(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2b58"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2b58"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kI8SP", function(module, exports) {

$parcel$export(module.exports, "register", () => $f13ecebb1f16f955$export$6503ec6e8aabbaf, (v) => $f13ecebb1f16f955$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $f13ecebb1f16f955$export$f7ad0328861e2f03, (v) => $f13ecebb1f16f955$export$f7ad0328861e2f03 = v);
var $f13ecebb1f16f955$export$6503ec6e8aabbaf;
var $f13ecebb1f16f955$export$f7ad0328861e2f03;
"use strict";
var $f13ecebb1f16f955$var$mapping = new Map();
function $f13ecebb1f16f955$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$f13ecebb1f16f955$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $f13ecebb1f16f955$var$resolve(id) {
    var resolved = $f13ecebb1f16f955$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$f13ecebb1f16f955$export$6503ec6e8aabbaf = $f13ecebb1f16f955$var$register;
$f13ecebb1f16f955$export$f7ad0328861e2f03 = $f13ecebb1f16f955$var$resolve;

});

parcelRegister("hIarR", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", () => $ce4ea6902f7a0721$export$bdfd709ae4826697, (v) => $ce4ea6902f7a0721$export$bdfd709ae4826697 = v);
var $ce4ea6902f7a0721$export$bdfd709ae4826697;
var $ce4ea6902f7a0721$export$c9e73fbda7da57b6;
var $ce4ea6902f7a0721$export$5a759dc7a1cfb72a;
"use strict";
var $ce4ea6902f7a0721$var$bundleURL = {};
function $ce4ea6902f7a0721$var$getBundleURLCached(id) {
    var value = $ce4ea6902f7a0721$var$bundleURL[id];
    if (!value) {
        value = $ce4ea6902f7a0721$var$getBundleURL();
        $ce4ea6902f7a0721$var$bundleURL[id] = value;
    }
    return value;
}
function $ce4ea6902f7a0721$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $ce4ea6902f7a0721$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $ce4ea6902f7a0721$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $ce4ea6902f7a0721$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$ce4ea6902f7a0721$export$bdfd709ae4826697 = $ce4ea6902f7a0721$var$getBundleURLCached;
$ce4ea6902f7a0721$export$c9e73fbda7da57b6 = $ce4ea6902f7a0721$var$getBaseURL;
$ce4ea6902f7a0721$export$5a759dc7a1cfb72a = $ce4ea6902f7a0721$var$getOrigin;

});

parcelRegister("lsosV", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $f9ef30dd7c82d3b1$export$ffb0004e005737fa, (v) => $f9ef30dd7c82d3b1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $f9ef30dd7c82d3b1$export$34b9dba7ce09269b, (v) => $f9ef30dd7c82d3b1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $f9ef30dd7c82d3b1$export$25062201e9e25d76, (v) => $f9ef30dd7c82d3b1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f9ef30dd7c82d3b1$export$ffb0004e005737fa;
var $f9ef30dd7c82d3b1$export$34b9dba7ce09269b;
var $f9ef30dd7c82d3b1$export$25062201e9e25d76;
"use strict";

(function() {
    "use strict";
    var React = (parcelRequire("8NFma"));
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var assign = Object.assign;
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown;
    var specialPropRefWarningShown;
    var didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function warnIfStringRefCannotBeAutoConverted(config, self) {
        if (typeof config.ref === "string" && ReactCurrentOwner.current && self && ReactCurrentOwner.current.stateNode !== self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', getComponentNameFromType(ReactCurrentOwner.current.type), config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * https://github.com/reactjs/rfcs/pull/107
 * @param {*} type
 * @param {object} props
 * @param {string} key
 */ function jsxDEV(type, config, maybeKey, source, self) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null; // Currently, key can be spread in as a prop. This causes a potential
        // issue if key is also explicitly declared (ie. <div {...props} key="Hi" />
        // or <div key="Hi" {...props} /> ). We want to deprecate key spread,
        // but as an intermediary step, we will use jsxDEV for everything except
        // <div {...props} key="Hi" />, because we aren't currently able to tell if
        // key is explicitly declared to be undefined or not.
        if (maybeKey !== undefined) {
            checkKeyStringCoercion(maybeKey);
            key = "" + maybeKey;
        }
        if (hasValidKey(config)) {
            checkKeyStringCoercion(config.key);
            key = "" + config.key;
        }
        if (hasValidRef(config)) {
            ref = config.ref;
            warnIfStringRefCannotBeAutoConverted(config, self);
        } // Remaining properties are added to a new props object
        for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
         // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner$1.current) {
            var name = getComponentNameFromType(ReactCurrentOwner$1.current.type);
            if (name) return "\n\nCheck the render method of `" + name + "`.";
        }
        return "";
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
        }
        return "";
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = "";
        if (element && element._owner && element._owner !== ReactCurrentOwner$1.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== "object") return;
        if (isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === "string") return;
        var propTypes;
        if (typeof type === "function") propTypes = type.propTypes;
        else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
        }
        if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "children" && key !== "key") {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
        }
    }
    var didWarnAboutKeySpread = {};
    function jsxWithValidation(type, props, key, isStaticChildren, source, self) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = "";
            if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendum(source);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = "null";
            else if (isArray(type)) typeString = "array";
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
                info = " Did you accidentally export a JSX literal instead of a component?";
            } else typeString = typeof type;
            error("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = jsxDEV(type, props, key, source, self); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) {
            var children = props.children;
            if (children !== undefined) {
                if (isStaticChildren) {
                    if (isArray(children)) {
                        for(var i = 0; i < children.length; i++)validateChildKeys(children[i], type);
                        if (Object.freeze) Object.freeze(children);
                    } else error("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
                } else validateChildKeys(children, type);
            }
        }
        if (hasOwnProperty.call(props, "key")) {
            var componentName = getComponentNameFromType(type);
            var keys = Object.keys(props).filter(function(k) {
                return k !== "key";
            });
            var beforeExample = keys.length > 0 ? "{key: someKey, " + keys.join(": ..., ") + ": ...}" : "{key: someKey}";
            if (!didWarnAboutKeySpread[componentName + beforeExample]) {
                var afterExample = keys.length > 0 ? "{" + keys.join(": ..., ") + ": ...}" : "{}";
                error('A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />', beforeExample, componentName, afterExample, componentName);
                didWarnAboutKeySpread[componentName + beforeExample] = true;
            }
        }
        if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    } // These two functions exist to still get child warnings in dev
    // even with the prod transform. This means that jsxDEV is purely
    // opt-in behavior for better messages but that we won't stop
    // giving you warnings if you use production apis.
    function jsxWithValidationStatic(type, props, key) {
        return jsxWithValidation(type, props, key, true);
    }
    function jsxWithValidationDynamic(type, props, key) {
        return jsxWithValidation(type, props, key, false);
    }
    var jsx = jsxWithValidationDynamic; // we may want to special case jsxs internally to take advantage of static children.
    // for now we can ship identical prod functions
    var jsxs = jsxWithValidationStatic;
    $f9ef30dd7c82d3b1$export$ffb0004e005737fa = REACT_FRAGMENT_TYPE;
    $f9ef30dd7c82d3b1$export$34b9dba7ce09269b = jsx;
    $f9ef30dd7c82d3b1$export$25062201e9e25d76 = jsxs;
})();

});
parcelRegister("8NFma", function(module, exports) {
"use strict";

module.exports = (parcelRequire("bripk"));

});
parcelRegister("bripk", function(module, exports) {
/**
 * @license React
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var ReactVersion = "18.3.1";
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    /**
 * Keeps track of the current dispatcher.
 */ var ReactCurrentDispatcher = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    /**
 * Keeps track of the current batch's configuration such as how long an update
 * should suspend for if it needs to.
 */ var ReactCurrentBatchConfig = {
        transition: null
    };
    var ReactCurrentActQueue = {
        current: null,
        // Used to reproduce behavior of `batchedUpdates` in legacy mode.
        isBatchingLegacy: false,
        didScheduleLegacyUpdate: false
    };
    /**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */ var ReactCurrentOwner = {
        /**
   * @internal
   * @type {ReactComponent}
   */ current: null
    };
    var ReactDebugCurrentFrame = {};
    var currentExtraStackFrame = null;
    function setExtraStackFrame(stack) {
        currentExtraStackFrame = stack;
    }
    ReactDebugCurrentFrame.setExtraStackFrame = function(stack) {
        currentExtraStackFrame = stack;
    }; // Stack implementation injected by the current renderer.
    ReactDebugCurrentFrame.getCurrentStack = null;
    ReactDebugCurrentFrame.getStackAddendum = function() {
        var stack = ""; // Add an extra top frame while an element is being validated
        if (currentExtraStackFrame) stack += currentExtraStackFrame;
         // Delegate to the injected renderer-specific implementation
        var impl = ReactDebugCurrentFrame.getCurrentStack;
        if (impl) stack += impl() || "";
        return stack;
    };
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var ReactSharedInternals = {
        ReactCurrentDispatcher: ReactCurrentDispatcher,
        ReactCurrentBatchConfig: ReactCurrentBatchConfig,
        ReactCurrentOwner: ReactCurrentOwner
    };
    ReactSharedInternals.ReactDebugCurrentFrame = ReactDebugCurrentFrame;
    ReactSharedInternals.ReactCurrentActQueue = ReactCurrentActQueue;
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        printWarning("warn", format, args);
    }
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var didWarnStateUpdateForUnmountedComponent = {};
    function warnNoop(publicInstance, callerName) {
        var _constructor = publicInstance.constructor;
        var componentName = _constructor && (_constructor.displayName || _constructor.name) || "ReactClass";
        var warningKey = componentName + "." + callerName;
        if (didWarnStateUpdateForUnmountedComponent[warningKey]) return;
        error("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", callerName, componentName);
        didWarnStateUpdateForUnmountedComponent[warningKey] = true;
    }
    /**
 * This is the abstract API for an update queue.
 */ var ReactNoopUpdateQueue = {
        /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */ isMounted: function(publicInstance) {
            return false;
        },
        /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueForceUpdate: function(publicInstance, callback, callerName) {
            warnNoop(publicInstance, "forceUpdate");
        },
        /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} callerName name of the calling function in the public API.
   * @internal
   */ enqueueReplaceState: function(publicInstance, completeState, callback, callerName) {
            warnNoop(publicInstance, "replaceState");
        },
        /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @param {?function} callback Called after component is updated.
   * @param {?string} Name of the calling function in the public API.
   * @internal
   */ enqueueSetState: function(publicInstance, partialState, callback, callerName) {
            warnNoop(publicInstance, "setState");
        }
    };
    var assign = Object.assign;
    var emptyObject = {};
    Object.freeze(emptyObject);
    /**
 * Base class helpers for the updating state of a component.
 */ function Component(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject; // We initialize the default updater but the real one gets injected by the
        // renderer.
        this.updater = updater || ReactNoopUpdateQueue;
    }
    Component.prototype.isReactComponent = {};
    /**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */ Component.prototype.setState = function(partialState, callback) {
        if (typeof partialState !== "object" && typeof partialState !== "function" && partialState != null) throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
        this.updater.enqueueSetState(this, partialState, callback, "setState");
    };
    /**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */ Component.prototype.forceUpdate = function(callback) {
        this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
    };
    var deprecatedAPIs = {
        isMounted: [
            "isMounted",
            "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."
        ],
        replaceState: [
            "replaceState",
            "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."
        ]
    };
    var defineDeprecationWarning = function(methodName, info) {
        Object.defineProperty(Component.prototype, methodName, {
            get: function() {
                warn("%s(...) is deprecated in plain JavaScript React classes. %s", info[0], info[1]);
                return undefined;
            }
        });
    };
    for(var fnName in deprecatedAPIs)if (deprecatedAPIs.hasOwnProperty(fnName)) defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    function ComponentDummy() {}
    ComponentDummy.prototype = Component.prototype;
    /**
 * Convenience component with default shallow equality check for sCU.
 */ function PureComponent(props, context, updater) {
        this.props = props;
        this.context = context; // If a component has string refs, we will assign a different object later.
        this.refs = emptyObject;
        this.updater = updater || ReactNoopUpdateQueue;
    }
    var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
    pureComponentPrototype.constructor = PureComponent; // Avoid an extra prototype jump for these methods.
    assign(pureComponentPrototype, Component.prototype);
    pureComponentPrototype.isPureReactComponent = true;
    // an immutable object with a single mutable value
    function createRef() {
        var refObject = {
            current: null
        };
        Object.seal(refObject);
        return refObject;
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var RESERVED_PROPS = {
        key: true,
        ref: true,
        __self: true,
        __source: true
    };
    var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;
    didWarnAboutStringRefs = {};
    function hasValidRef(config) {
        if (hasOwnProperty.call(config, "ref")) {
            var getter = Object.getOwnPropertyDescriptor(config, "ref").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.ref !== undefined;
    }
    function hasValidKey(config) {
        if (hasOwnProperty.call(config, "key")) {
            var getter = Object.getOwnPropertyDescriptor(config, "key").get;
            if (getter && getter.isReactWarning) return false;
        }
        return config.key !== undefined;
    }
    function defineKeyPropWarningGetter(props, displayName) {
        var warnAboutAccessingKey = function() {
            if (!specialPropKeyWarningShown) {
                specialPropKeyWarningShown = true;
                error("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingKey.isReactWarning = true;
        Object.defineProperty(props, "key", {
            get: warnAboutAccessingKey,
            configurable: true
        });
    }
    function defineRefPropWarningGetter(props, displayName) {
        var warnAboutAccessingRef = function() {
            if (!specialPropRefWarningShown) {
                specialPropRefWarningShown = true;
                error("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", displayName);
            }
        };
        warnAboutAccessingRef.isReactWarning = true;
        Object.defineProperty(props, "ref", {
            get: warnAboutAccessingRef,
            configurable: true
        });
    }
    function warnIfStringRefCannotBeAutoConverted(config) {
        if (typeof config.ref === "string" && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
            var componentName = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (!didWarnAboutStringRefs[componentName]) {
                error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', componentName, config.ref);
                didWarnAboutStringRefs[componentName] = true;
            }
        }
    }
    /**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, instanceof check
 * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} props
 * @param {*} key
 * @param {string|object} ref
 * @param {*} owner
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @internal
 */ var ReactElement = function(type, key, ref, self, source, owner, props) {
        var element = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: REACT_ELEMENT_TYPE,
            // Built-in properties that belong on the element
            type: type,
            key: key,
            ref: ref,
            props: props,
            // Record the component responsible for creating this element.
            _owner: owner
        };
        // The validation flag is currently mutative. We put it on
        // an external backing store so that we can freeze the whole object.
        // This can be replaced with a WeakMap once they are implemented in
        // commonly used development environments.
        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
        // the validation flag non-enumerable (where possible, which should
        // include every environment we run tests in), so the test framework
        // ignores it.
        Object.defineProperty(element._store, "validated", {
            configurable: false,
            enumerable: false,
            writable: true,
            value: false
        }); // self and source are DEV only properties.
        Object.defineProperty(element, "_self", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: self
        }); // Two elements created in two different places should be considered
        // equal for testing purposes and therefore we hide it from enumeration.
        Object.defineProperty(element, "_source", {
            configurable: false,
            enumerable: false,
            writable: false,
            value: source
        });
        if (Object.freeze) {
            Object.freeze(element.props);
            Object.freeze(element);
        }
        return element;
    };
    /**
 * Create and return a new ReactElement of the given type.
 * See https://reactjs.org/docs/react-api.html#createelement
 */ function createElement(type, config, children) {
        var propName; // Reserved names are extracted
        var props = {};
        var key = null;
        var ref = null;
        var self = null;
        var source = null;
        if (config != null) {
            if (hasValidRef(config)) {
                ref = config.ref;
                warnIfStringRefCannotBeAutoConverted(config);
            }
            if (hasValidKey(config)) {
                checkKeyStringCoercion(config.key);
                key = "" + config.key;
            }
            self = config.__self === undefined ? null : config.__self;
            source = config.__source === undefined ? null : config.__source; // Remaining properties are added to a new props object
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) props[propName] = config[propName];
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            if (Object.freeze) Object.freeze(childArray);
            props.children = childArray;
        } // Resolve default props
        if (type && type.defaultProps) {
            var defaultProps = type.defaultProps;
            for(propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
        }
        if (key || ref) {
            var displayName = typeof type === "function" ? type.displayName || type.name || "Unknown" : type;
            if (key) defineKeyPropWarningGetter(props, displayName);
            if (ref) defineRefPropWarningGetter(props, displayName);
        }
        return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
    }
    function cloneAndReplaceKey(oldElement, newKey) {
        var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
        return newElement;
    }
    /**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://reactjs.org/docs/react-api.html#cloneelement
 */ function cloneElement(element, config, children) {
        if (element === null || element === undefined) throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + element + ".");
        var propName; // Original props are copied
        var props = assign({}, element.props); // Reserved names are extracted
        var key = element.key;
        var ref = element.ref; // Self is preserved since the owner is preserved.
        var self = element._self; // Source is preserved since cloneElement is unlikely to be targeted by a
        // transpiler, and the original source is probably a better indicator of the
        // true owner.
        var source = element._source; // Owner will be preserved, unless ref is overridden
        var owner = element._owner;
        if (config != null) {
            if (hasValidRef(config)) {
                // Silently steal the ref from the parent.
                ref = config.ref;
                owner = ReactCurrentOwner.current;
            }
            if (hasValidKey(config)) {
                checkKeyStringCoercion(config.key);
                key = "" + config.key;
            } // Remaining properties override existing props
            var defaultProps;
            if (element.type && element.type.defaultProps) defaultProps = element.type.defaultProps;
            for(propName in config)if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
                if (config[propName] === undefined && defaultProps !== undefined) // Resolve default props
                props[propName] = defaultProps[propName];
                else props[propName] = config[propName];
            }
        } // Children can be more than one argument, and those are transferred onto
        // the newly allocated props object.
        var childrenLength = arguments.length - 2;
        if (childrenLength === 1) props.children = children;
        else if (childrenLength > 1) {
            var childArray = Array(childrenLength);
            for(var i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
            props.children = childArray;
        }
        return ReactElement(element.type, key, ref, self, source, owner, props);
    }
    /**
 * Verifies the object is a ReactElement.
 * See https://reactjs.org/docs/react-api.html#isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a ReactElement.
 * @final
 */ function isValidElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    var SEPARATOR = ".";
    var SUBSEPARATOR = ":";
    /**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */ function escape(key) {
        var escapeRegex = /[=:]/g;
        var escaperLookup = {
            "=": "=0",
            ":": "=2"
        };
        var escapedString = key.replace(escapeRegex, function(match) {
            return escaperLookup[match];
        });
        return "$" + escapedString;
    }
    /**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */ var didWarnAboutMaps = false;
    var userProvidedKeyEscapeRegex = /\/+/g;
    function escapeUserProvidedKey(text) {
        return text.replace(userProvidedKeyEscapeRegex, "$&/");
    }
    /**
 * Generate a key string that identifies a element within a set.
 *
 * @param {*} element A element that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */ function getElementKey(element, index) {
        // Do some typechecking here since we call this blindly. We want to ensure
        // that we don't block potential future ES APIs.
        if (typeof element === "object" && element !== null && element.key != null) {
            checkKeyStringCoercion(element.key);
            return escape("" + element.key);
        } // Implicit key determined by the index in the set
        return index.toString(36);
    }
    function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
        var type = typeof children;
        if (type === "undefined" || type === "boolean") // All of the above are perceived as null.
        children = null;
        var invokeCallback = false;
        if (children === null) invokeCallback = true;
        else switch(type){
            case "string":
            case "number":
                invokeCallback = true;
                break;
            case "object":
                switch(children.$$typeof){
                    case REACT_ELEMENT_TYPE:
                    case REACT_PORTAL_TYPE:
                        invokeCallback = true;
                }
        }
        if (invokeCallback) {
            var _child = children;
            var mappedChild = callback(_child); // If it's the only child, treat the name as if it was wrapped in an array
            // so that it's consistent if the number of children grows:
            var childKey = nameSoFar === "" ? SEPARATOR + getElementKey(_child, 0) : nameSoFar;
            if (isArray(mappedChild)) {
                var escapedChildKey = "";
                if (childKey != null) escapedChildKey = escapeUserProvidedKey(childKey) + "/";
                mapIntoArray(mappedChild, array, escapedChildKey, "", function(c) {
                    return c;
                });
            } else if (mappedChild != null) {
                if (isValidElement(mappedChild)) {
                    // The `if` statement here prevents auto-disabling of the safe
                    // coercion ESLint rule, so we must manually disable it below.
                    // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
                    if (mappedChild.key && (!_child || _child.key !== mappedChild.key)) checkKeyStringCoercion(mappedChild.key);
                    mappedChild = cloneAndReplaceKey(mappedChild, // traverseAllChildren used to do for objects as children
                    escapedPrefix + (mappedChild.key && (!_child || _child.key !== mappedChild.key) ? // eslint-disable-next-line react-internal/safe-string-coercion
                    escapeUserProvidedKey("" + mappedChild.key) + "/" : "") + childKey);
                }
                array.push(mappedChild);
            }
            return 1;
        }
        var child;
        var nextName;
        var subtreeCount = 0; // Count of children found in the current subtree.
        var nextNamePrefix = nameSoFar === "" ? SEPARATOR : nameSoFar + SUBSEPARATOR;
        if (isArray(children)) for(var i = 0; i < children.length; i++){
            child = children[i];
            nextName = nextNamePrefix + getElementKey(child, i);
            subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
        }
        else {
            var iteratorFn = getIteratorFn(children);
            if (typeof iteratorFn === "function") {
                var iterableChildren = children;
                // Warn about using Maps as children
                if (iteratorFn === iterableChildren.entries) {
                    if (!didWarnAboutMaps) warn("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                    didWarnAboutMaps = true;
                }
                var iterator = iteratorFn.call(iterableChildren);
                var step;
                var ii = 0;
                while(!(step = iterator.next()).done){
                    child = step.value;
                    nextName = nextNamePrefix + getElementKey(child, ii++);
                    subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
                }
            } else if (type === "object") {
                // eslint-disable-next-line react-internal/safe-string-coercion
                var childrenString = String(children);
                throw new Error("Objects are not valid as a React child (found: " + (childrenString === "[object Object]" ? "object with keys {" + Object.keys(children).join(", ") + "}" : childrenString) + "). " + "If you meant to render a collection of children, use an array " + "instead.");
            }
        }
        return subtreeCount;
    }
    /**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenmap
 *
 * The provided mapFunction(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */ function mapChildren(children, func, context) {
        if (children == null) return children;
        var result = [];
        var count = 0;
        mapIntoArray(children, result, "", "", function(child) {
            return func.call(context, child, count++);
        });
        return result;
    }
    /**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrencount
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */ function countChildren(children) {
        var n = 0;
        mapChildren(children, function() {
            n++; // Don't return anything
        });
        return n;
    }
    /**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenforeach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */ function forEachChildren(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments); // Don't return anything.
        }, forEachContext);
    }
    /**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrentoarray
 */ function toArray(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    }
    /**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://reactjs.org/docs/react-api.html#reactchildrenonly
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */ function onlyChild(children) {
        if (!isValidElement(children)) throw new Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
    function createContext(defaultValue) {
        // TODO: Second argument used to be an optional `calculateChangedBits`
        // function. Warn to reserve for future use?
        var context = {
            $$typeof: REACT_CONTEXT_TYPE,
            // As a workaround to support multiple concurrent renderers, we categorize
            // some renderers as primary and others as secondary. We only expect
            // there to be two concurrent renderers at most: React Native (primary) and
            // Fabric (secondary); React DOM (primary) and React ART (secondary).
            // Secondary renderers store their context values on separate fields.
            _currentValue: defaultValue,
            _currentValue2: defaultValue,
            // Used to track how many concurrent renderers this context currently
            // supports within in a single renderer. Such as parallel server rendering.
            _threadCount: 0,
            // These are circular
            Provider: null,
            Consumer: null,
            // Add these to use same hidden class in VM as ServerContext
            _defaultValue: null,
            _globalName: null
        };
        context.Provider = {
            $$typeof: REACT_PROVIDER_TYPE,
            _context: context
        };
        var hasWarnedAboutUsingNestedContextConsumers = false;
        var hasWarnedAboutUsingConsumerProvider = false;
        var hasWarnedAboutDisplayNameOnConsumer = false;
        // A separate object, but proxies back to the original context object for
        // backwards compatibility. It has a different $$typeof, so we can properly
        // warn for the incorrect usage of Context as a Consumer.
        var Consumer = {
            $$typeof: REACT_CONTEXT_TYPE,
            _context: context
        }; // $FlowFixMe: Flow complains about not setting a value, which is intentional here
        Object.defineProperties(Consumer, {
            Provider: {
                get: function() {
                    if (!hasWarnedAboutUsingConsumerProvider) {
                        hasWarnedAboutUsingConsumerProvider = true;
                        error("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?");
                    }
                    return context.Provider;
                },
                set: function(_Provider) {
                    context.Provider = _Provider;
                }
            },
            _currentValue: {
                get: function() {
                    return context._currentValue;
                },
                set: function(_currentValue) {
                    context._currentValue = _currentValue;
                }
            },
            _currentValue2: {
                get: function() {
                    return context._currentValue2;
                },
                set: function(_currentValue2) {
                    context._currentValue2 = _currentValue2;
                }
            },
            _threadCount: {
                get: function() {
                    return context._threadCount;
                },
                set: function(_threadCount) {
                    context._threadCount = _threadCount;
                }
            },
            Consumer: {
                get: function() {
                    if (!hasWarnedAboutUsingNestedContextConsumers) {
                        hasWarnedAboutUsingNestedContextConsumers = true;
                        error("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                    }
                    return context.Consumer;
                }
            },
            displayName: {
                get: function() {
                    return context.displayName;
                },
                set: function(displayName) {
                    if (!hasWarnedAboutDisplayNameOnConsumer) {
                        warn("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", displayName);
                        hasWarnedAboutDisplayNameOnConsumer = true;
                    }
                }
            }
        }); // $FlowFixMe: Flow complains about missing properties because it doesn't understand defineProperty
        context.Consumer = Consumer;
        context._currentRenderer = null;
        context._currentRenderer2 = null;
        return context;
    }
    var Uninitialized = -1;
    var Pending = 0;
    var Resolved = 1;
    var Rejected = 2;
    function lazyInitializer(payload) {
        if (payload._status === Uninitialized) {
            var ctor = payload._result;
            var thenable = ctor(); // Transition to the next state.
            // This might throw either because it's missing or throws. If so, we treat it
            // as still uninitialized and try again next time. Which is the same as what
            // happens if the ctor or any wrappers processing the ctor throws. This might
            // end up fixing it if the resolution was a concurrency bug.
            thenable.then(function(moduleObject) {
                if (payload._status === Pending || payload._status === Uninitialized) {
                    // Transition to the next state.
                    var resolved = payload;
                    resolved._status = Resolved;
                    resolved._result = moduleObject;
                }
            }, function(error) {
                if (payload._status === Pending || payload._status === Uninitialized) {
                    // Transition to the next state.
                    var rejected = payload;
                    rejected._status = Rejected;
                    rejected._result = error;
                }
            });
            if (payload._status === Uninitialized) {
                // In case, we're still uninitialized, then we're waiting for the thenable
                // to resolve. Set it as pending in the meantime.
                var pending = payload;
                pending._status = Pending;
                pending._result = thenable;
            }
        }
        if (payload._status === Resolved) {
            var moduleObject = payload._result;
            if (moduleObject === undefined) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))\n\nDid you accidentally put curly braces around the import?", moduleObject);
            if (!("default" in moduleObject)) error("lazy: Expected the result of a dynamic import() call. Instead received: %s\n\nYour code should look like: \n  const MyComponent = lazy(() => import('./MyComponent'))", moduleObject);
            return moduleObject.default;
        } else throw payload._result;
    }
    function lazy(ctor) {
        var payload = {
            // We use these fields to store the result.
            _status: Uninitialized,
            _result: ctor
        };
        var lazyType = {
            $$typeof: REACT_LAZY_TYPE,
            _payload: payload,
            _init: lazyInitializer
        };
        // In production, this would just set it on the object.
        var defaultProps;
        var propTypes; // $FlowFixMe
        Object.defineProperties(lazyType, {
            defaultProps: {
                configurable: true,
                get: function() {
                    return defaultProps;
                },
                set: function(newDefaultProps) {
                    error("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    defaultProps = newDefaultProps; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, "defaultProps", {
                        enumerable: true
                    });
                }
            },
            propTypes: {
                configurable: true,
                get: function() {
                    return propTypes;
                },
                set: function(newPropTypes) {
                    error("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it.");
                    propTypes = newPropTypes; // Match production behavior more closely:
                    // $FlowFixMe
                    Object.defineProperty(lazyType, "propTypes", {
                        enumerable: true
                    });
                }
            }
        });
        return lazyType;
    }
    function forwardRef(render) {
        if (render != null && render.$$typeof === REACT_MEMO_TYPE) error("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).");
        else if (typeof render !== "function") error("forwardRef requires a render function but was given %s.", render === null ? "null" : typeof render);
        else if (render.length !== 0 && render.length !== 2) error("forwardRef render functions accept exactly two parameters: props and ref. %s", render.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined.");
        if (render != null) {
            if (render.defaultProps != null || render.propTypes != null) error("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
        }
        var elementType = {
            $$typeof: REACT_FORWARD_REF_TYPE,
            render: render
        };
        var ownName;
        Object.defineProperty(elementType, "displayName", {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name; // The inner component shouldn't inherit this display name in most cases,
                // because the component may be used elsewhere.
                // But it's nice for anonymous functions to inherit the name,
                // so that our component-stack generation logic will display their frames.
                // An anonymous function generally suggests a pattern like:
                //   React.forwardRef((props, ref) => {...});
                // This kind of inner function is not used elsewhere so the side effect is okay.
                if (!render.name && !render.displayName) render.displayName = name;
            }
        });
        return elementType;
    }
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function memo(type, compare) {
        if (!isValidElementType(type)) error("memo: The first argument must be a component. Instead received: %s", type === null ? "null" : typeof type);
        var elementType = {
            $$typeof: REACT_MEMO_TYPE,
            type: type,
            compare: compare === undefined ? null : compare
        };
        var ownName;
        Object.defineProperty(elementType, "displayName", {
            enumerable: false,
            configurable: true,
            get: function() {
                return ownName;
            },
            set: function(name) {
                ownName = name; // The inner component shouldn't inherit this display name in most cases,
                // because the component may be used elsewhere.
                // But it's nice for anonymous functions to inherit the name,
                // so that our component-stack generation logic will display their frames.
                // An anonymous function generally suggests a pattern like:
                //   React.memo((props) => {...});
                // This kind of inner function is not used elsewhere so the side effect is okay.
                if (!type.name && !type.displayName) type.displayName = name;
            }
        });
        return elementType;
    }
    function resolveDispatcher() {
        var dispatcher = ReactCurrentDispatcher.current;
        if (dispatcher === null) error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
        // intentionally don't throw our own error because this is in a hot path.
        // Also helps ensure this is inlined.
        return dispatcher;
    }
    function useContext(Context) {
        var dispatcher = resolveDispatcher();
        // TODO: add a more generic warning for invalid values.
        if (Context._context !== undefined) {
            var realContext = Context._context; // Don't deduplicate because this legitimately causes bugs
            // and nobody should be using this in existing code.
            if (realContext.Consumer === Context) error("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?");
            else if (realContext.Provider === Context) error("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
        }
        return dispatcher.useContext(Context);
    }
    function useState(initialState) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useState(initialState);
    }
    function useReducer(reducer, initialArg, init) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useReducer(reducer, initialArg, init);
    }
    function useRef(initialValue) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useRef(initialValue);
    }
    function useEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useEffect(create, deps);
    }
    function useInsertionEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useInsertionEffect(create, deps);
    }
    function useLayoutEffect(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useLayoutEffect(create, deps);
    }
    function useCallback(callback, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useCallback(callback, deps);
    }
    function useMemo(create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useMemo(create, deps);
    }
    function useImperativeHandle(ref, create, deps) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useImperativeHandle(ref, create, deps);
    }
    function useDebugValue(value, formatterFn) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDebugValue(value, formatterFn);
    }
    function useTransition() {
        var dispatcher = resolveDispatcher();
        return dispatcher.useTransition();
    }
    function useDeferredValue(value) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useDeferredValue(value);
    }
    function useId() {
        var dispatcher = resolveDispatcher();
        return dispatcher.useId();
    }
    function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var dispatcher = resolveDispatcher();
        return dispatcher.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    }
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher$1.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher$1.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher$1.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    function setCurrentlyValidatingElement$1(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            setExtraStackFrame(stack);
        } else setExtraStackFrame(null);
    }
    var propTypesMisspellWarningShown;
    propTypesMisspellWarningShown = false;
    function getDeclarationErrorAddendum() {
        if (ReactCurrentOwner.current) {
            var name = getComponentNameFromType(ReactCurrentOwner.current.type);
            if (name) return "\n\nCheck the render method of `" + name + "`.";
        }
        return "";
    }
    function getSourceInfoErrorAddendum(source) {
        if (source !== undefined) {
            var fileName = source.fileName.replace(/^.*[\\\/]/, "");
            var lineNumber = source.lineNumber;
            return "\n\nCheck your code at " + fileName + ":" + lineNumber + ".";
        }
        return "";
    }
    function getSourceInfoErrorAddendumForProps(elementProps) {
        if (elementProps !== null && elementProps !== undefined) return getSourceInfoErrorAddendum(elementProps.__source);
        return "";
    }
    /**
 * Warn if there's no key explicitly set on dynamic arrays of children or
 * object keys are not valid. This allows us to keep track of children between
 * updates.
 */ var ownerHasKeyUseWarning = {};
    function getCurrentComponentErrorInfo(parentType) {
        var info = getDeclarationErrorAddendum();
        if (!info) {
            var parentName = typeof parentType === "string" ? parentType : parentType.displayName || parentType.name;
            if (parentName) info = "\n\nCheck the top-level render call using <" + parentName + ">.";
        }
        return info;
    }
    /**
 * Warn if the element doesn't have an explicit key assigned to it.
 * This element is in an array. The array could grow and shrink or be
 * reordered. All children that haven't already been validated are required to
 * have a "key" property assigned to it. Error statuses are cached so a warning
 * will only be shown once.
 *
 * @internal
 * @param {ReactElement} element Element that requires a key.
 * @param {*} parentType element's parent's type.
 */ function validateExplicitKey(element, parentType) {
        if (!element._store || element._store.validated || element.key != null) return;
        element._store.validated = true;
        var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
        if (ownerHasKeyUseWarning[currentComponentErrorInfo]) return;
        ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
        // property, it may be the creator of the child that's responsible for
        // assigning it a key.
        var childOwner = "";
        if (element && element._owner && element._owner !== ReactCurrentOwner.current) // Give the component that originally created this child.
        childOwner = " It was passed a child from " + getComponentNameFromType(element._owner.type) + ".";
        setCurrentlyValidatingElement$1(element);
        error('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
        setCurrentlyValidatingElement$1(null);
    }
    /**
 * Ensure that every element either is passed in a static location, in an
 * array with an explicit keys property defined, or in an object literal
 * with valid key property.
 *
 * @internal
 * @param {ReactNode} node Statically passed child of any type.
 * @param {*} parentType node's parent's type.
 */ function validateChildKeys(node, parentType) {
        if (typeof node !== "object") return;
        if (isArray(node)) for(var i = 0; i < node.length; i++){
            var child = node[i];
            if (isValidElement(child)) validateExplicitKey(child, parentType);
        }
        else if (isValidElement(node)) // This element was passed in a valid location.
        {
            if (node._store) node._store.validated = true;
        } else if (node) {
            var iteratorFn = getIteratorFn(node);
            if (typeof iteratorFn === "function") // Entry iterators used to provide implicit keys,
            // but now we print a separate warning for them later.
            {
                if (iteratorFn !== node.entries) {
                    var iterator = iteratorFn.call(node);
                    var step;
                    while(!(step = iterator.next()).done)if (isValidElement(step.value)) validateExplicitKey(step.value, parentType);
                }
            }
        }
    }
    /**
 * Given an element, validate that its props follow the propTypes definition,
 * provided by the type.
 *
 * @param {ReactElement} element
 */ function validatePropTypes(element) {
        var type = element.type;
        if (type === null || type === undefined || typeof type === "string") return;
        var propTypes;
        if (typeof type === "function") propTypes = type.propTypes;
        else if (typeof type === "object" && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        type.$$typeof === REACT_MEMO_TYPE)) propTypes = type.propTypes;
        else return;
        if (propTypes) {
            // Intentionally inside to avoid triggering lazy initializers:
            var name = getComponentNameFromType(type);
            checkPropTypes(propTypes, element.props, "prop", name, element);
        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
            propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
            var _name = getComponentNameFromType(type);
            error("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", _name || "Unknown");
        }
        if (typeof type.getDefaultProps === "function" && !type.getDefaultProps.isReactClassApproved) error("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
    }
    /**
 * Given a fragment, validate that it can only be provided with fragment props
 * @param {ReactElement} fragment
 */ function validateFragmentProps(fragment) {
        var keys = Object.keys(fragment.props);
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "children" && key !== "key") {
                setCurrentlyValidatingElement$1(fragment);
                error("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", key);
                setCurrentlyValidatingElement$1(null);
                break;
            }
        }
        if (fragment.ref !== null) {
            setCurrentlyValidatingElement$1(fragment);
            error("Invalid attribute `ref` supplied to `React.Fragment`.");
            setCurrentlyValidatingElement$1(null);
        }
    }
    function createElementWithValidation(type, props, children) {
        var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
        // succeed and there will likely be errors in render.
        if (!validType) {
            var info = "";
            if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            var sourceInfo = getSourceInfoErrorAddendumForProps(props);
            if (sourceInfo) info += sourceInfo;
            else info += getDeclarationErrorAddendum();
            var typeString;
            if (type === null) typeString = "null";
            else if (isArray(type)) typeString = "array";
            else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
                typeString = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />";
                info = " Did you accidentally export a JSX literal instead of a component?";
            } else typeString = typeof type;
            error("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", typeString, info);
        }
        var element = createElement.apply(this, arguments); // The result can be nullish if a mock or a custom function is used.
        // TODO: Drop this when these are no longer allowed as the type argument.
        if (element == null) return element;
         // Skip key warning if the type isn't valid since our key validation logic
        // doesn't expect a non-string/function type and can throw confusing errors.
        // We don't want exception behavior to differ between dev and prod.
        // (Rendering will throw with a helpful message and as soon as the type is
        // fixed, the key warnings will appear.)
        if (validType) for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], type);
        if (type === REACT_FRAGMENT_TYPE) validateFragmentProps(element);
        else validatePropTypes(element);
        return element;
    }
    var didWarnAboutDeprecatedCreateFactory = false;
    function createFactoryWithValidation(type) {
        var validatedFactory = createElementWithValidation.bind(null, type);
        validatedFactory.type = type;
        if (!didWarnAboutDeprecatedCreateFactory) {
            didWarnAboutDeprecatedCreateFactory = true;
            warn("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.");
        } // Legacy hook: remove it
        Object.defineProperty(validatedFactory, "type", {
            enumerable: false,
            get: function() {
                warn("Factory.type is deprecated. Access the class directly before passing it to createFactory.");
                Object.defineProperty(this, "type", {
                    value: type
                });
                return type;
            }
        });
        return validatedFactory;
    }
    function cloneElementWithValidation(element, props, children) {
        var newElement = cloneElement.apply(this, arguments);
        for(var i = 2; i < arguments.length; i++)validateChildKeys(arguments[i], newElement.type);
        validatePropTypes(newElement);
        return newElement;
    }
    function startTransition(scope, options) {
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = {};
        var currentTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition._updatedFibers = new Set();
        try {
            scope();
        } finally{
            ReactCurrentBatchConfig.transition = prevTransition;
            if (prevTransition === null && currentTransition._updatedFibers) {
                var updatedFibersCount = currentTransition._updatedFibers.size;
                if (updatedFibersCount > 10) warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.");
                currentTransition._updatedFibers.clear();
            }
        }
    }
    var didWarnAboutMessageChannel = false;
    var enqueueTaskImpl = null;
    function enqueueTask(task) {
        if (enqueueTaskImpl === null) try {
            // read require off the module object to get around the bundlers.
            // we don't want them to detect a require and bundle a Node polyfill.
            var requireString = ("require" + Math.random()).slice(0, 7);
            var nodeRequire = module && module[requireString]; // assuming we're in node, let's try to get node's
            // version of setImmediate, bypassing fake timers if any.
            enqueueTaskImpl = nodeRequire.call(module, "timers").setImmediate;
        } catch (_err) {
            // we're in a browser
            // we can't use regular timers because they may still be faked
            // so we try MessageChannel+postMessage instead
            enqueueTaskImpl = function(callback) {
                if (didWarnAboutMessageChannel === false) {
                    didWarnAboutMessageChannel = true;
                    if (typeof MessageChannel === "undefined") error("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning.");
                }
                var channel = new MessageChannel();
                channel.port1.onmessage = callback;
                channel.port2.postMessage(undefined);
            };
        }
        return enqueueTaskImpl(task);
    }
    var actScopeDepth = 0;
    var didWarnNoAwaitAct = false;
    function act(callback) {
        // `act` calls can be nested, so we track the depth. This represents the
        // number of `act` scopes on the stack.
        var prevActScopeDepth = actScopeDepth;
        actScopeDepth++;
        if (ReactCurrentActQueue.current === null) // This is the outermost `act` scope. Initialize the queue. The reconciler
        // will detect the queue and use it instead of Scheduler.
        ReactCurrentActQueue.current = [];
        var prevIsBatchingLegacy = ReactCurrentActQueue.isBatchingLegacy;
        var result;
        try {
            // Used to reproduce behavior of `batchedUpdates` in legacy mode. Only
            // set to `true` while the given callback is executed, not for updates
            // triggered during an async event, because this is how the legacy
            // implementation of `act` behaved.
            ReactCurrentActQueue.isBatchingLegacy = true;
            result = callback(); // Replicate behavior of original `act` implementation in legacy mode,
            // which flushed updates immediately after the scope function exits, even
            // if it's an async function.
            if (!prevIsBatchingLegacy && ReactCurrentActQueue.didScheduleLegacyUpdate) {
                var queue = ReactCurrentActQueue.current;
                if (queue !== null) {
                    ReactCurrentActQueue.didScheduleLegacyUpdate = false;
                    flushActQueue(queue);
                }
            }
        } catch (error) {
            popActScope(prevActScopeDepth);
            throw error;
        } finally{
            ReactCurrentActQueue.isBatchingLegacy = prevIsBatchingLegacy;
        }
        if (result !== null && typeof result === "object" && typeof result.then === "function") {
            var thenableResult = result; // The callback is an async function (i.e. returned a promise). Wait
            // for it to resolve before exiting the current scope.
            var wasAwaited = false;
            var thenable = {
                then: function(resolve, reject) {
                    wasAwaited = true;
                    thenableResult.then(function(returnValue) {
                        popActScope(prevActScopeDepth);
                        if (actScopeDepth === 0) // We've exited the outermost act scope. Recursively flush the
                        // queue until there's no remaining work.
                        recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                        else resolve(returnValue);
                    }, function(error) {
                        // The callback threw an error.
                        popActScope(prevActScopeDepth);
                        reject(error);
                    });
                }
            };
            if (!didWarnNoAwaitAct && typeof Promise !== "undefined") // eslint-disable-next-line no-undef
            Promise.resolve().then(function() {}).then(function() {
                if (!wasAwaited) {
                    didWarnNoAwaitAct = true;
                    error("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);");
                }
            });
            return thenable;
        } else {
            var returnValue = result; // The callback is not an async function. Exit the current scope
            // immediately, without awaiting.
            popActScope(prevActScopeDepth);
            if (actScopeDepth === 0) {
                // Exiting the outermost act scope. Flush the queue.
                var _queue = ReactCurrentActQueue.current;
                if (_queue !== null) {
                    flushActQueue(_queue);
                    ReactCurrentActQueue.current = null;
                } // Return a thenable. If the user awaits it, we'll flush again in
                // case additional work was scheduled by a microtask.
                var _thenable = {
                    then: function(resolve, reject) {
                        // Confirm we haven't re-entered another `act` scope, in case
                        // the user does something weird like await the thenable
                        // multiple times.
                        if (ReactCurrentActQueue.current === null) {
                            // Recursively flush the queue until there's no remaining work.
                            ReactCurrentActQueue.current = [];
                            recursivelyFlushAsyncActWork(returnValue, resolve, reject);
                        } else resolve(returnValue);
                    }
                };
                return _thenable;
            } else {
                // Since we're inside a nested `act` scope, the returned thenable
                // immediately resolves. The outer scope will flush the queue.
                var _thenable2 = {
                    then: function(resolve, reject) {
                        resolve(returnValue);
                    }
                };
                return _thenable2;
            }
        }
    }
    function popActScope(prevActScopeDepth) {
        if (prevActScopeDepth !== actScopeDepth - 1) error("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. ");
        actScopeDepth = prevActScopeDepth;
    }
    function recursivelyFlushAsyncActWork(returnValue, resolve, reject) {
        var queue = ReactCurrentActQueue.current;
        if (queue !== null) try {
            flushActQueue(queue);
            enqueueTask(function() {
                if (queue.length === 0) {
                    // No additional work was scheduled. Finish.
                    ReactCurrentActQueue.current = null;
                    resolve(returnValue);
                } else // Keep flushing work until there's none left.
                recursivelyFlushAsyncActWork(returnValue, resolve, reject);
            });
        } catch (error) {
            reject(error);
        }
        else resolve(returnValue);
    }
    var isFlushing = false;
    function flushActQueue(queue) {
        if (!isFlushing) {
            // Prevent re-entrance.
            isFlushing = true;
            var i = 0;
            try {
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do callback = callback(true);
                    while (callback !== null);
                }
                queue.length = 0;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                queue = queue.slice(i + 1);
                throw error;
            } finally{
                isFlushing = false;
            }
        }
    }
    var createElement$1 = createElementWithValidation;
    var cloneElement$1 = cloneElementWithValidation;
    var createFactory = createFactoryWithValidation;
    var Children = {
        map: mapChildren,
        forEach: forEachChildren,
        count: countChildren,
        toArray: toArray,
        only: onlyChild
    };
    exports.Children = Children;
    exports.Component = Component;
    exports.Fragment = REACT_FRAGMENT_TYPE;
    exports.Profiler = REACT_PROFILER_TYPE;
    exports.PureComponent = PureComponent;
    exports.StrictMode = REACT_STRICT_MODE_TYPE;
    exports.Suspense = REACT_SUSPENSE_TYPE;
    exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactSharedInternals;
    exports.act = act;
    exports.cloneElement = cloneElement$1;
    exports.createContext = createContext;
    exports.createElement = createElement$1;
    exports.createFactory = createFactory;
    exports.createRef = createRef;
    exports.forwardRef = forwardRef;
    exports.isValidElement = isValidElement;
    exports.lazy = lazy;
    exports.memo = memo;
    exports.startTransition = startTransition;
    exports.unstable_act = act;
    exports.useCallback = useCallback;
    exports.useContext = useContext;
    exports.useDebugValue = useDebugValue;
    exports.useDeferredValue = useDeferredValue;
    exports.useEffect = useEffect;
    exports.useId = useId;
    exports.useImperativeHandle = useImperativeHandle;
    exports.useInsertionEffect = useInsertionEffect;
    exports.useLayoutEffect = useLayoutEffect;
    exports.useMemo = useMemo;
    exports.useReducer = useReducer;
    exports.useRef = useRef;
    exports.useState = useState;
    exports.useSyncExternalStore = useSyncExternalStore;
    exports.useTransition = useTransition;
    exports.version = ReactVersion;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});



parcelRegister("2bY7F", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $198b3efa41da6254$export$ae55be85d98224ed, (v) => $198b3efa41da6254$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $198b3efa41da6254$export$d39a5bbd09211389, (v) => $198b3efa41da6254$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $198b3efa41da6254$export$882461b6382ed46c, (v) => $198b3efa41da6254$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $198b3efa41da6254$export$466bfc07425424d5, (v) => $198b3efa41da6254$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $198b3efa41da6254$export$cd75ccfd720a3cd4, (v) => $198b3efa41da6254$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $198b3efa41da6254$export$fa8d919ba61d84db, (v) => $198b3efa41da6254$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $198b3efa41da6254$export$757ceba2d55c277e, (v) => $198b3efa41da6254$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $198b3efa41da6254$export$b3890eb0ae9dca99, (v) => $198b3efa41da6254$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $198b3efa41da6254$export$502457920280e6be, (v) => $198b3efa41da6254$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $198b3efa41da6254$export$c78a37762a8d58e1, (v) => $198b3efa41da6254$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $198b3efa41da6254$export$dc54d992c10e8a18, (v) => $198b3efa41da6254$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $198b3efa41da6254$export$83d89fbfd8236492, (v) => $198b3efa41da6254$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $198b3efa41da6254$export$ae55be85d98224ed;
var $198b3efa41da6254$export$d39a5bbd09211389;
var $198b3efa41da6254$export$882461b6382ed46c;
var $198b3efa41da6254$export$466bfc07425424d5;
var $198b3efa41da6254$export$cd75ccfd720a3cd4;
var $198b3efa41da6254$export$fa8d919ba61d84db;
var $198b3efa41da6254$export$757ceba2d55c277e;
var $198b3efa41da6254$export$b3890eb0ae9dca99;
var $198b3efa41da6254$export$502457920280e6be;
var $198b3efa41da6254$export$c78a37762a8d58e1;
var $198b3efa41da6254$export$dc54d992c10e8a18;
var $198b3efa41da6254$export$83d89fbfd8236492;
"use strict";


(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var React = (parcelRequire("8NFma"));
    var Scheduler = (parcelRequire("clk2u"));
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    var suppressWarning = false;
    function setSuppressWarning(newSuppressWarning) {
        suppressWarning = newSuppressWarning;
    } // In DEV, calls to console.warn and console.error get replaced
    // by calls to these methods by a Babel plugin.
    //
    // In PROD (or in packages without access to React internals),
    // they are left as they are instead.
    function warn(format) {
        if (!suppressWarning) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            printWarning("warn", format, args);
        }
    }
    function error(format) {
        if (!suppressWarning) {
            for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
            printWarning("error", format, args);
        }
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    var FunctionComponent = 0;
    var ClassComponent = 1;
    var IndeterminateComponent = 2; // Before we know whether it is function or class
    var HostRoot = 3; // Root of a host tree. Could be nested inside another node.
    var HostPortal = 4; // A subtree. Could be an entry point to a different renderer.
    var HostComponent = 5;
    var HostText = 6;
    var Fragment = 7;
    var Mode = 8;
    var ContextConsumer = 9;
    var ContextProvider = 10;
    var ForwardRef = 11;
    var Profiler = 12;
    var SuspenseComponent = 13;
    var MemoComponent = 14;
    var SimpleMemoComponent = 15;
    var LazyComponent = 16;
    var IncompleteClassComponent = 17;
    var DehydratedFragment = 18;
    var SuspenseListComponent = 19;
    var ScopeComponent = 21;
    var OffscreenComponent = 22;
    var LegacyHiddenComponent = 23;
    var CacheComponent = 24;
    var TracingMarkerComponent = 25;
    // -----------------------------------------------------------------------------
    var enableClientRenderFallbackOnTextMismatch = true; // TODO: Need to review this code one more time before landing
    // the react-reconciler package.
    var enableNewReconciler = false; // Support legacy Primer support on internal FB www
    var enableLazyContextPropagation = false; // FB-only usage. The new API has different semantics.
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    var enableSuspenseAvoidThisFallback = false; // Enables unstable_avoidThisFallback feature in Fizz
    // React DOM Chopping Block
    //
    // Similar to main Chopping Block but only flags related to React DOM. These are
    // grouped because we will likely batch all of them into a single major release.
    // -----------------------------------------------------------------------------
    // Disable support for comment nodes as React DOM containers. Already disabled
    // in open source, but www codebase still relies on it. Need to remove.
    var disableCommentsAsDOMContainers = true; // Disable javascript: URL strings in href for XSS protection.
    // and client rendering, mostly to allow JSX attributes to apply to the custom
    // element's object properties instead of only HTML attributes.
    // https://github.com/facebook/react/issues/11347
    var enableCustomElementPropertySupport = false; // Disables children for <textarea> elements
    var warnAboutStringRefs = true; // -----------------------------------------------------------------------------
    // Debugging and DevTools
    // -----------------------------------------------------------------------------
    // Adds user timing marks for e.g. state updates, suspense, and work loop stuff,
    // for an experimental timeline tool.
    var enableSchedulingProfiler = true; // Helps identify side effects in render-phase lifecycle hooks and setState
    var enableProfilerTimer = true; // Record durations for commit and passive effects phases.
    var enableProfilerCommitHooks = true; // Phase param passed to onRender callback differentiates between an "update" and a "cascading-update".
    var allNativeEvents = new Set();
    /**
 * Mapping from registration name to event name
 */ var registrationNameDependencies = {};
    /**
 * Mapping from lowercase registration names to the properly cased version,
 * used to warn in the case of missing event handlers. Available
 * only in true.
 * @type {Object}
 */ var possibleRegistrationNames = {}; // Trust the developer to only use possibleRegistrationNames in true
    function registerTwoPhaseEvent(registrationName, dependencies) {
        registerDirectEvent(registrationName, dependencies);
        registerDirectEvent(registrationName + "Capture", dependencies);
    }
    function registerDirectEvent(registrationName, dependencies) {
        if (registrationNameDependencies[registrationName]) error("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", registrationName);
        registrationNameDependencies[registrationName] = dependencies;
        var lowerCasedName = registrationName.toLowerCase();
        possibleRegistrationNames[lowerCasedName] = registrationName;
        if (registrationName === "onDoubleClick") possibleRegistrationNames.ondblclick = registrationName;
        for(var i = 0; i < dependencies.length; i++)allNativeEvents.add(dependencies[i]);
    }
    var canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /*
 * The `'' + value` pattern (used in in perf-sensitive code) throws for Symbol
 * and Temporal.* types. See https://github.com/facebook/react/pull/22064.
 *
 * The functions in this module will throw an easier-to-understand,
 * easier-to-debug exception with a clear errors message message explaining the
 * problem. (Instead of a confusing exception thrown inside the implementation
 * of the `value` object).
 */ // $FlowFixMe only called in DEV, so void return is not possible.
    function typeName(value) {
        // toStringTag is needed for namespaced types like Temporal.Instant
        var hasToStringTag = typeof Symbol === "function" && Symbol.toStringTag;
        var type = hasToStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        return type;
    } // $FlowFixMe only called in DEV, so void return is not possible.
    function willCoercionThrow(value) {
        try {
            testStringCoercion(value);
            return false;
        } catch (e) {
            return true;
        }
    }
    function testStringCoercion(value) {
        // If you ended up here by following an exception call stack, here's what's
        // happened: you supplied an object or symbol value to React (as a prop, key,
        // DOM attribute, CSS property, string ref, etc.) and when React tried to
        // coerce it to a string using `'' + value`, an exception was thrown.
        //
        // The most common types that will cause this exception are `Symbol` instances
        // and Temporal objects like `Temporal.Instant`. But any object that has a
        // `valueOf` or `[Symbol.toPrimitive]` method that throws will also cause this
        // exception. (Library authors do this to prevent users from using built-in
        // numeric operators like `+` or comparison operators like `>=` because custom
        // methods are needed to perform accurate arithmetic or comparison.)
        //
        // To fix the problem, coerce this object or symbol value to a string before
        // passing it to React. The most reliable way is usually `String(value)`.
        //
        // To find which value is throwing, check the browser or debugger console.
        // Before this exception was thrown, there should be `console.error` output
        // that shows the type (Symbol, Temporal.PlainDate, etc.) that caused the
        // problem and how that type was used: key, atrribute, input value prop, etc.
        // In most cases, this console output also shows the component and its
        // ancestor components where the exception happened.
        //
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function checkAttributeStringCoercion(value, attributeName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", attributeName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkKeyStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkPropStringCoercion(value, propName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkCSSPropertyStringCoercion(value, propName) {
        if (willCoercionThrow(value)) {
            error("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", propName, typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkHtmlStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    function checkFormFieldValueStringCoercion(value) {
        if (willCoercionThrow(value)) {
            error("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", typeName(value));
            return testStringCoercion(value); // throw (to help callers find troubleshooting comments)
        }
    }
    // A reserved attribute.
    // It is handled by React separately and shouldn't be written to the DOM.
    var RESERVED = 0; // A simple string attribute.
    // Attributes that aren't in the filter are presumed to have this type.
    var STRING = 1; // A string attribute that accepts booleans in React. In HTML, these are called
    // "enumerated" attributes with "true" and "false" as possible values.
    // When true, it should be set to a "true" string.
    // When false, it should be set to a "false" string.
    var BOOLEANISH_STRING = 2; // A real boolean attribute.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    var BOOLEAN = 3; // An attribute that can be used as a flag as well as with a value.
    // When true, it should be present (set either to an empty string or its name).
    // When false, it should be omitted.
    // For any other value, should be present with that value.
    var OVERLOADED_BOOLEAN = 4; // An attribute that must be numeric or parse as a numeric.
    // When falsy, it should be removed.
    var NUMERIC = 5; // An attribute that must be positive numeric or parse as a positive numeric.
    // When falsy, it should be removed.
    var POSITIVE_NUMERIC = 6;
    /* eslint-disable max-len */ var ATTRIBUTE_NAME_START_CHAR = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD";
    /* eslint-enable max-len */ var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040";
    var VALID_ATTRIBUTE_NAME_REGEX = new RegExp("^[" + ATTRIBUTE_NAME_START_CHAR + "][" + ATTRIBUTE_NAME_CHAR + "]*$");
    var illegalAttributeNameCache = {};
    var validatedAttributeNameCache = {};
    function isAttributeNameSafe(attributeName) {
        if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return true;
        if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return false;
        if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
            validatedAttributeNameCache[attributeName] = true;
            return true;
        }
        illegalAttributeNameCache[attributeName] = true;
        error("Invalid attribute name: `%s`", attributeName);
        return false;
    }
    function shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null) return propertyInfo.type === RESERVED;
        if (isCustomComponentTag) return false;
        if (name.length > 2 && (name[0] === "o" || name[0] === "O") && (name[1] === "n" || name[1] === "N")) return true;
        return false;
    }
    function shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag) {
        if (propertyInfo !== null && propertyInfo.type === RESERVED) return false;
        switch(typeof value){
            case "function":
            case "symbol":
                // eslint-disable-line
                return true;
            case "boolean":
                if (isCustomComponentTag) return false;
                if (propertyInfo !== null) return !propertyInfo.acceptsBooleans;
                else {
                    var prefix = name.toLowerCase().slice(0, 5);
                    return prefix !== "data-" && prefix !== "aria-";
                }
            default:
                return false;
        }
    }
    function shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag) {
        if (value === null || typeof value === "undefined") return true;
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, isCustomComponentTag)) return true;
        if (isCustomComponentTag) return false;
        if (propertyInfo !== null) switch(propertyInfo.type){
            case BOOLEAN:
                return !value;
            case OVERLOADED_BOOLEAN:
                return value === false;
            case NUMERIC:
                return isNaN(value);
            case POSITIVE_NUMERIC:
                return isNaN(value) || value < 1;
        }
        return false;
    }
    function getPropertyInfo(name) {
        return properties.hasOwnProperty(name) ? properties[name] : null;
    }
    function PropertyInfoRecord(name, type, mustUseProperty, attributeName, attributeNamespace, sanitizeURL, removeEmptyString) {
        this.acceptsBooleans = type === BOOLEANISH_STRING || type === BOOLEAN || type === OVERLOADED_BOOLEAN;
        this.attributeName = attributeName;
        this.attributeNamespace = attributeNamespace;
        this.mustUseProperty = mustUseProperty;
        this.propertyName = name;
        this.type = type;
        this.sanitizeURL = sanitizeURL;
        this.removeEmptyString = removeEmptyString;
    } // When adding attributes to this list, be sure to also add them to
    // the `possibleStandardNames` module to ensure casing and incorrect
    // name warnings.
    var properties = {}; // These props are reserved by React. They shouldn't be written to the DOM.
    var reservedProps = [
        "children",
        "dangerouslySetInnerHTML",
        // elements (not just inputs). Now that ReactDOMInput assigns to the
        // defaultValue property -- do we need this?
        "defaultValue",
        "defaultChecked",
        "innerHTML",
        "suppressContentEditableWarning",
        "suppressHydrationWarning",
        "style"
    ];
    reservedProps.forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, RESERVED, false, name, null, false, false);
    }); // A few React string attributes have a different name.
    // This is a mapping from React prop names to the attribute names.
    [
        [
            "acceptCharset",
            "accept-charset"
        ],
        [
            "className",
            "class"
        ],
        [
            "htmlFor",
            "for"
        ],
        [
            "httpEquiv",
            "http-equiv"
        ]
    ].forEach(function(_ref) {
        var name = _ref[0], attributeName = _ref[1];
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // These are "enumerated" HTML attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    [
        "contentEditable",
        "draggable",
        "spellCheck",
        "value"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name.toLowerCase(), null, false, false);
    }); // These are "enumerated" SVG attributes that accept "true" and "false".
    // In React, we let users pass `true` and `false` even though technically
    // these aren't boolean attributes (they are coerced to strings).
    // Since these are SVG attributes, their attribute names are case-sensitive.
    [
        "autoReverse",
        "externalResourcesRequired",
        "focusable",
        "preserveAlpha"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEANISH_STRING, false, name, null, false, false);
    }); // These are HTML boolean attributes.
    [
        "allowFullScreen",
        "async",
        // on the client side because the browsers are inconsistent. Instead we call focus().
        "autoFocus",
        "autoPlay",
        "controls",
        "default",
        "defer",
        "disabled",
        "disablePictureInPicture",
        "disableRemotePlayback",
        "formNoValidate",
        "hidden",
        "loop",
        "noModule",
        "noValidate",
        "open",
        "playsInline",
        "readOnly",
        "required",
        "reversed",
        "scoped",
        "seamless",
        "itemScope"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, false, name.toLowerCase(), null, false, false);
    }); // These are the few React props that we set as DOM properties
    // rather than attributes. These are all booleans.
    [
        "checked",
        // disabled with `removeAttribute`. We have special logic for handling this.
        "multiple",
        "muted",
        "selected" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, BOOLEAN, true, name, null, false, false);
    }); // These are HTML attributes that are "overloaded booleans": they behave like
    // booleans, but can also accept a string value.
    [
        "capture",
        "download" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, OVERLOADED_BOOLEAN, false, name, null, false, false);
    }); // These are HTML attributes that must be positive numbers.
    [
        "cols",
        "rows",
        "size",
        "span" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, POSITIVE_NUMERIC, false, name, null, false, false);
    }); // These are HTML attributes that must be numbers.
    [
        "rowSpan",
        "start"
    ].forEach(function(name) {
        properties[name] = new PropertyInfoRecord(name, NUMERIC, false, name.toLowerCase(), null, false, false);
    });
    var CAMELIZE = /[\-\:]([a-z])/g;
    var capitalize = function(token) {
        return token[1].toUpperCase();
    }; // This is a list of all SVG attributes that need special casing, namespacing,
    // or boolean value assignment. Regular attributes that just accept strings
    // and have the same names are omitted, just like in the HTML attribute filter.
    // Some of these attributes can be hard to find. This list was created by
    // scraping the MDN documentation.
    [
        "accent-height",
        "alignment-baseline",
        "arabic-form",
        "baseline-shift",
        "cap-height",
        "clip-path",
        "clip-rule",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "dominant-baseline",
        "enable-background",
        "fill-opacity",
        "fill-rule",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "glyph-name",
        "glyph-orientation-horizontal",
        "glyph-orientation-vertical",
        "horiz-adv-x",
        "horiz-origin-x",
        "image-rendering",
        "letter-spacing",
        "lighting-color",
        "marker-end",
        "marker-mid",
        "marker-start",
        "overline-position",
        "overline-thickness",
        "paint-order",
        "panose-1",
        "pointer-events",
        "rendering-intent",
        "shape-rendering",
        "stop-color",
        "stop-opacity",
        "strikethrough-position",
        "strikethrough-thickness",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "text-anchor",
        "text-decoration",
        "text-rendering",
        "underline-position",
        "underline-thickness",
        "unicode-bidi",
        "unicode-range",
        "units-per-em",
        "v-alphabetic",
        "v-hanging",
        "v-ideographic",
        "v-mathematical",
        "vector-effect",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "word-spacing",
        "writing-mode",
        "xmlns:xlink",
        "x-height" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, null, false, false);
    }); // String SVG attributes with the xlink namespace.
    [
        "xlink:actuate",
        "xlink:arcrole",
        "xlink:role",
        "xlink:show",
        "xlink:title",
        "xlink:type" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/1999/xlink", false, false);
    }); // String SVG attributes with the xml namespace.
    [
        "xml:base",
        "xml:lang",
        "xml:space" // NOTE: if you add a camelCased prop to this list,
    ].forEach(function(attributeName) {
        var name = attributeName.replace(CAMELIZE, capitalize);
        properties[name] = new PropertyInfoRecord(name, STRING, false, attributeName, "http://www.w3.org/XML/1998/namespace", false, false);
    }); // These attribute exists both in HTML and SVG.
    // The attribute name is case-sensitive in SVG so we can't just use
    // the React name like we do for attributes that exist only in HTML.
    [
        "tabIndex",
        "crossOrigin"
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, false, false);
    }); // These attributes accept URLs. These must not allow javascript: URLS.
    // These will also need to accept Trusted Types object in the future.
    var xlinkHref = "xlinkHref";
    properties[xlinkHref] = new PropertyInfoRecord("xlinkHref", STRING, false, "xlink:href", "http://www.w3.org/1999/xlink", true, false);
    [
        "src",
        "href",
        "action",
        "formAction"
    ].forEach(function(attributeName) {
        properties[attributeName] = new PropertyInfoRecord(attributeName, STRING, false, attributeName.toLowerCase(), null, true, true);
    });
    // and any newline or tab are filtered out as if they're not part of the URL.
    // https://url.spec.whatwg.org/#url-parsing
    // Tab or newline are defined as \r\n\t:
    // https://infra.spec.whatwg.org/#ascii-tab-or-newline
    // A C0 control is a code point in the range \u0000 NULL to \u001F
    // INFORMATION SEPARATOR ONE, inclusive:
    // https://infra.spec.whatwg.org/#c0-control-or-space
    /* eslint-disable max-len */ var isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i;
    var didWarn = false;
    function sanitizeURL(url) {
        if (!didWarn && isJavaScriptProtocol.test(url)) {
            didWarn = true;
            error("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(url));
        }
    }
    /**
 * Get the value for a property on a node. Only used in DEV for SSR validation.
 * The "expected" argument is used as a hint of what the expected value is.
 * Some properties have multiple equivalent values.
 */ function getValueForProperty(node, name, expected, propertyInfo) {
        if (propertyInfo.mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            return node[propertyName];
        } else {
            checkAttributeStringCoercion(expected, name);
            if (propertyInfo.sanitizeURL) // If we haven't fully disabled javascript: URLs, and if
            // the hydration is successful of a javascript: URL, we
            // still want to warn on the client.
            // eslint-disable-next-line react-internal/safe-string-coercion
            sanitizeURL("" + expected);
            var attributeName = propertyInfo.attributeName;
            var stringValue = null;
            if (propertyInfo.type === OVERLOADED_BOOLEAN) {
                if (node.hasAttribute(attributeName)) {
                    var value = node.getAttribute(attributeName);
                    if (value === "") return true;
                    if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return value;
                     // eslint-disable-next-line react-internal/safe-string-coercion
                    if (value === "" + expected) return expected;
                    return value;
                }
            } else if (node.hasAttribute(attributeName)) {
                if (shouldRemoveAttribute(name, expected, propertyInfo, false)) // We had an attribute but shouldn't have had one, so read it
                // for the error message.
                return node.getAttribute(attributeName);
                if (propertyInfo.type === BOOLEAN) // If this was a boolean, it doesn't matter what the value is
                // the fact that we have it is the same as the expected.
                return expected;
                 // Even if this property uses a namespace we use getAttribute
                // because we assume its namespaced name is the same as our config.
                // To use getAttributeNS we need the local name which we don't have
                // in our config atm.
                stringValue = node.getAttribute(attributeName);
            }
            if (shouldRemoveAttribute(name, expected, propertyInfo, false)) return stringValue === null ? expected : stringValue; // eslint-disable-next-line react-internal/safe-string-coercion
            else if (stringValue === "" + expected) return expected;
            else return stringValue;
        }
    }
    /**
 * Get the value for a attribute on a node. Only used in DEV for SSR validation.
 * The third argument is used as a hint of what the expected value is. Some
 * attributes have multiple equivalent values.
 */ function getValueForAttribute(node, name, expected, isCustomComponentTag) {
        if (!isAttributeNameSafe(name)) return;
        if (!node.hasAttribute(name)) return expected === undefined ? undefined : null;
        var value = node.getAttribute(name);
        checkAttributeStringCoercion(expected, name);
        if (value === "" + expected) return expected;
        return value;
    }
    /**
 * Sets the value for a property on a node.
 *
 * @param {DOMElement} node
 * @param {string} name
 * @param {*} value
 */ function setValueForProperty(node, name, value, isCustomComponentTag) {
        var propertyInfo = getPropertyInfo(name);
        if (shouldIgnoreAttribute(name, propertyInfo, isCustomComponentTag)) return;
        if (shouldRemoveAttribute(name, value, propertyInfo, isCustomComponentTag)) value = null;
        if (isCustomComponentTag || propertyInfo === null) {
            if (isAttributeNameSafe(name)) {
                var _attributeName = name;
                if (value === null) node.removeAttribute(_attributeName);
                else {
                    checkAttributeStringCoercion(value, name);
                    node.setAttribute(_attributeName, "" + value);
                }
            }
            return;
        }
        var mustUseProperty = propertyInfo.mustUseProperty;
        if (mustUseProperty) {
            var propertyName = propertyInfo.propertyName;
            if (value === null) {
                var type = propertyInfo.type;
                node[propertyName] = type === BOOLEAN ? false : "";
            } else // Contrary to `setAttribute`, object properties are properly
            // `toString`ed by IE8/9.
            node[propertyName] = value;
            return;
        } // The rest are treated as attributes with special cases.
        var attributeName = propertyInfo.attributeName, attributeNamespace = propertyInfo.attributeNamespace;
        if (value === null) node.removeAttribute(attributeName);
        else {
            var _type = propertyInfo.type;
            var attributeValue;
            if (_type === BOOLEAN || _type === OVERLOADED_BOOLEAN && value === true) // If attribute type is boolean, we know for sure it won't be an execution sink
            // and we won't require Trusted Type here.
            attributeValue = "";
            else {
                checkAttributeStringCoercion(value, attributeName);
                attributeValue = "" + value;
                if (propertyInfo.sanitizeURL) sanitizeURL(attributeValue.toString());
            }
            if (attributeNamespace) node.setAttributeNS(attributeNamespace, attributeName, attributeValue);
            else node.setAttribute(attributeName, attributeValue);
        }
    }
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_SCOPE_TYPE = Symbol.for("react.scope");
    var REACT_DEBUG_TRACING_MODE_TYPE = Symbol.for("react.debug_trace_mode");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    var REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
    var REACT_CACHE_TYPE = Symbol.for("react.cache");
    var REACT_TRACING_MARKER_TYPE = Symbol.for("react.tracing_marker");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = "@@iterator";
    function getIteratorFn(maybeIterable) {
        if (maybeIterable === null || typeof maybeIterable !== "object") return null;
        var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
        if (typeof maybeIterator === "function") return maybeIterator;
        return null;
    }
    var assign = Object.assign;
    // Helpers to patch console.logs to avoid logging during side-effect free
    // replaying on render function. This currently only patches the object
    // lazily which won't cover if the log function was extracted eagerly.
    // We could also eagerly patch the method.
    var disabledDepth = 0;
    var prevLog;
    var prevInfo;
    var prevWarn;
    var prevError;
    var prevGroup;
    var prevGroupCollapsed;
    var prevGroupEnd;
    function disabledLog() {}
    disabledLog.__reactDisabledLog = true;
    function disableLogs() {
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ prevLog = console.log;
            prevInfo = console.info;
            prevWarn = console.warn;
            prevError = console.error;
            prevGroup = console.group;
            prevGroupCollapsed = console.groupCollapsed;
            prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
            var props = {
                configurable: true,
                enumerable: true,
                value: disabledLog,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                info: props,
                log: props,
                warn: props,
                error: props,
                group: props,
                groupCollapsed: props,
                groupEnd: props
            });
        /* eslint-enable react-internal/no-production-logging */ }
        disabledDepth++;
    }
    function reenableLogs() {
        disabledDepth--;
        if (disabledDepth === 0) {
            /* eslint-disable react-internal/no-production-logging */ var props = {
                configurable: true,
                enumerable: true,
                writable: true
            }; // $FlowFixMe Flow thinks console is immutable.
            Object.defineProperties(console, {
                log: assign({}, props, {
                    value: prevLog
                }),
                info: assign({}, props, {
                    value: prevInfo
                }),
                warn: assign({}, props, {
                    value: prevWarn
                }),
                error: assign({}, props, {
                    value: prevError
                }),
                group: assign({}, props, {
                    value: prevGroup
                }),
                groupCollapsed: assign({}, props, {
                    value: prevGroupCollapsed
                }),
                groupEnd: assign({}, props, {
                    value: prevGroupEnd
                })
            });
        /* eslint-enable react-internal/no-production-logging */ }
        if (disabledDepth < 0) error("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
    }
    var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
    var prefix;
    function describeBuiltInComponentFrame(name, source, ownerFn) {
        if (prefix === undefined) // Extract the VM specific prefix used by each line.
        try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
        }
         // We use the prefix to ensure our stacks line up with native stack frames.
        return "\n" + prefix + name;
    }
    var reentry = false;
    var componentFrameCache;
    var PossiblyWeakMap = typeof WeakMap === "function" ? WeakMap : Map;
    componentFrameCache = new PossiblyWeakMap();
    function describeNativeComponentFrame(fn, construct) {
        // If something asked for a stack inside a fake render, it should get ignored.
        if (!fn || reentry) return "";
        var frame = componentFrameCache.get(fn);
        if (frame !== undefined) return frame;
        var control;
        reentry = true;
        var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
        Error.prepareStackTrace = undefined;
        var previousDispatcher;
        previousDispatcher = ReactCurrentDispatcher.current; // Set the dispatcher in DEV because this might be call in the render function
        // for warnings.
        ReactCurrentDispatcher.current = null;
        disableLogs();
        try {
            // This should throw.
            if (construct) {
                // Something should be setting the props in the constructor.
                var Fake = function() {
                    throw Error();
                }; // $FlowFixMe
                Object.defineProperty(Fake.prototype, "props", {
                    set: function() {
                        // We use a throwing setter instead of frozen or non-writable props
                        // because that won't throw in a non-strict mode function.
                        throw Error();
                    }
                });
                if (typeof Reflect === "object" && Reflect.construct) {
                    // We construct a different control for this case to include any extra
                    // frames added by the construct call.
                    try {
                        Reflect.construct(Fake, []);
                    } catch (x) {
                        control = x;
                    }
                    Reflect.construct(fn, [], Fake);
                } else {
                    try {
                        Fake.call();
                    } catch (x) {
                        control = x;
                    }
                    fn.call(Fake.prototype);
                }
            } else {
                try {
                    throw Error();
                } catch (x) {
                    control = x;
                }
                fn();
            }
        } catch (sample) {
            // This is inlined manually because closure doesn't do it for us.
            if (sample && control && typeof sample.stack === "string") {
                // This extracts the first frame from the sample that isn't also in the control.
                // Skipping one frame that we assume is the frame that calls the two.
                var sampleLines = sample.stack.split("\n");
                var controlLines = control.stack.split("\n");
                var s = sampleLines.length - 1;
                var c = controlLines.length - 1;
                while(s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c])// We expect at least one stack frame to be shared.
                // Typically this will be the root most one. However, stack frames may be
                // cut off due to maximum stack limits. In this case, one maybe cut off
                // earlier than the other. We assume that the sample is longer or the same
                // and there for cut off earlier. So we should find the root most frame in
                // the sample somewhere in the control.
                c--;
                for(; s >= 1 && c >= 0; s--, c--)// Next we find the first one that isn't the same which should be the
                // frame that called our sample function and the control.
                if (sampleLines[s] !== controlLines[c]) {
                    // In V8, the first line is describing the message but other VMs don't.
                    // If we're about to return the first line, and the control is also on the same
                    // line, that's a pretty good indicator that our sample threw at same line as
                    // the control. I.e. before we entered the sample frame. So we ignore this result.
                    // This can happen if you passed a class to function component, or non-function.
                    if (s !== 1 || c !== 1) do {
                        s--;
                        c--; // We may still have similar intermediate frames from the construct call.
                        // The next one that isn't the same should be our match though.
                        if (c < 0 || sampleLines[s] !== controlLines[c]) {
                            // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
                            var _frame = "\n" + sampleLines[s].replace(" at new ", " at "); // If our component frame is labeled "<anonymous>"
                            // but we have a user-provided "displayName"
                            // splice it in to make the stack more readable.
                            if (fn.displayName && _frame.includes("<anonymous>")) _frame = _frame.replace("<anonymous>", fn.displayName);
                            if (typeof fn === "function") componentFrameCache.set(fn, _frame);
                            return _frame;
                        }
                    }while (s >= 1 && c >= 0);
                    break;
                }
            }
        } finally{
            reentry = false;
            ReactCurrentDispatcher.current = previousDispatcher;
            reenableLogs();
            Error.prepareStackTrace = previousPrepareStackTrace;
        } // Fallback to just using the name if we couldn't make it throw.
        var name = fn ? fn.displayName || fn.name : "";
        var syntheticFrame = name ? describeBuiltInComponentFrame(name) : "";
        if (typeof fn === "function") componentFrameCache.set(fn, syntheticFrame);
        return syntheticFrame;
    }
    function describeClassComponentFrame(ctor, source, ownerFn) {
        return describeNativeComponentFrame(ctor, true);
    }
    function describeFunctionComponentFrame(fn, source, ownerFn) {
        return describeNativeComponentFrame(fn, false);
    }
    function shouldConstruct(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
        if (type == null) return "";
        if (typeof type === "function") return describeNativeComponentFrame(type, shouldConstruct(type));
        if (typeof type === "string") return describeBuiltInComponentFrame(type);
        switch(type){
            case REACT_SUSPENSE_TYPE:
                return describeBuiltInComponentFrame("Suspense");
            case REACT_SUSPENSE_LIST_TYPE:
                return describeBuiltInComponentFrame("SuspenseList");
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_FORWARD_REF_TYPE:
                return describeFunctionComponentFrame(type.render);
            case REACT_MEMO_TYPE:
                // Memo may contain any component type so we recursively resolve it.
                return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    // Lazy may contain any component type so we recursively resolve it.
                    return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
                } catch (x) {}
        }
        return "";
    }
    function describeFiber(fiber) {
        var owner = fiber._debugOwner ? fiber._debugOwner.type : null;
        var source = fiber._debugSource;
        switch(fiber.tag){
            case HostComponent:
                return describeBuiltInComponentFrame(fiber.type);
            case LazyComponent:
                return describeBuiltInComponentFrame("Lazy");
            case SuspenseComponent:
                return describeBuiltInComponentFrame("Suspense");
            case SuspenseListComponent:
                return describeBuiltInComponentFrame("SuspenseList");
            case FunctionComponent:
            case IndeterminateComponent:
            case SimpleMemoComponent:
                return describeFunctionComponentFrame(fiber.type);
            case ForwardRef:
                return describeFunctionComponentFrame(fiber.type.render);
            case ClassComponent:
                return describeClassComponentFrame(fiber.type);
            default:
                return "";
        }
    }
    function getStackByFiberInDevAndProd(workInProgress) {
        try {
            var info = "";
            var node = workInProgress;
            do {
                info += describeFiber(node);
                node = node.return;
            }while (node);
            return info;
        } catch (x) {
            return "\nError generating stack: " + x.message + "\n" + x.stack;
        }
    }
    function getWrappedName(outerType, innerType, wrapperName) {
        var displayName = outerType.displayName;
        if (displayName) return displayName;
        var functionName = innerType.displayName || innerType.name || "";
        return functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName;
    } // Keep in sync with react-reconciler/getComponentNameFromFiber
    function getContextName(type) {
        return type.displayName || "Context";
    } // Note that the reconciler package should generally prefer to use getComponentNameFromFiber() instead.
    function getComponentNameFromType(type) {
        if (type == null) // Host root, text node or just invalid type.
        return null;
        if (typeof type.tag === "number") error("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue.");
        if (typeof type === "function") return type.displayName || type.name || null;
        if (typeof type === "string") return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if (typeof type === "object") switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                var context = type;
                return getContextName(context) + ".Consumer";
            case REACT_PROVIDER_TYPE:
                var provider = type;
                return getContextName(provider._context) + ".Provider";
            case REACT_FORWARD_REF_TYPE:
                return getWrappedName(type, type.render, "ForwardRef");
            case REACT_MEMO_TYPE:
                var outerName = type.displayName || null;
                if (outerName !== null) return outerName;
                return getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                var lazyComponent = type;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    return getComponentNameFromType(init(payload));
                } catch (x) {
                    return null;
                }
        }
        return null;
    }
    function getWrappedName$1(outerType, innerType, wrapperName) {
        var functionName = innerType.displayName || innerType.name || "";
        return outerType.displayName || (functionName !== "" ? wrapperName + "(" + functionName + ")" : wrapperName);
    } // Keep in sync with shared/getComponentNameFromType
    function getContextName$1(type) {
        return type.displayName || "Context";
    }
    function getComponentNameFromFiber(fiber) {
        var tag = fiber.tag, type = fiber.type;
        switch(tag){
            case CacheComponent:
                return "Cache";
            case ContextConsumer:
                var context = type;
                return getContextName$1(context) + ".Consumer";
            case ContextProvider:
                var provider = type;
                return getContextName$1(provider._context) + ".Provider";
            case DehydratedFragment:
                return "DehydratedFragment";
            case ForwardRef:
                return getWrappedName$1(type, type.render, "ForwardRef");
            case Fragment:
                return "Fragment";
            case HostComponent:
                // Host component type is the display name (e.g. "div", "View")
                return type;
            case HostPortal:
                return "Portal";
            case HostRoot:
                return "Root";
            case HostText:
                return "Text";
            case LazyComponent:
                // Name comes from the type in this case; we don't have a tag.
                return getComponentNameFromType(type);
            case Mode:
                if (type === REACT_STRICT_MODE_TYPE) // Don't be less specific than shared/getComponentNameFromType
                return "StrictMode";
                return "Mode";
            case OffscreenComponent:
                return "Offscreen";
            case Profiler:
                return "Profiler";
            case ScopeComponent:
                return "Scope";
            case SuspenseComponent:
                return "Suspense";
            case SuspenseListComponent:
                return "SuspenseList";
            case TracingMarkerComponent:
                return "TracingMarker";
            // The display name for this tags come from the user-provided type:
            case ClassComponent:
            case FunctionComponent:
            case IncompleteClassComponent:
            case IndeterminateComponent:
            case MemoComponent:
            case SimpleMemoComponent:
                if (typeof type === "function") return type.displayName || type.name || null;
                if (typeof type === "string") return type;
                break;
        }
        return null;
    }
    var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
    var current = null;
    var isRendering = false;
    function getCurrentFiberOwnerNameInDevOrNull() {
        if (current === null) return null;
        var owner = current._debugOwner;
        if (owner !== null && typeof owner !== "undefined") return getComponentNameFromFiber(owner);
        return null;
    }
    function getCurrentFiberStackInDev() {
        if (current === null) return "";
         // Safe because if current fiber exists, we are reconciling,
        // and it is guaranteed to be the work-in-progress version.
        return getStackByFiberInDevAndProd(current);
    }
    function resetCurrentFiber() {
        ReactDebugCurrentFrame.getCurrentStack = null;
        current = null;
        isRendering = false;
    }
    function setCurrentFiber(fiber) {
        ReactDebugCurrentFrame.getCurrentStack = fiber === null ? null : getCurrentFiberStackInDev;
        current = fiber;
        isRendering = false;
    }
    function getCurrentFiber() {
        return current;
    }
    function setIsRendering(rendering) {
        isRendering = rendering;
    }
    // Flow does not allow string concatenation of most non-string types. To work
    // around this limitation, we use an opaque type that can only be obtained by
    // passing the value through getToStringValue first.
    function toString(value) {
        // The coercion safety check is performed in getToStringValue().
        // eslint-disable-next-line react-internal/safe-string-coercion
        return "" + value;
    }
    function getToStringValue(value) {
        switch(typeof value){
            case "boolean":
            case "number":
            case "string":
            case "undefined":
                return value;
            case "object":
                checkFormFieldValueStringCoercion(value);
                return value;
            default:
                // function, symbol are assigned as empty strings
                return "";
        }
    }
    var hasReadOnlyValue = {
        button: true,
        checkbox: true,
        image: true,
        hidden: true,
        radio: true,
        reset: true,
        submit: true
    };
    function checkControlledValueProps(tagName, props) {
        if (!(hasReadOnlyValue[props.type] || props.onChange || props.onInput || props.readOnly || props.disabled || props.value == null)) error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.");
        if (!(props.onChange || props.readOnly || props.disabled || props.checked == null)) error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    function isCheckable(elem) {
        var type = elem.type;
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === "input" && (type === "checkbox" || type === "radio");
    }
    function getTracker(node) {
        return node._valueTracker;
    }
    function detachTracker(node) {
        node._valueTracker = null;
    }
    function getValueFromNode(node) {
        var value = "";
        if (!node) return value;
        if (isCheckable(node)) value = node.checked ? "true" : "false";
        else value = node.value;
        return value;
    }
    function trackValueOnNode(node) {
        var valueField = isCheckable(node) ? "checked" : "value";
        var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
        checkFormFieldValueStringCoercion(node[valueField]);
        var currentValue = "" + node[valueField]; // if someone has already defined a value or Safari, then bail
        // and don't track value will cause over reporting of changes,
        // but it's better then a hard failure
        // (needed for certain tests that spyOn input values and Safari)
        if (node.hasOwnProperty(valueField) || typeof descriptor === "undefined" || typeof descriptor.get !== "function" || typeof descriptor.set !== "function") return;
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: true,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                checkFormFieldValueStringCoercion(value);
                currentValue = "" + value;
                set.call(this, value);
            }
        }); // We could've passed this the first time
        // but it triggers a bug in IE11 and Edge 14/15.
        // Calling defineProperty() again should be equivalent.
        // https://github.com/facebook/react/issues/11768
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        var tracker = {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                checkFormFieldValueStringCoercion(value);
                currentValue = "" + value;
            },
            stopTracking: function() {
                detachTracker(node);
                delete node[valueField];
            }
        };
        return tracker;
    }
    function track(node) {
        if (getTracker(node)) return;
         // TODO: Once it's just Fiber we can move this to node._wrapperState
        node._valueTracker = trackValueOnNode(node);
    }
    function updateValueIfChanged(node) {
        if (!node) return false;
        var tracker = getTracker(node); // if there is no tracker at this point it's unlikely
        // that trying again will succeed
        if (!tracker) return true;
        var lastValue = tracker.getValue();
        var nextValue = getValueFromNode(node);
        if (nextValue !== lastValue) {
            tracker.setValue(nextValue);
            return true;
        }
        return false;
    }
    function getActiveElement(doc) {
        doc = doc || (typeof document !== "undefined" ? document : undefined);
        if (typeof doc === "undefined") return null;
        try {
            return doc.activeElement || doc.body;
        } catch (e) {
            return doc.body;
        }
    }
    var didWarnValueDefaultValue = false;
    var didWarnCheckedDefaultChecked = false;
    var didWarnControlledToUncontrolled = false;
    var didWarnUncontrolledToControlled = false;
    function isControlled(props) {
        var usesChecked = props.type === "checkbox" || props.type === "radio";
        return usesChecked ? props.checked != null : props.value != null;
    }
    /**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * See http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */ function getHostProps(element, props) {
        var node = element;
        var checked = props.checked;
        var hostProps = assign({}, props, {
            defaultChecked: undefined,
            defaultValue: undefined,
            value: undefined,
            checked: checked != null ? checked : node._wrapperState.initialChecked
        });
        return hostProps;
    }
    function initWrapperState(element, props) {
        checkControlledValueProps("input", props);
        if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
            error("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type);
            didWarnCheckedDefaultChecked = true;
        }
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
            error("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component", props.type);
            didWarnValueDefaultValue = true;
        }
        var node = element;
        var defaultValue = props.defaultValue == null ? "" : props.defaultValue;
        node._wrapperState = {
            initialChecked: props.checked != null ? props.checked : props.defaultChecked,
            initialValue: getToStringValue(props.value != null ? props.value : defaultValue),
            controlled: isControlled(props)
        };
    }
    function updateChecked(element, props) {
        var node = element;
        var checked = props.checked;
        if (checked != null) setValueForProperty(node, "checked", checked, false);
    }
    function updateWrapper(element, props) {
        var node = element;
        var controlled = isControlled(props);
        if (!node._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
            error("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnUncontrolledToControlled = true;
        }
        if (node._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
            error("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components");
            didWarnControlledToUncontrolled = true;
        }
        updateChecked(element, props);
        var value = getToStringValue(props.value);
        var type = props.type;
        if (value != null) {
            if (type === "number") {
                if (value === 0 && node.value === "" || // We explicitly want to coerce to number here if possible.
                // eslint-disable-next-line
                node.value != value) node.value = toString(value);
            } else if (node.value !== toString(value)) node.value = toString(value);
        } else if (type === "submit" || type === "reset") {
            // Submit/reset inputs need the attribute removed completely to avoid
            // blank-text buttons.
            node.removeAttribute("value");
            return;
        }
        // When syncing the value attribute, the value comes from a cascade of
        // properties:
        //  1. The value React property
        //  2. The defaultValue React property
        //  3. Otherwise there should be no change
        if (props.hasOwnProperty("value")) setDefaultValue(node, props.type, value);
        else if (props.hasOwnProperty("defaultValue")) setDefaultValue(node, props.type, getToStringValue(props.defaultValue));
        // When syncing the checked attribute, it only changes when it needs
        // to be removed, such as transitioning from a checkbox into a text input
        if (props.checked == null && props.defaultChecked != null) node.defaultChecked = !!props.defaultChecked;
    }
    function postMountWrapper(element, props, isHydrating) {
        var node = element; // Do not assign value if it is already set. This prevents user text input
        // from being lost during SSR hydration.
        if (props.hasOwnProperty("value") || props.hasOwnProperty("defaultValue")) {
            var type = props.type;
            var isButton = type === "submit" || type === "reset"; // Avoid setting value attribute on submit/reset inputs as it overrides the
            // default value provided by the browser. See: #12872
            if (isButton && (props.value === undefined || props.value === null)) return;
            var initialValue = toString(node._wrapperState.initialValue); // Do not assign value if it is already set. This prevents user text input
            // from being lost during SSR hydration.
            if (!isHydrating) // When syncing the value attribute, the value property should use
            // the wrapperState._initialValue property. This uses:
            //
            //   1. The value React property when present
            //   2. The defaultValue React property when present
            //   3. An empty string
            {
                if (initialValue !== node.value) node.value = initialValue;
            }
            // Otherwise, the value attribute is synchronized to the property,
            // so we assign defaultValue to the same thing as the value property
            // assignment step above.
            node.defaultValue = initialValue;
        } // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
        // this is needed to work around a chrome bug where setting defaultChecked
        // will sometimes influence the value of checked (even after detachment).
        // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
        // We need to temporarily unset name to avoid disrupting radio button groups.
        var name = node.name;
        if (name !== "") node.name = "";
        // When syncing the checked attribute, both the checked property and
        // attribute are assigned at the same time using defaultChecked. This uses:
        //
        //   1. The checked React property when present
        //   2. The defaultChecked React property when present
        //   3. Otherwise, false
        node.defaultChecked = !node.defaultChecked;
        node.defaultChecked = !!node._wrapperState.initialChecked;
        if (name !== "") node.name = name;
    }
    function restoreControlledState(element, props) {
        var node = element;
        updateWrapper(node, props);
        updateNamedCousins(node, props);
    }
    function updateNamedCousins(rootNode, props) {
        var name = props.name;
        if (props.type === "radio" && name != null) {
            var queryRoot = rootNode;
            while(queryRoot.parentNode)queryRoot = queryRoot.parentNode;
             // If `rootNode.form` was non-null, then we could try `form.elements`,
            checkAttributeStringCoercion(name, "name");
            var group = queryRoot.querySelectorAll("input[name=" + JSON.stringify("" + name) + '][type="radio"]');
            for(var i = 0; i < group.length; i++){
                var otherNode = group[i];
                if (otherNode === rootNode || otherNode.form !== rootNode.form) continue;
                 // This will throw if radio buttons rendered by different copies of React
                // and the same name are rendered into the same form (same as #1939).
                // That's probably okay; we don't support it just as we don't support
                // mixing React radio buttons with non-React ones.
                var otherProps = getFiberCurrentPropsFromNode(otherNode);
                if (!otherProps) throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
                 // We need update the tracked value on the named cousin since the value
                // was changed but the input saw no event or value set
                updateValueIfChanged(otherNode); // If this is a controlled radio button group, forcing the input that
                // was previously checked to update will cause it to be come re-checked
                // as appropriate.
                updateWrapper(otherNode, otherProps);
            }
        }
    } // In Chrome, assigning defaultValue to certain input types triggers input validation.
    // For number inputs, the display value loses trailing decimal points. For email inputs,
    // Chrome raises "The specified value <x> is not a valid email address".
    //
    // Here we check to see if the defaultValue has actually changed, avoiding these problems
    // when the user is inputting text
    //
    // https://github.com/facebook/react/issues/7253
    function setDefaultValue(node, type, value) {
        if (type !== "number" || getActiveElement(node.ownerDocument) !== node) {
            if (value == null) node.defaultValue = toString(node._wrapperState.initialValue);
            else if (node.defaultValue !== toString(value)) node.defaultValue = toString(value);
        }
    }
    var didWarnSelectedSetOnOption = false;
    var didWarnInvalidChild = false;
    var didWarnInvalidInnerHTML = false;
    /**
 * Implements an <option> host component that warns when `selected` is set.
 */ function validateProps(element, props) {
        // If a value is not provided, then the children must be simple.
        if (props.value == null) {
            if (typeof props.children === "object" && props.children !== null) React.Children.forEach(props.children, function(child) {
                if (child == null) return;
                if (typeof child === "string" || typeof child === "number") return;
                if (!didWarnInvalidChild) {
                    didWarnInvalidChild = true;
                    error("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.");
                }
            });
            else if (props.dangerouslySetInnerHTML != null) {
                if (!didWarnInvalidInnerHTML) {
                    didWarnInvalidInnerHTML = true;
                    error("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.");
                }
            }
        } // TODO: Remove support for `selected` in <option>.
        if (props.selected != null && !didWarnSelectedSetOnOption) {
            error("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>.");
            didWarnSelectedSetOnOption = true;
        }
    }
    function postMountWrapper$1(element, props) {
        // value="" should make a value attribute (#6219)
        if (props.value != null) element.setAttribute("value", toString(getToStringValue(props.value)));
    }
    var isArrayImpl = Array.isArray; // eslint-disable-next-line no-redeclare
    function isArray(a) {
        return isArrayImpl(a);
    }
    var didWarnValueDefaultValue$1;
    didWarnValueDefaultValue$1 = false;
    function getDeclarationErrorAddendum() {
        var ownerName = getCurrentFiberOwnerNameInDevOrNull();
        if (ownerName) return "\n\nCheck the render method of `" + ownerName + "`.";
        return "";
    }
    var valuePropNames = [
        "value",
        "defaultValue"
    ];
    /**
 * Validation function for `value` and `defaultValue`.
 */ function checkSelectPropTypes(props) {
        checkControlledValueProps("select", props);
        for(var i = 0; i < valuePropNames.length; i++){
            var propName = valuePropNames[i];
            if (props[propName] == null) continue;
            var propNameIsArray = isArray(props[propName]);
            if (props.multiple && !propNameIsArray) error("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", propName, getDeclarationErrorAddendum());
            else if (!props.multiple && propNameIsArray) error("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", propName, getDeclarationErrorAddendum());
        }
    }
    function updateOptions(node, multiple, propValue, setDefaultSelected) {
        var options = node.options;
        if (multiple) {
            var selectedValues = propValue;
            var selectedValue = {};
            for(var i = 0; i < selectedValues.length; i++)// Prefix to avoid chaos with special keys.
            selectedValue["$" + selectedValues[i]] = true;
            for(var _i = 0; _i < options.length; _i++){
                var selected = selectedValue.hasOwnProperty("$" + options[_i].value);
                if (options[_i].selected !== selected) options[_i].selected = selected;
                if (selected && setDefaultSelected) options[_i].defaultSelected = true;
            }
        } else {
            // Do not set `select.value` as exact behavior isn't consistent across all
            // browsers for all cases.
            var _selectedValue = toString(getToStringValue(propValue));
            var defaultSelected = null;
            for(var _i2 = 0; _i2 < options.length; _i2++){
                if (options[_i2].value === _selectedValue) {
                    options[_i2].selected = true;
                    if (setDefaultSelected) options[_i2].defaultSelected = true;
                    return;
                }
                if (defaultSelected === null && !options[_i2].disabled) defaultSelected = options[_i2];
            }
            if (defaultSelected !== null) defaultSelected.selected = true;
        }
    }
    /**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */ function getHostProps$1(element, props) {
        return assign({}, props, {
            value: undefined
        });
    }
    function initWrapperState$1(element, props) {
        var node = element;
        checkSelectPropTypes(props);
        node._wrapperState = {
            wasMultiple: !!props.multiple
        };
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue$1) {
            error("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components");
            didWarnValueDefaultValue$1 = true;
        }
    }
    function postMountWrapper$2(element, props) {
        var node = element;
        node.multiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
    }
    function postUpdateWrapper(element, props) {
        var node = element;
        var wasMultiple = node._wrapperState.wasMultiple;
        node._wrapperState.wasMultiple = !!props.multiple;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
        else if (wasMultiple !== !!props.multiple) {
            // For simplicity, reapply `defaultValue` if `multiple` is toggled.
            if (props.defaultValue != null) updateOptions(node, !!props.multiple, props.defaultValue, true);
            else // Revert the select back to its default unselected state.
            updateOptions(node, !!props.multiple, props.multiple ? [] : "", false);
        }
    }
    function restoreControlledState$1(element, props) {
        var node = element;
        var value = props.value;
        if (value != null) updateOptions(node, !!props.multiple, value, false);
    }
    var didWarnValDefaultVal = false;
    /**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */ function getHostProps$2(element, props) {
        var node = element;
        if (props.dangerouslySetInnerHTML != null) throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
         // Always set children to the same thing. In IE9, the selection range will
        // get reset if `textContent` is mutated.  We could add a check in setTextContent
        // to only set the value if/when the value differs from the node value (which would
        // completely solve this IE9 bug), but Sebastian+Sophie seemed to like this
        // solution. The value can be a boolean or object so that's why it's forced
        // to be a string.
        var hostProps = assign({}, props, {
            value: undefined,
            defaultValue: undefined,
            children: toString(node._wrapperState.initialValue)
        });
        return hostProps;
    }
    function initWrapperState$2(element, props) {
        var node = element;
        checkControlledValueProps("textarea", props);
        if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
            error("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", getCurrentFiberOwnerNameInDevOrNull() || "A component");
            didWarnValDefaultVal = true;
        }
        var initialValue = props.value; // Only bother fetching default value if we're going to use it
        if (initialValue == null) {
            var children = props.children, defaultValue = props.defaultValue;
            if (children != null) {
                error("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
                if (defaultValue != null) throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
                if (isArray(children)) {
                    if (children.length > 1) throw new Error("<textarea> can only have at most one child.");
                    children = children[0];
                }
                defaultValue = children;
            }
            if (defaultValue == null) defaultValue = "";
            initialValue = defaultValue;
        }
        node._wrapperState = {
            initialValue: getToStringValue(initialValue)
        };
    }
    function updateWrapper$1(element, props) {
        var node = element;
        var value = getToStringValue(props.value);
        var defaultValue = getToStringValue(props.defaultValue);
        if (value != null) {
            // Cast `value` to a string to ensure the value is set correctly. While
            // browsers typically do this as necessary, jsdom doesn't.
            var newValue = toString(value); // To avoid side effects (such as losing text selection), only set value if changed
            if (newValue !== node.value) node.value = newValue;
            if (props.defaultValue == null && node.defaultValue !== newValue) node.defaultValue = newValue;
        }
        if (defaultValue != null) node.defaultValue = toString(defaultValue);
    }
    function postMountWrapper$3(element, props) {
        var node = element; // This is in postMount because we need access to the DOM node, which is not
        // available until after the component has mounted.
        var textContent = node.textContent; // Only set node.value if textContent is equal to the expected
        // initial value. In IE10/IE11 there is a bug where the placeholder attribute
        // will populate textContent as well.
        // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
        if (textContent === node._wrapperState.initialValue) {
            if (textContent !== "" && textContent !== null) node.value = textContent;
        }
    }
    function restoreControlledState$2(element, props) {
        // DOM component is still mounted; update
        updateWrapper$1(element, props);
    }
    var HTML_NAMESPACE = "http://www.w3.org/1999/xhtml";
    var MATH_NAMESPACE = "http://www.w3.org/1998/Math/MathML";
    var SVG_NAMESPACE = "http://www.w3.org/2000/svg"; // Assumes there is no parent namespace.
    function getIntrinsicNamespace(type) {
        switch(type){
            case "svg":
                return SVG_NAMESPACE;
            case "math":
                return MATH_NAMESPACE;
            default:
                return HTML_NAMESPACE;
        }
    }
    function getChildNamespace(parentNamespace, type) {
        if (parentNamespace == null || parentNamespace === HTML_NAMESPACE) // No (or default) parent namespace: potential entry point.
        return getIntrinsicNamespace(type);
        if (parentNamespace === SVG_NAMESPACE && type === "foreignObject") // We're leaving SVG.
        return HTML_NAMESPACE;
         // By default, pass namespace below.
        return parentNamespace;
    }
    /* globals MSApp */ /**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */ var createMicrosoftUnsafeLocalFunction = function(func) {
        if (typeof MSApp !== "undefined" && MSApp.execUnsafeLocalFunction) return function(arg0, arg1, arg2, arg3) {
            MSApp.execUnsafeLocalFunction(function() {
                return func(arg0, arg1, arg2, arg3);
            });
        };
        else return func;
    };
    var reusableSVGContainer;
    /**
 * Set the innerHTML property of a node
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */ var setInnerHTML = createMicrosoftUnsafeLocalFunction(function(node, html) {
        if (node.namespaceURI === SVG_NAMESPACE) {
            if (!("innerHTML" in node)) {
                // IE does not have innerHTML for SVG nodes, so instead we inject the
                // new markup in a temp node and then move the child nodes across into
                // the target node
                reusableSVGContainer = reusableSVGContainer || document.createElement("div");
                reusableSVGContainer.innerHTML = "<svg>" + html.valueOf().toString() + "</svg>";
                var svgNode = reusableSVGContainer.firstChild;
                while(node.firstChild)node.removeChild(node.firstChild);
                while(svgNode.firstChild)node.appendChild(svgNode.firstChild);
                return;
            }
        }
        node.innerHTML = html;
    });
    /**
 * HTML nodeType values that represent the type of the node
 */ var ELEMENT_NODE = 1;
    var TEXT_NODE = 3;
    var COMMENT_NODE = 8;
    var DOCUMENT_NODE = 9;
    var DOCUMENT_FRAGMENT_NODE = 11;
    /**
 * Set the textContent property of a node. For text updates, it's faster
 * to set the `nodeValue` of the Text node directly instead of using
 * `.textContent` which will remove the existing node and create a new one.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */ var setTextContent = function(node, text) {
        if (text) {
            var firstChild = node.firstChild;
            if (firstChild && firstChild === node.lastChild && firstChild.nodeType === TEXT_NODE) {
                firstChild.nodeValue = text;
                return;
            }
        }
        node.textContent = text;
    };
    // List derived from Gecko source code:
    // https://github.com/mozilla/gecko-dev/blob/4e638efc71/layout/style/test/property_database.js
    var shorthandToLonghand = {
        animation: [
            "animationDelay",
            "animationDirection",
            "animationDuration",
            "animationFillMode",
            "animationIterationCount",
            "animationName",
            "animationPlayState",
            "animationTimingFunction"
        ],
        background: [
            "backgroundAttachment",
            "backgroundClip",
            "backgroundColor",
            "backgroundImage",
            "backgroundOrigin",
            "backgroundPositionX",
            "backgroundPositionY",
            "backgroundRepeat",
            "backgroundSize"
        ],
        backgroundPosition: [
            "backgroundPositionX",
            "backgroundPositionY"
        ],
        border: [
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth",
            "borderImageOutset",
            "borderImageRepeat",
            "borderImageSlice",
            "borderImageSource",
            "borderImageWidth",
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth",
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth",
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth"
        ],
        borderBlockEnd: [
            "borderBlockEndColor",
            "borderBlockEndStyle",
            "borderBlockEndWidth"
        ],
        borderBlockStart: [
            "borderBlockStartColor",
            "borderBlockStartStyle",
            "borderBlockStartWidth"
        ],
        borderBottom: [
            "borderBottomColor",
            "borderBottomStyle",
            "borderBottomWidth"
        ],
        borderColor: [
            "borderBottomColor",
            "borderLeftColor",
            "borderRightColor",
            "borderTopColor"
        ],
        borderImage: [
            "borderImageOutset",
            "borderImageRepeat",
            "borderImageSlice",
            "borderImageSource",
            "borderImageWidth"
        ],
        borderInlineEnd: [
            "borderInlineEndColor",
            "borderInlineEndStyle",
            "borderInlineEndWidth"
        ],
        borderInlineStart: [
            "borderInlineStartColor",
            "borderInlineStartStyle",
            "borderInlineStartWidth"
        ],
        borderLeft: [
            "borderLeftColor",
            "borderLeftStyle",
            "borderLeftWidth"
        ],
        borderRadius: [
            "borderBottomLeftRadius",
            "borderBottomRightRadius",
            "borderTopLeftRadius",
            "borderTopRightRadius"
        ],
        borderRight: [
            "borderRightColor",
            "borderRightStyle",
            "borderRightWidth"
        ],
        borderStyle: [
            "borderBottomStyle",
            "borderLeftStyle",
            "borderRightStyle",
            "borderTopStyle"
        ],
        borderTop: [
            "borderTopColor",
            "borderTopStyle",
            "borderTopWidth"
        ],
        borderWidth: [
            "borderBottomWidth",
            "borderLeftWidth",
            "borderRightWidth",
            "borderTopWidth"
        ],
        columnRule: [
            "columnRuleColor",
            "columnRuleStyle",
            "columnRuleWidth"
        ],
        columns: [
            "columnCount",
            "columnWidth"
        ],
        flex: [
            "flexBasis",
            "flexGrow",
            "flexShrink"
        ],
        flexFlow: [
            "flexDirection",
            "flexWrap"
        ],
        font: [
            "fontFamily",
            "fontFeatureSettings",
            "fontKerning",
            "fontLanguageOverride",
            "fontSize",
            "fontSizeAdjust",
            "fontStretch",
            "fontStyle",
            "fontVariant",
            "fontVariantAlternates",
            "fontVariantCaps",
            "fontVariantEastAsian",
            "fontVariantLigatures",
            "fontVariantNumeric",
            "fontVariantPosition",
            "fontWeight",
            "lineHeight"
        ],
        fontVariant: [
            "fontVariantAlternates",
            "fontVariantCaps",
            "fontVariantEastAsian",
            "fontVariantLigatures",
            "fontVariantNumeric",
            "fontVariantPosition"
        ],
        gap: [
            "columnGap",
            "rowGap"
        ],
        grid: [
            "gridAutoColumns",
            "gridAutoFlow",
            "gridAutoRows",
            "gridTemplateAreas",
            "gridTemplateColumns",
            "gridTemplateRows"
        ],
        gridArea: [
            "gridColumnEnd",
            "gridColumnStart",
            "gridRowEnd",
            "gridRowStart"
        ],
        gridColumn: [
            "gridColumnEnd",
            "gridColumnStart"
        ],
        gridColumnGap: [
            "columnGap"
        ],
        gridGap: [
            "columnGap",
            "rowGap"
        ],
        gridRow: [
            "gridRowEnd",
            "gridRowStart"
        ],
        gridRowGap: [
            "rowGap"
        ],
        gridTemplate: [
            "gridTemplateAreas",
            "gridTemplateColumns",
            "gridTemplateRows"
        ],
        listStyle: [
            "listStyleImage",
            "listStylePosition",
            "listStyleType"
        ],
        margin: [
            "marginBottom",
            "marginLeft",
            "marginRight",
            "marginTop"
        ],
        marker: [
            "markerEnd",
            "markerMid",
            "markerStart"
        ],
        mask: [
            "maskClip",
            "maskComposite",
            "maskImage",
            "maskMode",
            "maskOrigin",
            "maskPositionX",
            "maskPositionY",
            "maskRepeat",
            "maskSize"
        ],
        maskPosition: [
            "maskPositionX",
            "maskPositionY"
        ],
        outline: [
            "outlineColor",
            "outlineStyle",
            "outlineWidth"
        ],
        overflow: [
            "overflowX",
            "overflowY"
        ],
        padding: [
            "paddingBottom",
            "paddingLeft",
            "paddingRight",
            "paddingTop"
        ],
        placeContent: [
            "alignContent",
            "justifyContent"
        ],
        placeItems: [
            "alignItems",
            "justifyItems"
        ],
        placeSelf: [
            "alignSelf",
            "justifySelf"
        ],
        textDecoration: [
            "textDecorationColor",
            "textDecorationLine",
            "textDecorationStyle"
        ],
        textEmphasis: [
            "textEmphasisColor",
            "textEmphasisStyle"
        ],
        transition: [
            "transitionDelay",
            "transitionDuration",
            "transitionProperty",
            "transitionTimingFunction"
        ],
        wordWrap: [
            "overflowWrap"
        ]
    };
    /**
 * CSS properties which accept numbers but are not in units of "px".
 */ var isUnitlessNumber = {
        animationIterationCount: true,
        aspectRatio: true,
        borderImageOutset: true,
        borderImageSlice: true,
        borderImageWidth: true,
        boxFlex: true,
        boxFlexGroup: true,
        boxOrdinalGroup: true,
        columnCount: true,
        columns: true,
        flex: true,
        flexGrow: true,
        flexPositive: true,
        flexShrink: true,
        flexNegative: true,
        flexOrder: true,
        gridArea: true,
        gridRow: true,
        gridRowEnd: true,
        gridRowSpan: true,
        gridRowStart: true,
        gridColumn: true,
        gridColumnEnd: true,
        gridColumnSpan: true,
        gridColumnStart: true,
        fontWeight: true,
        lineClamp: true,
        lineHeight: true,
        opacity: true,
        order: true,
        orphans: true,
        tabSize: true,
        widows: true,
        zIndex: true,
        zoom: true,
        // SVG-related properties
        fillOpacity: true,
        floodOpacity: true,
        stopOpacity: true,
        strokeDasharray: true,
        strokeDashoffset: true,
        strokeMiterlimit: true,
        strokeOpacity: true,
        strokeWidth: true
    };
    /**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */ function prefixKey(prefix, key) {
        return prefix + key.charAt(0).toUpperCase() + key.substring(1);
    }
    /**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */ var prefixes = [
        "Webkit",
        "ms",
        "Moz",
        "O"
    ]; // Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
    // infinite loop, because it iterates over the newly added props too.
    Object.keys(isUnitlessNumber).forEach(function(prop) {
        prefixes.forEach(function(prefix) {
            isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
        });
    });
    /**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @return {string} Normalized style value with dimensions applied.
 */ function dangerousStyleValue(name, value, isCustomProperty) {
        // Note that we've removed escapeTextForBrowser() calls here since the
        // whole string will be escaped when the attribute is injected into
        // the markup. If you provide unsafe user data here they can inject
        // arbitrary CSS which may be problematic (I couldn't repro this):
        // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
        // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
        // This is not an XSS hole but instead a potential CSS injection issue
        // which has lead to a greater discussion about how we're going to
        // trust URLs moving forward. See #2115901
        var isEmpty = value == null || typeof value === "boolean" || value === "";
        if (isEmpty) return "";
        if (!isCustomProperty && typeof value === "number" && value !== 0 && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name])) return value + "px"; // Presumes implicit 'px' suffix for unitless numbers
        checkCSSPropertyStringCoercion(value, name);
        return ("" + value).trim();
    }
    var uppercasePattern = /([A-Z])/g;
    var msPattern = /^ms-/;
    /**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 */ function hyphenateStyleName(name) {
        return name.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern, "-ms-");
    }
    var warnValidStyle = function() {};
    // 'msTransform' is correct, but the other prefixes should be capitalized
    var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
    var msPattern$1 = /^-ms-/;
    var hyphenPattern = /-(.)/g; // style values shouldn't contain a semicolon
    var badStyleValueWithSemicolonPattern = /;\s*$/;
    var warnedStyleNames = {};
    var warnedStyleValues = {};
    var warnedForNaNValue = false;
    var warnedForInfinityValue = false;
    var camelize = function(string) {
        return string.replace(hyphenPattern, function(_, character) {
            return character.toUpperCase();
        });
    };
    var warnHyphenatedStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error("Unsupported style property %s. Did you mean %s?", name, // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
        // is converted to lowercase `ms`.
        camelize(name.replace(msPattern$1, "ms-")));
    };
    var warnBadVendoredStyleName = function(name) {
        if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) return;
        warnedStyleNames[name] = true;
        error("Unsupported vendor-prefixed style property %s. Did you mean %s?", name, name.charAt(0).toUpperCase() + name.slice(1));
    };
    var warnStyleValueWithSemicolon = function(name, value) {
        if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) return;
        warnedStyleValues[value] = true;
        error('Style property values shouldn\'t contain a semicolon. Try "%s: %s" instead.', name, value.replace(badStyleValueWithSemicolonPattern, ""));
    };
    var warnStyleValueIsNaN = function(name, value) {
        if (warnedForNaNValue) return;
        warnedForNaNValue = true;
        error("`NaN` is an invalid value for the `%s` css style property.", name);
    };
    var warnStyleValueIsInfinity = function(name, value) {
        if (warnedForInfinityValue) return;
        warnedForInfinityValue = true;
        error("`Infinity` is an invalid value for the `%s` css style property.", name);
    };
    warnValidStyle = function(name, value) {
        if (name.indexOf("-") > -1) warnHyphenatedStyleName(name);
        else if (badVendoredStyleNamePattern.test(name)) warnBadVendoredStyleName(name);
        else if (badStyleValueWithSemicolonPattern.test(value)) warnStyleValueWithSemicolon(name, value);
        if (typeof value === "number") {
            if (isNaN(value)) warnStyleValueIsNaN(name, value);
            else if (!isFinite(value)) warnStyleValueIsInfinity(name, value);
        }
    };
    var warnValidStyle$1 = warnValidStyle;
    /**
 * Operations for dealing with CSS properties.
 */ /**
 * This creates a string that is expected to be equivalent to the style
 * attribute generated by server-side rendering. It by-passes warnings and
 * security checks so it's not safe to use this value for anything other than
 * comparison. It is only used in DEV for SSR validation.
 */ function createDangerousStringForStyles(styles) {
        var serialized = "";
        var delimiter = "";
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var styleValue = styles[styleName];
            if (styleValue != null) {
                var isCustomProperty = styleName.indexOf("--") === 0;
                serialized += delimiter + (isCustomProperty ? styleName : hyphenateStyleName(styleName)) + ":";
                serialized += dangerousStyleValue(styleName, styleValue, isCustomProperty);
                delimiter = ";";
            }
        }
        return serialized || null;
    }
    /**
 * Sets the value for multiple styles on a node.  If a value is specified as
 * '' (empty string), the corresponding style property will be unset.
 *
 * @param {DOMElement} node
 * @param {object} styles
 */ function setValueForStyles(node, styles) {
        var style = node.style;
        for(var styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            var isCustomProperty = styleName.indexOf("--") === 0;
            if (!isCustomProperty) warnValidStyle$1(styleName, styles[styleName]);
            var styleValue = dangerousStyleValue(styleName, styles[styleName], isCustomProperty);
            if (styleName === "float") styleName = "cssFloat";
            if (isCustomProperty) style.setProperty(styleName, styleValue);
            else style[styleName] = styleValue;
        }
    }
    function isValueEmpty(value) {
        return value == null || typeof value === "boolean" || value === "";
    }
    /**
 * Given {color: 'red', overflow: 'hidden'} returns {
 *   color: 'color',
 *   overflowX: 'overflow',
 *   overflowY: 'overflow',
 * }. This can be read as "the overflowY property was set by the overflow
 * shorthand". That is, the values are the property that each was derived from.
 */ function expandShorthandMap(styles) {
        var expanded = {};
        for(var key in styles){
            var longhands = shorthandToLonghand[key] || [
                key
            ];
            for(var i = 0; i < longhands.length; i++)expanded[longhands[i]] = key;
        }
        return expanded;
    }
    /**
 * When mixing shorthand and longhand property names, we warn during updates if
 * we expect an incorrect result to occur. In particular, we warn for:
 *
 * Updating a shorthand property (longhand gets overwritten):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'baz', fontVariant: 'bar'}
 *   becomes .style.font = 'baz'
 * Removing a shorthand property (longhand gets lost too):
 *   {font: 'foo', fontVariant: 'bar'} -> {fontVariant: 'bar'}
 *   becomes .style.font = ''
 * Removing a longhand property (should revert to shorthand; doesn't):
 *   {font: 'foo', fontVariant: 'bar'} -> {font: 'foo'}
 *   becomes .style.fontVariant = ''
 */ function validateShorthandPropertyCollisionInDev(styleUpdates, nextStyles) {
        if (!nextStyles) return;
        var expandedUpdates = expandShorthandMap(styleUpdates);
        var expandedStyles = expandShorthandMap(nextStyles);
        var warnedAbout = {};
        for(var key in expandedUpdates){
            var originalKey = expandedUpdates[key];
            var correctOriginalKey = expandedStyles[key];
            if (correctOriginalKey && originalKey !== correctOriginalKey) {
                var warningKey = originalKey + "," + correctOriginalKey;
                if (warnedAbout[warningKey]) continue;
                warnedAbout[warningKey] = true;
                error("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", isValueEmpty(styleUpdates[originalKey]) ? "Removing" : "Updating", originalKey, correctOriginalKey);
            }
        }
    }
    // For HTML, certain tags should omit their close tag. We keep a list for
    // those special-case tags.
    var omittedCloseTags = {
        area: true,
        base: true,
        br: true,
        col: true,
        embed: true,
        hr: true,
        img: true,
        input: true,
        keygen: true,
        link: true,
        meta: true,
        param: true,
        source: true,
        track: true,
        wbr: true // NOTE: menuitem's close tag should be omitted, but that causes problems.
    };
    // `omittedCloseTags` except that `menuitem` should still have its closing tag.
    var voidElementTags = assign({
        menuitem: true
    }, omittedCloseTags);
    var HTML = "__html";
    function assertValidProps(tag, props) {
        if (!props) return;
         // Note the use of `==` which checks for null or undefined.
        if (voidElementTags[tag]) {
            if (props.children != null || props.dangerouslySetInnerHTML != null) throw new Error(tag + " is a void element tag and must neither have `children` nor " + "use `dangerouslySetInnerHTML`.");
        }
        if (props.dangerouslySetInnerHTML != null) {
            if (props.children != null) throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
            if (typeof props.dangerouslySetInnerHTML !== "object" || !(HTML in props.dangerouslySetInnerHTML)) throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!props.suppressContentEditableWarning && props.contentEditable && props.children != null) error("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional.");
        if (props.style != null && typeof props.style !== "object") throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
    }
    function isCustomComponent(tagName, props) {
        if (tagName.indexOf("-") === -1) return typeof props.is === "string";
        switch(tagName){
            // These are reserved SVG and MathML elements.
            // We don't mind this list too much because we expect it to never grow.
            // The alternative is to track the namespace in a few places which is convoluted.
            // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
                return false;
            default:
                return true;
        }
    }
    // When adding attributes to the HTML or SVG allowed attribute list, be sure to
    // also add them to this module to ensure casing and incorrect name
    // warnings.
    var possibleStandardNames = {
        // HTML
        accept: "accept",
        acceptcharset: "acceptCharset",
        "accept-charset": "acceptCharset",
        accesskey: "accessKey",
        action: "action",
        allowfullscreen: "allowFullScreen",
        alt: "alt",
        as: "as",
        async: "async",
        autocapitalize: "autoCapitalize",
        autocomplete: "autoComplete",
        autocorrect: "autoCorrect",
        autofocus: "autoFocus",
        autoplay: "autoPlay",
        autosave: "autoSave",
        capture: "capture",
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        challenge: "challenge",
        charset: "charSet",
        checked: "checked",
        children: "children",
        cite: "cite",
        class: "className",
        classid: "classID",
        classname: "className",
        cols: "cols",
        colspan: "colSpan",
        content: "content",
        contenteditable: "contentEditable",
        contextmenu: "contextMenu",
        controls: "controls",
        controlslist: "controlsList",
        coords: "coords",
        crossorigin: "crossOrigin",
        dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
        data: "data",
        datetime: "dateTime",
        default: "default",
        defaultchecked: "defaultChecked",
        defaultvalue: "defaultValue",
        defer: "defer",
        dir: "dir",
        disabled: "disabled",
        disablepictureinpicture: "disablePictureInPicture",
        disableremoteplayback: "disableRemotePlayback",
        download: "download",
        draggable: "draggable",
        enctype: "encType",
        enterkeyhint: "enterKeyHint",
        for: "htmlFor",
        form: "form",
        formmethod: "formMethod",
        formaction: "formAction",
        formenctype: "formEncType",
        formnovalidate: "formNoValidate",
        formtarget: "formTarget",
        frameborder: "frameBorder",
        headers: "headers",
        height: "height",
        hidden: "hidden",
        high: "high",
        href: "href",
        hreflang: "hrefLang",
        htmlfor: "htmlFor",
        httpequiv: "httpEquiv",
        "http-equiv": "httpEquiv",
        icon: "icon",
        id: "id",
        imagesizes: "imageSizes",
        imagesrcset: "imageSrcSet",
        innerhtml: "innerHTML",
        inputmode: "inputMode",
        integrity: "integrity",
        is: "is",
        itemid: "itemID",
        itemprop: "itemProp",
        itemref: "itemRef",
        itemscope: "itemScope",
        itemtype: "itemType",
        keyparams: "keyParams",
        keytype: "keyType",
        kind: "kind",
        label: "label",
        lang: "lang",
        list: "list",
        loop: "loop",
        low: "low",
        manifest: "manifest",
        marginwidth: "marginWidth",
        marginheight: "marginHeight",
        max: "max",
        maxlength: "maxLength",
        media: "media",
        mediagroup: "mediaGroup",
        method: "method",
        min: "min",
        minlength: "minLength",
        multiple: "multiple",
        muted: "muted",
        name: "name",
        nomodule: "noModule",
        nonce: "nonce",
        novalidate: "noValidate",
        open: "open",
        optimum: "optimum",
        pattern: "pattern",
        placeholder: "placeholder",
        playsinline: "playsInline",
        poster: "poster",
        preload: "preload",
        profile: "profile",
        radiogroup: "radioGroup",
        readonly: "readOnly",
        referrerpolicy: "referrerPolicy",
        rel: "rel",
        required: "required",
        reversed: "reversed",
        role: "role",
        rows: "rows",
        rowspan: "rowSpan",
        sandbox: "sandbox",
        scope: "scope",
        scoped: "scoped",
        scrolling: "scrolling",
        seamless: "seamless",
        selected: "selected",
        shape: "shape",
        size: "size",
        sizes: "sizes",
        span: "span",
        spellcheck: "spellCheck",
        src: "src",
        srcdoc: "srcDoc",
        srclang: "srcLang",
        srcset: "srcSet",
        start: "start",
        step: "step",
        style: "style",
        summary: "summary",
        tabindex: "tabIndex",
        target: "target",
        title: "title",
        type: "type",
        usemap: "useMap",
        value: "value",
        width: "width",
        wmode: "wmode",
        wrap: "wrap",
        // SVG
        about: "about",
        accentheight: "accentHeight",
        "accent-height": "accentHeight",
        accumulate: "accumulate",
        additive: "additive",
        alignmentbaseline: "alignmentBaseline",
        "alignment-baseline": "alignmentBaseline",
        allowreorder: "allowReorder",
        alphabetic: "alphabetic",
        amplitude: "amplitude",
        arabicform: "arabicForm",
        "arabic-form": "arabicForm",
        ascent: "ascent",
        attributename: "attributeName",
        attributetype: "attributeType",
        autoreverse: "autoReverse",
        azimuth: "azimuth",
        basefrequency: "baseFrequency",
        baselineshift: "baselineShift",
        "baseline-shift": "baselineShift",
        baseprofile: "baseProfile",
        bbox: "bbox",
        begin: "begin",
        bias: "bias",
        by: "by",
        calcmode: "calcMode",
        capheight: "capHeight",
        "cap-height": "capHeight",
        clip: "clip",
        clippath: "clipPath",
        "clip-path": "clipPath",
        clippathunits: "clipPathUnits",
        cliprule: "clipRule",
        "clip-rule": "clipRule",
        color: "color",
        colorinterpolation: "colorInterpolation",
        "color-interpolation": "colorInterpolation",
        colorinterpolationfilters: "colorInterpolationFilters",
        "color-interpolation-filters": "colorInterpolationFilters",
        colorprofile: "colorProfile",
        "color-profile": "colorProfile",
        colorrendering: "colorRendering",
        "color-rendering": "colorRendering",
        contentscripttype: "contentScriptType",
        contentstyletype: "contentStyleType",
        cursor: "cursor",
        cx: "cx",
        cy: "cy",
        d: "d",
        datatype: "datatype",
        decelerate: "decelerate",
        descent: "descent",
        diffuseconstant: "diffuseConstant",
        direction: "direction",
        display: "display",
        divisor: "divisor",
        dominantbaseline: "dominantBaseline",
        "dominant-baseline": "dominantBaseline",
        dur: "dur",
        dx: "dx",
        dy: "dy",
        edgemode: "edgeMode",
        elevation: "elevation",
        enablebackground: "enableBackground",
        "enable-background": "enableBackground",
        end: "end",
        exponent: "exponent",
        externalresourcesrequired: "externalResourcesRequired",
        fill: "fill",
        fillopacity: "fillOpacity",
        "fill-opacity": "fillOpacity",
        fillrule: "fillRule",
        "fill-rule": "fillRule",
        filter: "filter",
        filterres: "filterRes",
        filterunits: "filterUnits",
        floodopacity: "floodOpacity",
        "flood-opacity": "floodOpacity",
        floodcolor: "floodColor",
        "flood-color": "floodColor",
        focusable: "focusable",
        fontfamily: "fontFamily",
        "font-family": "fontFamily",
        fontsize: "fontSize",
        "font-size": "fontSize",
        fontsizeadjust: "fontSizeAdjust",
        "font-size-adjust": "fontSizeAdjust",
        fontstretch: "fontStretch",
        "font-stretch": "fontStretch",
        fontstyle: "fontStyle",
        "font-style": "fontStyle",
        fontvariant: "fontVariant",
        "font-variant": "fontVariant",
        fontweight: "fontWeight",
        "font-weight": "fontWeight",
        format: "format",
        from: "from",
        fx: "fx",
        fy: "fy",
        g1: "g1",
        g2: "g2",
        glyphname: "glyphName",
        "glyph-name": "glyphName",
        glyphorientationhorizontal: "glyphOrientationHorizontal",
        "glyph-orientation-horizontal": "glyphOrientationHorizontal",
        glyphorientationvertical: "glyphOrientationVertical",
        "glyph-orientation-vertical": "glyphOrientationVertical",
        glyphref: "glyphRef",
        gradienttransform: "gradientTransform",
        gradientunits: "gradientUnits",
        hanging: "hanging",
        horizadvx: "horizAdvX",
        "horiz-adv-x": "horizAdvX",
        horizoriginx: "horizOriginX",
        "horiz-origin-x": "horizOriginX",
        ideographic: "ideographic",
        imagerendering: "imageRendering",
        "image-rendering": "imageRendering",
        in2: "in2",
        in: "in",
        inlist: "inlist",
        intercept: "intercept",
        k1: "k1",
        k2: "k2",
        k3: "k3",
        k4: "k4",
        k: "k",
        kernelmatrix: "kernelMatrix",
        kernelunitlength: "kernelUnitLength",
        kerning: "kerning",
        keypoints: "keyPoints",
        keysplines: "keySplines",
        keytimes: "keyTimes",
        lengthadjust: "lengthAdjust",
        letterspacing: "letterSpacing",
        "letter-spacing": "letterSpacing",
        lightingcolor: "lightingColor",
        "lighting-color": "lightingColor",
        limitingconeangle: "limitingConeAngle",
        local: "local",
        markerend: "markerEnd",
        "marker-end": "markerEnd",
        markerheight: "markerHeight",
        markermid: "markerMid",
        "marker-mid": "markerMid",
        markerstart: "markerStart",
        "marker-start": "markerStart",
        markerunits: "markerUnits",
        markerwidth: "markerWidth",
        mask: "mask",
        maskcontentunits: "maskContentUnits",
        maskunits: "maskUnits",
        mathematical: "mathematical",
        mode: "mode",
        numoctaves: "numOctaves",
        offset: "offset",
        opacity: "opacity",
        operator: "operator",
        order: "order",
        orient: "orient",
        orientation: "orientation",
        origin: "origin",
        overflow: "overflow",
        overlineposition: "overlinePosition",
        "overline-position": "overlinePosition",
        overlinethickness: "overlineThickness",
        "overline-thickness": "overlineThickness",
        paintorder: "paintOrder",
        "paint-order": "paintOrder",
        panose1: "panose1",
        "panose-1": "panose1",
        pathlength: "pathLength",
        patterncontentunits: "patternContentUnits",
        patterntransform: "patternTransform",
        patternunits: "patternUnits",
        pointerevents: "pointerEvents",
        "pointer-events": "pointerEvents",
        points: "points",
        pointsatx: "pointsAtX",
        pointsaty: "pointsAtY",
        pointsatz: "pointsAtZ",
        prefix: "prefix",
        preservealpha: "preserveAlpha",
        preserveaspectratio: "preserveAspectRatio",
        primitiveunits: "primitiveUnits",
        property: "property",
        r: "r",
        radius: "radius",
        refx: "refX",
        refy: "refY",
        renderingintent: "renderingIntent",
        "rendering-intent": "renderingIntent",
        repeatcount: "repeatCount",
        repeatdur: "repeatDur",
        requiredextensions: "requiredExtensions",
        requiredfeatures: "requiredFeatures",
        resource: "resource",
        restart: "restart",
        result: "result",
        results: "results",
        rotate: "rotate",
        rx: "rx",
        ry: "ry",
        scale: "scale",
        security: "security",
        seed: "seed",
        shaperendering: "shapeRendering",
        "shape-rendering": "shapeRendering",
        slope: "slope",
        spacing: "spacing",
        specularconstant: "specularConstant",
        specularexponent: "specularExponent",
        speed: "speed",
        spreadmethod: "spreadMethod",
        startoffset: "startOffset",
        stddeviation: "stdDeviation",
        stemh: "stemh",
        stemv: "stemv",
        stitchtiles: "stitchTiles",
        stopcolor: "stopColor",
        "stop-color": "stopColor",
        stopopacity: "stopOpacity",
        "stop-opacity": "stopOpacity",
        strikethroughposition: "strikethroughPosition",
        "strikethrough-position": "strikethroughPosition",
        strikethroughthickness: "strikethroughThickness",
        "strikethrough-thickness": "strikethroughThickness",
        string: "string",
        stroke: "stroke",
        strokedasharray: "strokeDasharray",
        "stroke-dasharray": "strokeDasharray",
        strokedashoffset: "strokeDashoffset",
        "stroke-dashoffset": "strokeDashoffset",
        strokelinecap: "strokeLinecap",
        "stroke-linecap": "strokeLinecap",
        strokelinejoin: "strokeLinejoin",
        "stroke-linejoin": "strokeLinejoin",
        strokemiterlimit: "strokeMiterlimit",
        "stroke-miterlimit": "strokeMiterlimit",
        strokewidth: "strokeWidth",
        "stroke-width": "strokeWidth",
        strokeopacity: "strokeOpacity",
        "stroke-opacity": "strokeOpacity",
        suppresscontenteditablewarning: "suppressContentEditableWarning",
        suppresshydrationwarning: "suppressHydrationWarning",
        surfacescale: "surfaceScale",
        systemlanguage: "systemLanguage",
        tablevalues: "tableValues",
        targetx: "targetX",
        targety: "targetY",
        textanchor: "textAnchor",
        "text-anchor": "textAnchor",
        textdecoration: "textDecoration",
        "text-decoration": "textDecoration",
        textlength: "textLength",
        textrendering: "textRendering",
        "text-rendering": "textRendering",
        to: "to",
        transform: "transform",
        typeof: "typeof",
        u1: "u1",
        u2: "u2",
        underlineposition: "underlinePosition",
        "underline-position": "underlinePosition",
        underlinethickness: "underlineThickness",
        "underline-thickness": "underlineThickness",
        unicode: "unicode",
        unicodebidi: "unicodeBidi",
        "unicode-bidi": "unicodeBidi",
        unicoderange: "unicodeRange",
        "unicode-range": "unicodeRange",
        unitsperem: "unitsPerEm",
        "units-per-em": "unitsPerEm",
        unselectable: "unselectable",
        valphabetic: "vAlphabetic",
        "v-alphabetic": "vAlphabetic",
        values: "values",
        vectoreffect: "vectorEffect",
        "vector-effect": "vectorEffect",
        version: "version",
        vertadvy: "vertAdvY",
        "vert-adv-y": "vertAdvY",
        vertoriginx: "vertOriginX",
        "vert-origin-x": "vertOriginX",
        vertoriginy: "vertOriginY",
        "vert-origin-y": "vertOriginY",
        vhanging: "vHanging",
        "v-hanging": "vHanging",
        videographic: "vIdeographic",
        "v-ideographic": "vIdeographic",
        viewbox: "viewBox",
        viewtarget: "viewTarget",
        visibility: "visibility",
        vmathematical: "vMathematical",
        "v-mathematical": "vMathematical",
        vocab: "vocab",
        widths: "widths",
        wordspacing: "wordSpacing",
        "word-spacing": "wordSpacing",
        writingmode: "writingMode",
        "writing-mode": "writingMode",
        x1: "x1",
        x2: "x2",
        x: "x",
        xchannelselector: "xChannelSelector",
        xheight: "xHeight",
        "x-height": "xHeight",
        xlinkactuate: "xlinkActuate",
        "xlink:actuate": "xlinkActuate",
        xlinkarcrole: "xlinkArcrole",
        "xlink:arcrole": "xlinkArcrole",
        xlinkhref: "xlinkHref",
        "xlink:href": "xlinkHref",
        xlinkrole: "xlinkRole",
        "xlink:role": "xlinkRole",
        xlinkshow: "xlinkShow",
        "xlink:show": "xlinkShow",
        xlinktitle: "xlinkTitle",
        "xlink:title": "xlinkTitle",
        xlinktype: "xlinkType",
        "xlink:type": "xlinkType",
        xmlbase: "xmlBase",
        "xml:base": "xmlBase",
        xmllang: "xmlLang",
        "xml:lang": "xmlLang",
        xmlns: "xmlns",
        "xml:space": "xmlSpace",
        xmlnsxlink: "xmlnsXlink",
        "xmlns:xlink": "xmlnsXlink",
        xmlspace: "xmlSpace",
        y1: "y1",
        y2: "y2",
        y: "y",
        ychannelselector: "yChannelSelector",
        z: "z",
        zoomandpan: "zoomAndPan"
    };
    var ariaProperties = {
        "aria-current": 0,
        // state
        "aria-description": 0,
        "aria-details": 0,
        "aria-disabled": 0,
        // state
        "aria-hidden": 0,
        // state
        "aria-invalid": 0,
        // state
        "aria-keyshortcuts": 0,
        "aria-label": 0,
        "aria-roledescription": 0,
        // Widget Attributes
        "aria-autocomplete": 0,
        "aria-checked": 0,
        "aria-expanded": 0,
        "aria-haspopup": 0,
        "aria-level": 0,
        "aria-modal": 0,
        "aria-multiline": 0,
        "aria-multiselectable": 0,
        "aria-orientation": 0,
        "aria-placeholder": 0,
        "aria-pressed": 0,
        "aria-readonly": 0,
        "aria-required": 0,
        "aria-selected": 0,
        "aria-sort": 0,
        "aria-valuemax": 0,
        "aria-valuemin": 0,
        "aria-valuenow": 0,
        "aria-valuetext": 0,
        // Live Region Attributes
        "aria-atomic": 0,
        "aria-busy": 0,
        "aria-live": 0,
        "aria-relevant": 0,
        // Drag-and-Drop Attributes
        "aria-dropeffect": 0,
        "aria-grabbed": 0,
        // Relationship Attributes
        "aria-activedescendant": 0,
        "aria-colcount": 0,
        "aria-colindex": 0,
        "aria-colspan": 0,
        "aria-controls": 0,
        "aria-describedby": 0,
        "aria-errormessage": 0,
        "aria-flowto": 0,
        "aria-labelledby": 0,
        "aria-owns": 0,
        "aria-posinset": 0,
        "aria-rowcount": 0,
        "aria-rowindex": 0,
        "aria-rowspan": 0,
        "aria-setsize": 0
    };
    var warnedProperties = {};
    var rARIA = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
    var rARIACamel = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
    function validateProperty(tagName, name) {
        if (hasOwnProperty.call(warnedProperties, name) && warnedProperties[name]) return true;
        if (rARIACamel.test(name)) {
            var ariaName = "aria-" + name.slice(4).toLowerCase();
            var correctName = ariaProperties.hasOwnProperty(ariaName) ? ariaName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (correctName == null) {
                error("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", name);
                warnedProperties[name] = true;
                return true;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== correctName) {
                error("Invalid ARIA attribute `%s`. Did you mean `%s`?", name, correctName);
                warnedProperties[name] = true;
                return true;
            }
        }
        if (rARIA.test(name)) {
            var lowerCasedName = name.toLowerCase();
            var standardName = ariaProperties.hasOwnProperty(lowerCasedName) ? lowerCasedName : null; // If this is an aria-* attribute, but is not listed in the known DOM
            // DOM properties, then it is an invalid aria-* attribute.
            if (standardName == null) {
                warnedProperties[name] = true;
                return false;
            } // aria-* attributes should be lowercase; suggest the lowercase version.
            if (name !== standardName) {
                error("Unknown ARIA attribute `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties[name] = true;
                return true;
            }
        }
        return true;
    }
    function warnInvalidARIAProps(type, props) {
        var invalidProps = [];
        for(var key in props){
            var isValid = validateProperty(type, key);
            if (!isValid) invalidProps.push(key);
        }
        var unknownPropString = invalidProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        if (invalidProps.length === 1) error("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
        else if (invalidProps.length > 1) error("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", unknownPropString, type);
    }
    function validateProperties(type, props) {
        if (isCustomComponent(type, props)) return;
        warnInvalidARIAProps(type, props);
    }
    var didWarnValueNull = false;
    function validateProperties$1(type, props) {
        if (type !== "input" && type !== "textarea" && type !== "select") return;
        if (props != null && props.value === null && !didWarnValueNull) {
            didWarnValueNull = true;
            if (type === "select" && props.multiple) error("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", type);
            else error("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", type);
        }
    }
    var validateProperty$1 = function() {};
    var warnedProperties$1 = {};
    var EVENT_NAME_REGEX = /^on./;
    var INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/;
    var rARIA$1 = new RegExp("^(aria)-[" + ATTRIBUTE_NAME_CHAR + "]*$");
    var rARIACamel$1 = new RegExp("^(aria)[A-Z][" + ATTRIBUTE_NAME_CHAR + "]*$");
    validateProperty$1 = function(tagName, name, value, eventRegistry) {
        if (hasOwnProperty.call(warnedProperties$1, name) && warnedProperties$1[name]) return true;
        var lowerCasedName = name.toLowerCase();
        if (lowerCasedName === "onfocusin" || lowerCasedName === "onfocusout") {
            error("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React.");
            warnedProperties$1[name] = true;
            return true;
        } // We can't rely on the event system being injected on the server.
        if (eventRegistry != null) {
            var registrationNameDependencies = eventRegistry.registrationNameDependencies, possibleRegistrationNames = eventRegistry.possibleRegistrationNames;
            if (registrationNameDependencies.hasOwnProperty(name)) return true;
            var registrationName = possibleRegistrationNames.hasOwnProperty(lowerCasedName) ? possibleRegistrationNames[lowerCasedName] : null;
            if (registrationName != null) {
                error("Invalid event handler property `%s`. Did you mean `%s`?", name, registrationName);
                warnedProperties$1[name] = true;
                return true;
            }
            if (EVENT_NAME_REGEX.test(name)) {
                error("Unknown event handler property `%s`. It will be ignored.", name);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (EVENT_NAME_REGEX.test(name)) {
            // If no event plugins have been injected, we are in a server environment.
            // So we can't tell if the event name is correct for sure, but we can filter
            // out known bad ones like `onclick`. We can't suggest a specific replacement though.
            if (INVALID_EVENT_NAME_REGEX.test(name)) error("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", name);
            warnedProperties$1[name] = true;
            return true;
        } // Let the ARIA attribute hook validate ARIA attributes
        if (rARIA$1.test(name) || rARIACamel$1.test(name)) return true;
        if (lowerCasedName === "innerhtml") {
            error("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === "aria") {
            error("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead.");
            warnedProperties$1[name] = true;
            return true;
        }
        if (lowerCasedName === "is" && value !== null && value !== undefined && typeof value !== "string") {
            error("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof value);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === "number" && isNaN(value)) {
            error("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", name);
            warnedProperties$1[name] = true;
            return true;
        }
        var propertyInfo = getPropertyInfo(name);
        var isReserved = propertyInfo !== null && propertyInfo.type === RESERVED; // Known attributes should match the casing specified in the property config.
        if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
            var standardName = possibleStandardNames[lowerCasedName];
            if (standardName !== name) {
                error("Invalid DOM property `%s`. Did you mean `%s`?", name, standardName);
                warnedProperties$1[name] = true;
                return true;
            }
        } else if (!isReserved && name !== lowerCasedName) {
            // Unknown attributes should have lowercase casing since that's how they
            // will be cased anyway with server rendering.
            error("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", name, lowerCasedName);
            warnedProperties$1[name] = true;
            return true;
        }
        if (typeof value === "boolean" && shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            if (value) error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', value, name, name, value, name);
            else error('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', value, name, name, value, name, name, name);
            warnedProperties$1[name] = true;
            return true;
        } // Now that we've validated casing, do not validate
        // data types for reserved props
        if (isReserved) return true;
         // Warn when a known attribute is a bad type
        if (shouldRemoveAttributeWithWarning(name, value, propertyInfo, false)) {
            warnedProperties$1[name] = true;
            return false;
        } // Warn when passing the strings 'false' or 'true' into a boolean prop
        if ((value === "false" || value === "true") && propertyInfo !== null && propertyInfo.type === BOOLEAN) {
            error("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", value, name, value === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', name, value);
            warnedProperties$1[name] = true;
            return true;
        }
        return true;
    };
    var warnUnknownProperties = function(type, props, eventRegistry) {
        var unknownProps = [];
        for(var key in props){
            var isValid = validateProperty$1(type, key, props[key], eventRegistry);
            if (!isValid) unknownProps.push(key);
        }
        var unknownPropString = unknownProps.map(function(prop) {
            return "`" + prop + "`";
        }).join(", ");
        if (unknownProps.length === 1) error("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
        else if (unknownProps.length > 1) error("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", unknownPropString, type);
    };
    function validateProperties$2(type, props, eventRegistry) {
        if (isCustomComponent(type, props)) return;
        warnUnknownProperties(type, props, eventRegistry);
    }
    var IS_EVENT_HANDLE_NON_MANAGED_NODE = 1;
    var IS_NON_DELEGATED = 2;
    var IS_CAPTURE_PHASE = 4;
    // set to LEGACY_FB_SUPPORT. LEGACY_FB_SUPPORT only gets set when
    // we call willDeferLaterForLegacyFBSupport, thus not bailing out
    // will result in endless cycles like an infinite loop.
    // We also don't want to defer during event replaying.
    var SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS = IS_EVENT_HANDLE_NON_MANAGED_NODE | IS_NON_DELEGATED | IS_CAPTURE_PHASE;
    // This exists to avoid circular dependency between ReactDOMEventReplaying
    // and DOMPluginEventSystem.
    var currentReplayingEvent = null;
    function setReplayingEvent(event) {
        if (currentReplayingEvent !== null) error("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue.");
        currentReplayingEvent = event;
    }
    function resetReplayingEvent() {
        if (currentReplayingEvent === null) error("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue.");
        currentReplayingEvent = null;
    }
    function isReplayingEvent(event) {
        return event === currentReplayingEvent;
    }
    /**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */ function getEventTarget(nativeEvent) {
        // Fallback to nativeEvent.srcElement for IE9
        // https://github.com/facebook/react/issues/12506
        var target = nativeEvent.target || nativeEvent.srcElement || window; // Normalize SVG <use> element events #4963
        if (target.correspondingUseElement) target = target.correspondingUseElement;
         // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
        // @see http://www.quirksmode.org/js/events_properties.html
        return target.nodeType === TEXT_NODE ? target.parentNode : target;
    }
    var restoreImpl = null;
    var restoreTarget = null;
    var restoreQueue = null;
    function restoreStateOfTarget(target) {
        // We perform this translation at the end of the event loop so that we
        // always receive the correct fiber here
        var internalInstance = getInstanceFromNode(target);
        if (!internalInstance) // Unmounted
        return;
        if (typeof restoreImpl !== "function") throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
        var stateNode = internalInstance.stateNode; // Guard against Fiber being unmounted.
        if (stateNode) {
            var _props = getFiberCurrentPropsFromNode(stateNode);
            restoreImpl(internalInstance.stateNode, internalInstance.type, _props);
        }
    }
    function setRestoreImplementation(impl) {
        restoreImpl = impl;
    }
    function enqueueStateRestore(target) {
        if (restoreTarget) {
            if (restoreQueue) restoreQueue.push(target);
            else restoreQueue = [
                target
            ];
        } else restoreTarget = target;
    }
    function needsStateRestore() {
        return restoreTarget !== null || restoreQueue !== null;
    }
    function restoreStateIfNeeded() {
        if (!restoreTarget) return;
        var target = restoreTarget;
        var queuedTargets = restoreQueue;
        restoreTarget = null;
        restoreQueue = null;
        restoreStateOfTarget(target);
        if (queuedTargets) for(var i = 0; i < queuedTargets.length; i++)restoreStateOfTarget(queuedTargets[i]);
    }
    // the renderer. Such as when we're dispatching events or if third party
    // libraries need to call batchedUpdates. Eventually, this API will go away when
    // everything is batched by default. We'll then have a similar API to opt-out of
    // scheduled work and instead do synchronous work.
    // Defaults
    var batchedUpdatesImpl = function(fn, bookkeeping) {
        return fn(bookkeeping);
    };
    var flushSyncImpl = function() {};
    var isInsideEventHandler = false;
    function finishEventHandler() {
        // Here we wait until all updates have propagated, which is important
        // when using controlled components within layers:
        // https://github.com/facebook/react/issues/1698
        // Then we restore state of any controlled component.
        var controlledComponentsHavePendingUpdates = needsStateRestore();
        if (controlledComponentsHavePendingUpdates) {
            // If a controlled event was fired, we may need to restore the state of
            // the DOM node back to the controlled value. This is necessary when React
            // bails out of the update without touching the DOM.
            // TODO: Restore state in the microtask, after the discrete updates flush,
            // instead of early flushing them here.
            flushSyncImpl();
            restoreStateIfNeeded();
        }
    }
    function batchedUpdates(fn, a, b) {
        if (isInsideEventHandler) // If we are currently inside another batch, we need to wait until it
        // fully completes before restoring state.
        return fn(a, b);
        isInsideEventHandler = true;
        try {
            return batchedUpdatesImpl(fn, a, b);
        } finally{
            isInsideEventHandler = false;
            finishEventHandler();
        }
    } // TODO: Replace with flushSync
    function setBatchingImplementation(_batchedUpdatesImpl, _discreteUpdatesImpl, _flushSyncImpl) {
        batchedUpdatesImpl = _batchedUpdatesImpl;
        flushSyncImpl = _flushSyncImpl;
    }
    function isInteractive(tag) {
        return tag === "button" || tag === "input" || tag === "select" || tag === "textarea";
    }
    function shouldPreventMouseEvent(name, type, props) {
        switch(name){
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
                return !!(props.disabled && isInteractive(type));
            default:
                return false;
        }
    }
    /**
 * @param {object} inst The instance, which is the source of events.
 * @param {string} registrationName Name of listener (e.g. `onClick`).
 * @return {?function} The stored callback.
 */ function getListener(inst, registrationName) {
        var stateNode = inst.stateNode;
        if (stateNode === null) // Work in progress (ex: onload events in incremental mode).
        return null;
        var props = getFiberCurrentPropsFromNode(stateNode);
        if (props === null) // Work in progress.
        return null;
        var listener = props[registrationName];
        if (shouldPreventMouseEvent(registrationName, inst.type, props)) return null;
        if (listener && typeof listener !== "function") throw new Error("Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof listener + "` type.");
        return listener;
    }
    var passiveBrowserEventsSupported = false; // Check if browser support events with passive listeners
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
    if (canUseDOM) try {
        var options = {}; // $FlowFixMe: Ignore Flow complaining about needing a value
        Object.defineProperty(options, "passive", {
            get: function() {
                passiveBrowserEventsSupported = true;
            }
        });
        window.addEventListener("test", options, options);
        window.removeEventListener("test", options, options);
    } catch (e) {
        passiveBrowserEventsSupported = false;
    }
    function invokeGuardedCallbackProd(name, func, context, a, b, c, d, e, f) {
        var funcArgs = Array.prototype.slice.call(arguments, 3);
        try {
            func.apply(context, funcArgs);
        } catch (error) {
            this.onError(error);
        }
    }
    var invokeGuardedCallbackImpl = invokeGuardedCallbackProd;
    // In DEV mode, we swap out invokeGuardedCallback for a special version
    // that plays more nicely with the browser's DevTools. The idea is to preserve
    // "Pause on exceptions" behavior. Because React wraps all user-provided
    // functions in invokeGuardedCallback, and the production version of
    // invokeGuardedCallback uses a try-catch, all user exceptions are treated
    // like caught exceptions, and the DevTools won't pause unless the developer
    // takes the extra step of enabling pause on caught exceptions. This is
    // unintuitive, though, because even though React has caught the error, from
    // the developer's perspective, the error is uncaught.
    //
    // To preserve the expected "Pause on exceptions" behavior, we don't use a
    // try-catch in DEV. Instead, we synchronously dispatch a fake event to a fake
    // DOM node, and call the user-provided callback from inside an event handler
    // for that fake event. If the callback throws, the error is "captured" using
    // a global event handler. But because the error happens in a different
    // event loop context, it does not interrupt the normal program flow.
    // Effectively, this gives us try-catch behavior without actually using
    // try-catch. Neat!
    // Check that the browser supports the APIs we need to implement our special
    // DEV version of invokeGuardedCallback
    if (typeof window !== "undefined" && typeof window.dispatchEvent === "function" && typeof document !== "undefined" && typeof document.createEvent === "function") {
        var fakeNode = document.createElement("react");
        invokeGuardedCallbackImpl = function invokeGuardedCallbackDev(name, func, context, a, b, c, d, e, f) {
            // If document doesn't exist we know for sure we will crash in this method
            // when we call document.createEvent(). However this can cause confusing
            // errors: https://github.com/facebook/create-react-app/issues/3482
            // So we preemptively throw with a better message instead.
            if (typeof document === "undefined" || document === null) throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
            var evt = document.createEvent("Event");
            var didCall = false; // Keeps track of whether the user-provided callback threw an error. We
            // set this to true at the beginning, then set it to false right after
            // calling the function. If the function errors, `didError` will never be
            // set to false. This strategy works even if the browser is flaky and
            // fails to call our global error handler, because it doesn't rely on
            // the error event at all.
            var didError = true; // Keeps track of the value of window.event so that we can reset it
            // during the callback to let user code access window.event in the
            // browsers that support it.
            var windowEvent = window.event; // Keeps track of the descriptor of window.event to restore it after event
            // dispatching: https://github.com/facebook/react/issues/13688
            var windowEventDescriptor = Object.getOwnPropertyDescriptor(window, "event");
            function restoreAfterDispatch() {
                // We immediately remove the callback from event listeners so that
                // nested `invokeGuardedCallback` calls do not clash. Otherwise, a
                // nested call would trigger the fake event handlers of any call higher
                // in the stack.
                fakeNode.removeEventListener(evtType, callCallback, false); // We check for window.hasOwnProperty('event') to prevent the
                // window.event assignment in both IE <= 10 as they throw an error
                // "Member not found" in strict mode, and in Firefox which does not
                // support window.event.
                if (typeof window.event !== "undefined" && window.hasOwnProperty("event")) window.event = windowEvent;
            } // Create an event handler for our fake event. We will synchronously
            // dispatch our fake event using `dispatchEvent`. Inside the handler, we
            // call the user-provided callback.
            var funcArgs = Array.prototype.slice.call(arguments, 3);
            function callCallback() {
                didCall = true;
                restoreAfterDispatch();
                func.apply(context, funcArgs);
                didError = false;
            } // Create a global error event handler. We use this to capture the value
            // that was thrown. It's possible that this error handler will fire more
            // than once; for example, if non-React code also calls `dispatchEvent`
            // and a handler for that event throws. We should be resilient to most of
            // those cases. Even if our error event handler fires more than once, the
            // last error event is always used. If the callback actually does error,
            // we know that the last error event is the correct one, because it's not
            // possible for anything else to have happened in between our callback
            // erroring and the code that follows the `dispatchEvent` call below. If
            // the callback doesn't error, but the error event was fired, we know to
            // ignore it because `didError` will be false, as described above.
            var error; // Use this to track whether the error event is ever called.
            var didSetError = false;
            var isCrossOriginError = false;
            function handleWindowError(event) {
                error = event.error;
                didSetError = true;
                if (error === null && event.colno === 0 && event.lineno === 0) isCrossOriginError = true;
                if (event.defaultPrevented) {
                    // Some other error handler has prevented default.
                    // Browsers silence the error report if this happens.
                    // We'll remember this to later decide whether to log it or not.
                    if (error != null && typeof error === "object") try {
                        error._suppressLogging = true;
                    } catch (inner) {}
                }
            } // Create a fake event type.
            var evtType = "react-" + (name ? name : "invokeguardedcallback"); // Attach our event handlers
            window.addEventListener("error", handleWindowError);
            fakeNode.addEventListener(evtType, callCallback, false); // Synchronously dispatch our fake event. If the user-provided function
            // errors, it will trigger our global error handler.
            evt.initEvent(evtType, false, false);
            fakeNode.dispatchEvent(evt);
            if (windowEventDescriptor) Object.defineProperty(window, "event", windowEventDescriptor);
            if (didCall && didError) {
                if (!didSetError) // The callback errored, but the error event never fired.
                // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error("An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the \"Pause on exceptions\" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.");
                else if (isCrossOriginError) // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.");
                this.onError(error);
            } // Remove our event listeners
            window.removeEventListener("error", handleWindowError);
            if (!didCall) {
                // Something went really wrong, and our event was not dispatched.
                // https://github.com/facebook/react/issues/16734
                // https://github.com/facebook/react/issues/16585
                // Fall back to the production implementation.
                restoreAfterDispatch();
                return invokeGuardedCallbackProd.apply(this, arguments);
            }
        };
    }
    var invokeGuardedCallbackImpl$1 = invokeGuardedCallbackImpl;
    var hasError = false;
    var caughtError = null; // Used by event system to capture/rethrow the first error.
    var hasRethrowError = false;
    var rethrowError = null;
    var reporter = {
        onError: function(error) {
            hasError = true;
            caughtError = error;
        }
    };
    /**
 * Call a function while guarding against errors that happens within it.
 * Returns an error if it throws, otherwise null.
 *
 * In production, this is implemented using a try-catch. The reason we don't
 * use a try-catch directly is so that we can swap out a different
 * implementation in DEV mode.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallback(name, func, context, a, b, c, d, e, f) {
        hasError = false;
        caughtError = null;
        invokeGuardedCallbackImpl$1.apply(reporter, arguments);
    }
    /**
 * Same as invokeGuardedCallback, but instead of returning an error, it stores
 * it in a global so it can be rethrown by `rethrowCaughtError` later.
 * TODO: See if caughtError and rethrowError can be unified.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} context The context to use when calling the function
 * @param {...*} args Arguments for function
 */ function invokeGuardedCallbackAndCatchFirstError(name, func, context, a, b, c, d, e, f) {
        invokeGuardedCallback.apply(this, arguments);
        if (hasError) {
            var error = clearCaughtError();
            if (!hasRethrowError) {
                hasRethrowError = true;
                rethrowError = error;
            }
        }
    }
    /**
 * During execution of guarded functions we will capture the first error which
 * we will rethrow to be handled by the top level error handler.
 */ function rethrowCaughtError() {
        if (hasRethrowError) {
            var error = rethrowError;
            hasRethrowError = false;
            rethrowError = null;
            throw error;
        }
    }
    function hasCaughtError() {
        return hasError;
    }
    function clearCaughtError() {
        if (hasError) {
            var error = caughtError;
            hasError = false;
            caughtError = null;
            return error;
        } else throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    /**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 *
 * Note that this module is currently shared and assumed to be stateless.
 * If this becomes an actual Map, that will break.
 */ function get(key) {
        return key._reactInternals;
    }
    function has(key) {
        return key._reactInternals !== undefined;
    }
    function set(key, value) {
        key._reactInternals = value;
    }
    // Don't change these two values. They're used by React Dev Tools.
    var NoFlags = /*                      */ 0;
    var PerformedWork = /*                */ 1; // You can change the rest (and add more).
    var Placement = /*                    */ 2;
    var Update = /*                       */ 4;
    var ChildDeletion = /*                */ 16;
    var ContentReset = /*                 */ 32;
    var Callback = /*                     */ 64;
    var DidCapture = /*                   */ 128;
    var ForceClientRender = /*            */ 256;
    var Ref = /*                          */ 512;
    var Snapshot = /*                     */ 1024;
    var Passive = /*                      */ 2048;
    var Hydrating = /*                    */ 4096;
    var Visibility = /*                   */ 8192;
    var StoreConsistency = /*             */ 16384;
    var LifecycleEffectMask = Passive | Update | Callback | Ref | Snapshot | StoreConsistency; // Union of all commit flags (flags with the lifetime of a particular commit)
    var HostEffectMask = /*               */ 32767; // These are not really side effects, but we still reuse this field.
    var Incomplete = /*                   */ 32768;
    var ShouldCapture = /*                */ 65536;
    var ForceUpdateForLegacySuspense = /* */ 131072;
    var Forked = /*                       */ 1048576; // Static tags describe aspects of a fiber that are not specific to a render,
    // e.g. a fiber uses a passive effect (even if there are no updates on this particular render).
    // This enables us to defer more work in the unmount case,
    // since we can defer traversing the tree during layout to look for Passive effects,
    // and instead rely on the static flag as a signal that there may be cleanup work.
    var RefStatic = /*                    */ 2097152;
    var LayoutStatic = /*                 */ 4194304;
    var PassiveStatic = /*                */ 8388608; // These flags allow us to traverse to fibers that have effects on mount
    // without traversing the entire tree after every commit for
    // double invoking
    var MountLayoutDev = /*               */ 16777216;
    var MountPassiveDev = /*              */ 33554432; // Groups of flags that are used in the commit phase to skip over trees that
    // don't contain effects, by checking subtreeFlags.
    var BeforeMutationMask = // flag logic (see #20043)
    Update | Snapshot | 0;
    var MutationMask = Placement | Update | ChildDeletion | ContentReset | Ref | Hydrating | Visibility;
    var LayoutMask = Update | Callback | Ref | Visibility; // TODO: Split into PassiveMountMask and PassiveUnmountMask
    var PassiveMask = Passive | ChildDeletion; // Union of tags that don't get reset on clones.
    // This allows certain concepts to persist without recalculating them,
    // e.g. whether a subtree contains passive effects or portals.
    var StaticMask = LayoutStatic | PassiveStatic | RefStatic;
    var ReactCurrentOwner = ReactSharedInternals.ReactCurrentOwner;
    function getNearestMountedFiber(fiber) {
        var node = fiber;
        var nearestMounted = fiber;
        if (!fiber.alternate) {
            // If there is no alternate, this might be a new tree that isn't inserted
            // yet. If it is, then it will have a pending insertion effect on it.
            var nextNode = node;
            do {
                node = nextNode;
                if ((node.flags & (Placement | Hydrating)) !== NoFlags) // This is an insertion or in-progress hydration. The nearest possible
                // mounted fiber is the parent but we need to continue to figure out
                // if that one is still mounted.
                nearestMounted = node.return;
                nextNode = node.return;
            }while (nextNode);
        } else while(node.return)node = node.return;
        if (node.tag === HostRoot) // TODO: Check if this was a nested HostRoot when used with
        // renderContainerIntoSubtree.
        return nearestMounted;
         // If we didn't hit the root, that means that we're in an disconnected tree
        // that has been unmounted.
        return null;
    }
    function getSuspenseInstanceFromFiber(fiber) {
        if (fiber.tag === SuspenseComponent) {
            var suspenseState = fiber.memoizedState;
            if (suspenseState === null) {
                var current = fiber.alternate;
                if (current !== null) suspenseState = current.memoizedState;
            }
            if (suspenseState !== null) return suspenseState.dehydrated;
        }
        return null;
    }
    function getContainerFromFiber(fiber) {
        return fiber.tag === HostRoot ? fiber.stateNode.containerInfo : null;
    }
    function isFiberMounted(fiber) {
        return getNearestMountedFiber(fiber) === fiber;
    }
    function isMounted(component) {
        var owner = ReactCurrentOwner.current;
        if (owner !== null && owner.tag === ClassComponent) {
            var ownerFiber = owner;
            var instance = ownerFiber.stateNode;
            if (!instance._warnedAboutRefsInRender) error("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentNameFromFiber(ownerFiber) || "A component");
            instance._warnedAboutRefsInRender = true;
        }
        var fiber = get(component);
        if (!fiber) return false;
        return getNearestMountedFiber(fiber) === fiber;
    }
    function assertIsMounted(fiber) {
        if (getNearestMountedFiber(fiber) !== fiber) throw new Error("Unable to find node on an unmounted component.");
    }
    function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
            // If there is no alternate, then we only need to check if it is mounted.
            var nearestMounted = getNearestMountedFiber(fiber);
            if (nearestMounted === null) throw new Error("Unable to find node on an unmounted component.");
            if (nearestMounted !== fiber) return null;
            return fiber;
        } // If we have two possible branches, we'll walk backwards up to the root
        // to see what path the root points to. On the way we may hit one of the
        // special cases and we'll deal with them.
        var a = fiber;
        var b = alternate;
        while(true){
            var parentA = a.return;
            if (parentA === null) break;
            var parentB = parentA.alternate;
            if (parentB === null) {
                // There is no alternate. This is an unusual case. Currently, it only
                // happens when a Suspense component is hidden. An extra fragment fiber
                // is inserted in between the Suspense fiber and its children. Skip
                // over this extra fragment fiber and proceed to the next parent.
                var nextParent = parentA.return;
                if (nextParent !== null) {
                    a = b = nextParent;
                    continue;
                } // If there's no parent, we're at the root.
                break;
            } // If both copies of the parent fiber point to the same child, we can
            // assume that the child is current. This happens when we bailout on low
            // priority: the bailed out fiber's child reuses the current child.
            if (parentA.child === parentB.child) {
                var child = parentA.child;
                while(child){
                    if (child === a) {
                        // We've determined that A is the current branch.
                        assertIsMounted(parentA);
                        return fiber;
                    }
                    if (child === b) {
                        // We've determined that B is the current branch.
                        assertIsMounted(parentA);
                        return alternate;
                    }
                    child = child.sibling;
                } // We should never have an alternate for any mounting node. So the only
                // way this could possibly happen is if this was unmounted, if at all.
                throw new Error("Unable to find node on an unmounted component.");
            }
            if (a.return !== b.return) {
                // The return pointer of A and the return pointer of B point to different
                // fibers. We assume that return pointers never criss-cross, so A must
                // belong to the child set of A.return, and B must belong to the child
                // set of B.return.
                a = parentA;
                b = parentB;
            } else {
                // The return pointers point to the same fiber. We'll have to use the
                // default, slow path: scan the child sets of each parent alternate to see
                // which child belongs to which set.
                //
                // Search parent A's child set
                var didFindChild = false;
                var _child = parentA.child;
                while(_child){
                    if (_child === a) {
                        didFindChild = true;
                        a = parentA;
                        b = parentB;
                        break;
                    }
                    if (_child === b) {
                        didFindChild = true;
                        b = parentA;
                        a = parentB;
                        break;
                    }
                    _child = _child.sibling;
                }
                if (!didFindChild) {
                    // Search parent B's child set
                    _child = parentB.child;
                    while(_child){
                        if (_child === a) {
                            didFindChild = true;
                            a = parentB;
                            b = parentA;
                            break;
                        }
                        if (_child === b) {
                            didFindChild = true;
                            b = parentB;
                            a = parentA;
                            break;
                        }
                        _child = _child.sibling;
                    }
                    if (!didFindChild) throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
                }
            }
            if (a.alternate !== b) throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
        } // If the root is not a host container, we're in a disconnected tree. I.e.
        // unmounted.
        if (a.tag !== HostRoot) throw new Error("Unable to find node on an unmounted component.");
        if (a.stateNode.current === a) // We've determined that A is the current branch.
        return fiber;
         // Otherwise B has to be current branch.
        return alternate;
    }
    function findCurrentHostFiber(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberImpl(currentParent) : null;
    }
    function findCurrentHostFiberImpl(node) {
        // Next we'll drill down this component to find the first HostComponent/Text.
        if (node.tag === HostComponent || node.tag === HostText) return node;
        var child = node.child;
        while(child !== null){
            var match = findCurrentHostFiberImpl(child);
            if (match !== null) return match;
            child = child.sibling;
        }
        return null;
    }
    function findCurrentHostFiberWithNoPortals(parent) {
        var currentParent = findCurrentFiberUsingSlowPath(parent);
        return currentParent !== null ? findCurrentHostFiberWithNoPortalsImpl(currentParent) : null;
    }
    function findCurrentHostFiberWithNoPortalsImpl(node) {
        // Next we'll drill down this component to find the first HostComponent/Text.
        if (node.tag === HostComponent || node.tag === HostText) return node;
        var child = node.child;
        while(child !== null){
            if (child.tag !== HostPortal) {
                var match = findCurrentHostFiberWithNoPortalsImpl(child);
                if (match !== null) return match;
            }
            child = child.sibling;
        }
        return null;
    }
    // This module only exists as an ESM wrapper around the external CommonJS
    var scheduleCallback = Scheduler.unstable_scheduleCallback;
    var cancelCallback = Scheduler.unstable_cancelCallback;
    var shouldYield = Scheduler.unstable_shouldYield;
    var requestPaint = Scheduler.unstable_requestPaint;
    var now = Scheduler.unstable_now;
    var getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel;
    var ImmediatePriority = Scheduler.unstable_ImmediatePriority;
    var UserBlockingPriority = Scheduler.unstable_UserBlockingPriority;
    var NormalPriority = Scheduler.unstable_NormalPriority;
    var LowPriority = Scheduler.unstable_LowPriority;
    var IdlePriority = Scheduler.unstable_IdlePriority;
    // this doesn't actually exist on the scheduler, but it *does*
    // on scheduler/unstable_mock, which we'll need for internal testing
    var unstable_yieldValue = Scheduler.unstable_yieldValue;
    var unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue;
    var rendererID = null;
    var injectedHook = null;
    var injectedProfilingHooks = null;
    var hasLoggedError = false;
    var isDevToolsPresent = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined";
    function injectInternals(internals) {
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined") // No DevTools
        return false;
        var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (hook.isDisabled) // This isn't a real property on the hook, but it can be set to opt out
        // of DevTools integration and associated warnings and logs.
        // https://github.com/facebook/react/issues/3877
        return true;
        if (!hook.supportsFiber) {
            error("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools");
            return true;
        }
        try {
            if (enableSchedulingProfiler) // Conditionally inject these hooks only if Timeline profiler is supported by this build.
            // This gives DevTools a way to feature detect that isn't tied to version number
            // (since profiling and timeline are controlled by different feature flags).
            internals = assign({}, internals, {
                getLaneLabelMap: getLaneLabelMap,
                injectProfilingHooks: injectProfilingHooks
            });
            rendererID = hook.inject(internals); // We have successfully injected, so now it is safe to set up hooks.
            injectedHook = hook;
        } catch (err) {
            error("React instrumentation encountered an error: %s.", err);
        }
        if (hook.checkDCE) // This is the real DevTools.
        return true;
        else // This is likely a hook installed by Fast Refresh runtime.
        return false;
    }
    function onScheduleRoot(root, children) {
        if (injectedHook && typeof injectedHook.onScheduleFiberRoot === "function") try {
            injectedHook.onScheduleFiberRoot(rendererID, root, children);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onCommitRoot(root, eventPriority) {
        if (injectedHook && typeof injectedHook.onCommitFiberRoot === "function") try {
            var didError = (root.current.flags & DidCapture) === DidCapture;
            if (enableProfilerTimer) {
                var schedulerPriority;
                switch(eventPriority){
                    case DiscreteEventPriority:
                        schedulerPriority = ImmediatePriority;
                        break;
                    case ContinuousEventPriority:
                        schedulerPriority = UserBlockingPriority;
                        break;
                    case DefaultEventPriority:
                        schedulerPriority = NormalPriority;
                        break;
                    case IdleEventPriority:
                        schedulerPriority = IdlePriority;
                        break;
                    default:
                        schedulerPriority = NormalPriority;
                        break;
                }
                injectedHook.onCommitFiberRoot(rendererID, root, schedulerPriority, didError);
            } else injectedHook.onCommitFiberRoot(rendererID, root, undefined, didError);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onPostCommitRoot(root) {
        if (injectedHook && typeof injectedHook.onPostCommitFiberRoot === "function") try {
            injectedHook.onPostCommitFiberRoot(rendererID, root);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function onCommitUnmount(fiber) {
        if (injectedHook && typeof injectedHook.onCommitFiberUnmount === "function") try {
            injectedHook.onCommitFiberUnmount(rendererID, fiber);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    }
    function setIsStrictModeForDevtools(newIsStrictMode) {
        if (typeof unstable_yieldValue === "function") {
            // We're in a test because Scheduler.unstable_yieldValue only exists
            // in SchedulerMock. To reduce the noise in strict mode tests,
            // suppress warnings and disable scheduler yielding during the double render
            unstable_setDisableYieldValue(newIsStrictMode);
            setSuppressWarning(newIsStrictMode);
        }
        if (injectedHook && typeof injectedHook.setStrictMode === "function") try {
            injectedHook.setStrictMode(rendererID, newIsStrictMode);
        } catch (err) {
            if (!hasLoggedError) {
                hasLoggedError = true;
                error("React instrumentation encountered an error: %s", err);
            }
        }
    } // Profiler API hooks
    function injectProfilingHooks(profilingHooks) {
        injectedProfilingHooks = profilingHooks;
    }
    function getLaneLabelMap() {
        var map = new Map();
        var lane = 1;
        for(var index = 0; index < TotalLanes; index++){
            var label = getLabelForLane(lane);
            map.set(lane, label);
            lane *= 2;
        }
        return map;
    }
    function markCommitStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStarted === "function") injectedProfilingHooks.markCommitStarted(lanes);
    }
    function markCommitStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markCommitStopped === "function") injectedProfilingHooks.markCommitStopped();
    }
    function markComponentRenderStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStarted === "function") injectedProfilingHooks.markComponentRenderStarted(fiber);
    }
    function markComponentRenderStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentRenderStopped === "function") injectedProfilingHooks.markComponentRenderStopped();
    }
    function markComponentPassiveEffectMountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStarted === "function") injectedProfilingHooks.markComponentPassiveEffectMountStarted(fiber);
    }
    function markComponentPassiveEffectMountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectMountStopped === "function") injectedProfilingHooks.markComponentPassiveEffectMountStopped();
    }
    function markComponentPassiveEffectUnmountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStarted === "function") injectedProfilingHooks.markComponentPassiveEffectUnmountStarted(fiber);
    }
    function markComponentPassiveEffectUnmountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentPassiveEffectUnmountStopped === "function") injectedProfilingHooks.markComponentPassiveEffectUnmountStopped();
    }
    function markComponentLayoutEffectMountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStarted === "function") injectedProfilingHooks.markComponentLayoutEffectMountStarted(fiber);
    }
    function markComponentLayoutEffectMountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectMountStopped === "function") injectedProfilingHooks.markComponentLayoutEffectMountStopped();
    }
    function markComponentLayoutEffectUnmountStarted(fiber) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStarted === "function") injectedProfilingHooks.markComponentLayoutEffectUnmountStarted(fiber);
    }
    function markComponentLayoutEffectUnmountStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentLayoutEffectUnmountStopped === "function") injectedProfilingHooks.markComponentLayoutEffectUnmountStopped();
    }
    function markComponentErrored(fiber, thrownValue, lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentErrored === "function") injectedProfilingHooks.markComponentErrored(fiber, thrownValue, lanes);
    }
    function markComponentSuspended(fiber, wakeable, lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markComponentSuspended === "function") injectedProfilingHooks.markComponentSuspended(fiber, wakeable, lanes);
    }
    function markLayoutEffectsStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStarted === "function") injectedProfilingHooks.markLayoutEffectsStarted(lanes);
    }
    function markLayoutEffectsStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markLayoutEffectsStopped === "function") injectedProfilingHooks.markLayoutEffectsStopped();
    }
    function markPassiveEffectsStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStarted === "function") injectedProfilingHooks.markPassiveEffectsStarted(lanes);
    }
    function markPassiveEffectsStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markPassiveEffectsStopped === "function") injectedProfilingHooks.markPassiveEffectsStopped();
    }
    function markRenderStarted(lanes) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStarted === "function") injectedProfilingHooks.markRenderStarted(lanes);
    }
    function markRenderYielded() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderYielded === "function") injectedProfilingHooks.markRenderYielded();
    }
    function markRenderStopped() {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderStopped === "function") injectedProfilingHooks.markRenderStopped();
    }
    function markRenderScheduled(lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markRenderScheduled === "function") injectedProfilingHooks.markRenderScheduled(lane);
    }
    function markForceUpdateScheduled(fiber, lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markForceUpdateScheduled === "function") injectedProfilingHooks.markForceUpdateScheduled(fiber, lane);
    }
    function markStateUpdateScheduled(fiber, lane) {
        if (injectedProfilingHooks !== null && typeof injectedProfilingHooks.markStateUpdateScheduled === "function") injectedProfilingHooks.markStateUpdateScheduled(fiber, lane);
    }
    var NoMode = /*                         */ 0; // TODO: Remove ConcurrentMode by reading from the root tag instead
    var ConcurrentMode = /*                 */ 1;
    var ProfileMode = /*                    */ 2;
    var StrictLegacyMode = /*               */ 8;
    var StrictEffectsMode = /*              */ 16;
    // TODO: This is pretty well supported by browsers. Maybe we can drop it.
    var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback; // Count leading zeros.
    // Based on:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/clz32
    var log = Math.log;
    var LN2 = Math.LN2;
    function clz32Fallback(x) {
        var asUint = x >>> 0;
        if (asUint === 0) return 32;
        return 31 - (log(asUint) / LN2 | 0) | 0;
    }
    // If those values are changed that package should be rebuilt and redeployed.
    var TotalLanes = 31;
    var NoLanes = /*                        */ 0;
    var NoLane = /*                          */ 0;
    var SyncLane = /*                        */ 1;
    var InputContinuousHydrationLane = /*    */ 2;
    var InputContinuousLane = /*             */ 4;
    var DefaultHydrationLane = /*            */ 8;
    var DefaultLane = /*                     */ 16;
    var TransitionHydrationLane = /*                */ 32;
    var TransitionLanes = /*                       */ 4194240;
    var TransitionLane1 = /*                        */ 64;
    var TransitionLane2 = /*                        */ 128;
    var TransitionLane3 = /*                        */ 256;
    var TransitionLane4 = /*                        */ 512;
    var TransitionLane5 = /*                        */ 1024;
    var TransitionLane6 = /*                        */ 2048;
    var TransitionLane7 = /*                        */ 4096;
    var TransitionLane8 = /*                        */ 8192;
    var TransitionLane9 = /*                        */ 16384;
    var TransitionLane10 = /*                       */ 32768;
    var TransitionLane11 = /*                       */ 65536;
    var TransitionLane12 = /*                       */ 131072;
    var TransitionLane13 = /*                       */ 262144;
    var TransitionLane14 = /*                       */ 524288;
    var TransitionLane15 = /*                       */ 1048576;
    var TransitionLane16 = /*                       */ 2097152;
    var RetryLanes = /*                            */ 130023424;
    var RetryLane1 = /*                             */ 4194304;
    var RetryLane2 = /*                             */ 8388608;
    var RetryLane3 = /*                             */ 16777216;
    var RetryLane4 = /*                             */ 33554432;
    var RetryLane5 = /*                             */ 67108864;
    var SomeRetryLane = RetryLane1;
    var SelectiveHydrationLane = /*          */ 134217728;
    var NonIdleLanes = /*                          */ 268435455;
    var IdleHydrationLane = /*               */ 268435456;
    var IdleLane = /*                        */ 536870912;
    var OffscreenLane = /*                   */ 1073741824; // This function is used for the experimental timeline (react-devtools-timeline)
    // It should be kept in sync with the Lanes values above.
    function getLabelForLane(lane) {
        if (lane & SyncLane) return "Sync";
        if (lane & InputContinuousHydrationLane) return "InputContinuousHydration";
        if (lane & InputContinuousLane) return "InputContinuous";
        if (lane & DefaultHydrationLane) return "DefaultHydration";
        if (lane & DefaultLane) return "Default";
        if (lane & TransitionHydrationLane) return "TransitionHydration";
        if (lane & TransitionLanes) return "Transition";
        if (lane & RetryLanes) return "Retry";
        if (lane & SelectiveHydrationLane) return "SelectiveHydration";
        if (lane & IdleHydrationLane) return "IdleHydration";
        if (lane & IdleLane) return "Idle";
        if (lane & OffscreenLane) return "Offscreen";
    }
    var NoTimestamp = -1;
    var nextTransitionLane = TransitionLane1;
    var nextRetryLane = RetryLane1;
    function getHighestPriorityLanes(lanes) {
        switch(getHighestPriorityLane(lanes)){
            case SyncLane:
                return SyncLane;
            case InputContinuousHydrationLane:
                return InputContinuousHydrationLane;
            case InputContinuousLane:
                return InputContinuousLane;
            case DefaultHydrationLane:
                return DefaultHydrationLane;
            case DefaultLane:
                return DefaultLane;
            case TransitionHydrationLane:
                return TransitionHydrationLane;
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
                return lanes & TransitionLanes;
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                return lanes & RetryLanes;
            case SelectiveHydrationLane:
                return SelectiveHydrationLane;
            case IdleHydrationLane:
                return IdleHydrationLane;
            case IdleLane:
                return IdleLane;
            case OffscreenLane:
                return OffscreenLane;
            default:
                error("Should have found matching lanes. This is a bug in React.");
                return lanes;
        }
    }
    function getNextLanes(root, wipLanes) {
        // Early bailout if there's no pending work left.
        var pendingLanes = root.pendingLanes;
        if (pendingLanes === NoLanes) return NoLanes;
        var nextLanes = NoLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes; // Do not work on any idle work until all the non-idle work has finished,
        // even if the work is suspended.
        var nonIdlePendingLanes = pendingLanes & NonIdleLanes;
        if (nonIdlePendingLanes !== NoLanes) {
            var nonIdleUnblockedLanes = nonIdlePendingLanes & ~suspendedLanes;
            if (nonIdleUnblockedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(nonIdleUnblockedLanes);
            else {
                var nonIdlePingedLanes = nonIdlePendingLanes & pingedLanes;
                if (nonIdlePingedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(nonIdlePingedLanes);
            }
        } else {
            // The only remaining work is Idle.
            var unblockedLanes = pendingLanes & ~suspendedLanes;
            if (unblockedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(unblockedLanes);
            else if (pingedLanes !== NoLanes) nextLanes = getHighestPriorityLanes(pingedLanes);
        }
        if (nextLanes === NoLanes) // This should only be reachable if we're suspended
        // TODO: Consider warning in this path if a fallback timer is not scheduled.
        return NoLanes;
         // If we're already in the middle of a render, switching lanes will interrupt
        // it and we'll lose our progress. We should only do this if the new lanes are
        // higher priority.
        if (wipLanes !== NoLanes && wipLanes !== nextLanes && // If we already suspended with a delay, then interrupting is fine. Don't
        // bother waiting until the root is complete.
        (wipLanes & suspendedLanes) === NoLanes) {
            var nextLane = getHighestPriorityLane(nextLanes);
            var wipLane = getHighestPriorityLane(wipLanes);
            if (// one. This works because the bits decrease in priority as you go left.
            nextLane >= wipLane || // Default priority updates should not interrupt transition updates. The
            // only difference between default updates and transition updates is that
            // default updates do not support refresh transitions.
            nextLane === DefaultLane && (wipLane & TransitionLanes) !== NoLanes) // Keep working on the existing in-progress tree. Do not interrupt.
            return wipLanes;
        }
        if ((nextLanes & InputContinuousLane) !== NoLanes) // When updates are sync by default, we entangle continuous priority updates
        // and default updates, so they render in the same batch. The only reason
        // they use separate lanes is because continuous updates should interrupt
        // transitions, but default updates should not.
        nextLanes |= pendingLanes & DefaultLane;
         // Check for entangled lanes and add them to the batch.
        //
        // A lane is said to be entangled with another when it's not allowed to render
        // in a batch that does not also include the other lane. Typically we do this
        // when multiple updates have the same source, and we only want to respond to
        // the most recent event from that source.
        //
        // Note that we apply entanglements *after* checking for partial work above.
        // This means that if a lane is entangled during an interleaved event while
        // it's already rendering, we won't interrupt it. This is intentional, since
        // entanglement is usually "best effort": we'll try our best to render the
        // lanes in the same batch, but it's not worth throwing out partially
        // completed work in order to do it.
        // TODO: Reconsider this. The counter-argument is that the partial work
        // represents an intermediate state, which we don't want to show to the user.
        // And by spending extra time finishing it, we're increasing the amount of
        // time it takes to show the final state, which is what they are actually
        // waiting for.
        //
        // For those exceptions where entanglement is semantically important, like
        // useMutableSource, we should ensure that there is no partial work at the
        // time we apply the entanglement.
        var entangledLanes = root.entangledLanes;
        if (entangledLanes !== NoLanes) {
            var entanglements = root.entanglements;
            var lanes = nextLanes & entangledLanes;
            while(lanes > 0){
                var index = pickArbitraryLaneIndex(lanes);
                var lane = 1 << index;
                nextLanes |= entanglements[index];
                lanes &= ~lane;
            }
        }
        return nextLanes;
    }
    function getMostRecentEventTime(root, lanes) {
        var eventTimes = root.eventTimes;
        var mostRecentEventTime = NoTimestamp;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var eventTime = eventTimes[index];
            if (eventTime > mostRecentEventTime) mostRecentEventTime = eventTime;
            lanes &= ~lane;
        }
        return mostRecentEventTime;
    }
    function computeExpirationTime(lane, currentTime) {
        switch(lane){
            case SyncLane:
            case InputContinuousHydrationLane:
            case InputContinuousLane:
                // User interactions should expire slightly more quickly.
                //
                // NOTE: This is set to the corresponding constant as in Scheduler.js.
                // When we made it larger, a product metric in www regressed, suggesting
                // there's a user interaction that's being starved by a series of
                // synchronous updates. If that theory is correct, the proper solution is
                // to fix the starvation. However, this scenario supports the idea that
                // expiration times are an important safeguard when starvation
                // does happen.
                return currentTime + 250;
            case DefaultHydrationLane:
            case DefaultLane:
            case TransitionHydrationLane:
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
                return currentTime + 5000;
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                // TODO: Retries should be allowed to expire if they are CPU bound for
                // too long, but when I made this change it caused a spike in browser
                // crashes. There must be some other underlying bug; not super urgent but
                // ideally should figure out why and fix it. Unfortunately we don't have
                // a repro for the crashes, only detected via production metrics.
                return NoTimestamp;
            case SelectiveHydrationLane:
            case IdleHydrationLane:
            case IdleLane:
            case OffscreenLane:
                // Anything idle priority or lower should never expire.
                return NoTimestamp;
            default:
                error("Should have found matching lanes. This is a bug in React.");
                return NoTimestamp;
        }
    }
    function markStarvedLanesAsExpired(root, currentTime) {
        // TODO: This gets called every time we yield. We can optimize by storing
        // the earliest expiration time on the root. Then use that to quickly bail out
        // of this function.
        var pendingLanes = root.pendingLanes;
        var suspendedLanes = root.suspendedLanes;
        var pingedLanes = root.pingedLanes;
        var expirationTimes = root.expirationTimes; // Iterate through the pending lanes and check if we've reached their
        // expiration time. If so, we'll assume the update is being starved and mark
        // it as expired to force it to finish.
        var lanes = pendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            var expirationTime = expirationTimes[index];
            if (expirationTime === NoTimestamp) // Found a pending lane with no expiration time. If it's not suspended, or
            // if it's pinged, assume it's CPU-bound. Compute a new expiration time
            // using the current time.
            {
                if ((lane & suspendedLanes) === NoLanes || (lane & pingedLanes) !== NoLanes) // Assumes timestamps are monotonically increasing.
                expirationTimes[index] = computeExpirationTime(lane, currentTime);
            } else if (expirationTime <= currentTime) // This lane expired
            root.expiredLanes |= lane;
            lanes &= ~lane;
        }
    } // This returns the highest priority pending lanes regardless of whether they
    // are suspended.
    function getHighestPriorityPendingLanes(root) {
        return getHighestPriorityLanes(root.pendingLanes);
    }
    function getLanesToRetrySynchronouslyOnError(root) {
        var everythingButOffscreen = root.pendingLanes & ~OffscreenLane;
        if (everythingButOffscreen !== NoLanes) return everythingButOffscreen;
        if (everythingButOffscreen & OffscreenLane) return OffscreenLane;
        return NoLanes;
    }
    function includesSyncLane(lanes) {
        return (lanes & SyncLane) !== NoLanes;
    }
    function includesNonIdleWork(lanes) {
        return (lanes & NonIdleLanes) !== NoLanes;
    }
    function includesOnlyRetries(lanes) {
        return (lanes & RetryLanes) === lanes;
    }
    function includesOnlyNonUrgentLanes(lanes) {
        var UrgentLanes = SyncLane | InputContinuousLane | DefaultLane;
        return (lanes & UrgentLanes) === NoLanes;
    }
    function includesOnlyTransitions(lanes) {
        return (lanes & TransitionLanes) === lanes;
    }
    function includesBlockingLane(root, lanes) {
        var SyncDefaultLanes = InputContinuousHydrationLane | InputContinuousLane | DefaultHydrationLane | DefaultLane;
        return (lanes & SyncDefaultLanes) !== NoLanes;
    }
    function includesExpiredLane(root, lanes) {
        // This is a separate check from includesBlockingLane because a lane can
        // expire after a render has already started.
        return (lanes & root.expiredLanes) !== NoLanes;
    }
    function isTransitionLane(lane) {
        return (lane & TransitionLanes) !== NoLanes;
    }
    function claimNextTransitionLane() {
        // Cycle through the lanes, assigning each new transition to the next lane.
        // In most cases, this means every transition gets its own lane, until we
        // run out of lanes and cycle back to the beginning.
        var lane = nextTransitionLane;
        nextTransitionLane <<= 1;
        if ((nextTransitionLane & TransitionLanes) === NoLanes) nextTransitionLane = TransitionLane1;
        return lane;
    }
    function claimNextRetryLane() {
        var lane = nextRetryLane;
        nextRetryLane <<= 1;
        if ((nextRetryLane & RetryLanes) === NoLanes) nextRetryLane = RetryLane1;
        return lane;
    }
    function getHighestPriorityLane(lanes) {
        return lanes & -lanes;
    }
    function pickArbitraryLane(lanes) {
        // This wrapper function gets inlined. Only exists so to communicate that it
        // doesn't matter which bit is selected; you can pick any bit without
        // affecting the algorithms where its used. Here I'm using
        // getHighestPriorityLane because it requires the fewest operations.
        return getHighestPriorityLane(lanes);
    }
    function pickArbitraryLaneIndex(lanes) {
        return 31 - clz32(lanes);
    }
    function laneToIndex(lane) {
        return pickArbitraryLaneIndex(lane);
    }
    function includesSomeLane(a, b) {
        return (a & b) !== NoLanes;
    }
    function isSubsetOfLanes(set, subset) {
        return (set & subset) === subset;
    }
    function mergeLanes(a, b) {
        return a | b;
    }
    function removeLanes(set, subset) {
        return set & ~subset;
    }
    function intersectLanes(a, b) {
        return a & b;
    } // Seems redundant, but it changes the type from a single lane (used for
    // updates) to a group of lanes (used for flushing work).
    function laneToLanes(lane) {
        return lane;
    }
    function higherPriorityLane(a, b) {
        // This works because the bit ranges decrease in priority as you go left.
        return a !== NoLane && a < b ? a : b;
    }
    function createLaneMap(initial) {
        // Intentionally pushing one by one.
        // https://v8.dev/blog/elements-kinds#avoid-creating-holes
        var laneMap = [];
        for(var i = 0; i < TotalLanes; i++)laneMap.push(initial);
        return laneMap;
    }
    function markRootUpdated(root, updateLane, eventTime) {
        root.pendingLanes |= updateLane; // If there are any suspended transitions, it's possible this new update
        // could unblock them. Clear the suspended lanes so that we can try rendering
        // them again.
        //
        // TODO: We really only need to unsuspend only lanes that are in the
        // `subtreeLanes` of the updated fiber, or the update lanes of the return
        // path. This would exclude suspended updates in an unrelated sibling tree,
        // since there's no way for this update to unblock it.
        //
        // We don't do this if the incoming update is idle, because we never process
        // idle updates until after all the regular updates have finished; there's no
        // way it could unblock a transition.
        if (updateLane !== IdleLane) {
            root.suspendedLanes = NoLanes;
            root.pingedLanes = NoLanes;
        }
        var eventTimes = root.eventTimes;
        var index = laneToIndex(updateLane); // We can always overwrite an existing timestamp because we prefer the most
        // recent event, and we assume time is monotonically increasing.
        eventTimes[index] = eventTime;
    }
    function markRootSuspended(root, suspendedLanes) {
        root.suspendedLanes |= suspendedLanes;
        root.pingedLanes &= ~suspendedLanes; // The suspended lanes are no longer CPU-bound. Clear their expiration times.
        var expirationTimes = root.expirationTimes;
        var lanes = suspendedLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootPinged(root, pingedLanes, eventTime) {
        root.pingedLanes |= root.suspendedLanes & pingedLanes;
    }
    function markRootFinished(root, remainingLanes) {
        var noLongerPendingLanes = root.pendingLanes & ~remainingLanes;
        root.pendingLanes = remainingLanes; // Let's try everything again
        root.suspendedLanes = NoLanes;
        root.pingedLanes = NoLanes;
        root.expiredLanes &= remainingLanes;
        root.mutableReadLanes &= remainingLanes;
        root.entangledLanes &= remainingLanes;
        var entanglements = root.entanglements;
        var eventTimes = root.eventTimes;
        var expirationTimes = root.expirationTimes; // Clear the lanes that no longer have pending work
        var lanes = noLongerPendingLanes;
        while(lanes > 0){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            entanglements[index] = NoLanes;
            eventTimes[index] = NoTimestamp;
            expirationTimes[index] = NoTimestamp;
            lanes &= ~lane;
        }
    }
    function markRootEntangled(root, entangledLanes) {
        // In addition to entangling each of the given lanes with each other, we also
        // have to consider _transitive_ entanglements. For each lane that is already
        // entangled with *any* of the given lanes, that lane is now transitively
        // entangled with *all* the given lanes.
        //
        // Translated: If C is entangled with A, then entangling A with B also
        // entangles C with B.
        //
        // If this is hard to grasp, it might help to intentionally break this
        // function and look at the tests that fail in ReactTransition-test.js. Try
        // commenting out one of the conditions below.
        var rootEntangledLanes = root.entangledLanes |= entangledLanes;
        var entanglements = root.entanglements;
        var lanes = rootEntangledLanes;
        while(lanes){
            var index = pickArbitraryLaneIndex(lanes);
            var lane = 1 << index;
            if (lane & entangledLanes | // Is this lane transitively entangled with the newly entangled lanes?
            entanglements[index] & entangledLanes) entanglements[index] |= entangledLanes;
            lanes &= ~lane;
        }
    }
    function getBumpedLaneForHydration(root, renderLanes) {
        var renderLane = getHighestPriorityLane(renderLanes);
        var lane;
        switch(renderLane){
            case InputContinuousLane:
                lane = InputContinuousHydrationLane;
                break;
            case DefaultLane:
                lane = DefaultHydrationLane;
                break;
            case TransitionLane1:
            case TransitionLane2:
            case TransitionLane3:
            case TransitionLane4:
            case TransitionLane5:
            case TransitionLane6:
            case TransitionLane7:
            case TransitionLane8:
            case TransitionLane9:
            case TransitionLane10:
            case TransitionLane11:
            case TransitionLane12:
            case TransitionLane13:
            case TransitionLane14:
            case TransitionLane15:
            case TransitionLane16:
            case RetryLane1:
            case RetryLane2:
            case RetryLane3:
            case RetryLane4:
            case RetryLane5:
                lane = TransitionHydrationLane;
                break;
            case IdleLane:
                lane = IdleHydrationLane;
                break;
            default:
                // Everything else is already either a hydration lane, or shouldn't
                // be retried at a hydration lane.
                lane = NoLane;
                break;
        } // Check if the lane we chose is suspended. If so, that indicates that we
        // already attempted and failed to hydrate at that level. Also check if we're
        // already rendering that lane, which is rare but could happen.
        if ((lane & (root.suspendedLanes | renderLanes)) !== NoLane) // Give up trying to hydrate and fall back to client render.
        return NoLane;
        return lane;
    }
    function addFiberToLanesMap(root, fiber, lanes) {
        if (!isDevToolsPresent) return;
        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;
        while(lanes > 0){
            var index = laneToIndex(lanes);
            var lane = 1 << index;
            var updaters = pendingUpdatersLaneMap[index];
            updaters.add(fiber);
            lanes &= ~lane;
        }
    }
    function movePendingFibersToMemoized(root, lanes) {
        if (!isDevToolsPresent) return;
        var pendingUpdatersLaneMap = root.pendingUpdatersLaneMap;
        var memoizedUpdaters = root.memoizedUpdaters;
        while(lanes > 0){
            var index = laneToIndex(lanes);
            var lane = 1 << index;
            var updaters = pendingUpdatersLaneMap[index];
            if (updaters.size > 0) {
                updaters.forEach(function(fiber) {
                    var alternate = fiber.alternate;
                    if (alternate === null || !memoizedUpdaters.has(alternate)) memoizedUpdaters.add(fiber);
                });
                updaters.clear();
            }
            lanes &= ~lane;
        }
    }
    function getTransitionsForLanes(root, lanes) {
        return null;
    }
    var DiscreteEventPriority = SyncLane;
    var ContinuousEventPriority = InputContinuousLane;
    var DefaultEventPriority = DefaultLane;
    var IdleEventPriority = IdleLane;
    var currentUpdatePriority = NoLane;
    function getCurrentUpdatePriority() {
        return currentUpdatePriority;
    }
    function setCurrentUpdatePriority(newPriority) {
        currentUpdatePriority = newPriority;
    }
    function runWithPriority(priority, fn) {
        var previousPriority = currentUpdatePriority;
        try {
            currentUpdatePriority = priority;
            return fn();
        } finally{
            currentUpdatePriority = previousPriority;
        }
    }
    function higherEventPriority(a, b) {
        return a !== 0 && a < b ? a : b;
    }
    function lowerEventPriority(a, b) {
        return a === 0 || a > b ? a : b;
    }
    function isHigherEventPriority(a, b) {
        return a !== 0 && a < b;
    }
    function lanesToEventPriority(lanes) {
        var lane = getHighestPriorityLane(lanes);
        if (!isHigherEventPriority(DiscreteEventPriority, lane)) return DiscreteEventPriority;
        if (!isHigherEventPriority(ContinuousEventPriority, lane)) return ContinuousEventPriority;
        if (includesNonIdleWork(lane)) return DefaultEventPriority;
        return IdleEventPriority;
    }
    // This is imported by the event replaying implementation in React DOM. It's
    // in a separate file to break a circular dependency between the renderer and
    // the reconciler.
    function isRootDehydrated(root) {
        var currentState = root.current.memoizedState;
        return currentState.isDehydrated;
    }
    var _attemptSynchronousHydration;
    function setAttemptSynchronousHydration(fn) {
        _attemptSynchronousHydration = fn;
    }
    function attemptSynchronousHydration(fiber) {
        _attemptSynchronousHydration(fiber);
    }
    var attemptContinuousHydration;
    function setAttemptContinuousHydration(fn) {
        attemptContinuousHydration = fn;
    }
    var attemptHydrationAtCurrentPriority;
    function setAttemptHydrationAtCurrentPriority(fn) {
        attemptHydrationAtCurrentPriority = fn;
    }
    var getCurrentUpdatePriority$1;
    function setGetCurrentUpdatePriority(fn) {
        getCurrentUpdatePriority$1 = fn;
    }
    var attemptHydrationAtPriority;
    function setAttemptHydrationAtPriority(fn) {
        attemptHydrationAtPriority = fn;
    } // TODO: Upgrade this definition once we're on a newer version of Flow that
    // has this definition built-in.
    var hasScheduledReplayAttempt = false; // The queue of discrete events to be replayed.
    var queuedDiscreteEvents = []; // Indicates if any continuous event targets are non-null for early bailout.
    // if the last target was dehydrated.
    var queuedFocus = null;
    var queuedDrag = null;
    var queuedMouse = null; // For pointer events there can be one latest event per pointerId.
    var queuedPointers = new Map();
    var queuedPointerCaptures = new Map(); // We could consider replaying selectionchange and touchmoves too.
    var queuedExplicitHydrationTargets = [];
    var discreteReplayableEvents = [
        "mousedown",
        "mouseup",
        "touchcancel",
        "touchend",
        "touchstart",
        "auxclick",
        "dblclick",
        "pointercancel",
        "pointerdown",
        "pointerup",
        "dragend",
        "dragstart",
        "drop",
        "compositionend",
        "compositionstart",
        "keydown",
        "keypress",
        "keyup",
        "input",
        "textInput",
        "copy",
        "cut",
        "paste",
        "click",
        "change",
        "contextmenu",
        "reset",
        "submit"
    ];
    function isDiscreteEventThatRequiresHydration(eventType) {
        return discreteReplayableEvents.indexOf(eventType) > -1;
    }
    function createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        return {
            blockedOn: blockedOn,
            domEventName: domEventName,
            eventSystemFlags: eventSystemFlags,
            nativeEvent: nativeEvent,
            targetContainers: [
                targetContainer
            ]
        };
    }
    function clearIfContinuousEvent(domEventName, nativeEvent) {
        switch(domEventName){
            case "focusin":
            case "focusout":
                queuedFocus = null;
                break;
            case "dragenter":
            case "dragleave":
                queuedDrag = null;
                break;
            case "mouseover":
            case "mouseout":
                queuedMouse = null;
                break;
            case "pointerover":
            case "pointerout":
                var pointerId = nativeEvent.pointerId;
                queuedPointers.delete(pointerId);
                break;
            case "gotpointercapture":
            case "lostpointercapture":
                var _pointerId = nativeEvent.pointerId;
                queuedPointerCaptures.delete(_pointerId);
                break;
        }
    }
    function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (existingQueuedEvent === null || existingQueuedEvent.nativeEvent !== nativeEvent) {
            var queuedEvent = createQueuedReplayableEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent);
            if (blockedOn !== null) {
                var _fiber2 = getInstanceFromNode(blockedOn);
                if (_fiber2 !== null) // Attempt to increase the priority of this target.
                attemptContinuousHydration(_fiber2);
            }
            return queuedEvent;
        } // If we have already queued this exact event, then it's because
        // the different event systems have different DOM event listeners.
        // We can accumulate the flags, and the targetContainers, and
        // store a single event to be replayed.
        existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
        var targetContainers = existingQueuedEvent.targetContainers;
        if (targetContainer !== null && targetContainers.indexOf(targetContainer) === -1) targetContainers.push(targetContainer);
        return existingQueuedEvent;
    }
    function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // These set relatedTarget to null because the replayed event will be treated as if we
        // moved from outside the window (no target) onto the target once it hydrates.
        // Instead of mutating we could clone the event.
        switch(domEventName){
            case "focusin":
                var focusEvent = nativeEvent;
                queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, focusEvent);
                return true;
            case "dragenter":
                var dragEvent = nativeEvent;
                queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, dragEvent);
                return true;
            case "mouseover":
                var mouseEvent = nativeEvent;
                queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, mouseEvent);
                return true;
            case "pointerover":
                var pointerEvent = nativeEvent;
                var pointerId = pointerEvent.pointerId;
                queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, pointerEvent));
                return true;
            case "gotpointercapture":
                var _pointerEvent = nativeEvent;
                var _pointerId2 = _pointerEvent.pointerId;
                queuedPointerCaptures.set(_pointerId2, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(_pointerId2) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, _pointerEvent));
                return true;
        }
        return false;
    } // Check if this target is unblocked. Returns true if it's unblocked.
    function attemptExplicitHydrationTarget(queuedTarget) {
        // TODO: This function shares a lot of logic with findInstanceBlockingEvent.
        // Try to unify them. It's a bit tricky since it would require two return
        // values.
        var targetInst = getClosestInstanceFromNode(queuedTarget.target);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted !== null) {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) {
                        // We're blocked on hydrating this boundary.
                        // Increase its priority.
                        queuedTarget.blockedOn = instance;
                        attemptHydrationAtPriority(queuedTarget.priority, function() {
                            attemptHydrationAtCurrentPriority(nearestMounted);
                        });
                        return;
                    }
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (isRootDehydrated(root)) {
                        queuedTarget.blockedOn = getContainerFromFiber(nearestMounted); // We don't currently have a way to increase the priority of
                        // a root other than sync.
                        return;
                    }
                }
            }
        }
        queuedTarget.blockedOn = null;
    }
    function queueExplicitHydrationTarget(target) {
        // TODO: This will read the priority if it's dispatched by the React
        // event system but not native events. Should read window.event.type, like
        // we do for updates (getCurrentEventPriority).
        var updatePriority = getCurrentUpdatePriority$1();
        var queuedTarget = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        var i = 0;
        for(; i < queuedExplicitHydrationTargets.length; i++){
            // Stop once we hit the first target with lower priority than
            if (!isHigherEventPriority(updatePriority, queuedExplicitHydrationTargets[i].priority)) break;
        }
        queuedExplicitHydrationTargets.splice(i, 0, queuedTarget);
        if (i === 0) attemptExplicitHydrationTarget(queuedTarget);
    }
    function attemptReplayContinuousQueuedEvent(queuedEvent) {
        if (queuedEvent.blockedOn !== null) return false;
        var targetContainers = queuedEvent.targetContainers;
        while(targetContainers.length > 0){
            var targetContainer = targetContainers[0];
            var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.domEventName, queuedEvent.eventSystemFlags, targetContainer, queuedEvent.nativeEvent);
            if (nextBlockedOn === null) {
                var nativeEvent = queuedEvent.nativeEvent;
                var nativeEventClone = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                setReplayingEvent(nativeEventClone);
                nativeEvent.target.dispatchEvent(nativeEventClone);
                resetReplayingEvent();
            } else {
                // We're still blocked. Try again later.
                var _fiber3 = getInstanceFromNode(nextBlockedOn);
                if (_fiber3 !== null) attemptContinuousHydration(_fiber3);
                queuedEvent.blockedOn = nextBlockedOn;
                return false;
            } // This target container was successfully dispatched. Try the next.
            targetContainers.shift();
        }
        return true;
    }
    function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
        if (attemptReplayContinuousQueuedEvent(queuedEvent)) map.delete(key);
    }
    function replayUnblockedEvents() {
        hasScheduledReplayAttempt = false;
        if (queuedFocus !== null && attemptReplayContinuousQueuedEvent(queuedFocus)) queuedFocus = null;
        if (queuedDrag !== null && attemptReplayContinuousQueuedEvent(queuedDrag)) queuedDrag = null;
        if (queuedMouse !== null && attemptReplayContinuousQueuedEvent(queuedMouse)) queuedMouse = null;
        queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
        queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
    }
    function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
        if (queuedEvent.blockedOn === unblocked) {
            queuedEvent.blockedOn = null;
            if (!hasScheduledReplayAttempt) {
                hasScheduledReplayAttempt = true; // Schedule a callback to attempt replaying as many events as are
                // now unblocked. This first might not actually be unblocked yet.
                // We could check it early to avoid scheduling an unnecessary callback.
                Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents);
            }
        }
    }
    function retryIfBlockedOn(unblocked) {
        // Mark anything that was blocked on this as no longer blocked
        // and eligible for a replay.
        if (queuedDiscreteEvents.length > 0) {
            scheduleCallbackIfUnblocked(queuedDiscreteEvents[0], unblocked); // This is a exponential search for each boundary that commits. I think it's
            // worth it because we expect very few discrete events to queue up and once
            // we are actually fully unblocked it will be fast to replay them.
            for(var i = 1; i < queuedDiscreteEvents.length; i++){
                var queuedEvent = queuedDiscreteEvents[i];
                if (queuedEvent.blockedOn === unblocked) queuedEvent.blockedOn = null;
            }
        }
        if (queuedFocus !== null) scheduleCallbackIfUnblocked(queuedFocus, unblocked);
        if (queuedDrag !== null) scheduleCallbackIfUnblocked(queuedDrag, unblocked);
        if (queuedMouse !== null) scheduleCallbackIfUnblocked(queuedMouse, unblocked);
        var unblock = function(queuedEvent) {
            return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
        };
        queuedPointers.forEach(unblock);
        queuedPointerCaptures.forEach(unblock);
        for(var _i = 0; _i < queuedExplicitHydrationTargets.length; _i++){
            var queuedTarget = queuedExplicitHydrationTargets[_i];
            if (queuedTarget.blockedOn === unblocked) queuedTarget.blockedOn = null;
        }
        while(queuedExplicitHydrationTargets.length > 0){
            var nextExplicitTarget = queuedExplicitHydrationTargets[0];
            if (nextExplicitTarget.blockedOn !== null) break;
            else {
                attemptExplicitHydrationTarget(nextExplicitTarget);
                if (nextExplicitTarget.blockedOn === null) // We're unblocked.
                queuedExplicitHydrationTargets.shift();
            }
        }
    }
    var ReactCurrentBatchConfig = ReactSharedInternals.ReactCurrentBatchConfig; // TODO: can we stop exporting these?
    var _enabled = true; // This is exported in FB builds for use by legacy FB layer infra.
    // We'd like to remove this but it's not clear if this is safe.
    function setEnabled(enabled) {
        _enabled = !!enabled;
    }
    function isEnabled() {
        return _enabled;
    }
    function createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags) {
        var eventPriority = getEventPriority(domEventName);
        var listenerWrapper;
        switch(eventPriority){
            case DiscreteEventPriority:
                listenerWrapper = dispatchDiscreteEvent;
                break;
            case ContinuousEventPriority:
                listenerWrapper = dispatchContinuousEvent;
                break;
            case DefaultEventPriority:
            default:
                listenerWrapper = dispatchEvent;
                break;
        }
        return listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    }
    function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;
        try {
            setCurrentUpdatePriority(DiscreteEventPriority);
            dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig.transition = prevTransition;
        }
    }
    function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig.transition;
        ReactCurrentBatchConfig.transition = null;
        try {
            setCurrentUpdatePriority(ContinuousEventPriority);
            dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig.transition = prevTransition;
        }
    }
    function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        if (!_enabled) return;
        dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent);
    }
    function dispatchEventWithEnableCapturePhaseSelectiveHydrationWithoutDiscreteEventReplay(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        var blockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
        if (blockedOn === null) {
            dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
            clearIfContinuousEvent(domEventName, nativeEvent);
            return;
        }
        if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) {
            nativeEvent.stopPropagation();
            return;
        } // We need to clear only if we didn't queue because
        // queueing is accumulative.
        clearIfContinuousEvent(domEventName, nativeEvent);
        if (eventSystemFlags & IS_CAPTURE_PHASE && isDiscreteEventThatRequiresHydration(domEventName)) {
            while(blockedOn !== null){
                var fiber = getInstanceFromNode(blockedOn);
                if (fiber !== null) attemptSynchronousHydration(fiber);
                var nextBlockedOn = findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent);
                if (nextBlockedOn === null) dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
                if (nextBlockedOn === blockedOn) break;
                blockedOn = nextBlockedOn;
            }
            if (blockedOn !== null) nativeEvent.stopPropagation();
            return;
        } // This is not replayable so we'll invoke it but without a target,
        // in case the event system needs to trace it.
        dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
    var return_targetInst = null; // Returns a SuspenseInstance or Container if it's blocked.
    // The return_targetInst field above is conceptually part of the return value.
    function findInstanceBlockingEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
        // TODO: Warn if _enabled is false.
        return_targetInst = null;
        var nativeEventTarget = getEventTarget(nativeEvent);
        var targetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (targetInst !== null) {
            var nearestMounted = getNearestMountedFiber(targetInst);
            if (nearestMounted === null) // This tree has been unmounted already. Dispatch without a target.
            targetInst = null;
            else {
                var tag = nearestMounted.tag;
                if (tag === SuspenseComponent) {
                    var instance = getSuspenseInstanceFromFiber(nearestMounted);
                    if (instance !== null) // Queue the event to be replayed later. Abort dispatching since we
                    // don't want this event dispatched twice through the event system.
                    // TODO: If this is the first discrete event in the queue. Schedule an increased
                    // priority for this boundary.
                    return instance;
                     // This shouldn't happen, something went wrong but to avoid blocking
                    // the whole system, dispatch the event without a target.
                    // TODO: Warn.
                    targetInst = null;
                } else if (tag === HostRoot) {
                    var root = nearestMounted.stateNode;
                    if (isRootDehydrated(root)) // If this happens during a replay something went wrong and it might block
                    // the whole system.
                    return getContainerFromFiber(nearestMounted);
                    targetInst = null;
                } else if (nearestMounted !== targetInst) // If we get an event (ex: img onload) before committing that
                // component's mount, ignore it for now (that is, treat it as if it was an
                // event on a non-React tree). We might also consider queueing events and
                // dispatching them after the mount.
                targetInst = null;
            }
        }
        return_targetInst = targetInst; // We're not blocked on anything.
        return null;
    }
    function getEventPriority(domEventName) {
        switch(domEventName){
            // Used by SimpleEventPlugin:
            case "cancel":
            case "click":
            case "close":
            case "contextmenu":
            case "copy":
            case "cut":
            case "auxclick":
            case "dblclick":
            case "dragend":
            case "dragstart":
            case "drop":
            case "focusin":
            case "focusout":
            case "input":
            case "invalid":
            case "keydown":
            case "keypress":
            case "keyup":
            case "mousedown":
            case "mouseup":
            case "paste":
            case "pause":
            case "play":
            case "pointercancel":
            case "pointerdown":
            case "pointerup":
            case "ratechange":
            case "reset":
            case "resize":
            case "seeked":
            case "submit":
            case "touchcancel":
            case "touchend":
            case "touchstart":
            case "volumechange":
            // eslint-disable-next-line no-fallthrough
            case "change":
            case "selectionchange":
            case "textInput":
            case "compositionstart":
            case "compositionend":
            case "compositionupdate":
            // eslint-disable-next-line no-fallthrough
            case "beforeblur":
            case "afterblur":
            // eslint-disable-next-line no-fallthrough
            case "beforeinput":
            case "blur":
            case "fullscreenchange":
            case "focus":
            case "hashchange":
            case "popstate":
            case "select":
            case "selectstart":
                return DiscreteEventPriority;
            case "drag":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "mousemove":
            case "mouseout":
            case "mouseover":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "scroll":
            case "toggle":
            case "touchmove":
            case "wheel":
            // eslint-disable-next-line no-fallthrough
            case "mouseenter":
            case "mouseleave":
            case "pointerenter":
            case "pointerleave":
                return ContinuousEventPriority;
            case "message":
                // We might be in the Scheduler callback.
                // Eventually this mechanism will be replaced by a check
                // of the current priority on the native scheduler.
                var schedulerPriority = getCurrentPriorityLevel();
                switch(schedulerPriority){
                    case ImmediatePriority:
                        return DiscreteEventPriority;
                    case UserBlockingPriority:
                        return ContinuousEventPriority;
                    case NormalPriority:
                    case LowPriority:
                        // TODO: Handle LowSchedulerPriority, somehow. Maybe the same lane as hydration.
                        return DefaultEventPriority;
                    case IdlePriority:
                        return IdleEventPriority;
                    default:
                        return DefaultEventPriority;
                }
            default:
                return DefaultEventPriority;
        }
    }
    function addEventBubbleListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, false);
        return listener;
    }
    function addEventCaptureListener(target, eventType, listener) {
        target.addEventListener(eventType, listener, true);
        return listener;
    }
    function addEventCaptureListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            capture: true,
            passive: passive
        });
        return listener;
    }
    function addEventBubbleListenerWithPassiveFlag(target, eventType, listener, passive) {
        target.addEventListener(eventType, listener, {
            passive: passive
        });
        return listener;
    }
    /**
 * These variables store information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 *
 */ var root = null;
    var startText = null;
    var fallbackText = null;
    function initialize(nativeEventTarget) {
        root = nativeEventTarget;
        startText = getText();
        return true;
    }
    function reset() {
        root = null;
        startText = null;
        fallbackText = null;
    }
    function getData() {
        if (fallbackText) return fallbackText;
        var start;
        var startValue = startText;
        var startLength = startValue.length;
        var end;
        var endValue = getText();
        var endLength = endValue.length;
        for(start = 0; start < startLength; start++){
            if (startValue[start] !== endValue[start]) break;
        }
        var minEnd = startLength - start;
        for(end = 1; end <= minEnd; end++){
            if (startValue[startLength - end] !== endValue[endLength - end]) break;
        }
        var sliceTail = end > 1 ? 1 - end : undefined;
        fallbackText = endValue.slice(start, sliceTail);
        return fallbackText;
    }
    function getText() {
        if ("value" in root) return root.value;
        return root.textContent;
    }
    /**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */ function getEventCharCode(nativeEvent) {
        var charCode;
        var keyCode = nativeEvent.keyCode;
        if ("charCode" in nativeEvent) {
            charCode = nativeEvent.charCode; // FF does not set `charCode` for the Enter-key, check against `keyCode`.
            if (charCode === 0 && keyCode === 13) charCode = 13;
        } else // IE8 does not implement `charCode`, but `keyCode` has the correct value.
        charCode = keyCode;
         // IE and Edge (on Windows) and Chrome / Safari (on Windows and Linux)
        // report Enter as charCode 10 when ctrl is pressed.
        if (charCode === 10) charCode = 13;
         // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
        // Must not discard the (non-)printable Enter-key.
        if (charCode >= 32 || charCode === 13) return charCode;
        return 0;
    }
    function functionThatReturnsTrue() {
        return true;
    }
    function functionThatReturnsFalse() {
        return false;
    } // This is intentionally a factory so that we have different returned constructors.
    // If we had a single constructor, it would be megamorphic and engines would deopt.
    function createSyntheticEvent(Interface) {
        /**
   * Synthetic events are dispatched by event plugins, typically in response to a
   * top-level event delegation handler.
   *
   * These systems should generally use pooling to reduce the frequency of garbage
   * collection. The system should check `isPersistent` to determine whether the
   * event should be released into the pool after being dispatched. Users that
   * need a persisted event should invoke `persist`.
   *
   * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
   * normalizing browser quirks. Subclasses do not necessarily have to implement a
   * DOM interface; custom application-specific events can also subclass this.
   */ function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
            this._reactName = reactName;
            this._targetInst = targetInst;
            this.type = reactEventType;
            this.nativeEvent = nativeEvent;
            this.target = nativeEventTarget;
            this.currentTarget = null;
            for(var _propName in Interface){
                if (!Interface.hasOwnProperty(_propName)) continue;
                var normalize = Interface[_propName];
                if (normalize) this[_propName] = normalize(nativeEvent);
                else this[_propName] = nativeEvent[_propName];
            }
            var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
            if (defaultPrevented) this.isDefaultPrevented = functionThatReturnsTrue;
            else this.isDefaultPrevented = functionThatReturnsFalse;
            this.isPropagationStopped = functionThatReturnsFalse;
            return this;
        }
        assign(SyntheticBaseEvent.prototype, {
            preventDefault: function() {
                this.defaultPrevented = true;
                var event = this.nativeEvent;
                if (!event) return;
                if (event.preventDefault) event.preventDefault(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.returnValue !== "unknown") event.returnValue = false;
                this.isDefaultPrevented = functionThatReturnsTrue;
            },
            stopPropagation: function() {
                var event = this.nativeEvent;
                if (!event) return;
                if (event.stopPropagation) event.stopPropagation(); // $FlowFixMe - flow is not aware of `unknown` in IE
                else if (typeof event.cancelBubble !== "unknown") // The ChangeEventPlugin registers a "propertychange" event for
                // IE. This event does not support bubbling or cancelling, and
                // any references to cancelBubble throw "Member not found".  A
                // typeof check of "unknown" circumvents this issue (and is also
                // IE specific).
                event.cancelBubble = true;
                this.isPropagationStopped = functionThatReturnsTrue;
            },
            /**
     * We release all dispatched `SyntheticEvent`s after each event loop, adding
     * them back into the pool. This allows a way to hold onto a reference that
     * won't be added back into the pool.
     */ persist: function() {},
            /**
     * Checks if this event should be released back into the pool.
     *
     * @return {boolean} True if this should not be released, false otherwise.
     */ isPersistent: functionThatReturnsTrue
        });
        return SyntheticBaseEvent;
    }
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var EventInterface = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function(event) {
            return event.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
    };
    var SyntheticEvent = createSyntheticEvent(EventInterface);
    var UIEventInterface = assign({}, EventInterface, {
        view: 0,
        detail: 0
    });
    var SyntheticUIEvent = createSyntheticEvent(UIEventInterface);
    var lastMovementX;
    var lastMovementY;
    var lastMouseEvent;
    function updateMouseMovementPolyfillState(event) {
        if (event !== lastMouseEvent) {
            if (lastMouseEvent && event.type === "mousemove") {
                lastMovementX = event.screenX - lastMouseEvent.screenX;
                lastMovementY = event.screenY - lastMouseEvent.screenY;
            } else {
                lastMovementX = 0;
                lastMovementY = 0;
            }
            lastMouseEvent = event;
        }
    }
    /**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var MouseEventInterface = assign({}, UIEventInterface, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: getEventModifierState,
        button: 0,
        buttons: 0,
        relatedTarget: function(event) {
            if (event.relatedTarget === undefined) return event.fromElement === event.srcElement ? event.toElement : event.fromElement;
            return event.relatedTarget;
        },
        movementX: function(event) {
            if ("movementX" in event) return event.movementX;
            updateMouseMovementPolyfillState(event);
            return lastMovementX;
        },
        movementY: function(event) {
            if ("movementY" in event) return event.movementY;
             // Don't need to call updateMouseMovementPolyfillState() here
            // because it's guaranteed to have already run when movementX
            // was copied.
            return lastMovementY;
        }
    });
    var SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface);
    /**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var DragEventInterface = assign({}, MouseEventInterface, {
        dataTransfer: 0
    });
    var SyntheticDragEvent = createSyntheticEvent(DragEventInterface);
    /**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var FocusEventInterface = assign({}, UIEventInterface, {
        relatedTarget: 0
    });
    var SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */ var AnimationEventInterface = assign({}, EventInterface, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */ var ClipboardEventInterface = assign({}, EventInterface, {
        clipboardData: function(event) {
            return "clipboardData" in event ? event.clipboardData : window.clipboardData;
        }
    });
    var SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */ var CompositionEventInterface = assign({}, EventInterface, {
        data: 0
    });
    var SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */ // Happens to share the same list for now.
    var SyntheticInputEvent = SyntheticCompositionEvent;
    /**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var normalizeKey = {
        Esc: "Escape",
        Spacebar: " ",
        Left: "ArrowLeft",
        Up: "ArrowUp",
        Right: "ArrowRight",
        Down: "ArrowDown",
        Del: "Delete",
        Win: "OS",
        Menu: "ContextMenu",
        Apps: "ContextMenu",
        Scroll: "ScrollLock",
        MozPrintableKey: "Unidentified"
    };
    /**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */ var translateToKey = {
        "8": "Backspace",
        "9": "Tab",
        "12": "Clear",
        "13": "Enter",
        "16": "Shift",
        "17": "Control",
        "18": "Alt",
        "19": "Pause",
        "20": "CapsLock",
        "27": "Escape",
        "32": " ",
        "33": "PageUp",
        "34": "PageDown",
        "35": "End",
        "36": "Home",
        "37": "ArrowLeft",
        "38": "ArrowUp",
        "39": "ArrowRight",
        "40": "ArrowDown",
        "45": "Insert",
        "46": "Delete",
        "112": "F1",
        "113": "F2",
        "114": "F3",
        "115": "F4",
        "116": "F5",
        "117": "F6",
        "118": "F7",
        "119": "F8",
        "120": "F9",
        "121": "F10",
        "122": "F11",
        "123": "F12",
        "144": "NumLock",
        "145": "ScrollLock",
        "224": "Meta"
    };
    /**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */ function getEventKey(nativeEvent) {
        if (nativeEvent.key) {
            // Normalize inconsistent values reported by browsers due to
            // implementations of a working draft specification.
            // FireFox implements `key` but returns `MozPrintableKey` for all
            // printable characters (normalized to `Unidentified`), ignore it.
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if (key !== "Unidentified") return key;
        } // Browser does not implement `key`, polyfill as much of it as we can.
        if (nativeEvent.type === "keypress") {
            var charCode = getEventCharCode(nativeEvent); // The enter-key is technically both printable and non-printable and can
            // thus be captured by `keypress`, no other non-printable key should.
            return charCode === 13 ? "Enter" : String.fromCharCode(charCode);
        }
        if (nativeEvent.type === "keydown" || nativeEvent.type === "keyup") // While user keyboard layout determines the actual meaning of each
        // `keyCode` value, almost all function keys have a universal value.
        return translateToKey[nativeEvent.keyCode] || "Unidentified";
        return "";
    }
    /**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */ var modifierKeyToProp = {
        Alt: "altKey",
        Control: "ctrlKey",
        Meta: "metaKey",
        Shift: "shiftKey"
    }; // Older browsers (Safari <= 10, iOS Safari <= 10.2) do not support
    // getModifierState. If getModifierState is not supported, we map it to a set of
    // modifier keys exposed by the event. In this case, Lock-keys are not supported.
    function modifierStateGetter(keyArg) {
        var syntheticEvent = this;
        var nativeEvent = syntheticEvent.nativeEvent;
        if (nativeEvent.getModifierState) return nativeEvent.getModifierState(keyArg);
        var keyProp = modifierKeyToProp[keyArg];
        return keyProp ? !!nativeEvent[keyProp] : false;
    }
    function getEventModifierState(nativeEvent) {
        return modifierStateGetter;
    }
    /**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var KeyboardEventInterface = assign({}, UIEventInterface, {
        key: getEventKey,
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: getEventModifierState,
        // Legacy Interface
        charCode: function(event) {
            // `charCode` is the result of a KeyPress event and represents the value of
            // the actual printable character.
            // KeyPress is deprecated, but its replacement is not yet final and not
            // implemented in any major browser. Only KeyPress has charCode.
            if (event.type === "keypress") return getEventCharCode(event);
            return 0;
        },
        keyCode: function(event) {
            // `keyCode` is the result of a KeyDown/Up event and represents the value of
            // physical keyboard key.
            // The actual meaning of the value depends on the users' keyboard layout
            // which cannot be detected. Assuming that it is a US keyboard layout
            // provides a surprisingly accurate mapping for US and European users.
            // Due to this, it is left to the user to implement at this time.
            if (event.type === "keydown" || event.type === "keyup") return event.keyCode;
            return 0;
        },
        which: function(event) {
            // `which` is an alias for either `keyCode` or `charCode` depending on the
            // type of the event.
            if (event.type === "keypress") return getEventCharCode(event);
            if (event.type === "keydown" || event.type === "keyup") return event.keyCode;
            return 0;
        }
    });
    var SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface);
    /**
 * @interface PointerEvent
 * @see http://www.w3.org/TR/pointerevents/
 */ var PointerEventInterface = assign({}, MouseEventInterface, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
    });
    var SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface);
    /**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */ var TouchEventInterface = assign({}, UIEventInterface, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: getEventModifierState
    });
    var SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface);
    /**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */ var TransitionEventInterface = assign({}, EventInterface, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
    });
    var SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface);
    /**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */ var WheelEventInterface = assign({}, MouseEventInterface, {
        deltaX: function(event) {
            return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
        },
        deltaY: function(event) {
            return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
        },
        deltaZ: 0,
        // Browsers without "deltaMode" is reporting in raw wheel delta where one
        // notch on the scroll is always +/- 120, roughly equivalent to pixels.
        // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
        // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
        deltaMode: 0
    });
    var SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface);
    var END_KEYCODES = [
        9,
        13,
        27,
        32
    ]; // Tab, Return, Esc, Space
    var START_KEYCODE = 229;
    var canUseCompositionEvent = canUseDOM && "CompositionEvent" in window;
    var documentMode = null;
    if (canUseDOM && "documentMode" in document) documentMode = document.documentMode;
     // Webkit offers a very useful `textInput` event that can be used to
    // directly represent `beforeInput`. The IE `textinput` event is not as
    // useful, so we don't use it.
    var canUseTextInputEvent = canUseDOM && "TextEvent" in window && !documentMode; // In IE9+, we have access to composition events, but the data supplied
    // by the native compositionend event may be incorrect. Japanese ideographic
    // spaces, for instance (\u3000) are not recorded correctly.
    var useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
    var SPACEBAR_CODE = 32;
    var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
    function registerEvents() {
        registerTwoPhaseEvent("onBeforeInput", [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]);
        registerTwoPhaseEvent("onCompositionEnd", [
            "compositionend",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
        registerTwoPhaseEvent("onCompositionStart", [
            "compositionstart",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
        registerTwoPhaseEvent("onCompositionUpdate", [
            "compositionupdate",
            "focusout",
            "keydown",
            "keypress",
            "keyup",
            "mousedown"
        ]);
    } // Track whether we've ever handled a keypress on the space key.
    var hasSpaceKeypress = false;
    /**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */ function isKeypressCommand(nativeEvent) {
        return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
        !(nativeEvent.ctrlKey && nativeEvent.altKey);
    }
    /**
 * Translate native top level events into event types.
 */ function getCompositionEventType(domEventName) {
        switch(domEventName){
            case "compositionstart":
                return "onCompositionStart";
            case "compositionend":
                return "onCompositionEnd";
            case "compositionupdate":
                return "onCompositionUpdate";
        }
    }
    /**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 */ function isFallbackCompositionStart(domEventName, nativeEvent) {
        return domEventName === "keydown" && nativeEvent.keyCode === START_KEYCODE;
    }
    /**
 * Does our fallback mode think that this event is the end of composition?
 */ function isFallbackCompositionEnd(domEventName, nativeEvent) {
        switch(domEventName){
            case "keyup":
                // Command keys insert or clear IME input.
                return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
            case "keydown":
                // Expect IME keyCode on each keydown. If we get any other
                // code we must have exited earlier.
                return nativeEvent.keyCode !== START_KEYCODE;
            case "keypress":
            case "mousedown":
            case "focusout":
                // Events are not possible without cancelling IME.
                return true;
            default:
                return false;
        }
    }
    /**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */ function getDataFromCustomEvent(nativeEvent) {
        var detail = nativeEvent.detail;
        if (typeof detail === "object" && "data" in detail) return detail.data;
        return null;
    }
    /**
 * Check if a composition event was triggered by Korean IME.
 * Our fallback mode does not work well with IE's Korean IME,
 * so just use native composition events when Korean IME is used.
 * Although CompositionEvent.locale property is deprecated,
 * it is available in IE, where our fallback mode is enabled.
 *
 * @param {object} nativeEvent
 * @return {boolean}
 */ function isUsingKoreanIME(nativeEvent) {
        return nativeEvent.locale === "ko";
    } // Track the current IME composition status, if any.
    var isComposing = false;
    /**
 * @return {?object} A SyntheticCompositionEvent.
 */ function extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var eventType;
        var fallbackData;
        if (canUseCompositionEvent) eventType = getCompositionEventType(domEventName);
        else if (!isComposing) {
            if (isFallbackCompositionStart(domEventName, nativeEvent)) eventType = "onCompositionStart";
        } else if (isFallbackCompositionEnd(domEventName, nativeEvent)) eventType = "onCompositionEnd";
        if (!eventType) return null;
        if (useFallbackCompositionData && !isUsingKoreanIME(nativeEvent)) {
            // The current composition is stored statically and must not be
            // overwritten while composition continues.
            if (!isComposing && eventType === "onCompositionStart") isComposing = initialize(nativeEventTarget);
            else if (eventType === "onCompositionEnd") {
                if (isComposing) fallbackData = getData();
            }
        }
        var listeners = accumulateTwoPhaseListeners(targetInst, eventType);
        if (listeners.length > 0) {
            var event = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            if (fallbackData) // Inject data generated from fallback path into the synthetic event.
            // This matches the property of native CompositionEventInterface.
            event.data = fallbackData;
            else {
                var customData = getDataFromCustomEvent(nativeEvent);
                if (customData !== null) event.data = customData;
            }
        }
    }
    function getNativeBeforeInputChars(domEventName, nativeEvent) {
        switch(domEventName){
            case "compositionend":
                return getDataFromCustomEvent(nativeEvent);
            case "keypress":
                /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */ var which = nativeEvent.which;
                if (which !== SPACEBAR_CODE) return null;
                hasSpaceKeypress = true;
                return SPACEBAR_CHAR;
            case "textInput":
                // Record the characters to be added to the DOM.
                var chars = nativeEvent.data; // If it's a spacebar character, assume that we have already handled
                // it at the keypress level and bail immediately. Android Chrome
                // doesn't give us keycodes, so we need to ignore it.
                if (chars === SPACEBAR_CHAR && hasSpaceKeypress) return null;
                return chars;
            default:
                // For other native event types, do nothing.
                return null;
        }
    }
    /**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 */ function getFallbackBeforeInputChars(domEventName, nativeEvent) {
        // If we are currently composing (IME) and using a fallback to do so,
        // try to extract the composed characters from the fallback object.
        // If composition event is available, we extract a string only at
        // compositionevent, otherwise extract it at fallback events.
        if (isComposing) {
            if (domEventName === "compositionend" || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent)) {
                var chars = getData();
                reset();
                isComposing = false;
                return chars;
            }
            return null;
        }
        switch(domEventName){
            case "paste":
                // If a paste event occurs after a keypress, throw out the input
                // chars. Paste events should not lead to BeforeInput events.
                return null;
            case "keypress":
                /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */ if (!isKeypressCommand(nativeEvent)) {
                    // IE fires the `keypress` event when a user types an emoji via
                    // Touch keyboard of Windows.  In such a case, the `char` property
                    // holds an emoji character like `\uD83D\uDE0A`.  Because its length
                    // is 2, the property `which` does not represent an emoji correctly.
                    // In such a case, we directly return the `char` property instead of
                    // using `which`.
                    if (nativeEvent.char && nativeEvent.char.length > 1) return nativeEvent.char;
                    else if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
                }
                return null;
            case "compositionend":
                return useFallbackCompositionData && !isUsingKoreanIME(nativeEvent) ? null : nativeEvent.data;
            default:
                return null;
        }
    }
    /**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */ function extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget) {
        var chars;
        if (canUseTextInputEvent) chars = getNativeBeforeInputChars(domEventName, nativeEvent);
        else chars = getFallbackBeforeInputChars(domEventName, nativeEvent);
         // If no characters are being inserted, no BeforeInput event should
        // be fired.
        if (!chars) return null;
        var listeners = accumulateTwoPhaseListeners(targetInst, "onBeforeInput");
        if (listeners.length > 0) {
            var event = new SyntheticInputEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
            event.data = chars;
        }
    }
    /**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */ function extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        extractCompositionEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        extractBeforeInputEvent(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
    }
    /**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */ var supportedInputTypes = {
        color: true,
        date: true,
        datetime: true,
        "datetime-local": true,
        email: true,
        month: true,
        number: true,
        password: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true
    };
    function isTextInputElement(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        if (nodeName === "input") return !!supportedInputTypes[elem.type];
        if (nodeName === "textarea") return true;
        return false;
    }
    /**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */ function isEventSupported(eventNameSuffix) {
        if (!canUseDOM) return false;
        var eventName = "on" + eventNameSuffix;
        var isSupported = eventName in document;
        if (!isSupported) {
            var element = document.createElement("div");
            element.setAttribute(eventName, "return;");
            isSupported = typeof element[eventName] === "function";
        }
        return isSupported;
    }
    function registerEvents$1() {
        registerTwoPhaseEvent("onChange", [
            "change",
            "click",
            "focusin",
            "focusout",
            "input",
            "keydown",
            "keyup",
            "selectionchange"
        ]);
    }
    function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
        // Flag this event loop as needing state restore.
        enqueueStateRestore(target);
        var listeners = accumulateTwoPhaseListeners(inst, "onChange");
        if (listeners.length > 0) {
            var event = new SyntheticEvent("onChange", "change", null, nativeEvent, target);
            dispatchQueue.push({
                event: event,
                listeners: listeners
            });
        }
    }
    /**
 * For IE shims
 */ var activeElement = null;
    var activeElementInst = null;
    /**
 * SECTION: handle `change` event
 */ function shouldUseChangeEvent(elem) {
        var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName === "select" || nodeName === "input" && elem.type === "file";
    }
    function manualDispatchChangeEvent(nativeEvent) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(dispatchQueue, activeElementInst, nativeEvent, getEventTarget(nativeEvent)); // If change and propertychange bubbled, we'd just bind to it like all the
        // other events and have it go through ReactBrowserEventEmitter. Since it
        // doesn't, we manually listen for the events and so we have to enqueue and
        // process the abstract event manually.
        //
        // Batching is necessary here in order to ensure that all event handlers run
        // before the next rerender (including event handlers attached to ancestor
        // elements instead of directly on the input). Without this, controlled
        // components don't work properly in conjunction with event bubbling because
        // the component is rerendered and the value reverted before all the event
        // handlers can run. See https://github.com/facebook/react/issues/708.
        batchedUpdates(runEventInBatch, dispatchQueue);
    }
    function runEventInBatch(dispatchQueue) {
        processDispatchQueue(dispatchQueue, 0);
    }
    function getInstIfValueChanged(targetInst) {
        var targetNode = getNodeFromInstance(targetInst);
        if (updateValueIfChanged(targetNode)) return targetInst;
    }
    function getTargetInstForChangeEvent(domEventName, targetInst) {
        if (domEventName === "change") return targetInst;
    }
    /**
 * SECTION: handle `input` event
 */ var isInputEventSupported = false;
    if (canUseDOM) // IE9 claims to support the input event but fails to trigger it when
    // deleting text, so we ignore its input events.
    isInputEventSupported = isEventSupported("input") && (!document.documentMode || document.documentMode > 9);
    /**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */ function startWatchingForValueChange(target, targetInst) {
        activeElement = target;
        activeElementInst = targetInst;
        activeElement.attachEvent("onpropertychange", handlePropertyChange);
    }
    /**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */ function stopWatchingForValueChange() {
        if (!activeElement) return;
        activeElement.detachEvent("onpropertychange", handlePropertyChange);
        activeElement = null;
        activeElementInst = null;
    }
    /**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */ function handlePropertyChange(nativeEvent) {
        if (nativeEvent.propertyName !== "value") return;
        if (getInstIfValueChanged(activeElementInst)) manualDispatchChangeEvent(nativeEvent);
    }
    function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
        if (domEventName === "focusin") {
            // In IE9, propertychange fires for most input events but is buggy and
            // doesn't fire when text is deleted, but conveniently, selectionchange
            // appears to fire in all of the remaining cases so we catch those and
            // forward the event if the value has changed
            // In either case, we don't want to call the event handler if the value
            // is changed from JS so we redefine a setter for `.value` that updates
            // our activeElementValue variable, allowing us to ignore those changes
            //
            // stopWatching() should be a noop here but we call it just in case we
            // missed a blur event somehow.
            stopWatchingForValueChange();
            startWatchingForValueChange(target, targetInst);
        } else if (domEventName === "focusout") stopWatchingForValueChange();
    } // For IE8 and IE9.
    function getTargetInstForInputEventPolyfill(domEventName, targetInst) {
        if (domEventName === "selectionchange" || domEventName === "keyup" || domEventName === "keydown") // On the selectionchange event, the target is just document which isn't
        // helpful for us so just check activeElement instead.
        //
        // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
        // propertychange on the first input event after setting `value` from a
        // script and fires only keydown, keypress, keyup. Catching keyup usually
        // gets it and catching keydown lets us fire an event for the first
        // keystroke if user does a key repeat (it'll be a little delayed: right
        // before the second keystroke). Other input methods (e.g., paste) seem to
        // fire selectionchange normally.
        return getInstIfValueChanged(activeElementInst);
    }
    /**
 * SECTION: handle `click` event
 */ function shouldUseClickEvent(elem) {
        // Use the `click` event to detect changes to checkbox and radio inputs.
        // This approach works across all browsers, whereas `change` does not fire
        // until `blur` in IE8.
        var nodeName = elem.nodeName;
        return nodeName && nodeName.toLowerCase() === "input" && (elem.type === "checkbox" || elem.type === "radio");
    }
    function getTargetInstForClickEvent(domEventName, targetInst) {
        if (domEventName === "click") return getInstIfValueChanged(targetInst);
    }
    function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
        if (domEventName === "input" || domEventName === "change") return getInstIfValueChanged(targetInst);
    }
    function handleControlledInputBlur(node) {
        var state = node._wrapperState;
        if (!state || !state.controlled || node.type !== "number") return;
        // If controlled, assign the value attribute to the current value on blur
        setDefaultValue(node, "number", node.value);
    }
    /**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */ function extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        var getTargetInstFunc, handleEventFunc;
        if (shouldUseChangeEvent(targetNode)) getTargetInstFunc = getTargetInstForChangeEvent;
        else if (isTextInputElement(targetNode)) {
            if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
            else {
                getTargetInstFunc = getTargetInstForInputEventPolyfill;
                handleEventFunc = handleEventsForInputEventPolyfill;
            }
        } else if (shouldUseClickEvent(targetNode)) getTargetInstFunc = getTargetInstForClickEvent;
        if (getTargetInstFunc) {
            var inst = getTargetInstFunc(domEventName, targetInst);
            if (inst) {
                createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, nativeEventTarget);
                return;
            }
        }
        if (handleEventFunc) handleEventFunc(domEventName, targetNode, targetInst);
         // When blurring, set the value attribute for number inputs
        if (domEventName === "focusout") handleControlledInputBlur(targetNode);
    }
    function registerEvents$2() {
        registerDirectEvent("onMouseEnter", [
            "mouseout",
            "mouseover"
        ]);
        registerDirectEvent("onMouseLeave", [
            "mouseout",
            "mouseover"
        ]);
        registerDirectEvent("onPointerEnter", [
            "pointerout",
            "pointerover"
        ]);
        registerDirectEvent("onPointerLeave", [
            "pointerout",
            "pointerover"
        ]);
    }
    /**
 * For almost every interaction we care about, there will be both a top-level
 * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
 * we do not extract duplicate events. However, moving the mouse into the
 * browser from outside will not fire a `mouseout` event. In this case, we use
 * the `mouseover` top-level event.
 */ function extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var isOverEvent = domEventName === "mouseover" || domEventName === "pointerover";
        var isOutEvent = domEventName === "mouseout" || domEventName === "pointerout";
        if (isOverEvent && !isReplayingEvent(nativeEvent)) {
            // If this is an over event with a target, we might have already dispatched
            // the event in the out event of the other target. If this is replayed,
            // then it's because we couldn't dispatch against this target previously
            // so we have to do it now instead.
            var related = nativeEvent.relatedTarget || nativeEvent.fromElement;
            if (related) {
                // If the related node is managed by React, we can assume that we have
                // already dispatched the corresponding events during its mouseout.
                if (getClosestInstanceFromNode(related) || isContainerMarkedAsRoot(related)) return;
            }
        }
        if (!isOutEvent && !isOverEvent) // Must not be a mouse or pointer in or out - ignoring.
        return;
        var win; // TODO: why is this nullable in the types but we read from it?
        if (nativeEventTarget.window === nativeEventTarget) // `nativeEventTarget` is probably a window object.
        win = nativeEventTarget;
        else {
            // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
            var doc = nativeEventTarget.ownerDocument;
            if (doc) win = doc.defaultView || doc.parentWindow;
            else win = window;
        }
        var from;
        var to;
        if (isOutEvent) {
            var _related = nativeEvent.relatedTarget || nativeEvent.toElement;
            from = targetInst;
            to = _related ? getClosestInstanceFromNode(_related) : null;
            if (to !== null) {
                var nearestMounted = getNearestMountedFiber(to);
                if (to !== nearestMounted || to.tag !== HostComponent && to.tag !== HostText) to = null;
            }
        } else {
            // Moving to a node from outside the window.
            from = null;
            to = targetInst;
        }
        if (from === to) // Nothing pertains to our managed components.
        return;
        var SyntheticEventCtor = SyntheticMouseEvent;
        var leaveEventType = "onMouseLeave";
        var enterEventType = "onMouseEnter";
        var eventTypePrefix = "mouse";
        if (domEventName === "pointerout" || domEventName === "pointerover") {
            SyntheticEventCtor = SyntheticPointerEvent;
            leaveEventType = "onPointerLeave";
            enterEventType = "onPointerEnter";
            eventTypePrefix = "pointer";
        }
        var fromNode = from == null ? win : getNodeFromInstance(from);
        var toNode = to == null ? win : getNodeFromInstance(to);
        var leave = new SyntheticEventCtor(leaveEventType, eventTypePrefix + "leave", from, nativeEvent, nativeEventTarget);
        leave.target = fromNode;
        leave.relatedTarget = toNode;
        var enter = null; // We should only process this nativeEvent if we are processing
        // the first ancestor. Next time, we will ignore the event.
        var nativeTargetInst = getClosestInstanceFromNode(nativeEventTarget);
        if (nativeTargetInst === targetInst) {
            var enterEvent = new SyntheticEventCtor(enterEventType, eventTypePrefix + "enter", to, nativeEvent, nativeEventTarget);
            enterEvent.target = toNode;
            enterEvent.relatedTarget = fromNode;
            enter = enterEvent;
        }
        accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leave, enter, from, to);
    }
    /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
    }
    var objectIs = typeof Object.is === "function" ? Object.is : is;
    /**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */ function shallowEqual(objA, objB) {
        if (objectIs(objA, objB)) return true;
        if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
        var keysA = Object.keys(objA);
        var keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(var i = 0; i < keysA.length; i++){
            var currentKey = keysA[i];
            if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) return false;
        }
        return true;
    }
    /**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */ function getLeafNode(node) {
        while(node && node.firstChild)node = node.firstChild;
        return node;
    }
    /**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */ function getSiblingNode(node) {
        while(node){
            if (node.nextSibling) return node.nextSibling;
            node = node.parentNode;
        }
    }
    /**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */ function getNodeForCharacterOffset(root, offset) {
        var node = getLeafNode(root);
        var nodeStart = 0;
        var nodeEnd = 0;
        while(node){
            if (node.nodeType === TEXT_NODE) {
                nodeEnd = nodeStart + node.textContent.length;
                if (nodeStart <= offset && nodeEnd >= offset) return {
                    node: node,
                    offset: offset - nodeStart
                };
                nodeStart = nodeEnd;
            }
            node = getLeafNode(getSiblingNode(node));
        }
    }
    /**
 * @param {DOMElement} outerNode
 * @return {?object}
 */ function getOffsets(outerNode) {
        var ownerDocument = outerNode.ownerDocument;
        var win = ownerDocument && ownerDocument.defaultView || window;
        var selection = win.getSelection && win.getSelection();
        if (!selection || selection.rangeCount === 0) return null;
        var anchorNode = selection.anchorNode, anchorOffset = selection.anchorOffset, focusNode = selection.focusNode, focusOffset = selection.focusOffset; // In Firefox, anchorNode and focusNode can be "anonymous divs", e.g. the
        // up/down buttons on an <input type="number">. Anonymous divs do not seem to
        // expose properties, triggering a "Permission denied error" if any of its
        // properties are accessed. The only seemingly possible way to avoid erroring
        // is to access a property that typically works for non-anonymous divs and
        // catch any error that may otherwise arise. See
        // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
        try {
            /* eslint-disable no-unused-expressions */ anchorNode.nodeType;
            focusNode.nodeType;
        /* eslint-enable no-unused-expressions */ } catch (e) {
            return null;
        }
        return getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset);
    }
    /**
 * Returns {start, end} where `start` is the character/codepoint index of
 * (anchorNode, anchorOffset) within the textContent of `outerNode`, and
 * `end` is the index of (focusNode, focusOffset).
 *
 * Returns null if you pass in garbage input but we should probably just crash.
 *
 * Exported only for testing.
 */ function getModernOffsetsFromPoints(outerNode, anchorNode, anchorOffset, focusNode, focusOffset) {
        var length = 0;
        var start = -1;
        var end = -1;
        var indexWithinAnchor = 0;
        var indexWithinFocus = 0;
        var node = outerNode;
        var parentNode = null;
        outer: while(true){
            var next = null;
            while(true){
                if (node === anchorNode && (anchorOffset === 0 || node.nodeType === TEXT_NODE)) start = length + anchorOffset;
                if (node === focusNode && (focusOffset === 0 || node.nodeType === TEXT_NODE)) end = length + focusOffset;
                if (node.nodeType === TEXT_NODE) length += node.nodeValue.length;
                if ((next = node.firstChild) === null) break;
                 // Moving from `node` to its first child `next`.
                parentNode = node;
                node = next;
            }
            while(true){
                if (node === outerNode) break outer;
                if (parentNode === anchorNode && ++indexWithinAnchor === anchorOffset) start = length;
                if (parentNode === focusNode && ++indexWithinFocus === focusOffset) end = length;
                if ((next = node.nextSibling) !== null) break;
                node = parentNode;
                parentNode = node.parentNode;
            } // Moving from `node` to its next sibling `next`.
            node = next;
        }
        if (start === -1 || end === -1) // This should never happen. (Would happen if the anchor/focus nodes aren't
        // actually inside the passed-in node.)
        return null;
        return {
            start: start,
            end: end
        };
    }
    /**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */ function setOffsets(node, offsets) {
        var doc = node.ownerDocument || document;
        var win = doc && doc.defaultView || window; // Edge fails with "Object expected" in some scenarios.
        // (For instance: TinyMCE editor used in a list component that supports pasting to add more,
        // fails when pasting 100+ items)
        if (!win.getSelection) return;
        var selection = win.getSelection();
        var length = node.textContent.length;
        var start = Math.min(offsets.start, length);
        var end = offsets.end === undefined ? start : Math.min(offsets.end, length); // IE 11 uses modern selection, but doesn't support the extend method.
        // Flip backward selections, so we can set with a single range.
        if (!selection.extend && start > end) {
            var temp = end;
            end = start;
            start = temp;
        }
        var startMarker = getNodeForCharacterOffset(node, start);
        var endMarker = getNodeForCharacterOffset(node, end);
        if (startMarker && endMarker) {
            if (selection.rangeCount === 1 && selection.anchorNode === startMarker.node && selection.anchorOffset === startMarker.offset && selection.focusNode === endMarker.node && selection.focusOffset === endMarker.offset) return;
            var range = doc.createRange();
            range.setStart(startMarker.node, startMarker.offset);
            selection.removeAllRanges();
            if (start > end) {
                selection.addRange(range);
                selection.extend(endMarker.node, endMarker.offset);
            } else {
                range.setEnd(endMarker.node, endMarker.offset);
                selection.addRange(range);
            }
        }
    }
    function isTextNode(node) {
        return node && node.nodeType === TEXT_NODE;
    }
    function containsNode(outerNode, innerNode) {
        if (!outerNode || !innerNode) return false;
        else if (outerNode === innerNode) return true;
        else if (isTextNode(outerNode)) return false;
        else if (isTextNode(innerNode)) return containsNode(outerNode, innerNode.parentNode);
        else if ("contains" in outerNode) return outerNode.contains(innerNode);
        else if (outerNode.compareDocumentPosition) return !!(outerNode.compareDocumentPosition(innerNode) & 16);
        else return false;
    }
    function isInDocument(node) {
        return node && node.ownerDocument && containsNode(node.ownerDocument.documentElement, node);
    }
    function isSameOriginFrame(iframe) {
        try {
            // Accessing the contentDocument of a HTMLIframeElement can cause the browser
            // to throw, e.g. if it has a cross-origin src attribute.
            // Safari will show an error in the console when the access results in "Blocked a frame with origin". e.g:
            // iframe.contentDocument.defaultView;
            // A safety way is to access one of the cross origin properties: Window or Location
            // Which might result in "SecurityError" DOM Exception and it is compatible to Safari.
            // https://html.spec.whatwg.org/multipage/browsers.html#integration-with-idl
            return typeof iframe.contentWindow.location.href === "string";
        } catch (err) {
            return false;
        }
    }
    function getActiveElementDeep() {
        var win = window;
        var element = getActiveElement();
        while(element instanceof win.HTMLIFrameElement){
            if (isSameOriginFrame(element)) win = element.contentWindow;
            else return element;
            element = getActiveElement(win.document);
        }
        return element;
    }
    /**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */ /**
 * @hasSelectionCapabilities: we get the element types that support selection
 * from https://html.spec.whatwg.org/#do-not-apply, looking at `selectionStart`
 * and `selectionEnd` rows.
 */ function hasSelectionCapabilities(elem) {
        var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
        return nodeName && (nodeName === "input" && (elem.type === "text" || elem.type === "search" || elem.type === "tel" || elem.type === "url" || elem.type === "password") || nodeName === "textarea" || elem.contentEditable === "true");
    }
    function getSelectionInformation() {
        var focusedElem = getActiveElementDeep();
        return {
            focusedElem: focusedElem,
            selectionRange: hasSelectionCapabilities(focusedElem) ? getSelection(focusedElem) : null
        };
    }
    /**
 * @restoreSelection: If any selection information was potentially lost,
 * restore it. This is useful when performing operations that could remove dom
 * nodes and place them back in, resulting in focus being lost.
 */ function restoreSelection(priorSelectionInformation) {
        var curFocusedElem = getActiveElementDeep();
        var priorFocusedElem = priorSelectionInformation.focusedElem;
        var priorSelectionRange = priorSelectionInformation.selectionRange;
        if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
            if (priorSelectionRange !== null && hasSelectionCapabilities(priorFocusedElem)) setSelection(priorFocusedElem, priorSelectionRange);
             // Focusing a node can change the scroll position, which is undesirable
            var ancestors = [];
            var ancestor = priorFocusedElem;
            while(ancestor = ancestor.parentNode)if (ancestor.nodeType === ELEMENT_NODE) ancestors.push({
                element: ancestor,
                left: ancestor.scrollLeft,
                top: ancestor.scrollTop
            });
            if (typeof priorFocusedElem.focus === "function") priorFocusedElem.focus();
            for(var i = 0; i < ancestors.length; i++){
                var info = ancestors[i];
                info.element.scrollLeft = info.left;
                info.element.scrollTop = info.top;
            }
        }
    }
    /**
 * @getSelection: Gets the selection bounds of a focused textarea, input or
 * contentEditable node.
 * -@input: Look up selection bounds of this input
 * -@return {start: selectionStart, end: selectionEnd}
 */ function getSelection(input) {
        var selection;
        if ("selectionStart" in input) // Modern browser with input or textarea.
        selection = {
            start: input.selectionStart,
            end: input.selectionEnd
        };
        else // Content editable or old IE textarea.
        selection = getOffsets(input);
        return selection || {
            start: 0,
            end: 0
        };
    }
    /**
 * @setSelection: Sets the selection bounds of a textarea or input and focuses
 * the input.
 * -@input     Set selection bounds of this input or textarea
 * -@offsets   Object of same form that is returned from get*
 */ function setSelection(input, offsets) {
        var start = offsets.start;
        var end = offsets.end;
        if (end === undefined) end = start;
        if ("selectionStart" in input) {
            input.selectionStart = start;
            input.selectionEnd = Math.min(end, input.value.length);
        } else setOffsets(input, offsets);
    }
    var skipSelectionChangeEvent = canUseDOM && "documentMode" in document && document.documentMode <= 11;
    function registerEvents$3() {
        registerTwoPhaseEvent("onSelect", [
            "focusout",
            "contextmenu",
            "dragend",
            "focusin",
            "keydown",
            "keyup",
            "mousedown",
            "mouseup",
            "selectionchange"
        ]);
    }
    var activeElement$1 = null;
    var activeElementInst$1 = null;
    var lastSelection = null;
    var mouseDown = false;
    /**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 */ function getSelection$1(node) {
        if ("selectionStart" in node && hasSelectionCapabilities(node)) return {
            start: node.selectionStart,
            end: node.selectionEnd
        };
        else {
            var win = node.ownerDocument && node.ownerDocument.defaultView || window;
            var selection = win.getSelection();
            return {
                anchorNode: selection.anchorNode,
                anchorOffset: selection.anchorOffset,
                focusNode: selection.focusNode,
                focusOffset: selection.focusOffset
            };
        }
    }
    /**
 * Get document associated with the event target.
 */ function getEventTargetDocument(eventTarget) {
        return eventTarget.window === eventTarget ? eventTarget.document : eventTarget.nodeType === DOCUMENT_NODE ? eventTarget : eventTarget.ownerDocument;
    }
    /**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @param {object} nativeEventTarget
 * @return {?SyntheticEvent}
 */ function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
        // Ensure we have the right element, and that the user is not dragging a
        // selection (this matches native `select` event behavior). In HTML5, select
        // fires only on input and textarea thus if there's no focused element we
        // won't dispatch.
        var doc = getEventTargetDocument(nativeEventTarget);
        if (mouseDown || activeElement$1 == null || activeElement$1 !== getActiveElement(doc)) return;
         // Only fire when selection has actually changed.
        var currentSelection = getSelection$1(activeElement$1);
        if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
            lastSelection = currentSelection;
            var listeners = accumulateTwoPhaseListeners(activeElementInst$1, "onSelect");
            if (listeners.length > 0) {
                var event = new SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget);
                dispatchQueue.push({
                    event: event,
                    listeners: listeners
                });
                event.target = activeElement$1;
            }
        }
    }
    /**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */ function extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var targetNode = targetInst ? getNodeFromInstance(targetInst) : window;
        switch(domEventName){
            // Track the input node that has focus.
            case "focusin":
                if (isTextInputElement(targetNode) || targetNode.contentEditable === "true") {
                    activeElement$1 = targetNode;
                    activeElementInst$1 = targetInst;
                    lastSelection = null;
                }
                break;
            case "focusout":
                activeElement$1 = null;
                activeElementInst$1 = null;
                lastSelection = null;
                break;
            // Don't fire the event while the user is dragging. This matches the
            // semantics of the native select event.
            case "mousedown":
                mouseDown = true;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                mouseDown = false;
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                break;
            // Chrome and IE fire non-standard event when selection is changed (and
            // sometimes when it hasn't). IE's event fires out of order with respect
            // to key and input events on deletion, so we discard it.
            //
            // Firefox doesn't support selectionchange, so check selection status
            // after each key entry. The selection changes after keydown and before
            // keyup, but we check on keydown as well in the case of holding down a
            // key, when multiple keydown events are fired but only one keyup is.
            // This is also our approach for IE handling, for the reason above.
            case "selectionchange":
                if (skipSelectionChangeEvent) break;
            // falls through
            case "keydown":
            case "keyup":
                constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
        }
    }
    /**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */ function makePrefixMap(styleProp, eventName) {
        var prefixes = {};
        prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
        prefixes["Webkit" + styleProp] = "webkit" + eventName;
        prefixes["Moz" + styleProp] = "moz" + eventName;
        return prefixes;
    }
    /**
 * A list of event names to a configurable list of vendor prefixes.
 */ var vendorPrefixes = {
        animationend: makePrefixMap("Animation", "AnimationEnd"),
        animationiteration: makePrefixMap("Animation", "AnimationIteration"),
        animationstart: makePrefixMap("Animation", "AnimationStart"),
        transitionend: makePrefixMap("Transition", "TransitionEnd")
    };
    /**
 * Event names that have already been detected and prefixed (if applicable).
 */ var prefixedEventNames = {};
    /**
 * Element to check for prefixes on.
 */ var style = {};
    /**
 * Bootstrap if a DOM exists.
 */ if (canUseDOM) {
        style = document.createElement("div").style; // On some platforms, in particular some releases of Android 4.x,
        // the un-prefixed "animation" and "transition" properties are defined on the
        // style object but the events that fire will still be prefixed, so we need
        // to check if the un-prefixed events are usable, and if not remove them from the map.
        if (!("AnimationEvent" in window)) {
            delete vendorPrefixes.animationend.animation;
            delete vendorPrefixes.animationiteration.animation;
            delete vendorPrefixes.animationstart.animation;
        } // Same as above
        if (!("TransitionEvent" in window)) delete vendorPrefixes.transitionend.transition;
    }
    /**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */ function getVendorPrefixedEventName(eventName) {
        if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
        else if (!vendorPrefixes[eventName]) return eventName;
        var prefixMap = vendorPrefixes[eventName];
        for(var styleProp in prefixMap){
            if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
        }
        return eventName;
    }
    var ANIMATION_END = getVendorPrefixedEventName("animationend");
    var ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration");
    var ANIMATION_START = getVendorPrefixedEventName("animationstart");
    var TRANSITION_END = getVendorPrefixedEventName("transitionend");
    var topLevelEventsToReactNames = new Map(); // NOTE: Capitalization is important in this list!
    //
    // E.g. it needs "pointerDown", not "pointerdown".
    // This is because we derive both React name ("onPointerDown")
    // and DOM name ("pointerdown") from the same list.
    //
    // Exceptions that don't match this convention are listed separately.
    //
    // prettier-ignore
    var simpleEventPluginEvents = [
        "abort",
        "auxClick",
        "cancel",
        "canPlay",
        "canPlayThrough",
        "click",
        "close",
        "contextMenu",
        "copy",
        "cut",
        "drag",
        "dragEnd",
        "dragEnter",
        "dragExit",
        "dragLeave",
        "dragOver",
        "dragStart",
        "drop",
        "durationChange",
        "emptied",
        "encrypted",
        "ended",
        "error",
        "gotPointerCapture",
        "input",
        "invalid",
        "keyDown",
        "keyPress",
        "keyUp",
        "load",
        "loadedData",
        "loadedMetadata",
        "loadStart",
        "lostPointerCapture",
        "mouseDown",
        "mouseMove",
        "mouseOut",
        "mouseOver",
        "mouseUp",
        "paste",
        "pause",
        "play",
        "playing",
        "pointerCancel",
        "pointerDown",
        "pointerMove",
        "pointerOut",
        "pointerOver",
        "pointerUp",
        "progress",
        "rateChange",
        "reset",
        "resize",
        "seeked",
        "seeking",
        "stalled",
        "submit",
        "suspend",
        "timeUpdate",
        "touchCancel",
        "touchEnd",
        "touchStart",
        "volumeChange",
        "scroll",
        "toggle",
        "touchMove",
        "waiting",
        "wheel"
    ];
    function registerSimpleEvent(domEventName, reactName) {
        topLevelEventsToReactNames.set(domEventName, reactName);
        registerTwoPhaseEvent(reactName, [
            domEventName
        ]);
    }
    function registerSimpleEvents() {
        for(var i = 0; i < simpleEventPluginEvents.length; i++){
            var eventName = simpleEventPluginEvents[i];
            var domEventName = eventName.toLowerCase();
            var capitalizedEvent = eventName[0].toUpperCase() + eventName.slice(1);
            registerSimpleEvent(domEventName, "on" + capitalizedEvent);
        } // Special cases where event names don't match.
        registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
        registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
        registerSimpleEvent(ANIMATION_START, "onAnimationStart");
        registerSimpleEvent("dblclick", "onDoubleClick");
        registerSimpleEvent("focusin", "onFocus");
        registerSimpleEvent("focusout", "onBlur");
        registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
    }
    function extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        var reactName = topLevelEventsToReactNames.get(domEventName);
        if (reactName === undefined) return;
        var SyntheticEventCtor = SyntheticEvent;
        var reactEventType = domEventName;
        switch(domEventName){
            case "keypress":
                // Firefox creates a keypress event for function keys too. This removes
                // the unwanted keypress events. Enter is however both printable and
                // non-printable. One would expect Tab to be as well (but it isn't).
                if (getEventCharCode(nativeEvent) === 0) return;
            /* falls through */ case "keydown":
            case "keyup":
                SyntheticEventCtor = SyntheticKeyboardEvent;
                break;
            case "focusin":
                reactEventType = "focus";
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "focusout":
                reactEventType = "blur";
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "beforeblur":
            case "afterblur":
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
            case "click":
                // Firefox creates a click event on right mouse clicks. This removes the
                // unwanted click events.
                if (nativeEvent.button === 2) return;
            /* falls through */ case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            /* falls through */ case "mouseout":
            case "mouseover":
            case "contextmenu":
                SyntheticEventCtor = SyntheticMouseEvent;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                SyntheticEventCtor = SyntheticDragEvent;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                SyntheticEventCtor = SyntheticTouchEvent;
                break;
            case ANIMATION_END:
            case ANIMATION_ITERATION:
            case ANIMATION_START:
                SyntheticEventCtor = SyntheticAnimationEvent;
                break;
            case TRANSITION_END:
                SyntheticEventCtor = SyntheticTransitionEvent;
                break;
            case "scroll":
                SyntheticEventCtor = SyntheticUIEvent;
                break;
            case "wheel":
                SyntheticEventCtor = SyntheticWheelEvent;
                break;
            case "copy":
            case "cut":
            case "paste":
                SyntheticEventCtor = SyntheticClipboardEvent;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                SyntheticEventCtor = SyntheticPointerEvent;
                break;
        }
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        // Some events don't bubble in the browser.
        // In the past, React has always bubbled them, but this can be surprising.
        // We're going to try aligning closer to the browser behavior by not bubbling
        // them in React either. We'll start by not bubbling onScroll, and then expand.
        var accumulateTargetOnly = !inCapturePhase && // TODO: ideally, we'd eventually add all events from
        // nonDelegatedEvents list in DOMPluginEventSystem.
        // Then we can remove this special list.
        // This is a breaking change that can wait until React 18.
        domEventName === "scroll";
        var _listeners = accumulateSinglePhaseListeners(targetInst, reactName, nativeEvent.type, inCapturePhase, accumulateTargetOnly);
        if (_listeners.length > 0) {
            // Intentionally create event lazily.
            var _event = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget);
            dispatchQueue.push({
                event: _event,
                listeners: _listeners
            });
        }
    }
    // TODO: remove top-level side effect.
    registerSimpleEvents();
    registerEvents$2();
    registerEvents$1();
    registerEvents$3();
    registerEvents();
    function extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags, targetContainer) {
        // TODO: we should remove the concept of a "SimpleEventPlugin".
        // This is the basic functionality of the event system. All
        // the other plugins are essentially polyfills. So the plugin
        // should probably be inlined somewhere and have its logic
        // be core the to event system. This would potentially allow
        // us to ship builds of React without the polyfilled plugins below.
        extractEvents$4(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        var shouldProcessPolyfillPlugins = (eventSystemFlags & SHOULD_NOT_PROCESS_POLYFILL_EVENT_PLUGINS) === 0; // We don't process these events unless we are in the
        // event's native "bubble" phase, which means that we're
        // not in the capture phase. That's because we emulate
        // the capture phase here still. This is a trade-off,
        // because in an ideal world we would not emulate and use
        // the phases properly, like we do with the SimpleEvent
        // plugin. However, the plugins below either expect
        // emulation (EnterLeave) or use state localized to that
        // plugin (BeforeInput, Change, Select). The state in
        // these modules complicates things, as you'll essentially
        // get the case where the capture phase event might change
        // state, only for the following bubble event to come in
        // later and not trigger anything as the state now
        // invalidates the heuristics of the event plugin. We
        // could alter all these plugins to work in such ways, but
        // that might cause other unknown side-effects that we
        // can't foresee right now.
        if (shouldProcessPolyfillPlugins) {
            extractEvents$2(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents$3(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
            extractEvents(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
    } // List of events that need to be individually attached to media elements.
    var mediaEventTypes = [
        "abort",
        "canplay",
        "canplaythrough",
        "durationchange",
        "emptied",
        "encrypted",
        "ended",
        "error",
        "loadeddata",
        "loadedmetadata",
        "loadstart",
        "pause",
        "play",
        "playing",
        "progress",
        "ratechange",
        "resize",
        "seeked",
        "seeking",
        "stalled",
        "suspend",
        "timeupdate",
        "volumechange",
        "waiting"
    ]; // We should not delegate these events to the container, but rather
    // set them on the actual target element itself. This is primarily
    // because these events do not consistently bubble in the DOM.
    var nonDelegatedEvents = new Set([
        "cancel",
        "close",
        "invalid",
        "load",
        "scroll",
        "toggle"
    ].concat(mediaEventTypes));
    function executeDispatch(event, listener, currentTarget) {
        var type = event.type || "unknown-event";
        event.currentTarget = currentTarget;
        invokeGuardedCallbackAndCatchFirstError(type, listener, undefined, event);
        event.currentTarget = null;
    }
    function processDispatchQueueItemsInOrder(event, dispatchListeners, inCapturePhase) {
        var previousInstance;
        if (inCapturePhase) for(var i = dispatchListeners.length - 1; i >= 0; i--){
            var _dispatchListeners$i = dispatchListeners[i], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget, listener = _dispatchListeners$i.listener;
            if (instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, listener, currentTarget);
            previousInstance = instance;
        }
        else for(var _i = 0; _i < dispatchListeners.length; _i++){
            var _dispatchListeners$_i = dispatchListeners[_i], _instance = _dispatchListeners$_i.instance, _currentTarget = _dispatchListeners$_i.currentTarget, _listener = _dispatchListeners$_i.listener;
            if (_instance !== previousInstance && event.isPropagationStopped()) return;
            executeDispatch(event, _listener, _currentTarget);
            previousInstance = _instance;
        }
    }
    function processDispatchQueue(dispatchQueue, eventSystemFlags) {
        var inCapturePhase = (eventSystemFlags & IS_CAPTURE_PHASE) !== 0;
        for(var i = 0; i < dispatchQueue.length; i++){
            var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event, listeners = _dispatchQueue$i.listeners;
            processDispatchQueueItemsInOrder(event, listeners, inCapturePhase); //  event system doesn't use pooling.
        } // This would be a good time to rethrow if any of the event handlers threw.
        rethrowCaughtError();
    }
    function dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var nativeEventTarget = getEventTarget(nativeEvent);
        var dispatchQueue = [];
        extractEvents$5(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget, eventSystemFlags);
        processDispatchQueue(dispatchQueue, eventSystemFlags);
    }
    function listenToNonDelegatedEvent(domEventName, targetElement) {
        if (!nonDelegatedEvents.has(domEventName)) error('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', domEventName);
        var isCapturePhaseListener = false;
        var listenerSet = getEventListenerSet(targetElement);
        var listenerSetKey = getListenerSetKey(domEventName, isCapturePhaseListener);
        if (!listenerSet.has(listenerSetKey)) {
            addTrappedEventListener(targetElement, domEventName, IS_NON_DELEGATED, isCapturePhaseListener);
            listenerSet.add(listenerSetKey);
        }
    }
    function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
        if (nonDelegatedEvents.has(domEventName) && !isCapturePhaseListener) error('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', domEventName);
        var eventSystemFlags = 0;
        if (isCapturePhaseListener) eventSystemFlags |= IS_CAPTURE_PHASE;
        addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
    } // This is only used by createEventHandle when the
    var listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
    function listenToAllSupportedEvents(rootContainerElement) {
        if (!rootContainerElement[listeningMarker]) {
            rootContainerElement[listeningMarker] = true;
            allNativeEvents.forEach(function(domEventName) {
                // We handle selectionchange separately because it
                // doesn't bubble and needs to be on the document.
                if (domEventName !== "selectionchange") {
                    if (!nonDelegatedEvents.has(domEventName)) listenToNativeEvent(domEventName, false, rootContainerElement);
                    listenToNativeEvent(domEventName, true, rootContainerElement);
                }
            });
            var ownerDocument = rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
            if (ownerDocument !== null) // The selectionchange event also needs deduplication
            // but it is attached to the document.
            {
                if (!ownerDocument[listeningMarker]) {
                    ownerDocument[listeningMarker] = true;
                    listenToNativeEvent("selectionchange", false, ownerDocument);
                }
            }
        }
    }
    function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener, isDeferredListenerForLegacyFBSupport) {
        var listener = createEventListenerWrapperWithPriority(targetContainer, domEventName, eventSystemFlags); // If passive option is not supported, then the event will be
        // active and not passive.
        var isPassiveListener = undefined;
        if (passiveBrowserEventsSupported) // Browsers introduced an intervention, making these events
        // passive by default on document. React doesn't bind them
        // to document anymore, but changing this now would undo
        // the performance wins from the change. So we emulate
        // the existing behavior manually on the roots now.
        // https://github.com/facebook/react/issues/19651
        {
            if (domEventName === "touchstart" || domEventName === "touchmove" || domEventName === "wheel") isPassiveListener = true;
        }
        targetContainer;
        var unsubscribeListener; // When legacyFBSupport is enabled, it's for when we
        if (isCapturePhaseListener) {
            if (isPassiveListener !== undefined) unsubscribeListener = addEventCaptureListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
            else unsubscribeListener = addEventCaptureListener(targetContainer, domEventName, listener);
        } else if (isPassiveListener !== undefined) unsubscribeListener = addEventBubbleListenerWithPassiveFlag(targetContainer, domEventName, listener, isPassiveListener);
        else unsubscribeListener = addEventBubbleListener(targetContainer, domEventName, listener);
    }
    function isMatchingRootContainer(grandContainer, targetContainer) {
        return grandContainer === targetContainer || grandContainer.nodeType === COMMENT_NODE && grandContainer.parentNode === targetContainer;
    }
    function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst, targetContainer) {
        var ancestorInst = targetInst;
        if ((eventSystemFlags & IS_EVENT_HANDLE_NON_MANAGED_NODE) === 0 && (eventSystemFlags & IS_NON_DELEGATED) === 0) {
            var targetContainerNode = targetContainer; // If we are using the legacy FB support flag, we
            if (targetInst !== null) {
                // The below logic attempts to work out if we need to change
                // the target fiber to a different ancestor. We had similar logic
                // in the legacy event system, except the big difference between
                // systems is that the modern event system now has an event listener
                // attached to each React Root and React Portal Root. Together,
                // the DOM nodes representing these roots are the "rootContainer".
                // To figure out which ancestor instance we should use, we traverse
                // up the fiber tree from the target instance and attempt to find
                // root boundaries that match that of our current "rootContainer".
                // If we find that "rootContainer", we find the parent fiber
                // sub-tree for that root and make that our ancestor instance.
                var node = targetInst;
                mainLoop: while(true){
                    if (node === null) return;
                    var nodeTag = node.tag;
                    if (nodeTag === HostRoot || nodeTag === HostPortal) {
                        var container = node.stateNode.containerInfo;
                        if (isMatchingRootContainer(container, targetContainerNode)) break;
                        if (nodeTag === HostPortal) {
                            // The target is a portal, but it's not the rootContainer we're looking for.
                            // Normally portals handle their own events all the way down to the root.
                            // So we should be able to stop now. However, we don't know if this portal
                            // was part of *our* root.
                            var grandNode = node.return;
                            while(grandNode !== null){
                                var grandTag = grandNode.tag;
                                if (grandTag === HostRoot || grandTag === HostPortal) {
                                    var grandContainer = grandNode.stateNode.containerInfo;
                                    if (isMatchingRootContainer(grandContainer, targetContainerNode)) // This is the rootContainer we're looking for and we found it as
                                    // a parent of the Portal. That means we can ignore it because the
                                    // Portal will bubble through to us.
                                    return;
                                }
                                grandNode = grandNode.return;
                            }
                        } // Now we need to find it's corresponding host fiber in the other
                        // tree. To do this we can use getClosestInstanceFromNode, but we
                        // need to validate that the fiber is a host instance, otherwise
                        // we need to traverse up through the DOM till we find the correct
                        // node that is from the other tree.
                        while(container !== null){
                            var parentNode = getClosestInstanceFromNode(container);
                            if (parentNode === null) return;
                            var parentTag = parentNode.tag;
                            if (parentTag === HostComponent || parentTag === HostText) {
                                node = ancestorInst = parentNode;
                                continue mainLoop;
                            }
                            container = container.parentNode;
                        }
                    }
                    node = node.return;
                }
            }
        }
        batchedUpdates(function() {
            return dispatchEventsForPlugins(domEventName, eventSystemFlags, nativeEvent, ancestorInst);
        });
    }
    function createDispatchListener(instance, listener, currentTarget) {
        return {
            instance: instance,
            listener: listener,
            currentTarget: currentTarget
        };
    }
    function accumulateSinglePhaseListeners(targetFiber, reactName, nativeEventType, inCapturePhase, accumulateTargetOnly, nativeEvent) {
        var captureName = reactName !== null ? reactName + "Capture" : null;
        var reactEventName = inCapturePhase ? captureName : reactName;
        var listeners = [];
        var instance = targetFiber;
        var lastHostComponent = null; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance2 = instance, stateNode = _instance2.stateNode, tag = _instance2.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                lastHostComponent = stateNode; // createEventHandle listeners
                if (reactEventName !== null) {
                    var listener = getListener(instance, reactEventName);
                    if (listener != null) listeners.push(createDispatchListener(instance, listener, lastHostComponent));
                }
            } // If we are only accumulating events for the target, then we don't
            // continue to propagate through the React fiber tree to find other
            // listeners.
            if (accumulateTargetOnly) break;
             // If we are processing the onBeforeBlur event, then we need to take
            instance = instance.return;
        }
        return listeners;
    } // We should only use this function for:
    // - BeforeInputEventPlugin
    // - ChangeEventPlugin
    // - SelectEventPlugin
    // This is because we only process these plugins
    // in the bubble phase, so we need to accumulate two
    // phase event listeners (via emulation).
    function accumulateTwoPhaseListeners(targetFiber, reactName) {
        var captureName = reactName + "Capture";
        var listeners = [];
        var instance = targetFiber; // Accumulate all instances and listeners via the target -> root path.
        while(instance !== null){
            var _instance3 = instance, stateNode = _instance3.stateNode, tag = _instance3.tag; // Handle listeners that are on HostComponents (i.e. <div>)
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                var captureListener = getListener(instance, captureName);
                if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                var bubbleListener = getListener(instance, reactName);
                if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
            }
            instance = instance.return;
        }
        return listeners;
    }
    function getParent(inst) {
        if (inst === null) return null;
        do inst = inst.return; // TODO: If this is a HostRoot we might want to bail out.
        while (inst && inst.tag !== HostComponent);
        if (inst) return inst;
        return null;
    }
    /**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */ function getLowestCommonAncestor(instA, instB) {
        var nodeA = instA;
        var nodeB = instB;
        var depthA = 0;
        for(var tempA = nodeA; tempA; tempA = getParent(tempA))depthA++;
        var depthB = 0;
        for(var tempB = nodeB; tempB; tempB = getParent(tempB))depthB++;
         // If A is deeper, crawl up.
        while(depthA - depthB > 0){
            nodeA = getParent(nodeA);
            depthA--;
        } // If B is deeper, crawl up.
        while(depthB - depthA > 0){
            nodeB = getParent(nodeB);
            depthB--;
        } // Walk in lockstep until we find a match.
        var depth = depthA;
        while(depth--){
            if (nodeA === nodeB || nodeB !== null && nodeA === nodeB.alternate) return nodeA;
            nodeA = getParent(nodeA);
            nodeB = getParent(nodeB);
        }
        return null;
    }
    function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
        var registrationName = event._reactName;
        var listeners = [];
        var instance = target;
        while(instance !== null){
            if (instance === common) break;
            var _instance4 = instance, alternate = _instance4.alternate, stateNode = _instance4.stateNode, tag = _instance4.tag;
            if (alternate !== null && alternate === common) break;
            if (tag === HostComponent && stateNode !== null) {
                var currentTarget = stateNode;
                if (inCapturePhase) {
                    var captureListener = getListener(instance, registrationName);
                    if (captureListener != null) listeners.unshift(createDispatchListener(instance, captureListener, currentTarget));
                } else if (!inCapturePhase) {
                    var bubbleListener = getListener(instance, registrationName);
                    if (bubbleListener != null) listeners.push(createDispatchListener(instance, bubbleListener, currentTarget));
                }
            }
            instance = instance.return;
        }
        if (listeners.length !== 0) dispatchQueue.push({
            event: event,
            listeners: listeners
        });
    } // We should only use this function for:
    // - EnterLeaveEventPlugin
    // This is because we only process this plugin
    // in the bubble phase, so we need to accumulate two
    // phase event listeners.
    function accumulateEnterLeaveTwoPhaseListeners(dispatchQueue, leaveEvent, enterEvent, from, to) {
        var common = from && to ? getLowestCommonAncestor(from, to) : null;
        if (from !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, leaveEvent, from, common, false);
        if (to !== null && enterEvent !== null) accumulateEnterLeaveListenersForEvent(dispatchQueue, enterEvent, to, common, true);
    }
    function getListenerSetKey(domEventName, capture) {
        return domEventName + "__" + (capture ? "capture" : "bubble");
    }
    var didWarnInvalidHydration = false;
    var DANGEROUSLY_SET_INNER_HTML = "dangerouslySetInnerHTML";
    var SUPPRESS_CONTENT_EDITABLE_WARNING = "suppressContentEditableWarning";
    var SUPPRESS_HYDRATION_WARNING = "suppressHydrationWarning";
    var AUTOFOCUS = "autoFocus";
    var CHILDREN = "children";
    var STYLE = "style";
    var HTML$1 = "__html";
    var warnedUnknownTags;
    var validatePropertiesInDevelopment;
    var warnForPropDifference;
    var warnForExtraAttributes;
    var warnForInvalidEventListener;
    var canDiffStyleForHydrationWarning;
    var normalizeHTML;
    warnedUnknownTags = {
        // There are working polyfills for <dialog>. Let people use it.
        dialog: true,
        // Electron ships a custom <webview> tag to display external web content in
        // an isolated frame and process.
        // This tag is not present in non Electron environments such as JSDom which
        // is often used for testing purposes.
        // @see https://electronjs.org/docs/api/webview-tag
        webview: true
    };
    validatePropertiesInDevelopment = function(type, props) {
        validateProperties(type, props);
        validateProperties$1(type, props);
        validateProperties$2(type, props, {
            registrationNameDependencies: registrationNameDependencies,
            possibleRegistrationNames: possibleRegistrationNames
        });
    }; // IE 11 parses & normalizes the style attribute as opposed to other
    // browsers. It adds spaces and sorts the properties in some
    // non-alphabetical order. Handling that would require sorting CSS
    // properties in the client & server versions or applying
    // `expectedStyle` to a temporary DOM node to read its `style` attribute
    // normalized. Since it only affects IE, we're skipping style warnings
    // in that browser completely in favor of doing all that work.
    // See https://github.com/facebook/react/issues/11807
    canDiffStyleForHydrationWarning = canUseDOM && !document.documentMode;
    warnForPropDifference = function(propName, serverValue, clientValue) {
        if (didWarnInvalidHydration) return;
        var normalizedClientValue = normalizeMarkupForTextOrAttribute(clientValue);
        var normalizedServerValue = normalizeMarkupForTextOrAttribute(serverValue);
        if (normalizedServerValue === normalizedClientValue) return;
        didWarnInvalidHydration = true;
        error("Prop `%s` did not match. Server: %s Client: %s", propName, JSON.stringify(normalizedServerValue), JSON.stringify(normalizedClientValue));
    };
    warnForExtraAttributes = function(attributeNames) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        var names = [];
        attributeNames.forEach(function(name) {
            names.push(name);
        });
        error("Extra attributes from the server: %s", names);
    };
    warnForInvalidEventListener = function(registrationName, listener) {
        if (listener === false) error("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", registrationName, registrationName, registrationName);
        else error("Expected `%s` listener to be a function, instead got a value of `%s` type.", registrationName, typeof listener);
    }; // Parse the HTML and read it back to normalize the HTML string so that it
    // can be used for comparison.
    normalizeHTML = function(parent, html) {
        // We could have created a separate document here to avoid
        // re-initializing custom elements if they exist. But this breaks
        // how <noscript> is being handled. So we use the same document.
        // See the discussion in https://github.com/facebook/react/pull/11157.
        var testElement = parent.namespaceURI === HTML_NAMESPACE ? parent.ownerDocument.createElement(parent.tagName) : parent.ownerDocument.createElementNS(parent.namespaceURI, parent.tagName);
        testElement.innerHTML = html;
        return testElement.innerHTML;
    };
    // It also can turn \u0000 into \uFFFD inside attributes.
    // https://www.w3.org/TR/html5/single-page.html#preprocessing-the-input-stream
    // If we have a mismatch, it might be caused by that.
    // We will still patch up in this case but not fire the warning.
    var NORMALIZE_NEWLINES_REGEX = /\r\n?/g;
    var NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
    function normalizeMarkupForTextOrAttribute(markup) {
        checkHtmlStringCoercion(markup);
        var markupString = typeof markup === "string" ? markup : "" + markup;
        return markupString.replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
    }
    function checkForUnmatchedText(serverText, clientText, isConcurrentMode, shouldWarnDev) {
        var normalizedClientText = normalizeMarkupForTextOrAttribute(clientText);
        var normalizedServerText = normalizeMarkupForTextOrAttribute(serverText);
        if (normalizedServerText === normalizedClientText) return;
        if (shouldWarnDev) {
            if (!didWarnInvalidHydration) {
                didWarnInvalidHydration = true;
                error('Text content did not match. Server: "%s" Client: "%s"', normalizedServerText, normalizedClientText);
            }
        }
        if (isConcurrentMode && enableClientRenderFallbackOnTextMismatch) // In concurrent roots, we throw when there's a text mismatch and revert to
        // client rendering, up to the nearest Suspense boundary.
        throw new Error("Text content does not match server-rendered HTML.");
    }
    function getOwnerDocumentFromRootContainer(rootContainerElement) {
        return rootContainerElement.nodeType === DOCUMENT_NODE ? rootContainerElement : rootContainerElement.ownerDocument;
    }
    function noop() {}
    function trapClickOnNonInteractiveElement(node) {
        // Mobile Safari does not fire properly bubble click events on
        // non-interactive elements, which means delegated click listeners do not
        // fire. The workaround for this bug involves attaching an empty click
        // listener on the target node.
        // https://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
        // Just set it using the onclick property so that we don't have to manage any
        // bookkeeping for it. Not sure if we need to clear it when the listener is
        // removed.
        // TODO: Only do this for the relevant Safaris maybe?
        node.onclick = noop;
    }
    function setInitialDOMProperties(tag, domElement, rootContainerElement, nextProps, isCustomComponentTag) {
        for(var propKey in nextProps){
            if (!nextProps.hasOwnProperty(propKey)) continue;
            var nextProp = nextProps[propKey];
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                setValueForStyles(domElement, nextProp);
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                if (nextHtml != null) setInnerHTML(domElement, nextHtml);
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === "string") {
                    // Avoid setting initial textContent when the text is empty. In IE11 setting
                    // textContent on a <textarea> will cause the placeholder to not
                    // show within the <textarea> until it has been focused and blurred again.
                    // https://github.com/facebook/react/issues/6731#issuecomment-254874553
                    var canSetTextContent = tag !== "textarea" || nextProp !== "";
                    if (canSetTextContent) setTextContent(domElement, nextProp);
                } else if (typeof nextProp === "number") setTextContent(domElement, "" + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
            } else if (nextProp != null) setValueForProperty(domElement, propKey, nextProp, isCustomComponentTag);
        }
    }
    function updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag) {
        // TODO: Handle wasCustomComponentTag
        for(var i = 0; i < updatePayload.length; i += 2){
            var propKey = updatePayload[i];
            var propValue = updatePayload[i + 1];
            if (propKey === STYLE) setValueForStyles(domElement, propValue);
            else if (propKey === DANGEROUSLY_SET_INNER_HTML) setInnerHTML(domElement, propValue);
            else if (propKey === CHILDREN) setTextContent(domElement, propValue);
            else setValueForProperty(domElement, propKey, propValue, isCustomComponentTag);
        }
    }
    function createElement(type, props, rootContainerElement, parentNamespace) {
        var isCustomComponentTag; // We create tags in the namespace of their parent container, except HTML
        // tags get no namespace.
        var ownerDocument = getOwnerDocumentFromRootContainer(rootContainerElement);
        var domElement;
        var namespaceURI = parentNamespace;
        if (namespaceURI === HTML_NAMESPACE) namespaceURI = getIntrinsicNamespace(type);
        if (namespaceURI === HTML_NAMESPACE) {
            isCustomComponentTag = isCustomComponent(type, props); // Should this check be gated by parent namespace? Not sure we want to
            // allow <SVG> or <mATH>.
            if (!isCustomComponentTag && type !== type.toLowerCase()) error("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", type);
            if (type === "script") {
                // Create the script via .innerHTML so its "parser-inserted" flag is
                // set to true and it does not execute
                var div = ownerDocument.createElement("div");
                div.innerHTML = "<script></script>"; // eslint-disable-line
                // This is guaranteed to yield a script element.
                var firstChild = div.firstChild;
                domElement = div.removeChild(firstChild);
            } else if (typeof props.is === "string") // $FlowIssue `createElement` should be updated for Web Components
            domElement = ownerDocument.createElement(type, {
                is: props.is
            });
            else {
                // Separate else branch instead of using `props.is || undefined` above because of a Firefox bug.
                // See discussion in https://github.com/facebook/react/pull/6896
                // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
                domElement = ownerDocument.createElement(type); // Normally attributes are assigned in `setInitialDOMProperties`, however the `multiple` and `size`
                // attributes on `select`s needs to be added before `option`s are inserted.
                // This prevents:
                // - a bug where the `select` does not scroll to the correct option because singular
                //  `select` elements automatically pick the first item #13222
                // - a bug where the `select` set the first item as selected despite the `size` attribute #14239
                // See https://github.com/facebook/react/issues/13222
                // and https://github.com/facebook/react/issues/14239
                if (type === "select") {
                    var node = domElement;
                    if (props.multiple) node.multiple = true;
                    else if (props.size) // Setting a size greater than 1 causes a select to behave like `multiple=true`, where
                    // it is possible that no option is selected.
                    //
                    // This is only necessary when a select in "single selection mode".
                    node.size = props.size;
                }
            }
        } else domElement = ownerDocument.createElementNS(namespaceURI, type);
        if (namespaceURI === HTML_NAMESPACE) {
            if (!isCustomComponentTag && Object.prototype.toString.call(domElement) === "[object HTMLUnknownElement]" && !hasOwnProperty.call(warnedUnknownTags, type)) {
                warnedUnknownTags[type] = true;
                error("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", type);
            }
        }
        return domElement;
    }
    function createTextNode(text, rootContainerElement) {
        return getOwnerDocumentFromRootContainer(rootContainerElement).createTextNode(text);
    }
    function setInitialProperties(domElement, tag, rawProps, rootContainerElement) {
        var isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        var props;
        switch(tag){
            case "dialog":
                listenToNonDelegatedEvent("cancel", domElement);
                listenToNonDelegatedEvent("close", domElement);
                props = rawProps;
                break;
            case "iframe":
            case "object":
            case "embed":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent("load", domElement);
                props = rawProps;
                break;
            case "video":
            case "audio":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                props = rawProps;
                break;
            case "source":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent("error", domElement);
                props = rawProps;
                break;
            case "img":
            case "image":
            case "link":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                props = rawProps;
                break;
            case "details":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent("toggle", domElement);
                props = rawProps;
                break;
            case "input":
                initWrapperState(domElement, rawProps);
                props = getHostProps(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "option":
                validateProps(domElement, rawProps);
                props = rawProps;
                break;
            case "select":
                initWrapperState$1(domElement, rawProps);
                props = getHostProps$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "textarea":
                initWrapperState$2(domElement, rawProps);
                props = getHostProps$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            default:
                props = rawProps;
        }
        assertValidProps(tag, props);
        setInitialDOMProperties(tag, domElement, rootContainerElement, props, isCustomComponentTag);
        switch(tag){
            case "input":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, false);
                break;
            case "textarea":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case "option":
                postMountWrapper$1(domElement, rawProps);
                break;
            case "select":
                postMountWrapper$2(domElement, rawProps);
                break;
            default:
                if (typeof props.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
    } // Calculate the diff between the two objects.
    function diffProperties(domElement, tag, lastRawProps, nextRawProps, rootContainerElement) {
        validatePropertiesInDevelopment(tag, nextRawProps);
        var updatePayload = null;
        var lastProps;
        var nextProps;
        switch(tag){
            case "input":
                lastProps = getHostProps(domElement, lastRawProps);
                nextProps = getHostProps(domElement, nextRawProps);
                updatePayload = [];
                break;
            case "select":
                lastProps = getHostProps$1(domElement, lastRawProps);
                nextProps = getHostProps$1(domElement, nextRawProps);
                updatePayload = [];
                break;
            case "textarea":
                lastProps = getHostProps$2(domElement, lastRawProps);
                nextProps = getHostProps$2(domElement, nextRawProps);
                updatePayload = [];
                break;
            default:
                lastProps = lastRawProps;
                nextProps = nextRawProps;
                if (typeof lastProps.onClick !== "function" && typeof nextProps.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        assertValidProps(tag, nextProps);
        var propKey;
        var styleName;
        var styleUpdates = null;
        for(propKey in lastProps){
            if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) continue;
            if (propKey === STYLE) {
                var lastStyle = lastProps[propKey];
                for(styleName in lastStyle)if (lastStyle.hasOwnProperty(styleName)) {
                    if (!styleUpdates) styleUpdates = {};
                    styleUpdates[styleName] = "";
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML || propKey === CHILDREN) ;
            else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (propKey === AUTOFOCUS) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) // This is a special case. If any listener updates we need to ensure
            // that the "current" fiber pointer gets updated so we need a commit
            // to update this element.
            {
                if (!updatePayload) updatePayload = [];
            } else // For all other deleted properties we add it to the queue. We use
            // the allowed property list in the commit phase instead.
            (updatePayload = updatePayload || []).push(propKey, null);
        }
        for(propKey in nextProps){
            var nextProp = nextProps[propKey];
            var lastProp = lastProps != null ? lastProps[propKey] : undefined;
            if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) continue;
            if (propKey === STYLE) {
                if (nextProp) // Freeze the next style object so that we can assume it won't be
                // mutated. We have already warned for this in the past.
                Object.freeze(nextProp);
                if (lastProp) {
                    // Unset styles on `lastProp` but not on `nextProp`.
                    for(styleName in lastProp)if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = "";
                    }
                     // Update styles that changed since `lastProp`.
                    for(styleName in nextProp)if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
                        if (!styleUpdates) styleUpdates = {};
                        styleUpdates[styleName] = nextProp[styleName];
                    }
                } else {
                    // Relies on `updateStylesByID` not mutating `styleUpdates`.
                    if (!styleUpdates) {
                        if (!updatePayload) updatePayload = [];
                        updatePayload.push(propKey, styleUpdates);
                    }
                    styleUpdates = nextProp;
                }
            } else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                var lastHtml = lastProp ? lastProp[HTML$1] : undefined;
                if (nextHtml != null) {
                    if (lastHtml !== nextHtml) (updatePayload = updatePayload || []).push(propKey, nextHtml);
                }
            } else if (propKey === CHILDREN) {
                if (typeof nextProp === "string" || typeof nextProp === "number") (updatePayload = updatePayload || []).push(propKey, "" + nextProp);
            } else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING) ;
            else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    // We eagerly listen to this even though we haven't committed yet.
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
                if (!updatePayload && lastProp !== nextProp) // This is a special case. If any listener updates we need to ensure
                // that the "current" props pointer gets updated so we need a commit
                // to update this element.
                updatePayload = [];
            } else // For any other property we always add it to the queue and then we
            // filter it out using the allowed property list during the commit.
            (updatePayload = updatePayload || []).push(propKey, nextProp);
        }
        if (styleUpdates) {
            validateShorthandPropertyCollisionInDev(styleUpdates, nextProps[STYLE]);
            (updatePayload = updatePayload || []).push(STYLE, styleUpdates);
        }
        return updatePayload;
    } // Apply the diff.
    function updateProperties(domElement, updatePayload, tag, lastRawProps, nextRawProps) {
        // Update checked *before* name.
        // In the middle of an update, it is possible to have multiple checked.
        // When a checked radio tries to change name, browser makes another radio's checked false.
        if (tag === "input" && nextRawProps.type === "radio" && nextRawProps.name != null) updateChecked(domElement, nextRawProps);
        var wasCustomComponentTag = isCustomComponent(tag, lastRawProps);
        var isCustomComponentTag = isCustomComponent(tag, nextRawProps); // Apply the diff.
        updateDOMProperties(domElement, updatePayload, wasCustomComponentTag, isCustomComponentTag); // TODO: Ensure that an update gets scheduled if any of the special props
        // changed.
        switch(tag){
            case "input":
                // Update the wrapper around inputs *after* updating props. This has to
                // happen after `updateDOMProperties`. Otherwise HTML5 input validations
                // raise warnings and prevent the new value from being assigned.
                updateWrapper(domElement, nextRawProps);
                break;
            case "textarea":
                updateWrapper$1(domElement, nextRawProps);
                break;
            case "select":
                // <select> value update needs to occur after <option> children
                // reconciliation
                postUpdateWrapper(domElement, nextRawProps);
                break;
        }
    }
    function getPossibleStandardName(propName) {
        var lowerCasedName = propName.toLowerCase();
        if (!possibleStandardNames.hasOwnProperty(lowerCasedName)) return null;
        return possibleStandardNames[lowerCasedName] || null;
    }
    function diffHydratedProperties(domElement, tag, rawProps, parentNamespace, rootContainerElement, isConcurrentMode, shouldWarnDev) {
        var isCustomComponentTag;
        var extraAttributeNames;
        isCustomComponentTag = isCustomComponent(tag, rawProps);
        validatePropertiesInDevelopment(tag, rawProps);
        switch(tag){
            case "dialog":
                listenToNonDelegatedEvent("cancel", domElement);
                listenToNonDelegatedEvent("close", domElement);
                break;
            case "iframe":
            case "object":
            case "embed":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the load event.
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "video":
            case "audio":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for all the media events.
                for(var i = 0; i < mediaEventTypes.length; i++)listenToNonDelegatedEvent(mediaEventTypes[i], domElement);
                break;
            case "source":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the error event.
                listenToNonDelegatedEvent("error", domElement);
                break;
            case "img":
            case "image":
            case "link":
                // We listen to these events in case to ensure emulated bubble
                // listeners still fire for error and load events.
                listenToNonDelegatedEvent("error", domElement);
                listenToNonDelegatedEvent("load", domElement);
                break;
            case "details":
                // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the toggle event.
                listenToNonDelegatedEvent("toggle", domElement);
                break;
            case "input":
                initWrapperState(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "option":
                validateProps(domElement, rawProps);
                break;
            case "select":
                initWrapperState$1(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
            case "textarea":
                initWrapperState$2(domElement, rawProps); // We listen to this event in case to ensure emulated bubble
                // listeners still fire for the invalid event.
                listenToNonDelegatedEvent("invalid", domElement);
                break;
        }
        assertValidProps(tag, rawProps);
        extraAttributeNames = new Set();
        var attributes = domElement.attributes;
        for(var _i = 0; _i < attributes.length; _i++){
            var name = attributes[_i].name.toLowerCase();
            switch(name){
                // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                case "value":
                    break;
                case "checked":
                    break;
                case "selected":
                    break;
                default:
                    // Intentionally use the original name.
                    // See discussion in https://github.com/facebook/react/pull/10676.
                    extraAttributeNames.add(attributes[_i].name);
            }
        }
        var updatePayload = null;
        for(var propKey in rawProps){
            if (!rawProps.hasOwnProperty(propKey)) continue;
            var nextProp = rawProps[propKey];
            if (propKey === CHILDREN) {
                // For text content children we compare against textContent. This
                // might match additional HTML that is hidden when we read it using
                // textContent. E.g. "foo" will match "f<span>oo</span>" but that still
                // satisfies our requirement. Our requirement is not to produce perfect
                // HTML and attributes. Ideally we should preserve structure but it's
                // ok not to if the visible content is still enough to indicate what
                // even listeners these nodes might be wired up to.
                // TODO: Warn if there is more than a single textNode as a child.
                // TODO: Should we use domElement.firstChild.nodeValue to compare?
                if (typeof nextProp === "string") {
                    if (domElement.textContent !== nextProp) {
                        if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                        updatePayload = [
                            CHILDREN,
                            nextProp
                        ];
                    }
                } else if (typeof nextProp === "number") {
                    if (domElement.textContent !== "" + nextProp) {
                        if (rawProps[SUPPRESS_HYDRATION_WARNING] !== true) checkForUnmatchedText(domElement.textContent, nextProp, isConcurrentMode, shouldWarnDev);
                        updatePayload = [
                            CHILDREN,
                            "" + nextProp
                        ];
                    }
                }
            } else if (registrationNameDependencies.hasOwnProperty(propKey)) {
                if (nextProp != null) {
                    if (typeof nextProp !== "function") warnForInvalidEventListener(propKey, nextProp);
                    if (propKey === "onScroll") listenToNonDelegatedEvent("scroll", domElement);
                }
            } else if (shouldWarnDev && true && // Convince Flow we've calculated it (it's DEV-only in this method.)
            typeof isCustomComponentTag === "boolean") {
                // Validate that the properties correspond to their expected values.
                var serverValue = void 0;
                var propertyInfo = isCustomComponentTag && enableCustomElementPropertySupport ? null : getPropertyInfo(propKey);
                if (rawProps[SUPPRESS_HYDRATION_WARNING] === true) ;
                else if (propKey === SUPPRESS_CONTENT_EDITABLE_WARNING || propKey === SUPPRESS_HYDRATION_WARNING || // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                propKey === "value" || propKey === "checked" || propKey === "selected") ;
                else if (propKey === DANGEROUSLY_SET_INNER_HTML) {
                    var serverHTML = domElement.innerHTML;
                    var nextHtml = nextProp ? nextProp[HTML$1] : undefined;
                    if (nextHtml != null) {
                        var expectedHTML = normalizeHTML(domElement, nextHtml);
                        if (expectedHTML !== serverHTML) warnForPropDifference(propKey, serverHTML, expectedHTML);
                    }
                } else if (propKey === STYLE) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey);
                    if (canDiffStyleForHydrationWarning) {
                        var expectedStyle = createDangerousStringForStyles(nextProp);
                        serverValue = domElement.getAttribute("style");
                        if (expectedStyle !== serverValue) warnForPropDifference(propKey, serverValue, expectedStyle);
                    }
                } else if (isCustomComponentTag && !enableCustomElementPropertySupport) {
                    // $FlowFixMe - Should be inferred as not undefined.
                    extraAttributeNames.delete(propKey.toLowerCase());
                    serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    if (nextProp !== serverValue) warnForPropDifference(propKey, serverValue, nextProp);
                } else if (!shouldIgnoreAttribute(propKey, propertyInfo, isCustomComponentTag) && !shouldRemoveAttribute(propKey, nextProp, propertyInfo, isCustomComponentTag)) {
                    var isMismatchDueToBadCasing = false;
                    if (propertyInfo !== null) {
                        // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propertyInfo.attributeName);
                        serverValue = getValueForProperty(domElement, propKey, nextProp, propertyInfo);
                    } else {
                        var ownNamespace = parentNamespace;
                        if (ownNamespace === HTML_NAMESPACE) ownNamespace = getIntrinsicNamespace(tag);
                        if (ownNamespace === HTML_NAMESPACE) // $FlowFixMe - Should be inferred as not undefined.
                        extraAttributeNames.delete(propKey.toLowerCase());
                        else {
                            var standardName = getPossibleStandardName(propKey);
                            if (standardName !== null && standardName !== propKey) {
                                // If an SVG prop is supplied with bad casing, it will
                                // be successfully parsed from HTML, but will produce a mismatch
                                // (and would be incorrectly rendered on the client).
                                // However, we already warn about bad casing elsewhere.
                                // So we'll skip the misleading extra mismatch warning in this case.
                                isMismatchDueToBadCasing = true; // $FlowFixMe - Should be inferred as not undefined.
                                extraAttributeNames.delete(standardName);
                            } // $FlowFixMe - Should be inferred as not undefined.
                            extraAttributeNames.delete(propKey);
                        }
                        serverValue = getValueForAttribute(domElement, propKey, nextProp);
                    }
                    var dontWarnCustomElement = enableCustomElementPropertySupport;
                    if (!dontWarnCustomElement && nextProp !== serverValue && !isMismatchDueToBadCasing) warnForPropDifference(propKey, serverValue, nextProp);
                }
            }
        }
        if (shouldWarnDev) {
            if (extraAttributeNames.size > 0 && rawProps[SUPPRESS_HYDRATION_WARNING] !== true) // $FlowFixMe - Should be inferred as not undefined.
            warnForExtraAttributes(extraAttributeNames);
        }
        switch(tag){
            case "input":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper(domElement, rawProps, true);
                break;
            case "textarea":
                // TODO: Make sure we check if this is still unmounted or do any clean
                // up necessary since we never stop tracking anymore.
                track(domElement);
                postMountWrapper$3(domElement);
                break;
            case "select":
            case "option":
                break;
            default:
                if (typeof rawProps.onClick === "function") // TODO: This cast may not be sound for SVG, MathML or custom elements.
                trapClickOnNonInteractiveElement(domElement);
                break;
        }
        return updatePayload;
    }
    function diffHydratedText(textNode, text, isConcurrentMode) {
        var isDifferent = textNode.nodeValue !== text;
        return isDifferent;
    }
    function warnForDeletedHydratableElement(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error("Did not expect server HTML to contain a <%s> in <%s>.", child.nodeName.toLowerCase(), parentNode.nodeName.toLowerCase());
    }
    function warnForDeletedHydratableText(parentNode, child) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Did not expect server HTML to contain the text node "%s" in <%s>.', child.nodeValue, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedElement(parentNode, tag, props) {
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error("Expected server HTML to contain a matching <%s> in <%s>.", tag, parentNode.nodeName.toLowerCase());
    }
    function warnForInsertedHydratedText(parentNode, text) {
        if (text === "") // We expect to insert empty text nodes since they're not represented in
        // the HTML.
        // TODO: Remove this special case if we can just avoid inserting empty
        // text nodes.
        return;
        if (didWarnInvalidHydration) return;
        didWarnInvalidHydration = true;
        error('Expected server HTML to contain a matching text node for "%s" in <%s>.', text, parentNode.nodeName.toLowerCase());
    }
    function restoreControlledState$3(domElement, tag, props) {
        switch(tag){
            case "input":
                restoreControlledState(domElement, props);
                return;
            case "textarea":
                restoreControlledState$2(domElement, props);
                return;
            case "select":
                restoreControlledState$1(domElement, props);
                return;
        }
    }
    var validateDOMNesting = function() {};
    var updatedAncestorInfo = function() {};
    // This validation code was written based on the HTML5 parsing spec:
    // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    //
    // Note: this does not catch all invalid nesting, nor does it try to (as it's
    // not clear what practical benefit doing so provides); instead, we warn only
    // for cases where the parser will give a parse tree differing from what React
    // intended. For example, <b><div></div></b> is invalid but we don't warn
    // because it still parses correctly; we do warn for other cases like nested
    // <p> tags where the beginning of the second element implicitly closes the
    // first, causing a confusing mess.
    // https://html.spec.whatwg.org/multipage/syntax.html#special
    var specialTags = [
        "address",
        "applet",
        "area",
        "article",
        "aside",
        "base",
        "basefont",
        "bgsound",
        "blockquote",
        "body",
        "br",
        "button",
        "caption",
        "center",
        "col",
        "colgroup",
        "dd",
        "details",
        "dir",
        "div",
        "dl",
        "dt",
        "embed",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "frame",
        "frameset",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "head",
        "header",
        "hgroup",
        "hr",
        "html",
        "iframe",
        "img",
        "input",
        "isindex",
        "li",
        "link",
        "listing",
        "main",
        "marquee",
        "menu",
        "menuitem",
        "meta",
        "nav",
        "noembed",
        "noframes",
        "noscript",
        "object",
        "ol",
        "p",
        "param",
        "plaintext",
        "pre",
        "script",
        "section",
        "select",
        "source",
        "style",
        "summary",
        "table",
        "tbody",
        "td",
        "template",
        "textarea",
        "tfoot",
        "th",
        "thead",
        "title",
        "tr",
        "track",
        "ul",
        "wbr",
        "xmp"
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
    var inScopeTags = [
        "applet",
        "caption",
        "html",
        "table",
        "td",
        "th",
        "marquee",
        "object",
        "template",
        // TODO: Distinguish by namespace here -- for <title>, including it here
        // errs on the side of fewer warnings
        "foreignObject",
        "desc",
        "title"
    ]; // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
    var buttonScopeTags = inScopeTags.concat([
        "button"
    ]); // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
    var impliedEndTags = [
        "dd",
        "dt",
        "li",
        "option",
        "optgroup",
        "p",
        "rp",
        "rt"
    ];
    var emptyAncestorInfo = {
        current: null,
        formTag: null,
        aTagInScope: null,
        buttonTagInScope: null,
        nobrTagInScope: null,
        pTagInButtonScope: null,
        listItemTagAutoclosing: null,
        dlItemTagAutoclosing: null
    };
    updatedAncestorInfo = function(oldInfo, tag) {
        var ancestorInfo = assign({}, oldInfo || emptyAncestorInfo);
        var info = {
            tag: tag
        };
        if (inScopeTags.indexOf(tag) !== -1) {
            ancestorInfo.aTagInScope = null;
            ancestorInfo.buttonTagInScope = null;
            ancestorInfo.nobrTagInScope = null;
        }
        if (buttonScopeTags.indexOf(tag) !== -1) ancestorInfo.pTagInButtonScope = null;
         // See rules for 'li', 'dd', 'dt' start tags in
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        if (specialTags.indexOf(tag) !== -1 && tag !== "address" && tag !== "div" && tag !== "p") {
            ancestorInfo.listItemTagAutoclosing = null;
            ancestorInfo.dlItemTagAutoclosing = null;
        }
        ancestorInfo.current = info;
        if (tag === "form") ancestorInfo.formTag = info;
        if (tag === "a") ancestorInfo.aTagInScope = info;
        if (tag === "button") ancestorInfo.buttonTagInScope = info;
        if (tag === "nobr") ancestorInfo.nobrTagInScope = info;
        if (tag === "p") ancestorInfo.pTagInButtonScope = info;
        if (tag === "li") ancestorInfo.listItemTagAutoclosing = info;
        if (tag === "dd" || tag === "dt") ancestorInfo.dlItemTagAutoclosing = info;
        return ancestorInfo;
    };
    /**
   * Returns whether
   */ var isTagValidWithParent = function(tag, parentTag) {
        // First, let's check if we're in an unusual parsing mode...
        switch(parentTag){
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
            case "select":
                return tag === "option" || tag === "optgroup" || tag === "#text";
            case "optgroup":
                return tag === "option" || tag === "#text";
            // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
            // but
            case "option":
                return tag === "#text";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
            // No special behavior since these rules fall back to "in body" mode for
            // all except special table nodes which cause bad parsing behavior anyway.
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
            case "tr":
                return tag === "th" || tag === "td" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
            case "tbody":
            case "thead":
            case "tfoot":
                return tag === "tr" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
            case "colgroup":
                return tag === "col" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
            case "table":
                return tag === "caption" || tag === "colgroup" || tag === "tbody" || tag === "tfoot" || tag === "thead" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
            case "head":
                return tag === "base" || tag === "basefont" || tag === "bgsound" || tag === "link" || tag === "meta" || tag === "title" || tag === "noscript" || tag === "noframes" || tag === "style" || tag === "script" || tag === "template";
            // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
            case "html":
                return tag === "head" || tag === "body" || tag === "frameset";
            case "frameset":
                return tag === "frame";
            case "#document":
                return tag === "html";
        } // Probably in the "in body" parsing mode, so we outlaw only tag combos
        // where the parsing rules cause implicit opens or closes to be added.
        // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
        switch(tag){
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return parentTag !== "h1" && parentTag !== "h2" && parentTag !== "h3" && parentTag !== "h4" && parentTag !== "h5" && parentTag !== "h6";
            case "rp":
            case "rt":
                return impliedEndTags.indexOf(parentTag) === -1;
            case "body":
            case "caption":
            case "col":
            case "colgroup":
            case "frameset":
            case "frame":
            case "head":
            case "html":
            case "tbody":
            case "td":
            case "tfoot":
            case "th":
            case "thead":
            case "tr":
                // These tags are only valid with a few parents that have special child
                // parsing rules -- if we're down here, then none of those matched and
                // so we allow it only if we don't know what the parent is, as all other
                // cases are invalid.
                return parentTag == null;
        }
        return true;
    };
    /**
   * Returns whether
   */ var findInvalidAncestorForTag = function(tag, ancestorInfo) {
        switch(tag){
            case "address":
            case "article":
            case "aside":
            case "blockquote":
            case "center":
            case "details":
            case "dialog":
            case "dir":
            case "div":
            case "dl":
            case "fieldset":
            case "figcaption":
            case "figure":
            case "footer":
            case "header":
            case "hgroup":
            case "main":
            case "menu":
            case "nav":
            case "ol":
            case "p":
            case "section":
            case "summary":
            case "ul":
            case "pre":
            case "listing":
            case "table":
            case "hr":
            case "xmp":
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
                return ancestorInfo.pTagInButtonScope;
            case "form":
                return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
            case "li":
                return ancestorInfo.listItemTagAutoclosing;
            case "dd":
            case "dt":
                return ancestorInfo.dlItemTagAutoclosing;
            case "button":
                return ancestorInfo.buttonTagInScope;
            case "a":
                // Spec says something about storing a list of markers, but it sounds
                // equivalent to this check.
                return ancestorInfo.aTagInScope;
            case "nobr":
                return ancestorInfo.nobrTagInScope;
        }
        return null;
    };
    var didWarn$1 = {};
    validateDOMNesting = function(childTag, childText, ancestorInfo) {
        ancestorInfo = ancestorInfo || emptyAncestorInfo;
        var parentInfo = ancestorInfo.current;
        var parentTag = parentInfo && parentInfo.tag;
        if (childText != null) {
            if (childTag != null) error("validateDOMNesting: when childText is passed, childTag should be null");
            childTag = "#text";
        }
        var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
        var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
        var invalidParentOrAncestor = invalidParent || invalidAncestor;
        if (!invalidParentOrAncestor) return;
        var ancestorTag = invalidParentOrAncestor.tag;
        var warnKey = !!invalidParent + "|" + childTag + "|" + ancestorTag;
        if (didWarn$1[warnKey]) return;
        didWarn$1[warnKey] = true;
        var tagDisplayName = childTag;
        var whitespaceInfo = "";
        if (childTag === "#text") {
            if (/\S/.test(childText)) tagDisplayName = "Text nodes";
            else {
                tagDisplayName = "Whitespace text nodes";
                whitespaceInfo = " Make sure you don't have any extra whitespace between tags on each line of your source code.";
            }
        } else tagDisplayName = "<" + childTag + ">";
        if (invalidParent) {
            var info = "";
            if (ancestorTag === "table" && childTag === "tr") info += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser.";
            error("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", tagDisplayName, ancestorTag, whitespaceInfo, info);
        } else error("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", tagDisplayName, ancestorTag);
    };
    var SUPPRESS_HYDRATION_WARNING$1 = "suppressHydrationWarning";
    var SUSPENSE_START_DATA = "$";
    var SUSPENSE_END_DATA = "/$";
    var SUSPENSE_PENDING_START_DATA = "$?";
    var SUSPENSE_FALLBACK_START_DATA = "$!";
    var STYLE$1 = "style";
    var eventsEnabled = null;
    var selectionInformation = null;
    function getRootHostContext(rootContainerInstance) {
        var type;
        var namespace;
        var nodeType = rootContainerInstance.nodeType;
        switch(nodeType){
            case DOCUMENT_NODE:
            case DOCUMENT_FRAGMENT_NODE:
                type = nodeType === DOCUMENT_NODE ? "#document" : "#fragment";
                var root = rootContainerInstance.documentElement;
                namespace = root ? root.namespaceURI : getChildNamespace(null, "");
                break;
            default:
                var container = nodeType === COMMENT_NODE ? rootContainerInstance.parentNode : rootContainerInstance;
                var ownNamespace = container.namespaceURI || null;
                type = container.tagName;
                namespace = getChildNamespace(ownNamespace, type);
                break;
        }
        var validatedTag = type.toLowerCase();
        var ancestorInfo = updatedAncestorInfo(null, validatedTag);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getChildHostContext(parentHostContext, type, rootContainerInstance) {
        var parentHostContextDev = parentHostContext;
        var namespace = getChildNamespace(parentHostContextDev.namespace, type);
        var ancestorInfo = updatedAncestorInfo(parentHostContextDev.ancestorInfo, type);
        return {
            namespace: namespace,
            ancestorInfo: ancestorInfo
        };
    }
    function getPublicInstance(instance) {
        return instance;
    }
    function prepareForCommit(containerInfo) {
        eventsEnabled = isEnabled();
        selectionInformation = getSelectionInformation();
        var activeInstance = null;
        setEnabled(false);
        return activeInstance;
    }
    function resetAfterCommit(containerInfo) {
        restoreSelection(selectionInformation);
        setEnabled(eventsEnabled);
        eventsEnabled = null;
        selectionInformation = null;
    }
    function createInstance(type, props, rootContainerInstance, hostContext, internalInstanceHandle) {
        var parentNamespace;
        // TODO: take namespace into account when validating.
        var hostContextDev = hostContext;
        validateDOMNesting(type, null, hostContextDev.ancestorInfo);
        if (typeof props.children === "string" || typeof props.children === "number") {
            var string = "" + props.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        parentNamespace = hostContextDev.namespace;
        var domElement = createElement(type, props, rootContainerInstance, parentNamespace);
        precacheFiberNode(internalInstanceHandle, domElement);
        updateFiberProps(domElement, props);
        return domElement;
    }
    function appendInitialChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function finalizeInitialChildren(domElement, type, props, rootContainerInstance, hostContext) {
        setInitialProperties(domElement, type, props, rootContainerInstance);
        switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                return !!props.autoFocus;
            case "img":
                return true;
            default:
                return false;
        }
    }
    function prepareUpdate(domElement, type, oldProps, newProps, rootContainerInstance, hostContext) {
        var hostContextDev = hostContext;
        if (typeof newProps.children !== typeof oldProps.children && (typeof newProps.children === "string" || typeof newProps.children === "number")) {
            var string = "" + newProps.children;
            var ownAncestorInfo = updatedAncestorInfo(hostContextDev.ancestorInfo, type);
            validateDOMNesting(null, string, ownAncestorInfo);
        }
        return diffProperties(domElement, type, oldProps, newProps);
    }
    function shouldSetTextContent(type, props) {
        return type === "textarea" || type === "noscript" || typeof props.children === "string" || typeof props.children === "number" || typeof props.dangerouslySetInnerHTML === "object" && props.dangerouslySetInnerHTML !== null && props.dangerouslySetInnerHTML.__html != null;
    }
    function createTextInstance(text, rootContainerInstance, hostContext, internalInstanceHandle) {
        var hostContextDev = hostContext;
        validateDOMNesting(null, text, hostContextDev.ancestorInfo);
        var textNode = createTextNode(text, rootContainerInstance);
        precacheFiberNode(internalInstanceHandle, textNode);
        return textNode;
    }
    function getCurrentEventPriority() {
        var currentEvent = window.event;
        if (currentEvent === undefined) return DefaultEventPriority;
        return getEventPriority(currentEvent.type);
    }
    // if a component just imports ReactDOM (e.g. for findDOMNode).
    // Some environments might not have setTimeout or clearTimeout.
    var scheduleTimeout = typeof setTimeout === "function" ? setTimeout : undefined;
    var cancelTimeout = typeof clearTimeout === "function" ? clearTimeout : undefined;
    var noTimeout = -1;
    var localPromise = typeof Promise === "function" ? Promise : undefined; // -------------------
    var scheduleMicrotask = typeof queueMicrotask === "function" ? queueMicrotask : typeof localPromise !== "undefined" ? function(callback) {
        return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
    } : scheduleTimeout; // TODO: Determine the best fallback here.
    function handleErrorInNextTick(error) {
        setTimeout(function() {
            throw error;
        });
    } // -------------------
    function commitMount(domElement, type, newProps, internalInstanceHandle) {
        // Despite the naming that might imply otherwise, this method only
        // fires if there is an `Update` effect scheduled during mounting.
        // This happens if `finalizeInitialChildren` returns `true` (which it
        // does to implement the `autoFocus` attribute on the client). But
        // there are also other cases when this might happen (such as patching
        // up text content during hydration mismatch). So we'll check this again.
        switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                if (newProps.autoFocus) domElement.focus();
                return;
            case "img":
                if (newProps.src) domElement.src = newProps.src;
                return;
        }
    }
    function commitUpdate(domElement, updatePayload, type, oldProps, newProps, internalInstanceHandle) {
        // Apply the diff to the DOM node.
        updateProperties(domElement, updatePayload, type, oldProps, newProps); // Update the props handle so that we know which props are the ones with
        // with current event handlers.
        updateFiberProps(domElement, newProps);
    }
    function resetTextContent(domElement) {
        setTextContent(domElement, "");
    }
    function commitTextUpdate(textInstance, oldText, newText) {
        textInstance.nodeValue = newText;
    }
    function appendChild(parentInstance, child) {
        parentInstance.appendChild(child);
    }
    function appendChildToContainer(container, child) {
        var parentNode;
        if (container.nodeType === COMMENT_NODE) {
            parentNode = container.parentNode;
            parentNode.insertBefore(child, container);
        } else {
            parentNode = container;
            parentNode.appendChild(child);
        } // This container might be used for a portal.
        // If something inside a portal is clicked, that click should bubble
        // through the React tree. However, on Mobile Safari the click would
        // never bubble through the *DOM* tree unless an ancestor with onclick
        // event exists. So we wouldn't see it and dispatch it.
        // This is why we ensure that non React root containers have inline onclick
        // defined.
        // https://github.com/facebook/react/issues/11918
        var reactRootContainer = container._reactRootContainer;
        if ((reactRootContainer === null || reactRootContainer === undefined) && parentNode.onclick === null) // TODO: This cast may not be sound for SVG, MathML or custom elements.
        trapClickOnNonInteractiveElement(parentNode);
    }
    function insertBefore(parentInstance, child, beforeChild) {
        parentInstance.insertBefore(child, beforeChild);
    }
    function insertInContainerBefore(container, child, beforeChild) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.insertBefore(child, beforeChild);
        else container.insertBefore(child, beforeChild);
    }
    function removeChild(parentInstance, child) {
        parentInstance.removeChild(child);
    }
    function removeChildFromContainer(container, child) {
        if (container.nodeType === COMMENT_NODE) container.parentNode.removeChild(child);
        else container.removeChild(child);
    }
    function clearSuspenseBoundary(parentInstance, suspenseInstance) {
        var node = suspenseInstance; // Delete all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        do {
            var nextNode = node.nextSibling;
            parentInstance.removeChild(node);
            if (nextNode && nextNode.nodeType === COMMENT_NODE) {
                var data = nextNode.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) {
                        parentInstance.removeChild(nextNode); // Retry if any event replaying was blocked on this.
                        retryIfBlockedOn(suspenseInstance);
                        return;
                    } else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_PENDING_START_DATA || data === SUSPENSE_FALLBACK_START_DATA) depth++;
            }
            node = nextNode;
        }while (node); // TODO: Warn, we didn't find the end comment boundary.
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function clearSuspenseBoundaryFromContainer(container, suspenseInstance) {
        if (container.nodeType === COMMENT_NODE) clearSuspenseBoundary(container.parentNode, suspenseInstance);
        else if (container.nodeType === ELEMENT_NODE) clearSuspenseBoundary(container, suspenseInstance);
         // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function hideInstance(instance) {
        // TODO: Does this work for all element types? What about MathML? Should we
        // pass host context to this method?
        instance;
        var style = instance.style;
        if (typeof style.setProperty === "function") style.setProperty("display", "none", "important");
        else style.display = "none";
    }
    function hideTextInstance(textInstance) {
        textInstance.nodeValue = "";
    }
    function unhideInstance(instance, props) {
        instance;
        var styleProp = props[STYLE$1];
        var display = styleProp !== undefined && styleProp !== null && styleProp.hasOwnProperty("display") ? styleProp.display : null;
        instance.style.display = dangerousStyleValue("display", display);
    }
    function unhideTextInstance(textInstance, text) {
        textInstance.nodeValue = text;
    }
    function clearContainer(container) {
        if (container.nodeType === ELEMENT_NODE) container.textContent = "";
        else if (container.nodeType === DOCUMENT_NODE) {
            if (container.documentElement) container.removeChild(container.documentElement);
        }
    } // -------------------
    function canHydrateInstance(instance, type, props) {
        if (instance.nodeType !== ELEMENT_NODE || type.toLowerCase() !== instance.nodeName.toLowerCase()) return null;
         // This has now been refined to an element node.
        return instance;
    }
    function canHydrateTextInstance(instance, text) {
        if (text === "" || instance.nodeType !== TEXT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a text node.
        return instance;
    }
    function canHydrateSuspenseInstance(instance) {
        if (instance.nodeType !== COMMENT_NODE) // Empty strings are not parsed by HTML so there won't be a correct match here.
        return null;
         // This has now been refined to a suspense node.
        return instance;
    }
    function isSuspenseInstancePending(instance) {
        return instance.data === SUSPENSE_PENDING_START_DATA;
    }
    function isSuspenseInstanceFallback(instance) {
        return instance.data === SUSPENSE_FALLBACK_START_DATA;
    }
    function getSuspenseInstanceFallbackErrorDetails(instance) {
        var dataset = instance.nextSibling && instance.nextSibling.dataset;
        var digest, message, stack;
        if (dataset) {
            digest = dataset.dgst;
            message = dataset.msg;
            stack = dataset.stck;
        }
        return {
            message: message,
            digest: digest,
            stack: stack
        };
    // const nextSibling = instance.nextSibling;
    // if (nextSibling) {
    //   const dataset = ((nextSibling: any): HTMLTemplateElement).dataset;
    //   value.message = dataset.msg;
    //   value.hash = dataset.hash;
    //   if (true) {
    //     value.stack = dataset.stack;
    //   }
    // }
    // return value;
    }
    function registerSuspenseInstanceRetry(instance, callback) {
        instance._reactRetry = callback;
    }
    function getNextHydratable(node) {
        // Skip non-hydratable nodes.
        for(; node != null; node = node.nextSibling){
            var nodeType = node.nodeType;
            if (nodeType === ELEMENT_NODE || nodeType === TEXT_NODE) break;
            if (nodeType === COMMENT_NODE) {
                var nodeData = node.data;
                if (nodeData === SUSPENSE_START_DATA || nodeData === SUSPENSE_FALLBACK_START_DATA || nodeData === SUSPENSE_PENDING_START_DATA) break;
                if (nodeData === SUSPENSE_END_DATA) return null;
            }
        }
        return node;
    }
    function getNextHydratableSibling(instance) {
        return getNextHydratable(instance.nextSibling);
    }
    function getFirstHydratableChild(parentInstance) {
        return getNextHydratable(parentInstance.firstChild);
    }
    function getFirstHydratableChildWithinContainer(parentContainer) {
        return getNextHydratable(parentContainer.firstChild);
    }
    function getFirstHydratableChildWithinSuspenseInstance(parentInstance) {
        return getNextHydratable(parentInstance.nextSibling);
    }
    function hydrateInstance(instance, type, props, rootContainerInstance, hostContext, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, instance); // TODO: Possibly defer this until the commit phase where all the events
        // get attached.
        updateFiberProps(instance, props);
        var parentNamespace;
        var hostContextDev = hostContext;
        parentNamespace = hostContextDev.namespace;
        // when the legacy root API is removed.
        var isConcurrentMode = (internalInstanceHandle.mode & ConcurrentMode) !== NoMode;
        return diffHydratedProperties(instance, type, props, parentNamespace, rootContainerInstance, isConcurrentMode, shouldWarnDev);
    }
    function hydrateTextInstance(textInstance, text, internalInstanceHandle, shouldWarnDev) {
        precacheFiberNode(internalInstanceHandle, textInstance); // TODO: Temporary hack to check if we're in a concurrent root. We can delete
        // when the legacy root API is removed.
        var isConcurrentMode = (internalInstanceHandle.mode & ConcurrentMode) !== NoMode;
        return diffHydratedText(textInstance, text);
    }
    function hydrateSuspenseInstance(suspenseInstance, internalInstanceHandle) {
        precacheFiberNode(internalInstanceHandle, suspenseInstance);
    }
    function getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance) {
        var node = suspenseInstance.nextSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_END_DATA) {
                    if (depth === 0) return getNextHydratableSibling(node);
                    else depth--;
                } else if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) depth++;
            }
            node = node.nextSibling;
        } // TODO: Warn, we didn't find the end comment boundary.
        return null;
    } // Returns the SuspenseInstance if this node is a direct child of a
    // SuspenseInstance. I.e. if its previous sibling is a Comment with
    // SUSPENSE_x_START_DATA. Otherwise, null.
    function getParentSuspenseInstance(targetInstance) {
        var node = targetInstance.previousSibling; // Skip past all nodes within this suspense boundary.
        // There might be nested nodes so we need to keep track of how
        // deep we are and only break out when we're back on top.
        var depth = 0;
        while(node){
            if (node.nodeType === COMMENT_NODE) {
                var data = node.data;
                if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA) {
                    if (depth === 0) return node;
                    else depth--;
                } else if (data === SUSPENSE_END_DATA) depth++;
            }
            node = node.previousSibling;
        }
        return null;
    }
    function commitHydratedContainer(container) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(container);
    }
    function commitHydratedSuspenseInstance(suspenseInstance) {
        // Retry if any event replaying was blocked on this.
        retryIfBlockedOn(suspenseInstance);
    }
    function shouldDeleteUnhydratedTailInstances(parentType) {
        return parentType !== "head" && parentType !== "body";
    }
    function didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, text, isConcurrentMode) {
        var shouldWarnDev = true;
        checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
    }
    function didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, text, isConcurrentMode) {
        if (parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            var shouldWarnDev = true;
            checkForUnmatchedText(textInstance.nodeValue, text, isConcurrentMode, shouldWarnDev);
        }
    }
    function didNotHydrateInstanceWithinContainer(parentContainer, instance) {
        if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentContainer, instance);
        else if (instance.nodeType === COMMENT_NODE) ;
        else warnForDeletedHydratableText(parentContainer, instance);
    }
    function didNotHydrateInstanceWithinSuspenseInstance(parentInstance, instance) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentNode, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentNode, instance);
        }
    }
    function didNotHydrateInstance(parentType, parentProps, parentInstance, instance, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) {
            if (instance.nodeType === ELEMENT_NODE) warnForDeletedHydratableElement(parentInstance, instance);
            else if (instance.nodeType === COMMENT_NODE) ;
            else warnForDeletedHydratableText(parentInstance, instance);
        }
    }
    function didNotFindHydratableInstanceWithinContainer(parentContainer, type, props) {
        warnForInsertedHydratedElement(parentContainer, type);
    }
    function didNotFindHydratableTextInstanceWithinContainer(parentContainer, text) {
        warnForInsertedHydratedText(parentContainer, text);
    }
    function didNotFindHydratableInstanceWithinSuspenseInstance(parentInstance, type, props) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) warnForInsertedHydratedElement(parentNode, type);
    }
    function didNotFindHydratableTextInstanceWithinSuspenseInstance(parentInstance, text) {
        // $FlowFixMe: Only Element or Document can be parent nodes.
        var parentNode = parentInstance.parentNode;
        if (parentNode !== null) warnForInsertedHydratedText(parentNode, text);
    }
    function didNotFindHydratableInstance(parentType, parentProps, parentInstance, type, props, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedElement(parentInstance, type);
    }
    function didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, text, isConcurrentMode) {
        if (isConcurrentMode || parentProps[SUPPRESS_HYDRATION_WARNING$1] !== true) warnForInsertedHydratedText(parentInstance, text);
    }
    function errorHydratingContainer(parentContainer) {
        // TODO: This gets logged by onRecoverableError, too, so we should be
        // able to remove it.
        error("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", parentContainer.nodeName.toLowerCase());
    }
    function preparePortalMount(portalInstance) {
        listenToAllSupportedEvents(portalInstance);
    }
    var randomKey = Math.random().toString(36).slice(2);
    var internalInstanceKey = "__reactFiber$" + randomKey;
    var internalPropsKey = "__reactProps$" + randomKey;
    var internalContainerInstanceKey = "__reactContainer$" + randomKey;
    var internalEventHandlersKey = "__reactEvents$" + randomKey;
    var internalEventHandlerListenersKey = "__reactListeners$" + randomKey;
    var internalEventHandlesSetKey = "__reactHandles$" + randomKey;
    function detachDeletedInstance(node) {
        // TODO: This function is only called on host components. I don't think all of
        // these fields are relevant.
        delete node[internalInstanceKey];
        delete node[internalPropsKey];
        delete node[internalEventHandlersKey];
        delete node[internalEventHandlerListenersKey];
        delete node[internalEventHandlesSetKey];
    }
    function precacheFiberNode(hostInst, node) {
        node[internalInstanceKey] = hostInst;
    }
    function markContainerAsRoot(hostRoot, node) {
        node[internalContainerInstanceKey] = hostRoot;
    }
    function unmarkContainerAsRoot(node) {
        node[internalContainerInstanceKey] = null;
    }
    function isContainerMarkedAsRoot(node) {
        return !!node[internalContainerInstanceKey];
    } // Given a DOM node, return the closest HostComponent or HostText fiber ancestor.
    // If the target node is part of a hydrated or not yet rendered subtree, then
    // this may also return a SuspenseComponent or HostRoot to indicate that.
    // Conceptually the HostRoot fiber is a child of the Container node. So if you
    // pass the Container node as the targetNode, you will not actually get the
    // HostRoot back. To get to the HostRoot, you need to pass a child of it.
    // The same thing applies to Suspense boundaries.
    function getClosestInstanceFromNode(targetNode) {
        var targetInst = targetNode[internalInstanceKey];
        if (targetInst) // Don't return HostRoot or SuspenseComponent here.
        return targetInst;
         // If the direct event target isn't a React owned DOM node, we need to look
        // to see if one of its parents is a React owned DOM node.
        var parentNode = targetNode.parentNode;
        while(parentNode){
            // We'll check if this is a container root that could include
            // React nodes in the future. We need to check this first because
            // if we're a child of a dehydrated container, we need to first
            // find that inner container before moving on to finding the parent
            // instance. Note that we don't check this field on  the targetNode
            // itself because the fibers are conceptually between the container
            // node and the first child. It isn't surrounding the container node.
            // If it's not a container, we check if it's an instance.
            targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey];
            if (targetInst) {
                // Since this wasn't the direct target of the event, we might have
                // stepped past dehydrated DOM nodes to get here. However they could
                // also have been non-React nodes. We need to answer which one.
                // If we the instance doesn't have any children, then there can't be
                // a nested suspense boundary within it. So we can use this as a fast
                // bailout. Most of the time, when people add non-React children to
                // the tree, it is using a ref to a child-less DOM node.
                // Normally we'd only need to check one of the fibers because if it
                // has ever gone from having children to deleting them or vice versa
                // it would have deleted the dehydrated boundary nested inside already.
                // However, since the HostRoot starts out with an alternate it might
                // have one on the alternate so we need to check in case this was a
                // root.
                var alternate = targetInst.alternate;
                if (targetInst.child !== null || alternate !== null && alternate.child !== null) {
                    // Next we need to figure out if the node that skipped past is
                    // nested within a dehydrated boundary and if so, which one.
                    var suspenseInstance = getParentSuspenseInstance(targetNode);
                    while(suspenseInstance !== null){
                        // We found a suspense instance. That means that we haven't
                        // hydrated it yet. Even though we leave the comments in the
                        // DOM after hydrating, and there are boundaries in the DOM
                        // that could already be hydrated, we wouldn't have found them
                        // through this pass since if the target is hydrated it would
                        // have had an internalInstanceKey on it.
                        // Let's get the fiber associated with the SuspenseComponent
                        // as the deepest instance.
                        var targetSuspenseInst = suspenseInstance[internalInstanceKey];
                        if (targetSuspenseInst) return targetSuspenseInst;
                         // If we don't find a Fiber on the comment, it might be because
                        // we haven't gotten to hydrate it yet. There might still be a
                        // parent boundary that hasn't above this one so we need to find
                        // the outer most that is known.
                        suspenseInstance = getParentSuspenseInstance(suspenseInstance); // If we don't find one, then that should mean that the parent
                    // host component also hasn't hydrated yet. We can return it
                    // below since it will bail out on the isMounted check later.
                    }
                }
                return targetInst;
            }
            targetNode = parentNode;
            parentNode = targetNode.parentNode;
        }
        return null;
    }
    /**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */ function getInstanceFromNode(node) {
        var inst = node[internalInstanceKey] || node[internalContainerInstanceKey];
        if (inst) {
            if (inst.tag === HostComponent || inst.tag === HostText || inst.tag === SuspenseComponent || inst.tag === HostRoot) return inst;
            else return null;
        }
        return null;
    }
    /**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */ function getNodeFromInstance(inst) {
        if (inst.tag === HostComponent || inst.tag === HostText) // In Fiber this, is just the state node right now. We assume it will be
        // a host component or host text.
        return inst.stateNode;
         // Without this first invariant, passing a non-DOM-component triggers the next
        // invariant for a missing parent, which is super confusing.
        throw new Error("getNodeFromInstance: Invalid argument.");
    }
    function getFiberCurrentPropsFromNode(node) {
        return node[internalPropsKey] || null;
    }
    function updateFiberProps(node, props) {
        node[internalPropsKey] = props;
    }
    function getEventListenerSet(node) {
        var elementListenerSet = node[internalEventHandlersKey];
        if (elementListenerSet === undefined) elementListenerSet = node[internalEventHandlersKey] = new Set();
        return elementListenerSet;
    }
    var loggedTypeFailures = {};
    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
    function setCurrentlyValidatingElement(element) {
        if (element) {
            var owner = element._owner;
            var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
            ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
        } else ReactDebugCurrentFrame$1.setExtraStackFrame(null);
    }
    function checkPropTypes(typeSpecs, values, location, componentName, element) {
        // $FlowFixMe This is okay but Flow doesn't know it.
        var has = Function.call.bind(hasOwnProperty);
        for(var typeSpecName in typeSpecs)if (has(typeSpecs, typeSpecName)) {
            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
            // fail the render phase where it didn't fail before. So we log it.
            // After these have been cleaned up, we'll let them throw.
            try {
                // This is intentionally an invariant that gets caught. It's the same
                // behavior as without this statement except with a better message.
                if (typeof typeSpecs[typeSpecName] !== "function") {
                    // eslint-disable-next-line react-internal/prod-error-codes
                    var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; " + "it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`." + "This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    err.name = "Invariant Violation";
                    throw err;
                }
                error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ex) {
                error$1 = ex;
            }
            if (error$1 && !(error$1 instanceof Error)) {
                setCurrentlyValidatingElement(element);
                error("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", componentName || "React class", location, typeSpecName, typeof error$1);
                setCurrentlyValidatingElement(null);
            }
            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
                // Only monitor this failure once because there tends to be a lot of the
                // same error.
                loggedTypeFailures[error$1.message] = true;
                setCurrentlyValidatingElement(element);
                error("Failed %s type: %s", location, error$1.message);
                setCurrentlyValidatingElement(null);
            }
        }
    }
    var valueStack = [];
    var fiberStack;
    fiberStack = [];
    var index = -1;
    function createCursor(defaultValue) {
        return {
            current: defaultValue
        };
    }
    function pop(cursor, fiber) {
        if (index < 0) {
            error("Unexpected pop.");
            return;
        }
        if (fiber !== fiberStack[index]) error("Unexpected Fiber popped.");
        cursor.current = valueStack[index];
        valueStack[index] = null;
        fiberStack[index] = null;
        index--;
    }
    function push(cursor, value, fiber) {
        index++;
        valueStack[index] = cursor.current;
        fiberStack[index] = fiber;
        cursor.current = value;
    }
    var warnedAboutMissingGetChildContext;
    warnedAboutMissingGetChildContext = {};
    var emptyContextObject = {};
    Object.freeze(emptyContextObject);
    var contextStackCursor = createCursor(emptyContextObject); // A cursor to a boolean indicating whether the context has changed.
    var didPerformWorkStackCursor = createCursor(false); // Keep track of the previous context object that was on the stack.
    // We use this to get access to the parent context after we have already
    // pushed the next context provider, and now need to merge their contexts.
    var previousContext = emptyContextObject;
    function getUnmaskedContext(workInProgress, Component, didPushOwnContextIfProvider) {
        if (didPushOwnContextIfProvider && isContextProvider(Component)) // If the fiber is a context provider itself, when we read its context
        // we may have already pushed its own child context on the stack. A context
        // provider should not "see" its own child context. Therefore we read the
        // previous (parent) context instead for a context provider.
        return previousContext;
        return contextStackCursor.current;
    }
    function cacheContext(workInProgress, unmaskedContext, maskedContext) {
        var instance = workInProgress.stateNode;
        instance.__reactInternalMemoizedUnmaskedChildContext = unmaskedContext;
        instance.__reactInternalMemoizedMaskedChildContext = maskedContext;
    }
    function getMaskedContext(workInProgress, unmaskedContext) {
        var type = workInProgress.type;
        var contextTypes = type.contextTypes;
        if (!contextTypes) return emptyContextObject;
         // Avoid recreating masked context unless unmasked context has changed.
        // Failing to do this will result in unnecessary calls to componentWillReceiveProps.
        // This may trigger infinite loops if componentWillReceiveProps calls setState.
        var instance = workInProgress.stateNode;
        if (instance && instance.__reactInternalMemoizedUnmaskedChildContext === unmaskedContext) return instance.__reactInternalMemoizedMaskedChildContext;
        var context = {};
        for(var key in contextTypes)context[key] = unmaskedContext[key];
        var name = getComponentNameFromFiber(workInProgress) || "Unknown";
        checkPropTypes(contextTypes, context, "context", name);
        // Context is created before the class component is instantiated so check for instance.
        if (instance) cacheContext(workInProgress, unmaskedContext, context);
        return context;
    }
    function hasContextChanged() {
        return didPerformWorkStackCursor.current;
    }
    function isContextProvider(type) {
        var childContextTypes = type.childContextTypes;
        return childContextTypes !== null && childContextTypes !== undefined;
    }
    function popContext(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function popTopLevelContextObject(fiber) {
        pop(didPerformWorkStackCursor, fiber);
        pop(contextStackCursor, fiber);
    }
    function pushTopLevelContextObject(fiber, context, didChange) {
        if (contextStackCursor.current !== emptyContextObject) throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
        push(contextStackCursor, context, fiber);
        push(didPerformWorkStackCursor, didChange, fiber);
    }
    function processChildContext(fiber, type, parentContext) {
        var instance = fiber.stateNode;
        var childContextTypes = type.childContextTypes; // TODO (bvaughn) Replace this behavior with an invariant() in the future.
        // It has only been added in Fiber to match the (unintentional) behavior in Stack.
        if (typeof instance.getChildContext !== "function") {
            var componentName = getComponentNameFromFiber(fiber) || "Unknown";
            if (!warnedAboutMissingGetChildContext[componentName]) {
                warnedAboutMissingGetChildContext[componentName] = true;
                error("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", componentName, componentName);
            }
            return parentContext;
        }
        var childContext = instance.getChildContext();
        for(var contextKey in childContext){
            if (!(contextKey in childContextTypes)) throw new Error((getComponentNameFromFiber(fiber) || "Unknown") + '.getChildContext(): key "' + contextKey + '" is not defined in childContextTypes.');
        }
        var name = getComponentNameFromFiber(fiber) || "Unknown";
        checkPropTypes(childContextTypes, childContext, "child context", name);
        return assign({}, parentContext, childContext);
    }
    function pushContextProvider(workInProgress) {
        var instance = workInProgress.stateNode; // We push the context as early as possible to ensure stack integrity.
        // If the instance does not exist yet, we will push null at first,
        // and replace it on the stack later when invalidating the context.
        var memoizedMergedChildContext = instance && instance.__reactInternalMemoizedMergedChildContext || emptyContextObject; // Remember the parent context so we can merge with it later.
        // Inherit the parent's did-perform-work value to avoid inadvertently blocking updates.
        previousContext = contextStackCursor.current;
        push(contextStackCursor, memoizedMergedChildContext, workInProgress);
        push(didPerformWorkStackCursor, didPerformWorkStackCursor.current, workInProgress);
        return true;
    }
    function invalidateContextProvider(workInProgress, type, didChange) {
        var instance = workInProgress.stateNode;
        if (!instance) throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
        if (didChange) {
            // Merge parent and own context.
            // Skip this if we're not updating due to sCU.
            // This avoids unnecessarily recomputing memoized values.
            var mergedContext = processChildContext(workInProgress, type, previousContext);
            instance.__reactInternalMemoizedMergedChildContext = mergedContext; // Replace the old (or empty) context with the new one.
            // It is important to unwind the context in the reverse order.
            pop(didPerformWorkStackCursor, workInProgress);
            pop(contextStackCursor, workInProgress); // Now push the new context and mark that it has changed.
            push(contextStackCursor, mergedContext, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        } else {
            pop(didPerformWorkStackCursor, workInProgress);
            push(didPerformWorkStackCursor, didChange, workInProgress);
        }
    }
    function findCurrentUnmaskedContext(fiber) {
        // Currently this is only used with renderSubtreeIntoContainer; not sure if it
        // makes sense elsewhere
        if (!isFiberMounted(fiber) || fiber.tag !== ClassComponent) throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
        var node = fiber;
        do {
            switch(node.tag){
                case HostRoot:
                    return node.stateNode.context;
                case ClassComponent:
                    var Component = node.type;
                    if (isContextProvider(Component)) return node.stateNode.__reactInternalMemoizedMergedChildContext;
                    break;
            }
            node = node.return;
        }while (node !== null);
        throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    var LegacyRoot = 0;
    var ConcurrentRoot = 1;
    var syncQueue = null;
    var includesLegacySyncCallbacks = false;
    var isFlushingSyncQueue = false;
    function scheduleSyncCallback(callback) {
        // Push this callback into an internal queue. We'll flush these either in
        // the next tick, or earlier if something calls `flushSyncCallbackQueue`.
        if (syncQueue === null) syncQueue = [
            callback
        ];
        else // Push onto existing queue. Don't need to schedule a callback because
        // we already scheduled one when we created the queue.
        syncQueue.push(callback);
    }
    function scheduleLegacySyncCallback(callback) {
        includesLegacySyncCallbacks = true;
        scheduleSyncCallback(callback);
    }
    function flushSyncCallbacksOnlyInLegacyMode() {
        // Only flushes the queue if there's a legacy sync callback scheduled.
        // TODO: There's only a single type of callback: performSyncOnWorkOnRoot. So
        // it might make more sense for the queue to be a list of roots instead of a
        // list of generic callbacks. Then we can have two: one for legacy roots, one
        // for concurrent roots. And this method would only flush the legacy ones.
        if (includesLegacySyncCallbacks) flushSyncCallbacks();
    }
    function flushSyncCallbacks() {
        if (!isFlushingSyncQueue && syncQueue !== null) {
            // Prevent re-entrance.
            isFlushingSyncQueue = true;
            var i = 0;
            var previousUpdatePriority = getCurrentUpdatePriority();
            try {
                var isSync = true;
                var queue = syncQueue; // TODO: Is this necessary anymore? The only user code that runs in this
                // queue is in the render or commit phases.
                setCurrentUpdatePriority(DiscreteEventPriority);
                for(; i < queue.length; i++){
                    var callback = queue[i];
                    do callback = callback(isSync);
                    while (callback !== null);
                }
                syncQueue = null;
                includesLegacySyncCallbacks = false;
            } catch (error) {
                // If something throws, leave the remaining callbacks on the queue.
                if (syncQueue !== null) syncQueue = syncQueue.slice(i + 1);
                 // Resume flushing in the next tick
                scheduleCallback(ImmediatePriority, flushSyncCallbacks);
                throw error;
            } finally{
                setCurrentUpdatePriority(previousUpdatePriority);
                isFlushingSyncQueue = false;
            }
        }
        return null;
    }
    // TODO: Use the unified fiber stack module instead of this local one?
    // Intentionally not using it yet to derisk the initial implementation, because
    // the way we push/pop these values is a bit unusual. If there's a mistake, I'd
    // rather the ids be wrong than crash the whole reconciler.
    var forkStack = [];
    var forkStackIndex = 0;
    var treeForkProvider = null;
    var treeForkCount = 0;
    var idStack = [];
    var idStackIndex = 0;
    var treeContextProvider = null;
    var treeContextId = 1;
    var treeContextOverflow = "";
    function isForkedChild(workInProgress) {
        warnIfNotHydrating();
        return (workInProgress.flags & Forked) !== NoFlags;
    }
    function getForksAtLevel(workInProgress) {
        warnIfNotHydrating();
        return treeForkCount;
    }
    function getTreeId() {
        var overflow = treeContextOverflow;
        var idWithLeadingBit = treeContextId;
        var id = idWithLeadingBit & ~getLeadingBit(idWithLeadingBit);
        return id.toString(32) + overflow;
    }
    function pushTreeFork(workInProgress, totalChildren) {
        // This is called right after we reconcile an array (or iterator) of child
        // fibers, because that's the only place where we know how many children in
        // the whole set without doing extra work later, or storing addtional
        // information on the fiber.
        //
        // That's why this function is separate from pushTreeId — it's called during
        // the render phase of the fork parent, not the child, which is where we push
        // the other context values.
        //
        // In the Fizz implementation this is much simpler because the child is
        // rendered in the same callstack as the parent.
        //
        // It might be better to just add a `forks` field to the Fiber type. It would
        // make this module simpler.
        warnIfNotHydrating();
        forkStack[forkStackIndex++] = treeForkCount;
        forkStack[forkStackIndex++] = treeForkProvider;
        treeForkProvider = workInProgress;
        treeForkCount = totalChildren;
    }
    function pushTreeId(workInProgress, totalChildren, index) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextProvider = workInProgress;
        var baseIdWithLeadingBit = treeContextId;
        var baseOverflow = treeContextOverflow; // The leftmost 1 marks the end of the sequence, non-inclusive. It's not part
        // of the id; we use it to account for leading 0s.
        var baseLength = getBitLength(baseIdWithLeadingBit) - 1;
        var baseId = baseIdWithLeadingBit & ~(1 << baseLength);
        var slot = index + 1;
        var length = getBitLength(totalChildren) + baseLength; // 30 is the max length we can store without overflowing, taking into
        // consideration the leading 1 we use to mark the end of the sequence.
        if (length > 30) {
            // We overflowed the bitwise-safe range. Fall back to slower algorithm.
            // This branch assumes the length of the base id is greater than 5; it won't
            // work for smaller ids, because you need 5 bits per character.
            //
            // We encode the id in multiple steps: first the base id, then the
            // remaining digits.
            //
            // Each 5 bit sequence corresponds to a single base 32 character. So for
            // example, if the current id is 23 bits long, we can convert 20 of those
            // bits into a string of 4 characters, with 3 bits left over.
            //
            // First calculate how many bits in the base id represent a complete
            // sequence of characters.
            var numberOfOverflowBits = baseLength - baseLength % 5; // Then create a bitmask that selects only those bits.
            var newOverflowBits = (1 << numberOfOverflowBits) - 1; // Select the bits, and convert them to a base 32 string.
            var newOverflow = (baseId & newOverflowBits).toString(32); // Now we can remove those bits from the base id.
            var restOfBaseId = baseId >> numberOfOverflowBits;
            var restOfBaseLength = baseLength - numberOfOverflowBits; // Finally, encode the rest of the bits using the normal algorithm. Because
            // we made more room, this time it won't overflow.
            var restOfLength = getBitLength(totalChildren) + restOfBaseLength;
            var restOfNewBits = slot << restOfBaseLength;
            var id = restOfNewBits | restOfBaseId;
            var overflow = newOverflow + baseOverflow;
            treeContextId = 1 << restOfLength | id;
            treeContextOverflow = overflow;
        } else {
            // Normal path
            var newBits = slot << baseLength;
            var _id = newBits | baseId;
            var _overflow = baseOverflow;
            treeContextId = 1 << length | _id;
            treeContextOverflow = _overflow;
        }
    }
    function pushMaterializedTreeId(workInProgress) {
        warnIfNotHydrating(); // This component materialized an id. This will affect any ids that appear
        // in its children.
        var returnFiber = workInProgress.return;
        if (returnFiber !== null) {
            var numberOfForks = 1;
            var slotIndex = 0;
            pushTreeFork(workInProgress, numberOfForks);
            pushTreeId(workInProgress, numberOfForks, slotIndex);
        }
    }
    function getBitLength(number) {
        return 32 - clz32(number);
    }
    function getLeadingBit(id) {
        return 1 << getBitLength(id) - 1;
    }
    function popTreeContext(workInProgress) {
        // Restore the previous values.
        // This is a bit more complicated than other context-like modules in Fiber
        // because the same Fiber may appear on the stack multiple times and for
        // different reasons. We have to keep popping until the work-in-progress is
        // no longer at the top of the stack.
        while(workInProgress === treeForkProvider){
            treeForkProvider = forkStack[--forkStackIndex];
            forkStack[forkStackIndex] = null;
            treeForkCount = forkStack[--forkStackIndex];
            forkStack[forkStackIndex] = null;
        }
        while(workInProgress === treeContextProvider){
            treeContextProvider = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
            treeContextOverflow = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
            treeContextId = idStack[--idStackIndex];
            idStack[idStackIndex] = null;
        }
    }
    function getSuspendedTreeContext() {
        warnIfNotHydrating();
        if (treeContextProvider !== null) return {
            id: treeContextId,
            overflow: treeContextOverflow
        };
        else return null;
    }
    function restoreSuspendedTreeContext(workInProgress, suspendedContext) {
        warnIfNotHydrating();
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextId = suspendedContext.id;
        treeContextOverflow = suspendedContext.overflow;
        treeContextProvider = workInProgress;
    }
    function warnIfNotHydrating() {
        if (!getIsHydrating()) error("Expected to be hydrating. This is a bug in React. Please file an issue.");
    }
    // This may have been an insertion or a hydration.
    var hydrationParentFiber = null;
    var nextHydratableInstance = null;
    var isHydrating = false; // This flag allows for warning supression when we expect there to be mismatches
    // due to earlier mismatches or a suspended fiber.
    var didSuspendOrErrorDEV = false; // Hydration errors that were thrown inside this boundary
    var hydrationErrors = null;
    function warnIfHydrating() {
        if (isHydrating) error("We should not be hydrating here. This is a bug in React. Please file a bug.");
    }
    function markDidThrowWhileHydratingDEV() {
        didSuspendOrErrorDEV = true;
    }
    function didSuspendOrErrorWhileHydratingDEV() {
        return didSuspendOrErrorDEV;
    }
    function enterHydrationState(fiber) {
        var parentInstance = fiber.stateNode.containerInfo;
        nextHydratableInstance = getFirstHydratableChildWithinContainer(parentInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;
        return true;
    }
    function reenterHydrationStateFromDehydratedSuspenseInstance(fiber, suspenseInstance, treeContext) {
        nextHydratableInstance = getFirstHydratableChildWithinSuspenseInstance(suspenseInstance);
        hydrationParentFiber = fiber;
        isHydrating = true;
        hydrationErrors = null;
        didSuspendOrErrorDEV = false;
        if (treeContext !== null) restoreSuspendedTreeContext(fiber, treeContext);
        return true;
    }
    function warnUnhydratedInstance(returnFiber, instance) {
        switch(returnFiber.tag){
            case HostRoot:
                didNotHydrateInstanceWithinContainer(returnFiber.stateNode.containerInfo, instance);
                break;
            case HostComponent:
                var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                didNotHydrateInstance(returnFiber.type, returnFiber.memoizedProps, returnFiber.stateNode, instance, isConcurrentMode);
                break;
            case SuspenseComponent:
                var suspenseState = returnFiber.memoizedState;
                if (suspenseState.dehydrated !== null) didNotHydrateInstanceWithinSuspenseInstance(suspenseState.dehydrated, instance);
                break;
        }
    }
    function deleteHydratableInstance(returnFiber, instance) {
        warnUnhydratedInstance(returnFiber, instance);
        var childToDelete = createFiberFromHostInstanceForDeletion();
        childToDelete.stateNode = instance;
        childToDelete.return = returnFiber;
        var deletions = returnFiber.deletions;
        if (deletions === null) {
            returnFiber.deletions = [
                childToDelete
            ];
            returnFiber.flags |= ChildDeletion;
        } else deletions.push(childToDelete);
    }
    function warnNonhydratedInstance(returnFiber, fiber) {
        if (didSuspendOrErrorDEV) // Inside a boundary that already suspended. We're currently rendering the
        // siblings of a suspended node. The mismatch may be due to the missing
        // data, so it's probably a false positive.
        return;
        switch(returnFiber.tag){
            case HostRoot:
                var parentContainer = returnFiber.stateNode.containerInfo;
                switch(fiber.tag){
                    case HostComponent:
                        var type = fiber.type;
                        var props = fiber.pendingProps;
                        didNotFindHydratableInstanceWithinContainer(parentContainer, type);
                        break;
                    case HostText:
                        var text = fiber.pendingProps;
                        didNotFindHydratableTextInstanceWithinContainer(parentContainer, text);
                        break;
                }
                break;
            case HostComponent:
                var parentType = returnFiber.type;
                var parentProps = returnFiber.memoizedProps;
                var parentInstance = returnFiber.stateNode;
                switch(fiber.tag){
                    case HostComponent:
                        var _type = fiber.type;
                        var _props = fiber.pendingProps;
                        var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                        didNotFindHydratableInstance(parentType, parentProps, parentInstance, _type, _props, isConcurrentMode);
                        break;
                    case HostText:
                        var _text = fiber.pendingProps;
                        var _isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                        didNotFindHydratableTextInstance(parentType, parentProps, parentInstance, _text, _isConcurrentMode);
                        break;
                }
                break;
            case SuspenseComponent:
                var suspenseState = returnFiber.memoizedState;
                var _parentInstance = suspenseState.dehydrated;
                if (_parentInstance !== null) switch(fiber.tag){
                    case HostComponent:
                        var _type2 = fiber.type;
                        var _props2 = fiber.pendingProps;
                        didNotFindHydratableInstanceWithinSuspenseInstance(_parentInstance, _type2);
                        break;
                    case HostText:
                        var _text2 = fiber.pendingProps;
                        didNotFindHydratableTextInstanceWithinSuspenseInstance(_parentInstance, _text2);
                        break;
                }
                break;
            default:
                return;
        }
    }
    function insertNonHydratedInstance(returnFiber, fiber) {
        fiber.flags = fiber.flags & ~Hydrating | Placement;
        warnNonhydratedInstance(returnFiber, fiber);
    }
    function tryHydrate(fiber, nextInstance) {
        switch(fiber.tag){
            case HostComponent:
                var type = fiber.type;
                var props = fiber.pendingProps;
                var instance = canHydrateInstance(nextInstance, type);
                if (instance !== null) {
                    fiber.stateNode = instance;
                    hydrationParentFiber = fiber;
                    nextHydratableInstance = getFirstHydratableChild(instance);
                    return true;
                }
                return false;
            case HostText:
                var text = fiber.pendingProps;
                var textInstance = canHydrateTextInstance(nextInstance, text);
                if (textInstance !== null) {
                    fiber.stateNode = textInstance;
                    hydrationParentFiber = fiber; // Text Instances don't have children so there's nothing to hydrate.
                    nextHydratableInstance = null;
                    return true;
                }
                return false;
            case SuspenseComponent:
                var suspenseInstance = canHydrateSuspenseInstance(nextInstance);
                if (suspenseInstance !== null) {
                    var suspenseState = {
                        dehydrated: suspenseInstance,
                        treeContext: getSuspendedTreeContext(),
                        retryLane: OffscreenLane
                    };
                    fiber.memoizedState = suspenseState; // Store the dehydrated fragment as a child fiber.
                    // This simplifies the code for getHostSibling and deleting nodes,
                    // since it doesn't have to consider all Suspense boundaries and
                    // check if they're dehydrated ones or not.
                    var dehydratedFragment = createFiberFromDehydratedFragment(suspenseInstance);
                    dehydratedFragment.return = fiber;
                    fiber.child = dehydratedFragment;
                    hydrationParentFiber = fiber; // While a Suspense Instance does have children, we won't step into
                    // it during the first pass. Instead, we'll reenter it later.
                    nextHydratableInstance = null;
                    return true;
                }
                return false;
            default:
                return false;
        }
    }
    function shouldClientRenderOnMismatch(fiber) {
        return (fiber.mode & ConcurrentMode) !== NoMode && (fiber.flags & DidCapture) === NoFlags;
    }
    function throwOnHydrationMismatch(fiber) {
        throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
    }
    function tryToClaimNextHydratableInstance(fiber) {
        if (!isHydrating) return;
        var nextInstance = nextHydratableInstance;
        if (!nextInstance) {
            if (shouldClientRenderOnMismatch(fiber)) {
                warnNonhydratedInstance(hydrationParentFiber, fiber);
                throwOnHydrationMismatch();
            } // Nothing to hydrate. Make it an insertion.
            insertNonHydratedInstance(hydrationParentFiber, fiber);
            isHydrating = false;
            hydrationParentFiber = fiber;
            return;
        }
        var firstAttemptedInstance = nextInstance;
        if (!tryHydrate(fiber, nextInstance)) {
            if (shouldClientRenderOnMismatch(fiber)) {
                warnNonhydratedInstance(hydrationParentFiber, fiber);
                throwOnHydrationMismatch();
            } // If we can't hydrate this instance let's try the next one.
            // We use this as a heuristic. It's based on intuition and not data so it
            // might be flawed or unnecessary.
            nextInstance = getNextHydratableSibling(firstAttemptedInstance);
            var prevHydrationParentFiber = hydrationParentFiber;
            if (!nextInstance || !tryHydrate(fiber, nextInstance)) {
                // Nothing to hydrate. Make it an insertion.
                insertNonHydratedInstance(hydrationParentFiber, fiber);
                isHydrating = false;
                hydrationParentFiber = fiber;
                return;
            } // We matched the next one, we'll now assume that the first one was
            // superfluous and we'll delete it. Since we can't eagerly delete it
            // we'll have to schedule a deletion. To do that, this node needs a dummy
            // fiber associated with it.
            deleteHydratableInstance(prevHydrationParentFiber, firstAttemptedInstance);
        }
    }
    function prepareToHydrateHostInstance(fiber, rootContainerInstance, hostContext) {
        var instance = fiber.stateNode;
        var shouldWarnIfMismatchDev = !didSuspendOrErrorDEV;
        var updatePayload = hydrateInstance(instance, fiber.type, fiber.memoizedProps, rootContainerInstance, hostContext, fiber, shouldWarnIfMismatchDev); // TODO: Type this specific to this type of component.
        fiber.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update.
        if (updatePayload !== null) return true;
        return false;
    }
    function prepareToHydrateHostTextInstance(fiber) {
        var textInstance = fiber.stateNode;
        var textContent = fiber.memoizedProps;
        var shouldUpdate = hydrateTextInstance(textInstance, textContent, fiber);
        if (shouldUpdate) {
            // We assume that prepareToHydrateHostTextInstance is called in a context where the
            // hydration parent is the parent host component of this host text.
            var returnFiber = hydrationParentFiber;
            if (returnFiber !== null) switch(returnFiber.tag){
                case HostRoot:
                    var parentContainer = returnFiber.stateNode.containerInfo;
                    var isConcurrentMode = (returnFiber.mode & ConcurrentMode) !== NoMode;
                    didNotMatchHydratedContainerTextInstance(parentContainer, textInstance, textContent, isConcurrentMode);
                    break;
                case HostComponent:
                    var parentType = returnFiber.type;
                    var parentProps = returnFiber.memoizedProps;
                    var parentInstance = returnFiber.stateNode;
                    var _isConcurrentMode2 = (returnFiber.mode & ConcurrentMode) !== NoMode;
                    didNotMatchHydratedTextInstance(parentType, parentProps, parentInstance, textInstance, textContent, _isConcurrentMode2);
                    break;
            }
        }
        return shouldUpdate;
    }
    function prepareToHydrateHostSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        hydrateSuspenseInstance(suspenseInstance, fiber);
    }
    function skipPastDehydratedSuspenseInstance(fiber) {
        var suspenseState = fiber.memoizedState;
        var suspenseInstance = suspenseState !== null ? suspenseState.dehydrated : null;
        if (!suspenseInstance) throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        return getNextHydratableInstanceAfterSuspenseInstance(suspenseInstance);
    }
    function popToNextHostParent(fiber) {
        var parent = fiber.return;
        while(parent !== null && parent.tag !== HostComponent && parent.tag !== HostRoot && parent.tag !== SuspenseComponent)parent = parent.return;
        hydrationParentFiber = parent;
    }
    function popHydrationState(fiber) {
        if (fiber !== hydrationParentFiber) // We're deeper than the current hydration context, inside an inserted
        // tree.
        return false;
        if (!isHydrating) {
            // If we're not currently hydrating but we're in a hydration context, then
            // we were an insertion and now need to pop up reenter hydration of our
            // siblings.
            popToNextHostParent(fiber);
            isHydrating = true;
            return false;
        } // If we have any remaining hydratable nodes, we need to delete them now.
        // We only do this deeper than head and body since they tend to have random
        // other nodes in them. We also ignore components with pure text content in
        // side of them. We also don't delete anything inside the root container.
        if (fiber.tag !== HostRoot && (fiber.tag !== HostComponent || shouldDeleteUnhydratedTailInstances(fiber.type) && !shouldSetTextContent(fiber.type, fiber.memoizedProps))) {
            var nextInstance = nextHydratableInstance;
            if (nextInstance) {
                if (shouldClientRenderOnMismatch(fiber)) {
                    warnIfUnhydratedTailNodes(fiber);
                    throwOnHydrationMismatch();
                } else while(nextInstance){
                    deleteHydratableInstance(fiber, nextInstance);
                    nextInstance = getNextHydratableSibling(nextInstance);
                }
            }
        }
        popToNextHostParent(fiber);
        if (fiber.tag === SuspenseComponent) nextHydratableInstance = skipPastDehydratedSuspenseInstance(fiber);
        else nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
        return true;
    }
    function hasUnhydratedTailNodes() {
        return isHydrating && nextHydratableInstance !== null;
    }
    function warnIfUnhydratedTailNodes(fiber) {
        var nextInstance = nextHydratableInstance;
        while(nextInstance){
            warnUnhydratedInstance(fiber, nextInstance);
            nextInstance = getNextHydratableSibling(nextInstance);
        }
    }
    function resetHydrationState() {
        hydrationParentFiber = null;
        nextHydratableInstance = null;
        isHydrating = false;
        didSuspendOrErrorDEV = false;
    }
    function upgradeHydrationErrorsToRecoverable() {
        if (hydrationErrors !== null) {
            // Successfully completed a forced client render. The errors that occurred
            // during the hydration attempt are now recovered. We will log them in
            // commit phase, once the entire tree has finished.
            queueRecoverableErrors(hydrationErrors);
            hydrationErrors = null;
        }
    }
    function getIsHydrating() {
        return isHydrating;
    }
    function queueHydrationError(error) {
        if (hydrationErrors === null) hydrationErrors = [
            error
        ];
        else hydrationErrors.push(error);
    }
    var ReactCurrentBatchConfig$1 = ReactSharedInternals.ReactCurrentBatchConfig;
    var NoTransition = null;
    function requestCurrentTransition() {
        return ReactCurrentBatchConfig$1.transition;
    }
    var ReactStrictModeWarnings = {
        recordUnsafeLifecycleWarnings: function(fiber, instance) {},
        flushPendingUnsafeLifecycleWarnings: function() {},
        recordLegacyContextWarning: function(fiber, instance) {},
        flushLegacyContextWarning: function() {},
        discardPendingWarnings: function() {}
    };
    var findStrictRoot = function(fiber) {
        var maybeStrictRoot = null;
        var node = fiber;
        while(node !== null){
            if (node.mode & StrictLegacyMode) maybeStrictRoot = node;
            node = node.return;
        }
        return maybeStrictRoot;
    };
    var setToSortedString = function(set) {
        var array = [];
        set.forEach(function(value) {
            array.push(value);
        });
        return array.sort().join(", ");
    };
    var pendingComponentWillMountWarnings = [];
    var pendingUNSAFE_ComponentWillMountWarnings = [];
    var pendingComponentWillReceivePropsWarnings = [];
    var pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
    var pendingComponentWillUpdateWarnings = [];
    var pendingUNSAFE_ComponentWillUpdateWarnings = []; // Tracks components we have already warned about.
    var didWarnAboutUnsafeLifecycles = new Set();
    ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance) {
        // Dedupe strategy: Warn once per component.
        if (didWarnAboutUnsafeLifecycles.has(fiber.type)) return;
        if (typeof instance.componentWillMount === "function" && // Don't warn about react-lifecycles-compat polyfilled components.
        instance.componentWillMount.__suppressDeprecationWarning !== true) pendingComponentWillMountWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillMount === "function") pendingUNSAFE_ComponentWillMountWarnings.push(fiber);
        if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) pendingComponentWillReceivePropsWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillReceiveProps === "function") pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber);
        if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) pendingComponentWillUpdateWarnings.push(fiber);
        if (fiber.mode & StrictLegacyMode && typeof instance.UNSAFE_componentWillUpdate === "function") pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber);
    };
    ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
        // We do an initial pass to gather component names
        var componentWillMountUniqueNames = new Set();
        if (pendingComponentWillMountWarnings.length > 0) {
            pendingComponentWillMountWarnings.forEach(function(fiber) {
                componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillMountWarnings = [];
        }
        var UNSAFE_componentWillMountUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillMountWarnings.length > 0) {
            pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
                UNSAFE_componentWillMountUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillMountWarnings = [];
        }
        var componentWillReceivePropsUniqueNames = new Set();
        if (pendingComponentWillReceivePropsWarnings.length > 0) {
            pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
                componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillReceivePropsWarnings = [];
        }
        var UNSAFE_componentWillReceivePropsUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillReceivePropsWarnings.length > 0) {
            pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(function(fiber) {
                UNSAFE_componentWillReceivePropsUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        }
        var componentWillUpdateUniqueNames = new Set();
        if (pendingComponentWillUpdateWarnings.length > 0) {
            pendingComponentWillUpdateWarnings.forEach(function(fiber) {
                componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingComponentWillUpdateWarnings = [];
        }
        var UNSAFE_componentWillUpdateUniqueNames = new Set();
        if (pendingUNSAFE_ComponentWillUpdateWarnings.length > 0) {
            pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
                UNSAFE_componentWillUpdateUniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutUnsafeLifecycles.add(fiber.type);
            });
            pendingUNSAFE_ComponentWillUpdateWarnings = [];
        } // Finally, we flush all the warnings
        // UNSAFE_ ones before the deprecated ones, since they'll be 'louder'
        if (UNSAFE_componentWillMountUniqueNames.size > 0) {
            var sortedNames = setToSortedString(UNSAFE_componentWillMountUniqueNames);
            error("Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s", sortedNames);
        }
        if (UNSAFE_componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames = setToSortedString(UNSAFE_componentWillReceivePropsUniqueNames);
            error("Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n\nPlease update the following components: %s", _sortedNames);
        }
        if (UNSAFE_componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames2 = setToSortedString(UNSAFE_componentWillUpdateUniqueNames);
            error("Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s", _sortedNames2);
        }
        if (componentWillMountUniqueNames.size > 0) {
            var _sortedNames3 = setToSortedString(componentWillMountUniqueNames);
            warn("componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames3);
        }
        if (componentWillReceivePropsUniqueNames.size > 0) {
            var _sortedNames4 = setToSortedString(componentWillReceivePropsUniqueNames);
            warn("componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames4);
        }
        if (componentWillUpdateUniqueNames.size > 0) {
            var _sortedNames5 = setToSortedString(componentWillUpdateUniqueNames);
            warn("componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s", _sortedNames5);
        }
    };
    var pendingLegacyContextWarning = new Map(); // Tracks components we have already warned about.
    var didWarnAboutLegacyContext = new Set();
    ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance) {
        var strictRoot = findStrictRoot(fiber);
        if (strictRoot === null) {
            error("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
            return;
        } // Dedup strategy: Warn once per component.
        if (didWarnAboutLegacyContext.has(fiber.type)) return;
        var warningsForRoot = pendingLegacyContextWarning.get(strictRoot);
        if (fiber.type.contextTypes != null || fiber.type.childContextTypes != null || instance !== null && typeof instance.getChildContext === "function") {
            if (warningsForRoot === undefined) {
                warningsForRoot = [];
                pendingLegacyContextWarning.set(strictRoot, warningsForRoot);
            }
            warningsForRoot.push(fiber);
        }
    };
    ReactStrictModeWarnings.flushLegacyContextWarning = function() {
        pendingLegacyContextWarning.forEach(function(fiberArray, strictRoot) {
            if (fiberArray.length === 0) return;
            var firstFiber = fiberArray[0];
            var uniqueNames = new Set();
            fiberArray.forEach(function(fiber) {
                uniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
                didWarnAboutLegacyContext.add(fiber.type);
            });
            var sortedNames = setToSortedString(uniqueNames);
            try {
                setCurrentFiber(firstFiber);
                error("Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context", sortedNames);
            } finally{
                resetCurrentFiber();
            }
        });
    };
    ReactStrictModeWarnings.discardPendingWarnings = function() {
        pendingComponentWillMountWarnings = [];
        pendingUNSAFE_ComponentWillMountWarnings = [];
        pendingComponentWillReceivePropsWarnings = [];
        pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
        pendingComponentWillUpdateWarnings = [];
        pendingUNSAFE_ComponentWillUpdateWarnings = [];
        pendingLegacyContextWarning = new Map();
    };
    var didWarnAboutMaps;
    var didWarnAboutGenerators;
    var didWarnAboutStringRefs;
    var ownerHasKeyUseWarning;
    var ownerHasFunctionTypeWarning;
    var warnForMissingKey = function(child, returnFiber) {};
    didWarnAboutMaps = false;
    didWarnAboutGenerators = false;
    didWarnAboutStringRefs = {};
    /**
   * Warn if there's no key explicitly set on dynamic arrays of children or
   * object keys are not valid. This allows us to keep track of children between
   * updates.
   */ ownerHasKeyUseWarning = {};
    ownerHasFunctionTypeWarning = {};
    warnForMissingKey = function(child, returnFiber) {
        if (child === null || typeof child !== "object") return;
        if (!child._store || child._store.validated || child.key != null) return;
        if (typeof child._store !== "object") throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
        child._store.validated = true;
        var componentName = getComponentNameFromFiber(returnFiber) || "Component";
        if (ownerHasKeyUseWarning[componentName]) return;
        ownerHasKeyUseWarning[componentName] = true;
        error('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.');
    };
    function isReactClass(type) {
        return type.prototype && type.prototype.isReactComponent;
    }
    function coerceRef(returnFiber, current, element) {
        var mixedRef = element.ref;
        if (mixedRef !== null && typeof mixedRef !== "function" && typeof mixedRef !== "object") {
            // TODO: Clean this up once we turn on the string ref warning for
            // everyone, because the strict mode case will no longer be relevant
            if ((returnFiber.mode & StrictLegacyMode || warnAboutStringRefs) && // We warn in ReactElement.js if owner and self are equal for string refs
            // because these cannot be automatically converted to an arrow function
            // using a codemod. Therefore, we don't have to warn about string refs again.
            !(element._owner && element._self && element._owner.stateNode !== element._self) && // Will already throw with "Function components cannot have string refs"
            !(element._owner && element._owner.tag !== ClassComponent) && // Will already warn with "Function components cannot be given refs"
            !(typeof element.type === "function" && !isReactClass(element.type)) && // Will already throw with "Element ref was specified as a string (someStringRef) but no owner was set"
            element._owner) {
                var componentName = getComponentNameFromFiber(returnFiber) || "Component";
                if (!didWarnAboutStringRefs[componentName]) {
                    error('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', componentName, mixedRef);
                    didWarnAboutStringRefs[componentName] = true;
                }
            }
            if (element._owner) {
                var owner = element._owner;
                var inst;
                if (owner) {
                    var ownerFiber = owner;
                    if (ownerFiber.tag !== ClassComponent) throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
                    inst = ownerFiber.stateNode;
                }
                if (!inst) throw new Error("Missing owner for string ref " + mixedRef + ". This error is likely caused by a " + "bug in React. Please file an issue.");
                 // Assigning this to a const so Flow knows it won't change in the closure
                var resolvedInst = inst;
                checkPropStringCoercion(mixedRef, "ref");
                var stringRef = "" + mixedRef; // Check if previous string ref matches new string ref
                if (current !== null && current.ref !== null && typeof current.ref === "function" && current.ref._stringRef === stringRef) return current.ref;
                var ref = function(value) {
                    var refs = resolvedInst.refs;
                    if (value === null) delete refs[stringRef];
                    else refs[stringRef] = value;
                };
                ref._stringRef = stringRef;
                return ref;
            } else {
                if (typeof mixedRef !== "string") throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
                if (!element._owner) throw new Error("Element ref was specified as a string (" + mixedRef + ") but no owner was set. This could happen for one of" + " the following reasons:\n" + "1. You may be adding a ref to a function component\n" + "2. You may be adding a ref to a component that was not created inside a component's render method\n" + "3. You have multiple copies of React loaded\n" + "See https://reactjs.org/link/refs-must-have-owner for more information.");
            }
        }
        return mixedRef;
    }
    function throwOnInvalidObjectType(returnFiber, newChild) {
        var childString = Object.prototype.toString.call(newChild);
        throw new Error("Objects are not valid as a React child (found: " + (childString === "[object Object]" ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : childString) + "). " + "If you meant to render a collection of children, use an array " + "instead.");
    }
    function warnOnFunctionType(returnFiber) {
        var componentName = getComponentNameFromFiber(returnFiber) || "Component";
        if (ownerHasFunctionTypeWarning[componentName]) return;
        ownerHasFunctionTypeWarning[componentName] = true;
        error("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
    }
    function resolveLazy(lazyType) {
        var payload = lazyType._payload;
        var init = lazyType._init;
        return init(payload);
    } // This wrapper function exists because I expect to clone the code in each path
    // to be able to optimize each path individually by branching early. This needs
    // a compiler or we can do it manually. Helpers that don't need this branching
    // live outside of this function.
    function ChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
            if (!shouldTrackSideEffects) // Noop.
            return;
            var deletions = returnFiber.deletions;
            if (deletions === null) {
                returnFiber.deletions = [
                    childToDelete
                ];
                returnFiber.flags |= ChildDeletion;
            } else deletions.push(childToDelete);
        }
        function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) // Noop.
            return null;
             // TODO: For the shouldClone case, this could be micro-optimized a bit by
            // assuming that after the first child we've already added everything.
            var childToDelete = currentFirstChild;
            while(childToDelete !== null){
                deleteChild(returnFiber, childToDelete);
                childToDelete = childToDelete.sibling;
            }
            return null;
        }
        function mapRemainingChildren(returnFiber, currentFirstChild) {
            // Add the remaining children to a temporary map so that we can find them by
            // keys quickly. Implicit (null) keys get added to this set with their index
            // instead.
            var existingChildren = new Map();
            var existingChild = currentFirstChild;
            while(existingChild !== null){
                if (existingChild.key !== null) existingChildren.set(existingChild.key, existingChild);
                else existingChildren.set(existingChild.index, existingChild);
                existingChild = existingChild.sibling;
            }
            return existingChildren;
        }
        function useFiber(fiber, pendingProps) {
            // We currently set sibling to null and index to 0 here because it is easy
            // to forget to do before returning it. E.g. for the single child case.
            var clone = createWorkInProgress(fiber, pendingProps);
            clone.index = 0;
            clone.sibling = null;
            return clone;
        }
        function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;
            if (!shouldTrackSideEffects) {
                // During hydration, the useId algorithm needs to know which fibers are
                // part of a list of children (arrays, iterators).
                newFiber.flags |= Forked;
                return lastPlacedIndex;
            }
            var current = newFiber.alternate;
            if (current !== null) {
                var oldIndex = current.index;
                if (oldIndex < lastPlacedIndex) {
                    // This is a move.
                    newFiber.flags |= Placement;
                    return lastPlacedIndex;
                } else // This item can stay in place.
                return oldIndex;
            } else {
                // This is an insertion.
                newFiber.flags |= Placement;
                return lastPlacedIndex;
            }
        }
        function placeSingleChild(newFiber) {
            // This is simpler for the single child case. We only need to do a
            // placement for inserting new children.
            if (shouldTrackSideEffects && newFiber.alternate === null) newFiber.flags |= Placement;
            return newFiber;
        }
        function updateTextNode(returnFiber, current, textContent, lanes) {
            if (current === null || current.tag !== HostText) {
                // Insert
                var created = createFiberFromText(textContent, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, textContent);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateElement(returnFiber, current, element, lanes) {
            var elementType = element.type;
            if (elementType === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
            if (current !== null) {
                if (current.elementType === elementType || isCompatibleFamilyForHotReloading(current, element) || // Lazy types should reconcile their resolved type.
                // We need to do this after the Hot Reloading check above,
                // because hot reloading has different semantics than prod because
                // it doesn't resuspend. So we can't let the call below suspend.
                typeof elementType === "object" && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type) {
                    // Move based on index
                    var existing = useFiber(current, element.props);
                    existing.ref = coerceRef(returnFiber, current, element);
                    existing.return = returnFiber;
                    existing._debugSource = element._source;
                    existing._debugOwner = element._owner;
                    return existing;
                }
            } // Insert
            var created = createFiberFromElement(element, returnFiber.mode, lanes);
            created.ref = coerceRef(returnFiber, current, element);
            created.return = returnFiber;
            return created;
        }
        function updatePortal(returnFiber, current, portal, lanes) {
            if (current === null || current.tag !== HostPortal || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) {
                // Insert
                var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, portal.children || []);
                existing.return = returnFiber;
                return existing;
            }
        }
        function updateFragment(returnFiber, current, fragment, lanes, key) {
            if (current === null || current.tag !== Fragment) {
                // Insert
                var created = createFiberFromFragment(fragment, returnFiber.mode, lanes, key);
                created.return = returnFiber;
                return created;
            } else {
                // Update
                var existing = useFiber(current, fragment);
                existing.return = returnFiber;
                return existing;
            }
        }
        function createChild(returnFiber, newChild, lanes) {
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                var created = createFiberFromText("" + newChild, returnFiber.mode, lanes);
                created.return = returnFiber;
                return created;
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _created = createFiberFromElement(newChild, returnFiber.mode, lanes);
                        _created.ref = coerceRef(returnFiber, null, newChild);
                        _created.return = returnFiber;
                        return _created;
                    case REACT_PORTAL_TYPE:
                        var _created2 = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        _created2.return = returnFiber;
                        return _created2;
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return createChild(returnFiber, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    var _created3 = createFiberFromFragment(newChild, returnFiber.mode, lanes, null);
                    _created3.return = returnFiber;
                    return _created3;
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        function updateSlot(returnFiber, oldFiber, newChild, lanes) {
            // Update the fiber if the keys match, otherwise return null.
            var key = oldFiber !== null ? oldFiber.key : null;
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
                // Text nodes don't have keys. If the previous node is implicitly keyed
                // we can continue to replace it without aborting even if it is not a text
                // node.
                if (key !== null) return null;
                return updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        if (newChild.key === key) return updateElement(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                    case REACT_PORTAL_TYPE:
                        if (newChild.key === key) return updatePortal(returnFiber, oldFiber, newChild, lanes);
                        else return null;
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return updateSlot(returnFiber, oldFiber, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    if (key !== null) return null;
                    return updateFragment(returnFiber, oldFiber, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") {
                // Text nodes don't have keys, so we neither have to check the old nor
                // new node for the key. If both are text nodes, they match.
                var matchedFiber = existingChildren.get(newIdx) || null;
                return updateTextNode(returnFiber, matchedFiber, "" + newChild, lanes);
            }
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        var _matchedFiber = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updateElement(returnFiber, _matchedFiber, newChild, lanes);
                    case REACT_PORTAL_TYPE:
                        var _matchedFiber2 = existingChildren.get(newChild.key === null ? newIdx : newChild.key) || null;
                        return updatePortal(returnFiber, _matchedFiber2, newChild, lanes);
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init;
                        return updateFromMap(existingChildren, returnFiber, newIdx, init(payload), lanes);
                }
                if (isArray(newChild) || getIteratorFn(newChild)) {
                    var _matchedFiber3 = existingChildren.get(newIdx) || null;
                    return updateFragment(returnFiber, _matchedFiber3, newChild, lanes, null);
                }
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return null;
        }
        /**
   * Warns if there is a duplicate or missing key
   */ function warnOnInvalidKey(child, knownKeys, returnFiber) {
            if (typeof child !== "object" || child === null) return knownKeys;
            switch(child.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    warnForMissingKey(child, returnFiber);
                    var key = child.key;
                    if (typeof key !== "string") break;
                    if (knownKeys === null) {
                        knownKeys = new Set();
                        knownKeys.add(key);
                        break;
                    }
                    if (!knownKeys.has(key)) {
                        knownKeys.add(key);
                        break;
                    }
                    error("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted \u2014 the behavior is unsupported and could change in a future version.", key);
                    break;
                case REACT_LAZY_TYPE:
                    var payload = child._payload;
                    var init = child._init;
                    warnOnInvalidKey(init(payload), knownKeys, returnFiber);
                    break;
            }
            return knownKeys;
        }
        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
            // First, validate keys.
            var knownKeys = null;
            for(var i = 0; i < newChildren.length; i++){
                var child = newChildren[i];
                knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
            }
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            for(; oldFiber !== null && newIdx < newChildren.length; newIdx++){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (newIdx === newChildren.length) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                if (getIsHydrating()) {
                    var numberOfForks = newIdx;
                    pushTreeFork(returnFiber, numberOfForks);
                }
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; newIdx < newChildren.length; newIdx++){
                    var _newFiber = createChild(returnFiber, newChildren[newIdx], lanes);
                    if (_newFiber === null) continue;
                    lastPlacedIndex = placeChild(_newFiber, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber;
                    else previousNewFiber.sibling = _newFiber;
                    previousNewFiber = _newFiber;
                }
                if (getIsHydrating()) {
                    var _numberOfForks = newIdx;
                    pushTreeFork(returnFiber, _numberOfForks);
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; newIdx < newChildren.length; newIdx++){
                var _newFiber2 = updateFromMap(existingChildren, returnFiber, newIdx, newChildren[newIdx], lanes);
                if (_newFiber2 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber2.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber2.key === null ? newIdx : _newFiber2.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber2, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber2;
                    else previousNewFiber.sibling = _newFiber2;
                    previousNewFiber = _newFiber2;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            if (getIsHydrating()) {
                var _numberOfForks2 = newIdx;
                pushTreeFork(returnFiber, _numberOfForks2);
            }
            return resultingFirstChild;
        }
        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildrenIterable, lanes) {
            // This is the same implementation as reconcileChildrenArray(),
            // but using the iterator instead.
            var iteratorFn = getIteratorFn(newChildrenIterable);
            if (typeof iteratorFn !== "function") throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
            // We don't support rendering Generators because it's a mutation.
            // See https://github.com/facebook/react/issues/12995
            if (typeof Symbol === "function" && // $FlowFixMe Flow doesn't know about toStringTag
            newChildrenIterable[Symbol.toStringTag] === "Generator") {
                if (!didWarnAboutGenerators) error("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers.");
                didWarnAboutGenerators = true;
            } // Warn about using Maps as children
            if (newChildrenIterable.entries === iteratorFn) {
                if (!didWarnAboutMaps) error("Using Maps as children is not supported. Use an array of keyed ReactElements instead.");
                didWarnAboutMaps = true;
            } // First, validate keys.
            // We'll get a different iterator later for the main pass.
            var _newChildren = iteratorFn.call(newChildrenIterable);
            if (_newChildren) {
                var knownKeys = null;
                var _step = _newChildren.next();
                for(; !_step.done; _step = _newChildren.next()){
                    var child = _step.value;
                    knownKeys = warnOnInvalidKey(child, knownKeys, returnFiber);
                }
            }
            var newChildren = iteratorFn.call(newChildrenIterable);
            if (newChildren == null) throw new Error("An iterable object provided no iterator.");
            var resultingFirstChild = null;
            var previousNewFiber = null;
            var oldFiber = currentFirstChild;
            var lastPlacedIndex = 0;
            var newIdx = 0;
            var nextOldFiber = null;
            var step = newChildren.next();
            for(; oldFiber !== null && !step.done; newIdx++, step = newChildren.next()){
                if (oldFiber.index > newIdx) {
                    nextOldFiber = oldFiber;
                    oldFiber = null;
                } else nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
                if (newFiber === null) {
                    // TODO: This breaks on empty slots like null children. That's
                    // unfortunate because it triggers the slow path all the time. We need
                    // a better way to communicate whether this was a miss or null,
                    // boolean, undefined, etc.
                    if (oldFiber === null) oldFiber = nextOldFiber;
                    break;
                }
                if (shouldTrackSideEffects) {
                    if (oldFiber && newFiber.alternate === null) // We matched the slot, but we didn't reuse the existing fiber, so we
                    // need to delete the existing child.
                    deleteChild(returnFiber, oldFiber);
                }
                lastPlacedIndex = placeChild(newFiber, lastPlacedIndex, newIdx);
                if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                resultingFirstChild = newFiber;
                else // TODO: Defer siblings if we're not at the right index for this slot.
                // I.e. if we had null values before, then we want to defer this
                // for each null value. However, we also don't want to call updateSlot
                // with the previous one.
                previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (step.done) {
                // We've reached the end of the new children. We can delete the rest.
                deleteRemainingChildren(returnFiber, oldFiber);
                if (getIsHydrating()) {
                    var numberOfForks = newIdx;
                    pushTreeFork(returnFiber, numberOfForks);
                }
                return resultingFirstChild;
            }
            if (oldFiber === null) {
                // If we don't have any more existing children we can choose a fast path
                // since the rest will all be insertions.
                for(; !step.done; newIdx++, step = newChildren.next()){
                    var _newFiber3 = createChild(returnFiber, step.value, lanes);
                    if (_newFiber3 === null) continue;
                    lastPlacedIndex = placeChild(_newFiber3, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) // TODO: Move out of the loop. This only happens for the first run.
                    resultingFirstChild = _newFiber3;
                    else previousNewFiber.sibling = _newFiber3;
                    previousNewFiber = _newFiber3;
                }
                if (getIsHydrating()) {
                    var _numberOfForks3 = newIdx;
                    pushTreeFork(returnFiber, _numberOfForks3);
                }
                return resultingFirstChild;
            } // Add all children to a key map for quick lookups.
            var existingChildren = mapRemainingChildren(returnFiber, oldFiber); // Keep scanning and use the map to restore deleted items as moves.
            for(; !step.done; newIdx++, step = newChildren.next()){
                var _newFiber4 = updateFromMap(existingChildren, returnFiber, newIdx, step.value, lanes);
                if (_newFiber4 !== null) {
                    if (shouldTrackSideEffects) {
                        if (_newFiber4.alternate !== null) // The new fiber is a work in progress, but if there exists a
                        // current, that means that we reused the fiber. We need to delete
                        // it from the child list so that we don't add it to the deletion
                        // list.
                        existingChildren.delete(_newFiber4.key === null ? newIdx : _newFiber4.key);
                    }
                    lastPlacedIndex = placeChild(_newFiber4, lastPlacedIndex, newIdx);
                    if (previousNewFiber === null) resultingFirstChild = _newFiber4;
                    else previousNewFiber.sibling = _newFiber4;
                    previousNewFiber = _newFiber4;
                }
            }
            if (shouldTrackSideEffects) // Any existing children that weren't consumed above were deleted. We need
            // to add them to the deletion list.
            existingChildren.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            if (getIsHydrating()) {
                var _numberOfForks4 = newIdx;
                pushTreeFork(returnFiber, _numberOfForks4);
            }
            return resultingFirstChild;
        }
        function reconcileSingleTextNode(returnFiber, currentFirstChild, textContent, lanes) {
            // There's no need to check for keys on text nodes since we don't have a
            // way to define them.
            if (currentFirstChild !== null && currentFirstChild.tag === HostText) {
                // We already have an existing node so let's just update it and delete
                // the rest.
                deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                var existing = useFiber(currentFirstChild, textContent);
                existing.return = returnFiber;
                return existing;
            } // The existing first child is not a text node so we need to create one
            // and delete the existing ones.
            deleteRemainingChildren(returnFiber, currentFirstChild);
            var created = createFiberFromText(textContent, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        }
        function reconcileSingleElement(returnFiber, currentFirstChild, element, lanes) {
            var key = element.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    var elementType = element.type;
                    if (elementType === REACT_FRAGMENT_TYPE) {
                        if (child.tag === Fragment) {
                            deleteRemainingChildren(returnFiber, child.sibling);
                            var existing = useFiber(child, element.props.children);
                            existing.return = returnFiber;
                            existing._debugSource = element._source;
                            existing._debugOwner = element._owner;
                            return existing;
                        }
                    } else if (child.elementType === elementType || isCompatibleFamilyForHotReloading(child, element) || // Lazy types should reconcile their resolved type.
                    // We need to do this after the Hot Reloading check above,
                    // because hot reloading has different semantics than prod because
                    // it doesn't resuspend. So we can't let the call below suspend.
                    typeof elementType === "object" && elementType !== null && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === child.type) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var _existing = useFiber(child, element.props);
                        _existing.ref = coerceRef(returnFiber, child, element);
                        _existing.return = returnFiber;
                        _existing._debugSource = element._source;
                        _existing._debugOwner = element._owner;
                        return _existing;
                    }
                     // Didn't match.
                    deleteRemainingChildren(returnFiber, child);
                    break;
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            if (element.type === REACT_FRAGMENT_TYPE) {
                var created = createFiberFromFragment(element.props.children, returnFiber.mode, lanes, element.key);
                created.return = returnFiber;
                return created;
            } else {
                var _created4 = createFiberFromElement(element, returnFiber.mode, lanes);
                _created4.ref = coerceRef(returnFiber, currentFirstChild, element);
                _created4.return = returnFiber;
                return _created4;
            }
        }
        function reconcileSinglePortal(returnFiber, currentFirstChild, portal, lanes) {
            var key = portal.key;
            var child = currentFirstChild;
            while(child !== null){
                // TODO: If key === null and child.key === null, then this only applies to
                // the first item in the list.
                if (child.key === key) {
                    if (child.tag === HostPortal && child.stateNode.containerInfo === portal.containerInfo && child.stateNode.implementation === portal.implementation) {
                        deleteRemainingChildren(returnFiber, child.sibling);
                        var existing = useFiber(child, portal.children || []);
                        existing.return = returnFiber;
                        return existing;
                    } else {
                        deleteRemainingChildren(returnFiber, child);
                        break;
                    }
                } else deleteChild(returnFiber, child);
                child = child.sibling;
            }
            var created = createFiberFromPortal(portal, returnFiber.mode, lanes);
            created.return = returnFiber;
            return created;
        } // This API will tag the children with the side-effect of the reconciliation
        // itself. They will be added to the side-effect list as we pass through the
        // children and the parent.
        function reconcileChildFibers(returnFiber, currentFirstChild, newChild, lanes) {
            // This function is not recursive.
            // If the top level item is an array, we treat it as a set of children,
            // not as a fragment. Nested arrays on the other hand will be treated as
            // fragment nodes. Recursion happens at the normal flow.
            // Handle top level unkeyed fragments as if they were arrays.
            // This leads to an ambiguity between <>{[...]}</> and <>...</>.
            // We treat the ambiguous cases above the same.
            var isUnkeyedTopLevelFragment = typeof newChild === "object" && newChild !== null && newChild.type === REACT_FRAGMENT_TYPE && newChild.key === null;
            if (isUnkeyedTopLevelFragment) newChild = newChild.props.children;
             // Handle object types
            if (typeof newChild === "object" && newChild !== null) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return placeSingleChild(reconcileSingleElement(returnFiber, currentFirstChild, newChild, lanes));
                    case REACT_PORTAL_TYPE:
                        return placeSingleChild(reconcileSinglePortal(returnFiber, currentFirstChild, newChild, lanes));
                    case REACT_LAZY_TYPE:
                        var payload = newChild._payload;
                        var init = newChild._init; // TODO: This function is supposed to be non-recursive.
                        return reconcileChildFibers(returnFiber, currentFirstChild, init(payload), lanes);
                }
                if (isArray(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
                if (getIteratorFn(newChild)) return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            if (typeof newChild === "string" && newChild !== "" || typeof newChild === "number") return placeSingleChild(reconcileSingleTextNode(returnFiber, currentFirstChild, "" + newChild, lanes));
            if (typeof newChild === "function") warnOnFunctionType(returnFiber);
            return deleteRemainingChildren(returnFiber, currentFirstChild);
        }
        return reconcileChildFibers;
    }
    var reconcileChildFibers = ChildReconciler(true);
    var mountChildFibers = ChildReconciler(false);
    function cloneChildFibers(current, workInProgress) {
        if (current !== null && workInProgress.child !== current.child) throw new Error("Resuming work not yet implemented.");
        if (workInProgress.child === null) return;
        var currentChild = workInProgress.child;
        var newChild = createWorkInProgress(currentChild, currentChild.pendingProps);
        workInProgress.child = newChild;
        newChild.return = workInProgress;
        while(currentChild.sibling !== null){
            currentChild = currentChild.sibling;
            newChild = newChild.sibling = createWorkInProgress(currentChild, currentChild.pendingProps);
            newChild.return = workInProgress;
        }
        newChild.sibling = null;
    } // Reset a workInProgress child set to prepare it for a second pass.
    function resetChildFibers(workInProgress, lanes) {
        var child = workInProgress.child;
        while(child !== null){
            resetWorkInProgress(child, lanes);
            child = child.sibling;
        }
    }
    var valueCursor = createCursor(null);
    var rendererSigil;
    // Use this to detect multiple renderers using the same context
    rendererSigil = {};
    var currentlyRenderingFiber = null;
    var lastContextDependency = null;
    var lastFullyObservedContext = null;
    var isDisallowedContextReadInDEV = false;
    function resetContextDependencies() {
        // This is called right before React yields execution, to ensure `readContext`
        // cannot be called outside the render phase.
        currentlyRenderingFiber = null;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        isDisallowedContextReadInDEV = false;
    }
    function enterDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = true;
    }
    function exitDisallowedContextReadInDEV() {
        isDisallowedContextReadInDEV = false;
    }
    function pushProvider(providerFiber, context, nextValue) {
        push(valueCursor, context._currentValue, providerFiber);
        context._currentValue = nextValue;
        if (context._currentRenderer !== undefined && context._currentRenderer !== null && context._currentRenderer !== rendererSigil) error("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.");
        context._currentRenderer = rendererSigil;
    }
    function popProvider(context, providerFiber) {
        var currentValue = valueCursor.current;
        pop(valueCursor, providerFiber);
        context._currentValue = currentValue;
    }
    function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
        // Update the child lanes of all the ancestors, including the alternates.
        var node = parent;
        while(node !== null){
            var alternate = node.alternate;
            if (!isSubsetOfLanes(node.childLanes, renderLanes)) {
                node.childLanes = mergeLanes(node.childLanes, renderLanes);
                if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            } else if (alternate !== null && !isSubsetOfLanes(alternate.childLanes, renderLanes)) alternate.childLanes = mergeLanes(alternate.childLanes, renderLanes);
            if (node === propagationRoot) break;
            node = node.return;
        }
        if (node !== propagationRoot) error("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
    }
    function propagateContextChange(workInProgress, context, renderLanes) {
        propagateContextChange_eager(workInProgress, context, renderLanes);
    }
    function propagateContextChange_eager(workInProgress, context, renderLanes) {
        var fiber = workInProgress.child;
        if (fiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
        fiber.return = workInProgress;
        while(fiber !== null){
            var nextFiber = void 0; // Visit this fiber.
            var list = fiber.dependencies;
            if (list !== null) {
                nextFiber = fiber.child;
                var dependency = list.firstContext;
                while(dependency !== null){
                    // Check if the context matches.
                    if (dependency.context === context) {
                        // Match! Schedule an update on this fiber.
                        if (fiber.tag === ClassComponent) {
                            // Schedule a force update on the work-in-progress.
                            var lane = pickArbitraryLane(renderLanes);
                            var update = createUpdate(NoTimestamp, lane);
                            update.tag = ForceUpdate; // TODO: Because we don't have a work-in-progress, this will add the
                            // update to the current fiber, too, which means it will persist even if
                            // this render is thrown away. Since it's a race condition, not sure it's
                            // worth fixing.
                            // Inlined `enqueueUpdate` to remove interleaved update check
                            var updateQueue = fiber.updateQueue;
                            if (updateQueue === null) ;
                            else {
                                var sharedQueue = updateQueue.shared;
                                var pending = sharedQueue.pending;
                                if (pending === null) // This is the first update. Create a circular list.
                                update.next = update;
                                else {
                                    update.next = pending.next;
                                    pending.next = update;
                                }
                                sharedQueue.pending = update;
                            }
                        }
                        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
                        var alternate = fiber.alternate;
                        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
                        scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress); // Mark the updated lanes on the list, too.
                        list.lanes = mergeLanes(list.lanes, renderLanes); // Since we already found a match, we can stop traversing the
                        break;
                    }
                    dependency = dependency.next;
                }
            } else if (fiber.tag === ContextProvider) // Don't scan deeper if this is a matching provider
            nextFiber = fiber.type === workInProgress.type ? null : fiber.child;
            else if (fiber.tag === DehydratedFragment) {
                // If a dehydrated suspense boundary is in this subtree, we don't know
                // if it will have any context consumers in it. The best we can do is
                // mark it as having updates.
                var parentSuspense = fiber.return;
                if (parentSuspense === null) throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
                parentSuspense.lanes = mergeLanes(parentSuspense.lanes, renderLanes);
                var _alternate = parentSuspense.alternate;
                if (_alternate !== null) _alternate.lanes = mergeLanes(_alternate.lanes, renderLanes);
                 // This is intentionally passing this fiber as the parent
                // because we want to schedule this fiber as having work
                // on its children. We'll use the childLanes on
                // this fiber to indicate that a context has changed.
                scheduleContextWorkOnParentPath(parentSuspense, renderLanes, workInProgress);
                nextFiber = fiber.sibling;
            } else // Traverse down.
            nextFiber = fiber.child;
            if (nextFiber !== null) // Set the return pointer of the child to the work-in-progress fiber.
            nextFiber.return = fiber;
            else {
                // No child. Traverse to next sibling.
                nextFiber = fiber;
                while(nextFiber !== null){
                    if (nextFiber === workInProgress) {
                        // We're back to the root of this subtree. Exit.
                        nextFiber = null;
                        break;
                    }
                    var sibling = nextFiber.sibling;
                    if (sibling !== null) {
                        // Set the return pointer of the sibling to the work-in-progress fiber.
                        sibling.return = nextFiber.return;
                        nextFiber = sibling;
                        break;
                    } // No more siblings. Traverse up.
                    nextFiber = nextFiber.return;
                }
            }
            fiber = nextFiber;
        }
    }
    function prepareToReadContext(workInProgress, renderLanes) {
        currentlyRenderingFiber = workInProgress;
        lastContextDependency = null;
        lastFullyObservedContext = null;
        var dependencies = workInProgress.dependencies;
        if (dependencies !== null) {
            var firstContext = dependencies.firstContext;
            if (firstContext !== null) {
                if (includesSomeLane(dependencies.lanes, renderLanes)) // Context list has a pending update. Mark that this fiber performed work.
                markWorkInProgressReceivedUpdate();
                 // Reset the work-in-progress list
                dependencies.firstContext = null;
            }
        }
    }
    function readContext(context) {
        // This warning would fire if you read context inside a Hook like useMemo.
        // Unlike the class check below, it's not enforced in production for perf.
        if (isDisallowedContextReadInDEV) error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        var value = context._currentValue;
        if (lastFullyObservedContext === context) ;
        else {
            var contextItem = {
                context: context,
                memoizedValue: value,
                next: null
            };
            if (lastContextDependency === null) {
                if (currentlyRenderingFiber === null) throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
                 // This is the first dependency for this component. Create a new list.
                lastContextDependency = contextItem;
                currentlyRenderingFiber.dependencies = {
                    lanes: NoLanes,
                    firstContext: contextItem
                };
            } else // Append a new context item.
            lastContextDependency = lastContextDependency.next = contextItem;
        }
        return value;
    }
    // render. When this render exits, either because it finishes or because it is
    // interrupted, the interleaved updates will be transferred onto the main part
    // of the queue.
    var concurrentQueues = null;
    function pushConcurrentUpdateQueue(queue) {
        if (concurrentQueues === null) concurrentQueues = [
            queue
        ];
        else concurrentQueues.push(queue);
    }
    function finishQueueingConcurrentUpdates() {
        // Transfer the interleaved updates onto the main queue. Each queue has a
        // `pending` field and an `interleaved` field. When they are not null, they
        // point to the last node in a circular linked list. We need to append the
        // interleaved list to the end of the pending list by joining them into a
        // single, circular list.
        if (concurrentQueues !== null) {
            for(var i = 0; i < concurrentQueues.length; i++){
                var queue = concurrentQueues[i];
                var lastInterleavedUpdate = queue.interleaved;
                if (lastInterleavedUpdate !== null) {
                    queue.interleaved = null;
                    var firstInterleavedUpdate = lastInterleavedUpdate.next;
                    var lastPendingUpdate = queue.pending;
                    if (lastPendingUpdate !== null) {
                        var firstPendingUpdate = lastPendingUpdate.next;
                        lastPendingUpdate.next = firstInterleavedUpdate;
                        lastInterleavedUpdate.next = firstPendingUpdate;
                    }
                    queue.pending = lastInterleavedUpdate;
                }
            }
            concurrentQueues = null;
        }
    }
    function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    }
    function enqueueConcurrentHookUpdateAndEagerlyBailout(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
    }
    function enqueueConcurrentClassUpdate(fiber, queue, update, lane) {
        var interleaved = queue.interleaved;
        if (interleaved === null) {
            // This is the first update. Create a circular list.
            update.next = update; // At the end of the current render, this queue's interleaved updates will
            // be transferred to the pending queue.
            pushConcurrentUpdateQueue(queue);
        } else {
            update.next = interleaved.next;
            interleaved.next = update;
        }
        queue.interleaved = update;
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    }
    function enqueueConcurrentRenderForLane(fiber, lane) {
        return markUpdateLaneFromFiberToRoot(fiber, lane);
    } // Calling this function outside this module should only be done for backwards
    // compatibility and should always be accompanied by a warning.
    var unsafe_markUpdateLaneFromFiberToRoot = markUpdateLaneFromFiberToRoot;
    function markUpdateLaneFromFiberToRoot(sourceFiber, lane) {
        // Update the source fiber's lanes
        sourceFiber.lanes = mergeLanes(sourceFiber.lanes, lane);
        var alternate = sourceFiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, lane);
        if (alternate === null && (sourceFiber.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
        var node = sourceFiber;
        var parent = sourceFiber.return;
        while(parent !== null){
            parent.childLanes = mergeLanes(parent.childLanes, lane);
            alternate = parent.alternate;
            if (alternate !== null) alternate.childLanes = mergeLanes(alternate.childLanes, lane);
            else if ((parent.flags & (Placement | Hydrating)) !== NoFlags) warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
            node = parent;
            parent = parent.return;
        }
        if (node.tag === HostRoot) {
            var root = node.stateNode;
            return root;
        } else return null;
    }
    var UpdateState = 0;
    var ReplaceState = 1;
    var ForceUpdate = 2;
    var CaptureUpdate = 3; // Global state that is reset at the beginning of calling `processUpdateQueue`.
    // It should only be read right after calling `processUpdateQueue`, via
    // `checkHasForceUpdateAfterProcessing`.
    var hasForceUpdate = false;
    var didWarnUpdateInsideUpdate;
    var currentlyProcessingQueue;
    didWarnUpdateInsideUpdate = false;
    currentlyProcessingQueue = null;
    function initializeUpdateQueue(fiber) {
        var queue = {
            baseState: fiber.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                interleaved: null,
                lanes: NoLanes
            },
            effects: null
        };
        fiber.updateQueue = queue;
    }
    function cloneUpdateQueue(current, workInProgress) {
        // Clone the update queue from current. Unless it's already a clone.
        var queue = workInProgress.updateQueue;
        var currentQueue = current.updateQueue;
        if (queue === currentQueue) {
            var clone = {
                baseState: currentQueue.baseState,
                firstBaseUpdate: currentQueue.firstBaseUpdate,
                lastBaseUpdate: currentQueue.lastBaseUpdate,
                shared: currentQueue.shared,
                effects: currentQueue.effects
            };
            workInProgress.updateQueue = clone;
        }
    }
    function createUpdate(eventTime, lane) {
        var update = {
            eventTime: eventTime,
            lane: lane,
            tag: UpdateState,
            payload: null,
            callback: null,
            next: null
        };
        return update;
    }
    function enqueueUpdate(fiber, update, lane) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return null;
        var sharedQueue = updateQueue.shared;
        if (currentlyProcessingQueue === sharedQueue && !didWarnUpdateInsideUpdate) {
            error("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.");
            didWarnUpdateInsideUpdate = true;
        }
        if (isUnsafeClassRenderPhaseUpdate()) {
            // This is an unsafe render phase update. Add directly to the update
            // queue so we can process it immediately during the current render.
            var pending = sharedQueue.pending;
            if (pending === null) // This is the first update. Create a circular list.
            update.next = update;
            else {
                update.next = pending.next;
                pending.next = update;
            }
            sharedQueue.pending = update; // Update the childLanes even though we're most likely already rendering
            // this fiber. This is for backwards compatibility in the case where you
            // update a different component during render phase than the one that is
            // currently renderings (a pattern that is accompanied by a warning).
            return unsafe_markUpdateLaneFromFiberToRoot(fiber, lane);
        } else return enqueueConcurrentClassUpdate(fiber, sharedQueue, update, lane);
    }
    function entangleTransitions(root, fiber, lane) {
        var updateQueue = fiber.updateQueue;
        if (updateQueue === null) // Only occurs if the fiber has been unmounted.
        return;
        var sharedQueue = updateQueue.shared;
        if (isTransitionLane(lane)) {
            var queueLanes = sharedQueue.lanes; // If any entangled lanes are no longer pending on the root, then they must
            // have finished. We can remove them from the shared queue, which represents
            // a superset of the actually pending lanes. In some cases we may entangle
            // more than we need to, but that's OK. In fact it's worse if we *don't*
            // entangle when we should.
            queueLanes = intersectLanes(queueLanes, root.pendingLanes); // Entangle the new transition lane with the other transition lanes.
            var newQueueLanes = mergeLanes(queueLanes, lane);
            sharedQueue.lanes = newQueueLanes; // Even if queue.lanes already include lane, we don't know for certain if
            // the lane finished since the last time we entangled it. So we need to
            // entangle it again, just to be sure.
            markRootEntangled(root, newQueueLanes);
        }
    }
    function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
        // Captured updates are updates that are thrown by a child during the render
        // phase. They should be discarded if the render is aborted. Therefore,
        // we should only put them on the work-in-progress queue, not the current one.
        var queue = workInProgress.updateQueue; // Check if the work-in-progress queue is a clone.
        var current = workInProgress.alternate;
        if (current !== null) {
            var currentQueue = current.updateQueue;
            if (queue === currentQueue) {
                // The work-in-progress queue is the same as current. This happens when
                // we bail out on a parent fiber that then captures an error thrown by
                // a child. Since we want to append the update only to the work-in
                // -progress queue, we need to clone the updates. We usually clone during
                // processUpdateQueue, but that didn't happen in this case because we
                // skipped over the parent when we bailed out.
                var newFirst = null;
                var newLast = null;
                var firstBaseUpdate = queue.firstBaseUpdate;
                if (firstBaseUpdate !== null) {
                    // Loop through the updates and clone them.
                    var update = firstBaseUpdate;
                    do {
                        var clone = {
                            eventTime: update.eventTime,
                            lane: update.lane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        if (newLast === null) newFirst = newLast = clone;
                        else {
                            newLast.next = clone;
                            newLast = clone;
                        }
                        update = update.next;
                    }while (update !== null); // Append the captured update the end of the cloned list.
                    if (newLast === null) newFirst = newLast = capturedUpdate;
                    else {
                        newLast.next = capturedUpdate;
                        newLast = capturedUpdate;
                    }
                } else // There are no base updates.
                newFirst = newLast = capturedUpdate;
                queue = {
                    baseState: currentQueue.baseState,
                    firstBaseUpdate: newFirst,
                    lastBaseUpdate: newLast,
                    shared: currentQueue.shared,
                    effects: currentQueue.effects
                };
                workInProgress.updateQueue = queue;
                return;
            }
        } // Append the update to the end of the list.
        var lastBaseUpdate = queue.lastBaseUpdate;
        if (lastBaseUpdate === null) queue.firstBaseUpdate = capturedUpdate;
        else lastBaseUpdate.next = capturedUpdate;
        queue.lastBaseUpdate = capturedUpdate;
    }
    function getStateFromUpdate(workInProgress, queue, update, prevState, nextProps, instance) {
        switch(update.tag){
            case ReplaceState:
                var payload = update.payload;
                if (typeof payload === "function") {
                    enterDisallowedContextReadInDEV();
                    var nextState = payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictLegacyMode) {
                        setIsStrictModeForDevtools(true);
                        try {
                            payload.call(instance, prevState, nextProps);
                        } finally{
                            setIsStrictModeForDevtools(false);
                        }
                    }
                    exitDisallowedContextReadInDEV();
                    return nextState;
                } // State object
                return payload;
            case CaptureUpdate:
                workInProgress.flags = workInProgress.flags & ~ShouldCapture | DidCapture;
            // Intentional fallthrough
            case UpdateState:
                var _payload = update.payload;
                var partialState;
                if (typeof _payload === "function") {
                    enterDisallowedContextReadInDEV();
                    partialState = _payload.call(instance, prevState, nextProps);
                    if (workInProgress.mode & StrictLegacyMode) {
                        setIsStrictModeForDevtools(true);
                        try {
                            _payload.call(instance, prevState, nextProps);
                        } finally{
                            setIsStrictModeForDevtools(false);
                        }
                    }
                    exitDisallowedContextReadInDEV();
                } else // Partial state object
                partialState = _payload;
                if (partialState === null || partialState === undefined) // Null and undefined are treated as no-ops.
                return prevState;
                 // Merge the partial state and the previous state.
                return assign({}, prevState, partialState);
            case ForceUpdate:
                hasForceUpdate = true;
                return prevState;
        }
        return prevState;
    }
    function processUpdateQueue(workInProgress, props, instance, renderLanes) {
        // This is always non-null on a ClassComponent or HostRoot
        var queue = workInProgress.updateQueue;
        hasForceUpdate = false;
        currentlyProcessingQueue = queue.shared;
        var firstBaseUpdate = queue.firstBaseUpdate;
        var lastBaseUpdate = queue.lastBaseUpdate; // Check if there are pending updates. If so, transfer them to the base queue.
        var pendingQueue = queue.shared.pending;
        if (pendingQueue !== null) {
            queue.shared.pending = null; // The pending queue is circular. Disconnect the pointer between first
            // and last so that it's non-circular.
            var lastPendingUpdate = pendingQueue;
            var firstPendingUpdate = lastPendingUpdate.next;
            lastPendingUpdate.next = null; // Append pending updates to base queue
            if (lastBaseUpdate === null) firstBaseUpdate = firstPendingUpdate;
            else lastBaseUpdate.next = firstPendingUpdate;
            lastBaseUpdate = lastPendingUpdate; // If there's a current queue, and it's different from the base queue, then
            // we need to transfer the updates to that queue, too. Because the base
            // queue is a singly-linked list with no cycles, we can append to both
            // lists and take advantage of structural sharing.
            // TODO: Pass `current` as argument
            var current = workInProgress.alternate;
            if (current !== null) {
                // This is always non-null on a ClassComponent or HostRoot
                var currentQueue = current.updateQueue;
                var currentLastBaseUpdate = currentQueue.lastBaseUpdate;
                if (currentLastBaseUpdate !== lastBaseUpdate) {
                    if (currentLastBaseUpdate === null) currentQueue.firstBaseUpdate = firstPendingUpdate;
                    else currentLastBaseUpdate.next = firstPendingUpdate;
                    currentQueue.lastBaseUpdate = lastPendingUpdate;
                }
            }
        } // These values may change as we process the queue.
        if (firstBaseUpdate !== null) {
            // Iterate through the list of updates to compute the result.
            var newState = queue.baseState; // TODO: Don't need to accumulate this. Instead, we can remove renderLanes
            // from the original lanes.
            var newLanes = NoLanes;
            var newBaseState = null;
            var newFirstBaseUpdate = null;
            var newLastBaseUpdate = null;
            var update = firstBaseUpdate;
            do {
                var updateLane = update.lane;
                var updateEventTime = update.eventTime;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        eventTime: updateEventTime,
                        lane: updateLane,
                        tag: update.tag,
                        payload: update.payload,
                        callback: update.callback,
                        next: null
                    };
                    if (newLastBaseUpdate === null) {
                        newFirstBaseUpdate = newLastBaseUpdate = clone;
                        newBaseState = newState;
                    } else newLastBaseUpdate = newLastBaseUpdate.next = clone;
                     // Update the remaining priority in the queue.
                    newLanes = mergeLanes(newLanes, updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newLastBaseUpdate !== null) {
                        var _clone = {
                            eventTime: updateEventTime,
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            tag: update.tag,
                            payload: update.payload,
                            callback: update.callback,
                            next: null
                        };
                        newLastBaseUpdate = newLastBaseUpdate.next = _clone;
                    } // Process this update.
                    newState = getStateFromUpdate(workInProgress, queue, update, newState, props, instance);
                    var callback = update.callback;
                    if (callback !== null && // If the update was already committed, we should not queue its
                    // callback again.
                    update.lane !== NoLane) {
                        workInProgress.flags |= Callback;
                        var effects = queue.effects;
                        if (effects === null) queue.effects = [
                            update
                        ];
                        else effects.push(update);
                    }
                }
                update = update.next;
                if (update === null) {
                    pendingQueue = queue.shared.pending;
                    if (pendingQueue === null) break;
                    else {
                        // An update was scheduled from inside a reducer. Add the new
                        // pending updates to the end of the list and keep processing.
                        var _lastPendingUpdate = pendingQueue; // Intentionally unsound. Pending updates form a circular list, but we
                        // unravel them when transferring them to the base queue.
                        var _firstPendingUpdate = _lastPendingUpdate.next;
                        _lastPendingUpdate.next = null;
                        update = _firstPendingUpdate;
                        queue.lastBaseUpdate = _lastPendingUpdate;
                        queue.shared.pending = null;
                    }
                }
            }while (true);
            if (newLastBaseUpdate === null) newBaseState = newState;
            queue.baseState = newBaseState;
            queue.firstBaseUpdate = newFirstBaseUpdate;
            queue.lastBaseUpdate = newLastBaseUpdate; // Interleaved updates are stored on a separate queue. We aren't going to
            // process them during this render, but we do need to track which lanes
            // are remaining.
            var lastInterleaved = queue.shared.interleaved;
            if (lastInterleaved !== null) {
                var interleaved = lastInterleaved;
                do {
                    newLanes = mergeLanes(newLanes, interleaved.lane);
                    interleaved = interleaved.next;
                }while (interleaved !== lastInterleaved);
            } else if (firstBaseUpdate === null) // `queue.lanes` is used for entangling transitions. We can set it back to
            // zero once the queue is empty.
            queue.shared.lanes = NoLanes;
             // Set the remaining expiration time to be whatever is remaining in the queue.
            // This should be fine because the only two other things that contribute to
            // expiration time are props and context. We're already in the middle of the
            // begin phase by the time we start processing the queue, so we've already
            // dealt with the props. Context in components that specify
            // shouldComponentUpdate is tricky; but we'll have to account for
            // that regardless.
            markSkippedUpdateLanes(newLanes);
            workInProgress.lanes = newLanes;
            workInProgress.memoizedState = newState;
        }
        currentlyProcessingQueue = null;
    }
    function callCallback(callback, context) {
        if (typeof callback !== "function") throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + callback));
        callback.call(context);
    }
    function resetHasForceUpdateBeforeProcessing() {
        hasForceUpdate = false;
    }
    function checkHasForceUpdateAfterProcessing() {
        return hasForceUpdate;
    }
    function commitUpdateQueue(finishedWork, finishedQueue, instance) {
        // Commit the effects
        var effects = finishedQueue.effects;
        finishedQueue.effects = null;
        if (effects !== null) for(var i = 0; i < effects.length; i++){
            var effect = effects[i];
            var callback = effect.callback;
            if (callback !== null) {
                effect.callback = null;
                callCallback(callback, instance);
            }
        }
    }
    var NO_CONTEXT = {};
    var contextStackCursor$1 = createCursor(NO_CONTEXT);
    var contextFiberStackCursor = createCursor(NO_CONTEXT);
    var rootInstanceStackCursor = createCursor(NO_CONTEXT);
    function requiredContext(c) {
        if (c === NO_CONTEXT) throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
        return c;
    }
    function getRootHostContainer() {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        return rootInstance;
    }
    function pushHostContainer(fiber, nextRootInstance) {
        // Push current root instance onto the stack;
        // This allows us to reset root when portals are popped.
        push(rootInstanceStackCursor, nextRootInstance, fiber); // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber); // Finally, we need to push the host context to the stack.
        // However, we can't just call getRootHostContext() and push it because
        // we'd have a different number of entries on the stack depending on
        // whether getRootHostContext() throws somewhere in renderer code or not.
        // So we push an empty value first. This lets us safely unwind on errors.
        push(contextStackCursor$1, NO_CONTEXT, fiber);
        var nextRootContext = getRootHostContext(nextRootInstance); // Now that we know this function doesn't throw, replace it.
        pop(contextStackCursor$1, fiber);
        push(contextStackCursor$1, nextRootContext, fiber);
    }
    function popHostContainer(fiber) {
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
        pop(rootInstanceStackCursor, fiber);
    }
    function getHostContext() {
        var context = requiredContext(contextStackCursor$1.current);
        return context;
    }
    function pushHostContext(fiber) {
        var rootInstance = requiredContext(rootInstanceStackCursor.current);
        var context = requiredContext(contextStackCursor$1.current);
        var nextContext = getChildHostContext(context, fiber.type); // Don't push this Fiber's context unless it's unique.
        if (context === nextContext) return;
         // Track the context and the Fiber that provided it.
        // This enables us to pop only Fibers that provide unique contexts.
        push(contextFiberStackCursor, fiber, fiber);
        push(contextStackCursor$1, nextContext, fiber);
    }
    function popHostContext(fiber) {
        // Do not pop unless this Fiber provided the current context.
        // pushHostContext() only pushes Fibers that provide unique contexts.
        if (contextFiberStackCursor.current !== fiber) return;
        pop(contextStackCursor$1, fiber);
        pop(contextFiberStackCursor, fiber);
    }
    var DefaultSuspenseContext = 0; // The Suspense Context is split into two parts. The lower bits is
    // inherited deeply down the subtree. The upper bits only affect
    // this immediate suspense boundary and gets reset each new
    // boundary or suspense list.
    var SubtreeSuspenseContextMask = 1; // Subtree Flags:
    // InvisibleParentSuspenseContext indicates that one of our parent Suspense
    // boundaries is not currently showing visible main content.
    // Either because it is already showing a fallback or is not mounted at all.
    // We can use this to determine if it is desirable to trigger a fallback at
    // the parent. If not, then we might need to trigger undesirable boundaries
    // and/or suspend the commit to avoid hiding the parent content.
    var InvisibleParentSuspenseContext = 1; // Shallow Flags:
    // ForceSuspenseFallback can be used by SuspenseList to force newly added
    // items into their fallback state during one of the render passes.
    var ForceSuspenseFallback = 2;
    var suspenseStackCursor = createCursor(DefaultSuspenseContext);
    function hasSuspenseContext(parentContext, flag) {
        return (parentContext & flag) !== 0;
    }
    function setDefaultShallowSuspenseContext(parentContext) {
        return parentContext & SubtreeSuspenseContextMask;
    }
    function setShallowSuspenseContext(parentContext, shallowContext) {
        return parentContext & SubtreeSuspenseContextMask | shallowContext;
    }
    function addSubtreeSuspenseContext(parentContext, subtreeContext) {
        return parentContext | subtreeContext;
    }
    function pushSuspenseContext(fiber, newContext) {
        push(suspenseStackCursor, newContext, fiber);
    }
    function popSuspenseContext(fiber) {
        pop(suspenseStackCursor, fiber);
    }
    function shouldCaptureSuspense(workInProgress, hasInvisibleParent) {
        // If it was the primary children that just suspended, capture and render the
        // fallback. Otherwise, don't capture and bubble to the next boundary.
        var nextState = workInProgress.memoizedState;
        if (nextState !== null) {
            if (nextState.dehydrated !== null) // A dehydrated boundary always captures.
            return true;
            return false;
        }
        var props = workInProgress.memoizedProps; // Regular boundaries always capture.
        return true;
    }
    function findFirstSuspended(row) {
        var node = row;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) {
                    var dehydrated = state.dehydrated;
                    if (dehydrated === null || isSuspenseInstancePending(dehydrated) || isSuspenseInstanceFallback(dehydrated)) return node;
                }
            } else if (node.tag === SuspenseListComponent && // revealOrder undefined can't be trusted because it don't
            // keep track of whether it suspended or not.
            node.memoizedProps.revealOrder !== undefined) {
                var didSuspend = (node.flags & DidCapture) !== NoFlags;
                if (didSuspend) return node;
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === row) return null;
            while(node.sibling === null){
                if (node.return === null || node.return === row) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return null;
    }
    var NoFlags$1 = /*   */ 0; // Represents whether effect should fire.
    var HasEffect = /* */ 1; // Represents the phase in which the effect (not the clean-up) fires.
    var Insertion = /*  */ 2;
    var Layout = /*    */ 4;
    var Passive$1 = /*   */ 8;
    // and should be reset before starting a new render.
    // This tracks which mutable sources need to be reset after a render.
    var workInProgressSources = [];
    function resetWorkInProgressVersions() {
        for(var i = 0; i < workInProgressSources.length; i++){
            var mutableSource = workInProgressSources[i];
            mutableSource._workInProgressVersionPrimary = null;
        }
        workInProgressSources.length = 0;
    }
    // This ensures that the version used for server rendering matches the one
    // that is eventually read during hydration.
    // If they don't match there's a potential tear and a full deopt render is required.
    function registerMutableSourceForHydration(root, mutableSource) {
        var getVersion = mutableSource._getVersion;
        var version = getVersion(mutableSource._source); // TODO Clear this data once all pending hydration work is finished.
        // Retaining it forever may interfere with GC.
        if (root.mutableSourceEagerHydrationData == null) root.mutableSourceEagerHydrationData = [
            mutableSource,
            version
        ];
        else root.mutableSourceEagerHydrationData.push(mutableSource, version);
    }
    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentBatchConfig$2 = ReactSharedInternals.ReactCurrentBatchConfig;
    var didWarnAboutMismatchedHooksForComponent;
    var didWarnUncachedGetSnapshot;
    didWarnAboutMismatchedHooksForComponent = new Set();
    // These are set right before calling the component.
    var renderLanes = NoLanes; // The work-in-progress fiber. I've named it differently to distinguish it from
    // the work-in-progress hook.
    var currentlyRenderingFiber$1 = null; // Hooks are stored as a linked list on the fiber's memoizedState field. The
    // current hook list is the list that belongs to the current fiber. The
    // work-in-progress hook list is a new list that will be added to the
    // work-in-progress fiber.
    var currentHook = null;
    var workInProgressHook = null; // Whether an update was scheduled at any point during the render phase. This
    // does not get reset if we do another render pass; only when we're completely
    // finished evaluating this component. This is an optimization so we know
    // whether we need to clear render phase updates after a throw.
    var didScheduleRenderPhaseUpdate = false; // Where an update was scheduled only during the current render pass. This
    // gets reset after each attempt.
    // TODO: Maybe there's some way to consolidate this with
    // `didScheduleRenderPhaseUpdate`. Or with `numberOfReRenders`.
    var didScheduleRenderPhaseUpdateDuringThisPass = false; // Counts the number of useId hooks in this component.
    var localIdCounter = 0; // Used for ids that are generated completely client-side (i.e. not during
    // hydration). This counter is global, so client ids are not stable across
    // render attempts.
    var globalClientIdCounter = 0;
    var RE_RENDER_LIMIT = 25; // In DEV, this is the name of the currently executing primitive hook
    var currentHookNameInDev = null; // In DEV, this list ensures that hooks are called in the same order between renders.
    // The list stores the order of hooks used during the initial render (mount).
    // Subsequent renders (updates) reference this list.
    var hookTypesDev = null;
    var hookTypesUpdateIndexDev = -1; // In DEV, this tracks whether currently rendering component needs to ignore
    // the dependencies for Hooks that need them (e.g. useEffect or useMemo).
    // When true, such Hooks will always be "remounted". Only used during hot reload.
    var ignorePreviousDependencies = false;
    function mountHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev === null) hookTypesDev = [
            hookName
        ];
        else hookTypesDev.push(hookName);
    }
    function updateHookTypesDev() {
        var hookName = currentHookNameInDev;
        if (hookTypesDev !== null) {
            hookTypesUpdateIndexDev++;
            if (hookTypesDev[hookTypesUpdateIndexDev] !== hookName) warnOnHookMismatchInDev(hookName);
        }
    }
    function checkDepsAreArrayDev(deps) {
        if (deps !== undefined && deps !== null && !isArray(deps)) // Verify deps, but only on mount to avoid extra checks.
        // It's unlikely their type would change as usually you define them inline.
        error("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", currentHookNameInDev, typeof deps);
    }
    function warnOnHookMismatchInDev(currentHookName) {
        var componentName = getComponentNameFromFiber(currentlyRenderingFiber$1);
        if (!didWarnAboutMismatchedHooksForComponent.has(componentName)) {
            didWarnAboutMismatchedHooksForComponent.add(componentName);
            if (hookTypesDev !== null) {
                var table = "";
                var secondColumnStart = 30;
                for(var i = 0; i <= hookTypesUpdateIndexDev; i++){
                    var oldHookName = hookTypesDev[i];
                    var newHookName = i === hookTypesUpdateIndexDev ? currentHookName : oldHookName;
                    var row = i + 1 + ". " + oldHookName; // Extra space so second column lines up
                    // lol @ IE not supporting String#repeat
                    while(row.length < secondColumnStart)row += " ";
                    row += newHookName + "\n";
                    table += row;
                }
                error("React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n", componentName, table);
            }
        }
    }
    function throwInvalidHookError() {
        throw new Error("Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.");
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
        if (ignorePreviousDependencies) // Only true when this component is being hot reloaded.
        return false;
        if (prevDeps === null) {
            error("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", currentHookNameInDev);
            return false;
        }
        // Don't bother comparing lengths in prod because these arrays should be
        // passed inline.
        if (nextDeps.length !== prevDeps.length) error("The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s", currentHookNameInDev, "[" + prevDeps.join(", ") + "]", "[" + nextDeps.join(", ") + "]");
        for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++){
            if (objectIs(nextDeps[i], prevDeps[i])) continue;
            return false;
        }
        return true;
    }
    function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
        renderLanes = nextRenderLanes;
        currentlyRenderingFiber$1 = workInProgress;
        hookTypesDev = current !== null ? current._debugHookTypes : null;
        hookTypesUpdateIndexDev = -1; // Used for hot reloading:
        ignorePreviousDependencies = current !== null && current.type !== workInProgress.type;
        workInProgress.memoizedState = null;
        workInProgress.updateQueue = null;
        workInProgress.lanes = NoLanes; // The following should have already been reset
        if (current !== null && current.memoizedState !== null) ReactCurrentDispatcher$1.current = HooksDispatcherOnUpdateInDEV;
        else if (hookTypesDev !== null) // This dispatcher handles an edge case where a component is updating,
        // but no stateful hooks have been used.
        // We want to match the production code behavior (which will use HooksDispatcherOnMount),
        // but with the extra DEV validation to ensure hooks ordering hasn't changed.
        // This dispatcher does that.
        ReactCurrentDispatcher$1.current = HooksDispatcherOnMountWithHookTypesInDEV;
        else ReactCurrentDispatcher$1.current = HooksDispatcherOnMountInDEV;
        var children = Component(props, secondArg); // Check if there was a render phase update
        if (didScheduleRenderPhaseUpdateDuringThisPass) {
            // Keep rendering in a loop for as long as render phase updates continue to
            // be scheduled. Use a counter to prevent infinite loops.
            var numberOfReRenders = 0;
            do {
                didScheduleRenderPhaseUpdateDuringThisPass = false;
                localIdCounter = 0;
                if (numberOfReRenders >= RE_RENDER_LIMIT) throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
                numberOfReRenders += 1;
                // Even when hot reloading, allow dependencies to stabilize
                // after first render to prevent infinite render phase updates.
                ignorePreviousDependencies = false;
                currentHook = null;
                workInProgressHook = null;
                workInProgress.updateQueue = null;
                // Also validate hook order for cascading updates.
                hookTypesUpdateIndexDev = -1;
                ReactCurrentDispatcher$1.current = HooksDispatcherOnRerenderInDEV;
                children = Component(props, secondArg);
            }while (didScheduleRenderPhaseUpdateDuringThisPass);
        } // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrance.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        workInProgress._debugHookTypes = hookTypesDev;
        // hookTypesDev could catch more cases (e.g. context) but only in DEV bundles.
        var didRenderTooFewHooks = currentHook !== null && currentHook.next !== null;
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        currentHookNameInDev = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1; // Confirm that a static flag was not added or removed since the last
        // render. If this fires, it suggests that we incorrectly reset the static
        // flags in some other part of the codebase. This has happened before, for
        // example, in the SuspenseList implementation.
        if (current !== null && (current.flags & StaticMask) !== (workInProgress.flags & StaticMask) && // Disable this warning in legacy mode, because legacy Suspense is weird
        // and creates false positives. To make this work in legacy mode, we'd
        // need to mark fibers that commit in an incomplete state, somehow. For
        // now I'll disable the warning that most of the bugs that would trigger
        // it are either exclusive to concurrent mode or exist in both.
        (current.mode & ConcurrentMode) !== NoMode) error("Internal React error: Expected static flag was missing. Please notify the React team.");
        didScheduleRenderPhaseUpdate = false; // This is reset by checkDidRenderIdHook
        // localIdCounter = 0;
        if (didRenderTooFewHooks) throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        return children;
    }
    function checkDidRenderIdHook() {
        // This should be called immediately after every renderWithHooks call.
        // Conceptually, it's part of the return value of renderWithHooks; it's only a
        // separate function to avoid using an array tuple.
        var didRenderIdHook = localIdCounter !== 0;
        localIdCounter = 0;
        return didRenderIdHook;
    }
    function bailoutHooks(current, workInProgress, lanes) {
        workInProgress.updateQueue = current.updateQueue; // TODO: Don't need to reset the flags here, because they're reset in the
        // complete phase (bubbleProperties).
        if ((workInProgress.mode & StrictEffectsMode) !== NoMode) workInProgress.flags &= ~(MountPassiveDev | MountLayoutDev | Passive | Update);
        else workInProgress.flags &= ~(Passive | Update);
        current.lanes = removeLanes(current.lanes, lanes);
    }
    function resetHooksAfterThrow() {
        // We can assume the previous dispatcher is always this one, since we set it
        // at the beginning of the render phase and there's no re-entrance.
        ReactCurrentDispatcher$1.current = ContextOnlyDispatcher;
        if (didScheduleRenderPhaseUpdate) {
            // There were render phase updates. These are only valid for this render
            // phase, which we are now aborting. Remove the updates from the queues so
            // they do not persist to the next render. Do not remove updates from hooks
            // that weren't processed.
            //
            // Only reset the updates from the queue if it has a clone. If it does
            // not have a clone, that means it wasn't processed, and the updates were
            // scheduled before we entered the render phase.
            var hook = currentlyRenderingFiber$1.memoizedState;
            while(hook !== null){
                var queue = hook.queue;
                if (queue !== null) queue.pending = null;
                hook = hook.next;
            }
            didScheduleRenderPhaseUpdate = false;
        }
        renderLanes = NoLanes;
        currentlyRenderingFiber$1 = null;
        currentHook = null;
        workInProgressHook = null;
        hookTypesDev = null;
        hookTypesUpdateIndexDev = -1;
        currentHookNameInDev = null;
        isUpdatingOpaqueValueInRenderPhase = false;
        didScheduleRenderPhaseUpdateDuringThisPass = false;
        localIdCounter = 0;
    }
    function mountWorkInProgressHook() {
        var hook = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        if (workInProgressHook === null) // This is the first hook in the list
        currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook;
        else // Append to the end of the list
        workInProgressHook = workInProgressHook.next = hook;
        return workInProgressHook;
    }
    function updateWorkInProgressHook() {
        // This function is used both for updates and for re-renders triggered by a
        // render phase update. It assumes there is either a current hook we can
        // clone, or a work-in-progress hook from a previous render pass that we can
        // use as a base. When we reach the end of the base list, we must switch to
        // the dispatcher used for mounts.
        var nextCurrentHook;
        if (currentHook === null) {
            var current = currentlyRenderingFiber$1.alternate;
            if (current !== null) nextCurrentHook = current.memoizedState;
            else nextCurrentHook = null;
        } else nextCurrentHook = currentHook.next;
        var nextWorkInProgressHook;
        if (workInProgressHook === null) nextWorkInProgressHook = currentlyRenderingFiber$1.memoizedState;
        else nextWorkInProgressHook = workInProgressHook.next;
        if (nextWorkInProgressHook !== null) {
            // There's already a work-in-progress. Reuse it.
            workInProgressHook = nextWorkInProgressHook;
            nextWorkInProgressHook = workInProgressHook.next;
            currentHook = nextCurrentHook;
        } else {
            // Clone from the current hook.
            if (nextCurrentHook === null) throw new Error("Rendered more hooks than during the previous render.");
            currentHook = nextCurrentHook;
            var newHook = {
                memoizedState: currentHook.memoizedState,
                baseState: currentHook.baseState,
                baseQueue: currentHook.baseQueue,
                queue: currentHook.queue,
                next: null
            };
            if (workInProgressHook === null) // This is the first hook in the list.
            currentlyRenderingFiber$1.memoizedState = workInProgressHook = newHook;
            else // Append to the end of the list.
            workInProgressHook = workInProgressHook.next = newHook;
        }
        return workInProgressHook;
    }
    function createFunctionComponentUpdateQueue() {
        return {
            lastEffect: null,
            stores: null
        };
    }
    function basicStateReducer(state, action) {
        // $FlowFixMe: Flow doesn't like mixed types
        return typeof action === "function" ? action(state) : action;
    }
    function mountReducer(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        var initialState;
        if (init !== undefined) initialState = init(initialArg);
        else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        var queue = {
            pending: null,
            interleaved: null,
            lanes: NoLanes,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (queue === null) throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer;
        var current = currentHook; // The last rebase update that is NOT part of the base state.
        var baseQueue = current.baseQueue; // The last pending update that hasn't been processed yet.
        var pendingQueue = queue.pending;
        if (pendingQueue !== null) {
            // We have new updates that haven't been processed yet.
            // We'll add them to the base queue.
            if (baseQueue !== null) {
                // Merge the pending queue and the base queue.
                var baseFirst = baseQueue.next;
                var pendingFirst = pendingQueue.next;
                baseQueue.next = pendingFirst;
                pendingQueue.next = baseFirst;
            }
            if (current.baseQueue !== baseQueue) // Internal invariant that should never happen, but feasibly could in
            // the future if we implement resuming, or some form of that.
            error("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React.");
            current.baseQueue = baseQueue = pendingQueue;
            queue.pending = null;
        }
        if (baseQueue !== null) {
            // We have a queue to process.
            var first = baseQueue.next;
            var newState = current.baseState;
            var newBaseState = null;
            var newBaseQueueFirst = null;
            var newBaseQueueLast = null;
            var update = first;
            do {
                var updateLane = update.lane;
                if (!isSubsetOfLanes(renderLanes, updateLane)) {
                    // Priority is insufficient. Skip this update. If this is the first
                    // skipped update, the previous update/state is the new base
                    // update/state.
                    var clone = {
                        lane: updateLane,
                        action: update.action,
                        hasEagerState: update.hasEagerState,
                        eagerState: update.eagerState,
                        next: null
                    };
                    if (newBaseQueueLast === null) {
                        newBaseQueueFirst = newBaseQueueLast = clone;
                        newBaseState = newState;
                    } else newBaseQueueLast = newBaseQueueLast.next = clone;
                     // Update the remaining priority in the queue.
                    // TODO: Don't need to accumulate this. Instead, we can remove
                    // renderLanes from the original lanes.
                    currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, updateLane);
                    markSkippedUpdateLanes(updateLane);
                } else {
                    // This update does have sufficient priority.
                    if (newBaseQueueLast !== null) {
                        var _clone = {
                            // This update is going to be committed so we never want uncommit
                            // it. Using NoLane works because 0 is a subset of all bitmasks, so
                            // this will never be skipped by the check above.
                            lane: NoLane,
                            action: update.action,
                            hasEagerState: update.hasEagerState,
                            eagerState: update.eagerState,
                            next: null
                        };
                        newBaseQueueLast = newBaseQueueLast.next = _clone;
                    } // Process this update.
                    if (update.hasEagerState) // If this update is a state update (not a reducer) and was processed eagerly,
                    // we can use the eagerly computed state
                    newState = update.eagerState;
                    else {
                        var action = update.action;
                        newState = reducer(newState, action);
                    }
                }
                update = update.next;
            }while (update !== null && update !== first);
            if (newBaseQueueLast === null) newBaseState = newState;
            else newBaseQueueLast.next = newBaseQueueFirst;
             // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState;
            hook.baseState = newBaseState;
            hook.baseQueue = newBaseQueueLast;
            queue.lastRenderedState = newState;
        } // Interleaved updates are stored on a separate queue. We aren't going to
        // process them during this render, but we do need to track which lanes
        // are remaining.
        var lastInterleaved = queue.interleaved;
        if (lastInterleaved !== null) {
            var interleaved = lastInterleaved;
            do {
                var interleavedLane = interleaved.lane;
                currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, interleavedLane);
                markSkippedUpdateLanes(interleavedLane);
                interleaved = interleaved.next;
            }while (interleaved !== lastInterleaved);
        } else if (baseQueue === null) // `queue.lanes` is used for entangling transitions. We can set it back to
        // zero once the queue is empty.
        queue.lanes = NoLanes;
        var dispatch = queue.dispatch;
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function rerenderReducer(reducer, initialArg, init) {
        var hook = updateWorkInProgressHook();
        var queue = hook.queue;
        if (queue === null) throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        queue.lastRenderedReducer = reducer; // This is a re-render. Apply the new render phase updates to the previous
        // work-in-progress hook.
        var dispatch = queue.dispatch;
        var lastRenderPhaseUpdate = queue.pending;
        var newState = hook.memoizedState;
        if (lastRenderPhaseUpdate !== null) {
            // The queue doesn't persist past this render pass.
            queue.pending = null;
            var firstRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            var update = firstRenderPhaseUpdate;
            do {
                // Process this render phase update. We don't have to check the
                // priority because it will always be the same as the current
                // render's.
                var action = update.action;
                newState = reducer(newState, action);
                update = update.next;
            }while (update !== firstRenderPhaseUpdate); // Mark that the fiber performed work, but only if the new state is
            // different from the current state.
            if (!objectIs(newState, hook.memoizedState)) markWorkInProgressReceivedUpdate();
            hook.memoizedState = newState; // Don't persist the state accumulated from the render phase updates to
            // the base state unless the queue is empty.
            // TODO: Not sure if this is the desired semantics, but it's what we
            // do for gDSFP. I can't remember why.
            if (hook.baseQueue === null) hook.baseState = newState;
            queue.lastRenderedState = newState;
        }
        return [
            newState,
            dispatch
        ];
    }
    function mountMutableSource(source, getSnapshot, subscribe) {
        return undefined;
    }
    function updateMutableSource(source, getSnapshot, subscribe) {
        return undefined;
    }
    function mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = mountWorkInProgressHook();
        var nextSnapshot;
        var isHydrating = getIsHydrating();
        if (isHydrating) {
            if (getServerSnapshot === undefined) throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
            nextSnapshot = getServerSnapshot();
            if (!didWarnUncachedGetSnapshot) {
                if (nextSnapshot !== getServerSnapshot()) {
                    error("The result of getServerSnapshot should be cached to avoid an infinite loop");
                    didWarnUncachedGetSnapshot = true;
                }
            }
        } else {
            nextSnapshot = getSnapshot();
            if (!didWarnUncachedGetSnapshot) {
                var cachedSnapshot = getSnapshot();
                if (!objectIs(nextSnapshot, cachedSnapshot)) {
                    error("The result of getSnapshot should be cached to avoid an infinite loop");
                    didWarnUncachedGetSnapshot = true;
                }
            }
            // Right before committing, we will walk the tree and check if any of the
            // stores were mutated.
            //
            // We won't do this if we're hydrating server-rendered content, because if
            // the content is stale, it's already visible anyway. Instead we'll patch
            // it up in a passive effect.
            var root = getWorkInProgressRoot();
            if (root === null) throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            if (!includesBlockingLane(root, renderLanes)) pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        } // Read the current snapshot from the store on every render. This breaks the
        // normal rules of React, and only works because store updates are
        // always synchronous.
        hook.memoizedState = nextSnapshot;
        var inst = {
            value: nextSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst; // Schedule an effect to subscribe to the store.
        mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]); // Schedule an effect to update the mutable instance fields. We will update
        // this whenever subscribe, getSnapshot, or value changes. Because there's no
        // clean-up function, and we track the deps correctly, we can call pushEffect
        // directly, without storing any additional state. For the same reason, we
        // don't need to set a static flag, either.
        // TODO: We can move this to the passive phase once we add a pre-commit
        // consistency check. See the next comment.
        fiber.flags |= Passive;
        pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null);
        return nextSnapshot;
    }
    function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1;
        var hook = updateWorkInProgressHook(); // Read the current snapshot from the store on every render. This breaks the
        // normal rules of React, and only works because store updates are
        // always synchronous.
        var nextSnapshot = getSnapshot();
        if (!didWarnUncachedGetSnapshot) {
            var cachedSnapshot = getSnapshot();
            if (!objectIs(nextSnapshot, cachedSnapshot)) {
                error("The result of getSnapshot should be cached to avoid an infinite loop");
                didWarnUncachedGetSnapshot = true;
            }
        }
        var prevSnapshot = hook.memoizedState;
        var snapshotChanged = !objectIs(prevSnapshot, nextSnapshot);
        if (snapshotChanged) {
            hook.memoizedState = nextSnapshot;
            markWorkInProgressReceivedUpdate();
        }
        var inst = hook.queue;
        updateEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]); // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if (inst.getSnapshot !== getSnapshot || snapshotChanged || // Check if the susbcribe function changed. We can save some memory by
        // checking whether we scheduled a subscription effect above.
        workInProgressHook !== null && workInProgressHook.memoizedState.tag & HasEffect) {
            fiber.flags |= Passive;
            pushEffect(HasEffect | Passive$1, updateStoreInstance.bind(null, fiber, inst, nextSnapshot, getSnapshot), undefined, null); // Unless we're rendering a blocking lane, schedule a consistency check.
            // Right before committing, we will walk the tree and check if any of the
            // stores were mutated.
            var root = getWorkInProgressRoot();
            if (root === null) throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
            if (!includesBlockingLane(root, renderLanes)) pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
        }
        return nextSnapshot;
    }
    function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
        fiber.flags |= StoreConsistency;
        var check = {
            getSnapshot: getSnapshot,
            value: renderedSnapshot
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.stores = [
                check
            ];
        } else {
            var stores = componentUpdateQueue.stores;
            if (stores === null) componentUpdateQueue.stores = [
                check
            ];
            else stores.push(check);
        }
    }
    function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
        // These are updated in the passive phase
        inst.value = nextSnapshot;
        inst.getSnapshot = getSnapshot; // Something may have been mutated in between render and commit. This could
        // have been in an event that fired before the passive effects, or it could
        // have been in a layout effect. In that case, we would have used the old
        // snapsho and getSnapshot values to bail out. We need to check one more time.
        if (checkIfSnapshotChanged(inst)) // Force a re-render.
        forceStoreRerender(fiber);
    }
    function subscribeToStore(fiber, inst, subscribe) {
        var handleStoreChange = function() {
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if (checkIfSnapshotChanged(inst)) // Force a re-render.
            forceStoreRerender(fiber);
        }; // Subscribe to the store and return a clean-up function.
        return subscribe(handleStoreChange);
    }
    function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        var prevValue = inst.value;
        try {
            var nextValue = latestGetSnapshot();
            return !objectIs(prevValue, nextValue);
        } catch (error) {
            return true;
        }
    }
    function forceStoreRerender(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    }
    function mountState(initialState) {
        var hook = mountWorkInProgressHook();
        if (typeof initialState === "function") // $FlowFixMe: Flow doesn't like mixed types
        initialState = initialState();
        hook.memoizedState = hook.baseState = initialState;
        var queue = {
            pending: null,
            interleaved: null,
            lanes: NoLanes,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialState
        };
        hook.queue = queue;
        var dispatch = queue.dispatch = dispatchSetState.bind(null, currentlyRenderingFiber$1, queue);
        return [
            hook.memoizedState,
            dispatch
        ];
    }
    function updateState(initialState) {
        return updateReducer(basicStateReducer);
    }
    function rerenderState(initialState) {
        return rerenderReducer(basicStateReducer);
    }
    function pushEffect(tag, create, destroy, deps) {
        var effect = {
            tag: tag,
            create: create,
            destroy: destroy,
            deps: deps,
            // Circular
            next: null
        };
        var componentUpdateQueue = currentlyRenderingFiber$1.updateQueue;
        if (componentUpdateQueue === null) {
            componentUpdateQueue = createFunctionComponentUpdateQueue();
            currentlyRenderingFiber$1.updateQueue = componentUpdateQueue;
            componentUpdateQueue.lastEffect = effect.next = effect;
        } else {
            var lastEffect = componentUpdateQueue.lastEffect;
            if (lastEffect === null) componentUpdateQueue.lastEffect = effect.next = effect;
            else {
                var firstEffect = lastEffect.next;
                lastEffect.next = effect;
                effect.next = firstEffect;
                componentUpdateQueue.lastEffect = effect;
            }
        }
        return effect;
    }
    function mountRef(initialValue) {
        var hook = mountWorkInProgressHook();
        var _ref2 = {
            current: initialValue
        };
        hook.memoizedState = _ref2;
        return _ref2;
    }
    function updateRef(initialValue) {
        var hook = updateWorkInProgressHook();
        return hook.memoizedState;
    }
    function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, undefined, nextDeps);
    }
    function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var destroy = undefined;
        if (currentHook !== null) {
            var prevEffect = currentHook.memoizedState;
            destroy = prevEffect.destroy;
            if (nextDeps !== null) {
                var prevDeps = prevEffect.deps;
                if (areHookInputsEqual(nextDeps, prevDeps)) {
                    hook.memoizedState = pushEffect(hookFlags, create, destroy, nextDeps);
                    return;
                }
            }
        }
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(HasEffect | hookFlags, create, destroy, nextDeps);
    }
    function mountEffect(create, deps) {
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) return mountEffectImpl(MountPassiveDev | Passive | PassiveStatic, Passive$1, create, deps);
        else return mountEffectImpl(Passive | PassiveStatic, Passive$1, create, deps);
    }
    function updateEffect(create, deps) {
        return updateEffectImpl(Passive, Passive$1, create, deps);
    }
    function mountInsertionEffect(create, deps) {
        return mountEffectImpl(Update, Insertion, create, deps);
    }
    function updateInsertionEffect(create, deps) {
        return updateEffectImpl(Update, Insertion, create, deps);
    }
    function mountLayoutEffect(create, deps) {
        var fiberFlags = Update;
        fiberFlags |= LayoutStatic;
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
        return mountEffectImpl(fiberFlags, Layout, create, deps);
    }
    function updateLayoutEffect(create, deps) {
        return updateEffectImpl(Update, Layout, create, deps);
    }
    function imperativeHandleEffect(create, ref) {
        if (typeof ref === "function") {
            var refCallback = ref;
            var _inst = create();
            refCallback(_inst);
            return function() {
                refCallback(null);
            };
        } else if (ref !== null && ref !== undefined) {
            var refObject = ref;
            if (!refObject.hasOwnProperty("current")) error("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(refObject).join(", ") + "}");
            var _inst2 = create();
            refObject.current = _inst2;
            return function() {
                refObject.current = null;
            };
        }
    }
    function mountImperativeHandle(ref, create, deps) {
        if (typeof create !== "function") error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : "null");
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        var fiberFlags = Update;
        fiberFlags |= LayoutStatic;
        if ((currentlyRenderingFiber$1.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
        return mountEffectImpl(fiberFlags, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function updateImperativeHandle(ref, create, deps) {
        if (typeof create !== "function") error("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", create !== null ? typeof create : "null");
        var effectDeps = deps !== null && deps !== undefined ? deps.concat([
            ref
        ]) : null;
        return updateEffectImpl(Update, Layout, imperativeHandleEffect.bind(null, create, ref), effectDeps);
    }
    function mountDebugValue(value, formatterFn) {
    // The react-debug-hooks package injects its own implementation
    // so that e.g. DevTools can display custom hook values.
    }
    var updateDebugValue = mountDebugValue;
    function mountCallback(callback, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        hook.memoizedState = [
            callback,
            nextDeps
        ];
        return callback;
    }
    function mountMemo(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        var nextDeps = deps === undefined ? null : deps;
        var prevState = hook.memoizedState;
        if (prevState !== null) // Assume these are defined. If they're not, areHookInputsEqual will warn.
        {
            if (nextDeps !== null) {
                var prevDeps = prevState[1];
                if (areHookInputsEqual(nextDeps, prevDeps)) return prevState[0];
            }
        }
        var nextValue = nextCreate();
        hook.memoizedState = [
            nextValue,
            nextDeps
        ];
        return nextValue;
    }
    function mountDeferredValue(value) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = value;
        return value;
    }
    function updateDeferredValue(value) {
        var hook = updateWorkInProgressHook();
        var resolvedCurrentHook = currentHook;
        var prevValue = resolvedCurrentHook.memoizedState;
        return updateDeferredValueImpl(hook, prevValue, value);
    }
    function rerenderDeferredValue(value) {
        var hook = updateWorkInProgressHook();
        if (currentHook === null) {
            // This is a rerender during a mount.
            hook.memoizedState = value;
            return value;
        } else {
            // This is a rerender during an update.
            var prevValue = currentHook.memoizedState;
            return updateDeferredValueImpl(hook, prevValue, value);
        }
    }
    function updateDeferredValueImpl(hook, prevValue, value) {
        var shouldDeferValue = !includesOnlyNonUrgentLanes(renderLanes);
        if (shouldDeferValue) {
            // This is an urgent update. If the value has changed, keep using the
            // previous value and spawn a deferred render to update it later.
            if (!objectIs(value, prevValue)) {
                // Schedule a deferred render
                var deferredLane = claimNextTransitionLane();
                currentlyRenderingFiber$1.lanes = mergeLanes(currentlyRenderingFiber$1.lanes, deferredLane);
                markSkippedUpdateLanes(deferredLane); // Set this to true to indicate that the rendered value is inconsistent
                // from the latest value. The name "baseState" doesn't really match how we
                // use it because we're reusing a state hook field instead of creating a
                // new one.
                hook.baseState = true;
            } // Reuse the previous value
            return prevValue;
        } else {
            // This is not an urgent update, so we can use the latest value regardless
            // of what it is. No need to defer it.
            // However, if we're currently inside a spawned render, then we need to mark
            // this as an update to prevent the fiber from bailing out.
            //
            // `baseState` is true when the current value is different from the rendered
            // value. The name doesn't really match how we use it because we're reusing
            // a state hook field instead of creating a new one.
            if (hook.baseState) {
                // Flip this back to false.
                hook.baseState = false;
                markWorkInProgressReceivedUpdate();
            }
            hook.memoizedState = value;
            return value;
        }
    }
    function startTransition(setPending, callback, options) {
        var previousPriority = getCurrentUpdatePriority();
        setCurrentUpdatePriority(higherEventPriority(previousPriority, ContinuousEventPriority));
        setPending(true);
        var prevTransition = ReactCurrentBatchConfig$2.transition;
        ReactCurrentBatchConfig$2.transition = {};
        var currentTransition = ReactCurrentBatchConfig$2.transition;
        ReactCurrentBatchConfig$2.transition._updatedFibers = new Set();
        try {
            setPending(false);
            callback();
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$2.transition = prevTransition;
            if (prevTransition === null && currentTransition._updatedFibers) {
                var updatedFibersCount = currentTransition._updatedFibers.size;
                if (updatedFibersCount > 10) warn("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table.");
                currentTransition._updatedFibers.clear();
            }
        }
    }
    function mountTransition() {
        var _mountState = mountState(false), isPending = _mountState[0], setPending = _mountState[1]; // The `start` method never changes.
        var start = startTransition.bind(null, setPending);
        var hook = mountWorkInProgressHook();
        hook.memoizedState = start;
        return [
            isPending,
            start
        ];
    }
    function updateTransition() {
        var _updateState = updateState(), isPending = _updateState[0];
        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [
            isPending,
            start
        ];
    }
    function rerenderTransition() {
        var _rerenderState = rerenderState(), isPending = _rerenderState[0];
        var hook = updateWorkInProgressHook();
        var start = hook.memoizedState;
        return [
            isPending,
            start
        ];
    }
    var isUpdatingOpaqueValueInRenderPhase = false;
    function getIsUpdatingOpaqueValueInRenderPhaseInDEV() {
        return isUpdatingOpaqueValueInRenderPhase;
    }
    function mountId() {
        var hook = mountWorkInProgressHook();
        var root = getWorkInProgressRoot(); // TODO: In Fizz, id generation is specific to each server config. Maybe we
        // should do this in Fiber, too? Deferring this decision for now because
        // there's no other place to store the prefix except for an internal field on
        // the public createRoot object, which the fiber tree does not currently have
        // a reference to.
        var identifierPrefix = root.identifierPrefix;
        var id;
        if (getIsHydrating()) {
            var treeId = getTreeId(); // Use a captial R prefix for server-generated ids.
            id = ":" + identifierPrefix + "R" + treeId; // Unless this is the first id at this level, append a number at the end
            // that represents the position of this useId hook among all the useId
            // hooks for this fiber.
            var localId = localIdCounter++;
            if (localId > 0) id += "H" + localId.toString(32);
            id += ":";
        } else {
            // Use a lowercase r prefix for client-generated ids.
            var globalClientId = globalClientIdCounter++;
            id = ":" + identifierPrefix + "r" + globalClientId.toString(32) + ":";
        }
        hook.memoizedState = id;
        return id;
    }
    function updateId() {
        var hook = updateWorkInProgressHook();
        var id = hook.memoizedState;
        return id;
    }
    function dispatchReducerAction(fiber, queue, action) {
        if (typeof arguments[3] === "function") error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            hasEagerState: false,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var root = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (root !== null) {
                var eventTime = requestEventTime();
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitionUpdate(root, queue, lane);
            }
        }
        markUpdateInDevTools(fiber, lane);
    }
    function dispatchSetState(fiber, queue, action) {
        if (typeof arguments[3] === "function") error("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var lane = requestUpdateLane(fiber);
        var update = {
            lane: lane,
            action: action,
            hasEagerState: false,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var alternate = fiber.alternate;
            if (fiber.lanes === NoLanes && (alternate === null || alternate.lanes === NoLanes)) {
                // The queue is currently empty, which means we can eagerly compute the
                // next state before entering the render phase. If the new state is the
                // same as the current state, we may be able to bail out entirely.
                var lastRenderedReducer = queue.lastRenderedReducer;
                if (lastRenderedReducer !== null) {
                    var prevDispatcher;
                    prevDispatcher = ReactCurrentDispatcher$1.current;
                    ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
                    try {
                        var currentState = queue.lastRenderedState;
                        var eagerState = lastRenderedReducer(currentState, action); // Stash the eagerly computed state, and the reducer used to compute
                        // it, on the update object. If the reducer hasn't changed by the
                        // time we enter the render phase, then the eager state can be used
                        // without calling the reducer again.
                        update.hasEagerState = true;
                        update.eagerState = eagerState;
                        if (objectIs(eagerState, currentState)) {
                            // Fast path. We can bail out without scheduling React to re-render.
                            // It's still possible that we'll need to rebase this update later,
                            // if the component re-renders for a different reason and by that
                            // time the reducer has changed.
                            // TODO: Do we still need to entangle transitions in this case?
                            enqueueConcurrentHookUpdateAndEagerlyBailout(fiber, queue, update, lane);
                            return;
                        }
                    } catch (error) {} finally{
                        ReactCurrentDispatcher$1.current = prevDispatcher;
                    }
                }
            }
            var root = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (root !== null) {
                var eventTime = requestEventTime();
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitionUpdate(root, queue, lane);
            }
        }
        markUpdateInDevTools(fiber, lane);
    }
    function isRenderPhaseUpdate(fiber) {
        var alternate = fiber.alternate;
        return fiber === currentlyRenderingFiber$1 || alternate !== null && alternate === currentlyRenderingFiber$1;
    }
    function enqueueRenderPhaseUpdate(queue, update) {
        // This is a render phase update. Stash it in a lazily-created map of
        // queue -> linked list of updates. After this render pass, we'll restart
        // and apply the stashed updates on top of the work-in-progress hook.
        didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
        var pending = queue.pending;
        if (pending === null) // This is the first update. Create a circular list.
        update.next = update;
        else {
            update.next = pending.next;
            pending.next = update;
        }
        queue.pending = update;
    } // TODO: Move to ReactFiberConcurrentUpdates?
    function entangleTransitionUpdate(root, queue, lane) {
        if (isTransitionLane(lane)) {
            var queueLanes = queue.lanes; // If any entangled lanes are no longer pending on the root, then they
            // must have finished. We can remove them from the shared queue, which
            // represents a superset of the actually pending lanes. In some cases we
            // may entangle more than we need to, but that's OK. In fact it's worse if
            // we *don't* entangle when we should.
            queueLanes = intersectLanes(queueLanes, root.pendingLanes); // Entangle the new transition lane with the other transition lanes.
            var newQueueLanes = mergeLanes(queueLanes, lane);
            queue.lanes = newQueueLanes; // Even if queue.lanes already include lane, we don't know for certain if
            // the lane finished since the last time we entangled it. So we need to
            // entangle it again, just to be sure.
            markRootEntangled(root, newQueueLanes);
        }
    }
    function markUpdateInDevTools(fiber, lane, action) {
        markStateUpdateScheduled(fiber, lane);
    }
    var ContextOnlyDispatcher = {
        readContext: readContext,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useInsertionEffect: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError,
        useMutableSource: throwInvalidHookError,
        useSyncExternalStore: throwInvalidHookError,
        useId: throwInvalidHookError,
        unstable_isNewReconciler: enableNewReconciler
    };
    var HooksDispatcherOnMountInDEV = null;
    var HooksDispatcherOnMountWithHookTypesInDEV = null;
    var HooksDispatcherOnUpdateInDEV = null;
    var HooksDispatcherOnRerenderInDEV = null;
    var InvalidNestedHooksDispatcherOnMountInDEV = null;
    var InvalidNestedHooksDispatcherOnUpdateInDEV = null;
    var InvalidNestedHooksDispatcherOnRerenderInDEV = null;
    var warnInvalidContextAccess = function() {
        error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
    };
    var warnInvalidHookAccess = function() {
        error("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
    };
    HooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            mountHookTypesDev();
            checkDepsAreArrayDev(deps);
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            mountHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            mountHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnMountWithHookTypesInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    HooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnRerenderInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnMountInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountRef(initialValue);
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            mountHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnMountInDEV;
            try {
                return mountState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            mountHookTypesDev();
            return mountId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnUpdateInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    InvalidNestedHooksDispatcherOnRerenderInDEV = {
        readContext: function(context) {
            warnInvalidContextAccess();
            return readContext(context);
        },
        useCallback: function(callback, deps) {
            currentHookNameInDev = "useCallback";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateCallback(callback, deps);
        },
        useContext: function(context) {
            currentHookNameInDev = "useContext";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return readContext(context);
        },
        useEffect: function(create, deps) {
            currentHookNameInDev = "useEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateEffect(create, deps);
        },
        useImperativeHandle: function(ref, create, deps) {
            currentHookNameInDev = "useImperativeHandle";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateImperativeHandle(ref, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            currentHookNameInDev = "useInsertionEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateInsertionEffect(create, deps);
        },
        useLayoutEffect: function(create, deps) {
            currentHookNameInDev = "useLayoutEffect";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateLayoutEffect(create, deps);
        },
        useMemo: function(create, deps) {
            currentHookNameInDev = "useMemo";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return updateMemo(create, deps);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useReducer: function(reducer, initialArg, init) {
            currentHookNameInDev = "useReducer";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderReducer(reducer, initialArg, init);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useRef: function(initialValue) {
            currentHookNameInDev = "useRef";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateRef();
        },
        useState: function(initialState) {
            currentHookNameInDev = "useState";
            warnInvalidHookAccess();
            updateHookTypesDev();
            var prevDispatcher = ReactCurrentDispatcher$1.current;
            ReactCurrentDispatcher$1.current = InvalidNestedHooksDispatcherOnUpdateInDEV;
            try {
                return rerenderState(initialState);
            } finally{
                ReactCurrentDispatcher$1.current = prevDispatcher;
            }
        },
        useDebugValue: function(value, formatterFn) {
            currentHookNameInDev = "useDebugValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateDebugValue();
        },
        useDeferredValue: function(value) {
            currentHookNameInDev = "useDeferredValue";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderDeferredValue(value);
        },
        useTransition: function() {
            currentHookNameInDev = "useTransition";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return rerenderTransition();
        },
        useMutableSource: function(source, getSnapshot, subscribe) {
            currentHookNameInDev = "useMutableSource";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateMutableSource();
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            currentHookNameInDev = "useSyncExternalStore";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateSyncExternalStore(subscribe, getSnapshot);
        },
        useId: function() {
            currentHookNameInDev = "useId";
            warnInvalidHookAccess();
            updateHookTypesDev();
            return updateId();
        },
        unstable_isNewReconciler: enableNewReconciler
    };
    var now$1 = Scheduler.unstable_now;
    var commitTime = 0;
    var layoutEffectStartTime = -1;
    var profilerStartTime = -1;
    var passiveEffectStartTime = -1;
    /**
 * Tracks whether the current update was a nested/cascading update (scheduled from a layout effect).
 *
 * The overall sequence is:
 *   1. render
 *   2. commit (and call `onRender`, `onCommit`)
 *   3. check for nested updates
 *   4. flush passive effects (and call `onPostCommit`)
 *
 * Nested updates are identified in step 3 above,
 * but step 4 still applies to the work that was just committed.
 * We use two flags to track nested updates then:
 * one tracks whether the upcoming update is a nested update,
 * and the other tracks whether the current update was a nested update.
 * The first value gets synced to the second at the start of the render phase.
 */ var currentUpdateIsNested = false;
    var nestedUpdateScheduled = false;
    function isCurrentUpdateNested() {
        return currentUpdateIsNested;
    }
    function markNestedUpdateScheduled() {
        nestedUpdateScheduled = true;
    }
    function resetNestedUpdateFlag() {
        currentUpdateIsNested = false;
        nestedUpdateScheduled = false;
    }
    function syncNestedUpdateFlag() {
        currentUpdateIsNested = nestedUpdateScheduled;
        nestedUpdateScheduled = false;
    }
    function getCommitTime() {
        return commitTime;
    }
    function recordCommitTime() {
        commitTime = now$1();
    }
    function startProfilerTimer(fiber) {
        profilerStartTime = now$1();
        if (fiber.actualStartTime < 0) fiber.actualStartTime = now$1();
    }
    function stopProfilerTimerIfRunning(fiber) {
        profilerStartTime = -1;
    }
    function stopProfilerTimerIfRunningAndRecordDelta(fiber, overrideBaseTime) {
        if (profilerStartTime >= 0) {
            var elapsedTime = now$1() - profilerStartTime;
            fiber.actualDuration += elapsedTime;
            if (overrideBaseTime) fiber.selfBaseDuration = elapsedTime;
            profilerStartTime = -1;
        }
    }
    function recordLayoutEffectDuration(fiber) {
        if (layoutEffectStartTime >= 0) {
            var elapsedTime = now$1() - layoutEffectStartTime;
            layoutEffectStartTime = -1; // Store duration on the next nearest Profiler ancestor
            // Or the root (for the DevTools Profiler to read)
            var parentFiber = fiber.return;
            while(parentFiber !== null){
                switch(parentFiber.tag){
                    case HostRoot:
                        var root = parentFiber.stateNode;
                        root.effectDuration += elapsedTime;
                        return;
                    case Profiler:
                        var parentStateNode = parentFiber.stateNode;
                        parentStateNode.effectDuration += elapsedTime;
                        return;
                }
                parentFiber = parentFiber.return;
            }
        }
    }
    function recordPassiveEffectDuration(fiber) {
        if (passiveEffectStartTime >= 0) {
            var elapsedTime = now$1() - passiveEffectStartTime;
            passiveEffectStartTime = -1; // Store duration on the next nearest Profiler ancestor
            // Or the root (for the DevTools Profiler to read)
            var parentFiber = fiber.return;
            while(parentFiber !== null){
                switch(parentFiber.tag){
                    case HostRoot:
                        var root = parentFiber.stateNode;
                        if (root !== null) root.passiveEffectDuration += elapsedTime;
                        return;
                    case Profiler:
                        var parentStateNode = parentFiber.stateNode;
                        if (parentStateNode !== null) // Detached fibers have their state node cleared out.
                        // In this case, the return pointer is also cleared out,
                        // so we won't be able to report the time spent in this Profiler's subtree.
                        parentStateNode.passiveEffectDuration += elapsedTime;
                        return;
                }
                parentFiber = parentFiber.return;
            }
        }
    }
    function startLayoutEffectTimer() {
        layoutEffectStartTime = now$1();
    }
    function startPassiveEffectTimer() {
        passiveEffectStartTime = now$1();
    }
    function transferActualDuration(fiber) {
        // Transfer time spent rendering these children so we don't lose it
        // after we rerender. This is used as a helper in special cases
        // where we should count the work of multiple passes.
        var child = fiber.child;
        while(child){
            fiber.actualDuration += child.actualDuration;
            child = child.sibling;
        }
    }
    function resolveDefaultProps(Component, baseProps) {
        if (Component && Component.defaultProps) {
            // Resolve default props. Taken from ReactElement
            var props = assign({}, baseProps);
            var defaultProps = Component.defaultProps;
            for(var propName in defaultProps)if (props[propName] === undefined) props[propName] = defaultProps[propName];
            return props;
        }
        return baseProps;
    }
    var fakeInternalInstance = {};
    var didWarnAboutStateAssignmentForComponent;
    var didWarnAboutUninitializedState;
    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate;
    var didWarnAboutLegacyLifecyclesAndDerivedState;
    var didWarnAboutUndefinedDerivedState;
    var warnOnUndefinedDerivedState;
    var warnOnInvalidCallback;
    var didWarnAboutDirectlyAssigningPropsToState;
    var didWarnAboutContextTypeAndContextTypes;
    var didWarnAboutInvalidateContextType;
    var didWarnAboutLegacyContext$1;
    didWarnAboutStateAssignmentForComponent = new Set();
    didWarnAboutUninitializedState = new Set();
    didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = new Set();
    didWarnAboutLegacyLifecyclesAndDerivedState = new Set();
    didWarnAboutDirectlyAssigningPropsToState = new Set();
    didWarnAboutUndefinedDerivedState = new Set();
    didWarnAboutContextTypeAndContextTypes = new Set();
    didWarnAboutInvalidateContextType = new Set();
    didWarnAboutLegacyContext$1 = new Set();
    var didWarnOnInvalidCallback = new Set();
    warnOnInvalidCallback = function(callback, callerName) {
        if (callback === null || typeof callback === "function") return;
        var key = callerName + "_" + callback;
        if (!didWarnOnInvalidCallback.has(key)) {
            didWarnOnInvalidCallback.add(key);
            error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
        }
    };
    warnOnUndefinedDerivedState = function(type, partialState) {
        if (partialState === undefined) {
            var componentName = getComponentNameFromType(type) || "Component";
            if (!didWarnAboutUndefinedDerivedState.has(componentName)) {
                didWarnAboutUndefinedDerivedState.add(componentName);
                error("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", componentName);
            }
        }
    }; // This is so gross but it's at least non-critical and can be removed if
    // it causes problems. This is meant to give a nicer error message for
    // ReactDOM15.unstable_renderSubtreeIntoContainer(reactDOM16Component,
    // ...)) which otherwise throws a "_processChildContext is not a function"
    // exception.
    Object.defineProperty(fakeInternalInstance, "_processChildContext", {
        enumerable: false,
        value: function() {
            throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
        }
    });
    Object.freeze(fakeInternalInstance);
    function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        var prevState = workInProgress.memoizedState;
        var partialState = getDerivedStateFromProps(nextProps, prevState);
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                // Invoke the function an extra time to help detect side-effects.
                partialState = getDerivedStateFromProps(nextProps, prevState);
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        warnOnUndefinedDerivedState(ctor, partialState);
        var memoizedState = partialState === null || partialState === undefined ? prevState : assign({}, prevState, partialState);
        workInProgress.memoizedState = memoizedState; // Once the update queue is empty, persist the derived state onto the
        // base state.
        if (workInProgress.lanes === NoLanes) {
            // Queue is always non-null for classes
            var updateQueue = workInProgress.updateQueue;
            updateQueue.baseState = memoizedState;
        }
    }
    var classComponentUpdater = {
        isMounted: isMounted,
        enqueueSetState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "setState");
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markStateUpdateScheduled(fiber, lane);
        },
        enqueueReplaceState: function(inst, payload, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ReplaceState;
            update.payload = payload;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "replaceState");
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markStateUpdateScheduled(fiber, lane);
        },
        enqueueForceUpdate: function(inst, callback) {
            var fiber = get(inst);
            var eventTime = requestEventTime();
            var lane = requestUpdateLane(fiber);
            var update = createUpdate(eventTime, lane);
            update.tag = ForceUpdate;
            if (callback !== undefined && callback !== null) {
                warnOnInvalidCallback(callback, "forceUpdate");
                update.callback = callback;
            }
            var root = enqueueUpdate(fiber, update, lane);
            if (root !== null) {
                scheduleUpdateOnFiber(root, fiber, lane, eventTime);
                entangleTransitions(root, fiber, lane);
            }
            markForceUpdateScheduled(fiber, lane);
        }
    };
    function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        var instance = workInProgress.stateNode;
        if (typeof instance.shouldComponentUpdate === "function") {
            var shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    // Invoke the function an extra time to help detect side-effects.
                    shouldUpdate = instance.shouldComponentUpdate(newProps, newState, nextContext);
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            if (shouldUpdate === undefined) error("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", getComponentNameFromType(ctor) || "Component");
            return shouldUpdate;
        }
        if (ctor.prototype && ctor.prototype.isPureReactComponent) return !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState);
        return true;
    }
    function checkClassInstance(workInProgress, ctor, newProps) {
        var instance = workInProgress.stateNode;
        var name = getComponentNameFromType(ctor) || "Component";
        var renderPresent = instance.render;
        if (!renderPresent) {
            if (ctor.prototype && typeof ctor.prototype.render === "function") error("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", name);
            else error("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", name);
        }
        if (instance.getInitialState && !instance.getInitialState.isReactClassApproved && !instance.state) error("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", name);
        if (instance.getDefaultProps && !instance.getDefaultProps.isReactClassApproved) error("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", name);
        if (instance.propTypes) error("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", name);
        if (instance.contextType) error("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", name);
        if (ctor.childContextTypes && !didWarnAboutLegacyContext$1.has(ctor) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (workInProgress.mode & StrictLegacyMode) === NoMode) {
            didWarnAboutLegacyContext$1.add(ctor);
            error("%s uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() instead\n\n.Learn more about this warning here: https://reactjs.org/link/legacy-context", name);
        }
        if (ctor.contextTypes && !didWarnAboutLegacyContext$1.has(ctor) && // Strict Mode has its own warning for legacy context, so we can skip
        // this one.
        (workInProgress.mode & StrictLegacyMode) === NoMode) {
            didWarnAboutLegacyContext$1.add(ctor);
            error("%s uses the legacy contextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() with static contextType instead.\n\nLearn more about this warning here: https://reactjs.org/link/legacy-context", name);
        }
        if (instance.contextTypes) error("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", name);
        if (ctor.contextType && ctor.contextTypes && !didWarnAboutContextTypeAndContextTypes.has(ctor)) {
            didWarnAboutContextTypeAndContextTypes.add(ctor);
            error("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", name);
        }
        if (typeof instance.componentShouldUpdate === "function") error("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", name);
        if (ctor.prototype && ctor.prototype.isPureReactComponent && typeof instance.shouldComponentUpdate !== "undefined") error("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", getComponentNameFromType(ctor) || "A pure component");
        if (typeof instance.componentDidUnmount === "function") error("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", name);
        if (typeof instance.componentDidReceiveProps === "function") error("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", name);
        if (typeof instance.componentWillRecieveProps === "function") error("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", name);
        if (typeof instance.UNSAFE_componentWillRecieveProps === "function") error("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", name);
        var hasMutatedProps = instance.props !== newProps;
        if (instance.props !== undefined && hasMutatedProps) error("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", name, name);
        if (instance.defaultProps) error("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", name, name);
        if (typeof instance.getSnapshotBeforeUpdate === "function" && typeof instance.componentDidUpdate !== "function" && !didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(ctor)) {
            didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(ctor);
            error("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", getComponentNameFromType(ctor));
        }
        if (typeof instance.getDerivedStateFromProps === "function") error("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof instance.getDerivedStateFromError === "function") error("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", name);
        if (typeof ctor.getSnapshotBeforeUpdate === "function") error("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", name);
        var _state = instance.state;
        if (_state && (typeof _state !== "object" || isArray(_state))) error("%s.state: must be set to an object or null", name);
        if (typeof instance.getChildContext === "function" && typeof ctor.childContextTypes !== "object") error("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", name);
    }
    function adoptClassInstance(workInProgress, instance) {
        instance.updater = classComponentUpdater;
        workInProgress.stateNode = instance; // The instance needs access to the fiber so that it can schedule updates
        set(instance, workInProgress);
        instance._reactInternalInstance = fakeInternalInstance;
    }
    function constructClassInstance(workInProgress, ctor, props) {
        var isLegacyContextConsumer = false;
        var unmaskedContext = emptyContextObject;
        var context = emptyContextObject;
        var contextType = ctor.contextType;
        if ("contextType" in ctor) {
            var isValid = contextType === null || contextType !== undefined && contextType.$$typeof === REACT_CONTEXT_TYPE && contextType._context === undefined; // Not a <Context.Consumer>
            if (!isValid && !didWarnAboutInvalidateContextType.has(ctor)) {
                didWarnAboutInvalidateContextType.add(ctor);
                var addendum = "";
                if (contextType === undefined) addendum = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file.";
                else if (typeof contextType !== "object") addendum = " However, it is set to a " + typeof contextType + ".";
                else if (contextType.$$typeof === REACT_PROVIDER_TYPE) addendum = " Did you accidentally pass the Context.Provider instead?";
                else if (contextType._context !== undefined) // <Context.Consumer>
                addendum = " Did you accidentally pass the Context.Consumer instead?";
                else addendum = " However, it is set to an object with keys {" + Object.keys(contextType).join(", ") + "}.";
                error("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", getComponentNameFromType(ctor) || "Component", addendum);
            }
        }
        if (typeof contextType === "object" && contextType !== null) context = readContext(contextType);
        else {
            unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            var contextTypes = ctor.contextTypes;
            isLegacyContextConsumer = contextTypes !== null && contextTypes !== undefined;
            context = isLegacyContextConsumer ? getMaskedContext(workInProgress, unmaskedContext) : emptyContextObject;
        }
        var instance = new ctor(props, context); // Instantiate twice to help detect side-effects.
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                instance = new ctor(props, context); // eslint-disable-line no-new
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        var state = workInProgress.memoizedState = instance.state !== null && instance.state !== undefined ? instance.state : null;
        adoptClassInstance(workInProgress, instance);
        if (typeof ctor.getDerivedStateFromProps === "function" && state === null) {
            var componentName = getComponentNameFromType(ctor) || "Component";
            if (!didWarnAboutUninitializedState.has(componentName)) {
                didWarnAboutUninitializedState.add(componentName);
                error("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", componentName, instance.state === null ? "null" : "undefined", componentName);
            }
        } // If new component APIs are defined, "unsafe" lifecycles won't be called.
        // Warn about these lifecycles if they are present.
        // Don't warn about react-lifecycles-compat polyfilled methods though.
        if (typeof ctor.getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function") {
            var foundWillMountName = null;
            var foundWillReceivePropsName = null;
            var foundWillUpdateName = null;
            if (typeof instance.componentWillMount === "function" && instance.componentWillMount.__suppressDeprecationWarning !== true) foundWillMountName = "componentWillMount";
            else if (typeof instance.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
            if (typeof instance.componentWillReceiveProps === "function" && instance.componentWillReceiveProps.__suppressDeprecationWarning !== true) foundWillReceivePropsName = "componentWillReceiveProps";
            else if (typeof instance.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
            if (typeof instance.componentWillUpdate === "function" && instance.componentWillUpdate.__suppressDeprecationWarning !== true) foundWillUpdateName = "componentWillUpdate";
            else if (typeof instance.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
            if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
                var _componentName = getComponentNameFromType(ctor) || "Component";
                var newApiName = typeof ctor.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
                if (!didWarnAboutLegacyLifecyclesAndDerivedState.has(_componentName)) {
                    didWarnAboutLegacyLifecyclesAndDerivedState.add(_componentName);
                    error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://reactjs.org/link/unsafe-component-lifecycles", _componentName, newApiName, foundWillMountName !== null ? "\n  " + foundWillMountName : "", foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "", foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "");
                }
            }
        }
        // ReactFiberContext usually updates this cache but can't for newly-created instances.
        if (isLegacyContextConsumer) cacheContext(workInProgress, unmaskedContext, context);
        return instance;
    }
    function callComponentWillMount(workInProgress, instance) {
        var oldState = instance.state;
        if (typeof instance.componentWillMount === "function") instance.componentWillMount();
        if (typeof instance.UNSAFE_componentWillMount === "function") instance.UNSAFE_componentWillMount();
        if (oldState !== instance.state) {
            error("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", getComponentNameFromFiber(workInProgress) || "Component");
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    }
    function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        var oldState = instance.state;
        if (typeof instance.componentWillReceiveProps === "function") instance.componentWillReceiveProps(newProps, nextContext);
        if (typeof instance.UNSAFE_componentWillReceiveProps === "function") instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        if (instance.state !== oldState) {
            var componentName = getComponentNameFromFiber(workInProgress) || "Component";
            if (!didWarnAboutStateAssignmentForComponent.has(componentName)) {
                didWarnAboutStateAssignmentForComponent.add(componentName);
                error("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", componentName);
            }
            classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
        }
    } // Invokes the mount life-cycles on a previously never rendered instance.
    function mountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        checkClassInstance(workInProgress, ctor, newProps);
        var instance = workInProgress.stateNode;
        instance.props = newProps;
        instance.state = workInProgress.memoizedState;
        instance.refs = {};
        initializeUpdateQueue(workInProgress);
        var contextType = ctor.contextType;
        if (typeof contextType === "object" && contextType !== null) instance.context = readContext(contextType);
        else {
            var unmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            instance.context = getMaskedContext(workInProgress, unmaskedContext);
        }
        if (instance.state === newProps) {
            var componentName = getComponentNameFromType(ctor) || "Component";
            if (!didWarnAboutDirectlyAssigningPropsToState.has(componentName)) {
                didWarnAboutDirectlyAssigningPropsToState.add(componentName);
                error("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", componentName);
            }
        }
        if (workInProgress.mode & StrictLegacyMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, instance);
        ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(workInProgress, instance);
        instance.state = workInProgress.memoizedState;
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            instance.state = workInProgress.memoizedState;
        } // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (typeof ctor.getDerivedStateFromProps !== "function" && typeof instance.getSnapshotBeforeUpdate !== "function" && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
            callComponentWillMount(workInProgress, instance); // If we had additional state updates during this life-cycle, let's
            // process them now.
            processUpdateQueue(workInProgress, newProps, instance, renderLanes);
            instance.state = workInProgress.memoizedState;
        }
        if (typeof instance.componentDidMount === "function") {
            var fiberFlags = Update;
            fiberFlags |= LayoutStatic;
            if ((workInProgress.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
            workInProgress.flags |= fiberFlags;
        }
    }
    function resumeMountClassInstance(workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        var oldProps = workInProgress.memoizedProps;
        instance.props = oldProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === "object" && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextLegacyUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextLegacyUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function"; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (oldProps !== newProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (oldProps === newProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing()) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === "function") {
                var fiberFlags = Update;
                fiberFlags |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) fiberFlags |= MountLayoutDev;
                workInProgress.flags |= fiberFlags;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext);
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillMount === "function" || typeof instance.componentWillMount === "function")) {
                if (typeof instance.componentWillMount === "function") instance.componentWillMount();
                if (typeof instance.UNSAFE_componentWillMount === "function") instance.UNSAFE_componentWillMount();
            }
            if (typeof instance.componentDidMount === "function") {
                var _fiberFlags = Update;
                _fiberFlags |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) _fiberFlags |= MountLayoutDev;
                workInProgress.flags |= _fiberFlags;
            }
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidMount === "function") {
                var _fiberFlags2 = Update;
                _fiberFlags2 |= LayoutStatic;
                if ((workInProgress.mode & StrictEffectsMode) !== NoMode) _fiberFlags2 |= MountLayoutDev;
                workInProgress.flags |= _fiberFlags2;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    } // Invokes the update life-cycles and returns false if it shouldn't rerender.
    function updateClassInstance(current, workInProgress, ctor, newProps, renderLanes) {
        var instance = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        var unresolvedOldProps = workInProgress.memoizedProps;
        var oldProps = workInProgress.type === workInProgress.elementType ? unresolvedOldProps : resolveDefaultProps(workInProgress.type, unresolvedOldProps);
        instance.props = oldProps;
        var unresolvedNewProps = workInProgress.pendingProps;
        var oldContext = instance.context;
        var contextType = ctor.contextType;
        var nextContext = emptyContextObject;
        if (typeof contextType === "object" && contextType !== null) nextContext = readContext(contextType);
        else {
            var nextUnmaskedContext = getUnmaskedContext(workInProgress, ctor, true);
            nextContext = getMaskedContext(workInProgress, nextUnmaskedContext);
        }
        var getDerivedStateFromProps = ctor.getDerivedStateFromProps;
        var hasNewLifecycles = typeof getDerivedStateFromProps === "function" || typeof instance.getSnapshotBeforeUpdate === "function"; // Note: During these life-cycles, instance.props/instance.state are what
        // ever the previously attempted to render - not the "current". However,
        // during componentDidUpdate we pass the "current" props.
        // In order to support react-lifecycles-compat polyfilled components,
        // Unsafe lifecycles should not be invoked for components using the new APIs.
        if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillReceiveProps === "function" || typeof instance.componentWillReceiveProps === "function")) {
            if (unresolvedOldProps !== unresolvedNewProps || oldContext !== nextContext) callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext);
        }
        resetHasForceUpdateBeforeProcessing();
        var oldState = workInProgress.memoizedState;
        var newState = instance.state = oldState;
        processUpdateQueue(workInProgress, newProps, instance, renderLanes);
        newState = workInProgress.memoizedState;
        if (unresolvedOldProps === unresolvedNewProps && oldState === newState && !hasContextChanged() && !checkHasForceUpdateAfterProcessing() && !enableLazyContextPropagation) {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            }
            return false;
        }
        if (typeof getDerivedStateFromProps === "function") {
            applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, newProps);
            newState = workInProgress.memoizedState;
        }
        var shouldUpdate = checkHasForceUpdateAfterProcessing() || checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) || // TODO: In some cases, we'll end up checking if context has changed twice,
        // both before and after `shouldComponentUpdate` has been called. Not ideal,
        // but I'm loath to refactor this function. This only happens for memoized
        // components so it's not that common.
        enableLazyContextPropagation;
        if (shouldUpdate) {
            // In order to support react-lifecycles-compat polyfilled components,
            // Unsafe lifecycles should not be invoked for components using the new APIs.
            if (!hasNewLifecycles && (typeof instance.UNSAFE_componentWillUpdate === "function" || typeof instance.componentWillUpdate === "function")) {
                if (typeof instance.componentWillUpdate === "function") instance.componentWillUpdate(newProps, newState, nextContext);
                if (typeof instance.UNSAFE_componentWillUpdate === "function") instance.UNSAFE_componentWillUpdate(newProps, newState, nextContext);
            }
            if (typeof instance.componentDidUpdate === "function") workInProgress.flags |= Update;
            if (typeof instance.getSnapshotBeforeUpdate === "function") workInProgress.flags |= Snapshot;
        } else {
            // If an update was already in progress, we should schedule an Update
            // effect even though we're bailing out, so that cWU/cDU are called.
            if (typeof instance.componentDidUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Update;
            }
            if (typeof instance.getSnapshotBeforeUpdate === "function") {
                if (unresolvedOldProps !== current.memoizedProps || oldState !== current.memoizedState) workInProgress.flags |= Snapshot;
            } // If shouldComponentUpdate returned false, we should still update the
            // memoized props/state to indicate that this work can be reused.
            workInProgress.memoizedProps = newProps;
            workInProgress.memoizedState = newState;
        } // Update the existing instance's state, props, and context pointers even
        // if shouldComponentUpdate returns false.
        instance.props = newProps;
        instance.state = newState;
        instance.context = nextContext;
        return shouldUpdate;
    }
    function createCapturedValueAtFiber(value, source) {
        // If the value is an error, call this function immediately after it is thrown
        // so the stack is accurate.
        return {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source),
            digest: null
        };
    }
    function createCapturedValue(value, digest, stack) {
        return {
            value: value,
            source: null,
            stack: stack != null ? stack : null,
            digest: digest != null ? digest : null
        };
    }
    // This module is forked in different environments.
    // By default, return `true` to log errors to the console.
    // Forks can return `false` if this isn't desirable.
    function showErrorDialog(boundary, errorInfo) {
        return true;
    }
    function logCapturedError(boundary, errorInfo) {
        try {
            var logError = showErrorDialog(boundary, errorInfo); // Allow injected showErrorDialog() to prevent default console.error logging.
            // This enables renderers like ReactNative to better manage redbox behavior.
            if (logError === false) return;
            var error = errorInfo.value;
            var source = errorInfo.source;
            var stack = errorInfo.stack;
            var componentStack = stack !== null ? stack : ""; // Browsers support silencing uncaught errors by calling
            // `preventDefault()` in window `error` handler.
            // We record this information as an expando on the error.
            if (error != null && error._suppressLogging) {
                if (boundary.tag === ClassComponent) // The error is recoverable and was silenced.
                // Ignore it and don't print the stack addendum.
                // This is handy for testing error boundaries without noise.
                return;
                 // The error is fatal. Since the silencing might have
                // been accidental, we'll surface it anyway.
                // However, the browser would have silenced the original error
                // so we'll print it first, and then print the stack addendum.
                console["error"](error); // Don't transform to our wrapper
            // For a more detailed description of this block, see:
            // https://github.com/facebook/react/pull/13384
            }
            var componentName = source ? getComponentNameFromFiber(source) : null;
            var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component:" : "The above error occurred in one of your React components:";
            var errorBoundaryMessage;
            if (boundary.tag === HostRoot) errorBoundaryMessage = "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://reactjs.org/link/error-boundaries to learn more about error boundaries.";
            else {
                var errorBoundaryName = getComponentNameFromFiber(boundary) || "Anonymous";
                errorBoundaryMessage = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + errorBoundaryName + ".");
            }
            var combinedMessage = componentNameMessage + "\n" + componentStack + "\n\n" + ("" + errorBoundaryMessage); // In development, we provide our own message with just the component stack.
            // We don't include the original error message and JS stack because the browser
            // has already printed it. Even if the application swallows the error, it is still
            // displayed by the browser thanks to the DEV-only fake event trick in ReactErrorUtils.
            console["error"](combinedMessage); // Don't transform to our wrapper
        } catch (e) {
            // This method must not throw, or React internal state will get messed up.
            // If console.error is overridden, or logCapturedError() shows a dialog that throws,
            // we want to report this error outside of the normal stack as a last resort.
            // https://github.com/facebook/react/issues/13188
            setTimeout(function() {
                throw e;
            });
        }
    }
    var PossiblyWeakMap$1 = typeof WeakMap === "function" ? WeakMap : Map;
    function createRootErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane); // Unmount the root by rendering null.
        update.tag = CaptureUpdate; // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: null
        };
        var error = errorInfo.value;
        update.callback = function() {
            onUncaughtError(error);
            logCapturedError(fiber, errorInfo);
        };
        return update;
    }
    function createClassErrorUpdate(fiber, errorInfo, lane) {
        var update = createUpdate(NoTimestamp, lane);
        update.tag = CaptureUpdate;
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
        if (typeof getDerivedStateFromError === "function") {
            var error$1 = errorInfo.value;
            update.payload = function() {
                return getDerivedStateFromError(error$1);
            };
            update.callback = function() {
                markFailedErrorBoundaryForHotReloading(fiber);
                logCapturedError(fiber, errorInfo);
            };
        }
        var inst = fiber.stateNode;
        if (inst !== null && typeof inst.componentDidCatch === "function") update.callback = function callback() {
            markFailedErrorBoundaryForHotReloading(fiber);
            logCapturedError(fiber, errorInfo);
            if (typeof getDerivedStateFromError !== "function") // To preserve the preexisting retry behavior of error boundaries,
            // we keep track of which ones already failed during this batch.
            // This gets reset before we yield back to the browser.
            // TODO: Warn in strict mode if getDerivedStateFromError is
            // not defined.
            markLegacyErrorBoundaryAsFailed(this);
            var error$1 = errorInfo.value;
            var stack = errorInfo.stack;
            this.componentDidCatch(error$1, {
                componentStack: stack !== null ? stack : ""
            });
            if (typeof getDerivedStateFromError !== "function") // If componentDidCatch is the only error boundary method defined,
            // then it needs to call setState to recover from errors.
            // If no state update is scheduled then the boundary will swallow the error.
            {
                if (!includesSomeLane(fiber.lanes, SyncLane)) error("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", getComponentNameFromFiber(fiber) || "Unknown");
            }
        };
        return update;
    }
    function attachPingListener(root, wakeable, lanes) {
        // Attach a ping listener
        //
        // The data might resolve before we have a chance to commit the fallback. Or,
        // in the case of a refresh, we'll never commit a fallback. So we need to
        // attach a listener now. When it resolves ("pings"), we can decide whether to
        // try rendering the tree again.
        //
        // Only attach a listener if one does not already exist for the lanes
        // we're currently rendering (which acts like a "thread ID" here).
        //
        // We only need to do this in concurrent mode. Legacy Suspense always
        // commits fallbacks synchronously, so there are no pings.
        var pingCache = root.pingCache;
        var threadIDs;
        if (pingCache === null) {
            pingCache = root.pingCache = new PossiblyWeakMap$1();
            threadIDs = new Set();
            pingCache.set(wakeable, threadIDs);
        } else {
            threadIDs = pingCache.get(wakeable);
            if (threadIDs === undefined) {
                threadIDs = new Set();
                pingCache.set(wakeable, threadIDs);
            }
        }
        if (!threadIDs.has(lanes)) {
            // Memoize using the thread ID to prevent redundant listeners.
            threadIDs.add(lanes);
            var ping = pingSuspendedRoot.bind(null, root, wakeable, lanes);
            if (isDevToolsPresent) // If we have pending work still, restore the original updaters
            restorePendingUpdaters(root, lanes);
            wakeable.then(ping, ping);
        }
    }
    function attachRetryListener(suspenseBoundary, root, wakeable, lanes) {
        // Retry listener
        //
        // If the fallback does commit, we need to attach a different type of
        // listener. This one schedules an update on the Suspense boundary to turn
        // the fallback state off.
        //
        // Stash the wakeable on the boundary fiber so we can access it in the
        // commit phase.
        //
        // When the wakeable resolves, we'll attempt to render the boundary
        // again ("retry").
        var wakeables = suspenseBoundary.updateQueue;
        if (wakeables === null) {
            var updateQueue = new Set();
            updateQueue.add(wakeable);
            suspenseBoundary.updateQueue = updateQueue;
        } else wakeables.add(wakeable);
    }
    function resetSuspendedComponent(sourceFiber, rootRenderLanes) {
        // A legacy mode Suspense quirk, only relevant to hook components.
        var tag = sourceFiber.tag;
        if ((sourceFiber.mode & ConcurrentMode) === NoMode && (tag === FunctionComponent || tag === ForwardRef || tag === SimpleMemoComponent)) {
            var currentSource = sourceFiber.alternate;
            if (currentSource) {
                sourceFiber.updateQueue = currentSource.updateQueue;
                sourceFiber.memoizedState = currentSource.memoizedState;
                sourceFiber.lanes = currentSource.lanes;
            } else {
                sourceFiber.updateQueue = null;
                sourceFiber.memoizedState = null;
            }
        }
    }
    function getNearestSuspenseBoundaryToCapture(returnFiber) {
        var node = returnFiber;
        do {
            if (node.tag === SuspenseComponent && shouldCaptureSuspense(node)) return node;
             // This boundary already captured during this render. Continue to the next
            // boundary.
            node = node.return;
        }while (node !== null);
        return null;
    }
    function markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes) {
        // This marks a Suspense boundary so that when we're unwinding the stack,
        // it captures the suspended "exception" and does a second (fallback) pass.
        if ((suspenseBoundary.mode & ConcurrentMode) === NoMode) {
            // Legacy Mode Suspense
            //
            // If the boundary is in legacy mode, we should *not*
            // suspend the commit. Pretend as if the suspended component rendered
            // null and keep rendering. When the Suspense boundary completes,
            // we'll do a second pass to render the fallback.
            if (suspenseBoundary === returnFiber) // Special case where we suspended while reconciling the children of
            // a Suspense boundary's inner Offscreen wrapper fiber. This happens
            // when a React.lazy component is a direct child of a
            // Suspense boundary.
            //
            // Suspense boundaries are implemented as multiple fibers, but they
            // are a single conceptual unit. The legacy mode behavior where we
            // pretend the suspended fiber committed as `null` won't work,
            // because in this case the "suspended" fiber is the inner
            // Offscreen wrapper.
            //
            // Because the contents of the boundary haven't started rendering
            // yet (i.e. nothing in the tree has partially rendered) we can
            // switch to the regular, concurrent mode behavior: mark the
            // boundary with ShouldCapture and enter the unwind phase.
            suspenseBoundary.flags |= ShouldCapture;
            else {
                suspenseBoundary.flags |= DidCapture;
                sourceFiber.flags |= ForceUpdateForLegacySuspense; // We're going to commit this fiber even though it didn't complete.
                // But we shouldn't call any lifecycle methods or callbacks. Remove
                // all lifecycle effect tags.
                sourceFiber.flags &= ~(LifecycleEffectMask | Incomplete);
                if (sourceFiber.tag === ClassComponent) {
                    var currentSourceFiber = sourceFiber.alternate;
                    if (currentSourceFiber === null) // This is a new mount. Change the tag so it's not mistaken for a
                    // completed class component. For example, we should not call
                    // componentWillUnmount if it is deleted.
                    sourceFiber.tag = IncompleteClassComponent;
                    else {
                        // When we try rendering again, we should not reuse the current fiber,
                        // since it's known to be in an inconsistent state. Use a force update to
                        // prevent a bail out.
                        var update = createUpdate(NoTimestamp, SyncLane);
                        update.tag = ForceUpdate;
                        enqueueUpdate(sourceFiber, update, SyncLane);
                    }
                } // The source fiber did not complete. Mark it with Sync priority to
                // indicate that it still has pending work.
                sourceFiber.lanes = mergeLanes(sourceFiber.lanes, SyncLane);
            }
            return suspenseBoundary;
        } // Confirmed that the boundary is in a concurrent mode tree. Continue
        // with the normal suspend path.
        //
        // After this we'll use a set of heuristics to determine whether this
        // render pass will run to completion or restart or "suspend" the commit.
        // The actual logic for this is spread out in different places.
        //
        // This first principle is that if we're going to suspend when we complete
        // a root, then we should also restart if we get an update or ping that
        // might unsuspend it, and vice versa. The only reason to suspend is
        // because you think you might want to restart before committing. However,
        // it doesn't make sense to restart only while in the period we're suspended.
        //
        // Restarting too aggressively is also not good because it starves out any
        // intermediate loading state. So we use heuristics to determine when.
        // Suspense Heuristics
        //
        // If nothing threw a Promise or all the same fallbacks are already showing,
        // then don't suspend/restart.
        //
        // If this is an initial render of a new tree of Suspense boundaries and
        // those trigger a fallback, then don't suspend/restart. We want to ensure
        // that we can show the initial loading state as quickly as possible.
        //
        // If we hit a "Delayed" case, such as when we'd switch from content back into
        // a fallback, then we should always suspend/restart. Transitions apply
        // to this case. If none is defined, JND is used instead.
        //
        // If we're already showing a fallback and it gets "retried", allowing us to show
        // another level, but there's still an inner boundary that would show a fallback,
        // then we suspend/restart for 500ms since the last time we showed a fallback
        // anywhere in the tree. This effectively throttles progressive loading into a
        // consistent train of commits. This also gives us an opportunity to restart to
        // get to the completed state slightly earlier.
        //
        // If there's ambiguity due to batching it's resolved in preference of:
        // 1) "delayed", 2) "initial render", 3) "retry".
        //
        // We want to ensure that a "busy" state doesn't get force committed. We want to
        // ensure that new initial loading states can commit as soon as possible.
        suspenseBoundary.flags |= ShouldCapture; // TODO: I think we can remove this, since we now use `DidCapture` in
        // the begin phase to prevent an early bailout.
        suspenseBoundary.lanes = rootRenderLanes;
        return suspenseBoundary;
    }
    function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
        // The source fiber did not complete.
        sourceFiber.flags |= Incomplete;
        if (isDevToolsPresent) // If we have pending work still, restore the original updaters
        restorePendingUpdaters(root, rootRenderLanes);
        if (value !== null && typeof value === "object" && typeof value.then === "function") {
            // This is a wakeable. The component suspended.
            var wakeable = value;
            resetSuspendedComponent(sourceFiber);
            if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) markDidThrowWhileHydratingDEV();
            var suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber);
            if (suspenseBoundary !== null) {
                suspenseBoundary.flags &= ~ForceClientRender;
                markSuspenseBoundaryShouldCapture(suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes); // We only attach ping listeners in concurrent mode. Legacy Suspense always
                // commits fallbacks synchronously, so there are no pings.
                if (suspenseBoundary.mode & ConcurrentMode) attachPingListener(root, wakeable, rootRenderLanes);
                attachRetryListener(suspenseBoundary, root, wakeable);
                return;
            } else {
                // No boundary was found. Unless this is a sync update, this is OK.
                // We can suspend and wait for more data to arrive.
                if (!includesSyncLane(rootRenderLanes)) {
                    // This is not a sync update. Suspend. Since we're not activating a
                    // Suspense boundary, this will unwind all the way to the root without
                    // performing a second pass to render a fallback. (This is arguably how
                    // refresh transitions should work, too, since we're not going to commit
                    // the fallbacks anyway.)
                    //
                    // This case also applies to initial hydration.
                    attachPingListener(root, wakeable, rootRenderLanes);
                    renderDidSuspendDelayIfPossible();
                    return;
                } // This is a sync/discrete update. We treat this case like an error
                // because discrete renders are expected to produce a complete tree
                // synchronously to maintain consistency with external state.
                var uncaughtSuspenseError = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition."); // If we're outside a transition, fall through to the regular error path.
                // The error will be caught by the nearest suspense boundary.
                value = uncaughtSuspenseError;
            }
        } else // This is a regular error, not a Suspense wakeable.
        if (getIsHydrating() && sourceFiber.mode & ConcurrentMode) {
            markDidThrowWhileHydratingDEV();
            var _suspenseBoundary = getNearestSuspenseBoundaryToCapture(returnFiber); // If the error was thrown during hydration, we may be able to recover by
            // discarding the dehydrated content and switching to a client render.
            // Instead of surfacing the error, find the nearest Suspense boundary
            // and render it again without hydration.
            if (_suspenseBoundary !== null) {
                if ((_suspenseBoundary.flags & ShouldCapture) === NoFlags) // Set a flag to indicate that we should try rendering the normal
                // children again, not the fallback.
                _suspenseBoundary.flags |= ForceClientRender;
                markSuspenseBoundaryShouldCapture(_suspenseBoundary, returnFiber, sourceFiber, root, rootRenderLanes); // Even though the user may not be affected by this error, we should
                // still log it so it can be fixed.
                queueHydrationError(createCapturedValueAtFiber(value, sourceFiber));
                return;
            }
        }
        value = createCapturedValueAtFiber(value, sourceFiber);
        renderDidError(value); // We didn't find a boundary that could handle this type of exception. Start
        // over and traverse parent path again, this time treating the exception
        // as an error.
        var workInProgress = returnFiber;
        do {
            switch(workInProgress.tag){
                case HostRoot:
                    var _errorInfo = value;
                    workInProgress.flags |= ShouldCapture;
                    var lane = pickArbitraryLane(rootRenderLanes);
                    workInProgress.lanes = mergeLanes(workInProgress.lanes, lane);
                    var update = createRootErrorUpdate(workInProgress, _errorInfo, lane);
                    enqueueCapturedUpdate(workInProgress, update);
                    return;
                case ClassComponent:
                    // Capture and retry
                    var errorInfo = value;
                    var ctor = workInProgress.type;
                    var instance = workInProgress.stateNode;
                    if ((workInProgress.flags & DidCapture) === NoFlags && (typeof ctor.getDerivedStateFromError === "function" || instance !== null && typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance))) {
                        workInProgress.flags |= ShouldCapture;
                        var _lane = pickArbitraryLane(rootRenderLanes);
                        workInProgress.lanes = mergeLanes(workInProgress.lanes, _lane); // Schedule the error boundary to re-render using updated state
                        var _update = createClassErrorUpdate(workInProgress, errorInfo, _lane);
                        enqueueCapturedUpdate(workInProgress, _update);
                        return;
                    }
                    break;
            }
            workInProgress = workInProgress.return;
        }while (workInProgress !== null);
    }
    function getSuspendedCache() {
        return null;
    }
    var ReactCurrentOwner$1 = ReactSharedInternals.ReactCurrentOwner;
    var didReceiveUpdate = false;
    var didWarnAboutBadClass;
    var didWarnAboutModulePatternComponent;
    var didWarnAboutContextTypeOnFunctionComponent;
    var didWarnAboutGetDerivedStateOnFunctionComponent;
    var didWarnAboutFunctionRefs;
    var didWarnAboutReassigningProps;
    var didWarnAboutRevealOrder;
    var didWarnAboutTailOptions;
    var didWarnAboutDefaultPropsOnFunctionComponent;
    didWarnAboutBadClass = {};
    didWarnAboutModulePatternComponent = {};
    didWarnAboutContextTypeOnFunctionComponent = {};
    didWarnAboutGetDerivedStateOnFunctionComponent = {};
    didWarnAboutFunctionRefs = {};
    didWarnAboutReassigningProps = false;
    didWarnAboutRevealOrder = {};
    didWarnAboutTailOptions = {};
    didWarnAboutDefaultPropsOnFunctionComponent = {};
    function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
        if (current === null) // If this is a fresh new component that hasn't been rendered yet, we
        // won't update its child set by applying minimal side-effects. Instead,
        // we will add them all to the child before it gets rendered. That means
        // we can optimize this reconciliation pass by not tracking side-effects.
        workInProgress.child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
        else // If the current child is the same as the work in progress, it means that
        // we haven't yet started any work on these children. Therefore, we use
        // the clone algorithm to create a copy of all the current children.
        // If we had any progressed work already, that is invalid at this point so
        // let's throw it out.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
    }
    function forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes) {
        // This function is fork of reconcileChildren. It's used in cases where we
        // want to reconcile without matching against the existing set. This has the
        // effect of all current children being unmounted; even if the type and key
        // are the same, the old child is unmounted and a new child is created.
        //
        // To do this, we're going to go through the reconcile algorithm twice. In
        // the first pass, we schedule a deletion for all the current children by
        // passing null.
        workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes); // In the second pass, we mount the new children. The trick here is that we
        // pass null in place of where we usually pass the current child set. This has
        // the effect of remounting all children regardless of whether their
        // identities match.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
    }
    function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(Component));
        }
        var render = Component.render;
        var ref = workInProgress.ref; // The rest is a fork of updateFunctionComponent
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        markComponentRenderStarted(workInProgress);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
        hasId = checkDidRenderIdHook();
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                nextChildren = renderWithHooks(current, workInProgress, render, nextProps, ref, renderLanes);
                hasId = checkDidRenderIdHook();
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        setIsRendering(false);
        markComponentRenderStopped();
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
         // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (current === null) {
            var type = Component.type;
            if (isSimpleFunctionComponent(type) && Component.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
            Component.defaultProps === undefined) {
                var resolvedType = type;
                resolvedType = resolveFunctionForHotReloading(type);
                // and with only the default shallow comparison, we upgrade it
                // to a SimpleMemoComponent to allow fast path updates.
                workInProgress.tag = SimpleMemoComponent;
                workInProgress.type = resolvedType;
                validateFunctionComponentInDev(workInProgress, type);
                return updateSimpleMemoComponent(current, workInProgress, resolvedType, nextProps, renderLanes);
            }
            var innerPropTypes = type.propTypes;
            if (innerPropTypes) // Inner memo component props aren't currently validated in createElement.
            // We could move it there, but we'd still need this for lazy code path.
            checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(type));
            if (Component.defaultProps !== undefined) {
                var componentName = getComponentNameFromType(type) || "Unknown";
                if (!didWarnAboutDefaultPropsOnFunctionComponent[componentName]) {
                    error("%s: Support for defaultProps will be removed from memo components in a future major release. Use JavaScript default parameters instead.", componentName);
                    didWarnAboutDefaultPropsOnFunctionComponent[componentName] = true;
                }
            }
            var child = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
            child.ref = workInProgress.ref;
            child.return = workInProgress;
            workInProgress.child = child;
            return child;
        }
        var _type = Component.type;
        var _innerPropTypes = _type.propTypes;
        if (_innerPropTypes) // Inner memo component props aren't currently validated in createElement.
        // We could move it there, but we'd still need this for lazy code path.
        checkPropTypes(_innerPropTypes, nextProps, "prop", getComponentNameFromType(_type));
        var currentChild = current.child; // This is always exactly one child
        var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);
        if (!hasScheduledUpdateOrContext) {
            // This will be the props with resolved defaultProps,
            // unlike current.memoizedProps which will be the unresolved ones.
            var prevProps = currentChild.memoizedProps; // Default to shallow comparison
            var compare = Component.compare;
            compare = compare !== null ? compare : shallowEqual;
            if (compare(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        var newChild = createWorkInProgress(currentChild, nextProps);
        newChild.ref = workInProgress.ref;
        newChild.return = workInProgress;
        workInProgress.child = newChild;
        return newChild;
    }
    function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var outerMemoType = workInProgress.elementType;
            if (outerMemoType.$$typeof === REACT_LAZY_TYPE) {
                // We warn when you define propTypes on lazy()
                // so let's just skip over it to find memo() outer wrapper.
                // Inner props for memo are validated later.
                var lazyComponent = outerMemoType;
                var payload = lazyComponent._payload;
                var init = lazyComponent._init;
                try {
                    outerMemoType = init(payload);
                } catch (x) {
                    outerMemoType = null;
                } // Inner propTypes will be validated in the function component path.
                var outerPropTypes = outerMemoType && outerMemoType.propTypes;
                if (outerPropTypes) checkPropTypes(outerPropTypes, nextProps, "prop", getComponentNameFromType(outerMemoType));
            }
        }
        if (current !== null) {
            var prevProps = current.memoizedProps;
            if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref && workInProgress.type === current.type) {
                didReceiveUpdate = false; // The props are shallowly equal. Reuse the previous props object, like we
                // would during a normal fiber bailout.
                //
                // We don't have strong guarantees that the props object is referentially
                // equal during updates where we can't bail out anyway — like if the props
                // are shallowly equal, but there's a local state or context update in the
                // same batch.
                //
                // However, as a principle, we should aim to make the behavior consistent
                // across different ways of memoizing a component. For example, React.memo
                // has a different internal Fiber layout if you pass a normal function
                // component (SimpleMemoComponent) versus if you pass a different type
                // like forwardRef (MemoComponent). But this is an implementation detail.
                // Wrapping a component in forwardRef (or React.lazy, etc) shouldn't
                // affect whether the props object is reused during a bailout.
                workInProgress.pendingProps = nextProps = prevProps;
                if (!checkScheduledUpdateOrContext(current, renderLanes)) {
                    // The pending lanes were cleared at the beginning of beginWork. We're
                    // about to bail out, but there might be other lanes that weren't
                    // included in the current render. Usually, the priority level of the
                    // remaining updates is accumulated during the evaluation of the
                    // component (i.e. when processing the update queue). But since since
                    // we're bailing out early *without* evaluating the component, we need
                    // to account for it here, too. Reset to the value of the current fiber.
                    // NOTE: This only applies to SimpleMemoComponent, not MemoComponent,
                    // because a MemoComponent fiber does not have hooks or an update queue;
                    // rather, it wraps around an inner component, which may or may not
                    // contains hooks.
                    // TODO: Move the reset at in beginWork out of the common path so that
                    // this is no longer necessary.
                    workInProgress.lanes = current.lanes;
                    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                } else if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
            }
        }
        return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
    }
    function updateOffscreenComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        var prevState = current !== null ? current.memoizedState : null;
        if (nextProps.mode === "hidden" || enableLegacyHidden) {
            // Rendering a hidden tree.
            if ((workInProgress.mode & ConcurrentMode) === NoMode) {
                // In legacy sync mode, don't defer the subtree. Render it now.
                // TODO: Consider how Offscreen should work with transitions in the future
                var nextState = {
                    baseLanes: NoLanes,
                    cachePool: null,
                    transitions: null
                };
                workInProgress.memoizedState = nextState;
                pushRenderLanes(workInProgress, renderLanes);
            } else if (!includesSomeLane(renderLanes, OffscreenLane)) {
                var spawnedCachePool = null; // We're hidden, and we're not rendering at Offscreen. We will bail out
                // and resume this tree later.
                var nextBaseLanes;
                if (prevState !== null) {
                    var prevBaseLanes = prevState.baseLanes;
                    nextBaseLanes = mergeLanes(prevBaseLanes, renderLanes);
                } else nextBaseLanes = renderLanes;
                 // Schedule this fiber to re-render at offscreen priority. Then bailout.
                workInProgress.lanes = workInProgress.childLanes = laneToLanes(OffscreenLane);
                var _nextState = {
                    baseLanes: nextBaseLanes,
                    cachePool: spawnedCachePool,
                    transitions: null
                };
                workInProgress.memoizedState = _nextState;
                workInProgress.updateQueue = null;
                // to avoid a push/pop misalignment.
                pushRenderLanes(workInProgress, nextBaseLanes);
                return null;
            } else {
                // This is the second render. The surrounding visible content has already
                // committed. Now we resume rendering the hidden tree.
                // Rendering at offscreen, so we can clear the base lanes.
                var _nextState2 = {
                    baseLanes: NoLanes,
                    cachePool: null,
                    transitions: null
                };
                workInProgress.memoizedState = _nextState2; // Push the lanes that were skipped when we bailed out.
                var subtreeRenderLanes = prevState !== null ? prevState.baseLanes : renderLanes;
                pushRenderLanes(workInProgress, subtreeRenderLanes);
            }
        } else {
            // Rendering a visible tree.
            var _subtreeRenderLanes;
            if (prevState !== null) {
                // We're going from hidden -> visible.
                _subtreeRenderLanes = mergeLanes(prevState.baseLanes, renderLanes);
                workInProgress.memoizedState = null;
            } else // We weren't previously hidden, and we still aren't, so there's nothing
            // special to do. Need to push to the stack regardless, though, to avoid
            // a push/pop misalignment.
            _subtreeRenderLanes = renderLanes;
            pushRenderLanes(workInProgress, _subtreeRenderLanes);
        }
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    } // Note: These happen to have identical begin phases, for now. We shouldn't hold
    function updateFragment(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateMode(current, workInProgress, renderLanes) {
        var nextChildren = workInProgress.pendingProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateProfiler(current, workInProgress, renderLanes) {
        workInProgress.flags |= Update;
        // Reset effect durations for the next eventual effect phase.
        // These are reset during render to allow the DevTools commit hook a chance to read them,
        var stateNode = workInProgress.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        var nextProps = workInProgress.pendingProps;
        var nextChildren = nextProps.children;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function markRef(current, workInProgress) {
        var ref = workInProgress.ref;
        if (current === null && ref !== null || current !== null && current.ref !== ref) {
            // Schedule a Ref effect
            workInProgress.flags |= Ref;
            workInProgress.flags |= RefStatic;
        }
    }
    function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(Component));
        }
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, true);
        context = getMaskedContext(workInProgress, unmaskedContext);
        var nextChildren;
        var hasId;
        prepareToReadContext(workInProgress, renderLanes);
        markComponentRenderStarted(workInProgress);
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
        hasId = checkDidRenderIdHook();
        if (workInProgress.mode & StrictLegacyMode) {
            setIsStrictModeForDevtools(true);
            try {
                nextChildren = renderWithHooks(current, workInProgress, Component, nextProps, context, renderLanes);
                hasId = checkDidRenderIdHook();
            } finally{
                setIsStrictModeForDevtools(false);
            }
        }
        setIsRendering(false);
        markComponentRenderStopped();
        if (current !== null && !didReceiveUpdate) {
            bailoutHooks(current, workInProgress, renderLanes);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
         // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
        // This is used by DevTools to force a boundary to error.
        switch(shouldError(workInProgress)){
            case false:
                var _instance = workInProgress.stateNode;
                var ctor = workInProgress.type; // TODO This way of resetting the error boundary state is a hack.
                // Is there a better way to do this?
                var tempInstance = new ctor(workInProgress.memoizedProps, _instance.context);
                var state = tempInstance.state;
                _instance.updater.enqueueSetState(_instance, state, null);
                break;
            case true:
                workInProgress.flags |= DidCapture;
                workInProgress.flags |= ShouldCapture; // eslint-disable-next-line react-internal/prod-error-codes
                var error$1 = new Error("Simulated error coming from DevTools");
                var lane = pickArbitraryLane(renderLanes);
                workInProgress.lanes = mergeLanes(workInProgress.lanes, lane); // Schedule the error boundary to re-render using updated state
                var update = createClassErrorUpdate(workInProgress, createCapturedValueAtFiber(error$1, workInProgress), lane);
                enqueueCapturedUpdate(workInProgress, update);
                break;
        }
        if (workInProgress.type !== workInProgress.elementType) {
            // Lazy component props can't be validated in createElement
            // because they're only guaranteed to be resolved here.
            var innerPropTypes = Component.propTypes;
            if (innerPropTypes) checkPropTypes(innerPropTypes, nextProps, "prop", getComponentNameFromType(Component));
        }
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        var instance = workInProgress.stateNode;
        var shouldUpdate;
        if (instance === null) {
            resetSuspendedCurrentOnMountInLegacyMode(current, workInProgress); // In the initial pass we might need to construct the instance.
            constructClassInstance(workInProgress, Component, nextProps);
            mountClassInstance(workInProgress, Component, nextProps, renderLanes);
            shouldUpdate = true;
        } else if (current === null) // In a resume, we'll already have an instance we can reuse.
        shouldUpdate = resumeMountClassInstance(workInProgress, Component, nextProps, renderLanes);
        else shouldUpdate = updateClassInstance(current, workInProgress, Component, nextProps, renderLanes);
        var nextUnitOfWork = finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes);
        var inst = workInProgress.stateNode;
        if (shouldUpdate && inst.props !== nextProps) {
            if (!didWarnAboutReassigningProps) error("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", getComponentNameFromFiber(workInProgress) || "a component");
            didWarnAboutReassigningProps = true;
        }
        return nextUnitOfWork;
    }
    function finishClassComponent(current, workInProgress, Component, shouldUpdate, hasContext, renderLanes) {
        // Refs should update even if shouldComponentUpdate returns false
        markRef(current, workInProgress);
        var didCaptureError = (workInProgress.flags & DidCapture) !== NoFlags;
        if (!shouldUpdate && !didCaptureError) {
            // Context providers should defer to sCU for rendering
            if (hasContext) invalidateContextProvider(workInProgress, Component, false);
            return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        var instance = workInProgress.stateNode; // Rerender
        ReactCurrentOwner$1.current = workInProgress;
        var nextChildren;
        if (didCaptureError && typeof Component.getDerivedStateFromError !== "function") {
            // If we captured an error, but getDerivedStateFromError is not defined,
            // unmount all the children. componentDidCatch will schedule an update to
            // re-render a fallback. This is temporary until we migrate everyone to
            // the new API.
            // TODO: Warn in a future release.
            nextChildren = null;
            stopProfilerTimerIfRunning();
        } else {
            markComponentRenderStarted(workInProgress);
            setIsRendering(true);
            nextChildren = instance.render();
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    instance.render();
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            setIsRendering(false);
            markComponentRenderStopped();
        } // React DevTools reads this flag.
        workInProgress.flags |= PerformedWork;
        if (current !== null && didCaptureError) // If we're recovering from an error, reconcile without reusing any of
        // the existing children. Conceptually, the normal children and the children
        // that are shown on error are two different sets, so we shouldn't reuse
        // normal children even if their identities match.
        forceUnmountCurrentAndReconcile(current, workInProgress, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
         // Memoize state using the values we just used to render.
        // TODO: Restructure so we never read values from the instance.
        workInProgress.memoizedState = instance.state; // The context might have changed so we need to recalculate it.
        if (hasContext) invalidateContextProvider(workInProgress, Component, true);
        return workInProgress.child;
    }
    function pushHostRootContext(workInProgress) {
        var root = workInProgress.stateNode;
        if (root.pendingContext) pushTopLevelContextObject(workInProgress, root.pendingContext, root.pendingContext !== root.context);
        else if (root.context) // Should always be set
        pushTopLevelContextObject(workInProgress, root.context, false);
        pushHostContainer(workInProgress, root.containerInfo);
    }
    function updateHostRoot(current, workInProgress, renderLanes) {
        pushHostRootContext(workInProgress);
        if (current === null) throw new Error("Should have a current fiber. This is a bug in React.");
        var nextProps = workInProgress.pendingProps;
        var prevState = workInProgress.memoizedState;
        var prevChildren = prevState.element;
        cloneUpdateQueue(current, workInProgress);
        processUpdateQueue(workInProgress, nextProps, null, renderLanes);
        var nextState = workInProgress.memoizedState;
        var root = workInProgress.stateNode;
        // being called "element".
        var nextChildren = nextState.element;
        if (prevState.isDehydrated) {
            // This is a hydration root whose shell has not yet hydrated. We should
            // attempt to hydrate.
            // Flip isDehydrated to false to indicate that when this render
            // finishes, the root will no longer be dehydrated.
            var overrideState = {
                element: nextChildren,
                isDehydrated: false,
                cache: nextState.cache,
                pendingSuspenseBoundaries: nextState.pendingSuspenseBoundaries,
                transitions: nextState.transitions
            };
            var updateQueue = workInProgress.updateQueue; // `baseState` can always be the last state because the root doesn't
            // have reducer functions so it doesn't need rebasing.
            updateQueue.baseState = overrideState;
            workInProgress.memoizedState = overrideState;
            if (workInProgress.flags & ForceClientRender) {
                // Something errored during a previous attempt to hydrate the shell, so we
                // forced a client render.
                var recoverableError = createCapturedValueAtFiber(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), workInProgress);
                return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError);
            } else if (nextChildren !== prevChildren) {
                var _recoverableError = createCapturedValueAtFiber(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), workInProgress);
                return mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, _recoverableError);
            } else {
                // The outermost shell has not hydrated yet. Start hydrating.
                enterHydrationState(workInProgress);
                var child = mountChildFibers(workInProgress, null, nextChildren, renderLanes);
                workInProgress.child = child;
                var node = child;
                while(node){
                    // Mark each child as hydrating. This is a fast path to know whether this
                    // tree is part of a hydrating tree. This is used to determine if a child
                    // node has fully mounted yet, and for scheduling event replaying.
                    // Conceptually this is similar to Placement in that a new subtree is
                    // inserted into the React tree here. It just happens to not need DOM
                    // mutations because it already exists.
                    node.flags = node.flags & ~Placement | Hydrating;
                    node = node.sibling;
                }
            }
        } else {
            // Root is not dehydrated. Either this is a client-only root, or it
            // already hydrated.
            resetHydrationState();
            if (nextChildren === prevChildren) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        }
        return workInProgress.child;
    }
    function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes, recoverableError) {
        // Revert to client rendering.
        resetHydrationState();
        queueHydrationError(recoverableError);
        workInProgress.flags |= ForceClientRender;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostComponent(current, workInProgress, renderLanes) {
        pushHostContext(workInProgress);
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
        var type = workInProgress.type;
        var nextProps = workInProgress.pendingProps;
        var prevProps = current !== null ? current.memoizedProps : null;
        var nextChildren = nextProps.children;
        var isDirectTextChild = shouldSetTextContent(type, nextProps);
        if (isDirectTextChild) // We special case a direct text child of a host node. This is a common
        // case. We won't handle it as a reified child. We will instead handle
        // this in the host environment that also has access to this prop. That
        // avoids allocating another HostText fiber and traversing it.
        nextChildren = null;
        else if (prevProps !== null && shouldSetTextContent(type, prevProps)) // If we're switching from a direct text child to a normal child, or to
        // empty, we need to schedule the text content to be reset.
        workInProgress.flags |= ContentReset;
        markRef(current, workInProgress);
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function updateHostText(current, workInProgress) {
        if (current === null) tryToClaimNextHydratableInstance(workInProgress);
         // Nothing to do here. This is terminal. We'll do the completion step
        // immediately after.
        return null;
    }
    function mountLazyComponent(_current, workInProgress, elementType, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress);
        var props = workInProgress.pendingProps;
        var lazyComponent = elementType;
        var payload = lazyComponent._payload;
        var init = lazyComponent._init;
        var Component = init(payload); // Store the unwrapped component in the type.
        workInProgress.type = Component;
        var resolvedTag = workInProgress.tag = resolveLazyComponentTag(Component);
        var resolvedProps = resolveDefaultProps(Component, props);
        var child;
        switch(resolvedTag){
            case FunctionComponent:
                validateFunctionComponentInDev(workInProgress, Component);
                workInProgress.type = Component = resolveFunctionForHotReloading(Component);
                child = updateFunctionComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ClassComponent:
                workInProgress.type = Component = resolveClassForHotReloading(Component);
                child = updateClassComponent(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case ForwardRef:
                workInProgress.type = Component = resolveForwardRefForHotReloading(Component);
                child = updateForwardRef(null, workInProgress, Component, resolvedProps, renderLanes);
                return child;
            case MemoComponent:
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = Component.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, resolvedProps, "prop", getComponentNameFromType(Component));
                }
                child = updateMemoComponent(null, workInProgress, Component, resolveDefaultProps(Component.type, resolvedProps), renderLanes);
                return child;
        }
        var hint = "";
        if (Component !== null && typeof Component === "object" && Component.$$typeof === REACT_LAZY_TYPE) hint = " Did you wrap a component in React.lazy() more than once?";
        // because the fact that it's a separate type of work is an
        // implementation detail.
        throw new Error("Element type is invalid. Received a promise that resolves to: " + Component + ". " + ("Lazy element type must resolve to a class or function." + hint));
    }
    function mountIncompleteClassComponent(_current, workInProgress, Component, nextProps, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress); // Promote the fiber to a class and try rendering again.
        workInProgress.tag = ClassComponent; // The rest of this function is a fork of `updateClassComponent`
        // Push context providers early to prevent context stack mismatches.
        // During mounting we don't know the child context yet as the instance doesn't exist.
        // We will invalidate the child context in finishClassComponent() right after rendering.
        var hasContext;
        if (isContextProvider(Component)) {
            hasContext = true;
            pushContextProvider(workInProgress);
        } else hasContext = false;
        prepareToReadContext(workInProgress, renderLanes);
        constructClassInstance(workInProgress, Component, nextProps);
        mountClassInstance(workInProgress, Component, nextProps, renderLanes);
        return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
    }
    function mountIndeterminateComponent(_current, workInProgress, Component, renderLanes) {
        resetSuspendedCurrentOnMountInLegacyMode(_current, workInProgress);
        var props = workInProgress.pendingProps;
        var context;
        var unmaskedContext = getUnmaskedContext(workInProgress, Component, false);
        context = getMaskedContext(workInProgress, unmaskedContext);
        prepareToReadContext(workInProgress, renderLanes);
        var value;
        var hasId;
        markComponentRenderStarted(workInProgress);
        if (Component.prototype && typeof Component.prototype.render === "function") {
            var componentName = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutBadClass[componentName]) {
                error("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", componentName, componentName);
                didWarnAboutBadClass[componentName] = true;
            }
        }
        if (workInProgress.mode & StrictLegacyMode) ReactStrictModeWarnings.recordLegacyContextWarning(workInProgress, null);
        setIsRendering(true);
        ReactCurrentOwner$1.current = workInProgress;
        value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
        hasId = checkDidRenderIdHook();
        setIsRendering(false);
        markComponentRenderStopped();
        workInProgress.flags |= PerformedWork;
        // Support for module components is deprecated and is removed behind a flag.
        // Whether or not it would crash later, we want to show a good message in DEV first.
        if (typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined) {
            var _componentName = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutModulePatternComponent[_componentName]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName, _componentName, _componentName);
                didWarnAboutModulePatternComponent[_componentName] = true;
            }
        }
        if (// Eventually we'll delete this branch altogether.
        typeof value === "object" && value !== null && typeof value.render === "function" && value.$$typeof === undefined) {
            var _componentName2 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutModulePatternComponent[_componentName2]) {
                error("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", _componentName2, _componentName2, _componentName2);
                didWarnAboutModulePatternComponent[_componentName2] = true;
            }
            workInProgress.tag = ClassComponent; // Throw out any hooks that were used.
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null; // Push context providers early to prevent context stack mismatches.
            // During mounting we don't know the child context yet as the instance doesn't exist.
            // We will invalidate the child context in finishClassComponent() right after rendering.
            var hasContext = false;
            if (isContextProvider(Component)) {
                hasContext = true;
                pushContextProvider(workInProgress);
            } else hasContext = false;
            workInProgress.memoizedState = value.state !== null && value.state !== undefined ? value.state : null;
            initializeUpdateQueue(workInProgress);
            adoptClassInstance(workInProgress, value);
            mountClassInstance(workInProgress, Component, props, renderLanes);
            return finishClassComponent(null, workInProgress, Component, true, hasContext, renderLanes);
        } else {
            // Proceed under the assumption that this is a function component
            workInProgress.tag = FunctionComponent;
            if (workInProgress.mode & StrictLegacyMode) {
                setIsStrictModeForDevtools(true);
                try {
                    value = renderWithHooks(null, workInProgress, Component, props, context, renderLanes);
                    hasId = checkDidRenderIdHook();
                } finally{
                    setIsStrictModeForDevtools(false);
                }
            }
            if (getIsHydrating() && hasId) pushMaterializedTreeId(workInProgress);
            reconcileChildren(null, workInProgress, value, renderLanes);
            validateFunctionComponentInDev(workInProgress, Component);
            return workInProgress.child;
        }
    }
    function validateFunctionComponentInDev(workInProgress, Component) {
        if (Component) {
            if (Component.childContextTypes) error("%s(...): childContextTypes cannot be defined on a function component.", Component.displayName || Component.name || "Component");
        }
        if (workInProgress.ref !== null) {
            var info = "";
            var ownerName = getCurrentFiberOwnerNameInDevOrNull();
            if (ownerName) info += "\n\nCheck the render method of `" + ownerName + "`.";
            var warningKey = ownerName || "";
            var debugSource = workInProgress._debugSource;
            if (debugSource) warningKey = debugSource.fileName + ":" + debugSource.lineNumber;
            if (!didWarnAboutFunctionRefs[warningKey]) {
                didWarnAboutFunctionRefs[warningKey] = true;
                error("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", info);
            }
        }
        if (Component.defaultProps !== undefined) {
            var componentName = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutDefaultPropsOnFunctionComponent[componentName]) {
                error("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", componentName);
                didWarnAboutDefaultPropsOnFunctionComponent[componentName] = true;
            }
        }
        if (typeof Component.getDerivedStateFromProps === "function") {
            var _componentName3 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3]) {
                error("%s: Function components do not support getDerivedStateFromProps.", _componentName3);
                didWarnAboutGetDerivedStateOnFunctionComponent[_componentName3] = true;
            }
        }
        if (typeof Component.contextType === "object" && Component.contextType !== null) {
            var _componentName4 = getComponentNameFromType(Component) || "Unknown";
            if (!didWarnAboutContextTypeOnFunctionComponent[_componentName4]) {
                error("%s: Function components do not support contextType.", _componentName4);
                didWarnAboutContextTypeOnFunctionComponent[_componentName4] = true;
            }
        }
    }
    var SUSPENDED_MARKER = {
        dehydrated: null,
        treeContext: null,
        retryLane: NoLane
    };
    function mountSuspenseOffscreenState(renderLanes) {
        return {
            baseLanes: renderLanes,
            cachePool: getSuspendedCache(),
            transitions: null
        };
    }
    function updateSuspenseOffscreenState(prevOffscreenState, renderLanes) {
        var cachePool = null;
        return {
            baseLanes: mergeLanes(prevOffscreenState.baseLanes, renderLanes),
            cachePool: cachePool,
            transitions: prevOffscreenState.transitions
        };
    } // TODO: Probably should inline this back
    function shouldRemainOnFallback(suspenseContext, current, workInProgress, renderLanes) {
        // If we're already showing a fallback, there are cases where we need to
        // remain on that fallback regardless of whether the content has resolved.
        // For example, SuspenseList coordinates when nested content appears.
        if (current !== null) {
            var suspenseState = current.memoizedState;
            if (suspenseState === null) // Currently showing content. Don't hide it, even if ForceSuspenseFallback
            // is true. More precise name might be "ForceRemainSuspenseFallback".
            // Note: This is a factoring smell. Can't remain on a fallback if there's
            // no fallback to remain on.
            return false;
        } // Not currently showing content. Consult the Suspense context.
        return hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
    }
    function getRemainingWorkInPrimaryTree(current, renderLanes) {
        // TODO: Should not remove render lanes that were pinged during this render
        return removeLanes(current.childLanes, renderLanes);
    }
    function updateSuspenseComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps; // This is used by DevTools to force a boundary to suspend.
        if (shouldSuspend(workInProgress)) workInProgress.flags |= DidCapture;
        var suspenseContext = suspenseStackCursor.current;
        var showFallback = false;
        var didSuspend = (workInProgress.flags & DidCapture) !== NoFlags;
        if (didSuspend || shouldRemainOnFallback(suspenseContext, current)) {
            // Something in this boundary's subtree already suspended. Switch to
            // rendering the fallback children.
            showFallback = true;
            workInProgress.flags &= ~DidCapture;
        } else // Attempting the main content
        if (current === null || current.memoizedState !== null) suspenseContext = addSubtreeSuspenseContext(suspenseContext, InvisibleParentSuspenseContext);
        suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        pushSuspenseContext(workInProgress, suspenseContext); // OK, the next part is confusing. We're about to reconcile the Suspense
        // boundary's children. This involves some custom reconciliation logic. Two
        // main reasons this is so complicated.
        //
        // First, Legacy Mode has different semantics for backwards compatibility. The
        // primary tree will commit in an inconsistent state, so when we do the
        // second pass to render the fallback, we do some exceedingly, uh, clever
        // hacks to make that not totally break. Like transferring effects and
        // deletions from hidden tree. In Concurrent Mode, it's much simpler,
        // because we bailout on the primary tree completely and leave it in its old
        // state, no effects. Same as what we do for Offscreen (except that
        // Offscreen doesn't have the first render pass).
        //
        // Second is hydration. During hydration, the Suspense fiber has a slightly
        // different layout, where the child points to a dehydrated fragment, which
        // contains the DOM rendered by the server.
        //
        // Third, even if you set all that aside, Suspense is like error boundaries in
        // that we first we try to render one tree, and if that fails, we render again
        // and switch to a different tree. Like a try/catch block. So we have to track
        // which branch we're currently rendering. Ideally we would model this using
        // a stack.
        if (current === null) {
            // Initial mount
            // Special path for hydration
            // If we're currently hydrating, try to hydrate this boundary.
            tryToClaimNextHydratableInstance(workInProgress); // This could've been a dehydrated suspense component.
            var suspenseState = workInProgress.memoizedState;
            if (suspenseState !== null) {
                var dehydrated = suspenseState.dehydrated;
                if (dehydrated !== null) return mountDehydratedSuspenseComponent(workInProgress, dehydrated);
            }
            var nextPrimaryChildren = nextProps.children;
            var nextFallbackChildren = nextProps.fallback;
            if (showFallback) {
                var fallbackFragment = mountSuspenseFallbackChildren(workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var primaryChildFragment = workInProgress.child;
                primaryChildFragment.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackFragment;
            } else return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
        } else {
            // This is an update.
            // Special path for hydration
            var prevState = current.memoizedState;
            if (prevState !== null) {
                var _dehydrated = prevState.dehydrated;
                if (_dehydrated !== null) return updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, nextProps, _dehydrated, prevState, renderLanes);
            }
            if (showFallback) {
                var _nextFallbackChildren = nextProps.fallback;
                var _nextPrimaryChildren = nextProps.children;
                var fallbackChildFragment = updateSuspenseFallbackChildren(current, workInProgress, _nextPrimaryChildren, _nextFallbackChildren, renderLanes);
                var _primaryChildFragment2 = workInProgress.child;
                var prevOffscreenState = current.child.memoizedState;
                _primaryChildFragment2.memoizedState = prevOffscreenState === null ? mountSuspenseOffscreenState(renderLanes) : updateSuspenseOffscreenState(prevOffscreenState, renderLanes);
                _primaryChildFragment2.childLanes = getRemainingWorkInPrimaryTree(current, renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackChildFragment;
            } else {
                var _nextPrimaryChildren2 = nextProps.children;
                var _primaryChildFragment3 = updateSuspensePrimaryChildren(current, workInProgress, _nextPrimaryChildren2, renderLanes);
                workInProgress.memoizedState = null;
                return _primaryChildFragment3;
            }
        }
    }
    function mountSuspensePrimaryChildren(workInProgress, primaryChildren, renderLanes) {
        var mode = workInProgress.mode;
        var primaryChildProps = {
            mode: "visible",
            children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
        primaryChildFragment.return = workInProgress;
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackChildren(workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var progressedPrimaryFragment = workInProgress.child;
        var primaryChildProps = {
            mode: "hidden",
            children: primaryChildren
        };
        var primaryChildFragment;
        var fallbackChildFragment;
        if ((mode & ConcurrentMode) === NoMode && progressedPrimaryFragment !== null) {
            // In legacy mode, we commit the primary tree as if it successfully
            // completed, even though it's in an inconsistent state.
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = 0;
                primaryChildFragment.treeBaseDuration = 0;
            }
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        } else {
            primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, mode);
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null);
        }
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function mountWorkInProgressOffscreenFiber(offscreenProps, mode, renderLanes) {
        // The props argument to `createFiberFromOffscreen` is `any` typed, so we use
        // this wrapper function to constrain it.
        return createFiberFromOffscreen(offscreenProps, mode, NoLanes, null);
    }
    function updateWorkInProgressOffscreenFiber(current, offscreenProps) {
        // The props argument to `createWorkInProgress` is `any` typed, so we use this
        // wrapper function to constrain it.
        return createWorkInProgress(current, offscreenProps);
    }
    function updateSuspensePrimaryChildren(current, workInProgress, primaryChildren, renderLanes) {
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, {
            mode: "visible",
            children: primaryChildren
        });
        if ((workInProgress.mode & ConcurrentMode) === NoMode) primaryChildFragment.lanes = renderLanes;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = null;
        if (currentFallbackChildFragment !== null) {
            // Delete the fallback child fragment
            var deletions = workInProgress.deletions;
            if (deletions === null) {
                workInProgress.deletions = [
                    currentFallbackChildFragment
                ];
                workInProgress.flags |= ChildDeletion;
            } else deletions.push(currentFallbackChildFragment);
        }
        workInProgress.child = primaryChildFragment;
        return primaryChildFragment;
    }
    function updateSuspenseFallbackChildren(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var mode = workInProgress.mode;
        var currentPrimaryChildFragment = current.child;
        var currentFallbackChildFragment = currentPrimaryChildFragment.sibling;
        var primaryChildProps = {
            mode: "hidden",
            children: primaryChildren
        };
        var primaryChildFragment;
        if (// completed, even though it's in an inconsistent state.
        (mode & ConcurrentMode) === NoMode && // Make sure we're on the second pass, i.e. the primary child fragment was
        // already cloned. In legacy mode, the only case where this isn't true is
        // when DevTools forces us to display a fallback; we skip the first render
        // pass entirely and go straight to rendering the fallback. (In Concurrent
        // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
        // only codepath.)
        workInProgress.child !== currentPrimaryChildFragment) {
            var progressedPrimaryFragment = workInProgress.child;
            primaryChildFragment = progressedPrimaryFragment;
            primaryChildFragment.childLanes = NoLanes;
            primaryChildFragment.pendingProps = primaryChildProps;
            if (workInProgress.mode & ProfileMode) {
                // Reset the durations from the first pass so they aren't included in the
                // final amounts. This seems counterintuitive, since we're intentionally
                // not measuring part of the render phase, but this makes it match what we
                // do in Concurrent Mode.
                primaryChildFragment.actualDuration = 0;
                primaryChildFragment.actualStartTime = -1;
                primaryChildFragment.selfBaseDuration = currentPrimaryChildFragment.selfBaseDuration;
                primaryChildFragment.treeBaseDuration = currentPrimaryChildFragment.treeBaseDuration;
            } // The fallback fiber was added as a deletion during the first pass.
            // However, since we're going to remain on the fallback, we no longer want
            // to delete it.
            workInProgress.deletions = null;
        } else {
            primaryChildFragment = updateWorkInProgressOffscreenFiber(currentPrimaryChildFragment, primaryChildProps); // Since we're reusing a current tree, we need to reuse the flags, too.
            // (We don't do this in legacy mode, because in legacy mode we don't re-use
            // the current tree; see previous branch.)
            primaryChildFragment.subtreeFlags = currentPrimaryChildFragment.subtreeFlags & StaticMask;
        }
        var fallbackChildFragment;
        if (currentFallbackChildFragment !== null) fallbackChildFragment = createWorkInProgress(currentFallbackChildFragment, fallbackChildren);
        else {
            fallbackChildFragment = createFiberFromFragment(fallbackChildren, mode, renderLanes, null); // Needs a placement effect because the parent (the Suspense boundary) already
            // mounted but this is a new fiber.
            fallbackChildFragment.flags |= Placement;
        }
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        return fallbackChildFragment;
    }
    function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, recoverableError) {
        // Falling back to client rendering. Because this has performance
        // implications, it's considered a recoverable error, even though the user
        // likely won't observe anything wrong with the UI.
        //
        // The error is passed in as an argument to enforce that every caller provide
        // a custom message, or explicitly opt out (currently the only path that opts
        // out is legacy mode; every concurrent path provides an error).
        if (recoverableError !== null) queueHydrationError(recoverableError);
         // This will add the old fiber to the deletion list
        reconcileChildFibers(workInProgress, current.child, null, renderLanes); // We're now not suspended nor dehydrated.
        var nextProps = workInProgress.pendingProps;
        var primaryChildren = nextProps.children;
        var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren); // Needs a placement effect because the parent (the Suspense boundary) already
        // mounted but this is a new fiber.
        primaryChildFragment.flags |= Placement;
        workInProgress.memoizedState = null;
        return primaryChildFragment;
    }
    function mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, primaryChildren, fallbackChildren, renderLanes) {
        var fiberMode = workInProgress.mode;
        var primaryChildProps = {
            mode: "visible",
            children: primaryChildren
        };
        var primaryChildFragment = mountWorkInProgressOffscreenFiber(primaryChildProps, fiberMode);
        var fallbackChildFragment = createFiberFromFragment(fallbackChildren, fiberMode, renderLanes, null); // Needs a placement effect because the parent (the Suspense
        // boundary) already mounted but this is a new fiber.
        fallbackChildFragment.flags |= Placement;
        primaryChildFragment.return = workInProgress;
        fallbackChildFragment.return = workInProgress;
        primaryChildFragment.sibling = fallbackChildFragment;
        workInProgress.child = primaryChildFragment;
        if ((workInProgress.mode & ConcurrentMode) !== NoMode) // We will have dropped the effect list which contains the
        // deletion. We need to reconcile to delete the current child.
        reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        return fallbackChildFragment;
    }
    function mountDehydratedSuspenseComponent(workInProgress, suspenseInstance, renderLanes) {
        // During the first pass, we'll bail out and not drill into the children.
        // Instead, we'll leave the content in place and try to hydrate it later.
        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
            error("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components.");
            workInProgress.lanes = laneToLanes(SyncLane);
        } else if (isSuspenseInstanceFallback(suspenseInstance)) // This is a client-only boundary. Since we won't get any content from the server
        // for this, we need to schedule that at a higher priority based on when it would
        // have timed out. In theory we could render it in this pass but it would have the
        // wrong priority associated with it and will prevent hydration of parent path.
        // Instead, we'll leave work left on it to render it in a separate commit.
        // TODO This time should be the time at which the server rendered response that is
        // a parent to this boundary was displayed. However, since we currently don't have
        // a protocol to transfer that time, we'll just estimate it by using the current
        // time. This will mean that Suspense timeouts are slightly shifted to later than
        // they should be.
        // Schedule a normal pri update to render this content.
        workInProgress.lanes = laneToLanes(DefaultHydrationLane);
        else // We'll continue hydrating the rest at offscreen priority since we'll already
        // be showing the right content coming from the server, it is no rush.
        workInProgress.lanes = laneToLanes(OffscreenLane);
        return null;
    }
    function updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, nextProps, suspenseInstance, suspenseState, renderLanes) {
        if (!didSuspend) {
            // This is the first render pass. Attempt to hydrate.
            // We should never be hydrating at this point because it is the first pass,
            // but after we've already committed once.
            warnIfHydrating();
            if ((workInProgress.mode & ConcurrentMode) === NoMode) return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, // required — every concurrent mode path that causes hydration to
            // de-opt to client rendering should have an error message.
            null);
            if (isSuspenseInstanceFallback(suspenseInstance)) {
                // This boundary is in a permanent fallback state. In this case, we'll never
                // get an update and we'll never be able to hydrate the final content. Let's just try the
                // client side render instead.
                var digest, message, stack;
                var _getSuspenseInstanceF = getSuspenseInstanceFallbackErrorDetails(suspenseInstance);
                digest = _getSuspenseInstanceF.digest;
                message = _getSuspenseInstanceF.message;
                stack = _getSuspenseInstanceF.stack;
                var error;
                if (message) // eslint-disable-next-line react-internal/prod-error-codes
                error = new Error(message);
                else error = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
                var capturedValue = createCapturedValue(error, digest, stack);
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, capturedValue);
            }
            // any context has changed, we need to treat is as if the input might have changed.
            var hasContextChanged = includesSomeLane(renderLanes, current.childLanes);
            if (didReceiveUpdate || hasContextChanged) {
                // This boundary has changed since the first render. This means that we are now unable to
                // hydrate it. We might still be able to hydrate it using a higher priority lane.
                var root = getWorkInProgressRoot();
                if (root !== null) {
                    var attemptHydrationAtLane = getBumpedLaneForHydration(root, renderLanes);
                    if (attemptHydrationAtLane !== NoLane && attemptHydrationAtLane !== suspenseState.retryLane) {
                        // Intentionally mutating since this render will get interrupted. This
                        // is one of the very rare times where we mutate the current tree
                        // during the render phase.
                        suspenseState.retryLane = attemptHydrationAtLane; // TODO: Ideally this would inherit the event time of the current render
                        var eventTime = NoTimestamp;
                        enqueueConcurrentRenderForLane(current, attemptHydrationAtLane);
                        scheduleUpdateOnFiber(root, current, attemptHydrationAtLane, eventTime);
                    }
                } // If we have scheduled higher pri work above, this will probably just abort the render
                // since we now have higher priority work, but in case it doesn't, we need to prepare to
                // render something, if we time out. Even if that requires us to delete everything and
                // skip hydration.
                // Delay having to do this as long as the suspense timeout allows us.
                renderDidSuspendDelayIfPossible();
                var _capturedValue = createCapturedValue(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, _capturedValue);
            } else if (isSuspenseInstancePending(suspenseInstance)) {
                // This component is still pending more data from the server, so we can't hydrate its
                // content. We treat it as if this component suspended itself. It might seem as if
                // we could just try to render it client-side instead. However, this will perform a
                // lot of unnecessary work and is unlikely to complete since it often will suspend
                // on missing data anyway. Additionally, the server might be able to render more
                // than we can on the client yet. In that case we'd end up with more fallback states
                // on the client than if we just leave it alone. If the server times out or errors
                // these should update this boundary to the permanent Fallback state instead.
                // Mark it as having captured (i.e. suspended).
                workInProgress.flags |= DidCapture; // Leave the child in place. I.e. the dehydrated fragment.
                workInProgress.child = current.child; // Register a callback to retry this boundary once the server has sent the result.
                var retry = retryDehydratedSuspenseBoundary.bind(null, current);
                registerSuspenseInstanceRetry(suspenseInstance, retry);
                return null;
            } else {
                // This is the first attempt.
                reenterHydrationStateFromDehydratedSuspenseInstance(workInProgress, suspenseInstance, suspenseState.treeContext);
                var primaryChildren = nextProps.children;
                var primaryChildFragment = mountSuspensePrimaryChildren(workInProgress, primaryChildren); // Mark the children as hydrating. This is a fast path to know whether this
                // tree is part of a hydrating tree. This is used to determine if a child
                // node has fully mounted yet, and for scheduling event replaying.
                // Conceptually this is similar to Placement in that a new subtree is
                // inserted into the React tree here. It just happens to not need DOM
                // mutations because it already exists.
                primaryChildFragment.flags |= Hydrating;
                return primaryChildFragment;
            }
        } else {
            // This is the second render pass. We already attempted to hydrated, but
            // something either suspended or errored.
            if (workInProgress.flags & ForceClientRender) {
                // Something errored during hydration. Try again without hydrating.
                workInProgress.flags &= ~ForceClientRender;
                var _capturedValue2 = createCapturedValue(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
                return retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes, _capturedValue2);
            } else if (workInProgress.memoizedState !== null) {
                // Something suspended and we should still be in dehydrated mode.
                // Leave the existing child in place.
                workInProgress.child = current.child; // The dehydrated completion pass expects this flag to be there
                // but the normal suspense pass doesn't.
                workInProgress.flags |= DidCapture;
                return null;
            } else {
                // Suspended but we should no longer be in dehydrated mode.
                // Therefore we now have to render the fallback.
                var nextPrimaryChildren = nextProps.children;
                var nextFallbackChildren = nextProps.fallback;
                var fallbackChildFragment = mountSuspenseFallbackAfterRetryWithoutHydrating(current, workInProgress, nextPrimaryChildren, nextFallbackChildren, renderLanes);
                var _primaryChildFragment4 = workInProgress.child;
                _primaryChildFragment4.memoizedState = mountSuspenseOffscreenState(renderLanes);
                workInProgress.memoizedState = SUSPENDED_MARKER;
                return fallbackChildFragment;
            }
        }
    }
    function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
        fiber.lanes = mergeLanes(fiber.lanes, renderLanes);
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.lanes = mergeLanes(alternate.lanes, renderLanes);
        scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
    }
    function propagateSuspenseContextChange(workInProgress, firstChild, renderLanes) {
        // Mark any Suspense boundaries with fallbacks as having work to do.
        // If they were previously forced into fallbacks, they may now be able
        // to unblock.
        var node = firstChild;
        while(node !== null){
            if (node.tag === SuspenseComponent) {
                var state = node.memoizedState;
                if (state !== null) scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
            } else if (node.tag === SuspenseListComponent) // If the tail is hidden there might not be an Suspense boundaries
            // to schedule work on. In this case we have to schedule it on the
            // list itself.
            // We don't have to traverse to the children of the list since
            // the list will propagate the change when it rerenders.
            scheduleSuspenseWorkOnFiber(node, renderLanes, workInProgress);
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function findLastContentRow(firstChild) {
        // This is going to find the last row among these children that is already
        // showing content on the screen, as opposed to being in fallback state or
        // new. If a row has multiple Suspense boundaries, any of them being in the
        // fallback state, counts as the whole row being in a fallback state.
        // Note that the "rows" will be workInProgress, but any nested children
        // will still be current since we haven't rendered them yet. The mounted
        // order may not be the same as the new order. We use the new order.
        var row = firstChild;
        var lastContentRow = null;
        while(row !== null){
            var currentRow = row.alternate; // New rows can't be content rows.
            if (currentRow !== null && findFirstSuspended(currentRow) === null) lastContentRow = row;
            row = row.sibling;
        }
        return lastContentRow;
    }
    function validateRevealOrder(revealOrder) {
        if (revealOrder !== undefined && revealOrder !== "forwards" && revealOrder !== "backwards" && revealOrder !== "together" && !didWarnAboutRevealOrder[revealOrder]) {
            didWarnAboutRevealOrder[revealOrder] = true;
            if (typeof revealOrder === "string") switch(revealOrder.toLowerCase()){
                case "together":
                case "forwards":
                case "backwards":
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                case "forward":
                case "backward":
                    error('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', revealOrder, revealOrder.toLowerCase());
                    break;
                default:
                    error('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
                    break;
            }
            else error('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', revealOrder);
        }
    }
    function validateTailOptions(tailMode, revealOrder) {
        if (tailMode !== undefined && !didWarnAboutTailOptions[tailMode]) {
            if (tailMode !== "collapsed" && tailMode !== "hidden") {
                didWarnAboutTailOptions[tailMode] = true;
                error('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', tailMode);
            } else if (revealOrder !== "forwards" && revealOrder !== "backwards") {
                didWarnAboutTailOptions[tailMode] = true;
                error('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', tailMode);
            }
        }
    }
    function validateSuspenseListNestedChild(childSlot, index) {
        var isAnArray = isArray(childSlot);
        var isIterable = !isAnArray && typeof getIteratorFn(childSlot) === "function";
        if (isAnArray || isIterable) {
            var type = isAnArray ? "array" : "iterable";
            error("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", type, index, type);
            return false;
        }
        return true;
    }
    function validateSuspenseListChildren(children, revealOrder) {
        if ((revealOrder === "forwards" || revealOrder === "backwards") && children !== undefined && children !== null && children !== false) {
            if (isArray(children)) for(var i = 0; i < children.length; i++){
                if (!validateSuspenseListNestedChild(children[i], i)) return;
            }
            else {
                var iteratorFn = getIteratorFn(children);
                if (typeof iteratorFn === "function") {
                    var childrenIterator = iteratorFn.call(children);
                    if (childrenIterator) {
                        var step = childrenIterator.next();
                        var _i = 0;
                        for(; !step.done; step = childrenIterator.next()){
                            if (!validateSuspenseListNestedChild(step.value, _i)) return;
                            _i++;
                        }
                    }
                } else error('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', revealOrder);
            }
        }
    }
    function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
        var renderState = workInProgress.memoizedState;
        if (renderState === null) workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail: tail,
            tailMode: tailMode
        };
        else {
            // We can reuse the existing object from previous renders.
            renderState.isBackwards = isBackwards;
            renderState.rendering = null;
            renderState.renderingStartTime = 0;
            renderState.last = lastContentRow;
            renderState.tail = tail;
            renderState.tailMode = tailMode;
        }
    } // This can end up rendering this component multiple passes.
    // The first pass splits the children fibers into two sets. A head and tail.
    // We first render the head. If anything is in fallback state, we do another
    // pass through beginWork to rerender all children (including the tail) with
    // the force suspend context. If the first render didn't have anything in
    // in fallback state. Then we render each row in the tail one-by-one.
    // That happens in the completeWork phase without going back to beginWork.
    function updateSuspenseListComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps;
        var revealOrder = nextProps.revealOrder;
        var tailMode = nextProps.tail;
        var newChildren = nextProps.children;
        validateRevealOrder(revealOrder);
        validateTailOptions(tailMode, revealOrder);
        validateSuspenseListChildren(newChildren, revealOrder);
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        var suspenseContext = suspenseStackCursor.current;
        var shouldForceFallback = hasSuspenseContext(suspenseContext, ForceSuspenseFallback);
        if (shouldForceFallback) {
            suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
            workInProgress.flags |= DidCapture;
        } else {
            var didSuspendBefore = current !== null && (current.flags & DidCapture) !== NoFlags;
            if (didSuspendBefore) // If we previously forced a fallback, we need to schedule work
            // on any nested boundaries to let them know to try to render
            // again. This is the same as context updating.
            propagateSuspenseContextChange(workInProgress, workInProgress.child, renderLanes);
            suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
        }
        pushSuspenseContext(workInProgress, suspenseContext);
        if ((workInProgress.mode & ConcurrentMode) === NoMode) // In legacy mode, SuspenseList doesn't work so we just
        // use make it a noop by treating it as the default revealOrder.
        workInProgress.memoizedState = null;
        else switch(revealOrder){
            case "forwards":
                var lastContentRow = findLastContentRow(workInProgress.child);
                var tail;
                if (lastContentRow === null) {
                    // The whole list is part of the tail.
                    // TODO: We could fast path by just rendering the tail now.
                    tail = workInProgress.child;
                    workInProgress.child = null;
                } else {
                    // Disconnect the tail rows after the content row.
                    // We're going to render them separately later.
                    tail = lastContentRow.sibling;
                    lastContentRow.sibling = null;
                }
                initSuspenseListRenderState(workInProgress, false, tail, lastContentRow, tailMode);
                break;
            case "backwards":
                // We're going to find the first row that has existing content.
                // At the same time we're going to reverse the list of everything
                // we pass in the meantime. That's going to be our tail in reverse
                // order.
                var _tail = null;
                var row = workInProgress.child;
                workInProgress.child = null;
                while(row !== null){
                    var currentRow = row.alternate; // New rows can't be content rows.
                    if (currentRow !== null && findFirstSuspended(currentRow) === null) {
                        // This is the beginning of the main content.
                        workInProgress.child = row;
                        break;
                    }
                    var nextRow = row.sibling;
                    row.sibling = _tail;
                    _tail = row;
                    row = nextRow;
                } // TODO: If workInProgress.child is null, we can continue on the tail immediately.
                initSuspenseListRenderState(workInProgress, true, _tail, null, tailMode);
                break;
            case "together":
                initSuspenseListRenderState(workInProgress, false, null, null, undefined);
                break;
            default:
                // The default reveal order is the same as not having
                // a boundary.
                workInProgress.memoizedState = null;
        }
        return workInProgress.child;
    }
    function updatePortalComponent(current, workInProgress, renderLanes) {
        pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
        var nextChildren = workInProgress.pendingProps;
        if (current === null) // Portals are special because we don't append the children during mount
        // but at commit. Therefore we need to track insertions which the normal
        // flow doesn't do during mount. This doesn't happen at the root because
        // the root always starts with a "current" with a null child.
        // TODO: Consider unifying this with how the root works.
        workInProgress.child = reconcileChildFibers(workInProgress, null, nextChildren, renderLanes);
        else reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingNoValuePropOnContextProvider = false;
    function updateContextProvider(current, workInProgress, renderLanes) {
        var providerType = workInProgress.type;
        var context = providerType._context;
        var newProps = workInProgress.pendingProps;
        var oldProps = workInProgress.memoizedProps;
        var newValue = newProps.value;
        if (!("value" in newProps)) {
            if (!hasWarnedAboutUsingNoValuePropOnContextProvider) {
                hasWarnedAboutUsingNoValuePropOnContextProvider = true;
                error("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?");
            }
        }
        var providerPropTypes = workInProgress.type.propTypes;
        if (providerPropTypes) checkPropTypes(providerPropTypes, newProps, "prop", "Context.Provider");
        pushProvider(workInProgress, context, newValue);
        if (oldProps !== null) {
            var oldValue = oldProps.value;
            if (objectIs(oldValue, newValue)) {
                // No change. Bailout early if children are the same.
                if (oldProps.children === newProps.children && !hasContextChanged()) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            } else // The context value changed. Search for matching consumers and schedule
            // them to update.
            propagateContextChange(workInProgress, context, renderLanes);
        }
        var newChildren = newProps.children;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    var hasWarnedAboutUsingContextAsConsumer = false;
    function updateContextConsumer(current, workInProgress, renderLanes) {
        var context = workInProgress.type; // The logic below for Context differs depending on PROD or DEV mode. In
        if (context._context === undefined) {
            // This may be because it's a Context (rather than a Consumer).
            // Or it may be because it's older React where they're the same thing.
            // We only want to warn if we're sure it's a new React.
            if (context !== context.Consumer) {
                if (!hasWarnedAboutUsingContextAsConsumer) {
                    hasWarnedAboutUsingContextAsConsumer = true;
                    error("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?");
                }
            }
        } else context = context._context;
        var newProps = workInProgress.pendingProps;
        var render = newProps.children;
        if (typeof render !== "function") error("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it.");
        prepareToReadContext(workInProgress, renderLanes);
        var newValue = readContext(context);
        markComponentRenderStarted(workInProgress);
        var newChildren;
        ReactCurrentOwner$1.current = workInProgress;
        setIsRendering(true);
        newChildren = render(newValue);
        setIsRendering(false);
        markComponentRenderStopped();
        workInProgress.flags |= PerformedWork;
        reconcileChildren(current, workInProgress, newChildren, renderLanes);
        return workInProgress.child;
    }
    function markWorkInProgressReceivedUpdate() {
        didReceiveUpdate = true;
    }
    function resetSuspendedCurrentOnMountInLegacyMode(current, workInProgress) {
        if ((workInProgress.mode & ConcurrentMode) === NoMode) {
            if (current !== null) {
                // A lazy component only mounts if it suspended inside a non-
                // concurrent tree, in an inconsistent state. We want to treat it like
                // a new mount, even though an empty version of it already committed.
                // Disconnect the alternate pointers.
                current.alternate = null;
                workInProgress.alternate = null; // Since this is conceptually a new fiber, schedule a Placement effect
                workInProgress.flags |= Placement;
            }
        }
    }
    function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
        if (current !== null) // Reuse previous dependencies
        workInProgress.dependencies = current.dependencies;
        // Don't update "base" render times for bailouts.
        stopProfilerTimerIfRunning();
        markSkippedUpdateLanes(workInProgress.lanes); // Check if the children have any pending work.
        if (!includesSomeLane(renderLanes, workInProgress.childLanes)) return null;
         // This fiber doesn't have work, but its subtree does. Clone the child
        // fibers and continue.
        cloneChildFibers(current, workInProgress);
        return workInProgress.child;
    }
    function remountFiber(current, oldWorkInProgress, newWorkInProgress) {
        var returnFiber = oldWorkInProgress.return;
        if (returnFiber === null) // eslint-disable-next-line react-internal/prod-error-codes
        throw new Error("Cannot swap the root fiber.");
         // Disconnect from the old current.
        // It will get deleted.
        current.alternate = null;
        oldWorkInProgress.alternate = null; // Connect to the new tree.
        newWorkInProgress.index = oldWorkInProgress.index;
        newWorkInProgress.sibling = oldWorkInProgress.sibling;
        newWorkInProgress.return = oldWorkInProgress.return;
        newWorkInProgress.ref = oldWorkInProgress.ref; // Replace the child/sibling pointers above it.
        if (oldWorkInProgress === returnFiber.child) returnFiber.child = newWorkInProgress;
        else {
            var prevSibling = returnFiber.child;
            if (prevSibling === null) // eslint-disable-next-line react-internal/prod-error-codes
            throw new Error("Expected parent to have a child.");
            while(prevSibling.sibling !== oldWorkInProgress){
                prevSibling = prevSibling.sibling;
                if (prevSibling === null) // eslint-disable-next-line react-internal/prod-error-codes
                throw new Error("Expected to find the previous sibling.");
            }
            prevSibling.sibling = newWorkInProgress;
        } // Delete the old fiber and place the new one.
        // Since the old fiber is disconnected, we have to schedule it manually.
        var deletions = returnFiber.deletions;
        if (deletions === null) {
            returnFiber.deletions = [
                current
            ];
            returnFiber.flags |= ChildDeletion;
        } else deletions.push(current);
        newWorkInProgress.flags |= Placement; // Restart work from the new fiber.
        return newWorkInProgress;
    }
    function checkScheduledUpdateOrContext(current, renderLanes) {
        // Before performing an early bailout, we must check if there are pending
        // updates or context.
        var updateLanes = current.lanes;
        if (includesSomeLane(updateLanes, renderLanes)) return true;
         // No pending update, but because context is propagated lazily, we need
        return false;
    }
    function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
        // This fiber does not have any pending work. Bailout without entering
        // the begin phase. There's still some bookkeeping we that needs to be done
        // in this optimized path, mostly pushing stuff onto the stack.
        switch(workInProgress.tag){
            case HostRoot:
                pushHostRootContext(workInProgress);
                var root = workInProgress.stateNode;
                resetHydrationState();
                break;
            case HostComponent:
                pushHostContext(workInProgress);
                break;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) pushContextProvider(workInProgress);
                break;
            case HostPortal:
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                break;
            case ContextProvider:
                var newValue = workInProgress.memoizedProps.value;
                var context = workInProgress.type._context;
                pushProvider(workInProgress, context, newValue);
                break;
            case Profiler:
                // Profiler should only call onRender when one of its descendants actually rendered.
                var hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                if (hasChildWork) workInProgress.flags |= Update;
                // Reset effect durations for the next eventual effect phase.
                // These are reset during render to allow the DevTools commit hook a chance to read them,
                var stateNode = workInProgress.stateNode;
                stateNode.effectDuration = 0;
                stateNode.passiveEffectDuration = 0;
                break;
            case SuspenseComponent:
                var state = workInProgress.memoizedState;
                if (state !== null) {
                    if (state.dehydrated !== null) {
                        pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // We know that this component will suspend again because if it has
                        // been unsuspended it has committed as a resolved Suspense component.
                        // If it needs to be retried, it should have work scheduled on it.
                        workInProgress.flags |= DidCapture; // We should never render the children of a dehydrated boundary until we
                        // upgrade it. We return null instead of bailoutOnAlreadyFinishedWork.
                        return null;
                    } // If this boundary is currently timed out, we need to decide
                    // whether to retry the primary children, or to skip over it and
                    // go straight to the fallback. Check the priority of the primary
                    // child fragment.
                    var primaryChildFragment = workInProgress.child;
                    var primaryChildLanes = primaryChildFragment.childLanes;
                    if (includesSomeLane(renderLanes, primaryChildLanes)) // The primary children have pending work. Use the normal path
                    // to attempt to render the primary children again.
                    return updateSuspenseComponent(current, workInProgress, renderLanes);
                    else {
                        // The primary child fragment does not have pending work marked
                        // on it
                        pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current)); // The primary children do not have pending work with sufficient
                        // priority. Bailout.
                        var child = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        if (child !== null) // The fallback children have pending work. Skip over the
                        // primary children and work on the fallback.
                        return child.sibling;
                        else // Note: We can return `null` here because we already checked
                        // whether there were nested context consumers, via the call to
                        // `bailoutOnAlreadyFinishedWork` above.
                        return null;
                    }
                } else pushSuspenseContext(workInProgress, setDefaultShallowSuspenseContext(suspenseStackCursor.current));
                break;
            case SuspenseListComponent:
                var didSuspendBefore = (current.flags & DidCapture) !== NoFlags;
                var _hasChildWork = includesSomeLane(renderLanes, workInProgress.childLanes);
                if (didSuspendBefore) {
                    if (_hasChildWork) // If something was in fallback state last time, and we have all the
                    // same children then we're still in progressive loading state.
                    // Something might get unblocked by state updates or retries in the
                    // tree which will affect the tail. So we need to use the normal
                    // path to compute the correct tail.
                    return updateSuspenseListComponent(current, workInProgress, renderLanes);
                     // If none of the children had any work, that means that none of
                    // them got retried so they'll still be blocked in the same way
                    // as before. We can fast bail out.
                    workInProgress.flags |= DidCapture;
                } // If nothing suspended before and we're rendering the same children,
                // then the tail doesn't matter. Anything new that suspends will work
                // in the "together" mode, so we can continue from the state we had.
                var renderState = workInProgress.memoizedState;
                if (renderState !== null) {
                    // Reset to the "together" mode in case we've started a different
                    // update in the past but didn't complete it.
                    renderState.rendering = null;
                    renderState.tail = null;
                    renderState.lastEffect = null;
                }
                pushSuspenseContext(workInProgress, suspenseStackCursor.current);
                if (_hasChildWork) break;
                else // If none of the children had any work, that means that none of
                // them got retried so they'll still be blocked in the same way
                // as before. We can fast bail out.
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                // Need to check if the tree still needs to be deferred. This is
                // almost identical to the logic used in the normal update path,
                // so we'll just enter that. The only difference is we'll bail out
                // at the next level instead of this one, because the child props
                // have not changed. Which is fine.
                // TODO: Probably should refactor `beginWork` to split the bailout
                // path from the normal path. I'm tempted to do a labeled break here
                // but I won't :)
                workInProgress.lanes = NoLanes;
                return updateOffscreenComponent(current, workInProgress, renderLanes);
        }
        return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    function beginWork(current, workInProgress, renderLanes) {
        if (workInProgress._debugNeedsRemount && current !== null) // This will restart the begin phase with a new fiber.
        return remountFiber(current, workInProgress, createFiberFromTypeAndProps(workInProgress.type, workInProgress.key, workInProgress.pendingProps, workInProgress._debugOwner || null, workInProgress.mode, workInProgress.lanes));
        if (current !== null) {
            var oldProps = current.memoizedProps;
            var newProps = workInProgress.pendingProps;
            if (oldProps !== newProps || hasContextChanged() || workInProgress.type !== current.type) // If props or context changed, mark the fiber as having performed work.
            // This may be unset if the props are determined to be equal later (memo).
            didReceiveUpdate = true;
            else {
                // Neither props nor legacy context changes. Check if there's a pending
                // update or context change.
                var hasScheduledUpdateOrContext = checkScheduledUpdateOrContext(current, renderLanes);
                if (!hasScheduledUpdateOrContext && // If this is the second pass of an error or suspense boundary, there
                // may not be work scheduled on `current`, so we check for this flag.
                (workInProgress.flags & DidCapture) === NoFlags) {
                    // No pending updates or context. Bail out now.
                    didReceiveUpdate = false;
                    return attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
                }
                if ((current.flags & ForceUpdateForLegacySuspense) !== NoFlags) // This is a special case that only exists for legacy mode.
                // See https://github.com/facebook/react/pull/19216.
                didReceiveUpdate = true;
                else // An update was scheduled on this fiber, but there are no new props
                // nor legacy context. Set this to false. If an update queue or context
                // consumer produces a changed value, it will set this to true. Otherwise,
                // the component will assume the children have not changed and bail out.
                didReceiveUpdate = false;
            }
        } else {
            didReceiveUpdate = false;
            if (getIsHydrating() && isForkedChild(workInProgress)) {
                // Check if this child belongs to a list of muliple children in
                // its parent.
                //
                // In a true multi-threaded implementation, we would render children on
                // parallel threads. This would represent the beginning of a new render
                // thread for this subtree.
                //
                // We only use this for id generation during hydration, which is why the
                // logic is located in this special branch.
                var slotIndex = workInProgress.index;
                var numberOfForks = getForksAtLevel();
                pushTreeId(workInProgress, numberOfForks, slotIndex);
            }
        } // Before entering the begin phase, clear pending update priority.
        // TODO: This assumes that we're about to evaluate the component and process
        // the update queue. However, there's an exception: SimpleMemoComponent
        // sometimes bails out later in the begin phase. This indicates that we should
        // move this assignment out of the common path and into each branch.
        workInProgress.lanes = NoLanes;
        switch(workInProgress.tag){
            case IndeterminateComponent:
                return mountIndeterminateComponent(current, workInProgress, workInProgress.type, renderLanes);
            case LazyComponent:
                var elementType = workInProgress.elementType;
                return mountLazyComponent(current, workInProgress, elementType, renderLanes);
            case FunctionComponent:
                var Component = workInProgress.type;
                var unresolvedProps = workInProgress.pendingProps;
                var resolvedProps = workInProgress.elementType === Component ? unresolvedProps : resolveDefaultProps(Component, unresolvedProps);
                return updateFunctionComponent(current, workInProgress, Component, resolvedProps, renderLanes);
            case ClassComponent:
                var _Component = workInProgress.type;
                var _unresolvedProps = workInProgress.pendingProps;
                var _resolvedProps = workInProgress.elementType === _Component ? _unresolvedProps : resolveDefaultProps(_Component, _unresolvedProps);
                return updateClassComponent(current, workInProgress, _Component, _resolvedProps, renderLanes);
            case HostRoot:
                return updateHostRoot(current, workInProgress, renderLanes);
            case HostComponent:
                return updateHostComponent(current, workInProgress, renderLanes);
            case HostText:
                return updateHostText(current, workInProgress);
            case SuspenseComponent:
                return updateSuspenseComponent(current, workInProgress, renderLanes);
            case HostPortal:
                return updatePortalComponent(current, workInProgress, renderLanes);
            case ForwardRef:
                var type = workInProgress.type;
                var _unresolvedProps2 = workInProgress.pendingProps;
                var _resolvedProps2 = workInProgress.elementType === type ? _unresolvedProps2 : resolveDefaultProps(type, _unresolvedProps2);
                return updateForwardRef(current, workInProgress, type, _resolvedProps2, renderLanes);
            case Fragment:
                return updateFragment(current, workInProgress, renderLanes);
            case Mode:
                return updateMode(current, workInProgress, renderLanes);
            case Profiler:
                return updateProfiler(current, workInProgress, renderLanes);
            case ContextProvider:
                return updateContextProvider(current, workInProgress, renderLanes);
            case ContextConsumer:
                return updateContextConsumer(current, workInProgress, renderLanes);
            case MemoComponent:
                var _type2 = workInProgress.type;
                var _unresolvedProps3 = workInProgress.pendingProps; // Resolve outer props first, then resolve inner props.
                var _resolvedProps3 = resolveDefaultProps(_type2, _unresolvedProps3);
                if (workInProgress.type !== workInProgress.elementType) {
                    var outerPropTypes = _type2.propTypes;
                    if (outerPropTypes) checkPropTypes(outerPropTypes, _resolvedProps3, "prop", getComponentNameFromType(_type2));
                }
                _resolvedProps3 = resolveDefaultProps(_type2.type, _resolvedProps3);
                return updateMemoComponent(current, workInProgress, _type2, _resolvedProps3, renderLanes);
            case SimpleMemoComponent:
                return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case IncompleteClassComponent:
                var _Component2 = workInProgress.type;
                var _unresolvedProps4 = workInProgress.pendingProps;
                var _resolvedProps4 = workInProgress.elementType === _Component2 ? _unresolvedProps4 : resolveDefaultProps(_Component2, _unresolvedProps4);
                return mountIncompleteClassComponent(current, workInProgress, _Component2, _resolvedProps4, renderLanes);
            case SuspenseListComponent:
                return updateSuspenseListComponent(current, workInProgress, renderLanes);
            case ScopeComponent:
                break;
            case OffscreenComponent:
                return updateOffscreenComponent(current, workInProgress, renderLanes);
        }
        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + "React. Please file an issue.");
    }
    function markUpdate(workInProgress) {
        // Tag the fiber with an update effect. This turns a Placement into
        // a PlacementAndUpdate.
        workInProgress.flags |= Update;
    }
    function markRef$1(workInProgress) {
        workInProgress.flags |= Ref;
        workInProgress.flags |= RefStatic;
    }
    var appendAllChildren;
    var updateHostContainer;
    var updateHostComponent$1;
    var updateHostText$1;
    // Mutation mode
    appendAllChildren = function(parent, workInProgress, needsVisibilityToggle, isHidden) {
        // We only have the top Fiber that was created but we need recurse down its
        // children to find all the terminal nodes.
        var node = workInProgress.child;
        while(node !== null){
            if (node.tag === HostComponent || node.tag === HostText) appendInitialChild(parent, node.stateNode);
            else if (node.tag === HostPortal) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === workInProgress) return;
            while(node.sibling === null){
                if (node.return === null || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    };
    updateHostContainer = function(current, workInProgress) {};
    updateHostComponent$1 = function(current, workInProgress, type, newProps, rootContainerInstance) {
        // If we have an alternate, that means this is an update and we need to
        // schedule a side-effect to do the updates.
        var oldProps = current.memoizedProps;
        if (oldProps === newProps) // In mutation mode, this is sufficient for a bailout because
        // we won't touch this node even if children changed.
        return;
         // If we get updated because one of our children updated, we don't
        // have newProps so we'll have to reuse them.
        // TODO: Split the update API as separate for the props vs. children.
        // Even better would be if children weren't special cased at all tho.
        var instance = workInProgress.stateNode;
        var currentHostContext = getHostContext(); // TODO: Experiencing an error where oldProps is null. Suggests a host
        // component is hitting the resume path. Figure out why. Possibly
        // related to `hidden`.
        var updatePayload = prepareUpdate(instance, type, oldProps, newProps, rootContainerInstance, currentHostContext); // TODO: Type this specific to this type of component.
        workInProgress.updateQueue = updatePayload; // If the update payload indicates that there is a change or if there
        // is a new ref we mark this as an update. All the work is done in commitWork.
        if (updatePayload) markUpdate(workInProgress);
    };
    updateHostText$1 = function(current, workInProgress, oldText, newText) {
        // If the text differs, mark it as an update. All the work in done in commitWork.
        if (oldText !== newText) markUpdate(workInProgress);
    };
    function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        if (getIsHydrating()) // If we're hydrating, we should consume as many items as we can
        // so we don't leave any behind.
        return;
        switch(renderState.tailMode){
            case "hidden":
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var tailNode = renderState.tail;
                var lastTailNode = null;
                while(tailNode !== null){
                    if (tailNode.alternate !== null) lastTailNode = tailNode;
                    tailNode = tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (lastTailNode === null) // All remaining items in the tail are insertions.
                renderState.tail = null;
                else // Detach the insertion after the last node that was already
                // inserted.
                lastTailNode.sibling = null;
                break;
            case "collapsed":
                // Any insertions at the end of the tail list after this point
                // should be invisible. If there are already mounted boundaries
                // anything before them are not considered for collapsing.
                // Therefore we need to go through the whole tail to find if
                // there are any.
                var _tailNode = renderState.tail;
                var _lastTailNode = null;
                while(_tailNode !== null){
                    if (_tailNode.alternate !== null) _lastTailNode = _tailNode;
                    _tailNode = _tailNode.sibling;
                } // Next we're simply going to delete all insertions after the
                // last rendered item.
                if (_lastTailNode === null) {
                    // All remaining items in the tail are insertions.
                    if (!hasRenderedATailFallback && renderState.tail !== null) // We suspended during the head. We want to show at least one
                    // row at the tail. So we'll keep on and cut off the rest.
                    renderState.tail.sibling = null;
                    else renderState.tail = null;
                } else // Detach the insertion after the last node that was already
                // inserted.
                _lastTailNode.sibling = null;
                break;
        }
    }
    function bubbleProperties(completedWork) {
        var didBailout = completedWork.alternate !== null && completedWork.alternate.child === completedWork.child;
        var newChildLanes = NoLanes;
        var subtreeFlags = NoFlags;
        if (!didBailout) {
            // Bubble up the earliest expiration time.
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                // In profiling mode, resetChildExpirationTime is also used to reset
                // profiler durations.
                var actualDuration = completedWork.actualDuration;
                var treeBaseDuration = completedWork.selfBaseDuration;
                var child = completedWork.child;
                while(child !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(child.lanes, child.childLanes));
                    subtreeFlags |= child.subtreeFlags;
                    subtreeFlags |= child.flags; // When a fiber is cloned, its actualDuration is reset to 0. This value will
                    // only be updated if work is done on the fiber (i.e. it doesn't bailout).
                    // When work is done, it should bubble to the parent's actualDuration. If
                    // the fiber has not been cloned though, (meaning no work was done), then
                    // this value will reflect the amount of time spent working on a previous
                    // render. In that case it should not bubble. We determine whether it was
                    // cloned by comparing the child pointer.
                    actualDuration += child.actualDuration;
                    treeBaseDuration += child.treeBaseDuration;
                    child = child.sibling;
                }
                completedWork.actualDuration = actualDuration;
                completedWork.treeBaseDuration = treeBaseDuration;
            } else {
                var _child = completedWork.child;
                while(_child !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child.lanes, _child.childLanes));
                    subtreeFlags |= _child.subtreeFlags;
                    subtreeFlags |= _child.flags; // Update the return pointer so the tree is consistent. This is a code
                    // smell because it assumes the commit phase is never concurrent with
                    // the render phase. Will address during refactor to alternate model.
                    _child.return = completedWork;
                    _child = _child.sibling;
                }
            }
            completedWork.subtreeFlags |= subtreeFlags;
        } else {
            // Bubble up the earliest expiration time.
            if ((completedWork.mode & ProfileMode) !== NoMode) {
                // In profiling mode, resetChildExpirationTime is also used to reset
                // profiler durations.
                var _treeBaseDuration = completedWork.selfBaseDuration;
                var _child2 = completedWork.child;
                while(_child2 !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child2.lanes, _child2.childLanes)); // "Static" flags share the lifetime of the fiber/hook they belong to,
                    // so we should bubble those up even during a bailout. All the other
                    // flags have a lifetime only of a single render + commit, so we should
                    // ignore them.
                    subtreeFlags |= _child2.subtreeFlags & StaticMask;
                    subtreeFlags |= _child2.flags & StaticMask;
                    _treeBaseDuration += _child2.treeBaseDuration;
                    _child2 = _child2.sibling;
                }
                completedWork.treeBaseDuration = _treeBaseDuration;
            } else {
                var _child3 = completedWork.child;
                while(_child3 !== null){
                    newChildLanes = mergeLanes(newChildLanes, mergeLanes(_child3.lanes, _child3.childLanes)); // "Static" flags share the lifetime of the fiber/hook they belong to,
                    // so we should bubble those up even during a bailout. All the other
                    // flags have a lifetime only of a single render + commit, so we should
                    // ignore them.
                    subtreeFlags |= _child3.subtreeFlags & StaticMask;
                    subtreeFlags |= _child3.flags & StaticMask; // Update the return pointer so the tree is consistent. This is a code
                    // smell because it assumes the commit phase is never concurrent with
                    // the render phase. Will address during refactor to alternate model.
                    _child3.return = completedWork;
                    _child3 = _child3.sibling;
                }
            }
            completedWork.subtreeFlags |= subtreeFlags;
        }
        completedWork.childLanes = newChildLanes;
        return didBailout;
    }
    function completeDehydratedSuspenseBoundary(current, workInProgress, nextState) {
        if (hasUnhydratedTailNodes() && (workInProgress.mode & ConcurrentMode) !== NoMode && (workInProgress.flags & DidCapture) === NoFlags) {
            warnIfUnhydratedTailNodes(workInProgress);
            resetHydrationState();
            workInProgress.flags |= ForceClientRender | Incomplete | ShouldCapture;
            return false;
        }
        var wasHydrated = popHydrationState(workInProgress);
        if (nextState !== null && nextState.dehydrated !== null) {
            // We might be inside a hydration state the first time we're picking up this
            // Suspense boundary, and also after we've reentered it for further hydration.
            if (current === null) {
                if (!wasHydrated) throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
                prepareToHydrateHostSuspenseInstance(workInProgress);
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    var isTimedOutSuspense = nextState !== null;
                    if (isTimedOutSuspense) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var primaryChildFragment = workInProgress.child;
                        if (primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                    }
                }
                return false;
            } else {
                // We might have reentered this boundary to hydrate it. If so, we need to reset the hydration
                // state since we're now exiting out of it. popHydrationState doesn't do that for us.
                resetHydrationState();
                if ((workInProgress.flags & DidCapture) === NoFlags) // This boundary did not suspend so it's now hydrated and unsuspended.
                workInProgress.memoizedState = null;
                 // If nothing suspended, we need to schedule an effect to mark this boundary
                // as having hydrated so events know that they're free to be invoked.
                // It's also a signal to replay events and the suspense callback.
                // If something suspended, schedule an effect to attach retry listeners.
                // So we might as well always mark this.
                workInProgress.flags |= Update;
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    var _isTimedOutSuspense = nextState !== null;
                    if (_isTimedOutSuspense) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var _primaryChildFragment = workInProgress.child;
                        if (_primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= _primaryChildFragment.treeBaseDuration;
                    }
                }
                return false;
            }
        } else {
            // Successfully completed this tree. If this was a forced client render,
            // there may have been recoverable errors during first hydration
            // attempt. If so, add them to a queue so we can log them in the
            // commit phase.
            upgradeHydrationErrorsToRecoverable(); // Fall through to normal Suspense path
            return true;
        }
    }
    function completeWork(current, workInProgress, renderLanes) {
        var newProps = workInProgress.pendingProps; // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case LazyComponent:
            case SimpleMemoComponent:
            case FunctionComponent:
            case ForwardRef:
            case Fragment:
            case Mode:
            case Profiler:
            case ContextConsumer:
            case MemoComponent:
                bubbleProperties(workInProgress);
                return null;
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case HostRoot:
                var fiberRoot = workInProgress.stateNode;
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                if (fiberRoot.pendingContext) {
                    fiberRoot.context = fiberRoot.pendingContext;
                    fiberRoot.pendingContext = null;
                }
                if (current === null || current.child === null) {
                    // If we hydrated, pop so that we can delete any remaining children
                    // that weren't hydrated.
                    var wasHydrated = popHydrationState(workInProgress);
                    if (wasHydrated) // If we hydrated, then we'll need to schedule an update for
                    // the commit side-effects on the root.
                    markUpdate(workInProgress);
                    else if (current !== null) {
                        var prevState = current.memoizedState;
                        if (!prevState.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
                        (workInProgress.flags & ForceClientRender) !== NoFlags) {
                            // Schedule an effect to clear this container at the start of the
                            // next commit. This handles the case of React rendering into a
                            // container with previous children. It's also safe to do for
                            // updates too, because current.child would only be null if the
                            // previous render was null (so the container would already
                            // be empty).
                            workInProgress.flags |= Snapshot; // If this was a forced client render, there may have been
                            // recoverable errors during first hydration attempt. If so, add
                            // them to a queue so we can log them in the commit phase.
                            upgradeHydrationErrorsToRecoverable();
                        }
                    }
                }
                updateHostContainer(current, workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case HostComponent:
                popHostContext(workInProgress);
                var rootContainerInstance = getRootHostContainer();
                var type = workInProgress.type;
                if (current !== null && workInProgress.stateNode != null) {
                    updateHostComponent$1(current, workInProgress, type, newProps, rootContainerInstance);
                    if (current.ref !== workInProgress.ref) markRef$1(workInProgress);
                } else {
                    if (!newProps) {
                        if (workInProgress.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                        bubbleProperties(workInProgress);
                        return null;
                    }
                    var currentHostContext = getHostContext(); // TODO: Move createInstance to beginWork and keep it on a context
                    // "stack" as the parent. Then append children as we go in beginWork
                    // or completeWork depending on whether we want to add them top->down or
                    // bottom->up. Top->down is faster in IE11.
                    var _wasHydrated = popHydrationState(workInProgress);
                    if (_wasHydrated) // TODO: Move this and createInstance step into the beginPhase
                    // to consolidate.
                    {
                        if (prepareToHydrateHostInstance(workInProgress, rootContainerInstance, currentHostContext)) // If changes to the hydrated node need to be applied at the
                        // commit-phase we mark this as such.
                        markUpdate(workInProgress);
                    } else {
                        var instance = createInstance(type, newProps, rootContainerInstance, currentHostContext, workInProgress);
                        appendAllChildren(instance, workInProgress, false, false);
                        workInProgress.stateNode = instance; // Certain renderers require commit-time effects for initial mount.
                        // (eg DOM renderer supports auto-focus for certain elements).
                        // Make sure such renderers get scheduled for later work.
                        if (finalizeInitialChildren(instance, type, newProps, rootContainerInstance)) markUpdate(workInProgress);
                    }
                    if (workInProgress.ref !== null) // If there is a ref on a host node we need to schedule a callback
                    markRef$1(workInProgress);
                }
                bubbleProperties(workInProgress);
                return null;
            case HostText:
                var newText = newProps;
                if (current && workInProgress.stateNode != null) {
                    var oldText = current.memoizedProps; // If we have an alternate, that means this is an update and we need
                    // to schedule a side-effect to do the updates.
                    updateHostText$1(current, workInProgress, oldText, newText);
                } else {
                    if (typeof newText !== "string") {
                        if (workInProgress.stateNode === null) throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                         // This can happen when we abort work.
                    }
                    var _rootContainerInstance = getRootHostContainer();
                    var _currentHostContext = getHostContext();
                    var _wasHydrated2 = popHydrationState(workInProgress);
                    if (_wasHydrated2) {
                        if (prepareToHydrateHostTextInstance(workInProgress)) markUpdate(workInProgress);
                    } else workInProgress.stateNode = createTextInstance(newText, _rootContainerInstance, _currentHostContext, workInProgress);
                }
                bubbleProperties(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var nextState = workInProgress.memoizedState; // Special path for dehydrated boundaries. We may eventually move this
                // to its own fiber type so that we can add other kinds of hydration
                // boundaries that aren't associated with a Suspense tree. In anticipation
                // of such a refactor, all the hydration logic is contained in
                // this branch.
                if (current === null || current.memoizedState !== null && current.memoizedState.dehydrated !== null) {
                    var fallthroughToNormalSuspensePath = completeDehydratedSuspenseBoundary(current, workInProgress, nextState);
                    if (!fallthroughToNormalSuspensePath) {
                        if (workInProgress.flags & ShouldCapture) // Special case. There were remaining unhydrated nodes. We treat
                        // this as a mismatch. Revert to client rendering.
                        return workInProgress;
                        else // Did not finish hydrating, either because this is the initial
                        // render or because something suspended.
                        return null;
                    } // Continue with the normal Suspense path.
                }
                if ((workInProgress.flags & DidCapture) !== NoFlags) {
                    // Something suspended. Re-render with the fallback children.
                    workInProgress.lanes = renderLanes; // Do not reset the effect list.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                     // Don't bubble properties in this case.
                    return workInProgress;
                }
                var nextDidTimeout = nextState !== null;
                var prevDidTimeout = current !== null && current.memoizedState !== null;
                // a passive effect, which is when we process the transitions
                if (nextDidTimeout !== prevDidTimeout) // an effect to toggle the subtree's visibility. When we switch from
                // fallback -> primary, the inner Offscreen fiber schedules this effect
                // as part of its normal complete phase. But when we switch from
                // primary -> fallback, the inner Offscreen fiber does not have a complete
                // phase. So we need to schedule its effect here.
                //
                // We also use this flag to connect/disconnect the effects, but the same
                // logic applies: when re-connecting, the Offscreen fiber's complete
                // phase will handle scheduling the effect. It's only when the fallback
                // is active that we have to do anything special.
                {
                    if (nextDidTimeout) {
                        var _offscreenFiber2 = workInProgress.child;
                        _offscreenFiber2.flags |= Visibility; // TODO: This will still suspend a synchronous tree if anything
                        // in the concurrent tree already suspended during this render.
                        // This is a known bug.
                        if ((workInProgress.mode & ConcurrentMode) !== NoMode) {
                            // TODO: Move this back to throwException because this is too late
                            // if this is a large tree which is common for initial loads. We
                            // don't know if we should restart a render or not until we get
                            // this marker, and this is too late.
                            // If this render already had a ping or lower pri updates,
                            // and this is the first time we know we're going to suspend we
                            // should be able to immediately restart from within throwException.
                            var hasInvisibleChildContext = current === null && (workInProgress.memoizedProps.unstable_avoidThisFallback !== true || !enableSuspenseAvoidThisFallback);
                            if (hasInvisibleChildContext || hasSuspenseContext(suspenseStackCursor.current, InvisibleParentSuspenseContext)) // If this was in an invisible tree or a new render, then showing
                            // this boundary is ok.
                            renderDidSuspend();
                            else // Otherwise, we're going to have to hide content so we should
                            // suspend for longer if possible.
                            renderDidSuspendDelayIfPossible();
                        }
                    }
                }
                var wakeables = workInProgress.updateQueue;
                if (wakeables !== null) // Schedule an effect to attach a retry listener to the promise.
                // TODO: Move to passive phase
                workInProgress.flags |= Update;
                bubbleProperties(workInProgress);
                if ((workInProgress.mode & ProfileMode) !== NoMode) {
                    if (nextDidTimeout) {
                        // Don't count time spent in a timed out Suspense subtree as part of the base duration.
                        var primaryChildFragment = workInProgress.child;
                        if (primaryChildFragment !== null) // $FlowFixMe Flow doesn't support type casting in combination with the -= operator
                        workInProgress.treeBaseDuration -= primaryChildFragment.treeBaseDuration;
                    }
                }
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                updateHostContainer(current, workInProgress);
                if (current === null) preparePortalMount(workInProgress.stateNode.containerInfo);
                bubbleProperties(workInProgress);
                return null;
            case ContextProvider:
                // Pop provider fiber
                var context = workInProgress.type._context;
                popProvider(context, workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case IncompleteClassComponent:
                // Same as class component case. I put it down here so that the tags are
                // sequential to ensure this switch is compiled to a jump table.
                var _Component = workInProgress.type;
                if (isContextProvider(_Component)) popContext(workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress);
                var renderState = workInProgress.memoizedState;
                if (renderState === null) {
                    // We're running in the default, "independent" mode.
                    // We don't do anything in this mode.
                    bubbleProperties(workInProgress);
                    return null;
                }
                var didSuspendAlready = (workInProgress.flags & DidCapture) !== NoFlags;
                var renderedTail = renderState.rendering;
                if (renderedTail === null) {
                    // We just rendered the head.
                    if (!didSuspendAlready) {
                        // This is the first pass. We need to figure out if anything is still
                        // suspended in the rendered set.
                        // If new content unsuspended, but there's still some content that
                        // didn't. Then we need to do a second pass that forces everything
                        // to keep showing their fallbacks.
                        // We might be suspended if something in this render pass suspended, or
                        // something in the previous committed pass suspended. Otherwise,
                        // there's no chance so we can skip the expensive call to
                        // findFirstSuspended.
                        var cannotBeSuspended = renderHasNotSuspendedYet() && (current === null || (current.flags & DidCapture) === NoFlags);
                        if (!cannotBeSuspended) {
                            var row = workInProgress.child;
                            while(row !== null){
                                var suspended = findFirstSuspended(row);
                                if (suspended !== null) {
                                    didSuspendAlready = true;
                                    workInProgress.flags |= DidCapture;
                                    cutOffTailIfNeeded(renderState, false); // If this is a newly suspended tree, it might not get committed as
                                    // part of the second pass. In that case nothing will subscribe to
                                    // its thenables. Instead, we'll transfer its thenables to the
                                    // SuspenseList so that it can retry if they resolve.
                                    // There might be multiple of these in the list but since we're
                                    // going to wait for all of them anyway, it doesn't really matter
                                    // which ones gets to ping. In theory we could get clever and keep
                                    // track of how many dependencies remain but it gets tricky because
                                    // in the meantime, we can add/remove/change items and dependencies.
                                    // We might bail out of the loop before finding any but that
                                    // doesn't matter since that means that the other boundaries that
                                    // we did find already has their listeners attached.
                                    var newThenables = suspended.updateQueue;
                                    if (newThenables !== null) {
                                        workInProgress.updateQueue = newThenables;
                                        workInProgress.flags |= Update;
                                    } // Rerender the whole list, but this time, we'll force fallbacks
                                    // to stay in place.
                                    // Reset the effect flags before doing the second pass since that's now invalid.
                                    // Reset the child fibers to their original state.
                                    workInProgress.subtreeFlags = NoFlags;
                                    resetChildFibers(workInProgress, renderLanes); // Set up the Suspense Context to force suspense and immediately
                                    // rerender the children.
                                    pushSuspenseContext(workInProgress, setShallowSuspenseContext(suspenseStackCursor.current, ForceSuspenseFallback)); // Don't bubble properties in this case.
                                    return workInProgress.child;
                                }
                                row = row.sibling;
                            }
                        }
                        if (renderState.tail !== null && now() > getRenderTargetTime()) {
                            // We have already passed our CPU deadline but we still have rows
                            // left in the tail. We'll just give up further attempts to render
                            // the main content and only render fallbacks.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                        }
                    } else cutOffTailIfNeeded(renderState, false);
                     // Next we're going to render the tail.
                } else {
                    // Append the rendered row to the child list.
                    if (!didSuspendAlready) {
                        var _suspended = findFirstSuspended(renderedTail);
                        if (_suspended !== null) {
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true; // Ensure we transfer the update queue to the parent so that it doesn't
                            // get lost if this row ends up dropped during a second pass.
                            var _newThenables = _suspended.updateQueue;
                            if (_newThenables !== null) {
                                workInProgress.updateQueue = _newThenables;
                                workInProgress.flags |= Update;
                            }
                            cutOffTailIfNeeded(renderState, true); // This might have been modified.
                            if (renderState.tail === null && renderState.tailMode === "hidden" && !renderedTail.alternate && !getIsHydrating() // We don't cut it if we're hydrating.
                            ) {
                                // We're done.
                                bubbleProperties(workInProgress);
                                return null;
                            }
                        } else if (// time we have to render. So rendering one more row would likely
                        // exceed it.
                        now() * 2 - renderState.renderingStartTime > getRenderTargetTime() && renderLanes !== OffscreenLane) {
                            // We have now passed our CPU deadline and we'll just give up further
                            // attempts to render the main content and only render fallbacks.
                            // The assumption is that this is usually faster.
                            workInProgress.flags |= DidCapture;
                            didSuspendAlready = true;
                            cutOffTailIfNeeded(renderState, false); // Since nothing actually suspended, there will nothing to ping this
                            // to get it started back up to attempt the next item. While in terms
                            // of priority this work has the same priority as this current render,
                            // it's not part of the same transition once the transition has
                            // committed. If it's sync, we still want to yield so that it can be
                            // painted. Conceptually, this is really the same as pinging.
                            // We can use any RetryLane even if it's the one currently rendering
                            // since we're leaving it behind on this node.
                            workInProgress.lanes = SomeRetryLane;
                        }
                    }
                    if (renderState.isBackwards) {
                        // The effect list of the backwards tail will have been added
                        // to the end. This breaks the guarantee that life-cycles fire in
                        // sibling order but that isn't a strong guarantee promised by React.
                        // Especially since these might also just pop in during future commits.
                        // Append to the beginning of the list.
                        renderedTail.sibling = workInProgress.child;
                        workInProgress.child = renderedTail;
                    } else {
                        var previousSibling = renderState.last;
                        if (previousSibling !== null) previousSibling.sibling = renderedTail;
                        else workInProgress.child = renderedTail;
                        renderState.last = renderedTail;
                    }
                }
                if (renderState.tail !== null) {
                    // We still have tail rows to render.
                    // Pop a row.
                    var next = renderState.tail;
                    renderState.rendering = next;
                    renderState.tail = next.sibling;
                    renderState.renderingStartTime = now();
                    next.sibling = null; // Restore the context.
                    // TODO: We can probably just avoid popping it instead and only
                    // setting it the first time we go from not suspended to suspended.
                    var suspenseContext = suspenseStackCursor.current;
                    if (didSuspendAlready) suspenseContext = setShallowSuspenseContext(suspenseContext, ForceSuspenseFallback);
                    else suspenseContext = setDefaultShallowSuspenseContext(suspenseContext);
                    pushSuspenseContext(workInProgress, suspenseContext); // Do a pass over the next row.
                    // Don't bubble properties in this case.
                    return next;
                }
                bubbleProperties(workInProgress);
                return null;
            case ScopeComponent:
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                var _nextState = workInProgress.memoizedState;
                var nextIsHidden = _nextState !== null;
                if (current !== null) {
                    var _prevState = current.memoizedState;
                    var prevIsHidden = _prevState !== null;
                    if (prevIsHidden !== nextIsHidden && !enableLegacyHidden) workInProgress.flags |= Visibility;
                }
                if (!nextIsHidden || (workInProgress.mode & ConcurrentMode) === NoMode) bubbleProperties(workInProgress);
                else // Don't bubble properties for hidden children unless we're rendering
                // at offscreen priority.
                if (includesSomeLane(subtreeRenderLanes, OffscreenLane)) {
                    bubbleProperties(workInProgress);
                    // Check if there was an insertion or update in the hidden subtree.
                    // If so, we need to hide those nodes in the commit phase, so
                    // schedule a visibility effect.
                    if (workInProgress.subtreeFlags & (Placement | Update)) workInProgress.flags |= Visibility;
                }
                return null;
            case CacheComponent:
                return null;
            case TracingMarkerComponent:
                return null;
        }
        throw new Error("Unknown unit of work tag (" + workInProgress.tag + "). This error is likely caused by a bug in " + "React. Please file an issue.");
    }
    function unwindWork(current, workInProgress, renderLanes) {
        // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case ClassComponent:
                var Component = workInProgress.type;
                if (isContextProvider(Component)) popContext(workInProgress);
                var flags = workInProgress.flags;
                if (flags & ShouldCapture) {
                    workInProgress.flags = flags & ~ShouldCapture | DidCapture;
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case HostRoot:
                var root = workInProgress.stateNode;
                popHostContainer(workInProgress);
                popTopLevelContextObject(workInProgress);
                resetWorkInProgressVersions();
                var _flags = workInProgress.flags;
                if ((_flags & ShouldCapture) !== NoFlags && (_flags & DidCapture) === NoFlags) {
                    // There was an error during render that wasn't captured by a suspense
                    // boundary. Do a second pass on the root to unmount the children.
                    workInProgress.flags = _flags & ~ShouldCapture | DidCapture;
                    return workInProgress;
                } // We unwound to the root without completing it. Exit.
                return null;
            case HostComponent:
                // TODO: popHydrationState
                popHostContext(workInProgress);
                return null;
            case SuspenseComponent:
                popSuspenseContext(workInProgress);
                var suspenseState = workInProgress.memoizedState;
                if (suspenseState !== null && suspenseState.dehydrated !== null) {
                    if (workInProgress.alternate === null) throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
                    resetHydrationState();
                }
                var _flags2 = workInProgress.flags;
                if (_flags2 & ShouldCapture) {
                    workInProgress.flags = _flags2 & ~ShouldCapture | DidCapture; // Captured a suspense effect. Re-render the boundary.
                    if ((workInProgress.mode & ProfileMode) !== NoMode) transferActualDuration(workInProgress);
                    return workInProgress;
                }
                return null;
            case SuspenseListComponent:
                popSuspenseContext(workInProgress); // SuspenseList doesn't actually catch anything. It should've been
                // caught by a nested boundary. If not, it should bubble through.
                return null;
            case HostPortal:
                popHostContainer(workInProgress);
                return null;
            case ContextProvider:
                var context = workInProgress.type._context;
                popProvider(context, workInProgress);
                return null;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(workInProgress);
                return null;
            case CacheComponent:
                return null;
            default:
                return null;
        }
    }
    function unwindInterruptedWork(current, interruptedWork, renderLanes) {
        // Note: This intentionally doesn't check if we're hydrating because comparing
        // to the current tree provider fiber is just as fast and less error-prone.
        // Ideally we would have a special version of the work loop only
        // for hydration.
        popTreeContext(interruptedWork);
        switch(interruptedWork.tag){
            case ClassComponent:
                var childContextTypes = interruptedWork.type.childContextTypes;
                if (childContextTypes !== null && childContextTypes !== undefined) popContext(interruptedWork);
                break;
            case HostRoot:
                var root = interruptedWork.stateNode;
                popHostContainer(interruptedWork);
                popTopLevelContextObject(interruptedWork);
                resetWorkInProgressVersions();
                break;
            case HostComponent:
                popHostContext(interruptedWork);
                break;
            case HostPortal:
                popHostContainer(interruptedWork);
                break;
            case SuspenseComponent:
                popSuspenseContext(interruptedWork);
                break;
            case SuspenseListComponent:
                popSuspenseContext(interruptedWork);
                break;
            case ContextProvider:
                var context = interruptedWork.type._context;
                popProvider(context, interruptedWork);
                break;
            case OffscreenComponent:
            case LegacyHiddenComponent:
                popRenderLanes(interruptedWork);
                break;
        }
    }
    var didWarnAboutUndefinedSnapshotBeforeUpdate = null;
    didWarnAboutUndefinedSnapshotBeforeUpdate = new Set();
    // Allows us to avoid traversing the return path to find the nearest Offscreen ancestor.
    // Only used when enableSuspenseLayoutEffectSemantics is enabled.
    var offscreenSubtreeIsHidden = false;
    var offscreenSubtreeWasHidden = false;
    var PossiblyWeakSet = typeof WeakSet === "function" ? WeakSet : Set;
    var nextEffect = null; // Used for Profiling builds to track updaters.
    var inProgressLanes = null;
    var inProgressRoot = null;
    function reportUncaughtErrorInDEV(error) {
        invokeGuardedCallback(null, function() {
            throw error;
        });
        clearCaughtError();
    }
    var callComponentWillUnmountWithTimer = function(current, instance) {
        instance.props = current.memoizedProps;
        instance.state = current.memoizedState;
        if (current.mode & ProfileMode) try {
            startLayoutEffectTimer();
            instance.componentWillUnmount();
        } finally{
            recordLayoutEffectDuration(current);
        }
        else instance.componentWillUnmount();
    }; // Capture errors so they don't interrupt mounting.
    function safelyCallCommitHookLayoutEffectListMount(current, nearestMountedAncestor) {
        try {
            commitHookEffectListMount(Layout, current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt unmounting.
    function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
        try {
            callComponentWillUnmountWithTimer(current, instance);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt mounting.
    function safelyCallComponentDidMount(current, nearestMountedAncestor, instance) {
        try {
            instance.componentDidMount();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    } // Capture errors so they don't interrupt mounting.
    function safelyAttachRef(current, nearestMountedAncestor) {
        try {
            commitAttachRef(current);
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    function safelyDetachRef(current, nearestMountedAncestor) {
        var ref = current.ref;
        if (ref !== null) {
            if (typeof ref === "function") {
                var retVal;
                try {
                    if (enableProfilerTimer && enableProfilerCommitHooks && current.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        retVal = ref(null);
                    } finally{
                        recordLayoutEffectDuration(current);
                    }
                    else retVal = ref(null);
                } catch (error) {
                    captureCommitPhaseError(current, nearestMountedAncestor, error);
                }
                if (typeof retVal === "function") error("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", getComponentNameFromFiber(current));
            } else ref.current = null;
        }
    }
    function safelyCallDestroy(current, nearestMountedAncestor, destroy) {
        try {
            destroy();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    var focusedInstanceHandle = null;
    var shouldFireAfterActiveInstanceBlur = false;
    function commitBeforeMutationEffects(root, firstChild) {
        focusedInstanceHandle = prepareForCommit(root.containerInfo);
        nextEffect = firstChild;
        commitBeforeMutationEffects_begin(); // We no longer need to track the active instance fiber
        var shouldFire = shouldFireAfterActiveInstanceBlur;
        shouldFireAfterActiveInstanceBlur = false;
        focusedInstanceHandle = null;
        return shouldFire;
    }
    function commitBeforeMutationEffects_begin() {
        while(nextEffect !== null){
            var fiber = nextEffect; // This phase is only used for beforeActiveInstanceBlur.
            var child = fiber.child;
            if ((fiber.subtreeFlags & BeforeMutationMask) !== NoFlags && child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitBeforeMutationEffects_complete();
        }
    }
    function commitBeforeMutationEffects_complete() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            setCurrentFiber(fiber);
            try {
                commitBeforeMutationEffectsOnFiber(fiber);
            } catch (error) {
                captureCommitPhaseError(fiber, fiber.return, error);
            }
            resetCurrentFiber();
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitBeforeMutationEffectsOnFiber(finishedWork) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags;
        if ((flags & Snapshot) !== NoFlags) {
            setCurrentFiber(finishedWork);
            switch(finishedWork.tag){
                case FunctionComponent:
                case ForwardRef:
                case SimpleMemoComponent:
                    break;
                case ClassComponent:
                    if (current !== null) {
                        var prevProps = current.memoizedProps;
                        var prevState = current.memoizedState;
                        var instance = finishedWork.stateNode; // We could update instance props and state here,
                        if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                            if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                            if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                        }
                        var snapshot = instance.getSnapshotBeforeUpdate(finishedWork.elementType === finishedWork.type ? prevProps : resolveDefaultProps(finishedWork.type, prevProps), prevState);
                        var didWarnSet = didWarnAboutUndefinedSnapshotBeforeUpdate;
                        if (snapshot === undefined && !didWarnSet.has(finishedWork.type)) {
                            didWarnSet.add(finishedWork.type);
                            error("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", getComponentNameFromFiber(finishedWork));
                        }
                        instance.__reactInternalSnapshotBeforeUpdate = snapshot;
                    }
                    break;
                case HostRoot:
                    var root = finishedWork.stateNode;
                    clearContainer(root.containerInfo);
                    break;
                case HostComponent:
                case HostText:
                case HostPortal:
                case IncompleteClassComponent:
                    break;
                default:
                    throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
            }
            resetCurrentFiber();
        }
    }
    function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & flags) === flags) {
                    // Unmount
                    var destroy = effect.destroy;
                    effect.destroy = undefined;
                    if (destroy !== undefined) {
                        if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectUnmountStarted(finishedWork);
                        else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectUnmountStarted(finishedWork);
                        if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(true);
                        safelyCallDestroy(finishedWork, nearestMountedAncestor, destroy);
                        if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(false);
                        if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectUnmountStopped();
                        else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectUnmountStopped();
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitHookEffectListMount(flags, finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        var lastEffect = updateQueue !== null ? updateQueue.lastEffect : null;
        if (lastEffect !== null) {
            var firstEffect = lastEffect.next;
            var effect = firstEffect;
            do {
                if ((effect.tag & flags) === flags) {
                    if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectMountStarted(finishedWork);
                    else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectMountStarted(finishedWork);
                    var create = effect.create;
                    if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(true);
                    effect.destroy = create();
                    if ((flags & Insertion) !== NoFlags$1) setIsRunningInsertionEffect(false);
                    if ((flags & Passive$1) !== NoFlags$1) markComponentPassiveEffectMountStopped();
                    else if ((flags & Layout) !== NoFlags$1) markComponentLayoutEffectMountStopped();
                    var destroy = effect.destroy;
                    if (destroy !== undefined && typeof destroy !== "function") {
                        var hookName = void 0;
                        if ((effect.tag & Layout) !== NoFlags) hookName = "useLayoutEffect";
                        else if ((effect.tag & Insertion) !== NoFlags) hookName = "useInsertionEffect";
                        else hookName = "useEffect";
                        var addendum = void 0;
                        if (destroy === null) addendum = " You returned null. If your effect does not require clean up, return undefined (or nothing).";
                        else if (typeof destroy.then === "function") addendum = "\n\nIt looks like you wrote " + hookName + "(async () => ...) or returned a Promise. " + "Instead, write the async function inside your effect " + "and call it immediately:\n\n" + hookName + "(() => {\n" + "  async function fetchData() {\n" + "    // You can await here\n" + "    const response = await MyAPI.getData(someId);\n" + "    // ...\n" + "  }\n" + "  fetchData();\n" + "}, [someId]); // Or [] if effect doesn't need props or state\n\n" + "Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching";
                        else addendum = " You returned: " + destroy;
                        error("%s must not return anything besides a function, which is used for clean-up.%s", hookName, addendum);
                    }
                }
                effect = effect.next;
            }while (effect !== firstEffect);
        }
    }
    function commitPassiveEffectDurations(finishedRoot, finishedWork) {
        // Only Profilers with work in their subtree will have an Update effect scheduled.
        if ((finishedWork.flags & Update) !== NoFlags) switch(finishedWork.tag){
            case Profiler:
                var passiveEffectDuration = finishedWork.stateNode.passiveEffectDuration;
                var _finishedWork$memoize = finishedWork.memoizedProps, id = _finishedWork$memoize.id, onPostCommit = _finishedWork$memoize.onPostCommit; // This value will still reflect the previous commit phase.
                // It does not get reset until the start of the next commit phase.
                var commitTime = getCommitTime();
                var phase = finishedWork.alternate === null ? "mount" : "update";
                if (isCurrentUpdateNested()) phase = "nested-update";
                if (typeof onPostCommit === "function") onPostCommit(id, phase, passiveEffectDuration, commitTime);
                 // Bubble times to the next nearest ancestor Profiler.
                // After we process that Profiler, we'll bubble further up.
                var parentFiber = finishedWork.return;
                outer: while(parentFiber !== null){
                    switch(parentFiber.tag){
                        case HostRoot:
                            var root = parentFiber.stateNode;
                            root.passiveEffectDuration += passiveEffectDuration;
                            break outer;
                        case Profiler:
                            var parentStateNode = parentFiber.stateNode;
                            parentStateNode.passiveEffectDuration += passiveEffectDuration;
                            break outer;
                    }
                    parentFiber = parentFiber.return;
                }
                break;
        }
    }
    function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork, committedLanes) {
        if ((finishedWork.flags & LayoutMask) !== NoFlags) switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (!offscreenSubtreeWasHidden) {
                    // At this point layout effects have already been destroyed (during mutation phase).
                    // This is done to prevent sibling component effects from interfering with each other,
                    // e.g. a destroy function in one component should never override a ref set
                    // by a create function in another component during the same commit.
                    if (finishedWork.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        commitHookEffectListMount(Layout | HasEffect, finishedWork);
                    } finally{
                        recordLayoutEffectDuration(finishedWork);
                    }
                    else commitHookEffectListMount(Layout | HasEffect, finishedWork);
                }
                break;
            case ClassComponent:
                var instance = finishedWork.stateNode;
                if (finishedWork.flags & Update) {
                    if (!offscreenSubtreeWasHidden) {
                        if (current === null) {
                            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                                if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                            }
                            if (finishedWork.mode & ProfileMode) try {
                                startLayoutEffectTimer();
                                instance.componentDidMount();
                            } finally{
                                recordLayoutEffectDuration(finishedWork);
                            }
                            else instance.componentDidMount();
                        } else {
                            var prevProps = finishedWork.elementType === finishedWork.type ? current.memoizedProps : resolveDefaultProps(finishedWork.type, current.memoizedProps);
                            var prevState = current.memoizedState; // We could update instance props and state here,
                            if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                                if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                                if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                            }
                            if (finishedWork.mode & ProfileMode) try {
                                startLayoutEffectTimer();
                                instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                            } finally{
                                recordLayoutEffectDuration(finishedWork);
                            }
                            else instance.componentDidUpdate(prevProps, prevState, instance.__reactInternalSnapshotBeforeUpdate);
                        }
                    }
                } // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var updateQueue = finishedWork.updateQueue;
                if (updateQueue !== null) {
                    if (finishedWork.type === finishedWork.elementType && !didWarnAboutReassigningProps) {
                        if (instance.props !== finishedWork.memoizedProps) error("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                        if (instance.state !== finishedWork.memoizedState) error("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", getComponentNameFromFiber(finishedWork) || "instance");
                    }
                    // but instead we rely on them being set during last render.
                    // TODO: revisit this when we implement resuming.
                    commitUpdateQueue(finishedWork, updateQueue, instance);
                }
                break;
            case HostRoot:
                // TODO: I think this is now always non-null by the time it reaches the
                // commit phase. Consider removing the type check.
                var _updateQueue = finishedWork.updateQueue;
                if (_updateQueue !== null) {
                    var _instance = null;
                    if (finishedWork.child !== null) switch(finishedWork.child.tag){
                        case HostComponent:
                            _instance = getPublicInstance(finishedWork.child.stateNode);
                            break;
                        case ClassComponent:
                            _instance = finishedWork.child.stateNode;
                            break;
                    }
                    commitUpdateQueue(finishedWork, _updateQueue, _instance);
                }
                break;
            case HostComponent:
                var _instance2 = finishedWork.stateNode; // Renderers may schedule work to be done after host components are mounted
                // (eg DOM renderer may schedule auto-focus for inputs and form controls).
                // These effects should only be committed when components are first mounted,
                // aka when there is no current/alternate.
                if (current === null && finishedWork.flags & Update) {
                    var type = finishedWork.type;
                    var props = finishedWork.memoizedProps;
                    commitMount(_instance2, type, props);
                }
                break;
            case HostText:
                break;
            case HostPortal:
                break;
            case Profiler:
                var _finishedWork$memoize2 = finishedWork.memoizedProps, onCommit = _finishedWork$memoize2.onCommit, onRender = _finishedWork$memoize2.onRender;
                var effectDuration = finishedWork.stateNode.effectDuration;
                var commitTime = getCommitTime();
                var phase = current === null ? "mount" : "update";
                if (isCurrentUpdateNested()) phase = "nested-update";
                if (typeof onRender === "function") onRender(finishedWork.memoizedProps.id, phase, finishedWork.actualDuration, finishedWork.treeBaseDuration, finishedWork.actualStartTime, commitTime);
                if (typeof onCommit === "function") onCommit(finishedWork.memoizedProps.id, phase, effectDuration, commitTime);
                 // Schedule a passive effect for this Profiler to call onPostCommit hooks.
                // This effect should be scheduled even if there is no onPostCommit callback for this Profiler,
                // because the effect is also where times bubble to parent Profilers.
                enqueuePendingPassiveProfilerEffect(finishedWork); // Propagate layout effect durations to the next nearest Profiler ancestor.
                // Do not reset these values until the next render so DevTools has a chance to read them first.
                var parentFiber = finishedWork.return;
                outer: while(parentFiber !== null){
                    switch(parentFiber.tag){
                        case HostRoot:
                            var root = parentFiber.stateNode;
                            root.effectDuration += effectDuration;
                            break outer;
                        case Profiler:
                            var parentStateNode = parentFiber.stateNode;
                            parentStateNode.effectDuration += effectDuration;
                            break outer;
                    }
                    parentFiber = parentFiber.return;
                }
                break;
            case SuspenseComponent:
                commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case SuspenseListComponent:
            case IncompleteClassComponent:
            case ScopeComponent:
            case OffscreenComponent:
            case LegacyHiddenComponent:
            case TracingMarkerComponent:
                break;
            default:
                throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
        }
        if (!offscreenSubtreeWasHidden) {
            if (finishedWork.flags & Ref) commitAttachRef(finishedWork);
        }
    }
    function reappearLayoutEffectsOnFiber(node) {
        // Turn on layout effects in a tree that previously disappeared.
        // TODO (Offscreen) Check: flags & LayoutStatic
        switch(node.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (node.mode & ProfileMode) try {
                    startLayoutEffectTimer();
                    safelyCallCommitHookLayoutEffectListMount(node, node.return);
                } finally{
                    recordLayoutEffectDuration(node);
                }
                else safelyCallCommitHookLayoutEffectListMount(node, node.return);
                break;
            case ClassComponent:
                var instance = node.stateNode;
                if (typeof instance.componentDidMount === "function") safelyCallComponentDidMount(node, node.return, instance);
                safelyAttachRef(node, node.return);
                break;
            case HostComponent:
                safelyAttachRef(node, node.return);
                break;
        }
    }
    function hideOrUnhideAllChildren(finishedWork, isHidden) {
        // Only hide or unhide the top-most host nodes.
        var hostSubtreeRoot = null;
        // We only have the top Fiber that was inserted but we need to recurse down its
        // children to find all the terminal nodes.
        var node = finishedWork;
        while(true){
            if (node.tag === HostComponent) {
                if (hostSubtreeRoot === null) {
                    hostSubtreeRoot = node;
                    try {
                        var instance = node.stateNode;
                        if (isHidden) hideInstance(instance);
                        else unhideInstance(node.stateNode, node.memoizedProps);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
            } else if (node.tag === HostText) {
                if (hostSubtreeRoot === null) try {
                    var _instance3 = node.stateNode;
                    if (isHidden) hideTextInstance(_instance3);
                    else unhideTextInstance(_instance3, node.memoizedProps);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else if ((node.tag === OffscreenComponent || node.tag === LegacyHiddenComponent) && node.memoizedState !== null && node !== finishedWork) ;
            else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === finishedWork) return;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return;
                if (hostSubtreeRoot === node) hostSubtreeRoot = null;
                node = node.return;
            }
            if (hostSubtreeRoot === node) hostSubtreeRoot = null;
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function commitAttachRef(finishedWork) {
        var ref = finishedWork.ref;
        if (ref !== null) {
            var instance = finishedWork.stateNode;
            var instanceToUse;
            switch(finishedWork.tag){
                case HostComponent:
                    instanceToUse = getPublicInstance(instance);
                    break;
                default:
                    instanceToUse = instance;
            } // Moved outside to ensure DCE works with this flag
            if (typeof ref === "function") {
                var retVal;
                if (finishedWork.mode & ProfileMode) try {
                    startLayoutEffectTimer();
                    retVal = ref(instanceToUse);
                } finally{
                    recordLayoutEffectDuration(finishedWork);
                }
                else retVal = ref(instanceToUse);
                if (typeof retVal === "function") error("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", getComponentNameFromFiber(finishedWork));
            } else {
                if (!ref.hasOwnProperty("current")) error("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", getComponentNameFromFiber(finishedWork));
                ref.current = instanceToUse;
            }
        }
    }
    function detachFiberMutation(fiber) {
        // Cut off the return pointer to disconnect it from the tree.
        // This enables us to detect and warn against state updates on an unmounted component.
        // It also prevents events from bubbling from within disconnected components.
        //
        // Ideally, we should also clear the child pointer of the parent alternate to let this
        // get GC:ed but we don't know which for sure which parent is the current
        // one so we'll settle for GC:ing the subtree of this child.
        // This child itself will be GC:ed when the parent updates the next time.
        //
        // Note that we can't clear child or sibling pointers yet.
        // They're needed for passive effects and for findDOMNode.
        // We defer those fields, and all other cleanup, to the passive phase (see detachFiberAfterEffects).
        //
        // Don't reset the alternate yet, either. We need that so we can detach the
        // alternate's fields in the passive phase. Clearing the return pointer is
        // sufficient for findDOMNode semantics.
        var alternate = fiber.alternate;
        if (alternate !== null) alternate.return = null;
        fiber.return = null;
    }
    function detachFiberAfterEffects(fiber) {
        var alternate = fiber.alternate;
        if (alternate !== null) {
            fiber.alternate = null;
            detachFiberAfterEffects(alternate);
        } // Note: Defensively using negation instead of < in case
        // Clear cyclical Fiber fields. This level alone is designed to roughly
        // approximate the planned Fiber refactor. In that world, `setState` will be
        // bound to a special "instance" object instead of a Fiber. The Instance
        // object will not have any of these fields. It will only be connected to
        // the fiber tree via a single link at the root. So if this level alone is
        // sufficient to fix memory issues, that bodes well for our plans.
        fiber.child = null;
        fiber.deletions = null;
        fiber.sibling = null; // The `stateNode` is cyclical because on host nodes it points to the host
        // tree, which has its own pointers to children, parents, and siblings.
        // The other host nodes also point back to fibers, so we should detach that
        // one, too.
        if (fiber.tag === HostComponent) {
            var hostInstance = fiber.stateNode;
            if (hostInstance !== null) detachDeletedInstance(hostInstance);
        }
        fiber.stateNode = null; // I'm intentionally not clearing the `return` field in this level. We
        fiber._debugOwner = null;
        // Theoretically, nothing in here should be necessary, because we already
        // disconnected the fiber from the tree. So even if something leaks this
        // particular fiber, it won't leak anything else
        //
        // The purpose of this branch is to be super aggressive so we can measure
        // if there's any difference in memory impact. If there is, that could
        // indicate a React leak we don't know about.
        fiber.return = null;
        fiber.dependencies = null;
        fiber.memoizedProps = null;
        fiber.memoizedState = null;
        fiber.pendingProps = null;
        fiber.stateNode = null; // TODO: Move to `commitPassiveUnmountInsideDeletedTreeOnFiber` instead.
        fiber.updateQueue = null;
    }
    function getHostParentFiber(fiber) {
        var parent = fiber.return;
        while(parent !== null){
            if (isHostParent(parent)) return parent;
            parent = parent.return;
        }
        throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
    }
    function isHostParent(fiber) {
        return fiber.tag === HostComponent || fiber.tag === HostRoot || fiber.tag === HostPortal;
    }
    function getHostSibling(fiber) {
        // We're going to search forward into the tree until we find a sibling host
        // node. Unfortunately, if multiple insertions are done in a row we have to
        // search past them. This leads to exponential search for the next sibling.
        // TODO: Find a more efficient way to do this.
        var node = fiber;
        siblings: while(true){
            // If we didn't find anything, let's try the next sibling.
            while(node.sibling === null){
                if (node.return === null || isHostParent(node.return)) // If we pop out of the root or hit the parent the fiber we are the
                // last sibling.
                return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
            while(node.tag !== HostComponent && node.tag !== HostText && node.tag !== DehydratedFragment){
                // If it is not host node and, we might have a host node inside it.
                // Try to search down until we find one.
                if (node.flags & Placement) continue siblings;
                 // If we don't have a child, try the siblings instead.
                // We also skip portals because they are not part of this host tree.
                if (node.child === null || node.tag === HostPortal) continue siblings;
                else {
                    node.child.return = node;
                    node = node.child;
                }
            } // Check if this host node is stable or about to be placed.
            if (!(node.flags & Placement)) // Found it!
            return node.stateNode;
        }
    }
    function commitPlacement(finishedWork) {
        var parentFiber = getHostParentFiber(finishedWork); // Note: these two variables *must* always be updated together.
        switch(parentFiber.tag){
            case HostComponent:
                var parent = parentFiber.stateNode;
                if (parentFiber.flags & ContentReset) {
                    // Reset the text content of the parent before doing any insertions
                    resetTextContent(parent); // Clear ContentReset from the effect tag
                    parentFiber.flags &= ~ContentReset;
                }
                var before = getHostSibling(finishedWork); // We only have the top Fiber that was inserted but we need to recurse down its
                // children to find all the terminal nodes.
                insertOrAppendPlacementNode(finishedWork, before, parent);
                break;
            case HostRoot:
            case HostPortal:
                var _parent = parentFiber.stateNode.containerInfo;
                var _before = getHostSibling(finishedWork);
                insertOrAppendPlacementNodeIntoContainer(finishedWork, _before, _parent);
                break;
            // eslint-disable-next-line-no-fallthrough
            default:
                throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
        }
    }
    function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost) {
            var stateNode = node.stateNode;
            if (before) insertInContainerBefore(parent, stateNode, before);
            else appendChildToContainer(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNodeIntoContainer(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNodeIntoContainer(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    }
    function insertOrAppendPlacementNode(node, before, parent) {
        var tag = node.tag;
        var isHost = tag === HostComponent || tag === HostText;
        if (isHost) {
            var stateNode = node.stateNode;
            if (before) insertBefore(parent, stateNode, before);
            else appendChild(parent, stateNode);
        } else if (tag === HostPortal) ;
        else {
            var child = node.child;
            if (child !== null) {
                insertOrAppendPlacementNode(child, before, parent);
                var sibling = child.sibling;
                while(sibling !== null){
                    insertOrAppendPlacementNode(sibling, before, parent);
                    sibling = sibling.sibling;
                }
            }
        }
    } // These are tracked on the stack as we recursively traverse a
    // deleted subtree.
    // TODO: Update these during the whole mutation phase, not just during
    // a deletion.
    var hostParent = null;
    var hostParentIsContainer = false;
    function commitDeletionEffects(root, returnFiber, deletedFiber) {
        // We only have the top Fiber that was deleted but we need to recurse down its
        // children to find all the terminal nodes.
        // Recursively delete all host nodes from the parent, detach refs, clean
        // up mounted layout effects, and call componentWillUnmount.
        // We only need to remove the topmost host child in each branch. But then we
        // still need to keep traversing to unmount effects, refs, and cWU. TODO: We
        // could split this into two separate traversals functions, where the second
        // one doesn't include any removeChild logic. This is maybe the same
        // function as "disappearLayoutEffects" (or whatever that turns into after
        // the layout phase is refactored to use recursion).
        // Before starting, find the nearest host parent on the stack so we know
        // which instance/container to remove the children from.
        // TODO: Instead of searching up the fiber return path on every deletion, we
        // can track the nearest host component on the JS stack as we traverse the
        // tree during the commit phase. This would make insertions faster, too.
        var parent = returnFiber;
        findParent: while(parent !== null){
            switch(parent.tag){
                case HostComponent:
                    hostParent = parent.stateNode;
                    hostParentIsContainer = false;
                    break findParent;
                case HostRoot:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = true;
                    break findParent;
                case HostPortal:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = true;
                    break findParent;
            }
            parent = parent.return;
        }
        if (hostParent === null) throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
        commitDeletionEffectsOnFiber(root, returnFiber, deletedFiber);
        hostParent = null;
        hostParentIsContainer = false;
        detachFiberMutation(deletedFiber);
    }
    function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
        // TODO: Use a static flag to skip trees that don't have unmount effects
        var child = parent.child;
        while(child !== null){
            commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, child);
            child = child.sibling;
        }
    }
    function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
        onCommitUnmount(deletedFiber); // The cases in this outer switch modify the stack before they traverse
        // into their subtree. There are simpler cases in the inner switch
        // that don't modify the stack.
        switch(deletedFiber.tag){
            case HostComponent:
                if (!offscreenSubtreeWasHidden) safelyDetachRef(deletedFiber, nearestMountedAncestor);
                 // Intentional fallthrough to next branch
            // eslint-disable-next-line-no-fallthrough
            case HostText:
                var prevHostParent = hostParent;
                var prevHostParentIsContainer = hostParentIsContainer;
                hostParent = null;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = prevHostParent;
                hostParentIsContainer = prevHostParentIsContainer;
                if (hostParent !== null) {
                    // Now that all the child effects have unmounted, we can remove the
                    // node from the tree.
                    if (hostParentIsContainer) removeChildFromContainer(hostParent, deletedFiber.stateNode);
                    else removeChild(hostParent, deletedFiber.stateNode);
                }
                return;
            case DehydratedFragment:
                if (hostParent !== null) {
                    if (hostParentIsContainer) clearSuspenseBoundaryFromContainer(hostParent, deletedFiber.stateNode);
                    else clearSuspenseBoundary(hostParent, deletedFiber.stateNode);
                }
                return;
            case HostPortal:
                // When we go into a portal, it becomes the parent to remove from.
                var _prevHostParent = hostParent;
                var _prevHostParentIsContainer = hostParentIsContainer;
                hostParent = deletedFiber.stateNode.containerInfo;
                hostParentIsContainer = true;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                hostParent = _prevHostParent;
                hostParentIsContainer = _prevHostParentIsContainer;
                return;
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
                if (!offscreenSubtreeWasHidden) {
                    var updateQueue = deletedFiber.updateQueue;
                    if (updateQueue !== null) {
                        var lastEffect = updateQueue.lastEffect;
                        if (lastEffect !== null) {
                            var firstEffect = lastEffect.next;
                            var effect = firstEffect;
                            do {
                                var _effect = effect, destroy = _effect.destroy, tag = _effect.tag;
                                if (destroy !== undefined) {
                                    if ((tag & Insertion) !== NoFlags$1) safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                    else if ((tag & Layout) !== NoFlags$1) {
                                        markComponentLayoutEffectUnmountStarted(deletedFiber);
                                        if (deletedFiber.mode & ProfileMode) {
                                            startLayoutEffectTimer();
                                            safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                            recordLayoutEffectDuration(deletedFiber);
                                        } else safelyCallDestroy(deletedFiber, nearestMountedAncestor, destroy);
                                        markComponentLayoutEffectUnmountStopped();
                                    }
                                }
                                effect = effect.next;
                            }while (effect !== firstEffect);
                        }
                    }
                }
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case ClassComponent:
                if (!offscreenSubtreeWasHidden) {
                    safelyDetachRef(deletedFiber, nearestMountedAncestor);
                    var instance = deletedFiber.stateNode;
                    if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, instance);
                }
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case ScopeComponent:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
            case OffscreenComponent:
                if (deletedFiber.mode & ConcurrentMode) {
                    // If this offscreen component is hidden, we already unmounted it. Before
                    // deleting the children, track that it's already unmounted so that we
                    // don't attempt to unmount the effects again.
                    // TODO: If the tree is hidden, in most cases we should be able to skip
                    // over the nested children entirely. An exception is we haven't yet found
                    // the topmost host node to delete, which we already track on the stack.
                    // But the other case is portals, which need to be detached no matter how
                    // deeply they are nested. We should use a subtree flag to track whether a
                    // subtree includes a nested portal.
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || deletedFiber.memoizedState !== null;
                    recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                } else recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            default:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                return;
        }
    }
    function commitSuspenseCallback(finishedWork) {
        // TODO: Move this to passive phase
        var newState = finishedWork.memoizedState;
    }
    function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        var newState = finishedWork.memoizedState;
        if (newState === null) {
            var current = finishedWork.alternate;
            if (current !== null) {
                var prevState = current.memoizedState;
                if (prevState !== null) {
                    var suspenseInstance = prevState.dehydrated;
                    if (suspenseInstance !== null) commitHydratedSuspenseInstance(suspenseInstance);
                }
            }
        }
    }
    function attachSuspenseRetryListeners(finishedWork) {
        // If this boundary just timed out, then it will have a set of wakeables.
        // For each wakeable, attach a listener so that when it resolves, React
        // attempts to re-render the boundary in the primary (pre-timeout) state.
        var wakeables = finishedWork.updateQueue;
        if (wakeables !== null) {
            finishedWork.updateQueue = null;
            var retryCache = finishedWork.stateNode;
            if (retryCache === null) retryCache = finishedWork.stateNode = new PossiblyWeakSet();
            wakeables.forEach(function(wakeable) {
                // Memoize using the boundary fiber to prevent redundant listeners.
                var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
                if (!retryCache.has(wakeable)) {
                    retryCache.add(wakeable);
                    if (isDevToolsPresent) {
                        if (inProgressLanes !== null && inProgressRoot !== null) // If we have pending work still, associate the original updaters with it.
                        restorePendingUpdaters(inProgressRoot, inProgressLanes);
                        else throw Error("Expected finished root and lanes to be set. This is a bug in React.");
                    }
                    wakeable.then(retry, retry);
                }
            });
        }
    } // This function detects when a Suspense boundary goes from visible to hidden.
    function commitMutationEffects(root, finishedWork, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        setCurrentFiber(finishedWork);
        commitMutationEffectsOnFiber(finishedWork, root);
        setCurrentFiber(finishedWork);
        inProgressLanes = null;
        inProgressRoot = null;
    }
    function recursivelyTraverseMutationEffects(root, parentFiber, lanes) {
        // Deletions effects can be scheduled on any fiber type. They need to happen
        // before the children effects hae fired.
        var deletions = parentFiber.deletions;
        if (deletions !== null) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            try {
                commitDeletionEffects(root, parentFiber, childToDelete);
            } catch (error) {
                captureCommitPhaseError(childToDelete, parentFiber, error);
            }
        }
        var prevDebugFiber = getCurrentFiber();
        if (parentFiber.subtreeFlags & MutationMask) {
            var child = parentFiber.child;
            while(child !== null){
                setCurrentFiber(child);
                commitMutationEffectsOnFiber(child, root);
                child = child.sibling;
            }
        }
        setCurrentFiber(prevDebugFiber);
    }
    function commitMutationEffectsOnFiber(finishedWork, root, lanes) {
        var current = finishedWork.alternate;
        var flags = finishedWork.flags; // The effect flag should be checked *after* we refine the type of fiber,
        // because the fiber tag is more specific. An exception is any flag related
        // to reconcilation, because those can be set on all fiber types.
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case MemoComponent:
            case SimpleMemoComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    try {
                        commitHookEffectListUnmount(Insertion | HasEffect, finishedWork, finishedWork.return);
                        commitHookEffectListMount(Insertion | HasEffect, finishedWork);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    } // Layout effects are destroyed during the mutation phase so that all
                    // destroy functions for all fibers are called before any create functions.
                    // This prevents sibling component effects from interfering with each other,
                    // e.g. a destroy function in one component should never override a ref set
                    // by a create function in another component during the same commit.
                    if (finishedWork.mode & ProfileMode) {
                        try {
                            startLayoutEffectTimer();
                            commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork.return);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                        recordLayoutEffectDuration(finishedWork);
                    } else try {
                        commitHookEffectListUnmount(Layout | HasEffect, finishedWork, finishedWork.return);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                return;
            case ClassComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Ref) {
                    if (current !== null) safelyDetachRef(current, current.return);
                }
                return;
            case HostComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Ref) {
                    if (current !== null) safelyDetachRef(current, current.return);
                }
                // TODO: ContentReset gets cleared by the children during the commit
                // phase. This is a refactor hazard because it means we must read
                // flags the flags after `commitReconciliationEffects` has already run;
                // the order matters. We should refactor so that ContentReset does not
                // rely on mutating the flag during commit. Like by setting a flag
                // during the render phase instead.
                if (finishedWork.flags & ContentReset) {
                    var instance = finishedWork.stateNode;
                    try {
                        resetTextContent(instance);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                if (flags & Update) {
                    var _instance4 = finishedWork.stateNode;
                    if (_instance4 != null) {
                        // Commit the work prepared earlier.
                        var newProps = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                        // as the newProps. The updatePayload will contain the real change in
                        // this case.
                        var oldProps = current !== null ? current.memoizedProps : newProps;
                        var type = finishedWork.type; // TODO: Type the updateQueue to be specific to host components.
                        var updatePayload = finishedWork.updateQueue;
                        finishedWork.updateQueue = null;
                        if (updatePayload !== null) try {
                            commitUpdate(_instance4, updatePayload, type, oldProps, newProps, finishedWork);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                return;
            case HostText:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    if (finishedWork.stateNode === null) throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
                    var textInstance = finishedWork.stateNode;
                    var newText = finishedWork.memoizedProps; // For hydration we reuse the update path but we treat the oldProps
                    // as the newProps. The updatePayload will contain the real change in
                    // this case.
                    var oldText = current !== null ? current.memoizedProps : newText;
                    try {
                        commitTextUpdate(textInstance, oldText, newText);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                return;
            case HostRoot:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) {
                    if (current !== null) {
                        var prevRootState = current.memoizedState;
                        if (prevRootState.isDehydrated) try {
                            commitHydratedContainer(root.containerInfo);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                return;
            case HostPortal:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                return;
            case SuspenseComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                var offscreenFiber = finishedWork.child;
                if (offscreenFiber.flags & Visibility) {
                    var offscreenInstance = offscreenFiber.stateNode;
                    var newState = offscreenFiber.memoizedState;
                    var isHidden = newState !== null; // Track the current state on the Offscreen instance so we can
                    // read it during an event
                    offscreenInstance.isHidden = isHidden;
                    if (isHidden) {
                        var wasHidden = offscreenFiber.alternate !== null && offscreenFiber.alternate.memoizedState !== null;
                        if (!wasHidden) // TODO: Move to passive phase
                        markCommitTimeOfFallback();
                    }
                }
                if (flags & Update) {
                    try {
                        commitSuspenseCallback(finishedWork);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                    attachSuspenseRetryListeners(finishedWork);
                }
                return;
            case OffscreenComponent:
                var _wasHidden = current !== null && current.memoizedState !== null;
                if (finishedWork.mode & ConcurrentMode) {
                    // Before committing the children, track on the stack whether this
                    // offscreen subtree was already hidden, so that we don't unmount the
                    // effects again.
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _wasHidden;
                    recursivelyTraverseMutationEffects(root, finishedWork);
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                } else recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Visibility) {
                    var _offscreenInstance = finishedWork.stateNode;
                    var _newState = finishedWork.memoizedState;
                    var _isHidden = _newState !== null;
                    var offscreenBoundary = finishedWork; // Track the current state on the Offscreen instance so we can
                    // read it during an event
                    _offscreenInstance.isHidden = _isHidden;
                    if (_isHidden) {
                        if (!_wasHidden) {
                            if ((offscreenBoundary.mode & ConcurrentMode) !== NoMode) {
                                nextEffect = offscreenBoundary;
                                var offscreenChild = offscreenBoundary.child;
                                while(offscreenChild !== null){
                                    nextEffect = offscreenChild;
                                    disappearLayoutEffects_begin(offscreenChild);
                                    offscreenChild = offscreenChild.sibling;
                                }
                            }
                        }
                    }
                    // TODO: This needs to run whenever there's an insertion or update
                    // inside a hidden Offscreen tree.
                    hideOrUnhideAllChildren(offscreenBoundary, _isHidden);
                }
                return;
            case SuspenseListComponent:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & Update) attachSuspenseRetryListeners(finishedWork);
                return;
            case ScopeComponent:
                return;
            default:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                return;
        }
    }
    function commitReconciliationEffects(finishedWork) {
        // Placement effects (insertions, reorders) can be scheduled on any fiber
        // type. They needs to happen after the children effects have fired, but
        // before the effects on this fiber have fired.
        var flags = finishedWork.flags;
        if (flags & Placement) {
            try {
                commitPlacement(finishedWork);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            } // Clear the "placement" from effect tag so that we know that this is
            // inserted, before any life-cycles like componentDidMount gets called.
            // TODO: findDOMNode doesn't rely on this any more but isMounted does
            // and isMounted is deprecated anyway so we should be able to kill this.
            finishedWork.flags &= ~Placement;
        }
        if (flags & Hydrating) finishedWork.flags &= ~Hydrating;
    }
    function commitLayoutEffects(finishedWork, root, committedLanes) {
        inProgressLanes = committedLanes;
        inProgressRoot = root;
        nextEffect = finishedWork;
        commitLayoutEffects_begin(finishedWork, root, committedLanes);
        inProgressLanes = null;
        inProgressRoot = null;
    }
    function commitLayoutEffects_begin(subtreeRoot, root, committedLanes) {
        // Suspense layout effects semantics don't change for legacy roots.
        var isModernRoot = (subtreeRoot.mode & ConcurrentMode) !== NoMode;
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if (fiber.tag === OffscreenComponent && isModernRoot) {
                // Keep track of the current Offscreen stack's state.
                var isHidden = fiber.memoizedState !== null;
                var newOffscreenSubtreeIsHidden = isHidden || offscreenSubtreeIsHidden;
                if (newOffscreenSubtreeIsHidden) {
                    // The Offscreen tree is hidden. Skip over its layout effects.
                    commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
                    continue;
                } else {
                    // TODO (Offscreen) Also check: subtreeFlags & LayoutMask
                    var current = fiber.alternate;
                    var wasHidden = current !== null && current.memoizedState !== null;
                    var newOffscreenSubtreeWasHidden = wasHidden || offscreenSubtreeWasHidden;
                    var prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden;
                    var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden; // Traverse the Offscreen subtree with the current Offscreen as the root.
                    offscreenSubtreeIsHidden = newOffscreenSubtreeIsHidden;
                    offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden;
                    if (offscreenSubtreeWasHidden && !prevOffscreenSubtreeWasHidden) {
                        // This is the root of a reappearing boundary. Turn its layout effects
                        // back on.
                        nextEffect = fiber;
                        reappearLayoutEffects_begin(fiber);
                    }
                    var child = firstChild;
                    while(child !== null){
                        nextEffect = child;
                        commitLayoutEffects_begin(child, root, committedLanes);
                        child = child.sibling;
                    } // Restore Offscreen state and resume in our-progress traversal.
                    nextEffect = fiber;
                    offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                    commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
                    continue;
                }
            }
            if ((fiber.subtreeFlags & LayoutMask) !== NoFlags && firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes);
        }
    }
    function commitLayoutMountEffects_complete(subtreeRoot, root, committedLanes) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & LayoutMask) !== NoFlags) {
                var current = fiber.alternate;
                setCurrentFiber(fiber);
                try {
                    commitLayoutEffectOnFiber(root, current, fiber, committedLanes);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                resetCurrentFiber();
            }
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function disappearLayoutEffects_begin(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child; // TODO (Offscreen) Check: flags & (RefStatic | LayoutStatic)
            switch(fiber.tag){
                case FunctionComponent:
                case ForwardRef:
                case MemoComponent:
                case SimpleMemoComponent:
                    if (fiber.mode & ProfileMode) try {
                        startLayoutEffectTimer();
                        commitHookEffectListUnmount(Layout, fiber, fiber.return);
                    } finally{
                        recordLayoutEffectDuration(fiber);
                    }
                    else commitHookEffectListUnmount(Layout, fiber, fiber.return);
                    break;
                case ClassComponent:
                    // TODO (Offscreen) Check: flags & RefStatic
                    safelyDetachRef(fiber, fiber.return);
                    var instance = fiber.stateNode;
                    if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(fiber, fiber.return, instance);
                    break;
                case HostComponent:
                    safelyDetachRef(fiber, fiber.return);
                    break;
                case OffscreenComponent:
                    // Check if this is a
                    var isHidden = fiber.memoizedState !== null;
                    if (isHidden) {
                        // Nested Offscreen tree is already hidden. Don't disappear
                        // its effects.
                        disappearLayoutEffects_complete(subtreeRoot);
                        continue;
                    }
                    break;
            } // TODO (Offscreen) Check: subtreeFlags & LayoutStatic
            if (firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else disappearLayoutEffects_complete(subtreeRoot);
        }
    }
    function disappearLayoutEffects_complete(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function reappearLayoutEffects_begin(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if (fiber.tag === OffscreenComponent) {
                var isHidden = fiber.memoizedState !== null;
                if (isHidden) {
                    // Nested Offscreen tree is still hidden. Don't re-appear its effects.
                    reappearLayoutEffects_complete(subtreeRoot);
                    continue;
                }
            } // TODO (Offscreen) Check: subtreeFlags & LayoutStatic
            if (firstChild !== null) {
                // This node may have been reused from a previous render, so we can't
                // assume its return pointer is correct.
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else reappearLayoutEffects_complete(subtreeRoot);
        }
    }
    function reappearLayoutEffects_complete(subtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect; // TODO (Offscreen) Check: flags & LayoutStatic
            setCurrentFiber(fiber);
            try {
                reappearLayoutEffectsOnFiber(fiber);
            } catch (error) {
                captureCommitPhaseError(fiber, fiber.return, error);
            }
            resetCurrentFiber();
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                // This node may have been reused from a previous render, so we can't
                // assume its return pointer is correct.
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveMountEffects(root, finishedWork, committedLanes, committedTransitions) {
        nextEffect = finishedWork;
        commitPassiveMountEffects_begin(finishedWork, root, committedLanes, committedTransitions);
    }
    function commitPassiveMountEffects_begin(subtreeRoot, root, committedLanes, committedTransitions) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var firstChild = fiber.child;
            if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && firstChild !== null) {
                firstChild.return = fiber;
                nextEffect = firstChild;
            } else commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions);
        }
    }
    function commitPassiveMountEffects_complete(subtreeRoot, root, committedLanes, committedTransitions) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & Passive) !== NoFlags) {
                setCurrentFiber(fiber);
                try {
                    commitPassiveMountOnFiber(root, fiber, committedLanes, committedTransitions);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                resetCurrentFiber();
            }
            if (fiber === subtreeRoot) {
                nextEffect = null;
                return;
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (finishedWork.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    try {
                        commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                    } finally{
                        recordPassiveEffectDuration(finishedWork);
                    }
                } else commitHookEffectListMount(Passive$1 | HasEffect, finishedWork);
                break;
        }
    }
    function commitPassiveUnmountEffects(firstChild) {
        nextEffect = firstChild;
        commitPassiveUnmountEffects_begin();
    }
    function commitPassiveUnmountEffects_begin() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var child = fiber.child;
            if ((nextEffect.flags & ChildDeletion) !== NoFlags) {
                var deletions = fiber.deletions;
                if (deletions !== null) {
                    for(var i = 0; i < deletions.length; i++){
                        var fiberToDelete = deletions[i];
                        nextEffect = fiberToDelete;
                        commitPassiveUnmountEffectsInsideOfDeletedTree_begin(fiberToDelete, fiber);
                    }
                    // A fiber was deleted from this parent fiber, but it's still part of
                    // the previous (alternate) parent fiber's list of children. Because
                    // children are a linked list, an earlier sibling that's still alive
                    // will be connected to the deleted fiber via its `alternate`:
                    //
                    //   live fiber
                    //   --alternate--> previous live fiber
                    //   --sibling--> deleted fiber
                    //
                    // We can't disconnect `alternate` on nodes that haven't been deleted
                    // yet, but we can disconnect the `sibling` and `child` pointers.
                    var previousFiber = fiber.alternate;
                    if (previousFiber !== null) {
                        var detachedChild = previousFiber.child;
                        if (detachedChild !== null) {
                            previousFiber.child = null;
                            do {
                                var detachedSibling = detachedChild.sibling;
                                detachedChild.sibling = null;
                                detachedChild = detachedSibling;
                            }while (detachedChild !== null);
                        }
                    }
                    nextEffect = fiber;
                }
            }
            if ((fiber.subtreeFlags & PassiveMask) !== NoFlags && child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitPassiveUnmountEffects_complete();
        }
    }
    function commitPassiveUnmountEffects_complete() {
        while(nextEffect !== null){
            var fiber = nextEffect;
            if ((fiber.flags & Passive) !== NoFlags) {
                setCurrentFiber(fiber);
                commitPassiveUnmountOnFiber(fiber);
                resetCurrentFiber();
            }
            var sibling = fiber.sibling;
            if (sibling !== null) {
                sibling.return = fiber.return;
                nextEffect = sibling;
                return;
            }
            nextEffect = fiber.return;
        }
    }
    function commitPassiveUnmountOnFiber(finishedWork) {
        switch(finishedWork.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (finishedWork.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork.return);
                    recordPassiveEffectDuration(finishedWork);
                } else commitHookEffectListUnmount(Passive$1 | HasEffect, finishedWork, finishedWork.return);
                break;
        }
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
        while(nextEffect !== null){
            var fiber = nextEffect; // Deletion effects fire in parent -> child order
            // TODO: Check if fiber has a PassiveStatic flag
            setCurrentFiber(fiber);
            commitPassiveUnmountInsideDeletedTreeOnFiber(fiber, nearestMountedAncestor);
            resetCurrentFiber();
            var child = fiber.child; // TODO: Only traverse subtree if it has a PassiveStatic flag. (But, if we
            // do this, still need to handle `deletedTreeCleanUpLevel` correctly.)
            if (child !== null) {
                child.return = fiber;
                nextEffect = child;
            } else commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot);
        }
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_complete(deletedSubtreeRoot) {
        while(nextEffect !== null){
            var fiber = nextEffect;
            var sibling = fiber.sibling;
            var returnFiber = fiber.return;
            // Recursively traverse the entire deleted tree and clean up fiber fields.
            // This is more aggressive than ideal, and the long term goal is to only
            // have to detach the deleted tree at the root.
            detachFiberAfterEffects(fiber);
            if (fiber === deletedSubtreeRoot) {
                nextEffect = null;
                return;
            }
            if (sibling !== null) {
                sibling.return = returnFiber;
                nextEffect = sibling;
                return;
            }
            nextEffect = returnFiber;
        }
    }
    function commitPassiveUnmountInsideDeletedTreeOnFiber(current, nearestMountedAncestor) {
        switch(current.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                if (current.mode & ProfileMode) {
                    startPassiveEffectTimer();
                    commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
                    recordPassiveEffectDuration(current);
                } else commitHookEffectListUnmount(Passive$1, current, nearestMountedAncestor);
                break;
        }
    } // TODO: Reuse reappearLayoutEffects traversal here?
    function invokeLayoutEffectMountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListMount(Layout | HasEffect, fiber);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case ClassComponent:
                var instance = fiber.stateNode;
                try {
                    instance.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
        }
    }
    function invokePassiveEffectMountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListMount(Passive$1 | HasEffect, fiber);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
        }
    }
    function invokeLayoutEffectUnmountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListUnmount(Layout | HasEffect, fiber, fiber.return);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
                break;
            case ClassComponent:
                var instance = fiber.stateNode;
                if (typeof instance.componentWillUnmount === "function") safelyCallComponentWillUnmount(fiber, fiber.return, instance);
                break;
        }
    }
    function invokePassiveEffectUnmountInDEV(fiber) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                try {
                    commitHookEffectListUnmount(Passive$1 | HasEffect, fiber, fiber.return);
                } catch (error) {
                    captureCommitPhaseError(fiber, fiber.return, error);
                }
        }
    }
    var COMPONENT_TYPE = 0;
    var HAS_PSEUDO_CLASS_TYPE = 1;
    var ROLE_TYPE = 2;
    var TEST_NAME_TYPE = 3;
    var TEXT_TYPE = 4;
    if (typeof Symbol === "function" && Symbol.for) {
        var symbolFor = Symbol.for;
        COMPONENT_TYPE = symbolFor("selector.component");
        HAS_PSEUDO_CLASS_TYPE = symbolFor("selector.has_pseudo_class");
        ROLE_TYPE = symbolFor("selector.role");
        TEST_NAME_TYPE = symbolFor("selector.test_id");
        TEXT_TYPE = symbolFor("selector.text");
    }
    var commitHooks = [];
    function onCommitRoot$1() {
        commitHooks.forEach(function(commitHook) {
            return commitHook();
        });
    }
    var ReactCurrentActQueue = ReactSharedInternals.ReactCurrentActQueue;
    function isLegacyActEnvironment(fiber) {
        // Legacy mode. We preserve the behavior of React 17's act. It assumes an
        // act environment whenever `jest` is defined, but you can still turn off
        // spurious warnings by setting IS_REACT_ACT_ENVIRONMENT explicitly
        // to false.
        var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== "undefined" ? IS_REACT_ACT_ENVIRONMENT : undefined; // $FlowExpectedError - Flow doesn't know about jest
        var jestIsDefined = typeof jest !== "undefined";
        return jestIsDefined && isReactActEnvironmentGlobal !== false;
    }
    function isConcurrentActEnvironment() {
        var isReactActEnvironmentGlobal = typeof IS_REACT_ACT_ENVIRONMENT !== "undefined" ? IS_REACT_ACT_ENVIRONMENT : undefined;
        if (!isReactActEnvironmentGlobal && ReactCurrentActQueue.current !== null) // TODO: Include link to relevant documentation page.
        error("The current testing environment is not configured to support act(...)");
        return isReactActEnvironmentGlobal;
    }
    var ceil = Math.ceil;
    var ReactCurrentDispatcher$2 = ReactSharedInternals.ReactCurrentDispatcher, ReactCurrentOwner$2 = ReactSharedInternals.ReactCurrentOwner, ReactCurrentBatchConfig$3 = ReactSharedInternals.ReactCurrentBatchConfig, ReactCurrentActQueue$1 = ReactSharedInternals.ReactCurrentActQueue;
    var NoContext = /*             */ 0;
    var BatchedContext = /*               */ 1;
    var RenderContext = /*                */ 2;
    var CommitContext = /*                */ 4;
    var RootInProgress = 0;
    var RootFatalErrored = 1;
    var RootErrored = 2;
    var RootSuspended = 3;
    var RootSuspendedWithDelay = 4;
    var RootCompleted = 5;
    var RootDidNotComplete = 6; // Describes where we are in the React execution stack
    var executionContext = NoContext; // The root we're working on
    var workInProgressRoot = null; // The fiber we're working on
    var workInProgress = null; // The lanes we're rendering
    var workInProgressRootRenderLanes = NoLanes; // Stack that allows components to change the render lanes for its subtree
    // This is a superset of the lanes we started working on at the root. The only
    // case where it's different from `workInProgressRootRenderLanes` is when we
    // enter a subtree that is hidden and needs to be unhidden: Suspense and
    // Offscreen component.
    //
    // Most things in the work loop should deal with workInProgressRootRenderLanes.
    // Most things in begin/complete phases should deal with subtreeRenderLanes.
    var subtreeRenderLanes = NoLanes;
    var subtreeRenderLanesCursor = createCursor(NoLanes); // Whether to root completed, errored, suspended, etc.
    var workInProgressRootExitStatus = RootInProgress; // A fatal error, if one is thrown
    var workInProgressRootFatalError = null; // "Included" lanes refer to lanes that were worked on during this render. It's
    // slightly different than `renderLanes` because `renderLanes` can change as you
    // enter and exit an Offscreen tree. This value is the combination of all render
    // lanes for the entire render phase.
    var workInProgressRootIncludedLanes = NoLanes; // The work left over by components that were visited during this render. Only
    // includes unprocessed updates, not work in bailed out children.
    var workInProgressRootSkippedLanes = NoLanes; // Lanes that were updated (in an interleaved event) during this render.
    var workInProgressRootInterleavedUpdatedLanes = NoLanes; // Lanes that were updated during the render phase (*not* an interleaved event).
    var workInProgressRootPingedLanes = NoLanes; // Errors that are thrown during the render phase.
    var workInProgressRootConcurrentErrors = null; // These are errors that we recovered from without surfacing them to the UI.
    // We will log them once the tree commits.
    var workInProgressRootRecoverableErrors = null; // The most recent time we committed a fallback. This lets us ensure a train
    // model where we don't commit new loading states in too quick succession.
    var globalMostRecentFallbackTime = 0;
    var FALLBACK_THROTTLE_MS = 500; // The absolute time for when we should start giving up on rendering
    // more and prefer CPU suspense heuristics instead.
    var workInProgressRootRenderTargetTime = Infinity; // How long a render is supposed to take before we start following CPU
    // suspense heuristics and opt out of rendering more content.
    var RENDER_TIMEOUT_MS = 500;
    var workInProgressTransitions = null;
    function resetRenderTimer() {
        workInProgressRootRenderTargetTime = now() + RENDER_TIMEOUT_MS;
    }
    function getRenderTargetTime() {
        return workInProgressRootRenderTargetTime;
    }
    var hasUncaughtError = false;
    var firstUncaughtError = null;
    var legacyErrorBoundariesThatAlreadyFailed = null; // Only used when enableProfilerNestedUpdateScheduledHook is true;
    var rootDoesHavePassiveEffects = false;
    var rootWithPendingPassiveEffects = null;
    var pendingPassiveEffectsLanes = NoLanes;
    var pendingPassiveProfilerEffects = [];
    var pendingPassiveTransitions = null; // Use these to prevent an infinite loop of nested updates
    var NESTED_UPDATE_LIMIT = 50;
    var nestedUpdateCount = 0;
    var rootWithNestedUpdates = null;
    var isFlushingPassiveEffects = false;
    var didScheduleUpdateDuringPassiveEffects = false;
    var NESTED_PASSIVE_UPDATE_LIMIT = 50;
    var nestedPassiveUpdateCount = 0;
    var rootWithPassiveNestedUpdates = null; // If two updates are scheduled within the same event, we should treat their
    // event times as simultaneous, even if the actual clock time has advanced
    // between the first and second call.
    var currentEventTime = NoTimestamp;
    var currentEventTransitionLane = NoLanes;
    var isRunningInsertionEffect = false;
    function getWorkInProgressRoot() {
        return workInProgressRoot;
    }
    function requestEventTime() {
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) // We're inside React, so it's fine to read the actual time.
        return now();
         // We're not inside React, so we may be in the middle of a browser event.
        if (currentEventTime !== NoTimestamp) // Use the same start time for all updates until we enter React again.
        return currentEventTime;
         // This is the first update since React yielded. Compute a new start time.
        currentEventTime = now();
        return currentEventTime;
    }
    function requestUpdateLane(fiber) {
        // Special cases
        var mode = fiber.mode;
        if ((mode & ConcurrentMode) === NoMode) return SyncLane;
        else if ((executionContext & RenderContext) !== NoContext && workInProgressRootRenderLanes !== NoLanes) // This is a render phase update. These are not officially supported. The
        // old behavior is to give this the same "thread" (lanes) as
        // whatever is currently rendering. So if you call `setState` on a component
        // that happens later in the same render, it will flush. Ideally, we want to
        // remove the special case and treat them as if they came from an
        // interleaved event. Regardless, this pattern is not officially supported.
        // This behavior is only a fallback. The flag only exists until we can roll
        // out the setState warning, since existing code might accidentally rely on
        // the current behavior.
        return pickArbitraryLane(workInProgressRootRenderLanes);
        var isTransition = requestCurrentTransition() !== NoTransition;
        if (isTransition) {
            if (ReactCurrentBatchConfig$3.transition !== null) {
                var transition = ReactCurrentBatchConfig$3.transition;
                if (!transition._updatedFibers) transition._updatedFibers = new Set();
                transition._updatedFibers.add(fiber);
            } // The algorithm for assigning an update to a lane should be stable for all
            // updates at the same priority within the same event. To do this, the
            // inputs to the algorithm must be the same.
            //
            // The trick we use is to cache the first of each of these inputs within an
            // event. Then reset the cached values once we can be sure the event is
            // over. Our heuristic for that is whenever we enter a concurrent work loop.
            if (currentEventTransitionLane === NoLane) // All transitions within the same event are assigned the same lane.
            currentEventTransitionLane = claimNextTransitionLane();
            return currentEventTransitionLane;
        } // Updates originating inside certain React methods, like flushSync, have
        // their priority set by tracking it with a context variable.
        //
        // The opaque type returned by the host config is internally a lane, so we can
        // use that directly.
        // TODO: Move this type conversion to the event priority module.
        var updateLane = getCurrentUpdatePriority();
        if (updateLane !== NoLane) return updateLane;
         // This update originated outside React. Ask the host environment for an
        // appropriate priority, based on the type of event.
        //
        // The opaque type returned by the host config is internally a lane, so we can
        // use that directly.
        // TODO: Move this type conversion to the event priority module.
        var eventLane = getCurrentEventPriority();
        return eventLane;
    }
    function requestRetryLane(fiber) {
        // This is a fork of `requestUpdateLane` designed specifically for Suspense
        // "retries" — a special update that attempts to flip a Suspense boundary
        // from its placeholder state to its primary/resolved state.
        // Special cases
        var mode = fiber.mode;
        if ((mode & ConcurrentMode) === NoMode) return SyncLane;
        return claimNextRetryLane();
    }
    function scheduleUpdateOnFiber(root, fiber, lane, eventTime) {
        checkForNestedUpdates();
        if (isRunningInsertionEffect) error("useInsertionEffect must not schedule updates.");
        if (isFlushingPassiveEffects) didScheduleUpdateDuringPassiveEffects = true;
        markRootUpdated(root, lane, eventTime);
        if ((executionContext & RenderContext) !== NoLanes && root === workInProgressRoot) // This update was dispatched during the render phase. This is a mistake
        // if the update originates from user space (with the exception of local
        // hook updates, which are handled differently and don't reach this
        // function), but there are some internal React features that use this as
        // an implementation detail, like selective hydration.
        warnAboutRenderPhaseUpdatesInDEV(fiber); // Track lanes that were updated during the render phase
        else {
            if (isDevToolsPresent) addFiberToLanesMap(root, fiber, lane);
            warnIfUpdatesNotWrappedWithActDEV(fiber);
            if (root === workInProgressRoot) {
                // Received an update to a tree that's in the middle of rendering. Mark
                // that there was an interleaved update work on this root. Unless the
                // `deferRenderPhaseUpdateToNextBatch` flag is off and this is a render
                // phase update. In that case, we don't treat render phase updates as if
                // they were interleaved, for backwards compat reasons.
                if ((executionContext & RenderContext) === NoContext) workInProgressRootInterleavedUpdatedLanes = mergeLanes(workInProgressRootInterleavedUpdatedLanes, lane);
                if (workInProgressRootExitStatus === RootSuspendedWithDelay) // The root already suspended with a delay, which means this render
                // definitely won't finish. Since we have a new update, let's mark it as
                // suspended now, right before marking the incoming update. This has the
                // effect of interrupting the current render and switching to the update.
                // TODO: Make sure this doesn't override pings that happen while we've
                // already started rendering.
                markRootSuspended$1(root, workInProgressRootRenderLanes);
            }
            ensureRootIsScheduled(root, eventTime);
            if (lane === SyncLane && executionContext === NoContext && (fiber.mode & ConcurrentMode) === NoMode && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
            !ReactCurrentActQueue$1.isBatchingLegacy) {
                // Flush the synchronous work now, unless we're already working or inside
                // a batch. This is intentionally inside scheduleUpdateOnFiber instead of
                // scheduleCallbackForFiber to preserve the ability to schedule a callback
                // without immediately flushing it. We only do this for user-initiated
                // updates, to preserve historical behavior of legacy mode.
                resetRenderTimer();
                flushSyncCallbacksOnlyInLegacyMode();
            }
        }
    }
    function scheduleInitialHydrationOnRoot(root, lane, eventTime) {
        // This is a special fork of scheduleUpdateOnFiber that is only used to
        // schedule the initial hydration of a root that has just been created. Most
        // of the stuff in scheduleUpdateOnFiber can be skipped.
        //
        // The main reason for this separate path, though, is to distinguish the
        // initial children from subsequent updates. In fully client-rendered roots
        // (createRoot instead of hydrateRoot), all top-level renders are modeled as
        // updates, but hydration roots are special because the initial render must
        // match what was rendered on the server.
        var current = root.current;
        current.lanes = lane;
        markRootUpdated(root, lane, eventTime);
        ensureRootIsScheduled(root, eventTime);
    }
    function isUnsafeClassRenderPhaseUpdate(fiber) {
        // Check if this is a render phase update. Only called by class components,
        // which special (deprecated) behavior for UNSAFE_componentWillReceive props.
        return(// decided not to enable it.
        (executionContext & RenderContext) !== NoContext);
    } // Use this function to schedule a task for a root. There's only one task per
    // root; if a task was already scheduled, we'll check to make sure the priority
    // of the existing task is the same as the priority of the next level that the
    // root has work on. This function is called on every update, and right before
    // exiting a task.
    function ensureRootIsScheduled(root, currentTime) {
        var existingCallbackNode = root.callbackNode; // Check if any lanes are being starved by other work. If so, mark them as
        // expired so we know to work on those next.
        markStarvedLanesAsExpired(root, currentTime); // Determine the next lanes to work on, and their priority.
        var nextLanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (nextLanes === NoLanes) {
            // Special case: There's nothing to work on.
            if (existingCallbackNode !== null) cancelCallback$1(existingCallbackNode);
            root.callbackNode = null;
            root.callbackPriority = NoLane;
            return;
        } // We use the highest priority lane to represent the priority of the callback.
        var newCallbackPriority = getHighestPriorityLane(nextLanes); // Check if there's an existing task. We may be able to reuse it.
        var existingCallbackPriority = root.callbackPriority;
        if (existingCallbackPriority === newCallbackPriority && // Special case related to `act`. If the currently scheduled task is a
        // Scheduler task, rather than an `act` task, cancel it and re-scheduled
        // on the `act` queue.
        !(ReactCurrentActQueue$1.current !== null && existingCallbackNode !== fakeActCallbackNode)) {
            // If we're going to re-use an existing task, it needs to exist.
            // Assume that discrete update microtasks are non-cancellable and null.
            // TODO: Temporary until we confirm this warning is not fired.
            if (existingCallbackNode == null && existingCallbackPriority !== SyncLane) error("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
            return;
        }
        if (existingCallbackNode != null) // Cancel the existing callback. We'll schedule a new one below.
        cancelCallback$1(existingCallbackNode);
         // Schedule a new callback.
        var newCallbackNode;
        if (newCallbackPriority === SyncLane) {
            // Special case: Sync React callbacks are scheduled on a special
            // internal queue
            if (root.tag === LegacyRoot) {
                if (ReactCurrentActQueue$1.isBatchingLegacy !== null) ReactCurrentActQueue$1.didScheduleLegacyUpdate = true;
                scheduleLegacySyncCallback(performSyncWorkOnRoot.bind(null, root));
            } else scheduleSyncCallback(performSyncWorkOnRoot.bind(null, root));
            // Flush the queue in a microtask.
            if (ReactCurrentActQueue$1.current !== null) // Inside `act`, use our internal `act` queue so that these get flushed
            // at the end of the current scope even when using the sync version
            // of `act`.
            ReactCurrentActQueue$1.current.push(flushSyncCallbacks);
            else scheduleMicrotask(function() {
                // In Safari, appending an iframe forces microtasks to run.
                // https://github.com/facebook/react/issues/22459
                // We don't support running callbacks in the middle of render
                // or commit so we need to check against that.
                if ((executionContext & (RenderContext | CommitContext)) === NoContext) // Note that this would still prematurely flush the callbacks
                // if this happens outside render or commit phase (e.g. in an event).
                flushSyncCallbacks();
            });
            newCallbackNode = null;
        } else {
            var schedulerPriorityLevel;
            switch(lanesToEventPriority(nextLanes)){
                case DiscreteEventPriority:
                    schedulerPriorityLevel = ImmediatePriority;
                    break;
                case ContinuousEventPriority:
                    schedulerPriorityLevel = UserBlockingPriority;
                    break;
                case DefaultEventPriority:
                    schedulerPriorityLevel = NormalPriority;
                    break;
                case IdleEventPriority:
                    schedulerPriorityLevel = IdlePriority;
                    break;
                default:
                    schedulerPriorityLevel = NormalPriority;
                    break;
            }
            newCallbackNode = scheduleCallback$1(schedulerPriorityLevel, performConcurrentWorkOnRoot.bind(null, root));
        }
        root.callbackPriority = newCallbackPriority;
        root.callbackNode = newCallbackNode;
    } // This is the entry point for every concurrent task, i.e. anything that
    // goes through Scheduler.
    function performConcurrentWorkOnRoot(root, didTimeout) {
        resetNestedUpdateFlag();
        // event time. The next update will compute a new event time.
        currentEventTime = NoTimestamp;
        currentEventTransitionLane = NoLanes;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Should not already be working.");
         // Flush any pending passive effects before deciding which lanes to work on,
        // in case they schedule additional work.
        var originalCallbackNode = root.callbackNode;
        var didFlushPassiveEffects = flushPassiveEffects();
        if (didFlushPassiveEffects) {
            // Something in the passive effect phase may have canceled the current task.
            // Check if the task node for this root was changed.
            if (root.callbackNode !== originalCallbackNode) // The current task was canceled. Exit. We don't need to call
            // `ensureRootIsScheduled` because the check above implies either that
            // there's a new task, or that there's no remaining work on this root.
            return null;
        } // Determine the next lanes to work on, using the fields stored
        // on the root.
        var lanes = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes : NoLanes);
        if (lanes === NoLanes) // Defensive coding. This is never expected to happen.
        return null;
         // We disable time-slicing in some cases: if the work has been CPU-bound
        // for too long ("expired" work, to prevent starvation), or we're in
        // sync-updates-by-default mode.
        // TODO: We only check `didTimeout` defensively, to account for a Scheduler
        // bug we're still investigating. Once the bug in Scheduler is fixed,
        // we can remove this, since we track expiration ourselves.
        var shouldTimeSlice = !includesBlockingLane(root, lanes) && !includesExpiredLane(root, lanes) && !didTimeout;
        var exitStatus = shouldTimeSlice ? renderRootConcurrent(root, lanes) : renderRootSync(root, lanes);
        if (exitStatus !== RootInProgress) {
            if (exitStatus === RootErrored) {
                // If something threw an error, try rendering one more time. We'll
                // render synchronously to block concurrent data mutations, and we'll
                // includes all pending updates are included. If it still fails after
                // the second attempt, we'll give up and commit the resulting tree.
                var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
                if (errorRetryLanes !== NoLanes) {
                    lanes = errorRetryLanes;
                    exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
                }
            }
            if (exitStatus === RootFatalErrored) {
                var fatalError = workInProgressRootFatalError;
                prepareFreshStack(root, NoLanes);
                markRootSuspended$1(root, lanes);
                ensureRootIsScheduled(root, now());
                throw fatalError;
            }
            if (exitStatus === RootDidNotComplete) // The render unwound without completing the tree. This happens in special
            // cases where need to exit the current render without producing a
            // consistent tree or committing.
            //
            // This should only happen during a concurrent render, not a discrete or
            // synchronous update. We should have already checked for this when we
            // unwound the stack.
            markRootSuspended$1(root, lanes);
            else {
                // The render completed.
                // Check if this render may have yielded to a concurrent event, and if so,
                // confirm that any newly rendered stores are consistent.
                // TODO: It's possible that even a concurrent render may never have yielded
                // to the main thread, if it was fast enough, or if it expired. We could
                // skip the consistency check in that case, too.
                var renderWasConcurrent = !includesBlockingLane(root, lanes);
                var finishedWork = root.current.alternate;
                if (renderWasConcurrent && !isRenderConsistentWithExternalStores(finishedWork)) {
                    // A store was mutated in an interleaved event. Render again,
                    // synchronously, to block further mutations.
                    exitStatus = renderRootSync(root, lanes); // We need to check again if something threw
                    if (exitStatus === RootErrored) {
                        var _errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
                        if (_errorRetryLanes !== NoLanes) {
                            lanes = _errorRetryLanes;
                            exitStatus = recoverFromConcurrentError(root, _errorRetryLanes); // We assume the tree is now consistent because we didn't yield to any
                        // concurrent events.
                        }
                    }
                    if (exitStatus === RootFatalErrored) {
                        var _fatalError = workInProgressRootFatalError;
                        prepareFreshStack(root, NoLanes);
                        markRootSuspended$1(root, lanes);
                        ensureRootIsScheduled(root, now());
                        throw _fatalError;
                    }
                } // We now have a consistent tree. The next step is either to commit it,
                // or, if something suspended, wait to commit it after a timeout.
                root.finishedWork = finishedWork;
                root.finishedLanes = lanes;
                finishConcurrentRender(root, exitStatus, lanes);
            }
        }
        ensureRootIsScheduled(root, now());
        if (root.callbackNode === originalCallbackNode) // The task node scheduled for this root is the same one that's
        // currently executed. Need to return a continuation.
        return performConcurrentWorkOnRoot.bind(null, root);
        return null;
    }
    function recoverFromConcurrentError(root, errorRetryLanes) {
        // If an error occurred during hydration, discard server response and fall
        // back to client side render.
        // Before rendering again, save the errors from the previous attempt.
        var errorsFromFirstAttempt = workInProgressRootConcurrentErrors;
        if (isRootDehydrated(root)) {
            // The shell failed to hydrate. Set a flag to force a client rendering
            // during the next attempt. To do this, we call prepareFreshStack now
            // to create the root work-in-progress fiber. This is a bit weird in terms
            // of factoring, because it relies on renderRootSync not calling
            // prepareFreshStack again in the call below, which happens because the
            // root and lanes haven't changed.
            //
            // TODO: I think what we should do is set ForceClientRender inside
            // throwException, like we do for nested Suspense boundaries. The reason
            // it's here instead is so we can switch to the synchronous work loop, too.
            // Something to consider for a future refactor.
            var rootWorkInProgress = prepareFreshStack(root, errorRetryLanes);
            rootWorkInProgress.flags |= ForceClientRender;
            errorHydratingContainer(root.containerInfo);
        }
        var exitStatus = renderRootSync(root, errorRetryLanes);
        if (exitStatus !== RootErrored) {
            // Successfully finished rendering on retry
            // The errors from the failed first attempt have been recovered. Add
            // them to the collection of recoverable errors. We'll log them in the
            // commit phase.
            var errorsFromSecondAttempt = workInProgressRootRecoverableErrors;
            workInProgressRootRecoverableErrors = errorsFromFirstAttempt; // The errors from the second attempt should be queued after the errors
            // from the first attempt, to preserve the causal sequence.
            if (errorsFromSecondAttempt !== null) queueRecoverableErrors(errorsFromSecondAttempt);
        }
        return exitStatus;
    }
    function queueRecoverableErrors(errors) {
        if (workInProgressRootRecoverableErrors === null) workInProgressRootRecoverableErrors = errors;
        else workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, errors);
    }
    function finishConcurrentRender(root, exitStatus, lanes) {
        switch(exitStatus){
            case RootInProgress:
            case RootFatalErrored:
                throw new Error("Root did not complete. This is a bug in React.");
            // Flow knows about invariant, so it complains if I add a break
            // statement, but eslint doesn't know about invariant, so it complains
            // if I do. eslint-disable-next-line no-fallthrough
            case RootErrored:
                // We should have already attempted to retry this tree. If we reached
                // this point, it errored again. Commit it.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootSuspended:
                markRootSuspended$1(root, lanes); // We have an acceptable loading state. We need to figure out if we
                // should immediately commit it or wait a bit.
                if (includesOnlyRetries(lanes) && // do not delay if we're inside an act() scope
                !shouldForceFlushFallbacksInDEV()) {
                    // This render only included retries, no updates. Throttle committing
                    // retries so that we don't show too many loading states too quickly.
                    var msUntilTimeout = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now(); // Don't bother with a very short suspense time.
                    if (msUntilTimeout > 10) {
                        var nextLanes = getNextLanes(root, NoLanes);
                        if (nextLanes !== NoLanes) break;
                        var suspendedLanes = root.suspendedLanes;
                        if (!isSubsetOfLanes(suspendedLanes, lanes)) {
                            // We should prefer to render the fallback of at the last
                            // suspended level. Ping the last suspended level to try
                            // rendering it again.
                            // FIXME: What if the suspended lanes are Idle? Should not restart.
                            var eventTime = requestEventTime();
                            markRootPinged(root, suspendedLanes);
                            break;
                        } // The render is suspended, it hasn't timed out, and there's no
                        // lower priority work to do. Instead of committing the fallback
                        // immediately, wait for more data to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), msUntilTimeout);
                        break;
                    }
                } // The work expired. Commit immediately.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootSuspendedWithDelay:
                markRootSuspended$1(root, lanes);
                if (includesOnlyTransitions(lanes)) break;
                if (!shouldForceFlushFallbacksInDEV()) {
                    // This is not a transition, but we did trigger an avoided state.
                    // Schedule a placeholder to display after a short delay, using the Just
                    // Noticeable Difference.
                    // TODO: Is the JND optimization worth the added complexity? If this is
                    // the only reason we track the event time, then probably not.
                    // Consider removing.
                    var mostRecentEventTime = getMostRecentEventTime(root, lanes);
                    var eventTimeMs = mostRecentEventTime;
                    var timeElapsedMs = now() - eventTimeMs;
                    var _msUntilTimeout = jnd(timeElapsedMs) - timeElapsedMs; // Don't bother with a very short suspense time.
                    if (_msUntilTimeout > 10) {
                        // Instead of committing the fallback immediately, wait for more data
                        // to arrive.
                        root.timeoutHandle = scheduleTimeout(commitRoot.bind(null, root, workInProgressRootRecoverableErrors, workInProgressTransitions), _msUntilTimeout);
                        break;
                    }
                } // Commit the placeholder.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            case RootCompleted:
                // The work completed. Ready to commit.
                commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions);
                break;
            default:
                throw new Error("Unknown root exit status.");
        }
    }
    function isRenderConsistentWithExternalStores(finishedWork) {
        // Search the rendered tree for external store reads, and check whether the
        // stores were mutated in a concurrent event. Intentionally using an iterative
        // loop instead of recursion so we can exit early.
        var node = finishedWork;
        while(true){
            if (node.flags & StoreConsistency) {
                var updateQueue = node.updateQueue;
                if (updateQueue !== null) {
                    var checks = updateQueue.stores;
                    if (checks !== null) for(var i = 0; i < checks.length; i++){
                        var check = checks[i];
                        var getSnapshot = check.getSnapshot;
                        var renderedValue = check.value;
                        try {
                            if (!objectIs(getSnapshot(), renderedValue)) // Found an inconsistent store.
                            return false;
                        } catch (error) {
                            // If `getSnapshot` throws, return `false`. This will schedule
                            // a re-render, and the error will be rethrown during render.
                            return false;
                        }
                    }
                }
            }
            var child = node.child;
            if (node.subtreeFlags & StoreConsistency && child !== null) {
                child.return = node;
                node = child;
                continue;
            }
            if (node === finishedWork) return true;
            while(node.sibling === null){
                if (node.return === null || node.return === finishedWork) return true;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        } // Flow doesn't know this is unreachable, but eslint does
        // eslint-disable-next-line no-unreachable
        return true;
    }
    function markRootSuspended$1(root, suspendedLanes) {
        // When suspending, we should always exclude lanes that were pinged or (more
        // rarely, since we try to avoid it) updated during the render phase.
        // TODO: Lol maybe there's a better way to factor this besides this
        // obnoxiously named function :)
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootPingedLanes);
        suspendedLanes = removeLanes(suspendedLanes, workInProgressRootInterleavedUpdatedLanes);
        markRootSuspended(root, suspendedLanes);
    } // This is the entry point for synchronous tasks that don't go
    // through Scheduler
    function performSyncWorkOnRoot(root) {
        syncNestedUpdateFlag();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Should not already be working.");
        flushPassiveEffects();
        var lanes = getNextLanes(root, NoLanes);
        if (!includesSomeLane(lanes, SyncLane)) {
            // There's no remaining sync work left.
            ensureRootIsScheduled(root, now());
            return null;
        }
        var exitStatus = renderRootSync(root, lanes);
        if (root.tag !== LegacyRoot && exitStatus === RootErrored) {
            // If something threw an error, try rendering one more time. We'll render
            // synchronously to block concurrent data mutations, and we'll includes
            // all pending updates are included. If it still fails after the second
            // attempt, we'll give up and commit the resulting tree.
            var errorRetryLanes = getLanesToRetrySynchronouslyOnError(root);
            if (errorRetryLanes !== NoLanes) {
                lanes = errorRetryLanes;
                exitStatus = recoverFromConcurrentError(root, errorRetryLanes);
            }
        }
        if (exitStatus === RootFatalErrored) {
            var fatalError = workInProgressRootFatalError;
            prepareFreshStack(root, NoLanes);
            markRootSuspended$1(root, lanes);
            ensureRootIsScheduled(root, now());
            throw fatalError;
        }
        if (exitStatus === RootDidNotComplete) throw new Error("Root did not complete. This is a bug in React.");
         // We now have a consistent tree. Because this is a sync render, we
        // will commit it even if something suspended.
        var finishedWork = root.current.alternate;
        root.finishedWork = finishedWork;
        root.finishedLanes = lanes;
        commitRoot(root, workInProgressRootRecoverableErrors, workInProgressTransitions); // Before exiting, make sure there's a callback scheduled for the next
        // pending level.
        ensureRootIsScheduled(root, now());
        return null;
    }
    function flushRoot(root, lanes) {
        if (lanes !== NoLanes) {
            markRootEntangled(root, mergeLanes(lanes, SyncLane));
            ensureRootIsScheduled(root, now());
            if ((executionContext & (RenderContext | CommitContext)) === NoContext) {
                resetRenderTimer();
                flushSyncCallbacks();
            }
        }
    }
    function batchedUpdates$1(fn, a) {
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        try {
            return fn(a);
        } finally{
            executionContext = prevExecutionContext; // If there were legacy sync updates, flush them at the end of the outer
            // most batchedUpdates-like method.
            if (executionContext === NoContext && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
            !ReactCurrentActQueue$1.isBatchingLegacy) {
                resetRenderTimer();
                flushSyncCallbacksOnlyInLegacyMode();
            }
        }
    }
    function discreteUpdates(fn, a, b, c, d) {
        var previousPriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            return fn(a, b, c, d);
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
            if (executionContext === NoContext) resetRenderTimer();
        }
    } // Overload the definition to the two valid signatures.
    // Warning, this opts-out of checking the function body.
    // eslint-disable-next-line no-redeclare
    function flushSync(fn) {
        // In legacy mode, we flush pending passive effects at the beginning of the
        // next event, not at the end of the previous one.
        if (rootWithPendingPassiveEffects !== null && rootWithPendingPassiveEffects.tag === LegacyRoot && (executionContext & (RenderContext | CommitContext)) === NoContext) flushPassiveEffects();
        var prevExecutionContext = executionContext;
        executionContext |= BatchedContext;
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        var previousPriority = getCurrentUpdatePriority();
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            if (fn) return fn();
            else return undefined;
        } finally{
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
            executionContext = prevExecutionContext; // Flush the immediate callbacks that were scheduled during this batch.
            // Note that this will happen even if batchedUpdates is higher up
            // the stack.
            if ((executionContext & (RenderContext | CommitContext)) === NoContext) flushSyncCallbacks();
        }
    }
    function isAlreadyRendering() {
        // Used by the renderer to print a warning if certain APIs are called from
        // the wrong context.
        return (executionContext & (RenderContext | CommitContext)) !== NoContext;
    }
    function pushRenderLanes(fiber, lanes) {
        push(subtreeRenderLanesCursor, subtreeRenderLanes, fiber);
        subtreeRenderLanes = mergeLanes(subtreeRenderLanes, lanes);
        workInProgressRootIncludedLanes = mergeLanes(workInProgressRootIncludedLanes, lanes);
    }
    function popRenderLanes(fiber) {
        subtreeRenderLanes = subtreeRenderLanesCursor.current;
        pop(subtreeRenderLanesCursor, fiber);
    }
    function prepareFreshStack(root, lanes) {
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        var timeoutHandle = root.timeoutHandle;
        if (timeoutHandle !== noTimeout) {
            // The root previous suspended and scheduled a timeout to commit a fallback
            // state. Now that we have additional work, cancel the timeout.
            root.timeoutHandle = noTimeout; // $FlowFixMe Complains noTimeout is not a TimeoutID, despite the check above
            cancelTimeout(timeoutHandle);
        }
        if (workInProgress !== null) {
            var interruptedWork = workInProgress.return;
            while(interruptedWork !== null){
                var current = interruptedWork.alternate;
                unwindInterruptedWork(current, interruptedWork);
                interruptedWork = interruptedWork.return;
            }
        }
        workInProgressRoot = root;
        var rootWorkInProgress = createWorkInProgress(root.current, null);
        workInProgress = rootWorkInProgress;
        workInProgressRootRenderLanes = subtreeRenderLanes = workInProgressRootIncludedLanes = lanes;
        workInProgressRootExitStatus = RootInProgress;
        workInProgressRootFatalError = null;
        workInProgressRootSkippedLanes = NoLanes;
        workInProgressRootInterleavedUpdatedLanes = NoLanes;
        workInProgressRootPingedLanes = NoLanes;
        workInProgressRootConcurrentErrors = null;
        workInProgressRootRecoverableErrors = null;
        finishQueueingConcurrentUpdates();
        ReactStrictModeWarnings.discardPendingWarnings();
        return rootWorkInProgress;
    }
    function handleError(root, thrownValue) {
        do {
            var erroredWork = workInProgress;
            try {
                // Reset module-level state that was set during the render phase.
                resetContextDependencies();
                resetHooksAfterThrow();
                resetCurrentFiber(); // TODO: I found and added this missing line while investigating a
                // separate issue. Write a regression test using string refs.
                ReactCurrentOwner$2.current = null;
                if (erroredWork === null || erroredWork.return === null) {
                    // Expected to be working on a non-root fiber. This is a fatal error
                    // because there's no ancestor that can handle it; the root is
                    // supposed to capture all errors that weren't caught by an error
                    // boundary.
                    workInProgressRootExitStatus = RootFatalErrored;
                    workInProgressRootFatalError = thrownValue; // Set `workInProgress` to null. This represents advancing to the next
                    // sibling, or the parent if there are no siblings. But since the root
                    // has no siblings nor a parent, we set it to null. Usually this is
                    // handled by `completeUnitOfWork` or `unwindWork`, but since we're
                    // intentionally not calling those, we need set it here.
                    // TODO: Consider calling `unwindWork` to pop the contexts.
                    workInProgress = null;
                    return;
                }
                if (enableProfilerTimer && erroredWork.mode & ProfileMode) // Record the time spent rendering before an error was thrown. This
                // avoids inaccurate Profiler durations in the case of a
                // suspended render.
                stopProfilerTimerIfRunningAndRecordDelta(erroredWork, true);
                if (enableSchedulingProfiler) {
                    markComponentRenderStopped();
                    if (thrownValue !== null && typeof thrownValue === "object" && typeof thrownValue.then === "function") {
                        var wakeable = thrownValue;
                        markComponentSuspended(erroredWork, wakeable, workInProgressRootRenderLanes);
                    } else markComponentErrored(erroredWork, thrownValue, workInProgressRootRenderLanes);
                }
                throwException(root, erroredWork.return, erroredWork, thrownValue, workInProgressRootRenderLanes);
                completeUnitOfWork(erroredWork);
            } catch (yetAnotherThrownValue) {
                // Something in the return path also threw.
                thrownValue = yetAnotherThrownValue;
                if (workInProgress === erroredWork && erroredWork !== null) {
                    // If this boundary has already errored, then we had trouble processing
                    // the error. Bubble it to the next boundary.
                    erroredWork = erroredWork.return;
                    workInProgress = erroredWork;
                } else erroredWork = workInProgress;
                continue;
            } // Return to the normal work loop.
            return;
        }while (true);
    }
    function pushDispatcher() {
        var prevDispatcher = ReactCurrentDispatcher$2.current;
        ReactCurrentDispatcher$2.current = ContextOnlyDispatcher;
        if (prevDispatcher === null) // The React isomorphic package does not include a default dispatcher.
        // Instead the first renderer will lazily attach one, in order to give
        // nicer error messages.
        return ContextOnlyDispatcher;
        else return prevDispatcher;
    }
    function popDispatcher(prevDispatcher) {
        ReactCurrentDispatcher$2.current = prevDispatcher;
    }
    function markCommitTimeOfFallback() {
        globalMostRecentFallbackTime = now();
    }
    function markSkippedUpdateLanes(lane) {
        workInProgressRootSkippedLanes = mergeLanes(lane, workInProgressRootSkippedLanes);
    }
    function renderDidSuspend() {
        if (workInProgressRootExitStatus === RootInProgress) workInProgressRootExitStatus = RootSuspended;
    }
    function renderDidSuspendDelayIfPossible() {
        if (workInProgressRootExitStatus === RootInProgress || workInProgressRootExitStatus === RootSuspended || workInProgressRootExitStatus === RootErrored) workInProgressRootExitStatus = RootSuspendedWithDelay;
         // Check if there are updates that we skipped tree that might have unblocked
        // this render.
        if (workInProgressRoot !== null && (includesNonIdleWork(workInProgressRootSkippedLanes) || includesNonIdleWork(workInProgressRootInterleavedUpdatedLanes))) // Mark the current render as suspended so that we switch to working on
        // the updates that were skipped. Usually we only suspend at the end of
        // the render phase.
        // TODO: We should probably always mark the root as suspended immediately
        // (inside this function), since by suspending at the end of the render
        // phase introduces a potential mistake where we suspend lanes that were
        // pinged or updated while we were rendering.
        markRootSuspended$1(workInProgressRoot, workInProgressRootRenderLanes);
    }
    function renderDidError(error) {
        if (workInProgressRootExitStatus !== RootSuspendedWithDelay) workInProgressRootExitStatus = RootErrored;
        if (workInProgressRootConcurrentErrors === null) workInProgressRootConcurrentErrors = [
            error
        ];
        else workInProgressRootConcurrentErrors.push(error);
    } // Called during render to determine if anything has suspended.
    // Returns false if we're not sure.
    function renderHasNotSuspendedYet() {
        // If something errored or completed, we can't really be sure,
        // so those are false.
        return workInProgressRootExitStatus === RootInProgress;
    }
    function renderRootSync(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                if (memoizedUpdaters.size > 0) {
                    restorePendingUpdaters(root, workInProgressRootRenderLanes);
                    memoizedUpdaters.clear();
                } // At this point, move Fibers that scheduled the upcoming work from the Map to the Set.
                // If we bailout on this work, we'll move them back (like above).
                // It's important to move them now in case the work spawns more work at the same priority with different updaters.
                // That way we can keep the current update and future updates separate.
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = getTransitionsForLanes();
            prepareFreshStack(root, lanes);
        }
        markRenderStarted(lanes);
        for(;;)try {
            workLoopSync();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        executionContext = prevExecutionContext;
        popDispatcher(prevDispatcher);
        if (workInProgress !== null) // This is a sync render, so we should have finished the whole tree.
        throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
        markRenderStopped();
        workInProgressRoot = null;
        workInProgressRootRenderLanes = NoLanes;
        return workInProgressRootExitStatus;
    } // The work loop is an extremely hot path. Tell Closure not to inline it.
    /** @noinline */ function workLoopSync() {
        // Already timed out, so perform work without checking if we need to yield.
        while(workInProgress !== null)performUnitOfWork(workInProgress);
    }
    function renderRootConcurrent(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= RenderContext;
        var prevDispatcher = pushDispatcher(); // If the root or lanes have changed, throw out the existing stack
        // and prepare a fresh one. Otherwise we'll continue where we left off.
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) {
            if (isDevToolsPresent) {
                var memoizedUpdaters = root.memoizedUpdaters;
                if (memoizedUpdaters.size > 0) {
                    restorePendingUpdaters(root, workInProgressRootRenderLanes);
                    memoizedUpdaters.clear();
                } // At this point, move Fibers that scheduled the upcoming work from the Map to the Set.
                // If we bailout on this work, we'll move them back (like above).
                // It's important to move them now in case the work spawns more work at the same priority with different updaters.
                // That way we can keep the current update and future updates separate.
                movePendingFibersToMemoized(root, lanes);
            }
            workInProgressTransitions = getTransitionsForLanes();
            resetRenderTimer();
            prepareFreshStack(root, lanes);
        }
        markRenderStarted(lanes);
        for(;;)try {
            workLoopConcurrent();
            break;
        } catch (thrownValue) {
            handleError(root, thrownValue);
        }
        resetContextDependencies();
        popDispatcher(prevDispatcher);
        executionContext = prevExecutionContext;
        if (workInProgress !== null) {
            markRenderYielded();
            return RootInProgress;
        } else {
            markRenderStopped();
            workInProgressRoot = null;
            workInProgressRootRenderLanes = NoLanes; // Return the final exit status.
            return workInProgressRootExitStatus;
        }
    }
    /** @noinline */ function workLoopConcurrent() {
        // Perform work until Scheduler asks us to yield
        while(workInProgress !== null && !shouldYield())performUnitOfWork(workInProgress);
    }
    function performUnitOfWork(unitOfWork) {
        // The current, flushed, state of this fiber is the alternate. Ideally
        // nothing should rely on this, but relying on it here means that we don't
        // need an additional field on the work in progress.
        var current = unitOfWork.alternate;
        setCurrentFiber(unitOfWork);
        var next;
        if ((unitOfWork.mode & ProfileMode) !== NoMode) {
            startProfilerTimer(unitOfWork);
            next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
            stopProfilerTimerIfRunningAndRecordDelta(unitOfWork, true);
        } else next = beginWork$1(current, unitOfWork, subtreeRenderLanes);
        resetCurrentFiber();
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        if (next === null) // If this doesn't spawn new work, complete the current work.
        completeUnitOfWork(unitOfWork);
        else workInProgress = next;
        ReactCurrentOwner$2.current = null;
    }
    function completeUnitOfWork(unitOfWork) {
        // Attempt to complete the current unit of work, then move to the next
        // sibling. If there are no more siblings, return to the parent fiber.
        var completedWork = unitOfWork;
        do {
            // The current, flushed, state of this fiber is the alternate. Ideally
            // nothing should rely on this, but relying on it here means that we don't
            // need an additional field on the work in progress.
            var current = completedWork.alternate;
            var returnFiber = completedWork.return; // Check if the work completed or if something threw.
            if ((completedWork.flags & Incomplete) === NoFlags) {
                setCurrentFiber(completedWork);
                var next = void 0;
                if ((completedWork.mode & ProfileMode) === NoMode) next = completeWork(current, completedWork, subtreeRenderLanes);
                else {
                    startProfilerTimer(completedWork);
                    next = completeWork(current, completedWork, subtreeRenderLanes); // Update render duration assuming we didn't error.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false);
                }
                resetCurrentFiber();
                if (next !== null) {
                    // Completing this fiber spawned new work. Work on that next.
                    workInProgress = next;
                    return;
                }
            } else {
                // This fiber did not complete because something threw. Pop values off
                // the stack without entering the complete phase. If this is a boundary,
                // capture values if possible.
                var _next = unwindWork(current, completedWork); // Because this fiber did not complete, don't reset its lanes.
                if (_next !== null) {
                    // If completing this work spawned new work, do that next. We'll come
                    // back here again.
                    // Since we're restarting, remove anything that is not a host effect
                    // from the effect tag.
                    _next.flags &= HostEffectMask;
                    workInProgress = _next;
                    return;
                }
                if ((completedWork.mode & ProfileMode) !== NoMode) {
                    // Record the render duration for the fiber that errored.
                    stopProfilerTimerIfRunningAndRecordDelta(completedWork, false); // Include the time spent working on failed children before continuing.
                    var actualDuration = completedWork.actualDuration;
                    var child = completedWork.child;
                    while(child !== null){
                        actualDuration += child.actualDuration;
                        child = child.sibling;
                    }
                    completedWork.actualDuration = actualDuration;
                }
                if (returnFiber !== null) {
                    // Mark the parent fiber as incomplete and clear its subtree flags.
                    returnFiber.flags |= Incomplete;
                    returnFiber.subtreeFlags = NoFlags;
                    returnFiber.deletions = null;
                } else {
                    // We've unwound all the way to the root.
                    workInProgressRootExitStatus = RootDidNotComplete;
                    workInProgress = null;
                    return;
                }
            }
            var siblingFiber = completedWork.sibling;
            if (siblingFiber !== null) {
                // If there is more work to do in this returnFiber, do that next.
                workInProgress = siblingFiber;
                return;
            } // Otherwise, return to the parent
            completedWork = returnFiber; // Update the next thing we're working on in case something throws.
            workInProgress = completedWork;
        }while (completedWork !== null); // We've reached the root.
        if (workInProgressRootExitStatus === RootInProgress) workInProgressRootExitStatus = RootCompleted;
    }
    function commitRoot(root, recoverableErrors, transitions) {
        // TODO: This no longer makes any sense. We already wrap the mutation and
        // layout phases. Should be able to remove.
        var previousUpdateLanePriority = getCurrentUpdatePriority();
        var prevTransition = ReactCurrentBatchConfig$3.transition;
        try {
            ReactCurrentBatchConfig$3.transition = null;
            setCurrentUpdatePriority(DiscreteEventPriority);
            commitRootImpl(root, recoverableErrors, transitions, previousUpdateLanePriority);
        } finally{
            ReactCurrentBatchConfig$3.transition = prevTransition;
            setCurrentUpdatePriority(previousUpdateLanePriority);
        }
        return null;
    }
    function commitRootImpl(root, recoverableErrors, transitions, renderPriorityLevel) {
        do // `flushPassiveEffects` will call `flushSyncUpdateQueue` at the end, which
        // means `flushPassiveEffects` will sometimes result in additional
        // passive effects. So we need to keep flushing in a loop until there are
        // no more pending effects.
        // TODO: Might be better if `flushPassiveEffects` did not automatically
        // flush synchronous work at the end, to avoid factoring hazards like this.
        flushPassiveEffects();
        while (rootWithPendingPassiveEffects !== null);
        flushRenderPhaseStrictModeWarningsInDEV();
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Should not already be working.");
        var finishedWork = root.finishedWork;
        var lanes = root.finishedLanes;
        markCommitStarted(lanes);
        if (finishedWork === null) {
            markCommitStopped();
            return null;
        } else if (lanes === NoLanes) error("root.finishedLanes should not be empty during a commit. This is a bug in React.");
        root.finishedWork = null;
        root.finishedLanes = NoLanes;
        if (finishedWork === root.current) throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
         // commitRoot never returns a continuation; it always finishes synchronously.
        // So we can clear these now to allow a new callback to be scheduled.
        root.callbackNode = null;
        root.callbackPriority = NoLane; // Update the first and last pending times on this root. The new first
        // pending time is whatever is left on the root fiber.
        var remainingLanes = mergeLanes(finishedWork.lanes, finishedWork.childLanes);
        markRootFinished(root, remainingLanes);
        if (root === workInProgressRoot) {
            // We can reset these now that they are finished.
            workInProgressRoot = null;
            workInProgress = null;
            workInProgressRootRenderLanes = NoLanes;
        } // If there are pending passive effects, schedule a callback to process them.
        // Do this as early as possible, so it is queued before anything else that
        // might get scheduled in the commit phase. (See #16714.)
        // TODO: Delete all other places that schedule the passive effect callback
        // They're redundant.
        if ((finishedWork.subtreeFlags & PassiveMask) !== NoFlags || (finishedWork.flags & PassiveMask) !== NoFlags) {
            if (!rootDoesHavePassiveEffects) {
                rootDoesHavePassiveEffects = true;
                // to store it in pendingPassiveTransitions until they get processed
                // We need to pass this through as an argument to commitRoot
                // because workInProgressTransitions might have changed between
                // the previous render and commit if we throttle the commit
                // with setTimeout
                pendingPassiveTransitions = transitions;
                scheduleCallback$1(NormalPriority, function() {
                    flushPassiveEffects(); // This render triggered passive effects: release the root cache pool
                    // *after* passive effects fire to avoid freeing a cache pool that may
                    // be referenced by a node in the tree (HostRoot, Cache boundary etc)
                    return null;
                });
            }
        } // Check if there are any effects in the whole tree.
        // TODO: This is left over from the effect list implementation, where we had
        // to check for the existence of `firstEffect` to satisfy Flow. I think the
        // only other reason this optimization exists is because it affects profiling.
        // Reconsider whether this is necessary.
        var subtreeHasEffects = (finishedWork.subtreeFlags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        var rootHasEffect = (finishedWork.flags & (BeforeMutationMask | MutationMask | LayoutMask | PassiveMask)) !== NoFlags;
        if (subtreeHasEffects || rootHasEffect) {
            var prevTransition = ReactCurrentBatchConfig$3.transition;
            ReactCurrentBatchConfig$3.transition = null;
            var previousPriority = getCurrentUpdatePriority();
            setCurrentUpdatePriority(DiscreteEventPriority);
            var prevExecutionContext = executionContext;
            executionContext |= CommitContext; // Reset this to null before calling lifecycles
            ReactCurrentOwner$2.current = null; // The commit phase is broken into several sub-phases. We do a separate pass
            // of the effect list for each phase: all mutation effects come before all
            // layout effects, and so on.
            // The first phase a "before mutation" phase. We use this phase to read the
            // state of the host tree right before we mutate it. This is where
            // getSnapshotBeforeUpdate is called.
            var shouldFireAfterActiveInstanceBlur = commitBeforeMutationEffects(root, finishedWork);
            // Mark the current commit time to be shared by all Profilers in this
            // batch. This enables them to be grouped later.
            recordCommitTime();
            commitMutationEffects(root, finishedWork, lanes);
            resetAfterCommit(root.containerInfo); // The work-in-progress tree is now the current tree. This must come after
            // the mutation phase, so that the previous tree is still current during
            // componentWillUnmount, but before the layout phase, so that the finished
            // work is current during componentDidMount/Update.
            root.current = finishedWork; // The next phase is the layout phase, where we call effects that read
            markLayoutEffectsStarted(lanes);
            commitLayoutEffects(finishedWork, root, lanes);
            markLayoutEffectsStopped();
            // opportunity to paint.
            requestPaint();
            executionContext = prevExecutionContext; // Reset the priority to the previous non-sync value.
            setCurrentUpdatePriority(previousPriority);
            ReactCurrentBatchConfig$3.transition = prevTransition;
        } else {
            // No effects.
            root.current = finishedWork; // Measure these anyway so the flamegraph explicitly shows that there were
            recordCommitTime();
        }
        var rootDidHavePassiveEffects = rootDoesHavePassiveEffects;
        if (rootDoesHavePassiveEffects) {
            // This commit has passive effects. Stash a reference to them. But don't
            // schedule a callback until after flushing layout work.
            rootDoesHavePassiveEffects = false;
            rootWithPendingPassiveEffects = root;
            pendingPassiveEffectsLanes = lanes;
        } else {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
        } // Read this again, since an effect might have updated it
        remainingLanes = root.pendingLanes; // Check if there's remaining work on this root
        // TODO: This is part of the `componentDidCatch` implementation. Its purpose
        // is to detect whether something might have called setState inside
        // `componentDidCatch`. The mechanism is known to be flawed because `setState`
        // inside `componentDidCatch` is itself flawed — that's why we recommend
        // `getDerivedStateFromError` instead. However, it could be improved by
        // checking if remainingLanes includes Sync work, instead of whether there's
        // any work remaining at all (which would also include stuff like Suspense
        // retries or transitions). It's been like this for a while, though, so fixing
        // it probably isn't that urgent.
        if (remainingLanes === NoLanes) // If there's no remaining work, we can clear the set of already failed
        // error boundaries.
        legacyErrorBoundariesThatAlreadyFailed = null;
        if (!rootDidHavePassiveEffects) commitDoubleInvokeEffectsInDEV(root.current, false);
        onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
        if (isDevToolsPresent) root.memoizedUpdaters.clear();
        onCommitRoot$1();
        // additional work on this root is scheduled.
        ensureRootIsScheduled(root, now());
        if (recoverableErrors !== null) {
            // There were errors during this render, but recovered from them without
            // needing to surface it to the UI. We log them here.
            var onRecoverableError = root.onRecoverableError;
            for(var i = 0; i < recoverableErrors.length; i++){
                var recoverableError = recoverableErrors[i];
                var componentStack = recoverableError.stack;
                var digest = recoverableError.digest;
                onRecoverableError(recoverableError.value, {
                    componentStack: componentStack,
                    digest: digest
                });
            }
        }
        if (hasUncaughtError) {
            hasUncaughtError = false;
            var error$1 = firstUncaughtError;
            firstUncaughtError = null;
            throw error$1;
        } // If the passive effects are the result of a discrete render, flush them
        // synchronously at the end of the current task so that the result is
        // immediately observable. Otherwise, we assume that they are not
        // order-dependent and do not need to be observed by external systems, so we
        // can wait until after paint.
        // TODO: We can optimize this by not scheduling the callback earlier. Since we
        // currently schedule the callback in multiple places, will wait until those
        // are consolidated.
        if (includesSomeLane(pendingPassiveEffectsLanes, SyncLane) && root.tag !== LegacyRoot) flushPassiveEffects();
         // Read this again, since a passive effect might have updated it
        remainingLanes = root.pendingLanes;
        if (includesSomeLane(remainingLanes, SyncLane)) {
            markNestedUpdateScheduled();
            // finishing. If there are too many, it indicates an infinite update loop.
            if (root === rootWithNestedUpdates) nestedUpdateCount++;
            else {
                nestedUpdateCount = 0;
                rootWithNestedUpdates = root;
            }
        } else nestedUpdateCount = 0;
         // If layout work was scheduled, flush it now.
        flushSyncCallbacks();
        markCommitStopped();
        return null;
    }
    function flushPassiveEffects() {
        // Returns whether passive effects were flushed.
        // TODO: Combine this check with the one in flushPassiveEFfectsImpl. We should
        // probably just combine the two functions. I believe they were only separate
        // in the first place because we used to wrap it with
        // `Scheduler.runWithPriority`, which accepts a function. But now we track the
        // priority within React itself, so we can mutate the variable directly.
        if (rootWithPendingPassiveEffects !== null) {
            var renderPriority = lanesToEventPriority(pendingPassiveEffectsLanes);
            var priority = lowerEventPriority(DefaultEventPriority, renderPriority);
            var prevTransition = ReactCurrentBatchConfig$3.transition;
            var previousPriority = getCurrentUpdatePriority();
            try {
                ReactCurrentBatchConfig$3.transition = null;
                setCurrentUpdatePriority(priority);
                return flushPassiveEffectsImpl();
            } finally{
                setCurrentUpdatePriority(previousPriority);
                ReactCurrentBatchConfig$3.transition = prevTransition; // Once passive effects have run for the tree - giving components a
            }
        }
        return false;
    }
    function enqueuePendingPassiveProfilerEffect(fiber) {
        pendingPassiveProfilerEffects.push(fiber);
        if (!rootDoesHavePassiveEffects) {
            rootDoesHavePassiveEffects = true;
            scheduleCallback$1(NormalPriority, function() {
                flushPassiveEffects();
                return null;
            });
        }
    }
    function flushPassiveEffectsImpl() {
        if (rootWithPendingPassiveEffects === null) return false;
         // Cache and clear the transitions flag
        var transitions = pendingPassiveTransitions;
        pendingPassiveTransitions = null;
        var root = rootWithPendingPassiveEffects;
        var lanes = pendingPassiveEffectsLanes;
        rootWithPendingPassiveEffects = null; // TODO: This is sometimes out of sync with rootWithPendingPassiveEffects.
        // Figure out why and fix it. It's not causing any known issues (probably
        // because it's only used for profiling), but it's a refactor hazard.
        pendingPassiveEffectsLanes = NoLanes;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext) throw new Error("Cannot flush passive effects while already rendering.");
        isFlushingPassiveEffects = true;
        didScheduleUpdateDuringPassiveEffects = false;
        markPassiveEffectsStarted(lanes);
        var prevExecutionContext = executionContext;
        executionContext |= CommitContext;
        commitPassiveUnmountEffects(root.current);
        commitPassiveMountEffects(root, root.current, lanes, transitions); // TODO: Move to commitPassiveMountEffects
        var profilerEffects = pendingPassiveProfilerEffects;
        pendingPassiveProfilerEffects = [];
        for(var i = 0; i < profilerEffects.length; i++){
            var _fiber = profilerEffects[i];
            commitPassiveEffectDurations(root, _fiber);
        }
        markPassiveEffectsStopped();
        commitDoubleInvokeEffectsInDEV(root.current, true);
        executionContext = prevExecutionContext;
        flushSyncCallbacks();
        // If additional passive effects were scheduled, increment a counter. If this
        // exceeds the limit, we'll fire a warning.
        if (didScheduleUpdateDuringPassiveEffects) {
            if (root === rootWithPassiveNestedUpdates) nestedPassiveUpdateCount++;
            else {
                nestedPassiveUpdateCount = 0;
                rootWithPassiveNestedUpdates = root;
            }
        } else nestedPassiveUpdateCount = 0;
        isFlushingPassiveEffects = false;
        didScheduleUpdateDuringPassiveEffects = false;
        onPostCommitRoot(root);
        var stateNode = root.current.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        return true;
    }
    function isAlreadyFailedLegacyErrorBoundary(instance) {
        return legacyErrorBoundariesThatAlreadyFailed !== null && legacyErrorBoundariesThatAlreadyFailed.has(instance);
    }
    function markLegacyErrorBoundaryAsFailed(instance) {
        if (legacyErrorBoundariesThatAlreadyFailed === null) legacyErrorBoundariesThatAlreadyFailed = new Set([
            instance
        ]);
        else legacyErrorBoundariesThatAlreadyFailed.add(instance);
    }
    function prepareToThrowUncaughtError(error) {
        if (!hasUncaughtError) {
            hasUncaughtError = true;
            firstUncaughtError = error;
        }
    }
    var onUncaughtError = prepareToThrowUncaughtError;
    function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        var errorInfo = createCapturedValueAtFiber(error, sourceFiber);
        var update = createRootErrorUpdate(rootFiber, errorInfo, SyncLane);
        var root = enqueueUpdate(rootFiber, update, SyncLane);
        var eventTime = requestEventTime();
        if (root !== null) {
            markRootUpdated(root, SyncLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
        }
    }
    function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error$1) {
        reportUncaughtErrorInDEV(error$1);
        setIsRunningInsertionEffect(false);
        if (sourceFiber.tag === HostRoot) {
            // Error was thrown at the root. There is no parent, so the root
            // itself should capture it.
            captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error$1);
            return;
        }
        var fiber = null;
        fiber = nearestMountedAncestor;
        while(fiber !== null){
            if (fiber.tag === HostRoot) {
                captureCommitPhaseErrorOnRoot(fiber, sourceFiber, error$1);
                return;
            } else if (fiber.tag === ClassComponent) {
                var ctor = fiber.type;
                var instance = fiber.stateNode;
                if (typeof ctor.getDerivedStateFromError === "function" || typeof instance.componentDidCatch === "function" && !isAlreadyFailedLegacyErrorBoundary(instance)) {
                    var errorInfo = createCapturedValueAtFiber(error$1, sourceFiber);
                    var update = createClassErrorUpdate(fiber, errorInfo, SyncLane);
                    var root = enqueueUpdate(fiber, update, SyncLane);
                    var eventTime = requestEventTime();
                    if (root !== null) {
                        markRootUpdated(root, SyncLane, eventTime);
                        ensureRootIsScheduled(root, eventTime);
                    }
                    return;
                }
            }
            fiber = fiber.return;
        }
        // TODO: Until we re-land skipUnmountedBoundaries (see #20147), this warning
        // will fire for errors that are thrown by destroy functions inside deleted
        // trees. What it should instead do is propagate the error to the parent of
        // the deleted tree. In the meantime, do not add this warning to the
        // allowlist; this is only for our internal use.
        error("Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.\n\nError message:\n\n%s", error$1);
    }
    function pingSuspendedRoot(root, wakeable, pingedLanes) {
        var pingCache = root.pingCache;
        if (pingCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        pingCache.delete(wakeable);
        var eventTime = requestEventTime();
        markRootPinged(root, pingedLanes);
        warnIfSuspenseResolutionNotWrappedWithActDEV(root);
        if (workInProgressRoot === root && isSubsetOfLanes(workInProgressRootRenderLanes, pingedLanes)) {
            // Received a ping at the same priority level at which we're currently
            // rendering. We might want to restart this render. This should mirror
            // the logic of whether or not a root suspends once it completes.
            // TODO: If we're rendering sync either due to Sync, Batched or expired,
            // we should probably never restart.
            // If we're suspended with delay, or if it's a retry, we'll always suspend
            // so we can always restart.
            if (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && includesOnlyRetries(workInProgressRootRenderLanes) && now() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS) // Restart from the root.
            prepareFreshStack(root, NoLanes);
            else // Even though we can't restart right now, we might get an
            // opportunity later. So we mark this render as having a ping.
            workInProgressRootPingedLanes = mergeLanes(workInProgressRootPingedLanes, pingedLanes);
        }
        ensureRootIsScheduled(root, eventTime);
    }
    function retryTimedOutBoundary(boundaryFiber, retryLane) {
        // The boundary fiber (a Suspense component or SuspenseList component)
        // previously was rendered in its fallback state. One of the promises that
        // suspended it has resolved, which means at least part of the tree was
        // likely unblocked. Try rendering again, at a new lanes.
        if (retryLane === NoLane) // TODO: Assign this to `suspenseState.retryLane`? to avoid
        // unnecessary entanglement?
        retryLane = requestRetryLane(boundaryFiber);
         // TODO: Special case idle priority?
        var eventTime = requestEventTime();
        var root = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
        if (root !== null) {
            markRootUpdated(root, retryLane, eventTime);
            ensureRootIsScheduled(root, eventTime);
        }
    }
    function retryDehydratedSuspenseBoundary(boundaryFiber) {
        var suspenseState = boundaryFiber.memoizedState;
        var retryLane = NoLane;
        if (suspenseState !== null) retryLane = suspenseState.retryLane;
        retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function resolveRetryWakeable(boundaryFiber, wakeable) {
        var retryLane = NoLane; // Default
        var retryCache;
        switch(boundaryFiber.tag){
            case SuspenseComponent:
                retryCache = boundaryFiber.stateNode;
                var suspenseState = boundaryFiber.memoizedState;
                if (suspenseState !== null) retryLane = suspenseState.retryLane;
                break;
            case SuspenseListComponent:
                retryCache = boundaryFiber.stateNode;
                break;
            default:
                throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
        }
        if (retryCache !== null) // The wakeable resolved, so we no longer need to memoize, because it will
        // never be thrown again.
        retryCache.delete(wakeable);
        retryTimedOutBoundary(boundaryFiber, retryLane);
    } // Computes the next Just Noticeable Difference (JND) boundary.
    // The theory is that a person can't tell the difference between small differences in time.
    // Therefore, if we wait a bit longer than necessary that won't translate to a noticeable
    // difference in the experience. However, waiting for longer might mean that we can avoid
    // showing an intermediate loading state. The longer we have already waited, the harder it
    // is to tell small differences in time. Therefore, the longer we've already waited,
    // the longer we can wait additionally. At some point we have to give up though.
    // We pick a train model where the next boundary commits at a consistent schedule.
    // These particular numbers are vague estimates. We expect to adjust them based on research.
    function jnd(timeElapsed) {
        return timeElapsed < 120 ? 120 : timeElapsed < 480 ? 480 : timeElapsed < 1080 ? 1080 : timeElapsed < 1920 ? 1920 : timeElapsed < 3000 ? 3000 : timeElapsed < 4320 ? 4320 : ceil(timeElapsed / 1960) * 1960;
    }
    function checkForNestedUpdates() {
        if (nestedUpdateCount > NESTED_UPDATE_LIMIT) {
            nestedUpdateCount = 0;
            rootWithNestedUpdates = null;
            throw new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
        }
        if (nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT) {
            nestedPassiveUpdateCount = 0;
            rootWithPassiveNestedUpdates = null;
            error("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render.");
        }
    }
    function flushRenderPhaseStrictModeWarningsInDEV() {
        ReactStrictModeWarnings.flushLegacyContextWarning();
        ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
    }
    function commitDoubleInvokeEffectsInDEV(fiber, hasPassiveEffects) {
        // TODO (StrictEffects) Should we set a marker on the root if it contains strict effects
        // so we don't traverse unnecessarily? similar to subtreeFlags but just at the root level.
        // Maybe not a big deal since this is DEV only behavior.
        setCurrentFiber(fiber);
        invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectUnmountInDEV);
        if (hasPassiveEffects) invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectUnmountInDEV);
        invokeEffectsInDev(fiber, MountLayoutDev, invokeLayoutEffectMountInDEV);
        if (hasPassiveEffects) invokeEffectsInDev(fiber, MountPassiveDev, invokePassiveEffectMountInDEV);
        resetCurrentFiber();
    }
    function invokeEffectsInDev(firstChild, fiberFlags, invokeEffectFn) {
        // We don't need to re-check StrictEffectsMode here.
        // This function is only called if that check has already passed.
        var current = firstChild;
        var subtreeRoot = null;
        while(current !== null){
            var primarySubtreeFlag = current.subtreeFlags & fiberFlags;
            if (current !== subtreeRoot && current.child !== null && primarySubtreeFlag !== NoFlags) current = current.child;
            else {
                if ((current.flags & fiberFlags) !== NoFlags) invokeEffectFn(current);
                if (current.sibling !== null) current = current.sibling;
                else current = subtreeRoot = current.return;
            }
        }
    }
    var didWarnStateUpdateForNotYetMountedComponent = null;
    function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
        if ((executionContext & RenderContext) !== NoContext) // We let the other warning about render phase updates deal with this one.
        return;
        if (!(fiber.mode & ConcurrentMode)) return;
        var tag = fiber.tag;
        if (tag !== IndeterminateComponent && tag !== HostRoot && tag !== ClassComponent && tag !== FunctionComponent && tag !== ForwardRef && tag !== MemoComponent && tag !== SimpleMemoComponent) // Only warn for user-defined components, not internal ones like Suspense.
        return;
         // We show the whole stack but dedupe on the top component's name because
        // the problematic code almost always lies inside that component.
        var componentName = getComponentNameFromFiber(fiber) || "ReactComponent";
        if (didWarnStateUpdateForNotYetMountedComponent !== null) {
            if (didWarnStateUpdateForNotYetMountedComponent.has(componentName)) return;
            didWarnStateUpdateForNotYetMountedComponent.add(componentName);
        } else didWarnStateUpdateForNotYetMountedComponent = new Set([
            componentName
        ]);
        var previousFiber = current;
        try {
            setCurrentFiber(fiber);
            error("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
        } finally{
            if (previousFiber) setCurrentFiber(fiber);
            else resetCurrentFiber();
        }
    }
    var beginWork$1;
    var dummyFiber = null;
    beginWork$1 = function(current, unitOfWork, lanes) {
        // If a component throws an error, we replay it again in a synchronously
        // dispatched event, so that the debugger will treat it as an uncaught
        // error See ReactErrorUtils for more information.
        // Before entering the begin phase, copy the work-in-progress onto a dummy
        // fiber. If beginWork throws, we'll use this to reset the state.
        var originalWorkInProgressCopy = assignFiberPropertiesInDEV(dummyFiber, unitOfWork);
        try {
            return beginWork(current, unitOfWork, lanes);
        } catch (originalError) {
            if (didSuspendOrErrorWhileHydratingDEV() || originalError !== null && typeof originalError === "object" && typeof originalError.then === "function") // Don't replay promises.
            // Don't replay errors if we are hydrating and have already suspended or handled an error
            throw originalError;
             // Keep this code in sync with handleError; any changes here must have
            // corresponding changes there.
            resetContextDependencies();
            resetHooksAfterThrow(); // Don't reset current debug fiber, since we're about to work on the
            // same fiber again.
            // Unwind the failed stack frame
            unwindInterruptedWork(current, unitOfWork); // Restore the original properties of the fiber.
            assignFiberPropertiesInDEV(unitOfWork, originalWorkInProgressCopy);
            if (unitOfWork.mode & ProfileMode) // Reset the profiler timer.
            startProfilerTimer(unitOfWork);
             // Run beginWork again.
            invokeGuardedCallback(null, beginWork, null, current, unitOfWork, lanes);
            if (hasCaughtError()) {
                var replayError = clearCaughtError();
                if (typeof replayError === "object" && replayError !== null && replayError._suppressLogging && typeof originalError === "object" && originalError !== null && !originalError._suppressLogging) // If suppressed, let the flag carry over to the original error which is the one we'll rethrow.
                originalError._suppressLogging = true;
            } // We always throw the original error in case the second render pass is not idempotent.
            // This can happen if a memoized function or CommonJS module doesn't throw after first invocation.
            throw originalError;
        }
    };
    var didWarnAboutUpdateInRender = false;
    var didWarnAboutUpdateInRenderForAnotherComponent;
    didWarnAboutUpdateInRenderForAnotherComponent = new Set();
    function warnAboutRenderPhaseUpdatesInDEV(fiber) {
        if (isRendering && !getIsUpdatingOpaqueValueInRenderPhaseInDEV()) switch(fiber.tag){
            case FunctionComponent:
            case ForwardRef:
            case SimpleMemoComponent:
                var renderingComponentName = workInProgress && getComponentNameFromFiber(workInProgress) || "Unknown"; // Dedupe by the rendering component because it's the one that needs to be fixed.
                var dedupeKey = renderingComponentName;
                if (!didWarnAboutUpdateInRenderForAnotherComponent.has(dedupeKey)) {
                    didWarnAboutUpdateInRenderForAnotherComponent.add(dedupeKey);
                    var setStateComponentName = getComponentNameFromFiber(fiber) || "Unknown";
                    error("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", setStateComponentName, renderingComponentName, renderingComponentName);
                }
                break;
            case ClassComponent:
                if (!didWarnAboutUpdateInRender) {
                    error("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state.");
                    didWarnAboutUpdateInRender = true;
                }
                break;
        }
    }
    function restorePendingUpdaters(root, lanes) {
        if (isDevToolsPresent) {
            var memoizedUpdaters = root.memoizedUpdaters;
            memoizedUpdaters.forEach(function(schedulingFiber) {
                addFiberToLanesMap(root, schedulingFiber, lanes);
            }); // This function intentionally does not clear memoized updaters.
        // Those may still be relevant to the current commit
        // and a future one (e.g. Suspense).
        }
    }
    var fakeActCallbackNode = {};
    function scheduleCallback$1(priorityLevel, callback) {
        // If we're currently inside an `act` scope, bypass Scheduler and push to
        // the `act` queue instead.
        var actQueue = ReactCurrentActQueue$1.current;
        if (actQueue !== null) {
            actQueue.push(callback);
            return fakeActCallbackNode;
        } else return scheduleCallback(priorityLevel, callback);
    }
    function cancelCallback$1(callbackNode) {
        if (callbackNode === fakeActCallbackNode) return;
         // In production, always call Scheduler. This function will be stripped out.
        return cancelCallback(callbackNode);
    }
    function shouldForceFlushFallbacksInDEV() {
        // Never force flush in production. This function should get stripped out.
        return ReactCurrentActQueue$1.current !== null;
    }
    function warnIfUpdatesNotWrappedWithActDEV(fiber) {
        if (fiber.mode & ConcurrentMode) {
            if (!isConcurrentActEnvironment()) // Not in an act environment. No need to warn.
            return;
        } else {
            // Legacy mode has additional cases where we suppress a warning.
            if (!isLegacyActEnvironment()) // Not in an act environment. No need to warn.
            return;
            if (executionContext !== NoContext) // Legacy mode doesn't warn if the update is batched, i.e.
            // batchedUpdates or flushSync.
            return;
            if (fiber.tag !== FunctionComponent && fiber.tag !== ForwardRef && fiber.tag !== SimpleMemoComponent) // For backwards compatibility with pre-hooks code, legacy mode only
            // warns for updates that originate from a hook.
            return;
        }
        if (ReactCurrentActQueue$1.current === null) {
            var previousFiber = current;
            try {
                setCurrentFiber(fiber);
                error("An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act", getComponentNameFromFiber(fiber));
            } finally{
                if (previousFiber) setCurrentFiber(fiber);
                else resetCurrentFiber();
            }
        }
    }
    function warnIfSuspenseResolutionNotWrappedWithActDEV(root) {
        if (root.tag !== LegacyRoot && isConcurrentActEnvironment() && ReactCurrentActQueue$1.current === null) error("A suspended resource finished loading inside a test, but the event was not wrapped in act(...).\n\nWhen testing, code that resolves suspended data should be wrapped into act(...):\n\nact(() => {\n  /* finish loading suspended data */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act");
    }
    function setIsRunningInsertionEffect(isRunning) {
        isRunningInsertionEffect = isRunning;
    }
    /* eslint-disable react-internal/prod-error-codes */ var resolveFamily = null; // $FlowFixMe Flow gets confused by a WeakSet feature check below.
    var failedBoundaries = null;
    var setRefreshHandler = function(handler) {
        resolveFamily = handler;
    };
    function resolveFunctionForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) return type;
         // Use the latest known implementation.
        return family.current;
    }
    function resolveClassForHotReloading(type) {
        // No implementation differences.
        return resolveFunctionForHotReloading(type);
    }
    function resolveForwardRefForHotReloading(type) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return type;
        var family = resolveFamily(type);
        if (family === undefined) {
            // Check if we're dealing with a real forwardRef. Don't want to crash early.
            if (type !== null && type !== undefined && typeof type.render === "function") {
                // ForwardRef is special because its resolved .type is an object,
                // but it's possible that we only have its inner render function in the map.
                // If that inner render function is different, we'll build a new forwardRef type.
                var currentRender = resolveFunctionForHotReloading(type.render);
                if (type.render !== currentRender) {
                    var syntheticType = {
                        $$typeof: REACT_FORWARD_REF_TYPE,
                        render: currentRender
                    };
                    if (type.displayName !== undefined) syntheticType.displayName = type.displayName;
                    return syntheticType;
                }
            }
            return type;
        } // Use the latest known implementation.
        return family.current;
    }
    function isCompatibleFamilyForHotReloading(fiber, element) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return false;
        var prevType = fiber.elementType;
        var nextType = element.type; // If we got here, we know types aren't === equal.
        var needsCompareFamilies = false;
        var $$typeofNextType = typeof nextType === "object" && nextType !== null ? nextType.$$typeof : null;
        switch(fiber.tag){
            case ClassComponent:
                if (typeof nextType === "function") needsCompareFamilies = true;
                break;
            case FunctionComponent:
                if (typeof nextType === "function") needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) // We don't know the inner type yet.
                // We're going to assume that the lazy inner type is stable,
                // and so it is sufficient to avoid reconciling it away.
                // We're not going to unwrap or actually use the new lazy type.
                needsCompareFamilies = true;
                break;
            case ForwardRef:
                if ($$typeofNextType === REACT_FORWARD_REF_TYPE) needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            case MemoComponent:
            case SimpleMemoComponent:
                if ($$typeofNextType === REACT_MEMO_TYPE) // TODO: if it was but can no longer be simple,
                // we shouldn't set this.
                needsCompareFamilies = true;
                else if ($$typeofNextType === REACT_LAZY_TYPE) needsCompareFamilies = true;
                break;
            default:
                return false;
        } // Check if both types have a family and it's the same one.
        if (needsCompareFamilies) {
            // Note: memo() and forwardRef() we'll compare outer rather than inner type.
            // This means both of them need to be registered to preserve state.
            // If we unwrapped and compared the inner types for wrappers instead,
            // then we would risk falsely saying two separate memo(Foo)
            // calls are equivalent because they wrap the same Foo function.
            var prevFamily = resolveFamily(prevType);
            if (prevFamily !== undefined && prevFamily === resolveFamily(nextType)) return true;
        }
        return false;
    }
    function markFailedErrorBoundaryForHotReloading(fiber) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        if (typeof WeakSet !== "function") return;
        if (failedBoundaries === null) failedBoundaries = new WeakSet();
        failedBoundaries.add(fiber);
    }
    var scheduleRefresh = function(root, update) {
        if (resolveFamily === null) // Hot reloading is disabled.
        return;
        var staleFamilies = update.staleFamilies, updatedFamilies = update.updatedFamilies;
        flushPassiveEffects();
        flushSync(function() {
            scheduleFibersWithFamiliesRecursively(root.current, updatedFamilies, staleFamilies);
        });
    };
    var scheduleRoot = function(root, element) {
        if (root.context !== emptyContextObject) // Super edge case: root has a legacy _renderSubtree context
        // but we don't know the parentComponent so we can't pass it.
        // Just ignore. We'll delete this with _renderSubtree code path later.
        return;
        flushPassiveEffects();
        flushSync(function() {
            updateContainer(element, root, null, null);
        });
    };
    function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
        var alternate = fiber.alternate, child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        if (resolveFamily === null) throw new Error("Expected resolveFamily to be set during hot reload.");
        var needsRender = false;
        var needsRemount = false;
        if (candidateType !== null) {
            var family = resolveFamily(candidateType);
            if (family !== undefined) {
                if (staleFamilies.has(family)) needsRemount = true;
                else if (updatedFamilies.has(family)) {
                    if (tag === ClassComponent) needsRemount = true;
                    else needsRender = true;
                }
            }
        }
        if (failedBoundaries !== null) {
            if (failedBoundaries.has(fiber) || alternate !== null && failedBoundaries.has(alternate)) needsRemount = true;
        }
        if (needsRemount) fiber._debugNeedsRemount = true;
        if (needsRemount || needsRender) {
            var _root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (_root !== null) scheduleUpdateOnFiber(_root, fiber, SyncLane, NoTimestamp);
        }
        if (child !== null && !needsRemount) scheduleFibersWithFamiliesRecursively(child, updatedFamilies, staleFamilies);
        if (sibling !== null) scheduleFibersWithFamiliesRecursively(sibling, updatedFamilies, staleFamilies);
    }
    var findHostInstancesForRefresh = function(root, families) {
        var hostInstances = new Set();
        var types = new Set(families.map(function(family) {
            return family.current;
        }));
        findHostInstancesForMatchingFibersRecursively(root.current, types, hostInstances);
        return hostInstances;
    };
    function findHostInstancesForMatchingFibersRecursively(fiber, types, hostInstances) {
        var child = fiber.child, sibling = fiber.sibling, tag = fiber.tag, type = fiber.type;
        var candidateType = null;
        switch(tag){
            case FunctionComponent:
            case SimpleMemoComponent:
            case ClassComponent:
                candidateType = type;
                break;
            case ForwardRef:
                candidateType = type.render;
                break;
        }
        var didMatch = false;
        if (candidateType !== null) {
            if (types.has(candidateType)) didMatch = true;
        }
        if (didMatch) // We have a match. This only drills down to the closest host components.
        // There's no need to search deeper because for the purpose of giving
        // visual feedback, "flashing" outermost parent rectangles is sufficient.
        findHostInstancesForFiberShallowly(fiber, hostInstances);
        else // If there's no match, maybe there will be one further down in the child tree.
        if (child !== null) findHostInstancesForMatchingFibersRecursively(child, types, hostInstances);
        if (sibling !== null) findHostInstancesForMatchingFibersRecursively(sibling, types, hostInstances);
    }
    function findHostInstancesForFiberShallowly(fiber, hostInstances) {
        var foundHostInstances = findChildHostInstancesForFiberShallowly(fiber, hostInstances);
        if (foundHostInstances) return;
         // If we didn't find any host children, fallback to closest host parent.
        var node = fiber;
        while(true){
            switch(node.tag){
                case HostComponent:
                    hostInstances.add(node.stateNode);
                    return;
                case HostPortal:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
                case HostRoot:
                    hostInstances.add(node.stateNode.containerInfo);
                    return;
            }
            if (node.return === null) throw new Error("Expected to reach root first.");
            node = node.return;
        }
    }
    function findChildHostInstancesForFiberShallowly(fiber, hostInstances) {
        var node = fiber;
        var foundHostInstances = false;
        while(true){
            if (node.tag === HostComponent) {
                // We got a match.
                foundHostInstances = true;
                hostInstances.add(node.stateNode); // There may still be more, so keep searching.
            } else if (node.child !== null) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === fiber) return foundHostInstances;
            while(node.sibling === null){
                if (node.return === null || node.return === fiber) return foundHostInstances;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return false;
    }
    var hasBadMapPolyfill;
    hasBadMapPolyfill = false;
    try {
        var nonExtensibleObject = Object.preventExtensions({});
        /* eslint-disable no-new */ new Map([
            [
                nonExtensibleObject,
                null
            ]
        ]);
        new Set([
            nonExtensibleObject
        ]);
    /* eslint-enable no-new */ } catch (e) {
        // TODO: Consider warning about bad polyfills
        hasBadMapPolyfill = true;
    }
    function FiberNode(tag, pendingProps, key, mode) {
        // Instance
        this.tag = tag;
        this.key = key;
        this.elementType = null;
        this.type = null;
        this.stateNode = null; // Fiber
        this.return = null;
        this.child = null;
        this.sibling = null;
        this.index = 0;
        this.ref = null;
        this.pendingProps = pendingProps;
        this.memoizedProps = null;
        this.updateQueue = null;
        this.memoizedState = null;
        this.dependencies = null;
        this.mode = mode; // Effects
        this.flags = NoFlags;
        this.subtreeFlags = NoFlags;
        this.deletions = null;
        this.lanes = NoLanes;
        this.childLanes = NoLanes;
        this.alternate = null;
        // Note: The following is done to avoid a v8 performance cliff.
        //
        // Initializing the fields below to smis and later updating them with
        // double values will cause Fibers to end up having separate shapes.
        // This behavior/bug has something to do with Object.preventExtension().
        // Fortunately this only impacts DEV builds.
        // Unfortunately it makes React unusably slow for some applications.
        // To work around this, initialize the fields below with doubles.
        //
        // Learn more about this here:
        // https://github.com/facebook/react/issues/14365
        // https://bugs.chromium.org/p/v8/issues/detail?id=8538
        this.actualDuration = Number.NaN;
        this.actualStartTime = Number.NaN;
        this.selfBaseDuration = Number.NaN;
        this.treeBaseDuration = Number.NaN; // It's okay to replace the initial doubles with smis after initialization.
        // This won't trigger the performance cliff mentioned above,
        // and it simplifies other profiler code (including DevTools).
        this.actualDuration = 0;
        this.actualStartTime = -1;
        this.selfBaseDuration = 0;
        this.treeBaseDuration = 0;
        // This isn't directly used but is handy for debugging internals:
        this._debugSource = null;
        this._debugOwner = null;
        this._debugNeedsRemount = false;
        this._debugHookTypes = null;
        if (!hasBadMapPolyfill && typeof Object.preventExtensions === "function") Object.preventExtensions(this);
    } // This is a constructor function, rather than a POJO constructor, still
    // please ensure we do the following:
    // 1) Nobody should add any instance methods on this. Instance methods can be
    //    more difficult to predict when they get optimized and they are almost
    //    never inlined properly in static compilers.
    // 2) Nobody should rely on `instanceof Fiber` for type testing. We should
    //    always know when it is a fiber.
    // 3) We might want to experiment with using numeric keys since they are easier
    //    to optimize in a non-JIT environment.
    // 4) We can easily go from a constructor to a createFiber object literal if that
    //    is faster.
    // 5) It should be easy to port this to a C struct and keep a C implementation
    //    compatible.
    var createFiber = function(tag, pendingProps, key, mode) {
        // $FlowFixMe: the shapes are exact here but Flow doesn't like constructors
        return new FiberNode(tag, pendingProps, key, mode);
    };
    function shouldConstruct$1(Component) {
        var prototype = Component.prototype;
        return !!(prototype && prototype.isReactComponent);
    }
    function isSimpleFunctionComponent(type) {
        return typeof type === "function" && !shouldConstruct$1(type) && type.defaultProps === undefined;
    }
    function resolveLazyComponentTag(Component) {
        if (typeof Component === "function") return shouldConstruct$1(Component) ? ClassComponent : FunctionComponent;
        else if (Component !== undefined && Component !== null) {
            var $$typeof = Component.$$typeof;
            if ($$typeof === REACT_FORWARD_REF_TYPE) return ForwardRef;
            if ($$typeof === REACT_MEMO_TYPE) return MemoComponent;
        }
        return IndeterminateComponent;
    } // This is used to create an alternate fiber to do work on.
    function createWorkInProgress(current, pendingProps) {
        var workInProgress = current.alternate;
        if (workInProgress === null) {
            // We use a double buffering pooling technique because we know that we'll
            // only ever need at most two versions of a tree. We pool the "other" unused
            // node that we're free to reuse. This is lazily created to avoid allocating
            // extra objects for things that are never updated. It also allow us to
            // reclaim the extra memory if needed.
            workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode);
            workInProgress.elementType = current.elementType;
            workInProgress.type = current.type;
            workInProgress.stateNode = current.stateNode;
            // DEV-only fields
            workInProgress._debugSource = current._debugSource;
            workInProgress._debugOwner = current._debugOwner;
            workInProgress._debugHookTypes = current._debugHookTypes;
            workInProgress.alternate = current;
            current.alternate = workInProgress;
        } else {
            workInProgress.pendingProps = pendingProps; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // We already have an alternate.
            // Reset the effect tag.
            workInProgress.flags = NoFlags; // The effects are no longer valid.
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.deletions = null;
            // We intentionally reset, rather than copy, actualDuration & actualStartTime.
            // This prevents time from endlessly accumulating in new commits.
            // This has the downside of resetting values for different priority renders,
            // But works for yielding (the common case) and should support resuming.
            workInProgress.actualDuration = 0;
            workInProgress.actualStartTime = -1;
        } // Reset all effects except static ones.
        // Static effects are not specific to a render.
        workInProgress.flags = current.flags & StaticMask;
        workInProgress.childLanes = current.childLanes;
        workInProgress.lanes = current.lanes;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue; // Clone the dependencies object. This is mutated during the render phase, so
        // it cannot be shared with the current fiber.
        var currentDependencies = current.dependencies;
        workInProgress.dependencies = currentDependencies === null ? null : {
            lanes: currentDependencies.lanes,
            firstContext: currentDependencies.firstContext
        }; // These will be overridden during the parent's reconciliation
        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        workInProgress.selfBaseDuration = current.selfBaseDuration;
        workInProgress.treeBaseDuration = current.treeBaseDuration;
        workInProgress._debugNeedsRemount = current._debugNeedsRemount;
        switch(workInProgress.tag){
            case IndeterminateComponent:
            case FunctionComponent:
            case SimpleMemoComponent:
                workInProgress.type = resolveFunctionForHotReloading(current.type);
                break;
            case ClassComponent:
                workInProgress.type = resolveClassForHotReloading(current.type);
                break;
            case ForwardRef:
                workInProgress.type = resolveForwardRefForHotReloading(current.type);
                break;
        }
        return workInProgress;
    } // Used to reuse a Fiber for a second pass.
    function resetWorkInProgress(workInProgress, renderLanes) {
        // This resets the Fiber to what createFiber or createWorkInProgress would
        // have set the values to before during the first pass. Ideally this wouldn't
        // be necessary but unfortunately many code paths reads from the workInProgress
        // when they should be reading from current and writing to workInProgress.
        // We assume pendingProps, index, key, ref, return are still untouched to
        // avoid doing another reconciliation.
        // Reset the effect flags but keep any Placement tags, since that's something
        // that child fiber is setting, not the reconciliation.
        workInProgress.flags &= StaticMask | Placement; // The effects are no longer valid.
        var current = workInProgress.alternate;
        if (current === null) {
            // Reset to createFiber's initial values.
            workInProgress.childLanes = NoLanes;
            workInProgress.lanes = renderLanes;
            workInProgress.child = null;
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.memoizedProps = null;
            workInProgress.memoizedState = null;
            workInProgress.updateQueue = null;
            workInProgress.dependencies = null;
            workInProgress.stateNode = null;
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = 0;
            workInProgress.treeBaseDuration = 0;
        } else {
            // Reset to the cloned values that createWorkInProgress would've.
            workInProgress.childLanes = current.childLanes;
            workInProgress.lanes = current.lanes;
            workInProgress.child = current.child;
            workInProgress.subtreeFlags = NoFlags;
            workInProgress.deletions = null;
            workInProgress.memoizedProps = current.memoizedProps;
            workInProgress.memoizedState = current.memoizedState;
            workInProgress.updateQueue = current.updateQueue; // Needed because Blocks store data on type.
            workInProgress.type = current.type; // Clone the dependencies object. This is mutated during the render phase, so
            // it cannot be shared with the current fiber.
            var currentDependencies = current.dependencies;
            workInProgress.dependencies = currentDependencies === null ? null : {
                lanes: currentDependencies.lanes,
                firstContext: currentDependencies.firstContext
            };
            // Note: We don't reset the actualTime counts. It's useful to accumulate
            // actual time across multiple render passes.
            workInProgress.selfBaseDuration = current.selfBaseDuration;
            workInProgress.treeBaseDuration = current.treeBaseDuration;
        }
        return workInProgress;
    }
    function createHostRootFiber(tag, isStrictMode, concurrentUpdatesByDefaultOverride) {
        var mode;
        if (tag === ConcurrentRoot) {
            mode = ConcurrentMode;
            if (isStrictMode === true) {
                mode |= StrictLegacyMode;
                mode |= StrictEffectsMode;
            }
        } else mode = NoMode;
        if (isDevToolsPresent) // Always collect profile timings when DevTools are present.
        // This enables DevTools to start capturing timing at any point–
        // Without some nodes in the tree having empty base times.
        mode |= ProfileMode;
        return createFiber(HostRoot, null, null, mode);
    }
    function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
        var fiberTag = IndeterminateComponent; // The resolved type is set if we know what the final type will be. I.e. it's not lazy.
        var resolvedType = type;
        if (typeof type === "function") {
            if (shouldConstruct$1(type)) {
                fiberTag = ClassComponent;
                resolvedType = resolveClassForHotReloading(resolvedType);
            } else resolvedType = resolveFunctionForHotReloading(resolvedType);
        } else if (typeof type === "string") fiberTag = HostComponent;
        else getTag: switch(type){
            case REACT_FRAGMENT_TYPE:
                return createFiberFromFragment(pendingProps.children, mode, lanes, key);
            case REACT_STRICT_MODE_TYPE:
                fiberTag = Mode;
                mode |= StrictLegacyMode;
                if ((mode & ConcurrentMode) !== NoMode) // Strict effects should never run on legacy roots
                mode |= StrictEffectsMode;
                break;
            case REACT_PROFILER_TYPE:
                return createFiberFromProfiler(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_TYPE:
                return createFiberFromSuspense(pendingProps, mode, lanes, key);
            case REACT_SUSPENSE_LIST_TYPE:
                return createFiberFromSuspenseList(pendingProps, mode, lanes, key);
            case REACT_OFFSCREEN_TYPE:
                return createFiberFromOffscreen(pendingProps, mode, lanes, key);
            case REACT_LEGACY_HIDDEN_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_SCOPE_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_CACHE_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_TRACING_MARKER_TYPE:
            // eslint-disable-next-line no-fallthrough
            case REACT_DEBUG_TRACING_MODE_TYPE:
            // eslint-disable-next-line no-fallthrough
            default:
                if (typeof type === "object" && type !== null) switch(type.$$typeof){
                    case REACT_PROVIDER_TYPE:
                        fiberTag = ContextProvider;
                        break getTag;
                    case REACT_CONTEXT_TYPE:
                        // This is a consumer
                        fiberTag = ContextConsumer;
                        break getTag;
                    case REACT_FORWARD_REF_TYPE:
                        fiberTag = ForwardRef;
                        resolvedType = resolveForwardRefForHotReloading(resolvedType);
                        break getTag;
                    case REACT_MEMO_TYPE:
                        fiberTag = MemoComponent;
                        break getTag;
                    case REACT_LAZY_TYPE:
                        fiberTag = LazyComponent;
                        resolvedType = null;
                        break getTag;
                }
                var info = "";
                if (type === undefined || typeof type === "object" && type !== null && Object.keys(type).length === 0) info += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
                var ownerName = owner ? getComponentNameFromFiber(owner) : null;
                if (ownerName) info += "\n\nCheck the render method of `" + ownerName + "`.";
                throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (type == null ? type : typeof type) + "." + info));
        }
        var fiber = createFiber(fiberTag, pendingProps, key, mode);
        fiber.elementType = type;
        fiber.type = resolvedType;
        fiber.lanes = lanes;
        fiber._debugOwner = owner;
        return fiber;
    }
    function createFiberFromElement(element, mode, lanes) {
        var owner = null;
        owner = element._owner;
        var type = element.type;
        var key = element.key;
        var pendingProps = element.props;
        var fiber = createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes);
        fiber._debugSource = element._source;
        fiber._debugOwner = element._owner;
        return fiber;
    }
    function createFiberFromFragment(elements, mode, lanes, key) {
        var fiber = createFiber(Fragment, elements, key, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromProfiler(pendingProps, mode, lanes, key) {
        if (typeof pendingProps.id !== "string") error('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof pendingProps.id);
        var fiber = createFiber(Profiler, pendingProps, key, mode | ProfileMode);
        fiber.elementType = REACT_PROFILER_TYPE;
        fiber.lanes = lanes;
        fiber.stateNode = {
            effectDuration: 0,
            passiveEffectDuration: 0
        };
        return fiber;
    }
    function createFiberFromSuspense(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromSuspenseList(pendingProps, mode, lanes, key) {
        var fiber = createFiber(SuspenseListComponent, pendingProps, key, mode);
        fiber.elementType = REACT_SUSPENSE_LIST_TYPE;
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromOffscreen(pendingProps, mode, lanes, key) {
        var fiber = createFiber(OffscreenComponent, pendingProps, key, mode);
        fiber.elementType = REACT_OFFSCREEN_TYPE;
        fiber.lanes = lanes;
        var primaryChildInstance = {
            isHidden: false
        };
        fiber.stateNode = primaryChildInstance;
        return fiber;
    }
    function createFiberFromText(content, mode, lanes) {
        var fiber = createFiber(HostText, content, null, mode);
        fiber.lanes = lanes;
        return fiber;
    }
    function createFiberFromHostInstanceForDeletion() {
        var fiber = createFiber(HostComponent, null, null, NoMode);
        fiber.elementType = "DELETED";
        return fiber;
    }
    function createFiberFromDehydratedFragment(dehydratedNode) {
        var fiber = createFiber(DehydratedFragment, null, null, NoMode);
        fiber.stateNode = dehydratedNode;
        return fiber;
    }
    function createFiberFromPortal(portal, mode, lanes) {
        var pendingProps = portal.children !== null ? portal.children : [];
        var fiber = createFiber(HostPortal, pendingProps, portal.key, mode);
        fiber.lanes = lanes;
        fiber.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            // Used by persistent updates
            implementation: portal.implementation
        };
        return fiber;
    } // Used for stashing WIP properties to replay failed work in DEV.
    function assignFiberPropertiesInDEV(target, source) {
        if (target === null) // This Fiber's initial properties will always be overwritten.
        // We only use a Fiber to ensure the same hidden class so DEV isn't slow.
        target = createFiber(IndeterminateComponent, null, null, NoMode);
         // This is intentionally written as a list of all properties.
        // We tried to use Object.assign() instead but this is called in
        // the hottest path, and Object.assign() was too slow:
        // https://github.com/facebook/react/issues/12502
        // This code is DEV-only so size is not a concern.
        target.tag = source.tag;
        target.key = source.key;
        target.elementType = source.elementType;
        target.type = source.type;
        target.stateNode = source.stateNode;
        target.return = source.return;
        target.child = source.child;
        target.sibling = source.sibling;
        target.index = source.index;
        target.ref = source.ref;
        target.pendingProps = source.pendingProps;
        target.memoizedProps = source.memoizedProps;
        target.updateQueue = source.updateQueue;
        target.memoizedState = source.memoizedState;
        target.dependencies = source.dependencies;
        target.mode = source.mode;
        target.flags = source.flags;
        target.subtreeFlags = source.subtreeFlags;
        target.deletions = source.deletions;
        target.lanes = source.lanes;
        target.childLanes = source.childLanes;
        target.alternate = source.alternate;
        target.actualDuration = source.actualDuration;
        target.actualStartTime = source.actualStartTime;
        target.selfBaseDuration = source.selfBaseDuration;
        target.treeBaseDuration = source.treeBaseDuration;
        target._debugSource = source._debugSource;
        target._debugOwner = source._debugOwner;
        target._debugNeedsRemount = source._debugNeedsRemount;
        target._debugHookTypes = source._debugHookTypes;
        return target;
    }
    function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError) {
        this.tag = tag;
        this.containerInfo = containerInfo;
        this.pendingChildren = null;
        this.current = null;
        this.pingCache = null;
        this.finishedWork = null;
        this.timeoutHandle = noTimeout;
        this.context = null;
        this.pendingContext = null;
        this.callbackNode = null;
        this.callbackPriority = NoLane;
        this.eventTimes = createLaneMap(NoLanes);
        this.expirationTimes = createLaneMap(NoTimestamp);
        this.pendingLanes = NoLanes;
        this.suspendedLanes = NoLanes;
        this.pingedLanes = NoLanes;
        this.expiredLanes = NoLanes;
        this.mutableReadLanes = NoLanes;
        this.finishedLanes = NoLanes;
        this.entangledLanes = NoLanes;
        this.entanglements = createLaneMap(NoLanes);
        this.identifierPrefix = identifierPrefix;
        this.onRecoverableError = onRecoverableError;
        this.mutableSourceEagerHydrationData = null;
        this.effectDuration = 0;
        this.passiveEffectDuration = 0;
        this.memoizedUpdaters = new Set();
        var pendingUpdatersLaneMap = this.pendingUpdatersLaneMap = [];
        for(var _i = 0; _i < TotalLanes; _i++)pendingUpdatersLaneMap.push(new Set());
        switch(tag){
            case ConcurrentRoot:
                this._debugRootType = hydrate ? "hydrateRoot()" : "createRoot()";
                break;
            case LegacyRoot:
                this._debugRootType = hydrate ? "hydrate()" : "render()";
                break;
        }
    }
    function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, // host config, but because they are passed in at runtime, we have to thread
    // them through the root constructor. Perhaps we should put them all into a
    // single type, like a DynamicHostConfig that is defined by the renderer.
    identifierPrefix, onRecoverableError, transitionCallbacks) {
        var root = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onRecoverableError);
        // stateNode is any.
        var uninitializedFiber = createHostRootFiber(tag, isStrictMode);
        root.current = uninitializedFiber;
        uninitializedFiber.stateNode = root;
        var _initialState = {
            element: initialChildren,
            isDehydrated: hydrate,
            cache: null,
            // not enabled yet
            transitions: null,
            pendingSuspenseBoundaries: null
        };
        uninitializedFiber.memoizedState = _initialState;
        initializeUpdateQueue(uninitializedFiber);
        return root;
    }
    var ReactVersion = "18.3.1";
    function createPortal(children, containerInfo, implementation) {
        var key = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
        checkKeyStringCoercion(key);
        return {
            // This tag allow us to uniquely identify this as a React Portal
            $$typeof: REACT_PORTAL_TYPE,
            key: key == null ? null : "" + key,
            children: children,
            containerInfo: containerInfo,
            implementation: implementation
        };
    }
    var didWarnAboutNestedUpdates;
    var didWarnAboutFindNodeInStrictMode;
    didWarnAboutNestedUpdates = false;
    didWarnAboutFindNodeInStrictMode = {};
    function getContextForSubtree(parentComponent) {
        if (!parentComponent) return emptyContextObject;
        var fiber = get(parentComponent);
        var parentContext = findCurrentUnmaskedContext(fiber);
        if (fiber.tag === ClassComponent) {
            var Component = fiber.type;
            if (isContextProvider(Component)) return processChildContext(fiber, Component, parentContext);
        }
        return parentContext;
    }
    function findHostInstanceWithWarning(component, methodName) {
        var fiber = get(component);
        if (fiber === undefined) {
            if (typeof component.render === "function") throw new Error("Unable to find node on an unmounted component.");
            else {
                var keys = Object.keys(component).join(",");
                throw new Error("Argument appears to not be a ReactComponent. Keys: " + keys);
            }
        }
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        if (hostFiber.mode & StrictLegacyMode) {
            var componentName = getComponentNameFromFiber(fiber) || "Component";
            if (!didWarnAboutFindNodeInStrictMode[componentName]) {
                didWarnAboutFindNodeInStrictMode[componentName] = true;
                var previousFiber = current;
                try {
                    setCurrentFiber(hostFiber);
                    if (fiber.mode & StrictLegacyMode) error("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                    else error("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", methodName, methodName, componentName);
                } finally{
                    // Ideally this should reset to previous but this shouldn't be called in
                    // render and there's another warning for that anyway.
                    if (previousFiber) setCurrentFiber(previousFiber);
                    else resetCurrentFiber();
                }
            }
        }
        return hostFiber.stateNode;
    }
    function createContainer(containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = false;
        var initialChildren = null;
        return createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
    }
    function createHydrationContainer(initialChildren, callback, containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError, transitionCallbacks) {
        var hydrate = true;
        var root = createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError); // TODO: Move this to FiberRoot constructor
        root.context = getContextForSubtree(null); // Schedule the initial render. In a hydration root, this is different from
        // a regular update because the initial render must match was was rendered
        // on the server.
        // NOTE: This update intentionally doesn't have a payload. We're only using
        // the update to schedule work on the root fiber (and, for legacy roots, to
        // enqueue the callback if one is provided).
        var current = root.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current);
        var update = createUpdate(eventTime, lane);
        update.callback = callback !== undefined && callback !== null ? callback : null;
        enqueueUpdate(current, update, lane);
        scheduleInitialHydrationOnRoot(root, lane, eventTime);
        return root;
    }
    function updateContainer(element, container, parentComponent, callback) {
        onScheduleRoot(container, element);
        var current$1 = container.current;
        var eventTime = requestEventTime();
        var lane = requestUpdateLane(current$1);
        markRenderScheduled(lane);
        var context = getContextForSubtree(parentComponent);
        if (container.context === null) container.context = context;
        else container.pendingContext = context;
        if (isRendering && current !== null && !didWarnAboutNestedUpdates) {
            didWarnAboutNestedUpdates = true;
            error("Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.", getComponentNameFromFiber(current) || "Unknown");
        }
        var update = createUpdate(eventTime, lane); // Caution: React DevTools currently depends on this property
        // being called "element".
        update.payload = {
            element: element
        };
        callback = callback === undefined ? null : callback;
        if (callback !== null) {
            if (typeof callback !== "function") error("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callback);
            update.callback = callback;
        }
        var root = enqueueUpdate(current$1, update, lane);
        if (root !== null) {
            scheduleUpdateOnFiber(root, current$1, lane, eventTime);
            entangleTransitions(root, current$1, lane);
        }
        return lane;
    }
    function getPublicRootInstance(container) {
        var containerFiber = container.current;
        if (!containerFiber.child) return null;
        switch(containerFiber.child.tag){
            case HostComponent:
                return getPublicInstance(containerFiber.child.stateNode);
            default:
                return containerFiber.child.stateNode;
        }
    }
    function attemptSynchronousHydration$1(fiber) {
        switch(fiber.tag){
            case HostRoot:
                var root = fiber.stateNode;
                if (isRootDehydrated(root)) {
                    // Flush the first scheduled "update".
                    var lanes = getHighestPriorityPendingLanes(root);
                    flushRoot(root, lanes);
                }
                break;
            case SuspenseComponent:
                flushSync(function() {
                    var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
                    if (root !== null) {
                        var eventTime = requestEventTime();
                        scheduleUpdateOnFiber(root, fiber, SyncLane, eventTime);
                    }
                }); // If we're still blocked after this, we need to increase
                // the priority of any promises resolving within this
                // boundary so that they next attempt also has higher pri.
                var retryLane = SyncLane;
                markRetryLaneIfNotHydrated(fiber, retryLane);
                break;
        }
    }
    function markRetryLaneImpl(fiber, retryLane) {
        var suspenseState = fiber.memoizedState;
        if (suspenseState !== null && suspenseState.dehydrated !== null) suspenseState.retryLane = higherPriorityLane(suspenseState.retryLane, retryLane);
    } // Increases the priority of thenables when they resolve within this boundary.
    function markRetryLaneIfNotHydrated(fiber, retryLane) {
        markRetryLaneImpl(fiber, retryLane);
        var alternate = fiber.alternate;
        if (alternate) markRetryLaneImpl(alternate, retryLane);
    }
    function attemptContinuousHydration$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority and they should not suspend on I/O,
        // since you have to wrap anything that might suspend in
        // Suspense.
        return;
        var lane = SelectiveHydrationLane;
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        if (root !== null) {
            var eventTime = requestEventTime();
            scheduleUpdateOnFiber(root, fiber, lane, eventTime);
        }
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function attemptHydrationAtCurrentPriority$1(fiber) {
        if (fiber.tag !== SuspenseComponent) // We ignore HostRoots here because we can't increase
        // their priority other than synchronously flush it.
        return;
        var lane = requestUpdateLane(fiber);
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        if (root !== null) {
            var eventTime = requestEventTime();
            scheduleUpdateOnFiber(root, fiber, lane, eventTime);
        }
        markRetryLaneIfNotHydrated(fiber, lane);
    }
    function findHostInstanceWithNoPortals(fiber) {
        var hostFiber = findCurrentHostFiberWithNoPortals(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    var shouldErrorImpl = function(fiber) {
        return null;
    };
    function shouldError(fiber) {
        return shouldErrorImpl(fiber);
    }
    var shouldSuspendImpl = function(fiber) {
        return false;
    };
    function shouldSuspend(fiber) {
        return shouldSuspendImpl(fiber);
    }
    var overrideHookState = null;
    var overrideHookStateDeletePath = null;
    var overrideHookStateRenamePath = null;
    var overrideProps = null;
    var overridePropsDeletePath = null;
    var overridePropsRenamePath = null;
    var scheduleUpdate = null;
    var setErrorHandler = null;
    var setSuspenseHandler = null;
    var copyWithDeleteImpl = function(obj, path, index) {
        var key = path[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === path.length) {
            if (isArray(updated)) updated.splice(key, 1);
            else delete updated[key];
            return updated;
        } // $FlowFixMe number or string is fine here
        updated[key] = copyWithDeleteImpl(obj[key], path, index + 1);
        return updated;
    };
    var copyWithDelete = function(obj, path) {
        return copyWithDeleteImpl(obj, path, 0);
    };
    var copyWithRenameImpl = function(obj, oldPath, newPath, index) {
        var oldKey = oldPath[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj);
        if (index + 1 === oldPath.length) {
            var newKey = newPath[index]; // $FlowFixMe number or string is fine here
            updated[newKey] = updated[oldKey];
            if (isArray(updated)) updated.splice(oldKey, 1);
            else delete updated[oldKey];
        } else // $FlowFixMe number or string is fine here
        updated[oldKey] = copyWithRenameImpl(obj[oldKey], oldPath, newPath, index + 1);
        return updated;
    };
    var copyWithRename = function(obj, oldPath, newPath) {
        if (oldPath.length !== newPath.length) {
            warn("copyWithRename() expects paths of the same length");
            return;
        } else {
            for(var i = 0; i < newPath.length - 1; i++)if (oldPath[i] !== newPath[i]) {
                warn("copyWithRename() expects paths to be the same except for the deepest key");
                return;
            }
        }
        return copyWithRenameImpl(obj, oldPath, newPath, 0);
    };
    var copyWithSetImpl = function(obj, path, index, value) {
        if (index >= path.length) return value;
        var key = path[index];
        var updated = isArray(obj) ? obj.slice() : assign({}, obj); // $FlowFixMe number or string is fine here
        updated[key] = copyWithSetImpl(obj[key], path, index + 1, value);
        return updated;
    };
    var copyWithSet = function(obj, path, value) {
        return copyWithSetImpl(obj, path, 0, value);
    };
    var findHook = function(fiber, id) {
        // For now, the "id" of stateful hooks is just the stateful hook index.
        // This may change in the future with e.g. nested hooks.
        var currentHook = fiber.memoizedState;
        while(currentHook !== null && id > 0){
            currentHook = currentHook.next;
            id--;
        }
        return currentHook;
    }; // Support DevTools editable values for useState and useReducer.
    overrideHookState = function(fiber, id, path, value) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithSet(hook.memoizedState, path, value);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateDeletePath = function(fiber, id, path) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithDelete(hook.memoizedState, path);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    };
    overrideHookStateRenamePath = function(fiber, id, oldPath, newPath) {
        var hook = findHook(fiber, id);
        if (hook !== null) {
            var newState = copyWithRename(hook.memoizedState, oldPath, newPath);
            hook.memoizedState = newState;
            hook.baseState = newState; // We aren't actually adding an update to the queue,
            // because there is no update we can add for useReducer hooks that won't trigger an error.
            // (There's no appropriate action type for DevTools overrides.)
            // As a result though, React will see the scheduled update as a noop and bailout.
            // Shallow cloning props works as a workaround for now to bypass the bailout check.
            fiber.memoizedProps = assign({}, fiber.memoizedProps);
            var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
            if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
        }
    }; // Support DevTools props for function components, forwardRef, memo, host components, etc.
    overrideProps = function(fiber, path, value) {
        fiber.pendingProps = copyWithSet(fiber.memoizedProps, path, value);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    overridePropsDeletePath = function(fiber, path) {
        fiber.pendingProps = copyWithDelete(fiber.memoizedProps, path);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    overridePropsRenamePath = function(fiber, oldPath, newPath) {
        fiber.pendingProps = copyWithRename(fiber.memoizedProps, oldPath, newPath);
        if (fiber.alternate) fiber.alternate.pendingProps = fiber.pendingProps;
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    scheduleUpdate = function(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, SyncLane);
        if (root !== null) scheduleUpdateOnFiber(root, fiber, SyncLane, NoTimestamp);
    };
    setErrorHandler = function(newShouldErrorImpl) {
        shouldErrorImpl = newShouldErrorImpl;
    };
    setSuspenseHandler = function(newShouldSuspendImpl) {
        shouldSuspendImpl = newShouldSuspendImpl;
    };
    function findHostInstanceByFiber(fiber) {
        var hostFiber = findCurrentHostFiber(fiber);
        if (hostFiber === null) return null;
        return hostFiber.stateNode;
    }
    function emptyFindFiberByHostInstance(instance) {
        return null;
    }
    function getCurrentFiberForDevTools() {
        return current;
    }
    function injectIntoDevTools(devToolsConfig) {
        var findFiberByHostInstance = devToolsConfig.findFiberByHostInstance;
        var ReactCurrentDispatcher = ReactSharedInternals.ReactCurrentDispatcher;
        return injectInternals({
            bundleType: devToolsConfig.bundleType,
            version: devToolsConfig.version,
            rendererPackageName: devToolsConfig.rendererPackageName,
            rendererConfig: devToolsConfig.rendererConfig,
            overrideHookState: overrideHookState,
            overrideHookStateDeletePath: overrideHookStateDeletePath,
            overrideHookStateRenamePath: overrideHookStateRenamePath,
            overrideProps: overrideProps,
            overridePropsDeletePath: overridePropsDeletePath,
            overridePropsRenamePath: overridePropsRenamePath,
            setErrorHandler: setErrorHandler,
            setSuspenseHandler: setSuspenseHandler,
            scheduleUpdate: scheduleUpdate,
            currentDispatcherRef: ReactCurrentDispatcher,
            findHostInstanceByFiber: findHostInstanceByFiber,
            findFiberByHostInstance: findFiberByHostInstance || emptyFindFiberByHostInstance,
            // React Refresh
            findHostInstancesForRefresh: findHostInstancesForRefresh,
            scheduleRefresh: scheduleRefresh,
            scheduleRoot: scheduleRoot,
            setRefreshHandler: setRefreshHandler,
            // Enables DevTools to append owner stacks to error messages in DEV mode.
            getCurrentFiber: getCurrentFiberForDevTools,
            // Enables DevTools to detect reconciler version rather than renderer version
            // which may not match for third party renderers.
            reconcilerVersion: ReactVersion
        });
    }
    /* global reportError */ var defaultOnRecoverableError = typeof reportError === "function" ? // emulating an uncaught JavaScript error.
    reportError : function(error) {
        // In older browsers and test environments, fallback to console.error.
        // eslint-disable-next-line react-internal/no-production-logging
        console["error"](error);
    };
    function ReactDOMRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
        var root = this._internalRoot;
        if (root === null) throw new Error("Cannot update an unmounted root.");
        if (typeof arguments[1] === "function") error("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        else if (isValidContainer(arguments[1])) error("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.");
        else if (typeof arguments[1] !== "undefined") error("You passed a second argument to root.render(...) but it only accepts one argument.");
        var container = root.containerInfo;
        if (container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(root.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
            }
        }
        updateContainer(children, root, null, null);
    };
    ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
        if (typeof arguments[0] === "function") error("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        var root = this._internalRoot;
        if (root !== null) {
            this._internalRoot = null;
            var container = root.containerInfo;
            if (isAlreadyRendering()) error("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition.");
            flushSync(function() {
                updateContainer(null, root, null, null);
            });
            unmarkContainerAsRoot(container);
        }
    };
    function createRoot(container, options) {
        if (!isValidContainer(container)) throw new Error("createRoot(...): Target container is not a DOM element.");
        warnIfReactDOMContainerInDEV(container);
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = "";
        var onRecoverableError = defaultOnRecoverableError;
        var transitionCallbacks = null;
        if (options !== null && options !== undefined) {
            if (options.hydrate) warn("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.");
            else if (typeof options === "object" && options !== null && options.$$typeof === REACT_ELEMENT_TYPE) error("You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:\n\n  let root = createRoot(domContainer);\n  root.render(<App />);");
            if (options.unstable_strictMode === true) isStrictMode = true;
            if (options.identifierPrefix !== undefined) identifierPrefix = options.identifierPrefix;
            if (options.onRecoverableError !== undefined) onRecoverableError = options.onRecoverableError;
            if (options.transitionCallbacks !== undefined) transitionCallbacks = options.transitionCallbacks;
        }
        var root = createContainer(container, ConcurrentRoot, null, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container);
        var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
        listenToAllSupportedEvents(rootContainerElement);
        return new ReactDOMRoot(root);
    }
    function ReactDOMHydrationRoot(internalRoot) {
        this._internalRoot = internalRoot;
    }
    function scheduleHydration(target) {
        if (target) queueExplicitHydrationTarget(target);
    }
    ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = scheduleHydration;
    function hydrateRoot(container, initialChildren, options) {
        if (!isValidContainer(container)) throw new Error("hydrateRoot(...): Target container is not a DOM element.");
        warnIfReactDOMContainerInDEV(container);
        if (initialChildren === undefined) error("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
        // the hydration callbacks.
        var hydrationCallbacks = options != null ? options : null; // TODO: Delete this option
        var mutableSources = options != null && options.hydratedSources || null;
        var isStrictMode = false;
        var concurrentUpdatesByDefaultOverride = false;
        var identifierPrefix = "";
        var onRecoverableError = defaultOnRecoverableError;
        if (options !== null && options !== undefined) {
            if (options.unstable_strictMode === true) isStrictMode = true;
            if (options.identifierPrefix !== undefined) identifierPrefix = options.identifierPrefix;
            if (options.onRecoverableError !== undefined) onRecoverableError = options.onRecoverableError;
        }
        var root = createHydrationContainer(initialChildren, null, container, ConcurrentRoot, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onRecoverableError);
        markContainerAsRoot(root.current, container); // This can't be a comment node since hydration doesn't work on comment nodes anyway.
        listenToAllSupportedEvents(container);
        if (mutableSources) for(var i = 0; i < mutableSources.length; i++){
            var mutableSource = mutableSources[i];
            registerMutableSourceForHydration(root, mutableSource);
        }
        return new ReactDOMHydrationRoot(root);
    }
    function isValidContainer(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || !disableCommentsAsDOMContainers));
    } // TODO: Remove this function which also includes comment nodes.
    // We only use it in places that are currently more relaxed.
    function isValidContainerLegacy(node) {
        return !!(node && (node.nodeType === ELEMENT_NODE || node.nodeType === DOCUMENT_NODE || node.nodeType === DOCUMENT_FRAGMENT_NODE || node.nodeType === COMMENT_NODE && node.nodeValue === " react-mount-point-unstable "));
    }
    function warnIfReactDOMContainerInDEV(container) {
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === "BODY") error("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app.");
        if (isContainerMarkedAsRoot(container)) {
            if (container._reactRootContainer) error("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.");
            else error("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it.");
        }
    }
    var ReactCurrentOwner$3 = ReactSharedInternals.ReactCurrentOwner;
    var topLevelUpdateWarnings;
    topLevelUpdateWarnings = function(container) {
        if (container._reactRootContainer && container.nodeType !== COMMENT_NODE) {
            var hostInstance = findHostInstanceWithNoPortals(container._reactRootContainer.current);
            if (hostInstance) {
                if (hostInstance.parentNode !== container) error("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
            }
        }
        var isRootRenderedBySomeReact = !!container._reactRootContainer;
        var rootEl = getReactRootElementInContainer(container);
        var hasNonRootReactChild = !!(rootEl && getInstanceFromNode(rootEl));
        if (hasNonRootReactChild && !isRootRenderedBySomeReact) error("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render.");
        if (container.nodeType === ELEMENT_NODE && container.tagName && container.tagName.toUpperCase() === "BODY") error("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
    };
    function getReactRootElementInContainer(container) {
        if (!container) return null;
        if (container.nodeType === DOCUMENT_NODE) return container.documentElement;
        else return container.firstChild;
    }
    function noopOnRecoverableError() {
    // legacy API.
    }
    function legacyCreateRootFromDOMContainer(container, initialChildren, parentComponent, callback, isHydrationContainer) {
        if (isHydrationContainer) {
            if (typeof callback === "function") {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(root);
                    originalCallback.call(instance);
                };
            }
            var root = createHydrationContainer(initialChildren, callback, container, LegacyRoot, null, false, false, "", noopOnRecoverableError);
            container._reactRootContainer = root;
            markContainerAsRoot(root.current, container);
            var rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
            listenToAllSupportedEvents(rootContainerElement);
            flushSync();
            return root;
        } else {
            // First clear any existing content.
            var rootSibling;
            while(rootSibling = container.lastChild)container.removeChild(rootSibling);
            if (typeof callback === "function") {
                var _originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(_root);
                    _originalCallback.call(instance);
                };
            }
            var _root = createContainer(container, LegacyRoot, null, false, false, "", noopOnRecoverableError);
            container._reactRootContainer = _root;
            markContainerAsRoot(_root.current, container);
            var _rootContainerElement = container.nodeType === COMMENT_NODE ? container.parentNode : container;
            listenToAllSupportedEvents(_rootContainerElement); // Initial mount should not be batched.
            flushSync(function() {
                updateContainer(initialChildren, _root, parentComponent, callback);
            });
            return _root;
        }
    }
    function warnOnInvalidCallback$1(callback, callerName) {
        if (callback !== null && typeof callback !== "function") error("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", callerName, callback);
    }
    function legacyRenderSubtreeIntoContainer(parentComponent, children, container, forceHydrate, callback) {
        topLevelUpdateWarnings(container);
        warnOnInvalidCallback$1(callback === undefined ? null : callback, "render");
        var maybeRoot = container._reactRootContainer;
        var root;
        if (!maybeRoot) // Initial mount
        root = legacyCreateRootFromDOMContainer(container, children, parentComponent, callback, forceHydrate);
        else {
            root = maybeRoot;
            if (typeof callback === "function") {
                var originalCallback = callback;
                callback = function() {
                    var instance = getPublicRootInstance(root);
                    originalCallback.call(instance);
                };
            } // Update
            updateContainer(children, root, parentComponent, callback);
        }
        return getPublicRootInstance(root);
    }
    var didWarnAboutFindDOMNode = false;
    function findDOMNode(componentOrElement) {
        if (!didWarnAboutFindDOMNode) {
            didWarnAboutFindDOMNode = true;
            error("findDOMNode is deprecated and will be removed in the next major release. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node");
        }
        var owner = ReactCurrentOwner$3.current;
        if (owner !== null && owner.stateNode !== null) {
            var warnedAboutRefsInRender = owner.stateNode._warnedAboutRefsInRender;
            if (!warnedAboutRefsInRender) error("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", getComponentNameFromType(owner.type) || "A component");
            owner.stateNode._warnedAboutRefsInRender = true;
        }
        if (componentOrElement == null) return null;
        if (componentOrElement.nodeType === ELEMENT_NODE) return componentOrElement;
        return findHostInstanceWithWarning(componentOrElement, "findDOMNode");
    }
    function hydrate(element, container, callback) {
        error("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(container)) throw new Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, true, callback);
    }
    function render(element, container, callback) {
        error("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(container)) throw new Error("Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
        return legacyRenderSubtreeIntoContainer(null, element, container, false, callback);
    }
    function unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        error("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot");
        if (!isValidContainerLegacy(containerNode)) throw new Error("Target container is not a DOM element.");
        if (parentComponent == null || !has(parentComponent)) throw new Error("parentComponent must be a valid React Component");
        return legacyRenderSubtreeIntoContainer(parentComponent, element, containerNode, false, callback);
    }
    var didWarnAboutUnmountComponentAtNode = false;
    function unmountComponentAtNode(container) {
        if (!didWarnAboutUnmountComponentAtNode) {
            didWarnAboutUnmountComponentAtNode = true;
            error("unmountComponentAtNode is deprecated and will be removed in the next major release. Switch to the createRoot API. Learn more: https://reactjs.org/link/switch-to-createroot");
        }
        if (!isValidContainerLegacy(container)) throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
        var isModernRoot = isContainerMarkedAsRoot(container) && container._reactRootContainer === undefined;
        if (isModernRoot) error("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
        if (container._reactRootContainer) {
            var rootEl = getReactRootElementInContainer(container);
            var renderedByDifferentReact = rootEl && !getInstanceFromNode(rootEl);
            if (renderedByDifferentReact) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
            flushSync(function() {
                legacyRenderSubtreeIntoContainer(null, null, container, false, function() {
                    // $FlowFixMe This should probably use `delete container._reactRootContainer`
                    container._reactRootContainer = null;
                    unmarkContainerAsRoot(container);
                });
            }); // If you call unmountComponentAtNode twice in quick succession, you'll
            // get `true` twice. That's probably fine?
            return true;
        } else {
            var _rootEl = getReactRootElementInContainer(container);
            var hasNonRootReactChild = !!(_rootEl && getInstanceFromNode(_rootEl)); // Check if the container itself is a React root node.
            var isContainerReactRoot = container.nodeType === ELEMENT_NODE && isValidContainerLegacy(container.parentNode) && !!container.parentNode._reactRootContainer;
            if (hasNonRootReactChild) error("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", isContainerReactRoot ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
            return false;
        }
    }
    setAttemptSynchronousHydration(attemptSynchronousHydration$1);
    setAttemptContinuousHydration(attemptContinuousHydration$1);
    setAttemptHydrationAtCurrentPriority(attemptHydrationAtCurrentPriority$1);
    setGetCurrentUpdatePriority(getCurrentUpdatePriority);
    setAttemptHydrationAtPriority(runWithPriority);
    if (typeof Map !== "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
    Map.prototype == null || typeof Map.prototype.forEach !== "function" || typeof Set !== "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
    Set.prototype == null || typeof Set.prototype.clear !== "function" || typeof Set.prototype.forEach !== "function") error("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    setRestoreImplementation(restoreControlledState$3);
    setBatchingImplementation(batchedUpdates$1, discreteUpdates, flushSync);
    function createPortal$1(children, container) {
        var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        if (!isValidContainer(container)) throw new Error("Target container is not a DOM element.");
         // TODO: pass ReactDOM portal implementation as third argument
        // $FlowFixMe The Flow type is opaque but there's no way to actually create it.
        return createPortal(children, container, null, key);
    }
    function renderSubtreeIntoContainer(parentComponent, element, containerNode, callback) {
        return unstable_renderSubtreeIntoContainer(parentComponent, element, containerNode, callback);
    }
    var Internals = {
        usingClientEntryPoint: false,
        // Keep in sync with ReactTestUtils.js.
        // This is an array for better minification.
        Events: [
            getInstanceFromNode,
            getNodeFromInstance,
            getFiberCurrentPropsFromNode,
            enqueueStateRestore,
            restoreStateIfNeeded,
            batchedUpdates$1
        ]
    };
    function createRoot$1(container, options) {
        if (!Internals.usingClientEntryPoint && true) error('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".');
        return createRoot(container, options);
    }
    function hydrateRoot$1(container, initialChildren, options) {
        if (!Internals.usingClientEntryPoint && true) error('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".');
        return hydrateRoot(container, initialChildren, options);
    } // Overload the definition to the two valid signatures.
    // Warning, this opts-out of checking the function body.
    // eslint-disable-next-line no-redeclare
    function flushSync$1(fn) {
        if (isAlreadyRendering()) error("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task.");
        return flushSync(fn);
    }
    var foundDevTools = injectIntoDevTools({
        findFiberByHostInstance: getClosestInstanceFromNode,
        bundleType: 1,
        version: ReactVersion,
        rendererPackageName: "react-dom"
    });
    if (!foundDevTools && canUseDOM && window.top === window.self) // If we're in Chrome or Firefox, provide a download link if not installed.
    {
        if (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1) {
            var protocol = window.location.protocol; // Don't warn in exotic cases like chrome-extension://.
            if (/^(https?|file):$/.test(protocol)) // eslint-disable-next-line react-internal/no-production-logging
            console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (protocol === "file:" ? "\nYou might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq" : ""), "font-weight:bold");
        }
    }
    $198b3efa41da6254$export$ae55be85d98224ed = Internals;
    $198b3efa41da6254$export$d39a5bbd09211389 = createPortal$1;
    $198b3efa41da6254$export$882461b6382ed46c = createRoot$1;
    $198b3efa41da6254$export$466bfc07425424d5 = findDOMNode;
    $198b3efa41da6254$export$cd75ccfd720a3cd4 = flushSync$1;
    $198b3efa41da6254$export$fa8d919ba61d84db = hydrate;
    $198b3efa41da6254$export$757ceba2d55c277e = hydrateRoot$1;
    $198b3efa41da6254$export$b3890eb0ae9dca99 = render;
    $198b3efa41da6254$export$502457920280e6be = unmountComponentAtNode;
    $198b3efa41da6254$export$c78a37762a8d58e1 = batchedUpdates$1;
    $198b3efa41da6254$export$dc54d992c10e8a18 = renderSubtreeIntoContainer;
    $198b3efa41da6254$export$83d89fbfd8236492 = ReactVersion;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});
parcelRegister("clk2u", function(module, exports) {
"use strict";

module.exports = (parcelRequire("dQzph"));

});
parcelRegister("dQzph", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $a14b98b6315447e7$export$c4744153514ff05d, (v) => $a14b98b6315447e7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $a14b98b6315447e7$export$3e506c1ccc9cc1a7, (v) => $a14b98b6315447e7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $a14b98b6315447e7$export$e26fe2ed2fa76875, (v) => $a14b98b6315447e7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $a14b98b6315447e7$export$502329bbf4b505b1, (v) => $a14b98b6315447e7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $a14b98b6315447e7$export$6e3807111c4874c4, (v) => $a14b98b6315447e7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $a14b98b6315447e7$export$c27134553091fb3a, (v) => $a14b98b6315447e7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $a14b98b6315447e7$export$33ee1acdc04fd2a2, (v) => $a14b98b6315447e7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $a14b98b6315447e7$export$b00a404bbd5edef2, (v) => $a14b98b6315447e7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $a14b98b6315447e7$export$8352ce38b91d0c62, (v) => $a14b98b6315447e7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $a14b98b6315447e7$export$d66a1c1c77bd778b, (v) => $a14b98b6315447e7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $a14b98b6315447e7$export$d3dfb8e4810cb555, (v) => $a14b98b6315447e7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $a14b98b6315447e7$export$839f9183b0465a69, (v) => $a14b98b6315447e7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $a14b98b6315447e7$export$72fdf0e06517287b, (v) => $a14b98b6315447e7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $a14b98b6315447e7$export$4b844e58a3e414b4, (v) => $a14b98b6315447e7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $a14b98b6315447e7$export$816d2913ae6b83b1, (v) => $a14b98b6315447e7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $a14b98b6315447e7$export$61bcfe829111a1d0, (v) => $a14b98b6315447e7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $a14b98b6315447e7$export$7ee8c9beb337bc3f, (v) => $a14b98b6315447e7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $a14b98b6315447e7$export$b5836b71941fa3ed, (v) => $a14b98b6315447e7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $a14b98b6315447e7$export$cf845f2c119da08a, (v) => $a14b98b6315447e7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a14b98b6315447e7$export$c4744153514ff05d;
var $a14b98b6315447e7$export$3e506c1ccc9cc1a7;
var $a14b98b6315447e7$export$e26fe2ed2fa76875;
var $a14b98b6315447e7$export$502329bbf4b505b1;
var $a14b98b6315447e7$export$6e3807111c4874c4;
var $a14b98b6315447e7$export$c27134553091fb3a;
var $a14b98b6315447e7$export$33ee1acdc04fd2a2;
var $a14b98b6315447e7$export$b00a404bbd5edef2;
var $a14b98b6315447e7$export$8352ce38b91d0c62;
var $a14b98b6315447e7$export$d66a1c1c77bd778b;
var $a14b98b6315447e7$export$d3dfb8e4810cb555;
var $a14b98b6315447e7$export$839f9183b0465a69;
var $a14b98b6315447e7$export$72fdf0e06517287b;
var $a14b98b6315447e7$export$4b844e58a3e414b4;
var $a14b98b6315447e7$export$816d2913ae6b83b1;
var $a14b98b6315447e7$export$61bcfe829111a1d0;
var $a14b98b6315447e7$export$7ee8c9beb337bc3f;
var $a14b98b6315447e7$export$b5836b71941fa3ed;
var $a14b98b6315447e7$export$cf845f2c119da08a;
"use strict";
(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var enableSchedulerDebugging = false;
    var enableProfiling = false;
    var frameYieldMs = 5;
    function push(heap, node) {
        var index = heap.length;
        heap.push(node);
        siftUp(heap, node, index);
    }
    function peek(heap) {
        return heap.length === 0 ? null : heap[0];
    }
    function pop(heap) {
        if (heap.length === 0) return null;
        var first = heap[0];
        var last = heap.pop();
        if (last !== first) {
            heap[0] = last;
            siftDown(heap, last, 0);
        }
        return first;
    }
    function siftUp(heap, node, i) {
        var index = i;
        while(index > 0){
            var parentIndex = index - 1 >>> 1;
            var parent = heap[parentIndex];
            if (compare(parent, node) > 0) {
                // The parent is larger. Swap positions.
                heap[parentIndex] = node;
                heap[index] = parent;
                index = parentIndex;
            } else // The parent is smaller. Exit.
            return;
        }
    }
    function siftDown(heap, node, i) {
        var index = i;
        var length = heap.length;
        var halfLength = length >>> 1;
        while(index < halfLength){
            var leftIndex = (index + 1) * 2 - 1;
            var left = heap[leftIndex];
            var rightIndex = leftIndex + 1;
            var right = heap[rightIndex]; // If the left or right node is smaller, swap with the smaller of those.
            if (compare(left, node) < 0) {
                if (rightIndex < length && compare(right, left) < 0) {
                    heap[index] = right;
                    heap[rightIndex] = node;
                    index = rightIndex;
                } else {
                    heap[index] = left;
                    heap[leftIndex] = node;
                    index = leftIndex;
                }
            } else if (rightIndex < length && compare(right, node) < 0) {
                heap[index] = right;
                heap[rightIndex] = node;
                index = rightIndex;
            } else // Neither child is smaller. Exit.
            return;
        }
    }
    function compare(a, b) {
        // Compare sort index first, then task id.
        var diff = a.sortIndex - b.sortIndex;
        return diff !== 0 ? diff : a.id - b.id;
    }
    // TODO: Use symbols?
    var ImmediatePriority = 1;
    var UserBlockingPriority = 2;
    var NormalPriority = 3;
    var LowPriority = 4;
    var IdlePriority = 5;
    function markTaskErrored(task, ms) {}
    /* eslint-disable no-var */ var hasPerformanceNow = typeof performance === "object" && typeof performance.now === "function";
    if (hasPerformanceNow) {
        var localPerformance = performance;
        $a14b98b6315447e7$export$c4744153514ff05d = function() {
            return localPerformance.now();
        };
    } else {
        var localDate = Date;
        var initialTime = localDate.now();
        $a14b98b6315447e7$export$c4744153514ff05d = function() {
            return localDate.now() - initialTime;
        };
    } // Max 31 bit integer. The max integer size in V8 for 32-bit systems.
    // Math.pow(2, 30) - 1
    // 0b111111111111111111111111111111
    var maxSigned31BitInt = 1073741823; // Times out immediately
    var IMMEDIATE_PRIORITY_TIMEOUT = -1; // Eventually times out
    var USER_BLOCKING_PRIORITY_TIMEOUT = 250;
    var NORMAL_PRIORITY_TIMEOUT = 5000;
    var LOW_PRIORITY_TIMEOUT = 10000; // Never times out
    var IDLE_PRIORITY_TIMEOUT = maxSigned31BitInt; // Tasks are stored on a min heap
    var taskQueue = [];
    var timerQueue = []; // Incrementing id counter. Used to maintain insertion order.
    var taskIdCounter = 1; // Pausing the scheduler is useful for debugging.
    var currentTask = null;
    var currentPriorityLevel = NormalPriority; // This is set while performing work, to prevent re-entrance.
    var isPerformingWork = false;
    var isHostCallbackScheduled = false;
    var isHostTimeoutScheduled = false; // Capture local references to native APIs, in case a polyfill overrides them.
    var localSetTimeout = typeof setTimeout === "function" ? setTimeout : null;
    var localClearTimeout = typeof clearTimeout === "function" ? clearTimeout : null;
    var localSetImmediate = typeof setImmediate !== "undefined" ? setImmediate : null; // IE and Node.js + jsdom
    var isInputPending = typeof navigator !== "undefined" && navigator.scheduling !== undefined && navigator.scheduling.isInputPending !== undefined ? navigator.scheduling.isInputPending.bind(navigator.scheduling) : null;
    function advanceTimers(currentTime) {
        // Check for tasks that are no longer delayed and add them to the queue.
        var timer = peek(timerQueue);
        while(timer !== null){
            if (timer.callback === null) // Timer was cancelled.
            pop(timerQueue);
            else if (timer.startTime <= currentTime) {
                // Timer fired. Transfer to the task queue.
                pop(timerQueue);
                timer.sortIndex = timer.expirationTime;
                push(taskQueue, timer);
            } else // Remaining timers are pending.
            return;
            timer = peek(timerQueue);
        }
    }
    function handleTimeout(currentTime) {
        isHostTimeoutScheduled = false;
        advanceTimers(currentTime);
        if (!isHostCallbackScheduled) {
            if (peek(taskQueue) !== null) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            } else {
                var firstTimer = peek(timerQueue);
                if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            }
        }
    }
    function flushWork(hasTimeRemaining, initialTime) {
        isHostCallbackScheduled = false;
        if (isHostTimeoutScheduled) {
            // We scheduled a timeout but it's no longer needed. Cancel it.
            isHostTimeoutScheduled = false;
            cancelHostTimeout();
        }
        isPerformingWork = true;
        var previousPriorityLevel = currentPriorityLevel;
        try {
            if (enableProfiling) try {
                return workLoop(hasTimeRemaining, initialTime);
            } catch (error) {
                if (currentTask !== null) {
                    var currentTime = $a14b98b6315447e7$export$c4744153514ff05d();
                    markTaskErrored(currentTask, currentTime);
                    currentTask.isQueued = false;
                }
                throw error;
            }
            else // No catch in prod code path.
            return workLoop(hasTimeRemaining, initialTime);
        } finally{
            currentTask = null;
            currentPriorityLevel = previousPriorityLevel;
            isPerformingWork = false;
        }
    }
    function workLoop(hasTimeRemaining, initialTime) {
        var currentTime = initialTime;
        advanceTimers(currentTime);
        currentTask = peek(taskQueue);
        while(currentTask !== null && !enableSchedulerDebugging){
            if (currentTask.expirationTime > currentTime && (!hasTimeRemaining || shouldYieldToHost())) break;
            var callback = currentTask.callback;
            if (typeof callback === "function") {
                currentTask.callback = null;
                currentPriorityLevel = currentTask.priorityLevel;
                var didUserCallbackTimeout = currentTask.expirationTime <= currentTime;
                var continuationCallback = callback(didUserCallbackTimeout);
                currentTime = $a14b98b6315447e7$export$c4744153514ff05d();
                if (typeof continuationCallback === "function") currentTask.callback = continuationCallback;
                else if (currentTask === peek(taskQueue)) pop(taskQueue);
                advanceTimers(currentTime);
            } else pop(taskQueue);
            currentTask = peek(taskQueue);
        } // Return whether there's additional work
        if (currentTask !== null) return true;
        else {
            var firstTimer = peek(timerQueue);
            if (firstTimer !== null) requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
            return false;
        }
    }
    function unstable_runWithPriority(priorityLevel, eventHandler) {
        switch(priorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
            case LowPriority:
            case IdlePriority:
                break;
            default:
                priorityLevel = NormalPriority;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_next(eventHandler) {
        var priorityLevel;
        switch(currentPriorityLevel){
            case ImmediatePriority:
            case UserBlockingPriority:
            case NormalPriority:
                // Shift down to normal priority
                priorityLevel = NormalPriority;
                break;
            default:
                // Anything lower than normal priority should remain at the current level.
                priorityLevel = currentPriorityLevel;
                break;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
            return eventHandler();
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    }
    function unstable_wrapCallback(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function() {
            // This is a fork of runWithPriority, inlined for performance.
            var previousPriorityLevel = currentPriorityLevel;
            currentPriorityLevel = parentPriorityLevel;
            try {
                return callback.apply(this, arguments);
            } finally{
                currentPriorityLevel = previousPriorityLevel;
            }
        };
    }
    function unstable_scheduleCallback(priorityLevel, callback, options) {
        var currentTime = $a14b98b6315447e7$export$c4744153514ff05d();
        var startTime;
        if (typeof options === "object" && options !== null) {
            var delay = options.delay;
            if (typeof delay === "number" && delay > 0) startTime = currentTime + delay;
            else startTime = currentTime;
        } else startTime = currentTime;
        var timeout;
        switch(priorityLevel){
            case ImmediatePriority:
                timeout = IMMEDIATE_PRIORITY_TIMEOUT;
                break;
            case UserBlockingPriority:
                timeout = USER_BLOCKING_PRIORITY_TIMEOUT;
                break;
            case IdlePriority:
                timeout = IDLE_PRIORITY_TIMEOUT;
                break;
            case LowPriority:
                timeout = LOW_PRIORITY_TIMEOUT;
                break;
            case NormalPriority:
            default:
                timeout = NORMAL_PRIORITY_TIMEOUT;
                break;
        }
        var expirationTime = startTime + timeout;
        var newTask = {
            id: taskIdCounter++,
            callback: callback,
            priorityLevel: priorityLevel,
            startTime: startTime,
            expirationTime: expirationTime,
            sortIndex: -1
        };
        if (startTime > currentTime) {
            // This is a delayed task.
            newTask.sortIndex = startTime;
            push(timerQueue, newTask);
            if (peek(taskQueue) === null && newTask === peek(timerQueue)) {
                // All tasks are delayed, and this is the task with the earliest delay.
                if (isHostTimeoutScheduled) // Cancel an existing timeout.
                cancelHostTimeout();
                else isHostTimeoutScheduled = true;
                 // Schedule a timeout.
                requestHostTimeout(handleTimeout, startTime - currentTime);
            }
        } else {
            newTask.sortIndex = expirationTime;
            push(taskQueue, newTask);
            // wait until the next time we yield.
            if (!isHostCallbackScheduled && !isPerformingWork) {
                isHostCallbackScheduled = true;
                requestHostCallback(flushWork);
            }
        }
        return newTask;
    }
    function unstable_pauseExecution() {}
    function unstable_continueExecution() {
        if (!isHostCallbackScheduled && !isPerformingWork) {
            isHostCallbackScheduled = true;
            requestHostCallback(flushWork);
        }
    }
    function unstable_getFirstCallbackNode() {
        return peek(taskQueue);
    }
    function unstable_cancelCallback(task) {
        // remove from the queue because you can't remove arbitrary nodes from an
        // array based heap, only the first one.)
        task.callback = null;
    }
    function unstable_getCurrentPriorityLevel() {
        return currentPriorityLevel;
    }
    var isMessageLoopRunning = false;
    var scheduledHostCallback = null;
    var taskTimeoutID = -1; // Scheduler periodically yields in case there is other work on the main
    // thread, like user events. By default, it yields multiple times per frame.
    // It does not attempt to align with frame boundaries, since most tasks don't
    // need to be frame aligned; for those that do, use requestAnimationFrame.
    var frameInterval = frameYieldMs;
    var startTime = -1;
    function shouldYieldToHost() {
        var timeElapsed = $a14b98b6315447e7$export$c4744153514ff05d() - startTime;
        if (timeElapsed < frameInterval) // The main thread has only been blocked for a really short amount of time;
        // smaller than a single frame. Don't yield yet.
        return false;
         // The main thread has been blocked for a non-negligible amount of time. We
        return true;
    }
    function requestPaint() {}
    function forceFrameRate(fps) {
        if (fps < 0 || fps > 125) {
            // Using console['error'] to evade Babel and ESLint
            console["error"]("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
            return;
        }
        if (fps > 0) frameInterval = Math.floor(1000 / fps);
        else // reset the framerate
        frameInterval = frameYieldMs;
    }
    var performWorkUntilDeadline = function() {
        if (scheduledHostCallback !== null) {
            var currentTime = $a14b98b6315447e7$export$c4744153514ff05d(); // Keep track of the start time so we can measure how long the main thread
            // has been blocked.
            startTime = currentTime;
            var hasTimeRemaining = true; // If a scheduler task throws, exit the current browser task so the
            // error can be observed.
            //
            // Intentionally not using a try-catch, since that makes some debugging
            // techniques harder. Instead, if `scheduledHostCallback` errors, then
            // `hasMoreWork` will remain true, and we'll continue the work loop.
            var hasMoreWork = true;
            try {
                hasMoreWork = scheduledHostCallback(hasTimeRemaining, currentTime);
            } finally{
                if (hasMoreWork) // If there's more work, schedule the next message event at the end
                // of the preceding one.
                schedulePerformWorkUntilDeadline();
                else {
                    isMessageLoopRunning = false;
                    scheduledHostCallback = null;
                }
            }
        } else isMessageLoopRunning = false;
         // Yielding to the browser will give it a chance to paint, so we can
    };
    var schedulePerformWorkUntilDeadline;
    if (typeof localSetImmediate === "function") // Node.js and old IE.
    // There's a few reasons for why we prefer setImmediate.
    //
    // Unlike MessageChannel, it doesn't prevent a Node.js process from exiting.
    // (Even though this is a DOM fork of the Scheduler, you could get here
    // with a mix of Node.js 15+, which has a MessageChannel, and jsdom.)
    // https://github.com/facebook/react/issues/20756
    //
    // But also, it runs earlier which is the semantic we want.
    // If other browsers ever implement it, it's better to use it.
    // Although both of these would be inferior to native scheduling.
    schedulePerformWorkUntilDeadline = function() {
        localSetImmediate(performWorkUntilDeadline);
    };
    else if (typeof MessageChannel !== "undefined") {
        // DOM and Worker environments.
        // We prefer MessageChannel because of the 4ms setTimeout clamping.
        var channel = new MessageChannel();
        var port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;
        schedulePerformWorkUntilDeadline = function() {
            port.postMessage(null);
        };
    } else // We should only fallback here in non-browser environments.
    schedulePerformWorkUntilDeadline = function() {
        localSetTimeout(performWorkUntilDeadline, 0);
    };
    function requestHostCallback(callback) {
        scheduledHostCallback = callback;
        if (!isMessageLoopRunning) {
            isMessageLoopRunning = true;
            schedulePerformWorkUntilDeadline();
        }
    }
    function requestHostTimeout(callback, ms) {
        taskTimeoutID = localSetTimeout(function() {
            callback($a14b98b6315447e7$export$c4744153514ff05d());
        }, ms);
    }
    function cancelHostTimeout() {
        localClearTimeout(taskTimeoutID);
        taskTimeoutID = -1;
    }
    var unstable_requestPaint = requestPaint;
    var unstable_Profiling = null;
    $a14b98b6315447e7$export$3e506c1ccc9cc1a7 = IdlePriority;
    $a14b98b6315447e7$export$e26fe2ed2fa76875 = ImmediatePriority;
    $a14b98b6315447e7$export$502329bbf4b505b1 = LowPriority;
    $a14b98b6315447e7$export$6e3807111c4874c4 = NormalPriority;
    $a14b98b6315447e7$export$c27134553091fb3a = unstable_Profiling;
    $a14b98b6315447e7$export$33ee1acdc04fd2a2 = UserBlockingPriority;
    $a14b98b6315447e7$export$b00a404bbd5edef2 = unstable_cancelCallback;
    $a14b98b6315447e7$export$8352ce38b91d0c62 = unstable_continueExecution;
    $a14b98b6315447e7$export$d66a1c1c77bd778b = forceFrameRate;
    $a14b98b6315447e7$export$d3dfb8e4810cb555 = unstable_getCurrentPriorityLevel;
    $a14b98b6315447e7$export$839f9183b0465a69 = unstable_getFirstCallbackNode;
    $a14b98b6315447e7$export$72fdf0e06517287b = unstable_next;
    $a14b98b6315447e7$export$4b844e58a3e414b4 = unstable_pauseExecution;
    $a14b98b6315447e7$export$816d2913ae6b83b1 = unstable_requestPaint;
    $a14b98b6315447e7$export$61bcfe829111a1d0 = unstable_runWithPriority;
    $a14b98b6315447e7$export$7ee8c9beb337bc3f = unstable_scheduleCallback;
    $a14b98b6315447e7$export$b5836b71941fa3ed = shouldYieldToHost;
    $a14b98b6315447e7$export$cf845f2c119da08a = unstable_wrapCallback;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});



parcelRegister("hcgfX", function(module, exports) {
"use strict";
var $c8502ad98c072938$var$has = Object.prototype.hasOwnProperty, $c8502ad98c072938$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $c8502ad98c072938$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $c8502ad98c072938$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $c8502ad98c072938$var$Events().__proto__) $c8502ad98c072938$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $c8502ad98c072938$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $c8502ad98c072938$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $c8502ad98c072938$var$EE(fn, context || emitter, once), evt = $c8502ad98c072938$var$prefix ? $c8502ad98c072938$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $c8502ad98c072938$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $c8502ad98c072938$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $c8502ad98c072938$var$EventEmitter() {
    this._events = new $c8502ad98c072938$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $c8502ad98c072938$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($c8502ad98c072938$var$has.call(events, name)) names.push($c8502ad98c072938$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $c8502ad98c072938$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $c8502ad98c072938$var$prefix ? $c8502ad98c072938$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $c8502ad98c072938$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $c8502ad98c072938$var$prefix ? $c8502ad98c072938$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $c8502ad98c072938$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $c8502ad98c072938$var$prefix ? $c8502ad98c072938$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $c8502ad98c072938$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $c8502ad98c072938$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $c8502ad98c072938$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $c8502ad98c072938$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $c8502ad98c072938$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $c8502ad98c072938$var$prefix ? $c8502ad98c072938$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $c8502ad98c072938$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $c8502ad98c072938$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $c8502ad98c072938$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $c8502ad98c072938$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $c8502ad98c072938$var$prefix ? $c8502ad98c072938$var$prefix + event : event;
        if (this._events[evt]) $c8502ad98c072938$var$clearEvent(this, evt);
    } else {
        this._events = new $c8502ad98c072938$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$c8502ad98c072938$var$EventEmitter.prototype.off = $c8502ad98c072938$var$EventEmitter.prototype.removeListener;
$c8502ad98c072938$var$EventEmitter.prototype.addListener = $c8502ad98c072938$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$c8502ad98c072938$var$EventEmitter.prefixed = $c8502ad98c072938$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$c8502ad98c072938$var$EventEmitter.EventEmitter = $c8502ad98c072938$var$EventEmitter;
module.exports = $c8502ad98c072938$var$EventEmitter;

});

parcelRegister("6F8ii", function(module, exports) {

$parcel$export(module.exports, "BaseError", () => $4d9d016f9d238c69$export$a490eb03cb7a0a5e);

var $5h3yZ = parcelRequire("5h3yZ");
let $4d9d016f9d238c69$var$errorConfig = {
    getDocsUrl: ({ docsBaseUrl: docsBaseUrl, docsPath: docsPath = "", docsSlug: docsSlug })=>docsPath ? `${docsBaseUrl ?? "https://viem.sh"}${docsPath}${docsSlug ? `#${docsSlug}` : ""}` : undefined,
    version: $5h3yZ.version
};
function $4d9d016f9d238c69$export$4ac109df0c5244e9(config) {
    $4d9d016f9d238c69$var$errorConfig = config;
}
class $4d9d016f9d238c69$export$a490eb03cb7a0a5e extends Error {
    constructor(shortMessage, args = {}){
        const details = (()=>{
            if (args.cause instanceof $4d9d016f9d238c69$export$a490eb03cb7a0a5e) return args.cause.details;
            if (args.cause?.message) return args.cause.message;
            return args.details;
        })();
        const docsPath = (()=>{
            if (args.cause instanceof $4d9d016f9d238c69$export$a490eb03cb7a0a5e) return args.cause.docsPath || args.docsPath;
            return args.docsPath;
        })();
        const docsUrl = $4d9d016f9d238c69$var$errorConfig.getDocsUrl?.({
            ...args,
            docsPath: docsPath
        });
        const message = [
            shortMessage || "An error occurred.",
            "",
            ...args.metaMessages ? [
                ...args.metaMessages,
                ""
            ] : [],
            ...docsUrl ? [
                `Docs: ${docsUrl}`
            ] : [],
            ...details ? [
                `Details: ${details}`
            ] : [],
            ...$4d9d016f9d238c69$var$errorConfig.version ? [
                `Version: ${$4d9d016f9d238c69$var$errorConfig.version}`
            ] : []
        ].join("\n");
        super(message, args.cause ? {
            cause: args.cause
        } : undefined);
        Object.defineProperty(this, "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "docsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "metaMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shortMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "version", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "BaseError"
        });
        this.details = details;
        this.docsPath = docsPath;
        this.metaMessages = args.metaMessages;
        this.name = args.name ?? this.name;
        this.shortMessage = shortMessage;
        this.version = (0, $5h3yZ.version);
    }
    walk(fn) {
        return $4d9d016f9d238c69$var$walk(this, fn);
    }
}
function $4d9d016f9d238c69$var$walk(err, fn) {
    if (fn?.(err)) return err;
    if (err && typeof err === "object" && "cause" in err) return $4d9d016f9d238c69$var$walk(err.cause, fn);
    return fn ? null : err;
}

});
parcelRegister("5h3yZ", function(module, exports) {

$parcel$export(module.exports, "version", () => $3d714de3c0149b34$export$83d89fbfd8236492);
const $3d714de3c0149b34$export$83d89fbfd8236492 = "2.19.3";

});


parcelRegister("j6NiR", function(module, exports) {

$parcel$export(module.exports, "isHex", () => $de94d27240188acc$export$8a9b6341a7c96bc);
function $de94d27240188acc$export$8a9b6341a7c96bc(value, { strict: strict = true } = {}) {
    if (!value) return false;
    if (typeof value !== "string") return false;
    return strict ? /^0x[0-9a-fA-F]*$/.test(value) : value.startsWith("0x");
}

});

parcelRegister("h1EgD", function(module, exports) {

$parcel$export(module.exports, "HttpRequestError", () => $c651c3ee900cfb9e$export$715ba3385e9f2cf0);
$parcel$export(module.exports, "RpcRequestError", () => $c651c3ee900cfb9e$export$a823590631c47261);
$parcel$export(module.exports, "TimeoutError", () => $c651c3ee900cfb9e$export$66d311bf29d5c89c);

var $lOTY7 = parcelRequire("lOTY7");

var $6F8ii = parcelRequire("6F8ii");

var $b6a64 = parcelRequire("b6a64");
class $c651c3ee900cfb9e$export$715ba3385e9f2cf0 extends (0, $6F8ii.BaseError) {
    constructor({ body: body, cause: cause, details: details, headers: headers, status: status, url: url }){
        super("HTTP request failed.", {
            cause: cause,
            details: details,
            metaMessages: [
                status && `Status: ${status}`,
                `URL: ${(0, $b6a64.getUrl)(url)}`,
                body && `Request body: ${(0, $lOTY7.stringify)(body)}`
            ].filter(Boolean),
            name: "HttpRequestError"
        });
        Object.defineProperty(this, "body", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "headers", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "status", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "url", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.body = body;
        this.headers = headers;
        this.status = status;
        this.url = url;
    }
}
class $c651c3ee900cfb9e$export$e1d72a3a26ed1bc extends (0, $6F8ii.BaseError) {
    constructor({ body: body, cause: cause, details: details, url: url }){
        super("WebSocket request failed.", {
            cause: cause,
            details: details,
            metaMessages: [
                `URL: ${(0, $b6a64.getUrl)(url)}`,
                body && `Request body: ${(0, $lOTY7.stringify)(body)}`
            ].filter(Boolean),
            name: "WebSocketRequestError"
        });
    }
}
class $c651c3ee900cfb9e$export$a823590631c47261 extends (0, $6F8ii.BaseError) {
    constructor({ body: body, error: error, url: url }){
        super("RPC Request failed.", {
            cause: error,
            details: error.message,
            metaMessages: [
                `URL: ${(0, $b6a64.getUrl)(url)}`,
                `Request body: ${(0, $lOTY7.stringify)(body)}`
            ],
            name: "RpcRequestError"
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.code = error.code;
    }
}
class $c651c3ee900cfb9e$export$a52f6cfb6f69ff4d extends (0, $6F8ii.BaseError) {
    constructor({ url: url } = {}){
        super("The socket has been closed.", {
            metaMessages: [
                url && `URL: ${(0, $b6a64.getUrl)(url)}`
            ].filter(Boolean),
            name: "SocketClosedError"
        });
    }
}
class $c651c3ee900cfb9e$export$66d311bf29d5c89c extends (0, $6F8ii.BaseError) {
    constructor({ body: body, url: url }){
        super("The request took too long to respond.", {
            details: "The request timed out.",
            metaMessages: [
                `URL: ${(0, $b6a64.getUrl)(url)}`,
                `Request body: ${(0, $lOTY7.stringify)(body)}`
            ],
            name: "TimeoutError"
        });
    }
}

});
parcelRegister("lOTY7", function(module, exports) {

$parcel$export(module.exports, "stringify", () => $fe29aead9d1f4495$export$fac44ee5b035f737);
const $fe29aead9d1f4495$export$fac44ee5b035f737 = (value, replacer, space)=>JSON.stringify(value, (key, value_)=>{
        const value = typeof value_ === "bigint" ? value_.toString() : value_;
        return typeof replacer === "function" ? replacer(key, value) : value;
    }, space);

});

parcelRegister("b6a64", function(module, exports) {

$parcel$export(module.exports, "getContractAddress", () => $81481645fe50aa27$export$b7fbffef12272e40);
$parcel$export(module.exports, "getUrl", () => $81481645fe50aa27$export$94df0e59ebebf4a7);
const $81481645fe50aa27$export$b7fbffef12272e40 = (address)=>address;
const $81481645fe50aa27$export$94df0e59ebebf4a7 = (url)=>url;

});


parcelRegister("juM8X", function(module, exports) {

$parcel$export(module.exports, "decodeErrorResult", () => $e31629f03e9e8757$export$8f7898b7bcae6080);

var $6o2KQ = parcelRequire("6o2KQ");

var $3TFRi = parcelRequire("3TFRi");

var $a7Rp0 = parcelRequire("a7Rp0");

var $4WVnB = parcelRequire("4WVnB");

var $4VcDz = parcelRequire("4VcDz");

var $dDQ3R = parcelRequire("dDQ3R");
function $e31629f03e9e8757$export$8f7898b7bcae6080(parameters) {
    const { abi: abi, data: data } = parameters;
    const signature = (0, $a7Rp0.slice)(data, 0, 4);
    if (signature === "0x") throw new (0, $3TFRi.AbiDecodingZeroDataError)();
    const abi_ = [
        ...abi || [],
        (0, $6o2KQ.solidityError),
        (0, $6o2KQ.solidityPanic)
    ];
    const abiItem = abi_.find((x)=>x.type === "error" && signature === (0, $4WVnB.toFunctionSelector)((0, $dDQ3R.formatAbiItem)(x)));
    if (!abiItem) throw new (0, $3TFRi.AbiErrorSignatureNotFoundError)(signature, {
        docsPath: "/docs/contract/decodeErrorResult"
    });
    return {
        abiItem: abiItem,
        args: "inputs" in abiItem && abiItem.inputs && abiItem.inputs.length > 0 ? (0, $4VcDz.decodeAbiParameters)(abiItem.inputs, (0, $a7Rp0.slice)(data, 4)) : undefined,
        errorName: abiItem.name
    };
}

});
parcelRegister("6o2KQ", function(module, exports) {

$parcel$export(module.exports, "panicReasons", () => $4a671ef64632c260$export$a618024566d3d221);
$parcel$export(module.exports, "solidityError", () => $4a671ef64632c260$export$730e9cc7aaa8ca20);
$parcel$export(module.exports, "solidityPanic", () => $4a671ef64632c260$export$e45b3aea1c5b33e6);
// https://docs.soliditylang.org/en/v0.8.16/control-structures.html#panic-via-assert-and-error-via-require
const $4a671ef64632c260$export$a618024566d3d221 = {
    1: "An `assert` condition failed.",
    17: "Arithmetic operation resulted in underflow or overflow.",
    18: "Division or modulo by zero (e.g. `5 / 0` or `23 % 0`).",
    33: "Attempted to convert to an invalid type.",
    34: "Attempted to access a storage byte array that is incorrectly encoded.",
    49: "Performed `.pop()` on an empty array",
    50: "Array index is out of bounds.",
    65: "Allocated too much memory or created an array which is too large.",
    81: "Attempted to call a zero-initialized variable of internal function type."
};
const $4a671ef64632c260$export$730e9cc7aaa8ca20 = {
    inputs: [
        {
            name: "message",
            type: "string"
        }
    ],
    name: "Error",
    type: "error"
};
const $4a671ef64632c260$export$e45b3aea1c5b33e6 = {
    inputs: [
        {
            name: "reason",
            type: "uint256"
        }
    ],
    name: "Panic",
    type: "error"
};

});

parcelRegister("3TFRi", function(module, exports) {

$parcel$export(module.exports, "AbiConstructorNotFoundError", () => $2d66fa6a76c6be34$export$efa723f306cf6168);
$parcel$export(module.exports, "AbiConstructorParamsNotFoundError", () => $2d66fa6a76c6be34$export$4faec14323ef9c47);
$parcel$export(module.exports, "AbiDecodingDataSizeTooSmallError", () => $2d66fa6a76c6be34$export$7a409e433c5f3a8c);
$parcel$export(module.exports, "AbiDecodingZeroDataError", () => $2d66fa6a76c6be34$export$a063cde4013f1935);
$parcel$export(module.exports, "AbiEncodingArrayLengthMismatchError", () => $2d66fa6a76c6be34$export$a851da9bf50b557);
$parcel$export(module.exports, "AbiEncodingBytesSizeMismatchError", () => $2d66fa6a76c6be34$export$19c281dc8e23a2ea);
$parcel$export(module.exports, "AbiEncodingLengthMismatchError", () => $2d66fa6a76c6be34$export$20737d495bb13c2d);
$parcel$export(module.exports, "AbiErrorSignatureNotFoundError", () => $2d66fa6a76c6be34$export$8959cb729fefe1ea);
$parcel$export(module.exports, "AbiEventSignatureEmptyTopicsError", () => $2d66fa6a76c6be34$export$f83210ce5f9b901f);
$parcel$export(module.exports, "AbiEventSignatureNotFoundError", () => $2d66fa6a76c6be34$export$3b44baeac92e4d3a);
$parcel$export(module.exports, "AbiEventNotFoundError", () => $2d66fa6a76c6be34$export$c7be62baad13b157);
$parcel$export(module.exports, "AbiFunctionNotFoundError", () => $2d66fa6a76c6be34$export$c4faa308ea7f9b2);
$parcel$export(module.exports, "AbiFunctionOutputsNotFoundError", () => $2d66fa6a76c6be34$export$26f2edb605108b34);
$parcel$export(module.exports, "AbiItemAmbiguityError", () => $2d66fa6a76c6be34$export$fdbba54ba15f2c2d);
$parcel$export(module.exports, "BytesSizeMismatchError", () => $2d66fa6a76c6be34$export$a0eb884ede5c87eb);
$parcel$export(module.exports, "DecodeLogDataMismatch", () => $2d66fa6a76c6be34$export$3978f86c08fc8c25);
$parcel$export(module.exports, "DecodeLogTopicsMismatch", () => $2d66fa6a76c6be34$export$6d7c6f419cf52377);
$parcel$export(module.exports, "InvalidAbiEncodingTypeError", () => $2d66fa6a76c6be34$export$53ed98b886965f49);
$parcel$export(module.exports, "InvalidAbiDecodingTypeError", () => $2d66fa6a76c6be34$export$cf94ccff0ff97c65);
$parcel$export(module.exports, "InvalidArrayError", () => $2d66fa6a76c6be34$export$710dd6d4f78cc47e);
$parcel$export(module.exports, "InvalidDefinitionTypeError", () => $2d66fa6a76c6be34$export$81781a0fcfb9ed95);

var $dDQ3R = parcelRequire("dDQ3R");

var $jBXg5 = parcelRequire("jBXg5");

var $6F8ii = parcelRequire("6F8ii");
class $2d66fa6a76c6be34$export$efa723f306cf6168 extends (0, $6F8ii.BaseError) {
    constructor({ docsPath: docsPath }){
        super([
            "A constructor was not found on the ABI.",
            "Make sure you are using the correct ABI and that the constructor exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiConstructorNotFoundError"
        });
    }
}
class $2d66fa6a76c6be34$export$4faec14323ef9c47 extends (0, $6F8ii.BaseError) {
    constructor({ docsPath: docsPath }){
        super([
            "Constructor arguments were provided (`args`), but a constructor parameters (`inputs`) were not found on the ABI.",
            "Make sure you are using the correct ABI, and that the `inputs` attribute on the constructor exists."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiConstructorParamsNotFoundError"
        });
    }
}
class $2d66fa6a76c6be34$export$68a7b570091cba69 extends (0, $6F8ii.BaseError) {
    constructor({ data: data, size: size }){
        super([
            `Data size of ${size} bytes is invalid.`,
            "Size must be in increments of 32 bytes (size % 32 === 0)."
        ].join("\n"), {
            metaMessages: [
                `Data: ${data} (${size} bytes)`
            ],
            name: "AbiDecodingDataSizeInvalidError"
        });
    }
}
class $2d66fa6a76c6be34$export$7a409e433c5f3a8c extends (0, $6F8ii.BaseError) {
    constructor({ data: data, params: params, size: size }){
        super([
            `Data size of ${size} bytes is too small for given parameters.`
        ].join("\n"), {
            metaMessages: [
                `Params: (${(0, $dDQ3R.formatAbiParams)(params, {
                    includeName: true
                })})`,
                `Data:   ${data} (${size} bytes)`
            ],
            name: "AbiDecodingDataSizeTooSmallError"
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "params", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "size", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = data;
        this.params = params;
        this.size = size;
    }
}
class $2d66fa6a76c6be34$export$a063cde4013f1935 extends (0, $6F8ii.BaseError) {
    constructor(){
        super('Cannot decode zero data ("0x") with ABI parameters.', {
            name: "AbiDecodingZeroDataError"
        });
    }
}
class $2d66fa6a76c6be34$export$a851da9bf50b557 extends (0, $6F8ii.BaseError) {
    constructor({ expectedLength: expectedLength, givenLength: givenLength, type: type }){
        super([
            `ABI encoding array length mismatch for type ${type}.`,
            `Expected length: ${expectedLength}`,
            `Given length: ${givenLength}`
        ].join("\n"), {
            name: "AbiEncodingArrayLengthMismatchError"
        });
    }
}
class $2d66fa6a76c6be34$export$19c281dc8e23a2ea extends (0, $6F8ii.BaseError) {
    constructor({ expectedSize: expectedSize, value: value }){
        super(`Size of bytes "${value}" (bytes${(0, $jBXg5.size)(value)}) does not match expected size (bytes${expectedSize}).`, {
            name: "AbiEncodingBytesSizeMismatchError"
        });
    }
}
class $2d66fa6a76c6be34$export$20737d495bb13c2d extends (0, $6F8ii.BaseError) {
    constructor({ expectedLength: expectedLength, givenLength: givenLength }){
        super([
            "ABI encoding params/values length mismatch.",
            `Expected length (params): ${expectedLength}`,
            `Given length (values): ${givenLength}`
        ].join("\n"), {
            name: "AbiEncodingLengthMismatchError"
        });
    }
}
class $2d66fa6a76c6be34$export$d47cf5ef47eda817 extends (0, $6F8ii.BaseError) {
    constructor(errorName, { docsPath: docsPath }){
        super([
            `Arguments (\`args\`) were provided to "${errorName}", but "${errorName}" on the ABI does not contain any parameters (\`inputs\`).`,
            "Cannot encode error result without knowing what the parameter types are.",
            "Make sure you are using the correct ABI and that the inputs exist on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiErrorInputsNotFoundError"
        });
    }
}
class $2d66fa6a76c6be34$export$86b719574b683f04 extends (0, $6F8ii.BaseError) {
    constructor(errorName, { docsPath: docsPath } = {}){
        super([
            `Error ${errorName ? `"${errorName}" ` : ""}not found on ABI.`,
            "Make sure you are using the correct ABI and that the error exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiErrorNotFoundError"
        });
    }
}
class $2d66fa6a76c6be34$export$8959cb729fefe1ea extends (0, $6F8ii.BaseError) {
    constructor(signature, { docsPath: docsPath }){
        super([
            `Encoded error signature "${signature}" not found on ABI.`,
            "Make sure you are using the correct ABI and that the error exists on it.",
            `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${signature}.`
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiErrorSignatureNotFoundError"
        });
        Object.defineProperty(this, "signature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.signature = signature;
    }
}
class $2d66fa6a76c6be34$export$f83210ce5f9b901f extends (0, $6F8ii.BaseError) {
    constructor({ docsPath: docsPath }){
        super("Cannot extract event signature from empty topics.", {
            docsPath: docsPath,
            name: "AbiEventSignatureEmptyTopicsError"
        });
    }
}
class $2d66fa6a76c6be34$export$3b44baeac92e4d3a extends (0, $6F8ii.BaseError) {
    constructor(signature, { docsPath: docsPath }){
        super([
            `Encoded event signature "${signature}" not found on ABI.`,
            "Make sure you are using the correct ABI and that the event exists on it.",
            `You can look up the signature here: https://openchain.xyz/signatures?query=${signature}.`
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiEventSignatureNotFoundError"
        });
    }
}
class $2d66fa6a76c6be34$export$c7be62baad13b157 extends (0, $6F8ii.BaseError) {
    constructor(eventName, { docsPath: docsPath } = {}){
        super([
            `Event ${eventName ? `"${eventName}" ` : ""}not found on ABI.`,
            "Make sure you are using the correct ABI and that the event exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiEventNotFoundError"
        });
    }
}
class $2d66fa6a76c6be34$export$c4faa308ea7f9b2 extends (0, $6F8ii.BaseError) {
    constructor(functionName, { docsPath: docsPath } = {}){
        super([
            `Function ${functionName ? `"${functionName}" ` : ""}not found on ABI.`,
            "Make sure you are using the correct ABI and that the function exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiFunctionNotFoundError"
        });
    }
}
class $2d66fa6a76c6be34$export$26f2edb605108b34 extends (0, $6F8ii.BaseError) {
    constructor(functionName, { docsPath: docsPath }){
        super([
            `Function "${functionName}" does not contain any \`outputs\` on ABI.`,
            "Cannot decode function result without knowing what the parameter types are.",
            "Make sure you are using the correct ABI and that the function exists on it."
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiFunctionOutputsNotFoundError"
        });
    }
}
class $2d66fa6a76c6be34$export$14373147a0e60810 extends (0, $6F8ii.BaseError) {
    constructor(signature, { docsPath: docsPath }){
        super([
            `Encoded function signature "${signature}" not found on ABI.`,
            "Make sure you are using the correct ABI and that the function exists on it.",
            `You can look up the signature here: https://openchain.xyz/signatures?query=${signature}.`
        ].join("\n"), {
            docsPath: docsPath,
            name: "AbiFunctionSignatureNotFoundError"
        });
    }
}
class $2d66fa6a76c6be34$export$fdbba54ba15f2c2d extends (0, $6F8ii.BaseError) {
    constructor(x, y){
        super("Found ambiguous types in overloaded ABI items.", {
            metaMessages: [
                `\`${x.type}\` in \`${(0, $dDQ3R.formatAbiItem)(x.abiItem)}\`, and`,
                `\`${y.type}\` in \`${(0, $dDQ3R.formatAbiItem)(y.abiItem)}\``,
                "",
                "These types encode differently and cannot be distinguished at runtime.",
                "Remove one of the ambiguous items in the ABI."
            ],
            name: "AbiItemAmbiguityError"
        });
    }
}
class $2d66fa6a76c6be34$export$a0eb884ede5c87eb extends (0, $6F8ii.BaseError) {
    constructor({ expectedSize: expectedSize, givenSize: givenSize }){
        super(`Expected bytes${expectedSize}, got bytes${givenSize}.`, {
            name: "BytesSizeMismatchError"
        });
    }
}
class $2d66fa6a76c6be34$export$3978f86c08fc8c25 extends (0, $6F8ii.BaseError) {
    constructor({ abiItem: abiItem, data: data, params: params, size: size }){
        super([
            `Data size of ${size} bytes is too small for non-indexed event parameters.`
        ].join("\n"), {
            metaMessages: [
                `Params: (${(0, $dDQ3R.formatAbiParams)(params, {
                    includeName: true
                })})`,
                `Data:   ${data} (${size} bytes)`
            ],
            name: "DecodeLogDataMismatch"
        });
        Object.defineProperty(this, "abiItem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "params", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "size", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.abiItem = abiItem;
        this.data = data;
        this.params = params;
        this.size = size;
    }
}
class $2d66fa6a76c6be34$export$6d7c6f419cf52377 extends (0, $6F8ii.BaseError) {
    constructor({ abiItem: abiItem, param: param }){
        super([
            `Expected a topic for indexed event parameter${param.name ? ` "${param.name}"` : ""} on event "${(0, $dDQ3R.formatAbiItem)(abiItem, {
                includeName: true
            })}".`
        ].join("\n"), {
            name: "DecodeLogTopicsMismatch"
        });
        Object.defineProperty(this, "abiItem", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.abiItem = abiItem;
    }
}
class $2d66fa6a76c6be34$export$53ed98b886965f49 extends (0, $6F8ii.BaseError) {
    constructor(type, { docsPath: docsPath }){
        super([
            `Type "${type}" is not a valid encoding type.`,
            "Please provide a valid ABI type."
        ].join("\n"), {
            docsPath: docsPath,
            name: "InvalidAbiEncodingType"
        });
    }
}
class $2d66fa6a76c6be34$export$cf94ccff0ff97c65 extends (0, $6F8ii.BaseError) {
    constructor(type, { docsPath: docsPath }){
        super([
            `Type "${type}" is not a valid decoding type.`,
            "Please provide a valid ABI type."
        ].join("\n"), {
            docsPath: docsPath,
            name: "InvalidAbiDecodingType"
        });
    }
}
class $2d66fa6a76c6be34$export$710dd6d4f78cc47e extends (0, $6F8ii.BaseError) {
    constructor(value){
        super([
            `Value "${value}" is not a valid array.`
        ].join("\n"), {
            name: "InvalidArrayError"
        });
    }
}
class $2d66fa6a76c6be34$export$81781a0fcfb9ed95 extends (0, $6F8ii.BaseError) {
    constructor(type){
        super([
            `"${type}" is not a valid definition type.`,
            'Valid types: "function", "event", "error"'
        ].join("\n"), {
            name: "InvalidDefinitionTypeError"
        });
    }
}
class $2d66fa6a76c6be34$export$a16541e2fe420ef1 extends (0, $6F8ii.BaseError) {
    constructor(type){
        super(`Type "${type}" is not supported for packed encoding.`, {
            name: "UnsupportedPackedAbiType"
        });
    }
}

});
parcelRegister("dDQ3R", function(module, exports) {

$parcel$export(module.exports, "formatAbiItem", () => $02901e25cb421784$export$dc5d0ff4fc2fdee1);
$parcel$export(module.exports, "formatAbiParams", () => $02901e25cb421784$export$849e499971de75b3);

var $3TFRi = parcelRequire("3TFRi");
function $02901e25cb421784$export$dc5d0ff4fc2fdee1(abiItem, { includeName: includeName = false } = {}) {
    if (abiItem.type !== "function" && abiItem.type !== "event" && abiItem.type !== "error") throw new (0, $3TFRi.InvalidDefinitionTypeError)(abiItem.type);
    return `${abiItem.name}(${$02901e25cb421784$export$849e499971de75b3(abiItem.inputs, {
        includeName: includeName
    })})`;
}
function $02901e25cb421784$export$849e499971de75b3(params, { includeName: includeName = false } = {}) {
    if (!params) return "";
    return params.map((param)=>$02901e25cb421784$var$formatAbiParam(param, {
            includeName: includeName
        })).join(includeName ? ", " : ",");
}
function $02901e25cb421784$var$formatAbiParam(param, { includeName: includeName }) {
    if (param.type.startsWith("tuple")) return `(${$02901e25cb421784$export$849e499971de75b3(param.components, {
        includeName: includeName
    })})${param.type.slice(5)}`;
    return param.type + (includeName && param.name ? ` ${param.name}` : "");
}

});

parcelRegister("jBXg5", function(module, exports) {

$parcel$export(module.exports, "size", () => $e46f7085cb995369$export$346677f925de839c);

var $j6NiR = parcelRequire("j6NiR");
function $e46f7085cb995369$export$346677f925de839c(value) {
    if ((0, $j6NiR.isHex)(value, {
        strict: false
    })) return Math.ceil((value.length - 2) / 2);
    return value.length;
}

});


parcelRegister("a7Rp0", function(module, exports) {

$parcel$export(module.exports, "slice", () => $75f3fb64b2dd94ba$export$58adb3bec8346d0f);
$parcel$export(module.exports, "sliceHex", () => $75f3fb64b2dd94ba$export$728fe14c970402fe);
$parcel$export(module.exports, "sliceBytes", () => $75f3fb64b2dd94ba$export$8bac03c8c1da551);

var $eyBMJ = parcelRequire("eyBMJ");

var $j6NiR = parcelRequire("j6NiR");

var $jBXg5 = parcelRequire("jBXg5");
function $75f3fb64b2dd94ba$export$58adb3bec8346d0f(value, start, end, { strict: strict } = {}) {
    if ((0, $j6NiR.isHex)(value, {
        strict: false
    })) return $75f3fb64b2dd94ba$export$728fe14c970402fe(value, start, end, {
        strict: strict
    });
    return $75f3fb64b2dd94ba$export$8bac03c8c1da551(value, start, end, {
        strict: strict
    });
}
function $75f3fb64b2dd94ba$var$assertStartOffset(value, start) {
    if (typeof start === "number" && start > 0 && start > (0, $jBXg5.size)(value) - 1) throw new (0, $eyBMJ.SliceOffsetOutOfBoundsError)({
        offset: start,
        position: "start",
        size: (0, $jBXg5.size)(value)
    });
}
function $75f3fb64b2dd94ba$var$assertEndOffset(value, start, end) {
    if (typeof start === "number" && typeof end === "number" && (0, $jBXg5.size)(value) !== end - start) throw new (0, $eyBMJ.SliceOffsetOutOfBoundsError)({
        offset: end,
        position: "end",
        size: (0, $jBXg5.size)(value)
    });
}
function $75f3fb64b2dd94ba$export$8bac03c8c1da551(value_, start, end, { strict: strict } = {}) {
    $75f3fb64b2dd94ba$var$assertStartOffset(value_, start);
    const value = value_.slice(start, end);
    if (strict) $75f3fb64b2dd94ba$var$assertEndOffset(value, start, end);
    return value;
}
function $75f3fb64b2dd94ba$export$728fe14c970402fe(value_, start, end, { strict: strict } = {}) {
    $75f3fb64b2dd94ba$var$assertStartOffset(value_, start);
    const value = `0x${value_.replace("0x", "").slice((start ?? 0) * 2, (end ?? value_.length) * 2)}`;
    if (strict) $75f3fb64b2dd94ba$var$assertEndOffset(value, start, end);
    return value;
}

});
parcelRegister("eyBMJ", function(module, exports) {

$parcel$export(module.exports, "SliceOffsetOutOfBoundsError", () => $a9918cf41f8a5bb4$export$cfcd41bba8b36dbd);
$parcel$export(module.exports, "SizeExceedsPaddingSizeError", () => $a9918cf41f8a5bb4$export$70445dc308a7f3d5);
$parcel$export(module.exports, "InvalidBytesLengthError", () => $a9918cf41f8a5bb4$export$8a5469becf223114);

var $6F8ii = parcelRequire("6F8ii");
class $a9918cf41f8a5bb4$export$cfcd41bba8b36dbd extends (0, $6F8ii.BaseError) {
    constructor({ offset: offset, position: position, size: size }){
        super(`Slice ${position === "start" ? "starting" : "ending"} at offset "${offset}" is out-of-bounds (size: ${size}).`, {
            name: "SliceOffsetOutOfBoundsError"
        });
    }
}
class $a9918cf41f8a5bb4$export$70445dc308a7f3d5 extends (0, $6F8ii.BaseError) {
    constructor({ size: size, targetSize: targetSize, type: type }){
        super(`${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()} size (${size}) exceeds padding size (${targetSize}).`, {
            name: "SizeExceedsPaddingSizeError"
        });
    }
}
class $a9918cf41f8a5bb4$export$8a5469becf223114 extends (0, $6F8ii.BaseError) {
    constructor({ size: size, targetSize: targetSize, type: type }){
        super(`${type.charAt(0).toUpperCase()}${type.slice(1).toLowerCase()} is expected to be ${targetSize} ${type} long, but is ${size} ${type} long.`, {
            name: "InvalidBytesLengthError"
        });
    }
}

});


parcelRegister("4WVnB", function(module, exports) {

$parcel$export(module.exports, "toFunctionSelector", () => $39a9169a421fad89$export$e2442488533809cb);

var $a7Rp0 = parcelRequire("a7Rp0");

var $4wYDE = parcelRequire("4wYDE");
const $39a9169a421fad89$export$e2442488533809cb = (fn)=>(0, $a7Rp0.slice)((0, $4wYDE.toSignatureHash)(fn), 0, 4);

});
parcelRegister("4wYDE", function(module, exports) {

$parcel$export(module.exports, "toSignatureHash", () => $34c93022b0f13812$export$d809beebc9c913db);

var $4U7Ey = parcelRequire("4U7Ey");

var $5slab = parcelRequire("5slab");
function $34c93022b0f13812$export$d809beebc9c913db(fn) {
    return (0, $4U7Ey.hashSignature)((0, $5slab.toSignature)(fn));
}

});
parcelRegister("4U7Ey", function(module, exports) {

$parcel$export(module.exports, "hashSignature", () => $3922542490605893$export$77bbcd7aaec17976);

var $eFDiV = parcelRequire("eFDiV");

var $bRe6l = parcelRequire("bRe6l");
const $3922542490605893$var$hash = (value)=>(0, $bRe6l.keccak256)((0, $eFDiV.toBytes)(value));
function $3922542490605893$export$77bbcd7aaec17976(sig) {
    return $3922542490605893$var$hash(sig);
}

});
parcelRegister("eFDiV", function(module, exports) {

$parcel$export(module.exports, "toBytes", () => $aae3620c73f8dc50$export$30a71edf0753ed6b);
$parcel$export(module.exports, "hexToBytes", () => $aae3620c73f8dc50$export$31c96b9df38bc8d4);
$parcel$export(module.exports, "stringToBytes", () => $aae3620c73f8dc50$export$c8dd6bc66a63753c);

var $6F8ii = parcelRequire("6F8ii");

var $j6NiR = parcelRequire("j6NiR");

var $2OmJE = parcelRequire("2OmJE");

var $7Zv5I = parcelRequire("7Zv5I");

var $9UP4H = parcelRequire("9UP4H");
const $aae3620c73f8dc50$var$encoder = /*#__PURE__*/ new TextEncoder();
function $aae3620c73f8dc50$export$30a71edf0753ed6b(value, opts = {}) {
    if (typeof value === "number" || typeof value === "bigint") return $aae3620c73f8dc50$export$49ad9be85c347998(value, opts);
    if (typeof value === "boolean") return $aae3620c73f8dc50$export$771517697a68241(value, opts);
    if ((0, $j6NiR.isHex)(value)) return $aae3620c73f8dc50$export$31c96b9df38bc8d4(value, opts);
    return $aae3620c73f8dc50$export$c8dd6bc66a63753c(value, opts);
}
function $aae3620c73f8dc50$export$771517697a68241(value, opts = {}) {
    const bytes = new Uint8Array(1);
    bytes[0] = Number(value);
    if (typeof opts.size === "number") {
        (0, $7Zv5I.assertSize)(bytes, {
            size: opts.size
        });
        return (0, $2OmJE.pad)(bytes, {
            size: opts.size
        });
    }
    return bytes;
}
// We use very optimized technique to convert hex string to byte array
const $aae3620c73f8dc50$var$charCodeMap = {
    zero: 48,
    nine: 57,
    A: 65,
    F: 70,
    a: 97,
    f: 102
};
function $aae3620c73f8dc50$var$charCodeToBase16(char) {
    if (char >= $aae3620c73f8dc50$var$charCodeMap.zero && char <= $aae3620c73f8dc50$var$charCodeMap.nine) return char - $aae3620c73f8dc50$var$charCodeMap.zero;
    if (char >= $aae3620c73f8dc50$var$charCodeMap.A && char <= $aae3620c73f8dc50$var$charCodeMap.F) return char - ($aae3620c73f8dc50$var$charCodeMap.A - 10);
    if (char >= $aae3620c73f8dc50$var$charCodeMap.a && char <= $aae3620c73f8dc50$var$charCodeMap.f) return char - ($aae3620c73f8dc50$var$charCodeMap.a - 10);
    return undefined;
}
function $aae3620c73f8dc50$export$31c96b9df38bc8d4(hex_, opts = {}) {
    let hex = hex_;
    if (opts.size) {
        (0, $7Zv5I.assertSize)(hex, {
            size: opts.size
        });
        hex = (0, $2OmJE.pad)(hex, {
            dir: "right",
            size: opts.size
        });
    }
    let hexString = hex.slice(2);
    if (hexString.length % 2) hexString = `0${hexString}`;
    const length = hexString.length / 2;
    const bytes = new Uint8Array(length);
    for(let index = 0, j = 0; index < length; index++){
        const nibbleLeft = $aae3620c73f8dc50$var$charCodeToBase16(hexString.charCodeAt(j++));
        const nibbleRight = $aae3620c73f8dc50$var$charCodeToBase16(hexString.charCodeAt(j++));
        if (nibbleLeft === undefined || nibbleRight === undefined) throw new (0, $6F8ii.BaseError)(`Invalid byte sequence ("${hexString[j - 2]}${hexString[j - 1]}" in "${hexString}").`);
        bytes[index] = nibbleLeft * 16 + nibbleRight;
    }
    return bytes;
}
function $aae3620c73f8dc50$export$49ad9be85c347998(value, opts) {
    const hex = (0, $9UP4H.numberToHex)(value, opts);
    return $aae3620c73f8dc50$export$31c96b9df38bc8d4(hex);
}
function $aae3620c73f8dc50$export$c8dd6bc66a63753c(value, opts = {}) {
    const bytes = $aae3620c73f8dc50$var$encoder.encode(value);
    if (typeof opts.size === "number") {
        (0, $7Zv5I.assertSize)(bytes, {
            size: opts.size
        });
        return (0, $2OmJE.pad)(bytes, {
            dir: "right",
            size: opts.size
        });
    }
    return bytes;
}

});
parcelRegister("2OmJE", function(module, exports) {

$parcel$export(module.exports, "pad", () => $20c1e30482ec7a5a$export$5d04458e2a6c373e);
$parcel$export(module.exports, "padHex", () => $20c1e30482ec7a5a$export$1bcd51c0fce8ee55);

var $eyBMJ = parcelRequire("eyBMJ");
function $20c1e30482ec7a5a$export$5d04458e2a6c373e(hexOrBytes, { dir: dir, size: size = 32 } = {}) {
    if (typeof hexOrBytes === "string") return $20c1e30482ec7a5a$export$1bcd51c0fce8ee55(hexOrBytes, {
        dir: dir,
        size: size
    });
    return $20c1e30482ec7a5a$export$4c6b868113605df3(hexOrBytes, {
        dir: dir,
        size: size
    });
}
function $20c1e30482ec7a5a$export$1bcd51c0fce8ee55(hex_, { dir: dir, size: size = 32 } = {}) {
    if (size === null) return hex_;
    const hex = hex_.replace("0x", "");
    if (hex.length > size * 2) throw new (0, $eyBMJ.SizeExceedsPaddingSizeError)({
        size: Math.ceil(hex.length / 2),
        targetSize: size,
        type: "hex"
    });
    return `0x${hex[dir === "right" ? "padEnd" : "padStart"](size * 2, "0")}`;
}
function $20c1e30482ec7a5a$export$4c6b868113605df3(bytes, { dir: dir, size: size = 32 } = {}) {
    if (size === null) return bytes;
    if (bytes.length > size) throw new (0, $eyBMJ.SizeExceedsPaddingSizeError)({
        size: bytes.length,
        targetSize: size,
        type: "bytes"
    });
    const paddedBytes = new Uint8Array(size);
    for(let i = 0; i < size; i++){
        const padEnd = dir === "right";
        paddedBytes[padEnd ? i : size - i - 1] = bytes[padEnd ? i : bytes.length - i - 1];
    }
    return paddedBytes;
}

});

parcelRegister("7Zv5I", function(module, exports) {

$parcel$export(module.exports, "assertSize", () => $5d1658f9ffd3af16$export$2af489edb7fa35fe);
$parcel$export(module.exports, "hexToNumber", () => $5d1658f9ffd3af16$export$d57f2bacc26b4249);
$parcel$export(module.exports, "hexToBigInt", () => $5d1658f9ffd3af16$export$92a44656ec81b584);
$parcel$export(module.exports, "hexToString", () => $5d1658f9ffd3af16$export$f4bc7e46f3eb3ac3);

var $cN7s9 = parcelRequire("cN7s9");

var $jBXg5 = parcelRequire("jBXg5");

var $44bP9 = parcelRequire("44bP9");

var $eFDiV = parcelRequire("eFDiV");
function $5d1658f9ffd3af16$export$2af489edb7fa35fe(hexOrBytes, { size: size }) {
    if ((0, $jBXg5.size)(hexOrBytes) > size) throw new (0, $cN7s9.SizeOverflowError)({
        givenSize: (0, $jBXg5.size)(hexOrBytes),
        maxSize: size
    });
}
function $5d1658f9ffd3af16$export$1a8ceedbd5845648(hex, toOrOpts) {
    const opts = typeof toOrOpts === "string" ? {
        to: toOrOpts
    } : toOrOpts;
    const to = opts.to;
    if (to === "number") return $5d1658f9ffd3af16$export$d57f2bacc26b4249(hex, opts);
    if (to === "bigint") return $5d1658f9ffd3af16$export$92a44656ec81b584(hex, opts);
    if (to === "string") return $5d1658f9ffd3af16$export$f4bc7e46f3eb3ac3(hex, opts);
    if (to === "boolean") return $5d1658f9ffd3af16$export$bde1d77e6fe6c41e(hex, opts);
    return (0, $eFDiV.hexToBytes)(hex, opts);
}
function $5d1658f9ffd3af16$export$92a44656ec81b584(hex, opts = {}) {
    const { signed: signed } = opts;
    if (opts.size) $5d1658f9ffd3af16$export$2af489edb7fa35fe(hex, {
        size: opts.size
    });
    const value = BigInt(hex);
    if (!signed) return value;
    const size = (hex.length - 2) / 2;
    const max = (1n << BigInt(size) * 8n - 1n) - 1n;
    if (value <= max) return value;
    return value - BigInt(`0x${"f".padStart(size * 2, "f")}`) - 1n;
}
function $5d1658f9ffd3af16$export$bde1d77e6fe6c41e(hex_, opts = {}) {
    let hex = hex_;
    if (opts.size) {
        $5d1658f9ffd3af16$export$2af489edb7fa35fe(hex, {
            size: opts.size
        });
        hex = (0, $44bP9.trim)(hex);
    }
    if ((0, $44bP9.trim)(hex) === "0x00") return false;
    if ((0, $44bP9.trim)(hex) === "0x01") return true;
    throw new (0, $cN7s9.InvalidHexBooleanError)(hex);
}
function $5d1658f9ffd3af16$export$d57f2bacc26b4249(hex, opts = {}) {
    return Number($5d1658f9ffd3af16$export$92a44656ec81b584(hex, opts));
}
function $5d1658f9ffd3af16$export$f4bc7e46f3eb3ac3(hex, opts = {}) {
    let bytes = (0, $eFDiV.hexToBytes)(hex);
    if (opts.size) {
        $5d1658f9ffd3af16$export$2af489edb7fa35fe(bytes, {
            size: opts.size
        });
        bytes = (0, $44bP9.trim)(bytes, {
            dir: "right"
        });
    }
    return new TextDecoder().decode(bytes);
}

});
parcelRegister("cN7s9", function(module, exports) {

$parcel$export(module.exports, "IntegerOutOfRangeError", () => $94ffd7a3b27665fc$export$47d164a8071229a9);
$parcel$export(module.exports, "InvalidBytesBooleanError", () => $94ffd7a3b27665fc$export$52fc62e5266c8838);
$parcel$export(module.exports, "InvalidHexBooleanError", () => $94ffd7a3b27665fc$export$f574ac54e35514c);
$parcel$export(module.exports, "SizeOverflowError", () => $94ffd7a3b27665fc$export$beb44ed4f8747d0e);

var $6F8ii = parcelRequire("6F8ii");
class $94ffd7a3b27665fc$export$47d164a8071229a9 extends (0, $6F8ii.BaseError) {
    constructor({ max: max, min: min, signed: signed, size: size, value: value }){
        super(`Number "${value}" is not in safe ${size ? `${size * 8}-bit ${signed ? "signed" : "unsigned"} ` : ""}integer range ${max ? `(${min} to ${max})` : `(above ${min})`}`, {
            name: "IntegerOutOfRangeError"
        });
    }
}
class $94ffd7a3b27665fc$export$52fc62e5266c8838 extends (0, $6F8ii.BaseError) {
    constructor(bytes){
        super(`Bytes value "${bytes}" is not a valid boolean. The bytes array must contain a single byte of either a 0 or 1 value.`, {
            name: "InvalidBytesBooleanError"
        });
    }
}
class $94ffd7a3b27665fc$export$f574ac54e35514c extends (0, $6F8ii.BaseError) {
    constructor(hex){
        super(`Hex value "${hex}" is not a valid boolean. The hex value must be "0x0" (false) or "0x1" (true).`, {
            name: "InvalidHexBooleanError"
        });
    }
}
class $94ffd7a3b27665fc$export$ef05eafd11dd4a83 extends (0, $6F8ii.BaseError) {
    constructor(value){
        super(`Hex value "${value}" is an odd length (${value.length}). It must be an even length.`, {
            name: "InvalidHexValueError"
        });
    }
}
class $94ffd7a3b27665fc$export$beb44ed4f8747d0e extends (0, $6F8ii.BaseError) {
    constructor({ givenSize: givenSize, maxSize: maxSize }){
        super(`Size cannot exceed ${maxSize} bytes. Given size: ${givenSize} bytes.`, {
            name: "SizeOverflowError"
        });
    }
}

});

parcelRegister("44bP9", function(module, exports) {

$parcel$export(module.exports, "trim", () => $2f60b52abc6013a6$export$87c2784dc9fc4ab);
function $2f60b52abc6013a6$export$87c2784dc9fc4ab(hexOrBytes, { dir: dir = "left" } = {}) {
    let data = typeof hexOrBytes === "string" ? hexOrBytes.replace("0x", "") : hexOrBytes;
    let sliceLength = 0;
    for(let i = 0; i < data.length - 1; i++){
        if (data[dir === "left" ? i : data.length - i - 1].toString() === "0") sliceLength++;
        else break;
    }
    data = dir === "left" ? data.slice(sliceLength) : data.slice(0, data.length - sliceLength);
    if (typeof hexOrBytes === "string") {
        if (data.length === 1 && dir === "right") data = `${data}0`;
        return `0x${data.length % 2 === 1 ? `0${data}` : data}`;
    }
    return data;
}

});


parcelRegister("9UP4H", function(module, exports) {

$parcel$export(module.exports, "toHex", () => $7380f66494deea91$export$7ea66e3774a60b67);
$parcel$export(module.exports, "numberToHex", () => $7380f66494deea91$export$4e87185b7ecfeec4);
$parcel$export(module.exports, "stringToHex", () => $7380f66494deea91$export$551c48dea6f88e6d);
$parcel$export(module.exports, "boolToHex", () => $7380f66494deea91$export$b5c95dec4f62ef7a);
$parcel$export(module.exports, "bytesToHex", () => $7380f66494deea91$export$58b867e287a802c8);

var $cN7s9 = parcelRequire("cN7s9");

var $2OmJE = parcelRequire("2OmJE");

var $7Zv5I = parcelRequire("7Zv5I");
const $7380f66494deea91$var$hexes = /*#__PURE__*/ Array.from({
    length: 256
}, (_v, i)=>i.toString(16).padStart(2, "0"));
function $7380f66494deea91$export$7ea66e3774a60b67(value, opts = {}) {
    if (typeof value === "number" || typeof value === "bigint") return $7380f66494deea91$export$4e87185b7ecfeec4(value, opts);
    if (typeof value === "string") return $7380f66494deea91$export$551c48dea6f88e6d(value, opts);
    if (typeof value === "boolean") return $7380f66494deea91$export$b5c95dec4f62ef7a(value, opts);
    return $7380f66494deea91$export$58b867e287a802c8(value, opts);
}
function $7380f66494deea91$export$b5c95dec4f62ef7a(value, opts = {}) {
    const hex = `0x${Number(value)}`;
    if (typeof opts.size === "number") {
        (0, $7Zv5I.assertSize)(hex, {
            size: opts.size
        });
        return (0, $2OmJE.pad)(hex, {
            size: opts.size
        });
    }
    return hex;
}
function $7380f66494deea91$export$58b867e287a802c8(value, opts = {}) {
    let string = "";
    for(let i = 0; i < value.length; i++)string += $7380f66494deea91$var$hexes[value[i]];
    const hex = `0x${string}`;
    if (typeof opts.size === "number") {
        (0, $7Zv5I.assertSize)(hex, {
            size: opts.size
        });
        return (0, $2OmJE.pad)(hex, {
            dir: "right",
            size: opts.size
        });
    }
    return hex;
}
function $7380f66494deea91$export$4e87185b7ecfeec4(value_, opts = {}) {
    const { signed: signed, size: size } = opts;
    const value = BigInt(value_);
    let maxValue;
    if (size) {
        if (signed) maxValue = (1n << BigInt(size) * 8n - 1n) - 1n;
        else maxValue = 2n ** (BigInt(size) * 8n) - 1n;
    } else if (typeof value_ === "number") maxValue = BigInt(Number.MAX_SAFE_INTEGER);
    const minValue = typeof maxValue === "bigint" && signed ? -maxValue - 1n : 0;
    if (maxValue && value > maxValue || value < minValue) {
        const suffix = typeof value_ === "bigint" ? "n" : "";
        throw new (0, $cN7s9.IntegerOutOfRangeError)({
            max: maxValue ? `${maxValue}${suffix}` : undefined,
            min: `${minValue}${suffix}`,
            signed: signed,
            size: size,
            value: `${value_}${suffix}`
        });
    }
    const hex = `0x${(signed && value < 0 ? (1n << BigInt(size * 8)) + BigInt(value) : value).toString(16)}`;
    if (size) return (0, $2OmJE.pad)(hex, {
        size: size
    });
    return hex;
}
const $7380f66494deea91$var$encoder = /*#__PURE__*/ new TextEncoder();
function $7380f66494deea91$export$551c48dea6f88e6d(value_, opts = {}) {
    const value = $7380f66494deea91$var$encoder.encode(value_);
    return $7380f66494deea91$export$58b867e287a802c8(value, opts);
}

});


parcelRegister("bRe6l", function(module, exports) {

$parcel$export(module.exports, "keccak256", () => $8a1f952fc3975cfb$export$f8151fce47ad1c35);

var $hrc0B = parcelRequire("hrc0B");

var $j6NiR = parcelRequire("j6NiR");

var $eFDiV = parcelRequire("eFDiV");

var $9UP4H = parcelRequire("9UP4H");
function $8a1f952fc3975cfb$export$f8151fce47ad1c35(value, to_) {
    const to = to_ || "hex";
    const bytes = (0, $hrc0B.keccak_256)((0, $j6NiR.isHex)(value, {
        strict: false
    }) ? (0, $eFDiV.toBytes)(value) : value);
    if (to === "bytes") return bytes;
    return (0, $9UP4H.toHex)(bytes);
}

});
parcelRegister("hrc0B", function(module, exports) {

$parcel$export(module.exports, "keccak_256", () => $cb1e45f9a77f1d8f$export$860ddaa9ca84a66d);

var $jxb68 = parcelRequire("jxb68");

var $gbRBw = parcelRequire("gbRBw");

var $5358X = parcelRequire("5358X");
// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const $cb1e45f9a77f1d8f$var$SHA3_PI = [];
const $cb1e45f9a77f1d8f$var$SHA3_ROTL = [];
const $cb1e45f9a77f1d8f$var$_SHA3_IOTA = [];
const $cb1e45f9a77f1d8f$var$_0n = /* @__PURE__ */ BigInt(0);
const $cb1e45f9a77f1d8f$var$_1n = /* @__PURE__ */ BigInt(1);
const $cb1e45f9a77f1d8f$var$_2n = /* @__PURE__ */ BigInt(2);
const $cb1e45f9a77f1d8f$var$_7n = /* @__PURE__ */ BigInt(7);
const $cb1e45f9a77f1d8f$var$_256n = /* @__PURE__ */ BigInt(256);
const $cb1e45f9a77f1d8f$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $cb1e45f9a77f1d8f$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $cb1e45f9a77f1d8f$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $cb1e45f9a77f1d8f$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $cb1e45f9a77f1d8f$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $cb1e45f9a77f1d8f$var$_1n ^ (R >> $cb1e45f9a77f1d8f$var$_7n) * $cb1e45f9a77f1d8f$var$_0x71n) % $cb1e45f9a77f1d8f$var$_256n;
        if (R & $cb1e45f9a77f1d8f$var$_2n) t ^= $cb1e45f9a77f1d8f$var$_1n << ($cb1e45f9a77f1d8f$var$_1n << /* @__PURE__ */ BigInt(j)) - $cb1e45f9a77f1d8f$var$_1n;
    }
    $cb1e45f9a77f1d8f$var$_SHA3_IOTA.push(t);
}
const [$cb1e45f9a77f1d8f$var$SHA3_IOTA_H, $cb1e45f9a77f1d8f$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $gbRBw.split)($cb1e45f9a77f1d8f$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $cb1e45f9a77f1d8f$var$rotlH = (h, l, s)=>s > 32 ? (0, $gbRBw.rotlBH)(h, l, s) : (0, $gbRBw.rotlSH)(h, l, s);
const $cb1e45f9a77f1d8f$var$rotlL = (h, l, s)=>s > 32 ? (0, $gbRBw.rotlBL)(h, l, s) : (0, $gbRBw.rotlSL)(h, l, s);
function $cb1e45f9a77f1d8f$export$1bcd3d5a58ba6fb0(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $cb1e45f9a77f1d8f$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $cb1e45f9a77f1d8f$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $cb1e45f9a77f1d8f$var$SHA3_ROTL[t];
            const Th = $cb1e45f9a77f1d8f$var$rotlH(curH, curL, shift);
            const Tl = $cb1e45f9a77f1d8f$var$rotlL(curH, curL, shift);
            const PI = $cb1e45f9a77f1d8f$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $cb1e45f9a77f1d8f$var$SHA3_IOTA_H[round];
        s[1] ^= $cb1e45f9a77f1d8f$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
class $cb1e45f9a77f1d8f$export$f7374b8b4498bc2e extends (0, $5358X.Hash) {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $jxb68.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $5358X.u32)(this.state);
    }
    keccak() {
        if (!(0, $5358X.isLE)) (0, $5358X.byteSwap32)(this.state32);
        $cb1e45f9a77f1d8f$export$1bcd3d5a58ba6fb0(this.state32, this.rounds);
        if (!(0, $5358X.isLE)) (0, $5358X.byteSwap32)(this.state32);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $jxb68.exists)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $5358X.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $jxb68.exists)(this, false);
        (0, $jxb68.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $jxb68.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $jxb68.output)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $cb1e45f9a77f1d8f$export$f7374b8b4498bc2e(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
const $cb1e45f9a77f1d8f$var$gen = (suffix, blockLen, outputLen)=>(0, $5358X.wrapConstructor)(()=>new $cb1e45f9a77f1d8f$export$f7374b8b4498bc2e(blockLen, suffix, outputLen));
const $cb1e45f9a77f1d8f$export$fe6c2b96a79338e9 = /* @__PURE__ */ $cb1e45f9a77f1d8f$var$gen(0x06, 144, 28);
const $cb1e45f9a77f1d8f$export$76e19b6966813b14 = /* @__PURE__ */ $cb1e45f9a77f1d8f$var$gen(0x06, 136, 32);
const $cb1e45f9a77f1d8f$export$a58509fa80f30d15 = /* @__PURE__ */ $cb1e45f9a77f1d8f$var$gen(0x06, 104, 48);
const $cb1e45f9a77f1d8f$export$20ed324dbdf09b7c = /* @__PURE__ */ $cb1e45f9a77f1d8f$var$gen(0x06, 72, 64);
const $cb1e45f9a77f1d8f$export$2f7fb3c6fac246bc = /* @__PURE__ */ $cb1e45f9a77f1d8f$var$gen(0x01, 144, 28);
const $cb1e45f9a77f1d8f$export$860ddaa9ca84a66d = /* @__PURE__ */ $cb1e45f9a77f1d8f$var$gen(0x01, 136, 32);
const $cb1e45f9a77f1d8f$export$46fcdeb4c5686552 = /* @__PURE__ */ $cb1e45f9a77f1d8f$var$gen(0x01, 104, 48);
const $cb1e45f9a77f1d8f$export$aec1ddaf6c1ba495 = /* @__PURE__ */ $cb1e45f9a77f1d8f$var$gen(0x01, 72, 64);
const $cb1e45f9a77f1d8f$var$genShake = (suffix, blockLen, outputLen)=>(0, $5358X.wrapXOFConstructorWithOpts)((opts = {})=>new $cb1e45f9a77f1d8f$export$f7374b8b4498bc2e(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
const $cb1e45f9a77f1d8f$export$f43dc3bb86efbba2 = /* @__PURE__ */ $cb1e45f9a77f1d8f$var$genShake(0x1f, 168, 16);
const $cb1e45f9a77f1d8f$export$c240d011f1520440 = /* @__PURE__ */ $cb1e45f9a77f1d8f$var$genShake(0x1f, 136, 32);

});
parcelRegister("jxb68", function(module, exports) {

$parcel$export(module.exports, "number", () => $e389b5300c8c7cce$export$98e628dec113755e);
$parcel$export(module.exports, "bytes", () => $e389b5300c8c7cce$export$b3317979f9250576);
$parcel$export(module.exports, "hash", () => $e389b5300c8c7cce$export$d6af199866bfb566);
$parcel$export(module.exports, "exists", () => $e389b5300c8c7cce$export$f7e9f41ea797a17);
$parcel$export(module.exports, "output", () => $e389b5300c8c7cce$export$c789db2c85949867);
function $e389b5300c8c7cce$export$98e628dec113755e(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`positive integer expected, not ${n}`);
}
function $e389b5300c8c7cce$export$87b259aa03e3d267(b) {
    if (typeof b !== "boolean") throw new Error(`boolean expected, not ${b}`);
}
function $e389b5300c8c7cce$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
function $e389b5300c8c7cce$export$b3317979f9250576(b, ...lengths) {
    if (!$e389b5300c8c7cce$export$c6fabfbfd097fc30(b)) throw new Error("Uint8Array expected");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Uint8Array expected of length ${lengths}, not of length=${b.length}`);
}
function $e389b5300c8c7cce$export$d6af199866bfb566(h) {
    if (typeof h !== "function" || typeof h.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $e389b5300c8c7cce$export$98e628dec113755e(h.outputLen);
    $e389b5300c8c7cce$export$98e628dec113755e(h.blockLen);
}
function $e389b5300c8c7cce$export$f7e9f41ea797a17(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
function $e389b5300c8c7cce$export$c789db2c85949867(out, instance) {
    $e389b5300c8c7cce$export$b3317979f9250576(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
const $e389b5300c8c7cce$var$assert = {
    number: $e389b5300c8c7cce$export$98e628dec113755e,
    bool: $e389b5300c8c7cce$export$87b259aa03e3d267,
    bytes: $e389b5300c8c7cce$export$b3317979f9250576,
    hash: $e389b5300c8c7cce$export$d6af199866bfb566,
    exists: $e389b5300c8c7cce$export$f7e9f41ea797a17,
    output: $e389b5300c8c7cce$export$c789db2c85949867
};
var $e389b5300c8c7cce$export$2e2bcd8739ae039 = $e389b5300c8c7cce$var$assert;

});

parcelRegister("gbRBw", function(module, exports) {

$parcel$export(module.exports, "split", () => $bc9741133a5a26a9$export$65980d18b75784e2);
$parcel$export(module.exports, "rotlSH", () => $bc9741133a5a26a9$export$4b80a2917447870e);
$parcel$export(module.exports, "rotlSL", () => $bc9741133a5a26a9$export$20652918a7b63b3);
$parcel$export(module.exports, "rotlBH", () => $bc9741133a5a26a9$export$a52f14bf902f9977);
$parcel$export(module.exports, "rotlBL", () => $bc9741133a5a26a9$export$5d12cc1da441323f);
$parcel$export(module.exports, "default", () => $bc9741133a5a26a9$export$2e2bcd8739ae039);
const $bc9741133a5a26a9$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $bc9741133a5a26a9$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $bc9741133a5a26a9$export$9625d4333cb56c3f(n, le = false) {
    if (le) return {
        h: Number(n & $bc9741133a5a26a9$var$U32_MASK64),
        l: Number(n >> $bc9741133a5a26a9$var$_32n & $bc9741133a5a26a9$var$U32_MASK64)
    };
    return {
        h: Number(n >> $bc9741133a5a26a9$var$_32n & $bc9741133a5a26a9$var$U32_MASK64) | 0,
        l: Number(n & $bc9741133a5a26a9$var$U32_MASK64) | 0
    };
}
function $bc9741133a5a26a9$export$65980d18b75784e2(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $bc9741133a5a26a9$export$9625d4333cb56c3f(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $bc9741133a5a26a9$export$30f78adcaaa2eb7 = (h, l)=>BigInt(h >>> 0) << $bc9741133a5a26a9$var$_32n | BigInt(l >>> 0);
// for Shift in [0, 32)
const $bc9741133a5a26a9$export$75aa78dc5bd52853 = (h, _l, s)=>h >>> s;
const $bc9741133a5a26a9$export$a0225ff0aee14e25 = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in [1, 32)
const $bc9741133a5a26a9$export$97f812dfd830ca87 = (h, l, s)=>h >>> s | l << 32 - s;
const $bc9741133a5a26a9$export$60987e30e2c9d9d = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $bc9741133a5a26a9$export$af9c7fbac44dcb76 = (h, l, s)=>h << 64 - s | l >>> s - 32;
const $bc9741133a5a26a9$export$f619171d6d5ac414 = (h, l, s)=>h >>> s - 32 | l << 64 - s;
// Right rotate for shift===32 (just swaps l&h)
const $bc9741133a5a26a9$export$a088d44bd387d2a3 = (_h, l)=>l;
const $bc9741133a5a26a9$export$8415aae4d1f69577 = (h, _l)=>h;
// Left rotate for Shift in [1, 32)
const $bc9741133a5a26a9$export$4b80a2917447870e = (h, l, s)=>h << s | l >>> 32 - s;
const $bc9741133a5a26a9$export$20652918a7b63b3 = (h, l, s)=>l << s | h >>> 32 - s;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $bc9741133a5a26a9$export$a52f14bf902f9977 = (h, l, s)=>l << s - 32 | h >>> 64 - s;
const $bc9741133a5a26a9$export$5d12cc1da441323f = (h, l, s)=>h << s - 32 | l >>> 64 - s;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $bc9741133a5a26a9$export$e16d8520af44a096(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $bc9741133a5a26a9$export$c0c22b91f08911f = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
const $bc9741133a5a26a9$export$ef7b26044977a8ec = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
const $bc9741133a5a26a9$export$2f4e199c560f545d = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
const $bc9741133a5a26a9$export$e909220d675a7741 = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
const $bc9741133a5a26a9$export$d732b061fe9c9ae4 = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
const $bc9741133a5a26a9$export$b45ee8d78c965098 = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
// prettier-ignore
const $bc9741133a5a26a9$var$u64 = {
    fromBig: $bc9741133a5a26a9$export$9625d4333cb56c3f,
    split: $bc9741133a5a26a9$export$65980d18b75784e2,
    toBig: $bc9741133a5a26a9$export$30f78adcaaa2eb7,
    shrSH: $bc9741133a5a26a9$export$75aa78dc5bd52853,
    shrSL: $bc9741133a5a26a9$export$a0225ff0aee14e25,
    rotrSH: $bc9741133a5a26a9$export$97f812dfd830ca87,
    rotrSL: $bc9741133a5a26a9$export$60987e30e2c9d9d,
    rotrBH: $bc9741133a5a26a9$export$af9c7fbac44dcb76,
    rotrBL: $bc9741133a5a26a9$export$f619171d6d5ac414,
    rotr32H: $bc9741133a5a26a9$export$a088d44bd387d2a3,
    rotr32L: $bc9741133a5a26a9$export$8415aae4d1f69577,
    rotlSH: $bc9741133a5a26a9$export$4b80a2917447870e,
    rotlSL: $bc9741133a5a26a9$export$20652918a7b63b3,
    rotlBH: $bc9741133a5a26a9$export$a52f14bf902f9977,
    rotlBL: $bc9741133a5a26a9$export$5d12cc1da441323f,
    add: $bc9741133a5a26a9$export$e16d8520af44a096,
    add3L: $bc9741133a5a26a9$export$c0c22b91f08911f,
    add3H: $bc9741133a5a26a9$export$ef7b26044977a8ec,
    add4L: $bc9741133a5a26a9$export$2f4e199c560f545d,
    add4H: $bc9741133a5a26a9$export$e909220d675a7741,
    add5H: $bc9741133a5a26a9$export$b45ee8d78c965098,
    add5L: $bc9741133a5a26a9$export$d732b061fe9c9ae4
};
var $bc9741133a5a26a9$export$2e2bcd8739ae039 = $bc9741133a5a26a9$var$u64;

});

parcelRegister("5358X", function(module, exports) {

$parcel$export(module.exports, "u32", () => $3ad138ed186a3916$export$8bacf4ad828c7fe7);
$parcel$export(module.exports, "createView", () => $3ad138ed186a3916$export$d7febe7b891e79f0);
$parcel$export(module.exports, "rotr", () => $3ad138ed186a3916$export$466993d7d0d272aa);
$parcel$export(module.exports, "isLE", () => $3ad138ed186a3916$export$a0f88e38d4cf9577);
$parcel$export(module.exports, "byteSwap32", () => $3ad138ed186a3916$export$97b40fc37f25d711);
$parcel$export(module.exports, "utf8ToBytes", () => $3ad138ed186a3916$export$3df70a15530b5e81);
$parcel$export(module.exports, "toBytes", () => $3ad138ed186a3916$export$30a71edf0753ed6b);
$parcel$export(module.exports, "concatBytes", () => $3ad138ed186a3916$export$287dd7971339c972);
$parcel$export(module.exports, "Hash", () => $3ad138ed186a3916$export$ab85ecd77ce6a5cd);
$parcel$export(module.exports, "wrapConstructor", () => $3ad138ed186a3916$export$f081816339df1972);
$parcel$export(module.exports, "wrapXOFConstructorWithOpts", () => $3ad138ed186a3916$export$e18964dbd6e083c1);
$parcel$export(module.exports, "randomBytes", () => $3ad138ed186a3916$export$5f828d93ff035aa8);
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.

var $2o94N = parcelRequire("2o94N");

var $jxb68 = parcelRequire("jxb68");
function $3ad138ed186a3916$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
const $3ad138ed186a3916$export$9813fca58c0b9f71 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
const $3ad138ed186a3916$export$8bacf4ad828c7fe7 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
const $3ad138ed186a3916$export$d7febe7b891e79f0 = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
const $3ad138ed186a3916$export$466993d7d0d272aa = (word, shift)=>word << 32 - shift | word >>> shift;
const $3ad138ed186a3916$export$ac5e39599698b562 = (word, shift)=>word << shift | word >>> 32 - shift >>> 0;
const $3ad138ed186a3916$export$a0f88e38d4cf9577 = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
const $3ad138ed186a3916$export$a4170f7f8be47425 = (word)=>word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
const $3ad138ed186a3916$export$4a0a88cc2d284e7f = $3ad138ed186a3916$export$a0f88e38d4cf9577 ? (n)=>n : (n)=>$3ad138ed186a3916$export$a4170f7f8be47425(n);
function $3ad138ed186a3916$export$97b40fc37f25d711(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = $3ad138ed186a3916$export$a4170f7f8be47425(arr[i]);
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const $3ad138ed186a3916$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $3ad138ed186a3916$export$58b867e287a802c8(bytes) {
    (0, $jxb68.bytes)(bytes);
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $3ad138ed186a3916$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $3ad138ed186a3916$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $3ad138ed186a3916$var$asciiToBase16(char) {
    if (char >= $3ad138ed186a3916$var$asciis._0 && char <= $3ad138ed186a3916$var$asciis._9) return char - $3ad138ed186a3916$var$asciis._0;
    if (char >= $3ad138ed186a3916$var$asciis._A && char <= $3ad138ed186a3916$var$asciis._F) return char - ($3ad138ed186a3916$var$asciis._A - 10);
    if (char >= $3ad138ed186a3916$var$asciis._a && char <= $3ad138ed186a3916$var$asciis._f) return char - ($3ad138ed186a3916$var$asciis._a - 10);
    return;
}
function $3ad138ed186a3916$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $3ad138ed186a3916$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $3ad138ed186a3916$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
const $3ad138ed186a3916$export$bdd553fddd433dcb = async ()=>{};
async function $3ad138ed186a3916$export$57207d71b8c929c8(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await $3ad138ed186a3916$export$bdd553fddd433dcb();
        ts += diff;
    }
}
function $3ad138ed186a3916$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $3ad138ed186a3916$export$30a71edf0753ed6b(data) {
    if (typeof data === "string") data = $3ad138ed186a3916$export$3df70a15530b5e81(data);
    (0, $jxb68.bytes)(data);
    return data;
}
function $3ad138ed186a3916$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        (0, $jxb68.bytes)(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
class $3ad138ed186a3916$export$ab85ecd77ce6a5cd {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
const $3ad138ed186a3916$var$toStr = {}.toString;
function $3ad138ed186a3916$export$6fcee72895eceb1e(defaults, opts) {
    if (opts !== undefined && $3ad138ed186a3916$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
function $3ad138ed186a3916$export$f081816339df1972(hashCons) {
    const hashC = (msg)=>hashCons().update($3ad138ed186a3916$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $3ad138ed186a3916$export$b465638d1569a3ae(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($3ad138ed186a3916$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $3ad138ed186a3916$export$e18964dbd6e083c1(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($3ad138ed186a3916$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $3ad138ed186a3916$export$5f828d93ff035aa8(bytesLength = 32) {
    if ((0, $2o94N.crypto) && typeof (0, $2o94N.crypto).getRandomValues === "function") return (0, $2o94N.crypto).getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}

});
parcelRegister("2o94N", function(module, exports) {

$parcel$export(module.exports, "crypto", () => $1bd4dd0502c77b82$export$7effb53edfc7fa2d);
const $1bd4dd0502c77b82$export$7effb53edfc7fa2d = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});





parcelRegister("5slab", function(module, exports) {

$parcel$export(module.exports, "toSignature", () => $3f8ffbdfdfee850c$export$d075a2fd83e0ecb);

var $3qXF4 = parcelRequire("3qXF4");

var $fUyq5 = parcelRequire("fUyq5");
const $3f8ffbdfdfee850c$export$d075a2fd83e0ecb = (def)=>{
    const def_ = (()=>{
        if (typeof def === "string") return def;
        return (0, $3qXF4.formatAbiItem)(def);
    })();
    return (0, $fUyq5.normalizeSignature)(def_);
};

});
parcelRegister("3qXF4", function(module, exports) {

$parcel$export(module.exports, "formatAbiItem", () => $28021458a8df4387$export$dc5d0ff4fc2fdee1);

var $8joo4 = parcelRequire("8joo4");
function $28021458a8df4387$export$dc5d0ff4fc2fdee1(abiItem) {
    if (abiItem.type === "function") return `function ${abiItem.name}(${(0, $8joo4.formatAbiParameters)(abiItem.inputs)})${abiItem.stateMutability && abiItem.stateMutability !== "nonpayable" ? ` ${abiItem.stateMutability}` : ""}${abiItem.outputs.length ? ` returns (${(0, $8joo4.formatAbiParameters)(abiItem.outputs)})` : ""}`;
    if (abiItem.type === "event") return `event ${abiItem.name}(${(0, $8joo4.formatAbiParameters)(abiItem.inputs)})`;
    if (abiItem.type === "error") return `error ${abiItem.name}(${(0, $8joo4.formatAbiParameters)(abiItem.inputs)})`;
    if (abiItem.type === "constructor") return `constructor(${(0, $8joo4.formatAbiParameters)(abiItem.inputs)})${abiItem.stateMutability === "payable" ? " payable" : ""}`;
    if (abiItem.type === "fallback") return "fallback()";
    return "receive() external payable";
}

});
parcelRegister("8joo4", function(module, exports) {

$parcel$export(module.exports, "formatAbiParameters", () => $60d303e0f4cd6dc3$export$c55dbda1a081631e);

var $2ijTW = parcelRequire("2ijTW");
function $60d303e0f4cd6dc3$export$c55dbda1a081631e(abiParameters) {
    let params = "";
    const length = abiParameters.length;
    for(let i = 0; i < length; i++){
        const abiParameter = abiParameters[i];
        params += (0, $2ijTW.formatAbiParameter)(abiParameter);
        if (i !== length - 1) params += ", ";
    }
    return params;
}

});
parcelRegister("2ijTW", function(module, exports) {

$parcel$export(module.exports, "formatAbiParameter", () => $1abcb3366f9cc4e5$export$c75e01ebc733dc6b);

var $6Cr9r = parcelRequire("6Cr9r");
// https://regexr.com/7f7rv
const $1abcb3366f9cc4e5$var$tupleRegex = /^tuple(?<array>(\[(\d*)\])*)$/;
function $1abcb3366f9cc4e5$export$c75e01ebc733dc6b(abiParameter) {
    let type = abiParameter.type;
    if ($1abcb3366f9cc4e5$var$tupleRegex.test(abiParameter.type) && "components" in abiParameter) {
        type = "(";
        const length = abiParameter.components.length;
        for(let i = 0; i < length; i++){
            const component = abiParameter.components[i];
            type += $1abcb3366f9cc4e5$export$c75e01ebc733dc6b(component);
            if (i < length - 1) type += ", ";
        }
        const result = (0, $6Cr9r.execTyped)($1abcb3366f9cc4e5$var$tupleRegex, abiParameter.type);
        type += `)${result?.array ?? ""}`;
        return $1abcb3366f9cc4e5$export$c75e01ebc733dc6b({
            ...abiParameter,
            type: type
        });
    }
    // Add `indexed` to type if in `abiParameter`
    if ("indexed" in abiParameter && abiParameter.indexed) type = `${type} indexed`;
    // Return human-readable ABI parameter
    if (abiParameter.name) return `${type} ${abiParameter.name}`;
    return type;
}

});
parcelRegister("6Cr9r", function(module, exports) {

$parcel$export(module.exports, "execTyped", () => $4d1b5a5df5b25e78$export$1cca4755fb17f5bd);
$parcel$export(module.exports, "bytesRegex", () => $4d1b5a5df5b25e78$export$94d7303c0d9f263a);
$parcel$export(module.exports, "integerRegex", () => $4d1b5a5df5b25e78$export$45902cc189596eef);
$parcel$export(module.exports, "isTupleRegex", () => $4d1b5a5df5b25e78$export$5c1628af1434aed0);
// TODO: This looks cool. Need to check the performance of `new RegExp` versus defined inline though.
// https://twitter.com/GabrielVergnaud/status/1622906834343366657
function $4d1b5a5df5b25e78$export$1cca4755fb17f5bd(regex, string) {
    const match = regex.exec(string);
    return match?.groups;
}
const $4d1b5a5df5b25e78$export$94d7303c0d9f263a = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/;
const $4d1b5a5df5b25e78$export$45902cc189596eef = /^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;
const $4d1b5a5df5b25e78$export$5c1628af1434aed0 = /^\(.+?\).*?$/;

});




parcelRegister("fUyq5", function(module, exports) {

$parcel$export(module.exports, "normalizeSignature", () => $b956c90545fa6fa5$export$5cba87ebe4d0307a);

var $6F8ii = parcelRequire("6F8ii");
function $b956c90545fa6fa5$export$5cba87ebe4d0307a(signature) {
    let active = true;
    let current = "";
    let level = 0;
    let result = "";
    let valid = false;
    for(let i = 0; i < signature.length; i++){
        const char = signature[i];
        // If the character is a separator, we want to reactivate.
        if ([
            "(",
            ")",
            ","
        ].includes(char)) active = true;
        // If the character is a "level" token, we want to increment/decrement.
        if (char === "(") level++;
        if (char === ")") level--;
        // If we aren't active, we don't want to mutate the result.
        if (!active) continue;
        // If level === 0, we are at the definition level.
        if (level === 0) {
            if (char === " " && [
                "event",
                "function",
                ""
            ].includes(result)) result = "";
            else {
                result += char;
                // If we are at the end of the definition, we must be finished.
                if (char === ")") {
                    valid = true;
                    break;
                }
            }
            continue;
        }
        // Ignore spaces
        if (char === " ") {
            // If the previous character is a separator, and the current section isn't empty, we want to deactivate.
            if (signature[i - 1] !== "," && current !== "," && current !== ",(") {
                current = "";
                active = false;
            }
            continue;
        }
        result += char;
        current += char;
    }
    if (!valid) throw new (0, $6F8ii.BaseError)("Unable to normalize signature.");
    return result;
}

});




parcelRegister("4VcDz", function(module, exports) {

$parcel$export(module.exports, "decodeAbiParameters", () => $395649cf07eeadc7$export$84d51ac2fffabd56);

var $3TFRi = parcelRequire("3TFRi");

var $lqRRD = parcelRequire("lqRRD");

var $91vjL = parcelRequire("91vjL");

var $jBXg5 = parcelRequire("jBXg5");

var $a7Rp0 = parcelRequire("a7Rp0");

var $44bP9 = parcelRequire("44bP9");

var $1bqyR = parcelRequire("1bqyR");

var $eFDiV = parcelRequire("eFDiV");

var $9UP4H = parcelRequire("9UP4H");

var $keugB = parcelRequire("keugB");
function $395649cf07eeadc7$export$84d51ac2fffabd56(params, data) {
    const bytes = typeof data === "string" ? (0, $eFDiV.hexToBytes)(data) : data;
    const cursor = (0, $91vjL.createCursor)(bytes);
    if ((0, $jBXg5.size)(bytes) === 0 && params.length > 0) throw new (0, $3TFRi.AbiDecodingZeroDataError)();
    if ((0, $jBXg5.size)(data) && (0, $jBXg5.size)(data) < 32) throw new (0, $3TFRi.AbiDecodingDataSizeTooSmallError)({
        data: typeof data === "string" ? data : (0, $9UP4H.bytesToHex)(data),
        params: params,
        size: (0, $jBXg5.size)(data)
    });
    let consumed = 0;
    const values = [];
    for(let i = 0; i < params.length; ++i){
        const param = params[i];
        cursor.setPosition(consumed);
        const [data, consumed_] = $395649cf07eeadc7$var$decodeParameter(cursor, param, {
            staticPosition: 0
        });
        consumed += consumed_;
        values.push(data);
    }
    return values;
}
function $395649cf07eeadc7$var$decodeParameter(cursor, param, { staticPosition: staticPosition }) {
    const arrayComponents = (0, $keugB.getArrayComponents)(param.type);
    if (arrayComponents) {
        const [length, type] = arrayComponents;
        return $395649cf07eeadc7$var$decodeArray(cursor, {
            ...param,
            type: type
        }, {
            length: length,
            staticPosition: staticPosition
        });
    }
    if (param.type === "tuple") return $395649cf07eeadc7$var$decodeTuple(cursor, param, {
        staticPosition: staticPosition
    });
    if (param.type === "address") return $395649cf07eeadc7$var$decodeAddress(cursor);
    if (param.type === "bool") return $395649cf07eeadc7$var$decodeBool(cursor);
    if (param.type.startsWith("bytes")) return $395649cf07eeadc7$var$decodeBytes(cursor, param, {
        staticPosition: staticPosition
    });
    if (param.type.startsWith("uint") || param.type.startsWith("int")) return $395649cf07eeadc7$var$decodeNumber(cursor, param);
    if (param.type === "string") return $395649cf07eeadc7$var$decodeString(cursor, {
        staticPosition: staticPosition
    });
    throw new (0, $3TFRi.InvalidAbiDecodingTypeError)(param.type, {
        docsPath: "/docs/contract/decodeAbiParameters"
    });
}
////////////////////////////////////////////////////////////////////
// Type Decoders
const $395649cf07eeadc7$var$sizeOfLength = 32;
const $395649cf07eeadc7$var$sizeOfOffset = 32;
function $395649cf07eeadc7$var$decodeAddress(cursor) {
    const value = cursor.readBytes(32);
    return [
        (0, $lqRRD.checksumAddress)((0, $9UP4H.bytesToHex)((0, $a7Rp0.sliceBytes)(value, -20))),
        32
    ];
}
function $395649cf07eeadc7$var$decodeArray(cursor, param, { length: length, staticPosition: staticPosition }) {
    // If the length of the array is not known in advance (dynamic array),
    // this means we will need to wonder off to the pointer and decode.
    if (!length) {
        // Dealing with a dynamic type, so get the offset of the array data.
        const offset = (0, $1bqyR.bytesToNumber)(cursor.readBytes($395649cf07eeadc7$var$sizeOfOffset));
        // Start is the static position of current slot + offset.
        const start = staticPosition + offset;
        const startOfData = start + $395649cf07eeadc7$var$sizeOfLength;
        // Get the length of the array from the offset.
        cursor.setPosition(start);
        const length = (0, $1bqyR.bytesToNumber)(cursor.readBytes($395649cf07eeadc7$var$sizeOfLength));
        // Check if the array has any dynamic children.
        const dynamicChild = $395649cf07eeadc7$var$hasDynamicChild(param);
        let consumed = 0;
        const value = [];
        for(let i = 0; i < length; ++i){
            // If any of the children is dynamic, then all elements will be offset pointer, thus size of one slot (32 bytes).
            // Otherwise, elements will be the size of their encoding (consumed bytes).
            cursor.setPosition(startOfData + (dynamicChild ? i * 32 : consumed));
            const [data, consumed_] = $395649cf07eeadc7$var$decodeParameter(cursor, param, {
                staticPosition: startOfData
            });
            consumed += consumed_;
            value.push(data);
        }
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [
            value,
            32
        ];
    }
    // If the length of the array is known in advance,
    // and the length of an element deeply nested in the array is not known,
    // we need to decode the offset of the array data.
    if ($395649cf07eeadc7$var$hasDynamicChild(param)) {
        // Dealing with dynamic types, so get the offset of the array data.
        const offset = (0, $1bqyR.bytesToNumber)(cursor.readBytes($395649cf07eeadc7$var$sizeOfOffset));
        // Start is the static position of current slot + offset.
        const start = staticPosition + offset;
        const value = [];
        for(let i = 0; i < length; ++i){
            // Move cursor along to the next slot (next offset pointer).
            cursor.setPosition(start + i * 32);
            const [data] = $395649cf07eeadc7$var$decodeParameter(cursor, param, {
                staticPosition: start
            });
            value.push(data);
        }
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [
            value,
            32
        ];
    }
    // If the length of the array is known in advance and the array is deeply static,
    // then we can just decode each element in sequence.
    let consumed = 0;
    const value = [];
    for(let i = 0; i < length; ++i){
        const [data, consumed_] = $395649cf07eeadc7$var$decodeParameter(cursor, param, {
            staticPosition: staticPosition + consumed
        });
        consumed += consumed_;
        value.push(data);
    }
    return [
        value,
        consumed
    ];
}
function $395649cf07eeadc7$var$decodeBool(cursor) {
    return [
        (0, $1bqyR.bytesToBool)(cursor.readBytes(32), {
            size: 32
        }),
        32
    ];
}
function $395649cf07eeadc7$var$decodeBytes(cursor, param, { staticPosition: staticPosition }) {
    const [_, size] = param.type.split("bytes");
    if (!size) {
        // Dealing with dynamic types, so get the offset of the bytes data.
        const offset = (0, $1bqyR.bytesToNumber)(cursor.readBytes(32));
        // Set position of the cursor to start of bytes data.
        cursor.setPosition(staticPosition + offset);
        const length = (0, $1bqyR.bytesToNumber)(cursor.readBytes(32));
        // If there is no length, we have zero data.
        if (length === 0) {
            // As we have gone wondering, restore to the original position + next slot.
            cursor.setPosition(staticPosition + 32);
            return [
                "0x",
                32
            ];
        }
        const data = cursor.readBytes(length);
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [
            (0, $9UP4H.bytesToHex)(data),
            32
        ];
    }
    const value = (0, $9UP4H.bytesToHex)(cursor.readBytes(Number.parseInt(size), 32));
    return [
        value,
        32
    ];
}
function $395649cf07eeadc7$var$decodeNumber(cursor, param) {
    const signed = param.type.startsWith("int");
    const size = Number.parseInt(param.type.split("int")[1] || "256");
    const value = cursor.readBytes(32);
    return [
        size > 48 ? (0, $1bqyR.bytesToBigInt)(value, {
            signed: signed
        }) : (0, $1bqyR.bytesToNumber)(value, {
            signed: signed
        }),
        32
    ];
}
function $395649cf07eeadc7$var$decodeTuple(cursor, param, { staticPosition: staticPosition }) {
    // Tuples can have unnamed components (i.e. they are arrays), so we must
    // determine whether the tuple is named or unnamed. In the case of a named
    // tuple, the value will be an object where each property is the name of the
    // component. In the case of an unnamed tuple, the value will be an array.
    const hasUnnamedChild = param.components.length === 0 || param.components.some(({ name: name })=>!name);
    // Initialize the value to an object or an array, depending on whether the
    // tuple is named or unnamed.
    const value = hasUnnamedChild ? [] : {};
    let consumed = 0;
    // If the tuple has a dynamic child, we must first decode the offset to the
    // tuple data.
    if ($395649cf07eeadc7$var$hasDynamicChild(param)) {
        // Dealing with dynamic types, so get the offset of the tuple data.
        const offset = (0, $1bqyR.bytesToNumber)(cursor.readBytes($395649cf07eeadc7$var$sizeOfOffset));
        // Start is the static position of referencing slot + offset.
        const start = staticPosition + offset;
        for(let i = 0; i < param.components.length; ++i){
            const component = param.components[i];
            cursor.setPosition(start + consumed);
            const [data, consumed_] = $395649cf07eeadc7$var$decodeParameter(cursor, component, {
                staticPosition: start
            });
            consumed += consumed_;
            value[hasUnnamedChild ? i : component?.name] = data;
        }
        // As we have gone wondering, restore to the original position + next slot.
        cursor.setPosition(staticPosition + 32);
        return [
            value,
            32
        ];
    }
    // If the tuple has static children, we can just decode each component
    // in sequence.
    for(let i = 0; i < param.components.length; ++i){
        const component = param.components[i];
        const [data, consumed_] = $395649cf07eeadc7$var$decodeParameter(cursor, component, {
            staticPosition: staticPosition
        });
        value[hasUnnamedChild ? i : component?.name] = data;
        consumed += consumed_;
    }
    return [
        value,
        consumed
    ];
}
function $395649cf07eeadc7$var$decodeString(cursor, { staticPosition: staticPosition }) {
    // Get offset to start of string data.
    const offset = (0, $1bqyR.bytesToNumber)(cursor.readBytes(32));
    // Start is the static position of current slot + offset.
    const start = staticPosition + offset;
    cursor.setPosition(start);
    const length = (0, $1bqyR.bytesToNumber)(cursor.readBytes(32));
    // If there is no length, we have zero data (empty string).
    if (length === 0) {
        cursor.setPosition(staticPosition + 32);
        return [
            "",
            32
        ];
    }
    const data = cursor.readBytes(length, 32);
    const value = (0, $1bqyR.bytesToString)((0, $44bP9.trim)(data));
    // As we have gone wondering, restore to the original position + next slot.
    cursor.setPosition(staticPosition + 32);
    return [
        value,
        32
    ];
}
function $395649cf07eeadc7$var$hasDynamicChild(param) {
    const { type: type } = param;
    if (type === "string") return true;
    if (type === "bytes") return true;
    if (type.endsWith("[]")) return true;
    if (type === "tuple") return param.components?.some($395649cf07eeadc7$var$hasDynamicChild);
    const arrayComponents = (0, $keugB.getArrayComponents)(param.type);
    if (arrayComponents && $395649cf07eeadc7$var$hasDynamicChild({
        ...param,
        type: arrayComponents[1]
    })) return true;
    return false;
}

});
parcelRegister("lqRRD", function(module, exports) {

$parcel$export(module.exports, "checksumAddress", () => $f9a5cef34e973305$export$9ff46e8f6df13548);
$parcel$export(module.exports, "getAddress", () => $f9a5cef34e973305$export$88411125f012957a);

var $8j5HI = parcelRequire("8j5HI");

var $eFDiV = parcelRequire("eFDiV");

var $bRe6l = parcelRequire("bRe6l");

var $kGHiX = parcelRequire("kGHiX");

var $4rOic = parcelRequire("4rOic");
const $f9a5cef34e973305$var$checksumAddressCache = /*#__PURE__*/ new (0, $kGHiX.LruMap)(8192);
function $f9a5cef34e973305$export$9ff46e8f6df13548(address_, /**
 * Warning: EIP-1191 checksum addresses are generally not backwards compatible with the
 * wider Ethereum ecosystem, meaning it will break when validated against an application/tool
 * that relies on EIP-55 checksum encoding (checksum without chainId).
 *
 * It is highly recommended to not use this feature unless you
 * know what you are doing.
 *
 * See more: https://github.com/ethereum/EIPs/issues/1121
 */ chainId) {
    if ($f9a5cef34e973305$var$checksumAddressCache.has(`${address_}.${chainId}`)) return $f9a5cef34e973305$var$checksumAddressCache.get(`${address_}.${chainId}`);
    const hexAddress = chainId ? `${chainId}${address_.toLowerCase()}` : address_.substring(2).toLowerCase();
    const hash = (0, $bRe6l.keccak256)((0, $eFDiV.stringToBytes)(hexAddress), "bytes");
    const address = (chainId ? hexAddress.substring(`${chainId}0x`.length) : hexAddress).split("");
    for(let i = 0; i < 40; i += 2){
        if (hash[i >> 1] >> 4 >= 8 && address[i]) address[i] = address[i].toUpperCase();
        if ((hash[i >> 1] & 0x0f) >= 8 && address[i + 1]) address[i + 1] = address[i + 1].toUpperCase();
    }
    const result = `0x${address.join("")}`;
    $f9a5cef34e973305$var$checksumAddressCache.set(`${address_}.${chainId}`, result);
    return result;
}
function $f9a5cef34e973305$export$88411125f012957a(address, /**
 * Warning: EIP-1191 checksum addresses are generally not backwards compatible with the
 * wider Ethereum ecosystem, meaning it will break when validated against an application/tool
 * that relies on EIP-55 checksum encoding (checksum without chainId).
 *
 * It is highly recommended to not use this feature unless you
 * know what you are doing.
 *
 * See more: https://github.com/ethereum/EIPs/issues/1121
 */ chainId) {
    if (!(0, $4rOic.isAddress)(address, {
        strict: false
    })) throw new (0, $8j5HI.InvalidAddressError)({
        address: address
    });
    return $f9a5cef34e973305$export$9ff46e8f6df13548(address, chainId);
}

});
parcelRegister("8j5HI", function(module, exports) {

$parcel$export(module.exports, "InvalidAddressError", () => $60c485d021ae9220$export$66c44d927ffead98);

var $6F8ii = parcelRequire("6F8ii");
class $60c485d021ae9220$export$66c44d927ffead98 extends (0, $6F8ii.BaseError) {
    constructor({ address: address }){
        super(`Address "${address}" is invalid.`, {
            metaMessages: [
                "- Address must be a hex value of 20 bytes (40 hex characters).",
                "- Address must match its checksum counterpart."
            ],
            name: "InvalidAddressError"
        });
    }
}

});

parcelRegister("kGHiX", function(module, exports) {

$parcel$export(module.exports, "LruMap", () => $f0f9524a4eb169df$export$fcb3b6cad79d7e3a);
/**
 * Map with a LRU (Least recently used) policy.
 *
 * @link https://en.wikipedia.org/wiki/Cache_replacement_policies#LRU
 */ class $f0f9524a4eb169df$export$fcb3b6cad79d7e3a extends Map {
    constructor(size){
        super();
        Object.defineProperty(this, "maxSize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.maxSize = size;
    }
    set(key, value) {
        super.set(key, value);
        if (this.maxSize && this.size > this.maxSize) this.delete(this.keys().next().value);
        return this;
    }
}

});

parcelRegister("4rOic", function(module, exports) {

$parcel$export(module.exports, "isAddress", () => $33d0b215374ae2a9$export$977e255126d763d6);

var $kGHiX = parcelRequire("kGHiX");

var $lqRRD = parcelRequire("lqRRD");
const $33d0b215374ae2a9$var$addressRegex = /^0x[a-fA-F0-9]{40}$/;
const $33d0b215374ae2a9$export$ef83598cc5072ce = /*#__PURE__*/ new (0, $kGHiX.LruMap)(8192);
function $33d0b215374ae2a9$export$977e255126d763d6(address, options) {
    const { strict: strict = true } = options ?? {};
    const cacheKey = `${address}.${strict}`;
    if ($33d0b215374ae2a9$export$ef83598cc5072ce.has(cacheKey)) return $33d0b215374ae2a9$export$ef83598cc5072ce.get(cacheKey);
    const result = (()=>{
        if (!$33d0b215374ae2a9$var$addressRegex.test(address)) return false;
        if (address.toLowerCase() === address) return true;
        if (strict) return (0, $lqRRD.checksumAddress)(address) === address;
        return true;
    })();
    $33d0b215374ae2a9$export$ef83598cc5072ce.set(cacheKey, result);
    return result;
}

});


parcelRegister("91vjL", function(module, exports) {

$parcel$export(module.exports, "createCursor", () => $691c8018cf5bc9c2$export$fb542681b7c0dc55);

var $fVW5g = parcelRequire("fVW5g");
const $691c8018cf5bc9c2$var$staticCursor = {
    bytes: new Uint8Array(),
    dataView: new DataView(new ArrayBuffer(0)),
    position: 0,
    positionReadCount: new Map(),
    recursiveReadCount: 0,
    recursiveReadLimit: Number.POSITIVE_INFINITY,
    assertReadLimit () {
        if (this.recursiveReadCount >= this.recursiveReadLimit) throw new (0, $fVW5g.RecursiveReadLimitExceededError)({
            count: this.recursiveReadCount + 1,
            limit: this.recursiveReadLimit
        });
    },
    assertPosition (position) {
        if (position < 0 || position > this.bytes.length - 1) throw new (0, $fVW5g.PositionOutOfBoundsError)({
            length: this.bytes.length,
            position: position
        });
    },
    decrementPosition (offset) {
        if (offset < 0) throw new (0, $fVW5g.NegativeOffsetError)({
            offset: offset
        });
        const position = this.position - offset;
        this.assertPosition(position);
        this.position = position;
    },
    getReadCount (position) {
        return this.positionReadCount.get(position || this.position) || 0;
    },
    incrementPosition (offset) {
        if (offset < 0) throw new (0, $fVW5g.NegativeOffsetError)({
            offset: offset
        });
        const position = this.position + offset;
        this.assertPosition(position);
        this.position = position;
    },
    inspectByte (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position);
        return this.bytes[position];
    },
    inspectBytes (length, position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + length - 1);
        return this.bytes.subarray(position, position + length);
    },
    inspectUint8 (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position);
        return this.bytes[position];
    },
    inspectUint16 (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + 1);
        return this.dataView.getUint16(position);
    },
    inspectUint24 (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + 2);
        return (this.dataView.getUint16(position) << 8) + this.dataView.getUint8(position + 2);
    },
    inspectUint32 (position_) {
        const position = position_ ?? this.position;
        this.assertPosition(position + 3);
        return this.dataView.getUint32(position);
    },
    pushByte (byte) {
        this.assertPosition(this.position);
        this.bytes[this.position] = byte;
        this.position++;
    },
    pushBytes (bytes) {
        this.assertPosition(this.position + bytes.length - 1);
        this.bytes.set(bytes, this.position);
        this.position += bytes.length;
    },
    pushUint8 (value) {
        this.assertPosition(this.position);
        this.bytes[this.position] = value;
        this.position++;
    },
    pushUint16 (value) {
        this.assertPosition(this.position + 1);
        this.dataView.setUint16(this.position, value);
        this.position += 2;
    },
    pushUint24 (value) {
        this.assertPosition(this.position + 2);
        this.dataView.setUint16(this.position, value >> 8);
        this.dataView.setUint8(this.position + 2, value & 255);
        this.position += 3;
    },
    pushUint32 (value) {
        this.assertPosition(this.position + 3);
        this.dataView.setUint32(this.position, value);
        this.position += 4;
    },
    readByte () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectByte();
        this.position++;
        return value;
    },
    readBytes (length, size) {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectBytes(length);
        this.position += size ?? length;
        return value;
    },
    readUint8 () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectUint8();
        this.position += 1;
        return value;
    },
    readUint16 () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectUint16();
        this.position += 2;
        return value;
    },
    readUint24 () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectUint24();
        this.position += 3;
        return value;
    },
    readUint32 () {
        this.assertReadLimit();
        this._touch();
        const value = this.inspectUint32();
        this.position += 4;
        return value;
    },
    get remaining () {
        return this.bytes.length - this.position;
    },
    setPosition (position) {
        const oldPosition = this.position;
        this.assertPosition(position);
        this.position = position;
        return ()=>this.position = oldPosition;
    },
    _touch () {
        if (this.recursiveReadLimit === Number.POSITIVE_INFINITY) return;
        const count = this.getReadCount();
        this.positionReadCount.set(this.position, count + 1);
        if (count > 0) this.recursiveReadCount++;
    }
};
function $691c8018cf5bc9c2$export$fb542681b7c0dc55(bytes, { recursiveReadLimit: recursiveReadLimit = 8192 } = {}) {
    const cursor = Object.create($691c8018cf5bc9c2$var$staticCursor);
    cursor.bytes = bytes;
    cursor.dataView = new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
    cursor.positionReadCount = new Map();
    cursor.recursiveReadLimit = recursiveReadLimit;
    return cursor;
}

});
parcelRegister("fVW5g", function(module, exports) {

$parcel$export(module.exports, "NegativeOffsetError", () => $02fe57ae04c0ec15$export$4741ff085e62ac19);
$parcel$export(module.exports, "PositionOutOfBoundsError", () => $02fe57ae04c0ec15$export$72dcc4230cbf50ba);
$parcel$export(module.exports, "RecursiveReadLimitExceededError", () => $02fe57ae04c0ec15$export$4952f5c6336a7cc7);

var $6F8ii = parcelRequire("6F8ii");
class $02fe57ae04c0ec15$export$4741ff085e62ac19 extends (0, $6F8ii.BaseError) {
    constructor({ offset: offset }){
        super(`Offset \`${offset}\` cannot be negative.`, {
            name: "NegativeOffsetError"
        });
    }
}
class $02fe57ae04c0ec15$export$72dcc4230cbf50ba extends (0, $6F8ii.BaseError) {
    constructor({ length: length, position: position }){
        super(`Position \`${position}\` is out of bounds (\`0 < position < ${length}\`).`, {
            name: "PositionOutOfBoundsError"
        });
    }
}
class $02fe57ae04c0ec15$export$4952f5c6336a7cc7 extends (0, $6F8ii.BaseError) {
    constructor({ count: count, limit: limit }){
        super(`Recursive read limit of \`${limit}\` exceeded (recursive read count: \`${count}\`).`, {
            name: "RecursiveReadLimitExceededError"
        });
    }
}

});


parcelRegister("1bqyR", function(module, exports) {

$parcel$export(module.exports, "bytesToNumber", () => $0dcb6c0d786e6de1$export$c0cca17bcf674749);
$parcel$export(module.exports, "bytesToBigInt", () => $0dcb6c0d786e6de1$export$2a52511e4f35930a);
$parcel$export(module.exports, "bytesToBool", () => $0dcb6c0d786e6de1$export$aa06fda122958d5d);
$parcel$export(module.exports, "bytesToString", () => $0dcb6c0d786e6de1$export$7c746b75f47c9c7d);

var $cN7s9 = parcelRequire("cN7s9");

var $44bP9 = parcelRequire("44bP9");

var $7Zv5I = parcelRequire("7Zv5I");

var $9UP4H = parcelRequire("9UP4H");
function $0dcb6c0d786e6de1$export$de2da3025c30316c(bytes, toOrOpts) {
    const opts = typeof toOrOpts === "string" ? {
        to: toOrOpts
    } : toOrOpts;
    const to = opts.to;
    if (to === "number") return $0dcb6c0d786e6de1$export$c0cca17bcf674749(bytes, opts);
    if (to === "bigint") return $0dcb6c0d786e6de1$export$2a52511e4f35930a(bytes, opts);
    if (to === "boolean") return $0dcb6c0d786e6de1$export$aa06fda122958d5d(bytes, opts);
    if (to === "string") return $0dcb6c0d786e6de1$export$7c746b75f47c9c7d(bytes, opts);
    return (0, $9UP4H.bytesToHex)(bytes, opts);
}
function $0dcb6c0d786e6de1$export$2a52511e4f35930a(bytes, opts = {}) {
    if (typeof opts.size !== "undefined") (0, $7Zv5I.assertSize)(bytes, {
        size: opts.size
    });
    const hex = (0, $9UP4H.bytesToHex)(bytes, opts);
    return (0, $7Zv5I.hexToBigInt)(hex, opts);
}
function $0dcb6c0d786e6de1$export$aa06fda122958d5d(bytes_, opts = {}) {
    let bytes = bytes_;
    if (typeof opts.size !== "undefined") {
        (0, $7Zv5I.assertSize)(bytes, {
            size: opts.size
        });
        bytes = (0, $44bP9.trim)(bytes);
    }
    if (bytes.length > 1 || bytes[0] > 1) throw new (0, $cN7s9.InvalidBytesBooleanError)(bytes);
    return Boolean(bytes[0]);
}
function $0dcb6c0d786e6de1$export$c0cca17bcf674749(bytes, opts = {}) {
    if (typeof opts.size !== "undefined") (0, $7Zv5I.assertSize)(bytes, {
        size: opts.size
    });
    const hex = (0, $9UP4H.bytesToHex)(bytes, opts);
    return (0, $7Zv5I.hexToNumber)(hex, opts);
}
function $0dcb6c0d786e6de1$export$7c746b75f47c9c7d(bytes_, opts = {}) {
    let bytes = bytes_;
    if (typeof opts.size !== "undefined") {
        (0, $7Zv5I.assertSize)(bytes, {
            size: opts.size
        });
        bytes = (0, $44bP9.trim)(bytes, {
            dir: "right"
        });
    }
    return new TextDecoder().decode(bytes);
}

});

parcelRegister("keugB", function(module, exports) {

$parcel$export(module.exports, "encodeAbiParameters", () => $ebac97d4521e8e9c$export$448ea0950d6dd7d7);
$parcel$export(module.exports, "getArrayComponents", () => $ebac97d4521e8e9c$export$ab502cfdbb1a0d07);

var $3TFRi = parcelRequire("3TFRi");

var $8j5HI = parcelRequire("8j5HI");

var $6F8ii = parcelRequire("6F8ii");

var $4rOic = parcelRequire("4rOic");

var $jCBOw = parcelRequire("jCBOw");

var $2OmJE = parcelRequire("2OmJE");

var $jBXg5 = parcelRequire("jBXg5");

var $a7Rp0 = parcelRequire("a7Rp0");

var $9UP4H = parcelRequire("9UP4H");
function $ebac97d4521e8e9c$export$448ea0950d6dd7d7(params, values) {
    if (params.length !== values.length) throw new (0, $3TFRi.AbiEncodingLengthMismatchError)({
        expectedLength: params.length,
        givenLength: values.length
    });
    // Prepare the parameters to determine dynamic types to encode.
    const preparedParams = $ebac97d4521e8e9c$var$prepareParams({
        params: params,
        values: values
    });
    const data = $ebac97d4521e8e9c$var$encodeParams(preparedParams);
    if (data.length === 0) return "0x";
    return data;
}
function $ebac97d4521e8e9c$var$prepareParams({ params: params, values: values }) {
    const preparedParams = [];
    for(let i = 0; i < params.length; i++)preparedParams.push($ebac97d4521e8e9c$var$prepareParam({
        param: params[i],
        value: values[i]
    }));
    return preparedParams;
}
function $ebac97d4521e8e9c$var$prepareParam({ param: param, value: value }) {
    const arrayComponents = $ebac97d4521e8e9c$export$ab502cfdbb1a0d07(param.type);
    if (arrayComponents) {
        const [length, type] = arrayComponents;
        return $ebac97d4521e8e9c$var$encodeArray(value, {
            length: length,
            param: {
                ...param,
                type: type
            }
        });
    }
    if (param.type === "tuple") return $ebac97d4521e8e9c$var$encodeTuple(value, {
        param: param
    });
    if (param.type === "address") return $ebac97d4521e8e9c$var$encodeAddress(value);
    if (param.type === "bool") return $ebac97d4521e8e9c$var$encodeBool(value);
    if (param.type.startsWith("uint") || param.type.startsWith("int")) {
        const signed = param.type.startsWith("int");
        return $ebac97d4521e8e9c$var$encodeNumber(value, {
            signed: signed
        });
    }
    if (param.type.startsWith("bytes")) return $ebac97d4521e8e9c$var$encodeBytes(value, {
        param: param
    });
    if (param.type === "string") return $ebac97d4521e8e9c$var$encodeString(value);
    throw new (0, $3TFRi.InvalidAbiEncodingTypeError)(param.type, {
        docsPath: "/docs/contract/encodeAbiParameters"
    });
}
function $ebac97d4521e8e9c$var$encodeParams(preparedParams) {
    // 1. Compute the size of the static part of the parameters.
    let staticSize = 0;
    for(let i = 0; i < preparedParams.length; i++){
        const { dynamic: dynamic, encoded: encoded } = preparedParams[i];
        if (dynamic) staticSize += 32;
        else staticSize += (0, $jBXg5.size)(encoded);
    }
    // 2. Split the parameters into static and dynamic parts.
    const staticParams = [];
    const dynamicParams = [];
    let dynamicSize = 0;
    for(let i = 0; i < preparedParams.length; i++){
        const { dynamic: dynamic, encoded: encoded } = preparedParams[i];
        if (dynamic) {
            staticParams.push((0, $9UP4H.numberToHex)(staticSize + dynamicSize, {
                size: 32
            }));
            dynamicParams.push(encoded);
            dynamicSize += (0, $jBXg5.size)(encoded);
        } else staticParams.push(encoded);
    }
    // 3. Concatenate static and dynamic parts.
    return (0, $jCBOw.concat)([
        ...staticParams,
        ...dynamicParams
    ]);
}
function $ebac97d4521e8e9c$var$encodeAddress(value) {
    if (!(0, $4rOic.isAddress)(value)) throw new (0, $8j5HI.InvalidAddressError)({
        address: value
    });
    return {
        dynamic: false,
        encoded: (0, $2OmJE.padHex)(value.toLowerCase())
    };
}
function $ebac97d4521e8e9c$var$encodeArray(value, { length: length, param: param }) {
    const dynamic = length === null;
    if (!Array.isArray(value)) throw new (0, $3TFRi.InvalidArrayError)(value);
    if (!dynamic && value.length !== length) throw new (0, $3TFRi.AbiEncodingArrayLengthMismatchError)({
        expectedLength: length,
        givenLength: value.length,
        type: `${param.type}[${length}]`
    });
    let dynamicChild = false;
    const preparedParams = [];
    for(let i = 0; i < value.length; i++){
        const preparedParam = $ebac97d4521e8e9c$var$prepareParam({
            param: param,
            value: value[i]
        });
        if (preparedParam.dynamic) dynamicChild = true;
        preparedParams.push(preparedParam);
    }
    if (dynamic || dynamicChild) {
        const data = $ebac97d4521e8e9c$var$encodeParams(preparedParams);
        if (dynamic) {
            const length = (0, $9UP4H.numberToHex)(preparedParams.length, {
                size: 32
            });
            return {
                dynamic: true,
                encoded: preparedParams.length > 0 ? (0, $jCBOw.concat)([
                    length,
                    data
                ]) : length
            };
        }
        if (dynamicChild) return {
            dynamic: true,
            encoded: data
        };
    }
    return {
        dynamic: false,
        encoded: (0, $jCBOw.concat)(preparedParams.map(({ encoded: encoded })=>encoded))
    };
}
function $ebac97d4521e8e9c$var$encodeBytes(value, { param: param }) {
    const [, paramSize] = param.type.split("bytes");
    const bytesSize = (0, $jBXg5.size)(value);
    if (!paramSize) {
        let value_ = value;
        // If the size is not divisible by 32 bytes, pad the end
        // with empty bytes to the ceiling 32 bytes.
        if (bytesSize % 32 !== 0) value_ = (0, $2OmJE.padHex)(value_, {
            dir: "right",
            size: Math.ceil((value.length - 2) / 2 / 32) * 32
        });
        return {
            dynamic: true,
            encoded: (0, $jCBOw.concat)([
                (0, $2OmJE.padHex)((0, $9UP4H.numberToHex)(bytesSize, {
                    size: 32
                })),
                value_
            ])
        };
    }
    if (bytesSize !== Number.parseInt(paramSize)) throw new (0, $3TFRi.AbiEncodingBytesSizeMismatchError)({
        expectedSize: Number.parseInt(paramSize),
        value: value
    });
    return {
        dynamic: false,
        encoded: (0, $2OmJE.padHex)(value, {
            dir: "right"
        })
    };
}
function $ebac97d4521e8e9c$var$encodeBool(value) {
    if (typeof value !== "boolean") throw new (0, $6F8ii.BaseError)(`Invalid boolean value: "${value}" (type: ${typeof value}). Expected: \`true\` or \`false\`.`);
    return {
        dynamic: false,
        encoded: (0, $2OmJE.padHex)((0, $9UP4H.boolToHex)(value))
    };
}
function $ebac97d4521e8e9c$var$encodeNumber(value, { signed: signed }) {
    return {
        dynamic: false,
        encoded: (0, $9UP4H.numberToHex)(value, {
            size: 32,
            signed: signed
        })
    };
}
function $ebac97d4521e8e9c$var$encodeString(value) {
    const hexValue = (0, $9UP4H.stringToHex)(value);
    const partsLength = Math.ceil((0, $jBXg5.size)(hexValue) / 32);
    const parts = [];
    for(let i = 0; i < partsLength; i++)parts.push((0, $2OmJE.padHex)((0, $a7Rp0.slice)(hexValue, i * 32, (i + 1) * 32), {
        dir: "right"
    }));
    return {
        dynamic: true,
        encoded: (0, $jCBOw.concat)([
            (0, $2OmJE.padHex)((0, $9UP4H.numberToHex)((0, $jBXg5.size)(hexValue), {
                size: 32
            })),
            ...parts
        ])
    };
}
function $ebac97d4521e8e9c$var$encodeTuple(value, { param: param }) {
    let dynamic = false;
    const preparedParams = [];
    for(let i = 0; i < param.components.length; i++){
        const param_ = param.components[i];
        const index = Array.isArray(value) ? i : param_.name;
        const preparedParam = $ebac97d4521e8e9c$var$prepareParam({
            param: param_,
            value: value[index]
        });
        preparedParams.push(preparedParam);
        if (preparedParam.dynamic) dynamic = true;
    }
    return {
        dynamic: dynamic,
        encoded: dynamic ? $ebac97d4521e8e9c$var$encodeParams(preparedParams) : (0, $jCBOw.concat)(preparedParams.map(({ encoded: encoded })=>encoded))
    };
}
function $ebac97d4521e8e9c$export$ab502cfdbb1a0d07(type) {
    const matches = type.match(/^(.*)\[(\d+)?\]$/);
    return matches ? [
        matches[2] ? Number(matches[2]) : null,
        matches[1]
    ] : undefined;
}

});
parcelRegister("jCBOw", function(module, exports) {

$parcel$export(module.exports, "concat", () => $e48ee5fbe6d1f9c9$export$ee1b3e54f0441b22);
$parcel$export(module.exports, "concatHex", () => $e48ee5fbe6d1f9c9$export$f6cc0b64b5a999af);
function $e48ee5fbe6d1f9c9$export$ee1b3e54f0441b22(values) {
    if (typeof values[0] === "string") return $e48ee5fbe6d1f9c9$export$f6cc0b64b5a999af(values);
    return $e48ee5fbe6d1f9c9$export$287dd7971339c972(values);
}
function $e48ee5fbe6d1f9c9$export$287dd7971339c972(values) {
    let length = 0;
    for (const arr of values)length += arr.length;
    const result = new Uint8Array(length);
    let offset = 0;
    for (const arr of values){
        result.set(arr, offset);
        offset += arr.length;
    }
    return result;
}
function $e48ee5fbe6d1f9c9$export$f6cc0b64b5a999af(values) {
    return `0x${values.reduce((acc, x)=>acc + x.replace("0x", ""), "")}`;
}

});




parcelRegister("49mjM", function(module, exports) {

$parcel$export(module.exports, "call", () => $3059509424e4fc58$export$848feb93d8f32b9b);

var $lLWSG = parcelRequire("lLWSG");

var $4I1xa = parcelRequire("4I1xa");

var $9nOfC = parcelRequire("9nOfC");

var $S7QSb = parcelRequire("S7QSb");

var $8NbpU = parcelRequire("8NbpU");

var $6F8ii = parcelRequire("6F8ii");

var $98Tjv = parcelRequire("98Tjv");

var $9dX4d = parcelRequire("9dX4d");

var $ktUQf = parcelRequire("ktUQf");

var $k2kLE = parcelRequire("k2kLE");

var $ahylX = parcelRequire("ahylX");

var $kErjY = parcelRequire("kErjY");

var $9UP4H = parcelRequire("9UP4H");

var $7MtC1 = parcelRequire("7MtC1");

var $cdCOv = parcelRequire("cdCOv");

var $dT7D8 = parcelRequire("dT7D8");

var $5ruIR = parcelRequire("5ruIR");

var $5XFM1 = parcelRequire("5XFM1");

var $dVFRY = parcelRequire("dVFRY");

async function $3059509424e4fc58$export$848feb93d8f32b9b(client, args) {
    const { account: account_ = client.account, batch: batch = Boolean(client.batch?.multicall), blockNumber: blockNumber, blockTag: blockTag = "latest", accessList: accessList, blobs: blobs, code: code, data: data_, factory: factory, factoryData: factoryData, gas: gas, gasPrice: gasPrice, maxFeePerBlobGas: maxFeePerBlobGas, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value, stateOverride: stateOverride, ...rest } = args;
    const account = account_ ? (0, $4I1xa.parseAccount)(account_) : undefined;
    if (code && (factory || factoryData)) throw new (0, $6F8ii.BaseError)("Cannot provide both `code` & `factory`/`factoryData` as parameters.");
    if (code && to) throw new (0, $6F8ii.BaseError)("Cannot provide both `code` & `to` as parameters.");
    // Check if the call is deployless via bytecode.
    const deploylessCallViaBytecode = code && data_;
    // Check if the call is deployless via a factory.
    const deploylessCallViaFactory = factory && factoryData && to && data_;
    const deploylessCall = deploylessCallViaBytecode || deploylessCallViaFactory;
    const data = (()=>{
        if (deploylessCallViaBytecode) return $3059509424e4fc58$var$toDeploylessCallViaBytecodeData({
            code: code,
            data: data_
        });
        if (deploylessCallViaFactory) return $3059509424e4fc58$var$toDeploylessCallViaFactoryData({
            data: data_,
            factory: factory,
            factoryData: factoryData,
            to: to
        });
        return data_;
    })();
    try {
        (0, $dVFRY.assertRequest)(args);
        const blockNumberHex = blockNumber ? (0, $9UP4H.numberToHex)(blockNumber) : undefined;
        const block = blockNumberHex || blockTag;
        const rpcStateOverride = (0, $5XFM1.serializeStateOverride)(stateOverride);
        const chainFormat = client.chain?.formatters?.transactionRequest?.format;
        const format = chainFormat || (0, $dT7D8.formatTransactionRequest);
        const request = format({
            // Pick out extra data that might exist on the chain's transaction request type.
            ...(0, $cdCOv.extract)(rest, {
                format: chainFormat
            }),
            from: account?.address,
            accessList: accessList,
            blobs: blobs,
            data: data,
            gas: gas,
            gasPrice: gasPrice,
            maxFeePerBlobGas: maxFeePerBlobGas,
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas,
            nonce: nonce,
            to: deploylessCall ? undefined : to,
            value: value
        });
        if (batch && $3059509424e4fc58$var$shouldPerformMulticall({
            request: request
        }) && !rpcStateOverride) try {
            return await $3059509424e4fc58$var$scheduleMulticall(client, {
                ...request,
                blockNumber: blockNumber,
                blockTag: blockTag
            });
        } catch (err) {
            if (!(err instanceof (0, $98Tjv.ClientChainNotConfiguredError)) && !(err instanceof (0, $98Tjv.ChainDoesNotSupportContract))) throw err;
        }
        const response = await client.request({
            method: "eth_call",
            params: rpcStateOverride ? [
                request,
                block,
                rpcStateOverride
            ] : [
                request,
                block
            ]
        });
        if (response === "0x") return {
            data: undefined
        };
        return {
            data: response
        };
    } catch (err) {
        const data = $3059509424e4fc58$export$6ef1a527f868ca75(err);
        // Check for CCIP-Read offchain lookup signature.
        const { offchainLookup: offchainLookup, offchainLookupSignature: offchainLookupSignature } = await (parcelRequire("1E7g1"));
        if (client.ccipRead !== false && data?.slice(0, 10) === offchainLookupSignature && to) return {
            data: await offchainLookup(client, {
                data: data,
                to: to
            })
        };
        // Check for counterfactual deployment error.
        if (deploylessCall && data?.slice(0, 10) === "0x101bb98d") throw new (0, $9dX4d.CounterfactualDeploymentFailedError)({
            factory: factory
        });
        throw (0, $7MtC1.getCallError)(err, {
            ...args,
            account: account,
            chain: client.chain
        });
    }
}
// We only want to perform a scheduled multicall if:
// - The request has calldata,
// - The request has a target address,
// - The target address is not already the aggregate3 signature,
// - The request has no other properties (`nonce`, `gas`, etc cannot be sent with a multicall).
function $3059509424e4fc58$var$shouldPerformMulticall({ request: request }) {
    const { data: data, to: to, ...request_ } = request;
    if (!data) return false;
    if (data.startsWith((0, $S7QSb.aggregate3Signature))) return false;
    if (!to) return false;
    if (Object.values(request_).filter((x)=>typeof x !== "undefined").length > 0) return false;
    return true;
}
async function $3059509424e4fc58$var$scheduleMulticall(client, args) {
    const { batchSize: batchSize = 1024, wait: wait = 0 } = typeof client.batch?.multicall === "object" ? client.batch.multicall : {};
    const { blockNumber: blockNumber, blockTag: blockTag = "latest", data: data, multicallAddress: multicallAddress_, to: to } = args;
    let multicallAddress = multicallAddress_;
    if (!multicallAddress) {
        if (!client.chain) throw new (0, $98Tjv.ClientChainNotConfiguredError)();
        multicallAddress = (0, $kErjY.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "multicall3"
        });
    }
    const blockNumberHex = blockNumber ? (0, $9UP4H.numberToHex)(blockNumber) : undefined;
    const block = blockNumberHex || blockTag;
    const { schedule: schedule } = (0, $5ruIR.createBatchScheduler)({
        id: `${client.uid}.${block}`,
        wait: wait,
        shouldSplitBatch (args) {
            const size = args.reduce((size, { data: data })=>size + (data.length - 2), 0);
            return size > batchSize * 2;
        },
        fn: async (requests)=>{
            const calls = requests.map((request)=>({
                    allowFailure: true,
                    callData: request.data,
                    target: request.to
                }));
            const calldata = (0, $ahylX.encodeFunctionData)({
                abi: (0, $9nOfC.multicall3Abi),
                args: [
                    calls
                ],
                functionName: "aggregate3"
            });
            const data = await client.request({
                method: "eth_call",
                params: [
                    {
                        data: calldata,
                        to: multicallAddress
                    },
                    block
                ]
            });
            return (0, $ktUQf.decodeFunctionResult)({
                abi: (0, $9nOfC.multicall3Abi),
                args: [
                    calls
                ],
                functionName: "aggregate3",
                data: data || "0x"
            });
        }
    });
    const [{ returnData: returnData, success: success }] = await schedule({
        data: data,
        to: to
    });
    if (!success) throw new (0, $9dX4d.RawContractError)({
        data: returnData
    });
    if (returnData === "0x") return {
        data: undefined
    };
    return {
        data: returnData
    };
}
function $3059509424e4fc58$var$toDeploylessCallViaBytecodeData(parameters) {
    const { code: code, data: data } = parameters;
    return (0, $k2kLE.encodeDeployData)({
        abi: (0, $lLWSG.parseAbi)([
            "constructor(bytes, bytes)"
        ]),
        bytecode: (0, $8NbpU.deploylessCallViaBytecodeBytecode),
        args: [
            code,
            data
        ]
    });
}
function $3059509424e4fc58$var$toDeploylessCallViaFactoryData(parameters) {
    const { data: data, factory: factory, factoryData: factoryData, to: to } = parameters;
    return (0, $k2kLE.encodeDeployData)({
        abi: (0, $lLWSG.parseAbi)([
            "constructor(address, bytes, address, bytes)"
        ]),
        bytecode: (0, $8NbpU.deploylessCallViaFactoryBytecode),
        args: [
            to,
            data,
            factory,
            factoryData
        ]
    });
}
function $3059509424e4fc58$export$6ef1a527f868ca75(err) {
    if (!(err instanceof (0, $6F8ii.BaseError))) return undefined;
    const error = err.walk();
    return typeof error?.data === "object" ? error.data?.data : error.data;
}

});
parcelRegister("lLWSG", function(module, exports) {

$parcel$export(module.exports, "parseAbi", () => $fd9ba9517f59d473$export$4ab3f466fb8f069);

var $l1qAf = parcelRequire("l1qAf");

var $5lu9X = parcelRequire("5lu9X");

var $h9N10 = parcelRequire("h9N10");
function $fd9ba9517f59d473$export$4ab3f466fb8f069(signatures) {
    const structs = (0, $5lu9X.parseStructs)(signatures);
    const abi = [];
    const length = signatures.length;
    for(let i = 0; i < length; i++){
        const signature = signatures[i];
        if ((0, $l1qAf.isStructSignature)(signature)) continue;
        abi.push((0, $h9N10.parseSignature)(signature, structs));
    }
    return abi;
}

});
parcelRegister("l1qAf", function(module, exports) {

$parcel$export(module.exports, "isErrorSignature", () => $f4de4fe791163964$export$33be303020ecaff5);
$parcel$export(module.exports, "execErrorSignature", () => $f4de4fe791163964$export$a8b67e842e5c116d);
$parcel$export(module.exports, "isEventSignature", () => $f4de4fe791163964$export$7912f33b3b4526ca);
$parcel$export(module.exports, "execEventSignature", () => $f4de4fe791163964$export$87d5ec49338ff6f);
$parcel$export(module.exports, "isFunctionSignature", () => $f4de4fe791163964$export$fa8ae1a8bca33200);
$parcel$export(module.exports, "execFunctionSignature", () => $f4de4fe791163964$export$8a14253893829398);
$parcel$export(module.exports, "isStructSignature", () => $f4de4fe791163964$export$130f77ea18c25fb8);
$parcel$export(module.exports, "execStructSignature", () => $f4de4fe791163964$export$432f3b6c467d7b70);
$parcel$export(module.exports, "isConstructorSignature", () => $f4de4fe791163964$export$7ec9623fe58e8638);
$parcel$export(module.exports, "execConstructorSignature", () => $f4de4fe791163964$export$4713f9c79c855460);
$parcel$export(module.exports, "isFallbackSignature", () => $f4de4fe791163964$export$f99ebae7027f9f2f);
$parcel$export(module.exports, "isReceiveSignature", () => $f4de4fe791163964$export$555d9bfe0f07ab3d);
$parcel$export(module.exports, "eventModifiers", () => $f4de4fe791163964$export$e4045f69b6b17e16);
$parcel$export(module.exports, "functionModifiers", () => $f4de4fe791163964$export$d304f1652f422b6b);

var $6Cr9r = parcelRequire("6Cr9r");
// https://regexr.com/7gmok
const $f4de4fe791163964$var$errorSignatureRegex = /^error (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)$/;
function $f4de4fe791163964$export$33be303020ecaff5(signature) {
    return $f4de4fe791163964$var$errorSignatureRegex.test(signature);
}
function $f4de4fe791163964$export$a8b67e842e5c116d(signature) {
    return (0, $6Cr9r.execTyped)($f4de4fe791163964$var$errorSignatureRegex, signature);
}
// https://regexr.com/7gmoq
const $f4de4fe791163964$var$eventSignatureRegex = /^event (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)$/;
function $f4de4fe791163964$export$7912f33b3b4526ca(signature) {
    return $f4de4fe791163964$var$eventSignatureRegex.test(signature);
}
function $f4de4fe791163964$export$87d5ec49338ff6f(signature) {
    return (0, $6Cr9r.execTyped)($f4de4fe791163964$var$eventSignatureRegex, signature);
}
// https://regexr.com/7gmot
const $f4de4fe791163964$var$functionSignatureRegex = /^function (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*)\((?<parameters>.*?)\)(?: (?<scope>external|public{1}))?(?: (?<stateMutability>pure|view|nonpayable|payable{1}))?(?: returns\s?\((?<returns>.*?)\))?$/;
function $f4de4fe791163964$export$fa8ae1a8bca33200(signature) {
    return $f4de4fe791163964$var$functionSignatureRegex.test(signature);
}
function $f4de4fe791163964$export$8a14253893829398(signature) {
    return (0, $6Cr9r.execTyped)($f4de4fe791163964$var$functionSignatureRegex, signature);
}
// https://regexr.com/7gmp3
const $f4de4fe791163964$var$structSignatureRegex = /^struct (?<name>[a-zA-Z$_][a-zA-Z0-9$_]*) \{(?<properties>.*?)\}$/;
function $f4de4fe791163964$export$130f77ea18c25fb8(signature) {
    return $f4de4fe791163964$var$structSignatureRegex.test(signature);
}
function $f4de4fe791163964$export$432f3b6c467d7b70(signature) {
    return (0, $6Cr9r.execTyped)($f4de4fe791163964$var$structSignatureRegex, signature);
}
// https://regexr.com/78u01
const $f4de4fe791163964$var$constructorSignatureRegex = /^constructor\((?<parameters>.*?)\)(?:\s(?<stateMutability>payable{1}))?$/;
function $f4de4fe791163964$export$7ec9623fe58e8638(signature) {
    return $f4de4fe791163964$var$constructorSignatureRegex.test(signature);
}
function $f4de4fe791163964$export$4713f9c79c855460(signature) {
    return (0, $6Cr9r.execTyped)($f4de4fe791163964$var$constructorSignatureRegex, signature);
}
// https://regexr.com/7srtn
const $f4de4fe791163964$var$fallbackSignatureRegex = /^fallback\(\) external(?:\s(?<stateMutability>payable{1}))?$/;
function $f4de4fe791163964$export$f99ebae7027f9f2f(signature) {
    return $f4de4fe791163964$var$fallbackSignatureRegex.test(signature);
}
// https://regexr.com/78u1k
const $f4de4fe791163964$var$receiveSignatureRegex = /^receive\(\) external payable$/;
function $f4de4fe791163964$export$555d9bfe0f07ab3d(signature) {
    return $f4de4fe791163964$var$receiveSignatureRegex.test(signature);
}
const $f4de4fe791163964$export$c2f15f629432a51d = new Set([
    "memory",
    "indexed",
    "storage",
    "calldata"
]);
const $f4de4fe791163964$export$e4045f69b6b17e16 = new Set([
    "indexed"
]);
const $f4de4fe791163964$export$d304f1652f422b6b = new Set([
    "calldata",
    "memory",
    "storage"
]);

});

parcelRegister("5lu9X", function(module, exports) {

$parcel$export(module.exports, "parseStructs", () => $3e464f01d17c9bdc$export$6e5e6f927c48b857);

var $6Cr9r = parcelRequire("6Cr9r");

var $6Poh4 = parcelRequire("6Poh4");

var $4dOyR = parcelRequire("4dOyR");

var $9sLP2 = parcelRequire("9sLP2");

var $i5wCj = parcelRequire("i5wCj");

var $l1qAf = parcelRequire("l1qAf");

var $h9N10 = parcelRequire("h9N10");
function $3e464f01d17c9bdc$export$6e5e6f927c48b857(signatures) {
    // Create "shallow" version of each struct (and filter out non-structs or invalid structs)
    const shallowStructs = {};
    const signaturesLength = signatures.length;
    for(let i = 0; i < signaturesLength; i++){
        const signature = signatures[i];
        if (!(0, $l1qAf.isStructSignature)(signature)) continue;
        const match = (0, $l1qAf.execStructSignature)(signature);
        if (!match) throw new (0, $9sLP2.InvalidSignatureError)({
            signature: signature,
            type: "struct"
        });
        const properties = match.properties.split(";");
        const components = [];
        const propertiesLength = properties.length;
        for(let k = 0; k < propertiesLength; k++){
            const property = properties[k];
            const trimmed = property.trim();
            if (!trimmed) continue;
            const abiParameter = (0, $h9N10.parseAbiParameter)(trimmed, {
                type: "struct"
            });
            components.push(abiParameter);
        }
        if (!components.length) throw new (0, $9sLP2.InvalidStructSignatureError)({
            signature: signature
        });
        shallowStructs[match.name] = components;
    }
    // Resolve nested structs inside each parameter
    const resolvedStructs = {};
    const entries = Object.entries(shallowStructs);
    const entriesLength = entries.length;
    for(let i = 0; i < entriesLength; i++){
        const [name, parameters] = entries[i];
        resolvedStructs[name] = $3e464f01d17c9bdc$var$resolveStructs(parameters, shallowStructs);
    }
    return resolvedStructs;
}
const $3e464f01d17c9bdc$var$typeWithoutTupleRegex = /^(?<type>[a-zA-Z$_][a-zA-Z0-9$_]*)(?<array>(?:\[\d*?\])+?)?$/;
function $3e464f01d17c9bdc$var$resolveStructs(abiParameters, structs, ancestors = new Set()) {
    const components = [];
    const length = abiParameters.length;
    for(let i = 0; i < length; i++){
        const abiParameter = abiParameters[i];
        const isTuple = (0, $6Cr9r.isTupleRegex).test(abiParameter.type);
        if (isTuple) components.push(abiParameter);
        else {
            const match = (0, $6Cr9r.execTyped)($3e464f01d17c9bdc$var$typeWithoutTupleRegex, abiParameter.type);
            if (!match?.type) throw new (0, $4dOyR.InvalidAbiTypeParameterError)({
                abiParameter: abiParameter
            });
            const { array: array, type: type } = match;
            if (type in structs) {
                if (ancestors.has(type)) throw new (0, $i5wCj.CircularReferenceError)({
                    type: type
                });
                components.push({
                    ...abiParameter,
                    type: `tuple${array ?? ""}`,
                    components: $3e464f01d17c9bdc$var$resolveStructs(structs[type] ?? [], structs, new Set([
                        ...ancestors,
                        type
                    ]))
                });
            } else {
                if ((0, $h9N10.isSolidityType)(type)) components.push(abiParameter);
                else throw new (0, $6Poh4.UnknownTypeError)({
                    type: type
                });
            }
        }
    }
    return components;
}

});
parcelRegister("6Poh4", function(module, exports) {

$parcel$export(module.exports, "UnknownTypeError", () => $4f8a55e5fdca031a$export$9e77a92da3bcd5ca);
$parcel$export(module.exports, "UnknownSolidityTypeError", () => $4f8a55e5fdca031a$export$5a36348a2ac471a3);

var $dtCvT = parcelRequire("dtCvT");
class $4f8a55e5fdca031a$export$a4e0854b60f599b6 extends (0, $dtCvT.BaseError) {
    constructor({ signature: signature }){
        super("Failed to parse ABI item.", {
            details: `parseAbiItem(${JSON.stringify(signature, null, 2)})`,
            docsPath: "/api/human#parseabiitem-1"
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiItemError"
        });
    }
}
class $4f8a55e5fdca031a$export$9e77a92da3bcd5ca extends (0, $dtCvT.BaseError) {
    constructor({ type: type }){
        super("Unknown type.", {
            metaMessages: [
                `Type "${type}" is not a valid ABI type. Perhaps you forgot to include a struct signature?`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnknownTypeError"
        });
    }
}
class $4f8a55e5fdca031a$export$5a36348a2ac471a3 extends (0, $dtCvT.BaseError) {
    constructor({ type: type }){
        super("Unknown type.", {
            metaMessages: [
                `Type "${type}" is not a valid ABI type.`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnknownSolidityTypeError"
        });
    }
}

});
parcelRegister("dtCvT", function(module, exports) {

$parcel$export(module.exports, "BaseError", () => $9cfbdbc45cf4e50b$export$a490eb03cb7a0a5e);

var $5Rehu = parcelRequire("5Rehu");
class $9cfbdbc45cf4e50b$export$a490eb03cb7a0a5e extends Error {
    constructor(shortMessage, args = {}){
        const details = args.cause instanceof $9cfbdbc45cf4e50b$export$a490eb03cb7a0a5e ? args.cause.details : args.cause?.message ? args.cause.message : args.details;
        const docsPath = args.cause instanceof $9cfbdbc45cf4e50b$export$a490eb03cb7a0a5e ? args.cause.docsPath || args.docsPath : args.docsPath;
        const message = [
            shortMessage || "An error occurred.",
            "",
            ...args.metaMessages ? [
                ...args.metaMessages,
                ""
            ] : [],
            ...docsPath ? [
                `Docs: https://abitype.dev${docsPath}`
            ] : [],
            ...details ? [
                `Details: ${details}`
            ] : [],
            `Version: abitype@${(0, $5Rehu.version)}`
        ].join("\n");
        super(message);
        Object.defineProperty(this, "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "docsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "metaMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shortMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "AbiTypeError"
        });
        if (args.cause) this.cause = args.cause;
        this.details = details;
        this.docsPath = docsPath;
        this.metaMessages = args.metaMessages;
        this.shortMessage = shortMessage;
    }
}

});
parcelRegister("5Rehu", function(module, exports) {

$parcel$export(module.exports, "version", () => $443cfae60a59b429$export$83d89fbfd8236492);
const $443cfae60a59b429$export$83d89fbfd8236492 = "1.0.5";

});



parcelRegister("4dOyR", function(module, exports) {

$parcel$export(module.exports, "InvalidParameterError", () => $312f98bc4e07ac73$export$e569b97a5d46005c);
$parcel$export(module.exports, "SolidityProtectedKeywordError", () => $312f98bc4e07ac73$export$58697cc8f790f211);
$parcel$export(module.exports, "InvalidModifierError", () => $312f98bc4e07ac73$export$f837e6b0dee0e468);
$parcel$export(module.exports, "InvalidFunctionModifierError", () => $312f98bc4e07ac73$export$7afd0f25b8fdbbd8);
$parcel$export(module.exports, "InvalidAbiTypeParameterError", () => $312f98bc4e07ac73$export$b5451545b6c52dc8);

var $dtCvT = parcelRequire("dtCvT");
class $312f98bc4e07ac73$export$bdcd4054531f5b35 extends (0, $dtCvT.BaseError) {
    constructor({ param: param }){
        super("Failed to parse ABI parameter.", {
            details: `parseAbiParameter(${JSON.stringify(param, null, 2)})`,
            docsPath: "/api/human#parseabiparameter-1"
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiParameterError"
        });
    }
}
class $312f98bc4e07ac73$export$f35df31806e96ff extends (0, $dtCvT.BaseError) {
    constructor({ params: params }){
        super("Failed to parse ABI parameters.", {
            details: `parseAbiParameters(${JSON.stringify(params, null, 2)})`,
            docsPath: "/api/human#parseabiparameters-1"
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiParametersError"
        });
    }
}
class $312f98bc4e07ac73$export$e569b97a5d46005c extends (0, $dtCvT.BaseError) {
    constructor({ param: param }){
        super("Invalid ABI parameter.", {
            details: param
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidParameterError"
        });
    }
}
class $312f98bc4e07ac73$export$58697cc8f790f211 extends (0, $dtCvT.BaseError) {
    constructor({ param: param, name: name }){
        super("Invalid ABI parameter.", {
            details: param,
            metaMessages: [
                `"${name}" is a protected Solidity keyword. More info: https://docs.soliditylang.org/en/latest/cheatsheet.html`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "SolidityProtectedKeywordError"
        });
    }
}
class $312f98bc4e07ac73$export$f837e6b0dee0e468 extends (0, $dtCvT.BaseError) {
    constructor({ param: param, type: type, modifier: modifier }){
        super("Invalid ABI parameter.", {
            details: param,
            metaMessages: [
                `Modifier "${modifier}" not allowed${type ? ` in "${type}" type` : ""}.`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidModifierError"
        });
    }
}
class $312f98bc4e07ac73$export$7afd0f25b8fdbbd8 extends (0, $dtCvT.BaseError) {
    constructor({ param: param, type: type, modifier: modifier }){
        super("Invalid ABI parameter.", {
            details: param,
            metaMessages: [
                `Modifier "${modifier}" not allowed${type ? ` in "${type}" type` : ""}.`,
                `Data location can only be specified for array, struct, or mapping types, but "${modifier}" was given.`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidFunctionModifierError"
        });
    }
}
class $312f98bc4e07ac73$export$b5451545b6c52dc8 extends (0, $dtCvT.BaseError) {
    constructor({ abiParameter: abiParameter }){
        super("Invalid ABI parameter.", {
            details: JSON.stringify(abiParameter, null, 2),
            metaMessages: [
                "ABI parameter type is invalid."
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidAbiTypeParameterError"
        });
    }
}

});

parcelRegister("9sLP2", function(module, exports) {

$parcel$export(module.exports, "InvalidSignatureError", () => $6e3bd317f671e7d4$export$ccc2f68ef106615a);
$parcel$export(module.exports, "UnknownSignatureError", () => $6e3bd317f671e7d4$export$3727c00c40963d37);
$parcel$export(module.exports, "InvalidStructSignatureError", () => $6e3bd317f671e7d4$export$769955518e5ea753);

var $dtCvT = parcelRequire("dtCvT");
class $6e3bd317f671e7d4$export$ccc2f68ef106615a extends (0, $dtCvT.BaseError) {
    constructor({ signature: signature, type: type }){
        super(`Invalid ${type} signature.`, {
            details: signature
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidSignatureError"
        });
    }
}
class $6e3bd317f671e7d4$export$3727c00c40963d37 extends (0, $dtCvT.BaseError) {
    constructor({ signature: signature }){
        super("Unknown signature.", {
            details: signature
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "UnknownSignatureError"
        });
    }
}
class $6e3bd317f671e7d4$export$769955518e5ea753 extends (0, $dtCvT.BaseError) {
    constructor({ signature: signature }){
        super("Invalid struct signature.", {
            details: signature,
            metaMessages: [
                "No properties exist."
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidStructSignatureError"
        });
    }
}

});

parcelRegister("i5wCj", function(module, exports) {

$parcel$export(module.exports, "CircularReferenceError", () => $d2b1fea641d1d8b8$export$3b7cb2315fb6b103);

var $dtCvT = parcelRequire("dtCvT");
class $d2b1fea641d1d8b8$export$3b7cb2315fb6b103 extends (0, $dtCvT.BaseError) {
    constructor({ type: type }){
        super("Circular reference detected.", {
            metaMessages: [
                `Struct "${type}" is a circular reference.`
            ]
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "CircularReferenceError"
        });
    }
}

});

parcelRegister("h9N10", function(module, exports) {

$parcel$export(module.exports, "parseSignature", () => $c7d94c53a6251155$export$dc1dc22ccf24efef);
$parcel$export(module.exports, "parseAbiParameter", () => $c7d94c53a6251155$export$357229f9e2d85552);
$parcel$export(module.exports, "isSolidityType", () => $c7d94c53a6251155$export$640ecc6f40db6417);

var $6Cr9r = parcelRequire("6Cr9r");

var $6Poh4 = parcelRequire("6Poh4");

var $4dOyR = parcelRequire("4dOyR");

var $9sLP2 = parcelRequire("9sLP2");

var $fBact = parcelRequire("fBact");

var $jhQdX = parcelRequire("jhQdX");

var $l1qAf = parcelRequire("l1qAf");
function $c7d94c53a6251155$export$dc1dc22ccf24efef(signature, structs = {}) {
    if ((0, $l1qAf.isFunctionSignature)(signature)) {
        const match = (0, $l1qAf.execFunctionSignature)(signature);
        if (!match) throw new (0, $9sLP2.InvalidSignatureError)({
            signature: signature,
            type: "function"
        });
        const inputParams = $c7d94c53a6251155$export$8350908b11ff5aef(match.parameters);
        const inputs = [];
        const inputLength = inputParams.length;
        for(let i = 0; i < inputLength; i++)inputs.push($c7d94c53a6251155$export$357229f9e2d85552(inputParams[i], {
            modifiers: (0, $l1qAf.functionModifiers),
            structs: structs,
            type: "function"
        }));
        const outputs = [];
        if (match.returns) {
            const outputParams = $c7d94c53a6251155$export$8350908b11ff5aef(match.returns);
            const outputLength = outputParams.length;
            for(let i = 0; i < outputLength; i++)outputs.push($c7d94c53a6251155$export$357229f9e2d85552(outputParams[i], {
                modifiers: (0, $l1qAf.functionModifiers),
                structs: structs,
                type: "function"
            }));
        }
        return {
            name: match.name,
            type: "function",
            stateMutability: match.stateMutability ?? "nonpayable",
            inputs: inputs,
            outputs: outputs
        };
    }
    if ((0, $l1qAf.isEventSignature)(signature)) {
        const match = (0, $l1qAf.execEventSignature)(signature);
        if (!match) throw new (0, $9sLP2.InvalidSignatureError)({
            signature: signature,
            type: "event"
        });
        const params = $c7d94c53a6251155$export$8350908b11ff5aef(match.parameters);
        const abiParameters = [];
        const length = params.length;
        for(let i = 0; i < length; i++)abiParameters.push($c7d94c53a6251155$export$357229f9e2d85552(params[i], {
            modifiers: (0, $l1qAf.eventModifiers),
            structs: structs,
            type: "event"
        }));
        return {
            name: match.name,
            type: "event",
            inputs: abiParameters
        };
    }
    if ((0, $l1qAf.isErrorSignature)(signature)) {
        const match = (0, $l1qAf.execErrorSignature)(signature);
        if (!match) throw new (0, $9sLP2.InvalidSignatureError)({
            signature: signature,
            type: "error"
        });
        const params = $c7d94c53a6251155$export$8350908b11ff5aef(match.parameters);
        const abiParameters = [];
        const length = params.length;
        for(let i = 0; i < length; i++)abiParameters.push($c7d94c53a6251155$export$357229f9e2d85552(params[i], {
            structs: structs,
            type: "error"
        }));
        return {
            name: match.name,
            type: "error",
            inputs: abiParameters
        };
    }
    if ((0, $l1qAf.isConstructorSignature)(signature)) {
        const match = (0, $l1qAf.execConstructorSignature)(signature);
        if (!match) throw new (0, $9sLP2.InvalidSignatureError)({
            signature: signature,
            type: "constructor"
        });
        const params = $c7d94c53a6251155$export$8350908b11ff5aef(match.parameters);
        const abiParameters = [];
        const length = params.length;
        for(let i = 0; i < length; i++)abiParameters.push($c7d94c53a6251155$export$357229f9e2d85552(params[i], {
            structs: structs,
            type: "constructor"
        }));
        return {
            type: "constructor",
            stateMutability: match.stateMutability ?? "nonpayable",
            inputs: abiParameters
        };
    }
    if ((0, $l1qAf.isFallbackSignature)(signature)) return {
        type: "fallback"
    };
    if ((0, $l1qAf.isReceiveSignature)(signature)) return {
        type: "receive",
        stateMutability: "payable"
    };
    throw new (0, $9sLP2.UnknownSignatureError)({
        signature: signature
    });
}
const $c7d94c53a6251155$var$abiParameterWithoutTupleRegex = /^(?<type>[a-zA-Z$_][a-zA-Z0-9$_]*)(?<array>(?:\[\d*?\])+?)?(?:\s(?<modifier>calldata|indexed|memory|storage{1}))?(?:\s(?<name>[a-zA-Z$_][a-zA-Z0-9$_]*))?$/;
const $c7d94c53a6251155$var$abiParameterWithTupleRegex = /^\((?<type>.+?)\)(?<array>(?:\[\d*?\])+?)?(?:\s(?<modifier>calldata|indexed|memory|storage{1}))?(?:\s(?<name>[a-zA-Z$_][a-zA-Z0-9$_]*))?$/;
const $c7d94c53a6251155$var$dynamicIntegerRegex = /^u?int$/;
function $c7d94c53a6251155$export$357229f9e2d85552(param, options) {
    // optional namespace cache by `type`
    const parameterCacheKey = (0, $jhQdX.getParameterCacheKey)(param, options?.type);
    if ((0, $jhQdX.parameterCache).has(parameterCacheKey)) return (0, $jhQdX.parameterCache).get(parameterCacheKey);
    const isTuple = (0, $6Cr9r.isTupleRegex).test(param);
    const match = (0, $6Cr9r.execTyped)(isTuple ? $c7d94c53a6251155$var$abiParameterWithTupleRegex : $c7d94c53a6251155$var$abiParameterWithoutTupleRegex, param);
    if (!match) throw new (0, $4dOyR.InvalidParameterError)({
        param: param
    });
    if (match.name && $c7d94c53a6251155$export$d83e1b8970d84409(match.name)) throw new (0, $4dOyR.SolidityProtectedKeywordError)({
        param: param,
        name: match.name
    });
    const name = match.name ? {
        name: match.name
    } : {};
    const indexed = match.modifier === "indexed" ? {
        indexed: true
    } : {};
    const structs = options?.structs ?? {};
    let type;
    let components = {};
    if (isTuple) {
        type = "tuple";
        const params = $c7d94c53a6251155$export$8350908b11ff5aef(match.type);
        const components_ = [];
        const length = params.length;
        for(let i = 0; i < length; i++)// remove `modifiers` from `options` to prevent from being added to tuple components
        components_.push($c7d94c53a6251155$export$357229f9e2d85552(params[i], {
            structs: structs
        }));
        components = {
            components: components_
        };
    } else if (match.type in structs) {
        type = "tuple";
        components = {
            components: structs[match.type]
        };
    } else if ($c7d94c53a6251155$var$dynamicIntegerRegex.test(match.type)) type = `${match.type}256`;
    else {
        type = match.type;
        if (!(options?.type === "struct") && !$c7d94c53a6251155$export$640ecc6f40db6417(type)) throw new (0, $6Poh4.UnknownSolidityTypeError)({
            type: type
        });
    }
    if (match.modifier) {
        // Check if modifier exists, but is not allowed (e.g. `indexed` in `functionModifiers`)
        if (!options?.modifiers?.has?.(match.modifier)) throw new (0, $4dOyR.InvalidModifierError)({
            param: param,
            type: options?.type,
            modifier: match.modifier
        });
        // Check if resolved `type` is valid if there is a function modifier
        if ((0, $l1qAf.functionModifiers).has(match.modifier) && !$c7d94c53a6251155$export$7265528696368a9(type, !!match.array)) throw new (0, $4dOyR.InvalidFunctionModifierError)({
            param: param,
            type: options?.type,
            modifier: match.modifier
        });
    }
    const abiParameter = {
        type: `${type}${match.array ?? ""}`,
        ...name,
        ...indexed,
        ...components
    };
    (0, $jhQdX.parameterCache).set(parameterCacheKey, abiParameter);
    return abiParameter;
}
function $c7d94c53a6251155$export$8350908b11ff5aef(params, result = [], current = "", depth = 0) {
    const length = params.trim().length;
    // biome-ignore lint/correctness/noUnreachable: recursive
    for(let i = 0; i < length; i++){
        const char = params[i];
        const tail = params.slice(i + 1);
        switch(char){
            case ",":
                return depth === 0 ? $c7d94c53a6251155$export$8350908b11ff5aef(tail, [
                    ...result,
                    current.trim()
                ]) : $c7d94c53a6251155$export$8350908b11ff5aef(tail, result, `${current}${char}`, depth);
            case "(":
                return $c7d94c53a6251155$export$8350908b11ff5aef(tail, result, `${current}${char}`, depth + 1);
            case ")":
                return $c7d94c53a6251155$export$8350908b11ff5aef(tail, result, `${current}${char}`, depth - 1);
            default:
                return $c7d94c53a6251155$export$8350908b11ff5aef(tail, result, `${current}${char}`, depth);
        }
    }
    if (current === "") return result;
    if (depth !== 0) throw new (0, $fBact.InvalidParenthesisError)({
        current: current,
        depth: depth
    });
    result.push(current.trim());
    return result;
}
function $c7d94c53a6251155$export$640ecc6f40db6417(type) {
    return type === "address" || type === "bool" || type === "function" || type === "string" || (0, $6Cr9r.bytesRegex).test(type) || (0, $6Cr9r.integerRegex).test(type);
}
const $c7d94c53a6251155$var$protectedKeywordsRegex = /^(?:after|alias|anonymous|apply|auto|byte|calldata|case|catch|constant|copyof|default|defined|error|event|external|false|final|function|immutable|implements|in|indexed|inline|internal|let|mapping|match|memory|mutable|null|of|override|partial|private|promise|public|pure|reference|relocatable|return|returns|sizeof|static|storage|struct|super|supports|switch|this|true|try|typedef|typeof|var|view|virtual)$/;
function $c7d94c53a6251155$export$d83e1b8970d84409(name) {
    return name === "address" || name === "bool" || name === "function" || name === "string" || name === "tuple" || (0, $6Cr9r.bytesRegex).test(name) || (0, $6Cr9r.integerRegex).test(name) || $c7d94c53a6251155$var$protectedKeywordsRegex.test(name);
}
function $c7d94c53a6251155$export$7265528696368a9(type, isArray) {
    return isArray || type === "bytes" || type === "string" || type === "tuple";
}

});
parcelRegister("fBact", function(module, exports) {

$parcel$export(module.exports, "InvalidParenthesisError", () => $b5b2394641ec2821$export$a13d6673dbe1ad6e);

var $dtCvT = parcelRequire("dtCvT");
class $b5b2394641ec2821$export$a13d6673dbe1ad6e extends (0, $dtCvT.BaseError) {
    constructor({ current: current, depth: depth }){
        super("Unbalanced parentheses.", {
            metaMessages: [
                `"${current.trim()}" has too many ${depth > 0 ? "opening" : "closing"} parentheses.`
            ],
            details: `Depth "${depth}"`
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "InvalidParenthesisError"
        });
    }
}

});

parcelRegister("jhQdX", function(module, exports) {

$parcel$export(module.exports, "getParameterCacheKey", () => $e0a81d767c1db134$export$516f1eedf0355404);
$parcel$export(module.exports, "parameterCache", () => $e0a81d767c1db134$export$da1654d628010643);
/**
 * Gets {@link parameterCache} cache key namespaced by {@link type}. This prevents parameters from being accessible to types that don't allow them (e.g. `string indexed foo` not allowed outside of `type: 'event'`).
 * @param param ABI parameter string
 * @param type ABI parameter type
 * @returns Cache key for {@link parameterCache}
 */ function $e0a81d767c1db134$export$516f1eedf0355404(param, type) {
    if (type) return `${type}:${param}`;
    return param;
}
const $e0a81d767c1db134$export$da1654d628010643 = new Map([
    // Unnamed
    [
        "address",
        {
            type: "address"
        }
    ],
    [
        "bool",
        {
            type: "bool"
        }
    ],
    [
        "bytes",
        {
            type: "bytes"
        }
    ],
    [
        "bytes32",
        {
            type: "bytes32"
        }
    ],
    [
        "int",
        {
            type: "int256"
        }
    ],
    [
        "int256",
        {
            type: "int256"
        }
    ],
    [
        "string",
        {
            type: "string"
        }
    ],
    [
        "uint",
        {
            type: "uint256"
        }
    ],
    [
        "uint8",
        {
            type: "uint8"
        }
    ],
    [
        "uint16",
        {
            type: "uint16"
        }
    ],
    [
        "uint24",
        {
            type: "uint24"
        }
    ],
    [
        "uint32",
        {
            type: "uint32"
        }
    ],
    [
        "uint64",
        {
            type: "uint64"
        }
    ],
    [
        "uint96",
        {
            type: "uint96"
        }
    ],
    [
        "uint112",
        {
            type: "uint112"
        }
    ],
    [
        "uint160",
        {
            type: "uint160"
        }
    ],
    [
        "uint192",
        {
            type: "uint192"
        }
    ],
    [
        "uint256",
        {
            type: "uint256"
        }
    ],
    // Named
    [
        "address owner",
        {
            type: "address",
            name: "owner"
        }
    ],
    [
        "address to",
        {
            type: "address",
            name: "to"
        }
    ],
    [
        "bool approved",
        {
            type: "bool",
            name: "approved"
        }
    ],
    [
        "bytes _data",
        {
            type: "bytes",
            name: "_data"
        }
    ],
    [
        "bytes data",
        {
            type: "bytes",
            name: "data"
        }
    ],
    [
        "bytes signature",
        {
            type: "bytes",
            name: "signature"
        }
    ],
    [
        "bytes32 hash",
        {
            type: "bytes32",
            name: "hash"
        }
    ],
    [
        "bytes32 r",
        {
            type: "bytes32",
            name: "r"
        }
    ],
    [
        "bytes32 root",
        {
            type: "bytes32",
            name: "root"
        }
    ],
    [
        "bytes32 s",
        {
            type: "bytes32",
            name: "s"
        }
    ],
    [
        "string name",
        {
            type: "string",
            name: "name"
        }
    ],
    [
        "string symbol",
        {
            type: "string",
            name: "symbol"
        }
    ],
    [
        "string tokenURI",
        {
            type: "string",
            name: "tokenURI"
        }
    ],
    [
        "uint tokenId",
        {
            type: "uint256",
            name: "tokenId"
        }
    ],
    [
        "uint8 v",
        {
            type: "uint8",
            name: "v"
        }
    ],
    [
        "uint256 balance",
        {
            type: "uint256",
            name: "balance"
        }
    ],
    [
        "uint256 tokenId",
        {
            type: "uint256",
            name: "tokenId"
        }
    ],
    [
        "uint256 value",
        {
            type: "uint256",
            name: "value"
        }
    ],
    // Indexed
    [
        "event:address indexed from",
        {
            type: "address",
            name: "from",
            indexed: true
        }
    ],
    [
        "event:address indexed to",
        {
            type: "address",
            name: "to",
            indexed: true
        }
    ],
    [
        "event:uint indexed tokenId",
        {
            type: "uint256",
            name: "tokenId",
            indexed: true
        }
    ],
    [
        "event:uint256 indexed tokenId",
        {
            type: "uint256",
            name: "tokenId",
            indexed: true
        }
    ]
]);

});




parcelRegister("4I1xa", function(module, exports) {

$parcel$export(module.exports, "parseAccount", () => $36dc761bdbe1f216$export$11027cbf6cf15da2);
function $36dc761bdbe1f216$export$11027cbf6cf15da2(account) {
    if (typeof account === "string") return {
        address: account,
        type: "json-rpc"
    };
    return account;
}

});

parcelRegister("9nOfC", function(module, exports) {

$parcel$export(module.exports, "multicall3Abi", () => $6d4d3dd210026146$export$4e233219477ffb48);
$parcel$export(module.exports, "universalResolverResolveAbi", () => $6d4d3dd210026146$export$400f1d40cf4f98fe);
$parcel$export(module.exports, "universalResolverReverseAbi", () => $6d4d3dd210026146$export$fd0db820daeebac9);
$parcel$export(module.exports, "textResolverAbi", () => $6d4d3dd210026146$export$4e6990b9fd834e88);
$parcel$export(module.exports, "addressResolverAbi", () => $6d4d3dd210026146$export$4c61cc2994c5d90b);
$parcel$export(module.exports, "universalSignatureValidatorAbi", () => $6d4d3dd210026146$export$b10682c3fa53fbd1);
$parcel$export(module.exports, "erc20Abi", () => $6d4d3dd210026146$export$891152826cc2370a);
/* [Multicall3](https://github.com/mds1/multicall) */ const $6d4d3dd210026146$export$4e233219477ffb48 = [
    {
        inputs: [
            {
                components: [
                    {
                        name: "target",
                        type: "address"
                    },
                    {
                        name: "allowFailure",
                        type: "bool"
                    },
                    {
                        name: "callData",
                        type: "bytes"
                    }
                ],
                name: "calls",
                type: "tuple[]"
            }
        ],
        name: "aggregate3",
        outputs: [
            {
                components: [
                    {
                        name: "success",
                        type: "bool"
                    },
                    {
                        name: "returnData",
                        type: "bytes"
                    }
                ],
                name: "returnData",
                type: "tuple[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];
const $6d4d3dd210026146$var$universalResolverErrors = [
    {
        inputs: [],
        name: "ResolverNotFound",
        type: "error"
    },
    {
        inputs: [],
        name: "ResolverWildcardNotSupported",
        type: "error"
    },
    {
        inputs: [],
        name: "ResolverNotContract",
        type: "error"
    },
    {
        inputs: [
            {
                name: "returnData",
                type: "bytes"
            }
        ],
        name: "ResolverError",
        type: "error"
    },
    {
        inputs: [
            {
                components: [
                    {
                        name: "status",
                        type: "uint16"
                    },
                    {
                        name: "message",
                        type: "string"
                    }
                ],
                name: "errors",
                type: "tuple[]"
            }
        ],
        name: "HttpError",
        type: "error"
    }
];
const $6d4d3dd210026146$export$400f1d40cf4f98fe = [
    ...$6d4d3dd210026146$var$universalResolverErrors,
    {
        name: "resolve",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes"
            },
            {
                name: "data",
                type: "bytes"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bytes"
            },
            {
                name: "address",
                type: "address"
            }
        ]
    },
    {
        name: "resolve",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes"
            },
            {
                name: "data",
                type: "bytes"
            },
            {
                name: "gateways",
                type: "string[]"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bytes"
            },
            {
                name: "address",
                type: "address"
            }
        ]
    }
];
const $6d4d3dd210026146$export$fd0db820daeebac9 = [
    ...$6d4d3dd210026146$var$universalResolverErrors,
    {
        name: "reverse",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                type: "bytes",
                name: "reverseName"
            }
        ],
        outputs: [
            {
                type: "string",
                name: "resolvedName"
            },
            {
                type: "address",
                name: "resolvedAddress"
            },
            {
                type: "address",
                name: "reverseResolver"
            },
            {
                type: "address",
                name: "resolver"
            }
        ]
    },
    {
        name: "reverse",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                type: "bytes",
                name: "reverseName"
            },
            {
                type: "string[]",
                name: "gateways"
            }
        ],
        outputs: [
            {
                type: "string",
                name: "resolvedName"
            },
            {
                type: "address",
                name: "resolvedAddress"
            },
            {
                type: "address",
                name: "reverseResolver"
            },
            {
                type: "address",
                name: "resolver"
            }
        ]
    }
];
const $6d4d3dd210026146$export$4e6990b9fd834e88 = [
    {
        name: "text",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes32"
            },
            {
                name: "key",
                type: "string"
            }
        ],
        outputs: [
            {
                name: "",
                type: "string"
            }
        ]
    }
];
const $6d4d3dd210026146$export$4c61cc2994c5d90b = [
    {
        name: "addr",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes32"
            }
        ],
        outputs: [
            {
                name: "",
                type: "address"
            }
        ]
    },
    {
        name: "addr",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "name",
                type: "bytes32"
            },
            {
                name: "coinType",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bytes"
            }
        ]
    }
];
const $6d4d3dd210026146$export$429a705aa5b352c0 = [
    {
        name: "isValidSignature",
        type: "function",
        stateMutability: "view",
        inputs: [
            {
                name: "hash",
                type: "bytes32"
            },
            {
                name: "signature",
                type: "bytes"
            }
        ],
        outputs: [
            {
                name: "",
                type: "bytes4"
            }
        ]
    }
];
const $6d4d3dd210026146$export$b10682c3fa53fbd1 = [
    {
        inputs: [
            {
                name: "_signer",
                type: "address"
            },
            {
                name: "_hash",
                type: "bytes32"
            },
            {
                name: "_signature",
                type: "bytes"
            }
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    }
];
const $6d4d3dd210026146$export$891152826cc2370a = [
    {
        type: "event",
        name: "Approval",
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ]
    },
    {
        type: "event",
        name: "Transfer",
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "allowance",
        stateMutability: "view",
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "spender",
                type: "address"
            }
        ],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "approve",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "spender",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "balanceOf",
        stateMutability: "view",
        inputs: [
            {
                name: "account",
                type: "address"
            }
        ],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "decimals",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "uint8"
            }
        ]
    },
    {
        type: "function",
        name: "name",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "symbol",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "totalSupply",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "transfer",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "transferFrom",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "sender",
                type: "address"
            },
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    }
];
const $6d4d3dd210026146$export$1c8d119bf9c799eb = [
    {
        type: "event",
        name: "Approval",
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ]
    },
    {
        type: "event",
        name: "Transfer",
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "allowance",
        stateMutability: "view",
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "spender",
                type: "address"
            }
        ],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "approve",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "spender",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "balanceOf",
        stateMutability: "view",
        inputs: [
            {
                name: "account",
                type: "address"
            }
        ],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "decimals",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "uint8"
            }
        ]
    },
    {
        type: "function",
        name: "name",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "bytes32"
            }
        ]
    },
    {
        type: "function",
        name: "symbol",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "bytes32"
            }
        ]
    },
    {
        type: "function",
        name: "totalSupply",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "transfer",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "transferFrom",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "sender",
                type: "address"
            },
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    }
];
const $6d4d3dd210026146$export$da6511eb7df6e9f8 = [
    {
        type: "event",
        name: "Approval",
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: true,
                name: "tokenId",
                type: "uint256"
            }
        ]
    },
    {
        type: "event",
        name: "ApprovalForAll",
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "operator",
                type: "address"
            },
            {
                indexed: false,
                name: "approved",
                type: "bool"
            }
        ]
    },
    {
        type: "event",
        name: "Transfer",
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: true,
                name: "tokenId",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "approve",
        stateMutability: "payable",
        inputs: [
            {
                name: "spender",
                type: "address"
            },
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: []
    },
    {
        type: "function",
        name: "balanceOf",
        stateMutability: "view",
        inputs: [
            {
                name: "account",
                type: "address"
            }
        ],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "getApproved",
        stateMutability: "view",
        inputs: [
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "address"
            }
        ]
    },
    {
        type: "function",
        name: "isApprovedForAll",
        stateMutability: "view",
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "operator",
                type: "address"
            }
        ],
        outputs: [
            {
                type: "bool"
            }
        ]
    },
    {
        type: "function",
        name: "name",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "ownerOf",
        stateMutability: "view",
        inputs: [
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "owner",
                type: "address"
            }
        ]
    },
    {
        type: "function",
        name: "safeTransferFrom",
        stateMutability: "payable",
        inputs: [
            {
                name: "from",
                type: "address"
            },
            {
                name: "to",
                type: "address"
            },
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: []
    },
    {
        type: "function",
        name: "safeTransferFrom",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "from",
                type: "address"
            },
            {
                name: "to",
                type: "address"
            },
            {
                name: "id",
                type: "uint256"
            },
            {
                name: "data",
                type: "bytes"
            }
        ],
        outputs: []
    },
    {
        type: "function",
        name: "setApprovalForAll",
        stateMutability: "nonpayable",
        inputs: [
            {
                name: "operator",
                type: "address"
            },
            {
                name: "approved",
                type: "bool"
            }
        ],
        outputs: []
    },
    {
        type: "function",
        name: "symbol",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "tokenByIndex",
        stateMutability: "view",
        inputs: [
            {
                name: "index",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "tokenByIndex",
        stateMutability: "view",
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "index",
                type: "uint256"
            }
        ],
        outputs: [
            {
                name: "tokenId",
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "tokenURI",
        stateMutability: "view",
        inputs: [
            {
                name: "tokenId",
                type: "uint256"
            }
        ],
        outputs: [
            {
                type: "string"
            }
        ]
    },
    {
        type: "function",
        name: "totalSupply",
        stateMutability: "view",
        inputs: [],
        outputs: [
            {
                type: "uint256"
            }
        ]
    },
    {
        type: "function",
        name: "transferFrom",
        stateMutability: "payable",
        inputs: [
            {
                name: "sender",
                type: "address"
            },
            {
                name: "recipient",
                type: "address"
            },
            {
                name: "tokeId",
                type: "uint256"
            }
        ],
        outputs: []
    }
];
const $6d4d3dd210026146$export$82934a3bb3a99370 = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: true,
                name: "spender",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ],
        name: "Approval",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "sender",
                type: "address"
            },
            {
                indexed: true,
                name: "receiver",
                type: "address"
            },
            {
                indexed: false,
                name: "assets",
                type: "uint256"
            },
            {
                indexed: false,
                name: "shares",
                type: "uint256"
            }
        ],
        name: "Deposit",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "from",
                type: "address"
            },
            {
                indexed: true,
                name: "to",
                type: "address"
            },
            {
                indexed: false,
                name: "value",
                type: "uint256"
            }
        ],
        name: "Transfer",
        type: "event"
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "sender",
                type: "address"
            },
            {
                indexed: true,
                name: "receiver",
                type: "address"
            },
            {
                indexed: true,
                name: "owner",
                type: "address"
            },
            {
                indexed: false,
                name: "assets",
                type: "uint256"
            },
            {
                indexed: false,
                name: "shares",
                type: "uint256"
            }
        ],
        name: "Withdraw",
        type: "event"
    },
    {
        inputs: [
            {
                name: "owner",
                type: "address"
            },
            {
                name: "spender",
                type: "address"
            }
        ],
        name: "allowance",
        outputs: [
            {
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "spender",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        name: "approve",
        outputs: [
            {
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "asset",
        outputs: [
            {
                name: "assetTokenAddress",
                type: "address"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "account",
                type: "address"
            }
        ],
        name: "balanceOf",
        outputs: [
            {
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        name: "convertToAssets",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        name: "convertToShares",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            },
            {
                name: "receiver",
                type: "address"
            }
        ],
        name: "deposit",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                name: "caller",
                type: "address"
            }
        ],
        name: "maxDeposit",
        outputs: [
            {
                name: "maxAssets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "caller",
                type: "address"
            }
        ],
        name: "maxMint",
        outputs: [
            {
                name: "maxShares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "owner",
                type: "address"
            }
        ],
        name: "maxRedeem",
        outputs: [
            {
                name: "maxShares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "owner",
                type: "address"
            }
        ],
        name: "maxWithdraw",
        outputs: [
            {
                name: "maxAssets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            },
            {
                name: "receiver",
                type: "address"
            }
        ],
        name: "mint",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        name: "previewDeposit",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        name: "previewMint",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        name: "previewRedeem",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        name: "previewWithdraw",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "shares",
                type: "uint256"
            },
            {
                name: "receiver",
                type: "address"
            },
            {
                name: "owner",
                type: "address"
            }
        ],
        name: "redeem",
        outputs: [
            {
                name: "assets",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "totalAssets",
        outputs: [
            {
                name: "totalManagedAssets",
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                type: "uint256"
            }
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                name: "to",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transfer",
        outputs: [
            {
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                name: "from",
                type: "address"
            },
            {
                name: "to",
                type: "address"
            },
            {
                name: "amount",
                type: "uint256"
            }
        ],
        name: "transferFrom",
        outputs: [
            {
                type: "bool"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [
            {
                name: "assets",
                type: "uint256"
            },
            {
                name: "receiver",
                type: "address"
            },
            {
                name: "owner",
                type: "address"
            }
        ],
        name: "withdraw",
        outputs: [
            {
                name: "shares",
                type: "uint256"
            }
        ],
        stateMutability: "nonpayable",
        type: "function"
    }
];

});

parcelRegister("S7QSb", function(module, exports) {

$parcel$export(module.exports, "aggregate3Signature", () => $0a2b227643c3b95e$export$25fd9a7ba13a8409);
const $0a2b227643c3b95e$export$25fd9a7ba13a8409 = "0x82ad56cb";

});

parcelRegister("8NbpU", function(module, exports) {

$parcel$export(module.exports, "deploylessCallViaBytecodeBytecode", () => $666bc17df8ed3e28$export$b8650f6504de1536);
$parcel$export(module.exports, "deploylessCallViaFactoryBytecode", () => $666bc17df8ed3e28$export$b03493bdbcb80605);
$parcel$export(module.exports, "universalSignatureValidatorByteCode", () => $666bc17df8ed3e28$export$76c7202cd92b9dbb);
const $666bc17df8ed3e28$export$b8650f6504de1536 = "0x608060405234801561001057600080fd5b5060405161018e38038061018e83398101604081905261002f91610124565b6000808351602085016000f59050803b61004857600080fd5b6000808351602085016000855af16040513d6000823e81610067573d81fd5b3d81f35b634e487b7160e01b600052604160045260246000fd5b600082601f83011261009257600080fd5b81516001600160401b038111156100ab576100ab61006b565b604051601f8201601f19908116603f011681016001600160401b03811182821017156100d9576100d961006b565b6040528181528382016020018510156100f157600080fd5b60005b82811015610110576020818601810151838301820152016100f4565b506000918101602001919091529392505050565b6000806040838503121561013757600080fd5b82516001600160401b0381111561014d57600080fd5b61015985828601610081565b602085015190935090506001600160401b0381111561017757600080fd5b61018385828601610081565b915050925092905056fe";
const $666bc17df8ed3e28$export$b03493bdbcb80605 = "0x608060405234801561001057600080fd5b506040516102c03803806102c083398101604081905261002f916101e6565b836001600160a01b03163b6000036100e457600080836001600160a01b03168360405161005c9190610270565b6000604051808303816000865af19150503d8060008114610099576040519150601f19603f3d011682016040523d82523d6000602084013e61009e565b606091505b50915091508115806100b857506001600160a01b0386163b155b156100e1578060405163101bb98d60e01b81526004016100d8919061028c565b60405180910390fd5b50505b6000808451602086016000885af16040513d6000823e81610103573d81fd5b3d81f35b80516001600160a01b038116811461011e57600080fd5b919050565b634e487b7160e01b600052604160045260246000fd5b60005b8381101561015457818101518382015260200161013c565b50506000910152565b600082601f83011261016e57600080fd5b81516001600160401b0381111561018757610187610123565b604051601f8201601f19908116603f011681016001600160401b03811182821017156101b5576101b5610123565b6040528181528382016020018510156101cd57600080fd5b6101de826020830160208701610139565b949350505050565b600080600080608085870312156101fc57600080fd5b61020585610107565b60208601519094506001600160401b0381111561022157600080fd5b61022d8782880161015d565b93505061023c60408601610107565b60608601519092506001600160401b0381111561025857600080fd5b6102648782880161015d565b91505092959194509250565b60008251610282818460208701610139565b9190910192915050565b60208152600082518060208401526102ab816040850160208701610139565b601f01601f1916919091016040019291505056fe";
const $666bc17df8ed3e28$export$76c7202cd92b9dbb = "0x608060405234801561001057600080fd5b5060405161069438038061069483398101604081905261002f9161051e565b600061003c848484610048565b9050806000526001601ff35b60007f64926492649264926492649264926492649264926492649264926492649264926100748361040c565b036101e7576000606080848060200190518101906100929190610577565b60405192955090935091506000906001600160a01b038516906100b69085906105dd565b6000604051808303816000865af19150503d80600081146100f3576040519150601f19603f3d011682016040523d82523d6000602084013e6100f8565b606091505b50509050876001600160a01b03163b60000361016057806101605760405162461bcd60e51b815260206004820152601e60248201527f5369676e617475726556616c696461746f723a206465706c6f796d656e74000060448201526064015b60405180910390fd5b604051630b135d3f60e11b808252906001600160a01b038a1690631626ba7e90610190908b9087906004016105f9565b602060405180830381865afa1580156101ad573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906101d19190610633565b6001600160e01b03191614945050505050610405565b6001600160a01b0384163b1561027a57604051630b135d3f60e11b808252906001600160a01b03861690631626ba7e9061022790879087906004016105f9565b602060405180830381865afa158015610244573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906102689190610633565b6001600160e01b031916149050610405565b81516041146102df5760405162461bcd60e51b815260206004820152603a602482015260008051602061067483398151915260448201527f3a20696e76616c6964207369676e6174757265206c656e6774680000000000006064820152608401610157565b6102e7610425565b5060208201516040808401518451859392600091859190811061030c5761030c61065d565b016020015160f81c9050601b811480159061032b57508060ff16601c14155b1561038c5760405162461bcd60e51b815260206004820152603b602482015260008051602061067483398151915260448201527f3a20696e76616c6964207369676e617475726520762076616c756500000000006064820152608401610157565b60408051600081526020810180835289905260ff83169181019190915260608101849052608081018390526001600160a01b0389169060019060a0016020604051602081039080840390855afa1580156103ea573d6000803e3d6000fd5b505050602060405103516001600160a01b0316149450505050505b9392505050565b600060208251101561041d57600080fd5b508051015190565b60405180606001604052806003906020820280368337509192915050565b6001600160a01b038116811461045857600080fd5b50565b634e487b7160e01b600052604160045260246000fd5b60005b8381101561048c578181015183820152602001610474565b50506000910152565b600082601f8301126104a657600080fd5b81516001600160401b038111156104bf576104bf61045b565b604051601f8201601f19908116603f011681016001600160401b03811182821017156104ed576104ed61045b565b60405281815283820160200185101561050557600080fd5b610516826020830160208701610471565b949350505050565b60008060006060848603121561053357600080fd5b835161053e81610443565b6020850151604086015191945092506001600160401b0381111561056157600080fd5b61056d86828701610495565b9150509250925092565b60008060006060848603121561058c57600080fd5b835161059781610443565b60208501519093506001600160401b038111156105b357600080fd5b6105bf86828701610495565b604086015190935090506001600160401b0381111561056157600080fd5b600082516105ef818460208701610471565b9190910192915050565b828152604060208201526000825180604084015261061e816060850160208701610471565b601f01601f1916919091016060019392505050565b60006020828403121561064557600080fd5b81516001600160e01b03198116811461040557600080fd5b634e487b7160e01b600052603260045260246000fdfe5369676e617475726556616c696461746f72237265636f7665725369676e6572";

});

parcelRegister("98Tjv", function(module, exports) {

$parcel$export(module.exports, "ChainDoesNotSupportContract", () => $6a7fc48813920786$export$f2b2bfa70417796b);
$parcel$export(module.exports, "ChainMismatchError", () => $6a7fc48813920786$export$535d82255cc17992);
$parcel$export(module.exports, "ChainNotFoundError", () => $6a7fc48813920786$export$b7f33b26fea1ae0b);
$parcel$export(module.exports, "ClientChainNotConfiguredError", () => $6a7fc48813920786$export$64807f0e18658482);
$parcel$export(module.exports, "InvalidChainIdError", () => $6a7fc48813920786$export$4836eb835ffca5b2);

var $6F8ii = parcelRequire("6F8ii");
class $6a7fc48813920786$export$f2b2bfa70417796b extends (0, $6F8ii.BaseError) {
    constructor({ blockNumber: blockNumber, chain: chain, contract: contract }){
        super(`Chain "${chain.name}" does not support contract "${contract.name}".`, {
            metaMessages: [
                "This could be due to any of the following:",
                ...blockNumber && contract.blockCreated && contract.blockCreated > blockNumber ? [
                    `- The contract "${contract.name}" was not deployed until block ${contract.blockCreated} (current block ${blockNumber}).`
                ] : [
                    `- The chain does not have the contract "${contract.name}" configured.`
                ]
            ],
            name: "ChainDoesNotSupportContract"
        });
    }
}
class $6a7fc48813920786$export$535d82255cc17992 extends (0, $6F8ii.BaseError) {
    constructor({ chain: chain, currentChainId: currentChainId }){
        super(`The current chain of the wallet (id: ${currentChainId}) does not match the target chain for the transaction (id: ${chain.id} \u{2013} ${chain.name}).`, {
            metaMessages: [
                `Current Chain ID:  ${currentChainId}`,
                `Expected Chain ID: ${chain.id} \u{2013} ${chain.name}`
            ],
            name: "ChainMismatchError"
        });
    }
}
class $6a7fc48813920786$export$b7f33b26fea1ae0b extends (0, $6F8ii.BaseError) {
    constructor(){
        super([
            "No chain was provided to the request.",
            "Please provide a chain with the `chain` argument on the Action, or by supplying a `chain` to WalletClient."
        ].join("\n"), {
            name: "ChainNotFoundError"
        });
    }
}
class $6a7fc48813920786$export$64807f0e18658482 extends (0, $6F8ii.BaseError) {
    constructor(){
        super("No chain was provided to the Client.", {
            name: "ClientChainNotConfiguredError"
        });
    }
}
class $6a7fc48813920786$export$4836eb835ffca5b2 extends (0, $6F8ii.BaseError) {
    constructor({ chainId: chainId }){
        super(typeof chainId === "number" ? `Chain ID "${chainId}" is invalid.` : "Chain ID is invalid.", {
            name: "InvalidChainIdError"
        });
    }
}

});

parcelRegister("9dX4d", function(module, exports) {

$parcel$export(module.exports, "CallExecutionError", () => $6b73256f7f6fe236$export$e67b04e2cd29b7d);
$parcel$export(module.exports, "ContractFunctionExecutionError", () => $6b73256f7f6fe236$export$399e62fddbe24423);
$parcel$export(module.exports, "ContractFunctionRevertedError", () => $6b73256f7f6fe236$export$b3a6b9663001535f);
$parcel$export(module.exports, "ContractFunctionZeroDataError", () => $6b73256f7f6fe236$export$46f5208cdcd5a621);
$parcel$export(module.exports, "CounterfactualDeploymentFailedError", () => $6b73256f7f6fe236$export$4fec38f081e68d02);
$parcel$export(module.exports, "RawContractError", () => $6b73256f7f6fe236$export$5b877bc4d7d9d460);

var $4I1xa = parcelRequire("4I1xa");

var $6o2KQ = parcelRequire("6o2KQ");

var $juM8X = parcelRequire("juM8X");

var $dDQ3R = parcelRequire("dDQ3R");

var $bBjO9 = parcelRequire("bBjO9");

var $lPlQ2 = parcelRequire("lPlQ2");

var $1zkdv = parcelRequire("1zkdv");

var $7CqAp = parcelRequire("7CqAp");

var $3TFRi = parcelRequire("3TFRi");

var $6F8ii = parcelRequire("6F8ii");

var $4D6Ze = parcelRequire("4D6Ze");

var $8ceqR = parcelRequire("8ceqR");

var $b6a64 = parcelRequire("b6a64");
class $6b73256f7f6fe236$export$e67b04e2cd29b7d extends (0, $6F8ii.BaseError) {
    constructor(cause, { account: account_, docsPath: docsPath, chain: chain, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value, stateOverride: stateOverride }){
        const account = account_ ? (0, $4I1xa.parseAccount)(account_) : undefined;
        let prettyArgs = (0, $8ceqR.prettyPrint)({
            from: account?.address,
            to: to,
            value: typeof value !== "undefined" && `${(0, $1zkdv.formatEther)(value)} ${chain?.nativeCurrency?.symbol || "ETH"}`,
            data: data,
            gas: gas,
            gasPrice: typeof gasPrice !== "undefined" && `${(0, $7CqAp.formatGwei)(gasPrice)} gwei`,
            maxFeePerGas: typeof maxFeePerGas !== "undefined" && `${(0, $7CqAp.formatGwei)(maxFeePerGas)} gwei`,
            maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== "undefined" && `${(0, $7CqAp.formatGwei)(maxPriorityFeePerGas)} gwei`,
            nonce: nonce
        });
        if (stateOverride) prettyArgs += `\n${(0, $4D6Ze.prettyStateOverride)(stateOverride)}`;
        super(cause.shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: [
                ...cause.metaMessages ? [
                    ...cause.metaMessages,
                    " "
                ] : [],
                "Raw Call Arguments:",
                prettyArgs
            ].filter(Boolean),
            name: "CallExecutionError"
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.cause = cause;
    }
}
class $6b73256f7f6fe236$export$399e62fddbe24423 extends (0, $6F8ii.BaseError) {
    constructor(cause, { abi: abi, args: args, contractAddress: contractAddress, docsPath: docsPath, functionName: functionName, sender: sender }){
        const abiItem = (0, $lPlQ2.getAbiItem)({
            abi: abi,
            args: args,
            name: functionName
        });
        const formattedArgs = abiItem ? (0, $bBjO9.formatAbiItemWithArgs)({
            abiItem: abiItem,
            args: args,
            includeFunctionName: false,
            includeName: false
        }) : undefined;
        const functionWithParams = abiItem ? (0, $dDQ3R.formatAbiItem)(abiItem, {
            includeName: true
        }) : undefined;
        const prettyArgs = (0, $8ceqR.prettyPrint)({
            address: contractAddress && (0, $b6a64.getContractAddress)(contractAddress),
            function: functionWithParams,
            args: formattedArgs && formattedArgs !== "()" && `${[
                ...Array(functionName?.length ?? 0).keys()
            ].map(()=>" ").join("")}${formattedArgs}`,
            sender: sender
        });
        super(cause.shortMessage || `An unknown error occurred while executing the contract function "${functionName}".`, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: [
                ...cause.metaMessages ? [
                    ...cause.metaMessages,
                    " "
                ] : [],
                prettyArgs && "Contract Call:",
                prettyArgs
            ].filter(Boolean),
            name: "ContractFunctionExecutionError"
        });
        Object.defineProperty(this, "abi", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "args", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "contractAddress", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "formattedArgs", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "functionName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sender", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.abi = abi;
        this.args = args;
        this.cause = cause;
        this.contractAddress = contractAddress;
        this.functionName = functionName;
        this.sender = sender;
    }
}
class $6b73256f7f6fe236$export$b3a6b9663001535f extends (0, $6F8ii.BaseError) {
    constructor({ abi: abi, data: data, functionName: functionName, message: message }){
        let cause;
        let decodedData = undefined;
        let metaMessages;
        let reason;
        if (data && data !== "0x") try {
            decodedData = (0, $juM8X.decodeErrorResult)({
                abi: abi,
                data: data
            });
            const { abiItem: abiItem, errorName: errorName, args: errorArgs } = decodedData;
            if (errorName === "Error") reason = errorArgs[0];
            else if (errorName === "Panic") {
                const [firstArg] = errorArgs;
                reason = (0, $6o2KQ.panicReasons)[firstArg];
            } else {
                const errorWithParams = abiItem ? (0, $dDQ3R.formatAbiItem)(abiItem, {
                    includeName: true
                }) : undefined;
                const formattedArgs = abiItem && errorArgs ? (0, $bBjO9.formatAbiItemWithArgs)({
                    abiItem: abiItem,
                    args: errorArgs,
                    includeFunctionName: false,
                    includeName: false
                }) : undefined;
                metaMessages = [
                    errorWithParams ? `Error: ${errorWithParams}` : "",
                    formattedArgs && formattedArgs !== "()" ? `       ${[
                        ...Array(errorName?.length ?? 0).keys()
                    ].map(()=>" ").join("")}${formattedArgs}` : ""
                ];
            }
        } catch (err) {
            cause = err;
        }
        else if (message) reason = message;
        let signature;
        if (cause instanceof (0, $3TFRi.AbiErrorSignatureNotFoundError)) {
            signature = cause.signature;
            metaMessages = [
                `Unable to decode signature "${signature}" as it was not found on the provided ABI.`,
                "Make sure you are using the correct ABI and that the error exists on it.",
                `You can look up the decoded signature here: https://openchain.xyz/signatures?query=${signature}.`
            ];
        }
        super(reason && reason !== "execution reverted" || signature ? [
            `The contract function "${functionName}" reverted with the following ${signature ? "signature" : "reason"}:`,
            reason || signature
        ].join("\n") : `The contract function "${functionName}" reverted.`, {
            cause: cause,
            metaMessages: metaMessages,
            name: "ContractFunctionRevertedError"
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "reason", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "signature", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = decodedData;
        this.reason = reason;
        this.signature = signature;
    }
}
class $6b73256f7f6fe236$export$46f5208cdcd5a621 extends (0, $6F8ii.BaseError) {
    constructor({ functionName: functionName }){
        super(`The contract function "${functionName}" returned no data ("0x").`, {
            metaMessages: [
                "This could be due to any of the following:",
                `  - The contract does not have the function "${functionName}",`,
                "  - The parameters passed to the contract function may be invalid, or",
                "  - The address is not a contract."
            ],
            name: "ContractFunctionZeroDataError"
        });
    }
}
class $6b73256f7f6fe236$export$4fec38f081e68d02 extends (0, $6F8ii.BaseError) {
    constructor({ factory: factory }){
        super(`Deployment for counterfactual contract call failed${factory ? ` for factory "${factory}".` : ""}`, {
            metaMessages: [
                "Please ensure:",
                "- The `factory` is a valid contract deployment factory (ie. Create2 Factory, ERC-4337 Factory, etc).",
                "- The `factoryData` is a valid encoded function call for contract deployment function on the factory."
            ],
            name: "CounterfactualDeploymentFailedError"
        });
    }
}
class $6b73256f7f6fe236$export$5b877bc4d7d9d460 extends (0, $6F8ii.BaseError) {
    constructor({ data: data, message: message }){
        super(message || "", {
            name: "RawContractError"
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 3
        });
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = data;
    }
}

});
parcelRegister("bBjO9", function(module, exports) {

$parcel$export(module.exports, "formatAbiItemWithArgs", () => $872283da015d0309$export$5266ec2b0e3e9205);

var $lOTY7 = parcelRequire("lOTY7");
function $872283da015d0309$export$5266ec2b0e3e9205({ abiItem: abiItem, args: args, includeFunctionName: includeFunctionName = true, includeName: includeName = false }) {
    if (!("name" in abiItem)) return;
    if (!("inputs" in abiItem)) return;
    if (!abiItem.inputs) return;
    return `${includeFunctionName ? abiItem.name : ""}(${abiItem.inputs.map((input, i)=>`${includeName && input.name ? `${input.name}: ` : ""}${typeof args[i] === "object" ? (0, $lOTY7.stringify)(args[i]) : args[i]}`).join(", ")})`;
}

});

parcelRegister("lPlQ2", function(module, exports) {

$parcel$export(module.exports, "getAbiItem", () => $fe3f4d0774ad2fd0$export$99b134cd177e9574);

var $3TFRi = parcelRequire("3TFRi");

var $j6NiR = parcelRequire("j6NiR");

var $4rOic = parcelRequire("4rOic");

var $gvzyN = parcelRequire("gvzyN");

var $4WVnB = parcelRequire("4WVnB");
function $fe3f4d0774ad2fd0$export$99b134cd177e9574(parameters) {
    const { abi: abi, args: args = [], name: name } = parameters;
    const isSelector = (0, $j6NiR.isHex)(name, {
        strict: false
    });
    const abiItems = abi.filter((abiItem)=>{
        if (isSelector) {
            if (abiItem.type === "function") return (0, $4WVnB.toFunctionSelector)(abiItem) === name;
            if (abiItem.type === "event") return (0, $gvzyN.toEventSelector)(abiItem) === name;
            return false;
        }
        return "name" in abiItem && abiItem.name === name;
    });
    if (abiItems.length === 0) return undefined;
    if (abiItems.length === 1) return abiItems[0];
    let matchedAbiItem = undefined;
    for (const abiItem of abiItems){
        if (!("inputs" in abiItem)) continue;
        if (!args || args.length === 0) {
            if (!abiItem.inputs || abiItem.inputs.length === 0) return abiItem;
            continue;
        }
        if (!abiItem.inputs) continue;
        if (abiItem.inputs.length === 0) continue;
        if (abiItem.inputs.length !== args.length) continue;
        const matched = args.every((arg, index)=>{
            const abiParameter = "inputs" in abiItem && abiItem.inputs[index];
            if (!abiParameter) return false;
            return $fe3f4d0774ad2fd0$export$697eff86d182a8c1(arg, abiParameter);
        });
        if (matched) {
            // Check for ambiguity against already matched parameters (e.g. `address` vs `bytes20`).
            if (matchedAbiItem && "inputs" in matchedAbiItem && matchedAbiItem.inputs) {
                const ambiguousTypes = $fe3f4d0774ad2fd0$export$79fd08820d2778aa(abiItem.inputs, matchedAbiItem.inputs, args);
                if (ambiguousTypes) throw new (0, $3TFRi.AbiItemAmbiguityError)({
                    abiItem: abiItem,
                    type: ambiguousTypes[0]
                }, {
                    abiItem: matchedAbiItem,
                    type: ambiguousTypes[1]
                });
            }
            matchedAbiItem = abiItem;
        }
    }
    if (matchedAbiItem) return matchedAbiItem;
    return abiItems[0];
}
function $fe3f4d0774ad2fd0$export$697eff86d182a8c1(arg, abiParameter) {
    const argType = typeof arg;
    const abiParameterType = abiParameter.type;
    switch(abiParameterType){
        case "address":
            return (0, $4rOic.isAddress)(arg, {
                strict: false
            });
        case "bool":
            return argType === "boolean";
        case "function":
            return argType === "string";
        case "string":
            return argType === "string";
        default:
            if (abiParameterType === "tuple" && "components" in abiParameter) return Object.values(abiParameter.components).every((component, index)=>{
                return $fe3f4d0774ad2fd0$export$697eff86d182a8c1(Object.values(arg)[index], component);
            });
            // `(u)int<M>`: (un)signed integer type of `M` bits, `0 < M <= 256`, `M % 8 == 0`
            // https://regexr.com/6v8hp
            if (/^u?int(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/.test(abiParameterType)) return argType === "number" || argType === "bigint";
            // `bytes<M>`: binary type of `M` bytes, `0 < M <= 32`
            // https://regexr.com/6va55
            if (/^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/.test(abiParameterType)) return argType === "string" || arg instanceof Uint8Array;
            // fixed-length (`<type>[M]`) and dynamic (`<type>[]`) arrays
            // https://regexr.com/6va6i
            if (/[a-z]+[1-9]{0,3}(\[[0-9]{0,}\])+$/.test(abiParameterType)) return Array.isArray(arg) && arg.every((x)=>$fe3f4d0774ad2fd0$export$697eff86d182a8c1(x, {
                    ...abiParameter,
                    // Pop off `[]` or `[M]` from end of type
                    type: abiParameterType.replace(/(\[[0-9]{0,}\])$/, "")
                }));
            return false;
    }
}
function $fe3f4d0774ad2fd0$export$79fd08820d2778aa(sourceParameters, targetParameters, args) {
    for(const parameterIndex in sourceParameters){
        const sourceParameter = sourceParameters[parameterIndex];
        const targetParameter = targetParameters[parameterIndex];
        if (sourceParameter.type === "tuple" && targetParameter.type === "tuple" && "components" in sourceParameter && "components" in targetParameter) return $fe3f4d0774ad2fd0$export$79fd08820d2778aa(sourceParameter.components, targetParameter.components, args[parameterIndex]);
        const types = [
            sourceParameter.type,
            targetParameter.type
        ];
        const ambiguous = (()=>{
            if (types.includes("address") && types.includes("bytes20")) return true;
            if (types.includes("address") && types.includes("string")) return (0, $4rOic.isAddress)(args[parameterIndex], {
                strict: false
            });
            if (types.includes("address") && types.includes("bytes")) return (0, $4rOic.isAddress)(args[parameterIndex], {
                strict: false
            });
            return false;
        })();
        if (ambiguous) return types;
    }
    return;
}

});
parcelRegister("gvzyN", function(module, exports) {

$parcel$export(module.exports, "toEventSelector", () => $c04b201b89c5e2e6$export$351f40ec61b2972);

var $4wYDE = parcelRequire("4wYDE");
const $c04b201b89c5e2e6$export$351f40ec61b2972 = (0, $4wYDE.toSignatureHash);

});


parcelRegister("1zkdv", function(module, exports) {

$parcel$export(module.exports, "formatEther", () => $1248bdf78b447e19$export$11bc63b4c03ea518);

var $2IOoR = parcelRequire("2IOoR");

var $2HKZh = parcelRequire("2HKZh");
function $1248bdf78b447e19$export$11bc63b4c03ea518(wei, unit = "wei") {
    return (0, $2HKZh.formatUnits)(wei, (0, $2IOoR.etherUnits)[unit]);
}

});
parcelRegister("2IOoR", function(module, exports) {

$parcel$export(module.exports, "etherUnits", () => $1fb6c93d768da2ee$export$5bbd813111ed9646);
$parcel$export(module.exports, "gweiUnits", () => $1fb6c93d768da2ee$export$a26120bf8be88528);
$parcel$export(module.exports, "weiUnits", () => $1fb6c93d768da2ee$export$b959b3594ea07183);
const $1fb6c93d768da2ee$export$5bbd813111ed9646 = {
    gwei: 9,
    wei: 18
};
const $1fb6c93d768da2ee$export$a26120bf8be88528 = {
    ether: -9,
    wei: 9
};
const $1fb6c93d768da2ee$export$b959b3594ea07183 = {
    ether: -18,
    gwei: -9
};

});

parcelRegister("2HKZh", function(module, exports) {

$parcel$export(module.exports, "formatUnits", () => $1f840b9de524403c$export$bd39b96f71da1885);
/**
 *  Divides a number by a given exponent of base 10 (10exponent), and formats it into a string representation of the number..
 *
 * - Docs: https://viem.sh/docs/utilities/formatUnits
 *
 * @example
 * import { formatUnits } from 'viem'
 *
 * formatUnits(420000000000n, 9)
 * // '420'
 */ function $1f840b9de524403c$export$bd39b96f71da1885(value, decimals) {
    let display = value.toString();
    const negative = display.startsWith("-");
    if (negative) display = display.slice(1);
    display = display.padStart(decimals, "0");
    let [integer, fraction] = [
        display.slice(0, display.length - decimals),
        display.slice(display.length - decimals)
    ];
    fraction = fraction.replace(/(0+)$/, "");
    return `${negative ? "-" : ""}${integer || "0"}${fraction ? `.${fraction}` : ""}`;
}

});


parcelRegister("7CqAp", function(module, exports) {

$parcel$export(module.exports, "formatGwei", () => $58c0b4824dd37985$export$a716d64a7f646b61);

var $2IOoR = parcelRequire("2IOoR");

var $2HKZh = parcelRequire("2HKZh");
function $58c0b4824dd37985$export$a716d64a7f646b61(wei, unit = "wei") {
    return (0, $2HKZh.formatUnits)(wei, (0, $2IOoR.gweiUnits)[unit]);
}

});

parcelRegister("4D6Ze", function(module, exports) {

$parcel$export(module.exports, "AccountStateConflictError", () => $35f03950d0bebc39$export$eb92af66de2d34c1);
$parcel$export(module.exports, "StateAssignmentConflictError", () => $35f03950d0bebc39$export$3f829f5a43fdcc2e);
$parcel$export(module.exports, "prettyStateOverride", () => $35f03950d0bebc39$export$d08c47f9c4a87c67);

var $6F8ii = parcelRequire("6F8ii");
class $35f03950d0bebc39$export$eb92af66de2d34c1 extends (0, $6F8ii.BaseError) {
    constructor({ address: address }){
        super(`State for account "${address}" is set multiple times.`, {
            name: "AccountStateConflictError"
        });
    }
}
class $35f03950d0bebc39$export$3f829f5a43fdcc2e extends (0, $6F8ii.BaseError) {
    constructor(){
        super("state and stateDiff are set on the same account.", {
            name: "StateAssignmentConflictError"
        });
    }
}
function $35f03950d0bebc39$export$4afb15becff191ad(stateMapping) {
    return stateMapping.reduce((pretty, { slot: slot, value: value })=>{
        return `${pretty}        ${slot}: ${value}\n`;
    }, "");
}
function $35f03950d0bebc39$export$d08c47f9c4a87c67(stateOverride) {
    return stateOverride.reduce((pretty, { address: address, ...state })=>{
        let val = `${pretty}    ${address}:\n`;
        if (state.nonce) val += `      nonce: ${state.nonce}\n`;
        if (state.balance) val += `      balance: ${state.balance}\n`;
        if (state.code) val += `      code: ${state.code}\n`;
        if (state.state) {
            val += "      state:\n";
            val += $35f03950d0bebc39$export$4afb15becff191ad(state.state);
        }
        if (state.stateDiff) {
            val += "      stateDiff:\n";
            val += $35f03950d0bebc39$export$4afb15becff191ad(state.stateDiff);
        }
        return val;
    }, "  State Override:\n").slice(0, -1);
}

});

parcelRegister("8ceqR", function(module, exports) {

$parcel$export(module.exports, "prettyPrint", () => $5f7aa3a585ebaf7f$export$cde3d1388a9feac3);
$parcel$export(module.exports, "FeeConflictError", () => $5f7aa3a585ebaf7f$export$4e13f9693b10724d);
$parcel$export(module.exports, "InvalidLegacyVError", () => $5f7aa3a585ebaf7f$export$8ffce3f13fa2ade4);
$parcel$export(module.exports, "InvalidSerializableTransactionError", () => $5f7aa3a585ebaf7f$export$f2282ba9c8899971);
$parcel$export(module.exports, "InvalidStorageKeySizeError", () => $5f7aa3a585ebaf7f$export$f5e370fd7cd91580);
$parcel$export(module.exports, "TransactionExecutionError", () => $5f7aa3a585ebaf7f$export$17fc407b5aeb1e96);
$parcel$export(module.exports, "TransactionNotFoundError", () => $5f7aa3a585ebaf7f$export$23c42bc218867b7c);
$parcel$export(module.exports, "TransactionReceiptNotFoundError", () => $5f7aa3a585ebaf7f$export$df65591684d92652);
$parcel$export(module.exports, "WaitForTransactionReceiptTimeoutError", () => $5f7aa3a585ebaf7f$export$69578a09754f4b33);

var $1zkdv = parcelRequire("1zkdv");

var $7CqAp = parcelRequire("7CqAp");

var $6F8ii = parcelRequire("6F8ii");
function $5f7aa3a585ebaf7f$export$cde3d1388a9feac3(args) {
    const entries = Object.entries(args).map(([key, value])=>{
        if (value === undefined || value === false) return null;
        return [
            key,
            value
        ];
    }).filter(Boolean);
    const maxLength = entries.reduce((acc, [key])=>Math.max(acc, key.length), 0);
    return entries.map(([key, value])=>`  ${`${key}:`.padEnd(maxLength + 1)}  ${value}`).join("\n");
}
class $5f7aa3a585ebaf7f$export$4e13f9693b10724d extends (0, $6F8ii.BaseError) {
    constructor(){
        super([
            "Cannot specify both a `gasPrice` and a `maxFeePerGas`/`maxPriorityFeePerGas`.",
            "Use `maxFeePerGas`/`maxPriorityFeePerGas` for EIP-1559 compatible networks, and `gasPrice` for others."
        ].join("\n"), {
            name: "FeeConflictError"
        });
    }
}
class $5f7aa3a585ebaf7f$export$8ffce3f13fa2ade4 extends (0, $6F8ii.BaseError) {
    constructor({ v: v }){
        super(`Invalid \`v\` value "${v}". Expected 27 or 28.`, {
            name: "InvalidLegacyVError"
        });
    }
}
class $5f7aa3a585ebaf7f$export$f2282ba9c8899971 extends (0, $6F8ii.BaseError) {
    constructor({ transaction: transaction }){
        super("Cannot infer a transaction type from provided transaction.", {
            metaMessages: [
                "Provided Transaction:",
                "{",
                $5f7aa3a585ebaf7f$export$cde3d1388a9feac3(transaction),
                "}",
                "",
                "To infer the type, either provide:",
                "- a `type` to the Transaction, or",
                "- an EIP-1559 Transaction with `maxFeePerGas`, or",
                "- an EIP-2930 Transaction with `gasPrice` & `accessList`, or",
                "- an EIP-4844 Transaction with `blobs`, `blobVersionedHashes`, `sidecars`, or",
                "- an EIP-7702 Transaction with `authorizationList`, or",
                "- a Legacy Transaction with `gasPrice`"
            ],
            name: "InvalidSerializableTransactionError"
        });
    }
}
class $5f7aa3a585ebaf7f$export$e410925d6bb07863 extends (0, $6F8ii.BaseError) {
    constructor({ serializedType: serializedType }){
        super(`Serialized transaction type "${serializedType}" is invalid.`, {
            name: "InvalidSerializedTransactionType"
        });
        Object.defineProperty(this, "serializedType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.serializedType = serializedType;
    }
}
class $5f7aa3a585ebaf7f$export$75fa267d8b74b3b9 extends (0, $6F8ii.BaseError) {
    constructor({ attributes: attributes, serializedTransaction: serializedTransaction, type: type }){
        const missing = Object.entries(attributes).map(([key, value])=>typeof value === "undefined" ? key : undefined).filter(Boolean);
        super(`Invalid serialized transaction of type "${type}" was provided.`, {
            metaMessages: [
                `Serialized Transaction: "${serializedTransaction}"`,
                missing.length > 0 ? `Missing Attributes: ${missing.join(", ")}` : ""
            ].filter(Boolean),
            name: "InvalidSerializedTransactionError"
        });
        Object.defineProperty(this, "serializedTransaction", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.serializedTransaction = serializedTransaction;
        this.type = type;
    }
}
class $5f7aa3a585ebaf7f$export$f5e370fd7cd91580 extends (0, $6F8ii.BaseError) {
    constructor({ storageKey: storageKey }){
        super(`Size for storage key "${storageKey}" is invalid. Expected 32 bytes. Got ${Math.floor((storageKey.length - 2) / 2)} bytes.`, {
            name: "InvalidStorageKeySizeError"
        });
    }
}
class $5f7aa3a585ebaf7f$export$17fc407b5aeb1e96 extends (0, $6F8ii.BaseError) {
    constructor(cause, { account: account, docsPath: docsPath, chain: chain, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value }){
        const prettyArgs = $5f7aa3a585ebaf7f$export$cde3d1388a9feac3({
            chain: chain && `${chain?.name} (id: ${chain?.id})`,
            from: account?.address,
            to: to,
            value: typeof value !== "undefined" && `${(0, $1zkdv.formatEther)(value)} ${chain?.nativeCurrency?.symbol || "ETH"}`,
            data: data,
            gas: gas,
            gasPrice: typeof gasPrice !== "undefined" && `${(0, $7CqAp.formatGwei)(gasPrice)} gwei`,
            maxFeePerGas: typeof maxFeePerGas !== "undefined" && `${(0, $7CqAp.formatGwei)(maxFeePerGas)} gwei`,
            maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== "undefined" && `${(0, $7CqAp.formatGwei)(maxPriorityFeePerGas)} gwei`,
            nonce: nonce
        });
        super(cause.shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: [
                ...cause.metaMessages ? [
                    ...cause.metaMessages,
                    " "
                ] : [],
                "Request Arguments:",
                prettyArgs
            ].filter(Boolean),
            name: "TransactionExecutionError"
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.cause = cause;
    }
}
class $5f7aa3a585ebaf7f$export$23c42bc218867b7c extends (0, $6F8ii.BaseError) {
    constructor({ blockHash: blockHash, blockNumber: blockNumber, blockTag: blockTag, hash: hash, index: index }){
        let identifier = "Transaction";
        if (blockTag && index !== undefined) identifier = `Transaction at block time "${blockTag}" at index "${index}"`;
        if (blockHash && index !== undefined) identifier = `Transaction at block hash "${blockHash}" at index "${index}"`;
        if (blockNumber && index !== undefined) identifier = `Transaction at block number "${blockNumber}" at index "${index}"`;
        if (hash) identifier = `Transaction with hash "${hash}"`;
        super(`${identifier} could not be found.`, {
            name: "TransactionNotFoundError"
        });
    }
}
class $5f7aa3a585ebaf7f$export$df65591684d92652 extends (0, $6F8ii.BaseError) {
    constructor({ hash: hash }){
        super(`Transaction receipt with hash "${hash}" could not be found. The Transaction may not be processed on a block yet.`, {
            name: "TransactionReceiptNotFoundError"
        });
    }
}
class $5f7aa3a585ebaf7f$export$69578a09754f4b33 extends (0, $6F8ii.BaseError) {
    constructor({ hash: hash }){
        super(`Timed out while waiting for transaction with hash "${hash}" to be confirmed.`, {
            name: "WaitForTransactionReceiptTimeoutError"
        });
    }
}

});


parcelRegister("ktUQf", function(module, exports) {

$parcel$export(module.exports, "decodeFunctionResult", () => $ee929ba546b5b4b4$export$3a05a90c230f925);

var $3TFRi = parcelRequire("3TFRi");

var $4VcDz = parcelRequire("4VcDz");

var $lPlQ2 = parcelRequire("lPlQ2");
const $ee929ba546b5b4b4$var$docsPath = "/docs/contract/decodeFunctionResult";
function $ee929ba546b5b4b4$export$3a05a90c230f925(parameters) {
    const { abi: abi, args: args, functionName: functionName, data: data } = parameters;
    let abiItem = abi[0];
    if (functionName) {
        const item = (0, $lPlQ2.getAbiItem)({
            abi: abi,
            args: args,
            name: functionName
        });
        if (!item) throw new (0, $3TFRi.AbiFunctionNotFoundError)(functionName, {
            docsPath: $ee929ba546b5b4b4$var$docsPath
        });
        abiItem = item;
    }
    if (abiItem.type !== "function") throw new (0, $3TFRi.AbiFunctionNotFoundError)(undefined, {
        docsPath: $ee929ba546b5b4b4$var$docsPath
    });
    if (!abiItem.outputs) throw new (0, $3TFRi.AbiFunctionOutputsNotFoundError)(abiItem.name, {
        docsPath: $ee929ba546b5b4b4$var$docsPath
    });
    const values = (0, $4VcDz.decodeAbiParameters)(abiItem.outputs, data);
    if (values && values.length > 1) return values;
    if (values && values.length === 1) return values[0];
    return undefined;
}

});

parcelRegister("k2kLE", function(module, exports) {

$parcel$export(module.exports, "encodeDeployData", () => $e9641a8eeb9bdc16$export$d7a7276006273fbd);

var $3TFRi = parcelRequire("3TFRi");

var $jCBOw = parcelRequire("jCBOw");

var $keugB = parcelRequire("keugB");
const $e9641a8eeb9bdc16$var$docsPath = "/docs/contract/encodeDeployData";
function $e9641a8eeb9bdc16$export$d7a7276006273fbd(parameters) {
    const { abi: abi, args: args, bytecode: bytecode } = parameters;
    if (!args || args.length === 0) return bytecode;
    const description = abi.find((x)=>"type" in x && x.type === "constructor");
    if (!description) throw new (0, $3TFRi.AbiConstructorNotFoundError)({
        docsPath: $e9641a8eeb9bdc16$var$docsPath
    });
    if (!("inputs" in description)) throw new (0, $3TFRi.AbiConstructorParamsNotFoundError)({
        docsPath: $e9641a8eeb9bdc16$var$docsPath
    });
    if (!description.inputs || description.inputs.length === 0) throw new (0, $3TFRi.AbiConstructorParamsNotFoundError)({
        docsPath: $e9641a8eeb9bdc16$var$docsPath
    });
    const data = (0, $keugB.encodeAbiParameters)(description.inputs, args);
    return (0, $jCBOw.concatHex)([
        bytecode,
        data
    ]);
}

});

parcelRegister("ahylX", function(module, exports) {

$parcel$export(module.exports, "encodeFunctionData", () => $77c623bd73745642$export$f4ee15df45da9f03);

var $jCBOw = parcelRequire("jCBOw");

var $keugB = parcelRequire("keugB");

var $4k2ZD = parcelRequire("4k2ZD");
function $77c623bd73745642$export$f4ee15df45da9f03(parameters) {
    const { args: args } = parameters;
    const { abi: abi, functionName: functionName } = (()=>{
        if (parameters.abi.length === 1 && parameters.functionName?.startsWith("0x")) return parameters;
        return (0, $4k2ZD.prepareEncodeFunctionData)(parameters);
    })();
    const abiItem = abi[0];
    const signature = functionName;
    const data = "inputs" in abiItem && abiItem.inputs ? (0, $keugB.encodeAbiParameters)(abiItem.inputs, args ?? []) : undefined;
    return (0, $jCBOw.concatHex)([
        signature,
        data ?? "0x"
    ]);
}

});
parcelRegister("4k2ZD", function(module, exports) {

$parcel$export(module.exports, "prepareEncodeFunctionData", () => $325b5a0d64559928$export$bb3e0a434581ff8);

var $3TFRi = parcelRequire("3TFRi");

var $4WVnB = parcelRequire("4WVnB");

var $dDQ3R = parcelRequire("dDQ3R");

var $lPlQ2 = parcelRequire("lPlQ2");
const $325b5a0d64559928$var$docsPath = "/docs/contract/encodeFunctionData";
function $325b5a0d64559928$export$bb3e0a434581ff8(parameters) {
    const { abi: abi, args: args, functionName: functionName } = parameters;
    let abiItem = abi[0];
    if (functionName) {
        const item = (0, $lPlQ2.getAbiItem)({
            abi: abi,
            args: args,
            name: functionName
        });
        if (!item) throw new (0, $3TFRi.AbiFunctionNotFoundError)(functionName, {
            docsPath: $325b5a0d64559928$var$docsPath
        });
        abiItem = item;
    }
    if (abiItem.type !== "function") throw new (0, $3TFRi.AbiFunctionNotFoundError)(undefined, {
        docsPath: $325b5a0d64559928$var$docsPath
    });
    return {
        abi: [
            abiItem
        ],
        functionName: (0, $4WVnB.toFunctionSelector)((0, $dDQ3R.formatAbiItem)(abiItem))
    };
}

});


parcelRegister("kErjY", function(module, exports) {

$parcel$export(module.exports, "getChainContractAddress", () => $f08cbc7b6b596040$export$cf4414608a078996);

var $98Tjv = parcelRequire("98Tjv");
function $f08cbc7b6b596040$export$cf4414608a078996({ blockNumber: blockNumber, chain: chain, contract: name }) {
    const contract = chain?.contracts?.[name];
    if (!contract) throw new (0, $98Tjv.ChainDoesNotSupportContract)({
        chain: chain,
        contract: {
            name: name
        }
    });
    if (blockNumber && contract.blockCreated && contract.blockCreated > blockNumber) throw new (0, $98Tjv.ChainDoesNotSupportContract)({
        blockNumber: blockNumber,
        chain: chain,
        contract: {
            name: name,
            blockCreated: contract.blockCreated
        }
    });
    return contract.address;
}

});

parcelRegister("7MtC1", function(module, exports) {

$parcel$export(module.exports, "getCallError", () => $5aa3fc800211c6e7$export$7a3a4dfb724485e1);

var $9dX4d = parcelRequire("9dX4d");

var $7hHca = parcelRequire("7hHca");

var $8X5h6 = parcelRequire("8X5h6");
function $5aa3fc800211c6e7$export$7a3a4dfb724485e1(err, { docsPath: docsPath, ...args }) {
    const cause = (()=>{
        const cause = (0, $8X5h6.getNodeError)(err, args);
        if (cause instanceof (0, $7hHca.UnknownNodeError)) return err;
        return cause;
    })();
    return new (0, $9dX4d.CallExecutionError)(cause, {
        docsPath: docsPath,
        ...args
    });
}

});
parcelRegister("7hHca", function(module, exports) {

$parcel$export(module.exports, "ExecutionRevertedError", () => $54dba0a2d1252663$export$a558573a20f90d54);
$parcel$export(module.exports, "FeeCapTooHighError", () => $54dba0a2d1252663$export$63c545de2a2ec844);
$parcel$export(module.exports, "FeeCapTooLowError", () => $54dba0a2d1252663$export$dbd5936ae1758966);
$parcel$export(module.exports, "NonceTooHighError", () => $54dba0a2d1252663$export$6147426561fdc965);
$parcel$export(module.exports, "NonceTooLowError", () => $54dba0a2d1252663$export$2bb6d6395b589b3b);
$parcel$export(module.exports, "NonceMaxValueError", () => $54dba0a2d1252663$export$71cf1d500f9be262);
$parcel$export(module.exports, "InsufficientFundsError", () => $54dba0a2d1252663$export$b276096bbba16879);
$parcel$export(module.exports, "IntrinsicGasTooHighError", () => $54dba0a2d1252663$export$7ad883b4998b9615);
$parcel$export(module.exports, "IntrinsicGasTooLowError", () => $54dba0a2d1252663$export$813ccdcce0428bcf);
$parcel$export(module.exports, "TransactionTypeNotSupportedError", () => $54dba0a2d1252663$export$a20c52a8beca5c20);
$parcel$export(module.exports, "TipAboveFeeCapError", () => $54dba0a2d1252663$export$6ef9dd5e2f836046);
$parcel$export(module.exports, "UnknownNodeError", () => $54dba0a2d1252663$export$d6085363229de344);

var $7CqAp = parcelRequire("7CqAp");

var $6F8ii = parcelRequire("6F8ii");
class $54dba0a2d1252663$export$a558573a20f90d54 extends (0, $6F8ii.BaseError) {
    constructor({ cause: cause, message: message } = {}){
        const reason = message?.replace("execution reverted: ", "")?.replace("execution reverted", "");
        super(`Execution reverted ${reason ? `with reason: ${reason}` : "for an unknown reason"}.`, {
            cause: cause,
            name: "ExecutionRevertedError"
        });
    }
}
Object.defineProperty($54dba0a2d1252663$export$a558573a20f90d54, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 3
});
Object.defineProperty($54dba0a2d1252663$export$a558573a20f90d54, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /execution reverted/
});
class $54dba0a2d1252663$export$63c545de2a2ec844 extends (0, $6F8ii.BaseError) {
    constructor({ cause: cause, maxFeePerGas: maxFeePerGas } = {}){
        super(`The fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${(0, $7CqAp.formatGwei)(maxFeePerGas)} gwei` : ""}) cannot be higher than the maximum allowed value (2^256-1).`, {
            cause: cause,
            name: "FeeCapTooHighError"
        });
    }
}
Object.defineProperty($54dba0a2d1252663$export$63c545de2a2ec844, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /max fee per gas higher than 2\^256-1|fee cap higher than 2\^256-1/
});
class $54dba0a2d1252663$export$dbd5936ae1758966 extends (0, $6F8ii.BaseError) {
    constructor({ cause: cause, maxFeePerGas: maxFeePerGas } = {}){
        super(`The fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${(0, $7CqAp.formatGwei)(maxFeePerGas)}` : ""} gwei) cannot be lower than the block base fee.`, {
            cause: cause,
            name: "FeeCapTooLowError"
        });
    }
}
Object.defineProperty($54dba0a2d1252663$export$dbd5936ae1758966, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /max fee per gas less than block base fee|fee cap less than block base fee|transaction is outdated/
});
class $54dba0a2d1252663$export$6147426561fdc965 extends (0, $6F8ii.BaseError) {
    constructor({ cause: cause, nonce: nonce } = {}){
        super(`Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ""}is higher than the next one expected.`, {
            cause: cause,
            name: "NonceTooHighError"
        });
    }
}
Object.defineProperty($54dba0a2d1252663$export$6147426561fdc965, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /nonce too high/
});
class $54dba0a2d1252663$export$2bb6d6395b589b3b extends (0, $6F8ii.BaseError) {
    constructor({ cause: cause, nonce: nonce } = {}){
        super([
            `Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ""}is lower than the current nonce of the account.`,
            "Try increasing the nonce or find the latest nonce with `getTransactionCount`."
        ].join("\n"), {
            cause: cause,
            name: "NonceTooLowError"
        });
    }
}
Object.defineProperty($54dba0a2d1252663$export$2bb6d6395b589b3b, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /nonce too low|transaction already imported|already known/
});
class $54dba0a2d1252663$export$71cf1d500f9be262 extends (0, $6F8ii.BaseError) {
    constructor({ cause: cause, nonce: nonce } = {}){
        super(`Nonce provided for the transaction ${nonce ? `(${nonce}) ` : ""}exceeds the maximum allowed nonce.`, {
            cause: cause,
            name: "NonceMaxValueError"
        });
    }
}
Object.defineProperty($54dba0a2d1252663$export$71cf1d500f9be262, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /nonce has max value/
});
class $54dba0a2d1252663$export$b276096bbba16879 extends (0, $6F8ii.BaseError) {
    constructor({ cause: cause } = {}){
        super([
            "The total cost (gas * gas fee + value) of executing this transaction exceeds the balance of the account."
        ].join("\n"), {
            cause: cause,
            metaMessages: [
                "This error could arise when the account does not have enough funds to:",
                " - pay for the total gas fee,",
                " - pay for the value to send.",
                " ",
                "The cost of the transaction is calculated as `gas * gas fee + value`, where:",
                " - `gas` is the amount of gas needed for transaction to execute,",
                " - `gas fee` is the gas fee,",
                " - `value` is the amount of ether to send to the recipient."
            ],
            name: "InsufficientFundsError"
        });
    }
}
Object.defineProperty($54dba0a2d1252663$export$b276096bbba16879, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /insufficient funds/
});
class $54dba0a2d1252663$export$7ad883b4998b9615 extends (0, $6F8ii.BaseError) {
    constructor({ cause: cause, gas: gas } = {}){
        super(`The amount of gas ${gas ? `(${gas}) ` : ""}provided for the transaction exceeds the limit allowed for the block.`, {
            cause: cause,
            name: "IntrinsicGasTooHighError"
        });
    }
}
Object.defineProperty($54dba0a2d1252663$export$7ad883b4998b9615, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /intrinsic gas too high|gas limit reached/
});
class $54dba0a2d1252663$export$813ccdcce0428bcf extends (0, $6F8ii.BaseError) {
    constructor({ cause: cause, gas: gas } = {}){
        super(`The amount of gas ${gas ? `(${gas}) ` : ""}provided for the transaction is too low.`, {
            cause: cause,
            name: "IntrinsicGasTooLowError"
        });
    }
}
Object.defineProperty($54dba0a2d1252663$export$813ccdcce0428bcf, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /intrinsic gas too low/
});
class $54dba0a2d1252663$export$a20c52a8beca5c20 extends (0, $6F8ii.BaseError) {
    constructor({ cause: cause }){
        super("The transaction type is not supported for this chain.", {
            cause: cause,
            name: "TransactionTypeNotSupportedError"
        });
    }
}
Object.defineProperty($54dba0a2d1252663$export$a20c52a8beca5c20, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /transaction type not valid/
});
class $54dba0a2d1252663$export$6ef9dd5e2f836046 extends (0, $6F8ii.BaseError) {
    constructor({ cause: cause, maxPriorityFeePerGas: maxPriorityFeePerGas, maxFeePerGas: maxFeePerGas } = {}){
        super([
            `The provided tip (\`maxPriorityFeePerGas\`${maxPriorityFeePerGas ? ` = ${(0, $7CqAp.formatGwei)(maxPriorityFeePerGas)} gwei` : ""}) cannot be higher than the fee cap (\`maxFeePerGas\`${maxFeePerGas ? ` = ${(0, $7CqAp.formatGwei)(maxFeePerGas)} gwei` : ""}).`
        ].join("\n"), {
            cause: cause,
            name: "TipAboveFeeCapError"
        });
    }
}
Object.defineProperty($54dba0a2d1252663$export$6ef9dd5e2f836046, "nodeMessage", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: /max priority fee per gas higher than max fee per gas|tip higher than fee cap/
});
class $54dba0a2d1252663$export$d6085363229de344 extends (0, $6F8ii.BaseError) {
    constructor({ cause: cause }){
        super(`An error occurred while executing: ${cause?.shortMessage}`, {
            cause: cause,
            name: "UnknownNodeError"
        });
    }
}

});

parcelRegister("8X5h6", function(module, exports) {

$parcel$export(module.exports, "getNodeError", () => $6847ece811ab41e2$export$218ee3a1c831c34e);

var $6F8ii = parcelRequire("6F8ii");

var $7hHca = parcelRequire("7hHca");

var $h1EgD = parcelRequire("h1EgD");

var $k7R6B = parcelRequire("k7R6B");
function $6847ece811ab41e2$export$620efda101db5601(err) {
    return err instanceof (0, $k7R6B.TransactionRejectedRpcError) || err instanceof (0, $k7R6B.InvalidInputRpcError) || err instanceof (0, $h1EgD.RpcRequestError) && err.code === (0, $7hHca.ExecutionRevertedError).code;
}
function $6847ece811ab41e2$export$218ee3a1c831c34e(err, args) {
    const message = (err.details || "").toLowerCase();
    const executionRevertedError = err instanceof (0, $6F8ii.BaseError) ? err.walk((e)=>e.code === (0, $7hHca.ExecutionRevertedError).code) : err;
    if (executionRevertedError instanceof (0, $6F8ii.BaseError)) return new (0, $7hHca.ExecutionRevertedError)({
        cause: err,
        message: executionRevertedError.details
    });
    if ((0, $7hHca.ExecutionRevertedError).nodeMessage.test(message)) return new (0, $7hHca.ExecutionRevertedError)({
        cause: err,
        message: err.details
    });
    if ((0, $7hHca.FeeCapTooHighError).nodeMessage.test(message)) return new (0, $7hHca.FeeCapTooHighError)({
        cause: err,
        maxFeePerGas: args?.maxFeePerGas
    });
    if ((0, $7hHca.FeeCapTooLowError).nodeMessage.test(message)) return new (0, $7hHca.FeeCapTooLowError)({
        cause: err,
        maxFeePerGas: args?.maxFeePerGas
    });
    if ((0, $7hHca.NonceTooHighError).nodeMessage.test(message)) return new (0, $7hHca.NonceTooHighError)({
        cause: err,
        nonce: args?.nonce
    });
    if ((0, $7hHca.NonceTooLowError).nodeMessage.test(message)) return new (0, $7hHca.NonceTooLowError)({
        cause: err,
        nonce: args?.nonce
    });
    if ((0, $7hHca.NonceMaxValueError).nodeMessage.test(message)) return new (0, $7hHca.NonceMaxValueError)({
        cause: err,
        nonce: args?.nonce
    });
    if ((0, $7hHca.InsufficientFundsError).nodeMessage.test(message)) return new (0, $7hHca.InsufficientFundsError)({
        cause: err
    });
    if ((0, $7hHca.IntrinsicGasTooHighError).nodeMessage.test(message)) return new (0, $7hHca.IntrinsicGasTooHighError)({
        cause: err,
        gas: args?.gas
    });
    if ((0, $7hHca.IntrinsicGasTooLowError).nodeMessage.test(message)) return new (0, $7hHca.IntrinsicGasTooLowError)({
        cause: err,
        gas: args?.gas
    });
    if ((0, $7hHca.TransactionTypeNotSupportedError).nodeMessage.test(message)) return new (0, $7hHca.TransactionTypeNotSupportedError)({
        cause: err
    });
    if ((0, $7hHca.TipAboveFeeCapError).nodeMessage.test(message)) return new (0, $7hHca.TipAboveFeeCapError)({
        cause: err,
        maxFeePerGas: args?.maxFeePerGas,
        maxPriorityFeePerGas: args?.maxPriorityFeePerGas
    });
    return new (0, $7hHca.UnknownNodeError)({
        cause: err
    });
}

});
parcelRegister("k7R6B", function(module, exports) {

$parcel$export(module.exports, "ParseRpcError", () => $ea6da7b6c90c2f09$export$aa31e6432f136746);
$parcel$export(module.exports, "InvalidRequestRpcError", () => $ea6da7b6c90c2f09$export$ff7b9f15f3eb8d4d);
$parcel$export(module.exports, "MethodNotFoundRpcError", () => $ea6da7b6c90c2f09$export$4c4044ac99c8d2d3);
$parcel$export(module.exports, "InvalidParamsRpcError", () => $ea6da7b6c90c2f09$export$c600faffd3cbd390);
$parcel$export(module.exports, "InternalRpcError", () => $ea6da7b6c90c2f09$export$4e62fafb20e19fd7);
$parcel$export(module.exports, "InvalidInputRpcError", () => $ea6da7b6c90c2f09$export$3ba2994324ab015e);
$parcel$export(module.exports, "ResourceNotFoundRpcError", () => $ea6da7b6c90c2f09$export$466772c50c6d6751);
$parcel$export(module.exports, "ResourceUnavailableRpcError", () => $ea6da7b6c90c2f09$export$270451347568a637);
$parcel$export(module.exports, "TransactionRejectedRpcError", () => $ea6da7b6c90c2f09$export$f714565c9176e28);
$parcel$export(module.exports, "MethodNotSupportedRpcError", () => $ea6da7b6c90c2f09$export$b106fe05a02d89c5);
$parcel$export(module.exports, "LimitExceededRpcError", () => $ea6da7b6c90c2f09$export$2c6f5ab73129d9d7);
$parcel$export(module.exports, "JsonRpcVersionUnsupportedError", () => $ea6da7b6c90c2f09$export$662f3764fa426a13);
$parcel$export(module.exports, "UserRejectedRequestError", () => $ea6da7b6c90c2f09$export$4af5b080d9e9e1a6);
$parcel$export(module.exports, "UnauthorizedProviderError", () => $ea6da7b6c90c2f09$export$cc1057a5779c7ffa);
$parcel$export(module.exports, "UnsupportedProviderMethodError", () => $ea6da7b6c90c2f09$export$6a557500ae315a49);
$parcel$export(module.exports, "ProviderDisconnectedError", () => $ea6da7b6c90c2f09$export$abb104bf1dd9c38b);
$parcel$export(module.exports, "ChainDisconnectedError", () => $ea6da7b6c90c2f09$export$ef186cf1cda0444);
$parcel$export(module.exports, "SwitchChainError", () => $ea6da7b6c90c2f09$export$d4ddb31968a9d366);
$parcel$export(module.exports, "UnknownRpcError", () => $ea6da7b6c90c2f09$export$bfc830e1ec76e31b);

var $6F8ii = parcelRequire("6F8ii");

var $h1EgD = parcelRequire("h1EgD");
const $ea6da7b6c90c2f09$var$unknownErrorCode = -1;
class $ea6da7b6c90c2f09$export$5460eff990f31920 extends (0, $6F8ii.BaseError) {
    constructor(cause, { code: code, docsPath: docsPath, metaMessages: metaMessages, name: name, shortMessage: shortMessage }){
        super(shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: metaMessages || cause?.metaMessages,
            name: name || "RpcError"
        });
        Object.defineProperty(this, "code", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = name || cause.name;
        this.code = cause instanceof (0, $h1EgD.RpcRequestError) ? cause.code : code ?? $ea6da7b6c90c2f09$var$unknownErrorCode;
    }
}
class $ea6da7b6c90c2f09$export$417589b978208a8f extends $ea6da7b6c90c2f09$export$5460eff990f31920 {
    constructor(cause, options){
        super(cause, options);
        Object.defineProperty(this, "data", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.data = options.data;
    }
}
class $ea6da7b6c90c2f09$export$aa31e6432f136746 extends $ea6da7b6c90c2f09$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $ea6da7b6c90c2f09$export$aa31e6432f136746.code,
            name: "ParseRpcError",
            shortMessage: "Invalid JSON was received by the server. An error occurred on the server while parsing the JSON text."
        });
    }
}
Object.defineProperty($ea6da7b6c90c2f09$export$aa31e6432f136746, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32700
});
class $ea6da7b6c90c2f09$export$ff7b9f15f3eb8d4d extends $ea6da7b6c90c2f09$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $ea6da7b6c90c2f09$export$ff7b9f15f3eb8d4d.code,
            name: "InvalidRequestRpcError",
            shortMessage: "JSON is not a valid request object."
        });
    }
}
Object.defineProperty($ea6da7b6c90c2f09$export$ff7b9f15f3eb8d4d, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32600
});
class $ea6da7b6c90c2f09$export$4c4044ac99c8d2d3 extends $ea6da7b6c90c2f09$export$5460eff990f31920 {
    constructor(cause, { method: method } = {}){
        super(cause, {
            code: $ea6da7b6c90c2f09$export$4c4044ac99c8d2d3.code,
            name: "MethodNotFoundRpcError",
            shortMessage: `The method${method ? ` "${method}"` : ""} does not exist / is not available.`
        });
    }
}
Object.defineProperty($ea6da7b6c90c2f09$export$4c4044ac99c8d2d3, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32601
});
class $ea6da7b6c90c2f09$export$c600faffd3cbd390 extends $ea6da7b6c90c2f09$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $ea6da7b6c90c2f09$export$c600faffd3cbd390.code,
            name: "InvalidParamsRpcError",
            shortMessage: [
                "Invalid parameters were provided to the RPC method.",
                "Double check you have provided the correct parameters."
            ].join("\n")
        });
    }
}
Object.defineProperty($ea6da7b6c90c2f09$export$c600faffd3cbd390, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32602
});
class $ea6da7b6c90c2f09$export$4e62fafb20e19fd7 extends $ea6da7b6c90c2f09$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $ea6da7b6c90c2f09$export$4e62fafb20e19fd7.code,
            name: "InternalRpcError",
            shortMessage: "An internal error was received."
        });
    }
}
Object.defineProperty($ea6da7b6c90c2f09$export$4e62fafb20e19fd7, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32603
});
class $ea6da7b6c90c2f09$export$3ba2994324ab015e extends $ea6da7b6c90c2f09$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $ea6da7b6c90c2f09$export$3ba2994324ab015e.code,
            name: "InvalidInputRpcError",
            shortMessage: [
                "Missing or invalid parameters.",
                "Double check you have provided the correct parameters."
            ].join("\n")
        });
    }
}
Object.defineProperty($ea6da7b6c90c2f09$export$3ba2994324ab015e, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32000
});
class $ea6da7b6c90c2f09$export$466772c50c6d6751 extends $ea6da7b6c90c2f09$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $ea6da7b6c90c2f09$export$466772c50c6d6751.code,
            name: "ResourceNotFoundRpcError",
            shortMessage: "Requested resource not found."
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ResourceNotFoundRpcError"
        });
    }
}
Object.defineProperty($ea6da7b6c90c2f09$export$466772c50c6d6751, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32001
});
class $ea6da7b6c90c2f09$export$270451347568a637 extends $ea6da7b6c90c2f09$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $ea6da7b6c90c2f09$export$270451347568a637.code,
            name: "ResourceUnavailableRpcError",
            shortMessage: "Requested resource not available."
        });
    }
}
Object.defineProperty($ea6da7b6c90c2f09$export$270451347568a637, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32002
});
class $ea6da7b6c90c2f09$export$f714565c9176e28 extends $ea6da7b6c90c2f09$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $ea6da7b6c90c2f09$export$f714565c9176e28.code,
            name: "TransactionRejectedRpcError",
            shortMessage: "Transaction creation failed."
        });
    }
}
Object.defineProperty($ea6da7b6c90c2f09$export$f714565c9176e28, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32003
});
class $ea6da7b6c90c2f09$export$b106fe05a02d89c5 extends $ea6da7b6c90c2f09$export$5460eff990f31920 {
    constructor(cause, { method: method } = {}){
        super(cause, {
            code: $ea6da7b6c90c2f09$export$b106fe05a02d89c5.code,
            name: "MethodNotSupportedRpcError",
            shortMessage: `Method${method ? ` "${method}"` : ""} is not implemented.`
        });
    }
}
Object.defineProperty($ea6da7b6c90c2f09$export$b106fe05a02d89c5, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32004
});
class $ea6da7b6c90c2f09$export$2c6f5ab73129d9d7 extends $ea6da7b6c90c2f09$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $ea6da7b6c90c2f09$export$2c6f5ab73129d9d7.code,
            name: "LimitExceededRpcError",
            shortMessage: "Request exceeds defined limit."
        });
    }
}
Object.defineProperty($ea6da7b6c90c2f09$export$2c6f5ab73129d9d7, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32005
});
class $ea6da7b6c90c2f09$export$662f3764fa426a13 extends $ea6da7b6c90c2f09$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            code: $ea6da7b6c90c2f09$export$662f3764fa426a13.code,
            name: "JsonRpcVersionUnsupportedError",
            shortMessage: "Version of JSON-RPC protocol is not supported."
        });
    }
}
Object.defineProperty($ea6da7b6c90c2f09$export$662f3764fa426a13, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: -32006
});
class $ea6da7b6c90c2f09$export$4af5b080d9e9e1a6 extends $ea6da7b6c90c2f09$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $ea6da7b6c90c2f09$export$4af5b080d9e9e1a6.code,
            name: "UserRejectedRequestError",
            shortMessage: "User rejected the request."
        });
    }
}
Object.defineProperty($ea6da7b6c90c2f09$export$4af5b080d9e9e1a6, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4001
});
class $ea6da7b6c90c2f09$export$cc1057a5779c7ffa extends $ea6da7b6c90c2f09$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $ea6da7b6c90c2f09$export$cc1057a5779c7ffa.code,
            name: "UnauthorizedProviderError",
            shortMessage: "The requested method and/or account has not been authorized by the user."
        });
    }
}
Object.defineProperty($ea6da7b6c90c2f09$export$cc1057a5779c7ffa, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4100
});
class $ea6da7b6c90c2f09$export$6a557500ae315a49 extends $ea6da7b6c90c2f09$export$417589b978208a8f {
    constructor(cause, { method: method } = {}){
        super(cause, {
            code: $ea6da7b6c90c2f09$export$6a557500ae315a49.code,
            name: "UnsupportedProviderMethodError",
            shortMessage: `The Provider does not support the requested method${method ? ` " ${method}"` : ""}.`
        });
    }
}
Object.defineProperty($ea6da7b6c90c2f09$export$6a557500ae315a49, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4200
});
class $ea6da7b6c90c2f09$export$abb104bf1dd9c38b extends $ea6da7b6c90c2f09$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $ea6da7b6c90c2f09$export$abb104bf1dd9c38b.code,
            name: "ProviderDisconnectedError",
            shortMessage: "The Provider is disconnected from all chains."
        });
    }
}
Object.defineProperty($ea6da7b6c90c2f09$export$abb104bf1dd9c38b, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4900
});
class $ea6da7b6c90c2f09$export$ef186cf1cda0444 extends $ea6da7b6c90c2f09$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $ea6da7b6c90c2f09$export$ef186cf1cda0444.code,
            name: "ChainDisconnectedError",
            shortMessage: "The Provider is not connected to the requested chain."
        });
    }
}
Object.defineProperty($ea6da7b6c90c2f09$export$ef186cf1cda0444, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4901
});
class $ea6da7b6c90c2f09$export$d4ddb31968a9d366 extends $ea6da7b6c90c2f09$export$417589b978208a8f {
    constructor(cause){
        super(cause, {
            code: $ea6da7b6c90c2f09$export$d4ddb31968a9d366.code,
            name: "SwitchChainError",
            shortMessage: "An error occurred when attempting to switch chain."
        });
    }
}
Object.defineProperty($ea6da7b6c90c2f09$export$d4ddb31968a9d366, "code", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: 4902
});
class $ea6da7b6c90c2f09$export$bfc830e1ec76e31b extends $ea6da7b6c90c2f09$export$5460eff990f31920 {
    constructor(cause){
        super(cause, {
            name: "UnknownRpcError",
            shortMessage: "An unknown RPC error occurred."
        });
    }
}

});



parcelRegister("cdCOv", function(module, exports) {

$parcel$export(module.exports, "extract", () => $8e54ce83da4df442$export$f9380c9a627682d3);
/**
 * @description Picks out the keys from `value` that exist in the formatter..
 */ function $8e54ce83da4df442$export$f9380c9a627682d3(value_, { format: format }) {
    if (!format) return {};
    const value = {};
    function extract_(formatted) {
        const keys = Object.keys(formatted);
        for (const key of keys){
            if (key in value_) value[key] = value_[key];
            if (formatted[key] && typeof formatted[key] === "object" && !Array.isArray(formatted[key])) extract_(formatted[key]);
        }
    }
    const formatted = format(value_ || {});
    extract_(formatted);
    return value;
}

});

parcelRegister("dT7D8", function(module, exports) {

$parcel$export(module.exports, "formatTransactionRequest", () => $a1c654a33a3d5e18$export$d23fcba447c86a8e);

var $9UP4H = parcelRequire("9UP4H");

var $fKtZJ = parcelRequire("fKtZJ");
const $a1c654a33a3d5e18$export$b2a848539dcbb25f = {
    legacy: "0x0",
    eip2930: "0x1",
    eip1559: "0x2",
    eip4844: "0x3",
    eip7702: "0x4"
};
function $a1c654a33a3d5e18$export$d23fcba447c86a8e(request) {
    const rpcRequest = {};
    if (typeof request.authorizationList !== "undefined") rpcRequest.authorizationList = $a1c654a33a3d5e18$var$formatAuthorizationList(request.authorizationList);
    if (typeof request.accessList !== "undefined") rpcRequest.accessList = request.accessList;
    if (typeof request.blobVersionedHashes !== "undefined") rpcRequest.blobVersionedHashes = request.blobVersionedHashes;
    if (typeof request.blobs !== "undefined") {
        if (typeof request.blobs[0] !== "string") rpcRequest.blobs = request.blobs.map((x)=>(0, $9UP4H.bytesToHex)(x));
        else rpcRequest.blobs = request.blobs;
    }
    if (typeof request.data !== "undefined") rpcRequest.data = request.data;
    if (typeof request.from !== "undefined") rpcRequest.from = request.from;
    if (typeof request.gas !== "undefined") rpcRequest.gas = (0, $9UP4H.numberToHex)(request.gas);
    if (typeof request.gasPrice !== "undefined") rpcRequest.gasPrice = (0, $9UP4H.numberToHex)(request.gasPrice);
    if (typeof request.maxFeePerBlobGas !== "undefined") rpcRequest.maxFeePerBlobGas = (0, $9UP4H.numberToHex)(request.maxFeePerBlobGas);
    if (typeof request.maxFeePerGas !== "undefined") rpcRequest.maxFeePerGas = (0, $9UP4H.numberToHex)(request.maxFeePerGas);
    if (typeof request.maxPriorityFeePerGas !== "undefined") rpcRequest.maxPriorityFeePerGas = (0, $9UP4H.numberToHex)(request.maxPriorityFeePerGas);
    if (typeof request.nonce !== "undefined") rpcRequest.nonce = (0, $9UP4H.numberToHex)(request.nonce);
    if (typeof request.to !== "undefined") rpcRequest.to = request.to;
    if (typeof request.type !== "undefined") rpcRequest.type = $a1c654a33a3d5e18$export$b2a848539dcbb25f[request.type];
    if (typeof request.value !== "undefined") rpcRequest.value = (0, $9UP4H.numberToHex)(request.value);
    return rpcRequest;
}
const $a1c654a33a3d5e18$export$aba208618cee26e3 = /*#__PURE__*/ (0, $fKtZJ.defineFormatter)("transactionRequest", $a1c654a33a3d5e18$export$d23fcba447c86a8e);
//////////////////////////////////////////////////////////////////////////////
function $a1c654a33a3d5e18$var$formatAuthorizationList(authorizationList) {
    return authorizationList.map((authorization)=>({
            address: authorization.contractAddress,
            r: authorization.r,
            s: authorization.s,
            chainId: (0, $9UP4H.numberToHex)(authorization.chainId),
            nonce: (0, $9UP4H.numberToHex)(authorization.nonce),
            ...typeof authorization.yParity !== "undefined" ? {
                yParity: (0, $9UP4H.numberToHex)(authorization.yParity)
            } : {},
            ...typeof authorization.v !== "undefined" && typeof authorization.yParity === "undefined" ? {
                v: (0, $9UP4H.numberToHex)(authorization.v)
            } : {}
        }));
}

});
parcelRegister("fKtZJ", function(module, exports) {

$parcel$export(module.exports, "defineFormatter", () => $b7726b386e4819bd$export$5d08535cc975931a);
function $b7726b386e4819bd$export$5d08535cc975931a(type, format) {
    return ({ exclude: exclude, format: overrides })=>{
        return {
            exclude: exclude,
            format: (args)=>{
                const formatted = format(args);
                if (exclude) for (const key of exclude)delete formatted[key];
                return {
                    ...formatted,
                    ...overrides(args)
                };
            },
            type: type
        };
    };
}

});


parcelRegister("5ruIR", function(module, exports) {

$parcel$export(module.exports, "createBatchScheduler", () => $3f674e377f85640d$export$24d3fde68b7c4167);
const $3f674e377f85640d$var$schedulerCache = /*#__PURE__*/ new Map();
function $3f674e377f85640d$export$24d3fde68b7c4167({ fn: fn, id: id, shouldSplitBatch: shouldSplitBatch, wait: wait = 0, sort: sort }) {
    const exec = async ()=>{
        const scheduler = getScheduler();
        flush();
        const args = scheduler.map(({ args: args })=>args);
        if (args.length === 0) return;
        fn(args).then((data)=>{
            if (sort && Array.isArray(data)) data.sort(sort);
            for(let i = 0; i < scheduler.length; i++){
                const { pendingPromise: pendingPromise } = scheduler[i];
                pendingPromise.resolve?.([
                    data[i],
                    data
                ]);
            }
        }).catch((err)=>{
            for(let i = 0; i < scheduler.length; i++){
                const { pendingPromise: pendingPromise } = scheduler[i];
                pendingPromise.reject?.(err);
            }
        });
    };
    const flush = ()=>$3f674e377f85640d$var$schedulerCache.delete(id);
    const getBatchedArgs = ()=>getScheduler().map(({ args: args })=>args);
    const getScheduler = ()=>$3f674e377f85640d$var$schedulerCache.get(id) || [];
    const setScheduler = (item)=>$3f674e377f85640d$var$schedulerCache.set(id, [
            ...getScheduler(),
            item
        ]);
    return {
        flush: flush,
        async schedule (args) {
            const pendingPromise = {};
            const promise = new Promise((resolve, reject)=>{
                pendingPromise.resolve = resolve;
                pendingPromise.reject = reject;
            });
            const split = shouldSplitBatch?.([
                ...getBatchedArgs(),
                args
            ]);
            if (split) exec();
            const hasActiveScheduler = getScheduler().length > 0;
            if (hasActiveScheduler) {
                setScheduler({
                    args: args,
                    pendingPromise: pendingPromise
                });
                return promise;
            }
            setScheduler({
                args: args,
                pendingPromise: pendingPromise
            });
            setTimeout(exec, wait);
            return promise;
        }
    };
}

});

parcelRegister("5XFM1", function(module, exports) {

$parcel$export(module.exports, "serializeStateOverride", () => $4572ddcaf5b55c3e$export$f6da3c954eb711d6);

var $8j5HI = parcelRequire("8j5HI");

var $eyBMJ = parcelRequire("eyBMJ");

var $4D6Ze = parcelRequire("4D6Ze");

var $4rOic = parcelRequire("4rOic");

var $9UP4H = parcelRequire("9UP4H");
function $4572ddcaf5b55c3e$export$29e73cd11b306a76(stateMapping) {
    if (!stateMapping || stateMapping.length === 0) return undefined;
    return stateMapping.reduce((acc, { slot: slot, value: value })=>{
        if (slot.length !== 66) throw new (0, $eyBMJ.InvalidBytesLengthError)({
            size: slot.length,
            targetSize: 66,
            type: "hex"
        });
        if (value.length !== 66) throw new (0, $eyBMJ.InvalidBytesLengthError)({
            size: value.length,
            targetSize: 66,
            type: "hex"
        });
        acc[slot] = value;
        return acc;
    }, {});
}
function $4572ddcaf5b55c3e$export$ff6c86decd3de345(parameters) {
    const { balance: balance, nonce: nonce, state: state, stateDiff: stateDiff, code: code } = parameters;
    const rpcAccountStateOverride = {};
    if (code !== undefined) rpcAccountStateOverride.code = code;
    if (balance !== undefined) rpcAccountStateOverride.balance = (0, $9UP4H.numberToHex)(balance);
    if (nonce !== undefined) rpcAccountStateOverride.nonce = (0, $9UP4H.numberToHex)(nonce);
    if (state !== undefined) rpcAccountStateOverride.state = $4572ddcaf5b55c3e$export$29e73cd11b306a76(state);
    if (stateDiff !== undefined) {
        if (rpcAccountStateOverride.state) throw new (0, $4D6Ze.StateAssignmentConflictError)();
        rpcAccountStateOverride.stateDiff = $4572ddcaf5b55c3e$export$29e73cd11b306a76(stateDiff);
    }
    return rpcAccountStateOverride;
}
function $4572ddcaf5b55c3e$export$f6da3c954eb711d6(parameters) {
    if (!parameters) return undefined;
    const rpcStateOverride = {};
    for (const { address: address, ...accountState } of parameters){
        if (!(0, $4rOic.isAddress)(address, {
            strict: false
        })) throw new (0, $8j5HI.InvalidAddressError)({
            address: address
        });
        if (rpcStateOverride[address]) throw new (0, $4D6Ze.AccountStateConflictError)({
            address: address
        });
        rpcStateOverride[address] = $4572ddcaf5b55c3e$export$ff6c86decd3de345(accountState);
    }
    return rpcStateOverride;
}

});

parcelRegister("dVFRY", function(module, exports) {

$parcel$export(module.exports, "assertRequest", () => $a24113a55c9602b9$export$5378021d985ceaf8);

var $4I1xa = parcelRequire("4I1xa");

var $8j5HI = parcelRequire("8j5HI");

var $7hHca = parcelRequire("7hHca");

var $8ceqR = parcelRequire("8ceqR");

var $4rOic = parcelRequire("4rOic");
function $a24113a55c9602b9$export$5378021d985ceaf8(args) {
    const { account: account_, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, to: to } = args;
    const account = account_ ? (0, $4I1xa.parseAccount)(account_) : undefined;
    if (account && !(0, $4rOic.isAddress)(account.address)) throw new (0, $8j5HI.InvalidAddressError)({
        address: account.address
    });
    if (to && !(0, $4rOic.isAddress)(to)) throw new (0, $8j5HI.InvalidAddressError)({
        address: to
    });
    if (typeof gasPrice !== "undefined" && (typeof maxFeePerGas !== "undefined" || typeof maxPriorityFeePerGas !== "undefined")) throw new (0, $8ceqR.FeeConflictError)();
    if (maxFeePerGas && maxFeePerGas > 2n ** 256n - 1n) throw new (0, $7hHca.FeeCapTooHighError)({
        maxFeePerGas: maxFeePerGas
    });
    if (maxPriorityFeePerGas && maxFeePerGas && maxPriorityFeePerGas > maxFeePerGas) throw new (0, $7hHca.TipAboveFeeCapError)({
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas
    });
}

});

parcelRegister("1E7g1", function(module, exports) {


module.exports = (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("buD0f")).then(()=>parcelRequire("bBin2"));

});
parcelRegister("dNLwc", function(module, exports) {
"use strict";

var $7lV8K = parcelRequire("7lV8K");
module.exports = $7lV8K(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("7lV8K", function(module, exports) {
"use strict";
var $55a6d16921f8ab25$var$cachedBundles = {};
var $55a6d16921f8ab25$var$cachedPreloads = {};
var $55a6d16921f8ab25$var$cachedPrefetches = {};
function $55a6d16921f8ab25$var$getCache(type) {
    switch(type){
        case "preload":
            return $55a6d16921f8ab25$var$cachedPreloads;
        case "prefetch":
            return $55a6d16921f8ab25$var$cachedPrefetches;
        default:
            return $55a6d16921f8ab25$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $55a6d16921f8ab25$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});




parcelRegister("esotS", function(module, exports) {

$parcel$export(module.exports, "proxy", () => $535e3c5b9bbde61a$export$923f96dd5afa9ce6);
$parcel$export(module.exports, "getVersion", () => $535e3c5b9bbde61a$export$c506eb22e615ba4a);
$parcel$export(module.exports, "subscribe", () => $535e3c5b9bbde61a$export$ec068583843480e7);
$parcel$export(module.exports, "snapshot", () => $535e3c5b9bbde61a$export$b8801ea43165ed7d);
$parcel$export(module.exports, "ref", () => $535e3c5b9bbde61a$export$eff4d24c3ff7876e);
$parcel$export(module.exports, "unstable_buildProxyFunction", () => $535e3c5b9bbde61a$export$e7b04d37d9502758);

var $9TztG = parcelRequire("9TztG");
var $535e3c5b9bbde61a$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/valtio/esm/vanilla.mjs"
});
const $535e3c5b9bbde61a$var$isObject = (x)=>typeof x === "object" && x !== null;
const $535e3c5b9bbde61a$var$proxyStateMap = /* @__PURE__ */ new WeakMap();
const $535e3c5b9bbde61a$var$refSet = /* @__PURE__ */ new WeakSet();
const $535e3c5b9bbde61a$var$buildProxyFunction = (objectIs = Object.is, newProxy = (target, handler)=>new Proxy(target, handler), canProxy = (x)=>$535e3c5b9bbde61a$var$isObject(x) && !$535e3c5b9bbde61a$var$refSet.has(x) && (Array.isArray(x) || !(Symbol.iterator in x)) && !(x instanceof WeakMap) && !(x instanceof WeakSet) && !(x instanceof Error) && !(x instanceof Number) && !(x instanceof Date) && !(x instanceof String) && !(x instanceof RegExp) && !(x instanceof ArrayBuffer), defaultHandlePromise = (promise)=>{
    switch(promise.status){
        case "fulfilled":
            return promise.value;
        case "rejected":
            throw promise.reason;
        default:
            throw promise;
    }
}, snapCache = /* @__PURE__ */ new WeakMap(), createSnapshot = (target, version, handlePromise = defaultHandlePromise)=>{
    const cache = snapCache.get(target);
    if ((cache == null ? void 0 : cache[0]) === version) return cache[1];
    const snap = Array.isArray(target) ? [] : Object.create(Object.getPrototypeOf(target));
    (0, $9TztG.markToTrack)(snap, true);
    snapCache.set(target, [
        version,
        snap
    ]);
    Reflect.ownKeys(target).forEach((key)=>{
        if (Object.getOwnPropertyDescriptor(snap, key)) return;
        const value = Reflect.get(target, key);
        const desc = {
            value: value,
            enumerable: true,
            // This is intentional to avoid copying with proxy-compare.
            // It's still non-writable, so it avoids assigning a value.
            configurable: true
        };
        if ($535e3c5b9bbde61a$var$refSet.has(value)) (0, $9TztG.markToTrack)(value, false);
        else if (value instanceof Promise) {
            delete desc.value;
            desc.get = ()=>handlePromise(value);
        } else if ($535e3c5b9bbde61a$var$proxyStateMap.has(value)) {
            const [target2, ensureVersion] = $535e3c5b9bbde61a$var$proxyStateMap.get(value);
            desc.value = createSnapshot(target2, ensureVersion(), handlePromise);
        }
        Object.defineProperty(snap, key, desc);
    });
    return Object.preventExtensions(snap);
}, proxyCache = /* @__PURE__ */ new WeakMap(), versionHolder = [
    1,
    1
], proxyFunction = (initialObject)=>{
    if (!$535e3c5b9bbde61a$var$isObject(initialObject)) throw new Error("object required");
    const found = proxyCache.get(initialObject);
    if (found) return found;
    let version = versionHolder[0];
    const listeners = /* @__PURE__ */ new Set();
    const notifyUpdate = (op, nextVersion = ++versionHolder[0])=>{
        if (version !== nextVersion) {
            version = nextVersion;
            listeners.forEach((listener)=>listener(op, nextVersion));
        }
    };
    let checkVersion = versionHolder[1];
    const ensureVersion = (nextCheckVersion = ++versionHolder[1])=>{
        if (checkVersion !== nextCheckVersion && !listeners.size) {
            checkVersion = nextCheckVersion;
            propProxyStates.forEach(([propProxyState])=>{
                const propVersion = propProxyState[1](nextCheckVersion);
                if (propVersion > version) version = propVersion;
            });
        }
        return version;
    };
    const createPropListener = (prop)=>(op, nextVersion)=>{
            const newOp = [
                ...op
            ];
            newOp[1] = [
                prop,
                ...newOp[1]
            ];
            notifyUpdate(newOp, nextVersion);
        };
    const propProxyStates = /* @__PURE__ */ new Map();
    const addPropListener = (prop, propProxyState)=>{
        if (($535e3c5b9bbde61a$import_meta.env ? $535e3c5b9bbde61a$import_meta.env.MODE : void 0) !== "production" && propProxyStates.has(prop)) throw new Error("prop listener already exists");
        if (listeners.size) {
            const remove = propProxyState[3](createPropListener(prop));
            propProxyStates.set(prop, [
                propProxyState,
                remove
            ]);
        } else propProxyStates.set(prop, [
            propProxyState
        ]);
    };
    const removePropListener = (prop)=>{
        var _a;
        const entry = propProxyStates.get(prop);
        if (entry) {
            propProxyStates.delete(prop);
            (_a = entry[1]) == null || _a.call(entry);
        }
    };
    const addListener = (listener)=>{
        listeners.add(listener);
        if (listeners.size === 1) propProxyStates.forEach(([propProxyState, prevRemove], prop)=>{
            if (($535e3c5b9bbde61a$import_meta.env ? $535e3c5b9bbde61a$import_meta.env.MODE : void 0) !== "production" && prevRemove) throw new Error("remove already exists");
            const remove = propProxyState[3](createPropListener(prop));
            propProxyStates.set(prop, [
                propProxyState,
                remove
            ]);
        });
        const removeListener = ()=>{
            listeners.delete(listener);
            if (listeners.size === 0) propProxyStates.forEach(([propProxyState, remove], prop)=>{
                if (remove) {
                    remove();
                    propProxyStates.set(prop, [
                        propProxyState
                    ]);
                }
            });
        };
        return removeListener;
    };
    const baseObject = Array.isArray(initialObject) ? [] : Object.create(Object.getPrototypeOf(initialObject));
    const handler = {
        deleteProperty (target, prop) {
            const prevValue = Reflect.get(target, prop);
            removePropListener(prop);
            const deleted = Reflect.deleteProperty(target, prop);
            if (deleted) notifyUpdate([
                "delete",
                [
                    prop
                ],
                prevValue
            ]);
            return deleted;
        },
        set (target, prop, value, receiver) {
            const hasPrevValue = Reflect.has(target, prop);
            const prevValue = Reflect.get(target, prop, receiver);
            if (hasPrevValue && (objectIs(prevValue, value) || proxyCache.has(value) && objectIs(prevValue, proxyCache.get(value)))) return true;
            removePropListener(prop);
            if ($535e3c5b9bbde61a$var$isObject(value)) value = (0, $9TztG.getUntracked)(value) || value;
            let nextValue = value;
            if (value instanceof Promise) value.then((v)=>{
                value.status = "fulfilled";
                value.value = v;
                notifyUpdate([
                    "resolve",
                    [
                        prop
                    ],
                    v
                ]);
            }).catch((e)=>{
                value.status = "rejected";
                value.reason = e;
                notifyUpdate([
                    "reject",
                    [
                        prop
                    ],
                    e
                ]);
            });
            else {
                if (!$535e3c5b9bbde61a$var$proxyStateMap.has(value) && canProxy(value)) nextValue = proxyFunction(value);
                const childProxyState = !$535e3c5b9bbde61a$var$refSet.has(nextValue) && $535e3c5b9bbde61a$var$proxyStateMap.get(nextValue);
                if (childProxyState) addPropListener(prop, childProxyState);
            }
            Reflect.set(target, prop, nextValue, receiver);
            notifyUpdate([
                "set",
                [
                    prop
                ],
                value,
                prevValue
            ]);
            return true;
        }
    };
    const proxyObject = newProxy(baseObject, handler);
    proxyCache.set(initialObject, proxyObject);
    const proxyState = [
        baseObject,
        ensureVersion,
        createSnapshot,
        addListener
    ];
    $535e3c5b9bbde61a$var$proxyStateMap.set(proxyObject, proxyState);
    Reflect.ownKeys(initialObject).forEach((key)=>{
        const desc = Object.getOwnPropertyDescriptor(initialObject, key);
        if ("value" in desc) {
            proxyObject[key] = initialObject[key];
            delete desc.value;
            delete desc.writable;
        }
        Object.defineProperty(baseObject, key, desc);
    });
    return proxyObject;
})=>[
        // public functions
        proxyFunction,
        // shared state
        $535e3c5b9bbde61a$var$proxyStateMap,
        $535e3c5b9bbde61a$var$refSet,
        // internal things
        objectIs,
        newProxy,
        canProxy,
        defaultHandlePromise,
        snapCache,
        createSnapshot,
        proxyCache,
        versionHolder
    ];
const [$535e3c5b9bbde61a$var$defaultProxyFunction] = $535e3c5b9bbde61a$var$buildProxyFunction();
function $535e3c5b9bbde61a$export$923f96dd5afa9ce6(initialObject = {}) {
    return $535e3c5b9bbde61a$var$defaultProxyFunction(initialObject);
}
function $535e3c5b9bbde61a$export$c506eb22e615ba4a(proxyObject) {
    const proxyState = $535e3c5b9bbde61a$var$proxyStateMap.get(proxyObject);
    return proxyState == null ? void 0 : proxyState[1]();
}
function $535e3c5b9bbde61a$export$ec068583843480e7(proxyObject, callback, notifyInSync) {
    const proxyState = $535e3c5b9bbde61a$var$proxyStateMap.get(proxyObject);
    if (($535e3c5b9bbde61a$import_meta.env ? $535e3c5b9bbde61a$import_meta.env.MODE : void 0) !== "production" && !proxyState) console.warn("Please use proxy object");
    let promise;
    const ops = [];
    const addListener = proxyState[3];
    let isListenerActive = false;
    const listener = (op)=>{
        ops.push(op);
        if (notifyInSync) {
            callback(ops.splice(0));
            return;
        }
        if (!promise) promise = Promise.resolve().then(()=>{
            promise = void 0;
            if (isListenerActive) callback(ops.splice(0));
        });
    };
    const removeListener = addListener(listener);
    isListenerActive = true;
    return ()=>{
        isListenerActive = false;
        removeListener();
    };
}
function $535e3c5b9bbde61a$export$b8801ea43165ed7d(proxyObject, handlePromise) {
    const proxyState = $535e3c5b9bbde61a$var$proxyStateMap.get(proxyObject);
    if (($535e3c5b9bbde61a$import_meta.env ? $535e3c5b9bbde61a$import_meta.env.MODE : void 0) !== "production" && !proxyState) console.warn("Please use proxy object");
    const [target, ensureVersion, createSnapshot] = proxyState;
    return createSnapshot(target, ensureVersion(), handlePromise);
}
function $535e3c5b9bbde61a$export$eff4d24c3ff7876e(obj) {
    $535e3c5b9bbde61a$var$refSet.add(obj);
    return obj;
}
const $535e3c5b9bbde61a$export$e7b04d37d9502758 = $535e3c5b9bbde61a$var$buildProxyFunction;

});
parcelRegister("9TztG", function(module, exports) {

$parcel$export(module.exports, "getUntracked", () => $7344c5457be26236$export$80d2cee7ee556e99);
$parcel$export(module.exports, "markToTrack", () => $7344c5457be26236$export$2c8383c890e26a1c);
const $7344c5457be26236$var$e = Symbol(), $7344c5457be26236$var$t = Symbol(), $7344c5457be26236$var$r = "a", $7344c5457be26236$var$n = "w";
let $7344c5457be26236$var$o = (e, t)=>new Proxy(e, t);
const $7344c5457be26236$var$s = Object.getPrototypeOf, $7344c5457be26236$var$c = new WeakMap, $7344c5457be26236$var$l = (e)=>e && ($7344c5457be26236$var$c.has(e) ? $7344c5457be26236$var$c.get(e) : $7344c5457be26236$var$s(e) === Object.prototype || $7344c5457be26236$var$s(e) === Array.prototype), $7344c5457be26236$var$f = (e)=>"object" == typeof e && null !== e, $7344c5457be26236$var$i = (e)=>{
    if (Array.isArray(e)) return Array.from(e);
    const t = Object.getOwnPropertyDescriptors(e);
    return Object.values(t).forEach((e)=>{
        e.configurable = !0;
    }), Object.create($7344c5457be26236$var$s(e), t);
}, $7344c5457be26236$var$u = (e)=>e[$7344c5457be26236$var$t] || e, $7344c5457be26236$export$7865d0c7f908de6b = (s, c, f, p)=>{
    if (!$7344c5457be26236$var$l(s)) return s;
    let g = p && p.get(s);
    if (!g) {
        const e = $7344c5457be26236$var$u(s);
        g = ((e)=>Object.values(Object.getOwnPropertyDescriptors(e)).some((e)=>!e.configurable && !e.writable))(e) ? [
            e,
            $7344c5457be26236$var$i(e)
        ] : [
            e
        ], null == p || p.set(s, g);
    }
    const [y, h] = g;
    let w = f && f.get(y);
    return w && w[1].f === !!h || (w = ((o, s)=>{
        const c = {
            f: s
        };
        let l = !1;
        const f = (e, t)=>{
            if (!l) {
                let s = c[$7344c5457be26236$var$r].get(o);
                if (s || (s = {}, c[$7344c5457be26236$var$r].set(o, s)), e === $7344c5457be26236$var$n) s[$7344c5457be26236$var$n] = !0;
                else {
                    let r = s[e];
                    r || (r = new Set, s[e] = r), r.add(t);
                }
            }
        }, i = {
            get: (e, n)=>n === $7344c5457be26236$var$t ? o : (f("k", n), $7344c5457be26236$export$7865d0c7f908de6b(Reflect.get(e, n), c[$7344c5457be26236$var$r], c.c, c.t)),
            has: (t, n)=>n === $7344c5457be26236$var$e ? (l = !0, c[$7344c5457be26236$var$r].delete(o), !0) : (f("h", n), Reflect.has(t, n)),
            getOwnPropertyDescriptor: (e, t)=>(f("o", t), Reflect.getOwnPropertyDescriptor(e, t)),
            ownKeys: (e)=>(f($7344c5457be26236$var$n), Reflect.ownKeys(e))
        };
        return s && (i.set = i.deleteProperty = ()=>!1), [
            i,
            c
        ];
    })(y, !!h), w[1].p = $7344c5457be26236$var$o(h || y, w[0]), f && f.set(y, w)), w[1][$7344c5457be26236$var$r] = c, w[1].c = f, w[1].t = p, w[1].p;
}, $7344c5457be26236$export$3a85b3f4caf02b6f = (e, t, r, o)=>{
    if (Object.is(e, t)) return !1;
    if (!$7344c5457be26236$var$f(e) || !$7344c5457be26236$var$f(t)) return !0;
    const s = r.get($7344c5457be26236$var$u(e));
    if (!s) return !0;
    if (o) {
        const r = o.get(e);
        if (r && r.n === t) return r.g;
        o.set(e, {
            n: t,
            g: !1
        });
    }
    let c = null;
    try {
        for (const r of s.h || [])if (c = Reflect.has(e, r) !== Reflect.has(t, r), c) return c;
        if (!0 === s[$7344c5457be26236$var$n]) {
            if (c = ((e, t)=>{
                const r = Reflect.ownKeys(e), n = Reflect.ownKeys(t);
                return r.length !== n.length || r.some((e, t)=>e !== n[t]);
            })(e, t), c) return c;
        } else for (const r of s.o || [])if (c = !!Reflect.getOwnPropertyDescriptor(e, r) != !!Reflect.getOwnPropertyDescriptor(t, r), c) return c;
        for (const n of s.k || [])if (c = $7344c5457be26236$export$3a85b3f4caf02b6f(e[n], t[n], r, o), c) return c;
        return null === c && (c = !0), c;
    } finally{
        o && o.set(e, {
            n: t,
            g: c
        });
    }
}, $7344c5457be26236$export$badc26589cf7bb38 = (t)=>!!$7344c5457be26236$var$l(t) && $7344c5457be26236$var$e in t, $7344c5457be26236$export$80d2cee7ee556e99 = (e)=>$7344c5457be26236$var$l(e) && e[$7344c5457be26236$var$t] || null, $7344c5457be26236$export$2c8383c890e26a1c = (e, t = !0)=>{
    $7344c5457be26236$var$c.set(e, t);
}, $7344c5457be26236$export$10e85fc10e680a16 = (e, t, r)=>{
    const o = [], s = new WeakSet, c = (e, l)=>{
        if (s.has(e)) return;
        $7344c5457be26236$var$f(e) && s.add(e);
        const i = $7344c5457be26236$var$f(e) && t.get($7344c5457be26236$var$u(e));
        if (i) {
            var a, p;
            if (null == (a = i.h) || a.forEach((e)=>{
                const t = `:has(${String(e)})`;
                o.push(l ? [
                    ...l,
                    t
                ] : [
                    t
                ]);
            }), !0 === i[$7344c5457be26236$var$n]) {
                const e = ":ownKeys";
                o.push(l ? [
                    ...l,
                    e
                ] : [
                    e
                ]);
            } else {
                var g;
                null == (g = i.o) || g.forEach((e)=>{
                    const t = `:hasOwn(${String(e)})`;
                    o.push(l ? [
                        ...l,
                        t
                    ] : [
                        t
                    ]);
                });
            }
            null == (p = i.k) || p.forEach((t)=>{
                r && !("value" in (Object.getOwnPropertyDescriptor(e, t) || {})) || c(e[t], l ? [
                    ...l,
                    t
                ] : [
                    t
                ]);
            });
        } else l && o.push(l);
    };
    return c(e), o;
}, $7344c5457be26236$export$9b4d5450dbd8e67e = (e)=>{
    $7344c5457be26236$var$o = e;
};

});


parcelRegister("N0o3H", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $0934e0939605d48c$export$a143d493d941bafc, (v) => $0934e0939605d48c$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $0934e0939605d48c$export$e4cf37d7f6fb9e0a, (v) => $0934e0939605d48c$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $0934e0939605d48c$export$f99ded8fe4b79145, (v) => $0934e0939605d48c$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $0934e0939605d48c$export$599f31c3813fae4d, (v) => $0934e0939605d48c$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $0934e0939605d48c$export$a143d493d941bafc;
var $0934e0939605d48c$export$e4cf37d7f6fb9e0a;
var $0934e0939605d48c$export$f99ded8fe4b79145;
var $0934e0939605d48c$export$599f31c3813fae4d;
"use strict";

var $bQMRt = parcelRequire("bQMRt");

var $dbnIE = parcelRequire("dbnIE");
var $0934e0939605d48c$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$0934e0939605d48c$export$a143d493d941bafc = $0934e0939605d48c$var$Buffer;
$0934e0939605d48c$export$e4cf37d7f6fb9e0a = $0934e0939605d48c$var$SlowBuffer;
$0934e0939605d48c$export$f99ded8fe4b79145 = 50;
var $0934e0939605d48c$var$K_MAX_LENGTH = 0x7fffffff;
$0934e0939605d48c$export$599f31c3813fae4d = $0934e0939605d48c$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT = $0934e0939605d48c$var$typedArraySupport();
if (!$0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $0934e0939605d48c$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $0934e0939605d48c$var$createBuffer(length) {
    if (length > $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $0934e0939605d48c$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $0934e0939605d48c$var$allocUnsafe(arg);
    }
    return $0934e0939605d48c$var$from(arg, encodingOrOffset, length);
}
$0934e0939605d48c$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $0934e0939605d48c$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $0934e0939605d48c$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $0934e0939605d48c$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($0934e0939605d48c$var$isInstance(value, ArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, ArrayBuffer)) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($0934e0939605d48c$var$isInstance(value, SharedArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, SharedArrayBuffer))) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $0934e0939605d48c$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $0934e0939605d48c$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $0934e0939605d48c$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $0934e0939605d48c$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $0934e0939605d48c$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($0934e0939605d48c$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($0934e0939605d48c$var$Buffer, Uint8Array);
function $0934e0939605d48c$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $0934e0939605d48c$var$alloc(size, fill, encoding) {
    $0934e0939605d48c$var$assertSize(size);
    if (size <= 0) return $0934e0939605d48c$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $0934e0939605d48c$var$createBuffer(size).fill(fill, encoding) : $0934e0939605d48c$var$createBuffer(size).fill(fill);
    return $0934e0939605d48c$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $0934e0939605d48c$var$Buffer.alloc = function(size, fill, encoding) {
    return $0934e0939605d48c$var$alloc(size, fill, encoding);
};
function $0934e0939605d48c$var$allocUnsafe(size) {
    $0934e0939605d48c$var$assertSize(size);
    return $0934e0939605d48c$var$createBuffer(size < 0 ? 0 : $0934e0939605d48c$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $0934e0939605d48c$var$Buffer.allocUnsafe = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $0934e0939605d48c$var$Buffer.allocUnsafeSlow = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
function $0934e0939605d48c$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $0934e0939605d48c$var$byteLength(string, encoding) | 0;
    var buf = $0934e0939605d48c$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $0934e0939605d48c$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $0934e0939605d48c$var$checked(array.length) | 0;
    var buf = $0934e0939605d48c$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $0934e0939605d48c$var$fromArrayView(arrayView) {
    if ($0934e0939605d48c$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $0934e0939605d48c$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $0934e0939605d48c$var$fromArrayLike(arrayView);
}
function $0934e0939605d48c$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
function $0934e0939605d48c$var$fromObject(obj) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(obj)) {
        var len = $0934e0939605d48c$var$checked(obj.length) | 0;
        var buf = $0934e0939605d48c$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $0934e0939605d48c$var$numberIsNaN(obj.length)) return $0934e0939605d48c$var$createBuffer(0);
        return $0934e0939605d48c$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $0934e0939605d48c$var$fromArrayLike(obj.data);
}
function $0934e0939605d48c$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $0934e0939605d48c$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $0934e0939605d48c$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $0934e0939605d48c$var$Buffer.alloc(+length);
}
$0934e0939605d48c$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $0934e0939605d48c$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$0934e0939605d48c$var$Buffer.compare = function compare(a, b) {
    if ($0934e0939605d48c$var$isInstance(a, Uint8Array)) a = $0934e0939605d48c$var$Buffer.from(a, a.offset, a.byteLength);
    if ($0934e0939605d48c$var$isInstance(b, Uint8Array)) b = $0934e0939605d48c$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(a) || !$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$0934e0939605d48c$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$0934e0939605d48c$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $0934e0939605d48c$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $0934e0939605d48c$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($0934e0939605d48c$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $0934e0939605d48c$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $0934e0939605d48c$var$byteLength(string, encoding) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $0934e0939605d48c$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $0934e0939605d48c$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $0934e0939605d48c$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $0934e0939605d48c$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$0934e0939605d48c$var$Buffer.byteLength = $0934e0939605d48c$var$byteLength;
function $0934e0939605d48c$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $0934e0939605d48c$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $0934e0939605d48c$var$utf8Slice(this, start, end);
        case "ascii":
            return $0934e0939605d48c$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $0934e0939605d48c$var$latin1Slice(this, start, end);
        case "base64":
            return $0934e0939605d48c$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $0934e0939605d48c$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$0934e0939605d48c$var$Buffer.prototype._isBuffer = true;
function $0934e0939605d48c$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$0934e0939605d48c$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$0934e0939605d48c$var$swap(this, i, i + 1);
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $0934e0939605d48c$var$swap(this, i, i + 3);
        $0934e0939605d48c$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $0934e0939605d48c$var$swap(this, i, i + 7);
        $0934e0939605d48c$var$swap(this, i + 1, i + 6);
        $0934e0939605d48c$var$swap(this, i + 2, i + 5);
        $0934e0939605d48c$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $0934e0939605d48c$var$utf8Slice(this, 0, length);
    return $0934e0939605d48c$var$slowToString.apply(this, arguments);
};
$0934e0939605d48c$var$Buffer.prototype.toLocaleString = $0934e0939605d48c$var$Buffer.prototype.toString;
$0934e0939605d48c$var$Buffer.prototype.equals = function equals(b) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $0934e0939605d48c$var$Buffer.compare(this, b) === 0;
};
$0934e0939605d48c$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $0934e0939605d48c$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($0934e0939605d48c$var$customInspectSymbol) $0934e0939605d48c$var$Buffer.prototype[$0934e0939605d48c$var$customInspectSymbol] = $0934e0939605d48c$var$Buffer.prototype.inspect;
$0934e0939605d48c$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($0934e0939605d48c$var$isInstance(target, Uint8Array)) target = $0934e0939605d48c$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $0934e0939605d48c$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($0934e0939605d48c$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $0934e0939605d48c$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($0934e0939605d48c$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $0934e0939605d48c$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $0934e0939605d48c$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $0934e0939605d48c$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$0934e0939605d48c$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$0934e0939605d48c$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$0934e0939605d48c$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $0934e0939605d48c$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($0934e0939605d48c$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $0934e0939605d48c$var$utf8Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $0934e0939605d48c$var$asciiWrite(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$asciiToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$base64Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$base64ToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$ucs2Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$0934e0939605d48c$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $0934e0939605d48c$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $0934e0939605d48c$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $0934e0939605d48c$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $0934e0939605d48c$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $0934e0939605d48c$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$0934e0939605d48c$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $0934e0939605d48c$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $bQMRt.fromByteArray(buf);
    else return $bQMRt.fromByteArray(buf.slice(start, end));
}
function $0934e0939605d48c$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $0934e0939605d48c$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $0934e0939605d48c$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $0934e0939605d48c$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $0934e0939605d48c$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $0934e0939605d48c$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $0934e0939605d48c$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $0934e0939605d48c$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$0934e0939605d48c$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $0934e0939605d48c$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $0934e0939605d48c$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$0934e0939605d48c$var$Buffer.prototype.readUintLE = $0934e0939605d48c$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUintBE = $0934e0939605d48c$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUint8 = $0934e0939605d48c$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$0934e0939605d48c$var$Buffer.prototype.readUint16LE = $0934e0939605d48c$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$0934e0939605d48c$var$Buffer.prototype.readUint16BE = $0934e0939605d48c$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$0934e0939605d48c$var$Buffer.prototype.readUint32LE = $0934e0939605d48c$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$0934e0939605d48c$var$Buffer.prototype.readUint32BE = $0934e0939605d48c$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$0934e0939605d48c$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$0934e0939605d48c$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, true, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, false, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, true, 52, 8);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, false, 52, 8);
};
function $0934e0939605d48c$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$0934e0939605d48c$var$Buffer.prototype.writeUintLE = $0934e0939605d48c$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUintBE = $0934e0939605d48c$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint8 = $0934e0939605d48c$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $0934e0939605d48c$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $0934e0939605d48c$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$0934e0939605d48c$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, false, noAssert);
};
function $0934e0939605d48c$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$0934e0939605d48c$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$0934e0939605d48c$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $0934e0939605d48c$var$Buffer.isBuffer(val) ? val : $0934e0939605d48c$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $0934e0939605d48c$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $0934e0939605d48c$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($0934e0939605d48c$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $0934e0939605d48c$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $0934e0939605d48c$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $0934e0939605d48c$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $0934e0939605d48c$var$base64ToBytes(str) {
    return $bQMRt.toByteArray($0934e0939605d48c$var$base64clean(str));
}
function $0934e0939605d48c$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $0934e0939605d48c$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $0934e0939605d48c$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $0934e0939605d48c$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("bQMRt", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $8a0a73e6b73fd0c4$export$d622b2ad8d90c771, (v) => $8a0a73e6b73fd0c4$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $8a0a73e6b73fd0c4$export$6100ba28696e12de, (v) => $8a0a73e6b73fd0c4$export$6100ba28696e12de = v);
var $8a0a73e6b73fd0c4$export$a48f0734ac7c2329;
var $8a0a73e6b73fd0c4$export$d622b2ad8d90c771;
var $8a0a73e6b73fd0c4$export$6100ba28696e12de;
"use strict";
$8a0a73e6b73fd0c4$export$a48f0734ac7c2329 = $8a0a73e6b73fd0c4$var$byteLength;
$8a0a73e6b73fd0c4$export$d622b2ad8d90c771 = $8a0a73e6b73fd0c4$var$toByteArray;
$8a0a73e6b73fd0c4$export$6100ba28696e12de = $8a0a73e6b73fd0c4$var$fromByteArray;
var $8a0a73e6b73fd0c4$var$lookup = [];
var $8a0a73e6b73fd0c4$var$revLookup = [];
var $8a0a73e6b73fd0c4$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $8a0a73e6b73fd0c4$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $8a0a73e6b73fd0c4$var$i = 0, $8a0a73e6b73fd0c4$var$len = $8a0a73e6b73fd0c4$var$code.length; $8a0a73e6b73fd0c4$var$i < $8a0a73e6b73fd0c4$var$len; ++$8a0a73e6b73fd0c4$var$i){
    $8a0a73e6b73fd0c4$var$lookup[$8a0a73e6b73fd0c4$var$i] = $8a0a73e6b73fd0c4$var$code[$8a0a73e6b73fd0c4$var$i];
    $8a0a73e6b73fd0c4$var$revLookup[$8a0a73e6b73fd0c4$var$code.charCodeAt($8a0a73e6b73fd0c4$var$i)] = $8a0a73e6b73fd0c4$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$8a0a73e6b73fd0c4$var$revLookup["-".charCodeAt(0)] = 62;
$8a0a73e6b73fd0c4$var$revLookup["_".charCodeAt(0)] = 63;
function $8a0a73e6b73fd0c4$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $8a0a73e6b73fd0c4$var$byteLength(b64) {
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$toByteArray(b64) {
    var tmp;
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $8a0a73e6b73fd0c4$var$Arr($8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 18 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 2 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 10 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $8a0a73e6b73fd0c4$var$tripletToBase64(num) {
    return $8a0a73e6b73fd0c4$var$lookup[num >> 18 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 12 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 6 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num & 0x3F];
}
function $8a0a73e6b73fd0c4$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($8a0a73e6b73fd0c4$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $8a0a73e6b73fd0c4$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($8a0a73e6b73fd0c4$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 2] + $8a0a73e6b73fd0c4$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 10] + $8a0a73e6b73fd0c4$var$lookup[tmp >> 4 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("dbnIE", function(module, exports) {

$parcel$export(module.exports, "read", () => $998eb38f4d082829$export$aafa59e2e03f2942, (v) => $998eb38f4d082829$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $998eb38f4d082829$export$68d8715fc104d294, (v) => $998eb38f4d082829$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $998eb38f4d082829$export$aafa59e2e03f2942;
var $998eb38f4d082829$export$68d8715fc104d294;
$998eb38f4d082829$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$998eb38f4d082829$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("6eqhe", function(module, exports) {

$parcel$export(module.exports, "initializeTheming", () => (parcelRequire("9rwwE")).initializeTheming);
$parcel$export(module.exports, "setColorTheme", () => (parcelRequire("9rwwE")).setColorTheme);
$parcel$export(module.exports, "setThemeVariables", () => (parcelRequire("9rwwE")).setThemeVariables);
$parcel$export(module.exports, "UiHelperUtil", () => (parcelRequire("97bbL")).UiHelperUtil);
$parcel$export(module.exports, "TransactionUtil", () => (parcelRequire("gC2QS")).TransactionUtil);
$parcel$export(module.exports, "customElement", () => (parcelRequire("lkv4o")).customElement);

var $95Gkb = parcelRequire("95Gkb");

var $cvzvT = parcelRequire("cvzvT");

var $1fjkg = parcelRequire("1fjkg");

var $lW8Rn = parcelRequire("lW8Rn");

var $kc4Vb = parcelRequire("kc4Vb");

var $aA5kT = parcelRequire("aA5kT");

var $9Riks = parcelRequire("9Riks");

var $eFeuH = parcelRequire("eFeuH");

var $alLF6 = parcelRequire("alLF6");

var $8pDtD = parcelRequire("8pDtD");

var $lx9aw = parcelRequire("lx9aw");

var $1RCf2 = parcelRequire("1RCf2");

var $e7V2r = parcelRequire("e7V2r");

var $5NqEI = parcelRequire("5NqEI");

var $kz6v2 = parcelRequire("kz6v2");

var $8lfFP = parcelRequire("8lfFP");

var $5CmHN = parcelRequire("5CmHN");

var $1jnbi = parcelRequire("1jnbi");

var $77RDu = parcelRequire("77RDu");

var $e4QeF = parcelRequire("e4QeF");

var $9jMiu = parcelRequire("9jMiu");

var $i1zzT = parcelRequire("i1zzT");

var $wd6Nb = parcelRequire("wd6Nb");

var $rIBsQ = parcelRequire("rIBsQ");

var $jNQoR = parcelRequire("jNQoR");

var $3qytO = parcelRequire("3qytO");

var $blSJ1 = parcelRequire("blSJ1");

var $8oS2R = parcelRequire("8oS2R");

var $iYJ6v = parcelRequire("iYJ6v");

var $4bXjU = parcelRequire("4bXjU");

var $3jLql = parcelRequire("3jLql");

var $5UCXI = parcelRequire("5UCXI");

var $4jyh8 = parcelRequire("4jyh8");

var $5wY7t = parcelRequire("5wY7t");

var $d4fxd = parcelRequire("d4fxd");

var $7lEhr = parcelRequire("7lEhr");

var $iPyoG = parcelRequire("iPyoG");

var $cNmV9 = parcelRequire("cNmV9");

var $1ChWu = parcelRequire("1ChWu");

var $geQ3d = parcelRequire("geQ3d");

var $PzzG3 = parcelRequire("PzzG3");

var $azlul = parcelRequire("azlul");

var $fSvVa = parcelRequire("fSvVa");

var $lKtNz = parcelRequire("lKtNz");

var $cOnD5 = parcelRequire("cOnD5");

var $aPqUh = parcelRequire("aPqUh");

var $kZT6j = parcelRequire("kZT6j");

var $6yRhv = parcelRequire("6yRhv");

var $eWt5E = parcelRequire("eWt5E");

var $c5ila = parcelRequire("c5ila");

var $aiZ8J = parcelRequire("aiZ8J");

var $6NsWa = parcelRequire("6NsWa");

var $e9yjw = parcelRequire("e9yjw");

var $9rwwE = parcelRequire("9rwwE");

var $97bbL = parcelRequire("97bbL");

var $gC2QS = parcelRequire("gC2QS");

var $lkv4o = parcelRequire("lkv4o");
$parcel$exportWildcard(module.exports, $95Gkb);
$parcel$exportWildcard(module.exports, $cvzvT);
$parcel$exportWildcard(module.exports, $1fjkg);
$parcel$exportWildcard(module.exports, $lW8Rn);
$parcel$exportWildcard(module.exports, $kc4Vb);
$parcel$exportWildcard(module.exports, $aA5kT);
$parcel$exportWildcard(module.exports, $9Riks);
$parcel$exportWildcard(module.exports, $eFeuH);
$parcel$exportWildcard(module.exports, $alLF6);
$parcel$exportWildcard(module.exports, $8pDtD);
$parcel$exportWildcard(module.exports, $lx9aw);
$parcel$exportWildcard(module.exports, $1RCf2);
$parcel$exportWildcard(module.exports, $e7V2r);
$parcel$exportWildcard(module.exports, $5NqEI);
$parcel$exportWildcard(module.exports, $kz6v2);
$parcel$exportWildcard(module.exports, $8lfFP);
$parcel$exportWildcard(module.exports, $5CmHN);
$parcel$exportWildcard(module.exports, $1jnbi);
$parcel$exportWildcard(module.exports, $77RDu);
$parcel$exportWildcard(module.exports, $e4QeF);
$parcel$exportWildcard(module.exports, $9jMiu);
$parcel$exportWildcard(module.exports, $i1zzT);
$parcel$exportWildcard(module.exports, $wd6Nb);
$parcel$exportWildcard(module.exports, $rIBsQ);
$parcel$exportWildcard(module.exports, $jNQoR);
$parcel$exportWildcard(module.exports, $3qytO);
$parcel$exportWildcard(module.exports, $blSJ1);
$parcel$exportWildcard(module.exports, $8oS2R);
$parcel$exportWildcard(module.exports, $iYJ6v);
$parcel$exportWildcard(module.exports, $4bXjU);
$parcel$exportWildcard(module.exports, $3jLql);
$parcel$exportWildcard(module.exports, $5UCXI);
$parcel$exportWildcard(module.exports, $4jyh8);
$parcel$exportWildcard(module.exports, $5wY7t);
$parcel$exportWildcard(module.exports, $d4fxd);
$parcel$exportWildcard(module.exports, $7lEhr);
$parcel$exportWildcard(module.exports, $iPyoG);
$parcel$exportWildcard(module.exports, $cNmV9);
$parcel$exportWildcard(module.exports, $1ChWu);
$parcel$exportWildcard(module.exports, $geQ3d);
$parcel$exportWildcard(module.exports, $PzzG3);
$parcel$exportWildcard(module.exports, $azlul);
$parcel$exportWildcard(module.exports, $fSvVa);
$parcel$exportWildcard(module.exports, $lKtNz);
$parcel$exportWildcard(module.exports, $cOnD5);
$parcel$exportWildcard(module.exports, $aPqUh);
$parcel$exportWildcard(module.exports, $kZT6j);
$parcel$exportWildcard(module.exports, $6yRhv);
$parcel$exportWildcard(module.exports, $eWt5E);
$parcel$exportWildcard(module.exports, $c5ila);
$parcel$exportWildcard(module.exports, $aiZ8J);
$parcel$exportWildcard(module.exports, $6NsWa);
$parcel$exportWildcard(module.exports, $e9yjw);

});
parcelRegister("95Gkb", function(module, exports) {

$parcel$export(module.exports, "WuiCard", () => $69e56972071395eb$export$9de547c596d443f7);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");

var $fG57h = parcelRequire("fG57h");
var $69e56972071395eb$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $69e56972071395eb$export$9de547c596d443f7 = class WuiCard extends (0, $3KB8N.LitElement) {
    render() {
        return (0, $i7GIz.html)`<slot></slot>`;
    }
};
$69e56972071395eb$export$9de547c596d443f7.styles = [
    (0, $9rwwE.resetStyles),
    (0, $fG57h.default)
];
$69e56972071395eb$export$9de547c596d443f7 = $69e56972071395eb$var$__decorate([
    (0, $lkv4o.customElement)("wui-card")
], $69e56972071395eb$export$9de547c596d443f7);

});
parcelRegister("9xfz6", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("aPsWt")).css);
$parcel$export(module.exports, "html", () => (parcelRequire("i7GIz")).html);
$parcel$export(module.exports, "LitElement", () => (parcelRequire("3KB8N")).LitElement);
$parcel$export(module.exports, "svg", () => (parcelRequire("i7GIz")).svg);
$parcel$export(module.exports, "unsafeCSS", () => (parcelRequire("aPsWt")).unsafeCSS);
parcelRequire("3SvFt");
parcelRequire("i7GIz");
parcelRequire("3KB8N");
parcelRequire("5XLmv");

});
parcelRegister("3SvFt", function(module, exports) {

$parcel$export(module.exports, "defaultConverter", () => $2d2efad0c75a8980$export$7312b35fbf521afb);
$parcel$export(module.exports, "notEqual", () => $2d2efad0c75a8980$export$53a6892c50694894);
$parcel$export(module.exports, "ReactiveElement", () => $2d2efad0c75a8980$export$c7c07a37856565d);
$parcel$export(module.exports, "css", () => (parcelRequire("aPsWt")).css);
$parcel$export(module.exports, "unsafeCSS", () => (parcelRequire("aPsWt")).unsafeCSS);

var $aPsWt = parcelRequire("aPsWt");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $2d2efad0c75a8980$var$i, defineProperty: $2d2efad0c75a8980$var$e, getOwnPropertyDescriptor: $2d2efad0c75a8980$var$r, getOwnPropertyNames: $2d2efad0c75a8980$var$h, getOwnPropertySymbols: $2d2efad0c75a8980$var$o, getPrototypeOf: $2d2efad0c75a8980$var$n } = Object, $2d2efad0c75a8980$var$a = globalThis, $2d2efad0c75a8980$var$c = $2d2efad0c75a8980$var$a.trustedTypes, $2d2efad0c75a8980$var$l = $2d2efad0c75a8980$var$c ? $2d2efad0c75a8980$var$c.emptyScript : "", $2d2efad0c75a8980$var$p = $2d2efad0c75a8980$var$a.reactiveElementPolyfillSupport, $2d2efad0c75a8980$var$d = (t, s)=>t, $2d2efad0c75a8980$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $2d2efad0c75a8980$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $2d2efad0c75a8980$export$53a6892c50694894 = (t, s)=>!$2d2efad0c75a8980$var$i(t, s), $2d2efad0c75a8980$var$y = {
    attribute: !0,
    type: String,
    converter: $2d2efad0c75a8980$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $2d2efad0c75a8980$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $2d2efad0c75a8980$var$a.litPropertyMetadata ??= new WeakMap;
class $2d2efad0c75a8980$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $2d2efad0c75a8980$var$y) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), r = this.getPropertyDescriptor(t, i, s);
            void 0 !== r && $2d2efad0c75a8980$var$e(this.prototype, t, r);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: h } = $2d2efad0c75a8980$var$r(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get () {
                return e?.call(this);
            },
            set (s) {
                const r = e?.call(this);
                h.call(this, s), this.requestUpdate(t, r, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $2d2efad0c75a8980$var$y;
    }
    static _$Ei() {
        if (this.hasOwnProperty($2d2efad0c75a8980$var$d("elementProperties"))) return;
        const t = $2d2efad0c75a8980$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($2d2efad0c75a8980$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($2d2efad0c75a8980$var$d("properties"))) {
            const t = this.properties, s = [
                ...$2d2efad0c75a8980$var$h(t),
                ...$2d2efad0c75a8980$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $aPsWt.getCompatibleStyle)(s));
        } else void 0 !== s && i.push((0, $aPsWt.getCompatibleStyle)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $aPsWt.adoptStyles)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$EC(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const r = (void 0 !== i.converter?.toAttribute ? i.converter : $2d2efad0c75a8980$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == r ? this.removeAttribute(e) : this.setAttribute(e, r), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), r = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $2d2efad0c75a8980$export$7312b35fbf521afb;
            this._$Em = e, this[e] = r.fromAttribute(s, t.type), this._$Em = null;
        }
    }
    requestUpdate(t, s, i) {
        if (void 0 !== t) {
            if (i ??= this.constructor.getPropertyOptions(t), !(i.hasChanged ?? $2d2efad0c75a8980$export$53a6892c50694894)(this[t], s)) return;
            this.P(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$ET());
    }
    P(t, s, i) {
        this._$AL.has(t) || this._$AL.set(t, s), !0 === i.reflect && this._$Em !== t && (this._$Ej ??= new Set).add(t);
    }
    async _$ET() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t)!0 !== i.wrapped || this._$AL.has(s) || void 0 === this[s] || this.P(s, this[s], i);
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EU();
        } catch (s) {
            throw t = !1, this._$EU(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EU() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Ej &&= this._$Ej.forEach((t)=>this._$EC(t, this[t])), this._$EU();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$2d2efad0c75a8980$export$c7c07a37856565d.elementStyles = [], $2d2efad0c75a8980$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $2d2efad0c75a8980$export$c7c07a37856565d[$2d2efad0c75a8980$var$d("elementProperties")] = new Map, $2d2efad0c75a8980$export$c7c07a37856565d[$2d2efad0c75a8980$var$d("finalized")] = new Map, $2d2efad0c75a8980$var$p?.({
    ReactiveElement: $2d2efad0c75a8980$export$c7c07a37856565d
}), ($2d2efad0c75a8980$var$a.reactiveElementVersions ??= []).push("2.0.4");

});
parcelRegister("aPsWt", function(module, exports) {

$parcel$export(module.exports, "unsafeCSS", () => $7e251e20dafa8126$export$8d80f9cac07cdb3);
$parcel$export(module.exports, "css", () => $7e251e20dafa8126$export$dbf350e5966cf602);
$parcel$export(module.exports, "adoptStyles", () => $7e251e20dafa8126$export$2ca4a66ec4cecb90);
$parcel$export(module.exports, "getCompatibleStyle", () => $7e251e20dafa8126$export$ee69dfd951e24778);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $7e251e20dafa8126$var$t = globalThis, $7e251e20dafa8126$export$b4d10f6001c083c2 = $7e251e20dafa8126$var$t.ShadowRoot && (void 0 === $7e251e20dafa8126$var$t.ShadyCSS || $7e251e20dafa8126$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $7e251e20dafa8126$var$s = Symbol(), $7e251e20dafa8126$var$o = new WeakMap;
class $7e251e20dafa8126$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $7e251e20dafa8126$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($7e251e20dafa8126$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $7e251e20dafa8126$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $7e251e20dafa8126$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $7e251e20dafa8126$export$8d80f9cac07cdb3 = (t)=>new $7e251e20dafa8126$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $7e251e20dafa8126$var$s), $7e251e20dafa8126$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $7e251e20dafa8126$export$505d1e8739bad805(o, t, $7e251e20dafa8126$var$s);
}, $7e251e20dafa8126$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($7e251e20dafa8126$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $7e251e20dafa8126$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $7e251e20dafa8126$export$ee69dfd951e24778 = $7e251e20dafa8126$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $7e251e20dafa8126$export$8d80f9cac07cdb3(e);
    })(t) : t;

});


parcelRegister("i7GIz", function(module, exports) {

$parcel$export(module.exports, "html", () => $d31a044bdb105f56$export$c0bb0b647f701bb5);
$parcel$export(module.exports, "svg", () => $d31a044bdb105f56$export$7ed1367e7fa1ad68);
$parcel$export(module.exports, "noChange", () => $d31a044bdb105f56$export$9c068ae9cc5db4e8);
$parcel$export(module.exports, "nothing", () => $d31a044bdb105f56$export$45b790e32b2810ee);
$parcel$export(module.exports, "_$LH", () => $d31a044bdb105f56$export$8613d1ca9052b22e);
$parcel$export(module.exports, "render", () => $d31a044bdb105f56$export$b3890eb0ae9dca99);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $d31a044bdb105f56$var$n = globalThis, $d31a044bdb105f56$var$c = $d31a044bdb105f56$var$n.trustedTypes, $d31a044bdb105f56$var$h = $d31a044bdb105f56$var$c ? $d31a044bdb105f56$var$c.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $d31a044bdb105f56$var$f = "$lit$", $d31a044bdb105f56$var$v = `lit$${Math.random().toFixed(9).slice(2)}$`, $d31a044bdb105f56$var$m = "?" + $d31a044bdb105f56$var$v, $d31a044bdb105f56$var$_ = `<${$d31a044bdb105f56$var$m}>`, $d31a044bdb105f56$var$w = document, $d31a044bdb105f56$var$lt = ()=>$d31a044bdb105f56$var$w.createComment(""), $d31a044bdb105f56$var$st = (t)=>null === t || "object" != typeof t && "function" != typeof t, $d31a044bdb105f56$var$g = Array.isArray, $d31a044bdb105f56$var$$ = (t)=>$d31a044bdb105f56$var$g(t) || "function" == typeof t?.[Symbol.iterator], $d31a044bdb105f56$var$x = "[ 	\n\f\r]", $d31a044bdb105f56$var$T = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $d31a044bdb105f56$var$E = /-->/g, $d31a044bdb105f56$var$k = />/g, $d31a044bdb105f56$var$O = RegExp(`>|${$d31a044bdb105f56$var$x}(?:([^\\s"'>=/]+)(${$d31a044bdb105f56$var$x}*=${$d31a044bdb105f56$var$x}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $d31a044bdb105f56$var$S = /'/g, $d31a044bdb105f56$var$j = /"/g, $d31a044bdb105f56$var$M = /^(?:script|style|textarea|title)$/i, $d31a044bdb105f56$var$P = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $d31a044bdb105f56$export$c0bb0b647f701bb5 = $d31a044bdb105f56$var$P(1), $d31a044bdb105f56$export$7ed1367e7fa1ad68 = $d31a044bdb105f56$var$P(2), $d31a044bdb105f56$export$47d5b44d225be5b4 = $d31a044bdb105f56$var$P(3), $d31a044bdb105f56$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $d31a044bdb105f56$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $d31a044bdb105f56$var$V = new WeakMap, $d31a044bdb105f56$var$I = $d31a044bdb105f56$var$w.createTreeWalker($d31a044bdb105f56$var$w, 129);
function $d31a044bdb105f56$var$N(t, i) {
    if (!$d31a044bdb105f56$var$g(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $d31a044bdb105f56$var$h ? $d31a044bdb105f56$var$h.createHTML(i) : i;
}
const $d31a044bdb105f56$var$U = (t, i)=>{
    const s = t.length - 1, e = [];
    let h, o = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", n = $d31a044bdb105f56$var$T;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let r, l, c = -1, a = 0;
        for(; a < s.length && (n.lastIndex = a, l = n.exec(s), null !== l);)a = n.lastIndex, n === $d31a044bdb105f56$var$T ? "!--" === l[1] ? n = $d31a044bdb105f56$var$E : void 0 !== l[1] ? n = $d31a044bdb105f56$var$k : void 0 !== l[2] ? ($d31a044bdb105f56$var$M.test(l[2]) && (h = RegExp("</" + l[2], "g")), n = $d31a044bdb105f56$var$O) : void 0 !== l[3] && (n = $d31a044bdb105f56$var$O) : n === $d31a044bdb105f56$var$O ? ">" === l[0] ? (n = h ?? $d31a044bdb105f56$var$T, c = -1) : void 0 === l[1] ? c = -2 : (c = n.lastIndex - l[2].length, r = l[1], n = void 0 === l[3] ? $d31a044bdb105f56$var$O : '"' === l[3] ? $d31a044bdb105f56$var$j : $d31a044bdb105f56$var$S) : n === $d31a044bdb105f56$var$j || n === $d31a044bdb105f56$var$S ? n = $d31a044bdb105f56$var$O : n === $d31a044bdb105f56$var$E || n === $d31a044bdb105f56$var$k ? n = $d31a044bdb105f56$var$T : (n = $d31a044bdb105f56$var$O, h = void 0);
        const u = n === $d31a044bdb105f56$var$O && t[i + 1].startsWith("/>") ? " " : "";
        o += n === $d31a044bdb105f56$var$T ? s + $d31a044bdb105f56$var$_ : c >= 0 ? (e.push(r), s.slice(0, c) + $d31a044bdb105f56$var$f + s.slice(c) + $d31a044bdb105f56$var$v + u) : s + $d31a044bdb105f56$var$v + (-2 === c ? i : u);
    }
    return [
        $d31a044bdb105f56$var$N(t, o + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        e
    ];
};
class $d31a044bdb105f56$var$B {
    constructor({ strings: t, _$litType$: i }, s){
        let e;
        this.parts = [];
        let h = 0, o = 0;
        const n = t.length - 1, r = this.parts, [l, a] = $d31a044bdb105f56$var$U(t, i);
        if (this.el = $d31a044bdb105f56$var$B.createElement(l, s), $d31a044bdb105f56$var$I.currentNode = this.el.content, 2 === i || 3 === i) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (e = $d31a044bdb105f56$var$I.nextNode()) && r.length < n;){
            if (1 === e.nodeType) {
                if (e.hasAttributes()) for (const t of e.getAttributeNames())if (t.endsWith($d31a044bdb105f56$var$f)) {
                    const i = a[o++], s = e.getAttribute(t).split($d31a044bdb105f56$var$v), n = /([.?@])?(.*)/.exec(i);
                    r.push({
                        type: 1,
                        index: h,
                        name: n[2],
                        strings: s,
                        ctor: "." === n[1] ? $d31a044bdb105f56$var$Y : "?" === n[1] ? $d31a044bdb105f56$var$Z : "@" === n[1] ? $d31a044bdb105f56$var$q : $d31a044bdb105f56$var$G
                    }), e.removeAttribute(t);
                } else t.startsWith($d31a044bdb105f56$var$v) && (r.push({
                    type: 6,
                    index: h
                }), e.removeAttribute(t));
                if ($d31a044bdb105f56$var$M.test(e.tagName)) {
                    const t = e.textContent.split($d31a044bdb105f56$var$v), i = t.length - 1;
                    if (i > 0) {
                        e.textContent = $d31a044bdb105f56$var$c ? $d31a044bdb105f56$var$c.emptyScript : "";
                        for(let s = 0; s < i; s++)e.append(t[s], $d31a044bdb105f56$var$lt()), $d31a044bdb105f56$var$I.nextNode(), r.push({
                            type: 2,
                            index: ++h
                        });
                        e.append(t[i], $d31a044bdb105f56$var$lt());
                    }
                }
            } else if (8 === e.nodeType) {
                if (e.data === $d31a044bdb105f56$var$m) r.push({
                    type: 2,
                    index: h
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = e.data.indexOf($d31a044bdb105f56$var$v, t + 1));)r.push({
                        type: 7,
                        index: h
                    }), t += $d31a044bdb105f56$var$v.length - 1;
                }
            }
            h++;
        }
    }
    static createElement(t, i) {
        const s = $d31a044bdb105f56$var$w.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $d31a044bdb105f56$var$z(t, i, s = t, e) {
    if (i === $d31a044bdb105f56$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s.o?.[e] : s.l;
    const o = $d31a044bdb105f56$var$st(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s.o ??= [])[e] = h : s.l = h), void 0 !== h && (i = $d31a044bdb105f56$var$z(t, h._$AS(t, i.values), h, e)), i;
}
class $d31a044bdb105f56$var$F {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $d31a044bdb105f56$var$w).importNode(i, !0);
        $d31a044bdb105f56$var$I.currentNode = e;
        let h = $d31a044bdb105f56$var$I.nextNode(), o = 0, n = 0, r = s[0];
        for(; void 0 !== r;){
            if (o === r.index) {
                let i;
                2 === r.type ? i = new $d31a044bdb105f56$var$et(h, h.nextSibling, this, t) : 1 === r.type ? i = new r.ctor(h, r.name, r.strings, this, t) : 6 === r.type && (i = new $d31a044bdb105f56$var$K(h, this, t)), this._$AV.push(i), r = s[++n];
            }
            o !== r?.index && (h = $d31a044bdb105f56$var$I.nextNode(), o++);
        }
        return $d31a044bdb105f56$var$I.currentNode = $d31a044bdb105f56$var$w, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $d31a044bdb105f56$var$et {
    get _$AU() {
        return this._$AM?._$AU ?? this.v;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $d31a044bdb105f56$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this.v = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $d31a044bdb105f56$var$z(this, t, i), $d31a044bdb105f56$var$st(t) ? t === $d31a044bdb105f56$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $d31a044bdb105f56$export$45b790e32b2810ee && this._$AR(), this._$AH = $d31a044bdb105f56$export$45b790e32b2810ee) : t !== this._$AH && t !== $d31a044bdb105f56$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $d31a044bdb105f56$var$$(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $d31a044bdb105f56$export$45b790e32b2810ee && $d31a044bdb105f56$var$st(this._$AH) ? this._$AA.nextSibling.data = t : this.T($d31a044bdb105f56$var$w.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $d31a044bdb105f56$var$B.createElement($d31a044bdb105f56$var$N(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $d31a044bdb105f56$var$F(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $d31a044bdb105f56$var$V.get(t.strings);
        return void 0 === i && $d31a044bdb105f56$var$V.set(t.strings, i = new $d31a044bdb105f56$var$B(t)), i;
    }
    k(t) {
        $d31a044bdb105f56$var$g(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $d31a044bdb105f56$var$et(this.O($d31a044bdb105f56$var$lt()), this.O($d31a044bdb105f56$var$lt()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this.v = t, this._$AP?.(t));
    }
}
class $d31a044bdb105f56$var$G {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $d31a044bdb105f56$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $d31a044bdb105f56$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $d31a044bdb105f56$var$z(this, t, i, 0), o = !$d31a044bdb105f56$var$st(t) || t !== this._$AH && t !== $d31a044bdb105f56$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $d31a044bdb105f56$var$z(this, e[s + n], i, n), r === $d31a044bdb105f56$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$d31a044bdb105f56$var$st(r) || r !== this._$AH[n], r === $d31a044bdb105f56$export$45b790e32b2810ee ? t = $d31a044bdb105f56$export$45b790e32b2810ee : t !== $d31a044bdb105f56$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $d31a044bdb105f56$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $d31a044bdb105f56$var$Y extends $d31a044bdb105f56$var$G {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $d31a044bdb105f56$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $d31a044bdb105f56$var$Z extends $d31a044bdb105f56$var$G {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $d31a044bdb105f56$export$45b790e32b2810ee);
    }
}
class $d31a044bdb105f56$var$q extends $d31a044bdb105f56$var$G {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $d31a044bdb105f56$var$z(this, t, i, 0) ?? $d31a044bdb105f56$export$45b790e32b2810ee) === $d31a044bdb105f56$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $d31a044bdb105f56$export$45b790e32b2810ee && s !== $d31a044bdb105f56$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $d31a044bdb105f56$export$45b790e32b2810ee && (s === $d31a044bdb105f56$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $d31a044bdb105f56$var$K {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $d31a044bdb105f56$var$z(this, t);
    }
}
const $d31a044bdb105f56$export$8613d1ca9052b22e = {
    M: $d31a044bdb105f56$var$f,
    P: $d31a044bdb105f56$var$v,
    A: $d31a044bdb105f56$var$m,
    C: 1,
    L: $d31a044bdb105f56$var$U,
    R: $d31a044bdb105f56$var$F,
    D: $d31a044bdb105f56$var$$,
    V: $d31a044bdb105f56$var$z,
    I: $d31a044bdb105f56$var$et,
    H: $d31a044bdb105f56$var$G,
    N: $d31a044bdb105f56$var$Z,
    U: $d31a044bdb105f56$var$q,
    B: $d31a044bdb105f56$var$Y,
    F: $d31a044bdb105f56$var$K
}, $d31a044bdb105f56$var$Re = $d31a044bdb105f56$var$n.litHtmlPolyfillSupport;
$d31a044bdb105f56$var$Re?.($d31a044bdb105f56$var$B, $d31a044bdb105f56$var$et), ($d31a044bdb105f56$var$n.litHtmlVersions ??= []).push("3.2.0");
const $d31a044bdb105f56$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $d31a044bdb105f56$var$et(i.insertBefore($d31a044bdb105f56$var$lt(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};

});

parcelRegister("3KB8N", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("aPsWt")).css);
$parcel$export(module.exports, "ReactiveElement", () => (parcelRequire("3SvFt")).ReactiveElement);
$parcel$export(module.exports, "unsafeCSS", () => (parcelRequire("aPsWt")).unsafeCSS);
$parcel$export(module.exports, "html", () => (parcelRequire("i7GIz")).html);
$parcel$export(module.exports, "noChange", () => (parcelRequire("i7GIz")).noChange);
$parcel$export(module.exports, "render", () => (parcelRequire("i7GIz")).render);
$parcel$export(module.exports, "svg", () => (parcelRequire("i7GIz")).svg);

$parcel$export(module.exports, "LitElement", () => $2bb27a5e53ae7749$export$3f2f9f5909897157);

var $3SvFt = parcelRequire("3SvFt");

var $i7GIz = parcelRequire("i7GIz");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $2bb27a5e53ae7749$export$3f2f9f5909897157 extends (0, $3SvFt.ReactiveElement) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this.o = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const e = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this.o = (0, $i7GIz.render)(e, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this.o?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this.o?.setConnected(!1);
    }
    render() {
        return 0, $i7GIz.noChange;
    }
}
$2bb27a5e53ae7749$export$3f2f9f5909897157._$litElement$ = !0, $2bb27a5e53ae7749$export$3f2f9f5909897157["finalized"] = !0, globalThis.litElementHydrateSupport?.({
    LitElement: $2bb27a5e53ae7749$export$3f2f9f5909897157
});
const $2bb27a5e53ae7749$var$f = globalThis.litElementPolyfillSupport;
$2bb27a5e53ae7749$var$f?.({
    LitElement: $2bb27a5e53ae7749$export$3f2f9f5909897157
});
const $2bb27a5e53ae7749$export$f5c524615a7708d6 = {
    _$AK: (t, e, s)=>{
        t._$AK(e, s);
    },
    _$AL: (t)=>t._$AL
};
(globalThis.litElementVersions ??= []).push("4.1.0");

});

parcelRegister("5XLmv", function(module, exports) {
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $4577339212063716$export$6acf61af03e62db = !1;

});


parcelRegister("9rwwE", function(module, exports) {

$parcel$export(module.exports, "initializeTheming", () => $6dffdd9b132dd633$export$8ee9916a43f985de);
$parcel$export(module.exports, "setColorTheme", () => $6dffdd9b132dd633$export$718db041b82c5d23);
$parcel$export(module.exports, "setThemeVariables", () => $6dffdd9b132dd633$export$b6ed091aa8078e9b);
$parcel$export(module.exports, "resetStyles", () => $6dffdd9b132dd633$export$6b6f359a824920a4);
$parcel$export(module.exports, "elementStyles", () => $6dffdd9b132dd633$export$e7ba49a1dbca65c7);
$parcel$export(module.exports, "colorStyles", () => $6dffdd9b132dd633$export$ab44001f5690ee9c);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
let $6dffdd9b132dd633$var$themeTag = undefined;
let $6dffdd9b132dd633$var$darkModeTag = undefined;
let $6dffdd9b132dd633$var$lightModeTag = undefined;
function $6dffdd9b132dd633$export$8ee9916a43f985de(themeVariables, themeMode) {
    $6dffdd9b132dd633$var$themeTag = document.createElement("style");
    $6dffdd9b132dd633$var$darkModeTag = document.createElement("style");
    $6dffdd9b132dd633$var$lightModeTag = document.createElement("style");
    $6dffdd9b132dd633$var$themeTag.textContent = $6dffdd9b132dd633$var$createRootStyles(themeVariables).core.cssText;
    $6dffdd9b132dd633$var$darkModeTag.textContent = $6dffdd9b132dd633$var$createRootStyles(themeVariables).dark.cssText;
    $6dffdd9b132dd633$var$lightModeTag.textContent = $6dffdd9b132dd633$var$createRootStyles(themeVariables).light.cssText;
    document.head.appendChild($6dffdd9b132dd633$var$themeTag);
    document.head.appendChild($6dffdd9b132dd633$var$darkModeTag);
    document.head.appendChild($6dffdd9b132dd633$var$lightModeTag);
    $6dffdd9b132dd633$export$718db041b82c5d23(themeMode);
}
function $6dffdd9b132dd633$export$718db041b82c5d23(themeMode) {
    if ($6dffdd9b132dd633$var$darkModeTag && $6dffdd9b132dd633$var$lightModeTag) {
        if (themeMode === "light") {
            $6dffdd9b132dd633$var$darkModeTag.removeAttribute("media");
            $6dffdd9b132dd633$var$lightModeTag.media = "enabled";
        } else {
            $6dffdd9b132dd633$var$lightModeTag.removeAttribute("media");
            $6dffdd9b132dd633$var$darkModeTag.media = "enabled";
        }
    }
}
function $6dffdd9b132dd633$export$b6ed091aa8078e9b(themeVariables) {
    if ($6dffdd9b132dd633$var$themeTag && $6dffdd9b132dd633$var$darkModeTag && $6dffdd9b132dd633$var$lightModeTag) {
        $6dffdd9b132dd633$var$themeTag.textContent = $6dffdd9b132dd633$var$createRootStyles(themeVariables).core.cssText;
        $6dffdd9b132dd633$var$darkModeTag.textContent = $6dffdd9b132dd633$var$createRootStyles(themeVariables).dark.cssText;
        $6dffdd9b132dd633$var$lightModeTag.textContent = $6dffdd9b132dd633$var$createRootStyles(themeVariables).light.cssText;
    }
}
function $6dffdd9b132dd633$var$createRootStyles(themeVariables) {
    return {
        core: (0, $aPsWt.css)`
      @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
      :root {
        --w3m-color-mix-strength: ${(0, $aPsWt.unsafeCSS)(themeVariables?.["--w3m-color-mix-strength"] ? `${themeVariables["--w3m-color-mix-strength"]}%` : "0%")};
        --w3m-font-family: ${(0, $aPsWt.unsafeCSS)(themeVariables?.["--w3m-font-family"] || "Inter, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif;")};
        --w3m-font-size-master: ${(0, $aPsWt.unsafeCSS)(themeVariables?.["--w3m-font-size-master"] || "10px")};
        --w3m-border-radius-master: ${(0, $aPsWt.unsafeCSS)(themeVariables?.["--w3m-border-radius-master"] || "4px")};
        --w3m-z-index: ${(0, $aPsWt.unsafeCSS)(themeVariables?.["--w3m-z-index"] || 100)};

        --wui-font-family: var(--w3m-font-family);

        --wui-font-size-micro: var(--w3m-font-size-master);
        --wui-font-size-tiny: calc(var(--w3m-font-size-master) * 1.2);
        --wui-font-size-small: calc(var(--w3m-font-size-master) * 1.4);
        --wui-font-size-paragraph: calc(var(--w3m-font-size-master) * 1.6);
        --wui-font-size-large: calc(var(--w3m-font-size-master) * 2);
        --wui-font-size-medium-title: calc(var(--w3m-font-size-master) * 2.4);
        --wui-font-size-2xl: calc(var(--w3m-font-size-master) * 4);

        --wui-border-radius-5xs: var(--w3m-border-radius-master);
        --wui-border-radius-4xs: calc(var(--w3m-border-radius-master) * 1.5);
        --wui-border-radius-3xs: calc(var(--w3m-border-radius-master) * 2);
        --wui-border-radius-xxs: calc(var(--w3m-border-radius-master) * 3);
        --wui-border-radius-xs: calc(var(--w3m-border-radius-master) * 4);
        --wui-border-radius-s: calc(var(--w3m-border-radius-master) * 5);
        --wui-border-radius-m: calc(var(--w3m-border-radius-master) * 7);
        --wui-border-radius-l: calc(var(--w3m-border-radius-master) * 9);
        --wui-border-radius-3xl: calc(var(--w3m-border-radius-master) * 20);

        --wui-font-weight-light: 400;
        --wui-font-weight-regular: 500;
        --wui-font-weight-medium: 600;
        --wui-font-weight-bold: 700;

        --wui-letter-spacing-2xl: -1.6px;
        --wui-letter-spacing-medium-title: -0.96px;
        --wui-letter-spacing-large: -0.8px;
        --wui-letter-spacing-paragraph: -0.64px;
        --wui-letter-spacing-small: -0.56px;
        --wui-letter-spacing-tiny: -0.48px;
        --wui-letter-spacing-micro: -0.2px;

        --wui-spacing-0: 0px;
        --wui-spacing-4xs: 2px;
        --wui-spacing-3xs: 4px;
        --wui-spacing-xxs: 6px;
        --wui-spacing-2xs: 7px;
        --wui-spacing-xs: 8px;
        --wui-spacing-1xs: 10px;
        --wui-spacing-s: 12px;
        --wui-spacing-m: 14px;
        --wui-spacing-l: 16px;
        --wui-spacing-2l: 18px;
        --wui-spacing-xl: 20px;
        --wui-spacing-xxl: 24px;
        --wui-spacing-2xl: 32px;
        --wui-spacing-3xl: 40px;
        --wui-spacing-4xl: 90px;

        --wui-icon-box-size-xxs: 14px;
        --wui-icon-box-size-xs: 20px;
        --wui-icon-box-size-sm: 24px;
        --wui-icon-box-size-md: 32px;
        --wui-icon-box-size-lg: 40px;
        --wui-icon-box-size-xl: 64px;

        --wui-icon-size-inherit: inherit;
        --wui-icon-size-xxs: 10px;
        --wui-icon-size-xs: 12px;
        --wui-icon-size-sm: 14px;
        --wui-icon-size-md: 16px;
        --wui-icon-size-mdl: 18px;
        --wui-icon-size-lg: 20px;
        --wui-icon-size-xl: 24px;

        --wui-wallet-image-size-inherit: inherit;
        --wui-wallet-image-size-sm: 40px;
        --wui-wallet-image-size-md: 56px;
        --wui-wallet-image-size-lg: 80px;

        --wui-visual-size-size-inherit: inherit;
        --wui-visual-size-sm: 40px;
        --wui-visual-size-md: 55px;
        --wui-visual-size-lg: 80px;

        --wui-box-size-md: 100px;
        --wui-box-size-lg: 120px;

        --wui-ease-out-power-2: cubic-bezier(0, 0, 0.22, 1);
        --wui-ease-out-power-1: cubic-bezier(0, 0, 0.55, 1);

        --wui-ease-in-power-3: cubic-bezier(0.66, 0, 1, 1);
        --wui-ease-in-power-2: cubic-bezier(0.45, 0, 1, 1);
        --wui-ease-in-power-1: cubic-bezier(0.3, 0, 1, 1);

        --wui-ease-inout-power-1: cubic-bezier(0.45, 0, 0.55, 1);

        --wui-duration-lg: 200ms;
        --wui-duration-md: 125ms;
        --wui-duration-sm: 75ms;

        --wui-path-network-sm: path(
          'M15.4 2.1a5.21 5.21 0 0 1 5.2 0l11.61 6.7a5.21 5.21 0 0 1 2.61 4.52v13.4c0 1.87-1 3.59-2.6 4.52l-11.61 6.7c-1.62.93-3.6.93-5.22 0l-11.6-6.7a5.21 5.21 0 0 1-2.61-4.51v-13.4c0-1.87 1-3.6 2.6-4.52L15.4 2.1Z'
        );

        --wui-path-network-md: path(
          'M43.4605 10.7248L28.0485 1.61089C25.5438 0.129705 22.4562 0.129705 19.9515 1.61088L4.53951 10.7248C2.03626 12.2051 0.5 14.9365 0.5 17.886V36.1139C0.5 39.0635 2.03626 41.7949 4.53951 43.2752L19.9515 52.3891C22.4562 53.8703 25.5438 53.8703 28.0485 52.3891L43.4605 43.2752C45.9637 41.7949 47.5 39.0635 47.5 36.114V17.8861C47.5 14.9365 45.9637 12.2051 43.4605 10.7248Z'
        );

        --wui-path-network-lg: path(
          'M78.3244 18.926L50.1808 2.45078C45.7376 -0.150261 40.2624 -0.150262 35.8192 2.45078L7.6756 18.926C3.23322 21.5266 0.5 26.3301 0.5 31.5248V64.4752C0.5 69.6699 3.23322 74.4734 7.6756 77.074L35.8192 93.5492C40.2624 96.1503 45.7376 96.1503 50.1808 93.5492L78.3244 77.074C82.7668 74.4734 85.5 69.6699 85.5 64.4752V31.5248C85.5 26.3301 82.7668 21.5266 78.3244 18.926Z'
        );

        --wui-width-network-sm: 36px;
        --wui-width-network-md: 48px;
        --wui-width-network-lg: 86px;

        --wui-height-network-sm: 40px;
        --wui-height-network-md: 54px;
        --wui-height-network-lg: 96px;

        --wui-icon-size-network-sm: 16px;
        --wui-icon-size-network-md: 24px;
        --wui-icon-size-network-lg: 42px;

        --wui-color-inherit: inherit;

        --wui-color-inverse-100: #fff;
        --wui-color-inverse-000: #000;

        --wui-cover: rgba(20, 20, 20, 0.8);

        --wui-color-modal-bg: var(--wui-color-modal-bg-base);

        --wui-color-blue-100: var(--wui-color-blue-base-100);

        --wui-color-accent-100: var(--wui-color-accent-base-100);
        --wui-color-accent-090: var(--wui-color-accent-base-090);
        --wui-color-accent-080: var(--wui-color-accent-base-080);

        --wui-accent-glass-090: var(--wui-accent-glass-base-090);
        --wui-accent-glass-080: var(--wui-accent-glass-base-080);
        --wui-accent-glass-020: var(--wui-accent-glass-base-020);
        --wui-accent-glass-015: var(--wui-accent-glass-base-015);
        --wui-accent-glass-010: var(--wui-accent-glass-base-010);
        --wui-accent-glass-005: var(--wui-accent-glass-base-005);
        --wui-accent-glass-002: var(--wui-accent-glass-base-002);

        --wui-color-fg-100: var(--wui-color-fg-base-100);
        --wui-color-fg-125: var(--wui-color-fg-base-125);
        --wui-color-fg-150: var(--wui-color-fg-base-150);
        --wui-color-fg-175: var(--wui-color-fg-base-175);
        --wui-color-fg-200: var(--wui-color-fg-base-200);
        --wui-color-fg-225: var(--wui-color-fg-base-225);
        --wui-color-fg-250: var(--wui-color-fg-base-250);
        --wui-color-fg-275: var(--wui-color-fg-base-275);
        --wui-color-fg-300: var(--wui-color-fg-base-300);

        --wui-color-bg-100: var(--wui-color-bg-base-100);
        --wui-color-bg-125: var(--wui-color-bg-base-125);
        --wui-color-bg-150: var(--wui-color-bg-base-150);
        --wui-color-bg-175: var(--wui-color-bg-base-175);
        --wui-color-bg-200: var(--wui-color-bg-base-200);
        --wui-color-bg-225: var(--wui-color-bg-base-225);
        --wui-color-bg-250: var(--wui-color-bg-base-250);
        --wui-color-bg-275: var(--wui-color-bg-base-275);
        --wui-color-bg-300: var(--wui-color-bg-base-300);

        --wui-color-success-100: var(--wui-color-success-base-100);
        --wui-color-error-100: var(--wui-color-error-base-100);

        --wui-icon-box-bg-error-100: var(--wui-icon-box-bg-error-base-100);
        --wui-icon-box-bg-blue-100: var(--wui-icon-box-bg-blue-base-100);
        --wui-icon-box-bg-success-100: var(--wui-icon-box-bg-success-base-100);
        --wui-icon-box-bg-inverse-100: var(--wui-icon-box-bg-inverse-base-100);

        --wui-all-wallets-bg-100: var(--wui-all-wallets-bg-base-100);

        --wui-avatar-border: var(--wui-avatar-border-base);

        --wui-thumbnail-border: var(--wui-thumbnail-border-base);

        --wui-box-shadow-blue: rgba(71, 161, 255, 0.16);
      }

      @supports (background: color-mix(in srgb, white 50%, black)) {
        :root {
          --wui-color-modal-bg: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-modal-bg-base)
          );

          --wui-box-shadow-blue: color-mix(in srgb, var(--wui-color-accent-100) 16%, transparent);

          --wui-color-accent-090: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 90%,
            var(--w3m-default)
          );
          --wui-color-accent-080: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 80%,
            var(--w3m-default)
          );

          --wui-color-accent-090: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 90%,
            transparent
          );
          --wui-color-accent-080: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 80%,
            transparent
          );

          --wui-accent-glass-090: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 90%,
            transparent
          );
          --wui-accent-glass-080: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 80%,
            transparent
          );
          --wui-accent-glass-020: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 20%,
            transparent
          );
          --wui-accent-glass-015: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 15%,
            transparent
          );
          --wui-accent-glass-010: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 10%,
            transparent
          );
          --wui-accent-glass-005: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 5%,
            transparent
          );
          --wui-color-accent-002: color-mix(
            in srgb,
            var(--wui-color-accent-base-100) 2%,
            transparent
          );

          --wui-color-fg-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-100)
          );
          --wui-color-fg-125: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-125)
          );
          --wui-color-fg-150: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-150)
          );
          --wui-color-fg-175: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-175)
          );
          --wui-color-fg-200: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-200)
          );
          --wui-color-fg-225: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-225)
          );
          --wui-color-fg-250: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-250)
          );
          --wui-color-fg-275: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-275)
          );
          --wui-color-fg-300: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-fg-base-300)
          );

          --wui-color-bg-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-100)
          );
          --wui-color-bg-125: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-125)
          );
          --wui-color-bg-150: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-150)
          );
          --wui-color-bg-175: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-175)
          );
          --wui-color-bg-200: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-200)
          );
          --wui-color-bg-225: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-225)
          );
          --wui-color-bg-250: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-250)
          );
          --wui-color-bg-275: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-275)
          );
          --wui-color-bg-300: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-bg-base-300)
          );

          --wui-color-success-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-success-base-100)
          );
          --wui-color-error-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-color-error-base-100)
          );

          --wui-icon-box-bg-error-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-icon-box-bg-error-base-100)
          );
          --wui-icon-box-bg-accent-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-icon-box-bg-blue-base-100)
          );
          --wui-icon-box-bg-success-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-icon-box-bg-success-base-100)
          );
          --wui-icon-box-bg-inverse-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-icon-box-bg-inverse-base-100)
          );

          --wui-all-wallets-bg-100: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-all-wallets-bg-base-100)
          );

          --wui-avatar-border: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-avatar-border-base)
          );

          --wui-thumbnail-border: color-mix(
            in srgb,
            var(--w3m-color-mix) var(--w3m-color-mix-strength),
            var(--wui-thumbnail-border-base)
          );
        }
      }
    `,
        light: (0, $aPsWt.css)`
      :root {
        --w3m-color-mix: ${(0, $aPsWt.unsafeCSS)(themeVariables?.["--w3m-color-mix"] || "#fff")};
        --w3m-accent: ${(0, $aPsWt.unsafeCSS)(themeVariables?.["--w3m-accent"] || "#47a1ff")};
        --w3m-default: #fff;

        --wui-color-modal-bg-base: #191a1a;

        --wui-color-blue-base-100: #47a1ff;

        --wui-color-accent-base-100: var(--w3m-accent);
        --wui-color-accent-base-090: #59aaff;
        --wui-color-accent-base-080: #6cb4ff;

        --wui-accent-glass-base-090: rgba(71, 161, 255, 0.9);
        --wui-accent-glass-base-080: rgba(71, 161, 255, 0.8);
        --wui-accent-glass-base-020: rgba(71, 161, 255, 0.2);
        --wui-accent-glass-base-015: rgba(71, 161, 255, 0.15);
        --wui-accent-glass-base-010: rgba(71, 161, 255, 0.1);
        --wui-accent-glass-base-005: rgba(71, 161, 255, 0.05);
        --wui-accent-glass-base-002: rgba(71, 161, 255, 0.02);

        --wui-color-fg-base-100: #e4e7e7;
        --wui-color-fg-base-125: #d0d5d5;
        --wui-color-fg-base-150: #a8b1b1;
        --wui-color-fg-base-175: #a8b0b0;
        --wui-color-fg-base-200: #949e9e;
        --wui-color-fg-base-225: #868f8f;
        --wui-color-fg-base-250: #788080;
        --wui-color-fg-base-275: #788181;
        --wui-color-fg-base-300: #6e7777;

        --wui-color-bg-base-100: #141414;
        --wui-color-bg-base-125: #191a1a;
        --wui-color-bg-base-150: #1e1f1f;
        --wui-color-bg-base-175: #222525;
        --wui-color-bg-base-200: #272a2a;
        --wui-color-bg-base-225: #2c3030;
        --wui-color-bg-base-250: #313535;
        --wui-color-bg-base-275: #363b3b;
        --wui-color-bg-base-300: #3b4040;

        --wui-color-success-base-100: #26d962;
        --wui-color-error-base-100: #f25a67;

        --wui-success-glass-001: rgba(38, 217, 98, 0.01);
        --wui-success-glass-002: rgba(38, 217, 98, 0.02);
        --wui-success-glass-005: rgba(38, 217, 98, 0.05);
        --wui-success-glass-010: rgba(38, 217, 98, 0.1);
        --wui-success-glass-015: rgba(38, 217, 98, 0.15);
        --wui-success-glass-020: rgba(38, 217, 98, 0.2);
        --wui-success-glass-025: rgba(38, 217, 98, 0.25);
        --wui-success-glass-030: rgba(38, 217, 98, 0.3);
        --wui-success-glass-060: rgba(38, 217, 98, 0.6);
        --wui-success-glass-080: rgba(38, 217, 98, 0.8);

        --wui-error-glass-001: rgba(242, 90, 103, 0.01);
        --wui-error-glass-002: rgba(242, 90, 103, 0.02);
        --wui-error-glass-005: rgba(242, 90, 103, 0.05);
        --wui-error-glass-010: rgba(242, 90, 103, 0.1);
        --wui-error-glass-015: rgba(242, 90, 103, 0.15);
        --wui-error-glass-020: rgba(242, 90, 103, 0.2);
        --wui-error-glass-025: rgba(242, 90, 103, 0.25);
        --wui-error-glass-030: rgba(242, 90, 103, 0.3);
        --wui-error-glass-060: rgba(242, 90, 103, 0.6);
        --wui-error-glass-080: rgba(242, 90, 103, 0.8);

        --wui-icon-box-bg-error-base-100: #3c2426;
        --wui-icon-box-bg-blue-base-100: #20303f;
        --wui-icon-box-bg-success-base-100: #1f3a28;
        --wui-icon-box-bg-inverse-base-100: #243240;

        --wui-all-wallets-bg-base-100: #222b35;

        --wui-avatar-border-base: #252525;

        --wui-thumbnail-border-base: #252525;

        --wui-gray-glass-001: rgba(255, 255, 255, 0.01);
        --wui-gray-glass-002: rgba(255, 255, 255, 0.02);
        --wui-gray-glass-005: rgba(255, 255, 255, 0.05);
        --wui-gray-glass-010: rgba(255, 255, 255, 0.1);
        --wui-gray-glass-015: rgba(255, 255, 255, 0.15);
        --wui-gray-glass-020: rgba(255, 255, 255, 0.2);
        --wui-gray-glass-025: rgba(255, 255, 255, 0.25);
        --wui-gray-glass-030: rgba(255, 255, 255, 0.3);
        --wui-gray-glass-060: rgba(255, 255, 255, 0.6);
        --wui-gray-glass-080: rgba(255, 255, 255, 0.8);
      }
    `,
        dark: (0, $aPsWt.css)`
      :root {
        --w3m-color-mix: ${(0, $aPsWt.unsafeCSS)(themeVariables?.["--w3m-color-mix"] || "#000")};
        --w3m-accent: ${(0, $aPsWt.unsafeCSS)(themeVariables?.["--w3m-accent"] || "#3396ff")};
        --w3m-default: #000;

        --wui-color-modal-bg-base: #fff;

        --wui-color-blue-base-100: #3396ff;

        --wui-color-accent-base-100: var(--w3m-accent);
        --wui-color-accent-base-090: #2d7dd2;
        --wui-color-accent-base-080: #2978cc;

        --wui-accent-glass-base-090: rgba(51, 150, 255, 0.9);
        --wui-accent-glass-base-080: rgba(51, 150, 255, 0.8);
        --wui-accent-glass-base-020: rgba(51, 150, 255, 0.2);
        --wui-accent-glass-base-015: rgba(51, 150, 255, 0.15);
        --wui-accent-glass-base-010: rgba(51, 150, 255, 0.1);
        --wui-accent-glass-base-005: rgba(51, 150, 255, 0.05);
        --wui-accent-glass-base-002: rgba(51, 150, 255, 0.02);

        --wui-color-fg-base-100: #141414;
        --wui-color-fg-base-125: #2d3131;
        --wui-color-fg-base-150: #474d4d;
        --wui-color-fg-base-175: #636d6d;
        --wui-color-fg-base-200: #798686;
        --wui-color-fg-base-225: #828f8f;
        --wui-color-fg-base-250: #8b9797;
        --wui-color-fg-base-275: #95a0a0;
        --wui-color-fg-base-300: #9ea9a9;

        --wui-color-bg-base-100: #ffffff;
        --wui-color-bg-base-125: #f5fafa;
        --wui-color-bg-base-150: #f3f8f8;
        --wui-color-bg-base-175: #eef4f4;
        --wui-color-bg-base-200: #eaf1f1;
        --wui-color-bg-base-225: #e5eded;
        --wui-color-bg-base-250: #e1e9e9;
        --wui-color-bg-base-275: #dce7e7;
        --wui-color-bg-base-300: #d8e3e3;

        --wui-color-success-base-100: #26b562;
        --wui-color-error-base-100: #f05142;

        --wui-success-glass-001: rgba(38, 181, 98, 0.01);
        --wui-success-glass-002: rgba(38, 181, 98, 0.02);
        --wui-success-glass-005: rgba(38, 181, 98, 0.05);
        --wui-success-glass-010: rgba(38, 181, 98, 0.1);
        --wui-success-glass-015: rgba(38, 181, 98, 0.15);
        --wui-success-glass-020: rgba(38, 181, 98, 0.2);
        --wui-success-glass-025: rgba(38, 181, 98, 0.25);
        --wui-success-glass-030: rgba(38, 181, 98, 0.3);
        --wui-success-glass-060: rgba(38, 181, 98, 0.6);
        --wui-success-glass-080: rgba(38, 181, 98, 0.8);

        --wui-error-glass-001: rgba(240, 81, 66, 0.01);
        --wui-error-glass-002: rgba(240, 81, 66, 0.02);
        --wui-error-glass-005: rgba(240, 81, 66, 0.05);
        --wui-error-glass-010: rgba(240, 81, 66, 0.1);
        --wui-error-glass-015: rgba(240, 81, 66, 0.15);
        --wui-error-glass-020: rgba(240, 81, 66, 0.2);
        --wui-error-glass-025: rgba(240, 81, 66, 0.25);
        --wui-error-glass-030: rgba(240, 81, 66, 0.3);
        --wui-error-glass-060: rgba(240, 81, 66, 0.6);
        --wui-error-glass-080: rgba(240, 81, 66, 0.8);

        --wui-icon-box-bg-error-base-100: #f4dfdd;
        --wui-icon-box-bg-blue-base-100: #d9ecfb;
        --wui-icon-box-bg-success-base-100: #daf0e4;
        --wui-icon-box-bg-inverse-base-100: #dcecfc;

        --wui-all-wallets-bg-base-100: #e8f1fa;

        --wui-avatar-border-base: #f3f4f4;

        --wui-thumbnail-border-base: #eaefef;

        --wui-gray-glass-001: rgba(0, 0, 0, 0.01);
        --wui-gray-glass-002: rgba(0, 0, 0, 0.02);
        --wui-gray-glass-005: rgba(0, 0, 0, 0.05);
        --wui-gray-glass-010: rgba(0, 0, 0, 0.1);
        --wui-gray-glass-015: rgba(0, 0, 0, 0.15);
        --wui-gray-glass-020: rgba(0, 0, 0, 0.2);
        --wui-gray-glass-025: rgba(0, 0, 0, 0.25);
        --wui-gray-glass-030: rgba(0, 0, 0, 0.3);
        --wui-gray-glass-060: rgba(0, 0, 0, 0.6);
        --wui-gray-glass-080: rgba(0, 0, 0, 0.8);
      }
    `
    };
}
const $6dffdd9b132dd633$export$6b6f359a824920a4 = (0, $aPsWt.css)`
  *,
  *::after,
  *::before,
  :host {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-style: normal;
    text-rendering: optimizeSpeed;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-tap-highlight-color: transparent;
    font-family: var(--wui-font-family);
    backface-visibility: hidden;
  }
`;
const $6dffdd9b132dd633$export$e7ba49a1dbca65c7 = (0, $aPsWt.css)`
  button,
  a {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    transition: all var(--wui-ease-out-power-1) var(--wui-duration-lg);
    outline: none;
    border: 1px solid transparent;
    column-gap: var(--wui-spacing-3xs);
    background-color: transparent;
    text-decoration: none;
  }

  @media (hover: hover) and (pointer: fine) {
    button:hover:enabled {
      background-color: var(--wui-gray-glass-005);
    }

    button:active:enabled {
      transition: all var(--wui-ease-out-power-2) var(--wui-duration-sm);
      background-color: var(--wui-gray-glass-010);
    }

    button[data-variant='fill']:hover:enabled {
      background-color: var(--wui-color-accent-090);
    }

    button[data-variant='accentBg']:hover:enabled {
      background: var(--wui-accent-glass-015);
    }

    button[data-variant='accentBg']:active:enabled {
      background: var(--wui-accent-glass-020);
    }
  }

  button:disabled {
    cursor: not-allowed;
    background-color: var(--wui-gray-glass-005);
  }

  button[data-variant='shade']:disabled,
  button[data-variant='accent']:disabled,
  button[data-variant='accentBg']:disabled {
    background-color: var(--wui-gray-glass-010);
    color: var(--wui-gray-glass-015);
    filter: grayscale(1);
  }

  button:disabled > wui-wallet-image,
  button:disabled > wui-all-wallets-image,
  button:disabled > wui-network-image,
  button:disabled > wui-image,
  button:disabled > wui-icon-box,
  button:disabled > wui-transaction-visual,
  button:disabled > wui-logo {
    filter: grayscale(1);
  }

  button:focus-visible,
  a:focus-visible {
    border: 1px solid var(--wui-color-accent-100);
    background-color: var(--wui-gray-glass-005);
    -webkit-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    -moz-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
  }

  button[data-variant='fill']:focus-visible {
    background-color: var(--wui-color-accent-090);
  }

  button[data-variant='fill'] {
    color: var(--wui-color-inverse-100);
    background-color: var(--wui-color-accent-100);
  }

  button[data-variant='fill']:disabled {
    color: var(--wui-gray-glass-015);
    background-color: var(--wui-gray-glass-015);
  }

  button[data-variant='fill']:disabled > wui-icon {
    color: var(--wui-gray-glass-015);
  }

  button[data-variant='shade'] {
    color: var(--wui-color-fg-200);
  }

  button[data-variant='accent'],
  button[data-variant='accentBg'] {
    color: var(--wui-color-accent-100);
  }

  button[data-variant='accentBg'] {
    background: var(--wui-accent-glass-010);
    border: 1px solid var(--wui-accent-glass-010);
  }

  button[data-variant='fullWidth'] {
    width: 100%;
    border-radius: var(--wui-border-radius-xs);
    height: 56px;
    border: none;
    background-color: var(--wui-gray-glass-002);
    color: var(--wui-color-fg-200);
    gap: var(--wui-spacing-xs);
  }

  button:active:enabled {
    background-color: var(--wui-gray-glass-010);
  }

  button[data-variant='fill']:active:enabled {
    background-color: var(--wui-color-accent-080);
    border: 1px solid var(--wui-gray-glass-010);
  }

  input {
    border: none;
    outline: none;
    appearance: none;
  }
`;
const $6dffdd9b132dd633$export$ab44001f5690ee9c = (0, $aPsWt.css)`
  .wui-color-inherit {
    color: var(--wui-color-inherit);
  }

  .wui-color-accent-100 {
    color: var(--wui-color-accent-100);
  }

  .wui-color-error-100 {
    color: var(--wui-color-error-100);
  }

  .wui-color-success-100 {
    color: var(--wui-color-success-100);
  }

  .wui-color-inverse-100 {
    color: var(--wui-color-inverse-100);
  }

  .wui-color-inverse-000 {
    color: var(--wui-color-inverse-000);
  }

  .wui-color-fg-100 {
    color: var(--wui-color-fg-100);
  }

  .wui-color-fg-200 {
    color: var(--wui-color-fg-200);
  }

  .wui-color-fg-300 {
    color: var(--wui-color-fg-300);
  }

  .wui-bg-color-inherit {
    background-color: var(--wui-color-inherit);
  }

  .wui-bg-color-blue-100 {
    background-color: var(--wui-color-accent-100);
  }

  .wui-bg-color-error-100 {
    background-color: var(--wui-color-error-100);
  }

  .wui-bg-color-success-100 {
    background-color: var(--wui-color-success-100);
  }

  .wui-bg-color-inverse-100 {
    background-color: var(--wui-color-inverse-100);
  }

  .wui-bg-color-inverse-000 {
    background-color: var(--wui-color-inverse-000);
  }

  .wui-bg-color-fg-100 {
    background-color: var(--wui-color-fg-100);
  }

  .wui-bg-color-fg-200 {
    background-color: var(--wui-color-fg-200);
  }

  .wui-bg-color-fg-300 {
    background-color: var(--wui-color-fg-300);
  }
`;

});

parcelRegister("lkv4o", function(module, exports) {

$parcel$export(module.exports, "customElement", () => $f87391132ff671b6$export$da64fc29f17f9d0e);
function $f87391132ff671b6$var$standardCustomElement(tagName, descriptor) {
    const { kind: kind, elements: elements } = descriptor;
    return {
        kind: kind,
        elements: elements,
        finisher (clazz) {
            if (!customElements.get(tagName)) customElements.define(tagName, clazz);
        }
    };
}
function $f87391132ff671b6$var$legacyCustomElement(tagName, clazz) {
    if (!customElements.get(tagName)) customElements.define(tagName, clazz);
    return clazz;
}
function $f87391132ff671b6$export$da64fc29f17f9d0e(tagName) {
    return function create(classOrDescriptor) {
        return typeof classOrDescriptor === "function" ? $f87391132ff671b6$var$legacyCustomElement(tagName, classOrDescriptor) : $f87391132ff671b6$var$standardCustomElement(tagName, classOrDescriptor);
    };
}

});

parcelRegister("fG57h", function(module, exports) {

$parcel$export(module.exports, "default", () => $b69ebf425ce5a622$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $b69ebf425ce5a622$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    display: block;
    border-radius: clamp(0px, var(--wui-border-radius-l), 44px);
    box-shadow: 0 0 0 1px var(--wui-gray-glass-005);
    background-color: var(--wui-color-modal-bg);
    overflow: hidden;
  }
`;

});


parcelRegister("cvzvT", function(module, exports) {

$parcel$export(module.exports, "WuiIcon", () => $91b3ed877b3b6b40$export$10b8e15b42b9fa26);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");

var $iAqUU = parcelRequire("iAqUU");

var $9M87R = parcelRequire("9M87R");

var $2FI8w = parcelRequire("2FI8w");

var $iqnzC = parcelRequire("iqnzC");

var $2Ckyv = parcelRequire("2Ckyv");

var $95ygG = parcelRequire("95ygG");

var $aEcGa = parcelRequire("aEcGa");

var $d5s6j = parcelRequire("d5s6j");

var $l1ksd = parcelRequire("l1ksd");

var $gAGDI = parcelRequire("gAGDI");

var $u4kVZ = parcelRequire("u4kVZ");

var $csnz4 = parcelRequire("csnz4");

var $cASuh = parcelRequire("cASuh");

var $2jUlk = parcelRequire("2jUlk");

var $9442H = parcelRequire("9442H");

var $ciYom = parcelRequire("ciYom");

var $bKAcd = parcelRequire("bKAcd");

var $j61FQ = parcelRequire("j61FQ");

var $fveAl = parcelRequire("fveAl");

var $2sLWX = parcelRequire("2sLWX");

var $8GCCx = parcelRequire("8GCCx");

var $1G7OR = parcelRequire("1G7OR");

var $3NgXO = parcelRequire("3NgXO");

var $9BaW9 = parcelRequire("9BaW9");

var $6zAcC = parcelRequire("6zAcC");

var $dkY4I = parcelRequire("dkY4I");

var $aGIyC = parcelRequire("aGIyC");

var $2qjZ2 = parcelRequire("2qjZ2");

var $4rmYj = parcelRequire("4rmYj");

var $kz5qi = parcelRequire("kz5qi");

var $j4WJo = parcelRequire("j4WJo");

var $5xYTe = parcelRequire("5xYTe");

var $66vi1 = parcelRequire("66vi1");

var $4Agvs = parcelRequire("4Agvs");

var $arlmD = parcelRequire("arlmD");

var $lL9Sp = parcelRequire("lL9Sp");

var $8HvLJ = parcelRequire("8HvLJ");

var $drOKp = parcelRequire("drOKp");

var $gnrzt = parcelRequire("gnrzt");

var $3y8Z6 = parcelRequire("3y8Z6");

var $9vKL7 = parcelRequire("9vKL7");

var $94jxI = parcelRequire("94jxI");

var $hXt04 = parcelRequire("hXt04");

var $j3Kl1 = parcelRequire("j3Kl1");

var $1ydAd = parcelRequire("1ydAd");

var $jVj0p = parcelRequire("jVj0p");

var $e4XTB = parcelRequire("e4XTB");

var $hd4ge = parcelRequire("hd4ge");

var $gz9gw = parcelRequire("gz9gw");

var $5VwXU = parcelRequire("5VwXU");

var $9xnuM = parcelRequire("9xnuM");

var $jqrJn = parcelRequire("jqrJn");

var $fDo92 = parcelRequire("fDo92");

var $cZVkP = parcelRequire("cZVkP");

var $amxlC = parcelRequire("amxlC");

var $fC1b2 = parcelRequire("fC1b2");

var $lPUBB = parcelRequire("lPUBB");

var $gAnVT = parcelRequire("gAnVT");

var $8OL17 = parcelRequire("8OL17");

var $4iqk4 = parcelRequire("4iqk4");

var $1wWWa = parcelRequire("1wWWa");

var $jHQ7q = parcelRequire("jHQ7q");

var $j7peG = parcelRequire("j7peG");
var $91b3ed877b3b6b40$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $91b3ed877b3b6b40$var$svgOptions = {
    add: (0, $1G7OR.addSvg),
    allWallets: (0, $9M87R.allWalletsSvg),
    arrowBottomCircle: (0, $2FI8w.arrowBottomCircleSvg),
    appStore: (0, $iqnzC.appStoreSvg),
    apple: (0, $2Ckyv.appleSvg),
    arrowBottom: (0, $95ygG.arrowBottomSvg),
    arrowLeft: (0, $aEcGa.arrowLeftSvg),
    arrowRight: (0, $d5s6j.arrowRightSvg),
    arrowTop: (0, $l1ksd.arrowTopSvg),
    bank: (0, $1wWWa.bankSvg),
    browser: (0, $gAGDI.browserSvg),
    card: (0, $jHQ7q.cardSvg),
    checkmark: (0, $u4kVZ.checkmarkSvg),
    chevronBottom: (0, $csnz4.chevronBottomSvg),
    chevronLeft: (0, $cASuh.chevronLeftSvg),
    chevronRight: (0, $2jUlk.chevronRightSvg),
    chevronTop: (0, $9442H.chevronTopSvg),
    chromeStore: (0, $ciYom.chromeStoreSvg),
    clock: (0, $bKAcd.clockSvg),
    close: (0, $j61FQ.closeSvg),
    compass: (0, $2sLWX.compassSvg),
    coinPlaceholder: (0, $fveAl.coinPlaceholderSvg),
    copy: (0, $8GCCx.copySvg),
    cursor: (0, $3NgXO.cursorSvg),
    desktop: (0, $9BaW9.desktopSvg),
    disconnect: (0, $6zAcC.disconnectSvg),
    discord: (0, $dkY4I.discordSvg),
    etherscan: (0, $aGIyC.etherscanSvg),
    extension: (0, $2qjZ2.extensionSvg),
    externalLink: (0, $4rmYj.externalLinkSvg),
    facebook: (0, $kz5qi.facebookSvg),
    filters: (0, $j4WJo.filtersSvg),
    github: (0, $5xYTe.githubSvg),
    google: (0, $66vi1.googleSvg),
    helpCircle: (0, $4Agvs.helpCircleSvg),
    infoCircle: (0, $arlmD.infoCircleSvg),
    mail: (0, $lL9Sp.mailSvg),
    mobile: (0, $8HvLJ.mobileSvg),
    networkPlaceholder: (0, $drOKp.networkPlaceholderSvg),
    nftPlaceholder: (0, $gnrzt.nftPlaceholderSvg),
    off: (0, $3y8Z6.offSvg),
    playStore: (0, $9vKL7.playStoreSvg),
    plus: (0, $j7peG.plusSvg),
    qrCode: (0, $94jxI.qrCodeIcon),
    recycleHorizontal: (0, $4iqk4.recycleHorizontalSvg),
    refresh: (0, $hXt04.refreshSvg),
    search: (0, $j3Kl1.searchSvg),
    send: (0, $1ydAd.sendSvg),
    swapHorizontal: (0, $jVj0p.swapHorizontalSvg),
    swapHorizontalMedium: (0, $hd4ge.swapHorizontalMediumSvg),
    swapHorizontalBold: (0, $e4XTB.swapHorizontalBoldSvg),
    swapVertical: (0, $gz9gw.swapVerticalSvg),
    telegram: (0, $5VwXU.telegramSvg),
    twitch: (0, $9xnuM.twitchSvg),
    twitter: (0, $jqrJn.twitterSvg),
    twitterIcon: (0, $fDo92.twitterIconSvg),
    verify: (0, $cZVkP.verifySvg),
    verifyFilled: (0, $amxlC.verifyFilledSvg),
    wallet: (0, $lPUBB.walletSvg),
    walletConnect: (0, $gAnVT.walletConnectSvg),
    walletPlaceholder: (0, $fC1b2.walletPlaceholderSvg),
    warningCircle: (0, $8OL17.warningCircleSvg)
};
let $91b3ed877b3b6b40$export$10b8e15b42b9fa26 = class WuiIcon extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.size = "md";
        this.name = "copy";
        this.color = "fg-300";
    }
    render() {
        this.style.cssText = `
      --local-color: ${`var(--wui-color-${this.color});`}
      --local-width: ${`var(--wui-icon-size-${this.size});`}
    `;
        return (0, $i7GIz.html)`${$91b3ed877b3b6b40$var$svgOptions[this.name]}`;
    }
};
$91b3ed877b3b6b40$export$10b8e15b42b9fa26.styles = [
    (0, $9rwwE.resetStyles),
    (0, $9rwwE.colorStyles),
    (0, $iAqUU.default)
];
$91b3ed877b3b6b40$var$__decorate([
    (0, $cRlTX.property)()
], $91b3ed877b3b6b40$export$10b8e15b42b9fa26.prototype, "size", void 0);
$91b3ed877b3b6b40$var$__decorate([
    (0, $cRlTX.property)()
], $91b3ed877b3b6b40$export$10b8e15b42b9fa26.prototype, "name", void 0);
$91b3ed877b3b6b40$var$__decorate([
    (0, $cRlTX.property)()
], $91b3ed877b3b6b40$export$10b8e15b42b9fa26.prototype, "color", void 0);
$91b3ed877b3b6b40$export$10b8e15b42b9fa26 = $91b3ed877b3b6b40$var$__decorate([
    (0, $lkv4o.customElement)("wui-icon")
], $91b3ed877b3b6b40$export$10b8e15b42b9fa26);

});
parcelRegister("gWClp", function(module, exports) {
$parcel$export(module.exports, "property", () => (parcelRequire("cRlTX")).property);
$parcel$export(module.exports, "state", () => (parcelRequire("2o0HH")).state);
parcelRequire("jKiaN");
parcelRequire("cRlTX");
parcelRequire("2o0HH");
parcelRequire("77E1s");
parcelRequire("cHnZQ");
parcelRequire("bdnLe");
parcelRequire("2zomi");
parcelRequire("jFMV6");
parcelRequire("hFRLn");

});
parcelRegister("jKiaN", function(module, exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e60069035efa0cb3$export$da64fc29f17f9d0e = (t)=>(e, o)=>{
        void 0 !== o ? o.addInitializer(()=>{
            customElements.define(t, e);
        }) : customElements.define(t, e);
    };

});

parcelRegister("cRlTX", function(module, exports) {

$parcel$export(module.exports, "property", () => $95cb6c7ae76c7036$export$d541bacb2bda4494);

var $3SvFt = parcelRequire("3SvFt");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $95cb6c7ae76c7036$var$o = {
    attribute: !0,
    type: String,
    converter: (0, $3SvFt.defaultConverter),
    reflect: !1,
    hasChanged: (0, $3SvFt.notEqual)
}, $95cb6c7ae76c7036$export$8d623b1670eb40f4 = (t = $95cb6c7ae76c7036$var$o, e, r)=>{
    const { kind: n, metadata: i } = r;
    let s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), s.set(r.name, t), "accessor" === n) {
        const { name: o } = r;
        return {
            set (r) {
                const n = e.get.call(this);
                e.set.call(this, r), this.requestUpdate(o, n, t);
            },
            init (e) {
                return void 0 !== e && this.P(o, void 0, t), e;
            }
        };
    }
    if ("setter" === n) {
        const { name: o } = r;
        return function(r) {
            const n = this[o];
            e.call(this, r), this.requestUpdate(o, n, t);
        };
    }
    throw Error("Unsupported decorator location: " + n);
};
function $95cb6c7ae76c7036$export$d541bacb2bda4494(t) {
    return (e, o)=>"object" == typeof o ? $95cb6c7ae76c7036$export$8d623b1670eb40f4(t, e, o) : ((t, e, o)=>{
            const r = e.hasOwnProperty(o);
            return e.constructor.createProperty(o, r ? {
                ...t,
                wrapped: !0
            } : t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
        })(t, e, o);
}

});

parcelRegister("2o0HH", function(module, exports) {

$parcel$export(module.exports, "state", () => $1bce5e7336737d18$export$ca000e230c0caa3e);

var $cRlTX = parcelRequire("cRlTX");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $1bce5e7336737d18$export$ca000e230c0caa3e(r) {
    return (0, $cRlTX.property)({
        ...r,
        state: !0,
        attribute: !1
    });
}

});

parcelRegister("77E1s", function(module, exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $52f83b75f7d15003$export$b2b799818fbabcf3(t) {
    return (n, o)=>{
        const c = "function" == typeof n ? n : n[o];
        Object.assign(c, t);
    };
}

});

parcelRegister("cHnZQ", function(module, exports) {

var $lme2d = parcelRequire("lme2d");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $93ec1d61f9f2a909$export$2fa187e846a241c4(e, r) {
    return (n, s, i)=>{
        const o = (t)=>t.renderRoot?.querySelector(e) ?? null;
        if (r) {
            const { get: e, set: r } = "object" == typeof s ? n : i ?? (()=>{
                const t = Symbol();
                return {
                    get () {
                        return this[t];
                    },
                    set (e) {
                        this[t] = e;
                    }
                };
            })();
            return (0, $lme2d.desc)(n, s, {
                get () {
                    let t = e.call(this);
                    return void 0 === t && (t = o(this), (null !== t || this.hasUpdated) && r.call(this, t)), t;
                }
            });
        }
        return (0, $lme2d.desc)(n, s, {
            get () {
                return o(this);
            }
        });
    };
}

});
parcelRegister("lme2d", function(module, exports) {

$parcel$export(module.exports, "desc", () => $f8c68a0e91f46ba8$export$51987bb50e1f6752);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $f8c68a0e91f46ba8$export$51987bb50e1f6752 = (e, t, c)=>(c.configurable = !0, c.enumerable = !0, Reflect.decorate && "object" != typeof t && Object.defineProperty(e, t, c), c);

});


parcelRegister("bdnLe", function(module, exports) {

var $lme2d = parcelRequire("lme2d");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let $82a35703742161bd$var$e;
function $82a35703742161bd$export$dcd0d083aa86c355(r) {
    return (n, o)=>(0, $lme2d.desc)(n, o, {
            get () {
                return (this.renderRoot ?? ($82a35703742161bd$var$e ??= document.createDocumentFragment())).querySelectorAll(r);
            }
        });
}

});

parcelRegister("2zomi", function(module, exports) {

var $lme2d = parcelRequire("lme2d");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $1df1bec20d0e9eff$export$163dfc35cc43f240(r) {
    return (n, e)=>(0, $lme2d.desc)(n, e, {
            async get () {
                return await this.updateComplete, this.renderRoot?.querySelector(r) ?? null;
            }
        });
}

});

parcelRegister("jFMV6", function(module, exports) {

var $lme2d = parcelRequire("lme2d");
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $e527cb220939cf4a$export$4682af2d9ee91415(o) {
    return (e, n)=>{
        const { slot: r, selector: s } = o ?? {}, c = "slot" + (r ? `[name=${r}]` : ":not([name])");
        return (0, $lme2d.desc)(e, n, {
            get () {
                const t = this.renderRoot?.querySelector(c), e = t?.assignedElements(o) ?? [];
                return void 0 === s ? e : e.filter((t)=>t.matches(s));
            }
        });
    };
}

});

parcelRegister("hFRLn", function(module, exports) {

var $lme2d = parcelRequire("lme2d");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $cddff83c093cf479$export$1bdbe53f9df1b8(n) {
    return (o, r)=>{
        const { slot: e } = n ?? {}, s = "slot" + (e ? `[name=${e}]` : ":not([name])");
        return (0, $lme2d.desc)(o, r, {
            get () {
                const t = this.renderRoot?.querySelector(s);
                return t?.assignedNodes(n) ?? [];
            }
        });
    };
}

});


parcelRegister("iAqUU", function(module, exports) {

$parcel$export(module.exports, "default", () => $d88077ecfdf23fd2$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $d88077ecfdf23fd2$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    display: flex;
    aspect-ratio: 1 / 1;
    color: var(--local-color);
    width: var(--local-width);
  }

  svg {
    width: inherit;
    height: inherit;
    object-fit: contain;
    object-position: center;
  }
`;

});

parcelRegister("9M87R", function(module, exports) {

$parcel$export(module.exports, "allWalletsSvg", () => $71dee65cde274540$export$7d5fd172cc1c231a);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $71dee65cde274540$export$7d5fd172cc1c231a = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 24 24">
  <path
    style="fill: var(--wui-color-accent-100);"
    d="M10.2 6.6a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0ZM21 6.6a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0ZM10.2 17.4a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0ZM21 17.4a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0Z"
  />
</svg>`;

});

parcelRegister("2FI8w", function(module, exports) {

$parcel$export(module.exports, "arrowBottomCircleSvg", () => $1f21a5b37a7ae981$export$33eab3b897a3adc1);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $1f21a5b37a7ae981$export$33eab3b897a3adc1 = (0, $i7GIz.svg)`<svg
  fill="none"
  viewBox="0 0 21 20"
>
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M10.5 2.42908C6.31875 2.42908 2.92859 5.81989 2.92859 10.0034C2.92859 14.1869 6.31875 17.5777 10.5 17.5777C14.6813 17.5777 18.0714 14.1869 18.0714 10.0034C18.0714 5.81989 14.6813 2.42908 10.5 2.42908ZM0.928589 10.0034C0.928589 4.71596 5.21355 0.429077 10.5 0.429077C15.7865 0.429077 20.0714 4.71596 20.0714 10.0034C20.0714 15.2908 15.7865 19.5777 10.5 19.5777C5.21355 19.5777 0.928589 15.2908 0.928589 10.0034ZM10.5 5.75003C11.0523 5.75003 11.5 6.19774 11.5 6.75003L11.5 10.8343L12.7929 9.54137C13.1834 9.15085 13.8166 9.15085 14.2071 9.54137C14.5976 9.9319 14.5976 10.5651 14.2071 10.9556L11.2071 13.9556C10.8166 14.3461 10.1834 14.3461 9.79291 13.9556L6.79291 10.9556C6.40239 10.5651 6.40239 9.9319 6.79291 9.54137C7.18343 9.15085 7.8166 9.15085 8.20712 9.54137L9.50002 10.8343L9.50002 6.75003C9.50002 6.19774 9.94773 5.75003 10.5 5.75003Z"
    clip-rule="evenodd"
  /></svg
>`;

});

parcelRegister("iqnzC", function(module, exports) {

$parcel$export(module.exports, "appStoreSvg", () => $d69cf0ed89a6a7b7$export$bda99385bd09fbb7);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $d69cf0ed89a6a7b7$export$bda99385bd09fbb7 = (0, $i7GIz.svg)`
<svg width="36" height="36">
  <path
    d="M28.724 0H7.271A7.269 7.269 0 0 0 0 7.272v21.46A7.268 7.268 0 0 0 7.271 36H28.73A7.272 7.272 0 0 0 36 28.728V7.272A7.275 7.275 0 0 0 28.724 0Z"
    fill="url(#a)"
  />
  <path
    d="m17.845 8.271.729-1.26a1.64 1.64 0 1 1 2.843 1.638l-7.023 12.159h5.08c1.646 0 2.569 1.935 1.853 3.276H6.434a1.632 1.632 0 0 1-1.638-1.638c0-.909.73-1.638 1.638-1.638h4.176l5.345-9.265-1.67-2.898a1.642 1.642 0 0 1 2.844-1.638l.716 1.264Zm-6.317 17.5-1.575 2.732a1.64 1.64 0 1 1-2.844-1.638l1.17-2.025c1.323-.41 2.398-.095 3.249.931Zm13.56-4.954h4.262c.909 0 1.638.729 1.638 1.638 0 .909-.73 1.638-1.638 1.638h-2.367l1.597 2.772c.45.788.185 1.782-.602 2.241a1.642 1.642 0 0 1-2.241-.603c-2.69-4.666-4.711-8.159-6.052-10.485-1.372-2.367-.391-4.743.576-5.549 1.075 1.846 2.682 4.631 4.828 8.348Z"
    fill="#fff"
  />
  <defs>
    <linearGradient id="a" x1="18" y1="0" x2="18" y2="36" gradientUnits="userSpaceOnUse">
      <stop stop-color="#18BFFB" />
      <stop offset="1" stop-color="#2072F3" />
    </linearGradient>
  </defs>
</svg>`;

});

parcelRegister("2Ckyv", function(module, exports) {

$parcel$export(module.exports, "appleSvg", () => $1e7f13489b5e4769$export$3f5c85d1c093200);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $1e7f13489b5e4769$export$3f5c85d1c093200 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#000" />
      <g clip-path="url(#c)">
        <path
          fill="#fff"
          d="M28.77 23.3c-.69 1.99-2.75 5.52-4.87 5.56-1.4.03-1.86-.84-3.46-.84-1.61 0-2.12.81-3.45.86-2.25.1-5.72-5.1-5.72-9.62 0-4.15 2.9-6.2 5.42-6.25 1.36-.02 2.64.92 3.47.92.83 0 2.38-1.13 4.02-.97.68.03 2.6.28 3.84 2.08-3.27 2.14-2.76 6.61.75 8.25ZM24.2 7.88c-2.47.1-4.49 2.69-4.2 4.84 2.28.17 4.47-2.39 4.2-4.84Z"
        />
      </g>
    </g>
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    <clipPath id="c"><path fill="#fff" d="M8 7.89h24v24H8z" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("95ygG", function(module, exports) {

$parcel$export(module.exports, "arrowBottomSvg", () => $69df299e355b2857$export$6f382756ddebc10);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $69df299e355b2857$export$6f382756ddebc10 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M7 1.99a1 1 0 0 1 1 1v7.58l2.46-2.46a1 1 0 0 1 1.41 1.42L7.7 13.69a1 1 0 0 1-1.41 0L2.12 9.53A1 1 0 0 1 3.54 8.1L6 10.57V3a1 1 0 0 1 1-1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("aEcGa", function(module, exports) {

$parcel$export(module.exports, "arrowLeftSvg", () => $7c07799ce8b32eb5$export$539cc194b4601565);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $7c07799ce8b32eb5$export$539cc194b4601565 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M13 7.99a1 1 0 0 1-1 1H4.4l2.46 2.46a1 1 0 1 1-1.41 1.41L1.29 8.7a1 1 0 0 1 0-1.41L5.46 3.1a1 1 0 0 1 1.41 1.42L4.41 6.99H12a1 1 0 0 1 1 1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("d5s6j", function(module, exports) {

$parcel$export(module.exports, "arrowRightSvg", () => $98718a3e2ad53c4d$export$8c76deeccbfa0068);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $98718a3e2ad53c4d$export$8c76deeccbfa0068 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M1 7.99a1 1 0 0 1 1-1h7.58L7.12 4.53A1 1 0 1 1 8.54 3.1l4.16 4.17a1 1 0 0 1 0 1.41l-4.16 4.17a1 1 0 1 1-1.42-1.41l2.46-2.46H2a1 1 0 0 1-1-1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("l1ksd", function(module, exports) {

$parcel$export(module.exports, "arrowTopSvg", () => $f4d98eb4484b6a30$export$2903aa7e1dab2e70);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $f4d98eb4484b6a30$export$2903aa7e1dab2e70 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M7 13.99a1 1 0 0 1-1-1V5.4L3.54 7.86a1 1 0 0 1-1.42-1.41L6.3 2.28a1 1 0 0 1 1.41 0l4.17 4.17a1 1 0 1 1-1.41 1.41L8 5.4v7.59a1 1 0 0 1-1 1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("gAGDI", function(module, exports) {

$parcel$export(module.exports, "browserSvg", () => $c14115770fc79891$export$9a659d11e13bcec5);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $c14115770fc79891$export$9a659d11e13bcec5 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M4 6.4a1 1 0 0 1-.46.89 6.98 6.98 0 0 0 .38 6.18A7 7 0 0 0 16.46 7.3a1 1 0 0 1-.47-.92 7 7 0 0 0-12 .03Zm-2.02-.5a9 9 0 1 1 16.03 8.2A9 9 0 0 1 1.98 5.9Z"
    clip-rule="evenodd"
  />
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M6.03 8.63c-1.46-.3-2.72-.75-3.6-1.35l-.02-.01-.14-.11a1 1 0 0 1 1.2-1.6l.1.08c.6.4 1.52.74 2.69 1 .16-.99.39-1.88.67-2.65.3-.79.68-1.5 1.15-2.02A2.58 2.58 0 0 1 9.99 1c.8 0 1.45.44 1.92.97.47.52.84 1.23 1.14 2.02.29.77.52 1.66.68 2.64a8 8 0 0 0 2.7-1l.26-.18h.48a1 1 0 0 1 .12 2c-.86.51-2.01.91-3.34 1.18a22.24 22.24 0 0 1-.03 3.19c1.45.29 2.7.73 3.58 1.31a1 1 0 0 1-1.1 1.68c-.6-.4-1.56-.76-2.75-1-.15.8-.36 1.55-.6 2.2-.3.79-.67 1.5-1.14 2.02-.47.53-1.12.97-1.92.97-.8 0-1.45-.44-1.91-.97a6.51 6.51 0 0 1-1.15-2.02c-.24-.65-.44-1.4-.6-2.2-1.18.24-2.13.6-2.73.99a1 1 0 1 1-1.1-1.67c.88-.58 2.12-1.03 3.57-1.31a22.03 22.03 0 0 1-.04-3.2Zm2.2-1.7c.15-.86.34-1.61.58-2.24.24-.65.51-1.12.76-1.4.25-.28.4-.29.42-.29.03 0 .17.01.42.3.25.27.52.74.77 1.4.23.62.43 1.37.57 2.22a19.96 19.96 0 0 1-3.52 0Zm-.18 4.6a20.1 20.1 0 0 1-.03-2.62 21.95 21.95 0 0 0 3.94 0 20.4 20.4 0 0 1-.03 2.63 21.97 21.97 0 0 0-3.88 0Zm.27 2c.13.66.3 1.26.49 1.78.24.65.51 1.12.76 1.4.25.28.4.29.42.29.03 0 .17-.01.42-.3.25-.27.52-.74.77-1.4.19-.5.36-1.1.49-1.78a20.03 20.03 0 0 0-3.35 0Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("u4kVZ", function(module, exports) {

$parcel$export(module.exports, "checkmarkSvg", () => $05a62aa019a6ffae$export$1e994e99baa45d19);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $05a62aa019a6ffae$export$1e994e99baa45d19 = (0, $i7GIz.svg)`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="12"
  height="12"
  viewBox="0 0 12 12"
  fill="none"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10.537 2.34245C10.8997 2.64654 10.9471 3.187 10.6429 3.54959L5.61072 9.54757C5.45645 9.73144 5.23212 9.84222 4.99229 9.85295C4.75247 9.86368 4.51914 9.77337 4.34906 9.60401L1.40881 6.6761C1.07343 6.34213 1.07238 5.7996 1.40647 5.46433C1.74055 5.12906 2.28326 5.12801 2.61865 5.46198L4.89731 7.73108L9.32942 2.44834C9.63362 2.08576 10.1743 2.03835 10.537 2.34245Z"
    fill="currentColor"
  /></svg
>`;

});

parcelRegister("csnz4", function(module, exports) {

$parcel$export(module.exports, "chevronBottomSvg", () => $911a6106fb56a621$export$515090d56df26148);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $911a6106fb56a621$export$515090d56df26148 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M1.46 4.96a1 1 0 0 1 1.41 0L8 10.09l5.13-5.13a1 1 0 1 1 1.41 1.41l-5.83 5.84a1 1 0 0 1-1.42 0L1.46 6.37a1 1 0 0 1 0-1.41Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("cASuh", function(module, exports) {

$parcel$export(module.exports, "chevronLeftSvg", () => $92b31cde619221cf$export$dd4e32e981ac6b2);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $92b31cde619221cf$export$dd4e32e981ac6b2 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M11.04 1.46a1 1 0 0 1 0 1.41L5.91 8l5.13 5.13a1 1 0 1 1-1.41 1.41L3.79 8.71a1 1 0 0 1 0-1.42l5.84-5.83a1 1 0 0 1 1.41 0Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("2jUlk", function(module, exports) {

$parcel$export(module.exports, "chevronRightSvg", () => $1b090fae77eab29f$export$79c9cf11f1aff07c);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $1b090fae77eab29f$export$79c9cf11f1aff07c = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M4.96 14.54a1 1 0 0 1 0-1.41L10.09 8 4.96 2.87a1 1 0 0 1 1.41-1.41l5.84 5.83a1 1 0 0 1 0 1.42l-5.84 5.83a1 1 0 0 1-1.41 0Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("9442H", function(module, exports) {

$parcel$export(module.exports, "chevronTopSvg", () => $69979f89c893c027$export$95ea2c128f24f835);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $69979f89c893c027$export$95ea2c128f24f835 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M14.54 11.04a1 1 0 0 1-1.41 0L8 5.92l-5.13 5.12a1 1 0 1 1-1.41-1.41l5.83-5.84a1 1 0 0 1 1.42 0l5.83 5.84a1 1 0 0 1 0 1.41Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("ciYom", function(module, exports) {

$parcel$export(module.exports, "chromeStoreSvg", () => $8f56030d992907c4$export$a97c1f844e68ea51);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $8f56030d992907c4$export$a97c1f844e68ea51 = (0, $i7GIz.svg)`<svg width="36" height="36" fill="none">
  <path
    fill="#fff"
    fill-opacity=".05"
    d="M0 14.94c0-5.55 0-8.326 1.182-10.4a9 9 0 0 1 3.359-3.358C6.614 0 9.389 0 14.94 0h6.12c5.55 0 8.326 0 10.4 1.182a9 9 0 0 1 3.358 3.359C36 6.614 36 9.389 36 14.94v6.12c0 5.55 0 8.326-1.182 10.4a9 9 0 0 1-3.359 3.358C29.386 36 26.611 36 21.06 36h-6.12c-5.55 0-8.326 0-10.4-1.182a9 9 0 0 1-3.358-3.359C0 29.386 0 26.611 0 21.06v-6.12Z"
  />
  <path
    stroke="#fff"
    stroke-opacity=".05"
    d="M14.94.5h6.12c2.785 0 4.84 0 6.46.146 1.612.144 2.743.43 3.691.97a8.5 8.5 0 0 1 3.172 3.173c.541.948.826 2.08.971 3.692.145 1.62.146 3.675.146 6.459v6.12c0 2.785 0 4.84-.146 6.46-.145 1.612-.43 2.743-.97 3.691a8.5 8.5 0 0 1-3.173 3.172c-.948.541-2.08.826-3.692.971-1.62.145-3.674.146-6.459.146h-6.12c-2.784 0-4.84 0-6.46-.146-1.612-.145-2.743-.43-3.691-.97a8.5 8.5 0 0 1-3.172-3.173c-.541-.948-.827-2.08-.971-3.692C.5 25.9.5 23.845.5 21.06v-6.12c0-2.784 0-4.84.146-6.46.144-1.612.43-2.743.97-3.691A8.5 8.5 0 0 1 4.79 1.617C5.737 1.076 6.869.79 8.48.646 10.1.5 12.156.5 14.94.5Z"
  />
  <path
    fill="url(#a)"
    d="M17.998 10.8h12.469a14.397 14.397 0 0 0-24.938.001l6.234 10.798.006-.001a7.19 7.19 0 0 1 6.23-10.799Z"
  />
  <path
    fill="url(#b)"
    d="m24.237 21.598-6.234 10.798A14.397 14.397 0 0 0 30.47 10.798H18.002l-.002.006a7.191 7.191 0 0 1 6.237 10.794Z"
  />
  <path
    fill="url(#c)"
    d="M11.765 21.601 5.531 10.803A14.396 14.396 0 0 0 18.001 32.4l6.235-10.798-.004-.004a7.19 7.19 0 0 1-12.466.004Z"
  />
  <path fill="#fff" d="M18 25.2a7.2 7.2 0 1 0 0-14.4 7.2 7.2 0 0 0 0 14.4Z" />
  <path fill="#1A73E8" d="M18 23.7a5.7 5.7 0 1 0 0-11.4 5.7 5.7 0 0 0 0 11.4Z" />
  <defs>
    <linearGradient
      id="a"
      x1="6.294"
      x2="41.1"
      y1="5.995"
      y2="5.995"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#D93025" />
      <stop offset="1" stop-color="#EA4335" />
    </linearGradient>
    <linearGradient
      id="b"
      x1="20.953"
      x2="37.194"
      y1="32.143"
      y2="2.701"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#FCC934" />
      <stop offset="1" stop-color="#FBBC04" />
    </linearGradient>
    <linearGradient
      id="c"
      x1="25.873"
      x2="9.632"
      y1="31.2"
      y2="1.759"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#1E8E3E" />
      <stop offset="1" stop-color="#34A853" />
    </linearGradient>
  </defs>
</svg>`;

});

parcelRegister("bKAcd", function(module, exports) {

$parcel$export(module.exports, "clockSvg", () => $88e011638ed898b8$export$36e96663783b415c);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $88e011638ed898b8$export$36e96663783b415c = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M7 2.99a5 5 0 1 0 0 10 5 5 0 0 0 0-10Zm-7 5a7 7 0 1 1 14 0 7 7 0 0 1-14 0Zm7-4a1 1 0 0 1 1 1v2.58l1.85 1.85a1 1 0 0 1-1.41 1.42L6.29 8.69A1 1 0 0 1 6 8v-3a1 1 0 0 1 1-1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("j61FQ", function(module, exports) {

$parcel$export(module.exports, "closeSvg", () => $de6fe0467d524b1c$export$e973b7b7b0b44400);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $de6fe0467d524b1c$export$e973b7b7b0b44400 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M2.54 2.54a1 1 0 0 1 1.42 0L8 6.6l4.04-4.05a1 1 0 1 1 1.42 1.42L9.4 8l4.05 4.04a1 1 0 0 1-1.42 1.42L8 9.4l-4.04 4.05a1 1 0 0 1-1.42-1.42L6.6 8 2.54 3.96a1 1 0 0 1 0-1.42Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("fveAl", function(module, exports) {

$parcel$export(module.exports, "coinPlaceholderSvg", () => $b495109a8c05ebbe$export$c48cbfcb1f749517);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $b495109a8c05ebbe$export$c48cbfcb1f749517 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M10 3a7 7 0 0 0-6.85 8.44l8.29-8.3C10.97 3.06 10.49 3 10 3Zm3.49.93-9.56 9.56c.32.55.71 1.06 1.16 1.5L15 5.1a7.03 7.03 0 0 0-1.5-1.16Zm2.7 2.8-9.46 9.46a7 7 0 0 0 9.46-9.46ZM1.99 5.9A9 9 0 1 1 18 14.09 9 9 0 0 1 1.98 5.91Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("2sLWX", function(module, exports) {

$parcel$export(module.exports, "compassSvg", () => $1cb36428ada914b3$export$9fe5dd11ac55c8d4);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $1cb36428ada914b3$export$9fe5dd11ac55c8d4 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M8 2a6 6 0 1 0 0 12A6 6 0 0 0 8 2ZM0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm10.66-2.65a1 1 0 0 1 .23 1.06L9.83 9.24a1 1 0 0 1-.59.58l-2.83 1.06A1 1 0 0 1 5.13 9.6l1.06-2.82a1 1 0 0 1 .58-.59L9.6 5.12a1 1 0 0 1 1.06.23ZM7.9 7.89l-.13.35.35-.13.12-.35-.34.13Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("8GCCx", function(module, exports) {

$parcel$export(module.exports, "copySvg", () => $65303431913472a4$export$ec40c5c35ef5dd82);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $65303431913472a4$export$ec40c5c35ef5dd82 = (0, $i7GIz.svg)`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="16"
  height="16"
  viewBox="0 0 16 16"
  fill="none"
>
  <path
    fill="currentColor"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M9.21498 1.28565H10.5944C11.1458 1.28562 11.6246 1.2856 12.0182 1.32093C12.4353 1.35836 12.853 1.44155 13.2486 1.66724C13.7005 1.92498 14.0749 2.29935 14.3326 2.75122C14.5583 3.14689 14.6415 3.56456 14.6789 3.9817C14.7143 4.37531 14.7142 4.85403 14.7142 5.40545V6.78489C14.7142 7.33631 14.7143 7.81503 14.6789 8.20865C14.6415 8.62578 14.5583 9.04345 14.3326 9.43912C14.0749 9.89099 13.7005 10.2654 13.2486 10.5231C12.853 10.7488 12.4353 10.832 12.0182 10.8694C11.7003 10.8979 11.3269 10.9034 10.9045 10.9045C10.9034 11.3269 10.8979 11.7003 10.8694 12.0182C10.832 12.4353 10.7488 12.853 10.5231 13.2486C10.2654 13.7005 9.89099 14.0749 9.43912 14.3326C9.04345 14.5583 8.62578 14.6415 8.20865 14.6789C7.81503 14.7143 7.33631 14.7142 6.78489 14.7142H5.40545C4.85403 14.7142 4.37531 14.7143 3.9817 14.6789C3.56456 14.6415 3.14689 14.5583 2.75122 14.3326C2.29935 14.0749 1.92498 13.7005 1.66724 13.2486C1.44155 12.853 1.35836 12.4353 1.32093 12.0182C1.2856 11.6246 1.28562 11.1458 1.28565 10.5944V9.21498C1.28562 8.66356 1.2856 8.18484 1.32093 7.79122C1.35836 7.37409 1.44155 6.95642 1.66724 6.56074C1.92498 6.10887 2.29935 5.73451 2.75122 5.47677C3.14689 5.25108 3.56456 5.16789 3.9817 5.13045C4.2996 5.10192 4.67301 5.09645 5.09541 5.09541C5.09645 4.67302 5.10192 4.2996 5.13045 3.9817C5.16789 3.56456 5.25108 3.14689 5.47676 2.75122C5.73451 2.29935 6.10887 1.92498 6.56074 1.66724C6.95642 1.44155 7.37409 1.35836 7.79122 1.32093C8.18484 1.2856 8.66356 1.28562 9.21498 1.28565ZM5.09541 7.09552C4.68397 7.09667 4.39263 7.10161 4.16046 7.12245C3.88053 7.14757 3.78516 7.18949 3.74214 7.21403C3.60139 7.29431 3.48478 7.41091 3.4045 7.55166C3.37997 7.59468 3.33804 7.69005 3.31292 7.96999C3.28659 8.26345 3.28565 8.65147 3.28565 9.25708V10.5523C3.28565 11.1579 3.28659 11.5459 3.31292 11.8394C3.33804 12.1193 3.37997 12.2147 3.4045 12.2577C3.48478 12.3985 3.60139 12.5151 3.74214 12.5954C3.78516 12.6199 3.88053 12.6618 4.16046 12.6869C4.45393 12.7133 4.84195 12.7142 5.44755 12.7142H6.74279C7.3484 12.7142 7.73641 12.7133 8.02988 12.6869C8.30981 12.6618 8.40518 12.6199 8.44821 12.5954C8.58895 12.5151 8.70556 12.3985 8.78584 12.2577C8.81038 12.2147 8.8523 12.1193 8.87742 11.8394C8.89825 11.6072 8.90319 11.3159 8.90435 10.9045C8.48219 10.9034 8.10898 10.8979 7.79122 10.8694C7.37409 10.832 6.95641 10.7488 6.56074 10.5231C6.10887 10.2654 5.73451 9.89099 5.47676 9.43912C5.25108 9.04345 5.16789 8.62578 5.13045 8.20865C5.10194 7.89089 5.09645 7.51767 5.09541 7.09552ZM7.96999 3.31292C7.69005 3.33804 7.59468 3.37997 7.55166 3.4045C7.41091 3.48478 7.29431 3.60139 7.21403 3.74214C7.18949 3.78516 7.14757 3.88053 7.12245 4.16046C7.09611 4.45393 7.09517 4.84195 7.09517 5.44755V6.74279C7.09517 7.3484 7.09611 7.73641 7.12245 8.02988C7.14757 8.30981 7.18949 8.40518 7.21403 8.4482C7.29431 8.58895 7.41091 8.70556 7.55166 8.78584C7.59468 8.81038 7.69005 8.8523 7.96999 8.87742C8.26345 8.90376 8.65147 8.9047 9.25708 8.9047H10.5523C11.1579 8.9047 11.5459 8.90376 11.8394 8.87742C12.1193 8.8523 12.2147 8.81038 12.2577 8.78584C12.3985 8.70556 12.5151 8.58895 12.5954 8.4482C12.6199 8.40518 12.6618 8.30981 12.6869 8.02988C12.7133 7.73641 12.7142 7.3484 12.7142 6.74279V5.44755C12.7142 4.84195 12.7133 4.45393 12.6869 4.16046C12.6618 3.88053 12.6199 3.78516 12.5954 3.74214C12.5151 3.60139 12.3985 3.48478 12.2577 3.4045C12.2147 3.37997 12.1193 3.33804 11.8394 3.31292C11.5459 3.28659 11.1579 3.28565 10.5523 3.28565H9.25708C8.65147 3.28565 8.26345 3.28659 7.96999 3.31292Z"
    fill="#788181"
  /></svg
>`;

});

parcelRegister("1G7OR", function(module, exports) {

$parcel$export(module.exports, "addSvg", () => $138fc76c13237a61$export$ca7db417ce6a3550);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $138fc76c13237a61$export$ca7db417ce6a3550 = (0, $i7GIz.svg)`<svg
  width="14"
  height="14"
  viewBox="0 0 14 14"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill="currentColor"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7.0023 0.875C7.48571 0.875 7.8776 1.26675 7.8776 1.75V6.125H12.2541C12.7375 6.125 13.1294 6.51675 13.1294 7C13.1294 7.48325 12.7375 7.875 12.2541 7.875H7.8776V12.25C7.8776 12.7332 7.48571 13.125 7.0023 13.125C6.51889 13.125 6.12701 12.7332 6.12701 12.25V7.875H1.75054C1.26713 7.875 0.875244 7.48325 0.875244 7C0.875244 6.51675 1.26713 6.125 1.75054 6.125H6.12701V1.75C6.12701 1.26675 6.51889 0.875 7.0023 0.875Z"
    fill="#47A1FF"
  /></svg
>`;

});

parcelRegister("3NgXO", function(module, exports) {

$parcel$export(module.exports, "cursorSvg", () => $2c331b54e497a509$export$615c57907ad3661f);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $2c331b54e497a509$export$615c57907ad3661f = (0, $i7GIz.svg)` <svg fill="none" viewBox="0 0 13 4">
  <path fill="currentColor" d="M.5 0h12L8.9 3.13a3.76 3.76 0 0 1-4.8 0L.5 0Z" />
</svg>`;

});

parcelRegister("9BaW9", function(module, exports) {

$parcel$export(module.exports, "desktopSvg", () => $6fd00d9f3b297301$export$7a2123fcf97e10d1);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $6fd00d9f3b297301$export$7a2123fcf97e10d1 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M13.66 2H6.34c-1.07 0-1.96 0-2.68.08-.74.08-1.42.25-2.01.68a4 4 0 0 0-.89.89c-.43.6-.6 1.27-.68 2.01C0 6.38 0 7.26 0 8.34v.89c0 1.07 0 1.96.08 2.68.08.74.25 1.42.68 2.01a4 4 0 0 0 .89.89c.6.43 1.27.6 2.01.68a27 27 0 0 0 2.68.08h7.32a27 27 0 0 0 2.68-.08 4.03 4.03 0 0 0 2.01-.68 4 4 0 0 0 .89-.89c.43-.6.6-1.27.68-2.01.08-.72.08-1.6.08-2.68v-.89c0-1.07 0-1.96-.08-2.68a4.04 4.04 0 0 0-.68-2.01 4 4 0 0 0-.89-.89c-.6-.43-1.27-.6-2.01-.68C15.62 2 14.74 2 13.66 2ZM2.82 4.38c.2-.14.48-.25 1.06-.31C4.48 4 5.25 4 6.4 4h7.2c1.15 0 1.93 0 2.52.07.58.06.86.17 1.06.31a2 2 0 0 1 .44.44c.14.2.25.48.31 1.06.07.6.07 1.37.07 2.52v.77c0 1.15 0 1.93-.07 2.52-.06.58-.17.86-.31 1.06a2 2 0 0 1-.44.44c-.2.14-.48.25-1.06.32-.6.06-1.37.06-2.52.06H6.4c-1.15 0-1.93 0-2.52-.06-.58-.07-.86-.18-1.06-.32a2 2 0 0 1-.44-.44c-.14-.2-.25-.48-.31-1.06C2 11.1 2 10.32 2 9.17V8.4c0-1.15 0-1.93.07-2.52.06-.58.17-.86.31-1.06a2 2 0 0 1 .44-.44Z"
    clip-rule="evenodd"
  />
  <path fill="currentColor" d="M6.14 17.57a1 1 0 1 0 0 2h7.72a1 1 0 1 0 0-2H6.14Z" />
</svg>`;

});

parcelRegister("6zAcC", function(module, exports) {

$parcel$export(module.exports, "disconnectSvg", () => $4c92180d476eb3f5$export$50fbdab79b8f082d);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $4c92180d476eb3f5$export$50fbdab79b8f082d = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M6.07 1h.57a1 1 0 0 1 0 2h-.52c-.98 0-1.64 0-2.14.06-.48.05-.7.14-.84.24-.13.1-.25.22-.34.35-.1.14-.2.35-.25.83-.05.5-.05 1.16-.05 2.15v2.74c0 .99 0 1.65.05 2.15.05.48.14.7.25.83.1.14.2.25.34.35.14.1.36.2.84.25.5.05 1.16.05 2.14.05h.52a1 1 0 0 1 0 2h-.57c-.92 0-1.69 0-2.3-.07a3.6 3.6 0 0 1-1.8-.61c-.3-.22-.57-.49-.8-.8a3.6 3.6 0 0 1-.6-1.79C.5 11.11.5 10.35.5 9.43V6.58c0-.92 0-1.7.06-2.31a3.6 3.6 0 0 1 .62-1.8c.22-.3.48-.57.79-.79a3.6 3.6 0 0 1 1.8-.61C4.37 1 5.14 1 6.06 1ZM9.5 3a1 1 0 0 1 1.42 0l4.28 4.3a1 1 0 0 1 0 1.4L10.93 13a1 1 0 0 1-1.42-1.42L12.1 9H6.8a1 1 0 1 1 0-2h5.3L9.51 4.42a1 1 0 0 1 0-1.41Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("dkY4I", function(module, exports) {

$parcel$export(module.exports, "discordSvg", () => $9b5bbe42c2411ea8$export$29470bd7472aef51);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $9b5bbe42c2411ea8$export$29470bd7472aef51 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#5865F2" />
      <path
        fill="#fff"
        fill-rule="evenodd"
        d="M25.71 28.15C30.25 28 32 25.02 32 25.02c0-6.61-2.96-11.98-2.96-11.98-2.96-2.22-5.77-2.15-5.77-2.15l-.29.32c3.5 1.07 5.12 2.61 5.12 2.61a16.75 16.75 0 0 0-10.34-1.93l-.35.04a15.43 15.43 0 0 0-5.88 1.9s1.71-1.63 5.4-2.7l-.2-.24s-2.81-.07-5.77 2.15c0 0-2.96 5.37-2.96 11.98 0 0 1.73 2.98 6.27 3.13l1.37-1.7c-2.6-.79-3.6-2.43-3.6-2.43l.58.35.09.06.08.04.02.01.08.05a17.25 17.25 0 0 0 4.52 1.58 14.4 14.4 0 0 0 8.3-.86c.72-.27 1.52-.66 2.37-1.21 0 0-1.03 1.68-3.72 2.44.61.78 1.35 1.67 1.35 1.67Zm-9.55-9.6c-1.17 0-2.1 1.03-2.1 2.28 0 1.25.95 2.28 2.1 2.28 1.17 0 2.1-1.03 2.1-2.28.01-1.25-.93-2.28-2.1-2.28Zm7.5 0c-1.17 0-2.1 1.03-2.1 2.28 0 1.25.95 2.28 2.1 2.28 1.17 0 2.1-1.03 2.1-2.28 0-1.25-.93-2.28-2.1-2.28Z"
        clip-rule="evenodd"
      />
    </g>
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("aGIyC", function(module, exports) {

$parcel$export(module.exports, "etherscanSvg", () => $7c8063c6f3f64bd9$export$fad2d5a54496223b);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $7c8063c6f3f64bd9$export$fad2d5a54496223b = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    d="M4.25 7a.63.63 0 0 0-.63.63v3.97c0 .28-.2.51-.47.54l-.75.07a.93.93 0 0 1-.9-.47A7.51 7.51 0 0 1 5.54.92a7.5 7.5 0 0 1 9.54 4.62c.12.35.06.72-.16 1-.74.97-1.68 1.78-2.6 2.44V4.44a.64.64 0 0 0-.63-.64h-1.06c-.35 0-.63.3-.63.64v5.5c0 .23-.12.42-.32.5l-.52.23V6.05c0-.36-.3-.64-.64-.64H7.45c-.35 0-.64.3-.64.64v4.97c0 .25-.17.46-.4.52a5.8 5.8 0 0 0-.45.11v-4c0-.36-.3-.65-.64-.65H4.25ZM14.07 12.4A7.49 7.49 0 0 1 3.6 14.08c4.09-.58 9.14-2.5 11.87-6.6v.03a7.56 7.56 0 0 1-1.41 4.91Z"
  />
</svg>`;

});

parcelRegister("2qjZ2", function(module, exports) {

$parcel$export(module.exports, "extensionSvg", () => $1c3d82c7bb6c65e6$export$df81a22cbcc6237a);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $1c3d82c7bb6c65e6$export$df81a22cbcc6237a = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M6.71 2.99a.57.57 0 0 0-.57.57 1 1 0 0 1-1 1c-.58 0-.96 0-1.24.03-.27.03-.37.07-.42.1a.97.97 0 0 0-.36.35c-.04.08-.09.21-.11.67a2.57 2.57 0 0 1 0 5.13c.02.45.07.6.11.66.09.15.21.28.36.36.07.04.21.1.67.12a2.57 2.57 0 0 1 5.12 0c.46-.03.6-.08.67-.12a.97.97 0 0 0 .36-.36c.03-.04.07-.14.1-.41.02-.29.03-.66.03-1.24a1 1 0 0 1 1-1 .57.57 0 0 0 0-1.15 1 1 0 0 1-1-1c0-.58 0-.95-.03-1.24a1.04 1.04 0 0 0-.1-.42.97.97 0 0 0-.36-.36 1.04 1.04 0 0 0-.42-.1c-.28-.02-.65-.02-1.24-.02a1 1 0 0 1-1-1 .57.57 0 0 0-.57-.57ZM5.15 13.98a1 1 0 0 0 .99-1v-.78a.57.57 0 0 1 1.14 0v.78a1 1 0 0 0 .99 1H8.36a66.26 66.26 0 0 0 .73 0 3.78 3.78 0 0 0 1.84-.38c.46-.26.85-.64 1.1-1.1.23-.4.32-.8.36-1.22.02-.2.03-.4.03-.63a2.57 2.57 0 0 0 0-4.75c0-.23-.01-.44-.03-.63a2.96 2.96 0 0 0-.35-1.22 2.97 2.97 0 0 0-1.1-1.1c-.4-.22-.8-.31-1.22-.35a8.7 8.7 0 0 0-.64-.04 2.57 2.57 0 0 0-4.74 0c-.23 0-.44.02-.63.04-.42.04-.83.13-1.22.35-.46.26-.84.64-1.1 1.1-.33.57-.37 1.2-.39 1.84a21.39 21.39 0 0 0 0 .72v.1a1 1 0 0 0 1 .99h.78a.57.57 0 0 1 0 1.15h-.77a1 1 0 0 0-1 .98v.1a63.87 63.87 0 0 0 0 .73c0 .64.05 1.27.38 1.83.26.47.64.85 1.1 1.11.56.32 1.2.37 1.84.38a20.93 20.93 0 0 0 .72 0h.1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("4rmYj", function(module, exports) {

$parcel$export(module.exports, "externalLinkSvg", () => $33bb80c3989f0abc$export$34a422f948687038);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $33bb80c3989f0abc$export$34a422f948687038 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M3.74 3.99a1 1 0 0 1 1-1H11a1 1 0 0 1 1 1v6.26a1 1 0 0 1-2 0V6.4l-6.3 6.3a1 1 0 0 1-1.4-1.42l6.29-6.3H4.74a1 1 0 0 1-1-1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("kz5qi", function(module, exports) {

$parcel$export(module.exports, "facebookSvg", () => $ef8b486f825beea6$export$1ff5018c782ba6f);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $ef8b486f825beea6$export$1ff5018c782ba6f = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#1877F2" />
      <g clip-path="url(#c)">
        <path
          fill="#fff"
          d="M26 12.38h-2.89c-.92 0-1.61.38-1.61 1.34v1.66H26l-.36 4.5H21.5v12H17v-12h-3v-4.5h3V12.5c0-3.03 1.6-4.62 5.2-4.62H26v4.5Z"
        />
      </g>
    </g>
    <path
      fill="#1877F2"
      d="M40 20a20 20 0 1 0-23.13 19.76V25.78H11.8V20h5.07v-4.4c0-5.02 3-7.79 7.56-7.79 2.19 0 4.48.4 4.48.4v4.91h-2.53c-2.48 0-3.25 1.55-3.25 3.13V20h5.54l-.88 5.78h-4.66v13.98A20 20 0 0 0 40 20Z"
    />
    <path
      fill="#fff"
      d="m27.79 25.78.88-5.78h-5.55v-3.75c0-1.58.78-3.13 3.26-3.13h2.53V8.2s-2.3-.39-4.48-.39c-4.57 0-7.55 2.77-7.55 7.78V20H11.8v5.78h5.07v13.98a20.15 20.15 0 0 0 6.25 0V25.78h4.67Z"
    />
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    <clipPath id="c"><path fill="#fff" d="M8 7.89h24v24H8z" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("j4WJo", function(module, exports) {

$parcel$export(module.exports, "filtersSvg", () => $de3bf2d7e1e1c32e$export$9261929cf6dcbff0);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $de3bf2d7e1e1c32e$export$9261929cf6dcbff0 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M0 3a1 1 0 0 1 1-1h14a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1Zm2.63 5.25a1 1 0 0 1 1-1h8.75a1 1 0 1 1 0 2H3.63a1 1 0 0 1-1-1Zm2.62 5.25a1 1 0 0 1 1-1h3.5a1 1 0 0 1 0 2h-3.5a1 1 0 0 1-1-1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("5xYTe", function(module, exports) {

$parcel$export(module.exports, "githubSvg", () => $409f4440ede8ec77$export$f094865edb198013);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $409f4440ede8ec77$export$f094865edb198013 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#1B1F23" />
      <g clip-path="url(#c)">
        <path
          fill="#fff"
          d="M8 19.89a12 12 0 1 1 15.8 11.38c-.6.12-.8-.26-.8-.57v-3.3c0-1.12-.4-1.85-.82-2.22 2.67-.3 5.48-1.31 5.48-5.92 0-1.31-.47-2.38-1.24-3.22.13-.3.54-1.52-.12-3.18 0 0-1-.32-3.3 1.23a11.54 11.54 0 0 0-6 0c-2.3-1.55-3.3-1.23-3.3-1.23a4.32 4.32 0 0 0-.12 3.18 4.64 4.64 0 0 0-1.24 3.22c0 4.6 2.8 5.63 5.47 5.93-.34.3-.65.83-.76 1.6-.69.31-2.42.84-3.5-1 0 0-.63-1.15-1.83-1.23 0 0-1.18-.02-.09.73 0 0 .8.37 1.34 1.76 0 0 .7 2.14 4.03 1.41v2.24c0 .31-.2.68-.8.57A12 12 0 0 1 8 19.9Z"
        />
      </g>
    </g>
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    <clipPath id="c"><path fill="#fff" d="M8 7.89h24v24H8z" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("66vi1", function(module, exports) {

$parcel$export(module.exports, "googleSvg", () => $471b931612106ad8$export$62a66155552ed9b0);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $471b931612106ad8$export$62a66155552ed9b0 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#fff" fill-opacity=".05" />
      <g clip-path="url(#c)">
        <path
          fill="#4285F4"
          d="M20 17.7v4.65h6.46a5.53 5.53 0 0 1-2.41 3.61l3.9 3.02c2.26-2.09 3.57-5.17 3.57-8.82 0-.85-.08-1.67-.22-2.46H20Z"
        />
        <path
          fill="#34A853"
          d="m13.27 22.17-.87.67-3.11 2.42A12 12 0 0 0 20 31.9c3.24 0 5.96-1.07 7.94-2.9l-3.9-3.03A7.15 7.15 0 0 1 20 27.12a7.16 7.16 0 0 1-6.72-4.94v-.01Z"
        />
        <path
          fill="#FBBC05"
          d="M9.29 14.5a11.85 11.85 0 0 0 0 10.76l3.99-3.1a7.19 7.19 0 0 1 0-4.55l-4-3.1Z"
        />
        <path
          fill="#EA4335"
          d="M20 12.66c1.77 0 3.34.61 4.6 1.8l3.43-3.44A11.51 11.51 0 0 0 20 7.89c-4.7 0-8.74 2.69-10.71 6.62l3.99 3.1A7.16 7.16 0 0 1 20 12.66Z"
        />
      </g>
    </g>
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    <clipPath id="c"><path fill="#fff" d="M8 7.89h24v24H8z" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("4Agvs", function(module, exports) {

$parcel$export(module.exports, "helpCircleSvg", () => $35675409963136a2$export$cbf7b9dd25929c90);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $35675409963136a2$export$cbf7b9dd25929c90 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    d="M8.51 5.66a.83.83 0 0 0-.57-.2.83.83 0 0 0-.52.28.8.8 0 0 0-.25.52 1 1 0 0 1-2 0c0-.75.34-1.43.81-1.91a2.75 2.75 0 0 1 4.78 1.92c0 1.24-.8 1.86-1.25 2.2l-.04.03c-.47.36-.5.43-.5.65a1 1 0 1 1-2 0c0-1.25.8-1.86 1.24-2.2l.04-.04c.47-.36.5-.43.5-.65 0-.3-.1-.49-.24-.6ZM9.12 11.87a1.13 1.13 0 1 1-2.25 0 1.13 1.13 0 0 1 2.25 0Z"
  />
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8Zm8-6a6 6 0 1 0 0 12A6 6 0 0 0 8 2Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("arlmD", function(module, exports) {

$parcel$export(module.exports, "infoCircleSvg", () => $799cff75d46fda47$export$313082e449e2d152);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $799cff75d46fda47$export$313082e449e2d152 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 14 15">
  <path
    fill="currentColor"
    d="M6 10.49a1 1 0 1 0 2 0v-2a1 1 0 0 0-2 0v2ZM7 4.49a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
  />
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M7 14.99a7 7 0 1 0 0-14 7 7 0 0 0 0 14Zm5-7a5 5 0 1 1-10 0 5 5 0 0 1 10 0Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("lL9Sp", function(module, exports) {

$parcel$export(module.exports, "mailSvg", () => $fd75a60fb13f46b8$export$a9b1939cca165cd6);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $fd75a60fb13f46b8$export$a9b1939cca165cd6 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M4.83 1.34h6.34c.68 0 1.26 0 1.73.04.5.05.97.15 1.42.4.52.3.95.72 1.24 1.24.26.45.35.92.4 1.42.04.47.04 1.05.04 1.73v3.71c0 .69 0 1.26-.04 1.74-.05.5-.14.97-.4 1.41-.3.52-.72.95-1.24 1.25-.45.25-.92.35-1.42.4-.47.03-1.05.03-1.73.03H4.83c-.68 0-1.26 0-1.73-.04-.5-.04-.97-.14-1.42-.4-.52-.29-.95-.72-1.24-1.24a3.39 3.39 0 0 1-.4-1.41A20.9 20.9 0 0 1 0 9.88v-3.7c0-.7 0-1.27.04-1.74.05-.5.14-.97.4-1.42.3-.52.72-.95 1.24-1.24.45-.25.92-.35 1.42-.4.47-.04 1.05-.04 1.73-.04ZM3.28 3.38c-.36.03-.51.08-.6.14-.21.11-.39.29-.5.5a.8.8 0 0 0-.08.19l5.16 3.44c.45.3 1.03.3 1.48 0L13.9 4.2a.79.79 0 0 0-.08-.2c-.11-.2-.29-.38-.5-.5-.09-.05-.24-.1-.6-.13-.37-.04-.86-.04-1.6-.04H4.88c-.73 0-1.22 0-1.6.04ZM14 6.54 9.85 9.31a3.33 3.33 0 0 1-3.7 0L2 6.54v3.3c0 .74 0 1.22.03 1.6.04.36.1.5.15.6.11.2.29.38.5.5.09.05.24.1.6.14.37.03.86.03 1.6.03h6.25c.73 0 1.22 0 1.6-.03.35-.03.5-.09.6-.14.2-.12.38-.3.5-.5.05-.1.1-.24.14-.6.03-.38.03-.86.03-1.6v-3.3Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("8HvLJ", function(module, exports) {

$parcel$export(module.exports, "mobileSvg", () => $655afb8a126b44dd$export$b6a7821857ebc7d7);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $655afb8a126b44dd$export$b6a7821857ebc7d7 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path fill="currentColor" d="M10.81 5.81a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" />
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M3 4.75A4.75 4.75 0 0 1 7.75 0h4.5A4.75 4.75 0 0 1 17 4.75v10.5A4.75 4.75 0 0 1 12.25 20h-4.5A4.75 4.75 0 0 1 3 15.25V4.75ZM7.75 2A2.75 2.75 0 0 0 5 4.75v10.5A2.75 2.75 0 0 0 7.75 18h4.5A2.75 2.75 0 0 0 15 15.25V4.75A2.75 2.75 0 0 0 12.25 2h-4.5Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("drOKp", function(module, exports) {

$parcel$export(module.exports, "networkPlaceholderSvg", () => $9ca52962055c38c4$export$8eef6146d36b9527);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $9ca52962055c38c4$export$8eef6146d36b9527 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 22 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M16.32 13.62a3.14 3.14 0 1 1-.99 1.72l-1.6-.93a3.83 3.83 0 0 1-3.71 1 3.66 3.66 0 0 1-1.74-1l-1.6.94a3.14 3.14 0 1 1-1-1.73l1.6-.94a3.7 3.7 0 0 1 0-2 3.81 3.81 0 0 1 1.8-2.33c.29-.17.6-.3.92-.38V6.1a3.14 3.14 0 1 1 2 0l-.01.02v1.85H12a3.82 3.82 0 0 1 2.33 1.8 3.7 3.7 0 0 1 .39 2.91l1.6.93ZM2.6 16.54a1.14 1.14 0 0 0 1.98-1.14 1.14 1.14 0 0 0-1.98 1.14ZM11 2.01a1.14 1.14 0 1 0 0 2.28 1.14 1.14 0 0 0 0-2.28Zm1.68 10.45c.08-.19.14-.38.16-.58v-.05l.02-.13v-.13a1.92 1.92 0 0 0-.24-.8l-.11-.15a1.89 1.89 0 0 0-.74-.6 1.86 1.86 0 0 0-.77-.17h-.19a1.97 1.97 0 0 0-.89.34 1.98 1.98 0 0 0-.61.74 1.99 1.99 0 0 0-.16.9v.05a1.87 1.87 0 0 0 .24.74l.1.15c.12.16.26.3.42.42l.16.1.13.07.04.02a1.84 1.84 0 0 0 .76.17h.17a2 2 0 0 0 .91-.35 1.78 1.78 0 0 0 .52-.58l.03-.05a.84.84 0 0 0 .05-.11Zm5.15 4.5a1.14 1.14 0 0 0 1.14-1.97 1.13 1.13 0 0 0-1.55.41c-.32.55-.13 1.25.41 1.56Z"
    clip-rule="evenodd"
  />
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M4.63 9.43a1.5 1.5 0 1 0 1.5-2.6 1.5 1.5 0 0 0-1.5 2.6Zm.32-1.55a.5.5 0 0 1 .68-.19.5.5 0 0 1 .18.68.5.5 0 0 1-.68.19.5.5 0 0 1-.18-.68ZM17.94 8.88a1.5 1.5 0 1 1-2.6-1.5 1.5 1.5 0 1 1 2.6 1.5ZM16.9 7.69a.5.5 0 0 0-.68.19.5.5 0 0 0 .18.68.5.5 0 0 0 .68-.19.5.5 0 0 0-.18-.68ZM9.75 17.75a1.5 1.5 0 1 1 2.6 1.5 1.5 1.5 0 1 1-2.6-1.5Zm1.05 1.18a.5.5 0 0 0 .68-.18.5.5 0 0 0-.18-.68.5.5 0 0 0-.68.18.5.5 0 0 0 .18.68Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("gnrzt", function(module, exports) {

$parcel$export(module.exports, "nftPlaceholderSvg", () => $bec42e634715f05f$export$cacef02b4679549a);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $bec42e634715f05f$export$cacef02b4679549a = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M9.13 1h1.71c1.46 0 2.63 0 3.56.1.97.1 1.8.33 2.53.85a5 5 0 0 1 1.1 1.11c.53.73.75 1.56.86 2.53.1.93.1 2.1.1 3.55v1.72c0 1.45 0 2.62-.1 3.55-.1.97-.33 1.8-.86 2.53a5 5 0 0 1-1.1 1.1c-.73.53-1.56.75-2.53.86-.93.1-2.1.1-3.55.1H9.13c-1.45 0-2.62 0-3.56-.1-.96-.1-1.8-.33-2.52-.85a5 5 0 0 1-1.1-1.11 5.05 5.05 0 0 1-.86-2.53c-.1-.93-.1-2.1-.1-3.55V9.14c0-1.45 0-2.62.1-3.55.1-.97.33-1.8.85-2.53a5 5 0 0 1 1.1-1.1 5.05 5.05 0 0 1 2.53-.86C6.51 1 7.67 1 9.13 1ZM5.79 3.09a3.1 3.1 0 0 0-1.57.48 3 3 0 0 0-.66.67c-.24.32-.4.77-.48 1.56-.1.82-.1 1.88-.1 3.4v1.6c0 1.15 0 2.04.05 2.76l.41-.42c.5-.5.93-.92 1.32-1.24.41-.33.86-.6 1.43-.7a3 3 0 0 1 .94 0c.35.06.66.2.95.37a17.11 17.11 0 0 0 .8.45c.1-.08.2-.2.41-.4l.04-.03a27 27 0 0 1 1.95-1.84 4.03 4.03 0 0 1 1.91-.94 4 4 0 0 1 1.25 0c.73.11 1.33.46 1.91.94l.64.55V9.2c0-1.52 0-2.58-.1-3.4a3.1 3.1 0 0 0-.48-1.56 3 3 0 0 0-.66-.67 3.1 3.1 0 0 0-1.56-.48C13.37 3 12.3 3 10.79 3h-1.6c-1.52 0-2.59 0-3.4.09Zm11.18 10-.04-.05a26.24 26.24 0 0 0-1.83-1.74c-.45-.36-.73-.48-.97-.52a2 2 0 0 0-.63 0c-.24.04-.51.16-.97.52-.46.38-1.01.93-1.83 1.74l-.02.02c-.17.18-.34.34-.49.47a2.04 2.04 0 0 1-1.08.5 1.97 1.97 0 0 1-1.25-.27l-.79-.46-.02-.02a.65.65 0 0 0-.24-.1 1 1 0 0 0-.31 0c-.08.02-.21.06-.49.28-.3.24-.65.59-1.2 1.14l-.56.56-.65.66a3 3 0 0 0 .62.6c.33.24.77.4 1.57.49.81.09 1.88.09 3.4.09h1.6c1.52 0 2.58 0 3.4-.09a3.1 3.1 0 0 0 1.56-.48 3 3 0 0 0 .66-.67c.24-.32.4-.77.49-1.56l.07-1.12Zm-8.02-1.03ZM4.99 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("3y8Z6", function(module, exports) {

$parcel$export(module.exports, "offSvg", () => $295b843523984d9f$export$7ec09ee48c3bf315);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $295b843523984d9f$export$7ec09ee48c3bf315 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M8 0a1 1 0 0 1 1 1v5.38a1 1 0 0 1-2 0V1a1 1 0 0 1 1-1ZM5.26 2.6a1 1 0 0 1-.28 1.39 5.46 5.46 0 1 0 6.04 0 1 1 0 1 1 1.1-1.67 7.46 7.46 0 1 1-8.25 0 1 1 0 0 1 1.4.28Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("9vKL7", function(module, exports) {

$parcel$export(module.exports, "playStoreSvg", () => $6ecb47a943454f3d$export$65007b9f28ed0950);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $6ecb47a943454f3d$export$65007b9f28ed0950 = (0, $i7GIz.svg)` <svg
  width="36"
  height="36"
  fill="none"
>
  <path
    d="M0 8a8 8 0 0 1 8-8h20a8 8 0 0 1 8 8v20a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8V8Z"
    fill="#fff"
    fill-opacity=".05"
  />
  <path
    d="m18.262 17.513-8.944 9.49v.01a2.417 2.417 0 0 0 3.56 1.452l.026-.017 10.061-5.803-4.703-5.132Z"
    fill="#EA4335"
  />
  <path
    d="m27.307 15.9-.008-.008-4.342-2.52-4.896 4.36 4.913 4.912 4.325-2.494a2.42 2.42 0 0 0 .008-4.25Z"
    fill="#FBBC04"
  />
  <path
    d="M9.318 8.997c-.05.202-.084.403-.084.622V26.39c0 .218.025.42.084.621l9.246-9.247-9.246-8.768Z"
    fill="#4285F4"
  />
  <path
    d="m18.33 18 4.627-4.628-10.053-5.828a2.427 2.427 0 0 0-3.586 1.444L18.329 18Z"
    fill="#34A853"
  />
  <path
    d="M8 .5h20A7.5 7.5 0 0 1 35.5 8v20a7.5 7.5 0 0 1-7.5 7.5H8A7.5 7.5 0 0 1 .5 28V8A7.5 7.5 0 0 1 8 .5Z"
    stroke="#fff"
    stroke-opacity=".05"
  />
</svg>`;

});

parcelRegister("94jxI", function(module, exports) {

$parcel$export(module.exports, "qrCodeIcon", () => $69a3a58d4cc5cd7c$export$b033e2eb4807deba);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $69a3a58d4cc5cd7c$export$b033e2eb4807deba = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    d="M3 6a3 3 0 0 1 3-3h1a1 1 0 1 0 0-2H6a5 5 0 0 0-5 5v1a1 1 0 0 0 2 0V6ZM13 1a1 1 0 1 0 0 2h1a3 3 0 0 1 3 3v1a1 1 0 1 0 2 0V6a5 5 0 0 0-5-5h-1ZM3 13a1 1 0 1 0-2 0v1a5 5 0 0 0 5 5h1a1 1 0 1 0 0-2H6a3 3 0 0 1-3-3v-1ZM19 13a1 1 0 1 0-2 0v1a3 3 0 0 1-3 3h-1a1 1 0 1 0 0 2h1.01a5 5 0 0 0 5-5v-1ZM5.3 6.36c-.04.2-.04.43-.04.89s0 .7.05.89c.14.52.54.92 1.06 1.06.19.05.42.05.89.05.46 0 .7 0 .88-.05A1.5 1.5 0 0 0 9.2 8.14c.06-.2.06-.43.06-.89s0-.7-.06-.89A1.5 1.5 0 0 0 8.14 5.3c-.19-.05-.42-.05-.88-.05-.47 0-.7 0-.9.05a1.5 1.5 0 0 0-1.05 1.06ZM10.8 6.36c-.04.2-.04.43-.04.89s0 .7.05.89c.14.52.54.92 1.06 1.06.19.05.42.05.89.05.46 0 .7 0 .88-.05a1.5 1.5 0 0 0 1.06-1.06c.06-.2.06-.43.06-.89s0-.7-.06-.89a1.5 1.5 0 0 0-1.06-1.06c-.19-.05-.42-.05-.88-.05-.47 0-.7 0-.9.05a1.5 1.5 0 0 0-1.05 1.06ZM5.26 12.75c0-.46 0-.7.05-.89a1.5 1.5 0 0 1 1.06-1.06c.19-.05.42-.05.89-.05.46 0 .7 0 .88.05.52.14.93.54 1.06 1.06.06.2.06.43.06.89s0 .7-.06.89a1.5 1.5 0 0 1-1.06 1.06c-.19.05-.42.05-.88.05-.47 0-.7 0-.9-.05a1.5 1.5 0 0 1-1.05-1.06c-.05-.2-.05-.43-.05-.89ZM10.8 11.86c-.04.2-.04.43-.04.89s0 .7.05.89c.14.52.54.92 1.06 1.06.19.05.42.05.89.05.46 0 .7 0 .88-.05a1.5 1.5 0 0 0 1.06-1.06c.06-.2.06-.43.06-.89s0-.7-.06-.89a1.5 1.5 0 0 0-1.06-1.06c-.19-.05-.42-.05-.88-.05-.47 0-.7 0-.9.05a1.5 1.5 0 0 0-1.05 1.06Z"
  />
</svg>`;

});

parcelRegister("hXt04", function(module, exports) {

$parcel$export(module.exports, "refreshSvg", () => $d12e712c8d5de83f$export$bbe3b42eaaf82fae);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $d12e712c8d5de83f$export$bbe3b42eaaf82fae = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 14 16">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M3.94 1.04a1 1 0 0 1 .7 1.23l-.48 1.68a5.85 5.85 0 0 1 8.53 4.32 5.86 5.86 0 0 1-11.4 2.56 1 1 0 0 1 1.9-.57 3.86 3.86 0 1 0 1.83-4.5l1.87.53a1 1 0 0 1-.55 1.92l-4.1-1.15a1 1 0 0 1-.69-1.23l1.16-4.1a1 1 0 0 1 1.23-.7Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("j3Kl1", function(module, exports) {

$parcel$export(module.exports, "searchSvg", () => $de023de9ea83a3ac$export$28881e95f40c5f68);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $de023de9ea83a3ac$export$28881e95f40c5f68 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M9.36 4.21a5.14 5.14 0 1 0 0 10.29 5.14 5.14 0 0 0 0-10.29ZM1.64 9.36a7.71 7.71 0 1 1 14 4.47l2.52 2.5a1.29 1.29 0 1 1-1.82 1.83l-2.51-2.51A7.71 7.71 0 0 1 1.65 9.36Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("1ydAd", function(module, exports) {

$parcel$export(module.exports, "sendSvg", () => $121380c23556f3f5$export$cc4f2fc255fe3f38);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $121380c23556f3f5$export$cc4f2fc255fe3f38 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 21 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M14.3808 4.34812C13.72 4.47798 12.8501 4.7587 11.5748 5.17296L9.00869 6.00646C6.90631 6.68935 5.40679 7.17779 4.38121 7.63178C3.87166 7.85734 3.5351 8.05091 3.32022 8.22035C3.11183 8.38466 3.07011 8.48486 3.05969 8.51817C2.98058 8.77103 2.98009 9.04195 3.05831 9.29509C3.06861 9.32844 3.10998 9.42878 3.31777 9.59384C3.53205 9.76404 3.86792 9.95881 4.37667 10.1862C5.29287 10.5957 6.58844 11.0341 8.35529 11.6164L10.8876 8.59854C11.2426 8.17547 11.8733 8.12028 12.2964 8.47528C12.7195 8.83029 12.7746 9.46104 12.4196 9.88412L9.88738 12.9019C10.7676 14.5408 11.4244 15.7406 11.9867 16.5718C12.299 17.0333 12.5491 17.3303 12.7539 17.5117C12.9526 17.6877 13.0586 17.711 13.0932 17.7154C13.3561 17.7484 13.6228 17.7009 13.8581 17.5791C13.8891 17.563 13.9805 17.5046 14.1061 17.2708C14.2357 17.0298 14.3679 16.6647 14.5015 16.1237C14.7705 15.0349 14.9912 13.4733 15.2986 11.2843L15.6738 8.61249C15.8603 7.28456 15.9857 6.37917 15.9989 5.7059C16.012 5.03702 15.9047 4.8056 15.8145 4.69183C15.7044 4.55297 15.5673 4.43792 15.4114 4.35365C15.2837 4.28459 15.0372 4.2191 14.3808 4.34812ZM7.99373 13.603C6.11919 12.9864 4.6304 12.4902 3.5606 12.0121C2.98683 11.7557 2.4778 11.4808 2.07383 11.1599C1.66337 10.8339 1.31312 10.4217 1.14744 9.88551C0.949667 9.24541 0.950886 8.56035 1.15094 7.92096C1.31852 7.38534 1.67024 6.97442 2.08185 6.64985C2.48697 6.33041 2.99697 6.05734 3.57166 5.80295C4.70309 5.3021 6.30179 4.78283 8.32903 4.12437L11.0196 3.25042C12.2166 2.86159 13.2017 2.54158 13.9951 2.38566C14.8065 2.22618 15.6202 2.19289 16.3627 2.59437C16.7568 2.80747 17.1035 3.09839 17.3818 3.4495C17.9062 4.111 18.0147 4.91815 17.9985 5.74496C17.9827 6.55332 17.8386 7.57903 17.6636 8.82534L17.2701 11.6268C16.9737 13.7376 16.7399 15.4022 16.4432 16.6034C16.2924 17.2135 16.1121 17.7632 15.8678 18.2176C15.6197 18.6794 15.2761 19.0971 14.7777 19.3551C14.1827 19.6632 13.5083 19.7833 12.8436 19.6997C12.2867 19.6297 11.82 19.3563 11.4277 19.0087C11.0415 18.6666 10.6824 18.213 10.3302 17.6925C9.67361 16.722 8.92648 15.342 7.99373 13.603Z"
    clip-rule="evenodd"
  />
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
  ></svg></svg
>`;

});

parcelRegister("jVj0p", function(module, exports) {

$parcel$export(module.exports, "swapHorizontalSvg", () => $e81215491f0379b5$export$43cc65051e9f7716);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $e81215491f0379b5$export$43cc65051e9f7716 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M6.76.3a1 1 0 0 1 0 1.4L4.07 4.4h9a1 1 0 1 1 0 2h-9l2.69 2.68a1 1 0 1 1-1.42 1.42L.95 6.09a1 1 0 0 1 0-1.4l4.4-4.4a1 1 0 0 1 1.4 0Zm6.49 9.21a1 1 0 0 1 1.41 0l4.39 4.4a1 1 0 0 1 0 1.4l-4.39 4.4a1 1 0 0 1-1.41-1.42l2.68-2.68h-9a1 1 0 0 1 0-2h9l-2.68-2.68a1 1 0 0 1 0-1.42Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("e4XTB", function(module, exports) {

$parcel$export(module.exports, "swapHorizontalBoldSvg", () => $a3ffe67f144a39a7$export$6929881544dda4e0);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $a3ffe67f144a39a7$export$6929881544dda4e0 = (0, $i7GIz.svg)`<svg width="10" height="10" viewBox="0 0 10 10">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M3.77986 0.566631C4.0589 0.845577 4.0589 1.29784 3.77986 1.57678L3.08261 2.2738H6.34184C6.73647 2.2738 7.05637 2.5936 7.05637 2.98808C7.05637 3.38257 6.73647 3.70237 6.34184 3.70237H3.08261L3.77986 4.39938C4.0589 4.67833 4.0589 5.13059 3.77986 5.40954C3.50082 5.68848 3.04841 5.68848 2.76937 5.40954L0.852346 3.49316C0.573306 3.21421 0.573306 2.76195 0.852346 2.48301L2.76937 0.566631C3.04841 0.287685 3.50082 0.287685 3.77986 0.566631ZM6.22 4.59102C6.49904 4.31208 6.95145 4.31208 7.23049 4.59102L9.14751 6.5074C9.42655 6.78634 9.42655 7.23861 9.14751 7.51755L7.23049 9.43393C6.95145 9.71287 6.49904 9.71287 6.22 9.43393C5.94096 9.15498 5.94096 8.70272 6.22 8.42377L6.91725 7.72676L3.65802 7.72676C3.26339 7.72676 2.94349 7.40696 2.94349 7.01247C2.94349 6.61798 3.26339 6.29819 3.65802 6.29819L6.91725 6.29819L6.22 5.60117C5.94096 5.32223 5.94096 4.86997 6.22 4.59102Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("hd4ge", function(module, exports) {

$parcel$export(module.exports, "swapHorizontalMediumSvg", () => $c876f4abf6963bdf$export$f0d7b23b1c8e0312);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $c876f4abf6963bdf$export$f0d7b23b1c8e0312 = (0, $i7GIz.svg)`<svg
  width="14"
  height="14"
  viewBox="0 0 14 14"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13.7306 3.24213C14.0725 3.58384 14.0725 4.13786 13.7306 4.47957L10.7418 7.46737C10.4 7.80908 9.84581 7.80908 9.50399 7.46737C9.16216 7.12567 9.16216 6.57165 9.50399 6.22994L10.9986 4.73585H5.34082C4.85741 4.73585 4.46553 4.3441 4.46553 3.86085C4.46553 3.3776 4.85741 2.98585 5.34082 2.98585L10.9986 2.98585L9.50399 1.49177C9.16216 1.15006 9.16216 0.596037 9.50399 0.254328C9.84581 -0.0873803 10.4 -0.0873803 10.7418 0.254328L13.7306 3.24213ZM9.52515 10.1352C9.52515 10.6185 9.13327 11.0102 8.64986 11.0102L2.9921 11.0102L4.48669 12.5043C4.82852 12.846 4.82852 13.4001 4.48669 13.7418C4.14487 14.0835 3.59066 14.0835 3.24884 13.7418L0.26003 10.754C0.0958806 10.5899 0.0036621 10.3673 0.00366211 10.1352C0.00366212 9.90318 0.0958806 9.68062 0.26003 9.51652L3.24884 6.52872C3.59066 6.18701 4.14487 6.18701 4.48669 6.52872C4.82851 6.87043 4.82851 7.42445 4.48669 7.76616L2.9921 9.26024L8.64986 9.26024C9.13327 9.26024 9.52515 9.65199 9.52515 10.1352Z"
    fill="currentColor"
  />
</svg>

`;

});

parcelRegister("gz9gw", function(module, exports) {

$parcel$export(module.exports, "swapVerticalSvg", () => $c0f71a25202d59fa$export$8fbc1b2c09145763);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $c0f71a25202d59fa$export$8fbc1b2c09145763 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 14 14">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M3.48 2.18a1 1 0 0 1 1.41 0l2.68 2.68a1 1 0 1 1-1.41 1.42l-.98-.98v4.56a1 1 0 0 1-2 0V5.3l-.97.98A1 1 0 0 1 .79 4.86l2.69-2.68Zm6.34 2.93a1 1 0 0 1 1 1v4.56l.97-.98a1 1 0 1 1 1.42 1.42l-2.69 2.68a1 1 0 0 1-1.41 0l-2.68-2.68a1 1 0 0 1 1.41-1.42l.98.98V6.1a1 1 0 0 1 1-1Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("5VwXU", function(module, exports) {

$parcel$export(module.exports, "telegramSvg", () => $450bd8d67818a0bf$export$367999698d7de87a);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $450bd8d67818a0bf$export$367999698d7de87a = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#5865F2" />
      <path
        fill="#fff"
        fill-rule="evenodd"
        d="M25.71 28.15C30.25 28 32 25.02 32 25.02c0-6.61-2.96-11.98-2.96-11.98-2.96-2.22-5.77-2.15-5.77-2.15l-.29.32c3.5 1.07 5.12 2.61 5.12 2.61a16.75 16.75 0 0 0-10.34-1.93l-.35.04a15.43 15.43 0 0 0-5.88 1.9s1.71-1.63 5.4-2.7l-.2-.24s-2.81-.07-5.77 2.15c0 0-2.96 5.37-2.96 11.98 0 0 1.73 2.98 6.27 3.13l1.37-1.7c-2.6-.79-3.6-2.43-3.6-2.43l.58.35.09.06.08.04.02.01.08.05a17.25 17.25 0 0 0 4.52 1.58 14.4 14.4 0 0 0 8.3-.86c.72-.27 1.52-.66 2.37-1.21 0 0-1.03 1.68-3.72 2.44.61.78 1.35 1.67 1.35 1.67Zm-9.55-9.6c-1.17 0-2.1 1.03-2.1 2.28 0 1.25.95 2.28 2.1 2.28 1.17 0 2.1-1.03 2.1-2.28.01-1.25-.93-2.28-2.1-2.28Zm7.5 0c-1.17 0-2.1 1.03-2.1 2.28 0 1.25.95 2.28 2.1 2.28 1.17 0 2.1-1.03 2.1-2.28 0-1.25-.93-2.28-2.1-2.28Z"
        clip-rule="evenodd"
      />
    </g>
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
  </defs>
</svg> `;

});

parcelRegister("9xnuM", function(module, exports) {

$parcel$export(module.exports, "twitchSvg", () => $6f196bd4bbae4a00$export$759b73a5195b6264);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $6f196bd4bbae4a00$export$759b73a5195b6264 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#5A3E85" />
      <g clip-path="url(#c)">
        <path
          fill="#fff"
          d="M18.22 25.7 20 23.91h3.34l2.1-2.1v-6.68H15.4v8.78h2.82v1.77Zm3.87-8.16h1.25v3.66H22.1v-3.66Zm-3.34 0H20v3.66h-1.25v-3.66ZM20 7.9a12 12 0 1 0 0 24 12 12 0 0 0 0-24Zm6.69 14.56-3.66 3.66h-2.72l-1.77 1.78h-1.88V26.1H13.3v-9.82l.94-2.4H26.7v8.56Z"
        />
      </g>
    </g>
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    <clipPath id="c"><path fill="#fff" d="M8 7.89h24v24H8z" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("jqrJn", function(module, exports) {

$parcel$export(module.exports, "twitterSvg", () => $e245f4cfa42ca128$export$dd8df3e26aa6585);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $e245f4cfa42ca128$export$dd8df3e26aa6585 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 40 40">
  <g clip-path="url(#a)">
    <g clip-path="url(#b)">
      <circle cx="20" cy="19.89" r="20" fill="#1D9BF0" />
      <path
        fill="#fff"
        d="M30 13.81c-.74.33-1.53.55-2.36.65.85-.51 1.5-1.32 1.8-2.27-.79.47-1.66.8-2.6 1a4.1 4.1 0 0 0-7 3.73c-3.4-.17-6.42-1.8-8.45-4.28a4.1 4.1 0 0 0 1.27 5.47c-.67-.02-1.3-.2-1.86-.5a4.1 4.1 0 0 0 3.3 4.07c-.58.15-1.21.19-1.86.07a4.1 4.1 0 0 0 3.83 2.85A8.25 8.25 0 0 1 10 26.3a11.62 11.62 0 0 0 6.29 1.84c7.62 0 11.92-6.44 11.66-12.2.8-.59 1.5-1.3 2.05-2.13Z"
      />
    </g>
  </g>
  <defs>
    <clipPath id="a"><rect width="40" height="40" fill="#fff" rx="20" /></clipPath>
    <clipPath id="b"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("fDo92", function(module, exports) {

$parcel$export(module.exports, "twitterIconSvg", () => $b61d3a28d96e0281$export$d6bfd63304732c58);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $b61d3a28d96e0281$export$d6bfd63304732c58 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 16 16">
  <path
    fill="currentColor"
    d="m14.36 4.74.01.42c0 4.34-3.3 9.34-9.34 9.34A9.3 9.3 0 0 1 0 13.03a6.6 6.6 0 0 0 4.86-1.36 3.29 3.29 0 0 1-3.07-2.28c.5.1 1 .07 1.48-.06A3.28 3.28 0 0 1 .64 6.11v-.04c.46.26.97.4 1.49.41A3.29 3.29 0 0 1 1.11 2.1a9.32 9.32 0 0 0 6.77 3.43 3.28 3.28 0 0 1 5.6-3 6.59 6.59 0 0 0 2.08-.8 3.3 3.3 0 0 1-1.45 1.82A6.53 6.53 0 0 0 16 3.04c-.44.66-1 1.23-1.64 1.7Z"
  />
</svg>`;

});

parcelRegister("cZVkP", function(module, exports) {

$parcel$export(module.exports, "verifySvg", () => $9767a8103e4cf473$export$dddaa7bddf7e22f);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $9767a8103e4cf473$export$dddaa7bddf7e22f = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 28 28">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M18.1 4.76c-.42-.73-1.33-1.01-2.09-.66l-1.42.66c-.37.18-.8.18-1.18 0l-1.4-.65a1.63 1.63 0 0 0-2.1.66l-.84 1.45c-.2.34-.53.59-.92.67l-1.7.35c-.83.17-1.39.94-1.3 1.78l.19 1.56c.04.39-.08.78-.33 1.07l-1.12 1.3c-.52.6-.52 1.5 0 2.11L5 16.38c.25.3.37.68.33 1.06l-.18 1.57c-.1.83.46 1.6 1.28 1.78l1.7.35c.4.08.73.32.93.66l.84 1.43a1.63 1.63 0 0 0 2.09.66l1.41-.66c.37-.17.8-.17 1.18 0l1.43.67c.76.35 1.66.07 2.08-.65l.86-1.45c.2-.34.54-.58.92-.66l1.68-.35A1.63 1.63 0 0 0 22.84 19l-.18-1.57a1.4 1.4 0 0 1 .33-1.06l1.12-1.32c.52-.6.52-1.5 0-2.11l-1.12-1.3a1.4 1.4 0 0 1-.33-1.07l.18-1.57c.1-.83-.46-1.6-1.28-1.77l-1.68-.35a1.4 1.4 0 0 1-.92-.66l-.86-1.47Zm-3.27-3.2a4.43 4.43 0 0 1 5.69 1.78l.54.93 1.07.22a4.43 4.43 0 0 1 3.5 4.84l-.11.96.7.83a4.43 4.43 0 0 1 .02 5.76l-.72.85.1.96a4.43 4.43 0 0 1-3.5 4.84l-1.06.22-.54.92a4.43 4.43 0 0 1-5.68 1.77l-.84-.4-.82.39a4.43 4.43 0 0 1-5.7-1.79l-.51-.89-1.09-.22a4.43 4.43 0 0 1-3.5-4.84l.1-.96-.72-.85a4.43 4.43 0 0 1 .01-5.76l.71-.83-.1-.95a4.43 4.43 0 0 1 3.5-4.84l1.08-.23.53-.9a4.43 4.43 0 0 1 5.7-1.8l.81.38.83-.39ZM18.2 9.4c.65.42.84 1.28.42 1.93l-4.4 6.87a1.4 1.4 0 0 1-2.26.14L9.5 15.39a1.4 1.4 0 0 1 2.15-1.8l1.23 1.48 3.38-5.26a1.4 1.4 0 0 1 1.93-.42Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("amxlC", function(module, exports) {

$parcel$export(module.exports, "verifyFilledSvg", () => $78b5d39c20db31e9$export$1f9737848f580d88);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $78b5d39c20db31e9$export$1f9737848f580d88 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 14 14">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="m4.1 12.43-.45-.78-.93-.2a1.65 1.65 0 0 1-1.31-1.8l.1-.86-.61-.71a1.65 1.65 0 0 1 0-2.16l.6-.7-.09-.85c-.1-.86.47-1.64 1.3-1.81l.94-.2.45-.78A1.65 1.65 0 0 1 6.23.9l.77.36.78-.36c.77-.36 1.69-.07 2.12.66l.47.8.91.2c.84.17 1.4.95 1.31 1.8l-.1.86.6.7c.54.62.54 1.54.01 2.16l-.6.71.09.86c.1.85-.47 1.63-1.3 1.8l-.92.2-.47.79a1.65 1.65 0 0 1-2.12.66L7 12.74l-.77.36c-.78.35-1.7.07-2.13-.67Zm5.74-6.9a1 1 0 1 0-1.68-1.07L6.32 7.3l-.55-.66a1 1 0 0 0-1.54 1.28l1.43 1.71a1 1 0 0 0 1.61-.1l2.57-4Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("fC1b2", function(module, exports) {

$parcel$export(module.exports, "walletPlaceholderSvg", () => $b5db51616a140335$export$e1456ec7b14fe70e);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $b5db51616a140335$export$e1456ec7b14fe70e = (0, $i7GIz.svg)`
  <svg fill="none" viewBox="0 0 48 44">
    <path
      style="fill: var(--wui-color-bg-300);"
      d="M4.56 8.64c-1.23 1.68-1.23 4.08-1.23 8.88v8.96c0 4.8 0 7.2 1.23 8.88.39.55.87 1.02 1.41 1.42C7.65 38 10.05 38 14.85 38h14.3c4.8 0 7.2 0 8.88-1.22a6.4 6.4 0 0 0 1.41-1.42c.83-1.14 1.1-2.6 1.19-4.92a6.4 6.4 0 0 0 5.16-4.65c.21-.81.21-1.8.21-3.79 0-1.98 0-2.98-.22-3.79a6.4 6.4 0 0 0-5.15-4.65c-.1-2.32-.36-3.78-1.19-4.92a6.4 6.4 0 0 0-1.41-1.42C36.35 6 33.95 6 29.15 6h-14.3c-4.8 0-7.2 0-8.88 1.22a6.4 6.4 0 0 0-1.41 1.42Z"
    />
    <path
      style="fill: var(--wui-color-fg-200);"
      fill-rule="evenodd"
      d="M2.27 11.33a6.4 6.4 0 0 1 6.4-6.4h26.66a6.4 6.4 0 0 1 6.4 6.4v1.7a6.4 6.4 0 0 1 5.34 6.3v5.34a6.4 6.4 0 0 1-5.34 6.3v1.7a6.4 6.4 0 0 1-6.4 6.4H8.67a6.4 6.4 0 0 1-6.4-6.4V11.33ZM39.6 31.07h-6.93a9.07 9.07 0 1 1 0-18.14h6.93v-1.6a4.27 4.27 0 0 0-4.27-4.26H8.67a4.27 4.27 0 0 0-4.27 4.26v21.34a4.27 4.27 0 0 0 4.27 4.26h26.66a4.27 4.27 0 0 0 4.27-4.26v-1.6Zm-6.93-16a6.93 6.93 0 0 0 0 13.86h8a4.27 4.27 0 0 0 4.26-4.26v-5.34a4.27 4.27 0 0 0-4.26-4.26h-8Z"
      clip-rule="evenodd"
    />
  </svg>
`;

});

parcelRegister("lPUBB", function(module, exports) {

$parcel$export(module.exports, "walletSvg", () => $fe5a451404047db9$export$9025df5921500944);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $fe5a451404047db9$export$9025df5921500944 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M0 5.5c0-1.8 1.46-3.25 3.25-3.25H14.5c1.8 0 3.25 1.46 3.25 3.25v.28A3.25 3.25 0 0 1 20 8.88v2.24c0 1.45-.94 2.68-2.25 3.1v.28c0 1.8-1.46 3.25-3.25 3.25H3.25A3.25 3.25 0 0 1 0 14.5v-9Zm15.75 8.88h-2.38a4.38 4.38 0 0 1 0-8.76h2.38V5.5c0-.69-.56-1.25-1.25-1.25H3.25C2.56 4.25 2 4.81 2 5.5v9c0 .69.56 1.25 1.25 1.25H14.5c.69 0 1.25-.56 1.25-1.25v-.13Zm-2.38-6.76a2.37 2.37 0 1 0 0 4.75h3.38c.69 0 1.25-.55 1.25-1.24V8.87c0-.69-.56-1.24-1.25-1.24h-3.38Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("gAnVT", function(module, exports) {

$parcel$export(module.exports, "walletConnectSvg", () => $c13292ad387c421f$export$84e288e571149f90);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $c13292ad387c421f$export$84e288e571149f90 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 96 67">
  <path
    fill="currentColor"
    d="M25.32 18.8a32.56 32.56 0 0 1 45.36 0l1.5 1.47c.63.62.63 1.61 0 2.22l-5.15 5.05c-.31.3-.82.3-1.14 0l-2.07-2.03a22.71 22.71 0 0 0-31.64 0l-2.22 2.18c-.31.3-.82.3-1.14 0l-5.15-5.05a1.55 1.55 0 0 1 0-2.22l1.65-1.62Zm56.02 10.44 4.59 4.5c.63.6.63 1.6 0 2.21l-20.7 20.26c-.62.61-1.63.61-2.26 0L48.28 41.83a.4.4 0 0 0-.56 0L33.03 56.21c-.63.61-1.64.61-2.27 0L10.07 35.95a1.55 1.55 0 0 1 0-2.22l4.59-4.5a1.63 1.63 0 0 1 2.27 0L31.6 43.63a.4.4 0 0 0 .57 0l14.69-14.38a1.63 1.63 0 0 1 2.26 0l14.69 14.38a.4.4 0 0 0 .57 0l14.68-14.38a1.63 1.63 0 0 1 2.27 0Z"
  />
  <path
    stroke="#000"
    stroke-opacity=".1"
    d="M25.67 19.15a32.06 32.06 0 0 1 44.66 0l1.5 1.48c.43.42.43 1.09 0 1.5l-5.15 5.05a.31.31 0 0 1-.44 0l-2.07-2.03a23.21 23.21 0 0 0-32.34 0l-2.22 2.18a.31.31 0 0 1-.44 0l-5.15-5.05a1.05 1.05 0 0 1 0-1.5l1.65-1.63ZM81 29.6l4.6 4.5c.42.41.42 1.09 0 1.5l-20.7 20.26c-.43.43-1.14.43-1.57 0L48.63 41.47a.9.9 0 0 0-1.26 0L32.68 55.85c-.43.43-1.14.43-1.57 0L10.42 35.6a1.05 1.05 0 0 1 0-1.5l4.59-4.5a1.13 1.13 0 0 1 1.57 0l14.68 14.38a.9.9 0 0 0 1.27 0l-.35-.35.35.35L47.22 29.6a1.13 1.13 0 0 1 1.56 0l14.7 14.38a.9.9 0 0 0 1.26 0L79.42 29.6a1.13 1.13 0 0 1 1.57 0Z"
  />
</svg>`;

});

parcelRegister("8OL17", function(module, exports) {

$parcel$export(module.exports, "warningCircleSvg", () => $66b776d5cffb967a$export$6e55d6021a3f4197);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $66b776d5cffb967a$export$6e55d6021a3f4197 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 20 20">
  <path
    fill="currentColor"
    d="M11 6.67a1 1 0 1 0-2 0v2.66a1 1 0 0 0 2 0V6.67ZM10 14.5a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
  />
  <path
    fill="currentColor"
    fill-rule="evenodd"
    d="M10 1a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm-7 9a7 7 0 1 1 14 0 7 7 0 0 1-14 0Z"
    clip-rule="evenodd"
  />
</svg>`;

});

parcelRegister("4iqk4", function(module, exports) {

$parcel$export(module.exports, "recycleHorizontalSvg", () => $320d4303078918ee$export$abad67e618866d01);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $320d4303078918ee$export$abad67e618866d01 = (0, $i7GIz.svg)`<svg
  fill="none"
  viewBox="0 0 21 20"
>
  <path
    fill="currentColor"
    d="M8.8071 0.292893C9.19763 0.683417 9.19763 1.31658 8.8071 1.70711L6.91421 3.6H11.8404C14.3368 3.6 16.5533 5.1975 17.3427 7.56588L17.4487 7.88377C17.6233 8.40772 17.3402 8.97404 16.8162 9.14868C16.2923 9.32333 15.726 9.04017 15.5513 8.51623L15.4453 8.19834C14.9281 6.64664 13.476 5.6 11.8404 5.6H6.91421L8.8071 7.49289C9.19763 7.88342 9.19763 8.51658 8.8071 8.90711C8.41658 9.29763 7.78341 9.29763 7.39289 8.90711L3.79289 5.30711C3.40236 4.91658 3.40236 4.28342 3.79289 3.89289L7.39289 0.292893C7.78341 -0.0976311 8.41658 -0.0976311 8.8071 0.292893ZM4.18377 10.8513C4.70771 10.6767 5.27403 10.9598 5.44868 11.4838L5.55464 11.8017C6.07188 13.3534 7.52401 14.4 9.15964 14.4L14.0858 14.4L12.1929 12.5071C11.8024 12.1166 11.8024 11.4834 12.1929 11.0929C12.5834 10.7024 13.2166 10.7024 13.6071 11.0929L17.2071 14.6929C17.5976 15.0834 17.5976 15.7166 17.2071 16.1071L13.6071 19.7071C13.2166 20.0976 12.5834 20.0976 12.1929 19.7071C11.8024 19.3166 11.8024 18.6834 12.1929 18.2929L14.0858 16.4L9.15964 16.4C6.66314 16.4 4.44674 14.8025 3.65728 12.4341L3.55131 12.1162C3.37667 11.5923 3.65983 11.026 4.18377 10.8513Z"
  /></svg
>`;

});

parcelRegister("1wWWa", function(module, exports) {

$parcel$export(module.exports, "bankSvg", () => $11d67f4b5ee28cfc$export$b7cc4752b6244394);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $11d67f4b5ee28cfc$export$b7cc4752b6244394 = (0, $i7GIz.svg)`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="12"
  height="13"
  viewBox="0 0 12 13"
  fill="none"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M5.61391 1.57124C5.85142 1.42873 6.14813 1.42873 6.38564 1.57124L11.0793 4.38749C11.9179 4.89067 11.5612 6.17864 10.5832 6.17864H9.96398V10.0358H10.2854C10.6996 10.0358 11.0354 10.3716 11.0354 10.7858C11.0354 11.2 10.6996 11.5358 10.2854 11.5358H1.71416C1.29995 11.5358 0.964172 11.2 0.964172 10.7858C0.964172 10.3716 1.29995 10.0358 1.71416 10.0358H2.03558L2.03558 6.17864H1.41637C0.438389 6.17864 0.0816547 4.89066 0.920263 4.38749L5.61391 1.57124ZM3.53554 6.17864V10.0358H5.24979V6.17864H3.53554ZM6.74976 6.17864V10.0358H8.46401V6.17864H6.74976ZM8.64913 4.67864H3.35043L5.99978 3.089L8.64913 4.67864Z"
    fill="currentColor"
  /></svg
>`;

});

parcelRegister("jHQ7q", function(module, exports) {

$parcel$export(module.exports, "cardSvg", () => $e58a76298870f92d$export$996b002521801861);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $e58a76298870f92d$export$996b002521801861 = (0, $i7GIz.svg)`<svg
  xmlns="http://www.w3.org/2000/svg"
  width="12"
  height="13"
  viewBox="0 0 12 13"
  fill="none"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M4.16072 2C4.17367 2 4.18665 2 4.19968 2L7.83857 2C8.36772 1.99998 8.82398 1.99996 9.19518 2.04018C9.5895 2.0829 9.97577 2.17811 10.3221 2.42971C10.5131 2.56849 10.6811 2.73647 10.8198 2.92749C11.0714 3.27379 11.1666 3.66007 11.2094 4.0544C11.2496 4.42561 11.2496 4.88188 11.2495 5.41105V7.58896C11.2496 8.11812 11.2496 8.57439 11.2094 8.94561C11.1666 9.33994 11.0714 9.72621 10.8198 10.0725C10.6811 10.2635 10.5131 10.4315 10.3221 10.5703C9.97577 10.8219 9.5895 10.9171 9.19518 10.9598C8.82398 11 8.36772 11 7.83856 11H4.16073C3.63157 11 3.17531 11 2.80411 10.9598C2.40979 10.9171 2.02352 10.8219 1.67722 10.5703C1.48621 10.4315 1.31824 10.2635 1.17946 10.0725C0.927858 9.72621 0.832652 9.33994 0.78993 8.94561C0.749713 8.5744 0.749733 8.11813 0.749757 7.58896L0.749758 5.45C0.749758 5.43697 0.749758 5.42399 0.749757 5.41104C0.749733 4.88188 0.749713 4.42561 0.78993 4.0544C0.832652 3.66007 0.927858 3.27379 1.17946 2.92749C1.31824 2.73647 1.48621 2.56849 1.67722 2.42971C2.02352 2.17811 2.40979 2.0829 2.80411 2.04018C3.17531 1.99996 3.63157 1.99998 4.16072 2ZM2.96567 3.53145C2.69897 3.56034 2.60687 3.60837 2.55888 3.64324C2.49521 3.6895 2.43922 3.74549 2.39296 3.80916C2.35809 3.85715 2.31007 3.94926 2.28117 4.21597C2.26629 4.35335 2.25844 4.51311 2.25431 4.70832H9.74498C9.74085 4.51311 9.733 4.35335 9.71812 4.21597C9.68922 3.94926 9.6412 3.85715 9.60633 3.80916C9.56007 3.74549 9.50408 3.6895 9.44041 3.64324C9.39242 3.60837 9.30031 3.56034 9.03362 3.53145C8.75288 3.50103 8.37876 3.5 7.79961 3.5H4.19968C3.62053 3.5 3.24641 3.50103 2.96567 3.53145ZM9.74956 6.20832H2.24973V7.55C2.24973 8.12917 2.25076 8.5033 2.28117 8.78404C2.31007 9.05074 2.35809 9.14285 2.39296 9.19084C2.43922 9.25451 2.49521 9.31051 2.55888 9.35677C2.60687 9.39163 2.69897 9.43966 2.96567 9.46856C3.24641 9.49897 3.62053 9.5 4.19968 9.5H7.79961C8.37876 9.5 8.75288 9.49897 9.03362 9.46856C9.30032 9.43966 9.39242 9.39163 9.44041 9.35677C9.50408 9.31051 9.56007 9.25451 9.60633 9.19084C9.6412 9.14285 9.68922 9.05075 9.71812 8.78404C9.74854 8.5033 9.74956 8.12917 9.74956 7.55V6.20832ZM6.74963 8C6.74963 7.58579 7.08541 7.25 7.49961 7.25H8.2496C8.6638 7.25 8.99958 7.58579 8.99958 8C8.99958 8.41422 8.6638 8.75 8.2496 8.75H7.49961C7.08541 8.75 6.74963 8.41422 6.74963 8Z"
    fill="currentColor"
  /></svg
>`;

});

parcelRegister("j7peG", function(module, exports) {

$parcel$export(module.exports, "plusSvg", () => $deb23f0f7f994125$export$f392b38d2d3751);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $deb23f0f7f994125$export$f392b38d2d3751 = (0, $i7GIz.svg)`<svg
  width="13"
  height="12"
  viewBox="0 0 13 12"
  fill="none"
>
  <path
    fill="currentColor"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M0.794373 5.99982C0.794373 5.52643 1.17812 5.14268 1.6515 5.14268H5.643V1.15109C5.643 0.677701 6.02675 0.293946 6.50012 0.293945C6.9735 0.293946 7.35725 0.677701 7.35725 1.15109V5.14268H11.3488C11.8221 5.14268 12.2059 5.52643 12.2059 5.99982C12.2059 6.47321 11.8221 6.85696 11.3488 6.85696H7.35725V10.8486C7.35725 11.3219 6.9735 11.7057 6.50012 11.7057C6.02675 11.7057 5.643 11.3219 5.643 10.8486V6.85696H1.6515C1.17812 6.85696 0.794373 6.47321 0.794373 5.99982Z"
  /></svg
>`;

});


parcelRegister("1fjkg", function(module, exports) {

$parcel$export(module.exports, "WuiImage", () => $0e862ee01ebbea2c$export$6985d0bcc76e605c);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");

var $e4NKf = parcelRequire("e4NKf");
var $0e862ee01ebbea2c$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $0e862ee01ebbea2c$export$6985d0bcc76e605c = class WuiImage extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.src = "./path/to/image.jpg";
        this.alt = "Image";
    }
    render() {
        return (0, $i7GIz.html)`<img src=${this.src} alt=${this.alt} />`;
    }
};
$0e862ee01ebbea2c$export$6985d0bcc76e605c.styles = [
    (0, $9rwwE.resetStyles),
    (0, $9rwwE.colorStyles),
    (0, $e4NKf.default)
];
$0e862ee01ebbea2c$var$__decorate([
    (0, $cRlTX.property)()
], $0e862ee01ebbea2c$export$6985d0bcc76e605c.prototype, "src", void 0);
$0e862ee01ebbea2c$var$__decorate([
    (0, $cRlTX.property)()
], $0e862ee01ebbea2c$export$6985d0bcc76e605c.prototype, "alt", void 0);
$0e862ee01ebbea2c$export$6985d0bcc76e605c = $0e862ee01ebbea2c$var$__decorate([
    (0, $lkv4o.customElement)("wui-image")
], $0e862ee01ebbea2c$export$6985d0bcc76e605c);

});
parcelRegister("e4NKf", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3f806b2c7197d64$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $a3f806b2c7197d64$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    display: block;
    width: 100%;
    height: 100%;
  }

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
    border-radius: inherit;
  }
`;

});


parcelRegister("lW8Rn", function(module, exports) {

$parcel$export(module.exports, "WuiLoadingHexagon", () => $ff85e3254409f1b9$export$8429fc8b8d557b81);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");

var $c6q9l = parcelRequire("c6q9l");
var $ff85e3254409f1b9$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $ff85e3254409f1b9$export$8429fc8b8d557b81 = class WuiLoadingHexagon extends (0, $3KB8N.LitElement) {
    render() {
        return (0, $i7GIz.html)`
      <svg viewBox="0 0 54 59">
        <path
          id="wui-loader-path"
          d="M17.22 5.295c3.877-2.277 5.737-3.363 7.72-3.726a11.44 11.44 0 0 1 4.12 0c1.983.363 3.844 1.45 7.72 3.726l6.065 3.562c3.876 2.276 5.731 3.372 7.032 4.938a11.896 11.896 0 0 1 2.06 3.63c.683 1.928.688 4.11.688 8.663v7.124c0 4.553-.005 6.735-.688 8.664a11.896 11.896 0 0 1-2.06 3.63c-1.3 1.565-3.156 2.66-7.032 4.937l-6.065 3.563c-3.877 2.276-5.737 3.362-7.72 3.725a11.46 11.46 0 0 1-4.12 0c-1.983-.363-3.844-1.449-7.72-3.726l-6.065-3.562c-3.876-2.276-5.731-3.372-7.032-4.938a11.885 11.885 0 0 1-2.06-3.63c-.682-1.928-.688-4.11-.688-8.663v-7.124c0-4.553.006-6.735.688-8.664a11.885 11.885 0 0 1 2.06-3.63c1.3-1.565 3.156-2.66 7.032-4.937l6.065-3.562Z"
        />
        <use xlink:href="#wui-loader-path"></use>
      </svg>
    `;
    }
};
$ff85e3254409f1b9$export$8429fc8b8d557b81.styles = [
    (0, $9rwwE.resetStyles),
    (0, $c6q9l.default)
];
$ff85e3254409f1b9$export$8429fc8b8d557b81 = $ff85e3254409f1b9$var$__decorate([
    (0, $lkv4o.customElement)("wui-loading-hexagon")
], $ff85e3254409f1b9$export$8429fc8b8d557b81);

});
parcelRegister("c6q9l", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cfa5460c4e105e2$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $8cfa5460c4e105e2$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    display: block;
    width: var(--wui-box-size-lg);
    height: var(--wui-box-size-lg);
  }

  svg {
    width: var(--wui-box-size-lg);
    height: var(--wui-box-size-lg);
    fill: none;
    stroke: transparent;
    stroke-linecap: round;
    transition: all var(--wui-ease-in-power-3) var(--wui-duration-lg);
  }

  use {
    stroke: var(--wui-color-accent-100);
    stroke-width: 2px;
    stroke-dasharray: 54, 118;
    stroke-dashoffset: 172;
    animation: dash 1s linear infinite;
  }

  @keyframes dash {
    to {
      stroke-dashoffset: 0px;
    }
  }
`;

});


parcelRegister("kc4Vb", function(module, exports) {

$parcel$export(module.exports, "WuiLoadingSpinner", () => $eb38bee1d98f3c9b$export$3a84ab9b4ee14f8a);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");

var $hXGt6 = parcelRequire("hXGt6");
var $eb38bee1d98f3c9b$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $eb38bee1d98f3c9b$export$3a84ab9b4ee14f8a = class WuiLoadingSpinner extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.color = "accent-100";
        this.size = "lg";
    }
    render() {
        this.style.cssText = `--local-color: var(--wui-color-${this.color});`;
        this.dataset["size"] = this.size;
        return (0, $i7GIz.html)`<svg viewBox="25 25 50 50">
      <circle r="20" cy="50" cx="50"></circle>
    </svg>`;
    }
};
$eb38bee1d98f3c9b$export$3a84ab9b4ee14f8a.styles = [
    (0, $9rwwE.resetStyles),
    (0, $hXGt6.default)
];
$eb38bee1d98f3c9b$var$__decorate([
    (0, $cRlTX.property)()
], $eb38bee1d98f3c9b$export$3a84ab9b4ee14f8a.prototype, "color", void 0);
$eb38bee1d98f3c9b$var$__decorate([
    (0, $cRlTX.property)()
], $eb38bee1d98f3c9b$export$3a84ab9b4ee14f8a.prototype, "size", void 0);
$eb38bee1d98f3c9b$export$3a84ab9b4ee14f8a = $eb38bee1d98f3c9b$var$__decorate([
    (0, $lkv4o.customElement)("wui-loading-spinner")
], $eb38bee1d98f3c9b$export$3a84ab9b4ee14f8a);

});
parcelRegister("hXGt6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d138e3b085a9fb20$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $d138e3b085a9fb20$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    display: flex;
  }

  :host([data-size='sm']) > svg {
    width: 12px;
    height: 12px;
  }

  :host([data-size='md']) > svg {
    width: 16px;
    height: 16px;
  }

  :host([data-size='lg']) > svg {
    width: 24px;
    height: 24px;
  }

  :host([data-size='xl']) > svg {
    width: 32px;
    height: 32px;
  }

  svg {
    animation: rotate 2s linear infinite;
    transition: all var(--wui-ease-in-power-3) var(--wui-duration-lg);
  }

  circle {
    fill: none;
    stroke: var(--local-color);
    stroke-width: 4px;
    stroke-dasharray: 1, 124;
    stroke-dashoffset: 0;
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

  :host([data-size='md']) > svg > circle {
    stroke-width: 6px;
  }

  :host([data-size='sm']) > svg > circle {
    stroke-width: 8px;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 124;
      stroke-dashoffset: 0;
    }

    50% {
      stroke-dasharray: 90, 124;
      stroke-dashoffset: -35;
    }

    100% {
      stroke-dashoffset: -125;
    }
  }
`;

});


parcelRegister("aA5kT", function(module, exports) {

$parcel$export(module.exports, "WuiLoadingThumbnail", () => $7b4167c4118ff370$export$a8f5e0b29edd5ad2);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");

var $27It5 = parcelRequire("27It5");
var $7b4167c4118ff370$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $7b4167c4118ff370$export$a8f5e0b29edd5ad2 = class WuiLoadingThumbnail extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.radius = 36;
    }
    render() {
        return this.svgLoaderTemplate();
    }
    svgLoaderTemplate() {
        const radius = this.radius > 50 ? 50 : this.radius;
        const standardValue = 36;
        const radiusFactor = standardValue - radius;
        const dashArrayStart = 116 + radiusFactor;
        const dashArrayEnd = 245 + radiusFactor;
        const dashOffset = 360 + radiusFactor * 1.75;
        return (0, $i7GIz.html)`
      <svg viewBox="0 0 110 110" width="110" height="110">
        <rect
          x="2"
          y="2"
          width="106"
          height="106"
          rx=${radius}
          stroke-dasharray="${dashArrayStart} ${dashArrayEnd}"
          stroke-dashoffset=${dashOffset}
        />
      </svg>
    `;
    }
};
$7b4167c4118ff370$export$a8f5e0b29edd5ad2.styles = [
    (0, $9rwwE.resetStyles),
    (0, $27It5.default)
];
$7b4167c4118ff370$var$__decorate([
    (0, $cRlTX.property)({
        type: Number
    })
], $7b4167c4118ff370$export$a8f5e0b29edd5ad2.prototype, "radius", void 0);
$7b4167c4118ff370$export$a8f5e0b29edd5ad2 = $7b4167c4118ff370$var$__decorate([
    (0, $lkv4o.customElement)("wui-loading-thumbnail")
], $7b4167c4118ff370$export$a8f5e0b29edd5ad2);

});
parcelRegister("27It5", function(module, exports) {

$parcel$export(module.exports, "default", () => $18bebaa4e6db2186$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $18bebaa4e6db2186$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    display: block;
    width: var(--wui-box-size-md);
    height: var(--wui-box-size-md);
  }

  svg {
    width: var(--wui-box-size-md);
    height: var(--wui-box-size-md);
    transition: all var(--wui-ease-in-power-3) var(--wui-duration-lg);
  }

  rect {
    fill: none;
    stroke: var(--wui-color-accent-100);
    stroke-width: 4px;
    stroke-linecap: round;
    animation: dash 1s linear infinite;
  }

  @keyframes dash {
    to {
      stroke-dashoffset: 0px;
    }
  }
`;

});


parcelRegister("9Riks", function(module, exports) {

$parcel$export(module.exports, "WuiShimmer", () => $72d748119f09e2ec$export$22033065aa649938);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");

var $lkv4o = parcelRequire("lkv4o");

var $kV41G = parcelRequire("kV41G");
var $72d748119f09e2ec$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $72d748119f09e2ec$export$22033065aa649938 = class WuiShimmer extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.width = "";
        this.height = "";
        this.borderRadius = "m";
    }
    render() {
        this.style.cssText = `
      width: ${this.width};
      height: ${this.height};
      border-radius: ${`clamp(0px,var(--wui-border-radius-${this.borderRadius}), 40px)`};
    `;
        return (0, $i7GIz.html)`<slot></slot>`;
    }
};
$72d748119f09e2ec$export$22033065aa649938.styles = [
    (0, $kV41G.default)
];
$72d748119f09e2ec$var$__decorate([
    (0, $cRlTX.property)()
], $72d748119f09e2ec$export$22033065aa649938.prototype, "width", void 0);
$72d748119f09e2ec$var$__decorate([
    (0, $cRlTX.property)()
], $72d748119f09e2ec$export$22033065aa649938.prototype, "height", void 0);
$72d748119f09e2ec$var$__decorate([
    (0, $cRlTX.property)()
], $72d748119f09e2ec$export$22033065aa649938.prototype, "borderRadius", void 0);
$72d748119f09e2ec$export$22033065aa649938 = $72d748119f09e2ec$var$__decorate([
    (0, $lkv4o.customElement)("wui-shimmer")
], $72d748119f09e2ec$export$22033065aa649938);

});
parcelRegister("kV41G", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3ac4104816dfaf6$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $f3ac4104816dfaf6$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    display: block;
    box-shadow: inset 0 0 0 1px var(--wui-gray-glass-005);
    background: linear-gradient(
      120deg,
      var(--wui-color-bg-200) 5%,
      var(--wui-color-bg-200) 48%,
      var(--wui-color-bg-300) 55%,
      var(--wui-color-bg-300) 60%,
      var(--wui-color-bg-300) calc(60% + 10px),
      var(--wui-color-bg-200) calc(60% + 12px),
      var(--wui-color-bg-200) 100%
    );
    background-size: 250%;
    animation: shimmer 3s linear infinite reverse;
  }

  @keyframes shimmer {
    from {
      background-position: -250% 0;
    }
    to {
      background-position: 250% 0;
    }
  }
`;

});


parcelRegister("eFeuH", function(module, exports) {

$parcel$export(module.exports, "WuiText", () => $aad02344a42873b2$export$406e1aa02d8022e4);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
parcelRequire("aFBpv");
var $8tV8b = parcelRequire("8tV8b");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");

var $kR8bh = parcelRequire("kR8bh");
var $aad02344a42873b2$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $aad02344a42873b2$export$406e1aa02d8022e4 = class WuiText extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.variant = "paragraph-500";
        this.color = "fg-300";
        this.align = "left";
    }
    render() {
        const classes = {
            [`wui-font-${this.variant}`]: true,
            [`wui-color-${this.color}`]: true
        };
        this.style.cssText = `
      --local-align: ${this.align};
      --local-color: var(--wui-color-${this.color});
    `;
        return (0, $i7GIz.html)`<slot class=${(0, $8tV8b.classMap)(classes)}></slot>`;
    }
};
$aad02344a42873b2$export$406e1aa02d8022e4.styles = [
    (0, $9rwwE.resetStyles),
    (0, $kR8bh.default)
];
$aad02344a42873b2$var$__decorate([
    (0, $cRlTX.property)()
], $aad02344a42873b2$export$406e1aa02d8022e4.prototype, "variant", void 0);
$aad02344a42873b2$var$__decorate([
    (0, $cRlTX.property)()
], $aad02344a42873b2$export$406e1aa02d8022e4.prototype, "color", void 0);
$aad02344a42873b2$var$__decorate([
    (0, $cRlTX.property)()
], $aad02344a42873b2$export$406e1aa02d8022e4.prototype, "align", void 0);
$aad02344a42873b2$export$406e1aa02d8022e4 = $aad02344a42873b2$var$__decorate([
    (0, $lkv4o.customElement)("wui-text")
], $aad02344a42873b2$export$406e1aa02d8022e4);

});
parcelRegister("aFBpv", function(module, exports) {
$parcel$export(module.exports, "classMap", () => (parcelRequire("8tV8b")).classMap);
parcelRequire("8tV8b");

});
parcelRegister("8tV8b", function(module, exports) {

$parcel$export(module.exports, "classMap", () => $62cd5936a2c04a61$export$56cc687933817664);

var $i7GIz = parcelRequire("i7GIz");

var $bV7TY = parcelRequire("bV7TY");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $62cd5936a2c04a61$export$56cc687933817664 = (0, $bV7TY.directive)(class extends (0, $bV7TY.Directive) {
    constructor(s){
        if (super(s), s.type !== (0, $bV7TY.PartType).ATTRIBUTE || "class" !== s.name || s.strings?.length > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((s)=>t[s]).join(" ") + " ";
    }
    update(t, [s]) {
        if (void 0 === this.st) {
            this.st = new Set, void 0 !== t.strings && (this.nt = new Set(t.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in s)s[t] && !this.nt?.has(t) && this.st.add(t);
            return this.render(s);
        }
        const i = t.element.classList;
        for (const t of this.st)t in s || (i.remove(t), this.st.delete(t));
        for(const t in s){
            const r = !!s[t];
            r === this.st.has(t) || this.nt?.has(t) || (r ? (i.add(t), this.st.add(t)) : (i.remove(t), this.st.delete(t)));
        }
        return 0, $i7GIz.noChange;
    }
});

});
parcelRegister("bV7TY", function(module, exports) {

$parcel$export(module.exports, "PartType", () => $8adb25b13f75ad66$export$9ba3b3f20a85bfa);
$parcel$export(module.exports, "directive", () => $8adb25b13f75ad66$export$99b43ad1ed32e735);
$parcel$export(module.exports, "Directive", () => $8adb25b13f75ad66$export$befdefbdce210f91);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $8adb25b13f75ad66$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $8adb25b13f75ad66$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $8adb25b13f75ad66$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this.t = t, this._$AM = e, this.i = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}

});



parcelRegister("kR8bh", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2ef1a73637953be$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $f2ef1a73637953be$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    display: inline-flex !important;
  }

  slot {
    display: inline-block;
    font-style: normal;
    font-family: var(--wui-font-family);
    font-feature-settings:
      'tnum' on,
      'lnum' on,
      'case' on;
    line-height: 130%;
    font-weight: var(--wui-font-weight-regular);
    overflow: inherit;
    text-overflow: inherit;
    text-align: var(--local-align);
    color: var(--local-color);
  }

  .wui-font-medium-title-600 {
    font-size: var(--wui-font-size-medium-title);
    letter-spacing: var(--wui-letter-spacing-medium-title);
  }

  .wui-font-large-500,
  .wui-font-large-600,
  .wui-font-large-700 {
    font-size: var(--wui-font-size-large);
    letter-spacing: var(--wui-letter-spacing-large);
  }

  .wui-font-2xl-500,
  .wui-font-2xl-600,
  .wui-font-2xl-700 {
    font-size: var(--wui-font-size-2xl);
    letter-spacing: var(--wui-letter-spacing-2xl);
  }

  .wui-font-paragraph-500,
  .wui-font-paragraph-600,
  .wui-font-paragraph-700 {
    font-size: var(--wui-font-size-paragraph);
    letter-spacing: var(--wui-letter-spacing-paragraph);
  }

  .wui-font-small-400,
  .wui-font-small-500,
  .wui-font-small-600 {
    font-size: var(--wui-font-size-small);
    letter-spacing: var(--wui-letter-spacing-small);
  }

  .wui-font-tiny-400,
  .wui-font-tiny-500,
  .wui-font-tiny-600 {
    font-size: var(--wui-font-size-tiny);
    letter-spacing: var(--wui-letter-spacing-tiny);
  }

  .wui-font-micro-700,
  .wui-font-micro-600 {
    font-size: var(--wui-font-size-micro);
    letter-spacing: var(--wui-letter-spacing-micro);
    text-transform: uppercase;
  }

  .wui-font-tiny-400,
  .wui-font-small-400,
  .wui-font-paragraph-400 {
    font-weight: var(--wui-font-weight-light);
  }

  .wui-font-large-700,
  .wui-font-paragraph-700,
  .wui-font-micro-700 {
    font-weight: var(--wui-font-weight-bold);
  }

  .wui-font-medium-title-600,
  .wui-font-large-600,
  .wui-font-paragraph-600,
  .wui-font-small-600,
  .wui-font-tiny-600,
  .wui-font-micro-600 {
    font-weight: var(--wui-font-weight-medium);
  }
`;

});


parcelRegister("alLF6", function(module, exports) {

$parcel$export(module.exports, "WuiVisual", () => $7890d6345cda1e8c$export$e6365a334c1a5845);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");

var $g1vcj = parcelRequire("g1vcj");

var $8d5Uj = parcelRequire("8d5Uj");

var $9svqe = parcelRequire("9svqe");

var $1nx1R = parcelRequire("1nx1R");

var $32n7v = parcelRequire("32n7v");

var $cq3Yg = parcelRequire("cq3Yg");

var $lseNE = parcelRequire("lseNE");

var $ir5Hb = parcelRequire("ir5Hb");

var $jkR4G = parcelRequire("jkR4G");

var $bPj2V = parcelRequire("bPj2V");

var $d9H8H = parcelRequire("d9H8H");

var $1qhVo = parcelRequire("1qhVo");

var $aYHqP = parcelRequire("aYHqP");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");

var $lPCAB = parcelRequire("lPCAB");

var $gAglz = parcelRequire("gAglz");

var $6v3GD = parcelRequire("6v3GD");

var $kMZn1 = parcelRequire("kMZn1");

var $ePbyt = parcelRequire("ePbyt");

var $fieFp = parcelRequire("fieFp");
var $7890d6345cda1e8c$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $7890d6345cda1e8c$var$svgOptions = {
    browser: (0, $g1vcj.browserSvg),
    dao: (0, $8d5Uj.daoSvg),
    defi: (0, $9svqe.defiSvg),
    defiAlt: (0, $1nx1R.defiAltSvg),
    eth: (0, $32n7v.ethSvg),
    layers: (0, $cq3Yg.layersSvg),
    lock: (0, $lseNE.lockSvg),
    login: (0, $ir5Hb.loginSvg),
    network: (0, $jkR4G.networkSvg),
    nft: (0, $bPj2V.nftSvg),
    noun: (0, $d9H8H.nounSvg),
    profile: (0, $1qhVo.profileSvg),
    system: (0, $aYHqP.systemSvg),
    coinbase: (0, $lPCAB.coinbaseSvg),
    onrampCard: (0, $ePbyt.onrampCardSvg),
    moonpay: (0, $gAglz.moonpaySvg),
    stripe: (0, $6v3GD.stripeSvg),
    paypal: (0, $kMZn1.paypalSvg)
};
let $7890d6345cda1e8c$export$e6365a334c1a5845 = class WuiVisual extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.name = "browser";
        this.size = "md";
    }
    render() {
        this.style.cssText = `
       --local-size: var(--wui-visual-size-${this.size});
   `;
        return (0, $i7GIz.html)`${$7890d6345cda1e8c$var$svgOptions[this.name]}`;
    }
};
$7890d6345cda1e8c$export$e6365a334c1a5845.styles = [
    (0, $9rwwE.resetStyles),
    (0, $fieFp.default)
];
$7890d6345cda1e8c$var$__decorate([
    (0, $cRlTX.property)()
], $7890d6345cda1e8c$export$e6365a334c1a5845.prototype, "name", void 0);
$7890d6345cda1e8c$var$__decorate([
    (0, $cRlTX.property)()
], $7890d6345cda1e8c$export$e6365a334c1a5845.prototype, "size", void 0);
$7890d6345cda1e8c$export$e6365a334c1a5845 = $7890d6345cda1e8c$var$__decorate([
    (0, $lkv4o.customElement)("wui-visual")
], $7890d6345cda1e8c$export$e6365a334c1a5845);

});
parcelRegister("g1vcj", function(module, exports) {

$parcel$export(module.exports, "browserSvg", () => $baa4f08c6aa3b2a1$export$9a659d11e13bcec5);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $baa4f08c6aa3b2a1$export$9a659d11e13bcec5 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 60 60">
  <rect width="60" height="60" fill="#1DC956" rx="30" />
  <circle cx="30" cy="30" r="3" fill="#fff" />
  <path
    fill="#2BEE6C"
    stroke="#fff"
    stroke-width="2"
    d="m45.32 17.9-.88-.42.88.42.02-.05c.1-.2.21-.44.26-.7l-.82-.15.82.16a2 2 0 0 0-.24-1.4c-.13-.23-.32-.42-.47-.57a8.42 8.42 0 0 1-.04-.04l-.04-.04a2.9 2.9 0 0 0-.56-.47l-.51.86.5-.86a2 2 0 0 0-1.4-.24c-.26.05-.5.16-.69.26l-.05.02-15.05 7.25-.1.05c-1.14.55-1.85.89-2.46 1.37a7 7 0 0 0-1.13 1.14c-.5.6-.83 1.32-1.38 2.45l-.05.11-7.25 15.05-.02.05c-.1.2-.21.43-.26.69a2 2 0 0 0 .24 1.4l.85-.5-.85.5c.13.23.32.42.47.57l.04.04.04.04c.15.15.34.34.56.47a2 2 0 0 0 1.41.24l-.2-.98.2.98c.25-.05.5-.17.69-.26l.05-.02-.42-.87.42.87 15.05-7.25.1-.05c1.14-.55 1.85-.89 2.46-1.38a7 7 0 0 0 1.13-1.13 12.87 12.87 0 0 0 1.43-2.56l7.25-15.05Z"
  />
  <path
    fill="#1DC956"
    d="M33.38 32.72 30.7 29.3 15.86 44.14l.2.2a1 1 0 0 0 1.14.2l15.1-7.27a3 3 0 0 0 1.08-4.55Z"
  />
  <path
    fill="#86F999"
    d="m26.62 27.28 2.67 3.43 14.85-14.85-.2-.2a1 1 0 0 0-1.14-.2l-15.1 7.27a3 3 0 0 0-1.08 4.55Z"
  />
  <circle cx="30" cy="30" r="3" fill="#fff" transform="rotate(45 30 30)" />
  <rect width="59" height="59" x=".5" y=".5" stroke="#062B2B" stroke-opacity=".1" rx="29.5" />
</svg> `;

});

parcelRegister("8d5Uj", function(module, exports) {

$parcel$export(module.exports, "daoSvg", () => $5fa41eb0d7c7e352$export$4c380a6200fee43);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $5fa41eb0d7c7e352$export$4c380a6200fee43 = (0, $i7GIz.svg)`<svg viewBox="0 0 60 60" fill="none">
  <g clip-path="url(#clip0_7734_50402)">
    <path
      d="M0 24.9C0 15.6485 0 11.0228 1.97053 7.56812C3.3015 5.23468 5.23468 3.3015 7.56812 1.97053C11.0228 0 15.6485 0 24.9 0H35.1C44.3514 0 48.9772 0 52.4319 1.97053C54.7653 3.3015 56.6985 5.23468 58.0295 7.56812C60 11.0228 60 15.6485 60 24.9V35.1C60 44.3514 60 48.9772 58.0295 52.4319C56.6985 54.7653 54.7653 56.6985 52.4319 58.0295C48.9772 60 44.3514 60 35.1 60H24.9C15.6485 60 11.0228 60 7.56812 58.0295C5.23468 56.6985 3.3015 54.7653 1.97053 52.4319C0 48.9772 0 44.3514 0 35.1V24.9Z"
      fill="#EB8B47"
    />
    <path
      d="M0.5 24.9C0.5 20.2652 0.50047 16.8221 0.744315 14.105C0.987552 11.3946 1.46987 9.45504 2.40484 7.81585C3.69145 5.56019 5.56019 3.69145 7.81585 2.40484C9.45504 1.46987 11.3946 0.987552 14.105 0.744315C16.8221 0.50047 20.2652 0.5 24.9 0.5H35.1C39.7348 0.5 43.1779 0.50047 45.895 0.744315C48.6054 0.987552 50.545 1.46987 52.1841 2.40484C54.4398 3.69145 56.3086 5.56019 57.5952 7.81585C58.5301 9.45504 59.0124 11.3946 59.2557 14.105C59.4995 16.8221 59.5 20.2652 59.5 24.9V35.1C59.5 39.7348 59.4995 43.1779 59.2557 45.895C59.0124 48.6054 58.5301 50.545 57.5952 52.1841C56.3086 54.4398 54.4398 56.3086 52.1841 57.5952C50.545 58.5301 48.6054 59.0124 45.895 59.2557C43.1779 59.4995 39.7348 59.5 35.1 59.5H24.9C20.2652 59.5 16.8221 59.4995 14.105 59.2557C11.3946 59.0124 9.45504 58.5301 7.81585 57.5952C5.56019 56.3086 3.69145 54.4398 2.40484 52.1841C1.46987 50.545 0.987552 48.6054 0.744315 45.895C0.50047 43.1779 0.5 39.7348 0.5 35.1V24.9Z"
      stroke="#062B2B"
      stroke-opacity="0.1"
    />
    <path
      d="M19 52C24.5228 52 29 47.5228 29 42C29 36.4772 24.5228 32 19 32C13.4772 32 9 36.4772 9 42C9 47.5228 13.4772 52 19 52Z"
      fill="#FF974C"
      stroke="white"
      stroke-width="2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M42.8437 8.3264C42.4507 7.70891 41.5493 7.70891 41.1564 8.32641L28.978 27.4638C28.5544 28.1295 29.0326 29.0007 29.8217 29.0007H54.1783C54.9674 29.0007 55.4456 28.1295 55.022 27.4638L42.8437 8.3264Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M42.3348 11.6456C42.659 11.7608 42.9061 12.1492 43.4005 12.926L50.7332 24.4488C51.2952 25.332 51.5763 25.7737 51.5254 26.1382C51.4915 26.3808 51.3698 26.6026 51.1833 26.7614C50.9031 27 50.3796 27 49.3327 27H34.6673C33.6204 27 33.0969 27 32.8167 26.7614C32.6302 26.6026 32.5085 26.3808 32.4746 26.1382C32.4237 25.7737 32.7048 25.332 33.2669 24.4488L40.5995 12.926C41.0939 12.1492 41.341 11.7608 41.6652 11.6456C41.8818 11.5687 42.1182 11.5687 42.3348 11.6456ZM35.0001 26.999C38.8661 26.999 42.0001 23.865 42.0001 19.999C42.0001 23.865 45.1341 26.999 49.0001 26.999H35.0001Z"
      fill="#FF974C"
    />
    <path
      d="M10.1061 9.35712C9.9973 9.67775 9.99867 10.0388 9.99978 10.3323C9.99989 10.3611 10 10.3893 10 10.4167V25.5833C10 25.6107 9.99989 25.6389 9.99978 25.6677C9.99867 25.9612 9.9973 26.3222 10.1061 26.6429C10.306 27.2317 10.7683 27.694 11.3571 27.8939C11.6777 28.0027 12.0388 28.0013 12.3323 28.0002C12.3611 28.0001 12.3893 28 12.4167 28H19C24.5228 28 29 23.5228 29 18C29 12.4772 24.5228 8 19 8H12.4167C12.3893 8 12.3611 7.99989 12.3323 7.99978C12.0388 7.99867 11.6778 7.9973 11.3571 8.10614C10.7683 8.306 10.306 8.76834 10.1061 9.35712Z"
      fill="#FF974C"
      stroke="white"
      stroke-width="2"
    />
    <circle cx="19" cy="18" r="4" fill="#EB8B47" stroke="white" stroke-width="2" />
    <circle cx="19" cy="42" r="4" fill="#EB8B47" stroke="white" stroke-width="2" />
  </g>
  <defs>
    <clipPath id="clip0_7734_50402">
      <rect width="60" height="60" fill="white" />
    </clipPath>
  </defs>
</svg> `;

});

parcelRegister("9svqe", function(module, exports) {

$parcel$export(module.exports, "defiSvg", () => $6e2f1a59ff13ae0e$export$400ef2a1f7fc3217);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $6e2f1a59ff13ae0e$export$400ef2a1f7fc3217 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 60 60">
  <g clip-path="url(#a)">
    <path
      fill="#1DC956"
      d="M0 25.01c0-9.25 0-13.88 1.97-17.33a15 15 0 0 1 5.6-5.6C11.02.11 15.65.11 24.9.11h10.2c9.25 0 13.88 0 17.33 1.97a15 15 0 0 1 5.6 5.6C60 11.13 60 15.76 60 25v10.2c0 9.25 0 13.88-1.97 17.33a15 15 0 0 1-5.6 5.6c-3.45 1.97-8.08 1.97-17.33 1.97H24.9c-9.25 0-13.88 0-17.33-1.97a15 15 0 0 1-5.6-5.6C0 49.1 0 44.46 0 35.21v-10.2Z"
    />
    <path
      fill="#2BEE6C"
      d="M16.1 60c-3.82-.18-6.4-.64-8.53-1.86a15 15 0 0 1-5.6-5.6C.55 50.06.16 46.97.04 41.98L4.2 40.6a4 4 0 0 0 2.48-2.39l4.65-12.4a2 2 0 0 1 2.5-1.2l2.53.84a2 2 0 0 0 2.43-1l2.96-5.94a2 2 0 0 1 3.7.32l3.78 12.58a2 2 0 0 0 3.03 1.09l3.34-2.23a2 2 0 0 0 .65-.7l5.3-9.72a2 2 0 0 1 1.42-1.01l4.14-.69a2 2 0 0 1 1.6.44l3.9 3.24a2 2 0 0 0 2.7-.12l4.62-4.63c.08 2.2.08 4.8.08 7.93v10.2c0 9.25 0 13.88-1.97 17.33a15 15 0 0 1-5.6 5.6c-2.13 1.22-4.7 1.68-8.54 1.86H16.11Z"
    />
    <path
      fill="#fff"
      d="m.07 43.03-.05-2.1 3.85-1.28a3 3 0 0 0 1.86-1.79l4.66-12.4a3 3 0 0 1 3.75-1.8l2.53.84a1 1 0 0 0 1.21-.5l2.97-5.94a3 3 0 0 1 5.56.48l3.77 12.58a1 1 0 0 0 1.51.55l3.34-2.23a1 1 0 0 0 .33-.35l5.3-9.71a3 3 0 0 1 2.14-1.53l4.13-.69a3 3 0 0 1 2.41.66l3.9 3.24a1 1 0 0 0 1.34-.06l5.28-5.28c.05.85.08 1.75.1 2.73L56 22.41a3 3 0 0 1-4.04.19l-3.9-3.25a1 1 0 0 0-.8-.21l-4.13.69a1 1 0 0 0-.72.5l-5.3 9.72a3 3 0 0 1-.97 1.05l-3.34 2.23a3 3 0 0 1-4.53-1.63l-3.78-12.58a1 1 0 0 0-1.85-.16l-2.97 5.94a3 3 0 0 1-3.63 1.5l-2.53-.84a1 1 0 0 0-1.25.6l-4.65 12.4a5 5 0 0 1-3.1 3L.07 43.02Z"
    />
    <path
      fill="#fff"
      fill-rule="evenodd"
      d="M49.5 19a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z"
      clip-rule="evenodd"
    />
    <path fill="#fff" d="M45 .28v59.66l-2 .1V.19c.7.02 1.37.05 2 .1Z" />
    <path fill="#2BEE6C" d="M47.5 19a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" />
    <path
      stroke="#fff"
      stroke-opacity=".1"
      d="M.5 25.01c0-4.63 0-8.08.24-10.8.25-2.7.73-4.64 1.66-6.28a14.5 14.5 0 0 1 5.42-5.41C9.46 1.58 11.39 1.1 14.1.85A133 133 0 0 1 24.9.61h10.2c4.63 0 8.08 0 10.8.24 2.7.25 4.65.73 6.28 1.67a14.5 14.5 0 0 1 5.42 5.4c.93 1.65 1.41 3.58 1.66 6.3.24 2.71.24 6.16.24 10.79v10.2c0 4.64 0 8.08-.24 10.8-.25 2.7-.73 4.65-1.66 6.28a14.5 14.5 0 0 1-5.42 5.42c-1.63.93-3.57 1.41-6.28 1.66-2.72.24-6.17.24-10.8.24H24.9c-4.63 0-8.08 0-10.8-.24-2.7-.25-4.64-.73-6.28-1.66a14.5 14.5 0 0 1-5.42-5.42C1.47 50.66 1 48.72.74 46.01A133 133 0 0 1 .5 35.2v-10.2Z"
    />
  </g>
  <defs>
    <clipPath id="a"><path fill="#fff" d="M0 0h60v60H0z" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("1nx1R", function(module, exports) {

$parcel$export(module.exports, "defiAltSvg", () => $10118f4d3c6d4e02$export$f1568dd015c8f3b9);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $10118f4d3c6d4e02$export$f1568dd015c8f3b9 = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 60 60">
  <g clip-path="url(#a)">
    <rect width="60" height="60" fill="#C653C6" rx="30" />
    <path
      fill="#E87DE8"
      d="M57.98.01v19.5a4.09 4.09 0 0 0-2.63 2.29L50.7 34.2a2 2 0 0 1-2.5 1.2l-2.53-.84a2 2 0 0 0-2.42 1l-2.97 5.94a2 2 0 0 1-3.7-.32L32.8 28.6a2 2 0 0 0-3.02-1.09l-3.35 2.23a2 2 0 0 0-.64.7l-5.3 9.72a2 2 0 0 1-1.43 1.01l-4.13.69a2 2 0 0 1-1.61-.44l-3.9-3.24a2 2 0 0 0-2.69.12L2.1 42.93.02 43V.01h57.96Z"
    />
    <path
      fill="#fff"
      d="m61.95 16.94.05 2.1-3.85 1.28a3 3 0 0 0-1.86 1.79l-4.65 12.4a3 3 0 0 1-3.76 1.8l-2.53-.84a1 1 0 0 0-1.2.5l-2.98 5.94a3 3 0 0 1-5.55-.48l-3.78-12.58a1 1 0 0 0-1.5-.55l-3.35 2.23a1 1 0 0 0-.32.35l-5.3 9.72a3 3 0 0 1-2.14 1.52l-4.14.69a3 3 0 0 1-2.41-.66l-3.9-3.24a1 1 0 0 0-1.34.06l-5.28 5.28c-.05-.84-.08-1.75-.1-2.73l3.97-3.96a3 3 0 0 1 4.04-.19l3.89 3.25a1 1 0 0 0 .8.21l4.14-.68a1 1 0 0 0 .71-.51l5.3-9.71a3 3 0 0 1 .97-1.06l3.34-2.23a3 3 0 0 1 4.54 1.63l3.77 12.58a1 1 0 0 0 1.86.16l2.96-5.93a3 3 0 0 1 3.64-1.5l2.52.83a1 1 0 0 0 1.25-.6l4.66-12.4a5 5 0 0 1 3.1-2.99l4.43-1.48Z"
    />
    <path
      fill="#fff"
      fill-rule="evenodd"
      d="M35.5 27a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z"
      clip-rule="evenodd"
    />
    <path fill="#fff" d="M31 0v60h-2V0h2Z" />
    <path fill="#E87DE8" d="M33.5 27a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" />
  </g>
  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="29.5" />
  <defs>
    <clipPath id="a"><rect width="60" height="60" fill="#fff" rx="30" /></clipPath>
  </defs>
</svg> `;

});

parcelRegister("32n7v", function(module, exports) {

$parcel$export(module.exports, "ethSvg", () => $23637e264aa0415a$export$9c7a8a6662d6e69b);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $23637e264aa0415a$export$9c7a8a6662d6e69b = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 60 60">
  <g clip-path="url(#a)">
    <rect width="60" height="60" fill="#987DE8" rx="30" />
    <path
      fill="#fff"
      fill-rule="evenodd"
      d="m15.48 28.37 11.97-19.3a3 3 0 0 1 5.1 0l11.97 19.3a6 6 0 0 1 .9 3.14v.03a6 6 0 0 1-1.16 3.56L33.23 50.2a4 4 0 0 1-6.46 0L15.73 35.1a6 6 0 0 1-1.15-3.54v-.03a6 6 0 0 1 .9-3.16Z"
      clip-rule="evenodd"
    />
    <path
      fill="#643CDD"
      d="M30.84 10.11a1 1 0 0 0-.84-.46V24.5l12.6 5.53a2 2 0 0 0-.28-1.4L30.84 10.11Z"
    />
    <path
      fill="#BDADEB"
      d="M30 9.65a1 1 0 0 0-.85.46L17.66 28.64a2 2 0 0 0-.26 1.39L30 24.5V9.65Z"
    />
    <path
      fill="#643CDD"
      d="M30 50.54a1 1 0 0 0 .8-.4l11.24-15.38c.3-.44-.2-1-.66-.73l-9.89 5.68a3 3 0 0 1-1.5.4v10.43Z"
    />
    <path
      fill="#BDADEB"
      d="m17.97 34.76 11.22 15.37c.2.28.5.41.8.41V40.11a3 3 0 0 1-1.49-.4l-9.88-5.68c-.47-.27-.97.3-.65.73Z"
    />
    <path
      fill="#401AB3"
      d="M42.6 30.03 30 24.5v13.14a3 3 0 0 0 1.5-.4l10.14-5.83a2 2 0 0 0 .95-1.38Z"
    />
    <path
      fill="#7C5AE2"
      d="M30 37.64V24.46l-12.6 5.57a2 2 0 0 0 .97 1.39l10.13 5.82a3 3 0 0 0 1.5.4Z"
    />
  </g>
  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="29.5" />
  <defs>
    <clipPath id="a"><rect width="60" height="60" fill="#fff" rx="30" /></clipPath>
  </defs>
</svg> `;

});

parcelRegister("cq3Yg", function(module, exports) {

$parcel$export(module.exports, "layersSvg", () => $90aafe4866e328a9$export$92af4cd19d37b5ea);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $90aafe4866e328a9$export$92af4cd19d37b5ea = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 60 60">
  <rect width="60" height="60" fill="#1DC956" rx="3" />
  <path
    fill="#1FAD7E"
    stroke="#fff"
    stroke-width="2"
    d="m30.49 29.13-.49-.27-.49.27-12.77 7.1-.05.02c-.86.48-1.58.88-2.1 1.24-.54.37-1.04.81-1.28 1.45a3 3 0 0 0 0 2.12c.24.63.74 1.08 1.27 1.45.53.36 1.25.76 2.11 1.24l.05.03 6.33 3.51.17.1c2.33 1.3 3.72 2.06 5.22 2.32a9 9 0 0 0 3.08 0c1.5-.26 2.9-1.03 5.22-2.32l.18-.1 6.32-3.51.05-.03a26.9 26.9 0 0 0 2.1-1.24 3.21 3.21 0 0 0 1.28-1.45l-.94-.35.94.35a3 3 0 0 0 0-2.12l-.94.35.94-.35a3.21 3.21 0 0 0-1.27-1.45c-.53-.36-1.25-.76-2.11-1.24l-.05-.03-12.77-7.1Z"
  />
  <path
    fill="#2BEE6C"
    stroke="#fff"
    stroke-width="2"
    d="m30.49 19.13-.49-.27-.49.27-12.77 7.1-.05.02c-.86.48-1.58.88-2.1 1.24-.54.37-1.04.81-1.28 1.45a3 3 0 0 0 0 2.12c.24.63.74 1.08 1.27 1.45.53.36 1.25.76 2.11 1.24l.05.03 6.33 3.51.17.1c2.33 1.3 3.72 2.06 5.22 2.32a9 9 0 0 0 3.08 0c1.5-.26 2.9-1.03 5.22-2.32l.18-.1 6.32-3.51.05-.03a26.9 26.9 0 0 0 2.1-1.24 3.21 3.21 0 0 0 1.28-1.45l-.94-.35.94.35a3 3 0 0 0 0-2.12l-.94.35.94-.35a3.21 3.21 0 0 0-1.27-1.45c-.53-.36-1.25-.76-2.11-1.24l-.05-.03-12.77-7.1Z"
  />
  <path
    fill="#86F999"
    stroke="#fff"
    stroke-width="2"
    d="m46.69 21.06-.94-.35.94.35a3 3 0 0 0 0-2.12l-.94.35.94-.35a3.21 3.21 0 0 0-1.27-1.45c-.53-.36-1.25-.76-2.11-1.24l-.05-.03-6.32-3.51-.18-.1c-2.33-1.3-3.72-2.06-5.22-2.33a9 9 0 0 0-3.08 0c-1.5.27-2.9 1.04-5.22 2.33l-.17.1-6.33 3.51-.05.03c-.86.48-1.58.88-2.1 1.24-.54.37-1.04.81-1.28 1.45a3 3 0 0 0 0 2.12c.24.63.74 1.08 1.27 1.45.53.36 1.25.76 2.11 1.24l.05.03 6.33 3.51.17.1c2.33 1.3 3.72 2.06 5.22 2.32a9 9 0 0 0 3.08 0c1.5-.26 2.9-1.03 5.22-2.32l.18-.1 6.32-3.51.05-.03a26.9 26.9 0 0 0 2.1-1.24 3.21 3.21 0 0 0 1.28-1.45Z"
  />
  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="2.5" />
</svg>`;

});

parcelRegister("lseNE", function(module, exports) {

$parcel$export(module.exports, "lockSvg", () => $f9e7b16a79d664c0$export$70be6a782cc364be);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $f9e7b16a79d664c0$export$70be6a782cc364be = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 60 60">
  <rect width="60" height="60" fill="#C653C6" rx="3" />
  <path
    fill="#fff"
    d="M20.03 15.22C20 15.6 20 16.07 20 17v2.8c0 1.14 0 1.7-.2 2.12-.15.31-.3.5-.58.71-.37.28-1.06.42-2.43.7-.59.12-1.11.29-1.6.51a9 9 0 0 0-4.35 4.36C10 30 10 32.34 10 37c0 4.66 0 7 .84 8.8a9 9 0 0 0 4.36 4.36C17 51 19.34 51 24 51h12c4.66 0 7 0 8.8-.84a9 9 0 0 0 4.36-4.36C50 44 50 41.66 50 37c0-4.66 0-7-.84-8.8a9 9 0 0 0-4.36-4.36c-.48-.22-1-.39-1.6-.5-1.36-.29-2.05-.43-2.42-.7-.27-.22-.43-.4-.58-.72-.2-.42-.2-.98-.2-2.11V17c0-.93 0-1.4-.03-1.78a9 9 0 0 0-8.19-8.19C31.4 7 30.93 7 30 7s-1.4 0-1.78.03a9 9 0 0 0-8.19 8.19Z"
  />
  <path
    fill="#E87DE8"
    d="M22 17c0-.93 0-1.4.04-1.78a7 7 0 0 1 6.18-6.18C28.6 9 29.07 9 30 9s1.4 0 1.78.04a7 7 0 0 1 6.18 6.18c.04.39.04.85.04 1.78v4.5a1.5 1.5 0 0 1-3 0V17c0-.93 0-1.4-.08-1.78a4 4 0 0 0-3.14-3.14C31.39 12 30.93 12 30 12s-1.4 0-1.78.08a4 4 0 0 0-3.14 3.14c-.08.39-.08.85-.08 1.78v4.5a1.5 1.5 0 0 1-3 0V17Z"
  />
  <path
    fill="#E87DE8"
    fill-rule="evenodd"
    d="M12 36.62c0-4.32 0-6.48.92-8.09a7 7 0 0 1 2.61-2.61C17.14 25 19.3 25 23.62 25h6.86c.46 0 .7 0 .9.02 2.73.22 4.37 2.43 4.62 4.98.27-2.7 2.11-5 5.02-5A6.98 6.98 0 0 1 48 31.98v5.4c0 4.32 0 6.48-.92 8.09a7 7 0 0 1-2.61 2.61c-1.61.92-3.77.92-8.09.92h-5.86c-.46 0-.7 0-.9-.02-2.73-.22-4.37-2.43-4.62-4.98-.26 2.58-1.94 4.82-4.71 4.99l-.7.01c-.55 0-.82 0-1.05-.02a7 7 0 0 1-6.52-6.52c-.02-.23-.02-.5-.02-1.05v-4.79Zm21.24-.27a4 4 0 1 0-6.48 0 31.28 31.28 0 0 1 1.57 2.23c.17.4.17.81.17 1.24V42.5a1.5 1.5 0 0 0 3 0V39.82c0-.43 0-.85.17-1.24.09-.2.58-.87 1.57-2.23Z"
    clip-rule="evenodd"
  />
  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="2.5" />
</svg>`;

});

parcelRegister("ir5Hb", function(module, exports) {

$parcel$export(module.exports, "loginSvg", () => $d6bf2a9ecad61e62$export$c9aa74efff8430c);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $d6bf2a9ecad61e62$export$c9aa74efff8430c = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 60 60">
  <g clip-path="url(#a)">
    <path
      fill="#EB8B47"
      d="M0 24.9c0-9.25 0-13.88 1.97-17.33a15 15 0 0 1 5.6-5.6C11.02 0 15.65 0 24.9 0h10.2c9.25 0 13.88 0 17.33 1.97a15 15 0 0 1 5.6 5.6C60 11.02 60 15.65 60 24.9v10.2c0 9.25 0 13.88-1.97 17.33a15 15 0 0 1-5.6 5.6C48.98 60 44.35 60 35.1 60H24.9c-9.25 0-13.88 0-17.33-1.97a15 15 0 0 1-5.6-5.6C0 48.98 0 44.35 0 35.1V24.9Z"
    />
    <path
      stroke="#062B2B"
      stroke-opacity=".1"
      d="M.5 24.9c0-4.64 0-8.08.24-10.8.25-2.7.73-4.65 1.66-6.28A14.5 14.5 0 0 1 7.82 2.4C9.46 1.47 11.39 1 14.1.74A133 133 0 0 1 24.9.5h10.2c4.63 0 8.08 0 10.8.24 2.7.25 4.65.73 6.28 1.66a14.5 14.5 0 0 1 5.42 5.42c.93 1.63 1.41 3.57 1.66 6.28.24 2.72.24 6.16.24 10.8v10.2c0 4.63 0 8.08-.24 10.8-.25 2.7-.73 4.64-1.66 6.28a14.5 14.5 0 0 1-5.42 5.41c-1.63.94-3.57 1.42-6.28 1.67-2.72.24-6.17.24-10.8.24H24.9c-4.63 0-8.08 0-10.8-.24-2.7-.25-4.64-.73-6.28-1.67a14.5 14.5 0 0 1-5.42-5.4C1.47 50.53 1 48.6.74 45.88A133 133 0 0 1 .5 35.1V24.9Z"
    />
    <path
      fill="#FF974C"
      stroke="#fff"
      stroke-width="2"
      d="M39.2 29.2a13 13 0 1 0-18.4 0l1.3 1.28a12.82 12.82 0 0 1 2.1 2.39 6 6 0 0 1 .6 1.47c.2.76.2 1.56.2 3.17v11.24c0 1.08 0 1.61.13 2.12a4 4 0 0 0 .41.98c.26.45.64.83 1.4 1.6l.3.29c.65.65.98.98 1.36 1.09.26.07.54.07.8 0 .38-.11.7-.44 1.36-1.1l3.48-3.47c.65-.65.98-.98 1.09-1.36a1.5 1.5 0 0 0 0-.8c-.1-.38-.44-.7-1.1-1.36l-.47-.48c-.65-.65-.98-.98-1.09-1.36a1.5 1.5 0 0 1 0-.8c.1-.38.44-.7 1.1-1.36l.47-.48c.65-.65.98-.98 1.09-1.36a1.5 1.5 0 0 0 0-.8c-.1-.38-.44-.7-1.1-1.36l-.48-.5c-.65-.64-.98-.97-1.08-1.35a1.5 1.5 0 0 1 0-.79c.1-.38.42-.7 1.06-1.36l5.46-5.55Z"
    />
    <circle cx="30" cy="17" r="4" fill="#EB8B47" stroke="#fff" stroke-width="2" />
  </g>
  <defs>
    <clipPath id="a"><path fill="#fff" d="M0 0h60v60H0z" /></clipPath>
  </defs>
</svg> `;

});

parcelRegister("jkR4G", function(module, exports) {

$parcel$export(module.exports, "networkSvg", () => $e1390e140d6c5d05$export$1a3efa751581ed0a);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $e1390e140d6c5d05$export$1a3efa751581ed0a = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 60 60">
  <g clip-path="url(#a)">
    <rect width="60" height="60" fill="#00ACE6" rx="30" />
    <circle cx="64" cy="39" r="50" fill="#1AC6FF" stroke="#fff" stroke-width="2" />
    <circle cx="78" cy="30" r="50" fill="#4DD2FF" stroke="#fff" stroke-width="2" />
    <circle cx="72" cy="15" r="35" fill="#80DFFF" stroke="#fff" stroke-width="2" />
    <circle cx="34" cy="-17" r="45" stroke="#fff" stroke-width="2" />
    <circle cx="34" cy="-5" r="50" stroke="#fff" stroke-width="2" />
    <circle cx="30" cy="45" r="4" fill="#4DD2FF" stroke="#fff" stroke-width="2" />
    <circle cx="39.5" cy="27.5" r="4" fill="#80DFFF" stroke="#fff" stroke-width="2" />
    <circle cx="16" cy="24" r="4" fill="#19C6FF" stroke="#fff" stroke-width="2" />
  </g>
  <rect width="59" height="59" x=".5" y=".5" stroke="#062B2B" stroke-opacity=".1" rx="29.5" />
  <defs>
    <clipPath id="a"><rect width="60" height="60" fill="#fff" rx="30" /></clipPath>
  </defs>
</svg>`;

});

parcelRegister("bPj2V", function(module, exports) {

$parcel$export(module.exports, "nftSvg", () => $89c33b4f1df890c2$export$1c5022265b1a9f1f);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $89c33b4f1df890c2$export$1c5022265b1a9f1f = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 60 60">
  <g clip-path="url(#a)">
    <rect width="60" height="60" fill="#C653C6" rx="3" />
    <path
      fill="#E87DE8"
      stroke="#fff"
      stroke-width="2"
      d="M52.1 47.34c0-4.24-1.44-9.55-5.9-12.4a2.86 2.86 0 0 0-1.6-3.89v-.82c0-1.19-.52-2.26-1.35-3a4.74 4.74 0 0 0-2.4-6.26v-5.5a11.31 11.31 0 1 0-22.63 0v2.15a3.34 3.34 0 0 0-1.18 5.05 4.74 4.74 0 0 0-.68 6.44A5.22 5.22 0 0 0 14 35.92c-3.06 4.13-6.1 8.3-6.1 15.64 0 2.67.37 4.86.74 6.39a20.3 20.3 0 0 0 .73 2.39l.02.04v.01l.92-.39-.92.4.26.6h38.26l.3-.49-.87-.51.86.5.02-.01.03-.07a16.32 16.32 0 0 0 .57-1.05c.36-.72.85-1.74 1.33-2.96a25.51 25.51 0 0 0 1.94-9.07Z"
    />
    <path
      fill="#fff"
      fill-rule="evenodd"
      d="M26.5 29.5c-3-.5-5.5-3-5.5-7v-7c0-.47 0-.7.03-.9a3 3 0 0 1 2.58-2.57c.2-.03.42-.03.89-.03 2 0 2.5-2.5 2.5-2.5s0 2.5 2.5 2.5c1.4 0 2.1 0 2.65.23a3 3 0 0 1 1.62 1.62c.23.55.23 1.25.23 2.65v6c0 4-3 7-6.5 7 1.35.23 4 0 6.5-2v9.53C34 38.5 31.5 40 28 40s-6-1.5-6-2.97L24 34l2.5 1.5v-6ZM26 47h4.5c2.5 0 3 4 3 5.5h-3l-1-1.5H26v-4Zm-6.25 5.5H24V57h-8c0-1 1-4.5 3.75-4.5Z"
      clip-rule="evenodd"
    />
  </g>
  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="2.5" />
  <defs>
    <clipPath id="a"><rect width="60" height="60" fill="#fff" rx="3" /></clipPath>
  </defs>
</svg> `;

});

parcelRegister("d9H8H", function(module, exports) {

$parcel$export(module.exports, "nounSvg", () => $993d942eb0619cb4$export$3bfdd1a0cad16fad);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $993d942eb0619cb4$export$3bfdd1a0cad16fad = (0, $i7GIz.svg)`<svg fill="none" viewBox="0 0 60 60">
  <rect width="60" height="60" fill="#794CFF" rx="3" />
  <path
    fill="#987DE8"
    stroke="#fff"
    stroke-width="2"
    d="M33 22.5v-1H16v5H8.5V36H13v-5h3v7.5h17V31h1v7.5h17v-17H34v5h-1v-4Z"
  />
  <path fill="#fff" d="M37.5 25h10v10h-10z" />
  <path fill="#4019B2" d="M42.5 25h5v10h-5z" />
  <path fill="#fff" d="M19.5 25h10v10h-10z" />
  <path fill="#4019B2" d="M24.5 25h5v10h-5z" />
  <path fill="#fff" d="M12 30.5h4V37h-4v-6.5Z" />
  <rect width="59" height="59" x=".5" y=".5" stroke="#fff" stroke-opacity=".1" rx="2.5" />
</svg>`;

});

parcelRegister("1qhVo", function(module, exports) {

$parcel$export(module.exports, "profileSvg", () => $10961fa347647791$export$f1a0ec1d6376e59);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $10961fa347647791$export$f1a0ec1d6376e59 = (0, $i7GIz.svg)`<svg
  viewBox="0 0 60 60"
  fill="none"
>
  <g clip-path="url(#1)">
    <rect width="60" height="60" rx="30" fill="#00ACE6" />
    <path
      d="M59 73C59 89.0163 46.0163 102 30 102C13.9837 102 1 89.0163 1 73C1 56.9837 12 44 30 44C48 44 59 56.9837 59 73Z"
      fill="#1AC6FF"
      stroke="white"
      stroke-width="2"
    />
    <path
      d="M18.6904 19.9015C19.6264 15.3286 23.3466 11.8445 27.9708 11.2096C29.3231 11.024 30.6751 11.0238 32.0289 11.2096C36.6532 11.8445 40.3733 15.3286 41.3094 19.9015C41.4868 20.7681 41.6309 21.6509 41.7492 22.5271C41.8811 23.5041 41.8811 24.4944 41.7492 25.4715C41.6309 26.3476 41.4868 27.2304 41.3094 28.097C40.3733 32.6699 36.6532 36.154 32.0289 36.7889C30.6772 36.9744 29.3216 36.9743 27.9708 36.7889C23.3466 36.154 19.6264 32.6699 18.6904 28.097C18.513 27.2304 18.3689 26.3476 18.2506 25.4715C18.1186 24.4944 18.1186 23.5041 18.2506 22.5271C18.3689 21.6509 18.513 20.7681 18.6904 19.9015Z"
      fill="#1AC6FF"
      stroke="white"
      stroke-width="2"
    />
    <circle cx="24.5" cy="23.5" r="1.5" fill="white" />
    <circle cx="35.5" cy="23.5" r="1.5" fill="white" />
    <path
      d="M31 20L28 28H32"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
  <rect x="0.5" y="0.5" width="59" height="59" rx="29.5" stroke="white" stroke-opacity="0.1" />
  <defs>
    <clipPath id="1">
      <rect width="60" height="60" rx="30" fill="white" />
    </clipPath>
  </defs>
</svg> `;

});

parcelRegister("aYHqP", function(module, exports) {

$parcel$export(module.exports, "systemSvg", () => $7fe1329a4d000a4d$export$5752b741a746ef10);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $7fe1329a4d000a4d$export$5752b741a746ef10 = (0, $i7GIz.svg)`<svg viewBox="0 0 60 60" fill="none">
  <g clip-path="url(#1)">
    <path
      d="M0 24.9C0 15.6485 0 11.0228 1.97053 7.56812C3.3015 5.23468 5.23468 3.3015 7.56812 1.97053C11.0228 0 15.6485 0 24.9 0H35.1C44.3514 0 48.9772 0 52.4319 1.97053C54.7653 3.3015 56.6985 5.23468 58.0295 7.56812C60 11.0228 60 15.6485 60 24.9V35.1C60 44.3514 60 48.9772 58.0295 52.4319C56.6985 54.7653 54.7653 56.6985 52.4319 58.0295C48.9772 60 44.3514 60 35.1 60H24.9C15.6485 60 11.0228 60 7.56812 58.0295C5.23468 56.6985 3.3015 54.7653 1.97053 52.4319C0 48.9772 0 44.3514 0 35.1V24.9Z"
      fill="#794CFF"
    />
    <path
      d="M0.5 24.9C0.5 20.2652 0.50047 16.8221 0.744315 14.105C0.987552 11.3946 1.46987 9.45504 2.40484 7.81585C3.69145 5.56019 5.56019 3.69145 7.81585 2.40484C9.45504 1.46987 11.3946 0.987552 14.105 0.744315C16.8221 0.50047 20.2652 0.5 24.9 0.5H35.1C39.7348 0.5 43.1779 0.50047 45.895 0.744315C48.6054 0.987552 50.545 1.46987 52.1841 2.40484C54.4398 3.69145 56.3086 5.56019 57.5952 7.81585C58.5301 9.45504 59.0124 11.3946 59.2557 14.105C59.4995 16.8221 59.5 20.2652 59.5 24.9V35.1C59.5 39.7348 59.4995 43.1779 59.2557 45.895C59.0124 48.6054 58.5301 50.545 57.5952 52.1841C56.3086 54.4398 54.4398 56.3086 52.1841 57.5952C50.545 58.5301 48.6054 59.0124 45.895 59.2557C43.1779 59.4995 39.7348 59.5 35.1 59.5H24.9C20.2652 59.5 16.8221 59.4995 14.105 59.2557C11.3946 59.0124 9.45504 58.5301 7.81585 57.5952C5.56019 56.3086 3.69145 54.4398 2.40484 52.1841C1.46987 50.545 0.987552 48.6054 0.744315 45.895C0.50047 43.1779 0.5 39.7348 0.5 35.1V24.9Z"
      stroke="#062B2B"
      stroke-opacity="0.1"
    />
    <path
      d="M35.1403 31.5016C35.1193 30.9637 35.388 30.4558 35.8446 30.1707C36.1207 29.9982 36.4761 29.8473 36.7921 29.7685C37.3143 29.6382 37.8664 29.7977 38.2386 30.1864C38.8507 30.8257 39.3004 31.6836 39.8033 32.408C40.2796 33.0942 41.4695 33.2512 41.9687 32.5047C42.4839 31.7341 42.9405 30.8229 43.572 30.1399C43.9375 29.7447 44.4866 29.5756 45.0111 29.6967C45.3283 29.7701 45.6863 29.9147 45.9655 30.0823C46.4269 30.3595 46.7045 30.8626 46.6928 31.4008C46.6731 32.3083 46.3764 33.2571 46.2158 34.1473C46.061 35.0048 46.9045 35.8337 47.7592 35.664C48.6464 35.4878 49.5899 35.1747 50.497 35.1391C51.0348 35.1181 51.5427 35.3868 51.8279 35.8433C52.0004 36.1195 52.1513 36.4749 52.2301 36.7908C52.3604 37.3131 52.2009 37.8651 51.8121 38.2374C51.1729 38.8495 50.3151 39.2991 49.5908 39.8019C48.9046 40.2782 48.7473 41.4683 49.4939 41.9675C50.2644 42.4827 51.1757 42.9393 51.8587 43.5708C52.2539 43.9362 52.423 44.4854 52.3018 45.0099C52.2285 45.3271 52.0839 45.6851 51.9162 45.9642C51.6391 46.4257 51.1359 46.7032 50.5978 46.6916C49.6903 46.6719 48.7417 46.3753 47.8516 46.2146C46.9939 46.0598 46.1648 46.9035 46.3346 47.7583C46.5108 48.6454 46.8239 49.5888 46.8594 50.4958C46.8805 51.0336 46.6117 51.5415 46.1552 51.8267C45.879 51.9992 45.5236 52.15 45.2077 52.2289C44.6854 52.3592 44.1334 52.1997 43.7611 51.8109C43.1491 51.1718 42.6996 50.314 42.1968 49.5897C41.7203 48.9034 40.5301 48.7463 40.0309 49.493C39.5157 50.2634 39.0592 51.1746 38.4278 51.8574C38.0623 52.2527 37.5132 52.4218 36.9887 52.3006C36.6715 52.2273 36.3135 52.0826 36.0343 51.915C35.5729 51.6379 35.2953 51.1347 35.307 50.5966C35.3267 49.6891 35.6233 48.7405 35.7839 47.8505C35.9388 46.9928 35.0951 46.1636 34.2402 46.3334C33.3531 46.5096 32.4098 46.8227 31.5028 46.8582C30.9649 46.8793 30.457 46.6105 30.1719 46.154C29.9994 45.8778 29.8485 45.5224 29.7697 45.2065C29.6394 44.6842 29.7989 44.1322 30.1877 43.7599C30.8269 43.1479 31.6847 42.6982 32.4091 42.1954C33.0954 41.7189 33.2522 40.5289 32.5056 40.0297C31.7351 39.5145 30.824 39.058 30.1411 38.4265C29.7459 38.0611 29.5768 37.5119 29.698 36.9875C29.7713 36.6702 29.9159 36.3122 30.0836 36.0331C30.3607 35.5717 30.8638 35.2941 31.402 35.3058C32.3095 35.3255 33.2583 35.6221 34.1485 35.7828C35.006 35.9376 35.8349 35.094 35.6652 34.2393C35.489 33.3521 35.1759 32.4087 35.1403 31.5016Z"
      fill="#906EF7"
      stroke="white"
      stroke-width="2"
    />
    <path
      d="M20.7706 8.22357C20.9036 7.51411 21.5231 7 22.2449 7H23.7551C24.4769 7 25.0964 7.51411 25.2294 8.22357C25.5051 9.69403 25.4829 11.6321 27.1202 12.2606C27.3092 12.3331 27.4958 12.4105 27.6798 12.4926C29.2818 13.2072 30.6374 11.8199 31.8721 10.9752C32.4678 10.5676 33.2694 10.6421 33.7798 11.1525L34.8477 12.2204C35.3581 12.7308 35.4326 13.5323 35.025 14.128C34.1802 15.3627 32.7931 16.7183 33.5077 18.3202C33.5898 18.5043 33.6672 18.6909 33.7398 18.88C34.3683 20.5171 36.3061 20.4949 37.7764 20.7706C38.4859 20.9036 39 21.5231 39 22.2449V23.7551C39 24.4769 38.4859 25.0964 37.7764 25.2294C36.3061 25.5051 34.3685 25.483 33.7401 27.1201C33.6675 27.3093 33.59 27.4961 33.5079 27.6803C32.7934 29.282 34.1803 30.6374 35.025 31.8719C35.4326 32.4677 35.3581 33.2692 34.8477 33.7796L33.7798 34.8475C33.2694 35.3579 32.4678 35.4324 31.8721 35.0248C30.6376 34.1801 29.2823 32.7934 27.6806 33.508C27.4962 33.5903 27.3093 33.6678 27.12 33.7405C25.483 34.3688 25.5051 36.3062 25.2294 37.7764C25.0964 38.4859 24.4769 39 23.7551 39H22.2449C21.5231 39 20.9036 38.4859 20.7706 37.7764C20.4949 36.3062 20.517 34.3688 18.88 33.7405C18.6908 33.6678 18.5039 33.5903 18.3196 33.5081C16.7179 32.7936 15.3625 34.1804 14.1279 35.0251C13.5322 35.4327 12.7307 35.3582 12.2203 34.8478L11.1524 33.7799C10.642 33.2695 10.5675 32.4679 10.9751 31.8722C11.8198 30.6376 13.2067 29.2822 12.4922 27.6804C12.41 27.4962 12.3325 27.3093 12.2599 27.1201C11.6315 25.483 9.69392 25.5051 8.22357 25.2294C7.51411 25.0964 7 24.4769 7 23.7551V22.2449C7 21.5231 7.51411 20.9036 8.22357 20.7706C9.69394 20.4949 11.6317 20.5171 12.2602 18.88C12.3328 18.6909 12.4103 18.5042 12.4924 18.3201C13.207 16.7181 11.8198 15.3625 10.975 14.1278C10.5674 13.5321 10.6419 12.7305 11.1523 12.2201L12.2202 11.1522C12.7306 10.6418 13.5322 10.5673 14.1279 10.9749C15.3626 11.8197 16.7184 13.2071 18.3204 12.4925C18.5044 12.4105 18.6909 12.3331 18.8799 12.2606C20.5171 11.6321 20.4949 9.69403 20.7706 8.22357Z"
      fill="#906EF7"
      stroke="white"
      stroke-width="2"
    />
    <circle cx="23" cy="23" r="6" fill="#794CFF" stroke="white" stroke-width="2" />
    <circle cx="41" cy="41" r="4" fill="#794CFF" stroke="white" stroke-width="2" />
  </g>
  <defs>
    <clipPath id="1">
      <rect width="60" height="60" fill="white" />
    </clipPath>
  </defs>
</svg> `;

});

parcelRegister("lPCAB", function(module, exports) {

$parcel$export(module.exports, "coinbaseSvg", () => $fe4c4b76c8685441$export$8661898196b83c8c);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $fe4c4b76c8685441$export$8661898196b83c8c = (0, $i7GIz.svg)`<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
  <g clip-path="url(#clip0_187_29)">
    <path d="M1.18187e-05 15.8055C1.18187e-05 9.8015 -5.19442e-07 6.91338 1.69991e-08 0C4.5 3.72236e-05 9.62249 0 16.5 0L23.5 4.31399e-05C29.9349 4.31399e-05 35.5 0.000206332 40 3.73468e-05C40 2.77754 40 9.36708 40 15.8055V22.8364C40 29.2647 40 33.7962 40 40C31.5 40 29.8337 40 23.4 40H16.6C10.5092 40 6.50004 40 4.04289e-05 40C3.05176e-05 32.2453 1.18187e-05 29.6382 1.18187e-05 22.8364V15.8055Z" fill="#0052FF"/>
    <path d="M20.0236 26.5C16.4342 26.5 13.5236 23.5931 13.5236 20C13.5236 16.4069 16.4342 13.5 20.0236 13.5C23.2411 13.5 25.9134 15.8472 26.4261 18.9167H32.9731C32.4206 12.2433 26.8342 7 20.02 7C12.8411 7 7.02002 12.8211 7.02002 20C7.02002 27.1789 12.8411 33 20.02 33C26.8342 33 32.4206 27.7567 32.9731 21.0833H26.4225C25.9061 24.1528 23.2411 26.5 20.0236 26.5Z" fill="white"/>
  </g>
  <defs>
    <clipPath id="clip0_187_29">
      <rect width="40" height="40" fill="white"/>
    </clipPath>
  </defs>
</svg>`;

});

parcelRegister("gAglz", function(module, exports) {

$parcel$export(module.exports, "moonpaySvg", () => $c12cb04d29db7953$export$a9ed45040996931e);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $c12cb04d29db7953$export$a9ed45040996931e = (0, $i7GIz.svg)`
  <svg width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#a)">
      <path
        d="M0 16.6c0-6.168 0-9.251 1.314-11.555a10 10 0 0 1 3.731-3.731C7.35 0 10.432 0 16.6 0h6.8c6.168 0 9.252 0 11.555 1.314a10 10 0 0 1 3.731 3.731C40 7.35 40 10.432 40 16.6v6.8c0 6.168 0 9.252-1.314 11.555a10 10 0 0 1-3.731 3.731C32.652 40 29.568 40 23.4 40h-6.8c-6.168 0-9.251 0-11.555-1.314a10 10 0 0 1-3.731-3.731C0 32.652 0 29.568 0 23.4v-6.8Z"
        fill="#7D00FF"
      />
      <path
        d="M.5 16.6c0-3.093 0-5.38.162-7.182.161-1.795.48-3.061 1.086-4.125a9.5 9.5 0 0 1 3.545-3.545C6.357 1.141 7.623.823 9.418.662 11.221.5 13.508.5 16.6.5h6.8c3.093 0 5.38 0 7.182.162 1.795.161 3.062.48 4.125 1.086a9.5 9.5 0 0 1 3.545 3.545c.607 1.064.925 2.33 1.086 4.125.161 1.803.162 4.09.162 7.182v6.8c0 3.093 0 5.38-.162 7.182-.161 1.795-.48 3.062-1.086 4.125a9.5 9.5 0 0 1-3.545 3.545c-1.063.607-2.33.925-4.125 1.086-1.803.161-4.09.162-7.182.162h-6.8c-3.093 0-5.38 0-7.182-.162-1.795-.161-3.061-.48-4.125-1.086a9.5 9.5 0 0 1-3.545-3.545c-.607-1.063-.925-2.33-1.086-4.125C.5 28.779.5 26.492.5 23.4v-6.8Z"
        stroke="#fff"
        stroke-opacity=".05"
      />
      <path
        d="M28.306 15.381a3.69 3.69 0 1 0 0-7.381 3.69 3.69 0 0 0 0 7.381ZM16.987 32a8.991 8.991 0 1 1 .016-17.983A8.991 8.991 0 0 1 16.988 32Z"
        fill="#fff"
      />
    </g>
    <defs>
      <clipPath id="a"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    </defs>
  </svg>
`;

});

parcelRegister("6v3GD", function(module, exports) {

$parcel$export(module.exports, "stripeSvg", () => $4bb87f6fdb521295$export$e3fac6a9cb8f9c7b);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $4bb87f6fdb521295$export$e3fac6a9cb8f9c7b = (0, $i7GIz.svg)`
  <svg width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#a)">
      <path
        d="M0 16.6c0-6.168 0-9.251 1.314-11.555a10 10 0 0 1 3.731-3.731C7.35 0 10.432 0 16.6 0h6.8c6.168 0 9.252 0 11.555 1.314a10 10 0 0 1 3.731 3.731C40 7.35 40 10.432 40 16.6v6.8c0 6.168 0 9.252-1.314 11.555a10 10 0 0 1-3.731 3.731C32.652 40 29.568 40 23.4 40h-6.8c-6.168 0-9.251 0-11.555-1.314a10 10 0 0 1-3.731-3.731C0 32.652 0 29.568 0 23.4v-6.8Z"
        fill="#635BFF"
      />
      <path
        d="M.5 16.6c0-3.093 0-5.38.162-7.182.161-1.795.48-3.061 1.086-4.125a9.5 9.5 0 0 1 3.545-3.545C6.357 1.141 7.623.823 9.418.662 11.221.5 13.508.5 16.6.5h6.8c3.093 0 5.38 0 7.182.162 1.795.161 3.062.48 4.125 1.086a9.5 9.5 0 0 1 3.545 3.545c.607 1.064.925 2.33 1.086 4.125.161 1.803.162 4.09.162 7.182v6.8c0 3.093 0 5.38-.162 7.182-.161 1.795-.48 3.062-1.086 4.125a9.5 9.5 0 0 1-3.545 3.545c-1.063.607-2.33.925-4.125 1.086-1.803.161-4.09.162-7.182.162h-6.8c-3.093 0-5.38 0-7.182-.162-1.795-.161-3.061-.48-4.125-1.086a9.5 9.5 0 0 1-3.545-3.545c-.607-1.063-.925-2.33-1.086-4.125C.5 28.779.5 26.492.5 23.4v-6.8Z"
        stroke="#fff"
        stroke-opacity=".05"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.299 15.147c0-1.028.844-1.424 2.242-1.424 2.004 0 4.536.607 6.54 1.688V9.213C24.892 8.343 22.73 8 20.541 8c-5.354 0-8.915 2.796-8.915 7.464 0 7.279 10.022 6.118 10.022 9.257 0 1.213-1.055 1.609-2.531 1.609-2.19 0-4.985-.897-7.2-2.11v6.277a18.283 18.283 0 0 0 7.2 1.503c5.485 0 9.257-2.716 9.257-7.437-.027-7.86-10.075-6.462-10.075-9.416Z"
        fill="#fff"
      />
    </g>
    <defs>
      <clipPath id="a"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    </defs>
  </svg>
`;

});

parcelRegister("kMZn1", function(module, exports) {

$parcel$export(module.exports, "paypalSvg", () => $f227e5339e16bcac$export$aa910b71a02cb299);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $f227e5339e16bcac$export$aa910b71a02cb299 = (0, $i7GIz.svg)`
  <svg width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#a)">
      <path
        d="M0 16.6c0-6.168 0-9.251 1.314-11.555a10 10 0 0 1 3.731-3.731C7.35 0 10.432 0 16.6 0h6.8c6.168 0 9.252 0 11.555 1.314a10 10 0 0 1 3.731 3.731C40 7.35 40 10.432 40 16.6v6.8c0 6.168 0 9.252-1.314 11.555a10 10 0 0 1-3.731 3.731C32.652 40 29.568 40 23.4 40h-6.8c-6.168 0-9.251 0-11.555-1.314a10 10 0 0 1-3.731-3.731C0 32.652 0 29.568 0 23.4v-6.8Z"
        fill="#fff"
      />
      <path
        d="M.5 16.6c0-3.093 0-5.38.162-7.182.161-1.795.48-3.061 1.086-4.125a9.5 9.5 0 0 1 3.545-3.545C6.357 1.141 7.623.823 9.418.662 11.221.5 13.508.5 16.6.5h6.8c3.093 0 5.38 0 7.182.162 1.795.161 3.062.48 4.125 1.086a9.5 9.5 0 0 1 3.545 3.545c.607 1.064.925 2.33 1.086 4.125.161 1.803.162 4.09.162 7.182v6.8c0 3.093 0 5.38-.162 7.182-.161 1.795-.48 3.062-1.086 4.125a9.5 9.5 0 0 1-3.545 3.545c-1.063.607-2.33.925-4.125 1.086-1.803.161-4.09.162-7.182.162h-6.8c-3.093 0-5.38 0-7.182-.162-1.795-.161-3.061-.48-4.125-1.086a9.5 9.5 0 0 1-3.545-3.545c-.607-1.063-.925-2.33-1.086-4.125C.5 28.779.5 26.492.5 23.4v-6.8Z"
        stroke="#fff"
        stroke-opacity=".05"
      />
      <path
        d="M18.606 12.642a.781.781 0 0 0-.771.66l-1.281 8.125a.78.78 0 0 1 .77-.66h3.755a7.668 7.668 0 0 0 7.57-6.49 6.26 6.26 0 0 0 .075-.843c-.96-.504-2.089-.792-3.325-.792h-6.793Z"
        fill="#001C64"
      />
      <path
        d="M28.724 13.434c-.006.282-.03.564-.075.843a7.668 7.668 0 0 1-7.57 6.491h-3.754a.78.78 0 0 0-.771.66l-1.916 12.15a.634.634 0 0 0 .626.734h4.075a.781.781 0 0 0 .77-.66l1.074-6.807a.781.781 0 0 1 .772-.66h2.4a7.668 7.668 0 0 0 7.57-6.491c.415-2.651-.92-5.064-3.201-6.26Z"
        fill="#0070E0"
      />
      <path
        d="M13.977 7.226a.78.78 0 0 0-.771.658l-3.198 20.277a.634.634 0 0 0 .626.733h4.742l1.178-7.467 1.281-8.125a.782.782 0 0 1 .771-.66H25.4c1.237 0 2.364.289 3.325.792.065-3.4-2.74-6.208-6.599-6.208h-8.148Z"
        fill="#003087"
      />
    </g>
    <defs>
      <clipPath id="a"><path fill="#fff" d="M0 0h40v40H0z" /></clipPath>
    </defs>
  </svg>
`;

});

parcelRegister("ePbyt", function(module, exports) {

$parcel$export(module.exports, "onrampCardSvg", () => $acaecab3ec5b20f1$export$bfa60d0bcc3bcad2);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $acaecab3ec5b20f1$export$bfa60d0bcc3bcad2 = (0, $i7GIz.svg)`<svg width="60" height="60" viewBox="0 0 60 60" fill="none">
<g clip-path="url(#clip0_13859_31161)">
  <path d="M0 24.8995C0 15.6481 0 11.0223 1.97053 7.56763C3.3015 5.2342 5.23468 3.30101 7.56812 1.97004C11.0228 -0.000488281 15.6485 -0.000488281 24.9 -0.000488281H35.1C44.3514 -0.000488281 48.9772 -0.000488281 52.4319 1.97004C54.7653 3.30101 56.6985 5.2342 58.0295 7.56763C60 11.0223 60 15.6481 60 24.8995V35.0995C60 44.351 60 48.9767 58.0295 52.4314C56.6985 54.7648 54.7653 56.698 52.4319 58.029C48.9772 59.9995 44.3514 59.9995 35.1 59.9995H24.9C15.6485 59.9995 11.0228 59.9995 7.56812 58.029C5.23468 56.698 3.3015 54.7648 1.97053 52.4314C0 48.9767 0 44.351 0 35.0995V24.8995Z" fill="#EB8B47"/>
  <path d="M0.5 24.8995C0.5 20.2647 0.50047 16.8216 0.744315 14.1045C0.987552 11.3941 1.46987 9.45455 2.40484 7.81536C3.69145 5.55971 5.56019 3.69096 7.81585 2.40435C9.45504 1.46938 11.3946 0.987064 14.105 0.743826C16.8221 0.499981 20.2652 0.499512 24.9 0.499512H35.1C39.7348 0.499512 43.1779 0.499981 45.895 0.743826C48.6054 0.987064 50.545 1.46938 52.1841 2.40435C54.4398 3.69096 56.3086 5.55971 57.5952 7.81536C58.5301 9.45455 59.0124 11.3941 59.2557 14.1045C59.4995 16.8216 59.5 20.2647 59.5 24.8995V35.0995C59.5 39.7343 59.4995 43.1774 59.2557 45.8945C59.0124 48.6049 58.5301 50.5445 57.5952 52.1837C56.3086 54.4393 54.4398 56.3081 52.1841 57.5947C50.545 58.5296 48.6054 59.012 45.895 59.2552C43.1779 59.499 39.7348 59.4995 35.1 59.4995H24.9C20.2652 59.4995 16.8221 59.499 14.105 59.2552C11.3946 59.012 9.45504 58.5296 7.81585 57.5947C5.56019 56.3081 3.69145 54.4393 2.40484 52.1837C1.46987 50.5445 0.987552 48.6049 0.744315 45.8945C0.50047 43.1774 0.5 39.7343 0.5 35.0995V24.8995Z" stroke="#141414" stroke-opacity="0.1"/>
  <path d="M13 26.0335C13 21.7838 13 19.659 14.0822 18.1694C14.4318 17.6883 14.8548 17.2653 15.3359 16.9157C16.8255 15.8335 18.9503 15.8335 23.2 15.8335H36.8C41.0497 15.8335 43.1745 15.8335 44.6641 16.9157C45.1452 17.2653 45.5682 17.6883 45.9178 18.1694C47 19.659 47 21.7838 47 26.0335V33.9668C47 38.2165 47 40.3414 45.9178 41.831C45.5682 42.312 45.1452 42.7351 44.6641 43.0846C43.1745 44.1668 41.0497 44.1668 36.8 44.1668H23.2C18.9503 44.1668 16.8255 44.1668 15.3359 43.0846C14.8548 42.7351 14.4318 42.312 14.0822 41.831C13 40.3414 13 38.2165 13 33.9668V26.0335Z" fill="#FF974C" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M39.5 36.667H36.6666" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M45.2 23.0645H14.8C14.0501 23.0645 13.6751 23.0645 13.4122 23.2554C13.3273 23.3171 13.2527 23.3918 13.191 23.4767C13 23.7395 13 24.1145 13 24.8645V27.2645C13 28.0144 13 28.3894 13.191 28.6522C13.2527 28.7371 13.3273 28.8118 13.4122 28.8735C13.6751 29.0645 14.0501 29.0645 14.8 29.0645H45.2C45.9499 29.0645 46.3249 29.0645 46.5878 28.8735C46.6727 28.8118 46.7473 28.7371 46.809 28.6522C47 28.3894 47 28.0144 47 27.2645V24.8645C47 24.1145 47 23.7395 46.809 23.4767C46.7473 23.3918 46.6727 23.3171 46.5878 23.2554C46.3249 23.0645 45.9499 23.0645 45.2 23.0645Z" fill="white" fill-opacity="0.4" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
  <clipPath id="clip0_13859_31161">
    <rect width="60" height="60" fill="white"/>
  </clipPath>
</defs>
</svg>`;

});

parcelRegister("fieFp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b223ea0007a7b90c$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $b223ea0007a7b90c$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    display: block;
    width: var(--local-size);
    height: var(--local-size);
  }

  :host svg {
    width: 100%;
    height: 100%;
  }
`;

});


parcelRegister("8pDtD", function(module, exports) {

$parcel$export(module.exports, "WuiAccountButton", () => $61ff47d7deb61d83$export$bfec9622ebde4e9e);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
parcelRequire("lP6NM");
var $j71f4 = parcelRequire("j71f4");
parcelRequire("1fjkg");
parcelRequire("eFeuH");
parcelRequire("aiZ8J");

var $9rwwE = parcelRequire("9rwwE");

var $97bbL = parcelRequire("97bbL");

var $lkv4o = parcelRequire("lkv4o");
parcelRequire("1RCf2");
parcelRequire("e4QeF");

var $aKFkx = parcelRequire("aKFkx");
var $61ff47d7deb61d83$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $61ff47d7deb61d83$export$bfec9622ebde4e9e = class WuiAccountButton extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.networkSrc = undefined;
        this.avatarSrc = undefined;
        this.balance = undefined;
        this.isUnsupportedChain = undefined;
        this.disabled = false;
        this.isProfileName = false;
        this.address = "";
        this.charsStart = 4;
        this.charsEnd = 6;
    }
    render() {
        return (0, $i7GIz.html)`
      <button
        ?disabled=${this.disabled}
        class=${(0, $j71f4.ifDefined)(this.balance ? undefined : "local-no-balance")}
      >
        ${this.balanceTemplate()}
        <wui-flex gap="xxs" alignItems="center">
          <wui-avatar
            .imageSrc=${this.avatarSrc}
            alt=${this.address}
            address=${this.address}
          ></wui-avatar>
          <wui-text variant="paragraph-600" color="inherit">
            ${(0, $97bbL.UiHelperUtil).getTruncateString({
            string: this.address,
            charsStart: this.isProfileName ? 18 : this.charsStart,
            charsEnd: this.isProfileName ? 0 : this.charsEnd,
            truncate: this.isProfileName ? "end" : "middle"
        })}
          </wui-text>
        </wui-flex>
      </button>
    `;
    }
    balanceTemplate() {
        if (this.isUnsupportedChain) return (0, $i7GIz.html)` <wui-icon-box
          size="sm"
          iconColor="error-100"
          backgroundColor="error-100"
          icon="warningCircle"
        ></wui-icon-box>
        <wui-text variant="paragraph-600" color="inherit"> Switch Network</wui-text>`;
        if (this.balance) {
            const networkElement = this.networkSrc ? (0, $i7GIz.html)`<wui-image src=${this.networkSrc}></wui-image>` : (0, $i7GIz.html)`
            <wui-icon-box
              size="sm"
              iconColor="fg-200"
              backgroundColor="fg-300"
              icon="networkPlaceholder"
            ></wui-icon-box>
          `;
            return (0, $i7GIz.html)`
        ${networkElement}
        <wui-text variant="paragraph-600" color="inherit"> ${this.balance} </wui-text>
      `;
        }
        return null;
    }
};
$61ff47d7deb61d83$export$bfec9622ebde4e9e.styles = [
    (0, $9rwwE.resetStyles),
    (0, $9rwwE.elementStyles),
    (0, $aKFkx.default)
];
$61ff47d7deb61d83$var$__decorate([
    (0, $cRlTX.property)()
], $61ff47d7deb61d83$export$bfec9622ebde4e9e.prototype, "networkSrc", void 0);
$61ff47d7deb61d83$var$__decorate([
    (0, $cRlTX.property)()
], $61ff47d7deb61d83$export$bfec9622ebde4e9e.prototype, "avatarSrc", void 0);
$61ff47d7deb61d83$var$__decorate([
    (0, $cRlTX.property)()
], $61ff47d7deb61d83$export$bfec9622ebde4e9e.prototype, "balance", void 0);
$61ff47d7deb61d83$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $61ff47d7deb61d83$export$bfec9622ebde4e9e.prototype, "isUnsupportedChain", void 0);
$61ff47d7deb61d83$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $61ff47d7deb61d83$export$bfec9622ebde4e9e.prototype, "disabled", void 0);
$61ff47d7deb61d83$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $61ff47d7deb61d83$export$bfec9622ebde4e9e.prototype, "isProfileName", void 0);
$61ff47d7deb61d83$var$__decorate([
    (0, $cRlTX.property)()
], $61ff47d7deb61d83$export$bfec9622ebde4e9e.prototype, "address", void 0);
$61ff47d7deb61d83$var$__decorate([
    (0, $cRlTX.property)()
], $61ff47d7deb61d83$export$bfec9622ebde4e9e.prototype, "charsStart", void 0);
$61ff47d7deb61d83$var$__decorate([
    (0, $cRlTX.property)()
], $61ff47d7deb61d83$export$bfec9622ebde4e9e.prototype, "charsEnd", void 0);
$61ff47d7deb61d83$export$bfec9622ebde4e9e = $61ff47d7deb61d83$var$__decorate([
    (0, $lkv4o.customElement)("wui-account-button")
], $61ff47d7deb61d83$export$bfec9622ebde4e9e);

});
parcelRegister("lP6NM", function(module, exports) {
$parcel$export(module.exports, "ifDefined", () => (parcelRequire("j71f4")).ifDefined);
parcelRequire("j71f4");

});
parcelRegister("j71f4", function(module, exports) {

$parcel$export(module.exports, "ifDefined", () => $de9fa26b99a6732c$export$f68dd208b5df064d);

var $i7GIz = parcelRequire("i7GIz");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $de9fa26b99a6732c$export$f68dd208b5df064d = (t)=>t ?? (0, $i7GIz.nothing);

});


parcelRegister("aiZ8J", function(module, exports) {

$parcel$export(module.exports, "WuiFlex", () => $780b02e89dec0fcd$export$cb455767ea18ce95);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");

var $9rwwE = parcelRequire("9rwwE");

var $97bbL = parcelRequire("97bbL");

var $lkv4o = parcelRequire("lkv4o");

var $h87CB = parcelRequire("h87CB");
var $780b02e89dec0fcd$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $780b02e89dec0fcd$export$cb455767ea18ce95 = class WuiFlex extends (0, $3KB8N.LitElement) {
    render() {
        this.style.cssText = `
      flex-direction: ${this.flexDirection};
      flex-wrap: ${this.flexWrap};
      flex-basis: ${this.flexBasis};
      flex-grow: ${this.flexGrow};
      flex-shrink: ${this.flexShrink};
      align-items: ${this.alignItems};
      justify-content: ${this.justifyContent};
      column-gap: ${this.columnGap && `var(--wui-spacing-${this.columnGap})`};
      row-gap: ${this.rowGap && `var(--wui-spacing-${this.rowGap})`};
      gap: ${this.gap && `var(--wui-spacing-${this.gap})`};
      padding-top: ${this.padding && (0, $97bbL.UiHelperUtil).getSpacingStyles(this.padding, 0)};
      padding-right: ${this.padding && (0, $97bbL.UiHelperUtil).getSpacingStyles(this.padding, 1)};
      padding-bottom: ${this.padding && (0, $97bbL.UiHelperUtil).getSpacingStyles(this.padding, 2)};
      padding-left: ${this.padding && (0, $97bbL.UiHelperUtil).getSpacingStyles(this.padding, 3)};
      margin-top: ${this.margin && (0, $97bbL.UiHelperUtil).getSpacingStyles(this.margin, 0)};
      margin-right: ${this.margin && (0, $97bbL.UiHelperUtil).getSpacingStyles(this.margin, 1)};
      margin-bottom: ${this.margin && (0, $97bbL.UiHelperUtil).getSpacingStyles(this.margin, 2)};
      margin-left: ${this.margin && (0, $97bbL.UiHelperUtil).getSpacingStyles(this.margin, 3)};
    `;
        return (0, $i7GIz.html)`<slot></slot>`;
    }
};
$780b02e89dec0fcd$export$cb455767ea18ce95.styles = [
    (0, $9rwwE.resetStyles),
    (0, $h87CB.default)
];
$780b02e89dec0fcd$var$__decorate([
    (0, $cRlTX.property)()
], $780b02e89dec0fcd$export$cb455767ea18ce95.prototype, "flexDirection", void 0);
$780b02e89dec0fcd$var$__decorate([
    (0, $cRlTX.property)()
], $780b02e89dec0fcd$export$cb455767ea18ce95.prototype, "flexWrap", void 0);
$780b02e89dec0fcd$var$__decorate([
    (0, $cRlTX.property)()
], $780b02e89dec0fcd$export$cb455767ea18ce95.prototype, "flexBasis", void 0);
$780b02e89dec0fcd$var$__decorate([
    (0, $cRlTX.property)()
], $780b02e89dec0fcd$export$cb455767ea18ce95.prototype, "flexGrow", void 0);
$780b02e89dec0fcd$var$__decorate([
    (0, $cRlTX.property)()
], $780b02e89dec0fcd$export$cb455767ea18ce95.prototype, "flexShrink", void 0);
$780b02e89dec0fcd$var$__decorate([
    (0, $cRlTX.property)()
], $780b02e89dec0fcd$export$cb455767ea18ce95.prototype, "alignItems", void 0);
$780b02e89dec0fcd$var$__decorate([
    (0, $cRlTX.property)()
], $780b02e89dec0fcd$export$cb455767ea18ce95.prototype, "justifyContent", void 0);
$780b02e89dec0fcd$var$__decorate([
    (0, $cRlTX.property)()
], $780b02e89dec0fcd$export$cb455767ea18ce95.prototype, "columnGap", void 0);
$780b02e89dec0fcd$var$__decorate([
    (0, $cRlTX.property)()
], $780b02e89dec0fcd$export$cb455767ea18ce95.prototype, "rowGap", void 0);
$780b02e89dec0fcd$var$__decorate([
    (0, $cRlTX.property)()
], $780b02e89dec0fcd$export$cb455767ea18ce95.prototype, "gap", void 0);
$780b02e89dec0fcd$var$__decorate([
    (0, $cRlTX.property)()
], $780b02e89dec0fcd$export$cb455767ea18ce95.prototype, "padding", void 0);
$780b02e89dec0fcd$var$__decorate([
    (0, $cRlTX.property)()
], $780b02e89dec0fcd$export$cb455767ea18ce95.prototype, "margin", void 0);
$780b02e89dec0fcd$export$cb455767ea18ce95 = $780b02e89dec0fcd$var$__decorate([
    (0, $lkv4o.customElement)("wui-flex")
], $780b02e89dec0fcd$export$cb455767ea18ce95);

});
parcelRegister("97bbL", function(module, exports) {

$parcel$export(module.exports, "UiHelperUtil", () => $6a2d725d57c500f1$export$be769b74c01bc1bc);
const $6a2d725d57c500f1$export$be769b74c01bc1bc = {
    getSpacingStyles (spacing, index) {
        if (Array.isArray(spacing)) return spacing[index] ? `var(--wui-spacing-${spacing[index]})` : undefined;
        else if (typeof spacing === "string") return `var(--wui-spacing-${spacing})`;
        return undefined;
    },
    getFormattedDate (date) {
        return new Intl.DateTimeFormat("en-US", {
            month: "short",
            day: "numeric"
        }).format(date);
    },
    getHostName (url) {
        const newUrl = new URL(url);
        return newUrl.hostname;
    },
    getTruncateString ({ string: string, charsStart: charsStart, charsEnd: charsEnd, truncate: truncate }) {
        if (string.length <= charsStart + charsEnd) return string;
        if (truncate === "end") return `${string.substring(0, charsStart)}...`;
        else if (truncate === "start") return `...${string.substring(string.length - charsEnd)}`;
        return `${string.substring(0, Math.floor(charsStart))}...${string.substring(string.length - Math.floor(charsEnd))}`;
    },
    generateAvatarColors (address) {
        const hash = address.toLowerCase().replace(/^0x/iu, "");
        const baseColor = hash.substring(0, 6);
        const rgbColor = this.hexToRgb(baseColor);
        const masterBorderRadius = getComputedStyle(document.documentElement).getPropertyValue("--w3m-border-radius-master");
        const radius = Number(masterBorderRadius?.replace("px", ""));
        const edge = 100 - 3 * radius;
        const gradientCircle = `${edge}% ${edge}% at 65% 40%`;
        const colors = [];
        for(let i = 0; i < 5; i += 1){
            const tintedColor = this.tintColor(rgbColor, 0.15 * i);
            colors.push(`rgb(${tintedColor[0]}, ${tintedColor[1]}, ${tintedColor[2]})`);
        }
        return `
    --local-color-1: ${colors[0]};
    --local-color-2: ${colors[1]};
    --local-color-3: ${colors[2]};
    --local-color-4: ${colors[3]};
    --local-color-5: ${colors[4]};
    --local-radial-circle: ${gradientCircle}
   `;
    },
    hexToRgb (hex) {
        const bigint = parseInt(hex, 16);
        const r = bigint >> 16 & 255;
        const g = bigint >> 8 & 255;
        const b = bigint & 255;
        return [
            r,
            g,
            b
        ];
    },
    tintColor (rgb, tint) {
        const [r, g, b] = rgb;
        const tintedR = Math.round(r + (255 - r) * tint);
        const tintedG = Math.round(g + (255 - g) * tint);
        const tintedB = Math.round(b + (255 - b) * tint);
        return [
            tintedR,
            tintedG,
            tintedB
        ];
    },
    isNumber (character) {
        const regex = {
            number: /^[0-9]+$/u
        };
        return regex.number.test(character);
    },
    getColorTheme (theme) {
        if (theme) return theme;
        else if (typeof window !== "undefined" && window.matchMedia) {
            if (window.matchMedia("(prefers-color-scheme: dark)").matches) return "dark";
            return "light";
        }
        return "dark";
    }
};

});

parcelRegister("h87CB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c78918896219e88d$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $c78918896219e88d$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    display: flex;
    width: inherit;
    height: inherit;
  }
`;

});


parcelRegister("1RCf2", function(module, exports) {

$parcel$export(module.exports, "WuiAvatar", () => $15b867ae74a5d000$export$21cc36693be5eb11);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
parcelRequire("1fjkg");

var $9rwwE = parcelRequire("9rwwE");

var $97bbL = parcelRequire("97bbL");

var $lkv4o = parcelRequire("lkv4o");

var $ky4Qf = parcelRequire("ky4Qf");
var $15b867ae74a5d000$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $15b867ae74a5d000$export$21cc36693be5eb11 = class WuiAvatar extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.imageSrc = undefined;
        this.alt = undefined;
        this.address = undefined;
    }
    render() {
        return (0, $i7GIz.html)`${this.visualTemplate()}`;
    }
    visualTemplate() {
        if (this.imageSrc) {
            this.dataset["variant"] = "image";
            return (0, $i7GIz.html)`<wui-image src=${this.imageSrc} alt=${this.alt ?? "avatar"}></wui-image>`;
        } else if (this.address) {
            this.dataset["variant"] = "generated";
            const cssColors = (0, $97bbL.UiHelperUtil).generateAvatarColors(this.address);
            this.style.cssText = cssColors;
            return null;
        }
        this.dataset["variant"] = "default";
        return null;
    }
};
$15b867ae74a5d000$export$21cc36693be5eb11.styles = [
    (0, $9rwwE.resetStyles),
    (0, $ky4Qf.default)
];
$15b867ae74a5d000$var$__decorate([
    (0, $cRlTX.property)()
], $15b867ae74a5d000$export$21cc36693be5eb11.prototype, "imageSrc", void 0);
$15b867ae74a5d000$var$__decorate([
    (0, $cRlTX.property)()
], $15b867ae74a5d000$export$21cc36693be5eb11.prototype, "alt", void 0);
$15b867ae74a5d000$var$__decorate([
    (0, $cRlTX.property)()
], $15b867ae74a5d000$export$21cc36693be5eb11.prototype, "address", void 0);
$15b867ae74a5d000$export$21cc36693be5eb11 = $15b867ae74a5d000$var$__decorate([
    (0, $lkv4o.customElement)("wui-avatar")
], $15b867ae74a5d000$export$21cc36693be5eb11);

});
parcelRegister("ky4Qf", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef5abd14301334a2$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $ef5abd14301334a2$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    display: block;
    width: var(--wui-icon-box-size-xl);
    height: var(--wui-icon-box-size-xl);
    border-radius: var(--wui-border-radius-3xl);
    box-shadow: 0 0 0 8px var(--wui-gray-glass-005);
    overflow: hidden;
    position: relative;
  }

  :host([data-variant='generated']) {
    --mixed-local-color-1: var(--local-color-1);
    --mixed-local-color-2: var(--local-color-2);
    --mixed-local-color-3: var(--local-color-3);
    --mixed-local-color-4: var(--local-color-4);
    --mixed-local-color-5: var(--local-color-5);
  }

  @supports (background: color-mix(in srgb, white 50%, black)) {
    :host([data-variant='generated']) {
      --mixed-local-color-1: color-mix(
        in srgb,
        var(--w3m-color-mix) var(--w3m-color-mix-strength),
        var(--local-color-1)
      );
      --mixed-local-color-2: color-mix(
        in srgb,
        var(--w3m-color-mix) var(--w3m-color-mix-strength),
        var(--local-color-2)
      );
      --mixed-local-color-3: color-mix(
        in srgb,
        var(--w3m-color-mix) var(--w3m-color-mix-strength),
        var(--local-color-3)
      );
      --mixed-local-color-4: color-mix(
        in srgb,
        var(--w3m-color-mix) var(--w3m-color-mix-strength),
        var(--local-color-4)
      );
      --mixed-local-color-5: color-mix(
        in srgb,
        var(--w3m-color-mix) var(--w3m-color-mix-strength),
        var(--local-color-5)
      );
    }
  }

  :host([data-variant='generated']) {
    box-shadow: 0 0 0 8px var(--wui-gray-glass-005);
    background: radial-gradient(
      var(--local-radial-circle),
      #fff 0.52%,
      var(--mixed-local-color-5) 31.25%,
      var(--mixed-local-color-3) 51.56%,
      var(--mixed-local-color-2) 65.63%,
      var(--mixed-local-color-1) 82.29%,
      var(--mixed-local-color-4) 100%
    );
  }

  :host([data-variant='default']) {
    box-shadow: 0 0 0 8px var(--wui-gray-glass-005);
    background: radial-gradient(
      75.29% 75.29% at 64.96% 24.36%,
      #fff 0.52%,
      #f5ccfc 31.25%,
      #dba4f5 51.56%,
      #9a8ee8 65.63%,
      #6493da 82.29%,
      #6ebdea 100%
    );
  }
`;

});


parcelRegister("e4QeF", function(module, exports) {

$parcel$export(module.exports, "WuiIconBox", () => $a3f9f547e50996b2$export$df20651935c1141);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
parcelRequire("cvzvT");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");

var $hme4v = parcelRequire("hme4v");
var $a3f9f547e50996b2$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $a3f9f547e50996b2$export$df20651935c1141 = class WuiIconBox extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.size = "md";
        this.backgroundColor = "accent-100";
        this.iconColor = "accent-100";
        this.background = "transparent";
        this.border = false;
        this.borderColor = "wui-color-bg-125";
        this.icon = "copy";
    }
    render() {
        const iconSize = this.iconSize || this.size;
        const isLg = this.size === "lg";
        const isXl = this.size === "xl";
        const bgMix = isLg ? "12%" : "16%";
        const borderRadius = isLg ? "xxs" : isXl ? "s" : "3xl";
        const isGray = this.background === "gray";
        const isOpaque = this.background === "opaque";
        const isColorChange = this.backgroundColor === "accent-100" && isOpaque || this.backgroundColor === "success-100" && isOpaque || this.backgroundColor === "error-100" && isOpaque || this.backgroundColor === "inverse-100" && isOpaque;
        let bgValueVariable = `var(--wui-color-${this.backgroundColor})`;
        if (isColorChange) bgValueVariable = `var(--wui-icon-box-bg-${this.backgroundColor})`;
        else if (isGray) bgValueVariable = `var(--wui-gray-${this.backgroundColor})`;
        this.style.cssText = `
       --local-bg-value: ${bgValueVariable};
       --local-bg-mix: ${isColorChange || isGray ? `100%` : bgMix};
       --local-border-radius: var(--wui-border-radius-${borderRadius});
       --local-size: var(--wui-icon-box-size-${this.size});
       --local-border: ${this.borderColor === "wui-color-bg-125" ? `2px` : `1px`} solid ${this.border ? `var(--${this.borderColor})` : `transparent`}
   `;
        return (0, $i7GIz.html)` <wui-icon color=${this.iconColor} size=${iconSize} name=${this.icon}></wui-icon> `;
    }
};
$a3f9f547e50996b2$export$df20651935c1141.styles = [
    (0, $9rwwE.resetStyles),
    (0, $9rwwE.elementStyles),
    (0, $hme4v.default)
];
$a3f9f547e50996b2$var$__decorate([
    (0, $cRlTX.property)()
], $a3f9f547e50996b2$export$df20651935c1141.prototype, "size", void 0);
$a3f9f547e50996b2$var$__decorate([
    (0, $cRlTX.property)()
], $a3f9f547e50996b2$export$df20651935c1141.prototype, "backgroundColor", void 0);
$a3f9f547e50996b2$var$__decorate([
    (0, $cRlTX.property)()
], $a3f9f547e50996b2$export$df20651935c1141.prototype, "iconColor", void 0);
$a3f9f547e50996b2$var$__decorate([
    (0, $cRlTX.property)()
], $a3f9f547e50996b2$export$df20651935c1141.prototype, "iconSize", void 0);
$a3f9f547e50996b2$var$__decorate([
    (0, $cRlTX.property)()
], $a3f9f547e50996b2$export$df20651935c1141.prototype, "background", void 0);
$a3f9f547e50996b2$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $a3f9f547e50996b2$export$df20651935c1141.prototype, "border", void 0);
$a3f9f547e50996b2$var$__decorate([
    (0, $cRlTX.property)()
], $a3f9f547e50996b2$export$df20651935c1141.prototype, "borderColor", void 0);
$a3f9f547e50996b2$var$__decorate([
    (0, $cRlTX.property)()
], $a3f9f547e50996b2$export$df20651935c1141.prototype, "icon", void 0);
$a3f9f547e50996b2$export$df20651935c1141 = $a3f9f547e50996b2$var$__decorate([
    (0, $lkv4o.customElement)("wui-icon-box")
], $a3f9f547e50996b2$export$df20651935c1141);

});
parcelRegister("hme4v", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca2f6815866c01f2$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $ca2f6815866c01f2$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    position: relative;
    overflow: hidden;
    background-color: var(--wui-gray-glass-020);
    border-radius: var(--local-border-radius);
    border: var(--local-border);
    box-sizing: content-box;
    width: var(--local-size);
    height: var(--local-size);
    min-height: var(--local-size);
    min-width: var(--local-size);
  }

  @supports (background: color-mix(in srgb, white 50%, black)) {
    :host {
      background-color: color-mix(in srgb, var(--local-bg-value) var(--local-bg-mix), transparent);
    }
  }
`;

});


parcelRegister("aKFkx", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d3e42967ae10f88$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $7d3e42967ae10f88$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    display: block;
  }

  button {
    border-radius: var(--wui-border-radius-3xl);
    background: var(--wui-gray-glass-002);
    display: flex;
    gap: var(--wui-spacing-xs);
    padding: var(--wui-spacing-3xs) var(--wui-spacing-xs) var(--wui-spacing-3xs)
      var(--wui-spacing-xs);
    border: 1px solid var(--wui-gray-glass-005);
  }

  button:disabled {
    background: var(--wui-gray-glass-015);
  }

  button:disabled > wui-text {
    color: var(--wui-gray-glass-015);
  }

  button:disabled > wui-flex > wui-text {
    color: var(--wui-gray-glass-015);
  }

  button:disabled > wui-image,
  button:disabled > wui-icon-box,
  button:disabled > wui-flex > wui-avatar {
    filter: grayscale(1);
  }

  button:has(wui-image) {
    padding: var(--wui-spacing-3xs) var(--wui-spacing-3xs) var(--wui-spacing-3xs)
      var(--wui-spacing-xs);
  }

  wui-text {
    color: var(--wui-color-fg-100);
  }

  wui-flex > wui-text {
    color: var(--wui-color-fg-200);
    transition: all var(--wui-ease-out-power-1) var(--wui-duration-lg);
  }

  wui-image,
  wui-icon-box {
    border-radius: var(--wui-border-radius-3xl);
    width: 24px;
    height: 24px;
    box-shadow: 0 0 0 2px var(--wui-gray-glass-005);
  }

  wui-flex {
    border-radius: var(--wui-border-radius-3xl);
    border: 1px solid var(--wui-gray-glass-005);
    background: var(--wui-gray-glass-005);
    padding: 4px var(--wui-spacing-m) 4px var(--wui-spacing-xxs);
  }

  button.local-no-balance {
    border-radius: 0px;
    border: none;
    background: transparent;
  }

  wui-avatar {
    width: 20px;
    height: 20px;
    box-shadow: 0 0 0 2px var(--wui-accent-glass-010);
  }

  @media (max-width: 500px) {
    button {
      gap: 0px;
      padding: var(--wui-spacing-3xs) var(--wui-spacing-xs) !important;
      height: 32px;
    }
    wui-image,
    wui-icon-box,
    button > wui-text {
      visibility: hidden;
      width: 0px;
      height: 0px;
    }
    button {
      border-radius: 0px;
      border: none;
      background: transparent;
      padding: 0px;
    }
  }

  @media (hover: hover) and (pointer: fine) {
    button:hover:enabled > wui-flex > wui-text {
      color: var(--wui-color-fg-175);
    }

    button:active:enabled > wui-flex > wui-text {
      color: var(--wui-color-fg-175);
    }
  }
`;

});


parcelRegister("lx9aw", function(module, exports) {

$parcel$export(module.exports, "WuiAllWalletsImage", () => $fad3cabc2abe2a27$export$92558ad1dd06e644);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
parcelRequire("lP6NM");
var $j71f4 = parcelRequire("j71f4");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");
parcelRequire("fSvVa");
parcelRequire("e4QeF");

var $cgpzR = parcelRequire("cgpzR");
var $fad3cabc2abe2a27$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $fad3cabc2abe2a27$var$TOTAL_IMAGES = 4;
let $fad3cabc2abe2a27$export$92558ad1dd06e644 = class WuiAllWalletsImage extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.walletImages = [];
    }
    render() {
        const isPlaceholders = this.walletImages.length < $fad3cabc2abe2a27$var$TOTAL_IMAGES;
        return (0, $i7GIz.html)`${this.walletImages.slice(0, $fad3cabc2abe2a27$var$TOTAL_IMAGES).map(({ src: src, walletName: walletName })=>(0, $i7GIz.html)`
            <wui-wallet-image
              size="inherit"
              imageSrc=${src}
              name=${(0, $j71f4.ifDefined)(walletName)}
            ></wui-wallet-image>
          `)}
      ${isPlaceholders ? [
            ...Array($fad3cabc2abe2a27$var$TOTAL_IMAGES - this.walletImages.length)
        ].map(()=>(0, $i7GIz.html)` <wui-wallet-image size="inherit" name=""></wui-wallet-image>`) : null}
      <wui-flex>
        <wui-icon-box
          size="xxs"
          iconSize="xxs"
          iconcolor="success-100"
          backgroundcolor="success-100"
          icon="checkmark"
          background="opaque"
        ></wui-icon-box>
      </wui-flex>`;
    }
};
$fad3cabc2abe2a27$export$92558ad1dd06e644.styles = [
    (0, $9rwwE.resetStyles),
    (0, $cgpzR.default)
];
$fad3cabc2abe2a27$var$__decorate([
    (0, $cRlTX.property)({
        type: Array
    })
], $fad3cabc2abe2a27$export$92558ad1dd06e644.prototype, "walletImages", void 0);
$fad3cabc2abe2a27$export$92558ad1dd06e644 = $fad3cabc2abe2a27$var$__decorate([
    (0, $lkv4o.customElement)("wui-all-wallets-image")
], $fad3cabc2abe2a27$export$92558ad1dd06e644);

});
parcelRegister("fSvVa", function(module, exports) {

$parcel$export(module.exports, "WuiWalletImage", () => $b8f4a8fdb60aaed1$export$2df48f4f4e74a226);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
parcelRequire("cvzvT");
parcelRequire("1fjkg");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");
parcelRequire("e4QeF");

var $iVaB2 = parcelRequire("iVaB2");
var $b8f4a8fdb60aaed1$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $b8f4a8fdb60aaed1$export$2df48f4f4e74a226 = class WuiWalletImage extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.size = "md";
        this.name = "";
        this.installed = false;
        this.badgeSize = "xs";
    }
    render() {
        let borderRadius = "xxs";
        if (this.size === "lg") borderRadius = "m";
        else if (this.size === "md") borderRadius = "xs";
        else borderRadius = "xxs";
        this.style.cssText = `
       --local-border-radius: var(--wui-border-radius-${borderRadius});
       --local-size: var(--wui-wallet-image-size-${this.size});
   `;
        if (this.walletIcon) this.dataset["walletIcon"] = this.walletIcon;
        return (0, $i7GIz.html)`
      <wui-flex justifyContent="center" alignItems="center"> ${this.templateVisual()} </wui-flex>
    `;
    }
    templateVisual() {
        if (this.imageSrc) return (0, $i7GIz.html)`<wui-image src=${this.imageSrc} alt=${this.name}></wui-image>`;
        else if (this.walletIcon) return (0, $i7GIz.html)`<wui-icon
        data-parent-size="md"
        size="md"
        color="inherit"
        name=${this.walletIcon}
      ></wui-icon>`;
        return (0, $i7GIz.html)`<wui-icon
      data-parent-size=${this.size}
      size="inherit"
      color="inherit"
      name="walletPlaceholder"
    ></wui-icon>`;
    }
};
$b8f4a8fdb60aaed1$export$2df48f4f4e74a226.styles = [
    (0, $9rwwE.resetStyles),
    (0, $iVaB2.default)
];
$b8f4a8fdb60aaed1$var$__decorate([
    (0, $cRlTX.property)()
], $b8f4a8fdb60aaed1$export$2df48f4f4e74a226.prototype, "size", void 0);
$b8f4a8fdb60aaed1$var$__decorate([
    (0, $cRlTX.property)()
], $b8f4a8fdb60aaed1$export$2df48f4f4e74a226.prototype, "name", void 0);
$b8f4a8fdb60aaed1$var$__decorate([
    (0, $cRlTX.property)()
], $b8f4a8fdb60aaed1$export$2df48f4f4e74a226.prototype, "imageSrc", void 0);
$b8f4a8fdb60aaed1$var$__decorate([
    (0, $cRlTX.property)()
], $b8f4a8fdb60aaed1$export$2df48f4f4e74a226.prototype, "walletIcon", void 0);
$b8f4a8fdb60aaed1$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $b8f4a8fdb60aaed1$export$2df48f4f4e74a226.prototype, "installed", void 0);
$b8f4a8fdb60aaed1$var$__decorate([
    (0, $cRlTX.property)()
], $b8f4a8fdb60aaed1$export$2df48f4f4e74a226.prototype, "badgeSize", void 0);
$b8f4a8fdb60aaed1$export$2df48f4f4e74a226 = $b8f4a8fdb60aaed1$var$__decorate([
    (0, $lkv4o.customElement)("wui-wallet-image")
], $b8f4a8fdb60aaed1$export$2df48f4f4e74a226);

});
parcelRegister("iVaB2", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc65c51358767922$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $dc65c51358767922$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    position: relative;
    background-color: var(--wui-gray-glass-002);
    display: flex;
    justify-content: center;
    align-items: center;
    width: var(--local-size);
    height: var(--local-size);
    border-radius: inherit;
    border-radius: var(--local-border-radius);
  }

  :host > wui-flex {
    overflow: hidden;
    border-radius: inherit;
    border-radius: var(--local-border-radius);
  }

  :host::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: inherit;
    border: 1px solid var(--wui-gray-glass-010);
    pointer-events: none;
  }

  :host([name='Extension'])::after {
    border: 1px solid var(--wui-accent-glass-010);
  }

  :host([data-wallet-icon='allWallets']) {
    background-color: var(--wui-all-wallets-bg-100);
  }

  :host([data-wallet-icon='allWallets'])::after {
    border: 1px solid var(--wui-accent-glass-010);
  }

  wui-icon[data-parent-size='inherit'] {
    width: 75%;
    height: 75%;
    align-items: center;
  }

  wui-icon[data-parent-size='sm'] {
    width: 18px;
    height: 18px;
  }

  wui-icon[data-parent-size='md'] {
    width: 24px;
    height: 24px;
  }

  wui-icon[data-parent-size='lg'] {
    width: 42px;
    height: 42px;
  }

  wui-icon[data-parent-size='full'] {
    width: 100%;
    height: 100%;
  }

  :host > wui-icon-box {
    position: absolute;
    overflow: hidden;
    right: -1px;
    bottom: -2px;
    z-index: 1;
    border: 2px solid var(--wui-color-bg-base-150, #1e1f1f);
    padding: 1px;
  }
`;

});


parcelRegister("cgpzR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8edad1ce602d847a$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $8edad1ce602d847a$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    position: relative;
    border-radius: var(--wui-border-radius-xxs);
    width: 40px;
    height: 40px;
    overflow: hidden;
    background: var(--wui-gray-glass-002);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: var(--wui-spacing-4xs);
    padding: 3.75px !important;
  }

  :host::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: inherit;
    border: 1px solid var(--wui-gray-glass-010);
    pointer-events: none;
  }

  :host > wui-wallet-image {
    width: 14px;
    height: 14px;
    border-radius: var(--wui-border-radius-5xs);
  }

  :host > wui-flex {
    padding: 2px;
    position: fixed;
    overflow: hidden;
    left: 34px;
    bottom: 8px;
    background: var(--dark-background-150, #1e1f1f);
    border-radius: 50%;
    z-index: 2;
    display: flex;
  }
`;

});


parcelRegister("e7V2r", function(module, exports) {

$parcel$export(module.exports, "WuiButton", () => $a48df6cb2e70024d$export$5496564a8aaab1b8);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
parcelRequire("cvzvT");
parcelRequire("kc4Vb");
parcelRequire("eFeuH");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");

var $5hI2c = parcelRequire("5hI2c");
var $a48df6cb2e70024d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $a48df6cb2e70024d$var$TEXT_VARIANT_BY_SIZE = {
    xs: "small-600",
    sm: "paragraph-600",
    md: "small-600",
    mdl: "small-600",
    lg: "paragraph-600"
};
let $a48df6cb2e70024d$export$5496564a8aaab1b8 = class WuiButton extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.size = "md";
        this.disabled = false;
        this.fullWidth = false;
        this.loading = false;
        this.variant = "fill";
        this.hasIconLeft = false;
        this.hasIconRight = false;
        this.borderRadius = "m";
    }
    render() {
        this.style.cssText = `
    --local-width: ${this.fullWidth ? "100%" : "auto"};
    --local-opacity-100: ${this.loading ? 0 : 1};
    --local-opacity-000: ${this.loading ? 1 : 0};
    --local-border-radius: var(--wui-border-radius-${this.borderRadius});
    `;
        const textVariant = this.textVariant ?? $a48df6cb2e70024d$var$TEXT_VARIANT_BY_SIZE[this.size];
        return (0, $i7GIz.html)`
      <button
        data-variant=${this.variant}
        data-icon-left=${this.hasIconLeft}
        data-icon-right=${this.hasIconRight}
        data-size=${this.size}
        ?disabled=${this.disabled || this.loading}
        ontouchstart
      >
        ${this.loadingTemplate()}
        <slot name="iconLeft" @slotchange=${()=>this.handleSlotLeftChange()}></slot>
        <wui-text variant=${textVariant} color="inherit">
          <slot></slot>
        </wui-text>
        <slot name="iconRight" @slotchange=${()=>this.handleSlotRightChange()}></slot>
      </button>
    `;
    }
    handleSlotLeftChange() {
        this.hasIconLeft = true;
    }
    handleSlotRightChange() {
        this.hasIconRight = true;
    }
    loadingTemplate() {
        if (this.loading) return (0, $i7GIz.html)`<wui-loading-spinner color="fg-300"></wui-loading-spinner>`;
        return (0, $i7GIz.html)``;
    }
};
$a48df6cb2e70024d$export$5496564a8aaab1b8.styles = [
    (0, $9rwwE.resetStyles),
    (0, $9rwwE.elementStyles),
    (0, $5hI2c.default)
];
$a48df6cb2e70024d$var$__decorate([
    (0, $cRlTX.property)()
], $a48df6cb2e70024d$export$5496564a8aaab1b8.prototype, "size", void 0);
$a48df6cb2e70024d$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $a48df6cb2e70024d$export$5496564a8aaab1b8.prototype, "disabled", void 0);
$a48df6cb2e70024d$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $a48df6cb2e70024d$export$5496564a8aaab1b8.prototype, "fullWidth", void 0);
$a48df6cb2e70024d$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $a48df6cb2e70024d$export$5496564a8aaab1b8.prototype, "loading", void 0);
$a48df6cb2e70024d$var$__decorate([
    (0, $cRlTX.property)()
], $a48df6cb2e70024d$export$5496564a8aaab1b8.prototype, "variant", void 0);
$a48df6cb2e70024d$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $a48df6cb2e70024d$export$5496564a8aaab1b8.prototype, "hasIconLeft", void 0);
$a48df6cb2e70024d$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $a48df6cb2e70024d$export$5496564a8aaab1b8.prototype, "hasIconRight", void 0);
$a48df6cb2e70024d$var$__decorate([
    (0, $cRlTX.property)()
], $a48df6cb2e70024d$export$5496564a8aaab1b8.prototype, "borderRadius", void 0);
$a48df6cb2e70024d$var$__decorate([
    (0, $cRlTX.property)()
], $a48df6cb2e70024d$export$5496564a8aaab1b8.prototype, "textVariant", void 0);
$a48df6cb2e70024d$export$5496564a8aaab1b8 = $a48df6cb2e70024d$var$__decorate([
    (0, $lkv4o.customElement)("wui-button")
], $a48df6cb2e70024d$export$5496564a8aaab1b8);

});
parcelRegister("5hI2c", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d90b29e04bc8bb8$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $3d90b29e04bc8bb8$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    width: var(--local-width);
    position: relative;
  }

  button {
    border: 1px solid var(--wui-gray-glass-010);
    border-radius: var(--local-border-radius);
    width: var(--local-width);
  }

  button:disabled {
    border: 1px solid var(--wui-gray-glass-010);
  }

  /* xs settings */
  button[data-size='xs'] {
    padding: var(--wui-spacing-xs) var(--wui-spacing-1xs);
  }

  button[data-size='xs'][data-icon-left='true'][data-icon-right='false'] {
    padding-left: var(--wui-spacing-xxs);
  }

  button[data-size='xs'][data-icon-right='true'][data-icon-left='false'] {
    padding-right: var(--wui-spacing-xxs);
  }

  /* sm settings */
  button[data-size='sm'] {
    padding: var(--wui-spacing-xxs) var(--wui-spacing-s);
  }

  button[data-size='sm'][data-icon-left='true'][data-icon-right='false'] {
    padding: var(--wui-spacing-xxs) var(--wui-spacing-s) var(--wui-spacing-xxs)
      var(--wui-spacing-xs);
  }

  button[data-size='sm'][data-icon-right='true'][data-icon-left='false'] {
    padding: var(--wui-spacing-xxs) var(--wui-spacing-xs) var(--wui-spacing-xxs)
      var(--wui-spacing-s);
  }

  /* md settings */
  button[data-size='md'] {
    padding: 8.2px var(--wui-spacing-l) 9px var(--wui-spacing-l);
  }

  button[data-size='md'][data-icon-left='true'][data-icon-right='false'] {
    padding: 8.2px var(--wui-spacing-l) 9px var(--wui-spacing-s);
  }

  button[data-size='md'][data-icon-right='true'][data-icon-left='false'] {
    padding: 8.2px var(--wui-spacing-s) 9px var(--wui-spacing-l);
  }

  /* lg settings */
  button[data-size='lg'] {
    padding: var(--wui-spacing-m) var(--wui-spacing-2l);
  }

  button[data-size='lg'][data-icon-left='true'][data-icon-right='false'] {
    padding-left: var(--wui-spacing-m);
  }

  button[data-size='lg'][data-icon-right='true'][data-icon-left='false'] {
    padding-right: var(--wui-spacing-m);
  }

  button > wui-text {
    transition: opacity 200ms ease-in-out;
    opacity: var(--local-opacity-100);
  }

  ::slotted(*) {
    transition: opacity 200ms ease-in-out;
    opacity: var(--local-opacity-100);
  }

  wui-loading-spinner {
    position: absolute;
    left: 50%;
    top: 50%;
    transition: all 200ms ease-in-out;
    transform: translate(-50%, -50%);
    opacity: var(--local-opacity-000);
  }
`;

});


parcelRegister("5NqEI", function(module, exports) {

$parcel$export(module.exports, "WuiCardSelectLoader", () => $438634a425f2a59d$export$fc388e944144bd3a);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");

var $9sTXv = parcelRequire("9sTXv");
parcelRequire("9Riks");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");

var $aEDEA = parcelRequire("aEDEA");
var $438634a425f2a59d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $438634a425f2a59d$export$fc388e944144bd3a = class WuiCardSelectLoader extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.type = "wallet";
    }
    render() {
        return (0, $i7GIz.html)`
      ${this.shimmerTemplate()}
      <wui-shimmer width="56px" height="20px" borderRadius="xs"></wui-shimmer>
    `;
    }
    shimmerTemplate() {
        if (this.type === "network") return (0, $i7GIz.html)` <wui-shimmer
          data-type=${this.type}
          width="48px"
          height="54px"
          borderRadius="xs"
        ></wui-shimmer>
        ${0, $9sTXv.networkSvgMd}`;
        return (0, $i7GIz.html)`<wui-shimmer width="56px" height="56px" borderRadius="xs"></wui-shimmer>`;
    }
};
$438634a425f2a59d$export$fc388e944144bd3a.styles = [
    (0, $9rwwE.resetStyles),
    (0, $9rwwE.elementStyles),
    (0, $aEDEA.default)
];
$438634a425f2a59d$var$__decorate([
    (0, $cRlTX.property)()
], $438634a425f2a59d$export$fc388e944144bd3a.prototype, "type", void 0);
$438634a425f2a59d$export$fc388e944144bd3a = $438634a425f2a59d$var$__decorate([
    (0, $lkv4o.customElement)("wui-card-select-loader")
], $438634a425f2a59d$export$fc388e944144bd3a);

});
parcelRegister("9sTXv", function(module, exports) {

$parcel$export(module.exports, "networkSvgMd", () => $6e4222d862d16cd0$export$711c5994129523c4);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $6e4222d862d16cd0$export$711c5994129523c4 = (0, $i7GIz.svg)`<svg  viewBox="0 0 48 54" fill="none">
  <path
    d="M43.4605 10.7248L28.0485 1.61089C25.5438 0.129705 22.4562 0.129705 19.9515 1.61088L4.53951 10.7248C2.03626 12.2051 0.5 14.9365 0.5 17.886V36.1139C0.5 39.0635 2.03626 41.7949 4.53951 43.2752L19.9515 52.3891C22.4562 53.8703 25.5438 53.8703 28.0485 52.3891L43.4605 43.2752C45.9637 41.7949 47.5 39.0635 47.5 36.114V17.8861C47.5 14.9365 45.9637 12.2051 43.4605 10.7248Z"
  />
</svg>`;

});

parcelRegister("aEDEA", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c1c6632c8f5d3d3$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $7c1c6632c8f5d3d3$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 76px;
    row-gap: var(--wui-spacing-xs);
    padding: var(--wui-spacing-xs) 10px;
    background-color: var(--wui-gray-glass-002);
    border-radius: clamp(0px, var(--wui-border-radius-xs), 20px);
    position: relative;
  }

  wui-shimmer[data-type='network'] {
    border: none;
    -webkit-clip-path: var(--wui-path-network);
    clip-path: var(--wui-path-network);
  }

  svg {
    position: absolute;
    width: 48px;
    height: 54px;
    z-index: 1;
  }

  svg > path {
    stroke: var(--wui-gray-glass-010);
    stroke-width: 1px;
  }
`;

});


parcelRegister("kz6v2", function(module, exports) {

$parcel$export(module.exports, "WuiCardSelect", () => $ef8c1e3574c38439$export$815c16e0af51756a);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
parcelRequire("lP6NM");
var $j71f4 = parcelRequire("j71f4");
parcelRequire("eFeuH");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");
parcelRequire("4jyh8");
parcelRequire("fSvVa");

var $eEFKS = parcelRequire("eEFKS");
var $ef8c1e3574c38439$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $ef8c1e3574c38439$export$815c16e0af51756a = class WuiCardSelect extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.name = "Unknown";
        this.type = "wallet";
        this.imageSrc = undefined;
        this.disabled = false;
        this.selected = false;
        this.installed = false;
    }
    render() {
        return (0, $i7GIz.html)`
      <button data-selected=${(0, $j71f4.ifDefined)(this.selected)} ?disabled=${this.disabled} ontouchstart>
        ${this.imageTemplate()}
        <wui-text variant="tiny-500" color=${this.selected ? "accent-100" : "inherit"}>
          ${this.name}
        </wui-text>
      </button>
    `;
    }
    imageTemplate() {
        if (this.type === "network") return (0, $i7GIz.html)`
        <wui-network-image
          .selected=${this.selected}
          imageSrc=${(0, $j71f4.ifDefined)(this.imageSrc)}
          name=${this.name}
        >
        </wui-network-image>
      `;
        return (0, $i7GIz.html)`
      <wui-wallet-image
        size="md"
        imageSrc=${(0, $j71f4.ifDefined)(this.imageSrc)}
        name=${this.name}
        .installed=${this.installed}
        badgeSize="sm"
      >
      </wui-wallet-image>
    `;
    }
};
$ef8c1e3574c38439$export$815c16e0af51756a.styles = [
    (0, $9rwwE.resetStyles),
    (0, $9rwwE.elementStyles),
    (0, $eEFKS.default)
];
$ef8c1e3574c38439$var$__decorate([
    (0, $cRlTX.property)()
], $ef8c1e3574c38439$export$815c16e0af51756a.prototype, "name", void 0);
$ef8c1e3574c38439$var$__decorate([
    (0, $cRlTX.property)()
], $ef8c1e3574c38439$export$815c16e0af51756a.prototype, "type", void 0);
$ef8c1e3574c38439$var$__decorate([
    (0, $cRlTX.property)()
], $ef8c1e3574c38439$export$815c16e0af51756a.prototype, "imageSrc", void 0);
$ef8c1e3574c38439$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $ef8c1e3574c38439$export$815c16e0af51756a.prototype, "disabled", void 0);
$ef8c1e3574c38439$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $ef8c1e3574c38439$export$815c16e0af51756a.prototype, "selected", void 0);
$ef8c1e3574c38439$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $ef8c1e3574c38439$export$815c16e0af51756a.prototype, "installed", void 0);
$ef8c1e3574c38439$export$815c16e0af51756a = $ef8c1e3574c38439$var$__decorate([
    (0, $lkv4o.customElement)("wui-card-select")
], $ef8c1e3574c38439$export$815c16e0af51756a);

});
parcelRegister("4jyh8", function(module, exports) {

$parcel$export(module.exports, "WuiNetworkImage", () => $3243862491f25578$export$4dc5510728d31c71);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");

var $9AHlG = parcelRequire("9AHlG");

var $9sTXv = parcelRequire("9sTXv");

var $9gsgx = parcelRequire("9gsgx");
parcelRequire("cvzvT");
parcelRequire("1fjkg");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");

var $8odxH = parcelRequire("8odxH");
var $3243862491f25578$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $3243862491f25578$export$4dc5510728d31c71 = class WuiNetworkImage extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.size = "md";
        this.name = "uknown";
        this.selected = false;
    }
    render() {
        const networkImagesBySize = {
            sm: (0, $9AHlG.networkSvgSm),
            md: (0, $9sTXv.networkSvgMd),
            lg: (0, $9gsgx.networkSvgLg)
        };
        this.style.cssText = `
      --local-stroke: ${this.selected ? "var(--wui-color-accent-100)" : "var(--wui-gray-glass-010)"};
      --local-path: var(--wui-path-network-${this.size});
      --local-width:  var(--wui-width-network-${this.size});
      --local-height:  var(--wui-height-network-${this.size});
      --local-icon-size:  var(--wui-icon-size-network-${this.size});
    `;
        return (0, $i7GIz.html)`${this.templateVisual()} ${networkImagesBySize[this.size]}`;
    }
    templateVisual() {
        if (this.imageSrc) return (0, $i7GIz.html)`<wui-image src=${this.imageSrc} alt=${this.name}></wui-image>`;
        return (0, $i7GIz.html)`<wui-icon size="inherit" color="fg-200" name="networkPlaceholder"></wui-icon>`;
    }
};
$3243862491f25578$export$4dc5510728d31c71.styles = [
    (0, $9rwwE.resetStyles),
    (0, $8odxH.default)
];
$3243862491f25578$var$__decorate([
    (0, $cRlTX.property)()
], $3243862491f25578$export$4dc5510728d31c71.prototype, "size", void 0);
$3243862491f25578$var$__decorate([
    (0, $cRlTX.property)()
], $3243862491f25578$export$4dc5510728d31c71.prototype, "name", void 0);
$3243862491f25578$var$__decorate([
    (0, $cRlTX.property)()
], $3243862491f25578$export$4dc5510728d31c71.prototype, "imageSrc", void 0);
$3243862491f25578$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $3243862491f25578$export$4dc5510728d31c71.prototype, "selected", void 0);
$3243862491f25578$export$4dc5510728d31c71 = $3243862491f25578$var$__decorate([
    (0, $lkv4o.customElement)("wui-network-image")
], $3243862491f25578$export$4dc5510728d31c71);

});
parcelRegister("9AHlG", function(module, exports) {

$parcel$export(module.exports, "networkSvgSm", () => $6fb91a0160901062$export$a36e707df42c73a2);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $6fb91a0160901062$export$a36e707df42c73a2 = (0, $i7GIz.svg)`
  <svg fill="none" viewBox="0 0 36 40">
    <path
      d="M15.4 2.1a5.21 5.21 0 0 1 5.2 0l11.61 6.7a5.21 5.21 0 0 1 2.61 4.52v13.4c0 1.87-1 3.59-2.6 4.52l-11.61 6.7c-1.62.93-3.6.93-5.22 0l-11.6-6.7a5.21 5.21 0 0 1-2.61-4.51v-13.4c0-1.87 1-3.6 2.6-4.52L15.4 2.1Z"
    />
  </svg>
`;

});

parcelRegister("9gsgx", function(module, exports) {

$parcel$export(module.exports, "networkSvgLg", () => $6beb88b07e2b0976$export$d2869a6a8000adfa);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
const $6beb88b07e2b0976$export$d2869a6a8000adfa = (0, $i7GIz.svg)`<svg width="86" height="96" fill="none">
  <path
    d="M78.3244 18.926L50.1808 2.45078C45.7376 -0.150261 40.2624 -0.150262 35.8192 2.45078L7.6756 18.926C3.23322 21.5266 0.5 26.3301 0.5 31.5248V64.4752C0.5 69.6699 3.23322 74.4734 7.6756 77.074L35.8192 93.5492C40.2624 96.1503 45.7376 96.1503 50.1808 93.5492L78.3244 77.074C82.7668 74.4734 85.5 69.6699 85.5 64.4752V31.5248C85.5 26.3301 82.7668 21.5266 78.3244 18.926Z"
  />
</svg>`;

});

parcelRegister("8odxH", function(module, exports) {

$parcel$export(module.exports, "default", () => $61bb11df29e03b68$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $61bb11df29e03b68$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    position: relative;
    border-radius: inherit;
    display: flex;
    justify-content: center;
    align-items: center;
    width: var(--local-width);
    height: var(--local-height);
  }

  svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    fill: var(--wui-gray-glass-002);
  }

  svg > path {
    stroke: var(--local-stroke);
    transition: stroke var(--wui-ease-out-power-1) var(--wui-duration-lg);
  }

  wui-image {
    width: 100%;
    height: 100%;
    -webkit-clip-path: var(--local-path);
    clip-path: var(--local-path);
    background: var(--wui-gray-glass-002);
  }

  wui-icon {
    transform: translateY(-5%);
    width: var(--local-icon-size);
    height: var(--local-icon-size);
  }
`;

});


parcelRegister("eEFKS", function(module, exports) {

$parcel$export(module.exports, "default", () => $aab530cfd65c50cf$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $aab530cfd65c50cf$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  button {
    flex-direction: column;
    width: 76px;
    row-gap: var(--wui-spacing-xs);
    padding: var(--wui-spacing-xs) var(--wui-spacing-0);
    background-color: var(--wui-gray-glass-002);
    border-radius: clamp(0px, var(--wui-border-radius-xs), 20px);
  }

  button > wui-text {
    color: var(--wui-color-fg-100);
    max-width: var(--wui-icon-box-size-xl);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    justify-content: center;
  }

  button:disabled > wui-text {
    color: var(--wui-gray-glass-015);
  }

  [data-selected='true'] {
    background-color: var(--wui-accent-glass-020);
  }

  @media (hover: hover) and (pointer: fine) {
    [data-selected='true']:hover:enabled {
      background-color: var(--wui-accent-glass-015);
    }
  }

  [data-selected='true']:active:enabled {
    background-color: var(--wui-accent-glass-010);
  }
`;

});


parcelRegister("8lfFP", function(module, exports) {

$parcel$export(module.exports, "WuiChip", () => $612c7155649d2dd4$export$418286c4c7ff87c6);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
parcelRequire("cvzvT");
parcelRequire("1fjkg");
parcelRequire("eFeuH");

var $9rwwE = parcelRequire("9rwwE");

var $97bbL = parcelRequire("97bbL");

var $lkv4o = parcelRequire("lkv4o");

var $hxY2G = parcelRequire("hxY2G");
var $612c7155649d2dd4$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $612c7155649d2dd4$export$418286c4c7ff87c6 = class WuiChip extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.variant = "fill";
        this.imageSrc = undefined;
        this.disabled = false;
        this.icon = "externalLink";
        this.href = "";
        this.text = undefined;
    }
    render() {
        const isSmall = this.variant === "success" || this.variant === "transparent" || this.variant === "shadeSmall";
        const textVariant = isSmall ? "small-600" : "paragraph-600";
        return (0, $i7GIz.html)`
      <a
        rel="noreferrer"
        target="_blank"
        href=${this.href}
        class=${this.disabled ? "disabled" : ""}
        data-variant=${this.variant}
      >
        ${this.imageTemplate()}
        <wui-text variant=${textVariant} color="inherit">
          ${this.title ? this.title : (0, $97bbL.UiHelperUtil).getHostName(this.href)}
        </wui-text>
        <wui-icon name=${this.icon} color="inherit" size="inherit"></wui-icon>
      </a>
    `;
    }
    imageTemplate() {
        if (this.imageSrc) return (0, $i7GIz.html)`<wui-image src=${this.imageSrc}></wui-image>`;
        return null;
    }
};
$612c7155649d2dd4$export$418286c4c7ff87c6.styles = [
    (0, $9rwwE.resetStyles),
    (0, $9rwwE.elementStyles),
    (0, $hxY2G.default)
];
$612c7155649d2dd4$var$__decorate([
    (0, $cRlTX.property)()
], $612c7155649d2dd4$export$418286c4c7ff87c6.prototype, "variant", void 0);
$612c7155649d2dd4$var$__decorate([
    (0, $cRlTX.property)()
], $612c7155649d2dd4$export$418286c4c7ff87c6.prototype, "imageSrc", void 0);
$612c7155649d2dd4$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $612c7155649d2dd4$export$418286c4c7ff87c6.prototype, "disabled", void 0);
$612c7155649d2dd4$var$__decorate([
    (0, $cRlTX.property)()
], $612c7155649d2dd4$export$418286c4c7ff87c6.prototype, "icon", void 0);
$612c7155649d2dd4$var$__decorate([
    (0, $cRlTX.property)()
], $612c7155649d2dd4$export$418286c4c7ff87c6.prototype, "href", void 0);
$612c7155649d2dd4$var$__decorate([
    (0, $cRlTX.property)()
], $612c7155649d2dd4$export$418286c4c7ff87c6.prototype, "text", void 0);
$612c7155649d2dd4$export$418286c4c7ff87c6 = $612c7155649d2dd4$var$__decorate([
    (0, $lkv4o.customElement)("wui-chip")
], $612c7155649d2dd4$export$418286c4c7ff87c6);

});
parcelRegister("hxY2G", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc6417e559a605da$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $cc6417e559a605da$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  a {
    border: 1px solid var(--wui-gray-glass-010);
    border-radius: var(--wui-border-radius-3xl);
  }

  wui-image {
    border-radius: var(--wui-border-radius-3xl);
    overflow: hidden;
  }

  a.disabled > wui-icon,
  a.disabled > wui-image {
    filter: grayscale(1);
  }

  a[data-variant='fill'] {
    color: var(--wui-color-inverse-100);
    background-color: var(--wui-color-accent-100);
  }

  a[data-variant='shade'],
  a[data-variant='shadeSmall'] {
    background-color: transparent;
    background-color: var(--wui-gray-glass-010);
    color: var(--wui-color-fg-200);
  }

  a[data-variant='success'] {
    column-gap: var(--wui-spacing-xxs);
    border: 1px solid var(--wui-success-glass-010);
    background-color: var(--wui-success-glass-010);
    color: var(--wui-color-success-100);
  }

  a[data-variant='error'] {
    column-gap: var(--wui-spacing-xxs);
    border: 1px solid var(--wui-error-glass-010);
    background-color: var(--wui-error-glass-010);
    color: var(--wui-color-error-100);
  }

  a[data-variant='transparent'] {
    column-gap: var(--wui-spacing-xxs);
    background-color: transparent;
    color: var(--wui-color-fg-150);
  }

  a[data-variant='transparent'],
  a[data-variant='success'],
  a[data-variant='shadeSmall'],
  a[data-variant='error'] {
    padding: 7px var(--wui-spacing-s) 7px 10px;
  }

  a[data-variant='transparent']:has(wui-text:first-child),
  a[data-variant='success']:has(wui-text:first-child),
  a[data-variant='shadeSmall']:has(wui-text:first-child),
  a[data-variant='error']:has(wui-text:first-child) {
    padding: 7px var(--wui-spacing-s);
  }

  a[data-variant='fill'],
  a[data-variant='shade'] {
    column-gap: var(--wui-spacing-xs);
    padding: var(--wui-spacing-xxs) var(--wui-spacing-m) var(--wui-spacing-xxs)
      var(--wui-spacing-xs);
  }

  a[data-variant='fill']:has(wui-text:first-child),
  a[data-variant='shade']:has(wui-text:first-child) {
    padding: 9px var(--wui-spacing-m) 9px var(--wui-spacing-m);
  }

  a[data-variant='fill'] > wui-image,
  a[data-variant='shade'] > wui-image {
    width: 24px;
    height: 24px;
  }

  a[data-variant='fill'] > wui-image {
    box-shadow: inset 0 0 0 1px var(--wui-color-accent-090);
  }

  a[data-variant='shade'] > wui-image,
  a[data-variant='shadeSmall'] > wui-image {
    box-shadow: inset 0 0 0 1px var(--wui-gray-glass-010);
  }

  a[data-variant='fill'] > wui-icon,
  a[data-variant='shade'] > wui-icon {
    width: 14px;
    height: 14px;
  }

  a[data-variant='transparent'] > wui-image,
  a[data-variant='success'] > wui-image,
  a[data-variant='shadeSmall'] > wui-image,
  a[data-variant='error'] > wui-image {
    width: 14px;
    height: 14px;
  }

  a[data-variant='transparent'] > wui-icon,
  a[data-variant='success'] > wui-icon,
  a[data-variant='shadeSmall'] > wui-icon,
  a[data-variant='error'] > wui-icon {
    width: 12px;
    height: 12px;
  }

  a[data-variant='fill']:focus-visible {
    background-color: var(--wui-color-accent-090);
  }

  a[data-variant='shade']:focus-visible,
  a[data-variant='shadeSmall']:focus-visible {
    background-color: var(--wui-gray-glass-015);
  }

  a[data-variant='transparent']:focus-visible {
    background-color: var(--wui-gray-glass-005);
  }

  a[data-variant='success']:focus-visible {
    background-color: var(--wui-success-glass-015);
  }

  a[data-variant='error']:focus-visible {
    background-color: var(--wui-error-glass-015);
  }

  a.disabled {
    color: var(--wui-gray-glass-015);
    background-color: var(--wui-gray-glass-015);
    pointer-events: none;
  }

  @media (hover: hover) and (pointer: fine) {
    a[data-variant='fill']:hover {
      background-color: var(--wui-color-accent-090);
    }

    a[data-variant='shade']:hover,
    a[data-variant='shadeSmall']:hover {
      background-color: var(--wui-gray-glass-015);
    }

    a[data-variant='transparent']:hover {
      background-color: var(--wui-gray-glass-005);
    }

    a[data-variant='success']:hover {
      background-color: var(--wui-success-glass-015);
    }

    a[data-variant='error']:hover {
      background-color: var(--wui-error-glass-015);
    }
  }

  a[data-variant='fill']:active {
    background-color: var(--wui-color-accent-080);
  }

  a[data-variant='shade']:active,
  a[data-variant='shadeSmall']:active {
    background-color: var(--wui-gray-glass-020);
  }

  a[data-variant='transparent']:active {
    background-color: var(--wui-gray-glass-010);
  }

  a[data-variant='success']:active {
    background-color: var(--wui-success-glass-020);
  }

  a[data-variant='error']:active {
    background-color: var(--wui-error-glass-020);
  }
`;

});


parcelRegister("5CmHN", function(module, exports) {

$parcel$export(module.exports, "WuiConnectButton", () => $010e3a46e75497d8$export$7e12422df5cbb04c);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
parcelRequire("cvzvT");
parcelRequire("kc4Vb");
parcelRequire("eFeuH");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");

var $1cCKG = parcelRequire("1cCKG");
var $010e3a46e75497d8$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $010e3a46e75497d8$export$7e12422df5cbb04c = class WuiConnectButton extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.size = "md";
        this.loading = false;
    }
    render() {
        const textVariant = this.size === "md" ? "paragraph-600" : "small-600";
        return (0, $i7GIz.html)`
      <button data-size=${this.size} ?disabled=${this.loading} ontouchstart>
        ${this.loadingTemplate()}
        <wui-text variant=${textVariant} color=${this.loading ? "accent-100" : "inherit"}>
          <slot></slot>
        </wui-text>
      </button>
    `;
    }
    loadingTemplate() {
        if (!this.loading) return null;
        return (0, $i7GIz.html)`<wui-loading-spinner size=${this.size} color="accent-100"></wui-loading-spinner>`;
    }
};
$010e3a46e75497d8$export$7e12422df5cbb04c.styles = [
    (0, $9rwwE.resetStyles),
    (0, $9rwwE.elementStyles),
    (0, $1cCKG.default)
];
$010e3a46e75497d8$var$__decorate([
    (0, $cRlTX.property)()
], $010e3a46e75497d8$export$7e12422df5cbb04c.prototype, "size", void 0);
$010e3a46e75497d8$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $010e3a46e75497d8$export$7e12422df5cbb04c.prototype, "loading", void 0);
$010e3a46e75497d8$export$7e12422df5cbb04c = $010e3a46e75497d8$var$__decorate([
    (0, $lkv4o.customElement)("wui-connect-button")
], $010e3a46e75497d8$export$7e12422df5cbb04c);

});
parcelRegister("1cCKG", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e04f8c1f1a449f4$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $0e04f8c1f1a449f4$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    position: relative;
    display: block;
  }

  button {
    background: var(--wui-color-accent-100);
    border: 1px solid var(--wui-gray-glass-010);
    border-radius: var(--wui-border-radius-m);
    gap: var(--wui-spacing-xs);
  }

  button.loading {
    background: var(--wui-gray-glass-010);
    border: 1px solid var(--wui-gray-glass-010);
    pointer-events: none;
  }

  button:disabled {
    background-color: var(--wui-gray-glass-015);
    border: 1px solid var(--wui-gray-glass-010);
  }

  button:disabled > wui-text {
    color: var(--wui-gray-glass-015);
  }

  @media (hover: hover) and (pointer: fine) {
    button:hover:enabled {
      background-color: var(--wui-color-accent-090);
    }

    button:active:enabled {
      background-color: var(--wui-color-accent-080);
    }
  }

  button:focus-visible {
    border: 1px solid var(--wui-gray-glass-010);
    background-color: var(--wui-color-accent-090);
    -webkit-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    -moz-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
  }

  button[data-size='sm'] {
    padding: 6.75px 10px 7.25px;
  }

  ::slotted(*) {
    transition: opacity 200ms ease-in-out;
    opacity: var(--local-opacity-100);
  }

  button > wui-text {
    transition: opacity 200ms ease-in-out;
    opacity: var(--local-opacity-100);
    color: var(--wui-color-inverse-100);
  }

  button[data-size='md'] {
    padding: 9px var(--wui-spacing-l) 9px var(--wui-spacing-l);
  }

  button[data-size='md'] + wui-text {
    padding-left: var(--wui-spacing-3xs);
  }

  @media (max-width: 500px) {
    button[data-size='md'] {
      height: 32px;
      padding: 5px 12px;
    }

    button[data-size='md'] > wui-text > slot {
      font-size: 14px !important;
    }
  }

  wui-loading-spinner {
    width: 14px;
    height: 14px;
  }

  wui-loading-spinner::slotted(svg) {
    width: 10px !important;
    height: 10px !important;
  }

  button[data-size='sm'] > wui-loading-spinner {
    width: 12px;
    height: 12px;
  }
`;

});


parcelRegister("1jnbi", function(module, exports) {

$parcel$export(module.exports, "WuiCtaButton", () => $0f498c15370fac68$export$4cb12aabb6d5d23c);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
parcelRequire("cvzvT");
parcelRequire("eFeuH");
parcelRequire("e7V2r");
parcelRequire("aiZ8J");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");

var $8VjF3 = parcelRequire("8VjF3");
var $0f498c15370fac68$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $0f498c15370fac68$export$4cb12aabb6d5d23c = class WuiCtaButton extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.disabled = false;
        this.label = "";
        this.buttonLabel = "";
    }
    render() {
        return (0, $i7GIz.html)`
      <wui-flex
        justifyContent="space-between"
        alignItems="center"
        .padding=${[
            "1xs",
            "2l",
            "1xs",
            "2l"
        ]}
      >
        <wui-text variant="paragraph-500" color="fg-200">${this.label}</wui-text>
        <wui-button size="sm" variant="accent">
          ${this.buttonLabel}
          <wui-icon size="xs" color="inherit" slot="iconRight" name="chevronRight"></wui-icon>
        </wui-button>
      </wui-flex>
    `;
    }
};
$0f498c15370fac68$export$4cb12aabb6d5d23c.styles = [
    (0, $9rwwE.resetStyles),
    (0, $9rwwE.elementStyles),
    (0, $8VjF3.default)
];
$0f498c15370fac68$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $0f498c15370fac68$export$4cb12aabb6d5d23c.prototype, "disabled", void 0);
$0f498c15370fac68$var$__decorate([
    (0, $cRlTX.property)()
], $0f498c15370fac68$export$4cb12aabb6d5d23c.prototype, "label", void 0);
$0f498c15370fac68$var$__decorate([
    (0, $cRlTX.property)()
], $0f498c15370fac68$export$4cb12aabb6d5d23c.prototype, "buttonLabel", void 0);
$0f498c15370fac68$export$4cb12aabb6d5d23c = $0f498c15370fac68$var$__decorate([
    (0, $lkv4o.customElement)("wui-cta-button")
], $0f498c15370fac68$export$4cb12aabb6d5d23c);

});
parcelRegister("8VjF3", function(module, exports) {

$parcel$export(module.exports, "default", () => $67f2e5eb86d9b7d8$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $67f2e5eb86d9b7d8$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  wui-flex {
    width: 100%;
    background-color: var(--wui-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
  }
`;

});


parcelRegister("77RDu", function(module, exports) {

$parcel$export(module.exports, "WuiEmailInput", () => $5302cada917dc44c$export$99face4607bb46ea);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
parcelRequire("cvzvT");
parcelRequire("eFeuH");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");
parcelRequire("rIBsQ");

var $fbGLw = parcelRequire("fbGLw");
var $5302cada917dc44c$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $5302cada917dc44c$export$99face4607bb46ea = class WuiEmailInput extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.disabled = false;
    }
    render() {
        return (0, $i7GIz.html)`
      <wui-input-text
        placeholder="Email"
        icon="mail"
        size="md"
        .disabled=${this.disabled}
        .value=${this.value}
        data-testid="wui-email-input"
      ></wui-input-text>
      ${this.templateError()}
    `;
    }
    templateError() {
        if (this.errorMessage) return (0, $i7GIz.html)`<wui-text variant="tiny-500" color="error-100">${this.errorMessage}</wui-text>`;
        return null;
    }
};
$5302cada917dc44c$export$99face4607bb46ea.styles = [
    (0, $9rwwE.resetStyles),
    (0, $fbGLw.default)
];
$5302cada917dc44c$var$__decorate([
    (0, $cRlTX.property)()
], $5302cada917dc44c$export$99face4607bb46ea.prototype, "errorMessage", void 0);
$5302cada917dc44c$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $5302cada917dc44c$export$99face4607bb46ea.prototype, "disabled", void 0);
$5302cada917dc44c$var$__decorate([
    (0, $cRlTX.property)()
], $5302cada917dc44c$export$99face4607bb46ea.prototype, "value", void 0);
$5302cada917dc44c$export$99face4607bb46ea = $5302cada917dc44c$var$__decorate([
    (0, $lkv4o.customElement)("wui-email-input")
], $5302cada917dc44c$export$99face4607bb46ea);

});
parcelRegister("rIBsQ", function(module, exports) {

$parcel$export(module.exports, "WuiInputText", () => $05351f026f8489f5$export$487c694bc02cf7da);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
parcelRequire("lP6NM");
var $j71f4 = parcelRequire("j71f4");
parcelRequire("9jtxR");
var $hP6Yh = parcelRequire("hP6Yh");
parcelRequire("cvzvT");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");

var $gwT8p = parcelRequire("gwT8p");
var $05351f026f8489f5$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $05351f026f8489f5$export$487c694bc02cf7da = class WuiInputText extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.inputElementRef = (0, $hP6Yh.createRef)();
        this.size = "md";
        this.disabled = false;
        this.placeholder = "";
        this.type = "text";
    }
    render() {
        const sizeClass = `wui-size-${this.size}`;
        return (0, $i7GIz.html)` ${this.templateIcon()}
      <input
        ${(0, $hP6Yh.ref)(this.inputElementRef)}
        class=${sizeClass}
        type=${this.type}
        enterkeyhint=${(0, $j71f4.ifDefined)(this.enterKeyHint)}
        ?disabled=${this.disabled}
        placeholder=${this.placeholder}
        @input=${this.dispatchInputChangeEvent.bind(this)}
        value=${(0, $j71f4.ifDefined)(this.value)}
        .value=${this.value || ""}
      />
      <slot></slot>`;
    }
    templateIcon() {
        if (this.icon) return (0, $i7GIz.html)`<wui-icon
        data-input=${this.size}
        size=${this.size}
        color="inherit"
        name=${this.icon}
      ></wui-icon>`;
        return null;
    }
    dispatchInputChangeEvent() {
        this.dispatchEvent(new CustomEvent("inputChange", {
            detail: this.inputElementRef.value?.value,
            bubbles: true,
            composed: true
        }));
    }
};
$05351f026f8489f5$export$487c694bc02cf7da.styles = [
    (0, $9rwwE.resetStyles),
    (0, $9rwwE.elementStyles),
    (0, $gwT8p.default)
];
$05351f026f8489f5$var$__decorate([
    (0, $cRlTX.property)()
], $05351f026f8489f5$export$487c694bc02cf7da.prototype, "size", void 0);
$05351f026f8489f5$var$__decorate([
    (0, $cRlTX.property)()
], $05351f026f8489f5$export$487c694bc02cf7da.prototype, "icon", void 0);
$05351f026f8489f5$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $05351f026f8489f5$export$487c694bc02cf7da.prototype, "disabled", void 0);
$05351f026f8489f5$var$__decorate([
    (0, $cRlTX.property)()
], $05351f026f8489f5$export$487c694bc02cf7da.prototype, "placeholder", void 0);
$05351f026f8489f5$var$__decorate([
    (0, $cRlTX.property)()
], $05351f026f8489f5$export$487c694bc02cf7da.prototype, "type", void 0);
$05351f026f8489f5$var$__decorate([
    (0, $cRlTX.property)()
], $05351f026f8489f5$export$487c694bc02cf7da.prototype, "keyHint", void 0);
$05351f026f8489f5$var$__decorate([
    (0, $cRlTX.property)()
], $05351f026f8489f5$export$487c694bc02cf7da.prototype, "value", void 0);
$05351f026f8489f5$export$487c694bc02cf7da = $05351f026f8489f5$var$__decorate([
    (0, $lkv4o.customElement)("wui-input-text")
], $05351f026f8489f5$export$487c694bc02cf7da);

});
parcelRegister("9jtxR", function(module, exports) {
$parcel$export(module.exports, "createRef", () => (parcelRequire("hP6Yh")).createRef);
$parcel$export(module.exports, "ref", () => (parcelRequire("hP6Yh")).ref);
parcelRequire("hP6Yh");

});
parcelRegister("hP6Yh", function(module, exports) {

$parcel$export(module.exports, "createRef", () => $cf9c9b70c60807f1$export$7d1e3a5e95ceca43);
$parcel$export(module.exports, "ref", () => $cf9c9b70c60807f1$export$eff4d24c3ff7876e);

var $i7GIz = parcelRequire("i7GIz");

var $b2ngx = parcelRequire("b2ngx");

var $bV7TY = parcelRequire("bV7TY");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $cf9c9b70c60807f1$export$7d1e3a5e95ceca43 = ()=>new $cf9c9b70c60807f1$var$Zt;
class $cf9c9b70c60807f1$var$Zt {
}
const $cf9c9b70c60807f1$var$qt = new WeakMap, $cf9c9b70c60807f1$export$eff4d24c3ff7876e = (0, $bV7TY.directive)(class extends (0, $b2ngx.AsyncDirective) {
    render(t) {
        return 0, $i7GIz.nothing;
    }
    update(t, [i]) {
        const s = i !== this.Y;
        return s && void 0 !== this.Y && this.rt(void 0), (s || this.lt !== this.ct) && (this.Y = i, this.ht = t.options?.host, this.rt(this.ct = t.element)), $i7GIz.nothing;
    }
    rt(t) {
        if (this.isConnected || (t = void 0), "function" == typeof this.Y) {
            const i = this.ht ?? globalThis;
            let s = $cf9c9b70c60807f1$var$qt.get(i);
            void 0 === s && (s = new WeakMap, $cf9c9b70c60807f1$var$qt.set(i, s)), void 0 !== s.get(this.Y) && this.Y.call(this.ht, void 0), s.set(this.Y, t), void 0 !== t && this.Y.call(this.ht, t);
        } else this.Y.value = t;
    }
    get lt() {
        return "function" == typeof this.Y ? $cf9c9b70c60807f1$var$qt.get(this.ht ?? globalThis)?.get(this.Y) : this.Y?.value;
    }
    disconnected() {
        this.lt === this.ct && this.rt(void 0);
    }
    reconnected() {
        this.rt(this.ct);
    }
});

});
parcelRegister("b2ngx", function(module, exports) {

$parcel$export(module.exports, "AsyncDirective", () => $8091edaf7db80f8b$export$7d025501802325e);

var $UbgOb = parcelRequire("UbgOb");

var $bV7TY = parcelRequire("bV7TY");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $8091edaf7db80f8b$var$mt = (i, t)=>{
    const e = i._$AN;
    if (void 0 === e) return !1;
    for (const i of e)i._$AO?.(t, !1), $8091edaf7db80f8b$var$mt(i, t);
    return !0;
}, $8091edaf7db80f8b$var$_t = (i)=>{
    let t, e;
    do {
        if (void 0 === (t = i._$AM)) break;
        e = t._$AN, e.delete(i), i = t;
    }while (0 === e?.size);
}, $8091edaf7db80f8b$var$wt = (i)=>{
    for(let t; t = i._$AM; i = t){
        let e = t._$AN;
        if (void 0 === e) t._$AN = e = new Set;
        else if (e.has(i)) break;
        e.add(i), $8091edaf7db80f8b$var$gt(t);
    }
};
function $8091edaf7db80f8b$var$bt(i) {
    void 0 !== this._$AN ? ($8091edaf7db80f8b$var$_t(this), this._$AM = i, $8091edaf7db80f8b$var$wt(this)) : this._$AM = i;
}
function $8091edaf7db80f8b$var$yt(i, t = !1, e = 0) {
    const s = this._$AH, o = this._$AN;
    if (void 0 !== o && 0 !== o.size) {
        if (t) {
            if (Array.isArray(s)) for(let i = e; i < s.length; i++)$8091edaf7db80f8b$var$mt(s[i], !1), $8091edaf7db80f8b$var$_t(s[i]);
            else null != s && ($8091edaf7db80f8b$var$mt(s, !1), $8091edaf7db80f8b$var$_t(s));
        } else $8091edaf7db80f8b$var$mt(this, i);
    }
}
const $8091edaf7db80f8b$var$gt = (i)=>{
    i.type == (0, $bV7TY.PartType).CHILD && (i._$AP ??= $8091edaf7db80f8b$var$yt, i._$AQ ??= $8091edaf7db80f8b$var$bt);
};
class $8091edaf7db80f8b$export$7d025501802325e extends (0, $bV7TY.Directive) {
    constructor(){
        super(...arguments), this._$AN = void 0;
    }
    _$AT(i, t, e) {
        super._$AT(i, t, e), $8091edaf7db80f8b$var$wt(this), this.isConnected = i._$AU;
    }
    _$AO(i, t = !0) {
        i !== this.isConnected && (this.isConnected = i, i ? this.reconnected?.() : this.disconnected?.()), t && ($8091edaf7db80f8b$var$mt(this, i), $8091edaf7db80f8b$var$_t(this));
    }
    setValue(i) {
        if ((0, $UbgOb.isSingleExpression)(this.t)) this.t._$AI(i, this);
        else {
            const t = [
                ...this.t._$AH
            ];
            t[this.i] = i, this.t._$AI(t, this, 0);
        }
    }
    disconnected() {}
    reconnected() {}
}

});
parcelRegister("UbgOb", function(module, exports) {

$parcel$export(module.exports, "isSingleExpression", () => $0a8df915c87730ff$export$7f431ad0fff82fd9);

var $i7GIz = parcelRequire("i7GIz");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { I: $0a8df915c87730ff$var$et } = (0, $i7GIz._$LH), $0a8df915c87730ff$export$c3825b437cbdea5c = (o)=>null === o || "object" != typeof o && "function" != typeof o, $0a8df915c87730ff$export$80c36ae3cab9881d = {
    HTML: 1,
    SVG: 2,
    MATHML: 3
}, $0a8df915c87730ff$export$6b6d145ec2a44ca9 = (o, t)=>void 0 === t ? void 0 !== o?._$litType$ : o?._$litType$ === t, $0a8df915c87730ff$export$6a0e8de894d2fcca = (o)=>null != o?._$litType$?.h, $0a8df915c87730ff$export$2f448fec17d50a3e = (o)=>void 0 !== o?._$litDirective$, $0a8df915c87730ff$export$f28e31de6a6eaf32 = (o)=>o?._$litDirective$, $0a8df915c87730ff$export$7f431ad0fff82fd9 = (o)=>void 0 === o.strings, $0a8df915c87730ff$var$lt = ()=>document.createComment(""), $0a8df915c87730ff$export$291b2338ad9b0b30 = (o, t, i)=>{
    const n = o._$AA.parentNode, e = void 0 === t ? o._$AB : t._$AA;
    if (void 0 === i) {
        const t = n.insertBefore($0a8df915c87730ff$var$lt(), e), l = n.insertBefore($0a8df915c87730ff$var$lt(), e);
        i = new $0a8df915c87730ff$var$et(t, l, o, o.options);
    } else {
        const t = i._$AB.nextSibling, l = i._$AM, c = l !== o;
        if (c) {
            let t;
            i._$AQ?.(o), i._$AM = o, void 0 !== i._$AP && (t = o._$AU) !== l._$AU && i._$AP(t);
        }
        if (t !== e || c) {
            let o = i._$AA;
            for(; o !== t;){
                const t = o.nextSibling;
                n.insertBefore(o, e), o = t;
            }
        }
    }
    return i;
}, $0a8df915c87730ff$export$cb8bf9562088e9f4 = (o, t, i = o)=>(o._$AI(t, i), o), $0a8df915c87730ff$var$ht = {}, $0a8df915c87730ff$export$ea70d9dd5965b1c8 = (o, t = $0a8df915c87730ff$var$ht)=>o._$AH = t, $0a8df915c87730ff$export$59e9bce518cde500 = (o)=>o._$AH, $0a8df915c87730ff$export$3133b3144bbba267 = (o)=>{
    o._$AP?.(!1, !0);
    let t = o._$AA;
    const i = o._$AB.nextSibling;
    for(; t !== i;){
        const o = t.nextSibling;
        t.remove(), t = o;
    }
}, $0a8df915c87730ff$export$7f600b8138c094dc = (o)=>{
    o._$AR();
};

});




parcelRegister("gwT8p", function(module, exports) {

$parcel$export(module.exports, "default", () => $c08a6716e3d8c8a5$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $c08a6716e3d8c8a5$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    position: relative;
    width: 100%;
    display: inline-block;
    color: var(--wui-color-fg-275);
  }

  input {
    width: 100%;
    border-radius: var(--wui-border-radius-xs);
    border: 1px solid var(--wui-gray-glass-005);
    background: var(--wui-gray-glass-005);
    font-size: var(--wui-font-size-paragraph);
    font-weight: var(--wui-font-weight-light);
    letter-spacing: var(--wui-letter-spacing-paragraph);
    color: var(--wui-color-fg-100);
    transition: all var(--wui-ease-inout-power-1) var(--wui-duration-lg);
    caret-color: var(--wui-color-accent-100);
  }

  input:disabled {
    cursor: not-allowed;
    border: 1px solid var(--wui-gray-glass-010);
  }

  input:disabled::placeholder,
  input:disabled + wui-icon {
    color: var(--wui-color-fg-300);
  }

  input::placeholder {
    color: var(--wui-color-fg-275);
  }

  input:focus:enabled {
    transition: all var(--wui-ease-out-power-2) var(--wui-duration-sm);
    background-color: var(--wui-gray-glass-010);
    border: 1px solid var(--wui-color-accent-100);
    -webkit-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    -moz-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
  }

  input:hover:enabled {
    background-color: var(--wui-gray-glass-010);
  }

  wui-icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
  }

  .wui-size-sm {
    padding: 9px var(--wui-spacing-m) 10px var(--wui-spacing-s);
  }

  wui-icon + .wui-size-sm {
    padding: 9px var(--wui-spacing-m) 10px 36px;
  }

  wui-icon[data-input='sm'] {
    left: var(--wui-spacing-s);
  }

  .wui-size-md {
    padding: 15px var(--wui-spacing-m) var(--wui-spacing-l) var(--wui-spacing-m);
  }

  wui-icon + .wui-size-md,
  wui-loading-spinner + .wui-size-md {
    padding: 10.5px var(--wui-spacing-3xl) 10.5px 40px;
  }

  wui-icon[data-input='md'] {
    left: var(--wui-spacing-l);
  }

  .wui-size-lg {
    padding: var(--wui-spacing-s) var(--wui-spacing-s) var(--wui-spacing-s) var(--wui-spacing-l);
    letter-spacing: var(--wui-letter-spacing-medium-title);
    font-size: var(--wui-font-size-medium-title);
    font-weight: var(--wui-font-weight-light);
    line-height: 130%;
    color: var(--wui-color-fg-100);
    height: 64px;
  }

  wui-icon + .wui-size-lg,
  wui-loading-spinner + .wui-size-lg {
    padding-left: 50px;
  }

  wui-icon[data-input='lg'] {
    left: var(--wui-spacing-l);
  }

  input:placeholder-shown ~ ::slotted(wui-input-element),
  input:placeholder-shown ~ ::slotted(wui-icon) {
    opacity: 0;
    pointer-events: none;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }

  ::slotted(wui-input-element),
  ::slotted(wui-icon) {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    transition: all var(--wui-ease-in-power-2) var(--wui-duration-md);
  }

  ::slotted(wui-input-element) {
    right: var(--wui-spacing-m);
  }

  ::slotted(wui-icon) {
    right: 0px;
  }
`;

});


parcelRegister("fbGLw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0e90e69aa40bf9d$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $b0e90e69aa40bf9d$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    position: relative;
    display: inline-block;
  }

  wui-text {
    margin: var(--wui-spacing-xxs) var(--wui-spacing-m) var(--wui-spacing-0) var(--wui-spacing-m);
  }
`;

});


parcelRegister("9jMiu", function(module, exports) {

$parcel$export(module.exports, "WuiIconLink", () => $6c8b5a3a38fa28d6$export$5a944ba239383166);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
parcelRequire("cvzvT");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");

var $1GnZT = parcelRequire("1GnZT");
var $6c8b5a3a38fa28d6$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $6c8b5a3a38fa28d6$export$5a944ba239383166 = class WuiIconLink extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.size = "md";
        this.disabled = false;
        this.icon = "copy";
        this.iconColor = "inherit";
    }
    render() {
        const borderRadius = this.size === "lg" ? "--wui-border-radius-xs" : "--wui-border-radius-xxs";
        const padding = this.size === "lg" ? "--wui-spacing-1xs" : "--wui-spacing-2xs";
        this.style.cssText = `
    --local-border-radius: var(${borderRadius});
    --local-padding: var(${padding});
`;
        return (0, $i7GIz.html)`
      <button ?disabled=${this.disabled} ontouchstart>
        <wui-icon color=${this.iconColor} size=${this.size} name=${this.icon}></wui-icon>
      </button>
    `;
    }
};
$6c8b5a3a38fa28d6$export$5a944ba239383166.styles = [
    (0, $9rwwE.resetStyles),
    (0, $9rwwE.elementStyles),
    (0, $9rwwE.colorStyles),
    (0, $1GnZT.default)
];
$6c8b5a3a38fa28d6$var$__decorate([
    (0, $cRlTX.property)()
], $6c8b5a3a38fa28d6$export$5a944ba239383166.prototype, "size", void 0);
$6c8b5a3a38fa28d6$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $6c8b5a3a38fa28d6$export$5a944ba239383166.prototype, "disabled", void 0);
$6c8b5a3a38fa28d6$var$__decorate([
    (0, $cRlTX.property)()
], $6c8b5a3a38fa28d6$export$5a944ba239383166.prototype, "icon", void 0);
$6c8b5a3a38fa28d6$var$__decorate([
    (0, $cRlTX.property)()
], $6c8b5a3a38fa28d6$export$5a944ba239383166.prototype, "iconColor", void 0);
$6c8b5a3a38fa28d6$export$5a944ba239383166 = $6c8b5a3a38fa28d6$var$__decorate([
    (0, $lkv4o.customElement)("wui-icon-link")
], $6c8b5a3a38fa28d6$export$5a944ba239383166);

});
parcelRegister("1GnZT", function(module, exports) {

$parcel$export(module.exports, "default", () => $139c5410cbec1d33$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $139c5410cbec1d33$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  button {
    border-radius: var(--local-border-radius);
    color: var(--wui-color-fg-100);
    padding: var(--local-padding);
  }

  @media (max-width: 700px) {
    button {
      padding: var(--wui-spacing-s);
    }
  }

  button > wui-icon {
    pointer-events: none;
  }

  button:disabled > wui-icon {
    color: var(--wui-color-bg-300) !important;
  }

  button:disabled {
    background-color: transparent;
  }
`;

});


parcelRegister("i1zzT", function(module, exports) {

$parcel$export(module.exports, "WuiInputElement", () => $d1f3eb0015646324$export$673191bf93fc142c);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
parcelRequire("cvzvT");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");

var $gKEAi = parcelRequire("gKEAi");
var $d1f3eb0015646324$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $d1f3eb0015646324$export$673191bf93fc142c = class WuiInputElement extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.icon = "copy";
    }
    render() {
        return (0, $i7GIz.html)`
      <button>
        <wui-icon color="inherit" size="xxs" name=${this.icon}></wui-icon>
      </button>
    `;
    }
};
$d1f3eb0015646324$export$673191bf93fc142c.styles = [
    (0, $9rwwE.resetStyles),
    (0, $9rwwE.elementStyles),
    (0, $gKEAi.default)
];
$d1f3eb0015646324$var$__decorate([
    (0, $cRlTX.property)()
], $d1f3eb0015646324$export$673191bf93fc142c.prototype, "icon", void 0);
$d1f3eb0015646324$export$673191bf93fc142c = $d1f3eb0015646324$var$__decorate([
    (0, $lkv4o.customElement)("wui-input-element")
], $d1f3eb0015646324$export$673191bf93fc142c);

});
parcelRegister("gKEAi", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3206c6d1dcb4945$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $c3206c6d1dcb4945$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  button {
    background-color: var(--wui-color-fg-300);
    border-radius: var(--wui-border-radius-4xs);
    width: 16px;
    height: 16px;
  }

  button:disabled {
    background-color: var(--wui-color-bg-300);
  }

  wui-icon {
    color: var(--wui-color-bg-200) !important;
  }

  button:focus-visible {
    background-color: var(--wui-color-fg-250);
    border: 1px solid var(--wui-color-accent-100);
  }

  button:active:enabled {
    background-color: var(--wui-color-fg-225);
  }

  @media (hover: hover) and (pointer: fine) {
    button:hover:enabled {
      background-color: var(--wui-color-fg-250);
    }
  }
`;

});


parcelRegister("wd6Nb", function(module, exports) {

$parcel$export(module.exports, "WuiInputNumeric", () => $060d285be1a82946$export$230332bec9d0029b);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");

var $3qPI7 = parcelRequire("3qPI7");
var $060d285be1a82946$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $060d285be1a82946$export$230332bec9d0029b = class WuiInputNumeric extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.disabled = false;
        this.value = "";
    }
    render() {
        return (0, $i7GIz.html)`<input
      type="number"
      maxlength="1"
      inputmode="numeric"
      autofocus
      ?disabled=${this.disabled}
      value=${this.value}
    /> `;
    }
};
$060d285be1a82946$export$230332bec9d0029b.styles = [
    (0, $9rwwE.resetStyles),
    (0, $9rwwE.elementStyles),
    (0, $3qPI7.default)
];
$060d285be1a82946$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $060d285be1a82946$export$230332bec9d0029b.prototype, "disabled", void 0);
$060d285be1a82946$var$__decorate([
    (0, $cRlTX.property)({
        type: String
    })
], $060d285be1a82946$export$230332bec9d0029b.prototype, "value", void 0);
$060d285be1a82946$export$230332bec9d0029b = $060d285be1a82946$var$__decorate([
    (0, $lkv4o.customElement)("wui-input-numeric")
], $060d285be1a82946$export$230332bec9d0029b);

});
parcelRegister("3qPI7", function(module, exports) {

$parcel$export(module.exports, "default", () => $27fbe96f729f0739$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $27fbe96f729f0739$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    position: relative;
    display: inline-block;
  }

  input {
    width: 50px;
    height: 50px;
    background: var(--wui-gray-glass-010);
    border-radius: var(--wui-border-radius-xs);
    border: 1px solid var(--wui-gray-glass-005);
    font-family: var(--wui-font-family);
    font-size: var(--wui-font-size-large);
    font-weight: var(--wui-font-weight-regular);
    letter-spacing: var(--wui-letter-spacing-large);
    text-align: center;
    color: var(--wui-color-fg-100);
    caret-color: var(--wui-color-accent-100);
    transition: all var(--wui-ease-inout-power-1) var(--wui-duration-lg);
    box-sizing: border-box;
    -webkit-appearance: none;
    -moz-appearance: textfield;
    padding: 0px;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }

  input:disabled {
    cursor: not-allowed;
    border: 1px solid var(--wui-gray-glass-010);
    background: var(--wui-gray-glass-005);
  }

  input:focus:enabled {
    transition: all var(--wui-ease-out-power-2) var(--wui-duration-sm);
    background-color: var(--wui-gray-glass-015);
    border: 1px solid var(--wui-color-accent-100);
    -webkit-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    -moz-box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
    box-shadow: 0px 0px 0px 4px var(--wui-box-shadow-blue);
  }
  @media (hover: hover) and (pointer: fine) {
    input:hover:enabled {
      background-color: var(--wui-gray-glass-015);
    }
  }
`;

});


parcelRegister("jNQoR", function(module, exports) {

$parcel$export(module.exports, "WuiLink", () => $e6ab3d7d00f0a95f$export$f279fe723271abb);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
parcelRequire("cvzvT");
parcelRequire("eFeuH");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");

var $6VAew = parcelRequire("6VAew");
var $e6ab3d7d00f0a95f$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $e6ab3d7d00f0a95f$export$f279fe723271abb = class WuiLink extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.disabled = false;
        this.color = "inherit";
    }
    render() {
        return (0, $i7GIz.html)`
      <button ?disabled=${this.disabled} ontouchstart>
        <slot name="iconLeft"></slot>
        <wui-text variant="small-600" color=${this.color}>
          <slot></slot>
        </wui-text>
        <slot name="iconRight"></slot>
      </button>
    `;
    }
};
$e6ab3d7d00f0a95f$export$f279fe723271abb.styles = [
    (0, $9rwwE.resetStyles),
    (0, $9rwwE.elementStyles),
    (0, $6VAew.default)
];
$e6ab3d7d00f0a95f$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $e6ab3d7d00f0a95f$export$f279fe723271abb.prototype, "disabled", void 0);
$e6ab3d7d00f0a95f$var$__decorate([
    (0, $cRlTX.property)()
], $e6ab3d7d00f0a95f$export$f279fe723271abb.prototype, "color", void 0);
$e6ab3d7d00f0a95f$export$f279fe723271abb = $e6ab3d7d00f0a95f$var$__decorate([
    (0, $lkv4o.customElement)("wui-link")
], $e6ab3d7d00f0a95f$export$f279fe723271abb);

});
parcelRegister("6VAew", function(module, exports) {

$parcel$export(module.exports, "default", () => $50b42c227ac9bdaa$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $50b42c227ac9bdaa$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  button {
    padding: var(--wui-spacing-4xs) var(--wui-spacing-xxs);
    border-radius: var(--wui-border-radius-3xs);
    background-color: transparent;
    color: var(--wui-color-accent-100);
  }

  button:disabled {
    background-color: transparent;
    color: var(--wui-gray-glass-015);
  }
`;

});


parcelRegister("3qytO", function(module, exports) {

$parcel$export(module.exports, "WuiListItem", () => $27ee8bc4760fe219$export$cd9b2e41f828fc8a);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
parcelRequire("lP6NM");
var $j71f4 = parcelRequire("j71f4");
parcelRequire("cvzvT");
parcelRequire("1fjkg");
parcelRequire("kc4Vb");
parcelRequire("eFeuH");
parcelRequire("aiZ8J");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");
parcelRequire("e4QeF");

var $dFJYp = parcelRequire("dFJYp");
var $27ee8bc4760fe219$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $27ee8bc4760fe219$export$cd9b2e41f828fc8a = class WuiListItem extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.variant = "icon";
        this.disabled = false;
        this.imageSrc = undefined;
        this.alt = undefined;
        this.chevron = false;
        this.loading = false;
    }
    render() {
        return (0, $i7GIz.html)`
      <button
        ?disabled=${this.loading ? true : Boolean(this.disabled)}
        data-loading=${this.loading}
        data-iconvariant=${(0, $j71f4.ifDefined)(this.iconVariant)}
        ontouchstart
      >
        ${this.loadingTemplate()} ${this.visualTemplate()}
        <wui-flex gap="3xs">
          <slot></slot>
        </wui-flex>
        ${this.chevronTemplate()}
      </button>
    `;
    }
    visualTemplate() {
        if (this.variant === "image" && this.imageSrc) return (0, $i7GIz.html)`<wui-image src=${this.imageSrc} alt=${this.alt ?? "list item"}></wui-image>`;
        if (this.iconVariant === "square" && this.icon && this.variant === "icon") return (0, $i7GIz.html)`<wui-icon name=${this.icon}></wui-icon>`;
        if (this.variant === "icon" && this.icon && this.iconVariant) {
            const color = [
                "blue",
                "square-blue"
            ].includes(this.iconVariant) ? "accent-100" : "fg-200";
            const size = this.iconVariant === "square-blue" ? "mdl" : "md";
            const iconSize = this.iconSize ? this.iconSize : size;
            return (0, $i7GIz.html)`
        <wui-icon-box
          data-variant=${this.iconVariant}
          icon=${this.icon}
          iconSize=${iconSize}
          background="transparent"
          iconColor=${color}
          backgroundColor=${color}
          size=${size}
        ></wui-icon-box>
      `;
        }
        return null;
    }
    loadingTemplate() {
        if (this.loading) return (0, $i7GIz.html)`<wui-loading-spinner color="fg-300"></wui-loading-spinner>`;
        return (0, $i7GIz.html)``;
    }
    chevronTemplate() {
        if (this.chevron) return (0, $i7GIz.html)`<wui-icon size="inherit" color="fg-200" name="chevronRight"></wui-icon>`;
        return null;
    }
};
$27ee8bc4760fe219$export$cd9b2e41f828fc8a.styles = [
    (0, $9rwwE.resetStyles),
    (0, $9rwwE.elementStyles),
    (0, $dFJYp.default)
];
$27ee8bc4760fe219$var$__decorate([
    (0, $cRlTX.property)()
], $27ee8bc4760fe219$export$cd9b2e41f828fc8a.prototype, "icon", void 0);
$27ee8bc4760fe219$var$__decorate([
    (0, $cRlTX.property)()
], $27ee8bc4760fe219$export$cd9b2e41f828fc8a.prototype, "iconSize", void 0);
$27ee8bc4760fe219$var$__decorate([
    (0, $cRlTX.property)()
], $27ee8bc4760fe219$export$cd9b2e41f828fc8a.prototype, "variant", void 0);
$27ee8bc4760fe219$var$__decorate([
    (0, $cRlTX.property)()
], $27ee8bc4760fe219$export$cd9b2e41f828fc8a.prototype, "iconVariant", void 0);
$27ee8bc4760fe219$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $27ee8bc4760fe219$export$cd9b2e41f828fc8a.prototype, "disabled", void 0);
$27ee8bc4760fe219$var$__decorate([
    (0, $cRlTX.property)()
], $27ee8bc4760fe219$export$cd9b2e41f828fc8a.prototype, "imageSrc", void 0);
$27ee8bc4760fe219$var$__decorate([
    (0, $cRlTX.property)()
], $27ee8bc4760fe219$export$cd9b2e41f828fc8a.prototype, "alt", void 0);
$27ee8bc4760fe219$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $27ee8bc4760fe219$export$cd9b2e41f828fc8a.prototype, "chevron", void 0);
$27ee8bc4760fe219$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $27ee8bc4760fe219$export$cd9b2e41f828fc8a.prototype, "loading", void 0);
$27ee8bc4760fe219$export$cd9b2e41f828fc8a = $27ee8bc4760fe219$var$__decorate([
    (0, $lkv4o.customElement)("wui-list-item")
], $27ee8bc4760fe219$export$cd9b2e41f828fc8a);

});
parcelRegister("dFJYp", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f42c40cbf9f1329$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $9f42c40cbf9f1329$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  button {
    column-gap: var(--wui-spacing-s);
    padding: 11px 18px 11px var(--wui-spacing-s);
    width: 100%;
    background-color: var(--wui-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
    color: var(--wui-color-fg-250);
  }

  button[data-iconvariant='square'],
  button[data-iconvariant='square-blue'] {
    padding: 6px 18px 6px 9px;
  }

  button > wui-flex {
    flex: 1;
  }

  button > wui-image {
    width: 32px;
    height: 32px;
    box-shadow: 0 0 0 2px var(--wui-gray-glass-005);
    border-radius: var(--wui-border-radius-3xl);
  }

  button > wui-icon {
    width: 36px;
    height: 36px;
  }

  button > wui-icon-box[data-variant='blue'] {
    box-shadow: 0 0 0 2px var(--wui-accent-glass-005);
  }

  button > wui-icon-box[data-variant='overlay'] {
    box-shadow: 0 0 0 2px var(--wui-gray-glass-005);
  }

  button > wui-icon-box[data-variant='square-blue'] {
    border-radius: var(--wui-border-radius-3xs);
    position: relative;
    border: none;
    width: 36px;
    height: 36px;
  }

  button > wui-icon-box[data-variant='square-blue']::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: inherit;
    border: 1px solid var(--wui-accent-glass-010);
    pointer-events: none;
  }

  button > wui-icon:last-child {
    width: 14px;
    height: 14px;
  }

  button:disabled {
    background-color: var(--wui-gray-glass-015);
    color: var(--wui-gray-glass-015);
  }

  button[data-loading='true'] > wui-icon {
    transition: opacity 200ms ease-in-out;
    opacity: 0;
  }

  wui-loading-spinner {
    position: absolute;
    right: 18px;
    top: 50%;
    transform: translateY(-50%);
  }
`;

});


parcelRegister("blSJ1", function(module, exports) {

$parcel$export(module.exports, "WuiTransactionListItem", () => $843c1b25f245579b$export$ee516ccb0af19908);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");

var $lkv4o = parcelRequire("lkv4o");

var $hamP8 = parcelRequire("hamP8");

var $9rwwE = parcelRequire("9rwwE");
parcelRequire("eFeuH");
parcelRequire("PzzG3");
parcelRequire("lP6NM");
var $j71f4 = parcelRequire("j71f4");

var $kUvah = parcelRequire("kUvah");
var $843c1b25f245579b$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $843c1b25f245579b$export$ee516ccb0af19908 = class WuiTransactionListItem extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.type = "approve";
        this.onlyDirectionIcon = false;
        this.images = [];
        this.price = [];
        this.amount = [];
        this.symbol = [];
    }
    render() {
        return (0, $i7GIz.html)`
      <wui-flex>
        <wui-transaction-visual
          .status=${this.status}
          direction=${(0, $j71f4.ifDefined)(this.direction)}
          type=${this.type}
          onlyDirectionIcon=${(0, $j71f4.ifDefined)(this.onlyDirectionIcon)}
          .images=${this.images}
        ></wui-transaction-visual>
        <wui-flex flexDirection="column" gap="3xs">
          <wui-text variant="paragraph-600" color="fg-100">
            ${(0, $hamP8.TransactionTypePastTense)[this.type] || this.type}
          </wui-text>
          <wui-flex class="description-container">
            ${this.templateDescription()} ${this.templateSecondDescription()}
          </wui-flex>
        </wui-flex>
        <wui-text variant="micro-700" color="fg-300"><span>${this.date}</span></wui-text>
      </wui-flex>
    `;
    }
    templateDescription() {
        const description = this.descriptions?.[0];
        return description ? (0, $i7GIz.html)`
          <wui-text variant="small-500" color="fg-200">
            <span>${description}</span>
          </wui-text>
        ` : null;
    }
    templateSecondDescription() {
        const description = this.descriptions?.[1];
        return description ? (0, $i7GIz.html)`
          <wui-icon class="description-separator-icon" size="xxs" name="arrowRight"></wui-icon>
          <wui-text variant="small-400" color="fg-200">
            <span>${description}</span>
          </wui-text>
        ` : null;
    }
};
$843c1b25f245579b$export$ee516ccb0af19908.styles = [
    (0, $9rwwE.resetStyles),
    (0, $kUvah.default)
];
$843c1b25f245579b$var$__decorate([
    (0, $cRlTX.property)()
], $843c1b25f245579b$export$ee516ccb0af19908.prototype, "type", void 0);
$843c1b25f245579b$var$__decorate([
    (0, $cRlTX.property)({
        type: Array
    })
], $843c1b25f245579b$export$ee516ccb0af19908.prototype, "descriptions", void 0);
$843c1b25f245579b$var$__decorate([
    (0, $cRlTX.property)()
], $843c1b25f245579b$export$ee516ccb0af19908.prototype, "date", void 0);
$843c1b25f245579b$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $843c1b25f245579b$export$ee516ccb0af19908.prototype, "onlyDirectionIcon", void 0);
$843c1b25f245579b$var$__decorate([
    (0, $cRlTX.property)()
], $843c1b25f245579b$export$ee516ccb0af19908.prototype, "status", void 0);
$843c1b25f245579b$var$__decorate([
    (0, $cRlTX.property)()
], $843c1b25f245579b$export$ee516ccb0af19908.prototype, "direction", void 0);
$843c1b25f245579b$var$__decorate([
    (0, $cRlTX.property)({
        type: Array
    })
], $843c1b25f245579b$export$ee516ccb0af19908.prototype, "images", void 0);
$843c1b25f245579b$var$__decorate([
    (0, $cRlTX.property)({
        type: Array
    })
], $843c1b25f245579b$export$ee516ccb0af19908.prototype, "price", void 0);
$843c1b25f245579b$var$__decorate([
    (0, $cRlTX.property)({
        type: Array
    })
], $843c1b25f245579b$export$ee516ccb0af19908.prototype, "amount", void 0);
$843c1b25f245579b$var$__decorate([
    (0, $cRlTX.property)({
        type: Array
    })
], $843c1b25f245579b$export$ee516ccb0af19908.prototype, "symbol", void 0);
$843c1b25f245579b$export$ee516ccb0af19908 = $843c1b25f245579b$var$__decorate([
    (0, $lkv4o.customElement)("wui-transaction-list-item")
], $843c1b25f245579b$export$ee516ccb0af19908);

});
parcelRegister("hamP8", function(module, exports) {

$parcel$export(module.exports, "TransactionTypePastTense", () => $c7f5132dd8af8845$export$1c6b44bd2bf7f8fa);
var $c7f5132dd8af8845$export$1c6b44bd2bf7f8fa;
(function(TransactionTypePastTense) {
    TransactionTypePastTense["approve"] = "approved";
    TransactionTypePastTense["bought"] = "bought";
    TransactionTypePastTense["borrow"] = "borrowed";
    TransactionTypePastTense["burn"] = "burnt";
    TransactionTypePastTense["cancel"] = "canceled";
    TransactionTypePastTense["claim"] = "claimed";
    TransactionTypePastTense["deploy"] = "deployed";
    TransactionTypePastTense["deposit"] = "deposited";
    TransactionTypePastTense["execute"] = "executed";
    TransactionTypePastTense["mint"] = "minted";
    TransactionTypePastTense["receive"] = "received";
    TransactionTypePastTense["repay"] = "repaid";
    TransactionTypePastTense["send"] = "sent";
    TransactionTypePastTense["sell"] = "sold";
    TransactionTypePastTense["stake"] = "staked";
    TransactionTypePastTense["trade"] = "swapped";
    TransactionTypePastTense["unstake"] = "unstaked";
    TransactionTypePastTense["withdraw"] = "withdrawn";
})($c7f5132dd8af8845$export$1c6b44bd2bf7f8fa || ($c7f5132dd8af8845$export$1c6b44bd2bf7f8fa = {}));

});

parcelRegister("PzzG3", function(module, exports) {

$parcel$export(module.exports, "WuiTransactionVisual", () => $09b05be0b67b7ab9$export$98664c16c41f47e3);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");

var $lkv4o = parcelRequire("lkv4o");
parcelRequire("1fjkg");
parcelRequire("e4QeF");

var $iRlHs = parcelRequire("iRlHs");
var $09b05be0b67b7ab9$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $09b05be0b67b7ab9$export$98664c16c41f47e3 = class WuiTransactionVisual extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.images = [];
        this.secondImage = {
            type: undefined,
            url: ""
        };
    }
    render() {
        const [firstImage, secondImage] = this.images;
        const isLeftNFT = firstImage?.type === "NFT";
        const isRightNFT = secondImage?.url ? secondImage.type === "NFT" : isLeftNFT;
        const leftRadius = isLeftNFT ? "var(--wui-border-radius-xxs)" : "var(--wui-border-radius-s)";
        const rightRadius = isRightNFT ? "var(--wui-border-radius-xxs)" : "var(--wui-border-radius-s)";
        this.style.cssText = `
    --local-left-border-radius: ${leftRadius};
    --local-right-border-radius: ${rightRadius};
    `;
        return (0, $i7GIz.html)`<wui-flex> ${this.templateVisual()} ${this.templateIcon()} </wui-flex>`;
    }
    templateVisual() {
        const [firstImage, secondImage] = this.images;
        const firstImageType = firstImage?.type;
        const haveTwoImages = this.images.length === 2;
        if (haveTwoImages && (firstImage?.url || secondImage?.url)) return (0, $i7GIz.html)`<div class="swap-images-container">
        ${firstImage?.url ? (0, $i7GIz.html)`<wui-image src=${firstImage.url} alt="Transaction image"></wui-image>` : null}
        ${secondImage?.url ? (0, $i7GIz.html)`<wui-image src=${secondImage.url} alt="Transaction image"></wui-image>` : null}
      </div>`;
        else if (firstImage?.url) return (0, $i7GIz.html)`<wui-image src=${firstImage.url} alt="Transaction image"></wui-image>`;
        else if (firstImageType === "NFT") return (0, $i7GIz.html)`<wui-icon size="inherit" color="fg-200" name="nftPlaceholder"></wui-icon>`;
        return (0, $i7GIz.html)`<wui-icon size="inherit" color="fg-200" name="coinPlaceholder"></wui-icon>`;
    }
    templateIcon() {
        let color = "accent-100";
        let icon = undefined;
        icon = this.getIcon();
        if (this.status) color = this.getStatusColor();
        if (!icon) return null;
        return (0, $i7GIz.html)`
      <wui-icon-box
        size="xxs"
        iconColor=${color}
        backgroundColor=${color}
        background="opaque"
        icon=${icon}
        ?border=${true}
        borderColor="wui-color-bg-125"
      ></wui-icon-box>
    `;
    }
    getDirectionIcon() {
        switch(this.direction){
            case "in":
                return "arrowBottom";
            case "out":
                return "arrowTop";
            default:
                return undefined;
        }
    }
    getIcon() {
        if (this.onlyDirectionIcon) return this.getDirectionIcon();
        if (this.type === "trade") return "swapHorizontalBold";
        else if (this.type === "approve") return "checkmark";
        else if (this.type === "cancel") return "close";
        return this.getDirectionIcon();
    }
    getStatusColor() {
        switch(this.status){
            case "confirmed":
                return "success-100";
            case "failed":
                return "error-100";
            case "pending":
                return "inverse-100";
            default:
                return "accent-100";
        }
    }
};
$09b05be0b67b7ab9$export$98664c16c41f47e3.styles = [
    (0, $iRlHs.default)
];
$09b05be0b67b7ab9$var$__decorate([
    (0, $cRlTX.property)()
], $09b05be0b67b7ab9$export$98664c16c41f47e3.prototype, "type", void 0);
$09b05be0b67b7ab9$var$__decorate([
    (0, $cRlTX.property)()
], $09b05be0b67b7ab9$export$98664c16c41f47e3.prototype, "status", void 0);
$09b05be0b67b7ab9$var$__decorate([
    (0, $cRlTX.property)()
], $09b05be0b67b7ab9$export$98664c16c41f47e3.prototype, "direction", void 0);
$09b05be0b67b7ab9$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $09b05be0b67b7ab9$export$98664c16c41f47e3.prototype, "onlyDirectionIcon", void 0);
$09b05be0b67b7ab9$var$__decorate([
    (0, $cRlTX.property)({
        type: Array
    })
], $09b05be0b67b7ab9$export$98664c16c41f47e3.prototype, "images", void 0);
$09b05be0b67b7ab9$var$__decorate([
    (0, $cRlTX.property)({
        type: Object
    })
], $09b05be0b67b7ab9$export$98664c16c41f47e3.prototype, "secondImage", void 0);
$09b05be0b67b7ab9$export$98664c16c41f47e3 = $09b05be0b67b7ab9$var$__decorate([
    (0, $lkv4o.customElement)("wui-transaction-visual")
], $09b05be0b67b7ab9$export$98664c16c41f47e3);

});
parcelRegister("iRlHs", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbae025f8ee17404$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $dbae025f8ee17404$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host > wui-flex {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 40px;
    height: 40px;
    box-shadow: inset 0 0 0 1px var(--wui-gray-glass-005);
    background-color: var(--wui-gray-glass-005);
  }

  :host > wui-flex wui-image {
    display: block;
  }

  :host > wui-flex,
  :host > wui-flex wui-image,
  .swap-images-container,
  .swap-images-container.nft,
  wui-image.nft {
    border-top-left-radius: var(--local-left-border-radius);
    border-top-right-radius: var(--local-right-border-radius);
    border-bottom-left-radius: var(--local-left-border-radius);
    border-bottom-right-radius: var(--local-right-border-radius);
  }

  wui-icon {
    width: 20px;
    height: 20px;
  }

  wui-icon-box {
    position: absolute;
    right: 0;
    bottom: 0;
    transform: translate(20%, 20%);
  }

  .swap-images-container {
    position: relative;
    width: 40px;
    height: 40px;
    overflow: hidden;
  }

  .swap-images-container wui-image:first-child {
    position: absolute;
    width: 40px;
    height: 40px;
    top: 0;
    left: 0%;
    clip-path: inset(0px calc(50% + 2px) 0px 0%);
  }

  .swap-images-container wui-image:last-child {
    clip-path: inset(0px 0px 0px calc(50% + 2px));
  }
`;

});


parcelRegister("kUvah", function(module, exports) {

$parcel$export(module.exports, "default", () => $f39136497dd109fb$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $f39136497dd109fb$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host > wui-flex:first-child {
    align-items: center;
    column-gap: var(--wui-spacing-s);
    padding: 6.5px var(--wui-spacing-xs) 6.5px var(--wui-spacing-xs);
    width: 100%;
  }

  :host > wui-flex:first-child wui-text:nth-child(1) {
    text-transform: capitalize;
  }

  wui-transaction-visual {
    width: 40px;
    height: 40px;
  }

  wui-flex {
    flex: 1;
  }

  :host wui-flex wui-flex {
    overflow: hidden;
  }

  :host .description-container wui-text span {
    word-break: break-all;
  }

  :host .description-container wui-text {
    overflow: hidden;
  }

  :host .description-separator-icon {
    margin: 0px 6px;
  }

  :host wui-text > span {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
`;

});


parcelRegister("8oS2R", function(module, exports) {

$parcel$export(module.exports, "WuiTransactionListItemLoader", () => $61da7cdf30af59e2$export$994c2d15662c37cc);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");

var $lkv4o = parcelRequire("lkv4o");

var $9rwwE = parcelRequire("9rwwE");
parcelRequire("eFeuH");
parcelRequire("PzzG3");

var $9rwLq = parcelRequire("9rwLq");
var $61da7cdf30af59e2$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $61da7cdf30af59e2$export$994c2d15662c37cc = class WuiTransactionListItemLoader extends (0, $3KB8N.LitElement) {
    render() {
        return (0, $i7GIz.html)`
      <wui-flex alignItems="center">
        <wui-shimmer width="40px" height="40px"></wui-shimmer>
        <wui-flex flexDirection="column" gap="2xs">
          <wui-shimmer width="72px" height="16px" borderRadius="4xs"></wui-shimmer>
          <wui-shimmer width="148px" height="14px" borderRadius="4xs"></wui-shimmer>
        </wui-flex>
        <wui-shimmer width="24px" height="12px" borderRadius="5xs"></wui-shimmer>
      </wui-flex>
    `;
    }
};
$61da7cdf30af59e2$export$994c2d15662c37cc.styles = [
    (0, $9rwwE.resetStyles),
    (0, $9rwLq.default)
];
$61da7cdf30af59e2$export$994c2d15662c37cc = $61da7cdf30af59e2$var$__decorate([
    (0, $lkv4o.customElement)("wui-transaction-list-item-loader")
], $61da7cdf30af59e2$export$994c2d15662c37cc);

});
parcelRegister("9rwLq", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e000ce9ae992c19$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $6e000ce9ae992c19$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host > wui-flex:first-child {
    column-gap: var(--wui-spacing-s);
    padding: 7px var(--wui-spacing-l) 7px var(--wui-spacing-xs);
    width: 100%;
  }

  wui-flex {
    display: flex;
    flex: 1;
  }
`;

});


parcelRegister("iYJ6v", function(module, exports) {

$parcel$export(module.exports, "WuiListWallet", () => $dd10d144961e03c2$export$fe01be9b7ff81a09);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
parcelRequire("cvzvT");
parcelRequire("e4QeF");
parcelRequire("eFeuH");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");
parcelRequire("lx9aw");
parcelRequire("1ChWu");
parcelRequire("fSvVa");

var $hKk0F = parcelRequire("hKk0F");
var $dd10d144961e03c2$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $dd10d144961e03c2$export$fe01be9b7ff81a09 = class WuiListWallet extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.walletImages = [];
        this.imageSrc = "";
        this.name = "";
        this.installed = false;
        this.disabled = false;
        this.showAllWallets = false;
    }
    render() {
        return (0, $i7GIz.html)`
      <button ?disabled=${this.disabled} ontouchstart>
        ${this.templateAllWallets()} ${this.templateWalletImage()}
        <wui-text variant="paragraph-500" color="inherit">${this.name}</wui-text>
        ${this.templateStatus()}
      </button>
    `;
    }
    templateAllWallets() {
        if (this.showAllWallets && this.imageSrc) return (0, $i7GIz.html)` <wui-all-wallets-image .imageeSrc=${this.imageSrc}> </wui-all-wallets-image> `;
        else if (this.showAllWallets && this.walletIcon) return (0, $i7GIz.html)` <wui-wallet-image .walletIcon=${this.walletIcon} size="sm"> </wui-wallet-image> `;
        return null;
    }
    templateWalletImage() {
        if (!this.showAllWallets && this.imageSrc) return (0, $i7GIz.html)`<wui-wallet-image
        size="sm"
        imageSrc=${this.imageSrc}
        name=${this.name}
        .installed=${this.installed}
      ></wui-wallet-image>`;
        else if (!this.showAllWallets && !this.imageSrc) return (0, $i7GIz.html)`<wui-wallet-image size="sm" name=${this.name}></wui-wallet-image>`;
        return null;
    }
    templateStatus() {
        if (this.tagLabel && this.tagVariant) return (0, $i7GIz.html)`<wui-tag variant=${this.tagVariant}>${this.tagLabel}</wui-tag>`;
        else if (this.icon) return (0, $i7GIz.html)`<wui-icon color="inherit" size="sm" name=${this.icon}></wui-icon>`;
        return null;
    }
};
$dd10d144961e03c2$export$fe01be9b7ff81a09.styles = [
    (0, $9rwwE.resetStyles),
    (0, $9rwwE.elementStyles),
    (0, $hKk0F.default)
];
$dd10d144961e03c2$var$__decorate([
    (0, $cRlTX.property)({
        type: Array
    })
], $dd10d144961e03c2$export$fe01be9b7ff81a09.prototype, "walletImages", void 0);
$dd10d144961e03c2$var$__decorate([
    (0, $cRlTX.property)()
], $dd10d144961e03c2$export$fe01be9b7ff81a09.prototype, "imageSrc", void 0);
$dd10d144961e03c2$var$__decorate([
    (0, $cRlTX.property)()
], $dd10d144961e03c2$export$fe01be9b7ff81a09.prototype, "name", void 0);
$dd10d144961e03c2$var$__decorate([
    (0, $cRlTX.property)()
], $dd10d144961e03c2$export$fe01be9b7ff81a09.prototype, "tagLabel", void 0);
$dd10d144961e03c2$var$__decorate([
    (0, $cRlTX.property)()
], $dd10d144961e03c2$export$fe01be9b7ff81a09.prototype, "tagVariant", void 0);
$dd10d144961e03c2$var$__decorate([
    (0, $cRlTX.property)()
], $dd10d144961e03c2$export$fe01be9b7ff81a09.prototype, "icon", void 0);
$dd10d144961e03c2$var$__decorate([
    (0, $cRlTX.property)()
], $dd10d144961e03c2$export$fe01be9b7ff81a09.prototype, "walletIcon", void 0);
$dd10d144961e03c2$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $dd10d144961e03c2$export$fe01be9b7ff81a09.prototype, "installed", void 0);
$dd10d144961e03c2$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $dd10d144961e03c2$export$fe01be9b7ff81a09.prototype, "disabled", void 0);
$dd10d144961e03c2$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $dd10d144961e03c2$export$fe01be9b7ff81a09.prototype, "showAllWallets", void 0);
$dd10d144961e03c2$export$fe01be9b7ff81a09 = $dd10d144961e03c2$var$__decorate([
    (0, $lkv4o.customElement)("wui-list-wallet")
], $dd10d144961e03c2$export$fe01be9b7ff81a09);

});
parcelRegister("1ChWu", function(module, exports) {

$parcel$export(module.exports, "WuiTag", () => $12d7420ba96cd340$export$989e5aad4666150);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
parcelRequire("eFeuH");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");

var $6TyAq = parcelRequire("6TyAq");
var $12d7420ba96cd340$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $12d7420ba96cd340$export$989e5aad4666150 = class WuiTag extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.variant = "main";
    }
    render() {
        this.dataset["variant"] = this.variant;
        return (0, $i7GIz.html)`
      <wui-text data-variant=${this.variant} variant="micro-700" color="inherit">
        <slot></slot>
      </wui-text>
    `;
    }
};
$12d7420ba96cd340$export$989e5aad4666150.styles = [
    (0, $9rwwE.resetStyles),
    (0, $6TyAq.default)
];
$12d7420ba96cd340$var$__decorate([
    (0, $cRlTX.property)()
], $12d7420ba96cd340$export$989e5aad4666150.prototype, "variant", void 0);
$12d7420ba96cd340$export$989e5aad4666150 = $12d7420ba96cd340$var$__decorate([
    (0, $lkv4o.customElement)("wui-tag")
], $12d7420ba96cd340$export$989e5aad4666150);

});
parcelRegister("6TyAq", function(module, exports) {

$parcel$export(module.exports, "default", () => $5052b54a5be63b3b$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $5052b54a5be63b3b$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    display: block;
    padding: 3.5px 5px !important;
    border-radius: var(--wui-border-radius-5xs);
  }

  :host([data-variant='main']) {
    background-color: var(--wui-accent-glass-015);
    color: var(--wui-color-accent-100);
  }

  :host([data-variant='shade']) {
    background-color: var(--wui-gray-glass-010);
    color: var(--wui-color-fg-200);
  }

  :host([data-variant='success']) {
    background-color: var(--wui-icon-box-bg-success-100);
    color: var(--wui-color-success-100);
  }

  :host([data-variant='error']) {
    background-color: var(--wui-icon-box-bg-error-100);
    color: var(--wui-color-error-100);
  }
`;

});


parcelRegister("hKk0F", function(module, exports) {

$parcel$export(module.exports, "default", () => $ceb64114afa5bb57$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $ceb64114afa5bb57$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  button {
    column-gap: var(--wui-spacing-s);
    padding: 7px var(--wui-spacing-l) 7px var(--wui-spacing-xs);
    width: 100%;
    background-color: var(--wui-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
    color: var(--wui-color-fg-100);
  }

  button > wui-text:nth-child(2) {
    display: flex;
    flex: 1;
  }

  wui-icon {
    color: var(--wui-color-fg-200) !important;
  }

  button:disabled {
    background-color: var(--wui-gray-glass-015);
    color: var(--wui-gray-glass-015);
  }

  button:disabled > wui-tag {
    background-color: var(--wui-gray-glass-010);
    color: var(--wui-color-fg-300);
  }
`;

});


parcelRegister("4bXjU", function(module, exports) {

$parcel$export(module.exports, "WuiLogoSelect", () => $30d63442466cbb10$export$aadc276ee48f1572);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");
parcelRequire("3jLql");

var $2t9yp = parcelRequire("2t9yp");
var $30d63442466cbb10$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $30d63442466cbb10$export$aadc276ee48f1572 = class WuiLogoSelect extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.logo = "google";
        this.disabled = false;
    }
    render() {
        return (0, $i7GIz.html)`
      <button ?disabled=${this.disabled} ontouchstart>
        <wui-logo logo=${this.logo}></wui-logo>
      </button>
    `;
    }
};
$30d63442466cbb10$export$aadc276ee48f1572.styles = [
    (0, $9rwwE.resetStyles),
    (0, $9rwwE.elementStyles),
    (0, $2t9yp.default)
];
$30d63442466cbb10$var$__decorate([
    (0, $cRlTX.property)()
], $30d63442466cbb10$export$aadc276ee48f1572.prototype, "logo", void 0);
$30d63442466cbb10$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $30d63442466cbb10$export$aadc276ee48f1572.prototype, "disabled", void 0);
$30d63442466cbb10$export$aadc276ee48f1572 = $30d63442466cbb10$var$__decorate([
    (0, $lkv4o.customElement)("wui-logo-select")
], $30d63442466cbb10$export$aadc276ee48f1572);

});
parcelRegister("3jLql", function(module, exports) {

$parcel$export(module.exports, "WuiLogo", () => $26a7eede876392f3$export$e515c2183ed1fdbc);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
parcelRequire("cvzvT");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");

var $dauSS = parcelRequire("dauSS");
var $26a7eede876392f3$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $26a7eede876392f3$export$e515c2183ed1fdbc = class WuiLogo extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.logo = "google";
    }
    render() {
        return (0, $i7GIz.html)`<wui-icon color="inherit" size="inherit" name=${this.logo}></wui-icon> `;
    }
};
$26a7eede876392f3$export$e515c2183ed1fdbc.styles = [
    (0, $9rwwE.resetStyles),
    (0, $dauSS.default)
];
$26a7eede876392f3$var$__decorate([
    (0, $cRlTX.property)()
], $26a7eede876392f3$export$e515c2183ed1fdbc.prototype, "logo", void 0);
$26a7eede876392f3$export$e515c2183ed1fdbc = $26a7eede876392f3$var$__decorate([
    (0, $lkv4o.customElement)("wui-logo")
], $26a7eede876392f3$export$e515c2183ed1fdbc);

});
parcelRegister("dauSS", function(module, exports) {

$parcel$export(module.exports, "default", () => $99642a754fb187ce$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $99642a754fb187ce$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    display: block;
    width: 40px;
    height: 40px;
    border-radius: var(--wui-border-radius-3xl);
    border: 1px solid var(--wui-gray-glass-010);
    overflow: hidden;
  }

  wui-icon {
    width: 100%;
    height: 100%;
  }
`;

});


parcelRegister("2t9yp", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cc5b36a57968475$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $1cc5b36a57968475$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    display: block;
  }

  button {
    width: 50px;
    height: 50px;
    background: var(--wui-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
  }
`;

});


parcelRegister("5UCXI", function(module, exports) {

$parcel$export(module.exports, "WuiNetworkButton", () => $44e067c9b9b2d75e$export$bb00a3a9463dc4a7);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
parcelRequire("1fjkg");
parcelRequire("eFeuH");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");
parcelRequire("e4QeF");

var $iNdms = parcelRequire("iNdms");
var $44e067c9b9b2d75e$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $44e067c9b9b2d75e$export$bb00a3a9463dc4a7 = class WuiNetworkButton extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.imageSrc = undefined;
        this.isUnsupportedChain = undefined;
        this.disabled = false;
    }
    render() {
        return (0, $i7GIz.html)`
      <button ?disabled=${this.disabled}>
        ${this.visualTemplate()}
        <wui-text variant="paragraph-600" color="inherit">
          <slot></slot>
        </wui-text>
      </button>
    `;
    }
    visualTemplate() {
        if (this.isUnsupportedChain) return (0, $i7GIz.html)`
        <wui-icon-box
          size="sm"
          iconColor="error-100"
          backgroundColor="error-100"
          icon="warningCircle"
        ></wui-icon-box>
      `;
        if (this.imageSrc) return (0, $i7GIz.html)`<wui-image src=${this.imageSrc}></wui-image>`;
        return (0, $i7GIz.html)`
      <wui-icon-box
        size="sm"
        iconColor="inverse-100"
        backgroundColor="fg-100"
        icon="networkPlaceholder"
      ></wui-icon-box>
    `;
    }
};
$44e067c9b9b2d75e$export$bb00a3a9463dc4a7.styles = [
    (0, $9rwwE.resetStyles),
    (0, $9rwwE.elementStyles),
    (0, $iNdms.default)
];
$44e067c9b9b2d75e$var$__decorate([
    (0, $cRlTX.property)()
], $44e067c9b9b2d75e$export$bb00a3a9463dc4a7.prototype, "imageSrc", void 0);
$44e067c9b9b2d75e$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $44e067c9b9b2d75e$export$bb00a3a9463dc4a7.prototype, "isUnsupportedChain", void 0);
$44e067c9b9b2d75e$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $44e067c9b9b2d75e$export$bb00a3a9463dc4a7.prototype, "disabled", void 0);
$44e067c9b9b2d75e$export$bb00a3a9463dc4a7 = $44e067c9b9b2d75e$var$__decorate([
    (0, $lkv4o.customElement)("wui-network-button")
], $44e067c9b9b2d75e$export$bb00a3a9463dc4a7);

});
parcelRegister("iNdms", function(module, exports) {

$parcel$export(module.exports, "default", () => $dae72ad6601fd24a$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $dae72ad6601fd24a$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    display: block;
  }

  button {
    border-radius: var(--wui-border-radius-3xl);
    display: flex;
    gap: var(--wui-spacing-xs);
    padding: var(--wui-spacing-2xs) var(--wui-spacing-s) var(--wui-spacing-2xs)
      var(--wui-spacing-xs);
    border: 1px solid var(--wui-gray-glass-010);
    background-color: var(--wui-gray-glass-005);
    color: var(--wui-color-fg-100);
  }

  button:disabled {
    border: 1px solid var(--wui-gray-glass-005);
    background-color: var(--wui-gray-glass-015);
    color: var(--wui-gray-glass-015);
  }

  @media (hover: hover) and (pointer: fine) {
    button:hover:enabled {
      background-color: var(--wui-gray-glass-010);
    }

    button:active:enabled {
      background-color: var(--wui-gray-glass-015);
    }
  }

  wui-image,
  wui-icon-box {
    border-radius: var(--wui-border-radius-3xl);
    width: 24px;
    height: 24px;
    box-shadow: 0 0 0 2px var(--wui-gray-glass-005);
  }
`;

});


parcelRegister("5wY7t", function(module, exports) {

$parcel$export(module.exports, "WuiOtp", () => $406e9365ef4df471$export$443bf27d3bf7bc18);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
var $2o0HH = parcelRequire("2o0HH");
parcelRequire("aiZ8J");

var $9rwwE = parcelRequire("9rwwE");

var $97bbL = parcelRequire("97bbL");

var $lkv4o = parcelRequire("lkv4o");
parcelRequire("wd6Nb");

var $1TWNL = parcelRequire("1TWNL");
var $406e9365ef4df471$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $406e9365ef4df471$export$443bf27d3bf7bc18 = class WuiOtp extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.length = 6;
        this.otp = "";
        this.values = Array.from({
            length: this.length
        }).map(()=>"");
        this.numerics = [];
        this.shouldInputBeEnabled = (index)=>{
            const previousInputs = this.values.slice(0, index);
            return previousInputs.every((input)=>input !== "");
        };
        this.handleKeyDown = (e, index)=>{
            const inputElement = e.target;
            const input = this.getInputElement(inputElement);
            const keyArr = [
                "ArrowLeft",
                "ArrowRight",
                "Shift",
                "Delete"
            ];
            if (!input) return;
            if (keyArr.includes(e.key)) e.preventDefault();
            const currentCaretPos = input.selectionStart;
            switch(e.key){
                case "ArrowLeft":
                    if (currentCaretPos) input.setSelectionRange(currentCaretPos + 1, currentCaretPos + 1);
                    this.focusInputField("prev", index);
                    break;
                case "ArrowRight":
                    this.focusInputField("next", index);
                    break;
                case "Shift":
                    this.focusInputField("next", index);
                    break;
                case "Delete":
                    if (input.value === "") this.focusInputField("prev", index);
                    else this.updateInput(input, index, "");
                    break;
                case "Backspace":
                    if (input.value === "") this.focusInputField("prev", index);
                    else this.updateInput(input, index, "");
                    break;
                default:
            }
        };
        this.focusInputField = (dir, index)=>{
            if (dir === "next") {
                const nextIndex = index + 1;
                if (!this.shouldInputBeEnabled(nextIndex)) return;
                const numeric = this.numerics[nextIndex < this.length ? nextIndex : index];
                const input = numeric ? this.getInputElement(numeric) : undefined;
                if (input) {
                    input.disabled = false;
                    input.focus();
                }
            }
            if (dir === "prev") {
                const nextIndex = index - 1;
                const numeric = this.numerics[nextIndex > -1 ? nextIndex : index];
                const input = numeric ? this.getInputElement(numeric) : undefined;
                if (input) input.focus();
            }
        };
    }
    firstUpdated() {
        if (this.otp) this.values = this.otp.split("");
        const numericElements = this.shadowRoot?.querySelectorAll("wui-input-numeric");
        if (numericElements) this.numerics = Array.from(numericElements);
        this.numerics[0]?.focus();
    }
    render() {
        return (0, $i7GIz.html)`
      <wui-flex gap="xxs" data-testid="wui-otp-input">
        ${Array.from({
            length: this.length
        }).map((_, index)=>(0, $i7GIz.html)`
            <wui-input-numeric
              @input=${(e)=>this.handleInput(e, index)}
              @click=${(e)=>this.selectInput(e)}
              @keydown=${(e)=>this.handleKeyDown(e, index)}
              .disabled=${!this.shouldInputBeEnabled(index)}
              .value=${this.values[index] || ""}
            >
            </wui-input-numeric>
          `)}
      </wui-flex>
    `;
    }
    updateInput(element, index, value) {
        const numeric = this.numerics[index];
        const input = element || (numeric ? this.getInputElement(numeric) : undefined);
        if (input) {
            input.value = value;
            this.values = this.values.map((val, i)=>i === index ? value : val);
        }
    }
    selectInput(e) {
        const targetElement = e.target;
        if (targetElement) {
            const inputElement = this.getInputElement(targetElement);
            inputElement?.select();
        }
    }
    handleInput(e, index) {
        const inputElement = e.target;
        const input = this.getInputElement(inputElement);
        if (input) {
            const inputValue = input.value;
            if (e.inputType === "insertFromPaste") this.handlePaste(input, inputValue, index);
            else {
                const isValid = (0, $97bbL.UiHelperUtil).isNumber(inputValue);
                if (isValid && e.data) {
                    this.updateInput(input, index, e.data);
                    this.focusInputField("next", index);
                } else this.updateInput(input, index, "");
            }
        }
        this.dispatchInputChangeEvent();
    }
    handlePaste(input, inputValue, index) {
        const value = inputValue[0];
        const isValid = value && (0, $97bbL.UiHelperUtil).isNumber(value);
        if (isValid) {
            this.updateInput(input, index, value);
            const inputString = inputValue.substring(1);
            if (index + 1 < this.length && inputString.length) {
                const nextNumeric = this.numerics[index + 1];
                const nextInput = nextNumeric ? this.getInputElement(nextNumeric) : undefined;
                if (nextInput) this.handlePaste(nextInput, inputString, index + 1);
            } else this.focusInputField("next", index);
        } else this.updateInput(input, index, "");
    }
    getInputElement(el) {
        if (el.shadowRoot?.querySelector("input")) return el.shadowRoot.querySelector("input");
        return null;
    }
    dispatchInputChangeEvent() {
        const value = this.values.join("");
        this.dispatchEvent(new CustomEvent("inputChange", {
            detail: value,
            bubbles: true,
            composed: true
        }));
    }
};
$406e9365ef4df471$export$443bf27d3bf7bc18.styles = [
    (0, $9rwwE.resetStyles),
    (0, $1TWNL.default)
];
$406e9365ef4df471$var$__decorate([
    (0, $cRlTX.property)({
        type: Number
    })
], $406e9365ef4df471$export$443bf27d3bf7bc18.prototype, "length", void 0);
$406e9365ef4df471$var$__decorate([
    (0, $cRlTX.property)({
        type: String
    })
], $406e9365ef4df471$export$443bf27d3bf7bc18.prototype, "otp", void 0);
$406e9365ef4df471$var$__decorate([
    (0, $2o0HH.state)()
], $406e9365ef4df471$export$443bf27d3bf7bc18.prototype, "values", void 0);
$406e9365ef4df471$export$443bf27d3bf7bc18 = $406e9365ef4df471$var$__decorate([
    (0, $lkv4o.customElement)("wui-otp")
], $406e9365ef4df471$export$443bf27d3bf7bc18);

});
parcelRegister("1TWNL", function(module, exports) {

$parcel$export(module.exports, "default", () => $16288a4d4a60903b$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $16288a4d4a60903b$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    position: relative;
    display: block;
  }
`;

});


parcelRegister("d4fxd", function(module, exports) {

$parcel$export(module.exports, "WuiQrCode", () => $9837b2f88a1be691$export$29f6e16532a663bf);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
parcelRequire("cvzvT");
parcelRequire("1fjkg");

var $btl4Q = parcelRequire("btl4Q");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");

var $l1Gj7 = parcelRequire("l1Gj7");
var $9837b2f88a1be691$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $9837b2f88a1be691$export$29f6e16532a663bf = class WuiQrCode extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.uri = "";
        this.size = 0;
        this.theme = "dark";
        this.imageSrc = undefined;
        this.alt = undefined;
    }
    render() {
        this.dataset["theme"] = this.theme;
        this.style.cssText = `--local-size: ${this.size}px`;
        return (0, $i7GIz.html)`${this.templateVisual()} ${this.templateSvg()}`;
    }
    templateSvg() {
        const size = this.theme === "light" ? this.size : this.size - 32;
        return (0, $i7GIz.svg)`
      <svg height=${size} width=${size}>
        ${(0, $btl4Q.QrCodeUtil).generate(this.uri, size, size / 4)}
      </svg>
    `;
    }
    templateVisual() {
        if (this.imageSrc) return (0, $i7GIz.html)`<wui-image src=${this.imageSrc} alt=${this.alt ?? "logo"}></wui-image>`;
        return (0, $i7GIz.html)`<wui-icon size="inherit" color="inherit" name="walletConnect"></wui-icon>`;
    }
};
$9837b2f88a1be691$export$29f6e16532a663bf.styles = [
    (0, $9rwwE.resetStyles),
    (0, $l1Gj7.default)
];
$9837b2f88a1be691$var$__decorate([
    (0, $cRlTX.property)()
], $9837b2f88a1be691$export$29f6e16532a663bf.prototype, "uri", void 0);
$9837b2f88a1be691$var$__decorate([
    (0, $cRlTX.property)({
        type: Number
    })
], $9837b2f88a1be691$export$29f6e16532a663bf.prototype, "size", void 0);
$9837b2f88a1be691$var$__decorate([
    (0, $cRlTX.property)()
], $9837b2f88a1be691$export$29f6e16532a663bf.prototype, "theme", void 0);
$9837b2f88a1be691$var$__decorate([
    (0, $cRlTX.property)()
], $9837b2f88a1be691$export$29f6e16532a663bf.prototype, "imageSrc", void 0);
$9837b2f88a1be691$var$__decorate([
    (0, $cRlTX.property)()
], $9837b2f88a1be691$export$29f6e16532a663bf.prototype, "alt", void 0);
$9837b2f88a1be691$export$29f6e16532a663bf = $9837b2f88a1be691$var$__decorate([
    (0, $lkv4o.customElement)("wui-qr-code")
], $9837b2f88a1be691$export$29f6e16532a663bf);

});
parcelRegister("btl4Q", function(module, exports) {

$parcel$export(module.exports, "QrCodeUtil", () => $85a2c09a3f7e0216$export$2faef7998946735);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");

var $fPXAQ = parcelRequire("fPXAQ");
const $85a2c09a3f7e0216$var$CONNECTING_ERROR_MARGIN = 0.1;
const $85a2c09a3f7e0216$var$CIRCLE_SIZE_MODIFIER = 2.5;
const $85a2c09a3f7e0216$var$QRCODE_MATRIX_MARGIN = 7;
function $85a2c09a3f7e0216$var$isAdjecentDots(cy, otherCy, cellSize) {
    if (cy === otherCy) return false;
    const diff = cy - otherCy < 0 ? otherCy - cy : cy - otherCy;
    return diff <= cellSize + $85a2c09a3f7e0216$var$CONNECTING_ERROR_MARGIN;
}
function $85a2c09a3f7e0216$var$getMatrix(value, errorCorrectionLevel) {
    const arr = Array.prototype.slice.call((0, (/*@__PURE__*/$parcel$interopDefault($fPXAQ))).create(value, {
        errorCorrectionLevel: errorCorrectionLevel
    }).modules.data, 0);
    const sqrt = Math.sqrt(arr.length);
    return arr.reduce((rows, key, index)=>(index % sqrt === 0 ? rows.push([
            key
        ]) : rows[rows.length - 1].push(key)) && rows, []);
}
const $85a2c09a3f7e0216$export$2faef7998946735 = {
    generate (uri, size, logoSize) {
        const dotColor = "#141414";
        const edgeColor = "transparent";
        const strokeWidth = 5;
        const dots = [];
        const matrix = $85a2c09a3f7e0216$var$getMatrix(uri, "Q");
        const cellSize = size / matrix.length;
        const qrList = [
            {
                x: 0,
                y: 0
            },
            {
                x: 1,
                y: 0
            },
            {
                x: 0,
                y: 1
            }
        ];
        qrList.forEach(({ x: x, y: y })=>{
            const x1 = (matrix.length - $85a2c09a3f7e0216$var$QRCODE_MATRIX_MARGIN) * cellSize * x;
            const y1 = (matrix.length - $85a2c09a3f7e0216$var$QRCODE_MATRIX_MARGIN) * cellSize * y;
            const borderRadius = 0.45;
            for(let i = 0; i < qrList.length; i += 1){
                const dotSize = cellSize * ($85a2c09a3f7e0216$var$QRCODE_MATRIX_MARGIN - i * 2);
                dots.push((0, $i7GIz.svg)`
            <rect
              fill=${i === 2 ? dotColor : edgeColor}
              width=${i === 0 ? dotSize - strokeWidth : dotSize}
              rx= ${i === 0 ? (dotSize - strokeWidth) * borderRadius : dotSize * borderRadius}
              ry= ${i === 0 ? (dotSize - strokeWidth) * borderRadius : dotSize * borderRadius}
              stroke=${dotColor}
              stroke-width=${i === 0 ? strokeWidth : 0}
              height=${i === 0 ? dotSize - strokeWidth : dotSize}
              x= ${i === 0 ? y1 + cellSize * i + strokeWidth / 2 : y1 + cellSize * i}
              y= ${i === 0 ? x1 + cellSize * i + strokeWidth / 2 : x1 + cellSize * i}
            />
          `);
            }
        });
        const clearArenaSize = Math.floor((logoSize + 25) / cellSize);
        const matrixMiddleStart = matrix.length / 2 - clearArenaSize / 2;
        const matrixMiddleEnd = matrix.length / 2 + clearArenaSize / 2 - 1;
        const circles = [];
        matrix.forEach((row, i)=>{
            row.forEach((_, j)=>{
                if (matrix[i][j]) {
                    if (!(i < $85a2c09a3f7e0216$var$QRCODE_MATRIX_MARGIN && j < $85a2c09a3f7e0216$var$QRCODE_MATRIX_MARGIN || i > matrix.length - ($85a2c09a3f7e0216$var$QRCODE_MATRIX_MARGIN + 1) && j < $85a2c09a3f7e0216$var$QRCODE_MATRIX_MARGIN || i < $85a2c09a3f7e0216$var$QRCODE_MATRIX_MARGIN && j > matrix.length - ($85a2c09a3f7e0216$var$QRCODE_MATRIX_MARGIN + 1))) {
                        if (!(i > matrixMiddleStart && i < matrixMiddleEnd && j > matrixMiddleStart && j < matrixMiddleEnd)) {
                            const cx = i * cellSize + cellSize / 2;
                            const cy = j * cellSize + cellSize / 2;
                            circles.push([
                                cx,
                                cy
                            ]);
                        }
                    }
                }
            });
        });
        const circlesToConnect = {};
        circles.forEach(([cx, cy])=>{
            if (circlesToConnect[cx]) circlesToConnect[cx]?.push(cy);
            else circlesToConnect[cx] = [
                cy
            ];
        });
        Object.entries(circlesToConnect).map(([cx, cys])=>{
            const newCys = cys.filter((cy)=>cys.every((otherCy)=>!$85a2c09a3f7e0216$var$isAdjecentDots(cy, otherCy, cellSize)));
            return [
                Number(cx),
                newCys
            ];
        }).forEach(([cx, cys])=>{
            cys.forEach((cy)=>{
                dots.push((0, $i7GIz.svg)`<circle cx=${cx} cy=${cy} fill=${dotColor} r=${cellSize / $85a2c09a3f7e0216$var$CIRCLE_SIZE_MODIFIER} />`);
            });
        });
        Object.entries(circlesToConnect).filter(([_, cys])=>cys.length > 1).map(([cx, cys])=>{
            const newCys = cys.filter((cy)=>cys.some((otherCy)=>$85a2c09a3f7e0216$var$isAdjecentDots(cy, otherCy, cellSize)));
            return [
                Number(cx),
                newCys
            ];
        }).map(([cx, cys])=>{
            cys.sort((a, b)=>a < b ? -1 : 1);
            const groups = [];
            for (const cy of cys){
                const group = groups.find((item)=>item.some((otherCy)=>$85a2c09a3f7e0216$var$isAdjecentDots(cy, otherCy, cellSize)));
                if (group) group.push(cy);
                else groups.push([
                    cy
                ]);
            }
            return [
                cx,
                groups.map((item)=>[
                        item[0],
                        item[item.length - 1]
                    ])
            ];
        }).forEach(([cx, groups])=>{
            groups.forEach(([y1, y2])=>{
                dots.push((0, $i7GIz.svg)`
              <line
                x1=${cx}
                x2=${cx}
                y1=${y1}
                y2=${y2}
                stroke=${dotColor}
                stroke-width=${cellSize / ($85a2c09a3f7e0216$var$CIRCLE_SIZE_MODIFIER / 2)}
                stroke-linecap="round"
              />
            `);
            });
        });
        return dots;
    }
};

});
parcelRegister("fPXAQ", function(module, exports) {

$parcel$export(module.exports, "create", () => $b879d867f1bff53f$export$185802fd694ee1f5, (v) => $b879d867f1bff53f$export$185802fd694ee1f5 = v);
$parcel$export(module.exports, "toCanvas", () => $b879d867f1bff53f$export$f87f6982d1fd4f81, (v) => $b879d867f1bff53f$export$f87f6982d1fd4f81 = v);
$parcel$export(module.exports, "toDataURL", () => $b879d867f1bff53f$export$723e4939e5a27c8, (v) => $b879d867f1bff53f$export$723e4939e5a27c8 = v);
$parcel$export(module.exports, "toString", () => $b879d867f1bff53f$export$f84e8e69fd4488a5, (v) => $b879d867f1bff53f$export$f84e8e69fd4488a5 = v);
var $b879d867f1bff53f$export$185802fd694ee1f5;
var $b879d867f1bff53f$export$f87f6982d1fd4f81;
var $b879d867f1bff53f$export$723e4939e5a27c8;
// only svg for now.
var $b879d867f1bff53f$export$f84e8e69fd4488a5;

var $lfFwA = parcelRequire("lfFwA");

var $cgcOn = parcelRequire("cgcOn");

var $joGNa = parcelRequire("joGNa");

var $blG8i = parcelRequire("blG8i");
function $b879d867f1bff53f$var$renderCanvas(renderFunc, canvas, text, opts, cb) {
    const args = [].slice.call(arguments, 1);
    const argsNum = args.length;
    const isLastArgCb = typeof args[argsNum - 1] === "function";
    if (!isLastArgCb && !$lfFwA()) throw new Error("Callback required as last argument");
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error("Too few arguments provided");
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === "undefined") {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error("Too few arguments provided");
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                const data = $cgcOn.create(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        const data = $cgcOn.create(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
$b879d867f1bff53f$export$185802fd694ee1f5 = $cgcOn.create;
$b879d867f1bff53f$export$f87f6982d1fd4f81 = $b879d867f1bff53f$var$renderCanvas.bind(null, $joGNa.render);
$b879d867f1bff53f$export$723e4939e5a27c8 = $b879d867f1bff53f$var$renderCanvas.bind(null, $joGNa.renderToDataURL);
$b879d867f1bff53f$export$f84e8e69fd4488a5 = $b879d867f1bff53f$var$renderCanvas.bind(null, function(data, _, opts) {
    return $blG8i.render(data, opts);
});

});
parcelRegister("lfFwA", function(module, exports) {
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
module.exports = function() {
    return typeof Promise === "function" && Promise.prototype && Promise.prototype.then;
};

});

parcelRegister("cgcOn", function(module, exports) {

$parcel$export(module.exports, "create", () => $8ed0eac7685987c5$export$185802fd694ee1f5, (v) => $8ed0eac7685987c5$export$185802fd694ee1f5 = v);
/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ var $8ed0eac7685987c5$export$185802fd694ee1f5;

var $fIeXC = parcelRequire("fIeXC");

var $eWSU1 = parcelRequire("eWSU1");

var $3j2Nu = parcelRequire("3j2Nu");

var $8kWmG = parcelRequire("8kWmG");

var $f3KBx = parcelRequire("f3KBx");

var $fvVQq = parcelRequire("fvVQq");

var $jfjGb = parcelRequire("jfjGb");

var $1r3vy = parcelRequire("1r3vy");

var $cLXV6 = parcelRequire("cLXV6");

var $akldy = parcelRequire("akldy");

var $b2LbR = parcelRequire("b2LbR");

var $7DYQI = parcelRequire("7DYQI");

var $cKo59 = parcelRequire("cKo59");
/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $8ed0eac7685987c5$var$setupFinderPattern(matrix, version) {
    const size = matrix.size;
    const pos = $fvVQq.getPositions(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(let c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function $8ed0eac7685987c5$var$setupTimingPattern(matrix) {
    const size = matrix.size;
    for(let r = 8; r < size - 8; r++){
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $8ed0eac7685987c5$var$setupAlignmentPattern(matrix, version) {
    const pos = $f3KBx.getPositions(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -2; r <= 2; r++){
            for(let c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $8ed0eac7685987c5$var$setupVersionInfo(matrix, version) {
    const size = matrix.size;
    const bits = $akldy.getEncodedBits(version);
    let row, col, mod;
    for(let i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function $8ed0eac7685987c5$var$setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    const size = matrix.size;
    const bits = $b2LbR.getEncodedBits(errorCorrectionLevel, maskPattern);
    let i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function $8ed0eac7685987c5$var$setupData(matrix, data) {
    const size = matrix.size;
    let inc = -1;
    let row = size - 1;
    let bitIndex = 7;
    let byteIndex = 0;
    for(let col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(let c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function $8ed0eac7685987c5$var$createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    const buffer = new $3j2Nu();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), $7DYQI.getCharCountIndicator(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    const totalCodewords = $fIeXC.getSymbolTotalCodewords(version);
    const ecTotalCodewords = $1r3vy.getTotalCodewordsCount(version, errorCorrectionLevel);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(let i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return $8ed0eac7685987c5$var$createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function $8ed0eac7685987c5$var$createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $fIeXC.getSymbolTotalCodewords(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $1r3vy.getTotalCodewordsCount(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    const ecTotalBlocks = $1r3vy.getBlocksCount(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    const blocksInGroup2 = totalCodewords % ecTotalBlocks;
    const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    const rs = new $cLXV6(ecCount);
    let offset = 0;
    const dcData = new Array(ecTotalBlocks);
    const ecData = new Array(ecTotalBlocks);
    let maxDataSize = 0;
    const buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(let b = 0; b < ecTotalBlocks; b++){
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    const data = new Uint8Array(totalCodewords);
    let index = 0;
    let i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function $8ed0eac7685987c5$var$createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    let segments;
    if (Array.isArray(data)) segments = $cKo59.fromArray(data);
    else if (typeof data === "string") {
        let estimatedVersion = version;
        if (!estimatedVersion) {
            const rawSegments = $cKo59.rawSplit(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = $akldy.getBestVersionForData(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = $cKo59.fromString(data, estimatedVersion || 40);
    } else throw new Error("Invalid data");
    // Get the min version that can contain data
    const bestVersion = $akldy.getBestVersionForData(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error("The amount of data is too big to be stored in a QR Code");
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + ".\n");
    const dataBits = $8ed0eac7685987c5$var$createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    const moduleCount = $fIeXC.getSymbolSize(version);
    const modules = new $8kWmG(moduleCount);
    // Add function modules
    $8ed0eac7685987c5$var$setupFinderPattern(modules, version);
    $8ed0eac7685987c5$var$setupTimingPattern(modules);
    $8ed0eac7685987c5$var$setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    $8ed0eac7685987c5$var$setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) $8ed0eac7685987c5$var$setupVersionInfo(modules, version);
    // Add data codewords
    $8ed0eac7685987c5$var$setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = $jfjGb.getBestMask(modules, $8ed0eac7685987c5$var$setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    $jfjGb.applyMask(maskPattern, modules);
    // Replace format info bits with correct values
    $8ed0eac7685987c5$var$setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
$8ed0eac7685987c5$export$185802fd694ee1f5 = function create(data, options) {
    if (typeof data === "undefined" || data === "") throw new Error("No input text");
    let errorCorrectionLevel = $eWSU1.M;
    let version;
    let mask;
    if (typeof options !== "undefined") {
        // Use higher error correction level as default
        errorCorrectionLevel = $eWSU1.from(options.errorCorrectionLevel, $eWSU1.M);
        version = $akldy.from(options.version);
        mask = $jfjGb.from(options.maskPattern);
        if (options.toSJISFunc) $fIeXC.setToSJISFunction(options.toSJISFunc);
    }
    return $8ed0eac7685987c5$var$createSymbol(data, version, errorCorrectionLevel, mask);
};

});
parcelRegister("fIeXC", function(module, exports) {

$parcel$export(module.exports, "getSymbolSize", () => $b70691f3b4ed3ed0$export$8d4a06d3facd414b, (v) => $b70691f3b4ed3ed0$export$8d4a06d3facd414b = v);
$parcel$export(module.exports, "getSymbolTotalCodewords", () => $b70691f3b4ed3ed0$export$b05dac13c7a35c32, (v) => $b70691f3b4ed3ed0$export$b05dac13c7a35c32 = v);
$parcel$export(module.exports, "getBCHDigit", () => $b70691f3b4ed3ed0$export$ed1d66da50968976, (v) => $b70691f3b4ed3ed0$export$ed1d66da50968976 = v);
$parcel$export(module.exports, "setToSJISFunction", () => $b70691f3b4ed3ed0$export$6733b14783f975c2, (v) => $b70691f3b4ed3ed0$export$6733b14783f975c2 = v);
$parcel$export(module.exports, "isKanjiModeEnabled", () => $b70691f3b4ed3ed0$export$ce5b1274f8597fa0, (v) => $b70691f3b4ed3ed0$export$ce5b1274f8597fa0 = v);
$parcel$export(module.exports, "toSJIS", () => $b70691f3b4ed3ed0$export$43dd553ecded716d, (v) => $b70691f3b4ed3ed0$export$43dd553ecded716d = v);
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ var $b70691f3b4ed3ed0$export$8d4a06d3facd414b;
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ var $b70691f3b4ed3ed0$export$b05dac13c7a35c32;
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ var $b70691f3b4ed3ed0$export$ed1d66da50968976;
var $b70691f3b4ed3ed0$export$6733b14783f975c2;
var $b70691f3b4ed3ed0$export$ce5b1274f8597fa0;
var $b70691f3b4ed3ed0$export$43dd553ecded716d;
let $b70691f3b4ed3ed0$var$toSJISFunction;
const $b70691f3b4ed3ed0$var$CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$b70691f3b4ed3ed0$export$8d4a06d3facd414b = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
$b70691f3b4ed3ed0$export$b05dac13c7a35c32 = function getSymbolTotalCodewords(version) {
    return $b70691f3b4ed3ed0$var$CODEWORDS_COUNT[version];
};
$b70691f3b4ed3ed0$export$ed1d66da50968976 = function(data) {
    let digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
$b70691f3b4ed3ed0$export$6733b14783f975c2 = function setToSJISFunction(f) {
    if (typeof f !== "function") throw new Error('"toSJISFunc" is not a valid function.');
    $b70691f3b4ed3ed0$var$toSJISFunction = f;
};
$b70691f3b4ed3ed0$export$ce5b1274f8597fa0 = function() {
    return typeof $b70691f3b4ed3ed0$var$toSJISFunction !== "undefined";
};
$b70691f3b4ed3ed0$export$43dd553ecded716d = function toSJIS(kanji) {
    return $b70691f3b4ed3ed0$var$toSJISFunction(kanji);
};

});

parcelRegister("eWSU1", function(module, exports) {

$parcel$export(module.exports, "L", () => $ae2111ff9b283820$export$61196ced6d74a310, (v) => $ae2111ff9b283820$export$61196ced6d74a310 = v);
$parcel$export(module.exports, "M", () => $ae2111ff9b283820$export$3a1a48c8f6ef640e, (v) => $ae2111ff9b283820$export$3a1a48c8f6ef640e = v);
$parcel$export(module.exports, "Q", () => $ae2111ff9b283820$export$3722cfe417b6ed86, (v) => $ae2111ff9b283820$export$3722cfe417b6ed86 = v);
$parcel$export(module.exports, "H", () => $ae2111ff9b283820$export$7f8ddf7c7c20b3cd, (v) => $ae2111ff9b283820$export$7f8ddf7c7c20b3cd = v);
$parcel$export(module.exports, "isValid", () => $ae2111ff9b283820$export$1ea939691cdc45b8, (v) => $ae2111ff9b283820$export$1ea939691cdc45b8 = v);
$parcel$export(module.exports, "from", () => $ae2111ff9b283820$export$6788812c4e6611e6, (v) => $ae2111ff9b283820$export$6788812c4e6611e6 = v);
var $ae2111ff9b283820$export$61196ced6d74a310;
var $ae2111ff9b283820$export$3a1a48c8f6ef640e;
var $ae2111ff9b283820$export$3722cfe417b6ed86;
var $ae2111ff9b283820$export$7f8ddf7c7c20b3cd;
var $ae2111ff9b283820$export$1ea939691cdc45b8;
var $ae2111ff9b283820$export$6788812c4e6611e6;
$ae2111ff9b283820$export$61196ced6d74a310 = {
    bit: 1
};
$ae2111ff9b283820$export$3a1a48c8f6ef640e = {
    bit: 0
};
$ae2111ff9b283820$export$3722cfe417b6ed86 = {
    bit: 3
};
$ae2111ff9b283820$export$7f8ddf7c7c20b3cd = {
    bit: 2
};
function $ae2111ff9b283820$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "l":
        case "low":
            return $ae2111ff9b283820$export$61196ced6d74a310;
        case "m":
        case "medium":
            return $ae2111ff9b283820$export$3a1a48c8f6ef640e;
        case "q":
        case "quartile":
            return $ae2111ff9b283820$export$3722cfe417b6ed86;
        case "h":
        case "high":
            return $ae2111ff9b283820$export$7f8ddf7c7c20b3cd;
        default:
            throw new Error("Unknown EC Level: " + string);
    }
}
$ae2111ff9b283820$export$1ea939691cdc45b8 = function isValid(level) {
    return level && typeof level.bit !== "undefined" && level.bit >= 0 && level.bit < 4;
};
$ae2111ff9b283820$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($ae2111ff9b283820$export$1ea939691cdc45b8(value)) return value;
    try {
        return $ae2111ff9b283820$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};

});

parcelRegister("3j2Nu", function(module, exports) {
function $268550e9e4e1c954$var$BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$268550e9e4e1c954$var$BitBuffer.prototype = {
    get: function(index) {
        const bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(let i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
module.exports = $268550e9e4e1c954$var$BitBuffer;

});

parcelRegister("8kWmG", function(module, exports) {
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function $611d770b3982bf30$var$BitMatrix(size) {
    if (!size || size < 1) throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ $611d770b3982bf30$var$BitMatrix.prototype.set = function(row, col, value, reserved) {
    const index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ $611d770b3982bf30$var$BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ $611d770b3982bf30$var$BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ $611d770b3982bf30$var$BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
module.exports = $611d770b3982bf30$var$BitMatrix;

});

parcelRegister("f3KBx", function(module, exports) {

$parcel$export(module.exports, "getRowColCoords", () => $af6b4985c6fad587$export$cb05537eb8e57a83, (v) => $af6b4985c6fad587$export$cb05537eb8e57a83 = v);
$parcel$export(module.exports, "getPositions", () => $af6b4985c6fad587$export$c39457c570f2b189, (v) => $af6b4985c6fad587$export$c39457c570f2b189 = v);
/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ /**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ var $af6b4985c6fad587$export$cb05537eb8e57a83;
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $af6b4985c6fad587$export$c39457c570f2b189;

var $fIeXC = parcelRequire("fIeXC");
var $af6b4985c6fad587$require$getSymbolSize = $fIeXC.getSymbolSize;
$af6b4985c6fad587$export$cb05537eb8e57a83 = function getRowColCoords(version) {
    if (version === 1) return [];
    const posCount = Math.floor(version / 7) + 2;
    const size = $af6b4985c6fad587$require$getSymbolSize(version);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(let i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
$af6b4985c6fad587$export$c39457c570f2b189 = function getPositions(version) {
    const coords = [];
    const pos = $af6b4985c6fad587$export$cb05537eb8e57a83(version);
    const posLength = pos.length;
    for(let i = 0; i < posLength; i++)for(let j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};

});

parcelRegister("fvVQq", function(module, exports) {

$parcel$export(module.exports, "getPositions", () => $b4b69eff54e896c1$export$c39457c570f2b189, (v) => $b4b69eff54e896c1$export$c39457c570f2b189 = v);
/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $b4b69eff54e896c1$export$c39457c570f2b189;

var $fIeXC = parcelRequire("fIeXC");
var $b4b69eff54e896c1$require$getSymbolSize = $fIeXC.getSymbolSize;
const $b4b69eff54e896c1$var$FINDER_PATTERN_SIZE = 7;
$b4b69eff54e896c1$export$c39457c570f2b189 = function getPositions(version) {
    const size = $b4b69eff54e896c1$require$getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - $b4b69eff54e896c1$var$FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - $b4b69eff54e896c1$var$FINDER_PATTERN_SIZE
        ]
    ];
};

});

parcelRegister("jfjGb", function(module, exports) {

$parcel$export(module.exports, "Patterns", () => $e02eaef99ff1f1c3$export$7ed115685df827af, (v) => $e02eaef99ff1f1c3$export$7ed115685df827af = v);
$parcel$export(module.exports, "isValid", () => $e02eaef99ff1f1c3$export$1ea939691cdc45b8, (v) => $e02eaef99ff1f1c3$export$1ea939691cdc45b8 = v);
$parcel$export(module.exports, "from", () => $e02eaef99ff1f1c3$export$6788812c4e6611e6, (v) => $e02eaef99ff1f1c3$export$6788812c4e6611e6 = v);
$parcel$export(module.exports, "getPenaltyN1", () => $e02eaef99ff1f1c3$export$a5fd3a02c14d0b3e, (v) => $e02eaef99ff1f1c3$export$a5fd3a02c14d0b3e = v);
$parcel$export(module.exports, "getPenaltyN2", () => $e02eaef99ff1f1c3$export$9a9385107a518e46, (v) => $e02eaef99ff1f1c3$export$9a9385107a518e46 = v);
$parcel$export(module.exports, "getPenaltyN3", () => $e02eaef99ff1f1c3$export$ade754353f0dc75e, (v) => $e02eaef99ff1f1c3$export$ade754353f0dc75e = v);
$parcel$export(module.exports, "getPenaltyN4", () => $e02eaef99ff1f1c3$export$3ff6f04d40d9962b, (v) => $e02eaef99ff1f1c3$export$3ff6f04d40d9962b = v);
$parcel$export(module.exports, "applyMask", () => $e02eaef99ff1f1c3$export$a1c9aa9c0e8ba394, (v) => $e02eaef99ff1f1c3$export$a1c9aa9c0e8ba394 = v);
$parcel$export(module.exports, "getBestMask", () => $e02eaef99ff1f1c3$export$fe9625aaceb0e563, (v) => $e02eaef99ff1f1c3$export$fe9625aaceb0e563 = v);
/**
 * Data mask pattern reference
 * @type {Object}
 */ var $e02eaef99ff1f1c3$export$7ed115685df827af;
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ var $e02eaef99ff1f1c3$export$1ea939691cdc45b8;
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ var $e02eaef99ff1f1c3$export$6788812c4e6611e6;
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ var $e02eaef99ff1f1c3$export$a5fd3a02c14d0b3e;
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ var $e02eaef99ff1f1c3$export$9a9385107a518e46;
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ var $e02eaef99ff1f1c3$export$ade754353f0dc75e;
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ var $e02eaef99ff1f1c3$export$3ff6f04d40d9962b;
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ var $e02eaef99ff1f1c3$export$a1c9aa9c0e8ba394;
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ var $e02eaef99ff1f1c3$export$fe9625aaceb0e563;
$e02eaef99ff1f1c3$export$7ed115685df827af = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ const $e02eaef99ff1f1c3$var$PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
$e02eaef99ff1f1c3$export$1ea939691cdc45b8 = function isValid(mask) {
    return mask != null && mask !== "" && !isNaN(mask) && mask >= 0 && mask <= 7;
};
$e02eaef99ff1f1c3$export$6788812c4e6611e6 = function from(value) {
    return $e02eaef99ff1f1c3$export$1ea939691cdc45b8(value) ? parseInt(value, 10) : undefined;
};
$e02eaef99ff1f1c3$export$a5fd3a02c14d0b3e = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for(let row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(let col = 0; col < size; col++){
            let module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += $e02eaef99ff1f1c3$var$PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += $e02eaef99ff1f1c3$var$PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += $e02eaef99ff1f1c3$var$PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += $e02eaef99ff1f1c3$var$PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
$e02eaef99ff1f1c3$export$9a9385107a518e46 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for(let row = 0; row < size - 1; row++)for(let col = 0; col < size - 1; col++){
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * $e02eaef99ff1f1c3$var$PenaltyScores.N2;
};
$e02eaef99ff1f1c3$export$ade754353f0dc75e = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for(let row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(let col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * $e02eaef99ff1f1c3$var$PenaltyScores.N3;
};
$e02eaef99ff1f1c3$export$3ff6f04d40d9962b = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for(let i = 0; i < modulesCount; i++)darkCount += data.data[i];
    const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * $e02eaef99ff1f1c3$var$PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function $e02eaef99ff1f1c3$var$getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case $e02eaef99ff1f1c3$export$7ed115685df827af.PATTERN000:
            return (i + j) % 2 === 0;
        case $e02eaef99ff1f1c3$export$7ed115685df827af.PATTERN001:
            return i % 2 === 0;
        case $e02eaef99ff1f1c3$export$7ed115685df827af.PATTERN010:
            return j % 3 === 0;
        case $e02eaef99ff1f1c3$export$7ed115685df827af.PATTERN011:
            return (i + j) % 3 === 0;
        case $e02eaef99ff1f1c3$export$7ed115685df827af.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case $e02eaef99ff1f1c3$export$7ed115685df827af.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case $e02eaef99ff1f1c3$export$7ed115685df827af.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case $e02eaef99ff1f1c3$export$7ed115685df827af.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error("bad maskPattern:" + maskPattern);
    }
}
$e02eaef99ff1f1c3$export$a1c9aa9c0e8ba394 = function applyMask(pattern, data) {
    const size = data.size;
    for(let col = 0; col < size; col++)for(let row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, $e02eaef99ff1f1c3$var$getMaskAt(pattern, row, col));
    }
};
$e02eaef99ff1f1c3$export$fe9625aaceb0e563 = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys($e02eaef99ff1f1c3$export$7ed115685df827af).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for(let p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        $e02eaef99ff1f1c3$export$a1c9aa9c0e8ba394(p, data);
        // Calculate penalty
        const penalty = $e02eaef99ff1f1c3$export$a5fd3a02c14d0b3e(data) + $e02eaef99ff1f1c3$export$9a9385107a518e46(data) + $e02eaef99ff1f1c3$export$ade754353f0dc75e(data) + $e02eaef99ff1f1c3$export$3ff6f04d40d9962b(data);
        // Undo previously applied mask
        $e02eaef99ff1f1c3$export$a1c9aa9c0e8ba394(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};

});

parcelRegister("1r3vy", function(module, exports) {

$parcel$export(module.exports, "getBlocksCount", () => $10bb08af107de356$export$41a1fc627aca72b9, (v) => $10bb08af107de356$export$41a1fc627aca72b9 = v);
$parcel$export(module.exports, "getTotalCodewordsCount", () => $10bb08af107de356$export$683d1b3e8a1a8438, (v) => $10bb08af107de356$export$683d1b3e8a1a8438 = v);
/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ var $10bb08af107de356$export$41a1fc627aca72b9;
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ var $10bb08af107de356$export$683d1b3e8a1a8438;

var $eWSU1 = parcelRequire("eWSU1");
const $10bb08af107de356$var$EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
const $10bb08af107de356$var$EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$10bb08af107de356$export$41a1fc627aca72b9 = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $eWSU1.L:
            return $10bb08af107de356$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case $eWSU1.M:
            return $10bb08af107de356$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case $eWSU1.Q:
            return $10bb08af107de356$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case $eWSU1.H:
            return $10bb08af107de356$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$10bb08af107de356$export$683d1b3e8a1a8438 = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $eWSU1.L:
            return $10bb08af107de356$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case $eWSU1.M:
            return $10bb08af107de356$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case $eWSU1.Q:
            return $10bb08af107de356$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case $eWSU1.H:
            return $10bb08af107de356$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};

});

parcelRegister("cLXV6", function(module, exports) {

var $59KWI = parcelRequire("59KWI");
function $94c85ab25a5f9e64$var$ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ $94c85ab25a5f9e64$var$ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = $59KWI.generateECPolynomial(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ $94c85ab25a5f9e64$var$ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error("Encoder not initialized");
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    const paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    const remainder = $59KWI.mod(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    const start = this.degree - remainder.length;
    if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
module.exports = $94c85ab25a5f9e64$var$ReedSolomonEncoder;

});
parcelRegister("59KWI", function(module, exports) {

$parcel$export(module.exports, "mul", () => $3c123581a85c5707$export$6e3a27864ab166fe, (v) => $3c123581a85c5707$export$6e3a27864ab166fe = v);
$parcel$export(module.exports, "mod", () => $3c123581a85c5707$export$842a2cf37af977e1, (v) => $3c123581a85c5707$export$842a2cf37af977e1 = v);
$parcel$export(module.exports, "generateECPolynomial", () => $3c123581a85c5707$export$7b8be06a973a9d05, (v) => $3c123581a85c5707$export$7b8be06a973a9d05 = v);
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ var $3c123581a85c5707$export$6e3a27864ab166fe;
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ var $3c123581a85c5707$export$842a2cf37af977e1;
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ var $3c123581a85c5707$export$7b8be06a973a9d05;

var $5a55M = parcelRequire("5a55M");
$3c123581a85c5707$export$6e3a27864ab166fe = function mul(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for(let i = 0; i < p1.length; i++)for(let j = 0; j < p2.length; j++)coeff[i + j] ^= $5a55M.mul(p1[i], p2[j]);
    return coeff;
};
$3c123581a85c5707$export$842a2cf37af977e1 = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        const coeff = result[0];
        for(let i = 0; i < divisor.length; i++)result[i] ^= $5a55M.mul(divisor[i], coeff);
        // remove all zeros from buffer head
        let offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
$3c123581a85c5707$export$7b8be06a973a9d05 = function generateECPolynomial(degree) {
    let poly = new Uint8Array([
        1
    ]);
    for(let i = 0; i < degree; i++)poly = $3c123581a85c5707$export$6e3a27864ab166fe(poly, new Uint8Array([
        1,
        $5a55M.exp(i)
    ]));
    return poly;
};

});
parcelRegister("5a55M", function(module, exports) {

$parcel$export(module.exports, "exp", () => $3c21d61fea1ac8ac$export$b310ec824aaee37f, (v) => $3c21d61fea1ac8ac$export$b310ec824aaee37f = v);
$parcel$export(module.exports, "mul", () => $3c21d61fea1ac8ac$export$6e3a27864ab166fe, (v) => $3c21d61fea1ac8ac$export$6e3a27864ab166fe = v);
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $3c21d61fea1ac8ac$export$bef1f36f5486a6a3;
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $3c21d61fea1ac8ac$export$b310ec824aaee37f;
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ var $3c21d61fea1ac8ac$export$6e3a27864ab166fe;
const $3c21d61fea1ac8ac$var$EXP_TABLE = new Uint8Array(512);
const $3c21d61fea1ac8ac$var$LOG_TABLE = new Uint8Array(256) /**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */ ;
(function initTables() {
    let x = 1;
    for(let i = 0; i < 255; i++){
        $3c21d61fea1ac8ac$var$EXP_TABLE[i] = x;
        $3c21d61fea1ac8ac$var$LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(let i = 255; i < 512; i++)$3c21d61fea1ac8ac$var$EXP_TABLE[i] = $3c21d61fea1ac8ac$var$EXP_TABLE[i - 255];
})();
$3c21d61fea1ac8ac$export$bef1f36f5486a6a3 = function log(n) {
    if (n < 1) throw new Error("log(" + n + ")");
    return $3c21d61fea1ac8ac$var$LOG_TABLE[n];
};
$3c21d61fea1ac8ac$export$b310ec824aaee37f = function exp(n) {
    return $3c21d61fea1ac8ac$var$EXP_TABLE[n];
};
$3c21d61fea1ac8ac$export$6e3a27864ab166fe = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return $3c21d61fea1ac8ac$var$EXP_TABLE[$3c21d61fea1ac8ac$var$LOG_TABLE[x] + $3c21d61fea1ac8ac$var$LOG_TABLE[y]];
};

});



parcelRegister("akldy", function(module, exports) {

$parcel$export(module.exports, "getCapacity", () => $784c3b018ec5af32$export$55b283886ec2d3fb, (v) => $784c3b018ec5af32$export$55b283886ec2d3fb = v);
$parcel$export(module.exports, "from", () => $784c3b018ec5af32$export$6788812c4e6611e6, (v) => $784c3b018ec5af32$export$6788812c4e6611e6 = v);
$parcel$export(module.exports, "getBestVersionForData", () => $784c3b018ec5af32$export$264e969aa7a8ff7e, (v) => $784c3b018ec5af32$export$264e969aa7a8ff7e = v);
$parcel$export(module.exports, "getEncodedBits", () => $784c3b018ec5af32$export$eee5438974ef6f0e, (v) => $784c3b018ec5af32$export$eee5438974ef6f0e = v);
/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ var $784c3b018ec5af32$export$6788812c4e6611e6;
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ var $784c3b018ec5af32$export$55b283886ec2d3fb;
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ var $784c3b018ec5af32$export$264e969aa7a8ff7e;
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ var $784c3b018ec5af32$export$eee5438974ef6f0e;

var $fIeXC = parcelRequire("fIeXC");

var $1r3vy = parcelRequire("1r3vy");

var $eWSU1 = parcelRequire("eWSU1");

var $7DYQI = parcelRequire("7DYQI");

var $9goVx = parcelRequire("9goVx");
// Generator polynomial used to encode version information
const $784c3b018ec5af32$var$G18 = 7973;
const $784c3b018ec5af32$var$G18_BCH = $fIeXC.getBCHDigit($784c3b018ec5af32$var$G18);
function $784c3b018ec5af32$var$getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= $784c3b018ec5af32$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function $784c3b018ec5af32$var$getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return $7DYQI.getCharCountIndicator(mode, version) + 4;
}
function $784c3b018ec5af32$var$getTotalBitsFromDataArray(segments, version) {
    let totalBits = 0;
    segments.forEach(function(data) {
        const reservedBits = $784c3b018ec5af32$var$getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function $784c3b018ec5af32$var$getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        const length = $784c3b018ec5af32$var$getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= $784c3b018ec5af32$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, $7DYQI.MIXED)) return currentVersion;
    }
    return undefined;
}
$784c3b018ec5af32$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($9goVx.isValid(value)) return parseInt(value, 10);
    return defaultValue;
};
$784c3b018ec5af32$export$55b283886ec2d3fb = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!$9goVx.isValid(version)) throw new Error("Invalid QR Code version");
    // Use Byte mode as default
    if (typeof mode === "undefined") mode = $7DYQI.BYTE;
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $fIeXC.getSymbolTotalCodewords(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $1r3vy.getTotalCodewordsCount(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === $7DYQI.MIXED) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - $784c3b018ec5af32$var$getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case $7DYQI.NUMERIC:
            return Math.floor(usableBits / 10 * 3);
        case $7DYQI.ALPHANUMERIC:
            return Math.floor(usableBits / 11 * 2);
        case $7DYQI.KANJI:
            return Math.floor(usableBits / 13);
        case $7DYQI.BYTE:
        default:
            return Math.floor(usableBits / 8);
    }
};
$784c3b018ec5af32$export$264e969aa7a8ff7e = function getBestVersionForData(data, errorCorrectionLevel) {
    let seg;
    const ecl = $eWSU1.from(errorCorrectionLevel, $eWSU1.M);
    if (Array.isArray(data)) {
        if (data.length > 1) return $784c3b018ec5af32$var$getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return $784c3b018ec5af32$var$getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
$784c3b018ec5af32$export$eee5438974ef6f0e = function getEncodedBits(version) {
    if (!$9goVx.isValid(version) || version < 7) throw new Error("Invalid QR Code version");
    let d = version << 12;
    while($fIeXC.getBCHDigit(d) - $784c3b018ec5af32$var$G18_BCH >= 0)d ^= $784c3b018ec5af32$var$G18 << $fIeXC.getBCHDigit(d) - $784c3b018ec5af32$var$G18_BCH;
    return version << 12 | d;
};

});
parcelRegister("7DYQI", function(module, exports) {

$parcel$export(module.exports, "NUMERIC", () => $590b604c72914572$export$4d318981b5a83836, (v) => $590b604c72914572$export$4d318981b5a83836 = v);
$parcel$export(module.exports, "ALPHANUMERIC", () => $590b604c72914572$export$376a9ed239d6c1c8, (v) => $590b604c72914572$export$376a9ed239d6c1c8 = v);
$parcel$export(module.exports, "BYTE", () => $590b604c72914572$export$8f4bf8f7eb581284, (v) => $590b604c72914572$export$8f4bf8f7eb581284 = v);
$parcel$export(module.exports, "KANJI", () => $590b604c72914572$export$a4d452c2363c8e12, (v) => $590b604c72914572$export$a4d452c2363c8e12 = v);
$parcel$export(module.exports, "MIXED", () => $590b604c72914572$export$bb410559a65d3418, (v) => $590b604c72914572$export$bb410559a65d3418 = v);
$parcel$export(module.exports, "getCharCountIndicator", () => $590b604c72914572$export$e79764af6ffaeb8d, (v) => $590b604c72914572$export$e79764af6ffaeb8d = v);
$parcel$export(module.exports, "getBestModeForData", () => $590b604c72914572$export$1bd4c93ffb42e55e, (v) => $590b604c72914572$export$1bd4c93ffb42e55e = v);
$parcel$export(module.exports, "toString", () => $590b604c72914572$export$f84e8e69fd4488a5, (v) => $590b604c72914572$export$f84e8e69fd4488a5 = v);
$parcel$export(module.exports, "isValid", () => $590b604c72914572$export$1ea939691cdc45b8, (v) => $590b604c72914572$export$1ea939691cdc45b8 = v);
$parcel$export(module.exports, "from", () => $590b604c72914572$export$6788812c4e6611e6, (v) => $590b604c72914572$export$6788812c4e6611e6 = v);
/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ var $590b604c72914572$export$4d318981b5a83836;
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ var $590b604c72914572$export$376a9ed239d6c1c8;
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ var $590b604c72914572$export$8f4bf8f7eb581284;
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ var $590b604c72914572$export$a4d452c2363c8e12;
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ var $590b604c72914572$export$bb410559a65d3418;
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ var $590b604c72914572$export$e79764af6ffaeb8d;
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ var $590b604c72914572$export$1bd4c93ffb42e55e;
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ var $590b604c72914572$export$f84e8e69fd4488a5;
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ var $590b604c72914572$export$1ea939691cdc45b8;
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ var $590b604c72914572$export$6788812c4e6611e6;

var $9goVx = parcelRequire("9goVx");

var $kpsfg = parcelRequire("kpsfg");
$590b604c72914572$export$4d318981b5a83836 = {
    id: "Numeric",
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
$590b604c72914572$export$376a9ed239d6c1c8 = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
$590b604c72914572$export$8f4bf8f7eb581284 = {
    id: "Byte",
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
$590b604c72914572$export$a4d452c2363c8e12 = {
    id: "Kanji",
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
$590b604c72914572$export$bb410559a65d3418 = {
    bit: -1
};
$590b604c72914572$export$e79764af6ffaeb8d = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error("Invalid mode: " + mode);
    if (!$9goVx.isValid(version)) throw new Error("Invalid version: " + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
$590b604c72914572$export$1bd4c93ffb42e55e = function getBestModeForData(dataStr) {
    if ($kpsfg.testNumeric(dataStr)) return $590b604c72914572$export$4d318981b5a83836;
    else if ($kpsfg.testAlphanumeric(dataStr)) return $590b604c72914572$export$376a9ed239d6c1c8;
    else if ($kpsfg.testKanji(dataStr)) return $590b604c72914572$export$a4d452c2363c8e12;
    else return $590b604c72914572$export$8f4bf8f7eb581284;
};
$590b604c72914572$export$f84e8e69fd4488a5 = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error("Invalid mode");
};
$590b604c72914572$export$1ea939691cdc45b8 = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function $590b604c72914572$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "numeric":
            return $590b604c72914572$export$4d318981b5a83836;
        case "alphanumeric":
            return $590b604c72914572$export$376a9ed239d6c1c8;
        case "kanji":
            return $590b604c72914572$export$a4d452c2363c8e12;
        case "byte":
            return $590b604c72914572$export$8f4bf8f7eb581284;
        default:
            throw new Error("Unknown mode: " + string);
    }
}
$590b604c72914572$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($590b604c72914572$export$1ea939691cdc45b8(value)) return value;
    try {
        return $590b604c72914572$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};

});
parcelRegister("9goVx", function(module, exports) {

$parcel$export(module.exports, "isValid", () => $6be8f1a60adec9c7$export$1ea939691cdc45b8, (v) => $6be8f1a60adec9c7$export$1ea939691cdc45b8 = v);
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ var $6be8f1a60adec9c7$export$1ea939691cdc45b8;
$6be8f1a60adec9c7$export$1ea939691cdc45b8 = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};

});

parcelRegister("kpsfg", function(module, exports) {

$parcel$export(module.exports, "KANJI", () => $edbc0d5a184a4f48$export$a4d452c2363c8e12, (v) => $edbc0d5a184a4f48$export$a4d452c2363c8e12 = v);
$parcel$export(module.exports, "BYTE_KANJI", () => $edbc0d5a184a4f48$export$9df7c29d562bab83, (v) => $edbc0d5a184a4f48$export$9df7c29d562bab83 = v);
$parcel$export(module.exports, "BYTE", () => $edbc0d5a184a4f48$export$8f4bf8f7eb581284, (v) => $edbc0d5a184a4f48$export$8f4bf8f7eb581284 = v);
$parcel$export(module.exports, "NUMERIC", () => $edbc0d5a184a4f48$export$4d318981b5a83836, (v) => $edbc0d5a184a4f48$export$4d318981b5a83836 = v);
$parcel$export(module.exports, "ALPHANUMERIC", () => $edbc0d5a184a4f48$export$376a9ed239d6c1c8, (v) => $edbc0d5a184a4f48$export$376a9ed239d6c1c8 = v);
$parcel$export(module.exports, "testKanji", () => $edbc0d5a184a4f48$export$175f16aef75a4569, (v) => $edbc0d5a184a4f48$export$175f16aef75a4569 = v);
$parcel$export(module.exports, "testNumeric", () => $edbc0d5a184a4f48$export$50b7f9bf92c74274, (v) => $edbc0d5a184a4f48$export$50b7f9bf92c74274 = v);
$parcel$export(module.exports, "testAlphanumeric", () => $edbc0d5a184a4f48$export$4ba5f52893b4ac97, (v) => $edbc0d5a184a4f48$export$4ba5f52893b4ac97 = v);
var $edbc0d5a184a4f48$export$a4d452c2363c8e12;
var $edbc0d5a184a4f48$export$9df7c29d562bab83;
var $edbc0d5a184a4f48$export$8f4bf8f7eb581284;
var $edbc0d5a184a4f48$export$4d318981b5a83836;
var $edbc0d5a184a4f48$export$376a9ed239d6c1c8;
var $edbc0d5a184a4f48$export$175f16aef75a4569;
var $edbc0d5a184a4f48$export$50b7f9bf92c74274;
var $edbc0d5a184a4f48$export$4ba5f52893b4ac97;
const $edbc0d5a184a4f48$var$numeric = "[0-9]+";
const $edbc0d5a184a4f48$var$alphanumeric = "[A-Z $%*+\\-./:]+";
let $edbc0d5a184a4f48$var$kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$edbc0d5a184a4f48$var$kanji = $edbc0d5a184a4f48$var$kanji.replace(/u/g, "\\u");
const $edbc0d5a184a4f48$var$byte = "(?:(?![A-Z0-9 $%*+\\-./:]|" + $edbc0d5a184a4f48$var$kanji + ")(?:.|[\r\n]))+";
$edbc0d5a184a4f48$export$a4d452c2363c8e12 = new RegExp($edbc0d5a184a4f48$var$kanji, "g");
$edbc0d5a184a4f48$export$9df7c29d562bab83 = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
$edbc0d5a184a4f48$export$8f4bf8f7eb581284 = new RegExp($edbc0d5a184a4f48$var$byte, "g");
$edbc0d5a184a4f48$export$4d318981b5a83836 = new RegExp($edbc0d5a184a4f48$var$numeric, "g");
$edbc0d5a184a4f48$export$376a9ed239d6c1c8 = new RegExp($edbc0d5a184a4f48$var$alphanumeric, "g");
const $edbc0d5a184a4f48$var$TEST_KANJI = new RegExp("^" + $edbc0d5a184a4f48$var$kanji + "$");
const $edbc0d5a184a4f48$var$TEST_NUMERIC = new RegExp("^" + $edbc0d5a184a4f48$var$numeric + "$");
const $edbc0d5a184a4f48$var$TEST_ALPHANUMERIC = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
$edbc0d5a184a4f48$export$175f16aef75a4569 = function testKanji(str) {
    return $edbc0d5a184a4f48$var$TEST_KANJI.test(str);
};
$edbc0d5a184a4f48$export$50b7f9bf92c74274 = function testNumeric(str) {
    return $edbc0d5a184a4f48$var$TEST_NUMERIC.test(str);
};
$edbc0d5a184a4f48$export$4ba5f52893b4ac97 = function testAlphanumeric(str) {
    return $edbc0d5a184a4f48$var$TEST_ALPHANUMERIC.test(str);
};

});



parcelRegister("b2LbR", function(module, exports) {

$parcel$export(module.exports, "getEncodedBits", () => $80a47ca238ade8a6$export$eee5438974ef6f0e, (v) => $80a47ca238ade8a6$export$eee5438974ef6f0e = v);
/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ var $80a47ca238ade8a6$export$eee5438974ef6f0e;

var $fIeXC = parcelRequire("fIeXC");
const $80a47ca238ade8a6$var$G15 = 1335;
const $80a47ca238ade8a6$var$G15_MASK = 21522;
const $80a47ca238ade8a6$var$G15_BCH = $fIeXC.getBCHDigit($80a47ca238ade8a6$var$G15);
$80a47ca238ade8a6$export$eee5438974ef6f0e = function getEncodedBits(errorCorrectionLevel, mask) {
    const data = errorCorrectionLevel.bit << 3 | mask;
    let d = data << 10;
    while($fIeXC.getBCHDigit(d) - $80a47ca238ade8a6$var$G15_BCH >= 0)d ^= $80a47ca238ade8a6$var$G15 << $fIeXC.getBCHDigit(d) - $80a47ca238ade8a6$var$G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ $80a47ca238ade8a6$var$G15_MASK;
};

});

parcelRegister("cKo59", function(module, exports) {

$parcel$export(module.exports, "fromArray", () => $947c76183f25b799$export$571d59b505e6bb4e, (v) => $947c76183f25b799$export$571d59b505e6bb4e = v);
$parcel$export(module.exports, "fromString", () => $947c76183f25b799$export$3004f64547af360e, (v) => $947c76183f25b799$export$3004f64547af360e = v);
$parcel$export(module.exports, "rawSplit", () => $947c76183f25b799$export$89ab1afb9839589b, (v) => $947c76183f25b799$export$89ab1afb9839589b = v);
/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ var $947c76183f25b799$export$571d59b505e6bb4e;
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ var $947c76183f25b799$export$3004f64547af360e;
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ var $947c76183f25b799$export$89ab1afb9839589b;

var $7DYQI = parcelRequire("7DYQI");

var $feRof = parcelRequire("feRof");

var $f1IGQ = parcelRequire("f1IGQ");

var $3CMFN = parcelRequire("3CMFN");

var $6NTOJ = parcelRequire("6NTOJ");

var $kpsfg = parcelRequire("kpsfg");

var $fIeXC = parcelRequire("fIeXC");

var $ab0mb = parcelRequire("ab0mb");
/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function $947c76183f25b799$var$getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function $947c76183f25b799$var$getSegments(regex, mode, str) {
    const segments = [];
    let result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function $947c76183f25b799$var$getSegmentsFromString(dataStr) {
    const numSegs = $947c76183f25b799$var$getSegments($kpsfg.NUMERIC, $7DYQI.NUMERIC, dataStr);
    const alphaNumSegs = $947c76183f25b799$var$getSegments($kpsfg.ALPHANUMERIC, $7DYQI.ALPHANUMERIC, dataStr);
    let byteSegs;
    let kanjiSegs;
    if ($fIeXC.isKanjiModeEnabled()) {
        byteSegs = $947c76183f25b799$var$getSegments($kpsfg.BYTE, $7DYQI.BYTE, dataStr);
        kanjiSegs = $947c76183f25b799$var$getSegments($kpsfg.KANJI, $7DYQI.KANJI, dataStr);
    } else {
        byteSegs = $947c76183f25b799$var$getSegments($kpsfg.BYTE_KANJI, $7DYQI.BYTE, dataStr);
        kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function $947c76183f25b799$var$getSegmentBitsLength(length, mode) {
    switch(mode){
        case $7DYQI.NUMERIC:
            return $feRof.getBitsLength(length);
        case $7DYQI.ALPHANUMERIC:
            return $f1IGQ.getBitsLength(length);
        case $7DYQI.KANJI:
            return $6NTOJ.getBitsLength(length);
        case $7DYQI.BYTE:
            return $3CMFN.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $947c76183f25b799$var$mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $947c76183f25b799$var$buildNodes(segs) {
    const nodes = [];
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        switch(seg.mode){
            case $7DYQI.NUMERIC:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $7DYQI.ALPHANUMERIC,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: $7DYQI.BYTE,
                        length: seg.length
                    }
                ]);
                break;
            case $7DYQI.ALPHANUMERIC:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $7DYQI.BYTE,
                        length: seg.length
                    }
                ]);
                break;
            case $7DYQI.KANJI:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $7DYQI.BYTE,
                        length: $947c76183f25b799$var$getStringByteLength(seg.data)
                    }
                ]);
                break;
            case $7DYQI.BYTE:
                nodes.push([
                    {
                        data: seg.data,
                        mode: $7DYQI.BYTE,
                        length: $947c76183f25b799$var$getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function $947c76183f25b799$var$buildGraph(nodes, version) {
    const table = {};
    const graph = {
        start: {}
    };
    let prevNodeIds = [
        "start"
    ];
    for(let i = 0; i < nodes.length; i++){
        const nodeGroup = nodes[i];
        const currentNodeIds = [];
        for(let j = 0; j < nodeGroup.length; j++){
            const node = nodeGroup[j];
            const key = "" + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(let n = 0; n < prevNodeIds.length; n++){
                const prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = $947c76183f25b799$var$getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - $947c76183f25b799$var$getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = $947c76183f25b799$var$getSegmentBitsLength(node.length, node.mode) + 4 + $7DYQI.getCharCountIndicator(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(let n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function $947c76183f25b799$var$buildSingleSegment(data, modesHint) {
    let mode;
    const bestMode = $7DYQI.getBestModeForData(data);
    mode = $7DYQI.from(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== $7DYQI.BYTE && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + " cannot be encoded with mode " + $7DYQI.toString(mode) + ".\n Suggested mode is: " + $7DYQI.toString(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === $7DYQI.KANJI && !$fIeXC.isKanjiModeEnabled()) mode = $7DYQI.BYTE;
    switch(mode){
        case $7DYQI.NUMERIC:
            return new $feRof(data);
        case $7DYQI.ALPHANUMERIC:
            return new $f1IGQ(data);
        case $7DYQI.KANJI:
            return new $6NTOJ(data);
        case $7DYQI.BYTE:
            return new $3CMFN(data);
    }
}
$947c76183f25b799$export$571d59b505e6bb4e = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === "string") acc.push($947c76183f25b799$var$buildSingleSegment(seg, null));
        else if (seg.data) acc.push($947c76183f25b799$var$buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
$947c76183f25b799$export$3004f64547af360e = function fromString(data, version) {
    const segs = $947c76183f25b799$var$getSegmentsFromString(data, $fIeXC.isKanjiModeEnabled());
    const nodes = $947c76183f25b799$var$buildNodes(segs);
    const graph = $947c76183f25b799$var$buildGraph(nodes, version);
    const path = $ab0mb.find_path(graph.map, "start", "end");
    const optimizedSegs = [];
    for(let i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return $947c76183f25b799$export$571d59b505e6bb4e($947c76183f25b799$var$mergeSegments(optimizedSegs));
};
$947c76183f25b799$export$89ab1afb9839589b = function rawSplit(data) {
    return $947c76183f25b799$export$571d59b505e6bb4e($947c76183f25b799$var$getSegmentsFromString(data, $fIeXC.isKanjiModeEnabled()));
};

});
parcelRegister("feRof", function(module, exports) {

var $7DYQI = parcelRequire("7DYQI");
function $b18193fcb1c3432a$var$NumericData(data) {
    this.mode = $7DYQI.NUMERIC;
    this.data = data.toString();
}
$b18193fcb1c3432a$var$NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
$b18193fcb1c3432a$var$NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$b18193fcb1c3432a$var$NumericData.prototype.getBitsLength = function getBitsLength() {
    return $b18193fcb1c3432a$var$NumericData.getBitsLength(this.data.length);
};
$b18193fcb1c3432a$var$NumericData.prototype.write = function write(bitBuffer) {
    let i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    const remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
module.exports = $b18193fcb1c3432a$var$NumericData;

});

parcelRegister("f1IGQ", function(module, exports) {

var $7DYQI = parcelRequire("7DYQI");
/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ const $af099d83f9776f94$var$ALPHA_NUM_CHARS = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
];
function $af099d83f9776f94$var$AlphanumericData(data) {
    this.mode = $7DYQI.ALPHANUMERIC;
    this.data = data;
}
$af099d83f9776f94$var$AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
$af099d83f9776f94$var$AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$af099d83f9776f94$var$AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return $af099d83f9776f94$var$AlphanumericData.getBitsLength(this.data.length);
};
$af099d83f9776f94$var$AlphanumericData.prototype.write = function write(bitBuffer) {
    let i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        let value = $af099d83f9776f94$var$ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += $af099d83f9776f94$var$ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put($af099d83f9776f94$var$ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
module.exports = $af099d83f9776f94$var$AlphanumericData;

});

parcelRegister("3CMFN", function(module, exports) {

var $bFuPn = parcelRequire("bFuPn");

var $7DYQI = parcelRequire("7DYQI");
function $2a3aad323c0d5e80$var$ByteData(data) {
    this.mode = $7DYQI.BYTE;
    if (typeof data === "string") data = $bFuPn(data);
    this.data = new Uint8Array(data);
}
$2a3aad323c0d5e80$var$ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
$2a3aad323c0d5e80$var$ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
$2a3aad323c0d5e80$var$ByteData.prototype.getBitsLength = function getBitsLength() {
    return $2a3aad323c0d5e80$var$ByteData.getBitsLength(this.data.length);
};
$2a3aad323c0d5e80$var$ByteData.prototype.write = function(bitBuffer) {
    for(let i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
module.exports = $2a3aad323c0d5e80$var$ByteData;

});
parcelRegister("bFuPn", function(module, exports) {
"use strict";
module.exports = function encodeUtf8(input) {
    var result = [];
    var size = input.length;
    for(var index = 0; index < size; index++){
        var point = input.charCodeAt(index);
        if (point >= 0xD800 && point <= 0xDBFF && size > index + 1) {
            var second = input.charCodeAt(index + 1);
            if (second >= 0xDC00 && second <= 0xDFFF) {
                // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
                point = (point - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
                index += 1;
            }
        }
        // US-ASCII
        if (point < 0x80) {
            result.push(point);
            continue;
        }
        // 2-byte UTF-8
        if (point < 0x800) {
            result.push(point >> 6 | 192);
            result.push(point & 63 | 128);
            continue;
        }
        // 3-byte UTF-8
        if (point < 0xD800 || point >= 0xE000 && point < 0x10000) {
            result.push(point >> 12 | 224);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // 4-byte UTF-8
        if (point >= 0x10000 && point <= 0x10FFFF) {
            result.push(point >> 18 | 240);
            result.push(point >> 12 & 63 | 128);
            result.push(point >> 6 & 63 | 128);
            result.push(point & 63 | 128);
            continue;
        }
        // Invalid character
        result.push(0xEF, 0xBF, 0xBD);
    }
    return new Uint8Array(result).buffer;
};

});


parcelRegister("6NTOJ", function(module, exports) {

var $7DYQI = parcelRequire("7DYQI");

var $fIeXC = parcelRequire("fIeXC");
function $4f429dd0156e56b5$var$KanjiData(data) {
    this.mode = $7DYQI.KANJI;
    this.data = data;
}
$4f429dd0156e56b5$var$KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
$4f429dd0156e56b5$var$KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
$4f429dd0156e56b5$var$KanjiData.prototype.getBitsLength = function getBitsLength() {
    return $4f429dd0156e56b5$var$KanjiData.getBitsLength(this.data.length);
};
$4f429dd0156e56b5$var$KanjiData.prototype.write = function(bitBuffer) {
    let i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        let value = $fIeXC.toSJIS(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error("Invalid SJIS character: " + this.data[i] + "\n" + "Make sure your charset is UTF-8");
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
module.exports = $4f429dd0156e56b5$var$KanjiData;

});

parcelRegister("ab0mb", function(module, exports) {
"use strict";
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var $768b354dd3fe149e$var$dijkstra = {
    single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = $768b354dd3fe149e$var$dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === "undefined";
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== "undefined" && typeof costs[d] === "undefined") {
            var msg = [
                "Could not find a path from ",
                s,
                " to ",
                d,
                "."
            ].join("");
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function(graph, s, d) {
        var predecessors = $768b354dd3fe149e$var$dijkstra.single_source_shortest_paths(graph, s, d);
        return $768b354dd3fe149e$var$dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function(opts) {
            var T = $768b354dd3fe149e$var$dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function() {
            return this.queue.shift();
        },
        empty: function() {
            return this.queue.length === 0;
        }
    }
};
module.exports = $768b354dd3fe149e$var$dijkstra;

});



parcelRegister("joGNa", function(module, exports) {

$parcel$export(module.exports, "render", () => $e1f173ce8325e7e1$export$b3890eb0ae9dca99, (v) => $e1f173ce8325e7e1$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "renderToDataURL", () => $e1f173ce8325e7e1$export$c3e5526bbaf70a25, (v) => $e1f173ce8325e7e1$export$c3e5526bbaf70a25 = v);
var $e1f173ce8325e7e1$export$b3890eb0ae9dca99;
var $e1f173ce8325e7e1$export$c3e5526bbaf70a25;

var $9bzCc = parcelRequire("9bzCc");
function $e1f173ce8325e7e1$var$clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + "px";
    canvas.style.width = size + "px";
}
function $e1f173ce8325e7e1$var$getCanvasElement() {
    try {
        return document.createElement("canvas");
    } catch (e) {
        throw new Error("You need to specify a canvas element");
    }
}
$e1f173ce8325e7e1$export$b3890eb0ae9dca99 = function render(qrData, canvas, options) {
    let opts = options;
    let canvasEl = canvas;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = $e1f173ce8325e7e1$var$getCanvasElement();
    opts = $9bzCc.getOptions(opts);
    const size = $9bzCc.getImageWidth(qrData.modules.size, opts);
    const ctx = canvasEl.getContext("2d");
    const image = ctx.createImageData(size, size);
    $9bzCc.qrToImageData(image.data, qrData, opts);
    $e1f173ce8325e7e1$var$clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
$e1f173ce8325e7e1$export$c3e5526bbaf70a25 = function renderToDataURL(qrData, canvas, options) {
    let opts = options;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    const canvasEl = $e1f173ce8325e7e1$export$b3890eb0ae9dca99(qrData, canvas, opts);
    const type = opts.type || "image/png";
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};

});
parcelRegister("9bzCc", function(module, exports) {

$parcel$export(module.exports, "getOptions", () => $6b00c48af8bcb32b$export$d2312e68e1f5ad00, (v) => $6b00c48af8bcb32b$export$d2312e68e1f5ad00 = v);
$parcel$export(module.exports, "getScale", () => $6b00c48af8bcb32b$export$5cdac61cf538712e, (v) => $6b00c48af8bcb32b$export$5cdac61cf538712e = v);
$parcel$export(module.exports, "getImageWidth", () => $6b00c48af8bcb32b$export$c3a1a1f268a8142b, (v) => $6b00c48af8bcb32b$export$c3a1a1f268a8142b = v);
$parcel$export(module.exports, "qrToImageData", () => $6b00c48af8bcb32b$export$83136f57c739c5f3, (v) => $6b00c48af8bcb32b$export$83136f57c739c5f3 = v);
var $6b00c48af8bcb32b$export$d2312e68e1f5ad00;
var $6b00c48af8bcb32b$export$5cdac61cf538712e;
var $6b00c48af8bcb32b$export$c3a1a1f268a8142b;
var $6b00c48af8bcb32b$export$83136f57c739c5f3;
function $6b00c48af8bcb32b$var$hex2rgba(hex) {
    if (typeof hex === "number") hex = hex.toString();
    if (typeof hex !== "string") throw new Error("Color should be defined as hex string");
    let hexCode = hex.slice().replace("#", "").split("");
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error("Invalid hex color: " + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push("F", "F");
    const hexValue = parseInt(hexCode.join(""), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: "#" + hexCode.slice(0, 6).join("")
    };
}
$6b00c48af8bcb32b$export$d2312e68e1f5ad00 = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === "undefined" || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : undefined;
    const scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: $6b00c48af8bcb32b$var$hex2rgba(options.color.dark || "#000000ff"),
            light: $6b00c48af8bcb32b$var$hex2rgba(options.color.light || "#ffffffff")
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
$6b00c48af8bcb32b$export$5cdac61cf538712e = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
$6b00c48af8bcb32b$export$c3a1a1f268a8142b = function getImageWidth(qrSize, opts) {
    const scale = $6b00c48af8bcb32b$export$5cdac61cf538712e(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
$6b00c48af8bcb32b$export$83136f57c739c5f3 = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = $6b00c48af8bcb32b$export$5cdac61cf538712e(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(let i = 0; i < symbolSize; i++)for(let j = 0; j < symbolSize; j++){
        let posDst = (i * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};

});


parcelRegister("blG8i", function(module, exports) {

$parcel$export(module.exports, "render", () => $8432569138beea7c$export$b3890eb0ae9dca99, (v) => $8432569138beea7c$export$b3890eb0ae9dca99 = v);
var $8432569138beea7c$export$b3890eb0ae9dca99;

var $9bzCc = parcelRequire("9bzCc");
function $8432569138beea7c$var$getColorAttrib(color, attrib) {
    const alpha = color.a / 255;
    const str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + " " + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function $8432569138beea7c$var$svgCmd(cmd, x, y) {
    let str = cmd + x;
    if (typeof y !== "undefined") str += " " + y;
    return str;
}
function $8432569138beea7c$var$qrToPath(data, size, margin) {
    let path = "";
    let moveBy = 0;
    let newRow = false;
    let lineLength = 0;
    for(let i = 0; i < data.length; i++){
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? $8432569138beea7c$var$svgCmd("M", col + margin, 0.5 + row + margin) : $8432569138beea7c$var$svgCmd("m", moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += $8432569138beea7c$var$svgCmd("h", lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
$8432569138beea7c$export$b3890eb0ae9dca99 = function render(qrData, options, cb) {
    const opts = $9bzCc.getOptions(options);
    const size = qrData.modules.size;
    const data = qrData.modules.data;
    const qrcodesize = size + opts.margin * 2;
    const bg = !opts.color.light.a ? "" : "<path " + $8432569138beea7c$var$getColorAttrib(opts.color.light, "fill") + ' d="M0 0h' + qrcodesize + "v" + qrcodesize + 'H0z"/>';
    const path = "<path " + $8432569138beea7c$var$getColorAttrib(opts.color.dark, "stroke") + ' d="' + $8432569138beea7c$var$qrToPath(data, size, opts.margin) + '"/>';
    const viewBox = 'viewBox="0 0 ' + qrcodesize + " " + qrcodesize + '"';
    const width = !opts.width ? "" : 'width="' + opts.width + '" height="' + opts.width + '" ';
    const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + "</svg>\n";
    if (typeof cb === "function") cb(null, svgTag);
    return svgTag;
};

});



parcelRegister("l1Gj7", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4ea8250ce583543$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $f4ea8250ce583543$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    position: relative;
    user-select: none;
    display: block;
    overflow: hidden;
    aspect-ratio: 1 / 1;
    width: var(--local-size);
  }

  :host([data-theme='dark']) {
    border-radius: clamp(0px, var(--wui-border-radius-l), 40px);
    background-color: var(--wui-color-inverse-100);
    padding: var(--wui-spacing-l);
  }

  :host([data-theme='light']) {
    box-shadow: 0 0 0 1px var(--wui-color-bg-125);
    background-color: var(--wui-color-bg-125);
  }

  svg:first-child,
  wui-image,
  wui-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
  }

  wui-image {
    width: 25%;
    height: 25%;
    border-radius: var(--wui-border-radius-xs);
  }

  wui-icon {
    width: 100%;
    height: 100%;
    color: #3396ff !important;
    transform: translateY(-50%) translateX(-50%) scale(0.25);
  }
`;

});


parcelRegister("7lEhr", function(module, exports) {

$parcel$export(module.exports, "WuiSearchBar", () => $5599bd602271d1f6$export$208b8ce22c764062);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("9jtxR");
var $hP6Yh = parcelRequire("hP6Yh");
parcelRequire("i1zzT");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");
parcelRequire("rIBsQ");

var $k0n1u = parcelRequire("k0n1u");
var $5599bd602271d1f6$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $5599bd602271d1f6$export$208b8ce22c764062 = class WuiSearchBar extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.inputComponentRef = (0, $hP6Yh.createRef)();
    }
    render() {
        return (0, $i7GIz.html)`
      <wui-input-text
        ${(0, $hP6Yh.ref)(this.inputComponentRef)}
        placeholder="Search wallet"
        icon="search"
        type="search"
        enterKeyHint="search"
        size="sm"
      >
        <wui-input-element @click=${this.clearValue} icon="close"></wui-input-element>
      </wui-input-text>
    `;
    }
    clearValue() {
        const inputComponent = this.inputComponentRef.value;
        const inputElement = inputComponent?.inputElementRef.value;
        if (inputElement) {
            inputElement.value = "";
            inputElement.focus();
            inputElement.dispatchEvent(new Event("input"));
        }
    }
};
$5599bd602271d1f6$export$208b8ce22c764062.styles = [
    (0, $9rwwE.resetStyles),
    (0, $k0n1u.default)
];
$5599bd602271d1f6$export$208b8ce22c764062 = $5599bd602271d1f6$var$__decorate([
    (0, $lkv4o.customElement)("wui-search-bar")
], $5599bd602271d1f6$export$208b8ce22c764062);

});
parcelRegister("k0n1u", function(module, exports) {

$parcel$export(module.exports, "default", () => $e905aaa339333529$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $e905aaa339333529$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    position: relative;
    display: inline-block;
    width: 100%;
  }
`;

});


parcelRegister("iPyoG", function(module, exports) {

$parcel$export(module.exports, "WuiSnackbar", () => $db57abfa89ea79bf$export$864d710a9db8f7a3);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
parcelRequire("eFeuH");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");
parcelRequire("e4QeF");

var $bhgg8 = parcelRequire("bhgg8");
var $db57abfa89ea79bf$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $db57abfa89ea79bf$export$864d710a9db8f7a3 = class WuiSnackbar extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.backgroundColor = "accent-100";
        this.iconColor = "accent-100";
        this.icon = "checkmark";
        this.message = "";
    }
    render() {
        return (0, $i7GIz.html)`
      <wui-icon-box
        size="sm"
        iconSize="xs"
        iconColor=${this.iconColor}
        backgroundColor=${this.backgroundColor}
        icon=${this.icon}
        background="opaque"
      ></wui-icon-box>
      <wui-text variant="paragraph-500" color="fg-100">${this.message}</wui-text>
    `;
    }
};
$db57abfa89ea79bf$export$864d710a9db8f7a3.styles = [
    (0, $9rwwE.resetStyles),
    (0, $bhgg8.default)
];
$db57abfa89ea79bf$var$__decorate([
    (0, $cRlTX.property)()
], $db57abfa89ea79bf$export$864d710a9db8f7a3.prototype, "backgroundColor", void 0);
$db57abfa89ea79bf$var$__decorate([
    (0, $cRlTX.property)()
], $db57abfa89ea79bf$export$864d710a9db8f7a3.prototype, "iconColor", void 0);
$db57abfa89ea79bf$var$__decorate([
    (0, $cRlTX.property)()
], $db57abfa89ea79bf$export$864d710a9db8f7a3.prototype, "icon", void 0);
$db57abfa89ea79bf$var$__decorate([
    (0, $cRlTX.property)()
], $db57abfa89ea79bf$export$864d710a9db8f7a3.prototype, "message", void 0);
$db57abfa89ea79bf$export$864d710a9db8f7a3 = $db57abfa89ea79bf$var$__decorate([
    (0, $lkv4o.customElement)("wui-snackbar")
], $db57abfa89ea79bf$export$864d710a9db8f7a3);

});
parcelRegister("bhgg8", function(module, exports) {

$parcel$export(module.exports, "default", () => $835de4f8751e7970$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $835de4f8751e7970$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    display: flex;
    column-gap: var(--wui-spacing-xs);
    align-items: center;
    padding: var(--wui-spacing-xs) var(--wui-spacing-m) var(--wui-spacing-xs) var(--wui-spacing-xs);
    border-radius: var(--wui-border-radius-3xl);
    border: 1px solid var(--wui-gray-glass-005);
    box-sizing: border-box;
    max-height: 40px;
    background-color: var(--wui-color-bg-175);
    box-shadow:
      0px 14px 64px -4px rgba(0, 0, 0, 0.15),
      0px 8px 22px -6px rgba(0, 0, 0, 0.15);
  }
`;

});


parcelRegister("cNmV9", function(module, exports) {

$parcel$export(module.exports, "WuiTabs", () => $950bd73501ee0193$export$78c669163db53348);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
var $2o0HH = parcelRequire("2o0HH");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");

var $abdOj = parcelRequire("abdOj");
var $950bd73501ee0193$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $950bd73501ee0193$export$78c669163db53348 = class WuiTabs extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.tabs = [];
        this.onTabChange = ()=>null;
        this.buttons = [];
        this.disabled = false;
        this.activeTab = 0;
        this.localTabWidth = "100px";
        this.isDense = false;
    }
    render() {
        this.isDense = this.tabs.length > 3;
        this.style.cssText = `
      --local-tab: ${this.activeTab};
      --local-tab-width: ${this.localTabWidth};
    `;
        this.dataset["type"] = this.isDense ? "flex" : "block";
        return this.tabs.map((tab, index)=>{
            const isActive = index === this.activeTab;
            return (0, $i7GIz.html)`
        <button
          ?disabled=${this.disabled}
          @click=${()=>this.onTabClick(index)}
          data-active=${isActive}
        >
          <wui-icon size="xs" color="inherit" name=${tab.icon}></wui-icon>
          <wui-text variant="small-600" color="inherit"> ${tab.label} </wui-text>
        </button>
      `;
        });
    }
    firstUpdated() {
        if (this.shadowRoot && this.isDense) {
            this.buttons = [
                ...this.shadowRoot.querySelectorAll("button")
            ];
            setTimeout(()=>{
                this.animateTabs(0, true);
            }, 0);
        }
    }
    onTabClick(index) {
        if (this.buttons) this.animateTabs(index, false);
        this.activeTab = index;
        this.onTabChange(index);
    }
    animateTabs(index, initialAnimation) {
        const passiveBtn = this.buttons[this.activeTab];
        const activeBtn = this.buttons[index];
        const passiveBtnText = passiveBtn?.querySelector("wui-text");
        const activeBtnText = activeBtn?.querySelector("wui-text");
        const activeBtnBounds = activeBtn?.getBoundingClientRect();
        const activeBtnTextBounds = activeBtnText?.getBoundingClientRect();
        if (passiveBtn && passiveBtnText && !initialAnimation && index !== this.activeTab) {
            passiveBtnText.animate([
                {
                    opacity: 0
                }
            ], {
                duration: 50,
                easing: "ease",
                fill: "forwards"
            });
            passiveBtn.animate([
                {
                    width: `34px`
                }
            ], {
                duration: 500,
                easing: "ease",
                fill: "forwards"
            });
        }
        if (activeBtn && activeBtnBounds && activeBtnTextBounds && activeBtnText) {
            if (index !== this.activeTab || initialAnimation) {
                this.localTabWidth = `${Math.round(activeBtnBounds.width + activeBtnTextBounds.width) + 6}px`;
                activeBtn.animate([
                    {
                        width: `${activeBtnBounds.width + activeBtnTextBounds.width}px`
                    }
                ], {
                    duration: initialAnimation ? 0 : 500,
                    fill: "forwards",
                    easing: "ease"
                });
                activeBtnText.animate([
                    {
                        opacity: 1
                    }
                ], {
                    duration: initialAnimation ? 0 : 125,
                    delay: initialAnimation ? 0 : 200,
                    fill: "forwards",
                    easing: "ease"
                });
            }
        }
    }
};
$950bd73501ee0193$export$78c669163db53348.styles = [
    (0, $9rwwE.resetStyles),
    (0, $9rwwE.elementStyles),
    (0, $abdOj.default)
];
$950bd73501ee0193$var$__decorate([
    (0, $cRlTX.property)({
        type: Array
    })
], $950bd73501ee0193$export$78c669163db53348.prototype, "tabs", void 0);
$950bd73501ee0193$var$__decorate([
    (0, $cRlTX.property)()
], $950bd73501ee0193$export$78c669163db53348.prototype, "onTabChange", void 0);
$950bd73501ee0193$var$__decorate([
    (0, $cRlTX.property)({
        type: Array
    })
], $950bd73501ee0193$export$78c669163db53348.prototype, "buttons", void 0);
$950bd73501ee0193$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $950bd73501ee0193$export$78c669163db53348.prototype, "disabled", void 0);
$950bd73501ee0193$var$__decorate([
    (0, $2o0HH.state)()
], $950bd73501ee0193$export$78c669163db53348.prototype, "activeTab", void 0);
$950bd73501ee0193$var$__decorate([
    (0, $2o0HH.state)()
], $950bd73501ee0193$export$78c669163db53348.prototype, "localTabWidth", void 0);
$950bd73501ee0193$var$__decorate([
    (0, $2o0HH.state)()
], $950bd73501ee0193$export$78c669163db53348.prototype, "isDense", void 0);
$950bd73501ee0193$export$78c669163db53348 = $950bd73501ee0193$var$__decorate([
    (0, $lkv4o.customElement)("wui-tabs")
], $950bd73501ee0193$export$78c669163db53348);

});
parcelRegister("abdOj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7695a4f4d9a63d7e$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $7695a4f4d9a63d7e$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    display: inline-flex;
    background-color: var(--wui-gray-glass-002);
    border-radius: var(--wui-border-radius-3xl);
    padding: var(--wui-spacing-3xs);
    position: relative;
    height: 36px;
    overflow: hidden;
  }

  :host::before {
    content: '';
    position: absolute;
    pointer-events: none;
    top: 4px;
    left: 4px;
    display: block;
    width: var(--local-tab-width);
    height: 28px;
    border-radius: var(--wui-border-radius-3xl);
    background-color: var(--wui-gray-glass-002);
    box-shadow: inset 0 0 0 1px var(--wui-gray-glass-002);
    transform: translateX(calc(var(--local-tab) * var(--local-tab-width)));
    transition: transform var(--wui-ease-out-power-2) var(--wui-duration-lg);
  }

  :host([data-type='flex'])::before {
    left: 3px;
    transform: translateX(calc((var(--local-tab) * 34px) + (var(--local-tab) * 4px)));
  }

  :host([data-type='flex']) {
    display: flex;
    padding: 0px 0px 0px 12px;
    gap: 4px;
  }

  :host([data-type='flex']) > button > wui-text {
    position: absolute;
    left: 18px;
    opacity: 0;
  }

  button[data-active='true'] > wui-icon,
  button[data-active='true'] > wui-text {
    color: var(--wui-color-fg-100);
  }

  button[data-active='false'] > wui-icon,
  button[data-active='false'] > wui-text {
    color: var(--wui-color-fg-200);
  }

  button[data-active='true']:disabled,
  button[data-active='false']:disabled {
    background-color: transparent;
    opacity: 0.5;
    cursor: not-allowed;
  }

  button[data-active='true']:disabled > wui-text {
    color: var(--wui-color-fg-200);
  }

  button[data-active='false']:disabled > wui-text {
    color: var(--wui-color-fg-300);
  }

  button > wui-icon,
  button > wui-text {
    pointer-events: none;
    transition: all var(--wui-ease-out-power-2) var(--wui-duration-lg);
  }

  button {
    width: var(--local-tab-width);
  }

  :host([data-type='flex']) > button {
    width: 34px;
    position: relative;
    display: flex;
    justify-content: flex-start;
  }

  button:hover:enabled,
  button:active:enabled {
    background-color: transparent !important;
  }

  button:hover:enabled > wui-icon,
  button:active:enabled > wui-icon {
    color: var(--wui-color-fg-125);
  }

  button:hover:enabled > wui-text,
  button:active:enabled > wui-text {
    color: var(--wui-color-fg-125);
  }

  button {
    border-radius: var(--wui-border-radius-3xl);
  }
`;

});


parcelRegister("geQ3d", function(module, exports) {

$parcel$export(module.exports, "WuiTooltip", () => $bd265456f1d91574$export$eee74dbee7f7f64b);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
parcelRequire("cvzvT");
parcelRequire("eFeuH");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");

var $cqXS5 = parcelRequire("cqXS5");
var $bd265456f1d91574$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $bd265456f1d91574$export$eee74dbee7f7f64b = class WuiTooltip extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.placement = "top";
        this.message = "";
    }
    render() {
        return (0, $i7GIz.html)`<wui-icon
        data-placement=${this.placement}
        color="fg-100"
        size="inherit"
        name="cursor"
      ></wui-icon>
      <wui-text color="inherit" variant="small-500">${this.message}</wui-text>`;
    }
};
$bd265456f1d91574$export$eee74dbee7f7f64b.styles = [
    (0, $9rwwE.resetStyles),
    (0, $9rwwE.elementStyles),
    (0, $cqXS5.default)
];
$bd265456f1d91574$var$__decorate([
    (0, $cRlTX.property)()
], $bd265456f1d91574$export$eee74dbee7f7f64b.prototype, "placement", void 0);
$bd265456f1d91574$var$__decorate([
    (0, $cRlTX.property)()
], $bd265456f1d91574$export$eee74dbee7f7f64b.prototype, "message", void 0);
$bd265456f1d91574$export$eee74dbee7f7f64b = $bd265456f1d91574$var$__decorate([
    (0, $lkv4o.customElement)("wui-tooltip")
], $bd265456f1d91574$export$eee74dbee7f7f64b);

});
parcelRegister("cqXS5", function(module, exports) {

$parcel$export(module.exports, "default", () => $90d65af40ad0985c$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $90d65af40ad0985c$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    display: block;
    padding: 9px var(--wui-spacing-s) 10px var(--wui-spacing-s);
    border-radius: var(--wui-border-radius-xxs);
    background-color: var(--wui-color-fg-100);
    color: var(--wui-color-bg-100);
    position: relative;
  }

  wui-icon {
    position: absolute;
    width: 12px !important;
    height: 4px !important;
  }

  wui-icon[data-placement='top'] {
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 95%);
  }

  wui-icon[data-placement='bottom'] {
    top: 0;
    left: 50%;
    transform: translate(-50%, -95%) rotate(180deg);
  }

  wui-icon[data-placement='right'] {
    top: 50%;
    left: 0;
    transform: translate(-65%, -50%) rotate(90deg);
  }

  wui-icon[data-placement='left'] {
    top: 50%;
    right: 0%;
    transform: translate(65%, -50%) rotate(270deg);
  }
`;

});


parcelRegister("azlul", function(module, exports) {

$parcel$export(module.exports, "WuiVisualThumbnail", () => $7b1dd769723f08c5$export$fb0fe7c7cc2031fe);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
parcelRequire("1fjkg");
parcelRequire("cvzvT");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");

var $fkblD = parcelRequire("fkblD");
var $7b1dd769723f08c5$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $7b1dd769723f08c5$export$fb0fe7c7cc2031fe = class WuiVisualThumbnail extends (0, $3KB8N.LitElement) {
    render() {
        this.style.cssText = `--local-border-radius: ${this.borderRadiusFull ? "1000px" : "20px"};`;
        return (0, $i7GIz.html)`${this.templateVisual()}`;
    }
    templateVisual() {
        if (this.imageSrc) return (0, $i7GIz.html)`<wui-image src=${this.imageSrc} alt=${this.alt ?? ""}></wui-image>`;
        return (0, $i7GIz.html)`<wui-icon
      data-parent-size="md"
      size="inherit"
      color="inherit"
      name="walletPlaceholder"
    ></wui-icon>`;
    }
};
$7b1dd769723f08c5$export$fb0fe7c7cc2031fe.styles = [
    (0, $9rwwE.resetStyles),
    (0, $fkblD.default)
];
$7b1dd769723f08c5$var$__decorate([
    (0, $cRlTX.property)()
], $7b1dd769723f08c5$export$fb0fe7c7cc2031fe.prototype, "imageSrc", void 0);
$7b1dd769723f08c5$var$__decorate([
    (0, $cRlTX.property)()
], $7b1dd769723f08c5$export$fb0fe7c7cc2031fe.prototype, "alt", void 0);
$7b1dd769723f08c5$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $7b1dd769723f08c5$export$fb0fe7c7cc2031fe.prototype, "borderRadiusFull", void 0);
$7b1dd769723f08c5$export$fb0fe7c7cc2031fe = $7b1dd769723f08c5$var$__decorate([
    (0, $lkv4o.customElement)("wui-visual-thumbnail")
], $7b1dd769723f08c5$export$fb0fe7c7cc2031fe);

});
parcelRegister("fkblD", function(module, exports) {

$parcel$export(module.exports, "default", () => $b28186c1c3e3ef46$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $b28186c1c3e3ef46$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    display: flex;
    justify-content: center;
    align-items: center;
    width: var(--wui-icon-box-size-xl);
    height: var(--wui-icon-box-size-xl);
    box-shadow: 0 0 0 8px var(--wui-thumbnail-border);
    border-radius: var(--local-border-radius);
    overflow: hidden;
  }

  wui-icon {
    width: 32px;
    height: 32px;
  }
`;

});


parcelRegister("lKtNz", function(module, exports) {

$parcel$export(module.exports, "WuiNoticeCard", () => $fd550236e0ec44fd$export$bdf6de60cd1210c8);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("aiZ8J");
parcelRequire("eFeuH");
parcelRequire("e7V2r");
parcelRequire("e4QeF");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");

var $lvoYW = parcelRequire("lvoYW");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
var $fd550236e0ec44fd$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $fd550236e0ec44fd$export$bdf6de60cd1210c8 = class WuiNoticeCard extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.label = "";
        this.description = "";
        this.icon = "wallet";
    }
    render() {
        return (0, $i7GIz.html)`
      <button>
        <wui-flex gap="m" alignItems="center" justifyContent="space-between">
          <wui-icon-box
            size="lg"
            iconcolor="accent-100"
            backgroundcolor="accent-100"
            icon=${this.icon}
            background="transparent"
          ></wui-icon-box>

          <wui-flex flexDirection="column" gap="3xs">
            <wui-text variant="paragraph-500" color="fg-100">${this.label}</wui-text>
            <wui-text variant="small-400" color="fg-200">${this.description}</wui-text>
          </wui-flex>

          <wui-icon size="md" color="fg-200" name="chevronRight"></wui-icon>
        </wui-flex>
      </button>
    `;
    }
};
$fd550236e0ec44fd$export$bdf6de60cd1210c8.styles = [
    (0, $9rwwE.resetStyles),
    (0, $9rwwE.elementStyles),
    (0, $lvoYW.default)
];
$fd550236e0ec44fd$var$__decorate([
    (0, $cRlTX.property)()
], $fd550236e0ec44fd$export$bdf6de60cd1210c8.prototype, "label", void 0);
$fd550236e0ec44fd$var$__decorate([
    (0, $cRlTX.property)()
], $fd550236e0ec44fd$export$bdf6de60cd1210c8.prototype, "description", void 0);
$fd550236e0ec44fd$var$__decorate([
    (0, $cRlTX.property)()
], $fd550236e0ec44fd$export$bdf6de60cd1210c8.prototype, "icon", void 0);
$fd550236e0ec44fd$export$bdf6de60cd1210c8 = $fd550236e0ec44fd$var$__decorate([
    (0, $lkv4o.customElement)("wui-notice-card")
], $fd550236e0ec44fd$export$bdf6de60cd1210c8);

});
parcelRegister("lvoYW", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa7fdf1a8212c38b$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $fa7fdf1a8212c38b$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    display: block;
  }

  button {
    width: 100%;
    display: block;
    padding-top: var(--wui-spacing-l);
    padding-bottom: var(--wui-spacing-l);
    padding-left: var(--wui-spacing-s);
    padding-right: var(--wui-spacing-2l);
    border-radius: var(--wui-border-radius-s);
    background-color: var(--wui-accent-glass-015);
  }

  button:hover {
    background-color: var(--wui-accent-glass-010) !important;
  }

  button:active {
    background-color: var(--wui-accent-glass-020) !important;
  }
`;

});


parcelRegister("cOnD5", function(module, exports) {

$parcel$export(module.exports, "WuiListAccordion", () => $953c7bd9098393dd$export$f885ba019a6ba4db);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
parcelRequire("cvzvT");
parcelRequire("eFeuH");
parcelRequire("aiZ8J");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");

var $98i44 = parcelRequire("98i44");
var $953c7bd9098393dd$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $953c7bd9098393dd$var$MAX_HEIGHT = 100;
let $953c7bd9098393dd$export$f885ba019a6ba4db = class WuiListAccordion extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.textTitle = "";
        this.overflowedContent = "";
        this.toggled = false;
        this.enableAccordion = false;
        this.scrollElement = undefined;
        this.scrollHeightElement = 0;
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has("textTitle") || changedProperties.has("overflowedContent")) setTimeout(()=>{
            this.checkHeight();
        }, 1);
    }
    checkHeight() {
        this.updateComplete.then(()=>{
            const heightElement = this.shadowRoot?.querySelector(".heightContent");
            const textElement = this.shadowRoot?.querySelector(".textContent");
            if (heightElement && textElement) {
                this.scrollElement = heightElement;
                const scrollHeight = textElement?.scrollHeight;
                if (scrollHeight && scrollHeight > $953c7bd9098393dd$var$MAX_HEIGHT) {
                    this.enableAccordion = true;
                    this.scrollHeightElement = scrollHeight;
                    this.requestUpdate();
                }
            }
        });
    }
    render() {
        return (0, $i7GIz.html)`
      <button ontouchstart @click=${()=>this.onClick()}>
        <wui-flex justifyContent="space-between" alignItems="center">
          <wui-text variant="paragraph-500" color="fg-100">${this.textTitle}</wui-text>
          ${this.chevronTemplate()}
        </wui-flex>
        <div
          data-active=${this.enableAccordion ? Boolean(this.toggled) : true}
          class="overflowedContent"
        >
          <div class="heightContent">
            <wui-text class="textContent" variant="paragraph-400" color="fg-200">
              <pre>${this.overflowedContent}</pre>
            </wui-text>
          </div>
        </div>
      </button>
    `;
    }
    onClick() {
        const icon = this.shadowRoot?.querySelector("wui-icon");
        if (this.enableAccordion) {
            this.toggled = !this.toggled;
            this.requestUpdate();
            if (this.scrollElement) this.scrollElement.animate([
                {
                    maxHeight: this.toggled ? `${$953c7bd9098393dd$var$MAX_HEIGHT}px` : `${this.scrollHeightElement}px`
                },
                {
                    maxHeight: this.toggled ? `${this.scrollHeightElement}px` : `${$953c7bd9098393dd$var$MAX_HEIGHT}px`
                }
            ], {
                duration: 300,
                fill: "forwards",
                easing: "ease"
            });
            if (icon) icon.animate([
                {
                    transform: this.toggled ? `rotate(0deg)` : `rotate(180deg)`
                },
                {
                    transform: this.toggled ? `rotate(180deg)` : `rotate(0deg)`
                }
            ], {
                duration: 300,
                fill: "forwards",
                easing: "ease"
            });
        }
    }
    chevronTemplate() {
        if (this.enableAccordion) return (0, $i7GIz.html)` <wui-icon color="fg-100" size="sm" name="chevronBottom"></wui-icon>`;
        return null;
    }
};
$953c7bd9098393dd$export$f885ba019a6ba4db.styles = [
    (0, $9rwwE.resetStyles),
    (0, $9rwwE.elementStyles),
    (0, $98i44.default)
];
$953c7bd9098393dd$var$__decorate([
    (0, $cRlTX.property)()
], $953c7bd9098393dd$export$f885ba019a6ba4db.prototype, "textTitle", void 0);
$953c7bd9098393dd$var$__decorate([
    (0, $cRlTX.property)()
], $953c7bd9098393dd$export$f885ba019a6ba4db.prototype, "overflowedContent", void 0);
$953c7bd9098393dd$export$f885ba019a6ba4db = $953c7bd9098393dd$var$__decorate([
    (0, $lkv4o.customElement)("wui-list-accordion")
], $953c7bd9098393dd$export$f885ba019a6ba4db);

});
parcelRegister("98i44", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a62dfa7b4b11098$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $6a62dfa7b4b11098$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  button {
    height: auto;
    position: relative;
    flex-direction: column;
    gap: var(--wui-spacing-s);
    padding: 17px 18px 17px var(--wui-spacing-m);
    width: 100%;
    background-color: var(--wui-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
    color: var(--wui-color-fg-250);
  }

  .overflowedContent {
    width: 100%;
    overflow: hidden;
  }

  .overflowedContent[data-active='false']:after {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(to top, var(--wui-color-bg-200), transparent);
    border-bottom-left-radius: var(--wui-border-radius-xs);
    border-bottom-right-radius: var(--wui-border-radius-xs);
  }

  .heightContent {
    max-height: 100px;
  }

  pre {
    text-align: left;
    white-space: pre-wrap;
    height: auto;
    overflow-x: auto;
    overflow-wrap: anywhere;
  }
`;

});


parcelRegister("aPqUh", function(module, exports) {

$parcel$export(module.exports, "WuiListContent", () => $7e2389f09b42740f$export$621c7f09b7560b89);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
parcelRequire("cvzvT");
parcelRequire("1fjkg");
parcelRequire("eFeuH");
parcelRequire("aiZ8J");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");

var $eqhVv = parcelRequire("eqhVv");
var $7e2389f09b42740f$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $7e2389f09b42740f$export$621c7f09b7560b89 = class WuiListContent extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.imageSrc = undefined;
        this.textTitle = "";
        this.textValue = undefined;
    }
    render() {
        return (0, $i7GIz.html)`
      <wui-flex justifyContent="space-between" alignItems="center">
        <wui-text variant="paragraph-500" color=${this.textValue ? "fg-200" : "fg-100"}>
          ${this.textTitle}
        </wui-text>
        ${this.templateContent()}
      </wui-flex>
    `;
    }
    templateContent() {
        if (this.imageSrc) return (0, $i7GIz.html)`<wui-image src=${this.imageSrc} alt=${this.textTitle}></wui-image>`;
        else if (this.textValue) return (0, $i7GIz.html)` <wui-text variant="paragraph-400" color="fg-100"> ${this.textValue} </wui-text>`;
        return (0, $i7GIz.html)`<wui-icon size="inherit" color="fg-200" name="networkPlaceholder"></wui-icon>`;
    }
};
$7e2389f09b42740f$export$621c7f09b7560b89.styles = [
    (0, $9rwwE.resetStyles),
    (0, $9rwwE.elementStyles),
    (0, $eqhVv.default)
];
$7e2389f09b42740f$var$__decorate([
    (0, $cRlTX.property)()
], $7e2389f09b42740f$export$621c7f09b7560b89.prototype, "imageSrc", void 0);
$7e2389f09b42740f$var$__decorate([
    (0, $cRlTX.property)()
], $7e2389f09b42740f$export$621c7f09b7560b89.prototype, "textTitle", void 0);
$7e2389f09b42740f$var$__decorate([
    (0, $cRlTX.property)()
], $7e2389f09b42740f$export$621c7f09b7560b89.prototype, "textValue", void 0);
$7e2389f09b42740f$export$621c7f09b7560b89 = $7e2389f09b42740f$var$__decorate([
    (0, $lkv4o.customElement)("wui-list-content")
], $7e2389f09b42740f$export$621c7f09b7560b89);

});
parcelRegister("eqhVv", function(module, exports) {

$parcel$export(module.exports, "default", () => $a801663e506e0832$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $a801663e506e0832$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    display: flex;
    column-gap: var(--wui-spacing-s);
    padding: 17px 18px 17px var(--wui-spacing-m);
    width: 100%;
    background-color: var(--wui-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
    color: var(--wui-color-fg-250);
  }

  wui-image {
    width: var(--wui-icon-size-lg);
    height: var(--wui-icon-size-lg);
    border-radius: var(--wui-border-radius-3xl);
  }

  wui-icon {
    width: var(--wui-icon-size-lg);
    height: var(--wui-icon-size-lg);
  }
`;

});


parcelRegister("kZT6j", function(module, exports) {

$parcel$export(module.exports, "WuiListNetwork", () => $f4943f00bbb53604$export$f7ecfb3cf2878ec8);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
parcelRequire("eFeuH");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");
parcelRequire("4jyh8");

var $2iT9R = parcelRequire("2iT9R");
var $f4943f00bbb53604$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $f4943f00bbb53604$export$f7ecfb3cf2878ec8 = class WuiListNetwork extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.imageSrc = "";
        this.name = "";
        this.disabled = false;
    }
    render() {
        return (0, $i7GIz.html)`
      <button ?disabled=${this.disabled} ontouchstart>
        ${this.templateNetworkImage()}
        <wui-text variant="paragraph-500" color="inherit">${this.name}</wui-text>
      </button>
    `;
    }
    templateNetworkImage() {
        if (this.imageSrc) return (0, $i7GIz.html)`<wui-network-image
        size="sm"
        imageSrc=${this.imageSrc}
        name=${this.name}
      ></wui-network-image>`;
        if (!this.imageSrc) return (0, $i7GIz.html)`<wui-network-image size="sm" name=${this.name}></wui-network-image>`;
        return null;
    }
};
$f4943f00bbb53604$export$f7ecfb3cf2878ec8.styles = [
    (0, $9rwwE.resetStyles),
    (0, $9rwwE.elementStyles),
    (0, $2iT9R.default)
];
$f4943f00bbb53604$var$__decorate([
    (0, $cRlTX.property)()
], $f4943f00bbb53604$export$f7ecfb3cf2878ec8.prototype, "imageSrc", void 0);
$f4943f00bbb53604$var$__decorate([
    (0, $cRlTX.property)()
], $f4943f00bbb53604$export$f7ecfb3cf2878ec8.prototype, "name", void 0);
$f4943f00bbb53604$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $f4943f00bbb53604$export$f7ecfb3cf2878ec8.prototype, "disabled", void 0);
$f4943f00bbb53604$export$f7ecfb3cf2878ec8 = $f4943f00bbb53604$var$__decorate([
    (0, $lkv4o.customElement)("wui-list-network")
], $f4943f00bbb53604$export$f7ecfb3cf2878ec8);

});
parcelRegister("2iT9R", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ad80c74f6ea3457$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $1ad80c74f6ea3457$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  button {
    column-gap: var(--wui-spacing-s);
    padding: 7px var(--wui-spacing-l) 7px var(--wui-spacing-xs);
    width: 100%;
    background-color: var(--wui-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
    color: var(--wui-color-fg-100);
  }

  button > wui-text:nth-child(2) {
    display: flex;
    flex: 1;
  }

  wui-icon {
    color: var(--wui-color-fg-200) !important;
  }

  button:disabled {
    background-color: var(--wui-gray-glass-015);
    color: var(--wui-gray-glass-015);
  }

  button:disabled > wui-tag {
    background-color: var(--wui-gray-glass-010);
    color: var(--wui-color-fg-300);
  }
`;

});


parcelRegister("6yRhv", function(module, exports) {

$parcel$export(module.exports, "WuiListWalletTransaction", () => $4c6f3fa39e5d07d2$export$fc79cdc2df8cc885);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
parcelRequire("cvzvT");
parcelRequire("1fjkg");
parcelRequire("eFeuH");
parcelRequire("8lfFP");
parcelRequire("aiZ8J");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");

var $6NBxE = parcelRequire("6NBxE");
var $4c6f3fa39e5d07d2$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $4c6f3fa39e5d07d2$export$fc79cdc2df8cc885 = class WuiListWalletTransaction extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.amount = "";
        this.networkCurreny = "";
        this.networkImageUrl = "";
        this.receiverAddress = "";
        this.addressExplorerUrl = "";
    }
    render() {
        return (0, $i7GIz.html)`
      <wui-flex justifyContent="space-between" alignItems="center">
        <wui-text variant="paragraph-500" color="fg-200">Sending</wui-text>
        <wui-flex gap="xs" alignItems="center">
          <wui-text variant="paragraph-400" color="fg-100">
            ${this.amount} ${this.networkCurreny}
          </wui-text>
          ${this.templateNetworkVisual()}
        </wui-flex>
      </wui-flex>
      <wui-flex justifyContent="space-between" alignItems="center">
        <wui-text variant="paragraph-500" color="fg-200">To</wui-text>
        <wui-chip
          icon="externalLink"
          variant="shadeSmall"
          href=${this.addressExplorerUrl}
          title=${this.receiverAddress}
        ></wui-chip>
      </wui-flex>
    `;
    }
    templateNetworkVisual() {
        if (this.networkImageUrl) return (0, $i7GIz.html)`<wui-image src=${this.networkImageUrl} alt="Network Image"></wui-image>`;
        return (0, $i7GIz.html)`<wui-icon size="inherit" color="fg-200" name="networkPlaceholder"></wui-icon>`;
    }
};
$4c6f3fa39e5d07d2$export$fc79cdc2df8cc885.styles = [
    (0, $9rwwE.resetStyles),
    (0, $9rwwE.elementStyles),
    (0, $6NBxE.default)
];
$4c6f3fa39e5d07d2$var$__decorate([
    (0, $cRlTX.property)()
], $4c6f3fa39e5d07d2$export$fc79cdc2df8cc885.prototype, "amount", void 0);
$4c6f3fa39e5d07d2$var$__decorate([
    (0, $cRlTX.property)()
], $4c6f3fa39e5d07d2$export$fc79cdc2df8cc885.prototype, "networkCurreny", void 0);
$4c6f3fa39e5d07d2$var$__decorate([
    (0, $cRlTX.property)()
], $4c6f3fa39e5d07d2$export$fc79cdc2df8cc885.prototype, "networkImageUrl", void 0);
$4c6f3fa39e5d07d2$var$__decorate([
    (0, $cRlTX.property)()
], $4c6f3fa39e5d07d2$export$fc79cdc2df8cc885.prototype, "receiverAddress", void 0);
$4c6f3fa39e5d07d2$var$__decorate([
    (0, $cRlTX.property)()
], $4c6f3fa39e5d07d2$export$fc79cdc2df8cc885.prototype, "addressExplorerUrl", void 0);
$4c6f3fa39e5d07d2$export$fc79cdc2df8cc885 = $4c6f3fa39e5d07d2$var$__decorate([
    (0, $lkv4o.customElement)("wui-list-wallet-transaction")
], $4c6f3fa39e5d07d2$export$fc79cdc2df8cc885);

});
parcelRegister("6NBxE", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f3470b096e7abed$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $4f3470b096e7abed$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    display: flex;
    flex-direction: column;
    gap: var(--wui-spacing-l);
    padding: 17px 18px 17px var(--wui-spacing-m);
    width: 100%;
    background-color: var(--wui-gray-glass-002);
    border-radius: var(--wui-border-radius-xs);
    color: var(--wui-color-fg-250);
  }

  wui-image {
    width: var(--wui-icon-size-lg);
    height: var(--wui-icon-size-lg);
    border-radius: var(--wui-border-radius-3xl);
  }

  wui-icon {
    width: var(--wui-icon-size-lg);
    height: var(--wui-icon-size-lg);
  }
`;

});


parcelRegister("eWt5E", function(module, exports) {

$parcel$export(module.exports, "WuiOnRampActivityItem", () => $ae0d0c2676abae8f$export$73478a01e052eaa5);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
parcelRequire("cvzvT");
parcelRequire("eFeuH");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");

var $6cHU8 = parcelRequire("6cHU8");
parcelRequire("aAJP9");
var $6tAXH = parcelRequire("6tAXH");
var $ae0d0c2676abae8f$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $ae0d0c2676abae8f$export$73478a01e052eaa5 = class WuiOnRampActivityItem extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.disabled = false;
        this.color = "inherit";
        this.label = "Bought";
        this.purchaseValue = "";
        this.purchaseCurrency = "";
        this.date = "";
        this.completed = false;
        this.inProgress = false;
        this.failed = false;
        this.onClick = null;
        this.symbol = "";
    }
    firstUpdated() {
        if (!this.icon) this.fetchTokenImage();
    }
    render() {
        return (0, $i7GIz.html)`
      <wui-flex>
        ${this.imageTemplate()}
        <wui-flex flexDirection="column" gap="4xs" flexGrow="1">
          <wui-flex gap="xxs" alignItems="center" justifyContent="flex-start">
            ${this.statusIconTemplate()}
            <wui-text variant="paragraph-500" color="fg-100"> ${this.label}</wui-text>
          </wui-flex>
          <wui-text variant="small-400" color="fg-200">
            + ${this.purchaseValue} ${this.purchaseCurrency}
          </wui-text>
        </wui-flex>
        ${this.inProgress ? (0, $i7GIz.html)`<wui-loading-spinner color="fg-200" size="md"></wui-loading-spinner>` : (0, $i7GIz.html)`<wui-text variant="micro-700" color="fg-300"><span>${this.date}</span></wui-text>`}
      </wui-flex>
    `;
    }
    async fetchTokenImage() {
        await (0, $6tAXH.ApiController)._fetchTokenImage(this.purchaseCurrency);
    }
    statusIconTemplate() {
        if (this.inProgress) return null;
        return this.completed ? this.boughtIconTemplate() : this.errorIconTemplate();
    }
    errorIconTemplate() {
        return (0, $i7GIz.html)`<wui-icon-box
      size="xxs"
      iconColor="error-100"
      backgroundColor="error-100"
      background="opaque"
      icon="close"
      borderColor="wui-color-bg-125"
    ></wui-icon-box>`;
    }
    imageTemplate() {
        const icon = this.icon || `https://avatar.vercel.sh/andrew.svg?size=50&text=${this.symbol}`;
        return (0, $i7GIz.html)`<wui-flex class="purchase-image-container">
      <wui-image src=${icon}></wui-image>
    </wui-flex>`;
    }
    boughtIconTemplate() {
        return (0, $i7GIz.html)`<wui-icon-box
      size="xxs"
      iconColor="success-100"
      backgroundColor="success-100"
      background="opaque"
      icon="arrowBottom"
      borderColor="wui-color-bg-125"
    ></wui-icon-box>`;
    }
};
$ae0d0c2676abae8f$export$73478a01e052eaa5.styles = [
    (0, $9rwwE.resetStyles),
    (0, $9rwwE.elementStyles),
    (0, $6cHU8.default)
];
$ae0d0c2676abae8f$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $ae0d0c2676abae8f$export$73478a01e052eaa5.prototype, "disabled", void 0);
$ae0d0c2676abae8f$var$__decorate([
    (0, $cRlTX.property)()
], $ae0d0c2676abae8f$export$73478a01e052eaa5.prototype, "color", void 0);
$ae0d0c2676abae8f$var$__decorate([
    (0, $cRlTX.property)()
], $ae0d0c2676abae8f$export$73478a01e052eaa5.prototype, "label", void 0);
$ae0d0c2676abae8f$var$__decorate([
    (0, $cRlTX.property)()
], $ae0d0c2676abae8f$export$73478a01e052eaa5.prototype, "purchaseValue", void 0);
$ae0d0c2676abae8f$var$__decorate([
    (0, $cRlTX.property)()
], $ae0d0c2676abae8f$export$73478a01e052eaa5.prototype, "purchaseCurrency", void 0);
$ae0d0c2676abae8f$var$__decorate([
    (0, $cRlTX.property)()
], $ae0d0c2676abae8f$export$73478a01e052eaa5.prototype, "date", void 0);
$ae0d0c2676abae8f$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $ae0d0c2676abae8f$export$73478a01e052eaa5.prototype, "completed", void 0);
$ae0d0c2676abae8f$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $ae0d0c2676abae8f$export$73478a01e052eaa5.prototype, "inProgress", void 0);
$ae0d0c2676abae8f$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $ae0d0c2676abae8f$export$73478a01e052eaa5.prototype, "failed", void 0);
$ae0d0c2676abae8f$var$__decorate([
    (0, $cRlTX.property)()
], $ae0d0c2676abae8f$export$73478a01e052eaa5.prototype, "onClick", void 0);
$ae0d0c2676abae8f$var$__decorate([
    (0, $cRlTX.property)()
], $ae0d0c2676abae8f$export$73478a01e052eaa5.prototype, "symbol", void 0);
$ae0d0c2676abae8f$var$__decorate([
    (0, $cRlTX.property)()
], $ae0d0c2676abae8f$export$73478a01e052eaa5.prototype, "icon", void 0);
$ae0d0c2676abae8f$export$73478a01e052eaa5 = $ae0d0c2676abae8f$var$__decorate([
    (0, $lkv4o.customElement)("wui-onramp-activity-item")
], $ae0d0c2676abae8f$export$73478a01e052eaa5);

});
parcelRegister("6cHU8", function(module, exports) {

$parcel$export(module.exports, "default", () => $4845eb92942af89e$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $4845eb92942af89e$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    width: 100%;
  }

  :host > wui-flex {
    width: 100%;
    padding: var(--wui-spacing-s);
    border-radius: var(--wui-border-radius-xs);
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: var(--wui-spacing-s);
  }

  :host > wui-flex:hover {
    background-color: var(--wui-gray-glass-002);
  }

  .purchase-image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: var(--wui-icon-box-size-lg);
    height: var(--wui-icon-box-size-lg);
  }

  .purchase-image-container wui-image {
    width: 100%;
    height: 100%;
    position: relative;
    border-radius: calc(var(--wui-icon-box-size-lg) / 2);
  }

  .purchase-image-container wui-image::after {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    inset: 0;
    border-radius: calc(var(--wui-icon-box-size-lg) / 2);
    box-shadow: inset 0 0 0 1px var(--wui-gray-glass-005);
  }

  .purchase-image-container wui-icon-box {
    position: absolute;
    right: 0;
    bottom: 0;
    transform: translate(20%, 20%);
  }
`;

});

parcelRegister("aAJP9", function(module, exports) {

$parcel$export(module.exports, "ModalController", () => (parcelRequire("bnxqc")).ModalController);
$parcel$export(module.exports, "RouterController", () => (parcelRequire("dJjpc")).RouterController);
$parcel$export(module.exports, "AccountController", () => (parcelRequire("5mrMQ")).AccountController);
$parcel$export(module.exports, "NetworkController", () => (parcelRequire("b6tQF")).NetworkController);
$parcel$export(module.exports, "OnRampController", () => (parcelRequire("ahDsO")).OnRampController);
$parcel$export(module.exports, "ConnectionController", () => (parcelRequire("jJO2B")).ConnectionController);
$parcel$export(module.exports, "SIWEController", () => (parcelRequire("iQR2f")).SIWEController);
$parcel$export(module.exports, "ConnectorController", () => (parcelRequire("9QkaU")).ConnectorController);
$parcel$export(module.exports, "SnackController", () => (parcelRequire("9fh1I")).SnackController);
$parcel$export(module.exports, "ApiController", () => (parcelRequire("6tAXH")).ApiController);
$parcel$export(module.exports, "AssetController", () => (parcelRequire("hCakD")).AssetController);
$parcel$export(module.exports, "ThemeController", () => (parcelRequire("fyCFg")).ThemeController);
$parcel$export(module.exports, "OptionsController", () => (parcelRequire("8KEpV")).OptionsController);
$parcel$export(module.exports, "BlockchainApiController", () => (parcelRequire("6Y81T")).BlockchainApiController);
$parcel$export(module.exports, "PublicStateController", () => (parcelRequire("ha6or")).PublicStateController);
$parcel$export(module.exports, "EventsController", () => (parcelRequire("6n0eX")).EventsController);
$parcel$export(module.exports, "TransactionsController", () => (parcelRequire("6oINN")).TransactionsController);
$parcel$export(module.exports, "AssetUtil", () => (parcelRequire("7XY6i")).AssetUtil);
$parcel$export(module.exports, "ConstantsUtil", () => (parcelRequire("5S5Lx")).ConstantsUtil);
$parcel$export(module.exports, "CoreHelperUtil", () => (parcelRequire("kGR8V")).CoreHelperUtil);
$parcel$export(module.exports, "StorageUtil", () => (parcelRequire("heSwZ")).StorageUtil);
$parcel$export(module.exports, "RouterUtil", () => (parcelRequire("49HpJ")).RouterUtil);
$parcel$export(module.exports, "CryptoUtil", () => (parcelRequire("bOlNk")).CryptoUtil);

var $bnxqc = parcelRequire("bnxqc");

var $dJjpc = parcelRequire("dJjpc");

var $5mrMQ = parcelRequire("5mrMQ");

var $b6tQF = parcelRequire("b6tQF");

var $ahDsO = parcelRequire("ahDsO");

var $jJO2B = parcelRequire("jJO2B");

var $iQR2f = parcelRequire("iQR2f");

var $9QkaU = parcelRequire("9QkaU");

var $9fh1I = parcelRequire("9fh1I");

var $6tAXH = parcelRequire("6tAXH");

var $hCakD = parcelRequire("hCakD");

var $fyCFg = parcelRequire("fyCFg");

var $8KEpV = parcelRequire("8KEpV");

var $6Y81T = parcelRequire("6Y81T");

var $ha6or = parcelRequire("ha6or");

var $6n0eX = parcelRequire("6n0eX");

var $6oINN = parcelRequire("6oINN");

var $7XY6i = parcelRequire("7XY6i");

var $5S5Lx = parcelRequire("5S5Lx");

var $kGR8V = parcelRequire("kGR8V");

var $heSwZ = parcelRequire("heSwZ");

var $49HpJ = parcelRequire("49HpJ");

var $bOlNk = parcelRequire("bOlNk");

});
parcelRegister("bnxqc", function(module, exports) {

$parcel$export(module.exports, "ModalController", () => $848bc483f3eee280$export$d507f25e63650365);

var $hZH4A = parcelRequire("hZH4A");

var $esotS = parcelRequire("esotS");

var $5mrMQ = parcelRequire("5mrMQ");

var $6tAXH = parcelRequire("6tAXH");

var $6n0eX = parcelRequire("6n0eX");

var $ha6or = parcelRequire("ha6or");

var $dJjpc = parcelRequire("dJjpc");
const $848bc483f3eee280$var$state = (0, $esotS.proxy)({
    loading: false,
    open: false
});
const $848bc483f3eee280$export$d507f25e63650365 = {
    state: $848bc483f3eee280$var$state,
    subscribe (callback) {
        return (0, $esotS.subscribe)($848bc483f3eee280$var$state, ()=>callback($848bc483f3eee280$var$state));
    },
    subscribeKey (key, callback) {
        return (0, $hZH4A.subscribeKey)($848bc483f3eee280$var$state, key, callback);
    },
    async open (options) {
        await (0, $6tAXH.ApiController).state.prefetchPromise;
        const connected = (0, $5mrMQ.AccountController).state.isConnected;
        if (options?.view) (0, $dJjpc.RouterController).reset(options.view);
        else if (connected) (0, $dJjpc.RouterController).reset("Account");
        else (0, $dJjpc.RouterController).reset("Connect");
        $848bc483f3eee280$var$state.open = true;
        (0, $ha6or.PublicStateController).set({
            open: true
        });
        (0, $6n0eX.EventsController).sendEvent({
            type: "track",
            event: "MODAL_OPEN",
            properties: {
                connected: connected
            }
        });
    },
    close () {
        const connected = (0, $5mrMQ.AccountController).state.isConnected;
        $848bc483f3eee280$var$state.open = false;
        (0, $ha6or.PublicStateController).set({
            open: false
        });
        (0, $6n0eX.EventsController).sendEvent({
            type: "track",
            event: "MODAL_CLOSE",
            properties: {
                connected: connected
            }
        });
    },
    setLoading (loading) {
        $848bc483f3eee280$var$state.loading = loading;
    }
};

});
parcelRegister("hZH4A", function(module, exports) {

$parcel$export(module.exports, "subscribeKey", () => $6a21a7270ba6f847$export$7faad7f6b3708314);

var $esotS = parcelRequire("esotS");
var $6a21a7270ba6f847$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/valtio/esm/vanilla/utils.mjs"
});
function $6a21a7270ba6f847$export$7faad7f6b3708314(proxyObject, key, callback, notifyInSync) {
    let prevValue = proxyObject[key];
    return (0, $esotS.subscribe)(proxyObject, ()=>{
        const nextValue = proxyObject[key];
        if (!Object.is(prevValue, nextValue)) callback(prevValue = nextValue);
    }, notifyInSync);
}
let $6a21a7270ba6f847$var$currentCleanups;
function $6a21a7270ba6f847$export$3db5d71bdb2d5499(callback, options) {
    let alive = true;
    const cleanups = /* @__PURE__ */ new Set();
    const subscriptions = /* @__PURE__ */ new Map();
    const cleanup = ()=>{
        if (alive) {
            alive = false;
            cleanups.forEach((clean)=>clean());
            cleanups.clear();
            subscriptions.forEach((unsubscribe)=>unsubscribe());
            subscriptions.clear();
        }
    };
    const revalidate = ()=>{
        if (!alive) return;
        cleanups.forEach((clean)=>clean());
        cleanups.clear();
        const proxiesToSubscribe = /* @__PURE__ */ new Set();
        const parent = $6a21a7270ba6f847$var$currentCleanups;
        $6a21a7270ba6f847$var$currentCleanups = cleanups;
        try {
            const cleanupReturn = callback((proxyObject)=>{
                proxiesToSubscribe.add(proxyObject);
                return proxyObject;
            });
            if (cleanupReturn) cleanups.add(cleanupReturn);
        } finally{
            $6a21a7270ba6f847$var$currentCleanups = parent;
        }
        subscriptions.forEach((unsubscribe, proxyObject)=>{
            if (proxiesToSubscribe.has(proxyObject)) proxiesToSubscribe.delete(proxyObject);
            else {
                subscriptions.delete(proxyObject);
                unsubscribe();
            }
        });
        proxiesToSubscribe.forEach((proxyObject)=>{
            const unsubscribe = (0, $esotS.subscribe)(proxyObject, revalidate, options == null ? void 0 : options.sync);
            subscriptions.set(proxyObject, unsubscribe);
        });
    };
    if ($6a21a7270ba6f847$var$currentCleanups) $6a21a7270ba6f847$var$currentCleanups.add(cleanup);
    revalidate();
    return cleanup;
}
const $6a21a7270ba6f847$var$DEVTOOLS = Symbol();
function $6a21a7270ba6f847$export$6922d3b3a607469e(proxyObject, options) {
    if (typeof options === "string") {
        console.warn("string name option is deprecated, use { name }. https://github.com/pmndrs/valtio/pull/400");
        options = {
            name: options
        };
    }
    const { enabled: enabled, name: name = "", ...rest } = options || {};
    let extension;
    try {
        extension = (enabled != null ? enabled : ($6a21a7270ba6f847$import_meta.env ? $6a21a7270ba6f847$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
    } catch  {}
    if (!extension) {
        if (($6a21a7270ba6f847$import_meta.env ? $6a21a7270ba6f847$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[Warning] Please install/enable Redux devtools extension");
        return;
    }
    let isTimeTraveling = false;
    const devtools2 = extension.connect({
        name: name,
        ...rest
    });
    const unsub1 = (0, $esotS.subscribe)(proxyObject, (ops)=>{
        const action = ops.filter(([_, path])=>path[0] !== $6a21a7270ba6f847$var$DEVTOOLS).map(([op, path])=>`${op}:${path.map(String).join(".")}`).join(", ");
        if (!action) return;
        if (isTimeTraveling) isTimeTraveling = false;
        else {
            const snapWithoutDevtools = Object.assign({}, (0, $esotS.snapshot)(proxyObject));
            delete snapWithoutDevtools[$6a21a7270ba6f847$var$DEVTOOLS];
            devtools2.send({
                type: action,
                updatedAt: /* @__PURE__ */ new Date().toLocaleString()
            }, snapWithoutDevtools);
        }
    });
    const unsub2 = devtools2.subscribe((message)=>{
        var _a, _b, _c, _d, _e, _f;
        if (message.type === "ACTION" && message.payload) try {
            Object.assign(proxyObject, JSON.parse(message.payload));
        } catch (e) {
            console.error("please dispatch a serializable value that JSON.parse() and proxy() support\n", e);
        }
        if (message.type === "DISPATCH" && message.state) {
            if (((_a = message.payload) == null ? void 0 : _a.type) === "JUMP_TO_ACTION" || ((_b = message.payload) == null ? void 0 : _b.type) === "JUMP_TO_STATE") {
                isTimeTraveling = true;
                const state = JSON.parse(message.state);
                Object.assign(proxyObject, state);
            }
            proxyObject[$6a21a7270ba6f847$var$DEVTOOLS] = message;
        } else if (message.type === "DISPATCH" && ((_c = message.payload) == null ? void 0 : _c.type) === "COMMIT") devtools2.init((0, $esotS.snapshot)(proxyObject));
        else if (message.type === "DISPATCH" && ((_d = message.payload) == null ? void 0 : _d.type) === "IMPORT_STATE") {
            const actions = (_e = message.payload.nextLiftedState) == null ? void 0 : _e.actionsById;
            const computedStates = ((_f = message.payload.nextLiftedState) == null ? void 0 : _f.computedStates) || [];
            isTimeTraveling = true;
            computedStates.forEach(({ state: state }, index)=>{
                const action = actions[index] || "No action found";
                Object.assign(proxyObject, state);
                if (index === 0) devtools2.init((0, $esotS.snapshot)(proxyObject));
                else devtools2.send(action, (0, $esotS.snapshot)(proxyObject));
            });
        }
    });
    devtools2.init((0, $esotS.snapshot)(proxyObject));
    return ()=>{
        unsub1();
        unsub2 == null || unsub2();
    };
}
const $6a21a7270ba6f847$var$sourceObjectMap = /* @__PURE__ */ new WeakMap();
const $6a21a7270ba6f847$var$derivedObjectMap = /* @__PURE__ */ new WeakMap();
const $6a21a7270ba6f847$var$markPending = (sourceObject, callback)=>{
    const sourceObjectEntry = $6a21a7270ba6f847$var$sourceObjectMap.get(sourceObject);
    if (sourceObjectEntry) {
        sourceObjectEntry[0].forEach((subscription)=>{
            const { d: derivedObject } = subscription;
            if (sourceObject !== derivedObject) $6a21a7270ba6f847$var$markPending(derivedObject);
        });
        ++sourceObjectEntry[2];
        if (callback) sourceObjectEntry[3].add(callback);
    }
};
const $6a21a7270ba6f847$var$checkPending = (sourceObject, callback)=>{
    const sourceObjectEntry = $6a21a7270ba6f847$var$sourceObjectMap.get(sourceObject);
    if (sourceObjectEntry == null ? void 0 : sourceObjectEntry[2]) {
        sourceObjectEntry[3].add(callback);
        return true;
    }
    return false;
};
const $6a21a7270ba6f847$var$unmarkPending = (sourceObject)=>{
    const sourceObjectEntry = $6a21a7270ba6f847$var$sourceObjectMap.get(sourceObject);
    if (sourceObjectEntry) {
        --sourceObjectEntry[2];
        if (!sourceObjectEntry[2]) {
            sourceObjectEntry[3].forEach((callback)=>callback());
            sourceObjectEntry[3].clear();
        }
        sourceObjectEntry[0].forEach((subscription)=>{
            const { d: derivedObject } = subscription;
            if (sourceObject !== derivedObject) $6a21a7270ba6f847$var$unmarkPending(derivedObject);
        });
    }
};
const $6a21a7270ba6f847$var$addSubscription = (subscription)=>{
    const { s: sourceObject, d: derivedObject } = subscription;
    let derivedObjectEntry = $6a21a7270ba6f847$var$derivedObjectMap.get(derivedObject);
    if (!derivedObjectEntry) {
        derivedObjectEntry = [
            /* @__PURE__ */ new Set()
        ];
        $6a21a7270ba6f847$var$derivedObjectMap.set(subscription.d, derivedObjectEntry);
    }
    derivedObjectEntry[0].add(subscription);
    let sourceObjectEntry = $6a21a7270ba6f847$var$sourceObjectMap.get(sourceObject);
    if (!sourceObjectEntry) {
        const subscriptions = /* @__PURE__ */ new Set();
        const unsubscribe = (0, $esotS.subscribe)(sourceObject, (ops)=>{
            subscriptions.forEach((subscription2)=>{
                const { d: derivedObject2, c: callback, n: notifyInSync, i: ignoreKeys } = subscription2;
                if (sourceObject === derivedObject2 && ops.every((op)=>op[1].length === 1 && ignoreKeys.includes(op[1][0]))) return;
                if (subscription2.p) return;
                $6a21a7270ba6f847$var$markPending(sourceObject, callback);
                if (notifyInSync) $6a21a7270ba6f847$var$unmarkPending(sourceObject);
                else subscription2.p = Promise.resolve().then(()=>{
                    delete subscription2.p;
                    $6a21a7270ba6f847$var$unmarkPending(sourceObject);
                });
            });
        }, true);
        sourceObjectEntry = [
            subscriptions,
            unsubscribe,
            0,
            /* @__PURE__ */ new Set()
        ];
        $6a21a7270ba6f847$var$sourceObjectMap.set(sourceObject, sourceObjectEntry);
    }
    sourceObjectEntry[0].add(subscription);
};
const $6a21a7270ba6f847$var$removeSubscription = (subscription)=>{
    const { s: sourceObject, d: derivedObject } = subscription;
    const derivedObjectEntry = $6a21a7270ba6f847$var$derivedObjectMap.get(derivedObject);
    derivedObjectEntry == null || derivedObjectEntry[0].delete(subscription);
    if ((derivedObjectEntry == null ? void 0 : derivedObjectEntry[0].size) === 0) $6a21a7270ba6f847$var$derivedObjectMap.delete(derivedObject);
    const sourceObjectEntry = $6a21a7270ba6f847$var$sourceObjectMap.get(sourceObject);
    if (sourceObjectEntry) {
        const [subscriptions, unsubscribe] = sourceObjectEntry;
        subscriptions.delete(subscription);
        if (!subscriptions.size) {
            unsubscribe();
            $6a21a7270ba6f847$var$sourceObjectMap.delete(sourceObject);
        }
    }
};
const $6a21a7270ba6f847$var$listSubscriptions = (derivedObject)=>{
    const derivedObjectEntry = $6a21a7270ba6f847$var$derivedObjectMap.get(derivedObject);
    if (derivedObjectEntry) return Array.from(derivedObjectEntry[0]);
    return [];
};
const $6a21a7270ba6f847$export$5bb85a5dcd872eb9 = {
    add: $6a21a7270ba6f847$var$addSubscription,
    remove: $6a21a7270ba6f847$var$removeSubscription,
    list: $6a21a7270ba6f847$var$listSubscriptions
};
function $6a21a7270ba6f847$export$78ed5b3305815fc7(derivedFns, options) {
    const proxyObject = (options == null ? void 0 : options.proxy) || (0, $esotS.proxy)({});
    const notifyInSync = !!(options == null ? void 0 : options.sync);
    const derivedKeys = Object.keys(derivedFns);
    derivedKeys.forEach((key)=>{
        if (Object.getOwnPropertyDescriptor(proxyObject, key)) throw new Error("object property already defined");
        const fn = derivedFns[key];
        let lastDependencies = null;
        const evaluate = ()=>{
            if (lastDependencies) {
                if (Array.from(lastDependencies).map(([p])=>$6a21a7270ba6f847$var$checkPending(p, evaluate)).some((isPending)=>isPending)) return;
                if (Array.from(lastDependencies).every(([p, entry])=>(0, $esotS.getVersion)(p) === entry.v)) return;
            }
            const dependencies = /* @__PURE__ */ new Map();
            const get = (p)=>{
                dependencies.set(p, {
                    v: (0, $esotS.getVersion)(p)
                });
                return p;
            };
            const value = fn(get);
            const subscribeToDependencies = ()=>{
                dependencies.forEach((entry, p)=>{
                    var _a;
                    const lastSubscription = (_a = lastDependencies == null ? void 0 : lastDependencies.get(p)) == null ? void 0 : _a.s;
                    if (lastSubscription) entry.s = lastSubscription;
                    else {
                        const subscription = {
                            s: p,
                            // sourceObject
                            d: proxyObject,
                            // derivedObject
                            k: key,
                            // derived key
                            c: evaluate,
                            // callback
                            n: notifyInSync,
                            i: derivedKeys
                        };
                        $6a21a7270ba6f847$var$addSubscription(subscription);
                        entry.s = subscription;
                    }
                });
                lastDependencies == null || lastDependencies.forEach((entry, p)=>{
                    if (!dependencies.has(p) && entry.s) $6a21a7270ba6f847$var$removeSubscription(entry.s);
                });
                lastDependencies = dependencies;
            };
            if (value instanceof Promise) value.finally(subscribeToDependencies);
            else subscribeToDependencies();
            proxyObject[key] = value;
        };
        evaluate();
    });
    return proxyObject;
}
function $6a21a7270ba6f847$export$992ed2abb18cb90(proxyObject, options) {
    const keysToDelete = (options == null ? void 0 : options.delete) ? /* @__PURE__ */ new Set() : null;
    $6a21a7270ba6f847$var$listSubscriptions(proxyObject).forEach((subscription)=>{
        const { k: key } = subscription;
        if (!(options == null ? void 0 : options.keys) || options.keys.includes(key)) {
            $6a21a7270ba6f847$var$removeSubscription(subscription);
            if (keysToDelete) keysToDelete.add(key);
        }
    });
    if (keysToDelete) keysToDelete.forEach((key)=>{
        delete proxyObject[key];
    });
}
function $6a21a7270ba6f847$export$b84fff6f79a56fa3(proxyObject, computedFns_FAKE, targetObject = proxyObject) {
    if (($6a21a7270ba6f847$import_meta.env ? $6a21a7270ba6f847$import_meta.env.MODE : void 0) !== "production") console.warn("addComputed is deprecated. Please consider using `derive`. Falling back to emulation with derive. https://github.com/pmndrs/valtio/pull/201");
    const derivedFns = {};
    Object.keys(computedFns_FAKE).forEach((key)=>{
        derivedFns[key] = (get)=>computedFns_FAKE[key](get(proxyObject));
    });
    return $6a21a7270ba6f847$export$78ed5b3305815fc7(derivedFns, {
        proxy: targetObject
    });
}
function $6a21a7270ba6f847$export$64a33e9109220e08(initialObject, computedFns) {
    if (($6a21a7270ba6f847$import_meta.env ? $6a21a7270ba6f847$import_meta.env.MODE : void 0) !== "production") console.warn('proxyWithComputed is deprecated. Please follow "Computed Properties" guide in docs.');
    Object.keys(computedFns).forEach((key)=>{
        if (Object.getOwnPropertyDescriptor(initialObject, key)) throw new Error("object property already defined");
        const computedFn = computedFns[key];
        const { get: get, set: set } = typeof computedFn === "function" ? {
            get: computedFn
        } : computedFn;
        const desc = {};
        desc.get = ()=>get((0, $esotS.snapshot)(proxyObject));
        if (set) desc.set = (newValue)=>set(proxyObject, newValue);
        Object.defineProperty(initialObject, key, desc);
    });
    const proxyObject = (0, $esotS.proxy)(initialObject);
    return proxyObject;
}
const $6a21a7270ba6f847$var$isObject = (x)=>typeof x === "object" && x !== null;
let $6a21a7270ba6f847$var$refSet;
const $6a21a7270ba6f847$var$deepClone = (obj)=>{
    if (!$6a21a7270ba6f847$var$refSet) $6a21a7270ba6f847$var$refSet = (0, $esotS.unstable_buildProxyFunction)()[2];
    if (!$6a21a7270ba6f847$var$isObject(obj) || $6a21a7270ba6f847$var$refSet.has(obj)) return obj;
    const baseObject = Array.isArray(obj) ? [] : Object.create(Object.getPrototypeOf(obj));
    Reflect.ownKeys(obj).forEach((key)=>{
        baseObject[key] = $6a21a7270ba6f847$var$deepClone(obj[key]);
    });
    return baseObject;
};
function $6a21a7270ba6f847$export$32f3091caa3ecf1e(initialValue, skipSubscribe = false) {
    const proxyObject = (0, $esotS.proxy)({
        value: initialValue,
        history: (0, $esotS.ref)({
            wip: void 0,
            // to avoid infinite loop
            snapshots: [],
            index: -1
        }),
        clone: $6a21a7270ba6f847$var$deepClone,
        canUndo: ()=>proxyObject.history.index > 0,
        undo: ()=>{
            if (proxyObject.canUndo()) proxyObject.value = proxyObject.history.wip = proxyObject.clone(proxyObject.history.snapshots[--proxyObject.history.index]);
        },
        canRedo: ()=>proxyObject.history.index < proxyObject.history.snapshots.length - 1,
        redo: ()=>{
            if (proxyObject.canRedo()) proxyObject.value = proxyObject.history.wip = proxyObject.clone(proxyObject.history.snapshots[++proxyObject.history.index]);
        },
        saveHistory: ()=>{
            proxyObject.history.snapshots.splice(proxyObject.history.index + 1);
            proxyObject.history.snapshots.push((0, $esotS.snapshot)(proxyObject).value);
            ++proxyObject.history.index;
        },
        subscribe: ()=>(0, $esotS.subscribe)(proxyObject, (ops)=>{
                if (ops.every((op)=>op[1][0] === "value" && (op[0] !== "set" || op[2] !== proxyObject.history.wip))) proxyObject.saveHistory();
            })
    });
    proxyObject.saveHistory();
    if (!skipSubscribe) proxyObject.subscribe();
    return proxyObject;
}
function $6a21a7270ba6f847$export$339ebc24fb22ad80(initialValues) {
    const set = (0, $esotS.proxy)({
        data: Array.from(new Set(initialValues)),
        has (value) {
            return this.data.indexOf(value) !== -1;
        },
        add (value) {
            let hasProxy = false;
            if (typeof value === "object" && value !== null) hasProxy = this.data.indexOf((0, $esotS.proxy)(value)) !== -1;
            if (this.data.indexOf(value) === -1 && !hasProxy) this.data.push(value);
            return this;
        },
        delete (value) {
            const index = this.data.indexOf(value);
            if (index === -1) return false;
            this.data.splice(index, 1);
            return true;
        },
        clear () {
            this.data.splice(0);
        },
        get size () {
            return this.data.length;
        },
        forEach (cb) {
            this.data.forEach((value)=>{
                cb(value, value, this);
            });
        },
        get [Symbol.toStringTag] () {
            return "Set";
        },
        toJSON () {
            return new Set(this.data);
        },
        [Symbol.iterator] () {
            return this.data[Symbol.iterator]();
        },
        values () {
            return this.data.values();
        },
        keys () {
            return this.data.values();
        },
        entries () {
            return new Set(this.data).entries();
        }
    });
    Object.defineProperties(set, {
        data: {
            enumerable: false
        },
        size: {
            enumerable: false
        },
        toJSON: {
            enumerable: false
        }
    });
    Object.seal(set);
    return set;
}
function $6a21a7270ba6f847$export$17aaac2670e0d2b9(entries) {
    const map = (0, $esotS.proxy)({
        data: Array.from(entries || []),
        has (key) {
            return this.data.some((p)=>p[0] === key);
        },
        set (key, value) {
            const record = this.data.find((p)=>p[0] === key);
            if (record) record[1] = value;
            else this.data.push([
                key,
                value
            ]);
            return this;
        },
        get (key) {
            var _a;
            return (_a = this.data.find((p)=>p[0] === key)) == null ? void 0 : _a[1];
        },
        delete (key) {
            const index = this.data.findIndex((p)=>p[0] === key);
            if (index === -1) return false;
            this.data.splice(index, 1);
            return true;
        },
        clear () {
            this.data.splice(0);
        },
        get size () {
            return this.data.length;
        },
        toJSON () {
            return new Map(this.data);
        },
        forEach (cb) {
            this.data.forEach((p)=>{
                cb(p[1], p[0], this);
            });
        },
        keys () {
            return this.data.map((p)=>p[0]).values();
        },
        values () {
            return this.data.map((p)=>p[1]).values();
        },
        entries () {
            return new Map(this.data).entries();
        },
        get [Symbol.toStringTag] () {
            return "Map";
        },
        [Symbol.iterator] () {
            return this.entries();
        }
    });
    Object.defineProperties(map, {
        data: {
            enumerable: false
        },
        size: {
            enumerable: false
        },
        toJSON: {
            enumerable: false
        }
    });
    Object.seal(map);
    return map;
}

});

parcelRegister("5mrMQ", function(module, exports) {

$parcel$export(module.exports, "AccountController", () => $3e748fb130fb804c$export$3a40b83c1282ee40);

var $hZH4A = parcelRequire("hZH4A");

var $esotS = parcelRequire("esotS");

var $kGR8V = parcelRequire("kGR8V");
const $3e748fb130fb804c$var$state = (0, $esotS.proxy)({
    isConnected: false
});
const $3e748fb130fb804c$export$3a40b83c1282ee40 = {
    state: $3e748fb130fb804c$var$state,
    subscribe (callback) {
        return (0, $esotS.subscribe)($3e748fb130fb804c$var$state, ()=>callback($3e748fb130fb804c$var$state));
    },
    subscribeKey (key, callback) {
        return (0, $hZH4A.subscribeKey)($3e748fb130fb804c$var$state, key, callback);
    },
    setIsConnected (isConnected) {
        $3e748fb130fb804c$var$state.isConnected = isConnected;
    },
    setCaipAddress (caipAddress) {
        $3e748fb130fb804c$var$state.caipAddress = caipAddress;
        $3e748fb130fb804c$var$state.address = caipAddress ? (0, $kGR8V.CoreHelperUtil).getPlainAddress(caipAddress) : undefined;
    },
    setBalance (balance, balanceSymbol) {
        $3e748fb130fb804c$var$state.balance = balance;
        $3e748fb130fb804c$var$state.balanceSymbol = balanceSymbol;
    },
    setProfileName (profileName) {
        $3e748fb130fb804c$var$state.profileName = profileName;
    },
    setProfileImage (profileImage) {
        $3e748fb130fb804c$var$state.profileImage = profileImage;
    },
    setAddressExplorerUrl (explorerUrl) {
        $3e748fb130fb804c$var$state.addressExplorerUrl = explorerUrl;
    },
    resetAccount () {
        $3e748fb130fb804c$var$state.isConnected = false;
        $3e748fb130fb804c$var$state.caipAddress = undefined;
        $3e748fb130fb804c$var$state.address = undefined;
        $3e748fb130fb804c$var$state.balance = undefined;
        $3e748fb130fb804c$var$state.balanceSymbol = undefined;
        $3e748fb130fb804c$var$state.profileName = undefined;
        $3e748fb130fb804c$var$state.profileImage = undefined;
        $3e748fb130fb804c$var$state.addressExplorerUrl = undefined;
    }
};

});
parcelRegister("kGR8V", function(module, exports) {

$parcel$export(module.exports, "CoreHelperUtil", () => $f100f3f9d93283ae$export$d8fe68a4208d58ff);

var $5S5Lx = parcelRequire("5S5Lx");
const $f100f3f9d93283ae$export$d8fe68a4208d58ff = {
    isMobile () {
        if (typeof window !== "undefined") return Boolean(window.matchMedia("(pointer:coarse)").matches || /Android|webOS|iPhone|iPad|iPod|BlackBerry|Opera Mini/u.test(navigator.userAgent));
        return false;
    },
    isAndroid () {
        const ua = window.navigator.userAgent.toLowerCase();
        return $f100f3f9d93283ae$export$d8fe68a4208d58ff.isMobile() && ua.includes("android");
    },
    isIos () {
        const ua = window.navigator.userAgent.toLowerCase();
        return $f100f3f9d93283ae$export$d8fe68a4208d58ff.isMobile() && (ua.includes("iphone") || ua.includes("ipad"));
    },
    isClient () {
        return typeof window !== "undefined";
    },
    isPairingExpired (expiry) {
        return expiry ? expiry - Date.now() <= (0, $5S5Lx.ConstantsUtil).TEN_SEC_MS : true;
    },
    isAllowedRetry (lastRetry) {
        return Date.now() - lastRetry >= (0, $5S5Lx.ConstantsUtil).ONE_SEC_MS;
    },
    copyToClopboard (text) {
        navigator.clipboard.writeText(text);
    },
    getPairingExpiry () {
        return Date.now() + (0, $5S5Lx.ConstantsUtil).FOUR_MINUTES_MS;
    },
    getPlainAddress (caipAddress) {
        return caipAddress.split(":")[2];
    },
    async wait (milliseconds) {
        return new Promise((resolve)=>{
            setTimeout(resolve, milliseconds);
        });
    },
    debounce (func, timeout = 500) {
        let timer = undefined;
        return (...args)=>{
            function next() {
                func(...args);
            }
            if (timer) clearTimeout(timer);
            timer = setTimeout(next, timeout);
        };
    },
    isHttpUrl (url) {
        return url.startsWith("http://") || url.startsWith("https://");
    },
    formatNativeUrl (appUrl, wcUri) {
        if ($f100f3f9d93283ae$export$d8fe68a4208d58ff.isHttpUrl(appUrl)) return this.formatUniversalUrl(appUrl, wcUri);
        let safeAppUrl = appUrl;
        if (!safeAppUrl.includes("://")) {
            safeAppUrl = appUrl.replaceAll("/", "").replaceAll(":", "");
            safeAppUrl = `${safeAppUrl}://`;
        }
        if (!safeAppUrl.endsWith("/")) safeAppUrl = `${safeAppUrl}/`;
        const encodedWcUrl = encodeURIComponent(wcUri);
        return {
            redirect: `${safeAppUrl}wc?uri=${encodedWcUrl}`,
            href: safeAppUrl
        };
    },
    formatUniversalUrl (appUrl, wcUri) {
        if (!$f100f3f9d93283ae$export$d8fe68a4208d58ff.isHttpUrl(appUrl)) return this.formatNativeUrl(appUrl, wcUri);
        let safeAppUrl = appUrl;
        if (!safeAppUrl.endsWith("/")) safeAppUrl = `${safeAppUrl}/`;
        const encodedWcUrl = encodeURIComponent(wcUri);
        return {
            redirect: `${safeAppUrl}wc?uri=${encodedWcUrl}`,
            href: safeAppUrl
        };
    },
    openHref (href, target, features) {
        window.open(href, target, features || "noreferrer noopener");
    },
    async preloadImage (src) {
        const imagePromise = new Promise((resolve, reject)=>{
            const image = new Image();
            image.onload = resolve;
            image.onerror = reject;
            image.crossOrigin = "anonymous";
            image.src = src;
        });
        return Promise.race([
            imagePromise,
            $f100f3f9d93283ae$export$d8fe68a4208d58ff.wait(2000)
        ]);
    },
    formatBalance (balance, symbol) {
        let formattedBalance = undefined;
        if (balance === "0") formattedBalance = "0.000";
        else if (typeof balance === "string") {
            const number = Number(balance);
            if (number) formattedBalance = number.toString().match(/^-?\d+(?:\.\d{0,3})?/u)?.[0];
        }
        return formattedBalance ? `${formattedBalance} ${symbol ?? ""}` : `0.000 ${symbol ?? ""}`;
    },
    formatBalance2 (balance, symbol) {
        let formattedBalance = undefined;
        if (balance === "0") formattedBalance = "0";
        else if (typeof balance === "string") {
            const number = Number(balance);
            if (number) formattedBalance = number.toString().match(/^-?\d+(?:\.\d{0,3})?/u)?.[0];
        }
        return {
            value: formattedBalance ?? "0",
            rest: formattedBalance === "0" ? "000" : "",
            symbol: symbol
        };
    },
    isRestrictedRegion () {
        try {
            const { timeZone: timeZone } = new Intl.DateTimeFormat().resolvedOptions();
            const capTimeZone = timeZone.toUpperCase();
            return (0, $5S5Lx.ConstantsUtil).RESTRICTED_TIMEZONES.includes(capTimeZone);
        } catch  {
            return false;
        }
    },
    getApiUrl () {
        return $f100f3f9d93283ae$export$d8fe68a4208d58ff.isRestrictedRegion() ? "https://api.web3modal.org" : "https://api.web3modal.com";
    },
    getBlockchainApiUrl () {
        return $f100f3f9d93283ae$export$d8fe68a4208d58ff.isRestrictedRegion() ? "https://rpc.walletconnect.org" : "https://rpc.walletconnect.com";
    },
    getAnalyticsUrl () {
        return $f100f3f9d93283ae$export$d8fe68a4208d58ff.isRestrictedRegion() ? "https://pulse.walletconnect.org" : "https://pulse.walletconnect.com";
    },
    getUUID () {
        if (crypto?.randomUUID) return crypto.randomUUID();
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/gu, (c)=>{
            const r = Math.random() * 16 | 0;
            const v = c === "x" ? r : r & 0x3 | 0x8;
            return v.toString(16);
        });
    },
    parseError (error) {
        if (typeof error === "string") return error;
        else if (typeof error?.issues?.[0]?.message === "string") return error.issues[0].message;
        else if (error instanceof Error) return error.message;
        return "Unknown error";
    },
    sortRequestedNetworks (approvedIds, requestedNetworks = []) {
        const approvedIndexMap = {};
        if (requestedNetworks && approvedIds) {
            approvedIds.forEach((id, index)=>{
                approvedIndexMap[id] = index;
            });
            requestedNetworks.sort((a, b)=>{
                const indexA = approvedIndexMap[a.id];
                const indexB = approvedIndexMap[b.id];
                if (indexA !== undefined && indexB !== undefined) return indexA - indexB;
                else if (indexA !== undefined) return -1;
                else if (indexB !== undefined) return 1;
                return 0;
            });
        }
        return requestedNetworks;
    }
};

});
parcelRegister("5S5Lx", function(module, exports) {

$parcel$export(module.exports, "ONRAMP_PROVIDERS", () => $446677d9ac4b0fee$export$e021b4b4649620f6);
$parcel$export(module.exports, "ConstantsUtil", () => $446677d9ac4b0fee$export$aafe1f751f1bc52a);
const $446677d9ac4b0fee$var$SECURE_SITE = "https://secure.walletconnect.com";
const $446677d9ac4b0fee$export$e021b4b4649620f6 = [
    {
        label: "Coinbase",
        name: "coinbase",
        feeRange: "1-2%",
        url: ""
    }
];
const $446677d9ac4b0fee$export$aafe1f751f1bc52a = {
    FOUR_MINUTES_MS: 240000,
    TEN_SEC_MS: 10000,
    ONE_SEC_MS: 1000,
    SECURE_SITE: $446677d9ac4b0fee$var$SECURE_SITE,
    SECURE_SITE_DASHBOARD: `${$446677d9ac4b0fee$var$SECURE_SITE}/dashboard`,
    SECURE_SITE_FAVICON: `${$446677d9ac4b0fee$var$SECURE_SITE}/images/favicon.png`,
    RESTRICTED_TIMEZONES: [
        "ASIA/SHANGHAI",
        "ASIA/URUMQI",
        "ASIA/CHONGQING",
        "ASIA/HARBIN",
        "ASIA/KASHGAR",
        "ASIA/MACAU",
        "ASIA/HONG_KONG",
        "ASIA/MACAO",
        "ASIA/BEIJING",
        "ASIA/HARBIN"
    ],
    CONNECTOR_RDNS_MAP: {
        coinbaseWallet: "com.coinbase.wallet"
    },
    WC_COINBASE_PAY_SDK_CHAINS: [
        "ethereum",
        "arbitrum",
        "polygon",
        "avalanche-c-chain",
        "optimism",
        "celo",
        "base"
    ],
    WC_COINBASE_PAY_SDK_FALLBACK_CHAIN: "ethereum",
    WC_COINBASE_PAY_SDK_CHAIN_NAME_MAP: {
        Ethereum: "ethereum",
        "Arbitrum One": "arbitrum",
        Polygon: "polygon",
        Avalanche: "avalanche-c-chain",
        "OP Mainnet": "optimism",
        Celo: "celo",
        Base: "base"
    },
    WC_COINBASE_ONRAMP_APP_ID: "bf18c88d-495a-463b-b249-0b9d3656cf5e"
};

});



parcelRegister("6tAXH", function(module, exports) {

$parcel$export(module.exports, "ApiController", () => $4b721f620ffee778$export$99411f73957952af);

var $hZH4A = parcelRequire("hZH4A");

var $esotS = parcelRequire("esotS");

var $kGR8V = parcelRequire("kGR8V");

var $MKSXD = parcelRequire("MKSXD");

var $heSwZ = parcelRequire("heSwZ");

var $hCakD = parcelRequire("hCakD");

var $9QkaU = parcelRequire("9QkaU");

var $b6tQF = parcelRequire("b6tQF");

var $8KEpV = parcelRequire("8KEpV");
const $4b721f620ffee778$var$baseUrl = (0, $kGR8V.CoreHelperUtil).getApiUrl();
const $4b721f620ffee778$export$644d8ea042df96a6 = new (0, $MKSXD.FetchUtil)({
    baseUrl: $4b721f620ffee778$var$baseUrl
});
const $4b721f620ffee778$var$entries = "40";
const $4b721f620ffee778$var$recommendedEntries = "4";
const $4b721f620ffee778$var$state = (0, $esotS.proxy)({
    page: 1,
    count: 0,
    featured: [],
    recommended: [],
    wallets: [],
    search: [],
    isAnalyticsEnabled: false
});
const $4b721f620ffee778$export$99411f73957952af = {
    state: $4b721f620ffee778$var$state,
    subscribeKey (key, callback) {
        return (0, $hZH4A.subscribeKey)($4b721f620ffee778$var$state, key, callback);
    },
    _getApiHeaders () {
        const { projectId: projectId, sdkType: sdkType, sdkVersion: sdkVersion } = (0, $8KEpV.OptionsController).state;
        return {
            "x-project-id": projectId,
            "x-sdk-type": sdkType,
            "x-sdk-version": sdkVersion
        };
    },
    async _fetchWalletImage (imageId) {
        const imageUrl = `${$4b721f620ffee778$export$644d8ea042df96a6.baseUrl}/getWalletImage/${imageId}`;
        const blob = await $4b721f620ffee778$export$644d8ea042df96a6.getBlob({
            path: imageUrl,
            headers: $4b721f620ffee778$export$99411f73957952af._getApiHeaders()
        });
        (0, $hCakD.AssetController).setWalletImage(imageId, URL.createObjectURL(blob));
    },
    async _fetchNetworkImage (imageId) {
        const imageUrl = `${$4b721f620ffee778$export$644d8ea042df96a6.baseUrl}/public/getAssetImage/${imageId}`;
        const blob = await $4b721f620ffee778$export$644d8ea042df96a6.getBlob({
            path: imageUrl,
            headers: $4b721f620ffee778$export$99411f73957952af._getApiHeaders()
        });
        (0, $hCakD.AssetController).setNetworkImage(imageId, URL.createObjectURL(blob));
    },
    async _fetchConnectorImage (imageId) {
        const imageUrl = `${$4b721f620ffee778$export$644d8ea042df96a6.baseUrl}/public/getAssetImage/${imageId}`;
        const blob = await $4b721f620ffee778$export$644d8ea042df96a6.getBlob({
            path: imageUrl,
            headers: $4b721f620ffee778$export$99411f73957952af._getApiHeaders()
        });
        (0, $hCakD.AssetController).setConnectorImage(imageId, URL.createObjectURL(blob));
    },
    async _fetchCurrencyImage (countryCode) {
        const imageUrl = `${$4b721f620ffee778$export$644d8ea042df96a6.baseUrl}/public/getCurrencyImage/${countryCode}`;
        const blob = await $4b721f620ffee778$export$644d8ea042df96a6.getBlob({
            path: imageUrl,
            headers: $4b721f620ffee778$export$99411f73957952af._getApiHeaders()
        });
        (0, $hCakD.AssetController).setCurrencyImage(countryCode, URL.createObjectURL(blob));
    },
    async _fetchTokenImage (symbol) {
        const imageUrl = `${$4b721f620ffee778$export$644d8ea042df96a6.baseUrl}/public/getTokenImage/${symbol}`;
        const blob = await $4b721f620ffee778$export$644d8ea042df96a6.getBlob({
            path: imageUrl,
            headers: $4b721f620ffee778$export$99411f73957952af._getApiHeaders()
        });
        (0, $hCakD.AssetController).setTokenImage(symbol, URL.createObjectURL(blob));
    },
    async fetchNetworkImages () {
        const { requestedCaipNetworks: requestedCaipNetworks } = (0, $b6tQF.NetworkController).state;
        const ids = requestedCaipNetworks?.map(({ imageId: imageId })=>imageId).filter(Boolean);
        if (ids) await Promise.allSettled(ids.map((id)=>$4b721f620ffee778$export$99411f73957952af._fetchNetworkImage(id)));
    },
    async fetchConnectorImages () {
        const { connectors: connectors } = (0, $9QkaU.ConnectorController).state;
        const ids = connectors.map(({ imageId: imageId })=>imageId).filter(Boolean);
        await Promise.allSettled(ids.map((id)=>$4b721f620ffee778$export$99411f73957952af._fetchConnectorImage(id)));
    },
    async fetchCurrencyImages (currencies = []) {
        await Promise.allSettled(currencies.map((currency)=>$4b721f620ffee778$export$99411f73957952af._fetchCurrencyImage(currency)));
    },
    async fetchTokenImages (tokens = []) {
        await Promise.allSettled(tokens.map((token)=>$4b721f620ffee778$export$99411f73957952af._fetchTokenImage(token)));
    },
    async fetchFeaturedWallets () {
        const { featuredWalletIds: featuredWalletIds } = (0, $8KEpV.OptionsController).state;
        if (featuredWalletIds?.length) {
            const { data: data } = await $4b721f620ffee778$export$644d8ea042df96a6.get({
                path: "/getWallets",
                headers: $4b721f620ffee778$export$99411f73957952af._getApiHeaders(),
                params: {
                    page: "1",
                    entries: featuredWalletIds?.length ? String(featuredWalletIds.length) : $4b721f620ffee778$var$recommendedEntries,
                    include: featuredWalletIds?.join(",")
                }
            });
            data.sort((a, b)=>featuredWalletIds.indexOf(a.id) - featuredWalletIds.indexOf(b.id));
            const images = data.map((d)=>d.image_id).filter(Boolean);
            await Promise.allSettled(images.map((id)=>$4b721f620ffee778$export$99411f73957952af._fetchWalletImage(id)));
            $4b721f620ffee778$var$state.featured = data;
        }
    },
    async fetchRecommendedWallets () {
        const { includeWalletIds: includeWalletIds, excludeWalletIds: excludeWalletIds, featuredWalletIds: featuredWalletIds } = (0, $8KEpV.OptionsController).state;
        const exclude = [
            ...excludeWalletIds ?? [],
            ...featuredWalletIds ?? []
        ].filter(Boolean);
        const { data: data, count: count } = await $4b721f620ffee778$export$644d8ea042df96a6.get({
            path: "/getWallets",
            headers: $4b721f620ffee778$export$99411f73957952af._getApiHeaders(),
            params: {
                page: "1",
                entries: $4b721f620ffee778$var$recommendedEntries,
                include: includeWalletIds?.join(","),
                exclude: exclude?.join(",")
            }
        });
        const recent = (0, $heSwZ.StorageUtil).getRecentWallets();
        const recommendedImages = data.map((d)=>d.image_id).filter(Boolean);
        const recentImages = recent.map((r)=>r.image_id).filter(Boolean);
        await Promise.allSettled([
            ...recommendedImages,
            ...recentImages
        ].map((id)=>$4b721f620ffee778$export$99411f73957952af._fetchWalletImage(id)));
        $4b721f620ffee778$var$state.recommended = data;
        $4b721f620ffee778$var$state.count = count ?? 0;
    },
    async fetchWallets ({ page: page }) {
        const { includeWalletIds: includeWalletIds, excludeWalletIds: excludeWalletIds, featuredWalletIds: featuredWalletIds } = (0, $8KEpV.OptionsController).state;
        const exclude = [
            ...$4b721f620ffee778$var$state.recommended.map(({ id: id })=>id),
            ...excludeWalletIds ?? [],
            ...featuredWalletIds ?? []
        ].filter(Boolean);
        const { data: data, count: count } = await $4b721f620ffee778$export$644d8ea042df96a6.get({
            path: "/getWallets",
            headers: $4b721f620ffee778$export$99411f73957952af._getApiHeaders(),
            params: {
                page: String(page),
                entries: $4b721f620ffee778$var$entries,
                include: includeWalletIds?.join(","),
                exclude: exclude.join(",")
            }
        });
        const images = data.map((w)=>w.image_id).filter(Boolean);
        await Promise.allSettled([
            ...images.map((id)=>$4b721f620ffee778$export$99411f73957952af._fetchWalletImage(id)),
            (0, $kGR8V.CoreHelperUtil).wait(300)
        ]);
        $4b721f620ffee778$var$state.wallets = [
            ...$4b721f620ffee778$var$state.wallets,
            ...data
        ];
        $4b721f620ffee778$var$state.count = count > $4b721f620ffee778$var$state.count ? count : $4b721f620ffee778$var$state.count;
        $4b721f620ffee778$var$state.page = page;
    },
    async searchWallet ({ search: search }) {
        const { includeWalletIds: includeWalletIds, excludeWalletIds: excludeWalletIds } = (0, $8KEpV.OptionsController).state;
        $4b721f620ffee778$var$state.search = [];
        const { data: data } = await $4b721f620ffee778$export$644d8ea042df96a6.get({
            path: "/getWallets",
            headers: $4b721f620ffee778$export$99411f73957952af._getApiHeaders(),
            params: {
                page: "1",
                entries: "100",
                search: search,
                include: includeWalletIds?.join(","),
                exclude: excludeWalletIds?.join(",")
            }
        });
        const images = data.map((w)=>w.image_id).filter(Boolean);
        await Promise.allSettled([
            ...images.map((id)=>$4b721f620ffee778$export$99411f73957952af._fetchWalletImage(id)),
            (0, $kGR8V.CoreHelperUtil).wait(300)
        ]);
        $4b721f620ffee778$var$state.search = data;
    },
    prefetch () {
        const promises = [
            $4b721f620ffee778$export$99411f73957952af.fetchFeaturedWallets(),
            $4b721f620ffee778$export$99411f73957952af.fetchRecommendedWallets(),
            $4b721f620ffee778$export$99411f73957952af.fetchNetworkImages(),
            $4b721f620ffee778$export$99411f73957952af.fetchConnectorImages()
        ];
        if ((0, $8KEpV.OptionsController).state.enableAnalytics === undefined) promises.push($4b721f620ffee778$export$99411f73957952af.fetchAnalyticsConfig());
        $4b721f620ffee778$var$state.prefetchPromise = Promise.race([
            Promise.allSettled(promises),
            (0, $kGR8V.CoreHelperUtil).wait(3000)
        ]);
    },
    async fetchAnalyticsConfig () {
        const { isAnalyticsEnabled: isAnalyticsEnabled } = await $4b721f620ffee778$export$644d8ea042df96a6.get({
            path: "/getAnalyticsConfig",
            headers: $4b721f620ffee778$export$99411f73957952af._getApiHeaders()
        });
        (0, $8KEpV.OptionsController).setEnableAnalytics(isAnalyticsEnabled);
    }
};

});
parcelRegister("MKSXD", function(module, exports) {

$parcel$export(module.exports, "FetchUtil", () => $0928da495128e55f$export$ed6eff17d860976a);
class $0928da495128e55f$export$ed6eff17d860976a {
    constructor({ baseUrl: baseUrl }){
        this.baseUrl = baseUrl;
    }
    async get({ headers: headers, signal: signal, ...args }) {
        const url = this.createUrl(args);
        const response = await fetch(url, {
            method: "GET",
            headers: headers,
            signal: signal,
            cache: "no-cache"
        });
        return response.json();
    }
    async getBlob({ headers: headers, signal: signal, ...args }) {
        const url = this.createUrl(args);
        const response = await fetch(url, {
            method: "GET",
            headers: headers,
            signal: signal
        });
        return response.blob();
    }
    async post({ body: body, headers: headers, signal: signal, ...args }) {
        const url = this.createUrl(args);
        const response = await fetch(url, {
            method: "POST",
            headers: headers,
            body: body ? JSON.stringify(body) : undefined,
            signal: signal
        });
        return response.json();
    }
    async put({ body: body, headers: headers, signal: signal, ...args }) {
        const url = this.createUrl(args);
        const response = await fetch(url, {
            method: "PUT",
            headers: headers,
            body: body ? JSON.stringify(body) : undefined,
            signal: signal
        });
        return response.json();
    }
    async delete({ body: body, headers: headers, signal: signal, ...args }) {
        const url = this.createUrl(args);
        const response = await fetch(url, {
            method: "DELETE",
            headers: headers,
            body: body ? JSON.stringify(body) : undefined,
            signal: signal
        });
        return response.json();
    }
    createUrl({ path: path, params: params }) {
        const url = new URL(path, this.baseUrl);
        if (params) Object.entries(params).forEach(([key, value])=>{
            if (value) url.searchParams.append(key, value);
        });
        return url;
    }
}

});

parcelRegister("heSwZ", function(module, exports) {

$parcel$export(module.exports, "StorageUtil", () => $c8ce0b3a2c6e9df8$export$d4382c6359971b24);
const $c8ce0b3a2c6e9df8$var$WC_DEEPLINK = "WALLETCONNECT_DEEPLINK_CHOICE";
const $c8ce0b3a2c6e9df8$var$W3M_RECENT = "@w3m/recent";
const $c8ce0b3a2c6e9df8$var$W3M_CONNECTED_WALLET_IMAGE_URL = "@w3m/connected_wallet_image_url";
const $c8ce0b3a2c6e9df8$var$W3M_CONNECTED_CONNECTOR = "@w3m/connected_connector";
const $c8ce0b3a2c6e9df8$export$d4382c6359971b24 = {
    setWalletConnectDeepLink ({ href: href, name: name }) {
        try {
            localStorage.setItem($c8ce0b3a2c6e9df8$var$WC_DEEPLINK, JSON.stringify({
                href: href,
                name: name
            }));
        } catch  {
            console.info("Unable to set WalletConnect deep link");
        }
    },
    getWalletConnectDeepLink () {
        try {
            const deepLink = localStorage.getItem($c8ce0b3a2c6e9df8$var$WC_DEEPLINK);
            if (deepLink) return JSON.parse(deepLink);
        } catch  {
            console.info("Unable to get WalletConnect deep link");
        }
        return undefined;
    },
    deleteWalletConnectDeepLink () {
        try {
            localStorage.removeItem($c8ce0b3a2c6e9df8$var$WC_DEEPLINK);
        } catch  {
            console.info("Unable to delete WalletConnect deep link");
        }
    },
    setWeb3ModalRecent (wallet) {
        try {
            const recentWallets = $c8ce0b3a2c6e9df8$export$d4382c6359971b24.getRecentWallets();
            const exists = recentWallets.find((w)=>w.id === wallet.id);
            if (!exists) {
                recentWallets.unshift(wallet);
                if (recentWallets.length > 2) recentWallets.pop();
                localStorage.setItem($c8ce0b3a2c6e9df8$var$W3M_RECENT, JSON.stringify(recentWallets));
            }
        } catch  {
            console.info("Unable to set Web3Modal recent");
        }
    },
    getRecentWallets () {
        try {
            const recent = localStorage.getItem($c8ce0b3a2c6e9df8$var$W3M_RECENT);
            return recent ? JSON.parse(recent) : [];
        } catch  {
            console.info("Unable to get Web3Modal recent");
        }
        return [];
    },
    setConnectedWalletImageUrl (imageUrl) {
        try {
            localStorage.setItem($c8ce0b3a2c6e9df8$var$W3M_CONNECTED_WALLET_IMAGE_URL, imageUrl);
        } catch  {
            console.info("Unable to set Connected Wallet Image Url");
        }
    },
    getConnectedWalletImageUrl () {
        try {
            return localStorage.getItem($c8ce0b3a2c6e9df8$var$W3M_CONNECTED_WALLET_IMAGE_URL);
        } catch  {
            console.info("Unable to set Connected Wallet Image Url");
        }
        return undefined;
    },
    setConnectedConnector (connectorType) {
        try {
            localStorage.setItem($c8ce0b3a2c6e9df8$var$W3M_CONNECTED_CONNECTOR, connectorType);
        } catch  {
            console.info("Unable to set Connected Connector");
        }
    },
    getConnectedConnector () {
        try {
            return localStorage.getItem($c8ce0b3a2c6e9df8$var$W3M_CONNECTED_CONNECTOR);
        } catch  {
            console.info("Unable to get Connected Connector");
        }
        return undefined;
    }
};

});

parcelRegister("hCakD", function(module, exports) {

$parcel$export(module.exports, "AssetController", () => $cd2dfff7baf3d9b8$export$4f2a98fee99335);

var $hZH4A = parcelRequire("hZH4A");

var $esotS = parcelRequire("esotS");
const $cd2dfff7baf3d9b8$var$state = (0, $esotS.proxy)({
    walletImages: {},
    networkImages: {},
    connectorImages: {},
    tokenImages: {},
    currencyImages: {}
});
const $cd2dfff7baf3d9b8$export$4f2a98fee99335 = {
    state: $cd2dfff7baf3d9b8$var$state,
    subscribeNetworkImages (callback) {
        return (0, $esotS.subscribe)($cd2dfff7baf3d9b8$var$state.networkImages, ()=>callback($cd2dfff7baf3d9b8$var$state.networkImages));
    },
    subscribeKey (key, callback) {
        return (0, $hZH4A.subscribeKey)($cd2dfff7baf3d9b8$var$state, key, callback);
    },
    subscribe (callback) {
        return (0, $esotS.subscribe)($cd2dfff7baf3d9b8$var$state, ()=>callback($cd2dfff7baf3d9b8$var$state));
    },
    setWalletImage (key, value) {
        $cd2dfff7baf3d9b8$var$state.walletImages[key] = value;
    },
    setNetworkImage (key, value) {
        $cd2dfff7baf3d9b8$var$state.networkImages[key] = value;
    },
    setConnectorImage (key, value) {
        $cd2dfff7baf3d9b8$var$state.connectorImages[key] = value;
    },
    setTokenImage (key, value) {
        $cd2dfff7baf3d9b8$var$state.tokenImages[key] = value;
    },
    setCurrencyImage (key, value) {
        $cd2dfff7baf3d9b8$var$state.currencyImages[key] = value;
    }
};

});

parcelRegister("9QkaU", function(module, exports) {

$parcel$export(module.exports, "ConnectorController", () => $72a89eb8c022acd9$export$c83edcb4eee2f517);

var $hZH4A = parcelRequire("hZH4A");

var $esotS = parcelRequire("esotS");

var $8KEpV = parcelRequire("8KEpV");

var $fyCFg = parcelRequire("fyCFg");
const $72a89eb8c022acd9$var$state = (0, $esotS.proxy)({
    connectors: []
});
const $72a89eb8c022acd9$export$c83edcb4eee2f517 = {
    state: $72a89eb8c022acd9$var$state,
    subscribeKey (key, callback) {
        return (0, $hZH4A.subscribeKey)($72a89eb8c022acd9$var$state, key, callback);
    },
    setConnectors (connectors) {
        $72a89eb8c022acd9$var$state.connectors = connectors.map((c)=>(0, $esotS.ref)(c));
    },
    addConnector (connector) {
        $72a89eb8c022acd9$var$state.connectors.push((0, $esotS.ref)(connector));
        if (connector.id === "w3mEmail") {
            const emailConnector = connector;
            const optionsState = (0, $esotS.snapshot)((0, $8KEpV.OptionsController).state);
            emailConnector?.provider?.syncDappData?.({
                metadata: optionsState.metadata,
                sdkVersion: optionsState.sdkVersion,
                projectId: optionsState.projectId
            });
            emailConnector.provider.syncTheme({
                themeMode: (0, $fyCFg.ThemeController).getSnapshot().themeMode,
                themeVariables: (0, $fyCFg.ThemeController).getSnapshot().themeVariables
            });
        }
    },
    getEmailConnector () {
        return $72a89eb8c022acd9$var$state.connectors.find((c)=>c.type === "EMAIL");
    },
    getAnnouncedConnectorRdns () {
        return $72a89eb8c022acd9$var$state.connectors.filter((c)=>c.type === "ANNOUNCED").map((c)=>c.info?.rdns);
    },
    getConnectors () {
        return $72a89eb8c022acd9$var$state.connectors;
    }
};

});
parcelRegister("8KEpV", function(module, exports) {

$parcel$export(module.exports, "OptionsController", () => $65f1f8a023c52c0e$export$1f4c428077fc6173);

var $hZH4A = parcelRequire("hZH4A");

var $esotS = parcelRequire("esotS");
const $65f1f8a023c52c0e$var$state = (0, $esotS.proxy)({
    projectId: "",
    sdkType: "w3m",
    sdkVersion: "html-wagmi-undefined"
});
const $65f1f8a023c52c0e$export$1f4c428077fc6173 = {
    state: $65f1f8a023c52c0e$var$state,
    subscribeKey (key, callback) {
        return (0, $hZH4A.subscribeKey)($65f1f8a023c52c0e$var$state, key, callback);
    },
    setProjectId (projectId) {
        $65f1f8a023c52c0e$var$state.projectId = projectId;
    },
    setAllWallets (allWallets) {
        $65f1f8a023c52c0e$var$state.allWallets = allWallets;
    },
    setIncludeWalletIds (includeWalletIds) {
        $65f1f8a023c52c0e$var$state.includeWalletIds = includeWalletIds;
    },
    setExcludeWalletIds (excludeWalletIds) {
        $65f1f8a023c52c0e$var$state.excludeWalletIds = excludeWalletIds;
    },
    setFeaturedWalletIds (featuredWalletIds) {
        $65f1f8a023c52c0e$var$state.featuredWalletIds = featuredWalletIds;
    },
    setTokens (tokens) {
        $65f1f8a023c52c0e$var$state.tokens = tokens;
    },
    setTermsConditionsUrl (termsConditionsUrl) {
        $65f1f8a023c52c0e$var$state.termsConditionsUrl = termsConditionsUrl;
    },
    setPrivacyPolicyUrl (privacyPolicyUrl) {
        $65f1f8a023c52c0e$var$state.privacyPolicyUrl = privacyPolicyUrl;
    },
    setCustomWallets (customWallets) {
        $65f1f8a023c52c0e$var$state.customWallets = customWallets;
    },
    setEnableAnalytics (enableAnalytics) {
        $65f1f8a023c52c0e$var$state.enableAnalytics = enableAnalytics;
    },
    setSdkVersion (sdkVersion) {
        $65f1f8a023c52c0e$var$state.sdkVersion = sdkVersion;
    },
    setMetadata (metadata) {
        $65f1f8a023c52c0e$var$state.metadata = metadata;
    },
    setOnrampEnabled (enableOnramp) {
        $65f1f8a023c52c0e$var$state.enableOnramp = enableOnramp;
    }
};

});

parcelRegister("fyCFg", function(module, exports) {

$parcel$export(module.exports, "ThemeController", () => $b53805f27a20a9df$export$e18d4112326e72bf);

var $esotS = parcelRequire("esotS");

var $9QkaU = parcelRequire("9QkaU");
const $b53805f27a20a9df$var$state = (0, $esotS.proxy)({
    themeMode: "dark",
    themeVariables: {}
});
const $b53805f27a20a9df$export$e18d4112326e72bf = {
    state: $b53805f27a20a9df$var$state,
    subscribe (callback) {
        return (0, $esotS.subscribe)($b53805f27a20a9df$var$state, ()=>callback($b53805f27a20a9df$var$state));
    },
    setThemeMode (themeMode) {
        $b53805f27a20a9df$var$state.themeMode = themeMode;
        try {
            const emailConnector = (0, $9QkaU.ConnectorController).getEmailConnector();
            if (emailConnector) emailConnector.provider.syncTheme({
                themeMode: $b53805f27a20a9df$export$e18d4112326e72bf.getSnapshot().themeMode
            });
        } catch  {
            console.info("Unable to sync theme to email connector");
        }
    },
    setThemeVariables (themeVariables) {
        $b53805f27a20a9df$var$state.themeVariables = {
            ...$b53805f27a20a9df$var$state.themeVariables,
            ...themeVariables
        };
        try {
            const emailConnector = (0, $9QkaU.ConnectorController).getEmailConnector();
            if (emailConnector) emailConnector.provider.syncTheme({
                themeVariables: $b53805f27a20a9df$export$e18d4112326e72bf.getSnapshot().themeVariables
            });
        } catch  {
            console.info("Unable to sync theme to email connector");
        }
    },
    getSnapshot () {
        return (0, $esotS.snapshot)($b53805f27a20a9df$var$state);
    }
};

});


parcelRegister("b6tQF", function(module, exports) {

$parcel$export(module.exports, "NetworkController", () => $8157688bc3094df5$export$c63f10f788d47d86);

var $hZH4A = parcelRequire("hZH4A");

var $esotS = parcelRequire("esotS");

var $ha6or = parcelRequire("ha6or");

var $6n0eX = parcelRequire("6n0eX");

var $bnxqc = parcelRequire("bnxqc");

var $kGR8V = parcelRequire("kGR8V");
const $8157688bc3094df5$var$state = (0, $esotS.proxy)({
    supportsAllNetworks: true,
    isDefaultCaipNetwork: false
});
const $8157688bc3094df5$export$c63f10f788d47d86 = {
    state: $8157688bc3094df5$var$state,
    subscribeKey (key, callback) {
        return (0, $hZH4A.subscribeKey)($8157688bc3094df5$var$state, key, callback);
    },
    _getClient () {
        if (!$8157688bc3094df5$var$state._client) throw new Error("NetworkController client not set");
        return $8157688bc3094df5$var$state._client;
    },
    setClient (client) {
        $8157688bc3094df5$var$state._client = (0, $esotS.ref)(client);
    },
    setCaipNetwork (caipNetwork) {
        $8157688bc3094df5$var$state.caipNetwork = caipNetwork;
        (0, $ha6or.PublicStateController).set({
            selectedNetworkId: caipNetwork?.id
        });
        this.checkIfSupportedNetwork();
    },
    setDefaultCaipNetwork (caipNetwork) {
        $8157688bc3094df5$var$state.caipNetwork = caipNetwork;
        (0, $ha6or.PublicStateController).set({
            selectedNetworkId: caipNetwork?.id
        });
        $8157688bc3094df5$var$state.isDefaultCaipNetwork = true;
    },
    setRequestedCaipNetworks (requestedNetworks) {
        $8157688bc3094df5$var$state.requestedCaipNetworks = requestedNetworks;
    },
    getRequestedCaipNetworks () {
        const { approvedCaipNetworkIds: approvedCaipNetworkIds, requestedCaipNetworks: requestedCaipNetworks } = $8157688bc3094df5$var$state;
        const approvedIds = approvedCaipNetworkIds;
        const requestedNetworks = requestedCaipNetworks;
        return (0, $kGR8V.CoreHelperUtil).sortRequestedNetworks(approvedIds, requestedNetworks);
    },
    async getApprovedCaipNetworksData () {
        const data = await this._getClient().getApprovedCaipNetworksData();
        $8157688bc3094df5$var$state.supportsAllNetworks = data.supportsAllNetworks;
        $8157688bc3094df5$var$state.approvedCaipNetworkIds = data.approvedCaipNetworkIds;
    },
    async switchActiveNetwork (network) {
        await this._getClient().switchCaipNetwork(network);
        $8157688bc3094df5$var$state.caipNetwork = network;
        if (network) (0, $6n0eX.EventsController).sendEvent({
            type: "track",
            event: "SWITCH_NETWORK",
            properties: {
                network: network.id
            }
        });
    },
    checkIfSupportedNetwork () {
        $8157688bc3094df5$var$state.isUnsupportedChain = !$8157688bc3094df5$var$state.requestedCaipNetworks?.some((network)=>network.id === $8157688bc3094df5$var$state.caipNetwork?.id);
        if ($8157688bc3094df5$var$state.isUnsupportedChain) this.showUnsupportedChainUI();
    },
    resetNetwork () {
        if (!$8157688bc3094df5$var$state.isDefaultCaipNetwork) $8157688bc3094df5$var$state.caipNetwork = undefined;
        $8157688bc3094df5$var$state.approvedCaipNetworkIds = undefined;
        $8157688bc3094df5$var$state.supportsAllNetworks = true;
    },
    showUnsupportedChainUI () {
        setTimeout(()=>{
            (0, $bnxqc.ModalController).open({
                view: "UnsupportedChain"
            });
        }, 300);
    }
};

});
parcelRegister("ha6or", function(module, exports) {

$parcel$export(module.exports, "PublicStateController", () => $c7e854634105bf7a$export$24bc8c77cb7c530);

var $esotS = parcelRequire("esotS");
const $c7e854634105bf7a$var$state = (0, $esotS.proxy)({
    open: false,
    selectedNetworkId: undefined
});
const $c7e854634105bf7a$export$24bc8c77cb7c530 = {
    state: $c7e854634105bf7a$var$state,
    subscribe (callback) {
        return (0, $esotS.subscribe)($c7e854634105bf7a$var$state, ()=>callback($c7e854634105bf7a$var$state));
    },
    set (newState) {
        Object.assign($c7e854634105bf7a$var$state, {
            ...$c7e854634105bf7a$var$state,
            ...newState
        });
    }
};

});

parcelRegister("6n0eX", function(module, exports) {

$parcel$export(module.exports, "EventsController", () => $4a3513caef1a595c$export$23ca5cb260756952);

var $esotS = parcelRequire("esotS");

var $kGR8V = parcelRequire("kGR8V");

var $MKSXD = parcelRequire("MKSXD");

var $8KEpV = parcelRequire("8KEpV");
const $4a3513caef1a595c$var$baseUrl = (0, $kGR8V.CoreHelperUtil).getAnalyticsUrl();
const $4a3513caef1a595c$var$api = new (0, $MKSXD.FetchUtil)({
    baseUrl: $4a3513caef1a595c$var$baseUrl
});
const $4a3513caef1a595c$var$excluded = [
    "MODAL_CREATED"
];
const $4a3513caef1a595c$var$state = (0, $esotS.proxy)({
    timestamp: Date.now(),
    data: {
        type: "track",
        event: "MODAL_CREATED"
    }
});
const $4a3513caef1a595c$export$23ca5cb260756952 = {
    state: $4a3513caef1a595c$var$state,
    subscribe (callback) {
        return (0, $esotS.subscribe)($4a3513caef1a595c$var$state, ()=>callback($4a3513caef1a595c$var$state));
    },
    _getApiHeaders () {
        const { projectId: projectId, sdkType: sdkType, sdkVersion: sdkVersion } = (0, $8KEpV.OptionsController).state;
        return {
            "x-project-id": projectId,
            "x-sdk-type": sdkType,
            "x-sdk-version": sdkVersion
        };
    },
    async _sendAnalyticsEvent (payload) {
        try {
            if ($4a3513caef1a595c$var$excluded.includes(payload.data.event) || typeof window === "undefined") return;
            await $4a3513caef1a595c$var$api.post({
                path: "/e",
                headers: $4a3513caef1a595c$export$23ca5cb260756952._getApiHeaders(),
                body: {
                    eventId: (0, $kGR8V.CoreHelperUtil).getUUID(),
                    url: window.location.href,
                    domain: window.location.hostname,
                    timestamp: payload.timestamp,
                    props: payload.data
                }
            });
        } catch  {}
    },
    sendEvent (data) {
        $4a3513caef1a595c$var$state.timestamp = Date.now();
        $4a3513caef1a595c$var$state.data = data;
        if ((0, $8KEpV.OptionsController).state.enableAnalytics) $4a3513caef1a595c$export$23ca5cb260756952._sendAnalyticsEvent($4a3513caef1a595c$var$state);
    }
};

});



parcelRegister("dJjpc", function(module, exports) {

$parcel$export(module.exports, "RouterController", () => $9fee87dbc536f603$export$5ceead2526330ba8);

var $hZH4A = parcelRequire("hZH4A");

var $esotS = parcelRequire("esotS");
const $9fee87dbc536f603$var$state = (0, $esotS.proxy)({
    view: "Connect",
    history: [
        "Connect"
    ]
});
const $9fee87dbc536f603$export$5ceead2526330ba8 = {
    state: $9fee87dbc536f603$var$state,
    subscribeKey (key, callback) {
        return (0, $hZH4A.subscribeKey)($9fee87dbc536f603$var$state, key, callback);
    },
    push (view, data) {
        if (view !== $9fee87dbc536f603$var$state.view) {
            $9fee87dbc536f603$var$state.view = view;
            $9fee87dbc536f603$var$state.history.push(view);
            $9fee87dbc536f603$var$state.data = data;
        }
    },
    reset (view) {
        $9fee87dbc536f603$var$state.view = view;
        $9fee87dbc536f603$var$state.history = [
            view
        ];
    },
    replace (view, data) {
        if ($9fee87dbc536f603$var$state.history.length > 1 && $9fee87dbc536f603$var$state.history.at(-1) !== view) {
            $9fee87dbc536f603$var$state.view = view;
            $9fee87dbc536f603$var$state.history[$9fee87dbc536f603$var$state.history.length - 1] = view;
            $9fee87dbc536f603$var$state.data = data;
        }
    },
    goBack () {
        if ($9fee87dbc536f603$var$state.history.length > 1) {
            $9fee87dbc536f603$var$state.history.pop();
            const [last] = $9fee87dbc536f603$var$state.history.slice(-1);
            if (last) $9fee87dbc536f603$var$state.view = last;
        }
    },
    goBackToIndex (historyIndex) {
        if ($9fee87dbc536f603$var$state.history.length > 1) {
            $9fee87dbc536f603$var$state.history = $9fee87dbc536f603$var$state.history.slice(0, historyIndex + 1);
            const [last] = $9fee87dbc536f603$var$state.history.slice(-1);
            if (last) $9fee87dbc536f603$var$state.view = last;
        }
    }
};

});


parcelRegister("ahDsO", function(module, exports) {

$parcel$export(module.exports, "OnRampController", () => $77ca1a91f299bba1$export$8cdcd0d64858bea7);

var $hZH4A = parcelRequire("hZH4A");

var $esotS = parcelRequire("esotS");

var $5S5Lx = parcelRequire("5S5Lx");

var $6Y81T = parcelRequire("6Y81T");

var $6tAXH = parcelRequire("6tAXH");
const $77ca1a91f299bba1$var$USDC_CURRENCY_DEFAULT = {
    id: "2b92315d-eab7-5bef-84fa-089a131333f5",
    name: "USD Coin",
    symbol: "USDC",
    networks: [
        {
            name: "ethereum-mainnet",
            display_name: "Ethereum",
            chain_id: "1",
            contract_address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48"
        },
        {
            name: "polygon-mainnet",
            display_name: "Polygon",
            chain_id: "137",
            contract_address: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174"
        }
    ]
};
const $77ca1a91f299bba1$var$USD_CURRENCY_DEFAULT = {
    id: "USD",
    payment_method_limits: [
        {
            id: "card",
            min: "10.00",
            max: "7500.00"
        },
        {
            id: "ach_bank_account",
            min: "10.00",
            max: "25000.00"
        }
    ]
};
const $77ca1a91f299bba1$var$state = (0, $esotS.proxy)({
    providers: (0, $5S5Lx.ONRAMP_PROVIDERS),
    selectedProvider: null,
    error: null,
    purchaseCurrency: $77ca1a91f299bba1$var$USDC_CURRENCY_DEFAULT,
    paymentCurrency: $77ca1a91f299bba1$var$USD_CURRENCY_DEFAULT,
    purchaseCurrencies: [
        $77ca1a91f299bba1$var$USDC_CURRENCY_DEFAULT
    ],
    paymentCurrencies: [],
    quotesLoading: false
});
const $77ca1a91f299bba1$export$8cdcd0d64858bea7 = {
    state: $77ca1a91f299bba1$var$state,
    subscribe (callback) {
        return (0, $esotS.subscribe)($77ca1a91f299bba1$var$state, ()=>callback($77ca1a91f299bba1$var$state));
    },
    subscribeKey (key, callback) {
        return (0, $hZH4A.subscribeKey)($77ca1a91f299bba1$var$state, key, callback);
    },
    setSelectedProvider (provider) {
        $77ca1a91f299bba1$var$state.selectedProvider = provider;
    },
    setPurchaseCurrency (currency) {
        $77ca1a91f299bba1$var$state.purchaseCurrency = currency;
    },
    setPaymentCurrency (currency) {
        $77ca1a91f299bba1$var$state.paymentCurrency = currency;
    },
    setPurchaseAmount (amount) {
        this.state.purchaseAmount = amount;
    },
    setPaymentAmount (amount) {
        this.state.paymentAmount = amount;
    },
    async getAvailableCurrencies () {
        const options = await (0, $6Y81T.BlockchainApiController).getOnrampOptions();
        $77ca1a91f299bba1$var$state.purchaseCurrencies = options.purchaseCurrencies;
        $77ca1a91f299bba1$var$state.paymentCurrencies = options.paymentCurrencies;
        $77ca1a91f299bba1$var$state.paymentCurrency = options.paymentCurrencies[0] || $77ca1a91f299bba1$var$USD_CURRENCY_DEFAULT;
        $77ca1a91f299bba1$var$state.purchaseCurrency = options.purchaseCurrencies[0] || $77ca1a91f299bba1$var$USDC_CURRENCY_DEFAULT;
        await (0, $6tAXH.ApiController).fetchCurrencyImages(options.paymentCurrencies.map((currency)=>currency.id));
        await (0, $6tAXH.ApiController).fetchTokenImages(options.purchaseCurrencies.map((currency)=>currency.symbol));
    },
    async getQuote () {
        $77ca1a91f299bba1$var$state.quotesLoading = true;
        const quote = await (0, $6Y81T.BlockchainApiController).getOnrampQuote({
            purchaseCurrency: $77ca1a91f299bba1$var$state.purchaseCurrency,
            paymentCurrency: $77ca1a91f299bba1$var$state.paymentCurrency,
            amount: $77ca1a91f299bba1$var$state.paymentAmount?.toString() || "0",
            network: $77ca1a91f299bba1$var$state.purchaseCurrency?.name
        });
        $77ca1a91f299bba1$var$state.quotesLoading = false;
        $77ca1a91f299bba1$var$state.purchaseAmount = Number(quote.purchaseAmount.amount);
        return quote;
    }
};

});
parcelRegister("6Y81T", function(module, exports) {

$parcel$export(module.exports, "BlockchainApiController", () => $512e9331b2a41785$export$9c45fcf03cadbfaa);

var $kGR8V = parcelRequire("kGR8V");

var $MKSXD = parcelRequire("MKSXD");

var $8KEpV = parcelRequire("8KEpV");
const $512e9331b2a41785$var$DEFAULT_OPTIONS = {
    purchaseCurrencies: [
        {
            id: "2b92315d-eab7-5bef-84fa-089a131333f5",
            name: "USD Coin",
            symbol: "USDC",
            networks: [
                {
                    name: "ethereum-mainnet",
                    display_name: "Ethereum",
                    chain_id: "1",
                    contract_address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48"
                },
                {
                    name: "polygon-mainnet",
                    display_name: "Polygon",
                    chain_id: "137",
                    contract_address: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174"
                }
            ]
        },
        {
            id: "2b92315d-eab7-5bef-84fa-089a131333f5",
            name: "Ether",
            symbol: "ETH",
            networks: [
                {
                    name: "ethereum-mainnet",
                    display_name: "Ethereum",
                    chain_id: "1",
                    contract_address: "0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48"
                },
                {
                    name: "polygon-mainnet",
                    display_name: "Polygon",
                    chain_id: "137",
                    contract_address: "0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174"
                }
            ]
        }
    ],
    paymentCurrencies: [
        {
            id: "USD",
            payment_method_limits: [
                {
                    id: "card",
                    min: "10.00",
                    max: "7500.00"
                },
                {
                    id: "ach_bank_account",
                    min: "10.00",
                    max: "25000.00"
                }
            ]
        },
        {
            id: "EUR",
            payment_method_limits: [
                {
                    id: "card",
                    min: "10.00",
                    max: "7500.00"
                },
                {
                    id: "ach_bank_account",
                    min: "10.00",
                    max: "25000.00"
                }
            ]
        }
    ]
};
const $512e9331b2a41785$var$baseUrl = (0, $kGR8V.CoreHelperUtil).getBlockchainApiUrl();
const $512e9331b2a41785$var$api = new (0, $MKSXD.FetchUtil)({
    baseUrl: $512e9331b2a41785$var$baseUrl
});
const $512e9331b2a41785$export$9c45fcf03cadbfaa = {
    fetchIdentity ({ caipChainId: caipChainId, address: address }) {
        return $512e9331b2a41785$var$api.get({
            path: `/v1/identity/${address}`,
            params: {
                chainId: caipChainId,
                projectId: (0, $8KEpV.OptionsController).state.projectId
            }
        });
    },
    fetchTransactions ({ account: account, projectId: projectId, cursor: cursor, onramp: onramp, signal: signal }) {
        const queryParams = cursor ? {
            cursor: cursor
        } : {};
        return $512e9331b2a41785$var$api.get({
            path: `/v1/account/${account}/history?projectId=${projectId}${onramp ? `&onramp=${onramp}` : ""}`,
            params: queryParams,
            signal: signal
        });
    },
    async generateOnRampURL ({ destinationWallets: destinationWallets, partnerUserId: partnerUserId, defaultNetwork: defaultNetwork, purchaseAmount: purchaseAmount, paymentAmount: paymentAmount }) {
        const response = await $512e9331b2a41785$var$api.post({
            path: `/v1/generators/onrampurl?projectId=${(0, $8KEpV.OptionsController).state.projectId}`,
            body: {
                destinationWallets: destinationWallets,
                defaultNetwork: defaultNetwork,
                partnerUserId: partnerUserId,
                defaultExperience: "buy",
                presetCryptoAmount: purchaseAmount,
                presetFiatAmount: paymentAmount
            }
        });
        return response.url;
    },
    async getOnrampOptions () {
        try {
            const response = await $512e9331b2a41785$var$api.get({
                path: `/v1/onramp/options?projectId=${(0, $8KEpV.OptionsController).state.projectId}`
            });
            return response;
        } catch (e) {
            return $512e9331b2a41785$var$DEFAULT_OPTIONS;
        }
    },
    async getOnrampQuote ({ purchaseCurrency: purchaseCurrency, paymentCurrency: paymentCurrency, amount: amount, network: network }) {
        try {
            const response = await $512e9331b2a41785$var$api.post({
                path: `/v1/onramp/quote?projectId=${(0, $8KEpV.OptionsController).state.projectId}`,
                body: {
                    purchaseCurrency: purchaseCurrency,
                    paymentCurrency: paymentCurrency,
                    amount: amount,
                    network: network
                }
            });
            return response;
        } catch (e) {
            return {
                coinbaseFee: {
                    amount: amount,
                    currency: paymentCurrency.id
                },
                networkFee: {
                    amount: amount,
                    currency: paymentCurrency.id
                },
                paymentSubtotal: {
                    amount: amount,
                    currency: paymentCurrency.id
                },
                paymentTotal: {
                    amount: amount,
                    currency: paymentCurrency.id
                },
                purchaseAmount: {
                    amount: amount,
                    currency: paymentCurrency.id
                },
                quoteId: "mocked-quote-id"
            };
        }
    }
};

});


parcelRegister("jJO2B", function(module, exports) {

$parcel$export(module.exports, "ConnectionController", () => $e5e90965b15a2e39$export$303deccbe6e8c782);

var $hZH4A = parcelRequire("hZH4A");

var $esotS = parcelRequire("esotS");

var $kGR8V = parcelRequire("kGR8V");

var $heSwZ = parcelRequire("heSwZ");

var $6oINN = parcelRequire("6oINN");
const $e5e90965b15a2e39$var$state = (0, $esotS.proxy)({
    wcError: false,
    buffering: false
});
const $e5e90965b15a2e39$export$303deccbe6e8c782 = {
    state: $e5e90965b15a2e39$var$state,
    subscribeKey (key, callback) {
        return (0, $hZH4A.subscribeKey)($e5e90965b15a2e39$var$state, key, callback);
    },
    _getClient () {
        if (!$e5e90965b15a2e39$var$state._client) throw new Error("ConnectionController client not set");
        return $e5e90965b15a2e39$var$state._client;
    },
    setClient (client) {
        $e5e90965b15a2e39$var$state._client = (0, $esotS.ref)(client);
    },
    connectWalletConnect () {
        $e5e90965b15a2e39$var$state.wcPromise = this._getClient().connectWalletConnect((uri)=>{
            $e5e90965b15a2e39$var$state.wcUri = uri;
            $e5e90965b15a2e39$var$state.wcPairingExpiry = (0, $kGR8V.CoreHelperUtil).getPairingExpiry();
        });
        (0, $heSwZ.StorageUtil).setConnectedConnector("WALLET_CONNECT");
    },
    async connectExternal (options) {
        await this._getClient().connectExternal?.(options);
        (0, $heSwZ.StorageUtil).setConnectedConnector(options.type);
    },
    async signMessage (message) {
        return this._getClient().signMessage(message);
    },
    checkInstalled (ids) {
        return this._getClient().checkInstalled?.(ids);
    },
    resetWcConnection () {
        $e5e90965b15a2e39$var$state.wcUri = undefined;
        $e5e90965b15a2e39$var$state.wcPairingExpiry = undefined;
        $e5e90965b15a2e39$var$state.wcPromise = undefined;
        $e5e90965b15a2e39$var$state.wcLinking = undefined;
        $e5e90965b15a2e39$var$state.recentWallet = undefined;
        (0, $6oINN.TransactionsController).resetTransactions();
        (0, $heSwZ.StorageUtil).deleteWalletConnectDeepLink();
    },
    setWcLinking (wcLinking) {
        $e5e90965b15a2e39$var$state.wcLinking = wcLinking;
    },
    setWcError (wcError) {
        $e5e90965b15a2e39$var$state.wcError = wcError;
        $e5e90965b15a2e39$var$state.buffering = false;
    },
    setRecentWallet (wallet) {
        $e5e90965b15a2e39$var$state.recentWallet = wallet;
    },
    setBuffering (buffering) {
        $e5e90965b15a2e39$var$state.buffering = buffering;
    },
    async disconnect () {
        await this._getClient().disconnect();
        this.resetWcConnection();
    }
};

});
parcelRegister("6oINN", function(module, exports) {

$parcel$export(module.exports, "TransactionsController", () => $4a87bcbfb6f8bf5e$export$da1e018e28e23fb0);

var $esotS = parcelRequire("esotS");

var $8KEpV = parcelRequire("8KEpV");

var $6n0eX = parcelRequire("6n0eX");

var $9fh1I = parcelRequire("9fh1I");

var $6Y81T = parcelRequire("6Y81T");
const $4a87bcbfb6f8bf5e$var$state = (0, $esotS.proxy)({
    transactions: [],
    coinbaseTransactions: {},
    transactionsByYear: {},
    loading: false,
    empty: false,
    next: undefined
});
const $4a87bcbfb6f8bf5e$export$da1e018e28e23fb0 = {
    state: $4a87bcbfb6f8bf5e$var$state,
    subscribe (callback) {
        return (0, $esotS.subscribe)($4a87bcbfb6f8bf5e$var$state, ()=>callback($4a87bcbfb6f8bf5e$var$state));
    },
    async fetchTransactions (accountAddress, onramp) {
        const { projectId: projectId } = (0, $8KEpV.OptionsController).state;
        if (!projectId || !accountAddress) throw new Error("Transactions can't be fetched without a projectId and an accountAddress");
        $4a87bcbfb6f8bf5e$var$state.loading = true;
        try {
            const response = await (0, $6Y81T.BlockchainApiController).fetchTransactions({
                account: accountAddress,
                projectId: projectId,
                cursor: $4a87bcbfb6f8bf5e$var$state.next,
                onramp: onramp
            });
            const nonSpamTransactions = this.filterSpamTransactions(response.data);
            const filteredTransactions = [
                ...$4a87bcbfb6f8bf5e$var$state.transactions,
                ...nonSpamTransactions
            ];
            $4a87bcbfb6f8bf5e$var$state.loading = false;
            if (onramp === "coinbase") $4a87bcbfb6f8bf5e$var$state.coinbaseTransactions = this.groupTransactionsByYearAndMonth($4a87bcbfb6f8bf5e$var$state.coinbaseTransactions, response.data);
            else {
                $4a87bcbfb6f8bf5e$var$state.transactions = filteredTransactions;
                $4a87bcbfb6f8bf5e$var$state.transactionsByYear = this.groupTransactionsByYearAndMonth($4a87bcbfb6f8bf5e$var$state.transactionsByYear, nonSpamTransactions);
            }
            $4a87bcbfb6f8bf5e$var$state.empty = filteredTransactions.length === 0;
            $4a87bcbfb6f8bf5e$var$state.next = response.next ? response.next : undefined;
        } catch (error) {
            (0, $6n0eX.EventsController).sendEvent({
                type: "track",
                event: "ERROR_FETCH_TRANSACTIONS",
                properties: {
                    address: accountAddress,
                    projectId: projectId,
                    cursor: $4a87bcbfb6f8bf5e$var$state.next
                }
            });
            (0, $9fh1I.SnackController).showError("Failed to fetch transactions");
            $4a87bcbfb6f8bf5e$var$state.loading = false;
            $4a87bcbfb6f8bf5e$var$state.empty = true;
        }
    },
    groupTransactionsByYearAndMonth (transactionsMap = {}, transactions = []) {
        const grouped = transactionsMap;
        transactions.forEach((transaction)=>{
            const year = new Date(transaction.metadata.minedAt).getFullYear();
            const month = new Date(transaction.metadata.minedAt).getMonth();
            const yearTransactions = grouped[year] ?? {};
            const monthTransactions = yearTransactions[month] ?? [];
            const newMonthTransactions = monthTransactions.filter((tx)=>tx.id !== transaction.id);
            grouped[year] = {
                ...yearTransactions,
                [month]: [
                    ...newMonthTransactions,
                    transaction
                ].sort((a, b)=>new Date(b.metadata.minedAt).getTime() - new Date(a.metadata.minedAt).getTime())
            };
        });
        return grouped;
    },
    filterSpamTransactions (transactions) {
        return transactions.filter((transaction)=>{
            const isAllSpam = transaction.transfers.every((transfer)=>transfer.nft_info?.flags.is_spam === true);
            return !isAllSpam;
        });
    },
    resetTransactions () {
        $4a87bcbfb6f8bf5e$var$state.transactions = [];
        $4a87bcbfb6f8bf5e$var$state.transactionsByYear = {};
        $4a87bcbfb6f8bf5e$var$state.loading = false;
        $4a87bcbfb6f8bf5e$var$state.empty = false;
        $4a87bcbfb6f8bf5e$var$state.next = undefined;
    }
};

});
parcelRegister("9fh1I", function(module, exports) {

$parcel$export(module.exports, "SnackController", () => $6bb2b8e5bbc386a1$export$506cae4b4f746de7);

var $hZH4A = parcelRequire("hZH4A");

var $esotS = parcelRequire("esotS");

var $kGR8V = parcelRequire("kGR8V");
const $6bb2b8e5bbc386a1$var$state = (0, $esotS.proxy)({
    message: "",
    variant: "success",
    open: false
});
const $6bb2b8e5bbc386a1$export$506cae4b4f746de7 = {
    state: $6bb2b8e5bbc386a1$var$state,
    subscribeKey (key, callback) {
        return (0, $hZH4A.subscribeKey)($6bb2b8e5bbc386a1$var$state, key, callback);
    },
    showSuccess (message) {
        $6bb2b8e5bbc386a1$var$state.message = message;
        $6bb2b8e5bbc386a1$var$state.variant = "success";
        $6bb2b8e5bbc386a1$var$state.open = true;
    },
    showError (message) {
        const errorMessage = (0, $kGR8V.CoreHelperUtil).parseError(message);
        $6bb2b8e5bbc386a1$var$state.message = errorMessage;
        $6bb2b8e5bbc386a1$var$state.variant = "error";
        $6bb2b8e5bbc386a1$var$state.open = true;
    },
    hide () {
        $6bb2b8e5bbc386a1$var$state.open = false;
    }
};

});



parcelRegister("iQR2f", function(module, exports) {

$parcel$export(module.exports, "SIWEController", () => $db9638ff0a3adb8c$export$3ff5b538099e7763);

var $hZH4A = parcelRequire("hZH4A");

var $esotS = parcelRequire("esotS");
const $db9638ff0a3adb8c$var$state = (0, $esotS.proxy)({
    status: "uninitialized",
    isSiweEnabled: false
});
const $db9638ff0a3adb8c$export$3ff5b538099e7763 = {
    state: $db9638ff0a3adb8c$var$state,
    subscribeKey (key, callback) {
        return (0, $hZH4A.subscribeKey)($db9638ff0a3adb8c$var$state, key, callback);
    },
    subscribe (callback) {
        return (0, $esotS.subscribe)($db9638ff0a3adb8c$var$state, ()=>callback($db9638ff0a3adb8c$var$state));
    },
    _getClient () {
        if (!$db9638ff0a3adb8c$var$state._client) throw new Error("SIWEController client not set");
        return $db9638ff0a3adb8c$var$state._client;
    },
    async getNonce () {
        const client = this._getClient();
        const nonce = await client.getNonce();
        this.setNonce(nonce);
        return nonce;
    },
    async getSession () {
        const client = this._getClient();
        const session = await client.getSession();
        if (session) {
            this.setSession(session);
            this.setStatus("success");
        }
        return session;
    },
    createMessage (args) {
        const client = this._getClient();
        const message = client.createMessage(args);
        this.setMessage(message);
        return message;
    },
    async verifyMessage (args) {
        const client = this._getClient();
        const isValid = await client.verifyMessage(args);
        return isValid;
    },
    async signIn () {
        const client = this._getClient();
        const session = await client.signIn();
        return session;
    },
    async signOut () {
        const client = this._getClient();
        await client.signOut();
        this.setStatus("ready");
        client.onSignOut?.();
    },
    onSignIn (args) {
        const client = this._getClient();
        client.onSignIn?.(args);
    },
    onSignOut () {
        const client = this._getClient();
        client.onSignOut?.();
    },
    setSIWEClient (client) {
        $db9638ff0a3adb8c$var$state._client = (0, $esotS.ref)(client);
        $db9638ff0a3adb8c$var$state.status = "ready";
        $db9638ff0a3adb8c$var$state.isSiweEnabled = client.options.enabled;
    },
    setNonce (nonce) {
        $db9638ff0a3adb8c$var$state.nonce = nonce;
    },
    setStatus (status) {
        $db9638ff0a3adb8c$var$state.status = status;
    },
    setMessage (message) {
        $db9638ff0a3adb8c$var$state.message = message;
    },
    setSession (session) {
        $db9638ff0a3adb8c$var$state.session = session;
    }
};

});

parcelRegister("7XY6i", function(module, exports) {

$parcel$export(module.exports, "AssetUtil", () => $5ccca9d002fc7815$export$2a2d471f51b1e9cb);

var $hCakD = parcelRequire("hCakD");
const $5ccca9d002fc7815$export$2a2d471f51b1e9cb = {
    getWalletImage (wallet) {
        if (wallet?.image_url) return wallet?.image_url;
        if (wallet?.image_id) return (0, $hCakD.AssetController).state.walletImages[wallet.image_id];
        return undefined;
    },
    getNetworkImage (network) {
        if (network?.imageUrl) return network?.imageUrl;
        if (network?.imageId) return (0, $hCakD.AssetController).state.networkImages[network.imageId];
        return undefined;
    },
    getConnectorImage (connector) {
        if (connector?.imageUrl) return connector.imageUrl;
        if (connector?.imageId) return (0, $hCakD.AssetController).state.connectorImages[connector.imageId];
        return undefined;
    }
};

});

parcelRegister("49HpJ", function(module, exports) {

$parcel$export(module.exports, "RouterUtil", () => $3069add494818182$export$12c6341a287a74e0);

var $dJjpc = parcelRequire("dJjpc");

var $bnxqc = parcelRequire("bnxqc");
const $3069add494818182$export$12c6341a287a74e0 = {
    goBackOrCloseModal () {
        if ((0, $dJjpc.RouterController).state.history.length > 1) (0, $dJjpc.RouterController).goBack();
        else (0, $bnxqc.ModalController).close();
    },
    navigateAfterNetworkSwitch () {
        const { history: history } = (0, $dJjpc.RouterController).state;
        const networkSelectIndex = history.findIndex((name)=>name === "Networks");
        if (networkSelectIndex >= 1) (0, $dJjpc.RouterController).goBackToIndex(networkSelectIndex - 1);
        else (0, $bnxqc.ModalController).close();
    }
};

});

parcelRegister("bOlNk", function(module, exports) {

$parcel$export(module.exports, "CryptoUtil", () => $8995452a2df61239$export$a0deb7908713d08d);

var $aQPnZ = parcelRequire("aQPnZ");

var $lVmUU = parcelRequire("lVmUU");

var $N0o3H = parcelRequire("N0o3H");
var $8995452a2df61239$require$Buffer = $N0o3H.Buffer;
const $8995452a2df61239$var$STORE_KEY_PRIVATE_KEY = "STORE_KEY_PRIVATE_KEY";
const $8995452a2df61239$var$STORE_KEY_PUBLIC_JWK = "STORE_KEY_PUBLIC_JWK";
const $8995452a2df61239$var$ALGO_NAME = "ECDSA";
const $8995452a2df61239$var$ALGO_CURVE = "P-256";
const $8995452a2df61239$var$EC_GEN_PARAMS = {
    name: $8995452a2df61239$var$ALGO_NAME,
    namedCurve: $8995452a2df61239$var$ALGO_CURVE
};
const $8995452a2df61239$export$a0deb7908713d08d = {
    async getIndexedDB () {
        return (0, $lVmUU.openDB)("web3modal-indexedDB", 1, {
            upgrade (database) {
                database.createObjectStore("keypairs");
            }
        });
    },
    async generateMagicKP () {
        const db = await this.getIndexedDB();
        const { subtle: subtle } = window.crypto;
        const kp = await subtle.generateKey($8995452a2df61239$var$EC_GEN_PARAMS, false, [
            "sign"
        ]);
        const jwkPublicKey = await subtle.exportKey("jwk", kp.publicKey);
        await db.put("keypairs", kp.privateKey, $8995452a2df61239$var$STORE_KEY_PRIVATE_KEY);
        await db.put("keypairs", jwkPublicKey, $8995452a2df61239$var$STORE_KEY_PUBLIC_JWK);
    },
    async getOrCreateMagicPublicKey () {
        try {
            const db = await this.getIndexedDB();
            const storedKey = await db.get("keypairs", $8995452a2df61239$var$STORE_KEY_PUBLIC_JWK);
            if (storedKey) return storedKey;
            await this.generateMagicKP();
            return db.get("keypairs", $8995452a2df61239$var$STORE_KEY_PUBLIC_JWK);
        } catch (e) {
            console.error("getPublicKey error", e);
            return null;
        }
    },
    async createJwt () {
        const publicJwk = await this.getOrCreateMagicPublicKey();
        if (!publicJwk) {
            console.info("unable to create public key or webcrypto is unsupported");
            return undefined;
        }
        const { subtle: subtle } = window.crypto;
        const db = await this.getIndexedDB();
        const privateJwk = await db.get("keypairs", $8995452a2df61239$var$STORE_KEY_PRIVATE_KEY);
        if (!privateJwk || !subtle) {
            console.info("unable to find private key or webcrypto unsupported");
            return undefined;
        }
        const claims = {
            iat: Math.floor(new Date().getTime() / 1000),
            jti: (0, $aQPnZ.nanoid)()
        };
        const headers = {
            typ: "dpop+jwt",
            alg: "ES256",
            jwk: publicJwk
        };
        const jws = {
            protected: this.strToUrlBase64(JSON.stringify(headers)),
            claims: this.strToUrlBase64(JSON.stringify(claims))
        };
        const data = this.strToUint8(`${jws.protected}.${jws.claims}`);
        const sigType = {
            name: $8995452a2df61239$var$ALGO_NAME,
            hash: {
                name: "SHA-256"
            }
        };
        const sig = this.uint8ToUrlBase64(new Uint8Array(await subtle.sign(sigType, privateJwk, data)));
        return `${jws.protected}.${jws.claims}.${sig}`;
    },
    strToUrlBase64 (str) {
        return this.binToUrlBase64(this.utf8ToBinaryString(str));
    },
    strToUint8 (str) {
        return new TextEncoder().encode(str);
    },
    binToUrlBase64 (bin) {
        return $8995452a2df61239$require$Buffer.from(bin, "latin1").toString("base64").replace(/\+/gu, "-").replace(/\//gu, "_").replace(/[=]+/gu, "");
    },
    utf8ToBinaryString (str) {
        const escstr = encodeURIComponent(str);
        return escstr.replace(/%(?:[0-9A-F]{2})/gu, (_, p1)=>String.fromCharCode(parseInt(p1, 16)));
    },
    uint8ToUrlBase64 (uint8) {
        let bin = "";
        uint8.forEach((code)=>{
            bin += String.fromCharCode(code);
        });
        return this.binToUrlBase64(bin);
    }
};

});
parcelRegister("aQPnZ", function(module, exports) {

$parcel$export(module.exports, "nanoid", () => $7e669edeb7a3f946$export$ac4959f4f1338dfc);

var $58lla = parcelRequire("58lla");
let $7e669edeb7a3f946$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $7e669edeb7a3f946$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = "";
        while(true){
            let bytes = getRandom(step);
            let j = step;
            while(j--){
                id += alphabet[bytes[j] & mask] || "";
                if (id.length === size) return id;
            }
        }
    };
};
let $7e669edeb7a3f946$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$7e669edeb7a3f946$export$a5cee9e955a615e5(alphabet, size, $7e669edeb7a3f946$export$4385e60b38654f68);
let $7e669edeb7a3f946$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let bytes = crypto.getRandomValues(new Uint8Array(size));
    while(size--)id += (0, $58lla.urlAlphabet)[bytes[size] & 63];
    return id;
};

});
parcelRegister("58lla", function(module, exports) {

$parcel$export(module.exports, "urlAlphabet", () => $3bce40defd566837$export$2b646eea95309f00);
const $3bce40defd566837$export$2b646eea95309f00 = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";

});


parcelRegister("lVmUU", function(module, exports) {

$parcel$export(module.exports, "openDB", () => $ff60b2af55df9711$export$ca0ed41b1a2af7e);
const $ff60b2af55df9711$var$instanceOfAny = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $ff60b2af55df9711$var$idbProxyableTypes;
let $ff60b2af55df9711$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $ff60b2af55df9711$var$getIdbProxyableTypes() {
    return $ff60b2af55df9711$var$idbProxyableTypes || ($ff60b2af55df9711$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $ff60b2af55df9711$var$getCursorAdvanceMethods() {
    return $ff60b2af55df9711$var$cursorAdvanceMethods || ($ff60b2af55df9711$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $ff60b2af55df9711$var$transactionDoneMap = new WeakMap();
const $ff60b2af55df9711$var$transformCache = new WeakMap();
const $ff60b2af55df9711$var$reverseTransformCache = new WeakMap();
function $ff60b2af55df9711$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener("success", success);
            request.removeEventListener("error", error);
        };
        const success = ()=>{
            resolve($ff60b2af55df9711$export$4997ffc0176396a6(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener("success", success);
        request.addEventListener("error", error);
    });
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $ff60b2af55df9711$var$reverseTransformCache.set(promise, request);
    return promise;
}
function $ff60b2af55df9711$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($ff60b2af55df9711$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error);
            tx.removeEventListener("abort", error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException("AbortError", "AbortError"));
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error);
        tx.addEventListener("abort", error);
    });
    // Cache it for later retrieval.
    $ff60b2af55df9711$var$transactionDoneMap.set(tx, done);
}
let $ff60b2af55df9711$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === "done") return $ff60b2af55df9711$var$transactionDoneMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === "store") return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $ff60b2af55df9711$export$4997ffc0176396a6(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target;
    }
};
function $ff60b2af55df9711$var$replaceTraps(callback) {
    $ff60b2af55df9711$var$idbProxyTraps = callback($ff60b2af55df9711$var$idbProxyTraps);
}
function $ff60b2af55df9711$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($ff60b2af55df9711$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($ff60b2af55df9711$export$debb760848ca95a(this), args);
        return $ff60b2af55df9711$export$4997ffc0176396a6(this.request);
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $ff60b2af55df9711$export$4997ffc0176396a6(func.apply($ff60b2af55df9711$export$debb760848ca95a(this), args));
    };
}
function $ff60b2af55df9711$var$transformCachableValue(value) {
    if (typeof value === "function") return $ff60b2af55df9711$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $ff60b2af55df9711$var$cacheDonePromiseForTransaction(value);
    if ($ff60b2af55df9711$var$instanceOfAny(value, $ff60b2af55df9711$var$getIdbProxyableTypes())) return new Proxy(value, $ff60b2af55df9711$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $ff60b2af55df9711$export$4997ffc0176396a6(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $ff60b2af55df9711$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($ff60b2af55df9711$var$transformCache.has(value)) return $ff60b2af55df9711$var$transformCache.get(value);
    const newValue = $ff60b2af55df9711$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $ff60b2af55df9711$var$transformCache.set(value, newValue);
        $ff60b2af55df9711$var$reverseTransformCache.set(newValue, value);
    }
    return newValue;
}
const $ff60b2af55df9711$export$debb760848ca95a = (value)=>$ff60b2af55df9711$var$reverseTransformCache.get(value);
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $ff60b2af55df9711$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = $ff60b2af55df9711$export$4997ffc0176396a6(request);
    if (upgrade) request.addEventListener("upgradeneeded", (event)=>{
        upgrade($ff60b2af55df9711$export$4997ffc0176396a6(request.result), event.oldVersion, event.newVersion, $ff60b2af55df9711$export$4997ffc0176396a6(request.transaction), event);
    });
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener("close", ()=>terminated());
        if (blocking) db.addEventListener("versionchange", (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $ff60b2af55df9711$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return $ff60b2af55df9711$export$4997ffc0176396a6(request).then(()=>undefined);
}
const $ff60b2af55df9711$var$readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
const $ff60b2af55df9711$var$writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
const $ff60b2af55df9711$var$cachedMethods = new Map();
function $ff60b2af55df9711$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
    if ($ff60b2af55df9711$var$cachedMethods.get(prop)) return $ff60b2af55df9711$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, "");
    const useIndex = prop !== targetFuncName;
    const isWrite = $ff60b2af55df9711$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $ff60b2af55df9711$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $ff60b2af55df9711$var$cachedMethods.set(prop, method);
    return method;
}
$ff60b2af55df9711$var$replaceTraps((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$ff60b2af55df9711$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$ff60b2af55df9711$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));
const $ff60b2af55df9711$var$advanceMethodProps = [
    "continue",
    "continuePrimaryKey",
    "advance"
];
const $ff60b2af55df9711$var$methodMap = {};
const $ff60b2af55df9711$var$advanceResults = new WeakMap();
const $ff60b2af55df9711$var$ittrProxiedCursorToOriginalProxy = new WeakMap();
const $ff60b2af55df9711$var$cursorIteratorTraps = {
    get (target, prop) {
        if (!$ff60b2af55df9711$var$advanceMethodProps.includes(prop)) return target[prop];
        let cachedFunc = $ff60b2af55df9711$var$methodMap[prop];
        if (!cachedFunc) cachedFunc = $ff60b2af55df9711$var$methodMap[prop] = function(...args) {
            $ff60b2af55df9711$var$advanceResults.set(this, $ff60b2af55df9711$var$ittrProxiedCursorToOriginalProxy.get(this)[prop](...args));
        };
        return cachedFunc;
    }
};
async function* $ff60b2af55df9711$var$iterate(...args) {
    // tslint:disable-next-line:no-this-assignment
    let cursor = this;
    if (!(cursor instanceof IDBCursor)) cursor = await cursor.openCursor(...args);
    if (!cursor) return;
    cursor;
    const proxiedCursor = new Proxy(cursor, $ff60b2af55df9711$var$cursorIteratorTraps);
    $ff60b2af55df9711$var$ittrProxiedCursorToOriginalProxy.set(proxiedCursor, cursor);
    // Map this double-proxy back to the original, so other cursor methods work.
    $ff60b2af55df9711$var$reverseTransformCache.set(proxiedCursor, $ff60b2af55df9711$export$debb760848ca95a(cursor));
    while(cursor){
        yield proxiedCursor;
        // If one of the advancing methods was not called, call continue().
        cursor = await ($ff60b2af55df9711$var$advanceResults.get(proxiedCursor) || cursor.continue());
        $ff60b2af55df9711$var$advanceResults.delete(proxiedCursor);
    }
}
function $ff60b2af55df9711$var$isIteratorProp(target, prop) {
    return prop === Symbol.asyncIterator && $ff60b2af55df9711$var$instanceOfAny(target, [
        IDBIndex,
        IDBObjectStore,
        IDBCursor
    ]) || prop === "iterate" && $ff60b2af55df9711$var$instanceOfAny(target, [
        IDBIndex,
        IDBObjectStore
    ]);
}
$ff60b2af55df9711$var$replaceTraps((oldTraps)=>({
        ...oldTraps,
        get (target, prop, receiver) {
            if ($ff60b2af55df9711$var$isIteratorProp(target, prop)) return $ff60b2af55df9711$var$iterate;
            return oldTraps.get(target, prop, receiver);
        },
        has (target, prop) {
            return $ff60b2af55df9711$var$isIteratorProp(target, prop) || oldTraps.has(target, prop);
        }
    }));

});




parcelRegister("c5ila", function(module, exports) {

$parcel$export(module.exports, "WuiOnRampProviderItem", () => $8cc42daf13d94591$export$164d942f06e4d92f);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
parcelRequire("aAJP9");
var $7XY6i = parcelRequire("7XY6i");
var $b6tQF = parcelRequire("b6tQF");
parcelRequire("cvzvT");
parcelRequire("eFeuH");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");

var $6oVeP = parcelRequire("6oVeP");
parcelRequire("lP6NM");
var $j71f4 = parcelRequire("j71f4");
var $8cc42daf13d94591$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $8cc42daf13d94591$export$164d942f06e4d92f = class WuiOnRampProviderItem extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.disabled = false;
        this.color = "inherit";
        this.label = "";
        this.feeRange = "";
        this.loading = false;
        this.onClick = null;
    }
    render() {
        return (0, $i7GIz.html)`
      <button ?disabled=${this.disabled} ontouchstart>
        <wui-visual name=${(0, $j71f4.ifDefined)(this.name)} class="provider-image"></wui-visual>
        <wui-flex flexDirection="column" gap="4xs">
          <wui-text variant="paragraph-500" color="fg-100">${this.label}</wui-text>
          <wui-flex alignItems="center" justifyContent="flex-start" gap="l">
            <wui-text variant="tiny-500" color="fg-100">
              <wui-text variant="tiny-400" color="fg-200">Fees</wui-text>
              ${this.feeRange}
            </wui-text>
            <wui-flex gap="xxs">
              <wui-icon name="bank" size="xs" color="fg-150"></wui-icon>
              <wui-icon name="card" size="xs" color="fg-150"></wui-icon>
            </wui-flex>
            ${this.networksTemplate()}
          </wui-flex>
        </wui-flex>
        ${this.loading ? (0, $i7GIz.html)`<wui-loading-spinner color="fg-200" size="md"></wui-loading-spinner>` : (0, $i7GIz.html)`<wui-icon name="chevronRight" color="fg-200" size="sm"></wui-icon>`}
      </button>
    `;
    }
    networksTemplate() {
        const networks = (0, $b6tQF.NetworkController).getRequestedCaipNetworks();
        const slicedNetworks = networks?.filter((network)=>network?.imageId)?.slice(0, 5);
        return (0, $i7GIz.html)`
      <wui-flex class="networks">
        ${slicedNetworks?.map((network)=>(0, $i7GIz.html)`
            <wui-flex class="network-icon">
              <wui-image src=${(0, $j71f4.ifDefined)((0, $7XY6i.AssetUtil).getNetworkImage(network))}></wui-image>
            </wui-flex>
          `)}
      </wui-flex>
    `;
    }
};
$8cc42daf13d94591$export$164d942f06e4d92f.styles = [
    (0, $9rwwE.resetStyles),
    (0, $9rwwE.elementStyles),
    (0, $6oVeP.default)
];
$8cc42daf13d94591$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $8cc42daf13d94591$export$164d942f06e4d92f.prototype, "disabled", void 0);
$8cc42daf13d94591$var$__decorate([
    (0, $cRlTX.property)()
], $8cc42daf13d94591$export$164d942f06e4d92f.prototype, "color", void 0);
$8cc42daf13d94591$var$__decorate([
    (0, $cRlTX.property)()
], $8cc42daf13d94591$export$164d942f06e4d92f.prototype, "name", void 0);
$8cc42daf13d94591$var$__decorate([
    (0, $cRlTX.property)()
], $8cc42daf13d94591$export$164d942f06e4d92f.prototype, "label", void 0);
$8cc42daf13d94591$var$__decorate([
    (0, $cRlTX.property)()
], $8cc42daf13d94591$export$164d942f06e4d92f.prototype, "feeRange", void 0);
$8cc42daf13d94591$var$__decorate([
    (0, $cRlTX.property)({
        type: Boolean
    })
], $8cc42daf13d94591$export$164d942f06e4d92f.prototype, "loading", void 0);
$8cc42daf13d94591$var$__decorate([
    (0, $cRlTX.property)()
], $8cc42daf13d94591$export$164d942f06e4d92f.prototype, "onClick", void 0);
$8cc42daf13d94591$export$164d942f06e4d92f = $8cc42daf13d94591$var$__decorate([
    (0, $lkv4o.customElement)("wui-onramp-provider-item")
], $8cc42daf13d94591$export$164d942f06e4d92f);

});
parcelRegister("6oVeP", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a91624987ca4aaa$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $4a91624987ca4aaa$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  button {
    padding: var(--wui-spacing-s);
    border-radius: var(--wui-border-radius-xs);
    background-color: var(--wui-gray-glass-002);
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: var(--wui-spacing-s);
    transition: background-color 0.2s linear;
  }

  button:hover {
    background-color: var(--wui-gray-glass-005);
  }

  .provider-image {
    width: var(--wui-spacing-3xl);
    min-width: var(--wui-spacing-3xl);
    height: var(--wui-spacing-3xl);
    border-radius: calc(var(--wui-border-radius-xs) - calc(var(--wui-spacing-s) / 2));
    position: relative;
    overflow: hidden;
  }

  .provider-image::after {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    inset: 0;
    border-radius: calc(var(--wui-border-radius-xs) - calc(var(--wui-spacing-s) / 2));
    box-shadow: inset 0 0 0 1px var(--wui-gray-glass-005);
  }

  .network-icon {
    width: var(--wui-spacing-m);
    height: var(--wui-spacing-m);
    border-radius: calc(var(--wui-spacing-m) / 2);
    overflow: hidden;
    box-shadow:
      0 0 0 3px var(--wui-gray-glass-002),
      0 0 0 3px var(--wui-color-modal-bg);
    transition: box-shadow 0.2s linear;
  }

  button:hover .network-icon {
    box-shadow:
      0 0 0 3px var(--wui-gray-glass-005),
      0 0 0 3px var(--wui-color-modal-bg);
  }
`;

});


parcelRegister("6NsWa", function(module, exports) {

$parcel$export(module.exports, "WuiGrid", () => $4f2dc3fad188a379$export$834debd63a0ca469);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");

var $9rwwE = parcelRequire("9rwwE");

var $97bbL = parcelRequire("97bbL");

var $lkv4o = parcelRequire("lkv4o");

var $iiQLJ = parcelRequire("iiQLJ");
var $4f2dc3fad188a379$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $4f2dc3fad188a379$export$834debd63a0ca469 = class WuiGrid extends (0, $3KB8N.LitElement) {
    render() {
        this.style.cssText = `
      grid-template-rows: ${this.gridTemplateRows};
      grid-template-columns: ${this.gridTemplateColumns};
      justify-items: ${this.justifyItems};
      align-items: ${this.alignItems};
      justify-content: ${this.justifyContent};
      align-content: ${this.alignContent};
      column-gap: ${this.columnGap && `var(--wui-spacing-${this.columnGap})`};
      row-gap: ${this.rowGap && `var(--wui-spacing-${this.rowGap})`};
      gap: ${this.gap && `var(--wui-spacing-${this.gap})`};
      padding-top: ${this.padding && (0, $97bbL.UiHelperUtil).getSpacingStyles(this.padding, 0)};
      padding-right: ${this.padding && (0, $97bbL.UiHelperUtil).getSpacingStyles(this.padding, 1)};
      padding-bottom: ${this.padding && (0, $97bbL.UiHelperUtil).getSpacingStyles(this.padding, 2)};
      padding-left: ${this.padding && (0, $97bbL.UiHelperUtil).getSpacingStyles(this.padding, 3)};
      margin-top: ${this.margin && (0, $97bbL.UiHelperUtil).getSpacingStyles(this.margin, 0)};
      margin-right: ${this.margin && (0, $97bbL.UiHelperUtil).getSpacingStyles(this.margin, 1)};
      margin-bottom: ${this.margin && (0, $97bbL.UiHelperUtil).getSpacingStyles(this.margin, 2)};
      margin-left: ${this.margin && (0, $97bbL.UiHelperUtil).getSpacingStyles(this.margin, 3)};
    `;
        return (0, $i7GIz.html)`<slot></slot>`;
    }
};
$4f2dc3fad188a379$export$834debd63a0ca469.styles = [
    (0, $9rwwE.resetStyles),
    (0, $iiQLJ.default)
];
$4f2dc3fad188a379$var$__decorate([
    (0, $cRlTX.property)()
], $4f2dc3fad188a379$export$834debd63a0ca469.prototype, "gridTemplateRows", void 0);
$4f2dc3fad188a379$var$__decorate([
    (0, $cRlTX.property)()
], $4f2dc3fad188a379$export$834debd63a0ca469.prototype, "gridTemplateColumns", void 0);
$4f2dc3fad188a379$var$__decorate([
    (0, $cRlTX.property)()
], $4f2dc3fad188a379$export$834debd63a0ca469.prototype, "justifyItems", void 0);
$4f2dc3fad188a379$var$__decorate([
    (0, $cRlTX.property)()
], $4f2dc3fad188a379$export$834debd63a0ca469.prototype, "alignItems", void 0);
$4f2dc3fad188a379$var$__decorate([
    (0, $cRlTX.property)()
], $4f2dc3fad188a379$export$834debd63a0ca469.prototype, "justifyContent", void 0);
$4f2dc3fad188a379$var$__decorate([
    (0, $cRlTX.property)()
], $4f2dc3fad188a379$export$834debd63a0ca469.prototype, "alignContent", void 0);
$4f2dc3fad188a379$var$__decorate([
    (0, $cRlTX.property)()
], $4f2dc3fad188a379$export$834debd63a0ca469.prototype, "columnGap", void 0);
$4f2dc3fad188a379$var$__decorate([
    (0, $cRlTX.property)()
], $4f2dc3fad188a379$export$834debd63a0ca469.prototype, "rowGap", void 0);
$4f2dc3fad188a379$var$__decorate([
    (0, $cRlTX.property)()
], $4f2dc3fad188a379$export$834debd63a0ca469.prototype, "gap", void 0);
$4f2dc3fad188a379$var$__decorate([
    (0, $cRlTX.property)()
], $4f2dc3fad188a379$export$834debd63a0ca469.prototype, "padding", void 0);
$4f2dc3fad188a379$var$__decorate([
    (0, $cRlTX.property)()
], $4f2dc3fad188a379$export$834debd63a0ca469.prototype, "margin", void 0);
$4f2dc3fad188a379$export$834debd63a0ca469 = $4f2dc3fad188a379$var$__decorate([
    (0, $lkv4o.customElement)("wui-grid")
], $4f2dc3fad188a379$export$834debd63a0ca469);

});
parcelRegister("iiQLJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d532d741c6910785$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $d532d741c6910785$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    display: grid;
    width: inherit;
    height: inherit;
  }
`;

});


parcelRegister("e9yjw", function(module, exports) {

$parcel$export(module.exports, "WuiSeparator", () => $a4dc85f3fd839b8a$export$987a8443516753c9);
parcelRequire("9xfz6");
var $i7GIz = parcelRequire("i7GIz");
var $3KB8N = parcelRequire("3KB8N");
parcelRequire("gWClp");
var $cRlTX = parcelRequire("cRlTX");
parcelRequire("eFeuH");

var $9rwwE = parcelRequire("9rwwE");

var $lkv4o = parcelRequire("lkv4o");

var $gXJwM = parcelRequire("gXJwM");
var $a4dc85f3fd839b8a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $a4dc85f3fd839b8a$export$987a8443516753c9 = class WuiSeparator extends (0, $3KB8N.LitElement) {
    constructor(){
        super(...arguments);
        this.text = "";
    }
    render() {
        return (0, $i7GIz.html)`${this.template()}`;
    }
    template() {
        if (this.text) return (0, $i7GIz.html)`<wui-text variant="small-500" color="fg-200">${this.text}</wui-text>`;
        return null;
    }
};
$a4dc85f3fd839b8a$export$987a8443516753c9.styles = [
    (0, $9rwwE.resetStyles),
    (0, $gXJwM.default)
];
$a4dc85f3fd839b8a$var$__decorate([
    (0, $cRlTX.property)()
], $a4dc85f3fd839b8a$export$987a8443516753c9.prototype, "text", void 0);
$a4dc85f3fd839b8a$export$987a8443516753c9 = $a4dc85f3fd839b8a$var$__decorate([
    (0, $lkv4o.customElement)("wui-separator")
], $a4dc85f3fd839b8a$export$987a8443516753c9);

});
parcelRegister("gXJwM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c59578dfc37c6650$export$2e2bcd8739ae039);
parcelRequire("9xfz6");
var $aPsWt = parcelRequire("aPsWt");
var $c59578dfc37c6650$export$2e2bcd8739ae039 = (0, $aPsWt.css)`
  :host {
    position: relative;
    display: flex;
    width: 100%;
    height: 1px;
    background-color: var(--wui-gray-glass-005);
    justify-content: center;
    align-items: center;
  }

  :host > wui-text {
    position: absolute;
    padding: 0px 10px;
    background-color: var(--wui-color-modal-bg);
  }
`;

});


parcelRegister("gC2QS", function(module, exports) {

$parcel$export(module.exports, "TransactionUtil", () => $c182684613497cef$export$445ed8d5992cc5e0);
parcelRequire("1zadX");
var $c9aBm = parcelRequire("c9aBm");

var $97bbL = parcelRequire("97bbL");
const $c182684613497cef$var$FLOAT_FIXED_VALUE = 3;
const $c182684613497cef$var$plusTypes = [
    "receive",
    "deposit",
    "borrow",
    "claim"
];
const $c182684613497cef$var$minusTypes = [
    "withdraw",
    "repay",
    "burn"
];
const $c182684613497cef$export$445ed8d5992cc5e0 = {
    getMonthName (monthNumber) {
        const date = new Date();
        date.setMonth(monthNumber);
        return date.toLocaleString("en-US", {
            month: "long"
        });
    },
    getTransactionGroupTitle (year, month) {
        const currentYear = (0, $c9aBm.DateUtil).getYear();
        const monthName = this.getMonthName(month);
        const isCurrentYear = year === currentYear;
        const groupTitle = isCurrentYear ? monthName : `${monthName} ${year}`;
        return groupTitle;
    },
    getTransactionImages (transfers) {
        const [transfer, secondTransfer] = transfers;
        const isAllNFT = Boolean(transfer) && transfers?.every((item)=>Boolean(item.nft_info));
        const haveMultipleTransfers = transfers?.length > 1;
        const haveTwoTransfers = transfers?.length === 2;
        if (haveTwoTransfers && !isAllNFT) return [
            this.getTransactionImage(transfer),
            this.getTransactionImage(secondTransfer)
        ];
        if (haveMultipleTransfers) return transfers.map((item)=>this.getTransactionImage(item));
        return [
            this.getTransactionImage(transfer)
        ];
    },
    getTransactionImage (transfer) {
        return {
            type: $c182684613497cef$export$445ed8d5992cc5e0.getTransactionTransferTokenType(transfer),
            url: $c182684613497cef$export$445ed8d5992cc5e0.getTransactionImageURL(transfer)
        };
    },
    getTransactionImageURL (transfer) {
        let imageURL = undefined;
        const isNFT = Boolean(transfer?.nft_info);
        const isFungible = Boolean(transfer?.fungible_info);
        if (transfer && isNFT) imageURL = transfer?.nft_info?.content?.preview?.url;
        else if (transfer && isFungible) imageURL = transfer?.fungible_info?.icon?.url;
        return imageURL;
    },
    getTransactionTransferTokenType (transfer) {
        if (transfer?.fungible_info) return "FUNGIBLE";
        else if (transfer?.nft_info) return "NFT";
        return undefined;
    },
    getTransactionDescriptions (transaction) {
        const type = transaction?.metadata?.operationType;
        const transfers = transaction?.transfers;
        const haveTransfer = transaction?.transfers?.length > 0;
        const haveMultipleTransfers = transaction?.transfers?.length > 1;
        const isFungible = haveTransfer && transfers?.every((transfer)=>Boolean(transfer?.fungible_info));
        const [firstTransfer, secondTransfer] = transfers;
        let firstDescription = this.getTransferDescription(firstTransfer);
        let secondDescription = this.getTransferDescription(secondTransfer);
        if (!haveTransfer) {
            const isSendOrReceive = type === "send" || type === "receive";
            if (isSendOrReceive && isFungible) {
                firstDescription = (0, $97bbL.UiHelperUtil).getTruncateString({
                    string: transaction?.metadata.sentFrom,
                    charsStart: 4,
                    charsEnd: 6,
                    truncate: "middle"
                });
                secondDescription = (0, $97bbL.UiHelperUtil).getTruncateString({
                    string: transaction?.metadata.sentTo,
                    charsStart: 4,
                    charsEnd: 6,
                    truncate: "middle"
                });
                return [
                    firstDescription,
                    secondDescription
                ];
            }
            return [
                transaction.metadata.status
            ];
        }
        if (haveMultipleTransfers) return transfers.map((item)=>this.getTransferDescription(item));
        let prefix = "";
        if ($c182684613497cef$var$plusTypes.includes(type)) prefix = "+";
        else if ($c182684613497cef$var$minusTypes.includes(type)) prefix = "-";
        firstDescription = prefix.concat(firstDescription);
        return [
            firstDescription
        ];
    },
    getTransferDescription (transfer) {
        let description = "";
        if (!transfer) return description;
        if (transfer?.nft_info) description = transfer?.nft_info?.name || "-";
        else if (transfer?.fungible_info) description = this.getFungibleTransferDescription(transfer) || "-";
        return description;
    },
    getFungibleTransferDescription (transfer) {
        if (!transfer) return null;
        const quantity = this.getQuantityFixedValue(transfer?.quantity.numeric);
        const description = [
            quantity,
            transfer?.fungible_info?.symbol
        ].join(" ").trim();
        return description;
    },
    getQuantityFixedValue (value) {
        if (!value) return null;
        const parsedValue = parseFloat(value);
        return parsedValue.toFixed($c182684613497cef$var$FLOAT_FIXED_VALUE);
    }
};

});
parcelRegister("1zadX", function(module, exports) {

$parcel$export(module.exports, "DateUtil", () => (parcelRequire("c9aBm")).DateUtil);

var $c9aBm = parcelRequire("c9aBm");

});
parcelRegister("c9aBm", function(module, exports) {

$parcel$export(module.exports, "DateUtil", () => $8d7e8c8d3029ef1b$export$9b575f14aa5e09a1);

var $jhwMH = parcelRequire("jhwMH");

var $kXlSk = parcelRequire("kXlSk");

var $jABvO = parcelRequire("jABvO");
(0, (/*@__PURE__*/$parcel$interopDefault($jhwMH))).extend((0, (/*@__PURE__*/$parcel$interopDefault($jABvO))));
(0, (/*@__PURE__*/$parcel$interopDefault($jhwMH))).extend((0, (/*@__PURE__*/$parcel$interopDefault($kXlSk))));
(0, (/*@__PURE__*/$parcel$interopDefault($jhwMH))).updateLocale("en", {
    relativeTime: {
        future: "in %s",
        past: "%s ago",
        s: "%s sec",
        m: "1 min",
        mm: "%d min",
        h: "1 hr",
        hh: "%d hrs",
        d: "1 d",
        dd: "%d d",
        M: "1 mo",
        MM: "%d mo",
        y: "1 yr",
        yy: "%d yr"
    }
});
const $8d7e8c8d3029ef1b$export$9b575f14aa5e09a1 = {
    getYear (date = new Date().toISOString()) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($jhwMH)))(date).year();
    },
    getRelativeDateFromNow (date) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($jhwMH)))(date).fromNow(true);
    },
    formatDate (date, format = "DD MMM") {
        return (0, (/*@__PURE__*/$parcel$interopDefault($jhwMH)))(date).format(format);
    }
};

});
parcelRegister("jhwMH", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), k = _.prototype;
    return O.prototype = k, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        k[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

});

parcelRegister("kXlSk", function(module, exports) {
!function(e, n) {
    module.exports = n();
}(module.exports, function() {
    "use strict";
    return function(e, n, t) {
        t.updateLocale = function(e, n) {
            var o = t.Ls[e];
            if (o) return (n ? Object.keys(n) : []).forEach(function(e) {
                o[e] = n[e];
            }), o;
        };
    };
});

});

parcelRegister("jABvO", function(module, exports) {
!function(r, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    return function(r, e, t) {
        r = r || {};
        var n = e.prototype, o = {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years"
        };
        function i(r, e, t, o) {
            return n.fromToBase(r, e, t, o);
        }
        t.en.relativeTime = o, n.fromToBase = function(e, n, i, d, u) {
            for(var f, a, s, l = i.$locale().relativeTime || o, h = r.thresholds || [
                {
                    l: "s",
                    r: 44,
                    d: "second"
                },
                {
                    l: "m",
                    r: 89
                },
                {
                    l: "mm",
                    r: 44,
                    d: "minute"
                },
                {
                    l: "h",
                    r: 89
                },
                {
                    l: "hh",
                    r: 21,
                    d: "hour"
                },
                {
                    l: "d",
                    r: 35
                },
                {
                    l: "dd",
                    r: 25,
                    d: "day"
                },
                {
                    l: "M",
                    r: 45
                },
                {
                    l: "MM",
                    r: 10,
                    d: "month"
                },
                {
                    l: "y",
                    r: 17
                },
                {
                    l: "yy",
                    d: "year"
                }
            ], m = h.length, c = 0; c < m; c += 1){
                var y = h[c];
                y.d && (f = d ? t(e).diff(i, y.d, !0) : i.diff(e, y.d, !0));
                var p = (r.rounding || Math.round)(Math.abs(f));
                if (s = f > 0, p <= y.r || !y.r) {
                    p <= 1 && c > 0 && (y = h[c - 1]);
                    var v = l[y.l];
                    u && (p = u("" + p)), a = "string" == typeof v ? v.replace("%d", p) : v(p, n, y.l, s);
                    break;
                }
            }
            if (n) return a;
            var M = s ? l.future : l.past;
            return "function" == typeof M ? M(a) : M.replace("%s", a);
        }, n.to = function(r, e) {
            return i(r, e, this, !0);
        }, n.from = function(r, e) {
            return i(r, e, this);
        };
        var d = function(r) {
            return r.$u ? t.utc() : t();
        };
        n.toNow = function(r) {
            return this.to(d(this), r);
        }, n.fromNow = function(r) {
            return this.from(d(this), r);
        };
    };
});

});





parcelRegister("a4aTY", function(module, exports) {

$parcel$export(module.exports, "W3mModal", () => $7542bbf3d97634c9$export$8f54aa55129a8184);
parcelRequire("aAJP9");
var $5mrMQ = parcelRequire("5mrMQ");
var $6tAXH = parcelRequire("6tAXH");
var $jJO2B = parcelRequire("jJO2B");
var $6n0eX = parcelRequire("6n0eX");
var $bnxqc = parcelRequire("bnxqc");
var $dJjpc = parcelRequire("dJjpc");
var $iQR2f = parcelRequire("iQR2f");
var $9fh1I = parcelRequire("9fh1I");
var $fyCFg = parcelRequire("fyCFg");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
var $9rwwE = parcelRequire("9rwwE");
var $97bbL = parcelRequire("97bbL");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $6eT5F = parcelRequire("6eT5F");

var $gQwfc = parcelRequire("gQwfc");
var $7542bbf3d97634c9$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $7542bbf3d97634c9$var$SCROLL_LOCK = "scroll-lock";
let $7542bbf3d97634c9$export$8f54aa55129a8184 = class W3mModal extends (0, $b47AP.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.abortController = undefined;
        this.open = (0, $bnxqc.ModalController).state.open;
        this.caipAddress = (0, $5mrMQ.AccountController).state.caipAddress;
        this.isSiweEnabled = (0, $iQR2f.SIWEController).state.isSiweEnabled;
        this.initializeTheming();
        (0, $6tAXH.ApiController).prefetch();
        this.unsubscribe.push((0, $bnxqc.ModalController).subscribeKey("open", (val)=>val ? this.onOpen() : this.onClose()), (0, $iQR2f.SIWEController).subscribeKey("isSiweEnabled", (isEnabled)=>{
            this.isSiweEnabled = isEnabled;
        }), (0, $5mrMQ.AccountController).subscribe((newAccountState)=>this.onNewAccountState(newAccountState)));
        (0, $6n0eX.EventsController).sendEvent({
            type: "track",
            event: "MODAL_LOADED"
        });
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
        this.onRemoveKeyboardListener();
    }
    render() {
        return this.open ? (0, $6HMh7.html)`
          <wui-flex @click=${this.onOverlayClick.bind(this)}>
            <wui-card role="alertdialog" aria-modal="true" tabindex="0">
              <w3m-header></w3m-header>
              <w3m-router></w3m-router>
              <w3m-snackbar></w3m-snackbar>
            </wui-card>
          </wui-flex>
        ` : null;
    }
    async onOverlayClick(event) {
        if (event.target === event.currentTarget) await this.handleClose();
    }
    async handleClose() {
        if (this.isSiweEnabled && (0, $iQR2f.SIWEController).state.status !== "success") await (0, $jJO2B.ConnectionController).disconnect();
        (0, $bnxqc.ModalController).close();
    }
    initializeTheming() {
        const { themeVariables: themeVariables, themeMode: themeMode } = (0, $fyCFg.ThemeController).state;
        const defaultThemeMode = (0, $97bbL.UiHelperUtil).getColorTheme(themeMode);
        (0, $9rwwE.initializeTheming)(themeVariables, defaultThemeMode);
    }
    async onClose() {
        this.onScrollUnlock();
        await this.animate([
            {
                opacity: 1
            },
            {
                opacity: 0
            }
        ], {
            duration: 200,
            easing: "ease",
            fill: "forwards"
        }).finished;
        (0, $9fh1I.SnackController).hide();
        this.open = false;
        this.onRemoveKeyboardListener();
    }
    async onOpen() {
        this.onScrollLock();
        this.open = true;
        await this.animate([
            {
                opacity: 0
            },
            {
                opacity: 1
            }
        ], {
            duration: 200,
            easing: "ease",
            fill: "forwards",
            delay: 300
        }).finished;
        this.onAddKeyboardListener();
    }
    onScrollLock() {
        const styleTag = document.createElement("style");
        styleTag.dataset["w3m"] = $7542bbf3d97634c9$var$SCROLL_LOCK;
        styleTag.textContent = `
      html, body {
        touch-action: none;
        overflow: hidden;
        overscroll-behavior: contain;
      }
      w3m-modal {
        pointer-events: auto;
      }
    `;
        document.head.appendChild(styleTag);
    }
    onScrollUnlock() {
        const styleTag = document.head.querySelector(`style[data-w3m="${$7542bbf3d97634c9$var$SCROLL_LOCK}"]`);
        if (styleTag) styleTag.remove();
    }
    onAddKeyboardListener() {
        this.abortController = new AbortController();
        const card = this.shadowRoot?.querySelector("wui-card");
        card?.focus();
        window.addEventListener("keydown", (event)=>{
            if (event.key === "Escape") this.handleClose();
            else if (event.key === "Tab") {
                const { tagName: tagName } = event.target;
                if (tagName && !tagName.includes("W3M-") && !tagName.includes("WUI-")) card?.focus();
            }
        }, this.abortController);
    }
    onRemoveKeyboardListener() {
        this.abortController?.abort();
        this.abortController = undefined;
    }
    async onNewAccountState(newState) {
        const { isConnected: isConnected, caipAddress: newCaipAddress } = newState;
        if (this.isSiweEnabled) {
            if (isConnected && !this.caipAddress) this.caipAddress = newCaipAddress;
            if (isConnected && newCaipAddress && this.caipAddress !== newCaipAddress) {
                await (0, $iQR2f.SIWEController).signOut();
                this.onSiweNavigation();
                this.caipAddress = newCaipAddress;
            }
            try {
                const session = await (0, $iQR2f.SIWEController).getSession();
                if (session && !isConnected) await (0, $iQR2f.SIWEController).signOut();
                else if (isConnected && !session) this.onSiweNavigation();
            } catch (error) {
                if (isConnected) this.onSiweNavigation();
            }
        }
    }
    onSiweNavigation() {
        if (this.open) (0, $dJjpc.RouterController).push("ConnectingSiwe");
        else (0, $bnxqc.ModalController).open({
            view: "ConnectingSiwe"
        });
    }
};
$7542bbf3d97634c9$export$8f54aa55129a8184.styles = (0, $gQwfc.default);
$7542bbf3d97634c9$var$__decorate([
    (0, $6eT5F.state)()
], $7542bbf3d97634c9$export$8f54aa55129a8184.prototype, "open", void 0);
$7542bbf3d97634c9$var$__decorate([
    (0, $6eT5F.state)()
], $7542bbf3d97634c9$export$8f54aa55129a8184.prototype, "caipAddress", void 0);
$7542bbf3d97634c9$var$__decorate([
    (0, $6eT5F.state)()
], $7542bbf3d97634c9$export$8f54aa55129a8184.prototype, "isSiweEnabled", void 0);
$7542bbf3d97634c9$export$8f54aa55129a8184 = $7542bbf3d97634c9$var$__decorate([
    (0, $lkv4o.customElement)("w3m-modal")
], $7542bbf3d97634c9$export$8f54aa55129a8184);

});
parcelRegister("5bcND", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("kq2WI")).css);
$parcel$export(module.exports, "html", () => (parcelRequire("6HMh7")).html);
$parcel$export(module.exports, "LitElement", () => (parcelRequire("b47AP")).LitElement);
parcelRequire("9512w");
parcelRequire("6HMh7");
parcelRequire("b47AP");
parcelRequire("dMuAl");

});
parcelRegister("9512w", function(module, exports) {

$parcel$export(module.exports, "defaultConverter", () => $69c5632938618fde$export$7312b35fbf521afb);
$parcel$export(module.exports, "notEqual", () => $69c5632938618fde$export$53a6892c50694894);
$parcel$export(module.exports, "ReactiveElement", () => $69c5632938618fde$export$c7c07a37856565d);
$parcel$export(module.exports, "css", () => (parcelRequire("kq2WI")).css);

var $kq2WI = parcelRequire("kq2WI");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $69c5632938618fde$var$i, defineProperty: $69c5632938618fde$var$e, getOwnPropertyDescriptor: $69c5632938618fde$var$r, getOwnPropertyNames: $69c5632938618fde$var$h, getOwnPropertySymbols: $69c5632938618fde$var$o, getPrototypeOf: $69c5632938618fde$var$n } = Object, $69c5632938618fde$var$a = globalThis, $69c5632938618fde$var$c = $69c5632938618fde$var$a.trustedTypes, $69c5632938618fde$var$l = $69c5632938618fde$var$c ? $69c5632938618fde$var$c.emptyScript : "", $69c5632938618fde$var$p = $69c5632938618fde$var$a.reactiveElementPolyfillSupport, $69c5632938618fde$var$d = (t, s)=>t, $69c5632938618fde$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $69c5632938618fde$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $69c5632938618fde$export$53a6892c50694894 = (t, s)=>!$69c5632938618fde$var$i(t, s), $69c5632938618fde$var$y = {
    attribute: !0,
    type: String,
    converter: $69c5632938618fde$export$7312b35fbf521afb,
    reflect: !1,
    hasChanged: $69c5632938618fde$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $69c5632938618fde$var$a.litPropertyMetadata ??= new WeakMap;
class $69c5632938618fde$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $69c5632938618fde$var$y) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), r = this.getPropertyDescriptor(t, i, s);
            void 0 !== r && $69c5632938618fde$var$e(this.prototype, t, r);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: h } = $69c5632938618fde$var$r(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get () {
                return e?.call(this);
            },
            set (s) {
                const r = e?.call(this);
                h.call(this, s), this.requestUpdate(t, r, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $69c5632938618fde$var$y;
    }
    static _$Ei() {
        if (this.hasOwnProperty($69c5632938618fde$var$d("elementProperties"))) return;
        const t = $69c5632938618fde$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($69c5632938618fde$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($69c5632938618fde$var$d("properties"))) {
            const t = this.properties, s = [
                ...$69c5632938618fde$var$h(t),
                ...$69c5632938618fde$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $kq2WI.getCompatibleStyle)(s));
        } else void 0 !== s && i.push((0, $kq2WI.getCompatibleStyle)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $kq2WI.adoptStyles)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$EC(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const r = (void 0 !== i.converter?.toAttribute ? i.converter : $69c5632938618fde$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == r ? this.removeAttribute(e) : this.setAttribute(e, r), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), r = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $69c5632938618fde$export$7312b35fbf521afb;
            this._$Em = e, this[e] = r.fromAttribute(s, t.type), this._$Em = null;
        }
    }
    requestUpdate(t, s, i) {
        if (void 0 !== t) {
            if (i ??= this.constructor.getPropertyOptions(t), !(i.hasChanged ?? $69c5632938618fde$export$53a6892c50694894)(this[t], s)) return;
            this.P(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$ET());
    }
    P(t, s, i) {
        this._$AL.has(t) || this._$AL.set(t, s), !0 === i.reflect && this._$Em !== t && (this._$Ej ??= new Set).add(t);
    }
    async _$ET() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t)!0 !== i.wrapped || this._$AL.has(s) || void 0 === this[s] || this.P(s, this[s], i);
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EU();
        } catch (s) {
            throw t = !1, this._$EU(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EU() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Ej &&= this._$Ej.forEach((t)=>this._$EC(t, this[t])), this._$EU();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$69c5632938618fde$export$c7c07a37856565d.elementStyles = [], $69c5632938618fde$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $69c5632938618fde$export$c7c07a37856565d[$69c5632938618fde$var$d("elementProperties")] = new Map, $69c5632938618fde$export$c7c07a37856565d[$69c5632938618fde$var$d("finalized")] = new Map, $69c5632938618fde$var$p?.({
    ReactiveElement: $69c5632938618fde$export$c7c07a37856565d
}), ($69c5632938618fde$var$a.reactiveElementVersions ??= []).push("2.0.4");

});
parcelRegister("kq2WI", function(module, exports) {

$parcel$export(module.exports, "css", () => $edd8855ee7c14924$export$dbf350e5966cf602);
$parcel$export(module.exports, "adoptStyles", () => $edd8855ee7c14924$export$2ca4a66ec4cecb90);
$parcel$export(module.exports, "getCompatibleStyle", () => $edd8855ee7c14924$export$ee69dfd951e24778);
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $edd8855ee7c14924$var$t = globalThis, $edd8855ee7c14924$export$b4d10f6001c083c2 = $edd8855ee7c14924$var$t.ShadowRoot && (void 0 === $edd8855ee7c14924$var$t.ShadyCSS || $edd8855ee7c14924$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $edd8855ee7c14924$var$s = Symbol(), $edd8855ee7c14924$var$o = new WeakMap;
class $edd8855ee7c14924$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $edd8855ee7c14924$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($edd8855ee7c14924$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $edd8855ee7c14924$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $edd8855ee7c14924$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $edd8855ee7c14924$export$8d80f9cac07cdb3 = (t)=>new $edd8855ee7c14924$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $edd8855ee7c14924$var$s), $edd8855ee7c14924$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $edd8855ee7c14924$export$505d1e8739bad805(o, t, $edd8855ee7c14924$var$s);
}, $edd8855ee7c14924$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($edd8855ee7c14924$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $edd8855ee7c14924$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $edd8855ee7c14924$export$ee69dfd951e24778 = $edd8855ee7c14924$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $edd8855ee7c14924$export$8d80f9cac07cdb3(e);
    })(t) : t;

});


parcelRegister("6HMh7", function(module, exports) {

$parcel$export(module.exports, "html", () => $4e1c34a7656d6629$export$c0bb0b647f701bb5);
$parcel$export(module.exports, "noChange", () => $4e1c34a7656d6629$export$9c068ae9cc5db4e8);
$parcel$export(module.exports, "nothing", () => $4e1c34a7656d6629$export$45b790e32b2810ee);
$parcel$export(module.exports, "_$LH", () => $4e1c34a7656d6629$export$8613d1ca9052b22e);
$parcel$export(module.exports, "render", () => $4e1c34a7656d6629$export$b3890eb0ae9dca99);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $4e1c34a7656d6629$var$n = globalThis, $4e1c34a7656d6629$var$c = $4e1c34a7656d6629$var$n.trustedTypes, $4e1c34a7656d6629$var$h = $4e1c34a7656d6629$var$c ? $4e1c34a7656d6629$var$c.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $4e1c34a7656d6629$var$f = "$lit$", $4e1c34a7656d6629$var$v = `lit$${Math.random().toFixed(9).slice(2)}$`, $4e1c34a7656d6629$var$m = "?" + $4e1c34a7656d6629$var$v, $4e1c34a7656d6629$var$_ = `<${$4e1c34a7656d6629$var$m}>`, $4e1c34a7656d6629$var$w = document, $4e1c34a7656d6629$var$lt = ()=>$4e1c34a7656d6629$var$w.createComment(""), $4e1c34a7656d6629$var$st = (t)=>null === t || "object" != typeof t && "function" != typeof t, $4e1c34a7656d6629$var$g = Array.isArray, $4e1c34a7656d6629$var$$ = (t)=>$4e1c34a7656d6629$var$g(t) || "function" == typeof t?.[Symbol.iterator], $4e1c34a7656d6629$var$x = "[ 	\n\f\r]", $4e1c34a7656d6629$var$T = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $4e1c34a7656d6629$var$E = /-->/g, $4e1c34a7656d6629$var$k = />/g, $4e1c34a7656d6629$var$O = RegExp(`>|${$4e1c34a7656d6629$var$x}(?:([^\\s"'>=/]+)(${$4e1c34a7656d6629$var$x}*=${$4e1c34a7656d6629$var$x}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $4e1c34a7656d6629$var$S = /'/g, $4e1c34a7656d6629$var$j = /"/g, $4e1c34a7656d6629$var$M = /^(?:script|style|textarea|title)$/i, $4e1c34a7656d6629$var$P = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $4e1c34a7656d6629$export$c0bb0b647f701bb5 = $4e1c34a7656d6629$var$P(1), $4e1c34a7656d6629$export$7ed1367e7fa1ad68 = $4e1c34a7656d6629$var$P(2), $4e1c34a7656d6629$export$47d5b44d225be5b4 = $4e1c34a7656d6629$var$P(3), $4e1c34a7656d6629$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $4e1c34a7656d6629$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $4e1c34a7656d6629$var$V = new WeakMap, $4e1c34a7656d6629$var$I = $4e1c34a7656d6629$var$w.createTreeWalker($4e1c34a7656d6629$var$w, 129);
function $4e1c34a7656d6629$var$N(t, i) {
    if (!$4e1c34a7656d6629$var$g(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $4e1c34a7656d6629$var$h ? $4e1c34a7656d6629$var$h.createHTML(i) : i;
}
const $4e1c34a7656d6629$var$U = (t, i)=>{
    const s = t.length - 1, e = [];
    let h, o = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", n = $4e1c34a7656d6629$var$T;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let r, l, c = -1, a = 0;
        for(; a < s.length && (n.lastIndex = a, l = n.exec(s), null !== l);)a = n.lastIndex, n === $4e1c34a7656d6629$var$T ? "!--" === l[1] ? n = $4e1c34a7656d6629$var$E : void 0 !== l[1] ? n = $4e1c34a7656d6629$var$k : void 0 !== l[2] ? ($4e1c34a7656d6629$var$M.test(l[2]) && (h = RegExp("</" + l[2], "g")), n = $4e1c34a7656d6629$var$O) : void 0 !== l[3] && (n = $4e1c34a7656d6629$var$O) : n === $4e1c34a7656d6629$var$O ? ">" === l[0] ? (n = h ?? $4e1c34a7656d6629$var$T, c = -1) : void 0 === l[1] ? c = -2 : (c = n.lastIndex - l[2].length, r = l[1], n = void 0 === l[3] ? $4e1c34a7656d6629$var$O : '"' === l[3] ? $4e1c34a7656d6629$var$j : $4e1c34a7656d6629$var$S) : n === $4e1c34a7656d6629$var$j || n === $4e1c34a7656d6629$var$S ? n = $4e1c34a7656d6629$var$O : n === $4e1c34a7656d6629$var$E || n === $4e1c34a7656d6629$var$k ? n = $4e1c34a7656d6629$var$T : (n = $4e1c34a7656d6629$var$O, h = void 0);
        const u = n === $4e1c34a7656d6629$var$O && t[i + 1].startsWith("/>") ? " " : "";
        o += n === $4e1c34a7656d6629$var$T ? s + $4e1c34a7656d6629$var$_ : c >= 0 ? (e.push(r), s.slice(0, c) + $4e1c34a7656d6629$var$f + s.slice(c) + $4e1c34a7656d6629$var$v + u) : s + $4e1c34a7656d6629$var$v + (-2 === c ? i : u);
    }
    return [
        $4e1c34a7656d6629$var$N(t, o + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        e
    ];
};
class $4e1c34a7656d6629$var$B {
    constructor({ strings: t, _$litType$: i }, s){
        let e;
        this.parts = [];
        let h = 0, o = 0;
        const n = t.length - 1, r = this.parts, [l, a] = $4e1c34a7656d6629$var$U(t, i);
        if (this.el = $4e1c34a7656d6629$var$B.createElement(l, s), $4e1c34a7656d6629$var$I.currentNode = this.el.content, 2 === i || 3 === i) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (e = $4e1c34a7656d6629$var$I.nextNode()) && r.length < n;){
            if (1 === e.nodeType) {
                if (e.hasAttributes()) for (const t of e.getAttributeNames())if (t.endsWith($4e1c34a7656d6629$var$f)) {
                    const i = a[o++], s = e.getAttribute(t).split($4e1c34a7656d6629$var$v), n = /([.?@])?(.*)/.exec(i);
                    r.push({
                        type: 1,
                        index: h,
                        name: n[2],
                        strings: s,
                        ctor: "." === n[1] ? $4e1c34a7656d6629$var$Y : "?" === n[1] ? $4e1c34a7656d6629$var$Z : "@" === n[1] ? $4e1c34a7656d6629$var$q : $4e1c34a7656d6629$var$G
                    }), e.removeAttribute(t);
                } else t.startsWith($4e1c34a7656d6629$var$v) && (r.push({
                    type: 6,
                    index: h
                }), e.removeAttribute(t));
                if ($4e1c34a7656d6629$var$M.test(e.tagName)) {
                    const t = e.textContent.split($4e1c34a7656d6629$var$v), i = t.length - 1;
                    if (i > 0) {
                        e.textContent = $4e1c34a7656d6629$var$c ? $4e1c34a7656d6629$var$c.emptyScript : "";
                        for(let s = 0; s < i; s++)e.append(t[s], $4e1c34a7656d6629$var$lt()), $4e1c34a7656d6629$var$I.nextNode(), r.push({
                            type: 2,
                            index: ++h
                        });
                        e.append(t[i], $4e1c34a7656d6629$var$lt());
                    }
                }
            } else if (8 === e.nodeType) {
                if (e.data === $4e1c34a7656d6629$var$m) r.push({
                    type: 2,
                    index: h
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = e.data.indexOf($4e1c34a7656d6629$var$v, t + 1));)r.push({
                        type: 7,
                        index: h
                    }), t += $4e1c34a7656d6629$var$v.length - 1;
                }
            }
            h++;
        }
    }
    static createElement(t, i) {
        const s = $4e1c34a7656d6629$var$w.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $4e1c34a7656d6629$var$z(t, i, s = t, e) {
    if (i === $4e1c34a7656d6629$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s.o?.[e] : s.l;
    const o = $4e1c34a7656d6629$var$st(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s.o ??= [])[e] = h : s.l = h), void 0 !== h && (i = $4e1c34a7656d6629$var$z(t, h._$AS(t, i.values), h, e)), i;
}
class $4e1c34a7656d6629$var$F {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $4e1c34a7656d6629$var$w).importNode(i, !0);
        $4e1c34a7656d6629$var$I.currentNode = e;
        let h = $4e1c34a7656d6629$var$I.nextNode(), o = 0, n = 0, r = s[0];
        for(; void 0 !== r;){
            if (o === r.index) {
                let i;
                2 === r.type ? i = new $4e1c34a7656d6629$var$et(h, h.nextSibling, this, t) : 1 === r.type ? i = new r.ctor(h, r.name, r.strings, this, t) : 6 === r.type && (i = new $4e1c34a7656d6629$var$K(h, this, t)), this._$AV.push(i), r = s[++n];
            }
            o !== r?.index && (h = $4e1c34a7656d6629$var$I.nextNode(), o++);
        }
        return $4e1c34a7656d6629$var$I.currentNode = $4e1c34a7656d6629$var$w, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $4e1c34a7656d6629$var$et {
    get _$AU() {
        return this._$AM?._$AU ?? this.v;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $4e1c34a7656d6629$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this.v = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $4e1c34a7656d6629$var$z(this, t, i), $4e1c34a7656d6629$var$st(t) ? t === $4e1c34a7656d6629$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $4e1c34a7656d6629$export$45b790e32b2810ee && this._$AR(), this._$AH = $4e1c34a7656d6629$export$45b790e32b2810ee) : t !== this._$AH && t !== $4e1c34a7656d6629$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $4e1c34a7656d6629$var$$(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $4e1c34a7656d6629$export$45b790e32b2810ee && $4e1c34a7656d6629$var$st(this._$AH) ? this._$AA.nextSibling.data = t : this.T($4e1c34a7656d6629$var$w.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $4e1c34a7656d6629$var$B.createElement($4e1c34a7656d6629$var$N(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $4e1c34a7656d6629$var$F(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $4e1c34a7656d6629$var$V.get(t.strings);
        return void 0 === i && $4e1c34a7656d6629$var$V.set(t.strings, i = new $4e1c34a7656d6629$var$B(t)), i;
    }
    k(t) {
        $4e1c34a7656d6629$var$g(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $4e1c34a7656d6629$var$et(this.O($4e1c34a7656d6629$var$lt()), this.O($4e1c34a7656d6629$var$lt()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, i) {
        for(this._$AP?.(!1, !0, i); t && t !== this._$AB;){
            const i = t.nextSibling;
            t.remove(), t = i;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this.v = t, this._$AP?.(t));
    }
}
class $4e1c34a7656d6629$var$G {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $4e1c34a7656d6629$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $4e1c34a7656d6629$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $4e1c34a7656d6629$var$z(this, t, i, 0), o = !$4e1c34a7656d6629$var$st(t) || t !== this._$AH && t !== $4e1c34a7656d6629$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $4e1c34a7656d6629$var$z(this, e[s + n], i, n), r === $4e1c34a7656d6629$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$4e1c34a7656d6629$var$st(r) || r !== this._$AH[n], r === $4e1c34a7656d6629$export$45b790e32b2810ee ? t = $4e1c34a7656d6629$export$45b790e32b2810ee : t !== $4e1c34a7656d6629$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $4e1c34a7656d6629$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $4e1c34a7656d6629$var$Y extends $4e1c34a7656d6629$var$G {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $4e1c34a7656d6629$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $4e1c34a7656d6629$var$Z extends $4e1c34a7656d6629$var$G {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $4e1c34a7656d6629$export$45b790e32b2810ee);
    }
}
class $4e1c34a7656d6629$var$q extends $4e1c34a7656d6629$var$G {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $4e1c34a7656d6629$var$z(this, t, i, 0) ?? $4e1c34a7656d6629$export$45b790e32b2810ee) === $4e1c34a7656d6629$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $4e1c34a7656d6629$export$45b790e32b2810ee && s !== $4e1c34a7656d6629$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $4e1c34a7656d6629$export$45b790e32b2810ee && (s === $4e1c34a7656d6629$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $4e1c34a7656d6629$var$K {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $4e1c34a7656d6629$var$z(this, t);
    }
}
const $4e1c34a7656d6629$export$8613d1ca9052b22e = {
    M: $4e1c34a7656d6629$var$f,
    P: $4e1c34a7656d6629$var$v,
    A: $4e1c34a7656d6629$var$m,
    C: 1,
    L: $4e1c34a7656d6629$var$U,
    R: $4e1c34a7656d6629$var$F,
    D: $4e1c34a7656d6629$var$$,
    V: $4e1c34a7656d6629$var$z,
    I: $4e1c34a7656d6629$var$et,
    H: $4e1c34a7656d6629$var$G,
    N: $4e1c34a7656d6629$var$Z,
    U: $4e1c34a7656d6629$var$q,
    B: $4e1c34a7656d6629$var$Y,
    F: $4e1c34a7656d6629$var$K
}, $4e1c34a7656d6629$var$Re = $4e1c34a7656d6629$var$n.litHtmlPolyfillSupport;
$4e1c34a7656d6629$var$Re?.($4e1c34a7656d6629$var$B, $4e1c34a7656d6629$var$et), ($4e1c34a7656d6629$var$n.litHtmlVersions ??= []).push("3.2.0");
const $4e1c34a7656d6629$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $4e1c34a7656d6629$var$et(i.insertBefore($4e1c34a7656d6629$var$lt(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};

});

parcelRegister("b47AP", function(module, exports) {
$parcel$export(module.exports, "css", () => (parcelRequire("kq2WI")).css);
$parcel$export(module.exports, "ReactiveElement", () => (parcelRequire("9512w")).ReactiveElement);
$parcel$export(module.exports, "html", () => (parcelRequire("6HMh7")).html);
$parcel$export(module.exports, "noChange", () => (parcelRequire("6HMh7")).noChange);
$parcel$export(module.exports, "render", () => (parcelRequire("6HMh7")).render);

$parcel$export(module.exports, "LitElement", () => $80e5f53c4817fb65$export$3f2f9f5909897157);

var $9512w = parcelRequire("9512w");

var $6HMh7 = parcelRequire("6HMh7");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class $80e5f53c4817fb65$export$3f2f9f5909897157 extends (0, $9512w.ReactiveElement) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this.o = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const e = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this.o = (0, $6HMh7.render)(e, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this.o?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this.o?.setConnected(!1);
    }
    render() {
        return 0, $6HMh7.noChange;
    }
}
$80e5f53c4817fb65$export$3f2f9f5909897157._$litElement$ = !0, $80e5f53c4817fb65$export$3f2f9f5909897157["finalized"] = !0, globalThis.litElementHydrateSupport?.({
    LitElement: $80e5f53c4817fb65$export$3f2f9f5909897157
});
const $80e5f53c4817fb65$var$f = globalThis.litElementPolyfillSupport;
$80e5f53c4817fb65$var$f?.({
    LitElement: $80e5f53c4817fb65$export$3f2f9f5909897157
});
const $80e5f53c4817fb65$export$f5c524615a7708d6 = {
    _$AK: (t, e, s)=>{
        t._$AK(e, s);
    },
    _$AL: (t)=>t._$AL
};
(globalThis.litElementVersions ??= []).push("4.1.0");

});

parcelRegister("dMuAl", function(module, exports) {
/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $a0877b9dafa6edc1$export$6acf61af03e62db = !1;

});


parcelRegister("hrpLR", function(module, exports) {
$parcel$export(module.exports, "property", () => (parcelRequire("5YVCx")).property);
$parcel$export(module.exports, "state", () => (parcelRequire("6eT5F")).state);
parcelRequire("h14Az");
parcelRequire("5YVCx");
parcelRequire("6eT5F");
parcelRequire("7J9mr");
parcelRequire("2lf0K");
parcelRequire("eHBhW");
parcelRequire("Y1Dyp");
parcelRequire("kJ79W");
parcelRequire("895xL");

});
parcelRegister("h14Az", function(module, exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $c63616e7b3ad40df$export$da64fc29f17f9d0e = (t)=>(e, o)=>{
        void 0 !== o ? o.addInitializer(()=>{
            customElements.define(t, e);
        }) : customElements.define(t, e);
    };

});

parcelRegister("5YVCx", function(module, exports) {

$parcel$export(module.exports, "property", () => $45af409d29554601$export$d541bacb2bda4494);

var $9512w = parcelRequire("9512w");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $45af409d29554601$var$o = {
    attribute: !0,
    type: String,
    converter: (0, $9512w.defaultConverter),
    reflect: !1,
    hasChanged: (0, $9512w.notEqual)
}, $45af409d29554601$export$8d623b1670eb40f4 = (t = $45af409d29554601$var$o, e, r)=>{
    const { kind: n, metadata: i } = r;
    let s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), s.set(r.name, t), "accessor" === n) {
        const { name: o } = r;
        return {
            set (r) {
                const n = e.get.call(this);
                e.set.call(this, r), this.requestUpdate(o, n, t);
            },
            init (e) {
                return void 0 !== e && this.P(o, void 0, t), e;
            }
        };
    }
    if ("setter" === n) {
        const { name: o } = r;
        return function(r) {
            const n = this[o];
            e.call(this, r), this.requestUpdate(o, n, t);
        };
    }
    throw Error("Unsupported decorator location: " + n);
};
function $45af409d29554601$export$d541bacb2bda4494(t) {
    return (e, o)=>"object" == typeof o ? $45af409d29554601$export$8d623b1670eb40f4(t, e, o) : ((t, e, o)=>{
            const r = e.hasOwnProperty(o);
            return e.constructor.createProperty(o, r ? {
                ...t,
                wrapped: !0
            } : t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
        })(t, e, o);
}

});

parcelRegister("6eT5F", function(module, exports) {

$parcel$export(module.exports, "state", () => $48aec8ae6c661af2$export$ca000e230c0caa3e);

var $5YVCx = parcelRequire("5YVCx");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $48aec8ae6c661af2$export$ca000e230c0caa3e(r) {
    return (0, $5YVCx.property)({
        ...r,
        state: !0,
        attribute: !1
    });
}

});

parcelRegister("7J9mr", function(module, exports) {
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $5a03ff46b27cca67$export$b2b799818fbabcf3(t) {
    return (n, o)=>{
        const c = "function" == typeof n ? n : n[o];
        Object.assign(c, t);
    };
}

});

parcelRegister("2lf0K", function(module, exports) {

var $b3dS4 = parcelRequire("b3dS4");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $1b492fce9aab2495$export$2fa187e846a241c4(e, r) {
    return (n, s, i)=>{
        const o = (t)=>t.renderRoot?.querySelector(e) ?? null;
        if (r) {
            const { get: e, set: r } = "object" == typeof s ? n : i ?? (()=>{
                const t = Symbol();
                return {
                    get () {
                        return this[t];
                    },
                    set (e) {
                        this[t] = e;
                    }
                };
            })();
            return (0, $b3dS4.desc)(n, s, {
                get () {
                    let t = e.call(this);
                    return void 0 === t && (t = o(this), (null !== t || this.hasUpdated) && r.call(this, t)), t;
                }
            });
        }
        return (0, $b3dS4.desc)(n, s, {
            get () {
                return o(this);
            }
        });
    };
}

});
parcelRegister("b3dS4", function(module, exports) {

$parcel$export(module.exports, "desc", () => $80babc08e479b4d7$export$51987bb50e1f6752);
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $80babc08e479b4d7$export$51987bb50e1f6752 = (e, t, c)=>(c.configurable = !0, c.enumerable = !0, Reflect.decorate && "object" != typeof t && Object.defineProperty(e, t, c), c);

});


parcelRegister("eHBhW", function(module, exports) {

var $b3dS4 = parcelRequire("b3dS4");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let $ab42018b534d5805$var$e;
function $ab42018b534d5805$export$dcd0d083aa86c355(r) {
    return (n, o)=>(0, $b3dS4.desc)(n, o, {
            get () {
                return (this.renderRoot ?? ($ab42018b534d5805$var$e ??= document.createDocumentFragment())).querySelectorAll(r);
            }
        });
}

});

parcelRegister("Y1Dyp", function(module, exports) {

var $b3dS4 = parcelRequire("b3dS4");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $0b46dfc77ae4633a$export$163dfc35cc43f240(r) {
    return (n, e)=>(0, $b3dS4.desc)(n, e, {
            async get () {
                return await this.updateComplete, this.renderRoot?.querySelector(r) ?? null;
            }
        });
}

});

parcelRegister("kJ79W", function(module, exports) {

var $b3dS4 = parcelRequire("b3dS4");
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $f16d9056d0eb22bf$export$4682af2d9ee91415(o) {
    return (e, n)=>{
        const { slot: r, selector: s } = o ?? {}, c = "slot" + (r ? `[name=${r}]` : ":not([name])");
        return (0, $b3dS4.desc)(e, n, {
            get () {
                const t = this.renderRoot?.querySelector(c), e = t?.assignedElements(o) ?? [];
                return void 0 === s ? e : e.filter((t)=>t.matches(s));
            }
        });
    };
}

});

parcelRegister("895xL", function(module, exports) {

var $b3dS4 = parcelRequire("b3dS4");
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $5ee376d0e673464c$export$1bdbe53f9df1b8(n) {
    return (o, r)=>{
        const { slot: e } = n ?? {}, s = "slot" + (e ? `[name=${e}]` : ":not([name])");
        return (0, $b3dS4.desc)(o, r, {
            get () {
                const t = this.renderRoot?.querySelector(s);
                return t?.assignedNodes(n) ?? [];
            }
        });
    };
}

});


parcelRegister("gQwfc", function(module, exports) {

$parcel$export(module.exports, "default", () => $c43a83ad39fbf178$export$2e2bcd8739ae039);
parcelRequire("5bcND");
var $kq2WI = parcelRequire("kq2WI");
var $c43a83ad39fbf178$export$2e2bcd8739ae039 = (0, $kq2WI.css)`
  :host {
    z-index: var(--w3m-z-index);
    display: block;
    backface-visibility: hidden;
    will-change: opacity;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    pointer-events: none;
    opacity: 0;
    background-color: var(--wui-cover);
  }

  @keyframes zoom-in {
    0% {
      transform: scale(0.95) translateY(0);
    }
    100% {
      transform: scale(1) translateY(0);
    }
  }

  @keyframes slide-in {
    0% {
      transform: scale(1) translateY(50px);
    }
    100% {
      transform: scale(1) translateY(0);
    }
  }

  wui-card {
    max-width: 360px;
    width: 100%;
    position: relative;
    animation-delay: 0.3s;
    animation-duration: 0.2s;
    animation-name: zoom-in;
    animation-fill-mode: backwards;
    animation-timing-function: var(--wui-ease-out-power-2);
    outline: none;
  }

  wui-flex {
    overflow-x: hidden;
    overflow-y: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  @media (max-height: 700px) and (min-width: 431px) {
    wui-flex {
      align-items: flex-start;
    }

    wui-card {
      margin: var(--wui-spacing-xxl) 0px;
    }
  }

  @media (max-width: 430px) {
    wui-flex {
      align-items: flex-end;
    }

    wui-card {
      max-width: 100%;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      border-bottom: none;
      animation-name: slide-in;
    }
  }
`;

});


parcelRegister("kOxZb", function(module, exports) {


module.exports = (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("b4FhE")).then(()=>parcelRequire("lgGzk"));

});

parcelRegister("1itcf", function(module, exports) {


module.exports = (parcelRequire("dNLwc"))((parcelRequire("kI8SP")).resolve("hb191")).then(()=>parcelRequire("fBBAw"));

});

parcelRegister("ibaza", function(module, exports) {
// shim for using process in browser
var $d3c1734dacb01657$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $d3c1734dacb01657$var$cachedSetTimeout;
var $d3c1734dacb01657$var$cachedClearTimeout;
function $d3c1734dacb01657$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $d3c1734dacb01657$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        else $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedSetTimeout = $d3c1734dacb01657$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        else $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    } catch (e) {
        $d3c1734dacb01657$var$cachedClearTimeout = $d3c1734dacb01657$var$defaultClearTimeout;
    }
})();
function $d3c1734dacb01657$var$runTimeout(fun) {
    if ($d3c1734dacb01657$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedSetTimeout === $d3c1734dacb01657$var$defaultSetTimout || !$d3c1734dacb01657$var$cachedSetTimeout) && setTimeout) {
        $d3c1734dacb01657$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $d3c1734dacb01657$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $d3c1734dacb01657$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $d3c1734dacb01657$var$runClearTimeout(marker) {
    if ($d3c1734dacb01657$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($d3c1734dacb01657$var$cachedClearTimeout === $d3c1734dacb01657$var$defaultClearTimeout || !$d3c1734dacb01657$var$cachedClearTimeout) && clearTimeout) {
        $d3c1734dacb01657$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $d3c1734dacb01657$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $d3c1734dacb01657$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $d3c1734dacb01657$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $d3c1734dacb01657$var$queue = [];
var $d3c1734dacb01657$var$draining = false;
var $d3c1734dacb01657$var$currentQueue;
var $d3c1734dacb01657$var$queueIndex = -1;
function $d3c1734dacb01657$var$cleanUpNextTick() {
    if (!$d3c1734dacb01657$var$draining || !$d3c1734dacb01657$var$currentQueue) return;
    $d3c1734dacb01657$var$draining = false;
    if ($d3c1734dacb01657$var$currentQueue.length) $d3c1734dacb01657$var$queue = $d3c1734dacb01657$var$currentQueue.concat($d3c1734dacb01657$var$queue);
    else $d3c1734dacb01657$var$queueIndex = -1;
    if ($d3c1734dacb01657$var$queue.length) $d3c1734dacb01657$var$drainQueue();
}
function $d3c1734dacb01657$var$drainQueue() {
    if ($d3c1734dacb01657$var$draining) return;
    var timeout = $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$cleanUpNextTick);
    $d3c1734dacb01657$var$draining = true;
    var len = $d3c1734dacb01657$var$queue.length;
    while(len){
        $d3c1734dacb01657$var$currentQueue = $d3c1734dacb01657$var$queue;
        $d3c1734dacb01657$var$queue = [];
        while(++$d3c1734dacb01657$var$queueIndex < len)if ($d3c1734dacb01657$var$currentQueue) $d3c1734dacb01657$var$currentQueue[$d3c1734dacb01657$var$queueIndex].run();
        $d3c1734dacb01657$var$queueIndex = -1;
        len = $d3c1734dacb01657$var$queue.length;
    }
    $d3c1734dacb01657$var$currentQueue = null;
    $d3c1734dacb01657$var$draining = false;
    $d3c1734dacb01657$var$runClearTimeout(timeout);
}
$d3c1734dacb01657$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $d3c1734dacb01657$var$queue.push(new $d3c1734dacb01657$var$Item(fun, args));
    if ($d3c1734dacb01657$var$queue.length === 1 && !$d3c1734dacb01657$var$draining) $d3c1734dacb01657$var$runTimeout($d3c1734dacb01657$var$drainQueue);
};
// v8 likes predictible objects
function $d3c1734dacb01657$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$d3c1734dacb01657$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$d3c1734dacb01657$var$process.title = "browser";
$d3c1734dacb01657$var$process.browser = true;
$d3c1734dacb01657$var$process.env = {};
$d3c1734dacb01657$var$process.argv = [];
$d3c1734dacb01657$var$process.version = ""; // empty string to avoid regexp issues
$d3c1734dacb01657$var$process.versions = {};
function $d3c1734dacb01657$var$noop() {}
$d3c1734dacb01657$var$process.on = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.addListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.once = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.off = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.removeAllListeners = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.emit = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.prependOnceListener = $d3c1734dacb01657$var$noop;
$d3c1734dacb01657$var$process.listeners = function(name) {
    return [];
};
$d3c1734dacb01657$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$d3c1734dacb01657$var$process.cwd = function() {
    return "/";
};
$d3c1734dacb01657$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$d3c1734dacb01657$var$process.umask = function() {
    return 0;
};

});

parcelRegister("ioIGR", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $d64d226c7a9ad539$export$a7c73072b1a182ae, (v) => $d64d226c7a9ad539$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $d64d226c7a9ad539$export$9f27bc3417b4524d, (v) => $d64d226c7a9ad539$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $d64d226c7a9ad539$export$db77ccec0bb4ccac, (v) => $d64d226c7a9ad539$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $d64d226c7a9ad539$export$8392c0c9d3dcbd35, (v) => $d64d226c7a9ad539$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $d64d226c7a9ad539$export$ffb0004e005737fa, (v) => $d64d226c7a9ad539$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $d64d226c7a9ad539$export$b624eff549462981, (v) => $d64d226c7a9ad539$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $d64d226c7a9ad539$export$7897aa7841a5380c, (v) => $d64d226c7a9ad539$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $d64d226c7a9ad539$export$602eac185826482c, (v) => $d64d226c7a9ad539$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $d64d226c7a9ad539$export$e2c29f18771995cb, (v) => $d64d226c7a9ad539$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $d64d226c7a9ad539$export$5f8d39834fd61797, (v) => $d64d226c7a9ad539$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $d64d226c7a9ad539$export$74bf444e3cd11ea5, (v) => $d64d226c7a9ad539$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $d64d226c7a9ad539$export$998bcd577473dd93, (v) => $d64d226c7a9ad539$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $d64d226c7a9ad539$export$92387174baf9b227, (v) => $d64d226c7a9ad539$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $d64d226c7a9ad539$export$ec112efeb987d9c6, (v) => $d64d226c7a9ad539$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $d64d226c7a9ad539$export$b706b080d889d2c9, (v) => $d64d226c7a9ad539$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $d64d226c7a9ad539$export$5be5a87408f70ddc, (v) => $d64d226c7a9ad539$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $d64d226c7a9ad539$export$45a5e7f76e0caa8d, (v) => $d64d226c7a9ad539$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $d64d226c7a9ad539$export$455c2e768291efa6, (v) => $d64d226c7a9ad539$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $d64d226c7a9ad539$export$9522e17588c12572, (v) => $d64d226c7a9ad539$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $d64d226c7a9ad539$export$2110ac352bb060b9, (v) => $d64d226c7a9ad539$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $d64d226c7a9ad539$export$56885ab8b9c456ab, (v) => $d64d226c7a9ad539$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $d64d226c7a9ad539$export$d927fcb6adf8f9de, (v) => $d64d226c7a9ad539$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $d64d226c7a9ad539$export$b82d16f27459e05a, (v) => $d64d226c7a9ad539$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $d64d226c7a9ad539$export$522c17b4f5e123e8, (v) => $d64d226c7a9ad539$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $d64d226c7a9ad539$export$1aabd8a0274ecfd6, (v) => $d64d226c7a9ad539$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $d64d226c7a9ad539$export$3d6c20d97e46b957, (v) => $d64d226c7a9ad539$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $d64d226c7a9ad539$export$9b621391a187a31a, (v) => $d64d226c7a9ad539$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $d64d226c7a9ad539$export$f5bbd400c2f4426f, (v) => $d64d226c7a9ad539$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d64d226c7a9ad539$export$a7c73072b1a182ae;
var $d64d226c7a9ad539$export$9f27bc3417b4524d;
var $d64d226c7a9ad539$export$db77ccec0bb4ccac;
var $d64d226c7a9ad539$export$8392c0c9d3dcbd35;
var $d64d226c7a9ad539$export$ffb0004e005737fa;
var $d64d226c7a9ad539$export$b624eff549462981;
var $d64d226c7a9ad539$export$7897aa7841a5380c;
var $d64d226c7a9ad539$export$602eac185826482c;
var $d64d226c7a9ad539$export$e2c29f18771995cb;
var $d64d226c7a9ad539$export$5f8d39834fd61797;
var $d64d226c7a9ad539$export$74bf444e3cd11ea5;
var $d64d226c7a9ad539$export$998bcd577473dd93;
var $d64d226c7a9ad539$export$92387174baf9b227;
var $d64d226c7a9ad539$export$ec112efeb987d9c6;
var $d64d226c7a9ad539$export$b706b080d889d2c9;
var $d64d226c7a9ad539$export$5be5a87408f70ddc;
var $d64d226c7a9ad539$export$45a5e7f76e0caa8d;
var $d64d226c7a9ad539$export$455c2e768291efa6;
var $d64d226c7a9ad539$export$9522e17588c12572;
var $d64d226c7a9ad539$export$2110ac352bb060b9;
var $d64d226c7a9ad539$export$56885ab8b9c456ab;
var $d64d226c7a9ad539$export$d927fcb6adf8f9de;
var $d64d226c7a9ad539$export$b82d16f27459e05a;
var $d64d226c7a9ad539$export$522c17b4f5e123e8;
var $d64d226c7a9ad539$export$1aabd8a0274ecfd6;
var $d64d226c7a9ad539$export$3d6c20d97e46b957;
var $d64d226c7a9ad539$export$9b621391a187a31a;
var $d64d226c7a9ad539$export$f5bbd400c2f4426f;
"use strict";
(function() {
    "use strict";
    // ATTENTION
    // When adding new symbols to this file,
    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
    // The Symbol used to tag the ReactElement-like types.
    var REACT_ELEMENT_TYPE = Symbol.for("react.element");
    var REACT_PORTAL_TYPE = Symbol.for("react.portal");
    var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
    var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
    var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
    var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
    var REACT_CONTEXT_TYPE = Symbol.for("react.context");
    var REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
    var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
    var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
    var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
    var REACT_MEMO_TYPE = Symbol.for("react.memo");
    var REACT_LAZY_TYPE = Symbol.for("react.lazy");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    // -----------------------------------------------------------------------------
    var enableScopeAPI = false; // Experimental Create Event Handle API.
    var enableCacheElement = false;
    var enableTransitionTracing = false; // No known bugs, but needs performance testing
    var enableLegacyHidden = false; // Enables unstable_avoidThisFallback feature in Fiber
    // stuff. Intended to enable React core members to more easily debug scheduling
    // issues in DEV builds.
    var enableDebugTracing = false; // Track which Fiber(s) schedule render work.
    var REACT_MODULE_REFERENCE;
    REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
    function isValidElementType(type) {
        if (typeof type === "string" || typeof type === "function") return true;
         // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
        if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || enableDebugTracing || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) return true;
        if (typeof type === "object" && type !== null) {
            if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type.$$typeof === REACT_MODULE_REFERENCE || type.getModuleId !== undefined) return true;
        }
        return false;
    }
    function typeOf(object) {
        if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                        case REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_SERVER_CONTEXT_TYPE:
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    }
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false;
    var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.");
        }
        return false;
    }
    function isConcurrentMode(object) {
        if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
            hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.");
        }
        return false;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    function isSuspenseList(object) {
        return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
    }
    $d64d226c7a9ad539$export$a7c73072b1a182ae = ContextConsumer;
    $d64d226c7a9ad539$export$9f27bc3417b4524d = ContextProvider;
    $d64d226c7a9ad539$export$db77ccec0bb4ccac = Element;
    $d64d226c7a9ad539$export$8392c0c9d3dcbd35 = ForwardRef;
    $d64d226c7a9ad539$export$ffb0004e005737fa = Fragment;
    $d64d226c7a9ad539$export$b624eff549462981 = Lazy;
    $d64d226c7a9ad539$export$7897aa7841a5380c = Memo;
    $d64d226c7a9ad539$export$602eac185826482c = Portal;
    $d64d226c7a9ad539$export$e2c29f18771995cb = Profiler;
    $d64d226c7a9ad539$export$5f8d39834fd61797 = StrictMode;
    $d64d226c7a9ad539$export$74bf444e3cd11ea5 = Suspense;
    $d64d226c7a9ad539$export$998bcd577473dd93 = SuspenseList;
    $d64d226c7a9ad539$export$92387174baf9b227 = isAsyncMode;
    $d64d226c7a9ad539$export$ec112efeb987d9c6 = isConcurrentMode;
    $d64d226c7a9ad539$export$b706b080d889d2c9 = isContextConsumer;
    $d64d226c7a9ad539$export$5be5a87408f70ddc = isContextProvider;
    $d64d226c7a9ad539$export$45a5e7f76e0caa8d = isElement;
    $d64d226c7a9ad539$export$455c2e768291efa6 = isForwardRef;
    $d64d226c7a9ad539$export$9522e17588c12572 = isFragment;
    $d64d226c7a9ad539$export$2110ac352bb060b9 = isLazy;
    $d64d226c7a9ad539$export$56885ab8b9c456ab = isMemo;
    $d64d226c7a9ad539$export$d927fcb6adf8f9de = isPortal;
    $d64d226c7a9ad539$export$b82d16f27459e05a = isProfiler;
    $d64d226c7a9ad539$export$522c17b4f5e123e8 = isStrictMode;
    $d64d226c7a9ad539$export$1aabd8a0274ecfd6 = isSuspense;
    $d64d226c7a9ad539$export$3d6c20d97e46b957 = isSuspenseList;
    $d64d226c7a9ad539$export$9b621391a187a31a = isValidElementType;
    $d64d226c7a9ad539$export$f5bbd400c2f4426f = typeOf;
})();

});

parcelRegister("iwMs7", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $d7d0ccd1aee68f1a$export$2b8d127b894957b9, (v) => $d7d0ccd1aee68f1a$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $d7d0ccd1aee68f1a$export$cea3a54a6425200c, (v) => $d7d0ccd1aee68f1a$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $d7d0ccd1aee68f1a$export$a7c73072b1a182ae, (v) => $d7d0ccd1aee68f1a$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $d7d0ccd1aee68f1a$export$9f27bc3417b4524d, (v) => $d7d0ccd1aee68f1a$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $d7d0ccd1aee68f1a$export$db77ccec0bb4ccac, (v) => $d7d0ccd1aee68f1a$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $d7d0ccd1aee68f1a$export$8392c0c9d3dcbd35, (v) => $d7d0ccd1aee68f1a$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $d7d0ccd1aee68f1a$export$ffb0004e005737fa, (v) => $d7d0ccd1aee68f1a$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $d7d0ccd1aee68f1a$export$b624eff549462981, (v) => $d7d0ccd1aee68f1a$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $d7d0ccd1aee68f1a$export$7897aa7841a5380c, (v) => $d7d0ccd1aee68f1a$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $d7d0ccd1aee68f1a$export$602eac185826482c, (v) => $d7d0ccd1aee68f1a$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $d7d0ccd1aee68f1a$export$e2c29f18771995cb, (v) => $d7d0ccd1aee68f1a$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $d7d0ccd1aee68f1a$export$5f8d39834fd61797, (v) => $d7d0ccd1aee68f1a$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $d7d0ccd1aee68f1a$export$74bf444e3cd11ea5, (v) => $d7d0ccd1aee68f1a$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $d7d0ccd1aee68f1a$export$92387174baf9b227, (v) => $d7d0ccd1aee68f1a$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $d7d0ccd1aee68f1a$export$ec112efeb987d9c6, (v) => $d7d0ccd1aee68f1a$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $d7d0ccd1aee68f1a$export$b706b080d889d2c9, (v) => $d7d0ccd1aee68f1a$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $d7d0ccd1aee68f1a$export$5be5a87408f70ddc, (v) => $d7d0ccd1aee68f1a$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $d7d0ccd1aee68f1a$export$45a5e7f76e0caa8d, (v) => $d7d0ccd1aee68f1a$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $d7d0ccd1aee68f1a$export$455c2e768291efa6, (v) => $d7d0ccd1aee68f1a$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $d7d0ccd1aee68f1a$export$9522e17588c12572, (v) => $d7d0ccd1aee68f1a$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $d7d0ccd1aee68f1a$export$2110ac352bb060b9, (v) => $d7d0ccd1aee68f1a$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $d7d0ccd1aee68f1a$export$56885ab8b9c456ab, (v) => $d7d0ccd1aee68f1a$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $d7d0ccd1aee68f1a$export$d927fcb6adf8f9de, (v) => $d7d0ccd1aee68f1a$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $d7d0ccd1aee68f1a$export$b82d16f27459e05a, (v) => $d7d0ccd1aee68f1a$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $d7d0ccd1aee68f1a$export$522c17b4f5e123e8, (v) => $d7d0ccd1aee68f1a$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $d7d0ccd1aee68f1a$export$1aabd8a0274ecfd6, (v) => $d7d0ccd1aee68f1a$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $d7d0ccd1aee68f1a$export$9b621391a187a31a, (v) => $d7d0ccd1aee68f1a$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $d7d0ccd1aee68f1a$export$f5bbd400c2f4426f, (v) => $d7d0ccd1aee68f1a$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d7d0ccd1aee68f1a$export$2b8d127b894957b9;
var $d7d0ccd1aee68f1a$export$cea3a54a6425200c;
var $d7d0ccd1aee68f1a$export$a7c73072b1a182ae;
var $d7d0ccd1aee68f1a$export$9f27bc3417b4524d;
var $d7d0ccd1aee68f1a$export$db77ccec0bb4ccac;
var $d7d0ccd1aee68f1a$export$8392c0c9d3dcbd35;
var $d7d0ccd1aee68f1a$export$ffb0004e005737fa;
var $d7d0ccd1aee68f1a$export$b624eff549462981;
var $d7d0ccd1aee68f1a$export$7897aa7841a5380c;
var $d7d0ccd1aee68f1a$export$602eac185826482c;
var $d7d0ccd1aee68f1a$export$e2c29f18771995cb;
var $d7d0ccd1aee68f1a$export$5f8d39834fd61797;
var $d7d0ccd1aee68f1a$export$74bf444e3cd11ea5;
var $d7d0ccd1aee68f1a$export$92387174baf9b227;
var $d7d0ccd1aee68f1a$export$ec112efeb987d9c6;
var $d7d0ccd1aee68f1a$export$b706b080d889d2c9;
var $d7d0ccd1aee68f1a$export$5be5a87408f70ddc;
var $d7d0ccd1aee68f1a$export$45a5e7f76e0caa8d;
var $d7d0ccd1aee68f1a$export$455c2e768291efa6;
var $d7d0ccd1aee68f1a$export$9522e17588c12572;
var $d7d0ccd1aee68f1a$export$2110ac352bb060b9;
var $d7d0ccd1aee68f1a$export$56885ab8b9c456ab;
var $d7d0ccd1aee68f1a$export$d927fcb6adf8f9de;
var $d7d0ccd1aee68f1a$export$b82d16f27459e05a;
var $d7d0ccd1aee68f1a$export$522c17b4f5e123e8;
var $d7d0ccd1aee68f1a$export$1aabd8a0274ecfd6;
var $d7d0ccd1aee68f1a$export$9b621391a187a31a;
var $d7d0ccd1aee68f1a$export$f5bbd400c2f4426f;
"use strict";
(function() {
    "use strict";
    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
    // nor polyfill, then a plain number is used for performance.
    var hasSymbol = typeof Symbol === "function" && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for("react.element") : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for("react.portal") : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for("react.fragment") : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for("react.strict_mode") : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for("react.profiler") : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for("react.provider") : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for("react.context") : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?
    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for("react.async_mode") : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for("react.concurrent_mode") : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for("react.forward_ref") : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for("react.suspense") : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for("react.suspense_list") : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for("react.memo") : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for("react.lazy") : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for("react.block") : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for("react.fundamental") : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for("react.responder") : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for("react.scope") : 0xead7;
    function isValidElementType(type) {
        return typeof type === "string" || typeof type === "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }
    function typeOf(object) {
        if (typeof object === "object" && object !== null) {
            var $$typeof = object.$$typeof;
            switch($$typeof){
                case REACT_ELEMENT_TYPE:
                    var type = object.type;
                    switch(type){
                        case REACT_ASYNC_MODE_TYPE:
                        case REACT_CONCURRENT_MODE_TYPE:
                        case REACT_FRAGMENT_TYPE:
                        case REACT_PROFILER_TYPE:
                        case REACT_STRICT_MODE_TYPE:
                        case REACT_SUSPENSE_TYPE:
                            return type;
                        default:
                            var $$typeofType = type && type.$$typeof;
                            switch($$typeofType){
                                case REACT_CONTEXT_TYPE:
                                case REACT_FORWARD_REF_TYPE:
                                case REACT_LAZY_TYPE:
                                case REACT_MEMO_TYPE:
                                case REACT_PROVIDER_TYPE:
                                    return $$typeofType;
                                default:
                                    return $$typeof;
                            }
                    }
                case REACT_PORTAL_TYPE:
                    return $$typeof;
            }
        }
        return undefined;
    } // AsyncMode is deprecated along with isAsyncMode
    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated
    function isAsyncMode(object) {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
            hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint
            console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.");
        }
        return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }
    function isConcurrentMode(object) {
        return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }
    function isContextConsumer(object) {
        return typeOf(object) === REACT_CONTEXT_TYPE;
    }
    function isContextProvider(object) {
        return typeOf(object) === REACT_PROVIDER_TYPE;
    }
    function isElement(object) {
        return typeof object === "object" && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }
    function isForwardRef(object) {
        return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }
    function isFragment(object) {
        return typeOf(object) === REACT_FRAGMENT_TYPE;
    }
    function isLazy(object) {
        return typeOf(object) === REACT_LAZY_TYPE;
    }
    function isMemo(object) {
        return typeOf(object) === REACT_MEMO_TYPE;
    }
    function isPortal(object) {
        return typeOf(object) === REACT_PORTAL_TYPE;
    }
    function isProfiler(object) {
        return typeOf(object) === REACT_PROFILER_TYPE;
    }
    function isStrictMode(object) {
        return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }
    function isSuspense(object) {
        return typeOf(object) === REACT_SUSPENSE_TYPE;
    }
    $d7d0ccd1aee68f1a$export$2b8d127b894957b9 = AsyncMode;
    $d7d0ccd1aee68f1a$export$cea3a54a6425200c = ConcurrentMode;
    $d7d0ccd1aee68f1a$export$a7c73072b1a182ae = ContextConsumer;
    $d7d0ccd1aee68f1a$export$9f27bc3417b4524d = ContextProvider;
    $d7d0ccd1aee68f1a$export$db77ccec0bb4ccac = Element;
    $d7d0ccd1aee68f1a$export$8392c0c9d3dcbd35 = ForwardRef;
    $d7d0ccd1aee68f1a$export$ffb0004e005737fa = Fragment;
    $d7d0ccd1aee68f1a$export$b624eff549462981 = Lazy;
    $d7d0ccd1aee68f1a$export$7897aa7841a5380c = Memo;
    $d7d0ccd1aee68f1a$export$602eac185826482c = Portal;
    $d7d0ccd1aee68f1a$export$e2c29f18771995cb = Profiler;
    $d7d0ccd1aee68f1a$export$5f8d39834fd61797 = StrictMode;
    $d7d0ccd1aee68f1a$export$74bf444e3cd11ea5 = Suspense;
    $d7d0ccd1aee68f1a$export$92387174baf9b227 = isAsyncMode;
    $d7d0ccd1aee68f1a$export$ec112efeb987d9c6 = isConcurrentMode;
    $d7d0ccd1aee68f1a$export$b706b080d889d2c9 = isContextConsumer;
    $d7d0ccd1aee68f1a$export$5be5a87408f70ddc = isContextProvider;
    $d7d0ccd1aee68f1a$export$45a5e7f76e0caa8d = isElement;
    $d7d0ccd1aee68f1a$export$455c2e768291efa6 = isForwardRef;
    $d7d0ccd1aee68f1a$export$9522e17588c12572 = isFragment;
    $d7d0ccd1aee68f1a$export$2110ac352bb060b9 = isLazy;
    $d7d0ccd1aee68f1a$export$56885ab8b9c456ab = isMemo;
    $d7d0ccd1aee68f1a$export$d927fcb6adf8f9de = isPortal;
    $d7d0ccd1aee68f1a$export$b82d16f27459e05a = isProfiler;
    $d7d0ccd1aee68f1a$export$522c17b4f5e123e8 = isStrictMode;
    $d7d0ccd1aee68f1a$export$1aabd8a0274ecfd6 = isSuspense;
    $d7d0ccd1aee68f1a$export$9b621391a187a31a = isValidElementType;
    $d7d0ccd1aee68f1a$export$f5bbd400c2f4426f = typeOf;
})();

});

parcelRegister("O6tRJ", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("6gCNy", function(module, exports) {

$parcel$export(module.exports, "isAddressEqual", () => $4902553d1ee1c7f8$export$34ca016df7f376b8);

var $8j5HI = parcelRequire("8j5HI");

var $4rOic = parcelRequire("4rOic");
function $4902553d1ee1c7f8$export$34ca016df7f376b8(a, b) {
    if (!(0, $4rOic.isAddress)(a, {
        strict: false
    })) throw new (0, $8j5HI.InvalidAddressError)({
        address: a
    });
    if (!(0, $4rOic.isAddress)(b, {
        strict: false
    })) throw new (0, $8j5HI.InvalidAddressError)({
        address: b
    });
    return a.toLowerCase() === b.toLowerCase();
}

});

parcelRegister("3VCvn", function(module, exports) {

$parcel$export(module.exports, "secp256k1", () => $2dc4904548ca9557$export$529e6123e9353a90);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $jfkMZ = parcelRequire("jfkMZ");

var $5358X = parcelRequire("5358X");

var $clLt8 = parcelRequire("clLt8");

var $1ZciS = parcelRequire("1ZciS");

var $87Zkx = parcelRequire("87Zkx");

var $liJ6s = parcelRequire("liJ6s");

var $3DvJ1 = parcelRequire("3DvJ1");
const $2dc4904548ca9557$var$secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f");
const $2dc4904548ca9557$var$secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
const $2dc4904548ca9557$var$_1n = BigInt(1);
const $2dc4904548ca9557$var$_2n = BigInt(2);
const $2dc4904548ca9557$var$divNearest = (a, b)=>(a + b / $2dc4904548ca9557$var$_2n) / b;
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $2dc4904548ca9557$var$sqrtMod(y) {
    const P = $2dc4904548ca9557$var$secp256k1P;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, $clLt8.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, $clLt8.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, $clLt8.pow2)(b9, $2dc4904548ca9557$var$_2n, P) * b2 % P;
    const b22 = (0, $clLt8.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, $clLt8.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, $clLt8.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, $clLt8.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, $clLt8.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, $clLt8.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, $clLt8.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, $clLt8.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, $clLt8.pow2)(t2, $2dc4904548ca9557$var$_2n, P);
    if (!$2dc4904548ca9557$var$Fp.eql($2dc4904548ca9557$var$Fp.sqr(root), y)) throw new Error("Cannot find square root");
    return root;
}
const $2dc4904548ca9557$var$Fp = (0, $clLt8.Field)($2dc4904548ca9557$var$secp256k1P, undefined, undefined, {
    sqrt: $2dc4904548ca9557$var$sqrtMod
});
const $2dc4904548ca9557$export$529e6123e9353a90 = (0, $3DvJ1.createCurve)({
    a: BigInt(0),
    b: BigInt(7),
    Fp: $2dc4904548ca9557$var$Fp,
    n: $2dc4904548ca9557$var$secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: true,
    /**
     * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
     * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
     * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
     * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
     */ endo: {
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: (k)=>{
            const n = $2dc4904548ca9557$var$secp256k1N;
            const a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
            const b1 = -$2dc4904548ca9557$var$_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
            const a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
            const b2 = a1;
            const POW_2_128 = BigInt("0x100000000000000000000000000000000"); // (2n**128n).toString(16)
            const c1 = $2dc4904548ca9557$var$divNearest(b2 * k, n);
            const c2 = $2dc4904548ca9557$var$divNearest(-b1 * k, n);
            let k1 = (0, $clLt8.mod)(k - c1 * a1 - c2 * a2, n);
            let k2 = (0, $clLt8.mod)(-c1 * b1 - c2 * b2, n);
            const k1neg = k1 > POW_2_128;
            const k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error("splitScalar: Endomorphism failed, k=" + k);
            return {
                k1neg: k1neg,
                k1: k1,
                k2neg: k2neg,
                k2: k2
            };
        }
    }
}, (0, $jfkMZ.sha256));
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
const $2dc4904548ca9557$var$_0n = BigInt(0);
const $2dc4904548ca9557$var$fe = (x)=>typeof x === "bigint" && $2dc4904548ca9557$var$_0n < x && x < $2dc4904548ca9557$var$secp256k1P;
const $2dc4904548ca9557$var$ge = (x)=>typeof x === "bigint" && $2dc4904548ca9557$var$_0n < x && x < $2dc4904548ca9557$var$secp256k1N;
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const $2dc4904548ca9557$var$TAGGED_HASH_PREFIXES = {};
function $2dc4904548ca9557$var$taggedHash(tag, ...messages) {
    let tagP = $2dc4904548ca9557$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, $jfkMZ.sha256)(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
        tagP = (0, $87Zkx.concatBytes)(tagH, tagH);
        $2dc4904548ca9557$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $jfkMZ.sha256)((0, $87Zkx.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const $2dc4904548ca9557$var$pointToBytes = (point)=>point.toRawBytes(true).slice(1);
const $2dc4904548ca9557$var$numTo32b = (n)=>(0, $87Zkx.numberToBytesBE)(n, 32);
const $2dc4904548ca9557$var$modP = (x)=>(0, $clLt8.mod)(x, $2dc4904548ca9557$var$secp256k1P);
const $2dc4904548ca9557$var$modN = (x)=>(0, $clLt8.mod)(x, $2dc4904548ca9557$var$secp256k1N);
const $2dc4904548ca9557$var$Point = $2dc4904548ca9557$export$529e6123e9353a90.ProjectivePoint;
const $2dc4904548ca9557$var$GmulAdd = (Q, a, b)=>$2dc4904548ca9557$var$Point.BASE.multiplyAndAddUnsafe(Q, a, b);
// Calculate point, scalar and bytes
function $2dc4904548ca9557$var$schnorrGetExtPubKey(priv) {
    let d_ = $2dc4904548ca9557$export$529e6123e9353a90.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    let p = $2dc4904548ca9557$var$Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = p.hasEvenY() ? d_ : $2dc4904548ca9557$var$modN(-d_);
    return {
        scalar: scalar,
        bytes: $2dc4904548ca9557$var$pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $2dc4904548ca9557$var$lift_x(x) {
    if (!$2dc4904548ca9557$var$fe(x)) throw new Error("bad x: need 0 < x < p"); // Fail if x ≥ p.
    const xx = $2dc4904548ca9557$var$modP(x * x);
    const c = $2dc4904548ca9557$var$modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = $2dc4904548ca9557$var$sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % $2dc4904548ca9557$var$_2n !== $2dc4904548ca9557$var$_0n) y = $2dc4904548ca9557$var$modP(-y); // Return the unique point P such that x(P) = x and
    const p = new $2dc4904548ca9557$var$Point(x, y, $2dc4904548ca9557$var$_1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function $2dc4904548ca9557$var$challenge(...args) {
    return $2dc4904548ca9557$var$modN((0, $87Zkx.bytesToNumberBE)($2dc4904548ca9557$var$taggedHash("BIP0340/challenge", ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function $2dc4904548ca9557$var$schnorrGetPublicKey(privateKey) {
    return $2dc4904548ca9557$var$schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function $2dc4904548ca9557$var$schnorrSign(message, privateKey, auxRand = (0, $5358X.randomBytes)(32)) {
    const m = (0, $87Zkx.ensureBytes)("message", message);
    const { bytes: px, scalar: d } = $2dc4904548ca9557$var$schnorrGetExtPubKey(privateKey); // checks for isWithinCurveOrder
    const a = (0, $87Zkx.ensureBytes)("auxRand", auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = $2dc4904548ca9557$var$numTo32b(d ^ (0, $87Zkx.bytesToNumberBE)($2dc4904548ca9557$var$taggedHash("BIP0340/aux", a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = $2dc4904548ca9557$var$taggedHash("BIP0340/nonce", t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    const k_ = $2dc4904548ca9557$var$modN((0, $87Zkx.bytesToNumberBE)(rand)); // Let k' = int(rand) mod n
    if (k_ === $2dc4904548ca9557$var$_0n) throw new Error("sign failed: k is zero"); // Fail if k' = 0.
    const { bytes: rx, scalar: k } = $2dc4904548ca9557$var$schnorrGetExtPubKey(k_); // Let R = k'⋅G.
    const e = $2dc4904548ca9557$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set($2dc4904548ca9557$var$numTo32b($2dc4904548ca9557$var$modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$2dc4904548ca9557$var$schnorrVerify(sig, m, px)) throw new Error("sign: Invalid signature produced");
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $2dc4904548ca9557$var$schnorrVerify(signature, message, publicKey) {
    const sig = (0, $87Zkx.ensureBytes)("signature", signature, 64);
    const m = (0, $87Zkx.ensureBytes)("message", message);
    const pub = (0, $87Zkx.ensureBytes)("publicKey", publicKey, 32);
    try {
        const P = $2dc4904548ca9557$var$lift_x((0, $87Zkx.bytesToNumberBE)(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = (0, $87Zkx.bytesToNumberBE)(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!$2dc4904548ca9557$var$fe(r)) return false;
        const s = (0, $87Zkx.bytesToNumberBE)(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!$2dc4904548ca9557$var$ge(s)) return false;
        const e = $2dc4904548ca9557$var$challenge($2dc4904548ca9557$var$numTo32b(r), $2dc4904548ca9557$var$pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        const R = $2dc4904548ca9557$var$GmulAdd(P, s, $2dc4904548ca9557$var$modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
const $2dc4904548ca9557$export$1f2401df071be9f = /* @__PURE__ */ (()=>({
        getPublicKey: $2dc4904548ca9557$var$schnorrGetPublicKey,
        sign: $2dc4904548ca9557$var$schnorrSign,
        verify: $2dc4904548ca9557$var$schnorrVerify,
        utils: {
            randomPrivateKey: $2dc4904548ca9557$export$529e6123e9353a90.utils.randomPrivateKey,
            lift_x: $2dc4904548ca9557$var$lift_x,
            pointToBytes: $2dc4904548ca9557$var$pointToBytes,
            numberToBytesBE: $87Zkx.numberToBytesBE,
            bytesToNumberBE: $87Zkx.bytesToNumberBE,
            taggedHash: $2dc4904548ca9557$var$taggedHash,
            mod: $clLt8.mod
        }
    }))();
const $2dc4904548ca9557$var$isoMap = /* @__PURE__ */ (()=>(0, $liJ6s.isogenyMap)($2dc4904548ca9557$var$Fp, [
        // xNum
        [
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
            "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
            "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
        ],
        // xDen
        [
            "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
            "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ],
        // yNum
        [
            "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
            "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
            "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
            "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
        ],
        // yDen
        [
            "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
            "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
            "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const $2dc4904548ca9557$var$mapSWU = /* @__PURE__ */ (()=>(0, $1ZciS.mapToCurveSimpleSWU)($2dc4904548ca9557$var$Fp, {
        A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
        B: BigInt("1771"),
        Z: $2dc4904548ca9557$var$Fp.create(BigInt("-11"))
    }))();
const $2dc4904548ca9557$var$htf = /* @__PURE__ */ (()=>(0, $liJ6s.createHasher)($2dc4904548ca9557$export$529e6123e9353a90.ProjectivePoint, (scalars)=>{
        const { x: x, y: y } = $2dc4904548ca9557$var$mapSWU($2dc4904548ca9557$var$Fp.create(scalars[0]));
        return $2dc4904548ca9557$var$isoMap(x, y);
    }, {
        DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
        encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
        p: $2dc4904548ca9557$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: (0, $jfkMZ.sha256)
    }))();
const $2dc4904548ca9557$export$a95cc2b0cdb9c1e1 = /* @__PURE__ */ (()=>$2dc4904548ca9557$var$htf.hashToCurve)();
const $2dc4904548ca9557$export$124e820e7679cc3 = /* @__PURE__ */ (()=>$2dc4904548ca9557$var$htf.encodeToCurve)();

});
parcelRegister("jfkMZ", function(module, exports) {

$parcel$export(module.exports, "sha256", () => $e02f8b500f03490d$export$bced8d2aada2d1c9);

var $aHxry = parcelRequire("aHxry");

var $5358X = parcelRequire("5358X");
// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $e02f8b500f03490d$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state:
// first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19
// prettier-ignore
const $e02f8b500f03490d$var$SHA256_IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $e02f8b500f03490d$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $e02f8b500f03490d$var$SHA256 extends (0, $aHxry.HashMD) {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $e02f8b500f03490d$var$SHA256_IV[0] | 0;
        this.B = $e02f8b500f03490d$var$SHA256_IV[1] | 0;
        this.C = $e02f8b500f03490d$var$SHA256_IV[2] | 0;
        this.D = $e02f8b500f03490d$var$SHA256_IV[3] | 0;
        this.E = $e02f8b500f03490d$var$SHA256_IV[4] | 0;
        this.F = $e02f8b500f03490d$var$SHA256_IV[5] | 0;
        this.G = $e02f8b500f03490d$var$SHA256_IV[6] | 0;
        this.H = $e02f8b500f03490d$var$SHA256_IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$e02f8b500f03490d$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $e02f8b500f03490d$var$SHA256_W[i - 15];
            const W2 = $e02f8b500f03490d$var$SHA256_W[i - 2];
            const s0 = (0, $5358X.rotr)(W15, 7) ^ (0, $5358X.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $5358X.rotr)(W2, 17) ^ (0, $5358X.rotr)(W2, 19) ^ W2 >>> 10;
            $e02f8b500f03490d$var$SHA256_W[i] = s1 + $e02f8b500f03490d$var$SHA256_W[i - 7] + s0 + $e02f8b500f03490d$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $5358X.rotr)(E, 6) ^ (0, $5358X.rotr)(E, 11) ^ (0, $5358X.rotr)(E, 25);
            const T1 = H + sigma1 + (0, $aHxry.Chi)(E, F, G) + $e02f8b500f03490d$var$SHA256_K[i] + $e02f8b500f03490d$var$SHA256_W[i] | 0;
            const sigma0 = (0, $5358X.rotr)(A, 2) ^ (0, $5358X.rotr)(A, 13) ^ (0, $5358X.rotr)(A, 22);
            const T2 = sigma0 + (0, $aHxry.Maj)(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $e02f8b500f03490d$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $e02f8b500f03490d$var$SHA224 extends $e02f8b500f03490d$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
const $e02f8b500f03490d$export$bced8d2aada2d1c9 = /* @__PURE__ */ (0, $5358X.wrapConstructor)(()=>new $e02f8b500f03490d$var$SHA256());
const $e02f8b500f03490d$export$97b70509d4e397ea = /* @__PURE__ */ (0, $5358X.wrapConstructor)(()=>new $e02f8b500f03490d$var$SHA224());

});
parcelRegister("aHxry", function(module, exports) {

$parcel$export(module.exports, "Chi", () => $7ca7dcb3fa94681b$export$d0d97f016526eaf0);
$parcel$export(module.exports, "Maj", () => $7ca7dcb3fa94681b$export$8b1d810b1bd30adf);
$parcel$export(module.exports, "HashMD", () => $7ca7dcb3fa94681b$export$f9f830659f932cb2);

var $jxb68 = parcelRequire("jxb68");

var $5358X = parcelRequire("5358X");
// Polyfill for Safari 14
function $7ca7dcb3fa94681b$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
const $7ca7dcb3fa94681b$export$d0d97f016526eaf0 = (a, b, c)=>a & b ^ ~a & c;
const $7ca7dcb3fa94681b$export$8b1d810b1bd30adf = (a, b, c)=>a & b ^ a & c ^ b & c;
class $7ca7dcb3fa94681b$export$f9f830659f932cb2 extends (0, $5358X.Hash) {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $5358X.createView)(this.buffer);
    }
    update(data) {
        (0, $jxb68.exists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $5358X.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $5358X.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $jxb68.exists)(this);
        (0, $jxb68.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $7ca7dcb3fa94681b$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $5358X.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}

});


parcelRegister("clLt8", function(module, exports) {

$parcel$export(module.exports, "mod", () => $8fdc44851a9bee5b$export$842a2cf37af977e1);
$parcel$export(module.exports, "pow2", () => $8fdc44851a9bee5b$export$fa569bd808b67eef);
$parcel$export(module.exports, "invert", () => $8fdc44851a9bee5b$export$6897c284b6f9f4dc);
$parcel$export(module.exports, "validateField", () => $8fdc44851a9bee5b$export$bd454f0cef11418d);
$parcel$export(module.exports, "nLength", () => $8fdc44851a9bee5b$export$c79df43ecd7e66c2);
$parcel$export(module.exports, "Field", () => $8fdc44851a9bee5b$export$a455218a85c89869);
$parcel$export(module.exports, "getMinHashLength", () => $8fdc44851a9bee5b$export$d058763b563056af);
$parcel$export(module.exports, "mapHashToField", () => $8fdc44851a9bee5b$export$20cb21dbfa61dac3);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Utilities for modular arithmetics and finite fields

var $87Zkx = parcelRequire("87Zkx");
// prettier-ignore
const $8fdc44851a9bee5b$var$_0n = BigInt(0), $8fdc44851a9bee5b$var$_1n = BigInt(1), $8fdc44851a9bee5b$var$_2n = BigInt(2), $8fdc44851a9bee5b$var$_3n = BigInt(3);
// prettier-ignore
const $8fdc44851a9bee5b$var$_4n = BigInt(4), $8fdc44851a9bee5b$var$_5n = BigInt(5), $8fdc44851a9bee5b$var$_8n = BigInt(8);
// prettier-ignore
const $8fdc44851a9bee5b$var$_9n = BigInt(9), $8fdc44851a9bee5b$var$_16n = BigInt(16);
function $8fdc44851a9bee5b$export$842a2cf37af977e1(a, b) {
    const result = a % b;
    return result >= $8fdc44851a9bee5b$var$_0n ? result : b + result;
}
function $8fdc44851a9bee5b$export$9c297f60e22e3389(num, power, modulo) {
    if (modulo <= $8fdc44851a9bee5b$var$_0n || power < $8fdc44851a9bee5b$var$_0n) throw new Error("Expected power/modulo > 0");
    if (modulo === $8fdc44851a9bee5b$var$_1n) return $8fdc44851a9bee5b$var$_0n;
    let res = $8fdc44851a9bee5b$var$_1n;
    while(power > $8fdc44851a9bee5b$var$_0n){
        if (power & $8fdc44851a9bee5b$var$_1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= $8fdc44851a9bee5b$var$_1n;
    }
    return res;
}
function $8fdc44851a9bee5b$export$fa569bd808b67eef(x, power, modulo) {
    let res = x;
    while(power-- > $8fdc44851a9bee5b$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
function $8fdc44851a9bee5b$export$6897c284b6f9f4dc(number, modulo) {
    if (number === $8fdc44851a9bee5b$var$_0n || modulo <= $8fdc44851a9bee5b$var$_0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $8fdc44851a9bee5b$export$842a2cf37af977e1(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $8fdc44851a9bee5b$var$_0n, y = $8fdc44851a9bee5b$var$_1n, u = $8fdc44851a9bee5b$var$_1n, v = $8fdc44851a9bee5b$var$_0n;
    while(a !== $8fdc44851a9bee5b$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $8fdc44851a9bee5b$var$_1n) throw new Error("invert: does not exist");
    return $8fdc44851a9bee5b$export$842a2cf37af977e1(x, modulo);
}
function $8fdc44851a9bee5b$export$69f29ab1f3e9a234(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - $8fdc44851a9bee5b$var$_1n) / $8fdc44851a9bee5b$var$_2n;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - $8fdc44851a9bee5b$var$_1n, S = 0; Q % $8fdc44851a9bee5b$var$_2n === $8fdc44851a9bee5b$var$_0n; Q /= $8fdc44851a9bee5b$var$_2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = $8fdc44851a9bee5b$var$_2n; Z < P && $8fdc44851a9bee5b$export$9c297f60e22e3389(Z, legendreC, P) !== P - $8fdc44851a9bee5b$var$_1n; Z++);
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + $8fdc44851a9bee5b$var$_1n) / $8fdc44851a9bee5b$var$_4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + $8fdc44851a9bee5b$var$_1n) / $8fdc44851a9bee5b$var$_2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error("Cannot find square root");
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, $8fdc44851a9bee5b$var$_1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
function $8fdc44851a9bee5b$export$33bda048c6b8ea7d(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % $8fdc44851a9bee5b$var$_4n === $8fdc44851a9bee5b$var$_3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + $8fdc44851a9bee5b$var$_1n) / $8fdc44851a9bee5b$var$_4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % $8fdc44851a9bee5b$var$_8n === $8fdc44851a9bee5b$var$_5n) {
        const c1 = (P - $8fdc44851a9bee5b$var$_5n) / $8fdc44851a9bee5b$var$_8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, $8fdc44851a9bee5b$var$_2n);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, $8fdc44851a9bee5b$var$_2n), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    $8fdc44851a9bee5b$var$_9n;
    // Other cases: Tonelli-Shanks algorithm
    return $8fdc44851a9bee5b$export$69f29ab1f3e9a234(P);
}
const $8fdc44851a9bee5b$export$7806f13ad5078b2f = (num, modulo)=>($8fdc44851a9bee5b$export$842a2cf37af977e1(num, modulo) & $8fdc44851a9bee5b$var$_1n) === $8fdc44851a9bee5b$var$_1n;
// prettier-ignore
const $8fdc44851a9bee5b$var$FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $8fdc44851a9bee5b$export$bd454f0cef11418d(field) {
    const initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    const opts = $8fdc44851a9bee5b$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = "function";
        return map;
    }, initial);
    return (0, $87Zkx.validateObject)(field, opts);
}
function $8fdc44851a9bee5b$export$5d8ce3717733a987(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < $8fdc44851a9bee5b$var$_0n) throw new Error("Expected power > 0");
    if (power === $8fdc44851a9bee5b$var$_0n) return f.ONE;
    if (power === $8fdc44851a9bee5b$var$_1n) return num;
    let p = f.ONE;
    let d = num;
    while(power > $8fdc44851a9bee5b$var$_0n){
        if (power & $8fdc44851a9bee5b$var$_1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= $8fdc44851a9bee5b$var$_1n;
    }
    return p;
}
function $8fdc44851a9bee5b$export$a492e3387142c0e9(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
function $8fdc44851a9bee5b$export$e74c665040343df6(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === "bigint" ? $8fdc44851a9bee5b$export$6897c284b6f9f4dc(rhs, f.ORDER) : f.inv(rhs));
}
function $8fdc44851a9bee5b$export$5e2b6e87f2891ea7(f) {
    const legendreConst = (f.ORDER - $8fdc44851a9bee5b$var$_1n) / $8fdc44851a9bee5b$var$_2n; // Integer arithmetic
    return (x)=>{
        const p = f.pow(x, legendreConst);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
function $8fdc44851a9bee5b$export$c79df43ecd7e66c2(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
function $8fdc44851a9bee5b$export$a455218a85c89869(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= $8fdc44851a9bee5b$var$_0n) throw new Error(`Expected Field ORDER > 0, got ${ORDER}`);
    const { nBitLength: BITS, nByteLength: BYTES } = $8fdc44851a9bee5b$export$c79df43ecd7e66c2(ORDER, bitLen);
    if (BYTES > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
    const sqrtP = $8fdc44851a9bee5b$export$33bda048c6b8ea7d(ORDER);
    const f = Object.freeze({
        ORDER: ORDER,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $87Zkx.bitMask)(BITS),
        ZERO: $8fdc44851a9bee5b$var$_0n,
        ONE: $8fdc44851a9bee5b$var$_1n,
        create: (num)=>$8fdc44851a9bee5b$export$842a2cf37af977e1(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== "bigint") throw new Error(`Invalid field element: expected bigint, got ${typeof num}`);
            return $8fdc44851a9bee5b$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $8fdc44851a9bee5b$var$_0n,
        isOdd: (num)=>(num & $8fdc44851a9bee5b$var$_1n) === $8fdc44851a9bee5b$var$_1n,
        neg: (num)=>$8fdc44851a9bee5b$export$842a2cf37af977e1(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$8fdc44851a9bee5b$export$842a2cf37af977e1(num * num, ORDER),
        add: (lhs, rhs)=>$8fdc44851a9bee5b$export$842a2cf37af977e1(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$8fdc44851a9bee5b$export$842a2cf37af977e1(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$8fdc44851a9bee5b$export$842a2cf37af977e1(lhs * rhs, ORDER),
        pow: (num, power)=>$8fdc44851a9bee5b$export$5d8ce3717733a987(f, num, power),
        div: (lhs, rhs)=>$8fdc44851a9bee5b$export$842a2cf37af977e1(lhs * $8fdc44851a9bee5b$export$6897c284b6f9f4dc(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$8fdc44851a9bee5b$export$6897c284b6f9f4dc(num, ORDER),
        sqrt: redef.sqrt || ((n)=>sqrtP(f, n)),
        invertBatch: (lst)=>$8fdc44851a9bee5b$export$a492e3387142c0e9(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE ? (0, $87Zkx.numberToBytesLE)(num, BYTES) : (0, $87Zkx.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error(`Fp.fromBytes: expected ${BYTES}, got ${bytes.length}`);
            return isLE ? (0, $87Zkx.bytesToNumberLE)(bytes) : (0, $87Zkx.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
function $8fdc44851a9bee5b$export$7acc54692c525d2a(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
function $8fdc44851a9bee5b$export$1d7b691df0888e02(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
function $8fdc44851a9bee5b$export$d3b0e8260d5dbad4(hash, groupOrder, isLE = false) {
    hash = (0, $87Zkx.ensureBytes)("privateHash", hash);
    const hashLen = hash.length;
    const minLen = $8fdc44851a9bee5b$export$c79df43ecd7e66c2(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error(`hashToPrivateScalar: expected ${minLen}-1024 bytes of input, got ${hashLen}`);
    const num = isLE ? (0, $87Zkx.bytesToNumberLE)(hash) : (0, $87Zkx.bytesToNumberBE)(hash);
    return $8fdc44851a9bee5b$export$842a2cf37af977e1(num, groupOrder - $8fdc44851a9bee5b$var$_1n) + $8fdc44851a9bee5b$var$_1n;
}
function $8fdc44851a9bee5b$export$9cf21a9392b0fcfc(fieldOrder) {
    if (typeof fieldOrder !== "bigint") throw new Error("field order must be bigint");
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
function $8fdc44851a9bee5b$export$d058763b563056af(fieldOrder) {
    const length = $8fdc44851a9bee5b$export$9cf21a9392b0fcfc(fieldOrder);
    return length + Math.ceil(length / 2);
}
function $8fdc44851a9bee5b$export$20cb21dbfa61dac3(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = $8fdc44851a9bee5b$export$9cf21a9392b0fcfc(fieldOrder);
    const minLen = $8fdc44851a9bee5b$export$d058763b563056af(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error(`expected ${minLen}-1024 bytes of input, got ${len}`);
    const num = isLE ? (0, $87Zkx.bytesToNumberBE)(key) : (0, $87Zkx.bytesToNumberLE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = $8fdc44851a9bee5b$export$842a2cf37af977e1(num, fieldOrder - $8fdc44851a9bee5b$var$_1n) + $8fdc44851a9bee5b$var$_1n;
    return isLE ? (0, $87Zkx.numberToBytesLE)(reduced, fieldLen) : (0, $87Zkx.numberToBytesBE)(reduced, fieldLen);
}

});
parcelRegister("87Zkx", function(module, exports) {

$parcel$export(module.exports, "isBytes", () => $5eae8d12f242bd8b$export$c6fabfbfd097fc30);
$parcel$export(module.exports, "abytes", () => $5eae8d12f242bd8b$export$e8a750b9efad93f5);
$parcel$export(module.exports, "bytesToHex", () => $5eae8d12f242bd8b$export$58b867e287a802c8);
$parcel$export(module.exports, "numberToHexUnpadded", () => $5eae8d12f242bd8b$export$4ed2545b622827c1);
$parcel$export(module.exports, "hexToNumber", () => $5eae8d12f242bd8b$export$d57f2bacc26b4249);
$parcel$export(module.exports, "hexToBytes", () => $5eae8d12f242bd8b$export$31c96b9df38bc8d4);
$parcel$export(module.exports, "bytesToNumberBE", () => $5eae8d12f242bd8b$export$d609354794974f8);
$parcel$export(module.exports, "bytesToNumberLE", () => $5eae8d12f242bd8b$export$d67b1d03392107e7);
$parcel$export(module.exports, "numberToBytesBE", () => $5eae8d12f242bd8b$export$1459dafd057611cb);
$parcel$export(module.exports, "numberToBytesLE", () => $5eae8d12f242bd8b$export$ba2172e58d139f6d);
$parcel$export(module.exports, "numberToVarBytesBE", () => $5eae8d12f242bd8b$export$80ee8c1914de6dde);
$parcel$export(module.exports, "ensureBytes", () => $5eae8d12f242bd8b$export$3cb5d50a3a30e837);
$parcel$export(module.exports, "concatBytes", () => $5eae8d12f242bd8b$export$287dd7971339c972);
$parcel$export(module.exports, "equalBytes", () => $5eae8d12f242bd8b$export$2aa59cef064b0333);
$parcel$export(module.exports, "utf8ToBytes", () => $5eae8d12f242bd8b$export$3df70a15530b5e81);
$parcel$export(module.exports, "bitLen", () => $5eae8d12f242bd8b$export$e93ef600c41761a9);
$parcel$export(module.exports, "bitGet", () => $5eae8d12f242bd8b$export$9577d112d1fd46ad);
$parcel$export(module.exports, "bitSet", () => $5eae8d12f242bd8b$export$967bb2b9787441cb);
$parcel$export(module.exports, "bitMask", () => $5eae8d12f242bd8b$export$803efa2fa1c7279);
$parcel$export(module.exports, "createHmacDrbg", () => $5eae8d12f242bd8b$export$d459d139192e4fba);
$parcel$export(module.exports, "validateObject", () => $5eae8d12f242bd8b$export$381bae2d0f08004f);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const $5eae8d12f242bd8b$var$_0n = BigInt(0);
const $5eae8d12f242bd8b$var$_1n = BigInt(1);
const $5eae8d12f242bd8b$var$_2n = BigInt(2);
function $5eae8d12f242bd8b$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
function $5eae8d12f242bd8b$export$e8a750b9efad93f5(item) {
    if (!$5eae8d12f242bd8b$export$c6fabfbfd097fc30(item)) throw new Error("Uint8Array expected");
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const $5eae8d12f242bd8b$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $5eae8d12f242bd8b$export$58b867e287a802c8(bytes) {
    $5eae8d12f242bd8b$export$e8a750b9efad93f5(bytes);
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $5eae8d12f242bd8b$var$hexes[bytes[i]];
    return hex;
}
function $5eae8d12f242bd8b$export$4ed2545b622827c1(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
function $5eae8d12f242bd8b$export$d57f2bacc26b4249(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    // Big Endian
    return BigInt(hex === "" ? "0" : `0x${hex}`);
}
// We use optimized technique to convert hex string to byte array
const $5eae8d12f242bd8b$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $5eae8d12f242bd8b$var$asciiToBase16(char) {
    if (char >= $5eae8d12f242bd8b$var$asciis._0 && char <= $5eae8d12f242bd8b$var$asciis._9) return char - $5eae8d12f242bd8b$var$asciis._0;
    if (char >= $5eae8d12f242bd8b$var$asciis._A && char <= $5eae8d12f242bd8b$var$asciis._F) return char - ($5eae8d12f242bd8b$var$asciis._A - 10);
    if (char >= $5eae8d12f242bd8b$var$asciis._a && char <= $5eae8d12f242bd8b$var$asciis._f) return char - ($5eae8d12f242bd8b$var$asciis._a - 10);
    return;
}
function $5eae8d12f242bd8b$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $5eae8d12f242bd8b$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $5eae8d12f242bd8b$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
function $5eae8d12f242bd8b$export$d609354794974f8(bytes) {
    return $5eae8d12f242bd8b$export$d57f2bacc26b4249($5eae8d12f242bd8b$export$58b867e287a802c8(bytes));
}
function $5eae8d12f242bd8b$export$d67b1d03392107e7(bytes) {
    $5eae8d12f242bd8b$export$e8a750b9efad93f5(bytes);
    return $5eae8d12f242bd8b$export$d57f2bacc26b4249($5eae8d12f242bd8b$export$58b867e287a802c8(Uint8Array.from(bytes).reverse()));
}
function $5eae8d12f242bd8b$export$1459dafd057611cb(n, len) {
    return $5eae8d12f242bd8b$export$31c96b9df38bc8d4(n.toString(16).padStart(len * 2, "0"));
}
function $5eae8d12f242bd8b$export$ba2172e58d139f6d(n, len) {
    return $5eae8d12f242bd8b$export$1459dafd057611cb(n, len).reverse();
}
function $5eae8d12f242bd8b$export$80ee8c1914de6dde(n) {
    return $5eae8d12f242bd8b$export$31c96b9df38bc8d4($5eae8d12f242bd8b$export$4ed2545b622827c1(n));
}
function $5eae8d12f242bd8b$export$3cb5d50a3a30e837(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = $5eae8d12f242bd8b$export$31c96b9df38bc8d4(hex);
    } catch (e) {
        throw new Error(`${title} must be valid hex string, got "${hex}". Cause: ${e}`);
    }
    else if ($5eae8d12f242bd8b$export$c6fabfbfd097fc30(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(`${title} must be hex string or Uint8Array`);
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(`${title} expected ${expectedLength} bytes, got ${len}`);
    return res;
}
function $5eae8d12f242bd8b$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        $5eae8d12f242bd8b$export$e8a750b9efad93f5(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
function $5eae8d12f242bd8b$export$2aa59cef064b0333(a, b) {
    if (a.length !== b.length) return false;
    let diff = 0;
    for(let i = 0; i < a.length; i++)diff |= a[i] ^ b[i];
    return diff === 0;
}
function $5eae8d12f242bd8b$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $5eae8d12f242bd8b$export$e93ef600c41761a9(n) {
    let len;
    for(len = 0; n > $5eae8d12f242bd8b$var$_0n; n >>= $5eae8d12f242bd8b$var$_1n, len += 1);
    return len;
}
function $5eae8d12f242bd8b$export$9577d112d1fd46ad(n, pos) {
    return n >> BigInt(pos) & $5eae8d12f242bd8b$var$_1n;
}
function $5eae8d12f242bd8b$export$967bb2b9787441cb(n, pos, value) {
    return n | (value ? $5eae8d12f242bd8b$var$_1n : $5eae8d12f242bd8b$var$_0n) << BigInt(pos);
}
const $5eae8d12f242bd8b$export$803efa2fa1c7279 = (n)=>($5eae8d12f242bd8b$var$_2n << BigInt(n - 1)) - $5eae8d12f242bd8b$var$_1n;
// DRBG
const $5eae8d12f242bd8b$var$u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const $5eae8d12f242bd8b$var$u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
function $5eae8d12f242bd8b$export$d459d139192e4fba(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = $5eae8d12f242bd8b$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = $5eae8d12f242bd8b$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = $5eae8d12f242bd8b$var$u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($5eae8d12f242bd8b$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($5eae8d12f242bd8b$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $5eae8d12f242bd8b$export$287dd7971339c972(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
// Validating curves and fields
const $5eae8d12f242bd8b$var$validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    stringOrUint8Array: (val)=>typeof val === "string" || $5eae8d12f242bd8b$export$c6fabfbfd097fc30(val),
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
function $5eae8d12f242bd8b$export$381bae2d0f08004f(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $5eae8d12f242bd8b$var$validatorFns[type];
        if (typeof checkVal !== "function") throw new Error(`Invalid validator "${type}", expected function`);
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error(`Invalid param ${String(fieldName)}=${val} (${typeof val}), expected ${type}`);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
} // validate type tests
 // const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
 // const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
 // // Should fail type-check
 // const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
 // const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
 // const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
 // const z4 = validateObject(o, { a: 'boolean', z: 'bug' });

});


parcelRegister("1ZciS", function(module, exports) {

$parcel$export(module.exports, "weierstrass", () => $1725082ac41e164d$export$350b8ea6f1c27fae);
$parcel$export(module.exports, "mapToCurveSimpleSWU", () => $1725082ac41e164d$export$cc7fea9756a17416);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Short Weierstrass curve. The formula is: y² = x³ + ax + b

var $clLt8 = parcelRequire("clLt8");

var $87Zkx = parcelRequire("87Zkx");

var $9SYS8 = parcelRequire("9SYS8");
function $1725082ac41e164d$var$validatePointOpts(curve) {
    const opts = (0, $9SYS8.validateBasic)(curve);
    $87Zkx.validateObject(opts, {
        a: "field",
        b: "field"
    }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
    });
    const { endo: endo, Fp: Fp, a: a } = opts;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
        if (typeof endo !== "object" || typeof endo.beta !== "bigint" || typeof endo.splitScalar !== "function") throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
    }
    return Object.freeze({
        ...opts
    });
}
// ASN.1 DER encoding utilities
const { bytesToNumberBE: $1725082ac41e164d$var$b2n, hexToBytes: $1725082ac41e164d$var$h2b } = $87Zkx;
const $1725082ac41e164d$export$56ac33195d7076db = {
    // asn.1 DER encoding utils
    Err: class DERErr extends Error {
        constructor(m = ""){
            super(m);
        }
    },
    _parseInt (data) {
        const { Err: E } = $1725082ac41e164d$export$56ac33195d7076db;
        if (data.length < 2 || data[0] !== 0x02) throw new E("Invalid signature integer tag");
        const len = data[1];
        const res = data.subarray(2, len + 2);
        if (!len || res.length !== len) throw new E("Invalid signature integer: wrong length");
        // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
        // since we always use positive integers here. It must always be empty:
        // - add zero byte if exists
        // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
        if (res[0] & 128) throw new E("Invalid signature integer: negative");
        if (res[0] === 0x00 && !(res[1] & 128)) throw new E("Invalid signature integer: unnecessary leading zero");
        return {
            d: $1725082ac41e164d$var$b2n(res),
            l: data.subarray(len + 2)
        }; // d is data, l is left
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E } = $1725082ac41e164d$export$56ac33195d7076db;
        const data = typeof hex === "string" ? $1725082ac41e164d$var$h2b(hex) : hex;
        $87Zkx.abytes(data);
        let l = data.length;
        if (l < 2 || data[0] != 0x30) throw new E("Invalid signature tag");
        if (data[1] !== l - 2) throw new E("Invalid signature: incorrect length");
        const { d: r, l: sBytes } = $1725082ac41e164d$export$56ac33195d7076db._parseInt(data.subarray(2));
        const { d: s, l: rBytesLeft } = $1725082ac41e164d$export$56ac33195d7076db._parseInt(sBytes);
        if (rBytesLeft.length) throw new E("Invalid signature: left bytes after parsing");
        return {
            r: r,
            s: s
        };
    },
    hexFromSig (sig) {
        // Add leading zero if first byte has negative bit enabled. More details in '_parseInt'
        const slice = (s)=>Number.parseInt(s[0], 16) & 8 ? "00" + s : s;
        const h = (num)=>{
            const hex = num.toString(16);
            return hex.length & 1 ? `0${hex}` : hex;
        };
        const s = slice(h(sig.s));
        const r = slice(h(sig.r));
        const shl = s.length / 2;
        const rhl = r.length / 2;
        const sl = h(shl);
        const rl = h(rhl);
        return `30${h(rhl + shl + 4)}02${rl}${r}02${sl}${s}`;
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $1725082ac41e164d$var$_0n = BigInt(0), $1725082ac41e164d$var$_1n = BigInt(1), $1725082ac41e164d$var$_2n = BigInt(2), $1725082ac41e164d$var$_3n = BigInt(3), $1725082ac41e164d$var$_4n = BigInt(4);
function $1725082ac41e164d$export$fa783af82e4fe0fc(opts) {
    const CURVE = $1725082ac41e164d$var$validatePointOpts(opts);
    const { Fp: Fp } = CURVE; // All curves has same field / group length as for now, but they can differ
    const toBytes = CURVE.toBytes || ((_c, point, _isCompressed)=>{
        const a = point.toAffine();
        return $87Zkx.concatBytes(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes)=>{
        // const head = bytes[0];
        const tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x: x,
            y: y
        };
    });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */ function weierstrassEquation(x) {
        const { a: a, b: b } = CURVE;
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error("bad generator point: equation left != right");
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return typeof num === "bigint" && $1725082ac41e164d$var$_0n < num && num < CURVE.n;
    }
    function assertGE(num) {
        if (!isWithinCurveOrder(num)) throw new Error("Expected valid bigint: 0 < bigint < curve.n");
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength: nByteLength, wrapPrivateKey: wrapPrivateKey, n: n } = CURVE;
        if (lengths && typeof key !== "bigint") {
            if ($87Zkx.isBytes(key)) key = $87Zkx.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== "string" || !lengths.includes(key.length)) throw new Error("Invalid key");
            key = key.padStart(nByteLength * 2, "0");
        }
        let num;
        try {
            num = typeof key === "bigint" ? key : $87Zkx.bytesToNumberBE((0, $87Zkx.ensureBytes)("private key", key, nByteLength));
        } catch (error) {
            throw new Error(`private key must be ${nByteLength} bytes, hex or bigint, not ${typeof key}`);
        }
        if (wrapPrivateKey) num = $clLt8.mod(num, n); // disabled by default, enabled for BLS
        assertGE(num); // num in range [1..N-1]
        return num;
    }
    const pointPrecomputes = new Map();
    function assertPrjPoint(other) {
        if (!(other instanceof Point)) throw new Error("ProjectivePoint expected");
    }
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        constructor(px, py, pz){
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px)) throw new Error("x required");
            if (py == null || !Fp.isValid(py)) throw new Error("y required");
            if (pz == null || !Fp.isValid(pz)) throw new Error("z required");
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x: x, y: y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error("invalid affine point");
            if (p instanceof Point) throw new Error("projective point not allowed");
            const is0 = (i)=>Fp.eql(i, Fp.ZERO);
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.pz));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ static fromHex(hex) {
            const P = Point.fromAffine(fromBytes((0, $87Zkx.ensureBytes)("pointHex", hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            if (this.is0()) {
                // (0, 1, 0) aka ZERO is invalid in most contexts.
                // In BLS, ZERO can be serialized, so we allow it.
                // (0, 0, 0) is wrong representation of ZERO and is always invalid.
                if (CURVE.allowInfinityPoint && !Fp.is0(this.py)) return;
                throw new Error("bad point: ZERO");
            }
            // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
            const { x: x, y: y } = this.toAffine();
            // Check if x, y are valid field elements
            if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error("bad point: x or y not FE");
            const left = Fp.sqr(y); // y²
            const right = weierstrassEquation(x); // x³ + ax + b
            if (!Fp.eql(left, right)) throw new Error("bad point: equation left != right");
            if (!this.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
        }
        hasEvenY() {
            const { y: y } = this.toAffine();
            if (Fp.isOdd) return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */ equals(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ negate() {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a: a, b: b } = CURVE;
            const b3 = Fp.mul(b, $1725082ac41e164d$var$_3n);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, $1725082ac41e164d$var$_3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, (comp)=>{
                const toInv = Fp.invertBatch(comp.map((p)=>p.pz));
                return comp.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
            });
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(n) {
            const I = Point.ZERO;
            if (n === $1725082ac41e164d$var$_0n) return I;
            assertGE(n); // Will throw on 0
            if (n === $1725082ac41e164d$var$_1n) return this;
            const { endo: endo } = CURVE;
            if (!endo) return wnaf.unsafeLadder(this, n);
            // Apply endomorphism
            let { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
            let k1p = I;
            let k2p = I;
            let d = this;
            while(k1 > $1725082ac41e164d$var$_0n || k2 > $1725082ac41e164d$var$_0n){
                if (k1 & $1725082ac41e164d$var$_1n) k1p = k1p.add(d);
                if (k2 & $1725082ac41e164d$var$_1n) k2p = k2p.add(d);
                d = d.double();
                k1 >>= $1725082ac41e164d$var$_1n;
                k2 >>= $1725082ac41e164d$var$_1n;
            }
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            assertGE(scalar);
            let n = scalar;
            let point, fake; // Fake point is used to const-time mult
            const { endo: endo } = CURVE;
            if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            } else {
                const { p: p, f: f } = this.wNAF(n);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([
                point,
                fake
            ])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ multiplyAndAddUnsafe(Q, a, b) {
            const G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            const mul = (P, a // Select faster multiply() method
            )=>a === $1725082ac41e164d$var$_0n || a === $1725082ac41e164d$var$_1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            const { px: x, py: y, pz: z } = this;
            const is0 = this.is0();
            // If invZ was 0, we return zero point. However we still want to execute
            // all operations, so we replace invZ with a random number, 1.
            if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
            const ax = Fp.mul(x, iz);
            const ay = Fp.mul(y, iz);
            const zz = Fp.mul(z, iz);
            if (is0) return {
                x: Fp.ZERO,
                y: Fp.ZERO
            };
            if (!Fp.eql(zz, Fp.ONE)) throw new Error("invZ was invalid");
            return {
                x: ax,
                y: ay
            };
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree: isTorsionFree } = CURVE;
            if (cofactor === $1725082ac41e164d$var$_1n) return true; // No subgroups, always torsion-free
            if (isTorsionFree) return isTorsionFree(Point, this);
            throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor: clearCofactor } = CURVE;
            if (cofactor === $1725082ac41e164d$var$_1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            return $87Zkx.bytesToHex(this.toRawBytes(isCompressed));
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    const _bits = CURVE.nBitLength;
    const wnaf = (0, $9SYS8.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE: CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder
    };
}
function $1725082ac41e164d$var$validateOpts(curve) {
    const opts = (0, $9SYS8.validateBasic)(curve);
    $87Zkx.validateObject(opts, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
    }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
    });
    return Object.freeze({
        lowS: true,
        ...opts
    });
}
function $1725082ac41e164d$export$350b8ea6f1c27fae(curveDef) {
    const CURVE = $1725082ac41e164d$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    const uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function isValidFieldElement(num) {
        return $1725082ac41e164d$var$_0n < num && num < Fp.ORDER; // 0 is banned since it's not invertible FE
    }
    function modN(a) {
        return $clLt8.mod(a, CURVE_ORDER);
    }
    function invN(a) {
        return $clLt8.invert(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point, normPrivateKeyToScalar: normPrivateKeyToScalar, weierstrassEquation: weierstrassEquation, isWithinCurveOrder: isWithinCurveOrder } = $1725082ac41e164d$export$fa783af82e4fe0fc({
        ...CURVE,
        toBytes (_c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp.toBytes(a.x);
            const cat = $87Zkx.concatBytes;
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes (bytes) {
            const len = bytes.length;
            const head = bytes[0];
            const tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                const x = $87Zkx.bytesToNumberBE(tail);
                if (!isValidFieldElement(x)) throw new Error("Point is not on curve");
                const y2 = weierstrassEquation(x); // y² = x³ + ax + b
                let y;
                try {
                    y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                } catch (sqrtError) {
                    const suffix = sqrtError instanceof Error ? ": " + sqrtError.message : "";
                    throw new Error("Point is not on curve" + suffix);
                }
                const isYOdd = (y & $1725082ac41e164d$var$_1n) === $1725082ac41e164d$var$_1n;
                // ECDSA
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x: x,
                    y: y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x: x,
                    y: y
                };
            } else throw new Error(`Point of length ${len} was invalid. Expected ${compressedLen} compressed bytes or ${uncompressedLen} uncompressed bytes`);
        }
    });
    const numToNByteStr = (num)=>$87Zkx.bytesToHex($87Zkx.numberToBytesBE(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> $1725082ac41e164d$var$_1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    const slcNum = (b, from, to)=>$87Zkx.bytesToNumberBE(b.slice(from, to));
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ class Signature {
        constructor(r, s, recovery){
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = CURVE.nByteLength;
            hex = (0, $87Zkx.ensureBytes)("compactSignature", hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r: r, s: s } = $1725082ac41e164d$export$56ac33195d7076db.toSig((0, $87Zkx.ensureBytes)("DER", hex));
            return new Signature(r, s);
        }
        assertValidity() {
            // can use assertGE here
            if (!isWithinCurveOrder(this.r)) throw new Error("r must be 0 < r < CURVE.n");
            if (!isWithinCurveOrder(this.s)) throw new Error("s must be 0 < s < CURVE.n");
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r: r, s: s, recovery: rec } = this;
            const h = bits2int_modN((0, $87Zkx.ensureBytes)("msgHash", msgHash)); // Truncate hash
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error("recovery id invalid");
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER) throw new Error("recovery id 2 or 3 invalid");
            const prefix = (rec & 1) === 0 ? "02" : "03";
            const R = Point.fromHex(prefix + numToNByteStr(radj));
            const ir = invN(radj); // r^-1
            const u1 = modN(-h * ir); // -hr^-1
            const u2 = modN(s * ir); // sr^-1
            const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q) throw new Error("point at infinify"); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return $87Zkx.hexToBytes(this.toDERHex());
        }
        toDERHex() {
            return $1725082ac41e164d$export$56ac33195d7076db.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return $87Zkx.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        }
    }
    const utils = {
        isValidPrivateKey (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */ randomPrivateKey: ()=>{
            const length = $clLt8.getMinHashLength(CURVE.n);
            return $clLt8.mapHashToField(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey, isCompressed = true) {
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        const arr = $87Zkx.isBytes(item);
        const str = typeof item === "string";
        const len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA)) throw new Error("first arg must be private key");
        if (!isProbPub(publicB)) throw new Error("second arg must be public key");
        const b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = CURVE.bits2int || function(bytes) {
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = $87Zkx.bytesToNumberBE(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    const ORDER_MASK = $87Zkx.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        if (typeof num !== "bigint") throw new Error("bigint expected");
        if (!($1725082ac41e164d$var$_0n <= num && num < ORDER_MASK)) throw new Error(`bigint expected < 2^${CURVE.nBitLength}`);
        // works with order, can have different size than numToField!
        return $87Zkx.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order, this will be wrong at least for P521.
    // Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if ([
            "recovered",
            "canonical"
        ].some((k)=>k in opts)) throw new Error("sign() legacy options not supported");
        const { hash: hash, randomBytes: randomBytes } = CURVE;
        let { lowS: lowS, prehash: prehash, extraEntropy: ent } = opts; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, $87Zkx.ensureBytes)("msgHash", msgHash);
        if (prehash) msgHash = (0, $87Zkx.ensureBytes)("prehashed msgHash", hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null && ent !== false) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            const e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, $87Zkx.ensureBytes)("extraEntropy", e)); // check for being bytes
        }
        const seed = $87Zkx.concatBytes(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            const ik = invN(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = Gk
            const r = modN(q.x); // r = q.x mod n
            if (r === $1725082ac41e164d$var$_0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            const s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === $1725082ac41e164d$var$_0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & $1725082ac41e164d$var$_1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    const defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    const defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey, opts = defaultSigOpts) {
        const { seed: seed, k2sig: k2sig } = prepSig(msgHash, privKey, opts); // Steps A, D of RFC6979 3.2.
        const C = CURVE;
        const drbg = $87Zkx.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
        const sg = signature;
        msgHash = (0, $87Zkx.ensureBytes)("msgHash", msgHash);
        publicKey = (0, $87Zkx.ensureBytes)("publicKey", publicKey);
        if ("strict" in opts) throw new Error("options.strict was renamed to lowS");
        const { lowS: lowS, prehash: prehash } = opts;
        let _sig = undefined;
        let P;
        try {
            if (typeof sg === "string" || $87Zkx.isBytes(sg)) // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
            // Since DER can also be 2*nByteLength bytes, we check for it first.
            try {
                _sig = Signature.fromDER(sg);
            } catch (derError) {
                if (!(derError instanceof $1725082ac41e164d$export$56ac33195d7076db.Err)) throw derError;
                _sig = Signature.fromCompact(sg);
            }
            else if (typeof sg === "object" && typeof sg.r === "bigint" && typeof sg.s === "bigint") {
                const { r: r, s: s } = sg;
                _sig = new Signature(r, s);
            } else throw new Error("PARSE");
            P = Point.fromHex(publicKey);
        } catch (error) {
            if (error.message === "PARSE") throw new Error(`signature must be Signature instance, Uint8Array or hex string`);
            return false;
        }
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        const { r: r, s: s } = _sig;
        const h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        const is = invN(s); // s^-1
        const u1 = modN(h * is); // u1 = hs^-1 mod n
        const u2 = modN(r * is); // u2 = rs^-1 mod n
        const R = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        sign: sign,
        verify: verify,
        ProjectivePoint: Point,
        Signature: Signature,
        utils: utils
    };
}
function $1725082ac41e164d$export$8324ae9483e33241(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = $1725082ac41e164d$var$_0n;
    for(let o = q - $1725082ac41e164d$var$_1n; o % $1725082ac41e164d$var$_2n === $1725082ac41e164d$var$_0n; o /= $1725082ac41e164d$var$_2n)l += $1725082ac41e164d$var$_1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = $1725082ac41e164d$var$_2n << c1 - $1725082ac41e164d$var$_1n - $1725082ac41e164d$var$_1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * $1725082ac41e164d$var$_2n;
    const c2 = (q - $1725082ac41e164d$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - $1725082ac41e164d$var$_1n) / $1725082ac41e164d$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - $1725082ac41e164d$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + $1725082ac41e164d$var$_1n) / $1725082ac41e164d$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > $1725082ac41e164d$var$_1n; i--){
            let tv5 = i - $1725082ac41e164d$var$_2n; // 18.    tv5 = i - 2
            tv5 = $1725082ac41e164d$var$_2n << tv5 - $1725082ac41e164d$var$_1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $1725082ac41e164d$var$_4n === $1725082ac41e164d$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - $1725082ac41e164d$var$_3n) / $1725082ac41e164d$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
function $1725082ac41e164d$export$cc7fea9756a17416(Fp, opts) {
    $clLt8.validateField(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
    const sqrtRatio = $1725082ac41e164d$export$8324ae9483e33241(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error("Fp.isOdd is not implemented!");
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid: isValid, value: value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}

});
parcelRegister("9SYS8", function(module, exports) {

$parcel$export(module.exports, "wNAF", () => wNAF);
$parcel$export(module.exports, "validateBasic", () => validateBasic);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Abelian group utilities

var $clLt8 = parcelRequire("clLt8");

var $87Zkx = parcelRequire("87Zkx");
const _0n = BigInt(0);
const _1n = BigInt(1);
function wNAF(c, bits) {
    const constTimeNegate = (condition, item)=>{
        const neg = item.negate();
        return condition ? neg : item;
    };
    const opts = (W)=>{
        const windows = Math.ceil(bits / W) + 1; // +1, because
        const windowSize = 2 ** (W - 1); // -1 because we skip zero
        return {
            windows: windows,
            windowSize: windowSize
        };
    };
    return {
        constTimeNegate: constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder (elm, n) {
            let p = c.ZERO;
            let d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows, windowSize } = opts(W);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows, windowSize } = opts(W);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p: p,
                f: f
            };
        },
        wNAFCached (P, precomputesMap, n, transform) {
            // @ts-ignore
            const W = P._WINDOW_SIZE || 1;
            // Calculate precomputes on a first run, reuse them after
            let comp = precomputesMap.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) precomputesMap.set(P, transform(comp));
            }
            return this.wNAF(W, comp, n);
        }
    };
}
function validateBasic(curve) {
    (0, $clLt8.validateField)(curve.Fp);
    (0, $87Zkx.validateObject)(curve, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    // Set defaults
    return Object.freeze({
        ...(0, $clLt8.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}

});


parcelRegister("liJ6s", function(module, exports) {

$parcel$export(module.exports, "isogenyMap", () => $f81e43f6089d3ea6$export$9393380cf1075f28);
$parcel$export(module.exports, "createHasher", () => $f81e43f6089d3ea6$export$14b114effbc08b6b);

var $clLt8 = parcelRequire("clLt8");

var $87Zkx = parcelRequire("87Zkx");
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $f81e43f6089d3ea6$var$os2ip = (0, $87Zkx.bytesToNumberBE);
// Integer to Octet Stream (numberToBytesBE)
function $f81e43f6089d3ea6$var$i2osp(value, length) {
    if (value < 0 || value >= 1 << 8 * length) throw new Error(`bad I2OSP call: value=${value} length=${length}`);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $f81e43f6089d3ea6$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $f81e43f6089d3ea6$var$anum(item) {
    if (!Number.isSafeInteger(item)) throw new Error("number expected");
}
function $f81e43f6089d3ea6$export$3df78c69af9fc85d(msg, DST, lenInBytes, H) {
    (0, $87Zkx.abytes)(msg);
    (0, $87Zkx.abytes)(DST);
    $f81e43f6089d3ea6$var$anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $87Zkx.concatBytes)((0, $87Zkx.utf8ToBytes)("H2C-OVERSIZE-DST-"), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (ell > 255) throw new Error("Invalid xmd length");
    const DST_prime = (0, $87Zkx.concatBytes)(DST, $f81e43f6089d3ea6$var$i2osp(DST.length, 1));
    const Z_pad = $f81e43f6089d3ea6$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $f81e43f6089d3ea6$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $87Zkx.concatBytes)(Z_pad, msg, l_i_b_str, $f81e43f6089d3ea6$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $87Zkx.concatBytes)(b_0, $f81e43f6089d3ea6$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $f81e43f6089d3ea6$var$strxor(b_0, b[i - 1]),
            $f81e43f6089d3ea6$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $87Zkx.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, $87Zkx.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
function $f81e43f6089d3ea6$export$3f56d6fdbf95d07c(msg, DST, lenInBytes, k, H) {
    (0, $87Zkx.abytes)(msg);
    (0, $87Zkx.abytes)(DST);
    $f81e43f6089d3ea6$var$anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $87Zkx.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($f81e43f6089d3ea6$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($f81e43f6089d3ea6$var$i2osp(DST.length, 1)).digest();
}
function $f81e43f6089d3ea6$export$97cdd5ee18de8172(msg, count, options) {
    (0, $87Zkx.validateObject)(options, {
        DST: "stringOrUint8Array",
        p: "bigint",
        m: "isSafeInteger",
        k: "isSafeInteger",
        hash: "hash"
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: _DST } = options;
    (0, $87Zkx.abytes)(msg);
    $f81e43f6089d3ea6$var$anum(count);
    const DST = typeof _DST === "string" ? (0, $87Zkx.utf8ToBytes)(_DST) : _DST;
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === "xmd") prb = $f81e43f6089d3ea6$export$3df78c69af9fc85d(msg, DST, len_in_bytes, hash);
    else if (expand === "xof") prb = $f81e43f6089d3ea6$export$3f56d6fdbf95d07c(msg, DST, len_in_bytes, k, hash);
    else if (expand === "_internal_pass") // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $clLt8.mod)($f81e43f6089d3ea6$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
function $f81e43f6089d3ea6$export$9393380cf1075f28(field, map) {
    // Make same order as in spec
    const COEFF = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xNum, xDen, yNum, yDen] = COEFF.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
function $f81e43f6089d3ea6$export$14b114effbc08b6b(Point, mapToCurve, def) {
    if (typeof mapToCurve !== "function") throw new Error("mapToCurve() must be defined");
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve (msg, options) {
            const u = $f81e43f6089d3ea6$export$97cdd5ee18de8172(msg, 2, {
                ...def,
                DST: def.DST,
                ...options
            });
            const u0 = Point.fromAffine(mapToCurve(u[0]));
            const u1 = Point.fromAffine(mapToCurve(u[1]));
            const P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve (msg, options) {
            const u = $f81e43f6089d3ea6$export$97cdd5ee18de8172(msg, 1, {
                ...def,
                DST: def.encodeDST,
                ...options
            });
            const P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}

});

parcelRegister("3DvJ1", function(module, exports) {

$parcel$export(module.exports, "createCurve", () => $2a5d9f9750f11e5f$export$3f2f6721dd02558a);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $h8PfB = parcelRequire("h8PfB");

var $5358X = parcelRequire("5358X");

var $1ZciS = parcelRequire("1ZciS");
function $2a5d9f9750f11e5f$export$adaba664e531641c(hash) {
    return {
        hash: hash,
        hmac: (key, ...msgs)=>(0, $h8PfB.hmac)(hash, key, (0, $5358X.concatBytes)(...msgs)),
        randomBytes: $5358X.randomBytes
    };
}
function $2a5d9f9750f11e5f$export$3f2f6721dd02558a(curveDef, defHash) {
    const create = (hash)=>(0, $1ZciS.weierstrass)({
            ...curveDef,
            ...$2a5d9f9750f11e5f$export$adaba664e531641c(hash)
        });
    return Object.freeze({
        ...create(defHash),
        create: create
    });
}

});
parcelRegister("h8PfB", function(module, exports) {

$parcel$export(module.exports, "hmac", () => $c7aaf05206415f53$export$355af40f8ab02f34);

var $jxb68 = parcelRequire("jxb68");

var $5358X = parcelRequire("5358X");
class $c7aaf05206415f53$export$7b9cf41ebec74f45 extends (0, $5358X.Hash) {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $jxb68.hash)(hash);
        const key = (0, $5358X.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        (0, $jxb68.exists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $jxb68.exists)(this);
        (0, $jxb68.bytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
const $c7aaf05206415f53$export$355af40f8ab02f34 = (hash, key, message)=>new $c7aaf05206415f53$export$7b9cf41ebec74f45(hash, key).update(message).digest();
$c7aaf05206415f53$export$355af40f8ab02f34.create = (hash, key)=>new $c7aaf05206415f53$export$7b9cf41ebec74f45(hash, key);

});



parcelRegister("dRVqp", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $a18cc4fe791456e5$export$bf730a2d8bf68b42, (v) => $a18cc4fe791456e5$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a18cc4fe791456e5$export$bf730a2d8bf68b42;
"use strict";


(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var React = (parcelRequire("8NFma"));
    var shim = (parcelRequire("ck4pA"));
    /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
    }
    var objectIs = typeof Object.is === "function" ? Object.is : is;
    var useSyncExternalStore = shim.useSyncExternalStore;
    // for CommonJS interop.
    var useRef = React.useRef, useEffect = React.useEffect, useMemo = React.useMemo, useDebugValue = React.useDebugValue; // Same as useSyncExternalStore, but supports selector and isEqual arguments.
    function useSyncExternalStoreWithSelector(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
        // Use this to track the rendered snapshot.
        var instRef = useRef(null);
        var inst;
        if (instRef.current === null) {
            inst = {
                hasValue: false,
                value: null
            };
            instRef.current = inst;
        } else inst = instRef.current;
        var _useMemo = useMemo(function() {
            // Track the memoized state using closure variables that are local to this
            // memoized instance of a getSnapshot function. Intentionally not using a
            // useRef hook, because that state would be shared across all concurrent
            // copies of the hook/component.
            var hasMemo = false;
            var memoizedSnapshot;
            var memoizedSelection;
            var memoizedSelector = function(nextSnapshot) {
                if (!hasMemo) {
                    // The first time the hook is called, there is no memoized result.
                    hasMemo = true;
                    memoizedSnapshot = nextSnapshot;
                    var _nextSelection = selector(nextSnapshot);
                    if (isEqual !== undefined) // Even if the selector has changed, the currently rendered selection
                    // may be equal to the new selection. We should attempt to reuse the
                    // current value if possible, to preserve downstream memoizations.
                    {
                        if (inst.hasValue) {
                            var currentSelection = inst.value;
                            if (isEqual(currentSelection, _nextSelection)) {
                                memoizedSelection = currentSelection;
                                return currentSelection;
                            }
                        }
                    }
                    memoizedSelection = _nextSelection;
                    return _nextSelection;
                } // We may be able to reuse the previous invocation's result.
                // We may be able to reuse the previous invocation's result.
                var prevSnapshot = memoizedSnapshot;
                var prevSelection = memoizedSelection;
                if (objectIs(prevSnapshot, nextSnapshot)) // The snapshot is the same as last time. Reuse the previous selection.
                return prevSelection;
                 // The snapshot has changed, so we need to compute a new selection.
                // The snapshot has changed, so we need to compute a new selection.
                var nextSelection = selector(nextSnapshot); // If a custom isEqual function is provided, use that to check if the data
                // has changed. If it hasn't, return the previous selection. That signals
                // to React that the selections are conceptually equal, and we can bail
                // out of rendering.
                // If a custom isEqual function is provided, use that to check if the data
                // has changed. If it hasn't, return the previous selection. That signals
                // to React that the selections are conceptually equal, and we can bail
                // out of rendering.
                if (isEqual !== undefined && isEqual(prevSelection, nextSelection)) return prevSelection;
                memoizedSnapshot = nextSnapshot;
                memoizedSelection = nextSelection;
                return nextSelection;
            }; // Assigning this to a constant so that Flow knows it can't change.
            // Assigning this to a constant so that Flow knows it can't change.
            var maybeGetServerSnapshot = getServerSnapshot === undefined ? null : getServerSnapshot;
            var getSnapshotWithSelector = function() {
                return memoizedSelector(getSnapshot());
            };
            var getServerSnapshotWithSelector = maybeGetServerSnapshot === null ? undefined : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            };
            return [
                getSnapshotWithSelector,
                getServerSnapshotWithSelector
            ];
        }, [
            getSnapshot,
            getServerSnapshot,
            selector,
            isEqual
        ]), getSelection = _useMemo[0], getServerSelection = _useMemo[1];
        var value = useSyncExternalStore(subscribe, getSelection, getServerSelection);
        useEffect(function() {
            inst.hasValue = true;
            inst.value = value;
        }, [
            value
        ]);
        useDebugValue(value);
        return value;
    }
    $a18cc4fe791456e5$export$bf730a2d8bf68b42 = useSyncExternalStoreWithSelector;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});
parcelRegister("ck4pA", function(module, exports) {
"use strict";

module.exports = (parcelRequire("l4FTB"));

});
parcelRegister("l4FTB", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $f57a7850286c49a2$export$306c0aa65ff9ec16, (v) => $f57a7850286c49a2$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $f57a7850286c49a2$export$306c0aa65ff9ec16;
"use strict";

(function() {
    "use strict";
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var React = (parcelRequire("8NFma"));
    var ReactSharedInternals = React.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function error(format) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        printWarning("error", format, args);
    }
    function printWarning(level, format, args) {
        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
        var stack = ReactDebugCurrentFrame.getStackAddendum();
        if (stack !== "") {
            format += "%s";
            args = args.concat([
                stack
            ]);
        } // eslint-disable-next-line react-internal/safe-string-coercion
        var argsWithFormat = args.map(function(item) {
            return String(item);
        }); // Careful: RN currently depends on this prefix
        argsWithFormat.unshift("Warning: " + format); // We intentionally don't use spread (or .apply) directly because it
        // breaks IE9: https://github.com/facebook/react/issues/13610
        // eslint-disable-next-line react-internal/no-production-logging
        Function.prototype.apply.call(console[level], console, argsWithFormat);
    }
    /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function is(x, y) {
        return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
        ;
    }
    var objectIs = typeof Object.is === "function" ? Object.is : is;
    // dispatch for CommonJS interop named imports.
    var useState = React.useState, useEffect = React.useEffect, useLayoutEffect = React.useLayoutEffect, useDebugValue = React.useDebugValue;
    var didWarnOld18Alpha = false;
    var didWarnUncachedGetSnapshot = false; // Disclaimer: This shim breaks many of the rules of React, and only works
    // because of a very particular set of implementation details and assumptions
    // -- change any one of them and it will break. The most important assumption
    // is that updates are always synchronous, because concurrent rendering is
    // only available in versions of React that also have a built-in
    // useSyncExternalStore API. And we only use this shim when the built-in API
    // does not exist.
    //
    // Do not assume that the clever hacks used by this hook also work in general.
    // The point of this shim is to replace the need for hacks by other libraries.
    function useSyncExternalStore(subscribe, getSnapshot, // React do not expose a way to check if we're hydrating. So users of the shim
    // will need to track that themselves and return the correct value
    // from `getSnapshot`.
    getServerSnapshot) {
        if (!didWarnOld18Alpha) {
            if (React.startTransition !== undefined) {
                didWarnOld18Alpha = true;
                error("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release.");
            }
        }
        // breaks the rules of React, and only works here because of specific
        // implementation details, most importantly that updates are
        // always synchronous.
        var value = getSnapshot();
        if (!didWarnUncachedGetSnapshot) {
            var cachedValue = getSnapshot();
            if (!objectIs(value, cachedValue)) {
                error("The result of getSnapshot should be cached to avoid an infinite loop");
                didWarnUncachedGetSnapshot = true;
            }
        }
        // re-render whenever the subscribed state changes by updating an some
        // arbitrary useState hook. Then, during render, we call getSnapshot to read
        // the current value.
        //
        // Because we don't actually use the state returned by the useState hook, we
        // can save a bit of memory by storing other stuff in that slot.
        //
        // To implement the early bailout, we need to track some things on a mutable
        // object. Usually, we would put that in a useRef hook, but we can stash it in
        // our useState hook instead.
        //
        // To force a re-render, we call forceUpdate({inst}). That works because the
        // new object always fails an equality check.
        var _useState = useState({
            inst: {
                value: value,
                getSnapshot: getSnapshot
            }
        }), inst = _useState[0].inst, forceUpdate = _useState[1]; // Track the latest getSnapshot function with a ref. This needs to be updated
        // in the layout phase so we can access it during the tearing check that
        // happens on subscribe.
        useLayoutEffect(function() {
            inst.value = value;
            inst.getSnapshot = getSnapshot; // Whenever getSnapshot or subscribe changes, we need to check in the
            // commit phase if there was an interleaved mutation. In concurrent mode
            // this can happen all the time, but even in synchronous mode, an earlier
            // effect may have mutated the store.
            if (checkIfSnapshotChanged(inst)) // Force a re-render.
            forceUpdate({
                inst: inst
            });
        }, [
            subscribe,
            value,
            getSnapshot
        ]);
        useEffect(function() {
            // Check for changes right before subscribing. Subsequent changes will be
            // detected in the subscription handler.
            if (checkIfSnapshotChanged(inst)) // Force a re-render.
            forceUpdate({
                inst: inst
            });
            var handleStoreChange = function() {
                // TODO: Because there is no cross-renderer API for batching updates, it's
                // up to the consumer of this library to wrap their subscription event
                // with unstable_batchedUpdates. Should we try to detect when this isn't
                // the case and print a warning in development?
                // The store changed. Check if the snapshot changed since the last time we
                // read from the store.
                if (checkIfSnapshotChanged(inst)) // Force a re-render.
                forceUpdate({
                    inst: inst
                });
            }; // Subscribe to the store and return a clean-up function.
            return subscribe(handleStoreChange);
        }, [
            subscribe
        ]);
        useDebugValue(value);
        return value;
    }
    function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        var prevValue = inst.value;
        try {
            var nextValue = latestGetSnapshot();
            return !objectIs(prevValue, nextValue);
        } catch (error) {
            return true;
        }
    }
    function useSyncExternalStore$1(subscribe, getSnapshot, getServerSnapshot) {
        // Note: The shim does not use getServerSnapshot, because pre-18 versions of
        // React do not expose a way to check if we're hydrating. So users of the shim
        // will need to track that themselves and return the correct value
        // from `getSnapshot`.
        return getSnapshot();
    }
    var canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
    var isServerEnvironment = !canUseDOM;
    var shim = isServerEnvironment ? useSyncExternalStore$1 : useSyncExternalStore;
    var useSyncExternalStore$2 = React.useSyncExternalStore !== undefined ? React.useSyncExternalStore : shim;
    $f57a7850286c49a2$export$306c0aa65ff9ec16 = useSyncExternalStore$2;
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== "undefined" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === "function") __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
})();

});



parcelRegister("exvTT", function(module, exports) {

$parcel$export(module.exports, "wNAF", () => wNAF);
$parcel$export(module.exports, "validateBasic", () => validateBasic);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Abelian group utilities

var $lzJFq = parcelRequire("lzJFq");

var $heHQ1 = parcelRequire("heHQ1");
const _0n = BigInt(0);
const _1n = BigInt(1);
// Since points in different groups cannot be equal (different object constructor),
// we can have single place to store precomputes
const pointPrecomputes = new WeakMap();
const pointWindowSizes = new WeakMap(); // This allows use make points immutable (nothing changes inside)
function wNAF(c, bits) {
    const constTimeNegate = (condition, item)=>{
        const neg = item.negate();
        return condition ? neg : item;
    };
    const validateW = (W)=>{
        if (!Number.isSafeInteger(W) || W <= 0 || W > bits) throw new Error(`Wrong window size=${W}, should be [1..${bits}]`);
    };
    const opts = (W)=>{
        validateW(W);
        const windows = Math.ceil(bits / W) + 1; // +1, because
        const windowSize = 2 ** (W - 1); // -1 because we skip zero
        return {
            windows: windows,
            windowSize: windowSize
        };
    };
    return {
        constTimeNegate: constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder (elm, n) {
            let p = c.ZERO;
            let d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows, windowSize } = opts(W);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows, windowSize } = opts(W);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p: p,
                f: f
            };
        },
        wNAFCached (P, n, transform) {
            const W = pointWindowSizes.get(P) || 1;
            // Calculate precomputes on a first run, reuse them after
            let comp = pointPrecomputes.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) pointPrecomputes.set(P, transform(comp));
            }
            return this.wNAF(W, comp, n);
        },
        // We calculate precomputes for elliptic curve point multiplication
        // using windowed method. This specifies window size and
        // stores precomputed values. Usually only base point would be precomputed.
        setWindowSize (P, W) {
            validateW(W);
            pointWindowSizes.set(P, W);
            pointPrecomputes.delete(P);
        }
    };
}
function validateBasic(curve) {
    (0, $lzJFq.validateField)(curve.Fp);
    (0, $heHQ1.validateObject)(curve, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    // Set defaults
    return Object.freeze({
        ...(0, $lzJFq.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}

});
parcelRegister("lzJFq", function(module, exports) {

$parcel$export(module.exports, "mod", () => $fb504a664d97d406$export$842a2cf37af977e1);
$parcel$export(module.exports, "pow", () => $fb504a664d97d406$export$9c297f60e22e3389);
$parcel$export(module.exports, "pow2", () => $fb504a664d97d406$export$fa569bd808b67eef);
$parcel$export(module.exports, "invert", () => $fb504a664d97d406$export$6897c284b6f9f4dc);
$parcel$export(module.exports, "isNegativeLE", () => $fb504a664d97d406$export$7806f13ad5078b2f);
$parcel$export(module.exports, "validateField", () => $fb504a664d97d406$export$bd454f0cef11418d);
$parcel$export(module.exports, "nLength", () => $fb504a664d97d406$export$c79df43ecd7e66c2);
$parcel$export(module.exports, "Field", () => $fb504a664d97d406$export$a455218a85c89869);
$parcel$export(module.exports, "FpSqrtEven", () => $fb504a664d97d406$export$1d7b691df0888e02);
$parcel$export(module.exports, "getMinHashLength", () => $fb504a664d97d406$export$d058763b563056af);
$parcel$export(module.exports, "mapHashToField", () => $fb504a664d97d406$export$20cb21dbfa61dac3);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Utilities for modular arithmetics and finite fields

var $heHQ1 = parcelRequire("heHQ1");
// prettier-ignore
const $fb504a664d97d406$var$_0n = BigInt(0), $fb504a664d97d406$var$_1n = BigInt(1), $fb504a664d97d406$var$_2n = BigInt(2), $fb504a664d97d406$var$_3n = BigInt(3);
// prettier-ignore
const $fb504a664d97d406$var$_4n = BigInt(4), $fb504a664d97d406$var$_5n = BigInt(5), $fb504a664d97d406$var$_8n = BigInt(8);
// prettier-ignore
const $fb504a664d97d406$var$_9n = BigInt(9), $fb504a664d97d406$var$_16n = BigInt(16);
function $fb504a664d97d406$export$842a2cf37af977e1(a, b) {
    const result = a % b;
    return result >= $fb504a664d97d406$var$_0n ? result : b + result;
}
function $fb504a664d97d406$export$9c297f60e22e3389(num, power, modulo) {
    if (modulo <= $fb504a664d97d406$var$_0n || power < $fb504a664d97d406$var$_0n) throw new Error("Expected power/modulo > 0");
    if (modulo === $fb504a664d97d406$var$_1n) return $fb504a664d97d406$var$_0n;
    let res = $fb504a664d97d406$var$_1n;
    while(power > $fb504a664d97d406$var$_0n){
        if (power & $fb504a664d97d406$var$_1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= $fb504a664d97d406$var$_1n;
    }
    return res;
}
function $fb504a664d97d406$export$fa569bd808b67eef(x, power, modulo) {
    let res = x;
    while(power-- > $fb504a664d97d406$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
function $fb504a664d97d406$export$6897c284b6f9f4dc(number, modulo) {
    if (number === $fb504a664d97d406$var$_0n || modulo <= $fb504a664d97d406$var$_0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $fb504a664d97d406$export$842a2cf37af977e1(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $fb504a664d97d406$var$_0n, y = $fb504a664d97d406$var$_1n, u = $fb504a664d97d406$var$_1n, v = $fb504a664d97d406$var$_0n;
    while(a !== $fb504a664d97d406$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $fb504a664d97d406$var$_1n) throw new Error("invert: does not exist");
    return $fb504a664d97d406$export$842a2cf37af977e1(x, modulo);
}
function $fb504a664d97d406$export$69f29ab1f3e9a234(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - $fb504a664d97d406$var$_1n) / $fb504a664d97d406$var$_2n;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - $fb504a664d97d406$var$_1n, S = 0; Q % $fb504a664d97d406$var$_2n === $fb504a664d97d406$var$_0n; Q /= $fb504a664d97d406$var$_2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = $fb504a664d97d406$var$_2n; Z < P && $fb504a664d97d406$export$9c297f60e22e3389(Z, legendreC, P) !== P - $fb504a664d97d406$var$_1n; Z++);
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + $fb504a664d97d406$var$_1n) / $fb504a664d97d406$var$_4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + $fb504a664d97d406$var$_1n) / $fb504a664d97d406$var$_2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error("Cannot find square root");
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, $fb504a664d97d406$var$_1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
function $fb504a664d97d406$export$33bda048c6b8ea7d(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % $fb504a664d97d406$var$_4n === $fb504a664d97d406$var$_3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + $fb504a664d97d406$var$_1n) / $fb504a664d97d406$var$_4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % $fb504a664d97d406$var$_8n === $fb504a664d97d406$var$_5n) {
        const c1 = (P - $fb504a664d97d406$var$_5n) / $fb504a664d97d406$var$_8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, $fb504a664d97d406$var$_2n);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, $fb504a664d97d406$var$_2n), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    $fb504a664d97d406$var$_9n;
    // Other cases: Tonelli-Shanks algorithm
    return $fb504a664d97d406$export$69f29ab1f3e9a234(P);
}
const $fb504a664d97d406$export$7806f13ad5078b2f = (num, modulo)=>($fb504a664d97d406$export$842a2cf37af977e1(num, modulo) & $fb504a664d97d406$var$_1n) === $fb504a664d97d406$var$_1n;
// prettier-ignore
const $fb504a664d97d406$var$FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $fb504a664d97d406$export$bd454f0cef11418d(field) {
    const initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    const opts = $fb504a664d97d406$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = "function";
        return map;
    }, initial);
    return (0, $heHQ1.validateObject)(field, opts);
}
function $fb504a664d97d406$export$5d8ce3717733a987(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < $fb504a664d97d406$var$_0n) throw new Error("Expected power > 0");
    if (power === $fb504a664d97d406$var$_0n) return f.ONE;
    if (power === $fb504a664d97d406$var$_1n) return num;
    let p = f.ONE;
    let d = num;
    while(power > $fb504a664d97d406$var$_0n){
        if (power & $fb504a664d97d406$var$_1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= $fb504a664d97d406$var$_1n;
    }
    return p;
}
function $fb504a664d97d406$export$a492e3387142c0e9(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
function $fb504a664d97d406$export$e74c665040343df6(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === "bigint" ? $fb504a664d97d406$export$6897c284b6f9f4dc(rhs, f.ORDER) : f.inv(rhs));
}
function $fb504a664d97d406$export$77ed22730026dd0d(order) {
    // (a | p) ≡ 1    if a is a square (mod p), quadratic residue
    // (a | p) ≡ -1   if a is not a square (mod p), quadratic non residue
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreConst = (order - $fb504a664d97d406$var$_1n) / $fb504a664d97d406$var$_2n; // Integer arithmetic
    return (f, x)=>f.pow(x, legendreConst);
}
function $fb504a664d97d406$export$5e2b6e87f2891ea7(f) {
    const legendre = $fb504a664d97d406$export$77ed22730026dd0d(f.ORDER);
    return (x)=>{
        const p = legendre(f, x);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
function $fb504a664d97d406$export$c79df43ecd7e66c2(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
function $fb504a664d97d406$export$a455218a85c89869(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= $fb504a664d97d406$var$_0n) throw new Error(`Expected Field ORDER > 0, got ${ORDER}`);
    const { nBitLength: BITS, nByteLength: BYTES } = $fb504a664d97d406$export$c79df43ecd7e66c2(ORDER, bitLen);
    if (BYTES > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
    const sqrtP = $fb504a664d97d406$export$33bda048c6b8ea7d(ORDER);
    const f = Object.freeze({
        ORDER: ORDER,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $heHQ1.bitMask)(BITS),
        ZERO: $fb504a664d97d406$var$_0n,
        ONE: $fb504a664d97d406$var$_1n,
        create: (num)=>$fb504a664d97d406$export$842a2cf37af977e1(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== "bigint") throw new Error(`Invalid field element: expected bigint, got ${typeof num}`);
            return $fb504a664d97d406$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $fb504a664d97d406$var$_0n,
        isOdd: (num)=>(num & $fb504a664d97d406$var$_1n) === $fb504a664d97d406$var$_1n,
        neg: (num)=>$fb504a664d97d406$export$842a2cf37af977e1(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$fb504a664d97d406$export$842a2cf37af977e1(num * num, ORDER),
        add: (lhs, rhs)=>$fb504a664d97d406$export$842a2cf37af977e1(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$fb504a664d97d406$export$842a2cf37af977e1(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$fb504a664d97d406$export$842a2cf37af977e1(lhs * rhs, ORDER),
        pow: (num, power)=>$fb504a664d97d406$export$5d8ce3717733a987(f, num, power),
        div: (lhs, rhs)=>$fb504a664d97d406$export$842a2cf37af977e1(lhs * $fb504a664d97d406$export$6897c284b6f9f4dc(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$fb504a664d97d406$export$6897c284b6f9f4dc(num, ORDER),
        sqrt: redef.sqrt || ((n)=>sqrtP(f, n)),
        invertBatch: (lst)=>$fb504a664d97d406$export$a492e3387142c0e9(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE ? (0, $heHQ1.numberToBytesLE)(num, BYTES) : (0, $heHQ1.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error(`Fp.fromBytes: expected ${BYTES}, got ${bytes.length}`);
            return isLE ? (0, $heHQ1.bytesToNumberLE)(bytes) : (0, $heHQ1.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
function $fb504a664d97d406$export$7acc54692c525d2a(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
function $fb504a664d97d406$export$1d7b691df0888e02(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
function $fb504a664d97d406$export$d3b0e8260d5dbad4(hash, groupOrder, isLE = false) {
    hash = (0, $heHQ1.ensureBytes)("privateHash", hash);
    const hashLen = hash.length;
    const minLen = $fb504a664d97d406$export$c79df43ecd7e66c2(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error(`hashToPrivateScalar: expected ${minLen}-1024 bytes of input, got ${hashLen}`);
    const num = isLE ? (0, $heHQ1.bytesToNumberLE)(hash) : (0, $heHQ1.bytesToNumberBE)(hash);
    return $fb504a664d97d406$export$842a2cf37af977e1(num, groupOrder - $fb504a664d97d406$var$_1n) + $fb504a664d97d406$var$_1n;
}
function $fb504a664d97d406$export$9cf21a9392b0fcfc(fieldOrder) {
    if (typeof fieldOrder !== "bigint") throw new Error("field order must be bigint");
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
function $fb504a664d97d406$export$d058763b563056af(fieldOrder) {
    const length = $fb504a664d97d406$export$9cf21a9392b0fcfc(fieldOrder);
    return length + Math.ceil(length / 2);
}
function $fb504a664d97d406$export$20cb21dbfa61dac3(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = $fb504a664d97d406$export$9cf21a9392b0fcfc(fieldOrder);
    const minLen = $fb504a664d97d406$export$d058763b563056af(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error(`expected ${minLen}-1024 bytes of input, got ${len}`);
    const num = isLE ? (0, $heHQ1.bytesToNumberBE)(key) : (0, $heHQ1.bytesToNumberLE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = $fb504a664d97d406$export$842a2cf37af977e1(num, fieldOrder - $fb504a664d97d406$var$_1n) + $fb504a664d97d406$var$_1n;
    return isLE ? (0, $heHQ1.numberToBytesLE)(reduced, fieldLen) : (0, $heHQ1.numberToBytesBE)(reduced, fieldLen);
}

});
parcelRegister("heHQ1", function(module, exports) {

$parcel$export(module.exports, "isBytes", () => $c8c5bfcf373c9bdb$export$c6fabfbfd097fc30);
$parcel$export(module.exports, "abytes", () => $c8c5bfcf373c9bdb$export$e8a750b9efad93f5);
$parcel$export(module.exports, "abool", () => $c8c5bfcf373c9bdb$export$809304d28d77d92d);
$parcel$export(module.exports, "bytesToHex", () => $c8c5bfcf373c9bdb$export$58b867e287a802c8);
$parcel$export(module.exports, "numberToHexUnpadded", () => $c8c5bfcf373c9bdb$export$4ed2545b622827c1);
$parcel$export(module.exports, "hexToNumber", () => $c8c5bfcf373c9bdb$export$d57f2bacc26b4249);
$parcel$export(module.exports, "hexToBytes", () => $c8c5bfcf373c9bdb$export$31c96b9df38bc8d4);
$parcel$export(module.exports, "bytesToNumberBE", () => $c8c5bfcf373c9bdb$export$d609354794974f8);
$parcel$export(module.exports, "bytesToNumberLE", () => $c8c5bfcf373c9bdb$export$d67b1d03392107e7);
$parcel$export(module.exports, "numberToBytesBE", () => $c8c5bfcf373c9bdb$export$1459dafd057611cb);
$parcel$export(module.exports, "numberToBytesLE", () => $c8c5bfcf373c9bdb$export$ba2172e58d139f6d);
$parcel$export(module.exports, "numberToVarBytesBE", () => $c8c5bfcf373c9bdb$export$80ee8c1914de6dde);
$parcel$export(module.exports, "ensureBytes", () => $c8c5bfcf373c9bdb$export$3cb5d50a3a30e837);
$parcel$export(module.exports, "concatBytes", () => $c8c5bfcf373c9bdb$export$287dd7971339c972);
$parcel$export(module.exports, "equalBytes", () => $c8c5bfcf373c9bdb$export$2aa59cef064b0333);
$parcel$export(module.exports, "utf8ToBytes", () => $c8c5bfcf373c9bdb$export$3df70a15530b5e81);
$parcel$export(module.exports, "inRange", () => $c8c5bfcf373c9bdb$export$ddf89a9c5af38f94);
$parcel$export(module.exports, "aInRange", () => $c8c5bfcf373c9bdb$export$86cc12b5dde3c1e4);
$parcel$export(module.exports, "bitLen", () => $c8c5bfcf373c9bdb$export$e93ef600c41761a9);
$parcel$export(module.exports, "bitGet", () => $c8c5bfcf373c9bdb$export$9577d112d1fd46ad);
$parcel$export(module.exports, "bitSet", () => $c8c5bfcf373c9bdb$export$967bb2b9787441cb);
$parcel$export(module.exports, "bitMask", () => $c8c5bfcf373c9bdb$export$803efa2fa1c7279);
$parcel$export(module.exports, "createHmacDrbg", () => $c8c5bfcf373c9bdb$export$d459d139192e4fba);
$parcel$export(module.exports, "validateObject", () => $c8c5bfcf373c9bdb$export$381bae2d0f08004f);
$parcel$export(module.exports, "notImplemented", () => $c8c5bfcf373c9bdb$export$94a5f06e658f87e2);
$parcel$export(module.exports, "memoized", () => $c8c5bfcf373c9bdb$export$9756366f7cb6f62b);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const $c8c5bfcf373c9bdb$var$_0n = /* @__PURE__ */ BigInt(0);
const $c8c5bfcf373c9bdb$var$_1n = /* @__PURE__ */ BigInt(1);
const $c8c5bfcf373c9bdb$var$_2n = /* @__PURE__ */ BigInt(2);
function $c8c5bfcf373c9bdb$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
function $c8c5bfcf373c9bdb$export$e8a750b9efad93f5(item) {
    if (!$c8c5bfcf373c9bdb$export$c6fabfbfd097fc30(item)) throw new Error("Uint8Array expected");
}
function $c8c5bfcf373c9bdb$export$809304d28d77d92d(title, value) {
    if (typeof value !== "boolean") throw new Error(`${title} must be valid boolean, got "${value}".`);
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const $c8c5bfcf373c9bdb$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $c8c5bfcf373c9bdb$export$58b867e287a802c8(bytes) {
    $c8c5bfcf373c9bdb$export$e8a750b9efad93f5(bytes);
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $c8c5bfcf373c9bdb$var$hexes[bytes[i]];
    return hex;
}
function $c8c5bfcf373c9bdb$export$4ed2545b622827c1(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
function $c8c5bfcf373c9bdb$export$d57f2bacc26b4249(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    // Big Endian
    return BigInt(hex === "" ? "0" : `0x${hex}`);
}
// We use optimized technique to convert hex string to byte array
const $c8c5bfcf373c9bdb$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $c8c5bfcf373c9bdb$var$asciiToBase16(char) {
    if (char >= $c8c5bfcf373c9bdb$var$asciis._0 && char <= $c8c5bfcf373c9bdb$var$asciis._9) return char - $c8c5bfcf373c9bdb$var$asciis._0;
    if (char >= $c8c5bfcf373c9bdb$var$asciis._A && char <= $c8c5bfcf373c9bdb$var$asciis._F) return char - ($c8c5bfcf373c9bdb$var$asciis._A - 10);
    if (char >= $c8c5bfcf373c9bdb$var$asciis._a && char <= $c8c5bfcf373c9bdb$var$asciis._f) return char - ($c8c5bfcf373c9bdb$var$asciis._a - 10);
    return;
}
function $c8c5bfcf373c9bdb$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $c8c5bfcf373c9bdb$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $c8c5bfcf373c9bdb$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
function $c8c5bfcf373c9bdb$export$d609354794974f8(bytes) {
    return $c8c5bfcf373c9bdb$export$d57f2bacc26b4249($c8c5bfcf373c9bdb$export$58b867e287a802c8(bytes));
}
function $c8c5bfcf373c9bdb$export$d67b1d03392107e7(bytes) {
    $c8c5bfcf373c9bdb$export$e8a750b9efad93f5(bytes);
    return $c8c5bfcf373c9bdb$export$d57f2bacc26b4249($c8c5bfcf373c9bdb$export$58b867e287a802c8(Uint8Array.from(bytes).reverse()));
}
function $c8c5bfcf373c9bdb$export$1459dafd057611cb(n, len) {
    return $c8c5bfcf373c9bdb$export$31c96b9df38bc8d4(n.toString(16).padStart(len * 2, "0"));
}
function $c8c5bfcf373c9bdb$export$ba2172e58d139f6d(n, len) {
    return $c8c5bfcf373c9bdb$export$1459dafd057611cb(n, len).reverse();
}
function $c8c5bfcf373c9bdb$export$80ee8c1914de6dde(n) {
    return $c8c5bfcf373c9bdb$export$31c96b9df38bc8d4($c8c5bfcf373c9bdb$export$4ed2545b622827c1(n));
}
function $c8c5bfcf373c9bdb$export$3cb5d50a3a30e837(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = $c8c5bfcf373c9bdb$export$31c96b9df38bc8d4(hex);
    } catch (e) {
        throw new Error(`${title} must be valid hex string, got "${hex}". Cause: ${e}`);
    }
    else if ($c8c5bfcf373c9bdb$export$c6fabfbfd097fc30(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(`${title} must be hex string or Uint8Array`);
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(`${title} expected ${expectedLength} bytes, got ${len}`);
    return res;
}
function $c8c5bfcf373c9bdb$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        $c8c5bfcf373c9bdb$export$e8a750b9efad93f5(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
function $c8c5bfcf373c9bdb$export$2aa59cef064b0333(a, b) {
    if (a.length !== b.length) return false;
    let diff = 0;
    for(let i = 0; i < a.length; i++)diff |= a[i] ^ b[i];
    return diff === 0;
}
function $c8c5bfcf373c9bdb$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
// Is positive bigint
const $c8c5bfcf373c9bdb$var$isPosBig = (n)=>typeof n === "bigint" && $c8c5bfcf373c9bdb$var$_0n <= n;
function $c8c5bfcf373c9bdb$export$ddf89a9c5af38f94(n, min, max) {
    return $c8c5bfcf373c9bdb$var$isPosBig(n) && $c8c5bfcf373c9bdb$var$isPosBig(min) && $c8c5bfcf373c9bdb$var$isPosBig(max) && min <= n && n < max;
}
function $c8c5bfcf373c9bdb$export$86cc12b5dde3c1e4(title, n, min, max) {
    // Why min <= n < max and not a (min < n < max) OR b (min <= n <= max)?
    // consider P=256n, min=0n, max=P
    // - a for min=0 would require -1:          `inRange('x', x, -1n, P)`
    // - b would commonly require subtraction:  `inRange('x', x, 0n, P - 1n)`
    // - our way is the cleanest:               `inRange('x', x, 0n, P)
    if (!$c8c5bfcf373c9bdb$export$ddf89a9c5af38f94(n, min, max)) throw new Error(`expected valid ${title}: ${min} <= n < ${max}, got ${typeof n} ${n}`);
}
function $c8c5bfcf373c9bdb$export$e93ef600c41761a9(n) {
    let len;
    for(len = 0; n > $c8c5bfcf373c9bdb$var$_0n; n >>= $c8c5bfcf373c9bdb$var$_1n, len += 1);
    return len;
}
function $c8c5bfcf373c9bdb$export$9577d112d1fd46ad(n, pos) {
    return n >> BigInt(pos) & $c8c5bfcf373c9bdb$var$_1n;
}
function $c8c5bfcf373c9bdb$export$967bb2b9787441cb(n, pos, value) {
    return n | (value ? $c8c5bfcf373c9bdb$var$_1n : $c8c5bfcf373c9bdb$var$_0n) << BigInt(pos);
}
const $c8c5bfcf373c9bdb$export$803efa2fa1c7279 = (n)=>($c8c5bfcf373c9bdb$var$_2n << BigInt(n - 1)) - $c8c5bfcf373c9bdb$var$_1n;
// DRBG
const $c8c5bfcf373c9bdb$var$u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const $c8c5bfcf373c9bdb$var$u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
function $c8c5bfcf373c9bdb$export$d459d139192e4fba(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = $c8c5bfcf373c9bdb$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = $c8c5bfcf373c9bdb$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = $c8c5bfcf373c9bdb$var$u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($c8c5bfcf373c9bdb$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($c8c5bfcf373c9bdb$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $c8c5bfcf373c9bdb$export$287dd7971339c972(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
// Validating curves and fields
const $c8c5bfcf373c9bdb$var$validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    stringOrUint8Array: (val)=>typeof val === "string" || $c8c5bfcf373c9bdb$export$c6fabfbfd097fc30(val),
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
function $c8c5bfcf373c9bdb$export$381bae2d0f08004f(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $c8c5bfcf373c9bdb$var$validatorFns[type];
        if (typeof checkVal !== "function") throw new Error(`Invalid validator "${type}", expected function`);
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error(`Invalid param ${String(fieldName)}=${val} (${typeof val}), expected ${type}`);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
}
const $c8c5bfcf373c9bdb$export$94a5f06e658f87e2 = ()=>{
    throw new Error("not implemented");
};
function $c8c5bfcf373c9bdb$export$9756366f7cb6f62b(fn) {
    const map = new WeakMap();
    return (arg, ...args)=>{
        const val = map.get(arg);
        if (val !== undefined) return val;
        const computed = fn(arg, ...args);
        map.set(arg, computed);
        return computed;
    };
}

});



parcelRegister("lONYJ", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("foUwZ")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});
parcelRegister("foUwZ", function(module, exports) {
"use strict";

});


parcelRegister("fx8YU", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $N0o3H = parcelRequire("N0o3H");
var $b4f0e7985342bd1b$var$Buffer = $N0o3H.Buffer;
// alternative to using Object.keys for old browsers
function $b4f0e7985342bd1b$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($b4f0e7985342bd1b$var$Buffer.from && $b4f0e7985342bd1b$var$Buffer.alloc && $b4f0e7985342bd1b$var$Buffer.allocUnsafe && $b4f0e7985342bd1b$var$Buffer.allocUnsafeSlow) module.exports = $N0o3H;
else {
    // Copy properties from require('buffer')
    $b4f0e7985342bd1b$var$copyProps($N0o3H, module.exports);
    module.exports.Buffer = $b4f0e7985342bd1b$var$SafeBuffer;
}
function $b4f0e7985342bd1b$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $b4f0e7985342bd1b$var$Buffer(arg, encodingOrOffset, length);
}
$b4f0e7985342bd1b$var$SafeBuffer.prototype = Object.create($b4f0e7985342bd1b$var$Buffer.prototype);
// Copy static methods from Buffer
$b4f0e7985342bd1b$var$copyProps($b4f0e7985342bd1b$var$Buffer, $b4f0e7985342bd1b$var$SafeBuffer);
$b4f0e7985342bd1b$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $b4f0e7985342bd1b$var$Buffer(arg, encodingOrOffset, length);
};
$b4f0e7985342bd1b$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $b4f0e7985342bd1b$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$b4f0e7985342bd1b$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $b4f0e7985342bd1b$var$Buffer(size);
};
$b4f0e7985342bd1b$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $N0o3H.SlowBuffer(size);
};

});

parcelRegister("8qB41", function(module, exports) {

var $fq3eW = parcelRequire("fq3eW");
var $0195610a82554809$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
module.exports = $fq3eW($0195610a82554809$var$ALPHABET);

});
parcelRegister("fq3eW", function(module, exports) {
"use strict";

var $fx8YU = parcelRequire("fx8YU");
var $b39bcc183b73bed5$require$_Buffer = $fx8YU.Buffer;
function $b39bcc183b73bed5$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (Array.isArray(source) || source instanceof Uint8Array) source = $b39bcc183b73bed5$require$_Buffer.from(source);
        if (!$b39bcc183b73bed5$require$_Buffer.isBuffer(source)) throw new TypeError("Expected Buffer");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return $b39bcc183b73bed5$require$_Buffer.alloc(0);
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(psz < source.length){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = $b39bcc183b73bed5$require$_Buffer.allocUnsafe(zeroes + (size - it4));
        vch.fill(0x00, 0, zeroes);
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
module.exports = $b39bcc183b73bed5$var$base;

});


parcelRegister("5SUiI", function(module, exports) {

$parcel$export(module.exports, "TextEncoder", () => $448dab12e5c687b3$export$88fb0cfd153261a7, (v) => $448dab12e5c687b3$export$88fb0cfd153261a7 = v);
$parcel$export(module.exports, "TextDecoder", () => $448dab12e5c687b3$export$9c6b53e35bc51b5c, (v) => $448dab12e5c687b3$export$9c6b53e35bc51b5c = v);
var $448dab12e5c687b3$export$88fb0cfd153261a7;
var $448dab12e5c687b3$export$9c6b53e35bc51b5c;
"use strict";
// This is free and unencumbered software released into the public domain.
// See LICENSE.md for more information.
//
// Utilities
//
/**
 * @param {number} a The number to test.
 * @param {number} min The minimum value in the range, inclusive.
 * @param {number} max The maximum value in the range, inclusive.
 * @return {boolean} True if a >= min and a <= max.
 */ function $448dab12e5c687b3$var$inRange(a, min, max) {
    return min <= a && a <= max;
}
/**
 * @param {*} o
 * @return {Object}
 */ function $448dab12e5c687b3$var$ToDictionary(o) {
    if (o === undefined) return {};
    if (o === Object(o)) return o;
    throw TypeError("Could not convert argument to dictionary");
}
/**
 * @param {string} string Input string of UTF-16 code units.
 * @return {!Array.<number>} Code points.
 */ function $448dab12e5c687b3$var$stringToCodePoints(string) {
    // https://heycam.github.io/webidl/#dfn-obtain-unicode
    // 1. Let S be the DOMString value.
    var s = String(string);
    // 2. Let n be the length of S.
    var n = s.length;
    // 3. Initialize i to 0.
    var i = 0;
    // 4. Initialize U to be an empty sequence of Unicode characters.
    var u = [];
    // 5. While i < n:
    while(i < n){
        // 1. Let c be the code unit in S at index i.
        var c = s.charCodeAt(i);
        // 2. Depending on the value of c:
        // c < 0xD800 or c > 0xDFFF
        if (c < 0xD800 || c > 0xDFFF) // Append to U the Unicode character with code point c.
        u.push(c);
        else if (0xDC00 <= c && c <= 0xDFFF) // Append to U a U+FFFD REPLACEMENT CHARACTER.
        u.push(0xFFFD);
        else if (0xD800 <= c && c <= 0xDBFF) {
            // 1. If i = n−1, then append to U a U+FFFD REPLACEMENT
            // CHARACTER.
            if (i === n - 1) u.push(0xFFFD);
            else {
                // 1. Let d be the code unit in S at index i+1.
                var d = string.charCodeAt(i + 1);
                // 2. If 0xDC00 ≤ d ≤ 0xDFFF, then:
                if (0xDC00 <= d && d <= 0xDFFF) {
                    // 1. Let a be c & 0x3FF.
                    var a = c & 0x3FF;
                    // 2. Let b be d & 0x3FF.
                    var b = d & 0x3FF;
                    // 3. Append to U the Unicode character with code point
                    // 2^16+2^10*a+b.
                    u.push(0x10000 + (a << 10) + b);
                    // 4. Set i to i+1.
                    i += 1;
                } else u.push(0xFFFD);
            }
        }
        // 3. Set i to i+1.
        i += 1;
    }
    // 6. Return U.
    return u;
}
/**
 * @param {!Array.<number>} code_points Array of code points.
 * @return {string} string String of UTF-16 code units.
 */ function $448dab12e5c687b3$var$codePointsToString(code_points) {
    var s = "";
    for(var i = 0; i < code_points.length; ++i){
        var cp = code_points[i];
        if (cp <= 0xFFFF) s += String.fromCharCode(cp);
        else {
            cp -= 0x10000;
            s += String.fromCharCode((cp >> 10) + 0xD800, (cp & 0x3FF) + 0xDC00);
        }
    }
    return s;
}
//
// Implementation of Encoding specification
// https://encoding.spec.whatwg.org/
//
//
// 3. Terminology
//
/**
 * End-of-stream is a special token that signifies no more tokens
 * are in the stream.
 * @const
 */ var $448dab12e5c687b3$var$end_of_stream = -1;
/**
 * A stream represents an ordered sequence of tokens.
 *
 * @constructor
 * @param {!(Array.<number>|Uint8Array)} tokens Array of tokens that provide the
 * stream.
 */ function $448dab12e5c687b3$var$Stream(tokens) {
    /** @type {!Array.<number>} */ this.tokens = [].slice.call(tokens);
}
$448dab12e5c687b3$var$Stream.prototype = {
    /**
   * @return {boolean} True if end-of-stream has been hit.
   */ endOfStream: function() {
        return !this.tokens.length;
    },
    /**
   * When a token is read from a stream, the first token in the
   * stream must be returned and subsequently removed, and
   * end-of-stream must be returned otherwise.
   *
   * @return {number} Get the next token from the stream, or
   * end_of_stream.
   */ read: function() {
        if (!this.tokens.length) return $448dab12e5c687b3$var$end_of_stream;
        return this.tokens.shift();
    },
    /**
   * When one or more tokens are prepended to a stream, those tokens
   * must be inserted, in given order, before the first token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The token(s) to prepend to the stream.
   */ prepend: function(token) {
        if (Array.isArray(token)) {
            var tokens = /**@type {!Array.<number>}*/ token;
            while(tokens.length)this.tokens.unshift(tokens.pop());
        } else this.tokens.unshift(token);
    },
    /**
   * When one or more tokens are pushed to a stream, those tokens
   * must be inserted, in given order, after the last token in the
   * stream.
   *
   * @param {(number|!Array.<number>)} token The tokens(s) to prepend to the stream.
   */ push: function(token) {
        if (Array.isArray(token)) {
            var tokens = /**@type {!Array.<number>}*/ token;
            while(tokens.length)this.tokens.push(tokens.shift());
        } else this.tokens.push(token);
    }
};
//
// 4. Encodings
//
// 4.1 Encoders and decoders
/** @const */ var $448dab12e5c687b3$var$finished = -1;
/**
 * @param {boolean} fatal If true, decoding errors raise an exception.
 * @param {number=} opt_code_point Override the standard fallback code point.
 * @return {number} The code point to insert on a decoding error.
 */ function $448dab12e5c687b3$var$decoderError(fatal, opt_code_point) {
    if (fatal) throw TypeError("Decoder error");
    return opt_code_point || 0xFFFD;
}
//
// 7. API
//
/** @const */ var $448dab12e5c687b3$var$DEFAULT_ENCODING = "utf-8";
// 7.1 Interface TextDecoder
/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */ function $448dab12e5c687b3$var$TextDecoder(encoding, options) {
    if (!(this instanceof $448dab12e5c687b3$var$TextDecoder)) return new $448dab12e5c687b3$var$TextDecoder(encoding, options);
    encoding = encoding !== undefined ? String(encoding).toLowerCase() : $448dab12e5c687b3$var$DEFAULT_ENCODING;
    if (encoding !== $448dab12e5c687b3$var$DEFAULT_ENCODING) throw new Error("Encoding not supported. Only utf-8 is supported");
    options = $448dab12e5c687b3$var$ToDictionary(options);
    /** @private @type {boolean} */ this._streaming = false;
    /** @private @type {boolean} */ this._BOMseen = false;
    /** @private @type {?Decoder} */ this._decoder = null;
    /** @private @type {boolean} */ this._fatal = Boolean(options["fatal"]);
    /** @private @type {boolean} */ this._ignoreBOM = Boolean(options["ignoreBOM"]);
    Object.defineProperty(this, "encoding", {
        value: "utf-8"
    });
    Object.defineProperty(this, "fatal", {
        value: this._fatal
    });
    Object.defineProperty(this, "ignoreBOM", {
        value: this._ignoreBOM
    });
}
$448dab12e5c687b3$var$TextDecoder.prototype = {
    /**
   * @param {ArrayBufferView=} input The buffer of bytes to decode.
   * @param {Object=} options
   * @return {string} The decoded string.
   */ decode: function decode(input, options) {
        var bytes;
        if (typeof input === "object" && input instanceof ArrayBuffer) bytes = new Uint8Array(input);
        else if (typeof input === "object" && "buffer" in input && input.buffer instanceof ArrayBuffer) bytes = new Uint8Array(input.buffer, input.byteOffset, input.byteLength);
        else bytes = new Uint8Array(0);
        options = $448dab12e5c687b3$var$ToDictionary(options);
        if (!this._streaming) {
            this._decoder = new $448dab12e5c687b3$var$UTF8Decoder({
                fatal: this._fatal
            });
            this._BOMseen = false;
        }
        this._streaming = Boolean(options["stream"]);
        var input_stream = new $448dab12e5c687b3$var$Stream(bytes);
        var code_points = [];
        /** @type {?(number|!Array.<number>)} */ var result;
        while(!input_stream.endOfStream()){
            result = this._decoder.handler(input_stream, input_stream.read());
            if (result === $448dab12e5c687b3$var$finished) break;
            if (result === null) continue;
            if (Array.isArray(result)) code_points.push.apply(code_points, /**@type {!Array.<number>}*/ result);
            else code_points.push(result);
        }
        if (!this._streaming) {
            do {
                result = this._decoder.handler(input_stream, input_stream.read());
                if (result === $448dab12e5c687b3$var$finished) break;
                if (result === null) continue;
                if (Array.isArray(result)) code_points.push.apply(code_points, /**@type {!Array.<number>}*/ result);
                else code_points.push(result);
            }while (!input_stream.endOfStream());
            this._decoder = null;
        }
        if (code_points.length) // If encoding is one of utf-8, utf-16be, and utf-16le, and
        // ignore BOM flag and BOM seen flag are unset, run these
        // subsubsteps:
        {
            if ([
                "utf-8"
            ].indexOf(this.encoding) !== -1 && !this._ignoreBOM && !this._BOMseen) {
                // If token is U+FEFF, set BOM seen flag.
                if (code_points[0] === 0xFEFF) {
                    this._BOMseen = true;
                    code_points.shift();
                } else // Otherwise, if token is not end-of-stream, set BOM seen
                // flag and append token to output.
                this._BOMseen = true;
            }
        }
        return $448dab12e5c687b3$var$codePointsToString(code_points);
    }
};
// 7.2 Interface TextEncoder
/**
 * @constructor
 * @param {string=} encoding The label of the encoding;
 *     defaults to 'utf-8'.
 * @param {Object=} options
 */ function $448dab12e5c687b3$var$TextEncoder(encoding, options) {
    if (!(this instanceof $448dab12e5c687b3$var$TextEncoder)) return new $448dab12e5c687b3$var$TextEncoder(encoding, options);
    encoding = encoding !== undefined ? String(encoding).toLowerCase() : $448dab12e5c687b3$var$DEFAULT_ENCODING;
    if (encoding !== $448dab12e5c687b3$var$DEFAULT_ENCODING) throw new Error("Encoding not supported. Only utf-8 is supported");
    options = $448dab12e5c687b3$var$ToDictionary(options);
    /** @private @type {boolean} */ this._streaming = false;
    /** @private @type {?Encoder} */ this._encoder = null;
    /** @private @type {{fatal: boolean}} */ this._options = {
        fatal: Boolean(options["fatal"])
    };
    Object.defineProperty(this, "encoding", {
        value: "utf-8"
    });
}
$448dab12e5c687b3$var$TextEncoder.prototype = {
    /**
   * @param {string=} opt_string The string to encode.
   * @param {Object=} options
   * @return {Uint8Array} Encoded bytes, as a Uint8Array.
   */ encode: function encode(opt_string, options) {
        opt_string = opt_string ? String(opt_string) : "";
        options = $448dab12e5c687b3$var$ToDictionary(options);
        // NOTE: This option is nonstandard. None of the encodings
        // permitted for encoding (i.e. UTF-8, UTF-16) are stateful,
        // so streaming is not necessary.
        if (!this._streaming) this._encoder = new $448dab12e5c687b3$var$UTF8Encoder(this._options);
        this._streaming = Boolean(options["stream"]);
        var bytes = [];
        var input_stream = new $448dab12e5c687b3$var$Stream($448dab12e5c687b3$var$stringToCodePoints(opt_string));
        /** @type {?(number|!Array.<number>)} */ var result;
        while(!input_stream.endOfStream()){
            result = this._encoder.handler(input_stream, input_stream.read());
            if (result === $448dab12e5c687b3$var$finished) break;
            if (Array.isArray(result)) bytes.push.apply(bytes, /**@type {!Array.<number>}*/ result);
            else bytes.push(result);
        }
        if (!this._streaming) {
            while(true){
                result = this._encoder.handler(input_stream, input_stream.read());
                if (result === $448dab12e5c687b3$var$finished) break;
                if (Array.isArray(result)) bytes.push.apply(bytes, /**@type {!Array.<number>}*/ result);
                else bytes.push(result);
            }
            this._encoder = null;
        }
        return new Uint8Array(bytes);
    }
};
//
// 8. The encoding
//
// 8.1 utf-8
/**
 * @constructor
 * @implements {Decoder}
 * @param {{fatal: boolean}} options
 */ function $448dab12e5c687b3$var$UTF8Decoder(options) {
    var fatal = options.fatal;
    // utf-8's decoder's has an associated utf-8 code point, utf-8
    // bytes seen, and utf-8 bytes needed (all initially 0), a utf-8
    // lower boundary (initially 0x80), and a utf-8 upper boundary
    // (initially 0xBF).
    var /** @type {number} */ utf8_code_point = 0, /** @type {number} */ utf8_bytes_seen = 0, /** @type {number} */ utf8_bytes_needed = 0, /** @type {number} */ utf8_lower_boundary = 0x80, /** @type {number} */ utf8_upper_boundary = 0xBF;
    /**
   * @param {Stream} stream The stream of bytes being decoded.
   * @param {number} bite The next byte read from the stream.
   * @return {?(number|!Array.<number>)} The next code point(s)
   *     decoded, or null if not enough data exists in the input
   *     stream to decode a complete code point.
   */ this.handler = function(stream, bite) {
        // 1. If byte is end-of-stream and utf-8 bytes needed is not 0,
        // set utf-8 bytes needed to 0 and return error.
        if (bite === $448dab12e5c687b3$var$end_of_stream && utf8_bytes_needed !== 0) {
            utf8_bytes_needed = 0;
            return $448dab12e5c687b3$var$decoderError(fatal);
        }
        // 2. If byte is end-of-stream, return finished.
        if (bite === $448dab12e5c687b3$var$end_of_stream) return $448dab12e5c687b3$var$finished;
        // 3. If utf-8 bytes needed is 0, based on byte:
        if (utf8_bytes_needed === 0) {
            // 0x00 to 0x7F
            if ($448dab12e5c687b3$var$inRange(bite, 0x00, 0x7F)) // Return a code point whose value is byte.
            return bite;
            // 0xC2 to 0xDF
            if ($448dab12e5c687b3$var$inRange(bite, 0xC2, 0xDF)) {
                // Set utf-8 bytes needed to 1 and utf-8 code point to byte
                // − 0xC0.
                utf8_bytes_needed = 1;
                utf8_code_point = bite - 0xC0;
            } else if ($448dab12e5c687b3$var$inRange(bite, 0xE0, 0xEF)) {
                // 1. If byte is 0xE0, set utf-8 lower boundary to 0xA0.
                if (bite === 0xE0) utf8_lower_boundary = 0xA0;
                // 2. If byte is 0xED, set utf-8 upper boundary to 0x9F.
                if (bite === 0xED) utf8_upper_boundary = 0x9F;
                // 3. Set utf-8 bytes needed to 2 and utf-8 code point to
                // byte − 0xE0.
                utf8_bytes_needed = 2;
                utf8_code_point = bite - 0xE0;
            } else if ($448dab12e5c687b3$var$inRange(bite, 0xF0, 0xF4)) {
                // 1. If byte is 0xF0, set utf-8 lower boundary to 0x90.
                if (bite === 0xF0) utf8_lower_boundary = 0x90;
                // 2. If byte is 0xF4, set utf-8 upper boundary to 0x8F.
                if (bite === 0xF4) utf8_upper_boundary = 0x8F;
                // 3. Set utf-8 bytes needed to 3 and utf-8 code point to
                // byte − 0xF0.
                utf8_bytes_needed = 3;
                utf8_code_point = bite - 0xF0;
            } else // Return error.
            return $448dab12e5c687b3$var$decoderError(fatal);
            // Then (byte is in the range 0xC2 to 0xF4) set utf-8 code
            // point to utf-8 code point << (6 × utf-8 bytes needed) and
            // return continue.
            utf8_code_point = utf8_code_point << 6 * utf8_bytes_needed;
            return null;
        }
        // 4. If byte is not in the range utf-8 lower boundary to utf-8
        // upper boundary, run these substeps:
        if (!$448dab12e5c687b3$var$inRange(bite, utf8_lower_boundary, utf8_upper_boundary)) {
            // 1. Set utf-8 code point, utf-8 bytes needed, and utf-8
            // bytes seen to 0, set utf-8 lower boundary to 0x80, and set
            // utf-8 upper boundary to 0xBF.
            utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
            utf8_lower_boundary = 0x80;
            utf8_upper_boundary = 0xBF;
            // 2. Prepend byte to stream.
            stream.prepend(bite);
            // 3. Return error.
            return $448dab12e5c687b3$var$decoderError(fatal);
        }
        // 5. Set utf-8 lower boundary to 0x80 and utf-8 upper boundary
        // to 0xBF.
        utf8_lower_boundary = 0x80;
        utf8_upper_boundary = 0xBF;
        // 6. Increase utf-8 bytes seen by one and set utf-8 code point
        // to utf-8 code point + (byte − 0x80) << (6 × (utf-8 bytes
        // needed − utf-8 bytes seen)).
        utf8_bytes_seen += 1;
        utf8_code_point += bite - 0x80 << 6 * (utf8_bytes_needed - utf8_bytes_seen);
        // 7. If utf-8 bytes seen is not equal to utf-8 bytes needed,
        // continue.
        if (utf8_bytes_seen !== utf8_bytes_needed) return null;
        // 8. Let code point be utf-8 code point.
        var code_point = utf8_code_point;
        // 9. Set utf-8 code point, utf-8 bytes needed, and utf-8 bytes
        // seen to 0.
        utf8_code_point = utf8_bytes_needed = utf8_bytes_seen = 0;
        // 10. Return a code point whose value is code point.
        return code_point;
    };
}
/**
 * @constructor
 * @implements {Encoder}
 * @param {{fatal: boolean}} options
 */ function $448dab12e5c687b3$var$UTF8Encoder(options) {
    var fatal = options.fatal;
    /**
   * @param {Stream} stream Input stream.
   * @param {number} code_point Next code point read from the stream.
   * @return {(number|!Array.<number>)} Byte(s) to emit.
   */ this.handler = function(stream, code_point) {
        // 1. If code point is end-of-stream, return finished.
        if (code_point === $448dab12e5c687b3$var$end_of_stream) return $448dab12e5c687b3$var$finished;
        // 2. If code point is in the range U+0000 to U+007F, return a
        // byte whose value is code point.
        if ($448dab12e5c687b3$var$inRange(code_point, 0x0000, 0x007f)) return code_point;
        // 3. Set count and offset based on the range code point is in:
        var count, offset;
        // U+0080 to U+07FF:    1 and 0xC0
        if ($448dab12e5c687b3$var$inRange(code_point, 0x0080, 0x07FF)) {
            count = 1;
            offset = 0xC0;
        } else if ($448dab12e5c687b3$var$inRange(code_point, 0x0800, 0xFFFF)) {
            count = 2;
            offset = 0xE0;
        } else if ($448dab12e5c687b3$var$inRange(code_point, 0x10000, 0x10FFFF)) {
            count = 3;
            offset = 0xF0;
        }
        // 4.Let bytes be a byte sequence whose first byte is (code
        // point >> (6 × count)) + offset.
        var bytes = [
            (code_point >> 6 * count) + offset
        ];
        // 5. Run these substeps while count is greater than 0:
        while(count > 0){
            // 1. Set temp to code point >> (6 × (count − 1)).
            var temp = code_point >> 6 * (count - 1);
            // 2. Append to bytes 0x80 | (temp & 0x3F).
            bytes.push(0x80 | temp & 0x3F);
            // 3. Decrease count by one.
            count -= 1;
        }
        // 6. Return bytes bytes, in order.
        return bytes;
    };
}
$448dab12e5c687b3$export$88fb0cfd153261a7 = $448dab12e5c687b3$var$TextEncoder;
$448dab12e5c687b3$export$9c6b53e35bc51b5c = $448dab12e5c687b3$var$TextDecoder;

});

parcelRegister("3Xv2M", function(module, exports) {

$parcel$export(module.exports, "wNAF", () => wNAF);
$parcel$export(module.exports, "validateBasic", () => validateBasic);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Abelian group utilities

var $cJ5fp = parcelRequire("cJ5fp");

var $5hs45 = parcelRequire("5hs45");
const _0n = BigInt(0);
const _1n = BigInt(1);
function wNAF(c, bits) {
    const constTimeNegate = (condition, item)=>{
        const neg = item.negate();
        return condition ? neg : item;
    };
    const opts = (W)=>{
        const windows = Math.ceil(bits / W) + 1; // +1, because
        const windowSize = 2 ** (W - 1); // -1 because we skip zero
        return {
            windows: windows,
            windowSize: windowSize
        };
    };
    return {
        constTimeNegate: constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder (elm, n) {
            let p = c.ZERO;
            let d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows, windowSize } = opts(W);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows, windowSize } = opts(W);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p: p,
                f: f
            };
        },
        wNAFCached (P, precomputesMap, n, transform) {
            // @ts-ignore
            const W = P._WINDOW_SIZE || 1;
            // Calculate precomputes on a first run, reuse them after
            let comp = precomputesMap.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) precomputesMap.set(P, transform(comp));
            }
            return this.wNAF(W, comp, n);
        }
    };
}
function validateBasic(curve) {
    (0, $cJ5fp.validateField)(curve.Fp);
    (0, $5hs45.validateObject)(curve, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    // Set defaults
    return Object.freeze({
        ...(0, $cJ5fp.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}

});
parcelRegister("cJ5fp", function(module, exports) {

$parcel$export(module.exports, "mod", () => $943dc20e3183188f$export$842a2cf37af977e1);
$parcel$export(module.exports, "pow", () => $943dc20e3183188f$export$9c297f60e22e3389);
$parcel$export(module.exports, "pow2", () => $943dc20e3183188f$export$fa569bd808b67eef);
$parcel$export(module.exports, "isNegativeLE", () => $943dc20e3183188f$export$7806f13ad5078b2f);
$parcel$export(module.exports, "validateField", () => $943dc20e3183188f$export$bd454f0cef11418d);
$parcel$export(module.exports, "nLength", () => $943dc20e3183188f$export$c79df43ecd7e66c2);
$parcel$export(module.exports, "Field", () => $943dc20e3183188f$export$a455218a85c89869);
$parcel$export(module.exports, "FpSqrtEven", () => $943dc20e3183188f$export$1d7b691df0888e02);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Utilities for modular arithmetics and finite fields

var $5hs45 = parcelRequire("5hs45");
// prettier-ignore
const $943dc20e3183188f$var$_0n = BigInt(0), $943dc20e3183188f$var$_1n = BigInt(1), $943dc20e3183188f$var$_2n = BigInt(2), $943dc20e3183188f$var$_3n = BigInt(3);
// prettier-ignore
const $943dc20e3183188f$var$_4n = BigInt(4), $943dc20e3183188f$var$_5n = BigInt(5), $943dc20e3183188f$var$_8n = BigInt(8);
// prettier-ignore
const $943dc20e3183188f$var$_9n = BigInt(9), $943dc20e3183188f$var$_16n = BigInt(16);
function $943dc20e3183188f$export$842a2cf37af977e1(a, b) {
    const result = a % b;
    return result >= $943dc20e3183188f$var$_0n ? result : b + result;
}
function $943dc20e3183188f$export$9c297f60e22e3389(num, power, modulo) {
    if (modulo <= $943dc20e3183188f$var$_0n || power < $943dc20e3183188f$var$_0n) throw new Error("Expected power/modulo > 0");
    if (modulo === $943dc20e3183188f$var$_1n) return $943dc20e3183188f$var$_0n;
    let res = $943dc20e3183188f$var$_1n;
    while(power > $943dc20e3183188f$var$_0n){
        if (power & $943dc20e3183188f$var$_1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= $943dc20e3183188f$var$_1n;
    }
    return res;
}
function $943dc20e3183188f$export$fa569bd808b67eef(x, power, modulo) {
    let res = x;
    while(power-- > $943dc20e3183188f$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
function $943dc20e3183188f$export$6897c284b6f9f4dc(number, modulo) {
    if (number === $943dc20e3183188f$var$_0n || modulo <= $943dc20e3183188f$var$_0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $943dc20e3183188f$export$842a2cf37af977e1(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $943dc20e3183188f$var$_0n, y = $943dc20e3183188f$var$_1n, u = $943dc20e3183188f$var$_1n, v = $943dc20e3183188f$var$_0n;
    while(a !== $943dc20e3183188f$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $943dc20e3183188f$var$_1n) throw new Error("invert: does not exist");
    return $943dc20e3183188f$export$842a2cf37af977e1(x, modulo);
}
function $943dc20e3183188f$export$69f29ab1f3e9a234(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - $943dc20e3183188f$var$_1n) / $943dc20e3183188f$var$_2n;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - $943dc20e3183188f$var$_1n, S = 0; Q % $943dc20e3183188f$var$_2n === $943dc20e3183188f$var$_0n; Q /= $943dc20e3183188f$var$_2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = $943dc20e3183188f$var$_2n; Z < P && $943dc20e3183188f$export$9c297f60e22e3389(Z, legendreC, P) !== P - $943dc20e3183188f$var$_1n; Z++);
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + $943dc20e3183188f$var$_1n) / $943dc20e3183188f$var$_4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + $943dc20e3183188f$var$_1n) / $943dc20e3183188f$var$_2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error("Cannot find square root");
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, $943dc20e3183188f$var$_1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
function $943dc20e3183188f$export$33bda048c6b8ea7d(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % $943dc20e3183188f$var$_4n === $943dc20e3183188f$var$_3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + $943dc20e3183188f$var$_1n) / $943dc20e3183188f$var$_4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % $943dc20e3183188f$var$_8n === $943dc20e3183188f$var$_5n) {
        const c1 = (P - $943dc20e3183188f$var$_5n) / $943dc20e3183188f$var$_8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, $943dc20e3183188f$var$_2n);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, $943dc20e3183188f$var$_2n), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    $943dc20e3183188f$var$_9n;
    // Other cases: Tonelli-Shanks algorithm
    return $943dc20e3183188f$export$69f29ab1f3e9a234(P);
}
const $943dc20e3183188f$export$7806f13ad5078b2f = (num, modulo)=>($943dc20e3183188f$export$842a2cf37af977e1(num, modulo) & $943dc20e3183188f$var$_1n) === $943dc20e3183188f$var$_1n;
// prettier-ignore
const $943dc20e3183188f$var$FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $943dc20e3183188f$export$bd454f0cef11418d(field) {
    const initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    const opts = $943dc20e3183188f$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = "function";
        return map;
    }, initial);
    return (0, $5hs45.validateObject)(field, opts);
}
function $943dc20e3183188f$export$5d8ce3717733a987(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < $943dc20e3183188f$var$_0n) throw new Error("Expected power > 0");
    if (power === $943dc20e3183188f$var$_0n) return f.ONE;
    if (power === $943dc20e3183188f$var$_1n) return num;
    let p = f.ONE;
    let d = num;
    while(power > $943dc20e3183188f$var$_0n){
        if (power & $943dc20e3183188f$var$_1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= $943dc20e3183188f$var$_1n;
    }
    return p;
}
function $943dc20e3183188f$export$a492e3387142c0e9(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
function $943dc20e3183188f$export$e74c665040343df6(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === "bigint" ? $943dc20e3183188f$export$6897c284b6f9f4dc(rhs, f.ORDER) : f.inv(rhs));
}
function $943dc20e3183188f$export$5e2b6e87f2891ea7(f) {
    const legendreConst = (f.ORDER - $943dc20e3183188f$var$_1n) / $943dc20e3183188f$var$_2n; // Integer arithmetic
    return (x)=>{
        const p = f.pow(x, legendreConst);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
function $943dc20e3183188f$export$c79df43ecd7e66c2(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
function $943dc20e3183188f$export$a455218a85c89869(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= $943dc20e3183188f$var$_0n) throw new Error(`Expected Field ORDER > 0, got ${ORDER}`);
    const { nBitLength: BITS, nByteLength: BYTES } = $943dc20e3183188f$export$c79df43ecd7e66c2(ORDER, bitLen);
    if (BYTES > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
    const sqrtP = $943dc20e3183188f$export$33bda048c6b8ea7d(ORDER);
    const f = Object.freeze({
        ORDER: ORDER,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $5hs45.bitMask)(BITS),
        ZERO: $943dc20e3183188f$var$_0n,
        ONE: $943dc20e3183188f$var$_1n,
        create: (num)=>$943dc20e3183188f$export$842a2cf37af977e1(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== "bigint") throw new Error(`Invalid field element: expected bigint, got ${typeof num}`);
            return $943dc20e3183188f$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $943dc20e3183188f$var$_0n,
        isOdd: (num)=>(num & $943dc20e3183188f$var$_1n) === $943dc20e3183188f$var$_1n,
        neg: (num)=>$943dc20e3183188f$export$842a2cf37af977e1(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$943dc20e3183188f$export$842a2cf37af977e1(num * num, ORDER),
        add: (lhs, rhs)=>$943dc20e3183188f$export$842a2cf37af977e1(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$943dc20e3183188f$export$842a2cf37af977e1(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$943dc20e3183188f$export$842a2cf37af977e1(lhs * rhs, ORDER),
        pow: (num, power)=>$943dc20e3183188f$export$5d8ce3717733a987(f, num, power),
        div: (lhs, rhs)=>$943dc20e3183188f$export$842a2cf37af977e1(lhs * $943dc20e3183188f$export$6897c284b6f9f4dc(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$943dc20e3183188f$export$6897c284b6f9f4dc(num, ORDER),
        sqrt: redef.sqrt || ((n)=>sqrtP(f, n)),
        invertBatch: (lst)=>$943dc20e3183188f$export$a492e3387142c0e9(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE ? (0, $5hs45.numberToBytesLE)(num, BYTES) : (0, $5hs45.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error(`Fp.fromBytes: expected ${BYTES}, got ${bytes.length}`);
            return isLE ? (0, $5hs45.bytesToNumberLE)(bytes) : (0, $5hs45.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
function $943dc20e3183188f$export$7acc54692c525d2a(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
function $943dc20e3183188f$export$1d7b691df0888e02(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
function $943dc20e3183188f$export$d3b0e8260d5dbad4(hash, groupOrder, isLE = false) {
    hash = (0, $5hs45.ensureBytes)("privateHash", hash);
    const hashLen = hash.length;
    const minLen = $943dc20e3183188f$export$c79df43ecd7e66c2(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error(`hashToPrivateScalar: expected ${minLen}-1024 bytes of input, got ${hashLen}`);
    const num = isLE ? (0, $5hs45.bytesToNumberLE)(hash) : (0, $5hs45.bytesToNumberBE)(hash);
    return $943dc20e3183188f$export$842a2cf37af977e1(num, groupOrder - $943dc20e3183188f$var$_1n) + $943dc20e3183188f$var$_1n;
}
function $943dc20e3183188f$export$9cf21a9392b0fcfc(fieldOrder) {
    if (typeof fieldOrder !== "bigint") throw new Error("field order must be bigint");
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
function $943dc20e3183188f$export$d058763b563056af(fieldOrder) {
    const length = $943dc20e3183188f$export$9cf21a9392b0fcfc(fieldOrder);
    return length + Math.ceil(length / 2);
}
function $943dc20e3183188f$export$20cb21dbfa61dac3(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = $943dc20e3183188f$export$9cf21a9392b0fcfc(fieldOrder);
    const minLen = $943dc20e3183188f$export$d058763b563056af(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error(`expected ${minLen}-1024 bytes of input, got ${len}`);
    const num = isLE ? (0, $5hs45.bytesToNumberBE)(key) : (0, $5hs45.bytesToNumberLE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = $943dc20e3183188f$export$842a2cf37af977e1(num, fieldOrder - $943dc20e3183188f$var$_1n) + $943dc20e3183188f$var$_1n;
    return isLE ? (0, $5hs45.numberToBytesLE)(reduced, fieldLen) : (0, $5hs45.numberToBytesBE)(reduced, fieldLen);
}

});
parcelRegister("5hs45", function(module, exports) {

$parcel$export(module.exports, "isBytes", () => $3d844f5f0da1d795$export$c6fabfbfd097fc30);
$parcel$export(module.exports, "bytesToHex", () => $3d844f5f0da1d795$export$58b867e287a802c8);
$parcel$export(module.exports, "bytesToNumberBE", () => $3d844f5f0da1d795$export$d609354794974f8);
$parcel$export(module.exports, "bytesToNumberLE", () => $3d844f5f0da1d795$export$d67b1d03392107e7);
$parcel$export(module.exports, "numberToBytesBE", () => $3d844f5f0da1d795$export$1459dafd057611cb);
$parcel$export(module.exports, "numberToBytesLE", () => $3d844f5f0da1d795$export$ba2172e58d139f6d);
$parcel$export(module.exports, "ensureBytes", () => $3d844f5f0da1d795$export$3cb5d50a3a30e837);
$parcel$export(module.exports, "concatBytes", () => $3d844f5f0da1d795$export$287dd7971339c972);
$parcel$export(module.exports, "equalBytes", () => $3d844f5f0da1d795$export$2aa59cef064b0333);
$parcel$export(module.exports, "utf8ToBytes", () => $3d844f5f0da1d795$export$3df70a15530b5e81);
$parcel$export(module.exports, "bitMask", () => $3d844f5f0da1d795$export$803efa2fa1c7279);
$parcel$export(module.exports, "validateObject", () => $3d844f5f0da1d795$export$381bae2d0f08004f);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const $3d844f5f0da1d795$var$_0n = BigInt(0);
const $3d844f5f0da1d795$var$_1n = BigInt(1);
const $3d844f5f0da1d795$var$_2n = BigInt(2);
function $3d844f5f0da1d795$export$c6fabfbfd097fc30(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const $3d844f5f0da1d795$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $3d844f5f0da1d795$export$58b867e287a802c8(bytes) {
    if (!$3d844f5f0da1d795$export$c6fabfbfd097fc30(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $3d844f5f0da1d795$var$hexes[bytes[i]];
    return hex;
}
function $3d844f5f0da1d795$export$4ed2545b622827c1(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
function $3d844f5f0da1d795$export$d57f2bacc26b4249(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    // Big Endian
    return BigInt(hex === "" ? "0" : `0x${hex}`);
}
// We use optimized technique to convert hex string to byte array
const $3d844f5f0da1d795$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $3d844f5f0da1d795$var$asciiToBase16(char) {
    if (char >= $3d844f5f0da1d795$var$asciis._0 && char <= $3d844f5f0da1d795$var$asciis._9) return char - $3d844f5f0da1d795$var$asciis._0;
    if (char >= $3d844f5f0da1d795$var$asciis._A && char <= $3d844f5f0da1d795$var$asciis._F) return char - ($3d844f5f0da1d795$var$asciis._A - 10);
    if (char >= $3d844f5f0da1d795$var$asciis._a && char <= $3d844f5f0da1d795$var$asciis._f) return char - ($3d844f5f0da1d795$var$asciis._a - 10);
    return;
}
function $3d844f5f0da1d795$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $3d844f5f0da1d795$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $3d844f5f0da1d795$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
function $3d844f5f0da1d795$export$d609354794974f8(bytes) {
    return $3d844f5f0da1d795$export$d57f2bacc26b4249($3d844f5f0da1d795$export$58b867e287a802c8(bytes));
}
function $3d844f5f0da1d795$export$d67b1d03392107e7(bytes) {
    if (!$3d844f5f0da1d795$export$c6fabfbfd097fc30(bytes)) throw new Error("Uint8Array expected");
    return $3d844f5f0da1d795$export$d57f2bacc26b4249($3d844f5f0da1d795$export$58b867e287a802c8(Uint8Array.from(bytes).reverse()));
}
function $3d844f5f0da1d795$export$1459dafd057611cb(n, len) {
    return $3d844f5f0da1d795$export$31c96b9df38bc8d4(n.toString(16).padStart(len * 2, "0"));
}
function $3d844f5f0da1d795$export$ba2172e58d139f6d(n, len) {
    return $3d844f5f0da1d795$export$1459dafd057611cb(n, len).reverse();
}
function $3d844f5f0da1d795$export$80ee8c1914de6dde(n) {
    return $3d844f5f0da1d795$export$31c96b9df38bc8d4($3d844f5f0da1d795$export$4ed2545b622827c1(n));
}
function $3d844f5f0da1d795$export$3cb5d50a3a30e837(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = $3d844f5f0da1d795$export$31c96b9df38bc8d4(hex);
    } catch (e) {
        throw new Error(`${title} must be valid hex string, got "${hex}". Cause: ${e}`);
    }
    else if ($3d844f5f0da1d795$export$c6fabfbfd097fc30(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(`${title} must be hex string or Uint8Array`);
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(`${title} expected ${expectedLength} bytes, got ${len}`);
    return res;
}
function $3d844f5f0da1d795$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        if (!$3d844f5f0da1d795$export$c6fabfbfd097fc30(a)) throw new Error("Uint8Array expected");
        sum += a.length;
    }
    let res = new Uint8Array(sum);
    let pad = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
function $3d844f5f0da1d795$export$2aa59cef064b0333(a, b) {
    if (a.length !== b.length) return false;
    let diff = 0;
    for(let i = 0; i < a.length; i++)diff |= a[i] ^ b[i];
    return diff === 0;
}
function $3d844f5f0da1d795$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $3d844f5f0da1d795$export$e93ef600c41761a9(n) {
    let len;
    for(len = 0; n > $3d844f5f0da1d795$var$_0n; n >>= $3d844f5f0da1d795$var$_1n, len += 1);
    return len;
}
function $3d844f5f0da1d795$export$9577d112d1fd46ad(n, pos) {
    return n >> BigInt(pos) & $3d844f5f0da1d795$var$_1n;
}
const $3d844f5f0da1d795$export$967bb2b9787441cb = (n, pos, value)=>{
    return n | (value ? $3d844f5f0da1d795$var$_1n : $3d844f5f0da1d795$var$_0n) << BigInt(pos);
};
const $3d844f5f0da1d795$export$803efa2fa1c7279 = (n)=>($3d844f5f0da1d795$var$_2n << BigInt(n - 1)) - $3d844f5f0da1d795$var$_1n;
// DRBG
const $3d844f5f0da1d795$var$u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const $3d844f5f0da1d795$var$u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
function $3d844f5f0da1d795$export$d459d139192e4fba(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = $3d844f5f0da1d795$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = $3d844f5f0da1d795$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = $3d844f5f0da1d795$var$u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($3d844f5f0da1d795$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($3d844f5f0da1d795$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $3d844f5f0da1d795$export$287dd7971339c972(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
// Validating curves and fields
const $3d844f5f0da1d795$var$validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    stringOrUint8Array: (val)=>typeof val === "string" || $3d844f5f0da1d795$export$c6fabfbfd097fc30(val),
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
function $3d844f5f0da1d795$export$381bae2d0f08004f(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $3d844f5f0da1d795$var$validatorFns[type];
        if (typeof checkVal !== "function") throw new Error(`Invalid validator "${type}", expected function`);
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error(`Invalid param ${String(fieldName)}=${val} (${typeof val}), expected ${type}`);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
} // validate type tests
 // const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
 // const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
 // // Should fail type-check
 // const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
 // const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
 // const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
 // const z4 = validateObject(o, { a: 'boolean', z: 'bug' });

});



parcelRegister("fWaEd", function(module, exports) {
/* UAParser.js v1.0.38
   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
   MIT License */ (function(window1, undefined) {
    "use strict";
    var LIBVERSION = "1.0.38", EMPTY = "", UNKNOWN = "?", FUNC_TYPE = "function", UNDEF_TYPE = "undefined", OBJ_TYPE = "object", STR_TYPE = "string", MAJOR = "major", MODEL = "model", NAME = "name", TYPE = "type", VENDOR = "vendor", VERSION = "version", ARCHITECTURE = "architecture", CONSOLE = "console", MOBILE = "mobile", TABLET = "tablet", SMARTTV = "smarttv", WEARABLE = "wearable", EMBEDDED = "embedded", UA_MAX_LENGTH = 500;
    var AMAZON = "Amazon", APPLE = "Apple", ASUS = "ASUS", BLACKBERRY = "BlackBerry", BROWSER = "Browser", CHROME = "Chrome", EDGE = "Edge", FIREFOX = "Firefox", GOOGLE = "Google", HUAWEI = "Huawei", LG = "LG", MICROSOFT = "Microsoft", MOTOROLA = "Motorola", OPERA = "Opera", SAMSUNG = "Samsung", SHARP = "Sharp", SONY = "Sony", XIAOMI = "Xiaomi", ZEBRA = "Zebra", FACEBOOK = "Facebook", CHROMIUM_OS = "Chromium OS", MAC_OS = "Mac OS";
    var extend = function(regexes, extensions) {
        var mergedRegexes = {};
        for(var i in regexes)if (extensions[i] && extensions[i].length % 2 === 0) mergedRegexes[i] = extensions[i].concat(regexes[i]);
        else mergedRegexes[i] = regexes[i];
        return mergedRegexes;
    }, enumerize = function(arr) {
        var enums = {};
        for(var i = 0; i < arr.length; i++)enums[arr[i].toUpperCase()] = arr[i];
        return enums;
    }, has = function(str1, str2) {
        return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
    }, lowerize = function(str) {
        return str.toLowerCase();
    }, majorize = function(version) {
        return typeof version === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split(".")[0] : undefined;
    }, trim = function(str, len) {
        if (typeof str === STR_TYPE) {
            str = str.replace(/^\s\s*/, EMPTY);
            return typeof len === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
        }
    };
    var rgxMapper = function(ua, arrays) {
        var i = 0, j, k, p, q, matches, match;
        while(i < arrays.length && !matches){
            var regex = arrays[i], props = arrays[i + 1];
            j = k = 0;
            while(j < regex.length && !matches){
                if (!regex[j]) break;
                matches = regex[j++].exec(ua);
                if (!!matches) for(p = 0; p < props.length; p++){
                    match = matches[++k];
                    q = props[p];
                    if (typeof q === OBJ_TYPE && q.length > 0) {
                        if (q.length === 2) {
                            if (typeof q[1] == FUNC_TYPE) this[q[0]] = q[1].call(this, match);
                            else this[q[0]] = q[1];
                        } else if (q.length === 3) {
                            if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                            else this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                        } else if (q.length === 4) this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                    } else this[q] = match ? match : undefined;
                }
            }
            i += 2;
        }
    }, strMapper = function(str, map) {
        for(var i in map){
            if (typeof map[i] === OBJ_TYPE && map[i].length > 0) for(var j = 0; j < map[i].length; j++){
                if (has(map[i][j], str)) return i === UNKNOWN ? undefined : i;
            }
            else if (has(map[i], str)) return i === UNKNOWN ? undefined : i;
        }
        return str;
    };
    var oldSafariMap = {
        "1.0": "/8",
        1.2: "/1",
        1.3: "/3",
        "2.0": "/412",
        "2.0.2": "/416",
        "2.0.3": "/417",
        "2.0.4": "/419",
        "?": "/"
    }, windowsVersionMap = {
        ME: "4.90",
        "NT 3.11": "NT3.51",
        "NT 4.0": "NT4.0",
        2e3: "NT 5.0",
        XP: [
            "NT 5.1",
            "NT 5.2"
        ],
        Vista: "NT 6.0",
        7: "NT 6.1",
        8: "NT 6.2",
        8.1: "NT 6.3",
        10: [
            "NT 6.4",
            "NT 10.0"
        ],
        RT: "ARM"
    };
    var regexes = {
        browser: [
            [
                /\b(?:crmo|crios)\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Chrome"
                ]
            ],
            [
                /edg(?:e|ios|a)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Edge"
                ]
            ],
            [
                /(opera mini)\/([-\w\.]+)/i,
                /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
                /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /opios[\/ ]+([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Mini"
                ]
            ],
            [
                /\bop(?:rg)?x\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " GX"
                ]
            ],
            [
                /\bopr\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA
                ]
            ],
            [
                /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Baidu"
                ]
            ],
            [
                /(kindle)\/([\w\.]+)/i,
                /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
                /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
                /(?:ms|\()(ie) ([\w\.]+)/i,
                /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
                /(heytap|ovi)browser\/([\d\.]+)/i,
                /(weibo)__([\d\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bddg\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "DuckDuckGo"
                ]
            ],
            [
                /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "UC" + BROWSER
                ]
            ],
            [
                /microm.+\bqbcore\/([\w\.]+)/i,
                /\bqbcore\/([\w\.]+).+microm/i,
                /micromessenger\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "WeChat"
                ]
            ],
            [
                /konqueror\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Konqueror"
                ]
            ],
            [
                /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "IE"
                ]
            ],
            [
                /ya(?:search)?browser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Yandex"
                ]
            ],
            [
                /slbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Smart Lenovo " + BROWSER
                ]
            ],
            [
                /(avast|avg)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 Secure " + BROWSER
                ],
                VERSION
            ],
            [
                /\bfocus\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Focus"
                ]
            ],
            [
                /\bopt\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Touch"
                ]
            ],
            [
                /coc_coc\w+\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Coc Coc"
                ]
            ],
            [
                /dolfin\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Dolphin"
                ]
            ],
            [
                /coast\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    OPERA + " Coast"
                ]
            ],
            [
                /miuibrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "MIUI " + BROWSER
                ]
            ],
            [
                /fxios\/([-\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX
                ]
            ],
            [
                /\bqihu|(qi?ho?o?|360)browser/i
            ],
            [
                [
                    NAME,
                    "360 " + BROWSER
                ]
            ],
            [
                /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /(.+)/,
                    "$1 " + BROWSER
                ],
                VERSION
            ],
            [
                /samsungbrowser\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    SAMSUNG + " Internet"
                ]
            ],
            [
                /(comodo_dragon)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    /_/g,
                    " "
                ],
                VERSION
            ],
            [
                /metasr[\/ ]?([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Sogou Explorer"
                ]
            ],
            [
                /(sogou)mo\w+\/([\d\.]+)/i
            ],
            [
                [
                    NAME,
                    "Sogou Mobile"
                ],
                VERSION
            ],
            [
                /(electron)\/([\w\.]+) safari/i,
                /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
                /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(lbbrowser)/i,
                /\[(linkedin)app\]/i
            ],
            [
                NAME
            ],
            [
                /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
            ],
            [
                [
                    NAME,
                    FACEBOOK
                ],
                VERSION
            ],
            [
                /(Klarna)\/([\w\.]+)/i,
                /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
                /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
                /safari (line)\/([\w\.]+)/i,
                /\b(line)\/([\w\.]+)\/iab/i,
                /(alipay)client\/([\w\.]+)/i,
                /(twitter)(?:and| f.+e\/([\w\.]+))/i,
                /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\bgsa\/([\w\.]+) .*safari\//i
            ],
            [
                VERSION,
                [
                    NAME,
                    "GSA"
                ]
            ],
            [
                /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "TikTok"
                ]
            ],
            [
                /headlesschrome(?:\/([\w\.]+)| )/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + " Headless"
                ]
            ],
            [
                / wv\).+(chrome)\/([\w\.]+)/i
            ],
            [
                [
                    NAME,
                    CHROME + " WebView"
                ],
                VERSION
            ],
            [
                /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Android " + BROWSER
                ]
            ],
            [
                /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Mobile Safari"
                ]
            ],
            [
                /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    oldSafariMap
                ]
            ],
            [
                /(webkit|khtml)\/([\w\.]+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(navigator|netscape\d?)\/([-\w\.]+)/i
            ],
            [
                [
                    NAME,
                    "Netscape"
                ],
                VERSION
            ],
            [
                /mobile vr; rv:([\w\.]+)\).+firefox/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " Reality"
                ]
            ],
            [
                /ekiohf.+(flow)\/([\w\.]+)/i,
                /(swiftfox)/i,
                /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
                /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
                /(firefox)\/([\w\.]+)/i,
                /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
                /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
                /(links) \(([\w\.]+)/i,
                /panasonic;(viera)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(cobalt)\/([\w\.]+)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    /master.|lts./,
                    ""
                ]
            ]
        ],
        cpu: [
            [
                /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "amd64"
                ]
            ],
            [
                /(ia32(?=;))/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ],
            [
                /((?:i[346]|x)86)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "ia32"
                ]
            ],
            [
                /\b(aarch64|arm(v?8e?l?|_?64))\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm64"
                ]
            ],
            [
                /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
            ],
            [
                [
                    ARCHITECTURE,
                    "armhf"
                ]
            ],
            [
                /windows (ce|mobile); ppc;/i
            ],
            [
                [
                    ARCHITECTURE,
                    "arm"
                ]
            ],
            [
                /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
            ],
            [
                [
                    ARCHITECTURE,
                    /ower/,
                    EMPTY,
                    lowerize
                ]
            ],
            [
                /(sun4\w)[;\)]/i
            ],
            [
                [
                    ARCHITECTURE,
                    "sparc"
                ]
            ],
            [
                /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
            ],
            [
                [
                    ARCHITECTURE,
                    lowerize
                ]
            ]
        ],
        device: [
            [
                /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
                /samsung[- ]([-\w]+)/i,
                /sec-(sgh\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\((ipad);[-\w\),; ]+apple/i,
                /applecoremedia\/[\w\.]+ \((ipad)/i,
                /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(macintosh);/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ]
            ],
            [
                /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:huawei|honor)([-\w ]+)[;\)]/i,
                /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    HUAWEI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
                /\b; (\w+) build\/hm\1/i,
                /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
                /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
                /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
                /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
                /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /; (\w+) bui.+ oppo/i,
                /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(opd2\d{3}a?) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OPPO"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /vivo (\w+)(?: bui|\))/i,
                /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Vivo"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Realme"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
                /\bmot(?:orola)?[- ](\w*)/i,
                /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(mz60\d|xoom[2 ]{0,2}) build\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MOTOROLA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
                /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
                /\blg-?([\d\w]+) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(ideatab[-\w ]+)/i,
                /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Lenovo"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(?:maemo|nokia).*(n900|lumia \d+)/i,
                /nokia[-_ ]?([-\w\.]*)/i
            ],
            [
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    VENDOR,
                    "Nokia"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(pixel c)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /sony tablet [ps]/i,
                /\b(?:sony)?sgp\w+(?: bui|\))/i
            ],
            [
                [
                    MODEL,
                    "Xperia Tablet"
                ],
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (kb2005|in20[12]5|be20[12][59])\b/i,
                /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "OnePlus"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(alexa)webm/i,
                /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
                /(kf[a-z]+)( bui|\)).+silk\//i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
            ],
            [
                [
                    MODEL,
                    /(.+)/g,
                    "Fire Phone $1"
                ],
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(playbook);[-\w\),; ]+(rim)/i
            ],
            [
                MODEL,
                VENDOR,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((?:bb[a-f]|st[hv])100-\d)/i,
                /\(bb10; (\w+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    BLACKBERRY
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ASUS
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(nexus 9)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "HTC"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
                /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
                /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    /_/g,
                    " "
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Acer"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (m[1-5] note) bui/i,
                /\bmz-([-\w]{2,})/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Meizu"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Ulefone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
                /(hp) ([\w ]+\w)/i,
                /(asus)-?(\w+)/i,
                /(microsoft); (lumia[\w ]+)/i,
                /(lenovo)[-_ ]?([-\w]+)/i,
                /(jolla)/i,
                /(oppo) ?([\w ]+) bui/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kobo)\s(ereader|touch)/i,
                /(archos) (gamepad2?)/i,
                /(hp).+(touchpad(?!.+tablet)|tablet)/i,
                /(kindle)\/([\w\.]+)/i,
                /(nook)[\w ]+build\/(\w+)/i,
                /(dell) (strea[kpr\d ]*[\dko])/i,
                /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
                /(trinity)[- ]*(t\d{3}) bui/i,
                /(gigaset)[- ]+(q\w{1,9}) bui/i,
                /(vodafone) ([\w ]+)(?:\)| bui)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(surface duo)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid [\d\.]+; (fp\du?)(?: b|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Fairphone"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(u304aa)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "AT&T"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\bsie-(\w*)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Siemens"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(rct\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "RCA"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(venue[\d ]{2,7}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Dell"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(q(?:mv|ta)\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Verizon"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Barnes & Noble"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(tm\d{3}\w+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NuVision"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(k88) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(nx\d{3}j) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "ZTE"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(gen\d{3}) b.+49h/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(zur\d{3}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Swiss"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((zeki)?tb.*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Zeki"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b([yr]\d{2}) b/i,
                /\b(dragon[- ]+touch |dt)(\w{5}) b/i
            ],
            [
                [
                    VENDOR,
                    "Dragon Touch"
                ],
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(ns-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Insignia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((nxa|next)-?\w{0,9}) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "NextBook"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
            ],
            [
                [
                    VENDOR,
                    "Voice"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(lvtel\-)?(v1[12]) b/i
            ],
            [
                [
                    VENDOR,
                    "LvTel"
                ],
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(ph-1) /i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Essential"
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /\b(v(100md|700na|7011|917g).*\b) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Envizen"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b(trio[-\w\. ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "MachSpeed"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\btu_(1491) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Rotor"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(shield[\w ]+) b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(sprint) (\w+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(kin\.[onetw]{3})/i
            ],
            [
                [
                    MODEL,
                    /\./g,
                    " "
                ],
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /smart-tv.+(samsung)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /hbbtv.+maple;(\d+)/i
            ],
            [
                [
                    MODEL,
                    /^/,
                    "SmartTV"
                ],
                [
                    VENDOR,
                    SAMSUNG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
            ],
            [
                [
                    VENDOR,
                    LG
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(apple) ?tv/i
            ],
            [
                VENDOR,
                [
                    MODEL,
                    APPLE + " TV"
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /crkey/i
            ],
            [
                [
                    MODEL,
                    CHROME + "cast"
                ],
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /droid.+aft(\w+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\(dtv[\);].+(aquos)/i,
                /(aquos-tv[\w ]+)\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SHARP
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(bravia[\w ]+)( bui|\))/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(mitv-\w{5}) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    XIAOMI
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /Hbbtv.*(technisat) (.*);/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
                /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
            ],
            [
                [
                    VENDOR,
                    trim
                ],
                [
                    MODEL,
                    trim
                ],
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
            ],
            [
                [
                    TYPE,
                    SMARTTV
                ]
            ],
            [
                /(ouya)/i,
                /(nintendo) ([wids3utch]+)/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /droid.+; (shield) bui/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Nvidia"
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /(playstation [345portablevi]+)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    SONY
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /\b(xbox(?: one)?(?!; xbox))[\); ]/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    MICROSOFT
                ],
                [
                    TYPE,
                    CONSOLE
                ]
            ],
            [
                /((pebble))app/i
            ],
            [
                VENDOR,
                MODEL,
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    APPLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (glass) \d/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    GOOGLE
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /droid.+; (wt63?0{2,3})\)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    ZEBRA
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(quest( \d| pro)?)/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    FACEBOOK
                ],
                [
                    TYPE,
                    WEARABLE
                ]
            ],
            [
                /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
            ],
            [
                VENDOR,
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /(aeobc)\b/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    AMAZON
                ],
                [
                    TYPE,
                    EMBEDDED
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
            ],
            [
                MODEL,
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
            ],
            [
                [
                    TYPE,
                    TABLET
                ]
            ],
            [
                /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
            ],
            [
                [
                    TYPE,
                    MOBILE
                ]
            ],
            [
                /(android[-\w\. ]{0,9});.+buil/i
            ],
            [
                MODEL,
                [
                    VENDOR,
                    "Generic"
                ]
            ]
        ],
        engine: [
            [
                /windows.+ edge\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    EDGE + "HTML"
                ]
            ],
            [
                /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Blink"
                ]
            ],
            [
                /(presto)\/([\w\.]+)/i,
                /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
                /ekioh(flow)\/([\w\.]+)/i,
                /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
                /(icab)[\/ ]([23]\.[\d\.]+)/i,
                /\b(libweb)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /rv\:([\w\.]{1,9})\b.+(gecko)/i
            ],
            [
                VERSION,
                NAME
            ]
        ],
        os: [
            [
                /microsoft (windows) (vista|xp)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i
            ],
            [
                NAME,
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ]
            ],
            [
                /windows nt 6\.2; (arm)/i,
                /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
                /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
            ],
            [
                [
                    VERSION,
                    strMapper,
                    windowsVersionMap
                ],
                [
                    NAME,
                    "Windows"
                ]
            ],
            [
                /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
                /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
                /cfnetwork\/.+darwin/i
            ],
            [
                [
                    VERSION,
                    /_/g,
                    "."
                ],
                [
                    NAME,
                    "iOS"
                ]
            ],
            [
                /(mac os x) ?([\w\. ]*)/i,
                /(macintosh|mac_powerpc\b)(?!.+haiku)/i
            ],
            [
                [
                    NAME,
                    MAC_OS
                ],
                [
                    VERSION,
                    /_/g,
                    "."
                ]
            ],
            [
                /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
            ],
            [
                VERSION,
                NAME
            ],
            [
                /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
                /(blackberry)\w*\/([\w\.]*)/i,
                /(tizen|kaios)[\/ ]([\w\.]+)/i,
                /\((series40);/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /\(bb(10);/i
            ],
            [
                VERSION,
                [
                    NAME,
                    BLACKBERRY
                ]
            ],
            [
                /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "Symbian"
                ]
            ],
            [
                /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    FIREFOX + " OS"
                ]
            ],
            [
                /web0s;.+rt(tv)/i,
                /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "webOS"
                ]
            ],
            [
                /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    "watchOS"
                ]
            ],
            [
                /crkey\/([\d\.]+)/i
            ],
            [
                VERSION,
                [
                    NAME,
                    CHROME + "cast"
                ]
            ],
            [
                /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
            ],
            [
                [
                    NAME,
                    CHROMIUM_OS
                ],
                VERSION
            ],
            [
                /panasonic;(viera)/i,
                /(netrange)mmh/i,
                /(nettv)\/(\d+\.[\w\.]+)/i,
                /(nintendo|playstation) ([wids345portablevuch]+)/i,
                /(xbox); +xbox ([^\);]+)/i,
                /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
                /(mint)[\/\(\) ]?(\w*)/i,
                /(mageia|vectorlinux)[; ]/i,
                /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
                /(hurd|linux) ?([\w\.]*)/i,
                /(gnu) ?([\w\.]*)/i,
                /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
                /(haiku) (\w+)/i
            ],
            [
                NAME,
                VERSION
            ],
            [
                /(sunos) ?([\w\.\d]*)/i
            ],
            [
                [
                    NAME,
                    "Solaris"
                ],
                VERSION
            ],
            [
                /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
                /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
                /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
                /(unix) ?([\w\.]*)/i
            ],
            [
                NAME,
                VERSION
            ]
        ]
    };
    var UAParser = function(ua, extensions) {
        if (typeof ua === OBJ_TYPE) {
            extensions = ua;
            ua = undefined;
        }
        if (!(this instanceof UAParser)) return new UAParser(ua, extensions).getResult();
        var _navigator = typeof window1 !== UNDEF_TYPE && window1.navigator ? window1.navigator : undefined;
        var _ua = ua || (_navigator && _navigator.userAgent ? _navigator.userAgent : EMPTY);
        var _uach = _navigator && _navigator.userAgentData ? _navigator.userAgentData : undefined;
        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
        var _isSelfNav = _navigator && _navigator.userAgent == _ua;
        this.getBrowser = function() {
            var _browser = {};
            _browser[NAME] = undefined;
            _browser[VERSION] = undefined;
            rgxMapper.call(_browser, _ua, _rgxmap.browser);
            _browser[MAJOR] = majorize(_browser[VERSION]);
            if (_isSelfNav && _navigator && _navigator.brave && typeof _navigator.brave.isBrave == FUNC_TYPE) _browser[NAME] = "Brave";
            return _browser;
        };
        this.getCPU = function() {
            var _cpu = {};
            _cpu[ARCHITECTURE] = undefined;
            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
            return _cpu;
        };
        this.getDevice = function() {
            var _device = {};
            _device[VENDOR] = undefined;
            _device[MODEL] = undefined;
            _device[TYPE] = undefined;
            rgxMapper.call(_device, _ua, _rgxmap.device);
            if (_isSelfNav && !_device[TYPE] && _uach && _uach.mobile) _device[TYPE] = MOBILE;
            if (_isSelfNav && _device[MODEL] == "Macintosh" && _navigator && typeof _navigator.standalone !== UNDEF_TYPE && _navigator.maxTouchPoints && _navigator.maxTouchPoints > 2) {
                _device[MODEL] = "iPad";
                _device[TYPE] = TABLET;
            }
            return _device;
        };
        this.getEngine = function() {
            var _engine = {};
            _engine[NAME] = undefined;
            _engine[VERSION] = undefined;
            rgxMapper.call(_engine, _ua, _rgxmap.engine);
            return _engine;
        };
        this.getOS = function() {
            var _os = {};
            _os[NAME] = undefined;
            _os[VERSION] = undefined;
            rgxMapper.call(_os, _ua, _rgxmap.os);
            if (_isSelfNav && !_os[NAME] && _uach && _uach.platform && _uach.platform != "Unknown") _os[NAME] = _uach.platform.replace(/chrome os/i, CHROMIUM_OS).replace(/macos/i, MAC_OS);
            return _os;
        };
        this.getResult = function() {
            return {
                ua: this.getUA(),
                browser: this.getBrowser(),
                engine: this.getEngine(),
                os: this.getOS(),
                device: this.getDevice(),
                cpu: this.getCPU()
            };
        };
        this.getUA = function() {
            return _ua;
        };
        this.setUA = function(ua) {
            _ua = typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH ? trim(ua, UA_MAX_LENGTH) : ua;
            return this;
        };
        this.setUA(_ua);
        return this;
    };
    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = enumerize([
        NAME,
        VERSION,
        MAJOR
    ]);
    UAParser.CPU = enumerize([
        ARCHITECTURE
    ]);
    UAParser.DEVICE = enumerize([
        MODEL,
        VENDOR,
        TYPE,
        CONSOLE,
        MOBILE,
        SMARTTV,
        TABLET,
        WEARABLE,
        EMBEDDED
    ]);
    UAParser.ENGINE = UAParser.OS = enumerize([
        NAME,
        VERSION
    ]);
    if ("object" !== UNDEF_TYPE) {
        if ("object" !== UNDEF_TYPE && module.exports) exports = module.exports = UAParser;
        exports.UAParser = UAParser;
    } else {
        if (typeof define === FUNC_TYPE && define.amd) define(function() {
            return UAParser;
        });
        else if (typeof window1 !== UNDEF_TYPE) window1.UAParser = UAParser;
    }
    var $ = typeof window1 !== UNDEF_TYPE && (window1.jQuery || window1.Zepto);
    if ($ && !$.ua) {
        var parser = new UAParser;
        $.ua = parser.getResult();
        $.ua.get = function() {
            return parser.getUA();
        };
        $.ua.set = function(ua) {
            parser.setUA(ua);
            var result = parser.getResult();
            for(var prop in result)$.ua[prop] = result[prop];
        };
    }
})(typeof window === "object" ? window : this);

});

var $f815b414dd8f027b$exports = {};


(parcelRequire("kI8SP")).register((parcelRequire("hIarR")).getBundleURL("kBjr5"), JSON.parse('["kBjr5","index.js","buD0f","ccip.26889787.js","b4FhE","dist.f44ed809.js","hb191","index.es.7e5b57ee.js","2vOmz","dist.6e72bd68.js","7YPdS","dist.3b84c6d4.js","5TkG7","ArbitrumLogo.4a7518b6.svg","1VWPR","AvalancheLogo.ad53a0d0.svg","jSuZ4","BaseLogo.e87313d9.svg","8r44P","BAT.1212afba.svg","jr0lb","BNBLogo.3dada3dc.svg","78tXH","BTCLogo.5558c6c7.svg","38YWW","BUSDLogo.a70524b3.svg","al97R","CardanoLogo.c8e54c54.svg","b3h67","DashLogo.ac107e85.svg","4IKGO","Doge.9d700487.png","7r7Es","DogeLogo.58faeab6.svg","kte2d","DOT.7e599be5.svg","iBuJ2","EthLogo.13b90052.svg","bXZhj","LitecoinLogo.f8fad246.svg","82wNV","PolygonLogo.dda6f433.svg","hKcHM","Solana.3c790cbc.svg","iyW2y","TetherLogo.6d30f474.svg","8Oqrs","TronLogo.a023c6a9.svg","lYs6O","USDCLogo.08b3a902.svg","gULzZ","VerseLogo.e24b56c2.png","hnVq4","XMRLogo.26608d9e.svg","khYAC","ZcashLogo.5ee68c2f.svg","42CoM","EUROCLogo.e814427f.svg","fLpOR","FRAXLogo.493412e4.svg","kHFkX","DaiLogo.5b7d885d.svg","d6nnl","WETH.6226dbd9.svg","dpQD8","GeminiLogo.5cbba47e.png","iw9so","TORLogo.bd732ad4.svg","e7BeT","TUSDLogo.df934baa.svg","98hKm","USDPLogo.d2d050af.svg","gGkw7","TetherGoldLogo.5d02ace7.svg","4BogB","PRQLogo.ef7c079b.svg","dzesg","PAXGLogo.2d9a097a.svg","3lZaJ","MIMLogo.ea9454b3.svg","gmXbJ","FantomLogo.59ea410b.svg","IShhZ","WrappedBitcoin.a9abc558.svg","45Yui","DAIKLogo.7aa105ad.png","kPjSf","ETHKLogo.b79115fc.png","aNwUM","BTCKLogo.9770427e.png","lcoI1","WOKTLogo.2376971f.png","fqCZx","OKBLogo.8b0e77b3.png","4R09F","Wave.2a680c9e.svg","eWxYR","Wave2.22db6b94.svg","lmTuT","Wave3.ea6ec40e.svg","3q3DB","index.css"]'));

var $13f4c0370d7de649$exports = {};
"use strict";

$13f4c0370d7de649$exports = (parcelRequire("lsosV"));


parcelRequire("8NFma");
var $503937b663c395c4$export$882461b6382ed46c;
var $503937b663c395c4$export$757ceba2d55c277e;
"use strict";
var $1c0f1e610963dfb8$exports = {};
"use strict";
function $1c0f1e610963dfb8$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    var err;
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error("^_^");
}

$1c0f1e610963dfb8$exports = (parcelRequire("2bY7F"));


var $503937b663c395c4$var$i = $1c0f1e610963dfb8$exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
$503937b663c395c4$export$882461b6382ed46c = function(c, o) {
    $503937b663c395c4$var$i.usingClientEntryPoint = true;
    try {
        return $1c0f1e610963dfb8$exports.createRoot(c, o);
    } finally{
        $503937b663c395c4$var$i.usingClientEntryPoint = false;
    }
};
$503937b663c395c4$export$757ceba2d55c277e = function(c, h, o) {
    $503937b663c395c4$var$i.usingClientEntryPoint = true;
    try {
        return $1c0f1e610963dfb8$exports.hydrateRoot(c, h, o);
    } finally{
        $503937b663c395c4$var$i.usingClientEntryPoint = false;
    }
};


// src/queryClient.ts
// src/utils.ts
var $3546908fef5186ce$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $3546908fef5186ce$export$8793edee2d425525() {
    return void 0;
}
function $3546908fef5186ce$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $3546908fef5186ce$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $3546908fef5186ce$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $3546908fef5186ce$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $3546908fef5186ce$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$3546908fef5186ce$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $3546908fef5186ce$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($3546908fef5186ce$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $3546908fef5186ce$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$3546908fef5186ce$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $3546908fef5186ce$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = options?.queryKeyHashFn || $3546908fef5186ce$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $3546908fef5186ce$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$3546908fef5186ce$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $3546908fef5186ce$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!$3546908fef5186ce$export$2f07189bb9fa26a7(a[key], b[key]));
    return false;
}
function $3546908fef5186ce$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $3546908fef5186ce$export$7a8558113332b71e(a) && $3546908fef5186ce$export$7a8558113332b71e(b);
    if (array || $3546908fef5186ce$export$53b83ca8eaab0383(a) && $3546908fef5186ce$export$53b83ca8eaab0383(b)) {
        const aItems = array ? a : Object.keys(a);
        const aSize = aItems.length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            if ((!array && aItems.includes(key) || array) && a[key] === void 0 && b[key] === void 0) {
                copy[key] = void 0;
                equalItems++;
            } else {
                copy[key] = $3546908fef5186ce$export$77a71fc411098696(a[key], b[key]);
                if (copy[key] === a[key] && a[key] !== void 0) equalItems++;
            }
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
function $3546908fef5186ce$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $3546908fef5186ce$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $3546908fef5186ce$export$53b83ca8eaab0383(o) {
    if (!$3546908fef5186ce$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!$3546908fef5186ce$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (Object.getPrototypeOf(o) !== Object.prototype) return false;
    return true;
}
function $3546908fef5186ce$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $3546908fef5186ce$export$e772c8ff12451969(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
function $3546908fef5186ce$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) return $3546908fef5186ce$export$77a71fc411098696(prevData, data);
    return data;
}
function $3546908fef5186ce$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $3546908fef5186ce$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $3546908fef5186ce$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var $3546908fef5186ce$export$1aa5a89531b7670d = Symbol();


// src/queryCache.ts

// src/query.ts

// src/notifyManager.ts
function $e70386a3fc4a6b3f$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = (cb)=>setTimeout(cb, 0);
    const setScheduler = (fn)=>{
        scheduleFn = fn;
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction,
        setScheduler: setScheduler
    };
}
var $e70386a3fc4a6b3f$export$520687f44db6e1ab = $e70386a3fc4a6b3f$export$316a8efd03cd1458();


// src/retryer.ts
// src/focusManager.ts
// src/subscribable.ts
var $b9b70121081db01a$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};



var $afedfd80347d6cee$export$86f1af424b2ca4de = class extends (0, $b9b70121081db01a$export$d26086b469ecdbcc) {
    #focused;
    #cleanup;
    #setup;
    constructor(){
        super();
        this.#setup = (onFocus)=>{
            if (!(0, $3546908fef5186ce$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.#cleanup) this.setEventListener(this.#setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            this.#cleanup?.();
            this.#cleanup = void 0;
        }
    }
    setEventListener(setup) {
        this.#setup = setup;
        this.#cleanup?.();
        this.#cleanup = setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        const changed = this.#focused !== focused;
        if (changed) {
            this.#focused = focused;
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        if (typeof this.#focused === "boolean") return this.#focused;
        return globalThis.document?.visibilityState !== "hidden";
    }
};
var $afedfd80347d6cee$export$6bf54661be5b02cf = new $afedfd80347d6cee$export$86f1af424b2ca4de();


// src/onlineManager.ts


var $73b96c1fbdc7e9bc$export$58774fb55d5ff7fc = class extends (0, $b9b70121081db01a$export$d26086b469ecdbcc) {
    #online = true;
    #cleanup;
    #setup;
    constructor(){
        super();
        this.#setup = (onOnline)=>{
            if (!(0, $3546908fef5186ce$export$6acf61af03e62db) && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.#cleanup) this.setEventListener(this.#setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            this.#cleanup?.();
            this.#cleanup = void 0;
        }
    }
    setEventListener(setup) {
        this.#setup = setup;
        this.#cleanup?.();
        this.#cleanup = setup(this.setOnline.bind(this));
    }
    setOnline(online) {
        const changed = this.#online !== online;
        if (changed) {
            this.#online = online;
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return this.#online;
    }
};
var $73b96c1fbdc7e9bc$export$b113e788b2dd3fdc = new $73b96c1fbdc7e9bc$export$58774fb55d5ff7fc();



function $9f7cdfccbe305dca$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $9f7cdfccbe305dca$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $73b96c1fbdc7e9bc$export$b113e788b2dd3fdc).isOnline() : true;
}
var $9f7cdfccbe305dca$export$a8430ed4188f35a9 = class {
    constructor(options){
        this.revert = options?.revert;
        this.silent = options?.silent;
    }
};
function $9f7cdfccbe305dca$export$986cc6445c1d323(value) {
    return value instanceof $9f7cdfccbe305dca$export$a8430ed4188f35a9;
}
function $9f7cdfccbe305dca$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        if (!isResolved) {
            reject(new $9f7cdfccbe305dca$export$a8430ed4188f35a9(cancelOptions));
            config.abort?.();
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, $afedfd80347d6cee$export$6bf54661be5b02cf).isFocused() && (config.networkMode === "always" || (0, $73b96c1fbdc7e9bc$export$b113e788b2dd3fdc).isOnline()) && config.canRun();
    const canStart = ()=>$9f7cdfccbe305dca$export$61b92f63f30245cf(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onSuccess?.(value);
            continueFn?.();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onError?.(value);
            continueFn?.();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                if (isResolved || canContinue()) continueResolve(value);
            };
            config.onPause?.();
        }).then(()=>{
            continueFn = void 0;
            if (!isResolved) config.onContinue?.();
        });
    };
    const run = ()=>{
        if (isResolved) return;
        let promiseOrValue;
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            if (isResolved) return;
            const retry = config.retry ?? ((0, $3546908fef5186ce$export$6acf61af03e62db) ? 0 : 3);
            const retryDelay = config.retryDelay ?? $9f7cdfccbe305dca$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            config.onFail?.(failureCount, error);
            (0, $3546908fef5186ce$export$e772c8ff12451969)(delay).then(()=>{
                return canContinue() ? void 0 : pause();
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            continueFn?.();
            return promise;
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry,
        canStart: canStart,
        start: ()=>{
            if (canStart()) run();
            else pause().then(run);
            return promise;
        }
    };
}


// src/removable.ts

var $fa1d000269ec400a$export$e09608847fcc8c59 = class {
    #gcTimeout;
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $3546908fef5186ce$export$e539f754e934e270)(this.gcTime)) this.#gcTimeout = setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime);
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $3546908fef5186ce$export$6acf61af03e62db) ? Infinity : 300000));
    }
    clearGcTimeout() {
        if (this.#gcTimeout) {
            clearTimeout(this.#gcTimeout);
            this.#gcTimeout = void 0;
        }
    }
};


var $a387f8f5f7c6dea8$export$62297b13309008b2 = class extends (0, $fa1d000269ec400a$export$e09608847fcc8c59) {
    #initialState;
    #revertState;
    #cache;
    #retryer;
    #defaultOptions;
    #abortSignalConsumed;
    constructor(config){
        super();
        this.#abortSignalConsumed = false;
        this.#defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.#cache = config.cache;
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.#initialState = config.state || $a387f8f5f7c6dea8$var$getDefaultState(this.options);
        this.state = this.#initialState;
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    setOptions(options) {
        this.options = {
            ...this.#defaultOptions,
            ...options
        };
        this.updateGcTime(this.options.gcTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") this.#cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, $3546908fef5186ce$export$17619bac5b909b23)(this.state.data, newData, this.options);
        this.#dispatch({
            data: data,
            type: "success",
            dataUpdatedAt: options?.updatedAt,
            manual: options?.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.#dispatch({
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        const promise = this.#retryer?.promise;
        this.#retryer?.cancel(options);
        return promise ? promise.then((0, $3546908fef5186ce$export$8793edee2d425525)).catch((0, $3546908fef5186ce$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.#initialState);
    }
    isActive() {
        return this.observers.some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        if (this.state.isInvalidated) return true;
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0;
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || this.state.data === void 0 || !(0, $3546908fef5186ce$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        observer?.refetch({
            cancelRefetch: false
        });
        this.#retryer?.continue();
    }
    onOnline() {
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        observer?.refetch({
            cancelRefetch: false
        });
        this.#retryer?.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            this.#cache.notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                if (this.#retryer) {
                    if (this.#abortSignalConsumed) this.#retryer.cancel({
                        revert: true
                    });
                    else this.#retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.#cache.notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.#dispatch({
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        if (this.state.fetchStatus !== "idle") {
            if (this.state.data !== void 0 && fetchOptions?.cancelRefetch) this.cancel({
                silent: true
            });
            else if (this.#retryer) {
                this.#retryer.continueRetry();
                return this.#retryer.promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        if (!Array.isArray(this.options.queryKey)) console.error(`As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']`);
        const abortController = new AbortController();
        const queryFnContext = {
            queryKey: this.queryKey,
            meta: this.meta
        };
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    this.#abortSignalConsumed = true;
                    return abortController.signal;
                }
            });
        };
        addSignalProperty(queryFnContext);
        const fetchFn = ()=>{
            if (this.options.queryFn === (0, $3546908fef5186ce$export$1aa5a89531b7670d)) console.error(`Attempted to invoke queryFn when set to skipToken. This is likely a configuration error. Query hash: '${this.options.queryHash}'`);
            if (!this.options.queryFn || this.options.queryFn === (0, $3546908fef5186ce$export$1aa5a89531b7670d)) return Promise.reject(new Error(`Missing queryFn: '${this.options.queryHash}'`));
            this.#abortSignalConsumed = false;
            if (this.options.persister) return this.options.persister(this.options.queryFn, queryFnContext, this);
            return this.options.queryFn(queryFnContext);
        };
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        this.options.behavior?.onFetch(context, this);
        this.#revertState = this.state;
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== context.fetchOptions?.meta) this.#dispatch({
            type: "fetch",
            meta: context.fetchOptions?.meta
        });
        const onError = (error)=>{
            if (!((0, $9f7cdfccbe305dca$export$986cc6445c1d323)(error) && error.silent)) this.#dispatch({
                type: "error",
                error: error
            });
            if (!(0, $9f7cdfccbe305dca$export$986cc6445c1d323)(error)) {
                this.#cache.config.onError?.(error, this);
                this.#cache.config.onSettled?.(this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) this.scheduleGc();
            this.isFetchingOptimistic = false;
        };
        this.#retryer = (0, $9f7cdfccbe305dca$export$2cbd00fe8a2c8d85)({
            fn: context.fetchFn,
            abort: abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                if (data === void 0) {
                    console.error(`Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: ${this.queryHash}`);
                    onError(new Error(`${this.queryHash} data is undefined`));
                    return;
                }
                this.setData(data);
                this.#cache.config.onSuccess?.(data, this);
                this.#cache.config.onSettled?.(data, this.state.error, this);
                if (!this.isFetchingOptimistic) this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                this.#dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.#dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.#dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        });
        return this.#retryer.start();
    }
    #dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        fetchStatus: "paused"
                    };
                case "continue":
                    return {
                        ...state,
                        fetchStatus: "fetching"
                    };
                case "fetch":
                    return {
                        ...state,
                        ...$a387f8f5f7c6dea8$export$f3df9013f2b58bce(state.data, this.options),
                        fetchMeta: action.meta ?? null
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        dataUpdateCount: state.dataUpdateCount + 1,
                        dataUpdatedAt: action.dataUpdatedAt ?? Date.now(),
                        error: null,
                        isInvalidated: false,
                        status: "success",
                        ...!action.manual && {
                            fetchStatus: "idle",
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                case "error":
                    const error = action.error;
                    if ((0, $9f7cdfccbe305dca$export$986cc6445c1d323)(error) && error.revert && this.#revertState) return {
                        ...this.#revertState,
                        fetchStatus: "idle"
                    };
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: "idle",
                        status: "error"
                    };
                case "invalidate":
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $e70386a3fc4a6b3f$export$520687f44db6e1ab).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate();
            });
            this.#cache.notify({
                query: this,
                type: "updated",
                action: action
            });
        });
    }
};
function $a387f8f5f7c6dea8$export$f3df9013f2b58bce(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $9f7cdfccbe305dca$export$61b92f63f30245cf)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function $a387f8f5f7c6dea8$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}




var $2bd53a4bf00b85f8$export$5dde0cd941da8468 = class extends (0, $b9b70121081db01a$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        this.#queries = /* @__PURE__ */ new Map();
    }
    #queries;
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $3546908fef5186ce$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $a387f8f5f7c6dea8$export$62297b13309008b2)({
                cache: this,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.#queries.has(query.queryHash)) {
            this.#queries.set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = this.#queries.get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) this.#queries.delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $e70386a3fc4a6b3f$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.#queries.get(queryHash);
    }
    getAll() {
        return [
            ...this.#queries.values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $3546908fef5186ce$export$c5d1efe363797780)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $3546908fef5186ce$export$c5d1efe363797780)(filters, query)) : queries;
    }
    notify(event) {
        (0, $e70386a3fc4a6b3f$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $e70386a3fc4a6b3f$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $e70386a3fc4a6b3f$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};


// src/mutationCache.ts

// src/mutation.ts



var $970b87d0b0b90748$export$17b8b19c814bcf56 = class extends (0, $fa1d000269ec400a$export$e09608847fcc8c59) {
    #observers;
    #mutationCache;
    #retryer;
    constructor(config){
        super();
        this.mutationId = config.mutationId;
        this.#mutationCache = config.mutationCache;
        this.#observers = [];
        this.state = config.state || $970b87d0b0b90748$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!this.#observers.includes(observer)) {
            this.#observers.push(observer);
            this.clearGcTimeout();
            this.#mutationCache.notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        this.#observers = this.#observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.#mutationCache.notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.#observers.length) {
            if (this.state.status === "pending") this.scheduleGc();
            else this.#mutationCache.remove(this);
        }
    }
    continue() {
        return this.#retryer?.continue() ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        this.#retryer = (0, $9f7cdfccbe305dca$export$2cbd00fe8a2c8d85)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                return this.options.mutationFn(variables);
            },
            onFail: (failureCount, error)=>{
                this.#dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.#dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.#dispatch({
                    type: "continue"
                });
            },
            retry: this.options.retry ?? 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>this.#mutationCache.canRun(this)
        });
        const restored = this.state.status === "pending";
        const isPaused = !this.#retryer.canStart();
        try {
            if (!restored) {
                this.#dispatch({
                    type: "pending",
                    variables: variables,
                    isPaused: isPaused
                });
                await this.#mutationCache.config.onMutate?.(variables, this);
                const context = await this.options.onMutate?.(variables);
                if (context !== this.state.context) this.#dispatch({
                    type: "pending",
                    context: context,
                    variables: variables,
                    isPaused: isPaused
                });
            }
            const data = await this.#retryer.start();
            await this.#mutationCache.config.onSuccess?.(data, variables, this.state.context, this);
            await this.options.onSuccess?.(data, variables, this.state.context);
            await this.#mutationCache.config.onSettled?.(data, null, this.state.variables, this.state.context, this);
            await this.options.onSettled?.(data, null, variables, this.state.context);
            this.#dispatch({
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await this.#mutationCache.config.onError?.(error, variables, this.state.context, this);
                await this.options.onError?.(error, variables, this.state.context);
                await this.#mutationCache.config.onSettled?.(void 0, error, this.state.variables, this.state.context, this);
                await this.options.onSettled?.(void 0, error, variables, this.state.context);
                throw error;
            } finally{
                this.#dispatch({
                    type: "error",
                    error: error
                });
            }
        } finally{
            this.#mutationCache.runNext(this);
        }
    }
    #dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        isPaused: true
                    };
                case "continue":
                    return {
                        ...state,
                        isPaused: false
                    };
                case "pending":
                    return {
                        ...state,
                        context: action.context,
                        data: void 0,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: action.isPaused,
                        status: "pending",
                        variables: action.variables,
                        submittedAt: Date.now()
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: "success",
                        isPaused: false
                    };
                case "error":
                    return {
                        ...state,
                        data: void 0,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: "error"
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $e70386a3fc4a6b3f$export$520687f44db6e1ab).batch(()=>{
            this.#observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.#mutationCache.notify({
                mutation: this,
                type: "updated",
                action: action
            });
        });
    }
};
function $970b87d0b0b90748$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}




var $7c0dcf108dd53982$export$1fcfd9a244434844 = class extends (0, $b9b70121081db01a$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        this.#mutations = /* @__PURE__ */ new Map();
        this.#mutationId = Date.now();
    }
    #mutations;
    #mutationId;
    build(client, options, state) {
        const mutation = new (0, $970b87d0b0b90748$export$17b8b19c814bcf56)({
            mutationCache: this,
            mutationId: ++this.#mutationId,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        const scope = $7c0dcf108dd53982$var$scopeFor(mutation);
        const mutations = this.#mutations.get(scope) ?? [];
        mutations.push(mutation);
        this.#mutations.set(scope, mutations);
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        const scope = $7c0dcf108dd53982$var$scopeFor(mutation);
        if (this.#mutations.has(scope)) {
            const mutations = this.#mutations.get(scope)?.filter((x)=>x !== mutation);
            if (mutations) {
                if (mutations.length === 0) this.#mutations.delete(scope);
                else this.#mutations.set(scope, mutations);
            }
        }
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    canRun(mutation) {
        const firstPendingMutation = this.#mutations.get($7c0dcf108dd53982$var$scopeFor(mutation))?.find((m)=>m.state.status === "pending");
        return !firstPendingMutation || firstPendingMutation === mutation;
    }
    runNext(mutation) {
        const foundMutation = this.#mutations.get($7c0dcf108dd53982$var$scopeFor(mutation))?.find((m)=>m !== mutation && m.state.isPaused);
        return foundMutation?.continue() ?? Promise.resolve();
    }
    clear() {
        (0, $e70386a3fc4a6b3f$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return [
            ...this.#mutations.values()
        ].flat();
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((mutation)=>(0, $3546908fef5186ce$export$a1ea5fb559f63ae3)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, $3546908fef5186ce$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $e70386a3fc4a6b3f$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, $e70386a3fc4a6b3f$export$520687f44db6e1ab).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, $3546908fef5186ce$export$8793edee2d425525)))));
    }
};
function $7c0dcf108dd53982$var$scopeFor(mutation) {
    return mutation.options.scope?.id ?? String(mutation.mutationId);
}





// src/infiniteQueryBehavior.ts

function $08ba65f3338fe500$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            const fetchFn = async ()=>{
                const options = context.options;
                const direction = context.fetchOptions?.meta?.fetchMore?.direction;
                const oldPages = context.state.data?.pages || [];
                const oldPageParams = context.state.data?.pageParams || [];
                const empty = {
                    pages: [],
                    pageParams: []
                };
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            if (context.signal.aborted) cancelled = true;
                            else context.signal.addEventListener("abort", ()=>{
                                cancelled = true;
                            });
                            return context.signal;
                        }
                    });
                };
                const queryFn = context.options.queryFn && context.options.queryFn !== (0, $3546908fef5186ce$export$1aa5a89531b7670d) ? context.options.queryFn : ()=>{
                    if (context.options.queryFn === (0, $3546908fef5186ce$export$1aa5a89531b7670d)) console.error(`Attempted to invoke queryFn when set to skipToken. This is likely a configuration error. Query hash: '${context.options.queryHash}'`);
                    return Promise.reject(new Error(`Missing queryFn: '${context.options.queryHash}'`));
                };
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject();
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        direction: previous ? "backward" : "forward",
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $3546908fef5186ce$export$8c6246b73dd61f4a) : (0, $3546908fef5186ce$export$ccce65a22a26f2bc);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                let result;
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $08ba65f3338fe500$var$getPreviousPageParam : $08ba65f3338fe500$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    result = await fetchPage(empty, oldPageParams[0] ?? options.initialPageParam);
                    const remainingPages = pages ?? oldPages.length;
                    for(let i = 1; i < remainingPages; i++){
                        const param = $08ba65f3338fe500$var$getNextPageParam(options, result);
                        result = await fetchPage(result, param);
                    }
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                return context.options.persister?.(fetchFn, {
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $08ba65f3338fe500$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams);
}
function $08ba65f3338fe500$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    return options.getPreviousPageParam?.(pages[0], pages, pageParams[0], pageParams);
}
function $08ba65f3338fe500$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $08ba65f3338fe500$var$getNextPageParam(options, data) != null;
}
function $08ba65f3338fe500$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $08ba65f3338fe500$var$getPreviousPageParam(options, data) != null;
}


var $45076d1644600312$export$405d0624ed55a03f = class {
    #queryCache;
    #mutationCache;
    #defaultOptions;
    #queryDefaults;
    #mutationDefaults;
    #mountCount;
    #unsubscribeFocus;
    #unsubscribeOnline;
    constructor(config = {}){
        this.#queryCache = config.queryCache || new (0, $2bd53a4bf00b85f8$export$5dde0cd941da8468)();
        this.#mutationCache = config.mutationCache || new (0, $7c0dcf108dd53982$export$1fcfd9a244434844)();
        this.#defaultOptions = config.defaultOptions || {};
        this.#queryDefaults = /* @__PURE__ */ new Map();
        this.#mutationDefaults = /* @__PURE__ */ new Map();
        this.#mountCount = 0;
    }
    mount() {
        this.#mountCount++;
        if (this.#mountCount !== 1) return;
        this.#unsubscribeFocus = (0, $afedfd80347d6cee$export$6bf54661be5b02cf).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                this.#queryCache.onFocus();
            }
        });
        this.#unsubscribeOnline = (0, $73b96c1fbdc7e9bc$export$b113e788b2dd3fdc).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                this.#queryCache.onOnline();
            }
        });
    }
    unmount() {
        this.#mountCount--;
        if (this.#mountCount !== 0) return;
        this.#unsubscribeFocus?.();
        this.#unsubscribeFocus = void 0;
        this.#unsubscribeOnline?.();
        this.#unsubscribeOnline = void 0;
    }
    isFetching(filters) {
        return this.#queryCache.findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return this.#mutationCache.findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    getQueryData(queryKey) {
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return this.#queryCache.get(options.queryHash)?.state.data;
    }
    ensureQueryData(options) {
        const cachedData = this.getQueryData(options.queryKey);
        if (cachedData === void 0) return this.fetchQuery(options);
        else {
            const defaultedOptions = this.defaultQueryOptions(options);
            const query = this.#queryCache.build(this, defaultedOptions);
            if (options.revalidateIfStale && query.isStaleByTime(defaultedOptions.staleTime)) this.prefetchQuery(defaultedOptions);
            return Promise.resolve(cachedData);
        }
    }
    getQueriesData(filters) {
        return this.#queryCache.findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        const query = this.#queryCache.get(defaultedOptions.queryHash);
        const prevData = query?.state.data;
        const data = (0, $3546908fef5186ce$export$7f095f455ad5af3f)(updater, prevData);
        if (data === void 0) return void 0;
        return this.#queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, $e70386a3fc4a6b3f$export$520687f44db6e1ab).batch(()=>this.#queryCache.findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return this.#queryCache.get(options.queryHash)?.state;
    }
    removeQueries(filters) {
        const queryCache = this.#queryCache;
        (0, $e70386a3fc4a6b3f$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = this.#queryCache;
        const refetchFilters = {
            type: "active",
            ...filters
        };
        return (0, $e70386a3fc4a6b3f$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(filters = {}, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $e70386a3fc4a6b3f$export$520687f44db6e1ab).batch(()=>this.#queryCache.findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $3546908fef5186ce$export$8793edee2d425525)).catch((0, $3546908fef5186ce$export$8793edee2d425525));
    }
    invalidateQueries(filters = {}, options = {}) {
        return (0, $e70386a3fc4a6b3f$export$520687f44db6e1ab).batch(()=>{
            this.#queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === "none") return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: filters.refetchType ?? filters.type ?? "active"
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(filters = {}, options) {
        const fetchOptions = {
            ...options,
            cancelRefetch: options?.cancelRefetch ?? true
        };
        const promises = (0, $e70386a3fc4a6b3f$export$520687f44db6e1ab).batch(()=>this.#queryCache.findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $3546908fef5186ce$export$8793edee2d425525));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $3546908fef5186ce$export$8793edee2d425525));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = this.#queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $3546908fef5186ce$export$8793edee2d425525)).catch((0, $3546908fef5186ce$export$8793edee2d425525));
    }
    fetchInfiniteQuery(options) {
        options.behavior = (0, $08ba65f3338fe500$export$84470d1367601e8d)(options.pages);
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $3546908fef5186ce$export$8793edee2d425525)).catch((0, $3546908fef5186ce$export$8793edee2d425525));
    }
    resumePausedMutations() {
        if ((0, $73b96c1fbdc7e9bc$export$b113e788b2dd3fdc).isOnline()) return this.#mutationCache.resumePausedMutations();
        return Promise.resolve();
    }
    getQueryCache() {
        return this.#queryCache;
    }
    getMutationCache() {
        return this.#mutationCache;
    }
    getDefaultOptions() {
        return this.#defaultOptions;
    }
    setDefaultOptions(options) {
        this.#defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        this.#queryDefaults.set((0, $3546908fef5186ce$export$1e87d19d4aab5805)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...this.#queryDefaults.values()
        ];
        let result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $3546908fef5186ce$export$2f07189bb9fa26a7)(queryKey, queryDefault.queryKey)) result = {
                ...result,
                ...queryDefault.defaultOptions
            };
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        this.#mutationDefaults.set((0, $3546908fef5186ce$export$1e87d19d4aab5805)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...this.#mutationDefaults.values()
        ];
        let result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $3546908fef5186ce$export$2f07189bb9fa26a7)(mutationKey, queryDefault.mutationKey)) result = {
                ...result,
                ...queryDefault.defaultOptions
            };
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...this.#defaultOptions.queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $3546908fef5186ce$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.enabled !== true && defaultedOptions.queryFn === (0, $3546908fef5186ce$export$1aa5a89531b7670d)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options?._defaulted) return options;
        return {
            ...this.#defaultOptions.mutations,
            ...options?.mutationKey && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        this.#queryCache.clear();
        this.#mutationCache.clear();
    }
};


var $8NFma = parcelRequire("8NFma");

"use client";
var $116ae60afff0fd72$export$da112d31b0149f31 = $8NFma.createContext(void 0);
var $116ae60afff0fd72$export$22e77b9572c4fded = (queryClient)=>{
    const client = $8NFma.useContext($116ae60afff0fd72$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $116ae60afff0fd72$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $8NFma.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $13f4c0370d7de649$exports.jsx)($116ae60afff0fd72$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};




var $8NFma = parcelRequire("8NFma");



let $843b041d1ec8a53b$var$isReconnecting = false;
async function $843b041d1ec8a53b$export$f0e7018a430fa792(config, parameters = {}) {
    // If already reconnecting, do nothing
    if ($843b041d1ec8a53b$var$isReconnecting) return [];
    $843b041d1ec8a53b$var$isReconnecting = true;
    config.setState((x)=>({
            ...x,
            status: x.current ? "reconnecting" : "connecting"
        }));
    const connectors = [];
    if (parameters.connectors?.length) for (const connector_ of parameters.connectors){
        let connector;
        // "Register" connector if not already created
        if (typeof connector_ === "function") connector = config._internal.connectors.setup(connector_);
        else connector = connector_;
        connectors.push(connector);
    }
    else connectors.push(...config.connectors);
    // Try recently-used connectors first
    let recentConnectorId;
    try {
        recentConnectorId = await config.storage?.getItem("recentConnectorId");
    } catch  {}
    const scores = {};
    for (const [, connection] of config.state.connections)scores[connection.connector.id] = 1;
    if (recentConnectorId) scores[recentConnectorId] = 0;
    const sorted = Object.keys(scores).length > 0 ? [
        ...connectors
    ].sort((a, b)=>(scores[a.id] ?? 10) - (scores[b.id] ?? 10)) : connectors;
    // Iterate through each connector and try to connect
    let connected = false;
    const connections = [];
    const providers = [];
    for (const connector of sorted){
        const provider_ = await connector.getProvider();
        if (!provider_) continue;
        // If we already have an instance of this connector's provider,
        // then we have already checked it (ie. injected connectors can
        // share the same `window.ethereum` instance, so we don't want to
        // connect to it again).
        if (providers.some((provider)=>provider === provider_)) continue;
        const isAuthorized = await connector.isAuthorized();
        if (!isAuthorized) continue;
        const data = await connector.connect({
            isReconnecting: true
        }).catch(()=>null);
        if (!data) continue;
        connector.emitter.off("connect", config._internal.events.connect);
        connector.emitter.on("change", config._internal.events.change);
        connector.emitter.on("disconnect", config._internal.events.disconnect);
        config.setState((x)=>{
            const connections = new Map(connected ? x.connections : new Map()).set(connector.uid, {
                accounts: data.accounts,
                chainId: data.chainId,
                connector: connector
            });
            return {
                ...x,
                current: connected ? x.current : connector.uid,
                connections: connections
            };
        });
        connections.push({
            accounts: data.accounts,
            chainId: data.chainId,
            connector: connector
        });
        providers.push(provider_);
        connected = true;
    }
    // Prevent overwriting connected status from race condition
    if (config.state.status === "reconnecting" || config.state.status === "connecting") {
        // If connecting didn't succeed, set to disconnected
        if (!connected) config.setState((x)=>({
                ...x,
                connections: new Map(),
                current: null,
                status: "disconnected"
            }));
        else config.setState((x)=>({
                ...x,
                status: "connected"
            }));
    }
    $843b041d1ec8a53b$var$isReconnecting = false;
    return connections;
}


function $18d93c359e24ec89$export$fa8d919ba61d84db(config, parameters) {
    const { initialState: initialState, reconnectOnMount: reconnectOnMount } = parameters;
    if (initialState && !config._internal.store.persist.hasHydrated()) config.setState({
        ...initialState,
        connections: reconnectOnMount ? initialState.connections : new Map(),
        status: reconnectOnMount ? "reconnecting" : "disconnected"
    });
    return {
        async onMount () {
            if (config._internal.ssr) {
                await config._internal.store.persist.rehydrate();
                const mipdConnectors = config._internal.mipd?.getProviders().map(config._internal.connectors.providerDetailToConnector).map(config._internal.connectors.setup);
                config._internal.connectors.setState((connectors)=>[
                        ...connectors,
                        ...mipdConnectors ?? []
                    ]);
            }
            if (reconnectOnMount) (0, $843b041d1ec8a53b$export$f0e7018a430fa792)(config);
            else if (config.storage) // Reset connections that may have been hydrated from storage.
            config.setState((x)=>({
                    ...x,
                    connections: new Map()
                }));
        }
    };
}



var $8NFma = parcelRequire("8NFma");
"use client";
function $1f2b956b4247db51$export$f49feec8afe53ddd(parameters) {
    const { children: children, config: config, initialState: initialState, reconnectOnMount: reconnectOnMount = true } = parameters;
    const { onMount: onMount } = (0, $18d93c359e24ec89$export$fa8d919ba61d84db)(config, {
        initialState: initialState,
        reconnectOnMount: reconnectOnMount
    });
    // Hydrate for non-SSR
    if (!config._internal.ssr) onMount();
    // Hydrate for SSR
    const active = (0, $8NFma.useRef)(true);
    // biome-ignore lint/nursery/useExhaustiveDependencies:
    (0, $8NFma.useEffect)(()=>{
        if (!active.current) return;
        if (!config._internal.ssr) return;
        onMount();
        return ()=>{
            active.current = false;
        };
    }, []);
    return children;
}


"use client";
const $4a768efd39c3ad48$export$da7c16611087c70c = (0, $8NFma.createContext)(undefined);
function $4a768efd39c3ad48$export$a28463dc600bc9f8(parameters) {
    const { children: children, config: config } = parameters;
    const props = {
        value: config
    };
    return (0, $8NFma.createElement)((0, $1f2b956b4247db51$export$f49feec8afe53ddd), parameters, (0, $8NFma.createElement)($4a768efd39c3ad48$export$da7c16611087c70c.Provider, props, children));
}







const $269270ee5aa09b4f$export$83d89fbfd8236492 = "2.9.6";


const $32175b87689c123e$export$c506eb22e615ba4a = ()=>`@wagmi/core@${0, $269270ee5aa09b4f$export$83d89fbfd8236492}`;


var $23921cb92fbd5cef$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $23921cb92fbd5cef$var$_BaseError_instances, $23921cb92fbd5cef$var$_BaseError_walk;
class $23921cb92fbd5cef$export$a490eb03cb7a0a5e extends Error {
    get docsBaseUrl() {
        return "https://wagmi.sh/core";
    }
    get version() {
        return (0, $32175b87689c123e$export$c506eb22e615ba4a)();
    }
    constructor(shortMessage, options = {}){
        super();
        $23921cb92fbd5cef$var$_BaseError_instances.add(this);
        Object.defineProperty(this, "details", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "docsPath", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "metaMessages", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "shortMessage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "WagmiCoreError"
        });
        const details = options.cause instanceof $23921cb92fbd5cef$export$a490eb03cb7a0a5e ? options.cause.details : options.cause?.message ? options.cause.message : options.details;
        const docsPath = options.cause instanceof $23921cb92fbd5cef$export$a490eb03cb7a0a5e ? options.cause.docsPath || options.docsPath : options.docsPath;
        this.message = [
            shortMessage || "An error occurred.",
            "",
            ...options.metaMessages ? [
                ...options.metaMessages,
                ""
            ] : [],
            ...docsPath ? [
                `Docs: ${this.docsBaseUrl}${docsPath}.html${options.docsSlug ? `#${options.docsSlug}` : ""}`
            ] : [],
            ...details ? [
                `Details: ${details}`
            ] : [],
            `Version: ${this.version}`
        ].join("\n");
        if (options.cause) this.cause = options.cause;
        this.details = details;
        this.docsPath = docsPath;
        this.metaMessages = options.metaMessages;
        this.shortMessage = shortMessage;
    }
    walk(fn) {
        return $23921cb92fbd5cef$var$__classPrivateFieldGet(this, $23921cb92fbd5cef$var$_BaseError_instances, "m", $23921cb92fbd5cef$var$_BaseError_walk).call(this, this, fn);
    }
}
$23921cb92fbd5cef$var$_BaseError_instances = new WeakSet(), $23921cb92fbd5cef$var$_BaseError_walk = function _BaseError_walk(err, fn) {
    if (fn?.(err)) return err;
    if (err.cause) return $23921cb92fbd5cef$var$__classPrivateFieldGet(this, $23921cb92fbd5cef$var$_BaseError_instances, "m", _BaseError_walk).call(this, err.cause, fn);
    return err;
};


class $e9e19674d26bdf1a$export$688e5fda4b4631ed extends (0, $23921cb92fbd5cef$export$a490eb03cb7a0a5e) {
    constructor(){
        super("Chain not configured.");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ChainNotConfiguredError"
        });
    }
}
class $e9e19674d26bdf1a$export$ee7f4e50316bc4b2 extends (0, $23921cb92fbd5cef$export$a490eb03cb7a0a5e) {
    constructor(){
        super("Connector already connected.");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ConnectorAlreadyConnectedError"
        });
    }
}
class $e9e19674d26bdf1a$export$d9a3828eace037a6 extends (0, $23921cb92fbd5cef$export$a490eb03cb7a0a5e) {
    constructor(){
        super("Connector not connected.");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ConnectorNotConnectedError"
        });
    }
}
class $e9e19674d26bdf1a$export$9f8a797207d6544e extends (0, $23921cb92fbd5cef$export$a490eb03cb7a0a5e) {
    constructor(){
        super("Connector not found.");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ConnectorNotFoundError"
        });
    }
}
class $e9e19674d26bdf1a$export$65c369a969e2c62e extends (0, $23921cb92fbd5cef$export$a490eb03cb7a0a5e) {
    constructor({ address: address, connector: connector }){
        super(`Account "${address}" not found for connector "${connector.name}".`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ConnectorAccountNotFoundError"
        });
    }
}




async function $d3212b9943bd80f3$export$64605811ab45167f(config, parameters) {
    // "Register" connector if not already created
    let connector;
    if (typeof parameters.connector === "function") connector = config._internal.connectors.setup(parameters.connector);
    else connector = parameters.connector;
    // Check if connector is already connected
    if (connector.uid === config.state.current) throw new (0, $e9e19674d26bdf1a$export$ee7f4e50316bc4b2)();
    try {
        config.setState((x)=>({
                ...x,
                status: "connecting"
            }));
        connector.emitter.emit("message", {
            type: "connecting"
        });
        const data = await connector.connect({
            chainId: parameters.chainId
        });
        const accounts = data.accounts;
        connector.emitter.off("connect", config._internal.events.connect);
        connector.emitter.on("change", config._internal.events.change);
        connector.emitter.on("disconnect", config._internal.events.disconnect);
        await config.storage?.setItem("recentConnectorId", connector.id);
        config.setState((x)=>({
                ...x,
                connections: new Map(x.connections).set(connector.uid, {
                    accounts: accounts,
                    chainId: data.chainId,
                    connector: connector
                }),
                current: connector.uid,
                status: "connected"
            }));
        return {
            accounts: accounts,
            chainId: data.chainId
        };
    } catch (error) {
        config.setState((x)=>({
                ...x,
                // Keep existing connector connected in case of error
                status: x.current ? "connected" : "disconnected"
            }));
        throw error;
    }
}

/** https://wagmi.sh/core/api/actions/disconnect */ async function $16e09604f761585b$export$37dfea93db2e14ed(config, parameters = {}) {
    let connector;
    if (parameters.connector) connector = parameters.connector;
    else {
        const { connections: connections, current: current } = config.state;
        const connection = connections.get(current);
        connector = connection?.connector;
    }
    const connections = config.state.connections;
    if (connector) {
        await connector.disconnect();
        connector.emitter.off("change", config._internal.events.change);
        connector.emitter.off("disconnect", config._internal.events.disconnect);
        connector.emitter.on("connect", config._internal.events.connect);
        connections.delete(connector.uid);
    }
    config.setState((x)=>{
        // if no connections exist, move to disconnected state
        if (connections.size === 0) return {
            ...x,
            connections: new Map(),
            current: null,
            status: "disconnected"
        };
        // switch over to another connection
        const nextConnection = connections.values().next().value;
        return {
            ...x,
            connections: new Map(connections),
            current: nextConnection.connector.uid
        };
    });
    // Set recent connector if exists
    {
        const current = config.state.current;
        if (!current) return;
        const connector = config.state.connections.get(current)?.connector;
        if (!connector) return;
        await config.storage?.setItem("recentConnectorId", connector.id);
    }
}



function $135a5279acb2ac27$export$4f9234baf34abd0(config) {
    const uid = config.state.current;
    const connection = config.state.connections.get(uid);
    const addresses = connection?.accounts;
    const address = addresses?.[0];
    const chain = config.chains.find((chain)=>chain.id === connection?.chainId);
    const status = config.state.status;
    switch(status){
        case "connected":
            return {
                address: address,
                addresses: addresses,
                chain: chain,
                chainId: connection?.chainId,
                connector: connection?.connector,
                isConnected: true,
                isConnecting: false,
                isDisconnected: false,
                isReconnecting: false,
                status: status
            };
        case "reconnecting":
            return {
                address: address,
                addresses: addresses,
                chain: chain,
                chainId: connection?.chainId,
                connector: connection?.connector,
                isConnected: !!address,
                isConnecting: false,
                isDisconnected: false,
                isReconnecting: true,
                status: status
            };
        case "connecting":
            return {
                address: address,
                addresses: addresses,
                chain: chain,
                chainId: connection?.chainId,
                connector: connection?.connector,
                isConnected: false,
                isConnecting: true,
                isDisconnected: false,
                isReconnecting: false,
                status: status
            };
        case "disconnected":
            return {
                address: undefined,
                addresses: undefined,
                chain: undefined,
                chainId: undefined,
                connector: undefined,
                isConnected: false,
                isConnecting: false,
                isDisconnected: true,
                isReconnecting: false,
                status: status
            };
    }
}


var $9dX4d = parcelRequire("9dX4d");
var $2HKZh = parcelRequire("2HKZh");
var $7Zv5I = parcelRequire("7Zv5I");
var $44bP9 = parcelRequire("44bP9");

var $9UP4H = parcelRequire("9UP4H");
async function $854ed7a9743f5dc2$export$df96cd8d56be0ab1(client, { address: address, blockNumber: blockNumber, blockTag: blockTag = "latest" }) {
    const blockNumberHex = blockNumber ? (0, $9UP4H.numberToHex)(blockNumber) : undefined;
    const balance = await client.request({
        method: "eth_getBalance",
        params: [
            address,
            blockNumberHex || blockTag
        ]
    });
    return BigInt(balance);
}







function $df792fac4f6f7de9$export$6ca3170acb89054(client, actionFn, // Some minifiers drop `Function.prototype.name`, or replace it with short letters,
// meaning that `actionFn.name` will not always work. For that case, the consumer
// needs to pass the name explicitly.
name) {
    const action_implicit = client[actionFn.name];
    if (typeof action_implicit === "function") return action_implicit;
    const action_explicit = client[name];
    if (typeof action_explicit === "function") return action_explicit;
    return (params)=>actionFn(client, params);
}



var $2IOoR = parcelRequire("2IOoR");

function $3ae5fee8bf6aaf79$export$65f2564e9a9b9222(unit) {
    if (typeof unit === "number") return unit;
    if (unit === "wei") return 0;
    return Math.abs((0, $2IOoR.weiUnits)[unit]);
}



var $9dX4d = parcelRequire("9dX4d");



var $9nOfC = parcelRequire("9nOfC");

var $3TFRi = parcelRequire("3TFRi");

var $6F8ii = parcelRequire("6F8ii");

var $9dX4d = parcelRequire("9dX4d");

var $ktUQf = parcelRequire("ktUQf");

var $ahylX = parcelRequire("ahylX");

var $kErjY = parcelRequire("kErjY");

var $3TFRi = parcelRequire("3TFRi");

var $6F8ii = parcelRequire("6F8ii");

var $9dX4d = parcelRequire("9dX4d");

var $k7R6B = parcelRequire("k7R6B");
const $ed751cf9c83e9795$var$EXECUTION_REVERTED_ERROR_CODE = 3;
function $ed751cf9c83e9795$export$4414444aba6ddd8a(err, { abi: abi, address: address, args: args, docsPath: docsPath, functionName: functionName, sender: sender }) {
    const { code: code, data: data, message: message, shortMessage: shortMessage } = err instanceof (0, $9dX4d.RawContractError) ? err : err instanceof (0, $6F8ii.BaseError) ? err.walk((err)=>"data" in err) || err.walk() : {};
    const cause = (()=>{
        if (err instanceof (0, $3TFRi.AbiDecodingZeroDataError)) return new (0, $9dX4d.ContractFunctionZeroDataError)({
            functionName: functionName
        });
        if ([
            $ed751cf9c83e9795$var$EXECUTION_REVERTED_ERROR_CODE,
            (0, $k7R6B.InternalRpcError).code
        ].includes(code) && (data || message || shortMessage)) return new (0, $9dX4d.ContractFunctionRevertedError)({
            abi: abi,
            data: typeof data === "object" ? data.data : data,
            functionName: functionName,
            message: shortMessage ?? message
        });
        return err;
    })();
    return new (0, $9dX4d.ContractFunctionExecutionError)(cause, {
        abi: abi,
        args: args,
        contractAddress: address,
        docsPath: docsPath,
        functionName: functionName,
        sender: sender
    });
}


/**
 * Retrieves and returns an action from the client (if exists), and falls
 * back to the tree-shakable action.
 *
 * Useful for extracting overridden actions from a client (ie. if a consumer
 * wants to override the `sendTransaction` implementation).
 */ function $17629d164efed1df$export$6ca3170acb89054(client, actionFn, // Some minifiers drop `Function.prototype.name`, or replace it with short letters,
// meaning that `actionFn.name` will not always work. For that case, the consumer
// needs to pass the name explicitly.
name) {
    const action_implicit = client[actionFn.name];
    if (typeof action_implicit === "function") return action_implicit;
    const action_explicit = client[name];
    if (typeof action_explicit === "function") return action_explicit;
    return (params)=>actionFn(client, params);
}



var $ktUQf = parcelRequire("ktUQf");

var $ahylX = parcelRequire("ahylX");



var $49mjM = parcelRequire("49mjM");
async function $345cd736baedaec0$export$43af7de392176737(client, parameters) {
    const { abi: abi, address: address, args: args, functionName: functionName, ...rest } = parameters;
    const calldata = (0, $ahylX.encodeFunctionData)({
        abi: abi,
        args: args,
        functionName: functionName
    });
    try {
        const { data: data } = await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $49mjM.call), "call")({
            ...rest,
            data: calldata,
            to: address
        });
        return (0, $ktUQf.decodeFunctionResult)({
            abi: abi,
            args: args,
            functionName: functionName,
            data: data || "0x"
        });
    } catch (error) {
        throw (0, $ed751cf9c83e9795$export$4414444aba6ddd8a)(error, {
            abi: abi,
            address: address,
            args: args,
            docsPath: "/docs/contract/readContract",
            functionName: functionName
        });
    }
}


async function $15083d190e8609d0$export$60ef70589ee4f7ad(client, parameters) {
    const { allowFailure: allowFailure = true, batchSize: batchSize_, blockNumber: blockNumber, blockTag: blockTag, multicallAddress: multicallAddress_, stateOverride: stateOverride } = parameters;
    const contracts = parameters.contracts;
    const batchSize = batchSize_ ?? (typeof client.batch?.multicall === "object" && client.batch.multicall.batchSize || 1024);
    let multicallAddress = multicallAddress_;
    if (!multicallAddress) {
        if (!client.chain) throw new Error("client chain not configured. multicallAddress is required.");
        multicallAddress = (0, $kErjY.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "multicall3"
        });
    }
    const chunkedCalls = [
        []
    ];
    let currentChunk = 0;
    let currentChunkSize = 0;
    for(let i = 0; i < contracts.length; i++){
        const { abi: abi, address: address, args: args, functionName: functionName } = contracts[i];
        try {
            const callData = (0, $ahylX.encodeFunctionData)({
                abi: abi,
                args: args,
                functionName: functionName
            });
            currentChunkSize += (callData.length - 2) / 2;
            // Check to see if we need to create a new chunk.
            if (// Check if batching is enabled.
            batchSize > 0 && // Check if the current size of the batch exceeds the size limit.
            currentChunkSize > batchSize && // Check if the current chunk is not already empty.
            chunkedCalls[currentChunk].length > 0) {
                currentChunk++;
                currentChunkSize = (callData.length - 2) / 2;
                chunkedCalls[currentChunk] = [];
            }
            chunkedCalls[currentChunk] = [
                ...chunkedCalls[currentChunk],
                {
                    allowFailure: true,
                    callData: callData,
                    target: address
                }
            ];
        } catch (err) {
            const error = (0, $ed751cf9c83e9795$export$4414444aba6ddd8a)(err, {
                abi: abi,
                address: address,
                args: args,
                docsPath: "/docs/contract/multicall",
                functionName: functionName
            });
            if (!allowFailure) throw error;
            chunkedCalls[currentChunk] = [
                ...chunkedCalls[currentChunk],
                {
                    allowFailure: true,
                    callData: "0x",
                    target: address
                }
            ];
        }
    }
    const aggregate3Results = await Promise.allSettled(chunkedCalls.map((calls)=>(0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $345cd736baedaec0$export$43af7de392176737), "readContract")({
            abi: (0, $9nOfC.multicall3Abi),
            address: multicallAddress,
            args: [
                calls
            ],
            blockNumber: blockNumber,
            blockTag: blockTag,
            functionName: "aggregate3",
            stateOverride: stateOverride
        })));
    const results = [];
    for(let i = 0; i < aggregate3Results.length; i++){
        const result = aggregate3Results[i];
        // If an error occurred in a `readContract` invocation (ie. network error),
        // then append the failure reason to each contract result.
        if (result.status === "rejected") {
            if (!allowFailure) throw result.reason;
            for(let j = 0; j < chunkedCalls[i].length; j++)results.push({
                status: "failure",
                error: result.reason,
                result: undefined
            });
            continue;
        }
        // If the `readContract` call was successful, then decode the results.
        const aggregate3Result = result.value;
        for(let j = 0; j < aggregate3Result.length; j++){
            // Extract the response from `readContract`
            const { returnData: returnData, success: success } = aggregate3Result[j];
            // Extract the request call data from the original call.
            const { callData: callData } = chunkedCalls[i][j];
            // Extract the contract config for this call from the `contracts` argument
            // for decoding.
            const { abi: abi, address: address, functionName: functionName, args: args } = contracts[results.length];
            try {
                if (callData === "0x") throw new (0, $3TFRi.AbiDecodingZeroDataError)();
                if (!success) throw new (0, $9dX4d.RawContractError)({
                    data: returnData
                });
                const result = (0, $ktUQf.decodeFunctionResult)({
                    abi: abi,
                    args: args,
                    data: returnData,
                    functionName: functionName
                });
                results.push(allowFailure ? {
                    result: result,
                    status: "success"
                } : result);
            } catch (err) {
                const error = (0, $ed751cf9c83e9795$export$4414444aba6ddd8a)(err, {
                    abi: abi,
                    address: address,
                    args: args,
                    docsPath: "/docs/contract/multicall",
                    functionName: functionName
                });
                if (!allowFailure) throw error;
                results.push({
                    error: error,
                    result: undefined,
                    status: "failure"
                });
            }
        }
    }
    if (results.length !== contracts.length) throw new (0, $6F8ii.BaseError)("multicall results mismatch");
    return results;
}





async function $0ca51e32129e99c3$export$60ef70589ee4f7ad(config, parameters) {
    const { allowFailure: allowFailure = true, chainId: chainId, contracts: contracts, ...rest } = parameters;
    const client = config.getClient({
        chainId: chainId
    });
    const action = (0, $df792fac4f6f7de9$export$6ca3170acb89054)(client, (0, $15083d190e8609d0$export$60ef70589ee4f7ad), "multicall");
    return action({
        allowFailure: allowFailure,
        contracts: contracts,
        ...rest
    });
}







function $b781fc26b1f4e38f$export$43af7de392176737(config, parameters) {
    const { chainId: chainId, ...rest } = parameters;
    const client = config.getClient({
        chainId: chainId
    });
    const action = (0, $df792fac4f6f7de9$export$6ca3170acb89054)(client, (0, $345cd736baedaec0$export$43af7de392176737), "readContract");
    return action(rest);
}


async function $28bde3f386b23ee9$export$aa7cd72d27ce4a5(config, parameters) {
    const { allowFailure: allowFailure = true, blockNumber: blockNumber, blockTag: blockTag, ...rest } = parameters;
    const contracts = parameters.contracts;
    try {
        const contractsByChainId = contracts.reduce((contracts, contract, index)=>{
            const chainId = contract.chainId ?? config.state.chainId;
            return {
                ...contracts,
                [chainId]: [
                    ...contracts[chainId] || [],
                    {
                        contract: contract,
                        index: index
                    }
                ]
            };
        }, {});
        const promises = ()=>Object.entries(contractsByChainId).map(([chainId, contracts])=>(0, $0ca51e32129e99c3$export$60ef70589ee4f7ad)(config, {
                    ...rest,
                    allowFailure: allowFailure,
                    blockNumber: blockNumber,
                    blockTag: blockTag,
                    chainId: parseInt(chainId),
                    contracts: contracts.map(({ contract: contract })=>contract)
                }));
        const multicallResults = (await Promise.all(promises())).flat();
        // Reorder the contract results back to the order they were
        // provided in.
        const resultIndexes = Object.values(contractsByChainId).flatMap((contracts)=>contracts.map(({ index: index })=>index));
        return multicallResults.reduce((results, result, index)=>{
            if (results) results[resultIndexes[index]] = result;
            return results;
        }, []);
    } catch (error) {
        if (error instanceof (0, $9dX4d.ContractFunctionExecutionError)) throw error;
        const promises = ()=>contracts.map((contract)=>(0, $b781fc26b1f4e38f$export$43af7de392176737)(config, {
                    ...contract,
                    blockNumber: blockNumber,
                    blockTag: blockTag
                }));
        if (allowFailure) return (await Promise.allSettled(promises())).map((result)=>{
            if (result.status === "fulfilled") return {
                result: result.value,
                status: "success"
            };
            return {
                error: result.reason,
                result: undefined,
                status: "failure"
            };
        });
        return await Promise.all(promises());
    }
}


async function $1bd324b76344de3f$export$df96cd8d56be0ab1(config, parameters) {
    const { address: address, blockNumber: blockNumber, blockTag: blockTag, chainId: chainId, token: tokenAddress, unit: unit = "ether" } = parameters;
    if (tokenAddress) try {
        return $1bd324b76344de3f$var$getTokenBalance(config, {
            balanceAddress: address,
            chainId: chainId,
            symbolType: "string",
            tokenAddress: tokenAddress
        });
    } catch (error) {
        // In the chance that there is an error upon decoding the contract result,
        // it could be likely that the contract data is represented as bytes32 instead
        // of a string.
        if (error instanceof (0, $9dX4d.ContractFunctionExecutionError)) {
            const balance = await $1bd324b76344de3f$var$getTokenBalance(config, {
                balanceAddress: address,
                chainId: chainId,
                symbolType: "bytes32",
                tokenAddress: tokenAddress
            });
            const symbol = (0, $7Zv5I.hexToString)((0, $44bP9.trim)(balance.symbol, {
                dir: "right"
            }));
            return {
                ...balance,
                symbol: symbol
            };
        }
        throw error;
    }
    const client = config.getClient({
        chainId: chainId
    });
    const action = (0, $df792fac4f6f7de9$export$6ca3170acb89054)(client, (0, $854ed7a9743f5dc2$export$df96cd8d56be0ab1), "getBalance");
    const value = await action(blockNumber ? {
        address: address,
        blockNumber: blockNumber
    } : {
        address: address,
        blockTag: blockTag
    });
    const chain = config.chains.find((x)=>x.id === chainId) ?? client.chain;
    return {
        decimals: chain.nativeCurrency.decimals,
        formatted: (0, $2HKZh.formatUnits)(value, (0, $3ae5fee8bf6aaf79$export$65f2564e9a9b9222)(unit)),
        symbol: chain.nativeCurrency.symbol,
        value: value
    };
}
async function $1bd324b76344de3f$var$getTokenBalance(config, parameters) {
    const { balanceAddress: balanceAddress, chainId: chainId, symbolType: symbolType, tokenAddress: tokenAddress, unit: unit } = parameters;
    const contract = {
        abi: [
            {
                type: "function",
                name: "balanceOf",
                stateMutability: "view",
                inputs: [
                    {
                        type: "address"
                    }
                ],
                outputs: [
                    {
                        type: "uint256"
                    }
                ]
            },
            {
                type: "function",
                name: "decimals",
                stateMutability: "view",
                inputs: [],
                outputs: [
                    {
                        type: "uint8"
                    }
                ]
            },
            {
                type: "function",
                name: "symbol",
                stateMutability: "view",
                inputs: [],
                outputs: [
                    {
                        type: symbolType
                    }
                ]
            }
        ],
        address: tokenAddress
    };
    const [value, decimals, symbol] = await (0, $28bde3f386b23ee9$export$aa7cd72d27ce4a5)(config, {
        allowFailure: false,
        contracts: [
            {
                ...contract,
                functionName: "balanceOf",
                args: [
                    balanceAddress
                ],
                chainId: chainId
            },
            {
                ...contract,
                functionName: "decimals",
                chainId: chainId
            },
            {
                ...contract,
                functionName: "symbol",
                chainId: chainId
            }
        ]
    });
    const formatted = (0, $2HKZh.formatUnits)(value ?? "0", (0, $3ae5fee8bf6aaf79$export$65f2564e9a9b9222)(unit ?? decimals));
    return {
        decimals: decimals,
        formatted: formatted,
        symbol: symbol,
        value: value
    };
}



var $6F8ii = parcelRequire("6F8ii");
class $7d5bc98dfa8609d9$export$3d9377558041f9cf extends (0, $6F8ii.BaseError) {
    constructor({ data: data }){
        super("Unable to extract image from metadata. The metadata may be malformed or invalid.", {
            metaMessages: [
                "- Metadata must be a JSON object with at least an `image`, `image_url` or `image_data` property.",
                "",
                `Provided data: ${JSON.stringify(data)}`
            ],
            name: "EnsAvatarInvalidMetadataError"
        });
    }
}
class $7d5bc98dfa8609d9$export$74a8ea52cecec305 extends (0, $6F8ii.BaseError) {
    constructor({ reason: reason }){
        super(`ENS NFT avatar URI is invalid. ${reason}`, {
            name: "EnsAvatarInvalidNftUriError"
        });
    }
}
class $7d5bc98dfa8609d9$export$f202ff3d50da14eb extends (0, $6F8ii.BaseError) {
    constructor({ uri: uri }){
        super(`Unable to resolve ENS avatar URI "${uri}". The URI may be malformed, invalid, or does not respond with a valid image.`, {
            name: "EnsAvatarUriResolutionError"
        });
    }
}
class $7d5bc98dfa8609d9$export$45137f20297c5e74 extends (0, $6F8ii.BaseError) {
    constructor({ namespace: namespace }){
        super(`ENS NFT avatar namespace "${namespace}" is not supported. Must be "erc721" or "erc1155".`, {
            name: "EnsAvatarUnsupportedNamespaceError"
        });
    }
}


const $a3cfabdb113f74dd$var$networkRegex = /(?<protocol>https?:\/\/[^\/]*|ipfs:\/|ipns:\/|ar:\/)?(?<root>\/)?(?<subpath>ipfs\/|ipns\/)?(?<target>[\w\-.]+)(?<subtarget>\/.*)?/;
const $a3cfabdb113f74dd$var$ipfsHashRegex = /^(Qm[1-9A-HJ-NP-Za-km-z]{44,}|b[A-Za-z2-7]{58,}|B[A-Z2-7]{58,}|z[1-9A-HJ-NP-Za-km-z]{48,}|F[0-9A-F]{50,})(\/(?<target>[\w\-.]+))?(?<subtarget>\/.*)?$/;
const $a3cfabdb113f74dd$var$base64Regex = /^data:([a-zA-Z\-/+]*);base64,([^"].*)/;
const $a3cfabdb113f74dd$var$dataURIRegex = /^data:([a-zA-Z\-/+]*)?(;[a-zA-Z0-9].*?)?(,)/;
async function $a3cfabdb113f74dd$export$db9c123edba6463(uri) {
    try {
        const res = await fetch(uri, {
            method: "HEAD"
        });
        // retrieve content type header to check if content is image
        if (res.status === 200) {
            const contentType = res.headers.get("content-type");
            return contentType?.startsWith("image/");
        }
        return false;
    } catch (error) {
        // if error is not cors related then fail
        if (typeof error === "object" && typeof error.response !== "undefined") return false;
        // fail in NodeJS, since the error is not cors but any other network issue
        // biome-ignore lint/suspicious/noPrototypeBuiltins:
        if (!globalThis.hasOwnProperty("Image")) return false;
        // in case of cors, use image api to validate if given url is an actual image
        return new Promise((resolve)=>{
            const img = new Image();
            img.onload = ()=>{
                resolve(true);
            };
            img.onerror = ()=>{
                resolve(false);
            };
            img.src = uri;
        });
    }
}
function $a3cfabdb113f74dd$export$90df7f536ca3f624(custom, defaultGateway) {
    if (!custom) return defaultGateway;
    if (custom.endsWith("/")) return custom.slice(0, -1);
    return custom;
}
function $a3cfabdb113f74dd$export$9c878106a0d8edac({ uri: uri, gatewayUrls: gatewayUrls }) {
    const isEncoded = $a3cfabdb113f74dd$var$base64Regex.test(uri);
    if (isEncoded) return {
        uri: uri,
        isOnChain: true,
        isEncoded: isEncoded
    };
    const ipfsGateway = $a3cfabdb113f74dd$export$90df7f536ca3f624(gatewayUrls?.ipfs, "https://ipfs.io");
    const arweaveGateway = $a3cfabdb113f74dd$export$90df7f536ca3f624(gatewayUrls?.arweave, "https://arweave.net");
    const networkRegexMatch = uri.match($a3cfabdb113f74dd$var$networkRegex);
    const { protocol: protocol, subpath: subpath, target: target, subtarget: subtarget = "" } = networkRegexMatch?.groups || {};
    const isIPNS = protocol === "ipns:/" || subpath === "ipns/";
    const isIPFS = protocol === "ipfs:/" || subpath === "ipfs/" || $a3cfabdb113f74dd$var$ipfsHashRegex.test(uri);
    if (uri.startsWith("http") && !isIPNS && !isIPFS) {
        let replacedUri = uri;
        if (gatewayUrls?.arweave) replacedUri = uri.replace(/https:\/\/arweave.net/g, gatewayUrls?.arweave);
        return {
            uri: replacedUri,
            isOnChain: false,
            isEncoded: false
        };
    }
    if ((isIPNS || isIPFS) && target) return {
        uri: `${ipfsGateway}/${isIPNS ? "ipns" : "ipfs"}/${target}${subtarget}`,
        isOnChain: false,
        isEncoded: false
    };
    if (protocol === "ar:/" && target) return {
        uri: `${arweaveGateway}/${target}${subtarget || ""}`,
        isOnChain: false,
        isEncoded: false
    };
    let parsedUri = uri.replace($a3cfabdb113f74dd$var$dataURIRegex, "");
    if (parsedUri.startsWith("<svg")) // if svg, base64 encode
    parsedUri = `data:image/svg+xml;base64,${btoa(parsedUri)}`;
    if (parsedUri.startsWith("data:") || parsedUri.startsWith("{")) return {
        uri: parsedUri,
        isOnChain: true,
        isEncoded: false
    };
    throw new (0, $7d5bc98dfa8609d9$export$f202ff3d50da14eb)({
        uri: uri
    });
}
function $a3cfabdb113f74dd$export$9be3fe34a3333ecb(data) {
    // validation check for json data, must include one of theses properties
    if (typeof data !== "object" || !("image" in data) && !("image_url" in data) && !("image_data" in data)) throw new (0, $7d5bc98dfa8609d9$export$3d9377558041f9cf)({
        data: data
    });
    return data.image || data.image_url || data.image_data;
}
async function $a3cfabdb113f74dd$export$b9759ed161b5e3c5({ gatewayUrls: gatewayUrls, uri: uri }) {
    try {
        const res = await fetch(uri).then((res)=>res.json());
        const image = await $a3cfabdb113f74dd$export$1f4e569649d3a793({
            gatewayUrls: gatewayUrls,
            uri: $a3cfabdb113f74dd$export$9be3fe34a3333ecb(res)
        });
        return image;
    } catch  {
        throw new (0, $7d5bc98dfa8609d9$export$f202ff3d50da14eb)({
            uri: uri
        });
    }
}
async function $a3cfabdb113f74dd$export$1f4e569649d3a793({ gatewayUrls: gatewayUrls, uri: uri }) {
    const { uri: resolvedURI, isOnChain: isOnChain } = $a3cfabdb113f74dd$export$9c878106a0d8edac({
        uri: uri,
        gatewayUrls: gatewayUrls
    });
    if (isOnChain) return resolvedURI;
    // check if resolvedURI is an image, if it is return the url
    const isImage = await $a3cfabdb113f74dd$export$db9c123edba6463(resolvedURI);
    if (isImage) return resolvedURI;
    throw new (0, $7d5bc98dfa8609d9$export$f202ff3d50da14eb)({
        uri: uri
    });
}
function $a3cfabdb113f74dd$export$e78cf22c9d52ca8a(uri_) {
    let uri = uri_;
    // parse valid nft spec (CAIP-22/CAIP-29)
    // @see: https://github.com/ChainAgnostic/CAIPs/tree/master/CAIPs
    if (uri.startsWith("did:nft:")) // convert DID to CAIP
    uri = uri.replace("did:nft:", "").replace(/_/g, "/");
    const [reference, asset_namespace, tokenID] = uri.split("/");
    const [eip_namespace, chainID] = reference.split(":");
    const [erc_namespace, contractAddress] = asset_namespace.split(":");
    if (!eip_namespace || eip_namespace.toLowerCase() !== "eip155") throw new (0, $7d5bc98dfa8609d9$export$74a8ea52cecec305)({
        reason: "Only EIP-155 supported"
    });
    if (!chainID) throw new (0, $7d5bc98dfa8609d9$export$74a8ea52cecec305)({
        reason: "Chain ID not found"
    });
    if (!contractAddress) throw new (0, $7d5bc98dfa8609d9$export$74a8ea52cecec305)({
        reason: "Contract address not found"
    });
    if (!tokenID) throw new (0, $7d5bc98dfa8609d9$export$74a8ea52cecec305)({
        reason: "Token ID not found"
    });
    if (!erc_namespace) throw new (0, $7d5bc98dfa8609d9$export$74a8ea52cecec305)({
        reason: "ERC namespace not found"
    });
    return {
        chainID: Number.parseInt(chainID),
        namespace: erc_namespace.toLowerCase(),
        contractAddress: contractAddress,
        tokenID: tokenID
    };
}
async function $a3cfabdb113f74dd$export$29b8ee2b96a1ed4f(client, { nft: nft }) {
    if (nft.namespace === "erc721") return (0, $345cd736baedaec0$export$43af7de392176737)(client, {
        address: nft.contractAddress,
        abi: [
            {
                name: "tokenURI",
                type: "function",
                stateMutability: "view",
                inputs: [
                    {
                        name: "tokenId",
                        type: "uint256"
                    }
                ],
                outputs: [
                    {
                        name: "",
                        type: "string"
                    }
                ]
            }
        ],
        functionName: "tokenURI",
        args: [
            BigInt(nft.tokenID)
        ]
    });
    if (nft.namespace === "erc1155") return (0, $345cd736baedaec0$export$43af7de392176737)(client, {
        address: nft.contractAddress,
        abi: [
            {
                name: "uri",
                type: "function",
                stateMutability: "view",
                inputs: [
                    {
                        name: "_id",
                        type: "uint256"
                    }
                ],
                outputs: [
                    {
                        name: "",
                        type: "string"
                    }
                ]
            }
        ],
        functionName: "uri",
        args: [
            BigInt(nft.tokenID)
        ]
    });
    throw new (0, $7d5bc98dfa8609d9$export$45137f20297c5e74)({
        namespace: nft.namespace
    });
}


async function $219930b03c47c31b$export$3713446b2fba5(client, { gatewayUrls: gatewayUrls, record: record }) {
    if (/eip155:/i.test(record)) return $219930b03c47c31b$var$parseNftAvatarUri(client, {
        gatewayUrls: gatewayUrls,
        record: record
    });
    return (0, $a3cfabdb113f74dd$export$1f4e569649d3a793)({
        uri: record,
        gatewayUrls: gatewayUrls
    });
}
async function $219930b03c47c31b$var$parseNftAvatarUri(client, { gatewayUrls: gatewayUrls, record: record }) {
    // parse NFT URI into properties
    const nft = (0, $a3cfabdb113f74dd$export$e78cf22c9d52ca8a)(record);
    // fetch tokenURI from the NFT contract
    const nftUri = await (0, $a3cfabdb113f74dd$export$29b8ee2b96a1ed4f)(client, {
        nft: nft
    });
    // resolve the URI from the fetched tokenURI
    const { uri: resolvedNftUri, isOnChain: isOnChain, isEncoded: isEncoded } = (0, $a3cfabdb113f74dd$export$9c878106a0d8edac)({
        uri: nftUri,
        gatewayUrls: gatewayUrls
    });
    // if the resolved URI is on chain, return the data
    if (isOnChain && (resolvedNftUri.includes("data:application/json;base64,") || resolvedNftUri.startsWith("{"))) {
        const encodedJson = isEncoded ? atob(resolvedNftUri.replace("data:application/json;base64,", "")) : resolvedNftUri;
        const decoded = JSON.parse(encodedJson);
        return (0, $a3cfabdb113f74dd$export$1f4e569649d3a793)({
            uri: (0, $a3cfabdb113f74dd$export$9be3fe34a3333ecb)(decoded),
            gatewayUrls: gatewayUrls
        });
    }
    let uriTokenId = nft.tokenID;
    if (nft.namespace === "erc1155") uriTokenId = uriTokenId.replace("0x", "").padStart(64, "0");
    return (0, $a3cfabdb113f74dd$export$b9759ed161b5e3c5)({
        gatewayUrls: gatewayUrls,
        uri: resolvedNftUri.replace(/(?:0x)?{id}/, uriTokenId)
    });
}




var $9nOfC = parcelRequire("9nOfC");

var $ktUQf = parcelRequire("ktUQf");

var $ahylX = parcelRequire("ahylX");

var $kErjY = parcelRequire("kErjY");

var $9UP4H = parcelRequire("9UP4H");

var $6o2KQ = parcelRequire("6o2KQ");

var $6F8ii = parcelRequire("6F8ii");

var $9dX4d = parcelRequire("9dX4d");
function $a72348f10fc03c7b$export$78f90e26b9356cd7(err, callType) {
    if (!(err instanceof (0, $6F8ii.BaseError))) return false;
    const cause = err.walk((e)=>e instanceof (0, $9dX4d.ContractFunctionRevertedError));
    if (!(cause instanceof (0, $9dX4d.ContractFunctionRevertedError))) return false;
    if (cause.data?.errorName === "ResolverNotFound") return true;
    if (cause.data?.errorName === "ResolverWildcardNotSupported") return true;
    if (cause.data?.errorName === "ResolverNotContract") return true;
    if (cause.data?.errorName === "ResolverError") return true;
    if (cause.data?.errorName === "HttpError") return true;
    // Backwards compatibility for older UniversalResolver contracts
    if (cause.reason?.includes("Wildcard on non-extended resolvers is not supported")) return true;
    // No primary name set for address.
    if (callType === "reverse" && cause.reason === (0, $6o2KQ.panicReasons)[50]) return true;
    return false;
}



var $jCBOw = parcelRequire("jCBOw");

var $eFDiV = parcelRequire("eFDiV");

var $9UP4H = parcelRequire("9UP4H");

var $bRe6l = parcelRequire("bRe6l");

var $j6NiR = parcelRequire("j6NiR");
function $77c8c7a28ab916b9$export$cbf748cac2e87c52(label) {
    if (label.length !== 66) return null;
    if (label.indexOf("[") !== 0) return null;
    if (label.indexOf("]") !== 65) return null;
    const hash = `0x${label.slice(1, 65)}`;
    if (!(0, $j6NiR.isHex)(hash)) return null;
    return hash;
}


function $406c752c82e49948$export$91d651ee363e1209(name) {
    let result = new Uint8Array(32).fill(0);
    if (!name) return (0, $9UP4H.bytesToHex)(result);
    const labels = name.split(".");
    // Iterate in reverse order building up hash
    for(let i = labels.length - 1; i >= 0; i -= 1){
        const hashFromEncodedLabel = (0, $77c8c7a28ab916b9$export$cbf748cac2e87c52)(labels[i]);
        const hashed = hashFromEncodedLabel ? (0, $eFDiV.toBytes)(hashFromEncodedLabel) : (0, $bRe6l.keccak256)((0, $eFDiV.stringToBytes)(labels[i]), "bytes");
        result = (0, $bRe6l.keccak256)((0, $jCBOw.concat)([
            result,
            hashed
        ]), "bytes");
    }
    return (0, $9UP4H.bytesToHex)(result);
}



var $eFDiV = parcelRequire("eFDiV");
function $8be902fb19c55578$export$c23ac52da6ff5062(hash) {
    return `[${hash.slice(2)}]`;
}



var $eFDiV = parcelRequire("eFDiV");

var $9UP4H = parcelRequire("9UP4H");

var $bRe6l = parcelRequire("bRe6l");

function $5230a5532c64831e$export$83615f6c30436a69(label) {
    const result = new Uint8Array(32).fill(0);
    if (!label) return (0, $9UP4H.bytesToHex)(result);
    return (0, $77c8c7a28ab916b9$export$cbf748cac2e87c52)(label) || (0, $bRe6l.keccak256)((0, $eFDiV.stringToBytes)(label));
}


function $a48622506b78a6f9$export$8a0899f9ded0844(packet) {
    // strip leading and trailing `.`
    const value = packet.replace(/^\.|\.$/gm, "");
    if (value.length === 0) return new Uint8Array(1);
    const bytes = new Uint8Array((0, $eFDiV.stringToBytes)(value).byteLength + 2);
    let offset = 0;
    const list = value.split(".");
    for(let i = 0; i < list.length; i++){
        let encoded = (0, $eFDiV.stringToBytes)(list[i]);
        // if the length is > 255, make the encoded label value a labelhash
        // this is compatible with the universal resolver
        if (encoded.byteLength > 255) encoded = (0, $eFDiV.stringToBytes)((0, $8be902fb19c55578$export$c23ac52da6ff5062)((0, $5230a5532c64831e$export$83615f6c30436a69)(list[i])));
        bytes[offset] = encoded.length;
        bytes.set(encoded, offset + 1);
        offset += encoded.length + 1;
    }
    if (bytes.byteLength !== offset + 1) return bytes.slice(0, offset + 1);
    return bytes;
}




async function $657abfedeed8cfa0$export$2b2c96dabd62b431(client, { blockNumber: blockNumber, blockTag: blockTag, name: name, key: key, gatewayUrls: gatewayUrls, strict: strict, universalResolverAddress: universalResolverAddress_ }) {
    let universalResolverAddress = universalResolverAddress_;
    if (!universalResolverAddress) {
        if (!client.chain) throw new Error("client chain not configured. universalResolverAddress is required.");
        universalResolverAddress = (0, $kErjY.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "ensUniversalResolver"
        });
    }
    try {
        const readContractParameters = {
            address: universalResolverAddress,
            abi: (0, $9nOfC.universalResolverResolveAbi),
            functionName: "resolve",
            args: [
                (0, $9UP4H.toHex)((0, $a48622506b78a6f9$export$8a0899f9ded0844)(name)),
                (0, $ahylX.encodeFunctionData)({
                    abi: (0, $9nOfC.textResolverAbi),
                    functionName: "text",
                    args: [
                        (0, $406c752c82e49948$export$91d651ee363e1209)(name),
                        key
                    ]
                })
            ],
            blockNumber: blockNumber,
            blockTag: blockTag
        };
        const readContractAction = (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $345cd736baedaec0$export$43af7de392176737), "readContract");
        const res = gatewayUrls ? await readContractAction({
            ...readContractParameters,
            args: [
                ...readContractParameters.args,
                gatewayUrls
            ]
        }) : await readContractAction(readContractParameters);
        if (res[0] === "0x") return null;
        const record = (0, $ktUQf.decodeFunctionResult)({
            abi: (0, $9nOfC.textResolverAbi),
            functionName: "text",
            data: res[0]
        });
        return record === "" ? null : record;
    } catch (err) {
        if (strict) throw err;
        if ((0, $a72348f10fc03c7b$export$78f90e26b9356cd7)(err, "resolve")) return null;
        throw err;
    }
}


async function $ccfd2246705b6fe1$export$65f1d2b9649a54e5(client, { blockNumber: blockNumber, blockTag: blockTag, assetGatewayUrls: assetGatewayUrls, name: name, gatewayUrls: gatewayUrls, strict: strict, universalResolverAddress: universalResolverAddress }) {
    const record = await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $657abfedeed8cfa0$export$2b2c96dabd62b431), "getEnsText")({
        blockNumber: blockNumber,
        blockTag: blockTag,
        key: "avatar",
        name: name,
        universalResolverAddress: universalResolverAddress,
        gatewayUrls: gatewayUrls,
        strict: strict
    });
    if (!record) return null;
    try {
        return await (0, $219930b03c47c31b$export$3713446b2fba5)(client, {
            record: record,
            gatewayUrls: assetGatewayUrls
        });
    } catch  {
        return null;
    }
}






function $ef0552246eb5e90b$export$65f1d2b9649a54e5(config, parameters) {
    const { chainId: chainId, ...rest } = parameters;
    const client = config.getClient({
        chainId: chainId
    });
    const action = (0, $df792fac4f6f7de9$export$6ca3170acb89054)(client, (0, $ccfd2246705b6fe1$export$65f1d2b9649a54e5), "getEnsAvatar");
    return action(rest);
}


var $9nOfC = parcelRequire("9nOfC");

var $kErjY = parcelRequire("kErjY");

var $9UP4H = parcelRequire("9UP4H");




async function $9a7aff60d06f8b35$export$e1b98d9bc05a9fc2(client, { address: address, blockNumber: blockNumber, blockTag: blockTag, gatewayUrls: gatewayUrls, strict: strict, universalResolverAddress: universalResolverAddress_ }) {
    let universalResolverAddress = universalResolverAddress_;
    if (!universalResolverAddress) {
        if (!client.chain) throw new Error("client chain not configured. universalResolverAddress is required.");
        universalResolverAddress = (0, $kErjY.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "ensUniversalResolver"
        });
    }
    const reverseNode = `${address.toLowerCase().substring(2)}.addr.reverse`;
    try {
        const readContractParameters = {
            address: universalResolverAddress,
            abi: (0, $9nOfC.universalResolverReverseAbi),
            functionName: "reverse",
            args: [
                (0, $9UP4H.toHex)((0, $a48622506b78a6f9$export$8a0899f9ded0844)(reverseNode))
            ],
            blockNumber: blockNumber,
            blockTag: blockTag
        };
        const readContractAction = (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $345cd736baedaec0$export$43af7de392176737), "readContract");
        const [name, resolvedAddress] = gatewayUrls ? await readContractAction({
            ...readContractParameters,
            args: [
                ...readContractParameters.args,
                gatewayUrls
            ]
        }) : await readContractAction(readContractParameters);
        if (address.toLowerCase() !== resolvedAddress.toLowerCase()) return null;
        return name;
    } catch (err) {
        if (strict) throw err;
        if ((0, $a72348f10fc03c7b$export$78f90e26b9356cd7)(err, "reverse")) return null;
        throw err;
    }
}






function $fd667582dd660e5f$export$e1b98d9bc05a9fc2(config, parameters) {
    const { chainId: chainId, ...rest } = parameters;
    const client = config.getClient({
        chainId: chainId
    });
    const action = (0, $df792fac4f6f7de9$export$6ca3170acb89054)(client, (0, $9a7aff60d06f8b35$export$e1b98d9bc05a9fc2), "getEnsName");
    return action(rest);
}



var $4I1xa = parcelRequire("4I1xa");

var $6F8ii = parcelRequire("6F8ii");
class $bac5fb91181ff447$export$62ee6b05f0767f28 extends (0, $6F8ii.BaseError) {
    constructor({ docsPath: docsPath } = {}){
        super([
            "Could not find an Account to execute with this Action.",
            "Please provide an Account with the `account` argument on the Action, or by supplying an `account` to the Client."
        ].join("\n"), {
            docsPath: docsPath,
            docsSlug: "account",
            name: "AccountNotFoundError"
        });
    }
}
class $bac5fb91181ff447$export$22c1d840ef5fbc66 extends (0, $6F8ii.BaseError) {
    constructor({ docsPath: docsPath, metaMessages: metaMessages, type: type }){
        super(`Account type "${type}" is not supported.`, {
            docsPath: docsPath,
            metaMessages: metaMessages,
            name: "AccountTypeNotSupportedError"
        });
    }
}



var $9UP4H = parcelRequire("9UP4H");
async function $64cacff4b9d56027$export$1d9a7a8a40780de(client, { account: account_ = client.account, message: message }) {
    if (!account_) throw new (0, $bac5fb91181ff447$export$62ee6b05f0767f28)({
        docsPath: "/docs/actions/wallet/signMessage"
    });
    const account = (0, $4I1xa.parseAccount)(account_);
    if (account.signMessage) return account.signMessage({
        message: message
    });
    const message_ = (()=>{
        if (typeof message === "string") return (0, $9UP4H.stringToHex)(message);
        if (message.raw instanceof Uint8Array) return (0, $9UP4H.toHex)(message.raw);
        return message.raw;
    })();
    return client.request({
        method: "personal_sign",
        params: [
            message_,
            account.address
        ]
    }, {
        retryCount: 0
    });
}








var $4I1xa = parcelRequire("4I1xa");
const $d7a8b1425aeaefdf$var$size = 256;
let $d7a8b1425aeaefdf$var$index = $d7a8b1425aeaefdf$var$size;
let $d7a8b1425aeaefdf$var$buffer;
function $d7a8b1425aeaefdf$export$e2a22331486dcca0(length = 11) {
    if (!$d7a8b1425aeaefdf$var$buffer || $d7a8b1425aeaefdf$var$index + length > $d7a8b1425aeaefdf$var$size * 2) {
        $d7a8b1425aeaefdf$var$buffer = "";
        $d7a8b1425aeaefdf$var$index = 0;
        for(let i = 0; i < $d7a8b1425aeaefdf$var$size; i++)$d7a8b1425aeaefdf$var$buffer += (256 + Math.random() * 256 | 0).toString(16).substring(1);
    }
    return $d7a8b1425aeaefdf$var$buffer.substring($d7a8b1425aeaefdf$var$index, $d7a8b1425aeaefdf$var$index++ + length);
}


function $6a8402de2d7ee6e1$export$5d730b7aed1a3eb0(parameters) {
    const { batch: batch, cacheTime: cacheTime = parameters.pollingInterval ?? 4000, ccipRead: ccipRead, key: key = "base", name: name = "Base Client", pollingInterval: pollingInterval = 4000, type: type = "base" } = parameters;
    const chain = parameters.chain;
    const account = parameters.account ? (0, $4I1xa.parseAccount)(parameters.account) : undefined;
    const { config: config, request: request, value: value } = parameters.transport({
        chain: chain,
        pollingInterval: pollingInterval
    });
    const transport = {
        ...config,
        ...value
    };
    const client = {
        account: account,
        batch: batch,
        cacheTime: cacheTime,
        ccipRead: ccipRead,
        chain: chain,
        key: key,
        name: name,
        pollingInterval: pollingInterval,
        request: request,
        transport: transport,
        type: type,
        uid: (0, $d7a8b1425aeaefdf$export$e2a22331486dcca0)()
    };
    function extend(base) {
        return (extendFn)=>{
            const extended = extendFn(base);
            for(const key in client)delete extended[key];
            const combined = {
                ...base,
                ...extended
            };
            return Object.assign(combined, {
                extend: extend(combined)
            });
        };
    }
    return Object.assign(client, {
        extend: extend(client)
    });
}
function $6a8402de2d7ee6e1$export$3db60a9e016ddd81() {
    return null;
}


var $6F8ii = parcelRequire("6F8ii");

var $h1EgD = parcelRequire("h1EgD");

var $k7R6B = parcelRequire("k7R6B");

var $9UP4H = parcelRequire("9UP4H");

var $bRe6l = parcelRequire("bRe6l");

var $kGHiX = parcelRequire("kGHiX");
const $a7cc301497b5b577$export$e89e805418f4d2c = /*#__PURE__*/ new (0, $kGHiX.LruMap)(8192);
function $a7cc301497b5b577$export$387c3b0c09132fc3(fn, { enabled: enabled = true, id: id }) {
    if (!enabled || !id) return fn();
    if ($a7cc301497b5b577$export$e89e805418f4d2c.get(id)) return $a7cc301497b5b577$export$e89e805418f4d2c.get(id);
    const promise = fn().finally(()=>$a7cc301497b5b577$export$e89e805418f4d2c.delete(id));
    $a7cc301497b5b577$export$e89e805418f4d2c.set(id, promise);
    return promise;
}


async function $f3f44fe8be215f3b$export$5c069c93d2b7493f(time) {
    return new Promise((res)=>setTimeout(res, time));
}


function $019d66023bd7f6ee$export$188df5ecf8e7961a(fn, { delay: delay_ = 100, retryCount: retryCount = 2, shouldRetry: shouldRetry = ()=>true } = {}) {
    return new Promise((resolve, reject)=>{
        const attemptRetry = async ({ count: count = 0 } = {})=>{
            const retry = async ({ error: error })=>{
                const delay = typeof delay_ === "function" ? delay_({
                    count: count,
                    error: error
                }) : delay_;
                if (delay) await (0, $f3f44fe8be215f3b$export$5c069c93d2b7493f)(delay);
                attemptRetry({
                    count: count + 1
                });
            };
            try {
                const data = await fn();
                resolve(data);
            } catch (err) {
                if (count < retryCount && await shouldRetry({
                    count: count,
                    error: err
                })) return retry({
                    error: err
                });
                reject(err);
            }
        };
        attemptRetry();
    });
}



var $lOTY7 = parcelRequire("lOTY7");
function $6539131ad68a9a28$export$6c5295ef7e82f2b2(request, options = {}) {
    return async (args, overrideOptions = {})=>{
        const { dedupe: dedupe = false, retryDelay: retryDelay = 150, retryCount: retryCount = 3, uid: uid } = {
            ...options,
            ...overrideOptions
        };
        const requestId = dedupe ? (0, $bRe6l.keccak256)((0, $9UP4H.stringToHex)(`${uid}.${(0, $lOTY7.stringify)(args)}`)) : undefined;
        return (0, $a7cc301497b5b577$export$387c3b0c09132fc3)(()=>(0, $019d66023bd7f6ee$export$188df5ecf8e7961a)(async ()=>{
                try {
                    return await request(args);
                } catch (err_) {
                    const err = err_;
                    switch(err.code){
                        // -32700
                        case (0, $k7R6B.ParseRpcError).code:
                            throw new (0, $k7R6B.ParseRpcError)(err);
                        // -32600
                        case (0, $k7R6B.InvalidRequestRpcError).code:
                            throw new (0, $k7R6B.InvalidRequestRpcError)(err);
                        // -32601
                        case (0, $k7R6B.MethodNotFoundRpcError).code:
                            throw new (0, $k7R6B.MethodNotFoundRpcError)(err, {
                                method: args.method
                            });
                        // -32602
                        case (0, $k7R6B.InvalidParamsRpcError).code:
                            throw new (0, $k7R6B.InvalidParamsRpcError)(err);
                        // -32603
                        case (0, $k7R6B.InternalRpcError).code:
                            throw new (0, $k7R6B.InternalRpcError)(err);
                        // -32000
                        case (0, $k7R6B.InvalidInputRpcError).code:
                            throw new (0, $k7R6B.InvalidInputRpcError)(err);
                        // -32001
                        case (0, $k7R6B.ResourceNotFoundRpcError).code:
                            throw new (0, $k7R6B.ResourceNotFoundRpcError)(err);
                        // -32002
                        case (0, $k7R6B.ResourceUnavailableRpcError).code:
                            throw new (0, $k7R6B.ResourceUnavailableRpcError)(err);
                        // -32003
                        case (0, $k7R6B.TransactionRejectedRpcError).code:
                            throw new (0, $k7R6B.TransactionRejectedRpcError)(err);
                        // -32004
                        case (0, $k7R6B.MethodNotSupportedRpcError).code:
                            throw new (0, $k7R6B.MethodNotSupportedRpcError)(err, {
                                method: args.method
                            });
                        // -32005
                        case (0, $k7R6B.LimitExceededRpcError).code:
                            throw new (0, $k7R6B.LimitExceededRpcError)(err);
                        // -32006
                        case (0, $k7R6B.JsonRpcVersionUnsupportedError).code:
                            throw new (0, $k7R6B.JsonRpcVersionUnsupportedError)(err);
                        // 4001
                        case (0, $k7R6B.UserRejectedRequestError).code:
                            throw new (0, $k7R6B.UserRejectedRequestError)(err);
                        // 4100
                        case (0, $k7R6B.UnauthorizedProviderError).code:
                            throw new (0, $k7R6B.UnauthorizedProviderError)(err);
                        // 4200
                        case (0, $k7R6B.UnsupportedProviderMethodError).code:
                            throw new (0, $k7R6B.UnsupportedProviderMethodError)(err);
                        // 4900
                        case (0, $k7R6B.ProviderDisconnectedError).code:
                            throw new (0, $k7R6B.ProviderDisconnectedError)(err);
                        // 4901
                        case (0, $k7R6B.ChainDisconnectedError).code:
                            throw new (0, $k7R6B.ChainDisconnectedError)(err);
                        // 4902
                        case (0, $k7R6B.SwitchChainError).code:
                            throw new (0, $k7R6B.SwitchChainError)(err);
                        // CAIP-25: User Rejected Error
                        // https://docs.walletconnect.com/2.0/specs/clients/sign/error-codes#rejected-caip-25
                        case 5000:
                            throw new (0, $k7R6B.UserRejectedRequestError)(err);
                        default:
                            if (err_ instanceof (0, $6F8ii.BaseError)) throw err_;
                            throw new (0, $k7R6B.UnknownRpcError)(err);
                    }
                }
            }, {
                delay: ({ count: count, error: error })=>{
                    // If we find a Retry-After header, let's retry after the given time.
                    if (error && error instanceof (0, $h1EgD.HttpRequestError)) {
                        const retryAfter = error?.headers?.get("Retry-After");
                        if (retryAfter?.match(/\d/)) return Number.parseInt(retryAfter) * 1000;
                    }
                    // Otherwise, let's retry with an exponential backoff.
                    return ~~(1 << count) * retryDelay;
                },
                retryCount: retryCount,
                shouldRetry: ({ error: error })=>$6539131ad68a9a28$export$7bfea3c3d460ecd8(error)
            }), {
            enabled: dedupe,
            id: requestId
        });
    };
}
function $6539131ad68a9a28$export$7bfea3c3d460ecd8(error) {
    if ("code" in error && typeof error.code === "number") {
        if (error.code === -1) return true; // Unknown error
        if (error.code === (0, $k7R6B.LimitExceededRpcError).code) return true;
        if (error.code === (0, $k7R6B.InternalRpcError).code) return true;
        return false;
    }
    if (error instanceof (0, $h1EgD.HttpRequestError) && error.status) {
        // Forbidden
        if (error.status === 403) return true;
        // Request Timeout
        if (error.status === 408) return true;
        // Request Entity Too Large
        if (error.status === 413) return true;
        // Too Many Requests
        if (error.status === 429) return true;
        // Internal Server Error
        if (error.status === 500) return true;
        // Bad Gateway
        if (error.status === 502) return true;
        // Service Unavailable
        if (error.status === 503) return true;
        // Gateway Timeout
        if (error.status === 504) return true;
        return false;
    }
    return true;
}



function $c589f4bfc5acd4e5$export$d09f50d9ab7f7b69({ key: key, name: name, request: request, retryCount: retryCount = 3, retryDelay: retryDelay = 150, timeout: timeout, type: type }, value) {
    const uid = (0, $d7a8b1425aeaefdf$export$e2a22331486dcca0)();
    return {
        config: {
            key: key,
            name: name,
            request: request,
            retryCount: retryCount,
            retryDelay: retryDelay,
            timeout: timeout,
            type: type
        },
        request: (0, $6539131ad68a9a28$export$6c5295ef7e82f2b2)(request, {
            retryCount: retryCount,
            retryDelay: retryDelay,
            uid: uid
        }),
        value: value
    };
}


function $11d4efd0771a10a6$export$4c00f665f0d4b443(provider, config = {}) {
    const { key: key = "custom", name: name = "Custom Provider", retryDelay: retryDelay } = config;
    return ({ retryCount: defaultRetryCount })=>(0, $c589f4bfc5acd4e5$export$d09f50d9ab7f7b69)({
            key: key,
            name: name,
            request: provider.request.bind(provider),
            retryCount: config.retryCount ?? defaultRetryCount,
            retryDelay: retryDelay,
            type: "custom"
        });
}



var $lqRRD = parcelRequire("lqRRD");
var $4I1xa = parcelRequire("4I1xa");


async function $e3e32fb49fb7f56b$export$d784801ca17b4aec(config, parameters = {}) {
    // Get connection
    let connection;
    if (parameters.connector) {
        const { connector: connector } = parameters;
        const [accounts, chainId] = await Promise.all([
            connector.getAccounts(),
            connector.getChainId()
        ]);
        connection = {
            accounts: accounts,
            chainId: chainId,
            connector: connector
        };
    } else connection = config.state.connections.get(config.state.current);
    if (!connection) throw new (0, $e9e19674d26bdf1a$export$d9a3828eace037a6)();
    const chainId = parameters.chainId ?? connection.chainId;
    const connector = connection.connector;
    if (connector.getClient) return connector.getClient({
        chainId: chainId
    });
    // Default using `custom` transport
    const account = (0, $4I1xa.parseAccount)(parameters.account ?? connection.accounts[0]);
    account.address = (0, $lqRRD.getAddress)(account.address); // TODO: Checksum address as part of `parseAccount`?
    const chain = config.chains.find((chain)=>chain.id === chainId);
    const provider = await connection.connector.getProvider({
        chainId: chainId
    });
    // if account was provided, check that it exists on the connector
    if (parameters.account && !connection.accounts.some((x)=>x.toLowerCase() === account.address.toLowerCase())) throw new (0, $e9e19674d26bdf1a$export$65c369a969e2c62e)({
        address: account.address,
        connector: connector
    });
    return (0, $6a8402de2d7ee6e1$export$5d730b7aed1a3eb0)({
        account: account,
        chain: chain,
        name: "Connector Client",
        transport: (opts)=>(0, $11d4efd0771a10a6$export$4c00f665f0d4b443)(provider)({
                ...opts,
                retryCount: 0
            })
    });
}


async function $97f5eab29dd3b733$export$1d9a7a8a40780de(config, parameters) {
    const { account: account, connector: connector, ...rest } = parameters;
    let client;
    if (typeof account === "object" && account.type === "local") client = config.getClient();
    else client = await (0, $e3e32fb49fb7f56b$export$d784801ca17b4aec)(config, {
        account: account,
        connector: connector
    });
    const action = (0, $df792fac4f6f7de9$export$6ca3170acb89054)(client, (0, $64cacff4b9d56027$export$1d9a7a8a40780de), "signMessage");
    return action({
        ...rest,
        ...account ? {
            account: account
        } : {}
    });
}





class $2c3d10fbf0154625$export$43839b3ff6336f15 extends (0, $23921cb92fbd5cef$export$a490eb03cb7a0a5e) {
    constructor(){
        super("Provider not found.");
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "ProviderNotFoundError"
        });
    }
}
class $2c3d10fbf0154625$export$a4296a4b7763e5d8 extends (0, $23921cb92fbd5cef$export$a490eb03cb7a0a5e) {
    constructor({ connector: connector }){
        super(`"${connector.name}" does not support programmatic chain switching.`);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "SwitchChainNotSupportedError"
        });
    }
}



async function $c901df8c4828f5ee$export$15599da40e72d2f(config, parameters) {
    const { addEthereumChainParameter: addEthereumChainParameter, chainId: chainId } = parameters;
    const connection = config.state.connections.get(parameters.connector?.uid ?? config.state.current);
    if (connection) {
        const connector = connection.connector;
        if (!connector.switchChain) throw new (0, $2c3d10fbf0154625$export$a4296a4b7763e5d8)({
            connector: connector
        });
        const chain = await connector.switchChain({
            addEthereumChainParameter: addEthereumChainParameter,
            chainId: chainId
        });
        return chain;
    }
    const chain = config.chains.find((x)=>x.id === chainId);
    if (!chain) throw new (0, $e9e19674d26bdf1a$export$688e5fda4b4631ed)();
    config.setState((x)=>({
            ...x,
            chainId: chainId
        }));
    return chain;
}


/** Forked from https://github.com/epoberezkin/fast-deep-equal */ function $6efb6ef5b61b5026$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    if (a && b && typeof a === "object" && typeof b === "object") {
        if (a.constructor !== b.constructor) return false;
        let length;
        let i;
        if (Array.isArray(a) && Array.isArray(b)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;)if (!$6efb6ef5b61b5026$export$9cb4719e2e525b7a(a[i], b[i])) return false;
            return true;
        }
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        const keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key && !$6efb6ef5b61b5026$export$9cb4719e2e525b7a(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    // biome-ignore lint/suspicious/noSelfCompare: <explanation>
    return a !== a && b !== b;
}



function $de8ec52414ac50d6$export$30c94aeff2da2ac6(config, parameters) {
    const { onChange: onChange } = parameters;
    return config.subscribe(()=>(0, $135a5279acb2ac27$export$4f9234baf34abd0)(config), onChange, {
        equalityFn (a, b) {
            const { connector: aConnector, ...aRest } = a;
            const { connector: bConnector, ...bRest } = b;
            return (0, $6efb6ef5b61b5026$export$9cb4719e2e525b7a)(aRest, bRest) && // check connector separately
            aConnector?.id === bConnector?.id && aConnector?.uid === bConnector?.uid;
        }
    });
}



function $6e12989ef2b0dce4$export$9c8eec0a0da048a0(config, parameters) {
    const { onChange: onChange } = parameters;
    return config._internal.connectors.subscribe((connectors, prevConnectors)=>{
        onChange(Object.values(connectors), prevConnectors);
    });
}


function $bcc18d892337011b$export$b6380ff64616a4fb(chain) {
    return {
        formatters: undefined,
        fees: undefined,
        serializers: undefined,
        ...chain
    };
}


const $fcacb2d075a52fce$export$536d3e0d2c7baf54 = /*#__PURE__*/ (0, $bcc18d892337011b$export$b6380ff64616a4fb)({
    id: 1,
    name: "Ethereum",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://cloudflare-eth.com"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "Etherscan",
            url: "https://etherscan.io",
            apiUrl: "https://api.etherscan.io/api"
        }
    },
    contracts: {
        ensRegistry: {
            address: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
        },
        ensUniversalResolver: {
            address: "0xce01f8eee7E479C928F8919abD53E553a36CeF67",
            blockCreated: 19258213
        },
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 14353601
        }
    }
});


parcelRequire("aAJP9");
var $5mrMQ = parcelRequire("5mrMQ");
var $7XY6i = parcelRequire("7XY6i");
var $kGR8V = parcelRequire("kGR8V");
var $bnxqc = parcelRequire("bnxqc");
var $b6tQF = parcelRequire("b6tQF");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $5YVCx = parcelRequire("5YVCx");
var $6eT5F = parcelRequire("6eT5F");

var $6HMh7 = parcelRequire("6HMh7");
/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $7cc46e76860b3b4c$export$f68dd208b5df064d = (t)=>t ?? (0, $6HMh7.nothing);




var $07bc4c51f077bc7f$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $07bc4c51f077bc7f$export$f039a2838669d98e = class W3mAccountButton extends (0, $b47AP.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.disabled = false;
        this.balance = "show";
        this.charsStart = 4;
        this.charsEnd = 6;
        this.address = (0, $5mrMQ.AccountController).state.address;
        this.balanceVal = (0, $5mrMQ.AccountController).state.balance;
        this.balanceSymbol = (0, $5mrMQ.AccountController).state.balanceSymbol;
        this.profileName = (0, $5mrMQ.AccountController).state.profileName;
        this.profileImage = (0, $5mrMQ.AccountController).state.profileImage;
        this.network = (0, $b6tQF.NetworkController).state.caipNetwork;
        this.isUnsupportedChain = (0, $b6tQF.NetworkController).state.isUnsupportedChain;
        this.unsubscribe.push(...[
            (0, $5mrMQ.AccountController).subscribe((val)=>{
                if (val.isConnected) {
                    this.address = val.address;
                    this.balanceVal = val.balance;
                    this.profileName = val.profileName;
                    this.profileImage = val.profileImage;
                    this.balanceSymbol = val.balanceSymbol;
                } else {
                    this.address = "";
                    this.balanceVal = "";
                    this.profileName = "";
                    this.profileImage = "";
                    this.balanceSymbol = "";
                }
            }),
            (0, $b6tQF.NetworkController).subscribeKey("caipNetwork", (val)=>this.network = val),
            (0, $b6tQF.NetworkController).subscribeKey("isUnsupportedChain", (val)=>this.isUnsupportedChain = val)
        ]);
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        const networkImage = (0, $7XY6i.AssetUtil).getNetworkImage(this.network);
        const showBalance = this.balance === "show";
        return (0, $6HMh7.html)`
      <wui-account-button
        .disabled=${Boolean(this.disabled)}
        .isUnsupportedChain=${this.isUnsupportedChain}
        address=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)(this.profileName ?? this.address)}
        ?isProfileName=${Boolean(this.profileName)}
        networkSrc=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)(networkImage)}
        avatarSrc=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)(this.profileImage)}
        balance=${showBalance ? (0, $kGR8V.CoreHelperUtil).formatBalance(this.balanceVal, this.balanceSymbol) : ""}
        @click=${this.onClick.bind(this)}
        data-testid="account-button"
        .charsStart=${this.charsStart}
        .charsEnd=${this.charsEnd}
      >
      </wui-account-button>
    `;
    }
    onClick() {
        if (this.isUnsupportedChain) (0, $bnxqc.ModalController).open({
            view: "UnsupportedChain"
        });
        else (0, $bnxqc.ModalController).open();
    }
};
$07bc4c51f077bc7f$var$__decorate([
    (0, $5YVCx.property)({
        type: Boolean
    })
], $07bc4c51f077bc7f$export$f039a2838669d98e.prototype, "disabled", void 0);
$07bc4c51f077bc7f$var$__decorate([
    (0, $5YVCx.property)()
], $07bc4c51f077bc7f$export$f039a2838669d98e.prototype, "balance", void 0);
$07bc4c51f077bc7f$var$__decorate([
    (0, $5YVCx.property)()
], $07bc4c51f077bc7f$export$f039a2838669d98e.prototype, "charsStart", void 0);
$07bc4c51f077bc7f$var$__decorate([
    (0, $5YVCx.property)()
], $07bc4c51f077bc7f$export$f039a2838669d98e.prototype, "charsEnd", void 0);
$07bc4c51f077bc7f$var$__decorate([
    (0, $6eT5F.state)()
], $07bc4c51f077bc7f$export$f039a2838669d98e.prototype, "address", void 0);
$07bc4c51f077bc7f$var$__decorate([
    (0, $6eT5F.state)()
], $07bc4c51f077bc7f$export$f039a2838669d98e.prototype, "balanceVal", void 0);
$07bc4c51f077bc7f$var$__decorate([
    (0, $6eT5F.state)()
], $07bc4c51f077bc7f$export$f039a2838669d98e.prototype, "balanceSymbol", void 0);
$07bc4c51f077bc7f$var$__decorate([
    (0, $6eT5F.state)()
], $07bc4c51f077bc7f$export$f039a2838669d98e.prototype, "profileName", void 0);
$07bc4c51f077bc7f$var$__decorate([
    (0, $6eT5F.state)()
], $07bc4c51f077bc7f$export$f039a2838669d98e.prototype, "profileImage", void 0);
$07bc4c51f077bc7f$var$__decorate([
    (0, $6eT5F.state)()
], $07bc4c51f077bc7f$export$f039a2838669d98e.prototype, "network", void 0);
$07bc4c51f077bc7f$var$__decorate([
    (0, $6eT5F.state)()
], $07bc4c51f077bc7f$export$f039a2838669d98e.prototype, "isUnsupportedChain", void 0);
$07bc4c51f077bc7f$export$f039a2838669d98e = $07bc4c51f077bc7f$var$__decorate([
    (0, $lkv4o.customElement)("w3m-account-button")
], $07bc4c51f077bc7f$export$f039a2838669d98e);


parcelRequire("aAJP9");
var $5mrMQ = parcelRequire("5mrMQ");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $5YVCx = parcelRequire("5YVCx");
var $6eT5F = parcelRequire("6eT5F");

parcelRequire("5bcND");
var $kq2WI = parcelRequire("kq2WI");
var $9c45dfb1577af064$export$2e2bcd8739ae039 = (0, $kq2WI.css)`
  :host {
    display: block;
    width: max-content;
  }
`;


var $47d54af2105f5dba$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $47d54af2105f5dba$export$857f19a8cabe3497 = class W3mButton extends (0, $b47AP.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.disabled = false;
        this.balance = undefined;
        this.size = undefined;
        this.label = undefined;
        this.loadingLabel = undefined;
        this.charsStart = 4;
        this.charsEnd = 6;
        this.isAccount = (0, $5mrMQ.AccountController).state.isConnected;
        this.unsubscribe.push((0, $5mrMQ.AccountController).subscribeKey("isConnected", (val)=>{
            this.isAccount = val;
        }));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return this.isAccount ? (0, $6HMh7.html)`
          <w3m-account-button
            .disabled=${Boolean(this.disabled)}
            balance=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)(this.balance)}
            .charsStart=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)(this.charsStart)}
            .charsEnd=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)(this.charsEnd)}
          >
          </w3m-account-button>
        ` : (0, $6HMh7.html)`
          <w3m-connect-button
            size=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)(this.size)}
            label=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)(this.label)}
            loadingLabel=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)(this.loadingLabel)}
          ></w3m-connect-button>
        `;
    }
};
$47d54af2105f5dba$export$857f19a8cabe3497.styles = (0, $9c45dfb1577af064$export$2e2bcd8739ae039);
$47d54af2105f5dba$var$__decorate([
    (0, $5YVCx.property)({
        type: Boolean
    })
], $47d54af2105f5dba$export$857f19a8cabe3497.prototype, "disabled", void 0);
$47d54af2105f5dba$var$__decorate([
    (0, $5YVCx.property)()
], $47d54af2105f5dba$export$857f19a8cabe3497.prototype, "balance", void 0);
$47d54af2105f5dba$var$__decorate([
    (0, $5YVCx.property)()
], $47d54af2105f5dba$export$857f19a8cabe3497.prototype, "size", void 0);
$47d54af2105f5dba$var$__decorate([
    (0, $5YVCx.property)()
], $47d54af2105f5dba$export$857f19a8cabe3497.prototype, "label", void 0);
$47d54af2105f5dba$var$__decorate([
    (0, $5YVCx.property)()
], $47d54af2105f5dba$export$857f19a8cabe3497.prototype, "loadingLabel", void 0);
$47d54af2105f5dba$var$__decorate([
    (0, $5YVCx.property)()
], $47d54af2105f5dba$export$857f19a8cabe3497.prototype, "charsStart", void 0);
$47d54af2105f5dba$var$__decorate([
    (0, $5YVCx.property)()
], $47d54af2105f5dba$export$857f19a8cabe3497.prototype, "charsEnd", void 0);
$47d54af2105f5dba$var$__decorate([
    (0, $6eT5F.state)()
], $47d54af2105f5dba$export$857f19a8cabe3497.prototype, "isAccount", void 0);
$47d54af2105f5dba$export$857f19a8cabe3497 = $47d54af2105f5dba$var$__decorate([
    (0, $lkv4o.customElement)("w3m-button")
], $47d54af2105f5dba$export$857f19a8cabe3497);


parcelRequire("aAJP9");
var $bnxqc = parcelRequire("bnxqc");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $5YVCx = parcelRequire("5YVCx");
var $6eT5F = parcelRequire("6eT5F");

var $f27c28e1202e6ac8$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $f27c28e1202e6ac8$export$277240c185e0322e = class W3mConnectButton extends (0, $b47AP.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.size = "md";
        this.label = "Connect Wallet";
        this.loadingLabel = "Connecting...";
        this.open = (0, $bnxqc.ModalController).state.open;
        this.loading = (0, $bnxqc.ModalController).state.loading;
        this.unsubscribe.push((0, $bnxqc.ModalController).subscribe((val)=>{
            this.open = val.open;
            this.loading = val.loading;
        }));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        const isLoading = this.loading || this.open;
        return (0, $6HMh7.html)`
      <wui-connect-button
        size=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)(this.size)}
        .loading=${isLoading}
        @click=${this.onClick.bind(this)}
        data-testid="connect-button"
      >
        ${isLoading ? this.loadingLabel : this.label}
      </wui-connect-button>
    `;
    }
    onClick() {
        if (this.open) (0, $bnxqc.ModalController).close();
        else if (!this.loading) (0, $bnxqc.ModalController).open();
    }
};
$f27c28e1202e6ac8$var$__decorate([
    (0, $5YVCx.property)()
], $f27c28e1202e6ac8$export$277240c185e0322e.prototype, "size", void 0);
$f27c28e1202e6ac8$var$__decorate([
    (0, $5YVCx.property)()
], $f27c28e1202e6ac8$export$277240c185e0322e.prototype, "label", void 0);
$f27c28e1202e6ac8$var$__decorate([
    (0, $5YVCx.property)()
], $f27c28e1202e6ac8$export$277240c185e0322e.prototype, "loadingLabel", void 0);
$f27c28e1202e6ac8$var$__decorate([
    (0, $6eT5F.state)()
], $f27c28e1202e6ac8$export$277240c185e0322e.prototype, "open", void 0);
$f27c28e1202e6ac8$var$__decorate([
    (0, $6eT5F.state)()
], $f27c28e1202e6ac8$export$277240c185e0322e.prototype, "loading", void 0);
$f27c28e1202e6ac8$export$277240c185e0322e = $f27c28e1202e6ac8$var$__decorate([
    (0, $lkv4o.customElement)("w3m-connect-button")
], $f27c28e1202e6ac8$export$277240c185e0322e);


parcelRequire("a4aTY");
parcelRequire("aAJP9");
var $5mrMQ = parcelRequire("5mrMQ");
var $7XY6i = parcelRequire("7XY6i");
var $6n0eX = parcelRequire("6n0eX");
var $bnxqc = parcelRequire("bnxqc");
var $b6tQF = parcelRequire("b6tQF");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $5YVCx = parcelRequire("5YVCx");
var $6eT5F = parcelRequire("6eT5F");

parcelRequire("5bcND");
var $kq2WI = parcelRequire("kq2WI");
var $b8f30ab5c8a9a1fb$export$2e2bcd8739ae039 = (0, $kq2WI.css)`
  :host {
    display: block;
    width: max-content;
  }
`;


var $a4858e83b3bb15ac$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $a4858e83b3bb15ac$export$28375bf34267491c = class W3mNetworkButton extends (0, $b47AP.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.disabled = false;
        this.network = (0, $b6tQF.NetworkController).state.caipNetwork;
        this.connected = (0, $5mrMQ.AccountController).state.isConnected;
        this.loading = (0, $bnxqc.ModalController).state.loading;
        this.isUnsupportedChain = (0, $b6tQF.NetworkController).state.isUnsupportedChain;
        this.unsubscribe.push(...[
            (0, $b6tQF.NetworkController).subscribeKey("caipNetwork", (val)=>this.network = val),
            (0, $5mrMQ.AccountController).subscribeKey("isConnected", (val)=>this.connected = val),
            (0, $bnxqc.ModalController).subscribeKey("loading", (val)=>this.loading = val),
            (0, $b6tQF.NetworkController).subscribeKey("isUnsupportedChain", (val)=>this.isUnsupportedChain = val)
        ]);
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $6HMh7.html)`
      <wui-network-button
        .disabled=${Boolean(this.disabled || this.loading)}
        .isUnsupportedChain=${this.isUnsupportedChain}
        imageSrc=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)((0, $7XY6i.AssetUtil).getNetworkImage(this.network))}
        @click=${this.onClick.bind(this)}
      >
        ${this.isUnsupportedChain ? "Switch Network" : this.network?.name ?? (this.connected ? "Unknown Network" : "Select Network")}
      </wui-network-button>
    `;
    }
    onClick() {
        if (!this.loading) {
            (0, $6n0eX.EventsController).sendEvent({
                type: "track",
                event: "CLICK_NETWORKS"
            });
            (0, $bnxqc.ModalController).open({
                view: "Networks"
            });
        }
    }
};
$a4858e83b3bb15ac$export$28375bf34267491c.styles = (0, $b8f30ab5c8a9a1fb$export$2e2bcd8739ae039);
$a4858e83b3bb15ac$var$__decorate([
    (0, $5YVCx.property)({
        type: Boolean
    })
], $a4858e83b3bb15ac$export$28375bf34267491c.prototype, "disabled", void 0);
$a4858e83b3bb15ac$var$__decorate([
    (0, $6eT5F.state)()
], $a4858e83b3bb15ac$export$28375bf34267491c.prototype, "network", void 0);
$a4858e83b3bb15ac$var$__decorate([
    (0, $6eT5F.state)()
], $a4858e83b3bb15ac$export$28375bf34267491c.prototype, "connected", void 0);
$a4858e83b3bb15ac$var$__decorate([
    (0, $6eT5F.state)()
], $a4858e83b3bb15ac$export$28375bf34267491c.prototype, "loading", void 0);
$a4858e83b3bb15ac$var$__decorate([
    (0, $6eT5F.state)()
], $a4858e83b3bb15ac$export$28375bf34267491c.prototype, "isUnsupportedChain", void 0);
$a4858e83b3bb15ac$export$28375bf34267491c = $a4858e83b3bb15ac$var$__decorate([
    (0, $lkv4o.customElement)("w3m-network-button")
], $a4858e83b3bb15ac$export$28375bf34267491c);


parcelRequire("aAJP9");
var $dJjpc = parcelRequire("dJjpc");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $6eT5F = parcelRequire("6eT5F");
parcelRequire("5bcND");
var $kq2WI = parcelRequire("kq2WI");
var $5a628c322514ffb5$export$2e2bcd8739ae039 = (0, $kq2WI.css)`
  :host {
    display: block;
    will-change: transform, opacity;
  }
`;


var $90927d379b6b81b2$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $90927d379b6b81b2$export$ccc15c9e32141a55 = class W3mRouter extends (0, $b47AP.LitElement) {
    constructor(){
        super();
        this.resizeObserver = undefined;
        this.prevHeight = "0px";
        this.prevHistoryLength = 1;
        this.unsubscribe = [];
        this.view = (0, $dJjpc.RouterController).state.view;
        this.unsubscribe.push((0, $dJjpc.RouterController).subscribeKey("view", (val)=>this.onViewChange(val)));
    }
    firstUpdated() {
        this.resizeObserver = new ResizeObserver(async ([content])=>{
            const height = `${content?.contentRect.height}px`;
            if (this.prevHeight !== "0px") {
                await this.animate([
                    {
                        height: this.prevHeight
                    },
                    {
                        height: height
                    }
                ], {
                    duration: 150,
                    easing: "ease",
                    fill: "forwards"
                }).finished;
                this.style.height = "auto";
            }
            this.prevHeight = height;
        });
        this.resizeObserver.observe(this.getWrapper());
    }
    disconnectedCallback() {
        this.resizeObserver?.unobserve(this.getWrapper());
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $6HMh7.html)`<div>${this.viewTemplate()}</div>`;
    }
    viewTemplate() {
        switch(this.view){
            case "Connect":
                return (0, $6HMh7.html)`<w3m-connect-view></w3m-connect-view>`;
            case "ConnectingWalletConnect":
                return (0, $6HMh7.html)`<w3m-connecting-wc-view></w3m-connecting-wc-view>`;
            case "ConnectingExternal":
                return (0, $6HMh7.html)`<w3m-connecting-external-view></w3m-connecting-external-view>`;
            case "ConnectingSiwe":
                return (0, $6HMh7.html)`<w3m-connecting-siwe-view></w3m-connecting-siwe-view>`;
            case "AllWallets":
                return (0, $6HMh7.html)`<w3m-all-wallets-view></w3m-all-wallets-view>`;
            case "Networks":
                return (0, $6HMh7.html)`<w3m-networks-view></w3m-networks-view>`;
            case "SwitchNetwork":
                return (0, $6HMh7.html)`<w3m-network-switch-view></w3m-network-switch-view>`;
            case "Account":
                return (0, $6HMh7.html)`<w3m-account-view></w3m-account-view>`;
            case "AccountSettings":
                return (0, $6HMh7.html)`<w3m-account-settings-view></w3m-account-settings-view>`;
            case "WhatIsAWallet":
                return (0, $6HMh7.html)`<w3m-what-is-a-wallet-view></w3m-what-is-a-wallet-view>`;
            case "WhatIsANetwork":
                return (0, $6HMh7.html)`<w3m-what-is-a-network-view></w3m-what-is-a-network-view>`;
            case "GetWallet":
                return (0, $6HMh7.html)`<w3m-get-wallet-view></w3m-get-wallet-view>`;
            case "Downloads":
                return (0, $6HMh7.html)`<w3m-downloads-view></w3m-downloads-view>`;
            case "EmailVerifyOtp":
                return (0, $6HMh7.html)`<w3m-email-verify-otp-view></w3m-email-verify-otp-view>`;
            case "EmailVerifyDevice":
                return (0, $6HMh7.html)`<w3m-email-verify-device-view></w3m-email-verify-device-view>`;
            case "ApproveTransaction":
                return (0, $6HMh7.html)`<w3m-approve-transaction-view></w3m-approve-transaction-view>`;
            case "Transactions":
                return (0, $6HMh7.html)`<w3m-transactions-view></w3m-transactions-view>`;
            case "UpgradeEmailWallet":
                return (0, $6HMh7.html)`<w3m-upgrade-wallet-view></w3m-upgrade-wallet-view>`;
            case "UpdateEmailWallet":
                return (0, $6HMh7.html)`<w3m-update-email-wallet-view></w3m-update-email-wallet-view>`;
            case "UpdateEmailPrimaryOtp":
                return (0, $6HMh7.html)`<w3m-update-email-primary-otp-view></w3m-update-email-primary-otp-view>`;
            case "UpdateEmailSecondaryOtp":
                return (0, $6HMh7.html)`<w3m-update-email-secondary-otp-view></w3m-update-email-secondary-otp-view>`;
            case "UnsupportedChain":
                return (0, $6HMh7.html)`<w3m-unsupported-chain-view></w3m-unsupported-chain-view>`;
            case "OnRampProviders":
                return (0, $6HMh7.html)`<w3m-onramp-providers-view></w3m-onramp-providers-view>`;
            case "OnRampActivity":
                return (0, $6HMh7.html)`<w3m-onramp-activity-view></w3m-onramp-activity-view>`;
            case "OnRampTokenSelect":
                return (0, $6HMh7.html)`<w3m-onramp-token-select-view></w3m-onramp-token-select-view>`;
            case "OnRampFiatSelect":
                return (0, $6HMh7.html)`<w3m-onramp-fiat-select-view></w3m-onramp-fiat-select-view>`;
            case "WhatIsABuy":
                return (0, $6HMh7.html)`<w3m-what-is-a-buy-view></w3m-what-is-a-buy-view>`;
            case "BuyInProgress":
                return (0, $6HMh7.html)`<w3m-buy-in-progress-view></w3m-buy-in-progress-view>`;
            default:
                return (0, $6HMh7.html)`<w3m-connect-view></w3m-connect-view>`;
        }
    }
    async onViewChange(newView) {
        const { history: history } = (0, $dJjpc.RouterController).state;
        let xOut = -10;
        let xIn = 10;
        if (history.length < this.prevHistoryLength) {
            xOut = 10;
            xIn = -10;
        }
        this.prevHistoryLength = history.length;
        await this.animate([
            {
                opacity: 1,
                transform: "translateX(0px)"
            },
            {
                opacity: 0,
                transform: `translateX(${xOut}px)`
            }
        ], {
            duration: 150,
            easing: "ease",
            fill: "forwards"
        }).finished;
        this.view = newView;
        await this.animate([
            {
                opacity: 0,
                transform: `translateX(${xIn}px)`
            },
            {
                opacity: 1,
                transform: "translateX(0px)"
            }
        ], {
            duration: 150,
            easing: "ease",
            fill: "forwards",
            delay: 50
        }).finished;
    }
    getWrapper() {
        return this.shadowRoot?.querySelector("div");
    }
};
$90927d379b6b81b2$export$ccc15c9e32141a55.styles = (0, $5a628c322514ffb5$export$2e2bcd8739ae039);
$90927d379b6b81b2$var$__decorate([
    (0, $6eT5F.state)()
], $90927d379b6b81b2$export$ccc15c9e32141a55.prototype, "view", void 0);
$90927d379b6b81b2$export$ccc15c9e32141a55 = $90927d379b6b81b2$var$__decorate([
    (0, $lkv4o.customElement)("w3m-router")
], $90927d379b6b81b2$export$ccc15c9e32141a55);


parcelRequire("aAJP9");
var $5mrMQ = parcelRequire("5mrMQ");
var $bnxqc = parcelRequire("bnxqc");
var $ahDsO = parcelRequire("ahDsO");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $5YVCx = parcelRequire("5YVCx");
var $6eT5F = parcelRequire("6eT5F");
parcelRequire("5bcND");
var $kq2WI = parcelRequire("kq2WI");
var $6724babe5d46b437$export$2e2bcd8739ae039 = (0, $kq2WI.css)`
  :host > wui-flex {
    width: 100%;
    max-width: 360px;
  }

  :host > wui-flex > wui-flex {
    border-radius: var(--wui-border-radius-l);
    width: 100%;
  }

  .amounts-container {
    width: 100%;
  }
`;


var $b76af5c3932183e1$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $b76af5c3932183e1$var$PAYMENT_CURRENCY_SYMBOLS = {
    USD: "$",
    EUR: "\u20AC",
    GBP: "\xa3"
};
const $b76af5c3932183e1$var$BUY_PRESET_AMOUNTS = [
    100,
    250,
    500,
    1000
];
let $b76af5c3932183e1$export$33bc4f3e369ccb5f = class W3mOnrampWidget extends (0, $b47AP.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.disabled = false;
        this.connected = (0, $5mrMQ.AccountController).state.isConnected;
        this.loading = (0, $bnxqc.ModalController).state.loading;
        this.paymentCurrency = (0, $ahDsO.OnRampController).state.paymentCurrency;
        this.paymentAmount = (0, $ahDsO.OnRampController).state.paymentAmount;
        this.purchaseAmount = (0, $ahDsO.OnRampController).state.purchaseAmount;
        this.quoteLoading = (0, $ahDsO.OnRampController).state.quotesLoading;
        this.unsubscribe.push(...[
            (0, $5mrMQ.AccountController).subscribeKey("isConnected", (val)=>{
                this.connected = val;
            }),
            (0, $bnxqc.ModalController).subscribeKey("loading", (val)=>{
                this.loading = val;
            }),
            (0, $ahDsO.OnRampController).subscribe((val)=>{
                this.paymentCurrency = val.paymentCurrency;
                this.paymentAmount = val.paymentAmount;
                this.purchaseAmount = val.purchaseAmount;
                this.quoteLoading = val.quotesLoading;
            })
        ]);
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $6HMh7.html)`
      <wui-flex flexDirection="column" justifyContent="center" alignItems="center">
        <wui-flex flexDirection="column" alignItems="center" gap="xs">
          <w3m-swap-input
            type="Fiat"
            @inputChange=${this.onPaymentAmountChange.bind(this)}
            .value=${this.paymentAmount || 0}
          ></w3m-swap-input>
          <w3m-swap-input
            type="Token"
            .value=${this.purchaseAmount || 0}
            .loading=${this.quoteLoading}
          ></w3m-swap-input>
          <wui-flex justifyContent="space-evenly" class="amounts-container" gap="xs">
            ${$b76af5c3932183e1$var$BUY_PRESET_AMOUNTS.map((amount)=>(0, $6HMh7.html)`<wui-button
                  variant=${this.paymentAmount === amount ? "accentBg" : "shade"}
                  size="xs"
                  textVariant="paragraph-600"
                  fullWidth
                  @click=${()=>this.selectPresetAmount(amount)}
                  >${`${$b76af5c3932183e1$var$PAYMENT_CURRENCY_SYMBOLS[this.paymentCurrency?.id || "USD"]} ${amount}`}</wui-button
                >`)}
          </wui-flex>
          ${this.templateButton()}
        </wui-flex>
      </wui-flex>
    `;
    }
    templateButton() {
        return this.connected ? (0, $6HMh7.html)`<wui-button
          @click=${this.getQuotes.bind(this)}
          variant="fill"
          fullWidth
          size="lg"
          borderRadius="xs"
        >
          Get quotes
        </wui-button>` : (0, $6HMh7.html)`<wui-button
          @click=${this.openModal.bind(this)}
          variant="accentBg"
          fullWidth
          size="lg"
          borderRadius="xs"
        >
          Connect wallet
        </wui-button>`;
    }
    getQuotes() {
        if (!this.loading) (0, $bnxqc.ModalController).open({
            view: "OnRampProviders"
        });
    }
    openModal() {
        (0, $bnxqc.ModalController).open({
            view: "Connect"
        });
    }
    async onPaymentAmountChange(event) {
        (0, $ahDsO.OnRampController).setPaymentAmount(Number(event.detail));
        await (0, $ahDsO.OnRampController).getQuote();
    }
    async selectPresetAmount(amount) {
        (0, $ahDsO.OnRampController).setPaymentAmount(amount);
        await (0, $ahDsO.OnRampController).getQuote();
    }
};
$b76af5c3932183e1$export$33bc4f3e369ccb5f.styles = (0, $6724babe5d46b437$export$2e2bcd8739ae039);
$b76af5c3932183e1$var$__decorate([
    (0, $5YVCx.property)({
        type: Boolean
    })
], $b76af5c3932183e1$export$33bc4f3e369ccb5f.prototype, "disabled", void 0);
$b76af5c3932183e1$var$__decorate([
    (0, $6eT5F.state)()
], $b76af5c3932183e1$export$33bc4f3e369ccb5f.prototype, "connected", void 0);
$b76af5c3932183e1$var$__decorate([
    (0, $6eT5F.state)()
], $b76af5c3932183e1$export$33bc4f3e369ccb5f.prototype, "loading", void 0);
$b76af5c3932183e1$var$__decorate([
    (0, $6eT5F.state)()
], $b76af5c3932183e1$export$33bc4f3e369ccb5f.prototype, "paymentCurrency", void 0);
$b76af5c3932183e1$var$__decorate([
    (0, $6eT5F.state)()
], $b76af5c3932183e1$export$33bc4f3e369ccb5f.prototype, "paymentAmount", void 0);
$b76af5c3932183e1$var$__decorate([
    (0, $6eT5F.state)()
], $b76af5c3932183e1$export$33bc4f3e369ccb5f.prototype, "purchaseAmount", void 0);
$b76af5c3932183e1$var$__decorate([
    (0, $6eT5F.state)()
], $b76af5c3932183e1$export$33bc4f3e369ccb5f.prototype, "quoteLoading", void 0);
$b76af5c3932183e1$export$33bc4f3e369ccb5f = $b76af5c3932183e1$var$__decorate([
    (0, $lkv4o.customElement)("w3m-onramp-widget")
], $b76af5c3932183e1$export$33bc4f3e369ccb5f);


parcelRequire("aAJP9");
var $5mrMQ = parcelRequire("5mrMQ");
var $hCakD = parcelRequire("hCakD");
var $jJO2B = parcelRequire("jJO2B");
var $kGR8V = parcelRequire("kGR8V");
var $6n0eX = parcelRequire("6n0eX");
var $bnxqc = parcelRequire("bnxqc");
var $b6tQF = parcelRequire("b6tQF");
var $dJjpc = parcelRequire("dJjpc");
var $9fh1I = parcelRequire("9fh1I");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
var $97bbL = parcelRequire("97bbL");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $6eT5F = parcelRequire("6eT5F");

parcelRequire("5bcND");
var $kq2WI = parcelRequire("kq2WI");
var $115203810af2eaaf$export$2e2bcd8739ae039 = (0, $kq2WI.css)`
  wui-flex {
    width: 100%;
  }

  wui-icon-link {
    margin-right: calc(var(--wui-icon-box-size-md) * -1);
  }

  .account-links {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .account-links wui-flex {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    background: red;
    align-items: center;
    justify-content: center;
    height: 48px;
    padding: 10px;
    flex: 1 0 0;

    border-radius: var(--XS, 16px);
    border: 1px solid var(--dark-accent-glass-010, rgba(71, 161, 255, 0.1));
    background: var(--dark-accent-glass-010, rgba(71, 161, 255, 0.1));
    transition: background 0.2s linear;
  }

  .account-links wui-flex:hover {
    background: var(--dark-accent-glass-015, rgba(71, 161, 255, 0.15));
  }

  .account-links wui-flex wui-icon {
    width: var(--S, 20px);
    height: var(--S, 20px);
  }

  .account-links wui-flex wui-icon svg path {
    stroke: #47a1ff;
  }
`;


var $ef49c8b71106d904$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $ef49c8b71106d904$export$b2168ecfa4cbc2f8 = class W3mAccountSettingsView extends (0, $b47AP.LitElement) {
    constructor(){
        super();
        this.usubscribe = [];
        this.networkImages = (0, $hCakD.AssetController).state.networkImages;
        this.address = (0, $5mrMQ.AccountController).state.address;
        this.profileImage = (0, $5mrMQ.AccountController).state.profileImage;
        this.profileName = (0, $5mrMQ.AccountController).state.profileName;
        this.balance = (0, $5mrMQ.AccountController).state.balance;
        this.balanceSymbol = (0, $5mrMQ.AccountController).state.balanceSymbol;
        this.network = (0, $b6tQF.NetworkController).state.caipNetwork;
        this.disconnecting = false;
        this.usubscribe.push(...[
            (0, $5mrMQ.AccountController).subscribe((val)=>{
                if (val.address) {
                    this.address = val.address;
                    this.profileImage = val.profileImage;
                    this.profileName = val.profileName;
                    this.balance = val.balance;
                    this.balanceSymbol = val.balanceSymbol;
                } else (0, $bnxqc.ModalController).close();
            })
        ], (0, $b6tQF.NetworkController).subscribeKey("caipNetwork", (val)=>{
            if (val?.id) this.network = val;
        }));
    }
    disconnectedCallback() {
        this.usubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        if (!this.address) throw new Error("w3m-account-settings-view: No account provided");
        const networkImage = this.networkImages[this.network?.imageId ?? ""];
        return (0, $6HMh7.html)`
      <wui-flex
        flexDirection="column"
        .padding=${[
            "0",
            "xl",
            "m",
            "xl"
        ]}
        alignItems="center"
        gap="l"
      >
        <wui-avatar
          alt=${this.address}
          address=${this.address}
          imageSrc=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)(this.profileImage)}
        ></wui-avatar>
        <wui-flex flexDirection="column" alignItems="center">
          <wui-flex gap="3xs" alignItems="center" justifyContent="center">
            <wui-text variant="large-600" color="fg-100">
              ${this.profileName ? (0, $97bbL.UiHelperUtil).getTruncateString({
            string: this.profileName,
            charsStart: 20,
            charsEnd: 0,
            truncate: "end"
        }) : (0, $97bbL.UiHelperUtil).getTruncateString({
            string: this.address,
            charsStart: 4,
            charsEnd: 6,
            truncate: "middle"
        })}
            </wui-text>
            <wui-icon-link
              size="md"
              icon="copy"
              iconColor="fg-200"
              @click=${this.onCopyAddress}
            ></wui-icon-link>
          </wui-flex>
          <wui-flex gap="s" flexDirection="column" alignItems="center">
            <wui-text variant="paragraph-500" color="fg-200">
              ${(0, $kGR8V.CoreHelperUtil).formatBalance(this.balance, this.balanceSymbol)}
            </wui-text>
            ${this.explorerBtnTemplate()}
          </wui-flex>
        </wui-flex>
      </wui-flex>

      <wui-flex flexDirection="column" gap="m">
        <wui-flex flexDirection="column" gap="xs" .padding=${[
            "0",
            "xl",
            "xl",
            "xl"
        ]}>
          <wui-list-item
            .variant=${networkImage ? "image" : "icon"}
            iconVariant="overlay"
            icon="networkPlaceholder"
            imageSrc=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)(networkImage)}
            ?chevron=${this.isAllowedNetworkSwitch()}
            @click=${this.onNetworks.bind(this)}
          >
            <wui-text variant="paragraph-500" color="fg-100">
              ${this.network?.name ?? "Unknown"}
            </wui-text>
          </wui-list-item>

          <wui-list-item
            iconVariant="blue"
            icon="swapHorizontalBold"
            iconSize="sm"
            ?chevron=${true}
            @click=${this.onTransactions.bind(this)}
          >
            <wui-text variant="paragraph-500" color="fg-100">Activity</wui-text>
          </wui-list-item>
          <wui-list-item
            variant="icon"
            iconVariant="overlay"
            icon="disconnect"
            ?chevron=${false}
            .loading=${this.disconnecting}
            @click=${this.onDisconnect.bind(this)}
            data-testid="disconnect-button"
          >
            <wui-text variant="paragraph-500" color="fg-200">Disconnect</wui-text>
          </wui-list-item>
        </wui-flex>
      </wui-flex>
    `;
    }
    onTransactions() {
        (0, $6n0eX.EventsController).sendEvent({
            type: "track",
            event: "CLICK_TRANSACTIONS"
        });
        (0, $dJjpc.RouterController).push("Transactions");
    }
    explorerBtnTemplate() {
        const { addressExplorerUrl: addressExplorerUrl } = (0, $5mrMQ.AccountController).state;
        if (!addressExplorerUrl) return null;
        return (0, $6HMh7.html)`
      <wui-button size="sm" variant="shade" @click=${this.onExplorer.bind(this)}>
        <wui-icon size="sm" color="inherit" slot="iconLeft" name="compass"></wui-icon>
        Block Explorer
        <wui-icon size="sm" color="inherit" slot="iconRight" name="externalLink"></wui-icon>
      </wui-button>
    `;
    }
    isAllowedNetworkSwitch() {
        const { requestedCaipNetworks: requestedCaipNetworks } = (0, $b6tQF.NetworkController).state;
        const isMultiNetwork = requestedCaipNetworks ? requestedCaipNetworks.length > 1 : false;
        const isValidNetwork = requestedCaipNetworks?.find(({ id: id })=>id === this.network?.id);
        return isMultiNetwork || !isValidNetwork;
    }
    onCopyAddress() {
        try {
            if (this.address) {
                (0, $kGR8V.CoreHelperUtil).copyToClopboard(this.address);
                (0, $9fh1I.SnackController).showSuccess("Address copied");
            }
        } catch  {
            (0, $9fh1I.SnackController).showError("Failed to copy");
        }
    }
    onNetworks() {
        if (this.isAllowedNetworkSwitch()) (0, $dJjpc.RouterController).push("Networks");
    }
    async onDisconnect() {
        try {
            this.disconnecting = true;
            await (0, $jJO2B.ConnectionController).disconnect();
            (0, $6n0eX.EventsController).sendEvent({
                type: "track",
                event: "DISCONNECT_SUCCESS"
            });
            (0, $bnxqc.ModalController).close();
        } catch  {
            (0, $6n0eX.EventsController).sendEvent({
                type: "track",
                event: "DISCONNECT_ERROR"
            });
            (0, $9fh1I.SnackController).showError("Failed to disconnect");
        } finally{
            this.disconnecting = false;
        }
    }
    onExplorer() {
        const { addressExplorerUrl: addressExplorerUrl } = (0, $5mrMQ.AccountController).state;
        if (addressExplorerUrl) (0, $kGR8V.CoreHelperUtil).openHref(addressExplorerUrl, "_blank");
    }
};
$ef49c8b71106d904$export$b2168ecfa4cbc2f8.styles = (0, $115203810af2eaaf$export$2e2bcd8739ae039);
$ef49c8b71106d904$var$__decorate([
    (0, $6eT5F.state)()
], $ef49c8b71106d904$export$b2168ecfa4cbc2f8.prototype, "address", void 0);
$ef49c8b71106d904$var$__decorate([
    (0, $6eT5F.state)()
], $ef49c8b71106d904$export$b2168ecfa4cbc2f8.prototype, "profileImage", void 0);
$ef49c8b71106d904$var$__decorate([
    (0, $6eT5F.state)()
], $ef49c8b71106d904$export$b2168ecfa4cbc2f8.prototype, "profileName", void 0);
$ef49c8b71106d904$var$__decorate([
    (0, $6eT5F.state)()
], $ef49c8b71106d904$export$b2168ecfa4cbc2f8.prototype, "balance", void 0);
$ef49c8b71106d904$var$__decorate([
    (0, $6eT5F.state)()
], $ef49c8b71106d904$export$b2168ecfa4cbc2f8.prototype, "balanceSymbol", void 0);
$ef49c8b71106d904$var$__decorate([
    (0, $6eT5F.state)()
], $ef49c8b71106d904$export$b2168ecfa4cbc2f8.prototype, "network", void 0);
$ef49c8b71106d904$var$__decorate([
    (0, $6eT5F.state)()
], $ef49c8b71106d904$export$b2168ecfa4cbc2f8.prototype, "disconnecting", void 0);
$ef49c8b71106d904$export$b2168ecfa4cbc2f8 = $ef49c8b71106d904$var$__decorate([
    (0, $lkv4o.customElement)("w3m-account-settings-view")
], $ef49c8b71106d904$export$b2168ecfa4cbc2f8);


parcelRequire("aAJP9");
var $5mrMQ = parcelRequire("5mrMQ");
var $7XY6i = parcelRequire("7XY6i");
var $jJO2B = parcelRequire("jJO2B");
var $9QkaU = parcelRequire("9QkaU");
var $5S5Lx = parcelRequire("5S5Lx");
var $kGR8V = parcelRequire("kGR8V");
var $6n0eX = parcelRequire("6n0eX");
var $bnxqc = parcelRequire("bnxqc");
var $b6tQF = parcelRequire("b6tQF");
var $8KEpV = parcelRequire("8KEpV");
var $dJjpc = parcelRequire("dJjpc");
var $9fh1I = parcelRequire("9fh1I");
var $heSwZ = parcelRequire("heSwZ");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
var $97bbL = parcelRequire("97bbL");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $6eT5F = parcelRequire("6eT5F");

parcelRequire("5bcND");
var $kq2WI = parcelRequire("kq2WI");
var $31d16142860c65b2$export$2e2bcd8739ae039 = (0, $kq2WI.css)`
  wui-flex {
    width: 100%;
  }

  :host > wui-flex:first-child {
    transform: translateY(calc(var(--wui-spacing-xxs) * -1));
  }

  wui-icon-link {
    margin-right: calc(var(--wui-icon-box-size-md) * -1);
  }

  wui-notice-card {
    margin-bottom: var(--wui-spacing-3xs);
  }

  w3m-transactions-view {
    max-height: 200px;
  }

  .tab-content-container {
    height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
  }

  .account-button {
    width: auto;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--wui-spacing-s);
    height: 48px;
    padding: var(--wui-spacing-xs);
    padding-right: var(--wui-spacing-s);
    box-shadow: inset 0 0 0 1px var(--wui-gray-glass-002);
    background-color: var(--wui-gray-glass-002);
    border-radius: 24px;
    transaction: background-color 0.2s linear;
  }

  .account-button:hover {
    background-color: var(--wui-gray-glass-005);
  }

  .avatar-container {
    position: relative;
  }

  wui-avatar.avatar {
    width: 32px;
    height: 32px;
    box-shadow: 0 0 0 2px var(--wui-gray-glass-005);
  }

  wui-avatar.network-avatar {
    width: 16px;
    height: 16px;
    position: absolute;
    left: 100%;
    top: 100%;
    transform: translate(-75%, -75%);
    box-shadow: 0 0 0 2px var(--wui-gray-glass-005);
  }

  .account-links {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .account-links wui-flex {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    background: red;
    align-items: center;
    justify-content: center;
    height: 48px;
    padding: 10px;
    flex: 1 0 0;

    border-radius: var(--XS, 16px);
    border: 1px solid var(--dark-accent-glass-010, rgba(71, 161, 255, 0.1));
    background: var(--dark-accent-glass-010, rgba(71, 161, 255, 0.1));
    transition: background 0.2s linear;
  }

  .account-links wui-flex:hover {
    background: var(--dark-accent-glass-015, rgba(71, 161, 255, 0.15));
  }

  .account-links wui-flex wui-icon {
    width: var(--S, 20px);
    height: var(--S, 20px);
  }

  .account-links wui-flex wui-icon svg path {
    stroke: #47a1ff;
  }
`;


var $3acd00de0a52345d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $3acd00de0a52345d$export$fb2cfdfbb483d2ac = class W3mAccountView extends (0, $b47AP.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.address = (0, $5mrMQ.AccountController).state.address;
        this.profileImage = (0, $5mrMQ.AccountController).state.profileImage;
        this.profileName = (0, $5mrMQ.AccountController).state.profileName;
        this.network = (0, $b6tQF.NetworkController).state.caipNetwork;
        this.disconnecting = false;
        this.balance = (0, $5mrMQ.AccountController).state.balance;
        this.balanceSymbol = (0, $5mrMQ.AccountController).state.balanceSymbol;
        this.unsubscribe.push(...[
            (0, $5mrMQ.AccountController).subscribe((val)=>{
                if (val.address) {
                    this.address = val.address;
                    this.profileImage = val.profileImage;
                    this.profileName = val.profileName;
                    this.balance = val.balance;
                    this.balanceSymbol = val.balanceSymbol;
                } else (0, $bnxqc.ModalController).close();
            })
        ], (0, $b6tQF.NetworkController).subscribeKey("caipNetwork", (val)=>{
            if (val?.id) this.network = val;
        }));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        if (!this.address) throw new Error("w3m-account-view: No account provided");
        const networkImage = (0, $7XY6i.AssetUtil).getNetworkImage(this.network);
        return (0, $6HMh7.html)`
      <wui-flex
        flexDirection="column"
        .padding=${[
            "0",
            "xl",
            "m",
            "xl"
        ]}
        alignItems="center"
        gap="l"
      >
        <wui-avatar
          alt=${this.address}
          address=${this.address}
          imageSrc=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)(this.profileImage === null ? undefined : this.profileImage)}
        ></wui-avatar>
        <wui-flex flexDirection="column" alignItems="center">
          <wui-flex gap="3xs" alignItems="center" justifyContent="center">
            <wui-text variant="medium-title-600" color="fg-100">
              ${this.profileName ? (0, $97bbL.UiHelperUtil).getTruncateString({
            string: this.profileName,
            charsStart: 20,
            charsEnd: 0,
            truncate: "end"
        }) : (0, $97bbL.UiHelperUtil).getTruncateString({
            string: this.address,
            charsStart: 4,
            charsEnd: 4,
            truncate: "middle"
        })}
            </wui-text>
            <wui-icon-link
              size="md"
              icon="copy"
              iconColor="fg-200"
              @click=${this.onCopyAddress}
            ></wui-icon-link>
          </wui-flex>
          <wui-text variant="paragraph-500" color="fg-200"
            >${(0, $kGR8V.CoreHelperUtil).formatBalance(this.balance, this.balanceSymbol)}</wui-text
          >
        </wui-flex>
        ${this.explorerBtnTemplate()}
      </wui-flex>

      <wui-flex flexDirection="column" gap="xs" .padding=${[
            "0",
            "s",
            "s",
            "s"
        ]}>
        ${this.emailCardTemplate()} ${this.emailBtnTemplate()}

        <wui-list-item
          .variant=${networkImage ? "image" : "icon"}
          iconVariant="overlay"
          icon="networkPlaceholder"
          imageSrc=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)(networkImage)}
          ?chevron=${this.isAllowedNetworkSwitch()}
          @click=${this.onNetworks.bind(this)}
          data-testid="w3m-account-select-network"
        >
          <wui-text variant="paragraph-500" color="fg-100">
            ${this.network?.name ?? "Unknown"}
          </wui-text>
        </wui-list-item>
        ${this.onrampTemplate()}
        <wui-list-item
          iconVariant="blue"
          icon="swapHorizontalMedium"
          iconSize="sm"
          ?chevron=${true}
          @click=${this.onTransactions.bind(this)}
        >
          <wui-text variant="paragraph-500" color="fg-100">Activity</wui-text>
        </wui-list-item>
        <wui-list-item
          variant="icon"
          iconVariant="overlay"
          icon="disconnect"
          ?chevron=${false}
          .loading=${this.disconnecting}
          @click=${this.onDisconnect.bind(this)}
          data-testid="disconnect-button"
        >
          <wui-text variant="paragraph-500" color="fg-200">Disconnect</wui-text>
        </wui-list-item>
      </wui-flex>
    `;
    }
    onrampTemplate() {
        const { enableOnramp: enableOnramp } = (0, $8KEpV.OptionsController).state;
        if (!enableOnramp) return null;
        return (0, $6HMh7.html)`
      <wui-list-item
        iconVariant="blue"
        icon="card"
        ?chevron=${true}
        @click=${this.handleClickPay.bind(this)}
      >
        <wui-text variant="paragraph-500" color="fg-100">Buy crypto</wui-text>
      </wui-list-item>
    `;
    }
    emailCardTemplate() {
        const type = (0, $heSwZ.StorageUtil).getConnectedConnector();
        const emailConnector = (0, $9QkaU.ConnectorController).getEmailConnector();
        const { origin: origin } = location;
        if (!emailConnector || type !== "EMAIL" || origin.includes((0, $5S5Lx.ConstantsUtil).SECURE_SITE)) return null;
        return (0, $6HMh7.html)`
      <wui-notice-card
        @click=${this.onGoToUpgradeView.bind(this)}
        label="Upgrade your wallet"
        description="Transition to a self-custodial wallet"
        icon="wallet"
      ></wui-notice-card>
    `;
    }
    handleClickPay() {
        (0, $dJjpc.RouterController).push("OnRampProviders");
    }
    explorerBtnTemplate() {
        const { addressExplorerUrl: addressExplorerUrl } = (0, $5mrMQ.AccountController).state;
        if (!addressExplorerUrl) return null;
        return (0, $6HMh7.html)`
      <wui-button size="sm" variant="shade" @click=${this.onExplorer.bind(this)}>
        <wui-icon size="sm" color="inherit" slot="iconLeft" name="compass"></wui-icon>
        Block Explorer
        <wui-icon size="sm" color="inherit" slot="iconRight" name="externalLink"></wui-icon>
      </wui-button>
    `;
    }
    emailBtnTemplate() {
        const type = (0, $heSwZ.StorageUtil).getConnectedConnector();
        const emailConnector = (0, $9QkaU.ConnectorController).getEmailConnector();
        if (!emailConnector || type !== "EMAIL") return null;
        const email = emailConnector.provider.getEmail() ?? "";
        return (0, $6HMh7.html)`
      <wui-list-item
        variant="icon"
        iconVariant="overlay"
        icon="mail"
        iconSize="sm"
        ?chevron=${true}
        @click=${()=>this.onGoToUpdateEmail(email)}
      >
        <wui-text variant="paragraph-500" color="fg-100">${email}</wui-text>
      </wui-list-item>
    `;
    }
    isAllowedNetworkSwitch() {
        const { requestedCaipNetworks: requestedCaipNetworks } = (0, $b6tQF.NetworkController).state;
        const isMultiNetwork = requestedCaipNetworks ? requestedCaipNetworks.length > 1 : false;
        const isValidNetwork = requestedCaipNetworks?.find(({ id: id })=>id === this.network?.id);
        return isMultiNetwork || !isValidNetwork;
    }
    onCopyAddress() {
        try {
            if (this.address) {
                (0, $kGR8V.CoreHelperUtil).copyToClopboard(this.address);
                (0, $9fh1I.SnackController).showSuccess("Address copied");
            }
        } catch  {
            (0, $9fh1I.SnackController).showError("Failed to copy");
        }
    }
    onNetworks() {
        if (this.isAllowedNetworkSwitch()) {
            (0, $6n0eX.EventsController).sendEvent({
                type: "track",
                event: "CLICK_NETWORKS"
            });
            (0, $dJjpc.RouterController).push("Networks");
        }
    }
    onTransactions() {
        (0, $6n0eX.EventsController).sendEvent({
            type: "track",
            event: "CLICK_TRANSACTIONS"
        });
        (0, $dJjpc.RouterController).push("Transactions");
    }
    async onDisconnect() {
        try {
            this.disconnecting = true;
            await (0, $jJO2B.ConnectionController).disconnect();
            (0, $6n0eX.EventsController).sendEvent({
                type: "track",
                event: "DISCONNECT_SUCCESS"
            });
            (0, $bnxqc.ModalController).close();
        } catch  {
            (0, $6n0eX.EventsController).sendEvent({
                type: "track",
                event: "DISCONNECT_ERROR"
            });
            (0, $9fh1I.SnackController).showError("Failed to disconnect");
        } finally{
            this.disconnecting = false;
        }
    }
    onExplorer() {
        const { addressExplorerUrl: addressExplorerUrl } = (0, $5mrMQ.AccountController).state;
        if (addressExplorerUrl) (0, $kGR8V.CoreHelperUtil).openHref(addressExplorerUrl, "_blank");
    }
    onGoToUpgradeView() {
        (0, $6n0eX.EventsController).sendEvent({
            type: "track",
            event: "EMAIL_UPGRADE_FROM_MODAL"
        });
        (0, $dJjpc.RouterController).push("UpgradeEmailWallet");
    }
    onGoToUpdateEmail(email) {
        (0, $dJjpc.RouterController).push("UpdateEmailWallet", {
            email: email
        });
    }
};
$3acd00de0a52345d$export$fb2cfdfbb483d2ac.styles = (0, $31d16142860c65b2$export$2e2bcd8739ae039);
$3acd00de0a52345d$var$__decorate([
    (0, $6eT5F.state)()
], $3acd00de0a52345d$export$fb2cfdfbb483d2ac.prototype, "address", void 0);
$3acd00de0a52345d$var$__decorate([
    (0, $6eT5F.state)()
], $3acd00de0a52345d$export$fb2cfdfbb483d2ac.prototype, "profileImage", void 0);
$3acd00de0a52345d$var$__decorate([
    (0, $6eT5F.state)()
], $3acd00de0a52345d$export$fb2cfdfbb483d2ac.prototype, "profileName", void 0);
$3acd00de0a52345d$var$__decorate([
    (0, $6eT5F.state)()
], $3acd00de0a52345d$export$fb2cfdfbb483d2ac.prototype, "network", void 0);
$3acd00de0a52345d$var$__decorate([
    (0, $6eT5F.state)()
], $3acd00de0a52345d$export$fb2cfdfbb483d2ac.prototype, "disconnecting", void 0);
$3acd00de0a52345d$var$__decorate([
    (0, $6eT5F.state)()
], $3acd00de0a52345d$export$fb2cfdfbb483d2ac.prototype, "balance", void 0);
$3acd00de0a52345d$var$__decorate([
    (0, $6eT5F.state)()
], $3acd00de0a52345d$export$fb2cfdfbb483d2ac.prototype, "balanceSymbol", void 0);
$3acd00de0a52345d$export$fb2cfdfbb483d2ac = $3acd00de0a52345d$var$__decorate([
    (0, $lkv4o.customElement)("w3m-account-view")
], $3acd00de0a52345d$export$fb2cfdfbb483d2ac);


parcelRequire("aAJP9");
var $kGR8V = parcelRequire("kGR8V");
var $dJjpc = parcelRequire("dJjpc");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $6eT5F = parcelRequire("6eT5F");
var $b6f62cf8476e40fe$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $b6f62cf8476e40fe$export$88f35657f4e64778 = class W3mAllWalletsView extends (0, $b47AP.LitElement) {
    constructor(){
        super(...arguments);
        this.search = "";
        this.onDebouncedSearch = (0, $kGR8V.CoreHelperUtil).debounce((value)=>{
            this.search = value;
        });
    }
    render() {
        const isSearch = this.search.length >= 2;
        return (0, $6HMh7.html)`
      <wui-flex padding="s" gap="s">
        <wui-search-bar @inputChange=${this.onInputChange.bind(this)}></wui-search-bar>
        ${this.qrButtonTemplate()}
      </wui-flex>
      ${isSearch ? (0, $6HMh7.html)`<w3m-all-wallets-search query=${this.search}></w3m-all-wallets-search>` : (0, $6HMh7.html)`<w3m-all-wallets-list></w3m-all-wallets-list>`}
    `;
    }
    onInputChange(event) {
        this.onDebouncedSearch(event.detail);
    }
    qrButtonTemplate() {
        if ((0, $kGR8V.CoreHelperUtil).isMobile()) return (0, $6HMh7.html)`
        <wui-icon-box
          size="lg"
          iconSize="xl"
          iconColor="accent-100"
          backgroundColor="accent-100"
          icon="qrCode"
          background="transparent"
          border
          borderColor="wui-accent-glass-010"
          @click=${this.onWalletConnectQr.bind(this)}
        ></wui-icon-box>
      `;
        return null;
    }
    onWalletConnectQr() {
        (0, $dJjpc.RouterController).push("ConnectingWalletConnect");
    }
};
$b6f62cf8476e40fe$var$__decorate([
    (0, $6eT5F.state)()
], $b6f62cf8476e40fe$export$88f35657f4e64778.prototype, "search", void 0);
$b6f62cf8476e40fe$export$88f35657f4e64778 = $b6f62cf8476e40fe$var$__decorate([
    (0, $lkv4o.customElement)("w3m-all-wallets-view")
], $b6f62cf8476e40fe$export$88f35657f4e64778);


parcelRequire("aAJP9");
var $5mrMQ = parcelRequire("5mrMQ");
var $6Y81T = parcelRequire("6Y81T");
var $jJO2B = parcelRequire("jJO2B");
var $kGR8V = parcelRequire("kGR8V");
var $ahDsO = parcelRequire("ahDsO");
var $8KEpV = parcelRequire("8KEpV");
var $dJjpc = parcelRequire("dJjpc");
var $9fh1I = parcelRequire("9fh1I");
var $fyCFg = parcelRequire("fyCFg");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $5YVCx = parcelRequire("5YVCx");
var $6eT5F = parcelRequire("6eT5F");

parcelRequire("5bcND");
var $kq2WI = parcelRequire("kq2WI");
var $04687c111df0bc86$export$2e2bcd8739ae039 = (0, $kq2WI.css)`
  @keyframes shake {
    0% {
      transform: translateX(0);
    }
    25% {
      transform: translateX(3px);
    }
    50% {
      transform: translateX(-3px);
    }
    75% {
      transform: translateX(3px);
    }
    100% {
      transform: translateX(0);
    }
  }

  wui-flex:first-child:not(:only-child) {
    position: relative;
  }

  wui-loading-thumbnail {
    position: absolute;
  }

  wui-visual {
    width: var(--wui-wallet-image-size-lg);
    height: var(--wui-wallet-image-size-lg);
    border-radius: calc(var(--wui-border-radius-5xs) * 9 - var(--wui-border-radius-xxs));
    position: relative;
    overflow: hidden;
  }

  wui-visual::after {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    inset: 0;
    border-radius: calc(var(--wui-border-radius-5xs) * 9 - var(--wui-border-radius-xxs));
    box-shadow: inset 0 0 0 1px var(--wui-gray-glass-005);
  }

  wui-icon-box {
    position: absolute;
    right: calc(var(--wui-spacing-3xs) * -1);
    bottom: calc(var(--wui-spacing-3xs) * -1);
    opacity: 0;
    transform: scale(0.5);
    transition: all var(--wui-ease-out-power-2) var(--wui-duration-lg);
  }

  wui-text[align='center'] {
    width: 100%;
    padding: 0px var(--wui-spacing-l);
  }

  [data-error='true'] wui-icon-box {
    opacity: 1;
    transform: scale(1);
  }

  [data-error='true'] > wui-flex:first-child {
    animation: shake 250ms cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  }

  [data-retry='false'] wui-link {
    display: none;
  }

  [data-retry='true'] wui-link {
    display: block;
    opacity: 1;
  }

  wui-link {
    padding: var(--wui-spacing-4xs) var(--wui-spacing-xxs);
  }
`;


var $8a032e67579d8f74$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $8a032e67579d8f74$export$e0ca4e8f314f5325 = class W3mBuyInProgressView extends (0, $b47AP.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.selectedOnRampProvider = (0, $ahDsO.OnRampController).state.selectedProvider;
        this.uri = (0, $jJO2B.ConnectionController).state.wcUri;
        this.ready = false;
        this.showRetry = false;
        this.buffering = false;
        this.error = false;
        this.startTime = null;
        this.isMobile = false;
        this.onRetry = undefined;
        this.unsubscribe.push(...[
            (0, $ahDsO.OnRampController).subscribeKey("selectedProvider", (val)=>{
                this.selectedOnRampProvider = val;
            })
        ]);
        this.watchTransactions();
    }
    disconnectedCallback() {
        if (this.intervalId) clearInterval(this.intervalId);
    }
    render() {
        let label = "Continue in external window";
        if (this.error) label = "Buy failed";
        else if (this.selectedOnRampProvider) label = `Buy in ${this.selectedOnRampProvider?.label}`;
        const subLabel = this.error ? "Buy can be declined from your side or due to and error on the provider app" : `We\u{2019}ll notify you once your Buy is processed`;
        return (0, $6HMh7.html)`
      <wui-flex
        data-error=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)(this.error)}
        data-retry=${this.showRetry}
        flexDirection="column"
        alignItems="center"
        .padding=${[
            "3xl",
            "xl",
            "xl",
            "xl"
        ]}
        gap="xl"
      >
        <wui-flex justifyContent="center" alignItems="center">
          <wui-visual
            name=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)(this.selectedOnRampProvider?.name)}
            size="lg"
            class="provider-image"
          >
          </wui-visual>

          ${this.error ? null : this.loaderTemplate()}

          <wui-icon-box
            backgroundColor="error-100"
            background="opaque"
            iconColor="error-100"
            icon="close"
            size="sm"
            border
            borderColor="wui-color-bg-125"
          ></wui-icon-box>
        </wui-flex>

        <wui-flex flexDirection="column" alignItems="center" gap="xs">
          <wui-text variant="paragraph-500" color=${this.error ? "error-100" : "fg-100"}>
            ${label}
          </wui-text>
          <wui-text align="center" variant="small-500" color="fg-200">${subLabel}</wui-text>
        </wui-flex>

        ${this.error ? this.tryAgainTemplate() : null}
      </wui-flex>

      <wui-flex .padding=${[
            "0",
            "xl",
            "xl",
            "xl"
        ]} justifyContent="center">
        <wui-link @click=${this.onCopyUri} color="fg-200">
          <wui-icon size="xs" color="fg-200" slot="iconLeft" name="copy"></wui-icon>
          Copy link
        </wui-link>
      </wui-flex>
    `;
    }
    watchTransactions() {
        if (!this.selectedOnRampProvider) return;
        switch(this.selectedOnRampProvider.name){
            case "coinbase":
                this.startTime = Date.now();
                this.initializeCoinbaseTransactions();
                break;
            default:
                break;
        }
    }
    async initializeCoinbaseTransactions() {
        await this.watchCoinbaseTransactions();
        this.intervalId = setInterval(()=>this.watchCoinbaseTransactions(), 4000);
    }
    async watchCoinbaseTransactions() {
        try {
            const address = (0, $5mrMQ.AccountController).state.address;
            const projectId = (0, $8KEpV.OptionsController).state.projectId;
            if (!address) throw new Error("No address found");
            const coinbaseResponse = await (0, $6Y81T.BlockchainApiController).fetchTransactions({
                account: address,
                onramp: "coinbase",
                projectId: projectId
            });
            const newTransactions = coinbaseResponse.data.filter((tx)=>new Date(tx.metadata.minedAt) > new Date(this.startTime) || tx.metadata.status === "ONRAMP_TRANSACTION_STATUS_IN_PROGRESS");
            if (newTransactions.length) {
                clearInterval(this.intervalId);
                (0, $dJjpc.RouterController).replace("OnRampActivity");
            } else if (this.startTime && Date.now() - this.startTime >= 180000) {
                clearInterval(this.intervalId);
                this.error = true;
            }
        } catch (error) {
            (0, $9fh1I.SnackController).showError(error);
        }
    }
    onTryAgain() {
        if (!this.selectedOnRampProvider) return;
        this.error = false;
        (0, $kGR8V.CoreHelperUtil).openHref(this.selectedOnRampProvider.url, "popupWindow", "width=600,height=800,scrollbars=yes");
    }
    tryAgainTemplate() {
        if (!this.selectedOnRampProvider?.url) return null;
        return (0, $6HMh7.html)`<wui-button variant="accent" @click=${this.onTryAgain.bind(this)}>
      <wui-icon color="inherit" slot="iconLeft" name="refresh"></wui-icon>
      Try again
    </wui-button>`;
    }
    loaderTemplate() {
        const borderRadiusMaster = (0, $fyCFg.ThemeController).state.themeVariables["--w3m-border-radius-master"];
        const radius = borderRadiusMaster ? parseInt(borderRadiusMaster.replace("px", ""), 10) : 4;
        return (0, $6HMh7.html)`<wui-loading-thumbnail radius=${radius * 9}></wui-loading-thumbnail>`;
    }
    onCopyUri() {
        if (!this.selectedOnRampProvider?.url) {
            (0, $9fh1I.SnackController).showError("No link found");
            (0, $dJjpc.RouterController).goBack();
            return;
        }
        try {
            (0, $kGR8V.CoreHelperUtil).copyToClopboard(this.selectedOnRampProvider.url);
            (0, $9fh1I.SnackController).showSuccess("Link copied");
        } catch  {
            (0, $9fh1I.SnackController).showError("Failed to copy");
        }
    }
};
$8a032e67579d8f74$export$e0ca4e8f314f5325.styles = (0, $04687c111df0bc86$export$2e2bcd8739ae039);
$8a032e67579d8f74$var$__decorate([
    (0, $6eT5F.state)()
], $8a032e67579d8f74$export$e0ca4e8f314f5325.prototype, "selectedOnRampProvider", void 0);
$8a032e67579d8f74$var$__decorate([
    (0, $6eT5F.state)()
], $8a032e67579d8f74$export$e0ca4e8f314f5325.prototype, "uri", void 0);
$8a032e67579d8f74$var$__decorate([
    (0, $6eT5F.state)()
], $8a032e67579d8f74$export$e0ca4e8f314f5325.prototype, "ready", void 0);
$8a032e67579d8f74$var$__decorate([
    (0, $6eT5F.state)()
], $8a032e67579d8f74$export$e0ca4e8f314f5325.prototype, "showRetry", void 0);
$8a032e67579d8f74$var$__decorate([
    (0, $6eT5F.state)()
], $8a032e67579d8f74$export$e0ca4e8f314f5325.prototype, "buffering", void 0);
$8a032e67579d8f74$var$__decorate([
    (0, $6eT5F.state)()
], $8a032e67579d8f74$export$e0ca4e8f314f5325.prototype, "error", void 0);
$8a032e67579d8f74$var$__decorate([
    (0, $6eT5F.state)()
], $8a032e67579d8f74$export$e0ca4e8f314f5325.prototype, "intervalId", void 0);
$8a032e67579d8f74$var$__decorate([
    (0, $6eT5F.state)()
], $8a032e67579d8f74$export$e0ca4e8f314f5325.prototype, "startTime", void 0);
$8a032e67579d8f74$var$__decorate([
    (0, $5YVCx.property)({
        type: Boolean
    })
], $8a032e67579d8f74$export$e0ca4e8f314f5325.prototype, "isMobile", void 0);
$8a032e67579d8f74$var$__decorate([
    (0, $5YVCx.property)()
], $8a032e67579d8f74$export$e0ca4e8f314f5325.prototype, "onRetry", void 0);
$8a032e67579d8f74$export$e0ca4e8f314f5325 = $8a032e67579d8f74$var$__decorate([
    (0, $lkv4o.customElement)("w3m-buy-in-progress-view")
], $8a032e67579d8f74$export$e0ca4e8f314f5325);


parcelRequire("aAJP9");
var $6tAXH = parcelRequire("6tAXH");
var $7XY6i = parcelRequire("7XY6i");
var $jJO2B = parcelRequire("jJO2B");
var $9QkaU = parcelRequire("9QkaU");
var $5S5Lx = parcelRequire("5S5Lx");
var $kGR8V = parcelRequire("kGR8V");
var $6n0eX = parcelRequire("6n0eX");
var $8KEpV = parcelRequire("8KEpV");
var $dJjpc = parcelRequire("dJjpc");
var $heSwZ = parcelRequire("heSwZ");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $6eT5F = parcelRequire("6eT5F");

parcelRequire("5bcND");
var $kq2WI = parcelRequire("kq2WI");
var $a2510c12f8bc9a49$export$2e2bcd8739ae039 = (0, $kq2WI.css)`
  wui-flex {
    max-height: clamp(360px, 540px, 80vh);
    overflow: scroll;
    scrollbar-width: none;
  }

  wui-flex::-webkit-scrollbar {
    display: none;
  }
`;


var $b70769c90382a458$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $b70769c90382a458$export$b7220f3d0ae9dbca = class W3mConnectView extends (0, $b47AP.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.connectors = (0, $9QkaU.ConnectorController).state.connectors;
        this.unsubscribe.push((0, $9QkaU.ConnectorController).subscribeKey("connectors", (val)=>this.connectors = val));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $6HMh7.html)`
      <wui-flex flexDirection="column" padding="s" gap="xs">
        <w3m-email-login-widget></w3m-email-login-widget>

        ${this.walletConnectConnectorTemplate()} ${this.recentTemplate()}
        ${this.announcedTemplate()} ${this.injectedTemplate()} ${this.featuredTemplate()}
        ${this.customTemplate()} ${this.recommendedTemplate()} ${this.externalTemplate()}
        ${this.allWalletsTemplate()}
      </wui-flex>
      <w3m-legal-footer></w3m-legal-footer>
    `;
    }
    walletConnectConnectorTemplate() {
        if ((0, $kGR8V.CoreHelperUtil).isMobile()) return null;
        const connector = this.connectors.find((c)=>c.type === "WALLET_CONNECT");
        if (!connector) return null;
        return (0, $6HMh7.html)`
      <wui-list-wallet
        imageSrc=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)((0, $7XY6i.AssetUtil).getConnectorImage(connector))}
        name=${connector.name ?? "Unknown"}
        @click=${()=>this.onConnector(connector)}
        tagLabel="qr code"
        tagVariant="main"
        data-testid="wallet-selector-walletconnect"
      >
      </wui-list-wallet>
    `;
    }
    customTemplate() {
        const { customWallets: customWallets } = (0, $8KEpV.OptionsController).state;
        if (!customWallets?.length) return null;
        const wallets = this.filterOutDuplicateWallets(customWallets);
        return wallets.map((wallet)=>(0, $6HMh7.html)`
        <wui-list-wallet
          imageSrc=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)((0, $7XY6i.AssetUtil).getWalletImage(wallet))}
          name=${wallet.name ?? "Unknown"}
          @click=${()=>this.onConnectWallet(wallet)}
        >
        </wui-list-wallet>
      `);
    }
    featuredTemplate() {
        const connector = this.connectors.find((c)=>c.type === "WALLET_CONNECT");
        if (!connector) return null;
        const { featured: featured } = (0, $6tAXH.ApiController).state;
        if (!featured.length) return null;
        const wallets = this.filterOutDuplicateWallets(featured);
        return wallets.map((wallet)=>(0, $6HMh7.html)`
        <wui-list-wallet
          imageSrc=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)((0, $7XY6i.AssetUtil).getWalletImage(wallet))}
          name=${wallet.name ?? "Unknown"}
          @click=${()=>this.onConnectWallet(wallet)}
        >
        </wui-list-wallet>
      `);
    }
    recentTemplate() {
        const recent = (0, $heSwZ.StorageUtil).getRecentWallets();
        return recent.map((wallet)=>(0, $6HMh7.html)`
        <wui-list-wallet
          imageSrc=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)((0, $7XY6i.AssetUtil).getWalletImage(wallet))}
          name=${wallet.name ?? "Unknown"}
          @click=${()=>this.onConnectWallet(wallet)}
          tagLabel="recent"
          tagVariant="shade"
        >
        </wui-list-wallet>
      `);
    }
    announcedTemplate() {
        return this.connectors.map((connector)=>{
            if (connector.type !== "ANNOUNCED") return null;
            return (0, $6HMh7.html)`
        <wui-list-wallet
          imageSrc=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)((0, $7XY6i.AssetUtil).getConnectorImage(connector))}
          name=${connector.name ?? "Unknown"}
          @click=${()=>this.onConnector(connector)}
          tagVariant="success"
          .installed=${true}
        >
        </wui-list-wallet>
      `;
        });
    }
    injectedTemplate() {
        return this.connectors.map((connector)=>{
            if (connector.type !== "INJECTED") return null;
            if (!(0, $jJO2B.ConnectionController).checkInstalled()) return null;
            return (0, $6HMh7.html)`
        <wui-list-wallet
          imageSrc=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)((0, $7XY6i.AssetUtil).getConnectorImage(connector))}
          .installed=${true}
          name=${connector.name ?? "Unknown"}
          @click=${()=>this.onConnector(connector)}
        >
        </wui-list-wallet>
      `;
        });
    }
    externalTemplate() {
        const announcedRdns = (0, $9QkaU.ConnectorController).getAnnouncedConnectorRdns();
        return this.connectors.map((connector)=>{
            if ([
                "WALLET_CONNECT",
                "INJECTED",
                "ANNOUNCED",
                "EMAIL"
            ].includes(connector.type)) return null;
            if (announcedRdns.includes((0, $5S5Lx.ConstantsUtil).CONNECTOR_RDNS_MAP[connector.id])) return null;
            return (0, $6HMh7.html)`
        <wui-list-wallet
          imageSrc=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)((0, $7XY6i.AssetUtil).getConnectorImage(connector))}
          name=${connector.name ?? "Unknown"}
          @click=${()=>this.onConnector(connector)}
        >
        </wui-list-wallet>
      `;
        });
    }
    allWalletsTemplate() {
        const connector = this.connectors.find((c)=>c.type === "WALLET_CONNECT");
        const { allWallets: allWallets } = (0, $8KEpV.OptionsController).state;
        if (!connector || allWallets === "HIDE") return null;
        if (allWallets === "ONLY_MOBILE" && !(0, $kGR8V.CoreHelperUtil).isMobile()) return null;
        const count = (0, $6tAXH.ApiController).state.count;
        const featuredCount = (0, $6tAXH.ApiController).state.featured.length;
        const rawCount = count + featuredCount;
        const roundedCount = rawCount < 10 ? rawCount : Math.floor(rawCount / 10) * 10;
        const tagLabel = roundedCount < rawCount ? `${roundedCount}+` : `${roundedCount}`;
        return (0, $6HMh7.html)`
      <wui-list-wallet
        name="All Wallets"
        walletIcon="allWallets"
        showAllWallets
        @click=${this.onAllWallets.bind(this)}
        tagLabel=${tagLabel}
        tagVariant="shade"
        data-testid="all-wallets"
      ></wui-list-wallet>
    `;
    }
    recommendedTemplate() {
        const connector = this.connectors.find((c)=>c.type === "WALLET_CONNECT");
        if (!connector) return null;
        const { recommended: recommended } = (0, $6tAXH.ApiController).state;
        const { customWallets: customWallets, featuredWalletIds: featuredWalletIds } = (0, $8KEpV.OptionsController).state;
        const { connectors: connectors } = (0, $9QkaU.ConnectorController).state;
        const recent = (0, $heSwZ.StorageUtil).getRecentWallets();
        const injected = connectors.filter((c)=>c.type === "INJECTED");
        const filteredInjected = injected.filter((i)=>i.name !== "Browser Wallet");
        if (featuredWalletIds || customWallets || !recommended.length) return null;
        const overrideLength = filteredInjected.length + recent.length;
        const maxRecommended = Math.max(0, 2 - overrideLength);
        const wallets = this.filterOutDuplicateWallets(recommended).slice(0, maxRecommended);
        return wallets.map((wallet)=>(0, $6HMh7.html)`
        <wui-list-wallet
          imageSrc=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)((0, $7XY6i.AssetUtil).getWalletImage(wallet))}
          name=${wallet?.name ?? "Unknown"}
          @click=${()=>this.onConnectWallet(wallet)}
        >
        </wui-list-wallet>
      `);
    }
    onConnector(connector) {
        if (connector.type === "WALLET_CONNECT") {
            if ((0, $kGR8V.CoreHelperUtil).isMobile()) (0, $dJjpc.RouterController).push("AllWallets");
            else (0, $dJjpc.RouterController).push("ConnectingWalletConnect");
        } else (0, $dJjpc.RouterController).push("ConnectingExternal", {
            connector: connector
        });
    }
    filterOutDuplicateWallets(wallets) {
        const recent = (0, $heSwZ.StorageUtil).getRecentWallets();
        const recentIds = recent.map((wallet)=>wallet.id);
        const filtered = wallets.filter((wallet)=>!recentIds.includes(wallet.id));
        return filtered;
    }
    onAllWallets() {
        (0, $6n0eX.EventsController).sendEvent({
            type: "track",
            event: "CLICK_ALL_WALLETS"
        });
        (0, $dJjpc.RouterController).push("AllWallets");
    }
    onConnectWallet(wallet) {
        (0, $dJjpc.RouterController).push("ConnectingWalletConnect", {
            wallet: wallet
        });
    }
};
$b70769c90382a458$export$b7220f3d0ae9dbca.styles = (0, $a2510c12f8bc9a49$export$2e2bcd8739ae039);
$b70769c90382a458$var$__decorate([
    (0, $6eT5F.state)()
], $b70769c90382a458$export$b7220f3d0ae9dbca.prototype, "connectors", void 0);
$b70769c90382a458$export$b7220f3d0ae9dbca = $b70769c90382a458$var$__decorate([
    (0, $lkv4o.customElement)("w3m-connect-view")
], $b70769c90382a458$export$b7220f3d0ae9dbca);


parcelRequire("aAJP9");
var $jJO2B = parcelRequire("jJO2B");
var $6n0eX = parcelRequire("6n0eX");
var $bnxqc = parcelRequire("bnxqc");
var $dJjpc = parcelRequire("dJjpc");
var $iQR2f = parcelRequire("iQR2f");
var $heSwZ = parcelRequire("heSwZ");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("aAJP9");
var $7XY6i = parcelRequire("7XY6i");
var $jJO2B = parcelRequire("jJO2B");
var $kGR8V = parcelRequire("kGR8V");
var $dJjpc = parcelRequire("dJjpc");
var $9fh1I = parcelRequire("9fh1I");
var $fyCFg = parcelRequire("fyCFg");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $5YVCx = parcelRequire("5YVCx");
var $6eT5F = parcelRequire("6eT5F");

parcelRequire("5bcND");
var $kq2WI = parcelRequire("kq2WI");
var $02b05308bb23fb22$export$2e2bcd8739ae039 = (0, $kq2WI.css)`
  @keyframes shake {
    0% {
      transform: translateX(0);
    }
    25% {
      transform: translateX(3px);
    }
    50% {
      transform: translateX(-3px);
    }
    75% {
      transform: translateX(3px);
    }
    100% {
      transform: translateX(0);
    }
  }

  wui-flex:first-child:not(:only-child) {
    position: relative;
  }

  wui-loading-thumbnail {
    position: absolute;
  }

  wui-icon-box {
    position: absolute;
    right: calc(var(--wui-spacing-3xs) * -1);
    bottom: calc(var(--wui-spacing-3xs) * -1);
    opacity: 0;
    transform: scale(0.5);
    transition: all var(--wui-ease-out-power-2) var(--wui-duration-lg);
  }

  wui-text[align='center'] {
    width: 100%;
    padding: 0px var(--wui-spacing-l);
  }

  [data-error='true'] wui-icon-box {
    opacity: 1;
    transform: scale(1);
  }

  [data-error='true'] > wui-flex:first-child {
    animation: shake 250ms cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  }

  [data-retry='false'] wui-link {
    display: none;
  }

  [data-retry='true'] wui-link {
    display: block;
    opacity: 1;
  }
`;


var $f280655654489b57$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
class $f280655654489b57$export$902e3cfa9f67689d extends (0, $b47AP.LitElement) {
    constructor(){
        super();
        this.wallet = (0, $dJjpc.RouterController).state.data?.wallet;
        this.connector = (0, $dJjpc.RouterController).state.data?.connector;
        this.timeout = undefined;
        this.secondaryBtnLabel = "Try again";
        this.secondaryBtnIcon = "refresh";
        this.secondaryLabel = "Accept connection request in the wallet";
        this.onConnect = undefined;
        this.onRender = undefined;
        this.onAutoConnect = undefined;
        this.isWalletConnect = true;
        this.unsubscribe = [];
        this.imageSrc = (0, $7XY6i.AssetUtil).getWalletImage(this.wallet) ?? (0, $7XY6i.AssetUtil).getConnectorImage(this.connector);
        this.name = this.wallet?.name ?? this.connector?.name ?? "Wallet";
        this.isRetrying = false;
        this.uri = (0, $jJO2B.ConnectionController).state.wcUri;
        this.error = (0, $jJO2B.ConnectionController).state.wcError;
        this.ready = false;
        this.showRetry = false;
        this.buffering = false;
        this.isMobile = false;
        this.onRetry = undefined;
        this.unsubscribe.push(...[
            (0, $jJO2B.ConnectionController).subscribeKey("wcUri", (val)=>{
                this.uri = val;
                if (this.isRetrying && this.onRetry) {
                    this.isRetrying = false;
                    this.onConnect?.();
                }
            }),
            (0, $jJO2B.ConnectionController).subscribeKey("wcError", (val)=>this.error = val),
            (0, $jJO2B.ConnectionController).subscribeKey("buffering", (val)=>this.buffering = val)
        ]);
    }
    firstUpdated() {
        this.onAutoConnect?.();
        this.showRetry = !this.onAutoConnect;
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
        clearTimeout(this.timeout);
    }
    render() {
        this.onRender?.();
        this.onShowRetry();
        const subLabel = this.error ? "Connection can be declined if a previous request is still active" : this.secondaryLabel;
        let label = `Continue in ${this.name}`;
        if (this.buffering) label = "Connecting...";
        if (this.error) label = "Connection declined";
        return (0, $6HMh7.html)`
      <wui-flex
        data-error=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)(this.error)}
        data-retry=${this.showRetry}
        flexDirection="column"
        alignItems="center"
        .padding=${[
            "3xl",
            "xl",
            "xl",
            "xl"
        ]}
        gap="xl"
      >
        <wui-flex justifyContent="center" alignItems="center">
          <wui-wallet-image size="lg" imageSrc=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)(this.imageSrc)}></wui-wallet-image>

          ${this.error ? null : this.loaderTemplate()}

          <wui-icon-box
            backgroundColor="error-100"
            background="opaque"
            iconColor="error-100"
            icon="close"
            size="sm"
            border
            borderColor="wui-color-bg-125"
          ></wui-icon-box>
        </wui-flex>

        <wui-flex flexDirection="column" alignItems="center" gap="xs">
          <wui-text variant="paragraph-500" color=${this.error ? "error-100" : "fg-100"}>
            ${label}
          </wui-text>
          <wui-text align="center" variant="small-500" color="fg-200">${subLabel}</wui-text>
        </wui-flex>

        <wui-button
          variant="accent"
          ?disabled=${!this.error && this.buffering}
          @click=${this.onTryAgain.bind(this)}
        >
          <wui-icon color="inherit" slot="iconLeft" name=${this.secondaryBtnIcon}></wui-icon>
          ${this.secondaryBtnLabel}
        </wui-button>
      </wui-flex>

      ${this.isWalletConnect ? (0, $6HMh7.html)`
            <wui-flex .padding=${[
            "0",
            "xl",
            "xl",
            "xl"
        ]} justifyContent="center">
              <wui-link @click=${this.onCopyUri} color="fg-200">
                <wui-icon size="xs" color="fg-200" slot="iconLeft" name="copy"></wui-icon>
                Copy link
              </wui-link>
            </wui-flex>
          ` : null}

      <w3m-mobile-download-links .wallet=${this.wallet}></w3m-mobile-download-links>
    `;
    }
    onShowRetry() {
        if (this.error && !this.showRetry) {
            this.showRetry = true;
            const retryButton = this.shadowRoot?.querySelector("wui-button");
            retryButton?.animate([
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ], {
                fill: "forwards",
                easing: "ease"
            });
        }
    }
    onTryAgain() {
        if (!this.buffering) {
            (0, $jJO2B.ConnectionController).setWcError(false);
            if (this.onRetry) {
                this.isRetrying = true;
                this.onRetry?.();
            } else this.onConnect?.();
        }
    }
    loaderTemplate() {
        const borderRadiusMaster = (0, $fyCFg.ThemeController).state.themeVariables["--w3m-border-radius-master"];
        const radius = borderRadiusMaster ? parseInt(borderRadiusMaster.replace("px", ""), 10) : 4;
        return (0, $6HMh7.html)`<wui-loading-thumbnail radius=${radius * 9}></wui-loading-thumbnail>`;
    }
    onCopyUri() {
        try {
            if (this.uri) {
                (0, $kGR8V.CoreHelperUtil).copyToClopboard(this.uri);
                (0, $9fh1I.SnackController).showSuccess("Link copied");
            }
        } catch  {
            (0, $9fh1I.SnackController).showError("Failed to copy");
        }
    }
}
$f280655654489b57$export$902e3cfa9f67689d.styles = (0, $02b05308bb23fb22$export$2e2bcd8739ae039);
$f280655654489b57$var$__decorate([
    (0, $6eT5F.state)()
], $f280655654489b57$export$902e3cfa9f67689d.prototype, "uri", void 0);
$f280655654489b57$var$__decorate([
    (0, $6eT5F.state)()
], $f280655654489b57$export$902e3cfa9f67689d.prototype, "error", void 0);
$f280655654489b57$var$__decorate([
    (0, $6eT5F.state)()
], $f280655654489b57$export$902e3cfa9f67689d.prototype, "ready", void 0);
$f280655654489b57$var$__decorate([
    (0, $6eT5F.state)()
], $f280655654489b57$export$902e3cfa9f67689d.prototype, "showRetry", void 0);
$f280655654489b57$var$__decorate([
    (0, $6eT5F.state)()
], $f280655654489b57$export$902e3cfa9f67689d.prototype, "buffering", void 0);
$f280655654489b57$var$__decorate([
    (0, $5YVCx.property)({
        type: Boolean
    })
], $f280655654489b57$export$902e3cfa9f67689d.prototype, "isMobile", void 0);
$f280655654489b57$var$__decorate([
    (0, $5YVCx.property)()
], $f280655654489b57$export$902e3cfa9f67689d.prototype, "onRetry", void 0);


var $c0139105a8f619e8$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $c0139105a8f619e8$var$platformMap = {
    INJECTED: "browser",
    ANNOUNCED: "browser"
};
let $c0139105a8f619e8$export$1d20b0281d81b1fd = class W3mConnectingExternalView extends (0, $f280655654489b57$export$902e3cfa9f67689d) {
    constructor(){
        super();
        if (!this.connector) throw new Error("w3m-connecting-view: No connector provided");
        (0, $6n0eX.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: this.connector.name ?? "Unknown",
                platform: $c0139105a8f619e8$var$platformMap[this.connector.type] ?? "external"
            }
        });
        this.onConnect = this.onConnectProxy.bind(this);
        this.onAutoConnect = this.onConnectProxy.bind(this);
        this.isWalletConnect = false;
    }
    async onConnectProxy() {
        try {
            this.error = false;
            if (this.connector) {
                if (this.connector.imageUrl) (0, $heSwZ.StorageUtil).setConnectedWalletImageUrl(this.connector.imageUrl);
                await (0, $jJO2B.ConnectionController).connectExternal(this.connector);
                if ((0, $iQR2f.SIWEController).state.isSiweEnabled) (0, $dJjpc.RouterController).push("ConnectingSiwe");
                else (0, $bnxqc.ModalController).close();
                (0, $6n0eX.EventsController).sendEvent({
                    type: "track",
                    event: "CONNECT_SUCCESS",
                    properties: {
                        method: "external"
                    }
                });
            }
        } catch (error) {
            (0, $6n0eX.EventsController).sendEvent({
                type: "track",
                event: "CONNECT_ERROR",
                properties: {
                    message: error?.message ?? "Unknown"
                }
            });
            this.error = true;
        }
    }
};
$c0139105a8f619e8$export$1d20b0281d81b1fd = $c0139105a8f619e8$var$__decorate([
    (0, $lkv4o.customElement)("w3m-connecting-external-view")
], $c0139105a8f619e8$export$1d20b0281d81b1fd);


parcelRequire("aAJP9");
var $5mrMQ = parcelRequire("5mrMQ");
var $jJO2B = parcelRequire("jJO2B");
var $6n0eX = parcelRequire("6n0eX");
var $bnxqc = parcelRequire("bnxqc");
var $8KEpV = parcelRequire("8KEpV");
var $dJjpc = parcelRequire("dJjpc");
var $iQR2f = parcelRequire("iQR2f");
var $9fh1I = parcelRequire("9fh1I");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $6eT5F = parcelRequire("6eT5F");
var $bfa1a142ab15ce02$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $bfa1a142ab15ce02$export$cbe596dc0e3ac801 = class W3mConnectingSiweView extends (0, $b47AP.LitElement) {
    constructor(){
        super(...arguments);
        this.dappName = (0, $8KEpV.OptionsController).state.metadata?.name;
        this.isSigning = false;
    }
    render() {
        return (0, $6HMh7.html)`
      <wui-flex justifyContent="center" .padding=${[
            "2xl",
            "0",
            "xxl",
            "0"
        ]}>
        <w3m-connecting-siwe></w3m-connecting-siwe>
      </wui-flex>
      <wui-flex
        .padding=${[
            "0",
            "4xl",
            "l",
            "4xl"
        ]}
        gap="s"
        justifyContent="space-between"
      >
        <wui-text variant="paragraph-500" align="center" color="fg-100"
          >${this.dappName ?? "Dapp"} needs to connect to your wallet</wui-text
        >
      </wui-flex>
      <wui-flex
        .padding=${[
            "0",
            "3xl",
            "l",
            "3xl"
        ]}
        gap="s"
        justifyContent="space-between"
      >
        <wui-text variant="small-400" align="center" color="fg-200"
          >Sign this message to prove you own this wallet and proceed. Canceling will disconnect
          you.</wui-text
        >
      </wui-flex>
      <wui-flex .padding=${[
            "l",
            "xl",
            "xl",
            "xl"
        ]} gap="s" justifyContent="space-between">
        <wui-button
          size="md"
          ?fullwidth=${true}
          variant="shade"
          @click=${this.onCancel.bind(this)}
          data-testid="w3m-connecting-siwe-cancel"
        >
          Cancel
        </wui-button>
        <wui-button
          size="md"
          ?fullwidth=${true}
          variant="fill"
          @click=${this.onSign.bind(this)}
          ?loading=${this.isSigning}
          data-testid="w3m-connecting-siwe-sign"
        >
          ${this.isSigning ? "Signing..." : "Sign"}
        </wui-button>
      </wui-flex>
    `;
    }
    async onSign() {
        this.isSigning = true;
        (0, $6n0eX.EventsController).sendEvent({
            event: "CLICK_SIGN_SIWE_MESSAGE",
            type: "track"
        });
        try {
            (0, $iQR2f.SIWEController).setStatus("loading");
            const session = await (0, $iQR2f.SIWEController).signIn();
            (0, $iQR2f.SIWEController).setStatus("success");
            (0, $6n0eX.EventsController).sendEvent({
                event: "SIWE_AUTH_SUCCESS",
                type: "track"
            });
            return session;
        } catch (error) {
            (0, $9fh1I.SnackController).showError("Signature declined");
            (0, $iQR2f.SIWEController).setStatus("error");
            return (0, $6n0eX.EventsController).sendEvent({
                event: "SIWE_AUTH_ERROR",
                type: "track"
            });
        } finally{
            this.isSigning = false;
        }
    }
    async onCancel() {
        const { isConnected: isConnected } = (0, $5mrMQ.AccountController).state;
        if (isConnected) {
            await (0, $jJO2B.ConnectionController).disconnect();
            (0, $bnxqc.ModalController).close();
        } else (0, $dJjpc.RouterController).push("Connect");
        (0, $6n0eX.EventsController).sendEvent({
            event: "CLICK_CANCEL_SIWE",
            type: "track"
        });
    }
};
$bfa1a142ab15ce02$var$__decorate([
    (0, $6eT5F.state)()
], $bfa1a142ab15ce02$export$cbe596dc0e3ac801.prototype, "isSigning", void 0);
$bfa1a142ab15ce02$export$cbe596dc0e3ac801 = $bfa1a142ab15ce02$var$__decorate([
    (0, $lkv4o.customElement)("w3m-connecting-siwe-view")
], $bfa1a142ab15ce02$export$cbe596dc0e3ac801);


parcelRequire("aAJP9");
var $7XY6i = parcelRequire("7XY6i");
var $jJO2B = parcelRequire("jJO2B");
var $9QkaU = parcelRequire("9QkaU");
var $5S5Lx = parcelRequire("5S5Lx");
var $kGR8V = parcelRequire("kGR8V");
var $6n0eX = parcelRequire("6n0eX");
var $bnxqc = parcelRequire("bnxqc");
var $dJjpc = parcelRequire("dJjpc");
var $iQR2f = parcelRequire("iQR2f");
var $9fh1I = parcelRequire("9fh1I");
var $heSwZ = parcelRequire("heSwZ");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $6eT5F = parcelRequire("6eT5F");
var $4cb43b5374d71308$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $4cb43b5374d71308$export$749260f2a44cfead = class W3mConnectingWcView extends (0, $b47AP.LitElement) {
    constructor(){
        super();
        this.interval = undefined;
        this.lastRetry = Date.now();
        this.wallet = (0, $dJjpc.RouterController).state.data?.wallet;
        this.platform = undefined;
        this.platforms = [];
        this.initializeConnection();
        this.interval = setInterval(this.initializeConnection.bind(this), (0, $5S5Lx.ConstantsUtil).TEN_SEC_MS);
    }
    disconnectedCallback() {
        clearTimeout(this.interval);
    }
    render() {
        if (!this.wallet) return (0, $6HMh7.html)`<w3m-connecting-wc-qrcode></w3m-connecting-wc-qrcode>`;
        this.determinePlatforms();
        return (0, $6HMh7.html)`
      ${this.headerTemplate()}
      <div>${this.platformTemplate()}</div>
    `;
    }
    async initializeConnection(retry = false) {
        try {
            const { wcPairingExpiry: wcPairingExpiry } = (0, $jJO2B.ConnectionController).state;
            if (retry || (0, $kGR8V.CoreHelperUtil).isPairingExpired(wcPairingExpiry)) {
                (0, $jJO2B.ConnectionController).connectWalletConnect();
                if (this.wallet) {
                    const url = (0, $7XY6i.AssetUtil).getWalletImage(this.wallet);
                    if (url) (0, $heSwZ.StorageUtil).setConnectedWalletImageUrl(url);
                } else {
                    const connectors = (0, $9QkaU.ConnectorController).state.connectors;
                    const connector = connectors.find((c)=>c.type === "WALLET_CONNECT");
                    const url = (0, $7XY6i.AssetUtil).getConnectorImage(connector);
                    if (url) (0, $heSwZ.StorageUtil).setConnectedWalletImageUrl(url);
                }
                await (0, $jJO2B.ConnectionController).state.wcPromise;
                this.finalizeConnection();
                if ((0, $iQR2f.SIWEController).state.isSiweEnabled) (0, $dJjpc.RouterController).push("ConnectingSiwe");
                else (0, $bnxqc.ModalController).close();
            }
        } catch (error) {
            (0, $6n0eX.EventsController).sendEvent({
                type: "track",
                event: "CONNECT_ERROR",
                properties: {
                    message: error?.message ?? "Unknown"
                }
            });
            (0, $jJO2B.ConnectionController).setWcError(true);
            if ((0, $kGR8V.CoreHelperUtil).isAllowedRetry(this.lastRetry)) {
                (0, $9fh1I.SnackController).showError("Declined");
                this.lastRetry = Date.now();
                this.initializeConnection(true);
            }
        }
    }
    finalizeConnection() {
        const { wcLinking: wcLinking, recentWallet: recentWallet } = (0, $jJO2B.ConnectionController).state;
        if (wcLinking) (0, $heSwZ.StorageUtil).setWalletConnectDeepLink(wcLinking);
        if (recentWallet) (0, $heSwZ.StorageUtil).setWeb3ModalRecent(recentWallet);
        (0, $6n0eX.EventsController).sendEvent({
            type: "track",
            event: "CONNECT_SUCCESS",
            properties: {
                method: wcLinking ? "mobile" : "qrcode"
            }
        });
    }
    determinePlatforms() {
        if (!this.wallet) throw new Error("w3m-connecting-wc-view:determinePlatforms No wallet");
        if (this.platform) return;
        const { mobile_link: mobile_link, desktop_link: desktop_link, webapp_link: webapp_link, injected: injected, rdns: rdns } = this.wallet;
        const injectedIds = injected?.map(({ injected_id: injected_id })=>injected_id).filter(Boolean);
        const browserIds = rdns ? [
            rdns
        ] : injectedIds ?? [];
        const isBrowser = browserIds.length;
        const isMobileWc = mobile_link;
        const isWebWc = webapp_link;
        const isBrowserInstalled = (0, $jJO2B.ConnectionController).checkInstalled(browserIds);
        const isBrowserWc = isBrowser && isBrowserInstalled;
        const isDesktopWc = desktop_link && !(0, $kGR8V.CoreHelperUtil).isMobile();
        if (isBrowserWc) this.platforms.push("browser");
        if (isMobileWc) this.platforms.push((0, $kGR8V.CoreHelperUtil).isMobile() ? "mobile" : "qrcode");
        if (isWebWc) this.platforms.push("web");
        if (isDesktopWc) this.platforms.push("desktop");
        if (!isBrowserWc && isBrowser) this.platforms.push("unsupported");
        this.platform = this.platforms[0];
    }
    platformTemplate() {
        switch(this.platform){
            case "browser":
                return (0, $6HMh7.html)`<w3m-connecting-wc-browser></w3m-connecting-wc-browser>`;
            case "desktop":
                return (0, $6HMh7.html)`
          <w3m-connecting-wc-desktop .onRetry=${()=>this.initializeConnection(true)}>
          </w3m-connecting-wc-desktop>
        `;
            case "web":
                return (0, $6HMh7.html)`
          <w3m-connecting-wc-web .onRetry=${()=>this.initializeConnection(true)}>
          </w3m-connecting-wc-web>
        `;
            case "mobile":
                return (0, $6HMh7.html)`
          <w3m-connecting-wc-mobile isMobile .onRetry=${()=>this.initializeConnection(true)}>
          </w3m-connecting-wc-mobile>
        `;
            case "qrcode":
                return (0, $6HMh7.html)`<w3m-connecting-wc-qrcode></w3m-connecting-wc-qrcode>`;
            default:
                return (0, $6HMh7.html)`<w3m-connecting-wc-unsupported></w3m-connecting-wc-unsupported>`;
        }
    }
    headerTemplate() {
        const multiPlatform = this.platforms.length > 1;
        if (!multiPlatform) return null;
        return (0, $6HMh7.html)`
      <w3m-connecting-header
        .platforms=${this.platforms}
        .onSelectPlatfrom=${this.onSelectPlatform.bind(this)}
      >
      </w3m-connecting-header>
    `;
    }
    async onSelectPlatform(platform) {
        const container = this.shadowRoot?.querySelector("div");
        if (container) {
            await container.animate([
                {
                    opacity: 1
                },
                {
                    opacity: 0
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            }).finished;
            this.platform = platform;
            container.animate([
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            });
        }
    }
};
$4cb43b5374d71308$var$__decorate([
    (0, $6eT5F.state)()
], $4cb43b5374d71308$export$749260f2a44cfead.prototype, "platform", void 0);
$4cb43b5374d71308$var$__decorate([
    (0, $6eT5F.state)()
], $4cb43b5374d71308$export$749260f2a44cfead.prototype, "platforms", void 0);
$4cb43b5374d71308$export$749260f2a44cfead = $4cb43b5374d71308$var$__decorate([
    (0, $lkv4o.customElement)("w3m-connecting-wc-view")
], $4cb43b5374d71308$export$749260f2a44cfead);


parcelRequire("aAJP9");
var $kGR8V = parcelRequire("kGR8V");
var $dJjpc = parcelRequire("dJjpc");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
var $2796fc7419069b73$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $2796fc7419069b73$export$72485cd62e8c17e7 = class W3mDownloadsView extends (0, $b47AP.LitElement) {
    constructor(){
        super(...arguments);
        this.wallet = (0, $dJjpc.RouterController).state.data?.wallet;
    }
    render() {
        if (!this.wallet) throw new Error("w3m-downloads-view");
        return (0, $6HMh7.html)`
      <wui-flex gap="xs" flexDirection="column" .padding=${[
            "s",
            "s",
            "l",
            "s"
        ]}>
        ${this.chromeTemplate()} ${this.iosTemplate()} ${this.androidTemplate()}
        ${this.homepageTemplate()}
      </wui-flex>
    `;
    }
    chromeTemplate() {
        if (!this.wallet?.chrome_store) return null;
        return (0, $6HMh7.html)`<wui-list-item
      variant="icon"
      icon="chromeStore"
      iconVariant="square"
      @click=${this.onChromeStore.bind(this)}
      chevron
    >
      <wui-text variant="paragraph-500" color="fg-100">Chrome Extension</wui-text>
    </wui-list-item>`;
    }
    iosTemplate() {
        if (!this.wallet?.app_store) return null;
        return (0, $6HMh7.html)`<wui-list-item
      variant="icon"
      icon="appStore"
      iconVariant="square"
      @click=${this.onAppStore.bind(this)}
      chevron
    >
      <wui-text variant="paragraph-500" color="fg-100">iOS App</wui-text>
    </wui-list-item>`;
    }
    androidTemplate() {
        if (!this.wallet?.play_store) return null;
        return (0, $6HMh7.html)`<wui-list-item
      variant="icon"
      icon="playStore"
      iconVariant="square"
      @click=${this.onPlayStore.bind(this)}
      chevron
    >
      <wui-text variant="paragraph-500" color="fg-100">Android App</wui-text>
    </wui-list-item>`;
    }
    homepageTemplate() {
        if (!this.wallet?.homepage) return null;
        return (0, $6HMh7.html)`
      <wui-list-item
        variant="icon"
        icon="browser"
        iconVariant="square-blue"
        @click=${this.onHomePage.bind(this)}
        chevron
      >
        <wui-text variant="paragraph-500" color="fg-100">Website</wui-text>
      </wui-list-item>
    `;
    }
    onChromeStore() {
        if (this.wallet?.chrome_store) (0, $kGR8V.CoreHelperUtil).openHref(this.wallet.chrome_store, "_blank");
    }
    onAppStore() {
        if (this.wallet?.app_store) (0, $kGR8V.CoreHelperUtil).openHref(this.wallet.app_store, "_blank");
    }
    onPlayStore() {
        if (this.wallet?.play_store) (0, $kGR8V.CoreHelperUtil).openHref(this.wallet.play_store, "_blank");
    }
    onHomePage() {
        if (this.wallet?.homepage) (0, $kGR8V.CoreHelperUtil).openHref(this.wallet.homepage, "_blank");
    }
};
$2796fc7419069b73$export$72485cd62e8c17e7 = $2796fc7419069b73$var$__decorate([
    (0, $lkv4o.customElement)("w3m-downloads-view")
], $2796fc7419069b73$export$72485cd62e8c17e7);


parcelRequire("aAJP9");
var $6tAXH = parcelRequire("6tAXH");
var $7XY6i = parcelRequire("7XY6i");
var $kGR8V = parcelRequire("kGR8V");
var $8KEpV = parcelRequire("8KEpV");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");

var $e97f352eda6cb0ed$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $e97f352eda6cb0ed$var$EXPLORER = "https://walletconnect.com/explorer";
let $e97f352eda6cb0ed$export$24ca15e036ec0442 = class W3mGetWalletView extends (0, $b47AP.LitElement) {
    render() {
        return (0, $6HMh7.html)`
      <wui-flex flexDirection="column" padding="s" gap="xs">
        ${this.recommendedWalletsTemplate()}
        <wui-list-wallet
          name="Explore all"
          showAllWallets
          walletIcon="allWallets"
          icon="externalLink"
          @click=${()=>{
            (0, $kGR8V.CoreHelperUtil).openHref("https://walletconnect.com/explorer?type=wallet", "_blank");
        }}
        ></wui-list-wallet>
      </wui-flex>
    `;
    }
    recommendedWalletsTemplate() {
        const { recommended: recommended, featured: featured } = (0, $6tAXH.ApiController).state;
        const { customWallets: customWallets } = (0, $8KEpV.OptionsController).state;
        const wallets = [
            ...featured,
            ...customWallets ?? [],
            ...recommended
        ].slice(0, 4);
        return wallets.map((wallet)=>(0, $6HMh7.html)`
        <wui-list-wallet
          name=${wallet.name ?? "Unknown"}
          tagVariant="main"
          imageSrc=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)((0, $7XY6i.AssetUtil).getWalletImage(wallet))}
          @click=${()=>{
                (0, $kGR8V.CoreHelperUtil).openHref(wallet.homepage ?? $e97f352eda6cb0ed$var$EXPLORER, "_blank");
            }}
        ></wui-list-wallet>
      `);
    }
};
$e97f352eda6cb0ed$export$24ca15e036ec0442 = $e97f352eda6cb0ed$var$__decorate([
    (0, $lkv4o.customElement)("w3m-get-wallet-view")
], $e97f352eda6cb0ed$export$24ca15e036ec0442);


parcelRequire("aAJP9");
var $7XY6i = parcelRequire("7XY6i");
var $b6tQF = parcelRequire("b6tQF");
var $dJjpc = parcelRequire("dJjpc");
var $49HpJ = parcelRequire("49HpJ");
var $iQR2f = parcelRequire("iQR2f");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $6eT5F = parcelRequire("6eT5F");

parcelRequire("5bcND");
var $kq2WI = parcelRequire("kq2WI");
var $e9f9e90f0bfe4211$export$2e2bcd8739ae039 = (0, $kq2WI.css)`
  @keyframes shake {
    0% {
      transform: translateX(0);
    }
    25% {
      transform: translateX(3px);
    }
    50% {
      transform: translateX(-3px);
    }
    75% {
      transform: translateX(3px);
    }
    100% {
      transform: translateX(0);
    }
  }

  wui-flex:first-child:not(:only-child) {
    position: relative;
  }

  wui-loading-hexagon {
    position: absolute;
  }

  wui-icon-box {
    position: absolute;
    right: 4px;
    bottom: 0;
    opacity: 0;
    transform: scale(0.5);
    z-index: 1;
    transition: all var(--wui-ease-out-power-2) var(--wui-duration-lg);
  }

  wui-button {
    display: none;
  }

  [data-error='true'] wui-icon-box {
    opacity: 1;
    transform: scale(1);
  }

  [data-error='true'] > wui-flex:first-child {
    animation: shake 250ms cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
  }

  wui-button[data-retry='true'] {
    display: block;
    opacity: 1;
  }
`;


var $31e9b0cfa4377fec$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $31e9b0cfa4377fec$export$d124f6a585588d61 = class W3mNetworkSwitchView extends (0, $b47AP.LitElement) {
    constructor(){
        super();
        this.network = (0, $dJjpc.RouterController).state.data?.network;
        this.unsubscribe = [];
        this.showRetry = false;
        this.error = false;
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    firstUpdated() {
        this.onSwitchNetwork();
    }
    render() {
        if (!this.network) throw new Error("w3m-network-switch-view: No network provided");
        this.onShowRetry();
        const label = this.error ? "Switch declined" : "Approve in wallet";
        const subLabel = this.error ? "Switch can be declined if chain is not supported by a wallet or previous request is still active" : "Accept connection request in your wallet";
        return (0, $6HMh7.html)`
      <wui-flex
        data-error=${this.error}
        flexDirection="column"
        alignItems="center"
        .padding=${[
            "3xl",
            "xl",
            "3xl",
            "xl"
        ]}
        gap="xl"
      >
        <wui-flex justifyContent="center" alignItems="center">
          <wui-network-image
            size="lg"
            imageSrc=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)((0, $7XY6i.AssetUtil).getNetworkImage(this.network))}
          ></wui-network-image>

          ${this.error ? null : (0, $6HMh7.html)`<wui-loading-hexagon></wui-loading-hexagon>`}

          <wui-icon-box
            backgroundColor="error-100"
            background="opaque"
            iconColor="error-100"
            icon="close"
            size="sm"
            ?border=${true}
            borderColor="wui-color-bg-125"
          ></wui-icon-box>
        </wui-flex>

        <wui-flex flexDirection="column" alignItems="center" gap="xs">
          <wui-text align="center" variant="paragraph-500" color="fg-100">${label}</wui-text>
          <wui-text align="center" variant="small-500" color="fg-200">${subLabel}</wui-text>
        </wui-flex>

        <wui-button
          data-retry=${this.showRetry}
          variant="fill"
          .disabled=${!this.error}
          @click=${this.onSwitchNetwork.bind(this)}
        >
          <wui-icon color="inherit" slot="iconLeft" name="refresh"></wui-icon>
          Try again
        </wui-button>
      </wui-flex>
    `;
    }
    onShowRetry() {
        if (this.error && !this.showRetry) {
            this.showRetry = true;
            const retryButton = this.shadowRoot?.querySelector("wui-button");
            retryButton?.animate([
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ], {
                fill: "forwards",
                easing: "ease"
            });
        }
    }
    async onSwitchNetwork() {
        try {
            this.error = false;
            if (this.network) {
                await (0, $b6tQF.NetworkController).switchActiveNetwork(this.network);
                if (!(0, $iQR2f.SIWEController).state.isSiweEnabled) (0, $49HpJ.RouterUtil).navigateAfterNetworkSwitch();
            }
        } catch  {
            this.error = true;
        }
    }
};
$31e9b0cfa4377fec$export$d124f6a585588d61.styles = (0, $e9f9e90f0bfe4211$export$2e2bcd8739ae039);
$31e9b0cfa4377fec$var$__decorate([
    (0, $6eT5F.state)()
], $31e9b0cfa4377fec$export$d124f6a585588d61.prototype, "showRetry", void 0);
$31e9b0cfa4377fec$var$__decorate([
    (0, $6eT5F.state)()
], $31e9b0cfa4377fec$export$d124f6a585588d61.prototype, "error", void 0);
$31e9b0cfa4377fec$export$d124f6a585588d61 = $31e9b0cfa4377fec$var$__decorate([
    (0, $lkv4o.customElement)("w3m-network-switch-view")
], $31e9b0cfa4377fec$export$d124f6a585588d61);


parcelRequire("aAJP9");
var $5mrMQ = parcelRequire("5mrMQ");
var $7XY6i = parcelRequire("7XY6i");
var $kGR8V = parcelRequire("kGR8V");
var $6n0eX = parcelRequire("6n0eX");
var $b6tQF = parcelRequire("b6tQF");
var $dJjpc = parcelRequire("dJjpc");
var $49HpJ = parcelRequire("49HpJ");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $6eT5F = parcelRequire("6eT5F");

parcelRequire("5bcND");
var $kq2WI = parcelRequire("kq2WI");
var $1f63f92854814f64$export$2e2bcd8739ae039 = (0, $kq2WI.css)`
  :host > wui-grid {
    max-height: 360px;
    overflow: auto;
  }

  wui-grid::-webkit-scrollbar {
    display: none;
  }
`;


var $552fc6a69df09806$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $552fc6a69df09806$export$ff1f854e9d8d99b2 = class W3mNetworksView extends (0, $b47AP.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.caipNetwork = (0, $b6tQF.NetworkController).state.caipNetwork;
        this.unsubscribe.push((0, $b6tQF.NetworkController).subscribeKey("caipNetwork", (val)=>this.caipNetwork = val));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $6HMh7.html)`
      <wui-grid padding="s" gridTemplateColumns="repeat(4, 1fr)" rowGap="l" columnGap="xs">
        ${this.networksTemplate()}
      </wui-grid>

      <wui-separator></wui-separator>

      <wui-flex padding="s" flexDirection="column" gap="m" alignItems="center">
        <wui-text variant="small-400" color="fg-300" align="center">
          Your connected wallet may not support some of the networks available for this dApp
        </wui-text>
        <wui-link @click=${this.onNetworkHelp.bind(this)}>
          <wui-icon size="xs" color="accent-100" slot="iconLeft" name="helpCircle"></wui-icon>
          What is a network
        </wui-link>
      </wui-flex>
    `;
    }
    onNetworkHelp() {
        (0, $6n0eX.EventsController).sendEvent({
            type: "track",
            event: "CLICK_NETWORK_HELP"
        });
        (0, $dJjpc.RouterController).push("WhatIsANetwork");
    }
    networksTemplate() {
        const { approvedCaipNetworkIds: approvedCaipNetworkIds, requestedCaipNetworks: requestedCaipNetworks, supportsAllNetworks: supportsAllNetworks } = (0, $b6tQF.NetworkController).state;
        const sortedNetworks = (0, $kGR8V.CoreHelperUtil).sortRequestedNetworks(approvedCaipNetworkIds, requestedCaipNetworks);
        return sortedNetworks?.map((network)=>(0, $6HMh7.html)`
        <wui-card-select
          .selected=${this.caipNetwork?.id === network.id}
          imageSrc=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)((0, $7XY6i.AssetUtil).getNetworkImage(network))}
          type="network"
          name=${network.name ?? network.id}
          @click=${()=>this.onSwitchNetwork(network)}
          .disabled=${!supportsAllNetworks && !approvedCaipNetworkIds?.includes(network.id)}
          data-testid=${`w3m-network-switch-${network.name ?? network.id}`}
        ></wui-card-select>
      `);
    }
    async onSwitchNetwork(network) {
        const { isConnected: isConnected } = (0, $5mrMQ.AccountController).state;
        const { approvedCaipNetworkIds: approvedCaipNetworkIds, supportsAllNetworks: supportsAllNetworks, caipNetwork: caipNetwork } = (0, $b6tQF.NetworkController).state;
        const { data: data } = (0, $dJjpc.RouterController).state;
        if (isConnected && caipNetwork?.id !== network.id) {
            if (approvedCaipNetworkIds?.includes(network.id)) {
                await (0, $b6tQF.NetworkController).switchActiveNetwork(network);
                (0, $49HpJ.RouterUtil).navigateAfterNetworkSwitch();
            } else if (supportsAllNetworks) (0, $dJjpc.RouterController).push("SwitchNetwork", {
                ...data,
                network: network
            });
        } else if (!isConnected) {
            (0, $b6tQF.NetworkController).setCaipNetwork(network);
            (0, $dJjpc.RouterController).push("Connect");
        }
    }
};
$552fc6a69df09806$export$ff1f854e9d8d99b2.styles = (0, $1f63f92854814f64$export$2e2bcd8739ae039);
$552fc6a69df09806$var$__decorate([
    (0, $6eT5F.state)()
], $552fc6a69df09806$export$ff1f854e9d8d99b2.prototype, "caipNetwork", void 0);
$552fc6a69df09806$export$ff1f854e9d8d99b2 = $552fc6a69df09806$var$__decorate([
    (0, $lkv4o.customElement)("w3m-networks-view")
], $552fc6a69df09806$export$ff1f854e9d8d99b2);


parcelRequire("1zadX");
var $c9aBm = parcelRequire("c9aBm");
parcelRequire("aAJP9");
var $5mrMQ = parcelRequire("5mrMQ");
var $hCakD = parcelRequire("hCakD");
var $ahDsO = parcelRequire("ahDsO");
var $8KEpV = parcelRequire("8KEpV");
var $6oINN = parcelRequire("6oINN");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
var $gC2QS = parcelRequire("gC2QS");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $6eT5F = parcelRequire("6eT5F");
parcelRequire("5bcND");
var $kq2WI = parcelRequire("kq2WI");
var $a215ff0e47cbe333$export$2e2bcd8739ae039 = (0, $kq2WI.css)`
  :host > wui-flex {
    height: 500px;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
    padding: var(--wui-spacing-m);
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  :host > wui-flex > wui-flex {
    width: 100%;
  }

  wui-transaction-list-item-loader {
    width: 100%;
  }
`;



var $e54565cfe4d1fe55$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $e54565cfe4d1fe55$var$LOADING_ITEM_COUNT = 7;
let $e54565cfe4d1fe55$export$4a0b241548ecf9e5 = class W3mOnRampActivityView extends (0, $b47AP.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.refetchTimeout = undefined;
        this.selectedOnRampProvider = (0, $ahDsO.OnRampController).state.selectedProvider;
        this.loading = false;
        this.coinbaseTransactions = (0, $6oINN.TransactionsController).state.coinbaseTransactions;
        this.tokenImages = (0, $hCakD.AssetController).state.tokenImages;
        this.unsubscribe.push(...[
            (0, $ahDsO.OnRampController).subscribeKey("selectedProvider", (val)=>{
                this.selectedOnRampProvider = val;
            }),
            (0, $hCakD.AssetController).subscribeKey("tokenImages", (val)=>this.tokenImages = val),
            ()=>{
                clearTimeout(this.refetchTimeout);
            },
            (0, $6oINN.TransactionsController).subscribe((val)=>{
                this.coinbaseTransactions = {
                    ...val.coinbaseTransactions
                };
            })
        ]);
        this.fetchTransactions();
    }
    render() {
        return (0, $6HMh7.html)`
      <wui-flex flexDirection="column" padding="s" gap="xs">
        ${this.loading ? this.templateLoading() : this.templateTransactionsByYear()}
      </wui-flex>
    `;
    }
    templateTransactions(transactions) {
        return transactions?.map((transaction)=>{
            const date = (0, $c9aBm.DateUtil).formatDate(transaction?.metadata?.minedAt);
            const transfer = transaction.transfers[0];
            const fungibleInfo = transfer?.fungible_info;
            if (!fungibleInfo) return null;
            const icon = fungibleInfo?.icon?.url || this.tokenImages?.[fungibleInfo.symbol || ""];
            return (0, $6HMh7.html)`
        <wui-onramp-activity-item
          label="Bought"
          .completed=${transaction.metadata.status === "ONRAMP_TRANSACTION_STATUS_SUCCESS"}
          .inProgress=${transaction.metadata.status === "ONRAMP_TRANSACTION_STATUS_IN_PROGRESS"}
          .failed=${transaction.metadata.status === "ONRAMP_TRANSACTION_STATUS_FAILED"}
          purchaseCurrency=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)(fungibleInfo.symbol)}
          purchaseValue=${transfer.quantity.numeric}
          date=${date}
          icon=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)(icon)}
          symbol=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)(fungibleInfo.symbol)}
        ></wui-onramp-activity-item>
      `;
        });
    }
    templateTransactionsByYear() {
        const sortedYearKeys = Object.keys(this.coinbaseTransactions).sort().reverse();
        return sortedYearKeys.map((year)=>{
            const yearInt = parseInt(year, 10);
            const sortedMonthIndexes = new Array(12).fill(null).map((_, idx)=>idx).reverse();
            return sortedMonthIndexes.map((month)=>{
                const groupTitle = (0, $gC2QS.TransactionUtil).getTransactionGroupTitle(yearInt, month);
                const transactions = this.coinbaseTransactions[yearInt]?.[month];
                if (!transactions) return null;
                return (0, $6HMh7.html)`
          <wui-flex flexDirection="column">
            <wui-flex
              alignItems="center"
              flexDirection="row"
              .padding=${[
                    "xs",
                    "s",
                    "s",
                    "s"
                ]}
            >
              <wui-text variant="paragraph-500" color="fg-200">${groupTitle}</wui-text>
            </wui-flex>
            <wui-flex flexDirection="column" gap="xs">
              ${this.templateTransactions(transactions)}
            </wui-flex>
          </wui-flex>
        `;
            });
        });
    }
    async fetchTransactions() {
        const provider = "coinbase";
        if (provider === "coinbase") await this.fetchCoinbaseTransactions();
    }
    async fetchCoinbaseTransactions() {
        const address = (0, $5mrMQ.AccountController).state.address;
        const projectId = (0, $8KEpV.OptionsController).state.projectId;
        if (!address) throw new Error("No address found");
        if (!projectId) throw new Error("No projectId found");
        this.loading = true;
        await (0, $6oINN.TransactionsController).fetchTransactions(address, "coinbase");
        this.loading = false;
        this.refetchLoadingTransactions();
    }
    refetchLoadingTransactions() {
        const today = new Date();
        const currentMonthTxs = this.coinbaseTransactions[today.getFullYear()]?.[today.getMonth()] || [];
        const loadingTransactions = currentMonthTxs.filter((transaction)=>transaction.metadata.status === "ONRAMP_TRANSACTION_STATUS_IN_PROGRESS");
        if (loadingTransactions.length === 0) {
            clearTimeout(this.refetchTimeout);
            return;
        }
        this.refetchTimeout = setTimeout(async ()=>{
            const address = (0, $5mrMQ.AccountController).state.address;
            await (0, $6oINN.TransactionsController).fetchTransactions(address, "coinbase");
            this.refetchLoadingTransactions();
        }, 3000);
    }
    templateLoading() {
        return Array($e54565cfe4d1fe55$var$LOADING_ITEM_COUNT).fill((0, $6HMh7.html)` <wui-transaction-list-item-loader></wui-transaction-list-item-loader> `).map((item)=>item);
    }
};
$e54565cfe4d1fe55$export$4a0b241548ecf9e5.styles = (0, $a215ff0e47cbe333$export$2e2bcd8739ae039);
$e54565cfe4d1fe55$var$__decorate([
    (0, $6eT5F.state)()
], $e54565cfe4d1fe55$export$4a0b241548ecf9e5.prototype, "selectedOnRampProvider", void 0);
$e54565cfe4d1fe55$var$__decorate([
    (0, $6eT5F.state)()
], $e54565cfe4d1fe55$export$4a0b241548ecf9e5.prototype, "loading", void 0);
$e54565cfe4d1fe55$var$__decorate([
    (0, $6eT5F.state)()
], $e54565cfe4d1fe55$export$4a0b241548ecf9e5.prototype, "coinbaseTransactions", void 0);
$e54565cfe4d1fe55$var$__decorate([
    (0, $6eT5F.state)()
], $e54565cfe4d1fe55$export$4a0b241548ecf9e5.prototype, "tokenImages", void 0);
$e54565cfe4d1fe55$export$4a0b241548ecf9e5 = $e54565cfe4d1fe55$var$__decorate([
    (0, $lkv4o.customElement)("w3m-onramp-activity-view")
], $e54565cfe4d1fe55$export$4a0b241548ecf9e5);


parcelRequire("aAJP9");
var $hCakD = parcelRequire("hCakD");
var $bnxqc = parcelRequire("bnxqc");
var $ahDsO = parcelRequire("ahDsO");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $6eT5F = parcelRequire("6eT5F");
parcelRequire("5bcND");
var $kq2WI = parcelRequire("kq2WI");
var $f0849dff4f898be5$export$2e2bcd8739ae039 = (0, $kq2WI.css)`
  :host > wui-grid {
    max-height: 360px;
    overflow: auto;
  }

  wui-grid::-webkit-scrollbar {
    display: none;
  }
`;



var $7873c4ed183ee2df$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $7873c4ed183ee2df$export$d8e2d72354b51198 = class W3mOnrampFiatSelectView extends (0, $b47AP.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.selectedCurrency = (0, $ahDsO.OnRampController).state.paymentCurrency;
        this.currencies = (0, $ahDsO.OnRampController).state.paymentCurrencies;
        this.currencyImages = (0, $hCakD.AssetController).state.currencyImages;
        this.unsubscribe.push(...[
            (0, $ahDsO.OnRampController).subscribe((val)=>{
                this.selectedCurrency = val.paymentCurrency;
                this.currencies = val.paymentCurrencies;
            }),
            (0, $hCakD.AssetController).subscribeKey("currencyImages", (val)=>this.currencyImages = val)
        ]);
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $6HMh7.html)`
      <wui-flex flexDirection="column" padding="s" gap="xs">
        ${this.currenciesTemplate()}
      </wui-flex>
      <w3m-legal-footer></w3m-legal-footer>
    `;
    }
    currenciesTemplate() {
        return this.currencies.map((currency)=>(0, $6HMh7.html)`
        <wui-list-item
          imageSrc=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)(this.currencyImages?.[currency.id])}
          @click=${()=>this.selectCurrency(currency)}
          variant="image"
        >
          <wui-text variant="paragraph-500" color="fg-100">${currency.id}</wui-text>
        </wui-list-item>
      `);
    }
    selectCurrency(currency) {
        if (!currency) return;
        (0, $ahDsO.OnRampController).setPaymentCurrency(currency);
        (0, $bnxqc.ModalController).close();
    }
};
$7873c4ed183ee2df$export$d8e2d72354b51198.styles = (0, $f0849dff4f898be5$export$2e2bcd8739ae039);
$7873c4ed183ee2df$var$__decorate([
    (0, $6eT5F.state)()
], $7873c4ed183ee2df$export$d8e2d72354b51198.prototype, "selectedCurrency", void 0);
$7873c4ed183ee2df$var$__decorate([
    (0, $6eT5F.state)()
], $7873c4ed183ee2df$export$d8e2d72354b51198.prototype, "currencies", void 0);
$7873c4ed183ee2df$var$__decorate([
    (0, $6eT5F.state)()
], $7873c4ed183ee2df$export$d8e2d72354b51198.prototype, "currencyImages", void 0);
$7873c4ed183ee2df$export$d8e2d72354b51198 = $7873c4ed183ee2df$var$__decorate([
    (0, $lkv4o.customElement)("w3m-onramp-fiat-select-view")
], $7873c4ed183ee2df$export$d8e2d72354b51198);


parcelRequire("aAJP9");
var $5mrMQ = parcelRequire("5mrMQ");
var $6Y81T = parcelRequire("6Y81T");
var $5S5Lx = parcelRequire("5S5Lx");
var $kGR8V = parcelRequire("kGR8V");
var $b6tQF = parcelRequire("b6tQF");
var $ahDsO = parcelRequire("ahDsO");
var $dJjpc = parcelRequire("dJjpc");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $6eT5F = parcelRequire("6eT5F");
var $e1eacb25364c6c6c$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $e1eacb25364c6c6c$export$59a62e1add0f780c = class W3mOnRampProvidersView extends (0, $b47AP.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.providers = (0, $ahDsO.OnRampController).state.providers;
        this.unsubscribe.push(...[
            (0, $ahDsO.OnRampController).subscribeKey("providers", (val)=>{
                this.providers = val;
            })
        ]);
    }
    firstUpdated() {
        const urlPromises = this.providers.map(async (provider)=>{
            if (provider.name === "coinbase") return await this.getCoinbaseOnRampURL();
            return Promise.resolve(provider?.url);
        });
        Promise.all(urlPromises).then((urls)=>{
            this.providers = this.providers.map((provider, index)=>({
                    ...provider,
                    url: urls[index] || ""
                }));
        });
    }
    render() {
        return (0, $6HMh7.html)`
      <wui-flex flexDirection="column" padding="s" gap="xs">
        ${this.onRampProvidersTemplate()}
      </wui-flex>
      <w3m-onramp-providers-footer></w3m-onramp-providers-footer>
    `;
    }
    onRampProvidersTemplate() {
        return this.providers.map((provider)=>(0, $6HMh7.html)`
        <wui-onramp-provider-item
          label=${provider.label}
          name=${provider.name}
          feeRange=${provider.feeRange}
          @click=${()=>{
                this.onClickProvider(provider);
            }}
          ?disabled=${!provider.url}
        ></wui-onramp-provider-item>
      `);
    }
    onClickProvider(provider) {
        (0, $ahDsO.OnRampController).setSelectedProvider(provider);
        (0, $dJjpc.RouterController).push("BuyInProgress");
        (0, $kGR8V.CoreHelperUtil).openHref(provider.url, "popupWindow", "width=600,height=800,scrollbars=yes");
    }
    async getCoinbaseOnRampURL() {
        const address = (0, $5mrMQ.AccountController).state.address;
        const network = (0, $b6tQF.NetworkController).state.caipNetwork;
        if (!address) throw new Error("No address found");
        if (!network?.name) throw new Error("No network found");
        const defaultNetwork = (0, $5S5Lx.ConstantsUtil).WC_COINBASE_PAY_SDK_CHAIN_NAME_MAP[network.name] ?? (0, $5S5Lx.ConstantsUtil).WC_COINBASE_PAY_SDK_FALLBACK_CHAIN;
        const purchaseCurrency = (0, $ahDsO.OnRampController).state.purchaseCurrency;
        const assets = purchaseCurrency ? [
            purchaseCurrency.symbol
        ] : (0, $ahDsO.OnRampController).state.purchaseCurrencies.map((currency)=>currency.symbol);
        return await (0, $6Y81T.BlockchainApiController).generateOnRampURL({
            defaultNetwork: defaultNetwork,
            destinationWallets: [
                {
                    address: address,
                    blockchains: (0, $5S5Lx.ConstantsUtil).WC_COINBASE_PAY_SDK_CHAINS,
                    assets: assets
                }
            ],
            partnerUserId: address,
            purchaseAmount: (0, $ahDsO.OnRampController).state.purchaseAmount
        });
    }
};
$e1eacb25364c6c6c$var$__decorate([
    (0, $6eT5F.state)()
], $e1eacb25364c6c6c$export$59a62e1add0f780c.prototype, "providers", void 0);
$e1eacb25364c6c6c$export$59a62e1add0f780c = $e1eacb25364c6c6c$var$__decorate([
    (0, $lkv4o.customElement)("w3m-onramp-providers-view")
], $e1eacb25364c6c6c$export$59a62e1add0f780c);


parcelRequire("aAJP9");
var $hCakD = parcelRequire("hCakD");
var $bnxqc = parcelRequire("bnxqc");
var $ahDsO = parcelRequire("ahDsO");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $6eT5F = parcelRequire("6eT5F");
parcelRequire("5bcND");
var $kq2WI = parcelRequire("kq2WI");
var $a4cc6ed45dc00aaf$export$2e2bcd8739ae039 = (0, $kq2WI.css)`
  :host > wui-grid {
    max-height: 360px;
    overflow: auto;
  }

  wui-grid::-webkit-scrollbar {
    display: none;
  }
`;



var $e141823b66a6abfd$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $e141823b66a6abfd$export$97f0fa712fa488a5 = class W3mOnrampTokensView extends (0, $b47AP.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.selectedCurrency = (0, $ahDsO.OnRampController).state.purchaseCurrencies;
        this.tokens = (0, $ahDsO.OnRampController).state.purchaseCurrencies;
        this.tokenImages = (0, $hCakD.AssetController).state.tokenImages;
        this.unsubscribe.push(...[
            (0, $ahDsO.OnRampController).subscribe((val)=>{
                this.selectedCurrency = val.purchaseCurrencies;
                this.tokens = val.purchaseCurrencies;
            }),
            (0, $hCakD.AssetController).subscribeKey("tokenImages", (val)=>this.tokenImages = val)
        ]);
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $6HMh7.html)`
      <wui-flex flexDirection="column" padding="s" gap="xs">
        ${this.currenciesTemplate()}
      </wui-flex>
      <w3m-legal-footer></w3m-legal-footer>
    `;
    }
    currenciesTemplate() {
        return this.tokens.map((token)=>(0, $6HMh7.html)`
        <wui-list-item
          imageSrc=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)(this.tokenImages?.[token.symbol])}
          @click=${()=>this.selectToken(token)}
          variant="image"
        >
          <wui-flex gap="3xs" alignItems="center">
            <wui-text variant="paragraph-500" color="fg-100">${token.name}</wui-text>
            <wui-text variant="small-400" color="fg-200">${token.symbol}</wui-text>
          </wui-flex>
        </wui-list-item>
      `);
    }
    selectToken(currency) {
        if (!currency) return;
        (0, $ahDsO.OnRampController).setPurchaseCurrency(currency);
        (0, $bnxqc.ModalController).close();
    }
};
$e141823b66a6abfd$export$97f0fa712fa488a5.styles = (0, $a4cc6ed45dc00aaf$export$2e2bcd8739ae039);
$e141823b66a6abfd$var$__decorate([
    (0, $6eT5F.state)()
], $e141823b66a6abfd$export$97f0fa712fa488a5.prototype, "selectedCurrency", void 0);
$e141823b66a6abfd$var$__decorate([
    (0, $6eT5F.state)()
], $e141823b66a6abfd$export$97f0fa712fa488a5.prototype, "tokens", void 0);
$e141823b66a6abfd$var$__decorate([
    (0, $6eT5F.state)()
], $e141823b66a6abfd$export$97f0fa712fa488a5.prototype, "tokenImages", void 0);
$e141823b66a6abfd$export$97f0fa712fa488a5 = $e141823b66a6abfd$var$__decorate([
    (0, $lkv4o.customElement)("w3m-onramp-token-select-view")
], $e141823b66a6abfd$export$97f0fa712fa488a5);


parcelRequire("1zadX");
var $c9aBm = parcelRequire("c9aBm");
parcelRequire("aAJP9");
var $5mrMQ = parcelRequire("5mrMQ");
var $6n0eX = parcelRequire("6n0eX");
var $8KEpV = parcelRequire("8KEpV");
var $6oINN = parcelRequire("6oINN");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
var $gC2QS = parcelRequire("gC2QS");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $6eT5F = parcelRequire("6eT5F");
parcelRequire("5bcND");
var $kq2WI = parcelRequire("kq2WI");
var $44d6f59f4777fbe1$export$2e2bcd8739ae039 = (0, $kq2WI.css)`
  :host > wui-flex:first-child {
    height: 500px;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
    padding: var(--wui-spacing-m);
  }

  :host > wui-flex:first-child::-webkit-scrollbar {
    display: none;
  }
`;


var $1dda25eee947f849$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $1dda25eee947f849$var$PAGINATOR_ID = "last-transaction";
const $1dda25eee947f849$var$LOADING_ITEM_COUNT = 7;
let $1dda25eee947f849$export$5b9982998ebc2231 = class W3mTransactionsView extends (0, $b47AP.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.paginationObserver = undefined;
        this.address = (0, $5mrMQ.AccountController).state.address;
        this.transactionsByYear = (0, $6oINN.TransactionsController).state.transactionsByYear;
        this.loading = (0, $6oINN.TransactionsController).state.loading;
        this.empty = (0, $6oINN.TransactionsController).state.empty;
        this.next = (0, $6oINN.TransactionsController).state.next;
        this.unsubscribe.push(...[
            (0, $5mrMQ.AccountController).subscribe((val)=>{
                if (val.isConnected) {
                    if (this.address !== val.address) {
                        this.address = val.address;
                        (0, $6oINN.TransactionsController).resetTransactions();
                        (0, $6oINN.TransactionsController).fetchTransactions(val.address);
                    }
                }
            }),
            (0, $6oINN.TransactionsController).subscribe((val)=>{
                this.transactionsByYear = val.transactionsByYear;
                this.loading = val.loading;
                this.empty = val.empty;
                this.next = val.next;
            })
        ]);
    }
    firstUpdated() {
        (0, $6oINN.TransactionsController).fetchTransactions(this.address);
        this.createPaginationObserver();
    }
    updated() {
        this.setPaginationObserver();
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $6HMh7.html)`
      <wui-flex flexDirection="column" gap="s">
        ${this.empty ? null : this.templateTransactionsByYear()}
        ${this.loading ? this.templateLoading() : null}
        ${!this.loading && this.empty ? this.templateEmpty() : null}
      </wui-flex>
    `;
    }
    templateTransactionsByYear() {
        const sortedYearKeys = Object.keys(this.transactionsByYear).sort().reverse();
        return sortedYearKeys.map((year, index)=>{
            const isLastGroup = index === sortedYearKeys.length - 1;
            const yearInt = parseInt(year, 10);
            const sortedMonthIndexes = new Array(12).fill(null).map((_, idx)=>idx).reverse();
            return sortedMonthIndexes.map((month)=>{
                const groupTitle = (0, $gC2QS.TransactionUtil).getTransactionGroupTitle(yearInt, month);
                const transactions = this.transactionsByYear[yearInt]?.[month];
                if (!transactions) return null;
                return (0, $6HMh7.html)`
          <wui-flex flexDirection="column">
            <wui-flex
              alignItems="center"
              flexDirection="row"
              .padding=${[
                    "xs",
                    "s",
                    "s",
                    "s"
                ]}
            >
              <wui-text variant="paragraph-500" color="fg-200">${groupTitle}</wui-text>
            </wui-flex>
            <wui-flex flexDirection="column" gap="xs">
              ${this.templateTransactions(transactions, isLastGroup)}
            </wui-flex>
          </wui-flex>
        `;
            });
        });
    }
    templateRenderTransaction(transaction, isLastTransaction) {
        const { date: date, descriptions: descriptions, direction: direction, isAllNFT: isAllNFT, images: images, status: status, transfers: transfers, type: type } = this.getTransactionListItemProps(transaction);
        const haveMultipleTransfers = transfers?.length > 1;
        const haveTwoTransfers = transfers?.length === 2;
        if (haveTwoTransfers && !isAllNFT) return (0, $6HMh7.html)`
        <wui-transaction-list-item
          date=${date}
          .direction=${direction}
          id=${isLastTransaction && this.next ? $1dda25eee947f849$var$PAGINATOR_ID : ""}
          status=${status}
          type=${type}
          .images=${images}
          .descriptions=${descriptions}
        ></wui-transaction-list-item>
      `;
        if (haveMultipleTransfers) return transfers.map((transfer, index)=>{
            const description = (0, $gC2QS.TransactionUtil).getTransferDescription(transfer);
            const isLastTransfer = isLastTransaction && index === transfers.length - 1;
            return (0, $6HMh7.html)` <wui-transaction-list-item
          date=${date}
          direction=${transfer.direction}
          id=${isLastTransfer && this.next ? $1dda25eee947f849$var$PAGINATOR_ID : ""}
          status=${status}
          type=${type}
          .onlyDirectionIcon=${true}
          .images=${[
                images[index]
            ]}
          .descriptions=${[
                description
            ]}
        ></wui-transaction-list-item>`;
        });
        return (0, $6HMh7.html)`
      <wui-transaction-list-item
        date=${date}
        .direction=${direction}
        id=${isLastTransaction && this.next ? $1dda25eee947f849$var$PAGINATOR_ID : ""}
        status=${status}
        type=${type}
        .images=${images}
        .descriptions=${descriptions}
      ></wui-transaction-list-item>
    `;
    }
    templateTransactions(transactions, isLastGroup) {
        return transactions.map((transaction, index)=>{
            const isLastTransaction = isLastGroup && index === transactions.length - 1;
            return (0, $6HMh7.html)`${this.templateRenderTransaction(transaction, isLastTransaction)}`;
        });
    }
    templateEmpty() {
        return (0, $6HMh7.html)`
      <wui-flex
        flexGrow="1"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        .padding=${[
            "3xl",
            "xl",
            "3xl",
            "xl"
        ]}
        gap="xl"
      >
        <wui-icon-box
          backgroundColor="glass-005"
          background="gray"
          iconColor="fg-200"
          icon="wallet"
          size="lg"
          ?border=${true}
          borderColor="wui-color-bg-125"
        ></wui-icon-box>
        <wui-flex flexDirection="column" alignItems="center" gap="xs">
          <wui-text align="center" variant="paragraph-500" color="fg-100"
            >No Transactions yet</wui-text
          >
          <wui-text align="center" variant="small-500" color="fg-200"
            >Start trading on dApps <br />
            to grow your wallet!</wui-text
          >
        </wui-flex>
      </wui-flex>
    `;
    }
    templateLoading() {
        return Array($1dda25eee947f849$var$LOADING_ITEM_COUNT).fill((0, $6HMh7.html)` <wui-transaction-list-item-loader></wui-transaction-list-item-loader> `).map((item)=>item);
    }
    createPaginationObserver() {
        const { projectId: projectId } = (0, $8KEpV.OptionsController).state;
        this.paginationObserver = new IntersectionObserver(([element])=>{
            if (element?.isIntersecting && !this.loading) {
                (0, $6oINN.TransactionsController).fetchTransactions(this.address);
                (0, $6n0eX.EventsController).sendEvent({
                    type: "track",
                    event: "LOAD_MORE_TRANSACTIONS",
                    properties: {
                        address: this.address,
                        projectId: projectId,
                        cursor: this.next
                    }
                });
            }
        }, {});
        this.setPaginationObserver();
    }
    setPaginationObserver() {
        this.paginationObserver?.disconnect();
        const lastItem = this.shadowRoot?.querySelector(`#${$1dda25eee947f849$var$PAGINATOR_ID}`);
        if (lastItem) this.paginationObserver?.observe(lastItem);
    }
    getTransactionListItemProps(transaction) {
        const date = (0, $c9aBm.DateUtil).formatDate(transaction?.metadata?.minedAt);
        const descriptions = (0, $gC2QS.TransactionUtil).getTransactionDescriptions(transaction);
        const transfers = transaction?.transfers;
        const transfer = transaction?.transfers?.[0];
        const isAllNFT = Boolean(transfer) && transaction?.transfers?.every((item)=>Boolean(item.nft_info));
        const images = (0, $gC2QS.TransactionUtil).getTransactionImages(transfers);
        return {
            date: date,
            direction: transfer?.direction,
            descriptions: descriptions,
            isAllNFT: isAllNFT,
            images: images,
            status: transaction.metadata?.status,
            transfers: transfers,
            type: transaction.metadata?.operationType
        };
    }
};
$1dda25eee947f849$export$5b9982998ebc2231.styles = (0, $44d6f59f4777fbe1$export$2e2bcd8739ae039);
$1dda25eee947f849$var$__decorate([
    (0, $6eT5F.state)()
], $1dda25eee947f849$export$5b9982998ebc2231.prototype, "address", void 0);
$1dda25eee947f849$var$__decorate([
    (0, $6eT5F.state)()
], $1dda25eee947f849$export$5b9982998ebc2231.prototype, "transactionsByYear", void 0);
$1dda25eee947f849$var$__decorate([
    (0, $6eT5F.state)()
], $1dda25eee947f849$export$5b9982998ebc2231.prototype, "loading", void 0);
$1dda25eee947f849$var$__decorate([
    (0, $6eT5F.state)()
], $1dda25eee947f849$export$5b9982998ebc2231.prototype, "empty", void 0);
$1dda25eee947f849$var$__decorate([
    (0, $6eT5F.state)()
], $1dda25eee947f849$export$5b9982998ebc2231.prototype, "next", void 0);
$1dda25eee947f849$export$5b9982998ebc2231 = $1dda25eee947f849$var$__decorate([
    (0, $lkv4o.customElement)("w3m-transactions-view")
], $1dda25eee947f849$export$5b9982998ebc2231);


parcelRequire("aAJP9");
var $kGR8V = parcelRequire("kGR8V");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
var $628e16ea1f5463a6$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $628e16ea1f5463a6$var$data = [
    {
        images: [
            "network",
            "layers",
            "system"
        ],
        title: "The system\u2019s nuts and bolts",
        text: "A network is what brings the blockchain to life, as this technical infrastructure allows apps to access the ledger and smart contract services."
    },
    {
        images: [
            "noun",
            "defiAlt",
            "dao"
        ],
        title: "Designed for different uses",
        text: "Each network is designed differently, and may therefore suit certain apps and experiences."
    }
];
let $628e16ea1f5463a6$export$e747cd062ecb4580 = class W3mWhatIsANetworkView extends (0, $b47AP.LitElement) {
    render() {
        return (0, $6HMh7.html)`
      <wui-flex
        flexDirection="column"
        .padding=${[
            "xxl",
            "xl",
            "xl",
            "xl"
        ]}
        alignItems="center"
        gap="xl"
      >
        <w3m-help-widget .data=${$628e16ea1f5463a6$var$data}></w3m-help-widget>
        <wui-button
          variant="fill"
          size="sm"
          @click=${()=>{
            (0, $kGR8V.CoreHelperUtil).openHref("https://ethereum.org/en/developers/docs/networks/", "_blank");
        }}
        >
          Learn more
          <wui-icon color="inherit" slot="iconRight" name="externalLink"></wui-icon>
        </wui-button>
      </wui-flex>
    `;
    }
};
$628e16ea1f5463a6$export$e747cd062ecb4580 = $628e16ea1f5463a6$var$__decorate([
    (0, $lkv4o.customElement)("w3m-what-is-a-network-view")
], $628e16ea1f5463a6$export$e747cd062ecb4580);


parcelRequire("aAJP9");
var $6n0eX = parcelRequire("6n0eX");
var $dJjpc = parcelRequire("dJjpc");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
var $8185053f261ddfa7$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $8185053f261ddfa7$var$data = [
    {
        images: [
            "login",
            "profile",
            "lock"
        ],
        title: "One login for all of web3",
        text: "Log in to any app by connecting your wallet. Say goodbye to countless passwords!"
    },
    {
        images: [
            "defi",
            "nft",
            "eth"
        ],
        title: "A home for your digital assets",
        text: "A wallet lets you store, send and receive digital assets like cryptocurrencies and NFTs."
    },
    {
        images: [
            "browser",
            "noun",
            "dao"
        ],
        title: "Your gateway to a new web",
        text: "With your wallet, you can explore and interact with DeFi, NFTs, DAOs, and much more."
    }
];
let $8185053f261ddfa7$export$16ac3b6705a4e652 = class W3mWhatIsAWalletView extends (0, $b47AP.LitElement) {
    render() {
        return (0, $6HMh7.html)`
      <wui-flex
        flexDirection="column"
        .padding=${[
            "xxl",
            "xl",
            "xl",
            "xl"
        ]}
        alignItems="center"
        gap="xl"
      >
        <w3m-help-widget .data=${$8185053f261ddfa7$var$data}></w3m-help-widget>
        <wui-button variant="fill" size="sm" @click=${this.onGetWallet.bind(this)}>
          <wui-icon color="inherit" slot="iconLeft" name="wallet"></wui-icon>
          Get a wallet
        </wui-button>
      </wui-flex>
    `;
    }
    onGetWallet() {
        (0, $6n0eX.EventsController).sendEvent({
            type: "track",
            event: "CLICK_GET_WALLET"
        });
        (0, $dJjpc.RouterController).push("GetWallet");
    }
};
$8185053f261ddfa7$export$16ac3b6705a4e652 = $8185053f261ddfa7$var$__decorate([
    (0, $lkv4o.customElement)("w3m-what-is-a-wallet-view")
], $8185053f261ddfa7$export$16ac3b6705a4e652);


parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("aAJP9");
var $dJjpc = parcelRequire("dJjpc");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
var $1d5a3effa64a713d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $1d5a3effa64a713d$export$c63d73b9361e157e = class W3mWhatIsABuyView extends (0, $b47AP.LitElement) {
    render() {
        return (0, $6HMh7.html)`
      <wui-flex
        flexDirection="column"
        .padding=${[
            "xxl",
            "3xl",
            "xl",
            "3xl"
        ]}
        alignItems="center"
        gap="xl"
      >
        <wui-visual name="onrampCard"></wui-visual>
        <wui-flex flexDirection="column" gap="xs" alignItems="center">
          <wui-text align="center" variant="paragraph-500" color="fg-100">
            Quickly and easily buy digital assets!
          </wui-text>
          <wui-text align="center" variant="small-400" color="fg-200">
            Simply select your preferred onramp provider and add digital assets to your account
            using your credit card or bank transfer
          </wui-text>
        </wui-flex>
        <wui-button @click=${(0, $dJjpc.RouterController).goBack}>
          <wui-icon size="sm" color="inherit" name="add" slot="iconLeft"></wui-icon>
          Buy
        </wui-button>
      </wui-flex>
    `;
    }
};
$1d5a3effa64a713d$export$c63d73b9361e157e = $1d5a3effa64a713d$var$__decorate([
    (0, $lkv4o.customElement)("w3m-what-is-a-buy-view")
], $1d5a3effa64a713d$export$c63d73b9361e157e);


parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("aAJP9");
var $9QkaU = parcelRequire("9QkaU");
var $kGR8V = parcelRequire("kGR8V");
var $dJjpc = parcelRequire("dJjpc");
var $9fh1I = parcelRequire("9fh1I");
parcelRequire("hrpLR");
var $6eT5F = parcelRequire("6eT5F");
parcelRequire("5bcND");
var $kq2WI = parcelRequire("kq2WI");
var $396add6f7055054b$export$2e2bcd8739ae039 = (0, $kq2WI.css)`
  wui-loading-spinner {
    margin: 9px auto;
  }
`;


const $7e71742c1a96e4ab$export$3ff97a7390ed49be = {
    SECURE_SITE_SDK: "https://secure.walletconnect.com/sdk",
    APP_EVENT_KEY: "@w3m-app/",
    FRAME_EVENT_KEY: "@w3m-frame/",
    RPC_METHOD_KEY: "RPC_",
    STORAGE_KEY: "@w3m-storage/",
    SESSION_TOKEN_KEY: "SESSION_TOKEN_KEY",
    EMAIL_LOGIN_USED_KEY: "EMAIL_LOGIN_USED_KEY",
    LAST_USED_CHAIN_KEY: "LAST_USED_CHAIN_KEY",
    LAST_EMAIL_LOGIN_TIME: "LAST_EMAIL_LOGIN_TIME",
    EMAIL: "EMAIL",
    APP_SWITCH_NETWORK: "@w3m-app/SWITCH_NETWORK",
    APP_CONNECT_EMAIL: "@w3m-app/CONNECT_EMAIL",
    APP_CONNECT_DEVICE: "@w3m-app/CONNECT_DEVICE",
    APP_CONNECT_OTP: "@w3m-app/CONNECT_OTP",
    APP_GET_USER: "@w3m-app/GET_USER",
    APP_SIGN_OUT: "@w3m-app/SIGN_OUT",
    APP_IS_CONNECTED: "@w3m-app/IS_CONNECTED",
    APP_GET_CHAIN_ID: "@w3m-app/GET_CHAIN_ID",
    APP_RPC_REQUEST: "@w3m-app/RPC_REQUEST",
    APP_UPDATE_EMAIL: "@w3m-app/UPDATE_EMAIL",
    APP_UPDATE_EMAIL_PRIMARY_OTP: "@w3m-app/UPDATE_EMAIL_PRIMARY_OTP",
    APP_UPDATE_EMAIL_SECONDARY_OTP: "@w3m-app/UPDATE_EMAIL_SECONDARY_OTP",
    APP_AWAIT_UPDATE_EMAIL: "@w3m-app/AWAIT_UPDATE_EMAIL",
    APP_SYNC_THEME: "@w3m-app/SYNC_THEME",
    APP_SYNC_DAPP_DATA: "@w3m-app/SYNC_DAPP_DATA",
    FRAME_SWITCH_NETWORK_ERROR: "@w3m-frame/SWITCH_NETWORK_ERROR",
    FRAME_SWITCH_NETWORK_SUCCESS: "@w3m-frame/SWITCH_NETWORK_SUCCESS",
    FRAME_CONNECT_EMAIL_ERROR: "@w3m-frame/CONNECT_EMAIL_ERROR",
    FRAME_CONNECT_EMAIL_SUCCESS: "@w3m-frame/CONNECT_EMAIL_SUCCESS",
    FRAME_CONNECT_DEVICE_ERROR: "@w3m-frame/CONNECT_DEVICE_ERROR",
    FRAME_CONNECT_DEVICE_SUCCESS: "@w3m-frame/CONNECT_DEVICE_SUCCESS",
    FRAME_CONNECT_OTP_SUCCESS: "@w3m-frame/CONNECT_OTP_SUCCESS",
    FRAME_CONNECT_OTP_ERROR: "@w3m-frame/CONNECT_OTP_ERROR",
    FRAME_GET_USER_SUCCESS: "@w3m-frame/GET_USER_SUCCESS",
    FRAME_GET_USER_ERROR: "@w3m-frame/GET_USER_ERROR",
    FRAME_SIGN_OUT_SUCCESS: "@w3m-frame/SIGN_OUT_SUCCESS",
    FRAME_SIGN_OUT_ERROR: "@w3m-frame/SIGN_OUT_ERROR",
    FRAME_IS_CONNECTED_SUCCESS: "@w3m-frame/IS_CONNECTED_SUCCESS",
    FRAME_IS_CONNECTED_ERROR: "@w3m-frame/IS_CONNECTED_ERROR",
    FRAME_GET_CHAIN_ID_SUCCESS: "@w3m-frame/GET_CHAIN_ID_SUCCESS",
    FRAME_GET_CHAIN_ID_ERROR: "@w3m-frame/GET_CHAIN_ID_ERROR",
    FRAME_RPC_REQUEST_SUCCESS: "@w3m-frame/RPC_REQUEST_SUCCESS",
    FRAME_RPC_REQUEST_ERROR: "@w3m-frame/RPC_REQUEST_ERROR",
    FRAME_SESSION_UPDATE: "@w3m-frame/SESSION_UPDATE",
    FRAME_UPDATE_EMAIL_SUCCESS: "@w3m-frame/UPDATE_EMAIL_SUCCESS",
    FRAME_UPDATE_EMAIL_ERROR: "@w3m-frame/UPDATE_EMAIL_ERROR",
    FRAME_UPDATE_EMAIL_PRIMARY_OTP_SUCCESS: "@w3m-frame/UPDATE_EMAIL_PRIMARY_OTP_SUCCESS",
    FRAME_UPDATE_EMAIL_PRIMARY_OTP_ERROR: "@w3m-frame/UPDATE_EMAIL_PRIMARY_OTP_ERROR",
    FRAME_UPDATE_EMAIL_SECONDARY_OTP_SUCCESS: "@w3m-frame/UPDATE_EMAIL_SECONDARY_OTP_SUCCESS",
    FRAME_UPDATE_EMAIL_SECONDARY_OTP_ERROR: "@w3m-frame/UPDATE_EMAIL_SECONDARY_OTP_ERROR",
    FRAME_SYNC_THEME_SUCCESS: "@w3m-frame/SYNC_THEME_SUCCESS",
    FRAME_SYNC_THEME_ERROR: "@w3m-frame/SYNC_THEME_ERROR",
    FRAME_SYNC_DAPP_DATA_SUCCESS: "@w3m-frame/SYNC_DAPP_DATA_SUCCESS",
    FRAME_SYNC_DAPP_DATA_ERROR: "@w3m-frame/SYNC_DAPP_DATA_ERROR"
};
const $7e71742c1a96e4ab$export$9975694bfb286db = {
    SAFE_RPC_METHODS: [
        "eth_accounts",
        "eth_blockNumber",
        "eth_call",
        "eth_chainId",
        "eth_estimateGas",
        "eth_feeHistory",
        "eth_gasPrice",
        "eth_getAccount",
        "eth_getBalance",
        "eth_getBlockByHash",
        "eth_getBlockByNumber",
        "eth_getBlockReceipts",
        "eth_getBlockTransactionCountByHash",
        "eth_getBlockTransactionCountByNumber",
        "eth_getCode",
        "eth_getFilterChanges",
        "eth_getFilterLogs",
        "eth_getLogs",
        "eth_getProof",
        "eth_getStorageAt",
        "eth_getTransactionByBlockHashAndIndex",
        "eth_getTransactionByBlockNumberAndIndex",
        "eth_getTransactionByHash",
        "eth_getTransactionCount",
        "eth_getTransactionReceipt",
        "eth_getUncleCountByBlockHash",
        "eth_getUncleCountByBlockNumber",
        "eth_maxPriorityFeePerGas",
        "eth_newBlockFilter",
        "eth_newFilter",
        "eth_newPendingTransactionFilter",
        "eth_sendRawTransaction",
        "eth_syncing",
        "eth_uninstallFilter"
    ],
    NOT_SAFE_RPC_METHODS: [
        "personal_sign",
        "eth_signTypedData_v4",
        "eth_sendTransaction"
    ],
    GET_CHAIN_ID: "eth_chainId",
    RPC_METHOD_NOT_ALLOWED_MESSAGE: "Requested RPC call is not allowed",
    RPC_METHOD_NOT_ALLOWED_UI_MESSAGE: "Action not allowed"
};


var $bd87f15790d7a3e7$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($bd87f15790d7a3e7$export$7debb50ef11d5e0b || ($bd87f15790d7a3e7$export$7debb50ef11d5e0b = {}));
var $bd87f15790d7a3e7$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($bd87f15790d7a3e7$export$4aa2142c225fd5c7 || ($bd87f15790d7a3e7$export$4aa2142c225fd5c7 = {}));
const $bd87f15790d7a3e7$export$5716da67bfaa244d = $bd87f15790d7a3e7$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $bd87f15790d7a3e7$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $bd87f15790d7a3e7$export$5716da67bfaa244d.undefined;
        case "string":
            return $bd87f15790d7a3e7$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $bd87f15790d7a3e7$export$5716da67bfaa244d.nan : $bd87f15790d7a3e7$export$5716da67bfaa244d.number;
        case "boolean":
            return $bd87f15790d7a3e7$export$5716da67bfaa244d.boolean;
        case "function":
            return $bd87f15790d7a3e7$export$5716da67bfaa244d.function;
        case "bigint":
            return $bd87f15790d7a3e7$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $bd87f15790d7a3e7$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $bd87f15790d7a3e7$export$5716da67bfaa244d.array;
            if (data === null) return $bd87f15790d7a3e7$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $bd87f15790d7a3e7$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $bd87f15790d7a3e7$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $bd87f15790d7a3e7$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $bd87f15790d7a3e7$export$5716da67bfaa244d.date;
            return $bd87f15790d7a3e7$export$5716da67bfaa244d.object;
        default:
            return $bd87f15790d7a3e7$export$5716da67bfaa244d.unknown;
    }
};
const $bd87f15790d7a3e7$export$5ba560653e4a1035 = $bd87f15790d7a3e7$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $bd87f15790d7a3e7$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $bd87f15790d7a3e7$export$f98dac4b251ab333 extends Error {
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $bd87f15790d7a3e7$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$bd87f15790d7a3e7$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $bd87f15790d7a3e7$export$f98dac4b251ab333(issues);
    return error;
};
const $bd87f15790d7a3e7$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $bd87f15790d7a3e7$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $bd87f15790d7a3e7$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $bd87f15790d7a3e7$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$bd87f15790d7a3e7$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$bd87f15790d7a3e7$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$bd87f15790d7a3e7$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $bd87f15790d7a3e7$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $bd87f15790d7a3e7$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $bd87f15790d7a3e7$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $bd87f15790d7a3e7$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $bd87f15790d7a3e7$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $bd87f15790d7a3e7$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $bd87f15790d7a3e7$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $bd87f15790d7a3e7$var$overrideErrorMap = $bd87f15790d7a3e7$export$341b0b6e0a6f5099;
function $bd87f15790d7a3e7$export$1097a8289cfd22d7(map) {
    $bd87f15790d7a3e7$var$overrideErrorMap = map;
}
function $bd87f15790d7a3e7$export$32f27c719778d4c4() {
    return $bd87f15790d7a3e7$var$overrideErrorMap;
}
const $bd87f15790d7a3e7$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: issueData.message || errorMessage
    };
};
const $bd87f15790d7a3e7$export$1526d2e05f74572 = [];
function $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, issueData) {
    const issue = $bd87f15790d7a3e7$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            $bd87f15790d7a3e7$export$32f27c719778d4c4(),
            $bd87f15790d7a3e7$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $bd87f15790d7a3e7$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs)syncPairs.push({
            key: await pair.key,
            value: await pair.value
        });
        return $bd87f15790d7a3e7$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $bd87f15790d7a3e7$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $bd87f15790d7a3e7$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $bd87f15790d7a3e7$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $bd87f15790d7a3e7$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $bd87f15790d7a3e7$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $bd87f15790d7a3e7$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $bd87f15790d7a3e7$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
var $bd87f15790d7a3e7$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($bd87f15790d7a3e7$var$errorUtil || ($bd87f15790d7a3e7$var$errorUtil = {}));
class $bd87f15790d7a3e7$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $bd87f15790d7a3e7$var$handleResult = (ctx, result)=>{
    if ($bd87f15790d7a3e7$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $bd87f15790d7a3e7$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $bd87f15790d7a3e7$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError
        };
        return {
            message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $bd87f15790d7a3e7$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $bd87f15790d7a3e7$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $bd87f15790d7a3e7$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $bd87f15790d7a3e7$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($bd87f15790d7a3e7$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $bd87f15790d7a3e7$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $bd87f15790d7a3e7$var$handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $bd87f15790d7a3e7$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($bd87f15790d7a3e7$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $bd87f15790d7a3e7$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $bd87f15790d7a3e7$export$5ba560653e4a1035.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $bd87f15790d7a3e7$export$a60af00cc0ce2582({
            schema: this,
            typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $bd87f15790d7a3e7$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $bd87f15790d7a3e7$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $bd87f15790d7a3e7$export$7acfc3e64785411.create(this, this._def);
    }
    promise() {
        return $bd87f15790d7a3e7$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $bd87f15790d7a3e7$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $bd87f15790d7a3e7$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $bd87f15790d7a3e7$export$a60af00cc0ce2582({
            ...$bd87f15790d7a3e7$var$processCreateParams(this._def),
            schema: this,
            typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $bd87f15790d7a3e7$export$bb19b37874861e7e({
            ...$bd87f15790d7a3e7$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $bd87f15790d7a3e7$export$66b0c798a395271f({
            typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$bd87f15790d7a3e7$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $bd87f15790d7a3e7$export$75a44ec6249ac76b({
            ...$bd87f15790d7a3e7$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $bd87f15790d7a3e7$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $bd87f15790d7a3e7$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $bd87f15790d7a3e7$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $bd87f15790d7a3e7$var$cuid2Regex = /^[a-z][a-z0-9]*$/;
const $bd87f15790d7a3e7$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $bd87f15790d7a3e7$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $bd87f15790d7a3e7$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $bd87f15790d7a3e7$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $bd87f15790d7a3e7$var$emojiRegex;
const $bd87f15790d7a3e7$var$ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
const $bd87f15790d7a3e7$var$ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// Adapted from https://stackoverflow.com/a/3143231
const $bd87f15790d7a3e7$var$datetimeRegex = (args)=>{
    if (args.precision) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}Z$`);
    } else if (args.precision === 0) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$`);
    } else {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$`);
    }
};
function $bd87f15790d7a3e7$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $bd87f15790d7a3e7$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $bd87f15790d7a3e7$var$ipv6Regex.test(ip)) return true;
    return false;
}
class $bd87f15790d7a3e7$export$1230eb29b8d3b502 extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $bd87f15790d7a3e7$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_type,
                expected: $bd87f15790d7a3e7$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
        }
        const status = new $bd87f15790d7a3e7$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                        code: $bd87f15790d7a3e7$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                        code: $bd87f15790d7a3e7$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                        code: $bd87f15790d7a3e7$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                        code: $bd87f15790d7a3e7$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$bd87f15790d7a3e7$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$bd87f15790d7a3e7$var$emojiRegex) $bd87f15790d7a3e7$var$emojiRegex = new RegExp($bd87f15790d7a3e7$var$_emojiRegex, "u");
                if (!$bd87f15790d7a3e7$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$bd87f15790d7a3e7$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$bd87f15790d7a3e7$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$bd87f15790d7a3e7$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$bd87f15790d7a3e7$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                        code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                        code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                        code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $bd87f15790d7a3e7$var$datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                        code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$bd87f15790d7a3e7$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $bd87f15790d7a3e7$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_string,
            ...$bd87f15790d7a3e7$var$errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new $bd87f15790d7a3e7$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$bd87f15790d7a3e7$var$errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$bd87f15790d7a3e7$var$errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$bd87f15790d7a3e7$var$errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$bd87f15790d7a3e7$var$errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$bd87f15790d7a3e7$var$errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$bd87f15790d7a3e7$var$errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$bd87f15790d7a3e7$var$errorUtil.errToObj(message)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$bd87f15790d7a3e7$var$errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            ...$bd87f15790d7a3e7$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$bd87f15790d7a3e7$var$errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$bd87f15790d7a3e7$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$bd87f15790d7a3e7$var$errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$bd87f15790d7a3e7$var$errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$bd87f15790d7a3e7$var$errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$bd87f15790d7a3e7$var$errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$bd87f15790d7a3e7$var$errorUtil.errToObj(message)
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */ nonempty(message) {
        return this.min(1, $bd87f15790d7a3e7$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $bd87f15790d7a3e7$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $bd87f15790d7a3e7$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $bd87f15790d7a3e7$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$bd87f15790d7a3e7$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $bd87f15790d7a3e7$export$1230eb29b8d3b502({
        checks: [],
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $bd87f15790d7a3e7$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $bd87f15790d7a3e7$export$5b070a55c0c43e09 extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $bd87f15790d7a3e7$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_type,
                expected: $bd87f15790d7a3e7$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $bd87f15790d7a3e7$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$bd87f15790d7a3e7$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                        code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                        code: $bd87f15790d7a3e7$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                        code: $bd87f15790d7a3e7$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($bd87f15790d7a3e7$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                        code: $bd87f15790d7a3e7$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                        code: $bd87f15790d7a3e7$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $bd87f15790d7a3e7$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $bd87f15790d7a3e7$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $bd87f15790d7a3e7$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $bd87f15790d7a3e7$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $bd87f15790d7a3e7$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $bd87f15790d7a3e7$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $bd87f15790d7a3e7$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $bd87f15790d7a3e7$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $bd87f15790d7a3e7$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $bd87f15790d7a3e7$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $bd87f15790d7a3e7$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $bd87f15790d7a3e7$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $bd87f15790d7a3e7$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $bd87f15790d7a3e7$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $bd87f15790d7a3e7$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $bd87f15790d7a3e7$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $bd87f15790d7a3e7$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $bd87f15790d7a3e7$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$bd87f15790d7a3e7$export$5b070a55c0c43e09.create = (params)=>{
    return new $bd87f15790d7a3e7$export$5b070a55c0c43e09({
        checks: [],
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
};
class $bd87f15790d7a3e7$export$67d741fd70ff98f4 extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) input.data = BigInt(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $bd87f15790d7a3e7$export$5716da67bfaa244d.bigint) {
            const ctx = this._getOrReturnCtx(input);
            $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_type,
                expected: $bd87f15790d7a3e7$export$5716da67bfaa244d.bigint,
                received: ctx.parsedType
            });
            return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $bd87f15790d7a3e7$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                        code: $bd87f15790d7a3e7$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                        code: $bd87f15790d7a3e7$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                        code: $bd87f15790d7a3e7$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $bd87f15790d7a3e7$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $bd87f15790d7a3e7$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $bd87f15790d7a3e7$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $bd87f15790d7a3e7$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $bd87f15790d7a3e7$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $bd87f15790d7a3e7$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $bd87f15790d7a3e7$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $bd87f15790d7a3e7$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $bd87f15790d7a3e7$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $bd87f15790d7a3e7$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $bd87f15790d7a3e7$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $bd87f15790d7a3e7$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $bd87f15790d7a3e7$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$bd87f15790d7a3e7$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $bd87f15790d7a3e7$export$67d741fd70ff98f4({
        checks: [],
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
};
class $bd87f15790d7a3e7$export$723d146f80596191 extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $bd87f15790d7a3e7$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_type,
                expected: $bd87f15790d7a3e7$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
        }
        return $bd87f15790d7a3e7$export$c6813a8d51f77eaf(input.data);
    }
}
$bd87f15790d7a3e7$export$723d146f80596191.create = (params)=>{
    return new $bd87f15790d7a3e7$export$723d146f80596191({
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
};
class $bd87f15790d7a3e7$export$e974be33bdc55521 extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $bd87f15790d7a3e7$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_type,
                expected: $bd87f15790d7a3e7$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_date
            });
            return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
        }
        const status = new $bd87f15790d7a3e7$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                        code: $bd87f15790d7a3e7$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                        code: $bd87f15790d7a3e7$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $bd87f15790d7a3e7$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $bd87f15790d7a3e7$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $bd87f15790d7a3e7$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $bd87f15790d7a3e7$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$bd87f15790d7a3e7$export$e974be33bdc55521.create = (params)=>{
    return new $bd87f15790d7a3e7$export$e974be33bdc55521({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodDate,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
};
class $bd87f15790d7a3e7$export$bcc3b40f6b638044 extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $bd87f15790d7a3e7$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_type,
                expected: $bd87f15790d7a3e7$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
        }
        return $bd87f15790d7a3e7$export$c6813a8d51f77eaf(input.data);
    }
}
$bd87f15790d7a3e7$export$bcc3b40f6b638044.create = (params)=>{
    return new $bd87f15790d7a3e7$export$bcc3b40f6b638044({
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodSymbol,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
};
class $bd87f15790d7a3e7$export$4e780e961c30340d extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $bd87f15790d7a3e7$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_type,
                expected: $bd87f15790d7a3e7$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
        }
        return $bd87f15790d7a3e7$export$c6813a8d51f77eaf(input.data);
    }
}
$bd87f15790d7a3e7$export$4e780e961c30340d.create = (params)=>{
    return new $bd87f15790d7a3e7$export$4e780e961c30340d({
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodUndefined,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
};
class $bd87f15790d7a3e7$export$a96281f914484f2d extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $bd87f15790d7a3e7$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_type,
                expected: $bd87f15790d7a3e7$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
        }
        return $bd87f15790d7a3e7$export$c6813a8d51f77eaf(input.data);
    }
}
$bd87f15790d7a3e7$export$a96281f914484f2d.create = (params)=>{
    return new $bd87f15790d7a3e7$export$a96281f914484f2d({
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodNull,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
};
class $bd87f15790d7a3e7$export$b9d1edb536b4e4eb extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return $bd87f15790d7a3e7$export$c6813a8d51f77eaf(input.data);
    }
}
$bd87f15790d7a3e7$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $bd87f15790d7a3e7$export$b9d1edb536b4e4eb({
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodAny,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
};
class $bd87f15790d7a3e7$export$ef3b1bb1630977ae extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return $bd87f15790d7a3e7$export$c6813a8d51f77eaf(input.data);
    }
}
$bd87f15790d7a3e7$export$ef3b1bb1630977ae.create = (params)=>{
    return new $bd87f15790d7a3e7$export$ef3b1bb1630977ae({
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodUnknown,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
};
class $bd87f15790d7a3e7$export$1e576a20c3ce9fb5 extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
            code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_type,
            expected: $bd87f15790d7a3e7$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
    }
}
$bd87f15790d7a3e7$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $bd87f15790d7a3e7$export$1e576a20c3ce9fb5({
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodNever,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
};
class $bd87f15790d7a3e7$export$7d39f5df85f21031 extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $bd87f15790d7a3e7$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_type,
                expected: $bd87f15790d7a3e7$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
        }
        return $bd87f15790d7a3e7$export$c6813a8d51f77eaf(input.data);
    }
}
$bd87f15790d7a3e7$export$7d39f5df85f21031.create = (params)=>{
    return new $bd87f15790d7a3e7$export$7d39f5df85f21031({
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodVoid,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
};
class $bd87f15790d7a3e7$export$7acfc3e64785411 extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $bd87f15790d7a3e7$export$5716da67bfaa244d.array) {
            $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_type,
                expected: $bd87f15790d7a3e7$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $bd87f15790d7a3e7$export$5ba560653e4a1035.too_big : $bd87f15790d7a3e7$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                    code: $bd87f15790d7a3e7$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                    code: $bd87f15790d7a3e7$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $bd87f15790d7a3e7$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $bd87f15790d7a3e7$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $bd87f15790d7a3e7$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $bd87f15790d7a3e7$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $bd87f15790d7a3e7$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: $bd87f15790d7a3e7$var$errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $bd87f15790d7a3e7$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $bd87f15790d7a3e7$var$errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $bd87f15790d7a3e7$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: $bd87f15790d7a3e7$var$errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$bd87f15790d7a3e7$export$7acfc3e64785411.create = (schema, params)=>{
    return new $bd87f15790d7a3e7$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodArray,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
};
function $bd87f15790d7a3e7$var$deepPartialify(schema) {
    if (schema instanceof $bd87f15790d7a3e7$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $bd87f15790d7a3e7$export$aa56fec1e9d629b8.create($bd87f15790d7a3e7$var$deepPartialify(fieldSchema));
        }
        return new $bd87f15790d7a3e7$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $bd87f15790d7a3e7$export$7acfc3e64785411) return new $bd87f15790d7a3e7$export$7acfc3e64785411({
        ...schema._def,
        type: $bd87f15790d7a3e7$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $bd87f15790d7a3e7$export$aa56fec1e9d629b8) return $bd87f15790d7a3e7$export$aa56fec1e9d629b8.create($bd87f15790d7a3e7$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $bd87f15790d7a3e7$export$aaac0b8b429cef5) return $bd87f15790d7a3e7$export$aaac0b8b429cef5.create($bd87f15790d7a3e7$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $bd87f15790d7a3e7$export$e2a18bb771d8e6a3) return $bd87f15790d7a3e7$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$bd87f15790d7a3e7$var$deepPartialify(item)));
    else return schema;
}
class $bd87f15790d7a3e7$export$736315c5b55efbad extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $bd87f15790d7a3e7$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $bd87f15790d7a3e7$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_type,
                expected: $bd87f15790d7a3e7$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $bd87f15790d7a3e7$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $bd87f15790d7a3e7$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $bd87f15790d7a3e7$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                        code: $bd87f15790d7a3e7$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $bd87f15790d7a3e7$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                syncPairs.push({
                    key: key,
                    value: await pair.value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $bd87f15790d7a3e7$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $bd87f15790d7a3e7$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $bd87f15790d7a3e7$var$errorUtil.errToObj;
        return new $bd87f15790d7a3e7$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $bd87f15790d7a3e7$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $bd87f15790d7a3e7$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $bd87f15790d7a3e7$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $bd87f15790d7a3e7$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $bd87f15790d7a3e7$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $bd87f15790d7a3e7$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $bd87f15790d7a3e7$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $bd87f15790d7a3e7$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $bd87f15790d7a3e7$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $bd87f15790d7a3e7$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $bd87f15790d7a3e7$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $bd87f15790d7a3e7$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $bd87f15790d7a3e7$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $bd87f15790d7a3e7$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $bd87f15790d7a3e7$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $bd87f15790d7a3e7$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $bd87f15790d7a3e7$var$createZodEnum($bd87f15790d7a3e7$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
}
$bd87f15790d7a3e7$export$736315c5b55efbad.create = (shape, params)=>{
    return new $bd87f15790d7a3e7$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $bd87f15790d7a3e7$export$1e576a20c3ce9fb5.create(),
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodObject,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
};
$bd87f15790d7a3e7$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $bd87f15790d7a3e7$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $bd87f15790d7a3e7$export$1e576a20c3ce9fb5.create(),
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodObject,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
};
$bd87f15790d7a3e7$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $bd87f15790d7a3e7$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $bd87f15790d7a3e7$export$1e576a20c3ce9fb5.create(),
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodObject,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
};
class $bd87f15790d7a3e7$export$a8b236cb5070a311 extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $bd87f15790d7a3e7$export$f98dac4b251ab333(result.ctx.common.issues));
            $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $bd87f15790d7a3e7$export$f98dac4b251ab333(issues));
            $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$bd87f15790d7a3e7$export$a8b236cb5070a311.create = (types, params)=>{
    return new $bd87f15790d7a3e7$export$a8b236cb5070a311({
        options: types,
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodUnion,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $bd87f15790d7a3e7$var$getDiscriminator = (type)=>{
    if (type instanceof $bd87f15790d7a3e7$export$378d0cfce37406e6) return $bd87f15790d7a3e7$var$getDiscriminator(type.schema);
    else if (type instanceof $bd87f15790d7a3e7$export$a60af00cc0ce2582) return $bd87f15790d7a3e7$var$getDiscriminator(type.innerType());
    else if (type instanceof $bd87f15790d7a3e7$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $bd87f15790d7a3e7$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $bd87f15790d7a3e7$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return Object.keys(type.enum);
    else if (type instanceof $bd87f15790d7a3e7$export$bb19b37874861e7e) return $bd87f15790d7a3e7$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $bd87f15790d7a3e7$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $bd87f15790d7a3e7$export$a96281f914484f2d) return [
        null
    ];
    else return null;
};
class $bd87f15790d7a3e7$export$5ef2424805ac76a3 extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $bd87f15790d7a3e7$export$5716da67bfaa244d.object) {
            $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_type,
                expected: $bd87f15790d7a3e7$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $bd87f15790d7a3e7$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $bd87f15790d7a3e7$export$5ef2424805ac76a3({
            typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$bd87f15790d7a3e7$var$processCreateParams(params)
        });
    }
}
function $bd87f15790d7a3e7$var$mergeValues(a, b) {
    const aType = $bd87f15790d7a3e7$export$3e9057828ebd5c7a(a);
    const bType = $bd87f15790d7a3e7$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $bd87f15790d7a3e7$export$5716da67bfaa244d.object && bType === $bd87f15790d7a3e7$export$5716da67bfaa244d.object) {
        const bKeys = $bd87f15790d7a3e7$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $bd87f15790d7a3e7$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $bd87f15790d7a3e7$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $bd87f15790d7a3e7$export$5716da67bfaa244d.array && bType === $bd87f15790d7a3e7$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $bd87f15790d7a3e7$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $bd87f15790d7a3e7$export$5716da67bfaa244d.date && bType === $bd87f15790d7a3e7$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $bd87f15790d7a3e7$export$c02deaf0bb5203d4 extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($bd87f15790d7a3e7$export$afa861e3c5730743(parsedLeft) || $bd87f15790d7a3e7$export$afa861e3c5730743(parsedRight)) return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
            const merged = $bd87f15790d7a3e7$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                    code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
            }
            if ($bd87f15790d7a3e7$export$910b6cdd390341b3(parsedLeft) || $bd87f15790d7a3e7$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$bd87f15790d7a3e7$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $bd87f15790d7a3e7$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodIntersection,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
};
class $bd87f15790d7a3e7$export$e2a18bb771d8e6a3 extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $bd87f15790d7a3e7$export$5716da67bfaa244d.array) {
            $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_type,
                expected: $bd87f15790d7a3e7$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                code: $bd87f15790d7a3e7$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                code: $bd87f15790d7a3e7$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $bd87f15790d7a3e7$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $bd87f15790d7a3e7$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $bd87f15790d7a3e7$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $bd87f15790d7a3e7$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$bd87f15790d7a3e7$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $bd87f15790d7a3e7$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
};
class $bd87f15790d7a3e7$export$a2acc09968cb4b7f extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $bd87f15790d7a3e7$export$5716da67bfaa244d.object) {
            $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_type,
                expected: $bd87f15790d7a3e7$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $bd87f15790d7a3e7$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $bd87f15790d7a3e7$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key))
        });
        if (ctx.common.async) return $bd87f15790d7a3e7$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $bd87f15790d7a3e7$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $bd87f15790d7a3e7$export$19342e026b58ebb7) return new $bd87f15790d7a3e7$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodRecord,
            ...$bd87f15790d7a3e7$var$processCreateParams(third)
        });
        return new $bd87f15790d7a3e7$export$a2acc09968cb4b7f({
            keyType: $bd87f15790d7a3e7$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodRecord,
            ...$bd87f15790d7a3e7$var$processCreateParams(second)
        });
    }
}
class $bd87f15790d7a3e7$export$163b6a2b712d9542 extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $bd87f15790d7a3e7$export$5716da67bfaa244d.map) {
            $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_type,
                expected: $bd87f15790d7a3e7$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $bd87f15790d7a3e7$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $bd87f15790d7a3e7$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$bd87f15790d7a3e7$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $bd87f15790d7a3e7$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodMap,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
};
class $bd87f15790d7a3e7$export$977057706f816712 extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $bd87f15790d7a3e7$export$5716da67bfaa244d.set) {
            $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_type,
                expected: $bd87f15790d7a3e7$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                    code: $bd87f15790d7a3e7$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                    code: $bd87f15790d7a3e7$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $bd87f15790d7a3e7$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $bd87f15790d7a3e7$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: $bd87f15790d7a3e7$var$errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $bd87f15790d7a3e7$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $bd87f15790d7a3e7$var$errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$bd87f15790d7a3e7$export$977057706f816712.create = (valueType, params)=>{
    return new $bd87f15790d7a3e7$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodSet,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
};
class $bd87f15790d7a3e7$export$d4602ba55673f53c extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $bd87f15790d7a3e7$export$5716da67bfaa244d.function) {
            $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_type,
                expected: $bd87f15790d7a3e7$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $bd87f15790d7a3e7$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $bd87f15790d7a3e7$export$32f27c719778d4c4(),
                    $bd87f15790d7a3e7$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $bd87f15790d7a3e7$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $bd87f15790d7a3e7$export$32f27c719778d4c4(),
                    $bd87f15790d7a3e7$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $bd87f15790d7a3e7$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $bd87f15790d7a3e7$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $bd87f15790d7a3e7$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $bd87f15790d7a3e7$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $bd87f15790d7a3e7$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $bd87f15790d7a3e7$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $bd87f15790d7a3e7$export$d4602ba55673f53c({
            ...this._def,
            args: $bd87f15790d7a3e7$export$e2a18bb771d8e6a3.create(items).rest($bd87f15790d7a3e7$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $bd87f15790d7a3e7$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $bd87f15790d7a3e7$export$d4602ba55673f53c({
            args: args ? args : $bd87f15790d7a3e7$export$e2a18bb771d8e6a3.create([]).rest($bd87f15790d7a3e7$export$ef3b1bb1630977ae.create()),
            returns: returns || $bd87f15790d7a3e7$export$ef3b1bb1630977ae.create(),
            typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodFunction,
            ...$bd87f15790d7a3e7$var$processCreateParams(params)
        });
    }
}
class $bd87f15790d7a3e7$export$378d0cfce37406e6 extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$bd87f15790d7a3e7$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $bd87f15790d7a3e7$export$378d0cfce37406e6({
        getter: getter,
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodLazy,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
};
class $bd87f15790d7a3e7$export$7e44096782a165d3 extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$bd87f15790d7a3e7$export$7e44096782a165d3.create = (value, params)=>{
    return new $bd87f15790d7a3e7$export$7e44096782a165d3({
        value: value,
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodLiteral,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
};
function $bd87f15790d7a3e7$var$createZodEnum(values, params) {
    return new $bd87f15790d7a3e7$export$d325d1f0e1c20179({
        values: values,
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodEnum,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
}
class $bd87f15790d7a3e7$export$d325d1f0e1c20179 extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                expected: $bd87f15790d7a3e7$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_type
            });
            return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
        }
        if (this._def.values.indexOf(input.data) === -1) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
        }
        return $bd87f15790d7a3e7$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values) {
        return $bd87f15790d7a3e7$export$d325d1f0e1c20179.create(values);
    }
    exclude(values) {
        return $bd87f15790d7a3e7$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)));
    }
}
$bd87f15790d7a3e7$export$d325d1f0e1c20179.create = $bd87f15790d7a3e7$var$createZodEnum;
class $bd87f15790d7a3e7$export$370b2e8d6d6f5c56 extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    _parse(input) {
        const nativeEnumValues = $bd87f15790d7a3e7$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $bd87f15790d7a3e7$export$5716da67bfaa244d.string && ctx.parsedType !== $bd87f15790d7a3e7$export$5716da67bfaa244d.number) {
            const expectedValues = $bd87f15790d7a3e7$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                expected: $bd87f15790d7a3e7$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_type
            });
            return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
        }
        if (nativeEnumValues.indexOf(input.data) === -1) {
            const expectedValues = $bd87f15790d7a3e7$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
        }
        return $bd87f15790d7a3e7$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$bd87f15790d7a3e7$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $bd87f15790d7a3e7$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodNativeEnum,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
};
class $bd87f15790d7a3e7$export$3f196b0127d6e50a extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $bd87f15790d7a3e7$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_type,
                expected: $bd87f15790d7a3e7$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $bd87f15790d7a3e7$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $bd87f15790d7a3e7$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$bd87f15790d7a3e7$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $bd87f15790d7a3e7$export$3f196b0127d6e50a({
        type: schema,
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodPromise,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
};
class $bd87f15790d7a3e7$export$a60af00cc0ce2582 extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $bd87f15790d7a3e7$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.issues.length) return {
                status: "dirty",
                value: ctx.data
            };
            if (ctx.common.async) return Promise.resolve(processed).then((processed)=>{
                return this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
            });
            else return this._def.schema._parseSync({
                data: processed,
                path: ctx.path,
                parent: ctx
            });
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$bd87f15790d7a3e7$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$bd87f15790d7a3e7$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $bd87f15790d7a3e7$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$bd87f15790d7a3e7$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $bd87f15790d7a3e7$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
};
$bd87f15790d7a3e7$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $bd87f15790d7a3e7$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodEffects,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
};
class $bd87f15790d7a3e7$export$aa56fec1e9d629b8 extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $bd87f15790d7a3e7$export$5716da67bfaa244d.undefined) return $bd87f15790d7a3e7$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$bd87f15790d7a3e7$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $bd87f15790d7a3e7$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodOptional,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
};
class $bd87f15790d7a3e7$export$aaac0b8b429cef5 extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $bd87f15790d7a3e7$export$5716da67bfaa244d.null) return $bd87f15790d7a3e7$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$bd87f15790d7a3e7$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $bd87f15790d7a3e7$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodNullable,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
};
class $bd87f15790d7a3e7$export$bb19b37874861e7e extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $bd87f15790d7a3e7$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$bd87f15790d7a3e7$export$bb19b37874861e7e.create = (type, params)=>{
    return new $bd87f15790d7a3e7$export$bb19b37874861e7e({
        innerType: type,
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
};
class $bd87f15790d7a3e7$export$75a44ec6249ac76b extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ($bd87f15790d7a3e7$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $bd87f15790d7a3e7$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $bd87f15790d7a3e7$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$bd87f15790d7a3e7$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $bd87f15790d7a3e7$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
};
class $bd87f15790d7a3e7$export$26ccfa0145e8511f extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $bd87f15790d7a3e7$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $bd87f15790d7a3e7$export$db7caee60e5d514d(ctx, {
                code: $bd87f15790d7a3e7$export$5ba560653e4a1035.invalid_type,
                expected: $bd87f15790d7a3e7$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$bd87f15790d7a3e7$export$26ccfa0145e8511f.create = (params)=>{
    return new $bd87f15790d7a3e7$export$26ccfa0145e8511f({
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodNaN,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
};
const $bd87f15790d7a3e7$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $bd87f15790d7a3e7$export$66b0c798a395271f extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $bd87f15790d7a3e7$export$a3c3ef8a0e95c6da extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $bd87f15790d7a3e7$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $bd87f15790d7a3e7$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $bd87f15790d7a3e7$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $bd87f15790d7a3e7$export$5d1f7ef05c4e493a extends $bd87f15790d7a3e7$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        if ($bd87f15790d7a3e7$export$1ea939691cdc45b8(result)) result.value = Object.freeze(result.value);
        return result;
    }
}
$bd87f15790d7a3e7$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $bd87f15790d7a3e7$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $bd87f15790d7a3e7$export$558106ce543bd011.ZodReadonly,
        ...$bd87f15790d7a3e7$var$processCreateParams(params)
    });
};
const $bd87f15790d7a3e7$export$4c00f665f0d4b443 = (check, params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal)=>{
    if (check) return $bd87f15790d7a3e7$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue({
                code: "custom",
                ...p2,
                fatal: _fatal
            });
        }
    });
    return $bd87f15790d7a3e7$export$b9d1edb536b4e4eb.create();
};
const $bd87f15790d7a3e7$export$1ee8ee30835eab8b = {
    object: $bd87f15790d7a3e7$export$736315c5b55efbad.lazycreate
};
var $bd87f15790d7a3e7$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($bd87f15790d7a3e7$export$558106ce543bd011 || ($bd87f15790d7a3e7$export$558106ce543bd011 = {}));
const $bd87f15790d7a3e7$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$bd87f15790d7a3e7$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $bd87f15790d7a3e7$export$22b082955e083ec3 = $bd87f15790d7a3e7$export$1230eb29b8d3b502.create;
const $bd87f15790d7a3e7$export$98e628dec113755e = $bd87f15790d7a3e7$export$5b070a55c0c43e09.create;
const $bd87f15790d7a3e7$export$9e06de0973666692 = $bd87f15790d7a3e7$export$26ccfa0145e8511f.create;
const $bd87f15790d7a3e7$export$a0f65b52274bcc00 = $bd87f15790d7a3e7$export$67d741fd70ff98f4.create;
const $bd87f15790d7a3e7$export$4a21f16c33752377 = $bd87f15790d7a3e7$export$723d146f80596191.create;
const $bd87f15790d7a3e7$export$324d90190a8b822a = $bd87f15790d7a3e7$export$e974be33bdc55521.create;
const $bd87f15790d7a3e7$export$8f701197936bc2a6 = $bd87f15790d7a3e7$export$bcc3b40f6b638044.create;
const $bd87f15790d7a3e7$export$1db45310990710a5 = $bd87f15790d7a3e7$export$4e780e961c30340d.create;
const $bd87f15790d7a3e7$export$7b1b591b262c240 = $bd87f15790d7a3e7$export$a96281f914484f2d.create;
const $bd87f15790d7a3e7$export$4154a199d7d90455 = $bd87f15790d7a3e7$export$b9d1edb536b4e4eb.create;
const $bd87f15790d7a3e7$export$19282c40b967aec6 = $bd87f15790d7a3e7$export$ef3b1bb1630977ae.create;
const $bd87f15790d7a3e7$export$b3e22bcfd64c1022 = $bd87f15790d7a3e7$export$1e576a20c3ce9fb5.create;
const $bd87f15790d7a3e7$export$490e536ee7389aeb = $bd87f15790d7a3e7$export$7d39f5df85f21031.create;
const $bd87f15790d7a3e7$export$2f23118c22fb2630 = $bd87f15790d7a3e7$export$7acfc3e64785411.create;
const $bd87f15790d7a3e7$export$be5493f9613cbbe = $bd87f15790d7a3e7$export$736315c5b55efbad.create;
const $bd87f15790d7a3e7$export$8fb0df5f40d0b477 = $bd87f15790d7a3e7$export$736315c5b55efbad.strictCreate;
const $bd87f15790d7a3e7$export$971dd5b0dfd021b6 = $bd87f15790d7a3e7$export$a8b236cb5070a311.create;
const $bd87f15790d7a3e7$export$4b888e40c4ee26dd = $bd87f15790d7a3e7$export$5ef2424805ac76a3.create;
const $bd87f15790d7a3e7$export$bc86dfbf7795668c = $bd87f15790d7a3e7$export$c02deaf0bb5203d4.create;
const $bd87f15790d7a3e7$export$65e3907585753458 = $bd87f15790d7a3e7$export$e2a18bb771d8e6a3.create;
const $bd87f15790d7a3e7$export$e5185e241753e543 = $bd87f15790d7a3e7$export$a2acc09968cb4b7f.create;
const $bd87f15790d7a3e7$export$871de8747c9eaa88 = $bd87f15790d7a3e7$export$163b6a2b712d9542.create;
const $bd87f15790d7a3e7$export$adaa4cf7ef1b65be = $bd87f15790d7a3e7$export$977057706f816712.create;
const $bd87f15790d7a3e7$export$44e51c8aac7c2deb = $bd87f15790d7a3e7$export$d4602ba55673f53c.create;
const $bd87f15790d7a3e7$export$488013bae63b21da = $bd87f15790d7a3e7$export$378d0cfce37406e6.create;
const $bd87f15790d7a3e7$export$c8ec6e1ec9fefcb0 = $bd87f15790d7a3e7$export$7e44096782a165d3.create;
const $bd87f15790d7a3e7$export$78a99c8d44d72635 = $bd87f15790d7a3e7$export$d325d1f0e1c20179.create;
const $bd87f15790d7a3e7$export$6fe7eca19ebe5199 = $bd87f15790d7a3e7$export$370b2e8d6d6f5c56.create;
const $bd87f15790d7a3e7$export$c957ef27a0ebfd4 = $bd87f15790d7a3e7$export$3f196b0127d6e50a.create;
const $bd87f15790d7a3e7$export$dc573d8a6576cdb3 = $bd87f15790d7a3e7$export$a60af00cc0ce2582.create;
const $bd87f15790d7a3e7$export$516e28dec6a4b6d4 = $bd87f15790d7a3e7$export$aa56fec1e9d629b8.create;
const $bd87f15790d7a3e7$export$133fc36489ac9add = $bd87f15790d7a3e7$export$aaac0b8b429cef5.create;
const $bd87f15790d7a3e7$export$fc37fe19dfda43ee = $bd87f15790d7a3e7$export$a60af00cc0ce2582.createWithPreprocess;
const $bd87f15790d7a3e7$export$43f28b24e1eb8181 = $bd87f15790d7a3e7$export$a3c3ef8a0e95c6da.create;
const $bd87f15790d7a3e7$export$3b3d07727c5b702c = ()=>$bd87f15790d7a3e7$export$22b082955e083ec3().optional();
const $bd87f15790d7a3e7$export$eb150471a61fced6 = ()=>$bd87f15790d7a3e7$export$98e628dec113755e().optional();
const $bd87f15790d7a3e7$export$269251733cdcbbf1 = ()=>$bd87f15790d7a3e7$export$4a21f16c33752377().optional();
const $bd87f15790d7a3e7$export$8c14e57e778d3873 = {
    string: (arg)=>$bd87f15790d7a3e7$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$bd87f15790d7a3e7$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$bd87f15790d7a3e7$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$bd87f15790d7a3e7$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$bd87f15790d7a3e7$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $bd87f15790d7a3e7$export$96c94437c95d7862 = $bd87f15790d7a3e7$export$9a105a556e65c2c0;
var $bd87f15790d7a3e7$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $bd87f15790d7a3e7$export$341b0b6e0a6f5099,
    setErrorMap: $bd87f15790d7a3e7$export$1097a8289cfd22d7,
    getErrorMap: $bd87f15790d7a3e7$export$32f27c719778d4c4,
    makeIssue: $bd87f15790d7a3e7$export$244a85fde9c419ed,
    EMPTY_PATH: $bd87f15790d7a3e7$export$1526d2e05f74572,
    addIssueToContext: $bd87f15790d7a3e7$export$db7caee60e5d514d,
    ParseStatus: $bd87f15790d7a3e7$export$5b20a5c3d05c1f6f,
    INVALID: $bd87f15790d7a3e7$export$9a105a556e65c2c0,
    DIRTY: $bd87f15790d7a3e7$export$325a211da9693fcf,
    OK: $bd87f15790d7a3e7$export$c6813a8d51f77eaf,
    isAborted: $bd87f15790d7a3e7$export$afa861e3c5730743,
    isDirty: $bd87f15790d7a3e7$export$910b6cdd390341b3,
    isValid: $bd87f15790d7a3e7$export$1ea939691cdc45b8,
    isAsync: $bd87f15790d7a3e7$export$aefee5ebe1dcfd9e,
    get util () {
        return $bd87f15790d7a3e7$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $bd87f15790d7a3e7$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $bd87f15790d7a3e7$export$5716da67bfaa244d,
    getParsedType: $bd87f15790d7a3e7$export$3e9057828ebd5c7a,
    ZodType: $bd87f15790d7a3e7$export$19342e026b58ebb7,
    ZodString: $bd87f15790d7a3e7$export$1230eb29b8d3b502,
    ZodNumber: $bd87f15790d7a3e7$export$5b070a55c0c43e09,
    ZodBigInt: $bd87f15790d7a3e7$export$67d741fd70ff98f4,
    ZodBoolean: $bd87f15790d7a3e7$export$723d146f80596191,
    ZodDate: $bd87f15790d7a3e7$export$e974be33bdc55521,
    ZodSymbol: $bd87f15790d7a3e7$export$bcc3b40f6b638044,
    ZodUndefined: $bd87f15790d7a3e7$export$4e780e961c30340d,
    ZodNull: $bd87f15790d7a3e7$export$a96281f914484f2d,
    ZodAny: $bd87f15790d7a3e7$export$b9d1edb536b4e4eb,
    ZodUnknown: $bd87f15790d7a3e7$export$ef3b1bb1630977ae,
    ZodNever: $bd87f15790d7a3e7$export$1e576a20c3ce9fb5,
    ZodVoid: $bd87f15790d7a3e7$export$7d39f5df85f21031,
    ZodArray: $bd87f15790d7a3e7$export$7acfc3e64785411,
    ZodObject: $bd87f15790d7a3e7$export$736315c5b55efbad,
    ZodUnion: $bd87f15790d7a3e7$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $bd87f15790d7a3e7$export$5ef2424805ac76a3,
    ZodIntersection: $bd87f15790d7a3e7$export$c02deaf0bb5203d4,
    ZodTuple: $bd87f15790d7a3e7$export$e2a18bb771d8e6a3,
    ZodRecord: $bd87f15790d7a3e7$export$a2acc09968cb4b7f,
    ZodMap: $bd87f15790d7a3e7$export$163b6a2b712d9542,
    ZodSet: $bd87f15790d7a3e7$export$977057706f816712,
    ZodFunction: $bd87f15790d7a3e7$export$d4602ba55673f53c,
    ZodLazy: $bd87f15790d7a3e7$export$378d0cfce37406e6,
    ZodLiteral: $bd87f15790d7a3e7$export$7e44096782a165d3,
    ZodEnum: $bd87f15790d7a3e7$export$d325d1f0e1c20179,
    ZodNativeEnum: $bd87f15790d7a3e7$export$370b2e8d6d6f5c56,
    ZodPromise: $bd87f15790d7a3e7$export$3f196b0127d6e50a,
    ZodEffects: $bd87f15790d7a3e7$export$a60af00cc0ce2582,
    ZodTransformer: $bd87f15790d7a3e7$export$a60af00cc0ce2582,
    ZodOptional: $bd87f15790d7a3e7$export$aa56fec1e9d629b8,
    ZodNullable: $bd87f15790d7a3e7$export$aaac0b8b429cef5,
    ZodDefault: $bd87f15790d7a3e7$export$bb19b37874861e7e,
    ZodCatch: $bd87f15790d7a3e7$export$75a44ec6249ac76b,
    ZodNaN: $bd87f15790d7a3e7$export$26ccfa0145e8511f,
    BRAND: $bd87f15790d7a3e7$export$cf2deea74cde46b4,
    ZodBranded: $bd87f15790d7a3e7$export$66b0c798a395271f,
    ZodPipeline: $bd87f15790d7a3e7$export$a3c3ef8a0e95c6da,
    ZodReadonly: $bd87f15790d7a3e7$export$5d1f7ef05c4e493a,
    custom: $bd87f15790d7a3e7$export$4c00f665f0d4b443,
    Schema: $bd87f15790d7a3e7$export$19342e026b58ebb7,
    ZodSchema: $bd87f15790d7a3e7$export$19342e026b58ebb7,
    late: $bd87f15790d7a3e7$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $bd87f15790d7a3e7$export$558106ce543bd011;
    },
    coerce: $bd87f15790d7a3e7$export$8c14e57e778d3873,
    any: $bd87f15790d7a3e7$export$4154a199d7d90455,
    array: $bd87f15790d7a3e7$export$2f23118c22fb2630,
    bigint: $bd87f15790d7a3e7$export$a0f65b52274bcc00,
    boolean: $bd87f15790d7a3e7$export$4a21f16c33752377,
    date: $bd87f15790d7a3e7$export$324d90190a8b822a,
    discriminatedUnion: $bd87f15790d7a3e7$export$4b888e40c4ee26dd,
    effect: $bd87f15790d7a3e7$export$dc573d8a6576cdb3,
    "enum": $bd87f15790d7a3e7$export$78a99c8d44d72635,
    "function": $bd87f15790d7a3e7$export$44e51c8aac7c2deb,
    "instanceof": $bd87f15790d7a3e7$export$3d916e7c22dbd8b5,
    intersection: $bd87f15790d7a3e7$export$bc86dfbf7795668c,
    lazy: $bd87f15790d7a3e7$export$488013bae63b21da,
    literal: $bd87f15790d7a3e7$export$c8ec6e1ec9fefcb0,
    map: $bd87f15790d7a3e7$export$871de8747c9eaa88,
    nan: $bd87f15790d7a3e7$export$9e06de0973666692,
    nativeEnum: $bd87f15790d7a3e7$export$6fe7eca19ebe5199,
    never: $bd87f15790d7a3e7$export$b3e22bcfd64c1022,
    "null": $bd87f15790d7a3e7$export$7b1b591b262c240,
    nullable: $bd87f15790d7a3e7$export$133fc36489ac9add,
    number: $bd87f15790d7a3e7$export$98e628dec113755e,
    object: $bd87f15790d7a3e7$export$be5493f9613cbbe,
    oboolean: $bd87f15790d7a3e7$export$269251733cdcbbf1,
    onumber: $bd87f15790d7a3e7$export$eb150471a61fced6,
    optional: $bd87f15790d7a3e7$export$516e28dec6a4b6d4,
    ostring: $bd87f15790d7a3e7$export$3b3d07727c5b702c,
    pipeline: $bd87f15790d7a3e7$export$43f28b24e1eb8181,
    preprocess: $bd87f15790d7a3e7$export$fc37fe19dfda43ee,
    promise: $bd87f15790d7a3e7$export$c957ef27a0ebfd4,
    record: $bd87f15790d7a3e7$export$e5185e241753e543,
    set: $bd87f15790d7a3e7$export$adaa4cf7ef1b65be,
    strictObject: $bd87f15790d7a3e7$export$8fb0df5f40d0b477,
    string: $bd87f15790d7a3e7$export$22b082955e083ec3,
    symbol: $bd87f15790d7a3e7$export$8f701197936bc2a6,
    transformer: $bd87f15790d7a3e7$export$dc573d8a6576cdb3,
    tuple: $bd87f15790d7a3e7$export$65e3907585753458,
    "undefined": $bd87f15790d7a3e7$export$1db45310990710a5,
    union: $bd87f15790d7a3e7$export$971dd5b0dfd021b6,
    unknown: $bd87f15790d7a3e7$export$19282c40b967aec6,
    "void": $bd87f15790d7a3e7$export$490e536ee7389aeb,
    NEVER: $bd87f15790d7a3e7$export$96c94437c95d7862,
    ZodIssueCode: $bd87f15790d7a3e7$export$5ba560653e4a1035,
    quotelessJson: $bd87f15790d7a3e7$export$913eddeaf297cfea,
    ZodError: $bd87f15790d7a3e7$export$f98dac4b251ab333
});



const $479e84117c6008db$var$zError = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    message: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string()
});
function $479e84117c6008db$var$zType(key) {
    return (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal((0, $7e71742c1a96e4ab$export$3ff97a7390ed49be)[key]);
}
const $479e84117c6008db$export$89415e8e09b5a4e0 = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    accessList: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).array((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string()),
    blockHash: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string().nullable(),
    blockNumber: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string().nullable(),
    chainId: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string(),
    from: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string(),
    gas: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string(),
    hash: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string(),
    input: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string().nullable(),
    maxFeePerGas: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string(),
    maxPriorityFeePerGas: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string(),
    nonce: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string(),
    r: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string(),
    s: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string(),
    to: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string(),
    transactionIndex: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string().nullable(),
    type: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string(),
    v: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string(),
    value: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string()
});
const $479e84117c6008db$export$6f296c19518f2ab2 = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    chainId: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).number()
});
const $479e84117c6008db$export$976f191ce42ce5be = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    email: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string().email()
});
const $479e84117c6008db$export$3c60c26d0e7c7485 = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    otp: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string()
});
const $479e84117c6008db$export$2b55edadc32e688a = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    chainId: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).optional((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).number())
});
const $479e84117c6008db$export$65e6e56482b6df27 = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    email: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string().email()
});
const $479e84117c6008db$export$63ec130352b88085 = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    otp: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string()
});
const $479e84117c6008db$export$cbb50d2392bf53e2 = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    otp: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string()
});
const $479e84117c6008db$export$c523bb85fd166f04 = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    themeMode: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).optional((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).enum([
        "light",
        "dark"
    ])),
    themeVariables: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).optional((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).record((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string(), (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string().or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).number())))
});
const $479e84117c6008db$export$4ca9ea890e921270 = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    metadata: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        name: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string(),
        description: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string(),
        url: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string(),
        icons: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).array((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string())
    }).optional(),
    sdkVersion: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string(),
    projectId: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string()
});
const $479e84117c6008db$export$3fc5153b9dd73fc1 = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    jwt: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string()
});
const $479e84117c6008db$export$333a7bf9d10b914 = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    action: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).enum([
        "VERIFY_DEVICE",
        "VERIFY_OTP"
    ])
});
const $479e84117c6008db$export$2d6662dda0084b61 = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    email: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string().email(),
    address: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string(),
    chainId: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).number()
});
const $479e84117c6008db$export$775a450ce21f8fdf = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    isConnected: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).boolean()
});
const $479e84117c6008db$export$245abc04f43df573 = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    chainId: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).number()
});
const $479e84117c6008db$export$178941fe9bfa6200 = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    chainId: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).number()
});
const $479e84117c6008db$export$bb05e12b7f21caf1 = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    newEmail: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string().email()
});
const $479e84117c6008db$export$d4ce1c0118069cf6 = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).any();
const $479e84117c6008db$export$333c606c26a06359 = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_accounts")
});
const $479e84117c6008db$export$ed481a6ef87fb1a4 = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_blockNumber")
});
const $479e84117c6008db$export$3746f30d5256aebc = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_call"),
    params: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).array((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).any())
});
const $479e84117c6008db$export$ced6b8fef5e3a1ae = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_chainId")
});
const $479e84117c6008db$export$272161a7d614a7de = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_estimateGas"),
    params: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).array((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).any())
});
const $479e84117c6008db$export$601d25f8f10fb73e = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_feeHistory"),
    params: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).array((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).any())
});
const $479e84117c6008db$export$375f72aea2abe32f = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_gasPrice")
});
const $479e84117c6008db$export$5781e194c9800107 = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_getAccount"),
    params: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).array((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).any())
});
const $479e84117c6008db$export$e8c54d0244516318 = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_getBalance"),
    params: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).array((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).any())
});
const $479e84117c6008db$export$ed296586d8ca73e5 = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_getBlockByHash"),
    params: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).array((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).any())
});
const $479e84117c6008db$export$5930d1a65f85cd1c = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_getBlockByNumber"),
    params: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).array((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).any())
});
const $479e84117c6008db$export$728754e9b5ce598 = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_getBlockReceipts"),
    params: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).array((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).any())
});
const $479e84117c6008db$export$4ddab575d344fe47 = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_getBlockTransactionCountByHash"),
    params: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).array((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).any())
});
const $479e84117c6008db$export$3a9707a1a95b758c = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_getBlockTransactionCountByNumber"),
    params: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).array((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).any())
});
const $479e84117c6008db$export$32d3decd99b4e77c = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_getCode"),
    params: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).array((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).any())
});
const $479e84117c6008db$export$70385be35bb1c094 = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_getFilterChanges"),
    params: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).array((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).any())
});
const $479e84117c6008db$export$67adfcd98750c2a4 = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_getFilterLogs"),
    params: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).array((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).any())
});
const $479e84117c6008db$export$ec85b0f99f3b0860 = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_getLogs"),
    params: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).array((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).any())
});
const $479e84117c6008db$export$aad1bb370c749036 = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_getProof"),
    params: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).array((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).any())
});
const $479e84117c6008db$export$de118eb57c7e99ee = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_getStorageAt"),
    params: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).array((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).any())
});
const $479e84117c6008db$export$925a4185b30091ca = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_getTransactionByBlockHashAndIndex"),
    params: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).array((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).any())
});
const $479e84117c6008db$export$132e327b9ac8100f = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_getTransactionByBlockNumberAndIndex"),
    params: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).array((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).any())
});
const $479e84117c6008db$export$b498be03499c3270 = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_getTransactionByHash"),
    params: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).array((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).any())
});
const $479e84117c6008db$export$8e3ae636de98a13f = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_getTransactionCount"),
    params: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).array((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).any())
});
const $479e84117c6008db$export$ebf4091cc6dfa2ef = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_getTransactionReceipt"),
    params: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).array((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).any())
});
const $479e84117c6008db$export$a9e565a5951dbda1 = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_getUncleCountByBlockHash"),
    params: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).array((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).any())
});
const $479e84117c6008db$export$3e72b948c8cdb33b = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_getUncleCountByBlockNumber"),
    params: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).array((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).any())
});
const $479e84117c6008db$export$35da6e194885ea4f = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_maxPriorityFeePerGas")
});
const $479e84117c6008db$export$f2d7c90f3596d13e = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_newBlockFilter")
});
const $479e84117c6008db$export$f6ccc436669a288e = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_newFilter"),
    params: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).array((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).any())
});
const $479e84117c6008db$export$299d889501e7632c = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_newPendingTransactionFilter")
});
const $479e84117c6008db$export$2f01b91caa317491 = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_sendRawTransaction"),
    params: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).array((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).any())
});
const $479e84117c6008db$export$688f7a1e4924e71b = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_syncing"),
    params: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).array((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).any())
});
const $479e84117c6008db$export$1cc394e8ef03e09a = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_uninstallFilter"),
    params: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).array((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).any())
});
const $479e84117c6008db$export$57dc995d18380851 = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("personal_sign"),
    params: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).array((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).any())
});
const $479e84117c6008db$export$98d6e3ae5e5869d0 = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_signTypedData_v4"),
    params: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).array((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).any())
});
const $479e84117c6008db$export$fc4f4bb7f991c8e0 = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    method: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).literal("eth_sendTransaction"),
    params: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).array((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).any())
});
const $479e84117c6008db$export$583fad842749c757 = (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
    token: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).string()
});
const $479e84117c6008db$export$238f9986c2bb1b9a = {
    appEvent: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("APP_SWITCH_NETWORK"),
        payload: $479e84117c6008db$export$6f296c19518f2ab2
    }).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("APP_CONNECT_EMAIL"),
        payload: $479e84117c6008db$export$976f191ce42ce5be
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("APP_CONNECT_DEVICE"),
        payload: $479e84117c6008db$export$3fc5153b9dd73fc1
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("APP_CONNECT_OTP"),
        payload: $479e84117c6008db$export$3c60c26d0e7c7485
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("APP_GET_USER"),
        payload: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).optional($479e84117c6008db$export$2b55edadc32e688a)
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("APP_SIGN_OUT")
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("APP_IS_CONNECTED"),
        payload: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).optional($479e84117c6008db$export$583fad842749c757)
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("APP_GET_CHAIN_ID")
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("APP_RPC_REQUEST"),
        payload: $479e84117c6008db$export$57dc995d18380851.or($479e84117c6008db$export$fc4f4bb7f991c8e0).or($479e84117c6008db$export$333c606c26a06359).or($479e84117c6008db$export$ed481a6ef87fb1a4).or($479e84117c6008db$export$3746f30d5256aebc).or($479e84117c6008db$export$ced6b8fef5e3a1ae).or($479e84117c6008db$export$272161a7d614a7de).or($479e84117c6008db$export$601d25f8f10fb73e).or($479e84117c6008db$export$375f72aea2abe32f).or($479e84117c6008db$export$5781e194c9800107).or($479e84117c6008db$export$e8c54d0244516318).or($479e84117c6008db$export$ed296586d8ca73e5).or($479e84117c6008db$export$5930d1a65f85cd1c).or($479e84117c6008db$export$728754e9b5ce598).or($479e84117c6008db$export$4ddab575d344fe47).or($479e84117c6008db$export$3a9707a1a95b758c).or($479e84117c6008db$export$32d3decd99b4e77c).or($479e84117c6008db$export$70385be35bb1c094).or($479e84117c6008db$export$67adfcd98750c2a4).or($479e84117c6008db$export$ec85b0f99f3b0860).or($479e84117c6008db$export$aad1bb370c749036).or($479e84117c6008db$export$de118eb57c7e99ee).or($479e84117c6008db$export$925a4185b30091ca).or($479e84117c6008db$export$132e327b9ac8100f).or($479e84117c6008db$export$b498be03499c3270).or($479e84117c6008db$export$8e3ae636de98a13f).or($479e84117c6008db$export$ebf4091cc6dfa2ef).or($479e84117c6008db$export$a9e565a5951dbda1).or($479e84117c6008db$export$3e72b948c8cdb33b).or($479e84117c6008db$export$35da6e194885ea4f).or($479e84117c6008db$export$f2d7c90f3596d13e).or($479e84117c6008db$export$f6ccc436669a288e).or($479e84117c6008db$export$299d889501e7632c).or($479e84117c6008db$export$2f01b91caa317491).or($479e84117c6008db$export$688f7a1e4924e71b).or($479e84117c6008db$export$1cc394e8ef03e09a).or($479e84117c6008db$export$57dc995d18380851).or($479e84117c6008db$export$98d6e3ae5e5869d0).or($479e84117c6008db$export$fc4f4bb7f991c8e0)
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("APP_UPDATE_EMAIL"),
        payload: $479e84117c6008db$export$65e6e56482b6df27
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("APP_UPDATE_EMAIL_PRIMARY_OTP"),
        payload: $479e84117c6008db$export$63ec130352b88085
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("APP_UPDATE_EMAIL_SECONDARY_OTP"),
        payload: $479e84117c6008db$export$cbb50d2392bf53e2
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("APP_SYNC_THEME"),
        payload: $479e84117c6008db$export$c523bb85fd166f04
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("APP_SYNC_DAPP_DATA"),
        payload: $479e84117c6008db$export$4ca9ea890e921270
    })),
    frameEvent: (0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("FRAME_SWITCH_NETWORK_ERROR"),
        payload: $479e84117c6008db$var$zError
    }).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("FRAME_SWITCH_NETWORK_SUCCESS"),
        payload: $479e84117c6008db$export$178941fe9bfa6200
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("FRAME_CONNECT_EMAIL_ERROR"),
        payload: $479e84117c6008db$var$zError
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("FRAME_CONNECT_EMAIL_SUCCESS"),
        payload: $479e84117c6008db$export$333a7bf9d10b914
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("FRAME_CONNECT_OTP_ERROR"),
        payload: $479e84117c6008db$var$zError
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("FRAME_CONNECT_OTP_SUCCESS")
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("FRAME_CONNECT_DEVICE_ERROR"),
        payload: $479e84117c6008db$var$zError
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("FRAME_CONNECT_DEVICE_SUCCESS")
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("FRAME_GET_USER_ERROR"),
        payload: $479e84117c6008db$var$zError
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("FRAME_GET_USER_SUCCESS"),
        payload: $479e84117c6008db$export$2d6662dda0084b61
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("FRAME_SIGN_OUT_ERROR"),
        payload: $479e84117c6008db$var$zError
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("FRAME_SIGN_OUT_SUCCESS")
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("FRAME_IS_CONNECTED_ERROR"),
        payload: $479e84117c6008db$var$zError
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("FRAME_IS_CONNECTED_SUCCESS"),
        payload: $479e84117c6008db$export$775a450ce21f8fdf
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("FRAME_GET_CHAIN_ID_ERROR"),
        payload: $479e84117c6008db$var$zError
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("FRAME_GET_CHAIN_ID_SUCCESS"),
        payload: $479e84117c6008db$export$245abc04f43df573
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("FRAME_RPC_REQUEST_ERROR"),
        payload: $479e84117c6008db$var$zError
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("FRAME_RPC_REQUEST_SUCCESS"),
        payload: $479e84117c6008db$export$d4ce1c0118069cf6
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("FRAME_SESSION_UPDATE"),
        payload: $479e84117c6008db$export$583fad842749c757
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("FRAME_UPDATE_EMAIL_ERROR"),
        payload: $479e84117c6008db$var$zError
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("FRAME_UPDATE_EMAIL_SUCCESS")
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("FRAME_UPDATE_EMAIL_PRIMARY_OTP_ERROR"),
        payload: $479e84117c6008db$var$zError
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("FRAME_UPDATE_EMAIL_PRIMARY_OTP_SUCCESS")
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("FRAME_UPDATE_EMAIL_SECONDARY_OTP_ERROR"),
        payload: $479e84117c6008db$var$zError
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("FRAME_UPDATE_EMAIL_SECONDARY_OTP_SUCCESS"),
        payload: $479e84117c6008db$export$bb05e12b7f21caf1
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("FRAME_SYNC_THEME_ERROR"),
        payload: $479e84117c6008db$var$zError
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("FRAME_SYNC_THEME_SUCCESS")
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("FRAME_SYNC_DAPP_DATA_ERROR"),
        payload: $479e84117c6008db$var$zError
    })).or((0, $bd87f15790d7a3e7$export$2e2bcd8739ae039).object({
        type: $479e84117c6008db$var$zType("FRAME_SYNC_DAPP_DATA_SUCCESS")
    }))
};




const $2395d74c97ac5227$export$500c415dce2853c3 = {
    set (key, value) {
        if ((0, $d45dd643a7118621$export$794efc40d8765bc4).isClient) localStorage.setItem(`${(0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).STORAGE_KEY}${key}`, value);
    },
    get (key) {
        if ((0, $d45dd643a7118621$export$794efc40d8765bc4).isClient) return localStorage.getItem(`${(0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).STORAGE_KEY}${key}`);
        return null;
    },
    delete (key) {
        if ((0, $d45dd643a7118621$export$794efc40d8765bc4).isClient) localStorage.removeItem(`${(0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).STORAGE_KEY}${key}`);
    }
};



const $d45dd643a7118621$var$RESTRICTED_TIMEZONES = [
    "ASIA/SHANGHAI",
    "ASIA/URUMQI",
    "ASIA/CHONGQING",
    "ASIA/HARBIN",
    "ASIA/KASHGAR",
    "ASIA/MACAU",
    "ASIA/HONG_KONG",
    "ASIA/MACAO",
    "ASIA/BEIJING",
    "ASIA/HARBIN"
];
const $d45dd643a7118621$var$EMAIL_MINIMUM_TIMEOUT = 30000;
const $d45dd643a7118621$export$794efc40d8765bc4 = {
    getBlockchainApiUrl () {
        try {
            const { timeZone: timeZone } = new Intl.DateTimeFormat().resolvedOptions();
            const capTimeZone = timeZone.toUpperCase();
            return $d45dd643a7118621$var$RESTRICTED_TIMEZONES.includes(capTimeZone) ? "https://rpc.walletconnect.org" : "https://rpc.walletconnect.com";
        } catch  {
            return false;
        }
    },
    checkIfAllowedToTriggerEmail () {
        const lastEmailLoginTime = (0, $2395d74c97ac5227$export$500c415dce2853c3).get((0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).LAST_EMAIL_LOGIN_TIME);
        if (lastEmailLoginTime) {
            const difference = Date.now() - Number(lastEmailLoginTime);
            if (difference < $d45dd643a7118621$var$EMAIL_MINIMUM_TIMEOUT) {
                const cooldownSec = Math.ceil(($d45dd643a7118621$var$EMAIL_MINIMUM_TIMEOUT - difference) / 1000);
                throw new Error(`Please try again after ${cooldownSec} seconds`);
            }
        }
    },
    getTimeToNextEmailLogin () {
        const lastEmailLoginTime = (0, $2395d74c97ac5227$export$500c415dce2853c3).get((0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).LAST_EMAIL_LOGIN_TIME);
        if (lastEmailLoginTime) {
            const difference = Date.now() - Number(lastEmailLoginTime);
            if (difference < $d45dd643a7118621$var$EMAIL_MINIMUM_TIMEOUT) return Math.ceil(($d45dd643a7118621$var$EMAIL_MINIMUM_TIMEOUT - difference) / 1000);
        }
        return 0;
    },
    checkIfRequestExists (request) {
        const method = this.getRequestMethod(request);
        return (0, $7e71742c1a96e4ab$export$9975694bfb286db).NOT_SAFE_RPC_METHODS.includes(method) || (0, $7e71742c1a96e4ab$export$9975694bfb286db).SAFE_RPC_METHODS.includes(method);
    },
    getRequestMethod (request) {
        return request?.payload?.method;
    },
    checkIfRequestIsAllowed (request) {
        const method = this.getRequestMethod(request);
        return (0, $7e71742c1a96e4ab$export$9975694bfb286db).SAFE_RPC_METHODS.includes(method);
    },
    isClient: typeof window !== "undefined"
};


class $073df90dcbe56267$export$668e35d4f1b0aa08 {
    constructor(projectId, isAppClient = false){
        this.iframe = null;
        this.rpcUrl = (0, $d45dd643a7118621$export$794efc40d8765bc4).getBlockchainApiUrl();
        this.events = {
            onFrameEvent: (callback)=>{
                if ((0, $d45dd643a7118621$export$794efc40d8765bc4).isClient) window.addEventListener("message", ({ data: data })=>{
                    if (!data.type?.includes((0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).FRAME_EVENT_KEY)) return;
                    const frameEvent = (0, $479e84117c6008db$export$238f9986c2bb1b9a).frameEvent.parse(data);
                    callback(frameEvent);
                });
            },
            onAppEvent: (callback)=>{
                if ((0, $d45dd643a7118621$export$794efc40d8765bc4).isClient) window.addEventListener("message", ({ data: data })=>{
                    if (!data.type?.includes((0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).APP_EVENT_KEY)) return;
                    const appEvent = (0, $479e84117c6008db$export$238f9986c2bb1b9a).appEvent.parse(data);
                    callback(appEvent);
                });
            },
            postAppEvent: (event)=>{
                if ((0, $d45dd643a7118621$export$794efc40d8765bc4).isClient) {
                    if (!this.iframe?.contentWindow) throw new Error("W3mFrame: iframe is not set");
                    (0, $479e84117c6008db$export$238f9986c2bb1b9a).appEvent.parse(event);
                    window.postMessage(event);
                    this.iframe.contentWindow.postMessage(event, "*");
                }
            },
            postFrameEvent: (event)=>{
                if ((0, $d45dd643a7118621$export$794efc40d8765bc4).isClient) {
                    if (!parent) throw new Error("W3mFrame: parent is not set");
                    (0, $479e84117c6008db$export$238f9986c2bb1b9a).frameEvent.parse(event);
                    parent.postMessage(event, "*");
                }
            }
        };
        this.projectId = projectId;
        this.frameLoadPromise = new Promise((resolve, reject)=>{
            this.frameLoadPromiseResolver = {
                resolve: resolve,
                reject: reject
            };
        });
        if (isAppClient) {
            this.frameLoadPromise = new Promise((resolve, reject)=>{
                this.frameLoadPromiseResolver = {
                    resolve: resolve,
                    reject: reject
                };
            });
            if ((0, $d45dd643a7118621$export$794efc40d8765bc4).isClient) {
                const iframe = document.createElement("iframe");
                iframe.id = "w3m-iframe";
                iframe.src = `${(0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).SECURE_SITE_SDK}?projectId=${projectId}`;
                iframe.style.position = "fixed";
                iframe.style.zIndex = "999999";
                iframe.style.display = "none";
                iframe.style.opacity = "0";
                iframe.style.borderRadius = `clamp(0px, var(--wui-border-radius-l), 44px)`;
                document.body.appendChild(iframe);
                this.iframe = iframe;
                this.iframe.onload = ()=>{
                    this.frameLoadPromiseResolver?.resolve(undefined);
                };
                this.iframe.onerror = ()=>{
                    this.frameLoadPromiseResolver?.reject("Unable to load email login dependency");
                };
            }
        }
    }
    get networks() {
        const data = [
            1,
            5,
            11155111,
            10,
            420,
            42161,
            421613,
            137,
            80001,
            42220,
            1313161554,
            1313161555,
            56,
            97,
            43114,
            43113,
            324,
            280,
            100,
            8453,
            84531,
            7777777,
            999
        ].map((id)=>({
                [id]: {
                    rpcUrl: `${this.rpcUrl}/v1/?chainId=eip155:${id}&projectId=${this.projectId}`,
                    chainId: id
                }
            }));
        return Object.assign({}, ...data);
    }
}



parcelRequire("aAJP9");
var $bOlNk = parcelRequire("bOlNk");




class $adbbe8c0e0c86d80$export$112ca4a9acf9f612 {
    constructor(projectId){
        this.connectEmailResolver = undefined;
        this.connectDeviceResolver = undefined;
        this.connectOtpResolver = undefined;
        this.connectResolver = undefined;
        this.disconnectResolver = undefined;
        this.isConnectedResolver = undefined;
        this.getChainIdResolver = undefined;
        this.switchChainResolver = undefined;
        this.rpcRequestResolver = undefined;
        this.updateEmailResolver = undefined;
        this.updateEmailPrimaryOtpResolver = undefined;
        this.updateEmailSecondaryOtpResolver = undefined;
        this.syncThemeResolver = undefined;
        this.syncDappDataResolver = undefined;
        this.w3mFrame = new (0, $073df90dcbe56267$export$668e35d4f1b0aa08)(projectId, true);
        this.w3mFrame.events.onFrameEvent((event)=>{
            console.log("\uD83D\uDCBB received", event);
            switch(event.type){
                case (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).FRAME_CONNECT_EMAIL_SUCCESS:
                    return this.onConnectEmailSuccess(event);
                case (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).FRAME_CONNECT_EMAIL_ERROR:
                    return this.onConnectEmailError(event);
                case (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).FRAME_CONNECT_DEVICE_SUCCESS:
                    return this.onConnectDeviceSuccess();
                case (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).FRAME_CONNECT_DEVICE_ERROR:
                    return this.onConnectDeviceError(event);
                case (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).FRAME_CONNECT_OTP_SUCCESS:
                    return this.onConnectOtpSuccess();
                case (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).FRAME_CONNECT_OTP_ERROR:
                    return this.onConnectOtpError(event);
                case (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).FRAME_GET_USER_SUCCESS:
                    return this.onConnectSuccess(event);
                case (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).FRAME_GET_USER_ERROR:
                    return this.onConnectError(event);
                case (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).FRAME_IS_CONNECTED_SUCCESS:
                    return this.onIsConnectedSuccess(event);
                case (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).FRAME_IS_CONNECTED_ERROR:
                    return this.onIsConnectedError(event);
                case (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).FRAME_GET_CHAIN_ID_SUCCESS:
                    return this.onGetChainIdSuccess(event);
                case (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).FRAME_GET_CHAIN_ID_ERROR:
                    return this.onGetChainIdError(event);
                case (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).FRAME_SIGN_OUT_SUCCESS:
                    return this.onSignOutSuccess();
                case (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).FRAME_SIGN_OUT_ERROR:
                    return this.onSignOutError(event);
                case (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).FRAME_SWITCH_NETWORK_SUCCESS:
                    return this.onSwitchChainSuccess(event);
                case (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).FRAME_SWITCH_NETWORK_ERROR:
                    return this.onSwitchChainError(event);
                case (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).FRAME_RPC_REQUEST_SUCCESS:
                    return this.onRpcRequestSuccess(event);
                case (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).FRAME_RPC_REQUEST_ERROR:
                    return this.onRpcRequestError(event);
                case (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).FRAME_SESSION_UPDATE:
                    return this.onSessionUpdate(event);
                case (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).FRAME_UPDATE_EMAIL_SUCCESS:
                    return this.onUpdateEmailSuccess();
                case (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).FRAME_UPDATE_EMAIL_ERROR:
                    return this.onUpdateEmailError(event);
                case (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).FRAME_UPDATE_EMAIL_PRIMARY_OTP_SUCCESS:
                    return this.onUpdateEmailPrimaryOtpSuccess();
                case (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).FRAME_UPDATE_EMAIL_PRIMARY_OTP_ERROR:
                    return this.onUpdateEmailPrimaryOtpError(event);
                case (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).FRAME_UPDATE_EMAIL_SECONDARY_OTP_SUCCESS:
                    return this.onUpdateEmailSecondaryOtpSuccess(event);
                case (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).FRAME_UPDATE_EMAIL_SECONDARY_OTP_ERROR:
                    return this.onUpdateEmailSecondaryOtpError(event);
                case (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).FRAME_SYNC_THEME_SUCCESS:
                    return this.onSyncThemeSuccess();
                case (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).FRAME_SYNC_THEME_ERROR:
                    return this.onSyncThemeError(event);
                case (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).FRAME_SYNC_DAPP_DATA_SUCCESS:
                    return this.onSyncDappDataSuccess();
                case (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).FRAME_SYNC_DAPP_DATA_ERROR:
                    return this.onSyncDappDataError(event);
                default:
                    return null;
            }
        });
    }
    getLoginEmailUsed() {
        return Boolean((0, $2395d74c97ac5227$export$500c415dce2853c3).get((0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).EMAIL_LOGIN_USED_KEY));
    }
    getEmail() {
        return (0, $2395d74c97ac5227$export$500c415dce2853c3).get((0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).EMAIL);
    }
    rejectRpcRequest() {
        this.rpcRequestResolver?.reject();
    }
    async connectEmail(payload) {
        await this.w3mFrame.frameLoadPromise;
        (0, $d45dd643a7118621$export$794efc40d8765bc4).checkIfAllowedToTriggerEmail();
        this.w3mFrame.events.postAppEvent({
            type: (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).APP_CONNECT_EMAIL,
            payload: payload
        });
        return new Promise((resolve, reject)=>{
            this.connectEmailResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async connectDevice() {
        await this.w3mFrame.frameLoadPromise;
        const jwt = await (0, $bOlNk.CryptoUtil).createJwt();
        this.w3mFrame.events.postAppEvent({
            type: (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).APP_CONNECT_DEVICE,
            payload: {
                jwt: jwt || ""
            }
        });
        return new Promise((resolve, reject)=>{
            this.connectDeviceResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async connectOtp(payload) {
        await this.w3mFrame.frameLoadPromise;
        this.w3mFrame.events.postAppEvent({
            type: (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).APP_CONNECT_OTP,
            payload: payload
        });
        return new Promise((resolve, reject)=>{
            this.connectOtpResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async isConnected() {
        await this.w3mFrame.frameLoadPromise;
        this.w3mFrame.events.postAppEvent({
            type: (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).APP_IS_CONNECTED,
            payload: undefined
        });
        return new Promise((resolve, reject)=>{
            this.isConnectedResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async getChainId() {
        await this.w3mFrame.frameLoadPromise;
        this.w3mFrame.events.postAppEvent({
            type: (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).APP_GET_CHAIN_ID
        });
        return new Promise((resolve, reject)=>{
            this.getChainIdResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async updateEmail(payload) {
        await this.w3mFrame.frameLoadPromise;
        (0, $d45dd643a7118621$export$794efc40d8765bc4).checkIfAllowedToTriggerEmail();
        this.w3mFrame.events.postAppEvent({
            type: (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).APP_UPDATE_EMAIL,
            payload: payload
        });
        return new Promise((resolve, reject)=>{
            this.updateEmailResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async updateEmailPrimaryOtp(payload) {
        await this.w3mFrame.frameLoadPromise;
        this.w3mFrame.events.postAppEvent({
            type: (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).APP_UPDATE_EMAIL_PRIMARY_OTP,
            payload: payload
        });
        return new Promise((resolve, reject)=>{
            this.updateEmailPrimaryOtpResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async updateEmailSecondaryOtp(payload) {
        await this.w3mFrame.frameLoadPromise;
        this.w3mFrame.events.postAppEvent({
            type: (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).APP_UPDATE_EMAIL_SECONDARY_OTP,
            payload: payload
        });
        return new Promise((resolve, reject)=>{
            this.updateEmailSecondaryOtpResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async syncTheme(payload) {
        await this.w3mFrame.frameLoadPromise;
        this.w3mFrame.events.postAppEvent({
            type: (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).APP_SYNC_THEME,
            payload: payload
        });
        return new Promise((resolve, reject)=>{
            this.syncThemeResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async syncDappData(payload) {
        await this.w3mFrame.frameLoadPromise;
        this.w3mFrame.events.postAppEvent({
            type: (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).APP_SYNC_DAPP_DATA,
            payload: payload
        });
        return new Promise((resolve, reject)=>{
            this.syncDappDataResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async connect(payload) {
        const chainId = payload?.chainId ?? this.getLastUsedChainId() ?? 1;
        await this.w3mFrame.frameLoadPromise;
        this.w3mFrame.events.postAppEvent({
            type: (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).APP_GET_USER,
            payload: {
                chainId: chainId
            }
        });
        return new Promise((resolve, reject)=>{
            this.connectResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async switchNetwork(chainId) {
        await this.w3mFrame.frameLoadPromise;
        this.w3mFrame.events.postAppEvent({
            type: (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).APP_SWITCH_NETWORK,
            payload: {
                chainId: chainId
            }
        });
        return new Promise((resolve, reject)=>{
            this.switchChainResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async disconnect() {
        await this.w3mFrame.frameLoadPromise;
        this.w3mFrame.events.postAppEvent({
            type: (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).APP_SIGN_OUT
        });
        return new Promise((resolve, reject)=>{
            this.disconnectResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    async request(req) {
        await this.w3mFrame.frameLoadPromise;
        if ((0, $7e71742c1a96e4ab$export$9975694bfb286db).GET_CHAIN_ID === req.method) return this.getLastUsedChainId();
        this.w3mFrame.events.postAppEvent({
            type: (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).APP_RPC_REQUEST,
            payload: req
        });
        return new Promise((resolve, reject)=>{
            this.rpcRequestResolver = {
                resolve: resolve,
                reject: reject
            };
        });
    }
    onRpcRequest(callback) {
        this.w3mFrame.events.onAppEvent((event)=>{
            if (event.type.includes((0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).RPC_METHOD_KEY)) callback(event);
        });
    }
    onRpcResponse(callback) {
        this.w3mFrame.events.onFrameEvent((event)=>{
            if (event.type.includes((0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).RPC_METHOD_KEY)) callback(event);
        });
    }
    onIsConnected(callback) {
        this.w3mFrame.events.onFrameEvent((event)=>{
            if (event.type === (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).FRAME_GET_USER_SUCCESS) callback();
        });
    }
    onNotConnected(callback) {
        this.w3mFrame.events.onFrameEvent((event)=>{
            if (event.type === (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).FRAME_IS_CONNECTED_ERROR) callback();
            if (event.type === (0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).FRAME_IS_CONNECTED_SUCCESS && !event.payload.isConnected) callback();
        });
    }
    onConnectEmailSuccess(event) {
        this.connectEmailResolver?.resolve(event.payload);
        this.setNewLastEmailLoginTime();
    }
    onConnectEmailError(event) {
        this.connectEmailResolver?.reject(event.payload.message);
    }
    onConnectDeviceSuccess() {
        this.connectDeviceResolver?.resolve(undefined);
    }
    onConnectDeviceError(event) {
        this.connectDeviceResolver?.reject(event.payload.message);
    }
    onConnectOtpSuccess() {
        this.connectOtpResolver?.resolve(undefined);
    }
    onConnectOtpError(event) {
        this.connectOtpResolver?.reject(event.payload.message);
    }
    onConnectSuccess(event) {
        this.setEmailLoginSuccess(event.payload.email);
        this.setLastUsedChainId(event.payload.chainId);
        this.connectResolver?.resolve(event.payload);
    }
    onConnectError(event) {
        this.connectResolver?.reject(event.payload.message);
    }
    onIsConnectedSuccess(event) {
        if (!event.payload.isConnected) this.deleteEmailLoginCache();
        this.isConnectedResolver?.resolve(event.payload);
    }
    onIsConnectedError(event) {
        this.isConnectedResolver?.reject(event.payload.message);
    }
    onGetChainIdSuccess(event) {
        this.setLastUsedChainId(event.payload.chainId);
        this.getChainIdResolver?.resolve(event.payload);
    }
    onGetChainIdError(event) {
        this.getChainIdResolver?.reject(event.payload.message);
    }
    onSignOutSuccess() {
        this.disconnectResolver?.resolve(undefined);
        this.deleteEmailLoginCache();
    }
    onSignOutError(event) {
        this.disconnectResolver?.reject(event.payload.message);
    }
    onSwitchChainSuccess(event) {
        this.setLastUsedChainId(event.payload.chainId);
        this.switchChainResolver?.resolve(event.payload);
    }
    onSwitchChainError(event) {
        this.switchChainResolver?.reject(event.payload.message);
    }
    onRpcRequestSuccess(event) {
        this.rpcRequestResolver?.resolve(event.payload);
    }
    onRpcRequestError(event) {
        this.rpcRequestResolver?.reject(event.payload.message);
    }
    onSessionUpdate(event) {
        const { payload: payload } = event;
        payload;
    }
    onUpdateEmailSuccess() {
        this.updateEmailResolver?.resolve(undefined);
        this.setNewLastEmailLoginTime();
    }
    onUpdateEmailError(event) {
        this.updateEmailResolver?.reject(event.payload.message);
    }
    onUpdateEmailPrimaryOtpSuccess() {
        this.updateEmailPrimaryOtpResolver?.resolve(undefined);
    }
    onUpdateEmailPrimaryOtpError(event) {
        this.updateEmailPrimaryOtpResolver?.reject(event.payload.message);
    }
    onUpdateEmailSecondaryOtpSuccess(event) {
        const { newEmail: newEmail } = event.payload;
        this.setEmailLoginSuccess(newEmail);
        this.updateEmailSecondaryOtpResolver?.resolve({
            newEmail: newEmail
        });
    }
    onUpdateEmailSecondaryOtpError(event) {
        this.updateEmailSecondaryOtpResolver?.reject(event.payload.message);
    }
    onSyncThemeSuccess() {
        this.syncThemeResolver?.resolve(undefined);
    }
    onSyncThemeError(event) {
        this.syncThemeResolver?.reject(event.payload.message);
    }
    onSyncDappDataSuccess() {
        this.syncDappDataResolver?.resolve(undefined);
    }
    onSyncDappDataError(event) {
        this.syncDappDataResolver?.reject(event.payload.message);
    }
    setNewLastEmailLoginTime() {
        (0, $2395d74c97ac5227$export$500c415dce2853c3).set((0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).LAST_EMAIL_LOGIN_TIME, Date.now().toString());
    }
    setEmailLoginSuccess(email) {
        (0, $2395d74c97ac5227$export$500c415dce2853c3).set((0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).EMAIL, email);
        (0, $2395d74c97ac5227$export$500c415dce2853c3).set((0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).EMAIL_LOGIN_USED_KEY, "true");
        (0, $2395d74c97ac5227$export$500c415dce2853c3).delete((0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).LAST_EMAIL_LOGIN_TIME);
    }
    deleteEmailLoginCache() {
        (0, $2395d74c97ac5227$export$500c415dce2853c3).delete((0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).EMAIL_LOGIN_USED_KEY);
        (0, $2395d74c97ac5227$export$500c415dce2853c3).delete((0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).EMAIL);
        (0, $2395d74c97ac5227$export$500c415dce2853c3).delete((0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).LAST_USED_CHAIN_KEY);
    }
    setLastUsedChainId(chainId) {
        (0, $2395d74c97ac5227$export$500c415dce2853c3).set((0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).LAST_USED_CHAIN_KEY, `${chainId}`);
    }
    getLastUsedChainId() {
        return Number((0, $2395d74c97ac5227$export$500c415dce2853c3).get((0, $7e71742c1a96e4ab$export$3ff97a7390ed49be).LAST_USED_CHAIN_KEY));
    }
}







var $f5ccfabc6934093c$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $f5ccfabc6934093c$var$OTP_LENGTH = 6;
let $f5ccfabc6934093c$export$84443566fe241bc9 = class W3mEmailOtpWidget extends (0, $b47AP.LitElement) {
    firstUpdated() {
        this.startOTPTimeout();
    }
    disconnectedCallback() {
        clearTimeout(this.OTPTimeout);
    }
    constructor(){
        super();
        this.loading = false;
        this.timeoutTimeLeft = (0, $d45dd643a7118621$export$794efc40d8765bc4).getTimeToNextEmailLogin();
        this.error = "";
        this.otp = "";
        this.email = (0, $dJjpc.RouterController).state.data?.email;
        this.emailConnector = (0, $9QkaU.ConnectorController).getEmailConnector();
    }
    render() {
        if (!this.email) throw new Error("w3m-email-otp-widget: No email provided");
        const isResendDisabled = Boolean(this.timeoutTimeLeft);
        const footerLabels = this.getFooterLabels(isResendDisabled);
        return (0, $6HMh7.html)`
      <wui-flex
        flexDirection="column"
        alignItems="center"
        .padding=${[
            "l",
            "0",
            "l",
            "0"
        ]}
        gap="l"
      >
        <wui-flex flexDirection="column" alignItems="center">
          <wui-text variant="paragraph-400" color="fg-100">Enter the code we sent to</wui-text>
          <wui-text variant="paragraph-500" color="fg-100">${this.email}</wui-text>
        </wui-flex>

        <wui-text variant="small-400" color="fg-200">The code expires in 10 minutes</wui-text>

        ${this.loading ? (0, $6HMh7.html)`<wui-loading-spinner size="xl" color="accent-100"></wui-loading-spinner>` : (0, $6HMh7.html)` <wui-flex flexDirection="column" alignItems="center" gap="xs">
              <wui-otp
                dissabled
                length="6"
                @inputChange=${this.onOtpInputChange.bind(this)}
                .otp=${this.otp}
              ></wui-otp>
              ${this.error ? (0, $6HMh7.html)`
                    <wui-text variant="small-400" align="center" color="error-100">
                      ${this.error}. Try Again
                    </wui-text>
                  ` : null}
            </wui-flex>`}

        <wui-flex alignItems="center">
          <wui-text variant="small-400" color="fg-200">${footerLabels.title}</wui-text>
          <wui-link @click=${this.onResendCode.bind(this)} .disabled=${isResendDisabled}>
            ${footerLabels.action}
          </wui-link>
        </wui-flex>
      </wui-flex>
    `;
    }
    startOTPTimeout() {
        this.timeoutTimeLeft = (0, $d45dd643a7118621$export$794efc40d8765bc4).getTimeToNextEmailLogin();
        this.OTPTimeout = setInterval(()=>{
            if (this.timeoutTimeLeft > 0) this.timeoutTimeLeft = (0, $d45dd643a7118621$export$794efc40d8765bc4).getTimeToNextEmailLogin();
            else clearInterval(this.OTPTimeout);
        }, 1000);
    }
    async onOtpInputChange(event) {
        try {
            if (!this.loading) {
                this.otp = event.detail;
                if (this.emailConnector && this.otp.length === $f5ccfabc6934093c$var$OTP_LENGTH) {
                    this.loading = true;
                    await this.onOtpSubmit?.(this.otp);
                }
            }
        } catch (error) {
            this.error = (0, $kGR8V.CoreHelperUtil).parseError(error);
            this.loading = false;
        }
    }
    async onResendCode() {
        try {
            if (this.onOtpResend) {
                if (!this.loading && !this.timeoutTimeLeft) {
                    this.error = "";
                    this.otp = "";
                    const emailConnector = (0, $9QkaU.ConnectorController).getEmailConnector();
                    if (!emailConnector || !this.email) throw new Error("w3m-email-otp-widget: Unable to resend email");
                    this.loading = true;
                    await this.onOtpResend(this.email);
                    this.startOTPTimeout();
                    (0, $9fh1I.SnackController).showSuccess("Code email resent");
                }
            } else if (this.onStartOver) this.onStartOver();
        } catch (error) {
            (0, $9fh1I.SnackController).showError(error);
        } finally{
            this.loading = false;
        }
    }
    getFooterLabels(isResendDisabled) {
        if (this.onStartOver) return {
            title: "Something wrong?",
            action: `Try again ${isResendDisabled ? `in ${this.timeoutTimeLeft}s` : ""}`
        };
        return {
            title: `Didn't receive it?`,
            action: `Resend ${isResendDisabled ? `in ${this.timeoutTimeLeft}s` : "Code"}`
        };
    }
};
$f5ccfabc6934093c$export$84443566fe241bc9.styles = (0, $396add6f7055054b$export$2e2bcd8739ae039);
$f5ccfabc6934093c$var$__decorate([
    (0, $6eT5F.state)()
], $f5ccfabc6934093c$export$84443566fe241bc9.prototype, "loading", void 0);
$f5ccfabc6934093c$var$__decorate([
    (0, $6eT5F.state)()
], $f5ccfabc6934093c$export$84443566fe241bc9.prototype, "timeoutTimeLeft", void 0);
$f5ccfabc6934093c$var$__decorate([
    (0, $6eT5F.state)()
], $f5ccfabc6934093c$export$84443566fe241bc9.prototype, "error", void 0);
$f5ccfabc6934093c$export$84443566fe241bc9 = $f5ccfabc6934093c$var$__decorate([
    (0, $lkv4o.customElement)("w3m-email-otp-widget")
], $f5ccfabc6934093c$export$84443566fe241bc9);


parcelRequire("aAJP9");
var $jJO2B = parcelRequire("jJO2B");
var $6n0eX = parcelRequire("6n0eX");
var $bnxqc = parcelRequire("bnxqc");
var $820754961a7169b8$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $820754961a7169b8$export$cf0da95883710edd = class W3mEmailVerifyOtpView extends (0, $f5ccfabc6934093c$export$84443566fe241bc9) {
    constructor(){
        super();
        this.onOtpSubmit = async (otp)=>{
            try {
                if (this.emailConnector) {
                    await this.emailConnector.provider.connectOtp({
                        otp: otp
                    });
                    (0, $6n0eX.EventsController).sendEvent({
                        type: "track",
                        event: "EMAIL_VERIFICATION_CODE_PASS"
                    });
                    await (0, $jJO2B.ConnectionController).connectExternal(this.emailConnector);
                    (0, $bnxqc.ModalController).close();
                    (0, $6n0eX.EventsController).sendEvent({
                        type: "track",
                        event: "CONNECT_SUCCESS",
                        properties: {
                            method: "email"
                        }
                    });
                }
            } catch (error) {
                (0, $6n0eX.EventsController).sendEvent({
                    type: "track",
                    event: "EMAIL_VERIFICATION_CODE_FAIL"
                });
                throw error;
            }
        };
        this.onOtpResend = async (email)=>{
            if (this.emailConnector) {
                await this.emailConnector.provider.connectEmail({
                    email: email
                });
                (0, $6n0eX.EventsController).sendEvent({
                    type: "track",
                    event: "EMAIL_VERIFICATION_CODE_SENT"
                });
            }
        };
    }
};
$820754961a7169b8$export$cf0da95883710edd = $820754961a7169b8$var$__decorate([
    (0, $lkv4o.customElement)("w3m-email-verify-otp-view")
], $820754961a7169b8$export$cf0da95883710edd);


parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("5bcND");
var $kq2WI = parcelRequire("kq2WI");
var $ae3da90142e221cb$export$2e2bcd8739ae039 = (0, $kq2WI.css)`
  wui-icon-box {
    height: var(--wui-icon-box-size-xl);
    width: var(--wui-icon-box-size-xl);
  }
`;


parcelRequire("aAJP9");
var $9QkaU = parcelRequire("9QkaU");
var $6n0eX = parcelRequire("6n0eX");
var $dJjpc = parcelRequire("dJjpc");
var $9fh1I = parcelRequire("9fh1I");
parcelRequire("hrpLR");
var $6eT5F = parcelRequire("6eT5F");
var $20efb53c8e200360$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $20efb53c8e200360$export$442e575aa1acbb10 = class W3mEmailVerifyDeviceView extends (0, $b47AP.LitElement) {
    constructor(){
        super();
        this.email = (0, $dJjpc.RouterController).state.data?.email;
        this.emailConnector = (0, $9QkaU.ConnectorController).getEmailConnector();
        this.loading = false;
        this.listenForDeviceApproval();
    }
    render() {
        if (!this.email) throw new Error("w3m-email-verify-device-view: No email provided");
        if (!this.emailConnector) throw new Error("w3m-email-verify-device-view: No email connector provided");
        return (0, $6HMh7.html)`
      <wui-flex
        flexDirection="column"
        alignItems="center"
        .padding=${[
            "xxl",
            "s",
            "xxl",
            "s"
        ]}
        gap="l"
      >
        <wui-icon-box
          size="xl"
          iconcolor="accent-100"
          backgroundcolor="accent-100"
          icon="verify"
          background="opaque"
        ></wui-icon-box>

        <wui-flex flexDirection="column" alignItems="center" gap="s">
          <wui-flex flexDirection="column" alignItems="center">
            <wui-text variant="paragraph-400" color="fg-100">
              Approve the login link we sent to
            </wui-text>
            <wui-text variant="paragraph-400" color="fg-100"><b>${this.email}</b></wui-text>
          </wui-flex>

          <wui-text variant="small-400" color="fg-200" align="center">
            The code expires in 10 minutes
          </wui-text>

          <wui-flex alignItems="center" id="w3m-resend-section">
            <wui-text variant="small-400" color="fg-100" align="center">
              Didn't receive it?
            </wui-text>
            <wui-link @click=${this.onResendCode.bind(this)} .disabled=${this.loading}>
              Resend email
            </wui-link>
          </wui-flex>
        </wui-flex>
      </wui-flex>
    `;
    }
    async listenForDeviceApproval() {
        if (this.emailConnector) try {
            await this.emailConnector.provider.connectDevice();
            (0, $6n0eX.EventsController).sendEvent({
                type: "track",
                event: "DEVICE_REGISTERED_FOR_EMAIL"
            });
            (0, $6n0eX.EventsController).sendEvent({
                type: "track",
                event: "EMAIL_VERIFICATION_CODE_SENT"
            });
            (0, $dJjpc.RouterController).replace("EmailVerifyOtp", {
                email: this.email
            });
        } catch (error) {
            (0, $dJjpc.RouterController).goBack();
        }
    }
    async onResendCode() {
        try {
            if (!this.loading) {
                if (!this.emailConnector || !this.email) throw new Error("w3m-email-login-widget: Unable to resend email");
                this.loading = true;
                await this.emailConnector.provider.connectEmail({
                    email: this.email
                });
                (0, $9fh1I.SnackController).showSuccess("Code email resent");
            }
        } catch (error) {
            (0, $9fh1I.SnackController).showError(error);
        } finally{
            this.loading = false;
        }
    }
};
$20efb53c8e200360$export$442e575aa1acbb10.styles = (0, $ae3da90142e221cb$export$2e2bcd8739ae039);
$20efb53c8e200360$var$__decorate([
    (0, $6eT5F.state)()
], $20efb53c8e200360$export$442e575aa1acbb10.prototype, "loading", void 0);
$20efb53c8e200360$export$442e575aa1acbb10 = $20efb53c8e200360$var$__decorate([
    (0, $lkv4o.customElement)("w3m-email-verify-device-view")
], $20efb53c8e200360$export$442e575aa1acbb10);


parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $6eT5F = parcelRequire("6eT5F");
parcelRequire("5bcND");
var $kq2WI = parcelRequire("kq2WI");
var $5974a7d7a39394b7$export$2e2bcd8739ae039 = (0, $kq2WI.css)`
  div {
    width: 100%;
    height: 400px;
  }

  [data-ready='false'] {
    transform: scale(1.05);
  }

  @media (max-width: 430px) {
    [data-ready='false'] {
      transform: translateY(-50px);
    }
  }
`;


parcelRequire("aAJP9");
var $9QkaU = parcelRequire("9QkaU");
var $bnxqc = parcelRequire("bnxqc");
var $fyCFg = parcelRequire("fyCFg");
var $b46cc35c1673aaa0$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $b46cc35c1673aaa0$export$ab9ab0bd09f8f225 = class W3mApproveTransactionView extends (0, $b47AP.LitElement) {
    constructor(){
        super();
        this.bodyObserver = undefined;
        this.unsubscribe = [];
        this.iframe = document.getElementById("w3m-iframe");
        this.ready = false;
        this.unsubscribe.push((0, $bnxqc.ModalController).subscribeKey("open", (val)=>{
            if (!val) this.onHideIframe();
        }));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
        this.bodyObserver?.unobserve(window.document.body);
    }
    async firstUpdated() {
        const verticalPadding = 10;
        await this.syncTheme();
        this.iframe.style.display = "block";
        const blueprint = this.renderRoot.querySelector("div");
        this.bodyObserver = new ResizeObserver(()=>{
            const data = blueprint?.getBoundingClientRect();
            const dimensions = data ?? {
                left: 0,
                top: 0,
                width: 0,
                height: 0
            };
            this.iframe.style.width = `${dimensions.width}px`;
            this.iframe.style.height = `${dimensions.height - verticalPadding}px`;
            this.iframe.style.left = `${dimensions.left}px`;
            this.iframe.style.top = `${dimensions.top + verticalPadding / 2}px`;
            this.ready = true;
        });
        this.bodyObserver.observe(window.document.body);
    }
    render() {
        if (this.ready) this.onShowIframe();
        return (0, $6HMh7.html)`<div data-ready=${this.ready}></div>`;
    }
    onShowIframe() {
        const isMobile = window.innerWidth <= 430;
        this.iframe.animate([
            {
                opacity: 0,
                transform: isMobile ? "translateY(50px)" : "scale(.95)"
            },
            {
                opacity: 1,
                transform: isMobile ? "translateY(0)" : "scale(1)"
            }
        ], {
            duration: 200,
            easing: "ease",
            fill: "forwards",
            delay: 300
        });
    }
    async onHideIframe() {
        await this.iframe.animate([
            {
                opacity: 1
            },
            {
                opacity: 0
            }
        ], {
            duration: 200,
            easing: "ease",
            fill: "forwards"
        }).finished;
        this.iframe.style.display = "none";
    }
    async syncTheme() {
        const emailConnector = (0, $9QkaU.ConnectorController).getEmailConnector();
        if (emailConnector) await emailConnector.provider.syncTheme({
            themeVariables: (0, $fyCFg.ThemeController).getSnapshot().themeVariables
        });
    }
};
$b46cc35c1673aaa0$export$ab9ab0bd09f8f225.styles = (0, $5974a7d7a39394b7$export$2e2bcd8739ae039);
$b46cc35c1673aaa0$var$__decorate([
    (0, $6eT5F.state)()
], $b46cc35c1673aaa0$export$ab9ab0bd09f8f225.prototype, "ready", void 0);
$b46cc35c1673aaa0$export$ab9ab0bd09f8f225 = $b46cc35c1673aaa0$var$__decorate([
    (0, $lkv4o.customElement)("w3m-approve-transaction-view")
], $b46cc35c1673aaa0$export$ab9ab0bd09f8f225);


parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("aAJP9");
var $5S5Lx = parcelRequire("5S5Lx");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
var $ccf952858f9fcb49$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $ccf952858f9fcb49$export$a1f0d947f01e8672 = class W3mUpgradeWalletView extends (0, $b47AP.LitElement) {
    render() {
        return (0, $6HMh7.html)`
      <wui-flex flexDirection="column" alignItems="center" gap="xl" padding="xl">
        <wui-text variant="paragraph-400" color="fg-100">Follow the instructions on</wui-text>
        <wui-chip
          icon="externalLink"
          variant="fill"
          href=${(0, $5S5Lx.ConstantsUtil).SECURE_SITE_DASHBOARD}
          imageSrc=${(0, $5S5Lx.ConstantsUtil).SECURE_SITE_FAVICON}
        >
        </wui-chip>
        <wui-text variant="small-400" color="fg-200">
          You will have to reconnect for security reasons
        </wui-text>
      </wui-flex>
    `;
    }
};
$ccf952858f9fcb49$export$a1f0d947f01e8672 = $ccf952858f9fcb49$var$__decorate([
    (0, $lkv4o.customElement)("w3m-upgrade-wallet-view")
], $ccf952858f9fcb49$export$a1f0d947f01e8672);


parcelRequire("aAJP9");
var $9QkaU = parcelRequire("9QkaU");
var $6n0eX = parcelRequire("6n0eX");
var $dJjpc = parcelRequire("dJjpc");
var $9fh1I = parcelRequire("9fh1I");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $6eT5F = parcelRequire("6eT5F");

var $6HMh7 = parcelRequire("6HMh7");

var $6HMh7 = parcelRequire("6HMh7");
/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { I: $a4340dac41b25b5e$var$et } = (0, $6HMh7._$LH), $a4340dac41b25b5e$export$c3825b437cbdea5c = (o)=>null === o || "object" != typeof o && "function" != typeof o, $a4340dac41b25b5e$export$80c36ae3cab9881d = {
    HTML: 1,
    SVG: 2,
    MATHML: 3
}, $a4340dac41b25b5e$export$6b6d145ec2a44ca9 = (o, t)=>void 0 === t ? void 0 !== o?._$litType$ : o?._$litType$ === t, $a4340dac41b25b5e$export$6a0e8de894d2fcca = (o)=>null != o?._$litType$?.h, $a4340dac41b25b5e$export$2f448fec17d50a3e = (o)=>void 0 !== o?._$litDirective$, $a4340dac41b25b5e$export$f28e31de6a6eaf32 = (o)=>o?._$litDirective$, $a4340dac41b25b5e$export$7f431ad0fff82fd9 = (o)=>void 0 === o.strings, $a4340dac41b25b5e$var$lt = ()=>document.createComment(""), $a4340dac41b25b5e$export$291b2338ad9b0b30 = (o, t, i)=>{
    const n = o._$AA.parentNode, e = void 0 === t ? o._$AB : t._$AA;
    if (void 0 === i) {
        const t = n.insertBefore($a4340dac41b25b5e$var$lt(), e), l = n.insertBefore($a4340dac41b25b5e$var$lt(), e);
        i = new $a4340dac41b25b5e$var$et(t, l, o, o.options);
    } else {
        const t = i._$AB.nextSibling, l = i._$AM, c = l !== o;
        if (c) {
            let t;
            i._$AQ?.(o), i._$AM = o, void 0 !== i._$AP && (t = o._$AU) !== l._$AU && i._$AP(t);
        }
        if (t !== e || c) {
            let o = i._$AA;
            for(; o !== t;){
                const t = o.nextSibling;
                n.insertBefore(o, e), o = t;
            }
        }
    }
    return i;
}, $a4340dac41b25b5e$export$cb8bf9562088e9f4 = (o, t, i = o)=>(o._$AI(t, i), o), $a4340dac41b25b5e$var$ht = {}, $a4340dac41b25b5e$export$ea70d9dd5965b1c8 = (o, t = $a4340dac41b25b5e$var$ht)=>o._$AH = t, $a4340dac41b25b5e$export$59e9bce518cde500 = (o)=>o._$AH, $a4340dac41b25b5e$export$3133b3144bbba267 = (o)=>{
    o._$AP?.(!1, !0);
    let t = o._$AA;
    const i = o._$AB.nextSibling;
    for(; t !== i;){
        const o = t.nextSibling;
        t.remove(), t = o;
    }
}, $a4340dac41b25b5e$export$7f600b8138c094dc = (o)=>{
    o._$AR();
};


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $f71467b00a0505c8$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $f71467b00a0505c8$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $f71467b00a0505c8$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this.t = t, this._$AM = e, this.i = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $eaf36f4a4eb7b701$var$mt = (i, t)=>{
    const e = i._$AN;
    if (void 0 === e) return !1;
    for (const i of e)i._$AO?.(t, !1), $eaf36f4a4eb7b701$var$mt(i, t);
    return !0;
}, $eaf36f4a4eb7b701$var$_t = (i)=>{
    let t, e;
    do {
        if (void 0 === (t = i._$AM)) break;
        e = t._$AN, e.delete(i), i = t;
    }while (0 === e?.size);
}, $eaf36f4a4eb7b701$var$wt = (i)=>{
    for(let t; t = i._$AM; i = t){
        let e = t._$AN;
        if (void 0 === e) t._$AN = e = new Set;
        else if (e.has(i)) break;
        e.add(i), $eaf36f4a4eb7b701$var$gt(t);
    }
};
function $eaf36f4a4eb7b701$var$bt(i) {
    void 0 !== this._$AN ? ($eaf36f4a4eb7b701$var$_t(this), this._$AM = i, $eaf36f4a4eb7b701$var$wt(this)) : this._$AM = i;
}
function $eaf36f4a4eb7b701$var$yt(i, t = !1, e = 0) {
    const s = this._$AH, o = this._$AN;
    if (void 0 !== o && 0 !== o.size) {
        if (t) {
            if (Array.isArray(s)) for(let i = e; i < s.length; i++)$eaf36f4a4eb7b701$var$mt(s[i], !1), $eaf36f4a4eb7b701$var$_t(s[i]);
            else null != s && ($eaf36f4a4eb7b701$var$mt(s, !1), $eaf36f4a4eb7b701$var$_t(s));
        } else $eaf36f4a4eb7b701$var$mt(this, i);
    }
}
const $eaf36f4a4eb7b701$var$gt = (i)=>{
    i.type == (0, $f71467b00a0505c8$export$9ba3b3f20a85bfa).CHILD && (i._$AP ??= $eaf36f4a4eb7b701$var$yt, i._$AQ ??= $eaf36f4a4eb7b701$var$bt);
};
class $eaf36f4a4eb7b701$export$7d025501802325e extends (0, $f71467b00a0505c8$export$befdefbdce210f91) {
    constructor(){
        super(...arguments), this._$AN = void 0;
    }
    _$AT(i, t, e) {
        super._$AT(i, t, e), $eaf36f4a4eb7b701$var$wt(this), this.isConnected = i._$AU;
    }
    _$AO(i, t = !0) {
        i !== this.isConnected && (this.isConnected = i, i ? this.reconnected?.() : this.disconnected?.()), t && ($eaf36f4a4eb7b701$var$mt(this, i), $eaf36f4a4eb7b701$var$_t(this));
    }
    setValue(i) {
        if ((0, $a4340dac41b25b5e$export$7f431ad0fff82fd9)(this.t)) this.t._$AI(i, this);
        else {
            const t = [
                ...this.t._$AH
            ];
            t[this.i] = i, this.t._$AI(t, this, 0);
        }
    }
    disconnected() {}
    reconnected() {}
}



/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $37eb883020040ad0$export$7d1e3a5e95ceca43 = ()=>new $37eb883020040ad0$var$Zt;
class $37eb883020040ad0$var$Zt {
}
const $37eb883020040ad0$var$qt = new WeakMap, $37eb883020040ad0$export$eff4d24c3ff7876e = (0, $f71467b00a0505c8$export$99b43ad1ed32e735)(class extends (0, $eaf36f4a4eb7b701$export$7d025501802325e) {
    render(t) {
        return 0, $6HMh7.nothing;
    }
    update(t, [i]) {
        const s = i !== this.Y;
        return s && void 0 !== this.Y && this.rt(void 0), (s || this.lt !== this.ct) && (this.Y = i, this.ht = t.options?.host, this.rt(this.ct = t.element)), $6HMh7.nothing;
    }
    rt(t) {
        if (this.isConnected || (t = void 0), "function" == typeof this.Y) {
            const i = this.ht ?? globalThis;
            let s = $37eb883020040ad0$var$qt.get(i);
            void 0 === s && (s = new WeakMap, $37eb883020040ad0$var$qt.set(i, s)), void 0 !== s.get(this.Y) && this.Y.call(this.ht, void 0), s.set(this.Y, t), void 0 !== t && this.Y.call(this.ht, t);
        } else this.Y.value = t;
    }
    get lt() {
        return "function" == typeof this.Y ? $37eb883020040ad0$var$qt.get(this.ht ?? globalThis)?.get(this.Y) : this.Y?.value;
    }
    disconnected() {
        this.lt === this.ct && this.rt(void 0);
    }
    reconnected() {
        this.rt(this.ct);
    }
});




parcelRequire("5bcND");
var $kq2WI = parcelRequire("kq2WI");
var $7e2b4be992ddf3ce$export$2e2bcd8739ae039 = (0, $kq2WI.css)`
  wui-email-input {
    width: 100%;
  }

  form {
    width: 100%;
    display: block;
    position: relative;
  }
`;


var $8ebc7d129ddfd45a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $8ebc7d129ddfd45a$export$6814d6aff4948a0 = class W3mUpdateEmailWalletView extends (0, $b47AP.LitElement) {
    constructor(){
        super(...arguments);
        this.formRef = (0, $37eb883020040ad0$export$7d1e3a5e95ceca43)();
        this.initialEmail = (0, $dJjpc.RouterController).state.data?.email ?? "";
        this.email = "";
        this.loading = false;
    }
    firstUpdated() {
        this.formRef.value?.addEventListener("keydown", (event)=>{
            if (event.key === "Enter") this.onSubmitEmail(event);
        });
    }
    render() {
        const showSubmit = !this.loading && this.email.length > 3 && this.email !== this.initialEmail;
        return (0, $6HMh7.html)`
      <wui-flex flexDirection="column" padding="m" gap="m">
        <form ${(0, $37eb883020040ad0$export$eff4d24c3ff7876e)(this.formRef)} @submit=${this.onSubmitEmail.bind(this)}>
          <wui-email-input
            value=${this.initialEmail}
            .disabled=${this.loading}
            @inputChange=${this.onEmailInputChange.bind(this)}
          >
          </wui-email-input>
          <input type="submit" hidden />
        </form>

        <wui-flex gap="s">
          <wui-button size="md" variant="shade" fullWidth @click=${(0, $dJjpc.RouterController).goBack}>
            Cancel
          </wui-button>

          <wui-button
            size="md"
            variant="fill"
            fullWidth
            @click=${this.onSubmitEmail.bind(this)}
            .disabled=${!showSubmit}
            .loading=${this.loading}
          >
            Save
          </wui-button>
        </wui-flex>
      </wui-flex>
    `;
    }
    onEmailInputChange(event) {
        this.email = event.detail;
    }
    async onSubmitEmail(event) {
        try {
            if (this.loading) return;
            this.loading = true;
            event.preventDefault();
            const emailConnector = (0, $9QkaU.ConnectorController).getEmailConnector();
            if (!emailConnector) throw new Error("w3m-update-email-wallet: Email connector not found");
            await emailConnector.provider.updateEmail({
                email: this.email
            });
            (0, $6n0eX.EventsController).sendEvent({
                type: "track",
                event: "EMAIL_EDIT"
            });
            (0, $dJjpc.RouterController).replace("UpdateEmailPrimaryOtp", {
                email: this.initialEmail,
                newEmail: this.email
            });
        } catch (error) {
            (0, $9fh1I.SnackController).showError(error);
            this.loading = false;
        }
    }
};
$8ebc7d129ddfd45a$export$6814d6aff4948a0.styles = (0, $7e2b4be992ddf3ce$export$2e2bcd8739ae039);
$8ebc7d129ddfd45a$var$__decorate([
    (0, $6eT5F.state)()
], $8ebc7d129ddfd45a$export$6814d6aff4948a0.prototype, "email", void 0);
$8ebc7d129ddfd45a$var$__decorate([
    (0, $6eT5F.state)()
], $8ebc7d129ddfd45a$export$6814d6aff4948a0.prototype, "loading", void 0);
$8ebc7d129ddfd45a$export$6814d6aff4948a0 = $8ebc7d129ddfd45a$var$__decorate([
    (0, $lkv4o.customElement)("w3m-update-email-wallet-view")
], $8ebc7d129ddfd45a$export$6814d6aff4948a0);


parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");

parcelRequire("aAJP9");
var $6n0eX = parcelRequire("6n0eX");
var $dJjpc = parcelRequire("dJjpc");
var $65e78cc8900cd6ae$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $65e78cc8900cd6ae$export$f089084b6501bc5 = class W3mUpdateEmailPrimaryOtpView extends (0, $f5ccfabc6934093c$export$84443566fe241bc9) {
    constructor(){
        super();
        this.email = (0, $dJjpc.RouterController).state.data?.email;
        this.onOtpSubmit = async (otp)=>{
            try {
                if (this.emailConnector) {
                    await this.emailConnector.provider.updateEmailPrimaryOtp({
                        otp: otp
                    });
                    (0, $6n0eX.EventsController).sendEvent({
                        type: "track",
                        event: "EMAIL_VERIFICATION_CODE_PASS"
                    });
                    (0, $dJjpc.RouterController).replace("UpdateEmailSecondaryOtp", (0, $dJjpc.RouterController).state.data);
                }
            } catch (error) {
                (0, $6n0eX.EventsController).sendEvent({
                    type: "track",
                    event: "EMAIL_VERIFICATION_CODE_FAIL"
                });
                throw error;
            }
        };
        this.onStartOver = ()=>{
            (0, $dJjpc.RouterController).replace("UpdateEmailWallet", (0, $dJjpc.RouterController).state.data);
        };
    }
};
$65e78cc8900cd6ae$export$f089084b6501bc5 = $65e78cc8900cd6ae$var$__decorate([
    (0, $lkv4o.customElement)("w3m-update-email-primary-otp-view")
], $65e78cc8900cd6ae$export$f089084b6501bc5);


parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");

parcelRequire("aAJP9");
var $6n0eX = parcelRequire("6n0eX");
var $dJjpc = parcelRequire("dJjpc");
var $758f0e6ae93cd0f2$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $758f0e6ae93cd0f2$export$627b68ac942cb0d6 = class W3mUpdateEmailSecondaryOtpView extends (0, $f5ccfabc6934093c$export$84443566fe241bc9) {
    constructor(){
        super();
        this.email = (0, $dJjpc.RouterController).state.data?.newEmail;
        this.onOtpSubmit = async (otp)=>{
            try {
                if (this.emailConnector) {
                    await this.emailConnector.provider.updateEmailSecondaryOtp({
                        otp: otp
                    });
                    (0, $6n0eX.EventsController).sendEvent({
                        type: "track",
                        event: "EMAIL_VERIFICATION_CODE_PASS"
                    });
                    (0, $dJjpc.RouterController).reset("Account");
                }
            } catch (error) {
                (0, $6n0eX.EventsController).sendEvent({
                    type: "track",
                    event: "EMAIL_VERIFICATION_CODE_FAIL"
                });
                throw error;
            }
        };
        this.onStartOver = ()=>{
            (0, $dJjpc.RouterController).replace("UpdateEmailWallet", (0, $dJjpc.RouterController).state.data);
        };
    }
};
$758f0e6ae93cd0f2$export$627b68ac942cb0d6 = $758f0e6ae93cd0f2$var$__decorate([
    (0, $lkv4o.customElement)("w3m-update-email-secondary-otp-view")
], $758f0e6ae93cd0f2$export$627b68ac942cb0d6);


parcelRequire("aAJP9");
var $5mrMQ = parcelRequire("5mrMQ");
var $7XY6i = parcelRequire("7XY6i");
var $jJO2B = parcelRequire("jJO2B");
var $kGR8V = parcelRequire("kGR8V");
var $6n0eX = parcelRequire("6n0eX");
var $bnxqc = parcelRequire("bnxqc");
var $b6tQF = parcelRequire("b6tQF");
var $dJjpc = parcelRequire("dJjpc");
var $49HpJ = parcelRequire("49HpJ");
var $9fh1I = parcelRequire("9fh1I");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $6eT5F = parcelRequire("6eT5F");

parcelRequire("5bcND");
var $kq2WI = parcelRequire("kq2WI");
var $8375e9c277fe1b14$export$2e2bcd8739ae039 = (0, $kq2WI.css)`
  :host > wui-flex {
    max-height: clamp(360px, 540px, 80vh);
    overflow: scroll;
    scrollbar-width: none;
  }

  :host > wui-flex::-webkit-scrollbar {
    display: none;
  }
`;


var $530c157e826d4e1e$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $530c157e826d4e1e$export$db1b0c4a50057bc8 = class W3mUnsupportedChainView extends (0, $b47AP.LitElement) {
    constructor(){
        super(...arguments);
        this.disconecting = false;
    }
    render() {
        return (0, $6HMh7.html)`
      <wui-flex class="container" flexDirection="column" gap="0">
        <wui-flex
          class="container"
          flexDirection="column"
          .padding=${[
            "m",
            "xl",
            "xs",
            "xl"
        ]}
          alignItems="center"
          gap="xl"
        >
          <wui-text variant="small-400" color="fg-200" align="center">
            This app doesn’t support your current network. Switch to an available option following
            to continue.
          </wui-text>
        </wui-flex>

        <wui-flex flexDirection="column" padding="s" gap="xs">
          ${this.networksTemplate()}
        </wui-flex>

        <wui-separator text="or"></wui-separator>
        <wui-flex flexDirection="column" padding="s" gap="xs">
          <wui-list-item
            variant="icon"
            iconVariant="overlay"
            icon="disconnect"
            ?chevron=${false}
            .loading=${this.disconecting}
            @click=${this.onDisconnect.bind(this)}
            data-testid="disconnect-button"
          >
            <wui-text variant="paragraph-500" color="fg-200">Disconnect</wui-text>
          </wui-list-item>
        </wui-flex>
      </wui-flex>
    `;
    }
    networksTemplate() {
        const { approvedCaipNetworkIds: approvedCaipNetworkIds, requestedCaipNetworks: requestedCaipNetworks } = (0, $b6tQF.NetworkController).state;
        const sortedNetworks = (0, $kGR8V.CoreHelperUtil).sortRequestedNetworks(approvedCaipNetworkIds, requestedCaipNetworks);
        return sortedNetworks.map((network)=>(0, $6HMh7.html)`
        <wui-list-network
          imageSrc=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)((0, $7XY6i.AssetUtil).getNetworkImage(network))}
          name=${network.name ?? "Unknown"}
          @click=${()=>this.onSwitchNetwork(network)}
        >
        </wui-list-network>
      `);
    }
    async onDisconnect() {
        try {
            this.disconecting = true;
            await (0, $jJO2B.ConnectionController).disconnect();
            (0, $6n0eX.EventsController).sendEvent({
                type: "track",
                event: "DISCONNECT_SUCCESS"
            });
            (0, $bnxqc.ModalController).close();
        } catch  {
            (0, $6n0eX.EventsController).sendEvent({
                type: "track",
                event: "DISCONNECT_ERROR"
            });
            (0, $9fh1I.SnackController).showError("Failed to disconnect");
        } finally{
            this.disconecting = false;
        }
    }
    async onSwitchNetwork(network) {
        const { isConnected: isConnected } = (0, $5mrMQ.AccountController).state;
        const { approvedCaipNetworkIds: approvedCaipNetworkIds, supportsAllNetworks: supportsAllNetworks, caipNetwork: caipNetwork } = (0, $b6tQF.NetworkController).state;
        const { data: data } = (0, $dJjpc.RouterController).state;
        if (isConnected && caipNetwork?.id !== network.id) {
            if (approvedCaipNetworkIds?.includes(network.id)) {
                await (0, $b6tQF.NetworkController).switchActiveNetwork(network);
                (0, $49HpJ.RouterUtil).navigateAfterNetworkSwitch();
            } else if (supportsAllNetworks) (0, $dJjpc.RouterController).push("SwitchNetwork", {
                ...data,
                network: network
            });
        } else if (!isConnected) {
            (0, $b6tQF.NetworkController).setCaipNetwork(network);
            (0, $dJjpc.RouterController).push("Connect");
        }
    }
};
$530c157e826d4e1e$export$db1b0c4a50057bc8.styles = (0, $8375e9c277fe1b14$export$2e2bcd8739ae039);
$530c157e826d4e1e$var$__decorate([
    (0, $6eT5F.state)()
], $530c157e826d4e1e$export$db1b0c4a50057bc8.prototype, "disconecting", void 0);
$530c157e826d4e1e$export$db1b0c4a50057bc8 = $530c157e826d4e1e$var$__decorate([
    (0, $lkv4o.customElement)("w3m-unsupported-chain-view")
], $530c157e826d4e1e$export$db1b0c4a50057bc8);


parcelRequire("aAJP9");
var $6tAXH = parcelRequire("6tAXH");
var $7XY6i = parcelRequire("7XY6i");
var $9QkaU = parcelRequire("9QkaU");
var $dJjpc = parcelRequire("dJjpc");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $6eT5F = parcelRequire("6eT5F");

parcelRequire("5bcND");
var $kq2WI = parcelRequire("kq2WI");
var $b2920975a665833a$export$2e2bcd8739ae039 = (0, $kq2WI.css)`
  wui-grid {
    max-height: clamp(360px, 400px, 80vh);
    overflow: scroll;
    scrollbar-width: none;
    grid-auto-rows: min-content;
    grid-template-columns: repeat(auto-fill, 76px);
  }

  @media (max-width: 435px) {
    wui-grid {
      grid-template-columns: repeat(auto-fill, 77px);
    }
  }

  wui-grid[data-scroll='false'] {
    overflow: hidden;
  }

  wui-grid::-webkit-scrollbar {
    display: none;
  }

  wui-loading-spinner {
    padding-top: var(--wui-spacing-l);
    padding-bottom: var(--wui-spacing-l);
    justify-content: center;
    grid-column: 1 / span 4;
  }
`;


parcelRequire("aAJP9");
var $9QkaU = parcelRequire("9QkaU");
function $2bd8917fbb32b1a9$export$cffc81df24a1f1f1(wallets) {
    const { connectors: connectors } = (0, $9QkaU.ConnectorController).state;
    const installedConnectors = connectors.filter((c)=>c.type === "ANNOUNCED").reduce((acum, val)=>{
        if (!val.info?.rdns) return acum;
        acum[val.info.rdns] = true;
        return acum;
    }, {});
    const walletsWithInstalled = wallets.map((wallet)=>({
            ...wallet,
            installed: Boolean(wallet.rdns) && Boolean(installedConnectors[wallet.rdns ?? ""])
        }));
    const sortedWallets = walletsWithInstalled.sort((a, b)=>Number(b.installed) - Number(a.installed));
    return sortedWallets;
}


var $01e3b12b3c634204$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $01e3b12b3c634204$var$PAGINATOR_ID = "local-paginator";
let $01e3b12b3c634204$export$f39175f9037ce7d2 = class W3mAllWalletsList extends (0, $b47AP.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.paginationObserver = undefined;
        this.initial = !(0, $6tAXH.ApiController).state.wallets.length;
        this.wallets = (0, $6tAXH.ApiController).state.wallets;
        this.recommended = (0, $6tAXH.ApiController).state.recommended;
        this.featured = (0, $6tAXH.ApiController).state.featured;
        this.unsubscribe.push(...[
            (0, $6tAXH.ApiController).subscribeKey("wallets", (val)=>this.wallets = val),
            (0, $6tAXH.ApiController).subscribeKey("recommended", (val)=>this.recommended = val),
            (0, $6tAXH.ApiController).subscribeKey("featured", (val)=>this.featured = val)
        ]);
    }
    firstUpdated() {
        this.initialFetch();
        this.createPaginationObserver();
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
        this.paginationObserver?.disconnect();
    }
    render() {
        return (0, $6HMh7.html)`
      <wui-grid
        data-scroll=${!this.initial}
        .padding=${[
            "0",
            "s",
            "s",
            "s"
        ]}
        columnGap="xxs"
        rowGap="l"
        justifyContent="space-between"
      >
        ${this.initial ? this.shimmerTemplate(16) : this.walletsTemplate()}
        ${this.paginationLoaderTemplate()}
      </wui-grid>
    `;
    }
    async initialFetch() {
        const gridEl = this.shadowRoot?.querySelector("wui-grid");
        if (this.initial && gridEl) {
            await (0, $6tAXH.ApiController).fetchWallets({
                page: 1
            });
            await gridEl.animate([
                {
                    opacity: 1
                },
                {
                    opacity: 0
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            }).finished;
            this.initial = false;
            gridEl.animate([
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            });
        }
    }
    shimmerTemplate(items, id) {
        return [
            ...Array(items)
        ].map(()=>(0, $6HMh7.html)`
        <wui-card-select-loader type="wallet" id=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)(id)}></wui-card-select-loader>
      `);
    }
    walletsTemplate() {
        const wallets = [
            ...this.featured,
            ...this.recommended,
            ...this.wallets
        ];
        const walletsWithInstalled = (0, $2bd8917fbb32b1a9$export$cffc81df24a1f1f1)(wallets);
        return walletsWithInstalled.map((wallet)=>(0, $6HMh7.html)`
        <wui-card-select
          imageSrc=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)((0, $7XY6i.AssetUtil).getWalletImage(wallet))}
          type="wallet"
          name=${wallet.name}
          @click=${()=>this.onConnectWallet(wallet)}
          .installed=${wallet.installed}
        ></wui-card-select>
      `);
    }
    paginationLoaderTemplate() {
        const { wallets: wallets, recommended: recommended, featured: featured, count: count } = (0, $6tAXH.ApiController).state;
        const columns = window.innerWidth < 352 ? 3 : 4;
        const currentWallets = wallets.length + recommended.length;
        const minimumRows = Math.ceil(currentWallets / columns);
        let shimmerCount = minimumRows * columns - currentWallets + columns;
        shimmerCount -= wallets.length ? featured.length % columns : 0;
        if (count === 0 && featured.length > 0) return null;
        if (count === 0 || [
            ...featured,
            ...wallets,
            ...recommended
        ].length < count) return this.shimmerTemplate(shimmerCount, $01e3b12b3c634204$var$PAGINATOR_ID);
        return null;
    }
    createPaginationObserver() {
        const loaderEl = this.shadowRoot?.querySelector(`#${$01e3b12b3c634204$var$PAGINATOR_ID}`);
        if (loaderEl) {
            this.paginationObserver = new IntersectionObserver(([element])=>{
                if (element?.isIntersecting && !this.initial) {
                    const { page: page, count: count, wallets: wallets } = (0, $6tAXH.ApiController).state;
                    if (wallets.length < count) (0, $6tAXH.ApiController).fetchWallets({
                        page: page + 1
                    });
                }
            });
            this.paginationObserver.observe(loaderEl);
        }
    }
    onConnectWallet(wallet) {
        const { connectors: connectors } = (0, $9QkaU.ConnectorController).state;
        const connector = connectors.find(({ explorerId: explorerId })=>explorerId === wallet.id);
        if (connector) (0, $dJjpc.RouterController).push("ConnectingExternal", {
            connector: connector
        });
        else (0, $dJjpc.RouterController).push("ConnectingWalletConnect", {
            wallet: wallet
        });
    }
};
$01e3b12b3c634204$export$f39175f9037ce7d2.styles = (0, $b2920975a665833a$export$2e2bcd8739ae039);
$01e3b12b3c634204$var$__decorate([
    (0, $6eT5F.state)()
], $01e3b12b3c634204$export$f39175f9037ce7d2.prototype, "initial", void 0);
$01e3b12b3c634204$var$__decorate([
    (0, $6eT5F.state)()
], $01e3b12b3c634204$export$f39175f9037ce7d2.prototype, "wallets", void 0);
$01e3b12b3c634204$var$__decorate([
    (0, $6eT5F.state)()
], $01e3b12b3c634204$export$f39175f9037ce7d2.prototype, "recommended", void 0);
$01e3b12b3c634204$var$__decorate([
    (0, $6eT5F.state)()
], $01e3b12b3c634204$export$f39175f9037ce7d2.prototype, "featured", void 0);
$01e3b12b3c634204$export$f39175f9037ce7d2 = $01e3b12b3c634204$var$__decorate([
    (0, $lkv4o.customElement)("w3m-all-wallets-list")
], $01e3b12b3c634204$export$f39175f9037ce7d2);


parcelRequire("aAJP9");
var $6tAXH = parcelRequire("6tAXH");
var $7XY6i = parcelRequire("7XY6i");
var $9QkaU = parcelRequire("9QkaU");
var $dJjpc = parcelRequire("dJjpc");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $5YVCx = parcelRequire("5YVCx");
var $6eT5F = parcelRequire("6eT5F");

parcelRequire("5bcND");
var $kq2WI = parcelRequire("kq2WI");
var $7eb87d834db696f6$export$2e2bcd8739ae039 = (0, $kq2WI.css)`
  wui-grid,
  wui-loading-spinner,
  wui-flex {
    height: 360px;
  }

  wui-grid {
    overflow: scroll;
    scrollbar-width: none;
    grid-auto-rows: min-content;
  }

  wui-grid[data-scroll='false'] {
    overflow: hidden;
  }

  wui-grid::-webkit-scrollbar {
    display: none;
  }

  wui-loading-spinner {
    justify-content: center;
    align-items: center;
  }
`;



var $ddb43451c235165a$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $ddb43451c235165a$export$65a744e48142d5af = class W3mAllWalletsSearch extends (0, $b47AP.LitElement) {
    constructor(){
        super(...arguments);
        this.prevQuery = "";
        this.loading = true;
        this.query = "";
    }
    render() {
        this.onSearch();
        return this.loading ? (0, $6HMh7.html)`<wui-loading-spinner color="accent-100"></wui-loading-spinner>` : this.walletsTemplate();
    }
    async onSearch() {
        if (this.query !== this.prevQuery) {
            this.prevQuery = this.query;
            this.loading = true;
            await (0, $6tAXH.ApiController).searchWallet({
                search: this.query
            });
            this.loading = false;
        }
    }
    walletsTemplate() {
        const { search: search } = (0, $6tAXH.ApiController).state;
        const wallets = (0, $2bd8917fbb32b1a9$export$cffc81df24a1f1f1)(search);
        if (!search.length) return (0, $6HMh7.html)`
        <wui-flex justifyContent="center" alignItems="center" gap="s" flexDirection="column">
          <wui-icon-box
            size="lg"
            iconColor="fg-200"
            backgroundColor="fg-300"
            icon="wallet"
            background="transparent"
          ></wui-icon-box>
          <wui-text color="fg-200" variant="paragraph-500">No Wallet found</wui-text>
        </wui-flex>
      `;
        return (0, $6HMh7.html)`
      <wui-grid
        .padding=${[
            "0",
            "s",
            "s",
            "s"
        ]}
        gridTemplateColumns="repeat(4, 1fr)"
        rowGap="l"
        columnGap="xs"
      >
        ${wallets.map((wallet)=>(0, $6HMh7.html)`
            <wui-card-select
              imageSrc=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)((0, $7XY6i.AssetUtil).getWalletImage(wallet))}
              type="wallet"
              name=${wallet.name}
              @click=${()=>this.onConnectWallet(wallet)}
              .installed=${wallet.installed}
            ></wui-card-select>
          `)}
      </wui-grid>
    `;
    }
    onConnectWallet(wallet) {
        const { connectors: connectors } = (0, $9QkaU.ConnectorController).state;
        const connector = connectors.find(({ explorerId: explorerId })=>explorerId === wallet.id);
        if (connector) (0, $dJjpc.RouterController).push("ConnectingExternal", {
            connector: connector
        });
        else (0, $dJjpc.RouterController).push("ConnectingWalletConnect", {
            wallet: wallet
        });
    }
};
$ddb43451c235165a$export$65a744e48142d5af.styles = (0, $7eb87d834db696f6$export$2e2bcd8739ae039);
$ddb43451c235165a$var$__decorate([
    (0, $6eT5F.state)()
], $ddb43451c235165a$export$65a744e48142d5af.prototype, "loading", void 0);
$ddb43451c235165a$var$__decorate([
    (0, $5YVCx.property)()
], $ddb43451c235165a$export$65a744e48142d5af.prototype, "query", void 0);
$ddb43451c235165a$export$65a744e48142d5af = $ddb43451c235165a$var$__decorate([
    (0, $lkv4o.customElement)("w3m-all-wallets-search")
], $ddb43451c235165a$export$65a744e48142d5af);


parcelRequire("aAJP9");
var $jJO2B = parcelRequire("jJO2B");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $5YVCx = parcelRequire("5YVCx");
var $6eT5F = parcelRequire("6eT5F");
var $b798f99c1b4e8337$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $b798f99c1b4e8337$export$994bb77f05fbbbde = class W3mConnectingHeader extends (0, $b47AP.LitElement) {
    constructor(){
        super();
        this.platformTabs = [];
        this.unsubscribe = [];
        this.platforms = [];
        this.onSelectPlatfrom = undefined;
        this.buffering = false;
        this.unsubscribe.push((0, $jJO2B.ConnectionController).subscribeKey("buffering", (val)=>this.buffering = val));
    }
    disconnectCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        const tabs = this.generateTabs();
        return (0, $6HMh7.html)`
      <wui-flex justifyContent="center" .padding=${[
            "l",
            "0",
            "0",
            "0"
        ]}>
        <wui-tabs
          ?disabled=${this.buffering}
          .tabs=${tabs}
          .onTabChange=${this.onTabChange.bind(this)}
        ></wui-tabs>
      </wui-flex>
    `;
    }
    generateTabs() {
        const tabs = this.platforms.map((platform)=>{
            if (platform === "browser") return {
                label: "Browser",
                icon: "extension",
                platform: "browser"
            };
            else if (platform === "mobile") return {
                label: "Mobile",
                icon: "mobile",
                platform: "mobile"
            };
            else if (platform === "qrcode") return {
                label: "Mobile",
                icon: "mobile",
                platform: "qrcode"
            };
            else if (platform === "web") return {
                label: "Webapp",
                icon: "browser",
                platform: "web"
            };
            else if (platform === "desktop") return {
                label: "Desktop",
                icon: "desktop",
                platform: "desktop"
            };
            return {
                label: "Browser",
                icon: "extension",
                platform: "unsupported"
            };
        });
        this.platformTabs = tabs.map(({ platform: platform })=>platform);
        return tabs;
    }
    onTabChange(index) {
        const tab = this.platformTabs[index];
        if (tab) this.onSelectPlatfrom?.(tab);
    }
};
$b798f99c1b4e8337$var$__decorate([
    (0, $5YVCx.property)({
        type: Array
    })
], $b798f99c1b4e8337$export$994bb77f05fbbbde.prototype, "platforms", void 0);
$b798f99c1b4e8337$var$__decorate([
    (0, $5YVCx.property)()
], $b798f99c1b4e8337$export$994bb77f05fbbbde.prototype, "onSelectPlatfrom", void 0);
$b798f99c1b4e8337$var$__decorate([
    (0, $6eT5F.state)()
], $b798f99c1b4e8337$export$994bb77f05fbbbde.prototype, "buffering", void 0);
$b798f99c1b4e8337$export$994bb77f05fbbbde = $b798f99c1b4e8337$var$__decorate([
    (0, $lkv4o.customElement)("w3m-connecting-header")
], $b798f99c1b4e8337$export$994bb77f05fbbbde);


parcelRequire("aAJP9");
var $jJO2B = parcelRequire("jJO2B");
var $9QkaU = parcelRequire("9QkaU");
var $6n0eX = parcelRequire("6n0eX");
var $bnxqc = parcelRequire("bnxqc");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");

var $bb74d9c8dd2f8fff$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $bb74d9c8dd2f8fff$export$f6b6073753ecd240 = class W3mConnectingWcBrowser extends (0, $f280655654489b57$export$902e3cfa9f67689d) {
    constructor(){
        super();
        if (!this.wallet) throw new Error("w3m-connecting-wc-browser: No wallet provided");
        this.onConnect = this.onConnectProxy.bind(this);
        this.onAutoConnect = this.onConnectProxy.bind(this);
        (0, $6n0eX.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: this.wallet.name,
                platform: "browser"
            }
        });
    }
    async onConnectProxy() {
        try {
            this.error = false;
            const { connectors: connectors } = (0, $9QkaU.ConnectorController).state;
            const announcedConnector = connectors.find((c)=>c.type === "ANNOUNCED" && c.info?.rdns === this.wallet?.rdns);
            const injectedConnector = connectors.find((c)=>c.type === "INJECTED");
            if (announcedConnector) await (0, $jJO2B.ConnectionController).connectExternal(announcedConnector);
            else if (injectedConnector) await (0, $jJO2B.ConnectionController).connectExternal(injectedConnector);
            (0, $bnxqc.ModalController).close();
            (0, $6n0eX.EventsController).sendEvent({
                type: "track",
                event: "CONNECT_SUCCESS",
                properties: {
                    method: "browser"
                }
            });
        } catch (error) {
            (0, $6n0eX.EventsController).sendEvent({
                type: "track",
                event: "CONNECT_ERROR",
                properties: {
                    message: error?.message ?? "Unknown"
                }
            });
            this.error = true;
        }
    }
};
$bb74d9c8dd2f8fff$export$f6b6073753ecd240 = $bb74d9c8dd2f8fff$var$__decorate([
    (0, $lkv4o.customElement)("w3m-connecting-wc-browser")
], $bb74d9c8dd2f8fff$export$f6b6073753ecd240);


parcelRequire("aAJP9");
var $jJO2B = parcelRequire("jJO2B");
var $kGR8V = parcelRequire("kGR8V");
var $6n0eX = parcelRequire("6n0eX");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");

var $b57eb6a6c12e104b$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $b57eb6a6c12e104b$export$99d24518d9937f53 = class W3mConnectingWcDesktop extends (0, $f280655654489b57$export$902e3cfa9f67689d) {
    constructor(){
        super();
        if (!this.wallet) throw new Error("w3m-connecting-wc-desktop: No wallet provided");
        this.onConnect = this.onConnectProxy.bind(this);
        this.onRender = this.onRenderProxy.bind(this);
        (0, $6n0eX.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: this.wallet.name,
                platform: "desktop"
            }
        });
    }
    onRenderProxy() {
        if (!this.ready && this.uri) {
            this.ready = true;
            this.timeout = setTimeout(()=>{
                this.onConnect?.();
            }, 200);
        }
    }
    onConnectProxy() {
        if (this.wallet?.desktop_link && this.uri) try {
            this.error = false;
            const { desktop_link: desktop_link, name: name } = this.wallet;
            const { redirect: redirect, href: href } = (0, $kGR8V.CoreHelperUtil).formatNativeUrl(desktop_link, this.uri);
            (0, $jJO2B.ConnectionController).setWcLinking({
                name: name,
                href: href
            });
            (0, $jJO2B.ConnectionController).setRecentWallet(this.wallet);
            (0, $kGR8V.CoreHelperUtil).openHref(redirect, "_blank");
        } catch  {
            this.error = true;
        }
    }
};
$b57eb6a6c12e104b$export$99d24518d9937f53 = $b57eb6a6c12e104b$var$__decorate([
    (0, $lkv4o.customElement)("w3m-connecting-wc-desktop")
], $b57eb6a6c12e104b$export$99d24518d9937f53);


parcelRequire("aAJP9");
var $jJO2B = parcelRequire("jJO2B");
var $kGR8V = parcelRequire("kGR8V");
var $6n0eX = parcelRequire("6n0eX");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");

var $5c640f8e20969854$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $5c640f8e20969854$export$bde153011a6b26 = class W3mConnectingWcMobile extends (0, $f280655654489b57$export$902e3cfa9f67689d) {
    constructor(){
        super();
        if (!this.wallet) throw new Error("w3m-connecting-wc-mobile: No wallet provided");
        this.onConnect = this.onConnectProxy.bind(this);
        this.onRender = this.onRenderProxy.bind(this);
        document.addEventListener("visibilitychange", this.onBuffering.bind(this));
        (0, $6n0eX.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: this.wallet.name,
                platform: "mobile"
            }
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener("visibilitychange", this.onBuffering.bind(this));
    }
    onRenderProxy() {
        if (!this.ready && this.uri) {
            this.ready = true;
            this.onConnect?.();
        }
    }
    onConnectProxy() {
        if (this.wallet?.mobile_link && this.uri) try {
            this.error = false;
            const { mobile_link: mobile_link, name: name } = this.wallet;
            const { redirect: redirect, href: href } = (0, $kGR8V.CoreHelperUtil).formatNativeUrl(mobile_link, this.uri);
            (0, $jJO2B.ConnectionController).setWcLinking({
                name: name,
                href: href
            });
            (0, $jJO2B.ConnectionController).setRecentWallet(this.wallet);
            (0, $kGR8V.CoreHelperUtil).openHref(redirect, "_self");
        } catch  {
            this.error = true;
        }
    }
    onBuffering() {
        const isIos = (0, $kGR8V.CoreHelperUtil).isIos();
        if (document?.visibilityState === "visible" && !this.error && isIos) {
            (0, $jJO2B.ConnectionController).setBuffering(true);
            setTimeout(()=>{
                (0, $jJO2B.ConnectionController).setBuffering(false);
            }, 5000);
        }
    }
};
$5c640f8e20969854$export$bde153011a6b26 = $5c640f8e20969854$var$__decorate([
    (0, $lkv4o.customElement)("w3m-connecting-wc-mobile")
], $5c640f8e20969854$export$bde153011a6b26);


parcelRequire("aAJP9");
var $7XY6i = parcelRequire("7XY6i");
var $jJO2B = parcelRequire("jJO2B");
var $6n0eX = parcelRequire("6n0eX");
var $fyCFg = parcelRequire("fyCFg");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");


parcelRequire("5bcND");
var $kq2WI = parcelRequire("kq2WI");
var $7edc31138f197563$export$2e2bcd8739ae039 = (0, $kq2WI.css)`
  @keyframes fadein {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  wui-shimmer {
    width: 100%;
    aspect-ratio: 1 / 1;
    border-radius: clamp(0px, var(--wui-border-radius-l), 40px) !important;
  }

  wui-qr-code {
    opacity: 0;
    animation-duration: 200ms;
    animation-timing-function: ease;
    animation-name: fadein;
    animation-fill-mode: forwards;
  }
`;


var $2748c53679b6d128$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $2748c53679b6d128$export$d4369b1b68d9b78a = class W3mConnectingWcQrcode extends (0, $f280655654489b57$export$902e3cfa9f67689d) {
    constructor(){
        super();
        this.forceUpdate = ()=>{
            this.requestUpdate();
        };
        window.addEventListener("resize", this.forceUpdate);
        (0, $6n0eX.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: this.wallet?.name ?? "WalletConnect",
                platform: "qrcode"
            }
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener("resize", this.forceUpdate);
    }
    render() {
        this.onRenderProxy();
        return (0, $6HMh7.html)`
      <wui-flex padding="xl" flexDirection="column" gap="xl" alignItems="center">
        <wui-shimmer borderRadius="l" width="100%"> ${this.qrCodeTemplate()} </wui-shimmer>

        <wui-text variant="paragraph-500" color="fg-100">
          Scan this QR Code with your phone
        </wui-text>
        ${this.copyTemplate()}
      </wui-flex>

      <w3m-mobile-download-links .wallet=${this.wallet}></w3m-mobile-download-links>
    `;
    }
    onRenderProxy() {
        if (!this.ready && this.uri) this.timeout = setTimeout(()=>{
            this.ready = true;
        }, 200);
    }
    qrCodeTemplate() {
        if (!this.uri || !this.ready) return null;
        const size = this.getBoundingClientRect().width - 40;
        const alt = this.wallet ? this.wallet.name : undefined;
        (0, $jJO2B.ConnectionController).setWcLinking(undefined);
        (0, $jJO2B.ConnectionController).setRecentWallet(this.wallet);
        return (0, $6HMh7.html)` <wui-qr-code
      size=${size}
      theme=${(0, $fyCFg.ThemeController).state.themeMode}
      uri=${this.uri}
      imageSrc=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)((0, $7XY6i.AssetUtil).getWalletImage(this.wallet))}
      alt=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)(alt)}
      data-testid="wui-qr-code"
    ></wui-qr-code>`;
    }
    copyTemplate() {
        const inactive = !this.uri || !this.ready;
        return (0, $6HMh7.html)`<wui-link
      .disabled=${inactive}
      @click=${this.onCopyUri}
      color="fg-200"
      data-testid="copy-wc2-uri"
    >
      <wui-icon size="xs" color="fg-200" slot="iconLeft" name="copy"></wui-icon>
      Copy link
    </wui-link>`;
    }
};
$2748c53679b6d128$export$d4369b1b68d9b78a.styles = (0, $7edc31138f197563$export$2e2bcd8739ae039);
$2748c53679b6d128$export$d4369b1b68d9b78a = $2748c53679b6d128$var$__decorate([
    (0, $lkv4o.customElement)("w3m-connecting-wc-qrcode")
], $2748c53679b6d128$export$d4369b1b68d9b78a);


parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("5bcND");
var $kq2WI = parcelRequire("kq2WI");
var $c69960f169af4214$export$2e2bcd8739ae039 = (0, $kq2WI.css)`
  :host {
    display: flex;
    justify-content: center;
    gap: var(--wui-spacing-2xl);
  }

  wui-visual-thumbnail:nth-child(1) {
    z-index: 1;
  }
`;


parcelRequire("aAJP9");
var $8KEpV = parcelRequire("8KEpV");
var $heSwZ = parcelRequire("heSwZ");
var $225bb05382798cda$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $225bb05382798cda$export$415fdf721000461b = class W3mConnectingSiwe extends (0, $b47AP.LitElement) {
    constructor(){
        super(...arguments);
        this.dappImageUrl = (0, $8KEpV.OptionsController).state.metadata?.icons;
        this.walletImageUrl = (0, $heSwZ.StorageUtil).getConnectedWalletImageUrl();
    }
    firstUpdated() {
        const visuals = this.shadowRoot?.querySelectorAll("wui-visual-thumbnail");
        if (visuals?.[0]) this.createAnimation(visuals[0], "translate(18px)");
        if (visuals?.[1]) this.createAnimation(visuals[1], "translate(-18px)");
    }
    render() {
        return (0, $6HMh7.html)`
      <wui-visual-thumbnail
        ?borderRadiusFull=${true}
        .imageSrc=${this.dappImageUrl?.[0]}
      ></wui-visual-thumbnail>
      <wui-visual-thumbnail .imageSrc=${this.walletImageUrl}></wui-visual-thumbnail>
    `;
    }
    createAnimation(element, translation) {
        element.animate([
            {
                transform: "translateX(0px)"
            },
            {
                transform: translation
            }
        ], {
            duration: 1600,
            easing: "cubic-bezier(0.56, 0, 0.48, 1)",
            direction: "alternate",
            iterations: Infinity
        });
    }
};
$225bb05382798cda$export$415fdf721000461b.styles = (0, $c69960f169af4214$export$2e2bcd8739ae039);
$225bb05382798cda$export$415fdf721000461b = $225bb05382798cda$var$__decorate([
    (0, $lkv4o.customElement)("w3m-connecting-siwe")
], $225bb05382798cda$export$415fdf721000461b);


parcelRequire("aAJP9");
var $7XY6i = parcelRequire("7XY6i");
var $6n0eX = parcelRequire("6n0eX");
var $dJjpc = parcelRequire("dJjpc");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");

var $682e96e7ee1809df$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $682e96e7ee1809df$export$8ced6ff0971fe41b = class W3mConnectingWcUnsupported extends (0, $b47AP.LitElement) {
    constructor(){
        super();
        this.wallet = (0, $dJjpc.RouterController).state.data?.wallet;
        if (!this.wallet) throw new Error("w3m-connecting-wc-unsupported: No wallet provided");
        (0, $6n0eX.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: this.wallet.name,
                platform: "browser"
            }
        });
    }
    render() {
        return (0, $6HMh7.html)`
      <wui-flex
        flexDirection="column"
        alignItems="center"
        .padding=${[
            "3xl",
            "xl",
            "xl",
            "xl"
        ]}
        gap="xl"
      >
        <wui-wallet-image
          size="lg"
          imageSrc=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)((0, $7XY6i.AssetUtil).getWalletImage(this.wallet))}
        ></wui-wallet-image>

        <wui-text variant="paragraph-500" color="fg-100">Not Detected</wui-text>
      </wui-flex>

      <w3m-mobile-download-links .wallet=${this.wallet}></w3m-mobile-download-links>
    `;
    }
};
$682e96e7ee1809df$export$8ced6ff0971fe41b = $682e96e7ee1809df$var$__decorate([
    (0, $lkv4o.customElement)("w3m-connecting-wc-unsupported")
], $682e96e7ee1809df$export$8ced6ff0971fe41b);


parcelRequire("aAJP9");
var $jJO2B = parcelRequire("jJO2B");
var $kGR8V = parcelRequire("kGR8V");
var $6n0eX = parcelRequire("6n0eX");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");

var $06d58cfab2245966$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $06d58cfab2245966$export$bdfe677b483cfd66 = class W3mConnectingWcWeb extends (0, $f280655654489b57$export$902e3cfa9f67689d) {
    constructor(){
        super();
        if (!this.wallet) throw new Error("w3m-connecting-wc-web: No wallet provided");
        this.onConnect = this.onConnectProxy.bind(this);
        this.secondaryBtnLabel = "Open";
        this.secondaryLabel = "Open and continue in a new browser tab";
        this.secondaryBtnIcon = "externalLink";
        (0, $6n0eX.EventsController).sendEvent({
            type: "track",
            event: "SELECT_WALLET",
            properties: {
                name: this.wallet.name,
                platform: "web"
            }
        });
    }
    onConnectProxy() {
        if (this.wallet?.webapp_link && this.uri) try {
            this.error = false;
            const { webapp_link: webapp_link, name: name } = this.wallet;
            const { redirect: redirect, href: href } = (0, $kGR8V.CoreHelperUtil).formatUniversalUrl(webapp_link, this.uri);
            (0, $jJO2B.ConnectionController).setWcLinking({
                name: name,
                href: href
            });
            (0, $jJO2B.ConnectionController).setRecentWallet(this.wallet);
            (0, $kGR8V.CoreHelperUtil).openHref(redirect, "_blank");
        } catch  {
            this.error = true;
        }
    }
};
$06d58cfab2245966$export$bdfe677b483cfd66 = $06d58cfab2245966$var$__decorate([
    (0, $lkv4o.customElement)("w3m-connecting-wc-web")
], $06d58cfab2245966$export$bdfe677b483cfd66);


parcelRequire("aAJP9");
var $jJO2B = parcelRequire("jJO2B");
var $9QkaU = parcelRequire("9QkaU");
var $6n0eX = parcelRequire("6n0eX");
var $bnxqc = parcelRequire("bnxqc");
var $dJjpc = parcelRequire("dJjpc");
var $iQR2f = parcelRequire("iQR2f");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $6eT5F = parcelRequire("6eT5F");
parcelRequire("5bcND");
var $kq2WI = parcelRequire("kq2WI");
var $6190fbf26fd97aa1$export$2e2bcd8739ae039 = (0, $kq2WI.css)`
  wui-icon-link[data-hidden='true'] {
    opacity: 0 !important;
    pointer-events: none;
  }
`;


var $8ac99b439a25cd45$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
function $8ac99b439a25cd45$var$headings() {
    const connectorName = (0, $dJjpc.RouterController).state.data?.connector?.name;
    const walletName = (0, $dJjpc.RouterController).state.data?.wallet?.name;
    const networkName = (0, $dJjpc.RouterController).state.data?.network?.name;
    const name = walletName ?? connectorName;
    const connectors = (0, $9QkaU.ConnectorController).getConnectors();
    const isEmail = connectors.length === 1 && connectors[0]?.id === "w3m-email";
    return {
        Connect: `Connect ${isEmail ? "Email" : ""} Wallet`,
        Account: undefined,
        AccountSettings: undefined,
        ConnectingExternal: name ?? "Connect Wallet",
        ConnectingWalletConnect: name ?? "WalletConnect",
        ConnectingSiwe: "Sign In",
        Networks: "Choose Network",
        SwitchNetwork: networkName ?? "Switch Network",
        AllWallets: "All Wallets",
        WhatIsANetwork: "What is a network?",
        WhatIsAWallet: "What is a wallet?",
        GetWallet: "Get a wallet",
        Downloads: name ? `Get ${name}` : "Downloads",
        EmailVerifyOtp: "Confirm Email",
        EmailVerifyDevice: "Register Device",
        ApproveTransaction: "Approve Transaction",
        Transactions: "Activity",
        UpgradeEmailWallet: "Upgrade your Wallet",
        UpdateEmailWallet: "Edit Email",
        UpdateEmailPrimaryOtp: "Confirm Current Email",
        UpdateEmailSecondaryOtp: "Confirm New Email",
        UnsupportedChain: "Switch Network",
        OnRampProviders: "Choose Provider",
        OnRampActivity: "Activity",
        WhatIsABuy: "What is Buy?",
        BuyInProgress: "Buy",
        OnRampTokenSelect: "Select Token",
        OnRampFiatSelect: "Select Currency"
    };
}
let $8ac99b439a25cd45$export$c6714271d9f13670 = class W3mHeader extends (0, $b47AP.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.heading = $8ac99b439a25cd45$var$headings()[(0, $dJjpc.RouterController).state.view];
        this.buffering = false;
        this.showBack = false;
        this.unsubscribe.push((0, $dJjpc.RouterController).subscribeKey("view", (val)=>{
            this.onViewChange(val);
            this.onHistoryChange();
        }), (0, $jJO2B.ConnectionController).subscribeKey("buffering", (val)=>this.buffering = val));
    }
    disconnectCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        return (0, $6HMh7.html)`
      <wui-flex .padding=${this.getPadding()} justifyContent="space-between" alignItems="center">
        ${this.dynamicButtonTemplate()} ${this.titleTemplate()}
        <wui-icon-link
          ?disabled=${this.buffering}
          icon="close"
          @click=${this.onClose.bind(this)}
          data-testid="w3m-header-close"
        ></wui-icon-link>
      </wui-flex>
      ${this.separatorTemplate()}
    `;
    }
    onWalletHelp() {
        (0, $6n0eX.EventsController).sendEvent({
            type: "track",
            event: "CLICK_WALLET_HELP"
        });
        (0, $dJjpc.RouterController).push("WhatIsAWallet");
    }
    async onClose() {
        if ((0, $iQR2f.SIWEController).state.isSiweEnabled && (0, $iQR2f.SIWEController).state.status !== "success") await (0, $jJO2B.ConnectionController).disconnect();
        (0, $bnxqc.ModalController).close();
    }
    titleTemplate() {
        return (0, $6HMh7.html)`<wui-text variant="paragraph-700" color="fg-100">${this.heading}</wui-text>`;
    }
    dynamicButtonTemplate() {
        const { view: view } = (0, $dJjpc.RouterController).state;
        const isConnectHelp = view === "Connect";
        const isApproveTransaction = view === "ApproveTransaction";
        if (this.showBack && !isApproveTransaction) return (0, $6HMh7.html)`<wui-icon-link
        id="dynamic"
        icon="chevronLeft"
        ?disabled=${this.buffering}
        @click=${this.onGoBack.bind(this)}
      ></wui-icon-link>`;
        return (0, $6HMh7.html)`<wui-icon-link
      data-hidden=${!isConnectHelp}
      id="dynamic"
      icon="helpCircle"
      @click=${this.onWalletHelp.bind(this)}
    ></wui-icon-link>`;
    }
    separatorTemplate() {
        if (!this.heading) return null;
        return (0, $6HMh7.html)`<wui-separator></wui-separator>`;
    }
    getPadding() {
        if (this.heading) return [
            "l",
            "2l",
            "l",
            "2l"
        ];
        return [
            "l",
            "2l",
            "0",
            "2l"
        ];
    }
    async onViewChange(view) {
        const headingEl = this.shadowRoot?.querySelector("wui-text");
        if (headingEl) {
            const preset = $8ac99b439a25cd45$var$headings()[view];
            await headingEl.animate([
                {
                    opacity: 1
                },
                {
                    opacity: 0
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            }).finished;
            this.heading = preset;
            headingEl.animate([
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            });
        }
    }
    async onHistoryChange() {
        const { history: history } = (0, $dJjpc.RouterController).state;
        const buttonEl = this.shadowRoot?.querySelector("#dynamic");
        if (history.length > 1 && !this.showBack && buttonEl) {
            await buttonEl.animate([
                {
                    opacity: 1
                },
                {
                    opacity: 0
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            }).finished;
            this.showBack = true;
            buttonEl.animate([
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            });
        } else if (history.length <= 1 && this.showBack && buttonEl) {
            await buttonEl.animate([
                {
                    opacity: 1
                },
                {
                    opacity: 0
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            }).finished;
            this.showBack = false;
            buttonEl.animate([
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ], {
                duration: 200,
                fill: "forwards",
                easing: "ease"
            });
        }
    }
    onGoBack() {
        if ((0, $dJjpc.RouterController).state.view === "ConnectingSiwe") (0, $dJjpc.RouterController).push("Connect");
        else (0, $dJjpc.RouterController).goBack();
    }
};
$8ac99b439a25cd45$export$c6714271d9f13670.styles = [
    (0, $6190fbf26fd97aa1$export$2e2bcd8739ae039)
];
$8ac99b439a25cd45$var$__decorate([
    (0, $6eT5F.state)()
], $8ac99b439a25cd45$export$c6714271d9f13670.prototype, "heading", void 0);
$8ac99b439a25cd45$var$__decorate([
    (0, $6eT5F.state)()
], $8ac99b439a25cd45$export$c6714271d9f13670.prototype, "buffering", void 0);
$8ac99b439a25cd45$var$__decorate([
    (0, $6eT5F.state)()
], $8ac99b439a25cd45$export$c6714271d9f13670.prototype, "showBack", void 0);
$8ac99b439a25cd45$export$c6714271d9f13670 = $8ac99b439a25cd45$var$__decorate([
    (0, $lkv4o.customElement)("w3m-header")
], $8ac99b439a25cd45$export$c6714271d9f13670);


parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $5YVCx = parcelRequire("5YVCx");
var $86fba315d33944b6$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $86fba315d33944b6$export$c95abd0ceed44b88 = class W3mHelpWidget extends (0, $b47AP.LitElement) {
    constructor(){
        super(...arguments);
        this.data = [];
    }
    render() {
        return (0, $6HMh7.html)`
      <wui-flex flexDirection="column" alignItems="center" gap="l">
        ${this.data.map((item)=>(0, $6HMh7.html)`
            <wui-flex flexDirection="column" alignItems="center" gap="xl">
              <wui-flex flexDirection="row" justifyContent="center" gap="1xs">
                ${item.images.map((image)=>(0, $6HMh7.html)`<wui-visual name=${image}></wui-visual>`)}
              </wui-flex>
            </wui-flex>
            <wui-flex flexDirection="column" alignItems="center" gap="xxs">
              <wui-text variant="paragraph-500" color="fg-100" align="center">
                ${item.title}
              </wui-text>
              <wui-text variant="small-500" color="fg-200" align="center">${item.text}</wui-text>
            </wui-flex>
          `)}
      </wui-flex>
    `;
    }
};
$86fba315d33944b6$var$__decorate([
    (0, $5YVCx.property)({
        type: Array
    })
], $86fba315d33944b6$export$c95abd0ceed44b88.prototype, "data", void 0);
$86fba315d33944b6$export$c95abd0ceed44b88 = $86fba315d33944b6$var$__decorate([
    (0, $lkv4o.customElement)("w3m-help-widget")
], $86fba315d33944b6$export$c95abd0ceed44b88);


parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $5YVCx = parcelRequire("5YVCx");
var $6eT5F = parcelRequire("6eT5F");

parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $kq2WI = parcelRequire("kq2WI");
var $42ee90f6357b9fca$export$2e2bcd8739ae039 = (0, $kq2WI.css)`
  :host {
    width: 100%;
  }

  wui-loading-spinner {
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
  }

  .currency-container {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    transition: all var(--wui-ease-in-power-2) var(--wui-duration-md);
    right: var(--wui-spacing-1xs);
    height: 40px;
    padding: var(--wui-spacing-xs) var(--wui-spacing-1xs) var(--wui-spacing-xs)
      var(--wui-spacing-xs);
    min-width: 95px;
    border-radius: var(--FULL, 1000px);
    border: 1px solid var(--wui-gray-glass-002);
    background: var(--wui-gray-glass-002);
    cursor: pointer;
  }

  .currency-container > wui-image {
    height: 24px;
    width: 24px;
    border-radius: 50%;
  }
`;


parcelRequire("aAJP9");
var $hCakD = parcelRequire("hCakD");
var $bnxqc = parcelRequire("bnxqc");
var $ahDsO = parcelRequire("ahDsO");
var $f372aa7e9170c499$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $f372aa7e9170c499$export$8c7f6376138a05de = class W3mInputCurrency extends (0, $b47AP.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.type = "Token";
        this.value = 0;
        this.currencies = [];
        this.selectedCurrency = this.currencies?.[0];
        this.currencyImages = (0, $hCakD.AssetController).state.currencyImages;
        this.tokenImages = (0, $hCakD.AssetController).state.tokenImages;
        this.unsubscribe.push((0, $ahDsO.OnRampController).subscribeKey("purchaseCurrency", (val)=>{
            if (!val || this.type === "Fiat") return;
            this.selectedCurrency = this.formatPurchaseCurrency(val);
        }), (0, $ahDsO.OnRampController).subscribeKey("paymentCurrency", (val)=>{
            if (!val || this.type === "Token") return;
            this.selectedCurrency = this.formatPaymentCurrency(val);
        }), (0, $ahDsO.OnRampController).subscribe((val)=>{
            if (this.type === "Fiat") this.currencies = val.purchaseCurrencies.map(this.formatPurchaseCurrency);
            else this.currencies = val.paymentCurrencies.map(this.formatPaymentCurrency);
        }), (0, $hCakD.AssetController).subscribe((val)=>{
            this.currencyImages = {
                ...val.currencyImages
            };
            this.tokenImages = {
                ...val.tokenImages
            };
        }));
    }
    firstUpdated() {
        (0, $ahDsO.OnRampController).getAvailableCurrencies();
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        const symbol = this.selectedCurrency?.symbol || "";
        const image = this.currencyImages[symbol] || this.tokenImages[symbol];
        return (0, $6HMh7.html)` <wui-input-text type="number" size="lg" value=${this.value}>
      ${this.selectedCurrency ? (0, $6HMh7.html)` <wui-flex
            class="currency-container"
            justifyContent="space-between"
            alignItems="center"
            gap="xxs"
            @click=${()=>(0, $bnxqc.ModalController).open({
                view: `OnRamp${this.type}Select`
            })}
          >
            <wui-image src=${(0, $7cc46e76860b3b4c$export$f68dd208b5df064d)(image)}></wui-image>
            <wui-text color="fg-100"> ${this.selectedCurrency.symbol} </wui-text>
          </wui-flex>` : (0, $6HMh7.html)`<wui-loading-spinner></wui-loading-spinner>`}
    </wui-input-text>`;
    }
    formatPaymentCurrency(currency) {
        return {
            name: currency.id,
            symbol: currency.id
        };
    }
    formatPurchaseCurrency(currency) {
        return {
            name: currency.name,
            symbol: currency.symbol
        };
    }
};
$f372aa7e9170c499$export$8c7f6376138a05de.styles = (0, $42ee90f6357b9fca$export$2e2bcd8739ae039);
$f372aa7e9170c499$var$__decorate([
    (0, $5YVCx.property)({
        type: String
    })
], $f372aa7e9170c499$export$8c7f6376138a05de.prototype, "type", void 0);
$f372aa7e9170c499$var$__decorate([
    (0, $5YVCx.property)({
        type: Number
    })
], $f372aa7e9170c499$export$8c7f6376138a05de.prototype, "value", void 0);
$f372aa7e9170c499$var$__decorate([
    (0, $6eT5F.state)()
], $f372aa7e9170c499$export$8c7f6376138a05de.prototype, "currencies", void 0);
$f372aa7e9170c499$var$__decorate([
    (0, $6eT5F.state)()
], $f372aa7e9170c499$export$8c7f6376138a05de.prototype, "selectedCurrency", void 0);
$f372aa7e9170c499$var$__decorate([
    (0, $6eT5F.state)()
], $f372aa7e9170c499$export$8c7f6376138a05de.prototype, "currencyImages", void 0);
$f372aa7e9170c499$var$__decorate([
    (0, $6eT5F.state)()
], $f372aa7e9170c499$export$8c7f6376138a05de.prototype, "tokenImages", void 0);
$f372aa7e9170c499$export$8c7f6376138a05de = $f372aa7e9170c499$var$__decorate([
    (0, $lkv4o.customElement)("w3m-swap-input")
], $f372aa7e9170c499$export$8c7f6376138a05de);


parcelRequire("aAJP9");
var $8KEpV = parcelRequire("8KEpV");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("5bcND");
var $kq2WI = parcelRequire("kq2WI");
var $ad10fd1c09fc3b48$export$2e2bcd8739ae039 = (0, $kq2WI.css)`
  wui-flex {
    background-color: var(--wui-gray-glass-005);
  }

  a {
    text-decoration: none;
    color: var(--wui-color-fg-175);
    font-weight: 500;
  }
`;


var $fdf7f42a4cebce3b$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $fdf7f42a4cebce3b$export$c463b51fb31743f5 = class W3mLegalFooter extends (0, $b47AP.LitElement) {
    render() {
        const { termsConditionsUrl: termsConditionsUrl, privacyPolicyUrl: privacyPolicyUrl } = (0, $8KEpV.OptionsController).state;
        if (!termsConditionsUrl && !privacyPolicyUrl) return null;
        return (0, $6HMh7.html)`
      <wui-flex .padding=${[
            "m",
            "s",
            "s",
            "s"
        ]} justifyContent="center">
        <wui-text color="fg-250" variant="small-400" align="center">
          By connecting your wallet, you agree to our <br />
          ${this.termsTemplate()} ${this.andTemplate()} ${this.privacyTemplate()}
        </wui-text>
      </wui-flex>
    `;
    }
    andTemplate() {
        const { termsConditionsUrl: termsConditionsUrl, privacyPolicyUrl: privacyPolicyUrl } = (0, $8KEpV.OptionsController).state;
        return termsConditionsUrl && privacyPolicyUrl ? "and" : "";
    }
    termsTemplate() {
        const { termsConditionsUrl: termsConditionsUrl } = (0, $8KEpV.OptionsController).state;
        if (!termsConditionsUrl) return null;
        return (0, $6HMh7.html)`<a href=${termsConditionsUrl}>Terms of Service</a>`;
    }
    privacyTemplate() {
        const { privacyPolicyUrl: privacyPolicyUrl } = (0, $8KEpV.OptionsController).state;
        if (!privacyPolicyUrl) return null;
        return (0, $6HMh7.html)`<a href=${privacyPolicyUrl}>Privacy Policy</a>`;
    }
};
$fdf7f42a4cebce3b$export$c463b51fb31743f5.styles = [
    (0, $ad10fd1c09fc3b48$export$2e2bcd8739ae039)
];
$fdf7f42a4cebce3b$export$c463b51fb31743f5 = $fdf7f42a4cebce3b$var$__decorate([
    (0, $lkv4o.customElement)("w3m-legal-footer")
], $fdf7f42a4cebce3b$export$c463b51fb31743f5);


parcelRequire("aAJP9");
var $kGR8V = parcelRequire("kGR8V");
var $dJjpc = parcelRequire("dJjpc");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
var $97bbL = parcelRequire("97bbL");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $5YVCx = parcelRequire("5YVCx");
parcelRequire("5bcND");
var $kq2WI = parcelRequire("kq2WI");
var $34c26edcd9386b76$export$2e2bcd8739ae039 = (0, $kq2WI.css)`
  :host {
    display: block;
    padding: 0 var(--wui-spacing-xl) var(--wui-spacing-xl);
  }
`;


var $042fc28f2dc75633$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $042fc28f2dc75633$export$eabbdf5c2372470b = class W3mMobileDownloadLinks extends (0, $b47AP.LitElement) {
    constructor(){
        super(...arguments);
        this.wallet = undefined;
    }
    render() {
        if (!this.wallet) {
            this.style.display = "none";
            return null;
        }
        const { name: name, app_store: app_store, play_store: play_store, chrome_store: chrome_store, homepage: homepage } = this.wallet;
        const isMobile = (0, $kGR8V.CoreHelperUtil).isMobile();
        const isIos = (0, $kGR8V.CoreHelperUtil).isIos();
        const isAndroid = (0, $kGR8V.CoreHelperUtil).isAndroid();
        const isMultiple = [
            app_store,
            play_store,
            homepage,
            chrome_store
        ].filter(Boolean).length > 1;
        const shortName = (0, $97bbL.UiHelperUtil).getTruncateString({
            string: name,
            charsStart: 12,
            charsEnd: 0,
            truncate: "end"
        });
        if (isMultiple && !isMobile) return (0, $6HMh7.html)`
        <wui-cta-button
          label=${`Don't have ${shortName}?`}
          buttonLabel="Get"
          @click=${()=>(0, $dJjpc.RouterController).push("Downloads", {
                wallet: this.wallet
            })}
        ></wui-cta-button>
      `;
        if (!isMultiple && homepage) return (0, $6HMh7.html)`
        <wui-cta-button
          label=${`Don't have ${shortName}?`}
          buttonLabel="Get"
          @click=${this.onHomePage.bind(this)}
        ></wui-cta-button>
      `;
        if (app_store && isIos) return (0, $6HMh7.html)`
        <wui-cta-button
          label=${`Don't have ${shortName}?`}
          buttonLabel="Get"
          @click=${this.onAppStore.bind(this)}
        ></wui-cta-button>
      `;
        if (play_store && isAndroid) return (0, $6HMh7.html)`
        <wui-cta-button
          label=${`Don't have ${shortName}?`}
          buttonLabel="Get"
          @click=${this.onPlayStore.bind(this)}
        ></wui-cta-button>
      `;
        this.style.display = "none";
        return null;
    }
    onAppStore() {
        if (this.wallet?.app_store) (0, $kGR8V.CoreHelperUtil).openHref(this.wallet.app_store, "_blank");
    }
    onPlayStore() {
        if (this.wallet?.play_store) (0, $kGR8V.CoreHelperUtil).openHref(this.wallet.play_store, "_blank");
    }
    onHomePage() {
        if (this.wallet?.homepage) (0, $kGR8V.CoreHelperUtil).openHref(this.wallet.homepage, "_blank");
    }
};
$042fc28f2dc75633$export$eabbdf5c2372470b.styles = [
    (0, $34c26edcd9386b76$export$2e2bcd8739ae039)
];
$042fc28f2dc75633$var$__decorate([
    (0, $5YVCx.property)({
        type: Object
    })
], $042fc28f2dc75633$export$eabbdf5c2372470b.prototype, "wallet", void 0);
$042fc28f2dc75633$export$eabbdf5c2372470b = $042fc28f2dc75633$var$__decorate([
    (0, $lkv4o.customElement)("w3m-mobile-download-links")
], $042fc28f2dc75633$export$eabbdf5c2372470b);


parcelRequire("aAJP9");
var $8KEpV = parcelRequire("8KEpV");
var $dJjpc = parcelRequire("dJjpc");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("5bcND");
var $kq2WI = parcelRequire("kq2WI");
var $ebb6071b1b852209$export$2e2bcd8739ae039 = (0, $kq2WI.css)`
  wui-flex {
    border-top: 1px solid var(--wui-gray-glass-005);
  }

  a {
    text-decoration: none;
    color: var(--wui-color-fg-175);
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--wui-spacing-3xs);
  }
`;


var $1ba0ffa41e9b6e4d$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $1ba0ffa41e9b6e4d$export$1877b66553939a5b = class W3mOnRampProvidersFooter extends (0, $b47AP.LitElement) {
    render() {
        const { termsConditionsUrl: termsConditionsUrl, privacyPolicyUrl: privacyPolicyUrl } = (0, $8KEpV.OptionsController).state;
        if (!termsConditionsUrl && !privacyPolicyUrl) return null;
        return (0, $6HMh7.html)`
      <wui-flex
        .padding=${[
            "m",
            "s",
            "s",
            "s"
        ]}
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap="s"
      >
        <wui-text color="fg-250" variant="small-400" align="center">
          We work with the best providers to fit your buyer needs, region, and to get you the lowest
          fees
        </wui-text>

        ${this.whatIsBuyTemplate()}
      </wui-flex>
    `;
    }
    whatIsBuyTemplate() {
        return (0, $6HMh7.html)` <wui-link @click=${this.onWhatIsBuy.bind(this)}>
      <wui-icon size="xs" color="accent-100" slot="iconLeft" name="helpCircle"></wui-icon>
      What is Buy
    </wui-link>`;
    }
    onWhatIsBuy() {
        (0, $dJjpc.RouterController).push("WhatIsABuy");
    }
};
$1ba0ffa41e9b6e4d$export$1877b66553939a5b.styles = [
    (0, $ebb6071b1b852209$export$2e2bcd8739ae039)
];
$1ba0ffa41e9b6e4d$export$1877b66553939a5b = $1ba0ffa41e9b6e4d$var$__decorate([
    (0, $lkv4o.customElement)("w3m-onramp-providers-footer")
], $1ba0ffa41e9b6e4d$export$1877b66553939a5b);


parcelRequire("aAJP9");
var $9fh1I = parcelRequire("9fh1I");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $6eT5F = parcelRequire("6eT5F");
parcelRequire("5bcND");
var $kq2WI = parcelRequire("kq2WI");
var $4da989bb45930db1$export$2e2bcd8739ae039 = (0, $kq2WI.css)`
  :host {
    display: block;
    position: absolute;
    opacity: 0;
    pointer-events: none;
    top: 11px;
    left: 50%;
    width: max-content;
  }
`;


var $dfb264baef1ded49$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
const $dfb264baef1ded49$var$presets = {
    success: {
        backgroundColor: "success-100",
        iconColor: "success-100",
        icon: "checkmark"
    },
    error: {
        backgroundColor: "error-100",
        iconColor: "error-100",
        icon: "close"
    }
};
let $dfb264baef1ded49$export$a84538312ac1ab9d = class W3mSnackBar extends (0, $b47AP.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.timeout = undefined;
        this.open = (0, $9fh1I.SnackController).state.open;
        this.unsubscribe.push((0, $9fh1I.SnackController).subscribeKey("open", (val)=>{
            this.open = val;
            this.onOpen();
        }));
    }
    disconnectedCallback() {
        clearTimeout(this.timeout);
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    render() {
        const { message: message, variant: variant } = (0, $9fh1I.SnackController).state;
        const preset = $dfb264baef1ded49$var$presets[variant];
        return (0, $6HMh7.html)`
      <wui-snackbar
        message=${message}
        backgroundColor=${preset.backgroundColor}
        iconColor=${preset.iconColor}
        icon=${preset.icon}
      ></wui-snackbar>
    `;
    }
    onOpen() {
        clearTimeout(this.timeout);
        if (this.open) {
            this.animate([
                {
                    opacity: 0,
                    transform: "translateX(-50%) scale(0.85)"
                },
                {
                    opacity: 1,
                    transform: "translateX(-50%) scale(1)"
                }
            ], {
                duration: 150,
                fill: "forwards",
                easing: "ease"
            });
            this.timeout = setTimeout(()=>(0, $9fh1I.SnackController).hide(), 2500);
        } else this.animate([
            {
                opacity: 1,
                transform: "translateX(-50%) scale(1)"
            },
            {
                opacity: 0,
                transform: "translateX(-50%) scale(0.85)"
            }
        ], {
            duration: 150,
            fill: "forwards",
            easing: "ease"
        });
    }
};
$dfb264baef1ded49$export$a84538312ac1ab9d.styles = (0, $4da989bb45930db1$export$2e2bcd8739ae039);
$dfb264baef1ded49$var$__decorate([
    (0, $6eT5F.state)()
], $dfb264baef1ded49$export$a84538312ac1ab9d.prototype, "open", void 0);
$dfb264baef1ded49$export$a84538312ac1ab9d = $dfb264baef1ded49$var$__decorate([
    (0, $lkv4o.customElement)("w3m-snackbar")
], $dfb264baef1ded49$export$a84538312ac1ab9d);


parcelRequire("aAJP9");
var $9QkaU = parcelRequire("9QkaU");
var $kGR8V = parcelRequire("kGR8V");
var $6n0eX = parcelRequire("6n0eX");
var $dJjpc = parcelRequire("dJjpc");
var $9fh1I = parcelRequire("9fh1I");
parcelRequire("6eqhe");
var $lkv4o = parcelRequire("lkv4o");
parcelRequire("5bcND");
var $6HMh7 = parcelRequire("6HMh7");
var $b47AP = parcelRequire("b47AP");
parcelRequire("hrpLR");
var $6eT5F = parcelRequire("6eT5F");

parcelRequire("5bcND");
var $kq2WI = parcelRequire("kq2WI");
var $8c6307044cef185d$export$2e2bcd8739ae039 = (0, $kq2WI.css)`
  wui-separator {
    margin: var(--wui-spacing-s) calc(var(--wui-spacing-s) * -1);
    width: calc(100% + var(--wui-spacing-s) * 2);
  }

  wui-email-input {
    width: 100%;
  }

  form {
    width: 100%;
    display: block;
    position: relative;
  }

  wui-icon-link,
  wui-loading-spinner {
    position: absolute;
    top: 21px;
    transform: translateY(-50%);
  }

  wui-icon-link {
    right: var(--wui-spacing-xs);
  }

  wui-loading-spinner {
    right: var(--wui-spacing-m);
  }

  .betaBanner {
    padding: 10px 12px 10px 10px;
    border-radius: var(--wui-border-radius-s);
    background: var(--wui-accent-glass-010);
    margin-bottom: var(--wui-spacing-s);
  }
`;


var $1b54721fd2d7a324$var$__decorate = undefined && undefined.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let $1b54721fd2d7a324$export$73f53e8345d3576d = class W3mEmailLoginWidget extends (0, $b47AP.LitElement) {
    constructor(){
        super();
        this.unsubscribe = [];
        this.formRef = (0, $37eb883020040ad0$export$7d1e3a5e95ceca43)();
        this.connectors = (0, $9QkaU.ConnectorController).state.connectors;
        this.email = "";
        this.loading = false;
        this.error = "";
        this.unsubscribe.push((0, $9QkaU.ConnectorController).subscribeKey("connectors", (val)=>this.connectors = val));
    }
    disconnectedCallback() {
        this.unsubscribe.forEach((unsubscribe)=>unsubscribe());
    }
    firstUpdated() {
        this.formRef.value?.addEventListener("keydown", (event)=>{
            if (event.key === "Enter") this.onSubmitEmail(event);
        });
    }
    render() {
        const multipleConnectors = this.connectors.length > 1;
        const connector = this.connectors.find((c)=>c.type === "EMAIL");
        if (!connector) return null;
        return (0, $6HMh7.html)`
      ${this.betaWarningTemplate()}
      <form ${(0, $37eb883020040ad0$export$eff4d24c3ff7876e)(this.formRef)} @submit=${this.onSubmitEmail.bind(this)}>
        <wui-email-input
          @focus=${this.onFocusEvent.bind(this)}
          .disabled=${this.loading}
          @inputChange=${this.onEmailInputChange.bind(this)}
          .errorMessage=${this.error}
        >
        </wui-email-input>

        ${this.submitButtonTemplate()}${this.loadingTemplate()}
        <input type="submit" hidden />
      </form>

      ${multipleConnectors ? (0, $6HMh7.html)`<wui-separator text="or"></wui-separator>` : null}
    `;
    }
    betaWarningTemplate() {
        const showBetaWarning = true;
        return showBetaWarning ? (0, $6HMh7.html)`
          <wui-flex class="betaBanner" gap="xs" alignItems="center" justifyContent="center">
            <wui-text variant="small-400" color="accent-100">Email login is in beta</wui-text>
          </wui-flex>
        ` : null;
    }
    submitButtonTemplate() {
        const showSubmit = !this.loading && this.email.length > 3;
        return showSubmit ? (0, $6HMh7.html)`
          <wui-icon-link
            size="sm"
            icon="chevronRight"
            iconcolor="accent-100"
            @click=${this.onSubmitEmail.bind(this)}
          >
          </wui-icon-link>
        ` : null;
    }
    loadingTemplate() {
        return this.loading ? (0, $6HMh7.html)`<wui-loading-spinner size="md" color="accent-100"></wui-loading-spinner>` : null;
    }
    onEmailInputChange(event) {
        this.email = event.detail;
        this.error = "";
    }
    async onSubmitEmail(event) {
        try {
            if (this.loading) return;
            this.loading = true;
            event.preventDefault();
            const emailConnector = (0, $9QkaU.ConnectorController).getEmailConnector();
            if (!emailConnector) throw new Error("w3m-email-login-widget: Email connector not found");
            const { action: action } = await emailConnector.provider.connectEmail({
                email: this.email
            });
            (0, $6n0eX.EventsController).sendEvent({
                type: "track",
                event: "EMAIL_SUBMITTED"
            });
            if (action === "VERIFY_OTP") {
                (0, $6n0eX.EventsController).sendEvent({
                    type: "track",
                    event: "EMAIL_VERIFICATION_CODE_SENT"
                });
                (0, $dJjpc.RouterController).push("EmailVerifyOtp", {
                    email: this.email
                });
            } else if (action === "VERIFY_DEVICE") (0, $dJjpc.RouterController).push("EmailVerifyDevice", {
                email: this.email
            });
        } catch (error) {
            const parsedError = (0, $kGR8V.CoreHelperUtil).parseError(error);
            if (parsedError?.includes("Invalid email")) this.error = "Invalid email. Try again.";
            else (0, $9fh1I.SnackController).showError(error);
        } finally{
            this.loading = false;
        }
    }
    onFocusEvent() {
        (0, $6n0eX.EventsController).sendEvent({
            type: "track",
            event: "EMAIL_LOGIN_SELECTED"
        });
    }
};
$1b54721fd2d7a324$export$73f53e8345d3576d.styles = (0, $8c6307044cef185d$export$2e2bcd8739ae039);
$1b54721fd2d7a324$var$__decorate([
    (0, $6eT5F.state)()
], $1b54721fd2d7a324$export$73f53e8345d3576d.prototype, "connectors", void 0);
$1b54721fd2d7a324$var$__decorate([
    (0, $6eT5F.state)()
], $1b54721fd2d7a324$export$73f53e8345d3576d.prototype, "email", void 0);
$1b54721fd2d7a324$var$__decorate([
    (0, $6eT5F.state)()
], $1b54721fd2d7a324$export$73f53e8345d3576d.prototype, "loading", void 0);
$1b54721fd2d7a324$var$__decorate([
    (0, $6eT5F.state)()
], $1b54721fd2d7a324$export$73f53e8345d3576d.prototype, "error", void 0);
$1b54721fd2d7a324$export$73f53e8345d3576d = $1b54721fd2d7a324$var$__decorate([
    (0, $lkv4o.customElement)("w3m-email-login-widget")
], $1b54721fd2d7a324$export$73f53e8345d3576d);


parcelRequire("aAJP9");
var $5mrMQ = parcelRequire("5mrMQ");
var $6Y81T = parcelRequire("6Y81T");
var $jJO2B = parcelRequire("jJO2B");
var $9QkaU = parcelRequire("9QkaU");
var $kGR8V = parcelRequire("kGR8V");
var $6n0eX = parcelRequire("6n0eX");
var $bnxqc = parcelRequire("bnxqc");
var $b6tQF = parcelRequire("b6tQF");
var $8KEpV = parcelRequire("8KEpV");
var $ha6or = parcelRequire("ha6or");
var $iQR2f = parcelRequire("iQR2f");
var $9fh1I = parcelRequire("9fh1I");
var $fyCFg = parcelRequire("fyCFg");
parcelRequire("6eqhe");
var $9rwwE = parcelRequire("9rwwE");
let $5586eb14112caba6$var$isInitialized = false;


class $5586eb14112caba6$export$14b4aa396d4aed9a {
    constructor(options){
        this.initPromise = undefined;
        this.setIsConnected = (isConnected)=>{
            (0, $5mrMQ.AccountController).setIsConnected(isConnected);
        };
        this.setCaipAddress = (caipAddress)=>{
            (0, $5mrMQ.AccountController).setCaipAddress(caipAddress);
        };
        this.setBalance = (balance, balanceSymbol)=>{
            (0, $5mrMQ.AccountController).setBalance(balance, balanceSymbol);
        };
        this.setProfileName = (profileName)=>{
            (0, $5mrMQ.AccountController).setProfileName(profileName);
        };
        this.setProfileImage = (profileImage)=>{
            (0, $5mrMQ.AccountController).setProfileImage(profileImage);
        };
        this.resetAccount = ()=>{
            (0, $5mrMQ.AccountController).resetAccount();
        };
        this.setCaipNetwork = (caipNetwork)=>{
            (0, $b6tQF.NetworkController).setCaipNetwork(caipNetwork);
        };
        this.getCaipNetwork = ()=>(0, $b6tQF.NetworkController).state.caipNetwork;
        this.setRequestedCaipNetworks = (requestedCaipNetworks)=>{
            (0, $b6tQF.NetworkController).setRequestedCaipNetworks(requestedCaipNetworks);
        };
        this.getApprovedCaipNetworksData = ()=>(0, $b6tQF.NetworkController).getApprovedCaipNetworksData();
        this.resetNetwork = ()=>{
            (0, $b6tQF.NetworkController).resetNetwork();
        };
        this.setConnectors = (connectors)=>{
            (0, $9QkaU.ConnectorController).setConnectors(connectors);
        };
        this.addConnector = (connector)=>{
            (0, $9QkaU.ConnectorController).addConnector(connector);
        };
        this.getConnectors = ()=>(0, $9QkaU.ConnectorController).getConnectors();
        this.resetWcConnection = ()=>{
            (0, $jJO2B.ConnectionController).resetWcConnection();
        };
        this.fetchIdentity = (request)=>(0, $6Y81T.BlockchainApiController).fetchIdentity(request);
        this.setAddressExplorerUrl = (addressExplorerUrl)=>{
            (0, $5mrMQ.AccountController).setAddressExplorerUrl(addressExplorerUrl);
        };
        this.setSIWENonce = (nonce)=>{
            (0, $iQR2f.SIWEController).setNonce(nonce);
        };
        this.setSIWESession = (session)=>{
            (0, $iQR2f.SIWEController).setSession(session);
        };
        this.setSIWEStatus = (status)=>{
            (0, $iQR2f.SIWEController).setStatus(status);
        };
        this.setSIWEMessage = (message)=>{
            (0, $iQR2f.SIWEController).setMessage(message);
        };
        this.initControllers(options);
        this.initOrContinue();
    }
    async open(options) {
        await this.initOrContinue();
        (0, $bnxqc.ModalController).open(options);
    }
    async close() {
        await this.initOrContinue();
        (0, $bnxqc.ModalController).close();
    }
    setLoading(loading) {
        (0, $bnxqc.ModalController).setLoading(loading);
    }
    getThemeMode() {
        return (0, $fyCFg.ThemeController).state.themeMode;
    }
    getThemeVariables() {
        return (0, $fyCFg.ThemeController).state.themeVariables;
    }
    setThemeMode(themeMode) {
        (0, $fyCFg.ThemeController).setThemeMode(themeMode);
        (0, $9rwwE.setColorTheme)((0, $fyCFg.ThemeController).state.themeMode);
    }
    setThemeVariables(themeVariables) {
        (0, $fyCFg.ThemeController).setThemeVariables(themeVariables);
        (0, $9rwwE.setThemeVariables)((0, $fyCFg.ThemeController).state.themeVariables);
    }
    subscribeTheme(callback) {
        return (0, $fyCFg.ThemeController).subscribe(callback);
    }
    getState() {
        return {
            ...(0, $ha6or.PublicStateController).state
        };
    }
    subscribeState(callback) {
        return (0, $ha6or.PublicStateController).subscribe(callback);
    }
    showErrorMessage(message) {
        (0, $9fh1I.SnackController).showError(message);
    }
    showSuccessMessage(message) {
        (0, $9fh1I.SnackController).showSuccess(message);
    }
    getEvent() {
        return {
            ...(0, $6n0eX.EventsController).state
        };
    }
    subscribeEvents(callback) {
        return (0, $6n0eX.EventsController).subscribe(callback);
    }
    subscribeSIWEState(callback) {
        return (0, $iQR2f.SIWEController).subscribe(callback);
    }
    initControllers(options) {
        (0, $b6tQF.NetworkController).setClient(options.networkControllerClient);
        (0, $b6tQF.NetworkController).setDefaultCaipNetwork(options.defaultChain);
        (0, $8KEpV.OptionsController).setProjectId(options.projectId);
        (0, $8KEpV.OptionsController).setAllWallets(options.allWallets);
        (0, $8KEpV.OptionsController).setIncludeWalletIds(options.includeWalletIds);
        (0, $8KEpV.OptionsController).setExcludeWalletIds(options.excludeWalletIds);
        (0, $8KEpV.OptionsController).setFeaturedWalletIds(options.featuredWalletIds);
        (0, $8KEpV.OptionsController).setTokens(options.tokens);
        (0, $8KEpV.OptionsController).setTermsConditionsUrl(options.termsConditionsUrl);
        (0, $8KEpV.OptionsController).setPrivacyPolicyUrl(options.privacyPolicyUrl);
        (0, $8KEpV.OptionsController).setCustomWallets(options.customWallets);
        (0, $8KEpV.OptionsController).setEnableAnalytics(options.enableAnalytics);
        (0, $8KEpV.OptionsController).setSdkVersion(options._sdkVersion);
        (0, $jJO2B.ConnectionController).setClient(options.connectionControllerClient);
        if (options.siweControllerClient) {
            const siweClient = options.siweControllerClient;
            (0, $iQR2f.SIWEController).setSIWEClient(siweClient);
        }
        if (options.metadata) (0, $8KEpV.OptionsController).setMetadata(options.metadata);
        if (options.themeMode) (0, $fyCFg.ThemeController).setThemeMode(options.themeMode);
        if (options.themeVariables) (0, $fyCFg.ThemeController).setThemeVariables(options.themeVariables);
        if (options.enableOnramp) (0, $8KEpV.OptionsController).setOnrampEnabled(Boolean(options.enableOnramp));
    }
    async initOrContinue() {
        if (!this.initPromise && !$5586eb14112caba6$var$isInitialized && (0, $kGR8V.CoreHelperUtil).isClient()) {
            $5586eb14112caba6$var$isInitialized = true;
            this.initPromise = new Promise(async (resolve)=>{
                await Promise.all([
                    Promise.resolve((parcelRequire("6eqhe"))),
                    Promise.resolve((parcelRequire("a4aTY")))
                ]);
                const modal = document.createElement("w3m-modal");
                document.body.insertAdjacentElement("beforeend", modal);
                resolve();
            });
        }
        return this.initPromise;
    }
}


parcelRequire("aAJP9");
var $kGR8V = parcelRequire("kGR8V");


const $eee1c86a56cc8066$export$aafe1f751f1bc52a = {
    WALLET_CONNECT_CONNECTOR_ID: "walletConnect",
    INJECTED_CONNECTOR_ID: "injected",
    COINBASE_CONNECTOR_ID: "coinbaseWallet",
    COINBASE_SDK_CONNECTOR_ID: "coinbaseWalletSDK",
    SAFE_CONNECTOR_ID: "safe",
    LEDGER_CONNECTOR_ID: "ledger",
    EIP6963_CONNECTOR_ID: "eip6963",
    EMAIL_CONNECTOR_ID: "w3mEmail",
    EIP155: "eip155",
    ADD_CHAIN_METHOD: "wallet_addEthereumChain",
    EIP6963_ANNOUNCE_EVENT: "eip6963:announceProvider",
    EIP6963_REQUEST_EVENT: "eip6963:requestProvider",
    VERSION: "4.0.11-8c88aa26.0"
};



const $a3808fb44a37fe52$export$fd35d6514357600 = {
    ConnectorExplorerIds: {
        [(0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).COINBASE_CONNECTOR_ID]: "fd20dc426fb37566d803205b19bbc1d4096b248ac04548e3cfb6b3a38bd033aa",
        [(0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).SAFE_CONNECTOR_ID]: "225affb176778569276e484e1b92637ad061b01e13a048b35a9d280c3b58970f",
        [(0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).LEDGER_CONNECTOR_ID]: "19177a98252e07ddfc9af2083ba8e07ef627cb6103467ffebb3f8f4205fd7927"
    },
    EIP155NetworkImageIds: {
        1: "692ed6ba-e569-459a-556a-776476829e00",
        42161: "3bff954d-5cb0-47a0-9a23-d20192e74600",
        43114: "30c46e53-e989-45fb-4549-be3bd4eb3b00",
        56: "93564157-2e8e-4ce7-81df-b264dbee9b00",
        250: "06b26297-fe0c-4733-5d6b-ffa5498aac00",
        10: "ab9c186a-c52f-464b-2906-ca59d760a400",
        137: "41d04d42-da3b-4453-8506-668cc0727900",
        100: "02b53f6a-e3d4-479e-1cb4-21178987d100",
        9001: "f926ff41-260d-4028-635e-91913fc28e00",
        324: "b310f07f-4ef7-49f3-7073-2a0a39685800",
        314: "5a73b3dd-af74-424e-cae0-0de859ee9400",
        4689: "34e68754-e536-40da-c153-6ef2e7188a00",
        1088: "3897a66d-40b9-4833-162f-a2c90531c900",
        1284: "161038da-44ae-4ec7-1208-0ea569454b00",
        1285: "f1d73bb6-5450-4e18-38f7-fb6484264a00",
        7777777: "845c60df-d429-4991-e687-91ae45791600",
        42220: "ab781bbc-ccc6-418d-d32d-789b15da1f00",
        8453: "7289c336-3981-4081-c5f4-efc26ac64a00",
        1313161554: "3ff73439-a619-4894-9262-4470c773a100",
        2020: "b8101fc0-9c19-4b6f-ec65-f6dfff106e00",
        2021: "b8101fc0-9c19-4b6f-ec65-f6dfff106e00"
    },
    ConnectorImageIds: {
        [(0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).COINBASE_CONNECTOR_ID]: "0c2840c3-5b04-4c44-9661-fbd4b49e1800",
        [(0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).COINBASE_SDK_CONNECTOR_ID]: "0c2840c3-5b04-4c44-9661-fbd4b49e1800",
        [(0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).SAFE_CONNECTOR_ID]: "461db637-8616-43ce-035a-d89b8a1d5800",
        [(0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).LEDGER_CONNECTOR_ID]: "54a1aa77-d202-4f8d-0fb2-5d2bb6db0300",
        [(0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).WALLET_CONNECT_CONNECTOR_ID]: "ef1a1fcf-7fe8-4d69-bd6d-fda1345b4400",
        [(0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).INJECTED_CONNECTOR_ID]: "07ba87ed-43aa-4adf-4540-9e6a2b9cae00"
    },
    ConnectorNamesMap: {
        [(0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).INJECTED_CONNECTOR_ID]: "Browser Wallet",
        [(0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).WALLET_CONNECT_CONNECTOR_ID]: "WalletConnect",
        [(0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).COINBASE_CONNECTOR_ID]: "Coinbase",
        [(0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).COINBASE_SDK_CONNECTOR_ID]: "Coinbase",
        [(0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).LEDGER_CONNECTOR_ID]: "Ledger",
        [(0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).SAFE_CONNECTOR_ID]: "Safe"
    },
    ConnectorTypesMap: {
        [(0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).INJECTED_CONNECTOR_ID]: "INJECTED",
        [(0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).WALLET_CONNECT_CONNECTOR_ID]: "WALLET_CONNECT",
        [(0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).EIP6963_CONNECTOR_ID]: "ANNOUNCED",
        [(0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).EMAIL_CONNECTOR_ID]: "EMAIL"
    },
    WalletConnectRpcChainIds: [
        1,
        5,
        11155111,
        10,
        420,
        42161,
        421613,
        137,
        80001,
        42220,
        1313161554,
        1313161555,
        56,
        97,
        43114,
        43113,
        100,
        8453,
        84531,
        7777777,
        999,
        324,
        280
    ]
};



const $0d4dcbb54d6184cd$export$518f198897991e39 = {
    caipNetworkIdToNumber (caipnetworkId) {
        return caipnetworkId ? Number(caipnetworkId.split(":")[1]) : undefined;
    },
    getCaipTokens (tokens) {
        if (!tokens) return undefined;
        const caipTokens = {};
        Object.entries(tokens).forEach(([id, token])=>{
            caipTokens[`${(0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).EIP155}:${id}`] = token;
        });
        return caipTokens;
    }
};





var $kGR8V = parcelRequire("kGR8V");



var $h1EgD = parcelRequire("h1EgD");

var $6F8ii = parcelRequire("6F8ii");
class $8dbd5d64787cb419$export$d0a48bf953f3c239 extends (0, $6F8ii.BaseError) {
    constructor(){
        super("No URL was provided to the Transport. Please provide a valid RPC URL to the Transport.", {
            docsPath: "/docs/clients/intro",
            name: "UrlRequiredError"
        });
    }
}



var $5ruIR = parcelRequire("5ruIR");

var $h1EgD = parcelRequire("h1EgD");
function $e18475a31f1bc686$export$e86e19342bc4850e(fn, { errorInstance: errorInstance = new Error("timed out"), timeout: timeout, signal: signal }) {
    return new Promise((resolve, reject)=>{
        (async ()=>{
            let timeoutId;
            try {
                const controller = new AbortController();
                if (timeout > 0) timeoutId = setTimeout(()=>{
                    if (signal) controller.abort();
                    else reject(errorInstance);
                }, timeout); // need to cast because bun globals.d.ts overrides @types/node
                resolve(await fn({
                    signal: controller?.signal || null
                }));
            } catch (err) {
                if (err?.name === "AbortError") reject(errorInstance);
                reject(err);
            } finally{
                clearTimeout(timeoutId);
            }
        })();
    });
}



var $lOTY7 = parcelRequire("lOTY7");
function $2a3e2044aea97697$var$createIdStore() {
    return {
        current: 0,
        take () {
            return this.current++;
        },
        reset () {
            this.current = 0;
        }
    };
}
const $2a3e2044aea97697$export$94f79fd1fae0679e = /*#__PURE__*/ $2a3e2044aea97697$var$createIdStore();


function $86c5b4edf1530728$export$290dc69d3612792(url, options = {}) {
    return {
        async request (params) {
            const { body: body, onRequest: onRequest = options.onRequest, onResponse: onResponse = options.onResponse, timeout: timeout = options.timeout ?? 10000 } = params;
            const fetchOptions = {
                ...options.fetchOptions ?? {},
                ...params.fetchOptions ?? {}
            };
            const { headers: headers, method: method, signal: signal_ } = fetchOptions;
            try {
                const response = await (0, $e18475a31f1bc686$export$e86e19342bc4850e)(async ({ signal: signal })=>{
                    const init = {
                        ...fetchOptions,
                        body: Array.isArray(body) ? (0, $lOTY7.stringify)(body.map((body)=>({
                                jsonrpc: "2.0",
                                id: body.id ?? (0, $2a3e2044aea97697$export$94f79fd1fae0679e).take(),
                                ...body
                            }))) : (0, $lOTY7.stringify)({
                            jsonrpc: "2.0",
                            id: body.id ?? (0, $2a3e2044aea97697$export$94f79fd1fae0679e).take(),
                            ...body
                        }),
                        headers: {
                            "Content-Type": "application/json",
                            ...headers
                        },
                        method: method || "POST",
                        signal: signal_ || (timeout > 0 ? signal : null)
                    };
                    const request = new Request(url, init);
                    if (onRequest) await onRequest(request);
                    const response = await fetch(url, init);
                    return response;
                }, {
                    errorInstance: new (0, $h1EgD.TimeoutError)({
                        body: body,
                        url: url
                    }),
                    timeout: timeout,
                    signal: true
                });
                if (onResponse) await onResponse(response);
                let data;
                if (response.headers.get("Content-Type")?.startsWith("application/json")) data = await response.json();
                else {
                    data = await response.text();
                    data = JSON.parse(data || "{}");
                }
                if (!response.ok) throw new (0, $h1EgD.HttpRequestError)({
                    body: body,
                    details: (0, $lOTY7.stringify)(data.error) || response.statusText,
                    headers: response.headers,
                    status: response.status,
                    url: url
                });
                return data;
            } catch (err) {
                if (err instanceof (0, $h1EgD.HttpRequestError)) throw err;
                if (err instanceof (0, $h1EgD.TimeoutError)) throw err;
                throw new (0, $h1EgD.HttpRequestError)({
                    body: body,
                    cause: err,
                    url: url
                });
            }
        }
    };
}



function $f31cbc431d98644d$export$7d6f1c8842f9f527(/** URL of the JSON-RPC API. Defaults to the chain's public RPC URL. */ url, config = {}) {
    const { batch: batch, fetchOptions: fetchOptions, key: key = "http", name: name = "HTTP JSON-RPC", onFetchRequest: onFetchRequest, onFetchResponse: onFetchResponse, retryDelay: retryDelay } = config;
    return ({ chain: chain, retryCount: retryCount_, timeout: timeout_ })=>{
        const { batchSize: batchSize = 1000, wait: wait = 0 } = typeof batch === "object" ? batch : {};
        const retryCount = config.retryCount ?? retryCount_;
        const timeout = timeout_ ?? config.timeout ?? 10000;
        const url_ = url || chain?.rpcUrls.default.http[0];
        if (!url_) throw new (0, $8dbd5d64787cb419$export$d0a48bf953f3c239)();
        const rpcClient = (0, $86c5b4edf1530728$export$290dc69d3612792)(url_, {
            fetchOptions: fetchOptions,
            onRequest: onFetchRequest,
            onResponse: onFetchResponse,
            timeout: timeout
        });
        return (0, $c589f4bfc5acd4e5$export$d09f50d9ab7f7b69)({
            key: key,
            name: name,
            async request ({ method: method, params: params }) {
                const body = {
                    method: method,
                    params: params
                };
                const { schedule: schedule } = (0, $5ruIR.createBatchScheduler)({
                    id: url_,
                    wait: wait,
                    shouldSplitBatch (requests) {
                        return requests.length > batchSize;
                    },
                    fn: (body)=>rpcClient.request({
                            body: body
                        }),
                    sort: (a, b)=>a.id - b.id
                });
                const fn = async (body)=>batch ? schedule(body) : [
                        await rpcClient.request({
                            body: body
                        })
                    ];
                const [{ error: error, result: result }] = await fn(body);
                if (error) throw new (0, $h1EgD.RpcRequestError)({
                    body: body,
                    error: error,
                    url: url_
                });
                return result;
            },
            retryCount: retryCount,
            retryDelay: retryDelay,
            timeout: timeout,
            type: "http"
        }, {
            fetchOptions: fetchOptions,
            url: url_
        });
    };
}


function $2f170f342e8ad217$export$1ee567fcdafbf4d8(chain) {
    if (!chain) return undefined;
    return {
        id: `${(0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).EIP155}:${chain.id}`,
        name: chain.name,
        imageId: (0, $a3808fb44a37fe52$export$fd35d6514357600).EIP155NetworkImageIds[chain.id]
    };
}
async function $2f170f342e8ad217$export$24a8d1cae47a6f(connector) {
    if (!connector) throw new Error("networkControllerClient:getApprovedCaipNetworks - connector is undefined");
    const provider = await connector?.getProvider();
    const ns = provider?.signer?.session?.namespaces;
    const nsMethods = ns?.[(0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).EIP155]?.methods;
    const nsChains = ns?.[(0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).EIP155]?.chains;
    return {
        supportsAllNetworks: Boolean(nsMethods?.includes((0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).ADD_CHAIN_METHOD)),
        approvedCaipNetworkIds: nsChains
    };
}
function $2f170f342e8ad217$export$94f91666d3e5b28f() {
    return {
        supportsAllNetworks: false,
        approvedCaipNetworkIds: (0, $a3808fb44a37fe52$export$fd35d6514357600).WalletConnectRpcChainIds.map((id)=>`${(0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).EIP155}:${id}`)
    };
}
function $2f170f342e8ad217$export$867d8b939ab7f43e({ chainId: chainId, projectId: projectId }) {
    const RPC_URL = (0, $kGR8V.CoreHelperUtil).getBlockchainApiUrl();
    if (!(0, $a3808fb44a37fe52$export$fd35d6514357600).WalletConnectRpcChainIds.includes(chainId)) return (0, $f31cbc431d98644d$export$7d6f1c8842f9f527)();
    return (0, $f31cbc431d98644d$export$7d6f1c8842f9f527)(`${RPC_URL}/v1/?chainId=${(0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).EIP155}:${chainId}&projectId=${projectId}`);
}



parcelRequire("aAJP9");
var $5S5Lx = parcelRequire("5S5Lx");
class $ea8eaf0132f2eca6$export$c03599cd5308d12b extends (0, $5586eb14112caba6$export$14b4aa396d4aed9a) {
    constructor(options){
        const { wagmiConfig: wagmiConfig, siweConfig: siweConfig, defaultChain: defaultChain, tokens: tokens, _sdkVersion: _sdkVersion, ...w3mOptions } = options;
        if (!wagmiConfig) throw new Error("web3modal:constructor - wagmiConfig is undefined");
        if (!w3mOptions.projectId) throw new Error("web3modal:constructor - projectId is undefined");
        const networkControllerClient = {
            switchCaipNetwork: async (caipNetwork)=>{
                const chainId = (0, $0d4dcbb54d6184cd$export$518f198897991e39).caipNetworkIdToNumber(caipNetwork?.id);
                if (chainId) await (0, $c901df8c4828f5ee$export$15599da40e72d2f)(this.wagmiConfig, {
                    chainId: chainId
                });
            },
            getApprovedCaipNetworksData: async ()=>new Promise((resolve)=>{
                    const connections = new Map(wagmiConfig.state.connections);
                    const connection = connections.get(wagmiConfig.state.current || "");
                    if (connection?.connector?.id === (0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).EMAIL_CONNECTOR_ID) resolve((0, $2f170f342e8ad217$export$94f91666d3e5b28f)());
                    else if (connection?.connector?.id === (0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).WALLET_CONNECT_CONNECTOR_ID) {
                        const connector = wagmiConfig.connectors.find((c)=>c.id === (0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).WALLET_CONNECT_CONNECTOR_ID);
                        resolve((0, $2f170f342e8ad217$export$24a8d1cae47a6f)(connector));
                    }
                    resolve({
                        approvedCaipNetworkIds: undefined,
                        supportsAllNetworks: true
                    });
                })
        };
        const connectionControllerClient = {
            connectWalletConnect: async (onUri)=>{
                const connector = wagmiConfig.connectors.find((c)=>c.id === (0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).WALLET_CONNECT_CONNECTOR_ID);
                if (!connector) throw new Error("connectionControllerClient:getWalletConnectUri - connector is undefined");
                const provider = await connector.getProvider();
                provider.on("display_uri", (data)=>{
                    onUri(data);
                });
                const chainId = (0, $0d4dcbb54d6184cd$export$518f198897991e39).caipNetworkIdToNumber(this.getCaipNetwork()?.id);
                await (0, $d3212b9943bd80f3$export$64605811ab45167f)(this.wagmiConfig, {
                    connector: connector,
                    chainId: chainId
                });
            },
            connectExternal: async ({ id: id, provider: provider, info: info })=>{
                const connector = wagmiConfig.connectors.find((c)=>c.id === id);
                if (!connector) throw new Error("connectionControllerClient:connectExternal - connector is undefined");
                if (provider && info && connector.id === (0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).EIP6963_CONNECTOR_ID) connector.setEip6963Wallet?.({
                    provider: provider,
                    info: info
                });
                const chainId = (0, $0d4dcbb54d6184cd$export$518f198897991e39).caipNetworkIdToNumber(this.getCaipNetwork()?.id);
                await (0, $d3212b9943bd80f3$export$64605811ab45167f)(this.wagmiConfig, {
                    connector: connector,
                    chainId: chainId
                });
            },
            checkInstalled: (ids)=>{
                const injectedConnector = this.getConnectors().find((c)=>c.type === "INJECTED");
                if (!ids) return Boolean(window.ethereum);
                if (injectedConnector) {
                    if (!window?.ethereum) return false;
                    return ids.some((id)=>Boolean(window.ethereum?.[String(id)]));
                }
                return false;
            },
            disconnect: async ()=>{
                await (0, $16e09604f761585b$export$37dfea93db2e14ed)(this.wagmiConfig);
                if (siweConfig?.options?.signOutOnDisconnect) await siweConfig.signOut();
            },
            signMessage: async (message)=>(0, $97f5eab29dd3b733$export$1d9a7a8a40780de)(this.wagmiConfig, {
                    message: message
                })
        };
        super({
            networkControllerClient: networkControllerClient,
            connectionControllerClient: connectionControllerClient,
            siweControllerClient: siweConfig,
            defaultChain: (0, $2f170f342e8ad217$export$1ee567fcdafbf4d8)(defaultChain),
            tokens: (0, $0d4dcbb54d6184cd$export$518f198897991e39).getCaipTokens(tokens),
            _sdkVersion: _sdkVersion ?? `html-wagmi-${(0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).VERSION}`,
            ...w3mOptions
        });
        this.hasSyncedConnectedAccount = false;
        this.options = undefined;
        this.options = options;
        this.wagmiConfig = wagmiConfig;
        this.syncRequestedNetworks([
            ...wagmiConfig.chains
        ]);
        this.syncConnectors([
            ...wagmiConfig.connectors
        ]);
        (0, $6e12989ef2b0dce4$export$9c8eec0a0da048a0)(this.wagmiConfig, {
            onChange: (connectors)=>this.syncConnectors(connectors)
        });
        (0, $de8ec52414ac50d6$export$30c94aeff2da2ac6)(this.wagmiConfig, {
            onChange: (accountData)=>this.syncAccount({
                    ...accountData
                })
        });
    }
    getState() {
        const state = super.getState();
        return {
            ...state,
            selectedNetworkId: (0, $0d4dcbb54d6184cd$export$518f198897991e39).caipNetworkIdToNumber(state.selectedNetworkId)
        };
    }
    subscribeState(callback) {
        return super.subscribeState((state)=>callback({
                ...state,
                selectedNetworkId: (0, $0d4dcbb54d6184cd$export$518f198897991e39).caipNetworkIdToNumber(state.selectedNetworkId)
            }));
    }
    syncRequestedNetworks(chains) {
        const requestedCaipNetworks = chains?.map((chain)=>({
                id: `${(0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).EIP155}:${chain.id}`,
                name: chain.name,
                imageId: (0, $a3808fb44a37fe52$export$fd35d6514357600).EIP155NetworkImageIds[chain.id],
                imageUrl: this.options?.chainImages?.[chain.id]
            }));
        this.setRequestedCaipNetworks(requestedCaipNetworks ?? []);
    }
    async syncAccount({ address: address, isConnected: isConnected, chainId: chainId }) {
        this.resetAccount();
        this.syncNetwork();
        if (isConnected && address && chainId) {
            const caipAddress = `${(0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).EIP155}:${chainId}:${address}`;
            this.setIsConnected(isConnected);
            this.setCaipAddress(caipAddress);
            await Promise.all([
                this.syncProfile(address, chainId),
                this.syncBalance(address, chainId),
                this.getApprovedCaipNetworksData()
            ]);
            this.hasSyncedConnectedAccount = true;
        } else if (!isConnected && this.hasSyncedConnectedAccount) {
            this.resetWcConnection();
            this.resetNetwork();
        }
    }
    async syncNetwork() {
        const { address: address, isConnected: isConnected, chainId: chainId } = (0, $135a5279acb2ac27$export$4f9234baf34abd0)(this.wagmiConfig);
        const chain = this.wagmiConfig.chains.find((c)=>c.id === chainId);
        if (chain || chainId) {
            const name = chain?.name ?? chainId?.toString();
            const id = Number(chain?.id ?? chainId);
            const caipChainId = `${(0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).EIP155}:${id}`;
            this.setCaipNetwork({
                id: caipChainId,
                name: name,
                imageId: (0, $a3808fb44a37fe52$export$fd35d6514357600).EIP155NetworkImageIds[id],
                imageUrl: this.options?.chainImages?.[id]
            });
            if (isConnected && address && chainId) {
                const caipAddress = `${(0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).EIP155}:${id}:${address}`;
                this.setCaipAddress(caipAddress);
                if (chain?.blockExplorers?.default?.url) {
                    const url = `${chain.blockExplorers.default.url}/address/${address}`;
                    this.setAddressExplorerUrl(url);
                } else this.setAddressExplorerUrl(undefined);
                if (this.hasSyncedConnectedAccount) {
                    await this.syncProfile(address, chainId);
                    await this.syncBalance(address, chainId);
                }
            }
        }
    }
    async syncProfile(address, chainId) {
        if (chainId !== (0, $fcacb2d075a52fce$export$536d3e0d2c7baf54).id) {
            this.setProfileName(null);
            this.setProfileImage(null);
            return;
        }
        try {
            const { name: name, avatar: avatar } = await this.fetchIdentity({
                caipChainId: `${(0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).EIP155}:${chainId}`,
                address: address
            });
            this.setProfileName(name);
            this.setProfileImage(avatar);
        } catch  {
            const profileName = await (0, $fd667582dd660e5f$export$e1b98d9bc05a9fc2)(this.wagmiConfig, {
                address: address,
                chainId: chainId
            });
            if (profileName) {
                this.setProfileName(profileName);
                const profileImage = await (0, $ef0552246eb5e90b$export$65f1d2b9649a54e5)(this.wagmiConfig, {
                    name: profileName,
                    chainId: chainId
                });
                if (profileImage) this.setProfileImage(profileImage);
            }
        }
    }
    async syncBalance(address, chainId) {
        const chain = this.wagmiConfig.chains.find((c)=>c.id === chainId);
        if (chain) {
            const balance = await (0, $1bd324b76344de3f$export$df96cd8d56be0ab1)(this.wagmiConfig, {
                address: address,
                chainId: chain.id,
                token: this.options?.tokens?.[chain.id]?.address
            });
            this.setBalance(balance.formatted, balance.symbol);
            return;
        }
        this.setBalance(undefined, undefined);
    }
    syncConnectors(connectors) {
        const uniqueIds = new Set();
        const filteredConnectors = connectors.filter((item)=>!uniqueIds.has(item.id) && uniqueIds.add(item.id));
        const w3mConnectors = [];
        const coinbaseSDKId = (0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).COINBASE_SDK_CONNECTOR_ID;
        const coinbaseConnector = filteredConnectors.find((c)=>c.id === (0, $5S5Lx.ConstantsUtil).CONNECTOR_RDNS_MAP[coinbaseSDKId]);
        filteredConnectors.forEach(({ id: id, name: name, type: type, icon: icon })=>{
            const shouldSkip = coinbaseConnector && id === coinbaseSDKId || (0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).EMAIL_CONNECTOR_ID === id;
            if (!shouldSkip) w3mConnectors.push({
                id: id,
                explorerId: (0, $a3808fb44a37fe52$export$fd35d6514357600).ConnectorExplorerIds[id],
                imageUrl: this.options?.connectorImages?.[id] ?? icon,
                name: (0, $a3808fb44a37fe52$export$fd35d6514357600).ConnectorNamesMap[id] ?? name,
                imageId: (0, $a3808fb44a37fe52$export$fd35d6514357600).ConnectorImageIds[id],
                type: (0, $a3808fb44a37fe52$export$fd35d6514357600).ConnectorTypesMap[type] ?? "EXTERNAL"
            });
        });
        this.setConnectors(w3mConnectors);
        this.syncEmailConnector(filteredConnectors);
    }
    async syncEmailConnector(connectors) {
        const emailConnector = connectors.find(({ id: id })=>id === (0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).EMAIL_CONNECTOR_ID);
        if (emailConnector) {
            const provider = await emailConnector.getProvider();
            this.addConnector({
                id: (0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).EMAIL_CONNECTOR_ID,
                type: "EMAIL",
                name: "Email",
                provider: provider
            });
            this.listenEmailConnector(emailConnector);
            this.listenModal(emailConnector);
        }
    }
    async listenEmailConnector(connector) {
        if (typeof window !== "undefined" && connector) {
            super.setLoading(true);
            const provider = await connector.getProvider();
            const isLoginEmailUsed = provider.getLoginEmailUsed();
            super.setLoading(isLoginEmailUsed);
            if (isLoginEmailUsed) this.setIsConnected(false);
            provider.onRpcRequest((request)=>{
                if ((0, $d45dd643a7118621$export$794efc40d8765bc4).checkIfRequestExists(request)) {
                    if (!(0, $d45dd643a7118621$export$794efc40d8765bc4).checkIfRequestIsAllowed(request)) super.open({
                        view: "ApproveTransaction"
                    });
                } else {
                    super.open();
                    const method = (0, $d45dd643a7118621$export$794efc40d8765bc4).getRequestMethod(request);
                    console.error((0, $7e71742c1a96e4ab$export$9975694bfb286db).RPC_METHOD_NOT_ALLOWED_MESSAGE, {
                        method: method
                    });
                    setTimeout(()=>{
                        this.showErrorMessage((0, $7e71742c1a96e4ab$export$9975694bfb286db).RPC_METHOD_NOT_ALLOWED_UI_MESSAGE);
                    }, 300);
                    provider.rejectRpcRequest();
                }
            });
            provider.onRpcResponse(()=>{
                super.close();
            });
            provider.onNotConnected(()=>{
                this.setIsConnected(false);
                super.setLoading(false);
            });
            provider.onIsConnected(()=>{
                this.setIsConnected(true);
                super.setLoading(false);
            });
        }
    }
    async listenModal(connector) {
        const provider = await connector.getProvider();
        this.subscribeState((val)=>{
            if (!val.open) provider.rejectRpcRequest();
        });
    }
}



/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $72daf82bb1be7de3$export$a143d493d941bafc;
var $72daf82bb1be7de3$export$e4cf37d7f6fb9e0a;
var $72daf82bb1be7de3$export$f99ded8fe4b79145;
var $72daf82bb1be7de3$export$599f31c3813fae4d;
"use strict";

var $bQMRt = parcelRequire("bQMRt");

var $dbnIE = parcelRequire("dbnIE");
const $72daf82bb1be7de3$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$72daf82bb1be7de3$export$a143d493d941bafc = $72daf82bb1be7de3$var$Buffer;
$72daf82bb1be7de3$export$e4cf37d7f6fb9e0a = $72daf82bb1be7de3$var$SlowBuffer;
$72daf82bb1be7de3$export$f99ded8fe4b79145 = 50;
const $72daf82bb1be7de3$var$K_MAX_LENGTH = 0x7fffffff;
$72daf82bb1be7de3$export$599f31c3813fae4d = $72daf82bb1be7de3$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $72daf82bb1be7de3$var$Buffer.TYPED_ARRAY_SUPPORT = $72daf82bb1be7de3$var$typedArraySupport();
if (!$72daf82bb1be7de3$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $72daf82bb1be7de3$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($72daf82bb1be7de3$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$72daf82bb1be7de3$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($72daf82bb1be7de3$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$72daf82bb1be7de3$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $72daf82bb1be7de3$var$createBuffer(length) {
    if (length > $72daf82bb1be7de3$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $72daf82bb1be7de3$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $72daf82bb1be7de3$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $72daf82bb1be7de3$var$allocUnsafe(arg);
    }
    return $72daf82bb1be7de3$var$from(arg, encodingOrOffset, length);
}
$72daf82bb1be7de3$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $72daf82bb1be7de3$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $72daf82bb1be7de3$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $72daf82bb1be7de3$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($72daf82bb1be7de3$var$isInstance(value, ArrayBuffer) || value && $72daf82bb1be7de3$var$isInstance(value.buffer, ArrayBuffer)) return $72daf82bb1be7de3$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($72daf82bb1be7de3$var$isInstance(value, SharedArrayBuffer) || value && $72daf82bb1be7de3$var$isInstance(value.buffer, SharedArrayBuffer))) return $72daf82bb1be7de3$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $72daf82bb1be7de3$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $72daf82bb1be7de3$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $72daf82bb1be7de3$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $72daf82bb1be7de3$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $72daf82bb1be7de3$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($72daf82bb1be7de3$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($72daf82bb1be7de3$var$Buffer, Uint8Array);
function $72daf82bb1be7de3$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $72daf82bb1be7de3$var$alloc(size, fill, encoding) {
    $72daf82bb1be7de3$var$assertSize(size);
    if (size <= 0) return $72daf82bb1be7de3$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $72daf82bb1be7de3$var$createBuffer(size).fill(fill, encoding) : $72daf82bb1be7de3$var$createBuffer(size).fill(fill);
    return $72daf82bb1be7de3$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $72daf82bb1be7de3$var$Buffer.alloc = function(size, fill, encoding) {
    return $72daf82bb1be7de3$var$alloc(size, fill, encoding);
};
function $72daf82bb1be7de3$var$allocUnsafe(size) {
    $72daf82bb1be7de3$var$assertSize(size);
    return $72daf82bb1be7de3$var$createBuffer(size < 0 ? 0 : $72daf82bb1be7de3$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $72daf82bb1be7de3$var$Buffer.allocUnsafe = function(size) {
    return $72daf82bb1be7de3$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $72daf82bb1be7de3$var$Buffer.allocUnsafeSlow = function(size) {
    return $72daf82bb1be7de3$var$allocUnsafe(size);
};
function $72daf82bb1be7de3$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$72daf82bb1be7de3$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $72daf82bb1be7de3$var$byteLength(string, encoding) | 0;
    let buf = $72daf82bb1be7de3$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $72daf82bb1be7de3$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $72daf82bb1be7de3$var$checked(array.length) | 0;
    const buf = $72daf82bb1be7de3$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $72daf82bb1be7de3$var$fromArrayView(arrayView) {
    if ($72daf82bb1be7de3$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $72daf82bb1be7de3$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $72daf82bb1be7de3$var$fromArrayLike(arrayView);
}
function $72daf82bb1be7de3$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $72daf82bb1be7de3$var$Buffer.prototype);
    return buf;
}
function $72daf82bb1be7de3$var$fromObject(obj) {
    if ($72daf82bb1be7de3$var$Buffer.isBuffer(obj)) {
        const len = $72daf82bb1be7de3$var$checked(obj.length) | 0;
        const buf = $72daf82bb1be7de3$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $72daf82bb1be7de3$var$numberIsNaN(obj.length)) return $72daf82bb1be7de3$var$createBuffer(0);
        return $72daf82bb1be7de3$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $72daf82bb1be7de3$var$fromArrayLike(obj.data);
}
function $72daf82bb1be7de3$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $72daf82bb1be7de3$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $72daf82bb1be7de3$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $72daf82bb1be7de3$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $72daf82bb1be7de3$var$Buffer.alloc(+length);
}
$72daf82bb1be7de3$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $72daf82bb1be7de3$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$72daf82bb1be7de3$var$Buffer.compare = function compare(a, b) {
    if ($72daf82bb1be7de3$var$isInstance(a, Uint8Array)) a = $72daf82bb1be7de3$var$Buffer.from(a, a.offset, a.byteLength);
    if ($72daf82bb1be7de3$var$isInstance(b, Uint8Array)) b = $72daf82bb1be7de3$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$72daf82bb1be7de3$var$Buffer.isBuffer(a) || !$72daf82bb1be7de3$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$72daf82bb1be7de3$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$72daf82bb1be7de3$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $72daf82bb1be7de3$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $72daf82bb1be7de3$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($72daf82bb1be7de3$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$72daf82bb1be7de3$var$Buffer.isBuffer(buf)) buf = $72daf82bb1be7de3$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$72daf82bb1be7de3$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $72daf82bb1be7de3$var$byteLength(string, encoding) {
    if ($72daf82bb1be7de3$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $72daf82bb1be7de3$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $72daf82bb1be7de3$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $72daf82bb1be7de3$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $72daf82bb1be7de3$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$72daf82bb1be7de3$var$Buffer.byteLength = $72daf82bb1be7de3$var$byteLength;
function $72daf82bb1be7de3$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $72daf82bb1be7de3$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $72daf82bb1be7de3$var$utf8Slice(this, start, end);
        case "ascii":
            return $72daf82bb1be7de3$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $72daf82bb1be7de3$var$latin1Slice(this, start, end);
        case "base64":
            return $72daf82bb1be7de3$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $72daf82bb1be7de3$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$72daf82bb1be7de3$var$Buffer.prototype._isBuffer = true;
function $72daf82bb1be7de3$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$72daf82bb1be7de3$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$72daf82bb1be7de3$var$swap(this, i, i + 1);
    return this;
};
$72daf82bb1be7de3$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $72daf82bb1be7de3$var$swap(this, i, i + 3);
        $72daf82bb1be7de3$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$72daf82bb1be7de3$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $72daf82bb1be7de3$var$swap(this, i, i + 7);
        $72daf82bb1be7de3$var$swap(this, i + 1, i + 6);
        $72daf82bb1be7de3$var$swap(this, i + 2, i + 5);
        $72daf82bb1be7de3$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$72daf82bb1be7de3$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $72daf82bb1be7de3$var$utf8Slice(this, 0, length);
    return $72daf82bb1be7de3$var$slowToString.apply(this, arguments);
};
$72daf82bb1be7de3$var$Buffer.prototype.toLocaleString = $72daf82bb1be7de3$var$Buffer.prototype.toString;
$72daf82bb1be7de3$var$Buffer.prototype.equals = function equals(b) {
    if (!$72daf82bb1be7de3$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $72daf82bb1be7de3$var$Buffer.compare(this, b) === 0;
};
$72daf82bb1be7de3$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $72daf82bb1be7de3$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($72daf82bb1be7de3$var$customInspectSymbol) $72daf82bb1be7de3$var$Buffer.prototype[$72daf82bb1be7de3$var$customInspectSymbol] = $72daf82bb1be7de3$var$Buffer.prototype.inspect;
$72daf82bb1be7de3$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($72daf82bb1be7de3$var$isInstance(target, Uint8Array)) target = $72daf82bb1be7de3$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$72daf82bb1be7de3$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $72daf82bb1be7de3$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($72daf82bb1be7de3$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $72daf82bb1be7de3$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($72daf82bb1be7de3$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $72daf82bb1be7de3$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $72daf82bb1be7de3$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $72daf82bb1be7de3$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$72daf82bb1be7de3$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$72daf82bb1be7de3$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $72daf82bb1be7de3$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$72daf82bb1be7de3$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $72daf82bb1be7de3$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $72daf82bb1be7de3$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($72daf82bb1be7de3$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $72daf82bb1be7de3$var$utf8Write(buf, string, offset, length) {
    return $72daf82bb1be7de3$var$blitBuffer($72daf82bb1be7de3$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $72daf82bb1be7de3$var$asciiWrite(buf, string, offset, length) {
    return $72daf82bb1be7de3$var$blitBuffer($72daf82bb1be7de3$var$asciiToBytes(string), buf, offset, length);
}
function $72daf82bb1be7de3$var$base64Write(buf, string, offset, length) {
    return $72daf82bb1be7de3$var$blitBuffer($72daf82bb1be7de3$var$base64ToBytes(string), buf, offset, length);
}
function $72daf82bb1be7de3$var$ucs2Write(buf, string, offset, length) {
    return $72daf82bb1be7de3$var$blitBuffer($72daf82bb1be7de3$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$72daf82bb1be7de3$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $72daf82bb1be7de3$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $72daf82bb1be7de3$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $72daf82bb1be7de3$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $72daf82bb1be7de3$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $72daf82bb1be7de3$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$72daf82bb1be7de3$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $72daf82bb1be7de3$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $bQMRt.fromByteArray(buf);
    else return $bQMRt.fromByteArray(buf.slice(start, end));
}
function $72daf82bb1be7de3$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $72daf82bb1be7de3$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $72daf82bb1be7de3$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $72daf82bb1be7de3$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $72daf82bb1be7de3$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $72daf82bb1be7de3$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $72daf82bb1be7de3$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $72daf82bb1be7de3$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $72daf82bb1be7de3$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $72daf82bb1be7de3$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $72daf82bb1be7de3$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$72daf82bb1be7de3$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $72daf82bb1be7de3$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $72daf82bb1be7de3$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$72daf82bb1be7de3$var$Buffer.prototype.readUintLE = $72daf82bb1be7de3$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $72daf82bb1be7de3$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$72daf82bb1be7de3$var$Buffer.prototype.readUintBE = $72daf82bb1be7de3$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $72daf82bb1be7de3$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$72daf82bb1be7de3$var$Buffer.prototype.readUint8 = $72daf82bb1be7de3$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $72daf82bb1be7de3$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$72daf82bb1be7de3$var$Buffer.prototype.readUint16LE = $72daf82bb1be7de3$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $72daf82bb1be7de3$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$72daf82bb1be7de3$var$Buffer.prototype.readUint16BE = $72daf82bb1be7de3$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $72daf82bb1be7de3$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$72daf82bb1be7de3$var$Buffer.prototype.readUint32LE = $72daf82bb1be7de3$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $72daf82bb1be7de3$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$72daf82bb1be7de3$var$Buffer.prototype.readUint32BE = $72daf82bb1be7de3$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $72daf82bb1be7de3$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$72daf82bb1be7de3$var$Buffer.prototype.readBigUInt64LE = $72daf82bb1be7de3$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $72daf82bb1be7de3$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $72daf82bb1be7de3$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$72daf82bb1be7de3$var$Buffer.prototype.readBigUInt64BE = $72daf82bb1be7de3$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $72daf82bb1be7de3$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $72daf82bb1be7de3$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$72daf82bb1be7de3$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $72daf82bb1be7de3$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$72daf82bb1be7de3$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $72daf82bb1be7de3$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$72daf82bb1be7de3$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $72daf82bb1be7de3$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$72daf82bb1be7de3$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $72daf82bb1be7de3$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$72daf82bb1be7de3$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $72daf82bb1be7de3$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$72daf82bb1be7de3$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $72daf82bb1be7de3$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$72daf82bb1be7de3$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $72daf82bb1be7de3$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$72daf82bb1be7de3$var$Buffer.prototype.readBigInt64LE = $72daf82bb1be7de3$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $72daf82bb1be7de3$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $72daf82bb1be7de3$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$72daf82bb1be7de3$var$Buffer.prototype.readBigInt64BE = $72daf82bb1be7de3$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $72daf82bb1be7de3$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $72daf82bb1be7de3$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$72daf82bb1be7de3$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $72daf82bb1be7de3$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, true, 23, 4);
};
$72daf82bb1be7de3$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $72daf82bb1be7de3$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, false, 23, 4);
};
$72daf82bb1be7de3$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $72daf82bb1be7de3$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, true, 52, 8);
};
$72daf82bb1be7de3$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $72daf82bb1be7de3$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, false, 52, 8);
};
function $72daf82bb1be7de3$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$72daf82bb1be7de3$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$72daf82bb1be7de3$var$Buffer.prototype.writeUintLE = $72daf82bb1be7de3$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $72daf82bb1be7de3$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$72daf82bb1be7de3$var$Buffer.prototype.writeUintBE = $72daf82bb1be7de3$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $72daf82bb1be7de3$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$72daf82bb1be7de3$var$Buffer.prototype.writeUint8 = $72daf82bb1be7de3$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $72daf82bb1be7de3$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$72daf82bb1be7de3$var$Buffer.prototype.writeUint16LE = $72daf82bb1be7de3$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $72daf82bb1be7de3$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$72daf82bb1be7de3$var$Buffer.prototype.writeUint16BE = $72daf82bb1be7de3$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $72daf82bb1be7de3$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$72daf82bb1be7de3$var$Buffer.prototype.writeUint32LE = $72daf82bb1be7de3$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $72daf82bb1be7de3$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$72daf82bb1be7de3$var$Buffer.prototype.writeUint32BE = $72daf82bb1be7de3$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $72daf82bb1be7de3$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $72daf82bb1be7de3$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $72daf82bb1be7de3$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $72daf82bb1be7de3$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $72daf82bb1be7de3$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$72daf82bb1be7de3$var$Buffer.prototype.writeBigUInt64LE = $72daf82bb1be7de3$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $72daf82bb1be7de3$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$72daf82bb1be7de3$var$Buffer.prototype.writeBigUInt64BE = $72daf82bb1be7de3$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $72daf82bb1be7de3$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$72daf82bb1be7de3$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $72daf82bb1be7de3$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$72daf82bb1be7de3$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $72daf82bb1be7de3$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$72daf82bb1be7de3$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $72daf82bb1be7de3$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$72daf82bb1be7de3$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $72daf82bb1be7de3$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$72daf82bb1be7de3$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $72daf82bb1be7de3$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$72daf82bb1be7de3$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $72daf82bb1be7de3$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$72daf82bb1be7de3$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $72daf82bb1be7de3$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$72daf82bb1be7de3$var$Buffer.prototype.writeBigInt64LE = $72daf82bb1be7de3$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $72daf82bb1be7de3$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$72daf82bb1be7de3$var$Buffer.prototype.writeBigInt64BE = $72daf82bb1be7de3$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $72daf82bb1be7de3$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $72daf82bb1be7de3$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $72daf82bb1be7de3$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $72daf82bb1be7de3$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$72daf82bb1be7de3$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $72daf82bb1be7de3$var$writeFloat(this, value, offset, true, noAssert);
};
$72daf82bb1be7de3$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $72daf82bb1be7de3$var$writeFloat(this, value, offset, false, noAssert);
};
function $72daf82bb1be7de3$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $72daf82bb1be7de3$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$72daf82bb1be7de3$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $72daf82bb1be7de3$var$writeDouble(this, value, offset, true, noAssert);
};
$72daf82bb1be7de3$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $72daf82bb1be7de3$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$72daf82bb1be7de3$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$72daf82bb1be7de3$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$72daf82bb1be7de3$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$72daf82bb1be7de3$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $72daf82bb1be7de3$var$Buffer.isBuffer(val) ? val : $72daf82bb1be7de3$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $72daf82bb1be7de3$var$errors = {};
function $72daf82bb1be7de3$var$E(sym, getMessage, Base) {
    $72daf82bb1be7de3$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$72daf82bb1be7de3$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$72daf82bb1be7de3$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$72daf82bb1be7de3$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $72daf82bb1be7de3$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $72daf82bb1be7de3$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $72daf82bb1be7de3$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $72daf82bb1be7de3$var$checkBounds(buf, offset, byteLength) {
    $72daf82bb1be7de3$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $72daf82bb1be7de3$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $72daf82bb1be7de3$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $72daf82bb1be7de3$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $72daf82bb1be7de3$var$checkBounds(buf, offset, byteLength);
}
function $72daf82bb1be7de3$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $72daf82bb1be7de3$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $72daf82bb1be7de3$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $72daf82bb1be7de3$var$validateNumber(value, type);
        throw new $72daf82bb1be7de3$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $72daf82bb1be7de3$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $72daf82bb1be7de3$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $72daf82bb1be7de3$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $72daf82bb1be7de3$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($72daf82bb1be7de3$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $72daf82bb1be7de3$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $72daf82bb1be7de3$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $72daf82bb1be7de3$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $72daf82bb1be7de3$var$base64ToBytes(str) {
    return $bQMRt.toByteArray($72daf82bb1be7de3$var$base64clean(str));
}
function $72daf82bb1be7de3$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $72daf82bb1be7de3$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $72daf82bb1be7de3$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $72daf82bb1be7de3$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $72daf82bb1be7de3$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $72daf82bb1be7de3$var$BufferBigIntNotDefined : fn;
}
function $72daf82bb1be7de3$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


if (typeof window !== "undefined") {
    if (!window.Buffer) window.Buffer = (0, $72daf82bb1be7de3$export$a143d493d941bafc);
    if (!window.global) window.global = window;
    if (!window.process) window.process = {};
    if (!window.process?.env) window.process = {
        env: {}
    };
}


/**
 * Announces an EIP-1193 Provider.
 */ function $3855503a58cf486c$export$60dbeacb3287962a(detail) {
    const event = new CustomEvent("eip6963:announceProvider", {
        detail: Object.freeze(detail)
    });
    window.dispatchEvent(event);
    const handler = ()=>window.dispatchEvent(event);
    window.addEventListener("eip6963:requestProvider", handler);
    return ()=>window.removeEventListener("eip6963:requestProvider", handler);
}
function $3855503a58cf486c$export$f262fc9233ecbc18(listener) {
    const handler = (event)=>listener(event.detail);
    window.addEventListener("eip6963:announceProvider", handler);
    window.dispatchEvent(new CustomEvent("eip6963:requestProvider"));
    return ()=>window.removeEventListener("eip6963:announceProvider", handler);
}


function $775a09647a26399d$export$f51a9068ac82ea43() {
    const listeners = new Set();
    let providerDetails = [];
    const request = ()=>(0, $3855503a58cf486c$export$f262fc9233ecbc18)((providerDetail)=>{
            if (providerDetails.some(({ info: info })=>info.uuid === providerDetail.info.uuid)) return;
            providerDetails = [
                ...providerDetails,
                providerDetail
            ];
            listeners.forEach((listener)=>listener(providerDetails, {
                    added: [
                        providerDetail
                    ]
                }));
        });
    let unwatch = request();
    return {
        _listeners () {
            return listeners;
        },
        clear () {
            listeners.forEach((listener)=>listener([], {
                    removed: [
                        ...providerDetails
                    ]
                }));
            providerDetails = [];
        },
        destroy () {
            this.clear();
            listeners.clear();
            unwatch();
        },
        findProvider ({ rdns: rdns }) {
            return providerDetails.find((providerDetail)=>providerDetail.info.rdns === rdns);
        },
        getProviders () {
            return providerDetails;
        },
        reset () {
            this.clear();
            unwatch();
            unwatch = request();
        },
        subscribe (listener, { emitImmediately: emitImmediately } = {}) {
            listeners.add(listener);
            if (emitImmediately) listener(providerDetails, {
                added: providerDetails
            });
            return ()=>listeners.delete(listener);
        }
    };
}



var $b20fdb5cec4c4e73$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/middleware.mjs"
});
const $b20fdb5cec4c4e73$var$reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...a)=>api.dispatch(...a),
            ...initial
        };
    };
const $b20fdb5cec4c4e73$export$4feba8a1bc8e9afd = $b20fdb5cec4c4e73$var$reduxImpl;
const $b20fdb5cec4c4e73$var$trackedConnections = /* @__PURE__ */ new Map();
const $b20fdb5cec4c4e73$var$getTrackedConnectionState = (name)=>{
    const api = $b20fdb5cec4c4e73$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const $b20fdb5cec4c4e73$var$extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = $b20fdb5cec4c4e73$var$trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store: store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $b20fdb5cec4c4e73$var$trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store: store,
        ...newConnection
    };
};
const $b20fdb5cec4c4e73$var$devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled: enabled, anonymousActionType: anonymousActionType, store: store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : ($b20fdb5cec4c4e73$import_meta.env ? $b20fdb5cec4c4e73$import_meta.env.MODE : void 0) !== "production") && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (e) {}
        if (!extensionConnector) {
            if (($b20fdb5cec4c4e73$import_meta.env ? $b20fdb5cec4c4e73$import_meta.env.MODE : void 0) !== "production" && enabled) console.warn("[zustand devtools middleware] Please install/enable Redux devtools extension");
            return fn(set, get, api);
        }
        const { connection: connection, ...connectionInformation } = $b20fdb5cec4c4e73$var$extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...$b20fdb5cec4c4e73$var$getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...a)=>{
                if (($b20fdb5cec4c4e73$import_meta.env ? $b20fdb5cec4c4e73$import_meta.env.MODE : void 0) !== "production" && a[0].type === "__setState" && !didWarnAboutReservedActionType) {
                    console.warn('[zustand devtools middleware] "__setState" action type is reserved to set state from the devtools. Avoid using it.');
                    didWarnAboutReservedActionType = true;
                }
                originalDispatch(...a);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $b20fdb5cec4c4e73$var$parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format. 
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($b20fdb5cec4c4e73$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($b20fdb5cec4c4e73$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $b20fdb5cec4c4e73$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($b20fdb5cec4c4e73$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $b20fdb5cec4c4e73$var$parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState: nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const $b20fdb5cec4c4e73$export$6922d3b3a607469e = $b20fdb5cec4c4e73$var$devtoolsImpl;
const $b20fdb5cec4c4e73$var$parseJsonThen = (stringified, f)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) f(parsed);
};
const $b20fdb5cec4c4e73$var$subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const $b20fdb5cec4c4e73$export$5c593627aef9f076 = $b20fdb5cec4c4e73$var$subscribeWithSelectorImpl;
const $b20fdb5cec4c4e73$export$1be1fc439b849fdf = (initialState, create)=>(...a)=>Object.assign({}, initialState, create(...a));
function $b20fdb5cec4c4e73$export$95a3b7b12ab518f9(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const $b20fdb5cec4c4e73$var$toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return $b20fdb5cec4c4e73$var$toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return $b20fdb5cec4c4e73$var$toThenable(onRejected)(e);
                }
            };
        }
    };
const $b20fdb5cec4c4e73$var$oldImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            getStorage: ()=>localStorage,
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage;
        try {
            storage = options.getStorage();
        } catch (e) {}
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const thenableSerialize = $b20fdb5cec4c4e73$var$toThenable(options.serialize);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            let errorInSync;
            const thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then((serializedValue)=>storage.setItem(options.name, serializedValue)).catch((e)=>{
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        let stateFromStorage;
        const hydrate = ()=>{
            var _a;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>cb(get()));
            const postRehydrationCallback = ((_a = options.onRehydrateStorage) == null ? void 0 : _a.call(options, get())) || void 0;
            return $b20fdb5cec4c4e73$var$toThenable(storage.getItem.bind(storage))(options.name).then((storageValue)=>{
                if (storageValue) return options.deserialize(storageValue);
            }).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
const $b20fdb5cec4c4e73$var$newImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: $b20fdb5cec4c4e73$export$95a3b7b12ab518f9(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            setItem();
        }, get, api);
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return $b20fdb5cec4c4e73$var$toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return deserializedStorageValue.state;
                }
            }).then((migratedState)=>{
                var _a2;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const $b20fdb5cec4c4e73$var$persistImpl = (config, baseOptions)=>{
    if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) {
        if (($b20fdb5cec4c4e73$import_meta.env ? $b20fdb5cec4c4e73$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] `getStorage`, `serialize` and `deserialize` options are deprecated. Use `storage` option instead.");
        return $b20fdb5cec4c4e73$var$oldImpl(config, baseOptions);
    }
    return $b20fdb5cec4c4e73$var$newImpl(config, baseOptions);
};
const $b20fdb5cec4c4e73$export$9a6132153fba2e0 = $b20fdb5cec4c4e73$var$persistImpl;


var $127e56833d52979e$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/vanilla.mjs"
});
const $127e56833d52979e$var$createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object") ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const destroy = ()=>{
        if (($127e56833d52979e$import_meta.env ? $127e56833d52979e$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.");
        listeners.clear();
    };
    const api = {
        setState: setState,
        getState: getState,
        subscribe: subscribe,
        destroy: destroy
    };
    state = createState(setState, getState, api);
    return api;
};
const $127e56833d52979e$export$f51a9068ac82ea43 = (createState)=>createState ? $127e56833d52979e$var$createStoreImpl(createState) : $127e56833d52979e$var$createStoreImpl;
var $127e56833d52979e$export$2e2bcd8739ae039 = (createState)=>{
    if (($127e56833d52979e$import_meta.env ? $127e56833d52979e$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use import { createStore } from 'zustand/vanilla'.");
    return $127e56833d52979e$export$f51a9068ac82ea43(createState);
};




var $lqRRD = parcelRequire("lqRRD");
var $9UP4H = parcelRequire("9UP4H");
var $k7R6B = parcelRequire("k7R6B");







function $44d491b0b6ab42ee$export$36e7227504c841ea(createConnectorFn) {
    return createConnectorFn;
}


// Regex of wallets/providers that can accurately simulate contract calls & display contract revert reasons.
const $a3694b226b0a0592$var$supportsSimulationIdRegex = /(rabby|trustwallet)/;
const $a3694b226b0a0592$var$targetMap = {
    coinbaseWallet: {
        id: "coinbaseWallet",
        name: "Coinbase Wallet",
        provider (window1) {
            if (window1?.coinbaseWalletExtension) return window1.coinbaseWalletExtension;
            return $a3694b226b0a0592$var$findProvider(window1, "isCoinbaseWallet");
        }
    },
    metaMask: {
        id: "metaMask",
        name: "MetaMask",
        provider (window1) {
            return $a3694b226b0a0592$var$findProvider(window1, (provider)=>{
                if (!provider.isMetaMask) return false;
                // Brave tries to make itself look like MetaMask
                // Could also try RPC `web3_clientVersion` if following is unreliable
                if (provider.isBraveWallet && !provider._events && !provider._state) return false;
                // Other wallets that try to look like MetaMask
                const flags = [
                    "isApexWallet",
                    "isAvalanche",
                    "isBitKeep",
                    "isBlockWallet",
                    "isKuCoinWallet",
                    "isMathWallet",
                    "isOkxWallet",
                    "isOKExWallet",
                    "isOneInchIOSWallet",
                    "isOneInchAndroidWallet",
                    "isOpera",
                    "isPortal",
                    "isRabby",
                    "isTokenPocket",
                    "isTokenary",
                    "isZerion"
                ];
                for (const flag of flags)if (provider[flag]) return false;
                return true;
            });
        }
    },
    phantom: {
        id: "phantom",
        name: "Phantom",
        provider (window1) {
            if (window1?.phantom?.ethereum) return window1.phantom?.ethereum;
            return $a3694b226b0a0592$var$findProvider(window1, "isPhantom");
        }
    }
};
$a3694b226b0a0592$export$a7a34dad4983656f.type = "injected";
function $a3694b226b0a0592$export$a7a34dad4983656f(parameters = {}) {
    const { shimDisconnect: shimDisconnect = true, unstable_shimAsyncInject: unstable_shimAsyncInject } = parameters;
    function getTarget() {
        const target = parameters.target;
        if (typeof target === "function") {
            const result = target();
            if (result) return result;
        }
        if (typeof target === "object") return target;
        if (typeof target === "string") return {
            ...$a3694b226b0a0592$var$targetMap[target] ?? {
                id: target,
                name: `${target[0].toUpperCase()}${target.slice(1)}`,
                provider: `is${target[0].toUpperCase()}${target.slice(1)}`
            }
        };
        return {
            id: "injected",
            name: "Injected",
            provider (window1) {
                return window1?.ethereum;
            }
        };
    }
    let accountsChanged;
    let chainChanged;
    let connect;
    let disconnect;
    return (0, $44d491b0b6ab42ee$export$36e7227504c841ea)((config)=>({
            get icon () {
                return getTarget().icon;
            },
            get id () {
                return getTarget().id;
            },
            get name () {
                return getTarget().name;
            },
            get supportsSimulation () {
                return $a3694b226b0a0592$var$supportsSimulationIdRegex.test(this.id.toLowerCase());
            },
            type: $a3694b226b0a0592$export$a7a34dad4983656f.type,
            async setup () {
                const provider = await this.getProvider();
                // Only start listening for events if `target` is set, otherwise `injected()` will also receive events
                if (provider && parameters.target) {
                    if (!connect) {
                        connect = this.onConnect.bind(this);
                        provider.on("connect", connect);
                    }
                    // We shouldn't need to listen for `'accountsChanged'` here since the `'connect'` event should suffice (and wallet shouldn't be connected yet).
                    // Some wallets, like MetaMask, do not implement the `'connect'` event and overload `'accountsChanged'` instead.
                    if (!accountsChanged) {
                        accountsChanged = this.onAccountsChanged.bind(this);
                        provider.on("accountsChanged", accountsChanged);
                    }
                }
            },
            async connect ({ chainId: chainId, isReconnecting: isReconnecting } = {}) {
                const provider = await this.getProvider();
                if (!provider) throw new (0, $2c3d10fbf0154625$export$43839b3ff6336f15)();
                let accounts = [];
                if (isReconnecting) accounts = await this.getAccounts().catch(()=>[]);
                else if (shimDisconnect) // Attempt to show another prompt for selecting account if `shimDisconnect` flag is enabled
                try {
                    const permissions = await provider.request({
                        method: "wallet_requestPermissions",
                        params: [
                            {
                                eth_accounts: {}
                            }
                        ]
                    });
                    accounts = permissions[0]?.caveats?.[0]?.value?.map((x)=>(0, $lqRRD.getAddress)(x));
                } catch (err) {
                    const error = err;
                    // Not all injected providers support `wallet_requestPermissions` (e.g. MetaMask iOS).
                    // Only bubble up error if user rejects request
                    if (error.code === (0, $k7R6B.UserRejectedRequestError).code) throw new (0, $k7R6B.UserRejectedRequestError)(error);
                    // Or prompt is already open
                    if (error.code === (0, $k7R6B.ResourceUnavailableRpcError).code) throw error;
                }
                try {
                    if (!accounts?.length && !isReconnecting) {
                        const requestedAccounts = await provider.request({
                            method: "eth_requestAccounts"
                        });
                        accounts = requestedAccounts.map((x)=>(0, $lqRRD.getAddress)(x));
                    }
                    // Manage EIP-1193 event listeners
                    // https://eips.ethereum.org/EIPS/eip-1193#events
                    if (connect) {
                        provider.removeListener("connect", connect);
                        connect = undefined;
                    }
                    if (!accountsChanged) {
                        accountsChanged = this.onAccountsChanged.bind(this);
                        provider.on("accountsChanged", accountsChanged);
                    }
                    if (!chainChanged) {
                        chainChanged = this.onChainChanged.bind(this);
                        provider.on("chainChanged", chainChanged);
                    }
                    if (!disconnect) {
                        disconnect = this.onDisconnect.bind(this);
                        provider.on("disconnect", disconnect);
                    }
                    // Switch to chain if provided
                    let currentChainId = await this.getChainId();
                    if (chainId && currentChainId !== chainId) {
                        const chain = await this.switchChain({
                            chainId: chainId
                        }).catch((error)=>{
                            if (error.code === (0, $k7R6B.UserRejectedRequestError).code) throw error;
                            return {
                                id: currentChainId
                            };
                        });
                        currentChainId = chain?.id ?? currentChainId;
                    }
                    // Remove disconnected shim if it exists
                    if (shimDisconnect) await config.storage?.removeItem(`${this.id}.disconnected`);
                    // Add connected shim if no target exists
                    if (!parameters.target) await config.storage?.setItem("injected.connected", true);
                    return {
                        accounts: accounts,
                        chainId: currentChainId
                    };
                } catch (err) {
                    const error = err;
                    if (error.code === (0, $k7R6B.UserRejectedRequestError).code) throw new (0, $k7R6B.UserRejectedRequestError)(error);
                    if (error.code === (0, $k7R6B.ResourceUnavailableRpcError).code) throw new (0, $k7R6B.ResourceUnavailableRpcError)(error);
                    throw error;
                }
            },
            async disconnect () {
                const provider = await this.getProvider();
                if (!provider) throw new (0, $2c3d10fbf0154625$export$43839b3ff6336f15)();
                // Manage EIP-1193 event listeners
                if (chainChanged) {
                    provider.removeListener("chainChanged", chainChanged);
                    chainChanged = undefined;
                }
                if (disconnect) {
                    provider.removeListener("disconnect", disconnect);
                    disconnect = undefined;
                }
                if (!connect) {
                    connect = this.onConnect.bind(this);
                    provider.on("connect", connect);
                }
                // Experimental support for MetaMask disconnect
                // https://github.com/MetaMask/metamask-improvement-proposals/blob/main/MIPs/mip-2.md
                try {
                    // TODO: Remove explicit type for viem@3
                    await provider.request({
                        // `'wallet_revokePermissions'` added in `viem@2.10.3`
                        method: "wallet_revokePermissions",
                        params: [
                            {
                                eth_accounts: {}
                            }
                        ]
                    });
                } catch  {}
                // Add shim signalling connector is disconnected
                if (shimDisconnect) await config.storage?.setItem(`${this.id}.disconnected`, true);
                if (!parameters.target) await config.storage?.removeItem("injected.connected");
            },
            async getAccounts () {
                const provider = await this.getProvider();
                if (!provider) throw new (0, $2c3d10fbf0154625$export$43839b3ff6336f15)();
                const accounts = await provider.request({
                    method: "eth_accounts"
                });
                return accounts.map((x)=>(0, $lqRRD.getAddress)(x));
            },
            async getChainId () {
                const provider = await this.getProvider();
                if (!provider) throw new (0, $2c3d10fbf0154625$export$43839b3ff6336f15)();
                const hexChainId = await provider.request({
                    method: "eth_chainId"
                });
                return Number(hexChainId);
            },
            async getProvider () {
                if (typeof window === "undefined") return undefined;
                let provider;
                const target = getTarget();
                if (typeof target.provider === "function") provider = target.provider(window);
                else if (typeof target.provider === "string") provider = $a3694b226b0a0592$var$findProvider(window, target.provider);
                else provider = target.provider;
                // Some wallets do not conform to EIP-1193 (e.g. Trust Wallet)
                // https://github.com/wevm/wagmi/issues/3526#issuecomment-1912683002
                if (provider && !provider.removeListener) {
                    // Try using `off` handler if it exists, otherwise noop
                    if ("off" in provider && typeof provider.off === "function") provider.removeListener = provider.off;
                    else provider.removeListener = ()=>{};
                }
                return provider;
            },
            async isAuthorized () {
                try {
                    const isDisconnected = shimDisconnect && // If shim exists in storage, connector is disconnected
                    await config.storage?.getItem(`${this.id}.disconnected`);
                    if (isDisconnected) return false;
                    // Don't allow injected connector to connect if no target is set and it hasn't already connected
                    // (e.g. flag in storage is not set). This prevents a targetless injected connector from connecting
                    // automatically whenever there is a targeted connector configured.
                    if (!parameters.target) {
                        const connected = await config.storage?.getItem("injected.connected");
                        if (!connected) return false;
                    }
                    const provider = await this.getProvider();
                    if (!provider) {
                        if (unstable_shimAsyncInject !== undefined && unstable_shimAsyncInject !== false) {
                            // If no provider is found, check for async injection
                            // https://github.com/wevm/references/issues/167
                            // https://github.com/MetaMask/detect-provider
                            const handleEthereum = async ()=>{
                                if (typeof window !== "undefined") window.removeEventListener("ethereum#initialized", handleEthereum);
                                const provider = await this.getProvider();
                                return !!provider;
                            };
                            const timeout = typeof unstable_shimAsyncInject === "number" ? unstable_shimAsyncInject : 1000;
                            const res = await Promise.race([
                                ...typeof window !== "undefined" ? [
                                    new Promise((resolve)=>window.addEventListener("ethereum#initialized", ()=>resolve(handleEthereum()), {
                                            once: true
                                        }))
                                ] : [],
                                new Promise((resolve)=>setTimeout(()=>resolve(handleEthereum()), timeout))
                            ]);
                            if (res) return true;
                        }
                        throw new (0, $2c3d10fbf0154625$export$43839b3ff6336f15)();
                    }
                    // We are applying a retry & timeout strategy here as some injected wallets (e.g. MetaMask) fail to
                    // immediately resolve a JSON-RPC request on page load.
                    const accounts = await (0, $019d66023bd7f6ee$export$188df5ecf8e7961a)(()=>(0, $e18475a31f1bc686$export$e86e19342bc4850e)(()=>this.getAccounts(), {
                            timeout: 100
                        }));
                    return !!accounts.length;
                } catch  {
                    return false;
                }
            },
            async switchChain ({ addEthereumChainParameter: addEthereumChainParameter, chainId: chainId }) {
                const provider = await this.getProvider();
                if (!provider) throw new (0, $2c3d10fbf0154625$export$43839b3ff6336f15)();
                const chain = config.chains.find((x)=>x.id === chainId);
                if (!chain) throw new (0, $k7R6B.SwitchChainError)(new (0, $e9e19674d26bdf1a$export$688e5fda4b4631ed)());
                try {
                    await Promise.all([
                        provider.request({
                            method: "wallet_switchEthereumChain",
                            params: [
                                {
                                    chainId: (0, $9UP4H.numberToHex)(chainId)
                                }
                            ]
                        })// During `'wallet_switchEthereumChain'`, MetaMask makes a `'net_version'` RPC call to the target chain.
                        // If this request fails, MetaMask does not emit the `'chainChanged'` event, but will still switch the chain.
                        // To counter this behavior, we request and emit the current chain ID to confirm the chain switch either via
                        // this callback or an externally emitted `'chainChanged'` event.
                        // https://github.com/MetaMask/metamask-extension/issues/24247
                        .then(async ()=>{
                            const currentChainId = await this.getChainId();
                            if (currentChainId === chainId) config.emitter.emit("change", {
                                chainId: chainId
                            });
                        }),
                        new Promise((resolve)=>config.emitter.once("change", ({ chainId: currentChainId })=>{
                                if (currentChainId === chainId) resolve();
                            }))
                    ]);
                    return chain;
                } catch (err) {
                    const error = err;
                    // Indicates chain is not added to provider
                    if (error.code === 4902 || // Unwrapping for MetaMask Mobile
                    // https://github.com/MetaMask/metamask-mobile/issues/2944#issuecomment-976988719
                    error?.data?.originalError?.code === 4902) try {
                        const { default: blockExplorer, ...blockExplorers } = chain.blockExplorers ?? {};
                        let blockExplorerUrls;
                        if (addEthereumChainParameter?.blockExplorerUrls) blockExplorerUrls = addEthereumChainParameter.blockExplorerUrls;
                        else if (blockExplorer) blockExplorerUrls = [
                            blockExplorer.url,
                            ...Object.values(blockExplorers).map((x)=>x.url)
                        ];
                        let rpcUrls;
                        if (addEthereumChainParameter?.rpcUrls?.length) rpcUrls = addEthereumChainParameter.rpcUrls;
                        else rpcUrls = [
                            chain.rpcUrls.default?.http[0] ?? ""
                        ];
                        const addEthereumChain = {
                            blockExplorerUrls: blockExplorerUrls,
                            chainId: (0, $9UP4H.numberToHex)(chainId),
                            chainName: addEthereumChainParameter?.chainName ?? chain.name,
                            iconUrls: addEthereumChainParameter?.iconUrls,
                            nativeCurrency: addEthereumChainParameter?.nativeCurrency ?? chain.nativeCurrency,
                            rpcUrls: rpcUrls
                        };
                        await provider.request({
                            method: "wallet_addEthereumChain",
                            params: [
                                addEthereumChain
                            ]
                        });
                        const currentChainId = await this.getChainId();
                        if (currentChainId !== chainId) throw new (0, $k7R6B.UserRejectedRequestError)(new Error("User rejected switch after adding network."));
                        return chain;
                    } catch (error) {
                        throw new (0, $k7R6B.UserRejectedRequestError)(error);
                    }
                    if (error.code === (0, $k7R6B.UserRejectedRequestError).code) throw new (0, $k7R6B.UserRejectedRequestError)(error);
                    throw new (0, $k7R6B.SwitchChainError)(error);
                }
            },
            async onAccountsChanged (accounts) {
                // Disconnect if there are no accounts
                if (accounts.length === 0) this.onDisconnect();
                else if (config.emitter.listenerCount("connect")) {
                    const chainId = (await this.getChainId()).toString();
                    this.onConnect({
                        chainId: chainId
                    });
                    // Remove disconnected shim if it exists
                    if (shimDisconnect) await config.storage?.removeItem(`${this.id}.disconnected`);
                } else config.emitter.emit("change", {
                    accounts: accounts.map((x)=>(0, $lqRRD.getAddress)(x))
                });
            },
            onChainChanged (chain) {
                const chainId = Number(chain);
                config.emitter.emit("change", {
                    chainId: chainId
                });
            },
            async onConnect (connectInfo) {
                const accounts = await this.getAccounts();
                if (accounts.length === 0) return;
                const chainId = Number(connectInfo.chainId);
                config.emitter.emit("connect", {
                    accounts: accounts,
                    chainId: chainId
                });
                // Manage EIP-1193 event listeners
                const provider = await this.getProvider();
                if (provider) {
                    if (connect) {
                        provider.removeListener("connect", connect);
                        connect = undefined;
                    }
                    if (!accountsChanged) {
                        accountsChanged = this.onAccountsChanged.bind(this);
                        provider.on("accountsChanged", accountsChanged);
                    }
                    if (!chainChanged) {
                        chainChanged = this.onChainChanged.bind(this);
                        provider.on("chainChanged", chainChanged);
                    }
                    if (!disconnect) {
                        disconnect = this.onDisconnect.bind(this);
                        provider.on("disconnect", disconnect);
                    }
                }
            },
            async onDisconnect (error) {
                const provider = await this.getProvider();
                // If MetaMask emits a `code: 1013` error, wait for reconnection before disconnecting
                // https://github.com/MetaMask/providers/pull/120
                if (error && error.code === 1013) {
                    if (provider && !!(await this.getAccounts()).length) return;
                }
                // No need to remove `${this.id}.disconnected` from storage because `onDisconnect` is typically
                // only called when the wallet is disconnected through the wallet's interface, meaning the wallet
                // actually disconnected and we don't need to simulate it.
                config.emitter.emit("disconnect");
                // Manage EIP-1193 event listeners
                if (provider) {
                    if (chainChanged) {
                        provider.removeListener("chainChanged", chainChanged);
                        chainChanged = undefined;
                    }
                    if (disconnect) {
                        provider.removeListener("disconnect", disconnect);
                        disconnect = undefined;
                    }
                    if (!connect) {
                        connect = this.onConnect.bind(this);
                        provider.on("connect", connect);
                    }
                }
            }
        }));
}
function $a3694b226b0a0592$var$findProvider(window1, select) {
    function isProvider(provider) {
        if (typeof select === "function") return select(provider);
        if (typeof select === "string") return provider[select];
        return true;
    }
    const ethereum = window1.ethereum;
    if (ethereum?.providers) return ethereum.providers.find((provider)=>isProvider(provider));
    if (ethereum && isProvider(ethereum)) return ethereum;
    return undefined;
}



var $hcgfX = parcelRequire("hcgfX");
var $14a26a67935edd2a$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($hcgfX)));


var $hcgfX = parcelRequire("hcgfX");
var $d1bc4d6d767ecfee$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $d1bc4d6d767ecfee$var$_Emitter_emitter;
class $d1bc4d6d767ecfee$export$4293555f241ae35a {
    constructor(uid){
        Object.defineProperty(this, "uid", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: uid
        });
        $d1bc4d6d767ecfee$var$_Emitter_emitter.set(this, new (0, (/*@__PURE__*/$parcel$interopDefault($hcgfX)))());
    }
    on(eventName, fn) {
        $d1bc4d6d767ecfee$var$__classPrivateFieldGet(this, $d1bc4d6d767ecfee$var$_Emitter_emitter, "f").on(eventName, fn);
    }
    once(eventName, fn) {
        $d1bc4d6d767ecfee$var$__classPrivateFieldGet(this, $d1bc4d6d767ecfee$var$_Emitter_emitter, "f").once(eventName, fn);
    }
    off(eventName, fn) {
        $d1bc4d6d767ecfee$var$__classPrivateFieldGet(this, $d1bc4d6d767ecfee$var$_Emitter_emitter, "f").off(eventName, fn);
    }
    emit(eventName, ...params) {
        const data = params[0];
        $d1bc4d6d767ecfee$var$__classPrivateFieldGet(this, $d1bc4d6d767ecfee$var$_Emitter_emitter, "f").emit(eventName, {
            uid: this.uid,
            ...data
        });
    }
    listenerCount(eventName) {
        return $d1bc4d6d767ecfee$var$__classPrivateFieldGet(this, $d1bc4d6d767ecfee$var$_Emitter_emitter, "f").listenerCount(eventName);
    }
}
$d1bc4d6d767ecfee$var$_Emitter_emitter = new WeakMap();
function $d1bc4d6d767ecfee$export$6f5e8f34570e3ad1(uid) {
    return new $d1bc4d6d767ecfee$export$4293555f241ae35a(uid);
}




function $b3f2da4a05f00321$export$efcd34ab6248d3cd(value, reviver) {
    return JSON.parse(value, (key, value_)=>{
        let value = value_;
        if (value?.__type === "bigint") value = BigInt(value.value);
        if (value?.__type === "Map") value = new Map(value.value);
        return reviver?.(key, value) ?? value;
    });
}


/**
 * Get the reference key for the circular value
 *
 * @param keys the keys to build the reference key from
 * @param cutoff the maximum number of keys to include
 * @returns the reference key
 */ function $3d58f1f0b8638148$var$getReferenceKey(keys, cutoff) {
    return keys.slice(0, cutoff).join(".") || ".";
}
/**
 * Faster `Array.prototype.indexOf` implementation build for slicing / splicing
 *
 * @param array the array to match the value in
 * @param value the value to match
 * @returns the matching index, or -1
 */ function $3d58f1f0b8638148$var$getCutoff(array, value) {
    const { length: length } = array;
    for(let index = 0; index < length; ++index){
        if (array[index] === value) return index + 1;
    }
    return 0;
}
/**
 * Create a replacer method that handles circular values
 *
 * @param [replacer] a custom replacer to use for non-circular values
 * @param [circularReplacer] a custom replacer to use for circular methods
 * @returns the value to stringify
 */ function $3d58f1f0b8638148$var$createReplacer(replacer, circularReplacer) {
    const hasReplacer = typeof replacer === "function";
    const hasCircularReplacer = typeof circularReplacer === "function";
    const cache = [];
    const keys = [];
    return function replace(key, value) {
        if (typeof value === "object") {
            if (cache.length) {
                const thisCutoff = $3d58f1f0b8638148$var$getCutoff(cache, this);
                if (thisCutoff === 0) cache[cache.length] = this;
                else {
                    cache.splice(thisCutoff);
                    keys.splice(thisCutoff);
                }
                keys[keys.length] = key;
                const valueCutoff = $3d58f1f0b8638148$var$getCutoff(cache, value);
                if (valueCutoff !== 0) return hasCircularReplacer ? circularReplacer.call(this, key, value, $3d58f1f0b8638148$var$getReferenceKey(keys, valueCutoff)) : `[ref=${$3d58f1f0b8638148$var$getReferenceKey(keys, valueCutoff)}]`;
            } else {
                cache[0] = value;
                keys[0] = key;
            }
        }
        return hasReplacer ? replacer.call(this, key, value) : value;
    };
}
function $3d58f1f0b8638148$export$dfdc1655ccc5b9cb(value, replacer, indent, circularReplacer) {
    return JSON.stringify(value, $3d58f1f0b8638148$var$createReplacer((key, value_)=>{
        let value = value_;
        if (typeof value === "bigint") value = {
            __type: "bigint",
            value: value_.toString()
        };
        if (value instanceof Map) value = {
            __type: "Map",
            value: Array.from(value_.entries())
        };
        return replacer?.(key, value) ?? value;
    }, circularReplacer), indent ?? undefined);
}


function $bac1ff7b35b4e502$export$d184a47a971dd4b9(parameters) {
    const { deserialize: deserialize = (0, $b3f2da4a05f00321$export$efcd34ab6248d3cd), key: prefix = "wagmi", serialize: serialize = (0, $3d58f1f0b8638148$export$dfdc1655ccc5b9cb), storage: storage = $bac1ff7b35b4e502$export$e2ef6c4b988c05b } = parameters;
    function unwrap(value) {
        if (value instanceof Promise) return value.then((x)=>x).catch(()=>null);
        return value;
    }
    return {
        ...storage,
        key: prefix,
        async getItem (key, defaultValue) {
            const value = storage.getItem(`${prefix}.${key}`);
            const unwrapped = await unwrap(value);
            if (unwrapped) return deserialize(unwrapped) ?? null;
            return defaultValue ?? null;
        },
        async setItem (key, value) {
            const storageKey = `${prefix}.${key}`;
            if (value === null) await unwrap(storage.removeItem(storageKey));
            else await unwrap(storage.setItem(storageKey, serialize(value)));
        },
        async removeItem (key) {
            await unwrap(storage.removeItem(`${prefix}.${key}`));
        }
    };
}
const $bac1ff7b35b4e502$export$e2ef6c4b988c05b = {
    getItem: ()=>null,
    setItem: ()=>{},
    removeItem: ()=>{}
};



const $b5cd1b2403652282$var$size = 256;
let $b5cd1b2403652282$var$index = $b5cd1b2403652282$var$size;
let $b5cd1b2403652282$var$buffer;
function $b5cd1b2403652282$export$e2a22331486dcca0(length = 11) {
    if (!$b5cd1b2403652282$var$buffer || $b5cd1b2403652282$var$index + length > $b5cd1b2403652282$var$size * 2) {
        $b5cd1b2403652282$var$buffer = "";
        $b5cd1b2403652282$var$index = 0;
        for(let i = 0; i < $b5cd1b2403652282$var$size; i++)$b5cd1b2403652282$var$buffer += (256 + Math.random() * 256 | 0).toString(16).substring(1);
    }
    return $b5cd1b2403652282$var$buffer.substring($b5cd1b2403652282$var$index, $b5cd1b2403652282$var$index++ + length);
}



function $9c50f211ce0a813e$export$45a69314cf48a3eb(parameters) {
    const { multiInjectedProviderDiscovery: multiInjectedProviderDiscovery = true, storage: storage = (0, $bac1ff7b35b4e502$export$d184a47a971dd4b9)({
        storage: typeof window !== "undefined" && window.localStorage ? window.localStorage : (0, $bac1ff7b35b4e502$export$e2ef6c4b988c05b)
    }), syncConnectedChain: syncConnectedChain = true, ssr: ssr, ...rest } = parameters;
    /////////////////////////////////////////////////////////////////////////////////////////////////
    // Set up connectors, clients, etc.
    /////////////////////////////////////////////////////////////////////////////////////////////////
    const mipd = typeof window !== "undefined" && multiInjectedProviderDiscovery ? (0, $775a09647a26399d$export$f51a9068ac82ea43)() : undefined;
    const chains = (0, $127e56833d52979e$export$f51a9068ac82ea43)(()=>rest.chains);
    const connectors = (0, $127e56833d52979e$export$f51a9068ac82ea43)(()=>[
            ...rest.connectors ?? [],
            ...!ssr ? mipd?.getProviders().map(providerDetailToConnector) ?? [] : []
        ].map(setup));
    function setup(connectorFn) {
        // Set up emitter with uid and add to connector so they are "linked" together.
        const emitter = (0, $d1bc4d6d767ecfee$export$6f5e8f34570e3ad1)((0, $b5cd1b2403652282$export$e2a22331486dcca0)());
        const connector = {
            ...connectorFn({
                emitter: emitter,
                chains: chains.getState(),
                storage: storage
            }),
            emitter: emitter,
            uid: emitter.uid
        };
        // Start listening for `connect` events on connector setup
        // This allows connectors to "connect" themselves without user interaction (e.g. MetaMask's "Manually connect to current site")
        emitter.on("connect", connect);
        connector.setup?.();
        return connector;
    }
    function providerDetailToConnector(providerDetail) {
        const { info: info } = providerDetail;
        const provider = providerDetail.provider;
        return (0, $a3694b226b0a0592$export$a7a34dad4983656f)({
            target: {
                ...info,
                id: info.rdns,
                provider: provider
            }
        });
    }
    const clients = new Map();
    function getClient(config = {}) {
        const chainId = config.chainId ?? store.getState().chainId;
        const chain = chains.getState().find((x)=>x.id === chainId);
        // chainId specified and not configured
        if (config.chainId && !chain) throw new (0, $e9e19674d26bdf1a$export$688e5fda4b4631ed)();
        {
            const client = clients.get(store.getState().chainId);
            if (client && !chain) return client;
            else if (!chain) throw new (0, $e9e19674d26bdf1a$export$688e5fda4b4631ed)();
        }
        // If a memoized client exists for a chain id, use that.
        {
            const client = clients.get(chainId);
            if (client) return client;
        }
        let client;
        if (rest.client) client = rest.client({
            chain: chain
        });
        else {
            const chainId = chain.id;
            const chainIds = chains.getState().map((x)=>x.id);
            // Grab all properties off `rest` and resolve for use in `createClient`
            const properties = {};
            const entries = Object.entries(rest);
            for (const [key, value] of entries){
                if (key === "chains" || key === "client" || key === "connectors" || key === "transports") continue;
                else if (typeof value === "object") {
                    // check if value is chainId-specific since some values can be objects
                    // e.g. { batch: { multicall: { batchSize: 1024 } } }
                    if (chainId in value) properties[key] = value[chainId];
                    else {
                        // check if value is chainId-specific, but does not have value for current chainId
                        const hasChainSpecificValue = chainIds.some((x)=>x in value);
                        if (hasChainSpecificValue) continue;
                        properties[key] = value;
                    }
                } else properties[key] = value;
            }
            client = (0, $6a8402de2d7ee6e1$export$5d730b7aed1a3eb0)({
                ...properties,
                chain: chain,
                batch: properties.batch ?? {
                    multicall: true
                },
                transport: (parameters)=>rest.transports[chainId]({
                        ...parameters,
                        connectors: connectors
                    })
            });
        }
        clients.set(chainId, client);
        return client;
    }
    /////////////////////////////////////////////////////////////////////////////////////////////////
    // Create store
    /////////////////////////////////////////////////////////////////////////////////////////////////
    function getInitialState() {
        return {
            chainId: chains.getState()[0].id,
            connections: new Map(),
            current: null,
            status: "disconnected"
        };
    }
    let currentVersion;
    const prefix = "0.0.0-canary-";
    if ((0, $269270ee5aa09b4f$export$83d89fbfd8236492).startsWith(prefix)) currentVersion = parseInt((0, $269270ee5aa09b4f$export$83d89fbfd8236492).replace(prefix, ""));
    else currentVersion = parseInt((0, $269270ee5aa09b4f$export$83d89fbfd8236492).split(".")[0] ?? "0");
    const store = (0, $127e56833d52979e$export$f51a9068ac82ea43)((0, $b20fdb5cec4c4e73$export$5c593627aef9f076)(// only use persist middleware if storage exists
    storage ? (0, $b20fdb5cec4c4e73$export$9a6132153fba2e0)(getInitialState, {
        migrate (persistedState, version) {
            if (version === currentVersion) return persistedState;
            const initialState = getInitialState();
            const chainId = persistedState && typeof persistedState === "object" && "chainId" in persistedState && typeof persistedState.chainId === "number" ? persistedState.chainId : initialState.chainId;
            return {
                ...initialState,
                chainId: chainId
            };
        },
        name: "store",
        partialize (state) {
            // Only persist "critical" store properties to preserve storage size.
            return {
                connections: {
                    __type: "Map",
                    value: Array.from(state.connections.entries()).map(([key, connection])=>{
                        const { id: id, name: name, type: type, uid: uid } = connection.connector;
                        const connector = {
                            id: id,
                            name: name,
                            type: type,
                            uid: uid
                        };
                        return [
                            key,
                            {
                                ...connection,
                                connector: connector
                            }
                        ];
                    })
                },
                chainId: state.chainId,
                current: state.current
            };
        },
        skipHydration: ssr,
        storage: storage,
        version: currentVersion
    }) : getInitialState));
    /////////////////////////////////////////////////////////////////////////////////////////////////
    // Subscribe to changes
    /////////////////////////////////////////////////////////////////////////////////////////////////
    // Update default chain when connector chain changes
    if (syncConnectedChain) store.subscribe(({ connections: connections, current: current })=>current ? connections.get(current)?.chainId : undefined, (chainId)=>{
        // If chain is not configured, then don't switch over to it.
        const isChainConfigured = chains.getState().some((x)=>x.id === chainId);
        if (!isChainConfigured) return;
        return store.setState((x)=>({
                ...x,
                chainId: chainId ?? x.chainId
            }));
    });
    // EIP-6963 subscribe for new wallet providers
    mipd?.subscribe((providerDetails)=>{
        const currentConnectorIds = new Map();
        for (const connector of connectors.getState())currentConnectorIds.set(connector.id, true);
        const newConnectors = [];
        for (const providerDetail of providerDetails){
            const connector = setup(providerDetailToConnector(providerDetail));
            if (currentConnectorIds.has(connector.id)) continue;
            newConnectors.push(connector);
        }
        if (storage && !store.persist.hasHydrated()) return;
        connectors.setState((x)=>[
                ...x,
                ...newConnectors
            ], true);
    });
    /////////////////////////////////////////////////////////////////////////////////////////////////
    // Emitter listeners
    /////////////////////////////////////////////////////////////////////////////////////////////////
    function change(data) {
        store.setState((x)=>{
            const connection = x.connections.get(data.uid);
            if (!connection) return x;
            return {
                ...x,
                connections: new Map(x.connections).set(data.uid, {
                    accounts: data.accounts ?? connection.accounts,
                    chainId: data.chainId ?? connection.chainId,
                    connector: connection.connector
                })
            };
        });
    }
    function connect(data) {
        // Disable handling if reconnecting/connecting
        if (store.getState().status === "connecting" || store.getState().status === "reconnecting") return;
        store.setState((x)=>{
            const connector = connectors.getState().find((x)=>x.uid === data.uid);
            if (!connector) return x;
            if (connector.emitter.listenerCount("connect")) connector.emitter.off("connect", change);
            if (!connector.emitter.listenerCount("change")) connector.emitter.on("change", change);
            if (!connector.emitter.listenerCount("disconnect")) connector.emitter.on("disconnect", disconnect);
            return {
                ...x,
                connections: new Map(x.connections).set(data.uid, {
                    accounts: data.accounts,
                    chainId: data.chainId,
                    connector: connector
                }),
                current: data.uid,
                status: "connected"
            };
        });
    }
    function disconnect(data) {
        store.setState((x)=>{
            const connection = x.connections.get(data.uid);
            if (connection) {
                const connector = connection.connector;
                if (connector.emitter.listenerCount("change")) connection.connector.emitter.off("change", change);
                if (connector.emitter.listenerCount("disconnect")) connection.connector.emitter.off("disconnect", disconnect);
                if (!connector.emitter.listenerCount("connect")) connection.connector.emitter.on("connect", connect);
            }
            x.connections.delete(data.uid);
            if (x.connections.size === 0) return {
                ...x,
                connections: new Map(),
                current: null,
                status: "disconnected"
            };
            const nextConnection = x.connections.values().next().value;
            return {
                ...x,
                connections: new Map(x.connections),
                current: nextConnection.connector.uid
            };
        });
    }
    return {
        get chains () {
            return chains.getState();
        },
        get connectors () {
            return connectors.getState();
        },
        storage: storage,
        getClient: getClient,
        get state () {
            return store.getState();
        },
        setState (value) {
            let newState;
            if (typeof value === "function") newState = value(store.getState());
            else newState = value;
            // Reset state if it got set to something not matching the base state
            const initialState = getInitialState();
            if (typeof newState !== "object") newState = initialState;
            const isCorrupt = Object.keys(initialState).some((x)=>!(x in newState));
            if (isCorrupt) newState = initialState;
            store.setState(newState, true);
        },
        subscribe (selector, listener, options) {
            return store.subscribe(selector, listener, options ? {
                ...options,
                fireImmediately: options.emitImmediately
            } : undefined);
        },
        _internal: {
            mipd: mipd,
            store: store,
            ssr: Boolean(ssr),
            syncConnectedChain: syncConnectedChain,
            transports: rest.transports,
            chains: {
                setState (value) {
                    const nextChains = typeof value === "function" ? value(chains.getState()) : value;
                    if (nextChains.length === 0) return;
                    return chains.setState(nextChains, true);
                },
                subscribe (listener) {
                    return chains.subscribe(listener);
                }
            },
            connectors: {
                providerDetailToConnector: providerDetailToConnector,
                setup: setup,
                setState (value) {
                    return connectors.setState(typeof value === "function" ? value(connectors.getState()) : value, true);
                },
                subscribe (listener) {
                    return connectors.subscribe(listener);
                }
            },
            events: {
                change: change,
                connect: connect,
                disconnect: disconnect
            }
        }
    };
}




var $lqRRD = parcelRequire("lqRRD");
var $9UP4H = parcelRequire("9UP4H");
var $k7R6B = parcelRequire("k7R6B");
$147cdf48ccf56b7f$export$40dfb463b44d19b.type = "coinbaseWallet";

function $147cdf48ccf56b7f$export$40dfb463b44d19b(parameters) {
    const reloadOnDisconnect = false;
    let sdk;
    let walletProvider;
    let accountsChanged;
    let chainChanged;
    let disconnect;
    return (0, $44d491b0b6ab42ee$export$36e7227504c841ea)((config)=>({
            id: "coinbaseWalletSDK",
            name: "Coinbase Wallet",
            supportsSimulation: true,
            type: $147cdf48ccf56b7f$export$40dfb463b44d19b.type,
            async connect ({ chainId: chainId } = {}) {
                try {
                    const provider = await this.getProvider();
                    const accounts = (await provider.request({
                        method: "eth_requestAccounts"
                    })).map((x)=>(0, $lqRRD.getAddress)(x));
                    if (!accountsChanged) {
                        accountsChanged = this.onAccountsChanged.bind(this);
                        provider.on("accountsChanged", accountsChanged);
                    }
                    if (!chainChanged) {
                        chainChanged = this.onChainChanged.bind(this);
                        provider.on("chainChanged", chainChanged);
                    }
                    if (!disconnect) {
                        disconnect = this.onDisconnect.bind(this);
                        provider.on("disconnect", disconnect);
                    }
                    // Switch to chain if provided
                    let currentChainId = await this.getChainId();
                    if (chainId && currentChainId !== chainId) {
                        const chain = await this.switchChain({
                            chainId: chainId
                        }).catch((error)=>{
                            if (error.code === (0, $k7R6B.UserRejectedRequestError).code) throw error;
                            return {
                                id: currentChainId
                            };
                        });
                        currentChainId = chain?.id ?? currentChainId;
                    }
                    return {
                        accounts: accounts,
                        chainId: currentChainId
                    };
                } catch (error) {
                    if (/(user closed modal|accounts received is empty|user denied account)/i.test(error.message)) throw new (0, $k7R6B.UserRejectedRequestError)(error);
                    throw error;
                }
            },
            async disconnect () {
                const provider = await this.getProvider();
                if (accountsChanged) {
                    provider.removeListener("accountsChanged", accountsChanged);
                    accountsChanged = undefined;
                }
                if (chainChanged) {
                    provider.removeListener("chainChanged", chainChanged);
                    chainChanged = undefined;
                }
                if (disconnect) {
                    provider.removeListener("disconnect", disconnect);
                    disconnect = undefined;
                }
                provider.disconnect();
                provider.close();
            },
            async getAccounts () {
                const provider = await this.getProvider();
                return (await provider.request({
                    method: "eth_accounts"
                })).map((x)=>(0, $lqRRD.getAddress)(x));
            },
            async getChainId () {
                const provider = await this.getProvider();
                const chainId = await provider.request({
                    method: "eth_chainId"
                });
                return Number(chainId);
            },
            async getProvider () {
                if (!walletProvider) {
                    const { default: CoinbaseWalletSDK } = await (parcelRequire("kOxZb"));
                    let SDK;
                    if (typeof CoinbaseWalletSDK !== "function" && typeof CoinbaseWalletSDK.default === "function") SDK = CoinbaseWalletSDK.default;
                    else SDK = CoinbaseWalletSDK;
                    sdk = new SDK({
                        reloadOnDisconnect: reloadOnDisconnect,
                        ...parameters
                    });
                    // Force types to retrieve private `walletExtension` method from the Coinbase Wallet SDK.
                    const walletExtensionChainId = sdk.walletExtension?.getChainId();
                    const chain = config.chains.find((chain)=>parameters.chainId ? chain.id === parameters.chainId : chain.id === walletExtensionChainId) || config.chains[0];
                    const chainId = parameters.chainId || chain?.id;
                    const jsonRpcUrl = parameters.jsonRpcUrl || chain?.rpcUrls.default.http[0];
                    walletProvider = sdk.makeWeb3Provider(jsonRpcUrl, chainId);
                }
                return walletProvider;
            },
            async isAuthorized () {
                try {
                    const accounts = await this.getAccounts();
                    return !!accounts.length;
                } catch  {
                    return false;
                }
            },
            async switchChain ({ addEthereumChainParameter: addEthereumChainParameter, chainId: chainId }) {
                const chain = config.chains.find((chain)=>chain.id === chainId);
                if (!chain) throw new (0, $k7R6B.SwitchChainError)(new (0, $e9e19674d26bdf1a$export$688e5fda4b4631ed)());
                const provider = await this.getProvider();
                try {
                    await provider.request({
                        method: "wallet_switchEthereumChain",
                        params: [
                            {
                                chainId: (0, $9UP4H.numberToHex)(chain.id)
                            }
                        ]
                    });
                    return chain;
                } catch (error) {
                    // Indicates chain is not added to provider
                    if (error.code === 4902) try {
                        let blockExplorerUrls;
                        if (addEthereumChainParameter?.blockExplorerUrls) blockExplorerUrls = addEthereumChainParameter.blockExplorerUrls;
                        else blockExplorerUrls = chain.blockExplorers?.default.url ? [
                            chain.blockExplorers?.default.url
                        ] : [];
                        let rpcUrls;
                        if (addEthereumChainParameter?.rpcUrls?.length) rpcUrls = addEthereumChainParameter.rpcUrls;
                        else rpcUrls = [
                            chain.rpcUrls.default?.http[0] ?? ""
                        ];
                        const addEthereumChain = {
                            blockExplorerUrls: blockExplorerUrls,
                            chainId: (0, $9UP4H.numberToHex)(chainId),
                            chainName: addEthereumChainParameter?.chainName ?? chain.name,
                            iconUrls: addEthereumChainParameter?.iconUrls,
                            nativeCurrency: addEthereumChainParameter?.nativeCurrency ?? chain.nativeCurrency,
                            rpcUrls: rpcUrls
                        };
                        await provider.request({
                            method: "wallet_addEthereumChain",
                            params: [
                                addEthereumChain
                            ]
                        });
                        return chain;
                    } catch (error) {
                        throw new (0, $k7R6B.UserRejectedRequestError)(error);
                    }
                    throw new (0, $k7R6B.SwitchChainError)(error);
                }
            },
            onAccountsChanged (accounts) {
                if (accounts.length === 0) this.onDisconnect();
                else config.emitter.emit("change", {
                    accounts: accounts.map((x)=>(0, $lqRRD.getAddress)(x))
                });
            },
            onChainChanged (chain) {
                const chainId = Number(chain);
                config.emitter.emit("change", {
                    chainId: chainId
                });
            },
            async onDisconnect (_error) {
                config.emitter.emit("disconnect");
                const provider = await this.getProvider();
                if (accountsChanged) {
                    provider.removeListener("accountsChanged", accountsChanged);
                    accountsChanged = undefined;
                }
                if (chainChanged) {
                    provider.removeListener("chainChanged", chainChanged);
                    chainChanged = undefined;
                }
                if (disconnect) {
                    provider.removeListener("disconnect", disconnect);
                    disconnect = undefined;
                }
            }
        }));
}




var $lqRRD = parcelRequire("lqRRD");
var $9UP4H = parcelRequire("9UP4H");
var $k7R6B = parcelRequire("k7R6B");
$5b45b7b8431e00a7$export$340cc50ae9d9f255.type = "walletConnect";

function $5b45b7b8431e00a7$export$340cc50ae9d9f255(parameters) {
    const isNewChainsStale = parameters.isNewChainsStale ?? true;
    let provider_;
    let providerPromise;
    const NAMESPACE = "eip155";
    return (0, $44d491b0b6ab42ee$export$36e7227504c841ea)((config)=>({
            id: "walletConnect",
            name: "WalletConnect",
            type: $5b45b7b8431e00a7$export$340cc50ae9d9f255.type,
            async setup () {
                const provider = await this.getProvider().catch(()=>null);
                if (!provider) return;
                provider.on("connect", this.onConnect.bind(this));
                provider.on("session_delete", this.onSessionDelete.bind(this));
            },
            async connect ({ chainId: chainId, ...rest } = {}) {
                try {
                    const provider = await this.getProvider();
                    if (!provider) throw new (0, $2c3d10fbf0154625$export$43839b3ff6336f15)();
                    provider.on("display_uri", this.onDisplayUri);
                    let targetChainId = chainId;
                    if (!targetChainId) {
                        const state = await config.storage?.getItem("state") ?? {};
                        const isChainSupported = config.chains.some((x)=>x.id === state.chainId);
                        if (isChainSupported) targetChainId = state.chainId;
                        else targetChainId = config.chains[0]?.id;
                    }
                    if (!targetChainId) throw new Error("No chains found on connector.");
                    const isChainsStale = await this.isChainsStale();
                    // If there is an active session with stale chains, disconnect current session.
                    if (provider.session && isChainsStale) await provider.disconnect();
                    // If there isn't an active session or chains are stale, connect.
                    if (!provider.session || isChainsStale) {
                        const optionalChains = config.chains.filter((chain)=>chain.id !== targetChainId).map((optionalChain)=>optionalChain.id);
                        await provider.connect({
                            optionalChains: [
                                targetChainId,
                                ...optionalChains
                            ],
                            ..."pairingTopic" in rest ? {
                                pairingTopic: rest.pairingTopic
                            } : {}
                        });
                        this.setRequestedChainsIds(config.chains.map((x)=>x.id));
                    }
                    // If session exists and chains are authorized, enable provider for required chain
                    const accounts = (await provider.enable()).map((x)=>(0, $lqRRD.getAddress)(x));
                    const currentChainId = await this.getChainId();
                    provider.removeListener("display_uri", this.onDisplayUri);
                    provider.removeListener("connect", this.onConnect.bind(this));
                    provider.on("accountsChanged", this.onAccountsChanged.bind(this));
                    provider.on("chainChanged", this.onChainChanged);
                    provider.on("disconnect", this.onDisconnect.bind(this));
                    provider.on("session_delete", this.onSessionDelete.bind(this));
                    return {
                        accounts: accounts,
                        chainId: currentChainId
                    };
                } catch (error) {
                    if (/(user rejected|connection request reset)/i.test(error?.message)) throw new (0, $k7R6B.UserRejectedRequestError)(error);
                    throw error;
                }
            },
            async disconnect () {
                const provider = await this.getProvider();
                try {
                    await provider?.disconnect();
                } catch (error) {
                    if (!/No matching key/i.test(error.message)) throw error;
                } finally{
                    provider?.removeListener("accountsChanged", this.onAccountsChanged.bind(this));
                    provider?.removeListener("chainChanged", this.onChainChanged);
                    provider?.removeListener("disconnect", this.onDisconnect.bind(this));
                    provider?.removeListener("session_delete", this.onSessionDelete.bind(this));
                    provider?.on("connect", this.onConnect.bind(this));
                    this.setRequestedChainsIds([]);
                }
            },
            async getAccounts () {
                const provider = await this.getProvider();
                return provider.accounts.map((x)=>(0, $lqRRD.getAddress)(x));
            },
            async getProvider ({ chainId: chainId } = {}) {
                async function initProvider() {
                    const optionalChains = config.chains.map((x)=>x.id);
                    if (!optionalChains.length) return;
                    const { EthereumProvider: EthereumProvider } = await (parcelRequire("1itcf"));
                    return await EthereumProvider.init({
                        ...parameters,
                        disableProviderPing: true,
                        optionalChains: optionalChains,
                        projectId: parameters.projectId,
                        rpcMap: Object.fromEntries(config.chains.map((chain)=>[
                                chain.id,
                                chain.rpcUrls.default.http[0]
                            ])),
                        showQrModal: parameters.showQrModal ?? true
                    });
                }
                if (!provider_) {
                    if (!providerPromise) providerPromise = initProvider();
                    provider_ = await providerPromise;
                    provider_?.events.setMaxListeners(Infinity);
                }
                if (chainId) await this.switchChain?.({
                    chainId: chainId
                });
                return provider_;
            },
            async getChainId () {
                const provider = await this.getProvider();
                return provider.chainId;
            },
            async isAuthorized () {
                try {
                    const [accounts, provider] = await Promise.all([
                        this.getAccounts(),
                        this.getProvider()
                    ]);
                    // If an account does not exist on the session, then the connector is unauthorized.
                    if (!accounts.length) return false;
                    // If the chains are stale on the session, then the connector is unauthorized.
                    const isChainsStale = await this.isChainsStale();
                    if (isChainsStale && provider.session) {
                        await provider.disconnect().catch(()=>{});
                        return false;
                    }
                    return true;
                } catch  {
                    return false;
                }
            },
            async switchChain ({ addEthereumChainParameter: addEthereumChainParameter, chainId: chainId }) {
                const chain = config.chains.find((chain)=>chain.id === chainId);
                if (!chain) throw new (0, $k7R6B.SwitchChainError)(new (0, $e9e19674d26bdf1a$export$688e5fda4b4631ed)());
                try {
                    const provider = await this.getProvider();
                    const namespaceChains = this.getNamespaceChainsIds();
                    const namespaceMethods = this.getNamespaceMethods();
                    const isChainApproved = namespaceChains.includes(chainId);
                    if (!isChainApproved && namespaceMethods.includes("wallet_addEthereumChain")) {
                        let blockExplorerUrls;
                        if (addEthereumChainParameter?.blockExplorerUrls) blockExplorerUrls = addEthereumChainParameter.blockExplorerUrls;
                        else blockExplorerUrls = chain.blockExplorers?.default.url ? [
                            chain.blockExplorers?.default.url
                        ] : [];
                        let rpcUrls;
                        if (addEthereumChainParameter?.rpcUrls?.length) rpcUrls = addEthereumChainParameter.rpcUrls;
                        else rpcUrls = [
                            ...chain.rpcUrls.default.http
                        ];
                        const addEthereumChain = {
                            blockExplorerUrls: blockExplorerUrls,
                            chainId: (0, $9UP4H.numberToHex)(chainId),
                            chainName: addEthereumChainParameter?.chainName ?? chain.name,
                            iconUrls: addEthereumChainParameter?.iconUrls,
                            nativeCurrency: addEthereumChainParameter?.nativeCurrency ?? chain.nativeCurrency,
                            rpcUrls: rpcUrls
                        };
                        await provider.request({
                            method: "wallet_addEthereumChain",
                            params: [
                                addEthereumChain
                            ]
                        });
                        const requestedChains = await this.getRequestedChainsIds();
                        this.setRequestedChainsIds([
                            ...requestedChains,
                            chainId
                        ]);
                    }
                    await provider.request({
                        method: "wallet_switchEthereumChain",
                        params: [
                            {
                                chainId: (0, $9UP4H.numberToHex)(chainId)
                            }
                        ]
                    });
                    return chain;
                } catch (error) {
                    const message = typeof error === "string" ? error : error?.message;
                    if (/user rejected request/i.test(message)) throw new (0, $k7R6B.UserRejectedRequestError)(error);
                    throw new (0, $k7R6B.SwitchChainError)(error);
                }
            },
            onAccountsChanged (accounts) {
                if (accounts.length === 0) this.onDisconnect();
                else config.emitter.emit("change", {
                    accounts: accounts.map((x)=>(0, $lqRRD.getAddress)(x))
                });
            },
            onChainChanged (chain) {
                const chainId = Number(chain);
                config.emitter.emit("change", {
                    chainId: chainId
                });
            },
            async onConnect (connectInfo) {
                const chainId = Number(connectInfo.chainId);
                const accounts = await this.getAccounts();
                config.emitter.emit("connect", {
                    accounts: accounts,
                    chainId: chainId
                });
            },
            async onDisconnect (_error) {
                this.setRequestedChainsIds([]);
                config.emitter.emit("disconnect");
                const provider = await this.getProvider();
                provider.removeListener("accountsChanged", this.onAccountsChanged.bind(this));
                provider.removeListener("chainChanged", this.onChainChanged);
                provider.removeListener("disconnect", this.onDisconnect.bind(this));
                provider.removeListener("session_delete", this.onSessionDelete.bind(this));
                provider.on("connect", this.onConnect.bind(this));
            },
            onDisplayUri (uri) {
                config.emitter.emit("message", {
                    type: "display_uri",
                    data: uri
                });
            },
            onSessionDelete () {
                this.onDisconnect();
            },
            getNamespaceChainsIds () {
                if (!provider_) return [];
                const chainIds = provider_.session?.namespaces[NAMESPACE]?.chains?.map((chain)=>parseInt(chain.split(":")[1] || ""));
                return chainIds ?? [];
            },
            getNamespaceMethods () {
                if (!provider_) return [];
                const methods = provider_.session?.namespaces[NAMESPACE]?.methods;
                return methods ?? [];
            },
            async getRequestedChainsIds () {
                return await config.storage?.getItem(this.requestedChainsStorageKey) ?? [];
            },
            /**
         * Checks if the target chains match the chains that were
         * initially requested by the connector for the WalletConnect session.
         * If there is a mismatch, this means that the chains on the connector
         * are considered stale, and need to be revalidated at a later point (via
         * connection).
         *
         * There may be a scenario where a dapp adds a chain to the
         * connector later on, however, this chain will not have been approved or rejected
         * by the wallet. In this case, the chain is considered stale.
         *
         * There are exceptions however:
         * -  If the wallet supports dynamic chain addition via `eth_addEthereumChain`,
         *    then the chain is not considered stale.
         * -  If the `isNewChainsStale` flag is falsy on the connector, then the chain is
         *    not considered stale.
         *
         * For the above cases, chain validation occurs dynamically when the user
         * attempts to switch chain.
         *
         * Also check that dapp supports at least 1 chain from previously approved session.
         */ async isChainsStale () {
                const namespaceMethods = this.getNamespaceMethods();
                if (namespaceMethods.includes("wallet_addEthereumChain")) return false;
                if (!isNewChainsStale) return false;
                const connectorChains = config.chains.map((x)=>x.id);
                const namespaceChains = this.getNamespaceChainsIds();
                if (namespaceChains.length && !namespaceChains.some((id)=>connectorChains.includes(id))) return false;
                const requestedChains = await this.getRequestedChainsIds();
                return !connectorChains.every((id)=>requestedChains.includes(id));
            },
            async setRequestedChainsIds (chains) {
                await config.storage?.setItem(this.requestedChainsStorageKey, chains);
            },
            get requestedChainsStorageKey () {
                return `${this.id}.requestedChains`;
            }
        }));
}


/** @deprecated use `Number` instead */ function $ffa7128cb0384e83$export$723927690c88894d(chainId) {
    if (typeof chainId === "string") return Number.parseInt(chainId, chainId.trim().substring(0, 2) === "0x" ? 16 : 10);
    if (typeof chainId === "bigint") return Number(chainId);
    if (typeof chainId === "number") return chainId;
    throw new Error(`Cannot normalize chainId "${chainId}" of type "${typeof chainId}"`);
}




var $lqRRD = parcelRequire("lqRRD");
var $k7R6B = parcelRequire("k7R6B");

function $b7ef5dd74e0cb90b$export$8ca58e4e52917c25(parameters) {
    return (0, $44d491b0b6ab42ee$export$36e7227504c841ea)((config)=>({
            id: (0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).EMAIL_CONNECTOR_ID,
            name: "Web3Modal Email",
            type: "w3mEmail",
            async connect (options = {}) {
                const provider = await this.getProvider();
                const { address: address, chainId: chainId } = await provider.connect({
                    chainId: options.chainId
                });
                return {
                    accounts: [
                        address
                    ],
                    account: address,
                    chainId: chainId,
                    chain: {
                        id: chainId,
                        unsuported: false
                    }
                };
            },
            async disconnect () {
                const provider = await this.getProvider();
                await provider.disconnect();
            },
            async getAccounts () {
                const provider = await this.getProvider();
                const { address: address } = await provider.connect();
                return [
                    address
                ];
            },
            async getProvider () {
                if (!this.provider) this.provider = new (0, $adbbe8c0e0c86d80$export$112ca4a9acf9f612)(parameters.options.projectId);
                return Promise.resolve(this.provider);
            },
            async getChainId () {
                const provider = await this.getProvider();
                const { chainId: chainId } = await provider.getChainId();
                return chainId;
            },
            async isAuthorized () {
                const provider = await this.getProvider();
                const { isConnected: isConnected } = await provider.isConnected();
                return isConnected;
            },
            async switchChain ({ chainId: chainId }) {
                try {
                    const chain = config.chains.find((c)=>c.id === chainId);
                    if (!chain) throw new (0, $k7R6B.SwitchChainError)(new Error("chain not found on connector."));
                    const provider = await this.getProvider();
                    await provider.switchNetwork(chainId);
                    config.emitter.emit("change", {
                        chainId: (0, $ffa7128cb0384e83$export$723927690c88894d)(chainId)
                    });
                    return chain;
                } catch (error) {
                    if (error instanceof Error) throw new (0, $k7R6B.SwitchChainError)(error);
                    throw error;
                }
            },
            onAccountsChanged (accounts) {
                if (accounts.length === 0) this.onDisconnect();
                else config.emitter.emit("change", {
                    accounts: accounts.map((0, $lqRRD.getAddress))
                });
            },
            onChainChanged (chain) {
                const chainId = (0, $ffa7128cb0384e83$export$723927690c88894d)(chain);
                config.emitter.emit("change", {
                    chainId: chainId
                });
            },
            async onConnect (connectInfo) {
                const chainId = (0, $ffa7128cb0384e83$export$723927690c88894d)(connectInfo.chainId);
                const accounts = await this.getAccounts();
                config.emitter.emit("connect", {
                    accounts: accounts,
                    chainId: chainId
                });
            },
            async onDisconnect (_error) {
                const provider = await this.getProvider();
                await provider.disconnect();
            }
        }));
}



function $c54fe4d07c58f9e7$export$134240a34d71525e({ projectId: projectId, chains: chains, metadata: metadata, enableInjected: enableInjected, enableCoinbase: enableCoinbase, enableEmail: enableEmail, enableWalletConnect: enableWalletConnect, enableEIP6963: enableEIP6963, ...wagmiConfig }) {
    const connectors = [];
    const transportsArr = chains.map((chain)=>[
            chain.id,
            (0, $2f170f342e8ad217$export$867d8b939ab7f43e)({
                chainId: chain.id,
                projectId: projectId
            })
        ]);
    const transports = Object.fromEntries(transportsArr);
    if (enableWalletConnect !== false) connectors.push((0, $5b45b7b8431e00a7$export$340cc50ae9d9f255)({
        projectId: projectId,
        metadata: metadata,
        showQrModal: false
    }));
    if (enableInjected !== false) connectors.push((0, $a3694b226b0a0592$export$a7a34dad4983656f)({
        shimDisconnect: true
    }));
    if (enableCoinbase !== false) connectors.push((0, $147cdf48ccf56b7f$export$40dfb463b44d19b)({
        appName: metadata?.name ?? "Unknown",
        appLogoUrl: metadata?.icons[0] ?? "Unknown",
        enableMobileWalletLink: true
    }));
    if (enableEmail === true) connectors.push((0, $b7ef5dd74e0cb90b$export$8ca58e4e52917c25)({
        chains: [
            ...chains
        ],
        options: {
            projectId: projectId
        }
    }));
    return (0, $9c50f211ce0a813e$export$45a69314cf48a3eb)({
        chains: chains,
        multiInjectedProviderDiscovery: enableEIP6963 !== false,
        transports: transports,
        ...wagmiConfig,
        connectors: connectors
    });
}



function $e3c4d42401769f42$export$14650d4efb17e382(options) {
    return new (0, $ea8eaf0132f2eca6$export$c03599cd5308d12b)({
        ...options,
        _sdkVersion: `html-wagmi-${(0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).VERSION}`
    });
}



const $3401251e3fb8de97$export$625cf84d855940d4 = /*#__PURE__*/ (0, $bcc18d892337011b$export$b6380ff64616a4fb)({
    id: 42161,
    name: "Arbitrum One",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://arb1.arbitrum.io/rpc"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "Arbiscan",
            url: "https://arbiscan.io",
            apiUrl: "https://api.arbiscan.io/api"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 7654707
        }
    }
});


const $4ae0c7e78bd74eb3$export$857f1b5f596fb425 = /*#__PURE__*/ (0, $bcc18d892337011b$export$b6380ff64616a4fb)({
    id: 421613,
    name: "Arbitrum Goerli",
    nativeCurrency: {
        name: "Arbitrum Goerli Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://goerli-rollup.arbitrum.io/rpc"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "Arbiscan",
            url: "https://goerli.arbiscan.io"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 88114
        }
    },
    testnet: true
});


const $69611fdc05cc517c$export$ca1d15c01fde7266 = /*#__PURE__*/ (0, $bcc18d892337011b$export$b6380ff64616a4fb)({
    id: 43114,
    name: "Avalanche",
    nativeCurrency: {
        decimals: 18,
        name: "Avalanche",
        symbol: "AVAX"
    },
    rpcUrls: {
        default: {
            http: [
                "https://api.avax.network/ext/bc/C/rpc"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "SnowTrace",
            url: "https://snowtrace.io",
            apiUrl: "https://api.snowtrace.io"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 11907934
        }
    }
});

/**
 * Predeploy contracts for OP Stack.
 * @see https://github.com/ethereum-optimism/optimism/blob/develop/specs/predeploys.md
 */ const $9ce8a13c09715a1b$export$ea30b8ddade7b2c1 = {
    gasPriceOracle: {
        address: "0x420000000000000000000000000000000000000F"
    },
    l1Block: {
        address: "0x4200000000000000000000000000000000000015"
    },
    l2CrossDomainMessenger: {
        address: "0x4200000000000000000000000000000000000007"
    },
    l2Erc721Bridge: {
        address: "0x4200000000000000000000000000000000000014"
    },
    l2StandardBridge: {
        address: "0x4200000000000000000000000000000000000010"
    },
    l2ToL1MessagePasser: {
        address: "0x4200000000000000000000000000000000000016"
    }
};



var $7Zv5I = parcelRequire("7Zv5I");

var $fKtZJ = parcelRequire("fKtZJ");

var $7Zv5I = parcelRequire("7Zv5I");

var $fKtZJ = parcelRequire("fKtZJ");
const $bd3d0cf1db52600c$export$cd5f936b62a5e91 = {
    "0x0": "legacy",
    "0x1": "eip2930",
    "0x2": "eip1559",
    "0x3": "eip4844",
    "0x4": "eip7702"
};
function $bd3d0cf1db52600c$export$b02b16590d26dadc(transaction) {
    const transaction_ = {
        ...transaction,
        blockHash: transaction.blockHash ? transaction.blockHash : null,
        blockNumber: transaction.blockNumber ? BigInt(transaction.blockNumber) : null,
        chainId: transaction.chainId ? (0, $7Zv5I.hexToNumber)(transaction.chainId) : undefined,
        gas: transaction.gas ? BigInt(transaction.gas) : undefined,
        gasPrice: transaction.gasPrice ? BigInt(transaction.gasPrice) : undefined,
        maxFeePerBlobGas: transaction.maxFeePerBlobGas ? BigInt(transaction.maxFeePerBlobGas) : undefined,
        maxFeePerGas: transaction.maxFeePerGas ? BigInt(transaction.maxFeePerGas) : undefined,
        maxPriorityFeePerGas: transaction.maxPriorityFeePerGas ? BigInt(transaction.maxPriorityFeePerGas) : undefined,
        nonce: transaction.nonce ? (0, $7Zv5I.hexToNumber)(transaction.nonce) : undefined,
        to: transaction.to ? transaction.to : null,
        transactionIndex: transaction.transactionIndex ? Number(transaction.transactionIndex) : null,
        type: transaction.type ? $bd3d0cf1db52600c$export$cd5f936b62a5e91[transaction.type] : undefined,
        typeHex: transaction.type ? transaction.type : undefined,
        value: transaction.value ? BigInt(transaction.value) : undefined,
        v: transaction.v ? BigInt(transaction.v) : undefined
    };
    if (transaction.authorizationList) transaction_.authorizationList = $bd3d0cf1db52600c$var$formatAuthorizationList(transaction.authorizationList);
    transaction_.yParity = (()=>{
        // If `yParity` is provided, we will use it.
        if (transaction.yParity) return Number(transaction.yParity);
        // If no `yParity` provided, try derive from `v`.
        if (typeof transaction_.v === "bigint") {
            if (transaction_.v === 0n || transaction_.v === 27n) return 0;
            if (transaction_.v === 1n || transaction_.v === 28n) return 1;
            if (transaction_.v >= 35n) return transaction_.v % 2n === 0n ? 1 : 0;
        }
        return undefined;
    })();
    if (transaction_.type === "legacy") {
        delete transaction_.accessList;
        delete transaction_.maxFeePerBlobGas;
        delete transaction_.maxFeePerGas;
        delete transaction_.maxPriorityFeePerGas;
        delete transaction_.yParity;
    }
    if (transaction_.type === "eip2930") {
        delete transaction_.maxFeePerBlobGas;
        delete transaction_.maxFeePerGas;
        delete transaction_.maxPriorityFeePerGas;
    }
    if (transaction_.type === "eip1559") delete transaction_.maxFeePerBlobGas;
    return transaction_;
}
const $bd3d0cf1db52600c$export$c19bdc7dbe69198d = /*#__PURE__*/ (0, $fKtZJ.defineFormatter)("transaction", $bd3d0cf1db52600c$export$b02b16590d26dadc);
//////////////////////////////////////////////////////////////////////////////
function $bd3d0cf1db52600c$var$formatAuthorizationList(authorizationList) {
    return authorizationList.map((authorization)=>({
            contractAddress: authorization.address,
            r: authorization.r,
            s: authorization.s,
            chainId: Number(authorization.chainId),
            nonce: Number(authorization.nonce),
            ...typeof authorization.yParity !== "undefined" ? {
                yParity: Number(authorization.yParity)
            } : {},
            ...typeof authorization.v !== "undefined" && typeof authorization.yParity === "undefined" ? {
                v: Number(authorization.v)
            } : {}
        }));
}


function $8d786868837e77db$export$ba1152bc4017d62a(block) {
    const transactions = block.transactions?.map((transaction)=>{
        if (typeof transaction === "string") return transaction;
        return (0, $bd3d0cf1db52600c$export$b02b16590d26dadc)(transaction);
    });
    return {
        ...block,
        baseFeePerGas: block.baseFeePerGas ? BigInt(block.baseFeePerGas) : null,
        blobGasUsed: block.blobGasUsed ? BigInt(block.blobGasUsed) : undefined,
        difficulty: block.difficulty ? BigInt(block.difficulty) : undefined,
        excessBlobGas: block.excessBlobGas ? BigInt(block.excessBlobGas) : undefined,
        gasLimit: block.gasLimit ? BigInt(block.gasLimit) : undefined,
        gasUsed: block.gasUsed ? BigInt(block.gasUsed) : undefined,
        hash: block.hash ? block.hash : null,
        logsBloom: block.logsBloom ? block.logsBloom : null,
        nonce: block.nonce ? block.nonce : null,
        number: block.number ? BigInt(block.number) : null,
        size: block.size ? BigInt(block.size) : undefined,
        timestamp: block.timestamp ? BigInt(block.timestamp) : undefined,
        transactions: transactions,
        totalDifficulty: block.totalDifficulty ? BigInt(block.totalDifficulty) : null
    };
}
const $8d786868837e77db$export$9f35cb3327f1a5c5 = /*#__PURE__*/ (0, $fKtZJ.defineFormatter)("block", $8d786868837e77db$export$ba1152bc4017d62a);




var $7Zv5I = parcelRequire("7Zv5I");

var $fKtZJ = parcelRequire("fKtZJ");
function $85c39d465bc84f83$export$fccdbdc2b9d7893(log, { args: args, eventName: eventName } = {}) {
    return {
        ...log,
        blockHash: log.blockHash ? log.blockHash : null,
        blockNumber: log.blockNumber ? BigInt(log.blockNumber) : null,
        logIndex: log.logIndex ? Number(log.logIndex) : null,
        transactionHash: log.transactionHash ? log.transactionHash : null,
        transactionIndex: log.transactionIndex ? Number(log.transactionIndex) : null,
        ...eventName ? {
            args: args,
            eventName: eventName
        } : {}
    };
}



const $8a75a48a0283d821$export$3f17d120ae0df04 = {
    "0x0": "reverted",
    "0x1": "success"
};
function $8a75a48a0283d821$export$30da670e49d6fc31(transactionReceipt) {
    const receipt = {
        ...transactionReceipt,
        blockNumber: transactionReceipt.blockNumber ? BigInt(transactionReceipt.blockNumber) : null,
        contractAddress: transactionReceipt.contractAddress ? transactionReceipt.contractAddress : null,
        cumulativeGasUsed: transactionReceipt.cumulativeGasUsed ? BigInt(transactionReceipt.cumulativeGasUsed) : null,
        effectiveGasPrice: transactionReceipt.effectiveGasPrice ? BigInt(transactionReceipt.effectiveGasPrice) : null,
        gasUsed: transactionReceipt.gasUsed ? BigInt(transactionReceipt.gasUsed) : null,
        logs: transactionReceipt.logs ? transactionReceipt.logs.map((log)=>(0, $85c39d465bc84f83$export$fccdbdc2b9d7893)(log)) : null,
        to: transactionReceipt.to ? transactionReceipt.to : null,
        transactionIndex: transactionReceipt.transactionIndex ? (0, $7Zv5I.hexToNumber)(transactionReceipt.transactionIndex) : null,
        status: transactionReceipt.status ? $8a75a48a0283d821$export$3f17d120ae0df04[transactionReceipt.status] : null,
        type: transactionReceipt.type ? (0, $bd3d0cf1db52600c$export$cd5f936b62a5e91)[transactionReceipt.type] || transactionReceipt.type : null
    };
    if (transactionReceipt.blobGasPrice) receipt.blobGasPrice = BigInt(transactionReceipt.blobGasPrice);
    if (transactionReceipt.blobGasUsed) receipt.blobGasUsed = BigInt(transactionReceipt.blobGasUsed);
    return receipt;
}
const $8a75a48a0283d821$export$8d3f90420000ba71 = /*#__PURE__*/ (0, $fKtZJ.defineFormatter)("transactionReceipt", $8a75a48a0283d821$export$30da670e49d6fc31);


const $5995301a9f0100a9$export$fe98a034cfb96d55 = {
    block: /*#__PURE__*/ (0, $8d786868837e77db$export$9f35cb3327f1a5c5)({
        format (args) {
            const transactions = args.transactions?.map((transaction)=>{
                if (typeof transaction === "string") return transaction;
                const formatted = (0, $bd3d0cf1db52600c$export$b02b16590d26dadc)(transaction);
                if (formatted.typeHex === "0x7e") {
                    formatted.isSystemTx = transaction.isSystemTx;
                    formatted.mint = transaction.mint ? (0, $7Zv5I.hexToBigInt)(transaction.mint) : undefined;
                    formatted.sourceHash = transaction.sourceHash;
                    formatted.type = "deposit";
                }
                return formatted;
            });
            return {
                transactions: transactions,
                stateRoot: args.stateRoot
            };
        }
    }),
    transaction: /*#__PURE__*/ (0, $bd3d0cf1db52600c$export$c19bdc7dbe69198d)({
        format (args) {
            const transaction = {};
            if (args.type === "0x7e") {
                transaction.isSystemTx = args.isSystemTx;
                transaction.mint = args.mint ? (0, $7Zv5I.hexToBigInt)(args.mint) : undefined;
                transaction.sourceHash = args.sourceHash;
                transaction.type = "deposit";
            }
            return transaction;
        }
    }),
    transactionReceipt: /*#__PURE__*/ (0, $8a75a48a0283d821$export$8d3f90420000ba71)({
        format (args) {
            return {
                l1GasPrice: args.l1GasPrice ? (0, $7Zv5I.hexToBigInt)(args.l1GasPrice) : null,
                l1GasUsed: args.l1GasUsed ? (0, $7Zv5I.hexToBigInt)(args.l1GasUsed) : null,
                l1Fee: args.l1Fee ? (0, $7Zv5I.hexToBigInt)(args.l1Fee) : null,
                l1FeeScalar: args.l1FeeScalar ? Number(args.l1FeeScalar) : null
            };
        }
    })
};



var $8j5HI = parcelRequire("8j5HI");

var $4rOic = parcelRequire("4rOic");

var $jCBOw = parcelRequire("jCBOw");

var $9UP4H = parcelRequire("9UP4H");

var $6F8ii = parcelRequire("6F8ii");

var $91vjL = parcelRequire("91vjL");

var $eFDiV = parcelRequire("eFDiV");

var $9UP4H = parcelRequire("9UP4H");
function $e590101db94df837$export$140c78e750979cda(bytes, to = "hex") {
    const encodable = $e590101db94df837$var$getEncodable(bytes);
    const cursor = (0, $91vjL.createCursor)(new Uint8Array(encodable.length));
    encodable.encode(cursor);
    if (to === "hex") return (0, $9UP4H.bytesToHex)(cursor.bytes);
    return cursor.bytes;
}
function $e590101db94df837$export$643d3163062ff0f3(bytes, to = "bytes") {
    return $e590101db94df837$export$140c78e750979cda(bytes, to);
}
function $e590101db94df837$export$e01da38311234e95(hex, to = "hex") {
    return $e590101db94df837$export$140c78e750979cda(hex, to);
}
function $e590101db94df837$var$getEncodable(bytes) {
    if (Array.isArray(bytes)) return $e590101db94df837$var$getEncodableList(bytes.map((x)=>$e590101db94df837$var$getEncodable(x)));
    return $e590101db94df837$var$getEncodableBytes(bytes);
}
function $e590101db94df837$var$getEncodableList(list) {
    const bodyLength = list.reduce((acc, x)=>acc + x.length, 0);
    const sizeOfBodyLength = $e590101db94df837$var$getSizeOfLength(bodyLength);
    const length = (()=>{
        if (bodyLength <= 55) return 1 + bodyLength;
        return 1 + sizeOfBodyLength + bodyLength;
    })();
    return {
        length: length,
        encode (cursor) {
            if (bodyLength <= 55) cursor.pushByte(0xc0 + bodyLength);
            else {
                cursor.pushByte(247 + sizeOfBodyLength);
                if (sizeOfBodyLength === 1) cursor.pushUint8(bodyLength);
                else if (sizeOfBodyLength === 2) cursor.pushUint16(bodyLength);
                else if (sizeOfBodyLength === 3) cursor.pushUint24(bodyLength);
                else cursor.pushUint32(bodyLength);
            }
            for (const { encode: encode } of list)encode(cursor);
        }
    };
}
function $e590101db94df837$var$getEncodableBytes(bytesOrHex) {
    const bytes = typeof bytesOrHex === "string" ? (0, $eFDiV.hexToBytes)(bytesOrHex) : bytesOrHex;
    const sizeOfBytesLength = $e590101db94df837$var$getSizeOfLength(bytes.length);
    const length = (()=>{
        if (bytes.length === 1 && bytes[0] < 0x80) return 1;
        if (bytes.length <= 55) return 1 + bytes.length;
        return 1 + sizeOfBytesLength + bytes.length;
    })();
    return {
        length: length,
        encode (cursor) {
            if (bytes.length === 1 && bytes[0] < 0x80) cursor.pushBytes(bytes);
            else if (bytes.length <= 55) {
                cursor.pushByte(0x80 + bytes.length);
                cursor.pushBytes(bytes);
            } else {
                cursor.pushByte(183 + sizeOfBytesLength);
                if (sizeOfBytesLength === 1) cursor.pushUint8(bytes.length);
                else if (sizeOfBytesLength === 2) cursor.pushUint16(bytes.length);
                else if (sizeOfBytesLength === 3) cursor.pushUint24(bytes.length);
                else cursor.pushUint32(bytes.length);
                cursor.pushBytes(bytes);
            }
        }
    };
}
function $e590101db94df837$var$getSizeOfLength(length) {
    if (length < 256) return 1;
    if (length < 2 ** 16) return 2;
    if (length < 2 ** 24) return 3;
    if (length < 2 ** 32) return 4;
    throw new (0, $6F8ii.BaseError)("Length is too large.");
}



var $8ceqR = parcelRequire("8ceqR");

var $eFDiV = parcelRequire("eFDiV");

var $9UP4H = parcelRequire("9UP4H");
function $6507d1beda337491$export$b67626aab22a659b(parameters) {
    const { kzg: kzg } = parameters;
    const to = parameters.to ?? (typeof parameters.blobs[0] === "string" ? "hex" : "bytes");
    const blobs = typeof parameters.blobs[0] === "string" ? parameters.blobs.map((x)=>(0, $eFDiV.hexToBytes)(x)) : parameters.blobs;
    const commitments = [];
    for (const blob of blobs)commitments.push(Uint8Array.from(kzg.blobToKzgCommitment(blob)));
    return to === "bytes" ? commitments : commitments.map((x)=>(0, $9UP4H.bytesToHex)(x));
}



var $eFDiV = parcelRequire("eFDiV");

var $9UP4H = parcelRequire("9UP4H");
function $13a026c6ed189cfb$export$78a225f8922765eb(parameters) {
    const { kzg: kzg } = parameters;
    const to = parameters.to ?? (typeof parameters.blobs[0] === "string" ? "hex" : "bytes");
    const blobs = typeof parameters.blobs[0] === "string" ? parameters.blobs.map((x)=>(0, $eFDiV.hexToBytes)(x)) : parameters.blobs;
    const commitments = typeof parameters.commitments[0] === "string" ? parameters.commitments.map((x)=>(0, $eFDiV.hexToBytes)(x)) : parameters.commitments;
    const proofs = [];
    for(let i = 0; i < blobs.length; i++){
        const blob = blobs[i];
        const commitment = commitments[i];
        proofs.push(Uint8Array.from(kzg.computeBlobKzgProof(blob, commitment)));
    }
    return to === "bytes" ? proofs : proofs.map((x)=>(0, $9UP4H.bytesToHex)(x));
}



var $9UP4H = parcelRequire("9UP4H");

var $jfkMZ = parcelRequire("jfkMZ");

var $j6NiR = parcelRequire("j6NiR");

var $eFDiV = parcelRequire("eFDiV");

var $9UP4H = parcelRequire("9UP4H");
function $4a13a353da6507fc$export$bced8d2aada2d1c9(value, to_) {
    const to = to_ || "hex";
    const bytes = (0, $jfkMZ.sha256)((0, $j6NiR.isHex)(value, {
        strict: false
    }) ? (0, $eFDiV.toBytes)(value) : value);
    if (to === "bytes") return bytes;
    return (0, $9UP4H.toHex)(bytes);
}


function $9a905ab4399e376a$export$7b2f762c7eb1ecea(parameters) {
    const { commitment: commitment, version: version = 1 } = parameters;
    const to = parameters.to ?? (typeof commitment === "string" ? "hex" : "bytes");
    const versionedHash = (0, $4a13a353da6507fc$export$bced8d2aada2d1c9)(commitment, "bytes");
    versionedHash.set([
        version
    ], 0);
    return to === "bytes" ? versionedHash : (0, $9UP4H.bytesToHex)(versionedHash);
}


function $2ad8e7a2c1a65f08$export$e31b3e59dda37b17(parameters) {
    const { commitments: commitments, version: version } = parameters;
    const to = parameters.to ?? (typeof commitments[0] === "string" ? "hex" : "bytes");
    const hashes = [];
    for (const commitment of commitments)hashes.push((0, $9a905ab4399e376a$export$7b2f762c7eb1ecea)({
        commitment: commitment,
        to: to,
        version: version
    }));
    return hashes;
}




// https://github.com/ethereum/EIPs/blob/master/EIPS/eip-4844.md#parameters
/** Blob limit per transaction. */ const $43b0f103956c207f$var$blobsPerTransaction = 6;
const $43b0f103956c207f$export$a5d2a246d959344 = 32;
const $43b0f103956c207f$export$57577a1a84b7e334 = 4096;
const $43b0f103956c207f$export$6f30828563a6c6ef = $43b0f103956c207f$export$a5d2a246d959344 * $43b0f103956c207f$export$57577a1a84b7e334;
const $43b0f103956c207f$export$b8db4e3f07d08e09 = $43b0f103956c207f$export$6f30828563a6c6ef * $43b0f103956c207f$var$blobsPerTransaction - // terminator byte (0x80).
1 - // zero byte (0x00) appended to each field element.
1 * $43b0f103956c207f$export$57577a1a84b7e334 * $43b0f103956c207f$var$blobsPerTransaction;


// https://github.com/ethereum/EIPs/blob/master/EIPS/eip-4844.md#parameters
const $dc6c965765e86145$export$de38d5f871f0b1cd = 1;



var $6F8ii = parcelRequire("6F8ii");
class $88cbe804a575cd34$export$4000e90bfe41caa1 extends (0, $6F8ii.BaseError) {
    constructor({ maxSize: maxSize, size: size }){
        super("Blob size is too large.", {
            metaMessages: [
                `Max: ${maxSize} bytes`,
                `Given: ${size} bytes`
            ],
            name: "BlobSizeTooLargeError"
        });
    }
}
class $88cbe804a575cd34$export$d145394ceab4d1c3 extends (0, $6F8ii.BaseError) {
    constructor(){
        super("Blob data must not be empty.", {
            name: "EmptyBlobError"
        });
    }
}
class $88cbe804a575cd34$export$ebd5b15dd92c680 extends (0, $6F8ii.BaseError) {
    constructor({ hash: hash, size: size }){
        super(`Versioned hash "${hash}" size is invalid.`, {
            metaMessages: [
                "Expected: 32",
                `Received: ${size}`
            ],
            name: "InvalidVersionedHashSizeError"
        });
    }
}
class $88cbe804a575cd34$export$509ed1d312c500 extends (0, $6F8ii.BaseError) {
    constructor({ hash: hash, version: version }){
        super(`Versioned hash "${hash}" version is invalid.`, {
            metaMessages: [
                `Expected: ${(0, $dc6c965765e86145$export$de38d5f871f0b1cd)}`,
                `Received: ${version}`
            ],
            name: "InvalidVersionedHashVersionError"
        });
    }
}



var $91vjL = parcelRequire("91vjL");

var $jBXg5 = parcelRequire("jBXg5");

var $eFDiV = parcelRequire("eFDiV");

var $9UP4H = parcelRequire("9UP4H");
function $277b40536156ac9c$export$7ec339bd77d6ed92(parameters) {
    const to = parameters.to ?? (typeof parameters.data === "string" ? "hex" : "bytes");
    const data = typeof parameters.data === "string" ? (0, $eFDiV.hexToBytes)(parameters.data) : parameters.data;
    const size_ = (0, $jBXg5.size)(data);
    if (!size_) throw new (0, $88cbe804a575cd34$export$d145394ceab4d1c3)();
    if (size_ > (0, $43b0f103956c207f$export$b8db4e3f07d08e09)) throw new (0, $88cbe804a575cd34$export$4000e90bfe41caa1)({
        maxSize: (0, $43b0f103956c207f$export$b8db4e3f07d08e09),
        size: size_
    });
    const blobs = [];
    let active = true;
    let position = 0;
    while(active){
        const blob = (0, $91vjL.createCursor)(new Uint8Array((0, $43b0f103956c207f$export$6f30828563a6c6ef)));
        let size = 0;
        while(size < (0, $43b0f103956c207f$export$57577a1a84b7e334)){
            const bytes = data.slice(position, position + ((0, $43b0f103956c207f$export$a5d2a246d959344) - 1));
            // Push a zero byte so the field element doesn't overflow the BLS modulus.
            blob.pushByte(0x00);
            // Push the current segment of data bytes.
            blob.pushBytes(bytes);
            // If we detect that the current segment of data bytes is less than 31 bytes,
            // we can stop processing and push a terminator byte to indicate the end of the blob.
            if (bytes.length < 31) {
                blob.pushByte(0x80);
                active = false;
                break;
            }
            size++;
            position += 31;
        }
        blobs.push(blob);
    }
    return to === "bytes" ? blobs.map((x)=>x.bytes) : blobs.map((x)=>(0, $9UP4H.bytesToHex)(x.bytes));
}


function $8048a52d99894ddb$export$44960962e1c9641b(parameters) {
    const { data: data, kzg: kzg, to: to } = parameters;
    const blobs = parameters.blobs ?? (0, $277b40536156ac9c$export$7ec339bd77d6ed92)({
        data: data,
        to: to
    });
    const commitments = parameters.commitments ?? (0, $6507d1beda337491$export$b67626aab22a659b)({
        blobs: blobs,
        kzg: kzg,
        to: to
    });
    const proofs = parameters.proofs ?? (0, $13a026c6ed189cfb$export$78a225f8922765eb)({
        blobs: blobs,
        commitments: commitments,
        kzg: kzg,
        to: to
    });
    const sidecars = [];
    for(let i = 0; i < blobs.length; i++)sidecars.push({
        blob: blobs[i],
        commitment: commitments[i],
        proof: proofs[i]
    });
    return sidecars;
}



var $jCBOw = parcelRequire("jCBOw");

var $44bP9 = parcelRequire("44bP9");

var $9UP4H = parcelRequire("9UP4H");


var $9UP4H = parcelRequire("9UP4H");

function $af5fb22e5076cd6a$export$a695669f1a41df5b(authorizationList) {
    if (!authorizationList || authorizationList.length === 0) return [];
    const serializedAuthorizationList = [];
    for (const authorization of authorizationList){
        const { contractAddress: contractAddress, chainId: chainId, nonce: nonce, ...signature } = authorization;
        serializedAuthorizationList.push([
            (0, $9UP4H.toHex)(chainId),
            contractAddress,
            [
                nonce ? (0, $9UP4H.toHex)(nonce) : "0x"
            ],
            ...(0, $127c27078f06243d$export$13ef8e144f96fd76)({}, signature)
        ]);
    }
    return serializedAuthorizationList;
}




var $8j5HI = parcelRequire("8j5HI");

var $6F8ii = parcelRequire("6F8ii");


var $98Tjv = parcelRequire("98Tjv");

var $7hHca = parcelRequire("7hHca");

var $4rOic = parcelRequire("4rOic");

var $jBXg5 = parcelRequire("jBXg5");

var $a7Rp0 = parcelRequire("a7Rp0");

var $7Zv5I = parcelRequire("7Zv5I");
function $39552fbcbcc991f9$export$c066ee77932a0249(transaction) {
    const { authorizationList: authorizationList } = transaction;
    if (authorizationList) for (const authorization of authorizationList){
        const { contractAddress: contractAddress, chainId: chainId } = authorization;
        if (!(0, $4rOic.isAddress)(contractAddress)) throw new (0, $8j5HI.InvalidAddressError)({
            address: contractAddress
        });
        if (chainId <= 0) throw new (0, $98Tjv.InvalidChainIdError)({
            chainId: chainId
        });
    }
    $39552fbcbcc991f9$export$9ce52ad2ebd4d8fd(transaction);
}
function $39552fbcbcc991f9$export$7a7b1c9cbdcde679(transaction) {
    const { blobVersionedHashes: blobVersionedHashes } = transaction;
    if (blobVersionedHashes) {
        if (blobVersionedHashes.length === 0) throw new (0, $88cbe804a575cd34$export$d145394ceab4d1c3)();
        for (const hash of blobVersionedHashes){
            const size_ = (0, $jBXg5.size)(hash);
            const version = (0, $7Zv5I.hexToNumber)((0, $a7Rp0.slice)(hash, 0, 1));
            if (size_ !== 32) throw new (0, $88cbe804a575cd34$export$ebd5b15dd92c680)({
                hash: hash,
                size: size_
            });
            if (version !== (0, $dc6c965765e86145$export$de38d5f871f0b1cd)) throw new (0, $88cbe804a575cd34$export$509ed1d312c500)({
                hash: hash,
                version: version
            });
        }
    }
    $39552fbcbcc991f9$export$9ce52ad2ebd4d8fd(transaction);
}
function $39552fbcbcc991f9$export$9ce52ad2ebd4d8fd(transaction) {
    const { chainId: chainId, maxPriorityFeePerGas: maxPriorityFeePerGas, maxFeePerGas: maxFeePerGas, to: to } = transaction;
    if (chainId <= 0) throw new (0, $98Tjv.InvalidChainIdError)({
        chainId: chainId
    });
    if (to && !(0, $4rOic.isAddress)(to)) throw new (0, $8j5HI.InvalidAddressError)({
        address: to
    });
    if (maxFeePerGas && maxFeePerGas > 2n ** 256n - 1n) throw new (0, $7hHca.FeeCapTooHighError)({
        maxFeePerGas: maxFeePerGas
    });
    if (maxPriorityFeePerGas && maxFeePerGas && maxPriorityFeePerGas > maxFeePerGas) throw new (0, $7hHca.TipAboveFeeCapError)({
        maxFeePerGas: maxFeePerGas,
        maxPriorityFeePerGas: maxPriorityFeePerGas
    });
}
function $39552fbcbcc991f9$export$18dc5e03b8985881(transaction) {
    const { chainId: chainId, maxPriorityFeePerGas: maxPriorityFeePerGas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, to: to } = transaction;
    if (chainId <= 0) throw new (0, $98Tjv.InvalidChainIdError)({
        chainId: chainId
    });
    if (to && !(0, $4rOic.isAddress)(to)) throw new (0, $8j5HI.InvalidAddressError)({
        address: to
    });
    if (maxPriorityFeePerGas || maxFeePerGas) throw new (0, $6F8ii.BaseError)("`maxFeePerGas`/`maxPriorityFeePerGas` is not a valid EIP-2930 Transaction attribute.");
    if (gasPrice && gasPrice > 2n ** 256n - 1n) throw new (0, $7hHca.FeeCapTooHighError)({
        maxFeePerGas: gasPrice
    });
}
function $39552fbcbcc991f9$export$f9ff7fa58fadd108(transaction) {
    const { chainId: chainId, maxPriorityFeePerGas: maxPriorityFeePerGas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, to: to } = transaction;
    if (to && !(0, $4rOic.isAddress)(to)) throw new (0, $8j5HI.InvalidAddressError)({
        address: to
    });
    if (typeof chainId !== "undefined" && chainId <= 0) throw new (0, $98Tjv.InvalidChainIdError)({
        chainId: chainId
    });
    if (maxPriorityFeePerGas || maxFeePerGas) throw new (0, $6F8ii.BaseError)("`maxFeePerGas`/`maxPriorityFeePerGas` is not a valid Legacy Transaction attribute.");
    if (gasPrice && gasPrice > 2n ** 256n - 1n) throw new (0, $7hHca.FeeCapTooHighError)({
        maxFeePerGas: gasPrice
    });
}



var $8ceqR = parcelRequire("8ceqR");
function $56d663a63fac90e2$export$944c6678cd5a1ea8(transaction) {
    if (transaction.type) return transaction.type;
    if (typeof transaction.authorizationList !== "undefined") return "eip7702";
    if (typeof transaction.blobs !== "undefined" || typeof transaction.blobVersionedHashes !== "undefined" || typeof transaction.maxFeePerBlobGas !== "undefined" || typeof transaction.sidecars !== "undefined") return "eip4844";
    if (typeof transaction.maxFeePerGas !== "undefined" || typeof transaction.maxPriorityFeePerGas !== "undefined") return "eip1559";
    if (typeof transaction.gasPrice !== "undefined") {
        if (typeof transaction.accessList !== "undefined") return "eip2930";
        return "legacy";
    }
    throw new (0, $8ceqR.InvalidSerializableTransactionError)({
        transaction: transaction
    });
}



var $8j5HI = parcelRequire("8j5HI");

var $8ceqR = parcelRequire("8ceqR");

var $4rOic = parcelRequire("4rOic");
function $9c16a2b39217d0a9$export$736ebd57ab43df1(accessList) {
    if (!accessList || accessList.length === 0) return [];
    const serializedAccessList = [];
    for(let i = 0; i < accessList.length; i++){
        const { address: address, storageKeys: storageKeys } = accessList[i];
        for(let j = 0; j < storageKeys.length; j++){
            if (storageKeys[j].length - 2 !== 64) throw new (0, $8ceqR.InvalidStorageKeySizeError)({
                storageKey: storageKeys[j]
            });
        }
        if (!(0, $4rOic.isAddress)(address, {
            strict: false
        })) throw new (0, $8j5HI.InvalidAddressError)({
            address: address
        });
        serializedAccessList.push([
            address,
            storageKeys
        ]);
    }
    return serializedAccessList;
}


function $127c27078f06243d$export$7cb44e9a321cd996(transaction, signature) {
    const type = (0, $56d663a63fac90e2$export$944c6678cd5a1ea8)(transaction);
    if (type === "eip1559") return $127c27078f06243d$var$serializeTransactionEIP1559(transaction, signature);
    if (type === "eip2930") return $127c27078f06243d$var$serializeTransactionEIP2930(transaction, signature);
    if (type === "eip4844") return $127c27078f06243d$var$serializeTransactionEIP4844(transaction, signature);
    if (type === "eip7702") return $127c27078f06243d$var$serializeTransactionEIP7702(transaction, signature);
    return $127c27078f06243d$var$serializeTransactionLegacy(transaction, signature);
}
function $127c27078f06243d$var$serializeTransactionEIP7702(transaction, signature) {
    const { authorizationList: authorizationList, chainId: chainId, gas: gas, nonce: nonce, to: to, value: value, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, accessList: accessList, data: data } = transaction;
    (0, $39552fbcbcc991f9$export$c066ee77932a0249)(transaction);
    const serializedAccessList = (0, $9c16a2b39217d0a9$export$736ebd57ab43df1)(accessList);
    const serializedAuthorizationList = (0, $af5fb22e5076cd6a$export$a695669f1a41df5b)(authorizationList);
    return (0, $jCBOw.concatHex)([
        "0x04",
        (0, $e590101db94df837$export$140c78e750979cda)([
            (0, $9UP4H.toHex)(chainId),
            nonce ? (0, $9UP4H.toHex)(nonce) : "0x",
            maxPriorityFeePerGas ? (0, $9UP4H.toHex)(maxPriorityFeePerGas) : "0x",
            maxFeePerGas ? (0, $9UP4H.toHex)(maxFeePerGas) : "0x",
            gas ? (0, $9UP4H.toHex)(gas) : "0x",
            to ?? "0x",
            value ? (0, $9UP4H.toHex)(value) : "0x",
            data ?? "0x",
            serializedAccessList,
            serializedAuthorizationList,
            ...$127c27078f06243d$export$13ef8e144f96fd76(transaction, signature)
        ])
    ]);
}
function $127c27078f06243d$var$serializeTransactionEIP4844(transaction, signature) {
    const { chainId: chainId, gas: gas, nonce: nonce, to: to, value: value, maxFeePerBlobGas: maxFeePerBlobGas, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, accessList: accessList, data: data } = transaction;
    (0, $39552fbcbcc991f9$export$7a7b1c9cbdcde679)(transaction);
    let blobVersionedHashes = transaction.blobVersionedHashes;
    let sidecars = transaction.sidecars;
    // If `blobs` are passed, we will need to compute the KZG commitments & proofs.
    if (transaction.blobs && (typeof blobVersionedHashes === "undefined" || typeof sidecars === "undefined")) {
        const blobs = typeof transaction.blobs[0] === "string" ? transaction.blobs : transaction.blobs.map((x)=>(0, $9UP4H.bytesToHex)(x));
        const kzg = transaction.kzg;
        const commitments = (0, $6507d1beda337491$export$b67626aab22a659b)({
            blobs: blobs,
            kzg: kzg
        });
        if (typeof blobVersionedHashes === "undefined") blobVersionedHashes = (0, $2ad8e7a2c1a65f08$export$e31b3e59dda37b17)({
            commitments: commitments
        });
        if (typeof sidecars === "undefined") {
            const proofs = (0, $13a026c6ed189cfb$export$78a225f8922765eb)({
                blobs: blobs,
                commitments: commitments,
                kzg: kzg
            });
            sidecars = (0, $8048a52d99894ddb$export$44960962e1c9641b)({
                blobs: blobs,
                commitments: commitments,
                proofs: proofs
            });
        }
    }
    const serializedAccessList = (0, $9c16a2b39217d0a9$export$736ebd57ab43df1)(accessList);
    const serializedTransaction = [
        (0, $9UP4H.toHex)(chainId),
        nonce ? (0, $9UP4H.toHex)(nonce) : "0x",
        maxPriorityFeePerGas ? (0, $9UP4H.toHex)(maxPriorityFeePerGas) : "0x",
        maxFeePerGas ? (0, $9UP4H.toHex)(maxFeePerGas) : "0x",
        gas ? (0, $9UP4H.toHex)(gas) : "0x",
        to ?? "0x",
        value ? (0, $9UP4H.toHex)(value) : "0x",
        data ?? "0x",
        serializedAccessList,
        maxFeePerBlobGas ? (0, $9UP4H.toHex)(maxFeePerBlobGas) : "0x",
        blobVersionedHashes ?? [],
        ...$127c27078f06243d$export$13ef8e144f96fd76(transaction, signature)
    ];
    const blobs = [];
    const commitments = [];
    const proofs = [];
    if (sidecars) for(let i = 0; i < sidecars.length; i++){
        const { blob: blob, commitment: commitment, proof: proof } = sidecars[i];
        blobs.push(blob);
        commitments.push(commitment);
        proofs.push(proof);
    }
    return (0, $jCBOw.concatHex)([
        "0x03",
        sidecars ? (0, $e590101db94df837$export$140c78e750979cda)([
            serializedTransaction,
            blobs,
            commitments,
            proofs
        ]) : (0, $e590101db94df837$export$140c78e750979cda)(serializedTransaction)
    ]);
}
function $127c27078f06243d$var$serializeTransactionEIP1559(transaction, signature) {
    const { chainId: chainId, gas: gas, nonce: nonce, to: to, value: value, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, accessList: accessList, data: data } = transaction;
    (0, $39552fbcbcc991f9$export$9ce52ad2ebd4d8fd)(transaction);
    const serializedAccessList = (0, $9c16a2b39217d0a9$export$736ebd57ab43df1)(accessList);
    const serializedTransaction = [
        (0, $9UP4H.toHex)(chainId),
        nonce ? (0, $9UP4H.toHex)(nonce) : "0x",
        maxPriorityFeePerGas ? (0, $9UP4H.toHex)(maxPriorityFeePerGas) : "0x",
        maxFeePerGas ? (0, $9UP4H.toHex)(maxFeePerGas) : "0x",
        gas ? (0, $9UP4H.toHex)(gas) : "0x",
        to ?? "0x",
        value ? (0, $9UP4H.toHex)(value) : "0x",
        data ?? "0x",
        serializedAccessList,
        ...$127c27078f06243d$export$13ef8e144f96fd76(transaction, signature)
    ];
    return (0, $jCBOw.concatHex)([
        "0x02",
        (0, $e590101db94df837$export$140c78e750979cda)(serializedTransaction)
    ]);
}
function $127c27078f06243d$var$serializeTransactionEIP2930(transaction, signature) {
    const { chainId: chainId, gas: gas, data: data, nonce: nonce, to: to, value: value, accessList: accessList, gasPrice: gasPrice } = transaction;
    (0, $39552fbcbcc991f9$export$18dc5e03b8985881)(transaction);
    const serializedAccessList = (0, $9c16a2b39217d0a9$export$736ebd57ab43df1)(accessList);
    const serializedTransaction = [
        (0, $9UP4H.toHex)(chainId),
        nonce ? (0, $9UP4H.toHex)(nonce) : "0x",
        gasPrice ? (0, $9UP4H.toHex)(gasPrice) : "0x",
        gas ? (0, $9UP4H.toHex)(gas) : "0x",
        to ?? "0x",
        value ? (0, $9UP4H.toHex)(value) : "0x",
        data ?? "0x",
        serializedAccessList,
        ...$127c27078f06243d$export$13ef8e144f96fd76(transaction, signature)
    ];
    return (0, $jCBOw.concatHex)([
        "0x01",
        (0, $e590101db94df837$export$140c78e750979cda)(serializedTransaction)
    ]);
}
function $127c27078f06243d$var$serializeTransactionLegacy(transaction, signature) {
    const { chainId: chainId = 0, gas: gas, data: data, nonce: nonce, to: to, value: value, gasPrice: gasPrice } = transaction;
    (0, $39552fbcbcc991f9$export$f9ff7fa58fadd108)(transaction);
    let serializedTransaction = [
        nonce ? (0, $9UP4H.toHex)(nonce) : "0x",
        gasPrice ? (0, $9UP4H.toHex)(gasPrice) : "0x",
        gas ? (0, $9UP4H.toHex)(gas) : "0x",
        to ?? "0x",
        value ? (0, $9UP4H.toHex)(value) : "0x",
        data ?? "0x"
    ];
    if (signature) {
        const v = (()=>{
            // EIP-155 (inferred chainId)
            if (signature.v >= 35n) {
                const inferredChainId = (signature.v - 35n) / 2n;
                if (inferredChainId > 0) return signature.v;
                return 27n + (signature.v === 35n ? 0n : 1n);
            }
            // EIP-155 (explicit chainId)
            if (chainId > 0) return BigInt(chainId * 2) + BigInt(35n + signature.v - 27n);
            // Pre-EIP-155 (no chainId)
            const v = 27n + (signature.v === 27n ? 0n : 1n);
            if (signature.v !== v) throw new (0, $8ceqR.InvalidLegacyVError)({
                v: signature.v
            });
            return v;
        })();
        const r = (0, $44bP9.trim)(signature.r);
        const s = (0, $44bP9.trim)(signature.s);
        serializedTransaction = [
            ...serializedTransaction,
            (0, $9UP4H.toHex)(v),
            r === "0x00" ? "0x" : r,
            s === "0x00" ? "0x" : s
        ];
    } else if (chainId > 0) serializedTransaction = [
        ...serializedTransaction,
        (0, $9UP4H.toHex)(chainId),
        "0x",
        "0x"
    ];
    return (0, $e590101db94df837$export$140c78e750979cda)(serializedTransaction);
}
function $127c27078f06243d$export$13ef8e144f96fd76(transaction, signature_) {
    const signature = signature_ ?? transaction;
    const { v: v, yParity: yParity } = signature;
    if (typeof signature.r === "undefined") return [];
    if (typeof signature.s === "undefined") return [];
    if (typeof v === "undefined" && typeof yParity === "undefined") return [];
    const r = (0, $44bP9.trim)(signature.r);
    const s = (0, $44bP9.trim)(signature.s);
    const yParity_ = (()=>{
        if (typeof yParity === "number") return yParity ? (0, $9UP4H.toHex)(1) : "0x";
        if (v === 0n) return "0x";
        if (v === 1n) return (0, $9UP4H.toHex)(1);
        return v === 27n ? "0x" : (0, $9UP4H.toHex)(1);
    })();
    return [
        yParity_,
        r === "0x00" ? "0x" : r,
        s === "0x00" ? "0x" : s
    ];
}


function $71d0ca9d40b5fac7$export$7cb44e9a321cd996(transaction, signature) {
    if ($71d0ca9d40b5fac7$var$isDeposit(transaction)) return $71d0ca9d40b5fac7$var$serializeTransactionDeposit(transaction);
    return (0, $127c27078f06243d$export$7cb44e9a321cd996)(transaction, signature);
}
const $71d0ca9d40b5fac7$export$7824249990c72c71 = {
    transaction: $71d0ca9d40b5fac7$export$7cb44e9a321cd996
};
function $71d0ca9d40b5fac7$var$serializeTransactionDeposit(transaction) {
    $71d0ca9d40b5fac7$export$91db50bb3f58e144(transaction);
    const { sourceHash: sourceHash, data: data, from: from, gas: gas, isSystemTx: isSystemTx, mint: mint, to: to, value: value } = transaction;
    const serializedTransaction = [
        sourceHash,
        from,
        to ?? "0x",
        mint ? (0, $9UP4H.toHex)(mint) : "0x",
        value ? (0, $9UP4H.toHex)(value) : "0x",
        gas ? (0, $9UP4H.toHex)(gas) : "0x",
        isSystemTx ? "0x1" : "0x",
        data ?? "0x"
    ];
    return (0, $jCBOw.concatHex)([
        "0x7e",
        (0, $e590101db94df837$export$140c78e750979cda)(serializedTransaction)
    ]);
}
function $71d0ca9d40b5fac7$var$isDeposit(transaction) {
    if (transaction.type === "deposit") return true;
    if (typeof transaction.sourceHash !== "undefined") return true;
    return false;
}
function $71d0ca9d40b5fac7$export$91db50bb3f58e144(transaction) {
    const { from: from, to: to } = transaction;
    if (from && !(0, $4rOic.isAddress)(from)) throw new (0, $8j5HI.InvalidAddressError)({
        address: from
    });
    if (to && !(0, $4rOic.isAddress)(to)) throw new (0, $8j5HI.InvalidAddressError)({
        address: to
    });
}


const $d235ef7a541b95b3$export$ca9ff151299322fa = {
    contracts: $9ce8a13c09715a1b$export$ea30b8ddade7b2c1,
    formatters: $5995301a9f0100a9$export$fe98a034cfb96d55,
    serializers: $71d0ca9d40b5fac7$export$7824249990c72c71
};



const $9367250286d9393b$var$sourceId = 1; // mainnet
const $9367250286d9393b$export$e2253033e6e1df16 = /*#__PURE__*/ (0, $bcc18d892337011b$export$b6380ff64616a4fb)({
    ...(0, $d235ef7a541b95b3$export$ca9ff151299322fa),
    id: 8453,
    name: "Base",
    nativeCurrency: {
        name: "Ether",
        symbol: "ETH",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://mainnet.base.org"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "Basescan",
            url: "https://basescan.org",
            apiUrl: "https://api.basescan.org/api"
        }
    },
    contracts: {
        ...(0, $d235ef7a541b95b3$export$ca9ff151299322fa).contracts,
        l2OutputOracle: {
            [$9367250286d9393b$var$sourceId]: {
                address: "0x56315b90c40730925ec5485cf004d835058518A0"
            }
        },
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 5022
        },
        portal: {
            [$9367250286d9393b$var$sourceId]: {
                address: "0x49048044D57e1C92A77f79988d21Fa8fAF74E97e",
                blockCreated: 17482143
            }
        },
        l1StandardBridge: {
            [$9367250286d9393b$var$sourceId]: {
                address: "0x3154Cf16ccdb4C6d922629664174b904d80F2C35",
                blockCreated: 17482143
            }
        }
    },
    sourceId: $9367250286d9393b$var$sourceId
});


const $9b388afd19f7d528$export$170e8cdd0c4e59c8 = /*#__PURE__*/ (0, $bcc18d892337011b$export$b6380ff64616a4fb)({
    id: 56,
    name: "BNB Smart Chain",
    nativeCurrency: {
        decimals: 18,
        name: "BNB",
        symbol: "BNB"
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc.ankr.com/bsc"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "BscScan",
            url: "https://bscscan.com",
            apiUrl: "https://api.bscscan.com/api"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 15921452
        }
    }
});


const $3134da6e07c5b611$export$1c182ebff3ea4eef = /*#__PURE__*/ (0, $bcc18d892337011b$export$b6380ff64616a4fb)({
    id: 97,
    name: "Binance Smart Chain Testnet",
    nativeCurrency: {
        decimals: 18,
        name: "BNB",
        symbol: "tBNB"
    },
    rpcUrls: {
        default: {
            http: [
                "https://data-seed-prebsc-1-s1.bnbchain.org:8545"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "BscScan",
            url: "https://testnet.bscscan.com",
            apiUrl: "https://testnet.bscscan.com/api"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 17422483
        }
    },
    testnet: true
});


const $c514e5408690e775$export$b7b19aa0ee06c73 = /*#__PURE__*/ (0, $bcc18d892337011b$export$b6380ff64616a4fb)({
    id: 137,
    name: "Polygon",
    nativeCurrency: {
        name: "MATIC",
        symbol: "MATIC",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://polygon-rpc.com"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "PolygonScan",
            url: "https://polygonscan.com",
            apiUrl: "https://api.polygonscan.com/api"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 25770160
        }
    }
});


const $c2e289b0bd5d55c4$export$34b6ef3a78067459 = /*#__PURE__*/ (0, $bcc18d892337011b$export$b6380ff64616a4fb)({
    id: 80001,
    name: "Polygon Mumbai",
    nativeCurrency: {
        name: "MATIC",
        symbol: "MATIC",
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: [
                "https://rpc.ankr.com/polygon_mumbai"
            ]
        }
    },
    blockExplorers: {
        default: {
            name: "PolygonScan",
            url: "https://mumbai.polygonscan.com",
            apiUrl: "https://api-testnet.polygonscan.com/api"
        }
    },
    contracts: {
        multicall3: {
            address: "0xca11bde05977b3631167028862be2a173976ca11",
            blockCreated: 25770160
        }
    },
    testnet: true
});


var $4a7def4dd766b60b$exports = {};

$4a7def4dd766b60b$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "ArbitrumLogo.4a7518b6.svg";


var $419e6e6a8c2ce84c$exports = {};

$419e6e6a8c2ce84c$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "AvalancheLogo.ad53a0d0.svg";


var $45ea51ae3199adc7$exports = {};

$45ea51ae3199adc7$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "BaseLogo.e87313d9.svg";


var $4343aa8ba0291c55$exports = {};

$4343aa8ba0291c55$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "BAT.1212afba.svg";


var $6f1e8ceecab5748c$exports = {};

$6f1e8ceecab5748c$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "BNBLogo.3dada3dc.svg";


var $72a817535a6252f6$exports = {};

$72a817535a6252f6$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "BTCLogo.5558c6c7.svg";


var $d6dcdafb97da2969$exports = {};

$d6dcdafb97da2969$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "BUSDLogo.a70524b3.svg";


var $80dceaf84aad95b0$exports = {};

$80dceaf84aad95b0$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "CardanoLogo.c8e54c54.svg";


var $6dc91777267ebd44$exports = {};

$6dc91777267ebd44$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "DashLogo.ac107e85.svg";


var $e76aa866434331c2$exports = {};

$e76aa866434331c2$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "Doge.9d700487.png";


var $efbb8253bf7e1d52$exports = {};

$efbb8253bf7e1d52$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "DogeLogo.58faeab6.svg";


var $e34758ec81c0a72c$exports = {};

$e34758ec81c0a72c$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "DOT.7e599be5.svg";


var $54e6e7b6ede079aa$exports = {};

$54e6e7b6ede079aa$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "EthLogo.13b90052.svg";


var $7ba2872c3a884e73$exports = {};

$7ba2872c3a884e73$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "LitecoinLogo.f8fad246.svg";


var $5a57dde235c79701$exports = {};

$5a57dde235c79701$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "PolygonLogo.dda6f433.svg";


var $7012358ba53dfe8b$exports = {};

$7012358ba53dfe8b$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "Solana.3c790cbc.svg";


var $045a81ce5300c0bd$exports = {};

$045a81ce5300c0bd$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "TetherLogo.6d30f474.svg";


var $bcd65e04c94d9f59$exports = {};

$bcd65e04c94d9f59$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "TronLogo.a023c6a9.svg";


var $c3ae5bd62f2a8d35$exports = {};

$c3ae5bd62f2a8d35$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "USDCLogo.08b3a902.svg";


var $ec82471620373804$exports = {};

$ec82471620373804$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "VerseLogo.e24b56c2.png";


var $c3f64aaf7cb1e1ed$exports = {};

$c3f64aaf7cb1e1ed$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "XMRLogo.26608d9e.svg";


var $c66f0b943349404f$exports = {};

$c66f0b943349404f$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "ZcashLogo.5ee68c2f.svg";


const $61f236426b9e4eab$export$cc4208a8ebc9f985 = {
    Ethereum: (0, $fcacb2d075a52fce$export$536d3e0d2c7baf54),
    Avalanche: (0, $69611fdc05cc517c$export$ca1d15c01fde7266),
    Base: (0, $9367250286d9393b$export$e2253033e6e1df16),
    SepoliaTestnet: {
        id: 11155111,
        network: "sepolia",
        name: "Sepolia",
        nativeCurrency: {
            name: "Sepolia Ether",
            symbol: "SEP",
            decimals: 18
        },
        rpcUrls: {
            alchemy: {
                http: [
                    "https://eth-sepolia.g.alchemy.com/v2"
                ],
                webSocket: [
                    "wss://eth-sepolia.g.alchemy.com/v2"
                ]
            },
            infura: {
                http: [
                    "https://sepolia.infura.io/v3"
                ],
                webSocket: [
                    "wss://sepolia.infura.io/ws/v3"
                ]
            },
            default: {
                http: [
                    "https://eth-sepolia.api.onfinality.io/public",
                    "https://sepolia.gateway.tenderly.co",
                    "https://gateway.tenderly.co/public/sepolia",
                    "https://eth-sepolia.public.blastapi.io",
                    "https://ethereum-sepolia-rpc.publicnode.com",
                    "https://endpoints.omniatech.io/v1/eth/sepolia/public",
                    "https://eth-sepolia-public.unifra.io",
                    "https://sepolia.drpc.org",
                    "https://api.zan.top/eth-sepolia"
                ]
            },
            public: {
                http: [
                    "https://rpc2.sepolia.org"
                ]
            }
        },
        blockExplorers: {
            etherscan: {
                name: "Etherscan",
                url: "https://sepolia.etherscan.io"
            },
            default: {
                name: "Etherscan",
                url: "https://sepolia.etherscan.io"
            }
        },
        contracts: {
            multicall3: {
                address: "0xca11bde05977b3631167028862be2a173976ca11",
                blockCreated: 6507670
            }
        },
        testnet: true
    },
    Polygon: (0, $c514e5408690e775$export$b7b19aa0ee06c73),
    PolygonTestnet: (0, $c2e289b0bd5d55c4$export$34b6ef3a78067459),
    BNB: (0, $9b388afd19f7d528$export$170e8cdd0c4e59c8),
    BNBTestnet: (0, $3134da6e07c5b611$export$1c182ebff3ea4eef),
    Arbitrum: (0, $3401251e3fb8de97$export$625cf84d855940d4),
    ArbitrumTestnet: (0, $4ae0c7e78bd74eb3$export$857f1b5f596fb425)
};
const $61f236426b9e4eab$var$chains = Object.values($61f236426b9e4eab$export$cc4208a8ebc9f985);
const $61f236426b9e4eab$export$e4bb003b4e7478a = "e13bb5b25a3121bba8a056c8dadd0c1c";
const $61f236426b9e4eab$var$metadata = {
    name: "Radom",
    description: "Decentralized payments",
    url: "https://radom.com",
    icons: []
};
const $61f236426b9e4eab$export$382a3cc012b91987 = (0, $c54fe4d07c58f9e7$export$134240a34d71525e)({
    chains: $61f236426b9e4eab$var$chains,
    projectId: $61f236426b9e4eab$export$e4bb003b4e7478a,
    metadata: $61f236426b9e4eab$var$metadata
});
const $61f236426b9e4eab$export$ba33f6d94de735b7 = ()=>[
        {
            name: "Bitcoin",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($72a817535a6252f6$exports))),
            ticker: "BTC"
        },
        {
            name: "BitcoinTestnet",
            currencyName: "Bitcoin",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($72a817535a6252f6$exports))),
            ticker: "BTC",
            isTestnet: true
        },
        {
            name: "Ethereum",
            currencyName: "Ether",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($54e6e7b6ede079aa$exports))),
            ticker: "ETH",
            isWalletSupported: true
        },
        {
            name: "SepoliaTestnet",
            currencyName: "Ether",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($54e6e7b6ede079aa$exports))),
            ticker: "ETH",
            isTestnet: true,
            isWalletSupported: true
        },
        {
            name: "Polygon",
            currencyName: "Matic",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($5a57dde235c79701$exports))),
            ticker: "MATIC",
            isWalletSupported: true
        },
        {
            name: "Avalanche",
            currencyName: "Avalanche",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($419e6e6a8c2ce84c$exports))),
            ticker: "AVAX",
            isWalletSupported: true
        },
        {
            name: "PolygonTestnet",
            currencyName: "Matic",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($5a57dde235c79701$exports))),
            ticker: "MATIC",
            isTestnet: true,
            isWalletSupported: true
        },
        {
            name: "BNB",
            currencyName: "BNB",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($6f1e8ceecab5748c$exports))),
            ticker: "BNB",
            isWalletSupported: true
        },
        {
            name: "BNBTestnet",
            currencyName: "BNB",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($6f1e8ceecab5748c$exports))),
            ticker: "BNB",
            isTestnet: true,
            isWalletSupported: true
        },
        {
            name: "Arbitrum",
            currencyName: "ETH",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($4a7def4dd766b60b$exports))),
            ticker: "ETH",
            isWalletSupported: true
        },
        {
            name: "Base",
            currencyName: "ETH",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($45ea51ae3199adc7$exports))),
            ticker: "ETH",
            isWalletSupported: true
        },
        {
            name: "Sepolia USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($c3ae5bd62f2a8d35$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 11155111,
                tokenAddress: "0xa4fCE8264370437e718aE207805b4e6233638b9E",
                networkName: "SepoliaTestnet",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($54e6e7b6ede079aa$exports))),
                decimals: 6,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isTestnet: true,
            isWalletSupported: true
        },
        {
            name: "Devnet USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($c3ae5bd62f2a8d35$exports))),
            tokenInfo: {
                tokenType: "solana",
                tokenAddress: "4zMMC9srt5Ri5X14GAgXhaHii3GnPAEERYPJgZJDncDU",
                networkName: "SolanaDevnet",
                cluster: "SolanaDevnet",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($7012358ba53dfe8b$exports))),
                decimals: 6
            },
            isTestnet: true,
            isSolana: true,
            isWalletSupported: true
        },
        {
            name: "Sepolia Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($045a81ce5300c0bd$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 11155111,
                tokenAddress: "0xE50d86c6dE38F9754f6777d2925377564Bf79482",
                networkName: "SepoliaTestnet",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($54e6e7b6ede079aa$exports))),
                decimals: 6,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isTestnet: true,
            isWalletSupported: true
        },
        {
            name: "Basic Attention Token",
            ticker: "BAT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($4343aa8ba0291c55$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 11155111,
                tokenAddress: "0x5D684d37922dAf7Aa2013E65A22880a11C475e25",
                networkName: "SepoliaTestnet",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($54e6e7b6ede079aa$exports))),
                decimals: 18,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isTestnet: true,
            isWalletSupported: true
        },
        {
            name: "Polygon Testnet USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($c3ae5bd62f2a8d35$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 80001,
                tokenAddress: "0x8f8b1972eea072C3C228EbE8f9FEADe03927D70F",
                networkName: "PolygonTestnet",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($5a57dde235c79701$exports))),
                decimals: 6,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isTestnet: true,
            isWalletSupported: true
        },
        {
            name: "Polygon Testnet Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($045a81ce5300c0bd$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 80001,
                tokenAddress: "0x70BE8802e2F3C6652B7e0814B478f66Ec52d9d88",
                networkName: "PolygonTestnet",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($5a57dde235c79701$exports))),
                decimals: 6,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isTestnet: true,
            isWalletSupported: true
        },
        {
            name: "Polygon Testnet BAT",
            ticker: "BAT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($4343aa8ba0291c55$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 80001,
                tokenAddress: "0xd445cAAbb9eA6685D3A512439256866563a16E93",
                networkName: "PolygonTestnet",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($5a57dde235c79701$exports))),
                decimals: 18,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isTestnet: true,
            isWalletSupported: true
        },
        {
            name: "Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($045a81ce5300c0bd$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 1,
                tokenAddress: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
                networkName: "Ethereum",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($54e6e7b6ede079aa$exports))),
                decimals: 6,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isWalletSupported: true
        },
        {
            name: "Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($045a81ce5300c0bd$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 137,
                tokenAddress: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
                networkName: "Polygon",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($5a57dde235c79701$exports))),
                decimals: 6,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isWalletSupported: true
        },
        {
            name: "Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($045a81ce5300c0bd$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 56,
                tokenAddress: "0x55d398326f99059ff775485246999027b3197955",
                networkName: "BNB",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($6f1e8ceecab5748c$exports))),
                decimals: 18,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isWalletSupported: true
        },
        {
            name: "USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($c3ae5bd62f2a8d35$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 56,
                tokenAddress: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
                networkName: "BNB",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($6f1e8ceecab5748c$exports))),
                decimals: 18,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isWalletSupported: true
        },
        {
            name: "USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($c3ae5bd62f2a8d35$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 8453,
                tokenAddress: "0x833589fcd6edb6e08f4c7c32d4f71b54bda02913",
                networkName: "Base",
                subscriptionContract: "0x61dD58140201Af4E77B67a36BaA25e1e560d87E9",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($45ea51ae3199adc7$exports))),
                decimals: 6
            },
            isWalletSupported: true
        },
        {
            name: "USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($c3ae5bd62f2a8d35$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 42161,
                tokenAddress: "0xaf88d065e77c8cc2239327c5edb3a432268e5831",
                networkName: "Arbitrum",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($4a7def4dd766b60b$exports))),
                decimals: 6
            },
            isWalletSupported: true
        },
        {
            name: "Bridged USD Coin",
            ticker: "USDC.e",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($c3ae5bd62f2a8d35$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 42161,
                tokenAddress: "0xff970a61a04b1ca14834a43f5de4533ebddb5cc8",
                networkName: "Arbitrum",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($4a7def4dd766b60b$exports))),
                decimals: 6
            },
            isWalletSupported: true
        },
        {
            name: "Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($045a81ce5300c0bd$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 42161,
                tokenAddress: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
                networkName: "Arbitrum",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($4a7def4dd766b60b$exports))),
                decimals: 6
            },
            isWalletSupported: true
        },
        {
            name: "Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($045a81ce5300c0bd$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 43114,
                tokenAddress: "0x9702230a8ea53601f5cd2dc00fdbc13d4df4a8c7",
                networkName: "Avalanche",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($419e6e6a8c2ce84c$exports))),
                decimals: 6
            },
            isWalletSupported: true
        },
        {
            name: "Binance USD",
            ticker: "BUSD",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($d6dcdafb97da2969$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 56,
                tokenAddress: "0xe9e7cea3dedca5984780bafc599bd69add087d56",
                networkName: "BNB",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($6f1e8ceecab5748c$exports))),
                decimals: 18,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isWalletSupported: true
        },
        {
            name: "Basic Attention Token",
            ticker: "BAT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($4343aa8ba0291c55$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 56,
                tokenAddress: "0x101d82428437127bf1608f699cd651e6abf9766e",
                networkName: "BNB",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($6f1e8ceecab5748c$exports))),
                decimals: 18,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isWalletSupported: true
        },
        {
            name: "USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($c3ae5bd62f2a8d35$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 1,
                tokenAddress: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
                networkName: "Ethereum",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($54e6e7b6ede079aa$exports))),
                decimals: 6,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isWalletSupported: true
        },
        {
            name: "Basic Attention Token",
            ticker: "BAT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($4343aa8ba0291c55$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 1,
                tokenAddress: "0x0d8775f648430679a709e98d2b0cb6250d2887ef",
                networkName: "Ethereum",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($54e6e7b6ede079aa$exports))),
                decimals: 18,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isWalletSupported: true
        },
        {
            name: "Verse",
            ticker: "VERSE",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($ec82471620373804$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 1,
                tokenAddress: "0x249ca82617ec3dfb2589c4c17ab7ec9765350a18",
                networkName: "Ethereum",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($54e6e7b6ede079aa$exports))),
                decimals: 18,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isWalletSupported: true
        },
        {
            name: "Bridged USD Coin",
            ticker: "USDC.e",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($c3ae5bd62f2a8d35$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 137,
                tokenAddress: "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
                networkName: "Polygon",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($5a57dde235c79701$exports))),
                decimals: 6,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isWalletSupported: true
        },
        {
            name: "USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($c3ae5bd62f2a8d35$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 137,
                tokenAddress: "0x3c499c542cef5e3811e1192ce70d8cc03d5c3359",
                networkName: "Polygon",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($5a57dde235c79701$exports))),
                decimals: 6,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isWalletSupported: true
        },
        {
            name: "USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($c3ae5bd62f2a8d35$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 137,
                tokenAddress: "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
                networkName: "Polygon",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($5a57dde235c79701$exports))),
                decimals: 6,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isWalletSupported: true
        },
        {
            name: "Basic Attention Token",
            ticker: "BAT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($4343aa8ba0291c55$exports))),
            tokenInfo: {
                tokenType: "evm",
                chainId: 137,
                tokenAddress: "0x3cef98bb43d732e2f285ee605a8158cde967d219",
                networkName: "Polygon",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($5a57dde235c79701$exports))),
                decimals: 18,
                subscriptionContract: "0x87Fcf739aEe21FAb3b99121fA4f2D7bF243f9F15"
            },
            isWalletSupported: true
        },
        {
            name: "Solana",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($7012358ba53dfe8b$exports))),
            ticker: "SOL",
            isSolana: true,
            isWalletSupported: true
        },
        {
            name: "SolanaTestnet",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($7012358ba53dfe8b$exports))),
            ticker: "SOL",
            isTestnet: true,
            isSolana: true,
            isWalletSupported: true
        },
        {
            name: "SolanaDevnet",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($7012358ba53dfe8b$exports))),
            ticker: "SOL",
            isTestnet: true,
            isSolana: true,
            isWalletSupported: true
        },
        {
            name: "Polkadot",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($e34758ec81c0a72c$exports))),
            ticker: "DOT"
        },
        {
            name: "PolkadotTestnet",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($e34758ec81c0a72c$exports))),
            ticker: "WND",
            isTestnet: true
        },
        {
            name: "PolkadotAssetHub",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($e34758ec81c0a72c$exports))),
            ticker: "DOT"
        },
        {
            name: "Polkadot AssetHub Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($045a81ce5300c0bd$exports))),
            tokenInfo: {
                tokenType: "asset",
                cluster: "mainnet",
                tokenAddress: "1984",
                networkName: "PolkadotAssetHub",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($e34758ec81c0a72c$exports))),
                decimals: 6
            }
        },
        {
            name: "Polkadot AssetHub USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($c3ae5bd62f2a8d35$exports))),
            tokenInfo: {
                tokenType: "asset",
                cluster: "mainnet",
                tokenAddress: "1337",
                networkName: "PolkadotAssetHub",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($e34758ec81c0a72c$exports))),
                decimals: 6
            }
        },
        {
            name: "PolkadotAssetHubTestnet",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($e34758ec81c0a72c$exports))),
            ticker: "WND",
            isTestnet: true
        },
        {
            name: "Polkadot AssetHub Testnet Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($045a81ce5300c0bd$exports))),
            isTestnet: true,
            tokenInfo: {
                tokenType: "asset",
                cluster: "testnet",
                tokenAddress: "21984",
                networkName: "PolkadotAssetHubTestnet",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($e34758ec81c0a72c$exports))),
                decimals: 6
            }
        },
        {
            name: "Polkadot AssetHub Testnet USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($c3ae5bd62f2a8d35$exports))),
            isTestnet: true,
            tokenInfo: {
                tokenType: "asset",
                cluster: "testnet",
                tokenAddress: "31337",
                networkName: "PolkadotAssetHubTestnet",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($e34758ec81c0a72c$exports))),
                decimals: 6
            }
        },
        {
            name: "Solana Testnet USD Coin",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($c3ae5bd62f2a8d35$exports))),
            ticker: "USDC",
            isTestnet: true,
            tokenInfo: {
                tokenType: "solana",
                cluster: "testnet",
                tokenAddress: "CpMah17kQEL2wqyMKt3mZBdTnZbkbfx4nqmQMFDP5vwp",
                networkName: "SolanaTestnet",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($c3ae5bd62f2a8d35$exports))),
                decimals: 6
            },
            isSolana: true
        },
        {
            name: "Solana Devnet USD Coin",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($c3ae5bd62f2a8d35$exports))),
            ticker: "USDC",
            isTestnet: true,
            tokenInfo: {
                tokenType: "solana",
                cluster: "devnet",
                tokenAddress: "4zMMC9srt5Ri5X14GAgXhaHii3GnPAEERYPJgZJDncDU",
                networkName: "SolanaDevnet",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($c3ae5bd62f2a8d35$exports))),
                decimals: 6
            },
            isSolana: true
        },
        {
            name: "Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($045a81ce5300c0bd$exports))),
            tokenInfo: {
                tokenType: "solana",
                cluster: "mainnet",
                tokenAddress: "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
                networkName: "Solana",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($7012358ba53dfe8b$exports))),
                decimals: 6
            },
            isSolana: true,
            isWalletSupported: true
        },
        {
            name: "USD Coin",
            ticker: "USDC",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($c3ae5bd62f2a8d35$exports))),
            tokenInfo: {
                tokenType: "solana",
                cluster: "mainnet",
                tokenAddress: "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
                networkName: "Solana",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($7012358ba53dfe8b$exports))),
                decimals: 6
            },
            isSolana: true,
            isWalletSupported: true
        },
        {
            name: "Basic Attention Token",
            ticker: "BAT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($4343aa8ba0291c55$exports))),
            tokenInfo: {
                tokenType: "solana",
                cluster: "mainnet",
                tokenAddress: "EPeUFDgHRxs9xxEPVaL6kfGQvCon7jmAWKVUHuux1Tpz",
                networkName: "Solana",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($7012358ba53dfe8b$exports))),
                decimals: 8
            },
            isSolana: true,
            isWalletSupported: true
        },
        {
            name: "Cardano",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($80dceaf84aad95b0$exports))),
            ticker: "ADA"
        },
        {
            name: "Monero",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($c3f64aaf7cb1e1ed$exports))),
            ticker: "XMR"
        },
        {
            name: "Dogecoin",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($efbb8253bf7e1d52$exports))),
            ticker: "DOGE",
            qrCodeImage: (0, (/*@__PURE__*/$parcel$interopDefault($e76aa866434331c2$exports)))
        },
        {
            name: "Litecoin",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($7ba2872c3a884e73$exports))),
            ticker: "LTC"
        },
        {
            name: "Dash",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($6dc91777267ebd44$exports))),
            ticker: "DASH"
        },
        {
            name: "Zcash",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($c66f0b943349404f$exports))),
            ticker: "ZEC"
        },
        {
            name: "ZcashTestnet",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($c66f0b943349404f$exports))),
            ticker: "ZEC",
            isTestnet: true
        },
        {
            name: "Tron",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($bcd65e04c94d9f59$exports))),
            ticker: "TRX"
        },
        {
            name: "Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($045a81ce5300c0bd$exports))),
            tokenInfo: {
                tokenType: "tron",
                networkName: "Tron",
                tokenAddress: "TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($bcd65e04c94d9f59$exports))),
                decimals: 6
            }
        },
        {
            name: "TronTestnet",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($bcd65e04c94d9f59$exports))),
            ticker: "TRX",
            isTestnet: true
        },
        {
            name: "Tether",
            ticker: "USDT",
            logo: (0, (/*@__PURE__*/$parcel$interopDefault($045a81ce5300c0bd$exports))),
            tokenInfo: {
                tokenType: "tron",
                networkName: "TronTestnet",
                tokenAddress: "TSrUgwP9NPHKMcWPtHRRWcoxFV4JU6R9qk",
                logo: (0, (/*@__PURE__*/$parcel$interopDefault($bcd65e04c94d9f59$exports))),
                decimals: 6
            },
            isTestnet: true
        }
    ];
const $61f236426b9e4eab$export$8793fab959da70d1 = (network, token)=>{
    const method = $61f236426b9e4eab$export$ba33f6d94de735b7().find((m)=>{
        if (token) return m.tokenInfo?.tokenAddress.toLowerCase() === token.toLowerCase() && network.toLowerCase() === m.tokenInfo?.networkName.toLowerCase();
        else return m.name.toLowerCase() === network.toLowerCase();
    });
    if (!method) {
        const method = $61f236426b9e4eab$export$ba33f6d94de735b7().find((m)=>{
            return m.name.toLowerCase() === network.toLowerCase();
        });
        if (method) return method;
    }
    if (!method) return {
        name: "Unknown",
        logo: null,
        ticker: "Unknown"
    };
    return method;
};
const $61f236426b9e4eab$export$aab47327b38c6232 = (m)=>{
    if (!m) return false;
    if (m.tokenInfo) {
        if (m.tokenInfo.tokenType === "evm" && m.tokenInfo.subscriptionContract) return true;
    }
    return false;
};




var $8NFma = parcelRequire("8NFma");
"use strict";
function $93b0f01b05e2607a$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $aace3e920a0f1e4d$var$toString } = Object.prototype;
const { getPrototypeOf: $aace3e920a0f1e4d$var$getPrototypeOf } = Object;
const $aace3e920a0f1e4d$var$kindOf = ((cache)=>(thing)=>{
        const str = $aace3e920a0f1e4d$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $aace3e920a0f1e4d$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$aace3e920a0f1e4d$var$kindOf(thing) === type;
};
const $aace3e920a0f1e4d$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $aace3e920a0f1e4d$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $aace3e920a0f1e4d$var$isUndefined = $aace3e920a0f1e4d$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isBuffer(val) {
    return val !== null && !$aace3e920a0f1e4d$var$isUndefined(val) && val.constructor !== null && !$aace3e920a0f1e4d$var$isUndefined(val.constructor) && $aace3e920a0f1e4d$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $aace3e920a0f1e4d$var$isArrayBuffer = $aace3e920a0f1e4d$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $aace3e920a0f1e4d$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $aace3e920a0f1e4d$var$isString = $aace3e920a0f1e4d$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $aace3e920a0f1e4d$var$isFunction = $aace3e920a0f1e4d$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $aace3e920a0f1e4d$var$isNumber = $aace3e920a0f1e4d$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $aace3e920a0f1e4d$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $aace3e920a0f1e4d$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $aace3e920a0f1e4d$var$isPlainObject = (val)=>{
    if ($aace3e920a0f1e4d$var$kindOf(val) !== "object") return false;
    const prototype = $aace3e920a0f1e4d$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $aace3e920a0f1e4d$var$isDate = $aace3e920a0f1e4d$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $aace3e920a0f1e4d$var$isFile = $aace3e920a0f1e4d$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $aace3e920a0f1e4d$var$isBlob = $aace3e920a0f1e4d$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $aace3e920a0f1e4d$var$isFileList = $aace3e920a0f1e4d$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $aace3e920a0f1e4d$var$isStream = (val)=>$aace3e920a0f1e4d$var$isObject(val) && $aace3e920a0f1e4d$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $aace3e920a0f1e4d$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $aace3e920a0f1e4d$var$isFunction(thing.append) && ((kind = $aace3e920a0f1e4d$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $aace3e920a0f1e4d$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $aace3e920a0f1e4d$var$isURLSearchParams = $aace3e920a0f1e4d$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $aace3e920a0f1e4d$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $aace3e920a0f1e4d$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($aace3e920a0f1e4d$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $aace3e920a0f1e4d$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $aace3e920a0f1e4d$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $aace3e920a0f1e4d$var$isContextDefined = (context)=>!$aace3e920a0f1e4d$var$isUndefined(context) && context !== $aace3e920a0f1e4d$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $aace3e920a0f1e4d$var$merge() {
    const { caseless: caseless } = $aace3e920a0f1e4d$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $aace3e920a0f1e4d$var$findKey(result, key) || key;
        if ($aace3e920a0f1e4d$var$isPlainObject(result[targetKey]) && $aace3e920a0f1e4d$var$isPlainObject(val)) result[targetKey] = $aace3e920a0f1e4d$var$merge(result[targetKey], val);
        else if ($aace3e920a0f1e4d$var$isPlainObject(val)) result[targetKey] = $aace3e920a0f1e4d$var$merge({}, val);
        else if ($aace3e920a0f1e4d$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $aace3e920a0f1e4d$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $aace3e920a0f1e4d$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $aace3e920a0f1e4d$var$forEach(b, (val, key)=>{
        if (thisArg && $aace3e920a0f1e4d$var$isFunction(val)) a[key] = (0, $93b0f01b05e2607a$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $aace3e920a0f1e4d$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $aace3e920a0f1e4d$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $aace3e920a0f1e4d$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $aace3e920a0f1e4d$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $aace3e920a0f1e4d$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $aace3e920a0f1e4d$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($aace3e920a0f1e4d$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$aace3e920a0f1e4d$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $aace3e920a0f1e4d$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $aace3e920a0f1e4d$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $aace3e920a0f1e4d$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $aace3e920a0f1e4d$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $aace3e920a0f1e4d$var$isHTMLForm = $aace3e920a0f1e4d$var$kindOfTest("HTMLFormElement");
const $aace3e920a0f1e4d$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $aace3e920a0f1e4d$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $aace3e920a0f1e4d$var$isRegExp = $aace3e920a0f1e4d$var$kindOfTest("RegExp");
const $aace3e920a0f1e4d$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $aace3e920a0f1e4d$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $aace3e920a0f1e4d$var$freezeMethods = (obj)=>{
    $aace3e920a0f1e4d$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($aace3e920a0f1e4d$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$aace3e920a0f1e4d$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $aace3e920a0f1e4d$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $aace3e920a0f1e4d$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $aace3e920a0f1e4d$var$noop = ()=>{};
const $aace3e920a0f1e4d$var$toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const $aace3e920a0f1e4d$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $aace3e920a0f1e4d$var$DIGIT = "0123456789";
const $aace3e920a0f1e4d$var$ALPHABET = {
    DIGIT: $aace3e920a0f1e4d$var$DIGIT,
    ALPHA: $aace3e920a0f1e4d$var$ALPHA,
    ALPHA_DIGIT: $aace3e920a0f1e4d$var$ALPHA + $aace3e920a0f1e4d$var$ALPHA.toUpperCase() + $aace3e920a0f1e4d$var$DIGIT
};
const $aace3e920a0f1e4d$var$generateString = (size = 16, alphabet = $aace3e920a0f1e4d$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $aace3e920a0f1e4d$var$isSpecCompliantForm(thing) {
    return !!(thing && $aace3e920a0f1e4d$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $aace3e920a0f1e4d$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($aace3e920a0f1e4d$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $aace3e920a0f1e4d$var$isArray(source) ? [] : {};
                $aace3e920a0f1e4d$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$aace3e920a0f1e4d$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $aace3e920a0f1e4d$var$isAsyncFn = $aace3e920a0f1e4d$var$kindOfTest("AsyncFunction");
const $aace3e920a0f1e4d$var$isThenable = (thing)=>thing && ($aace3e920a0f1e4d$var$isObject(thing) || $aace3e920a0f1e4d$var$isFunction(thing)) && $aace3e920a0f1e4d$var$isFunction(thing.then) && $aace3e920a0f1e4d$var$isFunction(thing.catch);
var $aace3e920a0f1e4d$export$2e2bcd8739ae039 = {
    isArray: $aace3e920a0f1e4d$var$isArray,
    isArrayBuffer: $aace3e920a0f1e4d$var$isArrayBuffer,
    isBuffer: $aace3e920a0f1e4d$var$isBuffer,
    isFormData: $aace3e920a0f1e4d$var$isFormData,
    isArrayBufferView: $aace3e920a0f1e4d$var$isArrayBufferView,
    isString: $aace3e920a0f1e4d$var$isString,
    isNumber: $aace3e920a0f1e4d$var$isNumber,
    isBoolean: $aace3e920a0f1e4d$var$isBoolean,
    isObject: $aace3e920a0f1e4d$var$isObject,
    isPlainObject: $aace3e920a0f1e4d$var$isPlainObject,
    isUndefined: $aace3e920a0f1e4d$var$isUndefined,
    isDate: $aace3e920a0f1e4d$var$isDate,
    isFile: $aace3e920a0f1e4d$var$isFile,
    isBlob: $aace3e920a0f1e4d$var$isBlob,
    isRegExp: $aace3e920a0f1e4d$var$isRegExp,
    isFunction: $aace3e920a0f1e4d$var$isFunction,
    isStream: $aace3e920a0f1e4d$var$isStream,
    isURLSearchParams: $aace3e920a0f1e4d$var$isURLSearchParams,
    isTypedArray: $aace3e920a0f1e4d$var$isTypedArray,
    isFileList: $aace3e920a0f1e4d$var$isFileList,
    forEach: $aace3e920a0f1e4d$var$forEach,
    merge: $aace3e920a0f1e4d$var$merge,
    extend: $aace3e920a0f1e4d$var$extend,
    trim: $aace3e920a0f1e4d$var$trim,
    stripBOM: $aace3e920a0f1e4d$var$stripBOM,
    inherits: $aace3e920a0f1e4d$var$inherits,
    toFlatObject: $aace3e920a0f1e4d$var$toFlatObject,
    kindOf: $aace3e920a0f1e4d$var$kindOf,
    kindOfTest: $aace3e920a0f1e4d$var$kindOfTest,
    endsWith: $aace3e920a0f1e4d$var$endsWith,
    toArray: $aace3e920a0f1e4d$var$toArray,
    forEachEntry: $aace3e920a0f1e4d$var$forEachEntry,
    matchAll: $aace3e920a0f1e4d$var$matchAll,
    isHTMLForm: $aace3e920a0f1e4d$var$isHTMLForm,
    hasOwnProperty: $aace3e920a0f1e4d$var$hasOwnProperty,
    hasOwnProp: $aace3e920a0f1e4d$var$hasOwnProperty,
    reduceDescriptors: $aace3e920a0f1e4d$var$reduceDescriptors,
    freezeMethods: $aace3e920a0f1e4d$var$freezeMethods,
    toObjectSet: $aace3e920a0f1e4d$var$toObjectSet,
    toCamelCase: $aace3e920a0f1e4d$var$toCamelCase,
    noop: $aace3e920a0f1e4d$var$noop,
    toFiniteNumber: $aace3e920a0f1e4d$var$toFiniteNumber,
    findKey: $aace3e920a0f1e4d$var$findKey,
    global: $aace3e920a0f1e4d$var$_global,
    isContextDefined: $aace3e920a0f1e4d$var$isContextDefined,
    ALPHABET: $aace3e920a0f1e4d$var$ALPHABET,
    generateString: $aace3e920a0f1e4d$var$generateString,
    isSpecCompliantForm: $aace3e920a0f1e4d$var$isSpecCompliantForm,
    toJSONObject: $aace3e920a0f1e4d$var$toJSONObject,
    isAsyncFn: $aace3e920a0f1e4d$var$isAsyncFn,
    isThenable: $aace3e920a0f1e4d$var$isThenable
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $0139f1d30f4d6bd5$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).inherits($0139f1d30f4d6bd5$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $0139f1d30f4d6bd5$var$prototype = $0139f1d30f4d6bd5$var$AxiosError.prototype;
const $0139f1d30f4d6bd5$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $0139f1d30f4d6bd5$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($0139f1d30f4d6bd5$var$AxiosError, $0139f1d30f4d6bd5$var$descriptors);
Object.defineProperty($0139f1d30f4d6bd5$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$0139f1d30f4d6bd5$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($0139f1d30f4d6bd5$var$prototype);
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $0139f1d30f4d6bd5$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $0139f1d30f4d6bd5$export$2e2bcd8739ae039 = $0139f1d30f4d6bd5$var$AxiosError;


// eslint-disable-next-line strict
var $86ebf0c810395e29$export$2e2bcd8739ae039 = null;



var $N0o3H = parcelRequire("N0o3H");
var $fd07b9cb0132c1f6$require$Buffer = $N0o3H.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $fd07b9cb0132c1f6$var$isVisitable(thing) {
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $fd07b9cb0132c1f6$var$removeBrackets(key) {
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $fd07b9cb0132c1f6$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $fd07b9cb0132c1f6$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $fd07b9cb0132c1f6$var$isFlatArray(arr) {
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(arr) && !arr.some($fd07b9cb0132c1f6$var$isVisitable);
}
const $fd07b9cb0132c1f6$var$predicates = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toFlatObject((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $fd07b9cb0132c1f6$var$toFormData(obj, formData, options) {
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $86ebf0c810395e29$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $fd07b9cb0132c1f6$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(value) && $fd07b9cb0132c1f6$var$isFlatArray(value) || ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFileList(value) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $fd07b9cb0132c1f6$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $fd07b9cb0132c1f6$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($fd07b9cb0132c1f6$var$isVisitable(value)) return true;
        formData.append($fd07b9cb0132c1f6$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($fd07b9cb0132c1f6$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $fd07b9cb0132c1f6$var$isVisitable
    });
    function build(value, path) {
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $fd07b9cb0132c1f6$export$2e2bcd8739ae039 = $fd07b9cb0132c1f6$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $344cf8e4292137b6$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $344cf8e4292137b6$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $fd07b9cb0132c1f6$export$2e2bcd8739ae039)(params, this, options);
}
const $344cf8e4292137b6$var$prototype = $344cf8e4292137b6$var$AxiosURLSearchParams.prototype;
$344cf8e4292137b6$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$344cf8e4292137b6$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $344cf8e4292137b6$var$encode);
    } : $344cf8e4292137b6$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $344cf8e4292137b6$export$2e2bcd8739ae039 = $344cf8e4292137b6$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $db2f05ec923f2ee7$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $db2f05ec923f2ee7$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $db2f05ec923f2ee7$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $344cf8e4292137b6$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $01c17f80085c95b1$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $01c17f80085c95b1$export$2e2bcd8739ae039 = $01c17f80085c95b1$var$InterceptorManager;





"use strict";
var $3075bac9f30e7782$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $a85e5bed82430d61$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $344cf8e4292137b6$export$2e2bcd8739ae039);


"use strict";
var $46b12d255f217052$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $2e4211376cea43e6$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $fb24c6d0b2a74508$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $a85e5bed82430d61$export$2e2bcd8739ae039,
        FormData: $46b12d255f217052$export$2e2bcd8739ae039,
        Blob: $2e4211376cea43e6$export$2e2bcd8739ae039
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $232de52881daaba8$exports = {};

$parcel$export($232de52881daaba8$exports, "hasBrowserEnv", () => $232de52881daaba8$export$c4996c4b7b93b0bf);
$parcel$export($232de52881daaba8$exports, "hasStandardBrowserEnv", () => $232de52881daaba8$export$c0bcc9250309d66);
$parcel$export($232de52881daaba8$exports, "hasStandardBrowserWebWorkerEnv", () => $232de52881daaba8$export$c81692cf5af97dac);
const $232de52881daaba8$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $232de52881daaba8$export$c0bcc9250309d66 = ((product)=>{
    return $232de52881daaba8$export$c4996c4b7b93b0bf && [
        "ReactNative",
        "NativeScript",
        "NS"
    ].indexOf(product) < 0;
})(typeof navigator !== "undefined" && navigator.product);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $232de52881daaba8$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();


var $852831b4a152a7ad$export$2e2bcd8739ae039 = {
    ...$232de52881daaba8$exports,
    ...(0, $fb24c6d0b2a74508$export$2e2bcd8739ae039)
};


"use strict";
function $aa000567d8bb5ae2$export$2e2bcd8739ae039(data, options) {
    return (0, $fd07b9cb0132c1f6$export$2e2bcd8739ae039)(data, new (0, $852831b4a152a7ad$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $852831b4a152a7ad$export$2e2bcd8739ae039).isNode && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $cb8fe7f388dc4432$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $cb8fe7f388dc4432$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $cb8fe7f388dc4432$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $cb8fe7f388dc4432$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFormData(formData) && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($cb8fe7f388dc4432$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $cb8fe7f388dc4432$export$2e2bcd8739ae039 = $cb8fe7f388dc4432$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $e30871f78dcd7f19$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $e30871f78dcd7f19$var$defaults = {
    transitional: (0, $3075bac9f30e7782$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $cb8fe7f388dc4432$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBuffer(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isStream(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFile(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBlob(data)) return data;
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $aa000567d8bb5ae2$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $fd07b9cb0132c1f6$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $e30871f78dcd7f19$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $e30871f78dcd7f19$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).from(e, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $852831b4a152a7ad$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $852831b4a152a7ad$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $e30871f78dcd7f19$var$defaults.headers[method] = {};
});
var $e30871f78dcd7f19$export$2e2bcd8739ae039 = $e30871f78dcd7f19$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $36eacf0f5ae88424$var$ignoreDuplicateOf = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $36eacf0f5ae88424$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $36eacf0f5ae88424$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $54e5234108b8e954$var$$internals = Symbol("internals");
function $54e5234108b8e954$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $54e5234108b8e954$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(value) ? value.map($54e5234108b8e954$var$normalizeValue) : String(value);
}
function $54e5234108b8e954$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $54e5234108b8e954$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $54e5234108b8e954$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $54e5234108b8e954$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $54e5234108b8e954$var$buildAccessors(obj, header) {
    const accessorName = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $54e5234108b8e954$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $54e5234108b8e954$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $54e5234108b8e954$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$54e5234108b8e954$var$isValidHeaderName(header)) setHeaders((0, $36eacf0f5ae88424$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $54e5234108b8e954$var$normalizeHeader(header);
        if (header) {
            const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $54e5234108b8e954$var$parseTokens(value);
                if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $54e5234108b8e954$var$normalizeHeader(header);
        if (header) {
            const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $54e5234108b8e954$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $54e5234108b8e954$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $54e5234108b8e954$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $54e5234108b8e954$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $54e5234108b8e954$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $54e5234108b8e954$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $54e5234108b8e954$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$54e5234108b8e954$var$$internals] = this[$54e5234108b8e954$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $54e5234108b8e954$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $54e5234108b8e954$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$54e5234108b8e954$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).reduceDescriptors($54e5234108b8e954$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).freezeMethods($54e5234108b8e954$var$AxiosHeaders);
var $54e5234108b8e954$export$2e2bcd8739ae039 = $54e5234108b8e954$var$AxiosHeaders;


"use strict";
function $ec027d10dfede142$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $e30871f78dcd7f19$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $fbc9c01c5c3dc518$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $63b8b72909769bf2$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).inherits($63b8b72909769bf2$var$CanceledError, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $63b8b72909769bf2$export$2e2bcd8739ae039 = $63b8b72909769bf2$var$CanceledError;







"use strict";
function $c0e22576f74b8071$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}




var $4d3cf801f7fd4dc6$export$2e2bcd8739ae039 = (0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(path) && cookie.push("path=" + path);
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};



"use strict";
function $05bf269bfca011f3$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $7c49e720f6231ba2$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $8ed3292b1f9dccb5$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $05bf269bfca011f3$export$2e2bcd8739ae039)(requestedURL)) return (0, $7c49e720f6231ba2$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
var $3a08e3bf7b3045fa$export$2e2bcd8739ae039 = (0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover its components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();





"use strict";
function $9cab09d0d089fc0e$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $48a8aeed25ee768a$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $48a8aeed25ee768a$export$2e2bcd8739ae039 = $48a8aeed25ee768a$var$speedometer;


"use strict";
function $61abd1574bd1dd32$var$progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, $48a8aeed25ee768a$export$2e2bcd8739ae039)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const $61abd1574bd1dd32$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $61abd1574bd1dd32$export$2e2bcd8739ae039 = $61abd1574bd1dd32$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(config.headers).normalize();
        let { responseType: responseType, withXSRFToken: withXSRFToken } = config;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        let contentType;
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFormData(requestData)) {
            if ((0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else if ((contentType = requestHeaders.getContentType()) !== false) {
                // fix semicolon duplication issue for ReactNative FormData implementation
                const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
                requestHeaders.setContentType([
                    type || "multipart/form-data",
                    ...tokens
                ].join("; "));
            }
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, $8ed3292b1f9dccb5$export$2e2bcd8739ae039)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, $db2f05ec923f2ee7$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $c0e22576f74b8071$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)("Request aborted", (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)("Network Error", (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, $3075bac9f30e7782$export$2e2bcd8739ae039);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ETIMEDOUT : (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, $852831b4a152a7ad$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
            withXSRFToken && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(config));
            if (withXSRFToken || withXSRFToken !== false && (0, $3a08e3bf7b3045fa$export$2e2bcd8739ae039)(fullPath)) {
                // Add xsrf header
                const xsrfValue = config.xsrfHeaderName && config.xsrfCookieName && (0, $4d3cf801f7fd4dc6$export$2e2bcd8739ae039).read(config.xsrfCookieName);
                if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
            }
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", $61abd1574bd1dd32$var$progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", $61abd1574bd1dd32$var$progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $63b8b72909769bf2$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $9cab09d0d089fc0e$export$2e2bcd8739ae039)(fullPath);
        if (protocol && (0, $852831b4a152a7ad$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};



const $d570c100e0cb7a05$var$knownAdapters = {
    http: (0, $86ebf0c810395e29$export$2e2bcd8739ae039),
    xhr: (0, $61abd1574bd1dd32$export$2e2bcd8739ae039)
};
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach($d570c100e0cb7a05$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $d570c100e0cb7a05$var$renderReason = (reason)=>`- ${reason}`;
const $d570c100e0cb7a05$var$isResolvedHandle = (adapter)=>(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $d570c100e0cb7a05$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$d570c100e0cb7a05$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $d570c100e0cb7a05$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($d570c100e0cb7a05$var$renderReason).join("\n") : " " + $d570c100e0cb7a05$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $d570c100e0cb7a05$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $96666136aaccd2e5$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $63b8b72909769bf2$export$2e2bcd8739ae039)(null, config);
}
function $96666136aaccd2e5$export$2e2bcd8739ae039(config) {
    $96666136aaccd2e5$var$throwIfCancellationRequested(config);
    config.headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $ec027d10dfede142$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $d570c100e0cb7a05$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $e30871f78dcd7f19$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $96666136aaccd2e5$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $ec027d10dfede142$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $fbc9c01c5c3dc518$export$2e2bcd8739ae039)(reason)) {
            $96666136aaccd2e5$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $ec027d10dfede142$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




"use strict";
const $20ede3a7e8b675d4$var$headersToObject = (thing)=>thing instanceof (0, $54e5234108b8e954$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $20ede3a7e8b675d4$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(target) && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($20ede3a7e8b675d4$var$headersToObject(a), $20ede3a7e8b675d4$var$headersToObject(b), true)
    };
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}



const $4c74d331112ba968$export$a4ad2735b021c132 = "1.6.8";



"use strict";
const $63efb8494987aa98$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $63efb8494987aa98$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $63efb8494987aa98$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $63efb8494987aa98$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $4c74d331112ba968$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$63efb8494987aa98$var$deprecatedWarnings[opt]) {
            $63efb8494987aa98$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $63efb8494987aa98$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)("options must be an object", (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $63efb8494987aa98$export$2e2bcd8739ae039 = {
    assertOptions: $63efb8494987aa98$var$assertOptions,
    validators: $63efb8494987aa98$var$validators
};



"use strict";
const $cd0b8e3cbef64068$var$validators = (0, $63efb8494987aa98$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $cd0b8e3cbef64068$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $01c17f80085c95b1$export$2e2bcd8739ae039)(),
            response: new (0, $01c17f80085c95b1$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy;
                Error.captureStackTrace ? Error.captureStackTrace(dummy = {}) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                if (!err.stack) err.stack = stack;
                else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $63efb8494987aa98$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
            forcedJSONParsing: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
            clarifyTimeoutError: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $63efb8494987aa98$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $cd0b8e3cbef64068$var$validators.function,
                serialize: $cd0b8e3cbef64068$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $96666136aaccd2e5$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $96666136aaccd2e5$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $8ed3292b1f9dccb5$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $db2f05ec923f2ee7$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $cd0b8e3cbef64068$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $cd0b8e3cbef64068$var$Axios.prototype[method] = generateHTTPMethod();
    $cd0b8e3cbef64068$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $cd0b8e3cbef64068$export$2e2bcd8739ae039 = $cd0b8e3cbef64068$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $3218dd97b5460664$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $63b8b72909769bf2$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $3218dd97b5460664$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $3218dd97b5460664$export$2e2bcd8739ae039 = $3218dd97b5460664$var$CancelToken;






"use strict";
function $7874d702b64e6994$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $16f479813f4fb9c8$export$2e2bcd8739ae039(payload) {
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $edd7ef3f6e3b67e5$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($edd7ef3f6e3b67e5$var$HttpStatusCode).forEach(([key, value])=>{
    $edd7ef3f6e3b67e5$var$HttpStatusCode[value] = key;
});
var $edd7ef3f6e3b67e5$export$2e2bcd8739ae039 = $edd7ef3f6e3b67e5$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $5d7526a7a1e5b3fb$var$createInstance(defaultConfig) {
    const context = new (0, $cd0b8e3cbef64068$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $93b0f01b05e2607a$export$2e2bcd8739ae039)((0, $cd0b8e3cbef64068$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).extend(instance, (0, $cd0b8e3cbef64068$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $5d7526a7a1e5b3fb$var$createInstance((0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $5d7526a7a1e5b3fb$var$axios = $5d7526a7a1e5b3fb$var$createInstance((0, $e30871f78dcd7f19$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$5d7526a7a1e5b3fb$var$axios.Axios = (0, $cd0b8e3cbef64068$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$5d7526a7a1e5b3fb$var$axios.CanceledError = (0, $63b8b72909769bf2$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.CancelToken = (0, $3218dd97b5460664$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.isCancel = (0, $fbc9c01c5c3dc518$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.VERSION = (0, $4c74d331112ba968$export$a4ad2735b021c132);
$5d7526a7a1e5b3fb$var$axios.toFormData = (0, $fd07b9cb0132c1f6$export$2e2bcd8739ae039);
// Expose AxiosError class
$5d7526a7a1e5b3fb$var$axios.AxiosError = (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$5d7526a7a1e5b3fb$var$axios.Cancel = $5d7526a7a1e5b3fb$var$axios.CanceledError;
// Expose all/spread
$5d7526a7a1e5b3fb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$5d7526a7a1e5b3fb$var$axios.spread = (0, $7874d702b64e6994$export$2e2bcd8739ae039);
// Expose isAxiosError
$5d7526a7a1e5b3fb$var$axios.isAxiosError = (0, $16f479813f4fb9c8$export$2e2bcd8739ae039);
// Expose mergeConfig
$5d7526a7a1e5b3fb$var$axios.mergeConfig = (0, $20ede3a7e8b675d4$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.AxiosHeaders = (0, $54e5234108b8e954$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.formToJSON = (thing)=>(0, $cb8fe7f388dc4432$export$2e2bcd8739ae039)((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$5d7526a7a1e5b3fb$var$axios.getAdapter = (0, $d570c100e0cb7a05$export$2e2bcd8739ae039).getAdapter;
$5d7526a7a1e5b3fb$var$axios.HttpStatusCode = (0, $edd7ef3f6e3b67e5$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.default = $5d7526a7a1e5b3fb$var$axios;
var // this module should only have a default export
$5d7526a7a1e5b3fb$export$2e2bcd8739ae039 = $5d7526a7a1e5b3fb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $125d1ceb57662f9a$export$1c00760e9e5a4e95, AxiosError: $125d1ceb57662f9a$export$c1fbed17c2f6a328, CanceledError: $125d1ceb57662f9a$export$1ab0c6b20d94fa14, isCancel: $125d1ceb57662f9a$export$3b22524397b493c6, CancelToken: $125d1ceb57662f9a$export$fd08e3cb425f0d61, VERSION: $125d1ceb57662f9a$export$a4ad2735b021c132, all: $125d1ceb57662f9a$export$84bf76cd7afc7469, Cancel: $125d1ceb57662f9a$export$848c9b7ead0df967, isAxiosError: $125d1ceb57662f9a$export$fbafdbe06a5b5a9a, spread: $125d1ceb57662f9a$export$3ae0fd4797ed47c8, toFormData: $125d1ceb57662f9a$export$10ae0d317ea97f8b, AxiosHeaders: $125d1ceb57662f9a$export$4e7d6ff0f3e6520, HttpStatusCode: $125d1ceb57662f9a$export$a972f69c851492b3, formToJSON: $125d1ceb57662f9a$export$86d7c59254d6a2c9, getAdapter: $125d1ceb57662f9a$export$17ddc20a97d669e2, mergeConfig: $125d1ceb57662f9a$export$7ec1ebcfa9d8bd6a } = (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039);


const $643d9102d67b3722$export$f9865a0a7f208c15 = "prod" ?? "local";
const $643d9102d67b3722$export$1345fde192f5a83e = $643d9102d67b3722$export$f9865a0a7f208c15 === "prod";
const $643d9102d67b3722$var$API_BASE_URLS = {
    local: "http://0.0.0.0:3000",
    // local: 'https://api.radom.com',
    dev: "https://api.dev.radom.com",
    test: "https://api.test.radom.com",
    prod: "https://api.radom.com"
};
const $643d9102d67b3722$export$c3ee1e672e1e24e7 = $643d9102d67b3722$var$API_BASE_URLS[$643d9102d67b3722$export$f9865a0a7f208c15];
var $643d9102d67b3722$export$8fe7e62e076ddbb5;
(function(RADOM_COLORS) {
    RADOM_COLORS["BLACK"] = "#282828";
    RADOM_COLORS["BLUE"] = "#070728";
    RADOM_COLORS["BLUE_ALT"] = "#0E259C";
    RADOM_COLORS["BLUE_MED"] = "#0F1D4B";
    RADOM_COLORS["PURPLE"] = "#9F76EA";
    RADOM_COLORS["ORANGE"] = "#FF6648";
    RADOM_COLORS["ORANGE_MED"] = "#FF8972";
    RADOM_COLORS["ORANGE_LIGHT"] = "#FFDBD4";
    RADOM_COLORS["ORANGE_LIGHTEST"] = "#FFF2EF";
    RADOM_COLORS["SUCCESS"] = "#36AF67";
    RADOM_COLORS["SUCCESS_LIGHT"] = "#d8f3e3";
    RADOM_COLORS["WARNING"] = "#F79009";
    RADOM_COLORS["WARNING_LIGHT"] = "#FEF0C7";
    RADOM_COLORS["INFO"] = "#5490EC";
    RADOM_COLORS["INFO_LIGHT"] = "#d1e1fa";
    RADOM_COLORS["ERROR"] = "#FF5252";
    RADOM_COLORS["ERROR_LIGHT"] = "#ffcccc";
    RADOM_COLORS["GRAY_DARKEST"] = "#636576";
    RADOM_COLORS["GRAY_DARKER"] = "#9B9EB1";
    RADOM_COLORS["GRAY_DARK"] = "#E2E4EF";
    RADOM_COLORS["GRAY_MED"] = "#EFF0F8";
    RADOM_COLORS["GRAY_LIGHTEST"] = "#F8F8FB";
    RADOM_COLORS["INPUT_PLACEHOLDER"] = "#9ba3af";
    RADOM_COLORS["NICE_GREEN"] = "#4bb69c";
    RADOM_COLORS["NEW_BLUE"] = "#3464E6";
    RADOM_COLORS["DARK_BLUE"] = "#07053f";
})($643d9102d67b3722$export$8fe7e62e076ddbb5 || ($643d9102d67b3722$export$8fe7e62e076ddbb5 = {}));
var $643d9102d67b3722$export$a794f8af63328e6b;
(function(WINDOW_SIZE) {
    WINDOW_SIZE["MOBILE_SMALL"] = "320px";
    WINDOW_SIZE["MOBILE_MEDIUM"] = "375px";
    WINDOW_SIZE["MOBILE_LARGE"] = "425px";
    WINDOW_SIZE["TABLET"] = "768px";
    WINDOW_SIZE["LAPTOP"] = "1024px";
    WINDOW_SIZE["LAPTOP_LARGE"] = "1440px";
    WINDOW_SIZE["DESKTOP"] = "2560px";
})($643d9102d67b3722$export$a794f8af63328e6b || ($643d9102d67b3722$export$a794f8af63328e6b = {}));
const $643d9102d67b3722$export$aa70fbbb12382d3 = (seconds)=>{
    const intervals = {
        1: "Second",
        60: "Minute",
        [3600]: "Hour",
        [86400]: "Day",
        [604800]: "Week",
        [2592000]: "Month",
        [7776000]: "Quarter",
        [15552000]: "Six Months",
        [31536000]: "Year"
    };
    if (intervals[seconds]) return intervals[seconds];
    if (seconds > 31536000) {
        const years = (seconds / 31536000).toFixed(1);
        return `${years} Years`;
    }
    if (seconds > 2592000) {
        const months = (seconds / 2592000).toFixed(1);
        return `${months} Months`;
    }
    if (seconds > 86400) {
        const days = (seconds / 86400).toFixed(1);
        return `${days} Days`;
    }
    if (seconds > 3600) {
        const hours = (seconds / 3600).toFixed(1);
        return `${hours} Hours`;
    }
    if (seconds > 60) {
        const minutes = (seconds / 60).toFixed(1);
        return `${minutes} Minutes`;
    }
    return `${seconds} Seconds`;
};
const $643d9102d67b3722$export$d82eb24974fa9fd = (numSeconds)=>{
    if ($643d9102d67b3722$export$aa70fbbb12382d3(numSeconds)) return $643d9102d67b3722$export$aa70fbbb12382d3(numSeconds);
    return `${numSeconds} seconds`;
};
const $643d9102d67b3722$var$RADOM_CONTRACT_ADDRESSES = {
    31337: "0x749a0F73869eb0b0389F37B2Cee2b8DE5B358baB",
    5: "0x9D4B6432c290D4c393Bbe8fa30b72e240c008F17",
    80001: "0x987296974b23c050d6Eb2BE0CB2A60a1e9CeBa4e",
    4002: "0x819b60B377f99f1c1e8d40B53538b5Dbe1B4a37B",
    11155111: "0x8BBAaaE8225455ce62FCA83FF761fF4895bdD27B",
    1313161555: "0xc17C78B13f9594D974AF55921751B0919E4f377D",
    43113: "0xCc8401Fbca27934D4bFC762FEbb667ACdb976F88",
    534353: "0x3a909d378A6504287C03E0B19FdfB12f84c229e7",
    137: "0x63d76ee7B8b31F8D8CD1D96953C21Adb6fc5E028",
    56: "0x63d76ee7B8b31F8D8CD1D96953C21Adb6fc5E028",
    1: "0x63d76ee7B8b31F8D8CD1D96953C21Adb6fc5E028",
    1313161554: "0x63d76ee7B8b31F8D8CD1D96953C21Adb6fc5E028",
    250: "0x63d76ee7B8b31F8D8CD1D96953C21Adb6fc5E028",
    43114: "0x63d76ee7B8b31F8D8CD1D96953C21Adb6fc5E028",
    66: "0x63d76ee7B8b31F8D8CD1D96953C21Adb6fc5E028"
};
const $643d9102d67b3722$export$ce84370551d92e53 = (chainId)=>{
    if ($643d9102d67b3722$var$RADOM_CONTRACT_ADDRESSES[chainId]) return $643d9102d67b3722$var$RADOM_CONTRACT_ADDRESSES[chainId];
    return $643d9102d67b3722$var$RADOM_CONTRACT_ADDRESSES[31337];
};
const $643d9102d67b3722$export$cb8c5ae35c7906d6 = {
    RadomDevNet: "http://localhost:9545",
    GoerliTestnet: "https://goerli.etherscan.io",
    PolygonTestnet: "https://mumbai.polygonscan.com",
    FantomTestnet: "https://testnet.ftmscan.com",
    SepoliaTestnet: "https://sepolia.etherscan.io",
    BitcoinTestnet: "https://mempool.space/testnet",
    Bitcoin: "https://mempool.space",
    AuroraTestnet: "https://explorer.testnet.aurora.dev",
    Aurora: "https://explorer.aurora.dev",
    Arbitrum: "https://arbiscan.io",
    Ethereum: "https://etherscan.io",
    Fantom: "https://ftmscan.com",
    AvalancheTestnet: "https://testnet.snowtrace.io",
    Avalanche: "https://snowtrace.io",
    ScrollTestnet: "https://blockscout.scroll.io",
    Polygon: "https://polygonscan.com",
    BNB: "https://bscscan.com",
    BNBTestnet: "https://testnet.bscscan.com",
    PolkadotTestnet: "https://westend.subscan.io",
    Polkadot: "https://polkadot.subscan.io",
    TronTestnet: "https://nile.tronscan.org/#",
    Tron: "https://tronscan.org/#"
};
const $643d9102d67b3722$export$4d78c43b7fa734a7 = [
    "United Kingdom",
    "United States",
    "Canada",
    "Australia",
    "New Zealand",
    "South Africa",
    "Anguilla",
    "Bermuda",
    "British Virgin Islands",
    "Cayman Islands",
    "Falkland Islands",
    "Gibraltar",
    "Montserrat",
    "Pitcairn Islands",
    "Saint Helena",
    "South Georgia and the South Sandwich Islands",
    "Turks and Caicos Islands",
    "Albania",
    "Andorra",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belgium",
    "Belize",
    "Bhutan",
    "Bolivia",
    "Bosnia and Herzegovina",
    "Botswana",
    "Brazil",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cabo Verde",
    "Cambodia",
    "Cameroon",
    "Chile",
    "Colombia",
    "Comoros",
    "Costa Rica",
    "Croatia",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "East Timor (Timor-Leste)",
    "Ecuador",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Eswatini",
    "Faroe Islands",
    "Fiji",
    "Finland",
    "France",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Greece",
    "Greenland",
    "Grenada",
    "Guatemala",
    "Guernsey",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Honduras",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Ireland",
    "Isle of Man",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jersey",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Kosovo",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Malta",
    "Marshall Islands",
    "Mauritania",
    "Mauritius",
    "Mexico",
    "Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Morocco",
    "Mozambique",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "North Macedonia",
    "Norway",
    "Oman",
    "Palau",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Qatar",
    "Romania",
    "Rwanda",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Spain",
    "Sri Lanka",
    "Suriname",
    "Sweden",
    "Switzerland",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Togo",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Vatican City",
    "Vietnam",
    "Zambia",
    "Zimbabwe"
];


var $6cc04e58a8fffbcd$export$8d291ecd86a6c444;
(function(InputFieldDataType) {
    InputFieldDataType["String"] = "String";
    InputFieldDataType["Number"] = "Number";
    InputFieldDataType["Email"] = "Email";
    InputFieldDataType["Address"] = "Address";
})($6cc04e58a8fffbcd$export$8d291ecd86a6c444 || ($6cc04e58a8fffbcd$export$8d291ecd86a6c444 = {}));
class $6cc04e58a8fffbcd$var$Radom {
    constructor(){
        this.getPaymentLink = async (id)=>{
            return await (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).get(`${(0, $643d9102d67b3722$export$c3ee1e672e1e24e7)}/payment_link/${id}`).then((res)=>res.data);
        };
        this.getDonationLink = async (id)=>{
            return await (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).get(`${(0, $643d9102d67b3722$export$c3ee1e672e1e24e7)}/donation_link/${id}`).then((res)=>res.data);
        };
        this.getInvoice = async (id)=>{
            return await (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).get(`${(0, $643d9102d67b3722$export$c3ee1e672e1e24e7)}/invoice/${id}`).then((res)=>res.data);
        };
        this.redeemDiscountCode = async (req)=>{
            return await (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).post(`${(0, $643d9102d67b3722$export$c3ee1e672e1e24e7)}/discount_code/verify`, req).then((res)=>res.data);
        };
        this.getPriceQuotes = async (from, to)=>{
            const fromCurrencies = from.map((f, i)=>`from[${i}]=${f}`).join("&");
            const toCurrencies = to.map((f, i)=>`to[${i}]=${f}`).join("&");
            return await (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).get(`${(0, $643d9102d67b3722$export$c3ee1e672e1e24e7)}/price_quotes?${fromCurrencies}&${toCurrencies}`).then((res)=>res.data);
        };
        this.getCheckoutSession = async (id)=>{
            return await (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).get(`${(0, $643d9102d67b3722$export$c3ee1e672e1e24e7)}/checkout_session/${id}`).then((res)=>res.data);
        };
        this.getSellerProfile = async (address)=>{
            return await (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).get(`${(0, $643d9102d67b3722$export$c3ee1e672e1e24e7)}/sellers/${address}`).then((res)=>res.data);
        };
        this.createPaymentLinkOrder = async (data)=>{
            return await (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).post(`${(0, $643d9102d67b3722$export$c3ee1e672e1e24e7)}/payment_link_order/pending`, data).then((res)=>res.data).catch((err)=>{
                throw new Error(err.response.data.error);
            });
        };
        this.createDonationLinkOrder = async (data)=>{
            return await (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).post(`${(0, $643d9102d67b3722$export$c3ee1e672e1e24e7)}/donation_link_order/pending`, data).then((res)=>res.data).catch((err)=>{
                throw new Error(err.response.data.error);
            });
        };
        this.createCheckoutSessionOrder = async (data)=>{
            return await (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).post(`${(0, $643d9102d67b3722$export$c3ee1e672e1e24e7)}/checkout/pending`, data).then((res)=>res.data).catch((err)=>{
                throw new Error(err.response.data.error);
            });
        };
        this.createInvoicePayment = async (data)=>{
            return await (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).post(`${(0, $643d9102d67b3722$export$c3ee1e672e1e24e7)}/invoices/pending`, data).then((res)=>res.data);
        };
        this.getManagedPaymentStatus = async (paymentId)=>{
            return await (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).get(`${(0, $643d9102d67b3722$export$c3ee1e672e1e24e7)}/managed_payment_status/${paymentId}`).then((res)=>res.data);
        };
        this.getManagedTokenPaymentStatus = async (paymentId)=>{
            return await (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).get(`${(0, $643d9102d67b3722$export$c3ee1e672e1e24e7)}/managed_token_payment_status/${paymentId}`).then((res)=>res.data);
        };
        this.completeTokenDelegatePayment = async (paymentId, signature)=>{
            return await (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).post(`${(0, $643d9102d67b3722$export$c3ee1e672e1e24e7)}/token_delegate_payment`, {
                paymentId: paymentId,
                signature: signature
            }).then((res)=>res.data).catch((err)=>{
                throw new Error(err.response.data.error);
            });
        };
        this.getSubscription = async (id)=>{
            return await (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).get(`${(0, $643d9102d67b3722$export$c3ee1e672e1e24e7)}/subscription/${id}`).then((res)=>res.data).catch((err)=>{
                throw new Error(err.response.data.error);
            });
        };
        this.estimateTokenTranferGas = async (network, token)=>{
            return await (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).get(`${(0, $643d9102d67b3722$export$c3ee1e672e1e24e7)}/estimate_token_transfer_gas?network=${network}&token=${token}`).then((res)=>res.data).catch((err)=>{
                throw new Error(err.response.data.error);
            });
        };
        this.createSubscriptionPayment = async (subscriptionId)=>{
            return await (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).post(`${(0, $643d9102d67b3722$export$c3ee1e672e1e24e7)}/subscription/${subscriptionId}/pay`).then((res)=>res.data).catch((err)=>{
                throw new Error(err.response.data.error);
            });
        };
        this.cancelSubscription = async (id)=>{
            return await (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).post(`${(0, $643d9102d67b3722$export$c3ee1e672e1e24e7)}/subscription/${id}/cancel`).then((res)=>res.data).catch((err)=>{
                throw new Error(err.response.data.error);
            });
        };
    }
}
var $6cc04e58a8fffbcd$export$2e2bcd8739ae039 = new $6cc04e58a8fffbcd$var$Radom();




var $8NFma = parcelRequire("8NFma");


parcelRequire("8NFma");
function $47362f00518aba7f$var$RadomLogo({ logoProps: logoProps, ...props }) {
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("svg", {
        width: "120",
        height: "32",
        viewBox: "0 0 120 32",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "black",
        ...props,
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("g", {
                clipPath: "url(#clip0_526_40)",
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("path", {
                        d: "M0.499695 2.35787C0.688149 2.35787 0.863681 2.35787 1.03921 2.35787C4.26879 2.35787 7.49836 2.35571 10.7279 2.35894C12.7277 2.3611 14.7102 2.49248 16.5808 3.29583C19.6715 4.62255 21.2555 7.28461 21.2189 10.9019C21.1888 13.9117 19.1782 16.184 16.5808 17.2146C15.8367 17.5096 15.0322 17.6496 14.2666 17.8962C14.0641 17.9619 13.9047 18.1601 13.726 18.2979C13.9295 18.4056 14.1233 18.5671 14.3398 18.6113C15.1432 18.775 15.9767 18.8277 16.7596 19.056C18.2317 19.4857 19.1169 20.5637 19.6219 21.9679C20.5373 24.5126 21.4354 27.0637 22.3378 29.6116C22.3787 29.7279 22.3981 29.8518 22.439 30.0187C22.2754 30.037 22.1429 30.0628 22.0104 30.0639C20.6826 30.0672 19.3548 30.0542 18.0271 30.0736C17.662 30.079 17.4983 29.9821 17.4046 29.5998C16.9179 27.6172 16.4031 25.6422 15.883 23.6672C15.2627 21.311 13.8024 20.0349 11.2804 19.8486C9.19122 19.6946 7.08915 19.7162 4.99353 19.6462C4.56385 19.6322 4.55201 19.8723 4.55201 20.1943C4.55847 23.244 4.55631 26.2948 4.55631 29.3446C4.55631 29.8256 4.31007 30.0661 3.81757 30.0661C2.72561 30.0661 1.63365 30.0661 0.499695 30.0661V2.35787H0.499695ZM4.55631 16.1958C4.79108 16.1958 4.98276 16.1958 5.17552 16.1958C6.82639 16.1958 8.47725 16.1743 10.1281 16.2023C11.387 16.2238 12.5823 15.9675 13.7443 15.5142C16.5754 14.4093 17.8687 11.478 16.724 8.68994C15.9993 6.92385 14.5401 6.06127 12.7342 5.95466C10.2121 5.80605 7.67928 5.85558 5.15183 5.79528C4.67693 5.78451 4.54232 5.92881 4.54555 6.40372C4.56493 9.54391 4.55524 12.6841 4.55524 15.8243C4.55524 15.9266 4.55524 16.03 4.55524 16.1958H4.55631Z"
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("path", {
                        d: "M119.786 30.0476H116.058V29.4618C116.058 25.5678 116.063 21.6738 116.052 17.7798C116.051 17.2079 116.009 16.6307 115.929 16.0643C115.659 14.183 114.493 13.1104 112.585 12.951C110.393 12.7679 108.503 14.1151 107.891 16.3927C107.67 17.2122 107.557 18.0845 107.548 18.9342C107.511 22.433 107.532 25.9318 107.532 29.4316C107.532 29.6233 107.532 29.8161 107.532 30.0369H103.777C103.777 29.7999 103.777 29.591 103.777 29.3821C103.777 25.6496 103.797 21.9171 103.762 18.1847C103.753 17.2596 103.651 16.3174 103.442 15.4171C102.89 13.0286 100.663 12.6118 99.0872 13.0985C97.1456 13.6994 96.1193 15.1737 95.6239 17.027C95.3827 17.9316 95.2912 18.8976 95.2793 19.8377C95.2384 23.0317 95.2643 26.2258 95.2643 29.4198C95.2643 29.6126 95.2643 29.8053 95.2643 30.0638C94.0538 30.0638 92.893 30.0702 91.7332 30.0519C91.6449 30.0509 91.5199 29.8947 91.4822 29.7859C91.437 29.6578 91.4672 29.5027 91.4672 29.3584C91.4672 23.1136 91.4672 16.8687 91.4672 10.6249C91.4672 10.1526 91.6994 9.91672 92.1639 9.91743C93.1676 9.91743 94.1712 9.91743 95.2223 9.91743C95.331 11.004 95.2449 12.0454 95.0112 13.077C94.9563 13.3215 94.8583 13.5605 94.8324 13.8071C94.8109 14.0117 94.868 14.225 94.8906 14.4339C95.0618 14.2853 95.2836 14.1668 95.3924 13.9816C95.6832 13.4895 95.891 12.9489 96.1915 12.4632C97.5602 10.2523 100.258 9.15608 102.766 9.80651C104.532 10.2642 105.669 11.4326 106.307 13.1147C106.39 13.3322 106.416 13.5767 106.53 13.7748C106.616 13.9256 106.793 14.1087 106.94 14.1162C107.086 14.1248 107.3 13.9676 107.387 13.8244C107.674 13.3505 107.882 12.8272 108.184 12.3641C109.533 10.2943 111.419 9.34453 113.905 9.67298C115.165 9.83882 116.329 10.177 117.358 11.0019C118.694 12.0734 119.32 13.4959 119.582 15.1059C119.735 16.0384 119.792 16.9958 119.798 17.9424C119.822 21.8181 119.809 25.6938 119.808 29.5706C119.808 29.7106 119.792 29.8506 119.782 30.0476H119.786Z"
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("path", {
                        d: "M65.5957 30.0652C64.4273 30.0652 63.3159 30.076 62.2057 30.049C62.0904 30.0458 61.888 29.8304 61.8815 29.7066C61.8223 28.5199 61.8632 27.3428 62.2713 26.2024C62.3413 26.0064 62.2563 25.7544 62.2433 25.5283C62.0646 25.6844 61.7943 25.805 61.72 26.001C60.9748 27.9545 59.6233 29.3114 57.6515 29.937C54.5533 30.9192 51.7179 30.3452 49.3089 28.1322C47.2596 26.2498 46.3905 23.7837 46.1687 21.0797C45.949 18.4036 46.4562 15.8697 47.881 13.5544C49.5824 10.7911 52.5719 9.35995 55.782 9.6464C57.6881 9.81655 59.3271 10.5478 60.5731 12.0069C61.0297 12.5411 61.3162 13.2206 61.6758 13.8366C61.748 13.9593 61.7695 14.1252 61.8664 14.2178C61.9774 14.3233 62.1464 14.3685 62.2897 14.4396C62.3263 14.2964 62.4243 14.137 62.3909 14.0121C61.3194 9.99747 62.0786 5.91069 61.9009 1.86269C61.9009 1.84761 61.916 1.83254 61.9472 1.77438H65.5968V30.0652H65.5957ZM49.8592 19.9673C49.9626 20.7286 50.0078 21.5029 50.1833 22.247C50.5193 23.675 51.1687 24.9801 52.3748 25.846C54.9625 27.7025 58.4473 27.0919 60.2651 24.7034C62.1863 22.1781 62.3963 19.3664 61.0695 16.5417C59.8193 13.8796 57.2401 12.428 54.073 13.2809C53.2804 13.4941 52.5848 13.8409 51.9946 14.4364C50.4709 15.9731 49.9141 17.8576 49.8581 19.9683L49.8592 19.9673Z"
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("path", {
                        d: "M28.6953 16.1755H25.0554C25.1749 15.0663 25.526 14.0713 26.0838 13.1473C26.9486 11.7161 28.2344 10.7911 29.7862 10.2645C32.4654 9.3556 35.1738 9.33191 37.8671 10.2203C40.4904 11.0861 41.9743 12.9427 42.39 15.6435C42.5397 16.6149 42.6258 17.6045 42.6334 18.5866C42.6614 22.2653 42.6452 25.9439 42.6441 29.6236C42.6441 29.7475 42.6301 29.8713 42.6215 30.0296H38.8847C38.8471 28.691 38.7954 27.3719 39.2067 26.0828C39.2832 25.8448 39.3521 25.6004 39.378 25.3538C39.3898 25.2407 39.2864 25.1147 39.2358 24.9952C39.113 25.0695 38.9364 25.1147 38.8761 25.2235C38.5908 25.7393 38.3851 26.3057 38.0642 26.7957C36.2453 29.5709 33.5929 30.609 30.3838 30.3085C28.2311 30.1071 26.3972 29.1993 25.2223 27.3126C23.1536 23.9883 24.825 19.8315 28.6468 18.6599C30.456 18.1053 32.3276 18.1193 34.1863 18.0008C35.1695 17.9384 36.1548 17.8641 37.1327 17.7434C39.253 17.4818 39.1378 15.9634 38.4152 14.6269C37.9392 13.7461 37.0616 13.3648 36.1301 13.1613C34.5148 12.8081 32.8897 12.779 31.283 13.2087C29.9315 13.5705 29.1077 14.4643 28.8062 15.8341C28.7836 15.9386 28.7405 16.0387 28.6953 16.1744V16.1755ZM38.8104 19.2694C38.1665 19.9715 37.4094 20.286 36.5888 20.4357C35.3913 20.6532 34.1809 20.7986 32.9867 21.029C31.8861 21.2422 30.7414 21.3898 29.7183 21.813C27.9285 22.5517 27.6238 24.9909 29.0786 26.2164C29.7732 26.8022 30.61 26.9573 31.4876 26.9756C36.2033 27.0789 38.9967 23.5252 38.8115 19.2694H38.8104Z"
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("path", {
                        d: "M88.2782 19.9631C88.3051 22.5035 87.688 24.8565 86.0953 26.8864C84.5597 28.8442 82.5201 29.9512 80.0723 30.2722C78.0456 30.5371 76.0674 30.3271 74.2011 29.4225C71.8848 28.2993 70.3427 26.4708 69.5102 24.0704C68.512 21.1908 68.527 18.2875 69.6922 15.4542C71.2516 11.6625 74.563 9.53676 78.6831 9.6046C81.8287 9.65629 84.438 10.8172 86.3268 13.392C87.5114 15.0073 88.0962 16.8542 88.2728 18.8357C88.3062 19.2083 88.2771 19.5873 88.2771 19.9631H88.2782ZM84.5446 19.7025C84.5554 18.6493 84.3174 17.3905 83.7057 16.221C82.6741 14.2481 81.0706 13.1379 78.8167 13.0646C76.5401 12.9903 74.7288 13.8766 73.6401 15.8979C72.1206 18.7172 72.1475 21.5925 73.8005 24.3482C75.8186 27.7135 80.4589 27.4798 82.4694 25.4413C83.9706 23.9196 84.5554 22.0534 84.5446 19.7025Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("clipPath", {
                    id: "clip0_526_40",
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("rect", {
                        width: "119.315",
                        height: "28.6268",
                        transform: "translate(0.498489 1.77344)"
                    })
                })
            })
        ]
    });
}
var $47362f00518aba7f$export$2e2bcd8739ae039 = $47362f00518aba7f$var$RadomLogo;


/**
 * @module color-parse
 */ var $3cbe7ab7f006e2aa$exports = {};
"use strict";
$3cbe7ab7f006e2aa$exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};


var $821677d153f2f467$export$2e2bcd8739ae039 = $821677d153f2f467$var$parse;
/**
 * Base hues
 * http://dev.w3.org/csswg/css-color/#typedef-named-hue
 */ //FIXME: use external hue detector
var $821677d153f2f467$var$baseHues = {
    red: 0,
    orange: 60,
    yellow: 120,
    green: 180,
    blue: 240,
    purple: 300
};
/**
 * Parse color from the string passed
 *
 * @return {Object} A space indicator `space`, an array `values` and `alpha`
 */ function $821677d153f2f467$var$parse(cstr) {
    var m, parts = [], alpha = 1, space;
    if (typeof cstr === "string") {
        cstr = cstr.toLowerCase();
        //keyword
        if ((0, (/*@__PURE__*/$parcel$interopDefault($3cbe7ab7f006e2aa$exports)))[cstr]) {
            parts = (0, (/*@__PURE__*/$parcel$interopDefault($3cbe7ab7f006e2aa$exports)))[cstr].slice();
            space = "rgb";
        } else if (cstr === "transparent") {
            alpha = 0;
            space = "rgb";
            parts = [
                0,
                0,
                0
            ];
        } else if (/^#[A-Fa-f0-9]+$/.test(cstr)) {
            var base = cstr.slice(1);
            var size = base.length;
            var isShort = size <= 4;
            alpha = 1;
            if (isShort) {
                parts = [
                    parseInt(base[0] + base[0], 16),
                    parseInt(base[1] + base[1], 16),
                    parseInt(base[2] + base[2], 16)
                ];
                if (size === 4) alpha = parseInt(base[3] + base[3], 16) / 255;
            } else {
                parts = [
                    parseInt(base[0] + base[1], 16),
                    parseInt(base[2] + base[3], 16),
                    parseInt(base[4] + base[5], 16)
                ];
                if (size === 8) alpha = parseInt(base[6] + base[7], 16) / 255;
            }
            if (!parts[0]) parts[0] = 0;
            if (!parts[1]) parts[1] = 0;
            if (!parts[2]) parts[2] = 0;
            space = "rgb";
        } else if (m = /^((?:rgb|hs[lvb]|hwb|cmyk?|xy[zy]|gray|lab|lchu?v?|[ly]uv|lms)a?)\s*\(([^\)]*)\)/.exec(cstr)) {
            var name = m[1];
            var isRGB = name === "rgb";
            var base = name.replace(/a$/, "");
            space = base;
            var size = base === "cmyk" ? 4 : base === "gray" ? 1 : 3;
            parts = m[2].trim().split(/\s*[,\/]\s*|\s+/).map(function(x, i) {
                //<percentage>
                if (/%$/.test(x)) {
                    //alpha
                    if (i === size) return parseFloat(x) / 100;
                    //rgb
                    if (base === "rgb") return parseFloat(x) * 255 / 100;
                    return parseFloat(x);
                } else if (base[i] === "h") {
                    //<deg>
                    if (/deg$/.test(x)) return parseFloat(x);
                    else if ($821677d153f2f467$var$baseHues[x] !== undefined) return $821677d153f2f467$var$baseHues[x];
                }
                return parseFloat(x);
            });
            if (name === base) parts.push(1);
            alpha = isRGB ? 1 : parts[size] === undefined ? 1 : parts[size];
            parts = parts.slice(0, size);
        } else if (cstr.length > 10 && /[0-9](?:\s|\/)/.test(cstr)) {
            parts = cstr.match(/([0-9]+)/g).map(function(value) {
                return parseFloat(value);
            });
            space = cstr.match(/([a-z])/ig).join("").toLowerCase();
        }
    } else if (!isNaN(cstr)) {
        space = "rgb";
        parts = [
            cstr >>> 16,
            (cstr & 0x00ff00) >>> 8,
            cstr & 0x0000ff
        ];
    } else if (Array.isArray(cstr) || cstr.length) {
        parts = [
            cstr[0],
            cstr[1],
            cstr[2]
        ];
        space = "rgb";
        alpha = cstr.length === 4 ? cstr[3] : 1;
    } else if (cstr instanceof Object) {
        if (cstr.r != null || cstr.red != null || cstr.R != null) {
            space = "rgb";
            parts = [
                cstr.r || cstr.red || cstr.R || 0,
                cstr.g || cstr.green || cstr.G || 0,
                cstr.b || cstr.blue || cstr.B || 0
            ];
        } else {
            space = "hsl";
            parts = [
                cstr.h || cstr.hue || cstr.H || 0,
                cstr.s || cstr.saturation || cstr.S || 0,
                cstr.l || cstr.lightness || cstr.L || cstr.b || cstr.brightness
            ];
        }
        alpha = cstr.a || cstr.alpha || cstr.opacity || 1;
        if (cstr.opacity != null) alpha /= 100;
    }
    return {
        space: space,
        values: parts,
        alpha: alpha
    };
}


var $1491975c97e0baa4$exports = {};

$parcel$export($1491975c97e0baa4$exports, "parse", () => $1491975c97e0baa4$export$98e6a39c04603d36, (v) => $1491975c97e0baa4$export$98e6a39c04603d36 = v);
$parcel$export($1491975c97e0baa4$exports, "stringify", () => $1491975c97e0baa4$export$fac44ee5b035f737, (v) => $1491975c97e0baa4$export$fac44ee5b035f737 = v);
// Copyright (c) 2014 Rafael Caricio. All rights reserved.
// Use of this source code is governed by a BSD-style license that can be
// found in the LICENSE file.
var $1491975c97e0baa4$export$98e6a39c04603d36;
var $1491975c97e0baa4$export$fac44ee5b035f737;
var $1491975c97e0baa4$var$GradientParser = $1491975c97e0baa4$var$GradientParser || {};
$1491975c97e0baa4$var$GradientParser.stringify = function() {
    var visitor = {
        "visit_linear-gradient": function(node) {
            return visitor.visit_gradient(node);
        },
        "visit_repeating-linear-gradient": function(node) {
            return visitor.visit_gradient(node);
        },
        "visit_radial-gradient": function(node) {
            return visitor.visit_gradient(node);
        },
        "visit_repeating-radial-gradient": function(node) {
            return visitor.visit_gradient(node);
        },
        "visit_gradient": function(node) {
            var orientation = visitor.visit(node.orientation);
            if (orientation) orientation += ", ";
            return node.type + "(" + orientation + visitor.visit(node.colorStops) + ")";
        },
        "visit_shape": function(node) {
            var result = node.value, at = visitor.visit(node.at), style = visitor.visit(node.style);
            if (style) result += " " + style;
            if (at) result += " at " + at;
            return result;
        },
        "visit_default-radial": function(node) {
            var result = "", at = visitor.visit(node.at);
            if (at) result += at;
            return result;
        },
        "visit_extent-keyword": function(node) {
            var result = node.value, at = visitor.visit(node.at);
            if (at) result += " at " + at;
            return result;
        },
        "visit_position-keyword": function(node) {
            return node.value;
        },
        "visit_position": function(node) {
            return visitor.visit(node.value.x) + " " + visitor.visit(node.value.y);
        },
        "visit_%": function(node) {
            return node.value + "%";
        },
        "visit_em": function(node) {
            return node.value + "em";
        },
        "visit_px": function(node) {
            return node.value + "px";
        },
        "visit_literal": function(node) {
            return visitor.visit_color(node.value, node);
        },
        "visit_hex": function(node) {
            return visitor.visit_color("#" + node.value, node);
        },
        "visit_rgb": function(node) {
            return visitor.visit_color("rgb(" + node.value.join(", ") + ")", node);
        },
        "visit_rgba": function(node) {
            return visitor.visit_color("rgba(" + node.value.join(", ") + ")", node);
        },
        "visit_color": function(resultColor, node) {
            var result = resultColor, length = visitor.visit(node.length);
            if (length) result += " " + length;
            return result;
        },
        "visit_angular": function(node) {
            return node.value + "deg";
        },
        "visit_directional": function(node) {
            return "to " + node.value;
        },
        "visit_array": function(elements) {
            var result = "", size = elements.length;
            elements.forEach(function(element, i) {
                result += visitor.visit(element);
                if (i < size - 1) result += ", ";
            });
            return result;
        },
        "visit": function(element) {
            if (!element) return "";
            var result = "";
            if (element instanceof Array) return visitor.visit_array(element, result);
            else if (element.type) {
                var nodeVisitor = visitor["visit_" + element.type];
                if (nodeVisitor) return nodeVisitor(element);
                else throw Error("Missing visitor visit_" + element.type);
            } else throw Error("Invalid node.");
        }
    };
    return function(root) {
        return visitor.visit(root);
    };
}();
// Copyright (c) 2014 Rafael Caricio. All rights reserved.
// Use of this source code is governed by a BSD-style license that can be
// found in the LICENSE file.
var $1491975c97e0baa4$var$GradientParser = $1491975c97e0baa4$var$GradientParser || {};
$1491975c97e0baa4$var$GradientParser.parse = function() {
    var tokens = {
        linearGradient: /^(\-(webkit|o|ms|moz)\-)?(linear\-gradient)/i,
        repeatingLinearGradient: /^(\-(webkit|o|ms|moz)\-)?(repeating\-linear\-gradient)/i,
        radialGradient: /^(\-(webkit|o|ms|moz)\-)?(radial\-gradient)/i,
        repeatingRadialGradient: /^(\-(webkit|o|ms|moz)\-)?(repeating\-radial\-gradient)/i,
        sideOrCorner: /^to (left (top|bottom)|right (top|bottom)|left|right|top|bottom)/i,
        extentKeywords: /^(closest\-side|closest\-corner|farthest\-side|farthest\-corner|contain|cover)/,
        positionKeywords: /^(left|center|right|top|bottom)/i,
        pixelValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))px/,
        percentageValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))\%/,
        emValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))em/,
        angleValue: /^(-?(([0-9]*\.[0-9]+)|([0-9]+\.?)))deg/,
        startCall: /^\(/,
        endCall: /^\)/,
        comma: /^,/,
        hexColor: /^\#([0-9a-fA-F]+)/,
        literalColor: /^([a-zA-Z]+)/,
        rgbColor: /^rgb/i,
        rgbaColor: /^rgba/i,
        number: /^(([0-9]*\.[0-9]+)|([0-9]+\.?))/
    };
    var input = "";
    function error(msg) {
        var err = new Error(input + ": " + msg);
        err.source = input;
        throw err;
    }
    function getAST() {
        var ast = matchListDefinitions();
        if (input.length > 0) error("Invalid input not EOF");
        return ast;
    }
    function matchListDefinitions() {
        return matchListing(matchDefinition);
    }
    function matchDefinition() {
        return matchGradient("linear-gradient", tokens.linearGradient, matchLinearOrientation) || matchGradient("repeating-linear-gradient", tokens.repeatingLinearGradient, matchLinearOrientation) || matchGradient("radial-gradient", tokens.radialGradient, matchListRadialOrientations) || matchGradient("repeating-radial-gradient", tokens.repeatingRadialGradient, matchListRadialOrientations);
    }
    function matchGradient(gradientType, pattern, orientationMatcher) {
        return matchCall(pattern, function(captures) {
            var orientation = orientationMatcher();
            if (orientation) {
                if (!scan(tokens.comma)) error("Missing comma before color stops");
            }
            return {
                type: gradientType,
                orientation: orientation,
                colorStops: matchListing(matchColorStop)
            };
        });
    }
    function matchCall(pattern, callback) {
        var captures = scan(pattern);
        if (captures) {
            if (!scan(tokens.startCall)) error("Missing (");
            var result = callback(captures);
            if (!scan(tokens.endCall)) error("Missing )");
            return result;
        }
    }
    function matchLinearOrientation() {
        return matchSideOrCorner() || matchAngle();
    }
    function matchSideOrCorner() {
        return match("directional", tokens.sideOrCorner, 1);
    }
    function matchAngle() {
        return match("angular", tokens.angleValue, 1);
    }
    function matchListRadialOrientations() {
        var radialOrientations, radialOrientation = matchRadialOrientation(), lookaheadCache;
        if (radialOrientation) {
            radialOrientations = [];
            radialOrientations.push(radialOrientation);
            lookaheadCache = input;
            if (scan(tokens.comma)) {
                radialOrientation = matchRadialOrientation();
                if (radialOrientation) radialOrientations.push(radialOrientation);
                else input = lookaheadCache;
            }
        }
        return radialOrientations;
    }
    function matchRadialOrientation() {
        var radialType = matchCircle() || matchEllipse();
        if (radialType) radialType.at = matchAtPosition();
        else {
            var extent = matchExtentKeyword();
            if (extent) {
                radialType = extent;
                var positionAt = matchAtPosition();
                if (positionAt) radialType.at = positionAt;
            } else {
                var defaultPosition = matchPositioning();
                if (defaultPosition) radialType = {
                    type: "default-radial",
                    at: defaultPosition
                };
            }
        }
        return radialType;
    }
    function matchCircle() {
        var circle = match("shape", /^(circle)/i, 0);
        if (circle) circle.style = matchLength() || matchExtentKeyword();
        return circle;
    }
    function matchEllipse() {
        var ellipse = match("shape", /^(ellipse)/i, 0);
        if (ellipse) ellipse.style = matchDistance() || matchExtentKeyword();
        return ellipse;
    }
    function matchExtentKeyword() {
        return match("extent-keyword", tokens.extentKeywords, 1);
    }
    function matchAtPosition() {
        if (match("position", /^at/, 0)) {
            var positioning = matchPositioning();
            if (!positioning) error("Missing positioning value");
            return positioning;
        }
    }
    function matchPositioning() {
        var location = matchCoordinates();
        if (location.x || location.y) return {
            type: "position",
            value: location
        };
    }
    function matchCoordinates() {
        return {
            x: matchDistance(),
            y: matchDistance()
        };
    }
    function matchListing(matcher) {
        var captures = matcher(), result = [];
        if (captures) {
            result.push(captures);
            while(scan(tokens.comma)){
                captures = matcher();
                if (captures) result.push(captures);
                else error("One extra comma");
            }
        }
        return result;
    }
    function matchColorStop() {
        var color = matchColor();
        if (!color) error("Expected color definition");
        color.length = matchDistance();
        return color;
    }
    function matchColor() {
        return matchHexColor() || matchRGBAColor() || matchRGBColor() || matchLiteralColor();
    }
    function matchLiteralColor() {
        return match("literal", tokens.literalColor, 0);
    }
    function matchHexColor() {
        return match("hex", tokens.hexColor, 1);
    }
    function matchRGBColor() {
        return matchCall(tokens.rgbColor, function() {
            return {
                type: "rgb",
                value: matchListing(matchNumber)
            };
        });
    }
    function matchRGBAColor() {
        return matchCall(tokens.rgbaColor, function() {
            return {
                type: "rgba",
                value: matchListing(matchNumber)
            };
        });
    }
    function matchNumber() {
        return scan(tokens.number)[1];
    }
    function matchDistance() {
        return match("%", tokens.percentageValue, 1) || matchPositionKeyword() || matchLength();
    }
    function matchPositionKeyword() {
        return match("position-keyword", tokens.positionKeywords, 1);
    }
    function matchLength() {
        return match("px", tokens.pixelValue, 1) || match("em", tokens.emValue, 1);
    }
    function match(type, pattern, captureIndex) {
        var captures = scan(pattern);
        if (captures) return {
            type: type,
            value: captures[captureIndex]
        };
    }
    function scan(regexp) {
        var captures, blankCaptures;
        blankCaptures = /^[\n\r\t\s]+/.exec(input);
        if (blankCaptures) consume(blankCaptures[0].length);
        captures = regexp.exec(input);
        if (captures) consume(captures[0].length);
        return captures;
    }
    function consume(size) {
        input = input.substr(size);
    }
    return function(code) {
        input = code.toString();
        return getAST();
    };
}();
$1491975c97e0baa4$export$98e6a39c04603d36 = $1491975c97e0baa4$var$GradientParser.parse;
$1491975c97e0baa4$export$fac44ee5b035f737 = $1491975c97e0baa4$var$GradientParser.stringify;


const $2a4a168be657655e$export$193698062786be9a = (address, decimals = 4)=>{
    if (!address) return "";
    return address.substring(0, decimals) + "..." + address.slice(address.length - decimals);
};
function $2a4a168be657655e$export$8121a4101142837f(bgColor, lightColor, darkColor) {
    let color = (0, $821677d153f2f467$export$2e2bcd8739ae039)(bgColor);
    try {
        const gradientColor = (0, (/*@__PURE__*/$parcel$interopDefault($1491975c97e0baa4$exports))).parse(bgColor);
        color = (0, $821677d153f2f467$export$2e2bcd8739ae039)(gradientColor[0].colorStops[0].value);
    } catch  {}
    const r = color.values[0];
    const g = color.values[1];
    const b = color.values[2];
    const uicolors = [
        r / 255,
        g / 255,
        b / 255
    ];
    const c = uicolors.map((col)=>{
        if (col <= 0.03928) return col / 12.92;
        return Math.pow((col + 0.055) / 1.055, 2.4);
    });
    const L = 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
    return L > 0.179 ? darkColor : lightColor;
}
function $2a4a168be657655e$export$f5dd818bff069720(val, options) {
    return Intl.NumberFormat("en-US", options).format(val);
}
function $2a4a168be657655e$export$1e21512880529eb2(address) {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(address);
}



parcelRequire("8NFma");
var $161775e6c718b902$exports = {};
"use strict";

$161775e6c718b902$exports = (parcelRequire("ioIGR"));



var $8NFma = parcelRequire("8NFma");
var $ee39632639537d25$exports = {};
//
$ee39632639537d25$exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};


function $89735de78c884c94$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = "", p = "", F = "", G = "", C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, "")), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, "").trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ""));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(""), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ""));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + "{" + k + "}";
                                        break;
                                    case 107:
                                        f = f.replace(fa, "$1 $2");
                                        k = f + "{" + k + "}";
                                        k = 1 === w || 2 === w && L("@" + k, 3) ? "@-webkit-" + k + "@" + k : "@" + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ""));
                                }
                                else k = "";
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, "") : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(" ", ":")).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = "\0\0"), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += "\0");
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = "";
                                    break;
                                default:
                                    32 !== g && (y = " ");
                            }
                            break;
                        case 0:
                            y = "\\0";
                            break;
                        case 12:
                            y = "\\f";
                            break;
                        case 11:
                            y = "\\v";
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = "\f" + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += "\r");
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = "", b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(",") + "{" + p + "}";
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ":-moz-$1") + p;
                        break;
                    case 112:
                        p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? "" : d[0] + " "; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + " ", h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, "$1" + d.trim());
            case 58:
                return d.trim() + c.replace(F, "$1" + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf("\f")) return c.replace(F, (58 === d.charCodeAt(0) ? "" : "$1") + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ";", m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(":", 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ";";
            return 1 === w || 2 === w && L(b, 1) ? "-webkit-" + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return "-webkit-" + a + a;
            case 978:
                return "-webkit-" + a + "-moz-" + a + a;
            case 1019:
            case 983:
                return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
                if (0 < a.indexOf("image-set(", 11)) return a.replace(ja, "$1-webkit-$2") + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
                    case 115:
                        return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
                    case 98:
                        return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
                }
                return "-webkit-" + a + "-ms-" + a + a;
            case 964:
                return "-webkit-" + a + "-ms-flex-" + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
                return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf("-") + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, "tb");
                        break;
                    case 232:
                        b = a.replace(G, "tb-rl");
                        break;
                    case 220:
                        b = a.replace(G, "lr");
                        break;
                    default:
                        return a;
                }
                return "-webkit-" + a + "-ms-" + b + a;
            case 1017:
                if (-1 === a.indexOf("sticky", 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(":", 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, "-webkit-" + b) + ";" + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, "-webkit-" + (102 < m ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
                }
                return a + ";";
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
                    case 115:
                        return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
                    default:
                        return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(":") + 1)).charCodeAt(0) ? P(d.replace("stretch", "fill-available"), c, e, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
                break;
            case 962:
                if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ":" : "{"), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, "$1"), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ";" ? e.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ("function" === typeof d) S[A++] = d;
                else if ("object" === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? "function" !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && "string" === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = "";
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = "";
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $89735de78c884c94$export$2e2bcd8739ae039 = $89735de78c884c94$var$stylis_min;


var $50f0f55433e63d8c$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $50f0f55433e63d8c$export$2e2bcd8739ae039 = $50f0f55433e63d8c$var$unitlessKeys;


function $81fe9e0845417c5e$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $c8638f08acca5456$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $c8638f08acca5456$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $81fe9e0845417c5e$export$2e2bcd8739ae039)(function(prop) {
    return $c8638f08acca5456$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});


var $f550a03ccbc02dc9$exports = {};
"use strict";
var $ac08dba5546f7fbe$exports = {};
"use strict";

$ac08dba5546f7fbe$exports = (parcelRequire("iwMs7"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $f550a03ccbc02dc9$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $f550a03ccbc02dc9$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $f550a03ccbc02dc9$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $f550a03ccbc02dc9$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $f550a03ccbc02dc9$var$TYPE_STATICS = {};
$f550a03ccbc02dc9$var$TYPE_STATICS[$ac08dba5546f7fbe$exports.ForwardRef] = $f550a03ccbc02dc9$var$FORWARD_REF_STATICS;
$f550a03ccbc02dc9$var$TYPE_STATICS[$ac08dba5546f7fbe$exports.Memo] = $f550a03ccbc02dc9$var$MEMO_STATICS;
function $f550a03ccbc02dc9$var$getStatics(component) {
    // React v16.11 and below
    if ($ac08dba5546f7fbe$exports.isMemo(component)) return $f550a03ccbc02dc9$var$MEMO_STATICS;
     // React v16.12 and above
    return $f550a03ccbc02dc9$var$TYPE_STATICS[component["$$typeof"]] || $f550a03ccbc02dc9$var$REACT_STATICS;
}
var $f550a03ccbc02dc9$var$defineProperty = Object.defineProperty;
var $f550a03ccbc02dc9$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $f550a03ccbc02dc9$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $f550a03ccbc02dc9$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $f550a03ccbc02dc9$var$getPrototypeOf = Object.getPrototypeOf;
var $f550a03ccbc02dc9$var$objectPrototype = Object.prototype;
function $f550a03ccbc02dc9$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($f550a03ccbc02dc9$var$objectPrototype) {
            var inheritedComponent = $f550a03ccbc02dc9$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $f550a03ccbc02dc9$var$objectPrototype) $f550a03ccbc02dc9$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $f550a03ccbc02dc9$var$getOwnPropertyNames(sourceComponent);
        if ($f550a03ccbc02dc9$var$getOwnPropertySymbols) keys = keys.concat($f550a03ccbc02dc9$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $f550a03ccbc02dc9$var$getStatics(targetComponent);
        var sourceStatics = $f550a03ccbc02dc9$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$f550a03ccbc02dc9$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $f550a03ccbc02dc9$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $f550a03ccbc02dc9$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$f550a03ccbc02dc9$exports = $f550a03ccbc02dc9$var$hoistNonReactStatics;



var $ibaza = parcelRequire("ibaza");
function $65e706775ff71837$var$y() {
    return ($65e706775ff71837$var$y = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }).apply(this, arguments);
}
var $65e706775ff71837$var$v = function(e, t) {
    for(var n = [
        e[0]
    ], r = 0, o = t.length; r < o; r += 1)n.push(t[r], e[r + 1]);
    return n;
}, $65e706775ff71837$var$g = function(t) {
    return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, $161775e6c718b902$exports.typeOf)(t);
}, $65e706775ff71837$var$S = Object.freeze([]), $65e706775ff71837$var$w = Object.freeze({});
function $65e706775ff71837$var$E(e) {
    return "function" == typeof e;
}
function $65e706775ff71837$var$b(e) {
    return "string" == typeof e && e || e.displayName || e.name || "Component";
}
function $65e706775ff71837$export$7ba318d8d2f06c76(e) {
    return e && "string" == typeof e.styledComponentId;
}
var $65e706775ff71837$var$N = ("undefined" != typeof $ibaza && void 0 !== $ibaza.env && undefined, "data-styled"), $65e706775ff71837$export$83d89fbfd8236492 = "5.3.11", $65e706775ff71837$var$C = "undefined" != typeof window && "HTMLElement" in window, $65e706775ff71837$var$I = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : "undefined" != typeof $ibaza && void 0 !== $ibaza.env && true), $65e706775ff71837$var$P = {}, $65e706775ff71837$var$O = {
    1: "Cannot create styled-component for component: %s.\n\n",
    2: "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",
    3: "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
    4: "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",
    5: "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",
    6: "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",
    7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',
    8: 'ThemeProvider: Please make your "theme" prop an object.\n\n',
    9: "Missing document `<head>`\n\n",
    10: "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
    11: "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",
    12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",
    13: "%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.\n\n",
    14: 'ThemeProvider: "theme" prop is required.\n\n',
    15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",
    16: "Reached the limit of how many styled components may be created at group %s.\nYou may only create up to 1,073,741,824 components. If you're creating components dynamically,\nas for instance in your render method then you may be running into this limitation.\n\n",
    17: "CSSStyleSheet could not be found on HTMLStyleElement.\nHas styled-components' style tag been unmounted or altered by another script?\n"
};
function $65e706775ff71837$var$R() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function $65e706775ff71837$var$D(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    throw new Error($65e706775ff71837$var$R.apply(void 0, [
        $65e706775ff71837$var$O[e]
    ].concat(n)).trim());
}
var $65e706775ff71837$var$j = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, r = n.length, o = r; e >= o;)(o <<= 1) < 0 && $65e706775ff71837$var$D(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), $65e706775ff71837$var$T = new Map, $65e706775ff71837$var$x = new Map, $65e706775ff71837$var$k = 1, $65e706775ff71837$var$V = function(e) {
    if ($65e706775ff71837$var$T.has(e)) return $65e706775ff71837$var$T.get(e);
    for(; $65e706775ff71837$var$x.has($65e706775ff71837$var$k);)$65e706775ff71837$var$k++;
    var t = $65e706775ff71837$var$k++;
    return ((0 | t) < 0 || t > 1073741824) && $65e706775ff71837$var$D(16, "" + t), $65e706775ff71837$var$T.set(e, t), $65e706775ff71837$var$x.set(t, e), t;
}, $65e706775ff71837$var$B = function(e) {
    return $65e706775ff71837$var$x.get(e);
}, $65e706775ff71837$var$z = function(e, t) {
    t >= $65e706775ff71837$var$k && ($65e706775ff71837$var$k = t + 1), $65e706775ff71837$var$T.set(e, t), $65e706775ff71837$var$x.set(t, e);
}, $65e706775ff71837$var$M = "style[" + $65e706775ff71837$var$N + '][data-styled-version="5.3.11"]', $65e706775ff71837$var$G = new RegExp("^" + $65e706775ff71837$var$N + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), $65e706775ff71837$var$L = function(e, t, n) {
    for(var r, o = n.split(","), s = 0, i = o.length; s < i; s++)(r = o[s]) && e.registerName(t, r);
}, $65e706775ff71837$var$F = function(e, t) {
    for(var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match($65e706775ff71837$var$G);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && ($65e706775ff71837$var$z(u, c), $65e706775ff71837$var$L(e, u, a[3]), e.getTag().insertRules(c, r)), r.length = 0;
            } else r.push(i);
        }
    }
}, $65e706775ff71837$var$Y = function() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}, $65e706775ff71837$var$q = function(e) {
    var t = document.head, n = e || t, r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var r = t[n];
            if (r && 1 === r.nodeType && r.hasAttribute($65e706775ff71837$var$N)) return r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute($65e706775ff71837$var$N, "active"), r.setAttribute("data-styled-version", "5.3.11");
    var i = $65e706775ff71837$var$Y();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
}, $65e706775ff71837$var$H = function() {
    function e(e) {
        var t = this.element = $65e706775ff71837$var$q(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, r = t.length; n < r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            $65e706775ff71837$var$D(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $65e706775ff71837$var$$ = function() {
    function e(e) {
        var t = this.element = $65e706775ff71837$var$q(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), r = this.nodes[e];
            return this.element.insertBefore(n, r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $65e706775ff71837$var$W = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $65e706775ff71837$var$U = $65e706775ff71837$var$C, $65e706775ff71837$var$J = {
    isServer: !$65e706775ff71837$var$C,
    useCSSOMInjection: !$65e706775ff71837$var$I
}, $65e706775ff71837$var$X = function() {
    function e(e, t, n) {
        void 0 === e && (e = $65e706775ff71837$var$w), void 0 === t && (t = {}), this.options = $65e706775ff71837$var$y({}, $65e706775ff71837$var$J, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && $65e706775ff71837$var$C && $65e706775ff71837$var$U && ($65e706775ff71837$var$U = !1, function(e) {
            for(var t = document.querySelectorAll($65e706775ff71837$var$M), n = 0, r = t.length; n < r; n++){
                var o = t[n];
                o && "active" !== o.getAttribute($65e706775ff71837$var$N) && ($65e706775ff71837$var$F(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return $65e706775ff71837$var$V(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e($65e706775ff71837$var$y({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var e, t, n, r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new $65e706775ff71837$var$W(o) : r ? new $65e706775ff71837$var$H(o) : new $65e706775ff71837$var$$(o), new $65e706775ff71837$var$j(e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if ($65e706775ff71837$var$V(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($65e706775ff71837$var$V(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup($65e706775ff71837$var$V(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++){
                var s = $65e706775ff71837$var$B(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = $65e706775ff71837$var$N + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return r;
        }(this);
    }, e;
}(), $65e706775ff71837$var$Z = /(a)(d)/gi, $65e706775ff71837$var$K = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $65e706775ff71837$var$Q(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $65e706775ff71837$var$K(t % 52) + n;
    return ($65e706775ff71837$var$K(t % 52) + n).replace($65e706775ff71837$var$Z, "$1-$2");
}
var $65e706775ff71837$var$ee = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $65e706775ff71837$var$te = function(e) {
    return $65e706775ff71837$var$ee(5381, e);
};
function $65e706775ff71837$var$ne(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($65e706775ff71837$var$E(n) && !$65e706775ff71837$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $65e706775ff71837$var$re = $65e706775ff71837$var$te("5.3.11"), $65e706775ff71837$var$oe = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = false, this.componentId = t, this.baseHash = $65e706775ff71837$var$ee($65e706775ff71837$var$re, t), this.baseStyle = n, $65e706775ff71837$var$X.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = $65e706775ff71837$var$_e(this.rules, e, t, n).join(""), i = $65e706775ff71837$var$Q($65e706775ff71837$var$ee(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(r, i)) {
                    var a = n(s, "." + i, void 0, r);
                    t.insertRules(r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = $65e706775ff71837$var$ee(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h, u = $65e706775ff71837$var$ee(u, h + d);
                else if (h) {
                    var p = $65e706775ff71837$var$_e(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = $65e706775ff71837$var$ee(u, f + d), l += f;
                }
            }
            if (l) {
                var m = $65e706775ff71837$var$Q(u >>> 0);
                if (!t.hasNameForId(r, m)) {
                    var y = n(l, "." + m, void 0, r);
                    t.insertRules(r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), $65e706775ff71837$var$se = /^\s*\/\/.*$/gm, $65e706775ff71837$var$ie = [
    ":",
    "[",
    ".",
    "#"
];
function $65e706775ff71837$var$ae(e) {
    var t, n, r, o, s = void 0 === e ? $65e706775ff71837$var$w : e, i = s.options, a = void 0 === i ? $65e706775ff71837$var$w : i, c = s.plugins, u = void 0 === c ? $65e706775ff71837$var$S : c, l = new (0, $89735de78c884c94$export$2e2bcd8739ae039)(a), d = [], p = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function(e, r, s) {
        return 0 === r && -1 !== $65e706775ff71837$var$ie.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace($65e706775ff71837$var$se, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
        },
        p,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $65e706775ff71837$var$D(15), $65e706775ff71837$var$ee(e, t.name);
    }, 5381).toString() : "", m;
}
var $65e706775ff71837$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createContext(), $65e706775ff71837$export$91317688fc694efa = $65e706775ff71837$export$8c190ef828af4c86.Consumer, $65e706775ff71837$var$le = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createContext(), $65e706775ff71837$var$de = ($65e706775ff71837$var$le.Consumer, new $65e706775ff71837$var$X), $65e706775ff71837$var$he = $65e706775ff71837$var$ae();
function $65e706775ff71837$var$pe() {
    return (0, $8NFma.useContext)($65e706775ff71837$export$8c190ef828af4c86) || $65e706775ff71837$var$de;
}
function $65e706775ff71837$var$fe() {
    return (0, $8NFma.useContext)($65e706775ff71837$var$le) || $65e706775ff71837$var$he;
}
function $65e706775ff71837$export$a473771da2f0ff7c(e) {
    var t = (0, $8NFma.useState)(e.stylisPlugins), n = t[0], s = t[1], c = $65e706775ff71837$var$pe(), u = (0, $8NFma.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, $8NFma.useMemo)(function() {
        return $65e706775ff71837$var$ae({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, $8NFma.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($ee39632639537d25$exports)))(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement($65e706775ff71837$export$8c190ef828af4c86.Provider, {
        value: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement($65e706775ff71837$var$le.Provider, {
        value: l
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Children.only(e.children)));
}
var $65e706775ff71837$var$ye = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $65e706775ff71837$var$he);
            var r = n.name + t.hash;
            e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
        }, this.toString = function() {
            return $65e706775ff71837$var$D(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $65e706775ff71837$var$he), this.name + e.hash;
    }, e;
}(), $65e706775ff71837$var$ve = /([A-Z])/, $65e706775ff71837$var$ge = /([A-Z])/g, $65e706775ff71837$var$Se = /^ms-/, $65e706775ff71837$var$we = function(e) {
    return "-" + e.toLowerCase();
};
function $65e706775ff71837$var$Ee(e) {
    return $65e706775ff71837$var$ve.test(e) ? e.replace($65e706775ff71837$var$ge, $65e706775ff71837$var$we).replace($65e706775ff71837$var$Se, "-ms-") : e;
}
var $65e706775ff71837$var$be = function(e) {
    return null == e || !1 === e || "" === e;
};
function $65e706775ff71837$var$_e(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = $65e706775ff71837$var$_e(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if ($65e706775ff71837$var$be(e)) return "";
    if ($65e706775ff71837$export$7ba318d8d2f06c76(e)) return "." + e.styledComponentId;
    if ($65e706775ff71837$var$E(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return (0, $161775e6c718b902$exports.isElement)(u) && console.warn($65e706775ff71837$var$b(e) + " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."), $65e706775ff71837$var$_e(u, n, r, o);
    }
    var l;
    return e instanceof $65e706775ff71837$var$ye ? r ? (e.inject(r, o), e.getName(o)) : e : $65e706775ff71837$var$g(e) ? function e(t, n) {
        var r, o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !$65e706775ff71837$var$be(t[i]) && (Array.isArray(t[i]) && t[i].isCss || $65e706775ff71837$var$E(t[i]) ? s.push($65e706775ff71837$var$Ee(i) + ":", t[i], ";") : $65e706775ff71837$var$g(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push($65e706775ff71837$var$Ee(i) + ": " + (r = i, null == (o = t[i]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in (0, $50f0f55433e63d8c$export$2e2bcd8739ae039) || r.startsWith("--") ? String(o).trim() : o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var $65e706775ff71837$var$Ne = function(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function $65e706775ff71837$export$dbf350e5966cf602(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return $65e706775ff71837$var$E(e) || $65e706775ff71837$var$g(e) ? $65e706775ff71837$var$Ne($65e706775ff71837$var$_e($65e706775ff71837$var$v($65e706775ff71837$var$S, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : $65e706775ff71837$var$Ne($65e706775ff71837$var$_e($65e706775ff71837$var$v(e, n)));
}
var $65e706775ff71837$var$Ce = /invalid hook call/i, $65e706775ff71837$var$Ie = new Set, $65e706775ff71837$var$Pe = function(e, t) {
    var n = "The component " + e + (t ? ' with the id of "' + t + '"' : "") + " has been created dynamically.\nYou may see this warning because you've called styled inside another component.\nTo resolve this only create new StyledComponents outside of any render method and function component.", r = console.error;
    try {
        var o = !0;
        console.error = function(e) {
            if ($65e706775ff71837$var$Ce.test(e)) o = !1, $65e706775ff71837$var$Ie.delete(n);
            else {
                for(var t = arguments.length, s = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)s[i - 1] = arguments[i];
                r.apply(void 0, [
                    e
                ].concat(s));
            }
        }, (0, $8NFma.useRef)(), o && !$65e706775ff71837$var$Ie.has(n) && (console.warn(n), $65e706775ff71837$var$Ie.add(n));
    } catch (e) {
        $65e706775ff71837$var$Ce.test(e.message) && $65e706775ff71837$var$Ie.delete(n);
    } finally{
        console.error = r;
    }
}, $65e706775ff71837$var$Oe = function(e, t, n) {
    return void 0 === n && (n = $65e706775ff71837$var$w), e.theme !== n.theme && e.theme || t || n.theme;
}, $65e706775ff71837$var$Re = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $65e706775ff71837$var$De = /(^-|-$)/g;
function $65e706775ff71837$var$je(e) {
    return e.replace($65e706775ff71837$var$Re, "-").replace($65e706775ff71837$var$De, "");
}
var $65e706775ff71837$var$Te = function(e) {
    return $65e706775ff71837$var$Q($65e706775ff71837$var$te(e) >>> 0);
};
function $65e706775ff71837$var$xe(e) {
    return "string" == typeof e && e.charAt(0) === e.charAt(0).toLowerCase();
}
var $65e706775ff71837$var$ke = function(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
}, $65e706775ff71837$var$Ve = function(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function $65e706775ff71837$var$Be(e, t, n) {
    var r = e[n];
    $65e706775ff71837$var$ke(t) && $65e706775ff71837$var$ke(r) ? $65e706775ff71837$var$ze(r, t) : e[n] = t;
}
function $65e706775ff71837$var$ze(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if ($65e706775ff71837$var$ke(i)) for(var a in i)$65e706775ff71837$var$Ve(a) && $65e706775ff71837$var$Be(e, i[a], a);
    }
    return e;
}
var $65e706775ff71837$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createContext(), $65e706775ff71837$export$b631efc24e9d5e2f = $65e706775ff71837$export$2c657da244d00bd6.Consumer;
function $65e706775ff71837$export$d8964aec282183a3(e) {
    var t = (0, $8NFma.useContext)($65e706775ff71837$export$2c657da244d00bd6), n = (0, $8NFma.useMemo)(function() {
        return function(e, t) {
            if (!e) return $65e706775ff71837$var$D(14);
            if ($65e706775ff71837$var$E(e)) {
                var n = e(t);
                return null !== n && !Array.isArray(n) && "object" == typeof n ? n : $65e706775ff71837$var$D(7);
            }
            return Array.isArray(e) || "object" != typeof e ? $65e706775ff71837$var$D(8) : t ? $65e706775ff71837$var$y({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement($65e706775ff71837$export$2c657da244d00bd6.Provider, {
        value: n
    }, e.children) : null;
}
var $65e706775ff71837$var$Fe = {};
function $65e706775ff71837$var$Ye(e, t, n) {
    var o = $65e706775ff71837$export$7ba318d8d2f06c76(e), i = !$65e706775ff71837$var$xe(e), a = t.attrs, c = void 0 === a ? $65e706775ff71837$var$S : a, l = t.componentId, d = void 0 === l ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $65e706775ff71837$var$je(e);
        $65e706775ff71837$var$Fe[n] = ($65e706775ff71837$var$Fe[n] || 0) + 1;
        var r = n + "-" + $65e706775ff71837$var$Te("5.3.11" + n + $65e706775ff71837$var$Fe[n]);
        return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : l, h = t.displayName, p = void 0 === h ? function(e) {
        return $65e706775ff71837$var$xe(e) ? "styled." + e : "Styled(" + $65e706775ff71837$var$b(e) + ")";
    }(e) : h, v = t.displayName && t.componentId ? $65e706775ff71837$var$je(t.displayName) + "-" + t.componentId : t.componentId || d, g = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, N = t.shouldForwardProp;
    o && e.shouldForwardProp && (N = t.shouldForwardProp ? function(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var A, C = new $65e706775ff71837$var$oe(n, v, o ? e.componentStyle : void 0), I = C.isStatic && 0 === c.length, P = function(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, l = e.shouldForwardProp, d = e.styledComponentId, h = e.target, p = function(e, t, n) {
                void 0 === e && (e = $65e706775ff71837$var$w);
                var r = $65e706775ff71837$var$y({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var t, n, s, i = e;
                    for(t in $65e706775ff71837$var$E(i) && (i = i(r)), i)r[t] = o[t] = "className" === t ? (n = o[t], s = i[t], n && s ? n + " " + s : n || s) : i[t];
                }), [
                    r,
                    o
                ];
            }($65e706775ff71837$var$Oe(t, (0, $8NFma.useContext)($65e706775ff71837$export$2c657da244d00bd6), a) || $65e706775ff71837$var$w, t, o), m = p[0], v = p[1], g = function(e, t, n, r) {
                var o = $65e706775ff71837$var$pe(), s = $65e706775ff71837$var$fe(), i = t ? e.generateAndInjectStyles($65e706775ff71837$var$w, o, s) : e.generateAndInjectStyles(n, o, s);
                return !t && r && r(i), i;
            }(i, r, m, (0, e.warnTooManyClasses)), S = n, b = v.$as || t.$as || v.as || t.as || h, _ = $65e706775ff71837$var$xe(b), N = v !== t ? $65e706775ff71837$var$y({}, t, {}, v) : t, A = {};
            for(var C in N)"$" !== C[0] && "as" !== C && ("forwardedAs" === C ? A.as = N[C] : (l ? l(C, (0, $c8638f08acca5456$export$2e2bcd8739ae039), b) : !_ || (0, $c8638f08acca5456$export$2e2bcd8739ae039)(C)) && (A[C] = N[C]));
            return t.style && v.style !== t.style && (A.style = $65e706775ff71837$var$y({}, t.style, {}, v.style)), A.className = Array.prototype.concat(c, d, g !== d ? g : null, t.className, v.className).filter(Boolean).join(" "), A.ref = S, (0, $8NFma.createElement)(b, A);
        }(A, e, t, I);
    };
    return P.displayName = p, (A = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).forwardRef(P)).attrs = g, A.componentStyle = C, A.displayName = p, A.shouldForwardProp = N, A.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : $65e706775ff71837$var$S, A.styledComponentId = v, A.target = o ? e.target : e, A.withComponent = function(e) {
        var r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var n, r, o = {}, s = Object.keys(e);
            for(r = 0; r < s.length; r++)n = s[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o;
        }(t, [
            "componentId"
        ]), s = r && r + "-" + ($65e706775ff71837$var$xe(e) ? e : $65e706775ff71837$var$je($65e706775ff71837$var$b(e)));
        return $65e706775ff71837$var$Ye(e, $65e706775ff71837$var$y({}, o, {
            attrs: g,
            componentId: s
        }), n);
    }, Object.defineProperty(A, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(t) {
            this._foldedDefaultProps = o ? $65e706775ff71837$var$ze({}, e.defaultProps, t) : t;
        }
    }), $65e706775ff71837$var$Pe(p, v), A.warnTooManyClasses = function(e, t) {
        var n = {}, r = !1;
        return function(o) {
            if (!r && (n[o] = !0, Object.keys(n).length >= 200)) {
                var s = t ? ' with the id of "' + t + '"' : "";
                console.warn("Over 200 classes were generated for component " + e + s + ".\nConsider using the attrs method, together with a style object for frequently changed styles.\nExample:\n  const Component = styled.div.attrs(props => ({\n    style: {\n      background: props.background,\n    },\n  }))`width: 100%;`\n\n  <Component />"), r = !0, n = {};
            }
        };
    }(p, v), Object.defineProperty(A, "toString", {
        value: function() {
            return "." + A.styledComponentId;
        }
    }), i && (0, (/*@__PURE__*/$parcel$interopDefault($f550a03ccbc02dc9$exports)))(A, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), A;
}
var $65e706775ff71837$var$qe = function(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = $65e706775ff71837$var$w), !(0, $161775e6c718b902$exports.isValidElementType)(r)) return $65e706775ff71837$var$D(1, String(r));
        var s = function() {
            return t(r, o, $65e706775ff71837$export$dbf350e5966cf602.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, $65e706775ff71837$var$y({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, $65e706775ff71837$var$y({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }($65e706775ff71837$var$Ye, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    $65e706775ff71837$var$qe[e] = $65e706775ff71837$var$qe(e);
});
var $65e706775ff71837$var$He = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $65e706775ff71837$var$ne(e), $65e706775ff71837$var$X.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r($65e706775ff71837$var$_e(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && $65e706775ff71837$var$X.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $65e706775ff71837$export$f0f03736edb61697(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = $65e706775ff71837$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + $65e706775ff71837$var$Te(JSON.stringify(i)), u = new $65e706775ff71837$var$He(i, a);
    function d(e) {
        var t = $65e706775ff71837$var$pe(), n = $65e706775ff71837$var$fe(), o = (0, $8NFma.useContext)($65e706775ff71837$export$2c657da244d00bd6), d = (0, $8NFma.useRef)(t.allocateGSInstance(a)).current;
        return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Children.count(e.children) && console.warn("The global style component " + a + " was given child JSX. createGlobalStyle does not render children."), i.some(function(e) {
            return "string" == typeof e && -1 !== e.indexOf("@import");
        }) && console.warn("Please do not use @import CSS syntax in createGlobalStyle at this time, as the CSSOM APIs we use in production do not handle it well. Instead, we recommend using a library such as react-helmet to inject a typical <link> meta tag to the stylesheet, or simply embedding it manually in your index.html <head> section for a simpler app."), t.server && h(d, e, t, o, n), (0, $8NFma.useLayoutEffect)(function() {
            if (!t.server) return h(d, e, t, o, n), function() {
                return u.removeStyles(d, t);
            };
        }, [
            d,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, $65e706775ff71837$var$P, n, o);
        else {
            var s = $65e706775ff71837$var$y({}, t, {
                theme: $65e706775ff71837$var$Oe(t, r, d.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return $65e706775ff71837$var$Pe(a), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).memo(d);
}
function $65e706775ff71837$export$d25ddfdf17c3ad3e(e) {
    "undefined" != typeof navigator && "ReactNative" === navigator.product && console.warn("`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.");
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    var o = $65e706775ff71837$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)).join(""), s = $65e706775ff71837$var$Te(o);
    return new $65e706775ff71837$var$ye(s, o);
}
var $65e706775ff71837$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $65e706775ff71837$var$Y();
            return "<style " + [
                n && 'nonce="' + n + '"',
                $65e706775ff71837$var$N + '="true"',
                'data-styled-version="5.3.11"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return e.sealed ? $65e706775ff71837$var$D(2) : e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (e.sealed) return $65e706775ff71837$var$D(2);
            var n = ((t = {})[$65e706775ff71837$var$N] = "", t["data-styled-version"] = "5.3.11", t.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, t), o = $65e706775ff71837$var$Y();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("style", $65e706775ff71837$var$y({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $65e706775ff71837$var$X({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? $65e706775ff71837$var$D(2) : (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement($65e706775ff71837$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return $65e706775ff71837$var$D(3);
    }, e;
}(), $65e706775ff71837$export$e8748c6a27b910dc = function(e) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).forwardRef(function(t, n) {
        var o = (0, $8NFma.useContext)($65e706775ff71837$export$2c657da244d00bd6), i = e.defaultProps, a = $65e706775ff71837$var$Oe(t, o, i);
        return void 0 === a && console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps in component class "' + $65e706775ff71837$var$b(e) + '"'), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement(e, $65e706775ff71837$var$y({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($f550a03ccbc02dc9$exports)))(t, e), t.displayName = "WithTheme(" + $65e706775ff71837$var$b(e) + ")", t;
}, $65e706775ff71837$export$93d4e7f90805808f = function() {
    return (0, $8NFma.useContext)($65e706775ff71837$export$2c657da244d00bd6);
}, $65e706775ff71837$export$5c87cfe6c475f500 = {
    StyleSheet: $65e706775ff71837$var$X,
    masterSheet: $65e706775ff71837$var$de
};
"undefined" != typeof navigator && "ReactNative" === navigator.product && console.warn("It looks like you've imported 'styled-components' on React Native.\nPerhaps you're looking to import 'styled-components/native'?\nRead more about this at https://www.styled-components.com/docs/basics#react-native"), "undefined" != typeof window && (window["__styled-components-init__"] = window["__styled-components-init__"] || 0, 1 === window["__styled-components-init__"] && console.warn("It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles to not render properly, errors during the rehydration process, a missing theme prop, and makes your application bigger without good reason.\n\nSee https://s-c.sh/2BAXzed for more info."), window["__styled-components-init__"] += 1);
var $65e706775ff71837$export$2e2bcd8739ae039 = $65e706775ff71837$var$qe;



const $fbcecf017801e70f$export$e6d6b58188820b8a = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 8px;
  font-size: 12px;
  align-items: center;
  justify-content: center;
`;
const $fbcecf017801e70f$export$1e8407dccf0d27b6 = `
  border: 1px solid ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARK};
  border-radius: 5px;
  padding: 8px 6px;
  transition: 0.2s ease border, box-shadow;
  width: 100%;
  outline: none;
  box-shadow: 0 1px 1px rgb(226 228 239 / 50%);
  font-size: 14px;

  :hover {
    border-color: ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARK};
  }

  :focus {
    border-color: ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARKER};
    box-shadow: 0 0 5px ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARK};
  }

  ::placeholder {
    color: ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARKER};
  }
`;
const $fbcecf017801e70f$export$30c69c51aadaa8e4 = ({ label: label, type: type = "text", value: value, onChange: onChange, placeholder: placeholder, pattern: pattern, onKeyDown: onKeyDown, required: required })=>{
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            gap: 10
        },
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($fbcecf017801e70f$export$76d3231fec538b73, {
                children: label
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($fbcecf017801e70f$export$c86715117507e8e5, {
                type: type,
                value: value,
                onChange: onChange,
                placeholder: placeholder,
                pattern: pattern,
                onKeyDown: onKeyDown,
                required: required
            })
        ]
    });
};
const $fbcecf017801e70f$export$76d3231fec538b73 = (0, $65e706775ff71837$export$2e2bcd8739ae039).span`
  font-weight: 400;
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
  font-size: 14px;
  color: ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARKER};
`;
const $fbcecf017801e70f$export$c86715117507e8e5 = (0, $65e706775ff71837$export$2e2bcd8739ae039).input`
  ${$fbcecf017801e70f$export$1e8407dccf0d27b6}

  ::placeholder {
    ${(props)=>props.placeholderColor && `color: ${props.placeholderColor} !important;`}
  }
`;
const $fbcecf017801e70f$export$bd0cf18531183c14 = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
  max-width: min-content;
  background-color: ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_MED};
  border-radius: 5px;
  padding: 3px 5px;
  color: ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARKEST};
  font-size: 12px;
  user-select: none;
`;



parcelRequire("8NFma");




const $8cb41b6cdada8dfd$var$Spin = (0, $65e706775ff71837$export$d25ddfdf17c3ad3e)`
  from {
      transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
const $8cb41b6cdada8dfd$var$Spinner = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
  width: 20px;
  height: 20px;
  margin: 0;
  background: transparent;
  border-top: 2px solid ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).ORANGE};
  border-right: 2px solid transparent;
  border-radius: 50%;
  animation: .5s ${$8cb41b6cdada8dfd$var$Spin} linear infinite;
`;
var $8cb41b6cdada8dfd$export$2e2bcd8739ae039 = $8cb41b6cdada8dfd$var$Spinner;


const $348d722f77cc9b90$var$PrimaryButtonInner = (0, $65e706775ff71837$export$2e2bcd8739ae039).button`
  background-color: ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).BLACK};
  border-radius: 25px;
  padding: 14px 30px;
  outline: 0;
  border: 0;
  color: #FFF;
  cursor: pointer;
  transition: 0.2s ease all;
  font-size: 16px;
  height: fit-content;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transform: scale(1);

  :hover {
    transform: scale(1.005);
    opacity: 0.75;
  }
  
  :active {
    transform: scale(0.995);
  }

  :disabled {
    cursor: not-allowed;
    opacity: 0.5;

    :active {
      color: #FFF;
    }
  }
`;
const $348d722f77cc9b90$export$ac16a6a04d9b7c84 = ({ disabled: disabled, ...props })=>// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($348d722f77cc9b90$var$PrimaryButtonInner, {
        style: props.style,
        disabled: props.isLoading || disabled,
        ...props,
        children: props.isLoading ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $8cb41b6cdada8dfd$export$2e2bcd8739ae039), {
            style: {
                borderColor: props.spinnerColor ?? "white"
            }
        }) : props.children
    });
const $348d722f77cc9b90$export$f861551692d63a2e = (0, $65e706775ff71837$export$2e2bcd8739ae039).button`
  border: 1px solid;
  border-color: ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).ORANGE};
  border-radius: 5px;
  padding: 10px 30px;
  outline: 0;
  background: none;
  color: ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).ORANGE};
  cursor: pointer;
  transition: 0.2s ease all;
  font-size: 14px;
  height: fit-content;
  user-select: none;
  
  :hover {
    opacity: 0.75;
  }

  :disabled {
    cursor: default;
    border-color: ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).ORANGE_LIGHT};
    color: ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).ORANGE_LIGHT};
    :hover {
      opacity: 1;
    }
  }
  
  :active {
    opacity: 0.5;
  }
`;
const $348d722f77cc9b90$export$eeafbfd890eadf04 = (0, $65e706775ff71837$export$2e2bcd8739ae039).a`
  border: 1px solid;
  border-color: ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).ORANGE};
  border-radius: 5px;
  padding: 5px 20px;
  outline: 0;
  background: none;
  color: ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).ORANGE};
  cursor: pointer;
  transition: 0.2s ease all;
  font-size: 12px;
  height: fit-content;
  user-select: none;
  text-decoration: none;
  
  :hover {
    opacity: 0.75;
  }
  
  :active {
    opacity: 0.5;
  }
`;
const $348d722f77cc9b90$export$eeb919efb9beb575 = (0, $65e706775ff71837$export$2e2bcd8739ae039).a`
  background-color: ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).ORANGE};
  border-radius: 5px;
  padding: 10px 30px;
  outline: 0;
  border: 0;
  color: #FFF;
  cursor: pointer;
  transition: 0.2s ease all;
  text-decoration: none;
  font-size: 14px;
  height: fit-content;
  user-select: none;
  
  :hover {
      opacity: 0.75;
  }
  
  :active {
      background-color: #ffd6ce;
      color: ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).ORANGE};
  }
`;
const $348d722f77cc9b90$export$c25acd513dcc8062 = (0, $65e706775ff71837$export$2e2bcd8739ae039).button`
  border: 0;
  border-radius: 5px;
  padding: 5px 20px;
  outline: 0;
  background: none;
  color: ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).ORANGE};
  cursor: pointer;
  transition: 0.2s ease all;
  font-size: 12px;
  height: fit-content;
  user-select: none;
  display: flex;
  align-items: center;
  
  :hover {
    opacity: 0.75;
  }
  
  :active {
    opacity: 0.5;
  }
`;



parcelRequire("8NFma");



var $b20b7e68cb2f420e$exports = {};

$b20b7e68cb2f420e$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "EUROCLogo.e814427f.svg";


var $ef95c14598de3518$exports = {};

$ef95c14598de3518$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "FRAXLogo.493412e4.svg";


var $6589f42e70726bc0$exports = {};

$6589f42e70726bc0$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "DaiLogo.5b7d885d.svg";


var $7e24d2c6c5fdfe09$exports = {};

$7e24d2c6c5fdfe09$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "WETH.6226dbd9.svg";


var $9208d705d599d8a6$exports = {};

$9208d705d599d8a6$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "GeminiLogo.5cbba47e.png";



var $e4e3c143b775293f$exports = {};

$e4e3c143b775293f$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "TORLogo.bd732ad4.svg";


var $ba4fa81e257cffe0$exports = {};

$ba4fa81e257cffe0$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "TUSDLogo.df934baa.svg";


var $541f3597633652d1$exports = {};

$541f3597633652d1$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "USDPLogo.d2d050af.svg";


var $5e6d7626c0df20ca$exports = {};

$5e6d7626c0df20ca$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "TetherGoldLogo.5d02ace7.svg";


var $15405652ff4767c1$exports = {};

$15405652ff4767c1$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "PRQLogo.ef7c079b.svg";


var $7fe1014fba8a6b83$exports = {};

$7fe1014fba8a6b83$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "PAXGLogo.2d9a097a.svg";


var $c61384a5d302d9c7$exports = {};

$c61384a5d302d9c7$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "MIMLogo.ea9454b3.svg";



var $045ce130a045078f$exports = {};

$045ce130a045078f$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "FantomLogo.59ea410b.svg";


var $0d552097fc89e4e4$exports = {};

$0d552097fc89e4e4$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "WrappedBitcoin.a9abc558.svg";





var $1c36b22fdfaf54e9$exports = {};

$1c36b22fdfaf54e9$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "DAIKLogo.7aa105ad.png";


var $67b309c095a34afb$exports = {};

$67b309c095a34afb$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "ETHKLogo.b79115fc.png";


var $8c2eef3f7f97e2a0$exports = {};

$8c2eef3f7f97e2a0$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "BTCKLogo.9770427e.png";


var $95f30a4878f6e279$exports = {};

$95f30a4878f6e279$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "WOKTLogo.2376971f.png";


var $9bdae5fd83138776$exports = {};

$9bdae5fd83138776$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "OKBLogo.8b0e77b3.png";


const $88337873f840b6bb$export$8e1e81ac145e31be = {
    USDC: {
        name: "USD Coin",
        ticker: "USDC",
        addresses: {
            1: "0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48",
            31337: "0x6d4cc59Ca95Ab85e333a17bAF97a225CA10F292c",
            5: "0x12437ca9aCb41Cc73D1c59E29C7496A054FC8A78",
            80001: "0x8f8b1972eea072C3C228EbE8f9FEADe03927D70F",
            4002: "0x31720c00bD9EDEF0dbcBFcBa20B572c6b950C6Dc",
            11155111: "0xa4fCE8264370437e718aE207805b4e6233638b9E",
            1313161555: "0x0C6013dfdaBF883F3fc2d7D9911f30f54D10E4a6",
            43113: "0x2e9B1F01068B96D7c85913f70Cf29464FA98b567",
            534353: "0x87cba17033bAA29324708dC12503a14C179a00D7",
            137: "0x2791bca1f2de4661ed88a30c99a7a9449aa84174",
            56: "0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d",
            250: "0x04068DA6C83AFCFA0e13ba15A6696662335D5B75",
            43114: "0xB97EF9Ef8734C71904D8002F8b6Bc66Dd9c48a6E",
            66: "0xc946DAf81b08146B1C7A8Da2A851Ddf2B3EAaf85"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($c3ae5bd62f2a8d35$exports))),
        decimals: {
            default: 6,
            56: 18,
            66: 18
        }
    },
    PAXG: {
        name: "Paxos Gold",
        ticker: "PAXG",
        addresses: {
            1: "0x45804880de22913dafe09f4980848ece6ecbaf78"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($7fe1014fba8a6b83$exports))),
        decimals: {
            default: 18
        }
    },
    DAIK: {
        name: "DAI",
        ticker: "DAIK",
        pricefeedTicker: "DAI",
        addresses: {
            66: "0x21cDE7E32a6CAF4742d00d44B07279e7596d26B9"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($1c36b22fdfaf54e9$exports))),
        decimals: {
            default: 18
        }
    },
    ETHK: {
        name: "ETHK",
        ticker: "ETHK",
        pricefeedTicker: "ETH",
        addresses: {
            66: "0xEF71CA2EE68F45B9Ad6F72fbdb33d707b872315C"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($67b309c095a34afb$exports))),
        decimals: {
            default: 18
        }
    },
    WOKT: {
        name: "Wrapped OKT",
        ticker: "WOKT",
        pricefeedTicker: "OKT",
        addresses: {
            66: "0x8F8526dbfd6E38E3D8307702cA8469Bae6C56C15"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($95f30a4878f6e279$exports))),
        decimals: {
            default: 18
        }
    },
    XAUT: {
        name: "Tether Gold",
        ticker: "XAUT",
        addresses: {
            1: "0x68749665FF8D2d112Fa859AA293F07A622782F38"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($5e6d7626c0df20ca$exports))),
        decimals: {
            default: 6
        }
    },
    WBTC: {
        name: "Wrapped Bitcoin",
        ticker: "WBTC",
        addresses: {
            1: "0x2260fac5e5542a773aa44fbcfedf7c193bc2c599",
            250: "0x321162Cd933E2Be498Cd2267a90534A804051b11",
            137: "0x1bfd67037b42cf73acf2047067bd4f2c47d9bfd6",
            56: "0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c",
            43114: "0x50b7545627a5162f82a992c33b87adc75187b218"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($0d552097fc89e4e4$exports))),
        decimals: {
            default: 8,
            56: 18
        }
    },
    USDCe: {
        name: "Bridged USDC Coin",
        ticker: "USDC.e",
        pricefeedTicker: "USDC",
        addresses: {
            1313161554: "0xb12bfca5a55806aaf64e99521918a4bf0fc40802",
            43114: "0xa7d7079b0fead91f3e65f86e8915cb59c1a4c664"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($c3ae5bd62f2a8d35$exports))),
        decimals: {
            default: 6
        }
    },
    EURT: {
        name: "Euro Tether",
        ticker: "EURT",
        addresses: {
            1: "0xC581b735A1688071A1746c968e0798D642EDE491"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($045a81ce5300c0bd$exports))),
        decimals: {
            default: 6
        }
    },
    BTCK: {
        name: "BTCK",
        ticker: "BTCK",
        pricefeedTicker: "BTC",
        addresses: {
            66: "0x54e4622DC504176b3BB432dCCAf504569699a7fF"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($8c2eef3f7f97e2a0$exports))),
        decimals: {
            default: 18
        }
    },
    OKB: {
        name: "OKB",
        ticker: "OKB",
        addresses: {
            66: "0xdF54B6c6195EA4d948D03bfD818D365cf175cFC2"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($9bdae5fd83138776$exports))),
        decimals: {
            default: 18
        }
    },
    EUROC: {
        name: "Euro Coin",
        ticker: "EUROC",
        addresses: {
            1: "0x1abaea1f7c830bd89acc67ec4af516284b1bc33c"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($b20b7e68cb2f420e$exports))),
        decimals: {
            default: 6
        }
    },
    USDT: {
        name: "Tether USD",
        ticker: "USDT",
        addresses: {
            1: "0xdAC17F958D2ee523a2206206994597C13D831ec7",
            31337: "0x7e05775C8CD424Fc80a0a6B31c7596fdF20B8076",
            5: "0x1AAaF0f10C26E33DBe04d06531E533345CbA755e",
            80001: "0x70BE8802e2F3C6652B7e0814B478f66Ec52d9d88",
            4002: "0xCc8401Fbca27934D4bFC762FEbb667ACdb976F88",
            11155111: "0xE50d86c6dE38F9754f6777d2925377564Bf79482",
            1313161555: "0x7696c118ea37866c38918CAE97C4A9383e8129F6",
            43113: "0x31720c00bD9EDEF0dbcBFcBa20B572c6b950C6Dc",
            534353: "0xA0CA2CdC4291826AAFb0C2DF77f303EdfeA34ef3",
            137: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
            56: "0x55d398326f99059ff775485246999027b3197955",
            43114: "0x9702230A8Ea53601f5cD2dc00fDBc13d4dF4A8c7",
            66: "0x382bB369d343125BfB2117af9c149795C6C65C50"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($045a81ce5300c0bd$exports))),
        decimals: {
            default: 6,
            56: 18,
            66: 18
        }
    },
    USDTe: {
        name: "Tether USD",
        ticker: "USDT.e",
        pricefeedTicker: "USDT",
        addresses: {
            1313161554: "0x4988a896b1227218e4A686fdE5EabdcAbd91571f",
            43114: "0xc7198437980c041c805a1edcba50c1ce5db95118"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($045a81ce5300c0bd$exports))),
        decimals: {
            default: 6
        }
    },
    FUSDT: {
        name: "Frapped USDT",
        ticker: "fUSDT",
        pricefeedTicker: "USDT",
        addresses: {
            250: "0x049d68029688eAbF473097a2fC38ef61633A3C7A"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($045a81ce5300c0bd$exports))),
        decimals: {
            default: 6
        }
    },
    FRAX: {
        name: "FRAX",
        ticker: "FRAX",
        addresses: {
            1: "0x853d955acef822db058eb8505911ed77f175b99e",
            250: "0xdc301622e621166bd8e82f2ca0a26c13ad0be355",
            43114: "0xD24C2Ad096400B6FBcd2ad8B24E7acBc21A1da64"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($ef95c14598de3518$exports))),
        decimals: {
            default: 18
        }
    },
    WAVAX: {
        name: "Wrapped AVAX",
        ticker: "WAVAX",
        pricefeedTicker: "AVAX",
        addresses: {
            43114: "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($419e6e6a8c2ce84c$exports))),
        decimals: {
            default: 18
        }
    },
    USDP: {
        name: "Pax Dollar",
        ticker: "USDP",
        addresses: {
            1: "0x8e870d67f660d95d5be530380d0ec0bd388289e1"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($541f3597633652d1$exports))),
        decimals: {
            default: 18
        }
    },
    TUSD: {
        name: "TrueUSD",
        ticker: "TUSD",
        addresses: {
            1: "0x0000000000085d4780B73119b644AE5ecd22b376"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($ba4fa81e257cffe0$exports))),
        decimals: {
            default: 18
        }
    },
    MIM: {
        name: "Magic Internet Money",
        ticker: "MIM",
        addresses: {
            250: "0x82f0B8B456c1A451378467398982d4834b6829c1",
            43114: "0x130966628846bfd36ff31a822705796e8cb8c18d"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($c61384a5d302d9c7$exports))),
        decimals: {
            default: 18
        }
    },
    WFTM: {
        name: "Wrapped Fantom",
        ticker: "WFTM",
        pricefeedTicker: "FTM",
        addresses: {
            250: "0x21be370d5312f44cb42ce377bc9b8a0cef1a4c83"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($045ce130a045078f$exports))),
        decimals: {
            default: 18
        }
    },
    DAI: {
        name: "DAI Stablecoin",
        ticker: "DAI",
        addresses: {
            1: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
            31337: "0x3a2F7b4b41706C6A0A60cDf02835321175c919e4",
            5: "0x16246c650be7C4EE01fDE5DAEd829D4C65c09450",
            80001: "0x3C10B58B766F2E9BEE0895cd5654EF8E02Fb6b8B",
            4002: "0x2e9B1F01068B96D7c85913f70Cf29464FA98b567",
            11155111: "0xE76FbC3C71499e0C522F21ad1520825BB7Be6714",
            1313161555: "0xACdC5B8b4cD24D99737116afA55F98D05D853c55",
            43113: "0x04C15309Edf4ff9fcDa1F542CddBd63684bd50f0",
            534353: "0x56F8853aE261FFD95D65131e8525DBd317103664",
            137: "0x8f3cf7ad23cd3cadbd9735aff958023239c6a063",
            56: "0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3",
            1313161554: "0xe3520349F477A5F6EB06107066048508498A291b",
            250: "0x8d11ec38a3eb5e956b052f67da8bdc9bef8abf3e"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($6589f42e70726bc0$exports))),
        decimals: {
            default: 18
        }
    },
    DAIe: {
        name: "DAI Stablecoin",
        ticker: "DAI.e",
        pricefeedTicker: "DAI",
        addresses: {
            43114: "0xd586e7f844cea2f87f50152665bcbc2c279d8d70"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($6589f42e70726bc0$exports))),
        decimals: {
            default: 18
        }
    },
    BUSD: {
        name: "Binance USD",
        ticker: "BUSD",
        addresses: {
            56: "0xe9e7cea3dedca5984780bafc599bd69add087d56"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($d6dcdafb97da2969$exports))),
        decimals: {
            default: 18
        }
    },
    BUSDe: {
        name: "Binance USD",
        ticker: "BUSD.e",
        pricefeedTicker: "BUSD",
        addresses: {
            43114: "0x19860ccb0a68fd4213ab9d8266f7bbf05a8dde98"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($d6dcdafb97da2969$exports))),
        decimals: {
            default: 18
        }
    },
    TOR: {
        name: "TOR",
        ticker: "TOR",
        addresses: {
            250: "0x74e23df9110aa9ea0b6ff2faee01e740ca1c642e"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($e4e3c143b775293f$exports))),
        decimals: {
            default: 18
        }
    },
    GUSD: {
        name: "Gemini Dollar",
        ticker: "GUSD",
        addresses: {
            1: "0x056Fd409E1d7A124BD7017459dFEa2F387b6d5Cd",
            31337: "0xc9777dd0eCe801171dFedAE50d3FE8f9D03C80F1",
            5: "0xd72301a9aB0583d5294bb4BcAfb3781B14855001",
            80001: "0x1Df991976eFA97dCE09023B702f138F30E3fC8B4",
            4002: "0x04C15309Edf4ff9fcDa1F542CddBd63684bd50f0",
            11155111: "0xB081F0D0f1eb825D0A42134ef1121dAF5321D917",
            1313161555: "0x705210d03E8585FC8FFb41D008C6b4962001E346",
            43113: "0x692d1A26B49B8417d09b9CCD510096B933c8Bc4B",
            534353: "0xEc11bA12B74E0c6215FA66334c756780C2AB3fbb",
            137: "0xc8a94a3d3d2dabc3c1caffffdca6a7543c3e3e65"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($9208d705d599d8a6$exports))),
        decimals: {
            default: 2
        }
    },
    WETH: {
        name: "Wrapped Ether",
        ticker: "WETH",
        addresses: {
            1: "0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2",
            31337: "0xC89366f3e4C59DDBf17fb116ba9DF8bbD806338c",
            5: "0x0DAa76b8ebdAe1c170bc350c9E0eFb2C595de621",
            80001: "0x9aE88Fb19F76d07996b7d5Bc5d45E9747e6E0b31",
            4002: "0x692d1A26B49B8417d09b9CCD510096B933c8Bc4B",
            11155111: "0xa5Da2a6f19D79A88bd280d758393793d348FcD3D",
            1313161555: "0x54a2D690d06DFa62d911355F5d2f79ceA1f81C8c",
            43113: "0xa550DDe4f887Bd3B49137BAbE38BBD6bFa4e0BDA",
            534353: "0x7FDbC336F0d85BC31511fE20d582c7dCA46233e3",
            137: "0x7ceb23fd6bc0add59e62ac25578270cff1b9f619",
            56: "0x2170ed0880ac9a755fd29b2688956bd959f933f8",
            250: "0x74b23882a30290451A17c44f4F05243b6b58C76d",
            43114: "0x49D5c2BdFfac6CE2BFdB6640F4F80f226bc10bAB"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($7e24d2c6c5fdfe09$exports))),
        decimals: {
            default: 18
        }
    },
    WBNB: {
        name: "Wrapped BNB",
        ticker: "WBNB",
        addresses: {
            56: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($6f1e8ceecab5748c$exports))),
        decimals: {
            default: 18
        }
    },
    WMATIC: {
        name: "Wrapped Polygon",
        ticker: "WMATIC",
        pricefeedTicker: "MATIC",
        addresses: {
            137: "0x0d500b1d8e8ef31e21c99d1db9a6444d3adf1270"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($5a57dde235c79701$exports))),
        decimals: {
            default: 18
        }
    },
    BAT: {
        name: "Basic Attention Token",
        ticker: "BAT",
        addresses: {
            1: "0x0d8775f648430679a709e98d2b0cb6250d2887ef",
            137: "0x3cef98bb43d732e2f285ee605a8158cde967d219",
            56: "0x101d82428437127bf1608f699cd651e6abf9766e",
            80001: "0xd445cAAbb9eA6685D3A512439256866563a16E93",
            4002: "0x5720755857EF377D59cb8758B5E3eDBC483b4467",
            11155111: "0x5D684d37922dAf7Aa2013E65A22880a11C475e25",
            1313161555: "0x8dEf8ef4ea453c4dd988c1596DD6FaDD6A291e53",
            43113: "0xABB6a5C05a70098585D095D5446b6845b57E2873"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($4343aa8ba0291c55$exports))),
        decimals: {
            default: 18
        }
    },
    PRQ: {
        name: "Parsiq Token",
        ticker: "PRQ",
        addresses: {
            1: "0x362bc847A3a9637d3af6624EeC853618a43ed7D2"
        },
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($15405652ff4767c1$exports))),
        decimals: {
            default: 18
        }
    }
};
function $88337873f840b6bb$export$257b2d10b709d8ef(address, chainId) {
    const token = Object.values($88337873f840b6bb$export$8e1e81ac145e31be).find((t)=>Object.entries(t.addresses).find(([chain, addr])=>chain.toString() === chainId.toString() && addr.toLowerCase() === address.toLowerCase()));
    if (!token) return {
        name: "Unknown",
        ticker: "UNKNOWN",
        addresses: {},
        logo: "",
        decimals: {
            default: 18
        }
    };
    return token;
}


const $3562cc065b5f3994$export$330f51eee3728a4c = [
    {
        icon: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            style: {
                width: "inherit",
                opacity: 0.4
            },
            children: "$"
        }),
        ticker: "USD"
    },
    {
        icon: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            style: {
                width: "inherit",
                opacity: 0.4
            },
            children: "$"
        }),
        ticker: "CAD"
    },
    {
        icon: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            style: {
                width: "inherit",
                opacity: 0.4
            },
            children: "\xa3"
        }),
        ticker: "GBP"
    },
    {
        icon: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
            style: {
                width: "inherit",
                opacity: 0.4
            },
            children: "\u20AC"
        }),
        ticker: "EUR"
    },
    {
        icon: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
            src: (0, $88337873f840b6bb$export$8e1e81ac145e31be).USDC.logo,
            style: {
                width: "inherit"
            }
        }),
        ticker: "USDC"
    },
    {
        icon: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
            src: (0, $88337873f840b6bb$export$8e1e81ac145e31be).USDT.logo,
            style: {
                width: "inherit"
            }
        }),
        ticker: "USDT"
    }
];
const $3562cc065b5f3994$export$413b0d1e3ece6964 = [
    "USDT",
    "USDC",
    "ETH"
];
const $3562cc065b5f3994$export$3dc27271f5d5c629 = (currency, amount, decimals = 2)=>{
    const effectiveDecimals = decimals !== undefined ? decimals : 2;
    const numericAmount = typeof amount === "number" ? amount : Number(amount);
    if (!$3562cc065b5f3994$export$413b0d1e3ece6964.includes(currency)) try {
        const options = {
            style: "currency",
            currency: currency,
            minimumFractionDigits: effectiveDecimals,
            maximumFractionDigits: effectiveDecimals
        };
        const formattedAmount = Intl.NumberFormat("en-US", options).format(numericAmount).replace(/(\.\d*[1-9])0+$|\.0*$/, "$1");
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
            children: formattedAmount
        });
    } catch (err) {
        const tokenFormattedAmount = numericAmount.toFixed(6).replace(/(\.\d*[1-9])0+$|\.0*$/, "$1");
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            style: {
                display: "inline-flex",
                gap: "4px"
            },
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                    children: tokenFormattedAmount
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                    style: {
                        color: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARKER
                    },
                    children: currency
                })
            ]
        });
    }
    const tokenFormattedAmount = numericAmount.toFixed(6).replace(/(\.\d*[1-9])0+$|\.0*$/, "$1");
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
        style: {
            display: "inline-flex",
            gap: "4px"
        },
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                children: tokenFormattedAmount
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                style: {
                    color: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARKER
                },
                children: currency
            })
        ]
    });
};
const $3562cc065b5f3994$export$bc56dd87ebd6aae2 = (currency, amount)=>{
    if (!$3562cc065b5f3994$export$413b0d1e3ece6964.includes(currency)) try {
        return Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currency
        }).format(amount);
    } catch (err) {
        return Intl.NumberFormat("en-US").format(amount);
    }
    return `${Intl.NumberFormat("en-US").format(amount)} ${currency}`;
};




var $8NFma = parcelRequire("8NFma");
let $dbb64e404ec3de5f$var$modal = undefined;
function $dbb64e404ec3de5f$export$db9d243f55cd9d82(web3modal) {
    if (web3modal) $dbb64e404ec3de5f$var$modal = web3modal;
}
function $dbb64e404ec3de5f$export$7cb034a59823159f() {
    if (!$dbb64e404ec3de5f$var$modal) throw new Error('Please call "createWeb3Modal" before using "useWeb3ModalTheme" hook');
    function setThemeMode(themeMode) {
        $dbb64e404ec3de5f$var$modal?.setThemeMode(themeMode);
    }
    function setThemeVariables(themeVariables) {
        $dbb64e404ec3de5f$var$modal?.setThemeVariables(themeVariables);
    }
    const [themeMode, setInternalThemeMode] = (0, $8NFma.useState)($dbb64e404ec3de5f$var$modal.getThemeMode());
    const [themeVariables, setInternalThemeVariables] = (0, $8NFma.useState)($dbb64e404ec3de5f$var$modal.getThemeVariables());
    (0, $8NFma.useEffect)(()=>{
        const unsubscribe = $dbb64e404ec3de5f$var$modal?.subscribeTheme((state)=>{
            setInternalThemeMode(state.themeMode);
            setInternalThemeVariables(state.themeVariables);
        });
        return ()=>{
            unsubscribe?.();
        };
    }, []);
    return {
        themeMode: themeMode,
        themeVariables: themeVariables,
        setThemeMode: setThemeMode,
        setThemeVariables: setThemeVariables
    };
}
function $dbb64e404ec3de5f$export$69804ca079d47f29() {
    if (!$dbb64e404ec3de5f$var$modal) throw new Error('Please call "createWeb3Modal" before using "useWeb3Modal" hook');
    async function open(options) {
        await $dbb64e404ec3de5f$var$modal?.open(options);
    }
    async function close() {
        await $dbb64e404ec3de5f$var$modal?.close();
    }
    return {
        open: open,
        close: close
    };
}
function $dbb64e404ec3de5f$export$462a1af4ea315fad() {
    if (!$dbb64e404ec3de5f$var$modal) throw new Error('Please call "createWeb3Modal" before using "useWeb3ModalState" hook');
    const [state, setState] = (0, $8NFma.useState)($dbb64e404ec3de5f$var$modal.getState());
    (0, $8NFma.useEffect)(()=>{
        const unsubscribe = $dbb64e404ec3de5f$var$modal?.subscribeState((newState)=>{
            setState({
                ...newState
            });
        });
        return ()=>{
            unsubscribe?.();
        };
    }, []);
    return state;
}
function $dbb64e404ec3de5f$export$cd17534826f46144() {
    if (!$dbb64e404ec3de5f$var$modal) throw new Error('Please call "createWeb3Modal" before using "useWeb3ModalState" hook');
    const [event, setEvents] = (0, $8NFma.useState)($dbb64e404ec3de5f$var$modal.getEvent());
    (0, $8NFma.useEffect)(()=>{
        const unsubscribe = $dbb64e404ec3de5f$var$modal?.subscribeEvents((newEvent)=>{
            setEvents({
                ...newEvent
            });
        });
        return ()=>{
            unsubscribe?.();
        };
    }, []);
    return event;
}




let $f4478bf7da9e4de4$var$modal = undefined;
function $f4478bf7da9e4de4$export$14650d4efb17e382(options) {
    if (!$f4478bf7da9e4de4$var$modal) {
        $f4478bf7da9e4de4$var$modal = new (0, $ea8eaf0132f2eca6$export$c03599cd5308d12b)({
            ...options,
            _sdkVersion: `react-wagmi-${(0, $eee1c86a56cc8066$export$aafe1f751f1bc52a).VERSION}`
        });
        (0, $dbb64e404ec3de5f$export$db9d243f55cd9d82)($f4478bf7da9e4de4$var$modal);
    }
    return $f4478bf7da9e4de4$var$modal;
}


var $5bdcb58bd181ac10$var$defaultOptions = {};
function $5bdcb58bd181ac10$export$430a3269e24b912e() {
    return $5bdcb58bd181ac10$var$defaultOptions;
}
function $5bdcb58bd181ac10$export$95365be1b0704abc(newOptions) {
    $5bdcb58bd181ac10$var$defaultOptions = newOptions;
}


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $c6138e3e9e222cc3$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}


function $e6d8aa307cfbe8b4$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $e6d8aa307cfbe8b4$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e6d8aa307cfbe8b4$export$2e2bcd8739ae039(o);
}


function $e5b6e627005992fb$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}


function $db295730c81e792c$export$2e2bcd8739ae039(argument) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $e6d8aa307cfbe8b4$export$2e2bcd8739ae039)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $dabc289cdb54673c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}



var $af8883233baae810$var$MILLISECONDS_IN_DAY = 86400000;
function $af8883233baae810$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(2, arguments);
    var startOfDayLeft = (0, $dabc289cdb54673c$export$2e2bcd8739ae039)(dirtyDateLeft);
    var startOfDayRight = (0, $dabc289cdb54673c$export$2e2bcd8739ae039)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $c6138e3e9e222cc3$export$2e2bcd8739ae039)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $c6138e3e9e222cc3$export$2e2bcd8739ae039)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $af8883233baae810$var$MILLISECONDS_IN_DAY);
}




function $33099d3a0ee000b6$export$2e2bcd8739ae039(value) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    return value instanceof Date || (0, $e6d8aa307cfbe8b4$export$2e2bcd8739ae039)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}




function $62b6aa7362d709e7$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    if (!(0, $33099d3a0ee000b6$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(Number(date));
}


function $915d833559b42c3f$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}




function $6ec7037ed5e3d5c3$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $915d833559b42c3f$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}




function $59c24a9e74e1c5c0$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $915d833559b42c3f$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $6ec7037ed5e3d5c3$export$2e2bcd8739ae039)(dirtyDate, -amount);
}





var $f59bdeb98608936d$var$MILLISECONDS_IN_DAY = 86400000;
function $f59bdeb98608936d$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $f59bdeb98608936d$var$MILLISECONDS_IN_DAY) + 1;
}





function $48caadaecccd9d4f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}





function $c923e234d864ebd7$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $48caadaecccd9d4f$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $48caadaecccd9d4f$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $d969d9c83bc56a0e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $c923e234d864ebd7$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $48caadaecccd9d4f$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $d2c40956b8ab3953$var$MILLISECONDS_IN_WEEK = 604800000;
function $d2c40956b8ab3953$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $48caadaecccd9d4f$export$2e2bcd8739ae039)(date).getTime() - (0, $d969d9c83bc56a0e$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $d2c40956b8ab3953$var$MILLISECONDS_IN_WEEK) + 1;
}








function $a4a8a151e5e43f6b$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $5bdcb58bd181ac10$export$430a3269e24b912e)();
    var weekStartsOn = (0, $915d833559b42c3f$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}







function $9acdbcf7776722e9$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $5bdcb58bd181ac10$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $915d833559b42c3f$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $a4a8a151e5e43f6b$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $a4a8a151e5e43f6b$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $f6aee5547809ce40$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $5bdcb58bd181ac10$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $915d833559b42c3f$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $9acdbcf7776722e9$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $a4a8a151e5e43f6b$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}



var $c6f84a8f2fb5610c$var$MILLISECONDS_IN_WEEK = 604800000;
function $c6f84a8f2fb5610c$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $a4a8a151e5e43f6b$export$2e2bcd8739ae039)(date, options).getTime() - (0, $f6aee5547809ce40$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $c6f84a8f2fb5610c$var$MILLISECONDS_IN_WEEK) + 1;
}



function $a818db1c2d04a150$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}



/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $5389fd1b998732ff$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(fractionalSeconds, token.length);
    }
};
var $5389fd1b998732ff$export$2e2bcd8739ae039 = $5389fd1b998732ff$var$formatters;


var $4a2755b1807fc917$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $4a2755b1807fc917$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $5389fd1b998732ff$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $9acdbcf7776722e9$export$2e2bcd8739ae039)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $c923e234d864ebd7$export$2e2bcd8739ae039)(date);
        // Padding
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $5389fd1b998732ff$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $c6f84a8f2fb5610c$export$2e2bcd8739ae039)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $d2c40956b8ab3953$export$2e2bcd8739ae039)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, $5389fd1b998732ff$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $f59bdeb98608936d$export$2e2bcd8739ae039)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $4a2755b1807fc917$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $4a2755b1807fc917$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $4a2755b1807fc917$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $4a2755b1807fc917$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $4a2755b1807fc917$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $4a2755b1807fc917$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $5389fd1b998732ff$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, $5389fd1b998732ff$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, $5389fd1b998732ff$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, $5389fd1b998732ff$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $5389fd1b998732ff$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $4a2755b1807fc917$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return $4a2755b1807fc917$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $4a2755b1807fc917$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $4a2755b1807fc917$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return $4a2755b1807fc917$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $4a2755b1807fc917$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $4a2755b1807fc917$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $4a2755b1807fc917$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $4a2755b1807fc917$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $4a2755b1807fc917$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(timestamp, token.length);
    }
};
function $4a2755b1807fc917$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(minutes, 2);
}
function $4a2755b1807fc917$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(Math.abs(offset) / 60, 2);
    }
    return $4a2755b1807fc917$var$formatTimezone(offset, dirtyDelimiter);
}
function $4a2755b1807fc917$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $a818db1c2d04a150$export$2e2bcd8739ae039)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $4a2755b1807fc917$export$2e2bcd8739ae039 = $4a2755b1807fc917$var$formatters;


var $a188900c436ed76e$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $a188900c436ed76e$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $a188900c436ed76e$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $a188900c436ed76e$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $a188900c436ed76e$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $a188900c436ed76e$var$timeLongFormatter(timePattern, formatLong));
};
var $a188900c436ed76e$var$longFormatters = {
    p: $a188900c436ed76e$var$timeLongFormatter,
    P: $a188900c436ed76e$var$dateTimeLongFormatter
};
var $a188900c436ed76e$export$2e2bcd8739ae039 = $a188900c436ed76e$var$longFormatters;



var $a47722dda2cd757f$var$protectedDayOfYearTokens = [
    "D",
    "DD"
];
var $a47722dda2cd757f$var$protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function $a47722dda2cd757f$export$c6cc36aa33304772(token) {
    return $a47722dda2cd757f$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $a47722dda2cd757f$export$c6b49d6dceb604a1(token) {
    return $a47722dda2cd757f$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $a47722dda2cd757f$export$8073c1ae88f0e727(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}





var $a0fcf9a783a9c8cf$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $a0fcf9a783a9c8cf$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $a0fcf9a783a9c8cf$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $a0fcf9a783a9c8cf$export$2e2bcd8739ae039 = $a0fcf9a783a9c8cf$var$formatDistance;


function $46e336c804985263$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $f1af66fefd840e85$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $f1af66fefd840e85$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $f1af66fefd840e85$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $f1af66fefd840e85$var$formatLong = {
    date: (0, $46e336c804985263$export$2e2bcd8739ae039)({
        formats: $f1af66fefd840e85$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $46e336c804985263$export$2e2bcd8739ae039)({
        formats: $f1af66fefd840e85$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $46e336c804985263$export$2e2bcd8739ae039)({
        formats: $f1af66fefd840e85$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $f1af66fefd840e85$export$2e2bcd8739ae039 = $f1af66fefd840e85$var$formatLong;


var $2d69cb397acad490$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $2d69cb397acad490$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $2d69cb397acad490$var$formatRelativeLocale[token];
};
var $2d69cb397acad490$export$2e2bcd8739ae039 = $2d69cb397acad490$var$formatRelative;


function $e43ff33ed7f225ec$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $c4f46a8d544f3daa$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $c4f46a8d544f3daa$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $c4f46a8d544f3daa$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $c4f46a8d544f3daa$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $c4f46a8d544f3daa$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $c4f46a8d544f3daa$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $c4f46a8d544f3daa$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $c4f46a8d544f3daa$var$localize = {
    ordinalNumber: $c4f46a8d544f3daa$var$ordinalNumber,
    era: (0, $e43ff33ed7f225ec$export$2e2bcd8739ae039)({
        values: $c4f46a8d544f3daa$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $e43ff33ed7f225ec$export$2e2bcd8739ae039)({
        values: $c4f46a8d544f3daa$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $e43ff33ed7f225ec$export$2e2bcd8739ae039)({
        values: $c4f46a8d544f3daa$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $e43ff33ed7f225ec$export$2e2bcd8739ae039)({
        values: $c4f46a8d544f3daa$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $e43ff33ed7f225ec$export$2e2bcd8739ae039)({
        values: $c4f46a8d544f3daa$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $c4f46a8d544f3daa$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $c4f46a8d544f3daa$export$2e2bcd8739ae039 = $c4f46a8d544f3daa$var$localize;


function $f3b96828de7939a6$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $f3b96828de7939a6$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $f3b96828de7939a6$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $f3b96828de7939a6$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $f3b96828de7939a6$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $13e5a388dae711de$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $32f30a5965252391$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $32f30a5965252391$var$parseOrdinalNumberPattern = /\d+/i;
var $32f30a5965252391$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $32f30a5965252391$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $32f30a5965252391$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $32f30a5965252391$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $32f30a5965252391$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $32f30a5965252391$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $32f30a5965252391$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $32f30a5965252391$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $32f30a5965252391$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $32f30a5965252391$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $32f30a5965252391$var$match = {
    ordinalNumber: (0, $13e5a388dae711de$export$2e2bcd8739ae039)({
        matchPattern: $32f30a5965252391$var$matchOrdinalNumberPattern,
        parsePattern: $32f30a5965252391$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $f3b96828de7939a6$export$2e2bcd8739ae039)({
        matchPatterns: $32f30a5965252391$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $32f30a5965252391$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $f3b96828de7939a6$export$2e2bcd8739ae039)({
        matchPatterns: $32f30a5965252391$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $32f30a5965252391$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $f3b96828de7939a6$export$2e2bcd8739ae039)({
        matchPatterns: $32f30a5965252391$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $32f30a5965252391$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $f3b96828de7939a6$export$2e2bcd8739ae039)({
        matchPatterns: $32f30a5965252391$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $32f30a5965252391$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $f3b96828de7939a6$export$2e2bcd8739ae039)({
        matchPatterns: $32f30a5965252391$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $32f30a5965252391$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $32f30a5965252391$export$2e2bcd8739ae039 = $32f30a5965252391$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $1fab302b13b08d66$var$locale = {
    code: "en-US",
    formatDistance: (0, $a0fcf9a783a9c8cf$export$2e2bcd8739ae039),
    formatLong: (0, $f1af66fefd840e85$export$2e2bcd8739ae039),
    formatRelative: (0, $2d69cb397acad490$export$2e2bcd8739ae039),
    localize: (0, $c4f46a8d544f3daa$export$2e2bcd8739ae039),
    match: (0, $32f30a5965252391$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $1fab302b13b08d66$export$2e2bcd8739ae039 = $1fab302b13b08d66$var$locale;


var $ff2f5d41cd8b653b$export$2e2bcd8739ae039 = (0, $1fab302b13b08d66$export$2e2bcd8739ae039);


// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $3aad3dc8a82b847c$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $3aad3dc8a82b847c$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $3aad3dc8a82b847c$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $3aad3dc8a82b847c$var$doubleQuoteRegExp = /''/g;
var $3aad3dc8a82b847c$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $3aad3dc8a82b847c$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $5bdcb58bd181ac10$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $ff2f5d41cd8b653b$export$2e2bcd8739ae039);
    var firstWeekContainsDate = (0, $915d833559b42c3f$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $915d833559b42c3f$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    if (!(0, $62b6aa7362d709e7$export$2e2bcd8739ae039)(originalDate)) throw new RangeError("Invalid time value");
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $c6138e3e9e222cc3$export$2e2bcd8739ae039)(originalDate);
    var utcDate = (0, $59c24a9e74e1c5c0$export$2e2bcd8739ae039)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($3aad3dc8a82b847c$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, $a188900c436ed76e$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($3aad3dc8a82b847c$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $3aad3dc8a82b847c$var$cleanEscapedString(substring);
        var formatter = (0, $4a2755b1807fc917$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $a47722dda2cd757f$export$c6b49d6dceb604a1)(substring)) (0, $a47722dda2cd757f$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $a47722dda2cd757f$export$c6cc36aa33304772)(substring)) (0, $a47722dda2cd757f$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($3aad3dc8a82b847c$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $3aad3dc8a82b847c$var$cleanEscapedString(input) {
    var matched = input.match($3aad3dc8a82b847c$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($3aad3dc8a82b847c$var$doubleQuoteRegExp, "'");
}








function $965fc399e1b2030f$export$2e2bcd8739ae039(dirtyDate, dirtyBaseDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$weekStartsOn, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2;
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    var baseDate = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyBaseDate);
    var defaultOptions = (0, $5bdcb58bd181ac10$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $ff2f5d41cd8b653b$export$2e2bcd8739ae039);
    var weekStartsOn = (0, $915d833559b42c3f$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.weekStartsOn) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0);
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    if (!locale.formatRelative) throw new RangeError("locale must contain formatRelative property");
    var diff = (0, $af8883233baae810$export$2e2bcd8739ae039)(date, baseDate);
    if (isNaN(diff)) throw new RangeError("Invalid time value");
    var token;
    if (diff < -6) token = "other";
    else if (diff < -1) token = "lastWeek";
    else if (diff < 0) token = "yesterday";
    else if (diff < 1) token = "today";
    else if (diff < 2) token = "tomorrow";
    else if (diff < 7) token = "nextWeek";
    else token = "other";
    var utcDate = (0, $59c24a9e74e1c5c0$export$2e2bcd8739ae039)(date, (0, $c6138e3e9e222cc3$export$2e2bcd8739ae039)(date));
    var utcBaseDate = (0, $59c24a9e74e1c5c0$export$2e2bcd8739ae039)(baseDate, (0, $c6138e3e9e222cc3$export$2e2bcd8739ae039)(baseDate));
    var formatStr = locale.formatRelative(token, utcDate, utcBaseDate, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
    return (0, $3aad3dc8a82b847c$export$2e2bcd8739ae039)(date, formatStr, {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
}



function $a17d8ed27c1eb490$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDateRight);
    var diff = dateLeft.getTime() - dateRight.getTime();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}






function $700c805b81e44b88$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $915d833559b42c3f$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}





function $d7bc25d526160177$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $915d833559b42c3f$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}





function $d04979f5c6e52c5b$export$2e2bcd8739ae039(dirtyDate, duration) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(2, arguments);
    if (!duration || (0, $e6d8aa307cfbe8b4$export$2e2bcd8739ae039)(duration) !== "object") return new Date(NaN);
    var years = duration.years ? (0, $915d833559b42c3f$export$2e2bcd8739ae039)(duration.years) : 0;
    var months = duration.months ? (0, $915d833559b42c3f$export$2e2bcd8739ae039)(duration.months) : 0;
    var weeks = duration.weeks ? (0, $915d833559b42c3f$export$2e2bcd8739ae039)(duration.weeks) : 0;
    var days = duration.days ? (0, $915d833559b42c3f$export$2e2bcd8739ae039)(duration.days) : 0;
    var hours = duration.hours ? (0, $915d833559b42c3f$export$2e2bcd8739ae039)(duration.hours) : 0;
    var minutes = duration.minutes ? (0, $915d833559b42c3f$export$2e2bcd8739ae039)(duration.minutes) : 0;
    var seconds = duration.seconds ? (0, $915d833559b42c3f$export$2e2bcd8739ae039)(duration.seconds) : 0;
    // Add years and months
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    var dateWithMonths = months || years ? (0, $d7bc25d526160177$export$2e2bcd8739ae039)(date, months + years * 12) : date;
    // Add weeks and days
    var dateWithDays = days || weeks ? (0, $700c805b81e44b88$export$2e2bcd8739ae039)(dateWithMonths, days + weeks * 7) : dateWithMonths;
    // Add days, hours, minutes and seconds
    var minutesToAdd = minutes + hours * 60;
    var secondsToAdd = seconds + minutesToAdd * 60;
    var msToAdd = secondsToAdd * 1000;
    var finalDate = new Date(dateWithDays.getTime() + msToAdd);
    return finalDate;
}





// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $1a4c4c8b9bea7441$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $1a4c4c8b9bea7441$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = $1a4c4c8b9bea7441$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $af8883233baae810$export$2e2bcd8739ae039)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($1a4c4c8b9bea7441$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}


/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $5c6855f17eac7feb$export$dfd9b671c89acc8e = 7;
var $5c6855f17eac7feb$export$3913210603d8e9ae = 365.2425;
var $5c6855f17eac7feb$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $5c6855f17eac7feb$export$91246f0b9bd9beff = 60000;
var $5c6855f17eac7feb$export$7f72910d6dfd237a = 3600000;
var $5c6855f17eac7feb$export$397c2d5776aa9055 = 1000;
var $5c6855f17eac7feb$export$4dec998e48f9c246 = -$5c6855f17eac7feb$export$81caae6e1cc7a622;
var $5c6855f17eac7feb$export$f2f5ae5a8e2d8f9f = 60;
var $5c6855f17eac7feb$export$3c58128db900d44e = 3;
var $5c6855f17eac7feb$export$80d7e435f744f319 = 12;
var $5c6855f17eac7feb$export$4db7641526e3241f = 4;
var $5c6855f17eac7feb$export$698aec755e92c695 = 3600;
var $5c6855f17eac7feb$export$a77c1a7ebebe2a5a = 60;
var $5c6855f17eac7feb$export$815a9362476d2fe3 = $5c6855f17eac7feb$export$698aec755e92c695 * 24;
var $5c6855f17eac7feb$export$34804a017b31e2fe = $5c6855f17eac7feb$export$815a9362476d2fe3 * 7;
var $5c6855f17eac7feb$export$7271e9e3478110d1 = $5c6855f17eac7feb$export$815a9362476d2fe3 * $5c6855f17eac7feb$export$3913210603d8e9ae;
var $5c6855f17eac7feb$export$8e6600bbdee7dabb = $5c6855f17eac7feb$export$7271e9e3478110d1 / 12;
var $5c6855f17eac7feb$export$be1dccf2de902d31 = $5c6855f17eac7feb$export$8e6600bbdee7dabb * 3;




function $e8682246a6dbb418$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(2, arguments);
    return (0, $db295730c81e792c$export$2e2bcd8739ae039)(dateLeft).getTime() - (0, $db295730c81e792c$export$2e2bcd8739ae039)(dateRight).getTime();
}



var $eae8817a119fdba4$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $eae8817a119fdba4$var$defaultRoundingMethod = "trunc";
function $eae8817a119fdba4$export$b6474a47258c1211(method) {
    return method ? $eae8817a119fdba4$var$roundingMap[method] : $eae8817a119fdba4$var$roundingMap[$eae8817a119fdba4$var$defaultRoundingMethod];
}


function $aefdef00e8783960$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(2, arguments);
    var diff = (0, $e8682246a6dbb418$export$2e2bcd8739ae039)(dateLeft, dateRight) / (0, $5c6855f17eac7feb$export$7f72910d6dfd237a);
    return (0, $eae8817a119fdba4$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}






function $0358d42e51ba6bd2$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(2, arguments);
    var diff = (0, $e8682246a6dbb418$export$2e2bcd8739ae039)(dateLeft, dateRight) / (0, $5c6855f17eac7feb$export$91246f0b9bd9beff);
    return (0, $eae8817a119fdba4$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}





function $45cc92cfa09828ec$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}







function $51217ea95500cea3$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}




function $fb889019b26cae02$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}



function $a3cce2a31ed4f806$export$2e2bcd8739ae039(dirtyDate) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    return (0, $51217ea95500cea3$export$2e2bcd8739ae039)(date).getTime() === (0, $fb889019b26cae02$export$2e2bcd8739ae039)(date).getTime();
}


function $e5104d01f5b52383$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = (0, $a17d8ed27c1eb490$export$2e2bcd8739ae039)(dateLeft, dateRight);
    var difference = Math.abs((0, $45cc92cfa09828ec$export$2e2bcd8739ae039)(dateLeft, dateRight));
    var result;
    // Check for the difference of less than month
    if (difference < 1) result = 0;
    else {
        if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) // This will check if the date is end of Feb and assign a higher end of month date
        // to compare it with Jan
        dateLeft.setDate(30);
        dateLeft.setMonth(dateLeft.getMonth() - sign * difference);
        // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
        // If so, result must be decreased by 1 in absolute value
        var isLastMonthNotFull = (0, $a17d8ed27c1eb490$export$2e2bcd8739ae039)(dateLeft, dateRight) === -sign;
        // Check for cases of one full calendar month
        if ((0, $a3cce2a31ed4f806$export$2e2bcd8739ae039)((0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDateLeft)) && difference === 1 && (0, $a17d8ed27c1eb490$export$2e2bcd8739ae039)(dirtyDateLeft, dateRight) === 1) isLastMonthNotFull = false;
        result = sign * (difference - Number(isLastMonthNotFull));
    }
    // Prevent negative zero
    return result === 0 ? 0 : result;
}





function $df07c48362c169dc$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(2, arguments);
    var diff = (0, $e8682246a6dbb418$export$2e2bcd8739ae039)(dateLeft, dateRight) / 1000;
    return (0, $eae8817a119fdba4$export$b6474a47258c1211)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}





function $336ceb2508875bc1$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}




function $5337609d7ee3109b$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDateRight);
    var sign = (0, $a17d8ed27c1eb490$export$2e2bcd8739ae039)(dateLeft, dateRight);
    var difference = Math.abs((0, $336ceb2508875bc1$export$2e2bcd8739ae039)(dateLeft, dateRight));
    // Set both dates to a valid leap year for accurate comparison when dealing
    // with leap days
    dateLeft.setFullYear(1584);
    dateRight.setFullYear(1584);
    // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastYearNotFull = (0, $a17d8ed27c1eb490$export$2e2bcd8739ae039)(dateLeft, dateRight) === -sign;
    var result = sign * (difference - Number(isLastYearNotFull));
    // Prevent negative zero
    return result === 0 ? 0 : result;
}




function $16f75469e5b80165$export$2e2bcd8739ae039(interval) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var start = (0, $db295730c81e792c$export$2e2bcd8739ae039)(interval.start);
    var end = (0, $db295730c81e792c$export$2e2bcd8739ae039)(interval.end);
    if (isNaN(start.getTime())) throw new RangeError("Start Date is invalid");
    if (isNaN(end.getTime())) throw new RangeError("End Date is invalid");
    var duration = {};
    duration.years = Math.abs((0, $5337609d7ee3109b$export$2e2bcd8739ae039)(end, start));
    var sign = (0, $a17d8ed27c1eb490$export$2e2bcd8739ae039)(end, start);
    var remainingMonths = (0, $d04979f5c6e52c5b$export$2e2bcd8739ae039)(start, {
        years: sign * duration.years
    });
    duration.months = Math.abs((0, $e5104d01f5b52383$export$2e2bcd8739ae039)(end, remainingMonths));
    var remainingDays = (0, $d04979f5c6e52c5b$export$2e2bcd8739ae039)(remainingMonths, {
        months: sign * duration.months
    });
    duration.days = Math.abs((0, $1a4c4c8b9bea7441$export$2e2bcd8739ae039)(end, remainingDays));
    var remainingHours = (0, $d04979f5c6e52c5b$export$2e2bcd8739ae039)(remainingDays, {
        days: sign * duration.days
    });
    duration.hours = Math.abs((0, $aefdef00e8783960$export$2e2bcd8739ae039)(end, remainingHours));
    var remainingMinutes = (0, $d04979f5c6e52c5b$export$2e2bcd8739ae039)(remainingHours, {
        hours: sign * duration.hours
    });
    duration.minutes = Math.abs((0, $0358d42e51ba6bd2$export$2e2bcd8739ae039)(end, remainingMinutes));
    var remainingSeconds = (0, $d04979f5c6e52c5b$export$2e2bcd8739ae039)(remainingMinutes, {
        minutes: sign * duration.minutes
    });
    duration.seconds = Math.abs((0, $df07c48362c169dc$export$2e2bcd8739ae039)(end, remainingSeconds));
    return duration;
}




function $7fc809a90a42d5fb$export$2e2bcd8739ae039(dirtyDatesArray) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") datesArray = dirtyDatesArray;
    else if ((0, $e6d8aa307cfbe8b4$export$2e2bcd8739ae039)(dirtyDatesArray) === "object" && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
        if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) result = currentDate;
    });
    return result || new Date(NaN);
}



var $O6tRJ = parcelRequire("O6tRJ");

var $8NFma = parcelRequire("8NFma");



var $9nOfC = parcelRequire("9nOfC");

var $ktUQf = parcelRequire("ktUQf");

var $ahylX = parcelRequire("ahylX");

var $kErjY = parcelRequire("kErjY");

var $44bP9 = parcelRequire("44bP9");

var $9UP4H = parcelRequire("9UP4H");





async function $049cb9fbb03db7a2$export$24b77c7e87f05b8d(client, { blockNumber: blockNumber, blockTag: blockTag, coinType: coinType, name: name, gatewayUrls: gatewayUrls, strict: strict, universalResolverAddress: universalResolverAddress_ }) {
    let universalResolverAddress = universalResolverAddress_;
    if (!universalResolverAddress) {
        if (!client.chain) throw new Error("client chain not configured. universalResolverAddress is required.");
        universalResolverAddress = (0, $kErjY.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "ensUniversalResolver"
        });
    }
    try {
        const functionData = (0, $ahylX.encodeFunctionData)({
            abi: (0, $9nOfC.addressResolverAbi),
            functionName: "addr",
            ...coinType != null ? {
                args: [
                    (0, $406c752c82e49948$export$91d651ee363e1209)(name),
                    BigInt(coinType)
                ]
            } : {
                args: [
                    (0, $406c752c82e49948$export$91d651ee363e1209)(name)
                ]
            }
        });
        const readContractParameters = {
            address: universalResolverAddress,
            abi: (0, $9nOfC.universalResolverResolveAbi),
            functionName: "resolve",
            args: [
                (0, $9UP4H.toHex)((0, $a48622506b78a6f9$export$8a0899f9ded0844)(name)),
                functionData
            ],
            blockNumber: blockNumber,
            blockTag: blockTag
        };
        const readContractAction = (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $345cd736baedaec0$export$43af7de392176737), "readContract");
        const res = gatewayUrls ? await readContractAction({
            ...readContractParameters,
            args: [
                ...readContractParameters.args,
                gatewayUrls
            ]
        }) : await readContractAction(readContractParameters);
        if (res[0] === "0x") return null;
        const address = (0, $ktUQf.decodeFunctionResult)({
            abi: (0, $9nOfC.addressResolverAbi),
            args: coinType != null ? [
                (0, $406c752c82e49948$export$91d651ee363e1209)(name),
                BigInt(coinType)
            ] : undefined,
            functionName: "addr",
            data: res[0]
        });
        if (address === "0x") return null;
        if ((0, $44bP9.trim)(address) === "0x00") return null;
        return address;
    } catch (err) {
        if (strict) throw err;
        if ((0, $a72348f10fc03c7b$export$78f90e26b9356cd7)(err, "resolve")) return null;
        throw err;
    }
}





var $kErjY = parcelRequire("kErjY");

var $9UP4H = parcelRequire("9UP4H");



async function $c8195b24319ef4b8$export$ba1240cd558e6b31(client, { blockNumber: blockNumber, blockTag: blockTag, name: name, universalResolverAddress: universalResolverAddress_ }) {
    let universalResolverAddress = universalResolverAddress_;
    if (!universalResolverAddress) {
        if (!client.chain) throw new Error("client chain not configured. universalResolverAddress is required.");
        universalResolverAddress = (0, $kErjY.getChainContractAddress)({
            blockNumber: blockNumber,
            chain: client.chain,
            contract: "ensUniversalResolver"
        });
    }
    const [resolverAddress] = await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $345cd736baedaec0$export$43af7de392176737), "readContract")({
        address: universalResolverAddress,
        abi: [
            {
                inputs: [
                    {
                        type: "bytes"
                    }
                ],
                name: "findResolver",
                outputs: [
                    {
                        type: "address"
                    },
                    {
                        type: "bytes32"
                    }
                ],
                stateMutability: "view",
                type: "function"
            }
        ],
        functionName: "findResolver",
        args: [
            (0, $9UP4H.toHex)((0, $a48622506b78a6f9$export$8a0899f9ded0844)(name))
        ],
        blockNumber: blockNumber,
        blockTag: blockTag
    });
    return resolverAddress;
}




var $49mjM = parcelRequire("49mjM");
/**
 * Scopes `request` to the filter ID. If the client is a fallback, it will
 * listen for responses and scope the child transport `request` function
 * to the successful filter ID.
 */ function $26700917420b28e4$export$b7aadf80a875f555(client, { method: method }) {
    const requestMap = {};
    if (client.transport.type === "fallback") client.transport.onResponse?.(({ method: method_, response: id, status: status, transport: transport })=>{
        if (status === "success" && method === method_) requestMap[id] = transport.request;
    });
    return (id)=>requestMap[id] || client.request;
}


async function $d31664d80afe85d0$export$651edd5ecf84bf98(client) {
    const getRequest = (0, $26700917420b28e4$export$b7aadf80a875f555)(client, {
        method: "eth_newBlockFilter"
    });
    const id = await client.request({
        method: "eth_newBlockFilter"
    });
    return {
        id: id,
        request: getRequest(id),
        type: "block"
    };
}



var $3TFRi = parcelRequire("3TFRi");

var $6F8ii = parcelRequire("6F8ii");
class $43bf09df023e9961$export$f71f080d25382681 extends (0, $6F8ii.BaseError) {
    constructor(type){
        super(`Filter type "${type}" is not supported.`, {
            name: "FilterTypeNotSupportedError"
        });
    }
}



var $eFDiV = parcelRequire("eFDiV");

var $bRe6l = parcelRequire("bRe6l");

var $gvzyN = parcelRequire("gvzyN");

var $keugB = parcelRequire("keugB");

var $dDQ3R = parcelRequire("dDQ3R");

var $lPlQ2 = parcelRequire("lPlQ2");
const $a41ca3912e02661b$var$docsPath = "/docs/contract/encodeEventTopics";
function $a41ca3912e02661b$export$64e9f7ca5ce29acd(parameters) {
    const { abi: abi, eventName: eventName, args: args } = parameters;
    let abiItem = abi[0];
    if (eventName) {
        const item = (0, $lPlQ2.getAbiItem)({
            abi: abi,
            name: eventName
        });
        if (!item) throw new (0, $3TFRi.AbiEventNotFoundError)(eventName, {
            docsPath: $a41ca3912e02661b$var$docsPath
        });
        abiItem = item;
    }
    if (abiItem.type !== "event") throw new (0, $3TFRi.AbiEventNotFoundError)(undefined, {
        docsPath: $a41ca3912e02661b$var$docsPath
    });
    const definition = (0, $dDQ3R.formatAbiItem)(abiItem);
    const signature = (0, $gvzyN.toEventSelector)(definition);
    let topics = [];
    if (args && "inputs" in abiItem) {
        const indexedInputs = abiItem.inputs?.filter((param)=>"indexed" in param && param.indexed);
        const args_ = Array.isArray(args) ? args : Object.values(args).length > 0 ? indexedInputs?.map((x)=>args[x.name]) ?? [] : [];
        if (args_.length > 0) topics = indexedInputs?.map((param, i)=>{
            if (Array.isArray(args_[i])) return args_[i].map((_, j)=>$a41ca3912e02661b$var$encodeArg({
                    param: param,
                    value: args_[i][j]
                }));
            return args_[i] ? $a41ca3912e02661b$var$encodeArg({
                param: param,
                value: args_[i]
            }) : null;
        }) ?? [];
    }
    return [
        signature,
        ...topics
    ];
}
function $a41ca3912e02661b$var$encodeArg({ param: param, value: value }) {
    if (param.type === "string" || param.type === "bytes") return (0, $bRe6l.keccak256)((0, $eFDiV.toBytes)(value));
    if (param.type === "tuple" || param.type.match(/^(.*)\[(\d+)?\]$/)) throw new (0, $43bf09df023e9961$export$f71f080d25382681)(param.type);
    return (0, $keugB.encodeAbiParameters)([
        param
    ], [
        value
    ]);
}



var $9UP4H = parcelRequire("9UP4H");

async function $ddde17ea7e9ef03d$export$36f99fdb90149e8b(client, parameters) {
    const { address: address, abi: abi, args: args, eventName: eventName, fromBlock: fromBlock, strict: strict, toBlock: toBlock } = parameters;
    const getRequest = (0, $26700917420b28e4$export$b7aadf80a875f555)(client, {
        method: "eth_newFilter"
    });
    const topics = eventName ? (0, $a41ca3912e02661b$export$64e9f7ca5ce29acd)({
        abi: abi,
        args: args,
        eventName: eventName
    }) : undefined;
    const id = await client.request({
        method: "eth_newFilter",
        params: [
            {
                address: address,
                fromBlock: typeof fromBlock === "bigint" ? (0, $9UP4H.numberToHex)(fromBlock) : fromBlock,
                toBlock: typeof toBlock === "bigint" ? (0, $9UP4H.numberToHex)(toBlock) : toBlock,
                topics: topics
            }
        ]
    });
    return {
        abi: abi,
        args: args,
        eventName: eventName,
        id: id,
        request: getRequest(id),
        strict: Boolean(strict),
        type: "event"
    };
}




var $9UP4H = parcelRequire("9UP4H");

async function $4ec0fdb59d57a0ab$export$977ab14bbccde633(client, { address: address, args: args, event: event, events: events_, fromBlock: fromBlock, strict: strict, toBlock: toBlock } = {}) {
    const events = events_ ?? (event ? [
        event
    ] : undefined);
    const getRequest = (0, $26700917420b28e4$export$b7aadf80a875f555)(client, {
        method: "eth_newFilter"
    });
    let topics = [];
    if (events) {
        const encoded = events.flatMap((event)=>(0, $a41ca3912e02661b$export$64e9f7ca5ce29acd)({
                abi: [
                    event
                ],
                eventName: event.name,
                args: args
            }));
        // TODO: Clean up type casting
        topics = [
            encoded
        ];
        if (event) topics = topics[0];
    }
    const id = await client.request({
        method: "eth_newFilter",
        params: [
            {
                address: address,
                fromBlock: typeof fromBlock === "bigint" ? (0, $9UP4H.numberToHex)(fromBlock) : fromBlock,
                toBlock: typeof toBlock === "bigint" ? (0, $9UP4H.numberToHex)(toBlock) : toBlock,
                ...topics.length ? {
                    topics: topics
                } : {}
            }
        ]
    });
    return {
        abi: events,
        args: args,
        eventName: event ? event.name : undefined,
        fromBlock: fromBlock,
        id: id,
        request: getRequest(id),
        strict: Boolean(strict),
        toBlock: toBlock,
        type: "event"
    };
}



async function $20a91266b6901c25$export$d455ed04c3e85241(client) {
    const getRequest = (0, $26700917420b28e4$export$b7aadf80a875f555)(client, {
        method: "eth_newPendingTransactionFilter"
    });
    const id = await client.request({
        method: "eth_newPendingTransactionFilter"
    });
    return {
        id: id,
        request: getRequest(id),
        type: "transaction"
    };
}



var $4I1xa = parcelRequire("4I1xa");

var $ahylX = parcelRequire("ahylX");



var $4I1xa = parcelRequire("4I1xa");

var $6F8ii = parcelRequire("6F8ii");

var $lqRRD = parcelRequire("lqRRD");

var $bRe6l = parcelRequire("bRe6l");
function $faf04a5580634b8b$export$462669520a9d12d1(publicKey) {
    const address = (0, $bRe6l.keccak256)(`0x${publicKey.substring(4)}`).substring(26);
    return (0, $lqRRD.checksumAddress)(`0x${address}`);
}



var $j6NiR = parcelRequire("j6NiR");

var $7Zv5I = parcelRequire("7Zv5I");

var $9UP4H = parcelRequire("9UP4H");

async function $81a1784296594e74$export$952dd09fbe0232b7({ hash: hash, signature: signature }) {
    const hashHex = (0, $j6NiR.isHex)(hash) ? hash : (0, $9UP4H.toHex)(hash);
    const { secp256k1: secp256k1 } = await Promise.resolve((parcelRequire("3VCvn")));
    const signature_ = (()=>{
        // typeof signature: `Signature`
        if (typeof signature === "object" && "r" in signature && "s" in signature) {
            const { r: r, s: s, v: v, yParity: yParity } = signature;
            const yParityOrV = Number(yParity ?? v);
            const recoveryBit = $81a1784296594e74$var$toRecoveryBit(yParityOrV);
            return new secp256k1.Signature((0, $7Zv5I.hexToBigInt)(r), (0, $7Zv5I.hexToBigInt)(s)).addRecoveryBit(recoveryBit);
        }
        // typeof signature: `Hex | ByteArray`
        const signatureHex = (0, $j6NiR.isHex)(signature) ? signature : (0, $9UP4H.toHex)(signature);
        const yParityOrV = (0, $7Zv5I.hexToNumber)(`0x${signatureHex.slice(130)}`);
        const recoveryBit = $81a1784296594e74$var$toRecoveryBit(yParityOrV);
        return secp256k1.Signature.fromCompact(signatureHex.substring(2, 130)).addRecoveryBit(recoveryBit);
    })();
    const publicKey = signature_.recoverPublicKey(hashHex.substring(2)).toHex(false);
    return `0x${publicKey}`;
}
function $81a1784296594e74$var$toRecoveryBit(yParityOrV) {
    if (yParityOrV === 0 || yParityOrV === 1) return yParityOrV;
    if (yParityOrV === 27) return 0;
    if (yParityOrV === 28) return 1;
    throw new Error("Invalid yParityOrV value");
}


async function $71781e96f30bd9c1$export$23cc18f96d8510e2({ hash: hash, signature: signature }) {
    return (0, $faf04a5580634b8b$export$462669520a9d12d1)(await (0, $81a1784296594e74$export$952dd09fbe0232b7)({
        hash: hash,
        signature: signature
    }));
}



var $jCBOw = parcelRequire("jCBOw");

var $eFDiV = parcelRequire("eFDiV");

var $9UP4H = parcelRequire("9UP4H");


var $bRe6l = parcelRequire("bRe6l");
function $20cd0df23fc7813f$export$52e574e057b290dc(parameters) {
    const { chainId: chainId, contractAddress: contractAddress, nonce: nonce, to: to } = parameters;
    const hash = (0, $bRe6l.keccak256)((0, $jCBOw.concatHex)([
        "0x05",
        (0, $e590101db94df837$export$140c78e750979cda)([
            (0, $9UP4H.numberToHex)(chainId),
            contractAddress,
            [
                nonce ? (0, $9UP4H.numberToHex)(nonce) : "0x"
            ]
        ])
    ]));
    if (to === "bytes") return (0, $eFDiV.hexToBytes)(hash);
    return hash;
}


async function $0b57a38b1d7a5d5d$export$415d0315604a8515(parameters) {
    const { authorization: authorization, signature: signature } = parameters;
    return (0, $71781e96f30bd9c1$export$23cc18f96d8510e2)({
        hash: (0, $20cd0df23fc7813f$export$52e574e057b290dc)(authorization),
        signature: signature ?? authorization
    });
}



var $9UP4H = parcelRequire("9UP4H");

var $1zkdv = parcelRequire("1zkdv");

var $7CqAp = parcelRequire("7CqAp");

var $6F8ii = parcelRequire("6F8ii");

var $8ceqR = parcelRequire("8ceqR");
class $404671875c400460$export$9e393e362ab0c102 extends (0, $6F8ii.BaseError) {
    constructor(cause, { account: account, docsPath: docsPath, chain: chain, data: data, gas: gas, gasPrice: gasPrice, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, to: to, value: value }){
        const prettyArgs = (0, $8ceqR.prettyPrint)({
            from: account?.address,
            to: to,
            value: typeof value !== "undefined" && `${(0, $1zkdv.formatEther)(value)} ${chain?.nativeCurrency?.symbol || "ETH"}`,
            data: data,
            gas: gas,
            gasPrice: typeof gasPrice !== "undefined" && `${(0, $7CqAp.formatGwei)(gasPrice)} gwei`,
            maxFeePerGas: typeof maxFeePerGas !== "undefined" && `${(0, $7CqAp.formatGwei)(maxFeePerGas)} gwei`,
            maxPriorityFeePerGas: typeof maxPriorityFeePerGas !== "undefined" && `${(0, $7CqAp.formatGwei)(maxPriorityFeePerGas)} gwei`,
            nonce: nonce
        });
        super(cause.shortMessage, {
            cause: cause,
            docsPath: docsPath,
            metaMessages: [
                ...cause.metaMessages ? [
                    ...cause.metaMessages,
                    " "
                ] : [],
                "Estimate Gas Arguments:",
                prettyArgs
            ].filter(Boolean),
            name: "EstimateGasExecutionError"
        });
        Object.defineProperty(this, "cause", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.cause = cause;
    }
}



var $7hHca = parcelRequire("7hHca");

var $8X5h6 = parcelRequire("8X5h6");
function $dae23dcd406aa636$export$f201b805dbcd7c48(err, { docsPath: docsPath, ...args }) {
    const cause = (()=>{
        const cause = (0, $8X5h6.getNodeError)(err, args);
        if (cause instanceof (0, $7hHca.UnknownNodeError)) return err;
        return cause;
    })();
    return new (0, $404671875c400460$export$9e393e362ab0c102)(cause, {
        docsPath: docsPath,
        ...args
    });
}



var $cdCOv = parcelRequire("cdCOv");

var $dT7D8 = parcelRequire("dT7D8");

var $5XFM1 = parcelRequire("5XFM1");

var $dVFRY = parcelRequire("dVFRY");

var $4I1xa = parcelRequire("4I1xa");

var $7CqAp = parcelRequire("7CqAp");

var $6F8ii = parcelRequire("6F8ii");
class $9e4e6802dfbd6ed1$export$200c092bedf29ac0 extends (0, $6F8ii.BaseError) {
    constructor(){
        super("`baseFeeMultiplier` must be greater than 1.", {
            name: "BaseFeeScalarError"
        });
    }
}
class $9e4e6802dfbd6ed1$export$dcf53c0ae183fb46 extends (0, $6F8ii.BaseError) {
    constructor(){
        super("Chain does not support EIP-1559 fees.", {
            name: "Eip1559FeesNotSupportedError"
        });
    }
}
class $9e4e6802dfbd6ed1$export$bcf9730904a1086f extends (0, $6F8ii.BaseError) {
    constructor({ maxPriorityFeePerGas: maxPriorityFeePerGas }){
        super(`\`maxFeePerGas\` cannot be less than the \`maxPriorityFeePerGas\` (${(0, $7CqAp.formatGwei)(maxPriorityFeePerGas)} gwei).`, {
            name: "MaxFeePerGasTooLowError"
        });
    }
}





var $7Zv5I = parcelRequire("7Zv5I");


var $6F8ii = parcelRequire("6F8ii");
class $fcdf892879e784ec$export$f5a00468af285e38 extends (0, $6F8ii.BaseError) {
    constructor({ blockHash: blockHash, blockNumber: blockNumber }){
        let identifier = "Block";
        if (blockHash) identifier = `Block at hash "${blockHash}"`;
        if (blockNumber) identifier = `Block at number "${blockNumber}"`;
        super(`${identifier} could not be found.`, {
            name: "BlockNotFoundError"
        });
    }
}



var $9UP4H = parcelRequire("9UP4H");

async function $afc05e8a9d5120bd$export$ea0af84ed2e77902(client, { blockHash: blockHash, blockNumber: blockNumber, blockTag: blockTag_, includeTransactions: includeTransactions_ } = {}) {
    const blockTag = blockTag_ ?? "latest";
    const includeTransactions = includeTransactions_ ?? false;
    const blockNumberHex = blockNumber !== undefined ? (0, $9UP4H.numberToHex)(blockNumber) : undefined;
    let block = null;
    if (blockHash) block = await client.request({
        method: "eth_getBlockByHash",
        params: [
            blockHash,
            includeTransactions
        ]
    }, {
        dedupe: true
    });
    else block = await client.request({
        method: "eth_getBlockByNumber",
        params: [
            blockNumberHex || blockTag,
            includeTransactions
        ]
    }, {
        dedupe: Boolean(blockNumberHex)
    });
    if (!block) throw new (0, $fcdf892879e784ec$export$f5a00468af285e38)({
        blockHash: blockHash,
        blockNumber: blockNumber
    });
    const format = client.chain?.formatters?.block?.format || (0, $8d786868837e77db$export$ba1152bc4017d62a);
    return format(block);
}


/**
 * Returns the current price of gas (in wei).
 *
 * - Docs: https://viem.sh/docs/actions/public/getGasPrice
 * - JSON-RPC Methods: [`eth_gasPrice`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_gasprice)
 *
 * @param client - Client to use
 * @returns The gas price (in wei). {@link GetGasPriceReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getGasPrice } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const gasPrice = await getGasPrice(client)
 */ async function $62da37b22de25e6b$export$89c15b50d46d3f8c(client) {
    const gasPrice = await client.request({
        method: "eth_gasPrice"
    });
    return BigInt(gasPrice);
}


async function $35a4530cf434d5c9$export$fd79a693887f886c(client, args) {
    return $35a4530cf434d5c9$export$59275bafd388148(client, args);
}
async function $35a4530cf434d5c9$export$59275bafd388148(client, args) {
    const { block: block_, chain: chain = client.chain, request: request } = args || {};
    if (typeof chain?.fees?.defaultPriorityFee === "function") {
        const block = block_ || await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $afc05e8a9d5120bd$export$ea0af84ed2e77902), "getBlock")({});
        return chain.fees.defaultPriorityFee({
            block: block,
            client: client,
            request: request
        });
    }
    if (typeof chain?.fees?.defaultPriorityFee !== "undefined") return chain?.fees?.defaultPriorityFee;
    try {
        const maxPriorityFeePerGasHex = await client.request({
            method: "eth_maxPriorityFeePerGas"
        });
        return (0, $7Zv5I.hexToBigInt)(maxPriorityFeePerGasHex);
    } catch  {
        // If the RPC Provider does not support `eth_maxPriorityFeePerGas`
        // fall back to calculating it manually via `gasPrice - baseFeePerGas`.
        // See: https://github.com/ethereum/pm/issues/328#:~:text=eth_maxPriorityFeePerGas%20after%20London%20will%20effectively%20return%20eth_gasPrice%20%2D%20baseFee
        const [block, gasPrice] = await Promise.all([
            block_ ? Promise.resolve(block_) : (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $afc05e8a9d5120bd$export$ea0af84ed2e77902), "getBlock")({}),
            (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $62da37b22de25e6b$export$89c15b50d46d3f8c), "getGasPrice")({})
        ]);
        if (typeof block.baseFeePerGas !== "bigint") throw new (0, $9e4e6802dfbd6ed1$export$dcf53c0ae183fb46)();
        const maxPriorityFeePerGas = gasPrice - block.baseFeePerGas;
        if (maxPriorityFeePerGas < 0n) return 0n;
        return maxPriorityFeePerGas;
    }
}




async function $6fd5ed1f4857412b$export$8193bed8c46d2831(client, args) {
    return $6fd5ed1f4857412b$export$67115e8707c5a9e(client, args);
}
async function $6fd5ed1f4857412b$export$67115e8707c5a9e(client, args) {
    const { block: block_, chain: chain = client.chain, request: request, type: type = "eip1559" } = args || {};
    const baseFeeMultiplier = await (async ()=>{
        if (typeof chain?.fees?.baseFeeMultiplier === "function") return chain.fees.baseFeeMultiplier({
            block: block_,
            client: client,
            request: request
        });
        return chain?.fees?.baseFeeMultiplier ?? 1.2;
    })();
    if (baseFeeMultiplier < 1) throw new (0, $9e4e6802dfbd6ed1$export$200c092bedf29ac0)();
    const decimals = baseFeeMultiplier.toString().split(".")[1]?.length ?? 0;
    const denominator = 10 ** decimals;
    const multiply = (base)=>base * BigInt(Math.ceil(baseFeeMultiplier * denominator)) / BigInt(denominator);
    const block = block_ ? block_ : await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $afc05e8a9d5120bd$export$ea0af84ed2e77902), "getBlock")({});
    if (typeof chain?.fees?.estimateFeesPerGas === "function") {
        const fees = await chain.fees.estimateFeesPerGas({
            block: block_,
            client: client,
            multiply: multiply,
            request: request,
            type: type
        });
        if (fees !== null) return fees;
    }
    if (type === "eip1559") {
        if (typeof block.baseFeePerGas !== "bigint") throw new (0, $9e4e6802dfbd6ed1$export$dcf53c0ae183fb46)();
        const maxPriorityFeePerGas = typeof request?.maxPriorityFeePerGas === "bigint" ? request.maxPriorityFeePerGas : await (0, $35a4530cf434d5c9$export$59275bafd388148)(client, {
            block: block,
            chain: chain,
            request: request
        });
        const baseFeePerGas = multiply(block.baseFeePerGas);
        const maxFeePerGas = request?.maxFeePerGas ?? baseFeePerGas + maxPriorityFeePerGas;
        return {
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas
        };
    }
    const gasPrice = request?.gasPrice ?? multiply(await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $62da37b22de25e6b$export$89c15b50d46d3f8c), "getGasPrice")({}));
    return {
        gasPrice: gasPrice
    };
}





var $7Zv5I = parcelRequire("7Zv5I");

var $9UP4H = parcelRequire("9UP4H");
async function $8a83ac23a544e47c$export$b18e66333ec1361e(client, { address: address, blockTag: blockTag = "latest", blockNumber: blockNumber }) {
    const count = await client.request({
        method: "eth_getTransactionCount",
        params: [
            address,
            blockNumber ? (0, $9UP4H.numberToHex)(blockNumber) : blockTag
        ]
    }, {
        dedupe: Boolean(blockNumber)
    });
    return (0, $7Zv5I.hexToNumber)(count);
}









var $dVFRY = parcelRequire("dVFRY");


var $7Zv5I = parcelRequire("7Zv5I");
async function $8af7cdce0f8e6164$export$850fa7b3891187c(client) {
    const chainIdHex = await client.request({
        method: "eth_chainId"
    }, {
        dedupe: true
    });
    return (0, $7Zv5I.hexToNumber)(chainIdHex);
}


const $4854f417ee324bc1$export$4f3e0c2bc77eca55 = [
    "blobVersionedHashes",
    "chainId",
    "fees",
    "gas",
    "nonce",
    "type"
];
async function $4854f417ee324bc1$export$2e8a9232fb815d77(client, args) {
    const { account: account_ = client.account, blobs: blobs, chain: chain, gas: gas, kzg: kzg, nonce: nonce, parameters: parameters = $4854f417ee324bc1$export$4f3e0c2bc77eca55, type: type } = args;
    const account = account_ ? (0, $4I1xa.parseAccount)(account_) : undefined;
    const request = {
        ...args,
        ...account ? {
            from: account?.address
        } : {}
    };
    let block;
    async function getBlock() {
        if (block) return block;
        block = await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $afc05e8a9d5120bd$export$ea0af84ed2e77902), "getBlock")({
            blockTag: "latest"
        });
        return block;
    }
    let chainId;
    async function getChainId() {
        if (chainId) return chainId;
        if (chain) return chain.id;
        if (typeof args.chainId !== "undefined") return args.chainId;
        const chainId_ = await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $8af7cdce0f8e6164$export$850fa7b3891187c), "getChainId")({});
        chainId = chainId_;
        return chainId;
    }
    if ((parameters.includes("blobVersionedHashes") || parameters.includes("sidecars")) && blobs && kzg) {
        const commitments = (0, $6507d1beda337491$export$b67626aab22a659b)({
            blobs: blobs,
            kzg: kzg
        });
        if (parameters.includes("blobVersionedHashes")) {
            const versionedHashes = (0, $2ad8e7a2c1a65f08$export$e31b3e59dda37b17)({
                commitments: commitments,
                to: "hex"
            });
            request.blobVersionedHashes = versionedHashes;
        }
        if (parameters.includes("sidecars")) {
            const proofs = (0, $13a026c6ed189cfb$export$78a225f8922765eb)({
                blobs: blobs,
                commitments: commitments,
                kzg: kzg
            });
            const sidecars = (0, $8048a52d99894ddb$export$44960962e1c9641b)({
                blobs: blobs,
                commitments: commitments,
                proofs: proofs,
                to: "hex"
            });
            request.sidecars = sidecars;
        }
    }
    if (parameters.includes("chainId")) request.chainId = await getChainId();
    if (parameters.includes("nonce") && typeof nonce === "undefined" && account) {
        if (account.nonceManager) {
            const chainId = await getChainId();
            request.nonce = await account.nonceManager.consume({
                address: account.address,
                chainId: chainId,
                client: client
            });
        } else request.nonce = await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $8a83ac23a544e47c$export$b18e66333ec1361e), "getTransactionCount")({
            address: account.address,
            blockTag: "pending"
        });
    }
    if ((parameters.includes("fees") || parameters.includes("type")) && typeof type === "undefined") try {
        request.type = (0, $56d663a63fac90e2$export$944c6678cd5a1ea8)(request);
    } catch  {
        // infer type from block
        const block = await getBlock();
        request.type = typeof block?.baseFeePerGas === "bigint" ? "eip1559" : "legacy";
    }
    if (parameters.includes("fees")) {
        // TODO(4844): derive blob base fees once https://github.com/ethereum/execution-apis/pull/486 is merged.
        if (request.type !== "legacy" && request.type !== "eip2930") // EIP-1559 fees
        {
            if (typeof request.maxFeePerGas === "undefined" || typeof request.maxPriorityFeePerGas === "undefined") {
                const block = await getBlock();
                const { maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas } = await (0, $6fd5ed1f4857412b$export$67115e8707c5a9e)(client, {
                    block: block,
                    chain: chain,
                    request: request
                });
                if (typeof args.maxPriorityFeePerGas === "undefined" && args.maxFeePerGas && args.maxFeePerGas < maxPriorityFeePerGas) throw new (0, $9e4e6802dfbd6ed1$export$bcf9730904a1086f)({
                    maxPriorityFeePerGas: maxPriorityFeePerGas
                });
                request.maxPriorityFeePerGas = maxPriorityFeePerGas;
                request.maxFeePerGas = maxFeePerGas;
            }
        } else {
            // Legacy fees
            if (typeof args.maxFeePerGas !== "undefined" || typeof args.maxPriorityFeePerGas !== "undefined") throw new (0, $9e4e6802dfbd6ed1$export$dcf53c0ae183fb46)();
            const block = await getBlock();
            const { gasPrice: gasPrice_ } = await (0, $6fd5ed1f4857412b$export$67115e8707c5a9e)(client, {
                block: block,
                chain: chain,
                request: request,
                type: "legacy"
            });
            request.gasPrice = gasPrice_;
        }
    }
    if (parameters.includes("gas") && typeof gas === "undefined") request.gas = await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $6564eb1e7fd1d145$export$e0580ae1f48db848), "estimateGas")({
        ...request,
        account: account ? {
            address: account.address,
            type: "json-rpc"
        } : undefined
    });
    (0, $dVFRY.assertRequest)(request);
    delete request.parameters;
    return request;
}



async function $6564eb1e7fd1d145$export$e0580ae1f48db848(client, args) {
    const account_ = args.account ?? client.account;
    const account = account_ ? (0, $4I1xa.parseAccount)(account_) : undefined;
    try {
        const { accessList: accessList, authorizationList: authorizationList, blobs: blobs, blobVersionedHashes: blobVersionedHashes, blockNumber: blockNumber, blockTag: blockTag, data: data, gas: gas, gasPrice: gasPrice, maxFeePerBlobGas: maxFeePerBlobGas, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, value: value, stateOverride: stateOverride, ...rest } = await (0, $4854f417ee324bc1$export$2e8a9232fb815d77)(client, {
            ...args,
            parameters: // Some RPC Providers do not compute versioned hashes from blobs. We will need
            // to compute them.
            account?.type === "local" ? undefined : [
                "blobVersionedHashes"
            ]
        });
        const blockNumberHex = blockNumber ? (0, $9UP4H.numberToHex)(blockNumber) : undefined;
        const block = blockNumberHex || blockTag;
        const rpcStateOverride = (0, $5XFM1.serializeStateOverride)(stateOverride);
        const to = await (async ()=>{
            // If `to` exists on the parameters, use that.
            if (rest.to) return rest.to;
            // If no `to` exists, and we are sending a EIP-7702 transaction, use the
            // address of the first authorization in the list.
            if (authorizationList && authorizationList.length > 0) return await (0, $0b57a38b1d7a5d5d$export$415d0315604a8515)({
                authorization: authorizationList[0]
            }).catch(()=>{
                throw new (0, $6F8ii.BaseError)("`to` is required. Could not infer from `authorizationList`");
            });
            // Otherwise, we are sending a deployment transaction.
            return undefined;
        })();
        (0, $dVFRY.assertRequest)(args);
        const chainFormat = client.chain?.formatters?.transactionRequest?.format;
        const format = chainFormat || (0, $dT7D8.formatTransactionRequest);
        const request = format({
            // Pick out extra data that might exist on the chain's transaction request type.
            ...(0, $cdCOv.extract)(rest, {
                format: chainFormat
            }),
            from: account?.address,
            accessList: accessList,
            authorizationList: authorizationList,
            blobs: blobs,
            blobVersionedHashes: blobVersionedHashes,
            data: data,
            gas: gas,
            gasPrice: gasPrice,
            maxFeePerBlobGas: maxFeePerBlobGas,
            maxFeePerGas: maxFeePerGas,
            maxPriorityFeePerGas: maxPriorityFeePerGas,
            nonce: nonce,
            to: to,
            value: value
        });
        function estimateGas_rpc(parameters) {
            const { block: block, request: request, rpcStateOverride: rpcStateOverride } = parameters;
            return client.request({
                method: "eth_estimateGas",
                params: rpcStateOverride ? [
                    request,
                    block ?? "latest",
                    rpcStateOverride
                ] : block ? [
                    request,
                    block
                ] : [
                    request
                ]
            });
        }
        let estimate = BigInt(await estimateGas_rpc({
            block: block,
            request: request,
            rpcStateOverride: rpcStateOverride
        }));
        // TODO(7702): Remove this once https://github.com/ethereum/execution-apis/issues/561 is resolved.
        //       Authorization list schema is not implemented on JSON-RPC spec yet, so we need to
        //       manually estimate the gas.
        if (authorizationList) {
            const value = await (0, $854ed7a9743f5dc2$export$df96cd8d56be0ab1)(client, {
                address: request.from
            });
            const estimates = await Promise.all(authorizationList.map(async (authorization)=>{
                const { contractAddress: contractAddress } = authorization;
                const estimate = await estimateGas_rpc({
                    block: block,
                    request: {
                        authorizationList: undefined,
                        data: data,
                        from: account?.address,
                        to: contractAddress,
                        value: (0, $9UP4H.numberToHex)(value)
                    },
                    rpcStateOverride: rpcStateOverride
                }).catch(()=>100000n);
                return 2n * BigInt(estimate);
            }));
            estimate += estimates.reduce((acc, curr)=>acc + curr, 0n);
        }
        return estimate;
    } catch (err) {
        throw (0, $dae23dcd406aa636$export$f201b805dbcd7c48)(err, {
            ...args,
            account: account,
            chain: client.chain
        });
    }
}


async function $1ec63edfff7aa371$export$7b896b3a3695de87(client, parameters) {
    const { abi: abi, address: address, args: args, functionName: functionName, ...request } = parameters;
    const data = (0, $ahylX.encodeFunctionData)({
        abi: abi,
        args: args,
        functionName: functionName
    });
    try {
        const gas = await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $6564eb1e7fd1d145$export$e0580ae1f48db848), "estimateGas")({
            data: data,
            to: address,
            ...request
        });
        return gas;
    } catch (error) {
        const account = request.account ? (0, $4I1xa.parseAccount)(request.account) : undefined;
        throw (0, $ed751cf9c83e9795$export$4414444aba6ddd8a)(error, {
            abi: abi,
            address: address,
            args: args,
            docsPath: "/docs/contract/estimateContractGas",
            functionName: functionName,
            sender: account?.address
        });
    }
}






/**
 * Returns the base fee per blob gas in wei.
 *
 * - Docs: https://viem.sh/docs/actions/public/getBlobBaseFee
 * - JSON-RPC Methods: [`eth_blobBaseFee`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_blobBaseFee)
 *
 * @param client - Client to use
 * @returns The blob base fee (in wei). {@link GetBlobBaseFeeReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getBlobBaseFee } from 'viem/public'
 *
 * const client = createPublicClient({
 *   chain: mainnet,
 *   transport: http(),
 * })
 * const blobBaseFee = await getBlobBaseFee(client)
 */ async function $0722c7c83002eb76$export$9682cd49f77b48b(client) {
    const baseFee = await client.request({
        method: "eth_blobBaseFee"
    });
    return BigInt(baseFee);
}



/** @internal */ const $f395d3f41bbdd140$export$e89e805418f4d2c = /*#__PURE__*/ new Map();
const $f395d3f41bbdd140$export$b4c67320c85a8b9d = /*#__PURE__*/ new Map();
function $f395d3f41bbdd140$export$e2575ed62a2f107b(cacheKey) {
    const buildCache = (cacheKey, cache)=>({
            clear: ()=>cache.delete(cacheKey),
            get: ()=>cache.get(cacheKey),
            set: (data)=>cache.set(cacheKey, data)
        });
    const promise = buildCache(cacheKey, $f395d3f41bbdd140$export$e89e805418f4d2c);
    const response = buildCache(cacheKey, $f395d3f41bbdd140$export$b4c67320c85a8b9d);
    return {
        clear: ()=>{
            promise.clear();
            response.clear();
        },
        promise: promise,
        response: response
    };
}
async function $f395d3f41bbdd140$export$33b32b3abf8170f0(fn, { cacheKey: cacheKey, cacheTime: cacheTime = Number.POSITIVE_INFINITY }) {
    const cache = $f395d3f41bbdd140$export$e2575ed62a2f107b(cacheKey);
    // If a response exists in the cache, and it's not expired, return it
    // and do not invoke the promise.
    // If the max age is 0, the cache is disabled.
    const response = cache.response.get();
    if (response && cacheTime > 0) {
        const age = new Date().getTime() - response.created.getTime();
        if (age < cacheTime) return response.data;
    }
    let promise = cache.promise.get();
    if (!promise) {
        promise = fn();
        // Store the promise in the cache so that subsequent invocations
        // will wait for the same promise to resolve (deduping).
        cache.promise.set(promise);
    }
    try {
        const data = await promise;
        // Store the response in the cache so that subsequent invocations
        // will return the same response.
        cache.response.set({
            created: new Date(),
            data: data
        });
        return data;
    } finally{
        // Clear the promise cache so that subsequent invocations will
        // invoke the promise again.
        cache.promise.clear();
    }
}


const $ad8ffeddc2009a5e$var$cacheKey = (id)=>`blockNumber.${id}`;
function $ad8ffeddc2009a5e$export$bc78c57a2d1b4a2b(id) {
    return (0, $f395d3f41bbdd140$export$e2575ed62a2f107b)($ad8ffeddc2009a5e$var$cacheKey(id));
}
async function $ad8ffeddc2009a5e$export$9328b5c92c53a20e(client, { cacheTime: cacheTime = client.cacheTime } = {}) {
    const blockNumberHex = await (0, $f395d3f41bbdd140$export$33b32b3abf8170f0)(()=>client.request({
            method: "eth_blockNumber"
        }), {
        cacheKey: $ad8ffeddc2009a5e$var$cacheKey(client.uid),
        cacheTime: cacheTime
    });
    return BigInt(blockNumberHex);
}



var $7Zv5I = parcelRequire("7Zv5I");

var $9UP4H = parcelRequire("9UP4H");
async function $d9ff0e13e83869a1$export$8c2de5be7f4dfc0(client, { blockHash: blockHash, blockNumber: blockNumber, blockTag: blockTag = "latest" } = {}) {
    const blockNumberHex = blockNumber !== undefined ? (0, $9UP4H.numberToHex)(blockNumber) : undefined;
    let count;
    if (blockHash) count = await client.request({
        method: "eth_getBlockTransactionCountByHash",
        params: [
            blockHash
        ]
    }, {
        dedupe: true
    });
    else count = await client.request({
        method: "eth_getBlockTransactionCountByNumber",
        params: [
            blockNumberHex || blockTag
        ]
    }, {
        dedupe: Boolean(blockNumberHex)
    });
    return (0, $7Zv5I.hexToNumber)(count);
}




var $9UP4H = parcelRequire("9UP4H");
async function $72a6d2dbbbc1f647$export$9a0a9c75ccef13fb(client, { address: address, blockNumber: blockNumber, blockTag: blockTag = "latest" }) {
    const blockNumberHex = blockNumber !== undefined ? (0, $9UP4H.numberToHex)(blockNumber) : undefined;
    const hex = await client.request({
        method: "eth_getCode",
        params: [
            address,
            blockNumberHex || blockTag
        ]
    }, {
        dedupe: Boolean(blockNumberHex)
    });
    if (hex === "0x") return undefined;
    return hex;
}



var $lPlQ2 = parcelRequire("lPlQ2");


// TODO(v3): checksum address.

var $3TFRi = parcelRequire("3TFRi");

var $6gCNy = parcelRequire("6gCNy");

var $eFDiV = parcelRequire("eFDiV");

var $bRe6l = parcelRequire("bRe6l");

var $3TFRi = parcelRequire("3TFRi");

var $jBXg5 = parcelRequire("jBXg5");

var $gvzyN = parcelRequire("gvzyN");

var $fVW5g = parcelRequire("fVW5g");

var $4VcDz = parcelRequire("4VcDz");

var $dDQ3R = parcelRequire("dDQ3R");
const $d0fbcd7c3a384abc$var$docsPath = "/docs/contract/decodeEventLog";
function $d0fbcd7c3a384abc$export$ec0597e81db3d947(parameters) {
    const { abi: abi, data: data, strict: strict_, topics: topics } = parameters;
    const strict = strict_ ?? true;
    const [signature, ...argTopics] = topics;
    if (!signature) throw new (0, $3TFRi.AbiEventSignatureEmptyTopicsError)({
        docsPath: $d0fbcd7c3a384abc$var$docsPath
    });
    const abiItem = abi.find((x)=>x.type === "event" && signature === (0, $gvzyN.toEventSelector)((0, $dDQ3R.formatAbiItem)(x)));
    if (!(abiItem && "name" in abiItem) || abiItem.type !== "event") throw new (0, $3TFRi.AbiEventSignatureNotFoundError)(signature, {
        docsPath: $d0fbcd7c3a384abc$var$docsPath
    });
    const { name: name, inputs: inputs } = abiItem;
    const isUnnamed = inputs?.some((x)=>!("name" in x && x.name));
    let args = isUnnamed ? [] : {};
    // Decode topics (indexed args).
    const indexedInputs = inputs.filter((x)=>"indexed" in x && x.indexed);
    for(let i = 0; i < indexedInputs.length; i++){
        const param = indexedInputs[i];
        const topic = argTopics[i];
        if (!topic) throw new (0, $3TFRi.DecodeLogTopicsMismatch)({
            abiItem: abiItem,
            param: param
        });
        args[isUnnamed ? i : param.name || i] = $d0fbcd7c3a384abc$var$decodeTopic({
            param: param,
            value: topic
        });
    }
    // Decode data (non-indexed args).
    const nonIndexedInputs = inputs.filter((x)=>!("indexed" in x && x.indexed));
    if (nonIndexedInputs.length > 0) {
        if (data && data !== "0x") try {
            const decodedData = (0, $4VcDz.decodeAbiParameters)(nonIndexedInputs, data);
            if (decodedData) {
                if (isUnnamed) args = [
                    ...args,
                    ...decodedData
                ];
                else for(let i = 0; i < nonIndexedInputs.length; i++)args[nonIndexedInputs[i].name] = decodedData[i];
            }
        } catch (err) {
            if (strict) {
                if (err instanceof (0, $3TFRi.AbiDecodingDataSizeTooSmallError) || err instanceof (0, $fVW5g.PositionOutOfBoundsError)) throw new (0, $3TFRi.DecodeLogDataMismatch)({
                    abiItem: abiItem,
                    data: data,
                    params: nonIndexedInputs,
                    size: (0, $jBXg5.size)(data)
                });
                throw err;
            }
        }
        else if (strict) throw new (0, $3TFRi.DecodeLogDataMismatch)({
            abiItem: abiItem,
            data: "0x",
            params: nonIndexedInputs,
            size: 0
        });
    }
    return {
        eventName: name,
        args: Object.values(args).length > 0 ? args : undefined
    };
}
function $d0fbcd7c3a384abc$var$decodeTopic({ param: param, value: value }) {
    if (param.type === "string" || param.type === "bytes" || param.type === "tuple" || param.type.match(/^(.*)\[(\d+)?\]$/)) return value;
    const decodedArg = (0, $4VcDz.decodeAbiParameters)([
        param
    ], value) || [];
    return decodedArg[0];
}



var $lPlQ2 = parcelRequire("lPlQ2");
function $8cfa29100621782a$export$7d811a19971cdf46(parameters) {
    const { abi: abi, args: args, logs: logs, strict: strict = true } = parameters;
    const eventName = (()=>{
        if (!parameters.eventName) return undefined;
        if (Array.isArray(parameters.eventName)) return parameters.eventName;
        return [
            parameters.eventName
        ];
    })();
    return logs.map((log)=>{
        try {
            const abiItem = (0, $lPlQ2.getAbiItem)({
                abi: abi,
                name: log.topics[0]
            });
            if (!abiItem) return null;
            const event = (0, $d0fbcd7c3a384abc$export$ec0597e81db3d947)({
                ...log,
                abi: [
                    abiItem
                ],
                strict: strict
            });
            // Check that the decoded event name matches the provided event name.
            if (eventName && !eventName.includes(event.eventName)) return null;
            // Check that the decoded event args match the provided args.
            if (!$8cfa29100621782a$var$includesArgs({
                args: event.args,
                inputs: abiItem.inputs,
                matchArgs: args
            })) return null;
            return {
                ...event,
                ...log
            };
        } catch (err) {
            let eventName;
            let isUnnamed;
            if (err instanceof (0, $3TFRi.AbiEventSignatureNotFoundError)) return null;
            if (err instanceof (0, $3TFRi.DecodeLogDataMismatch) || err instanceof (0, $3TFRi.DecodeLogTopicsMismatch)) {
                // If strict mode is on, and log data/topics do not match event definition, skip.
                if (strict) return null;
                eventName = err.abiItem.name;
                isUnnamed = err.abiItem.inputs?.some((x)=>!("name" in x && x.name));
            }
            // Set args to empty if there is an error decoding (e.g. indexed/non-indexed params mismatch).
            return {
                ...log,
                args: isUnnamed ? [] : {},
                eventName: eventName
            };
        }
    }).filter(Boolean);
}
function $8cfa29100621782a$var$includesArgs(parameters) {
    const { args: args, inputs: inputs, matchArgs: matchArgs } = parameters;
    if (!matchArgs) return true;
    if (!args) return false;
    function isEqual(input, value, arg) {
        try {
            if (input.type === "address") return (0, $6gCNy.isAddressEqual)(value, arg);
            if (input.type === "string" || input.type === "bytes") return (0, $bRe6l.keccak256)((0, $eFDiV.toBytes)(value)) === arg;
            return value === arg;
        } catch  {
            return false;
        }
    }
    if (Array.isArray(args) && Array.isArray(matchArgs)) return matchArgs.every((value, index)=>{
        if (!value) return true;
        const input = inputs[index];
        if (!input) return false;
        const value_ = Array.isArray(value) ? value : [
            value
        ];
        return value_.some((value)=>isEqual(input, value, args[index]));
    });
    if (typeof args === "object" && !Array.isArray(args) && typeof matchArgs === "object" && !Array.isArray(matchArgs)) return Object.entries(matchArgs).every(([key, value])=>{
        if (!value) return true;
        const input = inputs.find((input)=>input.name === key);
        if (!input) return false;
        const value_ = Array.isArray(value) ? value : [
            value
        ];
        return value_.some((value)=>isEqual(input, value, args[key]));
    });
    return false;
}



var $9UP4H = parcelRequire("9UP4H");

async function $8dadc4b63f7c1440$export$cb5260c832aab30a(client, { address: address, blockHash: blockHash, fromBlock: fromBlock, toBlock: toBlock, event: event, events: events_, args: args, strict: strict_ } = {}) {
    const strict = strict_ ?? false;
    const events = events_ ?? (event ? [
        event
    ] : undefined);
    let topics = [];
    if (events) {
        const encoded = events.flatMap((event)=>(0, $a41ca3912e02661b$export$64e9f7ca5ce29acd)({
                abi: [
                    event
                ],
                eventName: event.name,
                args: events_ ? undefined : args
            }));
        // TODO: Clean up type casting
        topics = [
            encoded
        ];
        if (event) topics = topics[0];
    }
    let logs;
    if (blockHash) logs = await client.request({
        method: "eth_getLogs",
        params: [
            {
                address: address,
                topics: topics,
                blockHash: blockHash
            }
        ]
    });
    else logs = await client.request({
        method: "eth_getLogs",
        params: [
            {
                address: address,
                topics: topics,
                fromBlock: typeof fromBlock === "bigint" ? (0, $9UP4H.numberToHex)(fromBlock) : fromBlock,
                toBlock: typeof toBlock === "bigint" ? (0, $9UP4H.numberToHex)(toBlock) : toBlock
            }
        ]
    });
    const formattedLogs = logs.map((log)=>(0, $85c39d465bc84f83$export$fccdbdc2b9d7893)(log));
    if (!events) return formattedLogs;
    return (0, $8cfa29100621782a$export$7d811a19971cdf46)({
        abi: events,
        args: args,
        logs: formattedLogs,
        strict: strict
    });
}


async function $b6df579f3c0f85d0$export$1e175955db02d8d(client, parameters) {
    const { abi: abi, address: address, args: args, blockHash: blockHash, eventName: eventName, fromBlock: fromBlock, toBlock: toBlock, strict: strict } = parameters;
    const event = eventName ? (0, $lPlQ2.getAbiItem)({
        abi: abi,
        name: eventName
    }) : undefined;
    const events = !event ? abi.filter((x)=>x.type === "event") : undefined;
    return (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $8dadc4b63f7c1440$export$cb5260c832aab30a), "getLogs")({
        address: address,
        args: args,
        blockHash: blockHash,
        event: event,
        events: events,
        fromBlock: fromBlock,
        toBlock: toBlock,
        strict: strict
    });
}



var $6F8ii = parcelRequire("6F8ii");
class $1db06d56cab60161$export$3738cbd1470ec0c extends (0, $6F8ii.BaseError) {
    constructor({ address: address }){
        super(`No EIP-712 domain found on contract "${address}".`, {
            metaMessages: [
                "Ensure that:",
                `- The contract is deployed at the address "${address}".`,
                "- `eip712Domain()` function exists on the contract.",
                "- `eip712Domain()` function matches signature to ERC-5267 specification."
            ],
            name: "Eip712DomainNotFoundError"
        });
    }
}




async function $817baf431dc63797$export$78097141abc77755(client, parameters) {
    const { address: address, factory: factory, factoryData: factoryData } = parameters;
    try {
        const [fields, name, version, chainId, verifyingContract, salt, extensions] = await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $345cd736baedaec0$export$43af7de392176737), "readContract")({
            abi: $817baf431dc63797$var$abi,
            address: address,
            functionName: "eip712Domain",
            factory: factory,
            factoryData: factoryData
        });
        return {
            domain: {
                name: name,
                version: version,
                chainId: Number(chainId),
                verifyingContract: verifyingContract,
                salt: salt
            },
            extensions: extensions,
            fields: fields
        };
    } catch (e) {
        const error = e;
        if (error.name === "ContractFunctionExecutionError" && error.cause.name === "ContractFunctionZeroDataError") throw new (0, $1db06d56cab60161$export$3738cbd1470ec0c)({
            address: address
        });
        throw error;
    }
}
const $817baf431dc63797$var$abi = [
    {
        inputs: [],
        name: "eip712Domain",
        outputs: [
            {
                name: "fields",
                type: "bytes1"
            },
            {
                name: "name",
                type: "string"
            },
            {
                name: "version",
                type: "string"
            },
            {
                name: "chainId",
                type: "uint256"
            },
            {
                name: "verifyingContract",
                type: "address"
            },
            {
                name: "salt",
                type: "bytes32"
            },
            {
                name: "extensions",
                type: "uint256[]"
            }
        ],
        stateMutability: "view",
        type: "function"
    }
];



var $9UP4H = parcelRequire("9UP4H");
function $cb3da92f4045b943$export$6c26435bc7761d23(feeHistory) {
    return {
        baseFeePerGas: feeHistory.baseFeePerGas.map((value)=>BigInt(value)),
        gasUsedRatio: feeHistory.gasUsedRatio,
        oldestBlock: BigInt(feeHistory.oldestBlock),
        reward: feeHistory.reward?.map((reward)=>reward.map((value)=>BigInt(value)))
    };
}


async function $2d77b8ead8ffcfc6$export$66598bc0c00a958e(client, { blockCount: blockCount, blockNumber: blockNumber, blockTag: blockTag = "latest", rewardPercentiles: rewardPercentiles }) {
    const blockNumberHex = blockNumber ? (0, $9UP4H.numberToHex)(blockNumber) : undefined;
    const feeHistory = await client.request({
        method: "eth_feeHistory",
        params: [
            (0, $9UP4H.numberToHex)(blockCount),
            blockNumberHex || blockTag,
            rewardPercentiles
        ]
    }, {
        dedupe: Boolean(blockNumberHex)
    });
    return (0, $cb3da92f4045b943$export$6c26435bc7761d23)(feeHistory);
}




async function $9d97866840568f1f$export$e69fa84ce52a94fd(_client, { filter: filter }) {
    const strict = "strict" in filter && filter.strict;
    const logs = await filter.request({
        method: "eth_getFilterChanges",
        params: [
            filter.id
        ]
    });
    if (typeof logs[0] === "string") return logs;
    const formattedLogs = logs.map((log)=>(0, $85c39d465bc84f83$export$fccdbdc2b9d7893)(log));
    if (!("abi" in filter) || !filter.abi) return formattedLogs;
    return (0, $8cfa29100621782a$export$7d811a19971cdf46)({
        abi: filter.abi,
        logs: formattedLogs,
        strict: strict
    });
}




async function $cebe07a91f815d04$export$776d3b8c33a8b58(_client, { filter: filter }) {
    const strict = filter.strict ?? false;
    const logs = await filter.request({
        method: "eth_getFilterLogs",
        params: [
            filter.id
        ]
    });
    const formattedLogs = logs.map((log)=>(0, $85c39d465bc84f83$export$fccdbdc2b9d7893)(log));
    if (!filter.abi) return formattedLogs;
    return (0, $8cfa29100621782a$export$7d811a19971cdf46)({
        abi: filter.abi,
        logs: formattedLogs,
        strict: strict
    });
}





var $9UP4H = parcelRequire("9UP4H");

var $7Zv5I = parcelRequire("7Zv5I");
function $fdfbe856d6c6aace$var$formatStorageProof(storageProof) {
    return storageProof.map((proof)=>({
            ...proof,
            value: BigInt(proof.value)
        }));
}
function $fdfbe856d6c6aace$export$f37c234f0c7125e3(proof) {
    return {
        ...proof,
        balance: proof.balance ? BigInt(proof.balance) : undefined,
        nonce: proof.nonce ? (0, $7Zv5I.hexToNumber)(proof.nonce) : undefined,
        storageProof: proof.storageProof ? $fdfbe856d6c6aace$var$formatStorageProof(proof.storageProof) : undefined
    };
}


async function $feeed03e107c139b$export$4a314c097411dc17(client, { address: address, blockNumber: blockNumber, blockTag: blockTag_, storageKeys: storageKeys }) {
    const blockTag = blockTag_ ?? "latest";
    const blockNumberHex = blockNumber !== undefined ? (0, $9UP4H.numberToHex)(blockNumber) : undefined;
    const proof = await client.request({
        method: "eth_getProof",
        params: [
            address,
            storageKeys,
            blockNumberHex || blockTag
        ]
    });
    return (0, $fdfbe856d6c6aace$export$f37c234f0c7125e3)(proof);
}



var $9UP4H = parcelRequire("9UP4H");
async function $35619d601266d2f6$export$14e244c1a3c8527e(client, { address: address, blockNumber: blockNumber, blockTag: blockTag = "latest", slot: slot }) {
    const blockNumberHex = blockNumber !== undefined ? (0, $9UP4H.numberToHex)(blockNumber) : undefined;
    const data = await client.request({
        method: "eth_getStorageAt",
        params: [
            address,
            slot,
            blockNumberHex || blockTag
        ]
    });
    return data;
}



var $8ceqR = parcelRequire("8ceqR");

var $9UP4H = parcelRequire("9UP4H");

async function $837d17124076e235$export$ec0c6556a09b65b8(client, { blockHash: blockHash, blockNumber: blockNumber, blockTag: blockTag_, hash: hash, index: index }) {
    const blockTag = blockTag_ || "latest";
    const blockNumberHex = blockNumber !== undefined ? (0, $9UP4H.numberToHex)(blockNumber) : undefined;
    let transaction = null;
    if (hash) transaction = await client.request({
        method: "eth_getTransactionByHash",
        params: [
            hash
        ]
    }, {
        dedupe: true
    });
    else if (blockHash) transaction = await client.request({
        method: "eth_getTransactionByBlockHashAndIndex",
        params: [
            blockHash,
            (0, $9UP4H.numberToHex)(index)
        ]
    }, {
        dedupe: true
    });
    else if (blockNumberHex || blockTag) transaction = await client.request({
        method: "eth_getTransactionByBlockNumberAndIndex",
        params: [
            blockNumberHex || blockTag,
            (0, $9UP4H.numberToHex)(index)
        ]
    }, {
        dedupe: Boolean(blockNumberHex)
    });
    if (!transaction) throw new (0, $8ceqR.TransactionNotFoundError)({
        blockHash: blockHash,
        blockNumber: blockNumber,
        blockTag: blockTag,
        hash: hash,
        index: index
    });
    const format = client.chain?.formatters?.transaction?.format || (0, $bd3d0cf1db52600c$export$b02b16590d26dadc);
    return format(transaction);
}





async function $2be44f7cc652158d$export$e2ccc904d713b66d(client, { hash: hash, transactionReceipt: transactionReceipt }) {
    const [blockNumber, transaction] = await Promise.all([
        (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $ad8ffeddc2009a5e$export$9328b5c92c53a20e), "getBlockNumber")({}),
        hash ? (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $837d17124076e235$export$ec0c6556a09b65b8), "getTransaction")({
            hash: hash
        }) : undefined
    ]);
    const transactionBlockNumber = transactionReceipt?.blockNumber || transaction?.blockNumber;
    if (!transactionBlockNumber) return 0n;
    return blockNumber - transactionBlockNumber + 1n;
}




var $8ceqR = parcelRequire("8ceqR");

async function $7e91ce2c9b8cae84$export$6b1ceb3cd5f8b21f(client, { hash: hash }) {
    const receipt = await client.request({
        method: "eth_getTransactionReceipt",
        params: [
            hash
        ]
    }, {
        dedupe: true
    });
    if (!receipt) throw new (0, $8ceqR.TransactionReceiptNotFoundError)({
        hash: hash
    });
    const format = client.chain?.formatters?.transactionReceipt?.format || (0, $8a75a48a0283d821$export$30da670e49d6fc31);
    return format(receipt);
}





var $4I1xa = parcelRequire("4I1xa");

var $ktUQf = parcelRequire("ktUQf");

var $ahylX = parcelRequire("ahylX");



var $49mjM = parcelRequire("49mjM");
async function $49dfc3f6e4bdedcf$export$e8798d551e27a374(client, parameters) {
    const { abi: abi, address: address, args: args, dataSuffix: dataSuffix, functionName: functionName, ...callRequest } = parameters;
    const account = callRequest.account ? (0, $4I1xa.parseAccount)(callRequest.account) : client.account;
    const calldata = (0, $ahylX.encodeFunctionData)({
        abi: abi,
        args: args,
        functionName: functionName
    });
    try {
        const { data: data } = await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $49mjM.call), "call")({
            batch: false,
            data: `${calldata}${dataSuffix ? dataSuffix.replace("0x", "") : ""}`,
            to: address,
            ...callRequest,
            account: account
        });
        const result = (0, $ktUQf.decodeFunctionResult)({
            abi: abi,
            args: args,
            functionName: functionName,
            data: data || "0x"
        });
        const minimizedAbi = abi.filter((abiItem)=>"name" in abiItem && abiItem.name === parameters.functionName);
        return {
            result: result,
            request: {
                abi: minimizedAbi,
                address: address,
                args: args,
                dataSuffix: dataSuffix,
                functionName: functionName,
                ...callRequest,
                account: account
            }
        };
    } catch (error) {
        throw (0, $ed751cf9c83e9795$export$4414444aba6ddd8a)(error, {
            abi: abi,
            address: address,
            args: args,
            docsPath: "/docs/contract/simulateContract",
            functionName: functionName,
            sender: account?.address
        });
    }
}


/**
 * Destroys a [`Filter`](https://viem.sh/docs/glossary/types#filter).
 *
 * - Docs: https://viem.sh/docs/actions/public/uninstallFilter
 * - JSON-RPC Methods: [`eth_uninstallFilter`](https://ethereum.org/en/developers/docs/apis/json-rpc/#eth_uninstallFilter)
 *
 * Destroys a Filter that was created from one of the following Actions:
 * - [`createBlockFilter`](https://viem.sh/docs/actions/public/createBlockFilter)
 * - [`createEventFilter`](https://viem.sh/docs/actions/public/createEventFilter)
 * - [`createPendingTransactionFilter`](https://viem.sh/docs/actions/public/createPendingTransactionFilter)
 *
 * @param client - Client to use
 * @param parameters - {@link UninstallFilterParameters}
 * @returns A boolean indicating if the Filter was successfully uninstalled. {@link UninstallFilterReturnType}
 *
 * @example
 * import { createPublicClient, http } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { createPendingTransactionFilter, uninstallFilter } from 'viem/public'
 *
 * const filter = await createPendingTransactionFilter(client)
 * const uninstalled = await uninstallFilter(client, { filter })
 * // true
 */ async function $c2ed1e178102dd67$export$54eb7d691768f7f3(_client, { filter: filter }) {
    return filter.request({
        method: "eth_uninstallFilter",
        params: [
            filter.id
        ]
    });
}



var $bRe6l = parcelRequire("bRe6l");
const $31e3beddb327d7ff$export$39d5d904b514ff63 = "\x19Ethereum Signed Message:\n";



var $jCBOw = parcelRequire("jCBOw");

var $jBXg5 = parcelRequire("jBXg5");

var $9UP4H = parcelRequire("9UP4H");
function $f8a42d41fa33d96d$export$6c55de89b570d8ea(message_) {
    const message = (()=>{
        if (typeof message_ === "string") return (0, $9UP4H.stringToHex)(message_);
        if (typeof message_.raw === "string") return message_.raw;
        return (0, $9UP4H.bytesToHex)(message_.raw);
    })();
    const prefix = (0, $9UP4H.stringToHex)(`${(0, $31e3beddb327d7ff$export$39d5d904b514ff63)}${(0, $jBXg5.size)(message)}`);
    return (0, $jCBOw.concat)([
        prefix,
        message
    ]);
}


function $fb1da5fbfc2efd8f$export$d4c241cec96564c1(message, to_) {
    return (0, $bRe6l.keccak256)((0, $f8a42d41fa33d96d$export$6c55de89b570d8ea)(message), to_);
}



var $9nOfC = parcelRequire("9nOfC");

var $8NbpU = parcelRequire("8NbpU");

var $9dX4d = parcelRequire("9dX4d");

var $k2kLE = parcelRequire("k2kLE");

var $lqRRD = parcelRequire("lqRRD");

var $6gCNy = parcelRequire("6gCNy");

var $87Zkx = parcelRequire("87Zkx");

var $eFDiV = parcelRequire("eFDiV");

var $j6NiR = parcelRequire("j6NiR");
function $a3769ba65712e702$export$88282e62826c5bec(a_, b_) {
    const a = (0, $j6NiR.isHex)(a_) ? (0, $eFDiV.toBytes)(a_) : a_;
    const b = (0, $j6NiR.isHex)(b_) ? (0, $eFDiV.toBytes)(b_) : b_;
    return (0, $87Zkx.equalBytes)(a, b);
}



var $j6NiR = parcelRequire("j6NiR");

var $9UP4H = parcelRequire("9UP4H");

const $5b0d6d667ff6d854$export$8511286dc8754b90 = "0x6492649264926492649264926492649264926492649264926492649264926492";
const $5b0d6d667ff6d854$export$2f840586fca04b0e = "0x0000000000000000000000000000000000000000000000000000000000000000";



var $a7Rp0 = parcelRequire("a7Rp0");
function $e50190e45aa8332c$export$3d72f97f1f04bf61(signature) {
    return (0, $a7Rp0.sliceHex)(signature, -32) === (0, $5b0d6d667ff6d854$export$8511286dc8754b90);
}





var $keugB = parcelRequire("keugB");

var $jCBOw = parcelRequire("jCBOw");

var $eFDiV = parcelRequire("eFDiV");
function $f8df81c2bf3a6eb6$export$950b6c77371336fb(parameters) {
    const { address: address, data: data, signature: signature, to: to = "hex" } = parameters;
    const signature_ = (0, $jCBOw.concatHex)([
        (0, $keugB.encodeAbiParameters)([
            {
                type: "address"
            },
            {
                type: "bytes"
            },
            {
                type: "bytes"
            }
        ], [
            address,
            data,
            signature
        ]),
        (0, $5b0d6d667ff6d854$export$8511286dc8754b90)
    ]);
    if (to === "hex") return signature_;
    return (0, $eFDiV.hexToBytes)(signature_);
}



var $3VCvn = parcelRequire("3VCvn");

var $7Zv5I = parcelRequire("7Zv5I");

var $eFDiV = parcelRequire("eFDiV");
function $3dd5f1677d0ced89$export$97951e8415c34ee5({ r: r, s: s, to: to = "hex", v: v, yParity: yParity }) {
    const yParity_ = (()=>{
        if (yParity === 0 || yParity === 1) return yParity;
        if (v && (v === 27n || v === 28n || v >= 35n)) return v % 2n === 0n ? 1 : 0;
        throw new Error("Invalid `v` or `yParity` value");
    })();
    const signature = `0x${new (0, $3VCvn.secp256k1).Signature((0, $7Zv5I.hexToBigInt)(r), (0, $7Zv5I.hexToBigInt)(s)).toCompactHex()}${yParity_ === 0 ? "1b" : "1c"}`;
    if (to === "hex") return signature;
    return (0, $eFDiV.hexToBytes)(signature);
}



var $49mjM = parcelRequire("49mjM");
async function $4a40aea8ac42f698$export$434ee6408013d7f2(client, parameters) {
    const { address: address, factory: factory, factoryData: factoryData, hash: hash, signature: signature, ...rest } = parameters;
    const signatureHex = (()=>{
        if ((0, $j6NiR.isHex)(signature)) return signature;
        if (typeof signature === "object" && "r" in signature && "s" in signature) return (0, $3dd5f1677d0ced89$export$97951e8415c34ee5)(signature);
        return (0, $9UP4H.bytesToHex)(signature);
    })();
    const wrappedSignature = await (async ()=>{
        // If no `factory` or `factoryData` is provided, it is assumed that the
        // address is not a Smart Account, or the Smart Account is already deployed.
        if (!factory && !factoryData) return signatureHex;
        // If the signature is already wrapped, return the signature.
        if ((0, $e50190e45aa8332c$export$3d72f97f1f04bf61)(signatureHex)) return signatureHex;
        // If the Smart Account is not deployed, wrap the signature with a 6492 wrapper
        // to perform counterfactual validation.
        return (0, $f8df81c2bf3a6eb6$export$950b6c77371336fb)({
            address: factory,
            data: factoryData,
            signature: signatureHex
        });
    })();
    try {
        const { data: data } = await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $49mjM.call), "call")({
            data: (0, $k2kLE.encodeDeployData)({
                abi: (0, $9nOfC.universalSignatureValidatorAbi),
                args: [
                    address,
                    hash,
                    wrappedSignature
                ],
                bytecode: (0, $8NbpU.universalSignatureValidatorByteCode)
            }),
            ...rest
        });
        return (0, $a3769ba65712e702$export$88282e62826c5bec)(data ?? "0x0", "0x1");
    } catch (error) {
        // Fallback attempt to verify the signature via ECDSA recovery.
        try {
            const verified = (0, $6gCNy.isAddressEqual)((0, $lqRRD.getAddress)(address), await (0, $71781e96f30bd9c1$export$23cc18f96d8510e2)({
                hash: hash,
                signature: signature
            }));
            if (verified) return true;
        } catch  {}
        if (error instanceof (0, $9dX4d.CallExecutionError)) // if the execution fails, the signature was not valid and an internal method inside of the validator reverted
        // this can happen for many reasons, for example if signer can not be recovered from the signature
        // or if the signature has no valid format
        return false;
        throw error;
    }
}


async function $ad04f8b56a2c36ab$export$228d0e772cc158cb(client, { address: address, message: message, factory: factory, factoryData: factoryData, signature: signature, ...callRequest }) {
    const hash = (0, $fb1da5fbfc2efd8f$export$d4c241cec96564c1)(message);
    return (0, $4a40aea8ac42f698$export$434ee6408013d7f2)(client, {
        address: address,
        factory: factory,
        factoryData: factoryData,
        hash: hash,
        signature: signature,
        ...callRequest
    });
}


// Implementation forked and adapted from https://github.com/MetaMask/eth-sig-util/blob/main/src/sign-typed-data.ts

var $keugB = parcelRequire("keugB");

var $jCBOw = parcelRequire("jCBOw");

var $9UP4H = parcelRequire("9UP4H");

var $bRe6l = parcelRequire("bRe6l");

var $3TFRi = parcelRequire("3TFRi");

var $8j5HI = parcelRequire("8j5HI");

var $4rOic = parcelRequire("4rOic");

var $jBXg5 = parcelRequire("jBXg5");

var $9UP4H = parcelRequire("9UP4H");
const $e1850e59aea002d6$export$6cd562aaf6380f0e = /^(.*)\[([0-9]*)\]$/;
const $e1850e59aea002d6$export$94d7303c0d9f263a = /^bytes([1-9]|1[0-9]|2[0-9]|3[0-2])?$/;
const $e1850e59aea002d6$export$45902cc189596eef = /^(u?int)(8|16|24|32|40|48|56|64|72|80|88|96|104|112|120|128|136|144|152|160|168|176|184|192|200|208|216|224|232|240|248|256)?$/;




var $lOTY7 = parcelRequire("lOTY7");
function $63da8af71669a9b8$export$ce8e1cf733064451(parameters) {
    const { domain: domain_, message: message_, primaryType: primaryType, types: types } = parameters;
    const normalizeData = (struct, data_)=>{
        const data = {
            ...data_
        };
        for (const param of struct){
            const { name: name, type: type } = param;
            if (type === "address") data[name] = data[name].toLowerCase();
        }
        return data;
    };
    const domain = (()=>{
        if (!types.EIP712Domain) return {};
        if (!domain_) return {};
        return normalizeData(types.EIP712Domain, domain_);
    })();
    const message = (()=>{
        if (primaryType === "EIP712Domain") return undefined;
        return normalizeData(types[primaryType], message_);
    })();
    return (0, $lOTY7.stringify)({
        domain: domain,
        message: message,
        primaryType: primaryType,
        types: types
    });
}
function $63da8af71669a9b8$export$fac174f558903e26(parameters) {
    const { domain: domain, message: message, primaryType: primaryType, types: types } = parameters;
    const validateData = (struct, data)=>{
        for (const param of struct){
            const { name: name, type: type } = param;
            const value = data[name];
            const integerMatch = type.match((0, $e1850e59aea002d6$export$45902cc189596eef));
            if (integerMatch && (typeof value === "number" || typeof value === "bigint")) {
                const [_type, base, size_] = integerMatch;
                // If number cannot be cast to a sized hex value, it is out of range
                // and will throw.
                (0, $9UP4H.numberToHex)(value, {
                    signed: base === "int",
                    size: Number.parseInt(size_) / 8
                });
            }
            if (type === "address" && typeof value === "string" && !(0, $4rOic.isAddress)(value)) throw new (0, $8j5HI.InvalidAddressError)({
                address: value
            });
            const bytesMatch = type.match((0, $e1850e59aea002d6$export$94d7303c0d9f263a));
            if (bytesMatch) {
                const [_type, size_] = bytesMatch;
                if (size_ && (0, $jBXg5.size)(value) !== Number.parseInt(size_)) throw new (0, $3TFRi.BytesSizeMismatchError)({
                    expectedSize: Number.parseInt(size_),
                    givenSize: (0, $jBXg5.size)(value)
                });
            }
            const struct = types[type];
            if (struct) validateData(struct, value);
        }
    };
    // Validate domain types.
    if (types.EIP712Domain && domain) validateData(types.EIP712Domain, domain);
    // Validate message types.
    if (primaryType !== "EIP712Domain") validateData(types[primaryType], message);
}
function $63da8af71669a9b8$export$6a292159484ee032({ domain: domain }) {
    return [
        typeof domain?.name === "string" && {
            name: "name",
            type: "string"
        },
        domain?.version && {
            name: "version",
            type: "string"
        },
        typeof domain?.chainId === "number" && {
            name: "chainId",
            type: "uint256"
        },
        domain?.verifyingContract && {
            name: "verifyingContract",
            type: "address"
        },
        domain?.salt && {
            name: "salt",
            type: "bytes32"
        }
    ].filter(Boolean);
}
function $63da8af71669a9b8$export$a1ffff851efcaaba({ domain: domain }) {
    return (0, $f2301989e922c9f5$export$d4e887b08c47faea)({
        domain: domain,
        types: {
            EIP712Domain: $63da8af71669a9b8$export$6a292159484ee032({
                domain: domain
            })
        }
    });
}


function $f2301989e922c9f5$export$9e2bd399d9aaab56(parameters) {
    const { domain: domain = {}, message: message, primaryType: primaryType } = parameters;
    const types = {
        EIP712Domain: (0, $63da8af71669a9b8$export$6a292159484ee032)({
            domain: domain
        }),
        ...parameters.types
    };
    // Need to do a runtime validation check on addresses, byte ranges, integer ranges, etc
    // as we can't statically check this with TypeScript.
    (0, $63da8af71669a9b8$export$fac174f558903e26)({
        domain: domain,
        message: message,
        primaryType: primaryType,
        types: types
    });
    const parts = [
        "0x1901"
    ];
    if (domain) parts.push($f2301989e922c9f5$export$d4e887b08c47faea({
        domain: domain,
        types: types
    }));
    if (primaryType !== "EIP712Domain") parts.push($f2301989e922c9f5$export$4b8f67c208624fdf({
        data: message,
        primaryType: primaryType,
        types: types
    }));
    return (0, $bRe6l.keccak256)((0, $jCBOw.concat)(parts));
}
function $f2301989e922c9f5$export$d4e887b08c47faea({ domain: domain, types: types }) {
    return $f2301989e922c9f5$export$4b8f67c208624fdf({
        data: domain,
        primaryType: "EIP712Domain",
        types: types
    });
}
function $f2301989e922c9f5$export$4b8f67c208624fdf({ data: data, primaryType: primaryType, types: types }) {
    const encoded = $f2301989e922c9f5$var$encodeData({
        data: data,
        primaryType: primaryType,
        types: types
    });
    return (0, $bRe6l.keccak256)(encoded);
}
function $f2301989e922c9f5$var$encodeData({ data: data, primaryType: primaryType, types: types }) {
    const encodedTypes = [
        {
            type: "bytes32"
        }
    ];
    const encodedValues = [
        $f2301989e922c9f5$var$hashType({
            primaryType: primaryType,
            types: types
        })
    ];
    for (const field of types[primaryType]){
        const [type, value] = $f2301989e922c9f5$var$encodeField({
            types: types,
            name: field.name,
            type: field.type,
            value: data[field.name]
        });
        encodedTypes.push(type);
        encodedValues.push(value);
    }
    return (0, $keugB.encodeAbiParameters)(encodedTypes, encodedValues);
}
function $f2301989e922c9f5$var$hashType({ primaryType: primaryType, types: types }) {
    const encodedHashType = (0, $9UP4H.toHex)($f2301989e922c9f5$export$432cbecf661dce2b({
        primaryType: primaryType,
        types: types
    }));
    return (0, $bRe6l.keccak256)(encodedHashType);
}
function $f2301989e922c9f5$export$432cbecf661dce2b({ primaryType: primaryType, types: types }) {
    let result = "";
    const unsortedDeps = $f2301989e922c9f5$var$findTypeDependencies({
        primaryType: primaryType,
        types: types
    });
    unsortedDeps.delete(primaryType);
    const deps = [
        primaryType,
        ...Array.from(unsortedDeps).sort()
    ];
    for (const type of deps)result += `${type}(${types[type].map(({ name: name, type: t })=>`${t} ${name}`).join(",")})`;
    return result;
}
function $f2301989e922c9f5$var$findTypeDependencies({ primaryType: primaryType_, types: types }, results = new Set()) {
    const match = primaryType_.match(/^\w*/u);
    const primaryType = match?.[0];
    if (results.has(primaryType) || types[primaryType] === undefined) return results;
    results.add(primaryType);
    for (const field of types[primaryType])$f2301989e922c9f5$var$findTypeDependencies({
        primaryType: field.type,
        types: types
    }, results);
    return results;
}
function $f2301989e922c9f5$var$encodeField({ types: types, name: name, type: type, value: value }) {
    if (types[type] !== undefined) return [
        {
            type: "bytes32"
        },
        (0, $bRe6l.keccak256)($f2301989e922c9f5$var$encodeData({
            data: value,
            primaryType: type,
            types: types
        }))
    ];
    if (type === "bytes") {
        const prepend = value.length % 2 ? "0" : "";
        value = `0x${prepend + value.slice(2)}`;
        return [
            {
                type: "bytes32"
            },
            (0, $bRe6l.keccak256)(value)
        ];
    }
    if (type === "string") return [
        {
            type: "bytes32"
        },
        (0, $bRe6l.keccak256)((0, $9UP4H.toHex)(value))
    ];
    if (type.lastIndexOf("]") === type.length - 1) {
        const parsedType = type.slice(0, type.lastIndexOf("["));
        const typeValuePairs = value.map((item)=>$f2301989e922c9f5$var$encodeField({
                name: name,
                type: parsedType,
                types: types,
                value: item
            }));
        return [
            {
                type: "bytes32"
            },
            (0, $bRe6l.keccak256)((0, $keugB.encodeAbiParameters)(typeValuePairs.map(([t])=>t), typeValuePairs.map(([, v])=>v)))
        ];
    }
    return [
        {
            type: type
        },
        value
    ];
}



async function $988847ae3683e9b0$export$3603b1c1bcd76798(client, parameters) {
    const { address: address, factory: factory, factoryData: factoryData, signature: signature, message: message, primaryType: primaryType, types: types, domain: domain, ...callRequest } = parameters;
    const hash = (0, $f2301989e922c9f5$export$9e2bd399d9aaab56)({
        message: message,
        primaryType: primaryType,
        types: types,
        domain: domain
    });
    return (0, $4a40aea8ac42f698$export$434ee6408013d7f2)(client, {
        address: address,
        factory: factory,
        factoryData: factoryData,
        hash: hash,
        signature: signature,
        ...callRequest
    });
}




var $8ceqR = parcelRequire("8ceqR");

/** @internal */ const $ca407ba9ff2637a8$export$94ab3a05cb07971d = /*#__PURE__*/ new Map();
const $ca407ba9ff2637a8$export$b4a4aba7c5f97c17 = /*#__PURE__*/ new Map();
let $ca407ba9ff2637a8$var$callbackCount = 0;
function $ca407ba9ff2637a8$export$d1203567a167490e(observerId, callbacks, fn) {
    const callbackId = ++$ca407ba9ff2637a8$var$callbackCount;
    const getListeners = ()=>$ca407ba9ff2637a8$export$94ab3a05cb07971d.get(observerId) || [];
    const unsubscribe = ()=>{
        const listeners = getListeners();
        $ca407ba9ff2637a8$export$94ab3a05cb07971d.set(observerId, listeners.filter((cb)=>cb.id !== callbackId));
    };
    const unwatch = ()=>{
        const cleanup = $ca407ba9ff2637a8$export$b4a4aba7c5f97c17.get(observerId);
        if (getListeners().length === 1 && cleanup) cleanup();
        unsubscribe();
    };
    const listeners = getListeners();
    $ca407ba9ff2637a8$export$94ab3a05cb07971d.set(observerId, [
        ...listeners,
        {
            id: callbackId,
            fns: callbacks
        }
    ]);
    if (listeners && listeners.length > 0) return unwatch;
    const emit = {};
    for(const key in callbacks)emit[key] = (...args)=>{
        const listeners = getListeners();
        if (listeners.length === 0) return;
        for (const listener of listeners)listener.fns[key]?.(...args);
    };
    const cleanup = fn(emit);
    if (typeof cleanup === "function") $ca407ba9ff2637a8$export$b4a4aba7c5f97c17.set(observerId, cleanup);
    return unwatch;
}




var $lOTY7 = parcelRequire("lOTY7");




var $7Zv5I = parcelRequire("7Zv5I");



function $200df4d864ae01df$export$e0c10349b2c5e1d4(fn, { emitOnBegin: emitOnBegin, initialWaitTime: initialWaitTime, interval: interval }) {
    let active = true;
    const unwatch = ()=>active = false;
    const watch = async ()=>{
        let data = undefined;
        if (emitOnBegin) data = await fn({
            unpoll: unwatch
        });
        const initialWait = await initialWaitTime?.(data) ?? interval;
        await (0, $f3f44fe8be215f3b$export$5c069c93d2b7493f)(initialWait);
        const poll = async ()=>{
            if (!active) return;
            await fn({
                unpoll: unwatch
            });
            await (0, $f3f44fe8be215f3b$export$5c069c93d2b7493f)(interval);
            poll();
        };
        poll();
    };
    watch();
    return unwatch;
}



var $lOTY7 = parcelRequire("lOTY7");

function $aea0903f4797ac70$export$fc5f622dd0d82466(client, { emitOnBegin: emitOnBegin = false, emitMissed: emitMissed = false, onBlockNumber: onBlockNumber, onError: onError, poll: poll_, pollingInterval: pollingInterval = client.pollingInterval }) {
    const enablePolling = (()=>{
        if (typeof poll_ !== "undefined") return poll_;
        if (client.transport.type === "webSocket") return false;
        if (client.transport.type === "fallback" && client.transport.transports[0].config.type === "webSocket") return false;
        return true;
    })();
    let prevBlockNumber;
    const pollBlockNumber = ()=>{
        const observerId = (0, $lOTY7.stringify)([
            "watchBlockNumber",
            client.uid,
            emitOnBegin,
            emitMissed,
            pollingInterval
        ]);
        return (0, $ca407ba9ff2637a8$export$d1203567a167490e)(observerId, {
            onBlockNumber: onBlockNumber,
            onError: onError
        }, (emit)=>(0, $200df4d864ae01df$export$e0c10349b2c5e1d4)(async ()=>{
                try {
                    const blockNumber = await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $ad8ffeddc2009a5e$export$9328b5c92c53a20e), "getBlockNumber")({
                        cacheTime: 0
                    });
                    if (prevBlockNumber) {
                        // If the current block number is the same as the previous,
                        // we can skip.
                        if (blockNumber === prevBlockNumber) return;
                        // If we have missed out on some previous blocks, and the
                        // `emitMissed` flag is truthy, let's emit those blocks.
                        if (blockNumber - prevBlockNumber > 1 && emitMissed) for(let i = prevBlockNumber + 1n; i < blockNumber; i++){
                            emit.onBlockNumber(i, prevBlockNumber);
                            prevBlockNumber = i;
                        }
                    }
                    // If the next block number is greater than the previous,
                    // it is not in the past, and we can emit the new block number.
                    if (!prevBlockNumber || blockNumber > prevBlockNumber) {
                        emit.onBlockNumber(blockNumber, prevBlockNumber);
                        prevBlockNumber = blockNumber;
                    }
                } catch (err) {
                    emit.onError?.(err);
                }
            }, {
                emitOnBegin: emitOnBegin,
                interval: pollingInterval
            }));
    };
    const subscribeBlockNumber = ()=>{
        const observerId = (0, $lOTY7.stringify)([
            "watchBlockNumber",
            client.uid,
            emitOnBegin,
            emitMissed
        ]);
        return (0, $ca407ba9ff2637a8$export$d1203567a167490e)(observerId, {
            onBlockNumber: onBlockNumber,
            onError: onError
        }, (emit)=>{
            let active = true;
            let unsubscribe = ()=>active = false;
            (async ()=>{
                try {
                    const transport = (()=>{
                        if (client.transport.type === "fallback") {
                            const transport = client.transport.transports.find((transport)=>transport.config.type === "webSocket");
                            if (!transport) return client.transport;
                            return transport.value;
                        }
                        return client.transport;
                    })();
                    const { unsubscribe: unsubscribe_ } = await transport.subscribe({
                        params: [
                            "newHeads"
                        ],
                        onData (data) {
                            if (!active) return;
                            const blockNumber = (0, $7Zv5I.hexToBigInt)(data.result?.number);
                            emit.onBlockNumber(blockNumber, prevBlockNumber);
                            prevBlockNumber = blockNumber;
                        },
                        onError (error) {
                            emit.onError?.(error);
                        }
                    });
                    unsubscribe = unsubscribe_;
                    if (!active) unsubscribe();
                } catch (err) {
                    onError?.(err);
                }
            })();
            return ()=>unsubscribe();
        });
    };
    return enablePolling ? pollBlockNumber() : subscribeBlockNumber();
}


async function $94fe8f93f76c1ac5$export$694ec9bdf0bb55cf(client, { confirmations: confirmations = 1, hash: hash, onReplaced: onReplaced, pollingInterval: pollingInterval = client.pollingInterval, retryCount: retryCount = 6, retryDelay: retryDelay = ({ count: count })=>~~(1 << count) * 200, timeout: timeout }) {
    const observerId = (0, $lOTY7.stringify)([
        "waitForTransactionReceipt",
        client.uid,
        hash
    ]);
    let count = 0;
    let transaction;
    let replacedTransaction;
    let receipt;
    let retrying = false;
    return new Promise((resolve, reject)=>{
        if (timeout) setTimeout(()=>reject(new (0, $8ceqR.WaitForTransactionReceiptTimeoutError)({
                hash: hash
            })), timeout);
        const _unobserve = (0, $ca407ba9ff2637a8$export$d1203567a167490e)(observerId, {
            onReplaced: onReplaced,
            resolve: resolve,
            reject: reject
        }, (emit)=>{
            const _unwatch = (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $aea0903f4797ac70$export$fc5f622dd0d82466), "watchBlockNumber")({
                emitMissed: true,
                emitOnBegin: true,
                poll: true,
                pollingInterval: pollingInterval,
                async onBlockNumber (blockNumber_) {
                    const done = (fn)=>{
                        _unwatch();
                        fn();
                        _unobserve();
                    };
                    let blockNumber = blockNumber_;
                    if (retrying) return;
                    if (count > retryCount) done(()=>emit.reject(new (0, $8ceqR.WaitForTransactionReceiptTimeoutError)({
                            hash: hash
                        })));
                    try {
                        // If we already have a valid receipt, let's check if we have enough
                        // confirmations. If we do, then we can resolve.
                        if (receipt) {
                            if (confirmations > 1 && (!receipt.blockNumber || blockNumber - receipt.blockNumber + 1n < confirmations)) return;
                            done(()=>emit.resolve(receipt));
                            return;
                        }
                        // Get the transaction to check if it's been replaced.
                        // We need to retry as some RPC Providers may be slow to sync
                        // up mined transactions.
                        if (!transaction) {
                            retrying = true;
                            await (0, $019d66023bd7f6ee$export$188df5ecf8e7961a)(async ()=>{
                                transaction = await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $837d17124076e235$export$ec0c6556a09b65b8), "getTransaction")({
                                    hash: hash
                                });
                                if (transaction.blockNumber) blockNumber = transaction.blockNumber;
                            }, {
                                delay: retryDelay,
                                retryCount: retryCount
                            });
                            retrying = false;
                        }
                        // Get the receipt to check if it's been processed.
                        receipt = await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $7e91ce2c9b8cae84$export$6b1ceb3cd5f8b21f), "getTransactionReceipt")({
                            hash: hash
                        });
                        // Check if we have enough confirmations. If not, continue polling.
                        if (confirmations > 1 && (!receipt.blockNumber || blockNumber - receipt.blockNumber + 1n < confirmations)) return;
                        done(()=>emit.resolve(receipt));
                    } catch (err) {
                        // If the receipt is not found, the transaction will be pending.
                        // We need to check if it has potentially been replaced.
                        if (err instanceof (0, $8ceqR.TransactionNotFoundError) || err instanceof (0, $8ceqR.TransactionReceiptNotFoundError)) {
                            if (!transaction) {
                                retrying = false;
                                return;
                            }
                            try {
                                replacedTransaction = transaction;
                                // Let's retrieve the transactions from the current block.
                                // We need to retry as some RPC Providers may be slow to sync
                                // up mined blocks.
                                retrying = true;
                                const block = await (0, $019d66023bd7f6ee$export$188df5ecf8e7961a)(()=>(0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $afc05e8a9d5120bd$export$ea0af84ed2e77902), "getBlock")({
                                        blockNumber: blockNumber,
                                        includeTransactions: true
                                    }), {
                                    delay: retryDelay,
                                    retryCount: retryCount,
                                    shouldRetry: ({ error: error })=>error instanceof (0, $fcdf892879e784ec$export$f5a00468af285e38)
                                });
                                retrying = false;
                                const replacementTransaction = block.transactions.find(({ from: from, nonce: nonce })=>from === replacedTransaction.from && nonce === replacedTransaction.nonce);
                                // If we couldn't find a replacement transaction, continue polling.
                                if (!replacementTransaction) return;
                                // If we found a replacement transaction, return it's receipt.
                                receipt = await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $7e91ce2c9b8cae84$export$6b1ceb3cd5f8b21f), "getTransactionReceipt")({
                                    hash: replacementTransaction.hash
                                });
                                // Check if we have enough confirmations. If not, continue polling.
                                if (confirmations > 1 && (!receipt.blockNumber || blockNumber - receipt.blockNumber + 1n < confirmations)) return;
                                let reason = "replaced";
                                if (replacementTransaction.to === replacedTransaction.to && replacementTransaction.value === replacedTransaction.value) reason = "repriced";
                                else if (replacementTransaction.from === replacementTransaction.to && replacementTransaction.value === 0n) reason = "cancelled";
                                done(()=>{
                                    emit.onReplaced?.({
                                        reason: reason,
                                        replacedTransaction: replacedTransaction,
                                        transaction: replacementTransaction,
                                        transactionReceipt: receipt
                                    });
                                    emit.resolve(receipt);
                                });
                            } catch (err_) {
                                done(()=>emit.reject(err_));
                            }
                        } else done(()=>emit.reject(err));
                    } finally{
                        count++;
                    }
                }
            });
        });
    });
}








var $lOTY7 = parcelRequire("lOTY7");

function $9c8024cff68be9da$export$f04bd2888af8db20(client, { blockTag: blockTag = "latest", emitMissed: emitMissed = false, emitOnBegin: emitOnBegin = false, onBlock: onBlock, onError: onError, includeTransactions: includeTransactions_, poll: poll_, pollingInterval: pollingInterval = client.pollingInterval }) {
    const enablePolling = (()=>{
        if (typeof poll_ !== "undefined") return poll_;
        if (client.transport.type === "webSocket") return false;
        if (client.transport.type === "fallback" && client.transport.transports[0].config.type === "webSocket") return false;
        return true;
    })();
    const includeTransactions = includeTransactions_ ?? false;
    let prevBlock;
    const pollBlocks = ()=>{
        const observerId = (0, $lOTY7.stringify)([
            "watchBlocks",
            client.uid,
            blockTag,
            emitMissed,
            emitOnBegin,
            includeTransactions,
            pollingInterval
        ]);
        return (0, $ca407ba9ff2637a8$export$d1203567a167490e)(observerId, {
            onBlock: onBlock,
            onError: onError
        }, (emit)=>(0, $200df4d864ae01df$export$e0c10349b2c5e1d4)(async ()=>{
                try {
                    const block = await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $afc05e8a9d5120bd$export$ea0af84ed2e77902), "getBlock")({
                        blockTag: blockTag,
                        includeTransactions: includeTransactions
                    });
                    if (block.number && prevBlock?.number) {
                        // If the current block number is the same as the previous,
                        // we can skip.
                        if (block.number === prevBlock.number) return;
                        // If we have missed out on some previous blocks, and the
                        // `emitMissed` flag is truthy, let's emit those blocks.
                        if (block.number - prevBlock.number > 1 && emitMissed) for(let i = prevBlock?.number + 1n; i < block.number; i++){
                            const block = await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $afc05e8a9d5120bd$export$ea0af84ed2e77902), "getBlock")({
                                blockNumber: i,
                                includeTransactions: includeTransactions
                            });
                            emit.onBlock(block, prevBlock);
                            prevBlock = block;
                        }
                    }
                    if (// If no previous block exists, emit.
                    !prevBlock?.number || // If the block tag is "pending" with no block number, emit.
                    blockTag === "pending" && !block?.number || // If the next block number is greater than the previous block number, emit.
                    // We don't want to emit blocks in the past.
                    block.number && block.number > prevBlock.number) {
                        emit.onBlock(block, prevBlock);
                        prevBlock = block;
                    }
                } catch (err) {
                    emit.onError?.(err);
                }
            }, {
                emitOnBegin: emitOnBegin,
                interval: pollingInterval
            }));
    };
    const subscribeBlocks = ()=>{
        let active = true;
        let unsubscribe = ()=>active = false;
        (async ()=>{
            try {
                const transport = (()=>{
                    if (client.transport.type === "fallback") {
                        const transport = client.transport.transports.find((transport)=>transport.config.type === "webSocket");
                        if (!transport) return client.transport;
                        return transport.value;
                    }
                    return client.transport;
                })();
                const { unsubscribe: unsubscribe_ } = await transport.subscribe({
                    params: [
                        "newHeads"
                    ],
                    onData (data) {
                        if (!active) return;
                        const format = client.chain?.formatters?.block?.format || (0, $8d786868837e77db$export$ba1152bc4017d62a);
                        const block = format(data.result);
                        onBlock(block, prevBlock);
                        prevBlock = block;
                    },
                    onError (error) {
                        onError?.(error);
                    }
                });
                unsubscribe = unsubscribe_;
                if (!active) unsubscribe();
            } catch (err) {
                onError?.(err);
            }
        })();
        return ()=>unsubscribe();
    };
    return enablePolling ? pollBlocks() : subscribeBlocks();
}



var $3TFRi = parcelRequire("3TFRi");

var $k7R6B = parcelRequire("k7R6B");







var $lOTY7 = parcelRequire("lOTY7");





function $c354e9b44b11811f$export$2a02a63daa2df376(client, parameters) {
    const { abi: abi, address: address, args: args, batch: batch = true, eventName: eventName, fromBlock: fromBlock, onError: onError, onLogs: onLogs, poll: poll_, pollingInterval: pollingInterval = client.pollingInterval, strict: strict_ } = parameters;
    const enablePolling = (()=>{
        if (typeof poll_ !== "undefined") return poll_;
        if (typeof fromBlock === "bigint") return true;
        if (client.transport.type === "webSocket") return false;
        if (client.transport.type === "fallback" && client.transport.transports[0].config.type === "webSocket") return false;
        return true;
    })();
    const pollContractEvent = ()=>{
        const strict = strict_ ?? false;
        const observerId = (0, $lOTY7.stringify)([
            "watchContractEvent",
            address,
            args,
            batch,
            client.uid,
            eventName,
            pollingInterval,
            strict,
            fromBlock
        ]);
        return (0, $ca407ba9ff2637a8$export$d1203567a167490e)(observerId, {
            onLogs: onLogs,
            onError: onError
        }, (emit)=>{
            let previousBlockNumber;
            if (fromBlock !== undefined) previousBlockNumber = fromBlock - 1n;
            let filter;
            let initialized = false;
            const unwatch = (0, $200df4d864ae01df$export$e0c10349b2c5e1d4)(async ()=>{
                if (!initialized) {
                    try {
                        filter = await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $ddde17ea7e9ef03d$export$36f99fdb90149e8b), "createContractEventFilter")({
                            abi: abi,
                            address: address,
                            args: args,
                            eventName: eventName,
                            strict: strict,
                            fromBlock: fromBlock
                        });
                    } catch  {}
                    initialized = true;
                    return;
                }
                try {
                    let logs;
                    if (filter) logs = await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $9d97866840568f1f$export$e69fa84ce52a94fd), "getFilterChanges")({
                        filter: filter
                    });
                    else {
                        // If the filter doesn't exist, we will fall back to use `getLogs`.
                        // The fall back exists because some RPC Providers do not support filters.
                        // Fetch the block number to use for `getLogs`.
                        const blockNumber = await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $ad8ffeddc2009a5e$export$9328b5c92c53a20e), "getBlockNumber")({});
                        // If the block number has changed, we will need to fetch the logs.
                        // If the block number doesn't exist, we are yet to reach the first poll interval,
                        // so do not emit any logs.
                        if (previousBlockNumber && previousBlockNumber < blockNumber) logs = await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $b6df579f3c0f85d0$export$1e175955db02d8d), "getContractEvents")({
                            abi: abi,
                            address: address,
                            args: args,
                            eventName: eventName,
                            fromBlock: previousBlockNumber + 1n,
                            toBlock: blockNumber,
                            strict: strict
                        });
                        else logs = [];
                        previousBlockNumber = blockNumber;
                    }
                    if (logs.length === 0) return;
                    if (batch) emit.onLogs(logs);
                    else for (const log of logs)emit.onLogs([
                        log
                    ]);
                } catch (err) {
                    // If a filter has been set and gets uninstalled, providers will throw an InvalidInput error.
                    // Reinitialize the filter when this occurs
                    if (filter && err instanceof (0, $k7R6B.InvalidInputRpcError)) initialized = false;
                    emit.onError?.(err);
                }
            }, {
                emitOnBegin: true,
                interval: pollingInterval
            });
            return async ()=>{
                if (filter) await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $c2ed1e178102dd67$export$54eb7d691768f7f3), "uninstallFilter")({
                    filter: filter
                });
                unwatch();
            };
        });
    };
    const subscribeContractEvent = ()=>{
        const strict = strict_ ?? false;
        const observerId = (0, $lOTY7.stringify)([
            "watchContractEvent",
            address,
            args,
            batch,
            client.uid,
            eventName,
            pollingInterval,
            strict
        ]);
        let active = true;
        let unsubscribe = ()=>active = false;
        return (0, $ca407ba9ff2637a8$export$d1203567a167490e)(observerId, {
            onLogs: onLogs,
            onError: onError
        }, (emit)=>{
            (async ()=>{
                try {
                    const transport = (()=>{
                        if (client.transport.type === "fallback") {
                            const transport = client.transport.transports.find((transport)=>transport.config.type === "webSocket");
                            if (!transport) return client.transport;
                            return transport.value;
                        }
                        return client.transport;
                    })();
                    const topics = eventName ? (0, $a41ca3912e02661b$export$64e9f7ca5ce29acd)({
                        abi: abi,
                        eventName: eventName,
                        args: args
                    }) : [];
                    const { unsubscribe: unsubscribe_ } = await transport.subscribe({
                        params: [
                            "logs",
                            {
                                address: address,
                                topics: topics
                            }
                        ],
                        onData (data) {
                            if (!active) return;
                            const log = data.result;
                            try {
                                const { eventName: eventName, args: args } = (0, $d0fbcd7c3a384abc$export$ec0597e81db3d947)({
                                    abi: abi,
                                    data: log.data,
                                    topics: log.topics,
                                    strict: strict_
                                });
                                const formatted = (0, $85c39d465bc84f83$export$fccdbdc2b9d7893)(log, {
                                    args: args,
                                    eventName: eventName
                                });
                                emit.onLogs([
                                    formatted
                                ]);
                            } catch (err) {
                                let eventName;
                                let isUnnamed;
                                if (err instanceof (0, $3TFRi.DecodeLogDataMismatch) || err instanceof (0, $3TFRi.DecodeLogTopicsMismatch)) {
                                    // If strict mode is on, and log data/topics do not match event definition, skip.
                                    if (strict_) return;
                                    eventName = err.abiItem.name;
                                    isUnnamed = err.abiItem.inputs?.some((x)=>!("name" in x && x.name));
                                }
                                // Set args to empty if there is an error decoding (e.g. indexed/non-indexed params mismatch).
                                const formatted = (0, $85c39d465bc84f83$export$fccdbdc2b9d7893)(log, {
                                    args: isUnnamed ? [] : {},
                                    eventName: eventName
                                });
                                emit.onLogs([
                                    formatted
                                ]);
                            }
                        },
                        onError (error) {
                            emit.onError?.(error);
                        }
                    });
                    unsubscribe = unsubscribe_;
                    if (!active) unsubscribe();
                } catch (err) {
                    onError?.(err);
                }
            })();
            return ()=>unsubscribe();
        });
    };
    return enablePolling ? pollContractEvent() : subscribeContractEvent();
}






var $lOTY7 = parcelRequire("lOTY7");

var $3TFRi = parcelRequire("3TFRi");

var $k7R6B = parcelRequire("k7R6B");








function $12c4c29f90271391$export$f6260ad5441916b4(client, { address: address, args: args, batch: batch = true, event: event, events: events, fromBlock: fromBlock, onError: onError, onLogs: onLogs, poll: poll_, pollingInterval: pollingInterval = client.pollingInterval, strict: strict_ }) {
    const enablePolling = (()=>{
        if (typeof poll_ !== "undefined") return poll_;
        if (typeof fromBlock === "bigint") return true;
        if (client.transport.type === "webSocket") return false;
        if (client.transport.type === "fallback" && client.transport.transports[0].config.type === "webSocket") return false;
        return true;
    })();
    const strict = strict_ ?? false;
    const pollEvent = ()=>{
        const observerId = (0, $lOTY7.stringify)([
            "watchEvent",
            address,
            args,
            batch,
            client.uid,
            event,
            pollingInterval,
            fromBlock
        ]);
        return (0, $ca407ba9ff2637a8$export$d1203567a167490e)(observerId, {
            onLogs: onLogs,
            onError: onError
        }, (emit)=>{
            let previousBlockNumber;
            if (fromBlock !== undefined) previousBlockNumber = fromBlock - 1n;
            let filter;
            let initialized = false;
            const unwatch = (0, $200df4d864ae01df$export$e0c10349b2c5e1d4)(async ()=>{
                if (!initialized) {
                    try {
                        filter = await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $4ec0fdb59d57a0ab$export$977ab14bbccde633), "createEventFilter")({
                            address: address,
                            args: args,
                            event: event,
                            events: events,
                            strict: strict,
                            fromBlock: fromBlock
                        });
                    } catch  {}
                    initialized = true;
                    return;
                }
                try {
                    let logs;
                    if (filter) logs = await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $9d97866840568f1f$export$e69fa84ce52a94fd), "getFilterChanges")({
                        filter: filter
                    });
                    else {
                        // If the filter doesn't exist, we will fall back to use `getLogs`.
                        // The fall back exists because some RPC Providers do not support filters.
                        // Fetch the block number to use for `getLogs`.
                        const blockNumber = await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $ad8ffeddc2009a5e$export$9328b5c92c53a20e), "getBlockNumber")({});
                        // If the block number has changed, we will need to fetch the logs.
                        // If the block number doesn't exist, we are yet to reach the first poll interval,
                        // so do not emit any logs.
                        if (previousBlockNumber && previousBlockNumber !== blockNumber) logs = await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $8dadc4b63f7c1440$export$cb5260c832aab30a), "getLogs")({
                            address: address,
                            args: args,
                            event: event,
                            events: events,
                            fromBlock: previousBlockNumber + 1n,
                            toBlock: blockNumber
                        });
                        else logs = [];
                        previousBlockNumber = blockNumber;
                    }
                    if (logs.length === 0) return;
                    if (batch) emit.onLogs(logs);
                    else for (const log of logs)emit.onLogs([
                        log
                    ]);
                } catch (err) {
                    // If a filter has been set and gets uninstalled, providers will throw an InvalidInput error.
                    // Reinitialize the filter when this occurs
                    if (filter && err instanceof (0, $k7R6B.InvalidInputRpcError)) initialized = false;
                    emit.onError?.(err);
                }
            }, {
                emitOnBegin: true,
                interval: pollingInterval
            });
            return async ()=>{
                if (filter) await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $c2ed1e178102dd67$export$54eb7d691768f7f3), "uninstallFilter")({
                    filter: filter
                });
                unwatch();
            };
        });
    };
    const subscribeEvent = ()=>{
        let active = true;
        let unsubscribe = ()=>active = false;
        (async ()=>{
            try {
                const transport = (()=>{
                    if (client.transport.type === "fallback") {
                        const transport = client.transport.transports.find((transport)=>transport.config.type === "webSocket");
                        if (!transport) return client.transport;
                        return transport.value;
                    }
                    return client.transport;
                })();
                const events_ = events ?? (event ? [
                    event
                ] : undefined);
                let topics = [];
                if (events_) {
                    const encoded = events_.flatMap((event)=>(0, $a41ca3912e02661b$export$64e9f7ca5ce29acd)({
                            abi: [
                                event
                            ],
                            eventName: event.name,
                            args: args
                        }));
                    // TODO: Clean up type casting
                    topics = [
                        encoded
                    ];
                    if (event) topics = topics[0];
                }
                const { unsubscribe: unsubscribe_ } = await transport.subscribe({
                    params: [
                        "logs",
                        {
                            address: address,
                            topics: topics
                        }
                    ],
                    onData (data) {
                        if (!active) return;
                        const log = data.result;
                        try {
                            const { eventName: eventName, args: args } = (0, $d0fbcd7c3a384abc$export$ec0597e81db3d947)({
                                abi: events_ ?? [],
                                data: log.data,
                                topics: log.topics,
                                strict: strict
                            });
                            const formatted = (0, $85c39d465bc84f83$export$fccdbdc2b9d7893)(log, {
                                args: args,
                                eventName: eventName
                            });
                            onLogs([
                                formatted
                            ]);
                        } catch (err) {
                            let eventName;
                            let isUnnamed;
                            if (err instanceof (0, $3TFRi.DecodeLogDataMismatch) || err instanceof (0, $3TFRi.DecodeLogTopicsMismatch)) {
                                // If strict mode is on, and log data/topics do not match event definition, skip.
                                if (strict_) return;
                                eventName = err.abiItem.name;
                                isUnnamed = err.abiItem.inputs?.some((x)=>!("name" in x && x.name));
                            }
                            // Set args to empty if there is an error decoding (e.g. indexed/non-indexed params mismatch).
                            const formatted = (0, $85c39d465bc84f83$export$fccdbdc2b9d7893)(log, {
                                args: isUnnamed ? [] : {},
                                eventName: eventName
                            });
                            onLogs([
                                formatted
                            ]);
                        }
                    },
                    onError (error) {
                        onError?.(error);
                    }
                });
                unsubscribe = unsubscribe_;
                if (!active) unsubscribe();
            } catch (err) {
                onError?.(err);
            }
        })();
        return ()=>unsubscribe();
    };
    return enablePolling ? pollEvent() : subscribeEvent();
}






var $lOTY7 = parcelRequire("lOTY7");



function $7a01007af70ab085$export$223080172c87e789(client, { batch: batch = true, onError: onError, onTransactions: onTransactions, poll: poll_, pollingInterval: pollingInterval = client.pollingInterval }) {
    const enablePolling = typeof poll_ !== "undefined" ? poll_ : client.transport.type !== "webSocket";
    const pollPendingTransactions = ()=>{
        const observerId = (0, $lOTY7.stringify)([
            "watchPendingTransactions",
            client.uid,
            batch,
            pollingInterval
        ]);
        return (0, $ca407ba9ff2637a8$export$d1203567a167490e)(observerId, {
            onTransactions: onTransactions,
            onError: onError
        }, (emit)=>{
            let filter;
            const unwatch = (0, $200df4d864ae01df$export$e0c10349b2c5e1d4)(async ()=>{
                try {
                    if (!filter) try {
                        filter = await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $20a91266b6901c25$export$d455ed04c3e85241), "createPendingTransactionFilter")({});
                        return;
                    } catch (err) {
                        unwatch();
                        throw err;
                    }
                    const hashes = await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $9d97866840568f1f$export$e69fa84ce52a94fd), "getFilterChanges")({
                        filter: filter
                    });
                    if (hashes.length === 0) return;
                    if (batch) emit.onTransactions(hashes);
                    else for (const hash of hashes)emit.onTransactions([
                        hash
                    ]);
                } catch (err) {
                    emit.onError?.(err);
                }
            }, {
                emitOnBegin: true,
                interval: pollingInterval
            });
            return async ()=>{
                if (filter) await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $c2ed1e178102dd67$export$54eb7d691768f7f3), "uninstallFilter")({
                    filter: filter
                });
                unwatch();
            };
        });
    };
    const subscribePendingTransactions = ()=>{
        let active = true;
        let unsubscribe = ()=>active = false;
        (async ()=>{
            try {
                const { unsubscribe: unsubscribe_ } = await client.transport.subscribe({
                    params: [
                        "newPendingTransactions"
                    ],
                    onData (data) {
                        if (!active) return;
                        const transaction = data.result;
                        onTransactions([
                            transaction
                        ]);
                    },
                    onError (error) {
                        onError?.(error);
                    }
                });
                unsubscribe = unsubscribe_;
                if (!active) unsubscribe();
            } catch (err) {
                onError?.(err);
            }
        })();
        return ()=>unsubscribe();
    };
    return enablePolling ? pollPendingTransactions() : subscribePendingTransactions();
}



/**
 * @description Parses EIP-4361 formatted message into message fields object.
 *
 * @see https://eips.ethereum.org/EIPS/eip-4361
 *
 * @returns EIP-4361 fields object
 */ function $d14d7737da9e6d81$export$ebbfe406e131b6f6(message) {
    const { scheme: scheme, statement: statement, ...prefix } = message.match($d14d7737da9e6d81$var$prefixRegex)?.groups ?? {};
    const { chainId: chainId, expirationTime: expirationTime, issuedAt: issuedAt, notBefore: notBefore, requestId: requestId, ...suffix } = message.match($d14d7737da9e6d81$var$suffixRegex)?.groups ?? {};
    const resources = message.split("Resources:")[1]?.split("\n- ").slice(1);
    return {
        ...prefix,
        ...suffix,
        ...chainId ? {
            chainId: Number(chainId)
        } : {},
        ...expirationTime ? {
            expirationTime: new Date(expirationTime)
        } : {},
        ...issuedAt ? {
            issuedAt: new Date(issuedAt)
        } : {},
        ...notBefore ? {
            notBefore: new Date(notBefore)
        } : {},
        ...requestId ? {
            requestId: requestId
        } : {},
        ...resources ? {
            resources: resources
        } : {},
        ...scheme ? {
            scheme: scheme
        } : {},
        ...statement ? {
            statement: statement
        } : {}
    };
}
// https://regexr.com/80gdj
const $d14d7737da9e6d81$var$prefixRegex = /^(?:(?<scheme>[a-zA-Z][a-zA-Z0-9+-.]*):\/\/)?(?<domain>[a-zA-Z0-9+-.]*(?::[0-9]{1,5})?) (?:wants you to sign in with your Ethereum account:\n)(?<address>0x[a-fA-F0-9]{40})\n\n(?:(?<statement>.*)\n\n)?/;
// https://regexr.com/80gf9
const $d14d7737da9e6d81$var$suffixRegex = /(?:URI: (?<uri>.+))\n(?:Version: (?<version>.+))\n(?:Chain ID: (?<chainId>\d+))\n(?:Nonce: (?<nonce>[a-zA-Z0-9]+))\n(?:Issued At: (?<issuedAt>.+))(?:\nExpiration Time: (?<expirationTime>.+))?(?:\nNot Before: (?<notBefore>.+))?(?:\nRequest ID: (?<requestId>.+))?/;



var $6gCNy = parcelRequire("6gCNy");
function $760c3692a4448e48$export$d3bfd63549572667(parameters) {
    const { address: address, domain: domain, message: message, nonce: nonce, scheme: scheme, time: time = new Date() } = parameters;
    if (domain && message.domain !== domain) return false;
    if (nonce && message.nonce !== nonce) return false;
    if (scheme && message.scheme !== scheme) return false;
    if (message.expirationTime && time >= message.expirationTime) return false;
    if (message.notBefore && time < message.notBefore) return false;
    try {
        if (!message.address) return false;
        if (address && !(0, $6gCNy.isAddressEqual)(message.address, address)) return false;
    } catch  {
        return false;
    }
    return true;
}



async function $c634368cbd527283$export$10c59ebee3bc23e3(client, parameters) {
    const { address: address, domain: domain, message: message, nonce: nonce, scheme: scheme, signature: signature, time: time = new Date(), ...callRequest } = parameters;
    const parsed = (0, $d14d7737da9e6d81$export$ebbfe406e131b6f6)(message);
    if (!parsed.address) return false;
    const isValid = (0, $760c3692a4448e48$export$d3bfd63549572667)({
        address: address,
        domain: domain,
        message: parsed,
        nonce: nonce,
        scheme: scheme,
        time: time
    });
    if (!isValid) return false;
    const hash = (0, $fb1da5fbfc2efd8f$export$d4c241cec96564c1)(message);
    return (0, $4a40aea8ac42f698$export$434ee6408013d7f2)(client, {
        address: parsed.address,
        hash: hash,
        signature: signature,
        ...callRequest
    });
}



/**
 * Sends a **signed** transaction to the network
 *
 * - Docs: https://viem.sh/docs/actions/wallet/sendRawTransaction
 * - JSON-RPC Method: [`eth_sendRawTransaction`](https://ethereum.github.io/execution-apis/api-documentation/)
 *
 * @param client - Client to use
 * @param parameters - {@link SendRawTransactionParameters}
 * @returns The transaction hash. {@link SendRawTransactionReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { sendRawTransaction } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 *
 * const hash = await sendRawTransaction(client, {
 *   serializedTransaction: '0x02f850018203118080825208808080c080a04012522854168b27e5dc3d5839bab5e6b39e1a0ffd343901ce1622e3d64b48f1a04e00902ae0502c4728cbf12156290df99c3ed7de85b1dbfe20b5c36931733a33'
 * })
 */ async function $d44987e9a6831d49$export$4e309754b4830e29(client, { serializedTransaction: serializedTransaction }) {
    return client.request({
        method: "eth_sendRawTransaction",
        params: [
            serializedTransaction
        ]
    }, {
        retryCount: 0
    });
}


function $246243838b8fbd6a$export$8705b583fa097d24(client) {
    return {
        call: (args)=>(0, $49mjM.call)(client, args),
        createBlockFilter: ()=>(0, $d31664d80afe85d0$export$651edd5ecf84bf98)(client),
        createContractEventFilter: (args)=>(0, $ddde17ea7e9ef03d$export$36f99fdb90149e8b)(client, args),
        createEventFilter: (args)=>(0, $4ec0fdb59d57a0ab$export$977ab14bbccde633)(client, args),
        createPendingTransactionFilter: ()=>(0, $20a91266b6901c25$export$d455ed04c3e85241)(client),
        estimateContractGas: (args)=>(0, $1ec63edfff7aa371$export$7b896b3a3695de87)(client, args),
        estimateGas: (args)=>(0, $6564eb1e7fd1d145$export$e0580ae1f48db848)(client, args),
        getBalance: (args)=>(0, $854ed7a9743f5dc2$export$df96cd8d56be0ab1)(client, args),
        getBlobBaseFee: ()=>(0, $0722c7c83002eb76$export$9682cd49f77b48b)(client),
        getBlock: (args)=>(0, $afc05e8a9d5120bd$export$ea0af84ed2e77902)(client, args),
        getBlockNumber: (args)=>(0, $ad8ffeddc2009a5e$export$9328b5c92c53a20e)(client, args),
        getBlockTransactionCount: (args)=>(0, $d9ff0e13e83869a1$export$8c2de5be7f4dfc0)(client, args),
        getBytecode: (args)=>(0, $72a6d2dbbbc1f647$export$9a0a9c75ccef13fb)(client, args),
        getChainId: ()=>(0, $8af7cdce0f8e6164$export$850fa7b3891187c)(client),
        getCode: (args)=>(0, $72a6d2dbbbc1f647$export$9a0a9c75ccef13fb)(client, args),
        getContractEvents: (args)=>(0, $b6df579f3c0f85d0$export$1e175955db02d8d)(client, args),
        getEip712Domain: (args)=>(0, $817baf431dc63797$export$78097141abc77755)(client, args),
        getEnsAddress: (args)=>(0, $049cb9fbb03db7a2$export$24b77c7e87f05b8d)(client, args),
        getEnsAvatar: (args)=>(0, $ccfd2246705b6fe1$export$65f1d2b9649a54e5)(client, args),
        getEnsName: (args)=>(0, $9a7aff60d06f8b35$export$e1b98d9bc05a9fc2)(client, args),
        getEnsResolver: (args)=>(0, $c8195b24319ef4b8$export$ba1240cd558e6b31)(client, args),
        getEnsText: (args)=>(0, $657abfedeed8cfa0$export$2b2c96dabd62b431)(client, args),
        getFeeHistory: (args)=>(0, $2d77b8ead8ffcfc6$export$66598bc0c00a958e)(client, args),
        estimateFeesPerGas: (args)=>(0, $6fd5ed1f4857412b$export$8193bed8c46d2831)(client, args),
        getFilterChanges: (args)=>(0, $9d97866840568f1f$export$e69fa84ce52a94fd)(client, args),
        getFilterLogs: (args)=>(0, $cebe07a91f815d04$export$776d3b8c33a8b58)(client, args),
        getGasPrice: ()=>(0, $62da37b22de25e6b$export$89c15b50d46d3f8c)(client),
        getLogs: (args)=>(0, $8dadc4b63f7c1440$export$cb5260c832aab30a)(client, args),
        getProof: (args)=>(0, $feeed03e107c139b$export$4a314c097411dc17)(client, args),
        estimateMaxPriorityFeePerGas: (args)=>(0, $35a4530cf434d5c9$export$fd79a693887f886c)(client, args),
        getStorageAt: (args)=>(0, $35619d601266d2f6$export$14e244c1a3c8527e)(client, args),
        getTransaction: (args)=>(0, $837d17124076e235$export$ec0c6556a09b65b8)(client, args),
        getTransactionConfirmations: (args)=>(0, $2be44f7cc652158d$export$e2ccc904d713b66d)(client, args),
        getTransactionCount: (args)=>(0, $8a83ac23a544e47c$export$b18e66333ec1361e)(client, args),
        getTransactionReceipt: (args)=>(0, $7e91ce2c9b8cae84$export$6b1ceb3cd5f8b21f)(client, args),
        multicall: (args)=>(0, $15083d190e8609d0$export$60ef70589ee4f7ad)(client, args),
        prepareTransactionRequest: (args)=>(0, $4854f417ee324bc1$export$2e8a9232fb815d77)(client, args),
        readContract: (args)=>(0, $345cd736baedaec0$export$43af7de392176737)(client, args),
        sendRawTransaction: (args)=>(0, $d44987e9a6831d49$export$4e309754b4830e29)(client, args),
        simulateContract: (args)=>(0, $49dfc3f6e4bdedcf$export$e8798d551e27a374)(client, args),
        verifyMessage: (args)=>(0, $ad04f8b56a2c36ab$export$228d0e772cc158cb)(client, args),
        verifySiweMessage: (args)=>(0, $c634368cbd527283$export$10c59ebee3bc23e3)(client, args),
        verifyTypedData: (args)=>(0, $988847ae3683e9b0$export$3603b1c1bcd76798)(client, args),
        uninstallFilter: (args)=>(0, $c2ed1e178102dd67$export$54eb7d691768f7f3)(client, args),
        waitForTransactionReceipt: (args)=>(0, $94fe8f93f76c1ac5$export$694ec9bdf0bb55cf)(client, args),
        watchBlocks: (args)=>(0, $9c8024cff68be9da$export$f04bd2888af8db20)(client, args),
        watchBlockNumber: (args)=>(0, $aea0903f4797ac70$export$fc5f622dd0d82466)(client, args),
        watchContractEvent: (args)=>(0, $c354e9b44b11811f$export$2a02a63daa2df376)(client, args),
        watchEvent: (args)=>(0, $12c4c29f90271391$export$f6260ad5441916b4)(client, args),
        watchPendingTransactions: (args)=>(0, $7a01007af70ab085$export$223080172c87e789)(client, args)
    };
}


function $7c826deba1e299e5$export$d8e090d8c6a7a6ad(parameters) {
    const { key: key = "public", name: name = "Public Client" } = parameters;
    const client = (0, $6a8402de2d7ee6e1$export$5d730b7aed1a3eb0)({
        ...parameters,
        key: key,
        name: name,
        type: "publicClient"
    });
    return client.extend((0, $246243838b8fbd6a$export$8705b583fa097d24));
}




var $9UP4H = parcelRequire("9UP4H");
async function $e754620ef4042ea2$export$e648161d6b1bb565(client, { chain: chain }) {
    const { id: id, name: name, nativeCurrency: nativeCurrency, rpcUrls: rpcUrls, blockExplorers: blockExplorers } = chain;
    await client.request({
        method: "wallet_addEthereumChain",
        params: [
            {
                chainId: (0, $9UP4H.numberToHex)(id),
                chainName: name,
                nativeCurrency: nativeCurrency,
                rpcUrls: rpcUrls.default.http,
                blockExplorerUrls: blockExplorers ? Object.values(blockExplorers).map(({ url: url })=>url) : undefined
            }
        ]
    }, {
        dedupe: true,
        retryCount: 0
    });
}



var $k2kLE = parcelRequire("k2kLE");

var $4I1xa = parcelRequire("4I1xa");


var $6F8ii = parcelRequire("6F8ii");


var $98Tjv = parcelRequire("98Tjv");
function $42945dac9a88f603$export$390d312ab46d0597({ chain: chain, currentChainId: currentChainId }) {
    if (!chain) throw new (0, $98Tjv.ChainNotFoundError)();
    if (currentChainId !== chain.id) throw new (0, $98Tjv.ChainMismatchError)({
        chain: chain,
        currentChainId: currentChainId
    });
}



var $7hHca = parcelRequire("7hHca");

var $8ceqR = parcelRequire("8ceqR");

var $8X5h6 = parcelRequire("8X5h6");
function $9cacbf4d4b4031f3$export$da1758db1985646e(err, { docsPath: docsPath, ...args }) {
    const cause = (()=>{
        const cause = (0, $8X5h6.getNodeError)(err, args);
        if (cause instanceof (0, $7hHca.UnknownNodeError)) return err;
        return cause;
    })();
    return new (0, $8ceqR.TransactionExecutionError)(cause, {
        docsPath: docsPath,
        ...args
    });
}



var $cdCOv = parcelRequire("cdCOv");

var $dT7D8 = parcelRequire("dT7D8");


var $dVFRY = parcelRequire("dVFRY");



async function $e8cd3ba17ef00c13$export$8e0e7ffc78696d30(client, parameters) {
    const { account: account_ = client.account, chain: chain = client.chain, accessList: accessList, authorizationList: authorizationList, blobs: blobs, data: data, gas: gas, gasPrice: gasPrice, maxFeePerBlobGas: maxFeePerBlobGas, maxFeePerGas: maxFeePerGas, maxPriorityFeePerGas: maxPriorityFeePerGas, nonce: nonce, value: value, ...rest } = parameters;
    if (!account_) throw new (0, $bac5fb91181ff447$export$62ee6b05f0767f28)({
        docsPath: "/docs/actions/wallet/sendTransaction"
    });
    const account = (0, $4I1xa.parseAccount)(account_);
    try {
        (0, $dVFRY.assertRequest)(parameters);
        let chainId;
        if (chain !== null) {
            chainId = await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $8af7cdce0f8e6164$export$850fa7b3891187c), "getChainId")({});
            (0, $42945dac9a88f603$export$390d312ab46d0597)({
                currentChainId: chainId,
                chain: chain
            });
        }
        const to = await (async ()=>{
            // If `to` exists on the parameters, use that.
            if (parameters.to) return parameters.to;
            // If no `to` exists, and we are sending a EIP-7702 transaction, use the
            // address of the first authorization in the list.
            if (authorizationList && authorizationList.length > 0) return await (0, $0b57a38b1d7a5d5d$export$415d0315604a8515)({
                authorization: authorizationList[0]
            }).catch(()=>{
                throw new (0, $6F8ii.BaseError)("`to` is required. Could not infer from `authorizationList`.");
            });
            // Otherwise, we are sending a deployment transaction.
            return undefined;
        })();
        if (account.type === "json-rpc") {
            const chainFormat = client.chain?.formatters?.transactionRequest?.format;
            const format = chainFormat || (0, $dT7D8.formatTransactionRequest);
            const request = format({
                // Pick out extra data that might exist on the chain's transaction request type.
                ...(0, $cdCOv.extract)(rest, {
                    format: chainFormat
                }),
                accessList: accessList,
                authorizationList: authorizationList,
                blobs: blobs,
                chainId: chainId,
                data: data,
                from: account.address,
                gas: gas,
                gasPrice: gasPrice,
                maxFeePerBlobGas: maxFeePerBlobGas,
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                nonce: nonce,
                to: to,
                value: value
            });
            return await client.request({
                method: "eth_sendTransaction",
                params: [
                    request
                ]
            }, {
                retryCount: 0
            });
        }
        if (account.type === "local") {
            // Prepare the request for signing (assign appropriate fees, etc.)
            const request = await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $4854f417ee324bc1$export$2e8a9232fb815d77), "prepareTransactionRequest")({
                account: account,
                accessList: accessList,
                authorizationList: authorizationList,
                blobs: blobs,
                chain: chain,
                chainId: chainId,
                data: data,
                gas: gas,
                gasPrice: gasPrice,
                maxFeePerBlobGas: maxFeePerBlobGas,
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                nonce: nonce,
                parameters: [
                    ...(0, $4854f417ee324bc1$export$4f3e0c2bc77eca55),
                    "sidecars"
                ],
                value: value,
                ...rest,
                to: to
            });
            const serializer = chain?.serializers?.transaction;
            const serializedTransaction = await account.signTransaction(request, {
                serializer: serializer
            });
            return await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $d44987e9a6831d49$export$4e309754b4830e29), "sendRawTransaction")({
                serializedTransaction: serializedTransaction
            });
        }
        if (account.type === "smart") throw new (0, $bac5fb91181ff447$export$22c1d840ef5fbc66)({
            metaMessages: [
                "Consider using the `sendUserOperation` Action instead."
            ],
            docsPath: "/docs/actions/bundler/sendUserOperation",
            type: "smart"
        });
        throw new (0, $bac5fb91181ff447$export$22c1d840ef5fbc66)({
            docsPath: "/docs/actions/wallet/sendTransaction",
            type: account.type
        });
    } catch (err) {
        if (err instanceof (0, $bac5fb91181ff447$export$22c1d840ef5fbc66)) throw err;
        throw (0, $9cacbf4d4b4031f3$export$da1758db1985646e)(err, {
            ...parameters,
            account: account,
            chain: parameters.chain || undefined
        });
    }
}


function $6da878b466b7c09a$export$46c7a79747abe6a9(walletClient, parameters) {
    const { abi: abi, args: args, bytecode: bytecode, ...request } = parameters;
    const calldata = (0, $k2kLE.encodeDeployData)({
        abi: abi,
        args: args,
        bytecode: bytecode
    });
    return (0, $e8cd3ba17ef00c13$export$8e0e7ffc78696d30)(walletClient, {
        ...request,
        data: calldata
    });
}



var $lqRRD = parcelRequire("lqRRD");
async function $cf59c91d3a4e898b$export$17d5f00cfd692b8a(client) {
    if (client.account?.type === "local") return [
        client.account.address
    ];
    const addresses = await client.request({
        method: "eth_accounts"
    }, {
        dedupe: true
    });
    return addresses.map((address)=>(0, $lqRRD.checksumAddress)(address));
}


/**
 * Gets the wallets current permissions.
 *
 * - Docs: https://viem.sh/docs/actions/wallet/getPermissions
 * - JSON-RPC Methods: [`wallet_getPermissions`](https://eips.ethereum.org/EIPS/eip-2255)
 *
 * @param client - Client to use
 * @returns The wallet permissions. {@link GetPermissionsReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { getPermissions } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const permissions = await getPermissions(client)
 */ async function $bdebd8ea1c4b9982$export$e10fd44ca431fa8e(client) {
    const permissions = await client.request({
        method: "wallet_getPermissions"
    }, {
        dedupe: true
    });
    return permissions;
}




var $lqRRD = parcelRequire("lqRRD");
async function $97aa0a7508cd155d$export$87c5bcc1dede6f06(client) {
    const addresses = await client.request({
        method: "eth_requestAccounts"
    }, {
        dedupe: true,
        retryCount: 0
    });
    return addresses.map((address)=>(0, $lqRRD.getAddress)(address));
}


/**
 * Requests permissions for a wallet.
 *
 * - Docs: https://viem.sh/docs/actions/wallet/requestPermissions
 * - JSON-RPC Methods: [`wallet_requestPermissions`](https://eips.ethereum.org/EIPS/eip-2255)
 *
 * @param client - Client to use
 * @param parameters - {@link RequestPermissionsParameters}
 * @returns The wallet permissions. {@link RequestPermissionsReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { requestPermissions } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const permissions = await requestPermissions(client, {
 *   eth_accounts: {}
 * })
 */ async function $4c7b4b51ac48856f$export$8cec5d3683c6896e(client, permissions) {
    return client.request({
        method: "wallet_requestPermissions",
        params: [
            permissions
        ]
    }, {
        retryCount: 0
    });
}






var $4I1xa = parcelRequire("4I1xa");



var $9UP4H = parcelRequire("9UP4H");

var $dT7D8 = parcelRequire("dT7D8");


var $dVFRY = parcelRequire("dVFRY");

async function $ed8772f7b8373762$export$6ad02cc4966b42ab(client, parameters) {
    const { account: account_ = client.account, chain: chain = client.chain, ...transaction } = parameters;
    if (!account_) throw new (0, $bac5fb91181ff447$export$62ee6b05f0767f28)({
        docsPath: "/docs/actions/wallet/signTransaction"
    });
    const account = (0, $4I1xa.parseAccount)(account_);
    (0, $dVFRY.assertRequest)({
        account: account,
        ...parameters
    });
    const chainId = await (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $8af7cdce0f8e6164$export$850fa7b3891187c), "getChainId")({});
    if (chain !== null) (0, $42945dac9a88f603$export$390d312ab46d0597)({
        currentChainId: chainId,
        chain: chain
    });
    const formatters = chain?.formatters || client.chain?.formatters;
    const format = formatters?.transactionRequest?.format || (0, $dT7D8.formatTransactionRequest);
    if (account.signTransaction) return account.signTransaction({
        ...transaction,
        chainId: chainId
    }, {
        serializer: client.chain?.serializers?.transaction
    });
    return await client.request({
        method: "eth_signTransaction",
        params: [
            {
                ...format(transaction),
                chainId: (0, $9UP4H.numberToHex)(chainId),
                from: account.address
            }
        ]
    }, {
        retryCount: 0
    });
}



var $4I1xa = parcelRequire("4I1xa");


async function $67188c65c4f2f1e9$export$9f05de2db4d31153(client, parameters) {
    const { account: account_ = client.account, domain: domain, message: message, primaryType: primaryType } = parameters;
    if (!account_) throw new (0, $bac5fb91181ff447$export$62ee6b05f0767f28)({
        docsPath: "/docs/actions/wallet/signTypedData"
    });
    const account = (0, $4I1xa.parseAccount)(account_);
    const types = {
        EIP712Domain: (0, $63da8af71669a9b8$export$6a292159484ee032)({
            domain: domain
        }),
        ...parameters.types
    };
    // Need to do a runtime validation check on addresses, byte ranges, integer ranges, etc
    // as we can't statically check this with TypeScript.
    (0, $63da8af71669a9b8$export$fac174f558903e26)({
        domain: domain,
        message: message,
        primaryType: primaryType,
        types: types
    });
    if (account.signTypedData) return account.signTypedData({
        domain: domain,
        message: message,
        primaryType: primaryType,
        types: types
    });
    const typedData = (0, $63da8af71669a9b8$export$ce8e1cf733064451)({
        domain: domain,
        message: message,
        primaryType: primaryType,
        types: types
    });
    return client.request({
        method: "eth_signTypedData_v4",
        params: [
            account.address,
            typedData
        ]
    }, {
        retryCount: 0
    });
}



var $9UP4H = parcelRequire("9UP4H");
async function $c0e4b4886113ca0e$export$15599da40e72d2f(client, { id: id }) {
    await client.request({
        method: "wallet_switchEthereumChain",
        params: [
            {
                chainId: (0, $9UP4H.numberToHex)(id)
            }
        ]
    }, {
        retryCount: 0
    });
}


/**
 * Adds an EVM chain to the wallet.
 *
 * - Docs: https://viem.sh/docs/actions/wallet/watchAsset
 * - JSON-RPC Methods: [`eth_switchEthereumChain`](https://eips.ethereum.org/EIPS/eip-747)
 *
 * @param client - Client to use
 * @param parameters - {@link WatchAssetParameters}
 * @returns Boolean indicating if the token was successfully added. {@link WatchAssetReturnType}
 *
 * @example
 * import { createWalletClient, custom } from 'viem'
 * import { mainnet } from 'viem/chains'
 * import { watchAsset } from 'viem/wallet'
 *
 * const client = createWalletClient({
 *   chain: mainnet,
 *   transport: custom(window.ethereum),
 * })
 * const success = await watchAsset(client, {
 *   type: 'ERC20',
 *   options: {
 *     address: '0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2',
 *     decimals: 18,
 *     symbol: 'WETH',
 *   },
 * })
 */ async function $c08c4238e6dd4e2f$export$7eea68d1a70548bd(client, params) {
    const added = await client.request({
        method: "wallet_watchAsset",
        params: params
    }, {
        retryCount: 0
    });
    return added;
}



var $ahylX = parcelRequire("ahylX");


async function $b442dd6167cb87a3$export$4c0f201bc17cbf23(client, parameters) {
    const { abi: abi, address: address, args: args, dataSuffix: dataSuffix, functionName: functionName, ...request } = parameters;
    const data = (0, $ahylX.encodeFunctionData)({
        abi: abi,
        args: args,
        functionName: functionName
    });
    return (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $e8cd3ba17ef00c13$export$8e0e7ffc78696d30), "sendTransaction")({
        data: `${data}${dataSuffix ? dataSuffix.replace("0x", "") : ""}`,
        to: address,
        ...request
    });
}


function $4517b0a4b6be88b6$export$d07041b4ed194fbc(client) {
    return {
        addChain: (args)=>(0, $e754620ef4042ea2$export$e648161d6b1bb565)(client, args),
        deployContract: (args)=>(0, $6da878b466b7c09a$export$46c7a79747abe6a9)(client, args),
        getAddresses: ()=>(0, $cf59c91d3a4e898b$export$17d5f00cfd692b8a)(client),
        getChainId: ()=>(0, $8af7cdce0f8e6164$export$850fa7b3891187c)(client),
        getPermissions: ()=>(0, $bdebd8ea1c4b9982$export$e10fd44ca431fa8e)(client),
        prepareTransactionRequest: (args)=>(0, $4854f417ee324bc1$export$2e8a9232fb815d77)(client, args),
        requestAddresses: ()=>(0, $97aa0a7508cd155d$export$87c5bcc1dede6f06)(client),
        requestPermissions: (args)=>(0, $4c7b4b51ac48856f$export$8cec5d3683c6896e)(client, args),
        sendRawTransaction: (args)=>(0, $d44987e9a6831d49$export$4e309754b4830e29)(client, args),
        sendTransaction: (args)=>(0, $e8cd3ba17ef00c13$export$8e0e7ffc78696d30)(client, args),
        signMessage: (args)=>(0, $64cacff4b9d56027$export$1d9a7a8a40780de)(client, args),
        signTransaction: (args)=>(0, $ed8772f7b8373762$export$6ad02cc4966b42ab)(client, args),
        signTypedData: (args)=>(0, $67188c65c4f2f1e9$export$9f05de2db4d31153)(client, args),
        switchChain: (args)=>(0, $c0e4b4886113ca0e$export$15599da40e72d2f)(client, args),
        watchAsset: (args)=>(0, $c08c4238e6dd4e2f$export$7eea68d1a70548bd)(client, args),
        writeContract: (args)=>(0, $b442dd6167cb87a3$export$4c0f201bc17cbf23)(client, args)
    };
}


function $d7839887e0efaf1b$export$362b8ea2edbd9090(parameters) {
    const { key: key = "wallet", name: name = "Wallet Client", transport: transport } = parameters;
    const client = (0, $6a8402de2d7ee6e1$export$5d730b7aed1a3eb0)({
        ...parameters,
        key: key,
        name: name,
        transport: transport,
        type: "walletClient"
    });
    return client.extend((0, $4517b0a4b6be88b6$export$d07041b4ed194fbc));
}


var $9nOfC = parcelRequire("9nOfC");







function $740fc174ca817919$export$f518c38144e1f9d({ abi: abi, address: address, client: client_ }) {
    const client = client_;
    const [publicClient, walletClient] = (()=>{
        if (!client) return [
            undefined,
            undefined
        ];
        if ("public" in client && "wallet" in client) return [
            client.public,
            client.wallet
        ];
        if ("public" in client) return [
            client.public,
            undefined
        ];
        if ("wallet" in client) return [
            undefined,
            client.wallet
        ];
        return [
            client,
            client
        ];
    })();
    const hasPublicClient = publicClient !== undefined && publicClient !== null;
    const hasWalletClient = walletClient !== undefined && walletClient !== null;
    const contract = {};
    let hasReadFunction = false;
    let hasWriteFunction = false;
    let hasEvent = false;
    for (const item of abi){
        if (item.type === "function") {
            if (item.stateMutability === "view" || item.stateMutability === "pure") hasReadFunction = true;
            else hasWriteFunction = true;
        } else if (item.type === "event") hasEvent = true;
        // Exit early if all flags are `true`
        if (hasReadFunction && hasWriteFunction && hasEvent) break;
    }
    if (hasPublicClient) {
        if (hasReadFunction) contract.read = new Proxy({}, {
            get (_, functionName) {
                return (...parameters)=>{
                    const { args: args, options: options } = $740fc174ca817919$export$b1d653474fdb0f41(parameters);
                    return (0, $17629d164efed1df$export$6ca3170acb89054)(publicClient, (0, $345cd736baedaec0$export$43af7de392176737), "readContract")({
                        abi: abi,
                        address: address,
                        functionName: functionName,
                        args: args,
                        ...options
                    });
                };
            }
        });
        if (hasWriteFunction) contract.simulate = new Proxy({}, {
            get (_, functionName) {
                return (...parameters)=>{
                    const { args: args, options: options } = $740fc174ca817919$export$b1d653474fdb0f41(parameters);
                    return (0, $17629d164efed1df$export$6ca3170acb89054)(publicClient, (0, $49dfc3f6e4bdedcf$export$e8798d551e27a374), "simulateContract")({
                        abi: abi,
                        address: address,
                        functionName: functionName,
                        args: args,
                        ...options
                    });
                };
            }
        });
        if (hasEvent) {
            contract.createEventFilter = new Proxy({}, {
                get (_, eventName) {
                    return (...parameters)=>{
                        const abiEvent = abi.find((x)=>x.type === "event" && x.name === eventName);
                        const { args: args, options: options } = $740fc174ca817919$export$5d0aafa8249eb606(parameters, abiEvent);
                        return (0, $17629d164efed1df$export$6ca3170acb89054)(publicClient, (0, $ddde17ea7e9ef03d$export$36f99fdb90149e8b), "createContractEventFilter")({
                            abi: abi,
                            address: address,
                            eventName: eventName,
                            args: args,
                            ...options
                        });
                    };
                }
            });
            contract.getEvents = new Proxy({}, {
                get (_, eventName) {
                    return (...parameters)=>{
                        const abiEvent = abi.find((x)=>x.type === "event" && x.name === eventName);
                        const { args: args, options: options } = $740fc174ca817919$export$5d0aafa8249eb606(parameters, abiEvent);
                        return (0, $17629d164efed1df$export$6ca3170acb89054)(publicClient, (0, $b6df579f3c0f85d0$export$1e175955db02d8d), "getContractEvents")({
                            abi: abi,
                            address: address,
                            eventName: eventName,
                            args: args,
                            ...options
                        });
                    };
                }
            });
            contract.watchEvent = new Proxy({}, {
                get (_, eventName) {
                    return (...parameters)=>{
                        const abiEvent = abi.find((x)=>x.type === "event" && x.name === eventName);
                        const { args: args, options: options } = $740fc174ca817919$export$5d0aafa8249eb606(parameters, abiEvent);
                        return (0, $17629d164efed1df$export$6ca3170acb89054)(publicClient, (0, $c354e9b44b11811f$export$2a02a63daa2df376), "watchContractEvent")({
                            abi: abi,
                            address: address,
                            eventName: eventName,
                            args: args,
                            ...options
                        });
                    };
                }
            });
        }
    }
    if (hasWalletClient) {
        if (hasWriteFunction) contract.write = new Proxy({}, {
            get (_, functionName) {
                return (...parameters)=>{
                    const { args: args, options: options } = $740fc174ca817919$export$b1d653474fdb0f41(parameters);
                    return (0, $17629d164efed1df$export$6ca3170acb89054)(walletClient, (0, $b442dd6167cb87a3$export$4c0f201bc17cbf23), "writeContract")({
                        abi: abi,
                        address: address,
                        functionName: functionName,
                        args: args,
                        ...options
                    });
                };
            }
        });
    }
    if (hasPublicClient || hasWalletClient) {
        if (hasWriteFunction) contract.estimateGas = new Proxy({}, {
            get (_, functionName) {
                return (...parameters)=>{
                    const { args: args, options: options } = $740fc174ca817919$export$b1d653474fdb0f41(parameters);
                    const client = publicClient ?? walletClient;
                    return (0, $17629d164efed1df$export$6ca3170acb89054)(client, (0, $1ec63edfff7aa371$export$7b896b3a3695de87), "estimateContractGas")({
                        abi: abi,
                        address: address,
                        functionName: functionName,
                        args: args,
                        ...options,
                        account: options.account ?? walletClient.account
                    });
                };
            }
        });
    }
    contract.address = address;
    contract.abi = abi;
    return contract;
}
function $740fc174ca817919$export$b1d653474fdb0f41(values) {
    const hasArgs = values.length && Array.isArray(values[0]);
    const args = hasArgs ? values[0] : [];
    const options = (hasArgs ? values[1] : values[0]) ?? {};
    return {
        args: args,
        options: options
    };
}
function $740fc174ca817919$export$5d0aafa8249eb606(values, abiEvent) {
    let hasArgs = false;
    // If first item is array, must be `args`
    if (Array.isArray(values[0])) hasArgs = true;
    else if (values.length === 1) // if event has indexed inputs, must have `args`
    hasArgs = abiEvent.inputs.some((x)=>x.indexed);
    else if (values.length === 2) hasArgs = true;
    const args = hasArgs ? values[0] : undefined;
    const options = (hasArgs ? values[1] : values[0]) ?? {};
    return {
        args: args,
        options: options
    };
}

const $4231b4de1126cff9$export$bdd7109439799cdf = 2n ** (8n - 1n) - 1n;
const $4231b4de1126cff9$export$eee94935c9b963a1 = 2n ** (16n - 1n) - 1n;
const $4231b4de1126cff9$export$e91fe5d90cd4a2f6 = 2n ** (24n - 1n) - 1n;
const $4231b4de1126cff9$export$25c0796c740353c4 = 2n ** (32n - 1n) - 1n;
const $4231b4de1126cff9$export$ac2072b1e721a92d = 2n ** (40n - 1n) - 1n;
const $4231b4de1126cff9$export$7b7c71fa48943f3 = 2n ** (48n - 1n) - 1n;
const $4231b4de1126cff9$export$e27ce19a567c9842 = 2n ** (56n - 1n) - 1n;
const $4231b4de1126cff9$export$a51b0cf29ddb8e40 = 2n ** (64n - 1n) - 1n;
const $4231b4de1126cff9$export$347f40d3f7572e5a = 2n ** (72n - 1n) - 1n;
const $4231b4de1126cff9$export$940f45cde4f61aed = 2n ** (80n - 1n) - 1n;
const $4231b4de1126cff9$export$13cad54caf92841d = 2n ** (88n - 1n) - 1n;
const $4231b4de1126cff9$export$872296ce91d7dabe = 2n ** (96n - 1n) - 1n;
const $4231b4de1126cff9$export$404112bd52c31da4 = 2n ** (104n - 1n) - 1n;
const $4231b4de1126cff9$export$1d4284abecdbf56d = 2n ** (112n - 1n) - 1n;
const $4231b4de1126cff9$export$35201a0fd5d34f18 = 2n ** (120n - 1n) - 1n;
const $4231b4de1126cff9$export$92415df5352289c7 = 2n ** (128n - 1n) - 1n;
const $4231b4de1126cff9$export$ccb03f6a03d6e182 = 2n ** (136n - 1n) - 1n;
const $4231b4de1126cff9$export$cbf030aa46ccd63 = 2n ** (144n - 1n) - 1n;
const $4231b4de1126cff9$export$33ad14852d23a660 = 2n ** (152n - 1n) - 1n;
const $4231b4de1126cff9$export$6429af277dbaae06 = 2n ** (160n - 1n) - 1n;
const $4231b4de1126cff9$export$2b154fcf8b3c7a42 = 2n ** (168n - 1n) - 1n;
const $4231b4de1126cff9$export$6ba90f949100477a = 2n ** (176n - 1n) - 1n;
const $4231b4de1126cff9$export$a353fb8a621e38fd = 2n ** (184n - 1n) - 1n;
const $4231b4de1126cff9$export$ad4f6360abea4fa4 = 2n ** (192n - 1n) - 1n;
const $4231b4de1126cff9$export$381549e0b0f272ab = 2n ** (200n - 1n) - 1n;
const $4231b4de1126cff9$export$a083a4afa1a2c00c = 2n ** (208n - 1n) - 1n;
const $4231b4de1126cff9$export$ee8f6a880c431cd3 = 2n ** (216n - 1n) - 1n;
const $4231b4de1126cff9$export$a8672844e0af1027 = 2n ** (224n - 1n) - 1n;
const $4231b4de1126cff9$export$57c45c845403e7a5 = 2n ** (232n - 1n) - 1n;
const $4231b4de1126cff9$export$e8e88f55ae4a3354 = 2n ** (240n - 1n) - 1n;
const $4231b4de1126cff9$export$ebbd894fe518c064 = 2n ** (248n - 1n) - 1n;
const $4231b4de1126cff9$export$e4d673aa7367981c = 2n ** (256n - 1n) - 1n;
const $4231b4de1126cff9$export$ef9b9e1988c51720 = -(2n ** (8n - 1n));
const $4231b4de1126cff9$export$b923fba4a82cad48 = -(2n ** (16n - 1n));
const $4231b4de1126cff9$export$7b0286602251a7c7 = -(2n ** (24n - 1n));
const $4231b4de1126cff9$export$5f0d0d25b56bbb4f = -(2n ** (32n - 1n));
const $4231b4de1126cff9$export$4c07a8deea2258b1 = -(2n ** (40n - 1n));
const $4231b4de1126cff9$export$6a6c2e4f279545ff = -(2n ** (48n - 1n));
const $4231b4de1126cff9$export$1739c13d967d68b1 = -(2n ** (56n - 1n));
const $4231b4de1126cff9$export$14e6fedf9fb9d75c = -(2n ** (64n - 1n));
const $4231b4de1126cff9$export$bc3defde0bfb8bd = -(2n ** (72n - 1n));
const $4231b4de1126cff9$export$8efa66e0d946dfd2 = -(2n ** (80n - 1n));
const $4231b4de1126cff9$export$80ab8bed90b29bfe = -(2n ** (88n - 1n));
const $4231b4de1126cff9$export$39c4444aac2d0d86 = -(2n ** (96n - 1n));
const $4231b4de1126cff9$export$28fd4a9e64dafe7b = -(2n ** (104n - 1n));
const $4231b4de1126cff9$export$38cae674fedc8f74 = -(2n ** (112n - 1n));
const $4231b4de1126cff9$export$6779113dfecc5d69 = -(2n ** (120n - 1n));
const $4231b4de1126cff9$export$93cc92d28d07644b = -(2n ** (128n - 1n));
const $4231b4de1126cff9$export$4acf8238e6d61d3e = -(2n ** (136n - 1n));
const $4231b4de1126cff9$export$ac974246b2ca90ec = -(2n ** (144n - 1n));
const $4231b4de1126cff9$export$77d4dfc3aa958440 = -(2n ** (152n - 1n));
const $4231b4de1126cff9$export$a9a1ab546428ca6f = -(2n ** (160n - 1n));
const $4231b4de1126cff9$export$aca1dbffc71a377a = -(2n ** (168n - 1n));
const $4231b4de1126cff9$export$1ca77ffa68208066 = -(2n ** (176n - 1n));
const $4231b4de1126cff9$export$e74092b0e35f2385 = -(2n ** (184n - 1n));
const $4231b4de1126cff9$export$5f53c97c87f852f4 = -(2n ** (192n - 1n));
const $4231b4de1126cff9$export$df01e80cffe255dc = -(2n ** (200n - 1n));
const $4231b4de1126cff9$export$155f043c7b06e008 = -(2n ** (208n - 1n));
const $4231b4de1126cff9$export$195a5ffec9c679b8 = -(2n ** (216n - 1n));
const $4231b4de1126cff9$export$b1ee6eacfb96c50c = -(2n ** (224n - 1n));
const $4231b4de1126cff9$export$16bdbfee8230ad51 = -(2n ** (232n - 1n));
const $4231b4de1126cff9$export$5715ad8f9991a9a2 = -(2n ** (240n - 1n));
const $4231b4de1126cff9$export$9146117a246b63ab = -(2n ** (248n - 1n));
const $4231b4de1126cff9$export$5d31694d80b27ae5 = -(2n ** (256n - 1n));
const $4231b4de1126cff9$export$7db2ab1a72670716 = 2n ** 8n - 1n;
const $4231b4de1126cff9$export$e4e112958a94d87f = 2n ** 16n - 1n;
const $4231b4de1126cff9$export$1bea6075c2df6828 = 2n ** 24n - 1n;
const $4231b4de1126cff9$export$48716e5eecd83bf7 = 2n ** 32n - 1n;
const $4231b4de1126cff9$export$dc2184b5c9263ac7 = 2n ** 40n - 1n;
const $4231b4de1126cff9$export$e639b3656891925b = 2n ** 48n - 1n;
const $4231b4de1126cff9$export$bea470c1abdb1310 = 2n ** 56n - 1n;
const $4231b4de1126cff9$export$3f17b1570950699c = 2n ** 64n - 1n;
const $4231b4de1126cff9$export$8135da85ae9b595b = 2n ** 72n - 1n;
const $4231b4de1126cff9$export$caa80683240e3b73 = 2n ** 80n - 1n;
const $4231b4de1126cff9$export$8e50c223f761a8cf = 2n ** 88n - 1n;
const $4231b4de1126cff9$export$621d3d87b73138e5 = 2n ** 96n - 1n;
const $4231b4de1126cff9$export$4e5098f4748a9a4d = 2n ** 104n - 1n;
const $4231b4de1126cff9$export$1435b580b943ede2 = 2n ** 112n - 1n;
const $4231b4de1126cff9$export$4362e740aadf7dab = 2n ** 120n - 1n;
const $4231b4de1126cff9$export$380ebe6b2fc5caa9 = 2n ** 128n - 1n;
const $4231b4de1126cff9$export$6c13d06e0cefb9aa = 2n ** 136n - 1n;
const $4231b4de1126cff9$export$fe2d415b41e5f433 = 2n ** 144n - 1n;
const $4231b4de1126cff9$export$c2f2754e23c5488a = 2n ** 152n - 1n;
const $4231b4de1126cff9$export$34fcca92c372a91b = 2n ** 160n - 1n;
const $4231b4de1126cff9$export$32e3523cb82cc8a0 = 2n ** 168n - 1n;
const $4231b4de1126cff9$export$d36711d6637bde95 = 2n ** 176n - 1n;
const $4231b4de1126cff9$export$9211611648dd09a2 = 2n ** 184n - 1n;
const $4231b4de1126cff9$export$4e61cbaa2231cfdd = 2n ** 192n - 1n;
const $4231b4de1126cff9$export$9187c63f331d335b = 2n ** 200n - 1n;
const $4231b4de1126cff9$export$7f910799edc7ae97 = 2n ** 208n - 1n;
const $4231b4de1126cff9$export$64506e5a2676ecb0 = 2n ** 216n - 1n;
const $4231b4de1126cff9$export$a060896418206521 = 2n ** 224n - 1n;
const $4231b4de1126cff9$export$18b000c2bc5e114 = 2n ** 232n - 1n;
const $4231b4de1126cff9$export$253bb52e7f7a3909 = 2n ** 240n - 1n;
const $4231b4de1126cff9$export$d5a8ad83a637081c = 2n ** 248n - 1n;
const $4231b4de1126cff9$export$48de485e50a67ffa = 2n ** 256n - 1n;


var $2IOoR = parcelRequire("2IOoR");
/**
 * Multiplies a string representation of a number by a given exponent of base 10 (10exponent).
 *
 * - Docs: https://viem.sh/docs/utilities/parseUnits
 *
 * @example
 * import { parseUnits } from 'viem'
 *
 * parseUnits('420', 9)
 * // 420000000000n
 */ function $996ac4676bde0a02$export$203ae30b4f6490b3(value, decimals) {
    let [integer, fraction = "0"] = value.split(".");
    const negative = integer.startsWith("-");
    if (negative) integer = integer.slice(1);
    // trim trailing zeros.
    fraction = fraction.replace(/(0+)$/, "");
    // round off if the fraction is larger than the number of decimals.
    if (decimals === 0) {
        if (Math.round(Number(`.${fraction}`)) === 1) integer = `${BigInt(integer) + 1n}`;
        fraction = "";
    } else if (fraction.length > decimals) {
        const [left, unit, right] = [
            fraction.slice(0, decimals - 1),
            fraction.slice(decimals - 1, decimals),
            fraction.slice(decimals)
        ];
        const rounded = Math.round(Number(`${unit}.${right}`));
        if (rounded > 9) fraction = `${BigInt(left) + BigInt(1)}0`.padStart(left.length + 1, "0");
        else fraction = `${left}${rounded}`;
        if (fraction.length > decimals) {
            fraction = fraction.slice(1);
            integer = `${BigInt(integer) + 1n}`;
        }
        fraction = fraction.slice(0, decimals);
    } else fraction = fraction.padEnd(decimals, "0");
    return BigInt(`${negative ? "-" : ""}${integer}${fraction}`);
}


function $1a21c088f688ce4c$export$642c4e67bbdc0bc7(ether, unit = "wei") {
    return (0, $996ac4676bde0a02$export$203ae30b4f6490b3)(ether, (0, $2IOoR.etherUnits)[unit]);
}







var $8NFma = parcelRequire("8NFma");


const $ea69491ca5efe89a$export$83d89fbfd8236492 = "2.8.6";


const $2c6b13101c3b10db$export$c506eb22e615ba4a = ()=>`wagmi@${0, $ea69491ca5efe89a$export$83d89fbfd8236492}`;


class $5b18c3bdcad31985$export$a490eb03cb7a0a5e extends (0, $23921cb92fbd5cef$export$a490eb03cb7a0a5e) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "WagmiError"
        });
    }
    get docsBaseUrl() {
        return "https://wagmi.sh/react";
    }
    get version() {
        return (0, $2c6b13101c3b10db$export$c506eb22e615ba4a)();
    }
}


class $4d75fea103657dad$export$83af591da49c2ea extends (0, $5b18c3bdcad31985$export$a490eb03cb7a0a5e) {
    constructor(){
        super("`useConfig` must be used within `WagmiProvider`.", {
            docsPath: "/api/WagmiProvider"
        });
        Object.defineProperty(this, "name", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: "WagmiProviderNotFoundError"
        });
    }
}


"use client";
function $3fe8dc05b679ab9d$export$b3611e87cd5ba6ce(parameters = {}) {
    const config = parameters.config ?? (0, $8NFma.useContext)((0, $4a768efd39c3ad48$export$da7c16611087c70c));
    if (!config) throw new (0, $4d75fea103657dad$export$83af591da49c2ea)();
    return config;
}




var $8NFma = parcelRequire("8NFma");
var $60ed25f966e76557$exports = {};
"use strict";

$60ed25f966e76557$exports = (parcelRequire("dRVqp"));


"use client";
const $2db01c42e0b9970d$var$isPlainObject = (obj)=>typeof obj === "object" && !Array.isArray(obj);
function $2db01c42e0b9970d$export$1a0284c6345ef780(subscribe, getSnapshot, getServerSnapshot = getSnapshot, isEqual = (0, $6efb6ef5b61b5026$export$9cb4719e2e525b7a)) {
    const trackedKeys = (0, $8NFma.useRef)([]);
    const result = (0, $60ed25f966e76557$exports.useSyncExternalStoreWithSelector)(subscribe, getSnapshot, getServerSnapshot, (x)=>x, (a, b)=>{
        if ($2db01c42e0b9970d$var$isPlainObject(a) && $2db01c42e0b9970d$var$isPlainObject(b) && trackedKeys.current.length) {
            for (const key of trackedKeys.current){
                const equal = isEqual(a[key], b[key]);
                if (!equal) return false;
            }
            return true;
        }
        return isEqual(a, b);
    });
    if ($2db01c42e0b9970d$var$isPlainObject(result)) {
        const trackedResult = {
            ...result
        };
        Object.defineProperties(trackedResult, Object.entries(trackedResult).reduce((res, [key, value])=>{
            return {
                ...res,
                [key]: {
                    configurable: false,
                    enumerable: true,
                    get: ()=>{
                        if (!trackedKeys.current.includes(key)) trackedKeys.current.push(key);
                        return value;
                    }
                }
            };
        }, {}));
        return trackedResult;
    }
    return result;
}


"use client";
function $9cc58b6deaa591e8$export$83a8e409853da004(parameters = {}) {
    const config = (0, $3fe8dc05b679ab9d$export$b3611e87cd5ba6ce)(parameters);
    return (0, $2db01c42e0b9970d$export$1a0284c6345ef780)((onChange)=>(0, $de8ec52414ac50d6$export$30c94aeff2da2ac6)(config, {
            onChange: onChange
        }), ()=>(0, $135a5279acb2ac27$export$4f9234baf34abd0)(config));
}


var $8NFma = parcelRequire("8NFma");
// src/mutationObserver.ts




var $460cd08eec3ce961$export$d3c1860ee66f291a = class extends (0, $b9b70121081db01a$export$d26086b469ecdbcc) {
    #client;
    #currentResult = void 0;
    #currentMutation;
    #mutateOptions;
    constructor(client, options){
        super();
        this.#client = client;
        this.setOptions(options);
        this.bindMethods();
        this.#updateResult();
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        const prevOptions = this.options;
        this.options = this.#client.defaultMutationOptions(options);
        if (!(0, $3546908fef5186ce$export$3e67810a3f0e9f1c)(this.options, prevOptions)) this.#client.getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: this.#currentMutation,
            observer: this
        });
        if (prevOptions?.mutationKey && this.options.mutationKey && (0, $3546908fef5186ce$export$1e87d19d4aab5805)(prevOptions.mutationKey) !== (0, $3546908fef5186ce$export$1e87d19d4aab5805)(this.options.mutationKey)) this.reset();
        else if (this.#currentMutation?.state.status === "pending") this.#currentMutation.setOptions(this.options);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.#currentMutation?.removeObserver(this);
    }
    onMutationUpdate(action) {
        this.#updateResult();
        this.#notify(action);
    }
    getCurrentResult() {
        return this.#currentResult;
    }
    reset() {
        this.#currentMutation?.removeObserver(this);
        this.#currentMutation = void 0;
        this.#updateResult();
        this.#notify();
    }
    mutate(variables, options) {
        this.#mutateOptions = options;
        this.#currentMutation?.removeObserver(this);
        this.#currentMutation = this.#client.getMutationCache().build(this.#client, this.options);
        this.#currentMutation.addObserver(this);
        return this.#currentMutation.execute(variables);
    }
    #updateResult() {
        const state = this.#currentMutation?.state ?? (0, $970b87d0b0b90748$export$a1659b54bac3252a)();
        this.#currentResult = {
            ...state,
            isPending: state.status === "pending",
            isSuccess: state.status === "success",
            isError: state.status === "error",
            isIdle: state.status === "idle",
            mutate: this.mutate,
            reset: this.reset
        };
    }
    #notify(action) {
        (0, $e70386a3fc4a6b3f$export$520687f44db6e1ab).batch(()=>{
            if (this.#mutateOptions && this.hasListeners()) {
                const variables = this.#currentResult.variables;
                const context = this.#currentResult.context;
                if (action?.type === "success") {
                    this.#mutateOptions.onSuccess?.(action.data, variables, context);
                    this.#mutateOptions.onSettled?.(action.data, null, variables, context);
                } else if (action?.type === "error") {
                    this.#mutateOptions.onError?.(action.error, variables, context);
                    this.#mutateOptions.onSettled?.(void 0, action.error, variables, context);
                }
            }
            this.listeners.forEach((listener)=>{
                listener(this.#currentResult);
            });
        });
    }
};



// src/utils.ts
function $b764608255a106d8$export$2072f68e6c3507cf(throwError, params) {
    if (typeof throwError === "function") return throwError(...params);
    return !!throwError;
}
function $b764608255a106d8$export$8793edee2d425525() {}


"use client";
function $d18ed9863dec8f65$export$609860bf8b0084c(options, queryClient) {
    const client = (0, $116ae60afff0fd72$export$22e77b9572c4fded)(queryClient);
    const [observer] = $8NFma.useState(()=>new (0, $460cd08eec3ce961$export$d3c1860ee66f291a)(client, options));
    $8NFma.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = $8NFma.useSyncExternalStore($8NFma.useCallback((onStoreChange)=>observer.subscribe((0, $e70386a3fc4a6b3f$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $8NFma.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch((0, $b764608255a106d8$export$8793edee2d425525));
    }, [
        observer
    ]);
    if (result.error && (0, $b764608255a106d8$export$2072f68e6c3507cf)(observer.options.throwOnError, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
}





function $83db3dc983b448a5$export$81bca4b1e9392240(config) {
    return {
        mutationFn (variables) {
            return (0, $16e09604f761585b$export$37dfea93db2e14ed)(config, variables);
        },
        mutationKey: [
            "disconnect"
        ]
    };
}





let $256f4b044c53ec49$var$previousConnections = [];
function $256f4b044c53ec49$export$82b9f8f75cc709b4(config) {
    const connections = [
        ...config.state.connections.values()
    ];
    if (config.state.status === "reconnecting") return $256f4b044c53ec49$var$previousConnections;
    if ((0, $6efb6ef5b61b5026$export$9cb4719e2e525b7a)($256f4b044c53ec49$var$previousConnections, connections)) return $256f4b044c53ec49$var$previousConnections;
    $256f4b044c53ec49$var$previousConnections = connections;
    return connections;
}




function $147b6d07e6824df4$export$a7de891c4ee82d0d(config, parameters) {
    const { onChange: onChange } = parameters;
    return config.subscribe(()=>(0, $256f4b044c53ec49$export$82b9f8f75cc709b4)(config), onChange, {
        equalityFn: (0, $6efb6ef5b61b5026$export$9cb4719e2e525b7a)
    });
}



var $8NFma = parcelRequire("8NFma");

"use client";
function $9c0869a3a66cb9cd$export$e54e57ae932f0754(parameters = {}) {
    const config = (0, $3fe8dc05b679ab9d$export$b3611e87cd5ba6ce)(parameters);
    return (0, $8NFma.useSyncExternalStore)((onChange)=>(0, $147b6d07e6824df4$export$a7de891c4ee82d0d)(config, {
            onChange: onChange
        }), ()=>(0, $256f4b044c53ec49$export$82b9f8f75cc709b4)(config), ()=>(0, $256f4b044c53ec49$export$82b9f8f75cc709b4)(config));
}


"use client";
function $e271cce8b43c0b7b$export$83bebf2fe7fead4e(parameters = {}) {
    const { mutation: mutation } = parameters;
    const config = (0, $3fe8dc05b679ab9d$export$b3611e87cd5ba6ce)(parameters);
    const mutationOptions = (0, $83db3dc983b448a5$export$81bca4b1e9392240)(config);
    const { mutate: mutate, mutateAsync: mutateAsync, ...result } = (0, $d18ed9863dec8f65$export$609860bf8b0084c)({
        ...mutation,
        ...mutationOptions
    });
    return {
        ...result,
        connectors: (0, $9c0869a3a66cb9cd$export$e54e57ae932f0754)({
            config: config
        }).map((connection)=>connection.connector),
        disconnect: mutate,
        disconnectAsync: mutateAsync
    };
}


var $854d6433ea8d1fc7$exports = {};

$854d6433ea8d1fc7$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "Wave.2a680c9e.svg";


var $c0f28aab14de6aeb$exports = {};

$c0f28aab14de6aeb$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "Wave2.22db6b94.svg";


var $18f9b0243b414b37$exports = {};

$18f9b0243b414b37$exports = (parcelRequire("hIarR")).getBundleURL("kBjr5") + "Wave3.ea6ec40e.svg";




parcelRequire("8NFma");

const $8cf33920e53a48fc$var$Dash = (0, $65e706775ff71837$export$d25ddfdf17c3ad3e)`
  to {
    stroke-dashoffset: 0;
  }
`;
const $8cf33920e53a48fc$var$AnimatedPath = (0, $65e706775ff71837$export$2e2bcd8739ae039).path`
  animation: ${$8cf33920e53a48fc$var$Dash} ${({ animationSpeed: animationSpeed })=>animationSpeed} cubic-bezier(0.650, 0.000, 0.450, 1.000) forwards;
  animation-delay: ${({ animationDelay: animationDelay })=>animationDelay};
`;
function $8cf33920e53a48fc$var$Checkmark({ animationDelay: animationDelay = "0.3s", animationSpeed: animationSpeed = "0.5s", ...props }) {
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("svg", {
        width: "52",
        height: "52",
        viewBox: "0 0 52 52",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        strokeWidth: 4,
        stroke: "white",
        ...props,
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($8cf33920e53a48fc$var$AnimatedPath, {
            animationDelay: animationDelay,
            animationSpeed: animationSpeed,
            strokeDashoffset: 100,
            strokeDasharray: 100,
            d: "M14.1 27.2l7.1 7.2 16.7-16.8"
        })
    });
}
var $8cf33920e53a48fc$export$2e2bcd8739ae039 = $8cf33920e53a48fc$var$Checkmark;



parcelRequire("8NFma");
function $ce72948bfd3a5859$var$Copy(props) {
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("g", {
                clipPath: "url(#clip0_3_1274)",
                children: [
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("path", {
                        d: "M16 3H4V16",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("path", {
                        d: "M8 7H20V19C20 20.1046 19.1046 21 18 21H10C8.89543 21 8 20.1046 8 19V7Z",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("clipPath", {
                    id: "clip0_3_1274",
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("rect", {
                        width: "24",
                        height: "24",
                        fill: "white"
                    })
                })
            })
        ]
    });
}
var $ce72948bfd3a5859$export$2e2bcd8739ae039 = $ce72948bfd3a5859$var$Copy;



parcelRequire("8NFma");

function $00de14b99ede8a79$var$GasPump(props) {
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARKEST,
        viewBox: "4 2.7 25.33 26.67",
        ...props,
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("path", {
                d: "M10 8.03353C9.63181 8.03353 9.33333 8.33201 9.33333 8.70019V14.7002H14.6667V8.70019C14.6667 8.33201 14.3682 8.03353 14 8.03353H10Z"
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M8 2.7002C5.79086 2.7002 4 4.49106 4 6.7002V28.0335C4 28.7699 4.59695 29.3669 5.33333 29.3669H18.6667C19.403 29.3669 20 28.7699 20 28.0335V17.3669H20.9253C21.7367 17.3669 22.36 18.0855 22.2452 18.8888L21.7507 22.3508C21.4227 24.6464 23.204 26.7002 25.5228 26.7002C27.6273 26.7002 29.3333 24.9942 29.3333 22.8897V10.5858C29.3333 9.87857 29.0524 9.20029 28.5523 8.70019L24.2761 4.42405L22.3905 6.30967L24 7.91915V11.8535C24 12.2492 24.1758 12.6244 24.4798 12.8778L26.6667 14.7002V22.8897C26.6667 23.5214 26.1546 24.0335 25.5228 24.0335C24.8268 24.0335 24.2921 23.417 24.3905 22.728L24.8851 19.2659C25.2294 16.8561 23.3595 14.7002 20.9253 14.7002H20V6.7002C20 4.49106 18.2091 2.7002 16 2.7002H8ZM17.3333 6.7002C17.3333 5.96382 16.7364 5.36686 16 5.36686H8C7.26362 5.36686 6.66667 5.96382 6.66667 6.7002V26.7002H17.3333V6.7002Z"
            })
        ]
    });
}
var $00de14b99ede8a79$export$2e2bcd8739ae039 = $00de14b99ede8a79$var$GasPump;




function $7c83a2e55b930364$export$9b8b3c5440f71236(item, currency, priceQuotes) {
    const conversion = priceQuotes.find((p)=>p.from === item.currency && p.to === currency)?.value ?? 1;
    return item.price * (item.quantity ?? 1) * conversion;
}
function $7c83a2e55b930364$export$d20ac211ddc8e780(dollarNumber) {
    return Math.max(0.5, Math.min(2.5, dollarNumber * 0.008));
}
function $7c83a2e55b930364$export$61a490a80c552550(value, from, to, priceQuotes, chargeCustomerNetworkFee, paymentMethodDiscount = 0) {
    const conversion = priceQuotes.find((p)=>p.from === from.toUpperCase() && p.to === to.toUpperCase())?.value ?? 1;
    const networkFeeDollarValue = $7c83a2e55b930364$export$d20ac211ddc8e780(value * (priceQuotes.find((p)=>p.from === from.toUpperCase() && p.to === "USD")?.value ?? 1));
    const networkFeeConvertedValue = networkFeeDollarValue / (priceQuotes.find((p)=>p.from === from.toUpperCase() && p.to === "USD")?.value ?? 1);
    return Number((value * conversion * (1 - paymentMethodDiscount) + (chargeCustomerNetworkFee ? networkFeeConvertedValue * conversion : 0)).toFixed(12));
}
function $7c83a2e55b930364$export$56eaa5cece9d2d8a(checkoutData, priceQuotes, primaryCurrency, discount) {
    let total = 0;
    let subscriptionTotal = 0;
    if (checkoutData.total) {
        total = checkoutData.total;
        return [
            total,
            subscriptionTotal
        ];
    }
    if (checkoutData.products) total += checkoutData.products.reduce((total, p)=>{
        let subTotal = $7c83a2e55b930364$export$9b8b3c5440f71236({
            ...p.product,
            quantity: p.quantity
        }, primaryCurrency, priceQuotes);
        if (discount?.products.includes(p.product.id)) switch(discount.model.modelType){
            case "fixed":
                subTotal -= discount.model.amountOff;
                break;
            case "percentage":
                subTotal -= subTotal * discount.model.amountOff / 100;
        }
        if (p.product.chargingIntervalSeconds > 0) subscriptionTotal += subTotal;
        return total + subTotal;
    }, 0);
    if (checkoutData.subscription) {
        const subTotal = $7c83a2e55b930364$export$9b8b3c5440f71236({
            price: Number(checkoutData.subscription.amount),
            currency: checkoutData.subscription.currency,
            quantity: 1
        }, primaryCurrency, priceQuotes);
        total += subTotal;
    }
    if (checkoutData.lineItems) total += checkoutData.lineItems.reduce((total, p)=>{
        const subTotal = $7c83a2e55b930364$export$9b8b3c5440f71236(p, primaryCurrency, priceQuotes);
        if (p.chargingIntervalSeconds > 0) subscriptionTotal += subTotal;
        return total + subTotal;
    }, 0);
    return [
        total,
        subscriptionTotal
    ];
}



var $fPXAQ = parcelRequire("fPXAQ");


async function $d70492f3fe4454f0$var$loadImage(src) {
    const image = new Image();
    image.crossOrigin = "anonymous";
    return await new Promise((resolve)=>{
        image.onload = ()=>{
            resolve(image);
        };
        image.src = src;
    });
}
async function $d70492f3fe4454f0$export$45312203e6f4f22c(paymentMethodDetails, darkColor = "#000000", lightColor = "#ffffff", drawRadius = true) {
    let dataUrl = "";
    const { network: network, token: token, paymentAddress: paymentAddress, amount: amount } = paymentMethodDetails;
    const paymentMethod = (0, $61f236426b9e4eab$export$8793fab959da70d1)(network, token);
    switch(paymentMethod.name){
        case "Bitcoin":
        case "BitcoinTestnet":
            dataUrl = `bitcoin:${paymentAddress}?value=${amount}`;
            break;
        case "Litecoin":
            dataUrl = `litecoin:${paymentAddress}}?amount=${amount}`;
            break;
        case "Ethereum":
        case "SepoliaTestnet":
        case "Polygon":
        case "PolygonTestnet":
        case "BNB":
        case "BNBTestnet":
        case "Arbitrum":
        case "Avalanche":
        case "Base":
        case "ArbitrumTestnet":
            dataUrl = `ethereum:${paymentAddress}?value=${(0, $1a21c088f688ce4c$export$642c4e67bbdc0bc7)(amount)}`;
            break;
        case "SolanaDevnet":
        case "SolanaTestnet":
        case "Solana":
            dataUrl = `solana:${paymentAddress}?value=${amount}`;
            break;
        case "Zcash":
        case "ZcashTestnet":
            dataUrl = `zcash:${paymentAddress}?value=${amount}`;
            break;
        case "Dogecoin":
            dataUrl = `dogecoin:${paymentAddress}?value=${amount}`;
            break;
        case "Tron":
        case "TronTestnet":
            dataUrl = `tron:${paymentAddress}?value=${(0, $996ac4676bde0a02$export$203ae30b4f6490b3)(amount, 6)}`;
            break;
        case "PolkadotAssetHub":
        case "PolkadotAssetHubTestnet":
        case "PolkadotTestnet":
        case "Polkadot":
            dataUrl = paymentAddress;
            break;
    }
    switch(paymentMethod.tokenInfo?.networkName){
        case "Ethereum":
        case "SepoliaTestnet":
        case "Polygon":
        case "PolygonTestnet":
        case "BNB":
        case "BNBTestnet":
        case "Arbitrum":
        case "Avalanche":
        case "Base":
        case "ArbitrumTestnet":
            {
                const { tokenAddress: tokenAddress, chainId: chainId, decimals: decimals } = paymentMethod.tokenInfo;
                dataUrl = `ethereum:${tokenAddress}@${chainId}/transfer?address=${paymentAddress}&uint256=${(0, $996ac4676bde0a02$export$203ae30b4f6490b3)(amount, decimals)}`;
                break;
            }
        case "Solana":
        case "SolanaDevnet":
        case "SolanaTestnet":
            {
                const { tokenAddress: tokenAddress, decimals: decimals, cluster: cluster } = paymentMethod.tokenInfo;
                dataUrl = `solana:${tokenAddress}@${cluster}/transfer?address=${paymentAddress}&uint256=${(0, $996ac4676bde0a02$export$203ae30b4f6490b3)(amount, decimals)}`;
                break;
            }
        case "Tron":
        case "TronTestnet":
            {
                const { tokenAddress: tokenAddress, decimals: decimals } = paymentMethod.tokenInfo;
                dataUrl = `tron:${tokenAddress}/transfer?address=${paymentAddress}&uint256=${(0, $996ac4676bde0a02$export$203ae30b4f6490b3)(amount, decimals)}`;
                break;
            }
        case "PolkadotAssetHubTestnet":
        case "PolkadotAssetHub":
            dataUrl = paymentAddress;
            break;
    }
    const width = 500;
    const height = 500;
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    (0, (/*@__PURE__*/$parcel$interopDefault($fPXAQ))).toCanvas(canvas, dataUrl, {
        errorCorrectionLevel: "H",
        margin: 1,
        color: {
            dark: darkColor,
            light: lightColor
        },
        width: 500
    });
    const ctx = canvas.getContext("2d");
    if (!ctx) {
        console.error("Failed to get canvas");
        return await Promise.reject(new Error("Failed to get canvas context"));
    }
    const img = await $d70492f3fe4454f0$var$loadImage(paymentMethod.qrCodeImage || paymentMethod.logo);
    const maxLogoSize = 100;
    ctx.beginPath();
    ctx.fillStyle = "#ffffff";
    const outlineSize = 20;
    if (paymentMethod.tokenInfo) {
        const imgMax = Math.max(img.width, img.height);
        const imgWidth = img.width / imgMax * maxLogoSize;
        const imgHeight = img.height / imgMax * maxLogoSize;
        const centerX = (500 - imgWidth) / 2;
        const centerY = (500 - imgHeight) / 2;
        if (drawRadius && ctx.roundRect) {
            ctx.roundRect(200 - outlineSize / 2, 200 - outlineSize / 2, maxLogoSize + outlineSize, maxLogoSize + outlineSize, 90);
            ctx.fill();
        }
        const chainImage = await $d70492f3fe4454f0$var$loadImage(paymentMethod.tokenInfo.logo);
        const chainImgMax = Math.max(chainImage.width, chainImage.height);
        const chainImgWidth = chainImage.width / chainImgMax * maxLogoSize / 2;
        const chainImgHeight = chainImage.height / chainImgMax * maxLogoSize / 2;
        if (drawRadius && ctx.roundRect) {
            ctx.roundRect(centerX + maxLogoSize / 2 + outlineSize - 14, centerX + maxLogoSize / 2 + outlineSize - 14, 70, 70, 90);
            ctx.fill();
        }
        ctx.drawImage(img, centerX, centerY, imgWidth, imgHeight);
        ctx.drawImage(chainImage, centerX + maxLogoSize / 2 + outlineSize + (Math.max(chainImgWidth, chainImgHeight) - chainImgWidth) / 2, centerY + maxLogoSize / 2 + outlineSize + (Math.max(chainImgWidth, chainImgHeight) - chainImgHeight) / 2, chainImgWidth, chainImgHeight);
    } else {
        const imgMax = Math.max(img.width, img.height);
        const imgWidth = img.width / imgMax * maxLogoSize;
        const imgHeight = img.height / imgMax * maxLogoSize;
        const centerX = (500 - imgWidth) / 2;
        const centerY = (500 - imgHeight) / 2;
        if (drawRadius && ctx.roundRect) {
            ctx.roundRect(200 - outlineSize / 2, 200 - outlineSize / 2, maxLogoSize + outlineSize, maxLogoSize + outlineSize, 90);
            ctx.fill();
        }
        ctx.drawImage(img, centerX, centerY, imgWidth, imgHeight);
    }
    const newImg = canvas.toDataURL("image/png");
    return [
        newImg,
        dataUrl
    ];
}




const $dc80f518f0729f3c$export$ac81a72f0c3b6512 = (0, $65e706775ff71837$export$d25ddfdf17c3ad3e)`
  from {
    background-color: rgba(7, 7, 40, 0);
  }
  to {
    background-color: rgba(7, 7, 40, 0.75);
  }
`;
const $dc80f518f0729f3c$export$f9ae25e7d5fbc8b9 = (0, $65e706775ff71837$export$d25ddfdf17c3ad3e)`    
  from {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
`;
const $dc80f518f0729f3c$export$c4535d5c0dad4021 = (0, $65e706775ff71837$export$d25ddfdf17c3ad3e)`
  from {
    /* transform: scaleY(0); */
    height: 0;
  }
  to {
    /* transform: scaleY(1) */
    height: fit-content;
  }
`;
const $dc80f518f0729f3c$export$b953c4562f8602be = (0, $65e706775ff71837$export$d25ddfdf17c3ad3e)`
  from {
    /* transform: scaleY(1) */
  }
  to {
    /* transform: scaleY(0) */
  }
`;
const $dc80f518f0729f3c$export$bd7370ffb2917ab7 = (0, $65e706775ff71837$export$d25ddfdf17c3ad3e)`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;
const $dc80f518f0729f3c$export$21430ab519d0e9c = (0, $65e706775ff71837$export$d25ddfdf17c3ad3e)`
  0% {
    opacity: 1;
  }
 100% {
    opacity: 0;
  }
`;





var $8NFma = parcelRequire("8NFma");



const $db6f3e1460c65a23$var$CheckboxWrapper = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
  background-color: ${({ isChecked: isChecked })=>isChecked ? (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).NICE_GREEN : "#FFF"};
  border: 1px solid;
  border-color: ${({ isChecked: isChecked })=>isChecked ? (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).NICE_GREEN : (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARK};
  border-radius: ${({ isRadio: isRadio })=>isRadio ? "100%" : "5px"};
  ${({ size: size })=>`
    min-width: ${size}px;
    max-width: ${size}px;
  `}
  ${({ size: size })=>`
    min-height: ${size}px;
    max-height: ${size}px;
  `}
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s ease all;
  position: relative;
  
  :focus-within {
    box-shadow: 0 0 5px ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).NICE_GREEN};
  }
  
  &:hover {
    border-color: ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).NICE_GREEN};
  }

  &:active {
    opacity: 0.5;
  }
`;
const $db6f3e1460c65a23$var$CheckboxInput = (0, $65e706775ff71837$export$2e2bcd8739ae039).input`
  cursor: pointer;
  appearance: none;
  width: 100%;
  height: 100%;
  outline: none;
`;
class $db6f3e1460c65a23$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    render() {
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($db6f3e1460c65a23$var$CheckboxWrapper, {
            size: this.props.size ?? 20,
            isRadio: !!this.props.isRadio,
            isChecked: this.props.checked,
            onClick: (e)=>{
                if (!this.props.disabled) this.props.onClick?.(e);
            },
            children: [
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($db6f3e1460c65a23$var$CheckboxInput, {
                    disabled: this.props.disabled,
                    onChange: ()=>{},
                    type: "checkbox",
                    name: "toggle",
                    checked: this.props.checked,
                    isChecked: this.props.checked
                }),
                this.props.checked && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $8cf33920e53a48fc$export$2e2bcd8739ae039), {
                    color: "white",
                    animationDelay: "0",
                    style: {
                        width: 20,
                        height: 20,
                        position: "absolute",
                        userSelect: "none"
                    }
                })
            ]
        });
    }
}





var $8NFma = parcelRequire("8NFma");





/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $492757110c774bc9$export$a143d493d941bafc;
var $492757110c774bc9$export$e4cf37d7f6fb9e0a;
var $492757110c774bc9$export$f99ded8fe4b79145;
var $492757110c774bc9$export$599f31c3813fae4d;
"use strict";

var $bQMRt = parcelRequire("bQMRt");

var $dbnIE = parcelRequire("dbnIE");
const $492757110c774bc9$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$492757110c774bc9$export$a143d493d941bafc = $492757110c774bc9$var$Buffer;
$492757110c774bc9$export$e4cf37d7f6fb9e0a = $492757110c774bc9$var$SlowBuffer;
$492757110c774bc9$export$f99ded8fe4b79145 = 50;
const $492757110c774bc9$var$K_MAX_LENGTH = 0x7fffffff;
$492757110c774bc9$export$599f31c3813fae4d = $492757110c774bc9$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $492757110c774bc9$var$Buffer.TYPED_ARRAY_SUPPORT = $492757110c774bc9$var$typedArraySupport();
if (!$492757110c774bc9$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $492757110c774bc9$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($492757110c774bc9$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$492757110c774bc9$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($492757110c774bc9$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$492757110c774bc9$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $492757110c774bc9$var$createBuffer(length) {
    if (length > $492757110c774bc9$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $492757110c774bc9$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $492757110c774bc9$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $492757110c774bc9$var$allocUnsafe(arg);
    }
    return $492757110c774bc9$var$from(arg, encodingOrOffset, length);
}
$492757110c774bc9$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $492757110c774bc9$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $492757110c774bc9$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $492757110c774bc9$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($492757110c774bc9$var$isInstance(value, ArrayBuffer) || value && $492757110c774bc9$var$isInstance(value.buffer, ArrayBuffer)) return $492757110c774bc9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($492757110c774bc9$var$isInstance(value, SharedArrayBuffer) || value && $492757110c774bc9$var$isInstance(value.buffer, SharedArrayBuffer))) return $492757110c774bc9$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $492757110c774bc9$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $492757110c774bc9$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $492757110c774bc9$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $492757110c774bc9$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $492757110c774bc9$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($492757110c774bc9$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($492757110c774bc9$var$Buffer, Uint8Array);
function $492757110c774bc9$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $492757110c774bc9$var$alloc(size, fill, encoding) {
    $492757110c774bc9$var$assertSize(size);
    if (size <= 0) return $492757110c774bc9$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $492757110c774bc9$var$createBuffer(size).fill(fill, encoding) : $492757110c774bc9$var$createBuffer(size).fill(fill);
    return $492757110c774bc9$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $492757110c774bc9$var$Buffer.alloc = function(size, fill, encoding) {
    return $492757110c774bc9$var$alloc(size, fill, encoding);
};
function $492757110c774bc9$var$allocUnsafe(size) {
    $492757110c774bc9$var$assertSize(size);
    return $492757110c774bc9$var$createBuffer(size < 0 ? 0 : $492757110c774bc9$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $492757110c774bc9$var$Buffer.allocUnsafe = function(size) {
    return $492757110c774bc9$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $492757110c774bc9$var$Buffer.allocUnsafeSlow = function(size) {
    return $492757110c774bc9$var$allocUnsafe(size);
};
function $492757110c774bc9$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$492757110c774bc9$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $492757110c774bc9$var$byteLength(string, encoding) | 0;
    let buf = $492757110c774bc9$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $492757110c774bc9$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $492757110c774bc9$var$checked(array.length) | 0;
    const buf = $492757110c774bc9$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $492757110c774bc9$var$fromArrayView(arrayView) {
    if ($492757110c774bc9$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $492757110c774bc9$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $492757110c774bc9$var$fromArrayLike(arrayView);
}
function $492757110c774bc9$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $492757110c774bc9$var$Buffer.prototype);
    return buf;
}
function $492757110c774bc9$var$fromObject(obj) {
    if ($492757110c774bc9$var$Buffer.isBuffer(obj)) {
        const len = $492757110c774bc9$var$checked(obj.length) | 0;
        const buf = $492757110c774bc9$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $492757110c774bc9$var$numberIsNaN(obj.length)) return $492757110c774bc9$var$createBuffer(0);
        return $492757110c774bc9$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $492757110c774bc9$var$fromArrayLike(obj.data);
}
function $492757110c774bc9$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $492757110c774bc9$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $492757110c774bc9$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $492757110c774bc9$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $492757110c774bc9$var$Buffer.alloc(+length);
}
$492757110c774bc9$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $492757110c774bc9$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$492757110c774bc9$var$Buffer.compare = function compare(a, b) {
    if ($492757110c774bc9$var$isInstance(a, Uint8Array)) a = $492757110c774bc9$var$Buffer.from(a, a.offset, a.byteLength);
    if ($492757110c774bc9$var$isInstance(b, Uint8Array)) b = $492757110c774bc9$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$492757110c774bc9$var$Buffer.isBuffer(a) || !$492757110c774bc9$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$492757110c774bc9$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$492757110c774bc9$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $492757110c774bc9$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $492757110c774bc9$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($492757110c774bc9$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$492757110c774bc9$var$Buffer.isBuffer(buf)) buf = $492757110c774bc9$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$492757110c774bc9$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $492757110c774bc9$var$byteLength(string, encoding) {
    if ($492757110c774bc9$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $492757110c774bc9$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $492757110c774bc9$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $492757110c774bc9$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $492757110c774bc9$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$492757110c774bc9$var$Buffer.byteLength = $492757110c774bc9$var$byteLength;
function $492757110c774bc9$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $492757110c774bc9$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $492757110c774bc9$var$utf8Slice(this, start, end);
        case "ascii":
            return $492757110c774bc9$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $492757110c774bc9$var$latin1Slice(this, start, end);
        case "base64":
            return $492757110c774bc9$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $492757110c774bc9$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$492757110c774bc9$var$Buffer.prototype._isBuffer = true;
function $492757110c774bc9$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$492757110c774bc9$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$492757110c774bc9$var$swap(this, i, i + 1);
    return this;
};
$492757110c774bc9$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $492757110c774bc9$var$swap(this, i, i + 3);
        $492757110c774bc9$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$492757110c774bc9$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $492757110c774bc9$var$swap(this, i, i + 7);
        $492757110c774bc9$var$swap(this, i + 1, i + 6);
        $492757110c774bc9$var$swap(this, i + 2, i + 5);
        $492757110c774bc9$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$492757110c774bc9$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $492757110c774bc9$var$utf8Slice(this, 0, length);
    return $492757110c774bc9$var$slowToString.apply(this, arguments);
};
$492757110c774bc9$var$Buffer.prototype.toLocaleString = $492757110c774bc9$var$Buffer.prototype.toString;
$492757110c774bc9$var$Buffer.prototype.equals = function equals(b) {
    if (!$492757110c774bc9$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $492757110c774bc9$var$Buffer.compare(this, b) === 0;
};
$492757110c774bc9$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $492757110c774bc9$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($492757110c774bc9$var$customInspectSymbol) $492757110c774bc9$var$Buffer.prototype[$492757110c774bc9$var$customInspectSymbol] = $492757110c774bc9$var$Buffer.prototype.inspect;
$492757110c774bc9$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($492757110c774bc9$var$isInstance(target, Uint8Array)) target = $492757110c774bc9$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$492757110c774bc9$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $492757110c774bc9$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($492757110c774bc9$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $492757110c774bc9$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($492757110c774bc9$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $492757110c774bc9$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $492757110c774bc9$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $492757110c774bc9$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$492757110c774bc9$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$492757110c774bc9$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $492757110c774bc9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$492757110c774bc9$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $492757110c774bc9$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $492757110c774bc9$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($492757110c774bc9$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $492757110c774bc9$var$utf8Write(buf, string, offset, length) {
    return $492757110c774bc9$var$blitBuffer($492757110c774bc9$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $492757110c774bc9$var$asciiWrite(buf, string, offset, length) {
    return $492757110c774bc9$var$blitBuffer($492757110c774bc9$var$asciiToBytes(string), buf, offset, length);
}
function $492757110c774bc9$var$base64Write(buf, string, offset, length) {
    return $492757110c774bc9$var$blitBuffer($492757110c774bc9$var$base64ToBytes(string), buf, offset, length);
}
function $492757110c774bc9$var$ucs2Write(buf, string, offset, length) {
    return $492757110c774bc9$var$blitBuffer($492757110c774bc9$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$492757110c774bc9$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $492757110c774bc9$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $492757110c774bc9$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $492757110c774bc9$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $492757110c774bc9$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $492757110c774bc9$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$492757110c774bc9$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $492757110c774bc9$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $bQMRt.fromByteArray(buf);
    else return $bQMRt.fromByteArray(buf.slice(start, end));
}
function $492757110c774bc9$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $492757110c774bc9$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $492757110c774bc9$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $492757110c774bc9$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $492757110c774bc9$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $492757110c774bc9$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $492757110c774bc9$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $492757110c774bc9$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $492757110c774bc9$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $492757110c774bc9$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $492757110c774bc9$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$492757110c774bc9$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $492757110c774bc9$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $492757110c774bc9$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$492757110c774bc9$var$Buffer.prototype.readUintLE = $492757110c774bc9$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $492757110c774bc9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$492757110c774bc9$var$Buffer.prototype.readUintBE = $492757110c774bc9$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $492757110c774bc9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$492757110c774bc9$var$Buffer.prototype.readUint8 = $492757110c774bc9$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $492757110c774bc9$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$492757110c774bc9$var$Buffer.prototype.readUint16LE = $492757110c774bc9$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $492757110c774bc9$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$492757110c774bc9$var$Buffer.prototype.readUint16BE = $492757110c774bc9$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $492757110c774bc9$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$492757110c774bc9$var$Buffer.prototype.readUint32LE = $492757110c774bc9$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $492757110c774bc9$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$492757110c774bc9$var$Buffer.prototype.readUint32BE = $492757110c774bc9$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $492757110c774bc9$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$492757110c774bc9$var$Buffer.prototype.readBigUInt64LE = $492757110c774bc9$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $492757110c774bc9$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $492757110c774bc9$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$492757110c774bc9$var$Buffer.prototype.readBigUInt64BE = $492757110c774bc9$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $492757110c774bc9$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $492757110c774bc9$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$492757110c774bc9$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $492757110c774bc9$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$492757110c774bc9$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $492757110c774bc9$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$492757110c774bc9$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $492757110c774bc9$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$492757110c774bc9$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $492757110c774bc9$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$492757110c774bc9$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $492757110c774bc9$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$492757110c774bc9$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $492757110c774bc9$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$492757110c774bc9$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $492757110c774bc9$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$492757110c774bc9$var$Buffer.prototype.readBigInt64LE = $492757110c774bc9$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $492757110c774bc9$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $492757110c774bc9$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$492757110c774bc9$var$Buffer.prototype.readBigInt64BE = $492757110c774bc9$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $492757110c774bc9$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $492757110c774bc9$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$492757110c774bc9$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $492757110c774bc9$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, true, 23, 4);
};
$492757110c774bc9$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $492757110c774bc9$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, false, 23, 4);
};
$492757110c774bc9$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $492757110c774bc9$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, true, 52, 8);
};
$492757110c774bc9$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $492757110c774bc9$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, false, 52, 8);
};
function $492757110c774bc9$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$492757110c774bc9$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$492757110c774bc9$var$Buffer.prototype.writeUintLE = $492757110c774bc9$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $492757110c774bc9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$492757110c774bc9$var$Buffer.prototype.writeUintBE = $492757110c774bc9$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $492757110c774bc9$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$492757110c774bc9$var$Buffer.prototype.writeUint8 = $492757110c774bc9$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $492757110c774bc9$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$492757110c774bc9$var$Buffer.prototype.writeUint16LE = $492757110c774bc9$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $492757110c774bc9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$492757110c774bc9$var$Buffer.prototype.writeUint16BE = $492757110c774bc9$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $492757110c774bc9$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$492757110c774bc9$var$Buffer.prototype.writeUint32LE = $492757110c774bc9$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $492757110c774bc9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$492757110c774bc9$var$Buffer.prototype.writeUint32BE = $492757110c774bc9$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $492757110c774bc9$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $492757110c774bc9$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $492757110c774bc9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $492757110c774bc9$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $492757110c774bc9$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$492757110c774bc9$var$Buffer.prototype.writeBigUInt64LE = $492757110c774bc9$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $492757110c774bc9$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$492757110c774bc9$var$Buffer.prototype.writeBigUInt64BE = $492757110c774bc9$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $492757110c774bc9$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$492757110c774bc9$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $492757110c774bc9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$492757110c774bc9$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $492757110c774bc9$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$492757110c774bc9$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $492757110c774bc9$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$492757110c774bc9$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $492757110c774bc9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$492757110c774bc9$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $492757110c774bc9$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$492757110c774bc9$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $492757110c774bc9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$492757110c774bc9$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $492757110c774bc9$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$492757110c774bc9$var$Buffer.prototype.writeBigInt64LE = $492757110c774bc9$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $492757110c774bc9$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$492757110c774bc9$var$Buffer.prototype.writeBigInt64BE = $492757110c774bc9$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $492757110c774bc9$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $492757110c774bc9$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $492757110c774bc9$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $492757110c774bc9$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$492757110c774bc9$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $492757110c774bc9$var$writeFloat(this, value, offset, true, noAssert);
};
$492757110c774bc9$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $492757110c774bc9$var$writeFloat(this, value, offset, false, noAssert);
};
function $492757110c774bc9$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $492757110c774bc9$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$492757110c774bc9$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $492757110c774bc9$var$writeDouble(this, value, offset, true, noAssert);
};
$492757110c774bc9$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $492757110c774bc9$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$492757110c774bc9$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$492757110c774bc9$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$492757110c774bc9$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$492757110c774bc9$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $492757110c774bc9$var$Buffer.isBuffer(val) ? val : $492757110c774bc9$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $492757110c774bc9$var$errors = {};
function $492757110c774bc9$var$E(sym, getMessage, Base) {
    $492757110c774bc9$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$492757110c774bc9$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$492757110c774bc9$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$492757110c774bc9$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $492757110c774bc9$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $492757110c774bc9$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $492757110c774bc9$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $492757110c774bc9$var$checkBounds(buf, offset, byteLength) {
    $492757110c774bc9$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $492757110c774bc9$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $492757110c774bc9$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $492757110c774bc9$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $492757110c774bc9$var$checkBounds(buf, offset, byteLength);
}
function $492757110c774bc9$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $492757110c774bc9$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $492757110c774bc9$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $492757110c774bc9$var$validateNumber(value, type);
        throw new $492757110c774bc9$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $492757110c774bc9$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $492757110c774bc9$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $492757110c774bc9$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $492757110c774bc9$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($492757110c774bc9$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $492757110c774bc9$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $492757110c774bc9$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $492757110c774bc9$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $492757110c774bc9$var$base64ToBytes(str) {
    return $bQMRt.toByteArray($492757110c774bc9$var$base64clean(str));
}
function $492757110c774bc9$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $492757110c774bc9$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $492757110c774bc9$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $492757110c774bc9$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $492757110c774bc9$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $492757110c774bc9$var$BufferBigIntNotDefined : fn;
}
function $492757110c774bc9$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $aHxry = parcelRequire("aHxry");

var $gbRBw = parcelRequire("gbRBw");

var $5358X = parcelRequire("5358X");
// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
const [$8774b6faece4a269$var$SHA512_Kh, $8774b6faece4a269$var$SHA512_Kl] = /* @__PURE__ */ (()=>(0, $gbRBw.default).split([
        "0x428a2f98d728ae22",
        "0x7137449123ef65cd",
        "0xb5c0fbcfec4d3b2f",
        "0xe9b5dba58189dbbc",
        "0x3956c25bf348b538",
        "0x59f111f1b605d019",
        "0x923f82a4af194f9b",
        "0xab1c5ed5da6d8118",
        "0xd807aa98a3030242",
        "0x12835b0145706fbe",
        "0x243185be4ee4b28c",
        "0x550c7dc3d5ffb4e2",
        "0x72be5d74f27b896f",
        "0x80deb1fe3b1696b1",
        "0x9bdc06a725c71235",
        "0xc19bf174cf692694",
        "0xe49b69c19ef14ad2",
        "0xefbe4786384f25e3",
        "0x0fc19dc68b8cd5b5",
        "0x240ca1cc77ac9c65",
        "0x2de92c6f592b0275",
        "0x4a7484aa6ea6e483",
        "0x5cb0a9dcbd41fbd4",
        "0x76f988da831153b5",
        "0x983e5152ee66dfab",
        "0xa831c66d2db43210",
        "0xb00327c898fb213f",
        "0xbf597fc7beef0ee4",
        "0xc6e00bf33da88fc2",
        "0xd5a79147930aa725",
        "0x06ca6351e003826f",
        "0x142929670a0e6e70",
        "0x27b70a8546d22ffc",
        "0x2e1b21385c26c926",
        "0x4d2c6dfc5ac42aed",
        "0x53380d139d95b3df",
        "0x650a73548baf63de",
        "0x766a0abb3c77b2a8",
        "0x81c2c92e47edaee6",
        "0x92722c851482353b",
        "0xa2bfe8a14cf10364",
        "0xa81a664bbc423001",
        "0xc24b8b70d0f89791",
        "0xc76c51a30654be30",
        "0xd192e819d6ef5218",
        "0xd69906245565a910",
        "0xf40e35855771202a",
        "0x106aa07032bbd1b8",
        "0x19a4c116b8d2d0c8",
        "0x1e376c085141ab53",
        "0x2748774cdf8eeb99",
        "0x34b0bcb5e19b48a8",
        "0x391c0cb3c5c95a63",
        "0x4ed8aa4ae3418acb",
        "0x5b9cca4f7763e373",
        "0x682e6ff3d6b2b8a3",
        "0x748f82ee5defb2fc",
        "0x78a5636f43172f60",
        "0x84c87814a1f0ab72",
        "0x8cc702081a6439ec",
        "0x90befffa23631e28",
        "0xa4506cebde82bde9",
        "0xbef9a3f7b2c67915",
        "0xc67178f2e372532b",
        "0xca273eceea26619c",
        "0xd186b8c721c0c207",
        "0xeada7dd6cde0eb1e",
        "0xf57d4f7fee6ed178",
        "0x06f067aa72176fba",
        "0x0a637dc5a2c898a6",
        "0x113f9804bef90dae",
        "0x1b710b35131c471b",
        "0x28db77f523047d84",
        "0x32caab7b40c72493",
        "0x3c9ebe0a15c9bebc",
        "0x431d67c49c100d4c",
        "0x4cc5d4becb3e42b6",
        "0x597f299cfc657e2a",
        "0x5fcb6fab3ad6faec",
        "0x6c44198c4a475817"
    ].map((n)=>BigInt(n))))();
// Temporary buffer, not used to store anything between runs
const $8774b6faece4a269$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $8774b6faece4a269$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $8774b6faece4a269$export$d655fdb8a1cad5df extends (0, $aHxry.HashMD) {
    constructor(){
        super(128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 1779033703;
        this.Al = -205731576;
        this.Bh = -1150833019;
        this.Bl = -2067093701;
        this.Ch = 1013904242;
        this.Cl = -23791573;
        this.Dh = -1521486534;
        this.Dl = 1595750129;
        this.Eh = 1359893119;
        this.El = -1377402159;
        this.Fh = -1694144372;
        this.Fl = 725511199;
        this.Gh = 528734635;
        this.Gl = -79577749;
        this.Hh = 1541459225;
        this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $8774b6faece4a269$var$SHA512_W_H[i] = view.getUint32(offset);
            $8774b6faece4a269$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $8774b6faece4a269$var$SHA512_W_H[i - 15] | 0;
            const W15l = $8774b6faece4a269$var$SHA512_W_L[i - 15] | 0;
            const s0h = (0, $gbRBw.default).rotrSH(W15h, W15l, 1) ^ (0, $gbRBw.default).rotrSH(W15h, W15l, 8) ^ (0, $gbRBw.default).shrSH(W15h, W15l, 7);
            const s0l = (0, $gbRBw.default).rotrSL(W15h, W15l, 1) ^ (0, $gbRBw.default).rotrSL(W15h, W15l, 8) ^ (0, $gbRBw.default).shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $8774b6faece4a269$var$SHA512_W_H[i - 2] | 0;
            const W2l = $8774b6faece4a269$var$SHA512_W_L[i - 2] | 0;
            const s1h = (0, $gbRBw.default).rotrSH(W2h, W2l, 19) ^ (0, $gbRBw.default).rotrBH(W2h, W2l, 61) ^ (0, $gbRBw.default).shrSH(W2h, W2l, 6);
            const s1l = (0, $gbRBw.default).rotrSL(W2h, W2l, 19) ^ (0, $gbRBw.default).rotrBL(W2h, W2l, 61) ^ (0, $gbRBw.default).shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = (0, $gbRBw.default).add4L(s0l, s1l, $8774b6faece4a269$var$SHA512_W_L[i - 7], $8774b6faece4a269$var$SHA512_W_L[i - 16]);
            const SUMh = (0, $gbRBw.default).add4H(SUMl, s0h, s1h, $8774b6faece4a269$var$SHA512_W_H[i - 7], $8774b6faece4a269$var$SHA512_W_H[i - 16]);
            $8774b6faece4a269$var$SHA512_W_H[i] = SUMh | 0;
            $8774b6faece4a269$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = (0, $gbRBw.default).rotrSH(Eh, El, 14) ^ (0, $gbRBw.default).rotrSH(Eh, El, 18) ^ (0, $gbRBw.default).rotrBH(Eh, El, 41);
            const sigma1l = (0, $gbRBw.default).rotrSL(Eh, El, 14) ^ (0, $gbRBw.default).rotrSL(Eh, El, 18) ^ (0, $gbRBw.default).rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = (0, $gbRBw.default).add5L(Hl, sigma1l, CHIl, $8774b6faece4a269$var$SHA512_Kl[i], $8774b6faece4a269$var$SHA512_W_L[i]);
            const T1h = (0, $gbRBw.default).add5H(T1ll, Hh, sigma1h, CHIh, $8774b6faece4a269$var$SHA512_Kh[i], $8774b6faece4a269$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = (0, $gbRBw.default).rotrSH(Ah, Al, 28) ^ (0, $gbRBw.default).rotrBH(Ah, Al, 34) ^ (0, $gbRBw.default).rotrBH(Ah, Al, 39);
            const sigma0l = (0, $gbRBw.default).rotrSL(Ah, Al, 28) ^ (0, $gbRBw.default).rotrBL(Ah, Al, 34) ^ (0, $gbRBw.default).rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = (0, $gbRBw.default).add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = (0, $gbRBw.default).add3L(T1l, sigma0l, MAJl);
            Ah = (0, $gbRBw.default).add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = (0, $gbRBw.default).add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = (0, $gbRBw.default).add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = (0, $gbRBw.default).add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = (0, $gbRBw.default).add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = (0, $gbRBw.default).add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = (0, $gbRBw.default).add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = (0, $gbRBw.default).add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = (0, $gbRBw.default).add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        $8774b6faece4a269$var$SHA512_W_H.fill(0);
        $8774b6faece4a269$var$SHA512_W_L.fill(0);
    }
    destroy() {
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
class $8774b6faece4a269$var$SHA512_224 extends $8774b6faece4a269$export$d655fdb8a1cad5df {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -1942145080;
        this.Al = 424955298;
        this.Bh = 1944164710;
        this.Bl = -1982016298;
        this.Ch = 502970286;
        this.Cl = 855612546;
        this.Dh = 1738396948;
        this.Dl = 1479516111;
        this.Eh = 258812777;
        this.El = 2077511080;
        this.Fh = 2011393907;
        this.Fl = 79989058;
        this.Gh = 1067287976;
        this.Gl = 1780299464;
        this.Hh = 286451373;
        this.Hl = -1848208735;
        this.outputLen = 28;
    }
}
class $8774b6faece4a269$var$SHA512_256 extends $8774b6faece4a269$export$d655fdb8a1cad5df {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 573645204;
        this.Al = -64227540;
        this.Bh = -1621794909;
        this.Bl = -934517566;
        this.Ch = 596883563;
        this.Cl = 1867755857;
        this.Dh = -1774684391;
        this.Dl = 1497426621;
        this.Eh = -1775747358;
        this.El = -1467023389;
        this.Fh = -1101128155;
        this.Fl = 1401305490;
        this.Gh = 721525244;
        this.Gl = 746961066;
        this.Hh = 246885852;
        this.Hl = -2117784414;
        this.outputLen = 32;
    }
}
class $8774b6faece4a269$var$SHA384 extends $8774b6faece4a269$export$d655fdb8a1cad5df {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -876896931;
        this.Al = -1056596264;
        this.Bh = 1654270250;
        this.Bl = 914150663;
        this.Ch = -1856437926;
        this.Cl = 812702999;
        this.Dh = 355462360;
        this.Dl = -150054599;
        this.Eh = 1731405415;
        this.El = -4191439;
        this.Fh = -1900787065;
        this.Fl = 1750603025;
        this.Gh = -619958771;
        this.Gl = 1694076839;
        this.Hh = 1203062813;
        this.Hl = -1090891868;
        this.outputLen = 48;
    }
}
const $8774b6faece4a269$export$a888d2532e6dc7bb = /* @__PURE__ */ (0, $5358X.wrapConstructor)(()=>new $8774b6faece4a269$export$d655fdb8a1cad5df());
const $8774b6faece4a269$export$a090a04f72f0a320 = /* @__PURE__ */ (0, $5358X.wrapConstructor)(()=>new $8774b6faece4a269$var$SHA512_224());
const $8774b6faece4a269$export$c78786b6da86db2a = /* @__PURE__ */ (0, $5358X.wrapConstructor)(()=>new $8774b6faece4a269$var$SHA512_256());
const $8774b6faece4a269$export$612d47d55dedde45 = /* @__PURE__ */ (0, $5358X.wrapConstructor)(()=>new $8774b6faece4a269$var$SHA384());



var $5358X = parcelRequire("5358X");
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Twisted Edwards curve. The formula is: ax² + y² = 1 + dx²y²

var $exvTT = parcelRequire("exvTT");

var $lzJFq = parcelRequire("lzJFq");

var $heHQ1 = parcelRequire("heHQ1");
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $ac16a359e860feb0$var$_0n = BigInt(0), $ac16a359e860feb0$var$_1n = BigInt(1), $ac16a359e860feb0$var$_2n = BigInt(2), $ac16a359e860feb0$var$_8n = BigInt(8);
// verification rule is either zip215 or rfc8032 / nist186-5. Consult fromHex:
const $ac16a359e860feb0$var$VERIFY_DEFAULT = {
    zip215: true
};
function $ac16a359e860feb0$var$validateOpts(curve) {
    const opts = (0, $exvTT.validateBasic)(curve);
    $heHQ1.validateObject(curve, {
        hash: "function",
        a: "bigint",
        d: "bigint",
        randomBytes: "function"
    }, {
        adjustScalarBytes: "function",
        domain: "function",
        uvRatio: "function",
        mapToCurve: "function"
    });
    // Set defaults
    return Object.freeze({
        ...opts
    });
}
function $ac16a359e860feb0$export$f0c1eee63ea541eb(curveDef) {
    const CURVE = $ac16a359e860feb0$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER, prehash: prehash, hash: cHash, randomBytes: randomBytes, nByteLength: nByteLength, h: cofactor } = CURVE;
    const MASK = $ac16a359e860feb0$var$_2n << BigInt(nByteLength * 8) - $ac16a359e860feb0$var$_1n;
    const modP = Fp.create; // Function overrides
    // sqrt(u/v)
    const uvRatio = CURVE.uvRatio || ((u, v)=>{
        try {
            return {
                isValid: true,
                value: Fp.sqrt(u * Fp.inv(v))
            };
        } catch (e) {
            return {
                isValid: false,
                value: $ac16a359e860feb0$var$_0n
            };
        }
    });
    const adjustScalarBytes = CURVE.adjustScalarBytes || ((bytes)=>bytes); // NOOP
    const domain = CURVE.domain || ((data, ctx, phflag)=>{
        (0, $heHQ1.abool)("phflag", phflag);
        if (ctx.length || phflag) throw new Error("Contexts/pre-hash are not supported");
        return data;
    }); // NOOP
    // 0 <= n < MASK
    // Coordinates larger than Fp.ORDER are allowed for zip215
    function aCoordinate(title, n) {
        $heHQ1.aInRange("coordinate " + title, n, $ac16a359e860feb0$var$_0n, MASK);
    }
    function assertPoint(other) {
        if (!(other instanceof Point)) throw new Error("ExtendedPoint expected");
    }
    // Converts Extended point to default (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    const toAffineMemo = (0, $heHQ1.memoized)((p, iz)=>{
        const { ex: x, ey: y, ez: z } = p;
        const is0 = p.is0();
        if (iz == null) iz = is0 ? $ac16a359e860feb0$var$_8n : Fp.inv(z); // 8 was chosen arbitrarily
        const ax = modP(x * iz);
        const ay = modP(y * iz);
        const zz = modP(z * iz);
        if (is0) return {
            x: $ac16a359e860feb0$var$_0n,
            y: $ac16a359e860feb0$var$_1n
        };
        if (zz !== $ac16a359e860feb0$var$_1n) throw new Error("invZ was invalid");
        return {
            x: ax,
            y: ay
        };
    });
    const assertValidMemo = (0, $heHQ1.memoized)((p)=>{
        const { a: a, d: d } = CURVE;
        if (p.is0()) throw new Error("bad point: ZERO"); // TODO: optimize, with vars below?
        // Equation in affine coordinates: ax² + y² = 1 + dx²y²
        // Equation in projective coordinates (X/Z, Y/Z, Z):  (aX² + Y²)Z² = Z⁴ + dX²Y²
        const { ex: X, ey: Y, ez: Z, et: T } = p;
        const X2 = modP(X * X); // X²
        const Y2 = modP(Y * Y); // Y²
        const Z2 = modP(Z * Z); // Z²
        const Z4 = modP(Z2 * Z2); // Z⁴
        const aX2 = modP(X2 * a); // aX²
        const left = modP(Z2 * modP(aX2 + Y2)); // (aX² + Y²)Z²
        const right = modP(Z4 + modP(d * modP(X2 * Y2))); // Z⁴ + dX²Y²
        if (left !== right) throw new Error("bad point: equation left != right (1)");
        // In Extended coordinates we also have T, which is x*y=T/Z: check X*Y == Z*T
        const XY = modP(X * Y);
        const ZT = modP(Z * T);
        if (XY !== ZT) throw new Error("bad point: equation left != right (2)");
        return true;
    });
    // Extended Point works in extended coordinates: (x, y, z, t) ∋ (x=x/z, y=y/z, t=xy).
    // https://en.wikipedia.org/wiki/Twisted_Edwards_curve#Extended_coordinates
    class Point {
        constructor(ex, ey, ez, et){
            this.ex = ex;
            this.ey = ey;
            this.ez = ez;
            this.et = et;
            aCoordinate("x", ex);
            aCoordinate("y", ey);
            aCoordinate("z", ez);
            aCoordinate("t", et);
            Object.freeze(this);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        static fromAffine(p) {
            if (p instanceof Point) throw new Error("extended point not allowed");
            const { x: x, y: y } = p || {};
            aCoordinate("x", x);
            aCoordinate("y", y);
            return new Point(x, y, $ac16a359e860feb0$var$_1n, modP(x * y));
        }
        static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.ez));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            wnaf.setWindowSize(this, windowSize);
        }
        // Not required for fromHex(), which always creates valid points.
        // Could be useful for fromAffine().
        assertValidity() {
            assertValidMemo(this);
        }
        // Compare one point to another.
        equals(other) {
            assertPoint(other);
            const { ex: X1, ey: Y1, ez: Z1 } = this;
            const { ex: X2, ey: Y2, ez: Z2 } = other;
            const X1Z2 = modP(X1 * Z2);
            const X2Z1 = modP(X2 * Z1);
            const Y1Z2 = modP(Y1 * Z2);
            const Y2Z1 = modP(Y2 * Z1);
            return X1Z2 === X2Z1 && Y1Z2 === Y2Z1;
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        negate() {
            // Flips point sign to a negative one (-x, y in affine coords)
            return new Point(modP(-this.ex), this.ey, this.ez, modP(-this.et));
        }
        // Fast algo for doubling Extended Point.
        // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#doubling-dbl-2008-hwcd
        // Cost: 4M + 4S + 1*a + 6add + 1*2.
        double() {
            const { a: a } = CURVE;
            const { ex: X1, ey: Y1, ez: Z1 } = this;
            const A = modP(X1 * X1); // A = X12
            const B = modP(Y1 * Y1); // B = Y12
            const C = modP($ac16a359e860feb0$var$_2n * modP(Z1 * Z1)); // C = 2*Z12
            const D = modP(a * A); // D = a*A
            const x1y1 = X1 + Y1;
            const E = modP(modP(x1y1 * x1y1) - A - B); // E = (X1+Y1)2-A-B
            const G = D + B; // G = D+B
            const F = G - C; // F = G-C
            const H = D - B; // H = D-B
            const X3 = modP(E * F); // X3 = E*F
            const Y3 = modP(G * H); // Y3 = G*H
            const T3 = modP(E * H); // T3 = E*H
            const Z3 = modP(F * G); // Z3 = F*G
            return new Point(X3, Y3, Z3, T3);
        }
        // Fast algo for adding 2 Extended Points.
        // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#addition-add-2008-hwcd
        // Cost: 9M + 1*a + 1*d + 7add.
        add(other) {
            assertPoint(other);
            const { a: a, d: d } = CURVE;
            const { ex: X1, ey: Y1, ez: Z1, et: T1 } = this;
            const { ex: X2, ey: Y2, ez: Z2, et: T2 } = other;
            // Faster algo for adding 2 Extended Points when curve's a=-1.
            // http://hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html#addition-add-2008-hwcd-4
            // Cost: 8M + 8add + 2*2.
            // Note: It does not check whether the `other` point is valid.
            if (a === BigInt(-1)) {
                const A = modP((Y1 - X1) * (Y2 + X2));
                const B = modP((Y1 + X1) * (Y2 - X2));
                const F = modP(B - A);
                if (F === $ac16a359e860feb0$var$_0n) return this.double(); // Same point. Tests say it doesn't affect timing
                const C = modP(Z1 * $ac16a359e860feb0$var$_2n * T2);
                const D = modP(T1 * $ac16a359e860feb0$var$_2n * Z2);
                const E = D + C;
                const G = B + A;
                const H = D - C;
                const X3 = modP(E * F);
                const Y3 = modP(G * H);
                const T3 = modP(E * H);
                const Z3 = modP(F * G);
                return new Point(X3, Y3, Z3, T3);
            }
            const A = modP(X1 * X2); // A = X1*X2
            const B = modP(Y1 * Y2); // B = Y1*Y2
            const C = modP(T1 * d * T2); // C = T1*d*T2
            const D = modP(Z1 * Z2); // D = Z1*Z2
            const E = modP((X1 + Y1) * (X2 + Y2) - A - B); // E = (X1+Y1)*(X2+Y2)-A-B
            const F = D - C; // F = D-C
            const G = D + C; // G = D+C
            const H = modP(B - a * A); // H = B-a*A
            const X3 = modP(E * F); // X3 = E*F
            const Y3 = modP(G * H); // Y3 = G*H
            const T3 = modP(E * H); // T3 = E*H
            const Z3 = modP(F * G); // Z3 = F*G
            return new Point(X3, Y3, Z3, T3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, n, Point.normalizeZ);
        }
        // Constant-time multiplication.
        multiply(scalar) {
            const n = scalar;
            $heHQ1.aInRange("scalar", n, $ac16a359e860feb0$var$_1n, CURVE_ORDER); // 1 <= scalar < L
            const { p: p, f: f } = this.wNAF(n);
            return Point.normalizeZ([
                p,
                f
            ])[0];
        }
        // Non-constant-time multiplication. Uses double-and-add algorithm.
        // It's faster, but should only be used when you don't care about
        // an exposed private key e.g. sig verification.
        // Does NOT allow scalars higher than CURVE.n.
        multiplyUnsafe(scalar) {
            const n = scalar;
            $heHQ1.aInRange("scalar", n, $ac16a359e860feb0$var$_0n, CURVE_ORDER); // 0 <= scalar < L
            if (n === $ac16a359e860feb0$var$_0n) return I;
            if (this.equals(I) || n === $ac16a359e860feb0$var$_1n) return this;
            if (this.equals(G)) return this.wNAF(n).p;
            return wnaf.unsafeLadder(this, n);
        }
        // Checks if point is of small order.
        // If you add something to small order point, you will have "dirty"
        // point with torsion component.
        // Multiplies point by cofactor and checks if the result is 0.
        isSmallOrder() {
            return this.multiplyUnsafe(cofactor).is0();
        }
        // Multiplies point by curve order and checks if the result is 0.
        // Returns `false` is the point is dirty.
        isTorsionFree() {
            return wnaf.unsafeLadder(this, CURVE_ORDER).is0();
        }
        // Converts Extended point to default (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        toAffine(iz) {
            return toAffineMemo(this, iz);
        }
        clearCofactor() {
            const { h: cofactor } = CURVE;
            if (cofactor === $ac16a359e860feb0$var$_1n) return this;
            return this.multiplyUnsafe(cofactor);
        }
        // Converts hash string or Uint8Array to Point.
        // Uses algo from RFC8032 5.1.3.
        static fromHex(hex, zip215 = false) {
            const { d: d, a: a } = CURVE;
            const len = Fp.BYTES;
            hex = (0, $heHQ1.ensureBytes)("pointHex", hex, len); // copy hex to a new array
            (0, $heHQ1.abool)("zip215", zip215);
            const normed = hex.slice(); // copy again, we'll manipulate it
            const lastByte = hex[len - 1]; // select last byte
            normed[len - 1] = lastByte & -129; // clear last bit
            const y = $heHQ1.bytesToNumberLE(normed);
            // RFC8032 prohibits >= p, but ZIP215 doesn't
            // zip215=true:  0 <= y < MASK (2^256 for ed25519)
            // zip215=false: 0 <= y < P (2^255-19 for ed25519)
            const max = zip215 ? MASK : Fp.ORDER;
            $heHQ1.aInRange("pointHex.y", y, $ac16a359e860feb0$var$_0n, max);
            // Ed25519: x² = (y²-1)/(dy²+1) mod p. Ed448: x² = (y²-1)/(dy²-1) mod p. Generic case:
            // ax²+y²=1+dx²y² => y²-1=dx²y²-ax² => y²-1=x²(dy²-a) => x²=(y²-1)/(dy²-a)
            const y2 = modP(y * y); // denominator is always non-0 mod p.
            const u = modP(y2 - $ac16a359e860feb0$var$_1n); // u = y² - 1
            const v = modP(d * y2 - a); // v = d y² + 1.
            let { isValid: isValid, value: x } = uvRatio(u, v); // √(u/v)
            if (!isValid) throw new Error("Point.fromHex: invalid y coordinate");
            const isXOdd = (x & $ac16a359e860feb0$var$_1n) === $ac16a359e860feb0$var$_1n; // There are 2 square roots. Use x_0 bit to select proper
            const isLastByteOdd = (lastByte & 0x80) !== 0; // x_0, last bit
            if (!zip215 && x === $ac16a359e860feb0$var$_0n && isLastByteOdd) // if x=0 and x_0 = 1, fail
            throw new Error("Point.fromHex: x=0 and x_0=1");
            if (isLastByteOdd !== isXOdd) x = modP(-x); // if x_0 != x mod 2, set x = p-x
            return Point.fromAffine({
                x: x,
                y: y
            });
        }
        static fromPrivateKey(privKey) {
            return getExtendedPublicKey(privKey).point;
        }
        toRawBytes() {
            const { x: x, y: y } = this.toAffine();
            const bytes = $heHQ1.numberToBytesLE(y, Fp.BYTES); // each y has 2 x values (x, -y)
            bytes[bytes.length - 1] |= x & $ac16a359e860feb0$var$_1n ? 0x80 : 0; // when compressing, it's enough to store y
            return bytes; // and use the last byte to encode sign of x
        }
        toHex() {
            return $heHQ1.bytesToHex(this.toRawBytes()); // Same as toRawBytes, but returns string.
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, $ac16a359e860feb0$var$_1n, modP(CURVE.Gx * CURVE.Gy));
    Point.ZERO = new Point($ac16a359e860feb0$var$_0n, $ac16a359e860feb0$var$_1n, $ac16a359e860feb0$var$_1n, $ac16a359e860feb0$var$_0n); // 0, 1, 1, 0
    const { BASE: G, ZERO: I } = Point;
    const wnaf = (0, $exvTT.wNAF)(Point, nByteLength * 8);
    function modN(a) {
        return (0, $lzJFq.mod)(a, CURVE_ORDER);
    }
    // Little-endian SHA512 with modulo n
    function modN_LE(hash) {
        return modN($heHQ1.bytesToNumberLE(hash));
    }
    /** Convenience method that creates public key and other stuff. RFC8032 5.1.5 */ function getExtendedPublicKey(key) {
        const len = nByteLength;
        key = (0, $heHQ1.ensureBytes)("private key", key, len);
        // Hash private key with curve's hash function to produce uniformingly random input
        // Check byte lengths: ensure(64, h(ensure(32, key)))
        const hashed = (0, $heHQ1.ensureBytes)("hashed private key", cHash(key), 2 * len);
        const head = adjustScalarBytes(hashed.slice(0, len)); // clear first half bits, produce FE
        const prefix = hashed.slice(len, 2 * len); // second half is called key prefix (5.1.6)
        const scalar = modN_LE(head); // The actual private scalar
        const point = G.multiply(scalar); // Point on Edwards curve aka public key
        const pointBytes = point.toRawBytes(); // Uint8Array representation
        return {
            head: head,
            prefix: prefix,
            scalar: scalar,
            point: point,
            pointBytes: pointBytes
        };
    }
    // Calculates EdDSA pub key. RFC8032 5.1.5. Privkey is hashed. Use first half with 3 bits cleared
    function getPublicKey(privKey) {
        return getExtendedPublicKey(privKey).pointBytes;
    }
    // int('LE', SHA512(dom2(F, C) || msgs)) mod N
    function hashDomainToScalar(context = new Uint8Array(), ...msgs) {
        const msg = $heHQ1.concatBytes(...msgs);
        return modN_LE(cHash(domain(msg, (0, $heHQ1.ensureBytes)("context", context), !!prehash)));
    }
    /** Signs message with privateKey. RFC8032 5.1.6 */ function sign(msg, privKey, options = {}) {
        msg = (0, $heHQ1.ensureBytes)("message", msg);
        if (prehash) msg = prehash(msg); // for ed25519ph etc.
        const { prefix: prefix, scalar: scalar, pointBytes: pointBytes } = getExtendedPublicKey(privKey);
        const r = hashDomainToScalar(options.context, prefix, msg); // r = dom2(F, C) || prefix || PH(M)
        const R = G.multiply(r).toRawBytes(); // R = rG
        const k = hashDomainToScalar(options.context, R, pointBytes, msg); // R || A || PH(M)
        const s = modN(r + k * scalar); // S = (r + k * s) mod L
        $heHQ1.aInRange("signature.s", s, $ac16a359e860feb0$var$_0n, CURVE_ORDER); // 0 <= s < l
        const res = $heHQ1.concatBytes(R, $heHQ1.numberToBytesLE(s, Fp.BYTES));
        return (0, $heHQ1.ensureBytes)("result", res, nByteLength * 2); // 64-byte signature
    }
    const verifyOpts = $ac16a359e860feb0$var$VERIFY_DEFAULT;
    function verify(sig, msg, publicKey, options = verifyOpts) {
        const { context: context, zip215: zip215 } = options;
        const len = Fp.BYTES; // Verifies EdDSA signature against message and public key. RFC8032 5.1.7.
        sig = (0, $heHQ1.ensureBytes)("signature", sig, 2 * len); // An extended group equation is checked.
        msg = (0, $heHQ1.ensureBytes)("message", msg);
        if (zip215 !== undefined) (0, $heHQ1.abool)("zip215", zip215);
        if (prehash) msg = prehash(msg); // for ed25519ph, etc
        const s = $heHQ1.bytesToNumberLE(sig.slice(len, 2 * len));
        // zip215: true is good for consensus-critical apps and allows points < 2^256
        // zip215: false follows RFC8032 / NIST186-5 and restricts points to CURVE.p
        let A, R, SB;
        try {
            A = Point.fromHex(publicKey, zip215);
            R = Point.fromHex(sig.slice(0, len), zip215);
            SB = G.multiplyUnsafe(s); // 0 <= s < l is done inside
        } catch (error) {
            return false;
        }
        if (!zip215 && A.isSmallOrder()) return false;
        const k = hashDomainToScalar(context, R.toRawBytes(), A.toRawBytes(), msg);
        const RkA = R.add(A.multiplyUnsafe(k));
        // [8][S]B = [8]R + [8][k]A'
        return RkA.subtract(SB).clearCofactor().equals(Point.ZERO);
    }
    G._setWindowSize(8); // Enable precomputes. Slows down first publicKey computation by 20ms.
    const utils = {
        getExtendedPublicKey: getExtendedPublicKey,
        // ed25519 private keys are uniform 32b. No need to check for modulo bias, like in secp256k1.
        randomPrivateKey: ()=>randomBytes(Fp.BYTES),
        /**
         * We're doing scalar multiplication (used in getPublicKey etc) with precomputed BASE_POINT
         * values. This slows down first getPublicKey() by milliseconds (see Speed section),
         * but allows to speed-up subsequent getPublicKey() calls up to 20x.
         * @param windowSize 2, 4, 8, 16
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3));
            return point;
        }
    };
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        sign: sign,
        verify: verify,
        ExtendedPoint: Point,
        utils: utils
    };
}



var $lzJFq = parcelRequire("lzJFq");

var $heHQ1 = parcelRequire("heHQ1");
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $28512be289571107$var$os2ip = (0, $heHQ1.bytesToNumberBE);
// Integer to Octet Stream (numberToBytesBE)
function $28512be289571107$var$i2osp(value, length) {
    if (value < 0 || value >= 1 << 8 * length) throw new Error(`bad I2OSP call: value=${value} length=${length}`);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $28512be289571107$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $28512be289571107$var$anum(item) {
    if (!Number.isSafeInteger(item)) throw new Error("number expected");
}
function $28512be289571107$export$3df78c69af9fc85d(msg, DST, lenInBytes, H) {
    (0, $heHQ1.abytes)(msg);
    (0, $heHQ1.abytes)(DST);
    $28512be289571107$var$anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $heHQ1.concatBytes)((0, $heHQ1.utf8ToBytes)("H2C-OVERSIZE-DST-"), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (ell > 255) throw new Error("Invalid xmd length");
    const DST_prime = (0, $heHQ1.concatBytes)(DST, $28512be289571107$var$i2osp(DST.length, 1));
    const Z_pad = $28512be289571107$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $28512be289571107$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $heHQ1.concatBytes)(Z_pad, msg, l_i_b_str, $28512be289571107$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $heHQ1.concatBytes)(b_0, $28512be289571107$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $28512be289571107$var$strxor(b_0, b[i - 1]),
            $28512be289571107$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $heHQ1.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, $heHQ1.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
function $28512be289571107$export$3f56d6fdbf95d07c(msg, DST, lenInBytes, k, H) {
    (0, $heHQ1.abytes)(msg);
    (0, $heHQ1.abytes)(DST);
    $28512be289571107$var$anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $heHQ1.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($28512be289571107$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($28512be289571107$var$i2osp(DST.length, 1)).digest();
}
function $28512be289571107$export$97cdd5ee18de8172(msg, count, options) {
    (0, $heHQ1.validateObject)(options, {
        DST: "stringOrUint8Array",
        p: "bigint",
        m: "isSafeInteger",
        k: "isSafeInteger",
        hash: "hash"
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: _DST } = options;
    (0, $heHQ1.abytes)(msg);
    $28512be289571107$var$anum(count);
    const DST = typeof _DST === "string" ? (0, $heHQ1.utf8ToBytes)(_DST) : _DST;
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === "xmd") prb = $28512be289571107$export$3df78c69af9fc85d(msg, DST, len_in_bytes, hash);
    else if (expand === "xof") prb = $28512be289571107$export$3f56d6fdbf95d07c(msg, DST, len_in_bytes, k, hash);
    else if (expand === "_internal_pass") // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $lzJFq.mod)($28512be289571107$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
function $28512be289571107$export$9393380cf1075f28(field, map) {
    // Make same order as in spec
    const COEFF = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xNum, xDen, yNum, yDen] = COEFF.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
function $28512be289571107$export$14b114effbc08b6b(Point, mapToCurve, def) {
    if (typeof mapToCurve !== "function") throw new Error("mapToCurve() must be defined");
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve (msg, options) {
            const u = $28512be289571107$export$97cdd5ee18de8172(msg, 2, {
                ...def,
                DST: def.DST,
                ...options
            });
            const u0 = Point.fromAffine(mapToCurve(u[0]));
            const u1 = Point.fromAffine(mapToCurve(u[1]));
            const P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve (msg, options) {
            const u = $28512be289571107$export$97cdd5ee18de8172(msg, 1, {
                ...def,
                DST: def.encodeDST,
                ...options
            });
            const P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Same as encodeToCurve, but without hash
        mapToCurve (scalars) {
            if (!Array.isArray(scalars)) throw new Error("mapToCurve: expected array of bigints");
            for (const i of scalars)if (typeof i !== "bigint") throw new Error(`mapToCurve: expected array of bigints, got ${i} in array`);
            const P = Point.fromAffine(mapToCurve(scalars)).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}



var $lzJFq = parcelRequire("lzJFq");
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $lzJFq = parcelRequire("lzJFq");

var $heHQ1 = parcelRequire("heHQ1");
const $fbdcde12220b0b1b$var$_0n = BigInt(0);
const $fbdcde12220b0b1b$var$_1n = BigInt(1);
function $fbdcde12220b0b1b$var$validateOpts(curve) {
    (0, $heHQ1.validateObject)(curve, {
        a: "bigint"
    }, {
        montgomeryBits: "isSafeInteger",
        nByteLength: "isSafeInteger",
        adjustScalarBytes: "function",
        domain: "function",
        powPminus2: "function",
        Gu: "bigint"
    });
    // Set defaults
    return Object.freeze({
        ...curve
    });
}
function $fbdcde12220b0b1b$export$bdbee0d01bf914a7(curveDef) {
    const CURVE = $fbdcde12220b0b1b$var$validateOpts(curveDef);
    const { P: P } = CURVE;
    const modP = (n)=>(0, $lzJFq.mod)(n, P);
    const montgomeryBits = CURVE.montgomeryBits;
    const montgomeryBytes = Math.ceil(montgomeryBits / 8);
    const fieldLen = CURVE.nByteLength;
    const adjustScalarBytes = CURVE.adjustScalarBytes || ((bytes)=>bytes);
    const powPminus2 = CURVE.powPminus2 || ((x)=>(0, $lzJFq.pow)(x, P - BigInt(2), P));
    // cswap from RFC7748. But it is not from RFC7748!
    /*
      cswap(swap, x_2, x_3):
           dummy = mask(swap) AND (x_2 XOR x_3)
           x_2 = x_2 XOR dummy
           x_3 = x_3 XOR dummy
           Return (x_2, x_3)
    Where mask(swap) is the all-1 or all-0 word of the same length as x_2
     and x_3, computed, e.g., as mask(swap) = 0 - swap.
    */ function cswap(swap, x_2, x_3) {
        const dummy = modP(swap * (x_2 - x_3));
        x_2 = modP(x_2 - dummy);
        x_3 = modP(x_3 + dummy);
        return [
            x_2,
            x_3
        ];
    }
    // x25519 from 4
    // The constant a24 is (486662 - 2) / 4 = 121665 for curve25519/X25519
    const a24 = (CURVE.a - BigInt(2)) / BigInt(4);
    /**
     *
     * @param pointU u coordinate (x) on Montgomery Curve 25519
     * @param scalar by which the point would be multiplied
     * @returns new Point on Montgomery curve
     */ function montgomeryLadder(u, scalar) {
        (0, $heHQ1.aInRange)("u", u, $fbdcde12220b0b1b$var$_0n, P);
        (0, $heHQ1.aInRange)("scalar", scalar, $fbdcde12220b0b1b$var$_0n, P);
        // Section 5: Implementations MUST accept non-canonical values and process them as
        // if they had been reduced modulo the field prime.
        const k = scalar;
        const x_1 = u;
        let x_2 = $fbdcde12220b0b1b$var$_1n;
        let z_2 = $fbdcde12220b0b1b$var$_0n;
        let x_3 = u;
        let z_3 = $fbdcde12220b0b1b$var$_1n;
        let swap = $fbdcde12220b0b1b$var$_0n;
        let sw;
        for(let t = BigInt(montgomeryBits - 1); t >= $fbdcde12220b0b1b$var$_0n; t--){
            const k_t = k >> t & $fbdcde12220b0b1b$var$_1n;
            swap ^= k_t;
            sw = cswap(swap, x_2, x_3);
            x_2 = sw[0];
            x_3 = sw[1];
            sw = cswap(swap, z_2, z_3);
            z_2 = sw[0];
            z_3 = sw[1];
            swap = k_t;
            const A = x_2 + z_2;
            const AA = modP(A * A);
            const B = x_2 - z_2;
            const BB = modP(B * B);
            const E = AA - BB;
            const C = x_3 + z_3;
            const D = x_3 - z_3;
            const DA = modP(D * A);
            const CB = modP(C * B);
            const dacb = DA + CB;
            const da_cb = DA - CB;
            x_3 = modP(dacb * dacb);
            z_3 = modP(x_1 * modP(da_cb * da_cb));
            x_2 = modP(AA * BB);
            z_2 = modP(E * (AA + modP(a24 * E)));
        }
        // (x_2, x_3) = cswap(swap, x_2, x_3)
        sw = cswap(swap, x_2, x_3);
        x_2 = sw[0];
        x_3 = sw[1];
        // (z_2, z_3) = cswap(swap, z_2, z_3)
        sw = cswap(swap, z_2, z_3);
        z_2 = sw[0];
        z_3 = sw[1];
        // z_2^(p - 2)
        const z2 = powPminus2(z_2);
        // Return x_2 * (z_2^(p - 2))
        return modP(x_2 * z2);
    }
    function encodeUCoordinate(u) {
        return (0, $heHQ1.numberToBytesLE)(modP(u), montgomeryBytes);
    }
    function decodeUCoordinate(uEnc) {
        // Section 5: When receiving such an array, implementations of X25519
        // MUST mask the most significant bit in the final byte.
        const u = (0, $heHQ1.ensureBytes)("u coordinate", uEnc, montgomeryBytes);
        if (fieldLen === 32) u[31] &= 127; // 0b0111_1111
        return (0, $heHQ1.bytesToNumberLE)(u);
    }
    function decodeScalar(n) {
        const bytes = (0, $heHQ1.ensureBytes)("scalar", n);
        const len = bytes.length;
        if (len !== montgomeryBytes && len !== fieldLen) throw new Error(`Expected ${montgomeryBytes} or ${fieldLen} bytes, got ${len}`);
        return (0, $heHQ1.bytesToNumberLE)(adjustScalarBytes(bytes));
    }
    function scalarMult(scalar, u) {
        const pointU = decodeUCoordinate(u);
        const _scalar = decodeScalar(scalar);
        const pu = montgomeryLadder(pointU, _scalar);
        // The result was not contributory
        // https://cr.yp.to/ecdh.html#validate
        if (pu === $fbdcde12220b0b1b$var$_0n) throw new Error("Invalid private or public key received");
        return encodeUCoordinate(pu);
    }
    // Computes public key from private. By doing scalar multiplication of base point.
    const GuBytes = encodeUCoordinate(CURVE.Gu);
    function scalarMultBase(scalar) {
        return scalarMult(scalar, GuBytes);
    }
    return {
        scalarMult: scalarMult,
        scalarMultBase: scalarMultBase,
        getSharedSecret: (privateKey, publicKey)=>scalarMult(privateKey, publicKey),
        getPublicKey: (privateKey)=>scalarMultBase(privateKey),
        utils: {
            randomPrivateKey: ()=>CURVE.randomBytes(CURVE.nByteLength)
        },
        GuBytes: GuBytes
    };
}



var $heHQ1 = parcelRequire("heHQ1");
/**
 * ed25519 Twisted Edwards curve with following addons:
 * - X25519 ECDH
 * - Ristretto cofactor elimination
 * - Elligator hash-to-group / point indistinguishability
 */ const $92e3b0bc7d4bbbb7$var$ED25519_P = BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949");
// √(-1) aka √(a) aka 2^((p-1)/4)
const $92e3b0bc7d4bbbb7$var$ED25519_SQRT_M1 = /* @__PURE__ */ BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");
// prettier-ignore
const $92e3b0bc7d4bbbb7$var$_0n = BigInt(0), $92e3b0bc7d4bbbb7$var$_1n = BigInt(1), $92e3b0bc7d4bbbb7$var$_2n = BigInt(2), $92e3b0bc7d4bbbb7$var$_3n = BigInt(3);
// prettier-ignore
const $92e3b0bc7d4bbbb7$var$_5n = BigInt(5), $92e3b0bc7d4bbbb7$var$_8n = BigInt(8);
function $92e3b0bc7d4bbbb7$var$ed25519_pow_2_252_3(x) {
    // prettier-ignore
    const _10n = BigInt(10), _20n = BigInt(20), _40n = BigInt(40), _80n = BigInt(80);
    const P = $92e3b0bc7d4bbbb7$var$ED25519_P;
    const x2 = x * x % P;
    const b2 = x2 * x % P; // x^3, 11
    const b4 = (0, $lzJFq.pow2)(b2, $92e3b0bc7d4bbbb7$var$_2n, P) * b2 % P; // x^15, 1111
    const b5 = (0, $lzJFq.pow2)(b4, $92e3b0bc7d4bbbb7$var$_1n, P) * x % P; // x^31
    const b10 = (0, $lzJFq.pow2)(b5, $92e3b0bc7d4bbbb7$var$_5n, P) * b5 % P;
    const b20 = (0, $lzJFq.pow2)(b10, _10n, P) * b10 % P;
    const b40 = (0, $lzJFq.pow2)(b20, _20n, P) * b20 % P;
    const b80 = (0, $lzJFq.pow2)(b40, _40n, P) * b40 % P;
    const b160 = (0, $lzJFq.pow2)(b80, _80n, P) * b80 % P;
    const b240 = (0, $lzJFq.pow2)(b160, _80n, P) * b80 % P;
    const b250 = (0, $lzJFq.pow2)(b240, _10n, P) * b10 % P;
    const pow_p_5_8 = (0, $lzJFq.pow2)(b250, $92e3b0bc7d4bbbb7$var$_2n, P) * x % P;
    // ^ To pow to (p+3)/8, multiply it by x.
    return {
        pow_p_5_8: pow_p_5_8,
        b2: b2
    };
}
function $92e3b0bc7d4bbbb7$var$adjustScalarBytes(bytes) {
    // Section 5: For X25519, in order to decode 32 random bytes as an integer scalar,
    // set the three least significant bits of the first byte
    bytes[0] &= 248; // 0b1111_1000
    // and the most significant bit of the last to zero,
    bytes[31] &= 127; // 0b0111_1111
    // set the second most significant bit of the last byte to 1
    bytes[31] |= 64; // 0b0100_0000
    return bytes;
}
// sqrt(u/v)
function $92e3b0bc7d4bbbb7$var$uvRatio(u, v) {
    const P = $92e3b0bc7d4bbbb7$var$ED25519_P;
    const v3 = (0, $lzJFq.mod)(v * v * v, P); // v³
    const v7 = (0, $lzJFq.mod)(v3 * v3 * v, P); // v⁷
    // (p+3)/8 and (p-5)/8
    const pow = $92e3b0bc7d4bbbb7$var$ed25519_pow_2_252_3(u * v7).pow_p_5_8;
    let x = (0, $lzJFq.mod)(u * v3 * pow, P); // (uv³)(uv⁷)^(p-5)/8
    const vx2 = (0, $lzJFq.mod)(v * x * x, P); // vx²
    const root1 = x; // First root candidate
    const root2 = (0, $lzJFq.mod)(x * $92e3b0bc7d4bbbb7$var$ED25519_SQRT_M1, P); // Second root candidate
    const useRoot1 = vx2 === u; // If vx² = u (mod p), x is a square root
    const useRoot2 = vx2 === (0, $lzJFq.mod)(-u, P); // If vx² = -u, set x <-- x * 2^((p-1)/4)
    const noRoot = vx2 === (0, $lzJFq.mod)(-u * $92e3b0bc7d4bbbb7$var$ED25519_SQRT_M1, P); // There is no valid root, vx² = -u√(-1)
    if (useRoot1) x = root1;
    if (useRoot2 || noRoot) x = root2; // We return root2 anyway, for const-time
    if ((0, $lzJFq.isNegativeLE)(x, P)) x = (0, $lzJFq.mod)(-x, P);
    return {
        isValid: useRoot1 || useRoot2,
        value: x
    };
}
const $92e3b0bc7d4bbbb7$export$5ce3305f0d0b8e6f = [
    "0100000000000000000000000000000000000000000000000000000000000000",
    "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac037a",
    "0000000000000000000000000000000000000000000000000000000000000080",
    "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc05",
    "ecffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff7f",
    "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc85",
    "0000000000000000000000000000000000000000000000000000000000000000",
    "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac03fa"
];
const $92e3b0bc7d4bbbb7$var$Fp = /* @__PURE__ */ (()=>(0, $lzJFq.Field)($92e3b0bc7d4bbbb7$var$ED25519_P, undefined, true))();
const $92e3b0bc7d4bbbb7$var$ed25519Defaults = /* @__PURE__ */ (()=>({
        // Param: a
        a: BigInt(-1),
        // d is equal to -121665/121666 over finite field.
        // Negative number is P - number, and division is invert(number, P)
        d: BigInt("37095705934669439343138083508754565189542113879843219016388785533085940283555"),
        Fp: // Finite field 𝔽p over which we'll do calculations; 2n**255n - 19n
        $92e3b0bc7d4bbbb7$var$Fp,
        // Subgroup order: how many points curve has
        // 2n**252n + 27742317777372353535851937790883648493n;
        n: BigInt("7237005577332262213973186563042994240857116359379907606001950938285454250989"),
        // Cofactor
        h: $92e3b0bc7d4bbbb7$var$_8n,
        // Base point (x, y) aka generator point
        Gx: BigInt("15112221349535400772501151409588531511454012693041857206046113283949847762202"),
        Gy: BigInt("46316835694926478169428394003475163141307993866256225615783033603165251855960"),
        hash: (0, $8774b6faece4a269$export$a888d2532e6dc7bb),
        randomBytes: $5358X.randomBytes,
        adjustScalarBytes: $92e3b0bc7d4bbbb7$var$adjustScalarBytes,
        uvRatio: // dom2
        // Ratio of u to v. Allows us to combine inversion and square root. Uses algo from RFC8032 5.1.3.
        // Constant-time, u/√v
        $92e3b0bc7d4bbbb7$var$uvRatio
    }))();
const $92e3b0bc7d4bbbb7$export$f63794f4a09a19c1 = /* @__PURE__ */ (()=>(0, $ac16a359e860feb0$export$f0c1eee63ea541eb)($92e3b0bc7d4bbbb7$var$ed25519Defaults))();
function $92e3b0bc7d4bbbb7$var$ed25519_domain(data, ctx, phflag) {
    if (ctx.length > 255) throw new Error("Context is too big");
    return (0, $5358X.concatBytes)((0, $5358X.utf8ToBytes)("SigEd25519 no Ed25519 collisions"), new Uint8Array([
        phflag ? 1 : 0,
        ctx.length
    ]), ctx, data);
}
const $92e3b0bc7d4bbbb7$export$1bc11da7986b0196 = /* @__PURE__ */ (()=>(0, $ac16a359e860feb0$export$f0c1eee63ea541eb)({
        ...$92e3b0bc7d4bbbb7$var$ed25519Defaults,
        domain: $92e3b0bc7d4bbbb7$var$ed25519_domain
    }))();
const $92e3b0bc7d4bbbb7$export$473acbb6f701cbb6 = /* @__PURE__ */ (()=>(0, $ac16a359e860feb0$export$f0c1eee63ea541eb)(Object.assign({}, $92e3b0bc7d4bbbb7$var$ed25519Defaults, {
        domain: $92e3b0bc7d4bbbb7$var$ed25519_domain,
        prehash: (0, $8774b6faece4a269$export$a888d2532e6dc7bb)
    })))();
const $92e3b0bc7d4bbbb7$export$dab9625394da700 = /* @__PURE__ */ (()=>(0, $fbdcde12220b0b1b$export$bdbee0d01bf914a7)({
        P: $92e3b0bc7d4bbbb7$var$ED25519_P,
        a: BigInt(486662),
        montgomeryBits: 255,
        nByteLength: 32,
        Gu: BigInt(9),
        powPminus2: (x)=>{
            const P = $92e3b0bc7d4bbbb7$var$ED25519_P;
            // x^(p-2) aka x^(2^255-21)
            const { pow_p_5_8: pow_p_5_8, b2: b2 } = $92e3b0bc7d4bbbb7$var$ed25519_pow_2_252_3(x);
            return (0, $lzJFq.mod)((0, $lzJFq.pow2)(pow_p_5_8, $92e3b0bc7d4bbbb7$var$_3n, P) * b2, P);
        },
        adjustScalarBytes: $92e3b0bc7d4bbbb7$var$adjustScalarBytes,
        randomBytes: $5358X.randomBytes
    }))();
function $92e3b0bc7d4bbbb7$export$78609ae56f1edf04(edwardsPub) {
    const { y: y } = $92e3b0bc7d4bbbb7$export$f63794f4a09a19c1.ExtendedPoint.fromHex(edwardsPub);
    const _1n = BigInt(1);
    return $92e3b0bc7d4bbbb7$var$Fp.toBytes($92e3b0bc7d4bbbb7$var$Fp.create((_1n + y) * $92e3b0bc7d4bbbb7$var$Fp.inv(_1n - y)));
}
const $92e3b0bc7d4bbbb7$export$84bc39a6e4664b07 = $92e3b0bc7d4bbbb7$export$78609ae56f1edf04; // deprecated
function $92e3b0bc7d4bbbb7$export$c32b0f86cebbdf19(edwardsPriv) {
    const hashed = $92e3b0bc7d4bbbb7$var$ed25519Defaults.hash(edwardsPriv.subarray(0, 32));
    return $92e3b0bc7d4bbbb7$var$ed25519Defaults.adjustScalarBytes(hashed).subarray(0, 32);
}
// Hash To Curve Elligator2 Map (NOTE: different from ristretto255 elligator)
// NOTE: very important part is usage of FpSqrtEven for ELL2_C1_EDWARDS, since
// SageMath returns different root first and everything falls apart
const $92e3b0bc7d4bbbb7$var$ELL2_C1 = /* @__PURE__ */ (()=>($92e3b0bc7d4bbbb7$var$Fp.ORDER + $92e3b0bc7d4bbbb7$var$_3n) / $92e3b0bc7d4bbbb7$var$_8n)(); // 1. c1 = (q + 3) / 8       # Integer arithmetic
const $92e3b0bc7d4bbbb7$var$ELL2_C2 = /* @__PURE__ */ (()=>$92e3b0bc7d4bbbb7$var$Fp.pow($92e3b0bc7d4bbbb7$var$_2n, $92e3b0bc7d4bbbb7$var$ELL2_C1))(); // 2. c2 = 2^c1
const $92e3b0bc7d4bbbb7$var$ELL2_C3 = /* @__PURE__ */ (()=>$92e3b0bc7d4bbbb7$var$Fp.sqrt($92e3b0bc7d4bbbb7$var$Fp.neg($92e3b0bc7d4bbbb7$var$Fp.ONE)))(); // 3. c3 = sqrt(-1)
// prettier-ignore
function $92e3b0bc7d4bbbb7$var$map_to_curve_elligator2_curve25519(u) {
    const ELL2_C4 = ($92e3b0bc7d4bbbb7$var$Fp.ORDER - $92e3b0bc7d4bbbb7$var$_5n) / $92e3b0bc7d4bbbb7$var$_8n; // 4. c4 = (q - 5) / 8       # Integer arithmetic
    const ELL2_J = BigInt(486662);
    let tv1 = $92e3b0bc7d4bbbb7$var$Fp.sqr(u); //  1.  tv1 = u^2
    tv1 = $92e3b0bc7d4bbbb7$var$Fp.mul(tv1, $92e3b0bc7d4bbbb7$var$_2n); //  2.  tv1 = 2 * tv1
    let xd = $92e3b0bc7d4bbbb7$var$Fp.add(tv1, $92e3b0bc7d4bbbb7$var$Fp.ONE); //  3.   xd = tv1 + 1         # Nonzero: -1 is square (mod p), tv1 is not
    let x1n = $92e3b0bc7d4bbbb7$var$Fp.neg(ELL2_J); //  4.  x1n = -J              # x1 = x1n / xd = -J / (1 + 2 * u^2)
    let tv2 = $92e3b0bc7d4bbbb7$var$Fp.sqr(xd); //  5.  tv2 = xd^2
    let gxd = $92e3b0bc7d4bbbb7$var$Fp.mul(tv2, xd); //  6.  gxd = tv2 * xd        # gxd = xd^3
    let gx1 = $92e3b0bc7d4bbbb7$var$Fp.mul(tv1, ELL2_J); //  7.  gx1 = J * tv1         # x1n + J * xd
    gx1 = $92e3b0bc7d4bbbb7$var$Fp.mul(gx1, x1n); //  8.  gx1 = gx1 * x1n       # x1n^2 + J * x1n * xd
    gx1 = $92e3b0bc7d4bbbb7$var$Fp.add(gx1, tv2); //  9.  gx1 = gx1 + tv2       # x1n^2 + J * x1n * xd + xd^2
    gx1 = $92e3b0bc7d4bbbb7$var$Fp.mul(gx1, x1n); //  10. gx1 = gx1 * x1n       # x1n^3 + J * x1n^2 * xd + x1n * xd^2
    let tv3 = $92e3b0bc7d4bbbb7$var$Fp.sqr(gxd); //  11. tv3 = gxd^2
    tv2 = $92e3b0bc7d4bbbb7$var$Fp.sqr(tv3); //  12. tv2 = tv3^2           # gxd^4
    tv3 = $92e3b0bc7d4bbbb7$var$Fp.mul(tv3, gxd); //  13. tv3 = tv3 * gxd       # gxd^3
    tv3 = $92e3b0bc7d4bbbb7$var$Fp.mul(tv3, gx1); //  14. tv3 = tv3 * gx1       # gx1 * gxd^3
    tv2 = $92e3b0bc7d4bbbb7$var$Fp.mul(tv2, tv3); //  15. tv2 = tv2 * tv3       # gx1 * gxd^7
    let y11 = $92e3b0bc7d4bbbb7$var$Fp.pow(tv2, ELL2_C4); //  16. y11 = tv2^c4        # (gx1 * gxd^7)^((p - 5) / 8)
    y11 = $92e3b0bc7d4bbbb7$var$Fp.mul(y11, tv3); //  17. y11 = y11 * tv3       # gx1*gxd^3*(gx1*gxd^7)^((p-5)/8)
    let y12 = $92e3b0bc7d4bbbb7$var$Fp.mul(y11, $92e3b0bc7d4bbbb7$var$ELL2_C3); //  18. y12 = y11 * c3
    tv2 = $92e3b0bc7d4bbbb7$var$Fp.sqr(y11); //  19. tv2 = y11^2
    tv2 = $92e3b0bc7d4bbbb7$var$Fp.mul(tv2, gxd); //  20. tv2 = tv2 * gxd
    let e1 = $92e3b0bc7d4bbbb7$var$Fp.eql(tv2, gx1); //  21.  e1 = tv2 == gx1
    let y1 = $92e3b0bc7d4bbbb7$var$Fp.cmov(y12, y11, e1); //  22.  y1 = CMOV(y12, y11, e1)  # If g(x1) is square, this is its sqrt
    let x2n = $92e3b0bc7d4bbbb7$var$Fp.mul(x1n, tv1); //  23. x2n = x1n * tv1       # x2 = x2n / xd = 2 * u^2 * x1n / xd
    let y21 = $92e3b0bc7d4bbbb7$var$Fp.mul(y11, u); //  24. y21 = y11 * u
    y21 = $92e3b0bc7d4bbbb7$var$Fp.mul(y21, $92e3b0bc7d4bbbb7$var$ELL2_C2); //  25. y21 = y21 * c2
    let y22 = $92e3b0bc7d4bbbb7$var$Fp.mul(y21, $92e3b0bc7d4bbbb7$var$ELL2_C3); //  26. y22 = y21 * c3
    let gx2 = $92e3b0bc7d4bbbb7$var$Fp.mul(gx1, tv1); //  27. gx2 = gx1 * tv1       # g(x2) = gx2 / gxd = 2 * u^2 * g(x1)
    tv2 = $92e3b0bc7d4bbbb7$var$Fp.sqr(y21); //  28. tv2 = y21^2
    tv2 = $92e3b0bc7d4bbbb7$var$Fp.mul(tv2, gxd); //  29. tv2 = tv2 * gxd
    let e2 = $92e3b0bc7d4bbbb7$var$Fp.eql(tv2, gx2); //  30.  e2 = tv2 == gx2
    let y2 = $92e3b0bc7d4bbbb7$var$Fp.cmov(y22, y21, e2); //  31.  y2 = CMOV(y22, y21, e2)  # If g(x2) is square, this is its sqrt
    tv2 = $92e3b0bc7d4bbbb7$var$Fp.sqr(y1); //  32. tv2 = y1^2
    tv2 = $92e3b0bc7d4bbbb7$var$Fp.mul(tv2, gxd); //  33. tv2 = tv2 * gxd
    let e3 = $92e3b0bc7d4bbbb7$var$Fp.eql(tv2, gx1); //  34.  e3 = tv2 == gx1
    let xn = $92e3b0bc7d4bbbb7$var$Fp.cmov(x2n, x1n, e3); //  35.  xn = CMOV(x2n, x1n, e3)  # If e3, x = x1, else x = x2
    let y = $92e3b0bc7d4bbbb7$var$Fp.cmov(y2, y1, e3); //  36.   y = CMOV(y2, y1, e3)    # If e3, y = y1, else y = y2
    let e4 = $92e3b0bc7d4bbbb7$var$Fp.isOdd(y); //  37.  e4 = sgn0(y) == 1        # Fix sign of y
    y = $92e3b0bc7d4bbbb7$var$Fp.cmov(y, $92e3b0bc7d4bbbb7$var$Fp.neg(y), e3 !== e4); //  38.   y = CMOV(y, -y, e3 XOR e4)
    return {
        xMn: xn,
        xMd: xd,
        yMn: y,
        yMd: $92e3b0bc7d4bbbb7$var$_1n
    }; //  39. return (xn, xd, y, 1)
}
const $92e3b0bc7d4bbbb7$var$ELL2_C1_EDWARDS = /* @__PURE__ */ (()=>(0, $lzJFq.FpSqrtEven)($92e3b0bc7d4bbbb7$var$Fp, $92e3b0bc7d4bbbb7$var$Fp.neg(BigInt(486664))))(); // sgn0(c1) MUST equal 0
function $92e3b0bc7d4bbbb7$var$map_to_curve_elligator2_edwards25519(u) {
    const { xMn: xMn, xMd: xMd, yMn: yMn, yMd: yMd } = $92e3b0bc7d4bbbb7$var$map_to_curve_elligator2_curve25519(u); //  1.  (xMn, xMd, yMn, yMd) =
    // map_to_curve_elligator2_curve25519(u)
    let xn = $92e3b0bc7d4bbbb7$var$Fp.mul(xMn, yMd); //  2.  xn = xMn * yMd
    xn = $92e3b0bc7d4bbbb7$var$Fp.mul(xn, $92e3b0bc7d4bbbb7$var$ELL2_C1_EDWARDS); //  3.  xn = xn * c1
    let xd = $92e3b0bc7d4bbbb7$var$Fp.mul(xMd, yMn); //  4.  xd = xMd * yMn    # xn / xd = c1 * xM / yM
    let yn = $92e3b0bc7d4bbbb7$var$Fp.sub(xMn, xMd); //  5.  yn = xMn - xMd
    let yd = $92e3b0bc7d4bbbb7$var$Fp.add(xMn, xMd); //  6.  yd = xMn + xMd    # (n / d - 1) / (n / d + 1) = (n - d) / (n + d)
    let tv1 = $92e3b0bc7d4bbbb7$var$Fp.mul(xd, yd); //  7. tv1 = xd * yd
    let e = $92e3b0bc7d4bbbb7$var$Fp.eql(tv1, $92e3b0bc7d4bbbb7$var$Fp.ZERO); //  8.   e = tv1 == 0
    xn = $92e3b0bc7d4bbbb7$var$Fp.cmov(xn, $92e3b0bc7d4bbbb7$var$Fp.ZERO, e); //  9.  xn = CMOV(xn, 0, e)
    xd = $92e3b0bc7d4bbbb7$var$Fp.cmov(xd, $92e3b0bc7d4bbbb7$var$Fp.ONE, e); //  10. xd = CMOV(xd, 1, e)
    yn = $92e3b0bc7d4bbbb7$var$Fp.cmov(yn, $92e3b0bc7d4bbbb7$var$Fp.ONE, e); //  11. yn = CMOV(yn, 1, e)
    yd = $92e3b0bc7d4bbbb7$var$Fp.cmov(yd, $92e3b0bc7d4bbbb7$var$Fp.ONE, e); //  12. yd = CMOV(yd, 1, e)
    const inv = $92e3b0bc7d4bbbb7$var$Fp.invertBatch([
        xd,
        yd
    ]); // batch division
    return {
        x: $92e3b0bc7d4bbbb7$var$Fp.mul(xn, inv[0]),
        y: $92e3b0bc7d4bbbb7$var$Fp.mul(yn, inv[1])
    }; //  13. return (xn, xd, yn, yd)
}
const $92e3b0bc7d4bbbb7$var$htf = /* @__PURE__ */ (()=>(0, $28512be289571107$export$14b114effbc08b6b)($92e3b0bc7d4bbbb7$export$f63794f4a09a19c1.ExtendedPoint, (scalars)=>$92e3b0bc7d4bbbb7$var$map_to_curve_elligator2_edwards25519(scalars[0]), {
        DST: "edwards25519_XMD:SHA-512_ELL2_RO_",
        encodeDST: "edwards25519_XMD:SHA-512_ELL2_NU_",
        p: $92e3b0bc7d4bbbb7$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: (0, $8774b6faece4a269$export$a888d2532e6dc7bb)
    }))();
const $92e3b0bc7d4bbbb7$export$a95cc2b0cdb9c1e1 = /* @__PURE__ */ (()=>$92e3b0bc7d4bbbb7$var$htf.hashToCurve)();
const $92e3b0bc7d4bbbb7$export$124e820e7679cc3 = /* @__PURE__ */ (()=>$92e3b0bc7d4bbbb7$var$htf.encodeToCurve)();
function $92e3b0bc7d4bbbb7$var$assertRstPoint(other) {
    if (!(other instanceof $92e3b0bc7d4bbbb7$var$RistPoint)) throw new Error("RistrettoPoint expected");
}
// √(-1) aka √(a) aka 2^((p-1)/4)
const $92e3b0bc7d4bbbb7$var$SQRT_M1 = $92e3b0bc7d4bbbb7$var$ED25519_SQRT_M1;
// √(ad - 1)
const $92e3b0bc7d4bbbb7$var$SQRT_AD_MINUS_ONE = /* @__PURE__ */ BigInt("25063068953384623474111414158702152701244531502492656460079210482610430750235");
// 1 / √(a-d)
const $92e3b0bc7d4bbbb7$var$INVSQRT_A_MINUS_D = /* @__PURE__ */ BigInt("54469307008909316920995813868745141605393597292927456921205312896311721017578");
// 1-d²
const $92e3b0bc7d4bbbb7$var$ONE_MINUS_D_SQ = /* @__PURE__ */ BigInt("1159843021668779879193775521855586647937357759715417654439879720876111806838");
// (d-1)²
const $92e3b0bc7d4bbbb7$var$D_MINUS_ONE_SQ = /* @__PURE__ */ BigInt("40440834346308536858101042469323190826248399146238708352240133220865137265952");
// Calculates 1/√(number)
const $92e3b0bc7d4bbbb7$var$invertSqrt = (number)=>$92e3b0bc7d4bbbb7$var$uvRatio($92e3b0bc7d4bbbb7$var$_1n, number);
const $92e3b0bc7d4bbbb7$var$MAX_255B = /* @__PURE__ */ BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $92e3b0bc7d4bbbb7$var$bytes255ToNumberLE = (bytes)=>$92e3b0bc7d4bbbb7$export$f63794f4a09a19c1.CURVE.Fp.create((0, $heHQ1.bytesToNumberLE)(bytes) & $92e3b0bc7d4bbbb7$var$MAX_255B);
// Computes Elligator map for Ristretto
// https://ristretto.group/formulas/elligator.html
function $92e3b0bc7d4bbbb7$var$calcElligatorRistrettoMap(r0) {
    const { d: d } = $92e3b0bc7d4bbbb7$export$f63794f4a09a19c1.CURVE;
    const P = $92e3b0bc7d4bbbb7$export$f63794f4a09a19c1.CURVE.Fp.ORDER;
    const mod = $92e3b0bc7d4bbbb7$export$f63794f4a09a19c1.CURVE.Fp.create;
    const r = mod($92e3b0bc7d4bbbb7$var$SQRT_M1 * r0 * r0); // 1
    const Ns = mod((r + $92e3b0bc7d4bbbb7$var$_1n) * $92e3b0bc7d4bbbb7$var$ONE_MINUS_D_SQ); // 2
    let c = BigInt(-1); // 3
    const D = mod((c - d * r) * mod(r + d)); // 4
    let { isValid: Ns_D_is_sq, value: s } = $92e3b0bc7d4bbbb7$var$uvRatio(Ns, D); // 5
    let s_ = mod(s * r0); // 6
    if (!(0, $lzJFq.isNegativeLE)(s_, P)) s_ = mod(-s_);
    if (!Ns_D_is_sq) s = s_; // 7
    if (!Ns_D_is_sq) c = r; // 8
    const Nt = mod(c * (r - $92e3b0bc7d4bbbb7$var$_1n) * $92e3b0bc7d4bbbb7$var$D_MINUS_ONE_SQ - D); // 9
    const s2 = s * s;
    const W0 = mod((s + s) * D); // 10
    const W1 = mod(Nt * $92e3b0bc7d4bbbb7$var$SQRT_AD_MINUS_ONE); // 11
    const W2 = mod($92e3b0bc7d4bbbb7$var$_1n - s2); // 12
    const W3 = mod($92e3b0bc7d4bbbb7$var$_1n + s2); // 13
    return new $92e3b0bc7d4bbbb7$export$f63794f4a09a19c1.ExtendedPoint(mod(W0 * W3), mod(W2 * W1), mod(W1 * W3), mod(W0 * W2));
}
/**
 * Each ed25519/ExtendedPoint has 8 different equivalent points. This can be
 * a source of bugs for protocols like ring signatures. Ristretto was created to solve this.
 * Ristretto point operates in X:Y:Z:T extended coordinates like ExtendedPoint,
 * but it should work in its own namespace: do not combine those two.
 * https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-ristretto255-decaf448
 */ class $92e3b0bc7d4bbbb7$var$RistPoint {
    // Private property to discourage combining ExtendedPoint + RistrettoPoint
    // Always use Ristretto encoding/decoding instead.
    constructor(ep){
        this.ep = ep;
    }
    static fromAffine(ap) {
        return new $92e3b0bc7d4bbbb7$var$RistPoint($92e3b0bc7d4bbbb7$export$f63794f4a09a19c1.ExtendedPoint.fromAffine(ap));
    }
    /**
     * Takes uniform output of 64-byte hash function like sha512 and converts it to `RistrettoPoint`.
     * The hash-to-group operation applies Elligator twice and adds the results.
     * **Note:** this is one-way map, there is no conversion from point to hash.
     * https://ristretto.group/formulas/elligator.html
     * @param hex 64-byte output of a hash function
     */ static hashToCurve(hex) {
        hex = (0, $heHQ1.ensureBytes)("ristrettoHash", hex, 64);
        const r1 = $92e3b0bc7d4bbbb7$var$bytes255ToNumberLE(hex.slice(0, 32));
        const R1 = $92e3b0bc7d4bbbb7$var$calcElligatorRistrettoMap(r1);
        const r2 = $92e3b0bc7d4bbbb7$var$bytes255ToNumberLE(hex.slice(32, 64));
        const R2 = $92e3b0bc7d4bbbb7$var$calcElligatorRistrettoMap(r2);
        return new $92e3b0bc7d4bbbb7$var$RistPoint(R1.add(R2));
    }
    /**
     * Converts ristretto-encoded string to ristretto point.
     * https://ristretto.group/formulas/decoding.html
     * @param hex Ristretto-encoded 32 bytes. Not every 32-byte string is valid ristretto encoding
     */ static fromHex(hex) {
        hex = (0, $heHQ1.ensureBytes)("ristrettoHex", hex, 32);
        const { a: a, d: d } = $92e3b0bc7d4bbbb7$export$f63794f4a09a19c1.CURVE;
        const P = $92e3b0bc7d4bbbb7$export$f63794f4a09a19c1.CURVE.Fp.ORDER;
        const mod = $92e3b0bc7d4bbbb7$export$f63794f4a09a19c1.CURVE.Fp.create;
        const emsg = "RistrettoPoint.fromHex: the hex is not valid encoding of RistrettoPoint";
        const s = $92e3b0bc7d4bbbb7$var$bytes255ToNumberLE(hex);
        // 1. Check that s_bytes is the canonical encoding of a field element, or else abort.
        // 3. Check that s is non-negative, or else abort
        if (!(0, $heHQ1.equalBytes)((0, $heHQ1.numberToBytesLE)(s, 32), hex) || (0, $lzJFq.isNegativeLE)(s, P)) throw new Error(emsg);
        const s2 = mod(s * s);
        const u1 = mod($92e3b0bc7d4bbbb7$var$_1n + a * s2); // 4 (a is -1)
        const u2 = mod($92e3b0bc7d4bbbb7$var$_1n - a * s2); // 5
        const u1_2 = mod(u1 * u1);
        const u2_2 = mod(u2 * u2);
        const v = mod(a * d * u1_2 - u2_2); // 6
        const { isValid: isValid, value: I } = $92e3b0bc7d4bbbb7$var$invertSqrt(mod(v * u2_2)); // 7
        const Dx = mod(I * u2); // 8
        const Dy = mod(I * Dx * v); // 9
        let x = mod((s + s) * Dx); // 10
        if ((0, $lzJFq.isNegativeLE)(x, P)) x = mod(-x); // 10
        const y = mod(u1 * Dy); // 11
        const t = mod(x * y); // 12
        if (!isValid || (0, $lzJFq.isNegativeLE)(t, P) || y === $92e3b0bc7d4bbbb7$var$_0n) throw new Error(emsg);
        return new $92e3b0bc7d4bbbb7$var$RistPoint(new $92e3b0bc7d4bbbb7$export$f63794f4a09a19c1.ExtendedPoint(x, y, $92e3b0bc7d4bbbb7$var$_1n, t));
    }
    /**
     * Encodes ristretto point to Uint8Array.
     * https://ristretto.group/formulas/encoding.html
     */ toRawBytes() {
        let { ex: x, ey: y, ez: z, et: t } = this.ep;
        const P = $92e3b0bc7d4bbbb7$export$f63794f4a09a19c1.CURVE.Fp.ORDER;
        const mod = $92e3b0bc7d4bbbb7$export$f63794f4a09a19c1.CURVE.Fp.create;
        const u1 = mod(mod(z + y) * mod(z - y)); // 1
        const u2 = mod(x * y); // 2
        // Square root always exists
        const u2sq = mod(u2 * u2);
        const { value: invsqrt } = $92e3b0bc7d4bbbb7$var$invertSqrt(mod(u1 * u2sq)); // 3
        const D1 = mod(invsqrt * u1); // 4
        const D2 = mod(invsqrt * u2); // 5
        const zInv = mod(D1 * D2 * t); // 6
        let D; // 7
        if ((0, $lzJFq.isNegativeLE)(t * zInv, P)) {
            let _x = mod(y * $92e3b0bc7d4bbbb7$var$SQRT_M1);
            let _y = mod(x * $92e3b0bc7d4bbbb7$var$SQRT_M1);
            x = _x;
            y = _y;
            D = mod(D1 * $92e3b0bc7d4bbbb7$var$INVSQRT_A_MINUS_D);
        } else D = D2; // 8
        if ((0, $lzJFq.isNegativeLE)(x * zInv, P)) y = mod(-y); // 9
        let s = mod((z - y) * D); // 10 (check footer's note, no sqrt(-a))
        if ((0, $lzJFq.isNegativeLE)(s, P)) s = mod(-s);
        return (0, $heHQ1.numberToBytesLE)(s, 32); // 11
    }
    toHex() {
        return (0, $heHQ1.bytesToHex)(this.toRawBytes());
    }
    toString() {
        return this.toHex();
    }
    // Compare one point to another.
    equals(other) {
        $92e3b0bc7d4bbbb7$var$assertRstPoint(other);
        const { ex: X1, ey: Y1 } = this.ep;
        const { ex: X2, ey: Y2 } = other.ep;
        const mod = $92e3b0bc7d4bbbb7$export$f63794f4a09a19c1.CURVE.Fp.create;
        // (x1 * y2 == y1 * x2) | (y1 * y2 == x1 * x2)
        const one = mod(X1 * Y2) === mod(Y1 * X2);
        const two = mod(Y1 * Y2) === mod(X1 * X2);
        return one || two;
    }
    add(other) {
        $92e3b0bc7d4bbbb7$var$assertRstPoint(other);
        return new $92e3b0bc7d4bbbb7$var$RistPoint(this.ep.add(other.ep));
    }
    subtract(other) {
        $92e3b0bc7d4bbbb7$var$assertRstPoint(other);
        return new $92e3b0bc7d4bbbb7$var$RistPoint(this.ep.subtract(other.ep));
    }
    multiply(scalar) {
        return new $92e3b0bc7d4bbbb7$var$RistPoint(this.ep.multiply(scalar));
    }
    multiplyUnsafe(scalar) {
        return new $92e3b0bc7d4bbbb7$var$RistPoint(this.ep.multiplyUnsafe(scalar));
    }
    double() {
        return new $92e3b0bc7d4bbbb7$var$RistPoint(this.ep.double());
    }
    negate() {
        return new $92e3b0bc7d4bbbb7$var$RistPoint(this.ep.negate());
    }
}
const $92e3b0bc7d4bbbb7$export$5e87c4f36f27816d = /* @__PURE__ */ (()=>{
    if (!$92e3b0bc7d4bbbb7$var$RistPoint.BASE) $92e3b0bc7d4bbbb7$var$RistPoint.BASE = new $92e3b0bc7d4bbbb7$var$RistPoint($92e3b0bc7d4bbbb7$export$f63794f4a09a19c1.ExtendedPoint.BASE);
    if (!$92e3b0bc7d4bbbb7$var$RistPoint.ZERO) $92e3b0bc7d4bbbb7$var$RistPoint.ZERO = new $92e3b0bc7d4bbbb7$var$RistPoint($92e3b0bc7d4bbbb7$export$f63794f4a09a19c1.ExtendedPoint.ZERO);
    return $92e3b0bc7d4bbbb7$var$RistPoint;
})();
const $92e3b0bc7d4bbbb7$export$c9ad4c0d917ad3 = (msg, options)=>{
    const d = options.DST;
    const DST = typeof d === "string" ? (0, $5358X.utf8ToBytes)(d) : d;
    const uniform_bytes = (0, $28512be289571107$export$3df78c69af9fc85d)(msg, DST, 64, (0, $8774b6faece4a269$export$a888d2532e6dc7bb));
    const P = $92e3b0bc7d4bbbb7$var$RistPoint.hashToCurve(uniform_bytes);
    return P;
};
const $92e3b0bc7d4bbbb7$export$667ef88de7a83a7f = $92e3b0bc7d4bbbb7$export$c9ad4c0d917ad3; // legacy



var $lONYJ = parcelRequire("lONYJ");
var $d47ad8a6a3d340ae$exports = {};

var $fq3eW = parcelRequire("fq3eW");
var $d47ad8a6a3d340ae$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
$d47ad8a6a3d340ae$exports = $fq3eW($d47ad8a6a3d340ae$var$ALPHABET);



var $jfkMZ = parcelRequire("jfkMZ");
var $7a17e8040de0e363$exports = {};

var $N0o3H = parcelRequire("N0o3H");
var $7a17e8040de0e363$require$Buffer = $N0o3H.Buffer;
"use strict";
var $7a17e8040de0e363$var$__createBinding = $7a17e8040de0e363$exports && $7a17e8040de0e363$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7a17e8040de0e363$var$__setModuleDefault = $7a17e8040de0e363$exports && $7a17e8040de0e363$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $7a17e8040de0e363$var$__decorate = $7a17e8040de0e363$exports && $7a17e8040de0e363$exports.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var $7a17e8040de0e363$var$__importStar = $7a17e8040de0e363$exports && $7a17e8040de0e363$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $7a17e8040de0e363$var$__createBinding(result, mod, k);
    }
    $7a17e8040de0e363$var$__setModuleDefault(result, mod);
    return result;
};
var $7a17e8040de0e363$var$__importDefault = $7a17e8040de0e363$exports && $7a17e8040de0e363$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($7a17e8040de0e363$exports, "__esModule", {
    value: true
});
$7a17e8040de0e363$exports.deserializeUnchecked = $7a17e8040de0e363$exports.deserialize = $7a17e8040de0e363$exports.serialize = $7a17e8040de0e363$exports.BinaryReader = $7a17e8040de0e363$exports.BinaryWriter = $7a17e8040de0e363$exports.BorshError = $7a17e8040de0e363$exports.baseDecode = $7a17e8040de0e363$exports.baseEncode = void 0;

const $7a17e8040de0e363$var$bn_js_1 = $7a17e8040de0e363$var$__importDefault((parcelRequire("lONYJ")));

const $7a17e8040de0e363$var$bs58_1 = $7a17e8040de0e363$var$__importDefault((parcelRequire("8qB41")));

// TODO: Make sure this polyfill not included when not required
const $7a17e8040de0e363$var$encoding = $7a17e8040de0e363$var$__importStar((parcelRequire("5SUiI")));
const $7a17e8040de0e363$var$ResolvedTextDecoder = typeof TextDecoder !== "function" ? $7a17e8040de0e363$var$encoding.TextDecoder : TextDecoder;
const $7a17e8040de0e363$var$textDecoder = new $7a17e8040de0e363$var$ResolvedTextDecoder("utf-8", {
    fatal: true
});
function $7a17e8040de0e363$var$baseEncode(value) {
    if (typeof value === "string") value = $7a17e8040de0e363$require$Buffer.from(value, "utf8");
    return $7a17e8040de0e363$var$bs58_1.default.encode($7a17e8040de0e363$require$Buffer.from(value));
}
$7a17e8040de0e363$exports.baseEncode = $7a17e8040de0e363$var$baseEncode;
function $7a17e8040de0e363$var$baseDecode(value) {
    return $7a17e8040de0e363$require$Buffer.from($7a17e8040de0e363$var$bs58_1.default.decode(value));
}
$7a17e8040de0e363$exports.baseDecode = $7a17e8040de0e363$var$baseDecode;
const $7a17e8040de0e363$var$INITIAL_LENGTH = 1024;
class $7a17e8040de0e363$var$BorshError extends Error {
    constructor(message){
        super(message);
        this.fieldPath = [];
        this.originalMessage = message;
    }
    addToFieldPath(fieldName) {
        this.fieldPath.splice(0, 0, fieldName);
        // NOTE: Modifying message directly as jest doesn't use .toString()
        this.message = this.originalMessage + ": " + this.fieldPath.join(".");
    }
}
$7a17e8040de0e363$exports.BorshError = $7a17e8040de0e363$var$BorshError;
/// Binary encoder.
class $7a17e8040de0e363$var$BinaryWriter {
    constructor(){
        this.buf = $7a17e8040de0e363$require$Buffer.alloc($7a17e8040de0e363$var$INITIAL_LENGTH);
        this.length = 0;
    }
    maybeResize() {
        if (this.buf.length < 16 + this.length) this.buf = $7a17e8040de0e363$require$Buffer.concat([
            this.buf,
            $7a17e8040de0e363$require$Buffer.alloc($7a17e8040de0e363$var$INITIAL_LENGTH)
        ]);
    }
    writeU8(value) {
        this.maybeResize();
        this.buf.writeUInt8(value, this.length);
        this.length += 1;
    }
    writeU16(value) {
        this.maybeResize();
        this.buf.writeUInt16LE(value, this.length);
        this.length += 2;
    }
    writeU32(value) {
        this.maybeResize();
        this.buf.writeUInt32LE(value, this.length);
        this.length += 4;
    }
    writeU64(value) {
        this.maybeResize();
        this.writeBuffer($7a17e8040de0e363$require$Buffer.from(new $7a17e8040de0e363$var$bn_js_1.default(value).toArray("le", 8)));
    }
    writeU128(value) {
        this.maybeResize();
        this.writeBuffer($7a17e8040de0e363$require$Buffer.from(new $7a17e8040de0e363$var$bn_js_1.default(value).toArray("le", 16)));
    }
    writeU256(value) {
        this.maybeResize();
        this.writeBuffer($7a17e8040de0e363$require$Buffer.from(new $7a17e8040de0e363$var$bn_js_1.default(value).toArray("le", 32)));
    }
    writeU512(value) {
        this.maybeResize();
        this.writeBuffer($7a17e8040de0e363$require$Buffer.from(new $7a17e8040de0e363$var$bn_js_1.default(value).toArray("le", 64)));
    }
    writeBuffer(buffer) {
        // Buffer.from is needed as this.buf.subarray can return plain Uint8Array in browser
        this.buf = $7a17e8040de0e363$require$Buffer.concat([
            $7a17e8040de0e363$require$Buffer.from(this.buf.subarray(0, this.length)),
            buffer,
            $7a17e8040de0e363$require$Buffer.alloc($7a17e8040de0e363$var$INITIAL_LENGTH)
        ]);
        this.length += buffer.length;
    }
    writeString(str) {
        this.maybeResize();
        const b = $7a17e8040de0e363$require$Buffer.from(str, "utf8");
        this.writeU32(b.length);
        this.writeBuffer(b);
    }
    writeFixedArray(array) {
        this.writeBuffer($7a17e8040de0e363$require$Buffer.from(array));
    }
    writeArray(array, fn) {
        this.maybeResize();
        this.writeU32(array.length);
        for (const elem of array){
            this.maybeResize();
            fn(elem);
        }
    }
    toArray() {
        return this.buf.subarray(0, this.length);
    }
}
$7a17e8040de0e363$exports.BinaryWriter = $7a17e8040de0e363$var$BinaryWriter;
function $7a17e8040de0e363$var$handlingRangeError(target, propertyKey, propertyDescriptor) {
    const originalMethod = propertyDescriptor.value;
    propertyDescriptor.value = function(...args) {
        try {
            return originalMethod.apply(this, args);
        } catch (e) {
            if (e instanceof RangeError) {
                const code = e.code;
                if ([
                    "ERR_BUFFER_OUT_OF_BOUNDS",
                    "ERR_OUT_OF_RANGE"
                ].indexOf(code) >= 0) throw new $7a17e8040de0e363$var$BorshError("Reached the end of buffer when deserializing");
            }
            throw e;
        }
    };
}
class $7a17e8040de0e363$var$BinaryReader {
    constructor(buf){
        this.buf = buf;
        this.offset = 0;
    }
    readU8() {
        const value = this.buf.readUInt8(this.offset);
        this.offset += 1;
        return value;
    }
    readU16() {
        const value = this.buf.readUInt16LE(this.offset);
        this.offset += 2;
        return value;
    }
    readU32() {
        const value = this.buf.readUInt32LE(this.offset);
        this.offset += 4;
        return value;
    }
    readU64() {
        const buf = this.readBuffer(8);
        return new $7a17e8040de0e363$var$bn_js_1.default(buf, "le");
    }
    readU128() {
        const buf = this.readBuffer(16);
        return new $7a17e8040de0e363$var$bn_js_1.default(buf, "le");
    }
    readU256() {
        const buf = this.readBuffer(32);
        return new $7a17e8040de0e363$var$bn_js_1.default(buf, "le");
    }
    readU512() {
        const buf = this.readBuffer(64);
        return new $7a17e8040de0e363$var$bn_js_1.default(buf, "le");
    }
    readBuffer(len) {
        if (this.offset + len > this.buf.length) throw new $7a17e8040de0e363$var$BorshError(`Expected buffer length ${len} isn't within bounds`);
        const result = this.buf.slice(this.offset, this.offset + len);
        this.offset += len;
        return result;
    }
    readString() {
        const len = this.readU32();
        const buf = this.readBuffer(len);
        try {
            // NOTE: Using TextDecoder to fail on invalid UTF-8
            return $7a17e8040de0e363$var$textDecoder.decode(buf);
        } catch (e) {
            throw new $7a17e8040de0e363$var$BorshError(`Error decoding UTF-8 string: ${e}`);
        }
    }
    readFixedArray(len) {
        return new Uint8Array(this.readBuffer(len));
    }
    readArray(fn) {
        const len = this.readU32();
        const result = Array();
        for(let i = 0; i < len; ++i)result.push(fn());
        return result;
    }
}
$7a17e8040de0e363$var$__decorate([
    $7a17e8040de0e363$var$handlingRangeError
], $7a17e8040de0e363$var$BinaryReader.prototype, "readU8", null);
$7a17e8040de0e363$var$__decorate([
    $7a17e8040de0e363$var$handlingRangeError
], $7a17e8040de0e363$var$BinaryReader.prototype, "readU16", null);
$7a17e8040de0e363$var$__decorate([
    $7a17e8040de0e363$var$handlingRangeError
], $7a17e8040de0e363$var$BinaryReader.prototype, "readU32", null);
$7a17e8040de0e363$var$__decorate([
    $7a17e8040de0e363$var$handlingRangeError
], $7a17e8040de0e363$var$BinaryReader.prototype, "readU64", null);
$7a17e8040de0e363$var$__decorate([
    $7a17e8040de0e363$var$handlingRangeError
], $7a17e8040de0e363$var$BinaryReader.prototype, "readU128", null);
$7a17e8040de0e363$var$__decorate([
    $7a17e8040de0e363$var$handlingRangeError
], $7a17e8040de0e363$var$BinaryReader.prototype, "readU256", null);
$7a17e8040de0e363$var$__decorate([
    $7a17e8040de0e363$var$handlingRangeError
], $7a17e8040de0e363$var$BinaryReader.prototype, "readU512", null);
$7a17e8040de0e363$var$__decorate([
    $7a17e8040de0e363$var$handlingRangeError
], $7a17e8040de0e363$var$BinaryReader.prototype, "readString", null);
$7a17e8040de0e363$var$__decorate([
    $7a17e8040de0e363$var$handlingRangeError
], $7a17e8040de0e363$var$BinaryReader.prototype, "readFixedArray", null);
$7a17e8040de0e363$var$__decorate([
    $7a17e8040de0e363$var$handlingRangeError
], $7a17e8040de0e363$var$BinaryReader.prototype, "readArray", null);
$7a17e8040de0e363$exports.BinaryReader = $7a17e8040de0e363$var$BinaryReader;
function $7a17e8040de0e363$var$capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
function $7a17e8040de0e363$var$serializeField(schema, fieldName, value, fieldType, writer) {
    try {
        // TODO: Handle missing values properly (make sure they never result in just skipped write)
        if (typeof fieldType === "string") writer[`write${$7a17e8040de0e363$var$capitalizeFirstLetter(fieldType)}`](value);
        else if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") {
                if (value.length !== fieldType[0]) throw new $7a17e8040de0e363$var$BorshError(`Expecting byte array of length ${fieldType[0]}, but got ${value.length} bytes`);
                writer.writeFixedArray(value);
            } else if (fieldType.length === 2 && typeof fieldType[1] === "number") {
                if (value.length !== fieldType[1]) throw new $7a17e8040de0e363$var$BorshError(`Expecting byte array of length ${fieldType[1]}, but got ${value.length} bytes`);
                for(let i = 0; i < fieldType[1]; i++)$7a17e8040de0e363$var$serializeField(schema, null, value[i], fieldType[0], writer);
            } else writer.writeArray(value, (item)=>{
                $7a17e8040de0e363$var$serializeField(schema, fieldName, item, fieldType[0], writer);
            });
        } else if (fieldType.kind !== undefined) switch(fieldType.kind){
            case "option":
                if (value === null || value === undefined) writer.writeU8(0);
                else {
                    writer.writeU8(1);
                    $7a17e8040de0e363$var$serializeField(schema, fieldName, value, fieldType.type, writer);
                }
                break;
            case "map":
                writer.writeU32(value.size);
                value.forEach((val, key)=>{
                    $7a17e8040de0e363$var$serializeField(schema, fieldName, key, fieldType.key, writer);
                    $7a17e8040de0e363$var$serializeField(schema, fieldName, val, fieldType.value, writer);
                });
                break;
            default:
                throw new $7a17e8040de0e363$var$BorshError(`FieldType ${fieldType} unrecognized`);
        }
        else $7a17e8040de0e363$var$serializeStruct(schema, value, writer);
    } catch (error) {
        if (error instanceof $7a17e8040de0e363$var$BorshError) error.addToFieldPath(fieldName);
        throw error;
    }
}
function $7a17e8040de0e363$var$serializeStruct(schema, obj, writer) {
    if (typeof obj.borshSerialize === "function") {
        obj.borshSerialize(writer);
        return;
    }
    const structSchema = schema.get(obj.constructor);
    if (!structSchema) throw new $7a17e8040de0e363$var$BorshError(`Class ${obj.constructor.name} is missing in schema`);
    if (structSchema.kind === "struct") structSchema.fields.map(([fieldName, fieldType])=>{
        $7a17e8040de0e363$var$serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
    });
    else if (structSchema.kind === "enum") {
        const name = obj[structSchema.field];
        for(let idx = 0; idx < structSchema.values.length; ++idx){
            const [fieldName, fieldType] = structSchema.values[idx];
            if (fieldName === name) {
                writer.writeU8(idx);
                $7a17e8040de0e363$var$serializeField(schema, fieldName, obj[fieldName], fieldType, writer);
                break;
            }
        }
    } else throw new $7a17e8040de0e363$var$BorshError(`Unexpected schema kind: ${structSchema.kind} for ${obj.constructor.name}`);
}
/// Serialize given object using schema of the form:
/// { class_name -> [ [field_name, field_type], .. ], .. }
function $7a17e8040de0e363$var$serialize(schema, obj, Writer = $7a17e8040de0e363$var$BinaryWriter) {
    const writer = new Writer();
    $7a17e8040de0e363$var$serializeStruct(schema, obj, writer);
    return writer.toArray();
}
$7a17e8040de0e363$exports.serialize = $7a17e8040de0e363$var$serialize;
function $7a17e8040de0e363$var$deserializeField(schema, fieldName, fieldType, reader) {
    try {
        if (typeof fieldType === "string") return reader[`read${$7a17e8040de0e363$var$capitalizeFirstLetter(fieldType)}`]();
        if (fieldType instanceof Array) {
            if (typeof fieldType[0] === "number") return reader.readFixedArray(fieldType[0]);
            else if (typeof fieldType[1] === "number") {
                const arr = [];
                for(let i = 0; i < fieldType[1]; i++)arr.push($7a17e8040de0e363$var$deserializeField(schema, null, fieldType[0], reader));
                return arr;
            } else return reader.readArray(()=>$7a17e8040de0e363$var$deserializeField(schema, fieldName, fieldType[0], reader));
        }
        if (fieldType.kind === "option") {
            const option = reader.readU8();
            if (option) return $7a17e8040de0e363$var$deserializeField(schema, fieldName, fieldType.type, reader);
            return undefined;
        }
        if (fieldType.kind === "map") {
            let map = new Map();
            const length = reader.readU32();
            for(let i = 0; i < length; i++){
                const key = $7a17e8040de0e363$var$deserializeField(schema, fieldName, fieldType.key, reader);
                const val = $7a17e8040de0e363$var$deserializeField(schema, fieldName, fieldType.value, reader);
                map.set(key, val);
            }
            return map;
        }
        return $7a17e8040de0e363$var$deserializeStruct(schema, fieldType, reader);
    } catch (error) {
        if (error instanceof $7a17e8040de0e363$var$BorshError) error.addToFieldPath(fieldName);
        throw error;
    }
}
function $7a17e8040de0e363$var$deserializeStruct(schema, classType, reader) {
    if (typeof classType.borshDeserialize === "function") return classType.borshDeserialize(reader);
    const structSchema = schema.get(classType);
    if (!structSchema) throw new $7a17e8040de0e363$var$BorshError(`Class ${classType.name} is missing in schema`);
    if (structSchema.kind === "struct") {
        const result = {};
        for (const [fieldName, fieldType] of schema.get(classType).fields)result[fieldName] = $7a17e8040de0e363$var$deserializeField(schema, fieldName, fieldType, reader);
        return new classType(result);
    }
    if (structSchema.kind === "enum") {
        const idx = reader.readU8();
        if (idx >= structSchema.values.length) throw new $7a17e8040de0e363$var$BorshError(`Enum index: ${idx} is out of range`);
        const [fieldName, fieldType] = structSchema.values[idx];
        const fieldValue = $7a17e8040de0e363$var$deserializeField(schema, fieldName, fieldType, reader);
        return new classType({
            [fieldName]: fieldValue
        });
    }
    throw new $7a17e8040de0e363$var$BorshError(`Unexpected schema kind: ${structSchema.kind} for ${classType.constructor.name}`);
}
/// Deserializes object from bytes using schema.
function $7a17e8040de0e363$var$deserialize(schema, classType, buffer, Reader = $7a17e8040de0e363$var$BinaryReader) {
    const reader = new Reader(buffer);
    const result = $7a17e8040de0e363$var$deserializeStruct(schema, classType, reader);
    if (reader.offset < buffer.length) throw new $7a17e8040de0e363$var$BorshError(`Unexpected ${buffer.length - reader.offset} bytes after deserialized data`);
    return result;
}
$7a17e8040de0e363$exports.deserialize = $7a17e8040de0e363$var$deserialize;
/// Deserializes object from bytes using schema, without checking the length read
function $7a17e8040de0e363$var$deserializeUnchecked(schema, classType, buffer, Reader = $7a17e8040de0e363$var$BinaryReader) {
    const reader = new Reader(buffer);
    return $7a17e8040de0e363$var$deserializeStruct(schema, classType, reader);
}
$7a17e8040de0e363$exports.deserializeUnchecked = $7a17e8040de0e363$var$deserializeUnchecked;


var $ab8b5713b1ee9109$exports = {};
/* The MIT License (MIT)
 *
 * Copyright 2015-2018 Peter A. Bigot
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ /**
 * Support for translating between Uint8Array instances and JavaScript
 * native types.
 *
 * {@link module:Layout~Layout|Layout} is the basis of a class
 * hierarchy that associates property names with sequences of encoded
 * bytes.
 *
 * Layouts are supported for these scalar (numeric) types:
 * * {@link module:Layout~UInt|Unsigned integers in little-endian
 *   format} with {@link module:Layout.u8|8-bit}, {@link
 *   module:Layout.u16|16-bit}, {@link module:Layout.u24|24-bit},
 *   {@link module:Layout.u32|32-bit}, {@link
 *   module:Layout.u40|40-bit}, and {@link module:Layout.u48|48-bit}
 *   representation ranges;
 * * {@link module:Layout~UIntBE|Unsigned integers in big-endian
 *   format} with {@link module:Layout.u16be|16-bit}, {@link
 *   module:Layout.u24be|24-bit}, {@link module:Layout.u32be|32-bit},
 *   {@link module:Layout.u40be|40-bit}, and {@link
 *   module:Layout.u48be|48-bit} representation ranges;
 * * {@link module:Layout~Int|Signed integers in little-endian
 *   format} with {@link module:Layout.s8|8-bit}, {@link
 *   module:Layout.s16|16-bit}, {@link module:Layout.s24|24-bit},
 *   {@link module:Layout.s32|32-bit}, {@link
 *   module:Layout.s40|40-bit}, and {@link module:Layout.s48|48-bit}
 *   representation ranges;
 * * {@link module:Layout~IntBE|Signed integers in big-endian format}
 *   with {@link module:Layout.s16be|16-bit}, {@link
 *   module:Layout.s24be|24-bit}, {@link module:Layout.s32be|32-bit},
 *   {@link module:Layout.s40be|40-bit}, and {@link
 *   module:Layout.s48be|48-bit} representation ranges;
 * * 64-bit integral values that decode to an exact (if magnitude is
 *   less than 2^53) or nearby integral Number in {@link
 *   module:Layout.nu64|unsigned little-endian}, {@link
 *   module:Layout.nu64be|unsigned big-endian}, {@link
 *   module:Layout.ns64|signed little-endian}, and {@link
 *   module:Layout.ns64be|unsigned big-endian} encodings;
 * * 32-bit floating point values with {@link
 *   module:Layout.f32|little-endian} and {@link
 *   module:Layout.f32be|big-endian} representations;
 * * 64-bit floating point values with {@link
 *   module:Layout.f64|little-endian} and {@link
 *   module:Layout.f64be|big-endian} representations;
 * * {@link module:Layout.const|Constants} that take no space in the
 *   encoded expression.
 *
 * and for these aggregate types:
 * * {@link module:Layout.seq|Sequence}s of instances of a {@link
 *   module:Layout~Layout|Layout}, with JavaScript representation as
 *   an Array and constant or data-dependent {@link
 *   module:Layout~Sequence#count|length};
 * * {@link module:Layout.struct|Structure}s that aggregate a
 *   heterogeneous sequence of {@link module:Layout~Layout|Layout}
 *   instances, with JavaScript representation as an Object;
 * * {@link module:Layout.union|Union}s that support multiple {@link
 *   module:Layout~VariantLayout|variant layouts} over a fixed
 *   (padded) or variable (not padded) span of bytes, using an
 *   unsigned integer at the start of the data or a separate {@link
 *   module:Layout.unionLayoutDiscriminator|layout element} to
 *   determine which layout to use when interpreting the buffer
 *   contents;
 * * {@link module:Layout.bits|BitStructure}s that contain a sequence
 *   of individual {@link
 *   module:Layout~BitStructure#addField|BitField}s packed into an 8,
 *   16, 24, or 32-bit unsigned integer starting at the least- or
 *   most-significant bit;
 * * {@link module:Layout.cstr|C strings} of varying length;
 * * {@link module:Layout.blob|Blobs} of fixed- or variable-{@link
 *   module:Layout~Blob#length|length} raw data.
 *
 * All {@link module:Layout~Layout|Layout} instances are immutable
 * after construction, to prevent internal state from becoming
 * inconsistent.
 *
 * @local Layout
 * @local ExternalLayout
 * @local GreedyCount
 * @local OffsetLayout
 * @local UInt
 * @local UIntBE
 * @local Int
 * @local IntBE
 * @local NearUInt64
 * @local NearUInt64BE
 * @local NearInt64
 * @local NearInt64BE
 * @local Float
 * @local FloatBE
 * @local Double
 * @local DoubleBE
 * @local Sequence
 * @local Structure
 * @local UnionDiscriminator
 * @local UnionLayoutDiscriminator
 * @local Union
 * @local VariantLayout
 * @local BitStructure
 * @local BitField
 * @local Boolean
 * @local Blob
 * @local CString
 * @local Constant
 * @local bindConstructorLayout
 * @module Layout
 * @license MIT
 * @author Peter A. Bigot
 * @see {@link https://github.com/pabigot/buffer-layout|buffer-layout on GitHub}
 */ "use strict";
Object.defineProperty($ab8b5713b1ee9109$exports, "__esModule", {
    value: true
});
$ab8b5713b1ee9109$exports.s16 = $ab8b5713b1ee9109$exports.s8 = $ab8b5713b1ee9109$exports.nu64be = $ab8b5713b1ee9109$exports.u48be = $ab8b5713b1ee9109$exports.u40be = $ab8b5713b1ee9109$exports.u32be = $ab8b5713b1ee9109$exports.u24be = $ab8b5713b1ee9109$exports.u16be = $ab8b5713b1ee9109$exports.nu64 = $ab8b5713b1ee9109$exports.u48 = $ab8b5713b1ee9109$exports.u40 = $ab8b5713b1ee9109$exports.u32 = $ab8b5713b1ee9109$exports.u24 = $ab8b5713b1ee9109$exports.u16 = $ab8b5713b1ee9109$exports.u8 = $ab8b5713b1ee9109$exports.offset = $ab8b5713b1ee9109$exports.greedy = $ab8b5713b1ee9109$exports.Constant = $ab8b5713b1ee9109$exports.UTF8 = $ab8b5713b1ee9109$exports.CString = $ab8b5713b1ee9109$exports.Blob = $ab8b5713b1ee9109$exports.Boolean = $ab8b5713b1ee9109$exports.BitField = $ab8b5713b1ee9109$exports.BitStructure = $ab8b5713b1ee9109$exports.VariantLayout = $ab8b5713b1ee9109$exports.Union = $ab8b5713b1ee9109$exports.UnionLayoutDiscriminator = $ab8b5713b1ee9109$exports.UnionDiscriminator = $ab8b5713b1ee9109$exports.Structure = $ab8b5713b1ee9109$exports.Sequence = $ab8b5713b1ee9109$exports.DoubleBE = $ab8b5713b1ee9109$exports.Double = $ab8b5713b1ee9109$exports.FloatBE = $ab8b5713b1ee9109$exports.Float = $ab8b5713b1ee9109$exports.NearInt64BE = $ab8b5713b1ee9109$exports.NearInt64 = $ab8b5713b1ee9109$exports.NearUInt64BE = $ab8b5713b1ee9109$exports.NearUInt64 = $ab8b5713b1ee9109$exports.IntBE = $ab8b5713b1ee9109$exports.Int = $ab8b5713b1ee9109$exports.UIntBE = $ab8b5713b1ee9109$exports.UInt = $ab8b5713b1ee9109$exports.OffsetLayout = $ab8b5713b1ee9109$exports.GreedyCount = $ab8b5713b1ee9109$exports.ExternalLayout = $ab8b5713b1ee9109$exports.bindConstructorLayout = $ab8b5713b1ee9109$exports.nameWithProperty = $ab8b5713b1ee9109$exports.Layout = $ab8b5713b1ee9109$exports.uint8ArrayToBuffer = $ab8b5713b1ee9109$exports.checkUint8Array = void 0;
$ab8b5713b1ee9109$exports.constant = $ab8b5713b1ee9109$exports.utf8 = $ab8b5713b1ee9109$exports.cstr = $ab8b5713b1ee9109$exports.blob = $ab8b5713b1ee9109$exports.unionLayoutDiscriminator = $ab8b5713b1ee9109$exports.union = $ab8b5713b1ee9109$exports.seq = $ab8b5713b1ee9109$exports.bits = $ab8b5713b1ee9109$exports.struct = $ab8b5713b1ee9109$exports.f64be = $ab8b5713b1ee9109$exports.f64 = $ab8b5713b1ee9109$exports.f32be = $ab8b5713b1ee9109$exports.f32 = $ab8b5713b1ee9109$exports.ns64be = $ab8b5713b1ee9109$exports.s48be = $ab8b5713b1ee9109$exports.s40be = $ab8b5713b1ee9109$exports.s32be = $ab8b5713b1ee9109$exports.s24be = $ab8b5713b1ee9109$exports.s16be = $ab8b5713b1ee9109$exports.ns64 = $ab8b5713b1ee9109$exports.s48 = $ab8b5713b1ee9109$exports.s40 = $ab8b5713b1ee9109$exports.s32 = $ab8b5713b1ee9109$exports.s24 = void 0;
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $9891c961abffc7d1$export$a143d493d941bafc;
var $9891c961abffc7d1$export$e4cf37d7f6fb9e0a;
var $9891c961abffc7d1$export$f99ded8fe4b79145;
var $9891c961abffc7d1$export$599f31c3813fae4d;
"use strict";

var $bQMRt = parcelRequire("bQMRt");

var $dbnIE = parcelRequire("dbnIE");
const $9891c961abffc7d1$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$9891c961abffc7d1$export$a143d493d941bafc = $9891c961abffc7d1$var$Buffer;
$9891c961abffc7d1$export$e4cf37d7f6fb9e0a = $9891c961abffc7d1$var$SlowBuffer;
$9891c961abffc7d1$export$f99ded8fe4b79145 = 50;
const $9891c961abffc7d1$var$K_MAX_LENGTH = 0x7fffffff;
$9891c961abffc7d1$export$599f31c3813fae4d = $9891c961abffc7d1$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $9891c961abffc7d1$var$Buffer.TYPED_ARRAY_SUPPORT = $9891c961abffc7d1$var$typedArraySupport();
if (!$9891c961abffc7d1$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $9891c961abffc7d1$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($9891c961abffc7d1$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$9891c961abffc7d1$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($9891c961abffc7d1$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$9891c961abffc7d1$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $9891c961abffc7d1$var$createBuffer(length) {
    if (length > $9891c961abffc7d1$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $9891c961abffc7d1$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $9891c961abffc7d1$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $9891c961abffc7d1$var$allocUnsafe(arg);
    }
    return $9891c961abffc7d1$var$from(arg, encodingOrOffset, length);
}
$9891c961abffc7d1$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $9891c961abffc7d1$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $9891c961abffc7d1$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $9891c961abffc7d1$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($9891c961abffc7d1$var$isInstance(value, ArrayBuffer) || value && $9891c961abffc7d1$var$isInstance(value.buffer, ArrayBuffer)) return $9891c961abffc7d1$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($9891c961abffc7d1$var$isInstance(value, SharedArrayBuffer) || value && $9891c961abffc7d1$var$isInstance(value.buffer, SharedArrayBuffer))) return $9891c961abffc7d1$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $9891c961abffc7d1$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $9891c961abffc7d1$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $9891c961abffc7d1$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $9891c961abffc7d1$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $9891c961abffc7d1$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($9891c961abffc7d1$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($9891c961abffc7d1$var$Buffer, Uint8Array);
function $9891c961abffc7d1$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $9891c961abffc7d1$var$alloc(size, fill, encoding) {
    $9891c961abffc7d1$var$assertSize(size);
    if (size <= 0) return $9891c961abffc7d1$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $9891c961abffc7d1$var$createBuffer(size).fill(fill, encoding) : $9891c961abffc7d1$var$createBuffer(size).fill(fill);
    return $9891c961abffc7d1$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $9891c961abffc7d1$var$Buffer.alloc = function(size, fill, encoding) {
    return $9891c961abffc7d1$var$alloc(size, fill, encoding);
};
function $9891c961abffc7d1$var$allocUnsafe(size) {
    $9891c961abffc7d1$var$assertSize(size);
    return $9891c961abffc7d1$var$createBuffer(size < 0 ? 0 : $9891c961abffc7d1$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $9891c961abffc7d1$var$Buffer.allocUnsafe = function(size) {
    return $9891c961abffc7d1$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $9891c961abffc7d1$var$Buffer.allocUnsafeSlow = function(size) {
    return $9891c961abffc7d1$var$allocUnsafe(size);
};
function $9891c961abffc7d1$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$9891c961abffc7d1$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $9891c961abffc7d1$var$byteLength(string, encoding) | 0;
    let buf = $9891c961abffc7d1$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $9891c961abffc7d1$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $9891c961abffc7d1$var$checked(array.length) | 0;
    const buf = $9891c961abffc7d1$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $9891c961abffc7d1$var$fromArrayView(arrayView) {
    if ($9891c961abffc7d1$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $9891c961abffc7d1$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $9891c961abffc7d1$var$fromArrayLike(arrayView);
}
function $9891c961abffc7d1$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $9891c961abffc7d1$var$Buffer.prototype);
    return buf;
}
function $9891c961abffc7d1$var$fromObject(obj) {
    if ($9891c961abffc7d1$var$Buffer.isBuffer(obj)) {
        const len = $9891c961abffc7d1$var$checked(obj.length) | 0;
        const buf = $9891c961abffc7d1$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $9891c961abffc7d1$var$numberIsNaN(obj.length)) return $9891c961abffc7d1$var$createBuffer(0);
        return $9891c961abffc7d1$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $9891c961abffc7d1$var$fromArrayLike(obj.data);
}
function $9891c961abffc7d1$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $9891c961abffc7d1$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $9891c961abffc7d1$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $9891c961abffc7d1$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $9891c961abffc7d1$var$Buffer.alloc(+length);
}
$9891c961abffc7d1$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $9891c961abffc7d1$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$9891c961abffc7d1$var$Buffer.compare = function compare(a, b) {
    if ($9891c961abffc7d1$var$isInstance(a, Uint8Array)) a = $9891c961abffc7d1$var$Buffer.from(a, a.offset, a.byteLength);
    if ($9891c961abffc7d1$var$isInstance(b, Uint8Array)) b = $9891c961abffc7d1$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$9891c961abffc7d1$var$Buffer.isBuffer(a) || !$9891c961abffc7d1$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$9891c961abffc7d1$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$9891c961abffc7d1$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $9891c961abffc7d1$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $9891c961abffc7d1$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($9891c961abffc7d1$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$9891c961abffc7d1$var$Buffer.isBuffer(buf)) buf = $9891c961abffc7d1$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$9891c961abffc7d1$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $9891c961abffc7d1$var$byteLength(string, encoding) {
    if ($9891c961abffc7d1$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $9891c961abffc7d1$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $9891c961abffc7d1$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $9891c961abffc7d1$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $9891c961abffc7d1$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$9891c961abffc7d1$var$Buffer.byteLength = $9891c961abffc7d1$var$byteLength;
function $9891c961abffc7d1$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $9891c961abffc7d1$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $9891c961abffc7d1$var$utf8Slice(this, start, end);
        case "ascii":
            return $9891c961abffc7d1$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $9891c961abffc7d1$var$latin1Slice(this, start, end);
        case "base64":
            return $9891c961abffc7d1$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $9891c961abffc7d1$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$9891c961abffc7d1$var$Buffer.prototype._isBuffer = true;
function $9891c961abffc7d1$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$9891c961abffc7d1$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$9891c961abffc7d1$var$swap(this, i, i + 1);
    return this;
};
$9891c961abffc7d1$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $9891c961abffc7d1$var$swap(this, i, i + 3);
        $9891c961abffc7d1$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$9891c961abffc7d1$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $9891c961abffc7d1$var$swap(this, i, i + 7);
        $9891c961abffc7d1$var$swap(this, i + 1, i + 6);
        $9891c961abffc7d1$var$swap(this, i + 2, i + 5);
        $9891c961abffc7d1$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$9891c961abffc7d1$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $9891c961abffc7d1$var$utf8Slice(this, 0, length);
    return $9891c961abffc7d1$var$slowToString.apply(this, arguments);
};
$9891c961abffc7d1$var$Buffer.prototype.toLocaleString = $9891c961abffc7d1$var$Buffer.prototype.toString;
$9891c961abffc7d1$var$Buffer.prototype.equals = function equals(b) {
    if (!$9891c961abffc7d1$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $9891c961abffc7d1$var$Buffer.compare(this, b) === 0;
};
$9891c961abffc7d1$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $9891c961abffc7d1$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($9891c961abffc7d1$var$customInspectSymbol) $9891c961abffc7d1$var$Buffer.prototype[$9891c961abffc7d1$var$customInspectSymbol] = $9891c961abffc7d1$var$Buffer.prototype.inspect;
$9891c961abffc7d1$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($9891c961abffc7d1$var$isInstance(target, Uint8Array)) target = $9891c961abffc7d1$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$9891c961abffc7d1$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $9891c961abffc7d1$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($9891c961abffc7d1$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $9891c961abffc7d1$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($9891c961abffc7d1$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $9891c961abffc7d1$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $9891c961abffc7d1$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $9891c961abffc7d1$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$9891c961abffc7d1$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$9891c961abffc7d1$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $9891c961abffc7d1$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$9891c961abffc7d1$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $9891c961abffc7d1$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $9891c961abffc7d1$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($9891c961abffc7d1$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $9891c961abffc7d1$var$utf8Write(buf, string, offset, length) {
    return $9891c961abffc7d1$var$blitBuffer($9891c961abffc7d1$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $9891c961abffc7d1$var$asciiWrite(buf, string, offset, length) {
    return $9891c961abffc7d1$var$blitBuffer($9891c961abffc7d1$var$asciiToBytes(string), buf, offset, length);
}
function $9891c961abffc7d1$var$base64Write(buf, string, offset, length) {
    return $9891c961abffc7d1$var$blitBuffer($9891c961abffc7d1$var$base64ToBytes(string), buf, offset, length);
}
function $9891c961abffc7d1$var$ucs2Write(buf, string, offset, length) {
    return $9891c961abffc7d1$var$blitBuffer($9891c961abffc7d1$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$9891c961abffc7d1$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $9891c961abffc7d1$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $9891c961abffc7d1$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $9891c961abffc7d1$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $9891c961abffc7d1$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $9891c961abffc7d1$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$9891c961abffc7d1$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $9891c961abffc7d1$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $bQMRt.fromByteArray(buf);
    else return $bQMRt.fromByteArray(buf.slice(start, end));
}
function $9891c961abffc7d1$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $9891c961abffc7d1$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $9891c961abffc7d1$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $9891c961abffc7d1$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $9891c961abffc7d1$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $9891c961abffc7d1$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $9891c961abffc7d1$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $9891c961abffc7d1$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $9891c961abffc7d1$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $9891c961abffc7d1$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $9891c961abffc7d1$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$9891c961abffc7d1$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $9891c961abffc7d1$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $9891c961abffc7d1$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$9891c961abffc7d1$var$Buffer.prototype.readUintLE = $9891c961abffc7d1$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $9891c961abffc7d1$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$9891c961abffc7d1$var$Buffer.prototype.readUintBE = $9891c961abffc7d1$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $9891c961abffc7d1$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$9891c961abffc7d1$var$Buffer.prototype.readUint8 = $9891c961abffc7d1$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9891c961abffc7d1$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$9891c961abffc7d1$var$Buffer.prototype.readUint16LE = $9891c961abffc7d1$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9891c961abffc7d1$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$9891c961abffc7d1$var$Buffer.prototype.readUint16BE = $9891c961abffc7d1$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9891c961abffc7d1$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$9891c961abffc7d1$var$Buffer.prototype.readUint32LE = $9891c961abffc7d1$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9891c961abffc7d1$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$9891c961abffc7d1$var$Buffer.prototype.readUint32BE = $9891c961abffc7d1$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9891c961abffc7d1$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$9891c961abffc7d1$var$Buffer.prototype.readBigUInt64LE = $9891c961abffc7d1$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $9891c961abffc7d1$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $9891c961abffc7d1$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$9891c961abffc7d1$var$Buffer.prototype.readBigUInt64BE = $9891c961abffc7d1$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $9891c961abffc7d1$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $9891c961abffc7d1$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$9891c961abffc7d1$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $9891c961abffc7d1$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$9891c961abffc7d1$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $9891c961abffc7d1$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$9891c961abffc7d1$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9891c961abffc7d1$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$9891c961abffc7d1$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9891c961abffc7d1$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$9891c961abffc7d1$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9891c961abffc7d1$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$9891c961abffc7d1$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9891c961abffc7d1$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$9891c961abffc7d1$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9891c961abffc7d1$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$9891c961abffc7d1$var$Buffer.prototype.readBigInt64LE = $9891c961abffc7d1$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $9891c961abffc7d1$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $9891c961abffc7d1$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$9891c961abffc7d1$var$Buffer.prototype.readBigInt64BE = $9891c961abffc7d1$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $9891c961abffc7d1$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $9891c961abffc7d1$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$9891c961abffc7d1$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9891c961abffc7d1$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, true, 23, 4);
};
$9891c961abffc7d1$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9891c961abffc7d1$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, false, 23, 4);
};
$9891c961abffc7d1$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9891c961abffc7d1$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, true, 52, 8);
};
$9891c961abffc7d1$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $9891c961abffc7d1$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, false, 52, 8);
};
function $9891c961abffc7d1$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$9891c961abffc7d1$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$9891c961abffc7d1$var$Buffer.prototype.writeUintLE = $9891c961abffc7d1$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $9891c961abffc7d1$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$9891c961abffc7d1$var$Buffer.prototype.writeUintBE = $9891c961abffc7d1$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $9891c961abffc7d1$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$9891c961abffc7d1$var$Buffer.prototype.writeUint8 = $9891c961abffc7d1$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9891c961abffc7d1$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$9891c961abffc7d1$var$Buffer.prototype.writeUint16LE = $9891c961abffc7d1$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9891c961abffc7d1$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$9891c961abffc7d1$var$Buffer.prototype.writeUint16BE = $9891c961abffc7d1$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9891c961abffc7d1$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$9891c961abffc7d1$var$Buffer.prototype.writeUint32LE = $9891c961abffc7d1$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9891c961abffc7d1$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$9891c961abffc7d1$var$Buffer.prototype.writeUint32BE = $9891c961abffc7d1$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9891c961abffc7d1$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $9891c961abffc7d1$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $9891c961abffc7d1$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $9891c961abffc7d1$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $9891c961abffc7d1$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$9891c961abffc7d1$var$Buffer.prototype.writeBigUInt64LE = $9891c961abffc7d1$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $9891c961abffc7d1$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$9891c961abffc7d1$var$Buffer.prototype.writeBigUInt64BE = $9891c961abffc7d1$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $9891c961abffc7d1$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$9891c961abffc7d1$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $9891c961abffc7d1$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$9891c961abffc7d1$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $9891c961abffc7d1$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$9891c961abffc7d1$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9891c961abffc7d1$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$9891c961abffc7d1$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9891c961abffc7d1$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$9891c961abffc7d1$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9891c961abffc7d1$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$9891c961abffc7d1$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9891c961abffc7d1$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$9891c961abffc7d1$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9891c961abffc7d1$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$9891c961abffc7d1$var$Buffer.prototype.writeBigInt64LE = $9891c961abffc7d1$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $9891c961abffc7d1$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$9891c961abffc7d1$var$Buffer.prototype.writeBigInt64BE = $9891c961abffc7d1$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $9891c961abffc7d1$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $9891c961abffc7d1$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $9891c961abffc7d1$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9891c961abffc7d1$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$9891c961abffc7d1$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $9891c961abffc7d1$var$writeFloat(this, value, offset, true, noAssert);
};
$9891c961abffc7d1$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $9891c961abffc7d1$var$writeFloat(this, value, offset, false, noAssert);
};
function $9891c961abffc7d1$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $9891c961abffc7d1$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$9891c961abffc7d1$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $9891c961abffc7d1$var$writeDouble(this, value, offset, true, noAssert);
};
$9891c961abffc7d1$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $9891c961abffc7d1$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$9891c961abffc7d1$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$9891c961abffc7d1$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$9891c961abffc7d1$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$9891c961abffc7d1$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $9891c961abffc7d1$var$Buffer.isBuffer(val) ? val : $9891c961abffc7d1$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $9891c961abffc7d1$var$errors = {};
function $9891c961abffc7d1$var$E(sym, getMessage, Base) {
    $9891c961abffc7d1$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$9891c961abffc7d1$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$9891c961abffc7d1$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$9891c961abffc7d1$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $9891c961abffc7d1$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $9891c961abffc7d1$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $9891c961abffc7d1$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $9891c961abffc7d1$var$checkBounds(buf, offset, byteLength) {
    $9891c961abffc7d1$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $9891c961abffc7d1$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $9891c961abffc7d1$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $9891c961abffc7d1$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $9891c961abffc7d1$var$checkBounds(buf, offset, byteLength);
}
function $9891c961abffc7d1$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $9891c961abffc7d1$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $9891c961abffc7d1$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $9891c961abffc7d1$var$validateNumber(value, type);
        throw new $9891c961abffc7d1$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $9891c961abffc7d1$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $9891c961abffc7d1$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $9891c961abffc7d1$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $9891c961abffc7d1$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($9891c961abffc7d1$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $9891c961abffc7d1$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $9891c961abffc7d1$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $9891c961abffc7d1$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $9891c961abffc7d1$var$base64ToBytes(str) {
    return $bQMRt.toByteArray($9891c961abffc7d1$var$base64clean(str));
}
function $9891c961abffc7d1$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $9891c961abffc7d1$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $9891c961abffc7d1$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $9891c961abffc7d1$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $9891c961abffc7d1$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $9891c961abffc7d1$var$BufferBigIntNotDefined : fn;
}
function $9891c961abffc7d1$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


/* Check if a value is a Uint8Array.
 *
 * @ignore */ function $ab8b5713b1ee9109$var$checkUint8Array(b) {
    if (!(b instanceof Uint8Array)) throw new TypeError("b must be a Uint8Array");
}
$ab8b5713b1ee9109$exports.checkUint8Array = $ab8b5713b1ee9109$var$checkUint8Array;
/* Create a Buffer instance from a Uint8Array.
 *
 * @ignore */ function $ab8b5713b1ee9109$var$uint8ArrayToBuffer(b) {
    $ab8b5713b1ee9109$var$checkUint8Array(b);
    return $9891c961abffc7d1$export$a143d493d941bafc.from(b.buffer, b.byteOffset, b.length);
}
$ab8b5713b1ee9109$exports.uint8ArrayToBuffer = $ab8b5713b1ee9109$var$uint8ArrayToBuffer;
/**
 * Base class for layout objects.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support the {@link
 * Layout#encode|encode} or {@link Layout#decode|decode} functions.
 *
 * @param {Number} span - Initializer for {@link Layout#span|span}.  The
 * parameter must be an integer; a negative value signifies that the
 * span is {@link Layout#getSpan|value-specific}.
 *
 * @param {string} [property] - Initializer for {@link
 * Layout#property|property}.
 *
 * @abstract
 */ class $ab8b5713b1ee9109$var$Layout {
    constructor(span, property){
        if (!Number.isInteger(span)) throw new TypeError("span must be an integer");
        /** The span of the layout in bytes.
         *
         * Positive values are generally expected.
         *
         * Zero will only appear in {@link Constant}s and in {@link
         * Sequence}s where the {@link Sequence#count|count} is zero.
         *
         * A negative value indicates that the span is value-specific, and
         * must be obtained using {@link Layout#getSpan|getSpan}. */ this.span = span;
        /** The property name used when this layout is represented in an
         * Object.
         *
         * Used only for layouts that {@link Layout#decode|decode} to Object
         * instances.  If left undefined the span of the unnamed layout will
         * be treated as padding: it will not be mutated by {@link
         * Layout#encode|encode} nor represented as a property in the
         * decoded Object. */ this.property = property;
    }
    /** Function to create an Object into which decoded properties will
     * be written.
     *
     * Used only for layouts that {@link Layout#decode|decode} to Object
     * instances, which means:
     * * {@link Structure}
     * * {@link Union}
     * * {@link VariantLayout}
     * * {@link BitStructure}
     *
     * If left undefined the JavaScript representation of these layouts
     * will be Object instances.
     *
     * See {@link bindConstructorLayout}.
     */ makeDestinationObject() {
        return {};
    }
    /**
     * Calculate the span of a specific instance of a layout.
     *
     * @param {Uint8Array} b - the buffer that contains an encoded instance.
     *
     * @param {Number} [offset] - the offset at which the encoded instance
     * starts.  If absent a zero offset is inferred.
     *
     * @return {Number} - the number of bytes covered by the layout
     * instance.  If this method is not overridden in a subclass the
     * definition-time constant {@link Layout#span|span} will be
     * returned.
     *
     * @throws {RangeError} - if the length of the value cannot be
     * determined.
     */ getSpan(b, offset) {
        if (0 > this.span) throw new RangeError("indeterminate span");
        return this.span;
    }
    /**
     * Replicate the layout using a new property.
     *
     * This function must be used to get a structurally-equivalent layout
     * with a different name since all {@link Layout} instances are
     * immutable.
     *
     * **NOTE** This is a shallow copy.  All fields except {@link
     * Layout#property|property} are strictly equal to the origin layout.
     *
     * @param {String} property - the value for {@link
     * Layout#property|property} in the replica.
     *
     * @returns {Layout} - the copy with {@link Layout#property|property}
     * set to `property`.
     */ replicate(property) {
        const rv = Object.create(this.constructor.prototype);
        Object.assign(rv, this);
        rv.property = property;
        return rv;
    }
    /**
     * Create an object from layout properties and an array of values.
     *
     * **NOTE** This function returns `undefined` if invoked on a layout
     * that does not return its value as an Object.  Objects are
     * returned for things that are a {@link Structure}, which includes
     * {@link VariantLayout|variant layouts} if they are structures, and
     * excludes {@link Union}s.  If you want this feature for a union
     * you must use {@link Union.getVariant|getVariant} to select the
     * desired layout.
     *
     * @param {Array} values - an array of values that correspond to the
     * default order for properties.  As with {@link Layout#decode|decode}
     * layout elements that have no property name are skipped when
     * iterating over the array values.  Only the top-level properties are
     * assigned; arguments are not assigned to properties of contained
     * layouts.  Any unused values are ignored.
     *
     * @return {(Object|undefined)}
     */ fromArray(values) {
        return undefined;
    }
}
$ab8b5713b1ee9109$exports.Layout = $ab8b5713b1ee9109$var$Layout;
/* Provide text that carries a name (such as for a function that will
 * be throwing an error) annotated with the property of a given layout
 * (such as one for which the value was unacceptable).
 *
 * @ignore */ function $ab8b5713b1ee9109$var$nameWithProperty(name, lo) {
    if (lo.property) return name + "[" + lo.property + "]";
    return name;
}
$ab8b5713b1ee9109$exports.nameWithProperty = $ab8b5713b1ee9109$var$nameWithProperty;
/**
 * Augment a class so that instances can be encoded/decoded using a
 * given layout.
 *
 * Calling this function couples `Class` with `layout` in several ways:
 *
 * * `Class.layout_` becomes a static member property equal to `layout`;
 * * `layout.boundConstructor_` becomes a static member property equal
 *    to `Class`;
 * * The {@link Layout#makeDestinationObject|makeDestinationObject()}
 *   property of `layout` is set to a function that returns a `new
 *   Class()`;
 * * `Class.decode(b, offset)` becomes a static member function that
 *   delegates to {@link Layout#decode|layout.decode}.  The
 *   synthesized function may be captured and extended.
 * * `Class.prototype.encode(b, offset)` provides an instance member
 *   function that delegates to {@link Layout#encode|layout.encode}
 *   with `src` set to `this`.  The synthesized function may be
 *   captured and extended, but when the extension is invoked `this`
 *   must be explicitly bound to the instance.
 *
 * @param {class} Class - a JavaScript class with a nullary
 * constructor.
 *
 * @param {Layout} layout - the {@link Layout} instance used to encode
 * instances of `Class`.
 */ // `Class` must be a constructor Function, but the assignment of a `layout_` property to it makes it difficult to type
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $ab8b5713b1ee9109$var$bindConstructorLayout(Class, layout) {
    if ("function" !== typeof Class) throw new TypeError("Class must be constructor");
    if (Object.prototype.hasOwnProperty.call(Class, "layout_")) throw new Error("Class is already bound to a layout");
    if (!(layout && layout instanceof $ab8b5713b1ee9109$var$Layout)) throw new TypeError("layout must be a Layout");
    if (Object.prototype.hasOwnProperty.call(layout, "boundConstructor_")) throw new Error("layout is already bound to a constructor");
    Class.layout_ = layout;
    layout.boundConstructor_ = Class;
    layout.makeDestinationObject = ()=>new Class();
    Object.defineProperty(Class.prototype, "encode", {
        value (b, offset) {
            return layout.encode(this, b, offset);
        },
        writable: true
    });
    Object.defineProperty(Class, "decode", {
        value (b, offset) {
            return layout.decode(b, offset);
        },
        writable: true
    });
}
$ab8b5713b1ee9109$exports.bindConstructorLayout = $ab8b5713b1ee9109$var$bindConstructorLayout;
/**
 * An object that behaves like a layout but does not consume space
 * within its containing layout.
 *
 * This is primarily used to obtain metadata about a member, such as a
 * {@link OffsetLayout} that can provide data about a {@link
 * Layout#getSpan|value-specific span}.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support {@link
 * ExternalLayout#isCount|isCount} or other {@link Layout} functions.
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @abstract
 * @augments {Layout}
 */ class $ab8b5713b1ee9109$var$ExternalLayout extends $ab8b5713b1ee9109$var$Layout {
    /**
     * Return `true` iff the external layout decodes to an unsigned
     * integer layout.
     *
     * In that case it can be used as the source of {@link
     * Sequence#count|Sequence counts}, {@link Blob#length|Blob lengths},
     * or as {@link UnionLayoutDiscriminator#layout|external union
     * discriminators}.
     *
     * @abstract
     */ isCount() {
        throw new Error("ExternalLayout is abstract");
    }
}
$ab8b5713b1ee9109$exports.ExternalLayout = $ab8b5713b1ee9109$var$ExternalLayout;
/**
 * An {@link ExternalLayout} that determines its {@link
 * Layout#decode|value} based on offset into and length of the buffer
 * on which it is invoked.
 *
 * *Factory*: {@link module:Layout.greedy|greedy}
 *
 * @param {Number} [elementSpan] - initializer for {@link
 * GreedyCount#elementSpan|elementSpan}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {ExternalLayout}
 */ class $ab8b5713b1ee9109$var$GreedyCount extends $ab8b5713b1ee9109$var$ExternalLayout {
    constructor(elementSpan = 1, property){
        if (!Number.isInteger(elementSpan) || 0 >= elementSpan) throw new TypeError("elementSpan must be a (positive) integer");
        super(-1, property);
        /** The layout for individual elements of the sequence.  The value
         * must be a positive integer.  If not provided, the value will be
         * 1. */ this.elementSpan = elementSpan;
    }
    /** @override */ isCount() {
        return true;
    }
    /** @override */ decode(b, offset = 0) {
        $ab8b5713b1ee9109$var$checkUint8Array(b);
        const rem = b.length - offset;
        return Math.floor(rem / this.elementSpan);
    }
    /** @override */ encode(src, b, offset) {
        return 0;
    }
}
$ab8b5713b1ee9109$exports.GreedyCount = $ab8b5713b1ee9109$var$GreedyCount;
/**
 * An {@link ExternalLayout} that supports accessing a {@link Layout}
 * at a fixed offset from the start of another Layout.  The offset may
 * be before, within, or after the base layout.
 *
 * *Factory*: {@link module:Layout.offset|offset}
 *
 * @param {Layout} layout - initializer for {@link
 * OffsetLayout#layout|layout}, modulo `property`.
 *
 * @param {Number} [offset] - Initializes {@link
 * OffsetLayout#offset|offset}.  Defaults to zero.
 *
 * @param {string} [property] - Optional new property name for a
 * {@link Layout#replicate| replica} of `layout` to be used as {@link
 * OffsetLayout#layout|layout}.  If not provided the `layout` is used
 * unchanged.
 *
 * @augments {Layout}
 */ class $ab8b5713b1ee9109$var$OffsetLayout extends $ab8b5713b1ee9109$var$ExternalLayout {
    constructor(layout, offset = 0, property){
        if (!(layout instanceof $ab8b5713b1ee9109$var$Layout)) throw new TypeError("layout must be a Layout");
        if (!Number.isInteger(offset)) throw new TypeError("offset must be integer or undefined");
        super(layout.span, property || layout.property);
        /** The subordinated layout. */ this.layout = layout;
        /** The location of {@link OffsetLayout#layout} relative to the
         * start of another layout.
         *
         * The value may be positive or negative, but an error will thrown
         * if at the point of use it goes outside the span of the Uint8Array
         * being accessed.  */ this.offset = offset;
    }
    /** @override */ isCount() {
        return this.layout instanceof $ab8b5713b1ee9109$var$UInt || this.layout instanceof $ab8b5713b1ee9109$var$UIntBE;
    }
    /** @override */ decode(b, offset = 0) {
        return this.layout.decode(b, offset + this.offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        return this.layout.encode(src, b, offset + this.offset);
    }
}
$ab8b5713b1ee9109$exports.OffsetLayout = $ab8b5713b1ee9109$var$OffsetLayout;
/**
 * Represent an unsigned integer in little-endian format.
 *
 * *Factory*: {@link module:Layout.u8|u8}, {@link
 *  module:Layout.u16|u16}, {@link module:Layout.u24|u24}, {@link
 *  module:Layout.u32|u32}, {@link module:Layout.u40|u40}, {@link
 *  module:Layout.u48|u48}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $ab8b5713b1ee9109$var$UInt extends $ab8b5713b1ee9109$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset = 0) {
        return $ab8b5713b1ee9109$var$uint8ArrayToBuffer(b).readUIntLE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $ab8b5713b1ee9109$var$uint8ArrayToBuffer(b).writeUIntLE(src, offset, this.span);
        return this.span;
    }
}
$ab8b5713b1ee9109$exports.UInt = $ab8b5713b1ee9109$var$UInt;
/**
 * Represent an unsigned integer in big-endian format.
 *
 * *Factory*: {@link module:Layout.u8be|u8be}, {@link
 * module:Layout.u16be|u16be}, {@link module:Layout.u24be|u24be},
 * {@link module:Layout.u32be|u32be}, {@link
 * module:Layout.u40be|u40be}, {@link module:Layout.u48be|u48be}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $ab8b5713b1ee9109$var$UIntBE extends $ab8b5713b1ee9109$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset = 0) {
        return $ab8b5713b1ee9109$var$uint8ArrayToBuffer(b).readUIntBE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $ab8b5713b1ee9109$var$uint8ArrayToBuffer(b).writeUIntBE(src, offset, this.span);
        return this.span;
    }
}
$ab8b5713b1ee9109$exports.UIntBE = $ab8b5713b1ee9109$var$UIntBE;
/**
 * Represent a signed integer in little-endian format.
 *
 * *Factory*: {@link module:Layout.s8|s8}, {@link
 *  module:Layout.s16|s16}, {@link module:Layout.s24|s24}, {@link
 *  module:Layout.s32|s32}, {@link module:Layout.s40|s40}, {@link
 *  module:Layout.s48|s48}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $ab8b5713b1ee9109$var$Int extends $ab8b5713b1ee9109$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset = 0) {
        return $ab8b5713b1ee9109$var$uint8ArrayToBuffer(b).readIntLE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $ab8b5713b1ee9109$var$uint8ArrayToBuffer(b).writeIntLE(src, offset, this.span);
        return this.span;
    }
}
$ab8b5713b1ee9109$exports.Int = $ab8b5713b1ee9109$var$Int;
/**
 * Represent a signed integer in big-endian format.
 *
 * *Factory*: {@link module:Layout.s8be|s8be}, {@link
 * module:Layout.s16be|s16be}, {@link module:Layout.s24be|s24be},
 * {@link module:Layout.s32be|s32be}, {@link
 * module:Layout.s40be|s40be}, {@link module:Layout.s48be|s48be}
 *
 * @param {Number} span - initializer for {@link Layout#span|span}.
 * The parameter can range from 1 through 6.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $ab8b5713b1ee9109$var$IntBE extends $ab8b5713b1ee9109$var$Layout {
    constructor(span, property){
        super(span, property);
        if (6 < this.span) throw new RangeError("span must not exceed 6 bytes");
    }
    /** @override */ decode(b, offset = 0) {
        return $ab8b5713b1ee9109$var$uint8ArrayToBuffer(b).readIntBE(offset, this.span);
    }
    /** @override */ encode(src, b, offset = 0) {
        $ab8b5713b1ee9109$var$uint8ArrayToBuffer(b).writeIntBE(src, offset, this.span);
        return this.span;
    }
}
$ab8b5713b1ee9109$exports.IntBE = $ab8b5713b1ee9109$var$IntBE;
const $ab8b5713b1ee9109$var$V2E32 = Math.pow(2, 32);
/* True modulus high and low 32-bit words, where low word is always
 * non-negative. */ function $ab8b5713b1ee9109$var$divmodInt64(src) {
    const hi32 = Math.floor(src / $ab8b5713b1ee9109$var$V2E32);
    const lo32 = src - hi32 * $ab8b5713b1ee9109$var$V2E32;
    return {
        hi32: hi32,
        lo32: lo32
    };
}
/* Reconstruct Number from quotient and non-negative remainder */ function $ab8b5713b1ee9109$var$roundedInt64(hi32, lo32) {
    return hi32 * $ab8b5713b1ee9109$var$V2E32 + lo32;
}
/**
 * Represent an unsigned 64-bit integer in little-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.nu64|nu64}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $ab8b5713b1ee9109$var$NearUInt64 extends $ab8b5713b1ee9109$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $ab8b5713b1ee9109$var$uint8ArrayToBuffer(b);
        const lo32 = buffer.readUInt32LE(offset);
        const hi32 = buffer.readUInt32LE(offset + 4);
        return $ab8b5713b1ee9109$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $ab8b5713b1ee9109$var$divmodInt64(src);
        const buffer = $ab8b5713b1ee9109$var$uint8ArrayToBuffer(b);
        buffer.writeUInt32LE(split.lo32, offset);
        buffer.writeUInt32LE(split.hi32, offset + 4);
        return 8;
    }
}
$ab8b5713b1ee9109$exports.NearUInt64 = $ab8b5713b1ee9109$var$NearUInt64;
/**
 * Represent an unsigned 64-bit integer in big-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.nu64be|nu64be}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $ab8b5713b1ee9109$var$NearUInt64BE extends $ab8b5713b1ee9109$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $ab8b5713b1ee9109$var$uint8ArrayToBuffer(b);
        const hi32 = buffer.readUInt32BE(offset);
        const lo32 = buffer.readUInt32BE(offset + 4);
        return $ab8b5713b1ee9109$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $ab8b5713b1ee9109$var$divmodInt64(src);
        const buffer = $ab8b5713b1ee9109$var$uint8ArrayToBuffer(b);
        buffer.writeUInt32BE(split.hi32, offset);
        buffer.writeUInt32BE(split.lo32, offset + 4);
        return 8;
    }
}
$ab8b5713b1ee9109$exports.NearUInt64BE = $ab8b5713b1ee9109$var$NearUInt64BE;
/**
 * Represent a signed 64-bit integer in little-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.ns64|ns64}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $ab8b5713b1ee9109$var$NearInt64 extends $ab8b5713b1ee9109$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $ab8b5713b1ee9109$var$uint8ArrayToBuffer(b);
        const lo32 = buffer.readUInt32LE(offset);
        const hi32 = buffer.readInt32LE(offset + 4);
        return $ab8b5713b1ee9109$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $ab8b5713b1ee9109$var$divmodInt64(src);
        const buffer = $ab8b5713b1ee9109$var$uint8ArrayToBuffer(b);
        buffer.writeUInt32LE(split.lo32, offset);
        buffer.writeInt32LE(split.hi32, offset + 4);
        return 8;
    }
}
$ab8b5713b1ee9109$exports.NearInt64 = $ab8b5713b1ee9109$var$NearInt64;
/**
 * Represent a signed 64-bit integer in big-endian format when
 * encoded and as a near integral JavaScript Number when decoded.
 *
 * *Factory*: {@link module:Layout.ns64be|ns64be}
 *
 * **NOTE** Values with magnitude greater than 2^52 may not decode to
 * the exact value of the encoded representation.
 *
 * @augments {Layout}
 */ class $ab8b5713b1ee9109$var$NearInt64BE extends $ab8b5713b1ee9109$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        const buffer = $ab8b5713b1ee9109$var$uint8ArrayToBuffer(b);
        const hi32 = buffer.readInt32BE(offset);
        const lo32 = buffer.readUInt32BE(offset + 4);
        return $ab8b5713b1ee9109$var$roundedInt64(hi32, lo32);
    }
    /** @override */ encode(src, b, offset = 0) {
        const split = $ab8b5713b1ee9109$var$divmodInt64(src);
        const buffer = $ab8b5713b1ee9109$var$uint8ArrayToBuffer(b);
        buffer.writeInt32BE(split.hi32, offset);
        buffer.writeUInt32BE(split.lo32, offset + 4);
        return 8;
    }
}
$ab8b5713b1ee9109$exports.NearInt64BE = $ab8b5713b1ee9109$var$NearInt64BE;
/**
 * Represent a 32-bit floating point number in little-endian format.
 *
 * *Factory*: {@link module:Layout.f32|f32}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $ab8b5713b1ee9109$var$Float extends $ab8b5713b1ee9109$var$Layout {
    constructor(property){
        super(4, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $ab8b5713b1ee9109$var$uint8ArrayToBuffer(b).readFloatLE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $ab8b5713b1ee9109$var$uint8ArrayToBuffer(b).writeFloatLE(src, offset);
        return 4;
    }
}
$ab8b5713b1ee9109$exports.Float = $ab8b5713b1ee9109$var$Float;
/**
 * Represent a 32-bit floating point number in big-endian format.
 *
 * *Factory*: {@link module:Layout.f32be|f32be}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $ab8b5713b1ee9109$var$FloatBE extends $ab8b5713b1ee9109$var$Layout {
    constructor(property){
        super(4, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $ab8b5713b1ee9109$var$uint8ArrayToBuffer(b).readFloatBE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $ab8b5713b1ee9109$var$uint8ArrayToBuffer(b).writeFloatBE(src, offset);
        return 4;
    }
}
$ab8b5713b1ee9109$exports.FloatBE = $ab8b5713b1ee9109$var$FloatBE;
/**
 * Represent a 64-bit floating point number in little-endian format.
 *
 * *Factory*: {@link module:Layout.f64|f64}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $ab8b5713b1ee9109$var$Double extends $ab8b5713b1ee9109$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $ab8b5713b1ee9109$var$uint8ArrayToBuffer(b).readDoubleLE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $ab8b5713b1ee9109$var$uint8ArrayToBuffer(b).writeDoubleLE(src, offset);
        return 8;
    }
}
$ab8b5713b1ee9109$exports.Double = $ab8b5713b1ee9109$var$Double;
/**
 * Represent a 64-bit floating point number in big-endian format.
 *
 * *Factory*: {@link module:Layout.f64be|f64be}
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $ab8b5713b1ee9109$var$DoubleBE extends $ab8b5713b1ee9109$var$Layout {
    constructor(property){
        super(8, property);
    }
    /** @override */ decode(b, offset = 0) {
        return $ab8b5713b1ee9109$var$uint8ArrayToBuffer(b).readDoubleBE(offset);
    }
    /** @override */ encode(src, b, offset = 0) {
        $ab8b5713b1ee9109$var$uint8ArrayToBuffer(b).writeDoubleBE(src, offset);
        return 8;
    }
}
$ab8b5713b1ee9109$exports.DoubleBE = $ab8b5713b1ee9109$var$DoubleBE;
/**
 * Represent a contiguous sequence of a specific layout as an Array.
 *
 * *Factory*: {@link module:Layout.seq|seq}
 *
 * @param {Layout} elementLayout - initializer for {@link
 * Sequence#elementLayout|elementLayout}.
 *
 * @param {(Number|ExternalLayout)} count - initializer for {@link
 * Sequence#count|count}.  The parameter must be either a positive
 * integer or an instance of {@link ExternalLayout}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $ab8b5713b1ee9109$var$Sequence extends $ab8b5713b1ee9109$var$Layout {
    constructor(elementLayout, count, property){
        if (!(elementLayout instanceof $ab8b5713b1ee9109$var$Layout)) throw new TypeError("elementLayout must be a Layout");
        if (!(count instanceof $ab8b5713b1ee9109$var$ExternalLayout && count.isCount() || Number.isInteger(count) && 0 <= count)) throw new TypeError("count must be non-negative integer or an unsigned integer ExternalLayout");
        let span = -1;
        if (!(count instanceof $ab8b5713b1ee9109$var$ExternalLayout) && 0 < elementLayout.span) span = count * elementLayout.span;
        super(span, property);
        /** The layout for individual elements of the sequence. */ this.elementLayout = elementLayout;
        /** The number of elements in the sequence.
         *
         * This will be either a non-negative integer or an instance of
         * {@link ExternalLayout} for which {@link
         * ExternalLayout#isCount|isCount()} is `true`. */ this.count = count;
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) return this.span;
        let span = 0;
        let count = this.count;
        if (count instanceof $ab8b5713b1ee9109$var$ExternalLayout) count = count.decode(b, offset);
        if (0 < this.elementLayout.span) span = count * this.elementLayout.span;
        else {
            let idx = 0;
            while(idx < count){
                span += this.elementLayout.getSpan(b, offset + span);
                ++idx;
            }
        }
        return span;
    }
    /** @override */ decode(b, offset = 0) {
        const rv = [];
        let i = 0;
        let count = this.count;
        if (count instanceof $ab8b5713b1ee9109$var$ExternalLayout) count = count.decode(b, offset);
        while(i < count){
            rv.push(this.elementLayout.decode(b, offset));
            offset += this.elementLayout.getSpan(b, offset);
            i += 1;
        }
        return rv;
    }
    /** Implement {@link Layout#encode|encode} for {@link Sequence}.
     *
     * **NOTE** If `src` is shorter than {@link Sequence#count|count} then
     * the unused space in the buffer is left unchanged.  If `src` is
     * longer than {@link Sequence#count|count} the unneeded elements are
     * ignored.
     *
     * **NOTE** If {@link Layout#count|count} is an instance of {@link
     * ExternalLayout} then the length of `src` will be encoded as the
     * count after `src` is encoded. */ encode(src, b, offset = 0) {
        const elo = this.elementLayout;
        const span = src.reduce((span, v)=>{
            return span + elo.encode(v, b, offset + span);
        }, 0);
        if (this.count instanceof $ab8b5713b1ee9109$var$ExternalLayout) this.count.encode(src.length, b, offset);
        return span;
    }
}
$ab8b5713b1ee9109$exports.Sequence = $ab8b5713b1ee9109$var$Sequence;
/**
 * Represent a contiguous sequence of arbitrary layout elements as an
 * Object.
 *
 * *Factory*: {@link module:Layout.struct|struct}
 *
 * **NOTE** The {@link Layout#span|span} of the structure is variable
 * if any layout in {@link Structure#fields|fields} has a variable
 * span.  When {@link Layout#encode|encoding} we must have a value for
 * all variable-length fields, or we wouldn't be able to figure out
 * how much space to use for storage.  We can only identify the value
 * for a field when it has a {@link Layout#property|property}.  As
 * such, although a structure may contain both unnamed fields and
 * variable-length fields, it cannot contain an unnamed
 * variable-length field.
 *
 * @param {Layout[]} fields - initializer for {@link
 * Structure#fields|fields}.  An error is raised if this contains a
 * variable-length field for which a {@link Layout#property|property}
 * is not defined.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @param {Boolean} [decodePrefixes] - initializer for {@link
 * Structure#decodePrefixes|property}.
 *
 * @throws {Error} - if `fields` contains an unnamed variable-length
 * layout.
 *
 * @augments {Layout}
 */ class $ab8b5713b1ee9109$var$Structure extends $ab8b5713b1ee9109$var$Layout {
    constructor(fields, property, decodePrefixes){
        if (!(Array.isArray(fields) && fields.reduce((acc, v)=>acc && v instanceof $ab8b5713b1ee9109$var$Layout, true))) throw new TypeError("fields must be array of Layout instances");
        if ("boolean" === typeof property && undefined === decodePrefixes) {
            decodePrefixes = property;
            property = undefined;
        }
        /* Verify absence of unnamed variable-length fields. */ for (const fd of fields){
            if (0 > fd.span && undefined === fd.property) throw new Error("fields cannot contain unnamed variable-length layout");
        }
        let span = -1;
        try {
            span = fields.reduce((span, fd)=>span + fd.getSpan(), 0);
        } catch (e) {
        // ignore error
        }
        super(span, property);
        /** The sequence of {@link Layout} values that comprise the
         * structure.
         *
         * The individual elements need not be the same type, and may be
         * either scalar or aggregate layouts.  If a member layout leaves
         * its {@link Layout#property|property} undefined the
         * corresponding region of the buffer associated with the element
         * will not be mutated.
         *
         * @type {Layout[]} */ this.fields = fields;
        /** Control behavior of {@link Layout#decode|decode()} given short
         * buffers.
         *
         * In some situations a structure many be extended with additional
         * fields over time, with older installations providing only a
         * prefix of the full structure.  If this property is `true`
         * decoding will accept those buffers and leave subsequent fields
         * undefined, as long as the buffer ends at a field boundary.
         * Defaults to `false`. */ this.decodePrefixes = !!decodePrefixes;
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) return this.span;
        let span = 0;
        try {
            span = this.fields.reduce((span, fd)=>{
                const fsp = fd.getSpan(b, offset);
                offset += fsp;
                return span + fsp;
            }, 0);
        } catch (e) {
            throw new RangeError("indeterminate span");
        }
        return span;
    }
    /** @override */ decode(b, offset = 0) {
        $ab8b5713b1ee9109$var$checkUint8Array(b);
        const dest = this.makeDestinationObject();
        for (const fd of this.fields){
            if (undefined !== fd.property) dest[fd.property] = fd.decode(b, offset);
            offset += fd.getSpan(b, offset);
            if (this.decodePrefixes && b.length === offset) break;
        }
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link Structure}.
     *
     * If `src` is missing a property for a member with a defined {@link
     * Layout#property|property} the corresponding region of the buffer is
     * left unmodified. */ encode(src, b, offset = 0) {
        const firstOffset = offset;
        let lastOffset = 0;
        let lastWrote = 0;
        for (const fd of this.fields){
            let span = fd.span;
            lastWrote = 0 < span ? span : 0;
            if (undefined !== fd.property) {
                const fv = src[fd.property];
                if (undefined !== fv) {
                    lastWrote = fd.encode(fv, b, offset);
                    if (0 > span) /* Read the as-encoded span, which is not necessarily the
                         * same as what we wrote. */ span = fd.getSpan(b, offset);
                }
            }
            lastOffset = offset;
            offset += span;
        }
        /* Use (lastOffset + lastWrote) instead of offset because the last
         * item may have had a dynamic length and we don't want to include
         * the padding between it and the end of the space reserved for
         * it. */ return lastOffset + lastWrote - firstOffset;
    }
    /** @override */ fromArray(values) {
        const dest = this.makeDestinationObject();
        for (const fd of this.fields)if (undefined !== fd.property && 0 < values.length) dest[fd.property] = values.shift();
        return dest;
    }
    /**
     * Get access to the layout of a given property.
     *
     * @param {String} property - the structure member of interest.
     *
     * @return {Layout} - the layout associated with `property`, or
     * undefined if there is no such property.
     */ layoutFor(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        for (const fd of this.fields){
            if (fd.property === property) return fd;
        }
        return undefined;
    }
    /**
     * Get the offset of a structure member.
     *
     * @param {String} property - the structure member of interest.
     *
     * @return {Number} - the offset in bytes to the start of `property`
     * within the structure, or undefined if `property` is not a field
     * within the structure.  If the property is a member but follows a
     * variable-length structure member a negative number will be
     * returned.
     */ offsetOf(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        let offset = 0;
        for (const fd of this.fields){
            if (fd.property === property) return offset;
            if (0 > fd.span) offset = -1;
            else if (0 <= offset) offset += fd.span;
        }
        return undefined;
    }
}
$ab8b5713b1ee9109$exports.Structure = $ab8b5713b1ee9109$var$Structure;
/**
 * An object that can provide a {@link
 * Union#discriminator|discriminator} API for {@link Union}.
 *
 * **NOTE** This is an abstract base class; you can create instances
 * if it amuses you, but they won't support the {@link
 * UnionDiscriminator#encode|encode} or {@link
 * UnionDiscriminator#decode|decode} functions.
 *
 * @param {string} [property] - Default for {@link
 * UnionDiscriminator#property|property}.
 *
 * @abstract
 */ class $ab8b5713b1ee9109$var$UnionDiscriminator {
    constructor(property){
        /** The {@link Layout#property|property} to be used when the
         * discriminator is referenced in isolation (generally when {@link
         * Union#decode|Union decode} cannot delegate to a specific
         * variant). */ this.property = property;
    }
    /** Analog to {@link Layout#decode|Layout decode} for union discriminators.
     *
     * The implementation of this method need not reference the buffer if
     * variant information is available through other means. */ decode(b, offset) {
        throw new Error("UnionDiscriminator is abstract");
    }
    /** Analog to {@link Layout#decode|Layout encode} for union discriminators.
     *
     * The implementation of this method need not store the value if
     * variant information is maintained through other means. */ encode(src, b, offset) {
        throw new Error("UnionDiscriminator is abstract");
    }
}
$ab8b5713b1ee9109$exports.UnionDiscriminator = $ab8b5713b1ee9109$var$UnionDiscriminator;
/**
 * An object that can provide a {@link
 * UnionDiscriminator|discriminator API} for {@link Union} using an
 * unsigned integral {@link Layout} instance located either inside or
 * outside the union.
 *
 * @param {ExternalLayout} layout - initializes {@link
 * UnionLayoutDiscriminator#layout|layout}.  Must satisfy {@link
 * ExternalLayout#isCount|isCount()}.
 *
 * @param {string} [property] - Default for {@link
 * UnionDiscriminator#property|property}, superseding the property
 * from `layout`, but defaulting to `variant` if neither `property`
 * nor layout provide a property name.
 *
 * @augments {UnionDiscriminator}
 */ class $ab8b5713b1ee9109$var$UnionLayoutDiscriminator extends $ab8b5713b1ee9109$var$UnionDiscriminator {
    constructor(layout, property){
        if (!(layout instanceof $ab8b5713b1ee9109$var$ExternalLayout && layout.isCount())) throw new TypeError("layout must be an unsigned integer ExternalLayout");
        super(property || layout.property || "variant");
        /** The {@link ExternalLayout} used to access the discriminator
         * value. */ this.layout = layout;
    }
    /** Delegate decoding to {@link UnionLayoutDiscriminator#layout|layout}. */ decode(b, offset) {
        return this.layout.decode(b, offset);
    }
    /** Delegate encoding to {@link UnionLayoutDiscriminator#layout|layout}. */ encode(src, b, offset) {
        return this.layout.encode(src, b, offset);
    }
}
$ab8b5713b1ee9109$exports.UnionLayoutDiscriminator = $ab8b5713b1ee9109$var$UnionLayoutDiscriminator;
/**
 * Represent any number of span-compatible layouts.
 *
 * *Factory*: {@link module:Layout.union|union}
 *
 * If the union has a {@link Union#defaultLayout|default layout} that
 * layout must have a non-negative {@link Layout#span|span}.  The span
 * of a fixed-span union includes its {@link
 * Union#discriminator|discriminator} if the variant is a {@link
 * Union#usesPrefixDiscriminator|prefix of the union}, plus the span
 * of its {@link Union#defaultLayout|default layout}.
 *
 * If the union does not have a default layout then the encoded span
 * of the union depends on the encoded span of its variant (which may
 * be fixed or variable).
 *
 * {@link VariantLayout#layout|Variant layout}s are added through
 * {@link Union#addVariant|addVariant}.  If the union has a default
 * layout, the span of the {@link VariantLayout#layout|layout
 * contained by the variant} must not exceed the span of the {@link
 * Union#defaultLayout|default layout} (minus the span of a {@link
 * Union#usesPrefixDiscriminator|prefix disriminator}, if used).  The
 * span of the variant will equal the span of the union itself.
 *
 * The variant for a buffer can only be identified from the {@link
 * Union#discriminator|discriminator} {@link
 * UnionDiscriminator#property|property} (in the case of the {@link
 * Union#defaultLayout|default layout}), or by using {@link
 * Union#getVariant|getVariant} and examining the resulting {@link
 * VariantLayout} instance.
 *
 * A variant compatible with a JavaScript object can be identified
 * using {@link Union#getSourceVariant|getSourceVariant}.
 *
 * @param {(UnionDiscriminator|ExternalLayout|Layout)} discr - How to
 * identify the layout used to interpret the union contents.  The
 * parameter must be an instance of {@link UnionDiscriminator}, an
 * {@link ExternalLayout} that satisfies {@link
 * ExternalLayout#isCount|isCount()}, or {@link UInt} (or {@link
 * UIntBE}).  When a non-external layout element is passed the layout
 * appears at the start of the union.  In all cases the (synthesized)
 * {@link UnionDiscriminator} instance is recorded as {@link
 * Union#discriminator|discriminator}.
 *
 * @param {(Layout|null)} defaultLayout - initializer for {@link
 * Union#defaultLayout|defaultLayout}.  If absent defaults to `null`.
 * If `null` there is no default layout: the union has data-dependent
 * length and attempts to decode or encode unrecognized variants will
 * throw an exception.  A {@link Layout} instance must have a
 * non-negative {@link Layout#span|span}, and if it lacks a {@link
 * Layout#property|property} the {@link
 * Union#defaultLayout|defaultLayout} will be a {@link
 * Layout#replicate|replica} with property `content`.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $ab8b5713b1ee9109$var$Union extends $ab8b5713b1ee9109$var$Layout {
    constructor(discr, defaultLayout, property){
        let discriminator;
        if (discr instanceof $ab8b5713b1ee9109$var$UInt || discr instanceof $ab8b5713b1ee9109$var$UIntBE) discriminator = new $ab8b5713b1ee9109$var$UnionLayoutDiscriminator(new $ab8b5713b1ee9109$var$OffsetLayout(discr));
        else if (discr instanceof $ab8b5713b1ee9109$var$ExternalLayout && discr.isCount()) discriminator = new $ab8b5713b1ee9109$var$UnionLayoutDiscriminator(discr);
        else if (!(discr instanceof $ab8b5713b1ee9109$var$UnionDiscriminator)) throw new TypeError("discr must be a UnionDiscriminator or an unsigned integer layout");
        else discriminator = discr;
        if (undefined === defaultLayout) defaultLayout = null;
        if (!(null === defaultLayout || defaultLayout instanceof $ab8b5713b1ee9109$var$Layout)) throw new TypeError("defaultLayout must be null or a Layout");
        if (null !== defaultLayout) {
            if (0 > defaultLayout.span) throw new Error("defaultLayout must have constant span");
            if (undefined === defaultLayout.property) defaultLayout = defaultLayout.replicate("content");
        }
        /* The union span can be estimated only if there's a default
         * layout.  The union spans its default layout, plus any prefix
         * variant layout.  By construction both layouts, if present, have
         * non-negative span. */ let span = -1;
        if (defaultLayout) {
            span = defaultLayout.span;
            if (0 <= span && (discr instanceof $ab8b5713b1ee9109$var$UInt || discr instanceof $ab8b5713b1ee9109$var$UIntBE)) span += discriminator.layout.span;
        }
        super(span, property);
        /** The interface for the discriminator value in isolation.
         *
         * This a {@link UnionDiscriminator} either passed to the
         * constructor or synthesized from the `discr` constructor
         * argument.  {@link
         * Union#usesPrefixDiscriminator|usesPrefixDiscriminator} will be
         * `true` iff the `discr` parameter was a non-offset {@link
         * Layout} instance. */ this.discriminator = discriminator;
        /** `true` if the {@link Union#discriminator|discriminator} is the
         * first field in the union.
         *
         * If `false` the discriminator is obtained from somewhere
         * else. */ this.usesPrefixDiscriminator = discr instanceof $ab8b5713b1ee9109$var$UInt || discr instanceof $ab8b5713b1ee9109$var$UIntBE;
        /** The layout for non-discriminator content when the value of the
         * discriminator is not recognized.
         *
         * This is the value passed to the constructor.  It is
         * structurally equivalent to the second component of {@link
         * Union#layout|layout} but may have a different property
         * name. */ this.defaultLayout = defaultLayout;
        /** A registry of allowed variants.
         *
         * The keys are unsigned integers which should be compatible with
         * {@link Union.discriminator|discriminator}.  The property value
         * is the corresponding {@link VariantLayout} instances assigned
         * to this union by {@link Union#addVariant|addVariant}.
         *
         * **NOTE** The registry remains mutable so that variants can be
         * {@link Union#addVariant|added} at any time.  Users should not
         * manipulate the content of this property. */ this.registry = {};
        /* Private variable used when invoking getSourceVariant */ let boundGetSourceVariant = this.defaultGetSourceVariant.bind(this);
        /** Function to infer the variant selected by a source object.
         *
         * Defaults to {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant} but may
         * be overridden using {@link
         * Union#configGetSourceVariant|configGetSourceVariant}.
         *
         * @param {Object} src - as with {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant}.
         *
         * @returns {(undefined|VariantLayout)} The default variant
         * (`undefined`) or first registered variant that uses a property
         * available in `src`. */ this.getSourceVariant = function(src) {
            return boundGetSourceVariant(src);
        };
        /** Function to override the implementation of {@link
         * Union#getSourceVariant|getSourceVariant}.
         *
         * Use this if the desired variant cannot be identified using the
         * algorithm of {@link
         * Union#defaultGetSourceVariant|defaultGetSourceVariant}.
         *
         * **NOTE** The provided function will be invoked bound to this
         * Union instance, providing local access to {@link
         * Union#registry|registry}.
         *
         * @param {Function} gsv - a function that follows the API of
         * {@link Union#defaultGetSourceVariant|defaultGetSourceVariant}. */ this.configGetSourceVariant = function(gsv) {
            boundGetSourceVariant = gsv.bind(this);
        };
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) return this.span;
        /* Default layouts always have non-negative span, so we don't have
         * one and we have to recognize the variant which will in turn
         * determine the span. */ const vlo = this.getVariant(b, offset);
        if (!vlo) throw new Error("unable to determine span for unrecognized variant");
        return vlo.getSpan(b, offset);
    }
    /**
     * Method to infer a registered Union variant compatible with `src`.
     *
     * The first satisfied rule in the following sequence defines the
     * return value:
     * * If `src` has properties matching the Union discriminator and
     *   the default layout, `undefined` is returned regardless of the
     *   value of the discriminator property (this ensures the default
     *   layout will be used);
     * * If `src` has a property matching the Union discriminator, the
     *   value of the discriminator identifies a registered variant, and
     *   either (a) the variant has no layout, or (b) `src` has the
     *   variant's property, then the variant is returned (because the
     *   source satisfies the constraints of the variant it identifies);
     * * If `src` does not have a property matching the Union
     *   discriminator, but does have a property matching a registered
     *   variant, then the variant is returned (because the source
     *   matches a variant without an explicit conflict);
     * * An error is thrown (because we either can't identify a variant,
     *   or we were explicitly told the variant but can't satisfy it).
     *
     * @param {Object} src - an object presumed to be compatible with
     * the content of the Union.
     *
     * @return {(undefined|VariantLayout)} - as described above.
     *
     * @throws {Error} - if `src` cannot be associated with a default or
     * registered variant.
     */ defaultGetSourceVariant(src) {
        if (Object.prototype.hasOwnProperty.call(src, this.discriminator.property)) {
            if (this.defaultLayout && this.defaultLayout.property && Object.prototype.hasOwnProperty.call(src, this.defaultLayout.property)) return undefined;
            const vlo = this.registry[src[this.discriminator.property]];
            if (vlo && (!vlo.layout || vlo.property && Object.prototype.hasOwnProperty.call(src, vlo.property))) return vlo;
        } else for(const tag in this.registry){
            const vlo = this.registry[tag];
            if (vlo.property && Object.prototype.hasOwnProperty.call(src, vlo.property)) return vlo;
        }
        throw new Error("unable to infer src variant");
    }
    /** Implement {@link Layout#decode|decode} for {@link Union}.
     *
     * If the variant is {@link Union#addVariant|registered} the return
     * value is an instance of that variant, with no explicit
     * discriminator.  Otherwise the {@link Union#defaultLayout|default
     * layout} is used to decode the content. */ decode(b, offset = 0) {
        let dest;
        const dlo = this.discriminator;
        const discr = dlo.decode(b, offset);
        const clo = this.registry[discr];
        if (undefined === clo) {
            const defaultLayout = this.defaultLayout;
            let contentOffset = 0;
            if (this.usesPrefixDiscriminator) contentOffset = dlo.layout.span;
            dest = this.makeDestinationObject();
            dest[dlo.property] = discr;
            // defaultLayout.property can be undefined, but this is allowed by buffer-layout
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            dest[defaultLayout.property] = defaultLayout.decode(b, offset + contentOffset);
        } else dest = clo.decode(b, offset);
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link Union}.
     *
     * This API assumes the `src` object is consistent with the union's
     * {@link Union#defaultLayout|default layout}.  To encode variants
     * use the appropriate variant-specific {@link VariantLayout#encode}
     * method. */ encode(src, b, offset = 0) {
        const vlo = this.getSourceVariant(src);
        if (undefined === vlo) {
            const dlo = this.discriminator;
            // this.defaultLayout is not undefined when vlo is undefined
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const clo = this.defaultLayout;
            let contentOffset = 0;
            if (this.usesPrefixDiscriminator) contentOffset = dlo.layout.span;
            dlo.encode(src[dlo.property], b, offset);
            // clo.property is not undefined when vlo is undefined
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return contentOffset + clo.encode(src[clo.property], b, offset + contentOffset);
        }
        return vlo.encode(src, b, offset);
    }
    /** Register a new variant structure within a union.  The newly
     * created variant is returned.
     *
     * @param {Number} variant - initializer for {@link
     * VariantLayout#variant|variant}.
     *
     * @param {Layout} layout - initializer for {@link
     * VariantLayout#layout|layout}.
     *
     * @param {String} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {VariantLayout} */ addVariant(variant, layout, property) {
        const rv = new $ab8b5713b1ee9109$var$VariantLayout(this, variant, layout, property);
        this.registry[variant] = rv;
        return rv;
    }
    /**
     * Get the layout associated with a registered variant.
     *
     * If `vb` does not produce a registered variant the function returns
     * `undefined`.
     *
     * @param {(Number|Uint8Array)} vb - either the variant number, or a
     * buffer from which the discriminator is to be read.
     *
     * @param {Number} offset - offset into `vb` for the start of the
     * union.  Used only when `vb` is an instance of {Uint8Array}.
     *
     * @return {({VariantLayout}|undefined)}
     */ getVariant(vb, offset = 0) {
        let variant;
        if (vb instanceof Uint8Array) variant = this.discriminator.decode(vb, offset);
        else variant = vb;
        return this.registry[variant];
    }
}
$ab8b5713b1ee9109$exports.Union = $ab8b5713b1ee9109$var$Union;
/**
 * Represent a specific variant within a containing union.
 *
 * **NOTE** The {@link Layout#span|span} of the variant may include
 * the span of the {@link Union#discriminator|discriminator} used to
 * identify it, but values read and written using the variant strictly
 * conform to the content of {@link VariantLayout#layout|layout}.
 *
 * **NOTE** User code should not invoke this constructor directly.  Use
 * the union {@link Union#addVariant|addVariant} helper method.
 *
 * @param {Union} union - initializer for {@link
 * VariantLayout#union|union}.
 *
 * @param {Number} variant - initializer for {@link
 * VariantLayout#variant|variant}.
 *
 * @param {Layout} [layout] - initializer for {@link
 * VariantLayout#layout|layout}.  If absent the variant carries no
 * data.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.  Unlike many other layouts, variant
 * layouts normally include a property name so they can be identified
 * within their containing {@link Union}.  The property identifier may
 * be absent only if `layout` is is absent.
 *
 * @augments {Layout}
 */ class $ab8b5713b1ee9109$var$VariantLayout extends $ab8b5713b1ee9109$var$Layout {
    constructor(union, variant, layout, property){
        if (!(union instanceof $ab8b5713b1ee9109$var$Union)) throw new TypeError("union must be a Union");
        if (!Number.isInteger(variant) || 0 > variant) throw new TypeError("variant must be a (non-negative) integer");
        if ("string" === typeof layout && undefined === property) {
            property = layout;
            layout = null;
        }
        if (layout) {
            if (!(layout instanceof $ab8b5713b1ee9109$var$Layout)) throw new TypeError("layout must be a Layout");
            if (null !== union.defaultLayout && 0 <= layout.span && layout.span > union.defaultLayout.span) throw new Error("variant span exceeds span of containing union");
            if ("string" !== typeof property) throw new TypeError("variant must have a String property");
        }
        let span = union.span;
        if (0 > union.span) {
            span = layout ? layout.span : 0;
            if (0 <= span && union.usesPrefixDiscriminator) span += union.discriminator.layout.span;
        }
        super(span, property);
        /** The {@link Union} to which this variant belongs. */ this.union = union;
        /** The unsigned integral value identifying this variant within
         * the {@link Union#discriminator|discriminator} of the containing
         * union. */ this.variant = variant;
        /** The {@link Layout} to be used when reading/writing the
         * non-discriminator part of the {@link
         * VariantLayout#union|union}.  If `null` the variant carries no
         * data. */ this.layout = layout || null;
    }
    /** @override */ getSpan(b, offset = 0) {
        if (0 <= this.span) /* Will be equal to the containing union span if that is not
             * variable. */ return this.span;
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        /* Span is defined solely by the variant (and prefix discriminator) */ let span = 0;
        if (this.layout) span = this.layout.getSpan(b, offset + contentOffset);
        return contentOffset + span;
    }
    /** @override */ decode(b, offset = 0) {
        const dest = this.makeDestinationObject();
        if (this !== this.union.getVariant(b, offset)) throw new Error("variant mismatch");
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        if (this.layout) dest[this.property] = this.layout.decode(b, offset + contentOffset);
        else if (this.property) dest[this.property] = true;
        else if (this.union.usesPrefixDiscriminator) dest[this.union.discriminator.property] = this.variant;
        return dest;
    }
    /** @override */ encode(src, b, offset = 0) {
        let contentOffset = 0;
        if (this.union.usesPrefixDiscriminator) contentOffset = this.union.discriminator.layout.span;
        if (this.layout && !Object.prototype.hasOwnProperty.call(src, this.property)) throw new TypeError("variant lacks property " + this.property);
        this.union.discriminator.encode(this.variant, b, offset);
        let span = contentOffset;
        if (this.layout) {
            this.layout.encode(src[this.property], b, offset + contentOffset);
            span += this.layout.getSpan(b, offset + contentOffset);
            if (0 <= this.union.span && span > this.union.span) throw new Error("encoded variant overruns containing union");
        }
        return span;
    }
    /** Delegate {@link Layout#fromArray|fromArray} to {@link
     * VariantLayout#layout|layout}. */ fromArray(values) {
        if (this.layout) return this.layout.fromArray(values);
        return undefined;
    }
}
$ab8b5713b1ee9109$exports.VariantLayout = $ab8b5713b1ee9109$var$VariantLayout;
/** JavaScript chose to define bitwise operations as operating on
 * signed 32-bit values in 2's complement form, meaning any integer
 * with bit 31 set is going to look negative.  For right shifts that's
 * not a problem, because `>>>` is a logical shift, but for every
 * other bitwise operator we have to compensate for possible negative
 * results. */ function $ab8b5713b1ee9109$var$fixBitwiseResult(v) {
    if (0 > v) v += 0x100000000;
    return v;
}
/**
 * Contain a sequence of bit fields as an unsigned integer.
 *
 * *Factory*: {@link module:Layout.bits|bits}
 *
 * This is a container element; within it there are {@link BitField}
 * instances that provide the extracted properties.  The container
 * simply defines the aggregate representation and its bit ordering.
 * The representation is an object containing properties with numeric
 * or {@link Boolean} values.
 *
 * {@link BitField}s are added with the {@link
 * BitStructure#addField|addField} and {@link
 * BitStructure#addBoolean|addBoolean} methods.

 * @param {Layout} word - initializer for {@link
 * BitStructure#word|word}.  The parameter must be an instance of
 * {@link UInt} (or {@link UIntBE}) that is no more than 4 bytes wide.
 *
 * @param {bool} [msb] - `true` if the bit numbering starts at the
 * most significant bit of the containing word; `false` (default) if
 * it starts at the least significant bit of the containing word.  If
 * the parameter at this position is a string and `property` is
 * `undefined` the value of this argument will instead be used as the
 * value of `property`.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $ab8b5713b1ee9109$var$BitStructure extends $ab8b5713b1ee9109$var$Layout {
    constructor(word, msb, property){
        if (!(word instanceof $ab8b5713b1ee9109$var$UInt || word instanceof $ab8b5713b1ee9109$var$UIntBE)) throw new TypeError("word must be a UInt or UIntBE layout");
        if ("string" === typeof msb && undefined === property) {
            property = msb;
            msb = false;
        }
        if (4 < word.span) throw new RangeError("word cannot exceed 32 bits");
        super(word.span, property);
        /** The layout used for the packed value.  {@link BitField}
         * instances are packed sequentially depending on {@link
         * BitStructure#msb|msb}. */ this.word = word;
        /** Whether the bit sequences are packed starting at the most
         * significant bit growing down (`true`), or the least significant
         * bit growing up (`false`).
         *
         * **NOTE** Regardless of this value, the least significant bit of
         * any {@link BitField} value is the least significant bit of the
         * corresponding section of the packed value. */ this.msb = !!msb;
        /** The sequence of {@link BitField} layouts that comprise the
         * packed structure.
         *
         * **NOTE** The array remains mutable to allow fields to be {@link
         * BitStructure#addField|added} after construction.  Users should
         * not manipulate the content of this property.*/ this.fields = [];
        /* Storage for the value.  Capture a variable instead of using an
         * instance property because we don't want anything to change the
         * value without going through the mutator. */ let value = 0;
        this._packedSetValue = function(v) {
            value = $ab8b5713b1ee9109$var$fixBitwiseResult(v);
            return this;
        };
        this._packedGetValue = function() {
            return value;
        };
    }
    /** @override */ decode(b, offset = 0) {
        const dest = this.makeDestinationObject();
        const value = this.word.decode(b, offset);
        this._packedSetValue(value);
        for (const fd of this.fields)if (undefined !== fd.property) dest[fd.property] = fd.decode(b);
        return dest;
    }
    /** Implement {@link Layout#encode|encode} for {@link BitStructure}.
     *
     * If `src` is missing a property for a member with a defined {@link
     * Layout#property|property} the corresponding region of the packed
     * value is left unmodified.  Unused bits are also left unmodified. */ encode(src, b, offset = 0) {
        const value = this.word.decode(b, offset);
        this._packedSetValue(value);
        for (const fd of this.fields)if (undefined !== fd.property) {
            const fv = src[fd.property];
            if (undefined !== fv) fd.encode(fv);
        }
        return this.word.encode(this._packedGetValue(), b, offset);
    }
    /** Register a new bitfield with a containing bit structure.  The
     * resulting bitfield is returned.
     *
     * @param {Number} bits - initializer for {@link BitField#bits|bits}.
     *
     * @param {string} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {BitField} */ addField(bits, property) {
        const bf = new $ab8b5713b1ee9109$var$BitField(this, bits, property);
        this.fields.push(bf);
        return bf;
    }
    /** As with {@link BitStructure#addField|addField} for single-bit
     * fields with `boolean` value representation.
     *
     * @param {string} property - initializer for {@link
     * Layout#property|property}.
     *
     * @return {Boolean} */ // `Boolean` conflicts with the native primitive type
    // eslint-disable-next-line @typescript-eslint/ban-types
    addBoolean(property) {
        // This is my Boolean, not the Javascript one.
        const bf = new $ab8b5713b1ee9109$var$Boolean(this, property);
        this.fields.push(bf);
        return bf;
    }
    /**
     * Get access to the bit field for a given property.
     *
     * @param {String} property - the bit field of interest.
     *
     * @return {BitField} - the field associated with `property`, or
     * undefined if there is no such property.
     */ fieldFor(property) {
        if ("string" !== typeof property) throw new TypeError("property must be string");
        for (const fd of this.fields){
            if (fd.property === property) return fd;
        }
        return undefined;
    }
}
$ab8b5713b1ee9109$exports.BitStructure = $ab8b5713b1ee9109$var$BitStructure;
/**
 * Represent a sequence of bits within a {@link BitStructure}.
 *
 * All bit field values are represented as unsigned integers.
 *
 * **NOTE** User code should not invoke this constructor directly.
 * Use the container {@link BitStructure#addField|addField} helper
 * method.
 *
 * **NOTE** BitField instances are not instances of {@link Layout}
 * since {@link Layout#span|span} measures 8-bit units.
 *
 * @param {BitStructure} container - initializer for {@link
 * BitField#container|container}.
 *
 * @param {Number} bits - initializer for {@link BitField#bits|bits}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 */ class $ab8b5713b1ee9109$var$BitField {
    constructor(container, bits, property){
        if (!(container instanceof $ab8b5713b1ee9109$var$BitStructure)) throw new TypeError("container must be a BitStructure");
        if (!Number.isInteger(bits) || 0 >= bits) throw new TypeError("bits must be positive integer");
        const totalBits = 8 * container.span;
        const usedBits = container.fields.reduce((sum, fd)=>sum + fd.bits, 0);
        if (bits + usedBits > totalBits) throw new Error("bits too long for span remainder (" + (totalBits - usedBits) + " of " + totalBits + " remain)");
        /** The {@link BitStructure} instance to which this bit field
         * belongs. */ this.container = container;
        /** The span of this value in bits. */ this.bits = bits;
        /** A mask of {@link BitField#bits|bits} bits isolating value bits
         * that fit within the field.
         *
         * That is, it masks a value that has not yet been shifted into
         * position within its containing packed integer. */ this.valueMask = (1 << bits) - 1;
        if (32 === bits) this.valueMask = 0xFFFFFFFF;
        /** The offset of the value within the containing packed unsigned
         * integer.  The least significant bit of the packed value is at
         * offset zero, regardless of bit ordering used. */ this.start = usedBits;
        if (this.container.msb) this.start = totalBits - usedBits - bits;
        /** A mask of {@link BitField#bits|bits} isolating the field value
         * within the containing packed unsigned integer. */ this.wordMask = $ab8b5713b1ee9109$var$fixBitwiseResult(this.valueMask << this.start);
        /** The property name used when this bitfield is represented in an
         * Object.
         *
         * Intended to be functionally equivalent to {@link
         * Layout#property}.
         *
         * If left undefined the corresponding span of bits will be
         * treated as padding: it will not be mutated by {@link
         * Layout#encode|encode} nor represented as a property in the
         * decoded Object. */ this.property = property;
    }
    /** Store a value into the corresponding subsequence of the containing
     * bit field. */ decode(b, offset) {
        const word = this.container._packedGetValue();
        const wordValue = $ab8b5713b1ee9109$var$fixBitwiseResult(word & this.wordMask);
        const value = wordValue >>> this.start;
        return value;
    }
    /** Store a value into the corresponding subsequence of the containing
     * bit field.
     *
     * **NOTE** This is not a specialization of {@link
     * Layout#encode|Layout.encode} and there is no return value. */ encode(value) {
        if ("number" !== typeof value || !Number.isInteger(value) || value !== $ab8b5713b1ee9109$var$fixBitwiseResult(value & this.valueMask)) throw new TypeError($ab8b5713b1ee9109$var$nameWithProperty("BitField.encode", this) + " value must be integer not exceeding " + this.valueMask);
        const word = this.container._packedGetValue();
        const wordValue = $ab8b5713b1ee9109$var$fixBitwiseResult(value << this.start);
        this.container._packedSetValue($ab8b5713b1ee9109$var$fixBitwiseResult(word & ~this.wordMask) | wordValue);
    }
}
$ab8b5713b1ee9109$exports.BitField = $ab8b5713b1ee9109$var$BitField;
/**
 * Represent a single bit within a {@link BitStructure} as a
 * JavaScript boolean.
 *
 * **NOTE** User code should not invoke this constructor directly.
 * Use the container {@link BitStructure#addBoolean|addBoolean} helper
 * method.
 *
 * @param {BitStructure} container - initializer for {@link
 * BitField#container|container}.
 *
 * @param {string} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {BitField}
 */ /* eslint-disable no-extend-native */ class $ab8b5713b1ee9109$var$Boolean extends $ab8b5713b1ee9109$var$BitField {
    constructor(container, property){
        super(container, 1, property);
    }
    /** Override {@link BitField#decode|decode} for {@link Boolean|Boolean}.
     *
     * @returns {boolean} */ decode(b, offset) {
        return !!super.decode(b, offset);
    }
    /** @override */ encode(value) {
        if ("boolean" === typeof value) // BitField requires integer values
        value = +value;
        super.encode(value);
    }
}
$ab8b5713b1ee9109$exports.Boolean = $ab8b5713b1ee9109$var$Boolean;
/* eslint-enable no-extend-native */ /**
 * Contain a fixed-length block of arbitrary data, represented as a
 * Uint8Array.
 *
 * *Factory*: {@link module:Layout.blob|blob}
 *
 * @param {(Number|ExternalLayout)} length - initializes {@link
 * Blob#length|length}.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $ab8b5713b1ee9109$var$Blob extends $ab8b5713b1ee9109$var$Layout {
    constructor(length, property){
        if (!(length instanceof $ab8b5713b1ee9109$var$ExternalLayout && length.isCount() || Number.isInteger(length) && 0 <= length)) throw new TypeError("length must be positive integer or an unsigned integer ExternalLayout");
        let span = -1;
        if (!(length instanceof $ab8b5713b1ee9109$var$ExternalLayout)) span = length;
        super(span, property);
        /** The number of bytes in the blob.
         *
         * This may be a non-negative integer, or an instance of {@link
         * ExternalLayout} that satisfies {@link
         * ExternalLayout#isCount|isCount()}. */ this.length = length;
    }
    /** @override */ getSpan(b, offset) {
        let span = this.span;
        if (0 > span) span = this.length.decode(b, offset);
        return span;
    }
    /** @override */ decode(b, offset = 0) {
        let span = this.span;
        if (0 > span) span = this.length.decode(b, offset);
        return $ab8b5713b1ee9109$var$uint8ArrayToBuffer(b).slice(offset, offset + span);
    }
    /** Implement {@link Layout#encode|encode} for {@link Blob}.
     *
     * **NOTE** If {@link Layout#count|count} is an instance of {@link
     * ExternalLayout} then the length of `src` will be encoded as the
     * count after `src` is encoded. */ encode(src, b, offset) {
        let span = this.length;
        if (this.length instanceof $ab8b5713b1ee9109$var$ExternalLayout) span = src.length;
        if (!(src instanceof Uint8Array && span === src.length)) throw new TypeError($ab8b5713b1ee9109$var$nameWithProperty("Blob.encode", this) + " requires (length " + span + ") Uint8Array as src");
        if (offset + span > b.length) throw new RangeError("encoding overruns Uint8Array");
        const srcBuffer = $ab8b5713b1ee9109$var$uint8ArrayToBuffer(src);
        $ab8b5713b1ee9109$var$uint8ArrayToBuffer(b).write(srcBuffer.toString("hex"), offset, span, "hex");
        if (this.length instanceof $ab8b5713b1ee9109$var$ExternalLayout) this.length.encode(span, b, offset);
        return span;
    }
}
$ab8b5713b1ee9109$exports.Blob = $ab8b5713b1ee9109$var$Blob;
/**
 * Contain a `NUL`-terminated UTF8 string.
 *
 * *Factory*: {@link module:Layout.cstr|cstr}
 *
 * **NOTE** Any UTF8 string that incorporates a zero-valued byte will
 * not be correctly decoded by this layout.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $ab8b5713b1ee9109$var$CString extends $ab8b5713b1ee9109$var$Layout {
    constructor(property){
        super(-1, property);
    }
    /** @override */ getSpan(b, offset = 0) {
        $ab8b5713b1ee9109$var$checkUint8Array(b);
        let idx = offset;
        while(idx < b.length && 0 !== b[idx])idx += 1;
        return 1 + idx - offset;
    }
    /** @override */ decode(b, offset = 0) {
        const span = this.getSpan(b, offset);
        return $ab8b5713b1ee9109$var$uint8ArrayToBuffer(b).slice(offset, offset + span - 1).toString("utf-8");
    }
    /** @override */ encode(src, b, offset = 0) {
        /* Must force this to a string, lest it be a number and the
         * "utf8-encoding" below actually allocate a buffer of length
         * src */ if ("string" !== typeof src) src = String(src);
        const srcb = $9891c961abffc7d1$export$a143d493d941bafc.from(src, "utf8");
        const span = srcb.length;
        if (offset + span > b.length) throw new RangeError("encoding overruns Buffer");
        const buffer = $ab8b5713b1ee9109$var$uint8ArrayToBuffer(b);
        srcb.copy(buffer, offset);
        buffer[offset + span] = 0;
        return span + 1;
    }
}
$ab8b5713b1ee9109$exports.CString = $ab8b5713b1ee9109$var$CString;
/**
 * Contain a UTF8 string with implicit length.
 *
 * *Factory*: {@link module:Layout.utf8|utf8}
 *
 * **NOTE** Because the length is implicit in the size of the buffer
 * this layout should be used only in isolation, or in a situation
 * where the length can be expressed by operating on a slice of the
 * containing buffer.
 *
 * @param {Number} [maxSpan] - the maximum length allowed for encoded
 * string content.  If not provided there is no bound on the allowed
 * content.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $ab8b5713b1ee9109$var$UTF8 extends $ab8b5713b1ee9109$var$Layout {
    constructor(maxSpan, property){
        if ("string" === typeof maxSpan && undefined === property) {
            property = maxSpan;
            maxSpan = undefined;
        }
        if (undefined === maxSpan) maxSpan = -1;
        else if (!Number.isInteger(maxSpan)) throw new TypeError("maxSpan must be an integer");
        super(-1, property);
        /** The maximum span of the layout in bytes.
         *
         * Positive values are generally expected.  Zero is abnormal.
         * Attempts to encode or decode a value that exceeds this length
         * will throw a `RangeError`.
         *
         * A negative value indicates that there is no bound on the length
         * of the content. */ this.maxSpan = maxSpan;
    }
    /** @override */ getSpan(b, offset = 0) {
        $ab8b5713b1ee9109$var$checkUint8Array(b);
        return b.length - offset;
    }
    /** @override */ decode(b, offset = 0) {
        const span = this.getSpan(b, offset);
        if (0 <= this.maxSpan && this.maxSpan < span) throw new RangeError("text length exceeds maxSpan");
        return $ab8b5713b1ee9109$var$uint8ArrayToBuffer(b).slice(offset, offset + span).toString("utf-8");
    }
    /** @override */ encode(src, b, offset = 0) {
        /* Must force this to a string, lest it be a number and the
         * "utf8-encoding" below actually allocate a buffer of length
         * src */ if ("string" !== typeof src) src = String(src);
        const srcb = $9891c961abffc7d1$export$a143d493d941bafc.from(src, "utf8");
        const span = srcb.length;
        if (0 <= this.maxSpan && this.maxSpan < span) throw new RangeError("text length exceeds maxSpan");
        if (offset + span > b.length) throw new RangeError("encoding overruns Buffer");
        srcb.copy($ab8b5713b1ee9109$var$uint8ArrayToBuffer(b), offset);
        return span;
    }
}
$ab8b5713b1ee9109$exports.UTF8 = $ab8b5713b1ee9109$var$UTF8;
/**
 * Contain a constant value.
 *
 * This layout may be used in cases where a JavaScript value can be
 * inferred without an expression in the binary encoding.  An example
 * would be a {@link VariantLayout|variant layout} where the content
 * is implied by the union {@link Union#discriminator|discriminator}.
 *
 * @param {Object|Number|String} value - initializer for {@link
 * Constant#value|value}.  If the value is an object (or array) and
 * the application intends the object to remain unchanged regardless
 * of what is done to values decoded by this layout, the value should
 * be frozen prior passing it to this constructor.
 *
 * @param {String} [property] - initializer for {@link
 * Layout#property|property}.
 *
 * @augments {Layout}
 */ class $ab8b5713b1ee9109$var$Constant extends $ab8b5713b1ee9109$var$Layout {
    constructor(value, property){
        super(0, property);
        /** The value produced by this constant when the layout is {@link
         * Constant#decode|decoded}.
         *
         * Any JavaScript value including `null` and `undefined` is
         * permitted.
         *
         * **WARNING** If `value` passed in the constructor was not
         * frozen, it is possible for users of decoded values to change
         * the content of the value. */ this.value = value;
    }
    /** @override */ decode(b, offset) {
        return this.value;
    }
    /** @override */ encode(src, b, offset) {
        /* Constants take no space */ return 0;
    }
}
$ab8b5713b1ee9109$exports.Constant = $ab8b5713b1ee9109$var$Constant;
/** Factory for {@link GreedyCount}. */ $ab8b5713b1ee9109$exports.greedy = (elementSpan, property)=>new $ab8b5713b1ee9109$var$GreedyCount(elementSpan, property);
/** Factory for {@link OffsetLayout}. */ $ab8b5713b1ee9109$exports.offset = (layout, offset, property)=>new $ab8b5713b1ee9109$var$OffsetLayout(layout, offset, property);
/** Factory for {@link UInt|unsigned int layouts} spanning one
 * byte. */ $ab8b5713b1ee9109$exports.u8 = (property)=>new $ab8b5713b1ee9109$var$UInt(1, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning two bytes. */ $ab8b5713b1ee9109$exports.u16 = (property)=>new $ab8b5713b1ee9109$var$UInt(2, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning three bytes. */ $ab8b5713b1ee9109$exports.u24 = (property)=>new $ab8b5713b1ee9109$var$UInt(3, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning four bytes. */ $ab8b5713b1ee9109$exports.u32 = (property)=>new $ab8b5713b1ee9109$var$UInt(4, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning five bytes. */ $ab8b5713b1ee9109$exports.u40 = (property)=>new $ab8b5713b1ee9109$var$UInt(5, property);
/** Factory for {@link UInt|little-endian unsigned int layouts}
 * spanning six bytes. */ $ab8b5713b1ee9109$exports.u48 = (property)=>new $ab8b5713b1ee9109$var$UInt(6, property);
/** Factory for {@link NearUInt64|little-endian unsigned int
 * layouts} interpreted as Numbers. */ $ab8b5713b1ee9109$exports.nu64 = (property)=>new $ab8b5713b1ee9109$var$NearUInt64(property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning two bytes. */ $ab8b5713b1ee9109$exports.u16be = (property)=>new $ab8b5713b1ee9109$var$UIntBE(2, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning three bytes. */ $ab8b5713b1ee9109$exports.u24be = (property)=>new $ab8b5713b1ee9109$var$UIntBE(3, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning four bytes. */ $ab8b5713b1ee9109$exports.u32be = (property)=>new $ab8b5713b1ee9109$var$UIntBE(4, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning five bytes. */ $ab8b5713b1ee9109$exports.u40be = (property)=>new $ab8b5713b1ee9109$var$UIntBE(5, property);
/** Factory for {@link UInt|big-endian unsigned int layouts}
 * spanning six bytes. */ $ab8b5713b1ee9109$exports.u48be = (property)=>new $ab8b5713b1ee9109$var$UIntBE(6, property);
/** Factory for {@link NearUInt64BE|big-endian unsigned int
 * layouts} interpreted as Numbers. */ $ab8b5713b1ee9109$exports.nu64be = (property)=>new $ab8b5713b1ee9109$var$NearUInt64BE(property);
/** Factory for {@link Int|signed int layouts} spanning one
 * byte. */ $ab8b5713b1ee9109$exports.s8 = (property)=>new $ab8b5713b1ee9109$var$Int(1, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning two bytes. */ $ab8b5713b1ee9109$exports.s16 = (property)=>new $ab8b5713b1ee9109$var$Int(2, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning three bytes. */ $ab8b5713b1ee9109$exports.s24 = (property)=>new $ab8b5713b1ee9109$var$Int(3, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning four bytes. */ $ab8b5713b1ee9109$exports.s32 = (property)=>new $ab8b5713b1ee9109$var$Int(4, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning five bytes. */ $ab8b5713b1ee9109$exports.s40 = (property)=>new $ab8b5713b1ee9109$var$Int(5, property);
/** Factory for {@link Int|little-endian signed int layouts}
 * spanning six bytes. */ $ab8b5713b1ee9109$exports.s48 = (property)=>new $ab8b5713b1ee9109$var$Int(6, property);
/** Factory for {@link NearInt64|little-endian signed int layouts}
 * interpreted as Numbers. */ $ab8b5713b1ee9109$exports.ns64 = (property)=>new $ab8b5713b1ee9109$var$NearInt64(property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning two bytes. */ $ab8b5713b1ee9109$exports.s16be = (property)=>new $ab8b5713b1ee9109$var$IntBE(2, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning three bytes. */ $ab8b5713b1ee9109$exports.s24be = (property)=>new $ab8b5713b1ee9109$var$IntBE(3, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning four bytes. */ $ab8b5713b1ee9109$exports.s32be = (property)=>new $ab8b5713b1ee9109$var$IntBE(4, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning five bytes. */ $ab8b5713b1ee9109$exports.s40be = (property)=>new $ab8b5713b1ee9109$var$IntBE(5, property);
/** Factory for {@link Int|big-endian signed int layouts}
 * spanning six bytes. */ $ab8b5713b1ee9109$exports.s48be = (property)=>new $ab8b5713b1ee9109$var$IntBE(6, property);
/** Factory for {@link NearInt64BE|big-endian signed int layouts}
 * interpreted as Numbers. */ $ab8b5713b1ee9109$exports.ns64be = (property)=>new $ab8b5713b1ee9109$var$NearInt64BE(property);
/** Factory for {@link Float|little-endian 32-bit floating point} values. */ $ab8b5713b1ee9109$exports.f32 = (property)=>new $ab8b5713b1ee9109$var$Float(property);
/** Factory for {@link FloatBE|big-endian 32-bit floating point} values. */ $ab8b5713b1ee9109$exports.f32be = (property)=>new $ab8b5713b1ee9109$var$FloatBE(property);
/** Factory for {@link Double|little-endian 64-bit floating point} values. */ $ab8b5713b1ee9109$exports.f64 = (property)=>new $ab8b5713b1ee9109$var$Double(property);
/** Factory for {@link DoubleBE|big-endian 64-bit floating point} values. */ $ab8b5713b1ee9109$exports.f64be = (property)=>new $ab8b5713b1ee9109$var$DoubleBE(property);
/** Factory for {@link Structure} values. */ $ab8b5713b1ee9109$exports.struct = (fields, property, decodePrefixes)=>new $ab8b5713b1ee9109$var$Structure(fields, property, decodePrefixes);
/** Factory for {@link BitStructure} values. */ $ab8b5713b1ee9109$exports.bits = (word, msb, property)=>new $ab8b5713b1ee9109$var$BitStructure(word, msb, property);
/** Factory for {@link Sequence} values. */ $ab8b5713b1ee9109$exports.seq = (elementLayout, count, property)=>new $ab8b5713b1ee9109$var$Sequence(elementLayout, count, property);
/** Factory for {@link Union} values. */ $ab8b5713b1ee9109$exports.union = (discr, defaultLayout, property)=>new $ab8b5713b1ee9109$var$Union(discr, defaultLayout, property);
/** Factory for {@link UnionLayoutDiscriminator} values. */ $ab8b5713b1ee9109$exports.unionLayoutDiscriminator = (layout, property)=>new $ab8b5713b1ee9109$var$UnionLayoutDiscriminator(layout, property);
/** Factory for {@link Blob} values. */ $ab8b5713b1ee9109$exports.blob = (length, property)=>new $ab8b5713b1ee9109$var$Blob(length, property);
/** Factory for {@link CString} values. */ $ab8b5713b1ee9109$exports.cstr = (property)=>new $ab8b5713b1ee9109$var$CString(property);
/** Factory for {@link UTF8} values. */ $ab8b5713b1ee9109$exports.utf8 = (maxSpan, property)=>new $ab8b5713b1ee9109$var$UTF8(maxSpan, property);
/** Factory for {@link Constant} values. */ $ab8b5713b1ee9109$exports.constant = (value, property)=>new $ab8b5713b1ee9109$var$Constant(value, property);


var $681a4aa191fca251$exports = {};

var $N0o3H = parcelRequire("N0o3H");
var $681a4aa191fca251$require$Buffer = $N0o3H.Buffer;
"use strict";
Object.defineProperty($681a4aa191fca251$exports, "__esModule", {
    value: true
});
let $681a4aa191fca251$var$converter;
/**
 * Convert a little-endian buffer into a BigInt.
 * @param buf The little-endian buffer to convert
 * @returns A BigInt with the little-endian representation of buf.
 */ function $681a4aa191fca251$var$toBigIntLE(buf) {
    {
        const reversed = $681a4aa191fca251$require$Buffer.from(buf);
        reversed.reverse();
        const hex = reversed.toString("hex");
        if (hex.length === 0) return BigInt(0);
        return BigInt(`0x${hex}`);
    }
    return $681a4aa191fca251$var$converter.toBigInt(buf, false);
}
$681a4aa191fca251$exports.toBigIntLE = $681a4aa191fca251$var$toBigIntLE;
/**
 * Convert a big-endian buffer into a BigInt
 * @param buf The big-endian buffer to convert.
 * @returns A BigInt with the big-endian representation of buf.
 */ function $681a4aa191fca251$var$toBigIntBE(buf) {
    {
        const hex = buf.toString("hex");
        if (hex.length === 0) return BigInt(0);
        return BigInt(`0x${hex}`);
    }
    return $681a4aa191fca251$var$converter.toBigInt(buf, true);
}
$681a4aa191fca251$exports.toBigIntBE = $681a4aa191fca251$var$toBigIntBE;
/**
 * Convert a BigInt to a little-endian buffer.
 * @param num   The BigInt to convert.
 * @param width The number of bytes that the resulting buffer should be.
 * @returns A little-endian buffer representation of num.
 */ function $681a4aa191fca251$var$toBufferLE(num, width) {
    {
        const hex = num.toString(16);
        const buffer = $681a4aa191fca251$require$Buffer.from(hex.padStart(width * 2, "0").slice(0, width * 2), "hex");
        buffer.reverse();
        return buffer;
    }
    // Allocation is done here, since it is slower using napi in C
    return $681a4aa191fca251$var$converter.fromBigInt(num, $681a4aa191fca251$require$Buffer.allocUnsafe(width), false);
}
$681a4aa191fca251$exports.toBufferLE = $681a4aa191fca251$var$toBufferLE;
/**
 * Convert a BigInt to a big-endian buffer.
 * @param num   The BigInt to convert.
 * @param width The number of bytes that the resulting buffer should be.
 * @returns A big-endian buffer representation of num.
 */ function $681a4aa191fca251$var$toBufferBE(num, width) {
    {
        const hex = num.toString(16);
        return $681a4aa191fca251$require$Buffer.from(hex.padStart(width * 2, "0").slice(0, width * 2), "hex");
    }
    return $681a4aa191fca251$var$converter.fromBigInt(num, $681a4aa191fca251$require$Buffer.allocUnsafe(width), true);
}
$681a4aa191fca251$exports.toBufferBE = $681a4aa191fca251$var$toBufferBE;


/**
 * A `StructFailure` represents a single specific failure in validation.
 */ /**
 * `StructError` objects are thrown (or returned) when validation fails.
 *
 * Validation logic is design to exit early for maximum performance. The error
 * represents the first error encountered during validation. For more detail,
 * the `error.failures` property is a generator function that can be run to
 * continue validation and receive all the failures in the data.
 */ class $c32abee974e85639$export$58cc9131e3e8861b extends TypeError {
    constructor(failure, failures){
        let cached;
        const { message: message, explanation: explanation, ...rest } = failure;
        const { path: path } = failure;
        const msg = path.length === 0 ? message : `At path: ${path.join(".")} -- ${message}`;
        super(explanation ?? msg);
        if (explanation != null) this.cause = msg;
        Object.assign(this, rest);
        this.name = this.constructor.name;
        this.failures = ()=>{
            return cached ?? (cached = [
                failure,
                ...failures()
            ]);
        };
    }
}
/**
 * Check if a value is an iterator.
 */ function $c32abee974e85639$var$isIterable(x) {
    return $c32abee974e85639$var$isObject(x) && typeof x[Symbol.iterator] === "function";
}
/**
 * Check if a value is a plain object.
 */ function $c32abee974e85639$var$isObject(x) {
    return typeof x === "object" && x != null;
}
/**
 * Check if a value is a non-array object.
 */ function $c32abee974e85639$var$isNonArrayObject(x) {
    return $c32abee974e85639$var$isObject(x) && !Array.isArray(x);
}
/**
 * Check if a value is a plain object.
 */ function $c32abee974e85639$var$isPlainObject(x) {
    if (Object.prototype.toString.call(x) !== "[object Object]") return false;
    const prototype = Object.getPrototypeOf(x);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Return a value as a printable string.
 */ function $c32abee974e85639$var$print(value) {
    if (typeof value === "symbol") return value.toString();
    return typeof value === "string" ? JSON.stringify(value) : `${value}`;
}
/**
 * Shifts (removes and returns) the first value from the `input` iterator.
 * Like `Array.prototype.shift()` but for an `Iterator`.
 */ function $c32abee974e85639$var$shiftIterator(input) {
    const { done: done, value: value } = input.next();
    return done ? undefined : value;
}
/**
 * Convert a single validation result to a failure.
 */ function $c32abee974e85639$var$toFailure(result, context, struct, value) {
    if (result === true) return;
    else if (result === false) result = {};
    else if (typeof result === "string") result = {
        message: result
    };
    const { path: path, branch: branch } = context;
    const { type: type } = struct;
    const { refinement: refinement, message: message = `Expected a value of type \`${type}\`${refinement ? ` with refinement \`${refinement}\`` : ""}, but received: \`${$c32abee974e85639$var$print(value)}\`` } = result;
    return {
        value: value,
        type: type,
        refinement: refinement,
        key: path[path.length - 1],
        path: path,
        branch: branch,
        ...result,
        message: message
    };
}
/**
 * Convert a validation result to an iterable of failures.
 */ function* $c32abee974e85639$var$toFailures(result, context, struct, value) {
    if (!$c32abee974e85639$var$isIterable(result)) result = [
        result
    ];
    for (const r of result){
        const failure = $c32abee974e85639$var$toFailure(r, context, struct, value);
        if (failure) yield failure;
    }
}
/**
 * Check a value against a struct, traversing deeply into nested values, and
 * returning an iterator of failures or success.
 */ function* $c32abee974e85639$var$run(value, struct, options = {}) {
    const { path: path = [], branch: branch = [
        value
    ], coerce: coerce = false, mask: mask = false } = options;
    const ctx = {
        path: path,
        branch: branch,
        mask: mask
    };
    if (coerce) value = struct.coercer(value, ctx);
    let status = "valid";
    for (const failure of struct.validator(value, ctx)){
        failure.explanation = options.message;
        status = "not_valid";
        yield [
            failure,
            undefined
        ];
    }
    for (let [k, v, s] of struct.entries(value, ctx)){
        const ts = $c32abee974e85639$var$run(v, s, {
            path: k === undefined ? path : [
                ...path,
                k
            ],
            branch: k === undefined ? branch : [
                ...branch,
                v
            ],
            coerce: coerce,
            mask: mask,
            message: options.message
        });
        for (const t of ts){
            if (t[0]) {
                status = t[0].refinement != null ? "not_refined" : "not_valid";
                yield [
                    t[0],
                    undefined
                ];
            } else if (coerce) {
                v = t[1];
                if (k === undefined) value = v;
                else if (value instanceof Map) value.set(k, v);
                else if (value instanceof Set) value.add(v);
                else if ($c32abee974e85639$var$isObject(value)) {
                    if (v !== undefined || k in value) value[k] = v;
                }
            }
        }
    }
    if (status !== "not_valid") for (const failure of struct.refiner(value, ctx)){
        failure.explanation = options.message;
        status = "not_refined";
        yield [
            failure,
            undefined
        ];
    }
    if (status === "valid") yield [
        undefined,
        value
    ];
}
/**
 * `Struct` objects encapsulate the validation logic for a specific type of
 * values. Once constructed, you use the `assert`, `is` or `validate` helpers to
 * validate unknown input data against the struct.
 */ class $c32abee974e85639$export$eabc71f011df675a {
    constructor(props){
        const { type: type, schema: schema, validator: validator, refiner: refiner, coercer: coercer = (value)=>value, entries: entries = function*() {} } = props;
        this.type = type;
        this.schema = schema;
        this.entries = entries;
        this.coercer = coercer;
        if (validator) this.validator = (value, context)=>{
            const result = validator(value, context);
            return $c32abee974e85639$var$toFailures(result, context, this, value);
        };
        else this.validator = ()=>[];
        if (refiner) this.refiner = (value, context)=>{
            const result = refiner(value, context);
            return $c32abee974e85639$var$toFailures(result, context, this, value);
        };
        else this.refiner = ()=>[];
    }
    /**
     * Assert that a value passes the struct's validation, throwing if it doesn't.
     */ assert(value, message) {
        return $c32abee974e85639$export$a7a9523472993e97(value, this, message);
    }
    /**
     * Create a value with the struct's coercion logic, then validate it.
     */ create(value, message) {
        return $c32abee974e85639$export$185802fd694ee1f5(value, this, message);
    }
    /**
     * Check if a value passes the struct's validation.
     */ is(value) {
        return $c32abee974e85639$export$226b3eccf92c9ed9(value, this);
    }
    /**
     * Mask a value, coercing and validating it, but returning only the subset of
     * properties defined by the struct's schema. Masking applies recursively to
     * props of `object` structs only.
     */ mask(value, message) {
        return $c32abee974e85639$export$d99f0801a68bbcf1(value, this, message);
    }
    /**
     * Validate a value with the struct's validation logic, returning a tuple
     * representing the result.
     *
     * You may optionally pass `true` for the `coerce` argument to coerce
     * the value before attempting to validate it. If you do, the result will
     * contain the coerced result when successful. Also, `mask` will turn on
     * masking of the unknown `object` props recursively if passed.
     */ validate(value, options = {}) {
        return $c32abee974e85639$export$a22775fa5e2eebd9(value, this, options);
    }
}
/**
 * Assert that a value passes a struct, throwing if it doesn't.
 */ function $c32abee974e85639$export$a7a9523472993e97(value, struct, message) {
    const result = $c32abee974e85639$export$a22775fa5e2eebd9(value, struct, {
        message: message
    });
    if (result[0]) throw result[0];
}
/**
 * Create a value with the coercion logic of struct and validate it.
 */ function $c32abee974e85639$export$185802fd694ee1f5(value, struct, message) {
    const result = $c32abee974e85639$export$a22775fa5e2eebd9(value, struct, {
        coerce: true,
        message: message
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Mask a value, returning only the subset of properties defined by a struct.
 */ function $c32abee974e85639$export$d99f0801a68bbcf1(value, struct, message) {
    const result = $c32abee974e85639$export$a22775fa5e2eebd9(value, struct, {
        coerce: true,
        mask: true,
        message: message
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Check if a value passes a struct.
 */ function $c32abee974e85639$export$226b3eccf92c9ed9(value, struct) {
    const result = $c32abee974e85639$export$a22775fa5e2eebd9(value, struct);
    return !result[0];
}
/**
 * Validate a value against a struct, returning an error if invalid, or the
 * value (with potential coercion) if valid.
 */ function $c32abee974e85639$export$a22775fa5e2eebd9(value, struct, options = {}) {
    const tuples = $c32abee974e85639$var$run(value, struct, options);
    const tuple = $c32abee974e85639$var$shiftIterator(tuples);
    if (tuple[0]) {
        const error = new $c32abee974e85639$export$58cc9131e3e8861b(tuple[0], function*() {
            for (const t of tuples)if (t[0]) yield t[0];
        });
        return [
            error,
            undefined
        ];
    } else {
        const v = tuple[1];
        return [
            undefined,
            v
        ];
    }
}
function $c32abee974e85639$export$e6e34fd1f2686227(...Structs) {
    const isType = Structs[0].type === "type";
    const schemas = Structs.map((s)=>s.schema);
    const schema = Object.assign({}, ...schemas);
    return isType ? $c32abee974e85639$export$bf9fb029d174d554(schema) : $c32abee974e85639$export$be5493f9613cbbe(schema);
}
/**
 * Define a new struct type with a custom validation function.
 */ function $c32abee974e85639$export$f36d6a7a5c09a23e(name, validator) {
    return new $c32abee974e85639$export$eabc71f011df675a({
        type: name,
        schema: null,
        validator: validator
    });
}
/**
 * Create a new struct based on an existing struct, but the value is allowed to
 * be `undefined`. `log` will be called if the value is not `undefined`.
 */ function $c32abee974e85639$export$cdd73fc4100a6ef4(struct, log) {
    return new $c32abee974e85639$export$eabc71f011df675a({
        ...struct,
        refiner: (value, ctx)=>value === undefined || struct.refiner(value, ctx),
        validator (value, ctx) {
            if (value === undefined) return true;
            else {
                log(value, ctx);
                return struct.validator(value, ctx);
            }
        }
    });
}
/**
 * Create a struct with dynamic validation logic.
 *
 * The callback will receive the value currently being validated, and must
 * return a struct object to validate it with. This can be useful to model
 * validation logic that changes based on its input.
 */ function $c32abee974e85639$export$7077912c31975674(fn) {
    return new $c32abee974e85639$export$eabc71f011df675a({
        type: "dynamic",
        schema: null,
        *entries (value, ctx) {
            const struct = fn(value, ctx);
            yield* struct.entries(value, ctx);
        },
        validator (value, ctx) {
            const struct = fn(value, ctx);
            return struct.validator(value, ctx);
        },
        coercer (value, ctx) {
            const struct = fn(value, ctx);
            return struct.coercer(value, ctx);
        },
        refiner (value, ctx) {
            const struct = fn(value, ctx);
            return struct.refiner(value, ctx);
        }
    });
}
/**
 * Create a struct with lazily evaluated validation logic.
 *
 * The first time validation is run with the struct, the callback will be called
 * and must return a struct object to use. This is useful for cases where you
 * want to have self-referential structs for nested data structures to avoid a
 * circular definition problem.
 */ function $c32abee974e85639$export$488013bae63b21da(fn) {
    let struct;
    return new $c32abee974e85639$export$eabc71f011df675a({
        type: "lazy",
        schema: null,
        *entries (value, ctx) {
            struct ?? (struct = fn());
            yield* struct.entries(value, ctx);
        },
        validator (value, ctx) {
            struct ?? (struct = fn());
            return struct.validator(value, ctx);
        },
        coercer (value, ctx) {
            struct ?? (struct = fn());
            return struct.coercer(value, ctx);
        },
        refiner (value, ctx) {
            struct ?? (struct = fn());
            return struct.refiner(value, ctx);
        }
    });
}
/**
 * Create a new struct based on an existing object struct, but excluding
 * specific properties.
 *
 * Like TypeScript's `Omit` utility.
 */ function $c32abee974e85639$export$30a06c8d3562193f(struct, keys) {
    const { schema: schema } = struct;
    const subschema = {
        ...schema
    };
    for (const key of keys)delete subschema[key];
    switch(struct.type){
        case "type":
            return $c32abee974e85639$export$bf9fb029d174d554(subschema);
        default:
            return $c32abee974e85639$export$be5493f9613cbbe(subschema);
    }
}
/**
 * Create a new struct based on an existing object struct, but with all of its
 * properties allowed to be `undefined`.
 *
 * Like TypeScript's `Partial` utility.
 */ function $c32abee974e85639$export$e45945969df8035a(struct) {
    const isStruct = struct instanceof $c32abee974e85639$export$eabc71f011df675a;
    const schema = isStruct ? {
        ...struct.schema
    } : {
        ...struct
    };
    for(const key in schema)schema[key] = $c32abee974e85639$export$516e28dec6a4b6d4(schema[key]);
    if (isStruct && struct.type === "type") return $c32abee974e85639$export$bf9fb029d174d554(schema);
    return $c32abee974e85639$export$be5493f9613cbbe(schema);
}
/**
 * Create a new struct based on an existing object struct, but only including
 * specific properties.
 *
 * Like TypeScript's `Pick` utility.
 */ function $c32abee974e85639$export$357523c63a2253b9(struct, keys) {
    const { schema: schema } = struct;
    const subschema = {};
    for (const key of keys)subschema[key] = schema[key];
    switch(struct.type){
        case "type":
            return $c32abee974e85639$export$bf9fb029d174d554(subschema);
        default:
            return $c32abee974e85639$export$be5493f9613cbbe(subschema);
    }
}
/**
 * Define a new struct type with a custom validation function.
 *
 * @deprecated This function has been renamed to `define`.
 */ function $c32abee974e85639$export$8cf3da7c1c9174ea(name, validator) {
    console.warn("superstruct@0.11 - The `struct` helper has been renamed to `define`.");
    return $c32abee974e85639$export$f36d6a7a5c09a23e(name, validator);
}
/**
 * Ensure that any value passes validation.
 */ function $c32abee974e85639$export$4154a199d7d90455() {
    return $c32abee974e85639$export$f36d6a7a5c09a23e("any", ()=>true);
}
function $c32abee974e85639$export$2f23118c22fb2630(Element) {
    return new $c32abee974e85639$export$eabc71f011df675a({
        type: "array",
        schema: Element,
        *entries (value) {
            if (Element && Array.isArray(value)) for (const [i, v] of value.entries())yield [
                i,
                v,
                Element
            ];
        },
        coercer (value) {
            return Array.isArray(value) ? value.slice() : value;
        },
        validator (value) {
            return Array.isArray(value) || `Expected an array value, but received: ${$c32abee974e85639$var$print(value)}`;
        }
    });
}
/**
 * Ensure that a value is a bigint.
 */ function $c32abee974e85639$export$a0f65b52274bcc00() {
    return $c32abee974e85639$export$f36d6a7a5c09a23e("bigint", (value)=>{
        return typeof value === "bigint";
    });
}
/**
 * Ensure that a value is a boolean.
 */ function $c32abee974e85639$export$4a21f16c33752377() {
    return $c32abee974e85639$export$f36d6a7a5c09a23e("boolean", (value)=>{
        return typeof value === "boolean";
    });
}
/**
 * Ensure that a value is a valid `Date`.
 *
 * Note: this also ensures that the value is *not* an invalid `Date` object,
 * which can occur when parsing a date fails but still returns a `Date`.
 */ function $c32abee974e85639$export$324d90190a8b822a() {
    return $c32abee974e85639$export$f36d6a7a5c09a23e("date", (value)=>{
        return value instanceof Date && !isNaN(value.getTime()) || `Expected a valid \`Date\` object, but received: ${$c32abee974e85639$var$print(value)}`;
    });
}
function $c32abee974e85639$export$9b16c434df8cc259(values) {
    const schema = {};
    const description = values.map((v)=>$c32abee974e85639$var$print(v)).join();
    for (const key of values)schema[key] = key;
    return new $c32abee974e85639$export$eabc71f011df675a({
        type: "enums",
        schema: schema,
        validator (value) {
            return values.includes(value) || `Expected one of \`${description}\`, but received: ${$c32abee974e85639$var$print(value)}`;
        }
    });
}
/**
 * Ensure that a value is a function.
 */ function $c32abee974e85639$export$86951950244e2001() {
    return $c32abee974e85639$export$f36d6a7a5c09a23e("func", (value)=>{
        return typeof value === "function" || `Expected a function, but received: ${$c32abee974e85639$var$print(value)}`;
    });
}
/**
 * Ensure that a value is an instance of a specific class.
 */ function $c32abee974e85639$export$9544d5bb712b01ea(Class) {
    return $c32abee974e85639$export$f36d6a7a5c09a23e("instance", (value)=>{
        return value instanceof Class || `Expected a \`${Class.name}\` instance, but received: ${$c32abee974e85639$var$print(value)}`;
    });
}
/**
 * Ensure that a value is an integer.
 */ function $c32abee974e85639$export$32744b5b3bba4764() {
    return $c32abee974e85639$export$f36d6a7a5c09a23e("integer", (value)=>{
        return typeof value === "number" && !isNaN(value) && Number.isInteger(value) || `Expected an integer, but received: ${$c32abee974e85639$var$print(value)}`;
    });
}
/**
 * Ensure that a value matches all of a set of types.
 */ function $c32abee974e85639$export$bc86dfbf7795668c(Structs) {
    return new $c32abee974e85639$export$eabc71f011df675a({
        type: "intersection",
        schema: null,
        *entries (value, ctx) {
            for (const S of Structs)yield* S.entries(value, ctx);
        },
        *validator (value, ctx) {
            for (const S of Structs)yield* S.validator(value, ctx);
        },
        *refiner (value, ctx) {
            for (const S of Structs)yield* S.refiner(value, ctx);
        }
    });
}
function $c32abee974e85639$export$c8ec6e1ec9fefcb0(constant) {
    const description = $c32abee974e85639$var$print(constant);
    const t = typeof constant;
    return new $c32abee974e85639$export$eabc71f011df675a({
        type: "literal",
        schema: t === "string" || t === "number" || t === "boolean" ? constant : null,
        validator (value) {
            return value === constant || `Expected the literal \`${description}\`, but received: ${$c32abee974e85639$var$print(value)}`;
        }
    });
}
function $c32abee974e85639$export$871de8747c9eaa88(Key, Value) {
    return new $c32abee974e85639$export$eabc71f011df675a({
        type: "map",
        schema: null,
        *entries (value) {
            if (Key && Value && value instanceof Map) for (const [k, v] of value.entries()){
                yield [
                    k,
                    k,
                    Key
                ];
                yield [
                    k,
                    v,
                    Value
                ];
            }
        },
        coercer (value) {
            return value instanceof Map ? new Map(value) : value;
        },
        validator (value) {
            return value instanceof Map || `Expected a \`Map\` object, but received: ${$c32abee974e85639$var$print(value)}`;
        }
    });
}
/**
 * Ensure that no value ever passes validation.
 */ function $c32abee974e85639$export$b3e22bcfd64c1022() {
    return $c32abee974e85639$export$f36d6a7a5c09a23e("never", ()=>false);
}
/**
 * Augment an existing struct to allow `null` values.
 */ function $c32abee974e85639$export$133fc36489ac9add(struct) {
    return new $c32abee974e85639$export$eabc71f011df675a({
        ...struct,
        validator: (value, ctx)=>value === null || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === null || struct.refiner(value, ctx)
    });
}
/**
 * Ensure that a value is a number.
 */ function $c32abee974e85639$export$98e628dec113755e() {
    return $c32abee974e85639$export$f36d6a7a5c09a23e("number", (value)=>{
        return typeof value === "number" && !isNaN(value) || `Expected a number, but received: ${$c32abee974e85639$var$print(value)}`;
    });
}
function $c32abee974e85639$export$be5493f9613cbbe(schema) {
    const knowns = schema ? Object.keys(schema) : [];
    const Never = $c32abee974e85639$export$b3e22bcfd64c1022();
    return new $c32abee974e85639$export$eabc71f011df675a({
        type: "object",
        schema: schema ? schema : null,
        *entries (value) {
            if (schema && $c32abee974e85639$var$isObject(value)) {
                const unknowns = new Set(Object.keys(value));
                for (const key of knowns){
                    unknowns.delete(key);
                    yield [
                        key,
                        value[key],
                        schema[key]
                    ];
                }
                for (const key of unknowns)yield [
                    key,
                    value[key],
                    Never
                ];
            }
        },
        validator (value) {
            return $c32abee974e85639$var$isNonArrayObject(value) || `Expected an object, but received: ${$c32abee974e85639$var$print(value)}`;
        },
        coercer (value, ctx) {
            if (!$c32abee974e85639$var$isNonArrayObject(value)) return value;
            const coerced = {
                ...value
            };
            // The `object` struct has special behaviour enabled by the mask flag.
            // When masking, properties that are not in the schema are deleted from
            // the coerced object instead of eventually failing validaiton.
            if (ctx.mask && schema) {
                for(const key in coerced)if (schema[key] === undefined) delete coerced[key];
            }
            return coerced;
        }
    });
}
/**
 * Augment a struct to allow `undefined` values.
 */ function $c32abee974e85639$export$516e28dec6a4b6d4(struct) {
    return new $c32abee974e85639$export$eabc71f011df675a({
        ...struct,
        validator: (value, ctx)=>value === undefined || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === undefined || struct.refiner(value, ctx)
    });
}
/**
 * Ensure that a value is an object with keys and values of specific types, but
 * without ensuring any specific shape of properties.
 *
 * Like TypeScript's `Record` utility.
 */ function $c32abee974e85639$export$e5185e241753e543(Key, Value) {
    return new $c32abee974e85639$export$eabc71f011df675a({
        type: "record",
        schema: null,
        *entries (value) {
            if ($c32abee974e85639$var$isObject(value)) for(const k in value){
                const v = value[k];
                yield [
                    k,
                    k,
                    Key
                ];
                yield [
                    k,
                    v,
                    Value
                ];
            }
        },
        validator (value) {
            return $c32abee974e85639$var$isNonArrayObject(value) || `Expected an object, but received: ${$c32abee974e85639$var$print(value)}`;
        },
        coercer (value) {
            return $c32abee974e85639$var$isNonArrayObject(value) ? {
                ...value
            } : value;
        }
    });
}
/**
 * Ensure that a value is a `RegExp`.
 *
 * Note: this does not test the value against the regular expression! For that
 * you need to use the `pattern()` refinement.
 */ function $c32abee974e85639$export$efdc1e5bdb609bb() {
    return $c32abee974e85639$export$f36d6a7a5c09a23e("regexp", (value)=>{
        return value instanceof RegExp;
    });
}
function $c32abee974e85639$export$adaa4cf7ef1b65be(Element) {
    return new $c32abee974e85639$export$eabc71f011df675a({
        type: "set",
        schema: null,
        *entries (value) {
            if (Element && value instanceof Set) for (const v of value)yield [
                v,
                v,
                Element
            ];
        },
        coercer (value) {
            return value instanceof Set ? new Set(value) : value;
        },
        validator (value) {
            return value instanceof Set || `Expected a \`Set\` object, but received: ${$c32abee974e85639$var$print(value)}`;
        }
    });
}
/**
 * Ensure that a value is a string.
 */ function $c32abee974e85639$export$22b082955e083ec3() {
    return $c32abee974e85639$export$f36d6a7a5c09a23e("string", (value)=>{
        return typeof value === "string" || `Expected a string, but received: ${$c32abee974e85639$var$print(value)}`;
    });
}
/**
 * Ensure that a value is a tuple of a specific length, and that each of its
 * elements is of a specific type.
 */ function $c32abee974e85639$export$65e3907585753458(Structs) {
    const Never = $c32abee974e85639$export$b3e22bcfd64c1022();
    return new $c32abee974e85639$export$eabc71f011df675a({
        type: "tuple",
        schema: null,
        *entries (value) {
            if (Array.isArray(value)) {
                const length = Math.max(Structs.length, value.length);
                for(let i = 0; i < length; i++)yield [
                    i,
                    value[i],
                    Structs[i] || Never
                ];
            }
        },
        validator (value) {
            return Array.isArray(value) || `Expected an array, but received: ${$c32abee974e85639$var$print(value)}`;
        },
        coercer (value) {
            return Array.isArray(value) ? value.slice() : value;
        }
    });
}
/**
 * Ensure that a value has a set of known properties of specific types.
 *
 * Note: Unrecognized properties are allowed and untouched. This is similar to
 * how TypeScript's structural typing works.
 */ function $c32abee974e85639$export$bf9fb029d174d554(schema) {
    const keys = Object.keys(schema);
    return new $c32abee974e85639$export$eabc71f011df675a({
        type: "type",
        schema: schema,
        *entries (value) {
            if ($c32abee974e85639$var$isObject(value)) for (const k of keys)yield [
                k,
                value[k],
                schema[k]
            ];
        },
        validator (value) {
            return $c32abee974e85639$var$isNonArrayObject(value) || `Expected an object, but received: ${$c32abee974e85639$var$print(value)}`;
        },
        coercer (value) {
            return $c32abee974e85639$var$isNonArrayObject(value) ? {
                ...value
            } : value;
        }
    });
}
/**
 * Ensure that a value matches one of a set of types.
 */ function $c32abee974e85639$export$971dd5b0dfd021b6(Structs) {
    const description = Structs.map((s)=>s.type).join(" | ");
    return new $c32abee974e85639$export$eabc71f011df675a({
        type: "union",
        schema: null,
        coercer (value, ctx) {
            for (const S of Structs){
                const [error, coerced] = S.validate(value, {
                    coerce: true,
                    mask: ctx.mask
                });
                if (!error) return coerced;
            }
            return value;
        },
        validator (value, ctx) {
            const failures = [];
            for (const S of Structs){
                const [...tuples] = $c32abee974e85639$var$run(value, S, ctx);
                const [first] = tuples;
                if (!first[0]) return [];
                else {
                    for (const [failure] of tuples)if (failure) failures.push(failure);
                }
            }
            return [
                `Expected the value to satisfy a union of \`${description}\`, but received: ${$c32abee974e85639$var$print(value)}`,
                ...failures
            ];
        }
    });
}
/**
 * Ensure that any value passes validation, without widening its type to `any`.
 */ function $c32abee974e85639$export$19282c40b967aec6() {
    return $c32abee974e85639$export$f36d6a7a5c09a23e("unknown", ()=>true);
}
/**
 * Augment a `Struct` to add an additional coercion step to its input.
 *
 * This allows you to transform input data before validating it, to increase the
 * likelihood that it passes validation—for example for default values, parsing
 * different formats, etc.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $c32abee974e85639$export$8c14e57e778d3873(struct, condition, coercer) {
    return new $c32abee974e85639$export$eabc71f011df675a({
        ...struct,
        coercer: (value, ctx)=>{
            return $c32abee974e85639$export$226b3eccf92c9ed9(value, condition) ? struct.coercer(coercer(value, ctx), ctx) : struct.coercer(value, ctx);
        }
    });
}
/**
 * Augment a struct to replace `undefined` values with a default.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $c32abee974e85639$export$83c510c4356017ae(struct, fallback, options = {}) {
    return $c32abee974e85639$export$8c14e57e778d3873(struct, $c32abee974e85639$export$19282c40b967aec6(), (x)=>{
        const f = typeof fallback === "function" ? fallback() : fallback;
        if (x === undefined) return f;
        if (!options.strict && $c32abee974e85639$var$isPlainObject(x) && $c32abee974e85639$var$isPlainObject(f)) {
            const ret = {
                ...x
            };
            let changed = false;
            for(const key in f)if (ret[key] === undefined) {
                ret[key] = f[key];
                changed = true;
            }
            if (changed) return ret;
        }
        return x;
    });
}
/**
 * Augment a struct to trim string inputs.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $c32abee974e85639$export$41f369984ed28930(struct) {
    return $c32abee974e85639$export$8c14e57e778d3873(struct, $c32abee974e85639$export$22b082955e083ec3(), (x)=>x.trim());
}
/**
 * Ensure that a string, array, map, or set is empty.
 */ function $c32abee974e85639$export$6e22c362a0406a2c(struct) {
    return $c32abee974e85639$export$edc9d475108b3212(struct, "empty", (value)=>{
        const size = $c32abee974e85639$var$getSize(value);
        return size === 0 || `Expected an empty ${struct.type} but received one with a size of \`${size}\``;
    });
}
function $c32abee974e85639$var$getSize(value) {
    if (value instanceof Map || value instanceof Set) return value.size;
    else return value.length;
}
/**
 * Ensure that a number or date is below a threshold.
 */ function $c32abee974e85639$export$8960430cfd85939f(struct, threshold, options = {}) {
    const { exclusive: exclusive } = options;
    return $c32abee974e85639$export$edc9d475108b3212(struct, "max", (value)=>{
        return exclusive ? value < threshold : value <= threshold || `Expected a ${struct.type} less than ${exclusive ? "" : "or equal to "}${threshold} but received \`${value}\``;
    });
}
/**
 * Ensure that a number or date is above a threshold.
 */ function $c32abee974e85639$export$96ec731ed4dcb222(struct, threshold, options = {}) {
    const { exclusive: exclusive } = options;
    return $c32abee974e85639$export$edc9d475108b3212(struct, "min", (value)=>{
        return exclusive ? value > threshold : value >= threshold || `Expected a ${struct.type} greater than ${exclusive ? "" : "or equal to "}${threshold} but received \`${value}\``;
    });
}
/**
 * Ensure that a string, array, map or set is not empty.
 */ function $c32abee974e85639$export$6ce6c9218151d511(struct) {
    return $c32abee974e85639$export$edc9d475108b3212(struct, "nonempty", (value)=>{
        const size = $c32abee974e85639$var$getSize(value);
        return size > 0 || `Expected a nonempty ${struct.type} but received an empty one`;
    });
}
/**
 * Ensure that a string matches a regular expression.
 */ function $c32abee974e85639$export$24f82734ea047e6f(struct, regexp) {
    return $c32abee974e85639$export$edc9d475108b3212(struct, "pattern", (value)=>{
        return regexp.test(value) || `Expected a ${struct.type} matching \`/${regexp.source}/\` but received "${value}"`;
    });
}
/**
 * Ensure that a string, array, number, date, map, or set has a size (or length, or time) between `min` and `max`.
 */ function $c32abee974e85639$export$346677f925de839c(struct, min, max = min) {
    const expected = `Expected a ${struct.type}`;
    const of = min === max ? `of \`${min}\`` : `between \`${min}\` and \`${max}\``;
    return $c32abee974e85639$export$edc9d475108b3212(struct, "size", (value)=>{
        if (typeof value === "number" || value instanceof Date) return min <= value && value <= max || `${expected} ${of} but received \`${value}\``;
        else if (value instanceof Map || value instanceof Set) {
            const { size: size } = value;
            return min <= size && size <= max || `${expected} with a size ${of} but received one with a size of \`${size}\``;
        } else {
            const { length: length } = value;
            return min <= length && length <= max || `${expected} with a length ${of} but received one with a length of \`${length}\``;
        }
    });
}
/**
 * Augment a `Struct` to add an additional refinement to the validation.
 *
 * The refiner function is guaranteed to receive a value of the struct's type,
 * because the struct's existing validation will already have passed. This
 * allows you to layer additional validation on top of existing structs.
 */ function $c32abee974e85639$export$edc9d475108b3212(struct, name, refiner) {
    return new $c32abee974e85639$export$eabc71f011df675a({
        ...struct,
        *refiner (value, ctx) {
            yield* struct.refiner(value, ctx);
            const result = refiner(value, ctx);
            const failures = $c32abee974e85639$var$toFailures(result, ctx, struct, value);
            for (const failure of failures)yield {
                ...failure,
                refinement: name
            };
        }
    });
}


var $b293ddc10e8e03aa$exports = {};
"use strict";
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $d0da4566d2fd20fe$var$getRandomValues;
var $d0da4566d2fd20fe$var$rnds8 = new Uint8Array(16);
function $d0da4566d2fd20fe$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$d0da4566d2fd20fe$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $d0da4566d2fd20fe$var$getRandomValues = typeof crypto !== "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== "undefined" && typeof msCrypto.getRandomValues === "function" && msCrypto.getRandomValues.bind(msCrypto);
        if (!$d0da4566d2fd20fe$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    }
    return $d0da4566d2fd20fe$var$getRandomValues($d0da4566d2fd20fe$var$rnds8);
}


var $e8c673fd2604883f$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;


function $7d240e1718cbe118$var$validate(uuid) {
    return typeof uuid === "string" && (0, $e8c673fd2604883f$export$2e2bcd8739ae039).test(uuid);
}
var $7d240e1718cbe118$export$2e2bcd8739ae039 = $7d240e1718cbe118$var$validate;


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $8fb7ad22aed8f433$var$byteToHex = [];
for(var $8fb7ad22aed8f433$var$i = 0; $8fb7ad22aed8f433$var$i < 256; ++$8fb7ad22aed8f433$var$i)$8fb7ad22aed8f433$var$byteToHex.push(($8fb7ad22aed8f433$var$i + 0x100).toString(16).substr(1));
function $8fb7ad22aed8f433$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($8fb7ad22aed8f433$var$byteToHex[arr[offset + 0]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 1]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 2]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 3]] + "-" + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 4]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 5]] + "-" + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 6]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 7]] + "-" + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 8]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 9]] + "-" + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 10]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 11]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 12]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 13]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 14]] + $8fb7ad22aed8f433$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $7d240e1718cbe118$export$2e2bcd8739ae039)(uuid)) throw TypeError("Stringified UUID is invalid");
    return uuid;
}
var $8fb7ad22aed8f433$export$2e2bcd8739ae039 = $8fb7ad22aed8f433$var$stringify;


function $27d7069422be255c$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $d0da4566d2fd20fe$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $8fb7ad22aed8f433$export$2e2bcd8739ae039)(rnds);
}
var $27d7069422be255c$export$2e2bcd8739ae039 = $27d7069422be255c$var$v4;


var $b293ddc10e8e03aa$require$uuid = $27d7069422be255c$export$2e2bcd8739ae039;
var $7e905770d133e905$exports = {};
"use strict";

var $7e905770d133e905$require$uuid = $27d7069422be255c$export$2e2bcd8739ae039;
/**
 *  Generates a JSON-RPC 1.0 or 2.0 request
 *  @param {String} method Name of method to call
 *  @param {Array|Object} params Array of parameters passed to the method as specified, or an object of parameter names and corresponding value
 *  @param {String|Number|null} [id] Request ID can be a string, number, null for explicit notification or left out for automatic generation
 *  @param {Object} [options]
 *  @param {Number} [options.version=2] JSON-RPC version to use (1 or 2)
 *  @param {Boolean} [options.notificationIdNull=false] When true, version 2 requests will set id to null instead of omitting it
 *  @param {Function} [options.generator] Passed the request, and the options object and is expected to return a request ID
 *  @throws {TypeError} If any of the parameters are invalid
 *  @return {Object} A JSON-RPC 1.0 or 2.0 request
 *  @memberOf Utils
 */ const $7e905770d133e905$var$generateRequest = function(method, params, id, options) {
    if (typeof method !== "string") throw new TypeError(method + " must be a string");
    options = options || {};
    // check valid version provided
    const version = typeof options.version === "number" ? options.version : 2;
    if (version !== 1 && version !== 2) throw new TypeError(version + " must be 1 or 2");
    const request = {
        method: method
    };
    if (version === 2) request.jsonrpc = "2.0";
    if (params) {
        // params given, but invalid?
        if (typeof params !== "object" && !Array.isArray(params)) throw new TypeError(params + " must be an object, array or omitted");
        request.params = params;
    }
    // if id was left out, generate one (null means explicit notification)
    if (typeof id === "undefined") {
        const generator = typeof options.generator === "function" ? options.generator : function() {
            return $7e905770d133e905$require$uuid();
        };
        request.id = generator(request, options);
    } else if (version === 2 && id === null) // we have a version 2 notification
    {
        if (options.notificationIdNull) request.id = null; // id will not be set at all unless option provided
    } else request.id = id;
    return request;
};
$7e905770d133e905$exports = $7e905770d133e905$var$generateRequest;


/**
 * Constructor for a Jayson Browser Client that does not depend any node.js core libraries
 * @class ClientBrowser
 * @param {Function} callServer Method that calls the server, receives the stringified request and a regular node-style callback
 * @param {Object} [options]
 * @param {Function} [options.reviver] Reviver function for JSON
 * @param {Function} [options.replacer] Replacer function for JSON
 * @param {Number} [options.version=2] JSON-RPC version to use (1|2)
 * @param {Function} [options.generator] Function to use for generating request IDs
 *  @param {Boolean} [options.notificationIdNull=false] When true, version 2 requests will set id to null instead of omitting it
 * @return {ClientBrowser}
 */ const $b293ddc10e8e03aa$var$ClientBrowser = function(callServer, options) {
    if (!(this instanceof $b293ddc10e8e03aa$var$ClientBrowser)) return new $b293ddc10e8e03aa$var$ClientBrowser(callServer, options);
    if (!options) options = {};
    this.options = {
        reviver: typeof options.reviver !== "undefined" ? options.reviver : null,
        replacer: typeof options.replacer !== "undefined" ? options.replacer : null,
        generator: typeof options.generator !== "undefined" ? options.generator : function() {
            return $b293ddc10e8e03aa$require$uuid();
        },
        version: typeof options.version !== "undefined" ? options.version : 2,
        notificationIdNull: typeof options.notificationIdNull === "boolean" ? options.notificationIdNull : false
    };
    this.callServer = callServer;
};
$b293ddc10e8e03aa$exports = $b293ddc10e8e03aa$var$ClientBrowser;
/**
 *  Creates a request and dispatches it if given a callback.
 *  @param {String|Array} method A batch request if passed an Array, or a method name if passed a String
 *  @param {Array|Object} [params] Parameters for the method
 *  @param {String|Number} [id] Optional id. If undefined an id will be generated. If null it creates a notification request
 *  @param {Function} [callback] Request callback. If specified, executes the request rather than only returning it.
 *  @throws {TypeError} Invalid parameters
 *  @return {Object} JSON-RPC 1.0 or 2.0 compatible request
 */ $b293ddc10e8e03aa$var$ClientBrowser.prototype.request = function(method, params, id, callback) {
    const self = this;
    let request = null;
    // is this a batch request?
    const isBatch = Array.isArray(method) && typeof params === "function";
    if (this.options.version === 1 && isBatch) throw new TypeError("JSON-RPC 1.0 does not support batching");
    // is this a raw request?
    const isRaw = !isBatch && method && typeof method === "object" && typeof params === "function";
    if (isBatch || isRaw) {
        callback = params;
        request = method;
    } else {
        if (typeof id === "function") {
            callback = id;
            // specifically undefined because "null" is a notification request
            id = undefined;
        }
        const hasCallback = typeof callback === "function";
        try {
            request = $7e905770d133e905$exports(method, params, id, {
                generator: this.options.generator,
                version: this.options.version,
                notificationIdNull: this.options.notificationIdNull
            });
        } catch (err) {
            if (hasCallback) return callback(err);
            throw err;
        }
        // no callback means we should just return a raw request
        if (!hasCallback) return request;
    }
    let message;
    try {
        message = JSON.stringify(request, this.options.replacer);
    } catch (err) {
        return callback(err);
    }
    this.callServer(message, function(err, response) {
        self._parseResponse(err, response, callback);
    });
    // always return the raw request
    return request;
};
/**
 * Parses a response from a server
 * @param {Object} err Error to pass on that is unrelated to the actual response
 * @param {String} responseText JSON-RPC 1.0 or 2.0 response
 * @param {Function} callback Callback that will receive different arguments depending on the amount of parameters
 * @private
 */ $b293ddc10e8e03aa$var$ClientBrowser.prototype._parseResponse = function(err, responseText, callback) {
    if (err) {
        callback(err);
        return;
    }
    if (!responseText) // empty response text, assume that is correct because it could be a
    // notification which jayson does not give any body for
    return callback();
    let response;
    try {
        response = JSON.parse(responseText, this.options.reviver);
    } catch (err) {
        return callback(err);
    }
    if (callback.length === 3) {
        // if callback length is 3, we split callback arguments on error and response
        // is batch response?
        if (Array.isArray(response)) {
            // neccesary to split strictly on validity according to spec here
            const isError = function(res) {
                return typeof res.error !== "undefined";
            };
            const isNotError = function(res) {
                return !isError(res);
            };
            return callback(null, response.filter(isError), response.filter(isNotError));
        } else // split regardless of validity
        return callback(null, response.error, response.result);
    }
    callback(null, response);
};


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $a716231d9f1dcabd$export$a143d493d941bafc;
var $a716231d9f1dcabd$export$e4cf37d7f6fb9e0a;
var $a716231d9f1dcabd$export$f99ded8fe4b79145;
var $a716231d9f1dcabd$export$599f31c3813fae4d;
"use strict";

var $bQMRt = parcelRequire("bQMRt");

var $dbnIE = parcelRequire("dbnIE");
const $a716231d9f1dcabd$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$a716231d9f1dcabd$export$a143d493d941bafc = $a716231d9f1dcabd$var$Buffer;
$a716231d9f1dcabd$export$e4cf37d7f6fb9e0a = $a716231d9f1dcabd$var$SlowBuffer;
$a716231d9f1dcabd$export$f99ded8fe4b79145 = 50;
const $a716231d9f1dcabd$var$K_MAX_LENGTH = 0x7fffffff;
$a716231d9f1dcabd$export$599f31c3813fae4d = $a716231d9f1dcabd$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $a716231d9f1dcabd$var$Buffer.TYPED_ARRAY_SUPPORT = $a716231d9f1dcabd$var$typedArraySupport();
if (!$a716231d9f1dcabd$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $a716231d9f1dcabd$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($a716231d9f1dcabd$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$a716231d9f1dcabd$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($a716231d9f1dcabd$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$a716231d9f1dcabd$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $a716231d9f1dcabd$var$createBuffer(length) {
    if (length > $a716231d9f1dcabd$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $a716231d9f1dcabd$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $a716231d9f1dcabd$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $a716231d9f1dcabd$var$allocUnsafe(arg);
    }
    return $a716231d9f1dcabd$var$from(arg, encodingOrOffset, length);
}
$a716231d9f1dcabd$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $a716231d9f1dcabd$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $a716231d9f1dcabd$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $a716231d9f1dcabd$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($a716231d9f1dcabd$var$isInstance(value, ArrayBuffer) || value && $a716231d9f1dcabd$var$isInstance(value.buffer, ArrayBuffer)) return $a716231d9f1dcabd$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($a716231d9f1dcabd$var$isInstance(value, SharedArrayBuffer) || value && $a716231d9f1dcabd$var$isInstance(value.buffer, SharedArrayBuffer))) return $a716231d9f1dcabd$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $a716231d9f1dcabd$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $a716231d9f1dcabd$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $a716231d9f1dcabd$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $a716231d9f1dcabd$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $a716231d9f1dcabd$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($a716231d9f1dcabd$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($a716231d9f1dcabd$var$Buffer, Uint8Array);
function $a716231d9f1dcabd$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $a716231d9f1dcabd$var$alloc(size, fill, encoding) {
    $a716231d9f1dcabd$var$assertSize(size);
    if (size <= 0) return $a716231d9f1dcabd$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $a716231d9f1dcabd$var$createBuffer(size).fill(fill, encoding) : $a716231d9f1dcabd$var$createBuffer(size).fill(fill);
    return $a716231d9f1dcabd$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $a716231d9f1dcabd$var$Buffer.alloc = function(size, fill, encoding) {
    return $a716231d9f1dcabd$var$alloc(size, fill, encoding);
};
function $a716231d9f1dcabd$var$allocUnsafe(size) {
    $a716231d9f1dcabd$var$assertSize(size);
    return $a716231d9f1dcabd$var$createBuffer(size < 0 ? 0 : $a716231d9f1dcabd$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $a716231d9f1dcabd$var$Buffer.allocUnsafe = function(size) {
    return $a716231d9f1dcabd$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $a716231d9f1dcabd$var$Buffer.allocUnsafeSlow = function(size) {
    return $a716231d9f1dcabd$var$allocUnsafe(size);
};
function $a716231d9f1dcabd$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$a716231d9f1dcabd$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $a716231d9f1dcabd$var$byteLength(string, encoding) | 0;
    let buf = $a716231d9f1dcabd$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $a716231d9f1dcabd$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $a716231d9f1dcabd$var$checked(array.length) | 0;
    const buf = $a716231d9f1dcabd$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $a716231d9f1dcabd$var$fromArrayView(arrayView) {
    if ($a716231d9f1dcabd$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $a716231d9f1dcabd$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $a716231d9f1dcabd$var$fromArrayLike(arrayView);
}
function $a716231d9f1dcabd$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $a716231d9f1dcabd$var$Buffer.prototype);
    return buf;
}
function $a716231d9f1dcabd$var$fromObject(obj) {
    if ($a716231d9f1dcabd$var$Buffer.isBuffer(obj)) {
        const len = $a716231d9f1dcabd$var$checked(obj.length) | 0;
        const buf = $a716231d9f1dcabd$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $a716231d9f1dcabd$var$numberIsNaN(obj.length)) return $a716231d9f1dcabd$var$createBuffer(0);
        return $a716231d9f1dcabd$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $a716231d9f1dcabd$var$fromArrayLike(obj.data);
}
function $a716231d9f1dcabd$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $a716231d9f1dcabd$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $a716231d9f1dcabd$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $a716231d9f1dcabd$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $a716231d9f1dcabd$var$Buffer.alloc(+length);
}
$a716231d9f1dcabd$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $a716231d9f1dcabd$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$a716231d9f1dcabd$var$Buffer.compare = function compare(a, b) {
    if ($a716231d9f1dcabd$var$isInstance(a, Uint8Array)) a = $a716231d9f1dcabd$var$Buffer.from(a, a.offset, a.byteLength);
    if ($a716231d9f1dcabd$var$isInstance(b, Uint8Array)) b = $a716231d9f1dcabd$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$a716231d9f1dcabd$var$Buffer.isBuffer(a) || !$a716231d9f1dcabd$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$a716231d9f1dcabd$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$a716231d9f1dcabd$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $a716231d9f1dcabd$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $a716231d9f1dcabd$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($a716231d9f1dcabd$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$a716231d9f1dcabd$var$Buffer.isBuffer(buf)) buf = $a716231d9f1dcabd$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$a716231d9f1dcabd$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $a716231d9f1dcabd$var$byteLength(string, encoding) {
    if ($a716231d9f1dcabd$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $a716231d9f1dcabd$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $a716231d9f1dcabd$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $a716231d9f1dcabd$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $a716231d9f1dcabd$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$a716231d9f1dcabd$var$Buffer.byteLength = $a716231d9f1dcabd$var$byteLength;
function $a716231d9f1dcabd$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $a716231d9f1dcabd$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $a716231d9f1dcabd$var$utf8Slice(this, start, end);
        case "ascii":
            return $a716231d9f1dcabd$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $a716231d9f1dcabd$var$latin1Slice(this, start, end);
        case "base64":
            return $a716231d9f1dcabd$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $a716231d9f1dcabd$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$a716231d9f1dcabd$var$Buffer.prototype._isBuffer = true;
function $a716231d9f1dcabd$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$a716231d9f1dcabd$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$a716231d9f1dcabd$var$swap(this, i, i + 1);
    return this;
};
$a716231d9f1dcabd$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $a716231d9f1dcabd$var$swap(this, i, i + 3);
        $a716231d9f1dcabd$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$a716231d9f1dcabd$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $a716231d9f1dcabd$var$swap(this, i, i + 7);
        $a716231d9f1dcabd$var$swap(this, i + 1, i + 6);
        $a716231d9f1dcabd$var$swap(this, i + 2, i + 5);
        $a716231d9f1dcabd$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$a716231d9f1dcabd$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $a716231d9f1dcabd$var$utf8Slice(this, 0, length);
    return $a716231d9f1dcabd$var$slowToString.apply(this, arguments);
};
$a716231d9f1dcabd$var$Buffer.prototype.toLocaleString = $a716231d9f1dcabd$var$Buffer.prototype.toString;
$a716231d9f1dcabd$var$Buffer.prototype.equals = function equals(b) {
    if (!$a716231d9f1dcabd$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $a716231d9f1dcabd$var$Buffer.compare(this, b) === 0;
};
$a716231d9f1dcabd$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $a716231d9f1dcabd$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($a716231d9f1dcabd$var$customInspectSymbol) $a716231d9f1dcabd$var$Buffer.prototype[$a716231d9f1dcabd$var$customInspectSymbol] = $a716231d9f1dcabd$var$Buffer.prototype.inspect;
$a716231d9f1dcabd$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($a716231d9f1dcabd$var$isInstance(target, Uint8Array)) target = $a716231d9f1dcabd$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$a716231d9f1dcabd$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $a716231d9f1dcabd$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($a716231d9f1dcabd$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $a716231d9f1dcabd$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($a716231d9f1dcabd$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $a716231d9f1dcabd$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $a716231d9f1dcabd$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $a716231d9f1dcabd$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$a716231d9f1dcabd$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$a716231d9f1dcabd$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $a716231d9f1dcabd$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$a716231d9f1dcabd$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $a716231d9f1dcabd$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $a716231d9f1dcabd$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($a716231d9f1dcabd$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $a716231d9f1dcabd$var$utf8Write(buf, string, offset, length) {
    return $a716231d9f1dcabd$var$blitBuffer($a716231d9f1dcabd$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $a716231d9f1dcabd$var$asciiWrite(buf, string, offset, length) {
    return $a716231d9f1dcabd$var$blitBuffer($a716231d9f1dcabd$var$asciiToBytes(string), buf, offset, length);
}
function $a716231d9f1dcabd$var$base64Write(buf, string, offset, length) {
    return $a716231d9f1dcabd$var$blitBuffer($a716231d9f1dcabd$var$base64ToBytes(string), buf, offset, length);
}
function $a716231d9f1dcabd$var$ucs2Write(buf, string, offset, length) {
    return $a716231d9f1dcabd$var$blitBuffer($a716231d9f1dcabd$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$a716231d9f1dcabd$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $a716231d9f1dcabd$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $a716231d9f1dcabd$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $a716231d9f1dcabd$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $a716231d9f1dcabd$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $a716231d9f1dcabd$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$a716231d9f1dcabd$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $a716231d9f1dcabd$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $bQMRt.fromByteArray(buf);
    else return $bQMRt.fromByteArray(buf.slice(start, end));
}
function $a716231d9f1dcabd$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $a716231d9f1dcabd$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $a716231d9f1dcabd$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $a716231d9f1dcabd$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $a716231d9f1dcabd$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $a716231d9f1dcabd$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $a716231d9f1dcabd$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $a716231d9f1dcabd$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $a716231d9f1dcabd$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $a716231d9f1dcabd$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $a716231d9f1dcabd$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$a716231d9f1dcabd$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $a716231d9f1dcabd$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $a716231d9f1dcabd$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$a716231d9f1dcabd$var$Buffer.prototype.readUintLE = $a716231d9f1dcabd$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a716231d9f1dcabd$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$a716231d9f1dcabd$var$Buffer.prototype.readUintBE = $a716231d9f1dcabd$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a716231d9f1dcabd$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$a716231d9f1dcabd$var$Buffer.prototype.readUint8 = $a716231d9f1dcabd$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a716231d9f1dcabd$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$a716231d9f1dcabd$var$Buffer.prototype.readUint16LE = $a716231d9f1dcabd$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a716231d9f1dcabd$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$a716231d9f1dcabd$var$Buffer.prototype.readUint16BE = $a716231d9f1dcabd$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a716231d9f1dcabd$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$a716231d9f1dcabd$var$Buffer.prototype.readUint32LE = $a716231d9f1dcabd$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a716231d9f1dcabd$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$a716231d9f1dcabd$var$Buffer.prototype.readUint32BE = $a716231d9f1dcabd$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a716231d9f1dcabd$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$a716231d9f1dcabd$var$Buffer.prototype.readBigUInt64LE = $a716231d9f1dcabd$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $a716231d9f1dcabd$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $a716231d9f1dcabd$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$a716231d9f1dcabd$var$Buffer.prototype.readBigUInt64BE = $a716231d9f1dcabd$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $a716231d9f1dcabd$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $a716231d9f1dcabd$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$a716231d9f1dcabd$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a716231d9f1dcabd$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$a716231d9f1dcabd$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $a716231d9f1dcabd$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$a716231d9f1dcabd$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a716231d9f1dcabd$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$a716231d9f1dcabd$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a716231d9f1dcabd$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$a716231d9f1dcabd$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a716231d9f1dcabd$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$a716231d9f1dcabd$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a716231d9f1dcabd$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$a716231d9f1dcabd$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a716231d9f1dcabd$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$a716231d9f1dcabd$var$Buffer.prototype.readBigInt64LE = $a716231d9f1dcabd$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $a716231d9f1dcabd$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $a716231d9f1dcabd$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$a716231d9f1dcabd$var$Buffer.prototype.readBigInt64BE = $a716231d9f1dcabd$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $a716231d9f1dcabd$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $a716231d9f1dcabd$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$a716231d9f1dcabd$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a716231d9f1dcabd$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, true, 23, 4);
};
$a716231d9f1dcabd$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a716231d9f1dcabd$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, false, 23, 4);
};
$a716231d9f1dcabd$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a716231d9f1dcabd$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, true, 52, 8);
};
$a716231d9f1dcabd$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $a716231d9f1dcabd$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, false, 52, 8);
};
function $a716231d9f1dcabd$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$a716231d9f1dcabd$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$a716231d9f1dcabd$var$Buffer.prototype.writeUintLE = $a716231d9f1dcabd$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $a716231d9f1dcabd$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$a716231d9f1dcabd$var$Buffer.prototype.writeUintBE = $a716231d9f1dcabd$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $a716231d9f1dcabd$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$a716231d9f1dcabd$var$Buffer.prototype.writeUint8 = $a716231d9f1dcabd$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a716231d9f1dcabd$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$a716231d9f1dcabd$var$Buffer.prototype.writeUint16LE = $a716231d9f1dcabd$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a716231d9f1dcabd$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$a716231d9f1dcabd$var$Buffer.prototype.writeUint16BE = $a716231d9f1dcabd$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a716231d9f1dcabd$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$a716231d9f1dcabd$var$Buffer.prototype.writeUint32LE = $a716231d9f1dcabd$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a716231d9f1dcabd$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$a716231d9f1dcabd$var$Buffer.prototype.writeUint32BE = $a716231d9f1dcabd$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a716231d9f1dcabd$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $a716231d9f1dcabd$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $a716231d9f1dcabd$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $a716231d9f1dcabd$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $a716231d9f1dcabd$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$a716231d9f1dcabd$var$Buffer.prototype.writeBigUInt64LE = $a716231d9f1dcabd$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $a716231d9f1dcabd$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$a716231d9f1dcabd$var$Buffer.prototype.writeBigUInt64BE = $a716231d9f1dcabd$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $a716231d9f1dcabd$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$a716231d9f1dcabd$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $a716231d9f1dcabd$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$a716231d9f1dcabd$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $a716231d9f1dcabd$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$a716231d9f1dcabd$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a716231d9f1dcabd$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$a716231d9f1dcabd$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a716231d9f1dcabd$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$a716231d9f1dcabd$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a716231d9f1dcabd$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$a716231d9f1dcabd$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a716231d9f1dcabd$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$a716231d9f1dcabd$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a716231d9f1dcabd$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$a716231d9f1dcabd$var$Buffer.prototype.writeBigInt64LE = $a716231d9f1dcabd$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $a716231d9f1dcabd$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$a716231d9f1dcabd$var$Buffer.prototype.writeBigInt64BE = $a716231d9f1dcabd$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $a716231d9f1dcabd$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $a716231d9f1dcabd$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $a716231d9f1dcabd$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a716231d9f1dcabd$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$a716231d9f1dcabd$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $a716231d9f1dcabd$var$writeFloat(this, value, offset, true, noAssert);
};
$a716231d9f1dcabd$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $a716231d9f1dcabd$var$writeFloat(this, value, offset, false, noAssert);
};
function $a716231d9f1dcabd$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $a716231d9f1dcabd$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$a716231d9f1dcabd$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $a716231d9f1dcabd$var$writeDouble(this, value, offset, true, noAssert);
};
$a716231d9f1dcabd$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $a716231d9f1dcabd$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$a716231d9f1dcabd$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$a716231d9f1dcabd$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$a716231d9f1dcabd$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$a716231d9f1dcabd$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $a716231d9f1dcabd$var$Buffer.isBuffer(val) ? val : $a716231d9f1dcabd$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $a716231d9f1dcabd$var$errors = {};
function $a716231d9f1dcabd$var$E(sym, getMessage, Base) {
    $a716231d9f1dcabd$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$a716231d9f1dcabd$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$a716231d9f1dcabd$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$a716231d9f1dcabd$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $a716231d9f1dcabd$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $a716231d9f1dcabd$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $a716231d9f1dcabd$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $a716231d9f1dcabd$var$checkBounds(buf, offset, byteLength) {
    $a716231d9f1dcabd$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $a716231d9f1dcabd$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $a716231d9f1dcabd$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $a716231d9f1dcabd$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $a716231d9f1dcabd$var$checkBounds(buf, offset, byteLength);
}
function $a716231d9f1dcabd$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $a716231d9f1dcabd$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $a716231d9f1dcabd$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $a716231d9f1dcabd$var$validateNumber(value, type);
        throw new $a716231d9f1dcabd$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $a716231d9f1dcabd$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $a716231d9f1dcabd$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $a716231d9f1dcabd$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $a716231d9f1dcabd$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($a716231d9f1dcabd$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $a716231d9f1dcabd$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $a716231d9f1dcabd$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $a716231d9f1dcabd$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $a716231d9f1dcabd$var$base64ToBytes(str) {
    return $bQMRt.toByteArray($a716231d9f1dcabd$var$base64clean(str));
}
function $a716231d9f1dcabd$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $a716231d9f1dcabd$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $a716231d9f1dcabd$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $a716231d9f1dcabd$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $a716231d9f1dcabd$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $a716231d9f1dcabd$var$BufferBigIntNotDefined : fn;
}
function $a716231d9f1dcabd$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}



var $hcgfX = parcelRequire("hcgfX");
// node_modules/esbuild-plugin-polyfill-node/polyfills/buffer.js
var $55b6c0896fbec178$var$WebSocketBrowserImpl = class extends (0, (/*@__PURE__*/$parcel$interopDefault($hcgfX))) {
    socket;
    /** Instantiate a WebSocket class
  * @constructor
  * @param {String} address - url to a websocket server
  * @param {(Object)} options - websocket options
  * @param {(String|Array)} protocols - a list of protocols
  * @return {WebSocketBrowserImpl} - returns a WebSocket instance
  */ constructor(address, options, protocols){
        super();
        this.socket = new window.WebSocket(address, protocols);
        this.socket.onopen = ()=>this.emit("open");
        this.socket.onmessage = (event)=>this.emit("message", event.data);
        this.socket.onerror = (error)=>this.emit("error", error);
        this.socket.onclose = (event)=>{
            this.emit("close", event.code, event.reason);
        };
    }
    /**
  * Sends data through a websocket connection
  * @method
  * @param {(String|Object)} data - data to be sent via websocket
  * @param {Object} optionsOrCallback - ws options
  * @param {Function} callback - a callback called once the data is sent
  * @return {Undefined}
  */ send(data, optionsOrCallback, callback) {
        const cb = callback || optionsOrCallback;
        try {
            this.socket.send(data);
            cb();
        } catch (error) {
            cb(error);
        }
    }
    /**
  * Closes an underlying socket
  * @method
  * @param {Number} code - status code explaining why the connection is being closed
  * @param {String} reason - a description why the connection is closing
  * @return {Undefined}
  * @throws {Error}
  */ close(code, reason) {
        this.socket.close(code, reason);
    }
    addEventListener(type, listener, options) {
        this.socket.addEventListener(type, listener, options);
    }
};
function $55b6c0896fbec178$export$3909fb301d3dc8c9(address, options) {
    return new $55b6c0896fbec178$var$WebSocketBrowserImpl(address, options);
}
// src/lib/utils.ts
var $55b6c0896fbec178$export$9fd32f4b4353d82d = class {
    encode(value) {
        return JSON.stringify(value);
    }
    decode(value) {
        return JSON.parse(value);
    }
};
// src/lib/client.ts
var $55b6c0896fbec178$export$b43a6d9568fa5272 = class extends (0, (/*@__PURE__*/$parcel$interopDefault($hcgfX))) {
    address;
    rpc_id;
    queue;
    options;
    autoconnect;
    ready;
    reconnect;
    reconnect_timer_id;
    reconnect_interval;
    max_reconnects;
    rest_options;
    current_reconnects;
    generate_request_id;
    socket;
    webSocketFactory;
    dataPack;
    /**
  * Instantiate a Client class.
  * @constructor
  * @param {webSocketFactory} webSocketFactory - factory method for WebSocket
  * @param {String} address - url to a websocket server
  * @param {Object} options - ws options object with reconnect parameters
  * @param {Function} generate_request_id - custom generation request Id
  * @param {DataPack} dataPack - data pack contains encoder and decoder
  * @return {CommonClient}
  */ constructor(webSocketFactory, address = "ws://localhost:8080", { autoconnect: autoconnect = true, reconnect: reconnect = true, reconnect_interval: reconnect_interval = 1e3, max_reconnects: max_reconnects = 5, ...rest_options } = {}, generate_request_id, dataPack){
        super();
        this.webSocketFactory = webSocketFactory;
        this.queue = {};
        this.rpc_id = 0;
        this.address = address;
        this.autoconnect = autoconnect;
        this.ready = false;
        this.reconnect = reconnect;
        this.reconnect_timer_id = void 0;
        this.reconnect_interval = reconnect_interval;
        this.max_reconnects = max_reconnects;
        this.rest_options = rest_options;
        this.current_reconnects = 0;
        this.generate_request_id = generate_request_id || (()=>++this.rpc_id);
        if (!dataPack) this.dataPack = new $55b6c0896fbec178$export$9fd32f4b4353d82d();
        else this.dataPack = dataPack;
        if (this.autoconnect) this._connect(this.address, {
            autoconnect: this.autoconnect,
            reconnect: this.reconnect,
            reconnect_interval: this.reconnect_interval,
            max_reconnects: this.max_reconnects,
            ...this.rest_options
        });
    }
    /**
  * Connects to a defined server if not connected already.
  * @method
  * @return {Undefined}
  */ connect() {
        if (this.socket) return;
        this._connect(this.address, {
            autoconnect: this.autoconnect,
            reconnect: this.reconnect,
            reconnect_interval: this.reconnect_interval,
            max_reconnects: this.max_reconnects,
            ...this.rest_options
        });
    }
    /**
  * Calls a registered RPC method on server.
  * @method
  * @param {String} method - RPC method name
  * @param {Object|Array} params - optional method parameters
  * @param {Number} timeout - RPC reply timeout value
  * @param {Object} ws_opts - options passed to ws
  * @return {Promise}
  */ call(method, params, timeout, ws_opts) {
        if (!ws_opts && "object" === typeof timeout) {
            ws_opts = timeout;
            timeout = null;
        }
        return new Promise((resolve, reject)=>{
            if (!this.ready) return reject(new Error("socket not ready"));
            const rpc_id = this.generate_request_id(method, params);
            const message = {
                jsonrpc: "2.0",
                method: method,
                params: params || void 0,
                id: rpc_id
            };
            this.socket.send(this.dataPack.encode(message), ws_opts, (error)=>{
                if (error) return reject(error);
                this.queue[rpc_id] = {
                    promise: [
                        resolve,
                        reject
                    ]
                };
                if (timeout) this.queue[rpc_id].timeout = setTimeout(()=>{
                    delete this.queue[rpc_id];
                    reject(new Error("reply timeout"));
                }, timeout);
            });
        });
    }
    /**
  * Logins with the other side of the connection.
  * @method
  * @param {Object} params - Login credentials object
  * @return {Promise}
  */ async login(params) {
        const resp = await this.call("rpc.login", params);
        if (!resp) throw new Error("authentication failed");
        return resp;
    }
    /**
  * Fetches a list of client's methods registered on server.
  * @method
  * @return {Array}
  */ async listMethods() {
        return await this.call("__listMethods");
    }
    /**
  * Sends a JSON-RPC 2.0 notification to server.
  * @method
  * @param {String} method - RPC method name
  * @param {Object} params - optional method parameters
  * @return {Promise}
  */ notify(method, params) {
        return new Promise((resolve, reject)=>{
            if (!this.ready) return reject(new Error("socket not ready"));
            const message = {
                jsonrpc: "2.0",
                method: method,
                params: params
            };
            this.socket.send(this.dataPack.encode(message), (error)=>{
                if (error) return reject(error);
                resolve();
            });
        });
    }
    /**
  * Subscribes for a defined event.
  * @method
  * @param {String|Array} event - event name
  * @return {Undefined}
  * @throws {Error}
  */ async subscribe(event) {
        if (typeof event === "string") event = [
            event
        ];
        const result = await this.call("rpc.on", event);
        if (typeof event === "string" && result[event] !== "ok") throw new Error("Failed subscribing to an event '" + event + "' with: " + result[event]);
        return result;
    }
    /**
  * Unsubscribes from a defined event.
  * @method
  * @param {String|Array} event - event name
  * @return {Undefined}
  * @throws {Error}
  */ async unsubscribe(event) {
        if (typeof event === "string") event = [
            event
        ];
        const result = await this.call("rpc.off", event);
        if (typeof event === "string" && result[event] !== "ok") throw new Error("Failed unsubscribing from an event with: " + result);
        return result;
    }
    /**
  * Closes a WebSocket connection gracefully.
  * @method
  * @param {Number} code - socket close code
  * @param {String} data - optional data to be sent before closing
  * @return {Undefined}
  */ close(code, data) {
        this.socket.close(code || 1e3, data);
    }
    /**
  * Enable / disable automatic reconnection.
  * @method
  * @param {Boolean} reconnect - enable / disable reconnection
  * @return {Undefined}
  */ setAutoReconnect(reconnect) {
        this.reconnect = reconnect;
    }
    /**
  * Set the interval between reconnection attempts.
  * @method
  * @param {Number} interval - reconnection interval in milliseconds
  * @return {Undefined}
  */ setReconnectInterval(interval) {
        this.reconnect_interval = interval;
    }
    /**
  * Set the maximum number of reconnection attempts.
  * @method
  * @param {Number} max_reconnects - maximum reconnection attempts
  * @return {Undefined}
  */ setMaxReconnects(max_reconnects) {
        this.max_reconnects = max_reconnects;
    }
    /**
  * Connection/Message handler.
  * @method
  * @private
  * @param {String} address - WebSocket API address
  * @param {Object} options - ws options object
  * @return {Undefined}
  */ _connect(address, options) {
        clearTimeout(this.reconnect_timer_id);
        this.socket = this.webSocketFactory(address, options);
        this.socket.addEventListener("open", ()=>{
            this.ready = true;
            this.emit("open");
            this.current_reconnects = 0;
        });
        this.socket.addEventListener("message", ({ data: message })=>{
            if (message instanceof ArrayBuffer) message = (0, $a716231d9f1dcabd$export$a143d493d941bafc).from(message).toString();
            try {
                message = this.dataPack.decode(message);
            } catch (error) {
                return;
            }
            if (message.notification && this.listeners(message.notification).length) {
                if (!Object.keys(message.params).length) return this.emit(message.notification);
                const args = [
                    message.notification
                ];
                if (message.params.constructor === Object) args.push(message.params);
                else for(let i = 0; i < message.params.length; i++)args.push(message.params[i]);
                return Promise.resolve().then(()=>{
                    this.emit.apply(this, args);
                });
            }
            if (!this.queue[message.id]) {
                if (message.method) return Promise.resolve().then(()=>{
                    this.emit(message.method, message?.params);
                });
                return;
            }
            if ("error" in message === "result" in message) this.queue[message.id].promise[1](new Error('Server response malformed. Response must include either "result" or "error", but not both.'));
            if (this.queue[message.id].timeout) clearTimeout(this.queue[message.id].timeout);
            if (message.error) this.queue[message.id].promise[1](message.error);
            else this.queue[message.id].promise[0](message.result);
            delete this.queue[message.id];
        });
        this.socket.addEventListener("error", (error)=>this.emit("error", error));
        this.socket.addEventListener("close", ({ code: code, reason: reason })=>{
            if (this.ready) setTimeout(()=>this.emit("close", code, reason), 0);
            this.ready = false;
            this.socket = void 0;
            if (code === 1e3) return;
            this.current_reconnects++;
            if (this.reconnect && (this.max_reconnects > this.current_reconnects || this.max_reconnects === 0)) this.reconnect_timer_id = setTimeout(()=>this._connect(address, options), this.reconnect_interval);
        });
    }
};
// src/index.browser.ts
var $55b6c0896fbec178$export$1f2bb630327ac4b6 = class extends $55b6c0896fbec178$export$b43a6d9568fa5272 {
    constructor(address = "ws://localhost:8080", { autoconnect: autoconnect = true, reconnect: reconnect = true, reconnect_interval: reconnect_interval = 1e3, max_reconnects: max_reconnects = 5 } = {}, generate_request_id){
        super($55b6c0896fbec178$export$3909fb301d3dc8c9, address, {
            autoconnect: autoconnect,
            reconnect: reconnect,
            reconnect_interval: reconnect_interval,
            max_reconnects: max_reconnects
        }, generate_request_id);
    }
};
 //# sourceMappingURL=out.js.map



var $hrc0B = parcelRequire("hrc0B");
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $jfkMZ = parcelRequire("jfkMZ");

var $5358X = parcelRequire("5358X");
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $h8PfB = parcelRequire("h8PfB");

var $5358X = parcelRequire("5358X");
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Short Weierstrass curve. The formula is: y² = x³ + ax + b

var $exvTT = parcelRequire("exvTT");

var $lzJFq = parcelRequire("lzJFq");

var $heHQ1 = parcelRequire("heHQ1");
function $6c95361b56c6c225$var$validateSigVerOpts(opts) {
    if (opts.lowS !== undefined) (0, $heHQ1.abool)("lowS", opts.lowS);
    if (opts.prehash !== undefined) (0, $heHQ1.abool)("prehash", opts.prehash);
}
function $6c95361b56c6c225$var$validatePointOpts(curve) {
    const opts = (0, $exvTT.validateBasic)(curve);
    $heHQ1.validateObject(opts, {
        a: "field",
        b: "field"
    }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
    });
    const { endo: endo, Fp: Fp, a: a } = opts;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
        if (typeof endo !== "object" || typeof endo.beta !== "bigint" || typeof endo.splitScalar !== "function") throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
    }
    return Object.freeze({
        ...opts
    });
}
// ASN.1 DER encoding utilities
const { bytesToNumberBE: $6c95361b56c6c225$var$b2n, hexToBytes: $6c95361b56c6c225$var$h2b } = $heHQ1;
const $6c95361b56c6c225$export$56ac33195d7076db = {
    // asn.1 DER encoding utils
    Err: class DERErr extends Error {
        constructor(m = ""){
            super(m);
        }
    },
    _parseInt (data) {
        const { Err: E } = $6c95361b56c6c225$export$56ac33195d7076db;
        if (data.length < 2 || data[0] !== 0x02) throw new E("Invalid signature integer tag");
        const len = data[1];
        const res = data.subarray(2, len + 2);
        if (!len || res.length !== len) throw new E("Invalid signature integer: wrong length");
        // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
        // since we always use positive integers here. It must always be empty:
        // - add zero byte if exists
        // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
        if (res[0] & 128) throw new E("Invalid signature integer: negative");
        if (res[0] === 0x00 && !(res[1] & 128)) throw new E("Invalid signature integer: unnecessary leading zero");
        return {
            d: $6c95361b56c6c225$var$b2n(res),
            l: data.subarray(len + 2)
        }; // d is data, l is left
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E } = $6c95361b56c6c225$export$56ac33195d7076db;
        const data = typeof hex === "string" ? $6c95361b56c6c225$var$h2b(hex) : hex;
        $heHQ1.abytes(data);
        let l = data.length;
        if (l < 2 || data[0] != 0x30) throw new E("Invalid signature tag");
        if (data[1] !== l - 2) throw new E("Invalid signature: incorrect length");
        const { d: r, l: sBytes } = $6c95361b56c6c225$export$56ac33195d7076db._parseInt(data.subarray(2));
        const { d: s, l: rBytesLeft } = $6c95361b56c6c225$export$56ac33195d7076db._parseInt(sBytes);
        if (rBytesLeft.length) throw new E("Invalid signature: left bytes after parsing");
        return {
            r: r,
            s: s
        };
    },
    hexFromSig (sig) {
        // Add leading zero if first byte has negative bit enabled. More details in '_parseInt'
        const slice = (s)=>Number.parseInt(s[0], 16) & 8 ? "00" + s : s;
        const h = (num)=>{
            const hex = num.toString(16);
            return hex.length & 1 ? `0${hex}` : hex;
        };
        const s = slice(h(sig.s));
        const r = slice(h(sig.r));
        const shl = s.length / 2;
        const rhl = r.length / 2;
        const sl = h(shl);
        const rl = h(rhl);
        return `30${h(rhl + shl + 4)}02${rl}${r}02${sl}${s}`;
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $6c95361b56c6c225$var$_0n = BigInt(0), $6c95361b56c6c225$var$_1n = BigInt(1), $6c95361b56c6c225$var$_2n = BigInt(2), $6c95361b56c6c225$var$_3n = BigInt(3), $6c95361b56c6c225$var$_4n = BigInt(4);
function $6c95361b56c6c225$export$fa783af82e4fe0fc(opts) {
    const CURVE = $6c95361b56c6c225$var$validatePointOpts(opts);
    const { Fp: Fp } = CURVE; // All curves has same field / group length as for now, but they can differ
    const toBytes = CURVE.toBytes || ((_c, point, _isCompressed)=>{
        const a = point.toAffine();
        return $heHQ1.concatBytes(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes)=>{
        // const head = bytes[0];
        const tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x: x,
            y: y
        };
    });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */ function weierstrassEquation(x) {
        const { a: a, b: b } = CURVE;
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error("bad generator point: equation left != right");
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return $heHQ1.inRange(num, $6c95361b56c6c225$var$_1n, CURVE.n);
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength: nByteLength, wrapPrivateKey: wrapPrivateKey, n: N } = CURVE;
        if (lengths && typeof key !== "bigint") {
            if ($heHQ1.isBytes(key)) key = $heHQ1.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== "string" || !lengths.includes(key.length)) throw new Error("Invalid key");
            key = key.padStart(nByteLength * 2, "0");
        }
        let num;
        try {
            num = typeof key === "bigint" ? key : $heHQ1.bytesToNumberBE((0, $heHQ1.ensureBytes)("private key", key, nByteLength));
        } catch (error) {
            throw new Error(`private key must be ${nByteLength} bytes, hex or bigint, not ${typeof key}`);
        }
        if (wrapPrivateKey) num = $lzJFq.mod(num, N); // disabled by default, enabled for BLS
        $heHQ1.aInRange("private key", num, $6c95361b56c6c225$var$_1n, N); // num in range [1..N-1]
        return num;
    }
    function assertPrjPoint(other) {
        if (!(other instanceof Point)) throw new Error("ProjectivePoint expected");
    }
    // Memoized toAffine / validity check. They are heavy. Points are immutable.
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    const toAffineMemo = (0, $heHQ1.memoized)((p, iz)=>{
        const { px: x, py: y, pz: z } = p;
        // Fast-path for normalized points
        if (Fp.eql(z, Fp.ONE)) return {
            x: x,
            y: y
        };
        const is0 = p.is0();
        // If invZ was 0, we return zero point. However we still want to execute
        // all operations, so we replace invZ with a random number, 1.
        if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
        const ax = Fp.mul(x, iz);
        const ay = Fp.mul(y, iz);
        const zz = Fp.mul(z, iz);
        if (is0) return {
            x: Fp.ZERO,
            y: Fp.ZERO
        };
        if (!Fp.eql(zz, Fp.ONE)) throw new Error("invZ was invalid");
        return {
            x: ax,
            y: ay
        };
    });
    // NOTE: on exception this will crash 'cached' and no value will be set.
    // Otherwise true will be return
    const assertValidMemo = (0, $heHQ1.memoized)((p)=>{
        if (p.is0()) {
            // (0, 1, 0) aka ZERO is invalid in most contexts.
            // In BLS, ZERO can be serialized, so we allow it.
            // (0, 0, 0) is wrong representation of ZERO and is always invalid.
            if (CURVE.allowInfinityPoint && !Fp.is0(p.py)) return;
            throw new Error("bad point: ZERO");
        }
        // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
        const { x: x, y: y } = p.toAffine();
        // Check if x, y are valid field elements
        if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error("bad point: x or y not FE");
        const left = Fp.sqr(y); // y²
        const right = weierstrassEquation(x); // x³ + ax + b
        if (!Fp.eql(left, right)) throw new Error("bad point: equation left != right");
        if (!p.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
        return true;
    });
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        constructor(px, py, pz){
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px)) throw new Error("x required");
            if (py == null || !Fp.isValid(py)) throw new Error("y required");
            if (pz == null || !Fp.isValid(pz)) throw new Error("z required");
            Object.freeze(this);
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x: x, y: y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error("invalid affine point");
            if (p instanceof Point) throw new Error("projective point not allowed");
            const is0 = (i)=>Fp.eql(i, Fp.ZERO);
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.pz));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ static fromHex(hex) {
            const P = Point.fromAffine(fromBytes((0, $heHQ1.ensureBytes)("pointHex", hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            wnaf.setWindowSize(this, windowSize);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            assertValidMemo(this);
        }
        hasEvenY() {
            const { y: y } = this.toAffine();
            if (Fp.isOdd) return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */ equals(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ negate() {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a: a, b: b } = CURVE;
            const b3 = Fp.mul(b, $6c95361b56c6c225$var$_3n);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, $6c95361b56c6c225$var$_3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, n, Point.normalizeZ);
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(sc) {
            $heHQ1.aInRange("scalar", sc, $6c95361b56c6c225$var$_0n, CURVE.n);
            const I = Point.ZERO;
            if (sc === $6c95361b56c6c225$var$_0n) return I;
            if (sc === $6c95361b56c6c225$var$_1n) return this;
            const { endo: endo } = CURVE;
            if (!endo) return wnaf.unsafeLadder(this, sc);
            // Apply endomorphism
            let { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(sc);
            let k1p = I;
            let k2p = I;
            let d = this;
            while(k1 > $6c95361b56c6c225$var$_0n || k2 > $6c95361b56c6c225$var$_0n){
                if (k1 & $6c95361b56c6c225$var$_1n) k1p = k1p.add(d);
                if (k2 & $6c95361b56c6c225$var$_1n) k2p = k2p.add(d);
                d = d.double();
                k1 >>= $6c95361b56c6c225$var$_1n;
                k2 >>= $6c95361b56c6c225$var$_1n;
            }
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            const { endo: endo, n: N } = CURVE;
            $heHQ1.aInRange("scalar", scalar, $6c95361b56c6c225$var$_1n, N);
            let point, fake; // Fake point is used to const-time mult
            if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(scalar);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            } else {
                const { p: p, f: f } = this.wNAF(scalar);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([
                point,
                fake
            ])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ multiplyAndAddUnsafe(Q, a, b) {
            const G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            const mul = (P, a // Select faster multiply() method
            )=>a === $6c95361b56c6c225$var$_0n || a === $6c95361b56c6c225$var$_1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            return toAffineMemo(this, iz);
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree: isTorsionFree } = CURVE;
            if (cofactor === $6c95361b56c6c225$var$_1n) return true; // No subgroups, always torsion-free
            if (isTorsionFree) return isTorsionFree(Point, this);
            throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor: clearCofactor } = CURVE;
            if (cofactor === $6c95361b56c6c225$var$_1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            (0, $heHQ1.abool)("isCompressed", isCompressed);
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            (0, $heHQ1.abool)("isCompressed", isCompressed);
            return $heHQ1.bytesToHex(this.toRawBytes(isCompressed));
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    const _bits = CURVE.nBitLength;
    const wnaf = (0, $exvTT.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE: CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder
    };
}
function $6c95361b56c6c225$var$validateOpts(curve) {
    const opts = (0, $exvTT.validateBasic)(curve);
    $heHQ1.validateObject(opts, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
    }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
    });
    return Object.freeze({
        lowS: true,
        ...opts
    });
}
function $6c95361b56c6c225$export$350b8ea6f1c27fae(curveDef) {
    const CURVE = $6c95361b56c6c225$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    const uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function modN(a) {
        return $lzJFq.mod(a, CURVE_ORDER);
    }
    function invN(a) {
        return $lzJFq.invert(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point, normPrivateKeyToScalar: normPrivateKeyToScalar, weierstrassEquation: weierstrassEquation, isWithinCurveOrder: isWithinCurveOrder } = $6c95361b56c6c225$export$fa783af82e4fe0fc({
        ...CURVE,
        toBytes (_c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp.toBytes(a.x);
            const cat = $heHQ1.concatBytes;
            (0, $heHQ1.abool)("isCompressed", isCompressed);
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes (bytes) {
            const len = bytes.length;
            const head = bytes[0];
            const tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                const x = $heHQ1.bytesToNumberBE(tail);
                if (!$heHQ1.inRange(x, $6c95361b56c6c225$var$_1n, Fp.ORDER)) throw new Error("Point is not on curve");
                const y2 = weierstrassEquation(x); // y² = x³ + ax + b
                let y;
                try {
                    y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                } catch (sqrtError) {
                    const suffix = sqrtError instanceof Error ? ": " + sqrtError.message : "";
                    throw new Error("Point is not on curve" + suffix);
                }
                const isYOdd = (y & $6c95361b56c6c225$var$_1n) === $6c95361b56c6c225$var$_1n;
                // ECDSA
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x: x,
                    y: y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x: x,
                    y: y
                };
            } else throw new Error(`Point of length ${len} was invalid. Expected ${compressedLen} compressed bytes or ${uncompressedLen} uncompressed bytes`);
        }
    });
    const numToNByteStr = (num)=>$heHQ1.bytesToHex($heHQ1.numberToBytesBE(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> $6c95361b56c6c225$var$_1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    const slcNum = (b, from, to)=>$heHQ1.bytesToNumberBE(b.slice(from, to));
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ class Signature {
        constructor(r, s, recovery){
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = CURVE.nByteLength;
            hex = (0, $heHQ1.ensureBytes)("compactSignature", hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r: r, s: s } = $6c95361b56c6c225$export$56ac33195d7076db.toSig((0, $heHQ1.ensureBytes)("DER", hex));
            return new Signature(r, s);
        }
        assertValidity() {
            $heHQ1.aInRange("r", this.r, $6c95361b56c6c225$var$_1n, CURVE_ORDER); // r in [1..N]
            $heHQ1.aInRange("s", this.s, $6c95361b56c6c225$var$_1n, CURVE_ORDER); // s in [1..N]
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r: r, s: s, recovery: rec } = this;
            const h = bits2int_modN((0, $heHQ1.ensureBytes)("msgHash", msgHash)); // Truncate hash
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error("recovery id invalid");
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER) throw new Error("recovery id 2 or 3 invalid");
            const prefix = (rec & 1) === 0 ? "02" : "03";
            const R = Point.fromHex(prefix + numToNByteStr(radj));
            const ir = invN(radj); // r^-1
            const u1 = modN(-h * ir); // -hr^-1
            const u2 = modN(s * ir); // sr^-1
            const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q) throw new Error("point at infinify"); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return $heHQ1.hexToBytes(this.toDERHex());
        }
        toDERHex() {
            return $6c95361b56c6c225$export$56ac33195d7076db.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return $heHQ1.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        }
    }
    const utils = {
        isValidPrivateKey (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */ randomPrivateKey: ()=>{
            const length = $lzJFq.getMinHashLength(CURVE.n);
            return $lzJFq.mapHashToField(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey, isCompressed = true) {
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        const arr = $heHQ1.isBytes(item);
        const str = typeof item === "string";
        const len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA)) throw new Error("first arg must be private key");
        if (!isProbPub(publicB)) throw new Error("second arg must be public key");
        const b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = CURVE.bits2int || function(bytes) {
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = $heHQ1.bytesToNumberBE(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    const ORDER_MASK = $heHQ1.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        $heHQ1.aInRange(`num < 2^${CURVE.nBitLength}`, num, $6c95361b56c6c225$var$_0n, ORDER_MASK);
        // works with order, can have different size than numToField!
        return $heHQ1.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order, this will be wrong at least for P521.
    // Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if ([
            "recovered",
            "canonical"
        ].some((k)=>k in opts)) throw new Error("sign() legacy options not supported");
        const { hash: hash, randomBytes: randomBytes } = CURVE;
        let { lowS: lowS, prehash: prehash, extraEntropy: ent } = opts; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, $heHQ1.ensureBytes)("msgHash", msgHash);
        $6c95361b56c6c225$var$validateSigVerOpts(opts);
        if (prehash) msgHash = (0, $heHQ1.ensureBytes)("prehashed msgHash", hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null && ent !== false) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            const e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, $heHQ1.ensureBytes)("extraEntropy", e)); // check for being bytes
        }
        const seed = $heHQ1.concatBytes(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            const ik = invN(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = Gk
            const r = modN(q.x); // r = q.x mod n
            if (r === $6c95361b56c6c225$var$_0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            const s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === $6c95361b56c6c225$var$_0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & $6c95361b56c6c225$var$_1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    const defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    const defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey, opts = defaultSigOpts) {
        const { seed: seed, k2sig: k2sig } = prepSig(msgHash, privKey, opts); // Steps A, D of RFC6979 3.2.
        const C = CURVE;
        const drbg = $heHQ1.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
        const sg = signature;
        msgHash = (0, $heHQ1.ensureBytes)("msgHash", msgHash);
        publicKey = (0, $heHQ1.ensureBytes)("publicKey", publicKey);
        if ("strict" in opts) throw new Error("options.strict was renamed to lowS");
        $6c95361b56c6c225$var$validateSigVerOpts(opts);
        const { lowS: lowS, prehash: prehash } = opts;
        let _sig = undefined;
        let P;
        try {
            if (typeof sg === "string" || $heHQ1.isBytes(sg)) // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
            // Since DER can also be 2*nByteLength bytes, we check for it first.
            try {
                _sig = Signature.fromDER(sg);
            } catch (derError) {
                if (!(derError instanceof $6c95361b56c6c225$export$56ac33195d7076db.Err)) throw derError;
                _sig = Signature.fromCompact(sg);
            }
            else if (typeof sg === "object" && typeof sg.r === "bigint" && typeof sg.s === "bigint") {
                const { r: r, s: s } = sg;
                _sig = new Signature(r, s);
            } else throw new Error("PARSE");
            P = Point.fromHex(publicKey);
        } catch (error) {
            if (error.message === "PARSE") throw new Error(`signature must be Signature instance, Uint8Array or hex string`);
            return false;
        }
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        const { r: r, s: s } = _sig;
        const h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        const is = invN(s); // s^-1
        const u1 = modN(h * is); // u1 = hs^-1 mod n
        const u2 = modN(r * is); // u2 = rs^-1 mod n
        const R = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        sign: sign,
        verify: verify,
        ProjectivePoint: Point,
        Signature: Signature,
        utils: utils
    };
}
function $6c95361b56c6c225$export$8324ae9483e33241(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = $6c95361b56c6c225$var$_0n;
    for(let o = q - $6c95361b56c6c225$var$_1n; o % $6c95361b56c6c225$var$_2n === $6c95361b56c6c225$var$_0n; o /= $6c95361b56c6c225$var$_2n)l += $6c95361b56c6c225$var$_1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = $6c95361b56c6c225$var$_2n << c1 - $6c95361b56c6c225$var$_1n - $6c95361b56c6c225$var$_1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * $6c95361b56c6c225$var$_2n;
    const c2 = (q - $6c95361b56c6c225$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - $6c95361b56c6c225$var$_1n) / $6c95361b56c6c225$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - $6c95361b56c6c225$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + $6c95361b56c6c225$var$_1n) / $6c95361b56c6c225$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > $6c95361b56c6c225$var$_1n; i--){
            let tv5 = i - $6c95361b56c6c225$var$_2n; // 18.    tv5 = i - 2
            tv5 = $6c95361b56c6c225$var$_2n << tv5 - $6c95361b56c6c225$var$_1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $6c95361b56c6c225$var$_4n === $6c95361b56c6c225$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - $6c95361b56c6c225$var$_3n) / $6c95361b56c6c225$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
function $6c95361b56c6c225$export$cc7fea9756a17416(Fp, opts) {
    $lzJFq.validateField(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
    const sqrtRatio = $6c95361b56c6c225$export$8324ae9483e33241(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error("Fp.isOdd is not implemented!");
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid: isValid, value: value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}


function $03ec6e255de26751$export$adaba664e531641c(hash) {
    return {
        hash: hash,
        hmac: (key, ...msgs)=>(0, $h8PfB.hmac)(hash, key, (0, $5358X.concatBytes)(...msgs)),
        randomBytes: $5358X.randomBytes
    };
}
function $03ec6e255de26751$export$3f2f6721dd02558a(curveDef, defHash) {
    const create = (hash)=>(0, $6c95361b56c6c225$export$350b8ea6f1c27fae)({
            ...curveDef,
            ...$03ec6e255de26751$export$adaba664e531641c(hash)
        });
    return Object.freeze({
        ...create(defHash),
        create: create
    });
}




var $lzJFq = parcelRequire("lzJFq");

var $heHQ1 = parcelRequire("heHQ1");

const $48a78f8d451730ce$var$secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f");
const $48a78f8d451730ce$var$secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
const $48a78f8d451730ce$var$_1n = BigInt(1);
const $48a78f8d451730ce$var$_2n = BigInt(2);
const $48a78f8d451730ce$var$divNearest = (a, b)=>(a + b / $48a78f8d451730ce$var$_2n) / b;
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $48a78f8d451730ce$var$sqrtMod(y) {
    const P = $48a78f8d451730ce$var$secp256k1P;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, $lzJFq.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, $lzJFq.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, $lzJFq.pow2)(b9, $48a78f8d451730ce$var$_2n, P) * b2 % P;
    const b22 = (0, $lzJFq.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, $lzJFq.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, $lzJFq.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, $lzJFq.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, $lzJFq.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, $lzJFq.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, $lzJFq.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, $lzJFq.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, $lzJFq.pow2)(t2, $48a78f8d451730ce$var$_2n, P);
    if (!$48a78f8d451730ce$var$Fp.eql($48a78f8d451730ce$var$Fp.sqr(root), y)) throw new Error("Cannot find square root");
    return root;
}
const $48a78f8d451730ce$var$Fp = (0, $lzJFq.Field)($48a78f8d451730ce$var$secp256k1P, undefined, undefined, {
    sqrt: $48a78f8d451730ce$var$sqrtMod
});
const $48a78f8d451730ce$export$529e6123e9353a90 = (0, $03ec6e255de26751$export$3f2f6721dd02558a)({
    a: BigInt(0),
    b: BigInt(7),
    Fp: $48a78f8d451730ce$var$Fp,
    n: $48a78f8d451730ce$var$secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: true,
    /**
     * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
     * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
     * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
     * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
     */ endo: {
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: (k)=>{
            const n = $48a78f8d451730ce$var$secp256k1N;
            const a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
            const b1 = -$48a78f8d451730ce$var$_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
            const a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
            const b2 = a1;
            const POW_2_128 = BigInt("0x100000000000000000000000000000000"); // (2n**128n).toString(16)
            const c1 = $48a78f8d451730ce$var$divNearest(b2 * k, n);
            const c2 = $48a78f8d451730ce$var$divNearest(-b1 * k, n);
            let k1 = (0, $lzJFq.mod)(k - c1 * a1 - c2 * a2, n);
            let k2 = (0, $lzJFq.mod)(-c1 * b1 - c2 * b2, n);
            const k1neg = k1 > POW_2_128;
            const k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error("splitScalar: Endomorphism failed, k=" + k);
            return {
                k1neg: k1neg,
                k1: k1,
                k2neg: k2neg,
                k2: k2
            };
        }
    }
}, (0, $jfkMZ.sha256));
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
const $48a78f8d451730ce$var$_0n = BigInt(0);
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const $48a78f8d451730ce$var$TAGGED_HASH_PREFIXES = {};
function $48a78f8d451730ce$var$taggedHash(tag, ...messages) {
    let tagP = $48a78f8d451730ce$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, $jfkMZ.sha256)(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
        tagP = (0, $heHQ1.concatBytes)(tagH, tagH);
        $48a78f8d451730ce$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $jfkMZ.sha256)((0, $heHQ1.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const $48a78f8d451730ce$var$pointToBytes = (point)=>point.toRawBytes(true).slice(1);
const $48a78f8d451730ce$var$numTo32b = (n)=>(0, $heHQ1.numberToBytesBE)(n, 32);
const $48a78f8d451730ce$var$modP = (x)=>(0, $lzJFq.mod)(x, $48a78f8d451730ce$var$secp256k1P);
const $48a78f8d451730ce$var$modN = (x)=>(0, $lzJFq.mod)(x, $48a78f8d451730ce$var$secp256k1N);
const $48a78f8d451730ce$var$Point = $48a78f8d451730ce$export$529e6123e9353a90.ProjectivePoint;
const $48a78f8d451730ce$var$GmulAdd = (Q, a, b)=>$48a78f8d451730ce$var$Point.BASE.multiplyAndAddUnsafe(Q, a, b);
// Calculate point, scalar and bytes
function $48a78f8d451730ce$var$schnorrGetExtPubKey(priv) {
    let d_ = $48a78f8d451730ce$export$529e6123e9353a90.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    let p = $48a78f8d451730ce$var$Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = p.hasEvenY() ? d_ : $48a78f8d451730ce$var$modN(-d_);
    return {
        scalar: scalar,
        bytes: $48a78f8d451730ce$var$pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $48a78f8d451730ce$var$lift_x(x) {
    (0, $heHQ1.aInRange)("x", x, $48a78f8d451730ce$var$_1n, $48a78f8d451730ce$var$secp256k1P); // Fail if x ≥ p.
    const xx = $48a78f8d451730ce$var$modP(x * x);
    const c = $48a78f8d451730ce$var$modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = $48a78f8d451730ce$var$sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % $48a78f8d451730ce$var$_2n !== $48a78f8d451730ce$var$_0n) y = $48a78f8d451730ce$var$modP(-y); // Return the unique point P such that x(P) = x and
    const p = new $48a78f8d451730ce$var$Point(x, y, $48a78f8d451730ce$var$_1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
const $48a78f8d451730ce$var$num = (0, $heHQ1.bytesToNumberBE);
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function $48a78f8d451730ce$var$challenge(...args) {
    return $48a78f8d451730ce$var$modN($48a78f8d451730ce$var$num($48a78f8d451730ce$var$taggedHash("BIP0340/challenge", ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function $48a78f8d451730ce$var$schnorrGetPublicKey(privateKey) {
    return $48a78f8d451730ce$var$schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function $48a78f8d451730ce$var$schnorrSign(message, privateKey, auxRand = (0, $5358X.randomBytes)(32)) {
    const m = (0, $heHQ1.ensureBytes)("message", message);
    const { bytes: px, scalar: d } = $48a78f8d451730ce$var$schnorrGetExtPubKey(privateKey); // checks for isWithinCurveOrder
    const a = (0, $heHQ1.ensureBytes)("auxRand", auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = $48a78f8d451730ce$var$numTo32b(d ^ $48a78f8d451730ce$var$num($48a78f8d451730ce$var$taggedHash("BIP0340/aux", a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = $48a78f8d451730ce$var$taggedHash("BIP0340/nonce", t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    const k_ = $48a78f8d451730ce$var$modN($48a78f8d451730ce$var$num(rand)); // Let k' = int(rand) mod n
    if (k_ === $48a78f8d451730ce$var$_0n) throw new Error("sign failed: k is zero"); // Fail if k' = 0.
    const { bytes: rx, scalar: k } = $48a78f8d451730ce$var$schnorrGetExtPubKey(k_); // Let R = k'⋅G.
    const e = $48a78f8d451730ce$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set($48a78f8d451730ce$var$numTo32b($48a78f8d451730ce$var$modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$48a78f8d451730ce$var$schnorrVerify(sig, m, px)) throw new Error("sign: Invalid signature produced");
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $48a78f8d451730ce$var$schnorrVerify(signature, message, publicKey) {
    const sig = (0, $heHQ1.ensureBytes)("signature", signature, 64);
    const m = (0, $heHQ1.ensureBytes)("message", message);
    const pub = (0, $heHQ1.ensureBytes)("publicKey", publicKey, 32);
    try {
        const P = $48a78f8d451730ce$var$lift_x($48a78f8d451730ce$var$num(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = $48a78f8d451730ce$var$num(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!(0, $heHQ1.inRange)(r, $48a78f8d451730ce$var$_1n, $48a78f8d451730ce$var$secp256k1P)) return false;
        const s = $48a78f8d451730ce$var$num(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!(0, $heHQ1.inRange)(s, $48a78f8d451730ce$var$_1n, $48a78f8d451730ce$var$secp256k1N)) return false;
        const e = $48a78f8d451730ce$var$challenge($48a78f8d451730ce$var$numTo32b(r), $48a78f8d451730ce$var$pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        const R = $48a78f8d451730ce$var$GmulAdd(P, s, $48a78f8d451730ce$var$modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
const $48a78f8d451730ce$export$1f2401df071be9f = /* @__PURE__ */ (()=>({
        getPublicKey: $48a78f8d451730ce$var$schnorrGetPublicKey,
        sign: $48a78f8d451730ce$var$schnorrSign,
        verify: $48a78f8d451730ce$var$schnorrVerify,
        utils: {
            randomPrivateKey: $48a78f8d451730ce$export$529e6123e9353a90.utils.randomPrivateKey,
            lift_x: $48a78f8d451730ce$var$lift_x,
            pointToBytes: $48a78f8d451730ce$var$pointToBytes,
            numberToBytesBE: $heHQ1.numberToBytesBE,
            bytesToNumberBE: $heHQ1.bytesToNumberBE,
            taggedHash: $48a78f8d451730ce$var$taggedHash,
            mod: $lzJFq.mod
        }
    }))();
const $48a78f8d451730ce$var$isoMap = /* @__PURE__ */ (()=>(0, $28512be289571107$export$9393380cf1075f28)($48a78f8d451730ce$var$Fp, [
        // xNum
        [
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
            "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
            "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
        ],
        // xDen
        [
            "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
            "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ],
        // yNum
        [
            "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
            "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
            "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
            "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
        ],
        // yDen
        [
            "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
            "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
            "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const $48a78f8d451730ce$var$mapSWU = /* @__PURE__ */ (()=>(0, $6c95361b56c6c225$export$cc7fea9756a17416)($48a78f8d451730ce$var$Fp, {
        A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
        B: BigInt("1771"),
        Z: $48a78f8d451730ce$var$Fp.create(BigInt("-11"))
    }))();
const $48a78f8d451730ce$var$htf = /* @__PURE__ */ (()=>(0, $28512be289571107$export$14b114effbc08b6b)($48a78f8d451730ce$export$529e6123e9353a90.ProjectivePoint, (scalars)=>{
        const { x: x, y: y } = $48a78f8d451730ce$var$mapSWU($48a78f8d451730ce$var$Fp.create(scalars[0]));
        return $48a78f8d451730ce$var$isoMap(x, y);
    }, {
        DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
        encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
        p: $48a78f8d451730ce$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: (0, $jfkMZ.sha256)
    }))();
const $48a78f8d451730ce$export$a95cc2b0cdb9c1e1 = /* @__PURE__ */ (()=>$48a78f8d451730ce$var$htf.hashToCurve)();
const $48a78f8d451730ce$export$124e820e7679cc3 = /* @__PURE__ */ (()=>$48a78f8d451730ce$var$htf.encodeToCurve)();


/**
 * A 64 byte secret key, the first 32 bytes of which is the
 * private scalar and the last 32 bytes is the public key.
 * Read more: https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
 */ /**
 * Ed25519 Keypair
 */ const $ca3473265f76df98$var$generatePrivateKey = (0, $92e3b0bc7d4bbbb7$export$f63794f4a09a19c1).utils.randomPrivateKey;
const $ca3473265f76df98$var$generateKeypair = ()=>{
    const privateScalar = (0, $92e3b0bc7d4bbbb7$export$f63794f4a09a19c1).utils.randomPrivateKey();
    const publicKey = $ca3473265f76df98$var$getPublicKey(privateScalar);
    const secretKey = new Uint8Array(64);
    secretKey.set(privateScalar);
    secretKey.set(publicKey, 32);
    return {
        publicKey: publicKey,
        secretKey: secretKey
    };
};
const $ca3473265f76df98$var$getPublicKey = (0, $92e3b0bc7d4bbbb7$export$f63794f4a09a19c1).getPublicKey;
function $ca3473265f76df98$var$isOnCurve(publicKey) {
    try {
        (0, $92e3b0bc7d4bbbb7$export$f63794f4a09a19c1).ExtendedPoint.fromHex(publicKey);
        return true;
    } catch  {
        return false;
    }
}
const $ca3473265f76df98$var$sign = (message, secretKey)=>(0, $92e3b0bc7d4bbbb7$export$f63794f4a09a19c1).sign(message, secretKey.slice(0, 32));
const $ca3473265f76df98$var$verify = (0, $92e3b0bc7d4bbbb7$export$f63794f4a09a19c1).verify;
const $ca3473265f76df98$var$toBuffer = (arr)=>{
    if ((0, $492757110c774bc9$export$a143d493d941bafc).isBuffer(arr)) return arr;
    else if (arr instanceof Uint8Array) return (0, $492757110c774bc9$export$a143d493d941bafc).from(arr.buffer, arr.byteOffset, arr.byteLength);
    else return (0, $492757110c774bc9$export$a143d493d941bafc).from(arr);
};
// Class wrapping a plain object
class $ca3473265f76df98$export$eabc71f011df675a {
    constructor(properties){
        Object.assign(this, properties);
    }
    encode() {
        return (0, $492757110c774bc9$export$a143d493d941bafc).from((0, $7a17e8040de0e363$exports.serialize)($ca3473265f76df98$export$68d13ce9b4cc48f3, this));
    }
    static decode(data) {
        return (0, $7a17e8040de0e363$exports.deserialize)($ca3473265f76df98$export$68d13ce9b4cc48f3, this, data);
    }
    static decodeUnchecked(data) {
        return (0, $7a17e8040de0e363$exports.deserializeUnchecked)($ca3473265f76df98$export$68d13ce9b4cc48f3, this, data);
    }
}
// Class representing a Rust-compatible enum, since enums are only strings or
// numbers in pure JS
class $ca3473265f76df98$export$deb82508dd66d288 extends $ca3473265f76df98$export$eabc71f011df675a {
    constructor(properties){
        super(properties);
        this.enum = "";
        if (Object.keys(properties).length !== 1) throw new Error("Enum can only take single value");
        Object.keys(properties).map((key)=>{
            this.enum = key;
        });
    }
}
const $ca3473265f76df98$export$68d13ce9b4cc48f3 = new Map();
var $ca3473265f76df98$var$_PublicKey;
/**
 * Maximum length of derived pubkey seed
 */ const $ca3473265f76df98$export$8240f9da84ad7873 = 32;
/**
 * Size of public key in bytes
 */ const $ca3473265f76df98$export$84fc0a248cc54343 = 32;
/**
 * Value to be converted into public key
 */ /**
 * JSON object representation of PublicKey class
 */ function $ca3473265f76df98$var$isPublicKeyData(value) {
    return value._bn !== undefined;
}
// local counter used by PublicKey.unique()
let $ca3473265f76df98$var$uniquePublicKeyCounter = 1;
/**
 * A public key
 */ class $ca3473265f76df98$export$ca8b6604d6ce14de extends $ca3473265f76df98$export$eabc71f011df675a {
    /**
   * Create a new PublicKey object
   * @param value ed25519 public key as buffer or base-58 encoded string
   */ constructor(value){
        super({});
        /** @internal */ this._bn = void 0;
        if ($ca3473265f76df98$var$isPublicKeyData(value)) this._bn = value._bn;
        else {
            if (typeof value === "string") {
                // assume base 58 encoding by default
                const decoded = (0, (/*@__PURE__*/$parcel$interopDefault($d47ad8a6a3d340ae$exports))).decode(value);
                if (decoded.length != $ca3473265f76df98$export$84fc0a248cc54343) throw new Error(`Invalid public key input`);
                this._bn = new (0, (/*@__PURE__*/$parcel$interopDefault($lONYJ)))(decoded);
            } else this._bn = new (0, (/*@__PURE__*/$parcel$interopDefault($lONYJ)))(value);
            if (this._bn.byteLength() > $ca3473265f76df98$export$84fc0a248cc54343) throw new Error(`Invalid public key input`);
        }
    }
    /**
   * Returns a unique PublicKey for tests and benchmarks using a counter
   */ static unique() {
        const key = new $ca3473265f76df98$export$ca8b6604d6ce14de($ca3473265f76df98$var$uniquePublicKeyCounter);
        $ca3473265f76df98$var$uniquePublicKeyCounter += 1;
        return new $ca3473265f76df98$export$ca8b6604d6ce14de(key.toBuffer());
    }
    /**
   * Default public key value. The base58-encoded string representation is all ones (as seen below)
   * The underlying BN number is 32 bytes that are all zeros
   */ /**
   * Checks if two publicKeys are equal
   */ equals(publicKey) {
        return this._bn.eq(publicKey._bn);
    }
    /**
   * Return the base-58 representation of the public key
   */ toBase58() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($d47ad8a6a3d340ae$exports))).encode(this.toBytes());
    }
    toJSON() {
        return this.toBase58();
    }
    /**
   * Return the byte array representation of the public key in big endian
   */ toBytes() {
        const buf = this.toBuffer();
        return new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength);
    }
    /**
   * Return the Buffer representation of the public key in big endian
   */ toBuffer() {
        const b = this._bn.toArrayLike((0, $492757110c774bc9$export$a143d493d941bafc));
        if (b.length === $ca3473265f76df98$export$84fc0a248cc54343) return b;
        const zeroPad = (0, $492757110c774bc9$export$a143d493d941bafc).alloc(32);
        b.copy(zeroPad, 32 - b.length);
        return zeroPad;
    }
    get [Symbol.toStringTag]() {
        return `PublicKey(${this.toString()})`;
    }
    /**
   * Return the base-58 representation of the public key
   */ toString() {
        return this.toBase58();
    }
    /**
   * Derive a public key from another key, a seed, and a program ID.
   * The program ID will also serve as the owner of the public key, giving
   * it permission to write data to the account.
   */ /* eslint-disable require-await */ static async createWithSeed(fromPublicKey, seed, programId) {
        const buffer = (0, $492757110c774bc9$export$a143d493d941bafc).concat([
            fromPublicKey.toBuffer(),
            (0, $492757110c774bc9$export$a143d493d941bafc).from(seed),
            programId.toBuffer()
        ]);
        const publicKeyBytes = (0, $jfkMZ.sha256)(buffer);
        return new $ca3473265f76df98$export$ca8b6604d6ce14de(publicKeyBytes);
    }
    /**
   * Derive a program address from seeds and a program ID.
   */ /* eslint-disable require-await */ static createProgramAddressSync(seeds, programId) {
        let buffer = (0, $492757110c774bc9$export$a143d493d941bafc).alloc(0);
        seeds.forEach(function(seed) {
            if (seed.length > $ca3473265f76df98$export$8240f9da84ad7873) throw new TypeError(`Max seed length exceeded`);
            buffer = (0, $492757110c774bc9$export$a143d493d941bafc).concat([
                buffer,
                $ca3473265f76df98$var$toBuffer(seed)
            ]);
        });
        buffer = (0, $492757110c774bc9$export$a143d493d941bafc).concat([
            buffer,
            programId.toBuffer(),
            (0, $492757110c774bc9$export$a143d493d941bafc).from("ProgramDerivedAddress")
        ]);
        const publicKeyBytes = (0, $jfkMZ.sha256)(buffer);
        if ($ca3473265f76df98$var$isOnCurve(publicKeyBytes)) throw new Error(`Invalid seeds, address must fall off the curve`);
        return new $ca3473265f76df98$export$ca8b6604d6ce14de(publicKeyBytes);
    }
    /**
   * Async version of createProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link createProgramAddressSync} instead
   */ /* eslint-disable require-await */ static async createProgramAddress(seeds, programId) {
        return this.createProgramAddressSync(seeds, programId);
    }
    /**
   * Find a valid program address
   *
   * Valid program addresses must fall off the ed25519 curve.  This function
   * iterates a nonce until it finds one that when combined with the seeds
   * results in a valid program address.
   */ static findProgramAddressSync(seeds, programId) {
        let nonce = 255;
        let address;
        while(nonce != 0){
            try {
                const seedsWithNonce = seeds.concat((0, $492757110c774bc9$export$a143d493d941bafc).from([
                    nonce
                ]));
                address = this.createProgramAddressSync(seedsWithNonce, programId);
            } catch (err) {
                if (err instanceof TypeError) throw err;
                nonce--;
                continue;
            }
            return [
                address,
                nonce
            ];
        }
        throw new Error(`Unable to find a viable program address nonce`);
    }
    /**
   * Async version of findProgramAddressSync
   * For backwards compatibility
   *
   * @deprecated Use {@link findProgramAddressSync} instead
   */ static async findProgramAddress(seeds, programId) {
        return this.findProgramAddressSync(seeds, programId);
    }
    /**
   * Check that a pubkey is on the ed25519 curve.
   */ static isOnCurve(pubkeyData) {
        const pubkey = new $ca3473265f76df98$export$ca8b6604d6ce14de(pubkeyData);
        return $ca3473265f76df98$var$isOnCurve(pubkey.toBytes());
    }
}
$ca3473265f76df98$var$_PublicKey = $ca3473265f76df98$export$ca8b6604d6ce14de;
$ca3473265f76df98$export$ca8b6604d6ce14de.default = new $ca3473265f76df98$var$_PublicKey("11111111111111111111111111111111");
$ca3473265f76df98$export$68d13ce9b4cc48f3.set($ca3473265f76df98$export$ca8b6604d6ce14de, {
    kind: "struct",
    fields: [
        [
            "_bn",
            "u256"
        ]
    ]
});
/**
 * An account key pair (public and secret keys).
 *
 * @deprecated since v1.10.0, please use {@link Keypair} instead.
 */ class $ca3473265f76df98$export$1ed4b10e4aba04a7 {
    /**
   * Create a new Account object
   *
   * If the secretKey parameter is not provided a new key pair is randomly
   * created for the account
   *
   * @param secretKey Secret key for the account
   */ constructor(secretKey){
        /** @internal */ this._publicKey = void 0;
        /** @internal */ this._secretKey = void 0;
        if (secretKey) {
            const secretKeyBuffer = $ca3473265f76df98$var$toBuffer(secretKey);
            if (secretKey.length !== 64) throw new Error("bad secret key size");
            this._publicKey = secretKeyBuffer.slice(32, 64);
            this._secretKey = secretKeyBuffer.slice(0, 32);
        } else {
            this._secretKey = $ca3473265f76df98$var$toBuffer($ca3473265f76df98$var$generatePrivateKey());
            this._publicKey = $ca3473265f76df98$var$toBuffer($ca3473265f76df98$var$getPublicKey(this._secretKey));
        }
    }
    /**
   * The public key for this account
   */ get publicKey() {
        return new $ca3473265f76df98$export$ca8b6604d6ce14de(this._publicKey);
    }
    /**
   * The **unencrypted** secret key for this account. The first 32 bytes
   * is the private scalar and the last 32 bytes is the public key.
   * Read more: https://blog.mozilla.org/warner/2011/11/29/ed25519-keys/
   */ get secretKey() {
        return (0, $492757110c774bc9$export$a143d493d941bafc).concat([
            this._secretKey,
            this._publicKey
        ], 64);
    }
}
const $ca3473265f76df98$export$42bd37c1c64962b6 = new $ca3473265f76df98$export$ca8b6604d6ce14de("BPFLoader1111111111111111111111111111111111");
/**
 * Maximum over-the-wire size of a Transaction
 *
 * 1280 is IPv6 minimum MTU
 * 40 bytes is the size of the IPv6 header
 * 8 bytes is the size of the fragment header
 */ const $ca3473265f76df98$export$4c6d5b89e1596f26 = 1232;
const $ca3473265f76df98$export$3c3793d809f8b858 = 0x7f;
const $ca3473265f76df98$export$14aee086fde78fa6 = 64;
class $ca3473265f76df98$export$718fcd78527f88ed extends Error {
    constructor(signature){
        super(`Signature ${signature} has expired: block height exceeded.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($ca3473265f76df98$export$718fcd78527f88ed.prototype, "name", {
    value: "TransactionExpiredBlockheightExceededError"
});
class $ca3473265f76df98$export$b822204c22e46bdf extends Error {
    constructor(signature, timeoutSeconds){
        super(`Transaction was not confirmed in ${timeoutSeconds.toFixed(2)} seconds. It is ` + "unknown if it succeeded or failed. Check signature " + `${signature} using the Solana Explorer or CLI tools.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($ca3473265f76df98$export$b822204c22e46bdf.prototype, "name", {
    value: "TransactionExpiredTimeoutError"
});
class $ca3473265f76df98$export$a3e7565a95f5a1e5 extends Error {
    constructor(signature){
        super(`Signature ${signature} has expired: the nonce is no longer valid.`);
        this.signature = void 0;
        this.signature = signature;
    }
}
Object.defineProperty($ca3473265f76df98$export$a3e7565a95f5a1e5.prototype, "name", {
    value: "TransactionExpiredNonceInvalidError"
});
class $ca3473265f76df98$export$109914c107623102 {
    constructor(staticAccountKeys, accountKeysFromLookups){
        this.staticAccountKeys = void 0;
        this.accountKeysFromLookups = void 0;
        this.staticAccountKeys = staticAccountKeys;
        this.accountKeysFromLookups = accountKeysFromLookups;
    }
    keySegments() {
        const keySegments = [
            this.staticAccountKeys
        ];
        if (this.accountKeysFromLookups) {
            keySegments.push(this.accountKeysFromLookups.writable);
            keySegments.push(this.accountKeysFromLookups.readonly);
        }
        return keySegments;
    }
    get(index) {
        for (const keySegment of this.keySegments()){
            if (index < keySegment.length) return keySegment[index];
            else index -= keySegment.length;
        }
        return;
    }
    get length() {
        return this.keySegments().flat().length;
    }
    compileInstructions(instructions) {
        // Bail early if any account indexes would overflow a u8
        const U8_MAX = 255;
        if (this.length > U8_MAX + 1) throw new Error("Account index overflow encountered during compilation");
        const keyIndexMap = new Map();
        this.keySegments().flat().forEach((key, index)=>{
            keyIndexMap.set(key.toBase58(), index);
        });
        const findKeyIndex = (key)=>{
            const keyIndex = keyIndexMap.get(key.toBase58());
            if (keyIndex === undefined) throw new Error("Encountered an unknown instruction account key during compilation");
            return keyIndex;
        };
        return instructions.map((instruction)=>{
            return {
                programIdIndex: findKeyIndex(instruction.programId),
                accountKeyIndexes: instruction.keys.map((meta)=>findKeyIndex(meta.pubkey)),
                data: instruction.data
            };
        });
    }
}
/**
 * Layout for a public key
 */ const $ca3473265f76df98$var$publicKey = (property = "publicKey")=>{
    return $ab8b5713b1ee9109$exports.blob(32, property);
};
/**
 * Layout for a signature
 */ const $ca3473265f76df98$var$signature = (property = "signature")=>{
    return $ab8b5713b1ee9109$exports.blob(64, property);
};
/**
 * Layout for a Rust String type
 */ const $ca3473265f76df98$var$rustString = (property = "string")=>{
    const rsl = $ab8b5713b1ee9109$exports.struct([
        $ab8b5713b1ee9109$exports.u32("length"),
        $ab8b5713b1ee9109$exports.u32("lengthPadding"),
        $ab8b5713b1ee9109$exports.blob($ab8b5713b1ee9109$exports.offset($ab8b5713b1ee9109$exports.u32(), -8), "chars")
    ], property);
    const _decode = rsl.decode.bind(rsl);
    const _encode = rsl.encode.bind(rsl);
    const rslShim = rsl;
    rslShim.decode = (b, offset)=>{
        const data = _decode(b, offset);
        return data["chars"].toString();
    };
    rslShim.encode = (str, b, offset)=>{
        const data = {
            chars: (0, $492757110c774bc9$export$a143d493d941bafc).from(str, "utf8")
        };
        return _encode(data, b, offset);
    };
    rslShim.alloc = (str)=>{
        return $ab8b5713b1ee9109$exports.u32().span + $ab8b5713b1ee9109$exports.u32().span + (0, $492757110c774bc9$export$a143d493d941bafc).from(str, "utf8").length;
    };
    return rslShim;
};
/**
 * Layout for an Authorized object
 */ const $ca3473265f76df98$var$authorized = (property = "authorized")=>{
    return $ab8b5713b1ee9109$exports.struct([
        $ca3473265f76df98$var$publicKey("staker"),
        $ca3473265f76df98$var$publicKey("withdrawer")
    ], property);
};
/**
 * Layout for a Lockup object
 */ const $ca3473265f76df98$var$lockup = (property = "lockup")=>{
    return $ab8b5713b1ee9109$exports.struct([
        $ab8b5713b1ee9109$exports.ns64("unixTimestamp"),
        $ab8b5713b1ee9109$exports.ns64("epoch"),
        $ca3473265f76df98$var$publicKey("custodian")
    ], property);
};
/**
 *  Layout for a VoteInit object
 */ const $ca3473265f76df98$var$voteInit = (property = "voteInit")=>{
    return $ab8b5713b1ee9109$exports.struct([
        $ca3473265f76df98$var$publicKey("nodePubkey"),
        $ca3473265f76df98$var$publicKey("authorizedVoter"),
        $ca3473265f76df98$var$publicKey("authorizedWithdrawer"),
        $ab8b5713b1ee9109$exports.u8("commission")
    ], property);
};
/**
 *  Layout for a VoteAuthorizeWithSeedArgs object
 */ const $ca3473265f76df98$var$voteAuthorizeWithSeedArgs = (property = "voteAuthorizeWithSeedArgs")=>{
    return $ab8b5713b1ee9109$exports.struct([
        $ab8b5713b1ee9109$exports.u32("voteAuthorizationType"),
        $ca3473265f76df98$var$publicKey("currentAuthorityDerivedKeyOwnerPubkey"),
        $ca3473265f76df98$var$rustString("currentAuthorityDerivedKeySeed"),
        $ca3473265f76df98$var$publicKey("newAuthorized")
    ], property);
};
function $ca3473265f76df98$var$getAlloc(type, fields) {
    const getItemAlloc = (item)=>{
        if (item.span >= 0) return item.span;
        else if (typeof item.alloc === "function") return item.alloc(fields[item.property]);
        else if ("count" in item && "elementLayout" in item) {
            const field = fields[item.property];
            if (Array.isArray(field)) return field.length * getItemAlloc(item.elementLayout);
        } else if ("fields" in item) // This is a `Structure` whose size needs to be recursively measured.
        return $ca3473265f76df98$var$getAlloc({
            layout: item
        }, fields[item.property]);
        // Couldn't determine allocated size of layout
        return 0;
    };
    let alloc = 0;
    type.layout.fields.forEach((item)=>{
        alloc += getItemAlloc(item);
    });
    return alloc;
}
function $ca3473265f76df98$var$decodeLength(bytes) {
    let len = 0;
    let size = 0;
    for(;;){
        let elem = bytes.shift();
        len |= (elem & 0x7f) << size * 7;
        size += 1;
        if ((elem & 0x80) === 0) break;
    }
    return len;
}
function $ca3473265f76df98$var$encodeLength(bytes, len) {
    let rem_len = len;
    for(;;){
        let elem = rem_len & 0x7f;
        rem_len >>= 7;
        if (rem_len == 0) {
            bytes.push(elem);
            break;
        } else {
            elem |= 0x80;
            bytes.push(elem);
        }
    }
}
function $ca3473265f76df98$var$assert(condition, message) {
    if (!condition) throw new Error(message || "Assertion failed");
}
class $ca3473265f76df98$var$CompiledKeys {
    constructor(payer, keyMetaMap){
        this.payer = void 0;
        this.keyMetaMap = void 0;
        this.payer = payer;
        this.keyMetaMap = keyMetaMap;
    }
    static compile(instructions, payer) {
        const keyMetaMap = new Map();
        const getOrInsertDefault = (pubkey)=>{
            const address = pubkey.toBase58();
            let keyMeta = keyMetaMap.get(address);
            if (keyMeta === undefined) {
                keyMeta = {
                    isSigner: false,
                    isWritable: false,
                    isInvoked: false
                };
                keyMetaMap.set(address, keyMeta);
            }
            return keyMeta;
        };
        const payerKeyMeta = getOrInsertDefault(payer);
        payerKeyMeta.isSigner = true;
        payerKeyMeta.isWritable = true;
        for (const ix of instructions){
            getOrInsertDefault(ix.programId).isInvoked = true;
            for (const accountMeta of ix.keys){
                const keyMeta = getOrInsertDefault(accountMeta.pubkey);
                keyMeta.isSigner ||= accountMeta.isSigner;
                keyMeta.isWritable ||= accountMeta.isWritable;
            }
        }
        return new $ca3473265f76df98$var$CompiledKeys(payer, keyMetaMap);
    }
    getMessageComponents() {
        const mapEntries = [
            ...this.keyMetaMap.entries()
        ];
        $ca3473265f76df98$var$assert(mapEntries.length <= 256, "Max static account keys length exceeded");
        const writableSigners = mapEntries.filter(([, meta])=>meta.isSigner && meta.isWritable);
        const readonlySigners = mapEntries.filter(([, meta])=>meta.isSigner && !meta.isWritable);
        const writableNonSigners = mapEntries.filter(([, meta])=>!meta.isSigner && meta.isWritable);
        const readonlyNonSigners = mapEntries.filter(([, meta])=>!meta.isSigner && !meta.isWritable);
        const header = {
            numRequiredSignatures: writableSigners.length + readonlySigners.length,
            numReadonlySignedAccounts: readonlySigners.length,
            numReadonlyUnsignedAccounts: readonlyNonSigners.length
        };
        // sanity checks
        {
            $ca3473265f76df98$var$assert(writableSigners.length > 0, "Expected at least one writable signer key");
            const [payerAddress] = writableSigners[0];
            $ca3473265f76df98$var$assert(payerAddress === this.payer.toBase58(), "Expected first writable signer key to be the fee payer");
        }
        const staticAccountKeys = [
            ...writableSigners.map(([address])=>new $ca3473265f76df98$export$ca8b6604d6ce14de(address)),
            ...readonlySigners.map(([address])=>new $ca3473265f76df98$export$ca8b6604d6ce14de(address)),
            ...writableNonSigners.map(([address])=>new $ca3473265f76df98$export$ca8b6604d6ce14de(address)),
            ...readonlyNonSigners.map(([address])=>new $ca3473265f76df98$export$ca8b6604d6ce14de(address))
        ];
        return [
            header,
            staticAccountKeys
        ];
    }
    extractTableLookup(lookupTable) {
        const [writableIndexes, drainedWritableKeys] = this.drainKeysFoundInLookupTable(lookupTable.state.addresses, (keyMeta)=>!keyMeta.isSigner && !keyMeta.isInvoked && keyMeta.isWritable);
        const [readonlyIndexes, drainedReadonlyKeys] = this.drainKeysFoundInLookupTable(lookupTable.state.addresses, (keyMeta)=>!keyMeta.isSigner && !keyMeta.isInvoked && !keyMeta.isWritable);
        // Don't extract lookup if no keys were found
        if (writableIndexes.length === 0 && readonlyIndexes.length === 0) return;
        return [
            {
                accountKey: lookupTable.key,
                writableIndexes: writableIndexes,
                readonlyIndexes: readonlyIndexes
            },
            {
                writable: drainedWritableKeys,
                readonly: drainedReadonlyKeys
            }
        ];
    }
    /** @internal */ drainKeysFoundInLookupTable(lookupTableEntries, keyMetaFilter) {
        const lookupTableIndexes = new Array();
        const drainedKeys = new Array();
        for (const [address, keyMeta] of this.keyMetaMap.entries())if (keyMetaFilter(keyMeta)) {
            const key = new $ca3473265f76df98$export$ca8b6604d6ce14de(address);
            const lookupTableIndex = lookupTableEntries.findIndex((entry)=>entry.equals(key));
            if (lookupTableIndex >= 0) {
                $ca3473265f76df98$var$assert(lookupTableIndex < 256, "Max lookup table index exceeded");
                lookupTableIndexes.push(lookupTableIndex);
                drainedKeys.push(key);
                this.keyMetaMap.delete(address);
            }
        }
        return [
            lookupTableIndexes,
            drainedKeys
        ];
    }
}
const $ca3473265f76df98$var$END_OF_BUFFER_ERROR_MESSAGE = "Reached end of buffer unexpectedly";
/**
 * Delegates to `Array#shift`, but throws if the array is zero-length.
 */ function $ca3473265f76df98$var$guardedShift(byteArray) {
    if (byteArray.length === 0) throw new Error($ca3473265f76df98$var$END_OF_BUFFER_ERROR_MESSAGE);
    return byteArray.shift();
}
/**
 * Delegates to `Array#splice`, but throws if the section being spliced out extends past the end of
 * the array.
 */ function $ca3473265f76df98$var$guardedSplice(byteArray, ...args) {
    const [start] = args;
    if (args.length === 2 // Implies that `deleteCount` was supplied
     ? start + (args[1] ?? 0) > byteArray.length : start >= byteArray.length) throw new Error($ca3473265f76df98$var$END_OF_BUFFER_ERROR_MESSAGE);
    return byteArray.splice(...args);
}
/**
 * An instruction to execute by a program
 *
 * @property {number} programIdIndex
 * @property {number[]} accounts
 * @property {string} data
 */ /**
 * Message constructor arguments
 */ /**
 * List of instructions to be processed atomically
 */ class $ca3473265f76df98$export$f69c19e57285b83a {
    constructor(args){
        this.header = void 0;
        this.accountKeys = void 0;
        this.recentBlockhash = void 0;
        this.instructions = void 0;
        this.indexToProgramIds = new Map();
        this.header = args.header;
        this.accountKeys = args.accountKeys.map((account)=>new $ca3473265f76df98$export$ca8b6604d6ce14de(account));
        this.recentBlockhash = args.recentBlockhash;
        this.instructions = args.instructions;
        this.instructions.forEach((ix)=>this.indexToProgramIds.set(ix.programIdIndex, this.accountKeys[ix.programIdIndex]));
    }
    get version() {
        return "legacy";
    }
    get staticAccountKeys() {
        return this.accountKeys;
    }
    get compiledInstructions() {
        return this.instructions.map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accountKeyIndexes: ix.accounts,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($d47ad8a6a3d340ae$exports))).decode(ix.data)
            }));
    }
    get addressTableLookups() {
        return [];
    }
    getAccountKeys() {
        return new $ca3473265f76df98$export$109914c107623102(this.staticAccountKeys);
    }
    static compile(args) {
        const compiledKeys = $ca3473265f76df98$var$CompiledKeys.compile(args.instructions, args.payerKey);
        const [header, staticAccountKeys] = compiledKeys.getMessageComponents();
        const accountKeys = new $ca3473265f76df98$export$109914c107623102(staticAccountKeys);
        const instructions = accountKeys.compileInstructions(args.instructions).map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accounts: ix.accountKeyIndexes,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($d47ad8a6a3d340ae$exports))).encode(ix.data)
            }));
        return new $ca3473265f76df98$export$f69c19e57285b83a({
            header: header,
            accountKeys: staticAccountKeys,
            recentBlockhash: args.recentBlockhash,
            instructions: instructions
        });
    }
    isAccountSigner(index) {
        return index < this.header.numRequiredSignatures;
    }
    isAccountWritable(index) {
        const numSignedAccounts = this.header.numRequiredSignatures;
        if (index >= this.header.numRequiredSignatures) {
            const unsignedAccountIndex = index - numSignedAccounts;
            const numUnsignedAccounts = this.accountKeys.length - numSignedAccounts;
            const numWritableUnsignedAccounts = numUnsignedAccounts - this.header.numReadonlyUnsignedAccounts;
            return unsignedAccountIndex < numWritableUnsignedAccounts;
        } else {
            const numWritableSignedAccounts = numSignedAccounts - this.header.numReadonlySignedAccounts;
            return index < numWritableSignedAccounts;
        }
    }
    isProgramId(index) {
        return this.indexToProgramIds.has(index);
    }
    programIds() {
        return [
            ...this.indexToProgramIds.values()
        ];
    }
    nonProgramIds() {
        return this.accountKeys.filter((_, index)=>!this.isProgramId(index));
    }
    serialize() {
        const numKeys = this.accountKeys.length;
        let keyCount = [];
        $ca3473265f76df98$var$encodeLength(keyCount, numKeys);
        const instructions = this.instructions.map((instruction)=>{
            const { accounts: accounts, programIdIndex: programIdIndex } = instruction;
            const data = Array.from((0, (/*@__PURE__*/$parcel$interopDefault($d47ad8a6a3d340ae$exports))).decode(instruction.data));
            let keyIndicesCount = [];
            $ca3473265f76df98$var$encodeLength(keyIndicesCount, accounts.length);
            let dataCount = [];
            $ca3473265f76df98$var$encodeLength(dataCount, data.length);
            return {
                programIdIndex: programIdIndex,
                keyIndicesCount: (0, $492757110c774bc9$export$a143d493d941bafc).from(keyIndicesCount),
                keyIndices: accounts,
                dataLength: (0, $492757110c774bc9$export$a143d493d941bafc).from(dataCount),
                data: data
            };
        });
        let instructionCount = [];
        $ca3473265f76df98$var$encodeLength(instructionCount, instructions.length);
        let instructionBuffer = (0, $492757110c774bc9$export$a143d493d941bafc).alloc($ca3473265f76df98$export$4c6d5b89e1596f26);
        (0, $492757110c774bc9$export$a143d493d941bafc).from(instructionCount).copy(instructionBuffer);
        let instructionBufferLength = instructionCount.length;
        instructions.forEach((instruction)=>{
            const instructionLayout = $ab8b5713b1ee9109$exports.struct([
                $ab8b5713b1ee9109$exports.u8("programIdIndex"),
                $ab8b5713b1ee9109$exports.blob(instruction.keyIndicesCount.length, "keyIndicesCount"),
                $ab8b5713b1ee9109$exports.seq($ab8b5713b1ee9109$exports.u8("keyIndex"), instruction.keyIndices.length, "keyIndices"),
                $ab8b5713b1ee9109$exports.blob(instruction.dataLength.length, "dataLength"),
                $ab8b5713b1ee9109$exports.seq($ab8b5713b1ee9109$exports.u8("userdatum"), instruction.data.length, "data")
            ]);
            const length = instructionLayout.encode(instruction, instructionBuffer, instructionBufferLength);
            instructionBufferLength += length;
        });
        instructionBuffer = instructionBuffer.slice(0, instructionBufferLength);
        const signDataLayout = $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.blob(1, "numRequiredSignatures"),
            $ab8b5713b1ee9109$exports.blob(1, "numReadonlySignedAccounts"),
            $ab8b5713b1ee9109$exports.blob(1, "numReadonlyUnsignedAccounts"),
            $ab8b5713b1ee9109$exports.blob(keyCount.length, "keyCount"),
            $ab8b5713b1ee9109$exports.seq($ca3473265f76df98$var$publicKey("key"), numKeys, "keys"),
            $ca3473265f76df98$var$publicKey("recentBlockhash")
        ]);
        const transaction = {
            numRequiredSignatures: (0, $492757110c774bc9$export$a143d493d941bafc).from([
                this.header.numRequiredSignatures
            ]),
            numReadonlySignedAccounts: (0, $492757110c774bc9$export$a143d493d941bafc).from([
                this.header.numReadonlySignedAccounts
            ]),
            numReadonlyUnsignedAccounts: (0, $492757110c774bc9$export$a143d493d941bafc).from([
                this.header.numReadonlyUnsignedAccounts
            ]),
            keyCount: (0, $492757110c774bc9$export$a143d493d941bafc).from(keyCount),
            keys: this.accountKeys.map((key)=>$ca3473265f76df98$var$toBuffer(key.toBytes())),
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($d47ad8a6a3d340ae$exports))).decode(this.recentBlockhash)
        };
        let signData = (0, $492757110c774bc9$export$a143d493d941bafc).alloc(2048);
        const length = signDataLayout.encode(transaction, signData);
        instructionBuffer.copy(signData, length);
        return signData.slice(0, length + instructionBuffer.length);
    }
    /**
   * Decode a compiled message into a Message object.
   */ static from(buffer) {
        // Slice up wire data
        let byteArray = [
            ...buffer
        ];
        const numRequiredSignatures = $ca3473265f76df98$var$guardedShift(byteArray);
        if (numRequiredSignatures !== (numRequiredSignatures & $ca3473265f76df98$export$3c3793d809f8b858)) throw new Error("Versioned messages must be deserialized with VersionedMessage.deserialize()");
        const numReadonlySignedAccounts = $ca3473265f76df98$var$guardedShift(byteArray);
        const numReadonlyUnsignedAccounts = $ca3473265f76df98$var$guardedShift(byteArray);
        const accountCount = $ca3473265f76df98$var$decodeLength(byteArray);
        let accountKeys = [];
        for(let i = 0; i < accountCount; i++){
            const account = $ca3473265f76df98$var$guardedSplice(byteArray, 0, $ca3473265f76df98$export$84fc0a248cc54343);
            accountKeys.push(new $ca3473265f76df98$export$ca8b6604d6ce14de((0, $492757110c774bc9$export$a143d493d941bafc).from(account)));
        }
        const recentBlockhash = $ca3473265f76df98$var$guardedSplice(byteArray, 0, $ca3473265f76df98$export$84fc0a248cc54343);
        const instructionCount = $ca3473265f76df98$var$decodeLength(byteArray);
        let instructions = [];
        for(let i = 0; i < instructionCount; i++){
            const programIdIndex = $ca3473265f76df98$var$guardedShift(byteArray);
            const accountCount = $ca3473265f76df98$var$decodeLength(byteArray);
            const accounts = $ca3473265f76df98$var$guardedSplice(byteArray, 0, accountCount);
            const dataLength = $ca3473265f76df98$var$decodeLength(byteArray);
            const dataSlice = $ca3473265f76df98$var$guardedSplice(byteArray, 0, dataLength);
            const data = (0, (/*@__PURE__*/$parcel$interopDefault($d47ad8a6a3d340ae$exports))).encode((0, $492757110c774bc9$export$a143d493d941bafc).from(dataSlice));
            instructions.push({
                programIdIndex: programIdIndex,
                accounts: accounts,
                data: data
            });
        }
        const messageArgs = {
            header: {
                numRequiredSignatures: numRequiredSignatures,
                numReadonlySignedAccounts: numReadonlySignedAccounts,
                numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts
            },
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($d47ad8a6a3d340ae$exports))).encode((0, $492757110c774bc9$export$a143d493d941bafc).from(recentBlockhash)),
            accountKeys: accountKeys,
            instructions: instructions
        };
        return new $ca3473265f76df98$export$f69c19e57285b83a(messageArgs);
    }
}
/**
 * Message constructor arguments
 */ class $ca3473265f76df98$export$ee274c70e0fae590 {
    constructor(args){
        this.header = void 0;
        this.staticAccountKeys = void 0;
        this.recentBlockhash = void 0;
        this.compiledInstructions = void 0;
        this.addressTableLookups = void 0;
        this.header = args.header;
        this.staticAccountKeys = args.staticAccountKeys;
        this.recentBlockhash = args.recentBlockhash;
        this.compiledInstructions = args.compiledInstructions;
        this.addressTableLookups = args.addressTableLookups;
    }
    get version() {
        return 0;
    }
    get numAccountKeysFromLookups() {
        let count = 0;
        for (const lookup of this.addressTableLookups)count += lookup.readonlyIndexes.length + lookup.writableIndexes.length;
        return count;
    }
    getAccountKeys(args) {
        let accountKeysFromLookups;
        if (args && "accountKeysFromLookups" in args && args.accountKeysFromLookups) {
            if (this.numAccountKeysFromLookups != args.accountKeysFromLookups.writable.length + args.accountKeysFromLookups.readonly.length) throw new Error("Failed to get account keys because of a mismatch in the number of account keys from lookups");
            accountKeysFromLookups = args.accountKeysFromLookups;
        } else if (args && "addressLookupTableAccounts" in args && args.addressLookupTableAccounts) accountKeysFromLookups = this.resolveAddressTableLookups(args.addressLookupTableAccounts);
        else if (this.addressTableLookups.length > 0) throw new Error("Failed to get account keys because address table lookups were not resolved");
        return new $ca3473265f76df98$export$109914c107623102(this.staticAccountKeys, accountKeysFromLookups);
    }
    isAccountSigner(index) {
        return index < this.header.numRequiredSignatures;
    }
    isAccountWritable(index) {
        const numSignedAccounts = this.header.numRequiredSignatures;
        const numStaticAccountKeys = this.staticAccountKeys.length;
        if (index >= numStaticAccountKeys) {
            const lookupAccountKeysIndex = index - numStaticAccountKeys;
            const numWritableLookupAccountKeys = this.addressTableLookups.reduce((count, lookup)=>count + lookup.writableIndexes.length, 0);
            return lookupAccountKeysIndex < numWritableLookupAccountKeys;
        } else if (index >= this.header.numRequiredSignatures) {
            const unsignedAccountIndex = index - numSignedAccounts;
            const numUnsignedAccounts = numStaticAccountKeys - numSignedAccounts;
            const numWritableUnsignedAccounts = numUnsignedAccounts - this.header.numReadonlyUnsignedAccounts;
            return unsignedAccountIndex < numWritableUnsignedAccounts;
        } else {
            const numWritableSignedAccounts = numSignedAccounts - this.header.numReadonlySignedAccounts;
            return index < numWritableSignedAccounts;
        }
    }
    resolveAddressTableLookups(addressLookupTableAccounts) {
        const accountKeysFromLookups = {
            writable: [],
            readonly: []
        };
        for (const tableLookup of this.addressTableLookups){
            const tableAccount = addressLookupTableAccounts.find((account)=>account.key.equals(tableLookup.accountKey));
            if (!tableAccount) throw new Error(`Failed to find address lookup table account for table key ${tableLookup.accountKey.toBase58()}`);
            for (const index of tableLookup.writableIndexes){
                if (index < tableAccount.state.addresses.length) accountKeysFromLookups.writable.push(tableAccount.state.addresses[index]);
                else throw new Error(`Failed to find address for index ${index} in address lookup table ${tableLookup.accountKey.toBase58()}`);
            }
            for (const index of tableLookup.readonlyIndexes){
                if (index < tableAccount.state.addresses.length) accountKeysFromLookups.readonly.push(tableAccount.state.addresses[index]);
                else throw new Error(`Failed to find address for index ${index} in address lookup table ${tableLookup.accountKey.toBase58()}`);
            }
        }
        return accountKeysFromLookups;
    }
    static compile(args) {
        const compiledKeys = $ca3473265f76df98$var$CompiledKeys.compile(args.instructions, args.payerKey);
        const addressTableLookups = new Array();
        const accountKeysFromLookups = {
            writable: new Array(),
            readonly: new Array()
        };
        const lookupTableAccounts = args.addressLookupTableAccounts || [];
        for (const lookupTable of lookupTableAccounts){
            const extractResult = compiledKeys.extractTableLookup(lookupTable);
            if (extractResult !== undefined) {
                const [addressTableLookup, { writable: writable, readonly: readonly }] = extractResult;
                addressTableLookups.push(addressTableLookup);
                accountKeysFromLookups.writable.push(...writable);
                accountKeysFromLookups.readonly.push(...readonly);
            }
        }
        const [header, staticAccountKeys] = compiledKeys.getMessageComponents();
        const accountKeys = new $ca3473265f76df98$export$109914c107623102(staticAccountKeys, accountKeysFromLookups);
        const compiledInstructions = accountKeys.compileInstructions(args.instructions);
        return new $ca3473265f76df98$export$ee274c70e0fae590({
            header: header,
            staticAccountKeys: staticAccountKeys,
            recentBlockhash: args.recentBlockhash,
            compiledInstructions: compiledInstructions,
            addressTableLookups: addressTableLookups
        });
    }
    serialize() {
        const encodedStaticAccountKeysLength = Array();
        $ca3473265f76df98$var$encodeLength(encodedStaticAccountKeysLength, this.staticAccountKeys.length);
        const serializedInstructions = this.serializeInstructions();
        const encodedInstructionsLength = Array();
        $ca3473265f76df98$var$encodeLength(encodedInstructionsLength, this.compiledInstructions.length);
        const serializedAddressTableLookups = this.serializeAddressTableLookups();
        const encodedAddressTableLookupsLength = Array();
        $ca3473265f76df98$var$encodeLength(encodedAddressTableLookupsLength, this.addressTableLookups.length);
        const messageLayout = $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u8("prefix"),
            $ab8b5713b1ee9109$exports.struct([
                $ab8b5713b1ee9109$exports.u8("numRequiredSignatures"),
                $ab8b5713b1ee9109$exports.u8("numReadonlySignedAccounts"),
                $ab8b5713b1ee9109$exports.u8("numReadonlyUnsignedAccounts")
            ], "header"),
            $ab8b5713b1ee9109$exports.blob(encodedStaticAccountKeysLength.length, "staticAccountKeysLength"),
            $ab8b5713b1ee9109$exports.seq($ca3473265f76df98$var$publicKey(), this.staticAccountKeys.length, "staticAccountKeys"),
            $ca3473265f76df98$var$publicKey("recentBlockhash"),
            $ab8b5713b1ee9109$exports.blob(encodedInstructionsLength.length, "instructionsLength"),
            $ab8b5713b1ee9109$exports.blob(serializedInstructions.length, "serializedInstructions"),
            $ab8b5713b1ee9109$exports.blob(encodedAddressTableLookupsLength.length, "addressTableLookupsLength"),
            $ab8b5713b1ee9109$exports.blob(serializedAddressTableLookups.length, "serializedAddressTableLookups")
        ]);
        const serializedMessage = new Uint8Array($ca3473265f76df98$export$4c6d5b89e1596f26);
        const MESSAGE_VERSION_0_PREFIX = 128;
        const serializedMessageLength = messageLayout.encode({
            prefix: MESSAGE_VERSION_0_PREFIX,
            header: this.header,
            staticAccountKeysLength: new Uint8Array(encodedStaticAccountKeysLength),
            staticAccountKeys: this.staticAccountKeys.map((key)=>key.toBytes()),
            recentBlockhash: (0, (/*@__PURE__*/$parcel$interopDefault($d47ad8a6a3d340ae$exports))).decode(this.recentBlockhash),
            instructionsLength: new Uint8Array(encodedInstructionsLength),
            serializedInstructions: serializedInstructions,
            addressTableLookupsLength: new Uint8Array(encodedAddressTableLookupsLength),
            serializedAddressTableLookups: serializedAddressTableLookups
        }, serializedMessage);
        return serializedMessage.slice(0, serializedMessageLength);
    }
    serializeInstructions() {
        let serializedLength = 0;
        const serializedInstructions = new Uint8Array($ca3473265f76df98$export$4c6d5b89e1596f26);
        for (const instruction of this.compiledInstructions){
            const encodedAccountKeyIndexesLength = Array();
            $ca3473265f76df98$var$encodeLength(encodedAccountKeyIndexesLength, instruction.accountKeyIndexes.length);
            const encodedDataLength = Array();
            $ca3473265f76df98$var$encodeLength(encodedDataLength, instruction.data.length);
            const instructionLayout = $ab8b5713b1ee9109$exports.struct([
                $ab8b5713b1ee9109$exports.u8("programIdIndex"),
                $ab8b5713b1ee9109$exports.blob(encodedAccountKeyIndexesLength.length, "encodedAccountKeyIndexesLength"),
                $ab8b5713b1ee9109$exports.seq($ab8b5713b1ee9109$exports.u8(), instruction.accountKeyIndexes.length, "accountKeyIndexes"),
                $ab8b5713b1ee9109$exports.blob(encodedDataLength.length, "encodedDataLength"),
                $ab8b5713b1ee9109$exports.blob(instruction.data.length, "data")
            ]);
            serializedLength += instructionLayout.encode({
                programIdIndex: instruction.programIdIndex,
                encodedAccountKeyIndexesLength: new Uint8Array(encodedAccountKeyIndexesLength),
                accountKeyIndexes: instruction.accountKeyIndexes,
                encodedDataLength: new Uint8Array(encodedDataLength),
                data: instruction.data
            }, serializedInstructions, serializedLength);
        }
        return serializedInstructions.slice(0, serializedLength);
    }
    serializeAddressTableLookups() {
        let serializedLength = 0;
        const serializedAddressTableLookups = new Uint8Array($ca3473265f76df98$export$4c6d5b89e1596f26);
        for (const lookup of this.addressTableLookups){
            const encodedWritableIndexesLength = Array();
            $ca3473265f76df98$var$encodeLength(encodedWritableIndexesLength, lookup.writableIndexes.length);
            const encodedReadonlyIndexesLength = Array();
            $ca3473265f76df98$var$encodeLength(encodedReadonlyIndexesLength, lookup.readonlyIndexes.length);
            const addressTableLookupLayout = $ab8b5713b1ee9109$exports.struct([
                $ca3473265f76df98$var$publicKey("accountKey"),
                $ab8b5713b1ee9109$exports.blob(encodedWritableIndexesLength.length, "encodedWritableIndexesLength"),
                $ab8b5713b1ee9109$exports.seq($ab8b5713b1ee9109$exports.u8(), lookup.writableIndexes.length, "writableIndexes"),
                $ab8b5713b1ee9109$exports.blob(encodedReadonlyIndexesLength.length, "encodedReadonlyIndexesLength"),
                $ab8b5713b1ee9109$exports.seq($ab8b5713b1ee9109$exports.u8(), lookup.readonlyIndexes.length, "readonlyIndexes")
            ]);
            serializedLength += addressTableLookupLayout.encode({
                accountKey: lookup.accountKey.toBytes(),
                encodedWritableIndexesLength: new Uint8Array(encodedWritableIndexesLength),
                writableIndexes: lookup.writableIndexes,
                encodedReadonlyIndexesLength: new Uint8Array(encodedReadonlyIndexesLength),
                readonlyIndexes: lookup.readonlyIndexes
            }, serializedAddressTableLookups, serializedLength);
        }
        return serializedAddressTableLookups.slice(0, serializedLength);
    }
    static deserialize(serializedMessage) {
        let byteArray = [
            ...serializedMessage
        ];
        const prefix = $ca3473265f76df98$var$guardedShift(byteArray);
        const maskedPrefix = prefix & $ca3473265f76df98$export$3c3793d809f8b858;
        $ca3473265f76df98$var$assert(prefix !== maskedPrefix, `Expected versioned message but received legacy message`);
        const version = maskedPrefix;
        $ca3473265f76df98$var$assert(version === 0, `Expected versioned message with version 0 but found version ${version}`);
        const header = {
            numRequiredSignatures: $ca3473265f76df98$var$guardedShift(byteArray),
            numReadonlySignedAccounts: $ca3473265f76df98$var$guardedShift(byteArray),
            numReadonlyUnsignedAccounts: $ca3473265f76df98$var$guardedShift(byteArray)
        };
        const staticAccountKeys = [];
        const staticAccountKeysLength = $ca3473265f76df98$var$decodeLength(byteArray);
        for(let i = 0; i < staticAccountKeysLength; i++)staticAccountKeys.push(new $ca3473265f76df98$export$ca8b6604d6ce14de($ca3473265f76df98$var$guardedSplice(byteArray, 0, $ca3473265f76df98$export$84fc0a248cc54343)));
        const recentBlockhash = (0, (/*@__PURE__*/$parcel$interopDefault($d47ad8a6a3d340ae$exports))).encode($ca3473265f76df98$var$guardedSplice(byteArray, 0, $ca3473265f76df98$export$84fc0a248cc54343));
        const instructionCount = $ca3473265f76df98$var$decodeLength(byteArray);
        const compiledInstructions = [];
        for(let i = 0; i < instructionCount; i++){
            const programIdIndex = $ca3473265f76df98$var$guardedShift(byteArray);
            const accountKeyIndexesLength = $ca3473265f76df98$var$decodeLength(byteArray);
            const accountKeyIndexes = $ca3473265f76df98$var$guardedSplice(byteArray, 0, accountKeyIndexesLength);
            const dataLength = $ca3473265f76df98$var$decodeLength(byteArray);
            const data = new Uint8Array($ca3473265f76df98$var$guardedSplice(byteArray, 0, dataLength));
            compiledInstructions.push({
                programIdIndex: programIdIndex,
                accountKeyIndexes: accountKeyIndexes,
                data: data
            });
        }
        const addressTableLookupsCount = $ca3473265f76df98$var$decodeLength(byteArray);
        const addressTableLookups = [];
        for(let i = 0; i < addressTableLookupsCount; i++){
            const accountKey = new $ca3473265f76df98$export$ca8b6604d6ce14de($ca3473265f76df98$var$guardedSplice(byteArray, 0, $ca3473265f76df98$export$84fc0a248cc54343));
            const writableIndexesLength = $ca3473265f76df98$var$decodeLength(byteArray);
            const writableIndexes = $ca3473265f76df98$var$guardedSplice(byteArray, 0, writableIndexesLength);
            const readonlyIndexesLength = $ca3473265f76df98$var$decodeLength(byteArray);
            const readonlyIndexes = $ca3473265f76df98$var$guardedSplice(byteArray, 0, readonlyIndexesLength);
            addressTableLookups.push({
                accountKey: accountKey,
                writableIndexes: writableIndexes,
                readonlyIndexes: readonlyIndexes
            });
        }
        return new $ca3473265f76df98$export$ee274c70e0fae590({
            header: header,
            staticAccountKeys: staticAccountKeys,
            recentBlockhash: recentBlockhash,
            compiledInstructions: compiledInstructions,
            addressTableLookups: addressTableLookups
        });
    }
}
// eslint-disable-next-line no-redeclare
const $ca3473265f76df98$export$b0a61927d00ede7f = {
    deserializeMessageVersion (serializedMessage) {
        const prefix = serializedMessage[0];
        const maskedPrefix = prefix & $ca3473265f76df98$export$3c3793d809f8b858;
        // if the highest bit of the prefix is not set, the message is not versioned
        if (maskedPrefix === prefix) return "legacy";
        // the lower 7 bits of the prefix indicate the message version
        return maskedPrefix;
    },
    deserialize: (serializedMessage)=>{
        const version = $ca3473265f76df98$export$b0a61927d00ede7f.deserializeMessageVersion(serializedMessage);
        if (version === "legacy") return $ca3473265f76df98$export$f69c19e57285b83a.from(serializedMessage);
        if (version === 0) return $ca3473265f76df98$export$ee274c70e0fae590.deserialize(serializedMessage);
        else throw new Error(`Transaction message version ${version} deserialization is not supported`);
    }
};
/** @internal */ /**
 * Transaction signature as base-58 encoded string
 */ let $ca3473265f76df98$export$7c391bd3b61d2374 = /*#__PURE__*/ function(TransactionStatus) {
    TransactionStatus[TransactionStatus["BLOCKHEIGHT_EXCEEDED"] = 0] = "BLOCKHEIGHT_EXCEEDED";
    TransactionStatus[TransactionStatus["PROCESSED"] = 1] = "PROCESSED";
    TransactionStatus[TransactionStatus["TIMED_OUT"] = 2] = "TIMED_OUT";
    TransactionStatus[TransactionStatus["NONCE_INVALID"] = 3] = "NONCE_INVALID";
    return TransactionStatus;
}({});
/**
 * Default (empty) signature
 */ const $ca3473265f76df98$var$DEFAULT_SIGNATURE = (0, $492757110c774bc9$export$a143d493d941bafc).alloc($ca3473265f76df98$export$14aee086fde78fa6).fill(0);
/**
 * Account metadata used to define instructions
 */ /**
 * List of TransactionInstruction object fields that may be initialized at construction
 */ /**
 * Configuration object for Transaction.serialize()
 */ /**
 * @internal
 */ /**
 * Transaction Instruction class
 */ class $ca3473265f76df98$export$a7a3aa8360ac9f59 {
    constructor(opts){
        /**
     * Public keys to include in this transaction
     * Boolean represents whether this pubkey needs to sign the transaction
     */ this.keys = void 0;
        /**
     * Program Id to execute
     */ this.programId = void 0;
        /**
     * Program input
     */ this.data = (0, $492757110c774bc9$export$a143d493d941bafc).alloc(0);
        this.programId = opts.programId;
        this.keys = opts.keys;
        if (opts.data) this.data = opts.data;
    }
    /**
   * @internal
   */ toJSON() {
        return {
            keys: this.keys.map(({ pubkey: pubkey, isSigner: isSigner, isWritable: isWritable })=>({
                    pubkey: pubkey.toJSON(),
                    isSigner: isSigner,
                    isWritable: isWritable
                })),
            programId: this.programId.toJSON(),
            data: [
                ...this.data
            ]
        };
    }
}
/**
 * Pair of signature and corresponding public key
 */ /**
 * List of Transaction object fields that may be initialized at construction
 */ // For backward compatibility; an unfortunate consequence of being
// forced to over-export types by the documentation generator.
// See https://github.com/solana-labs/solana/pull/25820
/**
 * Blockhash-based transactions have a lifetime that are defined by
 * the blockhash they include. Any transaction whose blockhash is
 * too old will be rejected.
 */ /**
 * Use these options to construct a durable nonce transaction.
 */ /**
 * Nonce information to be used to build an offline Transaction.
 */ /**
 * @internal
 */ /**
 * Transaction class
 */ class $ca3473265f76df98$export$febc5573c75cefb0 {
    /**
   * The first (payer) Transaction signature
   *
   * @returns {Buffer | null} Buffer of payer's signature
   */ get signature() {
        if (this.signatures.length > 0) return this.signatures[0].signature;
        return null;
    }
    /**
   * The transaction fee payer
   */ // Construct a transaction with a blockhash and lastValidBlockHeight
    // Construct a transaction using a durable nonce
    /**
   * @deprecated `TransactionCtorFields` has been deprecated and will be removed in a future version.
   * Please supply a `TransactionBlockhashCtor` instead.
   */ /**
   * Construct an empty Transaction
   */ constructor(opts){
        /**
     * Signatures for the transaction.  Typically created by invoking the
     * `sign()` method
     */ this.signatures = [];
        this.feePayer = void 0;
        /**
     * The instructions to atomically execute
     */ this.instructions = [];
        /**
     * A recent transaction id. Must be populated by the caller
     */ this.recentBlockhash = void 0;
        /**
     * the last block chain can advance to before tx is declared expired
     * */ this.lastValidBlockHeight = void 0;
        /**
     * Optional Nonce information. If populated, transaction will use a durable
     * Nonce hash instead of a recentBlockhash. Must be populated by the caller
     */ this.nonceInfo = void 0;
        /**
     * If this is a nonce transaction this represents the minimum slot from which
     * to evaluate if the nonce has advanced when attempting to confirm the
     * transaction. This protects against a case where the transaction confirmation
     * logic loads the nonce account from an old slot and assumes the mismatch in
     * nonce value implies that the nonce has been advanced.
     */ this.minNonceContextSlot = void 0;
        /**
     * @internal
     */ this._message = void 0;
        /**
     * @internal
     */ this._json = void 0;
        if (!opts) return;
        if (opts.feePayer) this.feePayer = opts.feePayer;
        if (opts.signatures) this.signatures = opts.signatures;
        if (Object.prototype.hasOwnProperty.call(opts, "nonceInfo")) {
            const { minContextSlot: minContextSlot, nonceInfo: nonceInfo } = opts;
            this.minNonceContextSlot = minContextSlot;
            this.nonceInfo = nonceInfo;
        } else if (Object.prototype.hasOwnProperty.call(opts, "lastValidBlockHeight")) {
            const { blockhash: blockhash, lastValidBlockHeight: lastValidBlockHeight } = opts;
            this.recentBlockhash = blockhash;
            this.lastValidBlockHeight = lastValidBlockHeight;
        } else {
            const { recentBlockhash: recentBlockhash, nonceInfo: nonceInfo } = opts;
            if (nonceInfo) this.nonceInfo = nonceInfo;
            this.recentBlockhash = recentBlockhash;
        }
    }
    /**
   * @internal
   */ toJSON() {
        return {
            recentBlockhash: this.recentBlockhash || null,
            feePayer: this.feePayer ? this.feePayer.toJSON() : null,
            nonceInfo: this.nonceInfo ? {
                nonce: this.nonceInfo.nonce,
                nonceInstruction: this.nonceInfo.nonceInstruction.toJSON()
            } : null,
            instructions: this.instructions.map((instruction)=>instruction.toJSON()),
            signers: this.signatures.map(({ publicKey: publicKey })=>{
                return publicKey.toJSON();
            })
        };
    }
    /**
   * Add one or more instructions to this Transaction
   *
   * @param {Array< Transaction | TransactionInstruction | TransactionInstructionCtorFields >} items - Instructions to add to the Transaction
   */ add(...items) {
        if (items.length === 0) throw new Error("No instructions");
        items.forEach((item)=>{
            if ("instructions" in item) this.instructions = this.instructions.concat(item.instructions);
            else if ("data" in item && "programId" in item && "keys" in item) this.instructions.push(item);
            else this.instructions.push(new $ca3473265f76df98$export$a7a3aa8360ac9f59(item));
        });
        return this;
    }
    /**
   * Compile transaction data
   */ compileMessage() {
        if (this._message && JSON.stringify(this.toJSON()) === JSON.stringify(this._json)) return this._message;
        let recentBlockhash;
        let instructions;
        if (this.nonceInfo) {
            recentBlockhash = this.nonceInfo.nonce;
            if (this.instructions[0] != this.nonceInfo.nonceInstruction) instructions = [
                this.nonceInfo.nonceInstruction,
                ...this.instructions
            ];
            else instructions = this.instructions;
        } else {
            recentBlockhash = this.recentBlockhash;
            instructions = this.instructions;
        }
        if (!recentBlockhash) throw new Error("Transaction recentBlockhash required");
        if (instructions.length < 1) console.warn("No instructions provided");
        let feePayer;
        if (this.feePayer) feePayer = this.feePayer;
        else if (this.signatures.length > 0 && this.signatures[0].publicKey) // Use implicit fee payer
        feePayer = this.signatures[0].publicKey;
        else throw new Error("Transaction fee payer required");
        for(let i = 0; i < instructions.length; i++){
            if (instructions[i].programId === undefined) throw new Error(`Transaction instruction index ${i} has undefined program id`);
        }
        const programIds = [];
        const accountMetas = [];
        instructions.forEach((instruction)=>{
            instruction.keys.forEach((accountMeta)=>{
                accountMetas.push({
                    ...accountMeta
                });
            });
            const programId = instruction.programId.toString();
            if (!programIds.includes(programId)) programIds.push(programId);
        });
        // Append programID account metas
        programIds.forEach((programId)=>{
            accountMetas.push({
                pubkey: new $ca3473265f76df98$export$ca8b6604d6ce14de(programId),
                isSigner: false,
                isWritable: false
            });
        });
        // Cull duplicate account metas
        const uniqueMetas = [];
        accountMetas.forEach((accountMeta)=>{
            const pubkeyString = accountMeta.pubkey.toString();
            const uniqueIndex = uniqueMetas.findIndex((x)=>{
                return x.pubkey.toString() === pubkeyString;
            });
            if (uniqueIndex > -1) {
                uniqueMetas[uniqueIndex].isWritable = uniqueMetas[uniqueIndex].isWritable || accountMeta.isWritable;
                uniqueMetas[uniqueIndex].isSigner = uniqueMetas[uniqueIndex].isSigner || accountMeta.isSigner;
            } else uniqueMetas.push(accountMeta);
        });
        // Sort. Prioritizing first by signer, then by writable
        uniqueMetas.sort(function(x, y) {
            if (x.isSigner !== y.isSigner) // Signers always come before non-signers
            return x.isSigner ? -1 : 1;
            if (x.isWritable !== y.isWritable) // Writable accounts always come before read-only accounts
            return x.isWritable ? -1 : 1;
            // Otherwise, sort by pubkey, stringwise.
            const options = {
                localeMatcher: "best fit",
                usage: "sort",
                sensitivity: "variant",
                ignorePunctuation: false,
                numeric: false,
                caseFirst: "lower"
            };
            return x.pubkey.toBase58().localeCompare(y.pubkey.toBase58(), "en", options);
        });
        // Move fee payer to the front
        const feePayerIndex = uniqueMetas.findIndex((x)=>{
            return x.pubkey.equals(feePayer);
        });
        if (feePayerIndex > -1) {
            const [payerMeta] = uniqueMetas.splice(feePayerIndex, 1);
            payerMeta.isSigner = true;
            payerMeta.isWritable = true;
            uniqueMetas.unshift(payerMeta);
        } else uniqueMetas.unshift({
            pubkey: feePayer,
            isSigner: true,
            isWritable: true
        });
        // Disallow unknown signers
        for (const signature of this.signatures){
            const uniqueIndex = uniqueMetas.findIndex((x)=>{
                return x.pubkey.equals(signature.publicKey);
            });
            if (uniqueIndex > -1) {
                if (!uniqueMetas[uniqueIndex].isSigner) {
                    uniqueMetas[uniqueIndex].isSigner = true;
                    console.warn("Transaction references a signature that is unnecessary, only the fee payer and instruction signer accounts should sign a transaction. This behavior is deprecated and will throw an error in the next major version release.");
                }
            } else throw new Error(`unknown signer: ${signature.publicKey.toString()}`);
        }
        let numRequiredSignatures = 0;
        let numReadonlySignedAccounts = 0;
        let numReadonlyUnsignedAccounts = 0;
        // Split out signing from non-signing keys and count header values
        const signedKeys = [];
        const unsignedKeys = [];
        uniqueMetas.forEach(({ pubkey: pubkey, isSigner: isSigner, isWritable: isWritable })=>{
            if (isSigner) {
                signedKeys.push(pubkey.toString());
                numRequiredSignatures += 1;
                if (!isWritable) numReadonlySignedAccounts += 1;
            } else {
                unsignedKeys.push(pubkey.toString());
                if (!isWritable) numReadonlyUnsignedAccounts += 1;
            }
        });
        const accountKeys = signedKeys.concat(unsignedKeys);
        const compiledInstructions = instructions.map((instruction)=>{
            const { data: data, programId: programId } = instruction;
            return {
                programIdIndex: accountKeys.indexOf(programId.toString()),
                accounts: instruction.keys.map((meta)=>accountKeys.indexOf(meta.pubkey.toString())),
                data: (0, (/*@__PURE__*/$parcel$interopDefault($d47ad8a6a3d340ae$exports))).encode(data)
            };
        });
        compiledInstructions.forEach((instruction)=>{
            $ca3473265f76df98$var$assert(instruction.programIdIndex >= 0);
            instruction.accounts.forEach((keyIndex)=>$ca3473265f76df98$var$assert(keyIndex >= 0));
        });
        return new $ca3473265f76df98$export$f69c19e57285b83a({
            header: {
                numRequiredSignatures: numRequiredSignatures,
                numReadonlySignedAccounts: numReadonlySignedAccounts,
                numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts
            },
            accountKeys: accountKeys,
            recentBlockhash: recentBlockhash,
            instructions: compiledInstructions
        });
    }
    /**
   * @internal
   */ _compile() {
        const message = this.compileMessage();
        const signedKeys = message.accountKeys.slice(0, message.header.numRequiredSignatures);
        if (this.signatures.length === signedKeys.length) {
            const valid = this.signatures.every((pair, index)=>{
                return signedKeys[index].equals(pair.publicKey);
            });
            if (valid) return message;
        }
        this.signatures = signedKeys.map((publicKey)=>({
                signature: null,
                publicKey: publicKey
            }));
        return message;
    }
    /**
   * Get a buffer of the Transaction data that need to be covered by signatures
   */ serializeMessage() {
        return this._compile().serialize();
    }
    /**
   * Get the estimated fee associated with a transaction
   *
   * @param {Connection} connection Connection to RPC Endpoint.
   *
   * @returns {Promise<number | null>} The estimated fee for the transaction
   */ async getEstimatedFee(connection) {
        return (await connection.getFeeForMessage(this.compileMessage())).value;
    }
    /**
   * Specify the public keys which will be used to sign the Transaction.
   * The first signer will be used as the transaction fee payer account.
   *
   * Signatures can be added with either `partialSign` or `addSignature`
   *
   * @deprecated Deprecated since v0.84.0. Only the fee payer needs to be
   * specified and it can be set in the Transaction constructor or with the
   * `feePayer` property.
   */ setSigners(...signers) {
        if (signers.length === 0) throw new Error("No signers");
        const seen = new Set();
        this.signatures = signers.filter((publicKey)=>{
            const key = publicKey.toString();
            if (seen.has(key)) return false;
            else {
                seen.add(key);
                return true;
            }
        }).map((publicKey)=>({
                signature: null,
                publicKey: publicKey
            }));
    }
    /**
   * Sign the Transaction with the specified signers. Multiple signatures may
   * be applied to a Transaction. The first signature is considered "primary"
   * and is used identify and confirm transactions.
   *
   * If the Transaction `feePayer` is not set, the first signer will be used
   * as the transaction fee payer account.
   *
   * Transaction fields should not be modified after the first call to `sign`,
   * as doing so may invalidate the signature and cause the Transaction to be
   * rejected.
   *
   * The Transaction must be assigned a valid `recentBlockhash` before invoking this method
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */ sign(...signers) {
        if (signers.length === 0) throw new Error("No signers");
        // Dedupe signers
        const seen = new Set();
        const uniqueSigners = [];
        for (const signer of signers){
            const key = signer.publicKey.toString();
            if (seen.has(key)) continue;
            else {
                seen.add(key);
                uniqueSigners.push(signer);
            }
        }
        this.signatures = uniqueSigners.map((signer)=>({
                signature: null,
                publicKey: signer.publicKey
            }));
        const message = this._compile();
        this._partialSign(message, ...uniqueSigners);
    }
    /**
   * Partially sign a transaction with the specified accounts. All accounts must
   * correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * All the caveats from the `sign` method apply to `partialSign`
   *
   * @param {Array<Signer>} signers Array of signers that will sign the transaction
   */ partialSign(...signers) {
        if (signers.length === 0) throw new Error("No signers");
        // Dedupe signers
        const seen = new Set();
        const uniqueSigners = [];
        for (const signer of signers){
            const key = signer.publicKey.toString();
            if (seen.has(key)) continue;
            else {
                seen.add(key);
                uniqueSigners.push(signer);
            }
        }
        const message = this._compile();
        this._partialSign(message, ...uniqueSigners);
    }
    /**
   * @internal
   */ _partialSign(message, ...signers) {
        const signData = message.serialize();
        signers.forEach((signer)=>{
            const signature = $ca3473265f76df98$var$sign(signData, signer.secretKey);
            this._addSignature(signer.publicKey, $ca3473265f76df98$var$toBuffer(signature));
        });
    }
    /**
   * Add an externally created signature to a transaction. The public key
   * must correspond to either the fee payer or a signer account in the transaction
   * instructions.
   *
   * @param {PublicKey} pubkey Public key that will be added to the transaction.
   * @param {Buffer} signature An externally created signature to add to the transaction.
   */ addSignature(pubkey, signature) {
        this._compile(); // Ensure signatures array is populated
        this._addSignature(pubkey, signature);
    }
    /**
   * @internal
   */ _addSignature(pubkey, signature) {
        $ca3473265f76df98$var$assert(signature.length === 64);
        const index = this.signatures.findIndex((sigpair)=>pubkey.equals(sigpair.publicKey));
        if (index < 0) throw new Error(`unknown signer: ${pubkey.toString()}`);
        this.signatures[index].signature = (0, $492757110c774bc9$export$a143d493d941bafc).from(signature);
    }
    /**
   * Verify signatures of a Transaction
   * Optional parameter specifies if we're expecting a fully signed Transaction or a partially signed one.
   * If no boolean is provided, we expect a fully signed Transaction by default.
   *
   * @param {boolean} [requireAllSignatures=true] Require a fully signed Transaction
   */ verifySignatures(requireAllSignatures = true) {
        const signatureErrors = this._getMessageSignednessErrors(this.serializeMessage(), requireAllSignatures);
        return !signatureErrors;
    }
    /**
   * @internal
   */ _getMessageSignednessErrors(message, requireAllSignatures) {
        const errors = {};
        for (const { signature: signature, publicKey: publicKey } of this.signatures){
            if (signature === null) {
                if (requireAllSignatures) (errors.missing ||= []).push(publicKey);
            } else if (!$ca3473265f76df98$var$verify(signature, message, publicKey.toBytes())) (errors.invalid ||= []).push(publicKey);
        }
        return errors.invalid || errors.missing ? errors : undefined;
    }
    /**
   * Serialize the Transaction in the wire format.
   *
   * @param {Buffer} [config] Config of transaction.
   *
   * @returns {Buffer} Signature of transaction in wire format.
   */ serialize(config) {
        const { requireAllSignatures: requireAllSignatures, verifySignatures: verifySignatures } = Object.assign({
            requireAllSignatures: true,
            verifySignatures: true
        }, config);
        const signData = this.serializeMessage();
        if (verifySignatures) {
            const sigErrors = this._getMessageSignednessErrors(signData, requireAllSignatures);
            if (sigErrors) {
                let errorMessage = "Signature verification failed.";
                if (sigErrors.invalid) errorMessage += `\nInvalid signature for public key${sigErrors.invalid.length === 1 ? "" : "(s)"} [\`${sigErrors.invalid.map((p)=>p.toBase58()).join("`, `")}\`].`;
                if (sigErrors.missing) errorMessage += `\nMissing signature for public key${sigErrors.missing.length === 1 ? "" : "(s)"} [\`${sigErrors.missing.map((p)=>p.toBase58()).join("`, `")}\`].`;
                throw new Error(errorMessage);
            }
        }
        return this._serialize(signData);
    }
    /**
   * @internal
   */ _serialize(signData) {
        const { signatures: signatures } = this;
        const signatureCount = [];
        $ca3473265f76df98$var$encodeLength(signatureCount, signatures.length);
        const transactionLength = signatureCount.length + signatures.length * 64 + signData.length;
        const wireTransaction = (0, $492757110c774bc9$export$a143d493d941bafc).alloc(transactionLength);
        $ca3473265f76df98$var$assert(signatures.length < 256);
        (0, $492757110c774bc9$export$a143d493d941bafc).from(signatureCount).copy(wireTransaction, 0);
        signatures.forEach(({ signature: signature }, index)=>{
            if (signature !== null) {
                $ca3473265f76df98$var$assert(signature.length === 64, `signature has invalid length`);
                (0, $492757110c774bc9$export$a143d493d941bafc).from(signature).copy(wireTransaction, signatureCount.length + index * 64);
            }
        });
        signData.copy(wireTransaction, signatureCount.length + signatures.length * 64);
        $ca3473265f76df98$var$assert(wireTransaction.length <= $ca3473265f76df98$export$4c6d5b89e1596f26, `Transaction too large: ${wireTransaction.length} > ${$ca3473265f76df98$export$4c6d5b89e1596f26}`);
        return wireTransaction;
    }
    /**
   * Deprecated method
   * @internal
   */ get keys() {
        $ca3473265f76df98$var$assert(this.instructions.length === 1);
        return this.instructions[0].keys.map((keyObj)=>keyObj.pubkey);
    }
    /**
   * Deprecated method
   * @internal
   */ get programId() {
        $ca3473265f76df98$var$assert(this.instructions.length === 1);
        return this.instructions[0].programId;
    }
    /**
   * Deprecated method
   * @internal
   */ get data() {
        $ca3473265f76df98$var$assert(this.instructions.length === 1);
        return this.instructions[0].data;
    }
    /**
   * Parse a wire transaction into a Transaction object.
   *
   * @param {Buffer | Uint8Array | Array<number>} buffer Signature of wire Transaction
   *
   * @returns {Transaction} Transaction associated with the signature
   */ static from(buffer) {
        // Slice up wire data
        let byteArray = [
            ...buffer
        ];
        const signatureCount = $ca3473265f76df98$var$decodeLength(byteArray);
        let signatures = [];
        for(let i = 0; i < signatureCount; i++){
            const signature = $ca3473265f76df98$var$guardedSplice(byteArray, 0, $ca3473265f76df98$export$14aee086fde78fa6);
            signatures.push((0, (/*@__PURE__*/$parcel$interopDefault($d47ad8a6a3d340ae$exports))).encode((0, $492757110c774bc9$export$a143d493d941bafc).from(signature)));
        }
        return $ca3473265f76df98$export$febc5573c75cefb0.populate($ca3473265f76df98$export$f69c19e57285b83a.from(byteArray), signatures);
    }
    /**
   * Populate Transaction object from message and signatures
   *
   * @param {Message} message Message of transaction
   * @param {Array<string>} signatures List of signatures to assign to the transaction
   *
   * @returns {Transaction} The populated Transaction
   */ static populate(message, signatures = []) {
        const transaction = new $ca3473265f76df98$export$febc5573c75cefb0();
        transaction.recentBlockhash = message.recentBlockhash;
        if (message.header.numRequiredSignatures > 0) transaction.feePayer = message.accountKeys[0];
        signatures.forEach((signature, index)=>{
            const sigPubkeyPair = {
                signature: signature == (0, (/*@__PURE__*/$parcel$interopDefault($d47ad8a6a3d340ae$exports))).encode($ca3473265f76df98$var$DEFAULT_SIGNATURE) ? null : (0, (/*@__PURE__*/$parcel$interopDefault($d47ad8a6a3d340ae$exports))).decode(signature),
                publicKey: message.accountKeys[index]
            };
            transaction.signatures.push(sigPubkeyPair);
        });
        message.instructions.forEach((instruction)=>{
            const keys = instruction.accounts.map((account)=>{
                const pubkey = message.accountKeys[account];
                return {
                    pubkey: pubkey,
                    isSigner: transaction.signatures.some((keyObj)=>keyObj.publicKey.toString() === pubkey.toString()) || message.isAccountSigner(account),
                    isWritable: message.isAccountWritable(account)
                };
            });
            transaction.instructions.push(new $ca3473265f76df98$export$a7a3aa8360ac9f59({
                keys: keys,
                programId: message.accountKeys[instruction.programIdIndex],
                data: (0, (/*@__PURE__*/$parcel$interopDefault($d47ad8a6a3d340ae$exports))).decode(instruction.data)
            }));
        });
        transaction._message = message;
        transaction._json = transaction.toJSON();
        return transaction;
    }
}
class $ca3473265f76df98$export$eb15f3e001dd262d {
    constructor(args){
        this.payerKey = void 0;
        this.instructions = void 0;
        this.recentBlockhash = void 0;
        this.payerKey = args.payerKey;
        this.instructions = args.instructions;
        this.recentBlockhash = args.recentBlockhash;
    }
    static decompile(message, args) {
        const { header: header, compiledInstructions: compiledInstructions, recentBlockhash: recentBlockhash } = message;
        const { numRequiredSignatures: numRequiredSignatures, numReadonlySignedAccounts: numReadonlySignedAccounts, numReadonlyUnsignedAccounts: numReadonlyUnsignedAccounts } = header;
        const numWritableSignedAccounts = numRequiredSignatures - numReadonlySignedAccounts;
        $ca3473265f76df98$var$assert(numWritableSignedAccounts > 0, "Message header is invalid");
        const numWritableUnsignedAccounts = message.staticAccountKeys.length - numRequiredSignatures - numReadonlyUnsignedAccounts;
        $ca3473265f76df98$var$assert(numWritableUnsignedAccounts >= 0, "Message header is invalid");
        const accountKeys = message.getAccountKeys(args);
        const payerKey = accountKeys.get(0);
        if (payerKey === undefined) throw new Error("Failed to decompile message because no account keys were found");
        const instructions = [];
        for (const compiledIx of compiledInstructions){
            const keys = [];
            for (const keyIndex of compiledIx.accountKeyIndexes){
                const pubkey = accountKeys.get(keyIndex);
                if (pubkey === undefined) throw new Error(`Failed to find key for account key index ${keyIndex}`);
                const isSigner = keyIndex < numRequiredSignatures;
                let isWritable;
                if (isSigner) isWritable = keyIndex < numWritableSignedAccounts;
                else if (keyIndex < accountKeys.staticAccountKeys.length) isWritable = keyIndex - numRequiredSignatures < numWritableUnsignedAccounts;
                else isWritable = keyIndex - accountKeys.staticAccountKeys.length < // accountKeysFromLookups cannot be undefined because we already found a pubkey for this index above
                accountKeys.accountKeysFromLookups.writable.length;
                keys.push({
                    pubkey: pubkey,
                    isSigner: keyIndex < header.numRequiredSignatures,
                    isWritable: isWritable
                });
            }
            const programId = accountKeys.get(compiledIx.programIdIndex);
            if (programId === undefined) throw new Error(`Failed to find program id for program id index ${compiledIx.programIdIndex}`);
            instructions.push(new $ca3473265f76df98$export$a7a3aa8360ac9f59({
                programId: programId,
                data: $ca3473265f76df98$var$toBuffer(compiledIx.data),
                keys: keys
            }));
        }
        return new $ca3473265f76df98$export$eb15f3e001dd262d({
            payerKey: payerKey,
            instructions: instructions,
            recentBlockhash: recentBlockhash
        });
    }
    compileToLegacyMessage() {
        return $ca3473265f76df98$export$f69c19e57285b83a.compile({
            payerKey: this.payerKey,
            recentBlockhash: this.recentBlockhash,
            instructions: this.instructions
        });
    }
    compileToV0Message(addressLookupTableAccounts) {
        return $ca3473265f76df98$export$ee274c70e0fae590.compile({
            payerKey: this.payerKey,
            recentBlockhash: this.recentBlockhash,
            instructions: this.instructions,
            addressLookupTableAccounts: addressLookupTableAccounts
        });
    }
}
/**
 * Versioned transaction class
 */ class $ca3473265f76df98$export$232cc3f078dcc284 {
    get version() {
        return this.message.version;
    }
    constructor(message, signatures){
        this.signatures = void 0;
        this.message = void 0;
        if (signatures !== undefined) {
            $ca3473265f76df98$var$assert(signatures.length === message.header.numRequiredSignatures, "Expected signatures length to be equal to the number of required signatures");
            this.signatures = signatures;
        } else {
            const defaultSignatures = [];
            for(let i = 0; i < message.header.numRequiredSignatures; i++)defaultSignatures.push(new Uint8Array($ca3473265f76df98$export$14aee086fde78fa6));
            this.signatures = defaultSignatures;
        }
        this.message = message;
    }
    serialize() {
        const serializedMessage = this.message.serialize();
        const encodedSignaturesLength = Array();
        $ca3473265f76df98$var$encodeLength(encodedSignaturesLength, this.signatures.length);
        const transactionLayout = $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.blob(encodedSignaturesLength.length, "encodedSignaturesLength"),
            $ab8b5713b1ee9109$exports.seq($ca3473265f76df98$var$signature(), this.signatures.length, "signatures"),
            $ab8b5713b1ee9109$exports.blob(serializedMessage.length, "serializedMessage")
        ]);
        const serializedTransaction = new Uint8Array(2048);
        const serializedTransactionLength = transactionLayout.encode({
            encodedSignaturesLength: new Uint8Array(encodedSignaturesLength),
            signatures: this.signatures,
            serializedMessage: serializedMessage
        }, serializedTransaction);
        return serializedTransaction.slice(0, serializedTransactionLength);
    }
    static deserialize(serializedTransaction) {
        let byteArray = [
            ...serializedTransaction
        ];
        const signatures = [];
        const signaturesLength = $ca3473265f76df98$var$decodeLength(byteArray);
        for(let i = 0; i < signaturesLength; i++)signatures.push(new Uint8Array($ca3473265f76df98$var$guardedSplice(byteArray, 0, $ca3473265f76df98$export$14aee086fde78fa6)));
        const message = $ca3473265f76df98$export$b0a61927d00ede7f.deserialize(new Uint8Array(byteArray));
        return new $ca3473265f76df98$export$232cc3f078dcc284(message, signatures);
    }
    sign(signers) {
        const messageData = this.message.serialize();
        const signerPubkeys = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
        for (const signer of signers){
            const signerIndex = signerPubkeys.findIndex((pubkey)=>pubkey.equals(signer.publicKey));
            $ca3473265f76df98$var$assert(signerIndex >= 0, `Cannot sign with non signer key ${signer.publicKey.toBase58()}`);
            this.signatures[signerIndex] = $ca3473265f76df98$var$sign(messageData, signer.secretKey);
        }
    }
    addSignature(publicKey, signature) {
        $ca3473265f76df98$var$assert(signature.byteLength === 64, "Signature must be 64 bytes long");
        const signerPubkeys = this.message.staticAccountKeys.slice(0, this.message.header.numRequiredSignatures);
        const signerIndex = signerPubkeys.findIndex((pubkey)=>pubkey.equals(publicKey));
        $ca3473265f76df98$var$assert(signerIndex >= 0, `Can not add signature; \`${publicKey.toBase58()}\` is not required to sign this transaction`);
        this.signatures[signerIndex] = signature;
    }
}
// TODO: These constants should be removed in favor of reading them out of a
// Syscall account
/**
 * @internal
 */ const $ca3473265f76df98$var$NUM_TICKS_PER_SECOND = 160;
/**
 * @internal
 */ const $ca3473265f76df98$var$DEFAULT_TICKS_PER_SLOT = 64;
/**
 * @internal
 */ const $ca3473265f76df98$var$NUM_SLOTS_PER_SECOND = $ca3473265f76df98$var$NUM_TICKS_PER_SECOND / $ca3473265f76df98$var$DEFAULT_TICKS_PER_SLOT;
/**
 * @internal
 */ const $ca3473265f76df98$var$MS_PER_SLOT = 1000 / $ca3473265f76df98$var$NUM_SLOTS_PER_SECOND;
const $ca3473265f76df98$export$393aa1412d47050e = new $ca3473265f76df98$export$ca8b6604d6ce14de("SysvarC1ock11111111111111111111111111111111");
const $ca3473265f76df98$export$2b71d479444d2f4 = new $ca3473265f76df98$export$ca8b6604d6ce14de("SysvarEpochSchedu1e111111111111111111111111");
const $ca3473265f76df98$export$54419cc1a3ece8d6 = new $ca3473265f76df98$export$ca8b6604d6ce14de("Sysvar1nstructions1111111111111111111111111");
const $ca3473265f76df98$export$e74201139e9833db = new $ca3473265f76df98$export$ca8b6604d6ce14de("SysvarRecentB1ockHashes11111111111111111111");
const $ca3473265f76df98$export$970d0190cdb3a8e9 = new $ca3473265f76df98$export$ca8b6604d6ce14de("SysvarRent111111111111111111111111111111111");
const $ca3473265f76df98$export$da3b38d796bc1af1 = new $ca3473265f76df98$export$ca8b6604d6ce14de("SysvarRewards111111111111111111111111111111");
const $ca3473265f76df98$export$7b3a057916a4a7ae = new $ca3473265f76df98$export$ca8b6604d6ce14de("SysvarS1otHashes111111111111111111111111111");
const $ca3473265f76df98$export$3272815bf0633907 = new $ca3473265f76df98$export$ca8b6604d6ce14de("SysvarS1otHistory11111111111111111111111111");
const $ca3473265f76df98$export$ca994171317280ea = new $ca3473265f76df98$export$ca8b6604d6ce14de("SysvarStakeHistory1111111111111111111111111");
class $ca3473265f76df98$export$121e803f723b3045 extends Error {
    constructor({ action: action, signature: signature, transactionMessage: transactionMessage, logs: logs }){
        const maybeLogsOutput = logs ? `Logs: \n${JSON.stringify(logs.slice(-10), null, 2)}. ` : "";
        const guideText = "\nCatch the `SendTransactionError` and call `getLogs()` on it for full details.";
        let message;
        switch(action){
            case "send":
                message = `Transaction ${signature} resulted in an error. \n` + `${transactionMessage}. ` + maybeLogsOutput + guideText;
                break;
            case "simulate":
                message = `Simulation failed. \nMessage: ${transactionMessage}. \n` + maybeLogsOutput + guideText;
                break;
            default:
                message = `Unknown action '${((a)=>a)(action)}'`;
        }
        super(message);
        this.signature = void 0;
        this.transactionMessage = void 0;
        this.transactionLogs = void 0;
        this.signature = signature;
        this.transactionMessage = transactionMessage;
        this.transactionLogs = logs ? logs : undefined;
    }
    get transactionError() {
        return {
            message: this.transactionMessage,
            logs: Array.isArray(this.transactionLogs) ? this.transactionLogs : undefined
        };
    }
    /* @deprecated Use `await getLogs()` instead */ get logs() {
        const cachedLogs = this.transactionLogs;
        if (cachedLogs != null && typeof cachedLogs === "object" && "then" in cachedLogs) return undefined;
        return cachedLogs;
    }
    async getLogs(connection) {
        if (!Array.isArray(this.transactionLogs)) this.transactionLogs = new Promise((resolve, reject)=>{
            connection.getTransaction(this.signature).then((tx)=>{
                if (tx && tx.meta && tx.meta.logMessages) {
                    const logs = tx.meta.logMessages;
                    this.transactionLogs = logs;
                    resolve(logs);
                } else reject(new Error("Log messages not found"));
            }).catch(reject);
        });
        return await this.transactionLogs;
    }
}
// Keep in sync with client/src/rpc_custom_errors.rs
// Typescript `enums` thwart tree-shaking. See https://bargsten.org/jsts/enums/
const $ca3473265f76df98$export$e5e9869922dd22f8 = {
    JSON_RPC_SERVER_ERROR_BLOCK_CLEANED_UP: -32001,
    JSON_RPC_SERVER_ERROR_SEND_TRANSACTION_PREFLIGHT_FAILURE: -32002,
    JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_VERIFICATION_FAILURE: -32003,
    JSON_RPC_SERVER_ERROR_BLOCK_NOT_AVAILABLE: -32004,
    JSON_RPC_SERVER_ERROR_NODE_UNHEALTHY: -32005,
    JSON_RPC_SERVER_ERROR_TRANSACTION_PRECOMPILE_VERIFICATION_FAILURE: -32006,
    JSON_RPC_SERVER_ERROR_SLOT_SKIPPED: -32007,
    JSON_RPC_SERVER_ERROR_NO_SNAPSHOT: -32008,
    JSON_RPC_SERVER_ERROR_LONG_TERM_STORAGE_SLOT_SKIPPED: -32009,
    JSON_RPC_SERVER_ERROR_KEY_EXCLUDED_FROM_SECONDARY_INDEX: -32010,
    JSON_RPC_SERVER_ERROR_TRANSACTION_HISTORY_NOT_AVAILABLE: -32011,
    JSON_RPC_SCAN_ERROR: -32012,
    JSON_RPC_SERVER_ERROR_TRANSACTION_SIGNATURE_LEN_MISMATCH: -32013,
    JSON_RPC_SERVER_ERROR_BLOCK_STATUS_NOT_AVAILABLE_YET: -32014,
    JSON_RPC_SERVER_ERROR_UNSUPPORTED_TRANSACTION_VERSION: -32015,
    JSON_RPC_SERVER_ERROR_MIN_CONTEXT_SLOT_NOT_REACHED: -32016
};
class $ca3473265f76df98$export$ea1b1a1bba5c14ad extends Error {
    constructor({ code: code, message: message, data: data }, customMessage){
        super(customMessage != null ? `${customMessage}: ${message}` : message);
        this.code = void 0;
        this.data = void 0;
        this.code = code;
        this.data = data;
        this.name = "SolanaJSONRPCError";
    }
}
/**
 * Sign, send and confirm a transaction.
 *
 * If `commitment` option is not specified, defaults to 'max' commitment.
 *
 * @param {Connection} connection
 * @param {Transaction} transaction
 * @param {Array<Signer>} signers
 * @param {ConfirmOptions} [options]
 * @returns {Promise<TransactionSignature>}
 */ async function $ca3473265f76df98$export$4ad6fe6dae0b6bc3(connection, transaction, signers, options) {
    const sendOptions = options && {
        skipPreflight: options.skipPreflight,
        preflightCommitment: options.preflightCommitment || options.commitment,
        maxRetries: options.maxRetries,
        minContextSlot: options.minContextSlot
    };
    const signature = await connection.sendTransaction(transaction, signers, sendOptions);
    let status;
    if (transaction.recentBlockhash != null && transaction.lastValidBlockHeight != null) status = (await connection.confirmTransaction({
        abortSignal: options?.abortSignal,
        signature: signature,
        blockhash: transaction.recentBlockhash,
        lastValidBlockHeight: transaction.lastValidBlockHeight
    }, options && options.commitment)).value;
    else if (transaction.minNonceContextSlot != null && transaction.nonceInfo != null) {
        const { nonceInstruction: nonceInstruction } = transaction.nonceInfo;
        const nonceAccountPubkey = nonceInstruction.keys[0].pubkey;
        status = (await connection.confirmTransaction({
            abortSignal: options?.abortSignal,
            minContextSlot: transaction.minNonceContextSlot,
            nonceAccountPubkey: nonceAccountPubkey,
            nonceValue: transaction.nonceInfo.nonce,
            signature: signature
        }, options && options.commitment)).value;
    } else {
        if (options?.abortSignal != null) console.warn("sendAndConfirmTransaction(): A transaction with a deprecated confirmation strategy was supplied along with an `abortSignal`. Only transactions having `lastValidBlockHeight` or a combination of `nonceInfo` and `minNonceContextSlot` are abortable.");
        status = (await connection.confirmTransaction(signature, options && options.commitment)).value;
    }
    if (status.err) {
        if (signature != null) throw new $ca3473265f76df98$export$121e803f723b3045({
            action: "send",
            signature: signature,
            transactionMessage: `Status: (${JSON.stringify(status)})`
        });
        throw new Error(`Transaction ${signature} failed (${JSON.stringify(status)})`);
    }
    return signature;
}
// zzz
function $ca3473265f76df98$var$sleep(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
/**
 * @internal
 */ /**
 * Populate a buffer of instruction data using an InstructionType
 * @internal
 */ function $ca3473265f76df98$var$encodeData(type, fields) {
    const allocLength = type.layout.span >= 0 ? type.layout.span : $ca3473265f76df98$var$getAlloc(type, fields);
    const data = (0, $492757110c774bc9$export$a143d493d941bafc).alloc(allocLength);
    const layoutFields = Object.assign({
        instruction: type.index
    }, fields);
    type.layout.encode(layoutFields, data);
    return data;
}
/**
 * Decode instruction data buffer using an InstructionType
 * @internal
 */ function $ca3473265f76df98$var$decodeData$1(type, buffer) {
    let data;
    try {
        data = type.layout.decode(buffer);
    } catch (err) {
        throw new Error("invalid instruction; " + err);
    }
    if (data.instruction !== type.index) throw new Error(`invalid instruction; instruction index mismatch ${data.instruction} != ${type.index}`);
    return data;
}
/**
 * https://github.com/solana-labs/solana/blob/90bedd7e067b5b8f3ddbb45da00a4e9cabb22c62/sdk/src/fee_calculator.rs#L7-L11
 *
 * @internal
 */ const $ca3473265f76df98$export$d1cc579b1c48f515 = $ab8b5713b1ee9109$exports.nu64("lamportsPerSignature");
/**
 * Calculator for transaction fees.
 *
 * @deprecated Deprecated since Solana v1.8.0.
 */ /**
 * See https://github.com/solana-labs/solana/blob/0ea2843ec9cdc517572b8e62c959f41b55cf4453/sdk/src/nonce_state.rs#L29-L32
 *
 * @internal
 */ const $ca3473265f76df98$var$NonceAccountLayout = $ab8b5713b1ee9109$exports.struct([
    $ab8b5713b1ee9109$exports.u32("version"),
    $ab8b5713b1ee9109$exports.u32("state"),
    $ca3473265f76df98$var$publicKey("authorizedPubkey"),
    $ca3473265f76df98$var$publicKey("nonce"),
    $ab8b5713b1ee9109$exports.struct([
        $ca3473265f76df98$export$d1cc579b1c48f515
    ], "feeCalculator")
]);
const $ca3473265f76df98$export$7126250b6d8bd94a = $ca3473265f76df98$var$NonceAccountLayout.span;
/**
 * A durable nonce is a 32 byte value encoded as a base58 string.
 */ /**
 * NonceAccount class
 */ class $ca3473265f76df98$export$ed1c2356ce604759 {
    /**
   * @internal
   */ constructor(args){
        this.authorizedPubkey = void 0;
        this.nonce = void 0;
        this.feeCalculator = void 0;
        this.authorizedPubkey = args.authorizedPubkey;
        this.nonce = args.nonce;
        this.feeCalculator = args.feeCalculator;
    }
    /**
   * Deserialize NonceAccount from the account data.
   *
   * @param buffer account data
   * @return NonceAccount
   */ static fromAccountData(buffer) {
        const nonceAccount = $ca3473265f76df98$var$NonceAccountLayout.decode($ca3473265f76df98$var$toBuffer(buffer), 0);
        return new $ca3473265f76df98$export$ed1c2356ce604759({
            authorizedPubkey: new $ca3473265f76df98$export$ca8b6604d6ce14de(nonceAccount.authorizedPubkey),
            nonce: new $ca3473265f76df98$export$ca8b6604d6ce14de(nonceAccount.nonce).toString(),
            feeCalculator: nonceAccount.feeCalculator
        });
    }
}
const $ca3473265f76df98$var$encodeDecode = (layout)=>{
    const decode = layout.decode.bind(layout);
    const encode = layout.encode.bind(layout);
    return {
        decode: decode,
        encode: encode
    };
};
const $ca3473265f76df98$var$bigInt = (length)=>(property)=>{
        const layout = (0, $ab8b5713b1ee9109$exports.blob)(length, property);
        const { encode: encode, decode: decode } = $ca3473265f76df98$var$encodeDecode(layout);
        const bigIntLayout = layout;
        bigIntLayout.decode = (buffer, offset)=>{
            const src = decode(buffer, offset);
            return (0, $681a4aa191fca251$exports.toBigIntLE)((0, $492757110c774bc9$export$a143d493d941bafc).from(src));
        };
        bigIntLayout.encode = (bigInt, buffer, offset)=>{
            const src = (0, $681a4aa191fca251$exports.toBufferLE)(bigInt, length);
            return encode(src, buffer, offset);
        };
        return bigIntLayout;
    };
const $ca3473265f76df98$var$u64 = $ca3473265f76df98$var$bigInt(8);
/**
 * Create account system transaction params
 */ /**
 * Transfer system transaction params
 */ /**
 * Assign system transaction params
 */ /**
 * Create account with seed system transaction params
 */ /**
 * Create nonce account system transaction params
 */ /**
 * Create nonce account with seed system transaction params
 */ /**
 * Initialize nonce account system instruction params
 */ /**
 * Advance nonce account system instruction params
 */ /**
 * Withdraw nonce account system transaction params
 */ /**
 * Authorize nonce account system transaction params
 */ /**
 * Allocate account system transaction params
 */ /**
 * Allocate account with seed system transaction params
 */ /**
 * Assign account with seed system transaction params
 */ /**
 * Transfer with seed system transaction params
 */ /** Decoded transfer system transaction instruction */ /** Decoded transferWithSeed system transaction instruction */ /**
 * System Instruction class
 */ class $ca3473265f76df98$export$f009802131fa3d06 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a system instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $ab8b5713b1ee9109$exports.u32("instruction");
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($ca3473265f76df98$export$74bdf41d8d1e7108))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error("Instruction type incorrect; not a SystemInstruction");
        return type;
    }
    /**
   * Decode a create account system instruction and retrieve the instruction params.
   */ static decodeCreateAccount(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { lamports: lamports, space: space, programId: programId } = $ca3473265f76df98$var$decodeData$1($ca3473265f76df98$export$74bdf41d8d1e7108.Create, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            newAccountPubkey: instruction.keys[1].pubkey,
            lamports: lamports,
            space: space,
            programId: new $ca3473265f76df98$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a transfer system instruction and retrieve the instruction params.
   */ static decodeTransfer(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { lamports: lamports } = $ca3473265f76df98$var$decodeData$1($ca3473265f76df98$export$74bdf41d8d1e7108.Transfer, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a transfer with seed system instruction and retrieve the instruction params.
   */ static decodeTransferWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports, seed: seed, programId: programId } = $ca3473265f76df98$var$decodeData$1($ca3473265f76df98$export$74bdf41d8d1e7108.TransferWithSeed, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            basePubkey: instruction.keys[1].pubkey,
            toPubkey: instruction.keys[2].pubkey,
            lamports: lamports,
            seed: seed,
            programId: new $ca3473265f76df98$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an allocate system instruction and retrieve the instruction params.
   */ static decodeAllocate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { space: space } = $ca3473265f76df98$var$decodeData$1($ca3473265f76df98$export$74bdf41d8d1e7108.Allocate, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            space: space
        };
    }
    /**
   * Decode an allocate with seed system instruction and retrieve the instruction params.
   */ static decodeAllocateWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { base: base, seed: seed, space: space, programId: programId } = $ca3473265f76df98$var$decodeData$1($ca3473265f76df98$export$74bdf41d8d1e7108.AllocateWithSeed, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            basePubkey: new $ca3473265f76df98$export$ca8b6604d6ce14de(base),
            seed: seed,
            space: space,
            programId: new $ca3473265f76df98$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an assign system instruction and retrieve the instruction params.
   */ static decodeAssign(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { programId: programId } = $ca3473265f76df98$var$decodeData$1($ca3473265f76df98$export$74bdf41d8d1e7108.Assign, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            programId: new $ca3473265f76df98$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode an assign with seed system instruction and retrieve the instruction params.
   */ static decodeAssignWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 1);
        const { base: base, seed: seed, programId: programId } = $ca3473265f76df98$var$decodeData$1($ca3473265f76df98$export$74bdf41d8d1e7108.AssignWithSeed, instruction.data);
        return {
            accountPubkey: instruction.keys[0].pubkey,
            basePubkey: new $ca3473265f76df98$export$ca8b6604d6ce14de(base),
            seed: seed,
            programId: new $ca3473265f76df98$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a create account with seed system instruction and retrieve the instruction params.
   */ static decodeCreateWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { base: base, seed: seed, lamports: lamports, space: space, programId: programId } = $ca3473265f76df98$var$decodeData$1($ca3473265f76df98$export$74bdf41d8d1e7108.CreateWithSeed, instruction.data);
        return {
            fromPubkey: instruction.keys[0].pubkey,
            newAccountPubkey: instruction.keys[1].pubkey,
            basePubkey: new $ca3473265f76df98$export$ca8b6604d6ce14de(base),
            seed: seed,
            lamports: lamports,
            space: space,
            programId: new $ca3473265f76df98$export$ca8b6604d6ce14de(programId)
        };
    }
    /**
   * Decode a nonce initialize system instruction and retrieve the instruction params.
   */ static decodeNonceInitialize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { authorized: authorized } = $ca3473265f76df98$var$decodeData$1($ca3473265f76df98$export$74bdf41d8d1e7108.InitializeNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: new $ca3473265f76df98$export$ca8b6604d6ce14de(authorized)
        };
    }
    /**
   * Decode a nonce advance system instruction and retrieve the instruction params.
   */ static decodeNonceAdvance(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $ca3473265f76df98$var$decodeData$1($ca3473265f76df98$export$74bdf41d8d1e7108.AdvanceNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey
        };
    }
    /**
   * Decode a nonce withdraw system instruction and retrieve the instruction params.
   */ static decodeNonceWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 5);
        const { lamports: lamports } = $ca3473265f76df98$var$decodeData$1($ca3473265f76df98$export$74bdf41d8d1e7108.WithdrawNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a nonce authorize system instruction and retrieve the instruction params.
   */ static decodeNonceAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { authorized: authorized } = $ca3473265f76df98$var$decodeData$1($ca3473265f76df98$export$74bdf41d8d1e7108.AuthorizeNonceAccount, instruction.data);
        return {
            noncePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[1].pubkey,
            newAuthorizedPubkey: new $ca3473265f76df98$export$ca8b6604d6ce14de(authorized)
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($ca3473265f76df98$export$d8c4e17726848113.programId)) throw new Error("invalid instruction; programId is not SystemProgram");
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid SystemInstructionType's
 */ /**
 * An enumeration of valid system InstructionType's
 * @internal
 */ const $ca3473265f76df98$export$74bdf41d8d1e7108 = Object.freeze({
    Create: {
        index: 0,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u32("instruction"),
            $ab8b5713b1ee9109$exports.ns64("lamports"),
            $ab8b5713b1ee9109$exports.ns64("space"),
            $ca3473265f76df98$var$publicKey("programId")
        ])
    },
    Assign: {
        index: 1,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u32("instruction"),
            $ca3473265f76df98$var$publicKey("programId")
        ])
    },
    Transfer: {
        index: 2,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u32("instruction"),
            $ca3473265f76df98$var$u64("lamports")
        ])
    },
    CreateWithSeed: {
        index: 3,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u32("instruction"),
            $ca3473265f76df98$var$publicKey("base"),
            $ca3473265f76df98$var$rustString("seed"),
            $ab8b5713b1ee9109$exports.ns64("lamports"),
            $ab8b5713b1ee9109$exports.ns64("space"),
            $ca3473265f76df98$var$publicKey("programId")
        ])
    },
    AdvanceNonceAccount: {
        index: 4,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u32("instruction")
        ])
    },
    WithdrawNonceAccount: {
        index: 5,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u32("instruction"),
            $ab8b5713b1ee9109$exports.ns64("lamports")
        ])
    },
    InitializeNonceAccount: {
        index: 6,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u32("instruction"),
            $ca3473265f76df98$var$publicKey("authorized")
        ])
    },
    AuthorizeNonceAccount: {
        index: 7,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u32("instruction"),
            $ca3473265f76df98$var$publicKey("authorized")
        ])
    },
    Allocate: {
        index: 8,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u32("instruction"),
            $ab8b5713b1ee9109$exports.ns64("space")
        ])
    },
    AllocateWithSeed: {
        index: 9,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u32("instruction"),
            $ca3473265f76df98$var$publicKey("base"),
            $ca3473265f76df98$var$rustString("seed"),
            $ab8b5713b1ee9109$exports.ns64("space"),
            $ca3473265f76df98$var$publicKey("programId")
        ])
    },
    AssignWithSeed: {
        index: 10,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u32("instruction"),
            $ca3473265f76df98$var$publicKey("base"),
            $ca3473265f76df98$var$rustString("seed"),
            $ca3473265f76df98$var$publicKey("programId")
        ])
    },
    TransferWithSeed: {
        index: 11,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u32("instruction"),
            $ca3473265f76df98$var$u64("lamports"),
            $ca3473265f76df98$var$rustString("seed"),
            $ca3473265f76df98$var$publicKey("programId")
        ])
    },
    UpgradeNonceAccount: {
        index: 12,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u32("instruction")
        ])
    }
});
/**
 * Factory class for transactions to interact with the System program
 */ class $ca3473265f76df98$export$d8c4e17726848113 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the System program
   */ /**
   * Generate a transaction instruction that creates a new account
   */ static createAccount(params) {
        const type = $ca3473265f76df98$export$74bdf41d8d1e7108.Create;
        const data = $ca3473265f76df98$var$encodeData(type, {
            lamports: params.lamports,
            space: params.space,
            programId: $ca3473265f76df98$var$toBuffer(params.programId.toBuffer())
        });
        return new $ca3473265f76df98$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.fromPubkey,
                    isSigner: true,
                    isWritable: true
                },
                {
                    pubkey: params.newAccountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that transfers lamports from one account to another
   */ static transfer(params) {
        let data;
        let keys;
        if ("basePubkey" in params) {
            const type = $ca3473265f76df98$export$74bdf41d8d1e7108.TransferWithSeed;
            data = $ca3473265f76df98$var$encodeData(type, {
                lamports: BigInt(params.lamports),
                seed: params.seed,
                programId: $ca3473265f76df98$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.fromPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                }
            ];
        } else {
            const type = $ca3473265f76df98$export$74bdf41d8d1e7108.Transfer;
            data = $ca3473265f76df98$var$encodeData(type, {
                lamports: BigInt(params.lamports)
            });
            keys = [
                {
                    pubkey: params.fromPubkey,
                    isSigner: true,
                    isWritable: true
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                }
            ];
        }
        return new $ca3473265f76df98$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that assigns an account to a program
   */ static assign(params) {
        let data;
        let keys;
        if ("basePubkey" in params) {
            const type = $ca3473265f76df98$export$74bdf41d8d1e7108.AssignWithSeed;
            data = $ca3473265f76df98$var$encodeData(type, {
                base: $ca3473265f76df98$var$toBuffer(params.basePubkey.toBuffer()),
                seed: params.seed,
                programId: $ca3473265f76df98$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ];
        } else {
            const type = $ca3473265f76df98$export$74bdf41d8d1e7108.Assign;
            data = $ca3473265f76df98$var$encodeData(type, {
                programId: $ca3473265f76df98$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ];
        }
        return new $ca3473265f76df98$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that creates a new account at
   *   an address generated with `from`, a seed, and programId
   */ static createAccountWithSeed(params) {
        const type = $ca3473265f76df98$export$74bdf41d8d1e7108.CreateWithSeed;
        const data = $ca3473265f76df98$var$encodeData(type, {
            base: $ca3473265f76df98$var$toBuffer(params.basePubkey.toBuffer()),
            seed: params.seed,
            lamports: params.lamports,
            space: params.space,
            programId: $ca3473265f76df98$var$toBuffer(params.programId.toBuffer())
        });
        let keys = [
            {
                pubkey: params.fromPubkey,
                isSigner: true,
                isWritable: true
            },
            {
                pubkey: params.newAccountPubkey,
                isSigner: false,
                isWritable: true
            }
        ];
        if (!params.basePubkey.equals(params.fromPubkey)) keys.push({
            pubkey: params.basePubkey,
            isSigner: true,
            isWritable: false
        });
        return new $ca3473265f76df98$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction that creates a new Nonce account
   */ static createNonceAccount(params) {
        const transaction = new $ca3473265f76df98$export$febc5573c75cefb0();
        if ("basePubkey" in params && "seed" in params) transaction.add($ca3473265f76df98$export$d8c4e17726848113.createAccountWithSeed({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.noncePubkey,
            basePubkey: params.basePubkey,
            seed: params.seed,
            lamports: params.lamports,
            space: $ca3473265f76df98$export$7126250b6d8bd94a,
            programId: this.programId
        }));
        else transaction.add($ca3473265f76df98$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.noncePubkey,
            lamports: params.lamports,
            space: $ca3473265f76df98$export$7126250b6d8bd94a,
            programId: this.programId
        }));
        const initParams = {
            noncePubkey: params.noncePubkey,
            authorizedPubkey: params.authorizedPubkey
        };
        transaction.add(this.nonceInitialize(initParams));
        return transaction;
    }
    /**
   * Generate an instruction to initialize a Nonce account
   */ static nonceInitialize(params) {
        const type = $ca3473265f76df98$export$74bdf41d8d1e7108.InitializeNonceAccount;
        const data = $ca3473265f76df98$var$encodeData(type, {
            authorized: $ca3473265f76df98$var$toBuffer(params.authorizedPubkey.toBuffer())
        });
        const instructionData = {
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $ca3473265f76df98$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $ca3473265f76df98$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $ca3473265f76df98$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate an instruction to advance the nonce in a Nonce account
   */ static nonceAdvance(params) {
        const type = $ca3473265f76df98$export$74bdf41d8d1e7108.AdvanceNonceAccount;
        const data = $ca3473265f76df98$var$encodeData(type);
        const instructionData = {
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $ca3473265f76df98$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $ca3473265f76df98$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a transaction instruction that withdraws lamports from a Nonce account
   */ static nonceWithdraw(params) {
        const type = $ca3473265f76df98$export$74bdf41d8d1e7108.WithdrawNonceAccount;
        const data = $ca3473265f76df98$var$encodeData(type, {
            lamports: params.lamports
        });
        return new $ca3473265f76df98$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.toPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $ca3473265f76df98$export$e74201139e9833db,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $ca3473265f76df98$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that authorizes a new PublicKey as the authority
   * on a Nonce account.
   */ static nonceAuthorize(params) {
        const type = $ca3473265f76df98$export$74bdf41d8d1e7108.AuthorizeNonceAccount;
        const data = $ca3473265f76df98$var$encodeData(type, {
            authorized: $ca3473265f76df98$var$toBuffer(params.newAuthorizedPubkey.toBuffer())
        });
        return new $ca3473265f76df98$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: params.noncePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction instruction that allocates space in an account without funding
   */ static allocate(params) {
        let data;
        let keys;
        if ("basePubkey" in params) {
            const type = $ca3473265f76df98$export$74bdf41d8d1e7108.AllocateWithSeed;
            data = $ca3473265f76df98$var$encodeData(type, {
                base: $ca3473265f76df98$var$toBuffer(params.basePubkey.toBuffer()),
                seed: params.seed,
                space: params.space,
                programId: $ca3473265f76df98$var$toBuffer(params.programId.toBuffer())
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: params.basePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ];
        } else {
            const type = $ca3473265f76df98$export$74bdf41d8d1e7108.Allocate;
            data = $ca3473265f76df98$var$encodeData(type, {
                space: params.space
            });
            keys = [
                {
                    pubkey: params.accountPubkey,
                    isSigner: true,
                    isWritable: true
                }
            ];
        }
        return new $ca3473265f76df98$export$a7a3aa8360ac9f59({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
}
$ca3473265f76df98$export$d8c4e17726848113.programId = new $ca3473265f76df98$export$ca8b6604d6ce14de("11111111111111111111111111111111");
// Keep program chunks under PACKET_DATA_SIZE, leaving enough room for the
// rest of the Transaction fields
//
// TODO: replace 300 with a proper constant for the size of the other
// Transaction fields
const $ca3473265f76df98$var$CHUNK_SIZE = $ca3473265f76df98$export$4c6d5b89e1596f26 - 300;
/**
 * Program loader interface
 */ class $ca3473265f76df98$export$3b0d6d7590275603 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Amount of program data placed in each load Transaction
   */ /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */ static getMinNumSignatures(dataLength) {
        return 2 * // Every transaction requires two signatures (payer + program)
        (Math.ceil(dataLength / $ca3473265f76df98$export$3b0d6d7590275603.chunkSize) + 1 + // Add one for Create transaction
        1 // Add one for Finalize transaction
        );
    }
    /**
   * Loads a generic program
   *
   * @param connection The connection to use
   * @param payer System account that pays to load the program
   * @param program Account to load the program into
   * @param programId Public key that identifies the loader
   * @param data Program octets
   * @return true if program was loaded successfully, false if program was already loaded
   */ static async load(connection, payer, program, programId, data) {
        {
            const balanceNeeded = await connection.getMinimumBalanceForRentExemption(data.length);
            // Fetch program account info to check if it has already been created
            const programInfo = await connection.getAccountInfo(program.publicKey, "confirmed");
            let transaction = null;
            if (programInfo !== null) {
                if (programInfo.executable) {
                    console.error("Program load failed, account is already executable");
                    return false;
                }
                if (programInfo.data.length !== data.length) {
                    transaction = transaction || new $ca3473265f76df98$export$febc5573c75cefb0();
                    transaction.add($ca3473265f76df98$export$d8c4e17726848113.allocate({
                        accountPubkey: program.publicKey,
                        space: data.length
                    }));
                }
                if (!programInfo.owner.equals(programId)) {
                    transaction = transaction || new $ca3473265f76df98$export$febc5573c75cefb0();
                    transaction.add($ca3473265f76df98$export$d8c4e17726848113.assign({
                        accountPubkey: program.publicKey,
                        programId: programId
                    }));
                }
                if (programInfo.lamports < balanceNeeded) {
                    transaction = transaction || new $ca3473265f76df98$export$febc5573c75cefb0();
                    transaction.add($ca3473265f76df98$export$d8c4e17726848113.transfer({
                        fromPubkey: payer.publicKey,
                        toPubkey: program.publicKey,
                        lamports: balanceNeeded - programInfo.lamports
                    }));
                }
            } else transaction = new $ca3473265f76df98$export$febc5573c75cefb0().add($ca3473265f76df98$export$d8c4e17726848113.createAccount({
                fromPubkey: payer.publicKey,
                newAccountPubkey: program.publicKey,
                lamports: balanceNeeded > 0 ? balanceNeeded : 1,
                space: data.length,
                programId: programId
            }));
            // If the account is already created correctly, skip this step
            // and proceed directly to loading instructions
            if (transaction !== null) await $ca3473265f76df98$export$4ad6fe6dae0b6bc3(connection, transaction, [
                payer,
                program
            ], {
                commitment: "confirmed"
            });
        }
        const dataLayout = $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u32("instruction"),
            $ab8b5713b1ee9109$exports.u32("offset"),
            $ab8b5713b1ee9109$exports.u32("bytesLength"),
            $ab8b5713b1ee9109$exports.u32("bytesLengthPadding"),
            $ab8b5713b1ee9109$exports.seq($ab8b5713b1ee9109$exports.u8("byte"), $ab8b5713b1ee9109$exports.offset($ab8b5713b1ee9109$exports.u32(), -8), "bytes")
        ]);
        const chunkSize = $ca3473265f76df98$export$3b0d6d7590275603.chunkSize;
        let offset = 0;
        let array = data;
        let transactions = [];
        while(array.length > 0){
            const bytes = array.slice(0, chunkSize);
            const data = (0, $492757110c774bc9$export$a143d493d941bafc).alloc(chunkSize + 16);
            dataLayout.encode({
                instruction: 0,
                offset: // Load instruction
                offset,
                bytes: bytes,
                bytesLength: 0,
                bytesLengthPadding: 0
            }, data);
            const transaction = new $ca3473265f76df98$export$febc5573c75cefb0().add({
                keys: [
                    {
                        pubkey: program.publicKey,
                        isSigner: true,
                        isWritable: true
                    }
                ],
                programId: programId,
                data: data
            });
            transactions.push($ca3473265f76df98$export$4ad6fe6dae0b6bc3(connection, transaction, [
                payer,
                program
            ], {
                commitment: "confirmed"
            }));
            // Delay between sends in an attempt to reduce rate limit errors
            if (connection._rpcEndpoint.includes("solana.com")) {
                const REQUESTS_PER_SECOND = 4;
                await $ca3473265f76df98$var$sleep(1000 / REQUESTS_PER_SECOND);
            }
            offset += chunkSize;
            array = array.slice(chunkSize);
        }
        await Promise.all(transactions);
        // Finalize the account loaded with program data for execution
        {
            const dataLayout = $ab8b5713b1ee9109$exports.struct([
                $ab8b5713b1ee9109$exports.u32("instruction")
            ]);
            const data = (0, $492757110c774bc9$export$a143d493d941bafc).alloc(dataLayout.span);
            dataLayout.encode({
                instruction: 1 // Finalize instruction
            }, data);
            const transaction = new $ca3473265f76df98$export$febc5573c75cefb0().add({
                keys: [
                    {
                        pubkey: program.publicKey,
                        isSigner: true,
                        isWritable: true
                    },
                    {
                        pubkey: $ca3473265f76df98$export$970d0190cdb3a8e9,
                        isSigner: false,
                        isWritable: false
                    }
                ],
                programId: programId,
                data: data
            });
            const deployCommitment = "processed";
            const finalizeSignature = await connection.sendTransaction(transaction, [
                payer,
                program
            ], {
                preflightCommitment: deployCommitment
            });
            const { context: context, value: value } = await connection.confirmTransaction({
                signature: finalizeSignature,
                lastValidBlockHeight: transaction.lastValidBlockHeight,
                blockhash: transaction.recentBlockhash
            }, deployCommitment);
            if (value.err) throw new Error(`Transaction ${finalizeSignature} failed (${JSON.stringify(value)})`);
            // We prevent programs from being usable until the slot after their deployment.
            // See https://github.com/solana-labs/solana/pull/29654
            while(true // eslint-disable-line no-constant-condition
            ){
                try {
                    const currentSlot = await connection.getSlot({
                        commitment: deployCommitment
                    });
                    if (currentSlot > context.slot) break;
                } catch  {
                /* empty */ }
                await new Promise((resolve)=>setTimeout(resolve, Math.round($ca3473265f76df98$var$MS_PER_SLOT / 2)));
            }
        }
        // success
        return true;
    }
}
$ca3473265f76df98$export$3b0d6d7590275603.chunkSize = $ca3473265f76df98$var$CHUNK_SIZE;
/**
 * @deprecated Deprecated since Solana v1.17.20.
 */ const $ca3473265f76df98$export$59833422f998b937 = new $ca3473265f76df98$export$ca8b6604d6ce14de("BPFLoader2111111111111111111111111111111111");
/**
 * Factory class for transactions to interact with a program loader
 *
 * @deprecated Deprecated since Solana v1.17.20.
 */ class $ca3473265f76df98$export$493be68e6a240d3b {
    /**
   * Minimum number of signatures required to load a program not including
   * retries
   *
   * Can be used to calculate transaction fees
   */ static getMinNumSignatures(dataLength) {
        return $ca3473265f76df98$export$3b0d6d7590275603.getMinNumSignatures(dataLength);
    }
    /**
   * Load a SBF program
   *
   * @param connection The connection to use
   * @param payer Account that will pay program loading fees
   * @param program Account to load the program into
   * @param elf The entire ELF containing the SBF program
   * @param loaderProgramId The program id of the BPF loader to use
   * @return true if program was loaded successfully, false if program was already loaded
   */ static load(connection, payer, program, elf, loaderProgramId) {
        return $ca3473265f76df98$export$3b0d6d7590275603.load(connection, payer, program, loaderProgramId, elf);
    }
}
function $ca3473265f76df98$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var $ca3473265f76df98$var$objToString = Object.prototype.toString;
var $ca3473265f76df98$var$objKeys = Object.keys || function(obj) {
    var keys = [];
    for(var name in obj)keys.push(name);
    return keys;
};
function $ca3473265f76df98$var$stringify(val, isArrayProp) {
    var i, max, str, keys, key, propVal, toStr;
    if (val === true) return "true";
    if (val === false) return "false";
    switch(typeof val){
        case "object":
            if (val === null) return null;
            else if (val.toJSON && typeof val.toJSON === "function") return $ca3473265f76df98$var$stringify(val.toJSON(), isArrayProp);
            else {
                toStr = $ca3473265f76df98$var$objToString.call(val);
                if (toStr === "[object Array]") {
                    str = "[";
                    max = val.length - 1;
                    for(i = 0; i < max; i++)str += $ca3473265f76df98$var$stringify(val[i], true) + ",";
                    if (max > -1) str += $ca3473265f76df98$var$stringify(val[i], true);
                    return str + "]";
                } else if (toStr === "[object Object]") {
                    // only object is left
                    keys = $ca3473265f76df98$var$objKeys(val).sort();
                    max = keys.length;
                    str = "";
                    i = 0;
                    while(i < max){
                        key = keys[i];
                        propVal = $ca3473265f76df98$var$stringify(val[key], false);
                        if (propVal !== undefined) {
                            if (str) str += ",";
                            str += JSON.stringify(key) + ":" + propVal;
                        }
                        i++;
                    }
                    return "{" + str + "}";
                } else return JSON.stringify(val);
            }
        case "function":
        case "undefined":
            return isArrayProp ? null : undefined;
        case "string":
            return JSON.stringify(val);
        default:
            return isFinite(val) ? val : null;
    }
}
var $ca3473265f76df98$var$fastStableStringify = function(val) {
    var returnVal = $ca3473265f76df98$var$stringify(val, false);
    if (returnVal !== undefined) return "" + returnVal;
};
var $ca3473265f76df98$var$fastStableStringify$1 = /*@__PURE__*/ $ca3473265f76df98$var$getDefaultExportFromCjs($ca3473265f76df98$var$fastStableStringify);
const $ca3473265f76df98$var$MINIMUM_SLOT_PER_EPOCH = 32;
// Returns the number of trailing zeros in the binary representation of self.
function $ca3473265f76df98$var$trailingZeros(n) {
    let trailingZeros = 0;
    while(n > 1){
        n /= 2;
        trailingZeros++;
    }
    return trailingZeros;
}
// Returns the smallest power of two greater than or equal to n
function $ca3473265f76df98$var$nextPowerOfTwo(n) {
    if (n === 0) return 1;
    n--;
    n |= n >> 1;
    n |= n >> 2;
    n |= n >> 4;
    n |= n >> 8;
    n |= n >> 16;
    n |= n >> 32;
    return n + 1;
}
/**
 * Epoch schedule
 * (see https://docs.solana.com/terminology#epoch)
 * Can be retrieved with the {@link Connection.getEpochSchedule} method
 */ class $ca3473265f76df98$export$df8ed3e830b1d591 {
    constructor(slotsPerEpoch, leaderScheduleSlotOffset, warmup, firstNormalEpoch, firstNormalSlot){
        /** The maximum number of slots in each epoch */ this.slotsPerEpoch = void 0;
        /** The number of slots before beginning of an epoch to calculate a leader schedule for that epoch */ this.leaderScheduleSlotOffset = void 0;
        /** Indicates whether epochs start short and grow */ this.warmup = void 0;
        /** The first epoch with `slotsPerEpoch` slots */ this.firstNormalEpoch = void 0;
        /** The first slot of `firstNormalEpoch` */ this.firstNormalSlot = void 0;
        this.slotsPerEpoch = slotsPerEpoch;
        this.leaderScheduleSlotOffset = leaderScheduleSlotOffset;
        this.warmup = warmup;
        this.firstNormalEpoch = firstNormalEpoch;
        this.firstNormalSlot = firstNormalSlot;
    }
    getEpoch(slot) {
        return this.getEpochAndSlotIndex(slot)[0];
    }
    getEpochAndSlotIndex(slot) {
        if (slot < this.firstNormalSlot) {
            const epoch = $ca3473265f76df98$var$trailingZeros($ca3473265f76df98$var$nextPowerOfTwo(slot + $ca3473265f76df98$var$MINIMUM_SLOT_PER_EPOCH + 1)) - $ca3473265f76df98$var$trailingZeros($ca3473265f76df98$var$MINIMUM_SLOT_PER_EPOCH) - 1;
            const epochLen = this.getSlotsInEpoch(epoch);
            const slotIndex = slot - (epochLen - $ca3473265f76df98$var$MINIMUM_SLOT_PER_EPOCH);
            return [
                epoch,
                slotIndex
            ];
        } else {
            const normalSlotIndex = slot - this.firstNormalSlot;
            const normalEpochIndex = Math.floor(normalSlotIndex / this.slotsPerEpoch);
            const epoch = this.firstNormalEpoch + normalEpochIndex;
            const slotIndex = normalSlotIndex % this.slotsPerEpoch;
            return [
                epoch,
                slotIndex
            ];
        }
    }
    getFirstSlotInEpoch(epoch) {
        if (epoch <= this.firstNormalEpoch) return (Math.pow(2, epoch) - 1) * $ca3473265f76df98$var$MINIMUM_SLOT_PER_EPOCH;
        else return (epoch - this.firstNormalEpoch) * this.slotsPerEpoch + this.firstNormalSlot;
    }
    getLastSlotInEpoch(epoch) {
        return this.getFirstSlotInEpoch(epoch) + this.getSlotsInEpoch(epoch) - 1;
    }
    getSlotsInEpoch(epoch) {
        if (epoch < this.firstNormalEpoch) return Math.pow(2, epoch + $ca3473265f76df98$var$trailingZeros($ca3473265f76df98$var$MINIMUM_SLOT_PER_EPOCH));
        else return this.slotsPerEpoch;
    }
}
var $ca3473265f76df98$var$fetchImpl = globalThis.fetch;
class $ca3473265f76df98$var$RpcWebSocketClient extends (0, $55b6c0896fbec178$export$b43a6d9568fa5272) {
    constructor(address, options, generate_request_id){
        const webSocketFactory = (url)=>{
            const rpc = (0, $55b6c0896fbec178$export$3909fb301d3dc8c9)(url, {
                autoconnect: true,
                max_reconnects: 5,
                reconnect: true,
                reconnect_interval: 1000,
                ...options
            });
            if ("socket" in rpc) this.underlyingSocket = rpc.socket;
            else this.underlyingSocket = rpc;
            return rpc;
        };
        super(webSocketFactory, address, options, generate_request_id);
        this.underlyingSocket = void 0;
    }
    call(...args) {
        const readyState = this.underlyingSocket?.readyState;
        if (readyState === 1 /* WebSocket.OPEN */ ) return super.call(...args);
        return Promise.reject(new Error("Tried to call a JSON-RPC method `" + args[0] + "` but the socket was not `CONNECTING` or `OPEN` (`readyState` was " + readyState + ")"));
    }
    notify(...args) {
        const readyState = this.underlyingSocket?.readyState;
        if (readyState === 1 /* WebSocket.OPEN */ ) return super.notify(...args);
        return Promise.reject(new Error("Tried to send a JSON-RPC notification `" + args[0] + "` but the socket was not `CONNECTING` or `OPEN` (`readyState` was " + readyState + ")"));
    }
}
/**
 * @internal
 */ /**
 * Decode account data buffer using an AccountType
 * @internal
 */ function $ca3473265f76df98$var$decodeData(type, data) {
    let decoded;
    try {
        decoded = type.layout.decode(data);
    } catch (err) {
        throw new Error("invalid instruction; " + err);
    }
    if (decoded.typeIndex !== type.index) throw new Error(`invalid account data; account type mismatch ${decoded.typeIndex} != ${type.index}`);
    return decoded;
}
/// The serialized size of lookup table metadata
const $ca3473265f76df98$var$LOOKUP_TABLE_META_SIZE = 56;
class $ca3473265f76df98$export$5b2310da10e607da {
    constructor(args){
        this.key = void 0;
        this.state = void 0;
        this.key = args.key;
        this.state = args.state;
    }
    isActive() {
        const U64_MAX = BigInt("0xffffffffffffffff");
        return this.state.deactivationSlot === U64_MAX;
    }
    static deserialize(accountData) {
        const meta = $ca3473265f76df98$var$decodeData($ca3473265f76df98$var$LookupTableMetaLayout, accountData);
        const serializedAddressesLen = accountData.length - $ca3473265f76df98$var$LOOKUP_TABLE_META_SIZE;
        $ca3473265f76df98$var$assert(serializedAddressesLen >= 0, "lookup table is invalid");
        $ca3473265f76df98$var$assert(serializedAddressesLen % 32 === 0, "lookup table is invalid");
        const numSerializedAddresses = serializedAddressesLen / 32;
        const { addresses: addresses } = $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.seq($ca3473265f76df98$var$publicKey(), numSerializedAddresses, "addresses")
        ]).decode(accountData.slice($ca3473265f76df98$var$LOOKUP_TABLE_META_SIZE));
        return {
            deactivationSlot: meta.deactivationSlot,
            lastExtendedSlot: meta.lastExtendedSlot,
            lastExtendedSlotStartIndex: meta.lastExtendedStartIndex,
            authority: meta.authority.length !== 0 ? new $ca3473265f76df98$export$ca8b6604d6ce14de(meta.authority[0]) : undefined,
            addresses: addresses.map((address)=>new $ca3473265f76df98$export$ca8b6604d6ce14de(address))
        };
    }
}
const $ca3473265f76df98$var$LookupTableMetaLayout = {
    index: 1,
    layout: $ab8b5713b1ee9109$exports.struct([
        $ab8b5713b1ee9109$exports.u32("typeIndex"),
        $ca3473265f76df98$var$u64("deactivationSlot"),
        $ab8b5713b1ee9109$exports.nu64("lastExtendedSlot"),
        $ab8b5713b1ee9109$exports.u8("lastExtendedStartIndex"),
        $ab8b5713b1ee9109$exports.u8(),
        // option
        $ab8b5713b1ee9109$exports.seq($ca3473265f76df98$var$publicKey(), $ab8b5713b1ee9109$exports.offset($ab8b5713b1ee9109$exports.u8(), -1), "authority")
    ])
};
const $ca3473265f76df98$var$URL_RE = /^[^:]+:\/\/([^:[]+|\[[^\]]+\])(:\d+)?(.*)/i;
function $ca3473265f76df98$var$makeWebsocketUrl(endpoint) {
    const matches = endpoint.match($ca3473265f76df98$var$URL_RE);
    if (matches == null) throw TypeError(`Failed to validate endpoint URL \`${endpoint}\``);
    const [_, // eslint-disable-line @typescript-eslint/no-unused-vars
    hostish, portWithColon, rest] = matches;
    const protocol = endpoint.startsWith("https:") ? "wss:" : "ws:";
    const startPort = portWithColon == null ? null : parseInt(portWithColon.slice(1), 10);
    const websocketPort = // Only shift the port by +1 as a convention for ws(s) only if given endpoint
    // is explicitly specifying the endpoint port (HTTP-based RPC), assuming
    // we're directly trying to connect to agave-validator's ws listening port.
    // When the endpoint omits the port, we're connecting to the protocol
    // default ports: http(80) or https(443) and it's assumed we're behind a reverse
    // proxy which manages WebSocket upgrade and backend port redirection.
    startPort == null ? "" : `:${startPort + 1}`;
    return `${protocol}//${hostish}${websocketPort}${rest}`;
}
const $ca3473265f76df98$var$PublicKeyFromString = (0, $c32abee974e85639$export$8c14e57e778d3873)((0, $c32abee974e85639$export$9544d5bb712b01ea)($ca3473265f76df98$export$ca8b6604d6ce14de), (0, $c32abee974e85639$export$22b082955e083ec3)(), (value)=>new $ca3473265f76df98$export$ca8b6604d6ce14de(value));
const $ca3473265f76df98$var$RawAccountDataResult = (0, $c32abee974e85639$export$65e3907585753458)([
    (0, $c32abee974e85639$export$22b082955e083ec3)(),
    (0, $c32abee974e85639$export$c8ec6e1ec9fefcb0)("base64")
]);
const $ca3473265f76df98$var$BufferFromRawAccountData = (0, $c32abee974e85639$export$8c14e57e778d3873)((0, $c32abee974e85639$export$9544d5bb712b01ea)((0, $492757110c774bc9$export$a143d493d941bafc)), $ca3473265f76df98$var$RawAccountDataResult, (value)=>(0, $492757110c774bc9$export$a143d493d941bafc).from(value[0], "base64"));
/**
 * Attempt to use a recent blockhash for up to 30 seconds
 * @internal
 */ const $ca3473265f76df98$export$fcb705732fb5c597 = 30000;
/**
 * HACK.
 * Copied from rpc-websockets/dist/lib/client.
 * Otherwise, `yarn build` fails with:
 * https://gist.github.com/steveluscher/c057eca81d479ef705cdb53162f9971d
 */ /** @internal */ /** @internal */ /** @internal */ /** @internal */ /** @internal */ /**
 * @internal
 * Every subscription contains the args used to open the subscription with
 * the server, and a list of callers interested in notifications.
 */ /**
 * @internal
 * A subscription may be in various states of connectedness. Only when it is
 * fully connected will it have a server subscription id associated with it.
 * This id can be returned to the server to unsubscribe the client entirely.
 */ /**
 * A type that encapsulates a subscription's RPC method
 * names and notification (callback) signature.
 */ /**
 * @internal
 * Utility type that keeps tagged unions intact while omitting properties.
 */ /**
 * @internal
 * This type represents a single subscribable 'topic.' It's made up of:
 *
 * - The args used to open the subscription with the server,
 * - The state of the subscription, in terms of its connectedness, and
 * - The set of callbacks to call when the server publishes notifications
 *
 * This record gets indexed by `SubscriptionConfigHash` and is used to
 * set up subscriptions, fan out notifications, and track subscription state.
 */ /**
 * @internal
 */ /**
 * Extra contextual information for RPC responses
 */ /**
 * Options for sending transactions
 */ /**
 * Options for confirming transactions
 */ /**
 * Options for getConfirmedSignaturesForAddress2
 */ /**
 * Options for getSignaturesForAddress
 */ /**
 * RPC Response with extra contextual information
 */ /**
 * A strategy for confirming transactions that uses the last valid
 * block height for a given blockhash to check for transaction expiration.
 */ /**
 * A strategy for confirming durable nonce transactions.
 */ /**
 * Properties shared by all transaction confirmation strategies
 */ /**
 * This type represents all transaction confirmation strategies
 */ /* @internal */ function $ca3473265f76df98$var$assertEndpointUrl(putativeUrl) {
    if (/^https?:/.test(putativeUrl) === false) throw new TypeError("Endpoint URL must start with `http:` or `https:`.");
    return putativeUrl;
}
/** @internal */ function $ca3473265f76df98$var$extractCommitmentFromConfig(commitmentOrConfig) {
    let commitment;
    let config;
    if (typeof commitmentOrConfig === "string") commitment = commitmentOrConfig;
    else if (commitmentOrConfig) {
        const { commitment: specifiedCommitment, ...specifiedConfig } = commitmentOrConfig;
        commitment = specifiedCommitment;
        config = specifiedConfig;
    }
    return {
        commitment: commitment,
        config: config
    };
}
/**
 * @internal
 */ function $ca3473265f76df98$var$applyDefaultMemcmpEncodingToFilters(filters) {
    return filters.map((filter)=>"memcmp" in filter ? {
            ...filter,
            memcmp: {
                ...filter.memcmp,
                encoding: filter.memcmp.encoding ?? "base58"
            }
        } : filter);
}
/**
 * @internal
 */ function $ca3473265f76df98$var$createRpcResult(result) {
    return (0, $c32abee974e85639$export$971dd5b0dfd021b6)([
        (0, $c32abee974e85639$export$bf9fb029d174d554)({
            jsonrpc: (0, $c32abee974e85639$export$c8ec6e1ec9fefcb0)("2.0"),
            id: (0, $c32abee974e85639$export$22b082955e083ec3)(),
            result: result
        }),
        (0, $c32abee974e85639$export$bf9fb029d174d554)({
            jsonrpc: (0, $c32abee974e85639$export$c8ec6e1ec9fefcb0)("2.0"),
            id: (0, $c32abee974e85639$export$22b082955e083ec3)(),
            error: (0, $c32abee974e85639$export$bf9fb029d174d554)({
                code: (0, $c32abee974e85639$export$19282c40b967aec6)(),
                message: (0, $c32abee974e85639$export$22b082955e083ec3)(),
                data: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$4154a199d7d90455)())
            })
        })
    ]);
}
const $ca3473265f76df98$var$UnknownRpcResult = $ca3473265f76df98$var$createRpcResult((0, $c32abee974e85639$export$19282c40b967aec6)());
/**
 * @internal
 */ function $ca3473265f76df98$var$jsonRpcResult(schema) {
    return (0, $c32abee974e85639$export$8c14e57e778d3873)($ca3473265f76df98$var$createRpcResult(schema), $ca3473265f76df98$var$UnknownRpcResult, (value)=>{
        if ("error" in value) return value;
        else return {
            ...value,
            result: (0, $c32abee974e85639$export$185802fd694ee1f5)(value.result, schema)
        };
    });
}
/**
 * @internal
 */ function $ca3473265f76df98$var$jsonRpcResultAndContext(value) {
    return $ca3473265f76df98$var$jsonRpcResult((0, $c32abee974e85639$export$bf9fb029d174d554)({
        context: (0, $c32abee974e85639$export$bf9fb029d174d554)({
            slot: (0, $c32abee974e85639$export$98e628dec113755e)()
        }),
        value: value
    }));
}
/**
 * @internal
 */ function $ca3473265f76df98$var$notificationResultAndContext(value) {
    return (0, $c32abee974e85639$export$bf9fb029d174d554)({
        context: (0, $c32abee974e85639$export$bf9fb029d174d554)({
            slot: (0, $c32abee974e85639$export$98e628dec113755e)()
        }),
        value: value
    });
}
/**
 * @internal
 */ function $ca3473265f76df98$var$versionedMessageFromResponse(version, response) {
    if (version === 0) return new $ca3473265f76df98$export$ee274c70e0fae590({
        header: response.header,
        staticAccountKeys: response.accountKeys.map((accountKey)=>new $ca3473265f76df98$export$ca8b6604d6ce14de(accountKey)),
        recentBlockhash: response.recentBlockhash,
        compiledInstructions: response.instructions.map((ix)=>({
                programIdIndex: ix.programIdIndex,
                accountKeyIndexes: ix.accounts,
                data: (0, (/*@__PURE__*/$parcel$interopDefault($d47ad8a6a3d340ae$exports))).decode(ix.data)
            })),
        addressTableLookups: response.addressTableLookups
    });
    else return new $ca3473265f76df98$export$f69c19e57285b83a(response);
}
/**
 * The level of commitment desired when querying state
 * <pre>
 *   'processed': Query the most recent block which has reached 1 confirmation by the connected node
 *   'confirmed': Query the most recent block which has reached 1 confirmation by the cluster
 *   'finalized': Query the most recent block which has been finalized by the cluster
 * </pre>
 */ // Deprecated as of v1.5.5
/**
 * A subset of Commitment levels, which are at least optimistically confirmed
 * <pre>
 *   'confirmed': Query the most recent block which has reached 1 confirmation by the cluster
 *   'finalized': Query the most recent block which has been finalized by the cluster
 * </pre>
 */ /**
 * Filter for largest accounts query
 * <pre>
 *   'circulating':    Return the largest accounts that are part of the circulating supply
 *   'nonCirculating': Return the largest accounts that are not part of the circulating supply
 * </pre>
 */ /**
 * Configuration object for changing `getAccountInfo` query behavior
 */ /**
 * Configuration object for changing `getBalance` query behavior
 */ /**
 * Configuration object for changing `getBlock` query behavior
 */ /**
 * Configuration object for changing `getBlock` query behavior
 */ /**
 * Configuration object for changing `getStakeMinimumDelegation` query behavior
 */ /**
 * Configuration object for changing `getBlockHeight` query behavior
 */ /**
 * Configuration object for changing `getEpochInfo` query behavior
 */ /**
 * Configuration object for changing `getInflationReward` query behavior
 */ /**
 * Configuration object for changing `getLatestBlockhash` query behavior
 */ /**
 * Configuration object for changing `isBlockhashValid` query behavior
 */ /**
 * Configuration object for changing `getSlot` query behavior
 */ /**
 * Configuration object for changing `getSlotLeader` query behavior
 */ /**
 * Configuration object for changing `getTransaction` query behavior
 */ /**
 * Configuration object for changing `getTransaction` query behavior
 */ /**
 * Configuration object for changing `getLargestAccounts` query behavior
 */ /**
 * Configuration object for changing `getSupply` request behavior
 */ /**
 * Configuration object for changing query behavior
 */ /**
 * Information describing a cluster node
 */ /**
 * Information describing a vote account
 */ /**
 * A collection of cluster vote accounts
 */ /**
 * Network Inflation
 * (see https://docs.solana.com/implemented-proposals/ed_overview)
 */ const $ca3473265f76df98$var$GetInflationGovernorResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    foundation: (0, $c32abee974e85639$export$98e628dec113755e)(),
    foundationTerm: (0, $c32abee974e85639$export$98e628dec113755e)(),
    initial: (0, $c32abee974e85639$export$98e628dec113755e)(),
    taper: (0, $c32abee974e85639$export$98e628dec113755e)(),
    terminal: (0, $c32abee974e85639$export$98e628dec113755e)()
});
/**
 * The inflation reward for an epoch
 */ /**
 * Expected JSON RPC response for the "getInflationReward" message
 */ const $ca3473265f76df98$var$GetInflationRewardResult = $ca3473265f76df98$var$jsonRpcResult((0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$bf9fb029d174d554)({
    epoch: (0, $c32abee974e85639$export$98e628dec113755e)(),
    effectiveSlot: (0, $c32abee974e85639$export$98e628dec113755e)(),
    amount: (0, $c32abee974e85639$export$98e628dec113755e)(),
    postBalance: (0, $c32abee974e85639$export$98e628dec113755e)(),
    commission: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$98e628dec113755e)()))
}))));
/**
 * Configuration object for changing `getRecentPrioritizationFees` query behavior
 */ /**
 * Expected JSON RPC response for the "getRecentPrioritizationFees" message
 */ const $ca3473265f76df98$var$GetRecentPrioritizationFeesResult = (0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$bf9fb029d174d554)({
    slot: (0, $c32abee974e85639$export$98e628dec113755e)(),
    prioritizationFee: (0, $c32abee974e85639$export$98e628dec113755e)()
}));
/**
 * Expected JSON RPC response for the "getInflationRate" message
 */ const $ca3473265f76df98$var$GetInflationRateResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    total: (0, $c32abee974e85639$export$98e628dec113755e)(),
    validator: (0, $c32abee974e85639$export$98e628dec113755e)(),
    foundation: (0, $c32abee974e85639$export$98e628dec113755e)(),
    epoch: (0, $c32abee974e85639$export$98e628dec113755e)()
});
/**
 * Information about the current epoch
 */ const $ca3473265f76df98$var$GetEpochInfoResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    epoch: (0, $c32abee974e85639$export$98e628dec113755e)(),
    slotIndex: (0, $c32abee974e85639$export$98e628dec113755e)(),
    slotsInEpoch: (0, $c32abee974e85639$export$98e628dec113755e)(),
    absoluteSlot: (0, $c32abee974e85639$export$98e628dec113755e)(),
    blockHeight: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$98e628dec113755e)()),
    transactionCount: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$98e628dec113755e)())
});
const $ca3473265f76df98$var$GetEpochScheduleResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    slotsPerEpoch: (0, $c32abee974e85639$export$98e628dec113755e)(),
    leaderScheduleSlotOffset: (0, $c32abee974e85639$export$98e628dec113755e)(),
    warmup: (0, $c32abee974e85639$export$4a21f16c33752377)(),
    firstNormalEpoch: (0, $c32abee974e85639$export$98e628dec113755e)(),
    firstNormalSlot: (0, $c32abee974e85639$export$98e628dec113755e)()
});
/**
 * Leader schedule
 * (see https://docs.solana.com/terminology#leader-schedule)
 */ const $ca3473265f76df98$var$GetLeaderScheduleResult = (0, $c32abee974e85639$export$e5185e241753e543)((0, $c32abee974e85639$export$22b082955e083ec3)(), (0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$98e628dec113755e)()));
/**
 * Transaction error or null
 */ const $ca3473265f76df98$var$TransactionErrorResult = (0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$971dd5b0dfd021b6)([
    (0, $c32abee974e85639$export$bf9fb029d174d554)({}),
    (0, $c32abee974e85639$export$22b082955e083ec3)()
]));
/**
 * Signature status for a transaction
 */ const $ca3473265f76df98$var$SignatureStatusResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    err: $ca3473265f76df98$var$TransactionErrorResult
});
/**
 * Transaction signature received notification
 */ const $ca3473265f76df98$var$SignatureReceivedResult = (0, $c32abee974e85639$export$c8ec6e1ec9fefcb0)("receivedSignature");
/**
 * Version info for a node
 */ const $ca3473265f76df98$var$VersionResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    "solana-core": (0, $c32abee974e85639$export$22b082955e083ec3)(),
    "feature-set": (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$98e628dec113755e)())
});
const $ca3473265f76df98$var$ParsedInstructionStruct = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    program: (0, $c32abee974e85639$export$22b082955e083ec3)(),
    programId: $ca3473265f76df98$var$PublicKeyFromString,
    parsed: (0, $c32abee974e85639$export$19282c40b967aec6)()
});
const $ca3473265f76df98$var$PartiallyDecodedInstructionStruct = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    programId: $ca3473265f76df98$var$PublicKeyFromString,
    accounts: (0, $c32abee974e85639$export$2f23118c22fb2630)($ca3473265f76df98$var$PublicKeyFromString),
    data: (0, $c32abee974e85639$export$22b082955e083ec3)()
});
const $ca3473265f76df98$var$SimulatedTransactionResponseStruct = $ca3473265f76df98$var$jsonRpcResultAndContext((0, $c32abee974e85639$export$bf9fb029d174d554)({
    err: (0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$971dd5b0dfd021b6)([
        (0, $c32abee974e85639$export$bf9fb029d174d554)({}),
        (0, $c32abee974e85639$export$22b082955e083ec3)()
    ])),
    logs: (0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$22b082955e083ec3)())),
    accounts: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$bf9fb029d174d554)({
        executable: (0, $c32abee974e85639$export$4a21f16c33752377)(),
        owner: (0, $c32abee974e85639$export$22b082955e083ec3)(),
        lamports: (0, $c32abee974e85639$export$98e628dec113755e)(),
        data: (0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$22b082955e083ec3)()),
        rentEpoch: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$98e628dec113755e)())
    }))))),
    unitsConsumed: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$98e628dec113755e)()),
    returnData: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$bf9fb029d174d554)({
        programId: (0, $c32abee974e85639$export$22b082955e083ec3)(),
        data: (0, $c32abee974e85639$export$65e3907585753458)([
            (0, $c32abee974e85639$export$22b082955e083ec3)(),
            (0, $c32abee974e85639$export$c8ec6e1ec9fefcb0)("base64")
        ])
    }))),
    innerInstructions: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$bf9fb029d174d554)({
        index: (0, $c32abee974e85639$export$98e628dec113755e)(),
        instructions: (0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$971dd5b0dfd021b6)([
            $ca3473265f76df98$var$ParsedInstructionStruct,
            $ca3473265f76df98$var$PartiallyDecodedInstructionStruct
        ]))
    }))))
}));
/**
 * Metadata for a parsed confirmed transaction on the ledger
 *
 * @deprecated Deprecated since RPC v1.8.0. Please use {@link ParsedTransactionMeta} instead.
 */ /**
 * Collection of addresses loaded by a transaction using address table lookups
 */ /**
 * Metadata for a parsed transaction on the ledger
 */ /**
 * Metadata for a confirmed transaction on the ledger
 */ /**
 * A processed transaction from the RPC API
 */ /**
 * A processed transaction from the RPC API
 */ /**
 * A processed transaction message from the RPC API
 */ /**
 * A confirmed transaction on the ledger
 *
 * @deprecated Deprecated since RPC v1.8.0.
 */ /**
 * A partially decoded transaction instruction
 */ /**
 * A parsed transaction message account
 */ /**
 * A parsed transaction instruction
 */ /**
 * A parsed address table lookup
 */ /**
 * A parsed transaction message
 */ /**
 * A parsed transaction
 */ /**
 * A parsed and confirmed transaction on the ledger
 *
 * @deprecated Deprecated since RPC v1.8.0. Please use {@link ParsedTransactionWithMeta} instead.
 */ /**
 * A parsed transaction on the ledger with meta
 */ /**
 * A processed block fetched from the RPC API
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `accounts`
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `none`
 */ /**
 * A block with parsed transactions
 */ /**
 * A block with parsed transactions where the `transactionDetails` mode is `accounts`
 */ /**
 * A block with parsed transactions where the `transactionDetails` mode is `none`
 */ /**
 * A processed block fetched from the RPC API
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `accounts`
 */ /**
 * A processed block fetched from the RPC API where the `transactionDetails` mode is `none`
 */ /**
 * A confirmed block on the ledger
 *
 * @deprecated Deprecated since RPC v1.8.0.
 */ /**
 * A Block on the ledger with signatures only
 */ /**
 * recent block production information
 */ /**
 * Expected JSON RPC response for the "getBlockProduction" message
 */ const $ca3473265f76df98$var$BlockProductionResponseStruct = $ca3473265f76df98$var$jsonRpcResultAndContext((0, $c32abee974e85639$export$bf9fb029d174d554)({
    byIdentity: (0, $c32abee974e85639$export$e5185e241753e543)((0, $c32abee974e85639$export$22b082955e083ec3)(), (0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$98e628dec113755e)())),
    range: (0, $c32abee974e85639$export$bf9fb029d174d554)({
        firstSlot: (0, $c32abee974e85639$export$98e628dec113755e)(),
        lastSlot: (0, $c32abee974e85639$export$98e628dec113755e)()
    })
}));
/**
 * A performance sample
 */ function $ca3473265f76df98$var$createRpcClient(url, httpHeaders, customFetch, fetchMiddleware, disableRetryOnRateLimit, httpAgent) {
    const fetch = customFetch ? customFetch : $ca3473265f76df98$var$fetchImpl;
    let agent;
    if (httpAgent != null) console.warn("You have supplied an `httpAgent` when creating a `Connection` in a browser environment.It has been ignored; `httpAgent` is only used in Node environments.");
    let fetchWithMiddleware;
    if (fetchMiddleware) fetchWithMiddleware = async (info, init)=>{
        const modifiedFetchArgs = await new Promise((resolve, reject)=>{
            try {
                fetchMiddleware(info, init, (modifiedInfo, modifiedInit)=>resolve([
                        modifiedInfo,
                        modifiedInit
                    ]));
            } catch (error) {
                reject(error);
            }
        });
        return await fetch(...modifiedFetchArgs);
    };
    const clientBrowser = new (0, (/*@__PURE__*/$parcel$interopDefault($b293ddc10e8e03aa$exports)))(async (request, callback)=>{
        const options = {
            method: "POST",
            body: request,
            agent: agent,
            headers: Object.assign({
                "Content-Type": "application/json"
            }, httpHeaders || {}, $ca3473265f76df98$var$COMMON_HTTP_HEADERS)
        };
        try {
            let too_many_requests_retries = 5;
            let res;
            let waitTime = 500;
            for(;;){
                if (fetchWithMiddleware) res = await fetchWithMiddleware(url, options);
                else res = await fetch(url, options);
                if (res.status !== 429 /* Too many requests */ ) break;
                if (disableRetryOnRateLimit === true) break;
                too_many_requests_retries -= 1;
                if (too_many_requests_retries === 0) break;
                console.error(`Server responded with ${res.status} ${res.statusText}.  Retrying after ${waitTime}ms delay...`);
                await $ca3473265f76df98$var$sleep(waitTime);
                waitTime *= 2;
            }
            const text = await res.text();
            if (res.ok) callback(null, text);
            else callback(new Error(`${res.status} ${res.statusText}: ${text}`));
        } catch (err) {
            if (err instanceof Error) callback(err);
        }
    }, {});
    return clientBrowser;
}
function $ca3473265f76df98$var$createRpcRequest(client) {
    return (method, args)=>{
        return new Promise((resolve, reject)=>{
            client.request(method, args, (err, response)=>{
                if (err) {
                    reject(err);
                    return;
                }
                resolve(response);
            });
        });
    };
}
function $ca3473265f76df98$var$createRpcBatchRequest(client) {
    return (requests)=>{
        return new Promise((resolve, reject)=>{
            // Do nothing if requests is empty
            if (requests.length === 0) resolve([]);
            const batch = requests.map((params)=>{
                return client.request(params.methodName, params.args);
            });
            client.request(batch, (err, response)=>{
                if (err) {
                    reject(err);
                    return;
                }
                resolve(response);
            });
        });
    };
}
/**
 * Expected JSON RPC response for the "getInflationGovernor" message
 */ const $ca3473265f76df98$var$GetInflationGovernorRpcResult = $ca3473265f76df98$var$jsonRpcResult($ca3473265f76df98$var$GetInflationGovernorResult);
/**
 * Expected JSON RPC response for the "getInflationRate" message
 */ const $ca3473265f76df98$var$GetInflationRateRpcResult = $ca3473265f76df98$var$jsonRpcResult($ca3473265f76df98$var$GetInflationRateResult);
/**
 * Expected JSON RPC response for the "getRecentPrioritizationFees" message
 */ const $ca3473265f76df98$var$GetRecentPrioritizationFeesRpcResult = $ca3473265f76df98$var$jsonRpcResult($ca3473265f76df98$var$GetRecentPrioritizationFeesResult);
/**
 * Expected JSON RPC response for the "getEpochInfo" message
 */ const $ca3473265f76df98$var$GetEpochInfoRpcResult = $ca3473265f76df98$var$jsonRpcResult($ca3473265f76df98$var$GetEpochInfoResult);
/**
 * Expected JSON RPC response for the "getEpochSchedule" message
 */ const $ca3473265f76df98$var$GetEpochScheduleRpcResult = $ca3473265f76df98$var$jsonRpcResult($ca3473265f76df98$var$GetEpochScheduleResult);
/**
 * Expected JSON RPC response for the "getLeaderSchedule" message
 */ const $ca3473265f76df98$var$GetLeaderScheduleRpcResult = $ca3473265f76df98$var$jsonRpcResult($ca3473265f76df98$var$GetLeaderScheduleResult);
/**
 * Expected JSON RPC response for the "minimumLedgerSlot" and "getFirstAvailableBlock" messages
 */ const $ca3473265f76df98$var$SlotRpcResult = $ca3473265f76df98$var$jsonRpcResult((0, $c32abee974e85639$export$98e628dec113755e)());
/**
 * Supply
 */ /**
 * Expected JSON RPC response for the "getSupply" message
 */ const $ca3473265f76df98$var$GetSupplyRpcResult = $ca3473265f76df98$var$jsonRpcResultAndContext((0, $c32abee974e85639$export$bf9fb029d174d554)({
    total: (0, $c32abee974e85639$export$98e628dec113755e)(),
    circulating: (0, $c32abee974e85639$export$98e628dec113755e)(),
    nonCirculating: (0, $c32abee974e85639$export$98e628dec113755e)(),
    nonCirculatingAccounts: (0, $c32abee974e85639$export$2f23118c22fb2630)($ca3473265f76df98$var$PublicKeyFromString)
}));
/**
 * Token amount object which returns a token amount in different formats
 * for various client use cases.
 */ /**
 * Expected JSON RPC structure for token amounts
 */ const $ca3473265f76df98$var$TokenAmountResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    amount: (0, $c32abee974e85639$export$22b082955e083ec3)(),
    uiAmount: (0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$98e628dec113755e)()),
    decimals: (0, $c32abee974e85639$export$98e628dec113755e)(),
    uiAmountString: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$22b082955e083ec3)())
});
/**
 * Token address and balance.
 */ /**
 * Expected JSON RPC response for the "getTokenLargestAccounts" message
 */ const $ca3473265f76df98$var$GetTokenLargestAccountsResult = $ca3473265f76df98$var$jsonRpcResultAndContext((0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$bf9fb029d174d554)({
    address: $ca3473265f76df98$var$PublicKeyFromString,
    amount: (0, $c32abee974e85639$export$22b082955e083ec3)(),
    uiAmount: (0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$98e628dec113755e)()),
    decimals: (0, $c32abee974e85639$export$98e628dec113755e)(),
    uiAmountString: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$22b082955e083ec3)())
})));
/**
 * Expected JSON RPC response for the "getTokenAccountsByOwner" message
 */ const $ca3473265f76df98$var$GetTokenAccountsByOwner = $ca3473265f76df98$var$jsonRpcResultAndContext((0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$bf9fb029d174d554)({
    pubkey: $ca3473265f76df98$var$PublicKeyFromString,
    account: (0, $c32abee974e85639$export$bf9fb029d174d554)({
        executable: (0, $c32abee974e85639$export$4a21f16c33752377)(),
        owner: $ca3473265f76df98$var$PublicKeyFromString,
        lamports: (0, $c32abee974e85639$export$98e628dec113755e)(),
        data: $ca3473265f76df98$var$BufferFromRawAccountData,
        rentEpoch: (0, $c32abee974e85639$export$98e628dec113755e)()
    })
})));
const $ca3473265f76df98$var$ParsedAccountDataResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    program: (0, $c32abee974e85639$export$22b082955e083ec3)(),
    parsed: (0, $c32abee974e85639$export$19282c40b967aec6)(),
    space: (0, $c32abee974e85639$export$98e628dec113755e)()
});
/**
 * Expected JSON RPC response for the "getTokenAccountsByOwner" message with parsed data
 */ const $ca3473265f76df98$var$GetParsedTokenAccountsByOwner = $ca3473265f76df98$var$jsonRpcResultAndContext((0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$bf9fb029d174d554)({
    pubkey: $ca3473265f76df98$var$PublicKeyFromString,
    account: (0, $c32abee974e85639$export$bf9fb029d174d554)({
        executable: (0, $c32abee974e85639$export$4a21f16c33752377)(),
        owner: $ca3473265f76df98$var$PublicKeyFromString,
        lamports: (0, $c32abee974e85639$export$98e628dec113755e)(),
        data: $ca3473265f76df98$var$ParsedAccountDataResult,
        rentEpoch: (0, $c32abee974e85639$export$98e628dec113755e)()
    })
})));
/**
 * Pair of an account address and its balance
 */ /**
 * Expected JSON RPC response for the "getLargestAccounts" message
 */ const $ca3473265f76df98$var$GetLargestAccountsRpcResult = $ca3473265f76df98$var$jsonRpcResultAndContext((0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$bf9fb029d174d554)({
    lamports: (0, $c32abee974e85639$export$98e628dec113755e)(),
    address: $ca3473265f76df98$var$PublicKeyFromString
})));
/**
 * @internal
 */ const $ca3473265f76df98$var$AccountInfoResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    executable: (0, $c32abee974e85639$export$4a21f16c33752377)(),
    owner: $ca3473265f76df98$var$PublicKeyFromString,
    lamports: (0, $c32abee974e85639$export$98e628dec113755e)(),
    data: $ca3473265f76df98$var$BufferFromRawAccountData,
    rentEpoch: (0, $c32abee974e85639$export$98e628dec113755e)()
});
/**
 * @internal
 */ const $ca3473265f76df98$var$KeyedAccountInfoResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    pubkey: $ca3473265f76df98$var$PublicKeyFromString,
    account: $ca3473265f76df98$var$AccountInfoResult
});
const $ca3473265f76df98$var$ParsedOrRawAccountData = (0, $c32abee974e85639$export$8c14e57e778d3873)((0, $c32abee974e85639$export$971dd5b0dfd021b6)([
    (0, $c32abee974e85639$export$9544d5bb712b01ea)((0, $492757110c774bc9$export$a143d493d941bafc)),
    $ca3473265f76df98$var$ParsedAccountDataResult
]), (0, $c32abee974e85639$export$971dd5b0dfd021b6)([
    $ca3473265f76df98$var$RawAccountDataResult,
    $ca3473265f76df98$var$ParsedAccountDataResult
]), (value)=>{
    if (Array.isArray(value)) return (0, $c32abee974e85639$export$185802fd694ee1f5)(value, $ca3473265f76df98$var$BufferFromRawAccountData);
    else return value;
});
/**
 * @internal
 */ const $ca3473265f76df98$var$ParsedAccountInfoResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    executable: (0, $c32abee974e85639$export$4a21f16c33752377)(),
    owner: $ca3473265f76df98$var$PublicKeyFromString,
    lamports: (0, $c32abee974e85639$export$98e628dec113755e)(),
    data: $ca3473265f76df98$var$ParsedOrRawAccountData,
    rentEpoch: (0, $c32abee974e85639$export$98e628dec113755e)()
});
const $ca3473265f76df98$var$KeyedParsedAccountInfoResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    pubkey: $ca3473265f76df98$var$PublicKeyFromString,
    account: $ca3473265f76df98$var$ParsedAccountInfoResult
});
/**
 * @internal
 */ const $ca3473265f76df98$var$StakeActivationResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    state: (0, $c32abee974e85639$export$971dd5b0dfd021b6)([
        (0, $c32abee974e85639$export$c8ec6e1ec9fefcb0)("active"),
        (0, $c32abee974e85639$export$c8ec6e1ec9fefcb0)("inactive"),
        (0, $c32abee974e85639$export$c8ec6e1ec9fefcb0)("activating"),
        (0, $c32abee974e85639$export$c8ec6e1ec9fefcb0)("deactivating")
    ]),
    active: (0, $c32abee974e85639$export$98e628dec113755e)(),
    inactive: (0, $c32abee974e85639$export$98e628dec113755e)()
});
/**
 * Expected JSON RPC response for the "getConfirmedSignaturesForAddress2" message
 */ const $ca3473265f76df98$var$GetConfirmedSignaturesForAddress2RpcResult = $ca3473265f76df98$var$jsonRpcResult((0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$bf9fb029d174d554)({
    signature: (0, $c32abee974e85639$export$22b082955e083ec3)(),
    slot: (0, $c32abee974e85639$export$98e628dec113755e)(),
    err: $ca3473265f76df98$var$TransactionErrorResult,
    memo: (0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$22b082955e083ec3)()),
    blockTime: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$98e628dec113755e)()))
})));
/**
 * Expected JSON RPC response for the "getSignaturesForAddress" message
 */ const $ca3473265f76df98$var$GetSignaturesForAddressRpcResult = $ca3473265f76df98$var$jsonRpcResult((0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$bf9fb029d174d554)({
    signature: (0, $c32abee974e85639$export$22b082955e083ec3)(),
    slot: (0, $c32abee974e85639$export$98e628dec113755e)(),
    err: $ca3473265f76df98$var$TransactionErrorResult,
    memo: (0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$22b082955e083ec3)()),
    blockTime: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$98e628dec113755e)()))
})));
/***
 * Expected JSON RPC response for the "accountNotification" message
 */ const $ca3473265f76df98$var$AccountNotificationResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    subscription: (0, $c32abee974e85639$export$98e628dec113755e)(),
    result: $ca3473265f76df98$var$notificationResultAndContext($ca3473265f76df98$var$AccountInfoResult)
});
/**
 * @internal
 */ const $ca3473265f76df98$var$ProgramAccountInfoResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    pubkey: $ca3473265f76df98$var$PublicKeyFromString,
    account: $ca3473265f76df98$var$AccountInfoResult
});
/***
 * Expected JSON RPC response for the "programNotification" message
 */ const $ca3473265f76df98$var$ProgramAccountNotificationResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    subscription: (0, $c32abee974e85639$export$98e628dec113755e)(),
    result: $ca3473265f76df98$var$notificationResultAndContext($ca3473265f76df98$var$ProgramAccountInfoResult)
});
/**
 * @internal
 */ const $ca3473265f76df98$var$SlotInfoResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    parent: (0, $c32abee974e85639$export$98e628dec113755e)(),
    slot: (0, $c32abee974e85639$export$98e628dec113755e)(),
    root: (0, $c32abee974e85639$export$98e628dec113755e)()
});
/**
 * Expected JSON RPC response for the "slotNotification" message
 */ const $ca3473265f76df98$var$SlotNotificationResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    subscription: (0, $c32abee974e85639$export$98e628dec113755e)(),
    result: $ca3473265f76df98$var$SlotInfoResult
});
/**
 * Slot updates which can be used for tracking the live progress of a cluster.
 * - `"firstShredReceived"`: connected node received the first shred of a block.
 * Indicates that a new block that is being produced.
 * - `"completed"`: connected node has received all shreds of a block. Indicates
 * a block was recently produced.
 * - `"optimisticConfirmation"`: block was optimistically confirmed by the
 * cluster. It is not guaranteed that an optimistic confirmation notification
 * will be sent for every finalized blocks.
 * - `"root"`: the connected node rooted this block.
 * - `"createdBank"`: the connected node has started validating this block.
 * - `"frozen"`: the connected node has validated this block.
 * - `"dead"`: the connected node failed to validate this block.
 */ /**
 * @internal
 */ const $ca3473265f76df98$var$SlotUpdateResult = (0, $c32abee974e85639$export$971dd5b0dfd021b6)([
    (0, $c32abee974e85639$export$bf9fb029d174d554)({
        type: (0, $c32abee974e85639$export$971dd5b0dfd021b6)([
            (0, $c32abee974e85639$export$c8ec6e1ec9fefcb0)("firstShredReceived"),
            (0, $c32abee974e85639$export$c8ec6e1ec9fefcb0)("completed"),
            (0, $c32abee974e85639$export$c8ec6e1ec9fefcb0)("optimisticConfirmation"),
            (0, $c32abee974e85639$export$c8ec6e1ec9fefcb0)("root")
        ]),
        slot: (0, $c32abee974e85639$export$98e628dec113755e)(),
        timestamp: (0, $c32abee974e85639$export$98e628dec113755e)()
    }),
    (0, $c32abee974e85639$export$bf9fb029d174d554)({
        type: (0, $c32abee974e85639$export$c8ec6e1ec9fefcb0)("createdBank"),
        parent: (0, $c32abee974e85639$export$98e628dec113755e)(),
        slot: (0, $c32abee974e85639$export$98e628dec113755e)(),
        timestamp: (0, $c32abee974e85639$export$98e628dec113755e)()
    }),
    (0, $c32abee974e85639$export$bf9fb029d174d554)({
        type: (0, $c32abee974e85639$export$c8ec6e1ec9fefcb0)("frozen"),
        slot: (0, $c32abee974e85639$export$98e628dec113755e)(),
        timestamp: (0, $c32abee974e85639$export$98e628dec113755e)(),
        stats: (0, $c32abee974e85639$export$bf9fb029d174d554)({
            numTransactionEntries: (0, $c32abee974e85639$export$98e628dec113755e)(),
            numSuccessfulTransactions: (0, $c32abee974e85639$export$98e628dec113755e)(),
            numFailedTransactions: (0, $c32abee974e85639$export$98e628dec113755e)(),
            maxTransactionsPerEntry: (0, $c32abee974e85639$export$98e628dec113755e)()
        })
    }),
    (0, $c32abee974e85639$export$bf9fb029d174d554)({
        type: (0, $c32abee974e85639$export$c8ec6e1ec9fefcb0)("dead"),
        slot: (0, $c32abee974e85639$export$98e628dec113755e)(),
        timestamp: (0, $c32abee974e85639$export$98e628dec113755e)(),
        err: (0, $c32abee974e85639$export$22b082955e083ec3)()
    })
]);
/**
 * Expected JSON RPC response for the "slotsUpdatesNotification" message
 */ const $ca3473265f76df98$var$SlotUpdateNotificationResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    subscription: (0, $c32abee974e85639$export$98e628dec113755e)(),
    result: $ca3473265f76df98$var$SlotUpdateResult
});
/**
 * Expected JSON RPC response for the "signatureNotification" message
 */ const $ca3473265f76df98$var$SignatureNotificationResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    subscription: (0, $c32abee974e85639$export$98e628dec113755e)(),
    result: $ca3473265f76df98$var$notificationResultAndContext((0, $c32abee974e85639$export$971dd5b0dfd021b6)([
        $ca3473265f76df98$var$SignatureStatusResult,
        $ca3473265f76df98$var$SignatureReceivedResult
    ]))
});
/**
 * Expected JSON RPC response for the "rootNotification" message
 */ const $ca3473265f76df98$var$RootNotificationResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    subscription: (0, $c32abee974e85639$export$98e628dec113755e)(),
    result: (0, $c32abee974e85639$export$98e628dec113755e)()
});
const $ca3473265f76df98$var$ContactInfoResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    pubkey: (0, $c32abee974e85639$export$22b082955e083ec3)(),
    gossip: (0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$22b082955e083ec3)()),
    tpu: (0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$22b082955e083ec3)()),
    rpc: (0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$22b082955e083ec3)()),
    version: (0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$22b082955e083ec3)())
});
const $ca3473265f76df98$var$VoteAccountInfoResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    votePubkey: (0, $c32abee974e85639$export$22b082955e083ec3)(),
    nodePubkey: (0, $c32abee974e85639$export$22b082955e083ec3)(),
    activatedStake: (0, $c32abee974e85639$export$98e628dec113755e)(),
    epochVoteAccount: (0, $c32abee974e85639$export$4a21f16c33752377)(),
    epochCredits: (0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$65e3907585753458)([
        (0, $c32abee974e85639$export$98e628dec113755e)(),
        (0, $c32abee974e85639$export$98e628dec113755e)(),
        (0, $c32abee974e85639$export$98e628dec113755e)()
    ])),
    commission: (0, $c32abee974e85639$export$98e628dec113755e)(),
    lastVote: (0, $c32abee974e85639$export$98e628dec113755e)(),
    rootSlot: (0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$98e628dec113755e)())
});
/**
 * Expected JSON RPC response for the "getVoteAccounts" message
 */ const $ca3473265f76df98$var$GetVoteAccounts = $ca3473265f76df98$var$jsonRpcResult((0, $c32abee974e85639$export$bf9fb029d174d554)({
    current: (0, $c32abee974e85639$export$2f23118c22fb2630)($ca3473265f76df98$var$VoteAccountInfoResult),
    delinquent: (0, $c32abee974e85639$export$2f23118c22fb2630)($ca3473265f76df98$var$VoteAccountInfoResult)
}));
const $ca3473265f76df98$var$ConfirmationStatus = (0, $c32abee974e85639$export$971dd5b0dfd021b6)([
    (0, $c32abee974e85639$export$c8ec6e1ec9fefcb0)("processed"),
    (0, $c32abee974e85639$export$c8ec6e1ec9fefcb0)("confirmed"),
    (0, $c32abee974e85639$export$c8ec6e1ec9fefcb0)("finalized")
]);
const $ca3473265f76df98$var$SignatureStatusResponse = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    slot: (0, $c32abee974e85639$export$98e628dec113755e)(),
    confirmations: (0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$98e628dec113755e)()),
    err: $ca3473265f76df98$var$TransactionErrorResult,
    confirmationStatus: (0, $c32abee974e85639$export$516e28dec6a4b6d4)($ca3473265f76df98$var$ConfirmationStatus)
});
/**
 * Expected JSON RPC response for the "getSignatureStatuses" message
 */ const $ca3473265f76df98$var$GetSignatureStatusesRpcResult = $ca3473265f76df98$var$jsonRpcResultAndContext((0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$133fc36489ac9add)($ca3473265f76df98$var$SignatureStatusResponse)));
/**
 * Expected JSON RPC response for the "getMinimumBalanceForRentExemption" message
 */ const $ca3473265f76df98$var$GetMinimumBalanceForRentExemptionRpcResult = $ca3473265f76df98$var$jsonRpcResult((0, $c32abee974e85639$export$98e628dec113755e)());
const $ca3473265f76df98$var$AddressTableLookupStruct = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    accountKey: $ca3473265f76df98$var$PublicKeyFromString,
    writableIndexes: (0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$98e628dec113755e)()),
    readonlyIndexes: (0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$98e628dec113755e)())
});
const $ca3473265f76df98$var$ConfirmedTransactionResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    signatures: (0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$22b082955e083ec3)()),
    message: (0, $c32abee974e85639$export$bf9fb029d174d554)({
        accountKeys: (0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$22b082955e083ec3)()),
        header: (0, $c32abee974e85639$export$bf9fb029d174d554)({
            numRequiredSignatures: (0, $c32abee974e85639$export$98e628dec113755e)(),
            numReadonlySignedAccounts: (0, $c32abee974e85639$export$98e628dec113755e)(),
            numReadonlyUnsignedAccounts: (0, $c32abee974e85639$export$98e628dec113755e)()
        }),
        instructions: (0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$bf9fb029d174d554)({
            accounts: (0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$98e628dec113755e)()),
            data: (0, $c32abee974e85639$export$22b082955e083ec3)(),
            programIdIndex: (0, $c32abee974e85639$export$98e628dec113755e)()
        })),
        recentBlockhash: (0, $c32abee974e85639$export$22b082955e083ec3)(),
        addressTableLookups: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$2f23118c22fb2630)($ca3473265f76df98$var$AddressTableLookupStruct))
    })
});
const $ca3473265f76df98$var$AnnotatedAccountKey = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    pubkey: $ca3473265f76df98$var$PublicKeyFromString,
    signer: (0, $c32abee974e85639$export$4a21f16c33752377)(),
    writable: (0, $c32abee974e85639$export$4a21f16c33752377)(),
    source: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$971dd5b0dfd021b6)([
        (0, $c32abee974e85639$export$c8ec6e1ec9fefcb0)("transaction"),
        (0, $c32abee974e85639$export$c8ec6e1ec9fefcb0)("lookupTable")
    ]))
});
const $ca3473265f76df98$var$ConfirmedTransactionAccountsModeResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    accountKeys: (0, $c32abee974e85639$export$2f23118c22fb2630)($ca3473265f76df98$var$AnnotatedAccountKey),
    signatures: (0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$22b082955e083ec3)())
});
const $ca3473265f76df98$var$ParsedInstructionResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    parsed: (0, $c32abee974e85639$export$19282c40b967aec6)(),
    program: (0, $c32abee974e85639$export$22b082955e083ec3)(),
    programId: $ca3473265f76df98$var$PublicKeyFromString
});
const $ca3473265f76df98$var$RawInstructionResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    accounts: (0, $c32abee974e85639$export$2f23118c22fb2630)($ca3473265f76df98$var$PublicKeyFromString),
    data: (0, $c32abee974e85639$export$22b082955e083ec3)(),
    programId: $ca3473265f76df98$var$PublicKeyFromString
});
const $ca3473265f76df98$var$InstructionResult = (0, $c32abee974e85639$export$971dd5b0dfd021b6)([
    $ca3473265f76df98$var$RawInstructionResult,
    $ca3473265f76df98$var$ParsedInstructionResult
]);
const $ca3473265f76df98$var$UnknownInstructionResult = (0, $c32abee974e85639$export$971dd5b0dfd021b6)([
    (0, $c32abee974e85639$export$bf9fb029d174d554)({
        parsed: (0, $c32abee974e85639$export$19282c40b967aec6)(),
        program: (0, $c32abee974e85639$export$22b082955e083ec3)(),
        programId: (0, $c32abee974e85639$export$22b082955e083ec3)()
    }),
    (0, $c32abee974e85639$export$bf9fb029d174d554)({
        accounts: (0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$22b082955e083ec3)()),
        data: (0, $c32abee974e85639$export$22b082955e083ec3)(),
        programId: (0, $c32abee974e85639$export$22b082955e083ec3)()
    })
]);
const $ca3473265f76df98$var$ParsedOrRawInstruction = (0, $c32abee974e85639$export$8c14e57e778d3873)($ca3473265f76df98$var$InstructionResult, $ca3473265f76df98$var$UnknownInstructionResult, (value)=>{
    if ("accounts" in value) return (0, $c32abee974e85639$export$185802fd694ee1f5)(value, $ca3473265f76df98$var$RawInstructionResult);
    else return (0, $c32abee974e85639$export$185802fd694ee1f5)(value, $ca3473265f76df98$var$ParsedInstructionResult);
});
/**
 * @internal
 */ const $ca3473265f76df98$var$ParsedConfirmedTransactionResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    signatures: (0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$22b082955e083ec3)()),
    message: (0, $c32abee974e85639$export$bf9fb029d174d554)({
        accountKeys: (0, $c32abee974e85639$export$2f23118c22fb2630)($ca3473265f76df98$var$AnnotatedAccountKey),
        instructions: (0, $c32abee974e85639$export$2f23118c22fb2630)($ca3473265f76df98$var$ParsedOrRawInstruction),
        recentBlockhash: (0, $c32abee974e85639$export$22b082955e083ec3)(),
        addressTableLookups: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$2f23118c22fb2630)($ca3473265f76df98$var$AddressTableLookupStruct)))
    })
});
const $ca3473265f76df98$var$TokenBalanceResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    accountIndex: (0, $c32abee974e85639$export$98e628dec113755e)(),
    mint: (0, $c32abee974e85639$export$22b082955e083ec3)(),
    owner: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$22b082955e083ec3)()),
    uiTokenAmount: $ca3473265f76df98$var$TokenAmountResult
});
const $ca3473265f76df98$var$LoadedAddressesResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    writable: (0, $c32abee974e85639$export$2f23118c22fb2630)($ca3473265f76df98$var$PublicKeyFromString),
    readonly: (0, $c32abee974e85639$export$2f23118c22fb2630)($ca3473265f76df98$var$PublicKeyFromString)
});
/**
 * @internal
 */ const $ca3473265f76df98$var$ConfirmedTransactionMetaResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    err: $ca3473265f76df98$var$TransactionErrorResult,
    fee: (0, $c32abee974e85639$export$98e628dec113755e)(),
    innerInstructions: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$bf9fb029d174d554)({
        index: (0, $c32abee974e85639$export$98e628dec113755e)(),
        instructions: (0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$bf9fb029d174d554)({
            accounts: (0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$98e628dec113755e)()),
            data: (0, $c32abee974e85639$export$22b082955e083ec3)(),
            programIdIndex: (0, $c32abee974e85639$export$98e628dec113755e)()
        }))
    })))),
    preBalances: (0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$98e628dec113755e)()),
    postBalances: (0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$98e628dec113755e)()),
    logMessages: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$22b082955e083ec3)()))),
    preTokenBalances: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$2f23118c22fb2630)($ca3473265f76df98$var$TokenBalanceResult))),
    postTokenBalances: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$2f23118c22fb2630)($ca3473265f76df98$var$TokenBalanceResult))),
    loadedAddresses: (0, $c32abee974e85639$export$516e28dec6a4b6d4)($ca3473265f76df98$var$LoadedAddressesResult),
    computeUnitsConsumed: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$98e628dec113755e)())
});
/**
 * @internal
 */ const $ca3473265f76df98$var$ParsedConfirmedTransactionMetaResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    err: $ca3473265f76df98$var$TransactionErrorResult,
    fee: (0, $c32abee974e85639$export$98e628dec113755e)(),
    innerInstructions: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$bf9fb029d174d554)({
        index: (0, $c32abee974e85639$export$98e628dec113755e)(),
        instructions: (0, $c32abee974e85639$export$2f23118c22fb2630)($ca3473265f76df98$var$ParsedOrRawInstruction)
    })))),
    preBalances: (0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$98e628dec113755e)()),
    postBalances: (0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$98e628dec113755e)()),
    logMessages: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$22b082955e083ec3)()))),
    preTokenBalances: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$2f23118c22fb2630)($ca3473265f76df98$var$TokenBalanceResult))),
    postTokenBalances: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$2f23118c22fb2630)($ca3473265f76df98$var$TokenBalanceResult))),
    loadedAddresses: (0, $c32abee974e85639$export$516e28dec6a4b6d4)($ca3473265f76df98$var$LoadedAddressesResult),
    computeUnitsConsumed: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$98e628dec113755e)())
});
const $ca3473265f76df98$var$TransactionVersionStruct = (0, $c32abee974e85639$export$971dd5b0dfd021b6)([
    (0, $c32abee974e85639$export$c8ec6e1ec9fefcb0)(0),
    (0, $c32abee974e85639$export$c8ec6e1ec9fefcb0)("legacy")
]);
/** @internal */ const $ca3473265f76df98$var$RewardsResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    pubkey: (0, $c32abee974e85639$export$22b082955e083ec3)(),
    lamports: (0, $c32abee974e85639$export$98e628dec113755e)(),
    postBalance: (0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$98e628dec113755e)()),
    rewardType: (0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$22b082955e083ec3)()),
    commission: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$98e628dec113755e)()))
});
/**
 * Expected JSON RPC response for the "getBlock" message
 */ const $ca3473265f76df98$var$GetBlockRpcResult = $ca3473265f76df98$var$jsonRpcResult((0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$bf9fb029d174d554)({
    blockhash: (0, $c32abee974e85639$export$22b082955e083ec3)(),
    previousBlockhash: (0, $c32abee974e85639$export$22b082955e083ec3)(),
    parentSlot: (0, $c32abee974e85639$export$98e628dec113755e)(),
    transactions: (0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$bf9fb029d174d554)({
        transaction: $ca3473265f76df98$var$ConfirmedTransactionResult,
        meta: (0, $c32abee974e85639$export$133fc36489ac9add)($ca3473265f76df98$var$ConfirmedTransactionMetaResult),
        version: (0, $c32abee974e85639$export$516e28dec6a4b6d4)($ca3473265f76df98$var$TransactionVersionStruct)
    })),
    rewards: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$2f23118c22fb2630)($ca3473265f76df98$var$RewardsResult)),
    blockTime: (0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$98e628dec113755e)()),
    blockHeight: (0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$98e628dec113755e)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message when `transactionDetails` is `none`
 */ const $ca3473265f76df98$var$GetNoneModeBlockRpcResult = $ca3473265f76df98$var$jsonRpcResult((0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$bf9fb029d174d554)({
    blockhash: (0, $c32abee974e85639$export$22b082955e083ec3)(),
    previousBlockhash: (0, $c32abee974e85639$export$22b082955e083ec3)(),
    parentSlot: (0, $c32abee974e85639$export$98e628dec113755e)(),
    rewards: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$2f23118c22fb2630)($ca3473265f76df98$var$RewardsResult)),
    blockTime: (0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$98e628dec113755e)()),
    blockHeight: (0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$98e628dec113755e)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message when `transactionDetails` is `accounts`
 */ const $ca3473265f76df98$var$GetAccountsModeBlockRpcResult = $ca3473265f76df98$var$jsonRpcResult((0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$bf9fb029d174d554)({
    blockhash: (0, $c32abee974e85639$export$22b082955e083ec3)(),
    previousBlockhash: (0, $c32abee974e85639$export$22b082955e083ec3)(),
    parentSlot: (0, $c32abee974e85639$export$98e628dec113755e)(),
    transactions: (0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$bf9fb029d174d554)({
        transaction: $ca3473265f76df98$var$ConfirmedTransactionAccountsModeResult,
        meta: (0, $c32abee974e85639$export$133fc36489ac9add)($ca3473265f76df98$var$ConfirmedTransactionMetaResult),
        version: (0, $c32abee974e85639$export$516e28dec6a4b6d4)($ca3473265f76df98$var$TransactionVersionStruct)
    })),
    rewards: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$2f23118c22fb2630)($ca3473265f76df98$var$RewardsResult)),
    blockTime: (0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$98e628dec113755e)()),
    blockHeight: (0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$98e628dec113755e)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message
 */ const $ca3473265f76df98$var$GetParsedBlockRpcResult = $ca3473265f76df98$var$jsonRpcResult((0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$bf9fb029d174d554)({
    blockhash: (0, $c32abee974e85639$export$22b082955e083ec3)(),
    previousBlockhash: (0, $c32abee974e85639$export$22b082955e083ec3)(),
    parentSlot: (0, $c32abee974e85639$export$98e628dec113755e)(),
    transactions: (0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$bf9fb029d174d554)({
        transaction: $ca3473265f76df98$var$ParsedConfirmedTransactionResult,
        meta: (0, $c32abee974e85639$export$133fc36489ac9add)($ca3473265f76df98$var$ParsedConfirmedTransactionMetaResult),
        version: (0, $c32abee974e85639$export$516e28dec6a4b6d4)($ca3473265f76df98$var$TransactionVersionStruct)
    })),
    rewards: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$2f23118c22fb2630)($ca3473265f76df98$var$RewardsResult)),
    blockTime: (0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$98e628dec113755e)()),
    blockHeight: (0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$98e628dec113755e)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message  when `transactionDetails` is `accounts`
 */ const $ca3473265f76df98$var$GetParsedAccountsModeBlockRpcResult = $ca3473265f76df98$var$jsonRpcResult((0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$bf9fb029d174d554)({
    blockhash: (0, $c32abee974e85639$export$22b082955e083ec3)(),
    previousBlockhash: (0, $c32abee974e85639$export$22b082955e083ec3)(),
    parentSlot: (0, $c32abee974e85639$export$98e628dec113755e)(),
    transactions: (0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$bf9fb029d174d554)({
        transaction: $ca3473265f76df98$var$ConfirmedTransactionAccountsModeResult,
        meta: (0, $c32abee974e85639$export$133fc36489ac9add)($ca3473265f76df98$var$ParsedConfirmedTransactionMetaResult),
        version: (0, $c32abee974e85639$export$516e28dec6a4b6d4)($ca3473265f76df98$var$TransactionVersionStruct)
    })),
    rewards: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$2f23118c22fb2630)($ca3473265f76df98$var$RewardsResult)),
    blockTime: (0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$98e628dec113755e)()),
    blockHeight: (0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$98e628dec113755e)())
})));
/**
 * Expected parsed JSON RPC response for the "getBlock" message  when `transactionDetails` is `none`
 */ const $ca3473265f76df98$var$GetParsedNoneModeBlockRpcResult = $ca3473265f76df98$var$jsonRpcResult((0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$bf9fb029d174d554)({
    blockhash: (0, $c32abee974e85639$export$22b082955e083ec3)(),
    previousBlockhash: (0, $c32abee974e85639$export$22b082955e083ec3)(),
    parentSlot: (0, $c32abee974e85639$export$98e628dec113755e)(),
    rewards: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$2f23118c22fb2630)($ca3473265f76df98$var$RewardsResult)),
    blockTime: (0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$98e628dec113755e)()),
    blockHeight: (0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$98e628dec113755e)())
})));
/**
 * Expected JSON RPC response for the "getConfirmedBlock" message
 *
 * @deprecated Deprecated since RPC v1.8.0. Please use {@link GetBlockRpcResult} instead.
 */ const $ca3473265f76df98$var$GetConfirmedBlockRpcResult = $ca3473265f76df98$var$jsonRpcResult((0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$bf9fb029d174d554)({
    blockhash: (0, $c32abee974e85639$export$22b082955e083ec3)(),
    previousBlockhash: (0, $c32abee974e85639$export$22b082955e083ec3)(),
    parentSlot: (0, $c32abee974e85639$export$98e628dec113755e)(),
    transactions: (0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$bf9fb029d174d554)({
        transaction: $ca3473265f76df98$var$ConfirmedTransactionResult,
        meta: (0, $c32abee974e85639$export$133fc36489ac9add)($ca3473265f76df98$var$ConfirmedTransactionMetaResult)
    })),
    rewards: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$2f23118c22fb2630)($ca3473265f76df98$var$RewardsResult)),
    blockTime: (0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$98e628dec113755e)())
})));
/**
 * Expected JSON RPC response for the "getBlock" message
 */ const $ca3473265f76df98$var$GetBlockSignaturesRpcResult = $ca3473265f76df98$var$jsonRpcResult((0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$bf9fb029d174d554)({
    blockhash: (0, $c32abee974e85639$export$22b082955e083ec3)(),
    previousBlockhash: (0, $c32abee974e85639$export$22b082955e083ec3)(),
    parentSlot: (0, $c32abee974e85639$export$98e628dec113755e)(),
    signatures: (0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$22b082955e083ec3)()),
    blockTime: (0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$98e628dec113755e)())
})));
/**
 * Expected JSON RPC response for the "getTransaction" message
 */ const $ca3473265f76df98$var$GetTransactionRpcResult = $ca3473265f76df98$var$jsonRpcResult((0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$bf9fb029d174d554)({
    slot: (0, $c32abee974e85639$export$98e628dec113755e)(),
    meta: (0, $c32abee974e85639$export$133fc36489ac9add)($ca3473265f76df98$var$ConfirmedTransactionMetaResult),
    blockTime: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$98e628dec113755e)())),
    transaction: $ca3473265f76df98$var$ConfirmedTransactionResult,
    version: (0, $c32abee974e85639$export$516e28dec6a4b6d4)($ca3473265f76df98$var$TransactionVersionStruct)
})));
/**
 * Expected parsed JSON RPC response for the "getTransaction" message
 */ const $ca3473265f76df98$var$GetParsedTransactionRpcResult = $ca3473265f76df98$var$jsonRpcResult((0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$bf9fb029d174d554)({
    slot: (0, $c32abee974e85639$export$98e628dec113755e)(),
    transaction: $ca3473265f76df98$var$ParsedConfirmedTransactionResult,
    meta: (0, $c32abee974e85639$export$133fc36489ac9add)($ca3473265f76df98$var$ParsedConfirmedTransactionMetaResult),
    blockTime: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$98e628dec113755e)())),
    version: (0, $c32abee974e85639$export$516e28dec6a4b6d4)($ca3473265f76df98$var$TransactionVersionStruct)
})));
/**
 * Expected JSON RPC response for the "getRecentBlockhash" message
 *
 * @deprecated Deprecated since RPC v1.8.0. Please use {@link GetLatestBlockhashRpcResult} instead.
 */ const $ca3473265f76df98$var$GetRecentBlockhashAndContextRpcResult = $ca3473265f76df98$var$jsonRpcResultAndContext((0, $c32abee974e85639$export$bf9fb029d174d554)({
    blockhash: (0, $c32abee974e85639$export$22b082955e083ec3)(),
    feeCalculator: (0, $c32abee974e85639$export$bf9fb029d174d554)({
        lamportsPerSignature: (0, $c32abee974e85639$export$98e628dec113755e)()
    })
}));
/**
 * Expected JSON RPC response for the "getLatestBlockhash" message
 */ const $ca3473265f76df98$var$GetLatestBlockhashRpcResult = $ca3473265f76df98$var$jsonRpcResultAndContext((0, $c32abee974e85639$export$bf9fb029d174d554)({
    blockhash: (0, $c32abee974e85639$export$22b082955e083ec3)(),
    lastValidBlockHeight: (0, $c32abee974e85639$export$98e628dec113755e)()
}));
/**
 * Expected JSON RPC response for the "isBlockhashValid" message
 */ const $ca3473265f76df98$var$IsBlockhashValidRpcResult = $ca3473265f76df98$var$jsonRpcResultAndContext((0, $c32abee974e85639$export$4a21f16c33752377)());
const $ca3473265f76df98$var$PerfSampleResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    slot: (0, $c32abee974e85639$export$98e628dec113755e)(),
    numTransactions: (0, $c32abee974e85639$export$98e628dec113755e)(),
    numSlots: (0, $c32abee974e85639$export$98e628dec113755e)(),
    samplePeriodSecs: (0, $c32abee974e85639$export$98e628dec113755e)()
});
/*
 * Expected JSON RPC response for "getRecentPerformanceSamples" message
 */ const $ca3473265f76df98$var$GetRecentPerformanceSamplesRpcResult = $ca3473265f76df98$var$jsonRpcResult((0, $c32abee974e85639$export$2f23118c22fb2630)($ca3473265f76df98$var$PerfSampleResult));
/**
 * Expected JSON RPC response for the "getFeeCalculatorForBlockhash" message
 */ const $ca3473265f76df98$var$GetFeeCalculatorRpcResult = $ca3473265f76df98$var$jsonRpcResultAndContext((0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$bf9fb029d174d554)({
    feeCalculator: (0, $c32abee974e85639$export$bf9fb029d174d554)({
        lamportsPerSignature: (0, $c32abee974e85639$export$98e628dec113755e)()
    })
})));
/**
 * Expected JSON RPC response for the "requestAirdrop" message
 */ const $ca3473265f76df98$var$RequestAirdropRpcResult = $ca3473265f76df98$var$jsonRpcResult((0, $c32abee974e85639$export$22b082955e083ec3)());
/**
 * Expected JSON RPC response for the "sendTransaction" message
 */ const $ca3473265f76df98$var$SendTransactionRpcResult = $ca3473265f76df98$var$jsonRpcResult((0, $c32abee974e85639$export$22b082955e083ec3)());
/**
 * Information about the latest slot being processed by a node
 */ /**
 * Parsed account data
 */ /**
 * Stake Activation data
 */ /**
 * Data slice argument for getProgramAccounts
 */ /**
 * Memory comparison filter for getProgramAccounts
 */ /**
 * Data size comparison filter for getProgramAccounts
 */ /**
 * A filter object for getProgramAccounts
 */ /**
 * Configuration object for getProgramAccounts requests
 */ /**
 * Configuration object for getParsedProgramAccounts
 */ /**
 * Configuration object for getMultipleAccounts
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getStakeActivation`
 */ /**
 * Configuration object for `getNonce`
 */ /**
 * Configuration object for `getNonceAndContext`
 */ /**
 * Information describing an account
 */ /**
 * Account information identified by pubkey
 */ /**
 * Callback function for account change notifications
 */ /**
 * Callback function for program account change notifications
 */ /**
 * Callback function for slot change notifications
 */ /**
 * Callback function for slot update notifications
 */ /**
 * Callback function for signature status notifications
 */ /**
 * Signature status notification with transaction result
 */ /**
 * Signature received notification
 */ /**
 * Callback function for signature notifications
 */ /**
 * Signature subscription options
 */ /**
 * Callback function for root change notifications
 */ /**
 * @internal
 */ const $ca3473265f76df98$var$LogsResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    err: $ca3473265f76df98$var$TransactionErrorResult,
    logs: (0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$22b082955e083ec3)()),
    signature: (0, $c32abee974e85639$export$22b082955e083ec3)()
});
/**
 * Logs result.
 */ /**
 * Expected JSON RPC response for the "logsNotification" message.
 */ const $ca3473265f76df98$var$LogsNotificationResult = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    result: $ca3473265f76df98$var$notificationResultAndContext($ca3473265f76df98$var$LogsResult),
    subscription: (0, $c32abee974e85639$export$98e628dec113755e)()
});
/**
 * Filter for log subscriptions.
 */ /**
 * Callback function for log notifications.
 */ /**
 * Signature result
 */ /**
 * Transaction error
 */ /**
 * Transaction confirmation status
 * <pre>
 *   'processed': Transaction landed in a block which has reached 1 confirmation by the connected node
 *   'confirmed': Transaction landed in a block which has reached 1 confirmation by the cluster
 *   'finalized': Transaction landed in a block which has been finalized by the cluster
 * </pre>
 */ /**
 * Signature status
 */ /**
 * A confirmed signature with its status
 */ /**
 * An object defining headers to be passed to the RPC server
 */ /**
 * The type of the JavaScript `fetch()` API
 */ /**
 * A callback used to augment the outgoing HTTP request
 */ /**
 * Configuration for instantiating a Connection
 */ /** @internal */ const $ca3473265f76df98$var$COMMON_HTTP_HEADERS = {
    "solana-client": `js/${"1.0.0-maintenance"}`
};
/**
 * A connection to a fullnode JSON RPC endpoint
 */ class $ca3473265f76df98$export$98b66c25bb38499d {
    /**
   * Establish a JSON RPC connection
   *
   * @param endpoint URL to the fullnode JSON RPC endpoint
   * @param commitmentOrConfig optional default commitment level or optional ConnectionConfig configuration object
   */ constructor(endpoint, _commitmentOrConfig){
        /** @internal */ this._commitment = void 0;
        /** @internal */ this._confirmTransactionInitialTimeout = void 0;
        /** @internal */ this._rpcEndpoint = void 0;
        /** @internal */ this._rpcWsEndpoint = void 0;
        /** @internal */ this._rpcClient = void 0;
        /** @internal */ this._rpcRequest = void 0;
        /** @internal */ this._rpcBatchRequest = void 0;
        /** @internal */ this._rpcWebSocket = void 0;
        /** @internal */ this._rpcWebSocketConnected = false;
        /** @internal */ this._rpcWebSocketHeartbeat = null;
        /** @internal */ this._rpcWebSocketIdleTimeout = null;
        /** @internal
     * A number that we increment every time an active connection closes.
     * Used to determine whether the same socket connection that was open
     * when an async operation started is the same one that's active when
     * its continuation fires.
     *
     */ this._rpcWebSocketGeneration = 0;
        /** @internal */ this._disableBlockhashCaching = false;
        /** @internal */ this._pollingBlockhash = false;
        /** @internal */ this._blockhashInfo = {
            latestBlockhash: null,
            lastFetch: 0,
            transactionSignatures: [],
            simulatedSignatures: []
        };
        /** @internal */ this._nextClientSubscriptionId = 0;
        /** @internal */ this._subscriptionDisposeFunctionsByClientSubscriptionId = {};
        /** @internal */ this._subscriptionHashByClientSubscriptionId = {};
        /** @internal */ this._subscriptionStateChangeCallbacksByHash = {};
        /** @internal */ this._subscriptionCallbacksByServerSubscriptionId = {};
        /** @internal */ this._subscriptionsByHash = {};
        /**
     * Special case.
     * After a signature is processed, RPCs automatically dispose of the
     * subscription on the server side. We need to track which of these
     * subscriptions have been disposed in such a way, so that we know
     * whether the client is dealing with a not-yet-processed signature
     * (in which case we must tear down the server subscription) or an
     * already-processed signature (in which case the client can simply
     * clear out the subscription locally without telling the server).
     *
     * NOTE: There is a proposal to eliminate this special case, here:
     * https://github.com/solana-labs/solana/issues/18892
     */ /** @internal */ this._subscriptionsAutoDisposedByRpc = new Set();
        /*
     * Returns the current block height of the node
     */ this.getBlockHeight = (()=>{
            const requestPromises = {};
            return async (commitmentOrConfig)=>{
                const { commitment: commitment, config: config } = $ca3473265f76df98$var$extractCommitmentFromConfig(commitmentOrConfig);
                const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
                const requestHash = $ca3473265f76df98$var$fastStableStringify$1(args);
                requestPromises[requestHash] = requestPromises[requestHash] ?? (async ()=>{
                    try {
                        const unsafeRes = await this._rpcRequest("getBlockHeight", args);
                        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$jsonRpcResult((0, $c32abee974e85639$export$98e628dec113755e)()));
                        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get block height information");
                        return res.result;
                    } finally{
                        delete requestPromises[requestHash];
                    }
                })();
                return await requestPromises[requestHash];
            };
        })();
        let wsEndpoint;
        let httpHeaders;
        let fetch;
        let fetchMiddleware;
        let disableRetryOnRateLimit;
        let httpAgent;
        if (_commitmentOrConfig && typeof _commitmentOrConfig === "string") this._commitment = _commitmentOrConfig;
        else if (_commitmentOrConfig) {
            this._commitment = _commitmentOrConfig.commitment;
            this._confirmTransactionInitialTimeout = _commitmentOrConfig.confirmTransactionInitialTimeout;
            wsEndpoint = _commitmentOrConfig.wsEndpoint;
            httpHeaders = _commitmentOrConfig.httpHeaders;
            fetch = _commitmentOrConfig.fetch;
            fetchMiddleware = _commitmentOrConfig.fetchMiddleware;
            disableRetryOnRateLimit = _commitmentOrConfig.disableRetryOnRateLimit;
            httpAgent = _commitmentOrConfig.httpAgent;
        }
        this._rpcEndpoint = $ca3473265f76df98$var$assertEndpointUrl(endpoint);
        this._rpcWsEndpoint = wsEndpoint || $ca3473265f76df98$var$makeWebsocketUrl(endpoint);
        this._rpcClient = $ca3473265f76df98$var$createRpcClient(endpoint, httpHeaders, fetch, fetchMiddleware, disableRetryOnRateLimit, httpAgent);
        this._rpcRequest = $ca3473265f76df98$var$createRpcRequest(this._rpcClient);
        this._rpcBatchRequest = $ca3473265f76df98$var$createRpcBatchRequest(this._rpcClient);
        this._rpcWebSocket = new $ca3473265f76df98$var$RpcWebSocketClient(this._rpcWsEndpoint, {
            autoconnect: false,
            max_reconnects: Infinity
        });
        this._rpcWebSocket.on("open", this._wsOnOpen.bind(this));
        this._rpcWebSocket.on("error", this._wsOnError.bind(this));
        this._rpcWebSocket.on("close", this._wsOnClose.bind(this));
        this._rpcWebSocket.on("accountNotification", this._wsOnAccountNotification.bind(this));
        this._rpcWebSocket.on("programNotification", this._wsOnProgramAccountNotification.bind(this));
        this._rpcWebSocket.on("slotNotification", this._wsOnSlotNotification.bind(this));
        this._rpcWebSocket.on("slotsUpdatesNotification", this._wsOnSlotUpdatesNotification.bind(this));
        this._rpcWebSocket.on("signatureNotification", this._wsOnSignatureNotification.bind(this));
        this._rpcWebSocket.on("rootNotification", this._wsOnRootNotification.bind(this));
        this._rpcWebSocket.on("logsNotification", this._wsOnLogsNotification.bind(this));
    }
    /**
   * The default commitment used for requests
   */ get commitment() {
        return this._commitment;
    }
    /**
   * The RPC endpoint
   */ get rpcEndpoint() {
        return this._rpcEndpoint;
    }
    /**
   * Fetch the balance for the specified public key, return with context
   */ async getBalanceAndContext(publicKey, commitmentOrConfig) {
        /** @internal */ const { commitment: commitment, config: config } = $ca3473265f76df98$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getBalance", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$jsonRpcResultAndContext((0, $c32abee974e85639$export$98e628dec113755e)()));
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, `failed to get balance for ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch the balance for the specified public key
   */ async getBalance(publicKey, commitmentOrConfig) {
        return await this.getBalanceAndContext(publicKey, commitmentOrConfig).then((x)=>x.value).catch((e)=>{
            throw new Error("failed to get balance of account " + publicKey.toBase58() + ": " + e);
        });
    }
    /**
   * Fetch the estimated production time of a block
   */ async getBlockTime(slot) {
        const unsafeRes = await this._rpcRequest("getBlockTime", [
            slot
        ]);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$jsonRpcResult((0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$98e628dec113755e)())));
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, `failed to get block time for slot ${slot}`);
        return res.result;
    }
    /**
   * Fetch the lowest slot that the node has information about in its ledger.
   * This value may increase over time if the node is configured to purge older ledger data
   */ async getMinimumLedgerSlot() {
        const unsafeRes = await this._rpcRequest("minimumLedgerSlot", []);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$jsonRpcResult((0, $c32abee974e85639$export$98e628dec113755e)()));
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get minimum ledger slot");
        return res.result;
    }
    /**
   * Fetch the slot of the lowest confirmed block that has not been purged from the ledger
   */ async getFirstAvailableBlock() {
        const unsafeRes = await this._rpcRequest("getFirstAvailableBlock", []);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$SlotRpcResult);
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get first available block");
        return res.result;
    }
    /**
   * Fetch information about the current supply
   */ async getSupply(config) {
        let configArg = {};
        if (typeof config === "string") configArg = {
            commitment: config
        };
        else if (config) configArg = {
            ...config,
            commitment: config && config.commitment || this.commitment
        };
        else configArg = {
            commitment: this.commitment
        };
        const unsafeRes = await this._rpcRequest("getSupply", [
            configArg
        ]);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetSupplyRpcResult);
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get supply");
        return res.result;
    }
    /**
   * Fetch the current supply of a token mint
   */ async getTokenSupply(tokenMintAddress, commitment) {
        const args = this._buildArgs([
            tokenMintAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest("getTokenSupply", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$jsonRpcResultAndContext($ca3473265f76df98$var$TokenAmountResult));
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get token supply");
        return res.result;
    }
    /**
   * Fetch the current balance of a token account
   */ async getTokenAccountBalance(tokenAddress, commitment) {
        const args = this._buildArgs([
            tokenAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest("getTokenAccountBalance", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$jsonRpcResultAndContext($ca3473265f76df98$var$TokenAmountResult));
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get token account balance");
        return res.result;
    }
    /**
   * Fetch all the token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<GetProgramAccountsResponse>}
   */ async getTokenAccountsByOwner(ownerAddress, filter, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $ca3473265f76df98$var$extractCommitmentFromConfig(commitmentOrConfig);
        let _args = [
            ownerAddress.toBase58()
        ];
        if ("mint" in filter) _args.push({
            mint: filter.mint.toBase58()
        });
        else _args.push({
            programId: filter.programId.toBase58()
        });
        const args = this._buildArgs(_args, commitment, "base64", config);
        const unsafeRes = await this._rpcRequest("getTokenAccountsByOwner", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetTokenAccountsByOwner);
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, `failed to get token accounts owned by account ${ownerAddress.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch parsed token accounts owned by the specified account
   *
   * @return {Promise<RpcResponseAndContext<Array<{pubkey: PublicKey, account: AccountInfo<ParsedAccountData>}>>>}
   */ async getParsedTokenAccountsByOwner(ownerAddress, filter, commitment) {
        let _args = [
            ownerAddress.toBase58()
        ];
        if ("mint" in filter) _args.push({
            mint: filter.mint.toBase58()
        });
        else _args.push({
            programId: filter.programId.toBase58()
        });
        const args = this._buildArgs(_args, commitment, "jsonParsed");
        const unsafeRes = await this._rpcRequest("getTokenAccountsByOwner", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetParsedTokenAccountsByOwner);
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, `failed to get token accounts owned by account ${ownerAddress.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch the 20 largest accounts with their current balances
   */ async getLargestAccounts(config) {
        const arg = {
            ...config,
            commitment: config && config.commitment || this.commitment
        };
        const args = arg.filter || arg.commitment ? [
            arg
        ] : [];
        const unsafeRes = await this._rpcRequest("getLargestAccounts", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetLargestAccountsRpcResult);
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get largest accounts");
        return res.result;
    }
    /**
   * Fetch the 20 largest token accounts with their current balances
   * for a given mint.
   */ async getTokenLargestAccounts(mintAddress, commitment) {
        const args = this._buildArgs([
            mintAddress.toBase58()
        ], commitment);
        const unsafeRes = await this._rpcRequest("getTokenLargestAccounts", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetTokenLargestAccountsResult);
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get token largest accounts");
        return res.result;
    }
    /**
   * Fetch all the account info for the specified public key, return with context
   */ async getAccountInfoAndContext(publicKey, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $ca3473265f76df98$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, "base64", config);
        const unsafeRes = await this._rpcRequest("getAccountInfo", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$jsonRpcResultAndContext((0, $c32abee974e85639$export$133fc36489ac9add)($ca3473265f76df98$var$AccountInfoResult)));
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, `failed to get info about account ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch parsed account info for the specified public key
   */ async getParsedAccountInfo(publicKey, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $ca3473265f76df98$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getAccountInfo", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$jsonRpcResultAndContext((0, $c32abee974e85639$export$133fc36489ac9add)($ca3473265f76df98$var$ParsedAccountInfoResult)));
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, `failed to get info about account ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch all the account info for the specified public key
   */ async getAccountInfo(publicKey, commitmentOrConfig) {
        try {
            const res = await this.getAccountInfoAndContext(publicKey, commitmentOrConfig);
            return res.value;
        } catch (e) {
            throw new Error("failed to get info about account " + publicKey.toBase58() + ": " + e);
        }
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */ async getMultipleParsedAccounts(publicKeys, rawConfig) {
        const { commitment: commitment, config: config } = $ca3473265f76df98$var$extractCommitmentFromConfig(rawConfig);
        const keys = publicKeys.map((key)=>key.toBase58());
        const args = this._buildArgs([
            keys
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getMultipleAccounts", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$jsonRpcResultAndContext((0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$133fc36489ac9add)($ca3473265f76df98$var$ParsedAccountInfoResult))));
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, `failed to get info for accounts ${keys}`);
        return res.result;
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys, return with context
   */ async getMultipleAccountsInfoAndContext(publicKeys, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $ca3473265f76df98$var$extractCommitmentFromConfig(commitmentOrConfig);
        const keys = publicKeys.map((key)=>key.toBase58());
        const args = this._buildArgs([
            keys
        ], commitment, "base64", config);
        const unsafeRes = await this._rpcRequest("getMultipleAccounts", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$jsonRpcResultAndContext((0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$133fc36489ac9add)($ca3473265f76df98$var$AccountInfoResult))));
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, `failed to get info for accounts ${keys}`);
        return res.result;
    }
    /**
   * Fetch all the account info for multiple accounts specified by an array of public keys
   */ async getMultipleAccountsInfo(publicKeys, commitmentOrConfig) {
        const res = await this.getMultipleAccountsInfoAndContext(publicKeys, commitmentOrConfig);
        return res.value;
    }
    /**
   * Returns epoch activation information for a stake account that has been delegated
   *
   * @deprecated Deprecated since RPC v1.18; will be removed in a future version.
   */ async getStakeActivation(publicKey, commitmentOrConfig, epoch) {
        const { commitment: commitment, config: config } = $ca3473265f76df98$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment, undefined /* encoding */ , {
            ...config,
            epoch: epoch != null ? epoch : config?.epoch
        });
        const unsafeRes = await this._rpcRequest("getStakeActivation", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$jsonRpcResult($ca3473265f76df98$var$StakeActivationResult));
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, `failed to get Stake Activation ${publicKey.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer>}>>}
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async getProgramAccounts(programId, configOrCommitment) {
        const { commitment: commitment, config: config } = $ca3473265f76df98$var$extractCommitmentFromConfig(configOrCommitment);
        const { encoding: encoding, ...configWithoutEncoding } = config || {};
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment, encoding || "base64", {
            ...configWithoutEncoding,
            ...configWithoutEncoding.filters ? {
                filters: $ca3473265f76df98$var$applyDefaultMemcmpEncodingToFilters(configWithoutEncoding.filters)
            } : null
        });
        const unsafeRes = await this._rpcRequest("getProgramAccounts", args);
        const baseSchema = (0, $c32abee974e85639$export$2f23118c22fb2630)($ca3473265f76df98$var$KeyedAccountInfoResult);
        const res = configWithoutEncoding.withContext === true ? (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$jsonRpcResultAndContext(baseSchema)) : (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$jsonRpcResult(baseSchema));
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, `failed to get accounts owned by program ${programId.toBase58()}`);
        return res.result;
    }
    /**
   * Fetch and parse all the accounts owned by the specified program id
   *
   * @return {Promise<Array<{pubkey: PublicKey, account: AccountInfo<Buffer | ParsedAccountData>}>>}
   */ async getParsedProgramAccounts(programId, configOrCommitment) {
        const { commitment: commitment, config: config } = $ca3473265f76df98$var$extractCommitmentFromConfig(configOrCommitment);
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getProgramAccounts", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$jsonRpcResult((0, $c32abee974e85639$export$2f23118c22fb2630)($ca3473265f76df98$var$KeyedParsedAccountInfoResult)));
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, `failed to get accounts owned by program ${programId.toBase58()}`);
        return res.result;
    }
    /** @deprecated Instead, call `confirmTransaction` and pass in {@link TransactionConfirmationStrategy} */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async confirmTransaction(strategy, commitment) {
        let rawSignature;
        if (typeof strategy == "string") rawSignature = strategy;
        else {
            const config = strategy;
            if (config.abortSignal?.aborted) return Promise.reject(config.abortSignal.reason);
            rawSignature = config.signature;
        }
        let decodedSignature;
        try {
            decodedSignature = (0, (/*@__PURE__*/$parcel$interopDefault($d47ad8a6a3d340ae$exports))).decode(rawSignature);
        } catch (err) {
            throw new Error("signature must be base58 encoded: " + rawSignature);
        }
        $ca3473265f76df98$var$assert(decodedSignature.length === 64, "signature has invalid length");
        if (typeof strategy === "string") return await this.confirmTransactionUsingLegacyTimeoutStrategy({
            commitment: commitment || this.commitment,
            signature: rawSignature
        });
        else if ("lastValidBlockHeight" in strategy) return await this.confirmTransactionUsingBlockHeightExceedanceStrategy({
            commitment: commitment || this.commitment,
            strategy: strategy
        });
        else return await this.confirmTransactionUsingDurableNonceStrategy({
            commitment: commitment || this.commitment,
            strategy: strategy
        });
    }
    getCancellationPromise(signal) {
        return new Promise((_, reject)=>{
            if (signal == null) return;
            if (signal.aborted) reject(signal.reason);
            else signal.addEventListener("abort", ()=>{
                reject(signal.reason);
            });
        });
    }
    getTransactionConfirmationPromise({ commitment: commitment, signature: signature }) {
        let signatureSubscriptionId;
        let disposeSignatureSubscriptionStateChangeObserver;
        let done = false;
        const confirmationPromise = new Promise((resolve, reject)=>{
            try {
                signatureSubscriptionId = this.onSignature(signature, (result, context)=>{
                    signatureSubscriptionId = undefined;
                    const response = {
                        context: context,
                        value: result
                    };
                    resolve({
                        __type: $ca3473265f76df98$export$7c391bd3b61d2374.PROCESSED,
                        response: response
                    });
                }, commitment);
                const subscriptionSetupPromise = new Promise((resolveSubscriptionSetup)=>{
                    if (signatureSubscriptionId == null) resolveSubscriptionSetup();
                    else disposeSignatureSubscriptionStateChangeObserver = this._onSubscriptionStateChange(signatureSubscriptionId, (nextState)=>{
                        if (nextState === "subscribed") resolveSubscriptionSetup();
                    });
                });
                (async ()=>{
                    await subscriptionSetupPromise;
                    if (done) return;
                    const response = await this.getSignatureStatus(signature);
                    if (done) return;
                    if (response == null) return;
                    const { context: context, value: value } = response;
                    if (value == null) return;
                    if (value?.err) reject(value.err);
                    else {
                        switch(commitment){
                            case "confirmed":
                            case "single":
                            case "singleGossip":
                                if (value.confirmationStatus === "processed") return;
                                break;
                            case "finalized":
                            case "max":
                            case "root":
                                if (value.confirmationStatus === "processed" || value.confirmationStatus === "confirmed") return;
                                break;
                            // exhaust enums to ensure full coverage
                            case "processed":
                            case "recent":
                        }
                        done = true;
                        resolve({
                            __type: $ca3473265f76df98$export$7c391bd3b61d2374.PROCESSED,
                            response: {
                                context: context,
                                value: value
                            }
                        });
                    }
                })();
            } catch (err) {
                reject(err);
            }
        });
        const abortConfirmation = ()=>{
            if (disposeSignatureSubscriptionStateChangeObserver) {
                disposeSignatureSubscriptionStateChangeObserver();
                disposeSignatureSubscriptionStateChangeObserver = undefined;
            }
            if (signatureSubscriptionId != null) {
                this.removeSignatureListener(signatureSubscriptionId);
                signatureSubscriptionId = undefined;
            }
        };
        return {
            abortConfirmation: abortConfirmation,
            confirmationPromise: confirmationPromise
        };
    }
    async confirmTransactionUsingBlockHeightExceedanceStrategy({ commitment: commitment, strategy: { abortSignal: abortSignal, lastValidBlockHeight: lastValidBlockHeight, signature: signature } }) {
        let done = false;
        const expiryPromise = new Promise((resolve)=>{
            const checkBlockHeight = async ()=>{
                try {
                    const blockHeight = await this.getBlockHeight(commitment);
                    return blockHeight;
                } catch (_e) {
                    return -1;
                }
            };
            (async ()=>{
                let currentBlockHeight = await checkBlockHeight();
                if (done) return;
                while(currentBlockHeight <= lastValidBlockHeight){
                    await $ca3473265f76df98$var$sleep(1000);
                    if (done) return;
                    currentBlockHeight = await checkBlockHeight();
                    if (done) return;
                }
                resolve({
                    __type: $ca3473265f76df98$export$7c391bd3b61d2374.BLOCKHEIGHT_EXCEEDED
                });
            })();
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        const cancellationPromise = this.getCancellationPromise(abortSignal);
        let result;
        try {
            const outcome = await Promise.race([
                cancellationPromise,
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $ca3473265f76df98$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else throw new $ca3473265f76df98$export$718fcd78527f88ed(signature);
        } finally{
            done = true;
            abortConfirmation();
        }
        return result;
    }
    async confirmTransactionUsingDurableNonceStrategy({ commitment: commitment, strategy: { abortSignal: abortSignal, minContextSlot: minContextSlot, nonceAccountPubkey: nonceAccountPubkey, nonceValue: nonceValue, signature: signature } }) {
        let done = false;
        const expiryPromise = new Promise((resolve)=>{
            let currentNonceValue = nonceValue;
            let lastCheckedSlot = null;
            const getCurrentNonceValue = async ()=>{
                try {
                    const { context: context, value: nonceAccount } = await this.getNonceAndContext(nonceAccountPubkey, {
                        commitment: commitment,
                        minContextSlot: minContextSlot
                    });
                    lastCheckedSlot = context.slot;
                    return nonceAccount?.nonce;
                } catch (e) {
                    // If for whatever reason we can't reach/read the nonce
                    // account, just keep using the last-known value.
                    return currentNonceValue;
                }
            };
            (async ()=>{
                currentNonceValue = await getCurrentNonceValue();
                if (done) return;
                while(true // eslint-disable-line no-constant-condition
                ){
                    if (nonceValue !== currentNonceValue) {
                        resolve({
                            __type: $ca3473265f76df98$export$7c391bd3b61d2374.NONCE_INVALID,
                            slotInWhichNonceDidAdvance: lastCheckedSlot
                        });
                        return;
                    }
                    await $ca3473265f76df98$var$sleep(2000);
                    if (done) return;
                    currentNonceValue = await getCurrentNonceValue();
                    if (done) return;
                }
            })();
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        const cancellationPromise = this.getCancellationPromise(abortSignal);
        let result;
        try {
            const outcome = await Promise.race([
                cancellationPromise,
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $ca3473265f76df98$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else {
                // Double check that the transaction is indeed unconfirmed.
                let signatureStatus;
                while(true // eslint-disable-line no-constant-condition
                ){
                    const status = await this.getSignatureStatus(signature);
                    if (status == null) break;
                    if (status.context.slot < (outcome.slotInWhichNonceDidAdvance ?? minContextSlot)) {
                        await $ca3473265f76df98$var$sleep(400);
                        continue;
                    }
                    signatureStatus = status;
                    break;
                }
                if (signatureStatus?.value) {
                    const commitmentForStatus = commitment || "finalized";
                    const { confirmationStatus: confirmationStatus } = signatureStatus.value;
                    switch(commitmentForStatus){
                        case "processed":
                        case "recent":
                            if (confirmationStatus !== "processed" && confirmationStatus !== "confirmed" && confirmationStatus !== "finalized") throw new $ca3473265f76df98$export$a3e7565a95f5a1e5(signature);
                            break;
                        case "confirmed":
                        case "single":
                        case "singleGossip":
                            if (confirmationStatus !== "confirmed" && confirmationStatus !== "finalized") throw new $ca3473265f76df98$export$a3e7565a95f5a1e5(signature);
                            break;
                        case "finalized":
                        case "max":
                        case "root":
                            if (confirmationStatus !== "finalized") throw new $ca3473265f76df98$export$a3e7565a95f5a1e5(signature);
                            break;
                        default:
                            // Exhaustive switch.
                            // eslint-disable-next-line @typescript-eslint/no-unused-vars
                            ((_)=>{})(commitmentForStatus);
                    }
                    result = {
                        context: signatureStatus.context,
                        value: {
                            err: signatureStatus.value.err
                        }
                    };
                } else throw new $ca3473265f76df98$export$a3e7565a95f5a1e5(signature);
            }
        } finally{
            done = true;
            abortConfirmation();
        }
        return result;
    }
    async confirmTransactionUsingLegacyTimeoutStrategy({ commitment: commitment, signature: signature }) {
        let timeoutId;
        const expiryPromise = new Promise((resolve)=>{
            let timeoutMs = this._confirmTransactionInitialTimeout || 60000;
            switch(commitment){
                case "processed":
                case "recent":
                case "single":
                case "confirmed":
                case "singleGossip":
                    timeoutMs = this._confirmTransactionInitialTimeout || 30000;
                    break;
            }
            timeoutId = setTimeout(()=>resolve({
                    __type: $ca3473265f76df98$export$7c391bd3b61d2374.TIMED_OUT,
                    timeoutMs: timeoutMs
                }), timeoutMs);
        });
        const { abortConfirmation: abortConfirmation, confirmationPromise: confirmationPromise } = this.getTransactionConfirmationPromise({
            commitment: commitment,
            signature: signature
        });
        let result;
        try {
            const outcome = await Promise.race([
                confirmationPromise,
                expiryPromise
            ]);
            if (outcome.__type === $ca3473265f76df98$export$7c391bd3b61d2374.PROCESSED) result = outcome.response;
            else throw new $ca3473265f76df98$export$b822204c22e46bdf(signature, outcome.timeoutMs / 1000);
        } finally{
            clearTimeout(timeoutId);
            abortConfirmation();
        }
        return result;
    }
    /**
   * Return the list of nodes that are currently participating in the cluster
   */ async getClusterNodes() {
        const unsafeRes = await this._rpcRequest("getClusterNodes", []);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$jsonRpcResult((0, $c32abee974e85639$export$2f23118c22fb2630)($ca3473265f76df98$var$ContactInfoResult)));
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get cluster nodes");
        return res.result;
    }
    /**
   * Return the list of nodes that are currently participating in the cluster
   */ async getVoteAccounts(commitment) {
        const args = this._buildArgs([], commitment);
        const unsafeRes = await this._rpcRequest("getVoteAccounts", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetVoteAccounts);
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get vote accounts");
        return res.result;
    }
    /**
   * Fetch the current slot that the node is processing
   */ async getSlot(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $ca3473265f76df98$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getSlot", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$jsonRpcResult((0, $c32abee974e85639$export$98e628dec113755e)()));
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get slot");
        return res.result;
    }
    /**
   * Fetch the current slot leader of the cluster
   */ async getSlotLeader(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $ca3473265f76df98$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getSlotLeader", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$jsonRpcResult((0, $c32abee974e85639$export$22b082955e083ec3)()));
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get slot leader");
        return res.result;
    }
    /**
   * Fetch `limit` number of slot leaders starting from `startSlot`
   *
   * @param startSlot fetch slot leaders starting from this slot
   * @param limit number of slot leaders to return
   */ async getSlotLeaders(startSlot, limit) {
        const args = [
            startSlot,
            limit
        ];
        const unsafeRes = await this._rpcRequest("getSlotLeaders", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$jsonRpcResult((0, $c32abee974e85639$export$2f23118c22fb2630)($ca3473265f76df98$var$PublicKeyFromString)));
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get slot leaders");
        return res.result;
    }
    /**
   * Fetch the current status of a signature
   */ async getSignatureStatus(signature, config) {
        const { context: context, value: values } = await this.getSignatureStatuses([
            signature
        ], config);
        $ca3473265f76df98$var$assert(values.length === 1);
        const value = values[0];
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the current statuses of a batch of signatures
   */ async getSignatureStatuses(signatures, config) {
        const params = [
            signatures
        ];
        if (config) params.push(config);
        const unsafeRes = await this._rpcRequest("getSignatureStatuses", params);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetSignatureStatusesRpcResult);
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get signature status");
        return res.result;
    }
    /**
   * Fetch the current transaction count of the cluster
   */ async getTransactionCount(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $ca3473265f76df98$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getTransactionCount", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$jsonRpcResult((0, $c32abee974e85639$export$98e628dec113755e)()));
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction count");
        return res.result;
    }
    /**
   * Fetch the current total currency supply of the cluster in lamports
   *
   * @deprecated Deprecated since RPC v1.2.8. Please use {@link getSupply} instead.
   */ async getTotalSupply(commitment) {
        const result = await this.getSupply({
            commitment: commitment,
            excludeNonCirculatingAccountsList: true
        });
        return result.value.total;
    }
    /**
   * Fetch the cluster InflationGovernor parameters
   */ async getInflationGovernor(commitment) {
        const args = this._buildArgs([], commitment);
        const unsafeRes = await this._rpcRequest("getInflationGovernor", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetInflationGovernorRpcResult);
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get inflation");
        return res.result;
    }
    /**
   * Fetch the inflation reward for a list of addresses for an epoch
   */ async getInflationReward(addresses, epoch, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $ca3473265f76df98$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            addresses.map((pubkey)=>pubkey.toBase58())
        ], commitment, undefined /* encoding */ , {
            ...config,
            epoch: epoch != null ? epoch : config?.epoch
        });
        const unsafeRes = await this._rpcRequest("getInflationReward", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetInflationRewardResult);
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get inflation reward");
        return res.result;
    }
    /**
   * Fetch the specific inflation values for the current epoch
   */ async getInflationRate() {
        const unsafeRes = await this._rpcRequest("getInflationRate", []);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetInflationRateRpcResult);
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get inflation rate");
        return res.result;
    }
    /**
   * Fetch the Epoch Info parameters
   */ async getEpochInfo(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $ca3473265f76df98$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getEpochInfo", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetEpochInfoRpcResult);
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get epoch info");
        return res.result;
    }
    /**
   * Fetch the Epoch Schedule parameters
   */ async getEpochSchedule() {
        const unsafeRes = await this._rpcRequest("getEpochSchedule", []);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetEpochScheduleRpcResult);
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get epoch schedule");
        const epochSchedule = res.result;
        return new $ca3473265f76df98$export$df8ed3e830b1d591(epochSchedule.slotsPerEpoch, epochSchedule.leaderScheduleSlotOffset, epochSchedule.warmup, epochSchedule.firstNormalEpoch, epochSchedule.firstNormalSlot);
    }
    /**
   * Fetch the leader schedule for the current epoch
   * @return {Promise<RpcResponseAndContext<LeaderSchedule>>}
   */ async getLeaderSchedule() {
        const unsafeRes = await this._rpcRequest("getLeaderSchedule", []);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetLeaderScheduleRpcResult);
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get leader schedule");
        return res.result;
    }
    /**
   * Fetch the minimum balance needed to exempt an account of `dataLength`
   * size from rent
   */ async getMinimumBalanceForRentExemption(dataLength, commitment) {
        const args = this._buildArgs([
            dataLength
        ], commitment);
        const unsafeRes = await this._rpcRequest("getMinimumBalanceForRentExemption", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetMinimumBalanceForRentExemptionRpcResult);
        if ("error" in res) {
            console.warn("Unable to fetch minimum balance for rent exemption");
            return 0;
        }
        return res.result;
    }
    /**
   * Fetch a recent blockhash from the cluster, return with context
   * @return {Promise<RpcResponseAndContext<{blockhash: Blockhash, feeCalculator: FeeCalculator}>>}
   *
   * @deprecated Deprecated since RPC v1.9.0. Please use {@link getLatestBlockhash} instead.
   */ async getRecentBlockhashAndContext(commitment) {
        const args = this._buildArgs([], commitment);
        const unsafeRes = await this._rpcRequest("getRecentBlockhash", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetRecentBlockhashAndContextRpcResult);
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get recent blockhash");
        return res.result;
    }
    /**
   * Fetch recent performance samples
   * @return {Promise<Array<PerfSample>>}
   */ async getRecentPerformanceSamples(limit) {
        const unsafeRes = await this._rpcRequest("getRecentPerformanceSamples", limit ? [
            limit
        ] : []);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetRecentPerformanceSamplesRpcResult);
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get recent performance samples");
        return res.result;
    }
    /**
   * Fetch the fee calculator for a recent blockhash from the cluster, return with context
   *
   * @deprecated Deprecated since RPC v1.9.0. Please use {@link getFeeForMessage} instead.
   */ async getFeeCalculatorForBlockhash(blockhash, commitment) {
        const args = this._buildArgs([
            blockhash
        ], commitment);
        const unsafeRes = await this._rpcRequest("getFeeCalculatorForBlockhash", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetFeeCalculatorRpcResult);
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get fee calculator");
        const { context: context, value: value } = res.result;
        return {
            context: context,
            value: value !== null ? value.feeCalculator : null
        };
    }
    /**
   * Fetch the fee for a message from the cluster, return with context
   */ async getFeeForMessage(message, commitment) {
        const wireMessage = $ca3473265f76df98$var$toBuffer(message.serialize()).toString("base64");
        const args = this._buildArgs([
            wireMessage
        ], commitment);
        const unsafeRes = await this._rpcRequest("getFeeForMessage", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$jsonRpcResultAndContext((0, $c32abee974e85639$export$133fc36489ac9add)((0, $c32abee974e85639$export$98e628dec113755e)())));
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get fee for message");
        if (res.result === null) throw new Error("invalid blockhash");
        return res.result;
    }
    /**
   * Fetch a list of prioritization fees from recent blocks.
   */ async getRecentPrioritizationFees(config) {
        const accounts = config?.lockedWritableAccounts?.map((key)=>key.toBase58());
        const args = accounts?.length ? [
            accounts
        ] : [];
        const unsafeRes = await this._rpcRequest("getRecentPrioritizationFees", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetRecentPrioritizationFeesRpcResult);
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get recent prioritization fees");
        return res.result;
    }
    /**
   * Fetch a recent blockhash from the cluster
   * @return {Promise<{blockhash: Blockhash, feeCalculator: FeeCalculator}>}
   *
   * @deprecated Deprecated since RPC v1.8.0. Please use {@link getLatestBlockhash} instead.
   */ async getRecentBlockhash(commitment) {
        try {
            const res = await this.getRecentBlockhashAndContext(commitment);
            return res.value;
        } catch (e) {
            throw new Error("failed to get recent blockhash: " + e);
        }
    }
    /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */ async getLatestBlockhash(commitmentOrConfig) {
        try {
            const res = await this.getLatestBlockhashAndContext(commitmentOrConfig);
            return res.value;
        } catch (e) {
            throw new Error("failed to get recent blockhash: " + e);
        }
    }
    /**
   * Fetch the latest blockhash from the cluster
   * @return {Promise<BlockhashWithExpiryBlockHeight>}
   */ async getLatestBlockhashAndContext(commitmentOrConfig) {
        const { commitment: commitment, config: config } = $ca3473265f76df98$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getLatestBlockhash", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetLatestBlockhashRpcResult);
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get latest blockhash");
        return res.result;
    }
    /**
   * Returns whether a blockhash is still valid or not
   */ async isBlockhashValid(blockhash, rawConfig) {
        const { commitment: commitment, config: config } = $ca3473265f76df98$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgs([
            blockhash
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("isBlockhashValid", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$IsBlockhashValidRpcResult);
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to determine if the blockhash `" + blockhash + "`is valid");
        return res.result;
    }
    /**
   * Fetch the node version
   */ async getVersion() {
        const unsafeRes = await this._rpcRequest("getVersion", []);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$jsonRpcResult($ca3473265f76df98$var$VersionResult));
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get version");
        return res.result;
    }
    /**
   * Fetch the genesis hash
   */ async getGenesisHash() {
        const unsafeRes = await this._rpcRequest("getGenesisHash", []);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$jsonRpcResult((0, $c32abee974e85639$export$22b082955e083ec3)()));
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get genesis hash");
        return res.result;
    }
    /**
   * Fetch a processed block from the cluster.
   *
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * @deprecated Instead, call `getBlock` using a `GetVersionedBlockConfig` by
   * setting the `maxSupportedTransactionVersion` property.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a processed block from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a processed block from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    async getBlock(slot, rawConfig) {
        const { commitment: commitment, config: config } = $ca3473265f76df98$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getBlock", args);
        try {
            switch(config?.transactionDetails){
                case "accounts":
                    {
                        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetAccountsModeBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
                case "none":
                    {
                        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetNoneModeBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
                default:
                    {
                        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetBlockRpcResult);
                        if ("error" in res) throw res.error;
                        const { result: result } = res;
                        return result ? {
                            ...result,
                            transactions: result.transactions.map(({ transaction: transaction, meta: meta, version: version })=>({
                                    meta: meta,
                                    transaction: {
                                        ...transaction,
                                        message: $ca3473265f76df98$var$versionedMessageFromResponse(version, transaction.message)
                                    },
                                    version: version
                                }))
                        } : null;
                    }
            }
        } catch (e) {
            throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(e, "failed to get confirmed block");
        }
    }
    /**
   * Fetch parsed transaction details for a confirmed or finalized block
   */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    async getParsedBlock(slot, rawConfig) {
        const { commitment: commitment, config: config } = $ca3473265f76df98$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getBlock", args);
        try {
            switch(config?.transactionDetails){
                case "accounts":
                    {
                        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetParsedAccountsModeBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
                case "none":
                    {
                        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetParsedNoneModeBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
                default:
                    {
                        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetParsedBlockRpcResult);
                        if ("error" in res) throw res.error;
                        return res.result;
                    }
            }
        } catch (e) {
            throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(e, "failed to get block");
        }
    }
    /*
   * Returns recent block production information from the current or previous epoch
   */ async getBlockProduction(configOrCommitment) {
        let extra;
        let commitment;
        if (typeof configOrCommitment === "string") commitment = configOrCommitment;
        else if (configOrCommitment) {
            const { commitment: c, ...rest } = configOrCommitment;
            commitment = c;
            extra = rest;
        }
        const args = this._buildArgs([], commitment, "base64", extra);
        const unsafeRes = await this._rpcRequest("getBlockProduction", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$BlockProductionResponseStruct);
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get block production information");
        return res.result;
    }
    /**
   * Fetch a confirmed or finalized transaction from the cluster.
   *
   * @deprecated Instead, call `getTransaction` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */ /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch a confirmed or finalized transaction from the cluster.
   */ // eslint-disable-next-line no-dupe-class-members
    async getTransaction(signature, rawConfig) {
        const { commitment: commitment, config: config } = $ca3473265f76df98$var$extractCommitmentFromConfig(rawConfig);
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, undefined /* encoding */ , config);
        const unsafeRes = await this._rpcRequest("getTransaction", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetTransactionRpcResult);
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction");
        const result = res.result;
        if (!result) return result;
        return {
            ...result,
            transaction: {
                ...result.transaction,
                message: $ca3473265f76df98$var$versionedMessageFromResponse(result.version, result.transaction.message)
            }
        };
    }
    /**
   * Fetch parsed transaction details for a confirmed or finalized transaction
   */ async getParsedTransaction(signature, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $ca3473265f76df98$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, "jsonParsed", config);
        const unsafeRes = await this._rpcRequest("getTransaction", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetParsedTransactionRpcResult);
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction");
        return res.result;
    }
    /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   */ async getParsedTransactions(signatures, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $ca3473265f76df98$var$extractCommitmentFromConfig(commitmentOrConfig);
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, "jsonParsed", config);
            return {
                methodName: "getTransaction",
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetParsedTransactionRpcResult);
            if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get transactions");
            return res.result;
        });
        return res;
    }
    /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link TransactionResponse}.
   *
   * @deprecated Instead, call `getTransactions` using a
   * `GetVersionedTransactionConfig` by setting the
   * `maxSupportedTransactionVersion` property.
   */ /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Fetch transaction details for a batch of confirmed transactions.
   * Similar to {@link getParsedTransactions} but returns a {@link
   * VersionedTransactionResponse}.
   */ // eslint-disable-next-line no-dupe-class-members
    async getTransactions(signatures, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $ca3473265f76df98$var$extractCommitmentFromConfig(commitmentOrConfig);
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, undefined /* encoding */ , config);
            return {
                methodName: "getTransaction",
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetTransactionRpcResult);
            if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get transactions");
            const result = res.result;
            if (!result) return result;
            return {
                ...result,
                transaction: {
                    ...result.transaction,
                    message: $ca3473265f76df98$var$versionedMessageFromResponse(result.version, result.transaction.message)
                }
            };
        });
        return res;
    }
    /**
   * Fetch a list of Transactions and transaction statuses from the cluster
   * for a confirmed block.
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getBlock} instead.
   */ async getConfirmedBlock(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment);
        const unsafeRes = await this._rpcRequest("getConfirmedBlock", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetConfirmedBlockRpcResult);
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed block");
        const result = res.result;
        if (!result) throw new Error("Confirmed block " + slot + " not found");
        const block = {
            ...result,
            transactions: result.transactions.map(({ transaction: transaction, meta: meta })=>{
                const message = new $ca3473265f76df98$export$f69c19e57285b83a(transaction.message);
                return {
                    meta: meta,
                    transaction: {
                        ...transaction,
                        message: message
                    }
                };
            })
        };
        return {
            ...block,
            transactions: block.transactions.map(({ transaction: transaction, meta: meta })=>{
                return {
                    meta: meta,
                    transaction: $ca3473265f76df98$export$febc5573c75cefb0.populate(transaction.message, transaction.signatures)
                };
            })
        };
    }
    /**
   * Fetch confirmed blocks between two slots
   */ async getBlocks(startSlot, endSlot, commitment) {
        const args = this._buildArgsAtLeastConfirmed(endSlot !== undefined ? [
            startSlot,
            endSlot
        ] : [
            startSlot
        ], commitment);
        const unsafeRes = await this._rpcRequest("getBlocks", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$jsonRpcResult((0, $c32abee974e85639$export$2f23118c22fb2630)((0, $c32abee974e85639$export$98e628dec113755e)())));
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get blocks");
        return res.result;
    }
    /**
   * Fetch a list of Signatures from the cluster for a block, excluding rewards
   */ async getBlockSignatures(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined, {
            transactionDetails: "signatures",
            rewards: false
        });
        const unsafeRes = await this._rpcRequest("getBlock", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetBlockSignaturesRpcResult);
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get block");
        const result = res.result;
        if (!result) throw new Error("Block " + slot + " not found");
        return result;
    }
    /**
   * Fetch a list of Signatures from the cluster for a confirmed block, excluding rewards
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getBlockSignatures} instead.
   */ async getConfirmedBlockSignatures(slot, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            slot
        ], commitment, undefined, {
            transactionDetails: "signatures",
            rewards: false
        });
        const unsafeRes = await this._rpcRequest("getConfirmedBlock", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetBlockSignaturesRpcResult);
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed block");
        const result = res.result;
        if (!result) throw new Error("Confirmed block " + slot + " not found");
        return result;
    }
    /**
   * Fetch a transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getTransaction} instead.
   */ async getConfirmedTransaction(signature, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment);
        const unsafeRes = await this._rpcRequest("getConfirmedTransaction", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetTransactionRpcResult);
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get transaction");
        const result = res.result;
        if (!result) return result;
        const message = new $ca3473265f76df98$export$f69c19e57285b83a(result.transaction.message);
        const signatures = result.transaction.signatures;
        return {
            ...result,
            transaction: $ca3473265f76df98$export$febc5573c75cefb0.populate(message, signatures)
        };
    }
    /**
   * Fetch parsed transaction details for a confirmed transaction
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getParsedTransaction} instead.
   */ async getParsedConfirmedTransaction(signature, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            signature
        ], commitment, "jsonParsed");
        const unsafeRes = await this._rpcRequest("getConfirmedTransaction", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetParsedTransactionRpcResult);
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed transaction");
        return res.result;
    }
    /**
   * Fetch parsed transaction details for a batch of confirmed transactions
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getParsedTransactions} instead.
   */ async getParsedConfirmedTransactions(signatures, commitment) {
        const batch = signatures.map((signature)=>{
            const args = this._buildArgsAtLeastConfirmed([
                signature
            ], commitment, "jsonParsed");
            return {
                methodName: "getConfirmedTransaction",
                args: args
            };
        });
        const unsafeRes = await this._rpcBatchRequest(batch);
        const res = unsafeRes.map((unsafeRes)=>{
            const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetParsedTransactionRpcResult);
            if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed transactions");
            return res.result;
        });
        return res;
    }
    /**
   * Fetch a list of all the confirmed signatures for transactions involving an address
   * within a specified slot range. Max range allowed is 10,000 slots.
   *
   * @deprecated Deprecated since RPC v1.3. Please use {@link getConfirmedSignaturesForAddress2} instead.
   *
   * @param address queried address
   * @param startSlot start slot, inclusive
   * @param endSlot end slot, inclusive
   */ async getConfirmedSignaturesForAddress(address, startSlot, endSlot) {
        let options = {};
        let firstAvailableBlock = await this.getFirstAvailableBlock();
        while(!("until" in options)){
            startSlot--;
            if (startSlot <= 0 || startSlot < firstAvailableBlock) break;
            try {
                const block = await this.getConfirmedBlockSignatures(startSlot, "finalized");
                if (block.signatures.length > 0) options.until = block.signatures[block.signatures.length - 1].toString();
            } catch (err) {
                if (err instanceof Error && err.message.includes("skipped")) continue;
                else throw err;
            }
        }
        let highestConfirmedRoot = await this.getSlot("finalized");
        while(!("before" in options)){
            endSlot++;
            if (endSlot > highestConfirmedRoot) break;
            try {
                const block = await this.getConfirmedBlockSignatures(endSlot);
                if (block.signatures.length > 0) options.before = block.signatures[block.signatures.length - 1].toString();
            } catch (err) {
                if (err instanceof Error && err.message.includes("skipped")) continue;
                else throw err;
            }
        }
        const confirmedSignatureInfo = await this.getConfirmedSignaturesForAddress2(address, options);
        return confirmedSignatureInfo.map((info)=>info.signature);
    }
    /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   * @deprecated Deprecated since RPC v1.7.0. Please use {@link getSignaturesForAddress} instead.
   */ async getConfirmedSignaturesForAddress2(address, options, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            address.toBase58()
        ], commitment, undefined, options);
        const unsafeRes = await this._rpcRequest("getConfirmedSignaturesForAddress2", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetConfirmedSignaturesForAddress2RpcResult);
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get confirmed signatures for address");
        return res.result;
    }
    /**
   * Returns confirmed signatures for transactions involving an
   * address backwards in time from the provided signature or most recent confirmed block
   *
   *
   * @param address queried address
   * @param options
   */ async getSignaturesForAddress(address, options, commitment) {
        const args = this._buildArgsAtLeastConfirmed([
            address.toBase58()
        ], commitment, undefined, options);
        const unsafeRes = await this._rpcRequest("getSignaturesForAddress", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$GetSignaturesForAddressRpcResult);
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, "failed to get signatures for address");
        return res.result;
    }
    async getAddressLookupTable(accountKey, config) {
        const { context: context, value: accountInfo } = await this.getAccountInfoAndContext(accountKey, config);
        let value = null;
        if (accountInfo !== null) value = new $ca3473265f76df98$export$5b2310da10e607da({
            key: accountKey,
            state: $ca3473265f76df98$export$5b2310da10e607da.deserialize(accountInfo.data)
        });
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the contents of a Nonce account from the cluster, return with context
   */ async getNonceAndContext(nonceAccount, commitmentOrConfig) {
        const { context: context, value: accountInfo } = await this.getAccountInfoAndContext(nonceAccount, commitmentOrConfig);
        let value = null;
        if (accountInfo !== null) value = $ca3473265f76df98$export$ed1c2356ce604759.fromAccountData(accountInfo.data);
        return {
            context: context,
            value: value
        };
    }
    /**
   * Fetch the contents of a Nonce account from the cluster
   */ async getNonce(nonceAccount, commitmentOrConfig) {
        return await this.getNonceAndContext(nonceAccount, commitmentOrConfig).then((x)=>x.value).catch((e)=>{
            throw new Error("failed to get nonce for account " + nonceAccount.toBase58() + ": " + e);
        });
    }
    /**
   * Request an allocation of lamports to the specified address
   *
   * ```typescript
   * import { Connection, PublicKey, LAMPORTS_PER_SOL } from "@solana/web3.js";
   *
   * (async () => {
   *   const connection = new Connection("https://api.testnet.solana.com", "confirmed");
   *   const myAddress = new PublicKey("2nr1bHFT86W9tGnyvmYW4vcHKsQB3sVQfnddasz4kExM");
   *   const signature = await connection.requestAirdrop(myAddress, LAMPORTS_PER_SOL);
   *   await connection.confirmTransaction(signature);
   * })();
   * ```
   */ async requestAirdrop(to, lamports) {
        const unsafeRes = await this._rpcRequest("requestAirdrop", [
            to.toBase58(),
            lamports
        ]);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$RequestAirdropRpcResult);
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, `airdrop to ${to.toBase58()} failed`);
        return res.result;
    }
    /**
   * @internal
   */ async _blockhashWithExpiryBlockHeight(disableCache) {
        if (!disableCache) {
            // Wait for polling to finish
            while(this._pollingBlockhash)await $ca3473265f76df98$var$sleep(100);
            const timeSinceFetch = Date.now() - this._blockhashInfo.lastFetch;
            const expired = timeSinceFetch >= $ca3473265f76df98$export$fcb705732fb5c597;
            if (this._blockhashInfo.latestBlockhash !== null && !expired) return this._blockhashInfo.latestBlockhash;
        }
        return await this._pollNewBlockhash();
    }
    /**
   * @internal
   */ async _pollNewBlockhash() {
        this._pollingBlockhash = true;
        try {
            const startTime = Date.now();
            const cachedLatestBlockhash = this._blockhashInfo.latestBlockhash;
            const cachedBlockhash = cachedLatestBlockhash ? cachedLatestBlockhash.blockhash : null;
            for(let i = 0; i < 50; i++){
                const latestBlockhash = await this.getLatestBlockhash("finalized");
                if (cachedBlockhash !== latestBlockhash.blockhash) {
                    this._blockhashInfo = {
                        latestBlockhash: latestBlockhash,
                        lastFetch: Date.now(),
                        transactionSignatures: [],
                        simulatedSignatures: []
                    };
                    return latestBlockhash;
                }
                // Sleep for approximately half a slot
                await $ca3473265f76df98$var$sleep($ca3473265f76df98$var$MS_PER_SLOT / 2);
            }
            throw new Error(`Unable to obtain a new blockhash after ${Date.now() - startTime}ms`);
        } finally{
            this._pollingBlockhash = false;
        }
    }
    /**
   * get the stake minimum delegation
   */ async getStakeMinimumDelegation(config) {
        const { commitment: commitment, config: configArg } = $ca3473265f76df98$var$extractCommitmentFromConfig(config);
        const args = this._buildArgs([], commitment, "base64", configArg);
        const unsafeRes = await this._rpcRequest("getStakeMinimumDelegation", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$jsonRpcResultAndContext((0, $c32abee974e85639$export$98e628dec113755e)()));
        if ("error" in res) throw new $ca3473265f76df98$export$ea1b1a1bba5c14ad(res.error, `failed to get stake minimum delegation`);
        return res.result;
    }
    /**
   * Simulate a transaction
   *
   * @deprecated Instead, call {@link simulateTransaction} with {@link
   * VersionedTransaction} and {@link SimulateTransactionConfig} parameters
   */ /**
   * Simulate a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Simulate a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    async simulateTransaction(transactionOrMessage, configOrSigners, includeAccounts) {
        if ("message" in transactionOrMessage) {
            const versionedTx = transactionOrMessage;
            const wireTransaction = versionedTx.serialize();
            const encodedTransaction = (0, $492757110c774bc9$export$a143d493d941bafc).from(wireTransaction).toString("base64");
            if (Array.isArray(configOrSigners) || includeAccounts !== undefined) throw new Error("Invalid arguments");
            const config = configOrSigners || {};
            config.encoding = "base64";
            if (!("commitment" in config)) config.commitment = this.commitment;
            if (configOrSigners && typeof configOrSigners === "object" && "innerInstructions" in configOrSigners) config.innerInstructions = configOrSigners.innerInstructions;
            const args = [
                encodedTransaction,
                config
            ];
            const unsafeRes = await this._rpcRequest("simulateTransaction", args);
            const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$SimulatedTransactionResponseStruct);
            if ("error" in res) throw new Error("failed to simulate transaction: " + res.error.message);
            return res.result;
        }
        let transaction;
        if (transactionOrMessage instanceof $ca3473265f76df98$export$febc5573c75cefb0) {
            let originalTx = transactionOrMessage;
            transaction = new $ca3473265f76df98$export$febc5573c75cefb0();
            transaction.feePayer = originalTx.feePayer;
            transaction.instructions = transactionOrMessage.instructions;
            transaction.nonceInfo = originalTx.nonceInfo;
            transaction.signatures = originalTx.signatures;
        } else {
            transaction = $ca3473265f76df98$export$febc5573c75cefb0.populate(transactionOrMessage);
            // HACK: this function relies on mutating the populated transaction
            transaction._message = transaction._json = undefined;
        }
        if (configOrSigners !== undefined && !Array.isArray(configOrSigners)) throw new Error("Invalid arguments");
        const signers = configOrSigners;
        if (transaction.nonceInfo && signers) transaction.sign(...signers);
        else {
            let disableCache = this._disableBlockhashCaching;
            for(;;){
                const latestBlockhash = await this._blockhashWithExpiryBlockHeight(disableCache);
                transaction.lastValidBlockHeight = latestBlockhash.lastValidBlockHeight;
                transaction.recentBlockhash = latestBlockhash.blockhash;
                if (!signers) break;
                transaction.sign(...signers);
                if (!transaction.signature) throw new Error("!signature"); // should never happen
                const signature = transaction.signature.toString("base64");
                if (!this._blockhashInfo.simulatedSignatures.includes(signature) && !this._blockhashInfo.transactionSignatures.includes(signature)) {
                    // The signature of this transaction has not been seen before with the
                    // current recentBlockhash, all done. Let's break
                    this._blockhashInfo.simulatedSignatures.push(signature);
                    break;
                } else // This transaction would be treated as duplicate (its derived signature
                // matched to one of already recorded signatures).
                // So, we must fetch a new blockhash for a different signature by disabling
                // our cache not to wait for the cache expiration (BLOCKHASH_CACHE_TIMEOUT_MS).
                disableCache = true;
            }
        }
        const message = transaction._compile();
        const signData = message.serialize();
        const wireTransaction = transaction._serialize(signData);
        const encodedTransaction = wireTransaction.toString("base64");
        const config = {
            encoding: "base64",
            commitment: this.commitment
        };
        if (includeAccounts) {
            const addresses = (Array.isArray(includeAccounts) ? includeAccounts : message.nonProgramIds()).map((key)=>key.toBase58());
            config["accounts"] = {
                encoding: "base64",
                addresses: addresses
            };
        }
        if (signers) config.sigVerify = true;
        if (configOrSigners && typeof configOrSigners === "object" && "innerInstructions" in configOrSigners) config.innerInstructions = configOrSigners.innerInstructions;
        const args = [
            encodedTransaction,
            config
        ];
        const unsafeRes = await this._rpcRequest("simulateTransaction", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$SimulatedTransactionResponseStruct);
        if ("error" in res) {
            let logs;
            if ("data" in res.error) {
                logs = res.error.data.logs;
                if (logs && Array.isArray(logs)) {
                    const traceIndent = "\n    ";
                    const logTrace = traceIndent + logs.join(traceIndent);
                    console.error(res.error.message, logTrace);
                }
            }
            throw new $ca3473265f76df98$export$121e803f723b3045({
                action: "simulate",
                signature: "",
                transactionMessage: res.error.message,
                logs: logs
            });
        }
        return res.result;
    }
    /**
   * Sign and send a transaction
   *
   * @deprecated Instead, call {@link sendTransaction} with a {@link
   * VersionedTransaction}
   */ /**
   * Send a signed transaction
   */ // eslint-disable-next-line no-dupe-class-members
    /**
   * Sign and send a transaction
   */ // eslint-disable-next-line no-dupe-class-members
    async sendTransaction(transaction, signersOrOptions, options) {
        if ("version" in transaction) {
            if (signersOrOptions && Array.isArray(signersOrOptions)) throw new Error("Invalid arguments");
            const wireTransaction = transaction.serialize();
            return await this.sendRawTransaction(wireTransaction, signersOrOptions);
        }
        if (signersOrOptions === undefined || !Array.isArray(signersOrOptions)) throw new Error("Invalid arguments");
        const signers = signersOrOptions;
        if (transaction.nonceInfo) transaction.sign(...signers);
        else {
            let disableCache = this._disableBlockhashCaching;
            for(;;){
                const latestBlockhash = await this._blockhashWithExpiryBlockHeight(disableCache);
                transaction.lastValidBlockHeight = latestBlockhash.lastValidBlockHeight;
                transaction.recentBlockhash = latestBlockhash.blockhash;
                transaction.sign(...signers);
                if (!transaction.signature) throw new Error("!signature"); // should never happen
                const signature = transaction.signature.toString("base64");
                if (!this._blockhashInfo.transactionSignatures.includes(signature)) {
                    // The signature of this transaction has not been seen before with the
                    // current recentBlockhash, all done. Let's break
                    this._blockhashInfo.transactionSignatures.push(signature);
                    break;
                } else // This transaction would be treated as duplicate (its derived signature
                // matched to one of already recorded signatures).
                // So, we must fetch a new blockhash for a different signature by disabling
                // our cache not to wait for the cache expiration (BLOCKHASH_CACHE_TIMEOUT_MS).
                disableCache = true;
            }
        }
        const wireTransaction = transaction.serialize();
        return await this.sendRawTransaction(wireTransaction, options);
    }
    /**
   * Send a transaction that has already been signed and serialized into the
   * wire format
   */ async sendRawTransaction(rawTransaction, options) {
        const encodedTransaction = $ca3473265f76df98$var$toBuffer(rawTransaction).toString("base64");
        const result = await this.sendEncodedTransaction(encodedTransaction, options);
        return result;
    }
    /**
   * Send a transaction that has already been signed, serialized into the
   * wire format, and encoded as a base64 string
   */ async sendEncodedTransaction(encodedTransaction, options) {
        const config = {
            encoding: "base64"
        };
        const skipPreflight = options && options.skipPreflight;
        const preflightCommitment = skipPreflight === true ? "processed" // FIXME Remove when https://github.com/anza-xyz/agave/pull/483 is deployed.
         : options && options.preflightCommitment || this.commitment;
        if (options && options.maxRetries != null) config.maxRetries = options.maxRetries;
        if (options && options.minContextSlot != null) config.minContextSlot = options.minContextSlot;
        if (skipPreflight) config.skipPreflight = skipPreflight;
        if (preflightCommitment) config.preflightCommitment = preflightCommitment;
        const args = [
            encodedTransaction,
            config
        ];
        const unsafeRes = await this._rpcRequest("sendTransaction", args);
        const res = (0, $c32abee974e85639$export$185802fd694ee1f5)(unsafeRes, $ca3473265f76df98$var$SendTransactionRpcResult);
        if ("error" in res) {
            let logs = undefined;
            if ("data" in res.error) logs = res.error.data.logs;
            throw new $ca3473265f76df98$export$121e803f723b3045({
                action: skipPreflight ? "send" : "simulate",
                signature: "",
                transactionMessage: res.error.message,
                logs: logs
            });
        }
        return res.result;
    }
    /**
   * @internal
   */ _wsOnOpen() {
        this._rpcWebSocketConnected = true;
        this._rpcWebSocketHeartbeat = setInterval(()=>{
            // Ping server every 5s to prevent idle timeouts
            (async ()=>{
                try {
                    await this._rpcWebSocket.notify("ping");
                // eslint-disable-next-line no-empty
                } catch  {}
            })();
        }, 5000);
        this._updateSubscriptions();
    }
    /**
   * @internal
   */ _wsOnError(err) {
        this._rpcWebSocketConnected = false;
        console.error("ws error:", err.message);
    }
    /**
   * @internal
   */ _wsOnClose(code) {
        this._rpcWebSocketConnected = false;
        this._rpcWebSocketGeneration = (this._rpcWebSocketGeneration + 1) % Number.MAX_SAFE_INTEGER;
        if (this._rpcWebSocketIdleTimeout) {
            clearTimeout(this._rpcWebSocketIdleTimeout);
            this._rpcWebSocketIdleTimeout = null;
        }
        if (this._rpcWebSocketHeartbeat) {
            clearInterval(this._rpcWebSocketHeartbeat);
            this._rpcWebSocketHeartbeat = null;
        }
        if (code === 1000) {
            // explicit close, check if any subscriptions have been made since close
            this._updateSubscriptions();
            return;
        }
        // implicit close, prepare subscriptions for auto-reconnect
        this._subscriptionCallbacksByServerSubscriptionId = {};
        Object.entries(this._subscriptionsByHash).forEach(([hash, subscription])=>{
            this._setSubscription(hash, {
                ...subscription,
                state: "pending"
            });
        });
    }
    /**
   * @internal
   */ _setSubscription(hash, nextSubscription) {
        const prevState = this._subscriptionsByHash[hash]?.state;
        this._subscriptionsByHash[hash] = nextSubscription;
        if (prevState !== nextSubscription.state) {
            const stateChangeCallbacks = this._subscriptionStateChangeCallbacksByHash[hash];
            if (stateChangeCallbacks) stateChangeCallbacks.forEach((cb)=>{
                try {
                    cb(nextSubscription.state);
                // eslint-disable-next-line no-empty
                } catch  {}
            });
        }
    }
    /**
   * @internal
   */ _onSubscriptionStateChange(clientSubscriptionId, callback) {
        const hash = this._subscriptionHashByClientSubscriptionId[clientSubscriptionId];
        if (hash == null) return ()=>{};
        const stateChangeCallbacks = this._subscriptionStateChangeCallbacksByHash[hash] ||= new Set();
        stateChangeCallbacks.add(callback);
        return ()=>{
            stateChangeCallbacks.delete(callback);
            if (stateChangeCallbacks.size === 0) delete this._subscriptionStateChangeCallbacksByHash[hash];
        };
    }
    /**
   * @internal
   */ async _updateSubscriptions() {
        if (Object.keys(this._subscriptionsByHash).length === 0) {
            if (this._rpcWebSocketConnected) {
                this._rpcWebSocketConnected = false;
                this._rpcWebSocketIdleTimeout = setTimeout(()=>{
                    this._rpcWebSocketIdleTimeout = null;
                    try {
                        this._rpcWebSocket.close();
                    } catch (err) {
                        // swallow error if socket has already been closed.
                        if (err instanceof Error) console.log(`Error when closing socket connection: ${err.message}`);
                    }
                }, 500);
            }
            return;
        }
        if (this._rpcWebSocketIdleTimeout !== null) {
            clearTimeout(this._rpcWebSocketIdleTimeout);
            this._rpcWebSocketIdleTimeout = null;
            this._rpcWebSocketConnected = true;
        }
        if (!this._rpcWebSocketConnected) {
            this._rpcWebSocket.connect();
            return;
        }
        const activeWebSocketGeneration = this._rpcWebSocketGeneration;
        const isCurrentConnectionStillActive = ()=>{
            return activeWebSocketGeneration === this._rpcWebSocketGeneration;
        };
        await Promise.all(// Don't be tempted to change this to `Object.entries`. We call
        // `_updateSubscriptions` recursively when processing the state,
        // so it's important that we look up the *current* version of
        // each subscription, every time we process a hash.
        Object.keys(this._subscriptionsByHash).map(async (hash)=>{
            const subscription = this._subscriptionsByHash[hash];
            if (subscription === undefined) // This entry has since been deleted. Skip.
            return;
            switch(subscription.state){
                case "pending":
                case "unsubscribed":
                    if (subscription.callbacks.size === 0) {
                        /**
             * You can end up here when:
             *
             * - a subscription has recently unsubscribed
             *   without having new callbacks added to it
             *   while the unsubscribe was in flight, or
             * - when a pending subscription has its
             *   listeners removed before a request was
             *   sent to the server.
             *
             * Being that nobody is interested in this
             * subscription any longer, delete it.
             */ delete this._subscriptionsByHash[hash];
                        if (subscription.state === "unsubscribed") delete this._subscriptionCallbacksByServerSubscriptionId[subscription.serverSubscriptionId];
                        await this._updateSubscriptions();
                        return;
                    }
                    await (async ()=>{
                        const { args: args, method: method } = subscription;
                        try {
                            this._setSubscription(hash, {
                                ...subscription,
                                state: "subscribing"
                            });
                            const serverSubscriptionId = await this._rpcWebSocket.call(method, args);
                            this._setSubscription(hash, {
                                ...subscription,
                                serverSubscriptionId: serverSubscriptionId,
                                state: "subscribed"
                            });
                            this._subscriptionCallbacksByServerSubscriptionId[serverSubscriptionId] = subscription.callbacks;
                            await this._updateSubscriptions();
                        } catch (e) {
                            if (e instanceof Error) console.error(`${method} error for argument`, args, e.message);
                            if (!isCurrentConnectionStillActive()) return;
                            // TODO: Maybe add an 'errored' state or a retry limit?
                            this._setSubscription(hash, {
                                ...subscription,
                                state: "pending"
                            });
                            await this._updateSubscriptions();
                        }
                    })();
                    break;
                case "subscribed":
                    if (subscription.callbacks.size === 0) // By the time we successfully set up a subscription
                    // with the server, the client stopped caring about it.
                    // Tear it down now.
                    await (async ()=>{
                        const { serverSubscriptionId: serverSubscriptionId, unsubscribeMethod: unsubscribeMethod } = subscription;
                        if (this._subscriptionsAutoDisposedByRpc.has(serverSubscriptionId)) /**
                 * Special case.
                 * If we're dealing with a subscription that has been auto-
                 * disposed by the RPC, then we can skip the RPC call to
                 * tear down the subscription here.
                 *
                 * NOTE: There is a proposal to eliminate this special case, here:
                 * https://github.com/solana-labs/solana/issues/18892
                 */ this._subscriptionsAutoDisposedByRpc.delete(serverSubscriptionId);
                        else {
                            this._setSubscription(hash, {
                                ...subscription,
                                state: "unsubscribing"
                            });
                            this._setSubscription(hash, {
                                ...subscription,
                                state: "unsubscribing"
                            });
                            try {
                                await this._rpcWebSocket.call(unsubscribeMethod, [
                                    serverSubscriptionId
                                ]);
                            } catch (e) {
                                if (e instanceof Error) console.error(`${unsubscribeMethod} error:`, e.message);
                                if (!isCurrentConnectionStillActive()) return;
                                // TODO: Maybe add an 'errored' state or a retry limit?
                                this._setSubscription(hash, {
                                    ...subscription,
                                    state: "subscribed"
                                });
                                await this._updateSubscriptions();
                                return;
                            }
                        }
                        this._setSubscription(hash, {
                            ...subscription,
                            state: "unsubscribed"
                        });
                        await this._updateSubscriptions();
                    })();
                    break;
            }
        }));
    }
    /**
   * @internal
   */ _handleServerNotification(serverSubscriptionId, callbackArgs) {
        const callbacks = this._subscriptionCallbacksByServerSubscriptionId[serverSubscriptionId];
        if (callbacks === undefined) return;
        callbacks.forEach((cb)=>{
            try {
                cb(// I failed to find a way to convince TypeScript that `cb` is of type
                // `TCallback` which is certainly compatible with `Parameters<TCallback>`.
                // See https://github.com/microsoft/TypeScript/issues/47615
                // @ts-ignore
                ...callbackArgs);
            } catch (e) {
                console.error(e);
            }
        });
    }
    /**
   * @internal
   */ _wsOnAccountNotification(notification) {
        const { result: result, subscription: subscription } = (0, $c32abee974e85639$export$185802fd694ee1f5)(notification, $ca3473265f76df98$var$AccountNotificationResult);
        this._handleServerNotification(subscription, [
            result.value,
            result.context
        ]);
    }
    /**
   * @internal
   */ _makeSubscription(subscriptionConfig, /**
   * When preparing `args` for a call to `_makeSubscription`, be sure
   * to carefully apply a default `commitment` property, if necessary.
   *
   * - If the user supplied a `commitment` use that.
   * - Otherwise, if the `Connection::commitment` is set, use that.
   * - Otherwise, set it to the RPC server default: `finalized`.
   *
   * This is extremely important to ensure that these two fundamentally
   * identical subscriptions produce the same identifying hash:
   *
   * - A subscription made without specifying a commitment.
   * - A subscription made where the commitment specified is the same
   *   as the default applied to the subscription above.
   *
   * Example; these two subscriptions must produce the same hash:
   *
   * - An `accountSubscribe` subscription for `'PUBKEY'`
   * - An `accountSubscribe` subscription for `'PUBKEY'` with commitment
   *   `'finalized'`.
   *
   * See the 'making a subscription with defaulted params omitted' test
   * in `connection-subscriptions.ts` for more.
   */ args) {
        const clientSubscriptionId = this._nextClientSubscriptionId++;
        const hash = $ca3473265f76df98$var$fastStableStringify$1([
            subscriptionConfig.method,
            args
        ]);
        const existingSubscription = this._subscriptionsByHash[hash];
        if (existingSubscription === undefined) this._subscriptionsByHash[hash] = {
            ...subscriptionConfig,
            args: args,
            callbacks: new Set([
                subscriptionConfig.callback
            ]),
            state: "pending"
        };
        else existingSubscription.callbacks.add(subscriptionConfig.callback);
        this._subscriptionHashByClientSubscriptionId[clientSubscriptionId] = hash;
        this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId] = async ()=>{
            delete this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId];
            delete this._subscriptionHashByClientSubscriptionId[clientSubscriptionId];
            const subscription = this._subscriptionsByHash[hash];
            $ca3473265f76df98$var$assert(subscription !== undefined, `Could not find a \`Subscription\` when tearing down client subscription #${clientSubscriptionId}`);
            subscription.callbacks.delete(subscriptionConfig.callback);
            await this._updateSubscriptions();
        };
        this._updateSubscriptions();
        return clientSubscriptionId;
    }
    /**
   * Register a callback to be invoked whenever the specified account changes
   *
   * @param publicKey Public key of the account to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param config
   * @return subscription id
   */ /** @deprecated Instead, pass in an {@link AccountSubscriptionConfig} */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    onAccountChange(publicKey, callback, commitmentOrConfig) {
        const { commitment: commitment, config: config } = $ca3473265f76df98$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            publicKey.toBase58()
        ], commitment || this._commitment || "finalized", // Apply connection/server default.
        "base64", config);
        return this._makeSubscription({
            callback: callback,
            method: "accountSubscribe",
            unsubscribeMethod: "accountUnsubscribe"
        }, args);
    }
    /**
   * Deregister an account notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeAccountChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "account change");
    }
    /**
   * @internal
   */ _wsOnProgramAccountNotification(notification) {
        const { result: result, subscription: subscription } = (0, $c32abee974e85639$export$185802fd694ee1f5)(notification, $ca3473265f76df98$var$ProgramAccountNotificationResult);
        this._handleServerNotification(subscription, [
            {
                accountId: result.value.pubkey,
                accountInfo: result.value.account
            },
            result.context
        ]);
    }
    /**
   * Register a callback to be invoked whenever accounts owned by the
   * specified program change
   *
   * @param programId Public key of the program to monitor
   * @param callback Function to invoke whenever the account is changed
   * @param config
   * @return subscription id
   */ /** @deprecated Instead, pass in a {@link ProgramAccountSubscriptionConfig} */ // eslint-disable-next-line no-dupe-class-members
    // eslint-disable-next-line no-dupe-class-members
    onProgramAccountChange(programId, callback, commitmentOrConfig, maybeFilters) {
        const { commitment: commitment, config: config } = $ca3473265f76df98$var$extractCommitmentFromConfig(commitmentOrConfig);
        const args = this._buildArgs([
            programId.toBase58()
        ], commitment || this._commitment || "finalized", // Apply connection/server default.
        "base64" /* encoding */ , config ? config : maybeFilters ? {
            filters: $ca3473265f76df98$var$applyDefaultMemcmpEncodingToFilters(maybeFilters)
        } : undefined /* extra */ );
        return this._makeSubscription({
            callback: callback,
            method: "programSubscribe",
            unsubscribeMethod: "programUnsubscribe"
        }, args);
    }
    /**
   * Deregister an account notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeProgramAccountChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "program account change");
    }
    /**
   * Registers a callback to be invoked whenever logs are emitted.
   */ onLogs(filter, callback, commitment) {
        const args = this._buildArgs([
            typeof filter === "object" ? {
                mentions: [
                    filter.toString()
                ]
            } : filter
        ], commitment || this._commitment || "finalized" // Apply connection/server default.
        );
        return this._makeSubscription({
            callback: callback,
            method: "logsSubscribe",
            unsubscribeMethod: "logsUnsubscribe"
        }, args);
    }
    /**
   * Deregister a logs callback.
   *
   * @param clientSubscriptionId client subscription id to deregister.
   */ async removeOnLogsListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "logs");
    }
    /**
   * @internal
   */ _wsOnLogsNotification(notification) {
        const { result: result, subscription: subscription } = (0, $c32abee974e85639$export$185802fd694ee1f5)(notification, $ca3473265f76df98$var$LogsNotificationResult);
        this._handleServerNotification(subscription, [
            result.value,
            result.context
        ]);
    }
    /**
   * @internal
   */ _wsOnSlotNotification(notification) {
        const { result: result, subscription: subscription } = (0, $c32abee974e85639$export$185802fd694ee1f5)(notification, $ca3473265f76df98$var$SlotNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon slot changes
   *
   * @param callback Function to invoke whenever the slot changes
   * @return subscription id
   */ onSlotChange(callback) {
        return this._makeSubscription({
            callback: callback,
            method: "slotSubscribe",
            unsubscribeMethod: "slotUnsubscribe"
        }, []);
    }
    /**
   * Deregister a slot notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeSlotChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "slot change");
    }
    /**
   * @internal
   */ _wsOnSlotUpdatesNotification(notification) {
        const { result: result, subscription: subscription } = (0, $c32abee974e85639$export$185802fd694ee1f5)(notification, $ca3473265f76df98$var$SlotUpdateNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon slot updates. {@link SlotUpdate}'s
   * may be useful to track live progress of a cluster.
   *
   * @param callback Function to invoke whenever the slot updates
   * @return subscription id
   */ onSlotUpdate(callback) {
        return this._makeSubscription({
            callback: callback,
            method: "slotsUpdatesSubscribe",
            unsubscribeMethod: "slotsUpdatesUnsubscribe"
        }, []);
    }
    /**
   * Deregister a slot update notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeSlotUpdateListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "slot update");
    }
    /**
   * @internal
   */ async _unsubscribeClientSubscription(clientSubscriptionId, subscriptionName) {
        const dispose = this._subscriptionDisposeFunctionsByClientSubscriptionId[clientSubscriptionId];
        if (dispose) await dispose();
        else console.warn("Ignored unsubscribe request because an active subscription with id " + `\`${clientSubscriptionId}\` for '${subscriptionName}' events ` + "could not be found.");
    }
    _buildArgs(args, override, encoding, extra) {
        const commitment = override || this._commitment;
        if (commitment || encoding || extra) {
            let options = {};
            if (encoding) options.encoding = encoding;
            if (commitment) options.commitment = commitment;
            if (extra) options = Object.assign(options, extra);
            args.push(options);
        }
        return args;
    }
    /**
   * @internal
   */ _buildArgsAtLeastConfirmed(args, override, encoding, extra) {
        const commitment = override || this._commitment;
        if (commitment && ![
            "confirmed",
            "finalized"
        ].includes(commitment)) throw new Error("Using Connection with default commitment: `" + this._commitment + "`, but method requires at least `confirmed`");
        return this._buildArgs(args, override, encoding, extra);
    }
    /**
   * @internal
   */ _wsOnSignatureNotification(notification) {
        const { result: result, subscription: subscription } = (0, $c32abee974e85639$export$185802fd694ee1f5)(notification, $ca3473265f76df98$var$SignatureNotificationResult);
        if (result.value !== "receivedSignature") /**
       * Special case.
       * After a signature is processed, RPCs automatically dispose of the
       * subscription on the server side. We need to track which of these
       * subscriptions have been disposed in such a way, so that we know
       * whether the client is dealing with a not-yet-processed signature
       * (in which case we must tear down the server subscription) or an
       * already-processed signature (in which case the client can simply
       * clear out the subscription locally without telling the server).
       *
       * NOTE: There is a proposal to eliminate this special case, here:
       * https://github.com/solana-labs/solana/issues/18892
       */ this._subscriptionsAutoDisposedByRpc.add(subscription);
        this._handleServerNotification(subscription, result.value === "receivedSignature" ? [
            {
                type: "received"
            },
            result.context
        ] : [
            {
                type: "status",
                result: result.value
            },
            result.context
        ]);
    }
    /**
   * Register a callback to be invoked upon signature updates
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param commitment Specify the commitment level signature must reach before notification
   * @return subscription id
   */ onSignature(signature, callback, commitment) {
        const args = this._buildArgs([
            signature
        ], commitment || this._commitment || "finalized" // Apply connection/server default.
        );
        const clientSubscriptionId = this._makeSubscription({
            callback: (notification, context)=>{
                if (notification.type === "status") {
                    callback(notification.result, context);
                    // Signatures subscriptions are auto-removed by the RPC service
                    // so no need to explicitly send an unsubscribe message.
                    try {
                        this.removeSignatureListener(clientSubscriptionId);
                    // eslint-disable-next-line no-empty
                    } catch (_err) {
                    // Already removed.
                    }
                }
            },
            method: "signatureSubscribe",
            unsubscribeMethod: "signatureUnsubscribe"
        }, args);
        return clientSubscriptionId;
    }
    /**
   * Register a callback to be invoked when a transaction is
   * received and/or processed.
   *
   * @param signature Transaction signature string in base 58
   * @param callback Function to invoke on signature notifications
   * @param options Enable received notifications and set the commitment
   *   level that signature must reach before notification
   * @return subscription id
   */ onSignatureWithOptions(signature, callback, options) {
        const { commitment: commitment, ...extra } = {
            ...options,
            commitment: options && options.commitment || this._commitment || "finalized" // Apply connection/server default.
        };
        const args = this._buildArgs([
            signature
        ], commitment, undefined /* encoding */ , extra);
        const clientSubscriptionId = this._makeSubscription({
            callback: (notification, context)=>{
                callback(notification, context);
                // Signatures subscriptions are auto-removed by the RPC service
                // so no need to explicitly send an unsubscribe message.
                try {
                    this.removeSignatureListener(clientSubscriptionId);
                // eslint-disable-next-line no-empty
                } catch (_err) {
                // Already removed.
                }
            },
            method: "signatureSubscribe",
            unsubscribeMethod: "signatureUnsubscribe"
        }, args);
        return clientSubscriptionId;
    }
    /**
   * Deregister a signature notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeSignatureListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "signature result");
    }
    /**
   * @internal
   */ _wsOnRootNotification(notification) {
        const { result: result, subscription: subscription } = (0, $c32abee974e85639$export$185802fd694ee1f5)(notification, $ca3473265f76df98$var$RootNotificationResult);
        this._handleServerNotification(subscription, [
            result
        ]);
    }
    /**
   * Register a callback to be invoked upon root changes
   *
   * @param callback Function to invoke whenever the root changes
   * @return subscription id
   */ onRootChange(callback) {
        return this._makeSubscription({
            callback: callback,
            method: "rootSubscribe",
            unsubscribeMethod: "rootUnsubscribe"
        }, []);
    }
    /**
   * Deregister a root notification callback
   *
   * @param clientSubscriptionId client subscription id to deregister
   */ async removeRootChangeListener(clientSubscriptionId) {
        await this._unsubscribeClientSubscription(clientSubscriptionId, "root change");
    }
}
/**
 * Keypair signer interface
 */ /**
 * An account keypair used for signing transactions.
 */ class $ca3473265f76df98$export$c53bca448cf33676 {
    /**
   * Create a new keypair instance.
   * Generate random keypair if no {@link Ed25519Keypair} is provided.
   *
   * @param {Ed25519Keypair} keypair ed25519 keypair
   */ constructor(keypair){
        this._keypair = void 0;
        this._keypair = keypair ?? $ca3473265f76df98$var$generateKeypair();
    }
    /**
   * Generate a new random keypair
   *
   * @returns {Keypair} Keypair
   */ static generate() {
        return new $ca3473265f76df98$export$c53bca448cf33676($ca3473265f76df98$var$generateKeypair());
    }
    /**
   * Create a keypair from a raw secret key byte array.
   *
   * This method should only be used to recreate a keypair from a previously
   * generated secret key. Generating keypairs from a random seed should be done
   * with the {@link Keypair.fromSeed} method.
   *
   * @throws error if the provided secret key is invalid and validation is not skipped.
   *
   * @param secretKey secret key byte array
   * @param options skip secret key validation
   *
   * @returns {Keypair} Keypair
   */ static fromSecretKey(secretKey, options) {
        if (secretKey.byteLength !== 64) throw new Error("bad secret key size");
        const publicKey = secretKey.slice(32, 64);
        if (!options || !options.skipValidation) {
            const privateScalar = secretKey.slice(0, 32);
            const computedPublicKey = $ca3473265f76df98$var$getPublicKey(privateScalar);
            for(let ii = 0; ii < 32; ii++){
                if (publicKey[ii] !== computedPublicKey[ii]) throw new Error("provided secretKey is invalid");
            }
        }
        return new $ca3473265f76df98$export$c53bca448cf33676({
            publicKey: publicKey,
            secretKey: secretKey
        });
    }
    /**
   * Generate a keypair from a 32 byte seed.
   *
   * @param seed seed byte array
   *
   * @returns {Keypair} Keypair
   */ static fromSeed(seed) {
        const publicKey = $ca3473265f76df98$var$getPublicKey(seed);
        const secretKey = new Uint8Array(64);
        secretKey.set(seed);
        secretKey.set(publicKey, 32);
        return new $ca3473265f76df98$export$c53bca448cf33676({
            publicKey: publicKey,
            secretKey: secretKey
        });
    }
    /**
   * The public key for this keypair
   *
   * @returns {PublicKey} PublicKey
   */ get publicKey() {
        return new $ca3473265f76df98$export$ca8b6604d6ce14de(this._keypair.publicKey);
    }
    /**
   * The raw secret key for this keypair
   * @returns {Uint8Array} Secret key in an array of Uint8 bytes
   */ get secretKey() {
        return new Uint8Array(this._keypair.secretKey);
    }
}
/**
 * An enumeration of valid LookupTableInstructionType's
 */ /**
 * An enumeration of valid address lookup table InstructionType's
 * @internal
 */ const $ca3473265f76df98$export$7d102200c3a357d6 = Object.freeze({
    CreateLookupTable: {
        index: 0,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u32("instruction"),
            $ca3473265f76df98$var$u64("recentSlot"),
            $ab8b5713b1ee9109$exports.u8("bumpSeed")
        ])
    },
    FreezeLookupTable: {
        index: 1,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u32("instruction")
        ])
    },
    ExtendLookupTable: {
        index: 2,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u32("instruction"),
            $ca3473265f76df98$var$u64(),
            $ab8b5713b1ee9109$exports.seq($ca3473265f76df98$var$publicKey(), $ab8b5713b1ee9109$exports.offset($ab8b5713b1ee9109$exports.u32(), -8), "addresses")
        ])
    },
    DeactivateLookupTable: {
        index: 3,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u32("instruction")
        ])
    },
    CloseLookupTable: {
        index: 4,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u32("instruction")
        ])
    }
});
class $ca3473265f76df98$export$3ab2b24d551f0dc2 {
    /**
   * @internal
   */ constructor(){}
    static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $ab8b5713b1ee9109$exports.u32("instruction");
        const index = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [layoutType, layout] of Object.entries($ca3473265f76df98$export$7d102200c3a357d6))if (layout.index == index) {
            type = layoutType;
            break;
        }
        if (!type) throw new Error("Invalid Instruction. Should be a LookupTable Instruction");
        return type;
    }
    static decodeCreateLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 4);
        const { recentSlot: recentSlot } = $ca3473265f76df98$var$decodeData$1($ca3473265f76df98$export$7d102200c3a357d6.CreateLookupTable, instruction.data);
        return {
            authority: instruction.keys[1].pubkey,
            payer: instruction.keys[2].pubkey,
            recentSlot: Number(recentSlot)
        };
    }
    static decodeExtendLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        if (instruction.keys.length < 2) throw new Error(`invalid instruction; found ${instruction.keys.length} keys, expected at least 2`);
        const { addresses: addresses } = $ca3473265f76df98$var$decodeData$1($ca3473265f76df98$export$7d102200c3a357d6.ExtendLookupTable, instruction.data);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey,
            payer: instruction.keys.length > 2 ? instruction.keys[2].pubkey : undefined,
            addresses: addresses.map((buffer)=>new $ca3473265f76df98$export$ca8b6604d6ce14de(buffer))
        };
    }
    static decodeCloseLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 3);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey,
            recipient: instruction.keys[2].pubkey
        };
    }
    static decodeFreezeLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 2);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey
        };
    }
    static decodeDeactivateLookupTable(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeysLength(instruction.keys, 2);
        return {
            lookupTable: instruction.keys[0].pubkey,
            authority: instruction.keys[1].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($ca3473265f76df98$export$5147a345798de168.programId)) throw new Error("invalid instruction; programId is not AddressLookupTable Program");
    }
    /**
   * @internal
   */ static checkKeysLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
class $ca3473265f76df98$export$5147a345798de168 {
    /**
   * @internal
   */ constructor(){}
    static createLookupTable(params) {
        const [lookupTableAddress, bumpSeed] = $ca3473265f76df98$export$ca8b6604d6ce14de.findProgramAddressSync([
            params.authority.toBuffer(),
            (0, $681a4aa191fca251$exports.toBufferLE)(BigInt(params.recentSlot), 8)
        ], this.programId);
        const type = $ca3473265f76df98$export$7d102200c3a357d6.CreateLookupTable;
        const data = $ca3473265f76df98$var$encodeData(type, {
            recentSlot: BigInt(params.recentSlot),
            bumpSeed: bumpSeed
        });
        const keys = [
            {
                pubkey: lookupTableAddress,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: params.payer,
                isSigner: true,
                isWritable: true
            },
            {
                pubkey: $ca3473265f76df98$export$d8c4e17726848113.programId,
                isSigner: false,
                isWritable: false
            }
        ];
        return [
            new $ca3473265f76df98$export$a7a3aa8360ac9f59({
                programId: this.programId,
                keys: keys,
                data: data
            }),
            lookupTableAddress
        ];
    }
    static freezeLookupTable(params) {
        const type = $ca3473265f76df98$export$7d102200c3a357d6.FreezeLookupTable;
        const data = $ca3473265f76df98$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $ca3473265f76df98$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static extendLookupTable(params) {
        const type = $ca3473265f76df98$export$7d102200c3a357d6.ExtendLookupTable;
        const data = $ca3473265f76df98$var$encodeData(type, {
            addresses: params.addresses.map((addr)=>addr.toBytes())
        });
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        if (params.payer) keys.push({
            pubkey: params.payer,
            isSigner: true,
            isWritable: true
        }, {
            pubkey: $ca3473265f76df98$export$d8c4e17726848113.programId,
            isSigner: false,
            isWritable: false
        });
        return new $ca3473265f76df98$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static deactivateLookupTable(params) {
        const type = $ca3473265f76df98$export$7d102200c3a357d6.DeactivateLookupTable;
        const data = $ca3473265f76df98$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $ca3473265f76df98$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
    static closeLookupTable(params) {
        const type = $ca3473265f76df98$export$7d102200c3a357d6.CloseLookupTable;
        const data = $ca3473265f76df98$var$encodeData(type);
        const keys = [
            {
                pubkey: params.lookupTable,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: params.authority,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: params.recipient,
                isSigner: false,
                isWritable: true
            }
        ];
        return new $ca3473265f76df98$export$a7a3aa8360ac9f59({
            programId: this.programId,
            keys: keys,
            data: data
        });
    }
}
$ca3473265f76df98$export$5147a345798de168.programId = new $ca3473265f76df98$export$ca8b6604d6ce14de("AddressLookupTab1e1111111111111111111111111");
/**
 * Compute Budget Instruction class
 */ class $ca3473265f76df98$export$bc4776847c641a67 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a compute budget instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $ab8b5713b1ee9109$exports.u8("instruction");
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($ca3473265f76df98$export$b7c79c50764da3d6))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error("Instruction type incorrect; not a ComputeBudgetInstruction");
        return type;
    }
    /**
   * Decode request units compute budget instruction and retrieve the instruction params.
   */ static decodeRequestUnits(instruction) {
        this.checkProgramId(instruction.programId);
        const { units: units, additionalFee: additionalFee } = $ca3473265f76df98$var$decodeData$1($ca3473265f76df98$export$b7c79c50764da3d6.RequestUnits, instruction.data);
        return {
            units: units,
            additionalFee: additionalFee
        };
    }
    /**
   * Decode request heap frame compute budget instruction and retrieve the instruction params.
   */ static decodeRequestHeapFrame(instruction) {
        this.checkProgramId(instruction.programId);
        const { bytes: bytes } = $ca3473265f76df98$var$decodeData$1($ca3473265f76df98$export$b7c79c50764da3d6.RequestHeapFrame, instruction.data);
        return {
            bytes: bytes
        };
    }
    /**
   * Decode set compute unit limit compute budget instruction and retrieve the instruction params.
   */ static decodeSetComputeUnitLimit(instruction) {
        this.checkProgramId(instruction.programId);
        const { units: units } = $ca3473265f76df98$var$decodeData$1($ca3473265f76df98$export$b7c79c50764da3d6.SetComputeUnitLimit, instruction.data);
        return {
            units: units
        };
    }
    /**
   * Decode set compute unit price compute budget instruction and retrieve the instruction params.
   */ static decodeSetComputeUnitPrice(instruction) {
        this.checkProgramId(instruction.programId);
        const { microLamports: microLamports } = $ca3473265f76df98$var$decodeData$1($ca3473265f76df98$export$b7c79c50764da3d6.SetComputeUnitPrice, instruction.data);
        return {
            microLamports: microLamports
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($ca3473265f76df98$export$11585db5942bcdb7.programId)) throw new Error("invalid instruction; programId is not ComputeBudgetProgram");
    }
}
/**
 * An enumeration of valid ComputeBudgetInstructionType's
 */ /**
 * Request units instruction params
 */ /**
 * Request heap frame instruction params
 */ /**
 * Set compute unit limit instruction params
 */ /**
 * Set compute unit price instruction params
 */ /**
 * An enumeration of valid ComputeBudget InstructionType's
 * @internal
 */ const $ca3473265f76df98$export$b7c79c50764da3d6 = Object.freeze({
    RequestUnits: {
        index: 0,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u8("instruction"),
            $ab8b5713b1ee9109$exports.u32("units"),
            $ab8b5713b1ee9109$exports.u32("additionalFee")
        ])
    },
    RequestHeapFrame: {
        index: 1,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u8("instruction"),
            $ab8b5713b1ee9109$exports.u32("bytes")
        ])
    },
    SetComputeUnitLimit: {
        index: 2,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u8("instruction"),
            $ab8b5713b1ee9109$exports.u32("units")
        ])
    },
    SetComputeUnitPrice: {
        index: 3,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u8("instruction"),
            $ca3473265f76df98$var$u64("microLamports")
        ])
    }
});
/**
 * Factory class for transaction instructions to interact with the Compute Budget program
 */ class $ca3473265f76df98$export$11585db5942bcdb7 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Compute Budget program
   */ /**
   * @deprecated Instead, call {@link setComputeUnitLimit} and/or {@link setComputeUnitPrice}
   */ static requestUnits(params) {
        const type = $ca3473265f76df98$export$b7c79c50764da3d6.RequestUnits;
        const data = $ca3473265f76df98$var$encodeData(type, params);
        return new $ca3473265f76df98$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static requestHeapFrame(params) {
        const type = $ca3473265f76df98$export$b7c79c50764da3d6.RequestHeapFrame;
        const data = $ca3473265f76df98$var$encodeData(type, params);
        return new $ca3473265f76df98$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static setComputeUnitLimit(params) {
        const type = $ca3473265f76df98$export$b7c79c50764da3d6.SetComputeUnitLimit;
        const data = $ca3473265f76df98$var$encodeData(type, params);
        return new $ca3473265f76df98$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
    static setComputeUnitPrice(params) {
        const type = $ca3473265f76df98$export$b7c79c50764da3d6.SetComputeUnitPrice;
        const data = $ca3473265f76df98$var$encodeData(type, {
            microLamports: BigInt(params.microLamports)
        });
        return new $ca3473265f76df98$export$a7a3aa8360ac9f59({
            keys: [],
            programId: this.programId,
            data: data
        });
    }
}
$ca3473265f76df98$export$11585db5942bcdb7.programId = new $ca3473265f76df98$export$ca8b6604d6ce14de("ComputeBudget111111111111111111111111111111");
const $ca3473265f76df98$var$PRIVATE_KEY_BYTES$1 = 64;
const $ca3473265f76df98$var$PUBLIC_KEY_BYTES$1 = 32;
const $ca3473265f76df98$var$SIGNATURE_BYTES = 64;
/**
 * Params for creating an ed25519 instruction using a public key
 */ /**
 * Params for creating an ed25519 instruction using a private key
 */ const $ca3473265f76df98$var$ED25519_INSTRUCTION_LAYOUT = $ab8b5713b1ee9109$exports.struct([
    $ab8b5713b1ee9109$exports.u8("numSignatures"),
    $ab8b5713b1ee9109$exports.u8("padding"),
    $ab8b5713b1ee9109$exports.u16("signatureOffset"),
    $ab8b5713b1ee9109$exports.u16("signatureInstructionIndex"),
    $ab8b5713b1ee9109$exports.u16("publicKeyOffset"),
    $ab8b5713b1ee9109$exports.u16("publicKeyInstructionIndex"),
    $ab8b5713b1ee9109$exports.u16("messageDataOffset"),
    $ab8b5713b1ee9109$exports.u16("messageDataSize"),
    $ab8b5713b1ee9109$exports.u16("messageInstructionIndex")
]);
class $ca3473265f76df98$export$e5087aea02631e {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the ed25519 program
   */ /**
   * Create an ed25519 instruction with a public key and signature. The
   * public key must be a buffer that is 32 bytes long, and the signature
   * must be a buffer of 64 bytes.
   */ static createInstructionWithPublicKey(params) {
        const { publicKey: publicKey, message: message, signature: signature, instructionIndex: instructionIndex } = params;
        $ca3473265f76df98$var$assert(publicKey.length === $ca3473265f76df98$var$PUBLIC_KEY_BYTES$1, `Public Key must be ${$ca3473265f76df98$var$PUBLIC_KEY_BYTES$1} bytes but received ${publicKey.length} bytes`);
        $ca3473265f76df98$var$assert(signature.length === $ca3473265f76df98$var$SIGNATURE_BYTES, `Signature must be ${$ca3473265f76df98$var$SIGNATURE_BYTES} bytes but received ${signature.length} bytes`);
        const publicKeyOffset = $ca3473265f76df98$var$ED25519_INSTRUCTION_LAYOUT.span;
        const signatureOffset = publicKeyOffset + publicKey.length;
        const messageDataOffset = signatureOffset + signature.length;
        const numSignatures = 1;
        const instructionData = (0, $492757110c774bc9$export$a143d493d941bafc).alloc(messageDataOffset + message.length);
        const index = instructionIndex == null ? 0xffff // An index of `u16::MAX` makes it default to the current instruction.
         : instructionIndex;
        $ca3473265f76df98$var$ED25519_INSTRUCTION_LAYOUT.encode({
            numSignatures: numSignatures,
            padding: 0,
            signatureOffset: signatureOffset,
            signatureInstructionIndex: index,
            publicKeyOffset: publicKeyOffset,
            publicKeyInstructionIndex: index,
            messageDataOffset: messageDataOffset,
            messageDataSize: message.length,
            messageInstructionIndex: index
        }, instructionData);
        instructionData.fill(publicKey, publicKeyOffset);
        instructionData.fill(signature, signatureOffset);
        instructionData.fill(message, messageDataOffset);
        return new $ca3473265f76df98$export$a7a3aa8360ac9f59({
            keys: [],
            programId: $ca3473265f76df98$export$e5087aea02631e.programId,
            data: instructionData
        });
    }
    /**
   * Create an ed25519 instruction with a private key. The private key
   * must be a buffer that is 64 bytes long.
   */ static createInstructionWithPrivateKey(params) {
        const { privateKey: privateKey, message: message, instructionIndex: instructionIndex } = params;
        $ca3473265f76df98$var$assert(privateKey.length === $ca3473265f76df98$var$PRIVATE_KEY_BYTES$1, `Private key must be ${$ca3473265f76df98$var$PRIVATE_KEY_BYTES$1} bytes but received ${privateKey.length} bytes`);
        try {
            const keypair = $ca3473265f76df98$export$c53bca448cf33676.fromSecretKey(privateKey);
            const publicKey = keypair.publicKey.toBytes();
            const signature = $ca3473265f76df98$var$sign(message, keypair.secretKey);
            return this.createInstructionWithPublicKey({
                publicKey: publicKey,
                message: message,
                signature: signature,
                instructionIndex: instructionIndex
            });
        } catch (error) {
            throw new Error(`Error creating instruction; ${error}`);
        }
    }
}
$ca3473265f76df98$export$e5087aea02631e.programId = new $ca3473265f76df98$export$ca8b6604d6ce14de("Ed25519SigVerify111111111111111111111111111");
const $ca3473265f76df98$var$ecdsaSign = (msgHash, privKey)=>{
    const signature = (0, $48a78f8d451730ce$export$529e6123e9353a90).sign(msgHash, privKey);
    return [
        signature.toCompactRawBytes(),
        signature.recovery
    ];
};
(0, $48a78f8d451730ce$export$529e6123e9353a90).utils.isValidPrivateKey;
const $ca3473265f76df98$var$publicKeyCreate = (0, $48a78f8d451730ce$export$529e6123e9353a90).getPublicKey;
const $ca3473265f76df98$var$PRIVATE_KEY_BYTES = 32;
const $ca3473265f76df98$var$ETHEREUM_ADDRESS_BYTES = 20;
const $ca3473265f76df98$var$PUBLIC_KEY_BYTES = 64;
const $ca3473265f76df98$var$SIGNATURE_OFFSETS_SERIALIZED_SIZE = 11;
/**
 * Params for creating an secp256k1 instruction using a public key
 */ /**
 * Params for creating an secp256k1 instruction using an Ethereum address
 */ /**
 * Params for creating an secp256k1 instruction using a private key
 */ const $ca3473265f76df98$var$SECP256K1_INSTRUCTION_LAYOUT = $ab8b5713b1ee9109$exports.struct([
    $ab8b5713b1ee9109$exports.u8("numSignatures"),
    $ab8b5713b1ee9109$exports.u16("signatureOffset"),
    $ab8b5713b1ee9109$exports.u8("signatureInstructionIndex"),
    $ab8b5713b1ee9109$exports.u16("ethAddressOffset"),
    $ab8b5713b1ee9109$exports.u8("ethAddressInstructionIndex"),
    $ab8b5713b1ee9109$exports.u16("messageDataOffset"),
    $ab8b5713b1ee9109$exports.u16("messageDataSize"),
    $ab8b5713b1ee9109$exports.u8("messageInstructionIndex"),
    $ab8b5713b1ee9109$exports.blob(20, "ethAddress"),
    $ab8b5713b1ee9109$exports.blob(64, "signature"),
    $ab8b5713b1ee9109$exports.u8("recoveryId")
]);
class $ca3473265f76df98$export$d85dd4c1161d13c9 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the secp256k1 program
   */ /**
   * Construct an Ethereum address from a secp256k1 public key buffer.
   * @param {Buffer} publicKey a 64 byte secp256k1 public key buffer
   */ static publicKeyToEthAddress(publicKey) {
        $ca3473265f76df98$var$assert(publicKey.length === $ca3473265f76df98$var$PUBLIC_KEY_BYTES, `Public key must be ${$ca3473265f76df98$var$PUBLIC_KEY_BYTES} bytes but received ${publicKey.length} bytes`);
        try {
            return (0, $492757110c774bc9$export$a143d493d941bafc).from((0, $hrc0B.keccak_256)($ca3473265f76df98$var$toBuffer(publicKey))).slice(-$ca3473265f76df98$var$ETHEREUM_ADDRESS_BYTES);
        } catch (error) {
            throw new Error(`Error constructing Ethereum address: ${error}`);
        }
    }
    /**
   * Create an secp256k1 instruction with a public key. The public key
   * must be a buffer that is 64 bytes long.
   */ static createInstructionWithPublicKey(params) {
        const { publicKey: publicKey, message: message, signature: signature, recoveryId: recoveryId, instructionIndex: instructionIndex } = params;
        return $ca3473265f76df98$export$d85dd4c1161d13c9.createInstructionWithEthAddress({
            ethAddress: $ca3473265f76df98$export$d85dd4c1161d13c9.publicKeyToEthAddress(publicKey),
            message: message,
            signature: signature,
            recoveryId: recoveryId,
            instructionIndex: instructionIndex
        });
    }
    /**
   * Create an secp256k1 instruction with an Ethereum address. The address
   * must be a hex string or a buffer that is 20 bytes long.
   */ static createInstructionWithEthAddress(params) {
        const { ethAddress: rawAddress, message: message, signature: signature, recoveryId: recoveryId, instructionIndex: instructionIndex = 0 } = params;
        let ethAddress;
        if (typeof rawAddress === "string") {
            if (rawAddress.startsWith("0x")) ethAddress = (0, $492757110c774bc9$export$a143d493d941bafc).from(rawAddress.substr(2), "hex");
            else ethAddress = (0, $492757110c774bc9$export$a143d493d941bafc).from(rawAddress, "hex");
        } else ethAddress = rawAddress;
        $ca3473265f76df98$var$assert(ethAddress.length === $ca3473265f76df98$var$ETHEREUM_ADDRESS_BYTES, `Address must be ${$ca3473265f76df98$var$ETHEREUM_ADDRESS_BYTES} bytes but received ${ethAddress.length} bytes`);
        const dataStart = 1 + $ca3473265f76df98$var$SIGNATURE_OFFSETS_SERIALIZED_SIZE;
        const ethAddressOffset = dataStart;
        const signatureOffset = dataStart + ethAddress.length;
        const messageDataOffset = signatureOffset + signature.length + 1;
        const numSignatures = 1;
        const instructionData = (0, $492757110c774bc9$export$a143d493d941bafc).alloc($ca3473265f76df98$var$SECP256K1_INSTRUCTION_LAYOUT.span + message.length);
        $ca3473265f76df98$var$SECP256K1_INSTRUCTION_LAYOUT.encode({
            numSignatures: numSignatures,
            signatureOffset: signatureOffset,
            signatureInstructionIndex: instructionIndex,
            ethAddressOffset: ethAddressOffset,
            ethAddressInstructionIndex: instructionIndex,
            messageDataOffset: messageDataOffset,
            messageDataSize: message.length,
            messageInstructionIndex: instructionIndex,
            signature: $ca3473265f76df98$var$toBuffer(signature),
            ethAddress: $ca3473265f76df98$var$toBuffer(ethAddress),
            recoveryId: recoveryId
        }, instructionData);
        instructionData.fill($ca3473265f76df98$var$toBuffer(message), $ca3473265f76df98$var$SECP256K1_INSTRUCTION_LAYOUT.span);
        return new $ca3473265f76df98$export$a7a3aa8360ac9f59({
            keys: [],
            programId: $ca3473265f76df98$export$d85dd4c1161d13c9.programId,
            data: instructionData
        });
    }
    /**
   * Create an secp256k1 instruction with a private key. The private key
   * must be a buffer that is 32 bytes long.
   */ static createInstructionWithPrivateKey(params) {
        const { privateKey: pkey, message: message, instructionIndex: instructionIndex } = params;
        $ca3473265f76df98$var$assert(pkey.length === $ca3473265f76df98$var$PRIVATE_KEY_BYTES, `Private key must be ${$ca3473265f76df98$var$PRIVATE_KEY_BYTES} bytes but received ${pkey.length} bytes`);
        try {
            const privateKey = $ca3473265f76df98$var$toBuffer(pkey);
            const publicKey = $ca3473265f76df98$var$publicKeyCreate(privateKey, false).slice(1); // throw away leading byte
            const messageHash = (0, $492757110c774bc9$export$a143d493d941bafc).from((0, $hrc0B.keccak_256)($ca3473265f76df98$var$toBuffer(message)));
            const [signature, recoveryId] = $ca3473265f76df98$var$ecdsaSign(messageHash, privateKey);
            return this.createInstructionWithPublicKey({
                publicKey: publicKey,
                message: message,
                signature: signature,
                recoveryId: recoveryId,
                instructionIndex: instructionIndex
            });
        } catch (error) {
            throw new Error(`Error creating instruction; ${error}`);
        }
    }
}
$ca3473265f76df98$export$d85dd4c1161d13c9.programId = new $ca3473265f76df98$export$ca8b6604d6ce14de("KeccakSecp256k11111111111111111111111111111");
var $ca3473265f76df98$var$_Lockup;
/**
 * Address of the stake config account which configures the rate
 * of stake warmup and cooldown as well as the slashing penalty.
 */ const $ca3473265f76df98$export$18aac71979bdd08f = new $ca3473265f76df98$export$ca8b6604d6ce14de("StakeConfig11111111111111111111111111111111");
/**
 * Stake account authority info
 */ class $ca3473265f76df98$export$9ac74ae66932a145 {
    /**
   * Create a new Authorized object
   * @param staker the stake authority
   * @param withdrawer the withdraw authority
   */ constructor(staker, withdrawer){
        /** stake authority */ this.staker = void 0;
        /** withdraw authority */ this.withdrawer = void 0;
        this.staker = staker;
        this.withdrawer = withdrawer;
    }
}
/**
 * Stake account lockup info
 */ class $ca3473265f76df98$export$e7f3941ade35598c {
    /**
   * Create a new Lockup object
   */ constructor(unixTimestamp, epoch, custodian){
        /** Unix timestamp of lockup expiration */ this.unixTimestamp = void 0;
        /** Epoch of lockup expiration */ this.epoch = void 0;
        /** Lockup custodian authority */ this.custodian = void 0;
        this.unixTimestamp = unixTimestamp;
        this.epoch = epoch;
        this.custodian = custodian;
    }
}
$ca3473265f76df98$var$_Lockup = $ca3473265f76df98$export$e7f3941ade35598c;
$ca3473265f76df98$export$e7f3941ade35598c.default = new $ca3473265f76df98$var$_Lockup(0, 0, $ca3473265f76df98$export$ca8b6604d6ce14de.default);
/**
 * Create stake account transaction params
 */ /**
 * Create stake account with seed transaction params
 */ /**
 * Initialize stake instruction params
 */ /**
 * Delegate stake instruction params
 */ /**
 * Authorize stake instruction params
 */ /**
 * Authorize stake instruction params using a derived key
 */ /**
 * Split stake instruction params
 */ /**
 * Split with seed transaction params
 */ /**
 * Withdraw stake instruction params
 */ /**
 * Deactivate stake instruction params
 */ /**
 * Merge stake instruction params
 */ /**
 * Stake Instruction class
 */ class $ca3473265f76df98$export$aded313c3a4800f9 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a stake instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $ab8b5713b1ee9109$exports.u32("instruction");
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($ca3473265f76df98$export$c89793bd2bba8b2e))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error("Instruction type incorrect; not a StakeInstruction");
        return type;
    }
    /**
   * Decode a initialize stake instruction and retrieve the instruction params.
   */ static decodeInitialize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { authorized: authorized, lockup: lockup } = $ca3473265f76df98$var$decodeData$1($ca3473265f76df98$export$c89793bd2bba8b2e.Initialize, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            authorized: new $ca3473265f76df98$export$9ac74ae66932a145(new $ca3473265f76df98$export$ca8b6604d6ce14de(authorized.staker), new $ca3473265f76df98$export$ca8b6604d6ce14de(authorized.withdrawer)),
            lockup: new $ca3473265f76df98$export$e7f3941ade35598c(lockup.unixTimestamp, lockup.epoch, new $ca3473265f76df98$export$ca8b6604d6ce14de(lockup.custodian))
        };
    }
    /**
   * Decode a delegate stake instruction and retrieve the instruction params.
   */ static decodeDelegate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 6);
        $ca3473265f76df98$var$decodeData$1($ca3473265f76df98$export$c89793bd2bba8b2e.Delegate, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            votePubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[5].pubkey
        };
    }
    /**
   * Decode an authorize stake instruction and retrieve the instruction params.
   */ static decodeAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { newAuthorized: newAuthorized, stakeAuthorizationType: stakeAuthorizationType } = $ca3473265f76df98$var$decodeData$1($ca3473265f76df98$export$c89793bd2bba8b2e.Authorize, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            newAuthorizedPubkey: new $ca3473265f76df98$export$ca8b6604d6ce14de(newAuthorized),
            stakeAuthorizationType: {
                index: stakeAuthorizationType
            }
        };
        if (instruction.keys.length > 3) o.custodianPubkey = instruction.keys[3].pubkey;
        return o;
    }
    /**
   * Decode an authorize-with-seed stake instruction and retrieve the instruction params.
   */ static decodeAuthorizeWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 2);
        const { newAuthorized: newAuthorized, stakeAuthorizationType: stakeAuthorizationType, authoritySeed: authoritySeed, authorityOwner: authorityOwner } = $ca3473265f76df98$var$decodeData$1($ca3473265f76df98$export$c89793bd2bba8b2e.AuthorizeWithSeed, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            authorityBase: instruction.keys[1].pubkey,
            authoritySeed: authoritySeed,
            authorityOwner: new $ca3473265f76df98$export$ca8b6604d6ce14de(authorityOwner),
            newAuthorizedPubkey: new $ca3473265f76df98$export$ca8b6604d6ce14de(newAuthorized),
            stakeAuthorizationType: {
                index: stakeAuthorizationType
            }
        };
        if (instruction.keys.length > 3) o.custodianPubkey = instruction.keys[3].pubkey;
        return o;
    }
    /**
   * Decode a split stake instruction and retrieve the instruction params.
   */ static decodeSplit(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports } = $ca3473265f76df98$var$decodeData$1($ca3473265f76df98$export$c89793bd2bba8b2e.Split, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            splitStakePubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            lamports: lamports
        };
    }
    /**
   * Decode a merge stake instruction and retrieve the instruction params.
   */ static decodeMerge(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $ca3473265f76df98$var$decodeData$1($ca3473265f76df98$export$c89793bd2bba8b2e.Merge, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            sourceStakePubKey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey
        };
    }
    /**
   * Decode a withdraw stake instruction and retrieve the instruction params.
   */ static decodeWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 5);
        const { lamports: lamports } = $ca3473265f76df98$var$decodeData$1($ca3473265f76df98$export$c89793bd2bba8b2e.Withdraw, instruction.data);
        const o = {
            stakePubkey: instruction.keys[0].pubkey,
            toPubkey: instruction.keys[1].pubkey,
            authorizedPubkey: instruction.keys[4].pubkey,
            lamports: lamports
        };
        if (instruction.keys.length > 5) o.custodianPubkey = instruction.keys[5].pubkey;
        return o;
    }
    /**
   * Decode a deactivate stake instruction and retrieve the instruction params.
   */ static decodeDeactivate(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        $ca3473265f76df98$var$decodeData$1($ca3473265f76df98$export$c89793bd2bba8b2e.Deactivate, instruction.data);
        return {
            stakePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($ca3473265f76df98$export$df86f933e9f8fb15.programId)) throw new Error("invalid instruction; programId is not StakeProgram");
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid StakeInstructionType's
 */ /**
 * An enumeration of valid stake InstructionType's
 * @internal
 */ const $ca3473265f76df98$export$c89793bd2bba8b2e = Object.freeze({
    Initialize: {
        index: 0,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u32("instruction"),
            $ca3473265f76df98$var$authorized(),
            $ca3473265f76df98$var$lockup()
        ])
    },
    Authorize: {
        index: 1,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u32("instruction"),
            $ca3473265f76df98$var$publicKey("newAuthorized"),
            $ab8b5713b1ee9109$exports.u32("stakeAuthorizationType")
        ])
    },
    Delegate: {
        index: 2,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u32("instruction")
        ])
    },
    Split: {
        index: 3,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u32("instruction"),
            $ab8b5713b1ee9109$exports.ns64("lamports")
        ])
    },
    Withdraw: {
        index: 4,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u32("instruction"),
            $ab8b5713b1ee9109$exports.ns64("lamports")
        ])
    },
    Deactivate: {
        index: 5,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u32("instruction")
        ])
    },
    Merge: {
        index: 7,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u32("instruction")
        ])
    },
    AuthorizeWithSeed: {
        index: 8,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u32("instruction"),
            $ca3473265f76df98$var$publicKey("newAuthorized"),
            $ab8b5713b1ee9109$exports.u32("stakeAuthorizationType"),
            $ca3473265f76df98$var$rustString("authoritySeed"),
            $ca3473265f76df98$var$publicKey("authorityOwner")
        ])
    }
});
/**
 * Stake authorization type
 */ /**
 * An enumeration of valid StakeAuthorizationLayout's
 */ const $ca3473265f76df98$export$4783920eadd34361 = Object.freeze({
    Staker: {
        index: 0
    },
    Withdrawer: {
        index: 1
    }
});
/**
 * Factory class for transactions to interact with the Stake program
 */ class $ca3473265f76df98$export$df86f933e9f8fb15 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Stake program
   */ /**
   * Generate an Initialize instruction to add to a Stake Create transaction
   */ static initialize(params) {
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: maybeLockup } = params;
        const lockup = maybeLockup || $ca3473265f76df98$export$e7f3941ade35598c.default;
        const type = $ca3473265f76df98$export$c89793bd2bba8b2e.Initialize;
        const data = $ca3473265f76df98$var$encodeData(type, {
            authorized: {
                staker: $ca3473265f76df98$var$toBuffer(authorized.staker.toBuffer()),
                withdrawer: $ca3473265f76df98$var$toBuffer(authorized.withdrawer.toBuffer())
            },
            lockup: {
                unixTimestamp: lockup.unixTimestamp,
                epoch: lockup.epoch,
                custodian: $ca3473265f76df98$var$toBuffer(lockup.custodian.toBuffer())
            }
        });
        const instructionData = {
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $ca3473265f76df98$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $ca3473265f76df98$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a Transaction that creates a new Stake account at
   *   an address generated with `from`, a seed, and the Stake programId
   */ static createAccountWithSeed(params) {
        const transaction = new $ca3473265f76df98$export$febc5573c75cefb0();
        transaction.add($ca3473265f76df98$export$d8c4e17726848113.createAccountWithSeed({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.stakePubkey,
            basePubkey: params.basePubkey,
            seed: params.seed,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: lockup } = params;
        return transaction.add(this.initialize({
            stakePubkey: stakePubkey,
            authorized: authorized,
            lockup: lockup
        }));
    }
    /**
   * Generate a Transaction that creates a new Stake account
   */ static createAccount(params) {
        const transaction = new $ca3473265f76df98$export$febc5573c75cefb0();
        transaction.add($ca3473265f76df98$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.stakePubkey,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        const { stakePubkey: stakePubkey, authorized: authorized, lockup: lockup } = params;
        return transaction.add(this.initialize({
            stakePubkey: stakePubkey,
            authorized: authorized,
            lockup: lockup
        }));
    }
    /**
   * Generate a Transaction that delegates Stake tokens to a validator
   * Vote PublicKey. This transaction can also be used to redelegate Stake
   * to a new validator Vote PublicKey.
   */ static delegate(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, votePubkey: votePubkey } = params;
        const type = $ca3473265f76df98$export$c89793bd2bba8b2e.Delegate;
        const data = $ca3473265f76df98$var$encodeData(type);
        return new $ca3473265f76df98$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: votePubkey,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $ca3473265f76df98$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $ca3473265f76df98$export$ca994171317280ea,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $ca3473265f76df98$export$18aac71979bdd08f,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */ static authorize(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, newAuthorizedPubkey: newAuthorizedPubkey, stakeAuthorizationType: stakeAuthorizationType, custodianPubkey: custodianPubkey } = params;
        const type = $ca3473265f76df98$export$c89793bd2bba8b2e.Authorize;
        const data = $ca3473265f76df98$var$encodeData(type, {
            newAuthorized: $ca3473265f76df98$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            stakeAuthorizationType: stakeAuthorizationType.index
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $ca3473265f76df98$export$393aa1412d47050e,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: true,
            isWritable: false
        });
        return new $ca3473265f76df98$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that authorizes a new PublicKey as Staker
   * or Withdrawer on the Stake account.
   */ static authorizeWithSeed(params) {
        const { stakePubkey: stakePubkey, authorityBase: authorityBase, authoritySeed: authoritySeed, authorityOwner: authorityOwner, newAuthorizedPubkey: newAuthorizedPubkey, stakeAuthorizationType: stakeAuthorizationType, custodianPubkey: custodianPubkey } = params;
        const type = $ca3473265f76df98$export$c89793bd2bba8b2e.AuthorizeWithSeed;
        const data = $ca3473265f76df98$var$encodeData(type, {
            newAuthorized: $ca3473265f76df98$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            stakeAuthorizationType: stakeAuthorizationType.index,
            authoritySeed: authoritySeed,
            authorityOwner: $ca3473265f76df98$var$toBuffer(authorityOwner.toBuffer())
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorityBase,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: $ca3473265f76df98$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: true,
            isWritable: false
        });
        return new $ca3473265f76df98$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * @internal
   */ static splitInstruction(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, splitStakePubkey: splitStakePubkey, lamports: lamports } = params;
        const type = $ca3473265f76df98$export$c89793bd2bba8b2e.Split;
        const data = $ca3473265f76df98$var$encodeData(type, {
            lamports: lamports
        });
        return new $ca3473265f76df98$export$a7a3aa8360ac9f59({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: splitStakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that splits Stake tokens into another stake account
   */ static split(params, // Compute the cost of allocating the new stake account in lamports
    rentExemptReserve) {
        const transaction = new $ca3473265f76df98$export$febc5573c75cefb0();
        transaction.add($ca3473265f76df98$export$d8c4e17726848113.createAccount({
            fromPubkey: params.authorizedPubkey,
            newAccountPubkey: params.splitStakePubkey,
            lamports: rentExemptReserve,
            space: this.space,
            programId: this.programId
        }));
        return transaction.add(this.splitInstruction(params));
    }
    /**
   * Generate a Transaction that splits Stake tokens into another account
   * derived from a base public key and seed
   */ static splitWithSeed(params, // If this stake account is new, compute the cost of allocating it in lamports
    rentExemptReserve) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, splitStakePubkey: splitStakePubkey, basePubkey: basePubkey, seed: seed, lamports: lamports } = params;
        const transaction = new $ca3473265f76df98$export$febc5573c75cefb0();
        transaction.add($ca3473265f76df98$export$d8c4e17726848113.allocate({
            accountPubkey: splitStakePubkey,
            basePubkey: basePubkey,
            seed: seed,
            space: this.space,
            programId: this.programId
        }));
        if (rentExemptReserve && rentExemptReserve > 0) transaction.add($ca3473265f76df98$export$d8c4e17726848113.transfer({
            fromPubkey: params.authorizedPubkey,
            toPubkey: splitStakePubkey,
            lamports: rentExemptReserve
        }));
        return transaction.add(this.splitInstruction({
            stakePubkey: stakePubkey,
            authorizedPubkey: authorizedPubkey,
            splitStakePubkey: splitStakePubkey,
            lamports: lamports
        }));
    }
    /**
   * Generate a Transaction that merges Stake accounts.
   */ static merge(params) {
        const { stakePubkey: stakePubkey, sourceStakePubKey: sourceStakePubKey, authorizedPubkey: authorizedPubkey } = params;
        const type = $ca3473265f76df98$export$c89793bd2bba8b2e.Merge;
        const data = $ca3473265f76df98$var$encodeData(type);
        return new $ca3473265f76df98$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: sourceStakePubKey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $ca3473265f76df98$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $ca3473265f76df98$export$ca994171317280ea,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that withdraws deactivated Stake tokens.
   */ static withdraw(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey, toPubkey: toPubkey, lamports: lamports, custodianPubkey: custodianPubkey } = params;
        const type = $ca3473265f76df98$export$c89793bd2bba8b2e.Withdraw;
        const data = $ca3473265f76df98$var$encodeData(type, {
            lamports: lamports
        });
        const keys = [
            {
                pubkey: stakePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: toPubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $ca3473265f76df98$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: $ca3473265f76df98$export$ca994171317280ea,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        if (custodianPubkey) keys.push({
            pubkey: custodianPubkey,
            isSigner: true,
            isWritable: false
        });
        return new $ca3473265f76df98$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a Transaction that deactivates Stake tokens.
   */ static deactivate(params) {
        const { stakePubkey: stakePubkey, authorizedPubkey: authorizedPubkey } = params;
        const type = $ca3473265f76df98$export$c89793bd2bba8b2e.Deactivate;
        const data = $ca3473265f76df98$var$encodeData(type);
        return new $ca3473265f76df98$export$febc5573c75cefb0().add({
            keys: [
                {
                    pubkey: stakePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $ca3473265f76df98$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: authorizedPubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        });
    }
}
$ca3473265f76df98$export$df86f933e9f8fb15.programId = new $ca3473265f76df98$export$ca8b6604d6ce14de("Stake11111111111111111111111111111111111111");
/**
 * Max space of a Stake account
 *
 * This is generated from the solana-stake-program StakeState struct as
 * `StakeStateV2::size_of()`:
 * https://docs.rs/solana-stake-program/latest/solana_stake_program/stake_state/enum.StakeStateV2.html
 */ $ca3473265f76df98$export$df86f933e9f8fb15.space = 200;
/**
 * Vote account info
 */ class $ca3473265f76df98$export$3f9d1b16ff840d7 {
    /** [0, 100] */ constructor(nodePubkey, authorizedVoter, authorizedWithdrawer, commission){
        this.nodePubkey = void 0;
        this.authorizedVoter = void 0;
        this.authorizedWithdrawer = void 0;
        this.commission = void 0;
        this.nodePubkey = nodePubkey;
        this.authorizedVoter = authorizedVoter;
        this.authorizedWithdrawer = authorizedWithdrawer;
        this.commission = commission;
    }
}
/**
 * Create vote account transaction params
 */ /**
 * InitializeAccount instruction params
 */ /**
 * Authorize instruction params
 */ /**
 * AuthorizeWithSeed instruction params
 */ /**
 * Withdraw from vote account transaction params
 */ /**
 * Update validator identity (node pubkey) vote account instruction params.
 */ /**
 * Vote Instruction class
 */ class $ca3473265f76df98$export$af8300401fc56047 {
    /**
   * @internal
   */ constructor(){}
    /**
   * Decode a vote instruction and retrieve the instruction type.
   */ static decodeInstructionType(instruction) {
        this.checkProgramId(instruction.programId);
        const instructionTypeLayout = $ab8b5713b1ee9109$exports.u32("instruction");
        const typeIndex = instructionTypeLayout.decode(instruction.data);
        let type;
        for (const [ixType, layout] of Object.entries($ca3473265f76df98$var$VOTE_INSTRUCTION_LAYOUTS))if (layout.index == typeIndex) {
            type = ixType;
            break;
        }
        if (!type) throw new Error("Instruction type incorrect; not a VoteInstruction");
        return type;
    }
    /**
   * Decode an initialize vote instruction and retrieve the instruction params.
   */ static decodeInitializeAccount(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 4);
        const { voteInit: voteInit } = $ca3473265f76df98$var$decodeData$1($ca3473265f76df98$var$VOTE_INSTRUCTION_LAYOUTS.InitializeAccount, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            nodePubkey: instruction.keys[3].pubkey,
            voteInit: new $ca3473265f76df98$export$3f9d1b16ff840d7(new $ca3473265f76df98$export$ca8b6604d6ce14de(voteInit.nodePubkey), new $ca3473265f76df98$export$ca8b6604d6ce14de(voteInit.authorizedVoter), new $ca3473265f76df98$export$ca8b6604d6ce14de(voteInit.authorizedWithdrawer), voteInit.commission)
        };
    }
    /**
   * Decode an authorize instruction and retrieve the instruction params.
   */ static decodeAuthorize(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { newAuthorized: newAuthorized, voteAuthorizationType: voteAuthorizationType } = $ca3473265f76df98$var$decodeData$1($ca3473265f76df98$var$VOTE_INSTRUCTION_LAYOUTS.Authorize, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            authorizedPubkey: instruction.keys[2].pubkey,
            newAuthorizedPubkey: new $ca3473265f76df98$export$ca8b6604d6ce14de(newAuthorized),
            voteAuthorizationType: {
                index: voteAuthorizationType
            }
        };
    }
    /**
   * Decode an authorize instruction and retrieve the instruction params.
   */ static decodeAuthorizeWithSeed(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { voteAuthorizeWithSeedArgs: { currentAuthorityDerivedKeyOwnerPubkey: currentAuthorityDerivedKeyOwnerPubkey, currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed, newAuthorized: newAuthorized, voteAuthorizationType: voteAuthorizationType } } = $ca3473265f76df98$var$decodeData$1($ca3473265f76df98$var$VOTE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed, instruction.data);
        return {
            currentAuthorityDerivedKeyBasePubkey: instruction.keys[2].pubkey,
            currentAuthorityDerivedKeyOwnerPubkey: new $ca3473265f76df98$export$ca8b6604d6ce14de(currentAuthorityDerivedKeyOwnerPubkey),
            currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed,
            newAuthorizedPubkey: new $ca3473265f76df98$export$ca8b6604d6ce14de(newAuthorized),
            voteAuthorizationType: {
                index: voteAuthorizationType
            },
            votePubkey: instruction.keys[0].pubkey
        };
    }
    /**
   * Decode a withdraw instruction and retrieve the instruction params.
   */ static decodeWithdraw(instruction) {
        this.checkProgramId(instruction.programId);
        this.checkKeyLength(instruction.keys, 3);
        const { lamports: lamports } = $ca3473265f76df98$var$decodeData$1($ca3473265f76df98$var$VOTE_INSTRUCTION_LAYOUTS.Withdraw, instruction.data);
        return {
            votePubkey: instruction.keys[0].pubkey,
            authorizedWithdrawerPubkey: instruction.keys[2].pubkey,
            lamports: lamports,
            toPubkey: instruction.keys[1].pubkey
        };
    }
    /**
   * @internal
   */ static checkProgramId(programId) {
        if (!programId.equals($ca3473265f76df98$export$83db2bc702bee1eb.programId)) throw new Error("invalid instruction; programId is not VoteProgram");
    }
    /**
   * @internal
   */ static checkKeyLength(keys, expectedLength) {
        if (keys.length < expectedLength) throw new Error(`invalid instruction; found ${keys.length} keys, expected at least ${expectedLength}`);
    }
}
/**
 * An enumeration of valid VoteInstructionType's
 */ /** @internal */ const $ca3473265f76df98$var$VOTE_INSTRUCTION_LAYOUTS = Object.freeze({
    InitializeAccount: {
        index: 0,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u32("instruction"),
            $ca3473265f76df98$var$voteInit()
        ])
    },
    Authorize: {
        index: 1,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u32("instruction"),
            $ca3473265f76df98$var$publicKey("newAuthorized"),
            $ab8b5713b1ee9109$exports.u32("voteAuthorizationType")
        ])
    },
    Withdraw: {
        index: 3,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u32("instruction"),
            $ab8b5713b1ee9109$exports.ns64("lamports")
        ])
    },
    UpdateValidatorIdentity: {
        index: 4,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u32("instruction")
        ])
    },
    AuthorizeWithSeed: {
        index: 10,
        layout: $ab8b5713b1ee9109$exports.struct([
            $ab8b5713b1ee9109$exports.u32("instruction"),
            $ca3473265f76df98$var$voteAuthorizeWithSeedArgs()
        ])
    }
});
/**
 * VoteAuthorize type
 */ /**
 * An enumeration of valid VoteAuthorization layouts.
 */ const $ca3473265f76df98$export$3f2a92246fa9f71c = Object.freeze({
    Voter: {
        index: 0
    },
    Withdrawer: {
        index: 1
    }
});
/**
 * Factory class for transactions to interact with the Vote program
 */ class $ca3473265f76df98$export$83db2bc702bee1eb {
    /**
   * @internal
   */ constructor(){}
    /**
   * Public key that identifies the Vote program
   */ /**
   * Generate an Initialize instruction.
   */ static initializeAccount(params) {
        const { votePubkey: votePubkey, nodePubkey: nodePubkey, voteInit: voteInit } = params;
        const type = $ca3473265f76df98$var$VOTE_INSTRUCTION_LAYOUTS.InitializeAccount;
        const data = $ca3473265f76df98$var$encodeData(type, {
            voteInit: {
                nodePubkey: $ca3473265f76df98$var$toBuffer(voteInit.nodePubkey.toBuffer()),
                authorizedVoter: $ca3473265f76df98$var$toBuffer(voteInit.authorizedVoter.toBuffer()),
                authorizedWithdrawer: $ca3473265f76df98$var$toBuffer(voteInit.authorizedWithdrawer.toBuffer()),
                commission: voteInit.commission
            }
        });
        const instructionData = {
            keys: [
                {
                    pubkey: votePubkey,
                    isSigner: false,
                    isWritable: true
                },
                {
                    pubkey: $ca3473265f76df98$export$970d0190cdb3a8e9,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: $ca3473265f76df98$export$393aa1412d47050e,
                    isSigner: false,
                    isWritable: false
                },
                {
                    pubkey: nodePubkey,
                    isSigner: true,
                    isWritable: false
                }
            ],
            programId: this.programId,
            data: data
        };
        return new $ca3473265f76df98$export$a7a3aa8360ac9f59(instructionData);
    }
    /**
   * Generate a transaction that creates a new Vote account.
   */ static createAccount(params) {
        const transaction = new $ca3473265f76df98$export$febc5573c75cefb0();
        transaction.add($ca3473265f76df98$export$d8c4e17726848113.createAccount({
            fromPubkey: params.fromPubkey,
            newAccountPubkey: params.votePubkey,
            lamports: params.lamports,
            space: this.space,
            programId: this.programId
        }));
        return transaction.add(this.initializeAccount({
            votePubkey: params.votePubkey,
            nodePubkey: params.voteInit.nodePubkey,
            voteInit: params.voteInit
        }));
    }
    /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account.
   */ static authorize(params) {
        const { votePubkey: votePubkey, authorizedPubkey: authorizedPubkey, newAuthorizedPubkey: newAuthorizedPubkey, voteAuthorizationType: voteAuthorizationType } = params;
        const type = $ca3473265f76df98$var$VOTE_INSTRUCTION_LAYOUTS.Authorize;
        const data = $ca3473265f76df98$var$encodeData(type, {
            newAuthorized: $ca3473265f76df98$var$toBuffer(newAuthorizedPubkey.toBuffer()),
            voteAuthorizationType: voteAuthorizationType.index
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $ca3473265f76df98$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: authorizedPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $ca3473265f76df98$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction that authorizes a new Voter or Withdrawer on the Vote account
   * where the current Voter or Withdrawer authority is a derived key.
   */ static authorizeWithSeed(params) {
        const { currentAuthorityDerivedKeyBasePubkey: currentAuthorityDerivedKeyBasePubkey, currentAuthorityDerivedKeyOwnerPubkey: currentAuthorityDerivedKeyOwnerPubkey, currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed, newAuthorizedPubkey: newAuthorizedPubkey, voteAuthorizationType: voteAuthorizationType, votePubkey: votePubkey } = params;
        const type = $ca3473265f76df98$var$VOTE_INSTRUCTION_LAYOUTS.AuthorizeWithSeed;
        const data = $ca3473265f76df98$var$encodeData(type, {
            voteAuthorizeWithSeedArgs: {
                currentAuthorityDerivedKeyOwnerPubkey: $ca3473265f76df98$var$toBuffer(currentAuthorityDerivedKeyOwnerPubkey.toBuffer()),
                currentAuthorityDerivedKeySeed: currentAuthorityDerivedKeySeed,
                newAuthorized: $ca3473265f76df98$var$toBuffer(newAuthorizedPubkey.toBuffer()),
                voteAuthorizationType: voteAuthorizationType.index
            }
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: $ca3473265f76df98$export$393aa1412d47050e,
                isSigner: false,
                isWritable: false
            },
            {
                pubkey: currentAuthorityDerivedKeyBasePubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $ca3473265f76df98$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction to withdraw from a Vote account.
   */ static withdraw(params) {
        const { votePubkey: votePubkey, authorizedWithdrawerPubkey: authorizedWithdrawerPubkey, lamports: lamports, toPubkey: toPubkey } = params;
        const type = $ca3473265f76df98$var$VOTE_INSTRUCTION_LAYOUTS.Withdraw;
        const data = $ca3473265f76df98$var$encodeData(type, {
            lamports: lamports
        });
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: toPubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: authorizedWithdrawerPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $ca3473265f76df98$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
    /**
   * Generate a transaction to withdraw safely from a Vote account.
   *
   * This function was created as a safeguard for vote accounts running validators, `safeWithdraw`
   * checks that the withdraw amount will not exceed the specified balance while leaving enough left
   * to cover rent. If you wish to close the vote account by withdrawing the full amount, call the
   * `withdraw` method directly.
   */ static safeWithdraw(params, currentVoteAccountBalance, rentExemptMinimum) {
        if (params.lamports > currentVoteAccountBalance - rentExemptMinimum) throw new Error("Withdraw will leave vote account with insufficient funds.");
        return $ca3473265f76df98$export$83db2bc702bee1eb.withdraw(params);
    }
    /**
   * Generate a transaction to update the validator identity (node pubkey) of a Vote account.
   */ static updateValidatorIdentity(params) {
        const { votePubkey: votePubkey, authorizedWithdrawerPubkey: authorizedWithdrawerPubkey, nodePubkey: nodePubkey } = params;
        const type = $ca3473265f76df98$var$VOTE_INSTRUCTION_LAYOUTS.UpdateValidatorIdentity;
        const data = $ca3473265f76df98$var$encodeData(type);
        const keys = [
            {
                pubkey: votePubkey,
                isSigner: false,
                isWritable: true
            },
            {
                pubkey: nodePubkey,
                isSigner: true,
                isWritable: false
            },
            {
                pubkey: authorizedWithdrawerPubkey,
                isSigner: true,
                isWritable: false
            }
        ];
        return new $ca3473265f76df98$export$febc5573c75cefb0().add({
            keys: keys,
            programId: this.programId,
            data: data
        });
    }
}
$ca3473265f76df98$export$83db2bc702bee1eb.programId = new $ca3473265f76df98$export$ca8b6604d6ce14de("Vote111111111111111111111111111111111111111");
/**
 * Max space of a Vote account
 *
 * This is generated from the solana-vote-program VoteState struct as
 * `VoteState::size_of()`:
 * https://docs.rs/solana-vote-program/1.9.5/solana_vote_program/vote_state/struct.VoteState.html#method.size_of
 *
 * KEEP IN SYNC WITH `VoteState::size_of()` in https://github.com/solana-labs/solana/blob/a474cb24b9238f5edcc982f65c0b37d4a1046f7e/sdk/program/src/vote/state/mod.rs#L340-L342
 */ $ca3473265f76df98$export$83db2bc702bee1eb.space = 3762;
const $ca3473265f76df98$export$afdb09d3afdde87c = new $ca3473265f76df98$export$ca8b6604d6ce14de("Va1idator1nfo111111111111111111111111111111");
/**
 * @internal
 */ /**
 * Info used to identity validators.
 */ const $ca3473265f76df98$var$InfoString = (0, $c32abee974e85639$export$bf9fb029d174d554)({
    name: (0, $c32abee974e85639$export$22b082955e083ec3)(),
    website: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$22b082955e083ec3)()),
    details: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$22b082955e083ec3)()),
    iconUrl: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$22b082955e083ec3)()),
    keybaseUsername: (0, $c32abee974e85639$export$516e28dec6a4b6d4)((0, $c32abee974e85639$export$22b082955e083ec3)())
});
/**
 * ValidatorInfo class
 */ class $ca3473265f76df98$export$152d279cf067309b {
    /**
   * Construct a valid ValidatorInfo
   *
   * @param key validator public key
   * @param info validator information
   */ constructor(key, info){
        /**
     * validator public key
     */ this.key = void 0;
        /**
     * validator information
     */ this.info = void 0;
        this.key = key;
        this.info = info;
    }
    /**
   * Deserialize ValidatorInfo from the config account data. Exactly two config
   * keys are required in the data.
   *
   * @param buffer config account data
   * @return null if info was not found
   */ static fromConfigData(buffer) {
        let byteArray = [
            ...buffer
        ];
        const configKeyCount = $ca3473265f76df98$var$decodeLength(byteArray);
        if (configKeyCount !== 2) return null;
        const configKeys = [];
        for(let i = 0; i < 2; i++){
            const publicKey = new $ca3473265f76df98$export$ca8b6604d6ce14de($ca3473265f76df98$var$guardedSplice(byteArray, 0, $ca3473265f76df98$export$84fc0a248cc54343));
            const isSigner = $ca3473265f76df98$var$guardedShift(byteArray) === 1;
            configKeys.push({
                publicKey: publicKey,
                isSigner: isSigner
            });
        }
        if (configKeys[0].publicKey.equals($ca3473265f76df98$export$afdb09d3afdde87c)) {
            if (configKeys[1].isSigner) {
                const rawInfo = $ca3473265f76df98$var$rustString().decode((0, $492757110c774bc9$export$a143d493d941bafc).from(byteArray));
                const info = JSON.parse(rawInfo);
                (0, $c32abee974e85639$export$a7a9523472993e97)(info, $ca3473265f76df98$var$InfoString);
                return new $ca3473265f76df98$export$152d279cf067309b(configKeys[1].publicKey, info);
            }
        }
        return null;
    }
}
const $ca3473265f76df98$export$90bca02a3aea0768 = new $ca3473265f76df98$export$ca8b6604d6ce14de("Vote111111111111111111111111111111111111111");
/**
 * History of how many credits earned by the end of each epoch
 */ /**
 * See https://github.com/solana-labs/solana/blob/8a12ed029cfa38d4a45400916c2463fb82bbec8c/programs/vote_api/src/vote_state.rs#L68-L88
 *
 * @internal
 */ const $ca3473265f76df98$var$VoteAccountLayout = $ab8b5713b1ee9109$exports.struct([
    $ca3473265f76df98$var$publicKey("nodePubkey"),
    $ca3473265f76df98$var$publicKey("authorizedWithdrawer"),
    $ab8b5713b1ee9109$exports.u8("commission"),
    $ab8b5713b1ee9109$exports.nu64(),
    // votes.length
    $ab8b5713b1ee9109$exports.seq($ab8b5713b1ee9109$exports.struct([
        $ab8b5713b1ee9109$exports.nu64("slot"),
        $ab8b5713b1ee9109$exports.u32("confirmationCount")
    ]), $ab8b5713b1ee9109$exports.offset($ab8b5713b1ee9109$exports.u32(), -8), "votes"),
    $ab8b5713b1ee9109$exports.u8("rootSlotValid"),
    $ab8b5713b1ee9109$exports.nu64("rootSlot"),
    $ab8b5713b1ee9109$exports.nu64(),
    // authorizedVoters.length
    $ab8b5713b1ee9109$exports.seq($ab8b5713b1ee9109$exports.struct([
        $ab8b5713b1ee9109$exports.nu64("epoch"),
        $ca3473265f76df98$var$publicKey("authorizedVoter")
    ]), $ab8b5713b1ee9109$exports.offset($ab8b5713b1ee9109$exports.u32(), -8), "authorizedVoters"),
    $ab8b5713b1ee9109$exports.struct([
        $ab8b5713b1ee9109$exports.seq($ab8b5713b1ee9109$exports.struct([
            $ca3473265f76df98$var$publicKey("authorizedPubkey"),
            $ab8b5713b1ee9109$exports.nu64("epochOfLastAuthorizedSwitch"),
            $ab8b5713b1ee9109$exports.nu64("targetEpoch")
        ]), 32, "buf"),
        $ab8b5713b1ee9109$exports.nu64("idx"),
        $ab8b5713b1ee9109$exports.u8("isEmpty")
    ], "priorVoters"),
    $ab8b5713b1ee9109$exports.nu64(),
    // epochCredits.length
    $ab8b5713b1ee9109$exports.seq($ab8b5713b1ee9109$exports.struct([
        $ab8b5713b1ee9109$exports.nu64("epoch"),
        $ab8b5713b1ee9109$exports.nu64("credits"),
        $ab8b5713b1ee9109$exports.nu64("prevCredits")
    ]), $ab8b5713b1ee9109$exports.offset($ab8b5713b1ee9109$exports.u32(), -8), "epochCredits"),
    $ab8b5713b1ee9109$exports.struct([
        $ab8b5713b1ee9109$exports.nu64("slot"),
        $ab8b5713b1ee9109$exports.nu64("timestamp")
    ], "lastTimestamp")
]);
/**
 * VoteAccount class
 */ class $ca3473265f76df98$export$89ef186f708d638b {
    /**
   * @internal
   */ constructor(args){
        this.nodePubkey = void 0;
        this.authorizedWithdrawer = void 0;
        this.commission = void 0;
        this.rootSlot = void 0;
        this.votes = void 0;
        this.authorizedVoters = void 0;
        this.priorVoters = void 0;
        this.epochCredits = void 0;
        this.lastTimestamp = void 0;
        this.nodePubkey = args.nodePubkey;
        this.authorizedWithdrawer = args.authorizedWithdrawer;
        this.commission = args.commission;
        this.rootSlot = args.rootSlot;
        this.votes = args.votes;
        this.authorizedVoters = args.authorizedVoters;
        this.priorVoters = args.priorVoters;
        this.epochCredits = args.epochCredits;
        this.lastTimestamp = args.lastTimestamp;
    }
    /**
   * Deserialize VoteAccount from the account data.
   *
   * @param buffer account data
   * @return VoteAccount
   */ static fromAccountData(buffer) {
        const versionOffset = 4;
        const va = $ca3473265f76df98$var$VoteAccountLayout.decode($ca3473265f76df98$var$toBuffer(buffer), versionOffset);
        let rootSlot = va.rootSlot;
        if (!va.rootSlotValid) rootSlot = null;
        return new $ca3473265f76df98$export$89ef186f708d638b({
            nodePubkey: new $ca3473265f76df98$export$ca8b6604d6ce14de(va.nodePubkey),
            authorizedWithdrawer: new $ca3473265f76df98$export$ca8b6604d6ce14de(va.authorizedWithdrawer),
            commission: va.commission,
            votes: va.votes,
            rootSlot: rootSlot,
            authorizedVoters: va.authorizedVoters.map($ca3473265f76df98$var$parseAuthorizedVoter),
            priorVoters: $ca3473265f76df98$var$getPriorVoters(va.priorVoters),
            epochCredits: va.epochCredits,
            lastTimestamp: va.lastTimestamp
        });
    }
}
function $ca3473265f76df98$var$parseAuthorizedVoter({ authorizedVoter: authorizedVoter, epoch: epoch }) {
    return {
        epoch: epoch,
        authorizedVoter: new $ca3473265f76df98$export$ca8b6604d6ce14de(authorizedVoter)
    };
}
function $ca3473265f76df98$var$parsePriorVoters({ authorizedPubkey: authorizedPubkey, epochOfLastAuthorizedSwitch: epochOfLastAuthorizedSwitch, targetEpoch: targetEpoch }) {
    return {
        authorizedPubkey: new $ca3473265f76df98$export$ca8b6604d6ce14de(authorizedPubkey),
        epochOfLastAuthorizedSwitch: epochOfLastAuthorizedSwitch,
        targetEpoch: targetEpoch
    };
}
function $ca3473265f76df98$var$getPriorVoters({ buf: buf, idx: idx, isEmpty: isEmpty }) {
    if (isEmpty) return [];
    return [
        ...buf.slice(idx + 1).map($ca3473265f76df98$var$parsePriorVoters),
        ...buf.slice(0, idx).map($ca3473265f76df98$var$parsePriorVoters)
    ];
}
const $ca3473265f76df98$var$endpoint = {
    http: {
        devnet: "http://api.devnet.solana.com",
        testnet: "http://api.testnet.solana.com",
        "mainnet-beta": "http://api.mainnet-beta.solana.com/"
    },
    https: {
        devnet: "https://api.devnet.solana.com",
        testnet: "https://api.testnet.solana.com",
        "mainnet-beta": "https://api.mainnet-beta.solana.com/"
    }
};
/**
 * Retrieves the RPC API URL for the specified cluster
 * @param {Cluster} [cluster="devnet"] - The cluster name of the RPC API URL to use. Possible options: 'devnet' | 'testnet' | 'mainnet-beta'
 * @param {boolean} [tls="http"] - Use TLS when connecting to cluster.
 *
 * @returns {string} URL string of the RPC endpoint
 */ function $ca3473265f76df98$export$11656287b4eb76ff(cluster, tls) {
    const key = tls === false ? "http" : "https";
    if (!cluster) return $ca3473265f76df98$var$endpoint[key]["devnet"];
    const url = $ca3473265f76df98$var$endpoint[key][cluster];
    if (!url) throw new Error(`Unknown ${key} cluster: ${cluster}`);
    return url;
}
/**
 * Send and confirm a raw transaction
 *
 * If `commitment` option is not specified, defaults to 'max' commitment.
 *
 * @param {Connection} connection
 * @param {Buffer} rawTransaction
 * @param {TransactionConfirmationStrategy} confirmationStrategy
 * @param {ConfirmOptions} [options]
 * @returns {Promise<TransactionSignature>}
 */ /**
 * @deprecated Calling `sendAndConfirmRawTransaction()` without a `confirmationStrategy`
 * is no longer supported and will be removed in a future version.
 */ // eslint-disable-next-line no-redeclare
// eslint-disable-next-line no-redeclare
async function $ca3473265f76df98$export$554271b88fdb7843(connection, rawTransaction, confirmationStrategyOrConfirmOptions, maybeConfirmOptions) {
    let confirmationStrategy;
    let options;
    if (confirmationStrategyOrConfirmOptions && Object.prototype.hasOwnProperty.call(confirmationStrategyOrConfirmOptions, "lastValidBlockHeight")) {
        confirmationStrategy = confirmationStrategyOrConfirmOptions;
        options = maybeConfirmOptions;
    } else if (confirmationStrategyOrConfirmOptions && Object.prototype.hasOwnProperty.call(confirmationStrategyOrConfirmOptions, "nonceValue")) {
        confirmationStrategy = confirmationStrategyOrConfirmOptions;
        options = maybeConfirmOptions;
    } else options = confirmationStrategyOrConfirmOptions;
    const sendOptions = options && {
        skipPreflight: options.skipPreflight,
        preflightCommitment: options.preflightCommitment || options.commitment,
        minContextSlot: options.minContextSlot
    };
    const signature = await connection.sendRawTransaction(rawTransaction, sendOptions);
    const commitment = options && options.commitment;
    const confirmationPromise = confirmationStrategy ? connection.confirmTransaction(confirmationStrategy, commitment) : connection.confirmTransaction(signature, commitment);
    const status = (await confirmationPromise).value;
    if (status.err) {
        if (signature != null) throw new $ca3473265f76df98$export$121e803f723b3045({
            action: sendOptions?.skipPreflight ? "send" : "simulate",
            signature: signature,
            transactionMessage: `Status: (${JSON.stringify(status)})`
        });
        throw new Error(`Raw transaction ${signature} failed (${JSON.stringify(status)})`);
    }
    return signature;
}
/**
 * There are 1-billion lamports in one SOL
 */ const $ca3473265f76df98$export$5f6a2f2669741bbe = 1000000000;



var $8NFma = parcelRequire("8NFma");

var $8NFma = parcelRequire("8NFma");
const $c1d85d09818f0a66$export$af54d3055d90c64e = (0, $8NFma.createContext)({});
function $c1d85d09818f0a66$export$985e8768c0e91dbc() {
    return (0, $8NFma.useContext)($c1d85d09818f0a66$export$af54d3055d90c64e);
}


const $9e21814ff868d8fd$export$fd685cf7c99624bd = ({ children: children, endpoint: endpoint, config: config = {
    commitment: "confirmed"
} })=>{
    const connection = (0, $8NFma.useMemo)(()=>new (0, $ca3473265f76df98$export$98b66c25bb38499d)(endpoint, config), [
        endpoint,
        config
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $c1d85d09818f0a66$export$af54d3055d90c64e).Provider, {
        value: {
            connection: connection
        }
    }, children);
};


var $8NFma = parcelRequire("8NFma");
const $da2cf33ea909e7e2$var$EMPTY_ARRAY = [];
const $da2cf33ea909e7e2$var$DEFAULT_CONTEXT = {
    autoConnect: false,
    connecting: false,
    connected: false,
    disconnecting: false,
    select () {
        $da2cf33ea909e7e2$var$logMissingProviderError("call", "select");
    },
    connect () {
        return Promise.reject($da2cf33ea909e7e2$var$logMissingProviderError("call", "connect"));
    },
    disconnect () {
        return Promise.reject($da2cf33ea909e7e2$var$logMissingProviderError("call", "disconnect"));
    },
    sendTransaction () {
        return Promise.reject($da2cf33ea909e7e2$var$logMissingProviderError("call", "sendTransaction"));
    },
    signTransaction () {
        return Promise.reject($da2cf33ea909e7e2$var$logMissingProviderError("call", "signTransaction"));
    },
    signAllTransactions () {
        return Promise.reject($da2cf33ea909e7e2$var$logMissingProviderError("call", "signAllTransactions"));
    },
    signMessage () {
        return Promise.reject($da2cf33ea909e7e2$var$logMissingProviderError("call", "signMessage"));
    },
    signIn () {
        return Promise.reject($da2cf33ea909e7e2$var$logMissingProviderError("call", "signIn"));
    }
};
Object.defineProperty($da2cf33ea909e7e2$var$DEFAULT_CONTEXT, "wallets", {
    get () {
        $da2cf33ea909e7e2$var$logMissingProviderError("read", "wallets");
        return $da2cf33ea909e7e2$var$EMPTY_ARRAY;
    }
});
Object.defineProperty($da2cf33ea909e7e2$var$DEFAULT_CONTEXT, "wallet", {
    get () {
        $da2cf33ea909e7e2$var$logMissingProviderError("read", "wallet");
        return null;
    }
});
Object.defineProperty($da2cf33ea909e7e2$var$DEFAULT_CONTEXT, "publicKey", {
    get () {
        $da2cf33ea909e7e2$var$logMissingProviderError("read", "publicKey");
        return null;
    }
});
function $da2cf33ea909e7e2$var$logMissingProviderError(action, property) {
    const error = new Error(`You have tried to ${action} "${property}" on a WalletContext without providing one. ` + "Make sure to render a WalletProvider as an ancestor of the component that uses WalletContext.");
    console.error(error);
    return error;
}
const $da2cf33ea909e7e2$export$19648c908dc8d0bf = (0, $8NFma.createContext)($da2cf33ea909e7e2$var$DEFAULT_CONTEXT);
function $da2cf33ea909e7e2$export$c34addee860b0acb() {
    return (0, $8NFma.useContext)($da2cf33ea909e7e2$export$19648c908dc8d0bf);
}

var $4f582ccb383f7170$exports = {};
"use strict";
var $4f582ccb383f7170$var$has = Object.prototype.hasOwnProperty, $4f582ccb383f7170$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $4f582ccb383f7170$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $4f582ccb383f7170$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $4f582ccb383f7170$var$Events().__proto__) $4f582ccb383f7170$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $4f582ccb383f7170$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $4f582ccb383f7170$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $4f582ccb383f7170$var$EE(fn, context || emitter, once), evt = $4f582ccb383f7170$var$prefix ? $4f582ccb383f7170$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $4f582ccb383f7170$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $4f582ccb383f7170$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $4f582ccb383f7170$var$EventEmitter() {
    this._events = new $4f582ccb383f7170$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $4f582ccb383f7170$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($4f582ccb383f7170$var$has.call(events, name)) names.push($4f582ccb383f7170$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $4f582ccb383f7170$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $4f582ccb383f7170$var$prefix ? $4f582ccb383f7170$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $4f582ccb383f7170$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $4f582ccb383f7170$var$prefix ? $4f582ccb383f7170$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $4f582ccb383f7170$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $4f582ccb383f7170$var$prefix ? $4f582ccb383f7170$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4f582ccb383f7170$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $4f582ccb383f7170$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4f582ccb383f7170$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $4f582ccb383f7170$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4f582ccb383f7170$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $4f582ccb383f7170$var$prefix ? $4f582ccb383f7170$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $4f582ccb383f7170$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $4f582ccb383f7170$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $4f582ccb383f7170$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4f582ccb383f7170$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $4f582ccb383f7170$var$prefix ? $4f582ccb383f7170$var$prefix + event : event;
        if (this._events[evt]) $4f582ccb383f7170$var$clearEvent(this, evt);
    } else {
        this._events = new $4f582ccb383f7170$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$4f582ccb383f7170$var$EventEmitter.prototype.off = $4f582ccb383f7170$var$EventEmitter.prototype.removeListener;
$4f582ccb383f7170$var$EventEmitter.prototype.addListener = $4f582ccb383f7170$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$4f582ccb383f7170$var$EventEmitter.prefixed = $4f582ccb383f7170$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$4f582ccb383f7170$var$EventEmitter.EventEmitter = $4f582ccb383f7170$var$EventEmitter;
$4f582ccb383f7170$exports = $4f582ccb383f7170$var$EventEmitter;


class $954228dd8da6435a$export$f46ec6f9dba8711d extends Error {
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    constructor(message, error){
        super(message);
        this.error = error;
    }
}
class $954228dd8da6435a$export$d65db264eda99cd7 extends $954228dd8da6435a$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletNotReadyError";
    }
}
class $954228dd8da6435a$export$9a551f94af9b0bf8 extends $954228dd8da6435a$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletLoadError";
    }
}
class $954228dd8da6435a$export$9525019988612a5e extends $954228dd8da6435a$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletConfigError";
    }
}
class $954228dd8da6435a$export$38f21f1c810261c7 extends $954228dd8da6435a$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletConnectionError";
    }
}
class $954228dd8da6435a$export$bf7028c52ebda81e extends $954228dd8da6435a$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletDisconnectedError";
    }
}
class $954228dd8da6435a$export$92e2b26fad5723ee extends $954228dd8da6435a$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletDisconnectionError";
    }
}
class $954228dd8da6435a$export$cd6fa2f8e2a8a612 extends $954228dd8da6435a$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletAccountError";
    }
}
class $954228dd8da6435a$export$735bef3bfb0f2c86 extends $954228dd8da6435a$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletPublicKeyError";
    }
}
class $954228dd8da6435a$export$c2957028686b1575 extends $954228dd8da6435a$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletKeypairError";
    }
}
class $954228dd8da6435a$export$313d299817c74896 extends $954228dd8da6435a$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletNotConnectedError";
    }
}
class $954228dd8da6435a$export$769332ac3f90f46c extends $954228dd8da6435a$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletSendTransactionError";
    }
}
class $954228dd8da6435a$export$96f177062fdd8180 extends $954228dd8da6435a$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletSignTransactionError";
    }
}
class $954228dd8da6435a$export$2622c1721bbd4b17 extends $954228dd8da6435a$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletSignMessageError";
    }
}
class $954228dd8da6435a$export$a4c7d3c66e3cdd6c extends $954228dd8da6435a$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletSignInError";
    }
}
class $954228dd8da6435a$export$ec3efbdc71ef5c8c extends $954228dd8da6435a$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletTimeoutError";
    }
}
class $954228dd8da6435a$export$c87b9320dc154c95 extends $954228dd8da6435a$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletWindowBlockedError";
    }
}
class $954228dd8da6435a$export$d02b2d00a97edcea extends $954228dd8da6435a$export$f46ec6f9dba8711d {
    constructor(){
        super(...arguments);
        this.name = "WalletWindowClosedError";
    }
}


var $3020024d0a1e39a2$export$2a7b8071105d05b6;
(function(WalletReadyState) {
    /**
     * User-installable wallets can typically be detected by scanning for an API
     * that they've injected into the global context. If such an API is present,
     * we consider the wallet to have been installed.
     */ WalletReadyState["Installed"] = "Installed";
    WalletReadyState["NotDetected"] = "NotDetected";
    /**
     * Loadable wallets are always available to you. Since you can load them at
     * any time, it's meaningless to say that they have been detected.
     */ WalletReadyState["Loadable"] = "Loadable";
    /**
     * If a wallet is not supported on a given platform (eg. server-rendering, or
     * mobile) then it will stay in the `Unsupported` state.
     */ WalletReadyState["Unsupported"] = "Unsupported";
})($3020024d0a1e39a2$export$2a7b8071105d05b6 || ($3020024d0a1e39a2$export$2a7b8071105d05b6 = {}));
class $3020024d0a1e39a2$export$2af1ea2892adc469 extends (0, (/*@__PURE__*/$parcel$interopDefault($4f582ccb383f7170$exports))) {
    get connected() {
        return !!this.publicKey;
    }
    async autoConnect() {
        await this.connect();
    }
    async prepareTransaction(transaction, connection, options = {}) {
        const publicKey = this.publicKey;
        if (!publicKey) throw new (0, $954228dd8da6435a$export$313d299817c74896)();
        transaction.feePayer = transaction.feePayer || publicKey;
        transaction.recentBlockhash = transaction.recentBlockhash || (await connection.getLatestBlockhash({
            commitment: options.preflightCommitment,
            minContextSlot: options.minContextSlot
        })).blockhash;
        return transaction;
    }
}
function $3020024d0a1e39a2$export$378bae4c88e0b46e(detect) {
    // Early return when server-side rendering
    if (typeof window === "undefined" || typeof document === "undefined") return;
    const disposers = [];
    function detectAndDispose() {
        const detected = detect();
        if (detected) for (const dispose of disposers)dispose();
    }
    // Strategy #1: Try detecting every second.
    const interval = // TODO: #334 Replace with idle callback strategy.
    setInterval(detectAndDispose, 1000);
    disposers.push(()=>clearInterval(interval));
    // Strategy #2: Detect as soon as the DOM becomes 'ready'/'interactive'.
    if (// Implies that `DOMContentLoaded` has not yet fired.
    document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", detectAndDispose, {
            once: true
        });
        disposers.push(()=>document.removeEventListener("DOMContentLoaded", detectAndDispose));
    }
    // Strategy #3: Detect after the `window` has fully loaded.
    if (// If the `complete` state has been reached, we're too late.
    document.readyState !== "complete") {
        window.addEventListener("load", detectAndDispose, {
            once: true
        });
        disposers.push(()=>window.removeEventListener("load", detectAndDispose));
    }
    // Strategy #4: Detect synchronously, now.
    detectAndDispose();
}
function $3020024d0a1e39a2$export$bf89b558d1e273a2() {
    // SSR: return false
    if (!navigator) return false;
    const userAgent = navigator.userAgent.toLowerCase();
    // if on iOS the user agent will contain either iPhone or iPad
    // caveat: if requesting desktop site then this won't work
    const isIos = userAgent.includes("iphone") || userAgent.includes("ipad");
    // if in a webview then it will not include Safari
    // note that other iOS browsers also include Safari
    // so we will redirect only if Safari is also included
    const isSafari = userAgent.includes("safari");
    return isIos && isSafari;
}



function $b38f111071774614$export$37ce1cc82e255d8(transaction) {
    return "version" in transaction;
}


class $a9a0bf22390753d6$export$9a51bf5d1bea9e98 extends (0, $3020024d0a1e39a2$export$2af1ea2892adc469) {
    async sendTransaction(transaction, connection, options = {}) {
        let emit = true;
        try {
            if ((0, $b38f111071774614$export$37ce1cc82e255d8)(transaction)) {
                if (!this.supportedTransactionVersions) throw new (0, $954228dd8da6435a$export$769332ac3f90f46c)(`Sending versioned transactions isn't supported by this wallet`);
                if (!this.supportedTransactionVersions.has(transaction.version)) throw new (0, $954228dd8da6435a$export$769332ac3f90f46c)(`Sending transaction version ${transaction.version} isn't supported by this wallet`);
                try {
                    transaction = await this.signTransaction(transaction);
                    const rawTransaction = transaction.serialize();
                    return await connection.sendRawTransaction(rawTransaction, options);
                } catch (error) {
                    // If the error was thrown by `signTransaction`, rethrow it and don't emit a duplicate event
                    if (error instanceof (0, $954228dd8da6435a$export$96f177062fdd8180)) {
                        emit = false;
                        throw error;
                    }
                    throw new (0, $954228dd8da6435a$export$769332ac3f90f46c)(error?.message, error);
                }
            } else try {
                const { signers: signers, ...sendOptions } = options;
                transaction = await this.prepareTransaction(transaction, connection, sendOptions);
                signers?.length && transaction.partialSign(...signers);
                transaction = await this.signTransaction(transaction);
                const rawTransaction = transaction.serialize();
                return await connection.sendRawTransaction(rawTransaction, sendOptions);
            } catch (error) {
                // If the error was thrown by `signTransaction`, rethrow it and don't emit a duplicate event
                if (error instanceof (0, $954228dd8da6435a$export$96f177062fdd8180)) {
                    emit = false;
                    throw error;
                }
                throw new (0, $954228dd8da6435a$export$769332ac3f90f46c)(error?.message, error);
            }
        } catch (error) {
            if (emit) this.emit("error", error);
            throw error;
        }
    }
    async signAllTransactions(transactions) {
        for (const transaction of transactions)if ((0, $b38f111071774614$export$37ce1cc82e255d8)(transaction)) {
            if (!this.supportedTransactionVersions) throw new (0, $954228dd8da6435a$export$96f177062fdd8180)(`Signing versioned transactions isn't supported by this wallet`);
            if (!this.supportedTransactionVersions.has(transaction.version)) throw new (0, $954228dd8da6435a$export$96f177062fdd8180)(`Signing transaction version ${transaction.version} isn't supported by this wallet`);
        }
        const signedTransactions = [];
        for (const transaction of transactions)signedTransactions.push(await this.signTransaction(transaction));
        return signedTransactions;
    }
}
class $a9a0bf22390753d6$export$9db08bcddd106c96 extends $a9a0bf22390753d6$export$9a51bf5d1bea9e98 {
}
class $a9a0bf22390753d6$export$9779f871ffdb3d87 extends $a9a0bf22390753d6$export$9db08bcddd106c96 {
}




/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ function $8c22d0f5c49f7be0$export$98e628dec113755e(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
function $8c22d0f5c49f7be0$export$87b259aa03e3d267(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
// copied from utils
function $8c22d0f5c49f7be0$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
function $8c22d0f5c49f7be0$export$b3317979f9250576(b, ...lengths) {
    if (!$8c22d0f5c49f7be0$var$isBytes(b)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
function $8c22d0f5c49f7be0$export$d6af199866bfb566(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $8c22d0f5c49f7be0$export$98e628dec113755e(hash.outputLen);
    $8c22d0f5c49f7be0$export$98e628dec113755e(hash.blockLen);
}
function $8c22d0f5c49f7be0$export$f7e9f41ea797a17(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
function $8c22d0f5c49f7be0$export$c789db2c85949867(out, instance) {
    $8c22d0f5c49f7be0$export$b3317979f9250576(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
const $8c22d0f5c49f7be0$var$assert = {
    number: $8c22d0f5c49f7be0$export$98e628dec113755e,
    bool: $8c22d0f5c49f7be0$export$87b259aa03e3d267,
    bytes: $8c22d0f5c49f7be0$export$b3317979f9250576,
    hash: $8c22d0f5c49f7be0$export$d6af199866bfb566,
    exists: $8c22d0f5c49f7be0$export$f7e9f41ea797a17,
    output: $8c22d0f5c49f7be0$export$c789db2c85949867
};
var $8c22d0f5c49f7be0$export$2e2bcd8739ae039 = $8c22d0f5c49f7be0$var$assert;


/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // We use WebCrypto aka globalThis.crypto, which exists in browsers and node.js 16+.
// node.js versions earlier than v19 don't declare it in global scope.
// For node.js, package.json#exports field mapping rewrites import
// from `crypto` to `cryptoNode`, which imports native module.
// Makes the utils un-importable in browsers without a bundler.
// Once node.js 18 is deprecated (2025-04-30), we can just drop the import.
const $98893701ae4d1e53$export$7effb53edfc7fa2d = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;


const $ade6911eb19cf62a$export$9813fca58c0b9f71 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
const $ade6911eb19cf62a$export$8bacf4ad828c7fe7 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
function $ade6911eb19cf62a$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
const $ade6911eb19cf62a$export$d7febe7b891e79f0 = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
const $ade6911eb19cf62a$export$466993d7d0d272aa = (word, shift)=>word << 32 - shift | word >>> shift;
const $ade6911eb19cf62a$export$a0f88e38d4cf9577 = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!$ade6911eb19cf62a$export$a0f88e38d4cf9577) throw new Error("Non little-endian hardware is not supported");
// Array where index 0xf0 (240) is mapped to string 'f0'
const $ade6911eb19cf62a$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
function $ade6911eb19cf62a$export$58b867e287a802c8(bytes) {
    if (!$ade6911eb19cf62a$var$isBytes(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $ade6911eb19cf62a$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $ade6911eb19cf62a$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $ade6911eb19cf62a$var$asciiToBase16(char) {
    if (char >= $ade6911eb19cf62a$var$asciis._0 && char <= $ade6911eb19cf62a$var$asciis._9) return char - $ade6911eb19cf62a$var$asciis._0;
    if (char >= $ade6911eb19cf62a$var$asciis._A && char <= $ade6911eb19cf62a$var$asciis._F) return char - ($ade6911eb19cf62a$var$asciis._A - 10);
    if (char >= $ade6911eb19cf62a$var$asciis._a && char <= $ade6911eb19cf62a$var$asciis._f) return char - ($ade6911eb19cf62a$var$asciis._a - 10);
    return;
}
function $ade6911eb19cf62a$export$31c96b9df38bc8d4(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $ade6911eb19cf62a$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $ade6911eb19cf62a$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
const $ade6911eb19cf62a$export$bdd553fddd433dcb = async ()=>{};
async function $ade6911eb19cf62a$export$57207d71b8c929c8(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await $ade6911eb19cf62a$export$bdd553fddd433dcb();
        ts += diff;
    }
}
function $ade6911eb19cf62a$export$3df70a15530b5e81(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
function $ade6911eb19cf62a$export$30a71edf0753ed6b(data) {
    if (typeof data === "string") data = $ade6911eb19cf62a$export$3df70a15530b5e81(data);
    if (!$ade6911eb19cf62a$var$isBytes(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
function $ade6911eb19cf62a$export$287dd7971339c972(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        if (!$ade6911eb19cf62a$var$isBytes(a)) throw new Error("Uint8Array expected");
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
class $ade6911eb19cf62a$export$ab85ecd77ce6a5cd {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
const $ade6911eb19cf62a$var$toStr = {}.toString;
function $ade6911eb19cf62a$export$6fcee72895eceb1e(defaults, opts) {
    if (opts !== undefined && $ade6911eb19cf62a$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
function $ade6911eb19cf62a$export$f081816339df1972(hashCons) {
    const hashC = (msg)=>hashCons().update($ade6911eb19cf62a$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $ade6911eb19cf62a$export$b465638d1569a3ae(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($ade6911eb19cf62a$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $ade6911eb19cf62a$export$e18964dbd6e083c1(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($ade6911eb19cf62a$export$30a71edf0753ed6b(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $ade6911eb19cf62a$export$5f828d93ff035aa8(bytesLength = 32) {
    if ((0, $98893701ae4d1e53$export$7effb53edfc7fa2d) && typeof (0, $98893701ae4d1e53$export$7effb53edfc7fa2d).getRandomValues === "function") return (0, $98893701ae4d1e53$export$7effb53edfc7fa2d).getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}


// Polyfill for Safari 14
function $5bd3043a3f6a061f$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
class $5bd3043a3f6a061f$export$ebbe38f24b9a0856 extends (0, $ade6911eb19cf62a$export$ab85ecd77ce6a5cd) {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $ade6911eb19cf62a$export$d7febe7b891e79f0)(this.buffer);
    }
    update(data) {
        (0, $8c22d0f5c49f7be0$export$f7e9f41ea797a17)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $ade6911eb19cf62a$export$30a71edf0753ed6b)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $ade6911eb19cf62a$export$d7febe7b891e79f0)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $8c22d0f5c49f7be0$export$f7e9f41ea797a17)(this);
        (0, $8c22d0f5c49f7be0$export$c789db2c85949867)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $5bd3043a3f6a061f$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $ade6911eb19cf62a$export$d7febe7b891e79f0)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}


const $73eacdfe0094ed3d$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $73eacdfe0094ed3d$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $73eacdfe0094ed3d$export$9625d4333cb56c3f(n, le = false) {
    if (le) return {
        h: Number(n & $73eacdfe0094ed3d$var$U32_MASK64),
        l: Number(n >> $73eacdfe0094ed3d$var$_32n & $73eacdfe0094ed3d$var$U32_MASK64)
    };
    return {
        h: Number(n >> $73eacdfe0094ed3d$var$_32n & $73eacdfe0094ed3d$var$U32_MASK64) | 0,
        l: Number(n & $73eacdfe0094ed3d$var$U32_MASK64) | 0
    };
}
function $73eacdfe0094ed3d$export$65980d18b75784e2(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $73eacdfe0094ed3d$export$9625d4333cb56c3f(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $73eacdfe0094ed3d$export$30f78adcaaa2eb7 = (h, l)=>BigInt(h >>> 0) << $73eacdfe0094ed3d$var$_32n | BigInt(l >>> 0);
// for Shift in [0, 32)
const $73eacdfe0094ed3d$export$75aa78dc5bd52853 = (h, _l, s)=>h >>> s;
const $73eacdfe0094ed3d$export$a0225ff0aee14e25 = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in [1, 32)
const $73eacdfe0094ed3d$export$97f812dfd830ca87 = (h, l, s)=>h >>> s | l << 32 - s;
const $73eacdfe0094ed3d$export$60987e30e2c9d9d = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $73eacdfe0094ed3d$export$af9c7fbac44dcb76 = (h, l, s)=>h << 64 - s | l >>> s - 32;
const $73eacdfe0094ed3d$export$f619171d6d5ac414 = (h, l, s)=>h >>> s - 32 | l << 64 - s;
// Right rotate for shift===32 (just swaps l&h)
const $73eacdfe0094ed3d$export$a088d44bd387d2a3 = (_h, l)=>l;
const $73eacdfe0094ed3d$export$8415aae4d1f69577 = (h, _l)=>h;
// Left rotate for Shift in [1, 32)
const $73eacdfe0094ed3d$export$4b80a2917447870e = (h, l, s)=>h << s | l >>> 32 - s;
const $73eacdfe0094ed3d$export$20652918a7b63b3 = (h, l, s)=>l << s | h >>> 32 - s;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $73eacdfe0094ed3d$export$a52f14bf902f9977 = (h, l, s)=>l << s - 32 | h >>> 64 - s;
const $73eacdfe0094ed3d$export$5d12cc1da441323f = (h, l, s)=>h << s - 32 | l >>> 64 - s;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $73eacdfe0094ed3d$export$e16d8520af44a096(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $73eacdfe0094ed3d$export$c0c22b91f08911f = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
const $73eacdfe0094ed3d$export$ef7b26044977a8ec = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
const $73eacdfe0094ed3d$export$2f4e199c560f545d = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
const $73eacdfe0094ed3d$export$e909220d675a7741 = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
const $73eacdfe0094ed3d$export$d732b061fe9c9ae4 = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
const $73eacdfe0094ed3d$export$b45ee8d78c965098 = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
// prettier-ignore
const $73eacdfe0094ed3d$var$u64 = {
    fromBig: $73eacdfe0094ed3d$export$9625d4333cb56c3f,
    split: $73eacdfe0094ed3d$export$65980d18b75784e2,
    toBig: $73eacdfe0094ed3d$export$30f78adcaaa2eb7,
    shrSH: $73eacdfe0094ed3d$export$75aa78dc5bd52853,
    shrSL: $73eacdfe0094ed3d$export$a0225ff0aee14e25,
    rotrSH: $73eacdfe0094ed3d$export$97f812dfd830ca87,
    rotrSL: $73eacdfe0094ed3d$export$60987e30e2c9d9d,
    rotrBH: $73eacdfe0094ed3d$export$af9c7fbac44dcb76,
    rotrBL: $73eacdfe0094ed3d$export$f619171d6d5ac414,
    rotr32H: $73eacdfe0094ed3d$export$a088d44bd387d2a3,
    rotr32L: $73eacdfe0094ed3d$export$8415aae4d1f69577,
    rotlSH: $73eacdfe0094ed3d$export$4b80a2917447870e,
    rotlSL: $73eacdfe0094ed3d$export$20652918a7b63b3,
    rotlBH: $73eacdfe0094ed3d$export$a52f14bf902f9977,
    rotlBL: $73eacdfe0094ed3d$export$5d12cc1da441323f,
    add: $73eacdfe0094ed3d$export$e16d8520af44a096,
    add3L: $73eacdfe0094ed3d$export$c0c22b91f08911f,
    add3H: $73eacdfe0094ed3d$export$ef7b26044977a8ec,
    add4L: $73eacdfe0094ed3d$export$2f4e199c560f545d,
    add4H: $73eacdfe0094ed3d$export$e909220d675a7741,
    add5H: $73eacdfe0094ed3d$export$b45ee8d78c965098,
    add5L: $73eacdfe0094ed3d$export$d732b061fe9c9ae4
};
var $73eacdfe0094ed3d$export$2e2bcd8739ae039 = $73eacdfe0094ed3d$var$u64;



// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
const [$031f498723becf63$var$SHA512_Kh, $031f498723becf63$var$SHA512_Kl] = /* @__PURE__ */ (()=>(0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).split([
        "0x428a2f98d728ae22",
        "0x7137449123ef65cd",
        "0xb5c0fbcfec4d3b2f",
        "0xe9b5dba58189dbbc",
        "0x3956c25bf348b538",
        "0x59f111f1b605d019",
        "0x923f82a4af194f9b",
        "0xab1c5ed5da6d8118",
        "0xd807aa98a3030242",
        "0x12835b0145706fbe",
        "0x243185be4ee4b28c",
        "0x550c7dc3d5ffb4e2",
        "0x72be5d74f27b896f",
        "0x80deb1fe3b1696b1",
        "0x9bdc06a725c71235",
        "0xc19bf174cf692694",
        "0xe49b69c19ef14ad2",
        "0xefbe4786384f25e3",
        "0x0fc19dc68b8cd5b5",
        "0x240ca1cc77ac9c65",
        "0x2de92c6f592b0275",
        "0x4a7484aa6ea6e483",
        "0x5cb0a9dcbd41fbd4",
        "0x76f988da831153b5",
        "0x983e5152ee66dfab",
        "0xa831c66d2db43210",
        "0xb00327c898fb213f",
        "0xbf597fc7beef0ee4",
        "0xc6e00bf33da88fc2",
        "0xd5a79147930aa725",
        "0x06ca6351e003826f",
        "0x142929670a0e6e70",
        "0x27b70a8546d22ffc",
        "0x2e1b21385c26c926",
        "0x4d2c6dfc5ac42aed",
        "0x53380d139d95b3df",
        "0x650a73548baf63de",
        "0x766a0abb3c77b2a8",
        "0x81c2c92e47edaee6",
        "0x92722c851482353b",
        "0xa2bfe8a14cf10364",
        "0xa81a664bbc423001",
        "0xc24b8b70d0f89791",
        "0xc76c51a30654be30",
        "0xd192e819d6ef5218",
        "0xd69906245565a910",
        "0xf40e35855771202a",
        "0x106aa07032bbd1b8",
        "0x19a4c116b8d2d0c8",
        "0x1e376c085141ab53",
        "0x2748774cdf8eeb99",
        "0x34b0bcb5e19b48a8",
        "0x391c0cb3c5c95a63",
        "0x4ed8aa4ae3418acb",
        "0x5b9cca4f7763e373",
        "0x682e6ff3d6b2b8a3",
        "0x748f82ee5defb2fc",
        "0x78a5636f43172f60",
        "0x84c87814a1f0ab72",
        "0x8cc702081a6439ec",
        "0x90befffa23631e28",
        "0xa4506cebde82bde9",
        "0xbef9a3f7b2c67915",
        "0xc67178f2e372532b",
        "0xca273eceea26619c",
        "0xd186b8c721c0c207",
        "0xeada7dd6cde0eb1e",
        "0xf57d4f7fee6ed178",
        "0x06f067aa72176fba",
        "0x0a637dc5a2c898a6",
        "0x113f9804bef90dae",
        "0x1b710b35131c471b",
        "0x28db77f523047d84",
        "0x32caab7b40c72493",
        "0x3c9ebe0a15c9bebc",
        "0x431d67c49c100d4c",
        "0x4cc5d4becb3e42b6",
        "0x597f299cfc657e2a",
        "0x5fcb6fab3ad6faec",
        "0x6c44198c4a475817"
    ].map((n)=>BigInt(n))))();
// Temporary buffer, not used to store anything between runs
const $031f498723becf63$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $031f498723becf63$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $031f498723becf63$export$d655fdb8a1cad5df extends (0, $5bd3043a3f6a061f$export$ebbe38f24b9a0856) {
    constructor(){
        super(128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 1779033703;
        this.Al = -205731576;
        this.Bh = -1150833019;
        this.Bl = -2067093701;
        this.Ch = 1013904242;
        this.Cl = -23791573;
        this.Dh = -1521486534;
        this.Dl = 1595750129;
        this.Eh = 1359893119;
        this.El = -1377402159;
        this.Fh = -1694144372;
        this.Fl = 725511199;
        this.Gh = 528734635;
        this.Gl = -79577749;
        this.Hh = 1541459225;
        this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $031f498723becf63$var$SHA512_W_H[i] = view.getUint32(offset);
            $031f498723becf63$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $031f498723becf63$var$SHA512_W_H[i - 15] | 0;
            const W15l = $031f498723becf63$var$SHA512_W_L[i - 15] | 0;
            const s0h = (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).rotrSH(W15h, W15l, 1) ^ (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).rotrSH(W15h, W15l, 8) ^ (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).shrSH(W15h, W15l, 7);
            const s0l = (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).rotrSL(W15h, W15l, 1) ^ (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).rotrSL(W15h, W15l, 8) ^ (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $031f498723becf63$var$SHA512_W_H[i - 2] | 0;
            const W2l = $031f498723becf63$var$SHA512_W_L[i - 2] | 0;
            const s1h = (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).rotrSH(W2h, W2l, 19) ^ (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).rotrBH(W2h, W2l, 61) ^ (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).shrSH(W2h, W2l, 6);
            const s1l = (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).rotrSL(W2h, W2l, 19) ^ (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).rotrBL(W2h, W2l, 61) ^ (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).add4L(s0l, s1l, $031f498723becf63$var$SHA512_W_L[i - 7], $031f498723becf63$var$SHA512_W_L[i - 16]);
            const SUMh = (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).add4H(SUMl, s0h, s1h, $031f498723becf63$var$SHA512_W_H[i - 7], $031f498723becf63$var$SHA512_W_H[i - 16]);
            $031f498723becf63$var$SHA512_W_H[i] = SUMh | 0;
            $031f498723becf63$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).rotrSH(Eh, El, 14) ^ (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).rotrSH(Eh, El, 18) ^ (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).rotrBH(Eh, El, 41);
            const sigma1l = (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).rotrSL(Eh, El, 14) ^ (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).rotrSL(Eh, El, 18) ^ (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).add5L(Hl, sigma1l, CHIl, $031f498723becf63$var$SHA512_Kl[i], $031f498723becf63$var$SHA512_W_L[i]);
            const T1h = (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).add5H(T1ll, Hh, sigma1h, CHIh, $031f498723becf63$var$SHA512_Kh[i], $031f498723becf63$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).rotrSH(Ah, Al, 28) ^ (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).rotrBH(Ah, Al, 34) ^ (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).rotrBH(Ah, Al, 39);
            const sigma0l = (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).rotrSL(Ah, Al, 28) ^ (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).rotrBL(Ah, Al, 34) ^ (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).add3L(T1l, sigma0l, MAJl);
            Ah = (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = (0, $73eacdfe0094ed3d$export$2e2bcd8739ae039).add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        $031f498723becf63$var$SHA512_W_H.fill(0);
        $031f498723becf63$var$SHA512_W_L.fill(0);
    }
    destroy() {
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
class $031f498723becf63$var$SHA512_224 extends $031f498723becf63$export$d655fdb8a1cad5df {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -1942145080;
        this.Al = 424955298;
        this.Bh = 1944164710;
        this.Bl = -1982016298;
        this.Ch = 502970286;
        this.Cl = 855612546;
        this.Dh = 1738396948;
        this.Dl = 1479516111;
        this.Eh = 258812777;
        this.El = 2077511080;
        this.Fh = 2011393907;
        this.Fl = 79989058;
        this.Gh = 1067287976;
        this.Gl = 1780299464;
        this.Hh = 286451373;
        this.Hl = -1848208735;
        this.outputLen = 28;
    }
}
class $031f498723becf63$var$SHA512_256 extends $031f498723becf63$export$d655fdb8a1cad5df {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 573645204;
        this.Al = -64227540;
        this.Bh = -1621794909;
        this.Bl = -934517566;
        this.Ch = 596883563;
        this.Cl = 1867755857;
        this.Dh = -1774684391;
        this.Dl = 1497426621;
        this.Eh = -1775747358;
        this.El = -1467023389;
        this.Fh = -1101128155;
        this.Fl = 1401305490;
        this.Gh = 721525244;
        this.Gl = 746961066;
        this.Hh = 246885852;
        this.Hl = -2117784414;
        this.outputLen = 32;
    }
}
class $031f498723becf63$var$SHA384 extends $031f498723becf63$export$d655fdb8a1cad5df {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -876896931;
        this.Al = -1056596264;
        this.Bh = 1654270250;
        this.Bl = 914150663;
        this.Ch = -1856437926;
        this.Cl = 812702999;
        this.Dh = 355462360;
        this.Dl = -150054599;
        this.Eh = 1731405415;
        this.El = -4191439;
        this.Fh = -1900787065;
        this.Fl = 1750603025;
        this.Gh = -619958771;
        this.Gl = 1694076839;
        this.Hh = 1203062813;
        this.Hl = -1090891868;
        this.outputLen = 48;
    }
}
const $031f498723becf63$export$a888d2532e6dc7bb = /* @__PURE__ */ (0, $ade6911eb19cf62a$export$f081816339df1972)(()=>new $031f498723becf63$export$d655fdb8a1cad5df());
const $031f498723becf63$export$a090a04f72f0a320 = /* @__PURE__ */ (0, $ade6911eb19cf62a$export$f081816339df1972)(()=>new $031f498723becf63$var$SHA512_224());
const $031f498723becf63$export$c78786b6da86db2a = /* @__PURE__ */ (0, $ade6911eb19cf62a$export$f081816339df1972)(()=>new $031f498723becf63$var$SHA512_256());
const $031f498723becf63$export$612d47d55dedde45 = /* @__PURE__ */ (0, $ade6911eb19cf62a$export$f081816339df1972)(()=>new $031f498723becf63$var$SHA384());



/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Twisted Edwards curve. The formula is: ax² + y² = 1 + dx²y²

var $cJ5fp = parcelRequire("cJ5fp");

var $5hs45 = parcelRequire("5hs45");

var $3Xv2M = parcelRequire("3Xv2M");
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $0d7ebb81be3b4204$var$_0n = BigInt(0), $0d7ebb81be3b4204$var$_1n = BigInt(1), $0d7ebb81be3b4204$var$_2n = BigInt(2), $0d7ebb81be3b4204$var$_8n = BigInt(8);
// verification rule is either zip215 or rfc8032 / nist186-5. Consult fromHex:
const $0d7ebb81be3b4204$var$VERIFY_DEFAULT = {
    zip215: true
};
function $0d7ebb81be3b4204$var$validateOpts(curve) {
    const opts = (0, $3Xv2M.validateBasic)(curve);
    $5hs45.validateObject(curve, {
        hash: "function",
        a: "bigint",
        d: "bigint",
        randomBytes: "function"
    }, {
        adjustScalarBytes: "function",
        domain: "function",
        uvRatio: "function",
        mapToCurve: "function"
    });
    // Set defaults
    return Object.freeze({
        ...opts
    });
}
function $0d7ebb81be3b4204$export$f0c1eee63ea541eb(curveDef) {
    const CURVE = $0d7ebb81be3b4204$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER, prehash: prehash, hash: cHash, randomBytes: randomBytes, nByteLength: nByteLength, h: cofactor } = CURVE;
    const MASK = $0d7ebb81be3b4204$var$_2n << BigInt(nByteLength * 8) - $0d7ebb81be3b4204$var$_1n;
    const modP = Fp.create; // Function overrides
    // sqrt(u/v)
    const uvRatio = CURVE.uvRatio || ((u, v)=>{
        try {
            return {
                isValid: true,
                value: Fp.sqrt(u * Fp.inv(v))
            };
        } catch (e) {
            return {
                isValid: false,
                value: $0d7ebb81be3b4204$var$_0n
            };
        }
    });
    const adjustScalarBytes = CURVE.adjustScalarBytes || ((bytes)=>bytes); // NOOP
    const domain = CURVE.domain || ((data, ctx, phflag)=>{
        if (ctx.length || phflag) throw new Error("Contexts/pre-hash are not supported");
        return data;
    }); // NOOP
    const inBig = (n)=>typeof n === "bigint" && $0d7ebb81be3b4204$var$_0n < n; // n in [1..]
    const inRange = (n, max)=>inBig(n) && inBig(max) && n < max; // n in [1..max-1]
    const in0MaskRange = (n)=>n === $0d7ebb81be3b4204$var$_0n || inRange(n, MASK); // n in [0..MASK-1]
    function assertInRange(n, max) {
        // n in [1..max-1]
        if (inRange(n, max)) return n;
        throw new Error(`Expected valid scalar < ${max}, got ${typeof n} ${n}`);
    }
    function assertGE0(n) {
        // n in [0..CURVE_ORDER-1]
        return n === $0d7ebb81be3b4204$var$_0n ? n : assertInRange(n, CURVE_ORDER); // GE = prime subgroup, not full group
    }
    const pointPrecomputes = new Map();
    function isPoint(other) {
        if (!(other instanceof Point)) throw new Error("ExtendedPoint expected");
    }
    // Extended Point works in extended coordinates: (x, y, z, t) ∋ (x=x/z, y=y/z, t=xy).
    // https://en.wikipedia.org/wiki/Twisted_Edwards_curve#Extended_coordinates
    class Point {
        constructor(ex, ey, ez, et){
            this.ex = ex;
            this.ey = ey;
            this.ez = ez;
            this.et = et;
            if (!in0MaskRange(ex)) throw new Error("x required");
            if (!in0MaskRange(ey)) throw new Error("y required");
            if (!in0MaskRange(ez)) throw new Error("z required");
            if (!in0MaskRange(et)) throw new Error("t required");
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        static fromAffine(p) {
            if (p instanceof Point) throw new Error("extended point not allowed");
            const { x: x, y: y } = p || {};
            if (!in0MaskRange(x) || !in0MaskRange(y)) throw new Error("invalid affine point");
            return new Point(x, y, $0d7ebb81be3b4204$var$_1n, modP(x * y));
        }
        static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.ez));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        }
        // Not required for fromHex(), which always creates valid points.
        // Could be useful for fromAffine().
        assertValidity() {
            const { a: a, d: d } = CURVE;
            if (this.is0()) throw new Error("bad point: ZERO"); // TODO: optimize, with vars below?
            // Equation in affine coordinates: ax² + y² = 1 + dx²y²
            // Equation in projective coordinates (X/Z, Y/Z, Z):  (aX² + Y²)Z² = Z⁴ + dX²Y²
            const { ex: X, ey: Y, ez: Z, et: T } = this;
            const X2 = modP(X * X); // X²
            const Y2 = modP(Y * Y); // Y²
            const Z2 = modP(Z * Z); // Z²
            const Z4 = modP(Z2 * Z2); // Z⁴
            const aX2 = modP(X2 * a); // aX²
            const left = modP(Z2 * modP(aX2 + Y2)); // (aX² + Y²)Z²
            const right = modP(Z4 + modP(d * modP(X2 * Y2))); // Z⁴ + dX²Y²
            if (left !== right) throw new Error("bad point: equation left != right (1)");
            // In Extended coordinates we also have T, which is x*y=T/Z: check X*Y == Z*T
            const XY = modP(X * Y);
            const ZT = modP(Z * T);
            if (XY !== ZT) throw new Error("bad point: equation left != right (2)");
        }
        // Compare one point to another.
        equals(other) {
            isPoint(other);
            const { ex: X1, ey: Y1, ez: Z1 } = this;
            const { ex: X2, ey: Y2, ez: Z2 } = other;
            const X1Z2 = modP(X1 * Z2);
            const X2Z1 = modP(X2 * Z1);
            const Y1Z2 = modP(Y1 * Z2);
            const Y2Z1 = modP(Y2 * Z1);
            return X1Z2 === X2Z1 && Y1Z2 === Y2Z1;
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        negate() {
            // Flips point sign to a negative one (-x, y in affine coords)
            return new Point(modP(-this.ex), this.ey, this.ez, modP(-this.et));
        }
        // Fast algo for doubling Extended Point.
        // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#doubling-dbl-2008-hwcd
        // Cost: 4M + 4S + 1*a + 6add + 1*2.
        double() {
            const { a: a } = CURVE;
            const { ex: X1, ey: Y1, ez: Z1 } = this;
            const A = modP(X1 * X1); // A = X12
            const B = modP(Y1 * Y1); // B = Y12
            const C = modP($0d7ebb81be3b4204$var$_2n * modP(Z1 * Z1)); // C = 2*Z12
            const D = modP(a * A); // D = a*A
            const x1y1 = X1 + Y1;
            const E = modP(modP(x1y1 * x1y1) - A - B); // E = (X1+Y1)2-A-B
            const G = D + B; // G = D+B
            const F = G - C; // F = G-C
            const H = D - B; // H = D-B
            const X3 = modP(E * F); // X3 = E*F
            const Y3 = modP(G * H); // Y3 = G*H
            const T3 = modP(E * H); // T3 = E*H
            const Z3 = modP(F * G); // Z3 = F*G
            return new Point(X3, Y3, Z3, T3);
        }
        // Fast algo for adding 2 Extended Points.
        // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#addition-add-2008-hwcd
        // Cost: 9M + 1*a + 1*d + 7add.
        add(other) {
            isPoint(other);
            const { a: a, d: d } = CURVE;
            const { ex: X1, ey: Y1, ez: Z1, et: T1 } = this;
            const { ex: X2, ey: Y2, ez: Z2, et: T2 } = other;
            // Faster algo for adding 2 Extended Points when curve's a=-1.
            // http://hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html#addition-add-2008-hwcd-4
            // Cost: 8M + 8add + 2*2.
            // Note: It does not check whether the `other` point is valid.
            if (a === BigInt(-1)) {
                const A = modP((Y1 - X1) * (Y2 + X2));
                const B = modP((Y1 + X1) * (Y2 - X2));
                const F = modP(B - A);
                if (F === $0d7ebb81be3b4204$var$_0n) return this.double(); // Same point. Tests say it doesn't affect timing
                const C = modP(Z1 * $0d7ebb81be3b4204$var$_2n * T2);
                const D = modP(T1 * $0d7ebb81be3b4204$var$_2n * Z2);
                const E = D + C;
                const G = B + A;
                const H = D - C;
                const X3 = modP(E * F);
                const Y3 = modP(G * H);
                const T3 = modP(E * H);
                const Z3 = modP(F * G);
                return new Point(X3, Y3, Z3, T3);
            }
            const A = modP(X1 * X2); // A = X1*X2
            const B = modP(Y1 * Y2); // B = Y1*Y2
            const C = modP(T1 * d * T2); // C = T1*d*T2
            const D = modP(Z1 * Z2); // D = Z1*Z2
            const E = modP((X1 + Y1) * (X2 + Y2) - A - B); // E = (X1+Y1)*(X2+Y2)-A-B
            const F = D - C; // F = D-C
            const G = D + C; // G = D+C
            const H = modP(B - a * A); // H = B-a*A
            const X3 = modP(E * F); // X3 = E*F
            const Y3 = modP(G * H); // Y3 = G*H
            const T3 = modP(E * H); // T3 = E*H
            const Z3 = modP(F * G); // Z3 = F*G
            return new Point(X3, Y3, Z3, T3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, Point.normalizeZ);
        }
        // Constant-time multiplication.
        multiply(scalar) {
            const { p: p, f: f } = this.wNAF(assertInRange(scalar, CURVE_ORDER));
            return Point.normalizeZ([
                p,
                f
            ])[0];
        }
        // Non-constant-time multiplication. Uses double-and-add algorithm.
        // It's faster, but should only be used when you don't care about
        // an exposed private key e.g. sig verification.
        // Does NOT allow scalars higher than CURVE.n.
        multiplyUnsafe(scalar) {
            let n = assertGE0(scalar); // 0 <= scalar < CURVE.n
            if (n === $0d7ebb81be3b4204$var$_0n) return I;
            if (this.equals(I) || n === $0d7ebb81be3b4204$var$_1n) return this;
            if (this.equals(G)) return this.wNAF(n).p;
            return wnaf.unsafeLadder(this, n);
        }
        // Checks if point is of small order.
        // If you add something to small order point, you will have "dirty"
        // point with torsion component.
        // Multiplies point by cofactor and checks if the result is 0.
        isSmallOrder() {
            return this.multiplyUnsafe(cofactor).is0();
        }
        // Multiplies point by curve order and checks if the result is 0.
        // Returns `false` is the point is dirty.
        isTorsionFree() {
            return wnaf.unsafeLadder(this, CURVE_ORDER).is0();
        }
        // Converts Extended point to default (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        toAffine(iz) {
            const { ex: x, ey: y, ez: z } = this;
            const is0 = this.is0();
            if (iz == null) iz = is0 ? $0d7ebb81be3b4204$var$_8n : Fp.inv(z); // 8 was chosen arbitrarily
            const ax = modP(x * iz);
            const ay = modP(y * iz);
            const zz = modP(z * iz);
            if (is0) return {
                x: $0d7ebb81be3b4204$var$_0n,
                y: $0d7ebb81be3b4204$var$_1n
            };
            if (zz !== $0d7ebb81be3b4204$var$_1n) throw new Error("invZ was invalid");
            return {
                x: ax,
                y: ay
            };
        }
        clearCofactor() {
            const { h: cofactor } = CURVE;
            if (cofactor === $0d7ebb81be3b4204$var$_1n) return this;
            return this.multiplyUnsafe(cofactor);
        }
        // Converts hash string or Uint8Array to Point.
        // Uses algo from RFC8032 5.1.3.
        static fromHex(hex, zip215 = false) {
            const { d: d, a: a } = CURVE;
            const len = Fp.BYTES;
            hex = (0, $5hs45.ensureBytes)("pointHex", hex, len); // copy hex to a new array
            const normed = hex.slice(); // copy again, we'll manipulate it
            const lastByte = hex[len - 1]; // select last byte
            normed[len - 1] = lastByte & -129; // clear last bit
            const y = $5hs45.bytesToNumberLE(normed);
            if (y === $0d7ebb81be3b4204$var$_0n) ;
            else // RFC8032 prohibits >= p, but ZIP215 doesn't
            if (zip215) assertInRange(y, MASK); // zip215=true [1..P-1] (2^255-19-1 for ed25519)
            else assertInRange(y, Fp.ORDER); // zip215=false [1..MASK-1] (2^256-1 for ed25519)
            // Ed25519: x² = (y²-1)/(dy²+1) mod p. Ed448: x² = (y²-1)/(dy²-1) mod p. Generic case:
            // ax²+y²=1+dx²y² => y²-1=dx²y²-ax² => y²-1=x²(dy²-a) => x²=(y²-1)/(dy²-a)
            const y2 = modP(y * y); // denominator is always non-0 mod p.
            const u = modP(y2 - $0d7ebb81be3b4204$var$_1n); // u = y² - 1
            const v = modP(d * y2 - a); // v = d y² + 1.
            let { isValid: isValid, value: x } = uvRatio(u, v); // √(u/v)
            if (!isValid) throw new Error("Point.fromHex: invalid y coordinate");
            const isXOdd = (x & $0d7ebb81be3b4204$var$_1n) === $0d7ebb81be3b4204$var$_1n; // There are 2 square roots. Use x_0 bit to select proper
            const isLastByteOdd = (lastByte & 0x80) !== 0; // x_0, last bit
            if (!zip215 && x === $0d7ebb81be3b4204$var$_0n && isLastByteOdd) // if x=0 and x_0 = 1, fail
            throw new Error("Point.fromHex: x=0 and x_0=1");
            if (isLastByteOdd !== isXOdd) x = modP(-x); // if x_0 != x mod 2, set x = p-x
            return Point.fromAffine({
                x: x,
                y: y
            });
        }
        static fromPrivateKey(privKey) {
            return getExtendedPublicKey(privKey).point;
        }
        toRawBytes() {
            const { x: x, y: y } = this.toAffine();
            const bytes = $5hs45.numberToBytesLE(y, Fp.BYTES); // each y has 2 x values (x, -y)
            bytes[bytes.length - 1] |= x & $0d7ebb81be3b4204$var$_1n ? 0x80 : 0; // when compressing, it's enough to store y
            return bytes; // and use the last byte to encode sign of x
        }
        toHex() {
            return $5hs45.bytesToHex(this.toRawBytes()); // Same as toRawBytes, but returns string.
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, $0d7ebb81be3b4204$var$_1n, modP(CURVE.Gx * CURVE.Gy));
    Point.ZERO = new Point($0d7ebb81be3b4204$var$_0n, $0d7ebb81be3b4204$var$_1n, $0d7ebb81be3b4204$var$_1n, $0d7ebb81be3b4204$var$_0n); // 0, 1, 1, 0
    const { BASE: G, ZERO: I } = Point;
    const wnaf = (0, $3Xv2M.wNAF)(Point, nByteLength * 8);
    function modN(a) {
        return (0, $cJ5fp.mod)(a, CURVE_ORDER);
    }
    // Little-endian SHA512 with modulo n
    function modN_LE(hash) {
        return modN($5hs45.bytesToNumberLE(hash));
    }
    /** Convenience method that creates public key and other stuff. RFC8032 5.1.5 */ function getExtendedPublicKey(key) {
        const len = nByteLength;
        key = (0, $5hs45.ensureBytes)("private key", key, len);
        // Hash private key with curve's hash function to produce uniformingly random input
        // Check byte lengths: ensure(64, h(ensure(32, key)))
        const hashed = (0, $5hs45.ensureBytes)("hashed private key", cHash(key), 2 * len);
        const head = adjustScalarBytes(hashed.slice(0, len)); // clear first half bits, produce FE
        const prefix = hashed.slice(len, 2 * len); // second half is called key prefix (5.1.6)
        const scalar = modN_LE(head); // The actual private scalar
        const point = G.multiply(scalar); // Point on Edwards curve aka public key
        const pointBytes = point.toRawBytes(); // Uint8Array representation
        return {
            head: head,
            prefix: prefix,
            scalar: scalar,
            point: point,
            pointBytes: pointBytes
        };
    }
    // Calculates EdDSA pub key. RFC8032 5.1.5. Privkey is hashed. Use first half with 3 bits cleared
    function getPublicKey(privKey) {
        return getExtendedPublicKey(privKey).pointBytes;
    }
    // int('LE', SHA512(dom2(F, C) || msgs)) mod N
    function hashDomainToScalar(context = new Uint8Array(), ...msgs) {
        const msg = $5hs45.concatBytes(...msgs);
        return modN_LE(cHash(domain(msg, (0, $5hs45.ensureBytes)("context", context), !!prehash)));
    }
    /** Signs message with privateKey. RFC8032 5.1.6 */ function sign(msg, privKey, options = {}) {
        msg = (0, $5hs45.ensureBytes)("message", msg);
        if (prehash) msg = prehash(msg); // for ed25519ph etc.
        const { prefix: prefix, scalar: scalar, pointBytes: pointBytes } = getExtendedPublicKey(privKey);
        const r = hashDomainToScalar(options.context, prefix, msg); // r = dom2(F, C) || prefix || PH(M)
        const R = G.multiply(r).toRawBytes(); // R = rG
        const k = hashDomainToScalar(options.context, R, pointBytes, msg); // R || A || PH(M)
        const s = modN(r + k * scalar); // S = (r + k * s) mod L
        assertGE0(s); // 0 <= s < l
        const res = $5hs45.concatBytes(R, $5hs45.numberToBytesLE(s, Fp.BYTES));
        return (0, $5hs45.ensureBytes)("result", res, nByteLength * 2); // 64-byte signature
    }
    const verifyOpts = $0d7ebb81be3b4204$var$VERIFY_DEFAULT;
    function verify(sig, msg, publicKey, options = verifyOpts) {
        const { context: context, zip215: zip215 } = options;
        const len = Fp.BYTES; // Verifies EdDSA signature against message and public key. RFC8032 5.1.7.
        sig = (0, $5hs45.ensureBytes)("signature", sig, 2 * len); // An extended group equation is checked.
        msg = (0, $5hs45.ensureBytes)("message", msg);
        if (prehash) msg = prehash(msg); // for ed25519ph, etc
        const s = $5hs45.bytesToNumberLE(sig.slice(len, 2 * len));
        // zip215: true is good for consensus-critical apps and allows points < 2^256
        // zip215: false follows RFC8032 / NIST186-5 and restricts points to CURVE.p
        let A, R, SB;
        try {
            A = Point.fromHex(publicKey, zip215);
            R = Point.fromHex(sig.slice(0, len), zip215);
            SB = G.multiplyUnsafe(s); // 0 <= s < l is done inside
        } catch (error) {
            return false;
        }
        if (!zip215 && A.isSmallOrder()) return false;
        const k = hashDomainToScalar(context, R.toRawBytes(), A.toRawBytes(), msg);
        const RkA = R.add(A.multiplyUnsafe(k));
        // [8][S]B = [8]R + [8][k]A'
        return RkA.subtract(SB).clearCofactor().equals(Point.ZERO);
    }
    G._setWindowSize(8); // Enable precomputes. Slows down first publicKey computation by 20ms.
    const utils = {
        getExtendedPublicKey: getExtendedPublicKey,
        // ed25519 private keys are uniform 32b. No need to check for modulo bias, like in secp256k1.
        randomPrivateKey: ()=>randomBytes(Fp.BYTES),
        /**
         * We're doing scalar multiplication (used in getPublicKey etc) with precomputed BASE_POINT
         * values. This slows down first getPublicKey() by milliseconds (see Speed section),
         * but allows to speed-up subsequent getPublicKey() calls up to 20x.
         * @param windowSize 2, 4, 8, 16
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3));
            return point;
        }
    };
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        sign: sign,
        verify: verify,
        ExtendedPoint: Point,
        utils: utils
    };
}


/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ 
var $cJ5fp = parcelRequire("cJ5fp");

var $5hs45 = parcelRequire("5hs45");
const $7f42568f330de1fa$var$_0n = BigInt(0);
const $7f42568f330de1fa$var$_1n = BigInt(1);
function $7f42568f330de1fa$var$validateOpts(curve) {
    (0, $5hs45.validateObject)(curve, {
        a: "bigint"
    }, {
        montgomeryBits: "isSafeInteger",
        nByteLength: "isSafeInteger",
        adjustScalarBytes: "function",
        domain: "function",
        powPminus2: "function",
        Gu: "bigint"
    });
    // Set defaults
    return Object.freeze({
        ...curve
    });
}
function $7f42568f330de1fa$export$bdbee0d01bf914a7(curveDef) {
    const CURVE = $7f42568f330de1fa$var$validateOpts(curveDef);
    const { P: P } = CURVE;
    const modP = (n)=>(0, $cJ5fp.mod)(n, P);
    const montgomeryBits = CURVE.montgomeryBits;
    const montgomeryBytes = Math.ceil(montgomeryBits / 8);
    const fieldLen = CURVE.nByteLength;
    const adjustScalarBytes = CURVE.adjustScalarBytes || ((bytes)=>bytes);
    const powPminus2 = CURVE.powPminus2 || ((x)=>(0, $cJ5fp.pow)(x, P - BigInt(2), P));
    // cswap from RFC7748. But it is not from RFC7748!
    /*
      cswap(swap, x_2, x_3):
           dummy = mask(swap) AND (x_2 XOR x_3)
           x_2 = x_2 XOR dummy
           x_3 = x_3 XOR dummy
           Return (x_2, x_3)
    Where mask(swap) is the all-1 or all-0 word of the same length as x_2
     and x_3, computed, e.g., as mask(swap) = 0 - swap.
    */ function cswap(swap, x_2, x_3) {
        const dummy = modP(swap * (x_2 - x_3));
        x_2 = modP(x_2 - dummy);
        x_3 = modP(x_3 + dummy);
        return [
            x_2,
            x_3
        ];
    }
    // Accepts 0 as well
    function assertFieldElement(n) {
        if (typeof n === "bigint" && $7f42568f330de1fa$var$_0n <= n && n < P) return n;
        throw new Error("Expected valid scalar 0 < scalar < CURVE.P");
    }
    // x25519 from 4
    // The constant a24 is (486662 - 2) / 4 = 121665 for curve25519/X25519
    const a24 = (CURVE.a - BigInt(2)) / BigInt(4);
    /**
     *
     * @param pointU u coordinate (x) on Montgomery Curve 25519
     * @param scalar by which the point would be multiplied
     * @returns new Point on Montgomery curve
     */ function montgomeryLadder(pointU, scalar) {
        const u = assertFieldElement(pointU);
        // Section 5: Implementations MUST accept non-canonical values and process them as
        // if they had been reduced modulo the field prime.
        const k = assertFieldElement(scalar);
        const x_1 = u;
        let x_2 = $7f42568f330de1fa$var$_1n;
        let z_2 = $7f42568f330de1fa$var$_0n;
        let x_3 = u;
        let z_3 = $7f42568f330de1fa$var$_1n;
        let swap = $7f42568f330de1fa$var$_0n;
        let sw;
        for(let t = BigInt(montgomeryBits - 1); t >= $7f42568f330de1fa$var$_0n; t--){
            const k_t = k >> t & $7f42568f330de1fa$var$_1n;
            swap ^= k_t;
            sw = cswap(swap, x_2, x_3);
            x_2 = sw[0];
            x_3 = sw[1];
            sw = cswap(swap, z_2, z_3);
            z_2 = sw[0];
            z_3 = sw[1];
            swap = k_t;
            const A = x_2 + z_2;
            const AA = modP(A * A);
            const B = x_2 - z_2;
            const BB = modP(B * B);
            const E = AA - BB;
            const C = x_3 + z_3;
            const D = x_3 - z_3;
            const DA = modP(D * A);
            const CB = modP(C * B);
            const dacb = DA + CB;
            const da_cb = DA - CB;
            x_3 = modP(dacb * dacb);
            z_3 = modP(x_1 * modP(da_cb * da_cb));
            x_2 = modP(AA * BB);
            z_2 = modP(E * (AA + modP(a24 * E)));
        }
        // (x_2, x_3) = cswap(swap, x_2, x_3)
        sw = cswap(swap, x_2, x_3);
        x_2 = sw[0];
        x_3 = sw[1];
        // (z_2, z_3) = cswap(swap, z_2, z_3)
        sw = cswap(swap, z_2, z_3);
        z_2 = sw[0];
        z_3 = sw[1];
        // z_2^(p - 2)
        const z2 = powPminus2(z_2);
        // Return x_2 * (z_2^(p - 2))
        return modP(x_2 * z2);
    }
    function encodeUCoordinate(u) {
        return (0, $5hs45.numberToBytesLE)(modP(u), montgomeryBytes);
    }
    function decodeUCoordinate(uEnc) {
        // Section 5: When receiving such an array, implementations of X25519
        // MUST mask the most significant bit in the final byte.
        const u = (0, $5hs45.ensureBytes)("u coordinate", uEnc, montgomeryBytes);
        if (fieldLen === 32) u[31] &= 127; // 0b0111_1111
        return (0, $5hs45.bytesToNumberLE)(u);
    }
    function decodeScalar(n) {
        const bytes = (0, $5hs45.ensureBytes)("scalar", n);
        const len = bytes.length;
        if (len !== montgomeryBytes && len !== fieldLen) throw new Error(`Expected ${montgomeryBytes} or ${fieldLen} bytes, got ${len}`);
        return (0, $5hs45.bytesToNumberLE)(adjustScalarBytes(bytes));
    }
    function scalarMult(scalar, u) {
        const pointU = decodeUCoordinate(u);
        const _scalar = decodeScalar(scalar);
        const pu = montgomeryLadder(pointU, _scalar);
        // The result was not contributory
        // https://cr.yp.to/ecdh.html#validate
        if (pu === $7f42568f330de1fa$var$_0n) throw new Error("Invalid private or public key received");
        return encodeUCoordinate(pu);
    }
    // Computes public key from private. By doing scalar multiplication of base point.
    const GuBytes = encodeUCoordinate(CURVE.Gu);
    function scalarMultBase(scalar) {
        return scalarMult(scalar, GuBytes);
    }
    return {
        scalarMult: scalarMult,
        scalarMultBase: scalarMultBase,
        getSharedSecret: (privateKey, publicKey)=>scalarMult(privateKey, publicKey),
        getPublicKey: (privateKey)=>scalarMultBase(privateKey),
        utils: {
            randomPrivateKey: ()=>CURVE.randomBytes(CURVE.nByteLength)
        },
        GuBytes: GuBytes
    };
}



var $cJ5fp = parcelRequire("cJ5fp");

var $5hs45 = parcelRequire("5hs45");

var $cJ5fp = parcelRequire("cJ5fp");

var $5hs45 = parcelRequire("5hs45");
function $d1e2a0e29d07a139$var$validateDST(dst) {
    if ((0, $5hs45.isBytes)(dst)) return dst;
    if (typeof dst === "string") return (0, $5hs45.utf8ToBytes)(dst);
    throw new Error("DST must be Uint8Array or string");
}
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $d1e2a0e29d07a139$var$os2ip = (0, $5hs45.bytesToNumberBE);
// Integer to Octet Stream (numberToBytesBE)
function $d1e2a0e29d07a139$var$i2osp(value, length) {
    if (value < 0 || value >= 1 << 8 * length) throw new Error(`bad I2OSP call: value=${value} length=${length}`);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $d1e2a0e29d07a139$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $d1e2a0e29d07a139$var$abytes(item) {
    if (!(0, $5hs45.isBytes)(item)) throw new Error("Uint8Array expected");
}
function $d1e2a0e29d07a139$var$isNum(item) {
    if (!Number.isSafeInteger(item)) throw new Error("number expected");
}
function $d1e2a0e29d07a139$export$3df78c69af9fc85d(msg, DST, lenInBytes, H) {
    $d1e2a0e29d07a139$var$abytes(msg);
    $d1e2a0e29d07a139$var$abytes(DST);
    $d1e2a0e29d07a139$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $5hs45.concatBytes)((0, $5hs45.utf8ToBytes)("H2C-OVERSIZE-DST-"), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (ell > 255) throw new Error("Invalid xmd length");
    const DST_prime = (0, $5hs45.concatBytes)(DST, $d1e2a0e29d07a139$var$i2osp(DST.length, 1));
    const Z_pad = $d1e2a0e29d07a139$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $d1e2a0e29d07a139$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $5hs45.concatBytes)(Z_pad, msg, l_i_b_str, $d1e2a0e29d07a139$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $5hs45.concatBytes)(b_0, $d1e2a0e29d07a139$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $d1e2a0e29d07a139$var$strxor(b_0, b[i - 1]),
            $d1e2a0e29d07a139$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $5hs45.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, $5hs45.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
function $d1e2a0e29d07a139$export$3f56d6fdbf95d07c(msg, DST, lenInBytes, k, H) {
    $d1e2a0e29d07a139$var$abytes(msg);
    $d1e2a0e29d07a139$var$abytes(DST);
    $d1e2a0e29d07a139$var$isNum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $5hs45.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($d1e2a0e29d07a139$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($d1e2a0e29d07a139$var$i2osp(DST.length, 1)).digest();
}
function $d1e2a0e29d07a139$export$97cdd5ee18de8172(msg, count, options) {
    (0, $5hs45.validateObject)(options, {
        DST: "stringOrUint8Array",
        p: "bigint",
        m: "isSafeInteger",
        k: "isSafeInteger",
        hash: "hash"
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: _DST } = options;
    $d1e2a0e29d07a139$var$abytes(msg);
    $d1e2a0e29d07a139$var$isNum(count);
    const DST = $d1e2a0e29d07a139$var$validateDST(_DST);
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === "xmd") prb = $d1e2a0e29d07a139$export$3df78c69af9fc85d(msg, DST, len_in_bytes, hash);
    else if (expand === "xof") prb = $d1e2a0e29d07a139$export$3f56d6fdbf95d07c(msg, DST, len_in_bytes, k, hash);
    else if (expand === "_internal_pass") // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $cJ5fp.mod)($d1e2a0e29d07a139$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
function $d1e2a0e29d07a139$export$9393380cf1075f28(field, map) {
    // Make same order as in spec
    const COEFF = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xNum, xDen, yNum, yDen] = COEFF.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
function $d1e2a0e29d07a139$export$14b114effbc08b6b(Point, mapToCurve, def) {
    if (typeof mapToCurve !== "function") throw new Error("mapToCurve() must be defined");
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve (msg, options) {
            const u = $d1e2a0e29d07a139$export$97cdd5ee18de8172(msg, 2, {
                ...def,
                DST: def.DST,
                ...options
            });
            const u0 = Point.fromAffine(mapToCurve(u[0]));
            const u1 = Point.fromAffine(mapToCurve(u[1]));
            const P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve (msg, options) {
            const u = $d1e2a0e29d07a139$export$97cdd5ee18de8172(msg, 1, {
                ...def,
                DST: def.encodeDST,
                ...options
            });
            const P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}


/**
 * ed25519 Twisted Edwards curve with following addons:
 * - X25519 ECDH
 * - Ristretto cofactor elimination
 * - Elligator hash-to-group / point indistinguishability
 */ const $a51020b120fefcad$var$ED25519_P = BigInt("57896044618658097711785492504343953926634992332820282019728792003956564819949");
// √(-1) aka √(a) aka 2^((p-1)/4)
const $a51020b120fefcad$var$ED25519_SQRT_M1 = BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");
// prettier-ignore
const $a51020b120fefcad$var$_0n = BigInt(0), $a51020b120fefcad$var$_1n = BigInt(1), $a51020b120fefcad$var$_2n = BigInt(2), $a51020b120fefcad$var$_5n = BigInt(5);
// prettier-ignore
const $a51020b120fefcad$var$_10n = BigInt(10), $a51020b120fefcad$var$_20n = BigInt(20), $a51020b120fefcad$var$_40n = BigInt(40), $a51020b120fefcad$var$_80n = BigInt(80);
function $a51020b120fefcad$var$ed25519_pow_2_252_3(x) {
    const P = $a51020b120fefcad$var$ED25519_P;
    const x2 = x * x % P;
    const b2 = x2 * x % P; // x^3, 11
    const b4 = (0, $cJ5fp.pow2)(b2, $a51020b120fefcad$var$_2n, P) * b2 % P; // x^15, 1111
    const b5 = (0, $cJ5fp.pow2)(b4, $a51020b120fefcad$var$_1n, P) * x % P; // x^31
    const b10 = (0, $cJ5fp.pow2)(b5, $a51020b120fefcad$var$_5n, P) * b5 % P;
    const b20 = (0, $cJ5fp.pow2)(b10, $a51020b120fefcad$var$_10n, P) * b10 % P;
    const b40 = (0, $cJ5fp.pow2)(b20, $a51020b120fefcad$var$_20n, P) * b20 % P;
    const b80 = (0, $cJ5fp.pow2)(b40, $a51020b120fefcad$var$_40n, P) * b40 % P;
    const b160 = (0, $cJ5fp.pow2)(b80, $a51020b120fefcad$var$_80n, P) * b80 % P;
    const b240 = (0, $cJ5fp.pow2)(b160, $a51020b120fefcad$var$_80n, P) * b80 % P;
    const b250 = (0, $cJ5fp.pow2)(b240, $a51020b120fefcad$var$_10n, P) * b10 % P;
    const pow_p_5_8 = (0, $cJ5fp.pow2)(b250, $a51020b120fefcad$var$_2n, P) * x % P;
    // ^ To pow to (p+3)/8, multiply it by x.
    return {
        pow_p_5_8: pow_p_5_8,
        b2: b2
    };
}
function $a51020b120fefcad$var$adjustScalarBytes(bytes) {
    // Section 5: For X25519, in order to decode 32 random bytes as an integer scalar,
    // set the three least significant bits of the first byte
    bytes[0] &= 248; // 0b1111_1000
    // and the most significant bit of the last to zero,
    bytes[31] &= 127; // 0b0111_1111
    // set the second most significant bit of the last byte to 1
    bytes[31] |= 64; // 0b0100_0000
    return bytes;
}
// sqrt(u/v)
function $a51020b120fefcad$var$uvRatio(u, v) {
    const P = $a51020b120fefcad$var$ED25519_P;
    const v3 = (0, $cJ5fp.mod)(v * v * v, P); // v³
    const v7 = (0, $cJ5fp.mod)(v3 * v3 * v, P); // v⁷
    // (p+3)/8 and (p-5)/8
    const pow = $a51020b120fefcad$var$ed25519_pow_2_252_3(u * v7).pow_p_5_8;
    let x = (0, $cJ5fp.mod)(u * v3 * pow, P); // (uv³)(uv⁷)^(p-5)/8
    const vx2 = (0, $cJ5fp.mod)(v * x * x, P); // vx²
    const root1 = x; // First root candidate
    const root2 = (0, $cJ5fp.mod)(x * $a51020b120fefcad$var$ED25519_SQRT_M1, P); // Second root candidate
    const useRoot1 = vx2 === u; // If vx² = u (mod p), x is a square root
    const useRoot2 = vx2 === (0, $cJ5fp.mod)(-u, P); // If vx² = -u, set x <-- x * 2^((p-1)/4)
    const noRoot = vx2 === (0, $cJ5fp.mod)(-u * $a51020b120fefcad$var$ED25519_SQRT_M1, P); // There is no valid root, vx² = -u√(-1)
    if (useRoot1) x = root1;
    if (useRoot2 || noRoot) x = root2; // We return root2 anyway, for const-time
    if ((0, $cJ5fp.isNegativeLE)(x, P)) x = (0, $cJ5fp.mod)(-x, P);
    return {
        isValid: useRoot1 || useRoot2,
        value: x
    };
}
const $a51020b120fefcad$export$5ce3305f0d0b8e6f = [
    "0100000000000000000000000000000000000000000000000000000000000000",
    "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac037a",
    "0000000000000000000000000000000000000000000000000000000000000080",
    "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc05",
    "ecffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff7f",
    "26e8958fc2b227b045c3f489f2ef98f0d5dfac05d3c63339b13802886d53fc85",
    "0000000000000000000000000000000000000000000000000000000000000000",
    "c7176a703d4dd84fba3c0b760d10670f2a2053fa2c39ccc64ec7fd7792ac03fa"
];
const $a51020b120fefcad$var$Fp = (0, $cJ5fp.Field)($a51020b120fefcad$var$ED25519_P, undefined, true);
const $a51020b120fefcad$var$ed25519Defaults = {
    // Param: a
    a: BigInt(-1),
    // d is equal to -121665/121666 over finite field.
    // Negative number is P - number, and division is invert(number, P)
    d: BigInt("37095705934669439343138083508754565189542113879843219016388785533085940283555"),
    Fp: // Finite field 𝔽p over which we'll do calculations; 2n**255n - 19n
    $a51020b120fefcad$var$Fp,
    // Subgroup order: how many points curve has
    // 2n**252n + 27742317777372353535851937790883648493n;
    n: BigInt("7237005577332262213973186563042994240857116359379907606001950938285454250989"),
    // Cofactor
    h: BigInt(8),
    // Base point (x, y) aka generator point
    Gx: BigInt("15112221349535400772501151409588531511454012693041857206046113283949847762202"),
    Gy: BigInt("46316835694926478169428394003475163141307993866256225615783033603165251855960"),
    hash: (0, $031f498723becf63$export$a888d2532e6dc7bb),
    randomBytes: $ade6911eb19cf62a$export$5f828d93ff035aa8,
    adjustScalarBytes: $a51020b120fefcad$var$adjustScalarBytes,
    uvRatio: // dom2
    // Ratio of u to v. Allows us to combine inversion and square root. Uses algo from RFC8032 5.1.3.
    // Constant-time, u/√v
    $a51020b120fefcad$var$uvRatio
};
const $a51020b120fefcad$export$f63794f4a09a19c1 = /* @__PURE__ */ (0, $0d7ebb81be3b4204$export$f0c1eee63ea541eb)($a51020b120fefcad$var$ed25519Defaults);
function $a51020b120fefcad$var$ed25519_domain(data, ctx, phflag) {
    if (ctx.length > 255) throw new Error("Context is too big");
    return (0, $ade6911eb19cf62a$export$287dd7971339c972)((0, $ade6911eb19cf62a$export$3df70a15530b5e81)("SigEd25519 no Ed25519 collisions"), new Uint8Array([
        phflag ? 1 : 0,
        ctx.length
    ]), ctx, data);
}
const $a51020b120fefcad$export$1bc11da7986b0196 = /* @__PURE__ */ (0, $0d7ebb81be3b4204$export$f0c1eee63ea541eb)({
    ...$a51020b120fefcad$var$ed25519Defaults,
    domain: $a51020b120fefcad$var$ed25519_domain
});
const $a51020b120fefcad$export$473acbb6f701cbb6 = /* @__PURE__ */ (0, $0d7ebb81be3b4204$export$f0c1eee63ea541eb)({
    ...$a51020b120fefcad$var$ed25519Defaults,
    domain: $a51020b120fefcad$var$ed25519_domain,
    prehash: (0, $031f498723becf63$export$a888d2532e6dc7bb)
});
const $a51020b120fefcad$export$dab9625394da700 = /* @__PURE__ */ (()=>(0, $7f42568f330de1fa$export$bdbee0d01bf914a7)({
        P: $a51020b120fefcad$var$ED25519_P,
        a: BigInt(486662),
        montgomeryBits: 255,
        nByteLength: 32,
        Gu: BigInt(9),
        powPminus2: (x)=>{
            const P = $a51020b120fefcad$var$ED25519_P;
            // x^(p-2) aka x^(2^255-21)
            const { pow_p_5_8: pow_p_5_8, b2: b2 } = $a51020b120fefcad$var$ed25519_pow_2_252_3(x);
            return (0, $cJ5fp.mod)((0, $cJ5fp.pow2)(pow_p_5_8, BigInt(3), P) * b2, P);
        },
        adjustScalarBytes: $a51020b120fefcad$var$adjustScalarBytes,
        randomBytes: $ade6911eb19cf62a$export$5f828d93ff035aa8
    }))();
function $a51020b120fefcad$export$78609ae56f1edf04(edwardsPub) {
    const { y: y } = $a51020b120fefcad$export$f63794f4a09a19c1.ExtendedPoint.fromHex(edwardsPub);
    const _1n = BigInt(1);
    return $a51020b120fefcad$var$Fp.toBytes($a51020b120fefcad$var$Fp.create((_1n + y) * $a51020b120fefcad$var$Fp.inv(_1n - y)));
}
const $a51020b120fefcad$export$84bc39a6e4664b07 = $a51020b120fefcad$export$78609ae56f1edf04; // deprecated
function $a51020b120fefcad$export$c32b0f86cebbdf19(edwardsPriv) {
    const hashed = $a51020b120fefcad$var$ed25519Defaults.hash(edwardsPriv.subarray(0, 32));
    return $a51020b120fefcad$var$ed25519Defaults.adjustScalarBytes(hashed).subarray(0, 32);
}
// Hash To Curve Elligator2 Map (NOTE: different from ristretto255 elligator)
// NOTE: very important part is usage of FpSqrtEven for ELL2_C1_EDWARDS, since
// SageMath returns different root first and everything falls apart
const $a51020b120fefcad$var$ELL2_C1 = ($a51020b120fefcad$var$Fp.ORDER + BigInt(3)) / BigInt(8); // 1. c1 = (q + 3) / 8       # Integer arithmetic
const $a51020b120fefcad$var$ELL2_C2 = $a51020b120fefcad$var$Fp.pow($a51020b120fefcad$var$_2n, $a51020b120fefcad$var$ELL2_C1); // 2. c2 = 2^c1
const $a51020b120fefcad$var$ELL2_C3 = $a51020b120fefcad$var$Fp.sqrt($a51020b120fefcad$var$Fp.neg($a51020b120fefcad$var$Fp.ONE)); // 3. c3 = sqrt(-1)
const $a51020b120fefcad$var$ELL2_C4 = ($a51020b120fefcad$var$Fp.ORDER - BigInt(5)) / BigInt(8); // 4. c4 = (q - 5) / 8       # Integer arithmetic
const $a51020b120fefcad$var$ELL2_J = BigInt(486662);
// prettier-ignore
function $a51020b120fefcad$var$map_to_curve_elligator2_curve25519(u) {
    let tv1 = $a51020b120fefcad$var$Fp.sqr(u); //  1.  tv1 = u^2
    tv1 = $a51020b120fefcad$var$Fp.mul(tv1, $a51020b120fefcad$var$_2n); //  2.  tv1 = 2 * tv1
    let xd = $a51020b120fefcad$var$Fp.add(tv1, $a51020b120fefcad$var$Fp.ONE); //  3.   xd = tv1 + 1         # Nonzero: -1 is square (mod p), tv1 is not
    let x1n = $a51020b120fefcad$var$Fp.neg($a51020b120fefcad$var$ELL2_J); //  4.  x1n = -J              # x1 = x1n / xd = -J / (1 + 2 * u^2)
    let tv2 = $a51020b120fefcad$var$Fp.sqr(xd); //  5.  tv2 = xd^2
    let gxd = $a51020b120fefcad$var$Fp.mul(tv2, xd); //  6.  gxd = tv2 * xd        # gxd = xd^3
    let gx1 = $a51020b120fefcad$var$Fp.mul(tv1, $a51020b120fefcad$var$ELL2_J); //  7.  gx1 = J * tv1         # x1n + J * xd
    gx1 = $a51020b120fefcad$var$Fp.mul(gx1, x1n); //  8.  gx1 = gx1 * x1n       # x1n^2 + J * x1n * xd
    gx1 = $a51020b120fefcad$var$Fp.add(gx1, tv2); //  9.  gx1 = gx1 + tv2       # x1n^2 + J * x1n * xd + xd^2
    gx1 = $a51020b120fefcad$var$Fp.mul(gx1, x1n); //  10. gx1 = gx1 * x1n       # x1n^3 + J * x1n^2 * xd + x1n * xd^2
    let tv3 = $a51020b120fefcad$var$Fp.sqr(gxd); //  11. tv3 = gxd^2
    tv2 = $a51020b120fefcad$var$Fp.sqr(tv3); //  12. tv2 = tv3^2           # gxd^4
    tv3 = $a51020b120fefcad$var$Fp.mul(tv3, gxd); //  13. tv3 = tv3 * gxd       # gxd^3
    tv3 = $a51020b120fefcad$var$Fp.mul(tv3, gx1); //  14. tv3 = tv3 * gx1       # gx1 * gxd^3
    tv2 = $a51020b120fefcad$var$Fp.mul(tv2, tv3); //  15. tv2 = tv2 * tv3       # gx1 * gxd^7
    let y11 = $a51020b120fefcad$var$Fp.pow(tv2, $a51020b120fefcad$var$ELL2_C4); //  16. y11 = tv2^c4        # (gx1 * gxd^7)^((p - 5) / 8)
    y11 = $a51020b120fefcad$var$Fp.mul(y11, tv3); //  17. y11 = y11 * tv3       # gx1*gxd^3*(gx1*gxd^7)^((p-5)/8)
    let y12 = $a51020b120fefcad$var$Fp.mul(y11, $a51020b120fefcad$var$ELL2_C3); //  18. y12 = y11 * c3
    tv2 = $a51020b120fefcad$var$Fp.sqr(y11); //  19. tv2 = y11^2
    tv2 = $a51020b120fefcad$var$Fp.mul(tv2, gxd); //  20. tv2 = tv2 * gxd
    let e1 = $a51020b120fefcad$var$Fp.eql(tv2, gx1); //  21.  e1 = tv2 == gx1
    let y1 = $a51020b120fefcad$var$Fp.cmov(y12, y11, e1); //  22.  y1 = CMOV(y12, y11, e1)  # If g(x1) is square, this is its sqrt
    let x2n = $a51020b120fefcad$var$Fp.mul(x1n, tv1); //  23. x2n = x1n * tv1       # x2 = x2n / xd = 2 * u^2 * x1n / xd
    let y21 = $a51020b120fefcad$var$Fp.mul(y11, u); //  24. y21 = y11 * u
    y21 = $a51020b120fefcad$var$Fp.mul(y21, $a51020b120fefcad$var$ELL2_C2); //  25. y21 = y21 * c2
    let y22 = $a51020b120fefcad$var$Fp.mul(y21, $a51020b120fefcad$var$ELL2_C3); //  26. y22 = y21 * c3
    let gx2 = $a51020b120fefcad$var$Fp.mul(gx1, tv1); //  27. gx2 = gx1 * tv1       # g(x2) = gx2 / gxd = 2 * u^2 * g(x1)
    tv2 = $a51020b120fefcad$var$Fp.sqr(y21); //  28. tv2 = y21^2
    tv2 = $a51020b120fefcad$var$Fp.mul(tv2, gxd); //  29. tv2 = tv2 * gxd
    let e2 = $a51020b120fefcad$var$Fp.eql(tv2, gx2); //  30.  e2 = tv2 == gx2
    let y2 = $a51020b120fefcad$var$Fp.cmov(y22, y21, e2); //  31.  y2 = CMOV(y22, y21, e2)  # If g(x2) is square, this is its sqrt
    tv2 = $a51020b120fefcad$var$Fp.sqr(y1); //  32. tv2 = y1^2
    tv2 = $a51020b120fefcad$var$Fp.mul(tv2, gxd); //  33. tv2 = tv2 * gxd
    let e3 = $a51020b120fefcad$var$Fp.eql(tv2, gx1); //  34.  e3 = tv2 == gx1
    let xn = $a51020b120fefcad$var$Fp.cmov(x2n, x1n, e3); //  35.  xn = CMOV(x2n, x1n, e3)  # If e3, x = x1, else x = x2
    let y = $a51020b120fefcad$var$Fp.cmov(y2, y1, e3); //  36.   y = CMOV(y2, y1, e3)    # If e3, y = y1, else y = y2
    let e4 = $a51020b120fefcad$var$Fp.isOdd(y); //  37.  e4 = sgn0(y) == 1        # Fix sign of y
    y = $a51020b120fefcad$var$Fp.cmov(y, $a51020b120fefcad$var$Fp.neg(y), e3 !== e4); //  38.   y = CMOV(y, -y, e3 XOR e4)
    return {
        xMn: xn,
        xMd: xd,
        yMn: y,
        yMd: $a51020b120fefcad$var$_1n
    }; //  39. return (xn, xd, y, 1)
}
const $a51020b120fefcad$var$ELL2_C1_EDWARDS = (0, $cJ5fp.FpSqrtEven)($a51020b120fefcad$var$Fp, $a51020b120fefcad$var$Fp.neg(BigInt(486664))); // sgn0(c1) MUST equal 0
function $a51020b120fefcad$var$map_to_curve_elligator2_edwards25519(u) {
    const { xMn: xMn, xMd: xMd, yMn: yMn, yMd: yMd } = $a51020b120fefcad$var$map_to_curve_elligator2_curve25519(u); //  1.  (xMn, xMd, yMn, yMd) =
    // map_to_curve_elligator2_curve25519(u)
    let xn = $a51020b120fefcad$var$Fp.mul(xMn, yMd); //  2.  xn = xMn * yMd
    xn = $a51020b120fefcad$var$Fp.mul(xn, $a51020b120fefcad$var$ELL2_C1_EDWARDS); //  3.  xn = xn * c1
    let xd = $a51020b120fefcad$var$Fp.mul(xMd, yMn); //  4.  xd = xMd * yMn    # xn / xd = c1 * xM / yM
    let yn = $a51020b120fefcad$var$Fp.sub(xMn, xMd); //  5.  yn = xMn - xMd
    let yd = $a51020b120fefcad$var$Fp.add(xMn, xMd); //  6.  yd = xMn + xMd    # (n / d - 1) / (n / d + 1) = (n - d) / (n + d)
    let tv1 = $a51020b120fefcad$var$Fp.mul(xd, yd); //  7. tv1 = xd * yd
    let e = $a51020b120fefcad$var$Fp.eql(tv1, $a51020b120fefcad$var$Fp.ZERO); //  8.   e = tv1 == 0
    xn = $a51020b120fefcad$var$Fp.cmov(xn, $a51020b120fefcad$var$Fp.ZERO, e); //  9.  xn = CMOV(xn, 0, e)
    xd = $a51020b120fefcad$var$Fp.cmov(xd, $a51020b120fefcad$var$Fp.ONE, e); //  10. xd = CMOV(xd, 1, e)
    yn = $a51020b120fefcad$var$Fp.cmov(yn, $a51020b120fefcad$var$Fp.ONE, e); //  11. yn = CMOV(yn, 1, e)
    yd = $a51020b120fefcad$var$Fp.cmov(yd, $a51020b120fefcad$var$Fp.ONE, e); //  12. yd = CMOV(yd, 1, e)
    const inv = $a51020b120fefcad$var$Fp.invertBatch([
        xd,
        yd
    ]); // batch division
    return {
        x: $a51020b120fefcad$var$Fp.mul(xn, inv[0]),
        y: $a51020b120fefcad$var$Fp.mul(yn, inv[1])
    }; //  13. return (xn, xd, yn, yd)
}
const $a51020b120fefcad$var$htf = /* @__PURE__ */ (()=>(0, $d1e2a0e29d07a139$export$14b114effbc08b6b)($a51020b120fefcad$export$f63794f4a09a19c1.ExtendedPoint, (scalars)=>$a51020b120fefcad$var$map_to_curve_elligator2_edwards25519(scalars[0]), {
        DST: "edwards25519_XMD:SHA-512_ELL2_RO_",
        encodeDST: "edwards25519_XMD:SHA-512_ELL2_NU_",
        p: $a51020b120fefcad$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: (0, $031f498723becf63$export$a888d2532e6dc7bb)
    }))();
const $a51020b120fefcad$export$a95cc2b0cdb9c1e1 = /* @__PURE__ */ (()=>$a51020b120fefcad$var$htf.hashToCurve)();
const $a51020b120fefcad$export$124e820e7679cc3 = /* @__PURE__ */ (()=>$a51020b120fefcad$var$htf.encodeToCurve)();
function $a51020b120fefcad$var$assertRstPoint(other) {
    if (!(other instanceof $a51020b120fefcad$var$RistPoint)) throw new Error("RistrettoPoint expected");
}
// √(-1) aka √(a) aka 2^((p-1)/4)
const $a51020b120fefcad$var$SQRT_M1 = $a51020b120fefcad$var$ED25519_SQRT_M1;
// √(ad - 1)
const $a51020b120fefcad$var$SQRT_AD_MINUS_ONE = BigInt("25063068953384623474111414158702152701244531502492656460079210482610430750235");
// 1 / √(a-d)
const $a51020b120fefcad$var$INVSQRT_A_MINUS_D = BigInt("54469307008909316920995813868745141605393597292927456921205312896311721017578");
// 1-d²
const $a51020b120fefcad$var$ONE_MINUS_D_SQ = BigInt("1159843021668779879193775521855586647937357759715417654439879720876111806838");
// (d-1)²
const $a51020b120fefcad$var$D_MINUS_ONE_SQ = BigInt("40440834346308536858101042469323190826248399146238708352240133220865137265952");
// Calculates 1/√(number)
const $a51020b120fefcad$var$invertSqrt = (number)=>$a51020b120fefcad$var$uvRatio($a51020b120fefcad$var$_1n, number);
const $a51020b120fefcad$var$MAX_255B = BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $a51020b120fefcad$var$bytes255ToNumberLE = (bytes)=>$a51020b120fefcad$export$f63794f4a09a19c1.CURVE.Fp.create((0, $5hs45.bytesToNumberLE)(bytes) & $a51020b120fefcad$var$MAX_255B);
// Computes Elligator map for Ristretto
// https://ristretto.group/formulas/elligator.html
function $a51020b120fefcad$var$calcElligatorRistrettoMap(r0) {
    const { d: d } = $a51020b120fefcad$export$f63794f4a09a19c1.CURVE;
    const P = $a51020b120fefcad$export$f63794f4a09a19c1.CURVE.Fp.ORDER;
    const mod = $a51020b120fefcad$export$f63794f4a09a19c1.CURVE.Fp.create;
    const r = mod($a51020b120fefcad$var$SQRT_M1 * r0 * r0); // 1
    const Ns = mod((r + $a51020b120fefcad$var$_1n) * $a51020b120fefcad$var$ONE_MINUS_D_SQ); // 2
    let c = BigInt(-1); // 3
    const D = mod((c - d * r) * mod(r + d)); // 4
    let { isValid: Ns_D_is_sq, value: s } = $a51020b120fefcad$var$uvRatio(Ns, D); // 5
    let s_ = mod(s * r0); // 6
    if (!(0, $cJ5fp.isNegativeLE)(s_, P)) s_ = mod(-s_);
    if (!Ns_D_is_sq) s = s_; // 7
    if (!Ns_D_is_sq) c = r; // 8
    const Nt = mod(c * (r - $a51020b120fefcad$var$_1n) * $a51020b120fefcad$var$D_MINUS_ONE_SQ - D); // 9
    const s2 = s * s;
    const W0 = mod((s + s) * D); // 10
    const W1 = mod(Nt * $a51020b120fefcad$var$SQRT_AD_MINUS_ONE); // 11
    const W2 = mod($a51020b120fefcad$var$_1n - s2); // 12
    const W3 = mod($a51020b120fefcad$var$_1n + s2); // 13
    return new $a51020b120fefcad$export$f63794f4a09a19c1.ExtendedPoint(mod(W0 * W3), mod(W2 * W1), mod(W1 * W3), mod(W0 * W2));
}
/**
 * Each ed25519/ExtendedPoint has 8 different equivalent points. This can be
 * a source of bugs for protocols like ring signatures. Ristretto was created to solve this.
 * Ristretto point operates in X:Y:Z:T extended coordinates like ExtendedPoint,
 * but it should work in its own namespace: do not combine those two.
 * https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-ristretto255-decaf448
 */ class $a51020b120fefcad$var$RistPoint {
    // Private property to discourage combining ExtendedPoint + RistrettoPoint
    // Always use Ristretto encoding/decoding instead.
    constructor(ep){
        this.ep = ep;
    }
    static fromAffine(ap) {
        return new $a51020b120fefcad$var$RistPoint($a51020b120fefcad$export$f63794f4a09a19c1.ExtendedPoint.fromAffine(ap));
    }
    /**
     * Takes uniform output of 64-byte hash function like sha512 and converts it to `RistrettoPoint`.
     * The hash-to-group operation applies Elligator twice and adds the results.
     * **Note:** this is one-way map, there is no conversion from point to hash.
     * https://ristretto.group/formulas/elligator.html
     * @param hex 64-byte output of a hash function
     */ static hashToCurve(hex) {
        hex = (0, $5hs45.ensureBytes)("ristrettoHash", hex, 64);
        const r1 = $a51020b120fefcad$var$bytes255ToNumberLE(hex.slice(0, 32));
        const R1 = $a51020b120fefcad$var$calcElligatorRistrettoMap(r1);
        const r2 = $a51020b120fefcad$var$bytes255ToNumberLE(hex.slice(32, 64));
        const R2 = $a51020b120fefcad$var$calcElligatorRistrettoMap(r2);
        return new $a51020b120fefcad$var$RistPoint(R1.add(R2));
    }
    /**
     * Converts ristretto-encoded string to ristretto point.
     * https://ristretto.group/formulas/decoding.html
     * @param hex Ristretto-encoded 32 bytes. Not every 32-byte string is valid ristretto encoding
     */ static fromHex(hex) {
        hex = (0, $5hs45.ensureBytes)("ristrettoHex", hex, 32);
        const { a: a, d: d } = $a51020b120fefcad$export$f63794f4a09a19c1.CURVE;
        const P = $a51020b120fefcad$export$f63794f4a09a19c1.CURVE.Fp.ORDER;
        const mod = $a51020b120fefcad$export$f63794f4a09a19c1.CURVE.Fp.create;
        const emsg = "RistrettoPoint.fromHex: the hex is not valid encoding of RistrettoPoint";
        const s = $a51020b120fefcad$var$bytes255ToNumberLE(hex);
        // 1. Check that s_bytes is the canonical encoding of a field element, or else abort.
        // 3. Check that s is non-negative, or else abort
        if (!(0, $5hs45.equalBytes)((0, $5hs45.numberToBytesLE)(s, 32), hex) || (0, $cJ5fp.isNegativeLE)(s, P)) throw new Error(emsg);
        const s2 = mod(s * s);
        const u1 = mod($a51020b120fefcad$var$_1n + a * s2); // 4 (a is -1)
        const u2 = mod($a51020b120fefcad$var$_1n - a * s2); // 5
        const u1_2 = mod(u1 * u1);
        const u2_2 = mod(u2 * u2);
        const v = mod(a * d * u1_2 - u2_2); // 6
        const { isValid: isValid, value: I } = $a51020b120fefcad$var$invertSqrt(mod(v * u2_2)); // 7
        const Dx = mod(I * u2); // 8
        const Dy = mod(I * Dx * v); // 9
        let x = mod((s + s) * Dx); // 10
        if ((0, $cJ5fp.isNegativeLE)(x, P)) x = mod(-x); // 10
        const y = mod(u1 * Dy); // 11
        const t = mod(x * y); // 12
        if (!isValid || (0, $cJ5fp.isNegativeLE)(t, P) || y === $a51020b120fefcad$var$_0n) throw new Error(emsg);
        return new $a51020b120fefcad$var$RistPoint(new $a51020b120fefcad$export$f63794f4a09a19c1.ExtendedPoint(x, y, $a51020b120fefcad$var$_1n, t));
    }
    /**
     * Encodes ristretto point to Uint8Array.
     * https://ristretto.group/formulas/encoding.html
     */ toRawBytes() {
        let { ex: x, ey: y, ez: z, et: t } = this.ep;
        const P = $a51020b120fefcad$export$f63794f4a09a19c1.CURVE.Fp.ORDER;
        const mod = $a51020b120fefcad$export$f63794f4a09a19c1.CURVE.Fp.create;
        const u1 = mod(mod(z + y) * mod(z - y)); // 1
        const u2 = mod(x * y); // 2
        // Square root always exists
        const u2sq = mod(u2 * u2);
        const { value: invsqrt } = $a51020b120fefcad$var$invertSqrt(mod(u1 * u2sq)); // 3
        const D1 = mod(invsqrt * u1); // 4
        const D2 = mod(invsqrt * u2); // 5
        const zInv = mod(D1 * D2 * t); // 6
        let D; // 7
        if ((0, $cJ5fp.isNegativeLE)(t * zInv, P)) {
            let _x = mod(y * $a51020b120fefcad$var$SQRT_M1);
            let _y = mod(x * $a51020b120fefcad$var$SQRT_M1);
            x = _x;
            y = _y;
            D = mod(D1 * $a51020b120fefcad$var$INVSQRT_A_MINUS_D);
        } else D = D2; // 8
        if ((0, $cJ5fp.isNegativeLE)(x * zInv, P)) y = mod(-y); // 9
        let s = mod((z - y) * D); // 10 (check footer's note, no sqrt(-a))
        if ((0, $cJ5fp.isNegativeLE)(s, P)) s = mod(-s);
        return (0, $5hs45.numberToBytesLE)(s, 32); // 11
    }
    toHex() {
        return (0, $5hs45.bytesToHex)(this.toRawBytes());
    }
    toString() {
        return this.toHex();
    }
    // Compare one point to another.
    equals(other) {
        $a51020b120fefcad$var$assertRstPoint(other);
        const { ex: X1, ey: Y1 } = this.ep;
        const { ex: X2, ey: Y2 } = other.ep;
        const mod = $a51020b120fefcad$export$f63794f4a09a19c1.CURVE.Fp.create;
        // (x1 * y2 == y1 * x2) | (y1 * y2 == x1 * x2)
        const one = mod(X1 * Y2) === mod(Y1 * X2);
        const two = mod(Y1 * Y2) === mod(X1 * X2);
        return one || two;
    }
    add(other) {
        $a51020b120fefcad$var$assertRstPoint(other);
        return new $a51020b120fefcad$var$RistPoint(this.ep.add(other.ep));
    }
    subtract(other) {
        $a51020b120fefcad$var$assertRstPoint(other);
        return new $a51020b120fefcad$var$RistPoint(this.ep.subtract(other.ep));
    }
    multiply(scalar) {
        return new $a51020b120fefcad$var$RistPoint(this.ep.multiply(scalar));
    }
    multiplyUnsafe(scalar) {
        return new $a51020b120fefcad$var$RistPoint(this.ep.multiplyUnsafe(scalar));
    }
    double() {
        return new $a51020b120fefcad$var$RistPoint(this.ep.double());
    }
    negate() {
        return new $a51020b120fefcad$var$RistPoint(this.ep.negate());
    }
}
const $a51020b120fefcad$export$5e87c4f36f27816d = /* @__PURE__ */ (()=>{
    if (!$a51020b120fefcad$var$RistPoint.BASE) $a51020b120fefcad$var$RistPoint.BASE = new $a51020b120fefcad$var$RistPoint($a51020b120fefcad$export$f63794f4a09a19c1.ExtendedPoint.BASE);
    if (!$a51020b120fefcad$var$RistPoint.ZERO) $a51020b120fefcad$var$RistPoint.ZERO = new $a51020b120fefcad$var$RistPoint($a51020b120fefcad$export$f63794f4a09a19c1.ExtendedPoint.ZERO);
    return $a51020b120fefcad$var$RistPoint;
})();
const $a51020b120fefcad$export$c9ad4c0d917ad3 = (msg, options)=>{
    const d = options.DST;
    const DST = typeof d === "string" ? (0, $ade6911eb19cf62a$export$3df70a15530b5e81)(d) : d;
    const uniform_bytes = (0, $d1e2a0e29d07a139$export$3df78c69af9fc85d)(msg, DST, 64, (0, $031f498723becf63$export$a888d2532e6dc7bb));
    const P = $a51020b120fefcad$var$RistPoint.hashToCurve(uniform_bytes);
    return P;
};
const $a51020b120fefcad$export$667ef88de7a83a7f = $a51020b120fefcad$export$c9ad4c0d917ad3; // legacy


/**
 * @internal
 *
 * Efficiently compare {@link Indexed} arrays (e.g. `Array` and `Uint8Array`).
 *
 * @param a An array.
 * @param b Another array.
 *
 * @return `true` if the arrays have the same length and elements, `false` otherwise.
 *
 * @group Internal
 */ function $322796e913a56267$export$234180f8206db11b(a, b) {
    if (a === b) return true;
    const length = a.length;
    if (length !== b.length) return false;
    for(let i = 0; i < length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $322796e913a56267$export$c663ab80cce302c5(a, b) {
    return $322796e913a56267$export$234180f8206db11b(a, b);
}


function $aeec6f315d20fbd7$export$54b8e79a8f938f52({ message: message, signedMessage: signedMessage, signature: signature, publicKey: publicKey }) {
    // TODO: implement https://github.com/solana-labs/solana/blob/master/docs/src/proposals/off-chain-message-signing.md
    return (0, $322796e913a56267$export$c663ab80cce302c5)(message, signedMessage) && (0, $a51020b120fefcad$export$f63794f4a09a19c1).verify(signature, signedMessage, publicKey);
}
function $aeec6f315d20fbd7$export$a7a8e868ceb02186(input, output) {
    const { message: message, account: { publicKey: publicKey } } = input;
    const { signedMessage: signedMessage, signature: signature } = output;
    return $aeec6f315d20fbd7$export$54b8e79a8f938f52({
        message: message,
        signedMessage: signedMessage,
        signature: signature,
        publicKey: publicKey
    });
}



function $325d35fe3637f8d5$export$9828dc452d20db63(input, output) {
    const { signedMessage: signedMessage, signature: signature, account: { publicKey: publicKey } } = output;
    const message = $325d35fe3637f8d5$export$5a98156f426eafe8(input, output);
    return !!message && (0, $aeec6f315d20fbd7$export$54b8e79a8f938f52)({
        message: message,
        signedMessage: signedMessage,
        signature: signature,
        publicKey: publicKey
    });
}
function $325d35fe3637f8d5$export$5a98156f426eafe8(input, output) {
    const text = $325d35fe3637f8d5$export$14d5fbb279d179c2(input, output);
    if (!text) return null;
    return new TextEncoder().encode(text);
}
function $325d35fe3637f8d5$export$14d5fbb279d179c2(input, output) {
    const parsed = $325d35fe3637f8d5$export$ddde1a7f6f94bd0a(output.signedMessage);
    if (!parsed) return null;
    if (input.domain && input.domain !== parsed.domain) return null;
    if (input.address && input.address !== parsed.address) return null;
    if (input.statement !== parsed.statement) return null;
    if (input.uri !== parsed.uri) return null;
    if (input.version !== parsed.version) return null;
    if (input.chainId !== parsed.chainId) return null;
    if (input.nonce !== parsed.nonce) return null;
    if (input.issuedAt !== parsed.issuedAt) return null;
    if (input.expirationTime !== parsed.expirationTime) return null;
    if (input.notBefore !== parsed.notBefore) return null;
    if (input.requestId !== parsed.requestId) return null;
    if (input.resources) {
        if (!parsed.resources) return null;
        if (!(0, $322796e913a56267$export$234180f8206db11b)(input.resources, parsed.resources)) return null;
    } else if (parsed.resources) return null;
    return $325d35fe3637f8d5$export$88aceda9565b68d2(parsed);
}
function $325d35fe3637f8d5$export$ddde1a7f6f94bd0a(message) {
    const text = new TextDecoder().decode(message);
    return $325d35fe3637f8d5$export$4a112f3ad8ba8e50(text);
}
// TODO: implement https://github.com/solana-labs/solana/blob/master/docs/src/proposals/off-chain-message-signing.md
const $325d35fe3637f8d5$var$DOMAIN = "(?<domain>[^\\n]+?) wants you to sign in with your Solana account:\\n";
const $325d35fe3637f8d5$var$ADDRESS = "(?<address>[^\\n]+)(?:\\n|$)";
const $325d35fe3637f8d5$var$STATEMENT = "(?:\\n(?<statement>[\\S\\s]*?)(?:\\n|$))??";
const $325d35fe3637f8d5$var$URI = "(?:\\nURI: (?<uri>[^\\n]+))?";
const $325d35fe3637f8d5$var$VERSION = "(?:\\nVersion: (?<version>[^\\n]+))?";
const $325d35fe3637f8d5$var$CHAIN_ID = "(?:\\nChain ID: (?<chainId>[^\\n]+))?";
const $325d35fe3637f8d5$var$NONCE = "(?:\\nNonce: (?<nonce>[^\\n]+))?";
const $325d35fe3637f8d5$var$ISSUED_AT = "(?:\\nIssued At: (?<issuedAt>[^\\n]+))?";
const $325d35fe3637f8d5$var$EXPIRATION_TIME = "(?:\\nExpiration Time: (?<expirationTime>[^\\n]+))?";
const $325d35fe3637f8d5$var$NOT_BEFORE = "(?:\\nNot Before: (?<notBefore>[^\\n]+))?";
const $325d35fe3637f8d5$var$REQUEST_ID = "(?:\\nRequest ID: (?<requestId>[^\\n]+))?";
const $325d35fe3637f8d5$var$RESOURCES = "(?:\\nResources:(?<resources>(?:\\n- [^\\n]+)*))?";
const $325d35fe3637f8d5$var$FIELDS = `${$325d35fe3637f8d5$var$URI}${$325d35fe3637f8d5$var$VERSION}${$325d35fe3637f8d5$var$CHAIN_ID}${$325d35fe3637f8d5$var$NONCE}${$325d35fe3637f8d5$var$ISSUED_AT}${$325d35fe3637f8d5$var$EXPIRATION_TIME}${$325d35fe3637f8d5$var$NOT_BEFORE}${$325d35fe3637f8d5$var$REQUEST_ID}${$325d35fe3637f8d5$var$RESOURCES}`;
const $325d35fe3637f8d5$var$MESSAGE = new RegExp(`^${$325d35fe3637f8d5$var$DOMAIN}${$325d35fe3637f8d5$var$ADDRESS}${$325d35fe3637f8d5$var$STATEMENT}${$325d35fe3637f8d5$var$FIELDS}\\n*$`);
function $325d35fe3637f8d5$export$4a112f3ad8ba8e50(text) {
    const match = $325d35fe3637f8d5$var$MESSAGE.exec(text);
    if (!match) return null;
    const groups = match.groups;
    if (!groups) return null;
    return {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        domain: groups.domain,
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        address: groups.address,
        statement: groups.statement,
        uri: groups.uri,
        version: groups.version,
        nonce: groups.nonce,
        chainId: groups.chainId,
        issuedAt: groups.issuedAt,
        expirationTime: groups.expirationTime,
        notBefore: groups.notBefore,
        requestId: groups.requestId,
        resources: groups.resources?.split("\n- ").slice(1)
    };
}
function $325d35fe3637f8d5$export$92ddcd466ce9e7c4(input) {
    const text = $325d35fe3637f8d5$export$88aceda9565b68d2(input);
    return new TextEncoder().encode(text);
}
function $325d35fe3637f8d5$export$88aceda9565b68d2(input) {
    // ${domain} wants you to sign in with your Solana account:
    // ${address}
    //
    // ${statement}
    //
    // URI: ${uri}
    // Version: ${version}
    // Chain ID: ${chain}
    // Nonce: ${nonce}
    // Issued At: ${issued-at}
    // Expiration Time: ${expiration-time}
    // Not Before: ${not-before}
    // Request ID: ${request-id}
    // Resources:
    // - ${resources[0]}
    // - ${resources[1]}
    // ...
    // - ${resources[n]}
    let message = `${input.domain} wants you to sign in with your Solana account:\n`;
    message += `${input.address}`;
    if (input.statement) message += `\n\n${input.statement}`;
    const fields = [];
    if (input.uri) fields.push(`URI: ${input.uri}`);
    if (input.version) fields.push(`Version: ${input.version}`);
    if (input.chainId) fields.push(`Chain ID: ${input.chainId}`);
    if (input.nonce) fields.push(`Nonce: ${input.nonce}`);
    if (input.issuedAt) fields.push(`Issued At: ${input.issuedAt}`);
    if (input.expirationTime) fields.push(`Expiration Time: ${input.expirationTime}`);
    if (input.notBefore) fields.push(`Not Before: ${input.notBefore}`);
    if (input.requestId) fields.push(`Request ID: ${input.requestId}`);
    if (input.resources) {
        fields.push(`Resources:`);
        for (const resource of input.resources)fields.push(`- ${resource}`);
    }
    if (fields.length) message += `\n\n${fields.join("\n")}`;
    return message;
}


// Typescript `enums` thwart tree-shaking. See https://bargsten.org/jsts/enums/
const $c0abf786dbde3e8b$export$93083e877aec7a8a = {
    ERROR_ASSOCIATION_PORT_OUT_OF_RANGE: "ERROR_ASSOCIATION_PORT_OUT_OF_RANGE",
    ERROR_FORBIDDEN_WALLET_BASE_URL: "ERROR_FORBIDDEN_WALLET_BASE_URL",
    ERROR_SECURE_CONTEXT_REQUIRED: "ERROR_SECURE_CONTEXT_REQUIRED",
    ERROR_SESSION_CLOSED: "ERROR_SESSION_CLOSED",
    ERROR_SESSION_TIMEOUT: "ERROR_SESSION_TIMEOUT",
    ERROR_WALLET_NOT_FOUND: "ERROR_WALLET_NOT_FOUND",
    ERROR_INVALID_PROTOCOL_VERSION: "ERROR_INVALID_PROTOCOL_VERSION"
};
class $c0abf786dbde3e8b$export$d77545679c409b63 extends Error {
    constructor(...args){
        const [code, message, data] = args;
        super(message);
        this.code = code;
        this.data = data;
        this.name = "SolanaMobileWalletAdapterError";
    }
}
// Typescript `enums` thwart tree-shaking. See https://bargsten.org/jsts/enums/
const $c0abf786dbde3e8b$export$23d27841621bc1e8 = {
    // Keep these in sync with `mobilewalletadapter/common/ProtocolContract.java`.
    ERROR_AUTHORIZATION_FAILED: -1,
    ERROR_INVALID_PAYLOADS: -2,
    ERROR_NOT_SIGNED: -3,
    ERROR_NOT_SUBMITTED: -4,
    ERROR_TOO_MANY_PAYLOADS: -5,
    ERROR_ATTEST_ORIGIN_ANDROID: -100
};
class $c0abf786dbde3e8b$export$58b788f937123c66 extends Error {
    constructor(...args){
        const [jsonRpcMessageId, code, message, data] = args;
        super(message);
        this.code = code;
        this.data = data;
        this.jsonRpcMessageId = jsonRpcMessageId;
        this.name = "SolanaMobileWalletAdapterProtocolError";
    }
}
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $c0abf786dbde3e8b$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $c0abf786dbde3e8b$var$createHelloReq(ecdhPublicKey, associationKeypairPrivateKey) {
    return $c0abf786dbde3e8b$var$__awaiter(this, void 0, void 0, function*() {
        const publicKeyBuffer = yield crypto.subtle.exportKey("raw", ecdhPublicKey);
        const signatureBuffer = yield crypto.subtle.sign({
            hash: "SHA-256",
            name: "ECDSA"
        }, associationKeypairPrivateKey, publicKeyBuffer);
        const response = new Uint8Array(publicKeyBuffer.byteLength + signatureBuffer.byteLength);
        response.set(new Uint8Array(publicKeyBuffer), 0);
        response.set(new Uint8Array(signatureBuffer), publicKeyBuffer.byteLength);
        return response;
    });
}
function $c0abf786dbde3e8b$var$encode(input) {
    return window.btoa(input);
}
function $c0abf786dbde3e8b$var$createSIWSMessage(payload) {
    return (0, $325d35fe3637f8d5$export$88aceda9565b68d2)(payload);
}
function $c0abf786dbde3e8b$var$createSIWSMessageBase64(payload) {
    return $c0abf786dbde3e8b$var$encode($c0abf786dbde3e8b$var$createSIWSMessage(payload));
}
// optional features
const $c0abf786dbde3e8b$export$6d2aa8b15676f603 = "solana:signTransactions";
const $c0abf786dbde3e8b$export$7b8713ece485d770 = "solana:cloneAuthorization";
const $c0abf786dbde3e8b$export$fca2a421c519d7f8 = "solana:signInWithSolana";
/**
 * Creates a {@link MobileWallet} proxy that handles backwards compatibility and API to RPC conversion.
 *
 * @param protocolVersion the protocol version in use for this session/request
 * @param protocolRequestHandler callback function that handles sending the RPC request to the wallet endpoint.
 * @returns a {@link MobileWallet} proxy
 */ function $c0abf786dbde3e8b$var$createMobileWalletProxy(protocolVersion, protocolRequestHandler) {
    return new Proxy({}, {
        get (target, p) {
            if (target[p] == null) target[p] = function(inputParams) {
                return $c0abf786dbde3e8b$var$__awaiter(this, void 0, void 0, function*() {
                    const { method: method, params: params } = $c0abf786dbde3e8b$var$handleMobileWalletRequest(p, inputParams, protocolVersion);
                    const result = yield protocolRequestHandler(method, params);
                    // if the request tried to sign in but the wallet did not return a sign in result, fallback on message signing
                    if (method === "authorize" && params.sign_in_payload && !result.sign_in_result) result["sign_in_result"] = yield $c0abf786dbde3e8b$var$signInFallback(params.sign_in_payload, result, protocolRequestHandler);
                    return $c0abf786dbde3e8b$var$handleMobileWalletResponse(p, result, protocolVersion);
                });
            };
            return target[p];
        },
        defineProperty () {
            return false;
        },
        deleteProperty () {
            return false;
        }
    });
}
/**
 * Handles all {@link MobileWallet} API requests and determines the correct MWA RPC method and params to call.
 * This handles backwards compatibility, based on the provided @protocolVersion.
 *
 * @param methodName the name of {@link MobileWallet} method that was called
 * @param methodParams the parameters that were passed to the method
 * @param protocolVersion the protocol version in use for this session/request
 * @returns the RPC request method and params that should be sent to the wallet endpoint
 */ function $c0abf786dbde3e8b$var$handleMobileWalletRequest(methodName, methodParams, protocolVersion) {
    let params = methodParams;
    let method = methodName.toString().replace(/[A-Z]/g, (letter)=>`_${letter.toLowerCase()}`).toLowerCase();
    switch(methodName){
        case "authorize":
            {
                let { chain: chain } = params;
                if (protocolVersion === "legacy") {
                    switch(chain){
                        case "solana:testnet":
                            chain = "testnet";
                            break;
                        case "solana:devnet":
                            chain = "devnet";
                            break;
                        case "solana:mainnet":
                            chain = "mainnet-beta";
                            break;
                        default:
                            chain = params.cluster;
                    }
                    params.cluster = chain;
                } else {
                    switch(chain){
                        case "testnet":
                        case "devnet":
                            chain = `solana:${chain}`;
                            break;
                        case "mainnet-beta":
                            chain = "solana:mainnet";
                            break;
                    }
                    params.chain = chain;
                }
            }
        case "reauthorize":
            {
                const { auth_token: auth_token, identity: identity } = params;
                if (auth_token) switch(protocolVersion){
                    case "legacy":
                        method = "reauthorize";
                        params = {
                            auth_token: auth_token,
                            identity: identity
                        };
                        break;
                    default:
                        method = "authorize";
                        break;
                }
                break;
            }
    }
    return {
        method: method,
        params: params
    };
}
/**
 * Handles all {@link MobileWallet} API responses and modifies the response for backwards compatibility, if needed
 *
 * @param method the {@link MobileWallet} method that was called
 * @param response the original response that was returned by the method call
 * @param protocolVersion the protocol version in use for this session/request
 * @returns the possibly modified response
 */ function $c0abf786dbde3e8b$var$handleMobileWalletResponse(method, response, protocolVersion) {
    switch(method){
        case "getCapabilities":
            {
                const capabilities = response;
                switch(protocolVersion){
                    case "legacy":
                        {
                            const features = [
                                $c0abf786dbde3e8b$export$6d2aa8b15676f603
                            ];
                            if (capabilities.supports_clone_authorization === true) features.push($c0abf786dbde3e8b$export$7b8713ece485d770);
                            return Object.assign(Object.assign({}, capabilities), {
                                features: features
                            });
                        }
                    case "v1":
                        return Object.assign(Object.assign({}, capabilities), {
                            supports_sign_and_send_transactions: true,
                            supports_clone_authorization: capabilities.features.includes($c0abf786dbde3e8b$export$7b8713ece485d770)
                        });
                }
            }
    }
    return response;
}
function $c0abf786dbde3e8b$var$signInFallback(signInPayload, authorizationResult, protocolRequestHandler) {
    var _a;
    return $c0abf786dbde3e8b$var$__awaiter(this, void 0, void 0, function*() {
        const domain = (_a = signInPayload.domain) !== null && _a !== void 0 ? _a : window.location.host;
        const address = authorizationResult.accounts[0].address;
        const siwsMessage = $c0abf786dbde3e8b$var$createSIWSMessageBase64(Object.assign(Object.assign({}, signInPayload), {
            domain: domain,
            address: address
        }));
        const signMessageResult = yield protocolRequestHandler("sign_messages", {
            addresses: [
                address
            ],
            payloads: [
                siwsMessage
            ]
        });
        const signInResult = {
            address: address,
            signed_message: siwsMessage,
            signature: signMessageResult.signed_payloads[0].slice(siwsMessage.length)
        };
        return signInResult;
    });
}
const $c0abf786dbde3e8b$var$SEQUENCE_NUMBER_BYTES = 4;
function $c0abf786dbde3e8b$var$createSequenceNumberVector(sequenceNumber) {
    if (sequenceNumber >= 4294967296) throw new Error("Outbound sequence number overflow. The maximum sequence number is 32-bytes.");
    const byteArray = new ArrayBuffer($c0abf786dbde3e8b$var$SEQUENCE_NUMBER_BYTES);
    const view = new DataView(byteArray);
    view.setUint32(0, sequenceNumber, /* littleEndian */ false);
    return new Uint8Array(byteArray);
}
const $c0abf786dbde3e8b$var$INITIALIZATION_VECTOR_BYTES = 12;
const $c0abf786dbde3e8b$var$ENCODED_PUBLIC_KEY_LENGTH_BYTES = 65;
function $c0abf786dbde3e8b$var$encryptMessage(plaintext, sequenceNumber, sharedSecret) {
    return $c0abf786dbde3e8b$var$__awaiter(this, void 0, void 0, function*() {
        const sequenceNumberVector = $c0abf786dbde3e8b$var$createSequenceNumberVector(sequenceNumber);
        const initializationVector = new Uint8Array($c0abf786dbde3e8b$var$INITIALIZATION_VECTOR_BYTES);
        crypto.getRandomValues(initializationVector);
        const ciphertext = yield crypto.subtle.encrypt($c0abf786dbde3e8b$var$getAlgorithmParams(sequenceNumberVector, initializationVector), sharedSecret, new TextEncoder().encode(plaintext));
        const response = new Uint8Array(sequenceNumberVector.byteLength + initializationVector.byteLength + ciphertext.byteLength);
        response.set(new Uint8Array(sequenceNumberVector), 0);
        response.set(new Uint8Array(initializationVector), sequenceNumberVector.byteLength);
        response.set(new Uint8Array(ciphertext), sequenceNumberVector.byteLength + initializationVector.byteLength);
        return response;
    });
}
function $c0abf786dbde3e8b$var$decryptMessage(message, sharedSecret) {
    return $c0abf786dbde3e8b$var$__awaiter(this, void 0, void 0, function*() {
        const sequenceNumberVector = message.slice(0, $c0abf786dbde3e8b$var$SEQUENCE_NUMBER_BYTES);
        const initializationVector = message.slice($c0abf786dbde3e8b$var$SEQUENCE_NUMBER_BYTES, $c0abf786dbde3e8b$var$SEQUENCE_NUMBER_BYTES + $c0abf786dbde3e8b$var$INITIALIZATION_VECTOR_BYTES);
        const ciphertext = message.slice($c0abf786dbde3e8b$var$SEQUENCE_NUMBER_BYTES + $c0abf786dbde3e8b$var$INITIALIZATION_VECTOR_BYTES);
        const plaintextBuffer = yield crypto.subtle.decrypt($c0abf786dbde3e8b$var$getAlgorithmParams(sequenceNumberVector, initializationVector), sharedSecret, ciphertext);
        const plaintext = $c0abf786dbde3e8b$var$getUtf8Decoder().decode(plaintextBuffer);
        return plaintext;
    });
}
function $c0abf786dbde3e8b$var$getAlgorithmParams(sequenceNumber, initializationVector) {
    return {
        additionalData: sequenceNumber,
        iv: initializationVector,
        name: "AES-GCM",
        tagLength: 128
    };
}
let $c0abf786dbde3e8b$var$_utf8Decoder;
function $c0abf786dbde3e8b$var$getUtf8Decoder() {
    if ($c0abf786dbde3e8b$var$_utf8Decoder === undefined) $c0abf786dbde3e8b$var$_utf8Decoder = new TextDecoder("utf-8");
    return $c0abf786dbde3e8b$var$_utf8Decoder;
}
function $c0abf786dbde3e8b$var$generateAssociationKeypair() {
    return $c0abf786dbde3e8b$var$__awaiter(this, void 0, void 0, function*() {
        return yield crypto.subtle.generateKey({
            name: "ECDSA",
            namedCurve: "P-256"
        }, false, [
            "sign"
        ]);
    });
}
function $c0abf786dbde3e8b$var$generateECDHKeypair() {
    return $c0abf786dbde3e8b$var$__awaiter(this, void 0, void 0, function*() {
        return yield crypto.subtle.generateKey({
            name: "ECDH",
            namedCurve: "P-256"
        }, false, [
            "deriveKey",
            "deriveBits"
        ]);
    });
}
function $c0abf786dbde3e8b$var$encryptJsonRpcMessage(jsonRpcMessage, sharedSecret) {
    return $c0abf786dbde3e8b$var$__awaiter(this, void 0, void 0, function*() {
        const plaintext = JSON.stringify(jsonRpcMessage);
        const sequenceNumber = jsonRpcMessage.id;
        return $c0abf786dbde3e8b$var$encryptMessage(plaintext, sequenceNumber, sharedSecret);
    });
}
function $c0abf786dbde3e8b$var$decryptJsonRpcMessage(message, sharedSecret) {
    return $c0abf786dbde3e8b$var$__awaiter(this, void 0, void 0, function*() {
        const plaintext = yield $c0abf786dbde3e8b$var$decryptMessage(message, sharedSecret);
        const jsonRpcMessage = JSON.parse(plaintext);
        if (Object.hasOwnProperty.call(jsonRpcMessage, "error")) throw new $c0abf786dbde3e8b$export$58b788f937123c66(jsonRpcMessage.id, jsonRpcMessage.error.code, jsonRpcMessage.error.message);
        return jsonRpcMessage;
    });
}
function $c0abf786dbde3e8b$var$parseHelloRsp(payloadBuffer, associationPublicKey, ecdhPrivateKey) {
    return $c0abf786dbde3e8b$var$__awaiter(this, void 0, void 0, function*() {
        const [associationPublicKeyBuffer, walletPublicKey] = yield Promise.all([
            crypto.subtle.exportKey("raw", associationPublicKey),
            crypto.subtle.importKey("raw", payloadBuffer.slice(0, $c0abf786dbde3e8b$var$ENCODED_PUBLIC_KEY_LENGTH_BYTES), {
                name: "ECDH",
                namedCurve: "P-256"
            }, false, [])
        ]);
        const sharedSecret = yield crypto.subtle.deriveBits({
            name: "ECDH",
            public: walletPublicKey
        }, ecdhPrivateKey, 256);
        const ecdhSecretKey = yield crypto.subtle.importKey("raw", sharedSecret, "HKDF", false, [
            "deriveKey"
        ]);
        const aesKeyMaterialVal = yield crypto.subtle.deriveKey({
            name: "HKDF",
            hash: "SHA-256",
            salt: new Uint8Array(associationPublicKeyBuffer),
            info: new Uint8Array()
        }, ecdhSecretKey, {
            name: "AES-GCM",
            length: 128
        }, false, [
            "encrypt",
            "decrypt"
        ]);
        return aesKeyMaterialVal;
    });
}
function $c0abf786dbde3e8b$var$parseSessionProps(message, sharedSecret) {
    return $c0abf786dbde3e8b$var$__awaiter(this, void 0, void 0, function*() {
        const plaintext = yield $c0abf786dbde3e8b$var$decryptMessage(message, sharedSecret);
        const jsonProperties = JSON.parse(plaintext);
        let protocolVersion = "legacy";
        if (Object.hasOwnProperty.call(jsonProperties, "v")) switch(jsonProperties.v){
            case 1:
            case "1":
            case "v1":
                protocolVersion = "v1";
                break;
            case "legacy":
                protocolVersion = "legacy";
                break;
            default:
                throw new $c0abf786dbde3e8b$export$d77545679c409b63($c0abf786dbde3e8b$export$93083e877aec7a8a.ERROR_INVALID_PROTOCOL_VERSION, `Unknown/unsupported protocol version: ${jsonProperties.v}`);
        }
        return {
            protocol_version: protocolVersion
        };
    });
}
function $c0abf786dbde3e8b$var$getRandomAssociationPort() {
    return $c0abf786dbde3e8b$var$assertAssociationPort(49152 + Math.floor(Math.random() * 16384));
}
function $c0abf786dbde3e8b$var$assertAssociationPort(port) {
    if (port < 49152 || port > 65535) throw new $c0abf786dbde3e8b$export$d77545679c409b63($c0abf786dbde3e8b$export$93083e877aec7a8a.ERROR_ASSOCIATION_PORT_OUT_OF_RANGE, `Association port number must be between 49152 and 65535. ${port} given.`, {
        port: port
    });
    return port;
}
// https://stackoverflow.com/a/9458996/802047
function $c0abf786dbde3e8b$var$arrayBufferToBase64String(buffer) {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for(let ii = 0; ii < len; ii++)binary += String.fromCharCode(bytes[ii]);
    return window.btoa(binary);
}
function $c0abf786dbde3e8b$var$getStringWithURLUnsafeCharactersReplaced(unsafeBase64EncodedString) {
    return unsafeBase64EncodedString.replace(/[/+=]/g, (m)=>({
            "/": "_",
            "+": "-",
            "=": "."
        })[m]);
}
const $c0abf786dbde3e8b$var$INTENT_NAME = "solana-wallet";
function $c0abf786dbde3e8b$var$getPathParts(pathString) {
    return pathString// Strip leading and trailing slashes
    .replace(/(^\/+|\/+$)/g, "")// Return an array of directories
    .split("/");
}
function $c0abf786dbde3e8b$var$getIntentURL(methodPathname, intentUrlBase) {
    let baseUrl = null;
    if (intentUrlBase) {
        try {
            baseUrl = new URL(intentUrlBase);
        } catch (_a) {} // eslint-disable-line no-empty
        if ((baseUrl === null || baseUrl === void 0 ? void 0 : baseUrl.protocol) !== "https:") throw new $c0abf786dbde3e8b$export$d77545679c409b63($c0abf786dbde3e8b$export$93083e877aec7a8a.ERROR_FORBIDDEN_WALLET_BASE_URL, "Base URLs supplied by wallets must be valid `https` URLs");
    }
    baseUrl || (baseUrl = new URL(`${$c0abf786dbde3e8b$var$INTENT_NAME}:/`));
    const pathname = methodPathname.startsWith("/") ? methodPathname : [
        ...$c0abf786dbde3e8b$var$getPathParts(baseUrl.pathname),
        ...$c0abf786dbde3e8b$var$getPathParts(methodPathname)
    ].join("/");
    return new URL(pathname, baseUrl);
}
function $c0abf786dbde3e8b$var$getAssociateAndroidIntentURL(associationPublicKey, putativePort, associationURLBase, protocolVersions = [
    "v1"
]) {
    return $c0abf786dbde3e8b$var$__awaiter(this, void 0, void 0, function*() {
        const associationPort = $c0abf786dbde3e8b$var$assertAssociationPort(putativePort);
        const exportedKey = yield crypto.subtle.exportKey("raw", associationPublicKey);
        const encodedKey = $c0abf786dbde3e8b$var$arrayBufferToBase64String(exportedKey);
        const url = $c0abf786dbde3e8b$var$getIntentURL("v1/associate/local", associationURLBase);
        url.searchParams.set("association", $c0abf786dbde3e8b$var$getStringWithURLUnsafeCharactersReplaced(encodedKey));
        url.searchParams.set("port", `${associationPort}`);
        protocolVersions.forEach((version)=>{
            url.searchParams.set("v", version);
        });
        return url;
    });
}
// Typescript `enums` thwart tree-shaking. See https://bargsten.org/jsts/enums/
const $c0abf786dbde3e8b$var$Browser = {
    Firefox: 0,
    Other: 1
};
function $c0abf786dbde3e8b$var$assertUnreachable(x) {
    return x;
}
function $c0abf786dbde3e8b$var$getBrowser() {
    return navigator.userAgent.indexOf("Firefox/") !== -1 ? $c0abf786dbde3e8b$var$Browser.Firefox : $c0abf786dbde3e8b$var$Browser.Other;
}
function $c0abf786dbde3e8b$var$getDetectionPromise() {
    // Chrome and others silently fail if a custom protocol is not supported.
    // For these, we wait to see if the browser is navigated away from in
    // a reasonable amount of time (ie. the native wallet opened).
    return new Promise((resolve, reject)=>{
        function cleanup() {
            clearTimeout(timeoutId);
            window.removeEventListener("blur", handleBlur);
        }
        function handleBlur() {
            cleanup();
            resolve();
        }
        window.addEventListener("blur", handleBlur);
        const timeoutId = setTimeout(()=>{
            cleanup();
            reject();
        }, 2000);
    });
}
let $c0abf786dbde3e8b$var$_frame = null;
function $c0abf786dbde3e8b$var$launchUrlThroughHiddenFrame(url) {
    if ($c0abf786dbde3e8b$var$_frame == null) {
        $c0abf786dbde3e8b$var$_frame = document.createElement("iframe");
        $c0abf786dbde3e8b$var$_frame.style.display = "none";
        document.body.appendChild($c0abf786dbde3e8b$var$_frame);
    }
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    $c0abf786dbde3e8b$var$_frame.contentWindow.location.href = url.toString();
}
function $c0abf786dbde3e8b$var$startSession(associationPublicKey, associationURLBase) {
    return $c0abf786dbde3e8b$var$__awaiter(this, void 0, void 0, function*() {
        const randomAssociationPort = $c0abf786dbde3e8b$var$getRandomAssociationPort();
        const associationUrl = yield $c0abf786dbde3e8b$var$getAssociateAndroidIntentURL(associationPublicKey, randomAssociationPort, associationURLBase);
        if (associationUrl.protocol === "https:") // The association URL is an Android 'App Link' or iOS 'Universal Link'.
        // These are regular web URLs that are designed to launch an app if it
        // is installed or load the actual target webpage if not.
        window.location.assign(associationUrl);
        else // The association URL has a custom protocol (eg. `solana-wallet:`)
        try {
            const browser = $c0abf786dbde3e8b$var$getBrowser();
            switch(browser){
                case $c0abf786dbde3e8b$var$Browser.Firefox:
                    // If a custom protocol is not supported in Firefox, it throws.
                    $c0abf786dbde3e8b$var$launchUrlThroughHiddenFrame(associationUrl);
                    break;
                case $c0abf786dbde3e8b$var$Browser.Other:
                    {
                        const detectionPromise = $c0abf786dbde3e8b$var$getDetectionPromise();
                        window.location.assign(associationUrl);
                        yield detectionPromise;
                        break;
                    }
                default:
                    $c0abf786dbde3e8b$var$assertUnreachable(browser);
            }
        } catch (e) {
            throw new $c0abf786dbde3e8b$export$d77545679c409b63($c0abf786dbde3e8b$export$93083e877aec7a8a.ERROR_WALLET_NOT_FOUND, "Found no installed wallet that supports the mobile wallet protocol.");
        }
        return randomAssociationPort;
    });
}
const $c0abf786dbde3e8b$var$WEBSOCKET_CONNECTION_CONFIG = {
    /**
     * 300 milliseconds is a generally accepted threshold for what someone
     * would consider an acceptable response time for a user interface
     * after having performed a low-attention tapping task. We set the initial
     * interval at which we wait for the wallet to set up the websocket at
     * half this, as per the Nyquist frequency, with a progressive backoff
     * sequence from there. The total wait time is 30s, which allows for the
     * user to be presented with a disambiguation dialog, select a wallet, and
     * for the wallet app to subsequently start.
     */ retryDelayScheduleMs: [
        150,
        150,
        200,
        500,
        500,
        750,
        750,
        1000
    ],
    timeoutMs: 30000
};
const $c0abf786dbde3e8b$var$WEBSOCKET_PROTOCOL = "com.solana.mobilewalletadapter.v1";
function $c0abf786dbde3e8b$var$assertSecureContext() {
    if (typeof window === "undefined" || window.isSecureContext !== true) throw new $c0abf786dbde3e8b$export$d77545679c409b63($c0abf786dbde3e8b$export$93083e877aec7a8a.ERROR_SECURE_CONTEXT_REQUIRED, "The mobile wallet adapter protocol must be used in a secure context (`https`).");
}
function $c0abf786dbde3e8b$var$assertSecureEndpointSpecificURI(walletUriBase) {
    let url;
    try {
        url = new URL(walletUriBase);
    } catch (_a) {
        throw new $c0abf786dbde3e8b$export$d77545679c409b63($c0abf786dbde3e8b$export$93083e877aec7a8a.ERROR_FORBIDDEN_WALLET_BASE_URL, "Invalid base URL supplied by wallet");
    }
    if (url.protocol !== "https:") throw new $c0abf786dbde3e8b$export$d77545679c409b63($c0abf786dbde3e8b$export$93083e877aec7a8a.ERROR_FORBIDDEN_WALLET_BASE_URL, "Base URLs supplied by wallets must be valid `https` URLs");
}
function $c0abf786dbde3e8b$var$getSequenceNumberFromByteArray(byteArray) {
    const view = new DataView(byteArray);
    return view.getUint32(0, /* littleEndian */ false);
}
function $c0abf786dbde3e8b$export$dac1bad6146b2469(callback, config) {
    return $c0abf786dbde3e8b$var$__awaiter(this, void 0, void 0, function*() {
        $c0abf786dbde3e8b$var$assertSecureContext();
        const associationKeypair = yield $c0abf786dbde3e8b$var$generateAssociationKeypair();
        const sessionPort = yield $c0abf786dbde3e8b$var$startSession(associationKeypair.publicKey, config === null || config === void 0 ? void 0 : config.baseUri);
        const websocketURL = `ws://localhost:${sessionPort}/solana-wallet`;
        let connectionStartTime;
        const getNextRetryDelayMs = (()=>{
            const schedule = [
                ...$c0abf786dbde3e8b$var$WEBSOCKET_CONNECTION_CONFIG.retryDelayScheduleMs
            ];
            return ()=>schedule.length > 1 ? schedule.shift() : schedule[0];
        })();
        let nextJsonRpcMessageId = 1;
        let lastKnownInboundSequenceNumber = 0;
        let state = {
            __type: "disconnected"
        };
        return new Promise((resolve, reject)=>{
            let socket;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const jsonRpcResponsePromises = {};
            const handleOpen = ()=>$c0abf786dbde3e8b$var$__awaiter(this, void 0, void 0, function*() {
                    if (state.__type !== "connecting") {
                        console.warn("Expected adapter state to be `connecting` at the moment the websocket opens. " + `Got \`${state.__type}\`.`);
                        return;
                    }
                    const { associationKeypair: associationKeypair } = state;
                    socket.removeEventListener("open", handleOpen);
                    const ecdhKeypair = yield $c0abf786dbde3e8b$var$generateECDHKeypair();
                    socket.send((yield $c0abf786dbde3e8b$var$createHelloReq(ecdhKeypair.publicKey, associationKeypair.privateKey)));
                    state = {
                        __type: "hello_req_sent",
                        associationPublicKey: associationKeypair.publicKey,
                        ecdhPrivateKey: ecdhKeypair.privateKey
                    };
                });
            const handleClose = (evt)=>{
                if (evt.wasClean) state = {
                    __type: "disconnected"
                };
                else reject(new $c0abf786dbde3e8b$export$d77545679c409b63($c0abf786dbde3e8b$export$93083e877aec7a8a.ERROR_SESSION_CLOSED, `The wallet session dropped unexpectedly (${evt.code}: ${evt.reason}).`, {
                    closeEvent: evt
                }));
                disposeSocket();
            };
            const handleError = (_evt)=>$c0abf786dbde3e8b$var$__awaiter(this, void 0, void 0, function*() {
                    disposeSocket();
                    if (Date.now() - connectionStartTime >= $c0abf786dbde3e8b$var$WEBSOCKET_CONNECTION_CONFIG.timeoutMs) reject(new $c0abf786dbde3e8b$export$d77545679c409b63($c0abf786dbde3e8b$export$93083e877aec7a8a.ERROR_SESSION_TIMEOUT, `Failed to connect to the wallet websocket on port ${sessionPort}.`));
                    else {
                        yield new Promise((resolve)=>{
                            const retryDelayMs = getNextRetryDelayMs();
                            retryWaitTimeoutId = window.setTimeout(resolve, retryDelayMs);
                        });
                        attemptSocketConnection();
                    }
                });
            const handleMessage = (evt)=>$c0abf786dbde3e8b$var$__awaiter(this, void 0, void 0, function*() {
                    const responseBuffer = yield evt.data.arrayBuffer();
                    switch(state.__type){
                        case "connected":
                            try {
                                const sequenceNumberVector = responseBuffer.slice(0, $c0abf786dbde3e8b$var$SEQUENCE_NUMBER_BYTES);
                                const sequenceNumber = $c0abf786dbde3e8b$var$getSequenceNumberFromByteArray(sequenceNumberVector);
                                if (sequenceNumber !== lastKnownInboundSequenceNumber + 1) throw new Error("Encrypted message has invalid sequence number");
                                lastKnownInboundSequenceNumber = sequenceNumber;
                                const jsonRpcMessage = yield $c0abf786dbde3e8b$var$decryptJsonRpcMessage(responseBuffer, state.sharedSecret);
                                const responsePromise = jsonRpcResponsePromises[jsonRpcMessage.id];
                                delete jsonRpcResponsePromises[jsonRpcMessage.id];
                                responsePromise.resolve(jsonRpcMessage.result);
                            } catch (e) {
                                if (e instanceof $c0abf786dbde3e8b$export$58b788f937123c66) {
                                    const responsePromise = jsonRpcResponsePromises[e.jsonRpcMessageId];
                                    delete jsonRpcResponsePromises[e.jsonRpcMessageId];
                                    responsePromise.reject(e);
                                } else throw e;
                            }
                            break;
                        case "hello_req_sent":
                            {
                                const sharedSecret = yield $c0abf786dbde3e8b$var$parseHelloRsp(responseBuffer, state.associationPublicKey, state.ecdhPrivateKey);
                                const sessionPropertiesBuffer = responseBuffer.slice($c0abf786dbde3e8b$var$ENCODED_PUBLIC_KEY_LENGTH_BYTES);
                                const sessionProperties = sessionPropertiesBuffer.byteLength !== 0 ? yield (()=>$c0abf786dbde3e8b$var$__awaiter(this, void 0, void 0, function*() {
                                        const sequenceNumberVector = sessionPropertiesBuffer.slice(0, $c0abf786dbde3e8b$var$SEQUENCE_NUMBER_BYTES);
                                        const sequenceNumber = $c0abf786dbde3e8b$var$getSequenceNumberFromByteArray(sequenceNumberVector);
                                        if (sequenceNumber !== lastKnownInboundSequenceNumber + 1) throw new Error("Encrypted message has invalid sequence number");
                                        lastKnownInboundSequenceNumber = sequenceNumber;
                                        return $c0abf786dbde3e8b$var$parseSessionProps(sessionPropertiesBuffer, sharedSecret);
                                    }))() : {
                                    protocol_version: "legacy"
                                };
                                state = {
                                    __type: "connected",
                                    sharedSecret: sharedSecret,
                                    sessionProperties: sessionProperties
                                };
                                const wallet = $c0abf786dbde3e8b$var$createMobileWalletProxy(sessionProperties.protocol_version, (method, params)=>$c0abf786dbde3e8b$var$__awaiter(this, void 0, void 0, function*() {
                                        const id = nextJsonRpcMessageId++;
                                        socket.send((yield $c0abf786dbde3e8b$var$encryptJsonRpcMessage({
                                            id: id,
                                            jsonrpc: "2.0",
                                            method: method,
                                            params: params !== null && params !== void 0 ? params : {}
                                        }, sharedSecret)));
                                        return new Promise((resolve, reject)=>{
                                            jsonRpcResponsePromises[id] = {
                                                resolve (result) {
                                                    switch(method){
                                                        case "authorize":
                                                        case "reauthorize":
                                                            {
                                                                const { wallet_uri_base: wallet_uri_base } = result;
                                                                if (wallet_uri_base != null) try {
                                                                    $c0abf786dbde3e8b$var$assertSecureEndpointSpecificURI(wallet_uri_base);
                                                                } catch (e) {
                                                                    reject(e);
                                                                    return;
                                                                }
                                                                break;
                                                            }
                                                    }
                                                    resolve(result);
                                                },
                                                reject: reject
                                            };
                                        });
                                    }));
                                try {
                                    resolve((yield callback(wallet)));
                                } catch (e) {
                                    reject(e);
                                } finally{
                                    disposeSocket();
                                    socket.close();
                                }
                                break;
                            }
                    }
                });
            let disposeSocket;
            let retryWaitTimeoutId;
            const attemptSocketConnection = ()=>{
                if (disposeSocket) disposeSocket();
                state = {
                    __type: "connecting",
                    associationKeypair: associationKeypair
                };
                if (connectionStartTime === undefined) connectionStartTime = Date.now();
                socket = new WebSocket(websocketURL, [
                    $c0abf786dbde3e8b$var$WEBSOCKET_PROTOCOL
                ]);
                socket.addEventListener("open", handleOpen);
                socket.addEventListener("close", handleClose);
                socket.addEventListener("error", handleError);
                socket.addEventListener("message", handleMessage);
                disposeSocket = ()=>{
                    window.clearTimeout(retryWaitTimeoutId);
                    socket.removeEventListener("open", handleOpen);
                    socket.removeEventListener("close", handleClose);
                    socket.removeEventListener("error", handleError);
                    socket.removeEventListener("message", handleMessage);
                };
            };
            attemptSocketConnection();
        });
    });
}


var $a58a6d91d9c648ad$exports = {};
var $cd42a1fa41d9d8d9$exports = {};
"use strict";
// base-x encoding / decoding
// Copyright (c) 2018 base-x contributors
// Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
// Distributed under the MIT software license, see the accompanying
// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
function $cd42a1fa41d9d8d9$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
$cd42a1fa41d9d8d9$exports = $cd42a1fa41d9d8d9$var$base;


const $a58a6d91d9c648ad$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
$a58a6d91d9c648ad$exports = $cd42a1fa41d9d8d9$exports($a58a6d91d9c648ad$var$ALPHABET);


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $094296f2f336bc31$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $094296f2f336bc31$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $094296f2f336bc31$var$fromUint8Array(byteArray) {
    return window.btoa(String.fromCharCode.call(null, ...byteArray));
}
function $094296f2f336bc31$var$toUint8Array(base64EncodedByteArray) {
    return new Uint8Array(window.atob(base64EncodedByteArray).split("").map((c)=>c.charCodeAt(0)));
}
function $094296f2f336bc31$var$getPayloadFromTransaction(transaction) {
    const serializedTransaction = "version" in transaction ? transaction.serialize() : transaction.serialize({
        requireAllSignatures: false,
        verifySignatures: false
    });
    const payload = $094296f2f336bc31$var$fromUint8Array(serializedTransaction);
    return payload;
}
function $094296f2f336bc31$var$getTransactionFromWireMessage(byteArray) {
    const numSignatures = byteArray[0];
    const messageOffset = numSignatures * (0, $ca3473265f76df98$export$14aee086fde78fa6) + 1;
    const version = (0, $ca3473265f76df98$export$b0a61927d00ede7f).deserializeMessageVersion(byteArray.slice(messageOffset, byteArray.length));
    if (version === "legacy") return (0, $ca3473265f76df98$export$febc5573c75cefb0).from(byteArray);
    else return (0, $ca3473265f76df98$export$232cc3f078dcc284).deserialize(byteArray);
}
function $094296f2f336bc31$export$dac1bad6146b2469(callback, config) {
    return $094296f2f336bc31$var$__awaiter(this, void 0, void 0, function*() {
        const augmentedCallback = (wallet)=>{
            const augmentedAPI = new Proxy({}, {
                get (target, p) {
                    if (target[p] == null) switch(p){
                        case "signAndSendTransactions":
                            target[p] = function(_a) {
                                var { minContextSlot: minContextSlot, commitment: commitment, skipPreflight: skipPreflight, maxRetries: maxRetries, waitForCommitmentToSendNextTransaction: waitForCommitmentToSendNextTransaction, transactions: transactions } = _a, rest = $094296f2f336bc31$var$__rest(_a, [
                                    "minContextSlot",
                                    "commitment",
                                    "skipPreflight",
                                    "maxRetries",
                                    "waitForCommitmentToSendNextTransaction",
                                    "transactions"
                                ]);
                                return $094296f2f336bc31$var$__awaiter(this, void 0, void 0, function*() {
                                    const payloads = transactions.map($094296f2f336bc31$var$getPayloadFromTransaction);
                                    const options = {
                                        min_context_slot: minContextSlot,
                                        commitment: commitment,
                                        skip_preflight: skipPreflight,
                                        max_retries: maxRetries,
                                        wait_for_commitment_to_send_next_transaction: waitForCommitmentToSendNextTransaction
                                    };
                                    const { signatures: base64EncodedSignatures } = yield wallet.signAndSendTransactions(Object.assign(Object.assign(Object.assign({}, rest), Object.values(options).some((element)=>element != null) ? {
                                        options: options
                                    } : null), {
                                        payloads: payloads
                                    }));
                                    const signatures = base64EncodedSignatures.map($094296f2f336bc31$var$toUint8Array).map((0, (/*@__PURE__*/$parcel$interopDefault($a58a6d91d9c648ad$exports))).encode);
                                    return signatures;
                                });
                            };
                            break;
                        case "signMessages":
                            target[p] = function(_a) {
                                var { payloads: payloads } = _a, rest = $094296f2f336bc31$var$__rest(_a, [
                                    "payloads"
                                ]);
                                return $094296f2f336bc31$var$__awaiter(this, void 0, void 0, function*() {
                                    const base64EncodedPayloads = payloads.map($094296f2f336bc31$var$fromUint8Array);
                                    const { signed_payloads: base64EncodedSignedMessages } = yield wallet.signMessages(Object.assign(Object.assign({}, rest), {
                                        payloads: base64EncodedPayloads
                                    }));
                                    const signedMessages = base64EncodedSignedMessages.map($094296f2f336bc31$var$toUint8Array);
                                    return signedMessages;
                                });
                            };
                            break;
                        case "signTransactions":
                            target[p] = function(_a) {
                                var { transactions: transactions } = _a, rest = $094296f2f336bc31$var$__rest(_a, [
                                    "transactions"
                                ]);
                                return $094296f2f336bc31$var$__awaiter(this, void 0, void 0, function*() {
                                    const payloads = transactions.map($094296f2f336bc31$var$getPayloadFromTransaction);
                                    const { signed_payloads: base64EncodedCompiledTransactions } = yield wallet.signTransactions(Object.assign(Object.assign({}, rest), {
                                        payloads: payloads
                                    }));
                                    const compiledTransactions = base64EncodedCompiledTransactions.map($094296f2f336bc31$var$toUint8Array);
                                    const signedTransactions = compiledTransactions.map($094296f2f336bc31$var$getTransactionFromWireMessage);
                                    return signedTransactions;
                                });
                            };
                            break;
                        default:
                            target[p] = wallet[p];
                            break;
                    }
                    return target[p];
                },
                defineProperty () {
                    return false;
                },
                deleteProperty () {
                    return false;
                }
            });
            return callback(augmentedAPI);
        };
        return yield (0, $c0abf786dbde3e8b$export$dac1bad6146b2469)(augmentedCallback, config);
    });
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $bf765e8a33bb400e$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $bf765e8a33bb400e$var$toUint8Array(base64EncodedByteArray) {
    return new Uint8Array(window.atob(base64EncodedByteArray).split("").map((c)=>c.charCodeAt(0)));
}
function $bf765e8a33bb400e$var$getIsSupported() {
    return typeof window !== "undefined" && window.isSecureContext && typeof document !== "undefined" && /android/i.test(navigator.userAgent);
}
const $bf765e8a33bb400e$export$f1265e9082f346f1 = "Mobile Wallet Adapter";
const $bf765e8a33bb400e$var$SIGNATURE_LENGTH_IN_BYTES = 64;
function $bf765e8a33bb400e$var$getPublicKeyFromAddress(address) {
    const publicKeyByteArray = $bf765e8a33bb400e$var$toUint8Array(address);
    return new (0, $ca3473265f76df98$export$ca8b6604d6ce14de)(publicKeyByteArray);
}
function $bf765e8a33bb400e$var$isVersionedTransaction(transaction) {
    return "version" in transaction;
}
class $bf765e8a33bb400e$export$dec251788b2f5a84 extends (0, $a9a0bf22390753d6$export$9779f871ffdb3d87) {
    constructor(config){
        var _a;
        super();
        this.supportedTransactionVersions = new Set(// FIXME(#244): We can't actually know what versions are supported until we know which wallet we're talking to.
        [
            "legacy",
            0
        ]);
        this.name = $bf765e8a33bb400e$export$f1265e9082f346f1;
        this.url = "https://solanamobile.com/wallets";
        this.icon = "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjI4IiB3aWR0aD0iMjgiIHZpZXdCb3g9Ii0zIDAgMjggMjgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iI0RDQjhGRiI+PHBhdGggZD0iTTE3LjQgMTcuNEgxNXYyLjRoMi40di0yLjRabTEuMi05LjZoLTIuNHYyLjRoMi40VjcuOFoiLz48cGF0aCBkPSJNMjEuNiAzVjBoLTIuNHYzaC0zLjZWMGgtMi40djNoLTIuNHY2LjZINC41YTIuMSAyLjEgMCAxIDEgMC00LjJoMi43VjNINC41QTQuNSA0LjUgMCAwIDAgMCA3LjVWMjRoMjEuNnYtNi42aC0yLjR2NC4ySDIuNFYxMS41Yy41LjMgMS4yLjQgMS44LjVoNy41QTYuNiA2LjYgMCAwIDAgMjQgOVYzaC0yLjRabTAgNS43YTQuMiA0LjIgMCAxIDEtOC40IDBWNS40aDguNHYzLjNaIi8+PC9nPjwvc3ZnPg==";
        this._connecting = false;
        /**
         * Every time the connection is recycled in some way (eg. `disconnect()` is called)
         * increment this and use it to make sure that `transact` calls from the previous
         * 'generation' don't continue to do work and throw exceptions.
         */ this._connectionGeneration = 0;
        this._readyState = $bf765e8a33bb400e$var$getIsSupported() ? (0, $3020024d0a1e39a2$export$2a7b8071105d05b6).Loadable : (0, $3020024d0a1e39a2$export$2a7b8071105d05b6).Unsupported;
        this._authorizationResultCache = config.authorizationResultCache;
        this._addressSelector = config.addressSelector;
        this._appIdentity = config.appIdentity;
        this._chain = (_a = config.chain) !== null && _a !== void 0 ? _a : config.cluster;
        this._onWalletNotFound = config.onWalletNotFound;
        if (this._readyState !== (0, $3020024d0a1e39a2$export$2a7b8071105d05b6).Unsupported) this._authorizationResultCache.get().then((authorizationResult)=>{
            if (authorizationResult) // Having a prior authorization result is, right now, the best
            // indication that a mobile wallet is installed. There is no API
            // we can use to test for whether the association URI is supported.
            this.declareWalletAsInstalled();
        });
    }
    get publicKey() {
        if (this._publicKey == null && this._selectedAddress != null) try {
            this._publicKey = $bf765e8a33bb400e$var$getPublicKeyFromAddress(this._selectedAddress);
        } catch (e) {
            throw new (0, $954228dd8da6435a$export$735bef3bfb0f2c86)(e instanceof Error && (e === null || e === void 0 ? void 0 : e.message) || "Unknown error", e);
        }
        return this._publicKey ? this._publicKey : null;
    }
    get connected() {
        return !!this._authorizationResult;
    }
    get connecting() {
        return this._connecting;
    }
    get readyState() {
        return this._readyState;
    }
    declareWalletAsInstalled() {
        if (this._readyState !== (0, $3020024d0a1e39a2$export$2a7b8071105d05b6).Installed) this.emit("readyStateChange", this._readyState = (0, $3020024d0a1e39a2$export$2a7b8071105d05b6).Installed);
    }
    runWithGuard(callback) {
        return $bf765e8a33bb400e$var$__awaiter(this, void 0, void 0, function*() {
            try {
                return yield callback();
            } catch (e) {
                this.emit("error", e);
                throw e;
            }
        });
    }
    /** @deprecated Use `autoConnect()` instead. */ autoConnect_DO_NOT_USE_OR_YOU_WILL_BE_FIRED() {
        return $bf765e8a33bb400e$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.autoConnect();
        });
    }
    autoConnect() {
        return $bf765e8a33bb400e$var$__awaiter(this, void 0, void 0, function*() {
            if (this.connecting || this.connected) return;
            return yield this.runWithGuard(()=>$bf765e8a33bb400e$var$__awaiter(this, void 0, void 0, function*() {
                    if (this._readyState !== (0, $3020024d0a1e39a2$export$2a7b8071105d05b6).Installed && this._readyState !== (0, $3020024d0a1e39a2$export$2a7b8071105d05b6).Loadable) throw new (0, $954228dd8da6435a$export$d65db264eda99cd7)();
                    this._connecting = true;
                    try {
                        const cachedAuthorizationResult = yield this._authorizationResultCache.get();
                        if (cachedAuthorizationResult) // TODO: Evaluate whether there's any threat to not `awaiting` this expression
                        this.handleAuthorizationResult(cachedAuthorizationResult);
                    } catch (e) {
                        throw new (0, $954228dd8da6435a$export$38f21f1c810261c7)(e instanceof Error && e.message || "Unknown error", e);
                    } finally{
                        this._connecting = false;
                    }
                }));
        });
    }
    connect() {
        return $bf765e8a33bb400e$var$__awaiter(this, void 0, void 0, function*() {
            if (this.connecting || this.connected) return;
            return yield this.runWithGuard(()=>$bf765e8a33bb400e$var$__awaiter(this, void 0, void 0, function*() {
                    if (this._readyState !== (0, $3020024d0a1e39a2$export$2a7b8071105d05b6).Installed && this._readyState !== (0, $3020024d0a1e39a2$export$2a7b8071105d05b6).Loadable) throw new (0, $954228dd8da6435a$export$d65db264eda99cd7)();
                    this._connecting = true;
                    try {
                        yield this.performAuthorization();
                    } catch (e) {
                        throw new (0, $954228dd8da6435a$export$38f21f1c810261c7)(e instanceof Error && e.message || "Unknown error", e);
                    } finally{
                        this._connecting = false;
                    }
                }));
        });
    }
    performAuthorization(signInPayload) {
        return $bf765e8a33bb400e$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const cachedAuthorizationResult = yield this._authorizationResultCache.get();
                if (cachedAuthorizationResult) {
                    // TODO: Evaluate whether there's any threat to not `awaiting` this expression
                    this.handleAuthorizationResult(cachedAuthorizationResult);
                    return cachedAuthorizationResult;
                }
                return yield this.transact((wallet)=>$bf765e8a33bb400e$var$__awaiter(this, void 0, void 0, function*() {
                        const authorizationResult = yield wallet.authorize({
                            chain: this._chain,
                            identity: this._appIdentity,
                            sign_in_payload: signInPayload
                        });
                        // TODO: Evaluate whether there's any threat to not `awaiting` this expression
                        Promise.all([
                            this._authorizationResultCache.set(authorizationResult),
                            this.handleAuthorizationResult(authorizationResult)
                        ]);
                        return authorizationResult;
                    }));
            } catch (e) {
                throw new (0, $954228dd8da6435a$export$38f21f1c810261c7)(e instanceof Error && e.message || "Unknown error", e);
            }
        });
    }
    handleAuthorizationResult(authorizationResult) {
        var _a;
        return $bf765e8a33bb400e$var$__awaiter(this, void 0, void 0, function*() {
            const didPublicKeysChange = // Case 1: We started from having no authorization.
            this._authorizationResult == null || // Case 2: The number of authorized accounts changed.
            ((_a = this._authorizationResult) === null || _a === void 0 ? void 0 : _a.accounts.length) !== authorizationResult.accounts.length || // Case 3: The new list of addresses isn't exactly the same as the old list, in the same order.
            this._authorizationResult.accounts.some((account, ii)=>account.address !== authorizationResult.accounts[ii].address);
            this._authorizationResult = authorizationResult;
            this.declareWalletAsInstalled();
            if (didPublicKeysChange) {
                const nextSelectedAddress = yield this._addressSelector.select(authorizationResult.accounts.map(({ address: address })=>address));
                if (nextSelectedAddress !== this._selectedAddress) {
                    this._selectedAddress = nextSelectedAddress;
                    delete this._publicKey;
                    this.emit("connect", // Having just set `this._selectedAddress`, `this.publicKey` is definitely non-null
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    this.publicKey);
                }
            }
        });
    }
    performReauthorization(wallet, authToken) {
        return $bf765e8a33bb400e$var$__awaiter(this, void 0, void 0, function*() {
            try {
                const authorizationResult = yield wallet.authorize({
                    auth_token: authToken,
                    identity: this._appIdentity
                });
                // TODO: Evaluate whether there's any threat to not `awaiting` this expression
                Promise.all([
                    this._authorizationResultCache.set(authorizationResult),
                    this.handleAuthorizationResult(authorizationResult)
                ]);
            } catch (e) {
                this.disconnect();
                throw new (0, $954228dd8da6435a$export$bf7028c52ebda81e)(e instanceof Error && (e === null || e === void 0 ? void 0 : e.message) || "Unknown error", e);
            }
        });
    }
    disconnect() {
        return $bf765e8a33bb400e$var$__awaiter(this, void 0, void 0, function*() {
            this._authorizationResultCache.clear(); // TODO: Evaluate whether there's any threat to not `awaiting` this expression
            this._connecting = false;
            this._connectionGeneration++;
            delete this._authorizationResult;
            delete this._publicKey;
            delete this._selectedAddress;
            this.emit("disconnect");
        });
    }
    transact(callback) {
        var _a;
        return $bf765e8a33bb400e$var$__awaiter(this, void 0, void 0, function*() {
            const walletUriBase = (_a = this._authorizationResult) === null || _a === void 0 ? void 0 : _a.wallet_uri_base;
            const config = walletUriBase ? {
                baseUri: walletUriBase
            } : undefined;
            const currentConnectionGeneration = this._connectionGeneration;
            try {
                return yield (0, $094296f2f336bc31$export$dac1bad6146b2469)(callback, config);
            } catch (e) {
                if (this._connectionGeneration !== currentConnectionGeneration) yield new Promise(()=>{}); // Never resolve.
                if (e instanceof Error && e.name === "SolanaMobileWalletAdapterError" && e.code === "ERROR_WALLET_NOT_FOUND") yield this._onWalletNotFound(this);
                throw e;
            }
        });
    }
    assertIsAuthorized() {
        if (!this._authorizationResult || !this._selectedAddress) throw new (0, $954228dd8da6435a$export$313d299817c74896)();
        return {
            authToken: this._authorizationResult.auth_token,
            selectedAddress: this._selectedAddress
        };
    }
    performSignTransactions(transactions) {
        return $bf765e8a33bb400e$var$__awaiter(this, void 0, void 0, function*() {
            const { authToken: authToken } = this.assertIsAuthorized();
            try {
                return yield this.transact((wallet)=>$bf765e8a33bb400e$var$__awaiter(this, void 0, void 0, function*() {
                        yield this.performReauthorization(wallet, authToken);
                        const signedTransactions = yield wallet.signTransactions({
                            transactions: transactions
                        });
                        return signedTransactions;
                    }));
            } catch (error) {
                throw new (0, $954228dd8da6435a$export$96f177062fdd8180)(error === null || error === void 0 ? void 0 : error.message, error);
            }
        });
    }
    sendTransaction(transaction, connection, options) {
        return $bf765e8a33bb400e$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.runWithGuard(()=>$bf765e8a33bb400e$var$__awaiter(this, void 0, void 0, function*() {
                    const { authToken: authToken } = this.assertIsAuthorized();
                    const minContextSlot = options === null || options === void 0 ? void 0 : options.minContextSlot;
                    try {
                        return yield this.transact((wallet)=>$bf765e8a33bb400e$var$__awaiter(this, void 0, void 0, function*() {
                                function getTargetCommitment() {
                                    let targetCommitment;
                                    switch(connection.commitment){
                                        case "confirmed":
                                        case "finalized":
                                        case "processed":
                                            targetCommitment = connection.commitment;
                                            break;
                                        default:
                                            targetCommitment = "finalized";
                                    }
                                    let targetPreflightCommitment;
                                    switch(options === null || options === void 0 ? void 0 : options.preflightCommitment){
                                        case "confirmed":
                                        case "finalized":
                                        case "processed":
                                            targetPreflightCommitment = options.preflightCommitment;
                                            break;
                                        case undefined:
                                            targetPreflightCommitment = targetCommitment;
                                            break;
                                        default:
                                            targetPreflightCommitment = "finalized";
                                    }
                                    const preflightCommitmentScore = targetPreflightCommitment === "finalized" ? 2 : targetPreflightCommitment === "confirmed" ? 1 : 0;
                                    const targetCommitmentScore = targetCommitment === "finalized" ? 2 : targetCommitment === "confirmed" ? 1 : 0;
                                    return preflightCommitmentScore < targetCommitmentScore ? targetPreflightCommitment : targetCommitment;
                                }
                                const [capabilities, _1, _2] = yield Promise.all([
                                    wallet.getCapabilities(),
                                    this.performReauthorization(wallet, authToken),
                                    $bf765e8a33bb400e$var$isVersionedTransaction(transaction) ? null : /**
                                   * Unlike versioned transactions, legacy `Transaction` objects
                                   * may not have an associated `feePayer` or `recentBlockhash`.
                                   * This code exists to patch them up in case they are missing.
                                   */ (()=>$bf765e8a33bb400e$var$__awaiter(this, void 0, void 0, function*() {
                                            var _a;
                                            transaction.feePayer || (transaction.feePayer = (_a = this.publicKey) !== null && _a !== void 0 ? _a : undefined);
                                            if (transaction.recentBlockhash == null) {
                                                const { blockhash: blockhash } = yield connection.getLatestBlockhash({
                                                    commitment: getTargetCommitment()
                                                });
                                                transaction.recentBlockhash = blockhash;
                                            }
                                        }))()
                                ]);
                                if (capabilities.supports_sign_and_send_transactions) {
                                    const signatures = yield wallet.signAndSendTransactions({
                                        minContextSlot: minContextSlot,
                                        transactions: [
                                            transaction
                                        ]
                                    });
                                    return signatures[0];
                                } else {
                                    const [signedTransaction] = yield wallet.signTransactions({
                                        transactions: [
                                            transaction
                                        ]
                                    });
                                    if ($bf765e8a33bb400e$var$isVersionedTransaction(signedTransaction)) return yield connection.sendTransaction(signedTransaction);
                                    else {
                                        const serializedTransaction = signedTransaction.serialize();
                                        return yield connection.sendRawTransaction(serializedTransaction, Object.assign(Object.assign({}, options), {
                                            preflightCommitment: getTargetCommitment()
                                        }));
                                    }
                                }
                            }));
                    } catch (error) {
                        throw new (0, $954228dd8da6435a$export$769332ac3f90f46c)(error === null || error === void 0 ? void 0 : error.message, error);
                    }
                }));
        });
    }
    signTransaction(transaction) {
        return $bf765e8a33bb400e$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.runWithGuard(()=>$bf765e8a33bb400e$var$__awaiter(this, void 0, void 0, function*() {
                    const [signedTransaction] = yield this.performSignTransactions([
                        transaction
                    ]);
                    return signedTransaction;
                }));
        });
    }
    signAllTransactions(transactions) {
        return $bf765e8a33bb400e$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.runWithGuard(()=>$bf765e8a33bb400e$var$__awaiter(this, void 0, void 0, function*() {
                    const signedTransactions = yield this.performSignTransactions(transactions);
                    return signedTransactions;
                }));
        });
    }
    signMessage(message) {
        return $bf765e8a33bb400e$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.runWithGuard(()=>$bf765e8a33bb400e$var$__awaiter(this, void 0, void 0, function*() {
                    const { authToken: authToken, selectedAddress: selectedAddress } = this.assertIsAuthorized();
                    try {
                        return yield this.transact((wallet)=>$bf765e8a33bb400e$var$__awaiter(this, void 0, void 0, function*() {
                                yield this.performReauthorization(wallet, authToken);
                                const [signedMessage] = yield wallet.signMessages({
                                    addresses: [
                                        selectedAddress
                                    ],
                                    payloads: [
                                        message
                                    ]
                                });
                                const signature = signedMessage.slice(-$bf765e8a33bb400e$var$SIGNATURE_LENGTH_IN_BYTES);
                                return signature;
                            }));
                    } catch (error) {
                        throw new (0, $954228dd8da6435a$export$2622c1721bbd4b17)(error === null || error === void 0 ? void 0 : error.message, error);
                    }
                }));
        });
    }
    signIn(input) {
        return $bf765e8a33bb400e$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.runWithGuard(()=>$bf765e8a33bb400e$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b;
                    if (this._readyState !== (0, $3020024d0a1e39a2$export$2a7b8071105d05b6).Installed && this._readyState !== (0, $3020024d0a1e39a2$export$2a7b8071105d05b6).Loadable) throw new (0, $954228dd8da6435a$export$d65db264eda99cd7)();
                    this._connecting = true;
                    try {
                        const authorizationResult = yield this.performAuthorization(Object.assign(Object.assign({}, input), {
                            domain: (_a = input === null || input === void 0 ? void 0 : input.domain) !== null && _a !== void 0 ? _a : window.location.host
                        }));
                        if (!authorizationResult.sign_in_result) throw new Error("Sign in failed, no sign in result returned by wallet");
                        const signedInAddress = authorizationResult.sign_in_result.address;
                        const signedInAccount = Object.assign(Object.assign({}, (_b = authorizationResult.accounts.find((acc)=>acc.address == signedInAddress)) !== null && _b !== void 0 ? _b : {
                            address: signedInAddress
                        }), {
                            publicKey: $bf765e8a33bb400e$var$toUint8Array(signedInAddress)
                        });
                        return {
                            account: signedInAccount,
                            signedMessage: $bf765e8a33bb400e$var$toUint8Array(authorizationResult.sign_in_result.signed_message),
                            signature: $bf765e8a33bb400e$var$toUint8Array(authorizationResult.sign_in_result.signature)
                        };
                    } catch (e) {
                        throw new (0, $954228dd8da6435a$export$38f21f1c810261c7)(e instanceof Error && e.message || "Unknown error", e);
                    } finally{
                        this._connecting = false;
                    }
                }));
        });
    }
}
function $bf765e8a33bb400e$export$a299fb0acc11345b() {
    return {
        select (addresses) {
            return $bf765e8a33bb400e$var$__awaiter(this, void 0, void 0, function*() {
                return addresses[0];
            });
        }
    };
}
const $bf765e8a33bb400e$var$CACHE_KEY = "SolanaMobileWalletAdapterDefaultAuthorizationCache";
function $bf765e8a33bb400e$export$4a0b597891770806() {
    let storage;
    try {
        storage = window.localStorage;
    // eslint-disable-next-line no-empty
    } catch (_a) {}
    return {
        clear () {
            return $bf765e8a33bb400e$var$__awaiter(this, void 0, void 0, function*() {
                if (!storage) return;
                try {
                    storage.removeItem($bf765e8a33bb400e$var$CACHE_KEY);
                // eslint-disable-next-line no-empty
                } catch (_a) {}
            });
        },
        get () {
            return $bf765e8a33bb400e$var$__awaiter(this, void 0, void 0, function*() {
                if (!storage) return;
                try {
                    return JSON.parse(storage.getItem($bf765e8a33bb400e$var$CACHE_KEY)) || undefined;
                // eslint-disable-next-line no-empty
                } catch (_a) {}
            });
        },
        set (authorizationResult) {
            return $bf765e8a33bb400e$var$__awaiter(this, void 0, void 0, function*() {
                if (!storage) return;
                try {
                    storage.setItem($bf765e8a33bb400e$var$CACHE_KEY, JSON.stringify(authorizationResult));
                // eslint-disable-next-line no-empty
                } catch (_a) {}
            });
        }
    };
}
function $bf765e8a33bb400e$var$defaultWalletNotFoundHandler(mobileWalletAdapter) {
    return $bf765e8a33bb400e$var$__awaiter(this, void 0, void 0, function*() {
        if (typeof window !== "undefined") window.location.assign(mobileWalletAdapter.url);
    });
}
function $bf765e8a33bb400e$export$e8b9e70cdf783b70() {
    return $bf765e8a33bb400e$var$defaultWalletNotFoundHandler;
}


/** Name of the feature. */ const $e319821bd2655536$export$dd64f32469f35f81 = "solana:signAndSendTransaction";

/** Name of the feature. */ const $7e43716d533d38e1$export$54187c3796d0ecb = "solana:signTransaction";


/** Name of the feature. */ const $941284cd50281772$export$cc68487eeb93b1d4 = "standard:connect";
const $941284cd50281772$export$59e6910693f047c2 = $941284cd50281772$export$cc68487eeb93b1d4;

/** Name of the feature. */ const $efa6324668e2a12c$export$5296443ca9e9fa0f = "standard:events";
const $efa6324668e2a12c$export$ada873a34909da65 = $efa6324668e2a12c$export$5296443ca9e9fa0f;


function $08598dde73d0023c$export$de6946e7c2c87e9a(wallet) {
    return (0, $941284cd50281772$export$cc68487eeb93b1d4) in wallet.features && (0, $efa6324668e2a12c$export$5296443ca9e9fa0f) in wallet.features && ((0, $e319821bd2655536$export$dd64f32469f35f81) in wallet.features || (0, $7e43716d533d38e1$export$54187c3796d0ecb) in wallet.features);
}


const $8d4fe5a2ddef9d4a$export$c5439c91843266e6 = (0, $08598dde73d0023c$export$de6946e7c2c87e9a);


/** Name of the feature. */ const $930e150235cdcc35$export$8adeab75f48a3607 = "solana:signIn";

/** Name of the feature. */ const $91c3efc23d0fa34e$export$22c7939a38084172 = "solana:signMessage";


/** Solana Mainnet (beta) cluster, e.g. https://api.mainnet-beta.solana.com */ const $94222f6f6d5eb9ae$export$bba9a228295b3963 = "solana:mainnet";
const $94222f6f6d5eb9ae$export$654cc095bd2e650 = "solana:devnet";
const $94222f6f6d5eb9ae$export$76575b7bf4de1f40 = "solana:testnet";
const $94222f6f6d5eb9ae$export$483699a75281444c = "solana:localnet";
const $94222f6f6d5eb9ae$export$d77e7f94b1f6bf7d = [
    $94222f6f6d5eb9ae$export$bba9a228295b3963,
    $94222f6f6d5eb9ae$export$654cc095bd2e650,
    $94222f6f6d5eb9ae$export$76575b7bf4de1f40,
    $94222f6f6d5eb9ae$export$483699a75281444c
];
function $94222f6f6d5eb9ae$export$d8f86f4d3d9fc2b5(chain) {
    return $94222f6f6d5eb9ae$export$d77e7f94b1f6bf7d.includes(chain);
}


const $caf6e9babadef711$export$9462d80112b287bf = "https://api.mainnet-beta.solana.com";
const $caf6e9babadef711$export$2416cc3545b31c3b = "https://api.devnet.solana.com";
const $caf6e9babadef711$export$fe3dc909dfa57ddb = "https://api.testnet.solana.com";
const $caf6e9babadef711$export$ec9ed1d68bb4713f = "http://localhost:8899";
function $caf6e9babadef711$export$43dcd8213c5a5741(endpoint) {
    if (endpoint.includes($caf6e9babadef711$export$9462d80112b287bf)) return 0, $94222f6f6d5eb9ae$export$bba9a228295b3963;
    if (/\bdevnet\b/i.test(endpoint)) return 0, $94222f6f6d5eb9ae$export$654cc095bd2e650;
    if (/\btestnet\b/i.test(endpoint)) return 0, $94222f6f6d5eb9ae$export$76575b7bf4de1f40;
    if (/\blocalhost\b/i.test(endpoint) || /\b127\.0\.0\.1\b/.test(endpoint)) return 0, $94222f6f6d5eb9ae$export$483699a75281444c;
    return 0, $94222f6f6d5eb9ae$export$bba9a228295b3963;
}
function $caf6e9babadef711$export$c9b15526ee38efba(chain, endpoint) {
    if (endpoint) return endpoint;
    if (chain === (0, $94222f6f6d5eb9ae$export$bba9a228295b3963)) return $caf6e9babadef711$export$9462d80112b287bf;
    if (chain === (0, $94222f6f6d5eb9ae$export$654cc095bd2e650)) return $caf6e9babadef711$export$2416cc3545b31c3b;
    if (chain === (0, $94222f6f6d5eb9ae$export$76575b7bf4de1f40)) return $caf6e9babadef711$export$fe3dc909dfa57ddb;
    if (chain === (0, $94222f6f6d5eb9ae$export$483699a75281444c)) return $caf6e9babadef711$export$ec9ed1d68bb4713f;
    return $caf6e9babadef711$export$9462d80112b287bf;
}

/**
 * TODO: docs
 */ function $1b04b98e984e3e26$export$430b2bce150d42d4(commitment) {
    switch(commitment){
        case "processed":
        case "confirmed":
        case "finalized":
        case undefined:
            return commitment;
        case "recent":
            return "processed";
        case "single":
        case "singleGossip":
            return "confirmed";
        case "max":
        case "root":
            return "finalized";
        default:
            return undefined;
    }
}



/** Name of the feature. */ const $29bdd67e64b9473a$export$38dbd4bbb9b696e6 = "standard:disconnect";
const $29bdd67e64b9473a$export$9e282393ab352bcd = $29bdd67e64b9473a$export$38dbd4bbb9b696e6;


var $751d38c9a7d6a682$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $751d38c9a7d6a682$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $751d38c9a7d6a682$var$_ReadonlyWalletAccount_address, $751d38c9a7d6a682$var$_ReadonlyWalletAccount_publicKey, $751d38c9a7d6a682$var$_ReadonlyWalletAccount_chains, $751d38c9a7d6a682$var$_ReadonlyWalletAccount_features, $751d38c9a7d6a682$var$_ReadonlyWalletAccount_label, $751d38c9a7d6a682$var$_ReadonlyWalletAccount_icon;
class $751d38c9a7d6a682$export$c0ac434c7ac96eb0 {
    /**
     * Create and freeze a read-only account.
     *
     * @param account Account to copy properties from.
     */ constructor(account){
        $751d38c9a7d6a682$var$_ReadonlyWalletAccount_address.set(this, void 0);
        $751d38c9a7d6a682$var$_ReadonlyWalletAccount_publicKey.set(this, void 0);
        $751d38c9a7d6a682$var$_ReadonlyWalletAccount_chains.set(this, void 0);
        $751d38c9a7d6a682$var$_ReadonlyWalletAccount_features.set(this, void 0);
        $751d38c9a7d6a682$var$_ReadonlyWalletAccount_label.set(this, void 0);
        $751d38c9a7d6a682$var$_ReadonlyWalletAccount_icon.set(this, void 0);
        if (new.target === $751d38c9a7d6a682$export$c0ac434c7ac96eb0) Object.freeze(this);
        $751d38c9a7d6a682$var$__classPrivateFieldSet(this, $751d38c9a7d6a682$var$_ReadonlyWalletAccount_address, account.address, "f");
        $751d38c9a7d6a682$var$__classPrivateFieldSet(this, $751d38c9a7d6a682$var$_ReadonlyWalletAccount_publicKey, account.publicKey.slice(), "f");
        $751d38c9a7d6a682$var$__classPrivateFieldSet(this, $751d38c9a7d6a682$var$_ReadonlyWalletAccount_chains, account.chains.slice(), "f");
        $751d38c9a7d6a682$var$__classPrivateFieldSet(this, $751d38c9a7d6a682$var$_ReadonlyWalletAccount_features, account.features.slice(), "f");
        $751d38c9a7d6a682$var$__classPrivateFieldSet(this, $751d38c9a7d6a682$var$_ReadonlyWalletAccount_label, account.label, "f");
        $751d38c9a7d6a682$var$__classPrivateFieldSet(this, $751d38c9a7d6a682$var$_ReadonlyWalletAccount_icon, account.icon, "f");
    }
    /** Implementation of {@link "@wallet-standard/base".WalletAccount.address | WalletAccount::address} */ get address() {
        return $751d38c9a7d6a682$var$__classPrivateFieldGet(this, $751d38c9a7d6a682$var$_ReadonlyWalletAccount_address, "f");
    }
    /** Implementation of {@link "@wallet-standard/base".WalletAccount.publicKey | WalletAccount::publicKey} */ get publicKey() {
        return $751d38c9a7d6a682$var$__classPrivateFieldGet(this, $751d38c9a7d6a682$var$_ReadonlyWalletAccount_publicKey, "f").slice();
    }
    /** Implementation of {@link "@wallet-standard/base".WalletAccount.chains | WalletAccount::chains} */ get chains() {
        return $751d38c9a7d6a682$var$__classPrivateFieldGet(this, $751d38c9a7d6a682$var$_ReadonlyWalletAccount_chains, "f").slice();
    }
    /** Implementation of {@link "@wallet-standard/base".WalletAccount.features | WalletAccount::features} */ get features() {
        return $751d38c9a7d6a682$var$__classPrivateFieldGet(this, $751d38c9a7d6a682$var$_ReadonlyWalletAccount_features, "f").slice();
    }
    /** Implementation of {@link "@wallet-standard/base".WalletAccount.label | WalletAccount::label} */ get label() {
        return $751d38c9a7d6a682$var$__classPrivateFieldGet(this, $751d38c9a7d6a682$var$_ReadonlyWalletAccount_label, "f");
    }
    /** Implementation of {@link "@wallet-standard/base".WalletAccount.icon | WalletAccount::icon} */ get icon() {
        return $751d38c9a7d6a682$var$__classPrivateFieldGet(this, $751d38c9a7d6a682$var$_ReadonlyWalletAccount_icon, "f");
    }
}
$751d38c9a7d6a682$var$_ReadonlyWalletAccount_address = new WeakMap(), $751d38c9a7d6a682$var$_ReadonlyWalletAccount_publicKey = new WeakMap(), $751d38c9a7d6a682$var$_ReadonlyWalletAccount_chains = new WeakMap(), $751d38c9a7d6a682$var$_ReadonlyWalletAccount_features = new WeakMap(), $751d38c9a7d6a682$var$_ReadonlyWalletAccount_label = new WeakMap(), $751d38c9a7d6a682$var$_ReadonlyWalletAccount_icon = new WeakMap();
function $751d38c9a7d6a682$export$234180f8206db11b(a, b) {
    if (a === b) return true;
    const length = a.length;
    if (length !== b.length) return false;
    for(let i = 0; i < length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $751d38c9a7d6a682$export$c663ab80cce302c5(a, b) {
    return $751d38c9a7d6a682$export$234180f8206db11b(a, b);
}
function $751d38c9a7d6a682$export$287dd7971339c972(first, ...others) {
    const length = others.reduce((length, bytes)=>length + bytes.length, first.length);
    const bytes = new Uint8Array(length);
    bytes.set(first, 0);
    for (const other of others)bytes.set(other, bytes.length);
    return bytes;
}
function $751d38c9a7d6a682$export$357523c63a2253b9(source, ...keys) {
    const picked = {};
    for (const key of keys)picked[key] = source[key];
    return picked;
}
function $751d38c9a7d6a682$export$864d727b48066337(callback) {
    try {
        callback();
    } catch (error) {
        console.error(error);
    }
}


var $6a9f3747d4ce57da$exports = {};

var $fq3eW = parcelRequire("fq3eW");
var $6a9f3747d4ce57da$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
$6a9f3747d4ce57da$exports = $fq3eW($6a9f3747d4ce57da$var$ALPHABET);


var $80ecef73e160ddb1$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $80ecef73e160ddb1$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $80ecef73e160ddb1$var$_StandardWalletAdapter_instances, $80ecef73e160ddb1$var$_StandardWalletAdapter_account, $80ecef73e160ddb1$var$_StandardWalletAdapter_publicKey, $80ecef73e160ddb1$var$_StandardWalletAdapter_connecting, $80ecef73e160ddb1$var$_StandardWalletAdapter_disconnecting, $80ecef73e160ddb1$var$_StandardWalletAdapter_off, $80ecef73e160ddb1$var$_StandardWalletAdapter_supportedTransactionVersions, $80ecef73e160ddb1$var$_StandardWalletAdapter_wallet, $80ecef73e160ddb1$var$_StandardWalletAdapter_readyState, $80ecef73e160ddb1$var$_StandardWalletAdapter_connect, $80ecef73e160ddb1$var$_StandardWalletAdapter_connected, $80ecef73e160ddb1$var$_StandardWalletAdapter_disconnected, $80ecef73e160ddb1$var$_StandardWalletAdapter_reset, $80ecef73e160ddb1$var$_StandardWalletAdapter_changed, $80ecef73e160ddb1$var$_StandardWalletAdapter_signTransaction, $80ecef73e160ddb1$var$_StandardWalletAdapter_signAllTransactions, $80ecef73e160ddb1$var$_StandardWalletAdapter_signMessage, $80ecef73e160ddb1$var$_StandardWalletAdapter_signIn;
class $80ecef73e160ddb1$export$e0949de9e32fe3b2 extends (0, $3020024d0a1e39a2$export$2af1ea2892adc469) {
    constructor({ wallet: wallet }){
        super();
        $80ecef73e160ddb1$var$_StandardWalletAdapter_instances.add(this);
        $80ecef73e160ddb1$var$_StandardWalletAdapter_account.set(this, void 0);
        $80ecef73e160ddb1$var$_StandardWalletAdapter_publicKey.set(this, void 0);
        $80ecef73e160ddb1$var$_StandardWalletAdapter_connecting.set(this, void 0);
        $80ecef73e160ddb1$var$_StandardWalletAdapter_disconnecting.set(this, void 0);
        $80ecef73e160ddb1$var$_StandardWalletAdapter_off.set(this, void 0);
        $80ecef73e160ddb1$var$_StandardWalletAdapter_supportedTransactionVersions.set(this, void 0);
        $80ecef73e160ddb1$var$_StandardWalletAdapter_wallet.set(this, void 0);
        $80ecef73e160ddb1$var$_StandardWalletAdapter_readyState.set(this, typeof window === "undefined" || typeof document === "undefined" ? (0, $3020024d0a1e39a2$export$2a7b8071105d05b6).Unsupported : (0, $3020024d0a1e39a2$export$2a7b8071105d05b6).Installed);
        $80ecef73e160ddb1$var$_StandardWalletAdapter_changed.set(this, (properties)=>{
            // If accounts have changed on the wallet, reflect this on the adapter.
            if ("accounts" in properties) {
                const account = $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_wallet, "f").accounts[0];
                // If the adapter isn't connected, or is disconnecting, or the first account hasn't changed, do nothing.
                if ($80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_account, "f") && !$80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_disconnecting, "f") && account !== $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_account, "f")) {
                    // If there's a connected account, connect the adapter. Otherwise, disconnect it.
                    if (account) // Connect the adapter.
                    $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_instances, "m", $80ecef73e160ddb1$var$_StandardWalletAdapter_connected).call(this, account);
                    else {
                        // Emit an error because the wallet spontaneously disconnected.
                        this.emit("error", new (0, $954228dd8da6435a$export$bf7028c52ebda81e)());
                        // Disconnect the adapter.
                        $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_instances, "m", $80ecef73e160ddb1$var$_StandardWalletAdapter_disconnected).call(this);
                    }
                }
            }
            // After reflecting account changes, if features have changed on the wallet, reflect this on the adapter.
            if ("features" in properties) $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_instances, "m", $80ecef73e160ddb1$var$_StandardWalletAdapter_reset).call(this);
        });
        $80ecef73e160ddb1$var$__classPrivateFieldSet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_wallet, wallet, "f");
        $80ecef73e160ddb1$var$__classPrivateFieldSet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_account, null, "f");
        $80ecef73e160ddb1$var$__classPrivateFieldSet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_publicKey, null, "f");
        $80ecef73e160ddb1$var$__classPrivateFieldSet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_connecting, false, "f");
        $80ecef73e160ddb1$var$__classPrivateFieldSet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_disconnecting, false, "f");
        $80ecef73e160ddb1$var$__classPrivateFieldSet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_off, $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_wallet, "f").features[0, $efa6324668e2a12c$export$5296443ca9e9fa0f].on("change", $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_changed, "f")), "f");
        $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_instances, "m", $80ecef73e160ddb1$var$_StandardWalletAdapter_reset).call(this);
    }
    get name() {
        return $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_wallet, "f").name;
    }
    get url() {
        return "https://github.com/solana-labs/wallet-standard";
    }
    get icon() {
        return $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_wallet, "f").icon;
    }
    get readyState() {
        return $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_readyState, "f");
    }
    get publicKey() {
        return $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_publicKey, "f");
    }
    get connecting() {
        return $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_connecting, "f");
    }
    get supportedTransactionVersions() {
        return $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_supportedTransactionVersions, "f");
    }
    get wallet() {
        return $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_wallet, "f");
    }
    get standard() {
        return true;
    }
    destroy() {
        $80ecef73e160ddb1$var$__classPrivateFieldSet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_account, null, "f");
        $80ecef73e160ddb1$var$__classPrivateFieldSet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_publicKey, null, "f");
        $80ecef73e160ddb1$var$__classPrivateFieldSet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_connecting, false, "f");
        $80ecef73e160ddb1$var$__classPrivateFieldSet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_disconnecting, false, "f");
        const off = $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_off, "f");
        if (off) {
            $80ecef73e160ddb1$var$__classPrivateFieldSet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_off, null, "f");
            off();
        }
    }
    async autoConnect() {
        return $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_instances, "m", $80ecef73e160ddb1$var$_StandardWalletAdapter_connect).call(this, {
            silent: true
        });
    }
    async connect() {
        return $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_instances, "m", $80ecef73e160ddb1$var$_StandardWalletAdapter_connect).call(this);
    }
    async disconnect() {
        if ((0, $29bdd67e64b9473a$export$38dbd4bbb9b696e6) in $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_wallet, "f").features) try {
            $80ecef73e160ddb1$var$__classPrivateFieldSet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_disconnecting, true, "f");
            await $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_wallet, "f").features[0, $29bdd67e64b9473a$export$38dbd4bbb9b696e6].disconnect();
        } catch (error) {
            this.emit("error", new (0, $954228dd8da6435a$export$92e2b26fad5723ee)(error?.message, error));
        } finally{
            $80ecef73e160ddb1$var$__classPrivateFieldSet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_disconnecting, false, "f");
        }
        $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_instances, "m", $80ecef73e160ddb1$var$_StandardWalletAdapter_disconnected).call(this);
    }
    async sendTransaction(transaction, connection, options = {}) {
        try {
            const account = $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_account, "f");
            if (!account) throw new (0, $954228dd8da6435a$export$313d299817c74896)();
            let feature;
            if ((0, $e319821bd2655536$export$dd64f32469f35f81) in $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_wallet, "f").features) {
                if (account.features.includes((0, $e319821bd2655536$export$dd64f32469f35f81))) feature = (0, $e319821bd2655536$export$dd64f32469f35f81);
                else if ((0, $7e43716d533d38e1$export$54187c3796d0ecb) in $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_wallet, "f").features && account.features.includes((0, $7e43716d533d38e1$export$54187c3796d0ecb))) feature = (0, $7e43716d533d38e1$export$54187c3796d0ecb);
                else throw new (0, $954228dd8da6435a$export$cd6fa2f8e2a8a612)();
            } else if ((0, $7e43716d533d38e1$export$54187c3796d0ecb) in $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_wallet, "f").features) {
                if (!account.features.includes((0, $7e43716d533d38e1$export$54187c3796d0ecb))) throw new (0, $954228dd8da6435a$export$cd6fa2f8e2a8a612)();
                feature = (0, $7e43716d533d38e1$export$54187c3796d0ecb);
            } else throw new (0, $954228dd8da6435a$export$9525019988612a5e)();
            const chain = (0, $caf6e9babadef711$export$43dcd8213c5a5741)(connection.rpcEndpoint);
            if (!account.chains.includes(chain)) throw new (0, $954228dd8da6435a$export$769332ac3f90f46c)();
            try {
                const { signers: signers, ...sendOptions } = options;
                let serializedTransaction;
                if ((0, $b38f111071774614$export$37ce1cc82e255d8)(transaction)) {
                    signers?.length && transaction.sign(signers);
                    serializedTransaction = transaction.serialize();
                } else {
                    transaction = await this.prepareTransaction(transaction, connection, sendOptions);
                    signers?.length && transaction.partialSign(...signers);
                    serializedTransaction = new Uint8Array(transaction.serialize({
                        requireAllSignatures: false,
                        verifySignatures: false
                    }));
                }
                if (feature === (0, $e319821bd2655536$export$dd64f32469f35f81)) {
                    const [output] = await $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_wallet, "f").features[0, $e319821bd2655536$export$dd64f32469f35f81].signAndSendTransaction({
                        account: account,
                        chain: chain,
                        transaction: serializedTransaction,
                        options: {
                            preflightCommitment: (0, $1b04b98e984e3e26$export$430b2bce150d42d4)(sendOptions.preflightCommitment || connection.commitment),
                            skipPreflight: sendOptions.skipPreflight,
                            maxRetries: sendOptions.maxRetries,
                            minContextSlot: sendOptions.minContextSlot
                        }
                    });
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    return (0, (/*@__PURE__*/$parcel$interopDefault($6a9f3747d4ce57da$exports))).encode(output.signature);
                } else {
                    const [output] = await $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_wallet, "f").features[0, $7e43716d533d38e1$export$54187c3796d0ecb].signTransaction({
                        account: account,
                        chain: chain,
                        transaction: serializedTransaction,
                        options: {
                            preflightCommitment: (0, $1b04b98e984e3e26$export$430b2bce150d42d4)(sendOptions.preflightCommitment || connection.commitment),
                            minContextSlot: sendOptions.minContextSlot
                        }
                    });
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    return await connection.sendRawTransaction(output.signedTransaction, {
                        ...sendOptions,
                        preflightCommitment: (0, $1b04b98e984e3e26$export$430b2bce150d42d4)(sendOptions.preflightCommitment || connection.commitment)
                    });
                }
            } catch (error) {
                if (error instanceof (0, $954228dd8da6435a$export$f46ec6f9dba8711d)) throw error;
                throw new (0, $954228dd8da6435a$export$769332ac3f90f46c)(error?.message, error);
            }
        } catch (error) {
            this.emit("error", error);
            throw error;
        }
    }
}
$80ecef73e160ddb1$var$_StandardWalletAdapter_account = new WeakMap(), $80ecef73e160ddb1$var$_StandardWalletAdapter_publicKey = new WeakMap(), $80ecef73e160ddb1$var$_StandardWalletAdapter_connecting = new WeakMap(), $80ecef73e160ddb1$var$_StandardWalletAdapter_disconnecting = new WeakMap(), $80ecef73e160ddb1$var$_StandardWalletAdapter_off = new WeakMap(), $80ecef73e160ddb1$var$_StandardWalletAdapter_supportedTransactionVersions = new WeakMap(), $80ecef73e160ddb1$var$_StandardWalletAdapter_wallet = new WeakMap(), $80ecef73e160ddb1$var$_StandardWalletAdapter_readyState = new WeakMap(), $80ecef73e160ddb1$var$_StandardWalletAdapter_changed = new WeakMap(), $80ecef73e160ddb1$var$_StandardWalletAdapter_instances = new WeakSet(), $80ecef73e160ddb1$var$_StandardWalletAdapter_connect = async function _StandardWalletAdapter_connect(input) {
    try {
        if (this.connected || this.connecting) return;
        if ($80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_readyState, "f") !== (0, $3020024d0a1e39a2$export$2a7b8071105d05b6).Installed) throw new (0, $954228dd8da6435a$export$d65db264eda99cd7)();
        $80ecef73e160ddb1$var$__classPrivateFieldSet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_connecting, true, "f");
        if (!$80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_wallet, "f").accounts.length) try {
            await $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_wallet, "f").features[0, $941284cd50281772$export$cc68487eeb93b1d4].connect(input);
        } catch (error) {
            throw new (0, $954228dd8da6435a$export$38f21f1c810261c7)(error?.message, error);
        }
        const account = $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_wallet, "f").accounts[0];
        if (!account) throw new (0, $954228dd8da6435a$export$cd6fa2f8e2a8a612)();
        $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_instances, "m", $80ecef73e160ddb1$var$_StandardWalletAdapter_connected).call(this, account);
    } catch (error) {
        this.emit("error", error);
        throw error;
    } finally{
        $80ecef73e160ddb1$var$__classPrivateFieldSet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_connecting, false, "f");
    }
}, $80ecef73e160ddb1$var$_StandardWalletAdapter_connected = function _StandardWalletAdapter_connected(account) {
    let publicKey;
    try {
        // Use account.address instead of account.publicKey since address could be a PDA
        publicKey = new (0, $ca3473265f76df98$export$ca8b6604d6ce14de)(account.address);
    } catch (error) {
        throw new (0, $954228dd8da6435a$export$735bef3bfb0f2c86)(error?.message, error);
    }
    $80ecef73e160ddb1$var$__classPrivateFieldSet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_account, account, "f");
    $80ecef73e160ddb1$var$__classPrivateFieldSet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_publicKey, publicKey, "f");
    $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_instances, "m", $80ecef73e160ddb1$var$_StandardWalletAdapter_reset).call(this);
    this.emit("connect", publicKey);
}, $80ecef73e160ddb1$var$_StandardWalletAdapter_disconnected = function _StandardWalletAdapter_disconnected() {
    $80ecef73e160ddb1$var$__classPrivateFieldSet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_account, null, "f");
    $80ecef73e160ddb1$var$__classPrivateFieldSet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_publicKey, null, "f");
    $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_instances, "m", $80ecef73e160ddb1$var$_StandardWalletAdapter_reset).call(this);
    this.emit("disconnect");
}, $80ecef73e160ddb1$var$_StandardWalletAdapter_reset = function _StandardWalletAdapter_reset() {
    const supportedTransactionVersions = (0, $e319821bd2655536$export$dd64f32469f35f81) in $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_wallet, "f").features ? $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_wallet, "f").features[0, $e319821bd2655536$export$dd64f32469f35f81].supportedTransactionVersions : $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_wallet, "f").features[0, $7e43716d533d38e1$export$54187c3796d0ecb].supportedTransactionVersions;
    $80ecef73e160ddb1$var$__classPrivateFieldSet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_supportedTransactionVersions, (0, $751d38c9a7d6a682$export$234180f8206db11b)(supportedTransactionVersions, [
        "legacy"
    ]) ? null : new Set(supportedTransactionVersions), "f");
    if ((0, $7e43716d533d38e1$export$54187c3796d0ecb) in $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_wallet, "f").features && $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_account, "f")?.features.includes((0, $7e43716d533d38e1$export$54187c3796d0ecb))) {
        this.signTransaction = $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_instances, "m", $80ecef73e160ddb1$var$_StandardWalletAdapter_signTransaction);
        this.signAllTransactions = $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_instances, "m", $80ecef73e160ddb1$var$_StandardWalletAdapter_signAllTransactions);
    } else {
        delete this.signTransaction;
        delete this.signAllTransactions;
    }
    if ((0, $91c3efc23d0fa34e$export$22c7939a38084172) in $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_wallet, "f").features && $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_account, "f")?.features.includes((0, $91c3efc23d0fa34e$export$22c7939a38084172))) this.signMessage = $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_instances, "m", $80ecef73e160ddb1$var$_StandardWalletAdapter_signMessage);
    else delete this.signMessage;
    if ((0, $930e150235cdcc35$export$8adeab75f48a3607) in $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_wallet, "f").features) this.signIn = $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_instances, "m", $80ecef73e160ddb1$var$_StandardWalletAdapter_signIn);
    else delete this.signIn;
}, $80ecef73e160ddb1$var$_StandardWalletAdapter_signTransaction = async function _StandardWalletAdapter_signTransaction(transaction) {
    try {
        const account = $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_account, "f");
        if (!account) throw new (0, $954228dd8da6435a$export$313d299817c74896)();
        if (!((0, $7e43716d533d38e1$export$54187c3796d0ecb) in $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_wallet, "f").features)) throw new (0, $954228dd8da6435a$export$9525019988612a5e)();
        if (!account.features.includes((0, $7e43716d533d38e1$export$54187c3796d0ecb))) throw new (0, $954228dd8da6435a$export$cd6fa2f8e2a8a612)();
        try {
            const signedTransactions = await $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_wallet, "f").features[0, $7e43716d533d38e1$export$54187c3796d0ecb].signTransaction({
                account: account,
                transaction: (0, $b38f111071774614$export$37ce1cc82e255d8)(transaction) ? transaction.serialize() : new Uint8Array(transaction.serialize({
                    requireAllSignatures: false,
                    verifySignatures: false
                }))
            });
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const serializedTransaction = signedTransactions[0].signedTransaction;
            return (0, $b38f111071774614$export$37ce1cc82e255d8)(transaction) ? (0, $ca3473265f76df98$export$232cc3f078dcc284).deserialize(serializedTransaction) : (0, $ca3473265f76df98$export$febc5573c75cefb0).from(serializedTransaction);
        } catch (error) {
            if (error instanceof (0, $954228dd8da6435a$export$f46ec6f9dba8711d)) throw error;
            throw new (0, $954228dd8da6435a$export$96f177062fdd8180)(error?.message, error);
        }
    } catch (error) {
        this.emit("error", error);
        throw error;
    }
}, $80ecef73e160ddb1$var$_StandardWalletAdapter_signAllTransactions = async function _StandardWalletAdapter_signAllTransactions(transactions) {
    try {
        const account = $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_account, "f");
        if (!account) throw new (0, $954228dd8da6435a$export$313d299817c74896)();
        if (!((0, $7e43716d533d38e1$export$54187c3796d0ecb) in $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_wallet, "f").features)) throw new (0, $954228dd8da6435a$export$9525019988612a5e)();
        if (!account.features.includes((0, $7e43716d533d38e1$export$54187c3796d0ecb))) throw new (0, $954228dd8da6435a$export$cd6fa2f8e2a8a612)();
        try {
            const signedTransactions = await $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_wallet, "f").features[0, $7e43716d533d38e1$export$54187c3796d0ecb].signTransaction(...transactions.map((transaction)=>({
                    account: account,
                    transaction: (0, $b38f111071774614$export$37ce1cc82e255d8)(transaction) ? transaction.serialize() : new Uint8Array(transaction.serialize({
                        requireAllSignatures: false,
                        verifySignatures: false
                    }))
                })));
            return transactions.map((transaction, index)=>{
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const signedTransaction = signedTransactions[index].signedTransaction;
                return (0, $b38f111071774614$export$37ce1cc82e255d8)(transaction) ? (0, $ca3473265f76df98$export$232cc3f078dcc284).deserialize(signedTransaction) : (0, $ca3473265f76df98$export$febc5573c75cefb0).from(signedTransaction);
            });
        } catch (error) {
            throw new (0, $954228dd8da6435a$export$96f177062fdd8180)(error?.message, error);
        }
    } catch (error) {
        this.emit("error", error);
        throw error;
    }
}, $80ecef73e160ddb1$var$_StandardWalletAdapter_signMessage = async function _StandardWalletAdapter_signMessage(message) {
    try {
        const account = $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_account, "f");
        if (!account) throw new (0, $954228dd8da6435a$export$313d299817c74896)();
        if (!((0, $91c3efc23d0fa34e$export$22c7939a38084172) in $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_wallet, "f").features)) throw new (0, $954228dd8da6435a$export$9525019988612a5e)();
        if (!account.features.includes((0, $91c3efc23d0fa34e$export$22c7939a38084172))) throw new (0, $954228dd8da6435a$export$cd6fa2f8e2a8a612)();
        try {
            const signedMessages = await $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_wallet, "f").features[0, $91c3efc23d0fa34e$export$22c7939a38084172].signMessage({
                account: account,
                message: message
            });
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return signedMessages[0].signature;
        } catch (error) {
            throw new (0, $954228dd8da6435a$export$2622c1721bbd4b17)(error?.message, error);
        }
    } catch (error) {
        this.emit("error", error);
        throw error;
    }
}, $80ecef73e160ddb1$var$_StandardWalletAdapter_signIn = async function _StandardWalletAdapter_signIn(input = {}) {
    try {
        if (!((0, $930e150235cdcc35$export$8adeab75f48a3607) in $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_wallet, "f").features)) throw new (0, $954228dd8da6435a$export$9525019988612a5e)();
        let output;
        try {
            [output] = await $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_wallet, "f").features[0, $930e150235cdcc35$export$8adeab75f48a3607].signIn(input);
        } catch (error) {
            throw new (0, $954228dd8da6435a$export$a4c7d3c66e3cdd6c)(error?.message, error);
        }
        if (!output) throw new (0, $954228dd8da6435a$export$a4c7d3c66e3cdd6c)();
        $80ecef73e160ddb1$var$__classPrivateFieldGet(this, $80ecef73e160ddb1$var$_StandardWalletAdapter_instances, "m", $80ecef73e160ddb1$var$_StandardWalletAdapter_connected).call(this, output.account);
        return output;
    } catch (error) {
        this.emit("error", error);
        throw error;
    }
};


var $64cebd98488ae068$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $64cebd98488ae068$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $64cebd98488ae068$var$_AppReadyEvent_detail;
let $64cebd98488ae068$var$wallets = undefined;
const $64cebd98488ae068$var$registered = new Set();
const $64cebd98488ae068$var$listeners = {};
function $64cebd98488ae068$export$ac4d188b6eef3eb7() {
    if ($64cebd98488ae068$var$wallets) return $64cebd98488ae068$var$wallets;
    $64cebd98488ae068$var$wallets = Object.freeze({
        register: $64cebd98488ae068$var$register,
        get: $64cebd98488ae068$var$get,
        on: $64cebd98488ae068$var$on
    });
    if (typeof window === "undefined") return $64cebd98488ae068$var$wallets;
    const api = Object.freeze({
        register: $64cebd98488ae068$var$register
    });
    try {
        window.addEventListener("wallet-standard:register-wallet", ({ detail: callback })=>callback(api));
    } catch (error) {
        console.error("wallet-standard:register-wallet event listener could not be added\n", error);
    }
    try {
        window.dispatchEvent(new $64cebd98488ae068$var$AppReadyEvent(api));
    } catch (error) {
        console.error("wallet-standard:app-ready event could not be dispatched\n", error);
    }
    return $64cebd98488ae068$var$wallets;
}
function $64cebd98488ae068$var$register(...wallets) {
    // Filter out wallets that have already been registered.
    // This prevents the same wallet from being registered twice, but it also prevents wallets from being
    // unregistered by reusing a reference to the wallet to obtain the unregister function for it.
    wallets = wallets.filter((wallet)=>!$64cebd98488ae068$var$registered.has(wallet));
    // If there are no new wallets to register, just return a no-op unregister function.
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    if (!wallets.length) return ()=>{};
    wallets.forEach((wallet)=>$64cebd98488ae068$var$registered.add(wallet));
    $64cebd98488ae068$var$listeners["register"]?.forEach((listener)=>$64cebd98488ae068$var$guard(()=>listener(...wallets)));
    // Return a function that unregisters the registered wallets.
    return function unregister() {
        wallets.forEach((wallet)=>$64cebd98488ae068$var$registered.delete(wallet));
        $64cebd98488ae068$var$listeners["unregister"]?.forEach((listener)=>$64cebd98488ae068$var$guard(()=>listener(...wallets)));
    };
}
function $64cebd98488ae068$var$get() {
    return [
        ...$64cebd98488ae068$var$registered
    ];
}
function $64cebd98488ae068$var$on(event, listener) {
    $64cebd98488ae068$var$listeners[event]?.push(listener) || ($64cebd98488ae068$var$listeners[event] = [
        listener
    ]);
    // Return a function that removes the event listener.
    return function off() {
        $64cebd98488ae068$var$listeners[event] = $64cebd98488ae068$var$listeners[event]?.filter((existingListener)=>listener !== existingListener);
    };
}
function $64cebd98488ae068$var$guard(callback) {
    try {
        callback();
    } catch (error) {
        console.error(error);
    }
}
class $64cebd98488ae068$var$AppReadyEvent extends Event {
    constructor(api){
        super("wallet-standard:app-ready", {
            bubbles: false,
            cancelable: false,
            composed: false
        });
        $64cebd98488ae068$var$_AppReadyEvent_detail.set(this, void 0);
        $64cebd98488ae068$var$__classPrivateFieldSet(this, $64cebd98488ae068$var$_AppReadyEvent_detail, api, "f");
    }
    get detail() {
        return $64cebd98488ae068$var$__classPrivateFieldGet(this, $64cebd98488ae068$var$_AppReadyEvent_detail, "f");
    }
    get type() {
        return "wallet-standard:app-ready";
    }
    /** @deprecated */ preventDefault() {
        throw new Error("preventDefault cannot be called");
    }
    /** @deprecated */ stopImmediatePropagation() {
        throw new Error("stopImmediatePropagation cannot be called");
    }
    /** @deprecated */ stopPropagation() {
        throw new Error("stopPropagation cannot be called");
    }
}
$64cebd98488ae068$var$_AppReadyEvent_detail = new WeakMap();
function $64cebd98488ae068$export$2194deb72a59836d() {
    if ($64cebd98488ae068$var$wallets) return $64cebd98488ae068$var$wallets;
    $64cebd98488ae068$var$wallets = $64cebd98488ae068$export$ac4d188b6eef3eb7();
    if (typeof window === "undefined") return $64cebd98488ae068$var$wallets;
    const callbacks = window.navigator.wallets || [];
    if (!Array.isArray(callbacks)) {
        console.error("window.navigator.wallets is not an array");
        return $64cebd98488ae068$var$wallets;
    }
    const { register: register } = $64cebd98488ae068$var$wallets;
    const push = (...callbacks)=>callbacks.forEach((callback)=>$64cebd98488ae068$var$guard(()=>callback({
                    register: register
                })));
    try {
        Object.defineProperty(window.navigator, "wallets", {
            value: Object.freeze({
                push: push
            })
        });
    } catch (error) {
        console.error("window.navigator.wallets could not be set");
        return $64cebd98488ae068$var$wallets;
    }
    push(...callbacks);
    return $64cebd98488ae068$var$wallets;
}



var $8NFma = parcelRequire("8NFma");
function $5022e3fc9941ddce$export$ca3bd81d254ceecf(adapters) {
    const warnings = $5022e3fc9941ddce$var$useConstant(()=>new Set());
    const { get: get, on: on } = $5022e3fc9941ddce$var$useConstant(()=>(0, $64cebd98488ae068$export$2194deb72a59836d)());
    const [standardAdapters, setStandardAdapters] = (0, $8NFma.useState)(()=>$5022e3fc9941ddce$var$wrapWalletsWithAdapters(get()));
    (0, $8NFma.useEffect)(()=>{
        const listeners = [
            on("register", (...wallets)=>setStandardAdapters((standardAdapters)=>[
                        ...standardAdapters,
                        ...$5022e3fc9941ddce$var$wrapWalletsWithAdapters(wallets)
                    ])),
            on("unregister", (...wallets)=>setStandardAdapters((standardAdapters)=>standardAdapters.filter((standardAdapter)=>wallets.some((wallet)=>wallet === standardAdapter.wallet))))
        ];
        return ()=>listeners.forEach((off)=>off());
    }, [
        on
    ]);
    const prevStandardAdapters = $5022e3fc9941ddce$var$usePrevious(standardAdapters);
    (0, $8NFma.useEffect)(()=>{
        if (!prevStandardAdapters) return;
        const currentAdapters = new Set(standardAdapters);
        const removedAdapters = new Set(prevStandardAdapters.filter((previousAdapter)=>!currentAdapters.has(previousAdapter)));
        removedAdapters.forEach((adapter)=>adapter.destroy());
    }, [
        prevStandardAdapters,
        standardAdapters
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $8NFma.useEffect)(()=>()=>standardAdapters.forEach((adapter)=>adapter.destroy()), []);
    return (0, $8NFma.useMemo)(()=>[
            ...standardAdapters,
            ...adapters.filter(({ name: name })=>{
                if (standardAdapters.some((standardAdapter)=>standardAdapter.name === name)) {
                    if (!warnings.has(name)) {
                        warnings.add(name);
                        console.warn(`${name} was registered as a Standard Wallet. The Wallet Adapter for ${name} can be removed from your app.`);
                    }
                    return false;
                }
                return true;
            })
        ], [
        standardAdapters,
        adapters,
        warnings
    ]);
}
function $5022e3fc9941ddce$var$useConstant(fn) {
    const ref = (0, $8NFma.useRef)();
    if (!ref.current) ref.current = {
        value: fn()
    };
    return ref.current.value;
}
function $5022e3fc9941ddce$var$usePrevious(state) {
    const ref = (0, $8NFma.useRef)();
    (0, $8NFma.useEffect)(()=>{
        ref.current = state;
    });
    return ref.current;
}
function $5022e3fc9941ddce$var$wrapWalletsWithAdapters(wallets) {
    return wallets.filter((0, $8d4fe5a2ddef9d4a$export$c5439c91843266e6)).map((wallet)=>new (0, $80ecef73e160ddb1$export$e0949de9e32fe3b2)({
            wallet: wallet
        }));
}



var $8NFma = parcelRequire("8NFma");


var $073c00c5df14fe0a$export$7dc6752a22ab011a;
(function(Environment) {
    Environment[Environment["DESKTOP_WEB"] = 0] = "DESKTOP_WEB";
    Environment[Environment["MOBILE_WEB"] = 1] = "MOBILE_WEB";
})($073c00c5df14fe0a$export$7dc6752a22ab011a || ($073c00c5df14fe0a$export$7dc6752a22ab011a = {}));
function $073c00c5df14fe0a$var$isWebView(userAgentString) {
    return /(WebView|Version\/.+(Chrome)\/(\d+)\.(\d+)\.(\d+)\.(\d+)|; wv\).+(Chrome)\/(\d+)\.(\d+)\.(\d+)\.(\d+))/i.test(userAgentString);
}
function $073c00c5df14fe0a$export$2e2bcd8739ae039({ adapters: adapters, userAgentString: userAgentString }) {
    if (adapters.some((adapter)=>adapter.name !== (0, $bf765e8a33bb400e$export$f1265e9082f346f1) && adapter.readyState === (0, $3020024d0a1e39a2$export$2a7b8071105d05b6).Installed)) /**
         * There are only two ways a browser extension adapter should be able to reach `Installed` status:
         *
         *     1. Its browser extension is installed.
         *     2. The app is running on a mobile wallet's in-app browser.
         *
         * In either case, we consider the environment to be desktop-like.
         */ return $073c00c5df14fe0a$export$7dc6752a22ab011a.DESKTOP_WEB;
    if (userAgentString && // Step 1: Check whether we're on a platform that supports MWA at all.
    /android/i.test(userAgentString) && // Step 2: Determine that we are *not* running in a WebView.
    !$073c00c5df14fe0a$var$isWebView(userAgentString)) return $073c00c5df14fe0a$export$7dc6752a22ab011a.MOBILE_WEB;
    else return $073c00c5df14fe0a$export$7dc6752a22ab011a.DESKTOP_WEB;
}


function $b1361d15209ac2ca$export$2e2bcd8739ae039(endpoint) {
    if (!endpoint) return "mainnet-beta";
    if (/devnet/i.test(endpoint)) return "devnet";
    else if (/testnet/i.test(endpoint)) return "testnet";
    else return "mainnet-beta";
}




var $8NFma = parcelRequire("8NFma");
function $349e3d3609890073$export$86e2cef2561044ac(key, defaultState) {
    const state = (0, $8NFma.useState)(()=>{
        try {
            const value = localStorage.getItem(key);
            if (value) return JSON.parse(value);
        } catch (error) {
            if (typeof window !== "undefined") console.error(error);
        }
        return defaultState;
    });
    const value = state[0];
    const isFirstRenderRef = (0, $8NFma.useRef)(true);
    (0, $8NFma.useEffect)(()=>{
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        try {
            if (value === null) localStorage.removeItem(key);
            else localStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
            if (typeof window !== "undefined") console.error(error);
        }
    }, [
        value,
        key
    ]);
    return state;
}




var $8NFma = parcelRequire("8NFma");

class $6d03393e51309fdd$export$3f5ccdf96415785c extends (0, $954228dd8da6435a$export$f46ec6f9dba8711d) {
    constructor(){
        super(...arguments);
        this.name = "WalletNotSelectedError";
    }
}



function $faac7c53a3ad5cdc$export$a50b3c99d691184b({ children: children, wallets: adapters, adapter: adapter, isUnloadingRef: isUnloadingRef, onAutoConnectRequest: onAutoConnectRequest, onConnectError: onConnectError, onError: onError, onSelectWallet: onSelectWallet }) {
    const isConnectingRef = (0, $8NFma.useRef)(false);
    const [connecting, setConnecting] = (0, $8NFma.useState)(false);
    const isDisconnectingRef = (0, $8NFma.useRef)(false);
    const [disconnecting, setDisconnecting] = (0, $8NFma.useState)(false);
    const [publicKey, setPublicKey] = (0, $8NFma.useState)(()=>adapter?.publicKey ?? null);
    const [connected, setConnected] = (0, $8NFma.useState)(()=>adapter?.connected ?? false);
    /**
     * Store the error handlers as refs so that a change in the
     * custom error handler does not recompute other dependencies.
     */ const onErrorRef = (0, $8NFma.useRef)(onError);
    (0, $8NFma.useEffect)(()=>{
        onErrorRef.current = onError;
        return ()=>{
            onErrorRef.current = undefined;
        };
    }, [
        onError
    ]);
    const handleErrorRef = (0, $8NFma.useRef)((error, adapter)=>{
        if (!isUnloadingRef.current) {
            if (onErrorRef.current) onErrorRef.current(error, adapter);
            else {
                console.error(error, adapter);
                if (error instanceof (0, $954228dd8da6435a$export$d65db264eda99cd7) && typeof window !== "undefined" && adapter) window.open(adapter.url, "_blank");
            }
        }
        return error;
    });
    // Wrap adapters to conform to the `Wallet` interface
    const [wallets, setWallets] = (0, $8NFma.useState)(()=>adapters.map((adapter)=>({
                adapter: adapter,
                readyState: adapter.readyState
            })).filter(({ readyState: readyState })=>readyState !== (0, $3020024d0a1e39a2$export$2a7b8071105d05b6).Unsupported));
    // When the adapters change, start to listen for changes to their `readyState`
    (0, $8NFma.useEffect)(()=>{
        // When the adapters change, wrap them to conform to the `Wallet` interface
        setWallets((wallets)=>adapters.map((adapter, index)=>{
                const wallet = wallets[index];
                // If the wallet hasn't changed, return the same instance
                return wallet && wallet.adapter === adapter && wallet.readyState === adapter.readyState ? wallet : {
                    adapter: adapter,
                    readyState: adapter.readyState
                };
            }).filter(({ readyState: readyState })=>readyState !== (0, $3020024d0a1e39a2$export$2a7b8071105d05b6).Unsupported));
        function handleReadyStateChange(readyState) {
            setWallets((prevWallets)=>{
                const index = prevWallets.findIndex(({ adapter: adapter })=>adapter === this);
                if (index === -1) return prevWallets;
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const { adapter: adapter } = prevWallets[index];
                return [
                    ...prevWallets.slice(0, index),
                    {
                        adapter: adapter,
                        readyState: readyState
                    },
                    ...prevWallets.slice(index + 1)
                ].filter(({ readyState: readyState })=>readyState !== (0, $3020024d0a1e39a2$export$2a7b8071105d05b6).Unsupported);
            });
        }
        adapters.forEach((adapter)=>adapter.on("readyStateChange", handleReadyStateChange, adapter));
        return ()=>{
            adapters.forEach((adapter)=>adapter.off("readyStateChange", handleReadyStateChange, adapter));
        };
    }, [
        adapter,
        adapters
    ]);
    const wallet = (0, $8NFma.useMemo)(()=>wallets.find((wallet)=>wallet.adapter === adapter) ?? null, [
        adapter,
        wallets
    ]);
    // Setup and teardown event listeners when the adapter changes
    (0, $8NFma.useEffect)(()=>{
        if (!adapter) return;
        const handleConnect = (publicKey)=>{
            setPublicKey(publicKey);
            isConnectingRef.current = false;
            setConnecting(false);
            setConnected(true);
            isDisconnectingRef.current = false;
            setDisconnecting(false);
        };
        const handleDisconnect = ()=>{
            if (isUnloadingRef.current) return;
            setPublicKey(null);
            isConnectingRef.current = false;
            setConnecting(false);
            setConnected(false);
            isDisconnectingRef.current = false;
            setDisconnecting(false);
        };
        const handleError = (error)=>{
            handleErrorRef.current(error, adapter);
        };
        adapter.on("connect", handleConnect);
        adapter.on("disconnect", handleDisconnect);
        adapter.on("error", handleError);
        return ()=>{
            adapter.off("connect", handleConnect);
            adapter.off("disconnect", handleDisconnect);
            adapter.off("error", handleError);
            handleDisconnect();
        };
    }, [
        adapter,
        isUnloadingRef
    ]);
    // When the adapter changes, clear the `autoConnect` tracking flag
    const didAttemptAutoConnectRef = (0, $8NFma.useRef)(false);
    (0, $8NFma.useEffect)(()=>{
        return ()=>{
            didAttemptAutoConnectRef.current = false;
        };
    }, [
        adapter
    ]);
    // If auto-connect is enabled, request to connect when the adapter changes and is ready
    (0, $8NFma.useEffect)(()=>{
        if (didAttemptAutoConnectRef.current || isConnectingRef.current || connected || !onAutoConnectRequest || !(wallet?.readyState === (0, $3020024d0a1e39a2$export$2a7b8071105d05b6).Installed || wallet?.readyState === (0, $3020024d0a1e39a2$export$2a7b8071105d05b6).Loadable)) return;
        isConnectingRef.current = true;
        setConnecting(true);
        didAttemptAutoConnectRef.current = true;
        (async function() {
            try {
                await onAutoConnectRequest();
            } catch  {
                onConnectError();
            // Drop the error. It will be caught by `handleError` anyway.
            } finally{
                setConnecting(false);
                isConnectingRef.current = false;
            }
        })();
    }, [
        connected,
        onAutoConnectRequest,
        onConnectError,
        wallet
    ]);
    // Send a transaction using the provided connection
    const sendTransaction = (0, $8NFma.useCallback)(async (transaction, connection, options)=>{
        if (!adapter) throw handleErrorRef.current(new (0, $6d03393e51309fdd$export$3f5ccdf96415785c)());
        if (!connected) throw handleErrorRef.current(new (0, $954228dd8da6435a$export$313d299817c74896)(), adapter);
        return await adapter.sendTransaction(transaction, connection, options);
    }, [
        adapter,
        connected
    ]);
    // Sign a transaction if the wallet supports it
    const signTransaction = (0, $8NFma.useMemo)(()=>adapter && "signTransaction" in adapter ? async (transaction)=>{
            if (!connected) throw handleErrorRef.current(new (0, $954228dd8da6435a$export$313d299817c74896)(), adapter);
            return await adapter.signTransaction(transaction);
        } : undefined, [
        adapter,
        connected
    ]);
    // Sign multiple transactions if the wallet supports it
    const signAllTransactions = (0, $8NFma.useMemo)(()=>adapter && "signAllTransactions" in adapter ? async (transactions)=>{
            if (!connected) throw handleErrorRef.current(new (0, $954228dd8da6435a$export$313d299817c74896)(), adapter);
            return await adapter.signAllTransactions(transactions);
        } : undefined, [
        adapter,
        connected
    ]);
    // Sign an arbitrary message if the wallet supports it
    const signMessage = (0, $8NFma.useMemo)(()=>adapter && "signMessage" in adapter ? async (message)=>{
            if (!connected) throw handleErrorRef.current(new (0, $954228dd8da6435a$export$313d299817c74896)(), adapter);
            return await adapter.signMessage(message);
        } : undefined, [
        adapter,
        connected
    ]);
    // Sign in if the wallet supports it
    const signIn = (0, $8NFma.useMemo)(()=>adapter && "signIn" in adapter ? async (input)=>{
            return await adapter.signIn(input);
        } : undefined, [
        adapter
    ]);
    const handleConnect = (0, $8NFma.useCallback)(async ()=>{
        if (isConnectingRef.current || isDisconnectingRef.current || wallet?.adapter.connected) return;
        if (!wallet) throw handleErrorRef.current(new (0, $6d03393e51309fdd$export$3f5ccdf96415785c)());
        const { adapter: adapter, readyState: readyState } = wallet;
        if (!(readyState === (0, $3020024d0a1e39a2$export$2a7b8071105d05b6).Installed || readyState === (0, $3020024d0a1e39a2$export$2a7b8071105d05b6).Loadable)) throw handleErrorRef.current(new (0, $954228dd8da6435a$export$d65db264eda99cd7)(), adapter);
        isConnectingRef.current = true;
        setConnecting(true);
        try {
            await adapter.connect();
        } catch (e) {
            onConnectError();
            throw e;
        } finally{
            setConnecting(false);
            isConnectingRef.current = false;
        }
    }, [
        onConnectError,
        wallet
    ]);
    const handleDisconnect = (0, $8NFma.useCallback)(async ()=>{
        if (isDisconnectingRef.current) return;
        if (!adapter) return;
        isDisconnectingRef.current = true;
        setDisconnecting(true);
        try {
            await adapter.disconnect();
        } finally{
            setDisconnecting(false);
            isDisconnectingRef.current = false;
        }
    }, [
        adapter
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $da2cf33ea909e7e2$export$19648c908dc8d0bf).Provider, {
        value: {
            autoConnect: !!onAutoConnectRequest,
            wallets: wallets,
            wallet: wallet,
            publicKey: publicKey,
            connected: connected,
            connecting: connecting,
            disconnecting: disconnecting,
            select: onSelectWallet,
            connect: handleConnect,
            disconnect: handleDisconnect,
            sendTransaction: sendTransaction,
            signTransaction: signTransaction,
            signAllTransactions: signAllTransactions,
            signMessage: signMessage,
            signIn: signIn
        }
    }, children);
}


let $23cb594897fd5885$var$_userAgent;
function $23cb594897fd5885$var$getUserAgent() {
    if ($23cb594897fd5885$var$_userAgent === undefined) $23cb594897fd5885$var$_userAgent = globalThis.navigator?.userAgent ?? null;
    return $23cb594897fd5885$var$_userAgent;
}
function $23cb594897fd5885$var$getIsMobile(adapters) {
    const userAgentString = $23cb594897fd5885$var$getUserAgent();
    return (0, $073c00c5df14fe0a$export$2e2bcd8739ae039)({
        adapters: adapters,
        userAgentString: userAgentString
    }) === (0, $073c00c5df14fe0a$export$7dc6752a22ab011a).MOBILE_WEB;
}
function $23cb594897fd5885$var$getUriForAppIdentity() {
    const location = globalThis.location;
    if (!location) return;
    return `${location.protocol}//${location.host}`;
}
function $23cb594897fd5885$export$717b22fc3a2082b3({ children: children, wallets: adapters, autoConnect: autoConnect, localStorageKey: localStorageKey = "walletName", onError: onError }) {
    const { connection: connection } = (0, $c1d85d09818f0a66$export$985e8768c0e91dbc)();
    const adaptersWithStandardAdapters = (0, $5022e3fc9941ddce$export$ca3bd81d254ceecf)(adapters);
    const mobileWalletAdapter = (0, $8NFma.useMemo)(()=>{
        if (!$23cb594897fd5885$var$getIsMobile(adaptersWithStandardAdapters)) return null;
        const existingMobileWalletAdapter = adaptersWithStandardAdapters.find((adapter)=>adapter.name === (0, $bf765e8a33bb400e$export$f1265e9082f346f1));
        if (existingMobileWalletAdapter) return existingMobileWalletAdapter;
        return new (0, $bf765e8a33bb400e$export$dec251788b2f5a84)({
            addressSelector: (0, $bf765e8a33bb400e$export$a299fb0acc11345b)(),
            appIdentity: {
                uri: $23cb594897fd5885$var$getUriForAppIdentity()
            },
            authorizationResultCache: (0, $bf765e8a33bb400e$export$4a0b597891770806)(),
            cluster: (0, $b1361d15209ac2ca$export$2e2bcd8739ae039)(connection?.rpcEndpoint),
            onWalletNotFound: (0, $bf765e8a33bb400e$export$e8b9e70cdf783b70)()
        });
    }, [
        adaptersWithStandardAdapters,
        connection?.rpcEndpoint
    ]);
    const adaptersWithMobileWalletAdapter = (0, $8NFma.useMemo)(()=>{
        if (mobileWalletAdapter == null || adaptersWithStandardAdapters.indexOf(mobileWalletAdapter) !== -1) return adaptersWithStandardAdapters;
        return [
            mobileWalletAdapter,
            ...adaptersWithStandardAdapters
        ];
    }, [
        adaptersWithStandardAdapters,
        mobileWalletAdapter
    ]);
    const [walletName, setWalletName] = (0, $349e3d3609890073$export$86e2cef2561044ac)(localStorageKey, $23cb594897fd5885$var$getIsMobile(adaptersWithStandardAdapters) ? (0, $bf765e8a33bb400e$export$f1265e9082f346f1) : null);
    const adapter = (0, $8NFma.useMemo)(()=>adaptersWithMobileWalletAdapter.find((a)=>a.name === walletName) ?? null, [
        adaptersWithMobileWalletAdapter,
        walletName
    ]);
    const changeWallet = (0, $8NFma.useCallback)((nextWalletName)=>{
        if (walletName === nextWalletName) return;
        if (adapter && // Selecting a wallet other than the mobile wallet adapter is not
        // sufficient reason to call `disconnect` on the mobile wallet adapter.
        // Calling `disconnect` on the mobile wallet adapter causes the entire
        // authorization store to be wiped.
        adapter.name !== (0, $bf765e8a33bb400e$export$f1265e9082f346f1)) adapter.disconnect();
        setWalletName(nextWalletName);
    }, [
        adapter,
        setWalletName,
        walletName
    ]);
    (0, $8NFma.useEffect)(()=>{
        if (!adapter) return;
        function handleDisconnect() {
            if (isUnloadingRef.current) return;
            // Leave the adapter selected in the event of a disconnection.
            if (walletName === (0, $bf765e8a33bb400e$export$f1265e9082f346f1) && $23cb594897fd5885$var$getIsMobile(adaptersWithStandardAdapters)) return;
            setWalletName(null);
        }
        adapter.on("disconnect", handleDisconnect);
        return ()=>{
            adapter.off("disconnect", handleDisconnect);
        };
    }, [
        adapter,
        adaptersWithStandardAdapters,
        setWalletName,
        walletName
    ]);
    const hasUserSelectedAWallet = (0, $8NFma.useRef)(false);
    const handleAutoConnectRequest = (0, $8NFma.useMemo)(()=>{
        if (!autoConnect || !adapter) return;
        return async ()=>{
            // If autoConnect is true or returns true, use the default autoConnect behavior.
            if (autoConnect === true || await autoConnect(adapter)) {
                if (hasUserSelectedAWallet.current) await adapter.connect();
                else await adapter.autoConnect();
            }
        };
    }, [
        autoConnect,
        adapter
    ]);
    const isUnloadingRef = (0, $8NFma.useRef)(false);
    (0, $8NFma.useEffect)(()=>{
        if (walletName === (0, $bf765e8a33bb400e$export$f1265e9082f346f1) && $23cb594897fd5885$var$getIsMobile(adaptersWithStandardAdapters)) {
            isUnloadingRef.current = false;
            return;
        }
        function handleBeforeUnload() {
            isUnloadingRef.current = true;
        }
        /**
         * Some wallets fire disconnection events when the window unloads. Since there's no way to
         * distinguish between a disconnection event received because a user initiated it, and one
         * that was received because they've closed the window, we have to track window unload
         * events themselves. Downstream components use this information to decide whether to act
         * upon or drop wallet events and errors.
         */ window.addEventListener("beforeunload", handleBeforeUnload);
        return ()=>{
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [
        adaptersWithStandardAdapters,
        walletName
    ]);
    const handleConnectError = (0, $8NFma.useCallback)(()=>{
        if (adapter && adapter.name !== (0, $bf765e8a33bb400e$export$f1265e9082f346f1)) // If any error happens while connecting, unset the adapter.
        changeWallet(null);
    }, [
        adapter,
        changeWallet
    ]);
    const selectWallet = (0, $8NFma.useCallback)((walletName)=>{
        hasUserSelectedAWallet.current = true;
        changeWallet(walletName);
    }, [
        changeWallet
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $faac7c53a3ad5cdc$export$a50b3c99d691184b), {
        wallets: adaptersWithMobileWalletAdapter,
        adapter: adapter,
        isUnloadingRef: isUnloadingRef,
        onAutoConnectRequest: handleAutoConnectRequest,
        onConnectError: handleConnectError,
        onError: onError,
        onSelectWallet: selectWallet
    }, children);
}





const $071f33b9e1b22b13$export$79de3e3c2b1ca801 = new (0, $ca3473265f76df98$export$ca8b6604d6ce14de)("TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA");
const $071f33b9e1b22b13$export$8183845dc9f5ce72 = new (0, $ca3473265f76df98$export$ca8b6604d6ce14de)("TokenzQdBNbLqP5VEhdkAS6EPFLC1PHnBqCXEpPxuEb");
const $071f33b9e1b22b13$export$57a4f33bcc1767fa = new (0, $ca3473265f76df98$export$ca8b6604d6ce14de)("ATokenGPvbdGVxr1b2hvZbsiqW5xWH25efTNsLJA8knL");
const $071f33b9e1b22b13$export$71f490c6a4aef7af = new (0, $ca3473265f76df98$export$ca8b6604d6ce14de)("So11111111111111111111111111111111111111112");
const $071f33b9e1b22b13$export$710fe796384b28ef = new (0, $ca3473265f76df98$export$ca8b6604d6ce14de)("9pan9bMn5HatX4EJdBwg9VgCa7Uz5HL8N1m5D3NdXejP");
function $071f33b9e1b22b13$export$839bb614a661d99b(programId) {
    if (programId.equals($071f33b9e1b22b13$export$79de3e3c2b1ca801)) return false;
    else return true;
}


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $1ff5f276bd1e09e8$export$a143d493d941bafc;
var $1ff5f276bd1e09e8$export$e4cf37d7f6fb9e0a;
var $1ff5f276bd1e09e8$export$f99ded8fe4b79145;
var $1ff5f276bd1e09e8$export$599f31c3813fae4d;
"use strict";

var $bQMRt = parcelRequire("bQMRt");

var $dbnIE = parcelRequire("dbnIE");
const $1ff5f276bd1e09e8$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$1ff5f276bd1e09e8$export$a143d493d941bafc = $1ff5f276bd1e09e8$var$Buffer;
$1ff5f276bd1e09e8$export$e4cf37d7f6fb9e0a = $1ff5f276bd1e09e8$var$SlowBuffer;
$1ff5f276bd1e09e8$export$f99ded8fe4b79145 = 50;
const $1ff5f276bd1e09e8$var$K_MAX_LENGTH = 0x7fffffff;
$1ff5f276bd1e09e8$export$599f31c3813fae4d = $1ff5f276bd1e09e8$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $1ff5f276bd1e09e8$var$Buffer.TYPED_ARRAY_SUPPORT = $1ff5f276bd1e09e8$var$typedArraySupport();
if (!$1ff5f276bd1e09e8$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $1ff5f276bd1e09e8$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($1ff5f276bd1e09e8$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$1ff5f276bd1e09e8$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($1ff5f276bd1e09e8$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$1ff5f276bd1e09e8$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $1ff5f276bd1e09e8$var$createBuffer(length) {
    if (length > $1ff5f276bd1e09e8$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $1ff5f276bd1e09e8$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $1ff5f276bd1e09e8$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $1ff5f276bd1e09e8$var$allocUnsafe(arg);
    }
    return $1ff5f276bd1e09e8$var$from(arg, encodingOrOffset, length);
}
$1ff5f276bd1e09e8$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $1ff5f276bd1e09e8$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $1ff5f276bd1e09e8$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $1ff5f276bd1e09e8$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($1ff5f276bd1e09e8$var$isInstance(value, ArrayBuffer) || value && $1ff5f276bd1e09e8$var$isInstance(value.buffer, ArrayBuffer)) return $1ff5f276bd1e09e8$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($1ff5f276bd1e09e8$var$isInstance(value, SharedArrayBuffer) || value && $1ff5f276bd1e09e8$var$isInstance(value.buffer, SharedArrayBuffer))) return $1ff5f276bd1e09e8$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $1ff5f276bd1e09e8$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $1ff5f276bd1e09e8$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $1ff5f276bd1e09e8$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $1ff5f276bd1e09e8$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $1ff5f276bd1e09e8$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($1ff5f276bd1e09e8$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($1ff5f276bd1e09e8$var$Buffer, Uint8Array);
function $1ff5f276bd1e09e8$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $1ff5f276bd1e09e8$var$alloc(size, fill, encoding) {
    $1ff5f276bd1e09e8$var$assertSize(size);
    if (size <= 0) return $1ff5f276bd1e09e8$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $1ff5f276bd1e09e8$var$createBuffer(size).fill(fill, encoding) : $1ff5f276bd1e09e8$var$createBuffer(size).fill(fill);
    return $1ff5f276bd1e09e8$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $1ff5f276bd1e09e8$var$Buffer.alloc = function(size, fill, encoding) {
    return $1ff5f276bd1e09e8$var$alloc(size, fill, encoding);
};
function $1ff5f276bd1e09e8$var$allocUnsafe(size) {
    $1ff5f276bd1e09e8$var$assertSize(size);
    return $1ff5f276bd1e09e8$var$createBuffer(size < 0 ? 0 : $1ff5f276bd1e09e8$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $1ff5f276bd1e09e8$var$Buffer.allocUnsafe = function(size) {
    return $1ff5f276bd1e09e8$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $1ff5f276bd1e09e8$var$Buffer.allocUnsafeSlow = function(size) {
    return $1ff5f276bd1e09e8$var$allocUnsafe(size);
};
function $1ff5f276bd1e09e8$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$1ff5f276bd1e09e8$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $1ff5f276bd1e09e8$var$byteLength(string, encoding) | 0;
    let buf = $1ff5f276bd1e09e8$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $1ff5f276bd1e09e8$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $1ff5f276bd1e09e8$var$checked(array.length) | 0;
    const buf = $1ff5f276bd1e09e8$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $1ff5f276bd1e09e8$var$fromArrayView(arrayView) {
    if ($1ff5f276bd1e09e8$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $1ff5f276bd1e09e8$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $1ff5f276bd1e09e8$var$fromArrayLike(arrayView);
}
function $1ff5f276bd1e09e8$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $1ff5f276bd1e09e8$var$Buffer.prototype);
    return buf;
}
function $1ff5f276bd1e09e8$var$fromObject(obj) {
    if ($1ff5f276bd1e09e8$var$Buffer.isBuffer(obj)) {
        const len = $1ff5f276bd1e09e8$var$checked(obj.length) | 0;
        const buf = $1ff5f276bd1e09e8$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $1ff5f276bd1e09e8$var$numberIsNaN(obj.length)) return $1ff5f276bd1e09e8$var$createBuffer(0);
        return $1ff5f276bd1e09e8$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $1ff5f276bd1e09e8$var$fromArrayLike(obj.data);
}
function $1ff5f276bd1e09e8$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $1ff5f276bd1e09e8$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $1ff5f276bd1e09e8$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $1ff5f276bd1e09e8$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $1ff5f276bd1e09e8$var$Buffer.alloc(+length);
}
$1ff5f276bd1e09e8$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $1ff5f276bd1e09e8$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$1ff5f276bd1e09e8$var$Buffer.compare = function compare(a, b) {
    if ($1ff5f276bd1e09e8$var$isInstance(a, Uint8Array)) a = $1ff5f276bd1e09e8$var$Buffer.from(a, a.offset, a.byteLength);
    if ($1ff5f276bd1e09e8$var$isInstance(b, Uint8Array)) b = $1ff5f276bd1e09e8$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$1ff5f276bd1e09e8$var$Buffer.isBuffer(a) || !$1ff5f276bd1e09e8$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$1ff5f276bd1e09e8$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$1ff5f276bd1e09e8$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $1ff5f276bd1e09e8$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $1ff5f276bd1e09e8$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($1ff5f276bd1e09e8$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$1ff5f276bd1e09e8$var$Buffer.isBuffer(buf)) buf = $1ff5f276bd1e09e8$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$1ff5f276bd1e09e8$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $1ff5f276bd1e09e8$var$byteLength(string, encoding) {
    if ($1ff5f276bd1e09e8$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $1ff5f276bd1e09e8$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $1ff5f276bd1e09e8$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $1ff5f276bd1e09e8$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $1ff5f276bd1e09e8$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$1ff5f276bd1e09e8$var$Buffer.byteLength = $1ff5f276bd1e09e8$var$byteLength;
function $1ff5f276bd1e09e8$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $1ff5f276bd1e09e8$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $1ff5f276bd1e09e8$var$utf8Slice(this, start, end);
        case "ascii":
            return $1ff5f276bd1e09e8$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $1ff5f276bd1e09e8$var$latin1Slice(this, start, end);
        case "base64":
            return $1ff5f276bd1e09e8$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $1ff5f276bd1e09e8$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$1ff5f276bd1e09e8$var$Buffer.prototype._isBuffer = true;
function $1ff5f276bd1e09e8$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$1ff5f276bd1e09e8$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$1ff5f276bd1e09e8$var$swap(this, i, i + 1);
    return this;
};
$1ff5f276bd1e09e8$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $1ff5f276bd1e09e8$var$swap(this, i, i + 3);
        $1ff5f276bd1e09e8$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$1ff5f276bd1e09e8$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $1ff5f276bd1e09e8$var$swap(this, i, i + 7);
        $1ff5f276bd1e09e8$var$swap(this, i + 1, i + 6);
        $1ff5f276bd1e09e8$var$swap(this, i + 2, i + 5);
        $1ff5f276bd1e09e8$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$1ff5f276bd1e09e8$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $1ff5f276bd1e09e8$var$utf8Slice(this, 0, length);
    return $1ff5f276bd1e09e8$var$slowToString.apply(this, arguments);
};
$1ff5f276bd1e09e8$var$Buffer.prototype.toLocaleString = $1ff5f276bd1e09e8$var$Buffer.prototype.toString;
$1ff5f276bd1e09e8$var$Buffer.prototype.equals = function equals(b) {
    if (!$1ff5f276bd1e09e8$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $1ff5f276bd1e09e8$var$Buffer.compare(this, b) === 0;
};
$1ff5f276bd1e09e8$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $1ff5f276bd1e09e8$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($1ff5f276bd1e09e8$var$customInspectSymbol) $1ff5f276bd1e09e8$var$Buffer.prototype[$1ff5f276bd1e09e8$var$customInspectSymbol] = $1ff5f276bd1e09e8$var$Buffer.prototype.inspect;
$1ff5f276bd1e09e8$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($1ff5f276bd1e09e8$var$isInstance(target, Uint8Array)) target = $1ff5f276bd1e09e8$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$1ff5f276bd1e09e8$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $1ff5f276bd1e09e8$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($1ff5f276bd1e09e8$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $1ff5f276bd1e09e8$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($1ff5f276bd1e09e8$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $1ff5f276bd1e09e8$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $1ff5f276bd1e09e8$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $1ff5f276bd1e09e8$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$1ff5f276bd1e09e8$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$1ff5f276bd1e09e8$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $1ff5f276bd1e09e8$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$1ff5f276bd1e09e8$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $1ff5f276bd1e09e8$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $1ff5f276bd1e09e8$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($1ff5f276bd1e09e8$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $1ff5f276bd1e09e8$var$utf8Write(buf, string, offset, length) {
    return $1ff5f276bd1e09e8$var$blitBuffer($1ff5f276bd1e09e8$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $1ff5f276bd1e09e8$var$asciiWrite(buf, string, offset, length) {
    return $1ff5f276bd1e09e8$var$blitBuffer($1ff5f276bd1e09e8$var$asciiToBytes(string), buf, offset, length);
}
function $1ff5f276bd1e09e8$var$base64Write(buf, string, offset, length) {
    return $1ff5f276bd1e09e8$var$blitBuffer($1ff5f276bd1e09e8$var$base64ToBytes(string), buf, offset, length);
}
function $1ff5f276bd1e09e8$var$ucs2Write(buf, string, offset, length) {
    return $1ff5f276bd1e09e8$var$blitBuffer($1ff5f276bd1e09e8$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$1ff5f276bd1e09e8$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $1ff5f276bd1e09e8$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $1ff5f276bd1e09e8$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $1ff5f276bd1e09e8$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $1ff5f276bd1e09e8$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $1ff5f276bd1e09e8$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$1ff5f276bd1e09e8$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $1ff5f276bd1e09e8$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $bQMRt.fromByteArray(buf);
    else return $bQMRt.fromByteArray(buf.slice(start, end));
}
function $1ff5f276bd1e09e8$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $1ff5f276bd1e09e8$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $1ff5f276bd1e09e8$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $1ff5f276bd1e09e8$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $1ff5f276bd1e09e8$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $1ff5f276bd1e09e8$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $1ff5f276bd1e09e8$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $1ff5f276bd1e09e8$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $1ff5f276bd1e09e8$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $1ff5f276bd1e09e8$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $1ff5f276bd1e09e8$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$1ff5f276bd1e09e8$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $1ff5f276bd1e09e8$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $1ff5f276bd1e09e8$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$1ff5f276bd1e09e8$var$Buffer.prototype.readUintLE = $1ff5f276bd1e09e8$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $1ff5f276bd1e09e8$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$1ff5f276bd1e09e8$var$Buffer.prototype.readUintBE = $1ff5f276bd1e09e8$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $1ff5f276bd1e09e8$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$1ff5f276bd1e09e8$var$Buffer.prototype.readUint8 = $1ff5f276bd1e09e8$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1ff5f276bd1e09e8$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$1ff5f276bd1e09e8$var$Buffer.prototype.readUint16LE = $1ff5f276bd1e09e8$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1ff5f276bd1e09e8$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$1ff5f276bd1e09e8$var$Buffer.prototype.readUint16BE = $1ff5f276bd1e09e8$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1ff5f276bd1e09e8$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$1ff5f276bd1e09e8$var$Buffer.prototype.readUint32LE = $1ff5f276bd1e09e8$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1ff5f276bd1e09e8$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$1ff5f276bd1e09e8$var$Buffer.prototype.readUint32BE = $1ff5f276bd1e09e8$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1ff5f276bd1e09e8$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$1ff5f276bd1e09e8$var$Buffer.prototype.readBigUInt64LE = $1ff5f276bd1e09e8$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $1ff5f276bd1e09e8$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $1ff5f276bd1e09e8$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$1ff5f276bd1e09e8$var$Buffer.prototype.readBigUInt64BE = $1ff5f276bd1e09e8$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $1ff5f276bd1e09e8$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $1ff5f276bd1e09e8$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$1ff5f276bd1e09e8$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $1ff5f276bd1e09e8$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$1ff5f276bd1e09e8$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $1ff5f276bd1e09e8$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$1ff5f276bd1e09e8$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1ff5f276bd1e09e8$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$1ff5f276bd1e09e8$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1ff5f276bd1e09e8$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$1ff5f276bd1e09e8$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1ff5f276bd1e09e8$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$1ff5f276bd1e09e8$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1ff5f276bd1e09e8$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$1ff5f276bd1e09e8$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1ff5f276bd1e09e8$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$1ff5f276bd1e09e8$var$Buffer.prototype.readBigInt64LE = $1ff5f276bd1e09e8$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $1ff5f276bd1e09e8$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $1ff5f276bd1e09e8$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$1ff5f276bd1e09e8$var$Buffer.prototype.readBigInt64BE = $1ff5f276bd1e09e8$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $1ff5f276bd1e09e8$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $1ff5f276bd1e09e8$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$1ff5f276bd1e09e8$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1ff5f276bd1e09e8$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, true, 23, 4);
};
$1ff5f276bd1e09e8$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1ff5f276bd1e09e8$var$checkOffset(offset, 4, this.length);
    return $dbnIE.read(this, offset, false, 23, 4);
};
$1ff5f276bd1e09e8$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1ff5f276bd1e09e8$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, true, 52, 8);
};
$1ff5f276bd1e09e8$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $1ff5f276bd1e09e8$var$checkOffset(offset, 8, this.length);
    return $dbnIE.read(this, offset, false, 52, 8);
};
function $1ff5f276bd1e09e8$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$1ff5f276bd1e09e8$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$1ff5f276bd1e09e8$var$Buffer.prototype.writeUintLE = $1ff5f276bd1e09e8$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $1ff5f276bd1e09e8$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$1ff5f276bd1e09e8$var$Buffer.prototype.writeUintBE = $1ff5f276bd1e09e8$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $1ff5f276bd1e09e8$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$1ff5f276bd1e09e8$var$Buffer.prototype.writeUint8 = $1ff5f276bd1e09e8$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1ff5f276bd1e09e8$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$1ff5f276bd1e09e8$var$Buffer.prototype.writeUint16LE = $1ff5f276bd1e09e8$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1ff5f276bd1e09e8$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$1ff5f276bd1e09e8$var$Buffer.prototype.writeUint16BE = $1ff5f276bd1e09e8$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1ff5f276bd1e09e8$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$1ff5f276bd1e09e8$var$Buffer.prototype.writeUint32LE = $1ff5f276bd1e09e8$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1ff5f276bd1e09e8$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$1ff5f276bd1e09e8$var$Buffer.prototype.writeUint32BE = $1ff5f276bd1e09e8$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1ff5f276bd1e09e8$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $1ff5f276bd1e09e8$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $1ff5f276bd1e09e8$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $1ff5f276bd1e09e8$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $1ff5f276bd1e09e8$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$1ff5f276bd1e09e8$var$Buffer.prototype.writeBigUInt64LE = $1ff5f276bd1e09e8$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $1ff5f276bd1e09e8$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$1ff5f276bd1e09e8$var$Buffer.prototype.writeBigUInt64BE = $1ff5f276bd1e09e8$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $1ff5f276bd1e09e8$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$1ff5f276bd1e09e8$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $1ff5f276bd1e09e8$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$1ff5f276bd1e09e8$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $1ff5f276bd1e09e8$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$1ff5f276bd1e09e8$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1ff5f276bd1e09e8$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$1ff5f276bd1e09e8$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1ff5f276bd1e09e8$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$1ff5f276bd1e09e8$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1ff5f276bd1e09e8$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$1ff5f276bd1e09e8$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1ff5f276bd1e09e8$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$1ff5f276bd1e09e8$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1ff5f276bd1e09e8$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$1ff5f276bd1e09e8$var$Buffer.prototype.writeBigInt64LE = $1ff5f276bd1e09e8$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $1ff5f276bd1e09e8$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$1ff5f276bd1e09e8$var$Buffer.prototype.writeBigInt64BE = $1ff5f276bd1e09e8$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $1ff5f276bd1e09e8$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $1ff5f276bd1e09e8$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $1ff5f276bd1e09e8$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1ff5f276bd1e09e8$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$1ff5f276bd1e09e8$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $1ff5f276bd1e09e8$var$writeFloat(this, value, offset, true, noAssert);
};
$1ff5f276bd1e09e8$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $1ff5f276bd1e09e8$var$writeFloat(this, value, offset, false, noAssert);
};
function $1ff5f276bd1e09e8$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $1ff5f276bd1e09e8$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $dbnIE.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$1ff5f276bd1e09e8$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $1ff5f276bd1e09e8$var$writeDouble(this, value, offset, true, noAssert);
};
$1ff5f276bd1e09e8$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $1ff5f276bd1e09e8$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$1ff5f276bd1e09e8$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$1ff5f276bd1e09e8$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$1ff5f276bd1e09e8$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$1ff5f276bd1e09e8$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $1ff5f276bd1e09e8$var$Buffer.isBuffer(val) ? val : $1ff5f276bd1e09e8$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $1ff5f276bd1e09e8$var$errors = {};
function $1ff5f276bd1e09e8$var$E(sym, getMessage, Base) {
    $1ff5f276bd1e09e8$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$1ff5f276bd1e09e8$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$1ff5f276bd1e09e8$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$1ff5f276bd1e09e8$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $1ff5f276bd1e09e8$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $1ff5f276bd1e09e8$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $1ff5f276bd1e09e8$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $1ff5f276bd1e09e8$var$checkBounds(buf, offset, byteLength) {
    $1ff5f276bd1e09e8$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $1ff5f276bd1e09e8$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $1ff5f276bd1e09e8$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $1ff5f276bd1e09e8$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $1ff5f276bd1e09e8$var$checkBounds(buf, offset, byteLength);
}
function $1ff5f276bd1e09e8$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $1ff5f276bd1e09e8$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $1ff5f276bd1e09e8$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $1ff5f276bd1e09e8$var$validateNumber(value, type);
        throw new $1ff5f276bd1e09e8$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $1ff5f276bd1e09e8$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $1ff5f276bd1e09e8$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $1ff5f276bd1e09e8$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $1ff5f276bd1e09e8$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($1ff5f276bd1e09e8$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $1ff5f276bd1e09e8$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $1ff5f276bd1e09e8$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $1ff5f276bd1e09e8$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $1ff5f276bd1e09e8$var$base64ToBytes(str) {
    return $bQMRt.toByteArray($1ff5f276bd1e09e8$var$base64clean(str));
}
function $1ff5f276bd1e09e8$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $1ff5f276bd1e09e8$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $1ff5f276bd1e09e8$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $1ff5f276bd1e09e8$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $1ff5f276bd1e09e8$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $1ff5f276bd1e09e8$var$BufferBigIntNotDefined : fn;
}
function $1ff5f276bd1e09e8$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $a060f50b60a1e468$require$Buffer = $1ff5f276bd1e09e8$export$a143d493d941bafc;
function $a060f50b60a1e468$export$65d7d2fa066d6cc6(payer, associatedToken, owner, mint, programId = (0, $071f33b9e1b22b13$export$79de3e3c2b1ca801), associatedTokenProgramId = (0, $071f33b9e1b22b13$export$57a4f33bcc1767fa)) {
    return $a060f50b60a1e468$var$buildAssociatedTokenAccountInstruction(payer, associatedToken, owner, mint, $a060f50b60a1e468$require$Buffer.alloc(0), programId, associatedTokenProgramId);
}
function $a060f50b60a1e468$export$b66dd1dc00a3bc28(payer, associatedToken, owner, mint, programId = (0, $071f33b9e1b22b13$export$79de3e3c2b1ca801), associatedTokenProgramId = (0, $071f33b9e1b22b13$export$57a4f33bcc1767fa)) {
    return $a060f50b60a1e468$var$buildAssociatedTokenAccountInstruction(payer, associatedToken, owner, mint, $a060f50b60a1e468$require$Buffer.from([
        1
    ]), programId, associatedTokenProgramId);
}
function $a060f50b60a1e468$var$buildAssociatedTokenAccountInstruction(payer, associatedToken, owner, mint, instructionData, programId = (0, $071f33b9e1b22b13$export$79de3e3c2b1ca801), associatedTokenProgramId = (0, $071f33b9e1b22b13$export$57a4f33bcc1767fa)) {
    const keys = [
        {
            pubkey: payer,
            isSigner: true,
            isWritable: true
        },
        {
            pubkey: associatedToken,
            isSigner: false,
            isWritable: true
        },
        {
            pubkey: owner,
            isSigner: false,
            isWritable: false
        },
        {
            pubkey: mint,
            isSigner: false,
            isWritable: false
        },
        {
            pubkey: (0, $ca3473265f76df98$export$d8c4e17726848113).programId,
            isSigner: false,
            isWritable: false
        },
        {
            pubkey: programId,
            isSigner: false,
            isWritable: false
        }
    ];
    return new (0, $ca3473265f76df98$export$a7a3aa8360ac9f59)({
        keys: keys,
        programId: associatedTokenProgramId,
        data: instructionData
    });
}
function $a060f50b60a1e468$export$2108cac48553e999(nestedAssociatedToken, nestedMint, destinationAssociatedToken, ownerAssociatedToken, ownerMint, owner, programId = (0, $071f33b9e1b22b13$export$79de3e3c2b1ca801), associatedTokenProgramId = (0, $071f33b9e1b22b13$export$57a4f33bcc1767fa)) {
    const keys = [
        {
            pubkey: nestedAssociatedToken,
            isSigner: false,
            isWritable: true
        },
        {
            pubkey: nestedMint,
            isSigner: false,
            isWritable: false
        },
        {
            pubkey: destinationAssociatedToken,
            isSigner: false,
            isWritable: true
        },
        {
            pubkey: ownerAssociatedToken,
            isSigner: false,
            isWritable: true
        },
        {
            pubkey: ownerMint,
            isSigner: false,
            isWritable: false
        },
        {
            pubkey: owner,
            isSigner: true,
            isWritable: true
        },
        {
            pubkey: programId,
            isSigner: false,
            isWritable: false
        }
    ];
    return new (0, $ca3473265f76df98$export$a7a3aa8360ac9f59)({
        keys: keys,
        programId: associatedTokenProgramId,
        data: $a060f50b60a1e468$require$Buffer.from([
            2
        ])
    });
}


const $bd31c8d4e4071f4f$export$15db02dbfcaf60e0 = (layout)=>{
    const decode = layout.decode.bind(layout);
    const encode = layout.encode.bind(layout);
    return {
        decode: decode,
        encode: encode
    };
};






var $N0o3H = parcelRequire("N0o3H");
var $3b2d1baa52a31e71$require$Buffer = $N0o3H.Buffer;
const $3b2d1baa52a31e71$export$c97e695afb26d84 = (length)=>(property)=>{
        const layout = (0, $ab8b5713b1ee9109$exports.blob)(length, property);
        const { encode: encode, decode: decode } = (0, $bd31c8d4e4071f4f$export$15db02dbfcaf60e0)(layout);
        const bigIntLayout = layout;
        bigIntLayout.decode = (buffer, offset)=>{
            const src = decode(buffer, offset);
            return (0, $681a4aa191fca251$exports.toBigIntLE)($3b2d1baa52a31e71$require$Buffer.from(src));
        };
        bigIntLayout.encode = (bigInt, buffer, offset)=>{
            const src = (0, $681a4aa191fca251$exports.toBufferLE)(bigInt, length);
            return encode(src, buffer, offset);
        };
        return bigIntLayout;
    };
const $3b2d1baa52a31e71$export$8fa7afc0d3e063a4 = (length)=>(property)=>{
        const layout = (0, $ab8b5713b1ee9109$exports.blob)(length, property);
        const { encode: encode, decode: decode } = (0, $bd31c8d4e4071f4f$export$15db02dbfcaf60e0)(layout);
        const bigIntLayout = layout;
        bigIntLayout.decode = (buffer, offset)=>{
            const src = decode(buffer, offset);
            return (0, $681a4aa191fca251$exports.toBigIntBE)($3b2d1baa52a31e71$require$Buffer.from(src));
        };
        bigIntLayout.encode = (bigInt, buffer, offset)=>{
            const src = (0, $681a4aa191fca251$exports.toBufferBE)(bigInt, length);
            return encode(src, buffer, offset);
        };
        return bigIntLayout;
    };
const $3b2d1baa52a31e71$export$cd1442401e54cffa = $3b2d1baa52a31e71$export$c97e695afb26d84(8);
const $3b2d1baa52a31e71$export$7f18746cf5292838 = $3b2d1baa52a31e71$export$8fa7afc0d3e063a4(8);
const $3b2d1baa52a31e71$export$6cebf8c93d35ecb4 = $3b2d1baa52a31e71$export$c97e695afb26d84(16);
const $3b2d1baa52a31e71$export$327689723be22772 = $3b2d1baa52a31e71$export$8fa7afc0d3e063a4(16);
const $3b2d1baa52a31e71$export$8f928ec3e6d68946 = $3b2d1baa52a31e71$export$c97e695afb26d84(24);
const $3b2d1baa52a31e71$export$559ccecc3c5a7252 = $3b2d1baa52a31e71$export$8fa7afc0d3e063a4(24);
const $3b2d1baa52a31e71$export$c6d3c723c6dee16b = $3b2d1baa52a31e71$export$c97e695afb26d84(32);
const $3b2d1baa52a31e71$export$667f357a9402d24c = $3b2d1baa52a31e71$export$8fa7afc0d3e063a4(32);


/*
 *      bignumber.js v9.1.2
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var $c39fed560cbb8833$var$isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, $c39fed560cbb8833$var$mathceil = Math.ceil, $c39fed560cbb8833$var$mathfloor = Math.floor, $c39fed560cbb8833$var$bignumberError = "[BigNumber Error] ", $c39fed560cbb8833$var$tooManyDigits = $c39fed560cbb8833$var$bignumberError + "Number primitive has more than 15 significant digits: ", $c39fed560cbb8833$var$BASE = 1e14, $c39fed560cbb8833$var$LOG_BASE = 14, $c39fed560cbb8833$var$MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
$c39fed560cbb8833$var$POWS_TEN = [
    1,
    10,
    100,
    1e3,
    1e4,
    1e5,
    1e6,
    1e7,
    1e8,
    1e9,
    1e10,
    1e11,
    1e12,
    1e13
], $c39fed560cbb8833$var$SQRT_BASE = 1e7, // EDITABLE
// The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
// the arguments to toExponential, toFixed, toFormat, and toPrecision.
$c39fed560cbb8833$var$MAX = 1E9; // 0 to MAX_INT32
/*
 * Create and return a BigNumber constructor.
 */ function $c39fed560cbb8833$var$clone(configObject) {
    var div, convertBase, parseNumeric, P = BigNumber.prototype = {
        constructor: BigNumber,
        toString: null,
        valueOf: null
    }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
    // The default values below must be integers within the inclusive ranges stated.
    // The values can also be changed at run-time using BigNumber.set.
    // The maximum number of decimal places for operations involving division.
    DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
    // toExponential, toFixed, toFormat and toPrecision, and round (default value).
    // UP         0 Away from zero.
    // DOWN       1 Towards zero.
    // CEIL       2 Towards +Infinity.
    // FLOOR      3 Towards -Infinity.
    // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
    // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
    // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
    // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
    // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
    ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
    // The exponent value at and beneath which toString returns exponential notation.
    // Number type: -7
    TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
    // Number type: 21
    TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
    // The minimum exponent value, beneath which underflow to zero occurs.
    // Number type: -324  (5e-324)
    MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
    // Number type:  308  (1.7976931348623157e+308)
    // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
    MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
    CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
    // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
    // The remainder (r) is calculated as: r = a - n * q.
    //
    // UP        0 The remainder is positive if the dividend is negative, else is negative.
    // DOWN      1 The remainder has the same sign as the dividend.
    //             This modulo mode is commonly known as 'truncated division' and is
    //             equivalent to (a % n) in JavaScript.
    // FLOOR     3 The remainder has the same sign as the divisor (Python %).
    // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
    // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
    //             The remainder is always positive.
    //
    // The truncated division, floored division, Euclidian division and IEEE 754 remainder
    // modes are commonly used for the modulus operation.
    // Although the other rounding modes can also be used, they may not give useful results.
    MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
    // If POW_PRECISION is 0, there will be unlimited significant digits.
    POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
    FORMAT = {
        prefix: "",
        groupSize: 3,
        secondaryGroupSize: 0,
        groupSeparator: ",",
        decimalSeparator: ".",
        fractionGroupSize: 0,
        fractionGroupSeparator: "\xa0",
        suffix: ""
    }, // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
    // '-', '.', whitespace, or repeated character.
    // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
    ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz", alphabetHasNormalDecimalDigits = true;
    //------------------------------------------------------------------------------------------
    // CONSTRUCTOR
    /*
   * The BigNumber constructor and exported function.
   * Create and return a new instance of a BigNumber object.
   *
   * v {number|string|BigNumber} A numeric value.
   * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
   */ function BigNumber(v, b) {
        var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
        // Enable constructor call without `new`.
        if (!(x instanceof BigNumber)) return new BigNumber(v, b);
        if (b == null) {
            if (v && v._isBigNumber === true) {
                x.s = v.s;
                if (!v.c || v.e > MAX_EXP) x.c = x.e = null;
                else if (v.e < MIN_EXP) x.c = [
                    x.e = 0
                ];
                else {
                    x.e = v.e;
                    x.c = v.c.slice();
                }
                return;
            }
            if ((isNum = typeof v == "number") && v * 0 == 0) {
                // Use `1 / n` to handle minus zero also.
                x.s = 1 / v < 0 ? (v = -v, -1) : 1;
                // Fast path for integers, where n < 2147483648 (2**31).
                if (v === ~~v) {
                    for(e = 0, i = v; i >= 10; i /= 10, e++);
                    if (e > MAX_EXP) x.c = x.e = null;
                    else {
                        x.e = e;
                        x.c = [
                            v
                        ];
                    }
                    return;
                }
                str = String(v);
            } else {
                if (!$c39fed560cbb8833$var$isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);
                x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
            }
            // Decimal point?
            if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
            // Exponential form?
            if ((i = str.search(/e/i)) > 0) {
                // Determine exponent.
                if (e < 0) e = i;
                e += +str.slice(i + 1);
                str = str.substring(0, i);
            } else if (e < 0) // Integer.
            e = str.length;
        } else {
            // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
            $c39fed560cbb8833$var$intCheck(b, 2, ALPHABET.length, "Base");
            // Allow exponential notation to be used with base 10 argument, while
            // also rounding to DECIMAL_PLACES as with other bases.
            if (b == 10 && alphabetHasNormalDecimalDigits) {
                x = new BigNumber(v);
                return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
            }
            str = String(v);
            if (isNum = typeof v == "number") {
                // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                if (v * 0 != 0) return parseNumeric(x, str, isNum, b);
                x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;
                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, "").length > 15) throw Error($c39fed560cbb8833$var$tooManyDigits + v);
            } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
            alphabet = ALPHABET.slice(0, b);
            e = i = 0;
            // Check that str is a valid base b number.
            // Don't use RegExp, so alphabet can contain special characters.
            for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                if (c == ".") // If '.' is not the first character and it has not be found before.
                {
                    if (i > e) {
                        e = len;
                        continue;
                    }
                } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                {
                    if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                        caseChanged = true;
                        i = -1;
                        e = 0;
                        continue;
                    }
                }
                return parseNumeric(x, String(v), isNum, b);
            }
            // Prevent later check for length on converted number.
            isNum = false;
            str = convertBase(str, b, 10, x.s);
            // Decimal point?
            if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
            else e = str.length;
        }
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48; i++);
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(--len) === 48;);
        if (str = str.slice(i, ++len)) {
            len -= i;
            // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
            if (isNum && BigNumber.DEBUG && len > 15 && (v > $c39fed560cbb8833$var$MAX_SAFE_INTEGER || v !== $c39fed560cbb8833$var$mathfloor(v))) throw Error($c39fed560cbb8833$var$tooManyDigits + x.s * v);
            // Overflow?
            if ((e = e - i - 1) > MAX_EXP) // Infinity.
            x.c = x.e = null;
            else if (e < MIN_EXP) // Zero.
            x.c = [
                x.e = 0
            ];
            else {
                x.e = e;
                x.c = [];
                // Transform base
                // e is the base 10 exponent.
                // i is where to slice str to get the first element of the coefficient array.
                i = (e + 1) % $c39fed560cbb8833$var$LOG_BASE;
                if (e < 0) i += $c39fed560cbb8833$var$LOG_BASE; // i < 1
                if (i < len) {
                    if (i) x.c.push(+str.slice(0, i));
                    for(len -= $c39fed560cbb8833$var$LOG_BASE; i < len;)x.c.push(+str.slice(i, i += $c39fed560cbb8833$var$LOG_BASE));
                    i = $c39fed560cbb8833$var$LOG_BASE - (str = str.slice(i)).length;
                } else i -= len;
                for(; i--; str += "0");
                x.c.push(+str);
            }
        } else // Zero.
        x.c = [
            x.e = 0
        ];
    }
    // CONSTRUCTOR PROPERTIES
    BigNumber.clone = $c39fed560cbb8833$var$clone;
    BigNumber.ROUND_UP = 0;
    BigNumber.ROUND_DOWN = 1;
    BigNumber.ROUND_CEIL = 2;
    BigNumber.ROUND_FLOOR = 3;
    BigNumber.ROUND_HALF_UP = 4;
    BigNumber.ROUND_HALF_DOWN = 5;
    BigNumber.ROUND_HALF_EVEN = 6;
    BigNumber.ROUND_HALF_CEIL = 7;
    BigNumber.ROUND_HALF_FLOOR = 8;
    BigNumber.EUCLID = 9;
    /*
   * Configure infrequently-changing library-wide settings.
   *
   * Accept an object with the following optional properties (if the value of a property is
   * a number, it must be an integer within the inclusive range stated):
   *
   *   DECIMAL_PLACES   {number}           0 to MAX
   *   ROUNDING_MODE    {number}           0 to 8
   *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
   *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
   *   CRYPTO           {boolean}          true or false
   *   MODULO_MODE      {number}           0 to 9
   *   POW_PRECISION       {number}           0 to MAX
   *   ALPHABET         {string}           A string of two or more unique characters which does
   *                                       not contain '.'.
   *   FORMAT           {object}           An object with some of the following properties:
   *     prefix                 {string}
   *     groupSize              {number}
   *     secondaryGroupSize     {number}
   *     groupSeparator         {string}
   *     decimalSeparator       {string}
   *     fractionGroupSize      {number}
   *     fractionGroupSeparator {string}
   *     suffix                 {string}
   *
   * (The values assigned to the above FORMAT object properties are not checked for validity.)
   *
   * E.g.
   * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
   *
   * Ignore properties/parameters set to null or undefined, except for ALPHABET.
   *
   * Return an object with the properties current values.
   */ BigNumber.config = BigNumber.set = function(obj) {
        var p, v;
        if (obj != null) {
            if (typeof obj == "object") {
                // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = "DECIMAL_PLACES")) {
                    v = obj[p];
                    $c39fed560cbb8833$var$intCheck(v, 0, $c39fed560cbb8833$var$MAX, p);
                    DECIMAL_PLACES = v;
                }
                // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = "ROUNDING_MODE")) {
                    v = obj[p];
                    $c39fed560cbb8833$var$intCheck(v, 0, 8, p);
                    ROUNDING_MODE = v;
                }
                // EXPONENTIAL_AT {number|number[]}
                // Integer, -MAX to MAX inclusive or
                // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = "EXPONENTIAL_AT")) {
                    v = obj[p];
                    if (v && v.pop) {
                        $c39fed560cbb8833$var$intCheck(v[0], -$c39fed560cbb8833$var$MAX, 0, p);
                        $c39fed560cbb8833$var$intCheck(v[1], 0, $c39fed560cbb8833$var$MAX, p);
                        TO_EXP_NEG = v[0];
                        TO_EXP_POS = v[1];
                    } else {
                        $c39fed560cbb8833$var$intCheck(v, -$c39fed560cbb8833$var$MAX, $c39fed560cbb8833$var$MAX, p);
                        TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                    }
                }
                // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                if (obj.hasOwnProperty(p = "RANGE")) {
                    v = obj[p];
                    if (v && v.pop) {
                        $c39fed560cbb8833$var$intCheck(v[0], -$c39fed560cbb8833$var$MAX, -1, p);
                        $c39fed560cbb8833$var$intCheck(v[1], 1, $c39fed560cbb8833$var$MAX, p);
                        MIN_EXP = v[0];
                        MAX_EXP = v[1];
                    } else {
                        $c39fed560cbb8833$var$intCheck(v, -$c39fed560cbb8833$var$MAX, $c39fed560cbb8833$var$MAX, p);
                        if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                        else throw Error($c39fed560cbb8833$var$bignumberError + p + " cannot be zero: " + v);
                    }
                }
                // CRYPTO {boolean} true or false.
                // '[BigNumber Error] CRYPTO not true or false: {v}'
                // '[BigNumber Error] crypto unavailable'
                if (obj.hasOwnProperty(p = "CRYPTO")) {
                    v = obj[p];
                    if (v === !!v) {
                        if (v) {
                            if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                            else {
                                CRYPTO = !v;
                                throw Error($c39fed560cbb8833$var$bignumberError + "crypto unavailable");
                            }
                        } else CRYPTO = v;
                    } else throw Error($c39fed560cbb8833$var$bignumberError + p + " not true or false: " + v);
                }
                // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = "MODULO_MODE")) {
                    v = obj[p];
                    $c39fed560cbb8833$var$intCheck(v, 0, 9, p);
                    MODULO_MODE = v;
                }
                // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                if (obj.hasOwnProperty(p = "POW_PRECISION")) {
                    v = obj[p];
                    $c39fed560cbb8833$var$intCheck(v, 0, $c39fed560cbb8833$var$MAX, p);
                    POW_PRECISION = v;
                }
                // FORMAT {object}
                // '[BigNumber Error] FORMAT not an object: {v}'
                if (obj.hasOwnProperty(p = "FORMAT")) {
                    v = obj[p];
                    if (typeof v == "object") FORMAT = v;
                    else throw Error($c39fed560cbb8833$var$bignumberError + p + " not an object: " + v);
                }
                // ALPHABET {string}
                // '[BigNumber Error] ALPHABET invalid: {v}'
                if (obj.hasOwnProperty(p = "ALPHABET")) {
                    v = obj[p];
                    // Disallow if less than two characters,
                    // or if it contains '+', '-', '.', whitespace, or a repeated character.
                    if (typeof v == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) {
                        alphabetHasNormalDecimalDigits = v.slice(0, 10) == "0123456789";
                        ALPHABET = v;
                    } else throw Error($c39fed560cbb8833$var$bignumberError + p + " invalid: " + v);
                }
            } else // '[BigNumber Error] Object expected: {v}'
            throw Error($c39fed560cbb8833$var$bignumberError + "Object expected: " + obj);
        }
        return {
            DECIMAL_PLACES: DECIMAL_PLACES,
            ROUNDING_MODE: ROUNDING_MODE,
            EXPONENTIAL_AT: [
                TO_EXP_NEG,
                TO_EXP_POS
            ],
            RANGE: [
                MIN_EXP,
                MAX_EXP
            ],
            CRYPTO: CRYPTO,
            MODULO_MODE: MODULO_MODE,
            POW_PRECISION: POW_PRECISION,
            FORMAT: FORMAT,
            ALPHABET: ALPHABET
        };
    };
    /*
   * Return true if v is a BigNumber instance, otherwise return false.
   *
   * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
   *
   * v {any}
   *
   * '[BigNumber Error] Invalid BigNumber: {v}'
   */ BigNumber.isBigNumber = function(v) {
        if (!v || v._isBigNumber !== true) return false;
        if (!BigNumber.DEBUG) return true;
        var i, n, c = v.c, e = v.e, s = v.s;
        out: if (({}).toString.call(c) == "[object Array]") {
            if ((s === 1 || s === -1) && e >= -$c39fed560cbb8833$var$MAX && e <= $c39fed560cbb8833$var$MAX && e === $c39fed560cbb8833$var$mathfloor(e)) {
                // If the first element is zero, the BigNumber value must be zero.
                if (c[0] === 0) {
                    if (e === 0 && c.length === 1) return true;
                    break out;
                }
                // Calculate number of digits that c[0] should have, based on the exponent.
                i = (e + 1) % $c39fed560cbb8833$var$LOG_BASE;
                if (i < 1) i += $c39fed560cbb8833$var$LOG_BASE;
                // Calculate number of digits of c[0].
                //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
                if (String(c[0]).length == i) {
                    for(i = 0; i < c.length; i++){
                        n = c[i];
                        if (n < 0 || n >= $c39fed560cbb8833$var$BASE || n !== $c39fed560cbb8833$var$mathfloor(n)) break out;
                    }
                    // Last element cannot be zero, unless it is the only element.
                    if (n !== 0) return true;
                }
            }
        } else if (c === null && e === null && (s === null || s === 1 || s === -1)) return true;
        throw Error($c39fed560cbb8833$var$bignumberError + "Invalid BigNumber: " + v);
    };
    /*
   * Return a new BigNumber whose value is the maximum of the arguments.
   *
   * arguments {number|string|BigNumber}
   */ BigNumber.maximum = BigNumber.max = function() {
        return maxOrMin(arguments, -1);
    };
    /*
   * Return a new BigNumber whose value is the minimum of the arguments.
   *
   * arguments {number|string|BigNumber}
   */ BigNumber.minimum = BigNumber.min = function() {
        return maxOrMin(arguments, 1);
    };
    /*
   * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
   * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
   * zeros are produced).
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
   * '[BigNumber Error] crypto unavailable'
   */ BigNumber.random = function() {
        var pow2_53 = 0x20000000000000;
        // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
        // Check if Math.random() produces more than 32 bits of randomness.
        // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
        // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
        var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function() {
            return $c39fed560cbb8833$var$mathfloor(Math.random() * pow2_53);
        } : function() {
            return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
        };
        return function(dp) {
            var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
            if (dp == null) dp = DECIMAL_PLACES;
            else $c39fed560cbb8833$var$intCheck(dp, 0, $c39fed560cbb8833$var$MAX);
            k = $c39fed560cbb8833$var$mathceil(dp / $c39fed560cbb8833$var$LOG_BASE);
            if (CRYPTO) {
                // Browsers supporting crypto.getRandomValues.
                if (crypto.getRandomValues) {
                    a = crypto.getRandomValues(new Uint32Array(k *= 2));
                    for(; i < k;){
                        // 53 bits:
                        // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                        // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                        // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                        //                                     11111 11111111 11111111
                        // 0x20000 is 2^21.
                        v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                        // Rejection sampling:
                        // 0 <= v < 9007199254740992
                        // Probability that v >= 9e15, is
                        // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                        if (v >= 9e15) {
                            b = crypto.getRandomValues(new Uint32Array(2));
                            a[i] = b[0];
                            a[i + 1] = b[1];
                        } else {
                            // 0 <= v <= 8999999999999999
                            // 0 <= (v % 1e14) <= 99999999999999
                            c.push(v % 1e14);
                            i += 2;
                        }
                    }
                    i = k / 2;
                // Node.js supporting crypto.randomBytes.
                } else if (crypto.randomBytes) {
                    // buffer
                    a = crypto.randomBytes(k *= 7);
                    for(; i < k;){
                        // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                        // 0x100000000 is 2^32, 0x1000000 is 2^24
                        // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                        // 0 <= v < 9007199254740992
                        v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                        if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                        else {
                            // 0 <= (v % 1e14) <= 99999999999999
                            c.push(v % 1e14);
                            i += 7;
                        }
                    }
                    i = k / 7;
                } else {
                    CRYPTO = false;
                    throw Error($c39fed560cbb8833$var$bignumberError + "crypto unavailable");
                }
            }
            // Use Math.random.
            if (!CRYPTO) for(; i < k;){
                v = random53bitInt();
                if (v < 9e15) c[i++] = v % 1e14;
            }
            k = c[--i];
            dp %= $c39fed560cbb8833$var$LOG_BASE;
            // Convert trailing digits to zeros according to dp.
            if (k && dp) {
                v = $c39fed560cbb8833$var$POWS_TEN[$c39fed560cbb8833$var$LOG_BASE - dp];
                c[i] = $c39fed560cbb8833$var$mathfloor(k / v) * v;
            }
            // Remove trailing elements which are zero.
            for(; c[i] === 0; c.pop(), i--);
            // Zero?
            if (i < 0) c = [
                e = 0
            ];
            else {
                // Remove leading elements which are zero and adjust exponent accordingly.
                for(e = -1; c[0] === 0; c.splice(0, 1), e -= $c39fed560cbb8833$var$LOG_BASE);
                // Count the digits of the first element of c to determine leading zeros, and...
                for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                // adjust the exponent accordingly.
                if (i < $c39fed560cbb8833$var$LOG_BASE) e -= $c39fed560cbb8833$var$LOG_BASE - i;
            }
            rand.e = e;
            rand.c = c;
            return rand;
        };
    }();
    /*
   * Return a BigNumber whose value is the sum of the arguments.
   *
   * arguments {number|string|BigNumber}
   */ BigNumber.sum = function() {
        var i = 1, args = arguments, sum = new BigNumber(args[0]);
        for(; i < args.length;)sum = sum.plus(args[i++]);
        return sum;
    };
    // PRIVATE FUNCTIONS
    // Called by BigNumber and BigNumber.prototype.toString.
    convertBase = function() {
        var decimal = "0123456789";
        /*
     * Convert string of baseIn to an array of numbers of baseOut.
     * Eg. toBaseOut('255', 10, 16) returns [15, 15].
     * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
     */ function toBaseOut(str, baseIn, baseOut, alphabet) {
            var j, arr = [
                0
            ], arrL, i = 0, len = str.length;
            for(; i < len;){
                for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                arr[0] += alphabet.indexOf(str.charAt(i++));
                for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                    if (arr[j + 1] == null) arr[j + 1] = 0;
                    arr[j + 1] += arr[j] / baseOut | 0;
                    arr[j] %= baseOut;
                }
            }
            return arr.reverse();
        }
        // Convert a numeric string of baseIn to a numeric string of baseOut.
        // If the caller is toString, we are converting from base 10 to baseOut.
        // If the caller is BigNumber, we are converting from baseIn to base 10.
        return function(str, baseIn, baseOut, sign, callerIsToString) {
            var alphabet, d, e, k, r, x, xc, y, i = str.indexOf("."), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
            // Non-integer.
            if (i >= 0) {
                k = POW_PRECISION;
                // Unlimited precision.
                POW_PRECISION = 0;
                str = str.replace(".", "");
                y = new BigNumber(baseIn);
                x = y.pow(str.length - i);
                POW_PRECISION = k;
                // Convert str as if an integer, then restore the fraction part by dividing the
                // result by its base raised to a power.
                y.c = toBaseOut($c39fed560cbb8833$var$toFixedPoint($c39fed560cbb8833$var$coeffToString(x.c), x.e, "0"), 10, baseOut, decimal);
                y.e = y.c.length;
            }
            // Convert the number as integer.
            xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
            // xc now represents str as an integer and converted to baseOut. e is the exponent.
            e = k = xc.length;
            // Remove trailing zeros.
            for(; xc[--k] == 0; xc.pop());
            // Zero?
            if (!xc[0]) return alphabet.charAt(0);
            // Does str represent an integer? If so, no need for the division.
            if (i < 0) --e;
            else {
                x.c = xc;
                x.e = e;
                // The sign is needed for correct rounding.
                x.s = sign;
                x = div(x, y, dp, rm, baseOut);
                xc = x.c;
                r = x.r;
                e = x.e;
            }
            // xc now represents str converted to baseOut.
            // THe index of the rounding digit.
            d = e + dp + 1;
            // The rounding digit: the digit to the right of the digit that may be rounded up.
            i = xc[d];
            // Look at the rounding digits and mode to determine whether to round up.
            k = baseOut / 2;
            r = r || d < 0 || xc[d + 1] != null;
            r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
            // If the index of the rounding digit is not greater than zero, or xc represents
            // zero, then the result of the base conversion is zero or, if rounding up, a value
            // such as 0.00001.
            if (d < 1 || !xc[0]) // 1^-dp or 0
            str = r ? $c39fed560cbb8833$var$toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
            else {
                // Truncate xc to the required number of decimal places.
                xc.length = d;
                // Round up?
                if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                for(--baseOut; ++xc[--d] > baseOut;){
                    xc[d] = 0;
                    if (!d) {
                        ++e;
                        xc = [
                            1
                        ].concat(xc);
                    }
                }
                // Determine trailing zeros.
                for(k = xc.length; !xc[--k];);
                // E.g. [4, 11, 15] becomes 4bf.
                for(i = 0, str = ""; i <= k; str += alphabet.charAt(xc[i++]));
                // Add leading zeros, decimal point and trailing zeros as required.
                str = $c39fed560cbb8833$var$toFixedPoint(str, e, alphabet.charAt(0));
            }
            // The caller will add the sign.
            return str;
        };
    }();
    // Perform division in the specified base. Called by div and convertBase.
    div = function() {
        // Assume non-zero x and k.
        function multiply(x, k, base) {
            var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % $c39fed560cbb8833$var$SQRT_BASE, khi = k / $c39fed560cbb8833$var$SQRT_BASE | 0;
            for(x = x.slice(); i--;){
                xlo = x[i] % $c39fed560cbb8833$var$SQRT_BASE;
                xhi = x[i] / $c39fed560cbb8833$var$SQRT_BASE | 0;
                m = khi * xlo + xhi * klo;
                temp = klo * xlo + m % $c39fed560cbb8833$var$SQRT_BASE * $c39fed560cbb8833$var$SQRT_BASE + carry;
                carry = (temp / base | 0) + (m / $c39fed560cbb8833$var$SQRT_BASE | 0) + khi * xhi;
                x[i] = temp % base;
            }
            if (carry) x = [
                carry
            ].concat(x);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, cmp;
            if (aL != bL) cmp = aL > bL ? 1 : -1;
            else {
                for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                    cmp = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return cmp;
        }
        function subtract(a, b, aL, base) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * base + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1; a.splice(0, 1));
        }
        // x: dividend, y: divisor.
        return function(x, y, dp, rm, base) {
            var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
            // Either NaN, Infinity or 0?
            if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
            !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
            xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
            q = new BigNumber(s);
            qc = q.c = [];
            e = x.e - y.e;
            s = dp + e + 1;
            if (!base) {
                base = $c39fed560cbb8833$var$BASE;
                e = $c39fed560cbb8833$var$bitFloor(x.e / $c39fed560cbb8833$var$LOG_BASE) - $c39fed560cbb8833$var$bitFloor(y.e / $c39fed560cbb8833$var$LOG_BASE);
                s = s / $c39fed560cbb8833$var$LOG_BASE | 0;
            }
            // Result exponent may be one less then the current value of e.
            // The coefficients of the BigNumbers from convertBase may have trailing zeros.
            for(i = 0; yc[i] == (xc[i] || 0); i++);
            if (yc[i] > (xc[i] || 0)) e--;
            if (s < 0) {
                qc.push(1);
                more = true;
            } else {
                xL = xc.length;
                yL = yc.length;
                i = 0;
                s += 2;
                // Normalise xc and yc so highest order digit of yc is >= base / 2.
                n = $c39fed560cbb8833$var$mathfloor(base / (yc[0] + 1));
                // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                if (n > 1) {
                    yc = multiply(yc, n, base);
                    xc = multiply(xc, n, base);
                    yL = yc.length;
                    xL = xc.length;
                }
                xi = yL;
                rem = xc.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL; rem[remL++] = 0);
                yz = yc.slice();
                yz = [
                    0
                ].concat(yz);
                yc0 = yc[0];
                if (yc[1] >= base / 2) yc0++;
                // Not necessary, but to prevent trial digit n > base, when using base 3.
                // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                do {
                    n = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yc, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, n.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                        // n is how many times the divisor goes into the current remainder.
                        n = $c39fed560cbb8833$var$mathfloor(rem0 / yc0);
                        //  Algorithm:
                        //  product = divisor multiplied by trial digit (n).
                        //  Compare product and remainder.
                        //  If product is greater than remainder:
                        //    Subtract divisor from product, decrement trial digit.
                        //  Subtract product from remainder.
                        //  If product was less than remainder at the last compare:
                        //    Compare new remainder and divisor.
                        //    If remainder is greater than divisor:
                        //      Subtract divisor from remainder, increment trial digit.
                        if (n > 1) {
                            // n may be > base only when base is 3.
                            if (n >= base) n = base - 1;
                            // product = divisor * trial digit.
                            prod = multiply(yc, n, base);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            // If product > remainder then trial digit n too high.
                            // n is 1 too high about 5% of the time, and is not known to have
                            // ever been more than 1 too high.
                            while(compare(prod, rem, prodL, remL) == 1){
                                n--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                prodL = prod.length;
                                cmp = 1;
                            }
                        } else {
                            // n is 0 or 1, cmp is -1.
                            // If n is 0, there is no need to compare yc and rem again below,
                            // so change cmp to 1 to avoid it.
                            // If n is 1, leave cmp as -1, so yc and rem are compared again.
                            if (n == 0) // divisor < remainder, so n must be at least 1.
                            cmp = n = 1;
                            // product = divisor
                            prod = yc.slice();
                            prodL = prod.length;
                        }
                        if (prodL < remL) prod = [
                            0
                        ].concat(prod);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL, base);
                        remL = rem.length;
                        // If product was < remainder.
                        if (cmp == -1) // Compare divisor and new remainder.
                        // If divisor < new remainder, subtract divisor from remainder.
                        // Trial digit n too low.
                        // n is 1 too low about 5% of the time, and very rarely 2 too low.
                        while(compare(yc, rem, yL, remL) < 1){
                            n++;
                            // Subtract divisor from remainder.
                            subtract(rem, yL < remL ? yz : yc, remL, base);
                            remL = rem.length;
                        }
                    } else if (cmp === 0) {
                        n++;
                        rem = [
                            0
                        ];
                    } // else cmp === 1 and n will be 0
                    // Add the next digit, n, to the result array.
                    qc[i++] = n;
                    // Update the remainder.
                    if (rem[0]) rem[remL++] = xc[xi] || 0;
                    else {
                        rem = [
                            xc[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] != null) && s--);
                more = rem[0] != null;
                // Leading zero?
                if (!qc[0]) qc.splice(0, 1);
            }
            if (base == $c39fed560cbb8833$var$BASE) {
                // To calculate q.e, first get the number of digits of qc[0].
                for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                round(q, dp + (q.e = i + e * $c39fed560cbb8833$var$LOG_BASE - 1) + 1, rm, more);
            // Caller is convertBase.
            } else {
                q.e = e;
                q.r = +more;
            }
            return q;
        };
    }();
    /*
   * Return a string representing the value of BigNumber n in fixed-point or exponential
   * notation rounded to the specified decimal places or significant digits.
   *
   * n: a BigNumber.
   * i: the index of the last digit required (i.e. the digit that may be rounded up).
   * rm: the rounding mode.
   * id: 1 (toExponential) or 2 (toPrecision).
   */ function format(n, i, rm, id) {
        var c0, e, ne, len, str;
        if (rm == null) rm = ROUNDING_MODE;
        else $c39fed560cbb8833$var$intCheck(rm, 0, 8);
        if (!n.c) return n.toString();
        c0 = n.c[0];
        ne = n.e;
        if (i == null) {
            str = $c39fed560cbb8833$var$coeffToString(n.c);
            str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS) ? $c39fed560cbb8833$var$toExponential(str, ne) : $c39fed560cbb8833$var$toFixedPoint(str, ne, "0");
        } else {
            n = round(new BigNumber(n), i, rm);
            // n.e may have changed if the value was rounded up.
            e = n.e;
            str = $c39fed560cbb8833$var$coeffToString(n.c);
            len = str.length;
            // toPrecision returns exponential notation if the number of significant digits
            // specified is less than the number of digits necessary to represent the integer
            // part of the value in fixed-point notation.
            // Exponential notation.
            if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                // Append zeros?
                for(; len < i; str += "0", len++);
                str = $c39fed560cbb8833$var$toExponential(str, e);
            // Fixed-point notation.
            } else {
                i -= ne;
                str = $c39fed560cbb8833$var$toFixedPoint(str, e, "0");
                // Append zeros?
                if (e + 1 > len) {
                    if (--i > 0) for(str += "."; i--; str += "0");
                } else {
                    i += e - len;
                    if (i > 0) {
                        if (e + 1 == len) str += ".";
                        for(; i--; str += "0");
                    }
                }
            }
        }
        return n.s < 0 && c0 ? "-" + str : str;
    }
    // Handle BigNumber.max and BigNumber.min.
    // If any number is NaN, return NaN.
    function maxOrMin(args, n) {
        var k, y, i = 1, x = new BigNumber(args[0]);
        for(; i < args.length; i++){
            y = new BigNumber(args[i]);
            if (!y.s || (k = $c39fed560cbb8833$var$compare(x, y)) === n || k === 0 && x.s === n) x = y;
        }
        return x;
    }
    /*
   * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
   * Called by minus, plus and times.
   */ function normalise(n, c, e) {
        var i = 1, j = c.length;
        // Remove trailing zeros.
        for(; !c[--j]; c.pop());
        // Calculate the base 10 exponent. First get the number of digits of c[0].
        for(j = c[0]; j >= 10; j /= 10, i++);
        // Overflow?
        if ((e = i + e * $c39fed560cbb8833$var$LOG_BASE - 1) > MAX_EXP) // Infinity.
        n.c = n.e = null;
        else if (e < MIN_EXP) // Zero.
        n.c = [
            n.e = 0
        ];
        else {
            n.e = e;
            n.c = c;
        }
        return n;
    }
    // Handle values that fail the validity test in BigNumber.
    parseNumeric = function() {
        var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
        return function(x, str, isNum, b) {
            var base, s = isNum ? str : str.replace(whitespaceOrPlus, "");
            // No exception on ±Infinity or NaN.
            if (isInfinityOrNaN.test(s)) x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
            else {
                if (!isNum) {
                    // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                    s = s.replace(basePrefix, function(m, p1, p2) {
                        base = (p2 = p2.toLowerCase()) == "x" ? 16 : p2 == "b" ? 2 : 8;
                        return !b || b == base ? p1 : m;
                    });
                    if (b) {
                        base = b;
                        // E.g. '1.' to '1', '.1' to '0.1'
                        s = s.replace(dotAfter, "$1").replace(dotBefore, "0.$1");
                    }
                    if (str != s) return new BigNumber(s, base);
                }
                // '[BigNumber Error] Not a number: {n}'
                // '[BigNumber Error] Not a base {b} number: {n}'
                if (BigNumber.DEBUG) throw Error($c39fed560cbb8833$var$bignumberError + "Not a" + (b ? " base " + b : "") + " number: " + str);
                // NaN
                x.s = null;
            }
            x.c = x.e = null;
        };
    }();
    /*
   * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
   * If r is truthy, it is known that there are more digits after the rounding digit.
   */ function round(x, sd, rm, r) {
        var d, i, j, k, n, ni, rd, xc = x.c, pows10 = $c39fed560cbb8833$var$POWS_TEN;
        // if x is not Infinity or NaN...
        if (xc) {
            // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
            // n is a base 1e14 number, the value of the element of array x.c containing rd.
            // ni is the index of n within x.c.
            // d is the number of digits of n.
            // i is the index of rd within n including leading zeros.
            // j is the actual index of rd within n (if < 0, rd is a leading zero).
            out: {
                // Get the number of digits of the first element of xc.
                for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                i = sd - d;
                // If the rounding digit is in the first element of xc...
                if (i < 0) {
                    i += $c39fed560cbb8833$var$LOG_BASE;
                    j = sd;
                    n = xc[ni = 0];
                    // Get the rounding digit at index j of n.
                    rd = $c39fed560cbb8833$var$mathfloor(n / pows10[d - j - 1] % 10);
                } else {
                    ni = $c39fed560cbb8833$var$mathceil((i + 1) / $c39fed560cbb8833$var$LOG_BASE);
                    if (ni >= xc.length) {
                        if (r) {
                            // Needed by sqrt.
                            for(; xc.length <= ni; xc.push(0));
                            n = rd = 0;
                            d = 1;
                            i %= $c39fed560cbb8833$var$LOG_BASE;
                            j = i - $c39fed560cbb8833$var$LOG_BASE + 1;
                        } else break out;
                    } else {
                        n = k = xc[ni];
                        // Get the number of digits of n.
                        for(d = 1; k >= 10; k /= 10, d++);
                        // Get the index of rd within n.
                        i %= $c39fed560cbb8833$var$LOG_BASE;
                        // Get the index of rd within n, adjusted for leading zeros.
                        // The number of leading zeros of n is given by LOG_BASE - d.
                        j = i - $c39fed560cbb8833$var$LOG_BASE + d;
                        // Get the rounding digit at index j of n.
                        rd = j < 0 ? 0 : $c39fed560cbb8833$var$mathfloor(n / pows10[d - j - 1] % 10);
                    }
                }
                r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                if (sd < 1 || !xc[0]) {
                    xc.length = 0;
                    if (r) {
                        // Convert sd to decimal places.
                        sd -= x.e + 1;
                        // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                        xc[0] = pows10[($c39fed560cbb8833$var$LOG_BASE - sd % $c39fed560cbb8833$var$LOG_BASE) % $c39fed560cbb8833$var$LOG_BASE];
                        x.e = -sd || 0;
                    } else // Zero.
                    xc[0] = x.e = 0;
                    return x;
                }
                // Remove excess digits.
                if (i == 0) {
                    xc.length = ni;
                    k = 1;
                    ni--;
                } else {
                    xc.length = ni + 1;
                    k = pows10[$c39fed560cbb8833$var$LOG_BASE - i];
                    // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                    // j > 0 means i > number of leading zeros of n.
                    xc[ni] = j > 0 ? $c39fed560cbb8833$var$mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                }
                // Round up?
                if (r) {
                    for(;;)// If the digit to be rounded up is in the first element of xc...
                    if (ni == 0) {
                        // i will be the length of xc[0] before k is added.
                        for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                        j = xc[0] += k;
                        for(k = 1; j >= 10; j /= 10, k++);
                        // if i != k the length has increased.
                        if (i != k) {
                            x.e++;
                            if (xc[0] == $c39fed560cbb8833$var$BASE) xc[0] = 1;
                        }
                        break;
                    } else {
                        xc[ni] += k;
                        if (xc[ni] != $c39fed560cbb8833$var$BASE) break;
                        xc[ni--] = 0;
                        k = 1;
                    }
                }
                // Remove trailing zeros.
                for(i = xc.length; xc[--i] === 0; xc.pop());
            }
            // Overflow? Infinity.
            if (x.e > MAX_EXP) x.c = x.e = null;
            else if (x.e < MIN_EXP) x.c = [
                x.e = 0
            ];
        }
        return x;
    }
    function valueOf(n) {
        var str, e = n.e;
        if (e === null) return n.toString();
        str = $c39fed560cbb8833$var$coeffToString(n.c);
        str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? $c39fed560cbb8833$var$toExponential(str, e) : $c39fed560cbb8833$var$toFixedPoint(str, e, "0");
        return n.s < 0 ? "-" + str : str;
    }
    // PROTOTYPE/INSTANCE METHODS
    /*
   * Return a new BigNumber whose value is the absolute value of this BigNumber.
   */ P.absoluteValue = P.abs = function() {
        var x = new BigNumber(this);
        if (x.s < 0) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
   *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
   *   0 if they have the same value,
   *   or null if the value of either is NaN.
   */ P.comparedTo = function(y, b) {
        return $c39fed560cbb8833$var$compare(this, new BigNumber(y, b));
    };
    /*
   * If dp is undefined or null or true or false, return the number of decimal places of the
   * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
   *
   * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
   * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
   * ROUNDING_MODE if rm is omitted.
   *
   * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   */ P.decimalPlaces = P.dp = function(dp, rm) {
        var c, n, v, x = this;
        if (dp != null) {
            $c39fed560cbb8833$var$intCheck(dp, 0, $c39fed560cbb8833$var$MAX);
            if (rm == null) rm = ROUNDING_MODE;
            else $c39fed560cbb8833$var$intCheck(rm, 0, 8);
            return round(new BigNumber(x), dp + x.e + 1, rm);
        }
        if (!(c = x.c)) return null;
        n = ((v = c.length - 1) - $c39fed560cbb8833$var$bitFloor(this.e / $c39fed560cbb8833$var$LOG_BASE)) * $c39fed560cbb8833$var$LOG_BASE;
        // Subtract the number of trailing zeros of the last number.
        if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
        if (n < 0) n = 0;
        return n;
    };
    /*
   *  n / 0 = I
   *  n / N = N
   *  n / I = 0
   *  0 / n = 0
   *  0 / 0 = N
   *  0 / N = N
   *  0 / I = 0
   *  N / n = N
   *  N / 0 = N
   *  N / N = N
   *  N / I = N
   *  I / n = I
   *  I / 0 = I
   *  I / N = N
   *  I / I = N
   *
   * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
   * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
   */ P.dividedBy = P.div = function(y, b) {
        return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
    };
    /*
   * Return a new BigNumber whose value is the integer part of dividing the value of this
   * BigNumber by the value of BigNumber(y, b).
   */ P.dividedToIntegerBy = P.idiv = function(y, b) {
        return div(this, new BigNumber(y, b), 0, 1);
    };
    /*
   * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
   *
   * If m is present, return the result modulo m.
   * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
   * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
   *
   * The modular power operation works efficiently when x, n, and m are integers, otherwise it
   * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
   *
   * n {number|string|BigNumber} The exponent. An integer.
   * [m] {number|string|BigNumber} The modulus.
   *
   * '[BigNumber Error] Exponent not an integer: {n}'
   */ P.exponentiatedBy = P.pow = function(n, m) {
        var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
        n = new BigNumber(n);
        // Allow NaN and ±Infinity, but not other non-integers.
        if (n.c && !n.isInteger()) throw Error($c39fed560cbb8833$var$bignumberError + "Exponent not an integer: " + valueOf(n));
        if (m != null) m = new BigNumber(m);
        // Exponent of MAX_SAFE_INTEGER is 15.
        nIsBig = n.e > 14;
        // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
        if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
            // The sign of the result of pow when x is negative depends on the evenness of n.
            // If +n overflows to ±Infinity, the evenness of n would be not be known.
            y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? n.s * (2 - $c39fed560cbb8833$var$isOdd(n)) : +valueOf(n)));
            return m ? y.mod(m) : y;
        }
        nIsNeg = n.s < 0;
        if (m) {
            // x % m returns NaN if abs(m) is zero, or m is NaN.
            if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
            isModExp = !nIsNeg && x.isInteger() && m.isInteger();
            if (isModExp) x = x.mod(m);
        // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
        // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
        } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
            // If x is negative and n is odd, k = -0, else k = 0.
            k = x.s < 0 && $c39fed560cbb8833$var$isOdd(n) ? -0 : 0;
            // If x >= 1, k = ±Infinity.
            if (x.e > -1) k = 1 / k;
            // If n is negative return ±0, else return ±Infinity.
            return new BigNumber(nIsNeg ? 1 / k : k);
        } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
        // equates to truncating significant digits to POW_PRECISION + [28, 41],
        // i.e. there will be a minimum of 28 guard digits retained.
        k = $c39fed560cbb8833$var$mathceil(POW_PRECISION / $c39fed560cbb8833$var$LOG_BASE + 2);
        if (nIsBig) {
            half = new BigNumber(0.5);
            if (nIsNeg) n.s = 1;
            nIsOdd = $c39fed560cbb8833$var$isOdd(n);
        } else {
            i = Math.abs(+valueOf(n));
            nIsOdd = i % 2;
        }
        y = new BigNumber(ONE);
        // Performs 54 loop iterations for n of 9007199254740991.
        for(;;){
            if (nIsOdd) {
                y = y.times(x);
                if (!y.c) break;
                if (k) {
                    if (y.c.length > k) y.c.length = k;
                } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
            }
            if (i) {
                i = $c39fed560cbb8833$var$mathfloor(i / 2);
                if (i === 0) break;
                nIsOdd = i % 2;
            } else {
                n = n.times(half);
                round(n, n.e + 1, 1);
                if (n.e > 14) nIsOdd = $c39fed560cbb8833$var$isOdd(n);
                else {
                    i = +valueOf(n);
                    if (i === 0) break;
                    nIsOdd = i % 2;
                }
            }
            x = x.times(x);
            if (k) {
                if (x.c && x.c.length > k) x.c.length = k;
            } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
        }
        if (isModExp) return y;
        if (nIsNeg) y = ONE.div(y);
        return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
    };
    /*
   * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
   * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
   *
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
   */ P.integerValue = function(rm) {
        var n = new BigNumber(this);
        if (rm == null) rm = ROUNDING_MODE;
        else $c39fed560cbb8833$var$intCheck(rm, 0, 8);
        return round(n, n.e + 1, rm);
    };
    /*
   * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
   * otherwise return false.
   */ P.isEqualTo = P.eq = function(y, b) {
        return $c39fed560cbb8833$var$compare(this, new BigNumber(y, b)) === 0;
    };
    /*
   * Return true if the value of this BigNumber is a finite number, otherwise return false.
   */ P.isFinite = function() {
        return !!this.c;
    };
    /*
   * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
   * otherwise return false.
   */ P.isGreaterThan = P.gt = function(y, b) {
        return $c39fed560cbb8833$var$compare(this, new BigNumber(y, b)) > 0;
    };
    /*
   * Return true if the value of this BigNumber is greater than or equal to the value of
   * BigNumber(y, b), otherwise return false.
   */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
        return (b = $c39fed560cbb8833$var$compare(this, new BigNumber(y, b))) === 1 || b === 0;
    };
    /*
   * Return true if the value of this BigNumber is an integer, otherwise return false.
   */ P.isInteger = function() {
        return !!this.c && $c39fed560cbb8833$var$bitFloor(this.e / $c39fed560cbb8833$var$LOG_BASE) > this.c.length - 2;
    };
    /*
   * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
   * otherwise return false.
   */ P.isLessThan = P.lt = function(y, b) {
        return $c39fed560cbb8833$var$compare(this, new BigNumber(y, b)) < 0;
    };
    /*
   * Return true if the value of this BigNumber is less than or equal to the value of
   * BigNumber(y, b), otherwise return false.
   */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
        return (b = $c39fed560cbb8833$var$compare(this, new BigNumber(y, b))) === -1 || b === 0;
    };
    /*
   * Return true if the value of this BigNumber is NaN, otherwise return false.
   */ P.isNaN = function() {
        return !this.s;
    };
    /*
   * Return true if the value of this BigNumber is negative, otherwise return false.
   */ P.isNegative = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this BigNumber is positive, otherwise return false.
   */ P.isPositive = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
   */ P.isZero = function() {
        return !!this.c && this.c[0] == 0;
    };
    /*
   *  n - 0 = n
   *  n - N = N
   *  n - I = -I
   *  0 - n = -n
   *  0 - 0 = 0
   *  0 - N = N
   *  0 - I = -I
   *  N - n = N
   *  N - 0 = N
   *  N - N = N
   *  N - I = N
   *  I - n = I
   *  I - 0 = I
   *  I - N = N
   *  I - I = N
   *
   * Return a new BigNumber whose value is the value of this BigNumber minus the value of
   * BigNumber(y, b).
   */ P.minus = function(y, b) {
        var i, j, t, xLTy, x = this, a = x.s;
        y = new BigNumber(y, b);
        b = y.s;
        // Either NaN?
        if (!a || !b) return new BigNumber(NaN);
        // Signs differ?
        if (a != b) {
            y.s = -b;
            return x.plus(y);
        }
        var xe = x.e / $c39fed560cbb8833$var$LOG_BASE, ye = y.e / $c39fed560cbb8833$var$LOG_BASE, xc = x.c, yc = y.c;
        if (!xe || !ye) {
            // Either Infinity?
            if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
            // Either zero?
            if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
            return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
            ROUNDING_MODE == 3 ? -0 : 0);
        }
        xe = $c39fed560cbb8833$var$bitFloor(xe);
        ye = $c39fed560cbb8833$var$bitFloor(ye);
        xc = xc.slice();
        // Determine which is the bigger number.
        if (a = xe - ye) {
            if (xLTy = a < 0) {
                a = -a;
                t = xc;
            } else {
                ye = xe;
                t = yc;
            }
            t.reverse();
            // Prepend zeros to equalise exponents.
            for(b = a; b--; t.push(0));
            t.reverse();
        } else {
            // Exponents equal. Check digit by digit.
            j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
            for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                xLTy = xc[b] < yc[b];
                break;
            }
        }
        // x < y? Point xc to the array of the bigger number.
        if (xLTy) {
            t = xc;
            xc = yc;
            yc = t;
            y.s = -y.s;
        }
        b = (j = yc.length) - (i = xc.length);
        // Append zeros to xc if shorter.
        // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
        if (b > 0) for(; b--; xc[i++] = 0);
        b = $c39fed560cbb8833$var$BASE - 1;
        // Subtract yc from xc.
        for(; j > a;){
            if (xc[--j] < yc[j]) {
                for(i = j; i && !xc[--i]; xc[i] = b);
                --xc[i];
                xc[j] += $c39fed560cbb8833$var$BASE;
            }
            xc[j] -= yc[j];
        }
        // Remove leading zeros and adjust exponent accordingly.
        for(; xc[0] == 0; xc.splice(0, 1), --ye);
        // Zero?
        if (!xc[0]) {
            // Following IEEE 754 (2008) 6.3,
            // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
            y.s = ROUNDING_MODE == 3 ? -1 : 1;
            y.c = [
                y.e = 0
            ];
            return y;
        }
        // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
        // for finite x and y.
        return normalise(y, xc, ye);
    };
    /*
   *   n % 0 =  N
   *   n % N =  N
   *   n % I =  n
   *   0 % n =  0
   *  -0 % n = -0
   *   0 % 0 =  N
   *   0 % N =  N
   *   0 % I =  0
   *   N % n =  N
   *   N % 0 =  N
   *   N % N =  N
   *   N % I =  N
   *   I % n =  N
   *   I % 0 =  N
   *   I % N =  N
   *   I % I =  N
   *
   * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
   * BigNumber(y, b). The result depends on the value of MODULO_MODE.
   */ P.modulo = P.mod = function(y, b) {
        var q, s, x = this;
        y = new BigNumber(y, b);
        // Return NaN if x is Infinity or NaN, or y is NaN or zero.
        if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
        else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
        if (MODULO_MODE == 9) {
            // Euclidian division: q = sign(y) * floor(x / abs(y))
            // r = x - qy    where  0 <= r < abs(y)
            s = y.s;
            y.s = 1;
            q = div(x, y, 0, 3);
            y.s = s;
            q.s *= s;
        } else q = div(x, y, 0, MODULO_MODE);
        y = x.minus(q.times(y));
        // To match JavaScript %, ensure sign of zero is sign of dividend.
        if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
        return y;
    };
    /*
   *  n * 0 = 0
   *  n * N = N
   *  n * I = I
   *  0 * n = 0
   *  0 * 0 = 0
   *  0 * N = N
   *  0 * I = N
   *  N * n = N
   *  N * 0 = N
   *  N * N = N
   *  N * I = N
   *  I * n = I
   *  I * 0 = N
   *  I * N = N
   *  I * I = I
   *
   * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
   * of BigNumber(y, b).
   */ P.multipliedBy = P.times = function(y, b) {
        var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
        // Either NaN, ±Infinity or ±0?
        if (!xc || !yc || !xc[0] || !yc[0]) {
            // Return NaN if either is NaN, or one is 0 and the other is Infinity.
            if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
            else {
                y.s *= x.s;
                // Return ±Infinity if either is ±Infinity.
                if (!xc || !yc) y.c = y.e = null;
                else {
                    y.c = [
                        0
                    ];
                    y.e = 0;
                }
            }
            return y;
        }
        e = $c39fed560cbb8833$var$bitFloor(x.e / $c39fed560cbb8833$var$LOG_BASE) + $c39fed560cbb8833$var$bitFloor(y.e / $c39fed560cbb8833$var$LOG_BASE);
        y.s *= x.s;
        xcL = xc.length;
        ycL = yc.length;
        // Ensure xc points to longer array and xcL to its length.
        if (xcL < ycL) {
            zc = xc;
            xc = yc;
            yc = zc;
            i = xcL;
            xcL = ycL;
            ycL = i;
        }
        // Initialise the result array with zeros.
        for(i = xcL + ycL, zc = []; i--; zc.push(0));
        base = $c39fed560cbb8833$var$BASE;
        sqrtBase = $c39fed560cbb8833$var$SQRT_BASE;
        for(i = ycL; --i >= 0;){
            c = 0;
            ylo = yc[i] % sqrtBase;
            yhi = yc[i] / sqrtBase | 0;
            for(k = xcL, j = i + k; j > i;){
                xlo = xc[--k] % sqrtBase;
                xhi = xc[k] / sqrtBase | 0;
                m = yhi * xlo + xhi * ylo;
                xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                zc[j--] = xlo % base;
            }
            zc[j] = c;
        }
        if (c) ++e;
        else zc.splice(0, 1);
        return normalise(y, zc, e);
    };
    /*
   * Return a new BigNumber whose value is the value of this BigNumber negated,
   * i.e. multiplied by -1.
   */ P.negated = function() {
        var x = new BigNumber(this);
        x.s = -x.s || null;
        return x;
    };
    /*
   *  n + 0 = n
   *  n + N = N
   *  n + I = I
   *  0 + n = n
   *  0 + 0 = 0
   *  0 + N = N
   *  0 + I = I
   *  N + n = N
   *  N + 0 = N
   *  N + N = N
   *  N + I = N
   *  I + n = I
   *  I + 0 = I
   *  I + N = N
   *  I + I = I
   *
   * Return a new BigNumber whose value is the value of this BigNumber plus the value of
   * BigNumber(y, b).
   */ P.plus = function(y, b) {
        var t, x = this, a = x.s;
        y = new BigNumber(y, b);
        b = y.s;
        // Either NaN?
        if (!a || !b) return new BigNumber(NaN);
        // Signs differ?
        if (a != b) {
            y.s = -b;
            return x.minus(y);
        }
        var xe = x.e / $c39fed560cbb8833$var$LOG_BASE, ye = y.e / $c39fed560cbb8833$var$LOG_BASE, xc = x.c, yc = y.c;
        if (!xe || !ye) {
            // Return ±Infinity if either ±Infinity.
            if (!xc || !yc) return new BigNumber(a / 0);
            // Either zero?
            // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
            if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
        }
        xe = $c39fed560cbb8833$var$bitFloor(xe);
        ye = $c39fed560cbb8833$var$bitFloor(ye);
        xc = xc.slice();
        // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
        if (a = xe - ye) {
            if (a > 0) {
                ye = xe;
                t = yc;
            } else {
                a = -a;
                t = xc;
            }
            t.reverse();
            for(; a--; t.push(0));
            t.reverse();
        }
        a = xc.length;
        b = yc.length;
        // Point xc to the longer array, and b to the shorter length.
        if (a - b < 0) {
            t = yc;
            yc = xc;
            xc = t;
            b = a;
        }
        // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
        for(a = 0; b;){
            a = (xc[--b] = xc[b] + yc[b] + a) / $c39fed560cbb8833$var$BASE | 0;
            xc[b] = $c39fed560cbb8833$var$BASE === xc[b] ? 0 : xc[b] % $c39fed560cbb8833$var$BASE;
        }
        if (a) {
            xc = [
                a
            ].concat(xc);
            ++ye;
        }
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        // ye = MAX_EXP + 1 possible
        return normalise(y, xc, ye);
    };
    /*
   * If sd is undefined or null or true or false, return the number of significant digits of
   * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
   * If sd is true include integer-part trailing zeros in the count.
   *
   * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
   * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
   * ROUNDING_MODE if rm is omitted.
   *
   * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
   *                     boolean: whether to count integer-part trailing zeros: true or false.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
   */ P.precision = P.sd = function(sd, rm) {
        var c, n, v, x = this;
        if (sd != null && sd !== !!sd) {
            $c39fed560cbb8833$var$intCheck(sd, 1, $c39fed560cbb8833$var$MAX);
            if (rm == null) rm = ROUNDING_MODE;
            else $c39fed560cbb8833$var$intCheck(rm, 0, 8);
            return round(new BigNumber(x), sd, rm);
        }
        if (!(c = x.c)) return null;
        v = c.length - 1;
        n = v * $c39fed560cbb8833$var$LOG_BASE + 1;
        if (v = c[v]) {
            // Subtract the number of trailing zeros of the last element.
            for(; v % 10 == 0; v /= 10, n--);
            // Add the number of digits of the first element.
            for(v = c[0]; v >= 10; v /= 10, n++);
        }
        if (sd && x.e + 1 > n) n = x.e + 1;
        return n;
    };
    /*
   * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
   * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
   *
   * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
   */ P.shiftedBy = function(k) {
        $c39fed560cbb8833$var$intCheck(k, -$c39fed560cbb8833$var$MAX_SAFE_INTEGER, $c39fed560cbb8833$var$MAX_SAFE_INTEGER);
        return this.times("1e" + k);
    };
    /*
   *  sqrt(-n) =  N
   *  sqrt(N) =  N
   *  sqrt(-I) =  N
   *  sqrt(I) =  I
   *  sqrt(0) =  0
   *  sqrt(-0) = -0
   *
   * Return a new BigNumber whose value is the square root of the value of this BigNumber,
   * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
   */ P.squareRoot = P.sqrt = function() {
        var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber("0.5");
        // Negative/NaN/Infinity/zero?
        if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
        // Initial estimate.
        s = Math.sqrt(+valueOf(x));
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = $c39fed560cbb8833$var$coeffToString(c);
            if ((n.length + e) % 2 == 0) n += "0";
            s = Math.sqrt(+n);
            e = $c39fed560cbb8833$var$bitFloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = "5e" + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf("e") + 1) + e;
            }
            r = new BigNumber(n);
        } else r = new BigNumber(s + "");
        // Check for zero.
        // r could be zero if MIN_EXP is changed after the this value was created.
        // This would cause a division by zero (x/t) and hence Infinity below, which would cause
        // coeffToString to throw.
        if (r.c[0]) {
            e = r.e;
            s = e + dp;
            if (s < 3) s = 0;
            // Newton-Raphson iteration.
            for(;;){
                t = r;
                r = half.times(t.plus(div(x, t, dp, 1)));
                if ($c39fed560cbb8833$var$coeffToString(t.c).slice(0, s) === (n = $c39fed560cbb8833$var$coeffToString(r.c)).slice(0, s)) {
                    // The exponent of r may here be one less than the final result exponent,
                    // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                    // are indexed correctly.
                    if (r.e < e) --s;
                    n = n.slice(s - 3, s + 1);
                    // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                    // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                    // iteration.
                    if (n == "9999" || !rep && n == "4999") {
                        // On the first iteration only, check to see if rounding up gives the
                        // exact result as the nines may infinitely repeat.
                        if (!rep) {
                            round(t, t.e + DECIMAL_PLACES + 2, 0);
                            if (t.times(t).eq(x)) {
                                r = t;
                                break;
                            }
                        }
                        dp += 4;
                        s += 4;
                        rep = 1;
                    } else {
                        // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                        // result. If not, then there are further digits and m will be truthy.
                        if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                            // Truncate to the first rounding digit.
                            round(r, r.e + DECIMAL_PLACES + 2, 1);
                            m = !r.times(r).eq(x);
                        }
                        break;
                    }
                }
            }
        }
        return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
    };
    /*
   * Return a string representing the value of this BigNumber in exponential notation and
   * rounded using ROUNDING_MODE to dp fixed decimal places.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   */ P.toExponential = function(dp, rm) {
        if (dp != null) {
            $c39fed560cbb8833$var$intCheck(dp, 0, $c39fed560cbb8833$var$MAX);
            dp++;
        }
        return format(this, dp, rm, 1);
    };
    /*
   * Return a string representing the value of this BigNumber in fixed-point notation rounding
   * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
   *
   * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
   * but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   */ P.toFixed = function(dp, rm) {
        if (dp != null) {
            $c39fed560cbb8833$var$intCheck(dp, 0, $c39fed560cbb8833$var$MAX);
            dp = dp + this.e + 1;
        }
        return format(this, dp, rm);
    };
    /*
   * Return a string representing the value of this BigNumber in fixed-point notation rounded
   * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
   * of the format or FORMAT object (see BigNumber.set).
   *
   * The formatting object may contain some or all of the properties shown below.
   *
   * FORMAT = {
   *   prefix: '',
   *   groupSize: 3,
   *   secondaryGroupSize: 0,
   *   groupSeparator: ',',
   *   decimalSeparator: '.',
   *   fractionGroupSize: 0,
   *   fractionGroupSeparator: '\xA0',      // non-breaking space
   *   suffix: ''
   * };
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   * [format] {object} Formatting options. See FORMAT pbject above.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
   * '[BigNumber Error] Argument not an object: {format}'
   */ P.toFormat = function(dp, rm, format) {
        var str, x = this;
        if (format == null) {
            if (dp != null && rm && typeof rm == "object") {
                format = rm;
                rm = null;
            } else if (dp && typeof dp == "object") {
                format = dp;
                dp = rm = null;
            } else format = FORMAT;
        } else if (typeof format != "object") throw Error($c39fed560cbb8833$var$bignumberError + "Argument not an object: " + format);
        str = x.toFixed(dp, rm);
        if (x.c) {
            var i, arr = str.split("."), g1 = +format.groupSize, g2 = +format.secondaryGroupSize, groupSeparator = format.groupSeparator || "", intPart = arr[0], fractionPart = arr[1], isNeg = x.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
            if (g2) {
                i = g1;
                g1 = g2;
                g2 = i;
                len -= i;
            }
            if (g1 > 0 && len > 0) {
                i = len % g1 || g1;
                intPart = intDigits.substr(0, i);
                for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                if (isNeg) intPart = "-" + intPart;
            }
            str = fractionPart ? intPart + (format.decimalSeparator || "") + ((g2 = +format.fractionGroupSize) ? fractionPart.replace(new RegExp("\\d{" + g2 + "}\\B", "g"), "$&" + (format.fractionGroupSeparator || "")) : fractionPart) : intPart;
        }
        return (format.prefix || "") + str + (format.suffix || "");
    };
    /*
   * Return an array of two BigNumbers representing the value of this BigNumber as a simple
   * fraction with an integer numerator and an integer denominator.
   * The denominator will be a positive non-zero value less than or equal to the specified
   * maximum denominator. If a maximum denominator is not specified, the denominator will be
   * the lowest value necessary to represent the number exactly.
   *
   * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
   *
   * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
   */ P.toFraction = function(md) {
        var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s, x = this, xc = x.c;
        if (md != null) {
            n = new BigNumber(md);
            // Throw if md is less than one or is not an integer, unless it is Infinity.
            if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error($c39fed560cbb8833$var$bignumberError + "Argument " + (n.isInteger() ? "out of range: " : "not an integer: ") + valueOf(n));
        }
        if (!xc) return new BigNumber(x);
        d = new BigNumber(ONE);
        n1 = d0 = new BigNumber(ONE);
        d1 = n0 = new BigNumber(ONE);
        s = $c39fed560cbb8833$var$coeffToString(xc);
        // Determine initial denominator.
        // d is a power of 10 and the minimum max denominator that specifies the value exactly.
        e = d.e = s.length - x.e - 1;
        d.c[0] = $c39fed560cbb8833$var$POWS_TEN[(exp = e % $c39fed560cbb8833$var$LOG_BASE) < 0 ? $c39fed560cbb8833$var$LOG_BASE + exp : exp];
        md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
        exp = MAX_EXP;
        MAX_EXP = 1 / 0;
        n = new BigNumber(s);
        // n0 = d1 = 0
        n0.c[0] = 0;
        for(;;){
            q = div(n, d, 0, 1);
            d2 = d0.plus(q.times(d1));
            if (d2.comparedTo(md) == 1) break;
            d0 = d1;
            d1 = d2;
            n1 = n0.plus(q.times(d2 = n1));
            n0 = d2;
            d = n.minus(q.times(d2 = d));
            n = d2;
        }
        d2 = div(md.minus(d0), d1, 0, 1);
        n0 = n0.plus(d2.times(n1));
        d0 = d0.plus(d2.times(d1));
        n0.s = n1.s = x.s;
        e = e * 2;
        // Determine which fraction is closer to x, n0/d0 or n1/d1
        r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
            n1,
            d1
        ] : [
            n0,
            d0
        ];
        MAX_EXP = exp;
        return r;
    };
    /*
   * Return the value of this BigNumber converted to a number primitive.
   */ P.toNumber = function() {
        return +valueOf(this);
    };
    /*
   * Return a string representing the value of this BigNumber rounded to sd significant digits
   * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
   * necessary to represent the integer part of the value in fixed-point notation, then use
   * exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
   */ P.toPrecision = function(sd, rm) {
        if (sd != null) $c39fed560cbb8833$var$intCheck(sd, 1, $c39fed560cbb8833$var$MAX);
        return format(this, sd, rm, 2);
    };
    /*
   * Return a string representing the value of this BigNumber in base b, or base 10 if b is
   * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
   * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
   * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
   * TO_EXP_NEG, return exponential notation.
   *
   * [b] {number} Integer, 2 to ALPHABET.length inclusive.
   *
   * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
   */ P.toString = function(b) {
        var str, n = this, s = n.s, e = n.e;
        // Infinity or NaN?
        if (e === null) {
            if (s) {
                str = "Infinity";
                if (s < 0) str = "-" + str;
            } else str = "NaN";
        } else {
            if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? $c39fed560cbb8833$var$toExponential($c39fed560cbb8833$var$coeffToString(n.c), e) : $c39fed560cbb8833$var$toFixedPoint($c39fed560cbb8833$var$coeffToString(n.c), e, "0");
            else if (b === 10 && alphabetHasNormalDecimalDigits) {
                n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
                str = $c39fed560cbb8833$var$toFixedPoint($c39fed560cbb8833$var$coeffToString(n.c), n.e, "0");
            } else {
                $c39fed560cbb8833$var$intCheck(b, 2, ALPHABET.length, "Base");
                str = convertBase($c39fed560cbb8833$var$toFixedPoint($c39fed560cbb8833$var$coeffToString(n.c), e, "0"), 10, b, s, true);
            }
            if (s < 0 && n.c[0]) str = "-" + str;
        }
        return str;
    };
    /*
   * Return as toString, but do not accept a base argument, and include the minus sign for
   * negative zero.
   */ P.valueOf = P.toJSON = function() {
        return valueOf(this);
    };
    P._isBigNumber = true;
    P[Symbol.toStringTag] = "BigNumber";
    // Node.js v10.12.0+
    P[Symbol.for("nodejs.util.inspect.custom")] = P.valueOf;
    if (configObject != null) BigNumber.set(configObject);
    return BigNumber;
}
// PRIVATE HELPER FUNCTIONS
// These functions don't need access to variables,
// e.g. DECIMAL_PLACES, in the scope of the `clone` function above.
function $c39fed560cbb8833$var$bitFloor(n) {
    var i = n | 0;
    return n > 0 || n === i ? i : i - 1;
}
// Return a coefficient array as a string of base 10 digits.
function $c39fed560cbb8833$var$coeffToString(a) {
    var s, z, i = 1, j = a.length, r = a[0] + "";
    for(; i < j;){
        s = a[i++] + "";
        z = $c39fed560cbb8833$var$LOG_BASE - s.length;
        for(; z--; s = "0" + s);
        r += s;
    }
    // Determine trailing zeros.
    for(j = r.length; r.charCodeAt(--j) === 48;);
    return r.slice(0, j + 1 || 1);
}
// Compare the value of BigNumbers x and y.
function $c39fed560cbb8833$var$compare(x, y) {
    var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
    // Either NaN?
    if (!i || !j) return null;
    a = xc && !xc[0];
    b = yc && !yc[0];
    // Either zero?
    if (a || b) return a ? b ? 0 : -j : i;
    // Signs differ?
    if (i != j) return i;
    a = i < 0;
    b = k == l;
    // Either Infinity?
    if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
    // Compare exponents.
    if (!b) return k > l ^ a ? 1 : -1;
    j = (k = xc.length) < (l = yc.length) ? k : l;
    // Compare digit by digit.
    for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
    // Compare lengths.
    return k == l ? 0 : k > l ^ a ? 1 : -1;
}
/*
 * Check that n is a primitive number, an integer, and in range, otherwise throw.
 */ function $c39fed560cbb8833$var$intCheck(n, min, max, name) {
    if (n < min || n > max || n !== $c39fed560cbb8833$var$mathfloor(n)) throw Error($c39fed560cbb8833$var$bignumberError + (name || "Argument") + (typeof n == "number" ? n < min || n > max ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(n));
}
// Assumes finite n.
function $c39fed560cbb8833$var$isOdd(n) {
    var k = n.c.length - 1;
    return $c39fed560cbb8833$var$bitFloor(n.e / $c39fed560cbb8833$var$LOG_BASE) == k && n.c[k] % 2 != 0;
}
function $c39fed560cbb8833$var$toExponential(str, e) {
    return (str.length > 1 ? str.charAt(0) + "." + str.slice(1) : str) + (e < 0 ? "e" : "e+") + e;
}
function $c39fed560cbb8833$var$toFixedPoint(str, e, z) {
    var len, zs;
    // Negative exponent?
    if (e < 0) {
        // Prepend zeros.
        for(zs = z + "."; ++e; zs += z);
        str = zs + str;
    // Positive exponent
    } else {
        len = str.length;
        // Append zeros.
        if (++e > len) {
            for(zs = z, e -= len; --e; zs += z);
            str += zs;
        } else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
    }
    return str;
}
var $c39fed560cbb8833$export$d97aa349ed20696 = $c39fed560cbb8833$var$clone();
var $c39fed560cbb8833$export$2e2bcd8739ae039 = $c39fed560cbb8833$export$d97aa349ed20696;




const $d5c5be62b361c68a$export$23054672248b2c43 = new (0, $c39fed560cbb8833$export$2e2bcd8739ae039)("1e+18");
const $d5c5be62b361c68a$export$78a48a3d1e5dbe89 = (property)=>{
    const layout = (0, $3b2d1baa52a31e71$export$6cebf8c93d35ecb4)(property);
    const { encode: encode, decode: decode } = (0, $bd31c8d4e4071f4f$export$15db02dbfcaf60e0)(layout);
    const decimalLayout = layout;
    decimalLayout.decode = (buffer, offset)=>{
        const src = decode(buffer, offset).toString();
        return new (0, $c39fed560cbb8833$export$2e2bcd8739ae039)(src).div($d5c5be62b361c68a$export$23054672248b2c43);
    };
    decimalLayout.encode = (decimal, buffer, offset)=>{
        const src = BigInt(decimal.times($d5c5be62b361c68a$export$23054672248b2c43).integerValue().toString());
        return encode(src, buffer, offset);
    };
    return decimalLayout;
};




const $8f00f9d827a09685$export$87b259aa03e3d267 = (property)=>{
    const layout = (0, $ab8b5713b1ee9109$exports.u8)(property);
    const { encode: encode, decode: decode } = (0, $bd31c8d4e4071f4f$export$15db02dbfcaf60e0)(layout);
    const boolLayout = layout;
    boolLayout.decode = (buffer, offset)=>{
        const src = decode(buffer, offset);
        return !!src;
    };
    boolLayout.encode = (bool, buffer, offset)=>{
        const src = Number(bool);
        return encode(src, buffer, offset);
    };
    return boolLayout;
};





const $622167bc200b6540$export$86f13247979de5d7 = (property)=>{
    const layout = (0, $ab8b5713b1ee9109$exports.blob)(32, property);
    const { encode: encode, decode: decode } = (0, $bd31c8d4e4071f4f$export$15db02dbfcaf60e0)(layout);
    const publicKeyLayout = layout;
    publicKeyLayout.decode = (buffer, offset)=>{
        const src = decode(buffer, offset);
        return new (0, $ca3473265f76df98$export$ca8b6604d6ce14de)(src);
    };
    publicKeyLayout.encode = (publicKey, buffer, offset)=>{
        const src = publicKey.toBuffer();
        return encode(src, buffer, offset);
    };
    return publicKeyLayout;
};






/** Base class for errors */ class $8afd026bce6c5170$export$ed0b8b496332122d extends Error {
    constructor(message){
        super(message);
    }
}
class $8afd026bce6c5170$export$a09a5e48de2f3404 extends $8afd026bce6c5170$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenAccountNotFoundError";
    }
}
class $8afd026bce6c5170$export$f4938317c78e324f extends $8afd026bce6c5170$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenInvalidAccountError";
    }
}
class $8afd026bce6c5170$export$8daa71fef5582c70 extends $8afd026bce6c5170$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenInvalidAccountDataError";
    }
}
class $8afd026bce6c5170$export$abb470453474d51 extends $8afd026bce6c5170$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenInvalidAccountOwnerError";
    }
}
class $8afd026bce6c5170$export$250d31de4ddb7ca5 extends $8afd026bce6c5170$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenInvalidAccountSizeError";
    }
}
class $8afd026bce6c5170$export$871debb212ec395 extends $8afd026bce6c5170$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenInvalidMintError";
    }
}
class $8afd026bce6c5170$export$9d3e0012e0e06993 extends $8afd026bce6c5170$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenInvalidOwnerError";
    }
}
class $8afd026bce6c5170$export$c431a85da6f99bf0 extends $8afd026bce6c5170$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenOwnerOffCurveError";
    }
}
class $8afd026bce6c5170$export$a241007212c884f6 extends $8afd026bce6c5170$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenInvalidInstructionProgramError";
    }
}
class $8afd026bce6c5170$export$3882cbbd44973a88 extends $8afd026bce6c5170$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenInvalidInstructionKeysError";
    }
}
class $8afd026bce6c5170$export$f96a822f391c3cc4 extends $8afd026bce6c5170$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenInvalidInstructionDataError";
    }
}
class $8afd026bce6c5170$export$e1301365d704141e extends $8afd026bce6c5170$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenInvalidInstructionTypeError";
    }
}
class $8afd026bce6c5170$export$ff48aa5f01687311 extends $8afd026bce6c5170$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenUnsupportedInstructionError";
    }
}
class $8afd026bce6c5170$export$f515f489e4a79004 extends $8afd026bce6c5170$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenTransferHookAccountNotFound";
    }
}
class $8afd026bce6c5170$export$9fe40fd85b8108b extends $8afd026bce6c5170$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenTransferHookInvalidSeed";
    }
}
class $8afd026bce6c5170$export$de66998ed6d15b14 extends $8afd026bce6c5170$export$ed0b8b496332122d {
    constructor(){
        super(...arguments);
        this.name = "TokenTransferHookAccountDataNotFound";
    }
}



function $d2f675c3c5788b61$export$fde60050662f8c02(keys, ownerOrAuthority, multiSigners) {
    if (multiSigners.length) {
        keys.push({
            pubkey: ownerOrAuthority,
            isSigner: false,
            isWritable: false
        });
        for (const signer of multiSigners)keys.push({
            pubkey: signer instanceof (0, $ca3473265f76df98$export$ca8b6604d6ce14de) ? signer : signer.publicKey,
            isSigner: true,
            isWritable: false
        });
    } else keys.push({
        pubkey: ownerOrAuthority,
        isSigner: true,
        isWritable: false
    });
    return keys;
}


/** Instructions defined by the program */ var $c6e743120d59fcac$export$236c07be390a0994;
(function(TokenInstruction) {
    TokenInstruction[TokenInstruction["InitializeMint"] = 0] = "InitializeMint";
    TokenInstruction[TokenInstruction["InitializeAccount"] = 1] = "InitializeAccount";
    TokenInstruction[TokenInstruction["InitializeMultisig"] = 2] = "InitializeMultisig";
    TokenInstruction[TokenInstruction["Transfer"] = 3] = "Transfer";
    TokenInstruction[TokenInstruction["Approve"] = 4] = "Approve";
    TokenInstruction[TokenInstruction["Revoke"] = 5] = "Revoke";
    TokenInstruction[TokenInstruction["SetAuthority"] = 6] = "SetAuthority";
    TokenInstruction[TokenInstruction["MintTo"] = 7] = "MintTo";
    TokenInstruction[TokenInstruction["Burn"] = 8] = "Burn";
    TokenInstruction[TokenInstruction["CloseAccount"] = 9] = "CloseAccount";
    TokenInstruction[TokenInstruction["FreezeAccount"] = 10] = "FreezeAccount";
    TokenInstruction[TokenInstruction["ThawAccount"] = 11] = "ThawAccount";
    TokenInstruction[TokenInstruction["TransferChecked"] = 12] = "TransferChecked";
    TokenInstruction[TokenInstruction["ApproveChecked"] = 13] = "ApproveChecked";
    TokenInstruction[TokenInstruction["MintToChecked"] = 14] = "MintToChecked";
    TokenInstruction[TokenInstruction["BurnChecked"] = 15] = "BurnChecked";
    TokenInstruction[TokenInstruction["InitializeAccount2"] = 16] = "InitializeAccount2";
    TokenInstruction[TokenInstruction["SyncNative"] = 17] = "SyncNative";
    TokenInstruction[TokenInstruction["InitializeAccount3"] = 18] = "InitializeAccount3";
    TokenInstruction[TokenInstruction["InitializeMultisig2"] = 19] = "InitializeMultisig2";
    TokenInstruction[TokenInstruction["InitializeMint2"] = 20] = "InitializeMint2";
    TokenInstruction[TokenInstruction["GetAccountDataSize"] = 21] = "GetAccountDataSize";
    TokenInstruction[TokenInstruction["InitializeImmutableOwner"] = 22] = "InitializeImmutableOwner";
    TokenInstruction[TokenInstruction["AmountToUiAmount"] = 23] = "AmountToUiAmount";
    TokenInstruction[TokenInstruction["UiAmountToAmount"] = 24] = "UiAmountToAmount";
    TokenInstruction[TokenInstruction["InitializeMintCloseAuthority"] = 25] = "InitializeMintCloseAuthority";
    TokenInstruction[TokenInstruction["TransferFeeExtension"] = 26] = "TransferFeeExtension";
    TokenInstruction[TokenInstruction["ConfidentialTransferExtension"] = 27] = "ConfidentialTransferExtension";
    TokenInstruction[TokenInstruction["DefaultAccountStateExtension"] = 28] = "DefaultAccountStateExtension";
    TokenInstruction[TokenInstruction["Reallocate"] = 29] = "Reallocate";
    TokenInstruction[TokenInstruction["MemoTransferExtension"] = 30] = "MemoTransferExtension";
    TokenInstruction[TokenInstruction["CreateNativeMint"] = 31] = "CreateNativeMint";
    TokenInstruction[TokenInstruction["InitializeNonTransferableMint"] = 32] = "InitializeNonTransferableMint";
    TokenInstruction[TokenInstruction["InterestBearingMintExtension"] = 33] = "InterestBearingMintExtension";
    TokenInstruction[TokenInstruction["CpiGuardExtension"] = 34] = "CpiGuardExtension";
    TokenInstruction[TokenInstruction["InitializePermanentDelegate"] = 35] = "InitializePermanentDelegate";
    TokenInstruction[TokenInstruction["TransferHookExtension"] = 36] = "TransferHookExtension";
    // ConfidentialTransferFeeExtension = 37,
    // WithdrawalExcessLamports = 38,
    TokenInstruction[TokenInstruction["MetadataPointerExtension"] = 39] = "MetadataPointerExtension";
    TokenInstruction[TokenInstruction["GroupPointerExtension"] = 40] = "GroupPointerExtension";
    TokenInstruction[TokenInstruction["GroupMemberPointerExtension"] = 41] = "GroupMemberPointerExtension";
})($c6e743120d59fcac$export$236c07be390a0994 || ($c6e743120d59fcac$export$236c07be390a0994 = {}));



var $950a0899dcef3911$require$Buffer = $1ff5f276bd1e09e8$export$a143d493d941bafc;
const $950a0899dcef3911$export$36b3d03efc16d305 = (0, $ab8b5713b1ee9109$exports.struct)([
    (0, $ab8b5713b1ee9109$exports.u8)("instruction"),
    (0, $3b2d1baa52a31e71$export$cd1442401e54cffa)("amount")
]);
function $950a0899dcef3911$export$b274d5cebe357db9(source, destination, owner, amount, multiSigners = [], programId = (0, $071f33b9e1b22b13$export$79de3e3c2b1ca801)) {
    const keys = (0, $d2f675c3c5788b61$export$fde60050662f8c02)([
        {
            pubkey: source,
            isSigner: false,
            isWritable: true
        },
        {
            pubkey: destination,
            isSigner: false,
            isWritable: true
        }
    ], owner, multiSigners);
    const data = $950a0899dcef3911$require$Buffer.alloc($950a0899dcef3911$export$36b3d03efc16d305.span);
    $950a0899dcef3911$export$36b3d03efc16d305.encode({
        instruction: (0, $c6e743120d59fcac$export$236c07be390a0994).Transfer,
        amount: BigInt(amount)
    }, data);
    return new (0, $ca3473265f76df98$export$a7a3aa8360ac9f59)({
        keys: keys,
        programId: programId,
        data: data
    });
}
function $950a0899dcef3911$export$d4ef34cde439b107(instruction, programId = (0, $071f33b9e1b22b13$export$79de3e3c2b1ca801)) {
    if (!instruction.programId.equals(programId)) throw new (0, $8afd026bce6c5170$export$a241007212c884f6)();
    if (instruction.data.length !== $950a0899dcef3911$export$36b3d03efc16d305.span) throw new (0, $8afd026bce6c5170$export$f96a822f391c3cc4)();
    const { keys: { source: source, destination: destination, owner: owner, multiSigners: multiSigners }, data: data } = $950a0899dcef3911$export$f64172008a79e2e1(instruction);
    if (data.instruction !== (0, $c6e743120d59fcac$export$236c07be390a0994).Transfer) throw new (0, $8afd026bce6c5170$export$e1301365d704141e)();
    if (!source || !destination || !owner) throw new (0, $8afd026bce6c5170$export$3882cbbd44973a88)();
    // TODO: key checks?
    return {
        programId: programId,
        keys: {
            source: source,
            destination: destination,
            owner: owner,
            multiSigners: multiSigners
        },
        data: data
    };
}
function $950a0899dcef3911$export$f64172008a79e2e1({ programId: programId, keys: [source, destination, owner, ...multiSigners], data: data }) {
    return {
        programId: programId,
        keys: {
            source: source,
            destination: destination,
            owner: owner,
            multiSigners: multiSigners
        },
        data: $950a0899dcef3911$export$36b3d03efc16d305.decode(data)
    };
}






var $638cf1c35454a549$export$b8ca5fa4899cbfc7;
(function(AccountType) {
    AccountType[AccountType["Uninitialized"] = 0] = "Uninitialized";
    AccountType[AccountType["Mint"] = 1] = "Mint";
    AccountType[AccountType["Account"] = 2] = "Account";
})($638cf1c35454a549$export$b8ca5fa4899cbfc7 || ($638cf1c35454a549$export$b8ca5fa4899cbfc7 = {}));
const $638cf1c35454a549$export$9d3ac77dcbf22b3f = 1;












const $ef806c48b215bede$export$c23cd279ce124ca0 = (0, $ab8b5713b1ee9109$exports.struct)([
    (0, $ab8b5713b1ee9109$exports.u8)("m"),
    (0, $ab8b5713b1ee9109$exports.u8)("n"),
    (0, $8f00f9d827a09685$export$87b259aa03e3d267)("isInitialized"),
    (0, $622167bc200b6540$export$86f13247979de5d7)("signer1"),
    (0, $622167bc200b6540$export$86f13247979de5d7)("signer2"),
    (0, $622167bc200b6540$export$86f13247979de5d7)("signer3"),
    (0, $622167bc200b6540$export$86f13247979de5d7)("signer4"),
    (0, $622167bc200b6540$export$86f13247979de5d7)("signer5"),
    (0, $622167bc200b6540$export$86f13247979de5d7)("signer6"),
    (0, $622167bc200b6540$export$86f13247979de5d7)("signer7"),
    (0, $622167bc200b6540$export$86f13247979de5d7)("signer8"),
    (0, $622167bc200b6540$export$86f13247979de5d7)("signer9"),
    (0, $622167bc200b6540$export$86f13247979de5d7)("signer10"),
    (0, $622167bc200b6540$export$86f13247979de5d7)("signer11")
]);
const $ef806c48b215bede$export$c2abf71f91a1605b = $ef806c48b215bede$export$c23cd279ce124ca0.span;
async function $ef806c48b215bede$export$257dfa65916d8d24(connection, address, commitment, programId = (0, $071f33b9e1b22b13$export$79de3e3c2b1ca801)) {
    const info = await connection.getAccountInfo(address, commitment);
    return $ef806c48b215bede$export$2620f4d387573ced(address, info, programId);
}
function $ef806c48b215bede$export$2620f4d387573ced(address, info, programId = (0, $071f33b9e1b22b13$export$79de3e3c2b1ca801)) {
    if (!info) throw new (0, $8afd026bce6c5170$export$a09a5e48de2f3404)();
    if (!info.owner.equals(programId)) throw new (0, $8afd026bce6c5170$export$abb470453474d51)();
    if (info.data.length != $ef806c48b215bede$export$c2abf71f91a1605b) throw new (0, $8afd026bce6c5170$export$250d31de4ddb7ca5)();
    const multisig = $ef806c48b215bede$export$c23cd279ce124ca0.decode(info.data);
    return {
        address: address,
        ...multisig
    };
}
async function $ef806c48b215bede$export$cd6dc5245600da53(connection, commitment) {
    return await connection.getMinimumBalanceForRentExemption($ef806c48b215bede$export$c2abf71f91a1605b, commitment);
}



var $4f8e5a3f35fa75b9$require$Buffer = $1ff5f276bd1e09e8$export$a143d493d941bafc;
var $4f8e5a3f35fa75b9$export$70504fba2ce56d52;
(function(AccountState) {
    AccountState[AccountState["Uninitialized"] = 0] = "Uninitialized";
    AccountState[AccountState["Initialized"] = 1] = "Initialized";
    AccountState[AccountState["Frozen"] = 2] = "Frozen";
})($4f8e5a3f35fa75b9$export$70504fba2ce56d52 || ($4f8e5a3f35fa75b9$export$70504fba2ce56d52 = {}));
const $4f8e5a3f35fa75b9$export$cab31ec27f6c5fa = (0, $ab8b5713b1ee9109$exports.struct)([
    (0, $622167bc200b6540$export$86f13247979de5d7)("mint"),
    (0, $622167bc200b6540$export$86f13247979de5d7)("owner"),
    (0, $3b2d1baa52a31e71$export$cd1442401e54cffa)("amount"),
    (0, $ab8b5713b1ee9109$exports.u32)("delegateOption"),
    (0, $622167bc200b6540$export$86f13247979de5d7)("delegate"),
    (0, $ab8b5713b1ee9109$exports.u8)("state"),
    (0, $ab8b5713b1ee9109$exports.u32)("isNativeOption"),
    (0, $3b2d1baa52a31e71$export$cd1442401e54cffa)("isNative"),
    (0, $3b2d1baa52a31e71$export$cd1442401e54cffa)("delegatedAmount"),
    (0, $ab8b5713b1ee9109$exports.u32)("closeAuthorityOption"),
    (0, $622167bc200b6540$export$86f13247979de5d7)("closeAuthority")
]);
const $4f8e5a3f35fa75b9$export$66ab21ef808e9dc6 = $4f8e5a3f35fa75b9$export$cab31ec27f6c5fa.span;
async function $4f8e5a3f35fa75b9$export$4f9234baf34abd0(connection, address, commitment, programId = (0, $071f33b9e1b22b13$export$79de3e3c2b1ca801)) {
    const info = await connection.getAccountInfo(address, commitment);
    return $4f8e5a3f35fa75b9$export$776350edf20ed1cc(address, info, programId);
}
async function $4f8e5a3f35fa75b9$export$7ecda0587e867ff2(connection, addresses, commitment, programId = (0, $071f33b9e1b22b13$export$79de3e3c2b1ca801)) {
    const infos = await connection.getMultipleAccountsInfo(addresses, commitment);
    return addresses.map((address, i)=>$4f8e5a3f35fa75b9$export$776350edf20ed1cc(address, infos[i], programId));
}
async function $4f8e5a3f35fa75b9$export$22f9b1d0cdd74bb0(connection, commitment) {
    return await $4f8e5a3f35fa75b9$export$e650be7f0aa49cb4(connection, [], commitment);
}
async function $4f8e5a3f35fa75b9$export$e650be7f0aa49cb4(connection, extensions, commitment) {
    const accountLen = (0, $a05dc5f3bc940692$export$37c8c863c6dd42a9)(extensions);
    return await connection.getMinimumBalanceForRentExemption(accountLen, commitment);
}
function $4f8e5a3f35fa75b9$export$776350edf20ed1cc(address, info, programId = (0, $071f33b9e1b22b13$export$79de3e3c2b1ca801)) {
    if (!info) throw new (0, $8afd026bce6c5170$export$a09a5e48de2f3404)();
    if (!info.owner.equals(programId)) throw new (0, $8afd026bce6c5170$export$abb470453474d51)();
    if (info.data.length < $4f8e5a3f35fa75b9$export$66ab21ef808e9dc6) throw new (0, $8afd026bce6c5170$export$250d31de4ddb7ca5)();
    const rawAccount = $4f8e5a3f35fa75b9$export$cab31ec27f6c5fa.decode(info.data.slice(0, $4f8e5a3f35fa75b9$export$66ab21ef808e9dc6));
    let tlvData = $4f8e5a3f35fa75b9$require$Buffer.alloc(0);
    if (info.data.length > $4f8e5a3f35fa75b9$export$66ab21ef808e9dc6) {
        if (info.data.length === (0, $ef806c48b215bede$export$c2abf71f91a1605b)) throw new (0, $8afd026bce6c5170$export$250d31de4ddb7ca5)();
        if (info.data[$4f8e5a3f35fa75b9$export$66ab21ef808e9dc6] != (0, $638cf1c35454a549$export$b8ca5fa4899cbfc7).Account) throw new (0, $8afd026bce6c5170$export$f4938317c78e324f)();
        tlvData = info.data.slice($4f8e5a3f35fa75b9$export$66ab21ef808e9dc6 + (0, $638cf1c35454a549$export$9d3ac77dcbf22b3f));
    }
    return {
        address: address,
        mint: rawAccount.mint,
        owner: rawAccount.owner,
        amount: rawAccount.amount,
        delegate: rawAccount.delegateOption ? rawAccount.delegate : null,
        delegatedAmount: rawAccount.delegatedAmount,
        isInitialized: rawAccount.state !== $4f8e5a3f35fa75b9$export$70504fba2ce56d52.Uninitialized,
        isFrozen: rawAccount.state === $4f8e5a3f35fa75b9$export$70504fba2ce56d52.Frozen,
        isNative: !!rawAccount.isNativeOption,
        rentExemptReserve: rawAccount.isNativeOption ? rawAccount.isNative : null,
        closeAuthority: rawAccount.closeAuthorityOption ? rawAccount.closeAuthority : null,
        tlvData: tlvData
    };
}








const $fbaa73ec5701f5cf$export$f70216558c70b1a0 = (0, $ab8b5713b1ee9109$exports.struct)([
    (0, $8f00f9d827a09685$export$87b259aa03e3d267)("lockCpi")
]);
const $fbaa73ec5701f5cf$export$2ad51e83460d1d03 = $fbaa73ec5701f5cf$export$f70216558c70b1a0.span;
function $fbaa73ec5701f5cf$export$1f414ebe518a07c3(account) {
    const extensionData = (0, $a05dc5f3bc940692$export$4fff3ed4eba4f4ee)((0, $a05dc5f3bc940692$export$4f037c6ec2da4eeb).CpiGuard, account.tlvData);
    if (extensionData !== null) return $fbaa73ec5701f5cf$export$f70216558c70b1a0.decode(extensionData);
    else return null;
}




const $535fbf55534b09a8$export$e8ecc3a3060edae5 = (0, $ab8b5713b1ee9109$exports.struct)([
    (0, $ab8b5713b1ee9109$exports.u8)("state")
]);
const $535fbf55534b09a8$export$2e3c876eadfda1ab = $535fbf55534b09a8$export$e8ecc3a3060edae5.span;
function $535fbf55534b09a8$export$d7b87bbf5a44c34c(mint) {
    const extensionData = (0, $a05dc5f3bc940692$export$4fff3ed4eba4f4ee)((0, $a05dc5f3bc940692$export$4f037c6ec2da4eeb).DefaultAccountState, mint.tlvData);
    if (extensionData !== null) return $535fbf55534b09a8$export$e8ecc3a3060edae5.decode(extensionData);
    else return null;
}



// ../build-scripts/env-shim.ts
var $ccf386126da6a5ec$var$__DEV__ = /* @__PURE__ */ (()=>false)();
// src/codes.ts
var $ccf386126da6a5ec$export$637a712014b81b9c = 1;
var $ccf386126da6a5ec$export$2b45309b0547a9c4 = 2;
var $ccf386126da6a5ec$export$7cf14cde1226b7cb = 3;
var $ccf386126da6a5ec$export$6ad19ea5e363a944 = 4;
var $ccf386126da6a5ec$export$c37fe345cc9b38e7 = 5;
var $ccf386126da6a5ec$export$cf7b28c4ea07497b = 6;
var $ccf386126da6a5ec$export$e8ff0c73a3d6800d = 7;
var $ccf386126da6a5ec$export$7dd7d17f1f93a166 = 8;
var $ccf386126da6a5ec$export$8b23617676679e2d = 9;
var $ccf386126da6a5ec$export$e09e3905081e44fe = -32700;
var $ccf386126da6a5ec$export$afa40fd3fc01204 = -32603;
var $ccf386126da6a5ec$export$2981978a530b1a7c = -32602;
var $ccf386126da6a5ec$export$5ec955cc8b7e8cf9 = -32601;
var $ccf386126da6a5ec$export$23cb4efd59427895 = -32600;
var $ccf386126da6a5ec$export$4f93db3d1b48599e = -32016;
var $ccf386126da6a5ec$export$f7685139153f9191 = -32015;
var $ccf386126da6a5ec$export$65235469ebe9845e = -32014;
var $ccf386126da6a5ec$export$bdeebdca616ef1f3 = -32013;
var $ccf386126da6a5ec$export$1b90c411626421b1 = -32012;
var $ccf386126da6a5ec$export$8e678bf9b4e5cb64 = -32011;
var $ccf386126da6a5ec$export$54dea2286c43ec1e = -32010;
var $ccf386126da6a5ec$export$e71fbee92648fc61 = -32009;
var $ccf386126da6a5ec$export$eb4f7515ff6aa19d = -32008;
var $ccf386126da6a5ec$export$d21075fd06730e = -32007;
var $ccf386126da6a5ec$export$d964b43bb02eacdf = -32006;
var $ccf386126da6a5ec$export$6bad0f4fb625ae6e = -32005;
var $ccf386126da6a5ec$export$bfbf8b75e865efa0 = -32004;
var $ccf386126da6a5ec$export$83dce8c0aef70463 = -32003;
var $ccf386126da6a5ec$export$426cc73f5ad00f38 = -32002;
var $ccf386126da6a5ec$export$6ae475e85fe02aad = -32001;
var $ccf386126da6a5ec$export$fe284a92110eab86 = 28e5;
var $ccf386126da6a5ec$export$8aae3518bf4ea38c = 2800001;
var $ccf386126da6a5ec$export$e31a90a3bf6aebaa = 2800002;
var $ccf386126da6a5ec$export$adaec66b544981e7 = 2800003;
var $ccf386126da6a5ec$export$523a769cce7318bf = 2800004;
var $ccf386126da6a5ec$export$68473acf744cabf5 = 2800005;
var $ccf386126da6a5ec$export$940d17d3b63dba7c = 2800006;
var $ccf386126da6a5ec$export$a1cf857da540ee2e = 2800007;
var $ccf386126da6a5ec$export$30501b98da9564bb = 2800008;
var $ccf386126da6a5ec$export$123d01dd469dc2ef = 2800009;
var $ccf386126da6a5ec$export$2a7684440f52314e = 2800010;
var $ccf386126da6a5ec$export$8f39956700e64760 = 323e4;
var $ccf386126da6a5ec$export$1239089c4564c858 = 32300001;
var $ccf386126da6a5ec$export$afc08ee11abbc257 = 3230002;
var $ccf386126da6a5ec$export$57836d13a84f54b0 = 3230003;
var $ccf386126da6a5ec$export$f080cd056a56cd54 = 3230004;
var $ccf386126da6a5ec$export$f2bbb3c14e29977e = 361e4;
var $ccf386126da6a5ec$export$f18173f573d8bb21 = 3610001;
var $ccf386126da6a5ec$export$7ad09900bd645a86 = 3610002;
var $ccf386126da6a5ec$export$69c08c51e1841f29 = 3610003;
var $ccf386126da6a5ec$export$325dad4e0a6bd514 = 3610004;
var $ccf386126da6a5ec$export$242c341c7c464bee = 3610005;
var $ccf386126da6a5ec$export$a73c064bb32a7c36 = 3610006;
var $ccf386126da6a5ec$export$bc1242deaa4d848d = 3704e3;
var $ccf386126da6a5ec$export$44352af09ecae39f = 3704001;
var $ccf386126da6a5ec$export$d2a0e93e506be463 = 3704002;
var $ccf386126da6a5ec$export$bbe4ed5687bc7f55 = 3704003;
var $ccf386126da6a5ec$export$552eeff1216c4a1e = 4128e3;
var $ccf386126da6a5ec$export$b260fc8c8d3cde52 = 4128001;
var $ccf386126da6a5ec$export$b81e507604713b9b = 4128002;
var $ccf386126da6a5ec$export$d308cb6df5c28ff6 = 4615e3;
var $ccf386126da6a5ec$export$ab2273c84ffc5d61 = 4615001;
var $ccf386126da6a5ec$export$23cc359156888c7f = 4615002;
var $ccf386126da6a5ec$export$a4193356408e9ff0 = 4615003;
var $ccf386126da6a5ec$export$f9ae264f831e3bcf = 4615004;
var $ccf386126da6a5ec$export$e170b44d99a3d17c = 4615005;
var $ccf386126da6a5ec$export$84ec8e94b54ae7d2 = 4615006;
var $ccf386126da6a5ec$export$4063fe8d5aed84a5 = 4615007;
var $ccf386126da6a5ec$export$ecdd3388f6a493b1 = 4615008;
var $ccf386126da6a5ec$export$df0a6d6cbb0d96a1 = 4615009;
var $ccf386126da6a5ec$export$e45bdcd5a97f01d1 = 4615010;
var $ccf386126da6a5ec$export$c2bfe7e903a0febb = 4615011;
var $ccf386126da6a5ec$export$fa2d8ac69bd6117e = 4615012;
var $ccf386126da6a5ec$export$2b7e7e6bd3d5b8c4 = 4615013;
var $ccf386126da6a5ec$export$72e64aed285de589 = 4615014;
var $ccf386126da6a5ec$export$95d7c72146ee65c6 = 4615015;
var $ccf386126da6a5ec$export$aa03f185732dc00b = 4615016;
var $ccf386126da6a5ec$export$c390f45549d7336b = 4615017;
var $ccf386126da6a5ec$export$2ea2f2f9a9e26449 = 4615018;
var $ccf386126da6a5ec$export$c9ece88629d0d2d8 = 4615019;
var $ccf386126da6a5ec$export$2f331454431511bf = 4615020;
var $ccf386126da6a5ec$export$3c4b9377ed4116a0 = 4615021;
var $ccf386126da6a5ec$export$211b990ef3bd19ce = 4615022;
var $ccf386126da6a5ec$export$ef486e0fcc8262b = 4615023;
var $ccf386126da6a5ec$export$afcb9eeb4bf056b5 = 4615024;
var $ccf386126da6a5ec$export$4db39a3a67e51db2 = 4615025;
var $ccf386126da6a5ec$export$5abe2d1d040bf6cf = 4615026;
var $ccf386126da6a5ec$export$35a7a209cf9aaee8 = 4615027;
var $ccf386126da6a5ec$export$203fce7ce63eb278 = 4615028;
var $ccf386126da6a5ec$export$c65d87b69a4b86e5 = 4615029;
var $ccf386126da6a5ec$export$d13686e596713674 = 4615030;
var $ccf386126da6a5ec$export$a070310f29fe959b = 4615031;
var $ccf386126da6a5ec$export$8eb8ce58a8afa4d8 = 4615032;
var $ccf386126da6a5ec$export$1224afa7bd705d3d = 4615033;
var $ccf386126da6a5ec$export$547fdb4fff65c547 = 4615034;
var $ccf386126da6a5ec$export$cbeea52e947eb081 = 4615035;
var $ccf386126da6a5ec$export$fd7a98f0746b6c8a = 4615036;
var $ccf386126da6a5ec$export$8e6d399c8fb88eaa = 4615037;
var $ccf386126da6a5ec$export$2c001ce75e66180d = 4615038;
var $ccf386126da6a5ec$export$ec7d592dad68aa12 = 4615039;
var $ccf386126da6a5ec$export$8815da3ec592d05a = 4615040;
var $ccf386126da6a5ec$export$b1b9bf899899a525 = 4615041;
var $ccf386126da6a5ec$export$67715a67add5645f = 4615042;
var $ccf386126da6a5ec$export$e343a153899b82e9 = 4615043;
var $ccf386126da6a5ec$export$2199fb95c7d85b85 = 4615044;
var $ccf386126da6a5ec$export$57c1675a0c20931f = 4615045;
var $ccf386126da6a5ec$export$9e62f446da191370 = 4615046;
var $ccf386126da6a5ec$export$b5ccaf975fe486a0 = 4615047;
var $ccf386126da6a5ec$export$4d39d4c2f04b41a8 = 4615048;
var $ccf386126da6a5ec$export$1997554dc67e9c4e = 4615049;
var $ccf386126da6a5ec$export$8a65209e9cece2cd = 4615050;
var $ccf386126da6a5ec$export$6b675123aa59300c = 4615051;
var $ccf386126da6a5ec$export$70b4e2dd1496c5a3 = 4615052;
var $ccf386126da6a5ec$export$43d5111034db211a = 4615053;
var $ccf386126da6a5ec$export$8aebe3e76f515046 = 4615054;
var $ccf386126da6a5ec$export$ee84b29a9985e516 = 5508e3;
var $ccf386126da6a5ec$export$9998b265c986beaa = 5508001;
var $ccf386126da6a5ec$export$dd792e9d67cd031b = 5508002;
var $ccf386126da6a5ec$export$14d32fbdad2233cd = 5508003;
var $ccf386126da6a5ec$export$8c6fc1cfcec8440c = 5508004;
var $ccf386126da6a5ec$export$dcec7171cff295d1 = 5508005;
var $ccf386126da6a5ec$export$200acbfc722e322b = 5508006;
var $ccf386126da6a5ec$export$4c96d9a95880ae4b = 5508007;
var $ccf386126da6a5ec$export$bba76b21ada319a5 = 5508008;
var $ccf386126da6a5ec$export$3cb3b480d2bfdacc = 5508009;
var $ccf386126da6a5ec$export$1f5fbaa83776feec = 5508010;
var $ccf386126da6a5ec$export$694fd435994bcca = 5663e3;
var $ccf386126da6a5ec$export$707576ec00ca24d6 = 5663001;
var $ccf386126da6a5ec$export$e33d07a7526bded0 = 5663002;
var $ccf386126da6a5ec$export$a20747f749dd4515 = 5663003;
var $ccf386126da6a5ec$export$3963d9bca4091810 = 5663004;
var $ccf386126da6a5ec$export$b34a16b8adbffdc1 = 5663005;
var $ccf386126da6a5ec$export$3764bbcfb0679211 = 5663006;
var $ccf386126da6a5ec$export$ed2bdee7953e467f = 5663007;
var $ccf386126da6a5ec$export$11bea4440904349c = 5663008;
var $ccf386126da6a5ec$export$6d61b980429516bd = 5663009;
var $ccf386126da6a5ec$export$819b1b0603d2a966 = 5663010;
var $ccf386126da6a5ec$export$592862d1b11e32ac = 5663011;
var $ccf386126da6a5ec$export$242af5597d94abaf = 5663012;
var $ccf386126da6a5ec$export$802b3ebe5297e360 = 5663013;
var $ccf386126da6a5ec$export$bed6f92dafea0623 = 5663014;
var $ccf386126da6a5ec$export$8c82dde5b12c9789 = 705e4;
var $ccf386126da6a5ec$export$a746609ecc2f6acf = 7050001;
var $ccf386126da6a5ec$export$c4d8217d3eb3eaf8 = 7050002;
var $ccf386126da6a5ec$export$5d0f06cd8bc8e3af = 7050003;
var $ccf386126da6a5ec$export$83c8fe2717d1b271 = 7050004;
var $ccf386126da6a5ec$export$39ead28cf48a604c = 7050005;
var $ccf386126da6a5ec$export$624f65633216eb57 = 7050006;
var $ccf386126da6a5ec$export$2bbd9403cb117ea7 = 7050007;
var $ccf386126da6a5ec$export$e108dd5343c4c11 = 7050008;
var $ccf386126da6a5ec$export$a504ed6cab09ce4a = 7050009;
var $ccf386126da6a5ec$export$8c1ae05eccc11ef9 = 7050010;
var $ccf386126da6a5ec$export$47df44101c6f04b0 = 7050011;
var $ccf386126da6a5ec$export$89ae0c424691fbcb = 7050012;
var $ccf386126da6a5ec$export$bea5f92951bc42e7 = 7050013;
var $ccf386126da6a5ec$export$91a668e132084ecf = 7050014;
var $ccf386126da6a5ec$export$211b9b84186690f0 = 7050015;
var $ccf386126da6a5ec$export$291ea8d5a7496fde = 7050016;
var $ccf386126da6a5ec$export$5f027a86397cba92 = 7050017;
var $ccf386126da6a5ec$export$58bf90c73afbc02e = 7050018;
var $ccf386126da6a5ec$export$b8b2610c9a910763 = 7050019;
var $ccf386126da6a5ec$export$fb693aebffa32676 = 7050020;
var $ccf386126da6a5ec$export$572954173bc64b66 = 7050021;
var $ccf386126da6a5ec$export$fa9a13f1b40ee2fb = 7050022;
var $ccf386126da6a5ec$export$95c94f6ea500f1ab = 7050023;
var $ccf386126da6a5ec$export$11d69fb6993b2cf5 = 7050024;
var $ccf386126da6a5ec$export$bd54a9a85614b3a7 = 7050025;
var $ccf386126da6a5ec$export$df4ef1824fd194a3 = 7050026;
var $ccf386126da6a5ec$export$2725d50dd432fb3a = 7050027;
var $ccf386126da6a5ec$export$41f13726b04d8d05 = 7050028;
var $ccf386126da6a5ec$export$7b4a7eebff68ca7b = 7050029;
var $ccf386126da6a5ec$export$e3a4007020a2e8f5 = 7050030;
var $ccf386126da6a5ec$export$2ecc275dffbc087c = 7050031;
var $ccf386126da6a5ec$export$e3289c5954208202 = 7050032;
var $ccf386126da6a5ec$export$3569c6c71e349538 = 7050033;
var $ccf386126da6a5ec$export$4f413e02d5e82221 = 7050034;
var $ccf386126da6a5ec$export$1cd0de5dfcdeb99d = 7050035;
var $ccf386126da6a5ec$export$87e01307d368f511 = 7050036;
var $ccf386126da6a5ec$export$9c9326ce1e3df40c = 8078e3;
var $ccf386126da6a5ec$export$18fbf24f19efc69b = 8078001;
var $ccf386126da6a5ec$export$93561b31b951410d = 8078002;
var $ccf386126da6a5ec$export$3417da5bc6bcb45 = 8078003;
var $ccf386126da6a5ec$export$c4c73ab3c0833591 = 8078004;
var $ccf386126da6a5ec$export$824d79ab1779d517 = 8078005;
var $ccf386126da6a5ec$export$c464f3b291f1f3d0 = 8078006;
var $ccf386126da6a5ec$export$c04710d31ef4d278 = 8078007;
var $ccf386126da6a5ec$export$1fa107ead8489cf2 = 8078008;
var $ccf386126da6a5ec$export$46bcb1e361ec5ed6 = 8078009;
var $ccf386126da6a5ec$export$ae8f95254b95c938 = 8078010;
var $ccf386126da6a5ec$export$8653c145864f47f4 = 8078011;
var $ccf386126da6a5ec$export$89b582b06852d433 = 8078012;
var $ccf386126da6a5ec$export$4c1fcb4bd20b2951 = 8078013;
var $ccf386126da6a5ec$export$a617dff403944ec6 = 8078014;
var $ccf386126da6a5ec$export$ef742b7036fb9005 = 81e5;
var $ccf386126da6a5ec$export$2a2f0f75708d1697 = 8100001;
var $ccf386126da6a5ec$export$7f6822f75edb8f41 = 8100002;
var $ccf386126da6a5ec$export$c2b279d002edb7ec = 819e4;
var $ccf386126da6a5ec$export$e1a3658b043aad8e = 8190001;
var $ccf386126da6a5ec$export$70877b3524829eb0 = 8190002;
var $ccf386126da6a5ec$export$d017b741c4452673 = 8190003;
var $ccf386126da6a5ec$export$b1b380d4068eeb8f = 8190004;
var $ccf386126da6a5ec$export$ecb673640304655c = 99e5;
var $ccf386126da6a5ec$export$bd3f60d945c38448 = 9900001;
var $ccf386126da6a5ec$export$b57ffff6ec11f63 = 9900002;
var $ccf386126da6a5ec$export$6fe73388375373f = 9900003;
// src/messages.ts
var $ccf386126da6a5ec$var$SolanaErrorMessages = {
    [$ccf386126da6a5ec$export$8f39956700e64760]: "Account not found at address: $address",
    [$ccf386126da6a5ec$export$f080cd056a56cd54]: "Not all accounts were decoded. Encoded accounts found at addresses: $addresses.",
    [$ccf386126da6a5ec$export$57836d13a84f54b0]: "Expected decoded account at address: $address",
    [$ccf386126da6a5ec$export$afc08ee11abbc257]: "Failed to decode account data at address: $address",
    [$ccf386126da6a5ec$export$1239089c4564c858]: "Accounts not found at addresses: $addresses",
    [$ccf386126da6a5ec$export$123d01dd469dc2ef]: "Unable to find a viable program address bump seed.",
    [$ccf386126da6a5ec$export$e31a90a3bf6aebaa]: "$putativeAddress is not a base58-encoded address.",
    [$ccf386126da6a5ec$export$fe284a92110eab86]: "Expected base58 encoded address to decode to a byte array of length 32. Actual length: $actualLength.",
    [$ccf386126da6a5ec$export$adaec66b544981e7]: "The `CryptoKey` must be an `Ed25519` public key.",
    [$ccf386126da6a5ec$export$30501b98da9564bb]: "Invalid seeds; point must fall off the Ed25519 curve.",
    [$ccf386126da6a5ec$export$523a769cce7318bf]: "Expected given program derived address to have the following format: [Address, ProgramDerivedAddressBump].",
    [$ccf386126da6a5ec$export$940d17d3b63dba7c]: "A maximum of $maxSeeds seeds, including the bump seed, may be supplied when creating an address. Received: $actual.",
    [$ccf386126da6a5ec$export$a1cf857da540ee2e]: "The seed at index $index with length $actual exceeds the maximum length of $maxSeedLength bytes.",
    [$ccf386126da6a5ec$export$68473acf744cabf5]: "Expected program derived address bump to be in the range [0, 255], got: $bump.",
    [$ccf386126da6a5ec$export$2a7684440f52314e]: "Program address cannot end with PDA marker.",
    [$ccf386126da6a5ec$export$8aae3518bf4ea38c]: "Expected base58-encoded address string of length in the range [32, 44]. Actual length: $actualLength.",
    [$ccf386126da6a5ec$export$6ad19ea5e363a944]: "Expected base58-encoded blockash string of length in the range [32, 44]. Actual length: $actualLength.",
    [$ccf386126da6a5ec$export$637a712014b81b9c]: "The network has progressed past the last block for which this transaction could have been committed.",
    [$ccf386126da6a5ec$export$9c9326ce1e3df40c]: "Codec [$codecDescription] cannot decode empty byte arrays.",
    [$ccf386126da6a5ec$export$824d79ab1779d517]: "Encoder and decoder must have the same fixed size, got [$encoderFixedSize] and [$decoderFixedSize].",
    [$ccf386126da6a5ec$export$c464f3b291f1f3d0]: "Encoder and decoder must have the same max size, got [$encoderMaxSize] and [$decoderMaxSize].",
    [$ccf386126da6a5ec$export$c4c73ab3c0833591]: "Encoder and decoder must either both be fixed-size or variable-size.",
    [$ccf386126da6a5ec$export$1fa107ead8489cf2]: "Enum discriminator out of range. Expected a number between $minRange and $maxRange, got $discriminator.",
    [$ccf386126da6a5ec$export$93561b31b951410d]: "Expected a fixed-size codec, got a variable-size one.",
    [$ccf386126da6a5ec$export$4c1fcb4bd20b2951]: "Codec [$codecDescription] expected a positive byte length, got $bytesLength.",
    [$ccf386126da6a5ec$export$3417da5bc6bcb45]: "Expected a variable-size codec, got a fixed-size one.",
    [$ccf386126da6a5ec$export$18fbf24f19efc69b]: "Codec [$codecDescription] expected $expected bytes, got $bytesLength.",
    [$ccf386126da6a5ec$export$46bcb1e361ec5ed6]: "Invalid data enum variant. Expected one of [$variants], got $value.",
    [$ccf386126da6a5ec$export$c04710d31ef4d278]: "Expected [$codecDescription] to have $expected items, got $actual.",
    [$ccf386126da6a5ec$export$ae8f95254b95c938]: "Invalid scalar enum variant. Expected one of [$variants] or a number between $minRange and $maxRange, got $value.",
    [$ccf386126da6a5ec$export$89b582b06852d433]: "Invalid value $value for base $base with alphabet $alphabet.",
    [$ccf386126da6a5ec$export$8653c145864f47f4]: "Codec [$codecDescription] expected number to be in the range [$min, $max], got $value.",
    [$ccf386126da6a5ec$export$a617dff403944ec6]: "Codec [$codecDescription] expected offset to be in the range [0, $bytesLength], got $offset.",
    [$ccf386126da6a5ec$export$df0a6d6cbb0d96a1]: "instruction requires an uninitialized account",
    [$ccf386126da6a5ec$export$ef486e0fcc8262b]: "instruction tries to borrow reference for an account which is already borrowed",
    [$ccf386126da6a5ec$export$afcb9eeb4bf056b5]: "instruction left account with an outstanding borrowed reference",
    [$ccf386126da6a5ec$export$3c4b9377ed4116a0]: "program other than the account's owner changed the size of the account data",
    [$ccf386126da6a5ec$export$e170b44d99a3d17c]: "account data too small for instruction",
    [$ccf386126da6a5ec$export$211b990ef3bd19ce]: "instruction expected an executable account",
    [$ccf386126da6a5ec$export$9e62f446da191370]: "An account does not have enough lamports to be rent-exempt",
    [$ccf386126da6a5ec$export$4d39d4c2f04b41a8]: "Program arithmetic overflowed",
    [$ccf386126da6a5ec$export$57c1675a0c20931f]: "Failed to serialize or deserialize account data: $encodedData",
    [$ccf386126da6a5ec$export$8aebe3e76f515046]: "Builtin programs must consume compute units",
    [$ccf386126da6a5ec$export$8eb8ce58a8afa4d8]: "Cross-program invocation call depth too deep",
    [$ccf386126da6a5ec$export$2c001ce75e66180d]: "Computational budget exceeded",
    [$ccf386126da6a5ec$export$5abe2d1d040bf6cf]: "custom program error: #$code",
    [$ccf386126da6a5ec$export$c390f45549d7336b]: "instruction contains duplicate accounts",
    [$ccf386126da6a5ec$export$4db39a3a67e51db2]: "instruction modifications of multiply-passed account differ",
    [$ccf386126da6a5ec$export$d13686e596713674]: "executable accounts must be rent exempt",
    [$ccf386126da6a5ec$export$203fce7ce63eb278]: "instruction changed executable accounts data",
    [$ccf386126da6a5ec$export$c65d87b69a4b86e5]: "instruction changed the balance of an executable account",
    [$ccf386126da6a5ec$export$2ea2f2f9a9e26449]: "instruction changed executable bit of an account",
    [$ccf386126da6a5ec$export$72e64aed285de589]: "instruction modified data of an account it does not own",
    [$ccf386126da6a5ec$export$2b7e7e6bd3d5b8c4]: "instruction spent from the balance of an account it does not own",
    [$ccf386126da6a5ec$export$ab2273c84ffc5d61]: "generic instruction error",
    [$ccf386126da6a5ec$export$8a65209e9cece2cd]: "Provided owner is not allowed",
    [$ccf386126da6a5ec$export$e343a153899b82e9]: "Account is immutable",
    [$ccf386126da6a5ec$export$2199fb95c7d85b85]: "Incorrect authority provided",
    [$ccf386126da6a5ec$export$4063fe8d5aed84a5]: "incorrect program id for instruction",
    [$ccf386126da6a5ec$export$84ec8e94b54ae7d2]: "insufficient funds for instruction",
    [$ccf386126da6a5ec$export$f9ae264f831e3bcf]: "invalid account data for instruction",
    [$ccf386126da6a5ec$export$b5ccaf975fe486a0]: "Invalid account owner",
    [$ccf386126da6a5ec$export$23cc359156888c7f]: "invalid program argument",
    [$ccf386126da6a5ec$export$35a7a209cf9aaee8]: "program returned invalid error code",
    [$ccf386126da6a5ec$export$a4193356408e9ff0]: "invalid instruction data",
    [$ccf386126da6a5ec$export$8e6d399c8fb88eaa]: "Failed to reallocate account data",
    [$ccf386126da6a5ec$export$fd7a98f0746b6c8a]: "Provided seeds do not result in a valid address",
    [$ccf386126da6a5ec$export$6b675123aa59300c]: "Accounts data allocations exceeded the maximum allowed per transaction",
    [$ccf386126da6a5ec$export$70b4e2dd1496c5a3]: "Max accounts exceeded",
    [$ccf386126da6a5ec$export$43d5111034db211a]: "Max instruction trace length exceeded",
    [$ccf386126da6a5ec$export$cbeea52e947eb081]: "Length of the seed is too long for address generation",
    [$ccf386126da6a5ec$export$1224afa7bd705d3d]: "An account required by the instruction is missing",
    [$ccf386126da6a5ec$export$ecdd3388f6a493b1]: "missing required signature for instruction",
    [$ccf386126da6a5ec$export$fa2d8ac69bd6117e]: "instruction illegally modified the program id of an account",
    [$ccf386126da6a5ec$export$2f331454431511bf]: "insufficient account keys for instruction",
    [$ccf386126da6a5ec$export$ec7d592dad68aa12]: "Cross-program invocation with unauthorized signer or writable account",
    [$ccf386126da6a5ec$export$8815da3ec592d05a]: "Failed to create program execution environment",
    [$ccf386126da6a5ec$export$67715a67add5645f]: "Program failed to compile",
    [$ccf386126da6a5ec$export$b1b9bf899899a525]: "Program failed to complete",
    [$ccf386126da6a5ec$export$aa03f185732dc00b]: "instruction modified data of a read-only account",
    [$ccf386126da6a5ec$export$95d7c72146ee65c6]: "instruction changed the balance of a read-only account",
    [$ccf386126da6a5ec$export$547fdb4fff65c547]: "Cross-program invocation reentrancy not allowed for this instruction",
    [$ccf386126da6a5ec$export$c9ece88629d0d2d8]: "instruction modified rent epoch of an account",
    [$ccf386126da6a5ec$export$c2bfe7e903a0febb]: "sum of account balances before and after instruction do not match",
    [$ccf386126da6a5ec$export$e45bdcd5a97f01d1]: "instruction requires an initialized account",
    [$ccf386126da6a5ec$export$d308cb6df5c28ff6]: "",
    [$ccf386126da6a5ec$export$a070310f29fe959b]: "Unsupported program id",
    [$ccf386126da6a5ec$export$1997554dc67e9c4e]: "Unsupported sysvar",
    [$ccf386126da6a5ec$export$552eeff1216c4a1e]: "The instruction does not have any accounts.",
    [$ccf386126da6a5ec$export$b260fc8c8d3cde52]: "The instruction does not have any data.",
    [$ccf386126da6a5ec$export$b81e507604713b9b]: "Expected instruction to have progress address $expectedProgramAddress, got $actualProgramAddress.",
    [$ccf386126da6a5ec$export$c37fe345cc9b38e7]: "Expected base58 encoded blockhash to decode to a byte array of length 32. Actual length: $actualLength.",
    [$ccf386126da6a5ec$export$2b45309b0547a9c4]: "The nonce `$expectedNonceValue` is no longer valid. It has advanced to `$actualNonceValue`",
    [$ccf386126da6a5ec$export$b57ffff6ec11f63]: "Invariant violation: Found no abortable iterable cache entry for key `$cacheKey`. It should be impossible to hit this error; please file an issue at https://sola.na/web3invariant",
    [$ccf386126da6a5ec$export$6fe73388375373f]: "Invariant violation: Switch statement non-exhaustive. Received unexpected value `$unexpectedValue`. It should be impossible to hit this error; please file an issue at https://sola.na/web3invariant",
    [$ccf386126da6a5ec$export$bd3f60d945c38448]: "Invariant violation: WebSocket message iterator state is corrupt; iterated without first resolving existing message promise. It should be impossible to hit this error; please file an issue at https://sola.na/web3invariant",
    [$ccf386126da6a5ec$export$ecb673640304655c]: "Invariant violation: WebSocket message iterator is missing state storage. It should be impossible to hit this error; please file an issue at https://sola.na/web3invariant",
    [$ccf386126da6a5ec$export$afa40fd3fc01204]: "JSON-RPC error: Internal JSON-RPC error ($__serverMessage)",
    [$ccf386126da6a5ec$export$2981978a530b1a7c]: "JSON-RPC error: Invalid method parameter(s) ($__serverMessage)",
    [$ccf386126da6a5ec$export$23cb4efd59427895]: "JSON-RPC error: The JSON sent is not a valid `Request` object ($__serverMessage)",
    [$ccf386126da6a5ec$export$5ec955cc8b7e8cf9]: "JSON-RPC error: The method does not exist / is not available ($__serverMessage)",
    [$ccf386126da6a5ec$export$e09e3905081e44fe]: "JSON-RPC error: An error occurred on the server while parsing the JSON text ($__serverMessage)",
    [$ccf386126da6a5ec$export$1b90c411626421b1]: "$__serverMessage",
    [$ccf386126da6a5ec$export$6ae475e85fe02aad]: "$__serverMessage",
    [$ccf386126da6a5ec$export$bfbf8b75e865efa0]: "$__serverMessage",
    [$ccf386126da6a5ec$export$65235469ebe9845e]: "$__serverMessage",
    [$ccf386126da6a5ec$export$54dea2286c43ec1e]: "$__serverMessage",
    [$ccf386126da6a5ec$export$e71fbee92648fc61]: "$__serverMessage",
    [$ccf386126da6a5ec$export$4f93db3d1b48599e]: "Minimum context slot has not been reached",
    [$ccf386126da6a5ec$export$6bad0f4fb625ae6e]: "Node is unhealthy; behind by $numSlotsBehind slots",
    [$ccf386126da6a5ec$export$eb4f7515ff6aa19d]: "No snapshot",
    [$ccf386126da6a5ec$export$426cc73f5ad00f38]: "Transaction simulation failed",
    [$ccf386126da6a5ec$export$d21075fd06730e]: "$__serverMessage",
    [$ccf386126da6a5ec$export$8e678bf9b4e5cb64]: "Transaction history is not available from this node",
    [$ccf386126da6a5ec$export$d964b43bb02eacdf]: "$__serverMessage",
    [$ccf386126da6a5ec$export$bdeebdca616ef1f3]: "Transaction signature length mismatch",
    [$ccf386126da6a5ec$export$83dce8c0aef70463]: "Transaction signature verification failure",
    [$ccf386126da6a5ec$export$f7685139153f9191]: "$__serverMessage",
    [$ccf386126da6a5ec$export$bc1242deaa4d848d]: "Key pair bytes must be of length 64, got $byteLength.",
    [$ccf386126da6a5ec$export$44352af09ecae39f]: "Expected private key bytes with length 32. Actual length: $actualLength.",
    [$ccf386126da6a5ec$export$d2a0e93e506be463]: "Expected base58-encoded signature to decode to a byte array of length 64. Actual length: $actualLength.",
    [$ccf386126da6a5ec$export$bbe4ed5687bc7f55]: "Expected base58-encoded signature string of length in the range [64, 88]. Actual length: $actualLength.",
    [$ccf386126da6a5ec$export$cf7b28c4ea07497b]: "Lamports value must be in the range [0, 2e64-1]",
    [$ccf386126da6a5ec$export$e8ff0c73a3d6800d]: "`$value` cannot be parsed as a `BigInt`",
    [$ccf386126da6a5ec$export$7dd7d17f1f93a166]: "`$value` cannot be parsed as a `Number`",
    [$ccf386126da6a5ec$export$7cf14cde1226b7cb]: "No nonce account could be found at address `$nonceAccountAddress`",
    [$ccf386126da6a5ec$export$c2b279d002edb7ec]: "Either the notification name must end in 'Notifications' or the API must supply a subscription creator function for the notification '$notificationName' to map between the notification name and the subscribe/unsubscribe method names.",
    [$ccf386126da6a5ec$export$e1a3658b043aad8e]: "Failed to obtain a subscription id from the server",
    [$ccf386126da6a5ec$export$70877b3524829eb0]: "WebSocket was closed before payload could be added to the send buffer",
    [$ccf386126da6a5ec$export$d017b741c4452673]: "WebSocket connection closed",
    [$ccf386126da6a5ec$export$b1b380d4068eeb8f]: "WebSocket failed to connect",
    [$ccf386126da6a5ec$export$ef742b7036fb9005]: "The $argumentLabel argument to the `$methodName` RPC method$optionalPathLabel was `$value`. This number is unsafe for use with the Solana JSON-RPC because it exceeds `Number.MAX_SAFE_INTEGER`.",
    [$ccf386126da6a5ec$export$7f6822f75edb8f41]: "HTTP error ($statusCode): $message",
    [$ccf386126da6a5ec$export$2a2f0f75708d1697]: "HTTP header(s) forbidden: $headers. Learn more at https://developer.mozilla.org/en-US/docs/Glossary/Forbidden_header_name.",
    [$ccf386126da6a5ec$export$ee84b29a9985e516]: "Multiple distinct signers were identified for address `$address`. Please ensure that you are using the same signer instance for each address.",
    [$ccf386126da6a5ec$export$9998b265c986beaa]: "The provided value does not implement the `KeyPairSigner` interface",
    [$ccf386126da6a5ec$export$14d32fbdad2233cd]: "The provided value does not implement the `MessageModifyingSigner` interface",
    [$ccf386126da6a5ec$export$8c6fc1cfcec8440c]: "The provided value does not implement the `MessagePartialSigner` interface",
    [$ccf386126da6a5ec$export$dd792e9d67cd031b]: "The provided value does not implement any of the `MessageSigner` interfaces",
    [$ccf386126da6a5ec$export$200acbfc722e322b]: "The provided value does not implement the `TransactionModifyingSigner` interface",
    [$ccf386126da6a5ec$export$4c96d9a95880ae4b]: "The provided value does not implement the `TransactionPartialSigner` interface",
    [$ccf386126da6a5ec$export$bba76b21ada319a5]: "The provided value does not implement the `TransactionSendingSigner` interface",
    [$ccf386126da6a5ec$export$dcec7171cff295d1]: "The provided value does not implement any of the `TransactionSigner` interfaces",
    [$ccf386126da6a5ec$export$3cb3b480d2bfdacc]: "More than one `TransactionSendingSigner` was identified.",
    [$ccf386126da6a5ec$export$1f5fbaa83776feec]: "No `TransactionSendingSigner` was identified. Please provide a valid `ITransactionWithSingleSendingSigner` transaction.",
    [$ccf386126da6a5ec$export$f18173f573d8bb21]: "No digest implementation could be found.",
    [$ccf386126da6a5ec$export$f2bbb3c14e29977e]: "Cryptographic operations are only allowed in secure browser contexts. Read more here: https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts.",
    [$ccf386126da6a5ec$export$7ad09900bd645a86]: "This runtime does not support the generation of Ed25519 key pairs.\n\nInstall and import `@solana/webcrypto-ed25519-polyfill` before generating keys in environments that do not support Ed25519.\n\nFor a list of runtimes that currently support Ed25519 operations, visit https://github.com/WICG/webcrypto-secure-curves/issues/20.",
    [$ccf386126da6a5ec$export$69c08c51e1841f29]: "No signature verification implementation could be found.",
    [$ccf386126da6a5ec$export$325dad4e0a6bd514]: "No key generation implementation could be found.",
    [$ccf386126da6a5ec$export$242c341c7c464bee]: "No signing implementation could be found.",
    [$ccf386126da6a5ec$export$a73c064bb32a7c36]: "No key export implementation could be found.",
    [$ccf386126da6a5ec$export$8b23617676679e2d]: "Timestamp value must be in the range [-8.64e15, 8.64e15]. `$value` given",
    [$ccf386126da6a5ec$export$291ea8d5a7496fde]: "Transaction processing left an account with an outstanding borrowed reference",
    [$ccf386126da6a5ec$export$a746609ecc2f6acf]: "Account in use",
    [$ccf386126da6a5ec$export$c4d8217d3eb3eaf8]: "Account loaded twice",
    [$ccf386126da6a5ec$export$5d0f06cd8bc8e3af]: "Attempt to debit an account but found no record of a prior credit.",
    [$ccf386126da6a5ec$export$95c94f6ea500f1ab]: "Transaction loads an address table account that doesn't exist",
    [$ccf386126da6a5ec$export$2bbd9403cb117ea7]: "This transaction has already been processed",
    [$ccf386126da6a5ec$export$e108dd5343c4c11]: "Blockhash not found",
    [$ccf386126da6a5ec$export$a504ed6cab09ce4a]: "Loader call chain is too deep",
    [$ccf386126da6a5ec$export$211b9b84186690f0]: "Transactions are currently disabled due to cluster maintenance",
    [$ccf386126da6a5ec$export$e3a4007020a2e8f5]: "Transaction contains a duplicate instruction ($index) that is not allowed",
    [$ccf386126da6a5ec$export$39ead28cf48a604c]: "Insufficient funds for fee",
    [$ccf386126da6a5ec$export$2ecc275dffbc087c]: "Transaction results in an account ($accountIndex) with insufficient funds for rent",
    [$ccf386126da6a5ec$export$624f65633216eb57]: "This account may not be used to pay transaction fees",
    [$ccf386126da6a5ec$export$47df44101c6f04b0]: "Transaction contains an invalid account reference",
    [$ccf386126da6a5ec$export$bd54a9a85614b3a7]: "Transaction loads an address table account with invalid data",
    [$ccf386126da6a5ec$export$df4ef1824fd194a3]: "Transaction address table lookup uses an invalid index",
    [$ccf386126da6a5ec$export$11d69fb6993b2cf5]: "Transaction loads an address table account with an invalid owner",
    [$ccf386126da6a5ec$export$3569c6c71e349538]: "LoadedAccountsDataSizeLimit set for transaction must be greater than 0.",
    [$ccf386126da6a5ec$export$bea5f92951bc42e7]: "This program may not be used for executing instructions",
    [$ccf386126da6a5ec$export$2725d50dd432fb3a]: "Transaction leaves an account with a lower balance than rent-exempt minimum",
    [$ccf386126da6a5ec$export$b8b2610c9a910763]: "Transaction loads a writable account that cannot be written",
    [$ccf386126da6a5ec$export$e3289c5954208202]: "Transaction exceeded max loaded accounts data size cap",
    [$ccf386126da6a5ec$export$8c1ae05eccc11ef9]: "Transaction requires a fee but has no signature present",
    [$ccf386126da6a5ec$export$83c8fe2717d1b271]: "Attempt to load a program that does not exist",
    [$ccf386126da6a5ec$export$1cd0de5dfcdeb99d]: "Execution of the program referenced by account at index $accountIndex is temporarily restricted.",
    [$ccf386126da6a5ec$export$4f413e02d5e82221]: "ResanitizationNeeded",
    [$ccf386126da6a5ec$export$91a668e132084ecf]: "Transaction failed to sanitize accounts offsets correctly",
    [$ccf386126da6a5ec$export$89ae0c424691fbcb]: "Transaction did not pass signature verification",
    [$ccf386126da6a5ec$export$fa9a13f1b40ee2fb]: "Transaction locked too many accounts",
    [$ccf386126da6a5ec$export$87e01307d368f511]: "Sum of account balances before and after transaction do not match",
    [$ccf386126da6a5ec$export$8c82dde5b12c9789]: "The transaction failed with the error `$errorName`",
    [$ccf386126da6a5ec$export$58bf90c73afbc02e]: "Transaction version is unsupported",
    [$ccf386126da6a5ec$export$572954173bc64b66]: "Transaction would exceed account data limit within the block",
    [$ccf386126da6a5ec$export$7b4a7eebff68ca7b]: "Transaction would exceed total account data limit",
    [$ccf386126da6a5ec$export$fb693aebffa32676]: "Transaction would exceed max account limit within the block",
    [$ccf386126da6a5ec$export$5f027a86397cba92]: "Transaction would exceed max Block Cost Limit",
    [$ccf386126da6a5ec$export$41f13726b04d8d05]: "Transaction would exceed max Vote Cost Limit",
    [$ccf386126da6a5ec$export$819b1b0603d2a966]: "Transaction is missing an address at index: $index.",
    [$ccf386126da6a5ec$export$e33d07a7526bded0]: "Transaction does not have a blockhash lifetime",
    [$ccf386126da6a5ec$export$a20747f749dd4515]: "Transaction is not a durable nonce transaction",
    [$ccf386126da6a5ec$export$b34a16b8adbffdc1]: "Contents of these address lookup tables unknown: $lookupTableAddresses",
    [$ccf386126da6a5ec$export$3764bbcfb0679211]: "Lookup of address at index $highestRequestedIndex failed for lookup table `$lookupTableAddress`. Highest known index is $highestKnownIndex. The lookup table may have been extended since its contents were retrieved",
    [$ccf386126da6a5ec$export$11bea4440904349c]: "No fee payer set in CompiledTransaction",
    [$ccf386126da6a5ec$export$ed2bdee7953e467f]: "Could not find program address at index $index",
    [$ccf386126da6a5ec$export$592862d1b11e32ac]: "Transaction is missing a fee payer.",
    [$ccf386126da6a5ec$export$242af5597d94abaf]: "Could not determine this transaction's signature. Make sure that the transaction has been signed by its fee payer.",
    [$ccf386126da6a5ec$export$bed6f92dafea0623]: "Transaction first instruction is not advance nonce account instruction.",
    [$ccf386126da6a5ec$export$802b3ebe5297e360]: "Transaction with no instructions cannot be durable nonce transaction.",
    [$ccf386126da6a5ec$export$694fd435994bcca]: "This transaction includes an address (`$programAddress`) which is both invoked and set as the fee payer. Program addresses may not pay fees",
    [$ccf386126da6a5ec$export$707576ec00ca24d6]: "This transaction includes an address (`$programAddress`) which is both invoked and marked writable. Program addresses may not be writable",
    [$ccf386126da6a5ec$export$6d61b980429516bd]: "Transaction is missing signatures for addresses: $addresses.",
    [$ccf386126da6a5ec$export$3963d9bca4091810]: "Transaction version must be in the range [0, 127]. `$actualVersion` given"
};
// src/message-formatter.ts
function $ccf386126da6a5ec$var$encodeValue(value) {
    if (Array.isArray(value)) return /* "[" */ "%5B" + value.map((element)=>typeof element === "string" ? encodeURIComponent(`"${element.replace(/"/g, '\\"')}"`) : $ccf386126da6a5ec$var$encodeValue(element)).join(/* ", " */ "%2C%20") + /* "]" */ "%5D";
    else if (typeof value === "bigint") return `${value}n`;
    else return encodeURIComponent(String(value != null && Object.getPrototypeOf(value) === null ? // Plain objects with no protoype don't have a `toString` method.
    // Convert them before stringifying them.
    {
        ...value
    } : value));
}
function $ccf386126da6a5ec$var$encodeObjectContextEntry([key, value]) {
    return `${key}=${$ccf386126da6a5ec$var$encodeValue(value)}`;
}
function $ccf386126da6a5ec$var$encodeContextObject(context) {
    return Object.entries(context).map($ccf386126da6a5ec$var$encodeObjectContextEntry).join("&");
}
function $ccf386126da6a5ec$var$getHumanReadableErrorMessage(code, context = {}) {
    const messageFormatString = $ccf386126da6a5ec$var$SolanaErrorMessages[code];
    const message = messageFormatString.replace(/(?<!\\)\$(\w+)/g, (substring, variableName)=>variableName in context ? `${context[variableName]}` : substring);
    return message;
}
function $ccf386126da6a5ec$var$getErrorMessage(code, context = {}) {
    if ($ccf386126da6a5ec$var$__DEV__) return $ccf386126da6a5ec$var$getHumanReadableErrorMessage(code, context);
    else {
        let decodingAdviceMessage = `Solana error #${code}; Decode this error by running \`npx @solana/errors decode ${code}`;
        if (Object.keys(context).length) decodingAdviceMessage += ` $"${$ccf386126da6a5ec$var$encodeContextObject(context)}"`;
        return `${decodingAdviceMessage}\``;
    }
}
// src/error.ts
function $ccf386126da6a5ec$export$cfead212e52d9961(e, code) {
    const isSolanaError2 = e instanceof Error && e.name === "SolanaError";
    if (isSolanaError2) {
        if (code !== void 0) return e.context.__code === code;
        return true;
    }
    return false;
}
var $ccf386126da6a5ec$export$8349fd9adaaed269 = class extends Error {
    context;
    constructor(...[code, contextAndErrorOptions]){
        let context;
        let errorOptions;
        if (contextAndErrorOptions) {
            const { cause: cause, ...contextRest } = contextAndErrorOptions;
            if (cause) errorOptions = {
                cause: cause
            };
            if (Object.keys(contextRest).length > 0) context = contextRest;
        }
        const message = $ccf386126da6a5ec$var$getErrorMessage(code, context);
        super(message, errorOptions);
        this.context = {
            __code: code,
            ...context
        };
        this.name = "SolanaError";
    }
};
// src/stack-trace.ts
function $ccf386126da6a5ec$export$4608fd6508cb51(...args) {
    if ("captureStackTrace" in Error && typeof Error.captureStackTrace === "function") Error.captureStackTrace(...args);
}
// src/rpc-enum-errors.ts
function $ccf386126da6a5ec$var$getSolanaErrorFromRpcError({ errorCodeBaseOffset: errorCodeBaseOffset, getErrorContext: getErrorContext, orderedErrorNames: orderedErrorNames, rpcEnumError: rpcEnumError }, constructorOpt) {
    let rpcErrorName;
    let rpcErrorContext;
    if (typeof rpcEnumError === "string") rpcErrorName = rpcEnumError;
    else {
        rpcErrorName = Object.keys(rpcEnumError)[0];
        rpcErrorContext = rpcEnumError[rpcErrorName];
    }
    const codeOffset = orderedErrorNames.indexOf(rpcErrorName);
    const errorCode = errorCodeBaseOffset + codeOffset;
    const errorContext = getErrorContext(errorCode, rpcErrorName, rpcErrorContext);
    const err = new $ccf386126da6a5ec$export$8349fd9adaaed269(errorCode, errorContext);
    $ccf386126da6a5ec$export$4608fd6508cb51(err, constructorOpt);
    return err;
}
// src/instruction-error.ts
var $ccf386126da6a5ec$var$ORDERED_ERROR_NAMES = [
    // Keep synced with RPC source: https://github.com/anza-xyz/agave/blob/master/sdk/program/src/instruction.rs
    // If this list ever gets too large, consider implementing a compression strategy like this:
    // https://gist.github.com/steveluscher/aaa7cbbb5433b1197983908a40860c47
    "GenericError",
    "InvalidArgument",
    "InvalidInstructionData",
    "InvalidAccountData",
    "AccountDataTooSmall",
    "InsufficientFunds",
    "IncorrectProgramId",
    "MissingRequiredSignature",
    "AccountAlreadyInitialized",
    "UninitializedAccount",
    "UnbalancedInstruction",
    "ModifiedProgramId",
    "ExternalAccountLamportSpend",
    "ExternalAccountDataModified",
    "ReadonlyLamportChange",
    "ReadonlyDataModified",
    "DuplicateAccountIndex",
    "ExecutableModified",
    "RentEpochModified",
    "NotEnoughAccountKeys",
    "AccountDataSizeChanged",
    "AccountNotExecutable",
    "AccountBorrowFailed",
    "AccountBorrowOutstanding",
    "DuplicateAccountOutOfSync",
    "Custom",
    "InvalidError",
    "ExecutableDataModified",
    "ExecutableLamportChange",
    "ExecutableAccountNotRentExempt",
    "UnsupportedProgramId",
    "CallDepth",
    "MissingAccount",
    "ReentrancyNotAllowed",
    "MaxSeedLengthExceeded",
    "InvalidSeeds",
    "InvalidRealloc",
    "ComputationalBudgetExceeded",
    "PrivilegeEscalation",
    "ProgramEnvironmentSetupFailure",
    "ProgramFailedToComplete",
    "ProgramFailedToCompile",
    "Immutable",
    "IncorrectAuthority",
    "BorshIoError",
    "AccountNotRentExempt",
    "InvalidAccountOwner",
    "ArithmeticOverflow",
    "UnsupportedSysvar",
    "IllegalOwner",
    "MaxAccountsDataAllocationsExceeded",
    "MaxAccountsExceeded",
    "MaxInstructionTraceLengthExceeded",
    "BuiltinProgramsMustConsumeComputeUnits"
];
function $ccf386126da6a5ec$export$4e38d43e41953f9e(index, instructionError) {
    return $ccf386126da6a5ec$var$getSolanaErrorFromRpcError({
        errorCodeBaseOffset: 4615001,
        getErrorContext (errorCode, rpcErrorName, rpcErrorContext) {
            if (errorCode === $ccf386126da6a5ec$export$d308cb6df5c28ff6) return {
                errorName: rpcErrorName,
                index: index,
                ...rpcErrorContext !== void 0 ? {
                    instructionErrorContext: rpcErrorContext
                } : null
            };
            else if (errorCode === $ccf386126da6a5ec$export$5abe2d1d040bf6cf) return {
                code: rpcErrorContext,
                index: index
            };
            else if (errorCode === $ccf386126da6a5ec$export$57c1675a0c20931f) return {
                encodedData: rpcErrorContext,
                index: index
            };
            return {
                index: index
            };
        },
        orderedErrorNames: $ccf386126da6a5ec$var$ORDERED_ERROR_NAMES,
        rpcEnumError: instructionError
    }, $ccf386126da6a5ec$export$4e38d43e41953f9e);
}
// src/transaction-error.ts
var $ccf386126da6a5ec$var$ORDERED_ERROR_NAMES2 = [
    // Keep synced with RPC source: https://github.com/anza-xyz/agave/blob/master/sdk/src/transaction/error.rs
    // If this list ever gets too large, consider implementing a compression strategy like this:
    // https://gist.github.com/steveluscher/aaa7cbbb5433b1197983908a40860c47
    "AccountInUse",
    "AccountLoadedTwice",
    "AccountNotFound",
    "ProgramAccountNotFound",
    "InsufficientFundsForFee",
    "InvalidAccountForFee",
    "AlreadyProcessed",
    "BlockhashNotFound",
    // `InstructionError` intentionally omitted; delegated to `getSolanaErrorFromInstructionError`
    "CallChainTooDeep",
    "MissingSignatureForFee",
    "InvalidAccountIndex",
    "SignatureFailure",
    "InvalidProgramForExecution",
    "SanitizeFailure",
    "ClusterMaintenance",
    "AccountBorrowOutstanding",
    "WouldExceedMaxBlockCostLimit",
    "UnsupportedVersion",
    "InvalidWritableAccount",
    "WouldExceedMaxAccountCostLimit",
    "WouldExceedAccountDataBlockLimit",
    "TooManyAccountLocks",
    "AddressLookupTableNotFound",
    "InvalidAddressLookupTableOwner",
    "InvalidAddressLookupTableData",
    "InvalidAddressLookupTableIndex",
    "InvalidRentPayingAccount",
    "WouldExceedMaxVoteCostLimit",
    "WouldExceedAccountDataTotalLimit",
    "DuplicateInstruction",
    "InsufficientFundsForRent",
    "MaxLoadedAccountsDataSizeExceeded",
    "InvalidLoadedAccountsDataSizeLimit",
    "ResanitizationNeeded",
    "ProgramExecutionTemporarilyRestricted",
    "UnbalancedTransaction"
];
function $ccf386126da6a5ec$export$c10ce7a2fd9c66f0(transactionError) {
    if (typeof transactionError === "object" && "InstructionError" in transactionError) return $ccf386126da6a5ec$export$4e38d43e41953f9e(...transactionError.InstructionError);
    return $ccf386126da6a5ec$var$getSolanaErrorFromRpcError({
        errorCodeBaseOffset: 7050001,
        getErrorContext (errorCode, rpcErrorName, rpcErrorContext) {
            if (errorCode === $ccf386126da6a5ec$export$8c82dde5b12c9789) return {
                errorName: rpcErrorName,
                ...rpcErrorContext !== void 0 ? {
                    transactionErrorContext: rpcErrorContext
                } : null
            };
            else if (errorCode === $ccf386126da6a5ec$export$e3a4007020a2e8f5) return {
                index: rpcErrorContext
            };
            else if (errorCode === $ccf386126da6a5ec$export$2ecc275dffbc087c || errorCode === $ccf386126da6a5ec$export$1cd0de5dfcdeb99d) return {
                accountIndex: rpcErrorContext.account_index
            };
        },
        orderedErrorNames: $ccf386126da6a5ec$var$ORDERED_ERROR_NAMES2,
        rpcEnumError: transactionError
    }, $ccf386126da6a5ec$export$c10ce7a2fd9c66f0);
}
// src/json-rpc-error.ts
function $ccf386126da6a5ec$export$1f67f8d128316a6d({ code: code, data: data, message: message }) {
    let out;
    if (code === $ccf386126da6a5ec$export$426cc73f5ad00f38) {
        const { err: err, ...preflightErrorContext } = data;
        const causeObject = err ? {
            cause: $ccf386126da6a5ec$export$c10ce7a2fd9c66f0(err)
        } : null;
        out = new $ccf386126da6a5ec$export$8349fd9adaaed269($ccf386126da6a5ec$export$426cc73f5ad00f38, {
            ...preflightErrorContext,
            ...causeObject
        });
    } else {
        let errorContext;
        switch(code){
            case $ccf386126da6a5ec$export$afa40fd3fc01204:
            case $ccf386126da6a5ec$export$2981978a530b1a7c:
            case $ccf386126da6a5ec$export$23cb4efd59427895:
            case $ccf386126da6a5ec$export$5ec955cc8b7e8cf9:
            case $ccf386126da6a5ec$export$e09e3905081e44fe:
            case $ccf386126da6a5ec$export$1b90c411626421b1:
            case $ccf386126da6a5ec$export$6ae475e85fe02aad:
            case $ccf386126da6a5ec$export$bfbf8b75e865efa0:
            case $ccf386126da6a5ec$export$65235469ebe9845e:
            case $ccf386126da6a5ec$export$54dea2286c43ec1e:
            case $ccf386126da6a5ec$export$e71fbee92648fc61:
            case $ccf386126da6a5ec$export$d21075fd06730e:
            case $ccf386126da6a5ec$export$d964b43bb02eacdf:
            case $ccf386126da6a5ec$export$f7685139153f9191:
                errorContext = {
                    __serverMessage: message
                };
                break;
            default:
                if (typeof data === "object" && !Array.isArray(data)) errorContext = data;
        }
        out = new $ccf386126da6a5ec$export$8349fd9adaaed269(code, errorContext);
    }
    $ccf386126da6a5ec$export$4608fd6508cb51(out, $ccf386126da6a5ec$export$1f67f8d128316a6d);
    return out;
}
 //# sourceMappingURL=out.js.map


// src/assertions.ts
function $b7d16e67857467bd$export$bf929351331b7b89(codecDescription, bytes, offset = 0) {
    if (bytes.length - offset <= 0) throw new (0, $ccf386126da6a5ec$export$8349fd9adaaed269)((0, $ccf386126da6a5ec$export$9c9326ce1e3df40c), {
        codecDescription: codecDescription
    });
}
function $b7d16e67857467bd$export$4a981e7c9ed0b6bf(codecDescription, expected, bytes, offset = 0) {
    const bytesLength = bytes.length - offset;
    if (bytesLength < expected) throw new (0, $ccf386126da6a5ec$export$8349fd9adaaed269)((0, $ccf386126da6a5ec$export$18fbf24f19efc69b), {
        bytesLength: bytesLength,
        codecDescription: codecDescription,
        expected: expected
    });
}
function $b7d16e67857467bd$export$9319e0aa6a4927d2(codecDescription, offset, bytesLength) {
    if (offset < 0 || offset > bytesLength) throw new (0, $ccf386126da6a5ec$export$8349fd9adaaed269)((0, $ccf386126da6a5ec$export$a617dff403944ec6), {
        bytesLength: bytesLength,
        codecDescription: codecDescription,
        offset: offset
    });
}
// src/bytes.ts
var $b7d16e67857467bd$export$6cf3317d55598fde = (byteArrays)=>{
    const nonEmptyByteArrays = byteArrays.filter((arr)=>arr.length);
    if (nonEmptyByteArrays.length === 0) return byteArrays.length ? byteArrays[0] : new Uint8Array();
    if (nonEmptyByteArrays.length === 1) return nonEmptyByteArrays[0];
    const totalLength = nonEmptyByteArrays.reduce((total, arr)=>total + arr.length, 0);
    const result = new Uint8Array(totalLength);
    let offset = 0;
    nonEmptyByteArrays.forEach((arr)=>{
        result.set(arr, offset);
        offset += arr.length;
    });
    return result;
};
var $b7d16e67857467bd$export$4c6b868113605df3 = (bytes, length)=>{
    if (bytes.length >= length) return bytes;
    const paddedBytes = new Uint8Array(length).fill(0);
    paddedBytes.set(bytes);
    return paddedBytes;
};
var $b7d16e67857467bd$export$11b3146a4f4702ef = (bytes, length)=>$b7d16e67857467bd$export$4c6b868113605df3(bytes.length <= length ? bytes : bytes.slice(0, length), length);
function $b7d16e67857467bd$export$30f3257599397621(value, encoder) {
    return "fixedSize" in encoder ? encoder.fixedSize : encoder.getSizeFromValue(value);
}
function $b7d16e67857467bd$export$4e76eeb6df88c889(encoder) {
    return Object.freeze({
        ...encoder,
        encode: (value)=>{
            const bytes = new Uint8Array($b7d16e67857467bd$export$30f3257599397621(value, encoder));
            encoder.write(value, bytes, 0);
            return bytes;
        }
    });
}
function $b7d16e67857467bd$export$f8c898e83b60faaa(decoder) {
    return Object.freeze({
        ...decoder,
        decode: (bytes, offset = 0)=>decoder.read(bytes, offset)[0]
    });
}
function $b7d16e67857467bd$export$a4cf2f585987cc8(codec) {
    return Object.freeze({
        ...codec,
        decode: (bytes, offset = 0)=>codec.read(bytes, offset)[0],
        encode: (value)=>{
            const bytes = new Uint8Array($b7d16e67857467bd$export$30f3257599397621(value, codec));
            codec.write(value, bytes, 0);
            return bytes;
        }
    });
}
function $b7d16e67857467bd$export$f9d60229c95384d4(codec) {
    return "fixedSize" in codec && typeof codec.fixedSize === "number";
}
function $b7d16e67857467bd$export$4e85b7423fd6bc55(codec) {
    if (!$b7d16e67857467bd$export$f9d60229c95384d4(codec)) throw new (0, $ccf386126da6a5ec$export$8349fd9adaaed269)((0, $ccf386126da6a5ec$export$93561b31b951410d));
}
function $b7d16e67857467bd$export$d76fd0b6e42f051a(codec) {
    return !$b7d16e67857467bd$export$f9d60229c95384d4(codec);
}
function $b7d16e67857467bd$export$6bf5fc425e413c8a(codec) {
    if (!$b7d16e67857467bd$export$d76fd0b6e42f051a(codec)) throw new (0, $ccf386126da6a5ec$export$8349fd9adaaed269)((0, $ccf386126da6a5ec$export$3417da5bc6bcb45));
}
function $b7d16e67857467bd$export$b88681b853abde79(encoder, decoder) {
    if ($b7d16e67857467bd$export$f9d60229c95384d4(encoder) !== $b7d16e67857467bd$export$f9d60229c95384d4(decoder)) throw new (0, $ccf386126da6a5ec$export$8349fd9adaaed269)((0, $ccf386126da6a5ec$export$c4c73ab3c0833591));
    if ($b7d16e67857467bd$export$f9d60229c95384d4(encoder) && $b7d16e67857467bd$export$f9d60229c95384d4(decoder) && encoder.fixedSize !== decoder.fixedSize) throw new (0, $ccf386126da6a5ec$export$8349fd9adaaed269)((0, $ccf386126da6a5ec$export$824d79ab1779d517), {
        decoderFixedSize: decoder.fixedSize,
        encoderFixedSize: encoder.fixedSize
    });
    if (!$b7d16e67857467bd$export$f9d60229c95384d4(encoder) && !$b7d16e67857467bd$export$f9d60229c95384d4(decoder) && encoder.maxSize !== decoder.maxSize) throw new (0, $ccf386126da6a5ec$export$8349fd9adaaed269)((0, $ccf386126da6a5ec$export$c464f3b291f1f3d0), {
        decoderMaxSize: decoder.maxSize,
        encoderMaxSize: encoder.maxSize
    });
    return {
        ...decoder,
        ...encoder,
        decode: decoder.decode,
        encode: encoder.encode,
        read: decoder.read,
        write: encoder.write
    };
}
// src/fix-codec.ts
function $b7d16e67857467bd$export$7c45a7fca252a5a3(encoder, fixedBytes) {
    return $b7d16e67857467bd$export$4e76eeb6df88c889({
        fixedSize: fixedBytes,
        write: (value, bytes, offset)=>{
            const variableByteArray = encoder.encode(value);
            const fixedByteArray = variableByteArray.length > fixedBytes ? variableByteArray.slice(0, fixedBytes) : variableByteArray;
            bytes.set(fixedByteArray, offset);
            return offset + fixedBytes;
        }
    });
}
function $b7d16e67857467bd$export$55b1530b9f82bf3d(decoder, fixedBytes) {
    return $b7d16e67857467bd$export$f8c898e83b60faaa({
        fixedSize: fixedBytes,
        read: (bytes, offset)=>{
            $b7d16e67857467bd$export$4a981e7c9ed0b6bf("fixCodec", fixedBytes, bytes, offset);
            if (offset > 0 || bytes.length > fixedBytes) bytes = bytes.slice(offset, offset + fixedBytes);
            if ($b7d16e67857467bd$export$f9d60229c95384d4(decoder)) bytes = $b7d16e67857467bd$export$11b3146a4f4702ef(bytes, decoder.fixedSize);
            const [value] = decoder.read(bytes, 0);
            return [
                value,
                offset + fixedBytes
            ];
        }
    });
}
function $b7d16e67857467bd$export$4186298fbd725fe3(codec, fixedBytes) {
    return $b7d16e67857467bd$export$b88681b853abde79($b7d16e67857467bd$export$7c45a7fca252a5a3(codec, fixedBytes), $b7d16e67857467bd$export$55b1530b9f82bf3d(codec, fixedBytes));
}
// src/map-codec.ts
function $b7d16e67857467bd$export$f33e4302ccbdfdf3(encoder, unmap) {
    return $b7d16e67857467bd$export$4e76eeb6df88c889({
        ...$b7d16e67857467bd$export$d76fd0b6e42f051a(encoder) ? {
            ...encoder,
            getSizeFromValue: (value)=>encoder.getSizeFromValue(unmap(value))
        } : encoder,
        write: (value, bytes, offset)=>encoder.write(unmap(value), bytes, offset)
    });
}
function $b7d16e67857467bd$export$45b43a889ba2d4c0(decoder, map) {
    return $b7d16e67857467bd$export$f8c898e83b60faaa({
        ...decoder,
        read: (bytes, offset)=>{
            const [value, newOffset] = decoder.read(bytes, offset);
            return [
                map(value, bytes, offset),
                newOffset
            ];
        }
    });
}
function $b7d16e67857467bd$export$802eb90f20272696(codec, unmap, map) {
    return $b7d16e67857467bd$export$a4cf2f585987cc8({
        ...$b7d16e67857467bd$export$f33e4302ccbdfdf3(codec, unmap),
        read: map ? $b7d16e67857467bd$export$45b43a889ba2d4c0(codec, map).read : codec.read
    });
}
// src/offset-codec.ts
function $b7d16e67857467bd$export$92407871fbff8926(encoder, config) {
    return $b7d16e67857467bd$export$4e76eeb6df88c889({
        ...encoder,
        write: (value, bytes, preOffset)=>{
            const wrapBytes = (offset)=>$b7d16e67857467bd$var$modulo(offset, bytes.length);
            const newPreOffset = config.preOffset ? config.preOffset({
                bytes: bytes,
                preOffset: preOffset,
                wrapBytes: wrapBytes
            }) : preOffset;
            $b7d16e67857467bd$export$9319e0aa6a4927d2("offsetEncoder", newPreOffset, bytes.length);
            const postOffset = encoder.write(value, bytes, newPreOffset);
            const newPostOffset = config.postOffset ? config.postOffset({
                bytes: bytes,
                newPreOffset: newPreOffset,
                postOffset: postOffset,
                preOffset: preOffset,
                wrapBytes: wrapBytes
            }) : postOffset;
            $b7d16e67857467bd$export$9319e0aa6a4927d2("offsetEncoder", newPostOffset, bytes.length);
            return newPostOffset;
        }
    });
}
function $b7d16e67857467bd$export$24667feddece166a(decoder, config) {
    return $b7d16e67857467bd$export$f8c898e83b60faaa({
        ...decoder,
        read: (bytes, preOffset)=>{
            const wrapBytes = (offset)=>$b7d16e67857467bd$var$modulo(offset, bytes.length);
            const newPreOffset = config.preOffset ? config.preOffset({
                bytes: bytes,
                preOffset: preOffset,
                wrapBytes: wrapBytes
            }) : preOffset;
            $b7d16e67857467bd$export$9319e0aa6a4927d2("offsetDecoder", newPreOffset, bytes.length);
            const [value, postOffset] = decoder.read(bytes, newPreOffset);
            const newPostOffset = config.postOffset ? config.postOffset({
                bytes: bytes,
                newPreOffset: newPreOffset,
                postOffset: postOffset,
                preOffset: preOffset,
                wrapBytes: wrapBytes
            }) : postOffset;
            $b7d16e67857467bd$export$9319e0aa6a4927d2("offsetDecoder", newPostOffset, bytes.length);
            return [
                value,
                newPostOffset
            ];
        }
    });
}
function $b7d16e67857467bd$export$8170ddca0f3f53ea(codec, config) {
    return $b7d16e67857467bd$export$b88681b853abde79($b7d16e67857467bd$export$92407871fbff8926(codec, config), $b7d16e67857467bd$export$24667feddece166a(codec, config));
}
function $b7d16e67857467bd$var$modulo(dividend, divisor) {
    if (divisor === 0) return 0;
    return (dividend % divisor + divisor) % divisor;
}
function $b7d16e67857467bd$export$d41c2ca858573bc6(encoder, resize) {
    if ($b7d16e67857467bd$export$f9d60229c95384d4(encoder)) {
        const fixedSize = resize(encoder.fixedSize);
        if (fixedSize < 0) throw new (0, $ccf386126da6a5ec$export$8349fd9adaaed269)((0, $ccf386126da6a5ec$export$4c1fcb4bd20b2951), {
            bytesLength: fixedSize,
            codecDescription: "resizeEncoder"
        });
        return $b7d16e67857467bd$export$4e76eeb6df88c889({
            ...encoder,
            fixedSize: fixedSize
        });
    }
    return $b7d16e67857467bd$export$4e76eeb6df88c889({
        ...encoder,
        getSizeFromValue: (value)=>{
            const newSize = resize(encoder.getSizeFromValue(value));
            if (newSize < 0) throw new (0, $ccf386126da6a5ec$export$8349fd9adaaed269)((0, $ccf386126da6a5ec$export$4c1fcb4bd20b2951), {
                bytesLength: newSize,
                codecDescription: "resizeEncoder"
            });
            return newSize;
        }
    });
}
function $b7d16e67857467bd$export$7369e12a03366140(decoder, resize) {
    if ($b7d16e67857467bd$export$f9d60229c95384d4(decoder)) {
        const fixedSize = resize(decoder.fixedSize);
        if (fixedSize < 0) throw new (0, $ccf386126da6a5ec$export$8349fd9adaaed269)((0, $ccf386126da6a5ec$export$4c1fcb4bd20b2951), {
            bytesLength: fixedSize,
            codecDescription: "resizeDecoder"
        });
        return $b7d16e67857467bd$export$f8c898e83b60faaa({
            ...decoder,
            fixedSize: fixedSize
        });
    }
    return decoder;
}
function $b7d16e67857467bd$export$aff234b7657ae683(codec, resize) {
    return $b7d16e67857467bd$export$b88681b853abde79($b7d16e67857467bd$export$d41c2ca858573bc6(codec, resize), $b7d16e67857467bd$export$7369e12a03366140(codec, resize));
}
// src/pad-codec.ts
function $b7d16e67857467bd$export$66b1746799cd3030(encoder, offset) {
    return $b7d16e67857467bd$export$92407871fbff8926($b7d16e67857467bd$export$d41c2ca858573bc6(encoder, (size)=>size + offset), {
        preOffset: ({ preOffset: preOffset })=>preOffset + offset
    });
}
function $b7d16e67857467bd$export$770586d1e6f1e5b(encoder, offset) {
    return $b7d16e67857467bd$export$92407871fbff8926($b7d16e67857467bd$export$d41c2ca858573bc6(encoder, (size)=>size + offset), {
        postOffset: ({ postOffset: postOffset })=>postOffset + offset
    });
}
function $b7d16e67857467bd$export$d88f5bbaa5c2e177(decoder, offset) {
    return $b7d16e67857467bd$export$24667feddece166a($b7d16e67857467bd$export$7369e12a03366140(decoder, (size)=>size + offset), {
        preOffset: ({ preOffset: preOffset })=>preOffset + offset
    });
}
function $b7d16e67857467bd$export$57a7baba87e0aed9(decoder, offset) {
    return $b7d16e67857467bd$export$24667feddece166a($b7d16e67857467bd$export$7369e12a03366140(decoder, (size)=>size + offset), {
        postOffset: ({ postOffset: postOffset })=>postOffset + offset
    });
}
function $b7d16e67857467bd$export$d6ed5bbf596a5505(codec, offset) {
    return $b7d16e67857467bd$export$b88681b853abde79($b7d16e67857467bd$export$66b1746799cd3030(codec, offset), $b7d16e67857467bd$export$d88f5bbaa5c2e177(codec, offset));
}
function $b7d16e67857467bd$export$b11ce69168faaa31(codec, offset) {
    return $b7d16e67857467bd$export$b88681b853abde79($b7d16e67857467bd$export$770586d1e6f1e5b(codec, offset), $b7d16e67857467bd$export$57a7baba87e0aed9(codec, offset));
}
// src/reverse-codec.ts
function $b7d16e67857467bd$export$290b4b66fdcc682c(encoder) {
    $b7d16e67857467bd$export$4e85b7423fd6bc55(encoder);
    return $b7d16e67857467bd$export$4e76eeb6df88c889({
        ...encoder,
        write: (value, bytes, offset)=>{
            const newOffset = encoder.write(value, bytes, offset);
            const slice = bytes.slice(offset, offset + encoder.fixedSize).reverse();
            bytes.set(slice, offset);
            return newOffset;
        }
    });
}
function $b7d16e67857467bd$export$1dded7e9fb3087ff(decoder) {
    $b7d16e67857467bd$export$4e85b7423fd6bc55(decoder);
    return $b7d16e67857467bd$export$f8c898e83b60faaa({
        ...decoder,
        read: (bytes, offset)=>{
            const reverseEnd = offset + decoder.fixedSize;
            if (offset === 0 && bytes.length === reverseEnd) return decoder.read(bytes.reverse(), offset);
            const reversedBytes = bytes.slice();
            reversedBytes.set(bytes.slice(offset, reverseEnd).reverse(), offset);
            return decoder.read(reversedBytes, offset);
        }
    });
}
function $b7d16e67857467bd$export$e1ef688f83355e2e(codec) {
    return $b7d16e67857467bd$export$b88681b853abde79($b7d16e67857467bd$export$290b4b66fdcc682c(codec), $b7d16e67857467bd$export$1dded7e9fb3087ff(codec));
}
 //# sourceMappingURL=out.js.map




// src/assertions.ts
function $703c30ae641df6e2$export$50ab5941a148d055(codecDescription, min, max, value) {
    if (value < min || value > max) throw new (0, $ccf386126da6a5ec$export$8349fd9adaaed269)((0, $ccf386126da6a5ec$export$8653c145864f47f4), {
        codecDescription: codecDescription,
        max: max,
        min: min,
        value: value
    });
}
// src/common.ts
var $703c30ae641df6e2$export$54493dce0da47833 = /* @__PURE__ */ ((Endian2)=>{
    Endian2[Endian2["LITTLE"] = 0] = "LITTLE";
    Endian2[Endian2["BIG"] = 1] = "BIG";
    return Endian2;
})($703c30ae641df6e2$export$54493dce0da47833 || {});
function $703c30ae641df6e2$var$isLittleEndian(config) {
    return config?.endian === 1 /* BIG */  ? false : true;
}
function $703c30ae641df6e2$var$numberEncoderFactory(input) {
    return (0, $b7d16e67857467bd$export$4e76eeb6df88c889)({
        fixedSize: input.size,
        write (value, bytes, offset) {
            if (input.range) $703c30ae641df6e2$export$50ab5941a148d055(input.name, input.range[0], input.range[1], value);
            const arrayBuffer = new ArrayBuffer(input.size);
            input.set(new DataView(arrayBuffer), value, $703c30ae641df6e2$var$isLittleEndian(input.config));
            bytes.set(new Uint8Array(arrayBuffer), offset);
            return offset + input.size;
        }
    });
}
function $703c30ae641df6e2$var$numberDecoderFactory(input) {
    return (0, $b7d16e67857467bd$export$f8c898e83b60faaa)({
        fixedSize: input.size,
        read (bytes, offset = 0) {
            (0, $b7d16e67857467bd$export$bf929351331b7b89)(input.name, bytes, offset);
            (0, $b7d16e67857467bd$export$4a981e7c9ed0b6bf)(input.name, input.size, bytes, offset);
            const view = new DataView($703c30ae641df6e2$var$toArrayBuffer(bytes, offset, input.size));
            return [
                input.get(view, $703c30ae641df6e2$var$isLittleEndian(input.config)),
                offset + input.size
            ];
        }
    });
}
function $703c30ae641df6e2$var$toArrayBuffer(bytes, offset, length) {
    const bytesOffset = bytes.byteOffset + (offset ?? 0);
    const bytesLength = length ?? bytes.byteLength;
    return bytes.buffer.slice(bytesOffset, bytesOffset + bytesLength);
}
// src/f32.ts
var $703c30ae641df6e2$export$d76ef1cfec201bc9 = (config = {})=>$703c30ae641df6e2$var$numberEncoderFactory({
        config: config,
        name: "f32",
        set: (view, value, le)=>view.setFloat32(0, value, le),
        size: 4
    });
var $703c30ae641df6e2$export$314df11445cfa5d0 = (config = {})=>$703c30ae641df6e2$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>view.getFloat32(0, le),
        name: "f32",
        size: 4
    });
var $703c30ae641df6e2$export$97a035f0564c51de = (config = {})=>(0, $b7d16e67857467bd$export$b88681b853abde79)($703c30ae641df6e2$export$d76ef1cfec201bc9(config), $703c30ae641df6e2$export$314df11445cfa5d0(config));
var $703c30ae641df6e2$export$551368d522177b99 = (config = {})=>$703c30ae641df6e2$var$numberEncoderFactory({
        config: config,
        name: "f64",
        set: (view, value, le)=>view.setFloat64(0, value, le),
        size: 8
    });
var $703c30ae641df6e2$export$9475ae45ddf86dec = (config = {})=>$703c30ae641df6e2$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>view.getFloat64(0, le),
        name: "f64",
        size: 8
    });
var $703c30ae641df6e2$export$9db82e6fbf3ec8ac = (config = {})=>(0, $b7d16e67857467bd$export$b88681b853abde79)($703c30ae641df6e2$export$551368d522177b99(config), $703c30ae641df6e2$export$9475ae45ddf86dec(config));
var $703c30ae641df6e2$export$cf7587f741407205 = (config = {})=>$703c30ae641df6e2$var$numberEncoderFactory({
        config: config,
        name: "i128",
        range: [
            -BigInt("0x7fffffffffffffffffffffffffffffff") - 1n,
            BigInt("0x7fffffffffffffffffffffffffffffff")
        ],
        set: (view, value, le)=>{
            const leftOffset = le ? 8 : 0;
            const rightOffset = le ? 0 : 8;
            const rightMask = 0xffffffffffffffffn;
            view.setBigInt64(leftOffset, BigInt(value) >> 64n, le);
            view.setBigUint64(rightOffset, BigInt(value) & rightMask, le);
        },
        size: 16
    });
var $703c30ae641df6e2$export$aacd18c97984700c = (config = {})=>$703c30ae641df6e2$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>{
            const leftOffset = le ? 8 : 0;
            const rightOffset = le ? 0 : 8;
            const left = view.getBigInt64(leftOffset, le);
            const right = view.getBigUint64(rightOffset, le);
            return (left << 64n) + right;
        },
        name: "i128",
        size: 16
    });
var $703c30ae641df6e2$export$b2a180b15845f643 = (config = {})=>(0, $b7d16e67857467bd$export$b88681b853abde79)($703c30ae641df6e2$export$cf7587f741407205(config), $703c30ae641df6e2$export$aacd18c97984700c(config));
var $703c30ae641df6e2$export$45d575c12b2bb6a5 = (config = {})=>$703c30ae641df6e2$var$numberEncoderFactory({
        config: config,
        name: "i16",
        range: [
            -Number("0x7fff") - 1,
            Number("0x7fff")
        ],
        set: (view, value, le)=>view.setInt16(0, value, le),
        size: 2
    });
var $703c30ae641df6e2$export$4617ff1e22909f4 = (config = {})=>$703c30ae641df6e2$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>view.getInt16(0, le),
        name: "i16",
        size: 2
    });
var $703c30ae641df6e2$export$c82cd783a714bca2 = (config = {})=>(0, $b7d16e67857467bd$export$b88681b853abde79)($703c30ae641df6e2$export$45d575c12b2bb6a5(config), $703c30ae641df6e2$export$4617ff1e22909f4(config));
var $703c30ae641df6e2$export$73a58a16e77bb58b = (config = {})=>$703c30ae641df6e2$var$numberEncoderFactory({
        config: config,
        name: "i32",
        range: [
            -Number("0x7fffffff") - 1,
            Number("0x7fffffff")
        ],
        set: (view, value, le)=>view.setInt32(0, value, le),
        size: 4
    });
var $703c30ae641df6e2$export$a7167d44cb5c65b9 = (config = {})=>$703c30ae641df6e2$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>view.getInt32(0, le),
        name: "i32",
        size: 4
    });
var $703c30ae641df6e2$export$c31d2e083195a86f = (config = {})=>(0, $b7d16e67857467bd$export$b88681b853abde79)($703c30ae641df6e2$export$73a58a16e77bb58b(config), $703c30ae641df6e2$export$a7167d44cb5c65b9(config));
var $703c30ae641df6e2$export$42b58a304e7edd67 = (config = {})=>$703c30ae641df6e2$var$numberEncoderFactory({
        config: config,
        name: "i64",
        range: [
            -BigInt("0x7fffffffffffffff") - 1n,
            BigInt("0x7fffffffffffffff")
        ],
        set: (view, value, le)=>view.setBigInt64(0, BigInt(value), le),
        size: 8
    });
var $703c30ae641df6e2$export$6f14c9b3a349f404 = (config = {})=>$703c30ae641df6e2$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>view.getBigInt64(0, le),
        name: "i64",
        size: 8
    });
var $703c30ae641df6e2$export$ebdc4dbdba726e6a = (config = {})=>(0, $b7d16e67857467bd$export$b88681b853abde79)($703c30ae641df6e2$export$42b58a304e7edd67(config), $703c30ae641df6e2$export$6f14c9b3a349f404(config));
var $703c30ae641df6e2$export$44792a8c35b3c0ce = ()=>$703c30ae641df6e2$var$numberEncoderFactory({
        name: "i8",
        range: [
            -Number("0x7f") - 1,
            Number("0x7f")
        ],
        set: (view, value)=>view.setInt8(0, value),
        size: 1
    });
var $703c30ae641df6e2$export$fdc22c4a59dfe6be = ()=>$703c30ae641df6e2$var$numberDecoderFactory({
        get: (view)=>view.getInt8(0),
        name: "i8",
        size: 1
    });
var $703c30ae641df6e2$export$f930a8952cfab173 = ()=>(0, $b7d16e67857467bd$export$b88681b853abde79)($703c30ae641df6e2$export$44792a8c35b3c0ce(), $703c30ae641df6e2$export$fdc22c4a59dfe6be());
var $703c30ae641df6e2$export$6f025a6ce2a023fc = ()=>(0, $b7d16e67857467bd$export$4e76eeb6df88c889)({
        getSizeFromValue: (value)=>{
            if (value <= 127) return 1;
            if (value <= 16383) return 2;
            return 3;
        },
        maxSize: 3,
        write: (value, bytes, offset)=>{
            $703c30ae641df6e2$export$50ab5941a148d055("shortU16", 0, 65535, value);
            const shortU16Bytes = [
                0
            ];
            for(let ii = 0;; ii += 1){
                const alignedValue = value >> ii * 7;
                if (alignedValue === 0) break;
                const nextSevenBits = 127 & alignedValue;
                shortU16Bytes[ii] = nextSevenBits;
                if (ii > 0) shortU16Bytes[ii - 1] |= 128;
            }
            bytes.set(shortU16Bytes, offset);
            return offset + shortU16Bytes.length;
        }
    });
var $703c30ae641df6e2$export$fa35aa457fb08b4a = ()=>(0, $b7d16e67857467bd$export$f8c898e83b60faaa)({
        maxSize: 3,
        read: (bytes, offset)=>{
            let value = 0;
            let byteCount = 0;
            while(++byteCount){
                const byteIndex = byteCount - 1;
                const currentByte = bytes[offset + byteIndex];
                const nextSevenBits = 127 & currentByte;
                value |= nextSevenBits << byteIndex * 7;
                if ((currentByte & 128) === 0) break;
            }
            return [
                value,
                offset + byteCount
            ];
        }
    });
var $703c30ae641df6e2$export$9f6b1d6c8cda8e31 = ()=>(0, $b7d16e67857467bd$export$b88681b853abde79)($703c30ae641df6e2$export$6f025a6ce2a023fc(), $703c30ae641df6e2$export$fa35aa457fb08b4a());
var $703c30ae641df6e2$export$3333225663a8d6bb = (config = {})=>$703c30ae641df6e2$var$numberEncoderFactory({
        config: config,
        name: "u128",
        range: [
            0n,
            BigInt("0xffffffffffffffffffffffffffffffff")
        ],
        set: (view, value, le)=>{
            const leftOffset = le ? 8 : 0;
            const rightOffset = le ? 0 : 8;
            const rightMask = 0xffffffffffffffffn;
            view.setBigUint64(leftOffset, BigInt(value) >> 64n, le);
            view.setBigUint64(rightOffset, BigInt(value) & rightMask, le);
        },
        size: 16
    });
var $703c30ae641df6e2$export$523e33537e060693 = (config = {})=>$703c30ae641df6e2$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>{
            const leftOffset = le ? 8 : 0;
            const rightOffset = le ? 0 : 8;
            const left = view.getBigUint64(leftOffset, le);
            const right = view.getBigUint64(rightOffset, le);
            return (left << 64n) + right;
        },
        name: "u128",
        size: 16
    });
var $703c30ae641df6e2$export$e775878beaafab29 = (config = {})=>(0, $b7d16e67857467bd$export$b88681b853abde79)($703c30ae641df6e2$export$3333225663a8d6bb(config), $703c30ae641df6e2$export$523e33537e060693(config));
var $703c30ae641df6e2$export$e156211d06496a2f = (config = {})=>$703c30ae641df6e2$var$numberEncoderFactory({
        config: config,
        name: "u16",
        range: [
            0,
            Number("0xffff")
        ],
        set: (view, value, le)=>view.setUint16(0, value, le),
        size: 2
    });
var $703c30ae641df6e2$export$1a649eb0055ac058 = (config = {})=>$703c30ae641df6e2$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>view.getUint16(0, le),
        name: "u16",
        size: 2
    });
var $703c30ae641df6e2$export$dda1212c8afd5e5c = (config = {})=>(0, $b7d16e67857467bd$export$b88681b853abde79)($703c30ae641df6e2$export$e156211d06496a2f(config), $703c30ae641df6e2$export$1a649eb0055ac058(config));
var $703c30ae641df6e2$export$3e3136013a349951 = (config = {})=>$703c30ae641df6e2$var$numberEncoderFactory({
        config: config,
        name: "u32",
        range: [
            0,
            Number("0xffffffff")
        ],
        set: (view, value, le)=>view.setUint32(0, value, le),
        size: 4
    });
var $703c30ae641df6e2$export$ddc26825031b1ac9 = (config = {})=>$703c30ae641df6e2$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>view.getUint32(0, le),
        name: "u32",
        size: 4
    });
var $703c30ae641df6e2$export$172bf721fe9bbfd1 = (config = {})=>(0, $b7d16e67857467bd$export$b88681b853abde79)($703c30ae641df6e2$export$3e3136013a349951(config), $703c30ae641df6e2$export$ddc26825031b1ac9(config));
var $703c30ae641df6e2$export$59d3bc8d559487ec = (config = {})=>$703c30ae641df6e2$var$numberEncoderFactory({
        config: config,
        name: "u64",
        range: [
            0n,
            BigInt("0xffffffffffffffff")
        ],
        set: (view, value, le)=>view.setBigUint64(0, BigInt(value), le),
        size: 8
    });
var $703c30ae641df6e2$export$faa05ffebebd465d = (config = {})=>$703c30ae641df6e2$var$numberDecoderFactory({
        config: config,
        get: (view, le)=>view.getBigUint64(0, le),
        name: "u64",
        size: 8
    });
var $703c30ae641df6e2$export$7e56ec13f6029ccc = (config = {})=>(0, $b7d16e67857467bd$export$b88681b853abde79)($703c30ae641df6e2$export$59d3bc8d559487ec(config), $703c30ae641df6e2$export$faa05ffebebd465d(config));
var $703c30ae641df6e2$export$dc9732115561fb4b = ()=>$703c30ae641df6e2$var$numberEncoderFactory({
        name: "u8",
        range: [
            0,
            Number("0xff")
        ],
        set: (view, value)=>view.setUint8(0, value),
        size: 1
    });
var $703c30ae641df6e2$export$edadf68f5f1a8bc6 = ()=>$703c30ae641df6e2$var$numberDecoderFactory({
        get: (view)=>view.getUint8(0),
        name: "u8",
        size: 1
    });
var $703c30ae641df6e2$export$5ae2d5c46a10d97 = ()=>(0, $b7d16e67857467bd$export$b88681b853abde79)($703c30ae641df6e2$export$dc9732115561fb4b(), $703c30ae641df6e2$export$edadf68f5f1a8bc6());
 //# sourceMappingURL=out.js.map



// src/array.ts
function $7ef019fe080c77e0$export$1e6cff54ac72b1a3(codecDescription, expected, actual) {
    if (expected !== actual) throw new (0, $ccf386126da6a5ec$export$8349fd9adaaed269)((0, $ccf386126da6a5ec$export$c04710d31ef4d278), {
        actual: actual,
        codecDescription: codecDescription,
        expected: expected
    });
}
function $7ef019fe080c77e0$var$maxCodecSizes(sizes) {
    return sizes.reduce((all, size)=>all === null || size === null ? null : Math.max(all, size), 0);
}
function $7ef019fe080c77e0$var$sumCodecSizes(sizes) {
    return sizes.reduce((all, size)=>all === null || size === null ? null : all + size, 0);
}
function $7ef019fe080c77e0$var$getFixedSize(codec) {
    return (0, $b7d16e67857467bd$export$f9d60229c95384d4)(codec) ? codec.fixedSize : null;
}
function $7ef019fe080c77e0$var$getMaxSize(codec) {
    return (0, $b7d16e67857467bd$export$f9d60229c95384d4)(codec) ? codec.fixedSize : codec.maxSize ?? null;
}
// src/array.ts
function $7ef019fe080c77e0$export$415199198053c0b(item, config = {}) {
    const size = config.size ?? (0, $703c30ae641df6e2$export$3e3136013a349951)();
    const fixedSize = $7ef019fe080c77e0$var$computeArrayLikeCodecSize(size, $7ef019fe080c77e0$var$getFixedSize(item));
    const maxSize = $7ef019fe080c77e0$var$computeArrayLikeCodecSize(size, $7ef019fe080c77e0$var$getMaxSize(item)) ?? void 0;
    return (0, $b7d16e67857467bd$export$4e76eeb6df88c889)({
        ...fixedSize !== null ? {
            fixedSize: fixedSize
        } : {
            getSizeFromValue: (array)=>{
                const prefixSize = typeof size === "object" ? (0, $b7d16e67857467bd$export$30f3257599397621)(array.length, size) : 0;
                return prefixSize + [
                    ...array
                ].reduce((all, value)=>all + (0, $b7d16e67857467bd$export$30f3257599397621)(value, item), 0);
            },
            maxSize: maxSize
        },
        write: (array, bytes, offset)=>{
            if (typeof size === "number") $7ef019fe080c77e0$export$1e6cff54ac72b1a3("array", size, array.length);
            if (typeof size === "object") offset = size.write(array.length, bytes, offset);
            array.forEach((value)=>{
                offset = item.write(value, bytes, offset);
            });
            return offset;
        }
    });
}
function $7ef019fe080c77e0$export$9016038b2e3b0c2f(item, config = {}) {
    const size = config.size ?? (0, $703c30ae641df6e2$export$ddc26825031b1ac9)();
    const itemSize = $7ef019fe080c77e0$var$getFixedSize(item);
    const fixedSize = $7ef019fe080c77e0$var$computeArrayLikeCodecSize(size, itemSize);
    const maxSize = $7ef019fe080c77e0$var$computeArrayLikeCodecSize(size, $7ef019fe080c77e0$var$getMaxSize(item)) ?? void 0;
    return (0, $b7d16e67857467bd$export$f8c898e83b60faaa)({
        ...fixedSize !== null ? {
            fixedSize: fixedSize
        } : {
            maxSize: maxSize
        },
        read: (bytes, offset)=>{
            const array = [];
            if (typeof size === "object" && bytes.slice(offset).length === 0) return [
                array,
                offset
            ];
            if (size === "remainder") {
                while(offset < bytes.length){
                    const [value, newOffset2] = item.read(bytes, offset);
                    offset = newOffset2;
                    array.push(value);
                }
                return [
                    array,
                    offset
                ];
            }
            const [resolvedSize, newOffset] = typeof size === "number" ? [
                size,
                offset
            ] : size.read(bytes, offset);
            offset = newOffset;
            for(let i = 0; i < resolvedSize; i += 1){
                const [value, newOffset2] = item.read(bytes, offset);
                offset = newOffset2;
                array.push(value);
            }
            return [
                array,
                offset
            ];
        }
    });
}
function $7ef019fe080c77e0$export$8390591075c4b219(item, config = {}) {
    return (0, $b7d16e67857467bd$export$b88681b853abde79)($7ef019fe080c77e0$export$415199198053c0b(item, config), $7ef019fe080c77e0$export$9016038b2e3b0c2f(item, config));
}
function $7ef019fe080c77e0$var$computeArrayLikeCodecSize(size, itemSize) {
    if (typeof size !== "number") return null;
    if (size === 0) return 0;
    return itemSize === null ? null : itemSize * size;
}
function $7ef019fe080c77e0$export$f0392815667c42f2(size, config = {}) {
    const parsedConfig = typeof config === "boolean" ? {
        backward: config
    } : config;
    const backward = parsedConfig.backward ?? false;
    return (0, $b7d16e67857467bd$export$4e76eeb6df88c889)({
        fixedSize: size,
        write (value, bytes, offset) {
            const bytesToAdd = [];
            for(let i = 0; i < size; i += 1){
                let byte = 0;
                for(let j = 0; j < 8; j += 1){
                    const feature = Number(value[i * 8 + j] ?? 0);
                    byte |= feature << (backward ? j : 7 - j);
                }
                if (backward) bytesToAdd.unshift(byte);
                else bytesToAdd.push(byte);
            }
            bytes.set(bytesToAdd, offset);
            return size;
        }
    });
}
function $7ef019fe080c77e0$export$5b3f10dd092d835b(size, config = {}) {
    const parsedConfig = typeof config === "boolean" ? {
        backward: config
    } : config;
    const backward = parsedConfig.backward ?? false;
    return (0, $b7d16e67857467bd$export$f8c898e83b60faaa)({
        fixedSize: size,
        read (bytes, offset) {
            (0, $b7d16e67857467bd$export$4a981e7c9ed0b6bf)("bitArray", size, bytes, offset);
            const booleans = [];
            let slice = bytes.slice(offset, offset + size);
            slice = backward ? slice.reverse() : slice;
            slice.forEach((byte)=>{
                for(let i = 0; i < 8; i += 1)if (backward) {
                    booleans.push(Boolean(byte & 1));
                    byte >>= 1;
                } else {
                    booleans.push(Boolean(byte & 128));
                    byte <<= 1;
                }
            });
            return [
                booleans,
                offset + size
            ];
        }
    });
}
function $7ef019fe080c77e0$export$eb1097a7c4c3befd(size, config = {}) {
    return (0, $b7d16e67857467bd$export$b88681b853abde79)($7ef019fe080c77e0$export$f0392815667c42f2(size, config), $7ef019fe080c77e0$export$5b3f10dd092d835b(size, config));
}
function $7ef019fe080c77e0$export$4a518d3f98f842eb(config = {}) {
    const size = config.size ?? (0, $703c30ae641df6e2$export$dc9732115561fb4b)();
    (0, $b7d16e67857467bd$export$4e85b7423fd6bc55)(size);
    return (0, $b7d16e67857467bd$export$f33e4302ccbdfdf3)(size, (value)=>value ? 1 : 0);
}
function $7ef019fe080c77e0$export$43a73c742ad521e1(config = {}) {
    const size = config.size ?? (0, $703c30ae641df6e2$export$edadf68f5f1a8bc6)();
    (0, $b7d16e67857467bd$export$4e85b7423fd6bc55)(size);
    return (0, $b7d16e67857467bd$export$45b43a889ba2d4c0)(size, (value)=>Number(value) === 1);
}
function $7ef019fe080c77e0$export$3071f075392d1897(config = {}) {
    return (0, $b7d16e67857467bd$export$b88681b853abde79)($7ef019fe080c77e0$export$4a518d3f98f842eb(config), $7ef019fe080c77e0$export$43a73c742ad521e1(config));
}
function $7ef019fe080c77e0$export$636c51ad84d0674a(config = {}) {
    const size = config.size ?? "variable";
    const byteEncoder = (0, $b7d16e67857467bd$export$4e76eeb6df88c889)({
        getSizeFromValue: (value)=>value.length,
        write: (value, bytes, offset)=>{
            bytes.set(value, offset);
            return offset + value.length;
        }
    });
    if (size === "variable") return byteEncoder;
    if (typeof size === "number") return (0, $b7d16e67857467bd$export$7c45a7fca252a5a3)(byteEncoder, size);
    return (0, $b7d16e67857467bd$export$4e76eeb6df88c889)({
        getSizeFromValue: (value)=>(0, $b7d16e67857467bd$export$30f3257599397621)(value.length, size) + value.length,
        write: (value, bytes, offset)=>{
            offset = size.write(value.length, bytes, offset);
            return byteEncoder.write(value, bytes, offset);
        }
    });
}
function $7ef019fe080c77e0$export$b90e67818b1b3d45(config = {}) {
    const size = config.size ?? "variable";
    const byteDecoder = (0, $b7d16e67857467bd$export$f8c898e83b60faaa)({
        read: (bytes, offset)=>{
            const slice = bytes.slice(offset);
            return [
                slice,
                offset + slice.length
            ];
        }
    });
    if (size === "variable") return byteDecoder;
    if (typeof size === "number") return (0, $b7d16e67857467bd$export$55b1530b9f82bf3d)(byteDecoder, size);
    return (0, $b7d16e67857467bd$export$f8c898e83b60faaa)({
        read: (bytes, offset)=>{
            (0, $b7d16e67857467bd$export$bf929351331b7b89)("bytes", bytes, offset);
            const [lengthBigInt, lengthOffset] = size.read(bytes, offset);
            const length = Number(lengthBigInt);
            offset = lengthOffset;
            const contentBytes = bytes.slice(offset, offset + length);
            (0, $b7d16e67857467bd$export$4a981e7c9ed0b6bf)("bytes", length, contentBytes);
            const [value, contentOffset] = byteDecoder.read(contentBytes, 0);
            offset += contentOffset;
            return [
                value,
                offset
            ];
        }
    });
}
function $7ef019fe080c77e0$export$f3c2d67c19d09b74(config = {}) {
    return (0, $b7d16e67857467bd$export$b88681b853abde79)($7ef019fe080c77e0$export$636c51ad84d0674a(config), $7ef019fe080c77e0$export$b90e67818b1b3d45(config));
}
function $7ef019fe080c77e0$export$b7bab0bb6c91fbe9(variants, config = {}) {
    const prefix = config.size ?? (0, $703c30ae641df6e2$export$dc9732115561fb4b)();
    const fixedSize = $7ef019fe080c77e0$var$getDataEnumFixedSize(variants, prefix);
    return (0, $b7d16e67857467bd$export$4e76eeb6df88c889)({
        ...fixedSize !== null ? {
            fixedSize: fixedSize
        } : {
            getSizeFromValue: (variant)=>{
                const discriminator = $7ef019fe080c77e0$var$getVariantDiscriminator(variants, variant);
                const variantEncoder = variants[discriminator][1];
                return (0, $b7d16e67857467bd$export$30f3257599397621)(discriminator, prefix) + (0, $b7d16e67857467bd$export$30f3257599397621)(variant, variantEncoder);
            },
            maxSize: $7ef019fe080c77e0$var$getDataEnumMaxSize(variants, prefix)
        },
        write: (variant, bytes, offset)=>{
            const discriminator = $7ef019fe080c77e0$var$getVariantDiscriminator(variants, variant);
            offset = prefix.write(discriminator, bytes, offset);
            const variantEncoder = variants[discriminator][1];
            return variantEncoder.write(variant, bytes, offset);
        }
    });
}
function $7ef019fe080c77e0$export$9cf3b180fc535fb1(variants, config = {}) {
    const prefix = config.size ?? (0, $703c30ae641df6e2$export$edadf68f5f1a8bc6)();
    const fixedSize = $7ef019fe080c77e0$var$getDataEnumFixedSize(variants, prefix);
    return (0, $b7d16e67857467bd$export$f8c898e83b60faaa)({
        ...fixedSize !== null ? {
            fixedSize: fixedSize
        } : {
            maxSize: $7ef019fe080c77e0$var$getDataEnumMaxSize(variants, prefix)
        },
        read: (bytes, offset)=>{
            (0, $b7d16e67857467bd$export$bf929351331b7b89)("dataEnum", bytes, offset);
            const [discriminator, dOffset] = prefix.read(bytes, offset);
            offset = dOffset;
            const variantField = variants[Number(discriminator)] ?? null;
            if (!variantField) throw new (0, $ccf386126da6a5ec$export$8349fd9adaaed269)((0, $ccf386126da6a5ec$export$1fa107ead8489cf2), {
                discriminator: discriminator,
                maxRange: variants.length - 1,
                minRange: 0
            });
            const [variant, vOffset] = variantField[1].read(bytes, offset);
            offset = vOffset;
            return [
                {
                    __kind: variantField[0],
                    ...variant ?? {}
                },
                offset
            ];
        }
    });
}
function $7ef019fe080c77e0$export$e076362323986828(variants, config = {}) {
    return (0, $b7d16e67857467bd$export$b88681b853abde79)($7ef019fe080c77e0$export$b7bab0bb6c91fbe9(variants, config), $7ef019fe080c77e0$export$9cf3b180fc535fb1(variants, config));
}
function $7ef019fe080c77e0$var$getDataEnumFixedSize(variants, prefix) {
    if (variants.length === 0) return (0, $b7d16e67857467bd$export$f9d60229c95384d4)(prefix) ? prefix.fixedSize : null;
    if (!(0, $b7d16e67857467bd$export$f9d60229c95384d4)(variants[0][1])) return null;
    const variantSize = variants[0][1].fixedSize;
    const sameSizedVariants = variants.every((variant)=>(0, $b7d16e67857467bd$export$f9d60229c95384d4)(variant[1]) && variant[1].fixedSize === variantSize);
    if (!sameSizedVariants) return null;
    return (0, $b7d16e67857467bd$export$f9d60229c95384d4)(prefix) ? prefix.fixedSize + variantSize : null;
}
function $7ef019fe080c77e0$var$getDataEnumMaxSize(variants, prefix) {
    const maxVariantSize = $7ef019fe080c77e0$var$maxCodecSizes(variants.map(([, codec])=>$7ef019fe080c77e0$var$getMaxSize(codec)));
    return $7ef019fe080c77e0$var$sumCodecSizes([
        $7ef019fe080c77e0$var$getMaxSize(prefix),
        maxVariantSize
    ]) ?? void 0;
}
function $7ef019fe080c77e0$var$getVariantDiscriminator(variants, variant) {
    const discriminator = variants.findIndex(([key])=>variant.__kind === key);
    if (discriminator < 0) throw new (0, $ccf386126da6a5ec$export$8349fd9adaaed269)((0, $ccf386126da6a5ec$export$46bcb1e361ec5ed6), {
        value: variant.__kind,
        variants: variants.map(([key])=>key)
    });
    return discriminator;
}
function $7ef019fe080c77e0$export$6b19a6a85541fd99(items) {
    const fixedSize = $7ef019fe080c77e0$var$sumCodecSizes(items.map($7ef019fe080c77e0$var$getFixedSize));
    const maxSize = $7ef019fe080c77e0$var$sumCodecSizes(items.map($7ef019fe080c77e0$var$getMaxSize)) ?? void 0;
    return (0, $b7d16e67857467bd$export$4e76eeb6df88c889)({
        ...fixedSize === null ? {
            getSizeFromValue: (value)=>items.map((item, index)=>(0, $b7d16e67857467bd$export$30f3257599397621)(value[index], item)).reduce((all, one)=>all + one, 0),
            maxSize: maxSize
        } : {
            fixedSize: fixedSize
        },
        write: (value, bytes, offset)=>{
            $7ef019fe080c77e0$export$1e6cff54ac72b1a3("tuple", items.length, value.length);
            items.forEach((item, index)=>{
                offset = item.write(value[index], bytes, offset);
            });
            return offset;
        }
    });
}
function $7ef019fe080c77e0$export$9800955a9fcaec5(items) {
    const fixedSize = $7ef019fe080c77e0$var$sumCodecSizes(items.map($7ef019fe080c77e0$var$getFixedSize));
    const maxSize = $7ef019fe080c77e0$var$sumCodecSizes(items.map($7ef019fe080c77e0$var$getMaxSize)) ?? void 0;
    return (0, $b7d16e67857467bd$export$f8c898e83b60faaa)({
        ...fixedSize === null ? {
            maxSize: maxSize
        } : {
            fixedSize: fixedSize
        },
        read: (bytes, offset)=>{
            const values = [];
            items.forEach((item)=>{
                const [newValue, newOffset] = item.read(bytes, offset);
                values.push(newValue);
                offset = newOffset;
            });
            return [
                values,
                offset
            ];
        }
    });
}
function $7ef019fe080c77e0$export$dc2491d24b0f7b51(items) {
    return (0, $b7d16e67857467bd$export$b88681b853abde79)($7ef019fe080c77e0$export$6b19a6a85541fd99(items), $7ef019fe080c77e0$export$9800955a9fcaec5(items));
}
// src/map.ts
function $7ef019fe080c77e0$export$75c3a7c49a778905(key, value, config = {}) {
    return (0, $b7d16e67857467bd$export$f33e4302ccbdfdf3)($7ef019fe080c77e0$export$415199198053c0b($7ef019fe080c77e0$export$6b19a6a85541fd99([
        key,
        value
    ]), config), (map)=>[
            ...map.entries()
        ]);
}
function $7ef019fe080c77e0$export$e102943539f62962(key, value, config = {}) {
    return (0, $b7d16e67857467bd$export$45b43a889ba2d4c0)($7ef019fe080c77e0$export$9016038b2e3b0c2f($7ef019fe080c77e0$export$9800955a9fcaec5([
        key,
        value
    ]), config), (entries)=>new Map(entries));
}
function $7ef019fe080c77e0$export$191db844d92ad593(key, value, config = {}) {
    return (0, $b7d16e67857467bd$export$b88681b853abde79)($7ef019fe080c77e0$export$75c3a7c49a778905(key, value, config), $7ef019fe080c77e0$export$e102943539f62962(key, value, config));
}
function $7ef019fe080c77e0$export$b0dc66f9f6de624b(item, config = {}) {
    const prefix = config.prefix ?? (0, $703c30ae641df6e2$export$dc9732115561fb4b)();
    const fixed = config.fixed ?? false;
    const isZeroSizeItem = (0, $b7d16e67857467bd$export$f9d60229c95384d4)(item) && (0, $b7d16e67857467bd$export$f9d60229c95384d4)(prefix) && item.fixedSize === 0;
    if (fixed || isZeroSizeItem) {
        (0, $b7d16e67857467bd$export$4e85b7423fd6bc55)(item);
        (0, $b7d16e67857467bd$export$4e85b7423fd6bc55)(prefix);
        const fixedSize = prefix.fixedSize + item.fixedSize;
        return (0, $b7d16e67857467bd$export$4e76eeb6df88c889)({
            fixedSize: fixedSize,
            write: (option, bytes, offset)=>{
                const prefixOffset = prefix.write(Number(option !== null), bytes, offset);
                if (option !== null) item.write(option, bytes, prefixOffset);
                return offset + fixedSize;
            }
        });
    }
    return (0, $b7d16e67857467bd$export$4e76eeb6df88c889)({
        getSizeFromValue: (option)=>(0, $b7d16e67857467bd$export$30f3257599397621)(Number(option !== null), prefix) + (option !== null ? (0, $b7d16e67857467bd$export$30f3257599397621)(option, item) : 0),
        maxSize: $7ef019fe080c77e0$var$sumCodecSizes([
            prefix,
            item
        ].map($7ef019fe080c77e0$var$getMaxSize)) ?? void 0,
        write: (option, bytes, offset)=>{
            offset = prefix.write(Number(option !== null), bytes, offset);
            if (option !== null) offset = item.write(option, bytes, offset);
            return offset;
        }
    });
}
function $7ef019fe080c77e0$export$320bb1c6ae316289(item, config = {}) {
    const prefix = config.prefix ?? (0, $703c30ae641df6e2$export$edadf68f5f1a8bc6)();
    const fixed = config.fixed ?? false;
    let fixedSize = null;
    const isZeroSizeItem = (0, $b7d16e67857467bd$export$f9d60229c95384d4)(item) && (0, $b7d16e67857467bd$export$f9d60229c95384d4)(prefix) && item.fixedSize === 0;
    if (fixed || isZeroSizeItem) {
        (0, $b7d16e67857467bd$export$4e85b7423fd6bc55)(item);
        (0, $b7d16e67857467bd$export$4e85b7423fd6bc55)(prefix);
        fixedSize = prefix.fixedSize + item.fixedSize;
    }
    return (0, $b7d16e67857467bd$export$f8c898e83b60faaa)({
        ...fixedSize === null ? {
            maxSize: $7ef019fe080c77e0$var$sumCodecSizes([
                prefix,
                item
            ].map($7ef019fe080c77e0$var$getMaxSize)) ?? void 0
        } : {
            fixedSize: fixedSize
        },
        read: (bytes, offset)=>{
            if (bytes.length - offset <= 0) return [
                null,
                offset
            ];
            const [isSome, prefixOffset] = prefix.read(bytes, offset);
            if (isSome === 0) return [
                null,
                fixedSize !== null ? offset + fixedSize : prefixOffset
            ];
            const [value, newOffset] = item.read(bytes, prefixOffset);
            return [
                value,
                fixedSize !== null ? offset + fixedSize : newOffset
            ];
        }
    });
}
function $7ef019fe080c77e0$export$ac13939aa9a57a06(item, config = {}) {
    const configCast = config;
    return (0, $b7d16e67857467bd$export$b88681b853abde79)($7ef019fe080c77e0$export$b0dc66f9f6de624b(item, configCast), $7ef019fe080c77e0$export$320bb1c6ae316289(item, configCast));
}
function $7ef019fe080c77e0$export$b851c0039bae17a3(constructor, config = {}) {
    const prefix = config.size ?? (0, $703c30ae641df6e2$export$dc9732115561fb4b)();
    const { minRange: minRange, maxRange: maxRange, allStringInputs: allStringInputs, enumKeys: enumKeys, enumValues: enumValues } = $7ef019fe080c77e0$var$getScalarEnumStats(constructor);
    return (0, $b7d16e67857467bd$export$f33e4302ccbdfdf3)(prefix, (value)=>{
        const isInvalidNumber = typeof value === "number" && (value < minRange || value > maxRange);
        const isInvalidString = typeof value === "string" && !allStringInputs.includes(value);
        if (isInvalidNumber || isInvalidString) throw new (0, $ccf386126da6a5ec$export$8349fd9adaaed269)((0, $ccf386126da6a5ec$export$ae8f95254b95c938), {
            maxRange: maxRange,
            minRange: minRange,
            value: value,
            variants: allStringInputs
        });
        if (typeof value === "number") return value;
        const valueIndex = enumValues.indexOf(value);
        if (valueIndex >= 0) return valueIndex;
        return enumKeys.indexOf(value);
    });
}
function $7ef019fe080c77e0$export$8da56cb51c791874(constructor, config = {}) {
    const prefix = config.size ?? (0, $703c30ae641df6e2$export$edadf68f5f1a8bc6)();
    const { minRange: minRange, maxRange: maxRange, enumKeys: enumKeys } = $7ef019fe080c77e0$var$getScalarEnumStats(constructor);
    return (0, $b7d16e67857467bd$export$45b43a889ba2d4c0)(prefix, (value)=>{
        const valueAsNumber = Number(value);
        if (valueAsNumber < minRange || valueAsNumber > maxRange) throw new (0, $ccf386126da6a5ec$export$8349fd9adaaed269)((0, $ccf386126da6a5ec$export$1fa107ead8489cf2), {
            discriminator: valueAsNumber,
            maxRange: maxRange,
            minRange: minRange
        });
        return constructor[enumKeys[valueAsNumber]];
    });
}
function $7ef019fe080c77e0$export$5f12d67506fd387e(constructor, config = {}) {
    return (0, $b7d16e67857467bd$export$b88681b853abde79)($7ef019fe080c77e0$export$b851c0039bae17a3(constructor, config), $7ef019fe080c77e0$export$8da56cb51c791874(constructor, config));
}
function $7ef019fe080c77e0$var$getScalarEnumStats(constructor) {
    const numericValues = Object.values(constructor).filter((v)=>typeof v === "number");
    const deduplicatedConstructor = Object.fromEntries(Object.entries(constructor).slice(numericValues.length));
    const enumKeys = Object.keys(deduplicatedConstructor);
    const enumValues = Object.values(deduplicatedConstructor);
    const minRange = 0;
    const maxRange = enumValues.length - 1;
    const allStringInputs = [
        .../* @__PURE__ */ new Set([
            ...enumKeys,
            ...enumValues.filter((v)=>typeof v === "string")
        ])
    ];
    return {
        allStringInputs: allStringInputs,
        enumKeys: enumKeys,
        enumValues: enumValues,
        maxRange: maxRange,
        minRange: minRange
    };
}
function $7ef019fe080c77e0$export$b5f13ff6baa9ba6c(item, config = {}) {
    return (0, $b7d16e67857467bd$export$f33e4302ccbdfdf3)($7ef019fe080c77e0$export$415199198053c0b(item, config), (set)=>[
            ...set
        ]);
}
function $7ef019fe080c77e0$export$b5164526d93d52f2(item, config = {}) {
    return (0, $b7d16e67857467bd$export$45b43a889ba2d4c0)($7ef019fe080c77e0$export$9016038b2e3b0c2f(item, config), (entries)=>new Set(entries));
}
function $7ef019fe080c77e0$export$a7c6e50519818c5d(item, config = {}) {
    return (0, $b7d16e67857467bd$export$b88681b853abde79)($7ef019fe080c77e0$export$b5f13ff6baa9ba6c(item, config), $7ef019fe080c77e0$export$b5164526d93d52f2(item, config));
}
function $7ef019fe080c77e0$export$64024546a32014b8(fields) {
    const fieldCodecs = fields.map(([, codec])=>codec);
    const fixedSize = $7ef019fe080c77e0$var$sumCodecSizes(fieldCodecs.map($7ef019fe080c77e0$var$getFixedSize));
    const maxSize = $7ef019fe080c77e0$var$sumCodecSizes(fieldCodecs.map($7ef019fe080c77e0$var$getMaxSize)) ?? void 0;
    return (0, $b7d16e67857467bd$export$4e76eeb6df88c889)({
        ...fixedSize === null ? {
            getSizeFromValue: (value)=>fields.map(([key, codec])=>(0, $b7d16e67857467bd$export$30f3257599397621)(value[key], codec)).reduce((all, one)=>all + one, 0),
            maxSize: maxSize
        } : {
            fixedSize: fixedSize
        },
        write: (struct, bytes, offset)=>{
            fields.forEach(([key, codec])=>{
                offset = codec.write(struct[key], bytes, offset);
            });
            return offset;
        }
    });
}
function $7ef019fe080c77e0$export$7070fbe048971470(fields) {
    const fieldCodecs = fields.map(([, codec])=>codec);
    const fixedSize = $7ef019fe080c77e0$var$sumCodecSizes(fieldCodecs.map($7ef019fe080c77e0$var$getFixedSize));
    const maxSize = $7ef019fe080c77e0$var$sumCodecSizes(fieldCodecs.map($7ef019fe080c77e0$var$getMaxSize)) ?? void 0;
    return (0, $b7d16e67857467bd$export$f8c898e83b60faaa)({
        ...fixedSize === null ? {
            maxSize: maxSize
        } : {
            fixedSize: fixedSize
        },
        read: (bytes, offset)=>{
            const struct = {};
            fields.forEach(([key, codec])=>{
                const [value, newOffset] = codec.read(bytes, offset);
                offset = newOffset;
                struct[key] = value;
            });
            return [
                struct,
                offset
            ];
        }
    });
}
function $7ef019fe080c77e0$export$e7bbe4696420bde8(fields) {
    return (0, $b7d16e67857467bd$export$b88681b853abde79)($7ef019fe080c77e0$export$64024546a32014b8(fields), $7ef019fe080c77e0$export$7070fbe048971470(fields));
}
function $7ef019fe080c77e0$export$a222f4a6d9205421() {
    return (0, $b7d16e67857467bd$export$4e76eeb6df88c889)({
        fixedSize: 0,
        write: (_value, _bytes, offset)=>offset
    });
}
function $7ef019fe080c77e0$export$46a76d99d5c61218() {
    return (0, $b7d16e67857467bd$export$f8c898e83b60faaa)({
        fixedSize: 0,
        read: (_bytes, offset)=>[
                void 0,
                offset
            ]
    });
}
function $7ef019fe080c77e0$export$68459b38e676038a() {
    return (0, $b7d16e67857467bd$export$b88681b853abde79)($7ef019fe080c77e0$export$a222f4a6d9205421(), $7ef019fe080c77e0$export$46a76d99d5c61218());
}
 //# sourceMappingURL=out.js.map


const $e4d86a8dcbc4f491$var$tokenGroupMemberCodec = (0, $7ef019fe080c77e0$export$e7bbe4696420bde8)([
    [
        "mint",
        (0, $7ef019fe080c77e0$export$f3c2d67c19d09b74)({
            size: 32
        })
    ],
    [
        "group",
        (0, $7ef019fe080c77e0$export$f3c2d67c19d09b74)({
            size: 32
        })
    ],
    [
        "memberNumber",
        (0, $703c30ae641df6e2$export$172bf721fe9bbfd1)()
    ]
]);
const $e4d86a8dcbc4f491$export$922ab442b9cf73bd = $e4d86a8dcbc4f491$var$tokenGroupMemberCodec.fixedSize;
function $e4d86a8dcbc4f491$export$57f8603c3835e979(member) {
    return $e4d86a8dcbc4f491$var$tokenGroupMemberCodec.encode({
        mint: member.mint.toBuffer(),
        group: member.group.toBuffer(),
        memberNumber: member.memberNumber
    });
}
function $e4d86a8dcbc4f491$export$1724e5edf41d9e41(buffer) {
    const data = $e4d86a8dcbc4f491$var$tokenGroupMemberCodec.decode(buffer);
    return {
        mint: new (0, $ca3473265f76df98$export$ca8b6604d6ce14de)(data.mint),
        group: new (0, $ca3473265f76df98$export$ca8b6604d6ce14de)(data.group),
        memberNumber: data.memberNumber
    };
}



const $2f5d8c442257c5b8$var$tokenGroupCodec = (0, $7ef019fe080c77e0$export$e7bbe4696420bde8)([
    [
        "updateAuthority",
        (0, $7ef019fe080c77e0$export$f3c2d67c19d09b74)({
            size: 32
        })
    ],
    [
        "mint",
        (0, $7ef019fe080c77e0$export$f3c2d67c19d09b74)({
            size: 32
        })
    ],
    [
        "size",
        (0, $703c30ae641df6e2$export$172bf721fe9bbfd1)()
    ],
    [
        "maxSize",
        (0, $703c30ae641df6e2$export$172bf721fe9bbfd1)()
    ]
]);
const $2f5d8c442257c5b8$export$83b408df29875efc = $2f5d8c442257c5b8$var$tokenGroupCodec.fixedSize;
// Checks if all elements in the array are 0
function $2f5d8c442257c5b8$var$isNonePubkey(buffer) {
    for(let i = 0; i < buffer.length; i++){
        if (buffer[i] !== 0) return false;
    }
    return true;
}
function $2f5d8c442257c5b8$export$861b848ad534e6d5(group) {
    // If no updateAuthority given, set it to the None/Zero PublicKey for encoding
    const updateAuthority = group.updateAuthority ?? (0, $ca3473265f76df98$export$ca8b6604d6ce14de).default;
    return $2f5d8c442257c5b8$var$tokenGroupCodec.encode({
        updateAuthority: updateAuthority.toBuffer(),
        mint: group.mint.toBuffer(),
        size: group.size,
        maxSize: group.maxSize
    });
}
function $2f5d8c442257c5b8$export$28d9c2954cb7f24e(buffer) {
    const data = $2f5d8c442257c5b8$var$tokenGroupCodec.decode(buffer);
    return $2f5d8c442257c5b8$var$isNonePubkey(data.updateAuthority) ? {
        mint: new (0, $ca3473265f76df98$export$ca8b6604d6ce14de)(data.mint),
        size: data.size,
        maxSize: data.maxSize
    } : {
        updateAuthority: new (0, $ca3473265f76df98$export$ca8b6604d6ce14de)(data.updateAuthority),
        mint: new (0, $ca3473265f76df98$export$ca8b6604d6ce14de)(data.mint),
        size: data.size,
        maxSize: data.maxSize
    };
}






const $ad5343a9ccc69285$export$b9dda2426c86a44d = (0, $ab8b5713b1ee9109$exports.struct)([
    (0, $622167bc200b6540$export$86f13247979de5d7)("authority"),
    (0, $622167bc200b6540$export$86f13247979de5d7)("memberAddress")
]);
const $ad5343a9ccc69285$export$f4d582c48d8cc7e7 = $ad5343a9ccc69285$export$b9dda2426c86a44d.span;
function $ad5343a9ccc69285$export$5562dfc68f7b75f4(mint) {
    const extensionData = (0, $a05dc5f3bc940692$export$4fff3ed4eba4f4ee)((0, $a05dc5f3bc940692$export$4f037c6ec2da4eeb).GroupMemberPointer, mint.tlvData);
    if (extensionData !== null) {
        const { authority: authority, memberAddress: memberAddress } = $ad5343a9ccc69285$export$b9dda2426c86a44d.decode(extensionData);
        // Explicitly set None/Zero keys to null
        return {
            authority: authority.equals((0, $ca3473265f76df98$export$ca8b6604d6ce14de).default) ? null : authority,
            memberAddress: memberAddress.equals((0, $ca3473265f76df98$export$ca8b6604d6ce14de).default) ? null : memberAddress
        };
    } else return null;
}






const $49a812e814cde6fd$export$511631140e2874fe = (0, $ab8b5713b1ee9109$exports.struct)([
    (0, $622167bc200b6540$export$86f13247979de5d7)("authority"),
    (0, $622167bc200b6540$export$86f13247979de5d7)("groupAddress")
]);
const $49a812e814cde6fd$export$3852a2b4ecb1c96c = $49a812e814cde6fd$export$511631140e2874fe.span;
function $49a812e814cde6fd$export$9dc2a030696ac8a7(mint) {
    const extensionData = (0, $a05dc5f3bc940692$export$4fff3ed4eba4f4ee)((0, $a05dc5f3bc940692$export$4f037c6ec2da4eeb).GroupPointer, mint.tlvData);
    if (extensionData !== null) {
        const { authority: authority, groupAddress: groupAddress } = $49a812e814cde6fd$export$511631140e2874fe.decode(extensionData);
        // Explicitly set None/Zero keys to null
        return {
            authority: authority.equals((0, $ca3473265f76df98$export$ca8b6604d6ce14de).default) ? null : authority,
            groupAddress: groupAddress.equals((0, $ca3473265f76df98$export$ca8b6604d6ce14de).default) ? null : groupAddress
        };
    } else return null;
}




const $7b14beb802d300a7$export$3b7e34eff13c869c = (0, $ab8b5713b1ee9109$exports.struct)([]);
const $7b14beb802d300a7$export$4ba1dedcafaef535 = $7b14beb802d300a7$export$3b7e34eff13c869c.span;
function $7b14beb802d300a7$export$ff9fc6dae6f7d7a0(account) {
    const extensionData = (0, $a05dc5f3bc940692$export$4fff3ed4eba4f4ee)((0, $a05dc5f3bc940692$export$4f037c6ec2da4eeb).ImmutableOwner, account.tlvData);
    if (extensionData !== null) return $7b14beb802d300a7$export$3b7e34eff13c869c.decode(extensionData);
    else return null;
}





const $a2dcb1e781b79f04$export$dea2930f2b4b5995 = (0, $ab8b5713b1ee9109$exports.struct)([
    (0, $622167bc200b6540$export$86f13247979de5d7)("rateAuthority"),
    (0, $ab8b5713b1ee9109$exports.ns64)("initializationTimestamp"),
    (0, $ab8b5713b1ee9109$exports.s16)("preUpdateAverageRate"),
    (0, $ab8b5713b1ee9109$exports.ns64)("lastUpdateTimestamp"),
    (0, $ab8b5713b1ee9109$exports.s16)("currentRate")
]);
const $a2dcb1e781b79f04$export$5deaa22b862a446f = $a2dcb1e781b79f04$export$dea2930f2b4b5995.span;
function $a2dcb1e781b79f04$export$c0f4cb585bb22702(mint) {
    const extensionData = (0, $a05dc5f3bc940692$export$4fff3ed4eba4f4ee)((0, $a05dc5f3bc940692$export$4f037c6ec2da4eeb).InterestBearingConfig, mint.tlvData);
    if (extensionData !== null) return $a2dcb1e781b79f04$export$dea2930f2b4b5995.decode(extensionData);
    return null;
}





const $b93daecec663aea7$export$5607c4289fc50398 = (0, $ab8b5713b1ee9109$exports.struct)([
    (0, $8f00f9d827a09685$export$87b259aa03e3d267)("requireIncomingTransferMemos")
]);
const $b93daecec663aea7$export$f4b5375ad34477a1 = $b93daecec663aea7$export$5607c4289fc50398.span;
function $b93daecec663aea7$export$3f4bed2e631f122c(account) {
    const extensionData = (0, $a05dc5f3bc940692$export$4fff3ed4eba4f4ee)((0, $a05dc5f3bc940692$export$4f037c6ec2da4eeb).MemoTransfer, account.tlvData);
    if (extensionData !== null) return $b93daecec663aea7$export$5607c4289fc50398.decode(extensionData);
    else return null;
}






const $9051af2aea644334$export$4dfd642335bea3f4 = (0, $ab8b5713b1ee9109$exports.struct)([
    (0, $622167bc200b6540$export$86f13247979de5d7)("authority"),
    (0, $622167bc200b6540$export$86f13247979de5d7)("metadataAddress")
]);
const $9051af2aea644334$export$46bfcd668f9095d0 = $9051af2aea644334$export$4dfd642335bea3f4.span;
function $9051af2aea644334$export$eef22d421b9622d(mint) {
    const extensionData = (0, $a05dc5f3bc940692$export$4fff3ed4eba4f4ee)((0, $a05dc5f3bc940692$export$4f037c6ec2da4eeb).MetadataPointer, mint.tlvData);
    if (extensionData !== null) {
        const { authority: authority, metadataAddress: metadataAddress } = $9051af2aea644334$export$4dfd642335bea3f4.decode(extensionData);
        // Explicitly set None/Zero keys to null
        return {
            authority: authority.equals((0, $ca3473265f76df98$export$ca8b6604d6ce14de).default) ? null : authority,
            metadataAddress: metadataAddress.equals((0, $ca3473265f76df98$export$ca8b6604d6ce14de).default) ? null : metadataAddress
        };
    } else return null;
}





const $7e048dba97f175be$export$ece081d471f0fc95 = (0, $ab8b5713b1ee9109$exports.struct)([
    (0, $622167bc200b6540$export$86f13247979de5d7)("closeAuthority")
]);
const $7e048dba97f175be$export$1e1aa83bde32eb68 = $7e048dba97f175be$export$ece081d471f0fc95.span;
function $7e048dba97f175be$export$bfd41dfeb5917197(mint) {
    const extensionData = (0, $a05dc5f3bc940692$export$4fff3ed4eba4f4ee)((0, $a05dc5f3bc940692$export$4f037c6ec2da4eeb).MintCloseAuthority, mint.tlvData);
    if (extensionData !== null) return $7e048dba97f175be$export$ece081d471f0fc95.decode(extensionData);
    else return null;
}




const $e864166bb93d10f8$export$bae9d70f4fd33725 = (0, $ab8b5713b1ee9109$exports.struct)([]);
const $e864166bb93d10f8$export$31a113d46d052efb = $e864166bb93d10f8$export$bae9d70f4fd33725.span;
const $e864166bb93d10f8$export$91a6e2e8798d2502 = $e864166bb93d10f8$export$bae9d70f4fd33725.span;
function $e864166bb93d10f8$export$718a9bb289be2420(mint) {
    const extensionData = (0, $a05dc5f3bc940692$export$4fff3ed4eba4f4ee)((0, $a05dc5f3bc940692$export$4f037c6ec2da4eeb).NonTransferable, mint.tlvData);
    if (extensionData !== null) return $e864166bb93d10f8$export$bae9d70f4fd33725.decode(extensionData);
    else return null;
}
function $e864166bb93d10f8$export$a8f1f408ee730236(account) {
    const extensionData = (0, $a05dc5f3bc940692$export$4fff3ed4eba4f4ee)((0, $a05dc5f3bc940692$export$4f037c6ec2da4eeb).NonTransferableAccount, account.tlvData);
    if (extensionData !== null) return $e864166bb93d10f8$export$bae9d70f4fd33725.decode(extensionData);
    else return null;
}





const $b4ec99a91d359502$export$1d6e8e6f44705001 = (0, $ab8b5713b1ee9109$exports.struct)([
    (0, $622167bc200b6540$export$86f13247979de5d7)("delegate")
]);
const $b4ec99a91d359502$export$636ea2373b6c6b7d = $b4ec99a91d359502$export$1d6e8e6f44705001.span;
function $b4ec99a91d359502$export$3d161872832356b0(mint) {
    const extensionData = (0, $a05dc5f3bc940692$export$4fff3ed4eba4f4ee)((0, $a05dc5f3bc940692$export$4f037c6ec2da4eeb).PermanentDelegate, mint.tlvData);
    if (extensionData !== null) return $b4ec99a91d359502$export$1d6e8e6f44705001.decode(extensionData);
    else return null;
}





const $6c567b2209deb5b8$export$7bf230db5a769018 = 10000;
const $6c567b2209deb5b8$export$8a34ad2d496101b6 = BigInt($6c567b2209deb5b8$export$7bf230db5a769018);
function $6c567b2209deb5b8$export$35e5691ab3997dac(property) {
    return (0, $ab8b5713b1ee9109$exports.struct)([
        (0, $3b2d1baa52a31e71$export$cd1442401e54cffa)("epoch"),
        (0, $3b2d1baa52a31e71$export$cd1442401e54cffa)("maximumFee"),
        (0, $ab8b5713b1ee9109$exports.u16)("transferFeeBasisPoints")
    ], property);
}
function $6c567b2209deb5b8$export$8c3f5e003a1e38c7(transferFee, preFeeAmount) {
    const transferFeeBasisPoints = transferFee.transferFeeBasisPoints;
    if (transferFeeBasisPoints === 0 || preFeeAmount === BigInt(0)) return BigInt(0);
    else {
        const numerator = preFeeAmount * BigInt(transferFeeBasisPoints);
        const rawFee = (numerator + $6c567b2209deb5b8$export$8a34ad2d496101b6 - BigInt(1)) / $6c567b2209deb5b8$export$8a34ad2d496101b6;
        const fee = rawFee > transferFee.maximumFee ? transferFee.maximumFee : rawFee;
        return BigInt(fee);
    }
}
const $6c567b2209deb5b8$export$c849e8e6e4ae7e4b = (0, $ab8b5713b1ee9109$exports.struct)([
    (0, $622167bc200b6540$export$86f13247979de5d7)("transferFeeConfigAuthority"),
    (0, $622167bc200b6540$export$86f13247979de5d7)("withdrawWithheldAuthority"),
    (0, $3b2d1baa52a31e71$export$cd1442401e54cffa)("withheldAmount"),
    $6c567b2209deb5b8$export$35e5691ab3997dac("olderTransferFee"),
    $6c567b2209deb5b8$export$35e5691ab3997dac("newerTransferFee")
]);
const $6c567b2209deb5b8$export$972cf5dcc13158da = $6c567b2209deb5b8$export$c849e8e6e4ae7e4b.span;
function $6c567b2209deb5b8$export$2e57a339fb6e8894(transferFeeConfig, epoch) {
    if (epoch >= transferFeeConfig.newerTransferFee.epoch) return transferFeeConfig.newerTransferFee;
    else return transferFeeConfig.olderTransferFee;
}
function $6c567b2209deb5b8$export$c8f0c7e4622306bc(transferFeeConfig, epoch, preFeeAmount) {
    const transferFee = $6c567b2209deb5b8$export$2e57a339fb6e8894(transferFeeConfig, epoch);
    return $6c567b2209deb5b8$export$8c3f5e003a1e38c7(transferFee, preFeeAmount);
}
const $6c567b2209deb5b8$export$a20fb363192b96a2 = (0, $ab8b5713b1ee9109$exports.struct)([
    (0, $3b2d1baa52a31e71$export$cd1442401e54cffa)("withheldAmount")
]);
const $6c567b2209deb5b8$export$8657a852ae4f4019 = $6c567b2209deb5b8$export$a20fb363192b96a2.span;
function $6c567b2209deb5b8$export$451dabe4cdde5d9a(mint) {
    const extensionData = (0, $a05dc5f3bc940692$export$4fff3ed4eba4f4ee)((0, $a05dc5f3bc940692$export$4f037c6ec2da4eeb).TransferFeeConfig, mint.tlvData);
    if (extensionData !== null) return $6c567b2209deb5b8$export$c849e8e6e4ae7e4b.decode(extensionData);
    else return null;
}
function $6c567b2209deb5b8$export$857f13d8ce75ecd9(account) {
    const extensionData = (0, $a05dc5f3bc940692$export$4fff3ed4eba4f4ee)((0, $a05dc5f3bc940692$export$4f037c6ec2da4eeb).TransferFeeAmount, account.tlvData);
    if (extensionData !== null) return $6c567b2209deb5b8$export$a20fb363192b96a2.decode(extensionData);
    else return null;
}









var $6f61fdd68c2de82f$require$Buffer = $1ff5f276bd1e09e8$export$a143d493d941bafc;
const $6f61fdd68c2de82f$var$DISCRIMINATOR_SPAN = 1;
const $6f61fdd68c2de82f$var$LITERAL_LENGTH_SPAN = 1;
const $6f61fdd68c2de82f$var$INSTRUCTION_ARG_OFFSET_SPAN = 1;
const $6f61fdd68c2de82f$var$INSTRUCTION_ARG_LENGTH_SPAN = 1;
const $6f61fdd68c2de82f$var$ACCOUNT_KEY_INDEX_SPAN = 1;
const $6f61fdd68c2de82f$var$ACCOUNT_DATA_ACCOUNT_INDEX_SPAN = 1;
const $6f61fdd68c2de82f$var$ACCOUNT_DATA_OFFSET_SPAN = 1;
const $6f61fdd68c2de82f$var$ACCOUNT_DATA_LENGTH_SPAN = 1;
function $6f61fdd68c2de82f$var$unpackSeedLiteral(seeds) {
    if (seeds.length < 1) throw new (0, $8afd026bce6c5170$export$9fe40fd85b8108b)();
    const [length, ...rest] = seeds;
    if (rest.length < length) throw new (0, $8afd026bce6c5170$export$9fe40fd85b8108b)();
    return {
        data: $6f61fdd68c2de82f$require$Buffer.from(rest.slice(0, length)),
        packedLength: $6f61fdd68c2de82f$var$DISCRIMINATOR_SPAN + $6f61fdd68c2de82f$var$LITERAL_LENGTH_SPAN + length
    };
}
function $6f61fdd68c2de82f$var$unpackSeedInstructionArg(seeds, instructionData) {
    if (seeds.length < 2) throw new (0, $8afd026bce6c5170$export$9fe40fd85b8108b)();
    const [index, length] = seeds;
    if (instructionData.length < length + index) throw new (0, $8afd026bce6c5170$export$9fe40fd85b8108b)();
    return {
        data: instructionData.subarray(index, index + length),
        packedLength: $6f61fdd68c2de82f$var$DISCRIMINATOR_SPAN + $6f61fdd68c2de82f$var$INSTRUCTION_ARG_OFFSET_SPAN + $6f61fdd68c2de82f$var$INSTRUCTION_ARG_LENGTH_SPAN
    };
}
function $6f61fdd68c2de82f$var$unpackSeedAccountKey(seeds, previousMetas) {
    if (seeds.length < 1) throw new (0, $8afd026bce6c5170$export$9fe40fd85b8108b)();
    const [index] = seeds;
    if (previousMetas.length <= index) throw new (0, $8afd026bce6c5170$export$9fe40fd85b8108b)();
    return {
        data: previousMetas[index].pubkey.toBuffer(),
        packedLength: $6f61fdd68c2de82f$var$DISCRIMINATOR_SPAN + $6f61fdd68c2de82f$var$ACCOUNT_KEY_INDEX_SPAN
    };
}
async function $6f61fdd68c2de82f$var$unpackSeedAccountData(seeds, previousMetas, connection) {
    if (seeds.length < 3) throw new (0, $8afd026bce6c5170$export$9fe40fd85b8108b)();
    const [accountIndex, dataIndex, length] = seeds;
    if (previousMetas.length <= accountIndex) throw new (0, $8afd026bce6c5170$export$9fe40fd85b8108b)();
    const accountInfo = await connection.getAccountInfo(previousMetas[accountIndex].pubkey);
    if (accountInfo == null) throw new (0, $8afd026bce6c5170$export$de66998ed6d15b14)();
    if (accountInfo.data.length < dataIndex + length) throw new (0, $8afd026bce6c5170$export$9fe40fd85b8108b)();
    return {
        data: accountInfo.data.subarray(dataIndex, dataIndex + length),
        packedLength: $6f61fdd68c2de82f$var$DISCRIMINATOR_SPAN + $6f61fdd68c2de82f$var$ACCOUNT_DATA_ACCOUNT_INDEX_SPAN + $6f61fdd68c2de82f$var$ACCOUNT_DATA_OFFSET_SPAN + $6f61fdd68c2de82f$var$ACCOUNT_DATA_LENGTH_SPAN
    };
}
async function $6f61fdd68c2de82f$var$unpackFirstSeed(seeds, previousMetas, instructionData, connection) {
    const [discriminator, ...rest] = seeds;
    const remaining = new Uint8Array(rest);
    switch(discriminator){
        case 0:
            return null;
        case 1:
            return $6f61fdd68c2de82f$var$unpackSeedLiteral(remaining);
        case 2:
            return $6f61fdd68c2de82f$var$unpackSeedInstructionArg(remaining, instructionData);
        case 3:
            return $6f61fdd68c2de82f$var$unpackSeedAccountKey(remaining, previousMetas);
        case 4:
            return $6f61fdd68c2de82f$var$unpackSeedAccountData(remaining, previousMetas, connection);
        default:
            throw new (0, $8afd026bce6c5170$export$9fe40fd85b8108b)();
    }
}
async function $6f61fdd68c2de82f$export$e3c2327a8649c7d4(seeds, previousMetas, instructionData, connection) {
    const unpackedSeeds = [];
    let i = 0;
    while(i < 32){
        const seed = await $6f61fdd68c2de82f$var$unpackFirstSeed(seeds.slice(i), previousMetas, instructionData, connection);
        if (seed == null) break;
        unpackedSeeds.push(seed.data);
        i += seed.packedLength;
    }
    return unpackedSeeds;
}



var $53af0d1e03aa463b$require$Buffer = $1ff5f276bd1e09e8$export$a143d493d941bafc;
const $53af0d1e03aa463b$export$ce2e6042aff3c26e = (0, $ab8b5713b1ee9109$exports.struct)([
    (0, $622167bc200b6540$export$86f13247979de5d7)("authority"),
    (0, $622167bc200b6540$export$86f13247979de5d7)("programId")
]);
const $53af0d1e03aa463b$export$5ade3cdfd72ee348 = $53af0d1e03aa463b$export$ce2e6042aff3c26e.span;
function $53af0d1e03aa463b$export$eb429b5bab502847(mint) {
    const extensionData = (0, $a05dc5f3bc940692$export$4fff3ed4eba4f4ee)((0, $a05dc5f3bc940692$export$4f037c6ec2da4eeb).TransferHook, mint.tlvData);
    if (extensionData !== null) return $53af0d1e03aa463b$export$ce2e6042aff3c26e.decode(extensionData);
    else return null;
}
const $53af0d1e03aa463b$export$28d4d57b6bd1f0ec = (0, $ab8b5713b1ee9109$exports.struct)([
    (0, $8f00f9d827a09685$export$87b259aa03e3d267)("transferring")
]);
const $53af0d1e03aa463b$export$998fd74b23e70abd = $53af0d1e03aa463b$export$28d4d57b6bd1f0ec.span;
function $53af0d1e03aa463b$export$67421072ccffa447(account) {
    const extensionData = (0, $a05dc5f3bc940692$export$4fff3ed4eba4f4ee)((0, $a05dc5f3bc940692$export$4f037c6ec2da4eeb).TransferHookAccount, account.tlvData);
    if (extensionData !== null) return $53af0d1e03aa463b$export$28d4d57b6bd1f0ec.decode(extensionData);
    else return null;
}
function $53af0d1e03aa463b$export$92a7ba5e4a13b776(mint, programId) {
    const seeds = [
        $53af0d1e03aa463b$require$Buffer.from("extra-account-metas"),
        mint.toBuffer()
    ];
    return (0, $ca3473265f76df98$export$ca8b6604d6ce14de).findProgramAddressSync(seeds, programId)[0];
}
const $53af0d1e03aa463b$export$38015d717b952b07 = (0, $ab8b5713b1ee9109$exports.struct)([
    (0, $ab8b5713b1ee9109$exports.u8)("discriminator"),
    (0, $ab8b5713b1ee9109$exports.blob)(32, "addressConfig"),
    (0, $8f00f9d827a09685$export$87b259aa03e3d267)("isSigner"),
    (0, $8f00f9d827a09685$export$87b259aa03e3d267)("isWritable")
]);
const $53af0d1e03aa463b$export$547d3e194f2ec408 = (0, $ab8b5713b1ee9109$exports.struct)([
    (0, $ab8b5713b1ee9109$exports.u32)("count"),
    (0, $ab8b5713b1ee9109$exports.seq)($53af0d1e03aa463b$export$38015d717b952b07, (0, $ab8b5713b1ee9109$exports.greedy)($53af0d1e03aa463b$export$38015d717b952b07.span), "extraAccounts")
]);
const $53af0d1e03aa463b$export$e8f817468b384f2f = (0, $ab8b5713b1ee9109$exports.struct)([
    (0, $3b2d1baa52a31e71$export$cd1442401e54cffa)("instructionDiscriminator"),
    (0, $ab8b5713b1ee9109$exports.u32)("length"),
    $53af0d1e03aa463b$export$547d3e194f2ec408.replicate("extraAccountsList")
]);
function $53af0d1e03aa463b$export$b7fb7bf27b1d242(account) {
    const extraAccountsList = $53af0d1e03aa463b$export$e8f817468b384f2f.decode(account.data).extraAccountsList;
    return extraAccountsList.extraAccounts.slice(0, extraAccountsList.count);
}
async function $53af0d1e03aa463b$export$a538050d412c5646(connection, extraMeta, previousMetas, instructionData, transferHookProgramId) {
    if (extraMeta.discriminator === 0) return {
        pubkey: new (0, $ca3473265f76df98$export$ca8b6604d6ce14de)(extraMeta.addressConfig),
        isSigner: extraMeta.isSigner,
        isWritable: extraMeta.isWritable
    };
    let programId = (0, $ca3473265f76df98$export$ca8b6604d6ce14de).default;
    if (extraMeta.discriminator === 1) programId = transferHookProgramId;
    else {
        const accountIndex = extraMeta.discriminator - 128;
        if (previousMetas.length <= accountIndex) throw new (0, $8afd026bce6c5170$export$f515f489e4a79004)();
        programId = previousMetas[accountIndex].pubkey;
    }
    const seeds = await (0, $6f61fdd68c2de82f$export$e3c2327a8649c7d4)(extraMeta.addressConfig, previousMetas, instructionData, connection);
    const pubkey = (0, $ca3473265f76df98$export$ca8b6604d6ce14de).findProgramAddressSync(seeds, programId)[0];
    return {
        pubkey: pubkey,
        isSigner: extraMeta.isSigner,
        isWritable: extraMeta.isWritable
    };
}



var $a05dc5f3bc940692$export$4f037c6ec2da4eeb;
(function(ExtensionType) {
    ExtensionType[ExtensionType["Uninitialized"] = 0] = "Uninitialized";
    ExtensionType[ExtensionType["TransferFeeConfig"] = 1] = "TransferFeeConfig";
    ExtensionType[ExtensionType["TransferFeeAmount"] = 2] = "TransferFeeAmount";
    ExtensionType[ExtensionType["MintCloseAuthority"] = 3] = "MintCloseAuthority";
    ExtensionType[ExtensionType["ConfidentialTransferMint"] = 4] = "ConfidentialTransferMint";
    ExtensionType[ExtensionType["ConfidentialTransferAccount"] = 5] = "ConfidentialTransferAccount";
    ExtensionType[ExtensionType["DefaultAccountState"] = 6] = "DefaultAccountState";
    ExtensionType[ExtensionType["ImmutableOwner"] = 7] = "ImmutableOwner";
    ExtensionType[ExtensionType["MemoTransfer"] = 8] = "MemoTransfer";
    ExtensionType[ExtensionType["NonTransferable"] = 9] = "NonTransferable";
    ExtensionType[ExtensionType["InterestBearingConfig"] = 10] = "InterestBearingConfig";
    ExtensionType[ExtensionType["CpiGuard"] = 11] = "CpiGuard";
    ExtensionType[ExtensionType["PermanentDelegate"] = 12] = "PermanentDelegate";
    ExtensionType[ExtensionType["NonTransferableAccount"] = 13] = "NonTransferableAccount";
    ExtensionType[ExtensionType["TransferHook"] = 14] = "TransferHook";
    ExtensionType[ExtensionType["TransferHookAccount"] = 15] = "TransferHookAccount";
    // ConfidentialTransferFee, // Not implemented yet
    // ConfidentialTransferFeeAmount, // Not implemented yet
    ExtensionType[ExtensionType["MetadataPointer"] = 18] = "MetadataPointer";
    ExtensionType[ExtensionType["TokenMetadata"] = 19] = "TokenMetadata";
    ExtensionType[ExtensionType["GroupPointer"] = 20] = "GroupPointer";
    ExtensionType[ExtensionType["TokenGroup"] = 21] = "TokenGroup";
    ExtensionType[ExtensionType["GroupMemberPointer"] = 22] = "GroupMemberPointer";
    ExtensionType[ExtensionType["TokenGroupMember"] = 23] = "TokenGroupMember";
})($a05dc5f3bc940692$export$4f037c6ec2da4eeb || ($a05dc5f3bc940692$export$4f037c6ec2da4eeb = {}));
const $a05dc5f3bc940692$export$b60591f8709c84d6 = 2;
const $a05dc5f3bc940692$export$7ae242f656e23fe = 2;
function $a05dc5f3bc940692$var$addTypeAndLengthToLen(len) {
    return len + $a05dc5f3bc940692$export$b60591f8709c84d6 + $a05dc5f3bc940692$export$7ae242f656e23fe;
}
function $a05dc5f3bc940692$var$isVariableLengthExtension(e) {
    switch(e){
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.TokenMetadata:
            return true;
        default:
            return false;
    }
}
function $a05dc5f3bc940692$export$a83377bb2e8914d8(e) {
    switch(e){
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.Uninitialized:
            return 0;
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.TransferFeeConfig:
            return 0, $6c567b2209deb5b8$export$972cf5dcc13158da;
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.TransferFeeAmount:
            return 0, $6c567b2209deb5b8$export$8657a852ae4f4019;
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.MintCloseAuthority:
            return 0, $7e048dba97f175be$export$1e1aa83bde32eb68;
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.ConfidentialTransferMint:
            return 65;
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.ConfidentialTransferAccount:
            return 295;
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.CpiGuard:
            return 0, $fbaa73ec5701f5cf$export$2ad51e83460d1d03;
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.DefaultAccountState:
            return 0, $535fbf55534b09a8$export$2e3c876eadfda1ab;
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.ImmutableOwner:
            return 0, $7b14beb802d300a7$export$4ba1dedcafaef535;
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.MemoTransfer:
            return 0, $b93daecec663aea7$export$f4b5375ad34477a1;
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.MetadataPointer:
            return 0, $9051af2aea644334$export$46bfcd668f9095d0;
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.NonTransferable:
            return 0, $e864166bb93d10f8$export$31a113d46d052efb;
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.InterestBearingConfig:
            return 0, $a2dcb1e781b79f04$export$5deaa22b862a446f;
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.PermanentDelegate:
            return 0, $b4ec99a91d359502$export$636ea2373b6c6b7d;
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.NonTransferableAccount:
            return 0, $e864166bb93d10f8$export$91a6e2e8798d2502;
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.TransferHook:
            return 0, $53af0d1e03aa463b$export$5ade3cdfd72ee348;
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.TransferHookAccount:
            return 0, $53af0d1e03aa463b$export$998fd74b23e70abd;
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.GroupPointer:
            return 0, $49a812e814cde6fd$export$3852a2b4ecb1c96c;
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.GroupMemberPointer:
            return 0, $ad5343a9ccc69285$export$f4d582c48d8cc7e7;
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.TokenGroup:
            return 0, $2f5d8c442257c5b8$export$83b408df29875efc;
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.TokenGroupMember:
            return 0, $e4d86a8dcbc4f491$export$922ab442b9cf73bd;
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.TokenMetadata:
            throw Error(`Cannot get type length for variable extension type: ${e}`);
        default:
            throw Error(`Unknown extension type: ${e}`);
    }
}
function $a05dc5f3bc940692$export$bb78b607a215e9f6(e) {
    switch(e){
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.TransferFeeConfig:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.MintCloseAuthority:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.ConfidentialTransferMint:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.DefaultAccountState:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.NonTransferable:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.InterestBearingConfig:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.PermanentDelegate:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.TransferHook:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.MetadataPointer:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.TokenMetadata:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.GroupPointer:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.GroupMemberPointer:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.TokenGroup:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.TokenGroupMember:
            return true;
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.Uninitialized:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.TransferFeeAmount:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.ConfidentialTransferAccount:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.ImmutableOwner:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.MemoTransfer:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.CpiGuard:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.NonTransferableAccount:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.TransferHookAccount:
            return false;
        default:
            throw Error(`Unknown extension type: ${e}`);
    }
}
function $a05dc5f3bc940692$export$da3491d66fdbe926(e) {
    switch(e){
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.TransferFeeAmount:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.ConfidentialTransferAccount:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.ImmutableOwner:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.MemoTransfer:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.CpiGuard:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.NonTransferableAccount:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.TransferHookAccount:
            return true;
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.Uninitialized:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.TransferFeeConfig:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.MintCloseAuthority:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.ConfidentialTransferMint:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.DefaultAccountState:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.NonTransferable:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.InterestBearingConfig:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.PermanentDelegate:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.TransferHook:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.MetadataPointer:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.TokenMetadata:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.GroupPointer:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.GroupMemberPointer:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.TokenGroup:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.TokenGroupMember:
            return false;
        default:
            throw Error(`Unknown extension type: ${e}`);
    }
}
function $a05dc5f3bc940692$export$cbf93c990104e9e6(e) {
    switch(e){
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.TransferFeeConfig:
            return $a05dc5f3bc940692$export$4f037c6ec2da4eeb.TransferFeeAmount;
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.ConfidentialTransferMint:
            return $a05dc5f3bc940692$export$4f037c6ec2da4eeb.ConfidentialTransferAccount;
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.NonTransferable:
            return $a05dc5f3bc940692$export$4f037c6ec2da4eeb.NonTransferableAccount;
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.TransferHook:
            return $a05dc5f3bc940692$export$4f037c6ec2da4eeb.TransferHookAccount;
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.TransferFeeAmount:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.ConfidentialTransferAccount:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.CpiGuard:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.DefaultAccountState:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.ImmutableOwner:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.MemoTransfer:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.MintCloseAuthority:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.MetadataPointer:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.TokenMetadata:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.Uninitialized:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.InterestBearingConfig:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.PermanentDelegate:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.NonTransferableAccount:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.TransferHookAccount:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.GroupPointer:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.GroupMemberPointer:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.TokenGroup:
        case $a05dc5f3bc940692$export$4f037c6ec2da4eeb.TokenGroupMember:
            return $a05dc5f3bc940692$export$4f037c6ec2da4eeb.Uninitialized;
    }
}
function $a05dc5f3bc940692$var$getLen(extensionTypes, baseSize, variableLengthExtensions = {}) {
    if (extensionTypes.length === 0 && Object.keys(variableLengthExtensions).length === 0) return baseSize;
    else {
        const accountLength = (0, $4f8e5a3f35fa75b9$export$66ab21ef808e9dc6) + (0, $638cf1c35454a549$export$9d3ac77dcbf22b3f) + extensionTypes.filter((element, i)=>i === extensionTypes.indexOf(element)).map((element)=>$a05dc5f3bc940692$var$addTypeAndLengthToLen($a05dc5f3bc940692$export$a83377bb2e8914d8(element))).reduce((a, b)=>a + b, 0) + Object.entries(variableLengthExtensions).map(([extension, len])=>{
            if (!$a05dc5f3bc940692$var$isVariableLengthExtension(Number(extension))) throw Error(`Extension ${extension} is not variable length`);
            return $a05dc5f3bc940692$var$addTypeAndLengthToLen(len);
        }).reduce((a, b)=>a + b, 0);
        if (accountLength === (0, $ef806c48b215bede$export$c2abf71f91a1605b)) return accountLength + $a05dc5f3bc940692$export$b60591f8709c84d6;
        else return accountLength;
    }
}
function $a05dc5f3bc940692$export$887e6fc33c7c42b5(extensionTypes, variableLengthExtensions = {}) {
    return $a05dc5f3bc940692$var$getLen(extensionTypes, (0, $b7fa0603ab668fef$export$1e66c79f18e1c0c4), variableLengthExtensions);
}
function $a05dc5f3bc940692$export$37c8c863c6dd42a9(extensionTypes) {
    // There are currently no variable length extensions for accounts
    return $a05dc5f3bc940692$var$getLen(extensionTypes, (0, $4f8e5a3f35fa75b9$export$66ab21ef808e9dc6));
}
function $a05dc5f3bc940692$export$4fff3ed4eba4f4ee(extension, tlvData) {
    let extensionTypeIndex = 0;
    while($a05dc5f3bc940692$var$addTypeAndLengthToLen(extensionTypeIndex) <= tlvData.length){
        const entryType = tlvData.readUInt16LE(extensionTypeIndex);
        const entryLength = tlvData.readUInt16LE(extensionTypeIndex + $a05dc5f3bc940692$export$b60591f8709c84d6);
        const typeIndex = $a05dc5f3bc940692$var$addTypeAndLengthToLen(extensionTypeIndex);
        if (entryType == extension) return tlvData.slice(typeIndex, typeIndex + entryLength);
        extensionTypeIndex = typeIndex + entryLength;
    }
    return null;
}
function $a05dc5f3bc940692$export$ddfd0a43fd10c049(tlvData) {
    const extensionTypes = [];
    let extensionTypeIndex = 0;
    while(extensionTypeIndex < tlvData.length){
        const entryType = tlvData.readUInt16LE(extensionTypeIndex);
        extensionTypes.push(entryType);
        const entryLength = tlvData.readUInt16LE(extensionTypeIndex + $a05dc5f3bc940692$export$b60591f8709c84d6);
        extensionTypeIndex += $a05dc5f3bc940692$var$addTypeAndLengthToLen(entryLength);
    }
    return extensionTypes;
}
function $a05dc5f3bc940692$export$8e188ecf75868f0c(mint) {
    const extensionTypes = $a05dc5f3bc940692$export$ddfd0a43fd10c049(mint.tlvData);
    const accountExtensions = extensionTypes.map($a05dc5f3bc940692$export$cbf93c990104e9e6);
    return $a05dc5f3bc940692$export$37c8c863c6dd42a9(accountExtensions);
}
function $a05dc5f3bc940692$export$59ff847e58b4aa16(info, address, extensionType, extensionLen, programId = (0, $071f33b9e1b22b13$export$8183845dc9f5ce72)) {
    const mint = (0, $b7fa0603ab668fef$export$624621e2731540bb)(address, info, programId);
    const extensionData = $a05dc5f3bc940692$export$4fff3ed4eba4f4ee(extensionType, mint.tlvData);
    const currentExtensionLen = extensionData ? $a05dc5f3bc940692$var$addTypeAndLengthToLen(extensionData.length) : 0;
    const newExtensionLen = $a05dc5f3bc940692$var$addTypeAndLengthToLen(extensionLen);
    return info.data.length + newExtensionLen - currentExtensionLen;
}





var $b7fa0603ab668fef$require$Buffer = $1ff5f276bd1e09e8$export$a143d493d941bafc;
const $b7fa0603ab668fef$export$1374e91decd2fbe5 = (0, $ab8b5713b1ee9109$exports.struct)([
    (0, $ab8b5713b1ee9109$exports.u32)("mintAuthorityOption"),
    (0, $622167bc200b6540$export$86f13247979de5d7)("mintAuthority"),
    (0, $3b2d1baa52a31e71$export$cd1442401e54cffa)("supply"),
    (0, $ab8b5713b1ee9109$exports.u8)("decimals"),
    (0, $8f00f9d827a09685$export$87b259aa03e3d267)("isInitialized"),
    (0, $ab8b5713b1ee9109$exports.u32)("freezeAuthorityOption"),
    (0, $622167bc200b6540$export$86f13247979de5d7)("freezeAuthority")
]);
const $b7fa0603ab668fef$export$1e66c79f18e1c0c4 = $b7fa0603ab668fef$export$1374e91decd2fbe5.span;
async function $b7fa0603ab668fef$export$aa28710f9c948d46(connection, address, commitment, programId = (0, $071f33b9e1b22b13$export$79de3e3c2b1ca801)) {
    const info = await connection.getAccountInfo(address, commitment);
    return $b7fa0603ab668fef$export$624621e2731540bb(address, info, programId);
}
function $b7fa0603ab668fef$export$624621e2731540bb(address, info, programId = (0, $071f33b9e1b22b13$export$79de3e3c2b1ca801)) {
    if (!info) throw new (0, $8afd026bce6c5170$export$a09a5e48de2f3404)();
    if (!info.owner.equals(programId)) throw new (0, $8afd026bce6c5170$export$abb470453474d51)();
    if (info.data.length < $b7fa0603ab668fef$export$1e66c79f18e1c0c4) throw new (0, $8afd026bce6c5170$export$250d31de4ddb7ca5)();
    const rawMint = $b7fa0603ab668fef$export$1374e91decd2fbe5.decode(info.data.slice(0, $b7fa0603ab668fef$export$1e66c79f18e1c0c4));
    let tlvData = $b7fa0603ab668fef$require$Buffer.alloc(0);
    if (info.data.length > $b7fa0603ab668fef$export$1e66c79f18e1c0c4) {
        if (info.data.length <= (0, $4f8e5a3f35fa75b9$export$66ab21ef808e9dc6)) throw new (0, $8afd026bce6c5170$export$250d31de4ddb7ca5)();
        if (info.data.length === (0, $ef806c48b215bede$export$c2abf71f91a1605b)) throw new (0, $8afd026bce6c5170$export$250d31de4ddb7ca5)();
        if (info.data[0, $4f8e5a3f35fa75b9$export$66ab21ef808e9dc6] != (0, $638cf1c35454a549$export$b8ca5fa4899cbfc7).Mint) throw new (0, $8afd026bce6c5170$export$871debb212ec395)();
        tlvData = info.data.slice((0, $4f8e5a3f35fa75b9$export$66ab21ef808e9dc6) + (0, $638cf1c35454a549$export$9d3ac77dcbf22b3f));
    }
    return {
        address: address,
        mintAuthority: rawMint.mintAuthorityOption ? rawMint.mintAuthority : null,
        supply: rawMint.supply,
        decimals: rawMint.decimals,
        isInitialized: rawMint.isInitialized,
        freezeAuthority: rawMint.freezeAuthorityOption ? rawMint.freezeAuthority : null,
        tlvData: tlvData
    };
}
async function $b7fa0603ab668fef$export$ee29e619ed2e153c(connection, commitment) {
    return await $b7fa0603ab668fef$export$42e75cb3f25fa0b8(connection, [], commitment);
}
async function $b7fa0603ab668fef$export$42e75cb3f25fa0b8(connection, extensions, commitment) {
    const mintLen = (0, $a05dc5f3bc940692$export$887e6fc33c7c42b5)(extensions);
    return await connection.getMinimumBalanceForRentExemption(mintLen, commitment);
}
async function $b7fa0603ab668fef$export$d776e5c4182d21cc(mint, owner, allowOwnerOffCurve = false, programId = (0, $071f33b9e1b22b13$export$79de3e3c2b1ca801), associatedTokenProgramId = (0, $071f33b9e1b22b13$export$57a4f33bcc1767fa)) {
    if (!allowOwnerOffCurve && !(0, $ca3473265f76df98$export$ca8b6604d6ce14de).isOnCurve(owner.toBuffer())) throw new (0, $8afd026bce6c5170$export$c431a85da6f99bf0)();
    const [address] = await (0, $ca3473265f76df98$export$ca8b6604d6ce14de).findProgramAddress([
        owner.toBuffer(),
        programId.toBuffer(),
        mint.toBuffer()
    ], associatedTokenProgramId);
    return address;
}
function $b7fa0603ab668fef$export$226efbbb37d925bb(mint, owner, allowOwnerOffCurve = false, programId = (0, $071f33b9e1b22b13$export$79de3e3c2b1ca801), associatedTokenProgramId = (0, $071f33b9e1b22b13$export$57a4f33bcc1767fa)) {
    if (!allowOwnerOffCurve && !(0, $ca3473265f76df98$export$ca8b6604d6ce14de).isOnCurve(owner.toBuffer())) throw new (0, $8afd026bce6c5170$export$c431a85da6f99bf0)();
    const [address] = (0, $ca3473265f76df98$export$ca8b6604d6ce14de).findProgramAddressSync([
        owner.toBuffer(),
        programId.toBuffer(),
        mint.toBuffer()
    ], associatedTokenProgramId);
    return address;
}




var $8NFma = parcelRequire("8NFma");




parcelRequire("8NFma");
function $fde46c11fa0ffea3$var$S(props) {
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "6 6 12 12",
        stroke: "rgba(0,0,0, 0.25)",
        strokeWidth: "1",
        ...props,
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("path", {
            d: "M7 7L17 17M7 17L17 7",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
}
var $fde46c11fa0ffea3$export$2e2bcd8739ae039 = $fde46c11fa0ffea3$var$S;


const $d95055e1e84838c3$var$ModalContainer = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
  background-color: rgba(7, 7, 40, 0.75);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 101;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${(0, $dc80f518f0729f3c$export$ac81a72f0c3b6512)} 0.2s;
`;
const $d95055e1e84838c3$var$ModalInner = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
  background-color: white;
  box-shadow: 0 0 20px rgba(7, 7, 40, 0.5);
  width: 500px;
  max-width: 90%;
  border-radius: 10px;
  animation: ${(0, $dc80f518f0729f3c$export$f9ae25e7d5fbc8b9)} 0.1s cubic-bezier(0.18, 0.89, 0.32, 1.15);
  max-height: 90%;
  overflow: scroll;
`;
class $d95055e1e84838c3$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Component {
    render() {
        if (!this.props.visible) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $13f4c0370d7de649$exports.Fragment), {});
        return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($d95055e1e84838c3$var$ModalContainer, {
            onClick: (e)=>{
                if (!(e.target === this.inner || this.inner?.contains(e.target))) this.props.onClose();
            },
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($d95055e1e84838c3$var$ModalInner, {
                ref: (inner)=>this.inner = inner,
                style: this.props.innerStyles,
                children: [
                    this.props.title && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            padding: 30,
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                style: {
                                    fontSize: 16,
                                    fontWeight: 500
                                },
                                children: this.props.title
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $348d722f77cc9b90$export$c25acd513dcc8062), {
                                type: "button",
                                onClick: ()=>this.props.onClose(),
                                style: {
                                    padding: 0
                                },
                                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $fde46c11fa0ffea3$export$2e2bcd8739ae039), {
                                    style: {
                                        width: "14px"
                                    }
                                })
                            })
                        ]
                    }),
                    this.props.children
                ]
            })
        });
    }
}



var $e0f2bc43ee5a2b32$exports = {};
"use strict";
Object.defineProperty($e0f2bc43ee5a2b32$exports, "__esModule", {
    value: true
});
function $e0f2bc43ee5a2b32$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $8NFma = parcelRequire("8NFma");
var $e0f2bc43ee5a2b32$var$React__default = $e0f2bc43ee5a2b32$var$_interopDefault($8NFma);

var $fWaEd = parcelRequire("fWaEd");
var $e0f2bc43ee5a2b32$var$ClientUAInstance = new $fWaEd();
var $e0f2bc43ee5a2b32$var$browser = $e0f2bc43ee5a2b32$var$ClientUAInstance.getBrowser();
var $e0f2bc43ee5a2b32$var$cpu = $e0f2bc43ee5a2b32$var$ClientUAInstance.getCPU();
var $e0f2bc43ee5a2b32$var$device = $e0f2bc43ee5a2b32$var$ClientUAInstance.getDevice();
var $e0f2bc43ee5a2b32$var$engine = $e0f2bc43ee5a2b32$var$ClientUAInstance.getEngine();
var $e0f2bc43ee5a2b32$var$os = $e0f2bc43ee5a2b32$var$ClientUAInstance.getOS();
var $e0f2bc43ee5a2b32$var$ua = $e0f2bc43ee5a2b32$var$ClientUAInstance.getUA();
var $e0f2bc43ee5a2b32$var$setUa = function setUa(userAgentString) {
    return $e0f2bc43ee5a2b32$var$ClientUAInstance.setUA(userAgentString);
};
var $e0f2bc43ee5a2b32$var$parseUserAgent = function parseUserAgent(userAgent) {
    if (!userAgent) {
        console.error("No userAgent string was provided");
        return;
    }
    var UserAgentInstance = new $fWaEd(userAgent);
    return {
        UA: UserAgentInstance,
        browser: UserAgentInstance.getBrowser(),
        cpu: UserAgentInstance.getCPU(),
        device: UserAgentInstance.getDevice(),
        engine: UserAgentInstance.getEngine(),
        os: UserAgentInstance.getOS(),
        ua: UserAgentInstance.getUA(),
        setUserAgent: function setUserAgent(userAgentString) {
            return UserAgentInstance.setUA(userAgentString);
        }
    };
};
var $e0f2bc43ee5a2b32$var$UAHelper = /*#__PURE__*/ Object.freeze({
    ClientUAInstance: $e0f2bc43ee5a2b32$var$ClientUAInstance,
    browser: $e0f2bc43ee5a2b32$var$browser,
    cpu: $e0f2bc43ee5a2b32$var$cpu,
    device: $e0f2bc43ee5a2b32$var$device,
    engine: $e0f2bc43ee5a2b32$var$engine,
    os: $e0f2bc43ee5a2b32$var$os,
    ua: $e0f2bc43ee5a2b32$var$ua,
    setUa: $e0f2bc43ee5a2b32$var$setUa,
    parseUserAgent: $e0f2bc43ee5a2b32$var$parseUserAgent
});
function $e0f2bc43ee5a2b32$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e0f2bc43ee5a2b32$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $e0f2bc43ee5a2b32$var$ownKeys(Object(source), true).forEach(function(key) {
            $e0f2bc43ee5a2b32$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $e0f2bc43ee5a2b32$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e0f2bc43ee5a2b32$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $e0f2bc43ee5a2b32$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $e0f2bc43ee5a2b32$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $e0f2bc43ee5a2b32$var$_typeof(obj);
}
function $e0f2bc43ee5a2b32$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e0f2bc43ee5a2b32$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e0f2bc43ee5a2b32$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e0f2bc43ee5a2b32$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e0f2bc43ee5a2b32$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $e0f2bc43ee5a2b32$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e0f2bc43ee5a2b32$var$_extends() {
    $e0f2bc43ee5a2b32$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e0f2bc43ee5a2b32$var$_extends.apply(this, arguments);
}
function $e0f2bc43ee5a2b32$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $e0f2bc43ee5a2b32$var$_setPrototypeOf(subClass, superClass);
}
function $e0f2bc43ee5a2b32$var$_getPrototypeOf(o) {
    $e0f2bc43ee5a2b32$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e0f2bc43ee5a2b32$var$_getPrototypeOf(o);
}
function $e0f2bc43ee5a2b32$var$_setPrototypeOf(o, p) {
    $e0f2bc43ee5a2b32$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e0f2bc43ee5a2b32$var$_setPrototypeOf(o, p);
}
function $e0f2bc43ee5a2b32$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e0f2bc43ee5a2b32$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e0f2bc43ee5a2b32$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e0f2bc43ee5a2b32$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $e0f2bc43ee5a2b32$var$_possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $e0f2bc43ee5a2b32$var$_assertThisInitialized(self);
}
function $e0f2bc43ee5a2b32$var$_slicedToArray(arr, i) {
    return $e0f2bc43ee5a2b32$var$_arrayWithHoles(arr) || $e0f2bc43ee5a2b32$var$_iterableToArrayLimit(arr, i) || $e0f2bc43ee5a2b32$var$_unsupportedIterableToArray(arr, i) || $e0f2bc43ee5a2b32$var$_nonIterableRest();
}
function $e0f2bc43ee5a2b32$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $e0f2bc43ee5a2b32$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $e0f2bc43ee5a2b32$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e0f2bc43ee5a2b32$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e0f2bc43ee5a2b32$var$_arrayLikeToArray(o, minLen);
}
function $e0f2bc43ee5a2b32$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e0f2bc43ee5a2b32$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $e0f2bc43ee5a2b32$var$DeviceTypes = {
    Mobile: "mobile",
    Tablet: "tablet",
    SmartTv: "smarttv",
    Console: "console",
    Wearable: "wearable",
    Embedded: "embedded",
    Browser: undefined
};
var $e0f2bc43ee5a2b32$var$BrowserTypes = {
    Chrome: "Chrome",
    Firefox: "Firefox",
    Opera: "Opera",
    Yandex: "Yandex",
    Safari: "Safari",
    InternetExplorer: "Internet Explorer",
    Edge: "Edge",
    Chromium: "Chromium",
    Ie: "IE",
    MobileSafari: "Mobile Safari",
    EdgeChromium: "Edge Chromium",
    MIUI: "MIUI Browser",
    SamsungBrowser: "Samsung Browser"
};
var $e0f2bc43ee5a2b32$var$OsTypes = {
    IOS: "iOS",
    Android: "Android",
    WindowsPhone: "Windows Phone",
    Windows: "Windows",
    MAC_OS: "Mac OS"
};
var $e0f2bc43ee5a2b32$var$InitialDeviceTypes = {
    isMobile: false,
    isTablet: false,
    isBrowser: false,
    isSmartTV: false,
    isConsole: false,
    isWearable: false
};
var $e0f2bc43ee5a2b32$var$checkDeviceType = function checkDeviceType(type) {
    switch(type){
        case $e0f2bc43ee5a2b32$var$DeviceTypes.Mobile:
            return {
                isMobile: true
            };
        case $e0f2bc43ee5a2b32$var$DeviceTypes.Tablet:
            return {
                isTablet: true
            };
        case $e0f2bc43ee5a2b32$var$DeviceTypes.SmartTv:
            return {
                isSmartTV: true
            };
        case $e0f2bc43ee5a2b32$var$DeviceTypes.Console:
            return {
                isConsole: true
            };
        case $e0f2bc43ee5a2b32$var$DeviceTypes.Wearable:
            return {
                isWearable: true
            };
        case $e0f2bc43ee5a2b32$var$DeviceTypes.Browser:
            return {
                isBrowser: true
            };
        case $e0f2bc43ee5a2b32$var$DeviceTypes.Embedded:
            return {
                isEmbedded: true
            };
        default:
            return $e0f2bc43ee5a2b32$var$InitialDeviceTypes;
    }
};
var $e0f2bc43ee5a2b32$var$setUserAgent = function setUserAgent(userAgent) {
    return $e0f2bc43ee5a2b32$var$setUa(userAgent);
};
var $e0f2bc43ee5a2b32$var$setDefaults = function setDefaults(p) {
    var d = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "none";
    return p ? p : d;
};
var $e0f2bc43ee5a2b32$var$getNavigatorInstance = function getNavigatorInstance() {
    if (typeof window !== "undefined") {
        if (window.navigator || navigator) return window.navigator || navigator;
    }
    return false;
};
var $e0f2bc43ee5a2b32$var$isIOS13Check = function isIOS13Check(type) {
    var nav = $e0f2bc43ee5a2b32$var$getNavigatorInstance();
    return nav && nav.platform && (nav.platform.indexOf(type) !== -1 || nav.platform === "MacIntel" && nav.maxTouchPoints > 1 && !window.MSStream);
};
var $e0f2bc43ee5a2b32$var$browserPayload = function browserPayload(isBrowser, browser, engine, os, ua) {
    return {
        isBrowser: isBrowser,
        browserMajorVersion: $e0f2bc43ee5a2b32$var$setDefaults(browser.major),
        browserFullVersion: $e0f2bc43ee5a2b32$var$setDefaults(browser.version),
        browserName: $e0f2bc43ee5a2b32$var$setDefaults(browser.name),
        engineName: $e0f2bc43ee5a2b32$var$setDefaults(engine.name),
        engineVersion: $e0f2bc43ee5a2b32$var$setDefaults(engine.version),
        osName: $e0f2bc43ee5a2b32$var$setDefaults(os.name),
        osVersion: $e0f2bc43ee5a2b32$var$setDefaults(os.version),
        userAgent: $e0f2bc43ee5a2b32$var$setDefaults(ua)
    };
};
var $e0f2bc43ee5a2b32$var$mobilePayload = function mobilePayload(type, device, os, ua) {
    return $e0f2bc43ee5a2b32$var$_objectSpread2({}, type, {
        vendor: $e0f2bc43ee5a2b32$var$setDefaults(device.vendor),
        model: $e0f2bc43ee5a2b32$var$setDefaults(device.model),
        os: $e0f2bc43ee5a2b32$var$setDefaults(os.name),
        osVersion: $e0f2bc43ee5a2b32$var$setDefaults(os.version),
        ua: $e0f2bc43ee5a2b32$var$setDefaults(ua)
    });
};
var $e0f2bc43ee5a2b32$var$smartTvPayload = function smartTvPayload(isSmartTV, engine, os, ua) {
    return {
        isSmartTV: isSmartTV,
        engineName: $e0f2bc43ee5a2b32$var$setDefaults(engine.name),
        engineVersion: $e0f2bc43ee5a2b32$var$setDefaults(engine.version),
        osName: $e0f2bc43ee5a2b32$var$setDefaults(os.name),
        osVersion: $e0f2bc43ee5a2b32$var$setDefaults(os.version),
        userAgent: $e0f2bc43ee5a2b32$var$setDefaults(ua)
    };
};
var $e0f2bc43ee5a2b32$var$consolePayload = function consolePayload(isConsole, engine, os, ua) {
    return {
        isConsole: isConsole,
        engineName: $e0f2bc43ee5a2b32$var$setDefaults(engine.name),
        engineVersion: $e0f2bc43ee5a2b32$var$setDefaults(engine.version),
        osName: $e0f2bc43ee5a2b32$var$setDefaults(os.name),
        osVersion: $e0f2bc43ee5a2b32$var$setDefaults(os.version),
        userAgent: $e0f2bc43ee5a2b32$var$setDefaults(ua)
    };
};
var $e0f2bc43ee5a2b32$var$wearablePayload = function wearablePayload(isWearable, engine, os, ua) {
    return {
        isWearable: isWearable,
        engineName: $e0f2bc43ee5a2b32$var$setDefaults(engine.name),
        engineVersion: $e0f2bc43ee5a2b32$var$setDefaults(engine.version),
        osName: $e0f2bc43ee5a2b32$var$setDefaults(os.name),
        osVersion: $e0f2bc43ee5a2b32$var$setDefaults(os.version),
        userAgent: $e0f2bc43ee5a2b32$var$setDefaults(ua)
    };
};
var $e0f2bc43ee5a2b32$var$embeddedPayload = function embeddedPayload(isEmbedded, device, engine, os, ua) {
    return {
        isEmbedded: isEmbedded,
        vendor: $e0f2bc43ee5a2b32$var$setDefaults(device.vendor),
        model: $e0f2bc43ee5a2b32$var$setDefaults(device.model),
        engineName: $e0f2bc43ee5a2b32$var$setDefaults(engine.name),
        engineVersion: $e0f2bc43ee5a2b32$var$setDefaults(engine.version),
        osName: $e0f2bc43ee5a2b32$var$setDefaults(os.name),
        osVersion: $e0f2bc43ee5a2b32$var$setDefaults(os.version),
        userAgent: $e0f2bc43ee5a2b32$var$setDefaults(ua)
    };
};
function $e0f2bc43ee5a2b32$var$deviceDetect(userAgent) {
    var _ref = userAgent ? $e0f2bc43ee5a2b32$var$parseUserAgent(userAgent) : $e0f2bc43ee5a2b32$var$UAHelper, device = _ref.device, browser = _ref.browser, engine = _ref.engine, os = _ref.os, ua = _ref.ua;
    var type = $e0f2bc43ee5a2b32$var$checkDeviceType(device.type);
    var isBrowser = type.isBrowser, isMobile = type.isMobile, isTablet = type.isTablet, isSmartTV = type.isSmartTV, isConsole = type.isConsole, isWearable = type.isWearable, isEmbedded = type.isEmbedded;
    if (isBrowser) return $e0f2bc43ee5a2b32$var$browserPayload(isBrowser, browser, engine, os, ua);
    if (isSmartTV) return $e0f2bc43ee5a2b32$var$smartTvPayload(isSmartTV, engine, os, ua);
    if (isConsole) return $e0f2bc43ee5a2b32$var$consolePayload(isConsole, engine, os, ua);
    if (isMobile) return $e0f2bc43ee5a2b32$var$mobilePayload(type, device, os, ua);
    if (isTablet) return $e0f2bc43ee5a2b32$var$mobilePayload(type, device, os, ua);
    if (isWearable) return $e0f2bc43ee5a2b32$var$wearablePayload(isWearable, engine, os, ua);
    if (isEmbedded) return $e0f2bc43ee5a2b32$var$embeddedPayload(isEmbedded, device, engine, os, ua);
}
var $e0f2bc43ee5a2b32$var$isMobileType = function isMobileType(_ref) {
    var type = _ref.type;
    return type === $e0f2bc43ee5a2b32$var$DeviceTypes.Mobile;
};
var $e0f2bc43ee5a2b32$var$isTabletType = function isTabletType(_ref2) {
    var type = _ref2.type;
    return type === $e0f2bc43ee5a2b32$var$DeviceTypes.Tablet;
};
var $e0f2bc43ee5a2b32$var$isMobileAndTabletType = function isMobileAndTabletType(_ref3) {
    var type = _ref3.type;
    return type === $e0f2bc43ee5a2b32$var$DeviceTypes.Mobile || type === $e0f2bc43ee5a2b32$var$DeviceTypes.Tablet;
};
var $e0f2bc43ee5a2b32$var$isSmartTVType = function isSmartTVType(_ref4) {
    var type = _ref4.type;
    return type === $e0f2bc43ee5a2b32$var$DeviceTypes.SmartTv;
};
var $e0f2bc43ee5a2b32$var$isBrowserType = function isBrowserType(_ref5) {
    var type = _ref5.type;
    return type === $e0f2bc43ee5a2b32$var$DeviceTypes.Browser;
};
var $e0f2bc43ee5a2b32$var$isWearableType = function isWearableType(_ref6) {
    var type = _ref6.type;
    return type === $e0f2bc43ee5a2b32$var$DeviceTypes.Wearable;
};
var $e0f2bc43ee5a2b32$var$isConsoleType = function isConsoleType(_ref7) {
    var type = _ref7.type;
    return type === $e0f2bc43ee5a2b32$var$DeviceTypes.Console;
};
var $e0f2bc43ee5a2b32$var$isEmbeddedType = function isEmbeddedType(_ref8) {
    var type = _ref8.type;
    return type === $e0f2bc43ee5a2b32$var$DeviceTypes.Embedded;
};
var $e0f2bc43ee5a2b32$var$getMobileVendor = function getMobileVendor(_ref9) {
    var vendor = _ref9.vendor;
    return $e0f2bc43ee5a2b32$var$setDefaults(vendor);
};
var $e0f2bc43ee5a2b32$var$getMobileModel = function getMobileModel(_ref10) {
    var model = _ref10.model;
    return $e0f2bc43ee5a2b32$var$setDefaults(model);
};
var $e0f2bc43ee5a2b32$var$getDeviceType = function getDeviceType(_ref11) {
    var type = _ref11.type;
    return $e0f2bc43ee5a2b32$var$setDefaults(type, "browser");
}; // os types
var $e0f2bc43ee5a2b32$var$isAndroidType = function isAndroidType(_ref12) {
    var name = _ref12.name;
    return name === $e0f2bc43ee5a2b32$var$OsTypes.Android;
};
var $e0f2bc43ee5a2b32$var$isWindowsType = function isWindowsType(_ref13) {
    var name = _ref13.name;
    return name === $e0f2bc43ee5a2b32$var$OsTypes.Windows;
};
var $e0f2bc43ee5a2b32$var$isMacOsType = function isMacOsType(_ref14) {
    var name = _ref14.name;
    return name === $e0f2bc43ee5a2b32$var$OsTypes.MAC_OS;
};
var $e0f2bc43ee5a2b32$var$isWinPhoneType = function isWinPhoneType(_ref15) {
    var name = _ref15.name;
    return name === $e0f2bc43ee5a2b32$var$OsTypes.WindowsPhone;
};
var $e0f2bc43ee5a2b32$var$isIOSType = function isIOSType(_ref16) {
    var name = _ref16.name;
    return name === $e0f2bc43ee5a2b32$var$OsTypes.IOS;
};
var $e0f2bc43ee5a2b32$var$getOsVersion = function getOsVersion(_ref17) {
    var version = _ref17.version;
    return $e0f2bc43ee5a2b32$var$setDefaults(version);
};
var $e0f2bc43ee5a2b32$var$getOsName = function getOsName(_ref18) {
    var name = _ref18.name;
    return $e0f2bc43ee5a2b32$var$setDefaults(name);
}; // browser types
var $e0f2bc43ee5a2b32$var$isChromeType = function isChromeType(_ref19) {
    var name = _ref19.name;
    return name === $e0f2bc43ee5a2b32$var$BrowserTypes.Chrome;
};
var $e0f2bc43ee5a2b32$var$isFirefoxType = function isFirefoxType(_ref20) {
    var name = _ref20.name;
    return name === $e0f2bc43ee5a2b32$var$BrowserTypes.Firefox;
};
var $e0f2bc43ee5a2b32$var$isChromiumType = function isChromiumType(_ref21) {
    var name = _ref21.name;
    return name === $e0f2bc43ee5a2b32$var$BrowserTypes.Chromium;
};
var $e0f2bc43ee5a2b32$var$isEdgeType = function isEdgeType(_ref22) {
    var name = _ref22.name;
    return name === $e0f2bc43ee5a2b32$var$BrowserTypes.Edge;
};
var $e0f2bc43ee5a2b32$var$isYandexType = function isYandexType(_ref23) {
    var name = _ref23.name;
    return name === $e0f2bc43ee5a2b32$var$BrowserTypes.Yandex;
};
var $e0f2bc43ee5a2b32$var$isSafariType = function isSafariType(_ref24) {
    var name = _ref24.name;
    return name === $e0f2bc43ee5a2b32$var$BrowserTypes.Safari || name === $e0f2bc43ee5a2b32$var$BrowserTypes.MobileSafari;
};
var $e0f2bc43ee5a2b32$var$isMobileSafariType = function isMobileSafariType(_ref25) {
    var name = _ref25.name;
    return name === $e0f2bc43ee5a2b32$var$BrowserTypes.MobileSafari;
};
var $e0f2bc43ee5a2b32$var$isOperaType = function isOperaType(_ref26) {
    var name = _ref26.name;
    return name === $e0f2bc43ee5a2b32$var$BrowserTypes.Opera;
};
var $e0f2bc43ee5a2b32$var$isIEType = function isIEType(_ref27) {
    var name = _ref27.name;
    return name === $e0f2bc43ee5a2b32$var$BrowserTypes.InternetExplorer || name === $e0f2bc43ee5a2b32$var$BrowserTypes.Ie;
};
var $e0f2bc43ee5a2b32$var$isMIUIType = function isMIUIType(_ref28) {
    var name = _ref28.name;
    return name === $e0f2bc43ee5a2b32$var$BrowserTypes.MIUI;
};
var $e0f2bc43ee5a2b32$var$isSamsungBrowserType = function isSamsungBrowserType(_ref29) {
    var name = _ref29.name;
    return name === $e0f2bc43ee5a2b32$var$BrowserTypes.SamsungBrowser;
};
var $e0f2bc43ee5a2b32$var$getBrowserFullVersion = function getBrowserFullVersion(_ref30) {
    var version = _ref30.version;
    return $e0f2bc43ee5a2b32$var$setDefaults(version);
};
var $e0f2bc43ee5a2b32$var$getBrowserVersion = function getBrowserVersion(_ref31) {
    var major = _ref31.major;
    return $e0f2bc43ee5a2b32$var$setDefaults(major);
};
var $e0f2bc43ee5a2b32$var$getBrowserName = function getBrowserName(_ref32) {
    var name = _ref32.name;
    return $e0f2bc43ee5a2b32$var$setDefaults(name);
}; // engine types
var $e0f2bc43ee5a2b32$var$getEngineName = function getEngineName(_ref33) {
    var name = _ref33.name;
    return $e0f2bc43ee5a2b32$var$setDefaults(name);
};
var $e0f2bc43ee5a2b32$var$getEngineVersion = function getEngineVersion(_ref34) {
    var version = _ref34.version;
    return $e0f2bc43ee5a2b32$var$setDefaults(version);
};
var $e0f2bc43ee5a2b32$var$isElectronType = function isElectronType() {
    var nav = $e0f2bc43ee5a2b32$var$getNavigatorInstance();
    var ua = nav && nav.userAgent && nav.userAgent.toLowerCase();
    return typeof ua === "string" ? /electron/.test(ua) : false;
};
var $e0f2bc43ee5a2b32$var$isEdgeChromiumType = function isEdgeChromiumType(ua) {
    return typeof ua === "string" && ua.indexOf("Edg/") !== -1;
};
var $e0f2bc43ee5a2b32$var$getIOS13 = function getIOS13() {
    var nav = $e0f2bc43ee5a2b32$var$getNavigatorInstance();
    return nav && (/iPad|iPhone|iPod/.test(nav.platform) || nav.platform === "MacIntel" && nav.maxTouchPoints > 1) && !window.MSStream;
};
var $e0f2bc43ee5a2b32$var$getIPad13 = function getIPad13() {
    return $e0f2bc43ee5a2b32$var$isIOS13Check("iPad");
};
var $e0f2bc43ee5a2b32$var$getIphone13 = function getIphone13() {
    return $e0f2bc43ee5a2b32$var$isIOS13Check("iPhone");
};
var $e0f2bc43ee5a2b32$var$getIPod13 = function getIPod13() {
    return $e0f2bc43ee5a2b32$var$isIOS13Check("iPod");
};
var $e0f2bc43ee5a2b32$var$getUseragent = function getUseragent(userAg) {
    return $e0f2bc43ee5a2b32$var$setDefaults(userAg);
};
function $e0f2bc43ee5a2b32$var$buildSelectorsObject(options) {
    var _ref = options ? options : $e0f2bc43ee5a2b32$var$UAHelper, device = _ref.device, browser = _ref.browser, os = _ref.os, engine = _ref.engine, ua = _ref.ua;
    return {
        isSmartTV: $e0f2bc43ee5a2b32$var$isSmartTVType(device),
        isConsole: $e0f2bc43ee5a2b32$var$isConsoleType(device),
        isWearable: $e0f2bc43ee5a2b32$var$isWearableType(device),
        isEmbedded: $e0f2bc43ee5a2b32$var$isEmbeddedType(device),
        isMobileSafari: $e0f2bc43ee5a2b32$var$isMobileSafariType(browser) || $e0f2bc43ee5a2b32$var$getIPad13(),
        isChromium: $e0f2bc43ee5a2b32$var$isChromiumType(browser),
        isMobile: $e0f2bc43ee5a2b32$var$isMobileAndTabletType(device) || $e0f2bc43ee5a2b32$var$getIPad13(),
        isMobileOnly: $e0f2bc43ee5a2b32$var$isMobileType(device),
        isTablet: $e0f2bc43ee5a2b32$var$isTabletType(device) || $e0f2bc43ee5a2b32$var$getIPad13(),
        isBrowser: $e0f2bc43ee5a2b32$var$isBrowserType(device),
        isDesktop: $e0f2bc43ee5a2b32$var$isBrowserType(device),
        isAndroid: $e0f2bc43ee5a2b32$var$isAndroidType(os),
        isWinPhone: $e0f2bc43ee5a2b32$var$isWinPhoneType(os),
        isIOS: $e0f2bc43ee5a2b32$var$isIOSType(os) || $e0f2bc43ee5a2b32$var$getIPad13(),
        isChrome: $e0f2bc43ee5a2b32$var$isChromeType(browser),
        isFirefox: $e0f2bc43ee5a2b32$var$isFirefoxType(browser),
        isSafari: $e0f2bc43ee5a2b32$var$isSafariType(browser),
        isOpera: $e0f2bc43ee5a2b32$var$isOperaType(browser),
        isIE: $e0f2bc43ee5a2b32$var$isIEType(browser),
        osVersion: $e0f2bc43ee5a2b32$var$getOsVersion(os),
        osName: $e0f2bc43ee5a2b32$var$getOsName(os),
        fullBrowserVersion: $e0f2bc43ee5a2b32$var$getBrowserFullVersion(browser),
        browserVersion: $e0f2bc43ee5a2b32$var$getBrowserVersion(browser),
        browserName: $e0f2bc43ee5a2b32$var$getBrowserName(browser),
        mobileVendor: $e0f2bc43ee5a2b32$var$getMobileVendor(device),
        mobileModel: $e0f2bc43ee5a2b32$var$getMobileModel(device),
        engineName: $e0f2bc43ee5a2b32$var$getEngineName(engine),
        engineVersion: $e0f2bc43ee5a2b32$var$getEngineVersion(engine),
        getUA: $e0f2bc43ee5a2b32$var$getUseragent(ua),
        isEdge: $e0f2bc43ee5a2b32$var$isEdgeType(browser) || $e0f2bc43ee5a2b32$var$isEdgeChromiumType(ua),
        isYandex: $e0f2bc43ee5a2b32$var$isYandexType(browser),
        deviceType: $e0f2bc43ee5a2b32$var$getDeviceType(device),
        isIOS13: $e0f2bc43ee5a2b32$var$getIOS13(),
        isIPad13: $e0f2bc43ee5a2b32$var$getIPad13(),
        isIPhone13: $e0f2bc43ee5a2b32$var$getIphone13(),
        isIPod13: $e0f2bc43ee5a2b32$var$getIPod13(),
        isElectron: $e0f2bc43ee5a2b32$var$isElectronType(),
        isEdgeChromium: $e0f2bc43ee5a2b32$var$isEdgeChromiumType(ua),
        isLegacyEdge: $e0f2bc43ee5a2b32$var$isEdgeType(browser) && !$e0f2bc43ee5a2b32$var$isEdgeChromiumType(ua),
        isWindows: $e0f2bc43ee5a2b32$var$isWindowsType(os),
        isMacOs: $e0f2bc43ee5a2b32$var$isMacOsType(os),
        isMIUI: $e0f2bc43ee5a2b32$var$isMIUIType(browser),
        isSamsungBrowser: $e0f2bc43ee5a2b32$var$isSamsungBrowserType(browser)
    };
}
var $e0f2bc43ee5a2b32$var$isSmartTV = $e0f2bc43ee5a2b32$var$isSmartTVType($e0f2bc43ee5a2b32$var$device);
var $e0f2bc43ee5a2b32$var$isConsole = $e0f2bc43ee5a2b32$var$isConsoleType($e0f2bc43ee5a2b32$var$device);
var $e0f2bc43ee5a2b32$var$isWearable = $e0f2bc43ee5a2b32$var$isWearableType($e0f2bc43ee5a2b32$var$device);
var $e0f2bc43ee5a2b32$var$isEmbedded = $e0f2bc43ee5a2b32$var$isEmbeddedType($e0f2bc43ee5a2b32$var$device);
var $e0f2bc43ee5a2b32$var$isMobileSafari = $e0f2bc43ee5a2b32$var$isMobileSafariType($e0f2bc43ee5a2b32$var$browser) || $e0f2bc43ee5a2b32$var$getIPad13();
var $e0f2bc43ee5a2b32$var$isChromium = $e0f2bc43ee5a2b32$var$isChromiumType($e0f2bc43ee5a2b32$var$browser);
var $e0f2bc43ee5a2b32$var$isMobile = $e0f2bc43ee5a2b32$var$isMobileAndTabletType($e0f2bc43ee5a2b32$var$device) || $e0f2bc43ee5a2b32$var$getIPad13();
var $e0f2bc43ee5a2b32$var$isMobileOnly = $e0f2bc43ee5a2b32$var$isMobileType($e0f2bc43ee5a2b32$var$device);
var $e0f2bc43ee5a2b32$var$isTablet = $e0f2bc43ee5a2b32$var$isTabletType($e0f2bc43ee5a2b32$var$device) || $e0f2bc43ee5a2b32$var$getIPad13();
var $e0f2bc43ee5a2b32$var$isBrowser = $e0f2bc43ee5a2b32$var$isBrowserType($e0f2bc43ee5a2b32$var$device);
var $e0f2bc43ee5a2b32$var$isDesktop = $e0f2bc43ee5a2b32$var$isBrowserType($e0f2bc43ee5a2b32$var$device);
var $e0f2bc43ee5a2b32$var$isAndroid = $e0f2bc43ee5a2b32$var$isAndroidType($e0f2bc43ee5a2b32$var$os);
var $e0f2bc43ee5a2b32$var$isWinPhone = $e0f2bc43ee5a2b32$var$isWinPhoneType($e0f2bc43ee5a2b32$var$os);
var $e0f2bc43ee5a2b32$var$isIOS = $e0f2bc43ee5a2b32$var$isIOSType($e0f2bc43ee5a2b32$var$os) || $e0f2bc43ee5a2b32$var$getIPad13();
var $e0f2bc43ee5a2b32$var$isChrome = $e0f2bc43ee5a2b32$var$isChromeType($e0f2bc43ee5a2b32$var$browser);
var $e0f2bc43ee5a2b32$var$isFirefox = $e0f2bc43ee5a2b32$var$isFirefoxType($e0f2bc43ee5a2b32$var$browser);
var $e0f2bc43ee5a2b32$var$isSafari = $e0f2bc43ee5a2b32$var$isSafariType($e0f2bc43ee5a2b32$var$browser);
var $e0f2bc43ee5a2b32$var$isOpera = $e0f2bc43ee5a2b32$var$isOperaType($e0f2bc43ee5a2b32$var$browser);
var $e0f2bc43ee5a2b32$var$isIE = $e0f2bc43ee5a2b32$var$isIEType($e0f2bc43ee5a2b32$var$browser);
var $e0f2bc43ee5a2b32$var$osVersion = $e0f2bc43ee5a2b32$var$getOsVersion($e0f2bc43ee5a2b32$var$os);
var $e0f2bc43ee5a2b32$var$osName = $e0f2bc43ee5a2b32$var$getOsName($e0f2bc43ee5a2b32$var$os);
var $e0f2bc43ee5a2b32$var$fullBrowserVersion = $e0f2bc43ee5a2b32$var$getBrowserFullVersion($e0f2bc43ee5a2b32$var$browser);
var $e0f2bc43ee5a2b32$var$browserVersion = $e0f2bc43ee5a2b32$var$getBrowserVersion($e0f2bc43ee5a2b32$var$browser);
var $e0f2bc43ee5a2b32$var$browserName = $e0f2bc43ee5a2b32$var$getBrowserName($e0f2bc43ee5a2b32$var$browser);
var $e0f2bc43ee5a2b32$var$mobileVendor = $e0f2bc43ee5a2b32$var$getMobileVendor($e0f2bc43ee5a2b32$var$device);
var $e0f2bc43ee5a2b32$var$mobileModel = $e0f2bc43ee5a2b32$var$getMobileModel($e0f2bc43ee5a2b32$var$device);
var $e0f2bc43ee5a2b32$var$engineName = $e0f2bc43ee5a2b32$var$getEngineName($e0f2bc43ee5a2b32$var$engine);
var $e0f2bc43ee5a2b32$var$engineVersion = $e0f2bc43ee5a2b32$var$getEngineVersion($e0f2bc43ee5a2b32$var$engine);
var $e0f2bc43ee5a2b32$var$getUA = $e0f2bc43ee5a2b32$var$getUseragent($e0f2bc43ee5a2b32$var$ua);
var $e0f2bc43ee5a2b32$var$isEdge = $e0f2bc43ee5a2b32$var$isEdgeType($e0f2bc43ee5a2b32$var$browser) || $e0f2bc43ee5a2b32$var$isEdgeChromiumType($e0f2bc43ee5a2b32$var$ua);
var $e0f2bc43ee5a2b32$var$isYandex = $e0f2bc43ee5a2b32$var$isYandexType($e0f2bc43ee5a2b32$var$browser);
var $e0f2bc43ee5a2b32$var$deviceType = $e0f2bc43ee5a2b32$var$getDeviceType($e0f2bc43ee5a2b32$var$device);
var $e0f2bc43ee5a2b32$var$isIOS13 = $e0f2bc43ee5a2b32$var$getIOS13();
var $e0f2bc43ee5a2b32$var$isIPad13 = $e0f2bc43ee5a2b32$var$getIPad13();
var $e0f2bc43ee5a2b32$var$isIPhone13 = $e0f2bc43ee5a2b32$var$getIphone13();
var $e0f2bc43ee5a2b32$var$isIPod13 = $e0f2bc43ee5a2b32$var$getIPod13();
var $e0f2bc43ee5a2b32$var$isElectron = $e0f2bc43ee5a2b32$var$isElectronType();
var $e0f2bc43ee5a2b32$var$isEdgeChromium = $e0f2bc43ee5a2b32$var$isEdgeChromiumType($e0f2bc43ee5a2b32$var$ua);
var $e0f2bc43ee5a2b32$var$isLegacyEdge = $e0f2bc43ee5a2b32$var$isEdgeType($e0f2bc43ee5a2b32$var$browser) && !$e0f2bc43ee5a2b32$var$isEdgeChromiumType($e0f2bc43ee5a2b32$var$ua);
var $e0f2bc43ee5a2b32$var$isWindows = $e0f2bc43ee5a2b32$var$isWindowsType($e0f2bc43ee5a2b32$var$os);
var $e0f2bc43ee5a2b32$var$isMacOs = $e0f2bc43ee5a2b32$var$isMacOsType($e0f2bc43ee5a2b32$var$os);
var $e0f2bc43ee5a2b32$var$isMIUI = $e0f2bc43ee5a2b32$var$isMIUIType($e0f2bc43ee5a2b32$var$browser);
var $e0f2bc43ee5a2b32$var$isSamsungBrowser = $e0f2bc43ee5a2b32$var$isSamsungBrowserType($e0f2bc43ee5a2b32$var$browser);
var $e0f2bc43ee5a2b32$var$getSelectorsByUserAgent = function getSelectorsByUserAgent(userAgent) {
    if (!userAgent || typeof userAgent !== "string") {
        console.error("No valid user agent string was provided");
        return;
    }
    var _UAHelper$parseUserAg = $e0f2bc43ee5a2b32$var$parseUserAgent(userAgent), device = _UAHelper$parseUserAg.device, browser = _UAHelper$parseUserAg.browser, os = _UAHelper$parseUserAg.os, engine = _UAHelper$parseUserAg.engine, ua = _UAHelper$parseUserAg.ua;
    return $e0f2bc43ee5a2b32$var$buildSelectorsObject({
        device: device,
        browser: browser,
        os: os,
        engine: engine,
        ua: ua
    });
};
var $e0f2bc43ee5a2b32$var$AndroidView = function AndroidView(_ref) {
    var renderWithFragment = _ref.renderWithFragment, children = _ref.children, props = $e0f2bc43ee5a2b32$var$_objectWithoutProperties(_ref, [
        "renderWithFragment",
        "children"
    ]);
    return $e0f2bc43ee5a2b32$var$isAndroid ? renderWithFragment ? $e0f2bc43ee5a2b32$var$React__default.createElement($8NFma.Fragment, null, children) : $e0f2bc43ee5a2b32$var$React__default.createElement("div", props, children) : null;
};
var $e0f2bc43ee5a2b32$var$BrowserView = function BrowserView(_ref2) {
    var renderWithFragment = _ref2.renderWithFragment, children = _ref2.children, props = $e0f2bc43ee5a2b32$var$_objectWithoutProperties(_ref2, [
        "renderWithFragment",
        "children"
    ]);
    return $e0f2bc43ee5a2b32$var$isBrowser ? renderWithFragment ? $e0f2bc43ee5a2b32$var$React__default.createElement($8NFma.Fragment, null, children) : $e0f2bc43ee5a2b32$var$React__default.createElement("div", props, children) : null;
};
var $e0f2bc43ee5a2b32$var$IEView = function IEView(_ref3) {
    var renderWithFragment = _ref3.renderWithFragment, children = _ref3.children, props = $e0f2bc43ee5a2b32$var$_objectWithoutProperties(_ref3, [
        "renderWithFragment",
        "children"
    ]);
    return $e0f2bc43ee5a2b32$var$isIE ? renderWithFragment ? $e0f2bc43ee5a2b32$var$React__default.createElement($8NFma.Fragment, null, children) : $e0f2bc43ee5a2b32$var$React__default.createElement("div", props, children) : null;
};
var $e0f2bc43ee5a2b32$var$IOSView = function IOSView(_ref4) {
    var renderWithFragment = _ref4.renderWithFragment, children = _ref4.children, props = $e0f2bc43ee5a2b32$var$_objectWithoutProperties(_ref4, [
        "renderWithFragment",
        "children"
    ]);
    return $e0f2bc43ee5a2b32$var$isIOS ? renderWithFragment ? $e0f2bc43ee5a2b32$var$React__default.createElement($8NFma.Fragment, null, children) : $e0f2bc43ee5a2b32$var$React__default.createElement("div", props, children) : null;
};
var $e0f2bc43ee5a2b32$var$MobileView = function MobileView(_ref5) {
    var renderWithFragment = _ref5.renderWithFragment, children = _ref5.children, props = $e0f2bc43ee5a2b32$var$_objectWithoutProperties(_ref5, [
        "renderWithFragment",
        "children"
    ]);
    return $e0f2bc43ee5a2b32$var$isMobile ? renderWithFragment ? $e0f2bc43ee5a2b32$var$React__default.createElement($8NFma.Fragment, null, children) : $e0f2bc43ee5a2b32$var$React__default.createElement("div", props, children) : null;
};
var $e0f2bc43ee5a2b32$var$TabletView = function TabletView(_ref6) {
    var renderWithFragment = _ref6.renderWithFragment, children = _ref6.children, props = $e0f2bc43ee5a2b32$var$_objectWithoutProperties(_ref6, [
        "renderWithFragment",
        "children"
    ]);
    return $e0f2bc43ee5a2b32$var$isTablet ? renderWithFragment ? $e0f2bc43ee5a2b32$var$React__default.createElement($8NFma.Fragment, null, children) : $e0f2bc43ee5a2b32$var$React__default.createElement("div", props, children) : null;
};
var $e0f2bc43ee5a2b32$var$WinPhoneView = function WinPhoneView(_ref7) {
    var renderWithFragment = _ref7.renderWithFragment, children = _ref7.children, props = $e0f2bc43ee5a2b32$var$_objectWithoutProperties(_ref7, [
        "renderWithFragment",
        "children"
    ]);
    return $e0f2bc43ee5a2b32$var$isWinPhone ? renderWithFragment ? $e0f2bc43ee5a2b32$var$React__default.createElement($8NFma.Fragment, null, children) : $e0f2bc43ee5a2b32$var$React__default.createElement("div", props, children) : null;
};
var $e0f2bc43ee5a2b32$var$MobileOnlyView = function MobileOnlyView(_ref8) {
    var renderWithFragment = _ref8.renderWithFragment, children = _ref8.children, viewClassName = _ref8.viewClassName, style = _ref8.style, props = $e0f2bc43ee5a2b32$var$_objectWithoutProperties(_ref8, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style"
    ]);
    return $e0f2bc43ee5a2b32$var$isMobileOnly ? renderWithFragment ? $e0f2bc43ee5a2b32$var$React__default.createElement($8NFma.Fragment, null, children) : $e0f2bc43ee5a2b32$var$React__default.createElement("div", props, children) : null;
};
var $e0f2bc43ee5a2b32$var$SmartTVView = function SmartTVView(_ref9) {
    var renderWithFragment = _ref9.renderWithFragment, children = _ref9.children, props = $e0f2bc43ee5a2b32$var$_objectWithoutProperties(_ref9, [
        "renderWithFragment",
        "children"
    ]);
    return $e0f2bc43ee5a2b32$var$isSmartTV ? renderWithFragment ? $e0f2bc43ee5a2b32$var$React__default.createElement($8NFma.Fragment, null, children) : $e0f2bc43ee5a2b32$var$React__default.createElement("div", props, children) : null;
};
var $e0f2bc43ee5a2b32$var$ConsoleView = function ConsoleView(_ref10) {
    var renderWithFragment = _ref10.renderWithFragment, children = _ref10.children, props = $e0f2bc43ee5a2b32$var$_objectWithoutProperties(_ref10, [
        "renderWithFragment",
        "children"
    ]);
    return $e0f2bc43ee5a2b32$var$isConsole ? renderWithFragment ? $e0f2bc43ee5a2b32$var$React__default.createElement($8NFma.Fragment, null, children) : $e0f2bc43ee5a2b32$var$React__default.createElement("div", props, children) : null;
};
var $e0f2bc43ee5a2b32$var$WearableView = function WearableView(_ref11) {
    var renderWithFragment = _ref11.renderWithFragment, children = _ref11.children, props = $e0f2bc43ee5a2b32$var$_objectWithoutProperties(_ref11, [
        "renderWithFragment",
        "children"
    ]);
    return $e0f2bc43ee5a2b32$var$isWearable ? renderWithFragment ? $e0f2bc43ee5a2b32$var$React__default.createElement($8NFma.Fragment, null, children) : $e0f2bc43ee5a2b32$var$React__default.createElement("div", props, children) : null;
};
var $e0f2bc43ee5a2b32$var$CustomView = function CustomView(_ref12) {
    var renderWithFragment = _ref12.renderWithFragment, children = _ref12.children, viewClassName = _ref12.viewClassName, style = _ref12.style, condition = _ref12.condition, props = $e0f2bc43ee5a2b32$var$_objectWithoutProperties(_ref12, [
        "renderWithFragment",
        "children",
        "viewClassName",
        "style",
        "condition"
    ]);
    return condition ? renderWithFragment ? $e0f2bc43ee5a2b32$var$React__default.createElement($8NFma.Fragment, null, children) : $e0f2bc43ee5a2b32$var$React__default.createElement("div", props, children) : null;
};
function $e0f2bc43ee5a2b32$var$withOrientationChange(WrappedComponent) {
    return /*#__PURE__*/ function(_React$Component) {
        $e0f2bc43ee5a2b32$var$_inherits(_class, _React$Component);
        function _class(props) {
            var _this;
            $e0f2bc43ee5a2b32$var$_classCallCheck(this, _class);
            _this = $e0f2bc43ee5a2b32$var$_possibleConstructorReturn(this, $e0f2bc43ee5a2b32$var$_getPrototypeOf(_class).call(this, props));
            _this.isEventListenerAdded = false;
            _this.handleOrientationChange = _this.handleOrientationChange.bind($e0f2bc43ee5a2b32$var$_assertThisInitialized(_this));
            _this.onOrientationChange = _this.onOrientationChange.bind($e0f2bc43ee5a2b32$var$_assertThisInitialized(_this));
            _this.onPageLoad = _this.onPageLoad.bind($e0f2bc43ee5a2b32$var$_assertThisInitialized(_this));
            _this.state = {
                isLandscape: false,
                isPortrait: false
            };
            return _this;
        }
        $e0f2bc43ee5a2b32$var$_createClass(_class, [
            {
                key: "handleOrientationChange",
                value: function handleOrientationChange() {
                    if (!this.isEventListenerAdded) this.isEventListenerAdded = true;
                    var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
                    this.setState({
                        isPortrait: orientation === 0,
                        isLandscape: orientation === 90
                    });
                }
            },
            {
                key: "onOrientationChange",
                value: function onOrientationChange() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "onPageLoad",
                value: function onPageLoad() {
                    this.handleOrientationChange();
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if ((typeof window === "undefined" ? "undefined" : $e0f2bc43ee5a2b32$var$_typeof(window)) !== undefined && $e0f2bc43ee5a2b32$var$isMobile) {
                        if (!this.isEventListenerAdded) {
                            this.handleOrientationChange();
                            window.addEventListener("load", this.onPageLoad, false);
                        } else window.removeEventListener("load", this.onPageLoad, false);
                        window.addEventListener("resize", this.onOrientationChange, false);
                    }
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    window.removeEventListener("resize", this.onOrientationChange, false);
                }
            },
            {
                key: "render",
                value: function render() {
                    return $e0f2bc43ee5a2b32$var$React__default.createElement(WrappedComponent, $e0f2bc43ee5a2b32$var$_extends({}, this.props, {
                        isLandscape: this.state.isLandscape,
                        isPortrait: this.state.isPortrait
                    }));
                }
            }
        ]);
        return _class;
    }($e0f2bc43ee5a2b32$var$React__default.Component);
}
function $e0f2bc43ee5a2b32$var$useMobileOrientation() {
    var _useState = $8NFma.useState(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        return {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? "portrait" : "landscape"
        };
    }), _useState2 = $e0f2bc43ee5a2b32$var$_slicedToArray(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var handleOrientationChange = $8NFma.useCallback(function() {
        var orientation = window.innerWidth > window.innerHeight ? 90 : 0;
        var next = {
            isPortrait: orientation === 0,
            isLandscape: orientation === 90,
            orientation: orientation === 0 ? "portrait" : "landscape"
        };
        state.orientation !== next.orientation && setState(next);
    }, [
        state.orientation
    ]);
    $8NFma.useEffect(function() {
        if ((typeof window === "undefined" ? "undefined" : $e0f2bc43ee5a2b32$var$_typeof(window)) !== undefined && $e0f2bc43ee5a2b32$var$isMobile) {
            handleOrientationChange();
            window.addEventListener("load", handleOrientationChange, false);
            window.addEventListener("resize", handleOrientationChange, false);
        }
        return function() {
            window.removeEventListener("resize", handleOrientationChange, false);
            window.removeEventListener("load", handleOrientationChange, false);
        };
    }, [
        handleOrientationChange
    ]);
    return state;
}
function $e0f2bc43ee5a2b32$var$useDeviceData(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    return $e0f2bc43ee5a2b32$var$parseUserAgent(hookUserAgent);
}
function $e0f2bc43ee5a2b32$var$useDeviceSelectors(userAgent) {
    var hookUserAgent = userAgent ? userAgent : window.navigator.userAgent;
    var deviceData = $e0f2bc43ee5a2b32$var$useDeviceData(hookUserAgent);
    var selectors = $e0f2bc43ee5a2b32$var$buildSelectorsObject(deviceData);
    return [
        selectors,
        deviceData
    ];
}
$e0f2bc43ee5a2b32$exports.AndroidView = $e0f2bc43ee5a2b32$var$AndroidView;
$e0f2bc43ee5a2b32$exports.BrowserTypes = $e0f2bc43ee5a2b32$var$BrowserTypes;
$e0f2bc43ee5a2b32$exports.BrowserView = $e0f2bc43ee5a2b32$var$BrowserView;
$e0f2bc43ee5a2b32$exports.ConsoleView = $e0f2bc43ee5a2b32$var$ConsoleView;
$e0f2bc43ee5a2b32$exports.CustomView = $e0f2bc43ee5a2b32$var$CustomView;
$e0f2bc43ee5a2b32$exports.IEView = $e0f2bc43ee5a2b32$var$IEView;
$e0f2bc43ee5a2b32$exports.IOSView = $e0f2bc43ee5a2b32$var$IOSView;
$e0f2bc43ee5a2b32$exports.MobileOnlyView = $e0f2bc43ee5a2b32$var$MobileOnlyView;
$e0f2bc43ee5a2b32$exports.MobileView = $e0f2bc43ee5a2b32$var$MobileView;
$e0f2bc43ee5a2b32$exports.OsTypes = $e0f2bc43ee5a2b32$var$OsTypes;
$e0f2bc43ee5a2b32$exports.SmartTVView = $e0f2bc43ee5a2b32$var$SmartTVView;
$e0f2bc43ee5a2b32$exports.TabletView = $e0f2bc43ee5a2b32$var$TabletView;
$e0f2bc43ee5a2b32$exports.WearableView = $e0f2bc43ee5a2b32$var$WearableView;
$e0f2bc43ee5a2b32$exports.WinPhoneView = $e0f2bc43ee5a2b32$var$WinPhoneView;
$e0f2bc43ee5a2b32$exports.browserName = $e0f2bc43ee5a2b32$var$browserName;
$e0f2bc43ee5a2b32$exports.browserVersion = $e0f2bc43ee5a2b32$var$browserVersion;
$e0f2bc43ee5a2b32$exports.deviceDetect = $e0f2bc43ee5a2b32$var$deviceDetect;
$e0f2bc43ee5a2b32$exports.deviceType = $e0f2bc43ee5a2b32$var$deviceType;
$e0f2bc43ee5a2b32$exports.engineName = $e0f2bc43ee5a2b32$var$engineName;
$e0f2bc43ee5a2b32$exports.engineVersion = $e0f2bc43ee5a2b32$var$engineVersion;
$e0f2bc43ee5a2b32$exports.fullBrowserVersion = $e0f2bc43ee5a2b32$var$fullBrowserVersion;
$e0f2bc43ee5a2b32$exports.getSelectorsByUserAgent = $e0f2bc43ee5a2b32$var$getSelectorsByUserAgent;
$e0f2bc43ee5a2b32$exports.getUA = $e0f2bc43ee5a2b32$var$getUA;
$e0f2bc43ee5a2b32$exports.isAndroid = $e0f2bc43ee5a2b32$var$isAndroid;
$e0f2bc43ee5a2b32$exports.isBrowser = $e0f2bc43ee5a2b32$var$isBrowser;
$e0f2bc43ee5a2b32$exports.isChrome = $e0f2bc43ee5a2b32$var$isChrome;
$e0f2bc43ee5a2b32$exports.isChromium = $e0f2bc43ee5a2b32$var$isChromium;
$e0f2bc43ee5a2b32$exports.isConsole = $e0f2bc43ee5a2b32$var$isConsole;
$e0f2bc43ee5a2b32$exports.isDesktop = $e0f2bc43ee5a2b32$var$isDesktop;
$e0f2bc43ee5a2b32$exports.isEdge = $e0f2bc43ee5a2b32$var$isEdge;
$e0f2bc43ee5a2b32$exports.isEdgeChromium = $e0f2bc43ee5a2b32$var$isEdgeChromium;
$e0f2bc43ee5a2b32$exports.isElectron = $e0f2bc43ee5a2b32$var$isElectron;
$e0f2bc43ee5a2b32$exports.isEmbedded = $e0f2bc43ee5a2b32$var$isEmbedded;
$e0f2bc43ee5a2b32$exports.isFirefox = $e0f2bc43ee5a2b32$var$isFirefox;
$e0f2bc43ee5a2b32$exports.isIE = $e0f2bc43ee5a2b32$var$isIE;
$e0f2bc43ee5a2b32$exports.isIOS = $e0f2bc43ee5a2b32$var$isIOS;
$e0f2bc43ee5a2b32$exports.isIOS13 = $e0f2bc43ee5a2b32$var$isIOS13;
$e0f2bc43ee5a2b32$exports.isIPad13 = $e0f2bc43ee5a2b32$var$isIPad13;
$e0f2bc43ee5a2b32$exports.isIPhone13 = $e0f2bc43ee5a2b32$var$isIPhone13;
$e0f2bc43ee5a2b32$exports.isIPod13 = $e0f2bc43ee5a2b32$var$isIPod13;
$e0f2bc43ee5a2b32$exports.isLegacyEdge = $e0f2bc43ee5a2b32$var$isLegacyEdge;
$e0f2bc43ee5a2b32$exports.isMIUI = $e0f2bc43ee5a2b32$var$isMIUI;
$e0f2bc43ee5a2b32$exports.isMacOs = $e0f2bc43ee5a2b32$var$isMacOs;
$e0f2bc43ee5a2b32$exports.isMobile = $e0f2bc43ee5a2b32$var$isMobile;
$e0f2bc43ee5a2b32$exports.isMobileOnly = $e0f2bc43ee5a2b32$var$isMobileOnly;
$e0f2bc43ee5a2b32$exports.isMobileSafari = $e0f2bc43ee5a2b32$var$isMobileSafari;
$e0f2bc43ee5a2b32$exports.isOpera = $e0f2bc43ee5a2b32$var$isOpera;
$e0f2bc43ee5a2b32$exports.isSafari = $e0f2bc43ee5a2b32$var$isSafari;
$e0f2bc43ee5a2b32$exports.isSamsungBrowser = $e0f2bc43ee5a2b32$var$isSamsungBrowser;
$e0f2bc43ee5a2b32$exports.isSmartTV = $e0f2bc43ee5a2b32$var$isSmartTV;
$e0f2bc43ee5a2b32$exports.isTablet = $e0f2bc43ee5a2b32$var$isTablet;
$e0f2bc43ee5a2b32$exports.isWearable = $e0f2bc43ee5a2b32$var$isWearable;
$e0f2bc43ee5a2b32$exports.isWinPhone = $e0f2bc43ee5a2b32$var$isWinPhone;
$e0f2bc43ee5a2b32$exports.isWindows = $e0f2bc43ee5a2b32$var$isWindows;
$e0f2bc43ee5a2b32$exports.isYandex = $e0f2bc43ee5a2b32$var$isYandex;
$e0f2bc43ee5a2b32$exports.mobileModel = $e0f2bc43ee5a2b32$var$mobileModel;
$e0f2bc43ee5a2b32$exports.mobileVendor = $e0f2bc43ee5a2b32$var$mobileVendor;
$e0f2bc43ee5a2b32$exports.osName = $e0f2bc43ee5a2b32$var$osName;
$e0f2bc43ee5a2b32$exports.osVersion = $e0f2bc43ee5a2b32$var$osVersion;
$e0f2bc43ee5a2b32$exports.parseUserAgent = $e0f2bc43ee5a2b32$var$parseUserAgent;
$e0f2bc43ee5a2b32$exports.setUserAgent = $e0f2bc43ee5a2b32$var$setUserAgent;
$e0f2bc43ee5a2b32$exports.useDeviceData = $e0f2bc43ee5a2b32$var$useDeviceData;
$e0f2bc43ee5a2b32$exports.useDeviceSelectors = $e0f2bc43ee5a2b32$var$useDeviceSelectors;
$e0f2bc43ee5a2b32$exports.useMobileOrientation = $e0f2bc43ee5a2b32$var$useMobileOrientation;
$e0f2bc43ee5a2b32$exports.withOrientationChange = $e0f2bc43ee5a2b32$var$withOrientationChange;



var $8NFma = parcelRequire("8NFma");

var $8NFma = parcelRequire("8NFma");
const $422f014d14096cc6$var$DEFAULT_CONTEXT = {
    setVisible (_open) {
        console.error($422f014d14096cc6$var$constructMissingProviderErrorMessage("call", "setVisible"));
    },
    visible: false
};
Object.defineProperty($422f014d14096cc6$var$DEFAULT_CONTEXT, "visible", {
    get () {
        console.error($422f014d14096cc6$var$constructMissingProviderErrorMessage("read", "visible"));
        return false;
    }
});
function $422f014d14096cc6$var$constructMissingProviderErrorMessage(action, valueName) {
    return "You have tried to " + ` ${action} "${valueName}"` + " on a WalletModalContext without providing one." + " Make sure to render a WalletModalProvider" + " as an ancestor of the component that uses " + "WalletModalContext";
}
const $422f014d14096cc6$export$8fa8c0fc3ea86e87 = (0, $8NFma.createContext)($422f014d14096cc6$var$DEFAULT_CONTEXT);
function $422f014d14096cc6$export$6fdf0454adae214b() {
    return (0, $8NFma.useContext)($422f014d14096cc6$export$8fa8c0fc3ea86e87);
}





var $8NFma = parcelRequire("8NFma");


var $8NFma = parcelRequire("8NFma");
const $d73a2fbefac55335$export$78768a9af065a7b = ({ id: id, children: children, expanded: expanded = false })=>{
    const ref = (0, $8NFma.useRef)(null);
    const instant = (0, $8NFma.useRef)(true);
    const transition = "height 250ms ease-out";
    const openCollapse = ()=>{
        const node = ref.current;
        if (!node) return;
        requestAnimationFrame(()=>{
            node.style.height = node.scrollHeight + "px";
        });
    };
    const closeCollapse = ()=>{
        const node = ref.current;
        if (!node) return;
        requestAnimationFrame(()=>{
            node.style.height = node.offsetHeight + "px";
            node.style.overflow = "hidden";
            requestAnimationFrame(()=>{
                node.style.height = "0";
            });
        });
    };
    (0, $8NFma.useLayoutEffect)(()=>{
        if (expanded) openCollapse();
        else closeCollapse();
    }, [
        expanded
    ]);
    (0, $8NFma.useLayoutEffect)(()=>{
        const node = ref.current;
        if (!node) return;
        function handleComplete() {
            if (!node) return;
            node.style.overflow = expanded ? "initial" : "hidden";
            if (expanded) node.style.height = "auto";
        }
        function handleTransitionEnd(event) {
            if (node && event.target === node && event.propertyName === "height") handleComplete();
        }
        if (instant.current) {
            handleComplete();
            instant.current = false;
        }
        node.addEventListener("transitionend", handleTransitionEnd);
        return ()=>node.removeEventListener("transitionend", handleTransitionEnd);
    }, [
        expanded
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("div", {
        className: "wallet-adapter-collapse",
        id: id,
        ref: ref,
        role: "region",
        style: {
            height: 0,
            transition: instant.current ? undefined : transition
        }
    }, children);
};




var $8NFma = parcelRequire("8NFma");

var $8NFma = parcelRequire("8NFma");
const $372004903ac57d68$export$353f5b6fc5456de1 = (props)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("button", {
        className: `wallet-adapter-button ${props.className || ""}`,
        disabled: props.disabled,
        style: props.style,
        onClick: props.onClick,
        tabIndex: props.tabIndex || 0,
        type: "button"
    }, props.startIcon && (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("i", {
        className: "wallet-adapter-button-start-icon"
    }, props.startIcon), props.children, props.endIcon && (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("i", {
        className: "wallet-adapter-button-end-icon"
    }, props.endIcon));
};



var $8NFma = parcelRequire("8NFma");
const $00170ca91f57a7ef$export$deff84e7338ee5a5 = ({ wallet: wallet, ...props })=>{
    return wallet && (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("img", {
        src: wallet.adapter.icon,
        alt: `${wallet.adapter.name} icon`,
        ...props
    });
};


const $60dba1703a6e0ef5$export$b6b33106605f17bb = ({ handleClick: handleClick, tabIndex: tabIndex, wallet: wallet })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("li", null, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $372004903ac57d68$export$353f5b6fc5456de1), {
        onClick: handleClick,
        startIcon: (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $00170ca91f57a7ef$export$deff84e7338ee5a5), {
            wallet: wallet
        }),
        tabIndex: tabIndex
    }, wallet.adapter.name, wallet.readyState === (0, $3020024d0a1e39a2$export$2a7b8071105d05b6).Installed && (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("span", null, "Detected")));
};



var $8NFma = parcelRequire("8NFma");
const $75962576235bcb1a$export$d822b842d2dccc19 = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("svg", {
        width: "97",
        height: "96",
        viewBox: "0 0 97 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("circle", {
        cx: "48.5",
        cy: "48",
        r: "48",
        fill: "url(#paint0_linear_880_5115)",
        fillOpacity: "0.1"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("circle", {
        cx: "48.5",
        cy: "48",
        r: "47",
        stroke: "url(#paint1_linear_880_5115)",
        strokeOpacity: "0.4",
        strokeWidth: "2"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("g", {
        clipPath: "url(#clip0_880_5115)"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("path", {
        d: "M65.5769 28.1523H31.4231C27.6057 28.1523 24.5 31.258 24.5 35.0754V60.9215C24.5 64.7389 27.6057 67.8446 31.4231 67.8446H65.5769C69.3943 67.8446 72.5 64.7389 72.5 60.9215V35.0754C72.5 31.258 69.3943 28.1523 65.5769 28.1523ZM69.7308 52.1523H59.5769C57.2865 52.1523 55.4231 50.289 55.4231 47.9985C55.4231 45.708 57.2864 43.8446 59.5769 43.8446H69.7308V52.1523ZM69.7308 41.0754H59.5769C55.7595 41.0754 52.6539 44.1811 52.6539 47.9985C52.6539 51.8159 55.7595 54.9215 59.5769 54.9215H69.7308V60.9215C69.7308 63.2119 67.8674 65.0754 65.5769 65.0754H31.4231C29.1327 65.0754 27.2692 63.212 27.2692 60.9215V35.0754C27.2692 32.785 29.1326 30.9215 31.4231 30.9215H65.5769C67.8673 30.9215 69.7308 32.7849 69.7308 35.0754V41.0754Z",
        fill: "url(#paint2_linear_880_5115)"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("path", {
        d: "M61.4231 46.6172H59.577C58.8123 46.6172 58.1924 47.2371 58.1924 48.0018C58.1924 48.7665 58.8123 49.3863 59.577 49.3863H61.4231C62.1878 49.3863 62.8077 48.7664 62.8077 48.0018C62.8077 47.2371 62.1878 46.6172 61.4231 46.6172Z",
        fill: "url(#paint3_linear_880_5115)"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("defs", null, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("linearGradient", {
        id: "paint0_linear_880_5115",
        x1: "3.41664",
        y1: "98.0933",
        x2: "103.05",
        y2: "8.42498",
        gradientUnits: "userSpaceOnUse"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("stop", {
        stopColor: "#9945FF"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("stop", {
        offset: "0.14",
        stopColor: "#8A53F4"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("stop", {
        offset: "0.42",
        stopColor: "#6377D6"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("stop", {
        offset: "0.79",
        stopColor: "#24B0A7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("stop", {
        offset: "0.99",
        stopColor: "#00D18C"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("stop", {
        offset: "1",
        stopColor: "#00D18C"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("linearGradient", {
        id: "paint1_linear_880_5115",
        x1: "3.41664",
        y1: "98.0933",
        x2: "103.05",
        y2: "8.42498",
        gradientUnits: "userSpaceOnUse"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("stop", {
        stopColor: "#9945FF"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("stop", {
        offset: "0.14",
        stopColor: "#8A53F4"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("stop", {
        offset: "0.42",
        stopColor: "#6377D6"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("stop", {
        offset: "0.79",
        stopColor: "#24B0A7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("stop", {
        offset: "0.99",
        stopColor: "#00D18C"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("stop", {
        offset: "1",
        stopColor: "#00D18C"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("linearGradient", {
        id: "paint2_linear_880_5115",
        x1: "25.9583",
        y1: "68.7101",
        x2: "67.2337",
        y2: "23.7879",
        gradientUnits: "userSpaceOnUse"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("stop", {
        stopColor: "#9945FF"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("stop", {
        offset: "0.14",
        stopColor: "#8A53F4"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("stop", {
        offset: "0.42",
        stopColor: "#6377D6"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("stop", {
        offset: "0.79",
        stopColor: "#24B0A7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("stop", {
        offset: "0.99",
        stopColor: "#00D18C"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("stop", {
        offset: "1",
        stopColor: "#00D18C"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("linearGradient", {
        id: "paint3_linear_880_5115",
        x1: "58.3326",
        y1: "49.4467",
        x2: "61.0002",
        y2: "45.4453",
        gradientUnits: "userSpaceOnUse"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("stop", {
        stopColor: "#9945FF"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("stop", {
        offset: "0.14",
        stopColor: "#8A53F4"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("stop", {
        offset: "0.42",
        stopColor: "#6377D6"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("stop", {
        offset: "0.79",
        stopColor: "#24B0A7"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("stop", {
        offset: "0.99",
        stopColor: "#00D18C"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("stop", {
        offset: "1",
        stopColor: "#00D18C"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("clipPath", {
        id: "clip0_880_5115"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("rect", {
        width: "48",
        height: "48",
        fill: "white",
        transform: "translate(24.5 24)"
    }))));
};



const $e540a78aa1aba5dd$export$851b8e4aa786e6a1 = ({ className: className = "", container: container = "body" })=>{
    const ref = (0, $8NFma.useRef)(null);
    const { wallets: wallets, select: select } = (0, $da2cf33ea909e7e2$export$c34addee860b0acb)();
    const { setVisible: setVisible } = (0, $422f014d14096cc6$export$6fdf0454adae214b)();
    const [expanded, setExpanded] = (0, $8NFma.useState)(false);
    const [fadeIn, setFadeIn] = (0, $8NFma.useState)(false);
    const [portal, setPortal] = (0, $8NFma.useState)(null);
    const [listedWallets, collapsedWallets] = (0, $8NFma.useMemo)(()=>{
        const installed = [];
        const notInstalled = [];
        for (const wallet of wallets)if (wallet.readyState === (0, $3020024d0a1e39a2$export$2a7b8071105d05b6).Installed) installed.push(wallet);
        else notInstalled.push(wallet);
        return installed.length ? [
            installed,
            notInstalled
        ] : [
            notInstalled,
            []
        ];
    }, [
        wallets
    ]);
    const hideModal = (0, $8NFma.useCallback)(()=>{
        setFadeIn(false);
        setTimeout(()=>setVisible(false), 150);
    }, [
        setVisible
    ]);
    const handleClose = (0, $8NFma.useCallback)((event)=>{
        event.preventDefault();
        hideModal();
    }, [
        hideModal
    ]);
    const handleWalletClick = (0, $8NFma.useCallback)((event, walletName)=>{
        select(walletName);
        handleClose(event);
    }, [
        select,
        handleClose
    ]);
    const handleCollapseClick = (0, $8NFma.useCallback)(()=>setExpanded(!expanded), [
        expanded
    ]);
    const handleTabKey = (0, $8NFma.useCallback)((event)=>{
        const node = ref.current;
        if (!node) return;
        // here we query all focusable elements
        const focusableElements = node.querySelectorAll("button");
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const firstElement = focusableElements[0];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const lastElement = focusableElements[focusableElements.length - 1];
        if (event.shiftKey) // if going backward by pressing tab and firstElement is active, shift focus to last focusable element
        {
            if (document.activeElement === firstElement) {
                lastElement.focus();
                event.preventDefault();
            }
        } else // if going forward by pressing tab and lastElement is active, shift focus to first focusable element
        if (document.activeElement === lastElement) {
            firstElement.focus();
            event.preventDefault();
        }
    }, [
        ref
    ]);
    (0, $8NFma.useLayoutEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") hideModal();
            else if (event.key === "Tab") handleTabKey(event);
        };
        // Get original overflow
        const { overflow: overflow } = window.getComputedStyle(document.body);
        // Hack to enable fade in animation after mount
        setTimeout(()=>setFadeIn(true), 0);
        // Prevent scrolling on mount
        document.body.style.overflow = "hidden";
        // Listen for keydown events
        window.addEventListener("keydown", handleKeyDown, false);
        return ()=>{
            // Re-enable scrolling when component unmounts
            document.body.style.overflow = overflow;
            window.removeEventListener("keydown", handleKeyDown, false);
        };
    }, [
        hideModal,
        handleTabKey
    ]);
    (0, $8NFma.useLayoutEffect)(()=>setPortal(document.querySelector(container)), [
        container
    ]);
    return portal && (0, $1c0f1e610963dfb8$exports.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("div", {
        "aria-labelledby": "wallet-adapter-modal-title",
        "aria-modal": "true",
        className: `wallet-adapter-modal ${fadeIn && "wallet-adapter-modal-fade-in"} ${className}`,
        ref: ref,
        role: "dialog"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("div", {
        className: "wallet-adapter-modal-container"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("div", {
        className: "wallet-adapter-modal-wrapper"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("button", {
        onClick: handleClose,
        className: "wallet-adapter-modal-button-close"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("svg", {
        width: "14",
        height: "14"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("path", {
        d: "M14 12.461 8.3 6.772l5.234-5.233L12.006 0 6.772 5.234 1.54 0 0 1.539l5.234 5.233L0 12.006l1.539 1.528L6.772 8.3l5.69 5.7L14 12.461z"
    }))), listedWallets.length ? (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("h1", {
        className: "wallet-adapter-modal-title"
    }, "Connect a wallet on Solana to continue"), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("ul", {
        className: "wallet-adapter-modal-list"
    }, listedWallets.map((wallet)=>(0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $60dba1703a6e0ef5$export$b6b33106605f17bb), {
            key: wallet.adapter.name,
            handleClick: (event)=>handleWalletClick(event, wallet.adapter.name),
            wallet: wallet
        })), collapsedWallets.length ? (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $d73a2fbefac55335$export$78768a9af065a7b), {
        expanded: expanded,
        id: "wallet-adapter-modal-collapse"
    }, collapsedWallets.map((wallet)=>(0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $60dba1703a6e0ef5$export$b6b33106605f17bb), {
            key: wallet.adapter.name,
            handleClick: (event)=>handleWalletClick(event, wallet.adapter.name),
            tabIndex: expanded ? 0 : -1,
            wallet: wallet
        }))) : null), collapsedWallets.length ? (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("button", {
        className: "wallet-adapter-modal-list-more",
        onClick: handleCollapseClick,
        tabIndex: 0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("span", null, expanded ? "Less " : "More ", "options"), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("svg", {
        width: "13",
        height: "7",
        viewBox: "0 0 13 7",
        xmlns: "http://www.w3.org/2000/svg",
        className: `${expanded ? "wallet-adapter-modal-list-more-icon-rotate" : ""}`
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("path", {
        d: "M0.71418 1.626L5.83323 6.26188C5.91574 6.33657 6.0181 6.39652 6.13327 6.43762C6.24844 6.47872 6.37371 6.5 6.50048 6.5C6.62725 6.5 6.75252 6.47872 6.8677 6.43762C6.98287 6.39652 7.08523 6.33657 7.16774 6.26188L12.2868 1.626C12.7753 1.1835 12.3703 0.5 11.6195 0.5H1.37997C0.629216 0.5 0.224175 1.1835 0.71418 1.626Z"
    }))) : null) : (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("h1", {
        className: "wallet-adapter-modal-title"
    }, "You'll need a wallet on Solana to continue"), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("div", {
        className: "wallet-adapter-modal-middle"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $75962576235bcb1a$export$d822b842d2dccc19), null)), collapsedWallets.length ? (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("button", {
        className: "wallet-adapter-modal-list-more",
        onClick: handleCollapseClick,
        tabIndex: 0
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("span", null, expanded ? "Hide " : "Already have a wallet? View ", "options"), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("svg", {
        width: "13",
        height: "7",
        viewBox: "0 0 13 7",
        xmlns: "http://www.w3.org/2000/svg",
        className: `${expanded ? "wallet-adapter-modal-list-more-icon-rotate" : ""}`
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("path", {
        d: "M0.71418 1.626L5.83323 6.26188C5.91574 6.33657 6.0181 6.39652 6.13327 6.43762C6.24844 6.47872 6.37371 6.5 6.50048 6.5C6.62725 6.5 6.75252 6.47872 6.8677 6.43762C6.98287 6.39652 7.08523 6.33657 7.16774 6.26188L12.2868 1.626C12.7753 1.1835 12.3703 0.5 11.6195 0.5H1.37997C0.629216 0.5 0.224175 1.1835 0.71418 1.626Z"
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $d73a2fbefac55335$export$78768a9af065a7b), {
        expanded: expanded,
        id: "wallet-adapter-modal-collapse"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("ul", {
        className: "wallet-adapter-modal-list"
    }, collapsedWallets.map((wallet)=>(0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $60dba1703a6e0ef5$export$b6b33106605f17bb), {
            key: wallet.adapter.name,
            handleClick: (event)=>handleWalletClick(event, wallet.adapter.name),
            tabIndex: expanded ? 0 : -1,
            wallet: wallet
        }))))) : null))), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("div", {
        className: "wallet-adapter-modal-overlay",
        onMouseDown: handleClose
    })), portal);
};


const $0f7dfc629f5e4ec5$export$43bb60413a8a3ee6 = ({ children: children, ...props })=>{
    const [visible, setVisible] = (0, $8NFma.useState)(false);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $422f014d14096cc6$export$8fa8c0fc3ea86e87).Provider, {
        value: {
            visible: visible,
            setVisible: setVisible
        }
    }, children, visible && (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $e540a78aa1aba5dd$export$851b8e4aa786e6a1), {
        ...props
    }));
};


var $8NFma = parcelRequire("8NFma");


var $8NFma = parcelRequire("8NFma");
function $95f00f6e803bbdd1$export$629f18756d2627db({ onSelectWallet: onSelectWallet }) {
    const { connect: connect, connected: connected, connecting: connecting, disconnect: disconnect, disconnecting: disconnecting, publicKey: publicKey, select: select, wallet: wallet, wallets: wallets } = (0, $da2cf33ea909e7e2$export$c34addee860b0acb)();
    let buttonState;
    if (connecting) buttonState = "connecting";
    else if (connected) buttonState = "connected";
    else if (disconnecting) buttonState = "disconnecting";
    else if (wallet) buttonState = "has-wallet";
    else buttonState = "no-wallet";
    const handleConnect = (0, $8NFma.useCallback)(()=>{
        connect().catch(()=>{
        // Silently catch because any errors are caught by the context `onError` handler
        });
    }, [
        connect
    ]);
    const handleDisconnect = (0, $8NFma.useCallback)(()=>{
        disconnect().catch(()=>{
        // Silently catch because any errors are caught by the context `onError` handler
        });
    }, [
        disconnect
    ]);
    const handleSelectWallet = (0, $8NFma.useCallback)(()=>{
        onSelectWallet({
            onSelectWallet: select,
            wallets: wallets
        });
    }, [
        onSelectWallet,
        select,
        wallets
    ]);
    return {
        buttonState: buttonState,
        onConnect: buttonState === "has-wallet" ? handleConnect : undefined,
        onDisconnect: buttonState !== "disconnecting" && buttonState !== "no-wallet" ? handleDisconnect : undefined,
        onSelectWallet: handleSelectWallet,
        publicKey: publicKey ?? undefined,
        walletIcon: wallet?.adapter.icon,
        walletName: wallet?.adapter.name
    };
}



var $8NFma = parcelRequire("8NFma");

var $8NFma = parcelRequire("8NFma");


function $0924e1a1930e110c$export$a0d4a8038508425f({ walletIcon: walletIcon, walletName: walletName, ...props }) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $372004903ac57d68$export$353f5b6fc5456de1), {
        ...props,
        className: "wallet-adapter-button-trigger",
        startIcon: walletIcon && walletName ? (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $00170ca91f57a7ef$export$deff84e7338ee5a5), {
            wallet: {
                adapter: {
                    icon: walletIcon,
                    name: walletName
                }
            }
        }) : undefined
    });
}



function $db38b91cd6e55de5$export$50382f20865178f9({ children: children, labels: labels, ...props }) {
    const { setVisible: setModalVisible } = (0, $422f014d14096cc6$export$6fdf0454adae214b)();
    const { buttonState: buttonState, onConnect: onConnect, onDisconnect: onDisconnect, publicKey: publicKey, walletIcon: walletIcon, walletName: walletName } = (0, $95f00f6e803bbdd1$export$629f18756d2627db)({
        onSelectWallet () {
            setModalVisible(true);
        }
    });
    const [copied, setCopied] = (0, $8NFma.useState)(false);
    const [menuOpen, setMenuOpen] = (0, $8NFma.useState)(false);
    const ref = (0, $8NFma.useRef)(null);
    (0, $8NFma.useEffect)(()=>{
        const listener = (event)=>{
            const node = ref.current;
            // Do nothing if clicking dropdown or its descendants
            if (!node || node.contains(event.target)) return;
            setMenuOpen(false);
        };
        document.addEventListener("mousedown", listener);
        document.addEventListener("touchstart", listener);
        return ()=>{
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, []);
    const content = (0, $8NFma.useMemo)(()=>{
        if (children) return children;
        else if (publicKey) {
            const base58 = publicKey.toBase58();
            return base58.slice(0, 4) + ".." + base58.slice(-4);
        } else if (buttonState === "connecting" || buttonState === "has-wallet") return labels[buttonState];
        else return labels["no-wallet"];
    }, [
        buttonState,
        children,
        labels,
        publicKey
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("div", {
        className: "wallet-adapter-dropdown"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $0924e1a1930e110c$export$a0d4a8038508425f), {
        ...props,
        "aria-expanded": menuOpen,
        style: {
            pointerEvents: menuOpen ? "none" : "auto",
            ...props.style
        },
        onClick: ()=>{
            switch(buttonState){
                case "no-wallet":
                    setModalVisible(true);
                    break;
                case "has-wallet":
                    if (onConnect) onConnect();
                    break;
                case "connected":
                    setMenuOpen(true);
                    break;
            }
        },
        walletIcon: walletIcon,
        walletName: walletName
    }, content), (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("ul", {
        "aria-label": "dropdown-list",
        className: `wallet-adapter-dropdown-list ${menuOpen && "wallet-adapter-dropdown-list-active"}`,
        ref: ref,
        role: "menu"
    }, publicKey ? (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("li", {
        className: "wallet-adapter-dropdown-list-item",
        onClick: async ()=>{
            await navigator.clipboard.writeText(publicKey.toBase58());
            setCopied(true);
            setTimeout(()=>setCopied(false), 400);
        },
        role: "menuitem"
    }, copied ? labels["copied"] : labels["copy-address"]) : null, (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("li", {
        className: "wallet-adapter-dropdown-list-item",
        onClick: ()=>{
            setModalVisible(true);
            setMenuOpen(false);
        },
        role: "menuitem"
    }, labels["change-wallet"]), onDisconnect ? (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement("li", {
        className: "wallet-adapter-dropdown-list-item",
        onClick: ()=>{
            onDisconnect();
            setMenuOpen(false);
        },
        role: "menuitem"
    }, labels["disconnect"]) : null));
}


const $c90a922b2d8d2be6$var$LABELS = {
    "change-wallet": "Change wallet",
    connecting: "Connecting ...",
    "copy-address": "Copy address",
    copied: "Copied",
    disconnect: "Disconnect",
    "has-wallet": "Connect",
    "no-wallet": "Select Wallet"
};
function $c90a922b2d8d2be6$export$968d144f04194cbb(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8NFma))).createElement((0, $db38b91cd6e55de5$export$50382f20865178f9), {
        ...props,
        labels: $c90a922b2d8d2be6$var$LABELS
    });
}



const $3a7c189ba80694ae$var$ConnectedWalletContainer = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
  box-shadow: 0 0 3px ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARK};
  border-radius: 5px;
`;
function $3a7c189ba80694ae$var$endpointUrl(cluster) {
    if (cluster === "devnet") return "https://api.devnet.solana.com";
    return "https://api.radom.com/solana";
}
function $3a7c189ba80694ae$var$maxBigInt(a, b) {
    return a > b ? a : b;
}
const $3a7c189ba80694ae$var$SolanaWalletInner = (props)=>{
    const { connect: connect, connected: connected, disconnect: solanaDisconnect, sendTransaction: sendTransaction, publicKey: publicKey, select: select, wallet: wallet, wallets: wallets } = (0, $da2cf33ea909e7e2$export$c34addee860b0acb)();
    const { connection: connection } = (0, $c1d85d09818f0a66$export$985e8768c0e91dbc)();
    (0, $8NFma.useEffect)(()=>{
        if (wallet && !connected && !(0, $e0f2bc43ee5a2b32$exports.isMobile)) connect();
    }, []);
    const [isSolanaWalletModalVisible, setIsSolanaWalletModalVisible] = (0, $8NFma.useState)(false);
    (0, $8NFma.useEffect)(()=>{
        if (wallet && !(0, $e0f2bc43ee5a2b32$exports.isMobile)) connect();
    }, [
        wallet
    ]);
    const { isLoading: isLoading, setIsLoading: setIsLoading, managedPaymentDetails: managedPaymentDetails } = props;
    const onClick = async ()=>{
        if (!publicKey) return;
        setIsLoading(true);
        try {
            let transaction;
            const { value: { blockhash: blockhash, lastValidBlockHeight: lastValidBlockHeight }, context: { slot: minContextSlot } } = await connection.getLatestBlockhashAndContext();
            if (managedPaymentDetails.token) {
                const tokenAddress = await $b7fa0603ab668fef$export$d776e5c4182d21cc(new (0, $ca3473265f76df98$export$ca8b6604d6ce14de)(managedPaymentDetails.token), new (0, $ca3473265f76df98$export$ca8b6604d6ce14de)(managedPaymentDetails.paymentAddress));
                const fromTokenAddress = await $b7fa0603ab668fef$export$d776e5c4182d21cc(new (0, $ca3473265f76df98$export$ca8b6604d6ce14de)(managedPaymentDetails.token), publicKey);
                const method = (0, $61f236426b9e4eab$export$8793fab959da70d1)(managedPaymentDetails.network, managedPaymentDetails.token);
                transaction = new (0, $ca3473265f76df98$export$febc5573c75cefb0)({
                    blockhash: blockhash,
                    lastValidBlockHeight: lastValidBlockHeight,
                    feePayer: publicKey
                }).add($a060f50b60a1e468$export$b66dd1dc00a3bc28(publicKey, new (0, $ca3473265f76df98$export$ca8b6604d6ce14de)(tokenAddress), new (0, $ca3473265f76df98$export$ca8b6604d6ce14de)(managedPaymentDetails.paymentAddress), new (0, $ca3473265f76df98$export$ca8b6604d6ce14de)(managedPaymentDetails.token))).add($950a0899dcef3911$export$b274d5cebe357db9(fromTokenAddress, tokenAddress, publicKey, (0, $996ac4676bde0a02$export$203ae30b4f6490b3)(managedPaymentDetails.amount, method.tokenInfo?.decimals ?? 9)));
            } else {
                const minimumAmount = BigInt(await connection.getMinimumBalanceForRentExemption(0));
                transaction = new (0, $ca3473265f76df98$export$febc5573c75cefb0)({
                    blockhash: blockhash,
                    lastValidBlockHeight: lastValidBlockHeight,
                    feePayer: publicKey
                }).add((0, $ca3473265f76df98$export$d8c4e17726848113).transfer({
                    fromPubkey: publicKey,
                    toPubkey: new (0, $ca3473265f76df98$export$ca8b6604d6ce14de)(managedPaymentDetails.paymentAddress),
                    lamports: $3a7c189ba80694ae$var$maxBigInt((0, $996ac4676bde0a02$export$203ae30b4f6490b3)(managedPaymentDetails.amount, 9), minimumAmount)
                }));
            }
            const signature = await sendTransaction(transaction, connection, {
                preflightCommitment: "processed",
                minContextSlot: minContextSlot
            });
            await connection.confirmTransaction({
                blockhash: blockhash,
                lastValidBlockHeight: lastValidBlockHeight,
                signature: signature
            });
        } catch (err) {
            console.error("Failed", err);
            setIsLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $13f4c0370d7de649$exports.Fragment), {
        children: [
            wallet?.adapter.publicKey && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $13f4c0370d7de649$exports.Fragment), {
                children: [
                    props.presaleStyling && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                style: {
                                    color: props.presaleStyling.darkTextColor,
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 5
                                },
                                children: [
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                        style: {
                                            textTransform: "uppercase",
                                            fontSize: 10
                                        },
                                        children: "Connected wallet"
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                        children: (0, $2a4a168be657655e$export$193698062786be9a)(wallet.adapter.publicKey.toString(), 10)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $348d722f77cc9b90$export$f861551692d63a2e), {
                                disabled: isLoading,
                                onClick: async ()=>await solanaDisconnect(),
                                style: {
                                    padding: 0,
                                    border: 0,
                                    color: props.presaleStyling.titleTextColor,
                                    textTransform: "uppercase",
                                    fontSize: 10
                                },
                                children: "Disconnect"
                            })
                        ]
                    }),
                    !props.presaleStyling && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($3a7c189ba80694ae$var$ConnectedWalletContainer, {
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "column",
                                border: `1px solid ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARK}`,
                                borderRadius: 5
                            },
                            children: [
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        justifyContent: "space-between",
                                        padding: 15,
                                        backgroundColor: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_MED
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                            style: {
                                                fontSize: 14
                                            },
                                            children: "Connected wallet"
                                        }),
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $348d722f77cc9b90$export$f861551692d63a2e), {
                                            style: {
                                                border: 0,
                                                padding: 0,
                                                color: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).BLACK,
                                                fontSize: 10,
                                                textTransform: "uppercase"
                                            },
                                            onClick: async ()=>await solanaDisconnect(),
                                            children: "Disconnect"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                    style: {
                                        padding: 15
                                    },
                                    children: wallet.adapter.publicKey.toString()
                                })
                            ]
                        })
                    })
                ]
            }),
            wallet?.adapter.publicKey ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $348d722f77cc9b90$export$ac16a6a04d9b7c84), {
                isLoading: isLoading,
                onClick: ()=>{
                    onClick();
                },
                style: {
                    width: "100%",
                    background: props.primaryButtonColor,
                    color: props.presaleStyling?.buttonTextColor
                },
                children: "Open wallet"
            }) : /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $c90a922b2d8d2be6$export$968d144f04194cbb), {
                style: {
                    width: "100%",
                    backgroundColor: "black",
                    background: props.primaryButtonColor,
                    color: props.presaleStyling?.buttonTextColor,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    fontWeight: 400,
                    borderRadius: 30
                }
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $d95055e1e84838c3$export$2e2bcd8739ae039), {
                onClose: ()=>setIsSolanaWalletModalVisible(!isSolanaWalletModalVisible),
                visible: isSolanaWalletModalVisible,
                innerStyles: {
                    width: 350
                },
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        flexGrow: 1,
                        padding: 20,
                        gap: 10,
                        fontSize: 14
                    },
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                            style: {
                                marginBottom: 10
                            },
                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                style: {
                                    fontSize: 16,
                                    fontWeight: 500
                                },
                                children: "Select wallet"
                            })
                        }),
                        wallets.length <= 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                padding: "30px 0",
                                gap: 3
                            },
                            children: [
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                    style: {
                                        fontSize: 14
                                    },
                                    children: "No wallet found."
                                }),
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                    style: {
                                        opacity: 0.5
                                    },
                                    children: "Please install a Solana compatible wallet."
                                }),
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                    style: {
                                        opacity: 0.5
                                    },
                                    children: "Please open the app within Phantom or Solflare."
                                })
                            ]
                        }),
                        wallets.map((w, i)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $348d722f77cc9b90$export$ac16a6a04d9b7c84), {
                                onClick: async ()=>{
                                    if (0, $e0f2bc43ee5a2b32$exports.isMobile) {
                                        await connect();
                                        setIsSolanaWalletModalVisible(false);
                                    } else {
                                        select(w.adapter.name);
                                        setIsSolanaWalletModalVisible(false);
                                    }
                                },
                                style: {
                                    backgroundColor: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_MED,
                                    color: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).BLACK
                                },
                                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 15,
                                        justifyContent: "flex-start",
                                        width: "100%"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                            style: {
                                                width: 20,
                                                height: 20,
                                                backgroundImage: `url(${w.adapter.icon})`,
                                                backgroundSize: "contain",
                                                backgroundRepeat: "no-repeat",
                                                backgroundPosition: "center center"
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                            children: w.adapter.name
                                        })
                                    ]
                                })
                            }, i))
                    ]
                })
            })
        ]
    });
};
const $3a7c189ba80694ae$var$SolanaWallet = (props)=>{
    const endpoint = $3a7c189ba80694ae$var$endpointUrl(props.managedPaymentDetails.network === "Solana" ? "mainnet" : "devnet");
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $9e21814ff868d8fd$export$fd685cf7c99624bd), {
        endpoint: endpoint,
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $23cb594897fd5885$export$717b22fc3a2082b3), {
            wallets: [],
            autoConnect: true,
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $0f7dfc629f5e4ec5$export$43bb60413a8a3ee6), {
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($3a7c189ba80694ae$var$SolanaWalletInner, {
                    ...props
                })
            })
        })
    });
};
var $3a7c189ba80694ae$export$2e2bcd8739ae039 = $3a7c189ba80694ae$var$SolanaWallet;



(0, $f4478bf7da9e4de4$export$14650d4efb17e382)({
    wagmiConfig: $61f236426b9e4eab$export$382a3cc012b91987,
    projectId: $61f236426b9e4eab$export$e4bb003b4e7478a
});
function $6795754bca05c124$export$8e3f267d166b4a05(totalSeconds) {
    const duration = (0, $16f75469e5b80165$export$2e2bcd8739ae039)({
        start: 0,
        end: totalSeconds * 1000
    });
    const zeroPad = (num)=>String(num).padStart(2, "0");
    const formatted = [
        duration.days,
        duration.hours,
        duration.minutes,
        duration.seconds
    ].filter((a, i)=>i <= 1 ? !!a : true).map(zeroPad).join(":");
    return formatted;
}
const $6795754bca05c124$var$Styles = (0, $65e706775ff71837$export$f0f03736edb61697)`
  @property --angle {
    syntax: '<angle>';
    initial-value: 90deg;
    inherits: true;
  }

  :root {
    --d: 2500ms;
    --c1: rgba(0, 0, 0, 0.5);
    --c2: rgba(0, 0, 0, 0.1);
  }
`;
const $6795754bca05c124$var$ConnectedWalletContainer = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
  box-shadow: 0 0 3px ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARK};
  border-radius: 5px;
`;
const $6795754bca05c124$var$borderRotate = (0, $65e706775ff71837$export$d25ddfdf17c3ad3e)`
  100% {
    --angle: 440deg;
  }
`;
const $6795754bca05c124$export$ec3c7ce6a909733b = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
  border-radius: 3px;
  overflow: hidden;
  width: fit-content;
  box-shadow: 0 0 3px ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARK};
  transition: 0.2s ease all;
  cursor: pointer;

  &:active {
    transform: scale(0.99);
  }
`;
const $6795754bca05c124$export$3c6b4f0e2cd37515 = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
  width: fit-content;
  border: 3px solid;
  border-image: conic-gradient(from var(--angle), var(--c2), var(--c1) 0.1turn, var(--c1) 0.15turn, var(--c2) 0.25turn) 30;
  animation: ${$6795754bca05c124$var$borderRotate} var(--d) linear infinite forwards;
  font-size: 0;
`;
const $6795754bca05c124$export$b2a0bb8fc9a08697 = (0, $65e706775ff71837$export$d25ddfdf17c3ad3e)`
  from {
    transform: translateY(-25%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;
const $6795754bca05c124$var$WrapperAnimation = (0, $65e706775ff71837$export$dbf350e5966cf602)`
  animation: ${$6795754bca05c124$export$b2a0bb8fc9a08697} 0.2s ease;
`;
const $6795754bca05c124$var$Wrapper = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
  flex-grow: 1;
  ${({ disableAnimation: disableAnimation })=>!disableAnimation && $6795754bca05c124$var$WrapperAnimation}
`;
const $6795754bca05c124$var$Container = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  ${({ disableAnimation: disableAnimation })=>!disableAnimation && $6795754bca05c124$var$WrapperAnimation}
  // animation: ${$6795754bca05c124$export$b2a0bb8fc9a08697} 0.2s ease;
`;
const $6795754bca05c124$var$CheckmarkWrapper = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  min-height: 20px;
  border-radius: 100%;
  background-color: ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).NICE_GREEN};
  animation: ${(0, $dc80f518f0729f3c$export$f9ae25e7d5fbc8b9)} .25s ease;
`;
const $6795754bca05c124$export$6f653acab4a8965a = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 15px;
  border-radius: ${({ hoverEffect: hoverEffect })=>hoverEffect ? "0px" : "5px"};
  cursor: pointer;
  border-bottom: 1px solid;
  ${({ isSelected: isSelected })=>isSelected && "border: 1px solid;"}
  border-color: ${({ isSelected: isSelected })=>isSelected ? (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).NICE_GREEN : (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARK};
  box-shadow: ${({ isSelected: isSelected })=>isSelected && `0 0 3px ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).NICE_GREEN}`};
  opacity: ${({ isSelected: isSelected })=>isSelected ? "1" : "0.3"};
  transition: 0.2s ease all;
  user-select: none;

  ${({ isSelected: isSelected })=>isSelected && `
    position: sticky;
    top: 0;
    bottom: 0;
    background: white;
    z-index: 1;
  `}

  ${({ isDisabled: isDisabled })=>isDisabled && "opacity: 0.5;"}

  &:hover {
    opacity: ${({ isSelected: isSelected })=>isSelected ? 1 : 0.6};
    ${({ hoverEffect: hoverEffect })=>hoverEffect && `
      background-color: ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_LIGHTEST};
    `}
  }

  &:active {
    opacity: ${({ isSelected: isSelected })=>isSelected ? 1 : 0.8};
    transform: scale(0.98);
  }
`;
const $6795754bca05c124$export$c825e58f74061357 = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  z-index: -1;
  overflow: hidden;
`;
const $6795754bca05c124$var$WaveAnim = (0, $65e706775ff71837$export$d25ddfdf17c3ad3e)`
  0% {
    margin-left: 0;
  }
  100% {
    margin-left: -1600px;
  }
`;
const $6795754bca05c124$export$b8bb87b40c00c04e = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
  background: url(${(0, (/*@__PURE__*/$parcel$interopDefault($854d6433ea8d1fc7$exports)))}) repeat-x;
  position: absolute;
  width: 6400px;
  height: 50%;
  top: calc(50% - 100px);
  animation: ${$6795754bca05c124$var$WaveAnim} 18s cubic-bezier( 0.36, 0.45, 0.63, 0.53) infinite;
`;
const $6795754bca05c124$var$WaveAnim2 = (0, $65e706775ff71837$export$d25ddfdf17c3ad3e)`
  0% {
    margin-left: 0;
  }
  100% {
    margin-left: -3200px;
  }
`;
const $6795754bca05c124$export$6128c696434ef87c = (0, $65e706775ff71837$export$2e2bcd8739ae039)($6795754bca05c124$export$b8bb87b40c00c04e)`
  background: url(${(0, (/*@__PURE__*/$parcel$interopDefault($c0f28aab14de6aeb$exports)))}) repeat-x;
  animation: ${$6795754bca05c124$var$WaveAnim2} 15s cubic-bezier( 0.36, 0.45, 0.63, 0.53) infinite;
`;
const $6795754bca05c124$var$WaveAnim3 = (0, $65e706775ff71837$export$d25ddfdf17c3ad3e)`
  0% {
    margin-left: -800px;
  }
  100% {
    margin-left: -2400px;
  }
`;
const $6795754bca05c124$export$bd3f954aa84a63d6 = (0, $65e706775ff71837$export$2e2bcd8739ae039)($6795754bca05c124$export$b8bb87b40c00c04e)`
  background: url(${(0, (/*@__PURE__*/$parcel$interopDefault($18f9b0243b414b37$exports)))}) repeat-x;
  animation: ${$6795754bca05c124$var$WaveAnim3} 6s cubic-bezier( 0.36, 0.45, 0.63, 0.53) infinite;
`;
const $6795754bca05c124$var$Expand = (0, $65e706775ff71837$export$d25ddfdf17c3ad3e)`
  0% {
    transform: scaleY(0%);
  }
  100% {
    transform: scaleY(100%);
  }
`;
const $6795754bca05c124$var$PaymentDetectedContainer = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
  animation: ${$6795754bca05c124$var$Expand} 0.2s cubic-bezier(0, 1, 0, 1);
  transform-origin: 0 0;
  border-radius: 15px;
  border: 1px solid ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_MED};
  overflow: hidden;
`;
const $6795754bca05c124$export$4f2558dd25106ae2 = ({ onClick: onClick, style: style, iconColor: iconColor = (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARKEST })=>{
    const [copied, setCopied] = (0, $8NFma.useState)(false);
    (0, $8NFma.useEffect)(()=>{
        if (copied) {
            const timeout = setTimeout(()=>setCopied(false), 3000);
            return ()=>clearTimeout(timeout);
        }
    }, [
        copied
    ]);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $348d722f77cc9b90$export$f861551692d63a2e), {
        onClick: ()=>{
            setCopied(true);
            onClick();
        },
        style: {
            padding: "2px 4px",
            fontSize: 10,
            textTransform: "uppercase",
            background: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_MED,
            color: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARKEST,
            cursor: "pointer",
            borderRadius: 5,
            display: "flex",
            alignItems: "center",
            gap: 2,
            border: "none",
            ...style
        },
        children: [
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                children: copied ? "Copied" : "Copy"
            }),
            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $ce72948bfd3a5859$export$2e2bcd8739ae039), {
                style: {
                    height: 10
                },
                stroke: iconColor
            })
        ]
    });
};
var $6795754bca05c124$var$SubscriptionCheckoutState;
(function(SubscriptionCheckoutState) {
    SubscriptionCheckoutState[SubscriptionCheckoutState["Select"] = 0] = "Select";
    SubscriptionCheckoutState[SubscriptionCheckoutState["Confirm"] = 1] = "Confirm";
    SubscriptionCheckoutState[SubscriptionCheckoutState["Allowance"] = 2] = "Allowance";
    SubscriptionCheckoutState[SubscriptionCheckoutState["EmailInvoicePay"] = 3] = "EmailInvoicePay";
})($6795754bca05c124$var$SubscriptionCheckoutState || ($6795754bca05c124$var$SubscriptionCheckoutState = {}));
var $6795754bca05c124$export$60341e7d25c98210;
(function(SubscriptionType) {
    SubscriptionType[SubscriptionType["EmailInvoice"] = 0] = "EmailInvoice";
    SubscriptionType[SubscriptionType["Autopay"] = 1] = "Autopay";
})($6795754bca05c124$export$60341e7d25c98210 || ($6795754bca05c124$export$60341e7d25c98210 = {}));
const $6795754bca05c124$var$PayWidget = (props)=>{
    const [localCheckoutData, setLocalCheckoutData] = (0, $8NFma.useState)({});
    const [selectedMethod, setSelectedMethod] = (0, $8NFma.useState)();
    const [priceQuotes, setPriceQuotes] = (0, $8NFma.useState)([]);
    const [quoteExpiryTimestamp, setQuoteExpiryTimestamp] = (0, $8NFma.useState)(new Date());
    const [quoteSecondsRemaining, setQuoteSecondsRemaining] = (0, $8NFma.useState)(0);
    const [isLoadingPriceQuotes, setIsLoadingPriceQuotes] = (0, $8NFma.useState)(false);
    const { disconnect: disconnect } = (0, $e271cce8b43c0b7b$export$83bebf2fe7fead4e)();
    const { address: address, isConnected: isConnected, connector: connector } = (0, $9cc58b6deaa591e8$export$83a8e409853da004)();
    const { open: open } = (0, $dbb64e404ec3de5f$export$69804ca079d47f29)();
    const [localInputFields, setLocalInputFields] = (0, $8NFma.useState)([]);
    const inputRefs = (0, $8NFma.useRef)([]);
    const [subscriptionEmailAddress, setSubscriptionEmailAddress] = (0, $8NFma.useState)("");
    (0, $8NFma.useEffect)(()=>{
        if (props.checkoutData.inputFields) {
            inputRefs.current = inputRefs.current.slice(0, props.checkoutData.inputFields.length);
            setLocalInputFields(props.checkoutData.inputFields);
        }
    }, [
        props.checkoutData.inputFields
    ]);
    const getPriceQuotes = ()=>{
        props.onQuoteUpdate();
        setIsLoadingPriceQuotes(true);
        const fromCurList = [
            ...props.checkoutData.products?.map((p)=>p.product.currency) ?? [],
            ...props.checkoutData.lineItems?.map((p)=>p.currency ?? "USD") ?? [],
            props.currency
        ];
        const { managed: managed } = props.checkoutData.gateway;
        if (managed) fromCurList.push("USD", ...managed.methods.map((t)=>(0, $61f236426b9e4eab$export$8793fab959da70d1)(t.network, t.token).ticker));
        const fromCur = [
            ...new Set(fromCurList)
        ];
        if (fromCur.length === 0) return;
        (0, $6cc04e58a8fffbcd$export$2e2bcd8739ae039).getPriceQuotes(fromCur, fromCur).then((priceQuotes)=>{
            const minTimestamp = (0, $7fc809a90a42d5fb$export$2e2bcd8739ae039)(priceQuotes.map((p)=>new Date(p.expiryTimestamp)));
            setQuoteExpiryTimestamp(minTimestamp);
            setQuoteSecondsRemaining((minTimestamp.getTime() - new Date().getTime()) / 1000);
            setPriceQuotes(priceQuotes);
            setIsLoadingPriceQuotes(false);
        });
    };
    const [totalSum, recurringSum] = (0, $8NFma.useMemo)(()=>{
        return (0, $7c83a2e55b930364$export$56eaa5cece9d2d8a)(props.checkoutData, priceQuotes, props.currency, props.discount);
    }, [
        props.checkoutData,
        priceQuotes,
        props.currency,
        props.discount
    ]);
    const recurringInterval = ()=>{
        if (props.checkoutData.products) {
            const g = props.checkoutData.products.find((p)=>p.product.chargingIntervalSeconds > 0);
            if (g) return g.product.chargingIntervalSeconds / 60 / 60 / 24;
        }
        if (props.checkoutData.lineItems) {
            const g = props.checkoutData.lineItems.find((p)=>p.chargingIntervalSeconds > 0);
            if (g) return g.chargingIntervalSeconds / 60 / 60 / 24;
        }
        return 0;
    };
    const nextBillingAt = ()=>{
        if (props.checkoutData.products) {
            const g = props.checkoutData.products.find((p)=>p.product.chargingIntervalSeconds > 0);
            if (g?.product.nextBillingDateAt) return (0, $965fc399e1b2030f$export$2e2bcd8739ae039)(new Date(g.product.nextBillingDateAt), new Date());
        }
        if (props.checkoutData.lineItems) {
            const g = props.checkoutData.lineItems.find((p)=>p.chargingIntervalSeconds > 0);
            if (g?.nextBillingDateAt) return (0, $965fc399e1b2030f$export$2e2bcd8739ae039)(new Date(g.nextBillingDateAt), new Date());
        }
        return (0, $965fc399e1b2030f$export$2e2bcd8739ae039)(new Date(new Date().getTime() + recurringInterval() * 86400000), new Date());
    };
    (0, $8NFma.useEffect)(()=>{
        if ((0, $O6tRJ.isEqual)(localCheckoutData.gateway, props.checkoutData.gateway) && (0, $O6tRJ.isEqual)(localCheckoutData.products, props.checkoutData.products) && (0, $O6tRJ.isEqual)(localCheckoutData.lineItems, props.checkoutData.lineItems) && (0, $O6tRJ.isEqual)(localCheckoutData.currency, props.checkoutData.currency) && (0, $O6tRJ.isEqual)(localCheckoutData.total, props.checkoutData.total)) return;
        if (props.checkoutData.gateway.managed) {
            const method = props.checkoutData.gateway.managed.methods[0];
            if (method) setSelectedMethod((0, $61f236426b9e4eab$export$8793fab959da70d1)(method.network, method.token));
            setLocalCheckoutData((0, $O6tRJ.cloneDeep)(props.checkoutData));
            getPriceQuotes();
        }
    }, [
        props.checkoutData
    ]);
    (0, $8NFma.useEffect)(()=>{
        getPriceQuotes();
    }, [
        props.checkoutData.products?.length
    ]);
    (0, $8NFma.useEffect)(()=>{
        const myInterval = setInterval(()=>{
            if (quoteExpiryTimestamp.getTime() <= new Date().getTime()) getPriceQuotes();
            setQuoteSecondsRemaining((quoteExpiryTimestamp.getTime() - new Date().getTime()) / 1000);
        }, 1000);
        return ()=>clearInterval(myInterval);
    }, [
        quoteExpiryTimestamp
    ]);
    const [managedPaymentQrCode, setManagedPaymentQrCode] = (0, $8NFma.useState)("");
    const [isManagedEVMTxLoading, setIsManagedEVMTxLoading] = (0, $8NFma.useState)(false);
    const [errorMessage, setErrorMessage] = (0, $8NFma.useState)();
    const [managedSubscriptionState, setManagedSubscriptionState] = (0, $8NFma.useState)();
    const [selectedSubscriptionType, setSelectedSubscriptionType] = (0, $8NFma.useState)();
    const [receiveEmailNotifications, setReceiveEmailNotifications] = (0, $8NFma.useState)(false);
    const generateManagedPaymentQrCode = async ()=>{
        if (!props.managedPaymentDetails) return;
        const [qrCodeData] = await (0, $d70492f3fe4454f0$export$45312203e6f4f22c)(props.managedPaymentDetails);
        setManagedPaymentQrCode(qrCodeData);
    };
    const onClickOpenWallet = async ()=>{
        if (!props.managedPaymentDetails) return;
        switch(props.managedPaymentDetails.network){
            case "Bitcoin":
            case "Solana":
            case "Zcash":
            case "ZcashTestnet":
            case "Polkadot":
            case "PolkadotTestnet":
            case "PolkadotAssetHub":
            case "PolkadotAssetHubTestnet":
                break;
            case "Ethereum":
            case "SepoliaTestnet":
            case "Polygon":
            case "PolygonTestnet":
            case "BNB":
            case "BNBTestnet":
            case "Base":
            case "Arbitrum":
            case "Avalanche":
                try {
                    setErrorMessage("");
                    if (!address) {
                        await open();
                        return;
                    }
                    setIsManagedEVMTxLoading(true);
                    const chain = (0, $61f236426b9e4eab$export$cc4208a8ebc9f985)[props.managedPaymentDetails.network];
                    const provider = await connector?.getProvider();
                    const signer = (0, $d7839887e0efaf1b$export$362b8ea2edbd9090)({
                        chain: chain,
                        transport: (0, $11d4efd0771a10a6$export$4c00f665f0d4b443)(provider)
                    });
                    if (connector?.switchChain) {
                        const chainId = await connector.getChainId();
                        if (chainId !== chain.id) await connector?.switchChain({
                            chainId: chain.id
                        });
                    }
                    if (props.managedPaymentDetails.token) {
                        const method = (0, $61f236426b9e4eab$export$8793fab959da70d1)(props.managedPaymentDetails.network, props.managedPaymentDetails.token);
                        const contract = (0, $740fc174ca817919$export$f518c38144e1f9d)({
                            address: props.managedPaymentDetails.token,
                            abi: (0, $9nOfC.erc20Abi),
                            client: signer
                        });
                        try {
                            const balance = await contract.read.balanceOf([
                                address
                            ]);
                            const decimals = await contract.read.decimals();
                            const parsedAmount = (0, $996ac4676bde0a02$export$203ae30b4f6490b3)(totalSum.toString(), decimals);
                            if (balance < parsedAmount) {
                                setIsManagedEVMTxLoading(false);
                                return setErrorMessage(`Your wallet does not have enough ${selectedMethod?.name} for payment.`);
                            }
                        } catch (err) {
                            console.error("Failed to get token balance using injected provider", err);
                        }
                        await contract.write.transfer([
                            props.managedPaymentDetails.paymentAddress,
                            (0, $996ac4676bde0a02$export$203ae30b4f6490b3)(props.managedPaymentDetails.amount, method.tokenInfo?.decimals ?? 6)
                        ], {
                            account: address,
                            chain: chain
                        });
                    } else {
                        const client = (0, $7c826deba1e299e5$export$d8e090d8c6a7a6ad)({
                            chain: chain,
                            transport: (0, $11d4efd0771a10a6$export$4c00f665f0d4b443)(provider)
                        });
                        try {
                            const balance = await client.getBalance({
                                address: address
                            });
                            if (balance < (0, $1a21c088f688ce4c$export$642c4e67bbdc0bc7)(props.managedPaymentDetails.amount)) {
                                setIsManagedEVMTxLoading(false);
                                return setErrorMessage("Your wallet does not have enough ether for payment.");
                            }
                        } catch (err) {
                            console.error("Failed to get balance using injected provider", err);
                        }
                        if (!signer) return;
                        await signer.sendTransaction({
                            account: address,
                            chain: chain,
                            to: props.managedPaymentDetails.paymentAddress,
                            value: (0, $1a21c088f688ce4c$export$642c4e67bbdc0bc7)(props.managedPaymentDetails.amount)
                        });
                    }
                } catch (err) {
                    setIsManagedEVMTxLoading(false);
                    setErrorMessage("Failed to open wallet. Please ensure you have enough funds.");
                    console.error(err);
                }
                break;
            default:
                console.error("No wallet");
        }
    };
    const [isSigningMessage, setIsSigningMessage] = (0, $8NFma.useState)(false);
    const [isSettingAllowance, setIsSettingAllowance] = (0, $8NFma.useState)(false);
    const [allowSkipAllowance, setAllowSkipAllowance] = (0, $8NFma.useState)(false);
    const setManagedSubscriptionAllowance = async ()=>{
        if (selectedMethod?.tokenInfo?.tokenType !== "evm") return;
        if (!address) {
            await open();
            return;
        }
        setIsSettingAllowance(true);
        try {
            if (!address) return;
            const chain = (0, $61f236426b9e4eab$export$cc4208a8ebc9f985)[selectedMethod.tokenInfo.networkName];
            const provider = await connector?.getProvider();
            const signer = (0, $d7839887e0efaf1b$export$362b8ea2edbd9090)({
                chain: chain,
                transport: (0, $11d4efd0771a10a6$export$4c00f665f0d4b443)(provider)
            });
            if (connector?.switchChain) {
                const chainId = await connector.getChainId();
                if (chainId !== chain.id) await connector?.switchChain({
                    chainId: chain.id
                });
            }
            const contract = (0, $740fc174ca817919$export$f518c38144e1f9d)({
                address: selectedMethod.tokenInfo.tokenAddress,
                abi: (0, $9nOfC.erc20Abi),
                client: {
                    public: signer,
                    wallet: signer
                }
            });
            const balance = await contract.read.balanceOf([
                address
            ]);
            const parsedAmount = (0, $996ac4676bde0a02$export$203ae30b4f6490b3)(totalSum.toString(), selectedMethod.tokenInfo.decimals);
            if (balance < parsedAmount) {
                setIsSettingAllowance(false);
                return setErrorMessage(`Your wallet does not have enough ${selectedMethod?.name} for payment.`);
            }
            const allowance = await contract.read.allowance([
                address,
                selectedMethod.tokenInfo.subscriptionContract
            ]);
            if (allowance <= BigInt(0) || allowance < parsedAmount * BigInt(300)) {
                if (selectedMethod.name === "Tether" && allowance > 0) {
                    const hash = await contract.write.approve([
                        selectedMethod.tokenInfo.subscriptionContract,
                        0n
                    ], {
                        account: address,
                        chain: chain
                    });
                    if (hash) try {
                        await (0, $94fe8f93f76c1ac5$export$694ec9bdf0bb55cf)(signer, {
                            hash: hash,
                            retryCount: 30,
                            retryDelay: 1000
                        });
                    } catch (err) {
                        console.error("Failed to confirm allowance tx", err);
                    }
                }
                const hash = await contract.write.approve([
                    selectedMethod.tokenInfo.subscriptionContract,
                    (0, $4231b4de1126cff9$export$48de485e50a67ffa)
                ], {
                    account: address,
                    chain: chain
                });
                if (hash) try {
                    console.log("Waiting for tx receipt");
                    await (0, $94fe8f93f76c1ac5$export$694ec9bdf0bb55cf)(signer, {
                        hash: hash,
                        retryCount: 30,
                        retryDelay: 1000
                    });
                } catch (err) {
                    console.error("Failed to confirm allowance tx", err);
                }
            }
            setIsSettingAllowance(false);
            setManagedSubscriptionState(1);
        } catch (err) {
            setIsSettingAllowance(false);
            setErrorMessage("Failed to set allowance");
            console.error(err);
        }
    };
    (0, $8NFma.useEffect)(()=>{
        if (props.managedPaymentDetails) {
            generateManagedPaymentQrCode();
            if (managedSubscriptionState !== undefined) setManagedSubscriptionState(3);
        }
    }, [
        props.managedPaymentDetails
    ]);
    const [gasCost, setGasCost] = (0, $8NFma.useState)("");
    (0, $8NFma.useEffect)(()=>{
        if (managedSubscriptionState === undefined) {
            setSelectedSubscriptionType(undefined);
            setReceiveEmailNotifications(false);
        }
        if (selectedMethod?.tokenInfo && selectedMethod.tokenInfo.tokenType === "evm") (0, $6cc04e58a8fffbcd$export$2e2bcd8739ae039).estimateTokenTranferGas(selectedMethod.tokenInfo.networkName, selectedMethod.tokenInfo.tokenAddress).then((g)=>{
            setGasCost(g.gasCost);
        }).catch((err)=>console.error(err));
    }, [
        managedSubscriptionState
    ]);
    const [isLoadingAllowance, setIsLoadingAllowance] = (0, $8NFma.useState)(false);
    const computeAllowanceStep = async ()=>{
        if (!props.tokenDelegatePaymentDetails) return;
        if (selectedMethod?.tokenInfo?.tokenType !== "evm") return;
        if (!address || !connector) {
            await open();
            return;
        }
        setIsLoadingAllowance(true);
        setErrorMessage("");
        let signer;
        const chain = (0, $61f236426b9e4eab$export$cc4208a8ebc9f985)[props.tokenDelegatePaymentDetails.network];
        const publicClient = (0, $7c826deba1e299e5$export$d8e090d8c6a7a6ad)({
            chain: chain,
            transport: (0, $f31cbc431d98644d$export$7d6f1c8842f9f527)()
        });
        try {
            const provider = await connector?.getProvider();
            signer = (0, $d7839887e0efaf1b$export$362b8ea2edbd9090)({
                chain: chain,
                transport: (0, $11d4efd0771a10a6$export$4c00f665f0d4b443)(provider)
            });
            if (connector?.switchChain) {
                const chainId = await connector.getChainId();
                if (chainId !== chain.id) await connector?.switchChain({
                    chainId: chain.id
                });
            }
        } catch (err) {
            setIsLoadingAllowance(false);
            setErrorMessage(err.toString());
            return;
        }
        const contract = (0, $740fc174ca817919$export$f518c38144e1f9d)({
            address: selectedMethod.tokenInfo.tokenAddress,
            abi: (0, $9nOfC.erc20Abi),
            client: {
                public: signer,
                wallet: signer
            }
        });
        try {
            if (!address) return;
            const allowance = await contract.read.allowance([
                address,
                selectedMethod.tokenInfo.subscriptionContract
            ]);
            const parsedAmount = (0, $996ac4676bde0a02$export$203ae30b4f6490b3)(totalSum.toString(), 6);
            if (allowance >= parsedAmount) setAllowSkipAllowance(true);
        } catch (err) {
            setAllowSkipAllowance(true);
        }
        setIsLoadingAllowance(false);
        setManagedSubscriptionState(2);
    };
    (0, $8NFma.useEffect)(()=>{
        if (props.tokenDelegatePaymentDetails) computeAllowanceStep();
        else if (managedSubscriptionState === 1) setManagedSubscriptionState(0);
    }, [
        props.tokenDelegatePaymentDetails
    ]);
    (0, $8NFma.useEffect)(()=>{
        setErrorMessage(props.errorMessage);
    }, [
        props.errorMessage
    ]);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($6795754bca05c124$var$Wrapper, {
        disableAnimation: props.disableAnimation,
        children: [
            !props.isPreProcessingPayment && props.isSuccess && props.successElement,
            errorMessage && errorMessage.length > 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                style: {
                    backgroundColor: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).ERROR,
                    padding: 15,
                    borderRadius: 5,
                    marginBottom: 20,
                    color: "white",
                    overflowWrap: "break-word"
                },
                children: errorMessage
            }),
            !props.isSuccess && props.checkoutData.gateway.managed && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($6795754bca05c124$var$Container, {
                disableAnimation: props.disableAnimation,
                children: [
                    !props.managedPaymentDetails && managedSubscriptionState === undefined && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($6795754bca05c124$var$Container, {
                        disableAnimation: props.disableAnimation,
                        children: [
                            props.checkoutData.inputFields && props.checkoutData.inputFields.length > 0 && !props.isSuccess && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                style: {
                                    width: "100%",
                                    display: "grid",
                                    gap: 20,
                                    paddingBottom: 25,
                                    borderBottom: `1px solid ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_MED}`
                                },
                                children: localInputFields.map((c, i)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: 10
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 8
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $fbcecf017801e70f$export$76d3231fec538b73), {
                                                        children: c.inputLabel === "" ? "Input label" : c.inputLabel
                                                    }),
                                                    !c.isRequired && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $fbcecf017801e70f$export$bd0cf18531183c14), {
                                                        children: "Optional"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                children: [
                                                    [
                                                        "Email",
                                                        "String"
                                                    ].includes(c.dataType) && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $fbcecf017801e70f$export$c86715117507e8e5), {
                                                        disabled: props.isPreProcessingPayment,
                                                        ref: (el)=>inputRefs.current[i] = el,
                                                        placeholder: `Enter ${c.inputLabel.toLowerCase()}`,
                                                        value: c.value,
                                                        required: c.isRequired,
                                                        onInput: (e)=>{
                                                            const target = e.target;
                                                            let val = target.value;
                                                            if (c.inputLabel === "Email address") val = val.toLowerCase();
                                                            const newInputs = localInputFields.slice();
                                                            newInputs[i].value = val;
                                                            props.onInputFieldsChange?.(newInputs);
                                                            setSubscriptionEmailAddress(val.toLowerCase());
                                                        }
                                                    }),
                                                    c.dataType === "Number" && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $fbcecf017801e70f$export$c86715117507e8e5), {
                                                        disabled: props.isPreProcessingPayment,
                                                        type: "number",
                                                        value: c.value,
                                                        ref: (el)=>inputRefs.current[i] = el,
                                                        required: c.isRequired,
                                                        placeholder: "Enter a number",
                                                        onInput: (e)=>{
                                                            const val = e.target.value;
                                                            const newInputs = localInputFields.slice();
                                                            newInputs[i].value = val;
                                                            props.onInputFieldsChange?.(newInputs);
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    }, i))
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 10
                                },
                                children: [
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $fbcecf017801e70f$export$76d3231fec538b73), {
                                                children: "Payment method"
                                            }),
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    gap: 5,
                                                    borderRadius: 5,
                                                    padding: "3px 6px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                        style: {
                                                            color: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARKER,
                                                            fontSize: 12,
                                                            textTransform: "uppercase"
                                                        },
                                                        children: "Quote expiry"
                                                    }),
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                        style: {
                                                            display: "flex",
                                                            alignItems: "center",
                                                            fontSize: 12
                                                        },
                                                        children: isLoadingPriceQuotes ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $8cb41b6cdada8dfd$export$2e2bcd8739ae039), {
                                                            style: {
                                                                width: 10,
                                                                height: 10
                                                            }
                                                        }) : $6795754bca05c124$export$8e3f267d166b4a05(quoteSecondsRemaining)
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                        style: {
                                            border: "1px solid",
                                            borderColor: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARK,
                                            borderRadius: 5,
                                            maxHeight: "300px",
                                            overflow: "auto"
                                        },
                                        children: [
                                            // For invoice preview
                                            props.checkoutData.gateway.managed.methods.length === 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                style: {
                                                    fontSize: 14,
                                                    color: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARKER,
                                                    margin: 20
                                                },
                                                children: "No available payment methods"
                                            }),
                                            props.checkoutData.gateway.managed.methods.map((method)=>({
                                                    method: (0, $61f236426b9e4eab$export$8793fab959da70d1)(method.network, method.token),
                                                    discount: method.discountPercentOff
                                                })).map(({ method: method, discount: discount }, i)=>{
                                                return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($6795754bca05c124$export$6f653acab4a8965a, {
                                                    isDisabled: props.isPreProcessingPayment || isLoadingAllowance,
                                                    isSelected: (0, $O6tRJ.isEqual)(selectedMethod, method),
                                                    onClick: ()=>{
                                                        if (props.isPreProcessingPayment) return;
                                                        setSelectedMethod(method);
                                                    },
                                                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                        style: {
                                                            display: "flex",
                                                            gap: 10,
                                                            alignItems: "center"
                                                        },
                                                        children: [
                                                            (0, $O6tRJ.isEqual)(selectedMethod, method) && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($6795754bca05c124$var$CheckmarkWrapper, {
                                                                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $8cf33920e53a48fc$export$2e2bcd8739ae039), {
                                                                    width: 20,
                                                                    height: 20,
                                                                    animationDelay: "0",
                                                                    strokeWidth: 5
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                                style: {
                                                                    width: 30,
                                                                    height: 30,
                                                                    backgroundImage: `url(${method.logo})`,
                                                                    backgroundSize: "contain",
                                                                    backgroundPosition: "center",
                                                                    backgroundRepeat: "no-repeat",
                                                                    position: "relative"
                                                                },
                                                                children: method.tokenInfo && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                                    style: {
                                                                        background: "rgba(255, 255, 255, 0.95)",
                                                                        borderRadius: "100%",
                                                                        width: 15,
                                                                        height: 15,
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        position: "absolute",
                                                                        bottom: -1,
                                                                        right: -5,
                                                                        boxShadow: "0 0 1px"
                                                                    },
                                                                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                                        style: {
                                                                            width: 10,
                                                                            height: 10,
                                                                            backgroundImage: `url(${method.tokenInfo.logo})`,
                                                                            backgroundSize: "contain",
                                                                            backgroundPosition: "center",
                                                                            backgroundRepeat: "no-repeat"
                                                                        }
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                                style: {
                                                                    display: "flex",
                                                                    flexDirection: "column"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                                        style: {
                                                                            display: "flex",
                                                                            gap: 5,
                                                                            fontSize: 16,
                                                                            alignItems: "center"
                                                                        },
                                                                        children: [
                                                                            discount && discount > 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                                                style: {
                                                                                    textDecoration: "line-through",
                                                                                    opacity: 0.5
                                                                                },
                                                                                children: isLoadingPriceQuotes ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $8cb41b6cdada8dfd$export$2e2bcd8739ae039), {}) : (0, $2a4a168be657655e$export$f5dd818bff069720)((0, $7c83a2e55b930364$export$61a490a80c552550)(totalSum, props.currency, method.ticker, priceQuotes, props.checkoutData.chargeCustomerNetworkFee), {
                                                                                    minimumFractionDigits: 2,
                                                                                    maximumFractionDigits: 18
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                                                children: isLoadingPriceQuotes ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $8cb41b6cdada8dfd$export$2e2bcd8739ae039), {}) : (0, $2a4a168be657655e$export$f5dd818bff069720)((0, $7c83a2e55b930364$export$61a490a80c552550)(totalSum, props.currency, method.ticker, priceQuotes, props.checkoutData.chargeCustomerNetworkFee, discount), {
                                                                                    minimumFractionDigits: 2,
                                                                                    maximumFractionDigits: 18
                                                                                })
                                                                            }),
                                                                            discount && discount > 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                                                                                style: {
                                                                                    padding: "1px 5px",
                                                                                    fontSize: 11,
                                                                                    fontWeight: 600,
                                                                                    background: "linear-gradient(to right top, rgb(102 233 201), rgb(250 255 231 / 92%))",
                                                                                    border: "1px solid rgb(7 210 7 / 63%)",
                                                                                    boxShadow: "rgb(7 210 7 / 73%) 0px 0px 3px",
                                                                                    borderRadius: 5,
                                                                                    textTransform: "uppercase",
                                                                                    color: "#4aa233"
                                                                                },
                                                                                children: [
                                                                                    discount * 100,
                                                                                    "% off"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                                        style: {
                                                                            display: "flex",
                                                                            alignItems: "baseline",
                                                                            gap: 3
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                                                style: {
                                                                                    fontSize: 12,
                                                                                    color: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARKER
                                                                                },
                                                                                children: method.ticker
                                                                            }),
                                                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                                                                                style: {
                                                                                    color: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARKEST
                                                                                },
                                                                                children: [
                                                                                    "on ",
                                                                                    method.tokenInfo?.networkName ?? method.name
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }, i);
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $348d722f77cc9b90$export$ac16a6a04d9b7c84), {
                                isLoading: isLoadingPriceQuotes || isLoadingAllowance || props.isPreProcessingPayment,
                                style: {
                                    background: props.checkoutData.customizations?.primaryButtonColor,
                                    width: "100%",
                                    margin: "auto"
                                },
                                onClick: ()=>{
                                    if (!selectedMethod) return;
                                    if (recurringInterval() > 0) {
                                        setManagedSubscriptionState(0);
                                        return;
                                    }
                                    props.onCheckout({
                                        managed: {
                                            selectedMethod: selectedMethod
                                        },
                                        priceQuotes: priceQuotes
                                    });
                                },
                                children: "Continue"
                            })
                        ]
                    }),
                    !props.managedPaymentDetails && managedSubscriptionState === 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($6795754bca05c124$var$Container, {
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 10
                                },
                                children: [
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                        children: "Payment method"
                                    }),
                                    selectedMethod && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            gap: 15,
                                            alignItems: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                style: {
                                                    width: 30,
                                                    height: 30,
                                                    backgroundImage: `url(${selectedMethod.logo})`,
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "center",
                                                    backgroundRepeat: "no-repeat",
                                                    position: "relative"
                                                },
                                                children: selectedMethod.tokenInfo && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                    style: {
                                                        background: "rgba(255, 255, 255, 0.95)",
                                                        borderRadius: "100%",
                                                        width: 15,
                                                        height: 15,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        position: "absolute",
                                                        bottom: -1,
                                                        right: -5,
                                                        boxShadow: "0 0 1px"
                                                    },
                                                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                        style: {
                                                            width: 10,
                                                            height: 10,
                                                            backgroundImage: `url(${selectedMethod.tokenInfo.logo})`,
                                                            backgroundSize: "contain",
                                                            backgroundPosition: "center",
                                                            backgroundRepeat: "no-repeat"
                                                        }
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    flexDirection: "column"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                        style: {
                                                            color: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARKER
                                                        },
                                                        children: selectedMethod.ticker
                                                    }),
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                        style: {
                                                            color: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARKEST
                                                        },
                                                        children: selectedMethod.tokenInfo?.networkName ?? selectedMethod.name
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 15
                                },
                                children: [
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                        children: "Select subscription type"
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: 10
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $348d722f77cc9b90$export$ac16a6a04d9b7c84), {
                                                disabled: props.isPreProcessingPayment || isLoadingAllowance || !(0, $61f236426b9e4eab$export$aab47327b38c6232)(selectedMethod),
                                                style: {
                                                    background: "none",
                                                    color: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).BLACK,
                                                    justifyContent: "flex-start",
                                                    border: `1px solid ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARK}`,
                                                    padding: 20,
                                                    borderRadius: 5,
                                                    fontSize: 14
                                                },
                                                onClick: ()=>setSelectedSubscriptionType(1),
                                                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                    style: {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 10,
                                                        justifyContent: "space-between",
                                                        width: "100%"
                                                    },
                                                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                        style: {
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: 10
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $db6f3e1460c65a23$export$2e2bcd8739ae039), {
                                                                isRadio: true,
                                                                checked: selectedSubscriptionType === 1
                                                            }),
                                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                                style: {
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    alignItems: "flex-start"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                                        style: {
                                                                            textAlign: "left"
                                                                        },
                                                                        children: "Subscribe with auto renew"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                                        style: {
                                                                            opacity: 0.5,
                                                                            textAlign: "left"
                                                                        },
                                                                        children: "Set an alllowance and automatically pay"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $348d722f77cc9b90$export$ac16a6a04d9b7c84), {
                                                disabled: props.isPreProcessingPayment || isLoadingAllowance,
                                                style: {
                                                    background: "none",
                                                    color: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).BLACK,
                                                    justifyContent: "flex-start",
                                                    border: `1px solid ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARK}`,
                                                    padding: 20,
                                                    borderRadius: 5,
                                                    fontSize: 14
                                                },
                                                onClick: ()=>setSelectedSubscriptionType(0),
                                                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                    style: {
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 10,
                                                        justifyContent: "space-between",
                                                        width: "100%"
                                                    },
                                                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                        style: {
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: 10
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $db6f3e1460c65a23$export$2e2bcd8739ae039), {
                                                                isRadio: true,
                                                                checked: selectedSubscriptionType === 0
                                                            }),
                                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                                style: {
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    alignItems: "flex-start"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                                        style: {
                                                                            textAlign: "left"
                                                                        },
                                                                        children: "Subscribe with email invoices"
                                                                    }),
                                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                                        style: {
                                                                            opacity: 0.5,
                                                                            textAlign: "left"
                                                                        },
                                                                        children: "Manually pay using email invoices"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    selectedSubscriptionType === 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: 10
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                children: "Email address"
                                            }),
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $fbcecf017801e70f$export$c86715117507e8e5), {
                                                autoFocus: true,
                                                placeholder: "Enter email address",
                                                value: subscriptionEmailAddress,
                                                onChange: (e)=>setSubscriptionEmailAddress(e.target.value.toLowerCase())
                                            })
                                        ]
                                    }),
                                    selectedSubscriptionType === 1 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: 10
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    gap: 8,
                                                    alignItems: "center",
                                                    cursor: "pointer"
                                                },
                                                onClick: ()=>setReceiveEmailNotifications(!receiveEmailNotifications),
                                                children: [
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $db6f3e1460c65a23$export$2e2bcd8739ae039), {
                                                        checked: receiveEmailNotifications
                                                    }),
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                        children: "Send me email notifications about my subscription"
                                                    })
                                                ]
                                            }),
                                            receiveEmailNotifications && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $fbcecf017801e70f$export$c86715117507e8e5), {
                                                autoFocus: true,
                                                placeholder: "Enter email address",
                                                value: subscriptionEmailAddress,
                                                onChange: (e)=>setSubscriptionEmailAddress(e.target.value.toLowerCase())
                                            })
                                        ]
                                    })
                                ]
                            }),
                            selectedSubscriptionType === 1 && address && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($6795754bca05c124$var$ConnectedWalletContainer, {
                                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        flexDirection: "column",
                                        border: `1px solid ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARK}`,
                                        borderRadius: 5
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                justifyContent: "space-between",
                                                padding: 15,
                                                backgroundColor: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_MED
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                    style: {
                                                        fontSize: 14
                                                    },
                                                    children: "Connected wallet"
                                                }),
                                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $348d722f77cc9b90$export$f861551692d63a2e), {
                                                    style: {
                                                        border: 0,
                                                        padding: 0,
                                                        color: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).BLACK,
                                                        fontSize: 10,
                                                        textTransform: "uppercase"
                                                    },
                                                    onClick: ()=>disconnect(),
                                                    children: "Disconnect"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                            style: {
                                                padding: 15
                                            },
                                            children: address
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $348d722f77cc9b90$export$ac16a6a04d9b7c84), {
                                isLoading: isLoadingPriceQuotes || isSettingAllowance || props.isPreProcessingPayment || isLoadingAllowance,
                                disabled: selectedSubscriptionType === undefined || selectedSubscriptionType === 0 && !subscriptionEmailAddress,
                                style: {
                                    background: props.checkoutData.customizations?.primaryButtonColor,
                                    width: "100%",
                                    margin: "auto"
                                },
                                onClick: async ()=>{
                                    if (selectedSubscriptionType === 1 && !isConnected) return await open();
                                    if (!selectedMethod || selectedSubscriptionType === undefined) return;
                                    props.onCheckout({
                                        managed: {
                                            selectedMethod: selectedMethod
                                        },
                                        priceQuotes: priceQuotes,
                                        subscriptionOptions: {
                                            autopay: selectedSubscriptionType === 1 ? {
                                                subscriptionType: selectedSubscriptionType,
                                                address: address
                                            } : undefined,
                                            emailInvoice: selectedSubscriptionType === 0 ? {
                                                subscriptionType: selectedSubscriptionType,
                                                emailAddress: subscriptionEmailAddress.toLowerCase()
                                            } : undefined
                                        }
                                    });
                                },
                                children: selectedSubscriptionType === 1 && !isConnected ? "Connect wallet" : "Continue"
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $348d722f77cc9b90$export$f861551692d63a2e), {
                                disabled: isLoadingPriceQuotes || isSettingAllowance || isLoadingAllowance || props.isPreProcessingPayment,
                                style: {
                                    border: 0,
                                    padding: 5,
                                    color: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARKER
                                },
                                onClick: ()=>{
                                    console.log("resetting error message");
                                    setManagedSubscriptionState(undefined);
                                    setErrorMessage("");
                                },
                                children: "Change payment method"
                            })
                        ]
                    }),
                    !props.managedPaymentDetails && (managedSubscriptionState === 2 || managedSubscriptionState === 1) && selectedMethod && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($6795754bca05c124$var$Container, {
                        style: {
                            gap: 30
                        },
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    userSelect: "none",
                                    alignItems: "center",
                                    gap: 10,
                                    padding: 15,
                                    borderRadius: 5,
                                    border: `1px solid ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_MED}`
                                },
                                children: [
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 5,
                                            flexShrink: 0,
                                            padding: "0 20px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                style: {
                                                    display: "flex",
                                                    borderRadius: "100%",
                                                    width: 20,
                                                    height: 20,
                                                    backgroundColor: managedSubscriptionState === 1 ? (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).SUCCESS_LIGHT : (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).NICE_GREEN,
                                                    fontSize: 12,
                                                    fontWeight: 500,
                                                    color: "white",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    transition: "0.2s ease all"
                                                },
                                                children: "1"
                                            }),
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                style: {
                                                    fontSize: 16,
                                                    fontWeight: managedSubscriptionState === 1 ? 300 : 400,
                                                    color: managedSubscriptionState === 1 ? (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARKEST : (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).BLACK,
                                                    transition: "0.2s ease all"
                                                },
                                                children: "Set allowance"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                        style: {
                                            width: "100%",
                                            backgroundColor: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARK,
                                            height: 2,
                                            borderRadius: 2,
                                            flexGrow: 1,
                                            transition: "0.2s ease all"
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 5,
                                            flexShrink: 0,
                                            padding: "0 20px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                style: {
                                                    display: "flex",
                                                    borderRadius: "100%",
                                                    width: 20,
                                                    height: 20,
                                                    backgroundColor: managedSubscriptionState === 1 ? (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).NICE_GREEN : (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARKER,
                                                    fontSize: 12,
                                                    fontWeight: 500,
                                                    color: "white",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    transition: "0.2s ease all"
                                                },
                                                children: "2"
                                            }),
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                style: {
                                                    fontSize: 16,
                                                    fontWeight: managedSubscriptionState === 1 ? 400 : 300
                                                },
                                                children: "Subscribe"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            managedSubscriptionState === 2 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $13f4c0370d7de649$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: 10,
                                            color: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).BLACK,
                                            borderRadius: 5
                                        },
                                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                            children: "Set an allowance to enable automatically recurring payments for your subscription."
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: 10
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $348d722f77cc9b90$export$ac16a6a04d9b7c84), {
                                                isLoading: isLoadingPriceQuotes || isSettingAllowance,
                                                style: {
                                                    background: props.checkoutData.customizations?.primaryButtonColor,
                                                    width: "100%",
                                                    margin: "auto"
                                                },
                                                onClick: ()=>{
                                                    setErrorMessage("");
                                                    setManagedSubscriptionAllowance();
                                                },
                                                children: "Set allowance"
                                            }),
                                            allowSkipAllowance && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $348d722f77cc9b90$export$f861551692d63a2e), {
                                                disabled: isLoadingPriceQuotes || isSettingAllowance,
                                                style: {
                                                    padding: 5,
                                                    color: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARKER,
                                                    borderColor: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARK
                                                },
                                                onClick: ()=>setManagedSubscriptionState(1),
                                                children: "Skip"
                                            }),
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $348d722f77cc9b90$export$f861551692d63a2e), {
                                                disabled: isLoadingPriceQuotes || isSettingAllowance,
                                                style: {
                                                    border: 0,
                                                    padding: 5,
                                                    color: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARKER
                                                },
                                                onClick: ()=>{
                                                    setManagedSubscriptionState(undefined);
                                                    setErrorMessage("");
                                                },
                                                children: "Change payment method"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            managedSubscriptionState === 1 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($6795754bca05c124$var$Container, {
                                children: [
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                        style: {
                                            boxShadow: `0 0 3px ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARK}`,
                                            borderRadius: 5
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                style: {
                                                    backgroundColor: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_MED,
                                                    border: `1px solid ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARK}`,
                                                    borderTopLeftRadius: 5,
                                                    borderTopRightRadius: 5,
                                                    padding: 10
                                                },
                                                children: "Initial payment"
                                            }),
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    gap: 15,
                                                    alignItems: "center",
                                                    border: `1px solid ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARK}`,
                                                    padding: 15,
                                                    borderTop: 0,
                                                    borderBottomLeftRadius: 5,
                                                    borderBottomRightRadius: 5
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                        style: {
                                                            width: 30,
                                                            height: 30,
                                                            backgroundImage: `url(${selectedMethod.logo})`,
                                                            backgroundSize: "contain",
                                                            backgroundPosition: "center",
                                                            backgroundRepeat: "no-repeat",
                                                            position: "relative"
                                                        },
                                                        children: selectedMethod.tokenInfo && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                            style: {
                                                                background: "rgba(255, 255, 255, 0.95)",
                                                                borderRadius: "100%",
                                                                width: 15,
                                                                height: 15,
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                position: "absolute",
                                                                bottom: -1,
                                                                right: -5,
                                                                boxShadow: "0 0 1px"
                                                            },
                                                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                                style: {
                                                                    width: 10,
                                                                    height: 10,
                                                                    backgroundImage: `url(${selectedMethod.tokenInfo.logo})`,
                                                                    backgroundSize: "contain",
                                                                    backgroundPosition: "center",
                                                                    backgroundRepeat: "no-repeat"
                                                                }
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                        style: {
                                                            display: "flex",
                                                            flexDirection: "column"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                                style: {
                                                                    display: "flex",
                                                                    gap: 5,
                                                                    alignItems: "center"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                                        style: {
                                                                            fontSize: 16
                                                                        },
                                                                        children: isLoadingPriceQuotes ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $8cb41b6cdada8dfd$export$2e2bcd8739ae039), {}) : (0, $2a4a168be657655e$export$f5dd818bff069720)((0, $7c83a2e55b930364$export$61a490a80c552550)(totalSum, props.currency, selectedMethod.ticker, priceQuotes, false), {
                                                                            minimumFractionDigits: 2,
                                                                            maximumFractionDigits: 18
                                                                        })
                                                                    }),
                                                                    props.checkoutData.chargeCustomerNetworkFee && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $13f4c0370d7de649$exports.Fragment), {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                                                children: "+"
                                                                            }),
                                                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                                                style: {
                                                                                    display: "flex",
                                                                                    alignItems: "center",
                                                                                    gap: 4,
                                                                                    backgroundColor: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_MED,
                                                                                    borderRadius: 5,
                                                                                    padding: "2px 6px",
                                                                                    color: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).BLACK
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $00de14b99ede8a79$export$2e2bcd8739ae039), {
                                                                                        style: {
                                                                                            height: 10
                                                                                        },
                                                                                        fill: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).BLACK
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                                                        children: gasCost
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                                style: {
                                                                    display: "flex",
                                                                    alignItems: "baseline",
                                                                    gap: 3
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                                        style: {
                                                                            fontSize: 12,
                                                                            color: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARKER
                                                                        },
                                                                        children: selectedMethod.ticker
                                                                    }),
                                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                                                                        style: {
                                                                            color: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARKEST
                                                                        },
                                                                        children: [
                                                                            "on ",
                                                                            selectedMethod.tokenInfo?.networkName ?? selectedMethod.name
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                        style: {
                                            boxShadow: `0 0 3px ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARK}`,
                                            borderRadius: 5
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                style: {
                                                    border: `1px solid ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARK}`,
                                                    borderBottom: 0,
                                                    borderTopLeftRadius: 5,
                                                    borderTopRightRadius: 5,
                                                    padding: 10,
                                                    color: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARKEST,
                                                    backgroundColor: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_LIGHTEST
                                                },
                                                children: "Recurring payments"
                                            }),
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 10,
                                                    padding: "10px 20px",
                                                    color: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARKEST,
                                                    borderTop: 0,
                                                    border: `1px solid ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARK}`,
                                                    borderBottomLeftRadius: 5,
                                                    borderBottomRightRadius: 5
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                        style: {
                                                            width: 20,
                                                            height: 20,
                                                            backgroundImage: `url(${selectedMethod.logo})`,
                                                            backgroundSize: "contain",
                                                            backgroundPosition: "center",
                                                            backgroundRepeat: "no-repeat",
                                                            position: "relative"
                                                        },
                                                        children: selectedMethod.tokenInfo && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                            style: {
                                                                background: "rgba(255, 255, 255, 0.95)",
                                                                borderRadius: "100%",
                                                                width: 12,
                                                                height: 12,
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                position: "absolute",
                                                                bottom: -1,
                                                                right: -5,
                                                                boxShadow: "0 0 1px"
                                                            },
                                                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                                style: {
                                                                    width: 8,
                                                                    height: 8,
                                                                    backgroundImage: `url(${selectedMethod.tokenInfo.logo})`,
                                                                    backgroundSize: "contain",
                                                                    backgroundPosition: "center",
                                                                    backgroundRepeat: "no-repeat"
                                                                }
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                        style: {
                                                            display: "flex",
                                                            gap: 3
                                                        },
                                                        children: [
                                                            (0, $2a4a168be657655e$export$f5dd818bff069720)((0, $7c83a2e55b930364$export$61a490a80c552550)(recurringSum, props.currency, selectedMethod.ticker, priceQuotes, false), {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            }),
                                                            " ",
                                                            props.checkoutData.chargeCustomerNetworkFee && `+ gas fee per ${(0, $643d9102d67b3722$export$d82eb24974fa9fd)(recurringInterval() * 86400).toLowerCase()}`,
                                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                                children: "starting"
                                                            }),
                                                            nextBillingAt()
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: 10
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $348d722f77cc9b90$export$ac16a6a04d9b7c84), {
                                                isLoading: isLoadingPriceQuotes || props.isPreProcessingPayment || isSigningMessage,
                                                style: {
                                                    background: props.checkoutData.customizations?.primaryButtonColor,
                                                    width: "100%",
                                                    margin: "auto"
                                                },
                                                onClick: async ()=>{
                                                    if (!props.tokenDelegatePaymentDetails || !address) return;
                                                    setErrorMessage("");
                                                    setIsSigningMessage(true);
                                                    try {
                                                        const chain = (0, $61f236426b9e4eab$export$cc4208a8ebc9f985)[props.tokenDelegatePaymentDetails.network];
                                                        const provider = await connector?.getProvider();
                                                        const signer = (0, $d7839887e0efaf1b$export$362b8ea2edbd9090)({
                                                            chain: chain,
                                                            transport: (0, $11d4efd0771a10a6$export$4c00f665f0d4b443)(provider)
                                                        });
                                                        const signature = await signer?.signMessage({
                                                            account: address,
                                                            message: props.tokenDelegatePaymentDetails.messageToSign
                                                        });
                                                        props.onCheckout({
                                                            completeTokenDelegate: {
                                                                paymentId: props.tokenDelegatePaymentDetails.paymentId,
                                                                signature: signature
                                                            },
                                                            priceQuotes: priceQuotes
                                                        });
                                                    } catch (err) {
                                                        setErrorMessage(err.toString());
                                                    }
                                                    setIsSigningMessage(false);
                                                },
                                                children: "Subscribe"
                                            }),
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $348d722f77cc9b90$export$f861551692d63a2e), {
                                                style: {
                                                    border: 0,
                                                    padding: 5,
                                                    color: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARKER
                                                },
                                                disabled: isLoadingPriceQuotes || props.isPreProcessingPayment || isSigningMessage,
                                                onClick: ()=>{
                                                    setManagedSubscriptionState(undefined);
                                                    setErrorMessage("");
                                                },
                                                children: "Change payment method"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    props.managedPaymentDetails && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($6795754bca05c124$var$Container, {
                        style: {
                            overflowWrap: "anywhere",
                            ...props.posMode && {
                                alignItems: "center",
                                gap: 60,
                                overflowWrap: "normal"
                            }
                        },
                        children: [
                            props.posMode && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($6795754bca05c124$export$c825e58f74061357, {
                                children: [
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($6795754bca05c124$export$b8bb87b40c00c04e, {}),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($6795754bca05c124$export$6128c696434ef87c, {}),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($6795754bca05c124$export$bd3f954aa84a63d6, {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($6795754bca05c124$var$Styles, {}),
                            props.posMode && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "column",
                                    fontSize: 12,
                                    gap: 3,
                                    alignItems: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                        style: {
                                            opacity: 0.5,
                                            textTransform: "uppercase",
                                            textAlign: props.posMode ? "center" : undefined
                                        },
                                        children: "Time remaining"
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                        style: {
                                            fontSize: 16,
                                            fontWeight: 100,
                                            textAlign: "center"
                                        },
                                        children: $6795754bca05c124$export$8e3f267d166b4a05((new Date(props.paymentStatus?.expiresAt ?? props.managedPaymentDetails.expiresAt).getTime() - new Date().getTime()) / 1000)
                                    })
                                ]
                            }),
                            props.paymentStatus?.status !== "expired" && props.checkoutData.customizations?.displayQrCode !== false && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($6795754bca05c124$export$ec3c7ce6a909733b, {
                                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($6795754bca05c124$export$3c6b4f0e2cd37515, {
                                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                                        src: managedPaymentQrCode,
                                        style: {
                                            width: 200,
                                            height: 200
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 20,
                                    ...props.posMode && {
                                        gap: 40
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            fontSize: 12,
                                            gap: 3,
                                            ...props.posMode && {
                                                alignItems: "center"
                                            }
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 5
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                        style: {
                                                            opacity: 0.5,
                                                            textTransform: "uppercase"
                                                        },
                                                        children: "Payment address"
                                                    }),
                                                    props.paymentStatus?.status !== "expired" && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($6795754bca05c124$export$4f2558dd25106ae2, {
                                                        onClick: async ()=>await navigator.clipboard.writeText(props.managedPaymentDetails?.paymentAddress ?? "")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                style: {
                                                    fontSize: 16,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 2,
                                                    fontWeight: 100
                                                },
                                                children: props.paymentStatus?.status === "expired" ? "Expired" : props.managedPaymentDetails.paymentAddress
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            gap: "20px 40px",
                                            flexWrap: "wrap"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    fontSize: 12,
                                                    gap: 3,
                                                    flexGrow: 1,
                                                    ...props.posMode && {
                                                        alignItems: "center"
                                                    }
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                        style: {
                                                            opacity: 0.5,
                                                            textTransform: "uppercase"
                                                        },
                                                        children: "Network"
                                                    }),
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                        style: {
                                                            fontSize: 16,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: 5,
                                                            fontWeight: 300
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                                                                src: (0, $61f236426b9e4eab$export$8793fab959da70d1)(props.managedPaymentDetails.network, props.managedPaymentDetails.token)?.tokenInfo?.logo ?? (0, $61f236426b9e4eab$export$8793fab959da70d1)(props.managedPaymentDetails.network, props.managedPaymentDetails.token).logo,
                                                                style: {
                                                                    height: 20,
                                                                    width: "auto"
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                                style: {
                                                                    fontWeight: 300
                                                                },
                                                                children: (0, $61f236426b9e4eab$export$8793fab959da70d1)(props.managedPaymentDetails.network, props.managedPaymentDetails.token).tokenInfo?.networkName ?? (0, $61f236426b9e4eab$export$8793fab959da70d1)(props.managedPaymentDetails.network, props.managedPaymentDetails.token).name
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    fontSize: 12,
                                                    gap: 3,
                                                    flexGrow: 1,
                                                    ...props.posMode && {
                                                        alignItems: "center"
                                                    }
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                        style: {
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: 5
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                                style: {
                                                                    opacity: 0.5,
                                                                    textTransform: "uppercase"
                                                                },
                                                                children: "Amount due"
                                                            }),
                                                            props.paymentStatus?.status !== "expired" && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($6795754bca05c124$export$4f2558dd25106ae2, {
                                                                onClick: async ()=>await navigator.clipboard.writeText((0, $2a4a168be657655e$export$f5dd818bff069720)(props.managedPaymentDetails?.amount, {
                                                                        minimumFractionDigits: 2,
                                                                        maximumFractionDigits: 18
                                                                    }))
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                        style: {
                                                            fontSize: 16,
                                                            display: "flex",
                                                            alignItems: "center",
                                                            gap: 5,
                                                            fontWeight: 300
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                                                                src: (0, $61f236426b9e4eab$export$8793fab959da70d1)(props.managedPaymentDetails.network, props.managedPaymentDetails.token).logo,
                                                                style: {
                                                                    height: 20,
                                                                    width: "auto"
                                                                }
                                                            }),
                                                            (0, $2a4a168be657655e$export$f5dd818bff069720)(props.managedPaymentDetails.amount, {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 18
                                                            }),
                                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                                style: {
                                                                    opacity: 0.5,
                                                                    fontWeight: 100
                                                                },
                                                                children: (0, $61f236426b9e4eab$export$8793fab959da70d1)(props.managedPaymentDetails.network, props.managedPaymentDetails.token).ticker
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    !props.posMode && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            flexDirection: "column",
                                            fontSize: 12,
                                            gap: 3
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                style: {
                                                    opacity: 0.5,
                                                    textTransform: "uppercase"
                                                },
                                                children: "Time remaining"
                                            }),
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                style: {
                                                    fontSize: 16,
                                                    fontWeight: 100
                                                },
                                                children: props.paymentStatus?.status === "expired" ? "Expired" : $6795754bca05c124$export$8e3f267d166b4a05((new Date(props.paymentStatus?.expiresAt ?? props.managedPaymentDetails.expiresAt).getTime() - new Date().getTime()) / 1000)
                                            })
                                        ]
                                    }),
                                    props.paymentStatus && props.paymentStatus.transactions.length > 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                        style: {
                                            borderRadius: 15,
                                            border: `1px solid ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_MED}`,
                                            overflow: "hidden"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                style: {
                                                    padding: 15,
                                                    backgroundColor: "rgb(255 223 230)"
                                                },
                                                children: "Underpaid payment"
                                            }),
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                style: {
                                                    padding: 20,
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: 20
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                        children: "We have detected a payment transaction, but there is still an amount remaining to be paid."
                                                    }),
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                        style: {
                                                            width: "100%",
                                                            height: 1,
                                                            backgroundColor: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARK
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                        style: {
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: 5
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                                style: {
                                                                    opacity: 0.5,
                                                                    textTransform: "uppercase",
                                                                    fontSize: 12
                                                                },
                                                                children: "Amount remaining"
                                                            }),
                                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                                    style: {
                                                                        fontSize: 16,
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: 5,
                                                                        fontWeight: 300
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                                                                            src: (0, $61f236426b9e4eab$export$8793fab959da70d1)(props.managedPaymentDetails.network, props.managedPaymentDetails.token).logo,
                                                                            style: {
                                                                                height: 20,
                                                                                width: "auto"
                                                                            }
                                                                        }),
                                                                        (0, $2a4a168be657655e$export$f5dd818bff069720)(props.paymentStatus.amountRemaining, {
                                                                            minimumFractionDigits: 2,
                                                                            maximumFractionDigits: 18
                                                                        }),
                                                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                                            style: {
                                                                                opacity: 0.5,
                                                                                fontWeight: 100
                                                                            },
                                                                            children: (0, $61f236426b9e4eab$export$8793fab959da70d1)(props.managedPaymentDetails.network, props.managedPaymentDetails.token).ticker
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    props.paymentStatus && props.paymentStatus.pendingTransactions.length > 0 && props.paymentStatus.transactions.length <= 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($6795754bca05c124$var$PaymentDetectedContainer, {
                                        children: [
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                style: {
                                                    padding: 15,
                                                    backgroundColor: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_MED
                                                },
                                                children: "Payment detected"
                                            }),
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                style: {
                                                    padding: 20,
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: 20
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                        children: "We have detected your payment transaction pending to be confirmed."
                                                    }),
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                        style: {
                                                            width: "100%",
                                                            height: 1,
                                                            backgroundColor: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARK
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                        style: {
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            gap: 5
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                                style: {
                                                                    opacity: 0.5,
                                                                    textTransform: "uppercase",
                                                                    fontSize: 12
                                                                },
                                                                children: "Amount paid"
                                                            }),
                                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                                    style: {
                                                                        fontSize: 16,
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: 5,
                                                                        fontWeight: 300
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                                                                            src: (0, $61f236426b9e4eab$export$8793fab959da70d1)(props.managedPaymentDetails.network, props.managedPaymentDetails.token).logo,
                                                                            style: {
                                                                                height: 20,
                                                                                width: "auto"
                                                                            }
                                                                        }),
                                                                        (0, $2a4a168be657655e$export$f5dd818bff069720)(props.paymentStatus.pendingTransactions.reduce((s, t)=>s + Number(t.amount), 0), {
                                                                            minimumFractionDigits: 2,
                                                                            maximumFractionDigits: 18
                                                                        }),
                                                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                                            style: {
                                                                                opacity: 0.5,
                                                                                fontWeight: 100
                                                                            },
                                                                            children: (0, $61f236426b9e4eab$export$8793fab959da70d1)(props.managedPaymentDetails.network, props.managedPaymentDetails.token).ticker
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    !props.posMode && props.paymentStatus?.status !== "expired" && props.checkoutData.organizationId !== "f58cf6b3-b87d-4893-b859-cddc85ac0abf" && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                        style: {
                                            width: "100%",
                                            borderTop: `1px solid ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARK}`,
                                            paddingTop: 20,
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: 20
                                        },
                                        children: [
                                            !selectedMethod?.isSolana && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $13f4c0370d7de649$exports.Fragment), {
                                                children: [
                                                    isConnected && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($6795754bca05c124$var$ConnectedWalletContainer, {
                                                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                            style: {
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                border: `1px solid ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARK}`,
                                                                borderRadius: 5
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                                    style: {
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        padding: 15,
                                                                        backgroundColor: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_MED
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                                            style: {
                                                                                fontSize: 14
                                                                            },
                                                                            children: "Connected wallet"
                                                                        }),
                                                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $348d722f77cc9b90$export$f861551692d63a2e), {
                                                                            style: {
                                                                                border: 0,
                                                                                padding: 0,
                                                                                color: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).BLACK,
                                                                                fontSize: 10,
                                                                                textTransform: "uppercase"
                                                                            },
                                                                            onClick: ()=>disconnect(),
                                                                            children: "Disconnect"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                                    style: {
                                                                        padding: 15
                                                                    },
                                                                    children: address
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $348d722f77cc9b90$export$ac16a6a04d9b7c84), {
                                                        isLoading: isManagedEVMTxLoading,
                                                        onClick: onClickOpenWallet,
                                                        style: {
                                                            width: "100%",
                                                            background: props.checkoutData.customizations?.primaryButtonColor
                                                        },
                                                        children: isConnected ? "Open wallet" : "Connect wallet"
                                                    })
                                                ]
                                            }),
                                            selectedMethod?.isSolana && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $3a7c189ba80694ae$export$2e2bcd8739ae039), {
                                                managedPaymentDetails: props.managedPaymentDetails,
                                                isLoading: isManagedEVMTxLoading,
                                                setIsLoading: setIsManagedEVMTxLoading,
                                                primaryButtonColor: props.checkoutData.customizations?.primaryButtonColor
                                            })
                                        ]
                                    }),
                                    !props.posMode && props.paymentStatus?.status === "expired" && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                        style: {
                                            width: "100%",
                                            borderTop: `1px solid ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).GRAY_DARK}`,
                                            paddingTop: 20
                                        },
                                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $348d722f77cc9b90$export$ac16a6a04d9b7c84), {
                                            onClick: ()=>window.location.reload(),
                                            style: {
                                                width: "100%",
                                                background: props.checkoutData.customizations?.primaryButtonColor
                                            },
                                            children: "Reload"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $6795754bca05c124$export$2e2bcd8739ae039 = $6795754bca05c124$var$PayWidget;






var $9nOfC = parcelRequire("9nOfC");




const $a2e886aa15ab320a$var$ReceiptIn = (0, $65e706775ff71837$export$d25ddfdf17c3ad3e)`
  0% {
    opacity: 0;
    transform: translateY(25%);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;
const $a2e886aa15ab320a$export$af661ccd4dd193f2 = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
  background-color: white;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 40px;
  animation: ${$a2e886aa15ab320a$var$ReceiptIn} 0.5s ease;
  box-shadow: rgb(0 0 0 / 15%) 0px 1px 5px;
  padding: 40px;
`;
const $a2e886aa15ab320a$export$763817fece9a8c9d = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  border-radius: 100%;
  background-color: ${(0, $643d9102d67b3722$export$8fe7e62e076ddbb5).NICE_GREEN};
  animation: ${(0, $dc80f518f0729f3c$export$f9ae25e7d5fbc8b9)} 0.5s ease;
`;




var $O6tRJ = parcelRequire("O6tRJ");







function $4f424f68e2b4ec05$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}


function $2e98104d428ae556$export$2e2bcd8739ae039(object) {
    return (0, $4f424f68e2b4ec05$export$2e2bcd8739ae039)({}, object);
}





var $82f59ed542998b86$var$MINUTES_IN_DAY = 1440;
var $82f59ed542998b86$var$MINUTES_IN_ALMOST_TWO_DAYS = 2520;
var $82f59ed542998b86$var$MINUTES_IN_MONTH = 43200;
var $82f59ed542998b86$var$MINUTES_IN_TWO_MONTHS = 86400;
function $82f59ed542998b86$export$2e2bcd8739ae039(dirtyDate, dirtyBaseDate, options) {
    var _ref, _options$locale;
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(2, arguments);
    var defaultOptions = (0, $5bdcb58bd181ac10$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $ff2f5d41cd8b653b$export$2e2bcd8739ae039);
    if (!locale.formatDistance) throw new RangeError("locale must contain formatDistance property");
    var comparison = (0, $a17d8ed27c1eb490$export$2e2bcd8739ae039)(dirtyDate, dirtyBaseDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    var localizeOptions = (0, $4f424f68e2b4ec05$export$2e2bcd8739ae039)((0, $2e98104d428ae556$export$2e2bcd8739ae039)(options), {
        addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
        comparison: comparison
    });
    var dateLeft;
    var dateRight;
    if (comparison > 0) {
        dateLeft = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyBaseDate);
        dateRight = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
    } else {
        dateLeft = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyDate);
        dateRight = (0, $db295730c81e792c$export$2e2bcd8739ae039)(dirtyBaseDate);
    }
    var seconds = (0, $df07c48362c169dc$export$2e2bcd8739ae039)(dateRight, dateLeft);
    var offsetInSeconds = ((0, $c6138e3e9e222cc3$export$2e2bcd8739ae039)(dateRight) - (0, $c6138e3e9e222cc3$export$2e2bcd8739ae039)(dateLeft)) / 1000;
    var minutes = Math.round((seconds - offsetInSeconds) / 60);
    var months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options !== null && options !== void 0 && options.includeSeconds) {
            if (seconds < 5) return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance("halfAMinute", 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance("xMinutes", minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance("aboutXHours", 1, localizeOptions);
    else if (minutes < $82f59ed542998b86$var$MINUTES_IN_DAY) {
        var hours = Math.round(minutes / 60);
        return locale.formatDistance("aboutXHours", hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < $82f59ed542998b86$var$MINUTES_IN_ALMOST_TWO_DAYS) return locale.formatDistance("xDays", 1, localizeOptions);
    else if (minutes < $82f59ed542998b86$var$MINUTES_IN_MONTH) {
        var days = Math.round(minutes / $82f59ed542998b86$var$MINUTES_IN_DAY);
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < $82f59ed542998b86$var$MINUTES_IN_TWO_MONTHS) {
        months = Math.round(minutes / $82f59ed542998b86$var$MINUTES_IN_MONTH);
        return locale.formatDistance("aboutXMonths", months, localizeOptions);
    }
    months = (0, $e5104d01f5b52383$export$2e2bcd8739ae039)(dateRight, dateLeft);
    // 2 months up to 12 months
    if (months < 12) {
        var nearestMonth = Math.round(minutes / $82f59ed542998b86$var$MINUTES_IN_MONTH);
        return locale.formatDistance("xMonths", nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        var monthsSinceStartOfYear = months % 12;
        var years = Math.floor(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance("aboutXYears", years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance("overXYears", years, localizeOptions);
        else return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
}



function $68ab5c1af0093868$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $e5b6e627005992fb$export$2e2bcd8739ae039)(1, arguments);
    return (0, $82f59ed542998b86$export$2e2bcd8739ae039)(dirtyDate, Date.now(), options);
}



var $3d87de48bf4dd55e$var$defaultFormat = [
    "years",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds"
];
function $3d87de48bf4dd55e$export$2e2bcd8739ae039(duration, options) {
    var _ref, _options$locale, _options$format, _options$zero, _options$delimiter;
    if (arguments.length < 1) throw new TypeError("1 argument required, but only ".concat(arguments.length, " present"));
    var defaultOptions = (0, $5bdcb58bd181ac10$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $ff2f5d41cd8b653b$export$2e2bcd8739ae039);
    var format = (_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : $3d87de48bf4dd55e$var$defaultFormat;
    var zero = (_options$zero = options === null || options === void 0 ? void 0 : options.zero) !== null && _options$zero !== void 0 ? _options$zero : false;
    var delimiter = (_options$delimiter = options === null || options === void 0 ? void 0 : options.delimiter) !== null && _options$delimiter !== void 0 ? _options$delimiter : " ";
    if (!locale.formatDistance) return "";
    var result = format.reduce(function(acc, unit) {
        var token = "x".concat(unit.replace(/(^.)/, function(m) {
            return m.toUpperCase();
        }));
        var value = duration[unit];
        if (typeof value === "number" && (zero || duration[unit])) return acc.concat(locale.formatDistance(token, value));
        return acc;
    }, []).join(delimiter);
    return result;
}




parcelRequire("8NFma");
function $ee6a04979d87ee29$export$65be7b63f510f362(props) {
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("svg", {
        width: "10",
        height: "6",
        viewBox: "0 0 10 6",
        fill: "black",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("path", {
            d: "M5.39802 5.94478L9.9767 1.36609L8.90021 0.288086L5.39802 3.79257L1.89658 0.288086L0.819336 1.36533L5.39802 5.94478Z"
        })
    });
}



/**
 * React Router DOM v6.23.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8NFma = parcelRequire("8NFma");

/**
 * @remix-run/router v1.16.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $47039de3e9f0864a$var$_extends() {
    $47039de3e9f0864a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $47039de3e9f0864a$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $47039de3e9f0864a$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($47039de3e9f0864a$export$e19cd5f9376f8cee || ($47039de3e9f0864a$export$e19cd5f9376f8cee = {}));
const $47039de3e9f0864a$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $47039de3e9f0864a$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $47039de3e9f0864a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $47039de3e9f0864a$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $47039de3e9f0864a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $47039de3e9f0864a$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $47039de3e9f0864a$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $47039de3e9f0864a$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $47039de3e9f0864a$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $47039de3e9f0864a$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $47039de3e9f0864a$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $47039de3e9f0864a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $47039de3e9f0864a$export$fe53371bee54353d(to);
    }
    return $47039de3e9f0864a$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $47039de3e9f0864a$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $47039de3e9f0864a$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $47039de3e9f0864a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $47039de3e9f0864a$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $47039de3e9f0864a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $47039de3e9f0864a$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $47039de3e9f0864a$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $47039de3e9f0864a$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $47039de3e9f0864a$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $47039de3e9f0864a$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $47039de3e9f0864a$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $47039de3e9f0864a$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $47039de3e9f0864a$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $47039de3e9f0864a$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $47039de3e9f0864a$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $47039de3e9f0864a$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $47039de3e9f0864a$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $47039de3e9f0864a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($47039de3e9f0864a$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $47039de3e9f0864a$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $47039de3e9f0864a$export$e19cd5f9376f8cee.Push;
        let location = $47039de3e9f0864a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $47039de3e9f0864a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $47039de3e9f0864a$export$e19cd5f9376f8cee.Replace;
        let location = $47039de3e9f0864a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $47039de3e9f0864a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $47039de3e9f0864a$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $47039de3e9f0864a$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($47039de3e9f0864a$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($47039de3e9f0864a$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $47039de3e9f0864a$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($47039de3e9f0864a$var$ResultType || ($47039de3e9f0864a$var$ResultType = {}));
const $47039de3e9f0864a$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $47039de3e9f0864a$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $47039de3e9f0864a$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $47039de3e9f0864a$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $47039de3e9f0864a$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($47039de3e9f0864a$var$isIndexRoute(route)) {
            let indexRoute = $47039de3e9f0864a$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $47039de3e9f0864a$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $47039de3e9f0864a$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $47039de3e9f0864a$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $47039de3e9f0864a$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $47039de3e9f0864a$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $47039de3e9f0864a$var$flattenRoutes(routes);
    $47039de3e9f0864a$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $47039de3e9f0864a$var$decodePath(pathname);
        matches = $47039de3e9f0864a$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $47039de3e9f0864a$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $47039de3e9f0864a$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $47039de3e9f0864a$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $47039de3e9f0864a$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $47039de3e9f0864a$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $47039de3e9f0864a$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $47039de3e9f0864a$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $47039de3e9f0864a$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $47039de3e9f0864a$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $47039de3e9f0864a$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $47039de3e9f0864a$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $47039de3e9f0864a$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $47039de3e9f0864a$var$paramRe = /^:[\w-]+$/;
const $47039de3e9f0864a$var$dynamicSegmentValue = 3;
const $47039de3e9f0864a$var$indexRouteValue = 2;
const $47039de3e9f0864a$var$emptySegmentValue = 1;
const $47039de3e9f0864a$var$staticSegmentValue = 10;
const $47039de3e9f0864a$var$splatPenalty = -2;
const $47039de3e9f0864a$var$isSplat = (s)=>s === "*";
function $47039de3e9f0864a$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($47039de3e9f0864a$var$isSplat)) initialScore += $47039de3e9f0864a$var$splatPenalty;
    if (index) initialScore += $47039de3e9f0864a$var$indexRouteValue;
    return segments.filter((s)=>!$47039de3e9f0864a$var$isSplat(s)).reduce((score, segment)=>score + ($47039de3e9f0864a$var$paramRe.test(segment) ? $47039de3e9f0864a$var$dynamicSegmentValue : segment === "" ? $47039de3e9f0864a$var$emptySegmentValue : $47039de3e9f0864a$var$staticSegmentValue), initialScore);
}
function $47039de3e9f0864a$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $47039de3e9f0864a$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $47039de3e9f0864a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $47039de3e9f0864a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $47039de3e9f0864a$export$a5c6d149b50c1d86($47039de3e9f0864a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $47039de3e9f0864a$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $47039de3e9f0864a$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $47039de3e9f0864a$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $47039de3e9f0864a$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $47039de3e9f0864a$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $47039de3e9f0864a$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $47039de3e9f0864a$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $47039de3e9f0864a$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $47039de3e9f0864a$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $47039de3e9f0864a$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $47039de3e9f0864a$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $47039de3e9f0864a$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $47039de3e9f0864a$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $47039de3e9f0864a$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $47039de3e9f0864a$var$normalizeSearch(search),
        hash: $47039de3e9f0864a$var$normalizeHash(hash)
    };
}
function $47039de3e9f0864a$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $47039de3e9f0864a$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $47039de3e9f0864a$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $47039de3e9f0864a$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $47039de3e9f0864a$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $47039de3e9f0864a$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $47039de3e9f0864a$export$8ccf933b0513f8d0(toArg);
    else {
        to = $47039de3e9f0864a$var$_extends({}, toArg);
        $47039de3e9f0864a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $47039de3e9f0864a$var$getInvalidPathError("?", "pathname", "search", to));
        $47039de3e9f0864a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $47039de3e9f0864a$var$getInvalidPathError("#", "pathname", "hash", to));
        $47039de3e9f0864a$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $47039de3e9f0864a$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $47039de3e9f0864a$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $47039de3e9f0864a$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $47039de3e9f0864a$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $47039de3e9f0864a$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $47039de3e9f0864a$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $47039de3e9f0864a$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $47039de3e9f0864a$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $47039de3e9f0864a$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $47039de3e9f0864a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $47039de3e9f0864a$export$42a99a7a4bc0e76a extends Error {
}
class $47039de3e9f0864a$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $47039de3e9f0864a$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $47039de3e9f0864a$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $47039de3e9f0864a$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $47039de3e9f0864a$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $47039de3e9f0864a$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $47039de3e9f0864a$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $47039de3e9f0864a$var$unwrapTrackedPromise(value) {
    if (!$47039de3e9f0864a$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $47039de3e9f0864a$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $47039de3e9f0864a$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $47039de3e9f0864a$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $47039de3e9f0864a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $47039de3e9f0864a$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $47039de3e9f0864a$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $47039de3e9f0864a$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $47039de3e9f0864a$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $47039de3e9f0864a$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $47039de3e9f0864a$var$validMutationMethods = new Set($47039de3e9f0864a$var$validMutationMethodsArr);
const $47039de3e9f0864a$var$validRequestMethodsArr = [
    "get",
    ...$47039de3e9f0864a$var$validMutationMethodsArr
];
const $47039de3e9f0864a$var$validRequestMethods = new Set($47039de3e9f0864a$var$validRequestMethodsArr);
const $47039de3e9f0864a$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $47039de3e9f0864a$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $47039de3e9f0864a$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $47039de3e9f0864a$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $47039de3e9f0864a$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $47039de3e9f0864a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $47039de3e9f0864a$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $47039de3e9f0864a$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $47039de3e9f0864a$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $47039de3e9f0864a$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $47039de3e9f0864a$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $47039de3e9f0864a$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.unstable_dataStrategy || $47039de3e9f0864a$var$defaultDataStrategy;
    // Config driven behavior flags
    let future = $47039de3e9f0864a$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        unstable_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $47039de3e9f0864a$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $47039de3e9f0864a$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $47039de3e9f0864a$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $47039de3e9f0864a$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $47039de3e9f0864a$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $47039de3e9f0864a$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $47039de3e9f0864a$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $47039de3e9f0864a$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$47039de3e9f0864a$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($47039de3e9f0864a$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $47039de3e9f0864a$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $47039de3e9f0864a$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $47039de3e9f0864a$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $47039de3e9f0864a$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $47039de3e9f0864a$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $47039de3e9f0864a$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $47039de3e9f0864a$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $47039de3e9f0864a$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $47039de3e9f0864a$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($47039de3e9f0864a$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $47039de3e9f0864a$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $47039de3e9f0864a$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $47039de3e9f0864a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $47039de3e9f0864a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $47039de3e9f0864a$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $47039de3e9f0864a$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $47039de3e9f0864a$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $47039de3e9f0864a$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $47039de3e9f0864a$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $47039de3e9f0864a$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $47039de3e9f0864a$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $47039de3e9f0864a$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $47039de3e9f0864a$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $47039de3e9f0864a$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $47039de3e9f0864a$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $47039de3e9f0864a$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $47039de3e9f0864a$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $47039de3e9f0864a$var$findNearestBoundary(matches).route.id,
            {
                type: $47039de3e9f0864a$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $47039de3e9f0864a$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $47039de3e9f0864a$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = $47039de3e9f0864a$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $47039de3e9f0864a$var$_extends({
            matches: matches
        }, $47039de3e9f0864a$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $47039de3e9f0864a$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $47039de3e9f0864a$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $47039de3e9f0864a$var$ResultType.error,
            error: $47039de3e9f0864a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches);
            result = results[0];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($47039de3e9f0864a$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $47039de3e9f0864a$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($47039de3e9f0864a$var$isDeferredResult(result)) throw $47039de3e9f0864a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($47039de3e9f0864a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $47039de3e9f0864a$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $47039de3e9f0864a$export$e19cd5f9376f8cee.Push;
            return {
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $47039de3e9f0864a$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $47039de3e9f0864a$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $47039de3e9f0864a$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $47039de3e9f0864a$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $47039de3e9f0864a$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $47039de3e9f0864a$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $47039de3e9f0864a$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData;
            if (pendingActionResult && !$47039de3e9f0864a$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
            // would be a breaking change to use any.
            // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
            actionData = {
                [pendingActionResult[0]]: pendingActionResult[1].data
            };
            else if (state.actionData) {
                if (Object.keys(state.actionData).length === 0) actionData = null;
                else actionData = state.actionData;
            }
            updateState($47039de3e9f0864a$var$_extends({
                navigation: loadingNavigation
            }, actionData !== undefined ? {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $47039de3e9f0864a$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(request, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $47039de3e9f0864a$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $47039de3e9f0864a$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $47039de3e9f0864a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $47039de3e9f0864a$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $47039de3e9f0864a$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $47039de3e9f0864a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $47039de3e9f0864a$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $47039de3e9f0864a$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $47039de3e9f0864a$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $47039de3e9f0864a$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $47039de3e9f0864a$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", fetchRequest, [
            match
        ], requestMatches);
        let actionResult = actionResults[0];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($47039de3e9f0864a$var$isRedirectResult(actionResult) || $47039de3e9f0864a$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $47039de3e9f0864a$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($47039de3e9f0864a$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $47039de3e9f0864a$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $47039de3e9f0864a$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($47039de3e9f0864a$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($47039de3e9f0864a$var$isDeferredResult(actionResult)) throw $47039de3e9f0864a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $47039de3e9f0864a$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $47039de3e9f0864a$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $47039de3e9f0864a$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $47039de3e9f0864a$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $47039de3e9f0864a$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.unstable_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $47039de3e9f0864a$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $47039de3e9f0864a$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(revalidationRequest, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $47039de3e9f0864a$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $47039de3e9f0864a$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $47039de3e9f0864a$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $47039de3e9f0864a$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $47039de3e9f0864a$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $47039de3e9f0864a$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", fetchRequest, [
            match
        ], matches);
        let result = results[0];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($47039de3e9f0864a$var$isDeferredResult(result)) result = await $47039de3e9f0864a$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $47039de3e9f0864a$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($47039de3e9f0864a$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $47039de3e9f0864a$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($47039de3e9f0864a$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $47039de3e9f0864a$export$3e9cee6b33872309(!$47039de3e9f0864a$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $47039de3e9f0864a$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $47039de3e9f0864a$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $47039de3e9f0864a$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $47039de3e9f0864a$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($47039de3e9f0864a$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $47039de3e9f0864a$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $47039de3e9f0864a$export$e19cd5f9376f8cee.Replace : $47039de3e9f0864a$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $47039de3e9f0864a$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($47039de3e9f0864a$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $47039de3e9f0864a$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $47039de3e9f0864a$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $47039de3e9f0864a$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches) {
        try {
            let results = await $47039de3e9f0864a$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties);
            return await Promise.all(results.map((result, i)=>{
                if ($47039de3e9f0864a$var$isRedirectHandlerResult(result)) {
                    let response = result.result;
                    return {
                        type: $47039de3e9f0864a$var$ResultType.redirect,
                        response: $47039de3e9f0864a$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath)
                    };
                }
                return $47039de3e9f0864a$var$convertHandlerResultToDataResult(result);
            }));
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            return matchesToLoad.map(()=>({
                    type: $47039de3e9f0864a$var$ResultType.error,
                    error: e
                }));
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        let [loaderResults, ...fetcherResults] = await Promise.all([
            matchesToLoad.length ? callDataStrategy("loader", request, matchesToLoad, matches) : [],
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) {
                    let fetcherRequest = $47039de3e9f0864a$var$createClientSideRequest(init.history, f.path, f.controller.signal);
                    return callDataStrategy("loader", fetcherRequest, [
                        f.match
                    ], f.matches).then((r)=>r[0]);
                } else return Promise.resolve({
                    type: $47039de3e9f0864a$var$ResultType.error,
                    error: $47039de3e9f0864a$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                });
            })
        ]);
        await Promise.all([
            $47039de3e9f0864a$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $47039de3e9f0864a$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $47039de3e9f0864a$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $47039de3e9f0864a$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $47039de3e9f0864a$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $47039de3e9f0864a$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $47039de3e9f0864a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $47039de3e9f0864a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $47039de3e9f0864a$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $47039de3e9f0864a$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $47039de3e9f0864a$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $47039de3e9f0864a$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $47039de3e9f0864a$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$47039de3e9f0864a$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $47039de3e9f0864a$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $47039de3e9f0864a$export$4d0306f8f6a4585b = Symbol("deferred");
function $47039de3e9f0864a$export$3336b097a6fbc59a(routes, opts) {
    $47039de3e9f0864a$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $47039de3e9f0864a$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $47039de3e9f0864a$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $47039de3e9f0864a$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, unstable_dataStrategy: unstable_dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $47039de3e9f0864a$var$createLocation("", $47039de3e9f0864a$export$fe53371bee54353d(url), null, "default");
        let matches = $47039de3e9f0864a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$47039de3e9f0864a$var$isValidMethod(method) && method !== "HEAD") {
            let error = $47039de3e9f0864a$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $47039de3e9f0864a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $47039de3e9f0864a$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $47039de3e9f0864a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($47039de3e9f0864a$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $47039de3e9f0864a$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, unstable_dataStrategy: unstable_dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $47039de3e9f0864a$var$createLocation("", $47039de3e9f0864a$export$fe53371bee54353d(url), null, "default");
        let matches = $47039de3e9f0864a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$47039de3e9f0864a$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $47039de3e9f0864a$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $47039de3e9f0864a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $47039de3e9f0864a$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $47039de3e9f0864a$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $47039de3e9f0864a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, false, match);
        if ($47039de3e9f0864a$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$47039de3e9f0864a$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $47039de3e9f0864a$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($47039de3e9f0864a$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $47039de3e9f0864a$var$getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $47039de3e9f0864a$var$isResponse(result) ? result : $47039de3e9f0864a$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `HandlerResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($47039de3e9f0864a$var$isHandlerResult(e) && $47039de3e9f0864a$var$isResponse(e.result)) {
                if (e.type === $47039de3e9f0864a$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($47039de3e9f0864a$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $47039de3e9f0864a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $47039de3e9f0864a$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, unstable_dataStrategy);
            result = results[0];
            if (request.signal.aborted) $47039de3e9f0864a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($47039de3e9f0864a$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($47039de3e9f0864a$var$isDeferredResult(result)) {
            let error = $47039de3e9f0864a$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $47039de3e9f0864a$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($47039de3e9f0864a$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($47039de3e9f0864a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $47039de3e9f0864a$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $47039de3e9f0864a$var$_extends({}, context, {
                statusCode: $47039de3e9f0864a$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $47039de3e9f0864a$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null);
        return $47039de3e9f0864a$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $47039de3e9f0864a$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $47039de3e9f0864a$var$isErrorResult(pendingActionResult[1]) ? $47039de3e9f0864a$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $47039de3e9f0864a$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy);
        if (request.signal.aborted) $47039de3e9f0864a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $47039de3e9f0864a$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $47039de3e9f0864a$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        let results = await $47039de3e9f0864a$var$callDataStrategyImpl(unstable_dataStrategy || $47039de3e9f0864a$var$defaultDataStrategy, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext);
        return await Promise.all(results.map((result, i)=>{
            if ($47039de3e9f0864a$var$isRedirectHandlerResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $47039de3e9f0864a$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($47039de3e9f0864a$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            return $47039de3e9f0864a$var$convertHandlerResultToDataResult(result);
        }));
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $47039de3e9f0864a$export$fec11da027c70692(routes, context, error) {
    let newContext = $47039de3e9f0864a$var$_extends({}, context, {
        statusCode: $47039de3e9f0864a$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $47039de3e9f0864a$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $47039de3e9f0864a$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $47039de3e9f0864a$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $47039de3e9f0864a$export$cae722b0cc860f13(to ? to : ".", $47039de3e9f0864a$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $47039de3e9f0864a$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$47039de3e9f0864a$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $47039de3e9f0864a$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $47039de3e9f0864a$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $47039de3e9f0864a$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$47039de3e9f0864a$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$47039de3e9f0864a$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $47039de3e9f0864a$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $47039de3e9f0864a$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $47039de3e9f0864a$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$47039de3e9f0864a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$47039de3e9f0864a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $47039de3e9f0864a$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $47039de3e9f0864a$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $47039de3e9f0864a$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $47039de3e9f0864a$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $47039de3e9f0864a$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($47039de3e9f0864a$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $47039de3e9f0864a$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $47039de3e9f0864a$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $47039de3e9f0864a$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $47039de3e9f0864a$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $47039de3e9f0864a$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $47039de3e9f0864a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingActionResult && $47039de3e9f0864a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    let boundaryMatches = boundaryId ? $47039de3e9f0864a$var$getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($47039de3e9f0864a$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $47039de3e9f0864a$var$shouldRevalidateLoader(match, $47039de3e9f0864a$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $47039de3e9f0864a$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $47039de3e9f0864a$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $47039de3e9f0864a$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $47039de3e9f0864a$var$shouldRevalidateLoader(fetcherMatch, $47039de3e9f0864a$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            unstable_actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $47039de3e9f0864a$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $47039de3e9f0864a$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $47039de3e9f0864a$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $47039de3e9f0864a$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $47039de3e9f0864a$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $47039de3e9f0864a$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$47039de3e9f0864a$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $47039de3e9f0864a$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function $47039de3e9f0864a$var$defaultDataStrategy(opts) {
    return Promise.all(opts.matches.map((m)=>m.resolve()));
}
async function $47039de3e9f0864a$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
    let routeIdsToLoad = matchesToLoad.reduce((acc, m)=>acc.add(m.route.id), new Set());
    let loadedMatches = new Set();
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: matches.map((match)=>{
            let shouldLoad = routeIdsToLoad.has(match.route.id);
            // `resolve` encapsulates the route.lazy, executing the
            // loader/action, and mapping return values/thrown errors to a
            // HandlerResult.  Users can pass a callback to take fine-grained control
            // over the execution of the loader/action
            let resolve = (handlerOverride)=>{
                loadedMatches.add(match.route.id);
                return shouldLoad ? $47039de3e9f0864a$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, requestContext) : Promise.resolve({
                    type: $47039de3e9f0864a$var$ResultType.data,
                    result: undefined
                });
            };
            return $47039de3e9f0864a$var$_extends({}, match, {
                shouldLoad: shouldLoad,
                resolve: resolve
            });
        }),
        request: request,
        params: matches[0].params,
        context: requestContext
    });
    // Throw if any loadRoute implementations not called since they are what
    // ensures a route is fully loaded
    matches.forEach((m)=>$47039de3e9f0864a$export$3e9cee6b33872309(loadedMatches.has(m.route.id), '`match.resolve()` was not called for route id "' + m.route.id + '". ' + "You must call `match.resolve()` on every match passed to " + "`dataStrategy` to ensure all routes are properly loaded."));
    // Filter out any middleware-only matches for which we didn't need to run handlers
    return results.filter((_, i)=>routeIdsToLoad.has(matches[i].route.id));
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $47039de3e9f0864a$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<HandlerResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise;
        if (handlerOverride) handlerPromise = handlerOverride((ctx)=>actualHandler(ctx));
        else handlerPromise = (async ()=>{
            try {
                let val = await actualHandler();
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $47039de3e9f0864a$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await $47039de3e9f0864a$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $47039de3e9f0864a$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $47039de3e9f0864a$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $47039de3e9f0864a$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $47039de3e9f0864a$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // HandlerResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $47039de3e9f0864a$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $47039de3e9f0864a$var$convertHandlerResultToDataResult(handlerResult) {
    let { result: result, type: type, status: status } = handlerResult;
    if ($47039de3e9f0864a$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $47039de3e9f0864a$var$ResultType.error,
                error: e
            };
        }
        if (type === $47039de3e9f0864a$var$ResultType.error) return {
            type: $47039de3e9f0864a$var$ResultType.error,
            error: new $47039de3e9f0864a$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $47039de3e9f0864a$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $47039de3e9f0864a$var$ResultType.error) return {
        type: $47039de3e9f0864a$var$ResultType.error,
        error: result,
        statusCode: $47039de3e9f0864a$export$972111febbeef05b(result) ? result.status : status
    };
    if ($47039de3e9f0864a$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $47039de3e9f0864a$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $47039de3e9f0864a$var$ResultType.data,
        data: result,
        statusCode: status
    };
}
// Support relative routing in internal redirects
function $47039de3e9f0864a$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $47039de3e9f0864a$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$47039de3e9f0864a$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $47039de3e9f0864a$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $47039de3e9f0864a$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($47039de3e9f0864a$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $47039de3e9f0864a$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $47039de3e9f0864a$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($47039de3e9f0864a$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $47039de3e9f0864a$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $47039de3e9f0864a$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $47039de3e9f0864a$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $47039de3e9f0864a$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $47039de3e9f0864a$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $47039de3e9f0864a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $47039de3e9f0864a$export$3e9cee6b33872309(!$47039de3e9f0864a$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($47039de3e9f0864a$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $47039de3e9f0864a$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $47039de3e9f0864a$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($47039de3e9f0864a$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $47039de3e9f0864a$var$processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $47039de3e9f0864a$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $47039de3e9f0864a$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($47039de3e9f0864a$var$isErrorResult(result)) {
            let boundaryMatch = $47039de3e9f0864a$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $47039de3e9f0864a$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($47039de3e9f0864a$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $47039de3e9f0864a$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($47039de3e9f0864a$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $47039de3e9f0864a$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $47039de3e9f0864a$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $47039de3e9f0864a$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $47039de3e9f0864a$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $47039de3e9f0864a$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $47039de3e9f0864a$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $47039de3e9f0864a$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $47039de3e9f0864a$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $47039de3e9f0864a$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $47039de3e9f0864a$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $47039de3e9f0864a$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($47039de3e9f0864a$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $47039de3e9f0864a$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $47039de3e9f0864a$export$8ccf933b0513f8d0(path) : path;
    return $47039de3e9f0864a$export$fe53371bee54353d($47039de3e9f0864a$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $47039de3e9f0864a$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $47039de3e9f0864a$var$isHandlerResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $47039de3e9f0864a$var$ResultType.data || result.type === $47039de3e9f0864a$var$ResultType.error);
}
function $47039de3e9f0864a$var$isRedirectHandlerResult(result) {
    return $47039de3e9f0864a$var$isResponse(result.result) && $47039de3e9f0864a$var$redirectStatusCodes.has(result.result.status);
}
function $47039de3e9f0864a$var$isDeferredResult(result) {
    return result.type === $47039de3e9f0864a$var$ResultType.deferred;
}
function $47039de3e9f0864a$var$isErrorResult(result) {
    return result.type === $47039de3e9f0864a$var$ResultType.error;
}
function $47039de3e9f0864a$var$isRedirectResult(result) {
    return (result && result.type) === $47039de3e9f0864a$var$ResultType.redirect;
}
function $47039de3e9f0864a$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $47039de3e9f0864a$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $47039de3e9f0864a$var$isRedirectResponse(result) {
    if (!$47039de3e9f0864a$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $47039de3e9f0864a$var$isValidMethod(method) {
    return $47039de3e9f0864a$var$validRequestMethods.has(method.toLowerCase());
}
function $47039de3e9f0864a$var$isMutationMethod(method) {
    return $47039de3e9f0864a$var$validMutationMethods.has(method.toLowerCase());
}
async function $47039de3e9f0864a$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$47039de3e9f0864a$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($47039de3e9f0864a$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $47039de3e9f0864a$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $47039de3e9f0864a$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $47039de3e9f0864a$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $47039de3e9f0864a$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $47039de3e9f0864a$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $47039de3e9f0864a$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $47039de3e9f0864a$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $47039de3e9f0864a$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $47039de3e9f0864a$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $47039de3e9f0864a$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $47039de3e9f0864a$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $47039de3e9f0864a$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $47039de3e9f0864a$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $47039de3e9f0864a$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $47039de3e9f0864a$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $47039de3e9f0864a$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $47039de3e9f0864a$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $47039de3e9f0864a$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($47039de3e9f0864a$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $47039de3e9f0864a$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($47039de3e9f0864a$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $47039de3e9f0864a$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.23.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8NFma = parcelRequire("8NFma");

function $7b8d8d3adba9a65c$var$_extends() {
    $7b8d8d3adba9a65c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7b8d8d3adba9a65c$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7b8d8d3adba9a65c$export$3add0d5dce533e2e = /*#__PURE__*/ $8NFma.createContext(null);
$7b8d8d3adba9a65c$export$3add0d5dce533e2e.displayName = "DataRouter";
const $7b8d8d3adba9a65c$export$145dfa71566a64dc = /*#__PURE__*/ $8NFma.createContext(null);
$7b8d8d3adba9a65c$export$145dfa71566a64dc.displayName = "DataRouterState";
const $7b8d8d3adba9a65c$var$AwaitContext = /*#__PURE__*/ $8NFma.createContext(null);
$7b8d8d3adba9a65c$var$AwaitContext.displayName = "Await";
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7b8d8d3adba9a65c$export$26749e8557646306 = /*#__PURE__*/ $8NFma.createContext(null);
$7b8d8d3adba9a65c$export$26749e8557646306.displayName = "Navigation";
const $7b8d8d3adba9a65c$export$c7914228fb69b0f5 = /*#__PURE__*/ $8NFma.createContext(null);
$7b8d8d3adba9a65c$export$c7914228fb69b0f5.displayName = "Location";
const $7b8d8d3adba9a65c$export$9072aa6dd1f93057 = /*#__PURE__*/ $8NFma.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$7b8d8d3adba9a65c$export$9072aa6dd1f93057.displayName = "Route";
const $7b8d8d3adba9a65c$var$RouteErrorContext = /*#__PURE__*/ $8NFma.createContext(null);
$7b8d8d3adba9a65c$var$RouteErrorContext.displayName = "RouteError";
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7b8d8d3adba9a65c$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7b8d8d3adba9a65c$export$9c954a9d03d32f4a() && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useHref() may be used only in the context of a <Router> component.");
    let { basename: basename, navigator: navigator } = $8NFma.useContext($7b8d8d3adba9a65c$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7b8d8d3adba9a65c$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $47039de3e9f0864a$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7b8d8d3adba9a65c$export$9c954a9d03d32f4a() {
    return $8NFma.useContext($7b8d8d3adba9a65c$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7b8d8d3adba9a65c$export$45d76561a5302f2b() {
    !$7b8d8d3adba9a65c$export$9c954a9d03d32f4a() && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component.");
    return $8NFma.useContext($7b8d8d3adba9a65c$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7b8d8d3adba9a65c$export$1b3f31771c5d07c() {
    return $8NFma.useContext($7b8d8d3adba9a65c$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7b8d8d3adba9a65c$export$6c330e8992e8a295(pattern) {
    !$7b8d8d3adba9a65c$export$9c954a9d03d32f4a() && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useMatch() may be used only in the context of a <Router> component.");
    let { pathname: pathname } = $7b8d8d3adba9a65c$export$45d76561a5302f2b();
    return $8NFma.useMemo(()=>(0, $47039de3e9f0864a$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7b8d8d3adba9a65c$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7b8d8d3adba9a65c$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $8NFma.useContext($7b8d8d3adba9a65c$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $8NFma.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7b8d8d3adba9a65c$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $8NFma.useContext($7b8d8d3adba9a65c$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7b8d8d3adba9a65c$var$useNavigateStable() : $7b8d8d3adba9a65c$var$useNavigateUnstable();
}
function $7b8d8d3adba9a65c$var$useNavigateUnstable() {
    !$7b8d8d3adba9a65c$export$9c954a9d03d32f4a() && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component.");
    let dataRouterContext = $8NFma.useContext($7b8d8d3adba9a65c$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $8NFma.useContext($7b8d8d3adba9a65c$export$26749e8557646306);
    let { matches: matches } = $8NFma.useContext($7b8d8d3adba9a65c$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7b8d8d3adba9a65c$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $47039de3e9f0864a$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $8NFma.useRef(false);
    $7b8d8d3adba9a65c$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8NFma.useCallback(function(to, options) {
        if (options === void 0) options = {};
        (0, $47039de3e9f0864a$export$c0e02632e14916fd)(activeRef.current, $7b8d8d3adba9a65c$var$navigateEffectWarning);
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $47039de3e9f0864a$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $47039de3e9f0864a$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7b8d8d3adba9a65c$var$OutletContext = /*#__PURE__*/ $8NFma.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7b8d8d3adba9a65c$export$4138103a3ae699cc() {
    return $8NFma.useContext($7b8d8d3adba9a65c$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7b8d8d3adba9a65c$export$a3be3530d8e40d0b(context) {
    let outlet = $8NFma.useContext($7b8d8d3adba9a65c$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7b8d8d3adba9a65c$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $8NFma.useContext($7b8d8d3adba9a65c$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7b8d8d3adba9a65c$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $8NFma.useContext($7b8d8d3adba9a65c$export$26749e8557646306);
    let { matches: matches } = $8NFma.useContext($7b8d8d3adba9a65c$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7b8d8d3adba9a65c$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $47039de3e9f0864a$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $8NFma.useMemo(()=>(0, $47039de3e9f0864a$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7b8d8d3adba9a65c$export$5d3fca4a98652595(routes, locationArg) {
    return $7b8d8d3adba9a65c$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7b8d8d3adba9a65c$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7b8d8d3adba9a65c$export$9c954a9d03d32f4a() && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false, // router loaded. We can help them understand how to avoid that.
    "useRoutes() may be used only in the context of a <Router> component.");
    let { navigator: navigator } = $8NFma.useContext($7b8d8d3adba9a65c$export$26749e8557646306);
    let { matches: parentMatches } = $8NFma.useContext($7b8d8d3adba9a65c$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    {
        // You won't get a warning about 2 different <Routes> under a <Route>
        // without a trailing *, but this is a best-effort warning anyway since we
        // cannot even give the warning unless they land at the parent route.
        //
        // Example:
        //
        // <Routes>
        //   {/* This route path MUST end with /* because otherwise
        //       it will never match /blog/post/123 */}
        //   <Route path="blog" element={<Blog />} />
        //   <Route path="blog/feed" element={<BlogFeed />} />
        // </Routes>
        //
        // function Blog() {
        //   return (
        //     <Routes>
        //       <Route path="post/:id" element={<Post />} />
        //     </Routes>
        //   );
        // }
        let parentPath = parentRoute && parentRoute.path || "";
        $7b8d8d3adba9a65c$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*"), "You rendered descendant <Routes> (or called `useRoutes()`) at " + ('"' + parentPathname + '" (under <Route path="' + parentPath + '">) but the ') + 'parent route path has no trailing "*". This means if you navigate ' + "deeper, the parent won't match anymore and therefore the child " + "routes will never render.\n\n" + ('Please change the parent <Route path="' + parentPath + '"> to <Route ') + ('path="' + (parentPath === "/" ? "*" : parentPath + "/*") + '">.'));
    }
    let locationFromContext = $7b8d8d3adba9a65c$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $47039de3e9f0864a$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false, "When overriding the location using `<Routes location>` or `useRoutes(routes, location)`, the location pathname must begin with the portion of the URL pathname that was " + ('matched by all parent routes. The current pathname base is "' + parentPathnameBase + '" ') + ('but pathname "' + parsedLocationArg.pathname + '" was given in the `location` prop.'));
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $47039de3e9f0864a$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    (0, $47039de3e9f0864a$export$c0e02632e14916fd)(parentRoute || matches != null, 'No routes matched location "' + location.pathname + location.search + location.hash + '" ');
    (0, $47039de3e9f0864a$export$c0e02632e14916fd)(matches == null || matches[matches.length - 1].route.element !== undefined || matches[matches.length - 1].route.Component !== undefined || matches[matches.length - 1].route.lazy !== undefined, 'Matched leaf route at location "' + location.pathname + location.search + location.hash + '" ' + "does not have an element or Component. This means it will render an <Outlet /> with a " + 'null value by default resulting in an "empty" page.');
    let renderedMatches = $7b8d8d3adba9a65c$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $47039de3e9f0864a$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $47039de3e9f0864a$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7b8d8d3adba9a65c$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $47039de3e9f0864a$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7b8d8d3adba9a65c$var$DefaultErrorComponent() {
    let error = $7b8d8d3adba9a65c$export$ed527bf60f6e05f2();
    let message = (0, $47039de3e9f0864a$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    console.error("Error handled by React Router default ErrorBoundary:", error);
    devInfo = /*#__PURE__*/ $8NFma.createElement($8NFma.Fragment, null, /*#__PURE__*/ $8NFma.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /*#__PURE__*/ $8NFma.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /*#__PURE__*/ $8NFma.createElement("code", {
        style: codeStyles
    }, "ErrorBoundary"), " or", " ", /*#__PURE__*/ $8NFma.createElement("code", {
        style: codeStyles
    }, "errorElement"), " prop on your route."));
    return /*#__PURE__*/ $8NFma.createElement($8NFma.Fragment, null, /*#__PURE__*/ $8NFma.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $8NFma.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $8NFma.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7b8d8d3adba9a65c$var$defaultErrorElement = /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$var$DefaultErrorComponent, null);
class $7b8d8d3adba9a65c$var$RenderErrorBoundary extends $8NFma.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7b8d8d3adba9a65c$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $8NFma.useContext($7b8d8d3adba9a65c$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7b8d8d3adba9a65c$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false, "Could not find a matching route for errors on route IDs: " + Object.keys(errors).join(","));
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7b8d8d3adba9a65c$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7b8d8d3adba9a65c$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $8NFma.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7b8d8d3adba9a65c$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7b8d8d3adba9a65c$var$DataRouterHook || {});
var $7b8d8d3adba9a65c$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7b8d8d3adba9a65c$var$DataRouterStateHook || {});
function $7b8d8d3adba9a65c$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7b8d8d3adba9a65c$var$useDataRouterContext(hookName) {
    let ctx = $8NFma.useContext($7b8d8d3adba9a65c$export$3add0d5dce533e2e);
    !ctx && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false, $7b8d8d3adba9a65c$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $7b8d8d3adba9a65c$var$useDataRouterState(hookName) {
    let state = $8NFma.useContext($7b8d8d3adba9a65c$export$145dfa71566a64dc);
    !state && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false, $7b8d8d3adba9a65c$var$getDataRouterConsoleError(hookName));
    return state;
}
function $7b8d8d3adba9a65c$var$useRouteContext(hookName) {
    let route = $8NFma.useContext($7b8d8d3adba9a65c$export$9072aa6dd1f93057);
    !route && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false, $7b8d8d3adba9a65c$var$getDataRouterConsoleError(hookName));
    return route;
}
// Internal version with hookName-aware debugging
function $7b8d8d3adba9a65c$var$useCurrentRouteId(hookName) {
    let route = $7b8d8d3adba9a65c$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false, hookName + ' can only be used on routes that contain a unique "id"');
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7b8d8d3adba9a65c$export$5fc8298006ad9e58() {
    return $7b8d8d3adba9a65c$var$useCurrentRouteId($7b8d8d3adba9a65c$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7b8d8d3adba9a65c$export$d0fd4b7106de2769() {
    let state = $7b8d8d3adba9a65c$var$useDataRouterState($7b8d8d3adba9a65c$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7b8d8d3adba9a65c$export$600dc272ed516c15() {
    let dataRouterContext = $7b8d8d3adba9a65c$var$useDataRouterContext($7b8d8d3adba9a65c$var$DataRouterHook.UseRevalidator);
    let state = $7b8d8d3adba9a65c$var$useDataRouterState($7b8d8d3adba9a65c$var$DataRouterStateHook.UseRevalidator);
    return $8NFma.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7b8d8d3adba9a65c$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7b8d8d3adba9a65c$var$useDataRouterState($7b8d8d3adba9a65c$var$DataRouterStateHook.UseMatches);
    return $8NFma.useMemo(()=>matches.map((m)=>(0, $47039de3e9f0864a$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7b8d8d3adba9a65c$export$1448a5050d252c4d() {
    let state = $7b8d8d3adba9a65c$var$useDataRouterState($7b8d8d3adba9a65c$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7b8d8d3adba9a65c$var$useCurrentRouteId($7b8d8d3adba9a65c$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7b8d8d3adba9a65c$export$fd5d37484eab868d(routeId) {
    let state = $7b8d8d3adba9a65c$var$useDataRouterState($7b8d8d3adba9a65c$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7b8d8d3adba9a65c$export$fdc00f3f26066d5e() {
    let state = $7b8d8d3adba9a65c$var$useDataRouterState($7b8d8d3adba9a65c$var$DataRouterStateHook.UseActionData);
    let routeId = $7b8d8d3adba9a65c$var$useCurrentRouteId($7b8d8d3adba9a65c$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7b8d8d3adba9a65c$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $8NFma.useContext($7b8d8d3adba9a65c$var$RouteErrorContext);
    let state = $7b8d8d3adba9a65c$var$useDataRouterState($7b8d8d3adba9a65c$var$DataRouterStateHook.UseRouteError);
    let routeId = $7b8d8d3adba9a65c$var$useCurrentRouteId($7b8d8d3adba9a65c$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7b8d8d3adba9a65c$export$78a72ddb39bdd145() {
    let value = $8NFma.useContext($7b8d8d3adba9a65c$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7b8d8d3adba9a65c$export$17f53340677d5831() {
    let value = $8NFma.useContext($7b8d8d3adba9a65c$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7b8d8d3adba9a65c$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7b8d8d3adba9a65c$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7b8d8d3adba9a65c$var$useDataRouterContext($7b8d8d3adba9a65c$var$DataRouterHook.UseBlocker);
    let state = $7b8d8d3adba9a65c$var$useDataRouterState($7b8d8d3adba9a65c$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $8NFma.useState("");
    let blockerFunction = $8NFma.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7b8d8d3adba9a65c$var$_extends({}, currentLocation, {
                pathname: (0, $47039de3e9f0864a$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7b8d8d3adba9a65c$var$_extends({}, nextLocation, {
                pathname: (0, $47039de3e9f0864a$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $8NFma.useEffect(()=>{
        let key = String(++$7b8d8d3adba9a65c$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $8NFma.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $47039de3e9f0864a$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7b8d8d3adba9a65c$var$useNavigateStable() {
    let { router: router } = $7b8d8d3adba9a65c$var$useDataRouterContext($7b8d8d3adba9a65c$var$DataRouterHook.UseNavigateStable);
    let id = $7b8d8d3adba9a65c$var$useCurrentRouteId($7b8d8d3adba9a65c$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $8NFma.useRef(false);
    $7b8d8d3adba9a65c$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8NFma.useCallback(function(to, options) {
        if (options === void 0) options = {};
        (0, $47039de3e9f0864a$export$c0e02632e14916fd)(activeRef.current, $7b8d8d3adba9a65c$var$navigateEffectWarning);
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7b8d8d3adba9a65c$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7b8d8d3adba9a65c$var$alreadyWarned = {};
function $7b8d8d3adba9a65c$var$warningOnce(key, cond, message) {
    if (!cond && !$7b8d8d3adba9a65c$var$alreadyWarned[key]) {
        $7b8d8d3adba9a65c$var$alreadyWarned[key] = true;
        (0, $47039de3e9f0864a$export$c0e02632e14916fd)(false, message);
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7b8d8d3adba9a65c$var$START_TRANSITION = "startTransition";
const $7b8d8d3adba9a65c$var$startTransitionImpl = $8NFma[$7b8d8d3adba9a65c$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7b8d8d3adba9a65c$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8NFma.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8NFma.useCallback((newState)=>{
        if (v7_startTransition && $7b8d8d3adba9a65c$var$startTransitionImpl) $7b8d8d3adba9a65c$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8NFma.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $8NFma.useEffect(()=>{
        (0, $47039de3e9f0864a$export$c0e02632e14916fd)(fallbackElement == null || !router.future.v7_partialHydration, "`<RouterProvider fallbackElement>` is deprecated when using `v7_partialHydration`, use a `HydrateFallback` component instead");
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8NFma.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8NFma.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8NFma.createElement($8NFma.Fragment, null, /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7b8d8d3adba9a65c$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7b8d8d3adba9a65c$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7b8d8d3adba9a65c$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $8NFma.useRef();
    if (historyRef.current == null) historyRef.current = (0, $47039de3e9f0864a$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8NFma.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8NFma.useCallback((newState)=>{
        v7_startTransition && $7b8d8d3adba9a65c$var$startTransitionImpl ? $7b8d8d3adba9a65c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8NFma.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7b8d8d3adba9a65c$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7b8d8d3adba9a65c$export$9c954a9d03d32f4a() && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false, // the router loaded. We can help them understand how to avoid that.
    "<Navigate> may be used only in the context of a <Router> component.");
    let { future: future, static: isStatic } = $8NFma.useContext($7b8d8d3adba9a65c$export$26749e8557646306);
    (0, $47039de3e9f0864a$export$c0e02632e14916fd)(!isStatic, "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.");
    let { matches: matches } = $8NFma.useContext($7b8d8d3adba9a65c$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7b8d8d3adba9a65c$export$45d76561a5302f2b();
    let navigate = $7b8d8d3adba9a65c$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $47039de3e9f0864a$export$cae722b0cc860f13)(to, (0, $47039de3e9f0864a$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $8NFma.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7b8d8d3adba9a65c$export$910ae8079b2c2852(props) {
    return $7b8d8d3adba9a65c$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7b8d8d3adba9a65c$export$e7b0ac011bb776c6(_props) {
    (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.");
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7b8d8d3adba9a65c$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $47039de3e9f0864a$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7b8d8d3adba9a65c$export$9c954a9d03d32f4a() && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false, "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.");
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $8NFma.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7b8d8d3adba9a65c$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $47039de3e9f0864a$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $8NFma.useMemo(()=>{
        let trailingPathname = (0, $47039de3e9f0864a$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    (0, $47039de3e9f0864a$export$c0e02632e14916fd)(locationContext != null, '<Router basename="' + basename + '"> is not able to match the URL ' + ('"' + pathname + search + hash + '" because it does not start with the ') + "basename, so the <Router> won't render anything.");
    if (locationContext == null) return null;
    return /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7b8d8d3adba9a65c$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7b8d8d3adba9a65c$export$5d3fca4a98652595($7b8d8d3adba9a65c$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7b8d8d3adba9a65c$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$var$ResolveAwait, null, children));
}
var $7b8d8d3adba9a65c$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7b8d8d3adba9a65c$var$AwaitRenderStatus || {});
const $7b8d8d3adba9a65c$var$neverSettledPromise = new Promise(()=>{});
class $7b8d8d3adba9a65c$var$AwaitErrorBoundary extends $8NFma.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7b8d8d3adba9a65c$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7b8d8d3adba9a65c$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7b8d8d3adba9a65c$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $7b8d8d3adba9a65c$var$AwaitRenderStatus.error : "_data" in promise ? $7b8d8d3adba9a65c$var$AwaitRenderStatus.success : $7b8d8d3adba9a65c$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7b8d8d3adba9a65c$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7b8d8d3adba9a65c$var$AwaitRenderStatus.error && promise._error instanceof (0, $47039de3e9f0864a$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7b8d8d3adba9a65c$var$neverSettledPromise;
        if (status === $7b8d8d3adba9a65c$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7b8d8d3adba9a65c$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7b8d8d3adba9a65c$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $8NFma.createElement($7b8d8d3adba9a65c$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7b8d8d3adba9a65c$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7b8d8d3adba9a65c$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $8NFma.createElement($8NFma.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7b8d8d3adba9a65c$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $8NFma.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $8NFma.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $8NFma.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7b8d8d3adba9a65c$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7b8d8d3adba9a65c$export$e7b0ac011bb776c6) && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false, "[" + (typeof element.type === "string" ? element.type : element.type.name) + "] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>");
        !(!element.props.index || !element.props.children) && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7b8d8d3adba9a65c$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7b8d8d3adba9a65c$export$daf73786167a7f72(matches) {
    return $7b8d8d3adba9a65c$var$_renderMatches(matches);
}
function $7b8d8d3adba9a65c$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if (route.element) (0, $47039de3e9f0864a$export$c0e02632e14916fd)(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        Object.assign(updates, {
            element: /*#__PURE__*/ $8NFma.createElement(route.Component),
            Component: undefined
        });
    }
    if (route.HydrateFallback) {
        if (route.hydrateFallbackElement) (0, $47039de3e9f0864a$export$c0e02632e14916fd)(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        Object.assign(updates, {
            hydrateFallbackElement: /*#__PURE__*/ $8NFma.createElement(route.HydrateFallback),
            HydrateFallback: undefined
        });
    }
    if (route.ErrorBoundary) {
        if (route.errorElement) (0, $47039de3e9f0864a$export$c0e02632e14916fd)(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        Object.assign(updates, {
            errorElement: /*#__PURE__*/ $8NFma.createElement(route.ErrorBoundary),
            ErrorBoundary: undefined
        });
    }
    return updates;
}
function $7b8d8d3adba9a65c$export$f30f7e456d254e83(routes, opts) {
    return (0, $47039de3e9f0864a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7b8d8d3adba9a65c$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $47039de3e9f0864a$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7b8d8d3adba9a65c$export$52b333d321859367,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy
    }).initialize();
}



function $a8cea113a6044695$var$_extends() {
    $a8cea113a6044695$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a8cea113a6044695$var$_extends.apply(this, arguments);
}
function $a8cea113a6044695$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $a8cea113a6044695$var$defaultMethod = "get";
const $a8cea113a6044695$var$defaultEncType = "application/x-www-form-urlencoded";
function $a8cea113a6044695$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $a8cea113a6044695$var$isButtonElement(object) {
    return $a8cea113a6044695$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $a8cea113a6044695$var$isFormElement(object) {
    return $a8cea113a6044695$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $a8cea113a6044695$var$isInputElement(object) {
    return $a8cea113a6044695$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $a8cea113a6044695$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $a8cea113a6044695$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$a8cea113a6044695$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $a8cea113a6044695$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $a8cea113a6044695$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $a8cea113a6044695$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $a8cea113a6044695$var$_formDataSupportsSubmitter = null;
function $a8cea113a6044695$var$isFormDataSubmitterSupported() {
    if ($a8cea113a6044695$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $a8cea113a6044695$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $a8cea113a6044695$var$_formDataSupportsSubmitter = true;
    }
    return $a8cea113a6044695$var$_formDataSupportsSubmitter;
}
const $a8cea113a6044695$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $a8cea113a6044695$var$getFormEncType(encType) {
    if (encType != null && !$a8cea113a6044695$var$supportedFormEncTypes.has(encType)) {
        (0, $47039de3e9f0864a$export$c0e02632e14916fd)(false, '"' + encType + '" is not a valid `encType` for `<Form>`/`<fetcher.Form>` ' + ('and will default to "' + $a8cea113a6044695$var$defaultEncType + '"'));
        return null;
    }
    return encType;
}
function $a8cea113a6044695$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($a8cea113a6044695$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $47039de3e9f0864a$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $a8cea113a6044695$var$defaultMethod;
        encType = $a8cea113a6044695$var$getFormEncType(target.getAttribute("enctype")) || $a8cea113a6044695$var$defaultEncType;
        formData = new FormData(target);
    } else if ($a8cea113a6044695$var$isButtonElement(target) || $a8cea113a6044695$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $47039de3e9f0864a$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $a8cea113a6044695$var$defaultMethod;
        encType = $a8cea113a6044695$var$getFormEncType(target.getAttribute("formenctype")) || $a8cea113a6044695$var$getFormEncType(form.getAttribute("enctype")) || $a8cea113a6044695$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$a8cea113a6044695$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($a8cea113a6044695$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $a8cea113a6044695$var$defaultMethod;
        action = null;
        encType = $a8cea113a6044695$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $a8cea113a6044695$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $a8cea113a6044695$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $a8cea113a6044695$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $a8cea113a6044695$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $a8cea113a6044695$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $a8cea113a6044695$export$1f3f55432a00e06d(routes, opts) {
    return (0, $47039de3e9f0864a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $a8cea113a6044695$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $47039de3e9f0864a$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $a8cea113a6044695$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7b8d8d3adba9a65c$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $a8cea113a6044695$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $47039de3e9f0864a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $a8cea113a6044695$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $47039de3e9f0864a$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $a8cea113a6044695$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7b8d8d3adba9a65c$export$52b333d321859367),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $a8cea113a6044695$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $a8cea113a6044695$var$_extends({}, state, {
        errors: $a8cea113a6044695$var$deserializeErrors(state.errors)
    });
    return state;
}
function $a8cea113a6044695$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $47039de3e9f0864a$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $a8cea113a6044695$export$7ad602f0e94e62d1 = /*#__PURE__*/ $8NFma.createContext({
    isTransitioning: false
});
$a8cea113a6044695$export$7ad602f0e94e62d1.displayName = "ViewTransition";
const $a8cea113a6044695$export$148fd98d095596d4 = /*#__PURE__*/ $8NFma.createContext(new Map());
$a8cea113a6044695$export$148fd98d095596d4.displayName = "Fetchers";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $a8cea113a6044695$var$START_TRANSITION = "startTransition";
const $a8cea113a6044695$var$startTransitionImpl = $8NFma[$a8cea113a6044695$var$START_TRANSITION];
const $a8cea113a6044695$var$FLUSH_SYNC = "flushSync";
const $a8cea113a6044695$var$flushSyncImpl = $1c0f1e610963dfb8$exports[$a8cea113a6044695$var$FLUSH_SYNC];
const $a8cea113a6044695$var$USE_ID = "useId";
const $a8cea113a6044695$var$useIdImpl = $8NFma[$a8cea113a6044695$var$USE_ID];
function $a8cea113a6044695$var$startTransitionSafe(cb) {
    if ($a8cea113a6044695$var$startTransitionImpl) $a8cea113a6044695$var$startTransitionImpl(cb);
    else cb();
}
function $a8cea113a6044695$var$flushSyncSafe(cb) {
    if ($a8cea113a6044695$var$flushSyncImpl) $a8cea113a6044695$var$flushSyncImpl(cb);
    else cb();
}
class $a8cea113a6044695$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $a8cea113a6044695$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8NFma.useState(router.state);
    let [pendingState, setPendingState] = $8NFma.useState();
    let [vtContext, setVtContext] = $8NFma.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $8NFma.useState();
    let [transition, setTransition] = $8NFma.useState();
    let [interruption, setInterruption] = $8NFma.useState();
    let fetcherData = $8NFma.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $8NFma.useCallback((cb)=>{
        if (v7_startTransition) $a8cea113a6044695$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $8NFma.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $a8cea113a6044695$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $a8cea113a6044695$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $a8cea113a6044695$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $a8cea113a6044695$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $a8cea113a6044695$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8NFma.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $8NFma.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $a8cea113a6044695$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $8NFma.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $8NFma.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $8NFma.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $8NFma.useEffect(()=>{
        (0, $47039de3e9f0864a$export$c0e02632e14916fd)(fallbackElement == null || !router.future.v7_partialHydration, "`<RouterProvider fallbackElement>` is deprecated when using `v7_partialHydration`, use a `HydrateFallback` component instead");
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8NFma.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8NFma.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8NFma.createElement($8NFma.Fragment, null, /*#__PURE__*/ $8NFma.createElement((0, $7b8d8d3adba9a65c$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8NFma.createElement((0, $7b8d8d3adba9a65c$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $8NFma.createElement($a8cea113a6044695$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $8NFma.createElement($a8cea113a6044695$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $8NFma.createElement((0, $7b8d8d3adba9a65c$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8NFma.createElement($a8cea113a6044695$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $a8cea113a6044695$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7b8d8d3adba9a65c$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $a8cea113a6044695$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $8NFma.useRef();
    if (historyRef.current == null) historyRef.current = (0, $47039de3e9f0864a$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8NFma.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8NFma.useCallback((newState)=>{
        v7_startTransition && $a8cea113a6044695$var$startTransitionImpl ? $a8cea113a6044695$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8NFma.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8NFma.createElement((0, $7b8d8d3adba9a65c$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $a8cea113a6044695$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $8NFma.useRef();
    if (historyRef.current == null) historyRef.current = (0, $47039de3e9f0864a$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8NFma.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8NFma.useCallback((newState)=>{
        v7_startTransition && $a8cea113a6044695$var$startTransitionImpl ? $a8cea113a6044695$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8NFma.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8NFma.createElement((0, $7b8d8d3adba9a65c$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $a8cea113a6044695$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $8NFma.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8NFma.useCallback((newState)=>{
        v7_startTransition && $a8cea113a6044695$var$startTransitionImpl ? $a8cea113a6044695$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8NFma.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8NFma.createElement((0, $7b8d8d3adba9a65c$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
$a8cea113a6044695$export$eefb0c834599897e.displayName = "unstable_HistoryRouter";
const $a8cea113a6044695$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $a8cea113a6044695$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $a8cea113a6044695$export$a6c7ac8248d6e38a = /*#__PURE__*/ $8NFma.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $a8cea113a6044695$var$_objectWithoutPropertiesLoose(_ref7, $a8cea113a6044695$var$_excluded);
    let { basename: basename } = $8NFma.useContext((0, $7b8d8d3adba9a65c$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $a8cea113a6044695$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($a8cea113a6044695$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $47039de3e9f0864a$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {
            // We can't do external URL detection without a valid URL
            (0, $47039de3e9f0864a$export$c0e02632e14916fd)(false, '<Link to="' + to + '"> contains an invalid URL which will probably break ' + "when clicked - please update to a valid URL path.");
        }
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7b8d8d3adba9a65c$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $a8cea113a6044695$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $8NFma.createElement("a", $a8cea113a6044695$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
$a8cea113a6044695$export$a6c7ac8248d6e38a.displayName = "Link";
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $a8cea113a6044695$export$b0d92dbee9b5b60d = /*#__PURE__*/ $8NFma.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $a8cea113a6044695$var$_objectWithoutPropertiesLoose(_ref8, $a8cea113a6044695$var$_excluded2);
    let path = (0, $7b8d8d3adba9a65c$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7b8d8d3adba9a65c$export$45d76561a5302f2b)();
    let routerState = $8NFma.useContext((0, $7b8d8d3adba9a65c$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $8NFma.useContext((0, $7b8d8d3adba9a65c$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $a8cea113a6044695$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $47039de3e9f0864a$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $8NFma.createElement($a8cea113a6044695$export$a6c7ac8248d6e38a, $a8cea113a6044695$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
$a8cea113a6044695$export$b0d92dbee9b5b60d.displayName = "NavLink";
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $a8cea113a6044695$export$a7fed597f4b8afd8 = /*#__PURE__*/ $8NFma.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $a8cea113a6044695$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $a8cea113a6044695$var$_objectWithoutPropertiesLoose(_ref9, $a8cea113a6044695$var$_excluded3);
    let submit = $a8cea113a6044695$export$47c85c6e3a081d3();
    let formAction = $a8cea113a6044695$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $8NFma.createElement("form", $a8cea113a6044695$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
$a8cea113a6044695$export$a7fed597f4b8afd8.displayName = "Form";
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $a8cea113a6044695$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $a8cea113a6044695$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
$a8cea113a6044695$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $a8cea113a6044695$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($a8cea113a6044695$var$DataRouterHook || ($a8cea113a6044695$var$DataRouterHook = {}));
var $a8cea113a6044695$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($a8cea113a6044695$var$DataRouterStateHook || ($a8cea113a6044695$var$DataRouterStateHook = {}));
// Internal hooks
function $a8cea113a6044695$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $a8cea113a6044695$var$useDataRouterContext(hookName) {
    let ctx = $8NFma.useContext((0, $7b8d8d3adba9a65c$export$3add0d5dce533e2e));
    !ctx && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false, $a8cea113a6044695$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $a8cea113a6044695$var$useDataRouterState(hookName) {
    let state = $8NFma.useContext((0, $7b8d8d3adba9a65c$export$145dfa71566a64dc));
    !state && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false, $a8cea113a6044695$var$getDataRouterConsoleError(hookName));
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $a8cea113a6044695$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7b8d8d3adba9a65c$export$9770f232ac06a008)();
    let location = (0, $7b8d8d3adba9a65c$export$45d76561a5302f2b)();
    let path = (0, $7b8d8d3adba9a65c$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $8NFma.useCallback((event)=>{
        if ($a8cea113a6044695$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $47039de3e9f0864a$export$fe53371bee54353d)(location) === (0, $47039de3e9f0864a$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $a8cea113a6044695$export$f1a78c17382fe22a(defaultInit) {
    (0, $47039de3e9f0864a$export$c0e02632e14916fd)(typeof URLSearchParams !== "undefined", "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params\n\nIf you're unsure how to load polyfills, we recommend you check out https://polyfill.io/v3/ which provides some recommendations about how to load polyfills only for users that need them, instead of for every user.");
    let defaultSearchParamsRef = $8NFma.useRef($a8cea113a6044695$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $8NFma.useRef(false);
    let location = (0, $7b8d8d3adba9a65c$export$45d76561a5302f2b)();
    let searchParams = $8NFma.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $a8cea113a6044695$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7b8d8d3adba9a65c$export$9770f232ac06a008)();
    let setSearchParams = $8NFma.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $a8cea113a6044695$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $a8cea113a6044695$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $a8cea113a6044695$var$fetcherId = 0;
let $a8cea113a6044695$var$getUniqueFetcherId = ()=>"__" + String(++$a8cea113a6044695$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $a8cea113a6044695$export$47c85c6e3a081d3() {
    let { router: router } = $a8cea113a6044695$var$useDataRouterContext($a8cea113a6044695$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $8NFma.useContext((0, $7b8d8d3adba9a65c$export$26749e8557646306));
    let currentRouteId = (0, $7b8d8d3adba9a65c$export$5fc8298006ad9e58)();
    return $8NFma.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $a8cea113a6044695$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $a8cea113a6044695$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $a8cea113a6044695$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $a8cea113a6044695$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $8NFma.useContext((0, $7b8d8d3adba9a65c$export$26749e8557646306));
    let routeContext = $8NFma.useContext((0, $7b8d8d3adba9a65c$export$9072aa6dd1f93057));
    !routeContext && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $a8cea113a6044695$var$_extends({}, (0, $7b8d8d3adba9a65c$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7b8d8d3adba9a65c$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $47039de3e9f0864a$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $47039de3e9f0864a$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $a8cea113a6044695$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $a8cea113a6044695$var$useDataRouterContext($a8cea113a6044695$var$DataRouterHook.UseFetcher);
    let state = $a8cea113a6044695$var$useDataRouterState($a8cea113a6044695$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $8NFma.useContext($a8cea113a6044695$export$148fd98d095596d4);
    let route = $8NFma.useContext((0, $7b8d8d3adba9a65c$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false, "useFetcher must be used inside a FetchersContext");
    !route && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false, "useFetcher must be used inside a RouteContext");
    !(routeId != null) && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false, 'useFetcher can only be used on routes that contain a unique "id"');
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $a8cea113a6044695$var$useIdImpl ? $a8cea113a6044695$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $8NFma.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($a8cea113a6044695$var$getUniqueFetcherId());
    // Registration/cleanup
    $8NFma.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $8NFma.useCallback((href, opts)=>{
        !routeId && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false, "No routeId available for fetcher.load()");
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $a8cea113a6044695$export$47c85c6e3a081d3();
    let submit = $8NFma.useCallback((target, opts)=>{
        submitImpl(target, $a8cea113a6044695$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $8NFma.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $8NFma.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $8NFma.createElement($a8cea113a6044695$export$a7fed597f4b8afd8, $a8cea113a6044695$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        FetcherForm.displayName = "fetcher.Form";
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $47039de3e9f0864a$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $8NFma.useMemo(()=>$a8cea113a6044695$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $a8cea113a6044695$export$fa996778a3a31087() {
    let state = $a8cea113a6044695$var$useDataRouterState($a8cea113a6044695$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $a8cea113a6044695$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $a8cea113a6044695$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $a8cea113a6044695$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $a8cea113a6044695$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $a8cea113a6044695$var$useDataRouterContext($a8cea113a6044695$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $a8cea113a6044695$var$useDataRouterState($a8cea113a6044695$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $8NFma.useContext((0, $7b8d8d3adba9a65c$export$26749e8557646306));
    let location = (0, $7b8d8d3adba9a65c$export$45d76561a5302f2b)();
    let matches = (0, $7b8d8d3adba9a65c$export$2378eb7f5ff86053)();
    let navigation = (0, $7b8d8d3adba9a65c$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $8NFma.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $a8cea113a6044695$var$usePageHide($8NFma.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $a8cea113a6044695$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $a8cea113a6044695$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($a8cea113a6044695$var$savedScrollPositions));
        } catch (error) {
            (0, $47039de3e9f0864a$export$c0e02632e14916fd)(false, "Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (" + error + ").");
        }
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8NFma.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $a8cea113a6044695$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $a8cea113a6044695$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8NFma.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($a8cea113a6044695$var$_extends({}, location, {
                    pathname: (0, $47039de3e9f0864a$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($a8cea113a6044695$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8NFma.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $a8cea113a6044695$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $8NFma.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $a8cea113a6044695$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $8NFma.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $a8cea113a6044695$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $7b8d8d3adba9a65c$export$b273b3273281a049)(when);
    $8NFma.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $8NFma.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $a8cea113a6044695$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $8NFma.useContext($a8cea113a6044695$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $47039de3e9f0864a$export$3e9cee6b33872309)(false, "`unstable_useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $a8cea113a6044695$var$useDataRouterContext($a8cea113a6044695$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7b8d8d3adba9a65c$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $47039de3e9f0864a$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $47039de3e9f0864a$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $47039de3e9f0864a$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $47039de3e9f0864a$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}


const $e3115ce8c8a8ec19$var$Wrapper = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
  flex-grow: 1;
  animation: ${(0, $6795754bca05c124$export$b2a0bb8fc9a08697)} 0.2s ease;
`;
const $e3115ce8c8a8ec19$var$TokenIcon = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
  width: 20px;
  height: 20px;
  background-image: url(${({ imageUrl: imageUrl })=>imageUrl});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
`;
const $e3115ce8c8a8ec19$var$TimeInnerContainer = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
`;
var $e3115ce8c8a8ec19$var$State;
(function(State) {
    State[State["SettingAmount"] = 0] = "SettingAmount";
    State[State["SettingPaymentMethod"] = 1] = "SettingPaymentMethod";
    State[State["SettingInputFields"] = 2] = "SettingInputFields";
    State[State["MakingPayment"] = 3] = "MakingPayment";
})($e3115ce8c8a8ec19$var$State || ($e3115ce8c8a8ec19$var$State = {}));
function $e3115ce8c8a8ec19$var$Presale(props) {
    const [customizations, setCustomizations] = (0, $8NFma.useState)({
        leftPanelColor: "white",
        primaryButtonColor: "black"
    });
    const [searchParams] = (0, $a8cea113a6044695$export$f1a78c17382fe22a)();
    const [fiatAmount, setFiatAmount] = (0, $8NFma.useState)();
    const [tokenAmount, setTokenAmount] = (0, $8NFma.useState)();
    const [bonusTokenAmount, setBonusTokenAmount] = (0, $8NFma.useState)();
    const [selectedMethod, setSelectedPaymentMethod] = (0, $8NFma.useState)(props.checkoutData.gateway.managed?.methods[0]);
    const [state, setState] = (0, $8NFma.useState)(0);
    const [startsAt, setStartsAt] = (0, $8NFma.useState)();
    const [endsAt, setEndsAt] = (0, $8NFma.useState)();
    const [nextPriceIncreaseAt, setNextPriceIncreaseAt] = (0, $8NFma.useState)();
    (0, $8NFma.useEffect)(()=>{
        setSelectedPaymentMethod(props.checkoutData.gateway.managed?.methods[0]);
    }, [
        props.checkoutData.gateway.managed?.methods
    ]);
    if (!props.checkoutData.products || props.checkoutData.products?.length <= 0) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $13f4c0370d7de649$exports.Fragment), {});
    const presaleData = props.checkoutData.presaleData;
    const token = props.checkoutData.products[0];
    const titleTextColor = (0, $2a4a168be657655e$export$8121a4101142837f)(customizations.leftPanelColor, "rgba(255, 255, 255, 1)", "rgba(0, 0, 0, 1)");
    const lightTextColor = (0, $2a4a168be657655e$export$8121a4101142837f)(customizations.leftPanelColor, "rgba(255, 255, 255, 0.05)", "rgba(0, 0, 0, 0.05)");
    const mediumTextColor = (0, $2a4a168be657655e$export$8121a4101142837f)(customizations.leftPanelColor, "rgba(255, 255, 255, 0.1)", "rgba(0, 0, 0, 0.1)");
    const textColor = (0, $2a4a168be657655e$export$8121a4101142837f)(customizations.leftPanelColor, "rgba(255, 255, 255, 0.45)", "rgba(0, 0, 0, 0.45)");
    const darkTextColor = (0, $2a4a168be657655e$export$8121a4101142837f)(customizations.leftPanelColor, "rgba(255, 255, 255, 0.65)", "rgba(0, 0, 0, 0.65)");
    const buttonTextColor = (0, $2a4a168be657655e$export$8121a4101142837f)(customizations.primaryButtonColor, "rgba(255, 255, 255, 0.95)", "rgba(0, 0, 0, 0.95)");
    const [priceMultiplier, setPriceMultiplier] = (0, $8NFma.useState)(1);
    const getBonus = (amount, bonusLevels)=>{
        for (const level of bonusLevels){
            if (amount >= level.greaterThan && amount < level.lessThan) return level.bonus;
        }
        return 0;
    };
    const setTokenAmountFromFiatAmount = (fiatAmount)=>{
        const price = token.product.price * priceMultiplier;
        const tokenAmount = Number(fiatAmount) / price;
        const bonus = getBonus(tokenAmount, presaleData?.tokenPresaleData?.bonus ?? []);
        setTokenAmount((0, $O6tRJ.round)(tokenAmount, token.product.productType?.Presale?.Token?.decimals).toString());
        setBonusTokenAmount((tokenAmount * bonus / 100).toString());
    };
    const setFiatAmountFromTokenAmount = (tokenAmount)=>{
        const bonus = getBonus(tokenAmount, presaleData?.tokenPresaleData?.bonus ?? []);
        setBonusTokenAmount((tokenAmount * bonus / 100).toString());
        const price = token.product.price * priceMultiplier;
        const fiatAmount = Number(tokenAmount) * price;
        setFiatAmount((0, $O6tRJ.round)(fiatAmount, 2).toString());
    };
    const updateIntervals = ()=>{
        const { startsAt: startsAt, endsAt: endsAt, pricingStrategies: pricingStrategies } = presaleData?.tokenPresaleData ?? {};
        setStartsAt(startsAt ? new Date(startsAt) : undefined);
        setEndsAt(endsAt ? new Date(endsAt) : undefined);
        setNextPriceIncreaseAt(undefined);
        if (pricingStrategies) {
            const { timeBased: timeBased } = pricingStrategies;
            if (timeBased) {
                const { startsAt: startsAt, roundDurationSeconds: roundDurationSeconds, priceIncreasePercentage: priceIncreasePercentage } = timeBased;
                const roundDuration = roundDurationSeconds * 1000 || 1000;
                const start = new Date(startsAt).getTime();
                const now = new Date().getTime();
                let nextIncreaseAt;
                if (start > now) nextIncreaseAt = start + roundDuration;
                else {
                    nextIncreaseAt = start + Math.ceil((now - start) / roundDuration) * roundDuration;
                    const multipliers = Math.floor((now - start) / roundDuration);
                    const percentIncrease = 1 + multipliers * priceIncreasePercentage;
                    setPriceMultiplier(percentIncrease);
                }
                setNextPriceIncreaseAt((0, $16f75469e5b80165$export$2e2bcd8739ae039)({
                    start: new Date(),
                    end: new Date(nextIncreaseAt)
                }));
            }
        }
        const amountBased = pricingStrategies?.amountBased;
        if (amountBased) {
            const totalRaised = Number(presaleData?.tokenPresaleData?.totalAmountRaised ?? 0);
            for (const stage of amountBased.sort((a, b)=>Number(b.targetAmount) - Number(a.targetAmount))){
                const targetAmount = Number(stage.targetAmount);
                const priceIncreaseTo = Number(stage.priceIncreaseTo);
                if (totalRaised >= targetAmount) {
                    const newMultipliers = 1 + (priceIncreaseTo - token.product.price) / token.product.price;
                    setPriceMultiplier(newMultipliers);
                    return;
                }
            }
        }
        setPriceMultiplier(1);
    };
    (0, $8NFma.useEffect)(()=>{
        setCustomizations(props.checkoutData.customizations ?? customizations);
        const interval = setInterval(()=>updateIntervals(), 1000);
        updateIntervals();
        return ()=>clearInterval(interval);
    }, [
        props.checkoutData
    ]);
    (0, $8NFma.useEffect)(()=>{
        setErrorMessage(props.errorMessage);
    }, [
        props.errorMessage
    ]);
    const [managedPaymentQrCode, setManagedPaymentQrCode] = (0, $8NFma.useState)("");
    const generateManagedPaymentQrCode = async ()=>{
        if (!props.managedPaymentDetails) return;
        const darkColor = (0, $2a4a168be657655e$export$8121a4101142837f)(customizations.leftPanelColor, "#00000000", "#ffffff00");
        const lightColor = (0, $2a4a168be657655e$export$8121a4101142837f)(customizations.primaryButtonColor, "#000000", "#000000");
        const [qrCodeData] = await (0, $d70492f3fe4454f0$export$45312203e6f4f22c)(props.managedPaymentDetails, lightColor, darkColor, true);
        setManagedPaymentQrCode(qrCodeData);
    };
    const [errorMessage, setErrorMessage] = (0, $8NFma.useState)();
    const { disconnect: disconnect } = (0, $e271cce8b43c0b7b$export$83bebf2fe7fead4e)();
    const { address: address, isConnected: isConnected, connector: connector } = (0, $9cc58b6deaa591e8$export$83a8e409853da004)();
    const { open: open } = (0, $dbb64e404ec3de5f$export$69804ca079d47f29)();
    const [isWalletLoading, setIsWalletLoading] = (0, $8NFma.useState)(false);
    const onClickOpenWallet = async ()=>{
        if (!props.managedPaymentDetails) return;
        switch(props.managedPaymentDetails.network){
            case "Bitcoin":
            case "Solana":
            case "Zcash":
            case "ZcashTestnet":
                break;
            case "Ethereum":
            case "SepoliaTestnet":
            case "Polygon":
            case "PolygonTestnet":
            case "BNB":
            case "BNBTestnet":
            case "Base":
            case "Arbitrum":
            case "Avalanche":
                try {
                    setErrorMessage("");
                    if (!address) {
                        await open();
                        return;
                    }
                    if (!selectedMethod) return;
                    setIsWalletLoading(true);
                    const chain = (0, $61f236426b9e4eab$export$cc4208a8ebc9f985)[props.managedPaymentDetails.network];
                    const provider = await connector?.getProvider();
                    const signer = (0, $d7839887e0efaf1b$export$362b8ea2edbd9090)({
                        chain: chain,
                        transport: (0, $11d4efd0771a10a6$export$4c00f665f0d4b443)(provider)
                    });
                    if (connector?.switchChain) {
                        const chainId = await connector.getChainId();
                        if (chainId !== chain.id) await connector?.switchChain({
                            chainId: chain.id
                        });
                    }
                    if (props.managedPaymentDetails.token) {
                        const contract = (0, $740fc174ca817919$export$f518c38144e1f9d)({
                            address: props.managedPaymentDetails.token,
                            abi: (0, $9nOfC.erc20Abi),
                            client: signer
                        });
                        const balance = await contract.read.balanceOf([
                            address
                        ]);
                        const decimals = await contract.read.decimals();
                        const parsedAmount = (0, $996ac4676bde0a02$export$203ae30b4f6490b3)(props.managedPaymentDetails.amount.toString(), decimals);
                        if (balance < parsedAmount) {
                            setIsWalletLoading(false);
                            return setErrorMessage(`Your wallet does not have enough ${(0, $61f236426b9e4eab$export$8793fab959da70d1)(selectedMethod.network, selectedMethod.token).name} for payment.`);
                        }
                        await contract.write.transfer([
                            props.managedPaymentDetails.paymentAddress,
                            (0, $996ac4676bde0a02$export$203ae30b4f6490b3)(props.managedPaymentDetails.amount, decimals)
                        ], {
                            account: address,
                            chain: chain
                        });
                    } else {
                        const publicClient = (0, $7c826deba1e299e5$export$d8e090d8c6a7a6ad)({
                            chain: chain,
                            transport: (0, $f31cbc431d98644d$export$7d6f1c8842f9f527)()
                        });
                        const contract = (0, $740fc174ca817919$export$f518c38144e1f9d)({
                            address: props.managedPaymentDetails.token,
                            abi: (0, $9nOfC.erc20Abi),
                            client: {
                                public: publicClient,
                                wallet: signer
                            }
                        });
                        try {
                            const balance = await contract.read.balanceOf([
                                address
                            ]);
                            if (balance < (0, $1a21c088f688ce4c$export$642c4e67bbdc0bc7)(props.managedPaymentDetails.amount)) {
                                setIsWalletLoading(false);
                                return setErrorMessage("Your wallet does not have enough ether for payment.");
                            }
                        } catch (err) {
                            console.log(err);
                        }
                        if (!signer) return;
                        await signer.sendTransaction({
                            account: address,
                            chain: chain,
                            to: props.managedPaymentDetails.paymentAddress,
                            value: (0, $1a21c088f688ce4c$export$642c4e67bbdc0bc7)(props.managedPaymentDetails.amount)
                        });
                        setIsWalletLoading(false);
                    }
                } catch (err) {
                    setIsWalletLoading(false);
                    // setErrorMessage('Failed to open wallet. Please ensure you have enough funds.')
                    console.error(err);
                }
                break;
            default:
                console.error("No wallet");
        }
    };
    const totalRaised = Number(presaleData?.tokenPresaleData?.totalAmountRaised ?? 0);
    const totalGoal = Number(presaleData?.tokenPresaleData?.totalRaiseAmount) || 1;
    const amountBasedStages = presaleData?.tokenPresaleData?.pricingStrategies?.amountBased ?? [];
    const segments = amountBasedStages.map((stage)=>{
        const stageTarget = Number(stage.targetAmount);
        const reached = totalRaised >= stageTarget;
        return {
            width: stageTarget / totalGoal * 100,
            color: reached ? customizations.primaryButtonColor : lightTextColor,
            borderColor: titleTextColor
        };
    });
    let currentStageName = "";
    for (const stage of amountBasedStages.sort((a, b)=>Number(b.targetAmount) - Number(a.targetAmount))){
        const stageTarget = Number(stage.targetAmount);
        if (totalRaised >= stageTarget) {
            currentStageName = stage.name;
            break;
        }
    }
    (0, $8NFma.useEffect)(()=>{
        if (props.managedPaymentDetails) generateManagedPaymentQrCode();
    }, [
        props.managedPaymentDetails
    ]);
    (0, $8NFma.useEffect)(()=>{
        const customUrlParmasLabel = [
            "fiatAmount",
            "tokenAmount"
        ];
        for (const label of customUrlParmasLabel){
            const value = searchParams.get(label);
            if (value) {
                if (label === "fiatAmount") {
                    setFiatAmount(value);
                    setTokenAmountFromFiatAmount(Number(value));
                } else if (label === "tokenAmount") {
                    setTokenAmount(value);
                    setFiatAmountFromTokenAmount(Number(value));
                }
            }
        }
    }, [
        priceMultiplier
    ]);
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 14,
            minHeight: "100%"
        },
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
            style: {
                width: 450,
                minHeight: 550,
                maxWidth: "100%",
                background: customizations.leftPanelColor,
                padding: 30,
                borderRadius: 25,
                display: "flex",
                flexDirection: "column",
                position: "relative",
                overflow: "hidden"
            },
            children: [
                (props.paymentStatus ? Number(props.paymentStatus.amountRemaining) > 0 : true) && props.managedPaymentDetails && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $6795754bca05c124$export$c825e58f74061357), {
                    style: {
                        zIndex: 0,
                        pointerEvents: "none",
                        opacity: 0.15
                    },
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $6795754bca05c124$export$b8bb87b40c00c04e), {
                        style: {
                            top: 150
                        }
                    })
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: 30,
                        textAlign: "center",
                        zIndex: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                            style: {
                                fontSize: Number(presaleData?.tokenPresaleData?.customizations?.titleFontSize ?? 46),
                                fontWeight: 800,
                                fontFamily: presaleData?.tokenPresaleData?.customizations?.titleFontFamily,
                                color: presaleData?.tokenPresaleData?.customizations?.titleFontColor ?? titleTextColor
                            },
                            children: [
                                presaleData?.tokenPresaleData?.customizations?.title ?? `BUY $${token.product.productType?.Presale?.Token?.ticker}`,
                                currentStageName !== "" && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                    style: {
                                        fontSize: Number(presaleData?.tokenPresaleData?.customizations?.titleFontSize ?? 24),
                                        marginBottom: 10
                                    },
                                    children: currentStageName
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                            style: {
                                color: textColor
                            },
                            children: [
                                "1 ",
                                token.product.productType?.Presale?.Token?.ticker,
                                " = ",
                                (0, $3562cc065b5f3994$export$3dc27271f5d5c629)(token.product.currency, token.product.price * priceMultiplier, 10)
                            ]
                        })
                    ]
                }),
                state === 0 && !nextPriceIncreaseAt && endsAt && endsAt.getTime() > new Date().getTime() && (!startsAt || startsAt && startsAt.getTime() < new Date().getTime()) && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    style: {
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                        marginBottom: 30
                    },
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                        style: {
                            padding: "10px 20px",
                            color: darkTextColor,
                            backgroundColor: lightTextColor,
                            borderRadius: 10
                        },
                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                            children: [
                                "Presale ends in ",
                                (0, $68ab5c1af0093868$export$2e2bcd8739ae039)(endsAt)
                            ]
                        })
                    })
                }),
                state === 0 && nextPriceIncreaseAt && (!endsAt || endsAt && endsAt.getTime() > new Date().getTime()) && (!startsAt || startsAt && startsAt.getTime() < new Date().getTime()) && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: 30,
                        width: "100%"
                    },
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            alignItems: "center",
                            borderRadius: 10,
                            gap: 10
                        },
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                style: {
                                    fontSize: 14,
                                    color: titleTextColor
                                },
                                children: "Next price increase in"
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "column",
                                    width: "100%",
                                    alignItems: "center",
                                    border: `1px solid ${mediumTextColor}`,
                                    borderRadius: 10,
                                    overflow: "hidden"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                        style: {
                                            alignItems: "center",
                                            display: "grid",
                                            gridTemplateColumns: "repeat(4, 1fr)",
                                            width: "100%",
                                            padding: 15
                                        },
                                        children: [
                                            "days",
                                            "hours",
                                            "minutes",
                                            "seconds"
                                        ].map((t)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($e3115ce8c8a8ec19$var$TimeInnerContainer, {
                                                children: [
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                        style: {
                                                            textTransform: "uppercase",
                                                            color: darkTextColor,
                                                            fontSize: 10
                                                        },
                                                        children: (0, $O6tRJ.startCase)(t)
                                                    }),
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                        style: {
                                                            color: titleTextColor,
                                                            fontSize: 18
                                                        },
                                                        children: nextPriceIncreaseAt[t]
                                                    })
                                                ]
                                            }, t))
                                    }),
                                    endsAt && endsAt.getTime() > new Date().getTime() && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                        style: {
                                            color: darkTextColor,
                                            fontSize: 12,
                                            textAlign: "center",
                                            backgroundColor: lightTextColor,
                                            width: "100%",
                                            padding: 3
                                        },
                                        children: [
                                            "Presale ends in ",
                                            (0, $68ab5c1af0093868$export$2e2bcd8739ae039)(endsAt)
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                (props.paymentStatus ? Number(props.paymentStatus.amountRemaining) > 0 : true) && props.managedPaymentDetails && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($e3115ce8c8a8ec19$var$Wrapper, {
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        flexGrow: 1,
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 30
                    },
                    children: [
                        props.paymentStatus?.status !== "expired" && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $6795754bca05c124$export$ec3c7ce6a909733b), {
                            style: {
                                boxShadow: "initial"
                            },
                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $6795754bca05c124$export$3c6b4f0e2cd37515), {
                                style: {
                                    border: "1px solid",
                                    borderColor: textColor,
                                    background: "white",
                                    borderRadius: 10,
                                    width: 168,
                                    height: 168,
                                    position: "relative",
                                    overflow: "hidden",
                                    padding: 3
                                },
                                children: [
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                        style: {
                                            width: "100%",
                                            height: "100%",
                                            position: "absolute",
                                            opacity: 0.15,
                                            zIndex: 0,
                                            left: 0,
                                            top: 0
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                                        src: managedPaymentQrCode,
                                        style: {
                                            width: 160,
                                            height: 160,
                                            position: "relative",
                                            zIndex: 1
                                        }
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                rowGap: 20,
                                columnGap: 30,
                                flexWrap: "wrap",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        flexDirection: "column",
                                        fontSize: 12,
                                        gap: 3
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 5
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                    style: {
                                                        opacity: 0.5,
                                                        textTransform: "uppercase",
                                                        color: darkTextColor
                                                    },
                                                    children: "Amount due"
                                                }),
                                                props.paymentStatus?.status !== "expired" && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $6795754bca05c124$export$4f2558dd25106ae2), {
                                                    style: {
                                                        background: lightTextColor,
                                                        color: textColor
                                                    },
                                                    iconColor: textColor,
                                                    onClick: async ()=>await navigator.clipboard.writeText((0, $2a4a168be657655e$export$f5dd818bff069720)(props.managedPaymentDetails?.amount, {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 18
                                                        }))
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                            style: {
                                                fontSize: 16,
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 5,
                                                fontWeight: 300,
                                                color: titleTextColor
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                                                    src: (0, $61f236426b9e4eab$export$8793fab959da70d1)(props.managedPaymentDetails.network, props.managedPaymentDetails.token).logo,
                                                    style: {
                                                        height: 20,
                                                        width: "auto"
                                                    }
                                                }),
                                                (0, $2a4a168be657655e$export$f5dd818bff069720)(props.managedPaymentDetails.amount, {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 18
                                                }),
                                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                    style: {
                                                        opacity: 0.5,
                                                        fontWeight: 100
                                                    },
                                                    children: (0, $61f236426b9e4eab$export$8793fab959da70d1)(props.managedPaymentDetails.network, props.managedPaymentDetails.token).ticker
                                                }),
                                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                                                    children: [
                                                        "on ",
                                                        selectedMethod?.network
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        flexDirection: "column",
                                        fontSize: 12,
                                        gap: 3,
                                        alignItems: "start"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                            style: {
                                                opacity: 0.5,
                                                textTransform: "uppercase",
                                                textAlign: "center",
                                                color: darkTextColor
                                            },
                                            children: "Time remaining"
                                        }),
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                            style: {
                                                fontSize: 16,
                                                fontWeight: 100,
                                                textAlign: "center",
                                                color: titleTextColor
                                            },
                                            children: (0, $6795754bca05c124$export$8e3f267d166b4a05)((new Date(props.managedPaymentDetails.expiresAt).getTime() - new Date().getTime()) / 1000)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                    style: {
                                        display: "flex",
                                        flexDirection: "column",
                                        fontSize: 12,
                                        gap: 3
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 5
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                    style: {
                                                        opacity: 0.5,
                                                        textTransform: "uppercase",
                                                        color: darkTextColor
                                                    },
                                                    children: "Payment address"
                                                }),
                                                props.paymentStatus?.status !== "expired" && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $6795754bca05c124$export$4f2558dd25106ae2), {
                                                    style: {
                                                        background: lightTextColor,
                                                        color: textColor
                                                    },
                                                    iconColor: textColor,
                                                    onClick: async ()=>await navigator.clipboard.writeText(props.managedPaymentDetails?.paymentAddress ?? "")
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                            style: {
                                                fontSize: 16,
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 2,
                                                fontWeight: 100,
                                                color: titleTextColor,
                                                overflowWrap: "anywhere",
                                                textAlign: "left"
                                            },
                                            children: props.paymentStatus?.status === "expired" ? "Expired" : props.managedPaymentDetails.paymentAddress
                                        })
                                    ]
                                })
                            ]
                        }),
                        errorMessage && errorMessage.length > 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                            style: {
                                backgroundColor: (0, $643d9102d67b3722$export$8fe7e62e076ddbb5).ERROR,
                                padding: 15,
                                borderRadius: 5,
                                color: "white",
                                overflowWrap: "break-word"
                            },
                            children: errorMessage
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                                backgroundColor: address ? lightTextColor : "initial",
                                borderBottomLeftRadius: 25,
                                borderBottomRightRadius: 25,
                                borderTopLeftRadius: 5,
                                borderTopRightRadius: 5
                            },
                            children: [
                                selectedMethod && (0, $61f236426b9e4eab$export$8793fab959da70d1)(selectedMethod.network, selectedMethod.token).name !== "Bitcoin" && !(0, $61f236426b9e4eab$export$8793fab959da70d1)(selectedMethod.network, selectedMethod.token).isSolana && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $13f4c0370d7de649$exports.Fragment), {
                                    children: [
                                        address && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                justifyContent: "space-between",
                                                alignItems: "center",
                                                padding: 10
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                    style: {
                                                        color: darkTextColor,
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        gap: 5
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                            style: {
                                                                textTransform: "uppercase",
                                                                fontSize: 10
                                                            },
                                                            children: "Connected wallet"
                                                        }),
                                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                            children: (0, $2a4a168be657655e$export$193698062786be9a)(address, 10)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $348d722f77cc9b90$export$f861551692d63a2e), {
                                                    disabled: isWalletLoading,
                                                    onClick: ()=>disconnect(),
                                                    style: {
                                                        padding: 0,
                                                        border: 0,
                                                        color: titleTextColor,
                                                        textTransform: "uppercase",
                                                        fontSize: 10
                                                    },
                                                    children: "Disconnect"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $348d722f77cc9b90$export$ac16a6a04d9b7c84), {
                                            onClick: onClickOpenWallet,
                                            isLoading: isWalletLoading,
                                            spinnerColor: buttonTextColor,
                                            style: {
                                                background: customizations.primaryButtonColor,
                                                color: buttonTextColor,
                                                width: "100%"
                                            },
                                            children: isConnected ? "Open wallet" : "Connect wallet"
                                        })
                                    ]
                                }),
                                selectedMethod && (0, $61f236426b9e4eab$export$8793fab959da70d1)(selectedMethod.network, selectedMethod.token).isSolana && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $3a7c189ba80694ae$export$2e2bcd8739ae039), {
                                    managedPaymentDetails: props.managedPaymentDetails,
                                    isLoading: isWalletLoading,
                                    setIsLoading: setIsWalletLoading,
                                    primaryButtonColor: props.checkoutData.customizations?.primaryButtonColor,
                                    presaleStyling: {
                                        titleTextColor: titleTextColor,
                                        darkTextColor: darkTextColor,
                                        buttonTextColor: buttonTextColor
                                    }
                                })
                            ]
                        })
                    ]
                }),
                props.paymentStatus?.status === "expired" && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexGrow: 1,
                        flexDirection: "column",
                        gap: 5
                    },
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                            style: {
                                fontSize: 18,
                                color: titleTextColor
                            },
                            children: "Payment expired"
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                            style: {
                                color: darkTextColor,
                                textAlign: "center",
                                marginBottom: 20
                            },
                            children: "The payment timer has expired."
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $348d722f77cc9b90$export$ac16a6a04d9b7c84), {
                            onClick: ()=>window.location.reload(),
                            isLoading: props.isPreProcessingPayment,
                            style: {
                                background: customizations.primaryButtonColor,
                                color: buttonTextColor,
                                width: "100%"
                            },
                            children: "Refresh"
                        })
                    ]
                }),
                Number(props.paymentStatus?.amountRemaining) <= 0 && props.paymentStatus?.status !== "expired" && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    style: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexGrow: 1
                    },
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            gap: 30,
                            width: "100%",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                style: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 10,
                                    flexDirection: "column"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $a2e886aa15ab320a$export$763817fece9a8c9d), {
                                        style: {
                                            background: customizations.primaryButtonColor,
                                            width: 45,
                                            height: 45
                                        },
                                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $8cf33920e53a48fc$export$2e2bcd8739ae039), {
                                            animationDelay: "0.5s",
                                            animationSpeed: "0.75s",
                                            stroke: buttonTextColor
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                        style: {
                                            fontSize: 18,
                                            color: titleTextColor
                                        },
                                        children: "Payment successful"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                style: {
                                    display: "grid",
                                    gridTemplateColumns: "repeat(2, auto)",
                                    rowGap: 10,
                                    columnGap: 20,
                                    width: "100%",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    border: "1px solid",
                                    borderColor: lightTextColor,
                                    borderRadius: 25,
                                    padding: 20
                                },
                                children: [
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                        style: {
                                            color: textColor
                                        },
                                        children: "Order ID"
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                        style: {
                                            display: "flex",
                                            gap: 5,
                                            alignItems: "center",
                                            color: titleTextColor
                                        },
                                        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                            children: props.order?.id
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                        style: {
                                            gridColumn: "span 2",
                                            borderBottom: "1px solid",
                                            margin: "5px 0",
                                            borderColor: textColor,
                                            opacity: 0.25
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                        style: {
                                            color: textColor
                                        },
                                        children: "Tokens purchased"
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            gap: 5,
                                            alignItems: "center",
                                            color: titleTextColor
                                        },
                                        children: [
                                            token.product.imageUrl && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($e3115ce8c8a8ec19$var$TokenIcon, {
                                                imageUrl: token.product.imageUrl
                                            }),
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                children: tokenAmount
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                        style: {
                                            gridColumn: "span 2",
                                            borderBottom: "1px solid",
                                            margin: "5px 0",
                                            borderColor: textColor,
                                            opacity: 0.25
                                        }
                                    }),
                                    props.checkoutData.inputFields?.map((iF, i)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $13f4c0370d7de649$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                    style: {
                                                        color: textColor
                                                    },
                                                    children: iF.inputLabel
                                                }),
                                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                    style: {
                                                        color: titleTextColor,
                                                        textOverflow: "ellipsis",
                                                        overflow: "auto"
                                                    },
                                                    children: iF.value
                                                }),
                                                props.checkoutData.inputFields && i < props.checkoutData.inputFields.length - 1 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                    style: {
                                                        gridColumn: "span 2",
                                                        borderBottom: "1px solid",
                                                        borderColor: textColor,
                                                        opacity: 0.25
                                                    }
                                                })
                                            ]
                                        }))
                                ]
                            })
                        ]
                    })
                }),
                !props.managedPaymentDetails && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $13f4c0370d7de649$exports.Fragment), {
                    children: [
                        state === 1 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($e3115ce8c8a8ec19$var$Wrapper, {
                            style: {
                                display: "flex",
                                flexGrow: 1,
                                overflow: "scroll",
                                border: `1px solid ${lightTextColor}`,
                                borderRadius: 15,
                                maxHeight: 340
                            },
                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                style: {
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 8,
                                    width: "100%",
                                    height: "fit-content",
                                    padding: 10
                                },
                                children: props.checkoutData.gateway.managed?.methods.map((method, i)=>{
                                    const m = (0, $61f236426b9e4eab$export$8793fab959da70d1)(method.network, method.token);
                                    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $348d722f77cc9b90$export$ac16a6a04d9b7c84), {
                                        onClick: ()=>{
                                            setSelectedPaymentMethod(method);
                                            setState(0);
                                        },
                                        style: {
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "left",
                                            gap: 5,
                                            background: lightTextColor,
                                            padding: 15,
                                            borderRadius: 15,
                                            fontSize: 14
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                style: {
                                                    width: 20,
                                                    height: 20,
                                                    backgroundImage: `url(${m.logo})`,
                                                    backgroundSize: "contain",
                                                    backgroundPosition: "center",
                                                    backgroundRepeat: "no-repeat",
                                                    position: "relative"
                                                },
                                                children: m.tokenInfo && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                    style: {
                                                        background: "rgba(255, 255, 255, 0.95)",
                                                        borderRadius: "100%",
                                                        width: 12,
                                                        height: 12,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        position: "absolute",
                                                        bottom: -1,
                                                        right: -5,
                                                        boxShadow: "0 0 1px"
                                                    },
                                                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                        style: {
                                                            width: 8,
                                                            height: 8,
                                                            backgroundImage: `url(${m.tokenInfo.logo})`,
                                                            backgroundSize: "contain",
                                                            backgroundPosition: "center",
                                                            backgroundRepeat: "no-repeat"
                                                        }
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                style: {
                                                    color: titleTextColor
                                                },
                                                children: m.tokenInfo ? `${m.name} on ${m.tokenInfo.networkName}` : m.name
                                            })
                                        ]
                                    }, i);
                                })
                            })
                        }),
                        state === 0 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $13f4c0370d7de649$exports.Fragment), {
                            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($e3115ce8c8a8ec19$var$Wrapper, {
                                style: {
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 15,
                                    justifyContent: "center"
                                },
                                children: [
                                    presaleData?.tokenPresaleData?.totalRaiseAmount && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                        style: {
                                            display: "flex",
                                            gap: 10,
                                            flexDirection: "column",
                                            marginBottom: 10
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                style: {
                                                    width: "100%",
                                                    background: lightTextColor,
                                                    height: 15,
                                                    borderRadius: 25,
                                                    overflow: "hidden",
                                                    position: "relative"
                                                },
                                                children: [
                                                    segments.map((segment, index)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                            style: {
                                                                position: "absolute",
                                                                width: `${segment.width}%`,
                                                                maxWidth: "99%",
                                                                height: "100%",
                                                                background: index !== segments.length - 1 ? segment.color : "none",
                                                                transition: "width 0.3s ease-in-out, border-right 0.3s ease-in-out",
                                                                boxShadow: index !== segments.length - 1 ? "5px 0 15px rgba(0, 0, 0, 0.3)" : "none" // 添加阴影效果
                                                            }
                                                        }, index)),
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                        style: {
                                                            position: "absolute",
                                                            zIndex: 1,
                                                            width: `${Number(presaleData?.tokenPresaleData.totalAmountRaised ?? 0) / Number(presaleData?.tokenPresaleData.totalRaiseAmount) * 100}%`,
                                                            height: "100%",
                                                            background: customizations.primaryButtonColor
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                style: {
                                                    textTransform: "uppercase",
                                                    fontSize: 12,
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    color: textColor,
                                                    fontWeight: 600
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                                                        children: [
                                                            token.product.currency,
                                                            " raised"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                                                        children: [
                                                            (0, $3562cc065b5f3994$export$3dc27271f5d5c629)(token.product.currency, presaleData?.tokenPresaleData.totalAmountRaised ?? 0),
                                                            !presaleData?.tokenPresaleData?.customizations?.hideTotalRaiseGoal && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $13f4c0370d7de649$exports.Fragment), {
                                                                children: [
                                                                    "/ ",
                                                                    (0, $3562cc065b5f3994$export$3dc27271f5d5c629)(token.product.currency, presaleData?.tokenPresaleData.totalRaiseAmount)
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                        style: {
                                            border: `1px solid ${mediumTextColor}`,
                                            borderRadius: 15,
                                            padding: 15,
                                            color: textColor,
                                            display: "flex",
                                            alignItems: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                style: {
                                                    flexGrow: 1
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                        style: {
                                                            display: "flex",
                                                            gap: 10,
                                                            alignItems: "center",
                                                            marginBottom: 10
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                                children: [
                                                                    "You pay (",
                                                                    token.product.currency,
                                                                    ")"
                                                                ]
                                                            }),
                                                            fiatAmount && Number(fiatAmount) < Number(presaleData?.tokenPresaleData?.minimumPurchaseAmount ?? 0) && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                                style: {
                                                                    color: "red",
                                                                    textTransform: "uppercase",
                                                                    fontSize: 10
                                                                },
                                                                children: [
                                                                    "Min ",
                                                                    presaleData?.tokenPresaleData?.minimumPurchaseAmount
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $fbcecf017801e70f$export$c86715117507e8e5), {
                                                        placeholder: (0, $3562cc065b5f3994$export$bc56dd87ebd6aae2)(token.product.currency, fiatAmount ? Number(fiatAmount) : 0),
                                                        disabled: props.isPreProcessingPayment,
                                                        value: fiatAmount,
                                                        onChange: (e)=>{
                                                            if (!isNaN(e.target.value)) {
                                                                const amount = e.target.value;
                                                                setFiatAmount(amount);
                                                                setTokenAmountFromFiatAmount(amount);
                                                            }
                                                        },
                                                        placeholderColor: textColor,
                                                        style: {
                                                            border: 0,
                                                            boxShadow: "none",
                                                            padding: 0,
                                                            fontSize: 16,
                                                            background: "none",
                                                            color: titleTextColor
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $348d722f77cc9b90$export$ac16a6a04d9b7c84), {
                                                onClick: ()=>setState(1),
                                                style: {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 5,
                                                    background: lightTextColor,
                                                    padding: "5px 10px",
                                                    borderRadius: 15,
                                                    fontSize: 14
                                                },
                                                children: selectedMethod && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $13f4c0370d7de649$exports.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                            style: {
                                                                width: 20,
                                                                height: 20,
                                                                backgroundImage: `url(${(0, $61f236426b9e4eab$export$8793fab959da70d1)(selectedMethod.network, selectedMethod.token).logo})`,
                                                                backgroundSize: "contain",
                                                                backgroundPosition: "center",
                                                                backgroundRepeat: "no-repeat",
                                                                position: "relative"
                                                            },
                                                            children: (0, $61f236426b9e4eab$export$8793fab959da70d1)(selectedMethod.network, selectedMethod.token).tokenInfo && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                                style: {
                                                                    background: "rgba(255, 255, 255, 0.95)",
                                                                    borderRadius: "100%",
                                                                    width: 12,
                                                                    height: 12,
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    position: "absolute",
                                                                    bottom: -1,
                                                                    right: -5,
                                                                    boxShadow: "0 0 1px"
                                                                },
                                                                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                                                    style: {
                                                                        width: 8,
                                                                        height: 8,
                                                                        backgroundImage: `url(${(0, $61f236426b9e4eab$export$8793fab959da70d1)(selectedMethod.network, selectedMethod.token).tokenInfo?.logo})`,
                                                                        backgroundSize: "contain",
                                                                        backgroundPosition: "center",
                                                                        backgroundRepeat: "no-repeat"
                                                                    }
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                            style: {
                                                                color: titleTextColor
                                                            },
                                                            children: (0, $61f236426b9e4eab$export$8793fab959da70d1)(selectedMethod.network, selectedMethod.token).name
                                                        }),
                                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $ee6a04979d87ee29$export$65be7b63f510f362), {
                                                            fill: titleTextColor,
                                                            style: {
                                                                transform: "rotate(-90deg)",
                                                                opacity: 0.6
                                                            }
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                        style: {
                                            border: `1px solid ${mediumTextColor}`,
                                            borderRadius: 15,
                                            padding: 15,
                                            color: textColor,
                                            display: "flex",
                                            alignItems: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                style: {
                                                    flexGrow: 1
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                        style: {
                                                            marginBottom: 10
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                                children: "You receive"
                                                            }),
                                                            bonusTokenAmount && bonusTokenAmount !== "0" && presaleData?.tokenPresaleData?.customizations?.bonusTitle && presaleData?.tokenPresaleData?.customizations?.bonusTitle !== "" && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                                style: {
                                                                    color: titleTextColor,
                                                                    borderRadius: 5,
                                                                    boxShadow: "0px 4px 6px rgba(0, 0.1, 0.1, 0.2)",
                                                                    fontSize: 10,
                                                                    padding: "5px 10px",
                                                                    justifyContent: "center",
                                                                    marginLeft: 5
                                                                },
                                                                children: presaleData.tokenPresaleData?.customizations?.bonusTitle ?? ""
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $fbcecf017801e70f$export$c86715117507e8e5), {
                                                        disabled: props.isPreProcessingPayment,
                                                        placeholder: "0",
                                                        value: tokenAmount && bonusTokenAmount ? (Number(tokenAmount) + Number(bonusTokenAmount)).toString() : tokenAmount,
                                                        onChange: (e)=>{
                                                            if (!isNaN(e.target.value)) {
                                                                const amount = e.target.value;
                                                                setTokenAmount(amount);
                                                                setFiatAmountFromTokenAmount(amount);
                                                            }
                                                        },
                                                        placeholderColor: textColor,
                                                        style: {
                                                            border: 0,
                                                            boxShadow: "none",
                                                            padding: 0,
                                                            fontSize: 16,
                                                            background: "none",
                                                            color: titleTextColor
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                                style: {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 5,
                                                    background: lightTextColor,
                                                    padding: "5px 10px",
                                                    borderRadius: 15
                                                },
                                                children: [
                                                    token.product.imageUrl && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($e3115ce8c8a8ec19$var$TokenIcon, {
                                                        imageUrl: token.product.imageUrl
                                                    }),
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                        style: {
                                                            color: titleTextColor
                                                        },
                                                        children: token.product.productType?.Presale?.Token?.ticker
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                        style: {
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: 2
                                        },
                                        children: [
                                            ...new Set(props.checkoutData.gateway.managed?.methods.map((p)=>(0, $61f236426b9e4eab$export$8793fab959da70d1)(p.network, p.token).logo))
                                        ].map((p, i)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                                                style: {
                                                    height: 20,
                                                    maxWidth: 20
                                                },
                                                src: p
                                            }, i))
                                    }),
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $348d722f77cc9b90$export$ac16a6a04d9b7c84), {
                                        disabled: Number(fiatAmount ?? 1) < Number(presaleData?.tokenPresaleData?.minimumPurchaseAmount ?? 0),
                                        onClick: ()=>{
                                            if (startsAt && startsAt.getTime() > new Date().getTime()) return;
                                            if (endsAt && endsAt.getTime() < new Date().getTime()) return;
                                            if (selectedMethod && tokenAmount) setState(2);
                                        },
                                        isLoading: props.isPreProcessingPayment,
                                        style: {
                                            background: customizations.primaryButtonColor,
                                            color: buttonTextColor
                                        },
                                        children: startsAt && startsAt.getTime() > new Date().getTime() ? /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                flexDirection: "column"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                    children: "Presale starts in"
                                                }),
                                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                    style: {
                                                        fontSize: 12,
                                                        opacity: 0.5
                                                    },
                                                    children: (0, $3d87de48bf4dd55e$export$2e2bcd8739ae039)((0, $16f75469e5b80165$export$2e2bcd8739ae039)({
                                                        start: new Date(),
                                                        end: startsAt
                                                    }))
                                                })
                                            ]
                                        }) : endsAt && endsAt.getTime() < new Date().getTime() ? "Presale has ended" : "Continue"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                !props.managedPaymentDetails && state === 2 && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)($e3115ce8c8a8ec19$var$Wrapper, {
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        gap: 20
                    },
                    children: [
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                columnGap: 40,
                                rowGap: 20,
                                flexWrap: "wrap"
                            },
                            children: [
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                    style: {
                                        color: textColor,
                                        display: "flex",
                                        flexDirection: "column"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                            style: {
                                                marginBottom: 10
                                            },
                                            children: "Token amount"
                                        }),
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                gap: 5,
                                                alignItems: "center",
                                                color: titleTextColor
                                            },
                                            children: [
                                                token.product.imageUrl && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($e3115ce8c8a8ec19$var$TokenIcon, {
                                                    imageUrl: token.product.imageUrl
                                                }),
                                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                    children: tokenAmount
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                    style: {
                                        color: textColor,
                                        display: "flex",
                                        flexDirection: "column"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                            style: {
                                                marginBottom: 10
                                            },
                                            children: "Payment method"
                                        }),
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                            style: {
                                                display: "flex",
                                                gap: 5,
                                                alignItems: "center",
                                                color: titleTextColor
                                            },
                                            children: selectedMethod && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $13f4c0370d7de649$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("img", {
                                                        style: {
                                                            height: 20,
                                                            maxWidth: 20
                                                        },
                                                        src: (0, $61f236426b9e4eab$export$8793fab959da70d1)(selectedMethod.network, selectedMethod.token).logo
                                                    }),
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                        style: {
                                                            opacity: 0.75,
                                                            fontWeight: 100
                                                        },
                                                        children: (0, $61f236426b9e4eab$export$8793fab959da70d1)(selectedMethod.network, selectedMethod.token).ticker
                                                    }),
                                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                                                        children: [
                                                            "on ",
                                                            selectedMethod?.network
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                presaleData?.tokenPresaleData?.bonus !== undefined && presaleData?.tokenPresaleData?.bonus !== null && bonusTokenAmount && bonusTokenAmount !== "0" && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                    style: {
                                        color: textColor,
                                        display: "flex",
                                        flexDirection: "column"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                            style: {
                                                marginBottom: 10
                                            },
                                            children: "Bonus reward"
                                        }),
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                            style: {
                                                display: "flex",
                                                gap: 5,
                                                alignItems: "center",
                                                color: titleTextColor
                                            },
                                            children: [
                                                token.product.imageUrl && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($e3115ce8c8a8ec19$var$TokenIcon, {
                                                    imageUrl: token.product.imageUrl
                                                }),
                                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                                    children: (0, $O6tRJ.round)(Number(bonusTokenAmount), 6)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        props.checkoutData.inputFields?.map((inputField, i)=>/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                style: {
                                    border: `1px solid ${mediumTextColor}`,
                                    borderRadius: 15,
                                    padding: 15,
                                    color: textColor,
                                    display: "flex",
                                    alignItems: "center"
                                },
                                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                    style: {
                                        flexGrow: 1
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                            style: {
                                                marginBottom: 10
                                            },
                                            children: inputField.inputLabel
                                        }),
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $fbcecf017801e70f$export$c86715117507e8e5), {
                                            autoFocus: i === 0,
                                            disabled: props.isPreProcessingPayment,
                                            placeholder: `Enter ${inputField.inputLabel.toLowerCase()}`,
                                            value: inputField.value,
                                            onChange: (e)=>{
                                                if (!props.checkoutData.inputFields) return;
                                                const target = e.target;
                                                let val = target.value;
                                                if (inputField.inputLabel === "Email address") val = val.toLowerCase();
                                                const newInputs = props.checkoutData.inputFields.slice();
                                                newInputs[i].value = val;
                                                props.onInputFieldsChange?.(newInputs);
                                            },
                                            placeholderColor: textColor,
                                            style: {
                                                border: 0,
                                                boxShadow: "none",
                                                padding: 0,
                                                fontSize: 16,
                                                background: "none",
                                                color: titleTextColor
                                            }
                                        })
                                    ]
                                })
                            }, i)),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                            style: {
                                display: "flex",
                                flexGrow: 1
                            }
                        }),
                        errorMessage && /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "flex-start",
                                gap: 5,
                                width: "100%",
                                backgroundColor: "red",
                                borderRadius: 5,
                                padding: "10px 15px"
                            },
                            children: [
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                                    style: {
                                        color: "white",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 3,
                                        textTransform: "uppercase",
                                        opacity: 0.75,
                                        fontSize: 10
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $fde46c11fa0ffea3$export$2e2bcd8739ae039), {
                                            style: {
                                                height: 8,
                                                width: 8
                                            },
                                            stroke: "white",
                                            strokeWidth: 2
                                        }),
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                            children: "Error"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                                    style: {
                                        color: "white"
                                    },
                                    children: errorMessage
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("div", {
                            style: {
                                display: "flex",
                                gap: 0
                            },
                            children: [
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)((0, $348d722f77cc9b90$export$ac16a6a04d9b7c84), {
                                    onClick: ()=>{
                                        setErrorMessage(undefined);
                                        setState(0);
                                    },
                                    disabled: props.isPreProcessingPayment,
                                    spinnerColor: buttonTextColor,
                                    style: {
                                        background: lightTextColor,
                                        color: textColor,
                                        borderRadius: 25,
                                        borderTopRightRadius: 0,
                                        borderBottomRightRadius: 0,
                                        alignItems: "center",
                                        gap: 3
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $ee6a04979d87ee29$export$65be7b63f510f362), {
                                            fill: textColor,
                                            style: {
                                                transform: "rotate(90deg)",
                                                height: 14,
                                                width: 14,
                                                marginTop: -2
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                            children: "Back"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $348d722f77cc9b90$export$ac16a6a04d9b7c84), {
                                    onClick: ()=>{
                                        const paidAmount = tokenAmount ?? "0";
                                        if (selectedMethod && tokenAmount) {
                                            console.log("paidAmount", paidAmount);
                                            props.onCheckout({
                                                selectedMethod: selectedMethod,
                                                tokenAmount: paidAmount
                                            });
                                        }
                                    },
                                    isLoading: props.isPreProcessingPayment,
                                    spinnerColor: buttonTextColor,
                                    style: {
                                        background: customizations.primaryButtonColor,
                                        color: buttonTextColor,
                                        flexGrow: 1,
                                        borderTopLeftRadius: 0,
                                        borderBottomLeftRadius: 0
                                    },
                                    children: "Continue"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
                    style: {
                        display: "flex",
                        justifyContent: "center",
                        width: "100%",
                        marginTop: 30
                    },
                    children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("a", {
                        href: "https://www.radom.com/crypto-presales",
                        target: "_blank",
                        title: "Crypto Presale Powered by Radom",
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: 2,
                            cursor: "pointer",
                            userSelect: "none",
                            textDecoration: "none",
                            color: textColor
                        },
                        rel: "noreferrer",
                        children: [
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                style: {
                                    fontSize: 8,
                                    fontWeight: 100,
                                    marginBottom: 2
                                },
                                children: "Crypto Presale"
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsxs)("span", {
                                style: {
                                    display: "flex",
                                    alignItems: "center",
                                    fontSize: 14,
                                    fontWeight: 100
                                },
                                children: [
                                    "Powered by",
                                    /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $47362f00518aba7f$export$2e2bcd8739ae039), {
                                        width: 60,
                                        height: 14,
                                        fill: textColor
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("span", {
                                style: {
                                    position: "absolute",
                                    width: "1px",
                                    height: "1px",
                                    margin: "-1px",
                                    padding: 0,
                                    overflow: "hidden",
                                    clip: "rect(0, 0, 0, 0)",
                                    border: 0
                                },
                                children: "Radom"
                            })
                        ]
                    })
                })
            ]
        })
    });
}
var $e3115ce8c8a8ec19$export$2e2bcd8739ae039 = $e3115ce8c8a8ec19$var$Presale;



parcelRequire("8NFma");

parcelRequire("8NFma");

const $48cb3ef28abbede7$var$LoadingBarAnimation = (0, $65e706775ff71837$export$d25ddfdf17c3ad3e)`
  from {
    opacity: 1;
  }
  to {
    opacity: 0.5;
  }
`;
const $48cb3ef28abbede7$var$LoadingBarInner = (0, $65e706775ff71837$export$2e2bcd8739ae039).div`
  animation: ${$48cb3ef28abbede7$var$LoadingBarAnimation} ${({ animationSpeed: animationSpeed })=>animationSpeed}s alternate infinite linear;
  background-color: rgba(0, 0, 0, 0.1);
  background: linear-gradient(-45deg, rgb(155 158 177 / 50%), rgb(155 158 177 / 30%));
  border-radius: 5px;
  width: 50px;
  height: 20px;
`;
const $48cb3ef28abbede7$var$LoadingBar = ({ animationSpeed: animationSpeed = 0.5, style: style })=>{
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)($48cb3ef28abbede7$var$LoadingBarInner, {
        animationSpeed: animationSpeed,
        style: style
    });
};
var $48cb3ef28abbede7$export$2e2bcd8739ae039 = $48cb3ef28abbede7$var$LoadingBar;


function $e10e6643fef9fc13$var$LoadingPresale() {
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)("div", {
        style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 14,
            minHeight: "100%"
        },
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $48cb3ef28abbede7$export$2e2bcd8739ae039), {
            style: {
                width: 450,
                minHeight: 550,
                maxWidth: "100%",
                padding: 30,
                borderRadius: 25,
                display: "flex",
                flexDirection: "column"
            }
        })
    });
}
var $e10e6643fef9fc13$export$2e2bcd8739ae039 = $e10e6643fef9fc13$var$LoadingPresale;


function $c43cd0254563d93d$var$PresaleView({ paymentLinkId: paymentLinkId }) {
    const [isLoading, setIsLoading] = (0, $8NFma.useState)(true);
    const [paymentLinkData, setPaymentLinkData] = (0, $8NFma.useState)();
    const [isPreProcessingPayment, setIsPreProcessingPayment] = (0, $8NFma.useState)(false);
    const [order, setOrder] = (0, $8NFma.useState)();
    const [managedPaymentDetails, setManagedPaymentDetails] = (0, $8NFma.useState)();
    const [paymentStatus, setPaymentStatus] = (0, $8NFma.useState)();
    const [inputFields, setInputFields] = (0, $8NFma.useState)([]);
    const [errorMessage, setErrorMessage] = (0, $8NFma.useState)();
    console.log("hi");
    (0, $8NFma.useEffect)(()=>{
        console.log("getting apyemnt link");
        (0, $6cc04e58a8fffbcd$export$2e2bcd8739ae039).getPaymentLink(paymentLinkId).then((data)=>{
            setPaymentLinkData(data);
            if (data.inputFields) {
                const inputFields = [];
                for (const input of data.inputFields)inputFields.push({
                    ...input,
                    value: ""
                });
                setInputFields(inputFields);
            }
        }).finally(()=>{
            setIsLoading(false);
        });
    }, []);
    if (!paymentLinkData || paymentLinkData.products.length <= 0 || isLoading) return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $e10e6643fef9fc13$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $e3115ce8c8a8ec19$export$2e2bcd8739ae039), {
        checkoutData: {
            ...paymentLinkData,
            inputFields: inputFields,
            products: paymentLinkData.products.map((p)=>{
                return {
                    product: p,
                    quantity: 1
                };
            })
        },
        onCheckout: async ({ selectedMethod: selectedMethod, tokenAmount: tokenAmount })=>{
            try {
                setErrorMessage(undefined);
                setIsPreProcessingPayment(true);
                const orderRes = await (0, $6cc04e58a8fffbcd$export$2e2bcd8739ae039).createPaymentLinkOrder({
                    paymentLinkId: paymentLinkId,
                    paymentMethod: {
                        managed: {
                            method: selectedMethod
                        }
                    },
                    orderData: [
                        ...inputFields.map((c)=>{
                            return {
                                key: c.inputLabel,
                                value: c.value.toString()
                            };
                        }),
                        {
                            key: "Token amount",
                            value: tokenAmount
                        }
                    ]
                });
                setOrder(orderRes);
                setIsPreProcessingPayment(false);
                if (orderRes.paymentMethodDetails.managed) setManagedPaymentDetails(orderRes.paymentMethodDetails.managed);
                const checkPaymentInterval = setInterval(()=>{
                    if (!orderRes.paymentMethodDetails.managed) return;
                    (0, $6cc04e58a8fffbcd$export$2e2bcd8739ae039).getManagedPaymentStatus(orderRes.paymentMethodDetails.managed?.paymentId).then((res)=>{
                        setPaymentStatus(res);
                        if (res.status === "paymentConfirmed") {
                            if (window?.parent) window.parent.postMessage({
                                orderId: orderRes.id,
                                status: res.status
                            }, "*");
                            clearInterval(checkPaymentInterval);
                        }
                    }).catch(()=>{});
                }, 1000);
            } catch (err) {
                setErrorMessage(err.reason || err.message);
                setIsPreProcessingPayment(false);
            }
        },
        order: order,
        managedPaymentDetails: managedPaymentDetails,
        errorMessage: errorMessage,
        isPreProcessingPayment: isPreProcessingPayment,
        paymentStatus: paymentStatus,
        onInputFieldsChange: setInputFields,
        isSuccess: false,
        successElement: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $13f4c0370d7de649$exports.Fragment), {})
    });
}
var $c43cd0254563d93d$export$2e2bcd8739ae039 = $c43cd0254563d93d$var$PresaleView;



console.info(`
\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}
\u{255A}\u{2550}\u{255D}  \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}  \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}  \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}
Welcome to Radom!
Build: ${undefined}
`);
const $491ab40b800b339a$var$queryClient = new (0, $45076d1644600312$export$405d0624ed55a03f)();
window.LoadPresale = (elementId, presaleId)=>{
    const element = document.getElementById(elementId);
    if (!element) {
        console.error(`Element with id ${elementId} not found`);
        return;
    }
    const root = (0, $503937b663c395c4$export$882461b6382ed46c)(element);
    root.render(/*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $4a768efd39c3ad48$export$a28463dc600bc9f8), {
        config: (0, $61f236426b9e4eab$export$382a3cc012b91987),
        children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $116ae60afff0fd72$export$45604f0cc8ae667b), {
            client: $491ab40b800b339a$var$queryClient,
            children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $a8cea113a6044695$export$9ba4e89fdfa1fc54), {
                children: /*#__PURE__*/ (0, $13f4c0370d7de649$exports.jsx)((0, $c43cd0254563d93d$export$2e2bcd8739ae039), {
                    paymentLinkId: presaleId
                })
            })
        })
    }));
};

})();
//# sourceMappingURL=index.js.map
